// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  var $parcel$bundleURL;function $parcel$resolve(url) {  url = importMap[url] || url;  if (!$parcel$bundleURL) {    try {      throw new Error();    } catch (err) {      var matches = ('' + err.stack).match(        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,      );      if (matches) {        $parcel$bundleURL = matches[0];      } else {        return distDir + url;      }    }  }  return new URL(distDir + url, $parcel$bundleURL).toString();}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"apfRo":[function(require,module,exports,__globalThis) {
module.bundle.extendImportMap({
    "elqBb": "Icon Blue 192.c7bd1d27.png",
    "eUCok": "dump_validators.0e529490.js",
    "jq7EE": "web.b458bc6f.js",
    "hx2cG": "browser-polyfill.1783c223.js",
    "C42q3": "Rose Wallet Blue.27b4ab1f.svg",
    "6uEBH": "Rose Wallet White.0c84f0b8.svg",
    "MUzWr": "web-CuWXBIfc.16d9dde8.js",
    "dP98J": "web.145c7a5f.js",
    "bjDAz": "web.f21b6c30.js"
});

},{}],"4RXID":[function(require,module,exports,__globalThis) {
/**
 * index.tsx
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */ var _jsxRuntime = require("react/jsx-runtime");
var _warnImportMapViolation = require("./utils/warnImportMapViolation");
var _react = require("react");
var _client = require("react-dom/client");
var _reactRedux = require("react-redux");
// Use consistent styling
var _sanitizeCss = require("sanitize.css/sanitize.css");
var _reactRouterDom = require("react-router-dom");
var _reactHelmetAsync = require("react-helmet-async");
var _configureStore = require("store/configureStore");
var _themeProvider = require("styles/theme/ThemeProvider");
// Initialize languages
var _i18N = require("locales/i18n");
// Fonts
var _mainCss = require("styles/main.css");
var _routes = require("./routes");
const store = (0, _configureStore.configureAppStore)();
const container = document.getElementById('root');
const root = (0, _client.createRoot)(container);
const router = (0, _reactRouterDom.createBrowserRouter)((0, _routes.routes));
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRedux.Provider), {
    store: store,
    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeProvider.ThemeProvider), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHelmetAsync.HelmetProvider), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.StrictMode, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.RouterProvider), {
                    router: router
                })
            })
        })
    })
}));

},{"react/jsx-runtime":"6pm7f","./utils/warnImportMapViolation":"b7CFF","react":"8CCva","react-dom/client":"9cO5u","react-redux":"azV3Y","sanitize.css/sanitize.css":"4UN9G","react-router-dom":"9pTjq","react-helmet-async":"vfvPp","store/configureStore":"3xZa0","styles/theme/ThemeProvider":"dIepd","locales/i18n":"aQTIh","styles/main.css":"fuHzr","./routes":"yuQiW"}],"6pm7f":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("e5e9711c2edf1a4e");

},{"e5e9711c2edf1a4e":"iUtoV"}],"iUtoV":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var f = require("3fd2a064dc1f3641"), k = Symbol.for("react.element"), l = Symbol.for("react.fragment"), m = Object.prototype.hasOwnProperty, n = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)m.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: n.current
    };
}
exports.Fragment = l;
exports.jsx = q;
exports.jsxs = q;

},{"3fd2a064dc1f3641":"8CCva"}],"8CCva":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("956f36295e4e0134");

},{"956f36295e4e0134":"5OdDi"}],"5OdDi":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var l = Symbol.for("react.element"), n = Symbol.for("react.portal"), p = Symbol.for("react.fragment"), q = Symbol.for("react.strict_mode"), r = Symbol.for("react.profiler"), t = Symbol.for("react.provider"), u = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), w = Symbol.for("react.suspense"), x = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), z = Symbol.iterator;
function A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = z && a[z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, C = Object.assign, D = {};
function E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function F() {}
F.prototype = E.prototype;
function G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = D;
    this.updater = e || B;
}
var H = G.prototype = new F;
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
var I = Array.isArray, J = Object.prototype.hasOwnProperty, K = {
    current: null
}, L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)J.call(b, d) && !L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: K.current
    };
}
function N(a, b) {
    return {
        $$typeof: l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === l;
}
function escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var P = /\/+/g;
function Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case l:
                case n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + Q(h, 0) : d, I(c) ? (e = "", null != a && (e = a.replace(P, "$&/") + "/"), R(c, b, e, "", function(a) {
        return a;
    })) : null != c && (O(c) && (c = N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace(P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if (I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + Q(k, g);
        h += R(k, b, e, f, c);
    }
    else if (f = A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + Q(k, g++), h += R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var U = {
    current: null
}, V = {
    transition: null
}, W = {
    ReactCurrentDispatcher: U,
    ReactCurrentBatchConfig: V,
    ReactCurrentOwner: K
};
function X() {
    throw Error("act(...) is not supported in production builds of React.");
}
exports.Children = {
    map: S,
    forEach: function(a, b, e) {
        S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
exports.Component = E;
exports.Fragment = p;
exports.Profiler = r;
exports.PureComponent = G;
exports.StrictMode = q;
exports.Suspense = w;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = W;
exports.act = X;
exports.cloneElement = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)J.call(b, f) && !L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
exports.createContext = function(a) {
    a = {
        $$typeof: u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: t,
        _context: a
    };
    return a.Consumer = a;
};
exports.createElement = M;
exports.createFactory = function(a) {
    var b = M.bind(null, a);
    b.type = a;
    return b;
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(a) {
    return {
        $$typeof: v,
        render: a
    };
};
exports.isValidElement = O;
exports.lazy = function(a) {
    return {
        $$typeof: y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: T
    };
};
exports.memo = function(a, b) {
    return {
        $$typeof: x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
exports.startTransition = function(a) {
    var b = V.transition;
    V.transition = {};
    try {
        a();
    } finally{
        V.transition = b;
    }
};
exports.unstable_act = X;
exports.useCallback = function(a, b) {
    return U.current.useCallback(a, b);
};
exports.useContext = function(a) {
    return U.current.useContext(a);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(a) {
    return U.current.useDeferredValue(a);
};
exports.useEffect = function(a, b) {
    return U.current.useEffect(a, b);
};
exports.useId = function() {
    return U.current.useId();
};
exports.useImperativeHandle = function(a, b, e) {
    return U.current.useImperativeHandle(a, b, e);
};
exports.useInsertionEffect = function(a, b) {
    return U.current.useInsertionEffect(a, b);
};
exports.useLayoutEffect = function(a, b) {
    return U.current.useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
    return U.current.useMemo(a, b);
};
exports.useReducer = function(a, b, e) {
    return U.current.useReducer(a, b, e);
};
exports.useRef = function(a) {
    return U.current.useRef(a);
};
exports.useState = function(a) {
    return U.current.useState(a);
};
exports.useSyncExternalStore = function(a, b, e) {
    return U.current.useSyncExternalStore(a, b, e);
};
exports.useTransition = function() {
    return U.current.useTransition();
};
exports.version = "18.3.1";

},{}],"b7CFF":[function(require,module,exports,__globalThis) {
var _getSecurityHeaders = require("../../internals/getSecurityHeaders");
(0, _getSecurityHeaders.warnImportMapViolation)();

},{"../../internals/getSecurityHeaders":"1vB1o"}],"1vB1o":[function(require,module,exports,__globalThis) {
// @ts-check
// @TODO: Future improvements:
// - remove 'unsafe-inline' style by precomputing theme hash
// - add report-uri to gather errors if anything was missed
const dappFrameAncestors = `
  'self'
  https:
  http://localhost:*
  http://127.0.0.1:*
`;
const localnet = `
  http://localhost:42280
  http://localhost:9001
`;
const hmr = `
  http://localhost:2222
  ws://localhost:2222
`;
const hmrScripts = `
  'unsafe-eval'
`;
const warnImportMapViolation = async ()=>{
    const importMap = document.querySelector('script[type="importmap"]');
    if (!importMap) return;
    const hash = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(importMap.innerHTML));
    const cspHash = `sha256-${btoa(String.fromCharCode(...new Uint8Array(hash)))}`;
    console.warn(`In dev mode parcel adds <script type="importmap">. CSP blocks executing this and shows it as violation '${cspHash}', but imports still work.`);
};
/**
 * Keep this synced with deployment headers
 *
 * @param {{ isExtension: boolean, isDev: boolean }} param
 */ const getCsp = ({ isExtension, isDev })=>`
    default-src 'none';
    script-src
      'self'
      ${!isExtension && isDev ? hmrScripts : '' /* Manifest v3 doesn't allow anything */ }
      ${!isExtension ? 'report-sample' : ''}
      ;
    style-src
      'self'
      'unsafe-inline'
      'report-sample';
    font-src
      'self';
    connect-src
      'self'
      https://grpc.oasis.io
      https://testnet.grpc.oasis.io
      https://api.oasisscan.com
      https://nexus.oasis.io
      https://testnet.nexus.oasis.io
      ${isDev ? localnet : ''}
      ${isDev ? hmr : ''}
      ;
    frame-ancestors
      ${isExtension ? dappFrameAncestors : `'self'`};
    frame-src
      'self';
    img-src 'self' data: https:;
    base-uri 'self';
    manifest-src 'self';
  `.trim().split('\n').map((line)=>line.trim()).filter((line)=>!!line).join(' ').replace(/ ;/g, ';');
// Generated with https://www.permissionspolicy.com/
const getPermissionsPolicy = ()=>`
    accelerometer=(),
    ambient-light-sensor=(),
    autoplay=(),
    bluetooth=(self),
    camera=(),
    cross-origin-isolated=(),
    display-capture=(),
    document-domain=(self),
    encrypted-media=(),
    execution-while-not-rendered=(),
    execution-while-out-of-viewport=(),
    fullscreen=(self),
    geolocation=(),
    gyroscope=(),
    keyboard-map=(),
    magnetometer=(),
    microphone=(),
    midi=(),
    navigation-override=(),
    payment=(),
    picture-in-picture=(),
    publickey-credentials-get=(),
    screen-wake-lock=(),
    sync-xhr=(),
    usb=(self),
    web-share=(),
    xr-spatial-tracking=()
  `.trim().split('\n').map((line)=>line.trim()).filter((line)=>!!line).join(' ').replace(/ ,/g, ',');
module.exports = {
    getCsp,
    getPermissionsPolicy,
    warnImportMapViolation
};

},{}],"9cO5u":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("aaccff5d309d9239");
var i;
exports.createRoot = m.createRoot;
exports.hydrateRoot = m.hydrateRoot;

},{"aaccff5d309d9239":"ggrpy"}],"ggrpy":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9223fb8c5161e54b");

},{"9223fb8c5161e54b":"iQFmD"}],"iQFmD":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';
var aa = require("5393afc8c463ef07"), ca = require("ece50e903283a22f");
function p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var da = new Set, ea = {};
function fa(a, b) {
    ha(a, b);
    ha(a + "Capture", b);
}
function ha(a, b) {
    ea[a] = b;
    for(a = 0; a < b.length; a++)da.add(b[a]);
}
var ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ja = Object.prototype.hasOwnProperty, ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, la = {}, ma = {};
function oa(a) {
    if (ja.call(ma, a)) return !0;
    if (ja.call(la, a)) return !1;
    if (ka.test(a)) return ma[a] = !0;
    la[a] = !0;
    return !1;
}
function pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    z[a] = new v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    z[b] = new v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    z[a] = new v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    z[a] = new v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    z[a] = new v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    z[a] = new v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    z[a] = new v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    z[a] = new v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var ra = /[\-:]([a-z])/g;
function sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(ra, sa);
    z[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
z.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    z[a] = new v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function ta(a, b, c, d) {
    var e = z.hasOwnProperty(b) ? z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) qa(b, c, e, d) && (c = null), d || null === e ? oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var ua = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, va = Symbol.for("react.element"), wa = Symbol.for("react.portal"), ya = Symbol.for("react.fragment"), za = Symbol.for("react.strict_mode"), Aa = Symbol.for("react.profiler"), Ba = Symbol.for("react.provider"), Ca = Symbol.for("react.context"), Da = Symbol.for("react.forward_ref"), Ea = Symbol.for("react.suspense"), Fa = Symbol.for("react.suspense_list"), Ga = Symbol.for("react.memo"), Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var Ja = Symbol.iterator;
function Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ja && a[Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var A = Object.assign, La;
function Ma(a) {
    if (void 0 === La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        La = b && b[1] || "";
    }
    return "\n" + La + a;
}
var Na = !1;
function Oa(a, b) {
    if (!a || Na) return "";
    Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Ma(a) : "";
}
function Pa(a) {
    switch(a.tag){
        case 5:
            return Ma(a.type);
        case 16:
            return Ma("Lazy");
        case 13:
            return Ma("Suspense");
        case 19:
            return Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Oa(a.type, !1), a;
        case 11:
            return a = Oa(a.type.render, !1), a;
        case 1:
            return a = Oa(a.type, !0), a;
        default:
            return "";
    }
}
function Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ya:
            return "Fragment";
        case wa:
            return "Portal";
        case Aa:
            return "Profiler";
        case za:
            return "StrictMode";
        case Ea:
            return "Suspense";
        case Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case Ca:
            return (a.displayName || "Context") + ".Consumer";
        case Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case Ga:
            return b = a.displayName || null, null !== b ? b : Qa(a.type) || "Memo";
        case Ha:
            b = a._payload;
            a = a._init;
            try {
                return Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return Qa(b);
        case 8:
            return b === za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function ab(a, b) {
    b = b.checked;
    null != b && ta(a, "checked", b, !1);
}
function bb(a, b) {
    ab(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && cb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function cb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var eb = Array.isArray;
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(p(91));
    return A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(p(92));
            if (eb(c)) {
                if (1 < c.length) throw Error(p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var mb, nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        mb = mb || document.createElement("div");
        mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(pb).forEach(function(a) {
    qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        pb[b] = pb[a];
    });
});
function rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || pb.hasOwnProperty(a) && pb[a] ? ("" + b).trim() : b + "px";
}
function sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var tb = A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function ub(a, b) {
    if (b) {
        if (tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error(p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(p(62));
    }
}
function vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var wb = null;
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(p(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb() {}
var Ib = !1;
function Jb(a, b, c) {
    if (Ib) return a(b, c);
    Ib = !0;
    try {
        return Gb(a, b, c);
    } finally{
        if (Ib = !1, null !== zb || null !== Ab) Hb(), Fb();
    }
}
function Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(p(231, b, typeof c));
    return c;
}
var Lb = !1;
if (ia) try {
    var Mb = {};
    Object.defineProperty(Mb, "passive", {
        get: function() {
            Lb = !0;
        }
    });
    window.addEventListener("test", Mb, Mb);
    window.removeEventListener("test", Mb, Mb);
} catch (a) {
    Lb = !1;
}
function Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var Ob = !1, Pb = null, Qb = !1, Rb = null, Sb = {
    onError: function(a) {
        Ob = !0;
        Pb = a;
    }
};
function Tb(a, b, c, d, e, f, g, h, k) {
    Ob = !1;
    Pb = null;
    Nb.apply(Sb, arguments);
}
function Ub(a, b, c, d, e, f, g, h, k) {
    Tb.apply(this, arguments);
    if (Ob) {
        if (Ob) {
            var l = Pb;
            Ob = !1;
            Pb = null;
        } else throw Error(p(198));
        Qb || (Qb = !0, Rb = l);
    }
}
function Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function Xb(a) {
    if (Vb(a) !== a) throw Error(p(188));
}
function Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = Vb(a);
        if (null === b) throw Error(p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return Xb(e), a;
                if (f === d) return Xb(e), b;
                f = f.sibling;
            }
            throw Error(p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(p(189));
            }
        }
        if (c.alternate !== d) throw Error(p(190));
    }
    if (3 !== c.tag) throw Error(p(188));
    return c.stateNode.current === c ? a : b;
}
function Zb(a) {
    a = Yb(a);
    return null !== a ? $b(a) : null;
}
function $b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var ac = ca.unstable_scheduleCallback, bc = ca.unstable_cancelCallback, cc = ca.unstable_shouldYield, dc = ca.unstable_requestPaint, B = ca.unstable_now, ec = ca.unstable_getCurrentPriorityLevel, fc = ca.unstable_ImmediatePriority, gc = ca.unstable_UserBlockingPriority, hc = ca.unstable_NormalPriority, ic = ca.unstable_LowPriority, jc = ca.unstable_IdlePriority, kc = null, lc = null;
function mc(a) {
    if (lc && "function" === typeof lc.onCommitFiberRoot) try {
        lc.onCommitFiberRoot(kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var oc = Math.clz32 ? Math.clz32 : nc, pc = Math.log, qc = Math.LN2;
function nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - (pc(a) / qc | 0) | 0;
}
var rc = 64, sc = 4194304;
function tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = tc(h) : (f &= g, 0 !== f && (d = tc(f)));
    } else g = c & ~e, 0 !== g ? d = tc(g) : 0 !== f && (d = tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function yc() {
    var a = rc;
    rc <<= 1;
    0 === (rc & 4194240) && (rc = 64);
    return a;
}
function zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - oc(b);
    a[b] = c;
}
function Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var C = 0;
function Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var Ec, Fc, Gc, Hc, Ic, Jc = !1, Kc = [], Lc = null, Mc = null, Nc = null, Oc = new Map, Pc = new Map, Qc = [], Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Pc.delete(b.pointerId);
    }
}
function Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = Cb(b), null !== b && Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return Lc = Tc(Lc, a, b, c, d, e), !0;
        case "dragenter":
            return Mc = Tc(Mc, a, b, c, d, e), !0;
        case "mouseover":
            return Nc = Tc(Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Oc.set(f, Tc(Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Pc.set(f, Tc(Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Vc(a) {
    var b = Wc(a.target);
    if (null !== b) {
        var c = Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = Wb(c), null !== b) {
                    a.blockedOn = b;
                    Ic(a.priority, function() {
                        Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            wb = d;
            c.target.dispatchEvent(d);
            wb = null;
        } else return b = Cb(c), null !== b && Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function Zc(a, b, c) {
    Xc(a) && c.delete(b);
}
function $c() {
    Jc = !1;
    null !== Lc && Xc(Lc) && (Lc = null);
    null !== Mc && Xc(Mc) && (Mc = null);
    null !== Nc && Xc(Nc) && (Nc = null);
    Oc.forEach(Zc);
    Pc.forEach(Zc);
}
function ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, Jc || (Jc = !0, ca.unstable_scheduleCallback(ca.unstable_NormalPriority, $c)));
}
function bd(a) {
    function b(b) {
        return ad(b, a);
    }
    if (0 < Kc.length) {
        ad(Kc[0], a);
        for(var c = 1; c < Kc.length; c++){
            var d = Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Lc && ad(Lc, a);
    null !== Mc && ad(Mc, a);
    null !== Nc && ad(Nc, a);
    Oc.forEach(b);
    Pc.forEach(b);
    for(c = 0; c < Qc.length; c++)d = Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Qc.length && (c = Qc[0], null === c.blockedOn);)Vc(c), null === c.blockedOn && Qc.shift();
}
var cd = ua.ReactCurrentBatchConfig, dd = !0;
function ed(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 1, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function gd(a, b, c, d) {
    var e = C, f = cd.transition;
    cd.transition = null;
    try {
        C = 4, fd(a, b, c, d);
    } finally{
        C = e, cd.transition = f;
    }
}
function fd(a, b, c, d) {
    if (dd) {
        var e = Yc(a, b, c, d);
        if (null === e) hd(a, b, d, id, c), Sc(a, d);
        else if (Uc(e, a, b, c, d)) d.stopPropagation();
        else if (Sc(a, d), b & 4 && -1 < Rc.indexOf(a)) {
            for(; null !== e;){
                var f = Cb(e);
                null !== f && Ec(f);
                f = Yc(a, b, c, d);
                null === f && hd(a, b, d, id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else hd(a, b, d, null, c);
    }
}
var id = null;
function Yc(a, b, c, d) {
    id = null;
    a = xb(d);
    a = Wc(a);
    if (null !== a) {
        if (b = Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    id = a;
    return null;
}
function jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch(ec()){
                case fc:
                    return 1;
                case gc:
                    return 4;
                case hc:
                case ic:
                    return 16;
                case jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = A({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = A({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = A({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = A({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = A({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = A({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = A({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = A({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = A({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = A({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = A({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = A({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = ia && "CompositionEvent" in window, be = null;
ia && "documentMode" in document && (be = document.documentMode);
var ce = ia && "TextEvent" in window && !be, de = ia && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (ia) {
    var xe;
    if (ia) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        Jb(re, b);
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge;
function Ie(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!ja.call(b, e) || !He(a[e], b[e])) return !1;
    }
    return !0;
}
function Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Ke(a, b) {
    var c = Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Je(c);
    }
}
function Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Me() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function Oe(a) {
    var b = Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = Ke(c, f);
                var g = Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var Pe = ia && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Ie(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
function Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var We = {
    animationend: Ve("Animation", "AnimationEnd"),
    animationiteration: Ve("Animation", "AnimationIteration"),
    animationstart: Ve("Animation", "AnimationStart"),
    transitionend: Ve("Transition", "TransitionEnd")
}, Xe = {}, Ye = {};
ia && (Ye = document.createElement("div").style, "AnimationEvent" in window || (delete We.animationend.animation, delete We.animationiteration.animation, delete We.animationstart.animation), "TransitionEvent" in window || delete We.transitionend.transition);
function Ze(a) {
    if (Xe[a]) return Xe[a];
    if (!We[a]) return a;
    var b = We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Ye) return Xe[a] = b[c];
    return a;
}
var $e = Ze("animationend"), af = Ze("animationiteration"), bf = Ze("animationstart"), cf = Ze("transitionend"), df = new Map, ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function ff(a, b) {
    df.set(a, b);
    fa(b, [
        a
    ]);
}
for(var gf = 0; gf < ef.length; gf++){
    var hf = ef[gf], jf = hf.toLowerCase(), kf = hf[0].toUpperCase() + hf.slice(1);
    ff(jf, "on" + kf);
}
ff($e, "onAnimationEnd");
ff(af, "onAnimationIteration");
ff(bf, "onAnimationStart");
ff("dblclick", "onDoubleClick");
ff("focusin", "onFocus");
ff("focusout", "onBlur");
ff(cf, "onTransitionEnd");
ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), mf = new Set("cancel close invalid load scroll toggle".split(" ").concat(lf));
function nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                nf(e, h, l);
                f = k;
            }
        }
    }
    if (Qb) throw a = Rb, Qb = !1, Rb = null, a;
}
function D(a, b) {
    var c = b[of];
    void 0 === c && (c = b[of] = new Set);
    var d = a + "__bubble";
    c.has(d) || (pf(b, a, 2, !1), c.add(d));
}
function qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    pf(c, a, d, b);
}
var rf = "_reactListening" + Math.random().toString(36).slice(2);
function sf(a) {
    if (!a[rf]) {
        a[rf] = !0;
        da.forEach(function(b) {
            "selectionchange" !== b && (mf.has(b) || qf(b, !1, a), qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[rf] || (b[rf] = !0, qf("selectionchange", !1, b));
    }
}
function pf(a, b, c, d) {
    switch(jd(b)){
        case 1:
            var e = ed;
            break;
        case 4:
            e = gd;
            break;
        default:
            e = fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Jb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = df.get(a);
            if (void 0 !== h) {
                var k = td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case $e:
                    case af:
                    case bf:
                        k = Hd;
                        break;
                    case cf:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = Kb(w, x), null != F && t.push(tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== wb && (n = c.relatedTarget || c.fromElement) && (Wc(n) || n[uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? Wc(n) : null, null !== n && (J = Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : ue(k);
                        u = null == n ? h : ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = vf(u))w++;
                            u = 0;
                            for(F = x; F; F = vf(F))u++;
                            for(; 0 < w - u;)t = vf(t), w--;
                            for(; 0 < u - w;)x = vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = vf(t);
                                x = vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && wf(g, h, k, t, !1);
                        null !== n && null !== J && wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = ve;
                else if (me(h)) {
                    if (we) na = Fe;
                    else {
                        na = De;
                        var xa = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = Ee);
                if (na && (na = na(a, d))) {
                    ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && cb(h, "number", h.value);
            }
            xa = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(xa) || "true" === xa.contentEditable) Qe = xa, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var $a;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else ie ? ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && ie && ($a = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), xa = oe(d, ba), 0 < xa.length && (ba = new Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = he(c), null !== $a && (ba.data = $a))));
            if ($a = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        se(g, b);
    });
}
function tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Kb(a, c), null != f && d.unshift(tf(a, f, e)), f = Kb(a, b), null != f && d.push(tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Kb(c, f), null != k && g.unshift(tf(c, k, h))) : e || (k = Kb(c, f), null != k && g.push(tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var xf = /\r\n?/g, yf = /\u0000|\uFFFD/g;
function zf(a) {
    return ("string" === typeof a ? a : "" + a).replace(xf, "\n").replace(yf, "");
}
function Af(a, b, c) {
    b = zf(b);
    if (zf(a) !== b && c) throw Error(p(425));
}
function Bf() {}
var Cf = null, Df = null;
function Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Ff = "function" === typeof setTimeout ? setTimeout : void 0, Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, Hf = "function" === typeof Promise ? Promise : void 0, Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof Hf ? function(a) {
    return Hf.resolve(null).then(a).catch(If);
} : Ff;
function If(a) {
    setTimeout(function() {
        throw a;
    });
}
function Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    bd(b);
}
function Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Nf = Math.random().toString(36).slice(2), Of = "__reactFiber$" + Nf, Pf = "__reactProps$" + Nf, uf = "__reactContainer$" + Nf, of = "__reactEvents$" + Nf, Qf = "__reactListeners$" + Nf, Rf = "__reactHandles$" + Nf;
function Wc(a) {
    var b = a[Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[uf] || c[Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Mf(a); null !== a;){
                if (c = a[Of]) return c;
                a = Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[Of] || a[uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(p(33));
}
function Db(a) {
    return a[Pf] || null;
}
var Sf = [], Tf = -1;
function Uf(a) {
    return {
        current: a
    };
}
function E(a) {
    0 > Tf || (a.current = Sf[Tf], Sf[Tf] = null, Tf--);
}
function G(a, b) {
    Tf++;
    Sf[Tf] = a.current;
    a.current = b;
}
var Vf = {}, H = Uf(Vf), Wf = Uf(!1), Xf = Vf;
function Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $f() {
    E(Wf);
    E(H);
}
function ag(a, b, c) {
    if (H.current !== Vf) throw Error(p(168));
    G(H, b);
    G(Wf, c);
}
function bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error(p(108, Ra(a) || "Unknown", e));
    return A({}, c, d);
}
function cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Vf;
    Xf = H.current;
    G(H, a);
    G(Wf, Wf.current);
    return !0;
}
function dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(p(169));
    c ? (a = bg(a, b, Xf), d.__reactInternalMemoizedMergedChildContext = a, E(Wf), E(H), G(H, a)) : E(Wf);
    G(Wf, c);
}
var eg = null, fg = !1, gg = !1;
function hg(a) {
    null === eg ? eg = [
        a
    ] : eg.push(a);
}
function ig(a) {
    fg = !0;
    hg(a);
}
function jg() {
    if (!gg && null !== eg) {
        gg = !0;
        var a = 0, b = C;
        try {
            var c = eg;
            for(C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            eg = null;
            fg = !1;
        } catch (e) {
            throw null !== eg && (eg = eg.slice(a + 1)), ac(fc, jg), e;
        } finally{
            C = b, gg = !1;
        }
    }
    return null;
}
var kg = [], lg = 0, mg = null, ng = 0, og = [], pg = 0, qg = null, rg = 1, sg = "";
function tg(a, b) {
    kg[lg++] = ng;
    kg[lg++] = mg;
    mg = a;
    ng = b;
}
function ug(a, b, c) {
    og[pg++] = rg;
    og[pg++] = sg;
    og[pg++] = qg;
    qg = a;
    var d = rg;
    a = sg;
    var e = 32 - oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        rg = 1 << 32 - oc(b) + e | c << e | d;
        sg = f + a;
    } else rg = 1 << f | c << e | d, sg = a;
}
function vg(a) {
    null !== a.return && (tg(a, 1), ug(a, 1, 0));
}
function wg(a) {
    for(; a === mg;)mg = kg[--lg], kg[lg] = null, ng = kg[--lg], kg[lg] = null;
    for(; a === qg;)qg = og[--pg], og[pg] = null, sg = og[--pg], og[pg] = null, rg = og[--pg], og[pg] = null;
}
var xg = null, yg = null, I = !1, zg = null;
function Ag(a, b) {
    var c = Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, xg = a, yg = Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, xg = a, yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== qg ? {
                id: rg,
                overflow: sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, xg = a, yg = null, !0) : !1;
        default:
            return !1;
    }
}
function Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function Eg(a) {
    if (I) {
        var b = yg;
        if (b) {
            var c = b;
            if (!Cg(a, b)) {
                if (Dg(a)) throw Error(p(418));
                b = Lf(c.nextSibling);
                var d = xg;
                b && Cg(a, b) ? Ag(d, c) : (a.flags = a.flags & -4097 | 2, I = !1, xg = a);
            }
        } else {
            if (Dg(a)) throw Error(p(418));
            a.flags = a.flags & -4097 | 2;
            I = !1;
            xg = a;
        }
    }
}
function Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    xg = a;
}
function Gg(a) {
    if (a !== xg) return !1;
    if (!I) return Fg(a), I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !Ef(a.type, a.memoizedProps));
    if (b && (b = yg)) {
        if (Dg(a)) throw Hg(), Error(p(418));
        for(; b;)Ag(a, b), b = Lf(b.nextSibling);
    }
    Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            yg = Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            yg = null;
        }
    } else yg = xg ? Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function Hg() {
    for(var a = yg; a;)a = Lf(a.nextSibling);
}
function Ig() {
    yg = xg = null;
    I = !1;
}
function Jg(a) {
    null === zg ? zg = [
        a
    ] : zg.push(a);
}
var Kg = ua.ReactCurrentBatchConfig;
function Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error(p(284));
        if (!c._owner) throw Error(p(290, a));
    }
    return a;
}
function Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error(p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === Ha && Ng(f) === b.type)) return d = e(b, c.props), d.ref = Lg(a, b, c), d.return = a, d;
        d = Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case va:
                    return c = Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = Lg(a, null, b), c.return = a, c;
                case wa:
                    return b = Sg(b, a.mode, c), b.return = a, b;
                case Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if (eb(b) || Ka(b)) return b = Tg(b, a.mode, c, null), b.return = a, b;
            Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case va:
                    return c.key === e ? k(a, b, c, d) : null;
                case wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if (eb(c) || Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if (eb(d) || Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), I && tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            I && tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = Ka(h);
        if ("function" !== typeof l) throw Error(p(150));
        h = l.call(h);
        if (null == h) throw Error(p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), I && tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            I && tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        I && tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === Ha && Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === ya ? (d = Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if (eb(f)) return n(a, d, f, h);
            if (Ka(f)) return t(a, d, f, h);
            Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var Ug = Og(!0), Vg = Og(!1), Wg = Uf(null), Xg = null, Yg = null, Zg = null;
function $g() {
    Zg = Yg = Xg = null;
}
function ah(a) {
    var b = Wg.current;
    E(Wg);
    a._currentValue = b;
}
function bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function ch(a, b) {
    Xg = a;
    Zg = Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (dh = !0), a.firstContext = null);
}
function eh(a) {
    var b = a._currentValue;
    if (Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === Yg) {
            if (null === Xg) throw Error(p(308));
            Yg = a;
            Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else Yg = Yg.next = a;
    }
    return b;
}
var fh = null;
function gh(a) {
    null === fh ? fh = [
        a
    ] : fh.push(a);
}
function hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return ih(a, d);
}
function ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var jh = !1;
function kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== (K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return ih(a, c);
}
function oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
function ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function qh(a, b, c, d) {
    var e = a.updateQueue;
    jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = A({}, q, r);
                            break a;
                        case 2:
                            jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(p(191, e));
            e.call(d);
        }
    }
}
var th = {}, uh = Uf(th), vh = Uf(th), wh = Uf(th);
function xh(a) {
    if (a === th) throw Error(p(174));
    return a;
}
function yh(a, b) {
    G(wh, b);
    G(vh, a);
    G(uh, th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = lb(b, a);
    }
    E(uh);
    G(uh, b);
}
function zh() {
    E(uh);
    E(vh);
    E(wh);
}
function Ah(a) {
    xh(wh.current);
    var b = xh(uh.current);
    var c = lb(b, a.type);
    b !== c && (G(vh, a), G(uh, c));
}
function Bh(a) {
    vh.current === a && (E(uh), E(vh));
}
var L = Uf(0);
function Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var Dh = [];
function Eh() {
    for(var a = 0; a < Dh.length; a++)Dh[a]._workInProgressVersionPrimary = null;
    Dh.length = 0;
}
var Fh = ua.ReactCurrentDispatcher, Gh = ua.ReactCurrentBatchConfig, Hh = 0, M = null, N = null, O = null, Ih = !1, Jh = !1, Kh = 0, Lh = 0;
function P() {
    throw Error(p(321));
}
function Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Nh(a, b, c, d, e, f) {
    Hh = f;
    M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    Fh.current = null === a || null === a.memoizedState ? Oh : Ph;
    a = c(d, e);
    if (Jh) {
        f = 0;
        do {
            Jh = !1;
            Kh = 0;
            if (25 <= f) throw Error(p(301));
            f += 1;
            O = N = null;
            b.updateQueue = null;
            Fh.current = Qh;
            a = c(d, e);
        }while (Jh);
    }
    Fh.current = Rh;
    b = null !== N && null !== N.next;
    Hh = 0;
    O = N = M = null;
    Ih = !1;
    if (b) throw Error(p(300));
    return a;
}
function Sh() {
    var a = 0 !== Kh;
    Kh = 0;
    return a;
}
function Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === O ? M.memoizedState = O = a : O = O.next = a;
    return O;
}
function Uh() {
    if (null === N) {
        var a = M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = N.next;
    var b = null === O ? M.memoizedState : O.next;
    if (null !== b) O = b, N = a;
    else {
        if (null === a) throw Error(p(310));
        N = a;
        a = {
            memoizedState: N.memoizedState,
            baseState: N.baseState,
            baseQueue: N.baseQueue,
            queue: N.queue,
            next: null
        };
        null === O ? M.memoizedState = O = a : O = O.next = a;
    }
    return O;
}
function Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Wh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if ((Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                M.lanes |= m;
                rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        He(d, b.memoizedState) || (dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, M.lanes |= f, rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Xh(a) {
    var b = Uh(), c = b.queue;
    if (null === c) throw Error(p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Yh() {}
function Zh(a, b) {
    var c = M, d = Uh(), e = b(), f = !He(d.memoizedState, e);
    f && (d.memoizedState = e, dh = !0);
    d = d.queue;
    $h(ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== O && O.memoizedState.tag & 1) {
        c.flags |= 2048;
        bi(9, ci.bind(null, c, d, e, b), void 0, null);
        if (null === Q) throw Error(p(349));
        0 !== (Hh & 30) || di(c, b, e);
    }
    return e;
}
function di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    ei(b) && fi(a);
}
function ai(a, b, c) {
    return c(function() {
        ei(b) && fi(a);
    });
}
function ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !He(a, c);
    } catch (d) {
        return !0;
    }
}
function fi(a) {
    var b = ih(a, 1);
    null !== b && gi(b, a, 1, -1);
}
function hi(a) {
    var b = Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = ii.bind(null, M, a);
    return [
        b.memoizedState,
        a
    ];
}
function bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function ji() {
    return Uh().memoizedState;
}
function ki(a, b, c, d) {
    var e = Th();
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function li(a, b, c, d) {
    var e = Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== N) {
        var g = N.memoizedState;
        f = g.destroy;
        if (null !== d && Mh(d, g.deps)) {
            e.memoizedState = bi(b, c, f, d);
            return;
        }
    }
    M.flags |= a;
    e.memoizedState = bi(1 | b, c, f, d);
}
function mi(a, b) {
    return ki(8390656, 8, a, b);
}
function $h(a, b) {
    return li(2048, 8, a, b);
}
function ni(a, b) {
    return li(4, 2, a, b);
}
function oi(a, b) {
    return li(4, 4, a, b);
}
function pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return li(4, 4, pi.bind(null, b, a), c);
}
function ri() {}
function si(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ti(a, b) {
    var c = Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ui(a, b, c) {
    if (0 === (Hh & 21)) return a.baseState && (a.baseState = !1, dh = !0), a.memoizedState = c;
    He(c, b) || (c = yc(), M.lanes |= c, rh |= c, a.baseState = !0);
    return b;
}
function vi(a, b) {
    var c = C;
    C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = Gh.transition;
    Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        C = c, Gh.transition = d;
    }
}
function wi() {
    return Uh().memoizedState;
}
function xi(a, b, c) {
    var d = yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, c);
    else if (c = hh(a, b, c, d), null !== c) {
        var e = R();
        gi(c, a, d, e);
        Bi(c, b, d);
    }
}
function ii(a, b, c) {
    var d = yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (zi(a)) Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if (He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = hh(a, b, e, d);
        null !== c && (e = R(), gi(c, a, d, e), Bi(c, b, d));
    }
}
function zi(a) {
    var b = a.alternate;
    return a === M || null !== b && b === M;
}
function Ai(a, b) {
    Jh = Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        Cc(a, c);
    }
}
var Rh = {
    readContext: eh,
    useCallback: P,
    useContext: P,
    useEffect: P,
    useImperativeHandle: P,
    useInsertionEffect: P,
    useLayoutEffect: P,
    useMemo: P,
    useReducer: P,
    useRef: P,
    useState: P,
    useDebugValue: P,
    useDeferredValue: P,
    useTransition: P,
    useMutableSource: P,
    useSyncExternalStore: P,
    useId: P,
    unstable_isNewReconciler: !1
}, Oh = {
    readContext: eh,
    useCallback: function(a, b) {
        Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: eh,
    useEffect: mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return ki(4194308, 4, pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = xi.bind(null, M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: hi,
    useDebugValue: ri,
    useDeferredValue: function(a) {
        return Th().memoizedState = a;
    },
    useTransition: function() {
        var a = hi(!1), b = a[0];
        a = vi.bind(null, a[1]);
        Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = M, e = Th();
        if (I) {
            if (void 0 === c) throw Error(p(407));
            c = c();
        } else {
            c = b();
            if (null === Q) throw Error(p(349));
            0 !== (Hh & 30) || di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        mi(ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        bi(9, ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = Th(), b = Q.identifierPrefix;
        if (I) {
            var c = sg;
            var d = rg;
            c = (d & ~(1 << 32 - oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, Ph = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Wh,
    useRef: ji,
    useState: function() {
        return Wh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Wh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
}, Qh = {
    readContext: eh,
    useCallback: si,
    useContext: eh,
    useEffect: $h,
    useImperativeHandle: qi,
    useInsertionEffect: ni,
    useLayoutEffect: oi,
    useMemo: ti,
    useReducer: Xh,
    useRef: ji,
    useState: function() {
        return Xh(Vh);
    },
    useDebugValue: ri,
    useDeferredValue: function(a) {
        var b = Uh();
        return null === N ? b.memoizedState = a : ui(b, N.memoizedState, a);
    },
    useTransition: function() {
        var a = Xh(Vh)[0], b = Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: Yh,
    useSyncExternalStore: Zh,
    useId: wi,
    unstable_isNewReconciler: !1
};
function Ci(a, b) {
    if (a && a.defaultProps) {
        b = A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = R(), e = yi(a), f = mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = nh(a, f, e);
        null !== b && (gi(b, a, e, d), oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = R(), d = yi(a), e = mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = nh(a, e, d);
        null !== b && (gi(b, a, d, c), oh(b, a, d));
    }
};
function Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Ie(c, d) || !Ie(e, f) : !0;
}
function Gi(a, b, c) {
    var d = !1, e = Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = eh(f) : (e = Zf(b) ? Xf : H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Yf(a, e) : Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Ei.enqueueReplaceState(b, b.state, null);
}
function Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = eh(f) : (f = Zf(b) ? Xf : H.current, e.context = Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Ei.enqueueReplaceState(e, e.state, null), qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function Ji(a, b) {
    try {
        var c = "", d = b;
        do c += Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Mi = "function" === typeof WeakMap ? WeakMap : Map;
function Ni(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Oi || (Oi = !0, Pi = d);
        Li(a, b);
    };
    return c;
}
function Qi(a, b, c) {
    c = mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        Li(a, b);
        "function" !== typeof d && (null === Ri ? Ri = new Set([
            this
        ]) : Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = Ti.bind(null, a, b, c), b.then(a, a));
}
function Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = mh(-1, 1), b.tag = 2, nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var Wi = ua.ReactCurrentOwner, dh = !1;
function Xi(a, b, c, d) {
    b.child = null === a ? Vg(b, null, c, d) : Ug(b, a.child, c, d);
}
function Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    ch(b, e);
    d = Nh(a, b, c, d, f, e);
    c = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && c && vg(b);
    b.flags |= 1;
    Xi(a, b, d, e);
    return b.child;
}
function $i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, bj(a, b, f, d, e);
        a = Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : Ie;
        if (c(g, d) && a.ref === b.ref) return Zi(a, b, e);
    }
    b.flags |= 1;
    a = Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if (Ie(f, d) && a.ref === b.ref) {
            if (dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && (dh = !0);
            else return b.lanes = a.lanes, Zi(a, b, e);
        }
    }
    return cj(a, b, c, d, e);
}
function dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, G(ej, fj), fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, G(ej, fj), fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            G(ej, fj);
            fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, G(ej, fj), fj |= d;
    Xi(a, b, e, c);
    return b.child;
}
function gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function cj(a, b, c, d, e) {
    var f = Zf(c) ? Xf : H.current;
    f = Yf(b, f);
    ch(b, e);
    c = Nh(a, b, c, d, f, e);
    d = Sh();
    if (null !== a && !dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, Zi(a, b, e);
    I && d && vg(b);
    b.flags |= 1;
    Xi(a, b, c, e);
    return b.child;
}
function hj(a, b, c, d, e) {
    if (Zf(c)) {
        var f = !0;
        cg(b);
    } else f = !1;
    ch(b, e);
    if (null === b.stateNode) ij(a, b), Gi(b, c, d), Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = eh(l) : (l = Zf(c) ? Xf : H.current, l = Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Hi(b, g, d, l);
        jh = !1;
        var r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || Wf.current || jh ? ("function" === typeof m && (Di(b, c, m, d), k = b.memoizedState), (h = jh || Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = eh(k) : (k = Zf(c) ? Xf : H.current, k = Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && Hi(b, g, d, k);
        jh = !1;
        r = b.memoizedState;
        g.state = r;
        qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || Wf.current || jh ? ("function" === typeof y && (Di(b, c, y, d), n = b.memoizedState), (l = jh || Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return jj(a, b, c, d, f, e);
}
function jj(a, b, c, d, e, f) {
    gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && dg(b, c, !1), Zi(a, b, f);
    d = b.stateNode;
    Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Ug(b, a.child, null, f), b.child = Ug(b, null, h, f)) : Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && dg(b, c, !0);
    return b.child;
}
function kj(a) {
    var b = a.stateNode;
    b.pendingContext ? ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && ag(a, b.context, !1);
    yh(a, b.containerInfo);
}
function lj(a, b, c, d, e) {
    Ig();
    Jg(e);
    b.flags |= 256;
    Xi(a, b, c, d);
    return b.child;
}
var mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function oj(a, b, c) {
    var d = b.pendingProps, e = L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    G(L, e & 1);
    if (null === a) {
        Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = pj(g, d, 0, null), a = Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = nj(c), b.memoizedState = mj, a) : qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = Pg(h, f) : (f = Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function qj(a, b) {
    b = pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function sj(a, b, c, d) {
    null !== d && Jg(d);
    Ug(b, a.child, null, c);
    a = qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = Ki(Error(p(422))), sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && Ug(b, a.child, null, g);
        b.child.memoizedState = nj(g);
        b.memoizedState = mj;
        return f;
    }
    if (0 === (b.mode & 1)) return sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error(p(419));
        d = Ki(f, d, void 0);
        return sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if (dh || h) {
        d = Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, ih(a, e), gi(d, a, e, -1));
        }
        tj();
        d = Ki(Error(p(421)));
        return sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    yg = Lf(e.nextSibling);
    xg = b;
    I = !0;
    zg = null;
    null !== a && (og[pg++] = rg, og[pg++] = sg, og[pg++] = qg, rg = a.id, sg = a.overflow, qg = b);
    b = qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    bh(a.return, b, c);
}
function wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    Xi(a, b, d.children, c);
    d = L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && vj(a, c, b);
            else if (19 === a.tag) vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    G(L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            wj(b, !0, c, null, f);
            break;
        case "together":
            wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error(p(153));
    if (null !== b.child) {
        a = b.child;
        c = Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function yj(a, b, c) {
    switch(b.tag){
        case 3:
            kj(b);
            Ig();
            break;
        case 5:
            Ah(b);
            break;
        case 1:
            Zf(b.type) && cg(b);
            break;
        case 4:
            yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            G(Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return G(L, L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return oj(a, b, c);
                G(L, L.current & 1);
                a = Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            G(L, L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            G(L, L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, dj(a, b, c);
    }
    return Zi(a, b, c);
}
var zj, Aj, Bj, Cj;
zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Aj = function() {};
Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        xh(uh.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "select":
                e = A({}, e, {
                    value: void 0
                });
                d = A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = Bf);
        }
        ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Dj(a, b) {
    if (!I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function Ej(a, b, c) {
    var d = b.pendingProps;
    wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return S(b), null;
        case 1:
            return Zf(b.type) && $f(), S(b), null;
        case 3:
            d = b.stateNode;
            zh();
            E(Wf);
            E(H);
            Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== zg && (Fj(zg), zg = null));
            Aj(a, b);
            S(b);
            return null;
        case 5:
            Bh(b);
            var e = xh(wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(p(166));
                    S(b);
                    return null;
                }
                a = xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[Of] = b;
                    d[Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            D("cancel", d);
                            D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < lf.length; e++)D(lf[e], d);
                            break;
                        case "source":
                            D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            D("error", d);
                            D("load", d);
                            break;
                        case "details":
                            D("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            D("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), D("invalid", d);
                    }
                    ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : ea.hasOwnProperty(g) && null != h && "onScroll" === g && D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            Va(d);
                            db(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[Of] = b;
                    a[Pf] = d;
                    zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = vb(c, d);
                        switch(c){
                            case "dialog":
                                D("cancel", a);
                                D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < lf.length; e++)D(lf[e], a);
                                e = d;
                                break;
                            case "source":
                                D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                D("error", a);
                                D("load", a);
                                e = d;
                                break;
                            case "details":
                                D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                Za(a, d);
                                e = Ya(a, d);
                                D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = A({}, d, {
                                    value: void 0
                                });
                                D("invalid", a);
                                break;
                            case "textarea":
                                hb(a, d);
                                e = gb(a, d);
                                D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && ob(a, k) : "number" === typeof k && ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ea.hasOwnProperty(f) ? null != k && "onScroll" === f && D("scroll", a) : null != k && ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                Va(a);
                                db(a, d, !1);
                                break;
                            case "textarea":
                                Va(a);
                                jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(p(166));
                c = xh(wh.current);
                xh(uh.current);
                if (Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = xg, null !== a) switch(a.tag){
                            case 3:
                                Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[Of] = b, b.stateNode = d;
            }
            S(b);
            return null;
        case 13:
            E(L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if (I && null !== yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) Hg(), Ig(), b.flags |= 98560, f = !1;
                else if (f = Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error(p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error(p(317));
                        f[Of] = b;
                    } else Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    S(b);
                    f = !1;
                } else null !== zg && (Fj(zg), zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== (L.current & 1) ? 0 === T && (T = 3) : tj()));
            null !== b.updateQueue && (b.flags |= 4);
            S(b);
            return null;
        case 4:
            return zh(), Aj(a, b), null === a && sf(b.stateNode.containerInfo), S(b), null;
        case 10:
            return ah(b.type._context), S(b), null;
        case 17:
            return Zf(b.type) && $f(), S(b), null;
        case 19:
            E(L);
            f = b.memoizedState;
            if (null === f) return S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) Dj(f, !1);
                else {
                    if (0 !== T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            G(L, L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && B() > Gj && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !I) return S(b), null;
                    } else 2 * B() - f.renderingStartTime > Gj && 1073741824 !== c && (b.flags |= 128, d = !0, Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = B(), b.sibling = null, c = L.current, G(L, d ? c & 1 | 2 : c & 1), b;
            S(b);
            return null;
        case 22:
        case 23:
            return Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== (fj & 1073741824) && (S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error(p(156, b.tag));
}
function Ij(a, b) {
    wg(b);
    switch(b.tag){
        case 1:
            return Zf(b.type) && $f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return zh(), E(Wf), E(H), Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return Bh(b), null;
        case 13:
            E(L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error(p(340));
                Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return E(L), null;
        case 4:
            return zh(), null;
        case 10:
            return ah(b.type._context), null;
        case 22:
        case 23:
            return Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var Jj = !1, U = !1, Kj = "function" === typeof WeakSet ? WeakSet : Set, V = null;
function Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            W(a, b, d);
        }
        else c.current = null;
    }
}
function Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        W(a, b, d);
    }
}
var Nj = !1;
function Oj(a, b) {
    Cf = dd;
    a = Me();
    if (Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    Df = {
        focusedElem: a,
        selectionRange: c
    };
    dd = !1;
    for(V = b; null !== V;)if (b = V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, V = a;
    else for(; null !== V;){
        b = V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error(p(163));
            }
        } catch (F) {
            W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            V = a;
            break;
        }
        V = b.return;
    }
    n = Nj;
    Nj = !1;
    return n;
}
function Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[Of], delete b[Pf], delete b[of], delete b[Qf], delete b[Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = Bf));
    else if (4 !== d && (a = a.child, null !== a)) for(Vj(a, b, c), a = a.sibling; null !== a;)Vj(a, b, c), a = a.sibling;
}
function Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Wj(a, b, c), a = a.sibling; null !== a;)Wj(a, b, c), a = a.sibling;
}
var X = null, Xj = !1;
function Yj(a, b, c) {
    for(c = c.child; null !== c;)Zj(a, b, c), c = c.sibling;
}
function Zj(a, b, c) {
    if (lc && "function" === typeof lc.onCommitFiberUnmount) try {
        lc.onCommitFiberUnmount(kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            U || Lj(c, b);
        case 6:
            var d = X, e = Xj;
            X = null;
            Yj(a, b, c);
            X = d;
            Xj = e;
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : X.removeChild(c.stateNode));
            break;
        case 18:
            null !== X && (Xj ? (a = X, c = c.stateNode, 8 === a.nodeType ? Kf(a.parentNode, c) : 1 === a.nodeType && Kf(a, c), bd(a)) : Kf(X, c.stateNode));
            break;
        case 4:
            d = X;
            e = Xj;
            X = c.stateNode.containerInfo;
            Xj = !0;
            Yj(a, b, c);
            X = d;
            Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? Mj(c, b, g) : 0 !== (f & 4) && Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            Yj(a, b, c);
            break;
        case 1:
            if (!U && (Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                W(c, b, h);
            }
            Yj(a, b, c);
            break;
        case 21:
            Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? (U = (d = U) || null !== c.memoizedState, Yj(a, b, c), U = d) : Yj(a, b, c);
            break;
        default:
            Yj(a, b, c);
    }
}
function ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Kj);
        b.forEach(function(b) {
            var d = bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        X = h.stateNode;
                        Xj = !1;
                        break a;
                    case 3:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                    case 4:
                        X = h.stateNode.containerInfo;
                        Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === X) throw Error(p(160));
            Zj(f, g, e);
            X = null;
            Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)dk(b, a), b = b.sibling;
}
function dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            ck(b, a);
            ek(a);
            if (d & 4) {
                try {
                    Pj(3, a, a.return), Qj(3, a);
                } catch (t) {
                    W(a, a.return, t);
                }
                try {
                    Pj(5, a, a.return);
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 1:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            break;
        case 5:
            ck(b, a);
            ek(a);
            d & 512 && null !== c && Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    ob(e, "");
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && ab(e, f);
                    vb(h, g);
                    var l = vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? sb(e, q) : "dangerouslySetInnerHTML" === m ? nb(e, q) : "children" === m ? ob(e, q) : ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            bb(e, f);
                            break;
                        case "textarea":
                            ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? fb(e, !!f.multiple, f.defaultValue, !0) : fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[Pf] = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 6:
            ck(b, a);
            ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error(p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    W(a, a.return, t);
                }
            }
            break;
        case 3:
            ck(b, a);
            ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                bd(b.containerInfo);
            } catch (t) {
                W(a, a.return, t);
            }
            break;
        case 4:
            ck(b, a);
            ek(a);
            break;
        case 13:
            ck(b, a);
            ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || (fk = B()));
            d & 4 && ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? (U = (l = U) || m, ck(b, a), U = l) : ck(b, a);
            ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for(V = a, m = a.child; null !== m;){
                    for(q = V = m; null !== V;){
                        r = V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                Pj(4, r, r.return);
                                break;
                            case 1:
                                Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, V = y) : gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = rb("display", g));
                            } catch (t) {
                                W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            ck(b, a);
            ek(a);
            d & 4 && ak(a);
            break;
        case 21:
            break;
        default:
            ck(b, a), ek(a);
    }
}
function ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if (Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error(p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && (ob(e, ""), d.flags &= -33);
                    var f = Uj(a);
                    Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = Uj(a);
                    Vj(a, h, g);
                    break;
                default:
                    throw Error(p(161));
            }
        } catch (k) {
            W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function hk(a, b, c) {
    V = a;
    ik(a, b, c);
}
function ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== V;){
        var e = V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || U;
                h = Jj;
                var l = U;
                Jj = g;
                if ((U = k) && !l) for(V = e; null !== V;)g = V, k = g.child, 22 === g.tag && null !== g.memoizedState ? jk(e) : null !== k ? (k.return = g, V = k) : jk(e);
                for(; null !== f;)V = f, ik(f, b, c), f = f.sibling;
                V = e;
                Jj = h;
                U = l;
            }
            kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, V = f) : kk(a, b, c);
    }
}
function kk(a) {
    for(; null !== V;){
        var b = V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        U || Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error(p(163));
                }
                U || b.flags & 512 && Rj(b);
            } catch (r) {
                W(b, b.return, r);
            }
        }
        if (b === a) {
            V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function gk(a) {
    for(; null !== V;){
        var b = V;
        if (b === a) {
            V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            V = c;
            break;
        }
        V = b.return;
    }
}
function jk(a) {
    for(; null !== V;){
        var b = V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        Qj(4, b);
                    } catch (k) {
                        W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        Rj(b);
                    } catch (k) {
                        W(b, g, k);
                    }
            }
        } catch (k) {
            W(b, b.return, k);
        }
        if (b === a) {
            V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            V = h;
            break;
        }
        V = b.return;
    }
}
var lk = Math.ceil, mk = ua.ReactCurrentDispatcher, nk = ua.ReactCurrentOwner, ok = ua.ReactCurrentBatchConfig, K = 0, Q = null, Y = null, Z = 0, fj = 0, ej = Uf(0), T = 0, pk = null, rh = 0, qk = 0, rk = 0, sk = null, tk = null, fk = 0, Gj = Infinity, uk = null, Oi = !1, Pi = null, Ri = null, vk = !1, wk = null, xk = 0, yk = 0, zk = null, Ak = -1, Bk = 0;
function R() {
    return 0 !== (K & 6) ? B() : -1 !== Ak ? Ak : Ak = B();
}
function yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== (K & 2) && 0 !== Z) return Z & -Z;
    if (null !== Kg.transition) return 0 === Bk && (Bk = yc()), Bk;
    a = C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : jd(a.type);
    return a;
}
function gi(a, b, c, d) {
    if (50 < yk) throw yk = 0, zk = null, Error(p(185));
    Ac(a, c, d);
    if (0 === (K & 2) || a !== Q) a === Q && (0 === (K & 2) && (qk |= c), 4 === T && Ck(a, Z)), Dk(a, d), 1 === c && 0 === K && 0 === (b.mode & 1) && (Gj = B() + 500, fg && jg());
}
function Dk(a, b) {
    var c = a.callbackNode;
    wc(a, b);
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) null !== c && bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && bc(c);
        if (1 === b) 0 === a.tag ? ig(Ek.bind(null, a)) : hg(Ek.bind(null, a)), Jf(function() {
            0 === (K & 6) && jg();
        }), c = null;
        else {
            switch(Dc(d)){
                case 1:
                    c = fc;
                    break;
                case 4:
                    c = gc;
                    break;
                case 16:
                    c = hc;
                    break;
                case 536870912:
                    c = jc;
                    break;
                default:
                    c = hc;
            }
            c = Fk(c, Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Gk(a, b) {
    Ak = -1;
    Bk = 0;
    if (0 !== (K & 6)) throw Error(p(327));
    var c = a.callbackNode;
    if (Hk() && a.callbackNode !== c) return null;
    var d = uc(a, a === Q ? Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = Ik(a, d);
    else {
        b = d;
        var e = K;
        K |= 2;
        var f = Jk();
        if (Q !== a || Z !== b) uk = null, Gj = B() + 500, Kk(a, b);
        for(;;)try {
            Lk();
            break;
        } catch (h) {
            Mk(a, h);
        }
        $g();
        mk.current = f;
        K = e;
        null !== Y ? b = 0 : (Q = null, Z = 0, b = T);
    }
    if (0 !== b) {
        2 === b && (e = xc(a), 0 !== e && (d = e, b = Nk(a, e)));
        if (1 === b) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
        if (6 === b) Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !Ok(e) && (b = Ik(a, d), 2 === b && (f = xc(a), 0 !== f && (d = f, b = Nk(a, f))), 1 === b)) throw c = pk, Kk(a, 0), Ck(a, d), Dk(a, B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error(p(345));
                case 2:
                    Pk(a, tk, uk);
                    break;
                case 3:
                    Ck(a, d);
                    if ((d & 130023424) === d && (b = fk + 500 - B(), 10 < b)) {
                        if (0 !== uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), b);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 4:
                    Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = Ff(Pk.bind(null, a, tk, uk), d);
                        break;
                    }
                    Pk(a, tk, uk);
                    break;
                case 5:
                    Pk(a, tk, uk);
                    break;
                default:
                    throw Error(p(329));
            }
        }
    }
    Dk(a, B());
    return a.callbackNode === c ? Gk.bind(null, a) : null;
}
function Nk(a, b) {
    var c = sk;
    a.current.memoizedState.isDehydrated && (Kk(a, b).flags |= 256);
    a = Ik(a, b);
    2 !== a && (b = tk, tk = c, null !== b && Fj(b));
    return a;
}
function Fj(a) {
    null === tk ? tk = a : tk.push.apply(tk, a);
}
function Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function Ck(a, b) {
    b &= ~rk;
    b &= ~qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Ek(a) {
    if (0 !== (K & 6)) throw Error(p(327));
    Hk();
    var b = uc(a, 0);
    if (0 === (b & 1)) return Dk(a, B()), null;
    var c = Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = xc(a);
        0 !== d && (b = d, c = Nk(a, d));
    }
    if (1 === c) throw c = pk, Kk(a, 0), Ck(a, b), Dk(a, B()), c;
    if (6 === c) throw Error(p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Pk(a, tk, uk);
    Dk(a, B());
    return null;
}
function Qk(a, b) {
    var c = K;
    K |= 1;
    try {
        return a(b);
    } finally{
        K = c, 0 === K && (Gj = B() + 500, fg && jg());
    }
}
function Rk(a) {
    null !== wk && 0 === wk.tag && 0 === (K & 6) && Hk();
    var b = K;
    K |= 1;
    var c = ok.transition, d = C;
    try {
        if (ok.transition = null, C = 1, a) return a();
    } finally{
        C = d, ok.transition = c, K = b, 0 === (K & 6) && jg();
    }
}
function Hj() {
    fj = ej.current;
    E(ej);
}
function Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Gf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $f();
                break;
            case 3:
                zh();
                E(Wf);
                E(H);
                Eh();
                break;
            case 5:
                Bh(d);
                break;
            case 4:
                zh();
                break;
            case 13:
                E(L);
                break;
            case 19:
                E(L);
                break;
            case 10:
                ah(d.type._context);
                break;
            case 22:
            case 23:
                Hj();
        }
        c = c.return;
    }
    Q = a;
    Y = a = Pg(a.current, null);
    Z = fj = b;
    T = 0;
    pk = null;
    rk = qk = rh = 0;
    tk = sk = null;
    if (null !== fh) {
        for(b = 0; b < fh.length; b++)if (c = fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        fh = null;
    }
    return a;
}
function Mk(a, b) {
    do {
        var c = Y;
        try {
            $g();
            Fh.current = Rh;
            if (Ih) {
                for(var d = M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                Ih = !1;
            }
            Hh = 0;
            O = N = M = null;
            Jh = !1;
            Kh = 0;
            nk.current = null;
            if (null === c || null === c.return) {
                T = 1;
                pk = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        Vi(y, g, h, f, b);
                        y.mode & 1 && Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            Si(f, l, b);
                            tj();
                            break a;
                        }
                        k = Error(p(426));
                    }
                } else if (I && h.mode & 1) {
                    var J = Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        Vi(J, g, h, f, b);
                        Jg(Ji(k, h));
                        break a;
                    }
                }
                f = k = Ji(k, h);
                4 !== T && (T = 2);
                null === sk ? sk = [
                    f
                ] : sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = Ni(f, k, b);
                            ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === Ri || !Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = Qi(f, h, b);
                                ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            Sk(c);
        } catch (na) {
            b = na;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Jk() {
    var a = mk.current;
    mk.current = Rh;
    return null === a ? Rh : a;
}
function tj() {
    if (0 === T || 3 === T || 2 === T) T = 4;
    null === Q || 0 === (rh & 268435455) && 0 === (qk & 268435455) || Ck(Q, Z);
}
function Ik(a, b) {
    var c = K;
    K |= 2;
    var d = Jk();
    if (Q !== a || Z !== b) uk = null, Kk(a, b);
    for(;;)try {
        Tk();
        break;
    } catch (e) {
        Mk(a, e);
    }
    $g();
    K = c;
    mk.current = d;
    if (null !== Y) throw Error(p(261));
    Q = null;
    Z = 0;
    return T;
}
function Tk() {
    for(; null !== Y;)Uk(Y);
}
function Lk() {
    for(; null !== Y && !cc();)Uk(Y);
}
function Uk(a) {
    var b = Vk(a.alternate, a, fj);
    a.memoizedProps = a.pendingProps;
    null === b ? Sk(a) : Y = b;
    nk.current = null;
}
function Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = Ej(c, b, fj), null !== c) {
                Y = c;
                return;
            }
        } else {
            c = Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                T = 6;
                Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === T && (T = 5);
}
function Pk(a, b, c) {
    var d = C, e = ok.transition;
    try {
        ok.transition = null, C = 1, Wk(a, b, c, d);
    } finally{
        ok.transition = e, C = d;
    }
    return null;
}
function Wk(a, b, c, d) {
    do Hk();
    while (null !== wk);
    if (0 !== (K & 6)) throw Error(p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    Bc(a, f);
    a === Q && (Y = Q = null, Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || vk || (vk = !0, Fk(hc, function() {
        Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = ok.transition;
        ok.transition = null;
        var g = C;
        C = 1;
        var h = K;
        K |= 4;
        nk.current = null;
        Oj(a, c);
        dk(c, a);
        Oe(Df);
        dd = !!Cf;
        Df = Cf = null;
        a.current = c;
        hk(c, a, e);
        dc();
        K = h;
        C = g;
        ok.transition = f;
    } else a.current = c;
    vk && (vk = !1, wk = a, xk = e);
    f = a.pendingLanes;
    0 === f && (Ri = null);
    mc(c.stateNode, d);
    Dk(a, B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if (Oi) throw Oi = !1, a = Pi, Pi = null, a;
    0 !== (xk & 1) && 0 !== a.tag && Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === zk ? yk++ : (yk = 0, zk = a) : yk = 0;
    jg();
    return null;
}
function Hk() {
    if (null !== wk) {
        var a = Dc(xk), b = ok.transition, c = C;
        try {
            ok.transition = null;
            C = 16 > a ? 16 : a;
            if (null === wk) var d = !1;
            else {
                a = wk;
                wk = null;
                xk = 0;
                if (0 !== (K & 6)) throw Error(p(331));
                var e = K;
                K |= 4;
                for(V = a.current; null !== V;){
                    var f = V, g = f.child;
                    if (0 !== (V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for(V = l; null !== V;){
                                    var m = V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, V = q;
                                    else for(; null !== V;){
                                        m = V;
                                        var r = m.sibling, y = m.return;
                                        Sj(m);
                                        if (m === l) {
                                            V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            V = r;
                                            break;
                                        }
                                        V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, V = g;
                    else b: for(; null !== V;){
                        f = V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            V = x;
                            break b;
                        }
                        V = f.return;
                    }
                }
                var w = a.current;
                for(V = w; null !== V;){
                    g = V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, V = u;
                    else b: for(g = w; null !== V;){
                        h = V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    Qj(9, h);
                            }
                        } catch (na) {
                            W(h, h.return, na);
                        }
                        if (h === g) {
                            V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            V = F;
                            break b;
                        }
                        V = h.return;
                    }
                }
                K = e;
                jg();
                if (lc && "function" === typeof lc.onPostCommitFiberRoot) try {
                    lc.onPostCommitFiberRoot(kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            C = c, ok.transition = b;
        }
    }
    return !1;
}
function Xk(a, b, c) {
    b = Ji(c, b);
    b = Ni(a, b, 1);
    a = nh(a, b, 1);
    b = R();
    null !== a && (Ac(a, 1, b), Dk(a, b));
}
function W(a, b, c) {
    if (3 === a.tag) Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ri || !Ri.has(d))) {
                a = Ji(c, a);
                a = Qi(b, a, 1);
                b = nh(b, a, 1);
                a = R();
                null !== b && (Ac(b, 1, a), Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = R();
    a.pingedLanes |= a.suspendedLanes & c;
    Q === a && (Z & c) === c && (4 === T || 3 === T && (Z & 130023424) === Z && 500 > B() - fk ? Kk(a, 0) : rk |= c);
    Dk(a, b);
}
function Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = sc, sc <<= 1, 0 === (sc & 130023424) && (sc = 4194304)));
    var c = R();
    a = ih(a, b);
    null !== a && (Ac(a, b, c), Dk(a, c));
}
function uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    Yk(a, c);
}
function bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error(p(314));
    }
    null !== d && d.delete(b);
    Yk(a, c);
}
var Vk;
Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || Wf.current) dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return dh = !1, yj(a, b, c);
            dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else dh = !1, I && 0 !== (b.flags & 1048576) && ug(b, ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            ij(a, b);
            a = b.pendingProps;
            var e = Yf(b, H.current);
            ch(b, c);
            e = Nh(null, b, d, a, e, c);
            var f = Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, Zf(d) ? (f = !0, cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, kh(b), e.updater = Ei, b.stateNode = e, e._reactInternals = b, Ii(b, d, a, c), b = jj(null, b, d, !0, f, c)) : (b.tag = 0, I && f && vg(b), Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = Zk(d);
                a = Ci(d, a);
                switch(e){
                    case 0:
                        b = cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $i(null, b, d, Ci(d.type, a), c);
                        break a;
                }
                throw Error(p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), hj(a, b, d, e, c);
        case 3:
            a: {
                kj(b);
                if (null === a) throw Error(p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                lh(a, b);
                qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = Ji(Error(p(423)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = Ji(Error(p(424)), b);
                        b = lj(a, b, d, c, e);
                        break a;
                    } else for(yg = Lf(b.stateNode.containerInfo.firstChild), xg = b, I = !0, zg = null, c = Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    Ig();
                    if (d === e) {
                        b = Zi(a, b, c);
                        break a;
                    }
                    Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return Ah(b), null === a && Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Ef(d, e) ? g = null : null !== f && Ef(d, f) && (b.flags |= 32), gj(a, b), Xi(a, b, g, c), b.child;
        case 6:
            return null === a && Eg(b), null;
        case 13:
            return oj(a, b, c);
        case 4:
            return yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Ug(b, null, d, c) : Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), Yi(a, b, d, e, c);
        case 7:
            return Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                G(Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if (He(f.value, g)) {
                        if (f.children === e.children && !Wf.current) {
                            b = Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error(p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, ch(b, c), e = eh(e), d = d(e), b.flags |= 1, Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = Ci(d, b.pendingProps), e = Ci(d.type, e), $i(a, b, d, e, c);
        case 15:
            return bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : Ci(d, e), ij(a, b), b.tag = 1, Zf(d) ? (a = !0, cg(b)) : a = !1, ch(b, c), Gi(b, d, e), Ii(b, d, e, c), jj(null, b, d, !0, a, c);
        case 19:
            return xj(a, b, c);
        case 22:
            return dj(a, b, c);
    }
    throw Error(p(156, b.tag));
};
function Fk(a, b) {
    return ac(a, b);
}
function $k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function Bg(a, b, c, d) {
    return new $k(a, b, c, d);
}
function aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Zk(a) {
    if ("function" === typeof a) return aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Da) return 11;
        if (a === Ga) return 14;
    }
    return 2;
}
function Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ya:
            return Tg(c.children, e, f, b);
        case za:
            g = 8;
            e |= 8;
            break;
        case Aa:
            return a = Bg(12, c, b, e | 2), a.elementType = Aa, a.lanes = f, a;
        case Ea:
            return a = Bg(13, c, b, e), a.elementType = Ea, a.lanes = f, a;
        case Fa:
            return a = Bg(19, c, b, e), a.elementType = Fa, a.lanes = f, a;
        case Ia:
            return pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case Ba:
                    g = 10;
                    break a;
                case Ca:
                    g = 9;
                    break a;
                case Da:
                    g = 11;
                    break a;
                case Ga:
                    g = 14;
                    break a;
                case Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error(p(130, null == a ? a : typeof a, ""));
    }
    b = Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Tg(a, b, c, d) {
    a = Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function pj(a, b, c, d) {
    a = Bg(22, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function Qg(a, b, c) {
    a = Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function Sg(a, b, c) {
    b = Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = zc(0);
    this.expirationTimes = zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function bl(a, b, c, d, e, f, g, h, k) {
    a = new al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    kh(f);
    return a;
}
function cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function dl(a) {
    if (!a) return Vf;
    a = a._reactInternals;
    a: {
        if (Vb(a) !== a || 1 !== a.tag) throw Error(p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if (Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error(p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if (Zf(c)) return bg(a, c, b);
    }
    return b;
}
function el(a, b, c, d, e, f, g, h, k) {
    a = bl(c, d, !0, a, e, f, g, h, k);
    a.context = dl(null);
    c = a.current;
    d = R();
    e = yi(c);
    f = mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    nh(c, f, e);
    a.current.lanes = e;
    Ac(a, e, d);
    Dk(a, d);
    return a;
}
function fl(a, b, c, d) {
    var e = b.current, f = R(), g = yi(e);
    c = dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = nh(e, b, g);
    null !== a && (gi(a, e, g, f), oh(a, e, g));
    return g;
}
function gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function il(a, b) {
    hl(a, b);
    (a = a.alternate) && hl(a, b);
}
function jl() {
    return null;
}
var kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function ll(a) {
    this._internalRoot = a;
}
ml.prototype.render = ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error(p(409));
    fl(a, b, null, null);
};
ml.prototype.unmount = ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        Rk(function() {
            fl(null, a, null, null);
        });
        b[uf] = null;
    }
};
function ml(a) {
    this._internalRoot = a;
}
ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < Qc.length && 0 !== b && b < Qc[c].priority; c++);
        Qc.splice(c, 0, a);
        0 === c && Vc(a);
    }
};
function nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function pl() {}
function ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = gl(g);
                f.call(a);
            };
        }
        var g = el(b, d, a, 0, null, !1, !1, "", pl);
        a._reactRootContainer = g;
        a[uf] = g.current;
        sf(8 === a.nodeType ? a.parentNode : a);
        Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = gl(k);
            h.call(a);
        };
    }
    var k = bl(a, 0, !1, null, null, !1, !1, "", pl);
    a._reactRootContainer = k;
    a[uf] = k.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    Rk(function() {
        fl(b, k, c, d);
    });
    return k;
}
function rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = gl(g);
                h.call(a);
            };
        }
        fl(b, g, a, e);
    } else g = ql(c, b, a, e, d);
    return gl(g);
}
Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = tc(b.pendingLanes);
                0 !== c && (Cc(b, c | 1), Dk(b, B()), 0 === (K & 6) && (Gj = B() + 500, jg()));
            }
            break;
        case 13:
            Rk(function() {
                var b = ih(a, 1);
                if (null !== b) {
                    var c = R();
                    gi(b, a, 1, c);
                }
            }), il(a, 1);
    }
};
Fc = function(a) {
    if (13 === a.tag) {
        var b = ih(a, 134217728);
        if (null !== b) {
            var c = R();
            gi(b, a, 134217728, c);
        }
        il(a, 134217728);
    }
};
Gc = function(a) {
    if (13 === a.tag) {
        var b = yi(a), c = ih(a, b);
        if (null !== c) {
            var d = R();
            gi(c, a, b, d);
        }
        il(a, b);
    }
};
Hc = function() {
    return C;
};
Ic = function(a, b) {
    var c = C;
    try {
        return C = a, b();
    } finally{
        C = c;
    }
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(p(90));
                        Wa(d);
                        bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Qk;
Hb = Rk;
var sl = {
    usingClientEntryPoint: !1,
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Qk
    ]
}, tl = {
    findFiberByHostInstance: Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var ul = {
    bundleType: tl.bundleType,
    version: tl.version,
    rendererPackageName: tl.rendererPackageName,
    rendererConfig: tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: tl.findFiberByHostInstance || jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!vl.isDisabled && vl.supportsFiber) try {
        kc = vl.inject(ul), lc = vl;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = sl;
exports.createPortal = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!nl(b)) throw Error(p(200));
    return cl(a, b, null, c);
};
exports.createRoot = function(a, b) {
    if (!nl(a)) throw Error(p(299));
    var c = !1, d = "", e = kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = bl(a, 1, !1, null, null, c, !1, d, e);
    a[uf] = b.current;
    sf(8 === a.nodeType ? a.parentNode : a);
    return new ll(b);
};
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(p(188));
        a = Object.keys(a).join(",");
        throw Error(p(268, a));
    }
    a = Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a) {
    return Rk(a);
};
exports.hydrate = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !0, c);
};
exports.hydrateRoot = function(a, b, c) {
    if (!nl(a)) throw Error(p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[uf] = b.current;
    sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new ml(b);
};
exports.render = function(a, b, c) {
    if (!ol(b)) throw Error(p(200));
    return rl(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!ol(a)) throw Error(p(40));
    return a._reactRootContainer ? (Rk(function() {
        rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[uf] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Qk;
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!ol(c)) throw Error(p(200));
    if (null == a || void 0 === a._reactInternals) throw Error(p(38));
    return rl(a, b, c, !1, d);
};
exports.version = "18.3.1-next-f1338f8080-20240426";

},{"5393afc8c463ef07":"8CCva","ece50e903283a22f":"jW6N1"}],"jW6N1":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("15840f0beed8ff36");

},{"15840f0beed8ff36":"9cWRV"}],"9cWRV":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
function f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function h(a) {
    return 0 === a.length ? null : a[0];
}
function k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > g(C, c)) n < e && 0 > g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var l = performance;
    exports.unstable_now = function() {
        return l.now();
    };
} else {
    var p = Date, q = p.now();
    exports.unstable_now = function() {
        return p.now() - q;
    };
}
var r = [], t = [], u = 1, v = null, y = 3, z = !1, A = !1, B = !1, D = "function" === typeof setTimeout ? setTimeout : null, E = "function" === typeof clearTimeout ? clearTimeout : null, F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function G(a) {
    for(var b = h(t); null !== b;){
        if (null === b.callback) k(t);
        else if (b.startTime <= a) k(t), b.sortIndex = b.expirationTime, f(r, b);
        else break;
        b = h(t);
    }
}
function H(a) {
    B = !1;
    G(a);
    if (!A) {
        if (null !== h(r)) A = !0, I(J);
        else {
            var b = h(t);
            null !== b && K(H, b.startTime - a);
        }
    }
}
function J(a, b) {
    A = !1;
    B && (B = !1, E(L), L = -1);
    z = !0;
    var c = y;
    try {
        G(b);
        for(v = h(r); null !== v && (!(v.expirationTime > b) || a && !M());){
            var d = v.callback;
            if ("function" === typeof d) {
                v.callback = null;
                y = v.priorityLevel;
                var e = d(v.expirationTime <= b);
                b = exports.unstable_now();
                "function" === typeof e ? v.callback = e : v === h(r) && k(r);
                G(b);
            } else k(r);
            v = h(r);
        }
        if (null !== v) var w = !0;
        else {
            var m = h(t);
            null !== m && K(H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        v = null, y = c, z = !1;
    }
}
var N = !1, O = null, L = -1, P = 5, Q = -1;
function M() {
    return exports.unstable_now() - Q < P ? !1 : !0;
}
function R() {
    if (null !== O) {
        var a = exports.unstable_now();
        Q = a;
        var b = !0;
        try {
            b = O(!0, a);
        } finally{
            b ? S() : (N = !1, O = null);
        }
    } else N = !1;
}
var S;
if ("function" === typeof F) S = function() {
    F(R);
};
else if ("undefined" !== typeof MessageChannel) {
    var T = new MessageChannel, U = T.port2;
    T.port1.onmessage = R;
    S = function() {
        U.postMessage(null);
    };
} else S = function() {
    D(R, 0);
};
function I(a) {
    O = a;
    N || (N = !0, S());
}
function K(a, b) {
    L = D(function() {
        a(exports.unstable_now());
    }, b);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
    a.callback = null;
};
exports.unstable_continueExecution = function() {
    A || z || (A = !0, I(J));
};
exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : P = 0 < a ? Math.floor(1E3 / a) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return y;
};
exports.unstable_getFirstCallbackNode = function() {
    return h(r);
};
exports.unstable_next = function(a) {
    switch(y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = y;
    }
    var c = y;
    y = b;
    try {
        return a();
    } finally{
        y = c;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = y;
    y = a;
    try {
        return b();
    } finally{
        y = c;
    }
};
exports.unstable_scheduleCallback = function(a, b, c) {
    var d = exports.unstable_now();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, f(t, a), null === h(r) && a === h(t) && (B ? (E(L), L = -1) : B = !0, K(H, c - d))) : (a.sortIndex = e, f(r, a), A || z || (A = !0, I(J)));
    return a;
};
exports.unstable_shouldYield = M;
exports.unstable_wrapCallback = function(a) {
    var b = y;
    return function() {
        var c = y;
        y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            y = c;
        }
    };
};

},{}],"azV3Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>Provider_default);
parcelHelpers.export(exports, "ReactReduxContext", ()=>ReactReduxContext);
parcelHelpers.export(exports, "batch", ()=>batch);
parcelHelpers.export(exports, "connect", ()=>connect_default);
parcelHelpers.export(exports, "createDispatchHook", ()=>createDispatchHook);
parcelHelpers.export(exports, "createSelectorHook", ()=>createSelectorHook);
parcelHelpers.export(exports, "createStoreHook", ()=>createStoreHook);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
parcelHelpers.export(exports, "useDispatch", ()=>useDispatch);
parcelHelpers.export(exports, "useSelector", ()=>useSelector);
parcelHelpers.export(exports, "useStore", ()=>useStore);
// src/utils/react.ts
var _react = require("react");
// src/hooks/useSelector.ts
var _withSelectorJs = require("use-sync-external-store/with-selector.js");
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var IS_REACT_19 = /* @__PURE__ */ _react.version.startsWith("19");
var REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for(IS_REACT_19 ? "react.transitional.element" : "react.element");
var REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Memo = REACT_MEMO_TYPE;
function isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof } = object;
        switch($$typeof){
            case REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case REACT_FRAGMENT_TYPE:
                    case REACT_PROFILER_TYPE:
                    case REACT_STRICT_MODE_TYPE:
                    case REACT_SUSPENSE_TYPE:
                    case REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case REACT_CONTEXT_TYPE:
                            case REACT_FORWARD_REF_TYPE:
                            case REACT_LAZY_TYPE:
                            case REACT_MEMO_TYPE:
                                return object;
                            case REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function isContextConsumer(object) {
    return IS_REACT_19 ? typeOf(object) === REACT_CONSUMER_TYPE : typeOf(object) === REACT_CONTEXT_TYPE;
}
function isMemo(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    verify(mapStateToProps, "mapStateToProps");
    verify(mapDispatchToProps, "mapDispatchToProps");
    verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual, areOwnPropsEqual, areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps, initMapDispatchToProps, initMergeProps } = _b, options = __objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function verifyPlainObject(value, displayName, methodName) {
    if (!isPlainObject(value)) warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? wrapMapToPropsConstant((dispatch)=>({
            dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return __spreadValues(__spreadValues(__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName, areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>defaultMergeProps : typeof mergeProps === "function" ? wrapMergePropsFunc(mergeProps) : createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var nullListeners = {
    notify () {},
    get: ()=>[]
};
function createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub,
        notifyNestedSubs,
        handleChangeWrapper,
        isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var isDOM = /* @__PURE__ */ canUseDOM();
var isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var isReactNative = /* @__PURE__ */ isRunningInReactNative();
var getUseIsomorphicLayoutEffect = ()=>isDOM || isReactNative ? _react.useLayoutEffect : _react.useEffect;
var useIsomorphicLayoutEffect = /* @__PURE__ */ getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {
    [ForwardRef]: FORWARD_REF_STATICS,
    [Memo]: MEMO_STATICS
};
function getStatics(component) {
    if (isMemo(component)) return MEMO_STATICS;
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if (objectPrototype) {
            const inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        const targetStatics = getStatics(targetComponent);
        const sourceStatics = getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function getContext() {
    var _a;
    if (!_react.createContext) return {};
    const contextMap = (_a = gT[ContextKey]) != null ? _a : gT[ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get(_react.createContext);
    if (!realContext) {
        realContext = _react.createContext(null);
        contextMap.set(_react.createContext, realContext);
    }
    return realContext;
}
var ReactReduxContext = /* @__PURE__ */ getContext();
// src/components/connect.tsx
var NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function strictEqual(a, b) {
    return a === b;
}
var hasWarnedAboutDeprecatedPureOption = false;
function connect(mapStateToProps, mapDispatchToProps, mergeProps, { // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual = strictEqual, areOwnPropsEqual = shallowEqual, areStatePropsEqual = shallowEqual, areMergedPropsEqual = shallowEqual, // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, // the context consumer to use
context = ReactReduxContext } = {}) {
    const Context = context;
    const initMapStateToProps = mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges,
            displayName,
            wrappedComponentName,
            WrappedComponent,
            // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps,
            initMergeProps,
            areStatesEqual,
            areStatePropsEqual,
            areOwnPropsEqual,
            areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = _react.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = __objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = _react.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = _react.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = _react.useMemo(()=>{
                return finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = _react.useMemo(()=>{
                if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY;
                const subscription2 = createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = _react.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return __spreadProps(__spreadValues({}, contextValue), {
                    subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = _react.useRef(void 0);
            const lastWrapperProps = _react.useRef(wrapperProps);
            const childPropsFromStoreUpdate = _react.useRef(void 0);
            const renderIsScheduled = _react.useRef(false);
            const isMounted = _react.useRef(false);
            const latestSubscriptionCallbackError = _react.useRef(void 0);
            useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = _react.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = _react.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = _react.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = _react.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ _react.createElement(WrappedComponent, __spreadProps(__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = _react.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ _react.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = _react.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = _react.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ _react.createElement(Connect, __spreadProps(__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var connect_default = connect;
// src/components/Provider.tsx
function Provider(providerProps) {
    const { children, context, serverState, store } = providerProps;
    const contextValue = _react.useMemo(()=>{
        const subscription = createSubscription(store);
        const baseContextValue = {
            store,
            subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = _react.useMemo(()=>store.getState(), [
        store
    ]);
    useIsomorphicLayoutEffect(()=>{
        const { subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || ReactReduxContext;
    return /* @__PURE__ */ _react.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var Provider_default = Provider;
// src/hooks/useReduxContext.ts
function createReduxContextHook(context = ReactReduxContext) {
    return function useReduxContext2() {
        const contextValue = _react.useContext(context);
        return contextValue;
    };
}
var useReduxContext = /* @__PURE__ */ createReduxContextHook();
// src/hooks/useStore.ts
function createStoreHook(context = ReactReduxContext) {
    const useReduxContext2 = context === ReactReduxContext ? useReduxContext : // @ts-ignore
    createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var useStore = /* @__PURE__ */ createStoreHook();
// src/hooks/useDispatch.ts
function createDispatchHook(context = ReactReduxContext) {
    const useStore2 = context === ReactReduxContext ? useStore : createStoreHook(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var useDispatch = /* @__PURE__ */ createDispatchHook();
var refEquality = (a, b)=>a === b;
function createSelectorHook(context = ReactReduxContext) {
    const useReduxContext2 = context === ReactReduxContext ? useReduxContext : createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn = refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store, subscription, getServerState } = reduxContext;
        const firstRun = _react.useRef(true);
        const wrappedSelector = _react.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, _withSelectorJs.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        _react.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var useSelector = /* @__PURE__ */ createSelectorHook();
// src/exports.ts
var batch = defaultNoopBatch;

},{"react":"8CCva","use-sync-external-store/with-selector.js":"9qGe6","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9qGe6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("626c9c74fab84747");

},{"626c9c74fab84747":"2HWq1"}],"2HWq1":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("309335e472185eb6");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = React.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    useDebugValue(value);
    return value;
};

},{"309335e472185eb6":"8CCva"}],"bFO5N":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"4UN9G":[function() {},{}],"9pTjq":[function(require,module,exports,__globalThis) {
/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _reactRouter.AbortedDeferredError));
parcelHelpers.export(exports, "Await", ()=>(0, _reactRouter.Await));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Navigate", ()=>(0, _reactRouter.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _reactRouter.NavigationType));
parcelHelpers.export(exports, "Outlet", ()=>(0, _reactRouter.Outlet));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "Routes", ()=>(0, _reactRouter.Routes));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _reactRouter.UNSAFE_DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _reactRouter.UNSAFE_DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _reactRouter.UNSAFE_LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _reactRouter.UNSAFE_NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _reactRouter.UNSAFE_RouteContext));
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>(0, _reactRouter.UNSAFE_useRouteId));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _reactRouter.createMemoryRouter));
parcelHelpers.export(exports, "createPath", ()=>(0, _reactRouter.createPath));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _reactRouter.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _reactRouter.createRoutesFromElements));
parcelHelpers.export(exports, "defer", ()=>(0, _reactRouter.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _reactRouter.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _reactRouter.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _reactRouter.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _reactRouter.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _reactRouter.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _reactRouter.redirectDocument));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _reactRouter.renderMatches));
parcelHelpers.export(exports, "replace", ()=>(0, _reactRouter.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _reactRouter.resolvePath));
parcelHelpers.export(exports, "useActionData", ()=>(0, _reactRouter.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _reactRouter.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _reactRouter.useAsyncValue));
parcelHelpers.export(exports, "useBlocker", ()=>(0, _reactRouter.useBlocker));
parcelHelpers.export(exports, "useHref", ()=>(0, _reactRouter.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _reactRouter.useInRouterContext));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _reactRouter.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _reactRouter.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _reactRouter.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _reactRouter.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _reactRouter.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _reactRouter.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _reactRouter.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _reactRouter.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _reactRouter.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _reactRouter.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _reactRouter.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _reactRouter.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _reactRouter.useRoutes));
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>(0, _router.UNSAFE_ErrorResponseImpl));
//#endregion
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "UNSAFE_FetchersContext", ()=>FetchersContext);
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", ()=>ViewTransitionContext);
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "unstable_usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
parcelHelpers.export(exports, "useViewTransitionState", ()=>useViewTransitionState);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if (isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!isFormDataSubmitterSupported()) {
            let { name, type, value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData,
        body
    };
}
const _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], _excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const ViewTransitionContext = /*#__PURE__*/ _react.createContext({
    isTransitioning: false
});
const FetchersContext = /*#__PURE__*/ _react.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
const FLUSH_SYNC = "flushSync";
const flushSyncImpl = _reactDom[FLUSH_SYNC];
const USE_ID = "useId";
const useIdImpl = _react[USE_ID];
function startTransitionSafe(cb) {
    if (startTransitionImpl) startTransitionImpl(cb);
    else cb();
}
function flushSyncSafe(cb) {
    if (flushSyncImpl) flushSyncImpl(cb);
    else cb();
}
class Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let [pendingState, setPendingState] = _react.useState();
    let [vtContext, setVtContext] = _react.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = _react.useState();
    let [transition, setTransition] = _react.useState();
    let [interruption, setInterruption] = _react.useState();
    let fetcherData = _react.useRef(new Map());
    let { v7_startTransition } = future || {};
    let optInStartTransition = _react.useCallback((cb)=>{
        if (v7_startTransition) startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = _react.useCallback((newState, _ref2)=>{
        let { deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    _react.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    _react.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    _react.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    _react.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = _react.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const MemoizedDataRoutes = /*#__PURE__*/ _react.memo(DataRoutes);
function DataRoutes(_ref3) {
    let { routes, future, state } = _ref3;
    return (0, _reactRouter.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref4) {
    let { basename, children, future, window: window1 } = _ref4;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref5) {
    let { basename, children, future, window: window1 } = _ref5;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref6) {
    let { basename, children, future, history } = _ref6;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick, relative, reloadDocument, replace, state, target, to, preventScrollReset, viewTransition } = _ref7, rest = _objectWithoutPropertiesLoose(_ref7, _excluded);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, _router.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, _reactRouter.useHref)(to, {
        relative
    });
    let internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target,
        preventScrollReset,
        relative,
        viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, viewTransition, children } = _ref8, rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, _reactRouter.useLocation)();
    let routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    let { navigator, basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, _router.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive,
        isPending,
        isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const Form = /*#__PURE__*/ _react.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey, navigate, reloadDocument, replace, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, viewTransition } = _ref9, props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey,
            method: submitMethod,
            navigate,
            replace,
            state,
            relative,
            preventScrollReset,
            viewTransition
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref10) {
    let { getKey, storageKey } = _ref10;
    useScrollRestoration({
        getKey,
        storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    let { target, replace: replaceProp, state, preventScrollReset, relative, viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, _reactRouter.useNavigate)();
    let location = (0, _reactRouter.useLocation)();
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace,
                state,
                preventScrollReset,
                relative,
                viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let hasSetSearchParamsRef = _react.useRef(false);
    let location = (0, _reactRouter.useLocation)();
    let searchParams = _react.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, _reactRouter.useNavigate)();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let fetcherId = 0;
let getUniqueFetcherId = ()=>"__" + String(++fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    let { router } = useDataRouterContext(DataRouterHook.UseSubmit);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let currentRouteId = (0, _reactRouter.UNSAFE_useRouteId)();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        validateClientSideSubmission();
        let { action, method, encType, formData, body } = getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData,
                body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData,
            body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher(_temp3) {
    var _route$matches;
    let { key } = _temp3 === void 0 ? {} : _temp3;
    let { router } = useDataRouterContext(DataRouterHook.UseFetcher);
    let state = useDataRouterState(DataRouterStateHook.UseFetcher);
    let fetcherData = _react.useContext(FetchersContext);
    let route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, _router.UNSAFE_invariant)(false);
    !route && (0, _router.UNSAFE_invariant)(false);
    !(routeId != null) && (0, _router.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = useIdImpl ? useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = _react.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey(getUniqueFetcherId());
    // Registration/cleanup
    _react.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = _react.useCallback((href, opts)=>{
        !routeId && (0, _router.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = useSubmit();
    let submit = _react.useCallback((target, opts)=>{
        submitImpl(target, _extends({}, opts, {
            navigate: false,
            fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = _react.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
            return /*#__PURE__*/ _react.createElement(Form, _extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, _router.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>_extends({
            Form: FetcherForm,
            submit,
            load
        }, fetcher, {
            data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    let state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return _extends({}, fetcher, {
            key
        });
    });
}
const SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp4) {
    let { getKey, storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router } = useDataRouterContext(DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState(DataRouterStateHook.UseScrollRestoration);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let location = (0, _reactRouter.useLocation)();
    let matches = (0, _reactRouter.useMatches)();
    let navigation = (0, _reactRouter.useNavigation)();
    // Trigger manual scroll restoration while we're active
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    usePageHide(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey(_extends({}, location, {
                    pathname: (0, _router.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function usePageHide(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref12) {
    let { when, message } = _ref12;
    let blocker = (0, _reactRouter.useBlocker)(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function useViewTransitionState(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = _react.useContext(ViewTransitionContext);
    !(vtContext != null) && (0, _router.UNSAFE_invariant)(false);
    let { basename } = useDataRouterContext(DataRouterHook.useViewTransitionState);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, _router.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, _router.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, _router.matchPath)(path.pathname, nextPath) != null || (0, _router.matchPath)(path.pathname, currentPath) != null;
}

},{"react":"8CCva","react-dom":"ggrpy","react-router":"8VLPJ","@remix-run/router":"7loLG","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8VLPJ":[function(require,module,exports,__globalThis) {
/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _router.AbortedDeferredError));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _router.Action));
parcelHelpers.export(exports, "createPath", ()=>(0, _router.createPath));
parcelHelpers.export(exports, "defer", ()=>(0, _router.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _router.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _router.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _router.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _router.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _router.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _router.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _router.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _router.redirectDocument));
parcelHelpers.export(exports, "replace", ()=>(0, _router.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _router.resolvePath));
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "UNSAFE_logV6DeprecationWarnings", ()=>logV6DeprecationWarnings);
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", ()=>mapRouteProperties);
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>useRouteId);
parcelHelpers.export(exports, "UNSAFE_useRoutesImpl", ()=>useRoutesImpl);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
var _react = require("react");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const DataRouterContext = /*#__PURE__*/ _react.createContext(null);
const DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
const AwaitContext = /*#__PURE__*/ _react.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const NavigationContext = /*#__PURE__*/ _react.createContext(null);
const LocationContext = /*#__PURE__*/ _react.createContext(null);
const RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function useHref(to, _temp) {
    let { relative } = _temp === void 0 ? {} : _temp;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { pathname } = useLocation();
    return _react.useMemo(()=>(0, _router.matchPath)(pattern, (0, _router.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
    let isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function useNavigate() {
    let { isDataRoute } = _react.useContext(RouteContext);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let dataRouterContext = _react.useContext(DataRouterContext);
    let { basename, future, navigator } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { future } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return _react.useMemo(()=>(0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { navigator, static: isStatic } = _react.useContext(NavigationContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    let error = useRouteError();
    let message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const defaultErrorElement = /*#__PURE__*/ _react.createElement(DefaultErrorComponent, null);
class RenderErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function RenderedRoute(_ref) {
    let { routeContext, match, children } = _ref;
    let dataRouterContext = _react.useContext(DataRouterContext);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, _router.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData, errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet,
                    matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}(DataRouterHook || {});
var DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}(DataRouterStateHook || {});
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    let state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    let dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    let state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return _react.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    let { matches, loaderData } = useDataRouterState(DataRouterStateHook.UseMatches);
    return _react.useMemo(()=>matches.map((m)=>(0, _router.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    let state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    let state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    let state = useDataRouterState(DataRouterStateHook.UseActionData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState(DataRouterStateHook.UseRouteError);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
}
let blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    let { router, basename } = useDataRouterContext(DataRouterHook.UseBlocker);
    let state = useDataRouterState(DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = _react.useState("");
    let blockerFunction = _react.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation, nextLocation, historyAction } = arg;
        return shouldBlock({
            currentLocation: _extends({}, currentLocation, {
                pathname: (0, _router.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: _extends({}, nextLocation, {
                pathname: (0, _router.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    _react.useEffect(()=>{
        let key = String(++blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    _react.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, _router.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function useNavigateStable() {
    let { router } = useDataRouterContext(DataRouterHook.UseNavigateStable);
    let id = useCurrentRouteId(DataRouterStateHook.UseNavigateStable);
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, _extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const alreadyWarned$1 = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned$1[key]) alreadyWarned$1[key] = true;
}
const alreadyWarned = {};
function warnOnce(key, message) {}
const logDeprecation = (flag, msg, link)=>warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function logV6DeprecationWarnings(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        if (v7_startTransition && startTransitionImpl) startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    _react.useEffect(()=>logV6DeprecationWarnings(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function DataRoutes(_ref2) {
    let { routes, future, state } = _ref2;
    return useRoutesImpl(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function MemoryRouter(_ref3) {
    let { basename, children, initialEntries, initialIndex, future } = _ref3;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>logV6DeprecationWarnings(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function Navigate(_ref4) {
    let { to, replace, state, relative } = _ref4;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { future, static: isStatic } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let navigate = useNavigate();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, _router.resolveTo)(to, (0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    _react.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace,
            state,
            relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function Route(_props) {
    (0, _router.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function Router(_ref5) {
    let { basename: basenameProp = "/", children = null, location: locationProp, navigationType = (0, _router.Action).Pop, navigator, static: staticProp = false, future } = _ref5;
    !!useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator,
            static: staticProp,
            future: _extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let locationContext = _react.useMemo(()=>{
        let trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function Routes(_ref6) {
    let { children, location } = _ref6;
    return useRoutes(createRoutesFromChildren(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref7) {
    let { children, errorElement, resolve } = _ref7;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}(AwaitRenderStatus || {});
const neverSettledPromise = new Promise(()=>{});
class AwaitErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? AwaitRenderStatus.error : "_data" in promise ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw neverSettledPromise;
        if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function ResolveAwait(_ref8) {
    let { children } = _ref8;
    let data = useAsyncValue();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        !(element.type === Route) && (0, _router.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, _router.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
function mapRouteProperties(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ _react.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ _react.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ _react.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes,
        mapRouteProperties,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

},{"react":"8CCva","@remix-run/router":"7loLG","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7loLG":[function(require,module,exports,__globalThis) {
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "AbortedDeferredError", ()=>AbortedDeferredError);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", ()=>UNSAFE_DEFERRED_SYMBOL);
parcelHelpers.export(exports, "UNSAFE_DeferredData", ()=>DeferredData);
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>ErrorResponseImpl);
parcelHelpers.export(exports, "UNSAFE_convertRouteMatchToUiMatch", ()=>convertRouteMatchToUiMatch);
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", ()=>convertRoutesToDataRoutes);
parcelHelpers.export(exports, "UNSAFE_decodePath", ()=>decodePath);
parcelHelpers.export(exports, "UNSAFE_getResolveToMatches", ()=>getResolveToMatches);
parcelHelpers.export(exports, "UNSAFE_invariant", ()=>invariant);
parcelHelpers.export(exports, "UNSAFE_warning", ()=>warning);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler);
parcelHelpers.export(exports, "data", ()=>data);
parcelHelpers.export(exports, "defer", ()=>defer);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "getStaticContextFromError", ()=>getStaticContextFromError);
parcelHelpers.export(exports, "getToPathname", ()=>getToPathname);
parcelHelpers.export(exports, "isDataWithResponseInit", ()=>isDataWithResponseInit);
parcelHelpers.export(exports, "isDeferredData", ()=>isDeferredData);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "joinPaths", ()=>joinPaths);
parcelHelpers.export(exports, "json", ()=>json);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "normalizePathname", ()=>normalizePathname);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "redirectDocument", ()=>redirectDocument);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "resolveTo", ()=>resolveTo);
parcelHelpers.export(exports, "stripBasename", ()=>stripBasename);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
const PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = Action.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = Action.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = Action.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = Action.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname, search, hash } = window1.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    let { pathname = "/", search = "", hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = Action.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
const immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            let indexRoute = _extends({}, route, mapRouteProperties(route), {
                id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const paramRe = /^:[\w-]+$/;
const dynamicSegmentValue = 3;
const indexRouteValue = 2;
const emptySegmentValue = 1;
const staticSegmentValue = 10;
const splatPenalty = -2;
const isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            invariant(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName, isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        warning(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    let pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ const joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const json = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers
    }));
};
class DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class AbortedDeferredError extends Error {
}
class DeferredData {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new AbortedDeferredError("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const defer = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirectDocument = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const replace = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class ErrorResponseImpl {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const validMutationMethods = new Set(validMutationMethodsArr);
const validRequestMethodsArr = [
    "get",
    ...validMutationMethodsArr
];
const validRequestMethods = new Set(validRequestMethodsArr);
const redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location, delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, IDLE_BLOCKER));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers
        }), {
            viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = Action.Push;
        if (userReplace === true) historyAction = Action.Replace;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = Action.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, IDLE_BLOCKER);
                    updateState({
                        blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : matchRoutes(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches
            }, {
                flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            findNearestBoundary(matches).route.id,
            {
                type: ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited, matches: updatedMatches, loaderData, errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, _extends({
            matches: updatedMatches || matches
        }, getActionDataForCommit(pendingActionResult), {
            loaderData,
            errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = getSubmittingNavigation(location, submission);
        updateState({
            navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches, error, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: ResultType.error,
                            error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: ResultType.error,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission,
                replace
            });
            return {
                shortCircuited: true
            };
        }
        if (isDeferredResult(result)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
            return {
                matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState(_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData
                } : {}), {
                    flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, _extends({
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = _extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return _extends({
            matches,
            loaderData,
            errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = matchRoutes(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync
            });
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        let match = getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            }
        } else {
            if (isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if (isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset
        });
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if (isDeferredResult(result)) result = await resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if (isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if (isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission, fetcherSubmission, preventScrollReset, replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        invariant(location, "Expected a Location header on the redirect Response");
        location = normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if (ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod, formAction, formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if (redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: _extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if (isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: ResultType.redirect,
                response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: ResultType.error,
                    error: getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation, nextLocation, historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = getInternalRouterError(404, {
            pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches, route } = getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route,
            error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = matchRoutes(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose,
        getBlocker,
        deleteBlocker,
        patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    let future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext, skipLoaderErrorBubbling, dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if (isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return _extends({
            location,
            basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId, requestContext, dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) // This should never hit I don't think?
        throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return isResponse(result) ? result : _extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if (isDataStrategyResult(e) && isResponse(e.result)) {
                if (e.type === ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isDeferredResult(result)) {
            let error = getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return _extends({}, context, {
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: _extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return _extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return _extends({}, context, {
            matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if (isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    let newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path,
                submission: {
                    formMethod,
                    formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path,
                    submission: {
                        formMethod,
                        formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod,
        formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path,
        submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>isSameRoute(newRoute, existingRoute)));
    let newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        warning(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function defaultDataStrategy(_ref4) {
    let { matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: ResultType.data,
                result: undefined
            });
        };
        return _extends({}, match, {
            shouldLoad,
            resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request,
        params: matches[0].params,
        fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw getInternalRouterError(405, {
                        method: request.method,
                        pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw getInternalRouterError(404, {
                pathname
            });
        } else result = await runHandler(handler);
        invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result, type } = dataStrategyResult;
    if (isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: ResultType.error,
                error: e
            };
        }
        if (type === ResultType.error) return {
            type: ResultType.error,
            error: new ErrorResponseImpl(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: ResultType.data,
            data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === ResultType.error) {
        if (isDataWithResponseInit(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: ResultType.error,
                error: new ErrorResponseImpl(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: isRouteErrorResponse(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: ResultType.error,
            error: result,
            statusCode: isRouteErrorResponse(result) ? result.status : undefined
        };
    }
    if (isDeferredData(result)) {
        var _result$init5, _result$init6;
        return {
            type: ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if (isDataWithResponseInit(result)) {
        var _result$init7, _result$init8;
        return {
            type: ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData, errors } = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key, match, controller } = rf;
        let result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = _extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, _temp5) {
    let { pathname, routeId, method, type, message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if (isRedirectResult(result)) return {
            key,
            result
        };
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
async function resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if (isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key, routeId, controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if (isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: ResultType.error,
            error: e
        };
    }
    return {
        type: ResultType.data,
        data: result.deferredData.data
    };
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    let { formMethod, formAction, formEncType, text, formData, json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json: undefined,
        text
    };
    else if (formData != null) return {
        formMethod,
        formAction,
        formEncType,
        formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data
        };
        return fetcher;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"vfvPp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Helmet", ()=>W);
parcelHelpers.export(exports, "HelmetData", ()=>N);
parcelHelpers.export(exports, "HelmetProvider", ()=>q);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var _shallowequal = require("shallowequal");
var _shallowequalDefault = parcelHelpers.interopDefault(_shallowequal);
function a() {
    return a = Object.assign || function(t) {
        for(var e = 1; e < arguments.length; e++){
            var r = arguments[e];
            for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (t[n] = r[n]);
        }
        return t;
    }, a.apply(this, arguments);
}
function s(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t, c(t, e);
}
function c(t, e) {
    return c = Object.setPrototypeOf || function(t, e) {
        return t.__proto__ = e, t;
    }, c(t, e);
}
function u(t, e) {
    if (null == t) return {};
    var r, n, i = {}, o = Object.keys(t);
    for(n = 0; n < o.length; n++)e.indexOf(r = o[n]) >= 0 || (i[r] = t[r]);
    return i;
}
var l = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title",
    FRAGMENT: "Symbol(react.fragment)"
}, p = {
    rel: [
        "amphtml",
        "canonical",
        "alternate"
    ]
}, f = {
    type: [
        "application/ld+json"
    ]
}, d = {
    charset: "",
    name: [
        "robots",
        "description"
    ],
    property: [
        "og:type",
        "og:title",
        "og:url",
        "og:image",
        "og:image:alt",
        "og:description",
        "twitter:url",
        "twitter:title",
        "twitter:description",
        "twitter:image",
        "twitter:image:alt",
        "twitter:card",
        "twitter:site"
    ]
}, h = Object.keys(l).map(function(t) {
    return l[t];
}), m = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
}, y = Object.keys(m).reduce(function(t, e) {
    return t[m[e]] = e, t;
}, {}), T = function(t, e) {
    for(var r = t.length - 1; r >= 0; r -= 1){
        var n = t[r];
        if (Object.prototype.hasOwnProperty.call(n, e)) return n[e];
    }
    return null;
}, g = function(t) {
    var e = T(t, l.TITLE), r = T(t, "titleTemplate");
    if (Array.isArray(e) && (e = e.join("")), r && e) return r.replace(/%s/g, function() {
        return e;
    });
    var n = T(t, "defaultTitle");
    return e || n || void 0;
}, b = function(t) {
    return T(t, "onChangeClientState") || function() {};
}, v = function(t, e) {
    return e.filter(function(e) {
        return void 0 !== e[t];
    }).map(function(e) {
        return e[t];
    }).reduce(function(t, e) {
        return a({}, t, e);
    }, {});
}, A = function(t, e) {
    return e.filter(function(t) {
        return void 0 !== t[l.BASE];
    }).map(function(t) {
        return t[l.BASE];
    }).reverse().reduce(function(e, r) {
        if (!e.length) for(var n = Object.keys(r), i = 0; i < n.length; i += 1){
            var o = n[i].toLowerCase();
            if (-1 !== t.indexOf(o) && r[o]) return e.concat(r);
        }
        return e;
    }, []);
}, C = function(t, e, r) {
    var n = {};
    return r.filter(function(e) {
        return !!Array.isArray(e[t]) || (void 0 !== e[t] && console && "function" == typeof console.warn && console.warn("Helmet: " + t + ' should be of type "Array". Instead found type "' + typeof e[t] + '"'), !1);
    }).map(function(e) {
        return e[t];
    }).reverse().reduce(function(t, r) {
        var i = {};
        r.filter(function(t) {
            for(var r, o = Object.keys(t), a = 0; a < o.length; a += 1){
                var s = o[a], c = s.toLowerCase();
                -1 === e.indexOf(c) || "rel" === r && "canonical" === t[r].toLowerCase() || "rel" === c && "stylesheet" === t[c].toLowerCase() || (r = c), -1 === e.indexOf(s) || "innerHTML" !== s && "cssText" !== s && "itemprop" !== s || (r = s);
            }
            if (!r || !t[r]) return !1;
            var u = t[r].toLowerCase();
            return n[r] || (n[r] = {}), i[r] || (i[r] = {}), !n[r][u] && (i[r][u] = !0, !0);
        }).reverse().forEach(function(e) {
            return t.push(e);
        });
        for(var o = Object.keys(i), s = 0; s < o.length; s += 1){
            var c = o[s], u = a({}, n[c], i[c]);
            n[c] = u;
        }
        return t;
    }, []).reverse();
}, O = function(t, e) {
    if (Array.isArray(t) && t.length) {
        for(var r = 0; r < t.length; r += 1)if (t[r][e]) return !0;
    }
    return !1;
}, S = function(t) {
    return Array.isArray(t) ? t.join("") : t;
}, E = function(t, e) {
    return Array.isArray(t) ? t.reduce(function(t, r) {
        return function(t, e) {
            for(var r = Object.keys(t), n = 0; n < r.length; n += 1)if (e[r[n]] && e[r[n]].includes(t[r[n]])) return !0;
            return !1;
        }(r, e) ? t.priority.push(r) : t.default.push(r), t;
    }, {
        priority: [],
        default: []
    }) : {
        default: t
    };
}, I = function(t, e) {
    var r;
    return a({}, t, ((r = {})[e] = void 0, r));
}, P = [
    l.NOSCRIPT,
    l.SCRIPT,
    l.STYLE
], w = function(t, e) {
    return void 0 === e && (e = !0), !1 === e ? String(t) : String(t).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}, x = function(t) {
    return Object.keys(t).reduce(function(e, r) {
        var n = void 0 !== t[r] ? r + '="' + t[r] + '"' : "" + r;
        return e ? e + " " + n : n;
    }, "");
}, L = function(t, e) {
    return void 0 === e && (e = {}), Object.keys(t).reduce(function(e, r) {
        return e[m[r] || r] = t[r], e;
    }, e);
}, j = function(e, r) {
    return r.map(function(r, n) {
        var i, o = ((i = {
            key: n
        })["data-rh"] = !0, i);
        return Object.keys(r).forEach(function(t) {
            var e = m[t] || t;
            "innerHTML" === e || "cssText" === e ? o.dangerouslySetInnerHTML = {
                __html: r.innerHTML || r.cssText
            } : o[e] = r[t];
        }), (0, _reactDefault.default).createElement(e, o);
    });
}, M = function(e, r, n) {
    switch(e){
        case l.TITLE:
            return {
                toComponent: function() {
                    var e, n, i, o;
                    return n = r.titleAttributes, (i = {
                        key: e = r.title
                    })["data-rh"] = !0, o = L(n, i), [
                        (0, _reactDefault.default).createElement(l.TITLE, o, e)
                    ];
                },
                toString: function() {
                    return function(t, e, r, n) {
                        var i = x(r), o = S(e);
                        return i ? "<" + t + ' data-rh="true" ' + i + ">" + w(o, n) + "</" + t + ">" : "<" + t + ' data-rh="true">' + w(o, n) + "</" + t + ">";
                    }(e, r.title, r.titleAttributes, n);
                }
            };
        case "bodyAttributes":
        case "htmlAttributes":
            return {
                toComponent: function() {
                    return L(r);
                },
                toString: function() {
                    return x(r);
                }
            };
        default:
            return {
                toComponent: function() {
                    return j(e, r);
                },
                toString: function() {
                    return function(t, e, r) {
                        return e.reduce(function(e, n) {
                            var i = Object.keys(n).filter(function(t) {
                                return !("innerHTML" === t || "cssText" === t);
                            }).reduce(function(t, e) {
                                var i = void 0 === n[e] ? e : e + '="' + w(n[e], r) + '"';
                                return t ? t + " " + i : i;
                            }, ""), o = n.innerHTML || n.cssText || "", a = -1 === P.indexOf(t);
                            return e + "<" + t + ' data-rh="true" ' + i + (a ? "/>" : ">" + o + "</" + t + ">");
                        }, "");
                    }(e, r, n);
                }
            };
    }
}, k = function(t) {
    var e = t.baseTag, r = t.bodyAttributes, n = t.encode, i = t.htmlAttributes, o = t.noscriptTags, a = t.styleTags, s = t.title, c = void 0 === s ? "" : s, u = t.titleAttributes, h = t.linkTags, m = t.metaTags, y = t.scriptTags, T = {
        toComponent: function() {},
        toString: function() {
            return "";
        }
    };
    if (t.prioritizeSeoTags) {
        var g = function(t) {
            var e = t.linkTags, r = t.scriptTags, n = t.encode, i = E(t.metaTags, d), o = E(e, p), a = E(r, f);
            return {
                priorityMethods: {
                    toComponent: function() {
                        return [].concat(j(l.META, i.priority), j(l.LINK, o.priority), j(l.SCRIPT, a.priority));
                    },
                    toString: function() {
                        return M(l.META, i.priority, n) + " " + M(l.LINK, o.priority, n) + " " + M(l.SCRIPT, a.priority, n);
                    }
                },
                metaTags: i.default,
                linkTags: o.default,
                scriptTags: a.default
            };
        }(t);
        T = g.priorityMethods, h = g.linkTags, m = g.metaTags, y = g.scriptTags;
    }
    return {
        priority: T,
        base: M(l.BASE, e, n),
        bodyAttributes: M("bodyAttributes", r, n),
        htmlAttributes: M("htmlAttributes", i, n),
        link: M(l.LINK, h, n),
        meta: M(l.META, m, n),
        noscript: M(l.NOSCRIPT, o, n),
        script: M(l.SCRIPT, y, n),
        style: M(l.STYLE, a, n),
        title: M(l.TITLE, {
            title: c,
            titleAttributes: u
        }, n)
    };
}, H = [], N = function(t, e) {
    var r = this;
    void 0 === e && (e = "undefined" != typeof document), this.instances = [], this.value = {
        setHelmet: function(t) {
            r.context.helmet = t;
        },
        helmetInstances: {
            get: function() {
                return r.canUseDOM ? H : r.instances;
            },
            add: function(t) {
                (r.canUseDOM ? H : r.instances).push(t);
            },
            remove: function(t) {
                var e = (r.canUseDOM ? H : r.instances).indexOf(t);
                (r.canUseDOM ? H : r.instances).splice(e, 1);
            }
        }
    }, this.context = t, this.canUseDOM = e, e || (t.helmet = k({
        baseTag: [],
        bodyAttributes: {},
        encodeSpecialCharacters: !0,
        htmlAttributes: {},
        linkTags: [],
        metaTags: [],
        noscriptTags: [],
        scriptTags: [],
        styleTags: [],
        title: "",
        titleAttributes: {}
    }));
}, R = (0, _reactDefault.default).createContext({}), D = (0, _propTypesDefault.default).shape({
    setHelmet: (0, _propTypesDefault.default).func,
    helmetInstances: (0, _propTypesDefault.default).shape({
        get: (0, _propTypesDefault.default).func,
        add: (0, _propTypesDefault.default).func,
        remove: (0, _propTypesDefault.default).func
    })
}), U = "undefined" != typeof document, q = /*#__PURE__*/ function(e) {
    function r(t) {
        var n;
        return (n = e.call(this, t) || this).helmetData = new N(n.props.context, r.canUseDOM), n;
    }
    return s(r, e), r.prototype.render = function() {
        return (0, _reactDefault.default).createElement(R.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }, r;
}((0, _react.Component));
q.canUseDOM = U, q.propTypes = {
    context: (0, _propTypesDefault.default).shape({
        helmet: (0, _propTypesDefault.default).shape()
    }),
    children: (0, _propTypesDefault.default).node.isRequired
}, q.defaultProps = {
    context: {}
}, q.displayName = "HelmetProvider";
var Y = function(t, e) {
    var r, n = document.head || document.querySelector(l.HEAD), i = n.querySelectorAll(t + "[data-rh]"), o = [].slice.call(i), a = [];
    return e && e.length && e.forEach(function(e) {
        var n = document.createElement(t);
        for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && ("innerHTML" === i ? n.innerHTML = e.innerHTML : "cssText" === i ? n.styleSheet ? n.styleSheet.cssText = e.cssText : n.appendChild(document.createTextNode(e.cssText)) : n.setAttribute(i, void 0 === e[i] ? "" : e[i]));
        n.setAttribute("data-rh", "true"), o.some(function(t, e) {
            return r = e, n.isEqualNode(t);
        }) ? o.splice(r, 1) : a.push(n);
    }), o.forEach(function(t) {
        return t.parentNode.removeChild(t);
    }), a.forEach(function(t) {
        return n.appendChild(t);
    }), {
        oldTags: o,
        newTags: a
    };
}, B = function(t, e) {
    var r = document.getElementsByTagName(t)[0];
    if (r) {
        for(var n = r.getAttribute("data-rh"), i = n ? n.split(",") : [], o = [].concat(i), a = Object.keys(e), s = 0; s < a.length; s += 1){
            var c = a[s], u = e[c] || "";
            r.getAttribute(c) !== u && r.setAttribute(c, u), -1 === i.indexOf(c) && i.push(c);
            var l = o.indexOf(c);
            -1 !== l && o.splice(l, 1);
        }
        for(var p = o.length - 1; p >= 0; p -= 1)r.removeAttribute(o[p]);
        i.length === o.length ? r.removeAttribute("data-rh") : r.getAttribute("data-rh") !== a.join(",") && r.setAttribute("data-rh", a.join(","));
    }
}, K = function(t, e) {
    var r = t.baseTag, n = t.htmlAttributes, i = t.linkTags, o = t.metaTags, a = t.noscriptTags, s = t.onChangeClientState, c = t.scriptTags, u = t.styleTags, p = t.title, f = t.titleAttributes;
    B(l.BODY, t.bodyAttributes), B(l.HTML, n), function(t, e) {
        void 0 !== t && document.title !== t && (document.title = S(t)), B(l.TITLE, e);
    }(p, f);
    var d = {
        baseTag: Y(l.BASE, r),
        linkTags: Y(l.LINK, i),
        metaTags: Y(l.META, o),
        noscriptTags: Y(l.NOSCRIPT, a),
        scriptTags: Y(l.SCRIPT, c),
        styleTags: Y(l.STYLE, u)
    }, h = {}, m = {};
    Object.keys(d).forEach(function(t) {
        var e = d[t], r = e.newTags, n = e.oldTags;
        r.length && (h[t] = r), n.length && (m[t] = d[t].oldTags);
    }), e && e(), s(t, h, m);
}, _ = null, z = /*#__PURE__*/ function(t) {
    function e() {
        for(var e, r = arguments.length, n = new Array(r), i = 0; i < r; i++)n[i] = arguments[i];
        return (e = t.call.apply(t, [
            this
        ].concat(n)) || this).rendered = !1, e;
    }
    s(e, t);
    var r = e.prototype;
    return r.shouldComponentUpdate = function(t) {
        return !(0, _shallowequalDefault.default)(t, this.props);
    }, r.componentDidUpdate = function() {
        this.emitChange();
    }, r.componentWillUnmount = function() {
        this.props.context.helmetInstances.remove(this), this.emitChange();
    }, r.emitChange = function() {
        var t, e, r = this.props.context, n = r.setHelmet, i = null, o = (t = r.helmetInstances.get().map(function(t) {
            var e = a({}, t.props);
            return delete e.context, e;
        }), {
            baseTag: A([
                "href"
            ], t),
            bodyAttributes: v("bodyAttributes", t),
            defer: T(t, "defer"),
            encode: T(t, "encodeSpecialCharacters"),
            htmlAttributes: v("htmlAttributes", t),
            linkTags: C(l.LINK, [
                "rel",
                "href"
            ], t),
            metaTags: C(l.META, [
                "name",
                "charset",
                "http-equiv",
                "property",
                "itemprop"
            ], t),
            noscriptTags: C(l.NOSCRIPT, [
                "innerHTML"
            ], t),
            onChangeClientState: b(t),
            scriptTags: C(l.SCRIPT, [
                "src",
                "innerHTML"
            ], t),
            styleTags: C(l.STYLE, [
                "cssText"
            ], t),
            title: g(t),
            titleAttributes: v("titleAttributes", t),
            prioritizeSeoTags: O(t, "prioritizeSeoTags")
        });
        q.canUseDOM ? (e = o, _ && cancelAnimationFrame(_), e.defer ? _ = requestAnimationFrame(function() {
            K(e, function() {
                _ = null;
            });
        }) : (K(e), _ = null)) : k && (i = k(o)), n(i);
    }, r.init = function() {
        this.rendered || (this.rendered = !0, this.props.context.helmetInstances.add(this), this.emitChange());
    }, r.render = function() {
        return this.init(), null;
    }, e;
}((0, _react.Component));
z.propTypes = {
    context: D.isRequired
}, z.displayName = "HelmetDispatcher";
var F = [
    "children"
], G = [
    "children"
], W = /*#__PURE__*/ function(e) {
    function r() {
        return e.apply(this, arguments) || this;
    }
    s(r, e);
    var o = r.prototype;
    return o.shouldComponentUpdate = function(t) {
        return !(0, _reactFastCompareDefault.default)(I(this.props, "helmetData"), I(t, "helmetData"));
    }, o.mapNestedChildrenToProps = function(t, e) {
        if (!e) return null;
        switch(t.type){
            case l.SCRIPT:
            case l.NOSCRIPT:
                return {
                    innerHTML: e
                };
            case l.STYLE:
                return {
                    cssText: e
                };
            default:
                throw new Error("<" + t.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        }
    }, o.flattenArrayTypeChildren = function(t) {
        var e, r = t.child, n = t.arrayTypeChildren;
        return a({}, n, ((e = {})[r.type] = [].concat(n[r.type] || [], [
            a({}, t.newChildProps, this.mapNestedChildrenToProps(r, t.nestedChildren))
        ]), e));
    }, o.mapObjectTypeChildren = function(t) {
        var e, r, n = t.child, i = t.newProps, o = t.newChildProps, s = t.nestedChildren;
        switch(n.type){
            case l.TITLE:
                return a({}, i, ((e = {})[n.type] = s, e.titleAttributes = a({}, o), e));
            case l.BODY:
                return a({}, i, {
                    bodyAttributes: a({}, o)
                });
            case l.HTML:
                return a({}, i, {
                    htmlAttributes: a({}, o)
                });
            default:
                return a({}, i, ((r = {})[n.type] = a({}, o), r));
        }
    }, o.mapArrayTypeChildrenToProps = function(t, e) {
        var r = a({}, e);
        return Object.keys(t).forEach(function(e) {
            var n;
            r = a({}, r, ((n = {})[e] = t[e], n));
        }), r;
    }, o.warnOnInvalidChildren = function(t, e) {
        return (0, _invariantDefault.default)(h.some(function(e) {
            return t.type === e;
        }), "function" == typeof t.type ? "You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information." : "Only elements types " + h.join(", ") + " are allowed. Helmet does not support rendering <" + t.type + "> elements. Refer to our API for more information."), (0, _invariantDefault.default)(!e || "string" == typeof e || Array.isArray(e) && !e.some(function(t) {
            return "string" != typeof t;
        }), "Helmet expects a string as a child of <" + t.type + ">. Did you forget to wrap your children in braces? ( <" + t.type + ">{``}</" + t.type + "> ) Refer to our API for more information."), !0;
    }, o.mapChildrenToProps = function(e, r) {
        var n = this, i = {};
        return (0, _reactDefault.default).Children.forEach(e, function(t) {
            if (t && t.props) {
                var e = t.props, o = e.children, a = u(e, F), s = Object.keys(a).reduce(function(t, e) {
                    return t[y[e] || e] = a[e], t;
                }, {}), c = t.type;
                switch("symbol" == typeof c ? c = c.toString() : n.warnOnInvalidChildren(t, o), c){
                    case l.FRAGMENT:
                        r = n.mapChildrenToProps(o, r);
                        break;
                    case l.LINK:
                    case l.META:
                    case l.NOSCRIPT:
                    case l.SCRIPT:
                    case l.STYLE:
                        i = n.flattenArrayTypeChildren({
                            child: t,
                            arrayTypeChildren: i,
                            newChildProps: s,
                            nestedChildren: o
                        });
                        break;
                    default:
                        r = n.mapObjectTypeChildren({
                            child: t,
                            newProps: r,
                            newChildProps: s,
                            nestedChildren: o
                        });
                }
            }
        }), this.mapArrayTypeChildrenToProps(i, r);
    }, o.render = function() {
        var e = this.props, r = e.children, n = u(e, G), i = a({}, n), o = n.helmetData;
        return r && (i = this.mapChildrenToProps(r, i)), !o || o instanceof N || (o = new N(o.context, o.instances)), o ? /*#__PURE__*/ (0, _reactDefault.default).createElement(z, a({}, i, {
            context: o.value,
            helmetData: void 0
        })) : /*#__PURE__*/ (0, _reactDefault.default).createElement(R.Consumer, null, function(e) {
            return (0, _reactDefault.default).createElement(z, a({}, i, {
                context: e
            }));
        });
    }, r;
}((0, _react.Component));
W.propTypes = {
    base: (0, _propTypesDefault.default).object,
    bodyAttributes: (0, _propTypesDefault.default).object,
    children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).node),
        (0, _propTypesDefault.default).node
    ]),
    defaultTitle: (0, _propTypesDefault.default).string,
    defer: (0, _propTypesDefault.default).bool,
    encodeSpecialCharacters: (0, _propTypesDefault.default).bool,
    htmlAttributes: (0, _propTypesDefault.default).object,
    link: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    meta: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    noscript: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    onChangeClientState: (0, _propTypesDefault.default).func,
    script: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    style: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).object),
    title: (0, _propTypesDefault.default).string,
    titleAttributes: (0, _propTypesDefault.default).object,
    titleTemplate: (0, _propTypesDefault.default).string,
    prioritizeSeoTags: (0, _propTypesDefault.default).bool,
    helmetData: (0, _propTypesDefault.default).object
}, W.defaultProps = {
    defer: !0,
    encodeSpecialCharacters: !0,
    prioritizeSeoTags: !1
}, W.displayName = "Helmet";

},{"react":"8CCva","prop-types":"j03Ye","react-fast-compare":"lFUwX","invariant":"bjdwX","shallowequal":"f2IhI","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"j03Ye":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs, throwOnDirectAccess;
// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = require("e98516c5bab4526")();

},{"e98516c5bab4526":"bLQTE"}],"bLQTE":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = require("bf7f43a19ae1b960");
function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === ReactPropTypesSecret) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: emptyFunctionWithReset,
        resetWarningCache: emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"bf7f43a19ae1b960":"kFtNJ"}],"kFtNJ":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"lFUwX":[function(require,module,exports,__globalThis) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.1
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if (hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if (hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{}],"bjdwX":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = invariant;

},{}],"f2IhI":[function(require,module,exports,__globalThis) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

},{}],"3xZa0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "configureAppStore", ()=>configureAppStore);
var _reduxSaga = require("redux-saga");
var _reduxSagaDefault = parcelHelpers.interopDefault(_reduxSaga);
var _reducers = require("./reducers");
var _sagas = require("./sagas");
var _sagasDefault = parcelHelpers.interopDefault(_sagas);
var _fatalerror = require("app/state/fatalerror");
var _syncTabs = require("app/state/persist/syncTabs");
function configureAppStore(state) {
    const sagaMiddleware = (0, _reduxSagaDefault.default)({
        onError: (error, info)=>{
            store.dispatch((0, _fatalerror.fatalErrorActions).setError({
                message: error.toString(),
                stack: error.stack,
                sagaStack: info.sagaStack
            }));
        }
    });
    // Create the store with saga middleware
    const middlewares = [
        sagaMiddleware
    ];
    const store = (0, _syncTabs.configureStoreWithSyncTabs)({
        reducer: (0, _reducers.createPersistedRootReducer)(),
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat(middlewares),
        devTools: /* istanbul ignore next line */ false,
        preloadedState: state
    });
    sagaMiddleware.run((0, _sagasDefault.default));
    return store;
}

},{"redux-saga":"kvMDH","./reducers":"ia9FV","./sagas":"4EgkS","app/state/fatalerror":"dQQWe","app/state/persist/syncTabs":"eR10q","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kvMDH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _core = require("@redux-saga/core");
var _coreDefault = parcelHelpers.interopDefault(_core);
parcelHelpers.exportAll(_core, exports);
exports.default = (0, _coreDefault.default);

},{"@redux-saga/core":"7tWYb","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7tWYb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CANCEL", ()=>(0, _symbols.CANCEL));
parcelHelpers.export(exports, "SAGA_LOCATION", ()=>(0, _symbols.SAGA_LOCATION));
parcelHelpers.export(exports, "buffers", ()=>(0, _io22Ea0Cf9Js.I));
parcelHelpers.export(exports, "detach", ()=>(0, _io22Ea0Cf9Js.K));
parcelHelpers.export(exports, "END", ()=>END);
parcelHelpers.export(exports, "channel", ()=>channel);
parcelHelpers.export(exports, "eventChannel", ()=>eventChannel);
parcelHelpers.export(exports, "isEnd", ()=>isEnd);
parcelHelpers.export(exports, "multicastChannel", ()=>multicastChannel);
parcelHelpers.export(exports, "runSaga", ()=>runSaga);
parcelHelpers.export(exports, "stdChannel", ()=>stdChannel);
var _symbols = require("@redux-saga/symbols");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _is = require("@redux-saga/is");
var _io22Ea0Cf9Js = require("./io-22ea0cf9.js");
var _deferred = require("@redux-saga/deferred");
var _deferredDefault = parcelHelpers.interopDefault(_deferred);
var _delayP = require("@redux-saga/delay-p");
var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/ var semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/ function exec(task) {
    try {
        suspend();
        task();
    } finally{
        release();
    }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/ function asap(task) {
    queue.push(task);
    if (!semaphore) {
        suspend();
        flush();
    }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */ function immediately(task) {
    try {
        suspend();
        return task();
    } finally{
        flush();
    }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/ function suspend() {
    semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/ function release() {
    semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/ function flush() {
    release();
    var task;
    while(!semaphore && (task = queue.shift()) !== undefined)exec(task);
}
var array = function array(patterns) {
    return function(input) {
        return patterns.some(function(p) {
            return matcher(p)(input);
        });
    };
};
var predicate = function predicate(_predicate) {
    return function(input) {
        return _predicate(input);
    };
};
var string = function string(pattern) {
    return function(input) {
        return input.type === String(pattern);
    };
};
var symbol = function symbol(pattern) {
    return function(input) {
        return input.type === pattern;
    };
};
var wildcard = function wildcard() {
    return 0, _io22Ea0Cf9Js.k;
};
function matcher(pattern) {
    // prettier-ignore
    var matcherCreator = pattern === '*' ? wildcard : (0, _is.string)(pattern) ? string : (0, _is.array)(pattern) ? array : (0, _is.stringableFunc)(pattern) ? string : (0, _is.func)(pattern) ? predicate : (0, _is.symbol)(pattern) ? symbol : null;
    if (matcherCreator === null) throw new Error("invalid pattern: " + pattern);
    return matcherCreator(pattern);
}
var END = {
    type: (0, _symbols.CHANNEL_END_TYPE)
};
var isEnd = function isEnd(a) {
    return a && a.type === (0, _symbols.CHANNEL_END_TYPE);
};
var CLOSED_CHANNEL_WITH_TAKERS = 'Cannot have a closed channel with pending takers';
var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function channel(buffer$1) {
    if (buffer$1 === void 0) buffer$1 = (0, _io22Ea0Cf9Js.e)();
    var closed = false;
    var takers = [];
    function checkForbiddenStates() {
        if (closed && takers.length) throw (0, _io22Ea0Cf9Js.i)(CLOSED_CHANNEL_WITH_TAKERS);
        if (takers.length && !buffer$1.isEmpty()) throw (0, _io22Ea0Cf9Js.i)('Cannot have pending takers with non empty buffer');
    }
    function put(input) {
        if (closed) return;
        if (takers.length === 0) return buffer$1.put(input);
        var cb = takers.shift();
        cb(input);
    }
    function take(cb) {
        if (closed && buffer$1.isEmpty()) cb(END);
        else if (!buffer$1.isEmpty()) cb(buffer$1.take());
        else {
            takers.push(cb);
            cb.cancel = function() {
                (0, _io22Ea0Cf9Js.r)(takers, cb);
            };
        }
    }
    function flush(cb) {
        if (closed && buffer$1.isEmpty()) {
            cb(END);
            return;
        }
        cb(buffer$1.flush());
    }
    function close() {
        if (closed) return;
        closed = true;
        var arr = takers;
        takers = [];
        for(var i = 0, len = arr.length; i < len; i++){
            var taker = arr[i];
            taker(END);
        }
    }
    return {
        take: take,
        put: put,
        flush: flush,
        close: close
    };
}
function eventChannel(subscribe, buffer) {
    if (buffer === void 0) buffer = (0, _io22Ea0Cf9Js.n)();
    var closed = false;
    var unsubscribe;
    var chan = channel(buffer);
    var close = function close() {
        if (closed) return;
        closed = true;
        if ((0, _is.func)(unsubscribe)) unsubscribe();
        chan.close();
    };
    unsubscribe = subscribe(function(input) {
        if (isEnd(input)) {
            close();
            return;
        }
        chan.put(input);
    });
    unsubscribe = (0, _io22Ea0Cf9Js.o)(unsubscribe);
    if (closed) unsubscribe();
    return {
        take: chan.take,
        flush: chan.flush,
        close: close
    };
}
function multicastChannel() {
    var _ref;
    var closed = false;
    var currentTakers = [];
    var nextTakers = currentTakers;
    function checkForbiddenStates() {
        if (closed && nextTakers.length) throw (0, _io22Ea0Cf9Js.i)(CLOSED_CHANNEL_WITH_TAKERS);
    }
    var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
        if (nextTakers !== currentTakers) return;
        nextTakers = currentTakers.slice();
    };
    var close = function close() {
        closed = true;
        var takers = currentTakers = nextTakers;
        nextTakers = [];
        takers.forEach(function(taker) {
            taker(END);
        });
    };
    return _ref = {}, _ref[0, _symbols.MULTICAST] = true, _ref.put = function put(input) {
        if (closed) return;
        if (isEnd(input)) {
            close();
            return;
        }
        var takers = currentTakers = nextTakers;
        for(var i = 0, len = takers.length; i < len; i++){
            var taker = takers[i];
            if (taker[0, _symbols.MATCH](input)) {
                taker.cancel();
                taker(input);
            }
        }
    }, _ref.take = function take(cb, matcher) {
        if (matcher === void 0) matcher = wildcard;
        if (closed) {
            cb(END);
            return;
        }
        cb[0, _symbols.MATCH] = matcher;
        ensureCanMutateNextTakers();
        nextTakers.push(cb);
        cb.cancel = (0, _io22Ea0Cf9Js.o)(function() {
            ensureCanMutateNextTakers();
            (0, _io22Ea0Cf9Js.r)(nextTakers, cb);
        });
    }, _ref.close = close, _ref;
}
function stdChannel() {
    var chan = multicastChannel();
    var put = chan.put;
    chan.put = function(input) {
        if (input[0, _symbols.SAGA_ACTION]) {
            put(input);
            return;
        }
        asap(function() {
            put(input);
        });
    };
    return chan;
}
var RUNNING = 0;
var CANCELLED = 1;
var ABORTED = 2;
var DONE = 3;
function resolvePromise(promise, cb) {
    var cancelPromise = promise[0, _symbols.CANCEL];
    if ((0, _is.func)(cancelPromise)) cb.cancel = cancelPromise;
    promise.then(cb, function(error) {
        cb(error, true);
    });
}
var current = 0;
var nextSagaId = function() {
    return ++current;
};
var _effectRunnerMap;
function getIteratorMetaInfo(iterator, fn) {
    if (iterator.isSagaIterator) return {
        name: iterator.meta.name
    };
    return (0, _io22Ea0Cf9Js.j)(fn);
}
function createTaskIterator(_ref) {
    var context = _ref.context, fn = _ref.fn, args = _ref.args;
    // catch synchronous failures; see #152 and #441
    try {
        var result = fn.apply(context, args); // i.e. a generator function returns an iterator
        if ((0, _is.iterator)(result)) return result;
        var resolved = false;
        var next = function next(arg) {
            if (!resolved) {
                resolved = true; // Only promises returned from fork will be interpreted. See #1573
                return {
                    value: result,
                    done: !(0, _is.promise)(result)
                };
            } else return {
                value: arg,
                done: true
            };
        };
        return (0, _io22Ea0Cf9Js.q)(next);
    } catch (err) {
        // do not bubble up synchronous failures for detached forks
        // instead create a failed task. See #152 and #441
        return (0, _io22Ea0Cf9Js.q)(function() {
            throw err;
        });
    }
}
function runPutEffect(env, _ref2, cb) {
    var channel = _ref2.channel, action = _ref2.action, resolve = _ref2.resolve;
    /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/ asap(function() {
        var result;
        try {
            result = (channel ? channel.put : env.dispatch)(action);
        } catch (error) {
            cb(error, true);
            return;
        }
        if (resolve && (0, _is.promise)(result)) resolvePromise(result, cb);
        else cb(result);
    }); // Put effects are non cancellables
}
function runTakeEffect(env, _ref3, cb) {
    var _ref3$channel = _ref3.channel, channel = _ref3$channel === void 0 ? env.channel : _ref3$channel, pattern = _ref3.pattern, maybe = _ref3.maybe;
    var takeCb = function takeCb(input) {
        if (input instanceof Error) {
            cb(input, true);
            return;
        }
        if (isEnd(input) && !maybe) {
            cb((0, _symbols.TERMINATE));
            return;
        }
        cb(input);
    };
    try {
        channel.take(takeCb, (0, _is.notUndef)(pattern) ? matcher(pattern) : null);
    } catch (err) {
        cb(err, true);
        return;
    }
    cb.cancel = takeCb.cancel;
}
function runCallEffect(env, _ref4, cb, _ref5) {
    var context = _ref4.context, fn = _ref4.fn, args = _ref4.args;
    var task = _ref5.task;
    // catch synchronous failures; see #152
    try {
        var result = fn.apply(context, args);
        if ((0, _is.promise)(result)) {
            resolvePromise(result, cb);
            return;
        }
        if ((0, _is.iterator)(result)) {
            // resolve iterator
            proc(env, result, task.context, current, (0, _io22Ea0Cf9Js.j)(fn), /* isRoot */ false, cb);
            return;
        }
        cb(result);
    } catch (error) {
        cb(error, true);
    }
}
function runCPSEffect(env, _ref6, cb) {
    var context = _ref6.context, fn = _ref6.fn, args = _ref6.args;
    // CPS (ie node style functions) can define their own cancellation logic
    // by setting cancel field on the cb
    // catch synchronous failures; see #152
    try {
        var cpsCb = function cpsCb(err, res) {
            if ((0, _is.undef)(err)) cb(res);
            else cb(err, true);
        };
        fn.apply(context, args.concat(cpsCb));
        if (cpsCb.cancel) cb.cancel = cpsCb.cancel;
    } catch (error) {
        cb(error, true);
    }
}
function runForkEffect(env, _ref7, cb, _ref8) {
    var context = _ref7.context, fn = _ref7.fn, args = _ref7.args, detached = _ref7.detached;
    var parent = _ref8.task;
    var taskIterator = createTaskIterator({
        context: context,
        fn: fn,
        args: args
    });
    var meta = getIteratorMetaInfo(taskIterator, fn);
    immediately(function() {
        var child = proc(env, taskIterator, parent.context, current, meta, detached, undefined);
        if (detached) cb(child);
        else {
            if (child.isRunning()) {
                parent.queue.addTask(child);
                cb(child);
            } else if (child.isAborted()) parent.queue.abort(child.error());
            else cb(child);
        }
    }); // Fork effects are non cancellables
}
function runJoinEffect(env, taskOrTasks, cb, _ref9) {
    var task = _ref9.task;
    var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
        if (taskToJoin.isRunning()) {
            var joiner = {
                task: task,
                cb: cb
            };
            cb.cancel = function() {
                if (taskToJoin.isRunning()) (0, _io22Ea0Cf9Js.r)(taskToJoin.joiners, joiner);
            };
            taskToJoin.joiners.push(joiner);
        } else if (taskToJoin.isAborted()) cb(taskToJoin.error(), true);
        else cb(taskToJoin.result());
    };
    if ((0, _is.array)(taskOrTasks)) {
        if (taskOrTasks.length === 0) {
            cb([]);
            return;
        }
        var childCallbacks = (0, _io22Ea0Cf9Js.l)(taskOrTasks, cb);
        taskOrTasks.forEach(function(t, i) {
            joinSingleTask(t, childCallbacks[i]);
        });
    } else joinSingleTask(taskOrTasks, cb);
}
function cancelSingleTask(taskToCancel) {
    if (taskToCancel.isRunning()) taskToCancel.cancel();
}
function runCancelEffect(env, taskOrTasks, cb, _ref10) {
    var task = _ref10.task;
    if (taskOrTasks === (0, _symbols.SELF_CANCELLATION)) cancelSingleTask(task);
    else if ((0, _is.array)(taskOrTasks)) taskOrTasks.forEach(cancelSingleTask);
    else cancelSingleTask(taskOrTasks);
    cb(); // cancel effects are non cancellables
}
function runAllEffect(env, effects, cb, _ref11) {
    var digestEffect = _ref11.digestEffect;
    var effectId = current;
    var keys = Object.keys(effects);
    if (keys.length === 0) {
        cb((0, _is.array)(effects) ? [] : {});
        return;
    }
    var childCallbacks = (0, _io22Ea0Cf9Js.l)(effects, cb);
    keys.forEach(function(key) {
        digestEffect(effects[key], effectId, childCallbacks[key], key);
    });
}
function runRaceEffect(env, effects, cb, _ref12) {
    var digestEffect = _ref12.digestEffect;
    var effectId = current;
    var keys = Object.keys(effects);
    var response = (0, _is.array)(effects) ? (0, _io22Ea0Cf9Js.m)(keys.length) : {};
    var childCbs = {};
    var completed = false;
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || (0, _io22Ea0Cf9Js.s)(res)) {
                // Race Auto cancellation
                cb.cancel();
                cb(res, isErr);
            } else {
                cb.cancel();
                completed = true;
                response[key] = res;
                cb(response);
            }
        };
        chCbAtKey.cancel = (0, _io22Ea0Cf9Js.t);
        childCbs[key] = chCbAtKey;
    });
    cb.cancel = function() {
        // prevents unnecessary cancellation
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCbs[key].cancel();
            });
        }
    };
    keys.forEach(function(key) {
        if (completed) return;
        digestEffect(effects[key], effectId, childCbs[key], key);
    });
}
function runSelectEffect(env, _ref13, cb) {
    var selector = _ref13.selector, args = _ref13.args;
    try {
        var state = selector.apply(void 0, [
            env.getState()
        ].concat(args));
        cb(state);
    } catch (error) {
        cb(error, true);
    }
}
function runChannelEffect(env, _ref14, cb) {
    var pattern = _ref14.pattern, buffer = _ref14.buffer;
    var chan = channel(buffer);
    var match = matcher(pattern);
    var taker = function taker(action) {
        if (!isEnd(action)) env.channel.take(taker, match);
        chan.put(action);
    };
    var close = chan.close;
    chan.close = function() {
        taker.cancel();
        close();
    };
    env.channel.take(taker, match);
    cb(chan);
}
function runCancelledEffect(env, data, cb, _ref15) {
    var task = _ref15.task;
    cb(task.isCancelled());
}
function runFlushEffect(env, channel, cb) {
    channel.flush(cb);
}
function runGetContextEffect(env, prop, cb, _ref16) {
    var task = _ref16.task;
    cb(task.context[prop]);
}
function runSetContextEffect(env, props, cb, _ref17) {
    var task = _ref17.task;
    (0, _io22Ea0Cf9Js.p)(task.context, props);
    cb();
}
var effectRunnerMap = (_effectRunnerMap = {}, _effectRunnerMap[0, _io22Ea0Cf9Js.T] = runTakeEffect, _effectRunnerMap[0, _io22Ea0Cf9Js.P] = runPutEffect, _effectRunnerMap[0, _io22Ea0Cf9Js.A] = runAllEffect, _effectRunnerMap[0, _io22Ea0Cf9Js.R] = runRaceEffect, _effectRunnerMap[0, _io22Ea0Cf9Js.C] = runCallEffect, _effectRunnerMap[0, _io22Ea0Cf9Js.a] = runCPSEffect, _effectRunnerMap[0, _io22Ea0Cf9Js.F] = runForkEffect, _effectRunnerMap[0, _io22Ea0Cf9Js.J] = runJoinEffect, _effectRunnerMap[0, _io22Ea0Cf9Js.b] = runCancelEffect, _effectRunnerMap[0, _io22Ea0Cf9Js.S] = runSelectEffect, _effectRunnerMap[0, _io22Ea0Cf9Js.d] = runChannelEffect, _effectRunnerMap[0, _io22Ea0Cf9Js.f] = runCancelledEffect, _effectRunnerMap[0, _io22Ea0Cf9Js.g] = runFlushEffect, _effectRunnerMap[0, _io22Ea0Cf9Js.G] = runGetContextEffect, _effectRunnerMap[0, _io22Ea0Cf9Js.h] = runSetContextEffect, _effectRunnerMap);
/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/ function forkQueue(mainTask, onAbort, cont) {
    var tasks = [];
    var result;
    var completed = false;
    addTask(mainTask);
    var getTasks = function getTasks() {
        return tasks;
    };
    function abort(err) {
        onAbort();
        cancelAll();
        cont(err, true);
    }
    function addTask(task) {
        tasks.push(task);
        task.cont = function(res, isErr) {
            if (completed) return;
            (0, _io22Ea0Cf9Js.r)(tasks, task);
            task.cont = (0, _io22Ea0Cf9Js.t);
            if (isErr) abort(res);
            else {
                if (task === mainTask) result = res;
                if (!tasks.length) {
                    completed = true;
                    cont(result);
                }
            }
        };
    }
    function cancelAll() {
        if (completed) return;
        completed = true;
        tasks.forEach(function(t) {
            t.cont = (0, _io22Ea0Cf9Js.t);
            t.cancel();
        });
        tasks = [];
    }
    return {
        addTask: addTask,
        cancelAll: cancelAll,
        abort: abort,
        getTasks: getTasks
    };
}
// there can be only a single saga error created at any given moment
function formatLocation(fileName, lineNumber) {
    return fileName + "?" + lineNumber;
}
function effectLocationAsString(effect) {
    var location = (0, _io22Ea0Cf9Js.v)(effect);
    if (location) {
        var code = location.code, fileName = location.fileName, lineNumber = location.lineNumber;
        var source = code + "  " + formatLocation(fileName, lineNumber);
        return source;
    }
    return '';
}
function sagaLocationAsString(sagaMeta) {
    var name = sagaMeta.name, location = sagaMeta.location;
    if (location) return name + "  " + formatLocation(location.fileName, location.lineNumber);
    return name;
}
function cancelledTasksAsString(sagaStack) {
    var cancelledTasks = (0, _io22Ea0Cf9Js.u)(function(i) {
        return i.cancelledTasks;
    }, sagaStack);
    if (!cancelledTasks.length) return '';
    return [
        'Tasks cancelled due to error:'
    ].concat(cancelledTasks).join('\n');
}
var crashedEffect = null;
var sagaStack = [];
var addSagaFrame = function addSagaFrame(frame) {
    frame.crashedEffect = crashedEffect;
    sagaStack.push(frame);
};
var clear = function clear() {
    crashedEffect = null;
    sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now
var setCrashedEffect = function setCrashedEffect(effect) {
    crashedEffect = effect;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/ var toString = function toString() {
    var firstSaga = sagaStack[0], otherSagas = sagaStack.slice(1);
    var crashedEffectLocation = firstSaga.crashedEffect ? effectLocationAsString(firstSaga.crashedEffect) : null;
    var errorMessage = "The above error occurred in task " + sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : '');
    return [
        errorMessage
    ].concat(otherSagas.map(function(s) {
        return "    created by " + sagaLocationAsString(s.meta);
    }), [
        cancelledTasksAsString(sagaStack)
    ]).join('\n');
};
function newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
    var _task;
    if (cont === void 0) cont = (0, _io22Ea0Cf9Js.t);
    var status = RUNNING;
    var taskResult;
    var taskError;
    var deferredEnd = null;
    var cancelledDueToErrorTasks = [];
    var context = Object.create(parentContext);
    var queue = forkQueue(mainTask, function onAbort() {
        cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function(t) {
            return t.meta.name;
        }));
    }, end);
    /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/ function cancel() {
        if (status === RUNNING) {
            // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
            // effects in the iterator's finally block will still be executed
            status = CANCELLED;
            queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners
            end((0, _symbols.TASK_CANCEL), false);
        }
    }
    function end(result, isErr) {
        if (!isErr) {
            // The status here may be RUNNING or CANCELLED
            // If the status is CANCELLED, then we do not need to change it here
            if (result === (0, _symbols.TASK_CANCEL)) status = CANCELLED;
            else if (status !== CANCELLED) status = DONE;
            taskResult = result;
            deferredEnd && deferredEnd.resolve(result);
        } else {
            status = ABORTED;
            addSagaFrame({
                meta: meta,
                cancelledTasks: cancelledDueToErrorTasks
            });
            if (task.isRoot) {
                var sagaStack = toString(); // we've dumped the saga stack to string and are passing it to user's code
                // we know that it won't be needed anymore and we need to clear it
                clear();
                env.onError(result, {
                    sagaStack: sagaStack
                });
            }
            taskError = result;
            deferredEnd && deferredEnd.reject(result);
        }
        task.cont(result, isErr);
        task.joiners.forEach(function(joiner) {
            joiner.cb(result, isErr);
        });
        task.joiners = null;
    }
    function setContext(props) {
        (0, _io22Ea0Cf9Js.p)(context, props);
    }
    function toPromise() {
        if (deferredEnd) return deferredEnd.promise;
        deferredEnd = (0, _deferredDefault.default)();
        if (status === ABORTED) deferredEnd.reject(taskError);
        else if (status !== RUNNING) deferredEnd.resolve(taskResult);
        return deferredEnd.promise;
    }
    var task = (_task = {}, _task[0, _symbols.TASK] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel, _task.cont = cont, _task.end = end, _task.setContext = setContext, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
        return status === RUNNING;
    }, _task.isCancelled = function isCancelled() {
        return status === CANCELLED || status === RUNNING && mainTask.status === CANCELLED;
    }, _task.isAborted = function isAborted() {
        return status === ABORTED;
    }, _task.result = function result() {
        return taskResult;
    }, _task.error = function error() {
        return taskError;
    }, _task);
    return task;
}
function proc(env, iterator$1, parentContext, parentEffectId, meta, isRoot, cont) {
    var finalRunEffect = env.finalizeRunEffect(runEffect);
    /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/ next.cancel = (0, _io22Ea0Cf9Js.t);
    /** Creates a main task to track the main flow */ var mainTask = {
        meta: meta,
        cancel: cancelMain,
        status: RUNNING
    };
    /**
   Creates a new task descriptor for this generator.
   A task is the aggregation of it's mainTask and all it's forked tasks.
   **/ var task = newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
    var executingContext = {
        task: task,
        digestEffect: digestEffect
    };
    /**
    cancellation of the main task. We'll simply resume the Generator with a TASK_CANCEL
  **/ function cancelMain() {
        if (mainTask.status === RUNNING) {
            mainTask.status = CANCELLED;
            next((0, _symbols.TASK_CANCEL));
        }
    }
    /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/ if (cont) cont.cancel = task.cancel;
     // kicks up the generator
    next(); // then return the task descriptor to the caller
    return task;
    /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */ function next(arg, isErr) {
        try {
            var result;
            if (isErr) {
                result = iterator$1.throw(arg); // user handled the error, we can clear bookkept values
                clear();
            } else if ((0, _io22Ea0Cf9Js.y)(arg)) {
                /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/ mainTask.status = CANCELLED;
                /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/ next.cancel();
                /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/ result = (0, _is.func)(iterator$1.return) ? iterator$1.return((0, _symbols.TASK_CANCEL)) : {
                    done: true,
                    value: (0, _symbols.TASK_CANCEL)
                };
            } else if ((0, _io22Ea0Cf9Js.z)(arg)) // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
            result = (0, _is.func)(iterator$1.return) ? iterator$1.return() : {
                done: true
            };
            else result = iterator$1.next(arg);
            if (!result.done) digestEffect(result.value, parentEffectId, next);
            else {
                /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/ if (mainTask.status !== CANCELLED) mainTask.status = DONE;
                mainTask.cont(result.value);
            }
        } catch (error) {
            if (mainTask.status === CANCELLED) throw error;
            mainTask.status = ABORTED;
            mainTask.cont(error, true);
        }
    }
    function runEffect(effect, effectId, currCb) {
        /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/ if ((0, _is.promise)(effect)) resolvePromise(effect, currCb);
        else if ((0, _is.iterator)(effect)) // resolve iterator
        proc(env, effect, task.context, effectId, meta, /* isRoot */ false, currCb);
        else if (effect && effect[0, _symbols.IO]) {
            var effectRunner = effectRunnerMap[effect.type];
            effectRunner(env, effect.payload, currCb, executingContext);
        } else // anything else returned as is
        currCb(effect);
    }
    function digestEffect(effect, parentEffectId, cb, label) {
        if (label === void 0) label = '';
        var effectId = nextSagaId();
        env.sagaMonitor && env.sagaMonitor.effectTriggered({
            effectId: effectId,
            parentEffectId: parentEffectId,
            label: label,
            effect: effect
        });
        /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/ var effectSettled; // Completion callback passed to the appropriate effect runner
        function currCb(res, isErr) {
            if (effectSettled) return;
            effectSettled = true;
            cb.cancel = (0, _io22Ea0Cf9Js.t); // defensive measure
            if (env.sagaMonitor) {
                if (isErr) env.sagaMonitor.effectRejected(effectId, res);
                else env.sagaMonitor.effectResolved(effectId, res);
            }
            if (isErr) setCrashedEffect(effect);
            cb(res, isErr);
        } // tracks down the current cancel
        currCb.cancel = (0, _io22Ea0Cf9Js.t); // setup cancellation logic on the parent cb
        cb.cancel = function() {
            // prevents cancelling an already completed effect
            if (effectSettled) return;
            effectSettled = true;
            currCb.cancel(); // propagates cancel downward
            currCb.cancel = (0, _io22Ea0Cf9Js.t); // defensive measure
            env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
        };
        finalRunEffect(effect, effectId, currCb);
    }
}
var RUN_SAGA_SIGNATURE = 'runSaga(options, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function runSaga(_ref, saga) {
    var _ref$channel = _ref.channel, channel = _ref$channel === void 0 ? stdChannel() : _ref$channel, dispatch = _ref.dispatch, getState = _ref.getState, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, sagaMonitor = _ref.sagaMonitor, effectMiddlewares = _ref.effectMiddlewares, _ref$onError = _ref.onError, onError = _ref$onError === void 0 ? (0, _io22Ea0Cf9Js.D) : _ref$onError;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var iterator$1 = saga.apply(void 0, args);
    var effectId = nextSagaId();
    if (sagaMonitor) {
        // monitors are expected to have a certain interface, let's fill-in any missing ones
        sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || (0, _io22Ea0Cf9Js.t);
        sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || (0, _io22Ea0Cf9Js.t);
        sagaMonitor.effectResolved = sagaMonitor.effectResolved || (0, _io22Ea0Cf9Js.t);
        sagaMonitor.effectRejected = sagaMonitor.effectRejected || (0, _io22Ea0Cf9Js.t);
        sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || (0, _io22Ea0Cf9Js.t);
        sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || (0, _io22Ea0Cf9Js.t);
        sagaMonitor.rootSagaStarted({
            effectId: effectId,
            saga: saga,
            args: args
        });
    }
    var MIDDLEWARE_TYPE_ERROR;
    var finalizeRunEffect;
    if (effectMiddlewares) {
        var middleware = (0, _io22Ea0Cf9Js.B).apply(void 0, effectMiddlewares);
        finalizeRunEffect = function finalizeRunEffect(runEffect) {
            return function(effect, effectId, currCb) {
                var plainRunEffect = function plainRunEffect(eff) {
                    return runEffect(eff, effectId, currCb);
                };
                return middleware(plainRunEffect)(effect);
            };
        };
    } else finalizeRunEffect = (0, _io22Ea0Cf9Js.H);
    var env = {
        channel: channel,
        dispatch: (0, _io22Ea0Cf9Js.E)(dispatch),
        getState: getState,
        sagaMonitor: sagaMonitor,
        onError: onError,
        finalizeRunEffect: finalizeRunEffect
    };
    return immediately(function() {
        var task = proc(env, iterator$1, context, effectId, (0, _io22Ea0Cf9Js.j)(saga), /* isRoot */ true, undefined);
        if (sagaMonitor) sagaMonitor.effectResolved(effectId, task);
        return task;
    });
}
function sagaMiddlewareFactory(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$context = _ref.context, context = _ref$context === void 0 ? {} : _ref$context, _ref$channel = _ref.channel, channel = _ref$channel === void 0 ? stdChannel() : _ref$channel, sagaMonitor = _ref.sagaMonitor, options = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, [
        "context",
        "channel",
        "sagaMonitor"
    ]);
    var boundRunSaga;
    function sagaMiddleware(_ref2) {
        var getState = _ref2.getState, dispatch = _ref2.dispatch;
        boundRunSaga = runSaga.bind(null, (0, _extendsDefault.default)({}, options, {
            context: context,
            channel: channel,
            dispatch: dispatch,
            getState: getState,
            sagaMonitor: sagaMonitor
        }));
        return function(next) {
            return function(action) {
                if (sagaMonitor && sagaMonitor.actionDispatched) sagaMonitor.actionDispatched(action);
                var result = next(action); // hit reducers
                channel.put(action);
                return result;
            };
        };
    }
    sagaMiddleware.run = function() {
        return boundRunSaga.apply(void 0, arguments);
    };
    sagaMiddleware.setContext = function(props) {
        (0, _io22Ea0Cf9Js.p)(context, props);
    };
    return sagaMiddleware;
}
exports.default = sagaMiddlewareFactory;

},{"@redux-saga/symbols":"9v4bk","@babel/runtime/helpers/esm/extends":"jGVGo","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"7ul4s","@redux-saga/is":"bCJA0","./io-22ea0cf9.js":"j4tzc","@redux-saga/deferred":"17Rmg","@redux-saga/delay-p":"6f1ut","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9v4bk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CANCEL", ()=>CANCEL);
parcelHelpers.export(exports, "CHANNEL_END_TYPE", ()=>CHANNEL_END_TYPE);
parcelHelpers.export(exports, "IO", ()=>IO);
parcelHelpers.export(exports, "MATCH", ()=>MATCH);
parcelHelpers.export(exports, "MULTICAST", ()=>MULTICAST);
parcelHelpers.export(exports, "SAGA_ACTION", ()=>SAGA_ACTION);
parcelHelpers.export(exports, "SAGA_LOCATION", ()=>SAGA_LOCATION);
parcelHelpers.export(exports, "SELF_CANCELLATION", ()=>SELF_CANCELLATION);
parcelHelpers.export(exports, "TASK", ()=>TASK);
parcelHelpers.export(exports, "TASK_CANCEL", ()=>TASK_CANCEL);
parcelHelpers.export(exports, "TERMINATE", ()=>TERMINATE);
var createSymbol = function createSymbol(name) {
    return "@@redux-saga/" + name;
};
var CANCEL = /*#__PURE__*/ createSymbol('CANCEL_PROMISE');
var CHANNEL_END_TYPE = /*#__PURE__*/ createSymbol('CHANNEL_END');
var IO = /*#__PURE__*/ createSymbol('IO');
var MATCH = /*#__PURE__*/ createSymbol('MATCH');
var MULTICAST = /*#__PURE__*/ createSymbol('MULTICAST');
var SAGA_ACTION = /*#__PURE__*/ createSymbol('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/ createSymbol('SELF_CANCELLATION');
var TASK = /*#__PURE__*/ createSymbol('TASK');
var TASK_CANCEL = /*#__PURE__*/ createSymbol('TASK_CANCEL');
var TERMINATE = /*#__PURE__*/ createSymbol('TERMINATE');
var SAGA_LOCATION = /*#__PURE__*/ createSymbol('LOCATION');

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jGVGo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7ul4s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectWithoutPropertiesLoose);
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bCJA0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "array", ()=>array);
parcelHelpers.export(exports, "buffer", ()=>buffer);
parcelHelpers.export(exports, "channel", ()=>channel);
parcelHelpers.export(exports, "effect", ()=>effect);
parcelHelpers.export(exports, "func", ()=>func);
parcelHelpers.export(exports, "iterable", ()=>iterable);
parcelHelpers.export(exports, "iterator", ()=>iterator);
parcelHelpers.export(exports, "multicast", ()=>multicast);
parcelHelpers.export(exports, "notUndef", ()=>notUndef);
parcelHelpers.export(exports, "number", ()=>number);
parcelHelpers.export(exports, "object", ()=>object);
parcelHelpers.export(exports, "observable", ()=>observable);
parcelHelpers.export(exports, "pattern", ()=>pattern);
parcelHelpers.export(exports, "promise", ()=>promise);
parcelHelpers.export(exports, "sagaAction", ()=>sagaAction);
parcelHelpers.export(exports, "string", ()=>string);
parcelHelpers.export(exports, "stringableFunc", ()=>stringableFunc);
parcelHelpers.export(exports, "symbol", ()=>symbol);
parcelHelpers.export(exports, "task", ()=>task);
parcelHelpers.export(exports, "undef", ()=>undef);
var _symbols = require("@redux-saga/symbols");
var undef = function undef(v) {
    return v === null || v === undefined;
};
var notUndef = function notUndef(v) {
    return v !== null && v !== undefined;
};
var func = function func(f) {
    return typeof f === 'function';
};
var number = function number(n) {
    return typeof n === 'number';
};
var string = function string(s) {
    return typeof s === 'string';
};
var array = Array.isArray;
var object = function object(obj) {
    return obj && !array(obj) && typeof obj === 'object';
};
var promise = function promise(p) {
    return p && func(p.then);
};
var iterator = function iterator(it) {
    return it && func(it.next) && func(it.throw);
};
var iterable = function iterable(it) {
    return it && func(Symbol) ? func(it[Symbol.iterator]) : array(it);
};
var task = function task(t) {
    return t && t[0, _symbols.TASK];
};
var sagaAction = function sagaAction(a) {
    return Boolean(a && a[0, _symbols.SAGA_ACTION]);
};
var observable = function observable(ob) {
    return ob && func(ob.subscribe);
};
var buffer = function buffer(buf) {
    return buf && func(buf.isEmpty) && func(buf.take) && func(buf.put);
};
var pattern = function pattern(pat) {
    return pat && (string(pat) || symbol(pat) || func(pat) || array(pat) && pat.every(pattern));
};
var channel = function channel(ch) {
    return ch && func(ch.take) && func(ch.close);
};
var stringableFunc = function stringableFunc(f) {
    return func(f) && f.hasOwnProperty('toString');
};
var symbol = function symbol(sym) {
    return Boolean(sym) && typeof Symbol === 'function' && sym.constructor === Symbol && sym !== Symbol.prototype;
};
var multicast = function multicast(ch) {
    return channel(ch) && ch[0, _symbols.MULTICAST];
};
var effect = function effect(eff) {
    return eff && eff[0, _symbols.IO];
};

},{"@redux-saga/symbols":"9v4bk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"j4tzc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$", ()=>all);
parcelHelpers.export(exports, "A", ()=>ALL);
parcelHelpers.export(exports, "B", ()=>compose);
parcelHelpers.export(exports, "C", ()=>CALL);
parcelHelpers.export(exports, "D", ()=>logError);
parcelHelpers.export(exports, "E", ()=>wrapSagaDispatch);
parcelHelpers.export(exports, "F", ()=>FORK);
parcelHelpers.export(exports, "G", ()=>GET_CONTEXT);
parcelHelpers.export(exports, "H", ()=>identity);
parcelHelpers.export(exports, "I", ()=>buffers);
parcelHelpers.export(exports, "J", ()=>JOIN);
parcelHelpers.export(exports, "K", ()=>detach);
parcelHelpers.export(exports, "L", ()=>take);
parcelHelpers.export(exports, "M", ()=>fork);
parcelHelpers.export(exports, "N", ()=>cancel);
parcelHelpers.export(exports, "O", ()=>call);
parcelHelpers.export(exports, "P", ()=>PUT);
parcelHelpers.export(exports, "Q", ()=>delay);
parcelHelpers.export(exports, "R", ()=>RACE);
parcelHelpers.export(exports, "S", ()=>SELECT);
parcelHelpers.export(exports, "T", ()=>TAKE);
parcelHelpers.export(exports, "U", ()=>actionChannel);
parcelHelpers.export(exports, "V", ()=>sliding);
parcelHelpers.export(exports, "W", ()=>race);
parcelHelpers.export(exports, "X", ()=>effectTypes);
parcelHelpers.export(exports, "Y", ()=>takeMaybe);
parcelHelpers.export(exports, "Z", ()=>put);
parcelHelpers.export(exports, "_", ()=>putResolve);
parcelHelpers.export(exports, "a", ()=>CPS);
parcelHelpers.export(exports, "a0", ()=>apply);
parcelHelpers.export(exports, "a1", ()=>cps);
parcelHelpers.export(exports, "a2", ()=>spawn);
parcelHelpers.export(exports, "a3", ()=>join);
parcelHelpers.export(exports, "a4", ()=>select);
parcelHelpers.export(exports, "a5", ()=>cancelled);
parcelHelpers.export(exports, "a6", ()=>flush);
parcelHelpers.export(exports, "a7", ()=>getContext);
parcelHelpers.export(exports, "a8", ()=>setContext);
parcelHelpers.export(exports, "b", ()=>CANCEL);
parcelHelpers.export(exports, "c", ()=>check);
parcelHelpers.export(exports, "d", ()=>ACTION_CHANNEL);
parcelHelpers.export(exports, "e", ()=>expanding);
parcelHelpers.export(exports, "f", ()=>CANCELLED);
parcelHelpers.export(exports, "g", ()=>FLUSH);
parcelHelpers.export(exports, "h", ()=>SET_CONTEXT);
parcelHelpers.export(exports, "i", ()=>internalErr);
parcelHelpers.export(exports, "j", ()=>getMetaInfo);
parcelHelpers.export(exports, "k", ()=>kTrue);
parcelHelpers.export(exports, "l", ()=>createAllStyleChildCallbacks);
parcelHelpers.export(exports, "m", ()=>createEmptyArray);
parcelHelpers.export(exports, "n", ()=>none);
parcelHelpers.export(exports, "o", ()=>once);
parcelHelpers.export(exports, "p", ()=>assignWithSymbols);
parcelHelpers.export(exports, "q", ()=>makeIterator);
parcelHelpers.export(exports, "r", ()=>remove);
parcelHelpers.export(exports, "s", ()=>shouldComplete);
parcelHelpers.export(exports, "t", ()=>noop);
parcelHelpers.export(exports, "u", ()=>flatMap);
parcelHelpers.export(exports, "v", ()=>getLocation);
parcelHelpers.export(exports, "w", ()=>createSetContextWarning);
parcelHelpers.export(exports, "x", ()=>asyncIteratorSymbol);
parcelHelpers.export(exports, "y", ()=>shouldCancel);
parcelHelpers.export(exports, "z", ()=>shouldTerminate);
var _symbols = require("@redux-saga/symbols");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _is = require("@redux-saga/is");
var _delayP = require("@redux-saga/delay-p");
var _delayPDefault = parcelHelpers.interopDefault(_delayP);
var konst = function konst(v) {
    return function() {
        return v;
    };
};
var kTrue = /*#__PURE__*/ konst(true);
var noop = function noop() {};
var identity = function identity(v) {
    return v;
};
var hasSymbol = typeof Symbol === 'function';
var asyncIteratorSymbol = hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : '@@asyncIterator';
function check(value, predicate, error) {
    if (!predicate(value)) throw new Error(error);
}
var assignWithSymbols = function assignWithSymbols(target, source) {
    (0, _extendsDefault.default)(target, source);
    if (Object.getOwnPropertySymbols) Object.getOwnPropertySymbols(source).forEach(function(s) {
        target[s] = source[s];
    });
};
var flatMap = function flatMap(mapper, arr) {
    var _ref;
    return (_ref = []).concat.apply(_ref, arr.map(mapper));
};
function remove(array, item) {
    var index = array.indexOf(item);
    if (index >= 0) array.splice(index, 1);
}
function once(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        fn();
    };
}
var kThrow = function kThrow(err) {
    throw err;
};
var kReturn = function kReturn(value) {
    return {
        value: value,
        done: true
    };
};
function makeIterator(next, thro, name) {
    if (thro === void 0) thro = kThrow;
    if (name === void 0) name = 'iterator';
    var iterator = {
        meta: {
            name: name
        },
        next: next,
        throw: thro,
        return: kReturn,
        isSagaIterator: true
    };
    if (typeof Symbol !== 'undefined') iterator[Symbol.iterator] = function() {
        return iterator;
    };
    return iterator;
}
function logError(error, _ref2) {
    var sagaStack = _ref2.sagaStack;
    /*eslint-disable no-console*/ console.error(error);
    console.error(sagaStack);
}
var internalErr = function internalErr(err) {
    return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var createSetContextWarning = function createSetContextWarning(ctx, props) {
    return (ctx ? ctx + '.' : '') + "setContext(props): argument " + props + " is not a plain object";
};
var FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array
var createEmptyArray = function createEmptyArray(n) {
    return Array.apply(null, new Array(n));
};
var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
    return function(action) {
        return dispatch(Object.defineProperty(action, (0, _symbols.SAGA_ACTION), {
            value: true
        }));
    };
};
var shouldTerminate = function shouldTerminate(res) {
    return res === (0, _symbols.TERMINATE);
};
var shouldCancel = function shouldCancel(res) {
    return res === (0, _symbols.TASK_CANCEL);
};
var shouldComplete = function shouldComplete(res) {
    return shouldTerminate(res) || shouldCancel(res);
};
function createAllStyleChildCallbacks(shape, parentCallback) {
    var keys = Object.keys(shape);
    var totalCount = keys.length;
    var completedCount = 0;
    var completed;
    var results = (0, _is.array)(shape) ? createEmptyArray(totalCount) : {};
    var childCallbacks = {};
    function checkEnd() {
        if (completedCount === totalCount) {
            completed = true;
            parentCallback(results);
        }
    }
    keys.forEach(function(key) {
        var chCbAtKey = function chCbAtKey(res, isErr) {
            if (completed) return;
            if (isErr || shouldComplete(res)) {
                parentCallback.cancel();
                parentCallback(res, isErr);
            } else {
                results[key] = res;
                completedCount++;
                checkEnd();
            }
        };
        chCbAtKey.cancel = noop;
        childCallbacks[key] = chCbAtKey;
    });
    parentCallback.cancel = function() {
        if (!completed) {
            completed = true;
            keys.forEach(function(key) {
                return childCallbacks[key].cancel();
            });
        }
    };
    return childCallbacks;
}
function getMetaInfo(fn) {
    return {
        name: fn.name || 'anonymous',
        location: getLocation(fn)
    };
}
function getLocation(instrumented) {
    return instrumented[0, _symbols.SAGA_LOCATION];
}
function compose() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
var BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;
var zeroBuffer = {
    isEmpty: kTrue,
    put: noop,
    take: noop
};
function ringBuffer(limit, overflowAction) {
    if (limit === void 0) limit = 10;
    var arr = new Array(limit);
    var length = 0;
    var pushIndex = 0;
    var popIndex = 0;
    var push = function push(it) {
        arr[pushIndex] = it;
        pushIndex = (pushIndex + 1) % limit;
        length++;
    };
    var take = function take() {
        if (length != 0) {
            var it = arr[popIndex];
            arr[popIndex] = null;
            length--;
            popIndex = (popIndex + 1) % limit;
            return it;
        }
    };
    var flush = function flush() {
        var items = [];
        while(length)items.push(take());
        return items;
    };
    return {
        isEmpty: function isEmpty() {
            return length == 0;
        },
        put: function put(it) {
            if (length < limit) push(it);
            else {
                var doubledLimit;
                switch(overflowAction){
                    case ON_OVERFLOW_THROW:
                        throw new Error(BUFFER_OVERFLOW);
                    case ON_OVERFLOW_SLIDE:
                        arr[pushIndex] = it;
                        pushIndex = (pushIndex + 1) % limit;
                        popIndex = pushIndex;
                        break;
                    case ON_OVERFLOW_EXPAND:
                        doubledLimit = 2 * limit;
                        arr = flush();
                        length = arr.length;
                        pushIndex = arr.length;
                        popIndex = 0;
                        arr.length = doubledLimit;
                        limit = doubledLimit;
                        push(it);
                        break;
                    default:
                }
            }
        },
        take: take,
        flush: flush
    };
}
var none = function none() {
    return zeroBuffer;
};
var fixed = function fixed(limit) {
    return ringBuffer(limit, ON_OVERFLOW_THROW);
};
var dropping = function dropping(limit) {
    return ringBuffer(limit, ON_OVERFLOW_DROP);
};
var sliding = function sliding(limit) {
    return ringBuffer(limit, ON_OVERFLOW_SLIDE);
};
var expanding = function expanding(initialSize) {
    return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
};
var buffers = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    none: none,
    fixed: fixed,
    dropping: dropping,
    sliding: sliding,
    expanding: expanding
});
var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';
var effectTypes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    TAKE: TAKE,
    PUT: PUT,
    ALL: ALL,
    RACE: RACE,
    CALL: CALL,
    CPS: CPS,
    FORK: FORK,
    JOIN: JOIN,
    CANCEL: CANCEL,
    SELECT: SELECT,
    ACTION_CHANNEL: ACTION_CHANNEL,
    CANCELLED: CANCELLED,
    FLUSH: FLUSH,
    GET_CONTEXT: GET_CONTEXT,
    SET_CONTEXT: SET_CONTEXT
});
var TEST_HINT = '\n(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)';
var makeEffect = function makeEffect(type, payload) {
    var _ref;
    return _ref = {}, _ref[0, _symbols.IO] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};
var isForkEffect = function isForkEffect(eff) {
    return (0, _is.effect)(eff) && eff.type === FORK;
};
var detach = function detach(eff) {
    return makeEffect(FORK, (0, _extendsDefault.default)({}, eff.payload, {
        detached: true
    }));
};
function take(patternOrChannel, multicastPattern) {
    if (patternOrChannel === void 0) patternOrChannel = '*';
    if ((0, _is.pattern)(patternOrChannel)) {
        if ((0, _is.notUndef)(multicastPattern)) /* eslint-disable no-console */ console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types");
        return makeEffect(TAKE, {
            pattern: patternOrChannel
        });
    }
    if ((0, _is.multicast)(patternOrChannel) && (0, _is.notUndef)(multicastPattern) && (0, _is.pattern)(multicastPattern)) return makeEffect(TAKE, {
        channel: patternOrChannel,
        pattern: multicastPattern
    });
    if ((0, _is.channel)(patternOrChannel)) {
        if ((0, _is.notUndef)(multicastPattern)) /* eslint-disable no-console */ console.warn("take(channel) takes one argument but two were provided. Second argument is ignored.");
        return makeEffect(TAKE, {
            channel: patternOrChannel
        });
    }
}
var takeMaybe = function takeMaybe() {
    var eff = take.apply(void 0, arguments);
    eff.payload.maybe = true;
    return eff;
};
function put(channel$1, action) {
    if ((0, _is.undef)(action)) {
        action = channel$1; // `undefined` instead of `null` to make default parameter work
        channel$1 = undefined;
    }
    return makeEffect(PUT, {
        channel: channel$1,
        action: action
    });
}
var putResolve = function putResolve() {
    var eff = put.apply(void 0, arguments);
    eff.payload.resolve = true;
    return eff;
};
function all(effects) {
    var eff = makeEffect(ALL, effects);
    eff.combinator = true;
    return eff;
}
function race(effects) {
    var eff = makeEffect(RACE, effects);
    eff.combinator = true;
    return eff;
} // this match getFnCallDescriptor logic
var validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
    check(fnDescriptor, (0, _is.notUndef), effectName + ": argument fn is undefined or null");
    if ((0, _is.func)(fnDescriptor)) return;
    var context = null;
    var fn;
    if ((0, _is.array)(fnDescriptor)) {
        context = fnDescriptor[0];
        fn = fnDescriptor[1];
        check(fn, (0, _is.notUndef), effectName + ": argument of type [context, fn] has undefined or null `fn`");
    } else if ((0, _is.object)(fnDescriptor)) {
        context = fnDescriptor.context;
        fn = fnDescriptor.fn;
        check(fn, (0, _is.notUndef), effectName + ": argument of type {context, fn} has undefined or null `fn`");
    } else {
        check(fnDescriptor, (0, _is.func), effectName + ": argument fn is not function");
        return;
    }
    if (context && (0, _is.string)(fn)) {
        check(context[fn], (0, _is.func), effectName + ": context arguments has no such method - \"" + fn + "\"");
        return;
    }
    check(fn, (0, _is.func), effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};
function getFnCallDescriptor(fnDescriptor, args) {
    var context = null;
    var fn;
    if ((0, _is.func)(fnDescriptor)) fn = fnDescriptor;
    else {
        if ((0, _is.array)(fnDescriptor)) {
            context = fnDescriptor[0];
            fn = fnDescriptor[1];
        } else {
            context = fnDescriptor.context;
            fn = fnDescriptor.fn;
        }
        if (context && (0, _is.string)(fn) && (0, _is.func)(context[fn])) fn = context[fn];
    }
    return {
        context: context,
        fn: fn,
        args: args
    };
}
var isNotDelayEffect = function isNotDelayEffect(fn) {
    return fn !== delay;
};
function call(fnDescriptor) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var arg0;
    return makeEffect(CALL, getFnCallDescriptor(fnDescriptor, args));
}
function apply(context, fn, args) {
    if (args === void 0) args = [];
    var fnDescriptor = [
        context,
        fn
    ];
    return makeEffect(CALL, getFnCallDescriptor([
        context,
        fn
    ], args));
}
function cps(fnDescriptor) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return makeEffect(CPS, getFnCallDescriptor(fnDescriptor, args));
}
function fork(fnDescriptor) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return makeEffect(FORK, getFnCallDescriptor(fnDescriptor, args));
}
function spawn(fnDescriptor) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    return detach(fork.apply(void 0, [
        fnDescriptor
    ].concat(args)));
}
function join(taskOrTasks) {
    return makeEffect(JOIN, taskOrTasks);
}
function cancel(taskOrTasks) {
    if (taskOrTasks === void 0) taskOrTasks = (0, _symbols.SELF_CANCELLATION);
    return makeEffect(CANCEL, taskOrTasks);
}
function select(selector) {
    if (selector === void 0) selector = identity;
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return makeEffect(SELECT, {
        selector: selector,
        args: args
    });
}
/**
  channel(pattern, [buffer])    => creates a proxy channel for store actions
**/ function actionChannel(pattern$1, buffer$1) {
    return makeEffect(ACTION_CHANNEL, {
        pattern: pattern$1,
        buffer: buffer$1
    });
}
function cancelled() {
    return makeEffect(CANCELLED, {});
}
function flush(channel$1) {
    return makeEffect(FLUSH, channel$1);
}
function getContext(prop) {
    return makeEffect(GET_CONTEXT, prop);
}
function setContext(props) {
    return makeEffect(SET_CONTEXT, props);
}
var delay = /*#__PURE__*/ call.bind(null, (0, _delayPDefault.default));

},{"@redux-saga/symbols":"9v4bk","@babel/runtime/helpers/esm/extends":"jGVGo","@redux-saga/is":"bCJA0","@redux-saga/delay-p":"6f1ut","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6f1ut":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _symbols = require("@redux-saga/symbols");
var MAX_SIGNED_INT = 2147483647;
function delayP(ms, val) {
    if (val === void 0) val = true;
    var timeoutId;
    var promise = new Promise(function(resolve) {
        timeoutId = setTimeout(resolve, Math.min(MAX_SIGNED_INT, ms), val);
    });
    promise[0, _symbols.CANCEL] = function() {
        clearTimeout(timeoutId);
    };
    return promise;
}
exports.default = delayP;

},{"@redux-saga/symbols":"9v4bk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"17Rmg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrayOfDeferred", ()=>arrayOfDeferred);
function deferred() {
    var def = {};
    def.promise = new Promise(function(resolve, reject) {
        def.resolve = resolve;
        def.reject = reject;
    });
    return def;
}
function arrayOfDeferred(length) {
    var arr = [];
    for(var i = 0; i < length; i++)arr.push(deferred());
    return arr;
}
exports.default = deferred;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ia9FV":[function(require,module,exports,__globalThis) {
/**
 * Combine all reducers in this file and export the combined reducers.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPersistedRootReducer", ()=>createPersistedRootReducer);
var _toolkit = require("@reduxjs/toolkit");
var _persist = require("app/state/persist");
var _slices = require("./slices");
function createRootReducer() {
    const reducers = Object.fromEntries(Object.entries((0, _slices.rootSlices)).map(([key, slice])=>[
            key,
            slice.reducer
        ]));
    const rootReducer = (0, _toolkit.combineReducers)(reducers);
    return rootReducer;
}
function createPersistedRootReducer() {
    const originalRootReducer = createRootReducer();
    return (state, action)=>{
        const newState = originalRootReducer(state, action);
        if ((0, _persist.persistActions).setUnlockedRootState.match(action)) return (0, _persist.receivePersistedRootState)(newState, action.payload.persistedRootState, action.payload.stringifiedEncryptionKey);
        if ((0, _persist.persistActions).resetRootState.match(action)) return originalRootReducer(undefined, action);
        return newState;
    };
}

},{"@reduxjs/toolkit":"9ol63","app/state/persist":"9hwZK","./slices":"8A4Y5","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9ol63":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReducerType", ()=>ReducerType);
parcelHelpers.export(exports, "SHOULD_AUTOBATCH", ()=>SHOULD_AUTOBATCH);
parcelHelpers.export(exports, "TaskAbortError", ()=>TaskAbortError);
parcelHelpers.export(exports, "Tuple", ()=>Tuple);
parcelHelpers.export(exports, "addListener", ()=>addListener);
parcelHelpers.export(exports, "asyncThunkCreator", ()=>asyncThunkCreator);
parcelHelpers.export(exports, "autoBatchEnhancer", ()=>autoBatchEnhancer);
parcelHelpers.export(exports, "buildCreateSlice", ()=>buildCreateSlice);
parcelHelpers.export(exports, "clearAllListeners", ()=>clearAllListeners);
parcelHelpers.export(exports, "combineSlices", ()=>combineSlices);
parcelHelpers.export(exports, "configureStore", ()=>configureStore);
parcelHelpers.export(exports, "createAction", ()=>createAction);
parcelHelpers.export(exports, "createActionCreatorInvariantMiddleware", ()=>createActionCreatorInvariantMiddleware);
parcelHelpers.export(exports, "createAsyncThunk", ()=>createAsyncThunk);
parcelHelpers.export(exports, "createDraftSafeSelector", ()=>createDraftSafeSelector);
parcelHelpers.export(exports, "createDraftSafeSelectorCreator", ()=>createDraftSafeSelectorCreator);
parcelHelpers.export(exports, "createDynamicMiddleware", ()=>createDynamicMiddleware);
parcelHelpers.export(exports, "createEntityAdapter", ()=>createEntityAdapter);
parcelHelpers.export(exports, "createImmutableStateInvariantMiddleware", ()=>createImmutableStateInvariantMiddleware);
parcelHelpers.export(exports, "createListenerMiddleware", ()=>createListenerMiddleware);
parcelHelpers.export(exports, "createNextState", ()=>(0, _immer.produce));
parcelHelpers.export(exports, "createReducer", ()=>createReducer);
parcelHelpers.export(exports, "createSelector", ()=>(0, _reselect.createSelector));
parcelHelpers.export(exports, "createSelectorCreator", ()=>(0, _reselect.createSelectorCreator));
parcelHelpers.export(exports, "createSerializableStateInvariantMiddleware", ()=>createSerializableStateInvariantMiddleware);
parcelHelpers.export(exports, "createSlice", ()=>createSlice);
parcelHelpers.export(exports, "current", ()=>(0, _immer.current));
parcelHelpers.export(exports, "findNonSerializableValue", ()=>findNonSerializableValue);
parcelHelpers.export(exports, "formatProdErrorMessage", ()=>formatProdErrorMessage);
parcelHelpers.export(exports, "freeze", ()=>(0, _immer.freeze));
parcelHelpers.export(exports, "isActionCreator", ()=>isActionCreator);
parcelHelpers.export(exports, "isAllOf", ()=>isAllOf);
parcelHelpers.export(exports, "isAnyOf", ()=>isAnyOf);
parcelHelpers.export(exports, "isAsyncThunkAction", ()=>isAsyncThunkAction);
parcelHelpers.export(exports, "isDraft", ()=>(0, _immer.isDraft));
parcelHelpers.export(exports, "isFluxStandardAction", ()=>isFSA);
parcelHelpers.export(exports, "isFulfilled", ()=>isFulfilled);
parcelHelpers.export(exports, "isImmutableDefault", ()=>isImmutableDefault);
parcelHelpers.export(exports, "isPending", ()=>isPending);
parcelHelpers.export(exports, "isPlain", ()=>isPlain);
parcelHelpers.export(exports, "isRejected", ()=>isRejected);
parcelHelpers.export(exports, "isRejectedWithValue", ()=>isRejectedWithValue);
parcelHelpers.export(exports, "lruMemoize", ()=>(0, _reselect.lruMemoize));
parcelHelpers.export(exports, "miniSerializeError", ()=>miniSerializeError);
parcelHelpers.export(exports, "nanoid", ()=>nanoid);
parcelHelpers.export(exports, "original", ()=>(0, _immer.original));
parcelHelpers.export(exports, "prepareAutoBatched", ()=>prepareAutoBatched);
parcelHelpers.export(exports, "removeListener", ()=>removeListener);
parcelHelpers.export(exports, "unwrapResult", ()=>unwrapResult);
parcelHelpers.export(exports, "weakMapMemoize", ()=>(0, _reselect.weakMapMemoize));
// src/index.ts
var _redux = require("redux");
parcelHelpers.exportAll(_redux, exports);
var _immer = require("immer");
var _reselect = require("reselect");
// src/getDefaultMiddleware.ts
var _reduxThunk = require("redux-thunk");
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var __publicField = (obj, key, value)=>__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var createDraftSafeSelectorCreator = (...args)=>{
    const createSelector2 = (0, _reselect.createSelectorCreator)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, _immer.isDraft)(value) ? (0, _immer.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var createDraftSafeSelector = /* @__PURE__ */ createDraftSafeSelectorCreator((0, _reselect.weakMapMemoize));
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, _redux.compose;
    return (0, _redux.compose).apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error(formatProdErrorMessage(0));
            return __spreadValues(__spreadValues({
                type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, _redux.isAction)(action) && action.type === type;
    return actionCreator;
}
function isActionCreator(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    hasMatchFunction(action);
}
function isFSA(action) {
    return (0, _redux.isAction)(action) && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function createActionCreatorInvariantMiddleware(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var Tuple = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function freezeDraftable(val) {
    return (0, _immer.isDraftable)(val) ? (0, _immer.produce)(val, ()=>{}) : val;
}
function getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function isImmutableDefault(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function createImmutableStateInvariantMiddleware(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function isPlain(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, _redux.isPlainObject)(val);
}
function findNonSerializableValue(value, path = "", isSerializable = isPlain, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && isNestedFrozen(value)) cache.add(value);
    return false;
}
function isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function createSerializableStateInvariantMiddleware(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
var buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk = true, immutableCheck = true, serializableCheck = true, actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new Tuple();
        if (thunk) {
            if (isBoolean(thunk)) middlewareArray.push((0, _reduxThunk.thunk));
            else middlewareArray.push((0, _reduxThunk.withExtraArgument)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var prepareAutoBatched = ()=>(payload)=>({
            payload,
            meta: {
                [SHOULD_AUTOBATCH]: true
            }
        });
var createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var autoBatchEnhancer = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[SHOULD_AUTOBATCH]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch = true } = options != null ? options : {};
        let enhancerArray = new Tuple(middlewareEnhancer);
        if (autoBatch) enhancerArray.push(autoBatchEnhancer(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function configureStore(options) {
    const getDefaultMiddleware = buildGetDefaultMiddleware();
    const { reducer, middleware, devTools = true, preloadedState, enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, _redux.isPlainObject)(reducer)) rootReducer = (0, _redux.combineReducers)(reducer);
    else throw new Error(formatProdErrorMessage(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    let finalCompose = (0, _redux.compose);
    if (devTools) finalCompose = composeWithDevTools(__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, _redux.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, _redux.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error(formatProdErrorMessage(28));
            if (type in actionsMap) throw new Error(formatProdErrorMessage(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher,
                reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
function createReducer(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if (isStateFunction(initialState)) getInitialState = ()=>freezeDraftable(initialState());
    else {
        const frozenInitialState = freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, _immer.isDraft)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, _immer.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, _immer.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var matches = (matcher, action)=>{
    if (hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function isAnyOf(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>matches(matcher, action));
    };
}
function isAllOf(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>matches(matcher, action));
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isPending()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function isRejected(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isRejected()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function isRejectedWithValue(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return isAllOf(isRejected(...asyncThunks), hasFlag);
    if (!isAsyncThunkArray(asyncThunks)) return isRejectedWithValue()(asyncThunks[0]);
    return isAllOf(isRejected(...asyncThunks), hasFlag);
}
function isFulfilled(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isFulfilled()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function isAsyncThunkAction(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isAsyncThunkAction()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ __publicField(this, "_type");
    }
};
var FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ __publicField(this, "_type");
    }
};
var miniSerializeError = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var externalAbortMessage = "External signal was aborted";
var createAsyncThunk = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = createAction(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload,
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg,
                    requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = createAction(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg,
                    requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = createAction(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload,
                error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg,
                    requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort(externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort(externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState,
                            extra
                        });
                        if (isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId,
                            arg
                        }, {
                            getState,
                            extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch,
                                getState,
                                extra,
                                requestId,
                                signal: abortController.signal,
                                abort,
                                rejectWithValue: (value, meta)=>{
                                    return new RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof RejectWithValue) throw result;
                                if (result instanceof FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort,
                    requestId,
                    arg,
                    unwrap () {
                        return promise.then(unwrapResult);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending,
            rejected,
            fulfilled,
            settled: isAnyOf(rejected, fulfilled),
            typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var asyncThunkCreator = {
    [asyncThunkSymbol]: createAsyncThunk
};
var ReducerType = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})(ReducerType || {});
function getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function buildCreateSlice({ creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[asyncThunkSymbol];
    return function createSlice2(options) {
        const { name, reducerPath = name } = options;
        if (!name) throw new Error(formatProdErrorMessage(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers(buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error(formatProdErrorMessage(12));
                if (type in context.sliceCaseReducersByType) throw new Error(formatProdErrorMessage(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName,
                type: getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if (isAsyncThunkSliceReducerDefinition(reducerDefinition)) handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return createReducer(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = wrapSelector(selector, selectState, getInitialState, injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice
            };
        }
        const slice = __spreadProps(__spreadValues({
            name,
            reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = __objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer
                }, config);
                return __spreadValues(__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var createSlice = /* @__PURE__ */ buildCreateSlice();
function buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return __spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare,
                reducer
            };
        },
        asyncThunk
    };
}
function handleNormalReducerDefinition({ type, reducerName, createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error(formatProdErrorMessage(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? createAction(type, prepareCallback) : createAction(type));
}
function isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function handleThunkCaseReducerDefinition({ type, reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error(formatProdErrorMessage(18));
    const { payloadCreator, fulfilled, pending, rejected, settled, options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || noop,
        pending: pending || noop,
        rejected: rejected || noop,
        settled: settled || noop
    });
}
function noop() {}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign(getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState
    };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = createDraftSafeSelector } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds,
            selectEntities,
            selectAll,
            selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors
    };
}
var isDraftTyped = (0, _immer.isDraft);
function createSingleArgumentStateOperator(mutator) {
    const operator = createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if (isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, _immer.produce)(state, runMutator);
    };
}
function selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function getCurrent(value) {
    return (0, _immer.isDraft)(value) ? (0, _immer.current)(value) : value;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    const existingIdsArray = getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = selectIdValue(entity, selectId);
        if (existingIds.has(id)) updated.push({
            id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: __spreadValues(__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function createSortedStateAdapter(selectId, comparer) {
    const { removeOne, removeMany, removeAll } = createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : getCurrent(state.ids));
        const models = newEntities.filter((model)=>!existingKeys.has(selectIdValue(model, selectId)));
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities)delete state.entities[selectId(item)];
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = splitAddedUpdatedEntities(newEntities, selectId, state);
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = getCurrent(state.entities);
        const currentIds = getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne,
        removeMany,
        removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options = {}) {
    const { selectId, sortComparer } = __spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    const stateFactory = createInitialStateFactory(stateAdapter);
    const selectorsFactory = createSelectorsFactory();
    return __spreadValues(__spreadValues(__spreadValues({
        selectId,
        sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = `task-${cancelled}`;
var taskCompleted = `task-${completed}`;
var listenerCancelled = `${listener}-${cancelled}`;
var listenerCompleted = `${listener}-${completed}`;
var TaskAbortError = class {
    constructor(code){
        this.code = code;
        __publicField(this, "name", "TaskAbortError");
        __publicField(this, "message");
        this.message = `${task} ${cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError(formatProdErrorMessage(32));
};
var noop2 = ()=>{};
var catchRejection = (promise, onError = noop2)=>{
    promise.catch(onError);
    return promise;
};
var addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason } = signal;
        throw new TaskAbortError(reason);
    }
};
function raceWithSignal(signal, promise) {
    let cleanup = noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new TaskAbortError(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = noop2;
    });
}
var runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value
        };
    } catch (error) {
        return {
            status: error instanceof TaskAbortError ? "cancelled" : "rejected",
            error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var createPause = (signal)=>{
    return (promise)=>{
        return catchRejection(raceWithSignal(signal, promise).then((output)=>{
            validateActive(signal);
            return output;
        }));
    };
};
var createDelay = (signal)=>{
    const pause = createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign } = Object;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>addAbortSignalListener(parentAbortSignal, ()=>abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = runTask(async ()=>{
            validateActive(parentAbortSignal);
            validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: createPause(childAbortController.signal),
                delay: createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            validateActive(childAbortController.signal);
            return result2;
        }, ()=>abortControllerWithReason(childAbortController, taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch(noop2));
        return {
            result: createPause(parentAbortSignal)(result),
            cancel () {
                abortControllerWithReason(childAbortController, taskCancelled);
            }
        };
    };
};
var createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await raceWithSignal(signal, Promise.race(promises));
            validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>catchRejection(take(predicate, timeout));
};
var getListenerEntryPropsFrom = (options)=>{
    let { type, actionCreator, matcher, predicate, effect } = options;
    if (type) predicate = createAction(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error(formatProdErrorMessage(21));
    assertFunction(effect, "options.listener");
    return {
        predicate,
        type,
        effect
    };
};
var createListenerEntry = /* @__PURE__ */ assign((options)=>{
    const { type, predicate, effect } = getListenerEntryPropsFrom(options);
    const entry = {
        id: nanoid(),
        effect,
        type,
        predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error(formatProdErrorMessage(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>createListenerEntry
});
var findListenerEntry = (listenerMap, options)=>{
    const { type, effect, predicate } = getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        abortControllerWithReason(controller, listenerCancelled);
    });
};
var createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach(cancelActiveListeners);
        listenerMap.clear();
    };
};
var safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var addListener = /* @__PURE__ */ assign(/* @__PURE__ */ createAction(`${alm}/add`), {
    withTypes: ()=>addListener
});
var clearAllListeners = /* @__PURE__ */ createAction(`${alm}/removeAll`);
var removeListener = /* @__PURE__ */ assign(/* @__PURE__ */ createAction(`${alm}/remove`), {
    withTypes: ()=>removeListener
});
var defaultErrorHandler = (...args)=>{
    console.error(`${alm}/error`, ...args);
};
var createListenerMiddleware = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra, onError = defaultErrorHandler } = middlewareOptions;
    assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = findListenerEntry(listenerMap, options)) != null ? _a : createListenerEntry(options);
        return insertEntry(entry);
    };
    assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) cancelActiveListeners(entry);
        }
        return !!entry;
    };
    assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            assign({}, api, {
                getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take,
                delay: createDelay(internalTaskController.signal),
                pause: createPause(internalTaskController.signal),
                extra,
                signal: internalTaskController.signal,
                fork: createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            abortControllerWithReason(controller, listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    abortControllerWithReason(internalTaskController, listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof TaskAbortError)) safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            abortControllerWithReason(internalTaskController, listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, _redux.isAction)(action)) return next(action);
                if (addListener.match(action)) return startListening(action.payload);
                if (clearAllListeners.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if (removeListener.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === INTERNAL_NIL_TOKEN) throw new Error(formatProdErrorMessage(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware,
        startListening,
        stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var createMiddlewareEntry = (middleware)=>({
        middleware,
        applied: /* @__PURE__ */ new Map()
    });
var matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var createDynamicMiddleware = ()=>{
    const instanceId = nanoid();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign(createAction("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            getOrInsertComputed(middlewareMap, middleware2, createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, _redux.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = isAllOf(withMiddleware, matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware,
        addMiddleware,
        withMiddleware,
        instanceId
    };
};
var isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var getReducers = (slices)=>slices.flatMap((sliceOrMap)=>isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var isStateProxy = (value)=>!!value && !!value[ORIGINAL_STATE];
var stateProxyMap = /* @__PURE__ */ new WeakMap();
var createStateProxy = (state, reducerMap)=>getOrInsertComputed(stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const reducer = reducerMap[prop.toString()];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: nanoid()
                        });
                        if (typeof reducerResult === "undefined") throw new Error(formatProdErrorMessage(24));
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var original = (state)=>{
    if (!isStateProxy(state)) throw new Error(formatProdErrorMessage(25));
    return state[ORIGINAL_STATE];
};
var noopReducer = (state = {})=>state;
function combineSlices(...slices) {
    const reducerMap = Object.fromEntries(getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, _redux.combineReducers)(reducerMap) : noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn(createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original
    });
    return Object.assign(combinedReducer, {
        inject,
        selector
    });
}
// src/formatProdErrorMessage.ts
function formatProdErrorMessage(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

},{"redux":"iJvJl","immer":"9YfgM","reselect":"2FB8p","redux-thunk":"cTzeJ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iJvJl":[function(require,module,exports,__globalThis) {
// src/utils/formatProdErrorMessage.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", ()=>actionTypes_default);
parcelHelpers.export(exports, "applyMiddleware", ()=>applyMiddleware);
parcelHelpers.export(exports, "bindActionCreators", ()=>bindActionCreators);
parcelHelpers.export(exports, "combineReducers", ()=>combineReducers);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "isAction", ()=>isAction);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "legacy_createStore", ()=>legacy_createStore);
function formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;
// src/utils/actionTypes.ts
var randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
    INIT: `@@redux/INIT${randomString()}`,
    REPLACE: `@@redux/REPLACE${randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;
// src/utils/isPlainObject.ts
function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if (isDate(val)) return "date";
    if (isError(val)) return "error";
    const constructorName = ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function createStore(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error(formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error(formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error(formatProdErrorMessage(1));
        return enhancer(createStore)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error(formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error(formatProdErrorMessage(4));
        if (isDispatching) throw new Error(formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error(formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error(formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error(formatProdErrorMessage(17));
        if (isDispatching) throw new Error(formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error(formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: actionTypes_default.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error(formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe
                };
            },
            [symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: actionTypes_default.INIT
    });
    const store = {
        dispatch,
        subscribe,
        getState,
        replaceReducer,
        [symbol_observable_default]: observable
    };
    return store;
}
function legacy_createStore(reducer, preloadedState, enhancer) {
    return createStore(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === actionTypes_default.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return `The ${argumentName} has unexpected type of "${kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === actionTypes_default.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: actionTypes_default.INIT
        });
        if (typeof initialState === "undefined") throw new Error(formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: actionTypes_default.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error(formatProdErrorMessage(13));
    });
}
function combineReducers(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error(formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error(formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function compose(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function applyMiddleware(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error(formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = compose(...chain)(store.dispatch);
            return {
                ...store,
                dispatch
            };
        };
}
// src/utils/isAction.ts
function isAction(action) {
    return isPlainObject(action) && "type" in action && typeof action.type === "string";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9YfgM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immer", ()=>Immer2);
parcelHelpers.export(exports, "applyPatches", ()=>applyPatches);
parcelHelpers.export(exports, "castDraft", ()=>castDraft);
parcelHelpers.export(exports, "castImmutable", ()=>castImmutable);
parcelHelpers.export(exports, "createDraft", ()=>createDraft);
parcelHelpers.export(exports, "current", ()=>current);
parcelHelpers.export(exports, "enableMapSet", ()=>enableMapSet);
parcelHelpers.export(exports, "enablePatches", ()=>enablePatches);
parcelHelpers.export(exports, "finishDraft", ()=>finishDraft);
parcelHelpers.export(exports, "freeze", ()=>freeze);
parcelHelpers.export(exports, "immerable", ()=>DRAFTABLE);
parcelHelpers.export(exports, "isDraft", ()=>isDraft);
parcelHelpers.export(exports, "isDraftable", ()=>isDraftable);
parcelHelpers.export(exports, "nothing", ()=>NOTHING);
parcelHelpers.export(exports, "original", ()=>original);
parcelHelpers.export(exports, "produce", ()=>produce);
parcelHelpers.export(exports, "produceWithPatches", ()=>produceWithPatches);
parcelHelpers.export(exports, "setAutoFreeze", ()=>setAutoFreeze);
parcelHelpers.export(exports, "setUseStrictShallowCopy", ()=>setUseStrictShallowCopy);
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    if (getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach((key)=>{
        iter(key, obj[key], obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function getArchtype(thing) {
    const state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    const t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create(getPrototypeOf(base), descriptors);
    } else {
        const proto = getPrototypeOf(base);
        if (proto !== null && isPlain) return __spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function freeze(obj, deep = false) {
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(([key, value])=>freeze(value, true));
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
function isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    const plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_,
        immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    const state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    const state = value[DRAFT_STATE];
    if (!state) {
        each(value, (key, childValue)=>finalizeProperty(rootScope, state, value, key, childValue, path));
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, (key, childValue)=>finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (isDraft(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    const { revoke, proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get (state, prop) {
        if (prop === DRAFT_STATE) return state;
        const source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys(latest(state));
    },
    set (state, prop, value) {
        const desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = peek(latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        die(11);
    },
    getPrototypeOf (state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, (key, fn)=>{
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    const state = draft[DRAFT_STATE];
    const source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    const desc = getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            let result;
            if (isDraftable(base)) {
                const scope = enterScope(this);
                const proxy = createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!isDraftable(base)) die(8);
        if (isDraft(base)) base = current(base);
        const scope = enterScope(this);
        const proxy = createProxy(base, void 0);
        proxy[DRAFT_STATE].isManual_ = true;
        leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[DRAFT_STATE];
        if (!state || !state.isManual_) die(9);
        const { scope_: scope } = state;
        usePatchesInScope(scope, patchListener);
        return processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = getPlugin("Patches").applyPatches_;
        if (isDraft(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function createProxy(value, parent) {
    const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    const state = value[DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = shallowCopy(value, true);
    each(copy, (key, childValue)=>{
        set(copy, key, currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_, assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_, copy_ } = state;
        each(state.assigned_, (key, assignedValue)=>{
            const origValue = get(base_, key);
            const value = get(copy_, key);
            const op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op,
                path
            } : {
                op,
                path,
                value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path
            } : op === REMOVE ? {
                op: ADD,
                path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_, copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path,
                    value
                });
                inversePatches.unshift({
                    op: ADD,
                    path,
                    value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path,
                    value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path,
                    value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path, op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if (typeof base !== "object") die(errorOffset + 2, path.join("/"));
            }
            const type = getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create(getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_,
        generatePatches_,
        generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return latest(this[DRAFT_STATE]).size;
        }
        has(key) {
            return latest(this[DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!latest(state).has(key) || latest(state).get(key) !== value) {
                prepareMapCopy(state);
                markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (latest(state).size) {
                prepareMapCopy(state);
                markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[DRAFT_STATE];
            latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            const value = latest(state).get(key);
            if (state.finalized_ || !isDraftable(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return latest(this[DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [(DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return latest(this[DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (latest(state).size) {
                prepareSetCopy(state);
                markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [(DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if (isDraftable(value)) {
                    const draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_,
        proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2FB8p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSelector", ()=>createSelector);
parcelHelpers.export(exports, "createSelectorCreator", ()=>createSelectorCreator);
parcelHelpers.export(exports, "createStructuredSelector", ()=>createStructuredSelector);
parcelHelpers.export(exports, "lruMemoize", ()=>lruMemoize);
parcelHelpers.export(exports, "referenceEqualityCheck", ()=>referenceEqualityCheck);
parcelHelpers.export(exports, "setGlobalDevModeChecks", ()=>setGlobalDevModeChecks);
parcelHelpers.export(exports, "unstable_autotrackMemoize", ()=>autotrackMemoize);
parcelHelpers.export(exports, "weakMapMemoize", ()=>weakMapMemoize);
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __publicField = (obj, key, value)=>{
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize, memoizeOptions } = options;
    const { inputSelectorResults, inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var setGlobalDevModeChecks = (devModeChecks)=>{
    Object.assign(globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck, inputStabilityCheck } = __spreadValues(__spreadValues({}, globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $REVISION = 0;
var CURRENT_TRACKER = null;
var Cell = class {
    constructor(initialValue, isEqual = tripleEq){
        __publicField(this, "revision", $REVISION);
        __publicField(this, "_value");
        __publicField(this, "_lastValue");
        __publicField(this, "_isEqual", tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        CURRENT_TRACKER == null || CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$REVISION;
    }
};
function tripleEq(a, b) {
    return a === b;
}
var TrackingCache = class {
    constructor(fn){
        __publicField(this, "_cachedValue");
        __publicField(this, "_cachedRevision", -1);
        __publicField(this, "_deps", []);
        __publicField(this, "hits", 0);
        __publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = CURRENT_TRACKER;
            CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        CURRENT_TRACKER == null || CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function getValue(cell) {
    if (!(cell instanceof Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function setValue(storage, value) {
    if (!(storage instanceof Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function createCell(initialValue, isEqual = tripleEq) {
    return new Cell(initialValue, isEqual);
}
function createCache(fn) {
    assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var neverEq = (a, b)=>false;
function createTag() {
    return createCell(null, neverEq);
}
function dirtyTag(tag, value) {
    setValue(tag, value);
}
var consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = createTag();
    getValue(tag);
};
var dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var REDUX_PROXY_LABEL = Symbol();
var nextId = 0;
var proto = Object.getPrototypeOf({});
var ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        __publicField(this, "proxy", new Proxy(this, objectProxyHandler));
        __publicField(this, "tag", createTag());
        __publicField(this, "tags", {});
        __publicField(this, "children", {});
        __publicField(this, "collectionTag", null);
        __publicField(this, "id", nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = createNode(childValue);
                if (childNode.tag) getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = createTag();
                    tag.value = childValue;
                }
                getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        __publicField(this, "proxy", new Proxy([
            this
        ], arrayProxyHandler));
        __publicField(this, "tag", createTag());
        __publicField(this, "tags", {});
        __publicField(this, "children", {});
        __publicField(this, "collectionTag", null);
        __publicField(this, "id", nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") consumeCollection(node);
        return objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return objectProxyHandler.has(node, prop);
    }
};
function createNode(value) {
    if (Array.isArray(value)) return new ArrayTreeNode(value);
    return new ObjectTreeNode(value);
}
function updateNode(node, newValue) {
    const { value, tags, children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            dirtyCollection(node);
            dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) updateNode(childNode, newChildValue);
        else {
            deleteNode(childNode);
            delete children[key];
        }
    }
}
function deleteNode(node) {
    if (node.tag) dirtyTag(node.tag, null);
    dirtyCollection(node);
    for(const key in node.tags)dirtyTag(node.tags[key], null);
    for(const key in node.children)deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key,
                value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === NOT_FOUND) {
            entries.unshift({
                key,
                value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get,
        put,
        getEntries,
        clear
    };
}
var referenceEqualityCheck = (a, b)=>a === b;
function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function lruMemoize(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck = referenceEqualityCheck, maxSize = 1, resultEqualityCheck } = providedOptions;
    const comparator = createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function autotrackMemoize(func) {
    const node = createNode([]);
    let lastArgs = null;
    const shallowEqual = createCacheKeyComparator(referenceEqualityCheck);
    const cache = createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var Ref = typeof WeakRef !== "undefined" ? WeakRef : StrongRef;
var UNTERMINATED = 0;
var TERMINATED = 1;
function createCacheNode() {
    return {
        s: UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function weakMapMemoize(func, options = {}) {
    let fnNode = createCacheNode();
    const { resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new Ref(result) : result;
            }
        }
        terminatedNode.s = TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function createSelectorCreator(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = __spreadValues(__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize, memoizeOptions = [], argsMemoize = weakMapMemoize, argsMemoizeOptions = [], devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = ensureIsArray(argsMemoizeOptions);
        const dependencies = getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc,
            memoizedResultFunc,
            dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize,
            argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(weakMapMemoize);
// src/createStructuredSelector.ts
var createStructuredSelector = Object.assign((inputSelectorsObject, selectorCreator = createSelector)=>{
    assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>createStructuredSelector
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cTzeJ":[function(require,module,exports,__globalThis) {
// src/index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "thunk", ()=>thunk);
parcelHelpers.export(exports, "withExtraArgument", ()=>withExtraArgument);
function createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch, getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9hwZK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STORAGE_FIELD", ()=>STORAGE_FIELD);
parcelHelpers.export(exports, "needsSyncingTabs", ()=>needsSyncingTabs);
parcelHelpers.export(exports, "isSyncingTabsSupported", ()=>isSyncingTabsSupported);
parcelHelpers.export(exports, "getInitialState", ()=>getInitialState);
parcelHelpers.export(exports, "persistSlice", ()=>persistSlice);
parcelHelpers.export(exports, "persistActions", ()=>persistActions);
/**
 * When persisted state is unlocked use these state slices.
 */ parcelHelpers.export(exports, "receivePersistedRootState", ()=>receivePersistedRootState);
var _toolkit = require("utils/@reduxjs/toolkit");
var _runtimeIs = require("app/lib/runtimeIs");
const STORAGE_FIELD = 'oasis_wallet_persist_v1';
const needsSyncingTabs = (0, _runtimeIs.runtimeIs) === 'webapp';
const isSyncingTabsSupported = typeof BroadcastChannel === 'function';
function getInitialState() {
    return {
        hasPersistedProfiles: !!window.localStorage.getItem(STORAGE_FIELD),
        hasV0StorageToMigrate: false,
        // Disable persistence if tabs would override each other.
        isPersistenceUnsupported: needsSyncingTabs && !isSyncingTabsSupported,
        loading: false,
        stringifiedEncryptionKey: localStorage.getItem(STORAGE_FIELD) ? undefined : 'skipped',
        enteredWrongPassword: false
    };
}
const persistSlice = (0, _toolkit.createSlice)({
    name: 'persist',
    initialState: ()=>getInitialState(),
    reducers: {
        setWrongPassword (state) {
            state.enteredWrongPassword = true;
            state.loading = false;
        },
        resetWrongPassword (state) {
            state.enteredWrongPassword = false;
        },
        setUnlockedRootState (state, action) {
            /**
       * Handled in {@link createPersistedRootReducer} and {@link receivePersistedRootState}.
       * Sets `state.loading = false` and `state.stringifiedEncryptionKey`.
       */ return;
        },
        resetRootState (state) {
            /**
       * Handled in {@link createPersistedRootReducer}.
       * Sets `state.loading = false`.
       */ return;
        },
        skipUnlocking (state) {
            state.stringifiedEncryptionKey = 'skipped';
        },
        setHasV0StorageToMigrate (state, action) {
            state.hasV0StorageToMigrate = action.payload;
        },
        // Handled in saga
        // ---------------
        /**
     * Set a password to encrypt state with and begin storing it to localStorage.
     */ setPasswordAsync (state, action) {
            state.loading = true;
        },
        /**
     * Load encrypted state from localStorage and decrypt, or set {@link PersistState.enteredWrongPassword}.
     */ unlockAsync (state, action) {
            state.loading = true;
        },
        /**
     * Remove everything from state, especially {@link PersistState.stringifiedEncryptionKey}.
     * UnlockGate should stop any components relying on missing state.
     */ lockAsync (state) {
            state.loading = true;
        },
        /**
     * Remove encrypted state from localStorage and reload.
     */ deleteProfileAsync (state) {
            state.loading = true;
        },
        updatePasswordAsync (state, action) {
            return;
        },
        finishV0Migration (state, action) {
            return;
        }
    }
});
const persistActions = persistSlice.actions;
function receivePersistedRootState(prevState, persistedRootState, stringifiedEncryptionKey) {
    return {
        // Explicitly list every field instead of `...prevState` to force developers
        // to consider if their new slice should be persisted.
        account: prevState.account,
        createWallet: prevState.createWallet,
        fatalError: prevState.fatalError,
        importAccounts: prevState.importAccounts,
        paraTimes: prevState.paraTimes,
        staking: prevState.staking,
        transaction: prevState.transaction,
        contacts: persistedRootState.contacts,
        evmAccounts: persistedRootState.evmAccounts,
        settings: persistedRootState.settings,
        theme: persistedRootState.theme,
        wallet: persistedRootState.wallet,
        network: persistedRootState.network,
        persist: {
            ...getInitialState(),
            stringifiedEncryptionKey: stringifiedEncryptionKey
        }
    };
}

},{"utils/@reduxjs/toolkit":"2wpnD","app/lib/runtimeIs":"fboJV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2wpnD":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line no-restricted-imports
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSlice", ()=>createSlice);
var _toolkit = require("@reduxjs/toolkit");
const createSlice = (options)=>{
    return (0, _toolkit.createSlice)(options);
};

},{"@reduxjs/toolkit":"9ol63","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fboJV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "runtimeIs", ()=>runtimeIs);
var _core = require("@capacitor/core");
const runtimeIs = (0, _core.Capacitor).isNativePlatform() ? 'mobile-app' : globalThis.chrome?.runtime?.id ? 'extension' : 'webapp';

},{"@capacitor/core":"9nVQl","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9nVQl":[function(require,module,exports,__globalThis) {
/*! Capacitor: https://capacitorjs.com/ - MIT License */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/******** END SYSTEM BARS PLUGIN ********/ parcelHelpers.export(exports, "Capacitor", ()=>Capacitor);
parcelHelpers.export(exports, "CapacitorCookies", ()=>CapacitorCookies);
parcelHelpers.export(exports, "CapacitorException", ()=>CapacitorException);
parcelHelpers.export(exports, "CapacitorHttp", ()=>CapacitorHttp);
parcelHelpers.export(exports, "ExceptionCode", ()=>ExceptionCode);
parcelHelpers.export(exports, "SystemBarType", ()=>SystemBarType);
parcelHelpers.export(exports, "SystemBars", ()=>SystemBars);
parcelHelpers.export(exports, "SystemBarsStyle", ()=>SystemBarsStyle);
parcelHelpers.export(exports, "WebPlugin", ()=>WebPlugin);
parcelHelpers.export(exports, "WebView", ()=>WebView);
parcelHelpers.export(exports, "buildRequestInit", ()=>buildRequestInit);
parcelHelpers.export(exports, "registerPlugin", ()=>registerPlugin);
var global = arguments[3];
var ExceptionCode;
(function(ExceptionCode) {
    /**
     * API is not implemented.
     *
     * This usually means the API can't be used because it is not implemented for
     * the current platform.
     */ ExceptionCode["Unimplemented"] = "UNIMPLEMENTED";
    /**
     * API is not available.
     *
     * This means the API can't be used right now because:
     *   - it is currently missing a prerequisite, such as network connectivity
     *   - it requires a particular platform or browser version
     */ ExceptionCode["Unavailable"] = "UNAVAILABLE";
})(ExceptionCode || (ExceptionCode = {}));
class CapacitorException extends Error {
    constructor(message, code, data){
        super(message);
        this.message = message;
        this.code = code;
        this.data = data;
    }
}
const getPlatformId = (win)=>{
    var _a, _b;
    if (win === null || win === void 0 ? void 0 : win.androidBridge) return 'android';
    else if ((_b = (_a = win === null || win === void 0 ? void 0 : win.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.bridge) return 'ios';
    else return 'web';
};
const createCapacitor = (win)=>{
    const capCustomPlatform = win.CapacitorCustomPlatform || null;
    const cap = win.Capacitor || {};
    const Plugins = cap.Plugins = cap.Plugins || {};
    const getPlatform = ()=>{
        return capCustomPlatform !== null ? capCustomPlatform.name : getPlatformId(win);
    };
    const isNativePlatform = ()=>getPlatform() !== 'web';
    const isPluginAvailable = (pluginName)=>{
        const plugin = registeredPlugins.get(pluginName);
        if (plugin === null || plugin === void 0 ? void 0 : plugin.platforms.has(getPlatform())) // JS implementation available for the current platform.
        return true;
        if (getPluginHeader(pluginName)) // Native implementation available.
        return true;
        return false;
    };
    const getPluginHeader = (pluginName)=>{
        var _a;
        return (_a = cap.PluginHeaders) === null || _a === void 0 ? void 0 : _a.find((h)=>h.name === pluginName);
    };
    const handleError = (err)=>win.console.error(err);
    const registeredPlugins = new Map();
    const registerPlugin = (pluginName, jsImplementations = {})=>{
        const registeredPlugin = registeredPlugins.get(pluginName);
        if (registeredPlugin) {
            console.warn(`Capacitor plugin "${pluginName}" already registered. Cannot register plugins twice.`);
            return registeredPlugin.proxy;
        }
        const platform = getPlatform();
        const pluginHeader = getPluginHeader(pluginName);
        let jsImplementation;
        const loadPluginImplementation = async ()=>{
            if (!jsImplementation && platform in jsImplementations) jsImplementation = typeof jsImplementations[platform] === 'function' ? jsImplementation = await jsImplementations[platform]() : jsImplementation = jsImplementations[platform];
            else if (capCustomPlatform !== null && !jsImplementation && 'web' in jsImplementations) jsImplementation = typeof jsImplementations['web'] === 'function' ? jsImplementation = await jsImplementations['web']() : jsImplementation = jsImplementations['web'];
            return jsImplementation;
        };
        const createPluginMethod = (impl, prop)=>{
            var _a, _b;
            if (pluginHeader) {
                const methodHeader = pluginHeader === null || pluginHeader === void 0 ? void 0 : pluginHeader.methods.find((m)=>prop === m.name);
                if (methodHeader) {
                    if (methodHeader.rtype === 'promise') return (options)=>cap.nativePromise(pluginName, prop.toString(), options);
                    else return (options, callback)=>cap.nativeCallback(pluginName, prop.toString(), options, callback);
                } else if (impl) return (_a = impl[prop]) === null || _a === void 0 ? void 0 : _a.bind(impl);
            } else if (impl) return (_b = impl[prop]) === null || _b === void 0 ? void 0 : _b.bind(impl);
            else throw new CapacitorException(`"${pluginName}" plugin is not implemented on ${platform}`, ExceptionCode.Unimplemented);
        };
        const createPluginMethodWrapper = (prop)=>{
            let remove;
            const wrapper = (...args)=>{
                const p = loadPluginImplementation().then((impl)=>{
                    const fn = createPluginMethod(impl, prop);
                    if (fn) {
                        const p = fn(...args);
                        remove = p === null || p === void 0 ? void 0 : p.remove;
                        return p;
                    } else throw new CapacitorException(`"${pluginName}.${prop}()" is not implemented on ${platform}`, ExceptionCode.Unimplemented);
                });
                if (prop === 'addListener') p.remove = async ()=>remove();
                return p;
            };
            // Some flair ✨
            wrapper.toString = ()=>`${prop.toString()}() { [capacitor code] }`;
            Object.defineProperty(wrapper, 'name', {
                value: prop,
                writable: false,
                configurable: false
            });
            return wrapper;
        };
        const addListener = createPluginMethodWrapper('addListener');
        const removeListener = createPluginMethodWrapper('removeListener');
        const addListenerNative = (eventName, callback)=>{
            const call = addListener({
                eventName
            }, callback);
            const remove = async ()=>{
                const callbackId = await call;
                removeListener({
                    eventName,
                    callbackId
                }, callback);
            };
            const p = new Promise((resolve)=>call.then(()=>resolve({
                        remove
                    })));
            p.remove = async ()=>{
                console.warn(`Using addListener() without 'await' is deprecated.`);
                await remove();
            };
            return p;
        };
        const proxy = new Proxy({}, {
            get (_, prop) {
                switch(prop){
                    // https://github.com/facebook/react/issues/20030
                    case '$$typeof':
                        return undefined;
                    case 'toJSON':
                        return ()=>({});
                    case 'addListener':
                        return pluginHeader ? addListenerNative : addListener;
                    case 'removeListener':
                        return removeListener;
                    default:
                        return createPluginMethodWrapper(prop);
                }
            }
        });
        Plugins[pluginName] = proxy;
        registeredPlugins.set(pluginName, {
            name: pluginName,
            proxy,
            platforms: new Set([
                ...Object.keys(jsImplementations),
                ...pluginHeader ? [
                    platform
                ] : []
            ])
        });
        return proxy;
    };
    // Add in convertFileSrc for web, it will already be available in native context
    if (!cap.convertFileSrc) cap.convertFileSrc = (filePath)=>filePath;
    cap.getPlatform = getPlatform;
    cap.handleError = handleError;
    cap.isNativePlatform = isNativePlatform;
    cap.isPluginAvailable = isPluginAvailable;
    cap.registerPlugin = registerPlugin;
    cap.Exception = CapacitorException;
    cap.DEBUG = !!cap.DEBUG;
    cap.isLoggingEnabled = !!cap.isLoggingEnabled;
    return cap;
};
const initCapacitorGlobal = (win)=>win.Capacitor = createCapacitor(win);
const Capacitor = /*#__PURE__*/ initCapacitorGlobal(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {});
const registerPlugin = Capacitor.registerPlugin;
/**
 * Base class web plugins should extend.
 */ class WebPlugin {
    constructor(){
        this.listeners = {};
        this.retainedEventArguments = {};
        this.windowListeners = {};
    }
    addListener(eventName, listenerFunc) {
        let firstListener = false;
        const listeners = this.listeners[eventName];
        if (!listeners) {
            this.listeners[eventName] = [];
            firstListener = true;
        }
        this.listeners[eventName].push(listenerFunc);
        // If we haven't added a window listener for this event and it requires one,
        // go ahead and add it
        const windowListener = this.windowListeners[eventName];
        if (windowListener && !windowListener.registered) this.addWindowListener(windowListener);
        if (firstListener) this.sendRetainedArgumentsForEvent(eventName);
        const remove = async ()=>this.removeListener(eventName, listenerFunc);
        const p = Promise.resolve({
            remove
        });
        return p;
    }
    async removeAllListeners() {
        this.listeners = {};
        for(const listener in this.windowListeners)this.removeWindowListener(this.windowListeners[listener]);
        this.windowListeners = {};
    }
    notifyListeners(eventName, data, retainUntilConsumed) {
        const listeners = this.listeners[eventName];
        if (!listeners) {
            if (retainUntilConsumed) {
                let args = this.retainedEventArguments[eventName];
                if (!args) args = [];
                args.push(data);
                this.retainedEventArguments[eventName] = args;
            }
            return;
        }
        listeners.forEach((listener)=>listener(data));
    }
    hasListeners(eventName) {
        var _a;
        return !!((_a = this.listeners[eventName]) === null || _a === void 0 ? void 0 : _a.length);
    }
    registerWindowListener(windowEventName, pluginEventName) {
        this.windowListeners[pluginEventName] = {
            registered: false,
            windowEventName,
            pluginEventName,
            handler: (event)=>{
                this.notifyListeners(pluginEventName, event);
            }
        };
    }
    unimplemented(msg = 'not implemented') {
        return new Capacitor.Exception(msg, ExceptionCode.Unimplemented);
    }
    unavailable(msg = 'not available') {
        return new Capacitor.Exception(msg, ExceptionCode.Unavailable);
    }
    async removeListener(eventName, listenerFunc) {
        const listeners = this.listeners[eventName];
        if (!listeners) return;
        const index = listeners.indexOf(listenerFunc);
        this.listeners[eventName].splice(index, 1);
        // If there are no more listeners for this type of event,
        // remove the window listener
        if (!this.listeners[eventName].length) this.removeWindowListener(this.windowListeners[eventName]);
    }
    addWindowListener(handle) {
        window.addEventListener(handle.windowEventName, handle.handler);
        handle.registered = true;
    }
    removeWindowListener(handle) {
        if (!handle) return;
        window.removeEventListener(handle.windowEventName, handle.handler);
        handle.registered = false;
    }
    sendRetainedArgumentsForEvent(eventName) {
        const args = this.retainedEventArguments[eventName];
        if (!args) return;
        delete this.retainedEventArguments[eventName];
        args.forEach((arg)=>{
            this.notifyListeners(eventName, arg);
        });
    }
}
const WebView = /*#__PURE__*/ registerPlugin('WebView');
/******** END WEB VIEW PLUGIN ********/ /******** COOKIES PLUGIN ********/ /**
 * Safely web encode a string value (inspired by js-cookie)
 * @param str The string value to encode
 */ const encode = (str)=>encodeURIComponent(str).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
/**
 * Safely web decode a string value (inspired by js-cookie)
 * @param str The string value to decode
 */ const decode = (str)=>str.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
class CapacitorCookiesPluginWeb extends WebPlugin {
    async getCookies() {
        const cookies = document.cookie;
        const cookieMap = {};
        cookies.split(';').forEach((cookie)=>{
            if (cookie.length <= 0) return;
            // Replace first "=" with CAP_COOKIE to prevent splitting on additional "="
            let [key, value] = cookie.replace(/=/, 'CAP_COOKIE').split('CAP_COOKIE');
            key = decode(key).trim();
            value = decode(value).trim();
            cookieMap[key] = value;
        });
        return cookieMap;
    }
    async setCookie(options) {
        try {
            // Safely Encoded Key/Value
            const encodedKey = encode(options.key);
            const encodedValue = encode(options.value);
            // Clean & sanitize options
            const expires = `; expires=${(options.expires || '').replace('expires=', '')}`; // Default is "; expires="
            const path = (options.path || '/').replace('path=', ''); // Default is "path=/"
            const domain = options.url != null && options.url.length > 0 ? `domain=${options.url}` : '';
            document.cookie = `${encodedKey}=${encodedValue || ''}${expires}; path=${path}; ${domain};`;
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async deleteCookie(options) {
        try {
            document.cookie = `${options.key}=; Max-Age=0`;
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async clearCookies() {
        try {
            const cookies = document.cookie.split(';') || [];
            for (const cookie of cookies)document.cookie = cookie.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        } catch (error) {
            return Promise.reject(error);
        }
    }
    async clearAllCookies() {
        try {
            await this.clearCookies();
        } catch (error) {
            return Promise.reject(error);
        }
    }
}
const CapacitorCookies = registerPlugin('CapacitorCookies', {
    web: ()=>new CapacitorCookiesPluginWeb()
});
// UTILITY FUNCTIONS
/**
 * Read in a Blob value and return it as a base64 string
 * @param blob The blob value to convert to a base64 string
 */ const readBlobAsBase64 = async (blob)=>new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>{
            const base64String = reader.result;
            // remove prefix "data:application/pdf;base64,"
            resolve(base64String.indexOf(',') >= 0 ? base64String.split(',')[1] : base64String);
        };
        reader.onerror = (error)=>reject(error);
        reader.readAsDataURL(blob);
    });
/**
 * Normalize an HttpHeaders map by lowercasing all of the values
 * @param headers The HttpHeaders object to normalize
 */ const normalizeHttpHeaders = (headers = {})=>{
    const originalKeys = Object.keys(headers);
    const loweredKeys = Object.keys(headers).map((k)=>k.toLocaleLowerCase());
    const normalized = loweredKeys.reduce((acc, key, index)=>{
        acc[key] = headers[originalKeys[index]];
        return acc;
    }, {});
    return normalized;
};
/**
 * Builds a string of url parameters that
 * @param params A map of url parameters
 * @param shouldEncode true if you should encodeURIComponent() the values (true by default)
 */ const buildUrlParams = (params, shouldEncode = true)=>{
    if (!params) return null;
    const output = Object.entries(params).reduce((accumulator, entry)=>{
        const [key, value] = entry;
        let encodedValue;
        let item;
        if (Array.isArray(value)) {
            item = '';
            value.forEach((str)=>{
                encodedValue = shouldEncode ? encodeURIComponent(str) : str;
                item += `${key}=${encodedValue}&`;
            });
            // last character will always be "&" so slice it off
            item.slice(0, -1);
        } else {
            encodedValue = shouldEncode ? encodeURIComponent(value) : value;
            item = `${key}=${encodedValue}`;
        }
        return `${accumulator}&${item}`;
    }, '');
    // Remove initial "&" from the reduce
    return output.substr(1);
};
/**
 * Build the RequestInit object based on the options passed into the initial request
 * @param options The Http plugin options
 * @param extra Any extra RequestInit values
 */ const buildRequestInit = (options, extra = {})=>{
    const output = Object.assign({
        method: options.method || 'GET',
        headers: options.headers
    }, extra);
    // Get the content-type
    const headers = normalizeHttpHeaders(options.headers);
    const type = headers['content-type'] || '';
    // If body is already a string, then pass it through as-is.
    if (typeof options.data === 'string') output.body = options.data;
    else if (type.includes('application/x-www-form-urlencoded')) {
        const params = new URLSearchParams();
        for (const [key, value] of Object.entries(options.data || {}))params.set(key, value);
        output.body = params.toString();
    } else if (type.includes('multipart/form-data') || options.data instanceof FormData) {
        const form = new FormData();
        if (options.data instanceof FormData) options.data.forEach((value, key)=>{
            form.append(key, value);
        });
        else for (const key of Object.keys(options.data))form.append(key, options.data[key]);
        output.body = form;
        const headers = new Headers(output.headers);
        headers.delete('content-type'); // content-type will be set by `window.fetch` to includy boundary
        output.headers = headers;
    } else if (type.includes('application/json') || typeof options.data === 'object') output.body = JSON.stringify(options.data);
    return output;
};
// WEB IMPLEMENTATION
class CapacitorHttpPluginWeb extends WebPlugin {
    /**
     * Perform an Http request given a set of options
     * @param options Options to build the HTTP request
     */ async request(options) {
        const requestInit = buildRequestInit(options, options.webFetchExtra);
        const urlParams = buildUrlParams(options.params, options.shouldEncodeUrlParams);
        const url = urlParams ? `${options.url}?${urlParams}` : options.url;
        const response = await fetch(url, requestInit);
        const contentType = response.headers.get('content-type') || '';
        // Default to 'text' responseType so no parsing happens
        let { responseType = 'text' } = response.ok ? options : {};
        // If the response content-type is json, force the response to be json
        if (contentType.includes('application/json')) responseType = 'json';
        let data;
        let blob;
        switch(responseType){
            case 'arraybuffer':
            case 'blob':
                blob = await response.blob();
                data = await readBlobAsBase64(blob);
                break;
            case 'json':
                data = await response.json();
                break;
            case 'document':
            case 'text':
            default:
                data = await response.text();
        }
        // Convert fetch headers to Capacitor HttpHeaders
        const headers = {};
        response.headers.forEach((value, key)=>{
            headers[key] = value;
        });
        return {
            data,
            headers,
            status: response.status,
            url: response.url
        };
    }
    /**
     * Perform an Http GET request given a set of options
     * @param options Options to build the HTTP request
     */ async get(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'GET'
        }));
    }
    /**
     * Perform an Http POST request given a set of options
     * @param options Options to build the HTTP request
     */ async post(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'POST'
        }));
    }
    /**
     * Perform an Http PUT request given a set of options
     * @param options Options to build the HTTP request
     */ async put(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'PUT'
        }));
    }
    /**
     * Perform an Http PATCH request given a set of options
     * @param options Options to build the HTTP request
     */ async patch(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'PATCH'
        }));
    }
    /**
     * Perform an Http DELETE request given a set of options
     * @param options Options to build the HTTP request
     */ async delete(options) {
        return this.request(Object.assign(Object.assign({}, options), {
            method: 'DELETE'
        }));
    }
}
const CapacitorHttp = registerPlugin('CapacitorHttp', {
    web: ()=>new CapacitorHttpPluginWeb()
});
/******** END HTTP PLUGIN ********/ /******** SYSTEM BARS PLUGIN ********/ /**
 * Available status bar styles.
 */ var SystemBarsStyle;
(function(SystemBarsStyle) {
    /**
     * Light system bar content on a dark background.
     *
     * @since 8.0.0
     */ SystemBarsStyle["Dark"] = "DARK";
    /**
     * For dark system bar content on a light background.
     *
     * @since 8.0.0
     */ SystemBarsStyle["Light"] = "LIGHT";
    /**
     * The style is based on the device appearance or the underlying content.
     * If the device is using Dark mode, the system bars content will be light.
     * If the device is using Light mode, the system bars content will be dark.
     *
     * @since 8.0.0
     */ SystemBarsStyle["Default"] = "DEFAULT";
})(SystemBarsStyle || (SystemBarsStyle = {}));
/**
 * Available system bar types.
 */ var SystemBarType;
(function(SystemBarType) {
    /**
     * The top status bar on both Android and iOS.
     *
     * @since 8.0.0
     */ SystemBarType["StatusBar"] = "StatusBar";
    /**
     * The navigation bar (or gesture bar on iOS) on both Android and iOS.
     *
     * @since 8.0.0
     */ SystemBarType["NavigationBar"] = "NavigationBar";
})(SystemBarType || (SystemBarType = {}));
class SystemBarsPluginWeb extends WebPlugin {
    async setStyle() {
        this.unavailable('not available for web');
    }
    async setAnimation() {
        this.unavailable('not available for web');
    }
    async show() {
        this.unavailable('not available for web');
    }
    async hide() {
        this.unavailable('not available for web');
    }
}
const SystemBars = registerPlugin('SystemBars', {
    web: ()=>new SystemBarsPluginWeb()
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8A4Y5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rootSlices", ()=>rootSlices);
var _slice = require("app/pages/CreateWalletPage/slice");
var _account = require("app/state/account");
var _fatalerror = require("app/state/fatalerror");
var _importaccounts = require("app/state/importaccounts");
var _network = require("app/state/network");
var _paratimes = require("app/state/paratimes");
var _staking = require("app/state/staking");
var _contacts = require("app/state/contacts");
var _evmAccounts = require("app/state/evmAccounts");
var _transaction = require("app/state/transaction");
var _wallet = require("app/state/wallet");
var _slice1 = require("styles/theme/slice");
var _persist = require("app/state/persist");
var _slice2 = require("app/state/settings/slice");
const rootSlices = {
    account: (0, _account.accountSlice),
    contacts: (0, _contacts.contactsSlice),
    evmAccounts: (0, _evmAccounts.evmAccountsSlice),
    createWallet: (0, _slice.createWalletSlice),
    fatalError: (0, _fatalerror.fatalErrorSlice),
    importAccounts: (0, _importaccounts.importAccountsSlice),
    network: (0, _network.networkSlice),
    paraTimes: (0, _paratimes.paraTimesSlice),
    settings: (0, _slice2.settingsSlice),
    staking: (0, _staking.stakingSlice),
    theme: (0, _slice1.themeSlice),
    transaction: (0, _transaction.transactionSlice),
    wallet: (0, _wallet.walletSlice),
    persist: (0, _persist.persistSlice)
};

},{"app/pages/CreateWalletPage/slice":"apnKj","app/state/account":"3cfOb","app/state/fatalerror":"dQQWe","app/state/importaccounts":"eABjR","app/state/network":"8NDHR","app/state/paratimes":"63sI2","app/state/staking":"8XKJG","app/state/contacts":"83A9K","app/state/evmAccounts":"dpUJw","app/state/transaction":"jax2p","app/state/wallet":"iYAaC","styles/theme/slice":"56nVt","app/state/persist":"9hwZK","app/state/settings/slice":"hDJtm","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"apnKj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "createWalletSlice", ()=>createWalletSlice);
parcelHelpers.export(exports, "createWalletActions", ()=>createWalletActions);
var _toolkit = require("utils/@reduxjs/toolkit");
var _client = require("@oasisprotocol/client");
var _bip39 = require("bip39");
const initialState = {
    checkbox: false,
    mnemonic: []
};
const createWalletSlice = (0, _toolkit.createSlice)({
    name: 'createWallet',
    initialState,
    reducers: {
        /**
     * Generate a new mnemonic
     */ generateMnemonic (state, action) {
            state.mnemonic = (0, _client.hdkey).HDKey.generateMnemonic(256).split(' ');
            // Verify there's no drift between HDKey.generateMnemonic and bip39
            if (!(0, _bip39.validateMnemonic)(state.mnemonic.join(' '))) throw new Error('Generated mnemonic is not valid');
            state.checkbox = false;
        },
        setChecked (state, action) {
            state.checkbox = action.payload;
        },
        clear (state, action) {
            state.mnemonic = [];
            state.checkbox = false;
        }
    }
});
const { actions: createWalletActions } = createWalletSlice;

},{"utils/@reduxjs/toolkit":"2wpnD","@oasisprotocol/client":"9pxEg","bip39":"8hadA","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9pxEg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.worker = exports.upgrade = exports.types = exports.storage = exports.staking = exports.signature = exports.scheduler = exports.runtime = exports.roothash = exports.registry = exports.quantity = exports.misc = exports.keymanager = exports.hdkey = exports.hash = exports.governance = exports.genesis = exports.control = exports.consensus = exports.common = exports.client = exports.beacon = exports.address = void 0;
exports.address = require("f5e3fa9828f078d9");
exports.beacon = require("ecee47f0159c5fd9");
exports.client = require("5a9b796f38f49317");
exports.common = require("5471bdac7cf8b668");
exports.consensus = require("b1096c40702d9df4");
exports.control = require("ae8a6fe8960c38e7");
exports.genesis = require("4e12defdd4dac402");
exports.governance = require("591199ea3acdf7f9");
exports.hash = require("9e2fa77af053f2ea");
exports.hdkey = require("68c5a435883894c5");
exports.keymanager = require("40fe56562d6cb2fd");
exports.misc = require("6fff6f682d93b146");
exports.quantity = require("39b191858b1d59f0");
exports.registry = require("942e9636542f3d85");
exports.roothash = require("3f3a34f565e7f2f1");
exports.runtime = require("9e94bdc42a9194c9");
exports.scheduler = require("43e2c1cf8c068dc6");
exports.signature = require("a6e3cb2b58bfc777");
exports.staking = require("846e0ad17dfdfc92");
exports.storage = require("238aad1ce8e0027f");
exports.types = require("aa443c570075dd71");
exports.upgrade = require("b24b4816be8bb26b");
exports.worker = require("fd5d0058a00d72");

},{"f5e3fa9828f078d9":"4Tvi6","ecee47f0159c5fd9":"fk1Lm","5a9b796f38f49317":"9Fj5k","5471bdac7cf8b668":"drbhA","b1096c40702d9df4":"6XVjL","ae8a6fe8960c38e7":"7hXqf","4e12defdd4dac402":"dyFs9","591199ea3acdf7f9":"2fYpZ","9e2fa77af053f2ea":"gpNaY","68c5a435883894c5":"VNWAo","40fe56562d6cb2fd":"4fmNM","6fff6f682d93b146":"1Mc9i","39b191858b1d59f0":"adbNs","942e9636542f3d85":"gPiTb","3f3a34f565e7f2f1":"2B2sv","9e94bdc42a9194c9":"4wpNN","43e2c1cf8c068dc6":"gQCBS","a6e3cb2b58bfc777":"6UtA9","846e0ad17dfdfc92":"4Jr43","238aad1ce8e0027f":"dayB8","aa443c570075dd71":"9Iba2","b24b4816be8bb26b":"247hr","fd5d0058a00d72":"dbLDa"}],"4Tvi6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fromData = fromData;
exports.toBech32 = toBech32;
exports.fromBech32 = fromBech32;
const bech32_1 = require("a029b3b56c3794d0");
const hash = require("639bb6bf64b44f9b");
const misc = require("6f2e4191aba97196");
function fromData(contextIdentifier, contextVersion, data) {
    const versionU8 = new Uint8Array([
        contextVersion
    ]);
    return misc.concat(versionU8, hash.hash(misc.concat(misc.fromString(contextIdentifier), versionU8, data)).slice(0, 20));
}
function toBech32(prefix, addr) {
    return bech32_1.bech32.encode(prefix, bech32_1.bech32.toWords(addr));
}
function fromBech32(expectedPrefix, str) {
    const { prefix, words } = bech32_1.bech32.decode(str);
    if (prefix !== expectedPrefix) throw new Error(`wrong prefix: ${prefix}, expected ${expectedPrefix}`);
    return new Uint8Array(bech32_1.bech32.fromWords(words));
}

},{"a029b3b56c3794d0":"2RdXy","639bb6bf64b44f9b":"gpNaY","6f2e4191aba97196":"1Mc9i"}],"2RdXy":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bech32m = exports.bech32 = void 0;
const ALPHABET = 'qpzry9x8gf2tvdw0s3jn54khce6mua7l';
const ALPHABET_MAP = {};
for(let z = 0; z < ALPHABET.length; z++){
    const x = ALPHABET.charAt(z);
    ALPHABET_MAP[x] = z;
}
function polymodStep(pre) {
    const b = pre >> 25;
    return (pre & 0x1ffffff) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function prefixChk(prefix) {
    let chk = 1;
    for(let i = 0; i < prefix.length; ++i){
        const c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return 'Invalid prefix (' + prefix + ')';
        chk = polymodStep(chk) ^ c >> 5;
    }
    chk = polymodStep(chk);
    for(let i = 0; i < prefix.length; ++i){
        const v = prefix.charCodeAt(i);
        chk = polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function convert(data, inBits, outBits, pad) {
    let value = 0;
    let bits = 0;
    const maxV = (1 << outBits) - 1;
    const result = [];
    for(let i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return 'Excess padding';
        if (value << outBits - bits & maxV) return 'Non-zero padding';
    }
    return result;
}
function toWords(bytes) {
    return convert(bytes, 8, 5, true);
}
function fromWordsUnsafe(words) {
    const res = convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function fromWords(words) {
    const res = convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function getLibraryFromEncoding(encoding) {
    let ENCODING_CONST;
    if (encoding === 'bech32') ENCODING_CONST = 1;
    else ENCODING_CONST = 0x2bc830a3;
    function encode(prefix, words, LIMIT) {
        LIMIT = LIMIT || 90;
        if (prefix.length + 7 + words.length > LIMIT) throw new TypeError('Exceeds length limit');
        prefix = prefix.toLowerCase();
        // determine chk mod
        let chk = prefixChk(prefix);
        if (typeof chk === 'string') throw new Error(chk);
        let result = prefix + '1';
        for(let i = 0; i < words.length; ++i){
            const x = words[i];
            if (x >> 5 !== 0) throw new Error('Non 5-bit word');
            chk = polymodStep(chk) ^ x;
            result += ALPHABET.charAt(x);
        }
        for(let i = 0; i < 6; ++i)chk = polymodStep(chk);
        chk ^= ENCODING_CONST;
        for(let i = 0; i < 6; ++i){
            const v = chk >> (5 - i) * 5 & 0x1f;
            result += ALPHABET.charAt(v);
        }
        return result;
    }
    function __decode(str, LIMIT) {
        LIMIT = LIMIT || 90;
        if (str.length < 8) return str + ' too short';
        if (str.length > LIMIT) return 'Exceeds length limit';
        // don't allow mixed case
        const lowered = str.toLowerCase();
        const uppered = str.toUpperCase();
        if (str !== lowered && str !== uppered) return 'Mixed-case string ' + str;
        str = lowered;
        const split = str.lastIndexOf('1');
        if (split === -1) return 'No separator character for ' + str;
        if (split === 0) return 'Missing prefix for ' + str;
        const prefix = str.slice(0, split);
        const wordChars = str.slice(split + 1);
        if (wordChars.length < 6) return 'Data too short';
        let chk = prefixChk(prefix);
        if (typeof chk === 'string') return chk;
        const words = [];
        for(let i = 0; i < wordChars.length; ++i){
            const c = wordChars.charAt(i);
            const v = ALPHABET_MAP[c];
            if (v === undefined) return 'Unknown character ' + c;
            chk = polymodStep(chk) ^ v;
            // not in the checksum?
            if (i + 6 >= wordChars.length) continue;
            words.push(v);
        }
        if (chk !== ENCODING_CONST) return 'Invalid checksum for ' + str;
        return {
            prefix,
            words
        };
    }
    function decodeUnsafe(str, LIMIT) {
        const res = __decode(str, LIMIT);
        if (typeof res === 'object') return res;
    }
    function decode(str, LIMIT) {
        const res = __decode(str, LIMIT);
        if (typeof res === 'object') return res;
        throw new Error(res);
    }
    return {
        decodeUnsafe,
        decode,
        encode,
        toWords,
        fromWordsUnsafe,
        fromWords
    };
}
exports.bech32 = getLibraryFromEncoding('bech32');
exports.bech32m = getLibraryFromEncoding('bech32m');

},{}],"gpNaY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hash = hash;
const sha512_1 = require("5b515af316e6219e");
function hash(data) {
    return (0, sha512_1.sha512_256)(data);
}

},{"5b515af316e6219e":"3uPma"}],"3uPma":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sha512_256 = exports.SHA512_256 = exports.sha512_224 = exports.SHA512_224 = exports.sha384 = exports.SHA384 = exports.sha512 = exports.SHA512 = void 0;
/**
 * SHA2-512 a.k.a. sha512 and sha384. It is slower than sha256 in js because u64 operations are slow.
 *
 * Check out [RFC 4634](https://datatracker.ietf.org/doc/html/rfc4634) and
 * [the paper on truncated SHA512/256](https://eprint.iacr.org/2010/548.pdf).
 * @module
 * @deprecated
 */ const sha2_ts_1 = require("8523263c48623b9b");
/** @deprecated Use import from `noble/hashes/sha2` module */ exports.SHA512 = sha2_ts_1.SHA512;
/** @deprecated Use import from `noble/hashes/sha2` module */ exports.sha512 = sha2_ts_1.sha512;
/** @deprecated Use import from `noble/hashes/sha2` module */ exports.SHA384 = sha2_ts_1.SHA384;
/** @deprecated Use import from `noble/hashes/sha2` module */ exports.sha384 = sha2_ts_1.sha384;
/** @deprecated Use import from `noble/hashes/sha2` module */ exports.SHA512_224 = sha2_ts_1.SHA512_224;
/** @deprecated Use import from `noble/hashes/sha2` module */ exports.sha512_224 = sha2_ts_1.sha512_224;
/** @deprecated Use import from `noble/hashes/sha2` module */ exports.SHA512_256 = sha2_ts_1.SHA512_256;
/** @deprecated Use import from `noble/hashes/sha2` module */ exports.sha512_256 = sha2_ts_1.sha512_256;

},{"8523263c48623b9b":"1SJZy"}],"1SJZy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sha512_224 = exports.sha512_256 = exports.sha384 = exports.sha512 = exports.sha224 = exports.sha256 = exports.SHA512_256 = exports.SHA512_224 = exports.SHA384 = exports.SHA512 = exports.SHA224 = exports.SHA256 = void 0;
/**
 * SHA2 hash function. A.k.a. sha256, sha384, sha512, sha512_224, sha512_256.
 * SHA256 is the fastest hash implementable in JS, even faster than Blake3.
 * Check out [RFC 4634](https://datatracker.ietf.org/doc/html/rfc4634) and
 * [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 */ const _md_ts_1 = require("d6f8d958723acf1f");
const u64 = require("4c9499e44a61226e");
const utils_ts_1 = require("30c20354ae9f4c7b");
/**
 * Round constants:
 * First 32 bits of fractional parts of the cube roots of the first 64 primes 2..311)
 */ // prettier-ignore
const SHA256_K = /* @__PURE__ */ Uint32Array.from([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Reusable temporary buffer. "W" comes straight from spec. */ const SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class SHA256 extends _md_ts_1.HashMD {
    constructor(outputLen = 32){
        super(64, outputLen, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = _md_ts_1.SHA256_IV[0] | 0;
        this.B = _md_ts_1.SHA256_IV[1] | 0;
        this.C = _md_ts_1.SHA256_IV[2] | 0;
        this.D = _md_ts_1.SHA256_IV[3] | 0;
        this.E = _md_ts_1.SHA256_IV[4] | 0;
        this.F = _md_ts_1.SHA256_IV[5] | 0;
        this.G = _md_ts_1.SHA256_IV[6] | 0;
        this.H = _md_ts_1.SHA256_IV[7] | 0;
    }
    get() {
        const { A, B, C, D, E, F, G, H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = SHA256_W[i - 15];
            const W2 = SHA256_W[i - 2];
            const s0 = (0, utils_ts_1.rotr)(W15, 7) ^ (0, utils_ts_1.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, utils_ts_1.rotr)(W2, 17) ^ (0, utils_ts_1.rotr)(W2, 19) ^ W2 >>> 10;
            SHA256_W[i] = s1 + SHA256_W[i - 7] + s0 + SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A, B, C, D, E, F, G, H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, utils_ts_1.rotr)(E, 6) ^ (0, utils_ts_1.rotr)(E, 11) ^ (0, utils_ts_1.rotr)(E, 25);
            const T1 = H + sigma1 + (0, _md_ts_1.Chi)(E, F, G) + SHA256_K[i] + SHA256_W[i] | 0;
            const sigma0 = (0, utils_ts_1.rotr)(A, 2) ^ (0, utils_ts_1.rotr)(A, 13) ^ (0, utils_ts_1.rotr)(A, 22);
            const T2 = sigma0 + (0, _md_ts_1.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        (0, utils_ts_1.clean)(SHA256_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        (0, utils_ts_1.clean)(this.buffer);
    }
}
exports.SHA256 = SHA256;
class SHA224 extends SHA256 {
    constructor(){
        super(28);
        this.A = _md_ts_1.SHA224_IV[0] | 0;
        this.B = _md_ts_1.SHA224_IV[1] | 0;
        this.C = _md_ts_1.SHA224_IV[2] | 0;
        this.D = _md_ts_1.SHA224_IV[3] | 0;
        this.E = _md_ts_1.SHA224_IV[4] | 0;
        this.F = _md_ts_1.SHA224_IV[5] | 0;
        this.G = _md_ts_1.SHA224_IV[6] | 0;
        this.H = _md_ts_1.SHA224_IV[7] | 0;
    }
}
exports.SHA224 = SHA224;
// SHA2-512 is slower than sha256 in js because u64 operations are slow.
// Round contants
// First 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409
// prettier-ignore
const K512 = /* @__PURE__ */ (()=>u64.split([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
const SHA512_Kh = /* @__PURE__ */ (()=>K512[0])();
const SHA512_Kl = /* @__PURE__ */ (()=>K512[1])();
// Reusable temporary buffers
const SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class SHA512 extends _md_ts_1.HashMD {
    constructor(outputLen = 64){
        super(128, outputLen, 16, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = _md_ts_1.SHA512_IV[0] | 0;
        this.Al = _md_ts_1.SHA512_IV[1] | 0;
        this.Bh = _md_ts_1.SHA512_IV[2] | 0;
        this.Bl = _md_ts_1.SHA512_IV[3] | 0;
        this.Ch = _md_ts_1.SHA512_IV[4] | 0;
        this.Cl = _md_ts_1.SHA512_IV[5] | 0;
        this.Dh = _md_ts_1.SHA512_IV[6] | 0;
        this.Dl = _md_ts_1.SHA512_IV[7] | 0;
        this.Eh = _md_ts_1.SHA512_IV[8] | 0;
        this.El = _md_ts_1.SHA512_IV[9] | 0;
        this.Fh = _md_ts_1.SHA512_IV[10] | 0;
        this.Fl = _md_ts_1.SHA512_IV[11] | 0;
        this.Gh = _md_ts_1.SHA512_IV[12] | 0;
        this.Gl = _md_ts_1.SHA512_IV[13] | 0;
        this.Hh = _md_ts_1.SHA512_IV[14] | 0;
        this.Hl = _md_ts_1.SHA512_IV[15] | 0;
    }
    // prettier-ignore
    get() {
        const { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            SHA512_W_H[i] = view.getUint32(offset);
            SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = SHA512_W_H[i - 15] | 0;
            const W15l = SHA512_W_L[i - 15] | 0;
            const s0h = u64.rotrSH(W15h, W15l, 1) ^ u64.rotrSH(W15h, W15l, 8) ^ u64.shrSH(W15h, W15l, 7);
            const s0l = u64.rotrSL(W15h, W15l, 1) ^ u64.rotrSL(W15h, W15l, 8) ^ u64.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = SHA512_W_H[i - 2] | 0;
            const W2l = SHA512_W_L[i - 2] | 0;
            const s1h = u64.rotrSH(W2h, W2l, 19) ^ u64.rotrBH(W2h, W2l, 61) ^ u64.shrSH(W2h, W2l, 6);
            const s1l = u64.rotrSL(W2h, W2l, 19) ^ u64.rotrBL(W2h, W2l, 61) ^ u64.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = u64.add4L(s0l, s1l, SHA512_W_L[i - 7], SHA512_W_L[i - 16]);
            const SUMh = u64.add4H(SUMl, s0h, s1h, SHA512_W_H[i - 7], SHA512_W_H[i - 16]);
            SHA512_W_H[i] = SUMh | 0;
            SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = u64.rotrSH(Eh, El, 14) ^ u64.rotrSH(Eh, El, 18) ^ u64.rotrBH(Eh, El, 41);
            const sigma1l = u64.rotrSL(Eh, El, 14) ^ u64.rotrSL(Eh, El, 18) ^ u64.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = u64.add5L(Hl, sigma1l, CHIl, SHA512_Kl[i], SHA512_W_L[i]);
            const T1h = u64.add5H(T1ll, Hh, sigma1h, CHIh, SHA512_Kh[i], SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = u64.rotrSH(Ah, Al, 28) ^ u64.rotrBH(Ah, Al, 34) ^ u64.rotrBH(Ah, Al, 39);
            const sigma0l = u64.rotrSL(Ah, Al, 28) ^ u64.rotrBL(Ah, Al, 34) ^ u64.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = u64.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = u64.add3L(T1l, sigma0l, MAJl);
            Ah = u64.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = u64.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = u64.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = u64.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = u64.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = u64.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = u64.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = u64.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = u64.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        (0, utils_ts_1.clean)(SHA512_W_H, SHA512_W_L);
    }
    destroy() {
        (0, utils_ts_1.clean)(this.buffer);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
exports.SHA512 = SHA512;
class SHA384 extends SHA512 {
    constructor(){
        super(48);
        this.Ah = _md_ts_1.SHA384_IV[0] | 0;
        this.Al = _md_ts_1.SHA384_IV[1] | 0;
        this.Bh = _md_ts_1.SHA384_IV[2] | 0;
        this.Bl = _md_ts_1.SHA384_IV[3] | 0;
        this.Ch = _md_ts_1.SHA384_IV[4] | 0;
        this.Cl = _md_ts_1.SHA384_IV[5] | 0;
        this.Dh = _md_ts_1.SHA384_IV[6] | 0;
        this.Dl = _md_ts_1.SHA384_IV[7] | 0;
        this.Eh = _md_ts_1.SHA384_IV[8] | 0;
        this.El = _md_ts_1.SHA384_IV[9] | 0;
        this.Fh = _md_ts_1.SHA384_IV[10] | 0;
        this.Fl = _md_ts_1.SHA384_IV[11] | 0;
        this.Gh = _md_ts_1.SHA384_IV[12] | 0;
        this.Gl = _md_ts_1.SHA384_IV[13] | 0;
        this.Hh = _md_ts_1.SHA384_IV[14] | 0;
        this.Hl = _md_ts_1.SHA384_IV[15] | 0;
    }
}
exports.SHA384 = SHA384;
/**
 * Truncated SHA512/256 and SHA512/224.
 * SHA512_IV is XORed with 0xa5a5a5a5a5a5a5a5, then used as "intermediary" IV of SHA512/t.
 * Then t hashes string to produce result IV.
 * See `test/misc/sha2-gen-iv.js`.
 */ /** SHA512/224 IV */ const T224_IV = /* @__PURE__ */ Uint32Array.from([
    0x8c3d37c8,
    0x19544da2,
    0x73e19966,
    0x89dcd4d6,
    0x1dfab7ae,
    0x32ff9c82,
    0x679dd514,
    0x582f9fcf,
    0x0f6d2b69,
    0x7bd44da8,
    0x77e36f73,
    0x04c48942,
    0x3f9d85a8,
    0x6a1d36c8,
    0x1112e6ad,
    0x91d692a1
]);
/** SHA512/256 IV */ const T256_IV = /* @__PURE__ */ Uint32Array.from([
    0x22312194,
    0xfc2bf72c,
    0x9f555fa3,
    0xc84c64c2,
    0x2393b86b,
    0x6f53b151,
    0x96387719,
    0x5940eabd,
    0x96283ee2,
    0xa88effe3,
    0xbe5e1e25,
    0x53863992,
    0x2b0199fc,
    0x2c85b8aa,
    0x0eb72ddc,
    0x81c52ca2
]);
class SHA512_224 extends SHA512 {
    constructor(){
        super(28);
        this.Ah = T224_IV[0] | 0;
        this.Al = T224_IV[1] | 0;
        this.Bh = T224_IV[2] | 0;
        this.Bl = T224_IV[3] | 0;
        this.Ch = T224_IV[4] | 0;
        this.Cl = T224_IV[5] | 0;
        this.Dh = T224_IV[6] | 0;
        this.Dl = T224_IV[7] | 0;
        this.Eh = T224_IV[8] | 0;
        this.El = T224_IV[9] | 0;
        this.Fh = T224_IV[10] | 0;
        this.Fl = T224_IV[11] | 0;
        this.Gh = T224_IV[12] | 0;
        this.Gl = T224_IV[13] | 0;
        this.Hh = T224_IV[14] | 0;
        this.Hl = T224_IV[15] | 0;
    }
}
exports.SHA512_224 = SHA512_224;
class SHA512_256 extends SHA512 {
    constructor(){
        super(32);
        this.Ah = T256_IV[0] | 0;
        this.Al = T256_IV[1] | 0;
        this.Bh = T256_IV[2] | 0;
        this.Bl = T256_IV[3] | 0;
        this.Ch = T256_IV[4] | 0;
        this.Cl = T256_IV[5] | 0;
        this.Dh = T256_IV[6] | 0;
        this.Dl = T256_IV[7] | 0;
        this.Eh = T256_IV[8] | 0;
        this.El = T256_IV[9] | 0;
        this.Fh = T256_IV[10] | 0;
        this.Fl = T256_IV[11] | 0;
        this.Gh = T256_IV[12] | 0;
        this.Gl = T256_IV[13] | 0;
        this.Hh = T256_IV[14] | 0;
        this.Hl = T256_IV[15] | 0;
    }
}
exports.SHA512_256 = SHA512_256;
/**
 * SHA2-256 hash function from RFC 4634.
 *
 * It is the fastest JS hash, even faster than Blake3.
 * To break sha256 using birthday attack, attackers need to try 2^128 hashes.
 * BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 */ exports.sha256 = (0, utils_ts_1.createHasher)(()=>new SHA256());
/** SHA2-224 hash function from RFC 4634 */ exports.sha224 = (0, utils_ts_1.createHasher)(()=>new SHA224());
/** SHA2-512 hash function from RFC 4634. */ exports.sha512 = (0, utils_ts_1.createHasher)(()=>new SHA512());
/** SHA2-384 hash function from RFC 4634. */ exports.sha384 = (0, utils_ts_1.createHasher)(()=>new SHA384());
/**
 * SHA2-512/256 "truncated" hash function, with improved resistance to length extension attacks.
 * See the paper on [truncated SHA512](https://eprint.iacr.org/2010/548.pdf).
 */ exports.sha512_256 = (0, utils_ts_1.createHasher)(()=>new SHA512_256());
/**
 * SHA2-512/224 "truncated" hash function, with improved resistance to length extension attacks.
 * See the paper on [truncated SHA512](https://eprint.iacr.org/2010/548.pdf).
 */ exports.sha512_224 = (0, utils_ts_1.createHasher)(()=>new SHA512_224());

},{"d6f8d958723acf1f":"kZc1J","4c9499e44a61226e":"gFYWy","30c20354ae9f4c7b":"eZ1E0"}],"kZc1J":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SHA512_IV = exports.SHA384_IV = exports.SHA224_IV = exports.SHA256_IV = exports.HashMD = void 0;
exports.setBigUint64 = setBigUint64;
exports.Chi = Chi;
exports.Maj = Maj;
/**
 * Internal Merkle-Damgard hash utils.
 * @module
 */ const utils_ts_1 = require("8a22c83b91d79b09");
/** Polyfill for Safari 14. https://caniuse.com/mdn-javascript_builtins_dataview_setbiguint64 */ function setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
/** Choice: a ? b : c */ function Chi(a, b, c) {
    return a & b ^ ~a & c;
}
/** Majority function, true if any two inputs is true. */ function Maj(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */ class HashMD extends utils_ts_1.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, utils_ts_1.createView)(this.buffer);
    }
    update(data) {
        (0, utils_ts_1.aexists)(this);
        data = (0, utils_ts_1.toBytes)(data);
        (0, utils_ts_1.abytes)(data);
        const { view, buffer, blockLen } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, utils_ts_1.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, utils_ts_1.aexists)(this);
        (0, utils_ts_1.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer, view, blockLen, isLE } = this;
        let { pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        (0, utils_ts_1.clean)(this.buffer.subarray(pos));
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, utils_ts_1.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer, outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen, buffer, length, finished, destroyed, pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
exports.HashMD = HashMD;
/**
 * Initial SHA-2 state: fractional parts of square roots of first 16 primes 2..53.
 * Check out `test/misc/sha2-gen-iv.js` for recomputation guide.
 */ /** Initial SHA256 state. Bits 0..32 of frac part of sqrt of primes 2..19 */ exports.SHA256_IV = Uint32Array.from([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
/** Initial SHA224 state. Bits 32..64 of frac part of sqrt of primes 23..53 */ exports.SHA224_IV = Uint32Array.from([
    0xc1059ed8,
    0x367cd507,
    0x3070dd17,
    0xf70e5939,
    0xffc00b31,
    0x68581511,
    0x64f98fa7,
    0xbefa4fa4
]);
/** Initial SHA384 state. Bits 0..64 of frac part of sqrt of primes 23..53 */ exports.SHA384_IV = Uint32Array.from([
    0xcbbb9d5d,
    0xc1059ed8,
    0x629a292a,
    0x367cd507,
    0x9159015a,
    0x3070dd17,
    0x152fecd8,
    0xf70e5939,
    0x67332667,
    0xffc00b31,
    0x8eb44a87,
    0x68581511,
    0xdb0c2e0d,
    0x64f98fa7,
    0x47b5481d,
    0xbefa4fa4
]);
/** Initial SHA512 state. Bits 0..64 of frac part of sqrt of primes 2..19 */ exports.SHA512_IV = Uint32Array.from([
    0x6a09e667,
    0xf3bcc908,
    0xbb67ae85,
    0x84caa73b,
    0x3c6ef372,
    0xfe94f82b,
    0xa54ff53a,
    0x5f1d36f1,
    0x510e527f,
    0xade682d1,
    0x9b05688c,
    0x2b3e6c1f,
    0x1f83d9ab,
    0xfb41bd6b,
    0x5be0cd19,
    0x137e2179
]);

},{"8a22c83b91d79b09":"eZ1E0"}],"eZ1E0":[function(require,module,exports,__globalThis) {
"use strict";
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wrapXOFConstructorWithOpts = exports.wrapConstructorWithOpts = exports.wrapConstructor = exports.Hash = exports.nextTick = exports.swap32IfBE = exports.byteSwapIfBE = exports.swap8IfBE = exports.isLE = void 0;
exports.isBytes = isBytes;
exports.anumber = anumber;
exports.abytes = abytes;
exports.ahash = ahash;
exports.aexists = aexists;
exports.aoutput = aoutput;
exports.u8 = u8;
exports.u32 = u32;
exports.clean = clean;
exports.createView = createView;
exports.rotr = rotr;
exports.rotl = rotl;
exports.byteSwap = byteSwap;
exports.byteSwap32 = byteSwap32;
exports.bytesToHex = bytesToHex;
exports.hexToBytes = hexToBytes;
exports.asyncLoop = asyncLoop;
exports.utf8ToBytes = utf8ToBytes;
exports.bytesToUtf8 = bytesToUtf8;
exports.toBytes = toBytes;
exports.kdfInputToBytes = kdfInputToBytes;
exports.concatBytes = concatBytes;
exports.checkOpts = checkOpts;
exports.createHasher = createHasher;
exports.createOptHasher = createOptHasher;
exports.createXOFer = createXOFer;
exports.randomBytes = randomBytes;
// We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const crypto_1 = require("bea97c4d14883b78");
/** Checks if something is Uint8Array. Be careful: nodejs Buffer will return true. */ function isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
/** Asserts something is positive integer. */ function anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('positive integer expected, got ' + n);
}
/** Asserts something is Uint8Array. */ function abytes(b, ...lengths) {
    if (!isBytes(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
/** Asserts something is hash */ function ahash(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.createHasher');
    anumber(h.outputLen);
    anumber(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */ function aexists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
/** Asserts output is properly-sized byte array */ function aoutput(out, instance) {
    abytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}
/** Cast u8 / u16 / u32 to u8. */ function u8(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** Cast u8 / u16 / u32 to u32. */ function u32(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
/** Zeroize a byte array. Warning: JS provides no guarantees. */ function clean(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
/** Create DataView of an array for easy byte-level manipulation. */ function createView(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** The rotate right (circular right shift) operation for uint32 */ function rotr(word, shift) {
    return word << 32 - shift | word >>> shift;
}
/** The rotate left (circular left shift) operation for uint32 */ function rotl(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
/** Is current platform little-endian? Most are. Big-Endian platform: IBM */ exports.isLE = (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
/** The byte swap operation for uint32 */ function byteSwap(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
/** Conditionally byte swap if on a big-endian platform */ exports.swap8IfBE = exports.isLE ? (n)=>n : (n)=>byteSwap(n);
/** @deprecated */ exports.byteSwapIfBE = exports.swap8IfBE;
/** In place byte swap for Uint32Array */ function byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = byteSwap(arr[i]);
    return arr;
}
exports.swap32IfBE = exports.isLE ? (u)=>u : byteSwap32;
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * Convert byte array to hex string. Uses built-in function, when available.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function bytesToHex(bytes) {
    abytes(bytes);
    // @ts-ignore
    if (hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function asciiToBase16(ch) {
    if (ch >= asciis._0 && ch <= asciis._9) return ch - asciis._0; // '2' => 50-48
    if (ch >= asciis.A && ch <= asciis.F) return ch - (asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= asciis.a && ch <= asciis.f) return ch - (asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * Convert hex string to byte array. Uses built-in function, when available.
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function hexToBytes(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if (hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = asciiToBase16(hex.charCodeAt(hi));
        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
/**
 * There is no setImmediate in browser and setTimeout is slow.
 * Call of async fn will return Promise, which will be fullfiled only on
 * next scheduler queue processing step and this is exactly what we need.
 */ const nextTick = async ()=>{};
exports.nextTick = nextTick;
/** Returns control to thread each 'tick' ms to avoid blocking. */ async function asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, exports.nextTick)();
        ts += diff;
    }
}
/**
 * Converts string to bytes using UTF8 encoding.
 * @example utf8ToBytes('abc') // Uint8Array.from([97, 98, 99])
 */ function utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Converts bytes to string using UTF8 encoding.
 * @example bytesToUtf8(Uint8Array.from([97, 98, 99])) // 'abc'
 */ function bytesToUtf8(bytes) {
    return new TextDecoder().decode(bytes);
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function toBytes(data) {
    if (typeof data === 'string') data = utf8ToBytes(data);
    abytes(data);
    return data;
}
/**
 * Helper for KDFs: consumes uint8array or string.
 * When string is passed, does utf8 decoding, using TextDecoder.
 */ function kdfInputToBytes(data) {
    if (typeof data === 'string') data = utf8ToBytes(data);
    abytes(data);
    return data;
}
/** Copies several Uint8Arrays into one. */ function concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function checkOpts(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== '[object Object]') throw new Error('options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
/** For runtime check if class implements interface */ class Hash {
}
exports.Hash = Hash;
/** Wraps hash function, creating an interface on top of it */ function createHasher(hashCons) {
    const hashC = (msg)=>hashCons().update(toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function createOptHasher(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function createXOFer(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
exports.wrapConstructor = createHasher;
exports.wrapConstructorWithOpts = createOptHasher;
exports.wrapXOFConstructorWithOpts = createXOFer;
/** Cryptographically secure PRNG. Uses internal OS-level `crypto.getRandomValues`. */ function randomBytes(bytesLength = 32) {
    if (crypto_1.crypto && typeof crypto_1.crypto.getRandomValues === 'function') return crypto_1.crypto.getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if (crypto_1.crypto && typeof crypto_1.crypto.randomBytes === 'function') return Uint8Array.from(crypto_1.crypto.randomBytes(bytesLength));
    throw new Error('crypto.getRandomValues must be defined');
}

},{"bea97c4d14883b78":"2b769"}],"2b769":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.crypto = void 0;
exports.crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;

},{}],"gFYWy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toBig = exports.shrSL = exports.shrSH = exports.rotrSL = exports.rotrSH = exports.rotrBL = exports.rotrBH = exports.rotr32L = exports.rotr32H = exports.rotlSL = exports.rotlSH = exports.rotlBL = exports.rotlBH = exports.add5L = exports.add5H = exports.add4L = exports.add4H = exports.add3L = exports.add3H = void 0;
exports.add = add;
exports.fromBig = fromBig;
exports.split = split;
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const _32n = /* @__PURE__ */ BigInt(32);
function fromBig(n, le = false) {
    if (le) return {
        h: Number(n & U32_MASK64),
        l: Number(n >> _32n & U32_MASK64)
    };
    return {
        h: Number(n >> _32n & U32_MASK64) | 0,
        l: Number(n & U32_MASK64) | 0
    };
}
function split(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for(let i = 0; i < len; i++){
        const { h, l } = fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const toBig = (h, l)=>BigInt(h >>> 0) << _32n | BigInt(l >>> 0);
exports.toBig = toBig;
// for Shift in [0, 32)
const shrSH = (h, _l, s)=>h >>> s;
exports.shrSH = shrSH;
const shrSL = (h, l, s)=>h << 32 - s | l >>> s;
exports.shrSL = shrSL;
// Right rotate for Shift in [1, 32)
const rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
exports.rotrSH = rotrSH;
const rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
exports.rotrSL = rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
exports.rotrBH = rotrBH;
const rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
exports.rotrBL = rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const rotr32H = (_h, l)=>l;
exports.rotr32H = rotr32H;
const rotr32L = (h, _l)=>h;
exports.rotr32L = rotr32L;
// Left rotate for Shift in [1, 32)
const rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
exports.rotlSH = rotlSH;
const rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
exports.rotlSL = rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
exports.rotlBH = rotlBH;
const rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
exports.rotlBL = rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
exports.add3L = add3L;
const add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
exports.add3H = add3H;
const add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
exports.add4L = add4L;
const add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
exports.add4H = add4H;
const add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
exports.add5L = add5L;
const add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
exports.add5H = add5H;
// prettier-ignore
const u64 = {
    fromBig,
    split,
    toBig,
    shrSH,
    shrSL,
    rotrSH,
    rotrSL,
    rotrBH,
    rotrBL,
    rotr32H,
    rotr32L,
    rotlSH,
    rotlSL,
    rotlBH,
    rotlBL,
    add,
    add3L,
    add3H,
    add4L,
    add4H,
    add5H,
    add5L
};
exports.default = u64;

},{}],"1Mc9i":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toCBOR = toCBOR;
exports.fromCBOR = fromCBOR;
exports.toHex = toHex;
exports.fromHex = fromHex;
exports.toBase64 = toBase64;
exports.fromBase64 = fromBase64;
exports.toStringUTF8 = toStringUTF8;
exports.fromString = fromString;
exports.concat = concat;
const cborg = require("ce8233d4899ade92");
const HEX_DIGITS = '0123456789abcdef';
// oasis-core routinely uses maps with non-string keys, e.g. in a staking Delegations response. We
// can't pick and choose which CBOR maps to decode into objects and which to decode in to Maps, so
// walk through the data after decoding and find any string-keys-only and recreate them as objects.
function objsFromMaps(v) {
    if (v instanceof Map) {
        let keysCompatible = true;
        for (const key of v.keys())if (typeof key !== 'string') {
            keysCompatible = false;
            break;
        }
        if (v.size > 0 && keysCompatible) {
            // Recreate as an object.
            const o = {};
            for (const [key, val] of v)o[key] = objsFromMaps(val);
            return o;
        } else {
            // Leave as a Map. We'd miss empty structs, but we wouldn't dare use such a thing,
            // would we?
            const m = new Map();
            for (const [key, val] of v)m.set(objsFromMaps(key), objsFromMaps(val));
            return m;
        }
    } else if (v instanceof Array) {
        const a = [];
        for (const elem of v)a.push(objsFromMaps(elem));
        return a;
    } else return v;
}
function toCBOR(v) {
    return cborg.encode(v);
}
function fromCBOR(u8) {
    // oasis-core uses a special case to unmarshal an empty byte string to `nil`.
    if (!u8.length) return undefined;
    return objsFromMaps(cborg.decode(u8, {
        useMaps: true
    }));
}
function toHex(u8) {
    let hex = '';
    for (const b of u8)hex += HEX_DIGITS[b >>> 4] + HEX_DIGITS[b & 0xf];
    return hex;
}
function fromHex(hex) {
    let byteLength = hex.length >> 1;
    const u8 = new Uint8Array(byteLength);
    for(let i = 0; i < byteLength; i++)u8[i] = parseInt(hex.substr(2 * i, 2), 16);
    return u8;
}
function toBase64(u8) {
    return btoa(String.fromCharCode(...u8));
}
function fromBase64(base64) {
    const binaryStr = atob(base64);
    const byteLength = binaryStr.length;
    const u8 = new Uint8Array(byteLength);
    for(let i = 0; i < byteLength; i++)u8[i] = binaryStr.charCodeAt(i);
    return u8;
}
function toStringUTF8(u8) {
    return new TextDecoder().decode(u8);
}
function fromString(str) {
    return new TextEncoder().encode(str);
}
function concat(...parts) {
    let length = 0;
    for (const part of parts)length += part.length;
    let result = new Uint8Array(length);
    let pos = 0;
    for (const part of parts){
        result.set(part, pos);
        pos += part.length;
    }
    return result;
}

},{"ce8233d4899ade92":"7mG87"}],"7mG87":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var encode = require("3b3b89f138917eb3");
var decode = require("b75a80531c8b6f28");
var token = require("42eaad425c67d01d");
exports.encode = encode.encode;
exports.decode = decode.decode;
exports.Token = token.Token;
exports.Type = token.Type;

},{"3b3b89f138917eb3":"cmfJy","b75a80531c8b6f28":"7E331","42eaad425c67d01d":"7qjkh"}],"cmfJy":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var is = require("ec2a75c0822da05a");
var token = require("f97da2246e129d0b");
var bl = require("42f42a44fa64497f");
var common = require("b5d2fc01673063f5");
var jump = require("cfd3b54ebbbc9572");
var byteUtils = require("5812fb0dc3e1aead");
var _0uint = require("2f81eabd9c20c1da");
var _1negint = require("2d335d99064f4ad");
var _2bytes = require("996d587692e4d604");
var _3string = require("674fabc1677e8487");
var _4array = require("4548a2e1d33a5968");
var _5map = require("f63d29142cec98f3");
var _6tag = require("a9849610cf505e07");
var _7float = require("4d97fc016ada6d46");
const defaultEncodeOptions = {
    float64: false,
    mapSorter,
    quickEncodeToken: jump.quickEncodeToken
};
function makeCborEncoders() {
    const encoders = [];
    encoders[token.Type.uint.major] = _0uint.encodeUint;
    encoders[token.Type.negint.major] = _1negint.encodeNegint;
    encoders[token.Type.bytes.major] = _2bytes.encodeBytes;
    encoders[token.Type.string.major] = _3string.encodeString;
    encoders[token.Type.array.major] = _4array.encodeArray;
    encoders[token.Type.map.major] = _5map.encodeMap;
    encoders[token.Type.tag.major] = _6tag.encodeTag;
    encoders[token.Type.float.major] = _7float.encodeFloat;
    return encoders;
}
const cborEncoders = makeCborEncoders();
const buf = new bl.Bl();
class Ref {
    constructor(obj, parent){
        this.obj = obj;
        this.parent = parent;
    }
    includes(obj) {
        let p = this;
        do {
            if (p.obj === obj) return true;
        }while (p = p.parent);
        return false;
    }
    static createCheck(stack, obj) {
        if (stack && stack.includes(obj)) throw new Error(`${common.encodeErrPrefix} object contains circular references`);
        return new Ref(obj, stack);
    }
}
const simpleTokens = {
    null: new token.Token(token.Type.null, null),
    undefined: new token.Token(token.Type.undefined, undefined),
    true: new token.Token(token.Type.true, true),
    false: new token.Token(token.Type.false, false),
    emptyArray: new token.Token(token.Type.array, 0),
    emptyMap: new token.Token(token.Type.map, 0)
};
const typeEncoders = {
    number (obj, _typ, _options, _refStack) {
        if (!Number.isInteger(obj) || !Number.isSafeInteger(obj)) return new token.Token(token.Type.float, obj);
        else if (obj >= 0) return new token.Token(token.Type.uint, obj);
        else return new token.Token(token.Type.negint, obj);
    },
    bigint (obj, _typ, _options, _refStack) {
        if (obj >= BigInt(0)) return new token.Token(token.Type.uint, obj);
        else return new token.Token(token.Type.negint, obj);
    },
    Uint8Array (obj, _typ, _options, _refStack) {
        return new token.Token(token.Type.bytes, obj);
    },
    string (obj, _typ, _options, _refStack) {
        return new token.Token(token.Type.string, obj);
    },
    boolean (obj, _typ, _options, _refStack) {
        return obj ? simpleTokens.true : simpleTokens.false;
    },
    null (_obj, _typ, _options, _refStack) {
        return simpleTokens.null;
    },
    undefined (_obj, _typ, _options, _refStack) {
        return simpleTokens.undefined;
    },
    ArrayBuffer (obj, _typ, _options, _refStack) {
        return new token.Token(token.Type.bytes, new Uint8Array(obj));
    },
    DataView (obj, _typ, _options, _refStack) {
        return new token.Token(token.Type.bytes, new Uint8Array(obj.buffer, obj.byteOffset, obj.byteLength));
    },
    Array (obj, _typ, options, refStack) {
        if (!obj.length) {
            if (options.addBreakTokens === true) return [
                simpleTokens.emptyArray,
                new token.Token(token.Type.break)
            ];
            return simpleTokens.emptyArray;
        }
        refStack = Ref.createCheck(refStack, obj);
        const entries = [];
        let i = 0;
        for (const e of obj)entries[i++] = objectToTokens(e, options, refStack);
        if (options.addBreakTokens) return [
            new token.Token(token.Type.array, obj.length),
            entries,
            new token.Token(token.Type.break)
        ];
        return [
            new token.Token(token.Type.array, obj.length),
            entries
        ];
    },
    Object (obj, typ, options, refStack) {
        const isMap = typ !== 'Object';
        const keys = isMap ? obj.keys() : Object.keys(obj);
        const length = isMap ? obj.size : keys.length;
        if (!length) {
            if (options.addBreakTokens === true) return [
                simpleTokens.emptyMap,
                new token.Token(token.Type.break)
            ];
            return simpleTokens.emptyMap;
        }
        refStack = Ref.createCheck(refStack, obj);
        const entries = [];
        let i = 0;
        for (const key of keys)entries[i++] = [
            objectToTokens(key, options, refStack),
            objectToTokens(isMap ? obj.get(key) : obj[key], options, refStack)
        ];
        sortMapEntries(entries, options);
        if (options.addBreakTokens) return [
            new token.Token(token.Type.map, length),
            entries,
            new token.Token(token.Type.break)
        ];
        return [
            new token.Token(token.Type.map, length),
            entries
        ];
    }
};
typeEncoders.Map = typeEncoders.Object;
typeEncoders.Buffer = typeEncoders.Uint8Array;
for (const typ of 'Uint8Clamped Uint16 Uint32 Int8 Int16 Int32 BigUint64 BigInt64 Float32 Float64'.split(' '))typeEncoders[`${typ}Array`] = typeEncoders.DataView;
function objectToTokens(obj, options = {}, refStack) {
    const typ = is.is(obj);
    const customTypeEncoder = options && options.typeEncoders && options.typeEncoders[typ] || typeEncoders[typ];
    if (typeof customTypeEncoder === 'function') {
        const tokens = customTypeEncoder(obj, typ, options, refStack);
        if (tokens != null) return tokens;
    }
    const typeEncoder = typeEncoders[typ];
    if (!typeEncoder) throw new Error(`${common.encodeErrPrefix} unsupported type: ${typ}`);
    return typeEncoder(obj, typ, options, refStack);
}
function sortMapEntries(entries, options) {
    if (options.mapSorter) entries.sort(options.mapSorter);
}
function mapSorter(e1, e2) {
    const keyToken1 = Array.isArray(e1[0]) ? e1[0][0] : e1[0];
    const keyToken2 = Array.isArray(e2[0]) ? e2[0][0] : e2[0];
    if (keyToken1.type !== keyToken2.type) return keyToken1.type.compare(keyToken2.type);
    const major = keyToken1.type.major;
    const tcmp = cborEncoders[major].compareTokens(keyToken1, keyToken2);
    if (tcmp === 0) console.warn('WARNING: complex key types used, CBOR key sorting guarantees are gone');
    return tcmp;
}
function tokensToEncoded(buf, tokens, encoders, options) {
    if (Array.isArray(tokens)) for (const token of tokens)tokensToEncoded(buf, token, encoders, options);
    else encoders[tokens.type.major](buf, tokens, options);
}
function encodeCustom(data, encoders, options) {
    const tokens = objectToTokens(data, options);
    if (!Array.isArray(tokens) && options.quickEncodeToken) {
        const quickBytes = options.quickEncodeToken(tokens);
        if (quickBytes) return quickBytes;
        const encoder = encoders[tokens.type.major];
        if (encoder.encodedSize) {
            const size = encoder.encodedSize(tokens, options);
            const buf = new bl.Bl(size);
            encoder(buf, tokens, options);
            if (buf.chunks.length !== 1) throw new Error(`Unexpected error: pre-calculated length for ${tokens} was wrong`);
            return byteUtils.asU8A(buf.chunks[0]);
        }
    }
    buf.reset();
    tokensToEncoded(buf, tokens, encoders, options);
    return buf.toBytes(true);
}
function encode(data, options) {
    options = Object.assign({}, defaultEncodeOptions, options);
    return encodeCustom(data, cborEncoders, options);
}
exports.Ref = Ref;
exports.encode = encode;
exports.encodeCustom = encodeCustom;
exports.makeCborEncoders = makeCborEncoders;
exports.objectToTokens = objectToTokens;

},{"ec2a75c0822da05a":"emVGM","f97da2246e129d0b":"7qjkh","42f42a44fa64497f":"34kzh","b5d2fc01673063f5":"ludQE","cfd3b54ebbbc9572":"PnvSj","5812fb0dc3e1aead":"2T5kV","2f81eabd9c20c1da":"3gULd","2d335d99064f4ad":"47VNP","996d587692e4d604":"77qlu","674fabc1677e8487":"e5YTj","4548a2e1d33a5968":"cjJXs","f63d29142cec98f3":"dYZNG","a9849610cf505e07":"41jpR","4d97fc016ada6d46":"e0MrV"}],"emVGM":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
const typeofs = [
    'string',
    'number',
    'bigint',
    'symbol'
];
const objectTypeNames = [
    'Function',
    'Generator',
    'AsyncGenerator',
    'GeneratorFunction',
    'AsyncGeneratorFunction',
    'AsyncFunction',
    'Observable',
    'Array',
    'Buffer',
    'Object',
    'RegExp',
    'Date',
    'Error',
    'Map',
    'Set',
    'WeakMap',
    'WeakSet',
    'ArrayBuffer',
    'SharedArrayBuffer',
    'DataView',
    'Promise',
    'URL',
    'HTMLElement',
    'Int8Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Int16Array',
    'Uint16Array',
    'Int32Array',
    'Uint32Array',
    'Float32Array',
    'Float64Array',
    'BigInt64Array',
    'BigUint64Array'
];
function is(value) {
    if (value === null) return 'null';
    if (value === undefined) return 'undefined';
    if (value === true || value === false) return 'boolean';
    const typeOf = typeof value;
    if (typeofs.includes(typeOf)) return typeOf;
    if (typeOf === 'function') return 'Function';
    if (Array.isArray(value)) return 'Array';
    if (isBuffer(value)) return 'Buffer';
    const objectType = getObjectType(value);
    if (objectType) return objectType;
    return 'Object';
}
function isBuffer(value) {
    return value && value.constructor && value.constructor.isBuffer && value.constructor.isBuffer.call(null, value);
}
function getObjectType(value) {
    const objectTypeName = Object.prototype.toString.call(value).slice(8, -1);
    if (objectTypeNames.includes(objectTypeName)) return objectTypeName;
    return undefined;
}
exports.is = is;

},{}],"7qjkh":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
class Type {
    constructor(major, name, terminal){
        this.major = major;
        this.majorEncoded = major << 5;
        this.name = name;
        this.terminal = terminal;
    }
    toString() {
        return `Type[${this.major}].${this.name}`;
    }
    compare(typ) {
        return this.major < typ.major ? -1 : this.major > typ.major ? 1 : 0;
    }
}
Type.uint = new Type(0, 'uint', true);
Type.negint = new Type(1, 'negint', true);
Type.bytes = new Type(2, 'bytes', true);
Type.string = new Type(3, 'string', true);
Type.array = new Type(4, 'array', false);
Type.map = new Type(5, 'map', false);
Type.tag = new Type(6, 'tag', false);
Type.float = new Type(7, 'float', true);
Type.false = new Type(7, 'false', true);
Type.true = new Type(7, 'true', true);
Type.null = new Type(7, 'null', true);
Type.undefined = new Type(7, 'undefined', true);
Type.break = new Type(7, 'break', true);
class Token {
    constructor(type, value, encodedLength){
        this.type = type;
        this.value = value;
        this.encodedLength = encodedLength;
        this.encodedBytes = undefined;
        this.byteValue = undefined;
    }
    toString() {
        return `Token[${this.type}].${this.value}`;
    }
}
exports.Token = Token;
exports.Type = Type;

},{}],"34kzh":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var byteUtils = require("ecfb3bfaabc74275");
const defaultChunkSize = 256;
class Bl {
    constructor(chunkSize = defaultChunkSize){
        this.chunkSize = chunkSize;
        this.cursor = 0;
        this.maxCursor = -1;
        this.chunks = [];
        this._initReuseChunk = null;
    }
    reset() {
        this.cursor = 0;
        this.maxCursor = -1;
        if (this.chunks.length) this.chunks = [];
        if (this._initReuseChunk !== null) {
            this.chunks.push(this._initReuseChunk);
            this.maxCursor = this._initReuseChunk.length - 1;
        }
    }
    push(bytes) {
        let topChunk = this.chunks[this.chunks.length - 1];
        const newMax = this.cursor + bytes.length;
        if (newMax <= this.maxCursor + 1) {
            const chunkPos = topChunk.length - (this.maxCursor - this.cursor) - 1;
            topChunk.set(bytes, chunkPos);
        } else {
            if (topChunk) {
                const chunkPos = topChunk.length - (this.maxCursor - this.cursor) - 1;
                if (chunkPos < topChunk.length) {
                    this.chunks[this.chunks.length - 1] = topChunk.subarray(0, chunkPos);
                    this.maxCursor = this.cursor - 1;
                }
            }
            if (bytes.length < 64 && bytes.length < this.chunkSize) {
                topChunk = byteUtils.alloc(this.chunkSize);
                this.chunks.push(topChunk);
                this.maxCursor += topChunk.length;
                if (this._initReuseChunk === null) this._initReuseChunk = topChunk;
                topChunk.set(bytes, 0);
            } else {
                this.chunks.push(bytes);
                this.maxCursor += bytes.length;
            }
        }
        this.cursor += bytes.length;
    }
    toBytes(reset = false) {
        let byts;
        if (this.chunks.length === 1) {
            const chunk = this.chunks[0];
            if (reset && this.cursor > chunk.length / 2) {
                byts = this.cursor === chunk.length ? chunk : chunk.subarray(0, this.cursor);
                this._initReuseChunk = null;
                this.chunks = [];
            } else byts = byteUtils.slice(chunk, 0, this.cursor);
        } else byts = byteUtils.concat(this.chunks, this.cursor);
        if (reset) this.reset();
        return byts;
    }
}
exports.Bl = Bl;

},{"ecfb3bfaabc74275":"2T5kV"}],"2T5kV":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
const useBuffer = globalThis.process && !globalThis.process.browser && globalThis.Buffer && typeof globalThis.Buffer.isBuffer === 'function';
const textDecoder = new TextDecoder();
const textEncoder = new TextEncoder();
function isBuffer(buf) {
    return useBuffer && globalThis.Buffer.isBuffer(buf);
}
function asU8A(buf) {
    if (!(buf instanceof Uint8Array)) return Uint8Array.from(buf);
    return isBuffer(buf) ? new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength) : buf;
}
const toString = useBuffer ? (bytes, start, end)=>{
    return end - start > 64 ? globalThis.Buffer.from(bytes.subarray(start, end)).toString('utf8') : utf8Slice(bytes, start, end);
} : (bytes, start, end)=>{
    return end - start > 64 ? textDecoder.decode(bytes.subarray(start, end)) : utf8Slice(bytes, start, end);
};
const fromString = useBuffer ? (string)=>{
    return string.length > 64 ? globalThis.Buffer.from(string) : utf8ToBytes(string);
} : (string)=>{
    return string.length > 64 ? textEncoder.encode(string) : utf8ToBytes(string);
};
const fromArray = (arr)=>{
    return Uint8Array.from(arr);
};
const slice = useBuffer ? (bytes, start, end)=>{
    if (isBuffer(bytes)) return new Uint8Array(bytes.subarray(start, end));
    return bytes.slice(start, end);
} : (bytes, start, end)=>{
    return bytes.slice(start, end);
};
const concat = useBuffer ? (chunks, length)=>{
    chunks = chunks.map((c)=>c instanceof Uint8Array ? c : globalThis.Buffer.from(c));
    return asU8A(globalThis.Buffer.concat(chunks, length));
} : (chunks, length)=>{
    const out = new Uint8Array(length);
    let off = 0;
    for (let b of chunks){
        if (off + b.length > out.length) b = b.subarray(0, out.length - off);
        out.set(b, off);
        off += b.length;
    }
    return out;
};
const alloc = useBuffer ? (size)=>{
    return globalThis.Buffer.allocUnsafe(size);
} : (size)=>{
    return new Uint8Array(size);
};
const toHex = useBuffer ? (d)=>{
    if (typeof d === 'string') return d;
    return globalThis.Buffer.from(toBytes(d)).toString('hex');
} : (d)=>{
    if (typeof d === 'string') return d;
    return Array.prototype.reduce.call(toBytes(d), (p, c)=>`${p}${c.toString(16).padStart(2, '0')}`, '');
};
const fromHex = useBuffer ? (hex)=>{
    if (hex instanceof Uint8Array) return hex;
    return globalThis.Buffer.from(hex, 'hex');
} : (hex)=>{
    if (hex instanceof Uint8Array) return hex;
    if (!hex.length) return new Uint8Array(0);
    return new Uint8Array(hex.split('').map((c, i, d)=>i % 2 === 0 ? `0x${c}${d[i + 1]}` : '').filter(Boolean).map((e)=>parseInt(e, 16)));
};
function toBytes(obj) {
    if (obj instanceof Uint8Array && obj.constructor.name === 'Uint8Array') return obj;
    if (obj instanceof ArrayBuffer) return new Uint8Array(obj);
    if (ArrayBuffer.isView(obj)) return new Uint8Array(obj.buffer, obj.byteOffset, obj.byteLength);
    throw new Error('Unknown type, must be binary type');
}
function compare(b1, b2) {
    if (isBuffer(b1) && isBuffer(b2)) return b1.compare(b2);
    for(let i = 0; i < b1.length; i++){
        if (b1[i] === b2[i]) continue;
        return b1[i] < b2[i] ? -1 : 1;
    }
    return 0;
}
function utf8ToBytes(string, units = Infinity) {
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        if (codePoint > 55295 && codePoint < 57344) {
            if (!leadSurrogate) {
                if (codePoint > 56319) {
                    if ((units -= 3) > -1) bytes.push(239, 191, 189);
                    continue;
                } else if (i + 1 === length) {
                    if ((units -= 3) > -1) bytes.push(239, 191, 189);
                    continue;
                }
                leadSurrogate = codePoint;
                continue;
            }
            if (codePoint < 56320) {
                if ((units -= 3) > -1) bytes.push(239, 191, 189);
                leadSurrogate = codePoint;
                continue;
            }
            codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
        } else if (leadSurrogate) {
            if ((units -= 3) > -1) bytes.push(239, 191, 189);
        }
        leadSurrogate = null;
        if (codePoint < 128) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 2048) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 6 | 192, codePoint & 63 | 128);
        } else if (codePoint < 65536) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 12 | 224, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
        } else if (codePoint < 1114112) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 18 | 240, codePoint >> 12 & 63 | 128, codePoint >> 6 & 63 | 128, codePoint & 63 | 128);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function utf8Slice(buf, offset, end) {
    const res = [];
    while(offset < end){
        const firstByte = buf[offset];
        let codePoint = null;
        let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
        if (offset + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 128) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[offset + 1];
                    if ((secondByte & 192) === 128) {
                        tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                        if (tempCodePoint > 127) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[offset + 1];
                    thirdByte = buf[offset + 2];
                    if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                        tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                        if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[offset + 1];
                    thirdByte = buf[offset + 2];
                    fourthByte = buf[offset + 3];
                    if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                        tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                        if (tempCodePoint > 65535 && tempCodePoint < 1114112) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            codePoint = 65533;
            bytesPerSequence = 1;
        } else if (codePoint > 65535) {
            codePoint -= 65536;
            res.push(codePoint >>> 10 & 1023 | 55296);
            codePoint = 56320 | codePoint & 1023;
        }
        res.push(codePoint);
        offset += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
const MAX_ARGUMENTS_LENGTH = 4096;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints);
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
exports.alloc = alloc;
exports.asU8A = asU8A;
exports.compare = compare;
exports.concat = concat;
exports.decodeCodePointsArray = decodeCodePointsArray;
exports.fromArray = fromArray;
exports.fromHex = fromHex;
exports.fromString = fromString;
exports.slice = slice;
exports.toHex = toHex;
exports.toString = toString;
exports.useBuffer = useBuffer;

},{}],"ludQE":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
const decodeErrPrefix = 'CBOR decode error:';
const encodeErrPrefix = 'CBOR encode error:';
const uintMinorPrefixBytes = [];
uintMinorPrefixBytes[23] = 1;
uintMinorPrefixBytes[24] = 2;
uintMinorPrefixBytes[25] = 3;
uintMinorPrefixBytes[26] = 5;
uintMinorPrefixBytes[27] = 9;
function assertEnoughData(data, pos, need) {
    if (data.length - pos < need) throw new Error(`${decodeErrPrefix} not enough data for type`);
}
exports.assertEnoughData = assertEnoughData;
exports.decodeErrPrefix = decodeErrPrefix;
exports.encodeErrPrefix = encodeErrPrefix;
exports.uintMinorPrefixBytes = uintMinorPrefixBytes;

},{}],"PnvSj":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var token = require("29e8810831c8a803");
var _0uint = require("efc4559b22d9669a");
var _1negint = require("b7e0d56f865ae009");
var _2bytes = require("2bbcf7bef2f1195d");
var _3string = require("3edb62615aa04539");
var _4array = require("f7b93d0dd2ef7ce0");
var _5map = require("df46a7f6d4858b86");
var _6tag = require("2c2755be0a2e2a24");
var _7float = require("62f61dbbe78c9769");
var common = require("b1ebc97b8a651431");
var byteUtils = require("af3858d0b4d053bb");
function invalidMinor(data, pos, minor) {
    throw new Error(`${common.decodeErrPrefix} encountered invalid minor (${minor}) for major ${data[pos] >>> 5}`);
}
function errorer(msg) {
    return ()=>{
        throw new Error(`${common.decodeErrPrefix} ${msg}`);
    };
}
const jump = [];
for(let i = 0; i <= 23; i++)jump[i] = invalidMinor;
jump[24] = _0uint.decodeUint8;
jump[25] = _0uint.decodeUint16;
jump[26] = _0uint.decodeUint32;
jump[27] = _0uint.decodeUint64;
jump[28] = invalidMinor;
jump[29] = invalidMinor;
jump[30] = invalidMinor;
jump[31] = invalidMinor;
for(let i = 32; i <= 55; i++)jump[i] = invalidMinor;
jump[56] = _1negint.decodeNegint8;
jump[57] = _1negint.decodeNegint16;
jump[58] = _1negint.decodeNegint32;
jump[59] = _1negint.decodeNegint64;
jump[60] = invalidMinor;
jump[61] = invalidMinor;
jump[62] = invalidMinor;
jump[63] = invalidMinor;
for(let i = 64; i <= 87; i++)jump[i] = _2bytes.decodeBytesCompact;
jump[88] = _2bytes.decodeBytes8;
jump[89] = _2bytes.decodeBytes16;
jump[90] = _2bytes.decodeBytes32;
jump[91] = _2bytes.decodeBytes64;
jump[92] = invalidMinor;
jump[93] = invalidMinor;
jump[94] = invalidMinor;
jump[95] = errorer('indefinite length bytes/strings are not supported');
for(let i = 96; i <= 119; i++)jump[i] = _3string.decodeStringCompact;
jump[120] = _3string.decodeString8;
jump[121] = _3string.decodeString16;
jump[122] = _3string.decodeString32;
jump[123] = _3string.decodeString64;
jump[124] = invalidMinor;
jump[125] = invalidMinor;
jump[126] = invalidMinor;
jump[127] = errorer('indefinite length bytes/strings are not supported');
for(let i = 128; i <= 151; i++)jump[i] = _4array.decodeArrayCompact;
jump[152] = _4array.decodeArray8;
jump[153] = _4array.decodeArray16;
jump[154] = _4array.decodeArray32;
jump[155] = _4array.decodeArray64;
jump[156] = invalidMinor;
jump[157] = invalidMinor;
jump[158] = invalidMinor;
jump[159] = _4array.decodeArrayIndefinite;
for(let i = 160; i <= 183; i++)jump[i] = _5map.decodeMapCompact;
jump[184] = _5map.decodeMap8;
jump[185] = _5map.decodeMap16;
jump[186] = _5map.decodeMap32;
jump[187] = _5map.decodeMap64;
jump[188] = invalidMinor;
jump[189] = invalidMinor;
jump[190] = invalidMinor;
jump[191] = _5map.decodeMapIndefinite;
for(let i = 192; i <= 215; i++)jump[i] = _6tag.decodeTagCompact;
jump[216] = _6tag.decodeTag8;
jump[217] = _6tag.decodeTag16;
jump[218] = _6tag.decodeTag32;
jump[219] = _6tag.decodeTag64;
jump[220] = invalidMinor;
jump[221] = invalidMinor;
jump[222] = invalidMinor;
jump[223] = invalidMinor;
for(let i = 224; i <= 243; i++)jump[i] = errorer('simple values are not supported');
jump[244] = invalidMinor;
jump[245] = invalidMinor;
jump[246] = invalidMinor;
jump[247] = _7float.decodeUndefined;
jump[248] = errorer('simple values are not supported');
jump[249] = _7float.decodeFloat16;
jump[250] = _7float.decodeFloat32;
jump[251] = _7float.decodeFloat64;
jump[252] = invalidMinor;
jump[253] = invalidMinor;
jump[254] = invalidMinor;
jump[255] = _7float.decodeBreak;
const quick = [];
for(let i = 0; i < 24; i++)quick[i] = new token.Token(token.Type.uint, i, 1);
for(let i = -1; i >= -24; i--)quick[31 - i] = new token.Token(token.Type.negint, i, 1);
quick[64] = new token.Token(token.Type.bytes, new Uint8Array(0), 1);
quick[96] = new token.Token(token.Type.string, '', 1);
quick[128] = new token.Token(token.Type.array, 0, 1);
quick[160] = new token.Token(token.Type.map, 0, 1);
quick[244] = new token.Token(token.Type.false, false, 1);
quick[245] = new token.Token(token.Type.true, true, 1);
quick[246] = new token.Token(token.Type.null, null, 1);
function quickEncodeToken(token$1) {
    switch(token$1.type){
        case token.Type.false:
            return byteUtils.fromArray([
                244
            ]);
        case token.Type.true:
            return byteUtils.fromArray([
                245
            ]);
        case token.Type.null:
            return byteUtils.fromArray([
                246
            ]);
        case token.Type.bytes:
            if (!token$1.value.length) return byteUtils.fromArray([
                64
            ]);
            return;
        case token.Type.string:
            if (token$1.value === '') return byteUtils.fromArray([
                96
            ]);
            return;
        case token.Type.array:
            if (token$1.value === 0) return byteUtils.fromArray([
                128
            ]);
            return;
        case token.Type.map:
            if (token$1.value === 0) return byteUtils.fromArray([
                160
            ]);
            return;
        case token.Type.uint:
            if (token$1.value < 24) return byteUtils.fromArray([
                Number(token$1.value)
            ]);
            return;
        case token.Type.negint:
            if (token$1.value >= -24) return byteUtils.fromArray([
                31 - Number(token$1.value)
            ]);
    }
}
exports.jump = jump;
exports.quick = quick;
exports.quickEncodeToken = quickEncodeToken;

},{"29e8810831c8a803":"7qjkh","efc4559b22d9669a":"3gULd","b7e0d56f865ae009":"47VNP","2bbcf7bef2f1195d":"77qlu","3edb62615aa04539":"e5YTj","f7b93d0dd2ef7ce0":"cjJXs","df46a7f6d4858b86":"dYZNG","2c2755be0a2e2a24":"41jpR","62f61dbbe78c9769":"e0MrV","b1ebc97b8a651431":"ludQE","af3858d0b4d053bb":"2T5kV"}],"3gULd":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var token = require("6a5fc7ff5fb02684");
var common = require("b1bda3a8a0f90508");
const uintBoundaries = [
    24,
    256,
    65536,
    4294967296,
    BigInt('18446744073709551616')
];
function readUint8(data, offset, options) {
    common.assertEnoughData(data, offset, 1);
    const value = data[offset];
    if (options.strict === true && value < uintBoundaries[0]) throw new Error(`${common.decodeErrPrefix} integer encoded in more bytes than necessary (strict decode)`);
    return value;
}
function readUint16(data, offset, options) {
    common.assertEnoughData(data, offset, 2);
    const value = data[offset] << 8 | data[offset + 1];
    if (options.strict === true && value < uintBoundaries[1]) throw new Error(`${common.decodeErrPrefix} integer encoded in more bytes than necessary (strict decode)`);
    return value;
}
function readUint32(data, offset, options) {
    common.assertEnoughData(data, offset, 4);
    const value = data[offset] * 16777216 + (data[offset + 1] << 16) + (data[offset + 2] << 8) + data[offset + 3];
    if (options.strict === true && value < uintBoundaries[2]) throw new Error(`${common.decodeErrPrefix} integer encoded in more bytes than necessary (strict decode)`);
    return value;
}
function readUint64(data, offset, options) {
    common.assertEnoughData(data, offset, 8);
    const hi = data[offset] * 16777216 + (data[offset + 1] << 16) + (data[offset + 2] << 8) + data[offset + 3];
    const lo = data[offset + 4] * 16777216 + (data[offset + 5] << 16) + (data[offset + 6] << 8) + data[offset + 7];
    const value = (BigInt(hi) << BigInt(32)) + BigInt(lo);
    if (options.strict === true && value < uintBoundaries[3]) throw new Error(`${common.decodeErrPrefix} integer encoded in more bytes than necessary (strict decode)`);
    if (value <= Number.MAX_SAFE_INTEGER) return Number(value);
    if (options.allowBigInt === true) return value;
    throw new Error(`${common.decodeErrPrefix} integers outside of the safe integer range are not supported`);
}
function decodeUint8(data, pos, _minor, options) {
    return new token.Token(token.Type.uint, readUint8(data, pos + 1, options), 2);
}
function decodeUint16(data, pos, _minor, options) {
    return new token.Token(token.Type.uint, readUint16(data, pos + 1, options), 3);
}
function decodeUint32(data, pos, _minor, options) {
    return new token.Token(token.Type.uint, readUint32(data, pos + 1, options), 5);
}
function decodeUint64(data, pos, _minor, options) {
    return new token.Token(token.Type.uint, readUint64(data, pos + 1, options), 9);
}
function encodeUint(buf, token) {
    return encodeUintValue(buf, 0, token.value);
}
function encodeUintValue(buf, major, uint) {
    if (uint < uintBoundaries[0]) {
        const nuint = Number(uint);
        buf.push([
            major | nuint
        ]);
    } else if (uint < uintBoundaries[1]) {
        const nuint = Number(uint);
        buf.push([
            major | 24,
            nuint
        ]);
    } else if (uint < uintBoundaries[2]) {
        const nuint = Number(uint);
        buf.push([
            major | 25,
            nuint >>> 8,
            nuint & 255
        ]);
    } else if (uint < uintBoundaries[3]) {
        const nuint = Number(uint);
        buf.push([
            major | 26,
            nuint >>> 24 & 255,
            nuint >>> 16 & 255,
            nuint >>> 8 & 255,
            nuint & 255
        ]);
    } else {
        const buint = BigInt(uint);
        if (buint < uintBoundaries[4]) {
            const set = [
                major | 27,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ];
            let lo = Number(buint & BigInt(4294967295));
            let hi = Number(buint >> BigInt(32) & BigInt(4294967295));
            set[8] = lo & 255;
            lo = lo >> 8;
            set[7] = lo & 255;
            lo = lo >> 8;
            set[6] = lo & 255;
            lo = lo >> 8;
            set[5] = lo & 255;
            set[4] = hi & 255;
            hi = hi >> 8;
            set[3] = hi & 255;
            hi = hi >> 8;
            set[2] = hi & 255;
            hi = hi >> 8;
            set[1] = hi & 255;
            buf.push(set);
        } else throw new Error(`${common.decodeErrPrefix} encountered BigInt larger than allowable range`);
    }
}
encodeUint.encodedSize = function encodedSize(token) {
    return encodeUintValue.encodedSize(token.value);
};
encodeUintValue.encodedSize = function encodedSize(uint) {
    if (uint < uintBoundaries[0]) return 1;
    if (uint < uintBoundaries[1]) return 2;
    if (uint < uintBoundaries[2]) return 3;
    if (uint < uintBoundaries[3]) return 5;
    return 9;
};
encodeUint.compareTokens = function compareTokens(tok1, tok2) {
    return tok1.value < tok2.value ? -1 : tok1.value > tok2.value ? 1 : 0;
};
exports.decodeUint16 = decodeUint16;
exports.decodeUint32 = decodeUint32;
exports.decodeUint64 = decodeUint64;
exports.decodeUint8 = decodeUint8;
exports.encodeUint = encodeUint;
exports.encodeUintValue = encodeUintValue;
exports.readUint16 = readUint16;
exports.readUint32 = readUint32;
exports.readUint64 = readUint64;
exports.readUint8 = readUint8;
exports.uintBoundaries = uintBoundaries;

},{"6a5fc7ff5fb02684":"7qjkh","b1bda3a8a0f90508":"ludQE"}],"47VNP":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var token = require("442378fa5d3fd9eb");
var _0uint = require("c024facf79cf5306");
var common = require("8e3895163a18dff6");
function decodeNegint8(data, pos, _minor, options) {
    return new token.Token(token.Type.negint, -1 - _0uint.readUint8(data, pos + 1, options), 2);
}
function decodeNegint16(data, pos, _minor, options) {
    return new token.Token(token.Type.negint, -1 - _0uint.readUint16(data, pos + 1, options), 3);
}
function decodeNegint32(data, pos, _minor, options) {
    return new token.Token(token.Type.negint, -1 - _0uint.readUint32(data, pos + 1, options), 5);
}
const neg1b = BigInt(-1);
const pos1b = BigInt(1);
function decodeNegint64(data, pos, _minor, options) {
    const int = _0uint.readUint64(data, pos + 1, options);
    if (typeof int !== 'bigint') {
        const value = -1 - int;
        if (value >= Number.MIN_SAFE_INTEGER) return new token.Token(token.Type.negint, value, 9);
    }
    if (options.allowBigInt !== true) throw new Error(`${common.decodeErrPrefix} integers outside of the safe integer range are not supported`);
    return new token.Token(token.Type.negint, neg1b - BigInt(int), 9);
}
function encodeNegint(buf, token) {
    const negint = token.value;
    const unsigned = typeof negint === 'bigint' ? negint * neg1b - pos1b : negint * -1 - 1;
    _0uint.encodeUintValue(buf, token.type.majorEncoded, unsigned);
}
encodeNegint.encodedSize = function encodedSize(token) {
    const negint = token.value;
    const unsigned = typeof negint === 'bigint' ? negint * neg1b - pos1b : negint * -1 - 1;
    if (unsigned < _0uint.uintBoundaries[0]) return 1;
    if (unsigned < _0uint.uintBoundaries[1]) return 2;
    if (unsigned < _0uint.uintBoundaries[2]) return 3;
    if (unsigned < _0uint.uintBoundaries[3]) return 5;
    return 9;
};
encodeNegint.compareTokens = function compareTokens(tok1, tok2) {
    return tok1.value < tok2.value ? 1 : tok1.value > tok2.value ? -1 : 0;
};
exports.decodeNegint16 = decodeNegint16;
exports.decodeNegint32 = decodeNegint32;
exports.decodeNegint64 = decodeNegint64;
exports.decodeNegint8 = decodeNegint8;
exports.encodeNegint = encodeNegint;

},{"442378fa5d3fd9eb":"7qjkh","c024facf79cf5306":"3gULd","8e3895163a18dff6":"ludQE"}],"77qlu":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var token = require("e5fa5fecced10c3f");
var common = require("b42b6d1506e0be5d");
var _0uint = require("c8caa8feff3d44c3");
var byteUtils = require("b8ddce3603d641d2");
function toToken(data, pos, prefix, length) {
    common.assertEnoughData(data, pos, prefix + length);
    const buf = byteUtils.slice(data, pos + prefix, pos + prefix + length);
    return new token.Token(token.Type.bytes, buf, prefix + length);
}
function decodeBytesCompact(data, pos, minor, _options) {
    return toToken(data, pos, 1, minor);
}
function decodeBytes8(data, pos, _minor, options) {
    return toToken(data, pos, 2, _0uint.readUint8(data, pos + 1, options));
}
function decodeBytes16(data, pos, _minor, options) {
    return toToken(data, pos, 3, _0uint.readUint16(data, pos + 1, options));
}
function decodeBytes32(data, pos, _minor, options) {
    return toToken(data, pos, 5, _0uint.readUint32(data, pos + 1, options));
}
function decodeBytes64(data, pos, _minor, options) {
    const l = _0uint.readUint64(data, pos + 1, options);
    if (typeof l === 'bigint') throw new Error(`${common.decodeErrPrefix} 64-bit integer bytes lengths not supported`);
    return toToken(data, pos, 9, l);
}
function tokenBytes(token$1) {
    if (token$1.encodedBytes === undefined) token$1.encodedBytes = token$1.type === token.Type.string ? byteUtils.fromString(token$1.value) : token$1.value;
    return token$1.encodedBytes;
}
function encodeBytes(buf, token) {
    const bytes = tokenBytes(token);
    _0uint.encodeUintValue(buf, token.type.majorEncoded, bytes.length);
    buf.push(bytes);
}
encodeBytes.encodedSize = function encodedSize(token) {
    const bytes = tokenBytes(token);
    return _0uint.encodeUintValue.encodedSize(bytes.length) + bytes.length;
};
encodeBytes.compareTokens = function compareTokens(tok1, tok2) {
    return compareBytes(tokenBytes(tok1), tokenBytes(tok2));
};
function compareBytes(b1, b2) {
    return b1.length < b2.length ? -1 : b1.length > b2.length ? 1 : byteUtils.compare(b1, b2);
}
exports.compareBytes = compareBytes;
exports.decodeBytes16 = decodeBytes16;
exports.decodeBytes32 = decodeBytes32;
exports.decodeBytes64 = decodeBytes64;
exports.decodeBytes8 = decodeBytes8;
exports.decodeBytesCompact = decodeBytesCompact;
exports.encodeBytes = encodeBytes;

},{"e5fa5fecced10c3f":"7qjkh","b42b6d1506e0be5d":"ludQE","c8caa8feff3d44c3":"3gULd","b8ddce3603d641d2":"2T5kV"}],"e5YTj":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var token = require("6cffd868494ddcee");
var common = require("c609cb350f2835d1");
var _0uint = require("8acb5e72b5e5cce6");
var _2bytes = require("5bbca5c6f30bdfd6");
var byteUtils = require("d2b2e97a7c39982a");
function toToken(data, pos, prefix, length, options) {
    const totLength = prefix + length;
    common.assertEnoughData(data, pos, totLength);
    const tok = new token.Token(token.Type.string, byteUtils.toString(data, pos + prefix, pos + totLength), totLength);
    if (options.retainStringBytes === true) tok.byteValue = byteUtils.slice(data, pos + prefix, pos + totLength);
    return tok;
}
function decodeStringCompact(data, pos, minor, options) {
    return toToken(data, pos, 1, minor, options);
}
function decodeString8(data, pos, _minor, options) {
    return toToken(data, pos, 2, _0uint.readUint8(data, pos + 1, options), options);
}
function decodeString16(data, pos, _minor, options) {
    return toToken(data, pos, 3, _0uint.readUint16(data, pos + 1, options), options);
}
function decodeString32(data, pos, _minor, options) {
    return toToken(data, pos, 5, _0uint.readUint32(data, pos + 1, options), options);
}
function decodeString64(data, pos, _minor, options) {
    const l = _0uint.readUint64(data, pos + 1, options);
    if (typeof l === 'bigint') throw new Error(`${common.decodeErrPrefix} 64-bit integer string lengths not supported`);
    return toToken(data, pos, 9, l, options);
}
const encodeString = _2bytes.encodeBytes;
exports.decodeString16 = decodeString16;
exports.decodeString32 = decodeString32;
exports.decodeString64 = decodeString64;
exports.decodeString8 = decodeString8;
exports.decodeStringCompact = decodeStringCompact;
exports.encodeString = encodeString;

},{"6cffd868494ddcee":"7qjkh","c609cb350f2835d1":"ludQE","8acb5e72b5e5cce6":"3gULd","5bbca5c6f30bdfd6":"77qlu","d2b2e97a7c39982a":"2T5kV"}],"cjJXs":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var token = require("ed71a5f66f1a4fbf");
var _0uint = require("f6df0ec2c9ca76b0");
var common = require("35f04e82a2a4f151");
function toToken(_data, _pos, prefix, length) {
    return new token.Token(token.Type.array, length, prefix);
}
function decodeArrayCompact(data, pos, minor, _options) {
    return toToken(data, pos, 1, minor);
}
function decodeArray8(data, pos, _minor, options) {
    return toToken(data, pos, 2, _0uint.readUint8(data, pos + 1, options));
}
function decodeArray16(data, pos, _minor, options) {
    return toToken(data, pos, 3, _0uint.readUint16(data, pos + 1, options));
}
function decodeArray32(data, pos, _minor, options) {
    return toToken(data, pos, 5, _0uint.readUint32(data, pos + 1, options));
}
function decodeArray64(data, pos, _minor, options) {
    const l = _0uint.readUint64(data, pos + 1, options);
    if (typeof l === 'bigint') throw new Error(`${common.decodeErrPrefix} 64-bit integer array lengths not supported`);
    return toToken(data, pos, 9, l);
}
function decodeArrayIndefinite(data, pos, _minor, options) {
    if (options.allowIndefinite === false) throw new Error(`${common.decodeErrPrefix} indefinite length items not allowed`);
    return toToken(data, pos, 1, Infinity);
}
function encodeArray(buf, token$1) {
    _0uint.encodeUintValue(buf, token.Type.array.majorEncoded, token$1.value);
}
encodeArray.compareTokens = _0uint.encodeUint.compareTokens;
encodeArray.encodedSize = function encodedSize(token) {
    return _0uint.encodeUintValue.encodedSize(token.value);
};
exports.decodeArray16 = decodeArray16;
exports.decodeArray32 = decodeArray32;
exports.decodeArray64 = decodeArray64;
exports.decodeArray8 = decodeArray8;
exports.decodeArrayCompact = decodeArrayCompact;
exports.decodeArrayIndefinite = decodeArrayIndefinite;
exports.encodeArray = encodeArray;

},{"ed71a5f66f1a4fbf":"7qjkh","f6df0ec2c9ca76b0":"3gULd","35f04e82a2a4f151":"ludQE"}],"dYZNG":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var token = require("77ec5bc62d7f7541");
var _0uint = require("acda14c93d7a6c0f");
var common = require("d488b60a13b57bf6");
function toToken(_data, _pos, prefix, length) {
    return new token.Token(token.Type.map, length, prefix);
}
function decodeMapCompact(data, pos, minor, _options) {
    return toToken(data, pos, 1, minor);
}
function decodeMap8(data, pos, _minor, options) {
    return toToken(data, pos, 2, _0uint.readUint8(data, pos + 1, options));
}
function decodeMap16(data, pos, _minor, options) {
    return toToken(data, pos, 3, _0uint.readUint16(data, pos + 1, options));
}
function decodeMap32(data, pos, _minor, options) {
    return toToken(data, pos, 5, _0uint.readUint32(data, pos + 1, options));
}
function decodeMap64(data, pos, _minor, options) {
    const l = _0uint.readUint64(data, pos + 1, options);
    if (typeof l === 'bigint') throw new Error(`${common.decodeErrPrefix} 64-bit integer map lengths not supported`);
    return toToken(data, pos, 9, l);
}
function decodeMapIndefinite(data, pos, _minor, options) {
    if (options.allowIndefinite === false) throw new Error(`${common.decodeErrPrefix} indefinite length items not allowed`);
    return toToken(data, pos, 1, Infinity);
}
function encodeMap(buf, token$1) {
    _0uint.encodeUintValue(buf, token.Type.map.majorEncoded, token$1.value);
}
encodeMap.compareTokens = _0uint.encodeUint.compareTokens;
encodeMap.encodedSize = function encodedSize(token) {
    return _0uint.encodeUintValue.encodedSize(token.value);
};
exports.decodeMap16 = decodeMap16;
exports.decodeMap32 = decodeMap32;
exports.decodeMap64 = decodeMap64;
exports.decodeMap8 = decodeMap8;
exports.decodeMapCompact = decodeMapCompact;
exports.decodeMapIndefinite = decodeMapIndefinite;
exports.encodeMap = encodeMap;

},{"77ec5bc62d7f7541":"7qjkh","acda14c93d7a6c0f":"3gULd","d488b60a13b57bf6":"ludQE"}],"41jpR":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var token = require("2f4509d0a0142f23");
var _0uint = require("fc7a770869b7a8f3");
function decodeTagCompact(_data, _pos, minor, _options) {
    return new token.Token(token.Type.tag, minor, 1);
}
function decodeTag8(data, pos, _minor, options) {
    return new token.Token(token.Type.tag, _0uint.readUint8(data, pos + 1, options), 2);
}
function decodeTag16(data, pos, _minor, options) {
    return new token.Token(token.Type.tag, _0uint.readUint16(data, pos + 1, options), 3);
}
function decodeTag32(data, pos, _minor, options) {
    return new token.Token(token.Type.tag, _0uint.readUint32(data, pos + 1, options), 5);
}
function decodeTag64(data, pos, _minor, options) {
    return new token.Token(token.Type.tag, _0uint.readUint64(data, pos + 1, options), 9);
}
function encodeTag(buf, token$1) {
    _0uint.encodeUintValue(buf, token.Type.tag.majorEncoded, token$1.value);
}
encodeTag.compareTokens = _0uint.encodeUint.compareTokens;
encodeTag.encodedSize = function encodedSize(token) {
    return _0uint.encodeUintValue.encodedSize(token.value);
};
exports.decodeTag16 = decodeTag16;
exports.decodeTag32 = decodeTag32;
exports.decodeTag64 = decodeTag64;
exports.decodeTag8 = decodeTag8;
exports.decodeTagCompact = decodeTagCompact;
exports.encodeTag = encodeTag;

},{"2f4509d0a0142f23":"7qjkh","fc7a770869b7a8f3":"3gULd"}],"e0MrV":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var token = require("574d07bd71f75604");
var common = require("2cda160f97f0be62");
var _0uint = require("f7945f7014a9bebe");
const MINOR_FALSE = 20;
const MINOR_TRUE = 21;
const MINOR_NULL = 22;
const MINOR_UNDEFINED = 23;
function decodeUndefined(_data, _pos, _minor, options) {
    if (options.allowUndefined === false) throw new Error(`${common.decodeErrPrefix} undefined values are not supported`);
    else if (options.coerceUndefinedToNull === true) return new token.Token(token.Type.null, null, 1);
    return new token.Token(token.Type.undefined, undefined, 1);
}
function decodeBreak(_data, _pos, _minor, options) {
    if (options.allowIndefinite === false) throw new Error(`${common.decodeErrPrefix} indefinite length items not allowed`);
    return new token.Token(token.Type.break, undefined, 1);
}
function createToken(value, bytes, options) {
    if (options) {
        if (options.allowNaN === false && Number.isNaN(value)) throw new Error(`${common.decodeErrPrefix} NaN values are not supported`);
        if (options.allowInfinity === false && (value === Infinity || value === -Infinity)) throw new Error(`${common.decodeErrPrefix} Infinity values are not supported`);
    }
    return new token.Token(token.Type.float, value, bytes);
}
function decodeFloat16(data, pos, _minor, options) {
    return createToken(readFloat16(data, pos + 1), 3, options);
}
function decodeFloat32(data, pos, _minor, options) {
    return createToken(readFloat32(data, pos + 1), 5, options);
}
function decodeFloat64(data, pos, _minor, options) {
    return createToken(readFloat64(data, pos + 1), 9, options);
}
function encodeFloat(buf, token$1, options) {
    const float = token$1.value;
    if (float === false) buf.push([
        token.Type.float.majorEncoded | MINOR_FALSE
    ]);
    else if (float === true) buf.push([
        token.Type.float.majorEncoded | MINOR_TRUE
    ]);
    else if (float === null) buf.push([
        token.Type.float.majorEncoded | MINOR_NULL
    ]);
    else if (float === undefined) buf.push([
        token.Type.float.majorEncoded | MINOR_UNDEFINED
    ]);
    else {
        let decoded;
        let success = false;
        if (!options || options.float64 !== true) {
            encodeFloat16(float);
            decoded = readFloat16(ui8a, 1);
            if (float === decoded || Number.isNaN(float)) {
                ui8a[0] = 249;
                buf.push(ui8a.slice(0, 3));
                success = true;
            } else {
                encodeFloat32(float);
                decoded = readFloat32(ui8a, 1);
                if (float === decoded) {
                    ui8a[0] = 250;
                    buf.push(ui8a.slice(0, 5));
                    success = true;
                }
            }
        }
        if (!success) {
            encodeFloat64(float);
            decoded = readFloat64(ui8a, 1);
            ui8a[0] = 251;
            buf.push(ui8a.slice(0, 9));
        }
    }
}
encodeFloat.encodedSize = function encodedSize(token, options) {
    const float = token.value;
    if (float === false || float === true || float === null || float === undefined) return 1;
    if (!options || options.float64 !== true) {
        encodeFloat16(float);
        let decoded = readFloat16(ui8a, 1);
        if (float === decoded || Number.isNaN(float)) return 3;
        encodeFloat32(float);
        decoded = readFloat32(ui8a, 1);
        if (float === decoded) return 5;
    }
    return 9;
};
const buffer = new ArrayBuffer(9);
const dataView = new DataView(buffer, 1);
const ui8a = new Uint8Array(buffer, 0);
function encodeFloat16(inp) {
    if (inp === Infinity) dataView.setUint16(0, 31744, false);
    else if (inp === -Infinity) dataView.setUint16(0, 64512, false);
    else if (Number.isNaN(inp)) dataView.setUint16(0, 32256, false);
    else {
        dataView.setFloat32(0, inp);
        const valu32 = dataView.getUint32(0);
        const exponent = (valu32 & 2139095040) >> 23;
        const mantissa = valu32 & 8388607;
        if (exponent === 255) dataView.setUint16(0, 31744, false);
        else if (exponent === 0) dataView.setUint16(0, (inp & 2147483648) >> 16 | mantissa >> 13, false);
        else {
            const logicalExponent = exponent - 127;
            if (logicalExponent < -24) dataView.setUint16(0, 0);
            else if (logicalExponent < -14) dataView.setUint16(0, (valu32 & 2147483648) >> 16 | 1 << 24 + logicalExponent, false);
            else dataView.setUint16(0, (valu32 & 2147483648) >> 16 | logicalExponent + 15 << 10 | mantissa >> 13, false);
        }
    }
}
function readFloat16(ui8a, pos) {
    if (ui8a.length - pos < 2) throw new Error(`${common.decodeErrPrefix} not enough data for float16`);
    const half = (ui8a[pos] << 8) + ui8a[pos + 1];
    if (half === 31744) return Infinity;
    if (half === 64512) return -Infinity;
    if (half === 32256) return NaN;
    const exp = half >> 10 & 31;
    const mant = half & 1023;
    let val;
    if (exp === 0) val = mant * 2 ** -24;
    else if (exp !== 31) val = (mant + 1024) * 2 ** (exp - 25);
    else val = mant === 0 ? Infinity : NaN;
    return half & 32768 ? -val : val;
}
function encodeFloat32(inp) {
    dataView.setFloat32(0, inp, false);
}
function readFloat32(ui8a, pos) {
    if (ui8a.length - pos < 4) throw new Error(`${common.decodeErrPrefix} not enough data for float32`);
    const offset = (ui8a.byteOffset || 0) + pos;
    return new DataView(ui8a.buffer, offset, 4).getFloat32(0, false);
}
function encodeFloat64(inp) {
    dataView.setFloat64(0, inp, false);
}
function readFloat64(ui8a, pos) {
    if (ui8a.length - pos < 8) throw new Error(`${common.decodeErrPrefix} not enough data for float64`);
    const offset = (ui8a.byteOffset || 0) + pos;
    return new DataView(ui8a.buffer, offset, 8).getFloat64(0, false);
}
encodeFloat.compareTokens = _0uint.encodeUint.compareTokens;
exports.decodeBreak = decodeBreak;
exports.decodeFloat16 = decodeFloat16;
exports.decodeFloat32 = decodeFloat32;
exports.decodeFloat64 = decodeFloat64;
exports.decodeUndefined = decodeUndefined;
exports.encodeFloat = encodeFloat;

},{"574d07bd71f75604":"7qjkh","2cda160f97f0be62":"ludQE","f7945f7014a9bebe":"3gULd"}],"7E331":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
var common = require("caefc7605aaf4464");
var token = require("136f3b9c10f1046");
var jump = require("50bdb97cb7018123");
const defaultDecodeOptions = {
    strict: false,
    allowIndefinite: true,
    allowUndefined: true,
    allowBigInt: true
};
class Tokeniser {
    constructor(data, options = {}){
        this.pos = 0;
        this.data = data;
        this.options = options;
    }
    done() {
        return this.pos >= this.data.length;
    }
    next() {
        const byt = this.data[this.pos];
        let token = jump.quick[byt];
        if (token === undefined) {
            const decoder = jump.jump[byt];
            if (!decoder) throw new Error(`${common.decodeErrPrefix} no decoder for major type ${byt >>> 5} (byte 0x${byt.toString(16).padStart(2, '0')})`);
            const minor = byt & 31;
            token = decoder(this.data, this.pos, minor, this.options);
        }
        this.pos += token.encodedLength;
        return token;
    }
}
const DONE = Symbol.for('DONE');
const BREAK = Symbol.for('BREAK');
function tokenToArray(token, tokeniser, options) {
    const arr = [];
    for(let i = 0; i < token.value; i++){
        const value = tokensToObject(tokeniser, options);
        if (value === BREAK) {
            if (token.value === Infinity) break;
            throw new Error(`${common.decodeErrPrefix} got unexpected break to lengthed array`);
        }
        if (value === DONE) throw new Error(`${common.decodeErrPrefix} found array but not enough entries (got ${i}, expected ${token.value})`);
        arr[i] = value;
    }
    return arr;
}
function tokenToMap(token, tokeniser, options) {
    const useMaps = options.useMaps === true;
    const obj = useMaps ? undefined : {};
    const m = useMaps ? new Map() : undefined;
    for(let i = 0; i < token.value; i++){
        const key = tokensToObject(tokeniser, options);
        if (key === BREAK) {
            if (token.value === Infinity) break;
            throw new Error(`${common.decodeErrPrefix} got unexpected break to lengthed map`);
        }
        if (key === DONE) throw new Error(`${common.decodeErrPrefix} found map but not enough entries (got ${i} [no key], expected ${token.value})`);
        if (useMaps !== true && typeof key !== 'string') throw new Error(`${common.decodeErrPrefix} non-string keys not supported (got ${typeof key})`);
        if (options.rejectDuplicateMapKeys === true) {
            if (useMaps && m.has(key) || !useMaps && key in obj) throw new Error(`${common.decodeErrPrefix} found repeat map key "${key}"`);
        }
        const value = tokensToObject(tokeniser, options);
        if (value === DONE) throw new Error(`${common.decodeErrPrefix} found map but not enough entries (got ${i} [no value], expected ${token.value})`);
        if (useMaps) m.set(key, value);
        else obj[key] = value;
    }
    return useMaps ? m : obj;
}
function tokensToObject(tokeniser, options) {
    if (tokeniser.done()) return DONE;
    const token$1 = tokeniser.next();
    if (token$1.type === token.Type.break) return BREAK;
    if (token$1.type.terminal) return token$1.value;
    if (token$1.type === token.Type.array) return tokenToArray(token$1, tokeniser, options);
    if (token$1.type === token.Type.map) return tokenToMap(token$1, tokeniser, options);
    if (token$1.type === token.Type.tag) {
        if (options.tags && typeof options.tags[token$1.value] === 'function') {
            const tagged = tokensToObject(tokeniser, options);
            return options.tags[token$1.value](tagged);
        }
        throw new Error(`${common.decodeErrPrefix} tag not supported (${token$1.value})`);
    }
    throw new Error('unsupported');
}
function decode(data, options) {
    if (!(data instanceof Uint8Array)) throw new Error(`${common.decodeErrPrefix} data to decode must be a Uint8Array`);
    options = Object.assign({}, defaultDecodeOptions, options);
    const tokeniser = options.tokenizer || new Tokeniser(data, options);
    const decoded = tokensToObject(tokeniser, options);
    if (decoded === DONE) throw new Error(`${common.decodeErrPrefix} did not find any content to decode`);
    if (decoded === BREAK) throw new Error(`${common.decodeErrPrefix} got unexpected break`);
    if (!tokeniser.done()) throw new Error(`${common.decodeErrPrefix} too many terminals, data makes no sense`);
    return decoded;
}
exports.Tokeniser = Tokeniser;
exports.decode = decode;
exports.tokensToObject = tokensToObject;

},{"caefc7605aaf4464":"ludQE","136f3b9c10f1046":"7qjkh","50bdb97cb7018123":"PnvSj"}],"fk1Lm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ERR_BEACON_NOT_AVAILABLE_CODE = exports.MODULE_NAME = exports.BACKEND_VRF = exports.BACKEND_INSECURE = exports.METHOD_SET_EPOCH = exports.METHOD_VRF_PROVE = void 0;
exports.vrfProveWrapper = vrfProveWrapper;
exports.setEpochWrapper = setEpochWrapper;
const consensus = require("ae591ae3bb2afd45");
/**
 * MethodVRFProve is the method name for a VRF proof.
 */ exports.METHOD_VRF_PROVE = 'beacon.VRFProve';
/**
 * MethodSetEpoch is the method name for setting epochs.
 */ exports.METHOD_SET_EPOCH = '000_beacon.SetEpoch';
/**
 * BackendInsecure is the name of the insecure backend.
 */ exports.BACKEND_INSECURE = 'insecure';
/**
 * BackendVRF is the name of the VRF backend.
 */ exports.BACKEND_VRF = 'vrf';
/**
 * ModuleName is a unique module name for the beacon module.
 */ exports.MODULE_NAME = 'beacon';
/**
 * ErrBeaconNotAvailable is the error returned when a beacon is not
 * available for the requested height for any reason.
 */ exports.ERR_BEACON_NOT_AVAILABLE_CODE = 1;
function vrfProveWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_VRF_PROVE);
}
function setEpochWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_SET_EPOCH);
}

},{"ae591ae3bb2afd45":"6XVjL"}],"6XVjL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TransactionWrapper = exports.TRANSACTION_ERR_UPGRADE_PENDING = exports.TRANSACTION_ERR_GAS_PRICE_TOO_LOW_CODE = exports.TRANSACTION_ERR_INSUFFICIENT_FEE_BALANCE_CODE = exports.TRANSACTION_ERR_INVALID_NONCE_CODE = exports.TRANSACTION_MODULE_NAME = exports.ERR_INVALID_ARGUMENT_CODE = exports.ERR_DUPLICATE_TX_CODE = exports.ERR_UNSUPPORTED_CODE = exports.ERR_VERSION_NOT_FOUND_CODE = exports.ERR_OVERSIZED_TX_CODE = exports.ERR_NO_COMMITTED_BLOCKS_CODE = exports.MODULE_NAME = exports.TENDERMINT_BACKEND_NAME = exports.GAS_OP_TX_BYTE = exports.FEATURE_FULL_NODE = exports.FEATURE_SERVICES = exports.TRANSACTION_SIGNATURE_CONTEXT = exports.HEIGHT_LATEST = void 0;
exports.openSignedTransaction = openSignedTransaction;
exports.signSignedTransaction = signSignedTransaction;
exports.hashSignedTransaction = hashSignedTransaction;
exports.visitTransaction = visitTransaction;
const hash = require("4f0d1fc2254d4f36");
const misc = require("545a900ca1c9e1dc");
const quantity = require("8f83dc114c64df6");
const signature = require("bc5abe6e9c631876");
/**
 * HeightLatest is the height that represents the most recent block height.
 */ exports.HEIGHT_LATEST = 0n;
/**
 * SignatureContext is the context used for signing transactions.
 */ exports.TRANSACTION_SIGNATURE_CONTEXT = 'oasis-core/consensus: tx';
/**
 * FeatureServices indicates support for communicating with consensus services.
 */ exports.FEATURE_SERVICES = 1;
/**
 * FeatureFullNode indicates that the consensus backend is independently fully verifying all
 * consensus-layer blocks.
 */ exports.FEATURE_FULL_NODE = 2;
/**
 * GasOpTxByte is the gas operation identifier for costing each transaction byte.
 */ exports.GAS_OP_TX_BYTE = 'tx_byte';
/**
 * BackendName is the consensus backend name.
 */ exports.TENDERMINT_BACKEND_NAME = 'tendermint';
/**
 * moduleName is the module name used for error definitions.
 */ exports.MODULE_NAME = 'consensus';
/**
 * ErrNoCommittedBlocks is the error returned when there are no committed
 * blocks and as such no state can be queried.
 */ exports.ERR_NO_COMMITTED_BLOCKS_CODE = 1;
/**
 * ErrOversizedTx is the error returned when the given transaction is too big to be processed.
 */ exports.ERR_OVERSIZED_TX_CODE = 2;
/**
 * ErrVersionNotFound is the error returned when the given version (height) cannot be found,
 * possibly because it was pruned.
 */ exports.ERR_VERSION_NOT_FOUND_CODE = 3;
/**
 * ErrUnsupported is the error returned when the given method is not supported by the consensus
 * backend.
 */ exports.ERR_UNSUPPORTED_CODE = 4;
/**
 * ErrDuplicateTx is the error returned when the transaction already exists in the mempool.
 */ exports.ERR_DUPLICATE_TX_CODE = 5;
/**
 * ErrInvalidArgument is the error returned when the request contains an invalid argument.
 */ exports.ERR_INVALID_ARGUMENT_CODE = 6;
/**
 * moduleName is the module name used for error definitions.
 */ exports.TRANSACTION_MODULE_NAME = 'consensus/transaction';
/**
 * ErrInvalidNonce is the error returned when a nonce is invalid.
 */ exports.TRANSACTION_ERR_INVALID_NONCE_CODE = 1;
/**
 * ErrInsufficientFeeBalance is the error returned when there is insufficient
 * balance to pay consensus fees.
 */ exports.TRANSACTION_ERR_INSUFFICIENT_FEE_BALANCE_CODE = 2;
/**
 * ErrGasPriceTooLow is the error returned when the gas price is too low.
 */ exports.TRANSACTION_ERR_GAS_PRICE_TOO_LOW_CODE = 3;
/**
 * ErrUpgradePending is the error returned when an upgrade is pending and the transaction thus
 * cannot be processed right now. The submitter should retry the transaction in this case.
 */ exports.TRANSACTION_ERR_UPGRADE_PENDING = 4;
function openSignedTransaction(chainContext, signed) {
    const context = signature.combineChainContext(exports.TRANSACTION_SIGNATURE_CONTEXT, chainContext);
    return misc.fromCBOR(signature.openSigned(context, signed));
}
async function signSignedTransaction(signer, chainContext, transaction) {
    const context = signature.combineChainContext(exports.TRANSACTION_SIGNATURE_CONTEXT, chainContext);
    return await signature.signSigned(signer, context, misc.toCBOR(transaction));
}
/**
 * This special hex-hash-of-the-CBOR-encoded signed transaction is useful for interoperability
 * with block explorers, so here's a special function for doing it.
 */ function hashSignedTransaction(signed) {
    return misc.toHex(hash.hash(misc.toCBOR(signed)));
}
class TransactionWrapper {
    constructor(method){
        this.transaction = {
            nonce: 0n,
            fee: {
                amount: quantity.fromBigInt(0n),
                gas: 0n
            },
            method
        };
        this.signedTransaction = null;
    }
    setNonce(nonce) {
        this.transaction.nonce = nonce;
        return this;
    }
    setFeeAmount(amount) {
        this.transaction.fee.amount = amount;
        return this;
    }
    setFeeGas(gas) {
        this.transaction.fee.gas = gas;
        return this;
    }
    setBody(body) {
        this.transaction.body = body;
        return this;
    }
    async estimateGas(nic, signer) {
        return await nic.consensusEstimateGas({
            signer,
            transaction: this.transaction
        });
    }
    async sign(signer, chainContext) {
        this.signedTransaction = await signSignedTransaction(signer, chainContext, this.transaction);
    }
    hash() {
        return hashSignedTransaction(this.signedTransaction);
    }
    async submit(nic) {
        await nic.consensusSubmitTx(this.signedTransaction);
    }
}
exports.TransactionWrapper = TransactionWrapper;
/**
 * Calls one of the handlers based on the given transaction method.
 * @param handlers Handlers, use an intersection of other modules'
 * `ConsensusTransactionHandlers` types to initialize the fields.
 * @param tx The transaction
 * @returns `true` if the transaction method matched one of the handlers
 */ function visitTransaction(handlers, tx) {
    if (handlers[tx.method]) {
        handlers[tx.method](tx.body);
        return true;
    }
    return false;
}

},{"4f0d1fc2254d4f36":"gpNaY","545a900ca1c9e1dc":"1Mc9i","8f83dc114c64df6":"adbNs","bc5abe6e9c631876":"6UtA9"}],"adbNs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toBigInt = toBigInt;
exports.fromBigInt = fromBigInt;
const misc = require("b20403d5d17a1d2");
function toBigInt(q) {
    if (q.length === 0) return 0n;
    return BigInt('0x' + misc.toHex(q));
}
function fromBigInt(bi) {
    if (bi === 0n) return new Uint8Array();
    let hex = bi.toString(16);
    if (hex.length % 2) hex = '0' + hex;
    return misc.fromHex(hex);
}

},{"b20403d5d17a1d2":"1Mc9i"}],"6UtA9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NaclSigner = exports.BlindContextSigner = exports.CHAIN_CONTEXT_SEPARATOR = void 0;
exports.combineChainContext = combineChainContext;
exports.prepareSignerMessage = prepareSignerMessage;
exports.verify = verify;
exports.openSigned = openSigned;
exports.signSigned = signSigned;
exports.openMultiSigned = openMultiSigned;
exports.signMultiSigned = signMultiSigned;
exports.visitMessage = visitMessage;
const nacl = require("b5e966506aa4a940");
const hash = require("5321d378b70494be");
const misc = require("95e5ec0afb648406");
exports.CHAIN_CONTEXT_SEPARATOR = ' for chain ';
function combineChainContext(context, chainContext) {
    return `${context}${exports.CHAIN_CONTEXT_SEPARATOR}${chainContext}`;
}
function prepareSignerMessage(context, message) {
    return hash.hash(misc.concat(misc.fromString(context), message));
}
function verify(publicKey, context, message, signature) {
    const signerMessage = prepareSignerMessage(context, message);
    const sigOk = nacl.sign.detached.verify(signerMessage, signature, publicKey);
    return sigOk;
}
function openSigned(context, signed) {
    const sigOk = verify(signed.signature.public_key, context, signed.untrusted_raw_value, signed.signature.signature);
    if (!sigOk) throw new Error('signature verification failed');
    return signed.untrusted_raw_value;
}
async function signSigned(signer, context, rawValue) {
    return {
        untrusted_raw_value: rawValue,
        signature: {
            public_key: signer.public(),
            signature: await signer.sign(context, rawValue)
        }
    };
}
function openMultiSigned(context, multiSigned) {
    const signerMessage = prepareSignerMessage(context, multiSigned.untrusted_raw_value);
    for (const signature of multiSigned.signatures){
        const sigOk = nacl.sign.detached.verify(signerMessage, signature.signature, signature.public_key);
        if (!sigOk) throw new Error('signature verification failed');
    }
    return multiSigned.untrusted_raw_value;
}
async function signMultiSigned(signers, context, rawValue) {
    const signatures = [];
    for (const signer of signers)signatures.push({
        public_key: signer.public(),
        signature: await signer.sign(context, rawValue)
    });
    return {
        untrusted_raw_value: rawValue,
        signatures: signatures
    };
}
class BlindContextSigner {
    constructor(signer){
        this.signer = signer;
    }
    public() {
        return this.signer.public();
    }
    async sign(context, message) {
        const signerMessage = prepareSignerMessage(context, message);
        return await this.signer.sign(signerMessage);
    }
}
exports.BlindContextSigner = BlindContextSigner;
/**
 * An in-memory signer based on tweetnacl. We've included this for development.
 */ class NaclSigner {
    constructor(key, note){
        if (note !== 'this key is not important') throw new Error('insecure signer implementation');
        this.key = key;
    }
    /**
     * Generate a keypair from a random seed
     * @param note Set to 'this key is not important' to acknowledge the risks
     * @returns Instance of NaclSigner
     */ static fromRandom(note) {
        const secret = new Uint8Array(32);
        crypto.getRandomValues(secret);
        return NaclSigner.fromSeed(secret, note);
    }
    /**
     * Instanciate from a given secret
     * @param secret 64 bytes ed25519 secret (h) that will be used to sign messages
     * @param note Set to 'this key is not important' to acknowledge the risks
     * @returns Instance of NaclSigner
     */ static fromSecret(secret, note) {
        const key = nacl.sign.keyPair.fromSecretKey(secret);
        return new NaclSigner(key, note);
    }
    /**
     * Instanciate from a given seed
     * @param seed 32 bytes ed25519 seed (k) that will deterministically generate a private key
     * @param note Set to 'this key is not important' to acknowledge the risks
     * @returns Instance of NaclSigner
     */ static fromSeed(seed, note) {
        const key = nacl.sign.keyPair.fromSeed(seed);
        return new NaclSigner(key, note);
    }
    /**
     * Returns the 32 bytes public key of this key pair
     * @returns Public key
     */ public() {
        return this.key.publicKey;
    }
    /**
     * Signs the given message
     * @param message Bytes to sign
     * @returns Signed message
     */ async sign(message) {
        return nacl.sign.detached(message, this.key.secretKey);
    }
}
exports.NaclSigner = NaclSigner;
/**
 * Calls one of the handlers based on the given context.
 * @param handlers Handlers, use an intersection of other modules'
 * `SignatureMessageHandlers*` types to initialize the fields.
 * @param context The context string as would be given to `ContextSigner.sign`
 * @param message The messsage as would be given to `ContextSigner.sign`
 * @returns `true` if the context matched one of the handlers
 */ function visitMessage(handlers, context, message) {
    // This doesn't support dynamic suffixes.
    {
        const parts = context.split(exports.CHAIN_CONTEXT_SEPARATOR);
        if (parts.length === 2) {
            const [context2, chainContext] = parts;
            if (handlers.withChainContext?.[context2]) {
                handlers.withChainContext[context2](chainContext, misc.fromCBOR(message));
                return true;
            }
            return false;
        }
    }
    if (handlers.bare?.[context]) {
        handlers.bare[context](misc.fromCBOR(message));
        return true;
    }
    return false;
}

},{"b5e966506aa4a940":"5ZWFX","5321d378b70494be":"gpNaY","95e5ec0afb648406":"1Mc9i"}],"5ZWFX":[function(require,module,exports,__globalThis) {
(function(nacl) {
    'use strict';
    // Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
    // Public domain.
    //
    // Implementation derived from TweetNaCl version 20140427.
    // See for details: http://tweetnacl.cr.yp.to/
    var gf = function(init) {
        var i, r = new Float64Array(16);
        if (init) for(i = 0; i < init.length; i++)r[i] = init[i];
        return r;
    };
    //  Pluggable, initialized in high-level API below.
    var randombytes = function() {
        throw new Error('no PRNG');
    };
    var _0 = new Uint8Array(16);
    var _9 = new Uint8Array(32);
    _9[0] = 9;
    var gf0 = gf(), gf1 = gf([
        1
    ]), _121665 = gf([
        0xdb41,
        1
    ]), D = gf([
        0x78a3,
        0x1359,
        0x4dca,
        0x75eb,
        0xd8ab,
        0x4141,
        0x0a4d,
        0x0070,
        0xe898,
        0x7779,
        0x4079,
        0x8cc7,
        0xfe73,
        0x2b6f,
        0x6cee,
        0x5203
    ]), D2 = gf([
        0xf159,
        0x26b2,
        0x9b94,
        0xebd6,
        0xb156,
        0x8283,
        0x149a,
        0x00e0,
        0xd130,
        0xeef3,
        0x80f2,
        0x198e,
        0xfce7,
        0x56df,
        0xd9dc,
        0x2406
    ]), X = gf([
        0xd51a,
        0x8f25,
        0x2d60,
        0xc956,
        0xa7b2,
        0x9525,
        0xc760,
        0x692c,
        0xdc5c,
        0xfdd6,
        0xe231,
        0xc0a4,
        0x53fe,
        0xcd6e,
        0x36d3,
        0x2169
    ]), Y = gf([
        0x6658,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666
    ]), I = gf([
        0xa0b0,
        0x4a0e,
        0x1b27,
        0xc4ee,
        0xe478,
        0xad2f,
        0x1806,
        0x2f43,
        0xd7a7,
        0x3dfb,
        0x0099,
        0x2b4d,
        0xdf0b,
        0x4fc1,
        0x2480,
        0x2b83
    ]);
    function ts64(x, i, h, l) {
        x[i] = h >> 24 & 0xff;
        x[i + 1] = h >> 16 & 0xff;
        x[i + 2] = h >> 8 & 0xff;
        x[i + 3] = h & 0xff;
        x[i + 4] = l >> 24 & 0xff;
        x[i + 5] = l >> 16 & 0xff;
        x[i + 6] = l >> 8 & 0xff;
        x[i + 7] = l & 0xff;
    }
    function vn(x, xi, y, yi, n) {
        var i, d = 0;
        for(i = 0; i < n; i++)d |= x[xi + i] ^ y[yi + i];
        return (1 & d - 1 >>> 8) - 1;
    }
    function crypto_verify_16(x, xi, y, yi) {
        return vn(x, xi, y, yi, 16);
    }
    function crypto_verify_32(x, xi, y, yi) {
        return vn(x, xi, y, yi, 32);
    }
    function core_salsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        x0 = x0 + j0 | 0;
        x1 = x1 + j1 | 0;
        x2 = x2 + j2 | 0;
        x3 = x3 + j3 | 0;
        x4 = x4 + j4 | 0;
        x5 = x5 + j5 | 0;
        x6 = x6 + j6 | 0;
        x7 = x7 + j7 | 0;
        x8 = x8 + j8 | 0;
        x9 = x9 + j9 | 0;
        x10 = x10 + j10 | 0;
        x11 = x11 + j11 | 0;
        x12 = x12 + j12 | 0;
        x13 = x13 + j13 | 0;
        x14 = x14 + j14 | 0;
        x15 = x15 + j15 | 0;
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x1 >>> 0 & 0xff;
        o[5] = x1 >>> 8 & 0xff;
        o[6] = x1 >>> 16 & 0xff;
        o[7] = x1 >>> 24 & 0xff;
        o[8] = x2 >>> 0 & 0xff;
        o[9] = x2 >>> 8 & 0xff;
        o[10] = x2 >>> 16 & 0xff;
        o[11] = x2 >>> 24 & 0xff;
        o[12] = x3 >>> 0 & 0xff;
        o[13] = x3 >>> 8 & 0xff;
        o[14] = x3 >>> 16 & 0xff;
        o[15] = x3 >>> 24 & 0xff;
        o[16] = x4 >>> 0 & 0xff;
        o[17] = x4 >>> 8 & 0xff;
        o[18] = x4 >>> 16 & 0xff;
        o[19] = x4 >>> 24 & 0xff;
        o[20] = x5 >>> 0 & 0xff;
        o[21] = x5 >>> 8 & 0xff;
        o[22] = x5 >>> 16 & 0xff;
        o[23] = x5 >>> 24 & 0xff;
        o[24] = x6 >>> 0 & 0xff;
        o[25] = x6 >>> 8 & 0xff;
        o[26] = x6 >>> 16 & 0xff;
        o[27] = x6 >>> 24 & 0xff;
        o[28] = x7 >>> 0 & 0xff;
        o[29] = x7 >>> 8 & 0xff;
        o[30] = x7 >>> 16 & 0xff;
        o[31] = x7 >>> 24 & 0xff;
        o[32] = x8 >>> 0 & 0xff;
        o[33] = x8 >>> 8 & 0xff;
        o[34] = x8 >>> 16 & 0xff;
        o[35] = x8 >>> 24 & 0xff;
        o[36] = x9 >>> 0 & 0xff;
        o[37] = x9 >>> 8 & 0xff;
        o[38] = x9 >>> 16 & 0xff;
        o[39] = x9 >>> 24 & 0xff;
        o[40] = x10 >>> 0 & 0xff;
        o[41] = x10 >>> 8 & 0xff;
        o[42] = x10 >>> 16 & 0xff;
        o[43] = x10 >>> 24 & 0xff;
        o[44] = x11 >>> 0 & 0xff;
        o[45] = x11 >>> 8 & 0xff;
        o[46] = x11 >>> 16 & 0xff;
        o[47] = x11 >>> 24 & 0xff;
        o[48] = x12 >>> 0 & 0xff;
        o[49] = x12 >>> 8 & 0xff;
        o[50] = x12 >>> 16 & 0xff;
        o[51] = x12 >>> 24 & 0xff;
        o[52] = x13 >>> 0 & 0xff;
        o[53] = x13 >>> 8 & 0xff;
        o[54] = x13 >>> 16 & 0xff;
        o[55] = x13 >>> 24 & 0xff;
        o[56] = x14 >>> 0 & 0xff;
        o[57] = x14 >>> 8 & 0xff;
        o[58] = x14 >>> 16 & 0xff;
        o[59] = x14 >>> 24 & 0xff;
        o[60] = x15 >>> 0 & 0xff;
        o[61] = x15 >>> 8 & 0xff;
        o[62] = x15 >>> 16 & 0xff;
        o[63] = x15 >>> 24 & 0xff;
    }
    function core_hsalsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x5 >>> 0 & 0xff;
        o[5] = x5 >>> 8 & 0xff;
        o[6] = x5 >>> 16 & 0xff;
        o[7] = x5 >>> 24 & 0xff;
        o[8] = x10 >>> 0 & 0xff;
        o[9] = x10 >>> 8 & 0xff;
        o[10] = x10 >>> 16 & 0xff;
        o[11] = x10 >>> 24 & 0xff;
        o[12] = x15 >>> 0 & 0xff;
        o[13] = x15 >>> 8 & 0xff;
        o[14] = x15 >>> 16 & 0xff;
        o[15] = x15 >>> 24 & 0xff;
        o[16] = x6 >>> 0 & 0xff;
        o[17] = x6 >>> 8 & 0xff;
        o[18] = x6 >>> 16 & 0xff;
        o[19] = x6 >>> 24 & 0xff;
        o[20] = x7 >>> 0 & 0xff;
        o[21] = x7 >>> 8 & 0xff;
        o[22] = x7 >>> 16 & 0xff;
        o[23] = x7 >>> 24 & 0xff;
        o[24] = x8 >>> 0 & 0xff;
        o[25] = x8 >>> 8 & 0xff;
        o[26] = x8 >>> 16 & 0xff;
        o[27] = x8 >>> 24 & 0xff;
        o[28] = x9 >>> 0 & 0xff;
        o[29] = x9 >>> 8 & 0xff;
        o[30] = x9 >>> 16 & 0xff;
        o[31] = x9 >>> 24 & 0xff;
    }
    function crypto_core_salsa20(out, inp, k, c) {
        core_salsa20(out, inp, k, c);
    }
    function crypto_core_hsalsa20(out, inp, k, c) {
        core_hsalsa20(out, inp, k, c);
    }
    var sigma = new Uint8Array([
        101,
        120,
        112,
        97,
        110,
        100,
        32,
        51,
        50,
        45,
        98,
        121,
        116,
        101,
        32,
        107
    ]);
    // "expand 32-byte k"
    function crypto_stream_salsa20_xor(c, cpos, m, mpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = m[mpos + i] ^ x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
            mpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = m[mpos + i] ^ x[i];
        }
        return 0;
    }
    function crypto_stream_salsa20(c, cpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = x[i];
        }
        return 0;
    }
    function crypto_stream(c, cpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20(c, cpos, d, sn, s);
    }
    function crypto_stream_xor(c, cpos, m, mpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20_xor(c, cpos, m, mpos, d, sn, s);
    }
    /*
* Port of Andrew Moon's Poly1305-donna-16. Public domain.
* https://github.com/floodyberry/poly1305-donna
*/ var poly1305 = function(key) {
        this.buffer = new Uint8Array(16);
        this.r = new Uint16Array(10);
        this.h = new Uint16Array(10);
        this.pad = new Uint16Array(8);
        this.leftover = 0;
        this.fin = 0;
        var t0, t1, t2, t3, t4, t5, t6, t7;
        t0 = key[0] & 0xff | (key[1] & 0xff) << 8;
        this.r[0] = t0 & 0x1fff;
        t1 = key[2] & 0xff | (key[3] & 0xff) << 8;
        this.r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        t2 = key[4] & 0xff | (key[5] & 0xff) << 8;
        this.r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        t3 = key[6] & 0xff | (key[7] & 0xff) << 8;
        this.r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        t4 = key[8] & 0xff | (key[9] & 0xff) << 8;
        this.r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this.r[5] = t4 >>> 1 & 0x1ffe;
        t5 = key[10] & 0xff | (key[11] & 0xff) << 8;
        this.r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        t6 = key[12] & 0xff | (key[13] & 0xff) << 8;
        this.r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        t7 = key[14] & 0xff | (key[15] & 0xff) << 8;
        this.r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this.r[9] = t7 >>> 5 & 0x007f;
        this.pad[0] = key[16] & 0xff | (key[17] & 0xff) << 8;
        this.pad[1] = key[18] & 0xff | (key[19] & 0xff) << 8;
        this.pad[2] = key[20] & 0xff | (key[21] & 0xff) << 8;
        this.pad[3] = key[22] & 0xff | (key[23] & 0xff) << 8;
        this.pad[4] = key[24] & 0xff | (key[25] & 0xff) << 8;
        this.pad[5] = key[26] & 0xff | (key[27] & 0xff) << 8;
        this.pad[6] = key[28] & 0xff | (key[29] & 0xff) << 8;
        this.pad[7] = key[30] & 0xff | (key[31] & 0xff) << 8;
    };
    poly1305.prototype.blocks = function(m, mpos, bytes) {
        var hibit = this.fin ? 0 : 2048;
        var t0, t1, t2, t3, t4, t5, t6, t7, c;
        var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;
        var h0 = this.h[0], h1 = this.h[1], h2 = this.h[2], h3 = this.h[3], h4 = this.h[4], h5 = this.h[5], h6 = this.h[6], h7 = this.h[7], h8 = this.h[8], h9 = this.h[9];
        var r0 = this.r[0], r1 = this.r[1], r2 = this.r[2], r3 = this.r[3], r4 = this.r[4], r5 = this.r[5], r6 = this.r[6], r7 = this.r[7], r8 = this.r[8], r9 = this.r[9];
        while(bytes >= 16){
            t0 = m[mpos + 0] & 0xff | (m[mpos + 1] & 0xff) << 8;
            h0 += t0 & 0x1fff;
            t1 = m[mpos + 2] & 0xff | (m[mpos + 3] & 0xff) << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            t2 = m[mpos + 4] & 0xff | (m[mpos + 5] & 0xff) << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            t3 = m[mpos + 6] & 0xff | (m[mpos + 7] & 0xff) << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            t4 = m[mpos + 8] & 0xff | (m[mpos + 9] & 0xff) << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            t5 = m[mpos + 10] & 0xff | (m[mpos + 11] & 0xff) << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            t6 = m[mpos + 12] & 0xff | (m[mpos + 13] & 0xff) << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            t7 = m[mpos + 14] & 0xff | (m[mpos + 15] & 0xff) << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            c = 0;
            d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this.h[0] = h0;
        this.h[1] = h1;
        this.h[2] = h2;
        this.h[3] = h3;
        this.h[4] = h4;
        this.h[5] = h5;
        this.h[6] = h6;
        this.h[7] = h7;
        this.h[8] = h8;
        this.h[9] = h9;
    };
    poly1305.prototype.finish = function(mac, macpos) {
        var g = new Uint16Array(10);
        var c, mask, f, i;
        if (this.leftover) {
            i = this.leftover;
            this.buffer[i++] = 1;
            for(; i < 16; i++)this.buffer[i] = 0;
            this.fin = 1;
            this.blocks(this.buffer, 0, 16);
        }
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this.h[i] += c;
            c = this.h[i] >>> 13;
            this.h[i] &= 0x1fff;
        }
        this.h[0] += c * 5;
        c = this.h[0] >>> 13;
        this.h[0] &= 0x1fff;
        this.h[1] += c;
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        this.h[2] += c;
        g[0] = this.h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this.h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this.h[i] = this.h[i] & mask | g[i];
        this.h[0] = (this.h[0] | this.h[1] << 13) & 0xffff;
        this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 0xffff;
        this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 0xffff;
        this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 0xffff;
        this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 0xffff;
        this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 0xffff;
        this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 0xffff;
        this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 0xffff;
        f = this.h[0] + this.pad[0];
        this.h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this.h[i] + this.pad[i] | 0) + (f >>> 16) | 0;
            this.h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this.h[0] >>> 0 & 0xff;
        mac[macpos + 1] = this.h[0] >>> 8 & 0xff;
        mac[macpos + 2] = this.h[1] >>> 0 & 0xff;
        mac[macpos + 3] = this.h[1] >>> 8 & 0xff;
        mac[macpos + 4] = this.h[2] >>> 0 & 0xff;
        mac[macpos + 5] = this.h[2] >>> 8 & 0xff;
        mac[macpos + 6] = this.h[3] >>> 0 & 0xff;
        mac[macpos + 7] = this.h[3] >>> 8 & 0xff;
        mac[macpos + 8] = this.h[4] >>> 0 & 0xff;
        mac[macpos + 9] = this.h[4] >>> 8 & 0xff;
        mac[macpos + 10] = this.h[5] >>> 0 & 0xff;
        mac[macpos + 11] = this.h[5] >>> 8 & 0xff;
        mac[macpos + 12] = this.h[6] >>> 0 & 0xff;
        mac[macpos + 13] = this.h[6] >>> 8 & 0xff;
        mac[macpos + 14] = this.h[7] >>> 0 & 0xff;
        mac[macpos + 15] = this.h[7] >>> 8 & 0xff;
    };
    poly1305.prototype.update = function(m, mpos, bytes) {
        var i, want;
        if (this.leftover) {
            want = 16 - this.leftover;
            if (want > bytes) want = bytes;
            for(i = 0; i < want; i++)this.buffer[this.leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this.leftover += want;
            if (this.leftover < 16) return;
            this.blocks(this.buffer, 0, 16);
            this.leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this.blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(i = 0; i < bytes; i++)this.buffer[this.leftover + i] = m[mpos + i];
            this.leftover += bytes;
        }
    };
    function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
        var s = new poly1305(k);
        s.update(m, mpos, n);
        s.finish(out, outpos);
        return 0;
    }
    function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
        var x = new Uint8Array(16);
        crypto_onetimeauth(x, 0, m, mpos, n, k);
        return crypto_verify_16(h, hpos, x, 0);
    }
    function crypto_secretbox(c, m, d, n, k) {
        var i;
        if (d < 32) return -1;
        crypto_stream_xor(c, 0, m, 0, d, n, k);
        crypto_onetimeauth(c, 16, c, 32, d - 32, c);
        for(i = 0; i < 16; i++)c[i] = 0;
        return 0;
    }
    function crypto_secretbox_open(m, c, d, n, k) {
        var i;
        var x = new Uint8Array(32);
        if (d < 32) return -1;
        crypto_stream(x, 0, 32, n, k);
        if (crypto_onetimeauth_verify(c, 16, c, 32, d - 32, x) !== 0) return -1;
        crypto_stream_xor(m, 0, c, 0, d, n, k);
        for(i = 0; i < 32; i++)m[i] = 0;
        return 0;
    }
    function set25519(r, a) {
        var i;
        for(i = 0; i < 16; i++)r[i] = a[i] | 0;
    }
    function car25519(o) {
        var i, v, c = 1;
        for(i = 0; i < 16; i++){
            v = o[i] + c + 65535;
            c = Math.floor(v / 65536);
            o[i] = v - c * 65536;
        }
        o[0] += c - 1 + 37 * (c - 1);
    }
    function sel25519(p, q, b) {
        var t, c = ~(b - 1);
        for(var i = 0; i < 16; i++){
            t = c & (p[i] ^ q[i]);
            p[i] ^= t;
            q[i] ^= t;
        }
    }
    function pack25519(o, n) {
        var i, j, b;
        var m = gf(), t = gf();
        for(i = 0; i < 16; i++)t[i] = n[i];
        car25519(t);
        car25519(t);
        car25519(t);
        for(j = 0; j < 2; j++){
            m[0] = t[0] - 0xffed;
            for(i = 1; i < 15; i++){
                m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
                m[i - 1] &= 0xffff;
            }
            m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
            b = m[15] >> 16 & 1;
            m[14] &= 0xffff;
            sel25519(t, m, 1 - b);
        }
        for(i = 0; i < 16; i++){
            o[2 * i] = t[i] & 0xff;
            o[2 * i + 1] = t[i] >> 8;
        }
    }
    function neq25519(a, b) {
        var c = new Uint8Array(32), d = new Uint8Array(32);
        pack25519(c, a);
        pack25519(d, b);
        return crypto_verify_32(c, 0, d, 0);
    }
    function par25519(a) {
        var d = new Uint8Array(32);
        pack25519(d, a);
        return d[0] & 1;
    }
    function unpack25519(o, n) {
        var i;
        for(i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
        o[15] &= 0x7fff;
    }
    function A(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] + b[i];
    }
    function Z(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] - b[i];
    }
    function M(o, a, b) {
        var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
        v = a[0];
        t0 += v * b0;
        t1 += v * b1;
        t2 += v * b2;
        t3 += v * b3;
        t4 += v * b4;
        t5 += v * b5;
        t6 += v * b6;
        t7 += v * b7;
        t8 += v * b8;
        t9 += v * b9;
        t10 += v * b10;
        t11 += v * b11;
        t12 += v * b12;
        t13 += v * b13;
        t14 += v * b14;
        t15 += v * b15;
        v = a[1];
        t1 += v * b0;
        t2 += v * b1;
        t3 += v * b2;
        t4 += v * b3;
        t5 += v * b4;
        t6 += v * b5;
        t7 += v * b6;
        t8 += v * b7;
        t9 += v * b8;
        t10 += v * b9;
        t11 += v * b10;
        t12 += v * b11;
        t13 += v * b12;
        t14 += v * b13;
        t15 += v * b14;
        t16 += v * b15;
        v = a[2];
        t2 += v * b0;
        t3 += v * b1;
        t4 += v * b2;
        t5 += v * b3;
        t6 += v * b4;
        t7 += v * b5;
        t8 += v * b6;
        t9 += v * b7;
        t10 += v * b8;
        t11 += v * b9;
        t12 += v * b10;
        t13 += v * b11;
        t14 += v * b12;
        t15 += v * b13;
        t16 += v * b14;
        t17 += v * b15;
        v = a[3];
        t3 += v * b0;
        t4 += v * b1;
        t5 += v * b2;
        t6 += v * b3;
        t7 += v * b4;
        t8 += v * b5;
        t9 += v * b6;
        t10 += v * b7;
        t11 += v * b8;
        t12 += v * b9;
        t13 += v * b10;
        t14 += v * b11;
        t15 += v * b12;
        t16 += v * b13;
        t17 += v * b14;
        t18 += v * b15;
        v = a[4];
        t4 += v * b0;
        t5 += v * b1;
        t6 += v * b2;
        t7 += v * b3;
        t8 += v * b4;
        t9 += v * b5;
        t10 += v * b6;
        t11 += v * b7;
        t12 += v * b8;
        t13 += v * b9;
        t14 += v * b10;
        t15 += v * b11;
        t16 += v * b12;
        t17 += v * b13;
        t18 += v * b14;
        t19 += v * b15;
        v = a[5];
        t5 += v * b0;
        t6 += v * b1;
        t7 += v * b2;
        t8 += v * b3;
        t9 += v * b4;
        t10 += v * b5;
        t11 += v * b6;
        t12 += v * b7;
        t13 += v * b8;
        t14 += v * b9;
        t15 += v * b10;
        t16 += v * b11;
        t17 += v * b12;
        t18 += v * b13;
        t19 += v * b14;
        t20 += v * b15;
        v = a[6];
        t6 += v * b0;
        t7 += v * b1;
        t8 += v * b2;
        t9 += v * b3;
        t10 += v * b4;
        t11 += v * b5;
        t12 += v * b6;
        t13 += v * b7;
        t14 += v * b8;
        t15 += v * b9;
        t16 += v * b10;
        t17 += v * b11;
        t18 += v * b12;
        t19 += v * b13;
        t20 += v * b14;
        t21 += v * b15;
        v = a[7];
        t7 += v * b0;
        t8 += v * b1;
        t9 += v * b2;
        t10 += v * b3;
        t11 += v * b4;
        t12 += v * b5;
        t13 += v * b6;
        t14 += v * b7;
        t15 += v * b8;
        t16 += v * b9;
        t17 += v * b10;
        t18 += v * b11;
        t19 += v * b12;
        t20 += v * b13;
        t21 += v * b14;
        t22 += v * b15;
        v = a[8];
        t8 += v * b0;
        t9 += v * b1;
        t10 += v * b2;
        t11 += v * b3;
        t12 += v * b4;
        t13 += v * b5;
        t14 += v * b6;
        t15 += v * b7;
        t16 += v * b8;
        t17 += v * b9;
        t18 += v * b10;
        t19 += v * b11;
        t20 += v * b12;
        t21 += v * b13;
        t22 += v * b14;
        t23 += v * b15;
        v = a[9];
        t9 += v * b0;
        t10 += v * b1;
        t11 += v * b2;
        t12 += v * b3;
        t13 += v * b4;
        t14 += v * b5;
        t15 += v * b6;
        t16 += v * b7;
        t17 += v * b8;
        t18 += v * b9;
        t19 += v * b10;
        t20 += v * b11;
        t21 += v * b12;
        t22 += v * b13;
        t23 += v * b14;
        t24 += v * b15;
        v = a[10];
        t10 += v * b0;
        t11 += v * b1;
        t12 += v * b2;
        t13 += v * b3;
        t14 += v * b4;
        t15 += v * b5;
        t16 += v * b6;
        t17 += v * b7;
        t18 += v * b8;
        t19 += v * b9;
        t20 += v * b10;
        t21 += v * b11;
        t22 += v * b12;
        t23 += v * b13;
        t24 += v * b14;
        t25 += v * b15;
        v = a[11];
        t11 += v * b0;
        t12 += v * b1;
        t13 += v * b2;
        t14 += v * b3;
        t15 += v * b4;
        t16 += v * b5;
        t17 += v * b6;
        t18 += v * b7;
        t19 += v * b8;
        t20 += v * b9;
        t21 += v * b10;
        t22 += v * b11;
        t23 += v * b12;
        t24 += v * b13;
        t25 += v * b14;
        t26 += v * b15;
        v = a[12];
        t12 += v * b0;
        t13 += v * b1;
        t14 += v * b2;
        t15 += v * b3;
        t16 += v * b4;
        t17 += v * b5;
        t18 += v * b6;
        t19 += v * b7;
        t20 += v * b8;
        t21 += v * b9;
        t22 += v * b10;
        t23 += v * b11;
        t24 += v * b12;
        t25 += v * b13;
        t26 += v * b14;
        t27 += v * b15;
        v = a[13];
        t13 += v * b0;
        t14 += v * b1;
        t15 += v * b2;
        t16 += v * b3;
        t17 += v * b4;
        t18 += v * b5;
        t19 += v * b6;
        t20 += v * b7;
        t21 += v * b8;
        t22 += v * b9;
        t23 += v * b10;
        t24 += v * b11;
        t25 += v * b12;
        t26 += v * b13;
        t27 += v * b14;
        t28 += v * b15;
        v = a[14];
        t14 += v * b0;
        t15 += v * b1;
        t16 += v * b2;
        t17 += v * b3;
        t18 += v * b4;
        t19 += v * b5;
        t20 += v * b6;
        t21 += v * b7;
        t22 += v * b8;
        t23 += v * b9;
        t24 += v * b10;
        t25 += v * b11;
        t26 += v * b12;
        t27 += v * b13;
        t28 += v * b14;
        t29 += v * b15;
        v = a[15];
        t15 += v * b0;
        t16 += v * b1;
        t17 += v * b2;
        t18 += v * b3;
        t19 += v * b4;
        t20 += v * b5;
        t21 += v * b6;
        t22 += v * b7;
        t23 += v * b8;
        t24 += v * b9;
        t25 += v * b10;
        t26 += v * b11;
        t27 += v * b12;
        t28 += v * b13;
        t29 += v * b14;
        t30 += v * b15;
        t0 += 38 * t16;
        t1 += 38 * t17;
        t2 += 38 * t18;
        t3 += 38 * t19;
        t4 += 38 * t20;
        t5 += 38 * t21;
        t6 += 38 * t22;
        t7 += 38 * t23;
        t8 += 38 * t24;
        t9 += 38 * t25;
        t10 += 38 * t26;
        t11 += 38 * t27;
        t12 += 38 * t28;
        t13 += 38 * t29;
        t14 += 38 * t30;
        // t15 left as is
        // first car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        // second car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        o[0] = t0;
        o[1] = t1;
        o[2] = t2;
        o[3] = t3;
        o[4] = t4;
        o[5] = t5;
        o[6] = t6;
        o[7] = t7;
        o[8] = t8;
        o[9] = t9;
        o[10] = t10;
        o[11] = t11;
        o[12] = t12;
        o[13] = t13;
        o[14] = t14;
        o[15] = t15;
    }
    function S(o, a) {
        M(o, a, a);
    }
    function inv25519(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 253; a >= 0; a--){
            S(c, c);
            if (a !== 2 && a !== 4) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    }
    function pow2523(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 250; a >= 0; a--){
            S(c, c);
            if (a !== 1) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    }
    function crypto_scalarmult(q, n, p) {
        var z = new Uint8Array(32);
        var x = new Float64Array(80), r, i;
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf();
        for(i = 0; i < 31; i++)z[i] = n[i];
        z[31] = n[31] & 127 | 64;
        z[0] &= 248;
        unpack25519(x, p);
        for(i = 0; i < 16; i++){
            b[i] = x[i];
            d[i] = a[i] = c[i] = 0;
        }
        a[0] = d[0] = 1;
        for(i = 254; i >= 0; --i){
            r = z[i >>> 3] >>> (i & 7) & 1;
            sel25519(a, b, r);
            sel25519(c, d, r);
            A(e, a, c);
            Z(a, a, c);
            A(c, b, d);
            Z(b, b, d);
            S(d, e);
            S(f, a);
            M(a, c, a);
            M(c, b, e);
            A(e, a, c);
            Z(a, a, c);
            S(b, a);
            Z(c, d, f);
            M(a, c, _121665);
            A(a, a, d);
            M(c, c, a);
            M(a, d, f);
            M(d, b, x);
            S(b, e);
            sel25519(a, b, r);
            sel25519(c, d, r);
        }
        for(i = 0; i < 16; i++){
            x[i + 16] = a[i];
            x[i + 32] = c[i];
            x[i + 48] = b[i];
            x[i + 64] = d[i];
        }
        var x32 = x.subarray(32);
        var x16 = x.subarray(16);
        inv25519(x32, x32);
        M(x16, x16, x32);
        pack25519(q, x16);
        return 0;
    }
    function crypto_scalarmult_base(q, n) {
        return crypto_scalarmult(q, n, _9);
    }
    function crypto_box_keypair(y, x) {
        randombytes(x, 32);
        return crypto_scalarmult_base(y, x);
    }
    function crypto_box_beforenm(k, y, x) {
        var s = new Uint8Array(32);
        crypto_scalarmult(s, x, y);
        return crypto_core_hsalsa20(k, _0, s, sigma);
    }
    var crypto_box_afternm = crypto_secretbox;
    var crypto_box_open_afternm = crypto_secretbox_open;
    function crypto_box(c, m, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_afternm(c, m, d, n, k);
    }
    function crypto_box_open(m, c, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_open_afternm(m, c, d, n, k);
    }
    var K = [
        0x428a2f98,
        0xd728ae22,
        0x71374491,
        0x23ef65cd,
        0xb5c0fbcf,
        0xec4d3b2f,
        0xe9b5dba5,
        0x8189dbbc,
        0x3956c25b,
        0xf348b538,
        0x59f111f1,
        0xb605d019,
        0x923f82a4,
        0xaf194f9b,
        0xab1c5ed5,
        0xda6d8118,
        0xd807aa98,
        0xa3030242,
        0x12835b01,
        0x45706fbe,
        0x243185be,
        0x4ee4b28c,
        0x550c7dc3,
        0xd5ffb4e2,
        0x72be5d74,
        0xf27b896f,
        0x80deb1fe,
        0x3b1696b1,
        0x9bdc06a7,
        0x25c71235,
        0xc19bf174,
        0xcf692694,
        0xe49b69c1,
        0x9ef14ad2,
        0xefbe4786,
        0x384f25e3,
        0x0fc19dc6,
        0x8b8cd5b5,
        0x240ca1cc,
        0x77ac9c65,
        0x2de92c6f,
        0x592b0275,
        0x4a7484aa,
        0x6ea6e483,
        0x5cb0a9dc,
        0xbd41fbd4,
        0x76f988da,
        0x831153b5,
        0x983e5152,
        0xee66dfab,
        0xa831c66d,
        0x2db43210,
        0xb00327c8,
        0x98fb213f,
        0xbf597fc7,
        0xbeef0ee4,
        0xc6e00bf3,
        0x3da88fc2,
        0xd5a79147,
        0x930aa725,
        0x06ca6351,
        0xe003826f,
        0x14292967,
        0x0a0e6e70,
        0x27b70a85,
        0x46d22ffc,
        0x2e1b2138,
        0x5c26c926,
        0x4d2c6dfc,
        0x5ac42aed,
        0x53380d13,
        0x9d95b3df,
        0x650a7354,
        0x8baf63de,
        0x766a0abb,
        0x3c77b2a8,
        0x81c2c92e,
        0x47edaee6,
        0x92722c85,
        0x1482353b,
        0xa2bfe8a1,
        0x4cf10364,
        0xa81a664b,
        0xbc423001,
        0xc24b8b70,
        0xd0f89791,
        0xc76c51a3,
        0x0654be30,
        0xd192e819,
        0xd6ef5218,
        0xd6990624,
        0x5565a910,
        0xf40e3585,
        0x5771202a,
        0x106aa070,
        0x32bbd1b8,
        0x19a4c116,
        0xb8d2d0c8,
        0x1e376c08,
        0x5141ab53,
        0x2748774c,
        0xdf8eeb99,
        0x34b0bcb5,
        0xe19b48a8,
        0x391c0cb3,
        0xc5c95a63,
        0x4ed8aa4a,
        0xe3418acb,
        0x5b9cca4f,
        0x7763e373,
        0x682e6ff3,
        0xd6b2b8a3,
        0x748f82ee,
        0x5defb2fc,
        0x78a5636f,
        0x43172f60,
        0x84c87814,
        0xa1f0ab72,
        0x8cc70208,
        0x1a6439ec,
        0x90befffa,
        0x23631e28,
        0xa4506ceb,
        0xde82bde9,
        0xbef9a3f7,
        0xb2c67915,
        0xc67178f2,
        0xe372532b,
        0xca273ece,
        0xea26619c,
        0xd186b8c7,
        0x21c0c207,
        0xeada7dd6,
        0xcde0eb1e,
        0xf57d4f7f,
        0xee6ed178,
        0x06f067aa,
        0x72176fba,
        0x0a637dc5,
        0xa2c898a6,
        0x113f9804,
        0xbef90dae,
        0x1b710b35,
        0x131c471b,
        0x28db77f5,
        0x23047d84,
        0x32caab7b,
        0x40c72493,
        0x3c9ebe0a,
        0x15c9bebc,
        0x431d67c4,
        0x9c100d4c,
        0x4cc5d4be,
        0xcb3e42b6,
        0x597f299c,
        0xfc657e2a,
        0x5fcb6fab,
        0x3ad6faec,
        0x6c44198c,
        0x4a475817
    ];
    function crypto_hashblocks_hl(hh, hl, m, n) {
        var wh = new Int32Array(16), wl = new Int32Array(16), bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7, bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7, th, tl, i, j, h, l, a, b, c, d;
        var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
        var pos = 0;
        while(n >= 128){
            for(i = 0; i < 16; i++){
                j = 8 * i + pos;
                wh[i] = m[j + 0] << 24 | m[j + 1] << 16 | m[j + 2] << 8 | m[j + 3];
                wl[i] = m[j + 4] << 24 | m[j + 5] << 16 | m[j + 6] << 8 | m[j + 7];
            }
            for(i = 0; i < 80; i++){
                bh0 = ah0;
                bh1 = ah1;
                bh2 = ah2;
                bh3 = ah3;
                bh4 = ah4;
                bh5 = ah5;
                bh6 = ah6;
                bh7 = ah7;
                bl0 = al0;
                bl1 = al1;
                bl2 = al2;
                bl3 = al3;
                bl4 = al4;
                bl5 = al5;
                bl6 = al6;
                bl7 = al7;
                // add
                h = ah7;
                l = al7;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma1
                h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
                l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Ch
                h = ah4 & ah5 ^ ~ah4 & ah6;
                l = al4 & al5 ^ ~al4 & al6;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // K
                h = K[i * 2];
                l = K[i * 2 + 1];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // w
                h = wh[i % 16];
                l = wl[i % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                th = c & 0xffff | d << 16;
                tl = a & 0xffff | b << 16;
                // add
                h = th;
                l = tl;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma0
                h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
                l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Maj
                h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
                l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh7 = c & 0xffff | d << 16;
                bl7 = a & 0xffff | b << 16;
                // add
                h = bh3;
                l = bl3;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = th;
                l = tl;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh3 = c & 0xffff | d << 16;
                bl3 = a & 0xffff | b << 16;
                ah1 = bh0;
                ah2 = bh1;
                ah3 = bh2;
                ah4 = bh3;
                ah5 = bh4;
                ah6 = bh5;
                ah7 = bh6;
                ah0 = bh7;
                al1 = bl0;
                al2 = bl1;
                al3 = bl2;
                al4 = bl3;
                al5 = bl4;
                al6 = bl5;
                al7 = bl6;
                al0 = bl7;
                if (i % 16 === 15) for(j = 0; j < 16; j++){
                    // add
                    h = wh[j];
                    l = wl[j];
                    a = l & 0xffff;
                    b = l >>> 16;
                    c = h & 0xffff;
                    d = h >>> 16;
                    h = wh[(j + 9) % 16];
                    l = wl[(j + 9) % 16];
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma0
                    th = wh[(j + 1) % 16];
                    tl = wl[(j + 1) % 16];
                    h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                    l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma1
                    th = wh[(j + 14) % 16];
                    tl = wl[(j + 14) % 16];
                    h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                    l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    b += a >>> 16;
                    c += b >>> 16;
                    d += c >>> 16;
                    wh[j] = c & 0xffff | d << 16;
                    wl[j] = a & 0xffff | b << 16;
                }
            }
            // add
            h = ah0;
            l = al0;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[0];
            l = hl[0];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[0] = ah0 = c & 0xffff | d << 16;
            hl[0] = al0 = a & 0xffff | b << 16;
            h = ah1;
            l = al1;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[1];
            l = hl[1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[1] = ah1 = c & 0xffff | d << 16;
            hl[1] = al1 = a & 0xffff | b << 16;
            h = ah2;
            l = al2;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[2];
            l = hl[2];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[2] = ah2 = c & 0xffff | d << 16;
            hl[2] = al2 = a & 0xffff | b << 16;
            h = ah3;
            l = al3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[3];
            l = hl[3];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[3] = ah3 = c & 0xffff | d << 16;
            hl[3] = al3 = a & 0xffff | b << 16;
            h = ah4;
            l = al4;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[4];
            l = hl[4];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[4] = ah4 = c & 0xffff | d << 16;
            hl[4] = al4 = a & 0xffff | b << 16;
            h = ah5;
            l = al5;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[5];
            l = hl[5];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[5] = ah5 = c & 0xffff | d << 16;
            hl[5] = al5 = a & 0xffff | b << 16;
            h = ah6;
            l = al6;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[6];
            l = hl[6];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[6] = ah6 = c & 0xffff | d << 16;
            hl[6] = al6 = a & 0xffff | b << 16;
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[7];
            l = hl[7];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[7] = ah7 = c & 0xffff | d << 16;
            hl[7] = al7 = a & 0xffff | b << 16;
            pos += 128;
            n -= 128;
        }
        return n;
    }
    function crypto_hash(out, m, n) {
        var hh = new Int32Array(8), hl = new Int32Array(8), x = new Uint8Array(256), i, b = n;
        hh[0] = 0x6a09e667;
        hh[1] = 0xbb67ae85;
        hh[2] = 0x3c6ef372;
        hh[3] = 0xa54ff53a;
        hh[4] = 0x510e527f;
        hh[5] = 0x9b05688c;
        hh[6] = 0x1f83d9ab;
        hh[7] = 0x5be0cd19;
        hl[0] = 0xf3bcc908;
        hl[1] = 0x84caa73b;
        hl[2] = 0xfe94f82b;
        hl[3] = 0x5f1d36f1;
        hl[4] = 0xade682d1;
        hl[5] = 0x2b3e6c1f;
        hl[6] = 0xfb41bd6b;
        hl[7] = 0x137e2179;
        crypto_hashblocks_hl(hh, hl, m, n);
        n %= 128;
        for(i = 0; i < n; i++)x[i] = m[b - n + i];
        x[n] = 128;
        n = 256 - 128 * (n < 112 ? 1 : 0);
        x[n - 9] = 0;
        ts64(x, n - 8, b / 0x20000000 | 0, b << 3);
        crypto_hashblocks_hl(hh, hl, x, n);
        for(i = 0; i < 8; i++)ts64(out, 8 * i, hh[i], hl[i]);
        return 0;
    }
    function add(p, q) {
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf(), g = gf(), h = gf(), t = gf();
        Z(a, p[1], p[0]);
        Z(t, q[1], q[0]);
        M(a, a, t);
        A(b, p[0], p[1]);
        A(t, q[0], q[1]);
        M(b, b, t);
        M(c, p[3], q[3]);
        M(c, c, D2);
        M(d, p[2], q[2]);
        A(d, d, d);
        Z(e, b, a);
        Z(f, d, c);
        A(g, d, c);
        A(h, b, a);
        M(p[0], e, f);
        M(p[1], h, g);
        M(p[2], g, f);
        M(p[3], e, h);
    }
    function cswap(p, q, b) {
        var i;
        for(i = 0; i < 4; i++)sel25519(p[i], q[i], b);
    }
    function pack(r, p) {
        var tx = gf(), ty = gf(), zi = gf();
        inv25519(zi, p[2]);
        M(tx, p[0], zi);
        M(ty, p[1], zi);
        pack25519(r, ty);
        r[31] ^= par25519(tx) << 7;
    }
    function scalarmult(p, q, s) {
        var b, i;
        set25519(p[0], gf0);
        set25519(p[1], gf1);
        set25519(p[2], gf1);
        set25519(p[3], gf0);
        for(i = 255; i >= 0; --i){
            b = s[i / 8 | 0] >> (i & 7) & 1;
            cswap(p, q, b);
            add(q, p);
            add(p, p);
            cswap(p, q, b);
        }
    }
    function scalarbase(p, s) {
        var q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        set25519(q[0], X);
        set25519(q[1], Y);
        set25519(q[2], gf1);
        M(q[3], X, Y);
        scalarmult(p, q, s);
    }
    function crypto_sign_keypair(pk, sk, seeded) {
        var d = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        var i;
        if (!seeded) randombytes(sk, 32);
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        scalarbase(p, d);
        pack(pk, p);
        for(i = 0; i < 32; i++)sk[i + 32] = pk[i];
        return 0;
    }
    var L = new Float64Array([
        0xed,
        0xd3,
        0xf5,
        0x5c,
        0x1a,
        0x63,
        0x12,
        0x58,
        0xd6,
        0x9c,
        0xf7,
        0xa2,
        0xde,
        0xf9,
        0xde,
        0x14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0x10
    ]);
    function modL(r, x) {
        var carry, i, j, k;
        for(i = 63; i >= 32; --i){
            carry = 0;
            for(j = i - 32, k = i - 12; j < k; ++j){
                x[j] += carry - 16 * x[i] * L[j - (i - 32)];
                carry = Math.floor((x[j] + 128) / 256);
                x[j] -= carry * 256;
            }
            x[j] += carry;
            x[i] = 0;
        }
        carry = 0;
        for(j = 0; j < 32; j++){
            x[j] += carry - (x[31] >> 4) * L[j];
            carry = x[j] >> 8;
            x[j] &= 255;
        }
        for(j = 0; j < 32; j++)x[j] -= carry * L[j];
        for(i = 0; i < 32; i++){
            x[i + 1] += x[i] >> 8;
            r[i] = x[i] & 255;
        }
    }
    function reduce(r) {
        var x = new Float64Array(64), i;
        for(i = 0; i < 64; i++)x[i] = r[i];
        for(i = 0; i < 64; i++)r[i] = 0;
        modL(r, x);
    }
    // Note: difference from C - smlen returned, not passed as argument.
    function crypto_sign(sm, m, n, sk) {
        var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
        var i, j, x = new Float64Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        var smlen = n + 64;
        for(i = 0; i < n; i++)sm[64 + i] = m[i];
        for(i = 0; i < 32; i++)sm[32 + i] = d[32 + i];
        crypto_hash(r, sm.subarray(32), n + 32);
        reduce(r);
        scalarbase(p, r);
        pack(sm, p);
        for(i = 32; i < 64; i++)sm[i] = sk[i];
        crypto_hash(h, sm, n + 64);
        reduce(h);
        for(i = 0; i < 64; i++)x[i] = 0;
        for(i = 0; i < 32; i++)x[i] = r[i];
        for(i = 0; i < 32; i++)for(j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
        modL(sm.subarray(32), x);
        return smlen;
    }
    function unpackneg(r, p) {
        var t = gf(), chk = gf(), num = gf(), den = gf(), den2 = gf(), den4 = gf(), den6 = gf();
        set25519(r[2], gf1);
        unpack25519(r[1], p);
        S(num, r[1]);
        M(den, num, D);
        Z(num, num, r[2]);
        A(den, r[2], den);
        S(den2, den);
        S(den4, den2);
        M(den6, den4, den2);
        M(t, den6, num);
        M(t, t, den);
        pow2523(t, t);
        M(t, t, num);
        M(t, t, den);
        M(t, t, den);
        M(r[0], t, den);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) M(r[0], r[0], I);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) return -1;
        if (par25519(r[0]) === p[31] >> 7) Z(r[0], gf0, r[0]);
        M(r[3], r[0], r[1]);
        return 0;
    }
    function crypto_sign_open(m, sm, n, pk) {
        var i;
        var t = new Uint8Array(32), h = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ], q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        if (n < 64) return -1;
        if (unpackneg(q, pk)) return -1;
        for(i = 0; i < n; i++)m[i] = sm[i];
        for(i = 0; i < 32; i++)m[i + 32] = pk[i];
        crypto_hash(h, m, n);
        reduce(h);
        scalarmult(p, q, h);
        scalarbase(q, sm.subarray(32));
        add(p, q);
        pack(t, p);
        n -= 64;
        if (crypto_verify_32(sm, 0, t, 0)) {
            for(i = 0; i < n; i++)m[i] = 0;
            return -1;
        }
        for(i = 0; i < n; i++)m[i] = sm[i + 64];
        return n;
    }
    var crypto_secretbox_KEYBYTES = 32, crypto_secretbox_NONCEBYTES = 24, crypto_secretbox_ZEROBYTES = 32, crypto_secretbox_BOXZEROBYTES = 16, crypto_scalarmult_BYTES = 32, crypto_scalarmult_SCALARBYTES = 32, crypto_box_PUBLICKEYBYTES = 32, crypto_box_SECRETKEYBYTES = 32, crypto_box_BEFORENMBYTES = 32, crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES, crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES, crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES, crypto_sign_BYTES = 64, crypto_sign_PUBLICKEYBYTES = 32, crypto_sign_SECRETKEYBYTES = 64, crypto_sign_SEEDBYTES = 32, crypto_hash_BYTES = 64;
    nacl.lowlevel = {
        crypto_core_hsalsa20: crypto_core_hsalsa20,
        crypto_stream_xor: crypto_stream_xor,
        crypto_stream: crypto_stream,
        crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
        crypto_stream_salsa20: crypto_stream_salsa20,
        crypto_onetimeauth: crypto_onetimeauth,
        crypto_onetimeauth_verify: crypto_onetimeauth_verify,
        crypto_verify_16: crypto_verify_16,
        crypto_verify_32: crypto_verify_32,
        crypto_secretbox: crypto_secretbox,
        crypto_secretbox_open: crypto_secretbox_open,
        crypto_scalarmult: crypto_scalarmult,
        crypto_scalarmult_base: crypto_scalarmult_base,
        crypto_box_beforenm: crypto_box_beforenm,
        crypto_box_afternm: crypto_box_afternm,
        crypto_box: crypto_box,
        crypto_box_open: crypto_box_open,
        crypto_box_keypair: crypto_box_keypair,
        crypto_hash: crypto_hash,
        crypto_sign: crypto_sign,
        crypto_sign_keypair: crypto_sign_keypair,
        crypto_sign_open: crypto_sign_open,
        crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
        crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
        crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
        crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
        crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
        crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
        crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
        crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
        crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
        crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
        crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
        crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
        crypto_sign_BYTES: crypto_sign_BYTES,
        crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
        crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
        crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
        crypto_hash_BYTES: crypto_hash_BYTES,
        gf: gf,
        D: D,
        L: L,
        pack25519: pack25519,
        unpack25519: unpack25519,
        M: M,
        A: A,
        S: S,
        Z: Z,
        pow2523: pow2523,
        add: add,
        set25519: set25519,
        modL: modL,
        scalarmult: scalarmult,
        scalarbase: scalarbase
    };
    /* High-level API */ function checkLengths(k, n) {
        if (k.length !== crypto_secretbox_KEYBYTES) throw new Error('bad key size');
        if (n.length !== crypto_secretbox_NONCEBYTES) throw new Error('bad nonce size');
    }
    function checkBoxLengths(pk, sk) {
        if (pk.length !== crypto_box_PUBLICKEYBYTES) throw new Error('bad public key size');
        if (sk.length !== crypto_box_SECRETKEYBYTES) throw new Error('bad secret key size');
    }
    function checkArrayTypes() {
        for(var i = 0; i < arguments.length; i++){
            if (!(arguments[i] instanceof Uint8Array)) throw new TypeError('unexpected type, use Uint8Array');
        }
    }
    function cleanup(arr) {
        for(var i = 0; i < arr.length; i++)arr[i] = 0;
    }
    nacl.randomBytes = function(n) {
        var b = new Uint8Array(n);
        randombytes(b, n);
        return b;
    };
    nacl.secretbox = function(msg, nonce, key) {
        checkArrayTypes(msg, nonce, key);
        checkLengths(key, nonce);
        var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
        var c = new Uint8Array(m.length);
        for(var i = 0; i < msg.length; i++)m[i + crypto_secretbox_ZEROBYTES] = msg[i];
        crypto_secretbox(c, m, m.length, nonce, key);
        return c.subarray(crypto_secretbox_BOXZEROBYTES);
    };
    nacl.secretbox.open = function(box, nonce, key) {
        checkArrayTypes(box, nonce, key);
        checkLengths(key, nonce);
        var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
        var m = new Uint8Array(c.length);
        for(var i = 0; i < box.length; i++)c[i + crypto_secretbox_BOXZEROBYTES] = box[i];
        if (c.length < 32) return null;
        if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0) return null;
        return m.subarray(crypto_secretbox_ZEROBYTES);
    };
    nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
    nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
    nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;
    nacl.scalarMult = function(n, p) {
        checkArrayTypes(n, p);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error('bad n size');
        if (p.length !== crypto_scalarmult_BYTES) throw new Error('bad p size');
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult(q, n, p);
        return q;
    };
    nacl.scalarMult.base = function(n) {
        checkArrayTypes(n);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error('bad n size');
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult_base(q, n);
        return q;
    };
    nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
    nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;
    nacl.box = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox(msg, nonce, k);
    };
    nacl.box.before = function(publicKey, secretKey) {
        checkArrayTypes(publicKey, secretKey);
        checkBoxLengths(publicKey, secretKey);
        var k = new Uint8Array(crypto_box_BEFORENMBYTES);
        crypto_box_beforenm(k, publicKey, secretKey);
        return k;
    };
    nacl.box.after = nacl.secretbox;
    nacl.box.open = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox.open(msg, nonce, k);
    };
    nacl.box.open.after = nacl.secretbox.open;
    nacl.box.keyPair = function() {
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
        crypto_box_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.box.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_box_SECRETKEYBYTES) throw new Error('bad secret key size');
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        crypto_scalarmult_base(pk, secretKey);
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
    nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
    nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
    nacl.box.nonceLength = crypto_box_NONCEBYTES;
    nacl.box.overheadLength = nacl.secretbox.overheadLength;
    nacl.sign = function(msg, secretKey) {
        checkArrayTypes(msg, secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error('bad secret key size');
        var signedMsg = new Uint8Array(crypto_sign_BYTES + msg.length);
        crypto_sign(signedMsg, msg, msg.length, secretKey);
        return signedMsg;
    };
    nacl.sign.open = function(signedMsg, publicKey) {
        checkArrayTypes(signedMsg, publicKey);
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error('bad public key size');
        var tmp = new Uint8Array(signedMsg.length);
        var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
        if (mlen < 0) return null;
        var m = new Uint8Array(mlen);
        for(var i = 0; i < m.length; i++)m[i] = tmp[i];
        return m;
    };
    nacl.sign.detached = function(msg, secretKey) {
        var signedMsg = nacl.sign(msg, secretKey);
        var sig = new Uint8Array(crypto_sign_BYTES);
        for(var i = 0; i < sig.length; i++)sig[i] = signedMsg[i];
        return sig;
    };
    nacl.sign.detached.verify = function(msg, sig, publicKey) {
        checkArrayTypes(msg, sig, publicKey);
        if (sig.length !== crypto_sign_BYTES) throw new Error('bad signature size');
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error('bad public key size');
        var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
        var m = new Uint8Array(crypto_sign_BYTES + msg.length);
        var i;
        for(i = 0; i < crypto_sign_BYTES; i++)sm[i] = sig[i];
        for(i = 0; i < msg.length; i++)sm[i + crypto_sign_BYTES] = msg[i];
        return crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
    };
    nacl.sign.keyPair = function() {
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        crypto_sign_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error('bad secret key size');
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        for(var i = 0; i < pk.length; i++)pk[i] = secretKey[32 + i];
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.sign.keyPair.fromSeed = function(seed) {
        checkArrayTypes(seed);
        if (seed.length !== crypto_sign_SEEDBYTES) throw new Error('bad seed size');
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        for(var i = 0; i < 32; i++)sk[i] = seed[i];
        crypto_sign_keypair(pk, sk, true);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
    nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
    nacl.sign.seedLength = crypto_sign_SEEDBYTES;
    nacl.sign.signatureLength = crypto_sign_BYTES;
    nacl.hash = function(msg) {
        checkArrayTypes(msg);
        var h = new Uint8Array(crypto_hash_BYTES);
        crypto_hash(h, msg, msg.length);
        return h;
    };
    nacl.hash.hashLength = crypto_hash_BYTES;
    nacl.verify = function(x, y) {
        checkArrayTypes(x, y);
        // Zero length arguments are considered not equal.
        if (x.length === 0 || y.length === 0) return false;
        if (x.length !== y.length) return false;
        return vn(x, 0, y, 0, x.length) === 0 ? true : false;
    };
    nacl.setPRNG = function(fn) {
        randombytes = fn;
    };
    (function() {
        // Initialize PRNG if environment provides CSPRNG.
        // If not, methods calling randombytes will throw.
        var crypto = typeof self !== 'undefined' ? self.crypto || self.msCrypto : null;
        if (crypto && crypto.getRandomValues) {
            // Browsers.
            var QUOTA = 65536;
            nacl.setPRNG(function(x, n) {
                var i, v = new Uint8Array(n);
                for(i = 0; i < n; i += QUOTA)crypto.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        } else {
            // Node.js.
            crypto = require("64deaebb838d47b8");
            if (crypto && crypto.randomBytes) nacl.setPRNG(function(x, n) {
                var i, v = crypto.randomBytes(n);
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        }
    })();
})((0, module.exports) ? module.exports : self.nacl = self.nacl || {});

},{"64deaebb838d47b8":"cIz3r"}],"cIz3r":[function(require,module,exports,__globalThis) {
"use strict";

},{}],"9Fj5k":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NodeInternal = exports.GRPCWrapper = exports.OasisCodedError = void 0;
// Code below not generated by reflect-go.
const grpcWeb = require("9d1eb17909bce9fe");
const proto = require("6db49ae9491abcda");
const misc = require("f5d0aed926730b6");
function toCBOR(v) {
    // gRPC cannot handle nil arguments unmarshalled from CBOR, so we use a special case to
    // marshal `nil` to an empty byte string.
    if (v == null) return new Uint8Array();
    return misc.toCBOR(v);
}
function createMethodDescriptorUnary(serviceName, methodName) {
    const MethodType = grpcWeb.MethodType;
    return new grpcWeb.MethodDescriptor(`/oasis-core.${serviceName}/${methodName}`, MethodType.UNARY, null, null, toCBOR, misc.fromCBOR);
}
function createMethodDescriptorServerStreaming(serviceName, methodName) {
    const MethodType = grpcWeb.MethodType;
    return new grpcWeb.MethodDescriptor(`/oasis-core.${serviceName}/${methodName}`, MethodType.SERVER_STREAMING, null, null, toCBOR, misc.fromCBOR);
}
class OasisCodedError extends Error {
}
exports.OasisCodedError = OasisCodedError;
class GRPCWrapper {
    constructor(base){
        this.client = new grpcWeb.GrpcWebClientBase({});
        this.base = base;
    }
    callUnary(desc, request) {
        const method = this.base + desc.getName();
        // Some browsers with enormous market share aren't able to preserve the stack between here
        // and our `.catch` callback below. Save a copy explicitly.
        const invocationStack = new Error().stack;
        return this.client.thenableCall(method, request, // @ts-expect-error metadata nullability not modeled
        null, desc).catch((e)=>{
            if (e.metadata?.['grpc-status-details-bin']) {
                const statusU8 = misc.fromBase64(e.metadata['grpc-status-details-bin']);
                const status = proto.google.rpc.Status.decode(statusU8);
                const details = status.details;
                // `errorFromGrpc` from oasis-core checks for exactly one entry in Details.
                // We additionally check that the type URL is empty, consistent with how
                // `errorToGrpc` leaves it blank.
                if (details.length === 1 && details[0].type_url === '' && details[0].value) {
                    const grpcError = misc.fromCBOR(details[0].value);
                    const innerMessage = e.message || `Message missing, module=${grpcError.module} code=${grpcError.code}`;
                    const message = `callUnary method ${method}: ${innerMessage}`;
                    // @ts-expect-error options and cause not modeled
                    const wrapped = new OasisCodedError(message, {
                        cause: e
                    });
                    wrapped.oasisCode = grpcError.code;
                    wrapped.oasisModule = grpcError.module;
                    wrapped.stack += `
Cause stack:
${e.stack}
End of cause stack
Invocation stack:
${invocationStack}
End of invocation stack`;
                    throw wrapped;
                }
            }
            // Just in case there's some non-Error rejection reason that doesn't come with metadata
            // from oasis-core as expected above, try using JSON to stringify it so that we don't
            // end up with [object Object].
            const innerMessage = e instanceof Error ? e.toString() : JSON.stringify(e);
            const message = `callUnary method ${method}: ${innerMessage}`;
            // @ts-expect-error options and cause not modeled
            const wrapped = new Error(message, {
                cause: e
            });
            wrapped.stack += `
Cause stack:
${e.stack}
End of cause stack
Invocation stack:
${invocationStack}
End of invocation stack`;
            throw wrapped;
        });
    }
    callServerStreaming(desc, request) {
        return this.client.serverStreaming(this.base + desc.getName(), request, // @ts-expect-error metadata nullability not modeled
        null, desc);
    }
}
exports.GRPCWrapper = GRPCWrapper;
// Code above not generated by reflect-go.
const methodDescriptorBeaconConsensusParameters = createMethodDescriptorUnary('Beacon', 'ConsensusParameters');
const methodDescriptorBeaconGetBaseEpoch = createMethodDescriptorUnary('Beacon', 'GetBaseEpoch');
const methodDescriptorBeaconGetBeacon = createMethodDescriptorUnary('Beacon', 'GetBeacon');
const methodDescriptorBeaconGetEpoch = createMethodDescriptorUnary('Beacon', 'GetEpoch');
const methodDescriptorBeaconGetEpochBlock = createMethodDescriptorUnary('Beacon', 'GetEpochBlock');
const methodDescriptorBeaconGetFutureEpoch = createMethodDescriptorUnary('Beacon', 'GetFutureEpoch');
const methodDescriptorBeaconStateToGenesis = createMethodDescriptorUnary('Beacon', 'StateToGenesis');
const methodDescriptorBeaconWaitEpoch = createMethodDescriptorUnary('Beacon', 'WaitEpoch');
const methodDescriptorBeaconWatchEpochs = createMethodDescriptorServerStreaming('Beacon', 'WatchEpochs');
const methodDescriptorBeaconWatchLatestEpoch = createMethodDescriptorServerStreaming('Beacon', 'WatchLatestEpoch');
const methodDescriptorSchedulerConsensusParameters = createMethodDescriptorUnary('Scheduler', 'ConsensusParameters');
const methodDescriptorSchedulerGetCommittees = createMethodDescriptorUnary('Scheduler', 'GetCommittees');
const methodDescriptorSchedulerGetValidators = createMethodDescriptorUnary('Scheduler', 'GetValidators');
const methodDescriptorSchedulerStateToGenesis = createMethodDescriptorUnary('Scheduler', 'StateToGenesis');
const methodDescriptorSchedulerWatchCommittees = createMethodDescriptorServerStreaming('Scheduler', 'WatchCommittees');
const methodDescriptorRegistryConsensusParameters = createMethodDescriptorUnary('Registry', 'ConsensusParameters');
const methodDescriptorRegistryGetEntities = createMethodDescriptorUnary('Registry', 'GetEntities');
const methodDescriptorRegistryGetEntity = createMethodDescriptorUnary('Registry', 'GetEntity');
const methodDescriptorRegistryGetEvents = createMethodDescriptorUnary('Registry', 'GetEvents');
const methodDescriptorRegistryGetNode = createMethodDescriptorUnary('Registry', 'GetNode');
const methodDescriptorRegistryGetNodeByConsensusAddress = createMethodDescriptorUnary('Registry', 'GetNodeByConsensusAddress');
const methodDescriptorRegistryGetNodeStatus = createMethodDescriptorUnary('Registry', 'GetNodeStatus');
const methodDescriptorRegistryGetNodes = createMethodDescriptorUnary('Registry', 'GetNodes');
const methodDescriptorRegistryGetRuntime = createMethodDescriptorUnary('Registry', 'GetRuntime');
const methodDescriptorRegistryGetRuntimes = createMethodDescriptorUnary('Registry', 'GetRuntimes');
const methodDescriptorRegistryStateToGenesis = createMethodDescriptorUnary('Registry', 'StateToGenesis');
const methodDescriptorRegistryWatchEntities = createMethodDescriptorServerStreaming('Registry', 'WatchEntities');
const methodDescriptorRegistryWatchEvents = createMethodDescriptorServerStreaming('Registry', 'WatchEvents');
const methodDescriptorRegistryWatchNodeList = createMethodDescriptorServerStreaming('Registry', 'WatchNodeList');
const methodDescriptorRegistryWatchNodes = createMethodDescriptorServerStreaming('Registry', 'WatchNodes');
const methodDescriptorRegistryWatchRuntimes = createMethodDescriptorServerStreaming('Registry', 'WatchRuntimes');
const methodDescriptorStakingAccount = createMethodDescriptorUnary('Staking', 'Account');
const methodDescriptorStakingAddresses = createMethodDescriptorUnary('Staking', 'Addresses');
const methodDescriptorStakingAllowance = createMethodDescriptorUnary('Staking', 'Allowance');
const methodDescriptorStakingCommissionScheduleAddresses = createMethodDescriptorUnary('Staking', 'CommissionScheduleAddresses');
const methodDescriptorStakingCommonPool = createMethodDescriptorUnary('Staking', 'CommonPool');
const methodDescriptorStakingConsensusParameters = createMethodDescriptorUnary('Staking', 'ConsensusParameters');
const methodDescriptorStakingDebondingDelegationInfosFor = createMethodDescriptorUnary('Staking', 'DebondingDelegationInfosFor');
const methodDescriptorStakingDebondingDelegationsFor = createMethodDescriptorUnary('Staking', 'DebondingDelegationsFor');
const methodDescriptorStakingDebondingDelegationsTo = createMethodDescriptorUnary('Staking', 'DebondingDelegationsTo');
const methodDescriptorStakingDelegationInfosFor = createMethodDescriptorUnary('Staking', 'DelegationInfosFor');
const methodDescriptorStakingDelegationsFor = createMethodDescriptorUnary('Staking', 'DelegationsFor');
const methodDescriptorStakingDelegationsTo = createMethodDescriptorUnary('Staking', 'DelegationsTo');
const methodDescriptorStakingGetEvents = createMethodDescriptorUnary('Staking', 'GetEvents');
const methodDescriptorStakingGovernanceDeposits = createMethodDescriptorUnary('Staking', 'GovernanceDeposits');
const methodDescriptorStakingLastBlockFees = createMethodDescriptorUnary('Staking', 'LastBlockFees');
const methodDescriptorStakingStateToGenesis = createMethodDescriptorUnary('Staking', 'StateToGenesis');
const methodDescriptorStakingThreshold = createMethodDescriptorUnary('Staking', 'Threshold');
const methodDescriptorStakingTokenSymbol = createMethodDescriptorUnary('Staking', 'TokenSymbol');
const methodDescriptorStakingTokenValueExponent = createMethodDescriptorUnary('Staking', 'TokenValueExponent');
const methodDescriptorStakingTotalSupply = createMethodDescriptorUnary('Staking', 'TotalSupply');
const methodDescriptorStakingWatchEvents = createMethodDescriptorServerStreaming('Staking', 'WatchEvents');
const methodDescriptorKeyManagerStateToGenesis = createMethodDescriptorUnary('KeyManager', 'StateToGenesis');
const methodDescriptorRootHashConsensusParameters = createMethodDescriptorUnary('RootHash', 'ConsensusParameters');
const methodDescriptorRootHashGetEvents = createMethodDescriptorUnary('RootHash', 'GetEvents');
const methodDescriptorRootHashGetGenesisBlock = createMethodDescriptorUnary('RootHash', 'GetGenesisBlock');
const methodDescriptorRootHashGetIncomingMessageQueue = createMethodDescriptorUnary('RootHash', 'GetIncomingMessageQueue');
const methodDescriptorRootHashGetIncomingMessageQueueMeta = createMethodDescriptorUnary('RootHash', 'GetIncomingMessageQueueMeta');
const methodDescriptorRootHashGetLastRoundResults = createMethodDescriptorUnary('RootHash', 'GetLastRoundResults');
const methodDescriptorRootHashGetLatestBlock = createMethodDescriptorUnary('RootHash', 'GetLatestBlock');
const methodDescriptorRootHashGetPastRoundRoots = createMethodDescriptorUnary('RootHash', 'GetPastRoundRoots');
const methodDescriptorRootHashGetRoundRoots = createMethodDescriptorUnary('RootHash', 'GetRoundRoots');
const methodDescriptorRootHashGetRuntimeState = createMethodDescriptorUnary('RootHash', 'GetRuntimeState');
const methodDescriptorRootHashStateToGenesis = createMethodDescriptorUnary('RootHash', 'StateToGenesis');
const methodDescriptorRootHashWatchBlocks = createMethodDescriptorServerStreaming('RootHash', 'WatchBlocks');
const methodDescriptorRootHashWatchEvents = createMethodDescriptorServerStreaming('RootHash', 'WatchEvents');
const methodDescriptorRootHashWatchExecutorCommitments = createMethodDescriptorServerStreaming('RootHash', 'WatchExecutorCommitments');
const methodDescriptorGovernanceActiveProposals = createMethodDescriptorUnary('Governance', 'ActiveProposals');
const methodDescriptorGovernanceConsensusParameters = createMethodDescriptorUnary('Governance', 'ConsensusParameters');
const methodDescriptorGovernanceGetEvents = createMethodDescriptorUnary('Governance', 'GetEvents');
const methodDescriptorGovernancePendingUpgrades = createMethodDescriptorUnary('Governance', 'PendingUpgrades');
const methodDescriptorGovernanceProposal = createMethodDescriptorUnary('Governance', 'Proposal');
const methodDescriptorGovernanceProposals = createMethodDescriptorUnary('Governance', 'Proposals');
const methodDescriptorGovernanceStateToGenesis = createMethodDescriptorUnary('Governance', 'StateToGenesis');
const methodDescriptorGovernanceVotes = createMethodDescriptorUnary('Governance', 'Votes');
const methodDescriptorGovernanceWatchEvents = createMethodDescriptorServerStreaming('Governance', 'WatchEvents');
const methodDescriptorStorageGetCheckpointChunk = createMethodDescriptorServerStreaming('Storage', 'GetCheckpointChunk');
const methodDescriptorStorageGetCheckpoints = createMethodDescriptorUnary('Storage', 'GetCheckpoints');
const methodDescriptorStorageGetDiff = createMethodDescriptorServerStreaming('Storage', 'GetDiff');
const methodDescriptorStorageSyncGet = createMethodDescriptorUnary('Storage', 'SyncGet');
const methodDescriptorStorageSyncGetPrefixes = createMethodDescriptorUnary('Storage', 'SyncGetPrefixes');
const methodDescriptorStorageSyncIterate = createMethodDescriptorUnary('Storage', 'SyncIterate');
const methodDescriptorStorageWorkerGetLastSyncedRound = createMethodDescriptorUnary('StorageWorker', 'GetLastSyncedRound');
const methodDescriptorStorageWorkerPauseCheckpointer = createMethodDescriptorUnary('StorageWorker', 'PauseCheckpointer');
const methodDescriptorRuntimeClientCheckTx = createMethodDescriptorUnary('RuntimeClient', 'CheckTx');
const methodDescriptorRuntimeClientGetBlock = createMethodDescriptorUnary('RuntimeClient', 'GetBlock');
const methodDescriptorRuntimeClientGetEvents = createMethodDescriptorUnary('RuntimeClient', 'GetEvents');
const methodDescriptorRuntimeClientGetGenesisBlock = createMethodDescriptorUnary('RuntimeClient', 'GetGenesisBlock');
const methodDescriptorRuntimeClientGetLastRetainedBlock = createMethodDescriptorUnary('RuntimeClient', 'GetLastRetainedBlock');
const methodDescriptorRuntimeClientGetTransactions = createMethodDescriptorUnary('RuntimeClient', 'GetTransactions');
const methodDescriptorRuntimeClientGetTransactionsWithResults = createMethodDescriptorUnary('RuntimeClient', 'GetTransactionsWithResults');
const methodDescriptorRuntimeClientGetUnconfirmedTransactions = createMethodDescriptorUnary('RuntimeClient', 'GetUnconfirmedTransactions');
const methodDescriptorRuntimeClientQuery = createMethodDescriptorUnary('RuntimeClient', 'Query');
const methodDescriptorRuntimeClientSubmitTx = createMethodDescriptorUnary('RuntimeClient', 'SubmitTx');
const methodDescriptorRuntimeClientSubmitTxMeta = createMethodDescriptorUnary('RuntimeClient', 'SubmitTxMeta');
const methodDescriptorRuntimeClientSubmitTxNoWait = createMethodDescriptorUnary('RuntimeClient', 'SubmitTxNoWait');
const methodDescriptorRuntimeClientWatchBlocks = createMethodDescriptorServerStreaming('RuntimeClient', 'WatchBlocks');
const methodDescriptorConsensusEstimateGas = createMethodDescriptorUnary('Consensus', 'EstimateGas');
const methodDescriptorConsensusGetBlock = createMethodDescriptorUnary('Consensus', 'GetBlock');
const methodDescriptorConsensusGetChainContext = createMethodDescriptorUnary('Consensus', 'GetChainContext');
const methodDescriptorConsensusGetGenesisDocument = createMethodDescriptorUnary('Consensus', 'GetGenesisDocument');
const methodDescriptorConsensusGetLastRetainedHeight = createMethodDescriptorUnary('Consensus', 'GetLastRetainedHeight');
const methodDescriptorConsensusGetLatestHeight = createMethodDescriptorUnary('Consensus', 'GetLatestHeight');
const methodDescriptorConsensusGetLightBlock = createMethodDescriptorUnary('Consensus', 'GetLightBlock');
const methodDescriptorConsensusGetNextBlockState = createMethodDescriptorUnary('Consensus', 'GetNextBlockState');
const methodDescriptorConsensusGetParameters = createMethodDescriptorUnary('Consensus', 'GetParameters');
const methodDescriptorConsensusGetSignerNonce = createMethodDescriptorUnary('Consensus', 'GetSignerNonce');
const methodDescriptorConsensusGetStatus = createMethodDescriptorUnary('Consensus', 'GetStatus');
const methodDescriptorConsensusGetTransactions = createMethodDescriptorUnary('Consensus', 'GetTransactions');
const methodDescriptorConsensusGetTransactionsWithProofs = createMethodDescriptorUnary('Consensus', 'GetTransactionsWithProofs');
const methodDescriptorConsensusGetTransactionsWithResults = createMethodDescriptorUnary('Consensus', 'GetTransactionsWithResults');
const methodDescriptorConsensusGetUnconfirmedTransactions = createMethodDescriptorUnary('Consensus', 'GetUnconfirmedTransactions');
const methodDescriptorConsensusMinGasPrice = createMethodDescriptorUnary('Consensus', 'MinGasPrice');
const methodDescriptorConsensusStateToGenesis = createMethodDescriptorUnary('Consensus', 'StateToGenesis');
const methodDescriptorConsensusSubmitEvidence = createMethodDescriptorUnary('Consensus', 'SubmitEvidence');
const methodDescriptorConsensusSubmitTx = createMethodDescriptorUnary('Consensus', 'SubmitTx');
const methodDescriptorConsensusSubmitTxNoWait = createMethodDescriptorUnary('Consensus', 'SubmitTxNoWait');
const methodDescriptorConsensusSubmitTxWithProof = createMethodDescriptorUnary('Consensus', 'SubmitTxWithProof');
const methodDescriptorConsensusWatchBlocks = createMethodDescriptorServerStreaming('Consensus', 'WatchBlocks');
const methodDescriptorConsensusStateSyncGet = createMethodDescriptorUnary('Consensus', 'StateSyncGet');
const methodDescriptorConsensusStateSyncGetPrefixes = createMethodDescriptorUnary('Consensus', 'StateSyncGetPrefixes');
const methodDescriptorConsensusStateSyncIterate = createMethodDescriptorUnary('Consensus', 'StateSyncIterate');
const methodDescriptorNodeControllerAddBundle = createMethodDescriptorUnary('NodeController', 'AddBundle');
const methodDescriptorNodeControllerCancelUpgrade = createMethodDescriptorUnary('NodeController', 'CancelUpgrade');
const methodDescriptorNodeControllerGetStatus = createMethodDescriptorUnary('NodeController', 'GetStatus');
const methodDescriptorNodeControllerIsReady = createMethodDescriptorUnary('NodeController', 'IsReady');
const methodDescriptorNodeControllerIsSynced = createMethodDescriptorUnary('NodeController', 'IsSynced');
const methodDescriptorNodeControllerRequestShutdown = createMethodDescriptorUnary('NodeController', 'RequestShutdown');
const methodDescriptorNodeControllerUpgradeBinary = createMethodDescriptorUnary('NodeController', 'UpgradeBinary');
const methodDescriptorNodeControllerWaitReady = createMethodDescriptorUnary('NodeController', 'WaitReady');
const methodDescriptorNodeControllerWaitSync = createMethodDescriptorUnary('NodeController', 'WaitSync');
const methodDescriptorDebugControllerSetEpoch = createMethodDescriptorUnary('DebugController', 'SetEpoch');
const methodDescriptorDebugControllerWaitNodesRegistered = createMethodDescriptorUnary('DebugController', 'WaitNodesRegistered');
class NodeInternal extends GRPCWrapper {
    /**
     * ConsensusParameters returns the beacon consensus parameters.
     */ beaconConsensusParameters(height) {
        return this.callUnary(methodDescriptorBeaconConsensusParameters, height);
    }
    /**
     * GetBaseEpoch returns the base epoch.
     */ beaconGetBaseEpoch() {
        return this.callUnary(methodDescriptorBeaconGetBaseEpoch, undefined);
    }
    /**
     * GetBeacon gets the beacon for the provided block height.
     * Calling this method with height `consensus.HeightLatest` should
     * return the beacon for the latest finalized block.
     */ beaconGetBeacon(height) {
        return this.callUnary(methodDescriptorBeaconGetBeacon, height);
    }
    /**
     * GetEpoch returns the epoch number at the specified block height.
     * Calling this method with height `consensus.HeightLatest`, should
     * return the epoch of latest known block.
     */ beaconGetEpoch(height) {
        return this.callUnary(methodDescriptorBeaconGetEpoch, height);
    }
    /**
     * GetEpochBlock returns the block height at the start of the said
     * epoch.
     */ beaconGetEpochBlock(epoch) {
        return this.callUnary(methodDescriptorBeaconGetEpochBlock, epoch);
    }
    /**
     * GetFutureEpoch returns any future epoch that is currently scheduled
     * to occur at a specific height.
     *
     * Note that this may return a nil state in case no future epoch is
     * currently scheduled.
     */ beaconGetFutureEpoch(height) {
        return this.callUnary(methodDescriptorBeaconGetFutureEpoch, height);
    }
    /**
     * StateToGenesis returns the genesis state at specified block height.
     */ beaconStateToGenesis(height) {
        return this.callUnary(methodDescriptorBeaconStateToGenesis, height);
    }
    /**
     * WaitEpoch waits for a specific epoch.
     *
     * Note that an epoch is considered reached even if any epoch greater
     * than the one specified is reached (e.g., that the current epoch
     * is already in the future).
     */ beaconWaitEpoch(epoch) {
        return this.callUnary(methodDescriptorBeaconWaitEpoch, epoch);
    }
    /**
     * WatchEpochs returns a channel that produces a stream of messages
     * on epoch transitions.
     *
     * Upon subscription the current epoch is sent immediately.
     */ beaconWatchEpochs() {
        return this.callServerStreaming(methodDescriptorBeaconWatchEpochs, undefined);
    }
    /**
     * WatchLatestEpoch returns a channel that produces a stream of
     * messages on epoch transitions. If an epoch transition happens
     * before the previous epoch is read from the channel, the old
     * epochs are overwritten.
     *
     * Upon subscription the current epoch is sent immediately.
     */ beaconWatchLatestEpoch() {
        return this.callServerStreaming(methodDescriptorBeaconWatchLatestEpoch, undefined);
    }
    /**
     * ConsensusParameters returns the scheduler consensus parameters.
     */ schedulerConsensusParameters(height) {
        return this.callUnary(methodDescriptorSchedulerConsensusParameters, height);
    }
    /**
     * GetCommittees returns the vector of committees for a given
     * runtime ID, at the specified block height, and optional callback
     * for querying the beacon for a given epoch/block height.
     *
     * Iff the callback is nil, `beacon.GetBlockBeacon` will be used.
     */ schedulerGetCommittees(request) {
        return this.callUnary(methodDescriptorSchedulerGetCommittees, request);
    }
    /**
     * GetValidators returns the vector of consensus validators for
     * a given epoch.
     */ schedulerGetValidators(height) {
        return this.callUnary(methodDescriptorSchedulerGetValidators, height);
    }
    /**
     * StateToGenesis returns the genesis state at specified block height.
     */ schedulerStateToGenesis(height) {
        return this.callUnary(methodDescriptorSchedulerStateToGenesis, height);
    }
    /**
     * WatchCommittees returns a channel that produces a stream of
     * Committee.
     *
     * Upon subscription, all committees for the current epoch will
     * be sent immediately.
     */ schedulerWatchCommittees() {
        return this.callServerStreaming(methodDescriptorSchedulerWatchCommittees, undefined);
    }
    /**
     * ConsensusParameters returns the registry consensus parameters.
     */ registryConsensusParameters(height) {
        return this.callUnary(methodDescriptorRegistryConsensusParameters, height);
    }
    /**
     * GetEntities gets a list of all registered entities.
     */ registryGetEntities(height) {
        return this.callUnary(methodDescriptorRegistryGetEntities, height);
    }
    /**
     * GetEntity gets an entity by ID.
     */ registryGetEntity(query) {
        return this.callUnary(methodDescriptorRegistryGetEntity, query);
    }
    /**
     * GetEvents returns the events at specified block height.
     */ registryGetEvents(height) {
        return this.callUnary(methodDescriptorRegistryGetEvents, height);
    }
    /**
     * GetNode gets a node by ID.
     */ registryGetNode(query) {
        return this.callUnary(methodDescriptorRegistryGetNode, query);
    }
    /**
     * GetNodeByConsensusAddress looks up a node by its consensus address at the
     * specified block height. The nature and format of the consensus address depends
     * on the specific consensus backend implementation used.
     */ registryGetNodeByConsensusAddress(query) {
        return this.callUnary(methodDescriptorRegistryGetNodeByConsensusAddress, query);
    }
    /**
     * GetNodeStatus returns a node's status.
     */ registryGetNodeStatus(query) {
        return this.callUnary(methodDescriptorRegistryGetNodeStatus, query);
    }
    /**
     * GetNodes gets a list of all registered nodes.
     */ registryGetNodes(height) {
        return this.callUnary(methodDescriptorRegistryGetNodes, height);
    }
    /**
     * GetRuntime gets a runtime by ID.
     */ registryGetRuntime(query) {
        return this.callUnary(methodDescriptorRegistryGetRuntime, query);
    }
    /**
     * GetRuntimes returns the registered Runtimes at the specified
     * block height.
     */ registryGetRuntimes(query) {
        return this.callUnary(methodDescriptorRegistryGetRuntimes, query);
    }
    /**
     * StateToGenesis returns the genesis state at specified block height.
     */ registryStateToGenesis(height) {
        return this.callUnary(methodDescriptorRegistryStateToGenesis, height);
    }
    /**
     * WatchEntities returns a channel that produces a stream of
     * EntityEvent on entity registration changes.
     */ registryWatchEntities() {
        return this.callServerStreaming(methodDescriptorRegistryWatchEntities, undefined);
    }
    /**
     * WatchEvents returns a channel that produces a stream of Events.
     */ registryWatchEvents() {
        return this.callServerStreaming(methodDescriptorRegistryWatchEvents, undefined);
    }
    /**
     * WatchNodeList returns a channel that produces a stream of NodeList.
     * Upon subscription, the node list for the current epoch will be sent
     * immediately.
     *
     * Each node list will be sorted by node ID in lexicographically ascending
     * order.
     */ registryWatchNodeList() {
        return this.callServerStreaming(methodDescriptorRegistryWatchNodeList, undefined);
    }
    /**
     * WatchNodes returns a channel that produces a stream of
     * NodeEvent on node registration changes.
     */ registryWatchNodes() {
        return this.callServerStreaming(methodDescriptorRegistryWatchNodes, undefined);
    }
    /**
     * WatchRuntimes returns a stream of Runtime.  Upon subscription,
     * all runtimes will be sent immediately.
     */ registryWatchRuntimes() {
        return this.callServerStreaming(methodDescriptorRegistryWatchRuntimes, undefined);
    }
    /**
     * Account returns the account descriptor for the given account.
     */ stakingAccount(query) {
        return this.callUnary(methodDescriptorStakingAccount, query);
    }
    /**
     * Addresses returns the addresses of all accounts with a non-zero general
     * or escrow balance.
     */ stakingAddresses(height) {
        return this.callUnary(methodDescriptorStakingAddresses, height);
    }
    /**
     * Allowance looks up the allowance for the given owner/beneficiary combination.
     */ stakingAllowance(query) {
        return this.callUnary(methodDescriptorStakingAllowance, query);
    }
    /**
     * CommissionScheduleAddresses returns the addresses of all accounts with
     * non-empty commission schedule.
     */ stakingCommissionScheduleAddresses(height) {
        return this.callUnary(methodDescriptorStakingCommissionScheduleAddresses, height);
    }
    /**
     * CommonPool returns the common pool balance.
     */ stakingCommonPool(height) {
        return this.callUnary(methodDescriptorStakingCommonPool, height);
    }
    /**
     * ConsensusParameters returns the staking consensus parameters.
     */ stakingConsensusParameters(height) {
        return this.callUnary(methodDescriptorStakingConsensusParameters, height);
    }
    /**
     * DebondingDelegationsInfosFor returns (outgoing) debonding delegations
     * with additional information for the given owner (delegator).
     */ stakingDebondingDelegationInfosFor(query) {
        return this.callUnary(methodDescriptorStakingDebondingDelegationInfosFor, query);
    }
    /**
     * DebondingDelegationsFor returns the list of (outgoing) debonding
     * delegations for the given owner (delegator).
     */ stakingDebondingDelegationsFor(query) {
        return this.callUnary(methodDescriptorStakingDebondingDelegationsFor, query);
    }
    /**
     * DebondingDelegationsTo returns the list of (incoming) debonding
     * delegations to the given account.
     */ stakingDebondingDelegationsTo(query) {
        return this.callUnary(methodDescriptorStakingDebondingDelegationsTo, query);
    }
    /**
     * DelegationsInfosFor returns (outgoing) delegations with additional
     * information for the given owner (delegator).
     */ stakingDelegationInfosFor(query) {
        return this.callUnary(methodDescriptorStakingDelegationInfosFor, query);
    }
    /**
     * DelegationsFor returns the list of (outgoing) delegations for the given
     * owner (delegator).
     */ stakingDelegationsFor(query) {
        return this.callUnary(methodDescriptorStakingDelegationsFor, query);
    }
    /**
     * DelegationsTo returns the list of (incoming) delegations to the given
     * account.
     */ stakingDelegationsTo(query) {
        return this.callUnary(methodDescriptorStakingDelegationsTo, query);
    }
    /**
     * GetEvents returns the events at specified block height.
     */ stakingGetEvents(height) {
        return this.callUnary(methodDescriptorStakingGetEvents, height);
    }
    /**
     * GovernanceDeposits returns the governance deposits account balance.
     */ stakingGovernanceDeposits(height) {
        return this.callUnary(methodDescriptorStakingGovernanceDeposits, height);
    }
    /**
     * LastBlockFees returns the collected fees for previous block.
     */ stakingLastBlockFees(height) {
        return this.callUnary(methodDescriptorStakingLastBlockFees, height);
    }
    /**
     * StateToGenesis returns the genesis state at specified block height.
     */ stakingStateToGenesis(height) {
        return this.callUnary(methodDescriptorStakingStateToGenesis, height);
    }
    /**
     * Threshold returns the specific staking threshold by kind.
     */ stakingThreshold(query) {
        return this.callUnary(methodDescriptorStakingThreshold, query);
    }
    /**
     * TokenSymbol returns the token's ticker symbol.
     */ stakingTokenSymbol(height) {
        return this.callUnary(methodDescriptorStakingTokenSymbol, height);
    }
    /**
     * TokenValueExponent is the token's value base-10 exponent, i.e.
     * 1 token = 10**TokenValueExponent base units.
     */ stakingTokenValueExponent(height) {
        return this.callUnary(methodDescriptorStakingTokenValueExponent, height);
    }
    /**
     * TotalSupply returns the total number of base units.
     */ stakingTotalSupply(height) {
        return this.callUnary(methodDescriptorStakingTotalSupply, height);
    }
    /**
     * WatchEvents returns a channel that produces a stream of Events.
     */ stakingWatchEvents() {
        return this.callServerStreaming(methodDescriptorStakingWatchEvents, undefined);
    }
    /**
     * StateToGenesis returns the genesis state at specified block height.
     */ keyManagerStateToGenesis(height) {
        return this.callUnary(methodDescriptorKeyManagerStateToGenesis, height);
    }
    /**
     * ConsensusParameters returns the roothash consensus parameters.
     */ rootHashConsensusParameters(height) {
        return this.callUnary(methodDescriptorRootHashConsensusParameters, height);
    }
    /**
     * GetEvents returns the events at specified block height.
     */ rootHashGetEvents(height) {
        return this.callUnary(methodDescriptorRootHashGetEvents, height);
    }
    /**
     * GetGenesisBlock returns the genesis block.
     */ rootHashGetGenesisBlock(request) {
        return this.callUnary(methodDescriptorRootHashGetGenesisBlock, request);
    }
    /**
     * GetIncomingMessageQueue returns the given runtime's queued incoming messages.
     */ rootHashGetIncomingMessageQueue(request) {
        return this.callUnary(methodDescriptorRootHashGetIncomingMessageQueue, request);
    }
    /**
     * GetIncomingMessageQueueMeta returns the given runtime's incoming message queue metadata.
     */ rootHashGetIncomingMessageQueueMeta(request) {
        return this.callUnary(methodDescriptorRootHashGetIncomingMessageQueueMeta, request);
    }
    /**
     * GetLastRoundResults returns the given runtime's last normal round results.
     */ rootHashGetLastRoundResults(request) {
        return this.callUnary(methodDescriptorRootHashGetLastRoundResults, request);
    }
    /**
     * GetLatestBlock returns the latest block.
     *
     * The metadata contained in this block can be further used to get
     * the latest state from the storage backend.
     */ rootHashGetLatestBlock(request) {
        return this.callUnary(methodDescriptorRootHashGetLatestBlock, request);
    }
    /**
     * GetPastRoundRoots returns the stored past state and I/O roots for the given runtime.
     */ rootHashGetPastRoundRoots(request) {
        return this.callUnary(methodDescriptorRootHashGetPastRoundRoots, request);
    }
    /**
     * GetRoundRoots returns the stored state and I/O roots for the given runtime and round.
     */ rootHashGetRoundRoots(request) {
        return this.callUnary(methodDescriptorRootHashGetRoundRoots, request);
    }
    /**
     * GetRuntimeState returns the given runtime's state.
     */ rootHashGetRuntimeState(request) {
        return this.callUnary(methodDescriptorRootHashGetRuntimeState, request);
    }
    /**
     * StateToGenesis returns the genesis state at specified block height.
     */ rootHashStateToGenesis(height) {
        return this.callUnary(methodDescriptorRootHashStateToGenesis, height);
    }
    /**
     * WatchBlocks returns a channel that produces a stream of
     * annotated blocks.
     *
     * The latest block if any will get pushed to the stream immediately.
     * Subsequent blocks will be pushed into the stream as they are
     * confirmed.
     */ rootHashWatchBlocks(runtimeID) {
        return this.callServerStreaming(methodDescriptorRootHashWatchBlocks, runtimeID);
    }
    /**
     * WatchEvents returns a stream of protocol events.
     */ rootHashWatchEvents(runtimeID) {
        return this.callServerStreaming(methodDescriptorRootHashWatchEvents, runtimeID);
    }
    /**
     * WatchExecutorCommitments returns a channel that produces a stream of executor commitments
     * observed in the consensus layer P2P network.
     *
     * Note that these commitments may not have been processed by consensus, commitments may be
     * received in any order and duplicates are possible.
     */ rootHashWatchExecutorCommitments(runtimeID) {
        return this.callServerStreaming(methodDescriptorRootHashWatchExecutorCommitments, runtimeID);
    }
    /**
     * ActiveProposals returns a list of all proposals that have not yet closed.
     */ governanceActiveProposals(height) {
        return this.callUnary(methodDescriptorGovernanceActiveProposals, height);
    }
    /**
     * ConsensusParameters returns the governance consensus parameters.
     */ governanceConsensusParameters(height) {
        return this.callUnary(methodDescriptorGovernanceConsensusParameters, height);
    }
    /**
     * GetEvents returns the events at specified block height.
     */ governanceGetEvents(height) {
        return this.callUnary(methodDescriptorGovernanceGetEvents, height);
    }
    /**
     * PendingUpgrades returns a list of all pending upgrades.
     */ governancePendingUpgrades(height) {
        return this.callUnary(methodDescriptorGovernancePendingUpgrades, height);
    }
    /**
     * Proposal looks up a specific proposal.
     */ governanceProposal(query) {
        return this.callUnary(methodDescriptorGovernanceProposal, query);
    }
    /**
     * Proposals returns a list of all proposals.
     */ governanceProposals(height) {
        return this.callUnary(methodDescriptorGovernanceProposals, height);
    }
    /**
     * StateToGenesis returns the genesis state at specified block height.
     */ governanceStateToGenesis(height) {
        return this.callUnary(methodDescriptorGovernanceStateToGenesis, height);
    }
    /**
     * Votes looks up votes for a specific proposal.
     */ governanceVotes(query) {
        return this.callUnary(methodDescriptorGovernanceVotes, query);
    }
    /**
     * WatchEvents returns a channel that produces a stream of Events.
     */ governanceWatchEvents() {
        return this.callServerStreaming(methodDescriptorGovernanceWatchEvents, undefined);
    }
    /**
     * GetCheckpointChunk fetches a specific chunk from an existing chekpoint.
     */ storageGetCheckpointChunk(chunk) {
        return this.callServerStreaming(methodDescriptorStorageGetCheckpointChunk, chunk);
    }
    /**
     * GetCheckpoints returns a list of checkpoint metadata for all known checkpoints.
     */ storageGetCheckpoints(request) {
        return this.callUnary(methodDescriptorStorageGetCheckpoints, request);
    }
    /**
     * GetDiff returns an iterator of write log entries that must be applied
     * to get from the first given root to the second one.
     */ storageGetDiff(request) {
        return this.callServerStreaming(methodDescriptorStorageGetDiff, request);
    }
    /**
     * SyncGet fetches a single key and returns the corresponding proof.
     */ storageSyncGet(request) {
        return this.callUnary(methodDescriptorStorageSyncGet, request);
    }
    /**
     * SyncGetPrefixes fetches all keys under the given prefixes and returns
     * the corresponding proofs.
     */ storageSyncGetPrefixes(request) {
        return this.callUnary(methodDescriptorStorageSyncGetPrefixes, request);
    }
    /**
     * SyncIterate seeks to a given key and then fetches the specified
     * number of following items based on key iteration order.
     */ storageSyncIterate(request) {
        return this.callUnary(methodDescriptorStorageSyncIterate, request);
    }
    /**
     * GetLastSyncedRound retrieves the last synced round for the storage worker.
     */ storageWorkerGetLastSyncedRound(request) {
        return this.callUnary(methodDescriptorStorageWorkerGetLastSyncedRound, request);
    }
    /**
     * PauseCheckpointer pauses or unpauses the storage worker's checkpointer.
     */ storageWorkerPauseCheckpointer(request) {
        return this.callUnary(methodDescriptorStorageWorkerPauseCheckpointer, request);
    }
    /**
     * CheckTx asks the local runtime to check the specified transaction.
     */ runtimeClientCheckTx(request) {
        return this.callUnary(methodDescriptorRuntimeClientCheckTx, request);
    }
    /**
     * GetBlock fetches the given runtime block.
     */ runtimeClientGetBlock(request) {
        return this.callUnary(methodDescriptorRuntimeClientGetBlock, request);
    }
    /**
     * GetEvents returns all events emitted in a given block.
     */ runtimeClientGetEvents(request) {
        return this.callUnary(methodDescriptorRuntimeClientGetEvents, request);
    }
    /**
     * GetGenesisBlock returns the genesis block.
     */ runtimeClientGetGenesisBlock(runtimeID) {
        return this.callUnary(methodDescriptorRuntimeClientGetGenesisBlock, runtimeID);
    }
    /**
     * GetLastRetainedBlock returns the last retained block.
     */ runtimeClientGetLastRetainedBlock(runtimeID) {
        return this.callUnary(methodDescriptorRuntimeClientGetLastRetainedBlock, runtimeID);
    }
    /**
     * GetTransactions fetches all runtime transactions in a given block.
     */ runtimeClientGetTransactions(request) {
        return this.callUnary(methodDescriptorRuntimeClientGetTransactions, request);
    }
    /**
     * GetTransactionsWithResults fetches all runtime transactions in a given block together with
     * its results (outputs and emitted events).
     */ runtimeClientGetTransactionsWithResults(request) {
        return this.callUnary(methodDescriptorRuntimeClientGetTransactionsWithResults, request);
    }
    /**
     * GetUnconfirmedTransactions fetches all unconfirmed runtime transactions
     * that are currently pending to be included in a block.
     */ runtimeClientGetUnconfirmedTransactions(runtimeID) {
        return this.callUnary(methodDescriptorRuntimeClientGetUnconfirmedTransactions, runtimeID);
    }
    /**
     * Query makes a runtime-specific query.
     */ runtimeClientQuery(request) {
        return this.callUnary(methodDescriptorRuntimeClientQuery, request);
    }
    /**
     * SubmitTx submits a transaction to the runtime transaction scheduler and waits
     * for transaction execution results.
     */ runtimeClientSubmitTx(request) {
        return this.callUnary(methodDescriptorRuntimeClientSubmitTx, request);
    }
    /**
     * SubmitTxMeta submits a transaction to the runtime transaction scheduler and waits for
     * transaction execution results.
     *
     * Response includes transaction metadata - e.g. round at which the transaction was included
     * in a block.
     */ runtimeClientSubmitTxMeta(request) {
        return this.callUnary(methodDescriptorRuntimeClientSubmitTxMeta, request);
    }
    /**
     * SubmitTxNoWait submits a transaction to the runtime transaction scheduler but does
     * not wait for transaction execution.
     */ runtimeClientSubmitTxNoWait(request) {
        return this.callUnary(methodDescriptorRuntimeClientSubmitTxNoWait, request);
    }
    /**
     * WatchBlocks subscribes to blocks for a specific runtimes.
     */ runtimeClientWatchBlocks(runtimeID) {
        return this.callServerStreaming(methodDescriptorRuntimeClientWatchBlocks, runtimeID);
    }
    /**
     * EstimateGas calculates the amount of gas required to execute the given transaction.
     */ consensusEstimateGas(req) {
        return this.callUnary(methodDescriptorConsensusEstimateGas, req);
    }
    /**
     * GetBlock returns a consensus block at a specific height.
     */ consensusGetBlock(height) {
        return this.callUnary(methodDescriptorConsensusGetBlock, height);
    }
    /**
     * GetChainContext returns the chain domain separation context.
     */ consensusGetChainContext() {
        return this.callUnary(methodDescriptorConsensusGetChainContext, undefined);
    }
    /**
     * GetGenesisDocument returns the original genesis document.
     */ consensusGetGenesisDocument() {
        return this.callUnary(methodDescriptorConsensusGetGenesisDocument, undefined);
    }
    /**
     * GetLastRetainedHeight returns the height of the oldest retained consensus block.
     */ consensusGetLastRetainedHeight() {
        return this.callUnary(methodDescriptorConsensusGetLastRetainedHeight, undefined);
    }
    /**
     * GetLatestHeight returns the height of the latest consensus block.
     */ consensusGetLatestHeight() {
        return this.callUnary(methodDescriptorConsensusGetLatestHeight, undefined);
    }
    /**
     * GetLightBlock returns a light version of the consensus layer block that can be used for light
     * client verification.
     */ consensusGetLightBlock(height) {
        return this.callUnary(methodDescriptorConsensusGetLightBlock, height);
    }
    /**
     * GetNextBlockState returns the state of the next block being voted on by validators.
     */ consensusGetNextBlockState() {
        return this.callUnary(methodDescriptorConsensusGetNextBlockState, undefined);
    }
    /**
     * GetParameters returns the consensus parameters for a specific height.
     */ consensusGetParameters(height) {
        return this.callUnary(methodDescriptorConsensusGetParameters, height);
    }
    /**
     * GetSignerNonce returns the nonce that should be used by the given
     * signer for transmitting the next transaction.
     */ consensusGetSignerNonce(req) {
        return this.callUnary(methodDescriptorConsensusGetSignerNonce, req);
    }
    /**
     * GetStatus returns the current status overview.
     */ consensusGetStatus() {
        return this.callUnary(methodDescriptorConsensusGetStatus, undefined);
    }
    /**
     * GetTransactions returns a list of all transactions contained within a
     * consensus block at a specific height.
     *
     * NOTE: Any of these transactions could be invalid.
     */ consensusGetTransactions(height) {
        return this.callUnary(methodDescriptorConsensusGetTransactions, height);
    }
    /**
     * GetTransactionsWithProofs returns a list of all transactions and their proofs of inclusion
     * contained within a consensus block at a specific height.
     */ consensusGetTransactionsWithProofs(height) {
        return this.callUnary(methodDescriptorConsensusGetTransactionsWithProofs, height);
    }
    /**
     * GetTransactionsWithResults returns a list of transactions and their
     * execution results, contained within a consensus block at a specific
     * height.
     */ consensusGetTransactionsWithResults(height) {
        return this.callUnary(methodDescriptorConsensusGetTransactionsWithResults, height);
    }
    /**
     * GetUnconfirmedTransactions returns a list of transactions currently in the local node's
     * mempool. These have not yet been included in a block.
     */ consensusGetUnconfirmedTransactions() {
        return this.callUnary(methodDescriptorConsensusGetUnconfirmedTransactions, undefined);
    }
    /**
     * MinGasPrice returns the minimum gas price.
     */ consensusMinGasPrice() {
        return this.callUnary(methodDescriptorConsensusMinGasPrice, undefined);
    }
    /**
     * StateToGenesis returns the genesis state at the specified block height.
     */ consensusStateToGenesis(height) {
        return this.callUnary(methodDescriptorConsensusStateToGenesis, height);
    }
    /**
     * SubmitEvidence submits evidence of misbehavior.
     */ consensusSubmitEvidence(evidence) {
        return this.callUnary(methodDescriptorConsensusSubmitEvidence, evidence);
    }
    /**
     * SubmitTx submits a signed consensus transaction and waits for the transaction to be included
     * in a block. Use SubmitTxNoWait if you only need to broadcast the transaction.
     */ consensusSubmitTx(tx) {
        return this.callUnary(methodDescriptorConsensusSubmitTx, tx);
    }
    /**
     * SubmitTxNoWait submits a signed consensus transaction, but does not wait for the transaction
     * to be included in a block. Use SubmitTx if you need to wait for execution.
     */ consensusSubmitTxNoWait(tx) {
        return this.callUnary(methodDescriptorConsensusSubmitTxNoWait, tx);
    }
    /**
     * SubmitTxWithProof submits a signed consensus transaction, waits for the transaction to be
     * included in a block and returns a proof of inclusion.
     */ consensusSubmitTxWithProof(tx) {
        return this.callUnary(methodDescriptorConsensusSubmitTxWithProof, tx);
    }
    /**
     * WatchBlocks returns a channel that produces a stream of consensus
     * blocks as they are being finalized.
     */ consensusWatchBlocks() {
        return this.callServerStreaming(methodDescriptorConsensusWatchBlocks, undefined);
    }
    /**
     * SyncGet fetches a single key and returns the corresponding proof.
     */ consensusStateSyncGet(request) {
        return this.callUnary(methodDescriptorConsensusStateSyncGet, request);
    }
    /**
     * SyncGetPrefixes fetches all keys under the given prefixes and returns
     * the corresponding proofs.
     */ consensusStateSyncGetPrefixes(request) {
        return this.callUnary(methodDescriptorConsensusStateSyncGetPrefixes, request);
    }
    /**
     * SyncIterate seeks to a given key and then fetches the specified
     * number of following items based on key iteration order.
     */ consensusStateSyncIterate(request) {
        return this.callUnary(methodDescriptorConsensusStateSyncIterate, request);
    }
    /**
     * AddBundle adds bundle from the given path.
     *
     * If the bundle upgrades an existing ROFL component, the latter will
     * be upgraded to the new version.
     */ nodeControllerAddBundle(path) {
        return this.callUnary(methodDescriptorNodeControllerAddBundle, path);
    }
    /**
     * CancelUpgrade cancels the specific pending upgrade, unless it is already in progress.
     */ nodeControllerCancelUpgrade(descriptor) {
        return this.callUnary(methodDescriptorNodeControllerCancelUpgrade, descriptor);
    }
    /**
     * GetStatus returns the current status overview of the node.
     */ nodeControllerGetStatus() {
        return this.callUnary(methodDescriptorNodeControllerGetStatus, undefined);
    }
    /**
     * IsReady checks whether the node is ready to accept runtime work.
     */ nodeControllerIsReady() {
        return this.callUnary(methodDescriptorNodeControllerIsReady, undefined);
    }
    /**
     * IsSynced checks whether the node has finished syncing.
     */ nodeControllerIsSynced() {
        return this.callUnary(methodDescriptorNodeControllerIsSynced, undefined);
    }
    /**
     * RequestShutdown requests the node to shut down gracefully.
     *
     * If the wait argument is true then the method will also wait for the
     * shutdown to complete.
     */ nodeControllerRequestShutdown(wait) {
        return this.callUnary(methodDescriptorNodeControllerRequestShutdown, wait);
    }
    /**
     * UpgradeBinary submits an upgrade descriptor to a running node.
     * The node will wait for the appropriate epoch, then update its binaries
     * and shut down.
     */ nodeControllerUpgradeBinary(descriptor) {
        return this.callUnary(methodDescriptorNodeControllerUpgradeBinary, descriptor);
    }
    /**
     * WaitReady waits for the node to accept runtime work.
     */ nodeControllerWaitReady() {
        return this.callUnary(methodDescriptorNodeControllerWaitReady, undefined);
    }
    /**
     * WaitSync waits for the node to finish syncing.
     */ nodeControllerWaitSync() {
        return this.callUnary(methodDescriptorNodeControllerWaitSync, undefined);
    }
    /**
     * SetEpoch manually sets the current epoch to the given epoch.
     *
     * NOTE: This only works with a mock beacon backend and will otherwise
     *       return an error.
     */ debugControllerSetEpoch(epoch) {
        return this.callUnary(methodDescriptorDebugControllerSetEpoch, epoch);
    }
    /**
     * WaitNodesRegistered waits for the given number of nodes to register.
     */ debugControllerWaitNodesRegistered(count) {
        return this.callUnary(methodDescriptorDebugControllerWaitNodesRegistered, count);
    }
}
exports.NodeInternal = NodeInternal;

},{"9d1eb17909bce9fe":"5xYwM","6db49ae9491abcda":"8nquP","f5d0aed926730b6":"1Mc9i"}],"5xYwM":[function(require,module,exports,__globalThis) {
/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ var global = arguments[3];
var n;
function aa(a) {
    var b = 0;
    return function() {
        return b < a.length ? {
            done: !1,
            value: a[b++]
        } : {
            done: !0
        };
    };
}
var ba = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
    a != Array.prototype && a != Object.prototype && (a[b] = c.value);
};
function ca(a) {
    a = [
        "object" == typeof window && window,
        "object" == typeof self && self,
        "object" == typeof global && global,
        a
    ];
    for(var b = 0; b < a.length; ++b){
        var c = a[b];
        if (c && c.Math == Math) return c;
    }
    throw Error("Cannot find global object");
}
var r = ca(this);
function t() {
    t = function() {};
    r.Symbol || (r.Symbol = da);
}
function ea(a, b) {
    this.a = a;
    ba(this, "description", {
        configurable: !0,
        writable: !0,
        value: b
    });
}
ea.prototype.toString = function() {
    return this.a;
};
var da = function() {
    function a(c) {
        if (this instanceof a) throw new TypeError("Symbol is not a constructor");
        return new ea("jscomp_symbol_" + (c || "") + "_" + b++, c);
    }
    var b = 0;
    return a;
}();
function u() {
    t();
    var a = r.Symbol.iterator;
    a || (a = r.Symbol.iterator = r.Symbol("Symbol.iterator"));
    "function" != typeof Array.prototype[a] && ba(Array.prototype, a, {
        configurable: !0,
        writable: !0,
        value: function() {
            return fa(aa(this));
        }
    });
    u = function() {};
}
function fa(a) {
    u();
    a = {
        next: a
    };
    a[r.Symbol.iterator] = function() {
        return this;
    };
    return a;
}
function ha(a) {
    var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
    return b ? b.call(a) : {
        next: aa(a)
    };
}
var ia = "function" == typeof Object.create ? Object.create : function(a) {
    function b() {}
    b.prototype = a;
    return new b;
}, ja;
if ("function" == typeof Object.setPrototypeOf) ja = Object.setPrototypeOf;
else {
    var ka;
    a: {
        var la = {
            V: !0
        }, ma = {};
        try {
            ma.__proto__ = la;
            ka = ma.V;
            break a;
        } catch (a) {}
        ka = !1;
    }
    ja = ka ? function(a, b) {
        a.__proto__ = b;
        if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
        return a;
    } : null;
}
var na = ja;
function oa(a, b) {
    a.prototype = ia(b.prototype);
    a.prototype.constructor = a;
    if (na) na(a, b);
    else for(var c in b)if ("prototype" != c) {
        if (Object.defineProperties) {
            var d = Object.getOwnPropertyDescriptor(b, c);
            d && Object.defineProperty(a, c, d);
        } else a[c] = b[c];
    }
    a.O = b.prototype;
}
function pa(a, b) {
    u();
    a instanceof String && (a += "");
    var c = 0, d = {
        next: function() {
            if (c < a.length) {
                var f = c++;
                return {
                    value: b(f, a[f]),
                    done: !1
                };
            }
            d.next = function() {
                return {
                    done: !0,
                    value: void 0
                };
            };
            return d.next();
        }
    };
    d[Symbol.iterator] = function() {
        return d;
    };
    return d;
}
function v(a, b) {
    if (b) {
        var c = r;
        a = a.split(".");
        for(var d = 0; d < a.length - 1; d++){
            var f = a[d];
            f in c || (c[f] = {});
            c = c[f];
        }
        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && null != b && ba(c, a, {
            configurable: !0,
            writable: !0,
            value: b
        });
    }
}
v("Array.prototype.keys", function(a) {
    return a ? a : function() {
        return pa(this, function(b) {
            return b;
        });
    };
});
v("Array.prototype.find", function(a) {
    return a ? a : function(b, c) {
        a: {
            var d = this;
            d instanceof String && (d = String(d));
            for(var f = d.length, g = 0; g < f; g++){
                var e = d[g];
                if (b.call(c, e, g, d)) {
                    b = e;
                    break a;
                }
            }
            b = void 0;
        }
        return b;
    };
});
v("Object.is", function(a) {
    return a ? a : function(b, c) {
        return b === c ? 0 !== b || 1 / b === 1 / c : b !== b && c !== c;
    };
});
v("Array.prototype.includes", function(a) {
    return a ? a : function(b, c) {
        var d = this;
        d instanceof String && (d = String(d));
        var f = d.length;
        c = c || 0;
        for(0 > c && (c = Math.max(c + f, 0)); c < f; c++){
            var g = d[c];
            if (g === b || Object.is(g, b)) return !0;
        }
        return !1;
    };
});
v("Promise", function(a) {
    function b(e) {
        this.b = 0;
        this.c = void 0;
        this.a = [];
        var h = this.f();
        try {
            e(h.resolve, h.reject);
        } catch (k) {
            h.reject(k);
        }
    }
    function c() {
        this.a = null;
    }
    function d(e) {
        return e instanceof b ? e : new b(function(h) {
            h(e);
        });
    }
    if (a) return a;
    c.prototype.b = function(e) {
        if (null == this.a) {
            this.a = [];
            var h = this;
            this.c(function() {
                h.g();
            });
        }
        this.a.push(e);
    };
    var f = r.setTimeout;
    c.prototype.c = function(e) {
        f(e, 0);
    };
    c.prototype.g = function() {
        for(; this.a && this.a.length;){
            var e = this.a;
            this.a = [];
            for(var h = 0; h < e.length; ++h){
                var k = e[h];
                e[h] = null;
                try {
                    k();
                } catch (l) {
                    this.f(l);
                }
            }
        }
        this.a = null;
    };
    c.prototype.f = function(e) {
        this.c(function() {
            throw e;
        });
    };
    b.prototype.f = function() {
        function e(l) {
            return function(m) {
                k || (k = !0, l.call(h, m));
            };
        }
        var h = this, k = !1;
        return {
            resolve: e(this.s),
            reject: e(this.g)
        };
    };
    b.prototype.s = function(e) {
        if (e === this) this.g(new TypeError("A Promise cannot resolve to itself"));
        else if (e instanceof b) this.v(e);
        else {
            a: switch(typeof e){
                case "object":
                    var h = null != e;
                    break a;
                case "function":
                    h = !0;
                    break a;
                default:
                    h = !1;
            }
            h ? this.m(e) : this.h(e);
        }
    };
    b.prototype.m = function(e) {
        var h = void 0;
        try {
            h = e.then;
        } catch (k) {
            this.g(k);
            return;
        }
        "function" == typeof h ? this.w(h, e) : this.h(e);
    };
    b.prototype.g = function(e) {
        this.i(2, e);
    };
    b.prototype.h = function(e) {
        this.i(1, e);
    };
    b.prototype.i = function(e, h) {
        if (0 != this.b) throw Error("Cannot settle(" + e + ", " + h + "): Promise already settled in state" + this.b);
        this.b = e;
        this.c = h;
        this.l();
    };
    b.prototype.l = function() {
        if (null != this.a) {
            for(var e = 0; e < this.a.length; ++e)g.b(this.a[e]);
            this.a = null;
        }
    };
    var g = new c;
    b.prototype.v = function(e) {
        var h = this.f();
        e.F(h.resolve, h.reject);
    };
    b.prototype.w = function(e, h) {
        var k = this.f();
        try {
            e.call(h, k.resolve, k.reject);
        } catch (l) {
            k.reject(l);
        }
    };
    b.prototype.then = function(e, h) {
        function k(q, w) {
            return "function" == typeof q ? function(A) {
                try {
                    l(q(A));
                } catch (L) {
                    m(L);
                }
            } : w;
        }
        var l, m, p = new b(function(q, w) {
            l = q;
            m = w;
        });
        this.F(k(e, l), k(h, m));
        return p;
    };
    b.prototype.catch = function(e) {
        return this.then(void 0, e);
    };
    b.prototype.F = function(e, h) {
        function k() {
            switch(l.b){
                case 1:
                    e(l.c);
                    break;
                case 2:
                    h(l.c);
                    break;
                default:
                    throw Error("Unexpected state: " + l.b);
            }
        }
        var l = this;
        null == this.a ? g.b(k) : this.a.push(k);
    };
    b.resolve = d;
    b.reject = function(e) {
        return new b(function(h, k) {
            k(e);
        });
    };
    b.race = function(e) {
        return new b(function(h, k) {
            for(var l = ha(e), m = l.next(); !m.done; m = l.next())d(m.value).F(h, k);
        });
    };
    b.all = function(e) {
        var h = ha(e), k = h.next();
        return k.done ? d([]) : new b(function(l, m) {
            function p(A) {
                return function(L) {
                    q[A] = L;
                    w--;
                    0 == w && l(q);
                };
            }
            var q = [], w = 0;
            do q.push(void 0), w++, d(k.value).F(p(q.length - 1), m), k = h.next();
            while (!k.done);
        });
    };
    return b;
});
var qa = qa || {}, x = this || self;
function y(a, b) {
    a = a.split(".");
    b = b || x;
    for(var c = 0; c < a.length; c++)if (b = b[a[c]], null == b) return null;
    return b;
}
function ra() {}
function sa(a) {
    var b = typeof a;
    return "object" == b && null != a || "function" == b;
}
var ta = "closure_uid_" + (1E9 * Math.random() >>> 0), ua = 0;
function va(a, b, c) {
    return a.call.apply(a.bind, arguments);
}
function wa(a, b, c) {
    if (!a) throw Error();
    if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function() {
            var f = Array.prototype.slice.call(arguments);
            Array.prototype.unshift.apply(f, d);
            return a.apply(b, f);
        };
    }
    return function() {
        return a.apply(b, arguments);
    };
}
function z(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? z = va : z = wa;
    return z.apply(null, arguments);
}
function B(a, b) {
    function c() {}
    c.prototype = b.prototype;
    a.O = b.prototype;
    a.prototype = new c;
    a.prototype.constructor = a;
}
function xa(a) {
    this.a = a || {};
}
xa.prototype.get = function(a) {
    return this.a[a];
};
xa.prototype.G = function() {
    return Object.keys(this.a);
};
function C(a, b, c, d) {
    this.f = a;
    this.c = b;
    this.b = c;
    this.a = d;
}
C.prototype.getRequestMessage = function() {
    return this.f;
};
C.prototype.getMethodDescriptor = function() {
    return this.c;
};
C.prototype.getMetadata = function() {
    return this.b;
};
C.prototype.getCallOptions = function() {
    return this.a;
};
function D(a, b, c, d) {
    c = void 0 === c ? {} : c;
    this.c = a;
    this.a = c;
    this.b = b;
    this.f = void 0 === d ? null : d;
}
D.prototype.getResponseMessage = function() {
    return this.c;
};
D.prototype.getMetadata = function() {
    return this.a;
};
D.prototype.getMethodDescriptor = function() {
    return this.b;
};
D.prototype.getStatus = function() {
    return this.f;
};
function ya(a, b, c, d, f, g) {
    this.name = a;
    this.a = f;
    this.b = g;
}
function za(a, b, c) {
    c = void 0 === c ? {} : c;
    var d = void 0 === d ? new xa : d;
    return new C(b, a, c, d);
}
ya.prototype.getName = function() {
    return this.name;
};
ya.prototype.getName = ya.prototype.getName;
function Aa(a) {
    switch(a){
        case 200:
            return 0;
        case 400:
            return 3;
        case 401:
            return 16;
        case 403:
            return 7;
        case 404:
            return 5;
        case 409:
            return 10;
        case 412:
            return 9;
        case 429:
            return 8;
        case 499:
            return 1;
        case 500:
            return 2;
        case 501:
            return 12;
        case 503:
            return 14;
        case 504:
            return 4;
        default:
            return 2;
    }
}
function Ba(a) {
    switch(a){
        case 0:
            return "OK";
        case 1:
            return "CANCELLED";
        case 2:
            return "UNKNOWN";
        case 3:
            return "INVALID_ARGUMENT";
        case 4:
            return "DEADLINE_EXCEEDED";
        case 5:
            return "NOT_FOUND";
        case 6:
            return "ALREADY_EXISTS";
        case 7:
            return "PERMISSION_DENIED";
        case 16:
            return "UNAUTHENTICATED";
        case 8:
            return "RESOURCE_EXHAUSTED";
        case 9:
            return "FAILED_PRECONDITION";
        case 10:
            return "ABORTED";
        case 11:
            return "OUT_OF_RANGE";
        case 12:
            return "UNIMPLEMENTED";
        case 13:
            return "INTERNAL";
        case 14:
            return "UNAVAILABLE";
        case 15:
            return "DATA_LOSS";
        default:
            return "";
    }
}
function E(a, b, c) {
    c = void 0 === c ? {} : c;
    b = Error.call(this, b);
    this.message = b.message;
    "stack" in b && (this.stack = b.stack);
    this.code = a;
    this.metadata = c;
}
oa(E, Error);
E.prototype.toString = function() {
    var a = "RpcError(" + (Ba(this.code) || String(this.code)) + ")";
    this.message && (a += ": " + this.message);
    return a;
};
E.prototype.name = "RpcError";
function Ca(a) {
    this.a = a;
}
Ca.prototype.on = function(a, b) {
    return "data" == a || "error" == a ? this : this.a.on(a, b);
};
Ca.prototype.removeListener = function(a, b) {
    return this.a.removeListener(a, b);
};
Ca.prototype.cancel = function() {
    this.a.cancel();
};
function Da(a) {
    switch(a){
        case 0:
            return "No Error";
        case 1:
            return "Access denied to content document";
        case 2:
            return "File not found";
        case 3:
            return "Firefox silently errored";
        case 4:
            return "Application custom error";
        case 5:
            return "An exception occurred";
        case 6:
            return "Http response at 400 or 500 level";
        case 7:
            return "Request was aborted";
        case 8:
            return "Request timed out";
        case 9:
            return "The resource is not available offline";
        default:
            return "Unrecognized error code";
    }
}
function F(a) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, F);
    else {
        var b = Error().stack;
        b && (this.stack = b);
    }
    a && (this.message = String(a));
}
B(F, Error);
F.prototype.name = "CustomError";
function Ea(a, b) {
    a = a.split("%s");
    for(var c = "", d = a.length - 1, f = 0; f < d; f++)c += a[f] + (f < b.length ? b[f] : "%s");
    F.call(this, c + a[d]);
}
B(Ea, F);
Ea.prototype.name = "AssertionError";
function Fa(a, b) {
    throw new Ea("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
}
function Ga() {
    this.l = null;
    this.i = [];
    this.m = 0;
    this.b = Ha;
    this.f = this.a = this.h = 0;
    this.c = null;
    this.g = 0;
}
function Ia(a, b) {
    function c(l) {
        l == Ja ? e.h = l : l == G ? e.h = l : Ka(e, h, k, "invalid frame byte");
        e.b = La;
        e.a = 0;
        e.f = 0;
    }
    function d(l) {
        e.f++;
        e.a = (e.a << 8) + l;
        4 == e.f && (e.b = Ma, e.g = 0, "undefined" !== typeof Uint8Array ? e.c = new Uint8Array(e.a) : e.c = Array(e.a), 0 == e.a && g());
    }
    function f(l) {
        e.c[e.g++] = l;
        e.g == e.a && g();
    }
    function g() {
        var l = {};
        l[e.h] = e.c;
        e.i.push(l);
        e.b = Ha;
    }
    var e = a, h, k = 0;
    for(b instanceof Uint8Array || b instanceof Array ? h = b : h = new Uint8Array(b); k < h.length;){
        switch(e.b){
            case Na:
                Ka(e, h, k, "stream already broken");
                break;
            case Ha:
                c(h[k]);
                break;
            case La:
                d(h[k]);
                break;
            case Ma:
                f(h[k]);
                break;
            default:
                throw Error("unexpected parser state: " + e.b);
        }
        e.m++;
        k++;
    }
    a = e.i;
    e.i = [];
    return 0 < a.length ? a : null;
}
var Ha = 0, La = 1, Ma = 2, Na = 3, Ja = 0, G = 128;
function Ka(a, b, c, d) {
    a.b = Na;
    a.l = "The stream is broken @" + a.m + "/" + c + ". Error: " + d + ". With input:\n" + b;
    throw Error(a.l);
}
var Oa = Array.prototype.indexOf ? function(a, b) {
    return Array.prototype.indexOf.call(a, b, void 0);
} : function(a, b) {
    if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0);
    for(var c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
    return -1;
};
var Pa = String.prototype.trim ? function(a) {
    return a.trim();
} : function(a) {
    return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
};
function H(a, b) {
    return -1 != a.indexOf(b);
}
function Qa(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
var I;
a: {
    var Ra = x.navigator;
    if (Ra) {
        var Sa = Ra.userAgent;
        if (Sa) {
            I = Sa;
            break a;
        }
    }
    I = "";
}
function Ta(a, b) {
    for(var c in a)b.call(void 0, a[c], c, a);
}
function Ua(a, b) {
    var c = {}, d;
    for(d in a)c[d] = b.call(void 0, a[d], d, a);
    return c;
}
var Va = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function Wa(a, b) {
    for(var c, d, f = 1; f < arguments.length; f++){
        d = arguments[f];
        for(c in d)a[c] = d[c];
        for(var g = 0; g < Va.length; g++)c = Va[g], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
}
function Xa(a) {
    var b = 1;
    a = a.split(":");
    for(var c = []; 0 < b && a.length;)c.push(a.shift()), b--;
    a.length && c.push(a.join(":"));
    return c;
}
function Ya(a) {
    Ya[" "](a);
    return a;
}
Ya[" "] = ra;
function Za(a) {
    var b = $a;
    return Object.prototype.hasOwnProperty.call(b, 9) ? b[9] : b[9] = a(9);
}
var ab = H(I, "Opera"), bb = H(I, "Trident") || H(I, "MSIE"), cb = H(I, "Edge"), db = H(I, "Gecko") && !(H(I.toLowerCase(), "webkit") && !H(I, "Edge")) && !(H(I, "Trident") || H(I, "MSIE")) && !H(I, "Edge"), eb = H(I.toLowerCase(), "webkit") && !H(I, "Edge"), fb;
a: {
    var gb = "", hb = function() {
        var a = I;
        if (db) return /rv:([^\);]+)(\)|;)/.exec(a);
        if (cb) return /Edge\/([\d\.]+)/.exec(a);
        if (bb) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
        if (eb) return /WebKit\/(\S+)/.exec(a);
        if (ab) return /(?:Version)[ \/]?(\S+)/.exec(a);
    }();
    hb && (gb = hb ? hb[1] : "");
    if (bb) {
        var ib, jb = x.document;
        ib = jb ? jb.documentMode : void 0;
        if (null != ib && ib > parseFloat(gb)) {
            fb = String(ib);
            break a;
        }
    }
    fb = gb;
}
var $a = {};
function kb() {
    return Za(function() {
        for(var a = 0, b = Pa(String(fb)).split("."), c = Pa("9").split("."), d = Math.max(b.length, c.length), f = 0; 0 == a && f < d; f++){
            var g = b[f] || "", e = c[f] || "";
            do {
                g = /(\d*)(\D*)(.*)/.exec(g) || [
                    "",
                    "",
                    "",
                    ""
                ];
                e = /(\d*)(\D*)(.*)/.exec(e) || [
                    "",
                    "",
                    "",
                    ""
                ];
                if (0 == g[0].length && 0 == e[0].length) break;
                a = Qa(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == e[1].length ? 0 : parseInt(e[1], 10)) || Qa(0 == g[2].length, 0 == e[2].length) || Qa(g[2], e[2]);
                g = g[3];
                e = e[3];
            }while (0 == a);
        }
        return 0 <= a;
    });
}
function lb() {
    0 != mb && (Object.prototype.hasOwnProperty.call(this, ta) && this[ta] || (this[ta] = ++ua));
    this.K = this.K;
}
var mb = 0;
lb.prototype.K = !1;
var nb = Object.freeze || function(a) {
    return a;
};
function J(a, b) {
    this.type = a;
    this.a = this.target = b;
    this.defaultPrevented = !1;
}
J.prototype.b = function() {
    this.defaultPrevented = !0;
};
var ob = function() {
    if (!x.addEventListener || !Object.defineProperty) return !1;
    var a = !1, b = Object.defineProperty({}, "passive", {
        get: function() {
            a = !0;
        }
    });
    try {
        x.addEventListener("test", ra, b), x.removeEventListener("test", ra, b);
    } catch (c) {}
    return a;
}();
function K(a, b) {
    J.call(this, a ? a.type : "");
    this.relatedTarget = this.a = this.target = null;
    this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
    this.key = "";
    this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
    this.pointerId = 0;
    this.pointerType = "";
    this.c = null;
    if (a) {
        var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.a = b;
        if (b = a.relatedTarget) {
            if (db) {
                a: {
                    try {
                        Ya(b.nodeName);
                        var f = !0;
                        break a;
                    } catch (g) {}
                    f = !1;
                }
                f || (b = null);
            }
        } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
        this.relatedTarget = b;
        d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = "string" === typeof a.pointerType ? a.pointerType : pb[a.pointerType] || "";
        this.c = a;
        a.defaultPrevented && K.O.b.call(this);
    }
}
B(K, J);
var pb = nb({
    2: "touch",
    3: "pen",
    4: "mouse"
});
K.prototype.b = function() {
    K.O.b.call(this);
    var a = this.c;
    a.preventDefault ? a.preventDefault() : a.returnValue = !1;
};
var M = "closure_listenable_" + (1E6 * Math.random() | 0);
var qb = 0;
function rb(a, b, c, d, f) {
    this.listener = a;
    this.proxy = null;
    this.src = b;
    this.type = c;
    this.capture = !!d;
    this.H = f;
    this.key = ++qb;
    this.A = this.D = !1;
}
function sb(a) {
    a.A = !0;
    a.listener = null;
    a.proxy = null;
    a.src = null;
    a.H = null;
}
function tb(a) {
    this.src = a;
    this.a = {};
    this.b = 0;
}
tb.prototype.add = function(a, b, c, d, f) {
    var g = a.toString();
    a = this.a[g];
    a || (a = this.a[g] = [], this.b++);
    var e = ub(a, b, d, f);
    -1 < e ? (b = a[e], c || (b.D = !1)) : (b = new rb(b, this.src, g, !!d, f), b.D = c, a.push(b));
    return b;
};
tb.prototype.remove = function(a, b, c, d) {
    a = a.toString();
    if (!(a in this.a)) return !1;
    var f = this.a[a];
    b = ub(f, b, c, d);
    return -1 < b ? (sb(f[b]), Array.prototype.splice.call(f, b, 1), 0 == f.length && (delete this.a[a], this.b--), !0) : !1;
};
function vb(a, b) {
    var c = b.type;
    if (c in a.a) {
        var d = a.a[c], f = Oa(d, b), g;
        (g = 0 <= f) && Array.prototype.splice.call(d, f, 1);
        g && (sb(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
    }
}
function ub(a, b, c, d) {
    for(var f = 0; f < a.length; ++f){
        var g = a[f];
        if (!g.A && g.listener == b && g.capture == !!c && g.H == d) return f;
    }
    return -1;
}
var wb = "closure_lm_" + (1E6 * Math.random() | 0), xb = {}, yb = 0;
function zb(a, b, c, d, f) {
    if (d && d.once) Ab(a, b, c, d, f);
    else if (Array.isArray(b)) for(var g = 0; g < b.length; g++)zb(a, b[g], c, d, f);
    else c = Bb(c), a && a[M] ? a.f.add(String(b), c, !1, sa(d) ? !!d.capture : !!d, f) : Cb(a, b, c, !1, d, f);
}
function Cb(a, b, c, d, f, g) {
    if (!b) throw Error("Invalid event type");
    var e = sa(f) ? !!f.capture : !!f, h = Db(a);
    h || (a[wb] = h = new tb(a));
    c = h.add(b, c, d, e, g);
    if (!c.proxy) {
        d = Eb();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) ob || (f = e), void 0 === f && (f = !1), a.addEventListener(b.toString(), d, f);
        else if (a.attachEvent) a.attachEvent(Fb(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        yb++;
    }
}
function Eb() {
    function a(c) {
        return b.call(a.src, a.listener, c);
    }
    var b = Gb;
    return a;
}
function Ab(a, b, c, d, f) {
    if (Array.isArray(b)) for(var g = 0; g < b.length; g++)Ab(a, b[g], c, d, f);
    else c = Bb(c), a && a[M] ? a.f.add(String(b), c, !0, sa(d) ? !!d.capture : !!d, f) : Cb(a, b, c, !0, d, f);
}
function Hb(a, b, c, d, f) {
    if (Array.isArray(b)) for(var g = 0; g < b.length; g++)Hb(a, b[g], c, d, f);
    else (d = sa(d) ? !!d.capture : !!d, c = Bb(c), a && a[M]) ? a.f.remove(String(b), c, d, f) : a && (a = Db(a)) && (b = a.a[b.toString()], a = -1, b && (a = ub(b, c, d, f)), (c = -1 < a ? b[a] : null) && Ib(c));
}
function Ib(a) {
    if ("number" !== typeof a && a && !a.A) {
        var b = a.src;
        if (b && b[M]) vb(b.f, a);
        else {
            var c = a.type, d = a.proxy;
            b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Fb(c), d) : b.addListener && b.removeListener && b.removeListener(d);
            yb--;
            (c = Db(b)) ? (vb(c, a), 0 == c.b && (c.src = null, b[wb] = null)) : sb(a);
        }
    }
}
function Fb(a) {
    return a in xb ? xb[a] : xb[a] = "on" + a;
}
function Gb(a, b) {
    if (a.A) a = !0;
    else {
        b = new K(b, this);
        var c = a.listener, d = a.H || a.src;
        a.D && Ib(a);
        a = c.call(d, b);
    }
    return a;
}
function Db(a) {
    a = a[wb];
    return a instanceof tb ? a : null;
}
var Jb = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
function Bb(a) {
    if ("function" === typeof a) return a;
    a[Jb] || (a[Jb] = function(b) {
        return a.handleEvent(b);
    });
    return a[Jb];
}
function N() {
    lb.call(this);
    this.f = new tb(this);
    this.U = this;
}
B(N, lb);
N.prototype[M] = !0;
N.prototype.addEventListener = function(a, b, c, d) {
    zb(this, a, b, c, d);
};
N.prototype.removeEventListener = function(a, b, c, d) {
    Hb(this, a, b, c, d);
};
function O(a, b) {
    a = a.U;
    var c = b.type || b;
    if ("string" === typeof b) b = new J(b, a);
    else if (b instanceof J) b.target = b.target || a;
    else {
        var d = b;
        b = new J(c, a);
        Wa(b, d);
    }
    a = b.a = a;
    Kb(a, c, !0, b);
    Kb(a, c, !1, b);
}
function Kb(a, b, c, d) {
    if (b = a.f.a[String(b)]) {
        b = b.concat();
        for(var f = !0, g = 0; g < b.length; ++g){
            var e = b[g];
            if (e && !e.A && e.capture == c) {
                var h = e.listener, k = e.H || e.src;
                e.D && vb(a.f, e);
                f = !1 !== h.call(k, d) && f;
            }
        }
    }
}
var Lb = x;
function Mb(a, b, c) {
    if ("function" === typeof a) c && (a = z(a, c));
    else if (a && "function" == typeof a.handleEvent) a = z(a.handleEvent, a);
    else throw Error("Invalid listener argument");
    return 2147483647 < Number(b) ? -1 : Lb.setTimeout(a, b || 0);
}
function Nb(a, b) {
    this.name = a;
    this.value = b;
}
Nb.prototype.toString = function() {
    return this.name;
};
var Ob = new Nb("OFF", Infinity), Pb = new Nb("SEVERE", 1E3), Qb = new Nb("CONFIG", 700), Rb = new Nb("FINE", 500);
function Tb() {
    this.clear();
}
var Ub;
Tb.prototype.clear = function() {};
function Vb(a, b, c) {
    this.reset(a || Ob, b, c, void 0, void 0);
}
Vb.prototype.reset = function() {};
function Wb(a, b) {
    this.a = null;
    this.f = [];
    this.b = (void 0 === b ? null : b) || null;
    this.c = [];
    this.g = {
        getName: function() {
            return a;
        }
    };
}
function Xb(a) {
    if (a.a) return a.a;
    if (a.b) return Xb(a.b);
    Fa("Root logger has no level set.");
    return Ob;
}
function Yb(a, b) {
    for(; a;)a.f.forEach(function(c) {
        c(b);
    }), a = a.b;
}
function Zb() {
    this.entries = {};
    var a = new Wb("");
    a.a = Qb;
    this.entries[""] = a;
}
var $b;
function ac(a, b, c) {
    var d = a.entries[b];
    if (d) return void 0 !== c && (d.a = c), d;
    d = ac(a, b.substr(0, b.lastIndexOf(".")));
    var f = new Wb(b, d);
    a.entries[b] = f;
    d.c.push(f);
    void 0 !== c && (f.a = c);
    return f;
}
function bc() {
    $b || ($b = new Zb);
    return $b;
}
function cc(a, b, c) {
    var d;
    if (d = a) {
        if (d = a && b) {
            d = b.value;
            var f = a ? Xb(ac(bc(), a.getName())) : Ob;
            d = d >= f.value;
        }
    }
    d && (b = b || Ob, d = ac(bc(), a.getName()), "function" === typeof c && (c = c()), Ub || (Ub = new Tb), a = a.getName(), a = new Vb(b, c, a), Yb(d, a));
}
function P(a, b) {
    a && cc(a, Rb, b);
}
function dc() {}
dc.prototype.a = null;
function ec(a) {
    var b;
    (b = a.a) || (b = {}, fc(a) && (b[0] = !0, b[1] = !0), b = a.a = b);
    return b;
}
var gc;
function hc() {}
B(hc, dc);
function ic(a) {
    return (a = fc(a)) ? new ActiveXObject(a) : new XMLHttpRequest;
}
function fc(a) {
    if (!a.b && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
        for(var b = [
            "MSXML2.XMLHTTP.6.0",
            "MSXML2.XMLHTTP.3.0",
            "MSXML2.XMLHTTP",
            "Microsoft.XMLHTTP"
        ], c = 0; c < b.length; c++){
            var d = b[c];
            try {
                return new ActiveXObject(d), a.b = d;
            } catch (f) {}
        }
        throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
    }
    return a.b;
}
gc = new hc;
t();
u();
function jc(a, b) {
    this.b = a[x.Symbol.iterator]();
    this.c = b;
    this.f = 0;
}
jc.prototype[Symbol.iterator] = function() {
    return this;
};
jc.prototype.next = function() {
    var a = this.b.next();
    return {
        value: a.done ? void 0 : this.c.call(void 0, a.value, this.f++),
        done: a.done
    };
};
function kc(a, b) {
    return new jc(a, b);
}
t();
u();
t();
u();
var lc = "StopIteration" in x ? x.StopIteration : {
    message: "StopIteration",
    stack: ""
};
function Q() {}
Q.prototype.next = function() {
    return Q.prototype.a.call(this);
};
Q.prototype.a = function() {
    throw lc;
};
Q.prototype.u = function() {
    return this;
};
function mc(a) {
    if (a instanceof R || a instanceof S || a instanceof T) return a;
    if ("function" == typeof a.next) return new R(function() {
        return nc(a);
    });
    t();
    u();
    if ("function" == typeof a[Symbol.iterator]) return t(), u(), new R(function() {
        return a[Symbol.iterator]();
    });
    if ("function" == typeof a.u) return new R(function() {
        return nc(a.u());
    });
    throw Error("Not an iterator or iterable.");
}
function nc(a) {
    if (!(a instanceof Q)) return a;
    var b = !1;
    return {
        next: function() {
            for(var c; !b;)try {
                c = a.a();
                break;
            } catch (d) {
                if (d !== lc) throw d;
                b = !0;
            }
            return {
                value: c,
                done: b
            };
        }
    };
}
t();
u();
function R(a) {
    this.b = a;
}
R.prototype.u = function() {
    return new S(this.b());
};
R.prototype[Symbol.iterator] = function() {
    return new T(this.b());
};
R.prototype.c = function() {
    return new T(this.b());
};
t();
u();
function S(a) {
    this.b = a;
}
oa(S, Q);
S.prototype.a = function() {
    var a = this.b.next();
    if (a.done) throw lc;
    return a.value;
};
S.prototype.next = function() {
    return S.prototype.a.call(this);
};
S.prototype[Symbol.iterator] = function() {
    return new T(this.b);
};
S.prototype.c = function() {
    return new T(this.b);
};
function T(a) {
    R.call(this, function() {
        return a;
    });
    this.f = a;
}
oa(T, R);
T.prototype.next = function() {
    return this.f.next();
};
function oc(a, b) {
    this.o = {};
    this.j = [];
    this.B = this.size = 0;
    var c = arguments.length;
    if (1 < c) {
        if (c % 2) throw Error("Uneven number of arguments");
        for(var d = 0; d < c; d += 2)this.set(arguments[d], arguments[d + 1]);
    } else a && this.addAll(a);
}
n = oc.prototype;
n.G = function() {
    pc(this);
    return this.j.concat();
};
n.has = function(a) {
    return U(this.o, a);
};
n.clear = function() {
    this.o = {};
    this.B = this.size = this.j.length = 0;
};
n.remove = function(a) {
    return this.delete(a);
};
n.delete = function(a) {
    return U(this.o, a) ? (delete this.o[a], --this.size, this.B++, this.j.length > 2 * this.size && pc(this), !0) : !1;
};
function pc(a) {
    if (a.size != a.j.length) {
        for(var b = 0, c = 0; b < a.j.length;){
            var d = a.j[b];
            U(a.o, d) && (a.j[c++] = d);
            b++;
        }
        a.j.length = c;
    }
    if (a.size != a.j.length) {
        var f = {};
        for(c = b = 0; b < a.j.length;)d = a.j[b], U(f, d) || (a.j[c++] = d, f[d] = 1), b++;
        a.j.length = c;
    }
}
n.get = function(a, b) {
    return U(this.o, a) ? this.o[a] : b;
};
n.set = function(a, b) {
    U(this.o, a) || (this.size += 1, this.j.push(a), this.B++);
    this.o[a] = b;
};
n.addAll = function(a) {
    if (a instanceof oc) for(var b = a.G(), c = 0; c < b.length; c++)this.set(b[c], a.get(b[c]));
    else for(b in a)this.set(b, a[b]);
};
n.forEach = function(a, b) {
    for(var c = this.G(), d = 0; d < c.length; d++){
        var f = c[d], g = this.get(f);
        a.call(b, g, f, this);
    }
};
n.clone = function() {
    return new oc(this);
};
n.keys = function() {
    return mc(this.u(!0)).c();
};
n.values = function() {
    return mc(this.u(!1)).c();
};
n.entries = function() {
    var a = this;
    return kc(this.keys(), function(b) {
        return [
            b,
            a.get(b)
        ];
    });
};
n.u = function(a) {
    pc(this);
    var b = 0, c = this.B, d = this, f = new Q;
    f.a = function() {
        if (c != d.B) throw Error("The map has changed since the iterator was created");
        if (b >= d.j.length) throw lc;
        var g = d.j[b++];
        return a ? g : d.o[g];
    };
    f.next = f.a.bind(f);
    return f;
};
function U(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}
var qc = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
function rc(a) {
    N.call(this);
    this.headers = new oc;
    this.C = a || null;
    this.c = !1;
    this.J = this.a = null;
    this.P = this.v = "";
    this.g = 0;
    this.l = "";
    this.i = this.N = this.s = this.L = !1;
    this.h = 0;
    this.w = null;
    this.m = sc;
    this.I = this.M = !1;
}
B(rc, N);
var sc = "";
rc.prototype.b = ac(bc(), "goog.net.XhrIo", void 0).g;
var tc = /^https?$/i, uc = [
    "POST",
    "PUT"
];
function vc(a, b, c) {
    if (a.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + a.v + "; newUri=" + b);
    a.v = b;
    a.l = "";
    a.g = 0;
    a.P = "POST";
    a.L = !1;
    a.c = !0;
    a.a = a.C ? ic(a.C) : ic(gc);
    a.J = a.C ? ec(a.C) : ec(gc);
    a.a.onreadystatechange = z(a.R, a);
    try {
        P(a.b, V(a, "Opening Xhr")), a.N = !0, a.a.open("POST", String(b), !0), a.N = !1;
    } catch (g) {
        P(a.b, V(a, "Error opening Xhr: " + g.message));
        wc(a, g);
        return;
    }
    b = c || "";
    c = a.headers.clone();
    var d = c.G().find(function(g) {
        return "content-type" == g.toLowerCase();
    }), f = x.FormData && b instanceof x.FormData;
    !(0 <= Oa(uc, "POST")) || d || f || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
    c.forEach(function(g, e) {
        this.a.setRequestHeader(e, g);
    }, a);
    a.m && (a.a.responseType = a.m);
    "withCredentials" in a.a && a.a.withCredentials !== a.M && (a.a.withCredentials = a.M);
    try {
        xc(a), 0 < a.h && (a.I = yc(a.a), P(a.b, V(a, "Will abort after " + a.h + "ms if incomplete, xhr2 " + a.I)), a.I ? (a.a.timeout = a.h, a.a.ontimeout = z(a.T, a)) : a.w = Mb(a.T, a.h, a)), P(a.b, V(a, "Sending request")), a.s = !0, a.a.send(b), a.s = !1;
    } catch (g) {
        P(a.b, V(a, "Send error: " + g.message)), wc(a, g);
    }
}
function yc(a) {
    return bb && kb() && "number" === typeof a.timeout && void 0 !== a.ontimeout;
}
n = rc.prototype;
n.T = function() {
    "undefined" != typeof qa && this.a && (this.l = "Timed out after " + this.h + "ms, aborting", this.g = 8, P(this.b, V(this, this.l)), O(this, "timeout"), this.abort(8));
};
function wc(a, b) {
    a.c = !1;
    a.a && (a.i = !0, a.a.abort(), a.i = !1);
    a.l = b;
    a.g = 5;
    zc(a);
    Ac(a);
}
function zc(a) {
    a.L || (a.L = !0, O(a, "complete"), O(a, "error"));
}
n.abort = function(a) {
    this.a && this.c && (P(this.b, V(this, "Aborting")), this.c = !1, this.i = !0, this.a.abort(), this.i = !1, this.g = a || 7, O(this, "complete"), O(this, "abort"), Ac(this));
};
n.R = function() {
    this.K || (this.N || this.s || this.i ? Bc(this) : this.W());
};
n.W = function() {
    Bc(this);
};
function Bc(a) {
    if (a.c && "undefined" != typeof qa) {
        if (a.J[1] && 4 == W(a) && 2 == a.getStatus()) P(a.b, V(a, "Local request error detected and ignored"));
        else if (a.s && 4 == W(a)) Mb(a.R, 0, a);
        else if (O(a, "readystatechange"), 4 == W(a)) {
            P(a.b, V(a, "Request complete"));
            a.c = !1;
            try {
                var b = a.getStatus();
                a: switch(b){
                    case 200:
                    case 201:
                    case 202:
                    case 204:
                    case 206:
                    case 304:
                    case 1223:
                        var c = !0;
                        break a;
                    default:
                        c = !1;
                }
                var d;
                if (!(d = c)) {
                    var f;
                    if (f = 0 === b) {
                        var g = String(a.v).match(qc)[1] || null;
                        if (!g && x.self && x.self.location) {
                            var e = x.self.location.protocol;
                            g = e.substr(0, e.length - 1);
                        }
                        f = !tc.test(g ? g.toLowerCase() : "");
                    }
                    d = f;
                }
                if (d) O(a, "complete"), O(a, "success");
                else {
                    a.g = 6;
                    try {
                        var h = 2 < W(a) ? a.a.statusText : "";
                    } catch (k) {
                        P(a.b, "Can not get status: " + k.message), h = "";
                    }
                    a.l = h + " [" + a.getStatus() + "]";
                    zc(a);
                }
            } finally{
                Ac(a);
            }
        }
    }
}
function Ac(a) {
    if (a.a) {
        xc(a);
        var b = a.a, c = a.J[0] ? ra : null;
        a.a = null;
        a.J = null;
        O(a, "ready");
        try {
            b.onreadystatechange = c;
        } catch (d) {
            (a = a.b) && cc(a, Pb, "Problem encountered resetting onreadystatechange: " + d.message);
        }
    }
}
function xc(a) {
    a.a && a.I && (a.a.ontimeout = null);
    a.w && (Lb.clearTimeout(a.w), a.w = null);
}
function W(a) {
    return a.a ? a.a.readyState : 0;
}
n.getStatus = function() {
    try {
        return 2 < W(this) ? this.a.status : -1;
    } catch (a) {
        return -1;
    }
};
function Cc(a) {
    try {
        if (!a.a) return null;
        if ("response" in a.a) return a.a.response;
        switch(a.m){
            case sc:
            case "text":
                return a.a.responseText;
            case "arraybuffer":
                if ("mozResponseArrayBuffer" in a.a) return a.a.mozResponseArrayBuffer;
        }
        var b = a.b;
        b && cc(b, Pb, "Response type " + a.m + " is not supported on this browser");
        return null;
    } catch (c) {
        return P(a.b, "Can not get response: " + c.message), null;
    }
}
function Dc(a) {
    var b = {};
    a = (a.a && 4 == W(a) ? a.a.getAllResponseHeaders() || "" : "").split("\r\n");
    for(var c = 0; c < a.length; c++)if (!/^[\s\xa0]*$/.test(a[c])) {
        var d = Xa(a[c]), f = d[0];
        d = d[1];
        if ("string" === typeof d) {
            d = d.trim();
            var g = b[f] || [];
            b[f] = g;
            g.push(d);
        }
    }
    return Ua(b, function(e) {
        return e.join(", ");
    });
}
function V(a, b) {
    return b + " [" + a.P + " " + a.v + " " + a.getStatus() + "]";
}
var Ec = {}, Fc = null;
function Gc(a) {
    var b = a.length, c = 3 * b / 4;
    c % 3 ? c = Math.floor(c) : H("=.", a[b - 1]) && (c = H("=.", a[b - 2]) ? c - 2 : c - 1);
    var d = new Uint8Array(c), f = 0;
    Hc(a, function(g) {
        d[f++] = g;
    });
    return d.subarray(0, f);
}
function Hc(a, b) {
    function c(k) {
        for(; d < a.length;){
            var l = a.charAt(d++), m = Fc[l];
            if (null != m) return m;
            if (!/^[\s\xa0]*$/.test(l)) throw Error("Unknown base64 encoding at char: " + l);
        }
        return k;
    }
    Ic();
    for(var d = 0;;){
        var f = c(-1), g = c(0), e = c(64), h = c(64);
        if (64 === h && -1 === f) break;
        b(f << 2 | g >> 4);
        64 != e && (b(g << 4 & 240 | e >> 2), 64 != h && b(e << 6 & 192 | h));
    }
}
function Ic() {
    if (!Fc) {
        Fc = {};
        for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
            "+/=",
            "+/",
            "-_=",
            "-_.",
            "-_"
        ], c = 0; 5 > c; c++){
            var d = a.concat(b[c].split(""));
            Ec[c] = d;
            for(var f = 0; f < d.length; f++){
                var g = d[f];
                void 0 === Fc[g] && (Fc[g] = f);
            }
        }
    }
}
var Jc = [
    "content-type",
    "grpc-status",
    "grpc-message"
];
function X(a) {
    this.a = a.Z;
    this.m = null;
    this.b = [];
    this.h = [];
    this.g = [];
    this.f = [];
    this.c = [];
    this.l = !1;
    this.i = 0;
    this.s = new Ga;
    var b = this;
    zb(this.a, "readystatechange", function() {
        var c = b.a;
        if (c = c.a ? c.a.getResponseHeader("Content-Type") : null) {
            c = c.toLowerCase();
            if (0 == c.lastIndexOf("application/grpc-web-text", 0)) {
                c = b.a;
                try {
                    var d = c.a ? c.a.responseText : "";
                } catch (k) {
                    P(c.b, "Can not get responseText: " + k.message), d = "";
                }
                c = d || "";
                d = c.length - c.length % 4;
                c = c.substr(b.i, d - b.i);
                if (0 == c.length) return;
                b.i = d;
                c = Gc(c);
            } else if (0 == c.lastIndexOf("application/grpc", 0)) c = new Uint8Array(Cc(b.a));
            else {
                Y(b, new E(2, "Unknown Content-type received."));
                return;
            }
            d = null;
            try {
                d = Ia(b.s, c);
            } catch (k) {
                Y(b, new E(2, "Error in parsing response body"));
            }
            if (d) for(c = 0; c < d.length; c++){
                if (Ja in d[c]) {
                    var f = d[c][Ja];
                    if (f) {
                        var g = !1, e = void 0;
                        try {
                            e = b.m(f), g = !0;
                        } catch (k) {
                            Y(b, new E(13, "Error when deserializing response data; error: " + k + (", response: " + e)));
                        }
                        if (g) for(f = e, g = 0; g < b.b.length; g++)b.b[g](f);
                    }
                }
                if (G in d[c] && 0 < d[c][G].length) {
                    f = "";
                    for(g = 0; g < d[c][G].length; g++)f += String.fromCharCode(d[c][G][g]);
                    f = f.trim().split("\r\n");
                    g = {};
                    for(e = 0; e < f.length; e++){
                        var h = f[e].indexOf(":");
                        g[f[e].substring(0, h).trim()] = f[e].substring(h + 1).trim();
                    }
                    f = g;
                    g = 0;
                    e = "";
                    "grpc-status" in f && (g = Number(f["grpc-status"]), delete f["grpc-status"]);
                    "grpc-message" in f && (e = f["grpc-message"], delete f["grpc-message"]);
                    Y(b, new E(g, e, f));
                }
            }
        }
    });
    zb(this.a, "complete", function() {
        var c = b.a.g, d = 2, f = "", g = {};
        d = Dc(b.a);
        var e = {};
        for(h in d)d.hasOwnProperty(h) && (e[h.toLowerCase()] = d[h]);
        Object.keys(e).forEach(function(k) {
            Jc.includes(k) || (g[k] = e[k]);
        });
        Kc(b, g);
        var h = -1;
        if (0 != c) {
            switch(c){
                case 7:
                    d = 10;
                    break;
                case 8:
                    d = 4;
                    break;
                case 6:
                    h = b.a.getStatus();
                    d = Aa(h);
                    break;
                default:
                    d = 14;
            }
            10 == d && b.l || (f = Da(c), -1 != h && (f += ", http status code: " + h), Y(b, new E(d, f)));
        } else c = !1, "grpc-status" in e && (d = Number(e["grpc-status"]), "grpc-message" in e && (f = e["grpc-message"]), 0 != d && (Y(b, new E(d, f || "", e)), c = !0)), c || Lc(b);
    });
}
X.prototype.on = function(a, b) {
    "data" == a ? this.b.push(b) : "status" == a ? this.h.push(b) : "metadata" == a ? this.g.push(b) : "end" == a ? this.c.push(b) : "error" == a && this.f.push(b);
    return this;
};
function Mc(a, b) {
    b = a.indexOf(b);
    -1 < b && a.splice(b, 1);
}
X.prototype.removeListener = function(a, b) {
    "data" == a ? Mc(this.b, b) : "status" == a ? Mc(this.h, b) : "metadata" == a ? Mc(this.g, b) : "end" == a ? Mc(this.c, b) : "error" == a && Mc(this.f, b);
    return this;
};
X.prototype.cancel = function() {
    this.l = !0;
    this.a.abort();
};
function Y(a, b) {
    if (0 != b.code) for(var c = new E(b.code, decodeURIComponent(b.message || ""), b.metadata), d = 0; d < a.f.length; d++)a.f[d](c);
    b = {
        code: b.code,
        details: decodeURIComponent(b.message || ""),
        metadata: b.metadata
    };
    for(c = 0; c < a.h.length; c++)a.h[c](b);
}
function Kc(a, b) {
    for(var c = 0; c < a.g.length; c++)a.g[c](b);
}
function Lc(a) {
    for(var b = 0; b < a.c.length; b++)a.c[b]();
}
X.prototype.cancel = X.prototype.cancel;
X.prototype.removeListener = X.prototype.removeListener;
X.prototype.on = X.prototype.on;
function Nc(a) {
    var b = "";
    Ta(a, function(c, d) {
        b += d;
        b += ":";
        b += c;
        b += "\r\n";
    });
    return b;
}
function Z(a, b) {
    a = void 0 === a ? {} : a;
    this.a = a.format || y("format", a) || "text";
    this.g = a.aa || y("suppressCorsPreflight", a) || !1;
    this.f = a.withCredentials || y("withCredentials", a) || !1;
    this.b = a.$ || y("streamInterceptors", a) || [];
    this.h = a.ba || y("unaryInterceptors", a) || [];
    this.c = b || null;
}
Z.prototype.X = function(a, b, c, d, f) {
    var g = this, e = a.substr(0, a.length - d.name.length);
    a = Oc(function(h) {
        return Pc(g, h, e);
    }, this.b).call(this, za(d, b, c));
    Qc(a, f, !1);
    return new Ca(a);
};
Z.prototype.S = function(a, b, c, d) {
    var f = this, g = a.substr(0, a.length - d.name.length);
    return Oc(function(e) {
        return new Promise(function(h, k) {
            var l = Pc(f, e, g), m, p, q;
            Qc(l, function(w, A, L, Sb, Rc) {
                w ? k(w) : Rc ? q = A : L ? p = L : Sb ? m = Sb : (w = e.getMethodDescriptor(), A = m, A = void 0 === A ? {} : A, h(new D(q, w, A, void 0 === p ? null : p)));
            }, !0);
        });
    }, this.h).call(this, za(d, b, c)).then(function(e) {
        return e.getResponseMessage();
    });
};
Z.prototype.unaryCall = function(a, b, c, d) {
    return this.S(a, b, c, d);
};
Z.prototype.Y = function(a, b, c, d) {
    var f = this, g = a.substr(0, a.length - d.name.length);
    return Oc(function(e) {
        return Pc(f, e, g);
    }, this.b).call(this, za(d, b, c));
};
function Pc(a, b, c) {
    var d = b.getMethodDescriptor(), f = c + d.getName();
    c = a.c ? a.c : new rc;
    c.M = a.f;
    var g = new X({
        Z: c
    });
    g.m = d.b;
    var e = b.getMetadata();
    for(h in e)c.headers.set(h, e[h]);
    "text" == a.a ? (c.headers.set("Content-Type", "application/grpc-web-text"), c.headers.set("Accept", "application/grpc-web-text")) : c.headers.set("Content-Type", "application/grpc-web+proto");
    c.headers.set("X-User-Agent", "grpc-web-javascript/0.1");
    c.headers.set("X-Grpc-Web", "1");
    if (c.headers.has("deadline")) {
        var h = Number(c.headers.get("deadline"));
        h = Math.ceil(h - (new Date).getTime());
        c.headers.delete("deadline");
        Infinity === h && (h = 0);
        0 < h && (c.headers.set("grpc-timeout", h + "m"), c.h = Math.max(0, Math.max(1E3, Math.ceil(1.1 * h))));
    }
    if (a.g) {
        e = c.headers;
        h = {};
        for(var k = ha(e.keys()), l = k.next(); !l.done; l = k.next())l = l.value, h[l] = e.get(l);
        c.headers.clear();
        b: {
            for(m in h){
                var m = !1;
                break b;
            }
            m = !0;
        }
        if (!m) {
            if (h = Nc(h), "string" === typeof f) {
                if (m = encodeURIComponent("$httpHeaders"), h = null != h ? "=" + encodeURIComponent(String(h)) : "", m += h) h = f.indexOf("#"), 0 > h && (h = f.length), e = f.indexOf("?"), 0 > e || e > h ? (e = h, k = "") : k = f.substring(e + 1, h), f = [
                    f.substr(0, e),
                    k,
                    f.substr(h)
                ], h = f[1], f[1] = m ? h ? h + "&" + m : m : h, f = f[0] + (f[1] ? "?" + f[1] : "") + f[2];
            } else f.a("$httpHeaders", h);
        }
    }
    b = (0, d.a)(b.getRequestMessage());
    d = b.length;
    m = [
        0,
        0,
        0,
        0
    ];
    h = new Uint8Array(5 + d);
    for(e = 3; 0 <= e; e--)m[e] = d % 256, d >>>= 8;
    h.set(new Uint8Array(m), 1);
    h.set(b, 5);
    b = h;
    if ("text" == a.a) {
        a = b;
        var p;
        void 0 === p && (p = 0);
        Ic();
        p = Ec[p];
        b = Array(Math.floor(a.length / 3));
        d = p[64] || "";
        for(m = h = 0; h < a.length - 2; h += 3){
            l = a[h];
            var q = a[h + 1];
            k = a[h + 2];
            e = p[l >> 2];
            l = p[(l & 3) << 4 | q >> 4];
            q = p[(q & 15) << 2 | k >> 6];
            k = p[k & 63];
            b[m++] = e + l + q + k;
        }
        e = 0;
        k = d;
        switch(a.length - h){
            case 2:
                e = a[h + 1], k = p[(e & 15) << 2] || d;
            case 1:
                a = a[h], b[m] = p[a >> 2] + p[(a & 3) << 4 | e >> 4] + k + d;
        }
        b = b.join("");
    } else "binary" == a.a && (c.m = "arraybuffer");
    vc(c, f, b);
    return g;
}
function Qc(a, b, c) {
    var d = !1, f = null, g = !1;
    a.on("data", function(e) {
        d = !0;
        f = e;
    });
    a.on("error", function(e) {
        0 == e.code || g || (g = !0, b(e, null));
    });
    a.on("status", function(e) {
        0 == e.code || g ? c && b(null, null, e) : (g = !0, b({
            code: e.code,
            message: e.details,
            metadata: e.metadata
        }, null));
    });
    if (c) a.on("metadata", function(e) {
        b(null, null, null, e);
    });
    a.on("end", function() {
        g || (d ? c ? b(null, f, null, null, !0) : b(null, f) : b({
            code: 2,
            message: "Incomplete response"
        }));
        c && b(null, null);
    });
}
function Oc(a, b) {
    var c = a;
    b.forEach(function(d) {
        var f = c;
        c = function(g) {
            return d.intercept(g, f);
        };
    });
    return c;
}
Z.prototype.serverStreaming = Z.prototype.Y;
Z.prototype.unaryCall = Z.prototype.unaryCall;
Z.prototype.thenableCall = Z.prototype.S;
Z.prototype.rpcCall = Z.prototype.X;
module.exports.CallOptions = xa;
module.exports.MethodDescriptor = ya;
module.exports.GrpcWebClientBase = Z;
module.exports.RpcError = E;
module.exports.StatusCode = {
    OK: 0,
    CANCELLED: 1,
    UNKNOWN: 2,
    INVALID_ARGUMENT: 3,
    DEADLINE_EXCEEDED: 4,
    NOT_FOUND: 5,
    ALREADY_EXISTS: 6,
    PERMISSION_DENIED: 7,
    UNAUTHENTICATED: 16,
    RESOURCE_EXHAUSTED: 8,
    FAILED_PRECONDITION: 9,
    ABORTED: 10,
    OUT_OF_RANGE: 11,
    UNIMPLEMENTED: 12,
    INTERNAL: 13,
    UNAVAILABLE: 14,
    DATA_LOSS: 15
};
module.exports.MethodType = {
    UNARY: "unary",
    SERVER_STREAMING: "server_streaming",
    BIDI_STREAMING: "bidi_streaming"
};
Lb = "undefined" !== typeof globalThis && globalThis || self;

},{}],"8nquP":[function(require,module,exports,__globalThis) {
/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/ "use strict";
var $protobuf = require("7419f378f226128c");
// Common aliases
var $Reader = $protobuf.Reader, $util = $protobuf.util;
// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});
$root.google = function() {
    /**
     * Namespace google.
     * @exports google
     * @namespace
     */ var google = {};
    google.protobuf = function() {
        /**
         * Namespace protobuf.
         * @memberof google
         * @namespace
         */ var protobuf = {};
        protobuf.Any = function() {
            /**
             * Properties of an Any.
             * @memberof google.protobuf
             * @interface IAny
             * @property {string|null} [type_url] Any type_url
             * @property {Uint8Array|null} [value] Any value
             */ /**
             * Constructs a new Any.
             * @memberof google.protobuf
             * @classdesc Represents an Any.
             * @implements IAny
             * @constructor
             * @param {google.protobuf.IAny=} [properties] Properties to set
             */ function Any(properties) {
                if (properties) {
                    for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
                }
            }
            /**
             * Any type_url.
             * @member {string} type_url
             * @memberof google.protobuf.Any
             * @instance
             */ Any.prototype.type_url = "";
            /**
             * Any value.
             * @member {Uint8Array} value
             * @memberof google.protobuf.Any
             * @instance
             */ Any.prototype.value = $util.newBuffer([]);
            /**
             * Decodes an Any message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.Any
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.Any} Any
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */ Any.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Any();
                while(reader.pos < end){
                    var tag = reader.uint32();
                    switch(tag >>> 3){
                        case 1:
                            message.type_url = reader.string();
                            break;
                        case 2:
                            message.value = reader.bytes();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                    }
                }
                return message;
            };
            /**
             * Gets the default type url for Any
             * @function getTypeUrl
             * @memberof google.protobuf.Any
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */ Any.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
                return typeUrlPrefix + "/google.protobuf.Any";
            };
            return Any;
        }();
        return protobuf;
    }();
    google.rpc = function() {
        /**
         * Namespace rpc.
         * @memberof google
         * @namespace
         */ var rpc = {};
        rpc.Status = function() {
            /**
             * Properties of a Status.
             * @memberof google.rpc
             * @interface IStatus
             * @property {number|null} [code] Status code
             * @property {string|null} [message] Status message
             * @property {Array.<google.protobuf.IAny>|null} [details] Status details
             */ /**
             * Constructs a new Status.
             * @memberof google.rpc
             * @classdesc Represents a Status.
             * @implements IStatus
             * @constructor
             * @param {google.rpc.IStatus=} [properties] Properties to set
             */ function Status(properties) {
                this.details = [];
                if (properties) {
                    for(var keys = Object.keys(properties), i = 0; i < keys.length; ++i)if (properties[keys[i]] != null) this[keys[i]] = properties[keys[i]];
                }
            }
            /**
             * Status code.
             * @member {number} code
             * @memberof google.rpc.Status
             * @instance
             */ Status.prototype.code = 0;
            /**
             * Status message.
             * @member {string} message
             * @memberof google.rpc.Status
             * @instance
             */ Status.prototype.message = "";
            /**
             * Status details.
             * @member {Array.<google.protobuf.IAny>} details
             * @memberof google.rpc.Status
             * @instance
             */ Status.prototype.details = $util.emptyArray;
            /**
             * Decodes a Status message from the specified reader or buffer.
             * @function decode
             * @memberof google.rpc.Status
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.rpc.Status} Status
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */ Status.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader)) reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.rpc.Status();
                while(reader.pos < end){
                    var tag = reader.uint32();
                    switch(tag >>> 3){
                        case 1:
                            message.code = reader.int32();
                            break;
                        case 2:
                            message.message = reader.string();
                            break;
                        case 3:
                            if (!(message.details && message.details.length)) message.details = [];
                            message.details.push($root.google.protobuf.Any.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                    }
                }
                return message;
            };
            /**
             * Gets the default type url for Status
             * @function getTypeUrl
             * @memberof google.rpc.Status
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */ Status.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) typeUrlPrefix = "type.googleapis.com";
                return typeUrlPrefix + "/google.rpc.Status";
            };
            return Status;
        }();
        return rpc;
    }();
    return google;
}();
module.exports = $root;

},{"7419f378f226128c":"1e1ve"}],"1e1ve":[function(require,module,exports,__globalThis) {
// minimal library entry point.
"use strict";
module.exports = require("53502ce49364a9a0");

},{"53502ce49364a9a0":"fjhm6"}],"fjhm6":[function(require,module,exports,__globalThis) {
"use strict";
var protobuf = exports;
/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */ protobuf.build = "minimal";
// Serialization
protobuf.Writer = require("123b8c1671ce76b7");
protobuf.BufferWriter = require("5e89240d6b4d6c84");
protobuf.Reader = require("7e7524d57b18d0d0");
protobuf.BufferReader = require("443298fa9a162adc");
// Utility
protobuf.util = require("682ea4beebbab45d");
protobuf.rpc = require("862afecd43193828");
protobuf.roots = require("14faeab02aebb66b");
protobuf.configure = configure;
/* istanbul ignore next */ /**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */ function configure() {
    protobuf.util._configure();
    protobuf.Writer._configure(protobuf.BufferWriter);
    protobuf.Reader._configure(protobuf.BufferReader);
}
// Set up buffer utility according to the environment
configure();

},{"123b8c1671ce76b7":"2ISmH","5e89240d6b4d6c84":"7sNic","7e7524d57b18d0d0":"gh3Dh","443298fa9a162adc":"4eoJd","682ea4beebbab45d":"5E9P4","862afecd43193828":"9HXBs","14faeab02aebb66b":"eTLy4"}],"2ISmH":[function(require,module,exports,__globalThis) {
"use strict";
module.exports = Writer;
var util = require("5c785c60b384e6c3");
var BufferWriter; // cyclic
var LongBits = util.LongBits, base64 = util.base64, utf8 = util.utf8;
/**
 * Constructs a new writer operation instance.
 * @classdesc Scheduled writer operation.
 * @constructor
 * @param {function(*, Uint8Array, number)} fn Function to call
 * @param {number} len Value byte length
 * @param {*} val Value to write
 * @ignore
 */ function Op(fn, len, val) {
    /**
     * Function to call.
     * @type {function(Uint8Array, number, *)}
     */ this.fn = fn;
    /**
     * Value byte length.
     * @type {number}
     */ this.len = len;
    /**
     * Next operation.
     * @type {Writer.Op|undefined}
     */ this.next = undefined;
    /**
     * Value to write.
     * @type {*}
     */ this.val = val; // type varies
}
/* istanbul ignore next */ function noop() {} // eslint-disable-line no-empty-function
/**
 * Constructs a new writer state instance.
 * @classdesc Copied writer state.
 * @memberof Writer
 * @constructor
 * @param {Writer} writer Writer to copy state from
 * @ignore
 */ function State(writer) {
    /**
     * Current head.
     * @type {Writer.Op}
     */ this.head = writer.head;
    /**
     * Current tail.
     * @type {Writer.Op}
     */ this.tail = writer.tail;
    /**
     * Current buffer length.
     * @type {number}
     */ this.len = writer.len;
    /**
     * Next state.
     * @type {State|null}
     */ this.next = writer.states;
}
/**
 * Constructs a new writer instance.
 * @classdesc Wire format writer using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 */ function Writer() {
    /**
     * Current length.
     * @type {number}
     */ this.len = 0;
    /**
     * Operations head.
     * @type {Object}
     */ this.head = new Op(noop, 0, 0);
    /**
     * Operations tail
     * @type {Object}
     */ this.tail = this.head;
    /**
     * Linked forked states.
     * @type {Object|null}
     */ this.states = null;
// When a value is written, the writer calculates its byte length and puts it into a linked
// list of operations to perform when finish() is called. This both allows us to allocate
// buffers of the exact required size and reduces the amount of work we have to do compared
// to first calculating over objects and then encoding over objects. In our case, the encoding
// part is just a linked list walk calling operations with already prepared values.
}
var create = function create() {
    return util.Buffer ? function create_buffer_setup() {
        return (Writer.create = function create_buffer() {
            return new BufferWriter();
        })();
    } : function create_array() {
        return new Writer();
    };
};
/**
 * Creates a new writer.
 * @function
 * @returns {BufferWriter|Writer} A {@link BufferWriter} when Buffers are supported, otherwise a {@link Writer}
 */ Writer.create = create();
/**
 * Allocates a buffer of the specified size.
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ Writer.alloc = function alloc(size) {
    return new util.Array(size);
};
// Use Uint8Array buffer pool in the browser, just like node does with buffers
/* istanbul ignore else */ if (util.Array !== Array) Writer.alloc = util.pool(Writer.alloc, util.Array.prototype.subarray);
/**
 * Pushes a new operation to the queue.
 * @param {function(Uint8Array, number, *)} fn Function to call
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @returns {Writer} `this`
 * @private
 */ Writer.prototype._push = function push(fn, len, val) {
    this.tail = this.tail.next = new Op(fn, len, val);
    this.len += len;
    return this;
};
function writeByte(val, buf, pos) {
    buf[pos] = val & 255;
}
function writeVarint32(val, buf, pos) {
    while(val > 127){
        buf[pos++] = val & 127 | 128;
        val >>>= 7;
    }
    buf[pos] = val;
}
/**
 * Constructs a new varint writer operation instance.
 * @classdesc Scheduled varint writer operation.
 * @extends Op
 * @constructor
 * @param {number} len Value byte length
 * @param {number} val Value to write
 * @ignore
 */ function VarintOp(len, val) {
    this.len = len;
    this.next = undefined;
    this.val = val;
}
VarintOp.prototype = Object.create(Op.prototype);
VarintOp.prototype.fn = writeVarint32;
/**
 * Writes an unsigned 32 bit value as a varint.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.uint32 = function write_uint32(value) {
    // here, the call to this.push has been inlined and a varint specific Op subclass is used.
    // uint32 is by far the most frequently used operation and benefits significantly from this.
    this.len += (this.tail = this.tail.next = new VarintOp((value = value >>> 0) < 128 ? 1 : value < 16384 ? 2 : value < 2097152 ? 3 : value < 268435456 ? 4 : 5, value)).len;
    return this;
};
/**
 * Writes a signed 32 bit value as a varint.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.int32 = function write_int32(value) {
    return value < 0 ? this._push(writeVarint64, 10, LongBits.fromNumber(value)) // 10 bytes per spec
     : this.uint32(value);
};
/**
 * Writes a 32 bit value as a varint, zig-zag encoded.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.sint32 = function write_sint32(value) {
    return this.uint32((value << 1 ^ value >> 31) >>> 0);
};
function writeVarint64(val, buf, pos) {
    while(val.hi){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = (val.lo >>> 7 | val.hi << 25) >>> 0;
        val.hi >>>= 7;
    }
    while(val.lo > 127){
        buf[pos++] = val.lo & 127 | 128;
        val.lo = val.lo >>> 7;
    }
    buf[pos++] = val.lo;
}
/**
 * Writes an unsigned 64 bit value as a varint.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ Writer.prototype.uint64 = function write_uint64(value) {
    var bits = LongBits.from(value);
    return this._push(writeVarint64, bits.length(), bits);
};
/**
 * Writes a signed 64 bit value as a varint.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ Writer.prototype.int64 = Writer.prototype.uint64;
/**
 * Writes a signed 64 bit value as a varint, zig-zag encoded.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ Writer.prototype.sint64 = function write_sint64(value) {
    var bits = LongBits.from(value).zzEncode();
    return this._push(writeVarint64, bits.length(), bits);
};
/**
 * Writes a boolish value as a varint.
 * @param {boolean} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.bool = function write_bool(value) {
    return this._push(writeByte, 1, value ? 1 : 0);
};
function writeFixed32(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
/**
 * Writes an unsigned 32 bit value as fixed 32 bits.
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.fixed32 = function write_fixed32(value) {
    return this._push(writeFixed32, 4, value >>> 0);
};
/**
 * Writes a signed 32 bit value as fixed 32 bits.
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.sfixed32 = Writer.prototype.fixed32;
/**
 * Writes an unsigned 64 bit value as fixed 64 bits.
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ Writer.prototype.fixed64 = function write_fixed64(value) {
    var bits = LongBits.from(value);
    return this._push(writeFixed32, 4, bits.lo)._push(writeFixed32, 4, bits.hi);
};
/**
 * Writes a signed 64 bit value as fixed 64 bits.
 * @function
 * @param {Long|number|string} value Value to write
 * @returns {Writer} `this`
 * @throws {TypeError} If `value` is a string and no long library is present.
 */ Writer.prototype.sfixed64 = Writer.prototype.fixed64;
/**
 * Writes a float (32 bit).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.float = function write_float(value) {
    return this._push(util.float.writeFloatLE, 4, value);
};
/**
 * Writes a double (64 bit float).
 * @function
 * @param {number} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.double = function write_double(value) {
    return this._push(util.float.writeDoubleLE, 8, value);
};
var writeBytes = util.Array.prototype.set ? function writeBytes_set(val, buf, pos) {
    buf.set(val, pos); // also works for plain array values
} : function writeBytes_for(val, buf, pos) {
    for(var i = 0; i < val.length; ++i)buf[pos + i] = val[i];
};
/**
 * Writes a sequence of bytes.
 * @param {Uint8Array|string} value Buffer or base64 encoded string to write
 * @returns {Writer} `this`
 */ Writer.prototype.bytes = function write_bytes(value) {
    var len = value.length >>> 0;
    if (!len) return this._push(writeByte, 1, 0);
    if (util.isString(value)) {
        var buf = Writer.alloc(len = base64.length(value));
        base64.decode(value, buf, 0);
        value = buf;
    }
    return this.uint32(len)._push(writeBytes, len, value);
};
/**
 * Writes a string.
 * @param {string} value Value to write
 * @returns {Writer} `this`
 */ Writer.prototype.string = function write_string(value) {
    var len = utf8.length(value);
    return len ? this.uint32(len)._push(utf8.write, len, value) : this._push(writeByte, 1, 0);
};
/**
 * Forks this writer's state by pushing it to a stack.
 * Calling {@link Writer#reset|reset} or {@link Writer#ldelim|ldelim} resets the writer to the previous state.
 * @returns {Writer} `this`
 */ Writer.prototype.fork = function fork() {
    this.states = new State(this);
    this.head = this.tail = new Op(noop, 0, 0);
    this.len = 0;
    return this;
};
/**
 * Resets this instance to the last state.
 * @returns {Writer} `this`
 */ Writer.prototype.reset = function reset() {
    if (this.states) {
        this.head = this.states.head;
        this.tail = this.states.tail;
        this.len = this.states.len;
        this.states = this.states.next;
    } else {
        this.head = this.tail = new Op(noop, 0, 0);
        this.len = 0;
    }
    return this;
};
/**
 * Resets to the last state and appends the fork state's current write length as a varint followed by its operations.
 * @returns {Writer} `this`
 */ Writer.prototype.ldelim = function ldelim() {
    var head = this.head, tail = this.tail, len = this.len;
    this.reset().uint32(len);
    if (len) {
        this.tail.next = head.next; // skip noop
        this.tail = tail;
        this.len += len;
    }
    return this;
};
/**
 * Finishes the write operation.
 * @returns {Uint8Array} Finished buffer
 */ Writer.prototype.finish = function finish() {
    var head = this.head.next, buf = this.constructor.alloc(this.len), pos = 0;
    while(head){
        head.fn(head.val, buf, pos);
        pos += head.len;
        head = head.next;
    }
    // this.head = this.tail = null;
    return buf;
};
Writer._configure = function(BufferWriter_) {
    BufferWriter = BufferWriter_;
    Writer.create = create();
    BufferWriter._configure();
};

},{"5c785c60b384e6c3":"5E9P4"}],"5E9P4":[function(require,module,exports,__globalThis) {
var global = arguments[3];
"use strict";
var util = exports;
// used to return a Promise where callback is omitted
util.asPromise = require("217e30ba36d0c075");
// converts to / from base64 encoded strings
util.base64 = require("140216d783bbc015");
// base class of rpc.Service
util.EventEmitter = require("78776c045df9e77b");
// float handling accross browsers
util.float = require("392006759dba32fb");
// requires modules optionally and hides the call from bundlers
util.inquire = require("ac14d008f0aa6436");
// converts to / from utf8 encoded strings
util.utf8 = require("298ebb5f36c5d25a");
// provides a node-like buffer pool in the browser
util.pool = require("dc7a35661f9f9275");
// utility to work with the low and high bits of a 64 bit value
util.LongBits = require("94b513d9f4cac968");
/**
 * Whether running within node or not.
 * @memberof util
 * @type {boolean}
 */ util.isNode = Boolean(typeof global !== "undefined" && global && global.process && global.process.versions && global.process.versions.node);
/**
 * Global object reference.
 * @memberof util
 * @type {Object}
 */ util.global = util.isNode && global || typeof window !== "undefined" && window || typeof self !== "undefined" && self || this; // eslint-disable-line no-invalid-this
/**
 * An immuable empty array.
 * @memberof util
 * @type {Array.<*>}
 * @const
 */ util.emptyArray = Object.freeze ? Object.freeze([]) : /* istanbul ignore next */ []; // used on prototypes
/**
 * An immutable empty object.
 * @type {Object}
 * @const
 */ util.emptyObject = Object.freeze ? Object.freeze({}) : /* istanbul ignore next */ {}; // used on prototypes
/**
 * Tests if the specified value is an integer.
 * @function
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is an integer
 */ util.isInteger = Number.isInteger || /* istanbul ignore next */ function isInteger(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
/**
 * Tests if the specified value is a string.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a string
 */ util.isString = function isString(value) {
    return typeof value === "string" || value instanceof String;
};
/**
 * Tests if the specified value is a non-null object.
 * @param {*} value Value to test
 * @returns {boolean} `true` if the value is a non-null object
 */ util.isObject = function isObject(value) {
    return value && typeof value === "object";
};
/**
 * Checks if a property on a message is considered to be present.
 * This is an alias of {@link util.isSet}.
 * @function
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ util.isset = /**
 * Checks if a property on a message is considered to be present.
 * @param {Object} obj Plain object or message instance
 * @param {string} prop Property name
 * @returns {boolean} `true` if considered to be present, otherwise `false`
 */ util.isSet = function isSet(obj, prop) {
    var value = obj[prop];
    if (value != null && obj.hasOwnProperty(prop)) return typeof value !== "object" || (Array.isArray(value) ? value.length : Object.keys(value).length) > 0;
    return false;
};
/**
 * Any compatible Buffer instance.
 * This is a minimal stand-alone definition of a Buffer instance. The actual type is that exported by node's typings.
 * @interface Buffer
 * @extends Uint8Array
 */ /**
 * Node's Buffer class if available.
 * @type {Constructor<Buffer>}
 */ util.Buffer = function() {
    try {
        var Buffer = util.inquire("buffer").Buffer;
        // refuse to use non-node buffers if not explicitly assigned (perf reasons):
        return Buffer.prototype.utf8Write ? Buffer : /* istanbul ignore next */ null;
    } catch (e) {
        /* istanbul ignore next */ return null;
    }
}();
// Internal alias of or polyfull for Buffer.from.
util._Buffer_from = null;
// Internal alias of or polyfill for Buffer.allocUnsafe.
util._Buffer_allocUnsafe = null;
/**
 * Creates a new buffer of whatever type supported by the environment.
 * @param {number|number[]} [sizeOrArray=0] Buffer size or number array
 * @returns {Uint8Array|Buffer} Buffer
 */ util.newBuffer = function newBuffer(sizeOrArray) {
    /* istanbul ignore next */ return typeof sizeOrArray === "number" ? util.Buffer ? util._Buffer_allocUnsafe(sizeOrArray) : new util.Array(sizeOrArray) : util.Buffer ? util._Buffer_from(sizeOrArray) : typeof Uint8Array === "undefined" ? sizeOrArray : new Uint8Array(sizeOrArray);
};
/**
 * Array implementation used in the browser. `Uint8Array` if supported, otherwise `Array`.
 * @type {Constructor<Uint8Array>}
 */ util.Array = typeof Uint8Array !== "undefined" ? Uint8Array /* istanbul ignore next */  : Array;
/**
 * Any compatible Long instance.
 * This is a minimal stand-alone definition of a Long instance. The actual type is that exported by long.js.
 * @interface Long
 * @property {number} low Low bits
 * @property {number} high High bits
 * @property {boolean} unsigned Whether unsigned or not
 */ /**
 * Long.js's Long class if available.
 * @type {Constructor<Long>}
 */ util.Long = /* istanbul ignore next */ util.global.dcodeIO && /* istanbul ignore next */ util.global.dcodeIO.Long || /* istanbul ignore next */ util.global.Long || util.inquire("long");
/**
 * Regular expression used to verify 2 bit (`bool`) map keys.
 * @type {RegExp}
 * @const
 */ util.key2Re = /^true|false|0|1$/;
/**
 * Regular expression used to verify 32 bit (`int32` etc.) map keys.
 * @type {RegExp}
 * @const
 */ util.key32Re = /^-?(?:0|[1-9][0-9]*)$/;
/**
 * Regular expression used to verify 64 bit (`int64` etc.) map keys.
 * @type {RegExp}
 * @const
 */ util.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/;
/**
 * Converts a number or long to an 8 characters long hash string.
 * @param {Long|number} value Value to convert
 * @returns {string} Hash
 */ util.longToHash = function longToHash(value) {
    return value ? util.LongBits.from(value).toHash() : util.LongBits.zeroHash;
};
/**
 * Converts an 8 characters long hash string to a long or number.
 * @param {string} hash Hash
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long|number} Original value
 */ util.longFromHash = function longFromHash(hash, unsigned) {
    var bits = util.LongBits.fromHash(hash);
    if (util.Long) return util.Long.fromBits(bits.lo, bits.hi, unsigned);
    return bits.toNumber(Boolean(unsigned));
};
/**
 * Merges the properties of the source object into the destination object.
 * @memberof util
 * @param {Object.<string,*>} dst Destination object
 * @param {Object.<string,*>} src Source object
 * @param {boolean} [ifNotSet=false] Merges only if the key is not already set
 * @returns {Object.<string,*>} Destination object
 */ function merge(dst, src, ifNotSet) {
    for(var keys = Object.keys(src), i = 0; i < keys.length; ++i)if (dst[keys[i]] === undefined || !ifNotSet) dst[keys[i]] = src[keys[i]];
    return dst;
}
util.merge = merge;
/**
 * Converts the first character of a string to lower case.
 * @param {string} str String to convert
 * @returns {string} Converted string
 */ util.lcFirst = function lcFirst(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
};
/**
 * Creates a custom error constructor.
 * @memberof util
 * @param {string} name Error name
 * @returns {Constructor<Error>} Custom error constructor
 */ function newError(name) {
    function CustomError(message, properties) {
        if (!(this instanceof CustomError)) return new CustomError(message, properties);
        // Error.call(this, message);
        // ^ just returns a new error instance because the ctor can be called as a function
        Object.defineProperty(this, "message", {
            get: function() {
                return message;
            }
        });
        /* istanbul ignore next */ if (Error.captureStackTrace) Error.captureStackTrace(this, CustomError);
        else Object.defineProperty(this, "stack", {
            value: new Error().stack || ""
        });
        if (properties) merge(this, properties);
    }
    CustomError.prototype = Object.create(Error.prototype, {
        constructor: {
            value: CustomError,
            writable: true,
            enumerable: false,
            configurable: true
        },
        name: {
            get: function get() {
                return name;
            },
            set: undefined,
            enumerable: false,
            // configurable: false would accurately preserve the behavior of
            // the original, but I'm guessing that was not intentional.
            // For an actual error subclass, this property would
            // be configurable.
            configurable: true
        },
        toString: {
            value: function value() {
                return this.name + ": " + this.message;
            },
            writable: true,
            enumerable: false,
            configurable: true
        }
    });
    return CustomError;
}
util.newError = newError;
/**
 * Constructs a new protocol error.
 * @classdesc Error subclass indicating a protocol specifc error.
 * @memberof util
 * @extends Error
 * @template T extends Message<T>
 * @constructor
 * @param {string} message Error message
 * @param {Object.<string,*>} [properties] Additional properties
 * @example
 * try {
 *     MyMessage.decode(someBuffer); // throws if required fields are missing
 * } catch (e) {
 *     if (e instanceof ProtocolError && e.instance)
 *         console.log("decoded so far: " + JSON.stringify(e.instance));
 * }
 */ util.ProtocolError = newError("ProtocolError");
/**
 * So far decoded message instance.
 * @name util.ProtocolError#instance
 * @type {Message<T>}
 */ /**
 * A OneOf getter as returned by {@link util.oneOfGetter}.
 * @typedef OneOfGetter
 * @type {function}
 * @returns {string|undefined} Set field name, if any
 */ /**
 * Builds a getter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfGetter} Unbound getter
 */ util.oneOfGetter = function getOneOf(fieldNames) {
    var fieldMap = {};
    for(var i = 0; i < fieldNames.length; ++i)fieldMap[fieldNames[i]] = 1;
    /**
     * @returns {string|undefined} Set field name, if any
     * @this Object
     * @ignore
     */ return function() {
        for(var keys = Object.keys(this), i = keys.length - 1; i > -1; --i)if (fieldMap[keys[i]] === 1 && this[keys[i]] !== undefined && this[keys[i]] !== null) return keys[i];
    };
};
/**
 * A OneOf setter as returned by {@link util.oneOfSetter}.
 * @typedef OneOfSetter
 * @type {function}
 * @param {string|undefined} value Field name
 * @returns {undefined}
 */ /**
 * Builds a setter for a oneof's present field name.
 * @param {string[]} fieldNames Field names
 * @returns {OneOfSetter} Unbound setter
 */ util.oneOfSetter = function setOneOf(fieldNames) {
    /**
     * @param {string} name Field name
     * @returns {undefined}
     * @this Object
     * @ignore
     */ return function(name) {
        for(var i = 0; i < fieldNames.length; ++i)if (fieldNames[i] !== name) delete this[fieldNames[i]];
    };
};
/**
 * Default conversion options used for {@link Message#toJSON} implementations.
 *
 * These options are close to proto3's JSON mapping with the exception that internal types like Any are handled just like messages. More precisely:
 *
 * - Longs become strings
 * - Enums become string keys
 * - Bytes become base64 encoded strings
 * - (Sub-)Messages become plain objects
 * - Maps become plain objects with all string keys
 * - Repeated fields become arrays
 * - NaN and Infinity for float and double fields become strings
 *
 * @type {IConversionOptions}
 * @see https://developers.google.com/protocol-buffers/docs/proto3?hl=en#json
 */ util.toJSONOptions = {
    longs: String,
    enums: String,
    bytes: String,
    json: true
};
// Sets up buffer utility according to the environment (called in index-minimal)
util._configure = function() {
    var Buffer = util.Buffer;
    /* istanbul ignore if */ if (!Buffer) {
        util._Buffer_from = util._Buffer_allocUnsafe = null;
        return;
    }
    // because node 4.x buffers are incompatible & immutable
    // see: https://github.com/dcodeIO/protobuf.js/pull/665
    util._Buffer_from = Buffer.from !== Uint8Array.from && Buffer.from || /* istanbul ignore next */ function Buffer_from(value, encoding) {
        return new Buffer(value, encoding);
    };
    util._Buffer_allocUnsafe = Buffer.allocUnsafe || /* istanbul ignore next */ function Buffer_allocUnsafe(size) {
        return new Buffer(size);
    };
};

},{"217e30ba36d0c075":"eQYfr","140216d783bbc015":"aazTW","78776c045df9e77b":"1SZut","392006759dba32fb":"4pJfE","ac14d008f0aa6436":"1Ascf","298ebb5f36c5d25a":"3e2mN","dc7a35661f9f9275":"gXces","94b513d9f4cac968":"fCsZG"}],"eQYfr":[function(require,module,exports,__globalThis) {
"use strict";
module.exports = asPromise;
/**
 * Callback as used by {@link util.asPromise}.
 * @typedef asPromiseCallback
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {...*} params Additional arguments
 * @returns {undefined}
 */ /**
 * Returns a promise from a node-style callback function.
 * @memberof util
 * @param {asPromiseCallback} fn Function to call
 * @param {*} ctx Function context
 * @param {...*} params Function arguments
 * @returns {Promise<*>} Promisified function
 */ function asPromise(fn, ctx /*, varargs */ ) {
    var params = new Array(arguments.length - 1), offset = 0, index = 2, pending = true;
    while(index < arguments.length)params[offset++] = arguments[index++];
    return new Promise(function executor(resolve, reject) {
        params[offset] = function callback(err /*, varargs */ ) {
            if (pending) {
                pending = false;
                if (err) reject(err);
                else {
                    var params = new Array(arguments.length - 1), offset = 0;
                    while(offset < params.length)params[offset++] = arguments[offset];
                    resolve.apply(null, params);
                }
            }
        };
        try {
            fn.apply(ctx || null, params);
        } catch (err) {
            if (pending) {
                pending = false;
                reject(err);
            }
        }
    });
}

},{}],"aazTW":[function(require,module,exports,__globalThis) {
"use strict";
/**
 * A minimal base64 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var base64 = exports;
/**
 * Calculates the byte length of a base64 encoded string.
 * @param {string} string Base64 encoded string
 * @returns {number} Byte length
 */ base64.length = function length(string) {
    var p = string.length;
    if (!p) return 0;
    var n = 0;
    while(--p % 4 > 1 && string.charAt(p) === "=")++n;
    return Math.ceil(string.length * 3) / 4 - n;
};
// Base64 encoding table
var b64 = new Array(64);
// Base64 decoding table
var s64 = new Array(123);
// 65..90, 97..122, 48..57, 43, 47
for(var i = 0; i < 64;)s64[b64[i] = i < 26 ? i + 65 : i < 52 ? i + 71 : i < 62 ? i - 4 : i - 59 | 43] = i++;
/**
 * Encodes a buffer to a base64 encoded string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} Base64 encoded string
 */ base64.encode = function encode(buffer, start, end) {
    var parts = null, chunk = [];
    var i = 0, j = 0, t; // temporary
    while(start < end){
        var b = buffer[start++];
        switch(j){
            case 0:
                chunk[i++] = b64[b >> 2];
                t = (b & 3) << 4;
                j = 1;
                break;
            case 1:
                chunk[i++] = b64[t | b >> 4];
                t = (b & 15) << 2;
                j = 2;
                break;
            case 2:
                chunk[i++] = b64[t | b >> 6];
                chunk[i++] = b64[b & 63];
                j = 0;
                break;
        }
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (j) {
        chunk[i++] = b64[t];
        chunk[i++] = 61;
        if (j === 1) chunk[i++] = 61;
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
var invalidEncoding = "invalid encoding";
/**
 * Decodes a base64 encoded string to a buffer.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Number of bytes written
 * @throws {Error} If encoding is invalid
 */ base64.decode = function decode(string, buffer, offset) {
    var start = offset;
    var j = 0, t; // temporary
    for(var i = 0; i < string.length;){
        var c = string.charCodeAt(i++);
        if (c === 61 && j > 1) break;
        if ((c = s64[c]) === undefined) throw Error(invalidEncoding);
        switch(j){
            case 0:
                t = c;
                j = 1;
                break;
            case 1:
                buffer[offset++] = t << 2 | (c & 48) >> 4;
                t = c;
                j = 2;
                break;
            case 2:
                buffer[offset++] = (t & 15) << 4 | (c & 60) >> 2;
                t = c;
                j = 3;
                break;
            case 3:
                buffer[offset++] = (t & 3) << 6 | c;
                j = 0;
                break;
        }
    }
    if (j === 1) throw Error(invalidEncoding);
    return offset - start;
};
/**
 * Tests if the specified string appears to be base64 encoded.
 * @param {string} string String to test
 * @returns {boolean} `true` if probably base64 encoded, otherwise false
 */ base64.test = function test(string) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(string);
};

},{}],"1SZut":[function(require,module,exports,__globalThis) {
"use strict";
module.exports = EventEmitter;
/**
 * Constructs a new event emitter instance.
 * @classdesc A minimal event emitter.
 * @memberof util
 * @constructor
 */ function EventEmitter() {
    /**
     * Registered listeners.
     * @type {Object.<string,*>}
     * @private
     */ this._listeners = {};
}
/**
 * Registers an event listener.
 * @param {string} evt Event name
 * @param {function} fn Listener
 * @param {*} [ctx] Listener context
 * @returns {util.EventEmitter} `this`
 */ EventEmitter.prototype.on = function on(evt, fn, ctx) {
    (this._listeners[evt] || (this._listeners[evt] = [])).push({
        fn: fn,
        ctx: ctx || this
    });
    return this;
};
/**
 * Removes an event listener or any matching listeners if arguments are omitted.
 * @param {string} [evt] Event name. Removes all listeners if omitted.
 * @param {function} [fn] Listener to remove. Removes all listeners of `evt` if omitted.
 * @returns {util.EventEmitter} `this`
 */ EventEmitter.prototype.off = function off(evt, fn) {
    if (evt === undefined) this._listeners = {};
    else if (fn === undefined) this._listeners[evt] = [];
    else {
        var listeners = this._listeners[evt];
        for(var i = 0; i < listeners.length;)if (listeners[i].fn === fn) listeners.splice(i, 1);
        else ++i;
    }
    return this;
};
/**
 * Emits an event by calling its listeners with the specified arguments.
 * @param {string} evt Event name
 * @param {...*} args Arguments
 * @returns {util.EventEmitter} `this`
 */ EventEmitter.prototype.emit = function emit(evt) {
    var listeners = this._listeners[evt];
    if (listeners) {
        var args = [], i = 1;
        for(; i < arguments.length;)args.push(arguments[i++]);
        for(i = 0; i < listeners.length;)listeners[i].fn.apply(listeners[i++].ctx, args);
    }
    return this;
};

},{}],"4pJfE":[function(require,module,exports,__globalThis) {
"use strict";
module.exports = factory(factory);
/**
 * Reads / writes floats / doubles from / to buffers.
 * @name util.float
 * @namespace
 */ /**
 * Writes a 32 bit float to a buffer using little endian byte order.
 * @name util.float.writeFloatLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 32 bit float to a buffer using big endian byte order.
 * @name util.float.writeFloatBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 32 bit float from a buffer using little endian byte order.
 * @name util.float.readFloatLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 32 bit float from a buffer using big endian byte order.
 * @name util.float.readFloatBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Writes a 64 bit double to a buffer using little endian byte order.
 * @name util.float.writeDoubleLE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Writes a 64 bit double to a buffer using big endian byte order.
 * @name util.float.writeDoubleBE
 * @function
 * @param {number} val Value to write
 * @param {Uint8Array} buf Target buffer
 * @param {number} pos Target buffer offset
 * @returns {undefined}
 */ /**
 * Reads a 64 bit double from a buffer using little endian byte order.
 * @name util.float.readDoubleLE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ /**
 * Reads a 64 bit double from a buffer using big endian byte order.
 * @name util.float.readDoubleBE
 * @function
 * @param {Uint8Array} buf Source buffer
 * @param {number} pos Source buffer offset
 * @returns {number} Value read
 */ // Factory function for the purpose of node-based testing in modified global environments
function factory(exports) {
    // float: typed array
    if (typeof Float32Array !== "undefined") (function() {
        var f32 = new Float32Array([
            -0
        ]), f8b = new Uint8Array(f32.buffer), le = f8b[3] === 128;
        function writeFloat_f32_cpy(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
        }
        function writeFloat_f32_rev(val, buf, pos) {
            f32[0] = val;
            buf[pos] = f8b[3];
            buf[pos + 1] = f8b[2];
            buf[pos + 2] = f8b[1];
            buf[pos + 3] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeFloatLE = le ? writeFloat_f32_cpy : writeFloat_f32_rev;
        /* istanbul ignore next */ exports.writeFloatBE = le ? writeFloat_f32_rev : writeFloat_f32_cpy;
        function readFloat_f32_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            return f32[0];
        }
        function readFloat_f32_rev(buf, pos) {
            f8b[3] = buf[pos];
            f8b[2] = buf[pos + 1];
            f8b[1] = buf[pos + 2];
            f8b[0] = buf[pos + 3];
            return f32[0];
        }
        /* istanbul ignore next */ exports.readFloatLE = le ? readFloat_f32_cpy : readFloat_f32_rev;
        /* istanbul ignore next */ exports.readFloatBE = le ? readFloat_f32_rev : readFloat_f32_cpy;
    // float: ieee754
    })();
    else (function() {
        function writeFloat_ieee754(writeUint, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos);
            else if (isNaN(val)) writeUint(2143289344, buf, pos);
            else if (val > 3.4028234663852886e+38) writeUint((sign << 31 | 2139095040) >>> 0, buf, pos);
            else if (val < 1.1754943508222875e-38) writeUint((sign << 31 | Math.round(val / 1.401298464324817e-45)) >>> 0, buf, pos);
            else {
                var exponent = Math.floor(Math.log(val) / Math.LN2), mantissa = Math.round(val * Math.pow(2, -exponent) * 8388608) & 8388607;
                writeUint((sign << 31 | exponent + 127 << 23 | mantissa) >>> 0, buf, pos);
            }
        }
        exports.writeFloatLE = writeFloat_ieee754.bind(null, writeUintLE);
        exports.writeFloatBE = writeFloat_ieee754.bind(null, writeUintBE);
        function readFloat_ieee754(readUint, buf, pos) {
            var uint = readUint(buf, pos), sign = (uint >> 31) * 2 + 1, exponent = uint >>> 23 & 255, mantissa = uint & 8388607;
            return exponent === 255 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 1.401298464324817e-45 * mantissa : sign * Math.pow(2, exponent - 150) * (mantissa + 8388608);
        }
        exports.readFloatLE = readFloat_ieee754.bind(null, readUintLE);
        exports.readFloatBE = readFloat_ieee754.bind(null, readUintBE);
    })();
    // double: typed array
    if (typeof Float64Array !== "undefined") (function() {
        var f64 = new Float64Array([
            -0
        ]), f8b = new Uint8Array(f64.buffer), le = f8b[7] === 128;
        function writeDouble_f64_cpy(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[0];
            buf[pos + 1] = f8b[1];
            buf[pos + 2] = f8b[2];
            buf[pos + 3] = f8b[3];
            buf[pos + 4] = f8b[4];
            buf[pos + 5] = f8b[5];
            buf[pos + 6] = f8b[6];
            buf[pos + 7] = f8b[7];
        }
        function writeDouble_f64_rev(val, buf, pos) {
            f64[0] = val;
            buf[pos] = f8b[7];
            buf[pos + 1] = f8b[6];
            buf[pos + 2] = f8b[5];
            buf[pos + 3] = f8b[4];
            buf[pos + 4] = f8b[3];
            buf[pos + 5] = f8b[2];
            buf[pos + 6] = f8b[1];
            buf[pos + 7] = f8b[0];
        }
        /* istanbul ignore next */ exports.writeDoubleLE = le ? writeDouble_f64_cpy : writeDouble_f64_rev;
        /* istanbul ignore next */ exports.writeDoubleBE = le ? writeDouble_f64_rev : writeDouble_f64_cpy;
        function readDouble_f64_cpy(buf, pos) {
            f8b[0] = buf[pos];
            f8b[1] = buf[pos + 1];
            f8b[2] = buf[pos + 2];
            f8b[3] = buf[pos + 3];
            f8b[4] = buf[pos + 4];
            f8b[5] = buf[pos + 5];
            f8b[6] = buf[pos + 6];
            f8b[7] = buf[pos + 7];
            return f64[0];
        }
        function readDouble_f64_rev(buf, pos) {
            f8b[7] = buf[pos];
            f8b[6] = buf[pos + 1];
            f8b[5] = buf[pos + 2];
            f8b[4] = buf[pos + 3];
            f8b[3] = buf[pos + 4];
            f8b[2] = buf[pos + 5];
            f8b[1] = buf[pos + 6];
            f8b[0] = buf[pos + 7];
            return f64[0];
        }
        /* istanbul ignore next */ exports.readDoubleLE = le ? readDouble_f64_cpy : readDouble_f64_rev;
        /* istanbul ignore next */ exports.readDoubleBE = le ? readDouble_f64_rev : readDouble_f64_cpy;
    // double: ieee754
    })();
    else (function() {
        function writeDouble_ieee754(writeUint, off0, off1, val, buf, pos) {
            var sign = val < 0 ? 1 : 0;
            if (sign) val = -val;
            if (val === 0) {
                writeUint(0, buf, pos + off0);
                writeUint(1 / val > 0 ? /* positive */ 0 : /* negative 0 */ 2147483648, buf, pos + off1);
            } else if (isNaN(val)) {
                writeUint(0, buf, pos + off0);
                writeUint(2146959360, buf, pos + off1);
            } else if (val > 1.7976931348623157e+308) {
                writeUint(0, buf, pos + off0);
                writeUint((sign << 31 | 2146435072) >>> 0, buf, pos + off1);
            } else {
                var mantissa;
                if (val < 2.2250738585072014e-308) {
                    mantissa = val / 5e-324;
                    writeUint(mantissa >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | mantissa / 4294967296) >>> 0, buf, pos + off1);
                } else {
                    var exponent = Math.floor(Math.log(val) / Math.LN2);
                    if (exponent === 1024) exponent = 1023;
                    mantissa = val * Math.pow(2, -exponent);
                    writeUint(mantissa * 4503599627370496 >>> 0, buf, pos + off0);
                    writeUint((sign << 31 | exponent + 1023 << 20 | mantissa * 1048576 & 1048575) >>> 0, buf, pos + off1);
                }
            }
        }
        exports.writeDoubleLE = writeDouble_ieee754.bind(null, writeUintLE, 0, 4);
        exports.writeDoubleBE = writeDouble_ieee754.bind(null, writeUintBE, 4, 0);
        function readDouble_ieee754(readUint, off0, off1, buf, pos) {
            var lo = readUint(buf, pos + off0), hi = readUint(buf, pos + off1);
            var sign = (hi >> 31) * 2 + 1, exponent = hi >>> 20 & 2047, mantissa = 4294967296 * (hi & 1048575) + lo;
            return exponent === 2047 ? mantissa ? NaN : sign * Infinity : exponent === 0 // denormal
             ? sign * 5e-324 * mantissa : sign * Math.pow(2, exponent - 1075) * (mantissa + 4503599627370496);
        }
        exports.readDoubleLE = readDouble_ieee754.bind(null, readUintLE, 0, 4);
        exports.readDoubleBE = readDouble_ieee754.bind(null, readUintBE, 4, 0);
    })();
    return exports;
}
// uint helpers
function writeUintLE(val, buf, pos) {
    buf[pos] = val & 255;
    buf[pos + 1] = val >>> 8 & 255;
    buf[pos + 2] = val >>> 16 & 255;
    buf[pos + 3] = val >>> 24;
}
function writeUintBE(val, buf, pos) {
    buf[pos] = val >>> 24;
    buf[pos + 1] = val >>> 16 & 255;
    buf[pos + 2] = val >>> 8 & 255;
    buf[pos + 3] = val & 255;
}
function readUintLE(buf, pos) {
    return (buf[pos] | buf[pos + 1] << 8 | buf[pos + 2] << 16 | buf[pos + 3] << 24) >>> 0;
}
function readUintBE(buf, pos) {
    return (buf[pos] << 24 | buf[pos + 1] << 16 | buf[pos + 2] << 8 | buf[pos + 3]) >>> 0;
}

},{}],"1Ascf":[function(require,module,exports,__globalThis) {
// We intend to run in browsers, which don't support runtime `require`.
// https://github.com/protobufjs/protobuf.js/pull/1548/files#r588874248
// Stub this out to prevent CSP spam.
module.exports = ()=>null;

},{}],"3e2mN":[function(require,module,exports,__globalThis) {
"use strict";
/**
 * A minimal UTF8 implementation for number arrays.
 * @memberof util
 * @namespace
 */ var utf8 = exports;
/**
 * Calculates the UTF8 byte length of a string.
 * @param {string} string String
 * @returns {number} Byte length
 */ utf8.length = function utf8_length(string) {
    var len = 0, c = 0;
    for(var i = 0; i < string.length; ++i){
        c = string.charCodeAt(i);
        if (c < 128) len += 1;
        else if (c < 2048) len += 2;
        else if ((c & 0xFC00) === 0xD800 && (string.charCodeAt(i + 1) & 0xFC00) === 0xDC00) {
            ++i;
            len += 4;
        } else len += 3;
    }
    return len;
};
/**
 * Reads UTF8 bytes as a string.
 * @param {Uint8Array} buffer Source buffer
 * @param {number} start Source start
 * @param {number} end Source end
 * @returns {string} String read
 */ utf8.read = function utf8_read(buffer, start, end) {
    var len = end - start;
    if (len < 1) return "";
    var parts = null, chunk = [], i = 0, t; // temporary
    while(start < end){
        t = buffer[start++];
        if (t < 128) chunk[i++] = t;
        else if (t > 191 && t < 224) chunk[i++] = (t & 31) << 6 | buffer[start++] & 63;
        else if (t > 239 && t < 365) {
            t = ((t & 7) << 18 | (buffer[start++] & 63) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63) - 0x10000;
            chunk[i++] = 0xD800 + (t >> 10);
            chunk[i++] = 0xDC00 + (t & 1023);
        } else chunk[i++] = (t & 15) << 12 | (buffer[start++] & 63) << 6 | buffer[start++] & 63;
        if (i > 8191) {
            (parts || (parts = [])).push(String.fromCharCode.apply(String, chunk));
            i = 0;
        }
    }
    if (parts) {
        if (i) parts.push(String.fromCharCode.apply(String, chunk.slice(0, i)));
        return parts.join("");
    }
    return String.fromCharCode.apply(String, chunk.slice(0, i));
};
/**
 * Writes a string as UTF8 bytes.
 * @param {string} string Source string
 * @param {Uint8Array} buffer Destination buffer
 * @param {number} offset Destination offset
 * @returns {number} Bytes written
 */ utf8.write = function utf8_write(string, buffer, offset) {
    var start = offset, c1, c2; // character 2
    for(var i = 0; i < string.length; ++i){
        c1 = string.charCodeAt(i);
        if (c1 < 128) buffer[offset++] = c1;
        else if (c1 < 2048) {
            buffer[offset++] = c1 >> 6 | 192;
            buffer[offset++] = c1 & 63 | 128;
        } else if ((c1 & 0xFC00) === 0xD800 && ((c2 = string.charCodeAt(i + 1)) & 0xFC00) === 0xDC00) {
            c1 = 0x10000 + ((c1 & 0x03FF) << 10) + (c2 & 0x03FF);
            ++i;
            buffer[offset++] = c1 >> 18 | 240;
            buffer[offset++] = c1 >> 12 & 63 | 128;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        } else {
            buffer[offset++] = c1 >> 12 | 224;
            buffer[offset++] = c1 >> 6 & 63 | 128;
            buffer[offset++] = c1 & 63 | 128;
        }
    }
    return offset - start;
};

},{}],"gXces":[function(require,module,exports,__globalThis) {
"use strict";
module.exports = pool;
/**
 * An allocator as used by {@link util.pool}.
 * @typedef PoolAllocator
 * @type {function}
 * @param {number} size Buffer size
 * @returns {Uint8Array} Buffer
 */ /**
 * A slicer as used by {@link util.pool}.
 * @typedef PoolSlicer
 * @type {function}
 * @param {number} start Start offset
 * @param {number} end End offset
 * @returns {Uint8Array} Buffer slice
 * @this {Uint8Array}
 */ /**
 * A general purpose buffer pool.
 * @memberof util
 * @function
 * @param {PoolAllocator} alloc Allocator
 * @param {PoolSlicer} slice Slicer
 * @param {number} [size=8192] Slab size
 * @returns {PoolAllocator} Pooled allocator
 */ function pool(alloc, slice, size) {
    var SIZE = size || 8192;
    var MAX = SIZE >>> 1;
    var slab = null;
    var offset = SIZE;
    return function pool_alloc(size) {
        if (size < 1 || size > MAX) return alloc(size);
        if (offset + size > SIZE) {
            slab = alloc(SIZE);
            offset = 0;
        }
        var buf = slice.call(slab, offset, offset += size);
        if (offset & 7) offset = (offset | 7) + 1;
        return buf;
    };
}

},{}],"fCsZG":[function(require,module,exports,__globalThis) {
"use strict";
module.exports = LongBits;
var util = require("670bae0bb8fddc8f");
/**
 * Constructs new long bits.
 * @classdesc Helper class for working with the low and high bits of a 64 bit value.
 * @memberof util
 * @constructor
 * @param {number} lo Low 32 bits, unsigned
 * @param {number} hi High 32 bits, unsigned
 */ function LongBits(lo, hi) {
    // note that the casts below are theoretically unnecessary as of today, but older statically
    // generated converter code might still call the ctor with signed 32bits. kept for compat.
    /**
     * Low bits.
     * @type {number}
     */ this.lo = lo >>> 0;
    /**
     * High bits.
     * @type {number}
     */ this.hi = hi >>> 0;
}
/**
 * Zero bits.
 * @memberof util.LongBits
 * @type {util.LongBits}
 */ var zero = LongBits.zero = new LongBits(0, 0);
zero.toNumber = function() {
    return 0;
};
zero.zzEncode = zero.zzDecode = function() {
    return this;
};
zero.length = function() {
    return 1;
};
/**
 * Zero hash.
 * @memberof util.LongBits
 * @type {string}
 */ var zeroHash = LongBits.zeroHash = "\0\0\0\0\0\0\0\0";
/**
 * Constructs new long bits from the specified number.
 * @param {number} value Value
 * @returns {util.LongBits} Instance
 */ LongBits.fromNumber = function fromNumber(value) {
    if (value === 0) return zero;
    var sign = value < 0;
    if (sign) value = -value;
    var lo = value >>> 0, hi = (value - lo) / 4294967296 >>> 0;
    if (sign) {
        hi = ~hi >>> 0;
        lo = ~lo >>> 0;
        if (++lo > 4294967295) {
            lo = 0;
            if (++hi > 4294967295) hi = 0;
        }
    }
    return new LongBits(lo, hi);
};
/**
 * Constructs new long bits from a number, long or string.
 * @param {Long|number|string} value Value
 * @returns {util.LongBits} Instance
 */ LongBits.from = function from(value) {
    if (typeof value === "number") return LongBits.fromNumber(value);
    if (util.isString(value)) {
        /* istanbul ignore else */ if (util.Long) value = util.Long.fromString(value);
        else return LongBits.fromNumber(parseInt(value, 10));
    }
    return value.low || value.high ? new LongBits(value.low >>> 0, value.high >>> 0) : zero;
};
/**
 * Converts this long bits to a possibly unsafe JavaScript number.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {number} Possibly unsafe number
 */ LongBits.prototype.toNumber = function toNumber(unsigned) {
    if (!unsigned && this.hi >>> 31) {
        var lo = ~this.lo + 1 >>> 0, hi = ~this.hi >>> 0;
        if (!lo) hi = hi + 1 >>> 0;
        return -(lo + hi * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
};
/**
 * Converts this long bits to a long.
 * @param {boolean} [unsigned=false] Whether unsigned or not
 * @returns {Long} Long
 */ LongBits.prototype.toLong = function toLong(unsigned) {
    return util.Long ? new util.Long(this.lo | 0, this.hi | 0, Boolean(unsigned)) : {
        low: this.lo | 0,
        high: this.hi | 0,
        unsigned: Boolean(unsigned)
    };
};
var charCodeAt = String.prototype.charCodeAt;
/**
 * Constructs new long bits from the specified 8 characters long hash.
 * @param {string} hash Hash
 * @returns {util.LongBits} Bits
 */ LongBits.fromHash = function fromHash(hash) {
    if (hash === zeroHash) return zero;
    return new LongBits((charCodeAt.call(hash, 0) | charCodeAt.call(hash, 1) << 8 | charCodeAt.call(hash, 2) << 16 | charCodeAt.call(hash, 3) << 24) >>> 0, (charCodeAt.call(hash, 4) | charCodeAt.call(hash, 5) << 8 | charCodeAt.call(hash, 6) << 16 | charCodeAt.call(hash, 7) << 24) >>> 0);
};
/**
 * Converts this long bits to a 8 characters long hash.
 * @returns {string} Hash
 */ LongBits.prototype.toHash = function toHash() {
    return String.fromCharCode(this.lo & 255, this.lo >>> 8 & 255, this.lo >>> 16 & 255, this.lo >>> 24, this.hi & 255, this.hi >>> 8 & 255, this.hi >>> 16 & 255, this.hi >>> 24);
};
/**
 * Zig-zag encodes this long bits.
 * @returns {util.LongBits} `this`
 */ LongBits.prototype.zzEncode = function zzEncode() {
    var mask = this.hi >> 31;
    this.hi = ((this.hi << 1 | this.lo >>> 31) ^ mask) >>> 0;
    this.lo = (this.lo << 1 ^ mask) >>> 0;
    return this;
};
/**
 * Zig-zag decodes this long bits.
 * @returns {util.LongBits} `this`
 */ LongBits.prototype.zzDecode = function zzDecode() {
    var mask = -(this.lo & 1);
    this.lo = ((this.lo >>> 1 | this.hi << 31) ^ mask) >>> 0;
    this.hi = (this.hi >>> 1 ^ mask) >>> 0;
    return this;
};
/**
 * Calculates the length of this longbits when encoded as a varint.
 * @returns {number} Length
 */ LongBits.prototype.length = function length() {
    var part0 = this.lo, part1 = (this.lo >>> 28 | this.hi << 4) >>> 0, part2 = this.hi >>> 24;
    return part2 === 0 ? part1 === 0 ? part0 < 16384 ? part0 < 128 ? 1 : 2 : part0 < 2097152 ? 3 : 4 : part1 < 16384 ? part1 < 128 ? 5 : 6 : part1 < 2097152 ? 7 : 8 : part2 < 128 ? 9 : 10;
};

},{"670bae0bb8fddc8f":"5E9P4"}],"7sNic":[function(require,module,exports,__globalThis) {
"use strict";
module.exports = BufferWriter;
// extends Writer
var Writer = require("e9b2a43e398901ec");
(BufferWriter.prototype = Object.create(Writer.prototype)).constructor = BufferWriter;
var util = require("8ed11af2c26d797d");
/**
 * Constructs a new buffer writer instance.
 * @classdesc Wire format writer using node buffers.
 * @extends Writer
 * @constructor
 */ function BufferWriter() {
    Writer.call(this);
}
BufferWriter._configure = function() {
    /**
     * Allocates a buffer of the specified size.
     * @function
     * @param {number} size Buffer size
     * @returns {Buffer} Buffer
     */ BufferWriter.alloc = util._Buffer_allocUnsafe;
    BufferWriter.writeBytesBuffer = util.Buffer && util.Buffer.prototype instanceof Uint8Array && util.Buffer.prototype.set.name === "set" ? function writeBytesBuffer_set(val, buf, pos) {
        buf.set(val, pos); // faster than copy (requires node >= 4 where Buffers extend Uint8Array and set is properly inherited)
    // also works for plain array values
    } : function writeBytesBuffer_copy(val, buf, pos) {
        if (val.copy) val.copy(buf, pos, 0, val.length);
        else for(var i = 0; i < val.length;)buf[pos++] = val[i++];
    };
};
/**
 * @override
 */ BufferWriter.prototype.bytes = function write_bytes_buffer(value) {
    if (util.isString(value)) value = util._Buffer_from(value, "base64");
    var len = value.length >>> 0;
    this.uint32(len);
    if (len) this._push(BufferWriter.writeBytesBuffer, len, value);
    return this;
};
function writeStringBuffer(val, buf, pos) {
    if (val.length < 40) util.utf8.write(val, buf, pos);
    else if (buf.utf8Write) buf.utf8Write(val, pos);
    else buf.write(val, pos);
}
/**
 * @override
 */ BufferWriter.prototype.string = function write_string_buffer(value) {
    var len = util.Buffer.byteLength(value);
    this.uint32(len);
    if (len) this._push(writeStringBuffer, len, value);
    return this;
};
/**
 * Finishes the write operation.
 * @name BufferWriter#finish
 * @function
 * @returns {Buffer} Finished buffer
 */ BufferWriter._configure();

},{"e9b2a43e398901ec":"2ISmH","8ed11af2c26d797d":"5E9P4"}],"gh3Dh":[function(require,module,exports,__globalThis) {
"use strict";
module.exports = Reader;
var util = require("9f80034b34dad30b");
var BufferReader; // cyclic
var LongBits = util.LongBits, utf8 = util.utf8;
/* istanbul ignore next */ function indexOutOfRange(reader, writeLength) {
    return RangeError("index out of range: " + reader.pos + " + " + (writeLength || 1) + " > " + reader.len);
}
/**
 * Constructs a new reader instance using the specified buffer.
 * @classdesc Wire format reader using `Uint8Array` if available, otherwise `Array`.
 * @constructor
 * @param {Uint8Array} buffer Buffer to read from
 */ function Reader(buffer) {
    /**
     * Read buffer.
     * @type {Uint8Array}
     */ this.buf = buffer;
    /**
     * Read buffer position.
     * @type {number}
     */ this.pos = 0;
    /**
     * Read buffer length.
     * @type {number}
     */ this.len = buffer.length;
}
var create_array = typeof Uint8Array !== "undefined" ? function create_typed_array(buffer) {
    if (buffer instanceof Uint8Array || Array.isArray(buffer)) return new Reader(buffer);
    throw Error("illegal buffer");
} : function create_array(buffer) {
    if (Array.isArray(buffer)) return new Reader(buffer);
    throw Error("illegal buffer");
};
var create = function create() {
    return util.Buffer ? function create_buffer_setup(buffer) {
        return (Reader.create = function create_buffer(buffer) {
            return util.Buffer.isBuffer(buffer) ? new BufferReader(buffer) : create_array(buffer);
        })(buffer);
    } : create_array;
};
/**
 * Creates a new reader using the specified buffer.
 * @function
 * @param {Uint8Array|Buffer} buffer Buffer to read from
 * @returns {Reader|BufferReader} A {@link BufferReader} if `buffer` is a Buffer, otherwise a {@link Reader}
 * @throws {Error} If `buffer` is not a valid buffer
 */ Reader.create = create();
Reader.prototype._slice = util.Array.prototype.subarray || /* istanbul ignore next */ util.Array.prototype.slice;
/**
 * Reads a varint as an unsigned 32 bit value.
 * @function
 * @returns {number} Value read
 */ Reader.prototype.uint32 = function read_uint32_setup() {
    var value = 4294967295; // optimizer type-hint, tends to deopt otherwise (?!)
    return function read_uint32() {
        value = (this.buf[this.pos] & 127) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 7) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 14) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 127) << 21) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        value = (value | (this.buf[this.pos] & 15) << 28) >>> 0;
        if (this.buf[this.pos++] < 128) return value;
        /* istanbul ignore if */ if ((this.pos += 5) > this.len) {
            this.pos = this.len;
            throw indexOutOfRange(this, 10);
        }
        return value;
    };
}();
/**
 * Reads a varint as a signed 32 bit value.
 * @returns {number} Value read
 */ Reader.prototype.int32 = function read_int32() {
    return this.uint32() | 0;
};
/**
 * Reads a zig-zag encoded varint as a signed 32 bit value.
 * @returns {number} Value read
 */ Reader.prototype.sint32 = function read_sint32() {
    var value = this.uint32();
    return value >>> 1 ^ -(value & 1) | 0;
};
/* eslint-disable no-invalid-this */ function readLongVarint() {
    // tends to deopt with local vars for octet etc.
    var bits = new LongBits(0, 0);
    var i = 0;
    if (this.len - this.pos > 4) {
        for(; i < 4; ++i){
            // 1st..4th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 5th
        bits.lo = (bits.lo | (this.buf[this.pos] & 127) << 28) >>> 0;
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) >> 4) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
        i = 0;
    } else {
        for(; i < 3; ++i){
            /* istanbul ignore if */ if (this.pos >= this.len) throw indexOutOfRange(this);
            // 1st..3th
            bits.lo = (bits.lo | (this.buf[this.pos] & 127) << i * 7) >>> 0;
            if (this.buf[this.pos++] < 128) return bits;
        }
        // 4th
        bits.lo = (bits.lo | (this.buf[this.pos++] & 127) << i * 7) >>> 0;
        return bits;
    }
    if (this.len - this.pos > 4) for(; i < 5; ++i){
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    else for(; i < 5; ++i){
        /* istanbul ignore if */ if (this.pos >= this.len) throw indexOutOfRange(this);
        // 6th..10th
        bits.hi = (bits.hi | (this.buf[this.pos] & 127) << i * 7 + 3) >>> 0;
        if (this.buf[this.pos++] < 128) return bits;
    }
    /* istanbul ignore next */ throw Error("invalid varint encoding");
}
/* eslint-enable no-invalid-this */ /**
 * Reads a varint as a signed 64 bit value.
 * @name Reader#int64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as an unsigned 64 bit value.
 * @name Reader#uint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a zig-zag encoded varint as a signed 64 bit value.
 * @name Reader#sint64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a varint as a boolean.
 * @returns {boolean} Value read
 */ Reader.prototype.bool = function read_bool() {
    return this.uint32() !== 0;
};
function readFixed32_end(buf, end) {
    return (buf[end - 4] | buf[end - 3] << 8 | buf[end - 2] << 16 | buf[end - 1] << 24) >>> 0;
}
/**
 * Reads fixed 32 bits as an unsigned 32 bit integer.
 * @returns {number} Value read
 */ Reader.prototype.fixed32 = function read_fixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw indexOutOfRange(this, 4);
    return readFixed32_end(this.buf, this.pos += 4);
};
/**
 * Reads fixed 32 bits as a signed 32 bit integer.
 * @returns {number} Value read
 */ Reader.prototype.sfixed32 = function read_sfixed32() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw indexOutOfRange(this, 4);
    return readFixed32_end(this.buf, this.pos += 4) | 0;
};
/* eslint-disable no-invalid-this */ function readFixed64() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw indexOutOfRange(this, 8);
    return new LongBits(readFixed32_end(this.buf, this.pos += 4), readFixed32_end(this.buf, this.pos += 4));
}
/* eslint-enable no-invalid-this */ /**
 * Reads fixed 64 bits.
 * @name Reader#fixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads zig-zag encoded fixed 64 bits.
 * @name Reader#sfixed64
 * @function
 * @returns {Long} Value read
 */ /**
 * Reads a float (32 bit) as a number.
 * @function
 * @returns {number} Value read
 */ Reader.prototype.float = function read_float() {
    /* istanbul ignore if */ if (this.pos + 4 > this.len) throw indexOutOfRange(this, 4);
    var value = util.float.readFloatLE(this.buf, this.pos);
    this.pos += 4;
    return value;
};
/**
 * Reads a double (64 bit float) as a number.
 * @function
 * @returns {number} Value read
 */ Reader.prototype.double = function read_double() {
    /* istanbul ignore if */ if (this.pos + 8 > this.len) throw indexOutOfRange(this, 4);
    var value = util.float.readDoubleLE(this.buf, this.pos);
    this.pos += 8;
    return value;
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @returns {Uint8Array} Value read
 */ Reader.prototype.bytes = function read_bytes() {
    var length = this.uint32(), start = this.pos, end = this.pos + length;
    /* istanbul ignore if */ if (end > this.len) throw indexOutOfRange(this, length);
    this.pos += length;
    if (Array.isArray(this.buf)) return this.buf.slice(start, end);
    if (start === end) {
        var nativeBuffer = util.Buffer;
        return nativeBuffer ? nativeBuffer.alloc(0) : new this.buf.constructor(0);
    }
    return this._slice.call(this.buf, start, end);
};
/**
 * Reads a string preceeded by its byte length as a varint.
 * @returns {string} Value read
 */ Reader.prototype.string = function read_string() {
    var bytes = this.bytes();
    return utf8.read(bytes, 0, bytes.length);
};
/**
 * Skips the specified number of bytes if specified, otherwise skips a varint.
 * @param {number} [length] Length if known, otherwise a varint is assumed
 * @returns {Reader} `this`
 */ Reader.prototype.skip = function skip(length) {
    if (typeof length === "number") {
        /* istanbul ignore if */ if (this.pos + length > this.len) throw indexOutOfRange(this, length);
        this.pos += length;
    } else do {
        /* istanbul ignore if */ if (this.pos >= this.len) throw indexOutOfRange(this);
    }while (this.buf[this.pos++] & 128);
    return this;
};
/**
 * Skips the next element of the specified wire type.
 * @param {number} wireType Wire type received
 * @returns {Reader} `this`
 */ Reader.prototype.skipType = function(wireType) {
    switch(wireType){
        case 0:
            this.skip();
            break;
        case 1:
            this.skip(8);
            break;
        case 2:
            this.skip(this.uint32());
            break;
        case 3:
            while((wireType = this.uint32() & 7) !== 4)this.skipType(wireType);
            break;
        case 5:
            this.skip(4);
            break;
        /* istanbul ignore next */ default:
            throw Error("invalid wire type " + wireType + " at offset " + this.pos);
    }
    return this;
};
Reader._configure = function(BufferReader_) {
    BufferReader = BufferReader_;
    Reader.create = create();
    BufferReader._configure();
    var fn = util.Long ? "toLong" : /* istanbul ignore next */ "toNumber";
    util.merge(Reader.prototype, {
        int64: function read_int64() {
            return readLongVarint.call(this)[fn](false);
        },
        uint64: function read_uint64() {
            return readLongVarint.call(this)[fn](true);
        },
        sint64: function read_sint64() {
            return readLongVarint.call(this).zzDecode()[fn](false);
        },
        fixed64: function read_fixed64() {
            return readFixed64.call(this)[fn](true);
        },
        sfixed64: function read_sfixed64() {
            return readFixed64.call(this)[fn](false);
        }
    });
};

},{"9f80034b34dad30b":"5E9P4"}],"4eoJd":[function(require,module,exports,__globalThis) {
"use strict";
module.exports = BufferReader;
// extends Reader
var Reader = require("808dd763e7b39931");
(BufferReader.prototype = Object.create(Reader.prototype)).constructor = BufferReader;
var util = require("fcb9b16130e5c787");
/**
 * Constructs a new buffer reader instance.
 * @classdesc Wire format reader using node buffers.
 * @extends Reader
 * @constructor
 * @param {Buffer} buffer Buffer to read from
 */ function BufferReader(buffer) {
    Reader.call(this, buffer);
/**
     * Read buffer.
     * @name BufferReader#buf
     * @type {Buffer}
     */ }
BufferReader._configure = function() {
    /* istanbul ignore else */ if (util.Buffer) BufferReader.prototype._slice = util.Buffer.prototype.slice;
};
/**
 * @override
 */ BufferReader.prototype.string = function read_string_buffer() {
    var len = this.uint32(); // modifies pos
    return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + len, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + len, this.len));
};
/**
 * Reads a sequence of bytes preceeded by its length as a varint.
 * @name BufferReader#bytes
 * @function
 * @returns {Buffer} Value read
 */ BufferReader._configure();

},{"808dd763e7b39931":"gh3Dh","fcb9b16130e5c787":"5E9P4"}],"9HXBs":[function(require,module,exports,__globalThis) {
"use strict";
/**
 * Streaming RPC helpers.
 * @namespace
 */ var rpc = exports;
/**
 * RPC implementation passed to {@link Service#create} performing a service request on network level, i.e. by utilizing http requests or websockets.
 * @typedef RPCImpl
 * @type {function}
 * @param {Method|rpc.ServiceMethod<Message<{}>,Message<{}>>} method Reflected or static method being called
 * @param {Uint8Array} requestData Request data
 * @param {RPCImplCallback} callback Callback function
 * @returns {undefined}
 * @example
 * function rpcImpl(method, requestData, callback) {
 *     if (protobuf.util.lcFirst(method.name) !== "myMethod") // compatible with static code
 *         throw Error("no such method");
 *     asynchronouslyObtainAResponse(requestData, function(err, responseData) {
 *         callback(err, responseData);
 *     });
 * }
 */ /**
 * Node-style callback as used by {@link RPCImpl}.
 * @typedef RPCImplCallback
 * @type {function}
 * @param {Error|null} error Error, if any, otherwise `null`
 * @param {Uint8Array|null} [response] Response data or `null` to signal end of stream, if there hasn't been an error
 * @returns {undefined}
 */ rpc.Service = require("8d618176461c1566");

},{"8d618176461c1566":"eZeVQ"}],"eZeVQ":[function(require,module,exports,__globalThis) {
"use strict";
module.exports = Service;
var util = require("873e42e92ef9570e");
// Extends EventEmitter
(Service.prototype = Object.create(util.EventEmitter.prototype)).constructor = Service;
/**
 * A service method callback as used by {@link rpc.ServiceMethod|ServiceMethod}.
 *
 * Differs from {@link RPCImplCallback} in that it is an actual callback of a service method which may not return `response = null`.
 * @typedef rpc.ServiceMethodCallback
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {Error|null} error Error, if any
 * @param {TRes} [response] Response message
 * @returns {undefined}
 */ /**
 * A service method part of a {@link rpc.Service} as created by {@link Service.create}.
 * @typedef rpc.ServiceMethod
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 * @type {function}
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} [callback] Node-style callback called with the error, if any, and the response message
 * @returns {Promise<Message<TRes>>} Promise if `callback` has been omitted, otherwise `undefined`
 */ /**
 * Constructs a new RPC service instance.
 * @classdesc An RPC service as returned by {@link Service#create}.
 * @exports rpc.Service
 * @extends util.EventEmitter
 * @constructor
 * @param {RPCImpl} rpcImpl RPC implementation
 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
 */ function Service(rpcImpl, requestDelimited, responseDelimited) {
    if (typeof rpcImpl !== "function") throw TypeError("rpcImpl must be a function");
    util.EventEmitter.call(this);
    /**
     * RPC implementation. Becomes `null` once the service is ended.
     * @type {RPCImpl|null}
     */ this.rpcImpl = rpcImpl;
    /**
     * Whether requests are length-delimited.
     * @type {boolean}
     */ this.requestDelimited = Boolean(requestDelimited);
    /**
     * Whether responses are length-delimited.
     * @type {boolean}
     */ this.responseDelimited = Boolean(responseDelimited);
}
/**
 * Calls a service method through {@link rpc.Service#rpcImpl|rpcImpl}.
 * @param {Method|rpc.ServiceMethod<TReq,TRes>} method Reflected or static method
 * @param {Constructor<TReq>} requestCtor Request constructor
 * @param {Constructor<TRes>} responseCtor Response constructor
 * @param {TReq|Properties<TReq>} request Request message or plain object
 * @param {rpc.ServiceMethodCallback<TRes>} callback Service callback
 * @returns {undefined}
 * @template TReq extends Message<TReq>
 * @template TRes extends Message<TRes>
 */ Service.prototype.rpcCall = function rpcCall(method, requestCtor, responseCtor, request, callback) {
    if (!request) throw TypeError("request must be specified");
    var self = this;
    if (!callback) return util.asPromise(rpcCall, self, method, requestCtor, responseCtor, request);
    if (!self.rpcImpl) {
        setTimeout(function() {
            callback(Error("already ended"));
        }, 0);
        return undefined;
    }
    try {
        return self.rpcImpl(method, requestCtor[self.requestDelimited ? "encodeDelimited" : "encode"](request).finish(), function rpcCallback(err, response) {
            if (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            if (response === null) {
                self.end(/* endedByRPC */ true);
                return undefined;
            }
            if (!(response instanceof responseCtor)) try {
                response = responseCtor[self.responseDelimited ? "decodeDelimited" : "decode"](response);
            } catch (err) {
                self.emit("error", err, method);
                return callback(err);
            }
            self.emit("data", response, method);
            return callback(null, response);
        });
    } catch (err) {
        self.emit("error", err, method);
        setTimeout(function() {
            callback(err);
        }, 0);
        return undefined;
    }
};
/**
 * Ends this service and emits the `end` event.
 * @param {boolean} [endedByRPC=false] Whether the service has been ended by the RPC implementation.
 * @returns {rpc.Service} `this`
 */ Service.prototype.end = function end(endedByRPC) {
    if (this.rpcImpl) {
        if (!endedByRPC) this.rpcImpl(null, null, null);
        this.rpcImpl = null;
        this.emit("end").off();
    }
    return this;
};

},{"873e42e92ef9570e":"5E9P4"}],"eTLy4":[function(require,module,exports,__globalThis) {
"use strict";
module.exports = {}; /**
 * Named roots.
 * This is where pbjs stores generated structures (the option `-r, --root` specifies a name).
 * Can also be used manually to make roots available across modules.
 * @name roots
 * @type {Object.<string,Root>}
 * @example
 * // pbjs -r myroot -o compiled.js ...
 *
 * // in another module:
 * require("./compiled.js");
 *
 * // in any subsequent module:
 * var root = protobuf.roots["myroot"];
 */ 

},{}],"drbhA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IDENTITY_ERR_CERTIFICATE_ROTATION_FORBIDDEN_CODE = exports.IDENTITY_MODULE_NAME = exports.ERR_UNKNOWN_ERROR_CODE = exports.UNKNOWN_MODULE = exports.CODE_NO_ERROR = exports.LATEST_NODE_DESCRIPTOR_VERSION = exports.ENTITY_LATEST_DESCRIPTOR_VERSION = exports.INVALID_VERSION = exports.TEE_HARDWARE_RESERVED = exports.TEE_HARDWARE_INTEL_SGX = exports.TEE_HARDWARE_INVALID = exports.ROLE_STORAGE_RPC = exports.ROLE_CONSENSUS_RPC = exports.ROLE_VALIDATOR = exports.ROLE_KEY_MANAGER = exports.ROLE_COMPUTE_WORKER = void 0;
exports.openSignedEntity = openSignedEntity;
exports.signSignedEntity = signSignedEntity;
exports.openMultiSignedNode = openMultiSignedNode;
exports.signMultiSignedNode = signMultiSignedNode;
const misc = require("2b837538c7b092c0");
const signature = require("f58c191fa54a77");
/**
 * RoleComputeWorker is the compute worker role.
 */ exports.ROLE_COMPUTE_WORKER = 1;
/**
 * RoleKeyManager is the the key manager role.
 */ exports.ROLE_KEY_MANAGER = 4;
/**
 * RoleValidator is the validator role.
 */ exports.ROLE_VALIDATOR = 8;
/**
 * RoleConsensusRPC is the public consensus RPC services worker role.
 */ exports.ROLE_CONSENSUS_RPC = 16;
/**
 * RoleStorageRPC is the public storage RPC services worker role.
 */ exports.ROLE_STORAGE_RPC = 32;
/**
 * TEEHardwareInvalid is a non-TEE implementation.
 */ exports.TEE_HARDWARE_INVALID = 0;
/**
 * TEEHardwareIntelSGX is an Intel SGX TEE implementation.
 */ exports.TEE_HARDWARE_INTEL_SGX = 1;
/**
 * TEEHardwareReserved is the first reserved hardware implementation
 * identifier. All equal or greater identifiers are reserved.
 */ exports.TEE_HARDWARE_RESERVED = exports.TEE_HARDWARE_INTEL_SGX + 1;
exports.INVALID_VERSION = 65536;
/**
 * LatestDescriptorVersion is the latest descriptor version that should be
 * used for all new descriptors. Using earlier versions may be rejected.
 */ exports.ENTITY_LATEST_DESCRIPTOR_VERSION = 2;
/**
 * LatestNodeDescriptorVersion is the latest node descriptor version that should be used for all
 * new descriptors. Using earlier versions may be rejected.
 */ exports.LATEST_NODE_DESCRIPTOR_VERSION = 1;
/**
 * CodeNoError is the reserved "no error" code.
 */ exports.CODE_NO_ERROR = 0;
/**
 * UnknownModule is the module name used when the module is unknown.
 */ exports.UNKNOWN_MODULE = 'unknown';
exports.ERR_UNKNOWN_ERROR_CODE = 1;
exports.IDENTITY_MODULE_NAME = 'identity';
/**
 * ErrCertificateRotationForbidden is returned by RotateCertificates if
 * TLS certificate rotation is forbidden.  This happens when rotation is
 * enabled and an existing TLS certificate was successfully loaded
 * (or a new one was generated and persisted to disk).
 */ exports.IDENTITY_ERR_CERTIFICATE_ROTATION_FORBIDDEN_CODE = 1;
function openSignedEntity(context, signed) {
    return misc.fromCBOR(signature.openSigned(context, signed));
}
async function signSignedEntity(signer, context, entity) {
    return await signature.signSigned(signer, context, misc.toCBOR(entity));
}
function openMultiSignedNode(context, multiSigned) {
    return misc.fromCBOR(signature.openMultiSigned(context, multiSigned));
}
async function signMultiSignedNode(signers, context, node) {
    return await signature.signMultiSigned(signers, context, misc.toCBOR(node));
}

},{"2b837538c7b092c0":"1Mc9i","f58c191fa54a77":"6UtA9"}],"7hXqf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEBUG_ERR_INCOMPATIBLE_BACKEND_CODE = exports.DEBUG_MODULE_NAME = void 0;
/**
 * DebugModuleName is the module name for the debug controller service.
 */ exports.DEBUG_MODULE_NAME = 'control/debug';
/**
 * ErrIncompatibleBackend is the error raised when the current beacon
 * backend does not support manually setting the current epoch.
 */ exports.DEBUG_ERR_INCOMPATIBLE_BACKEND_CODE = 1;

},{}],"dyFs9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.chainContext = chainContext;
const hash = require("d29eefe720a7be37");
const misc = require("e4fa3f2c0ae5c71f");
function chainContext(doc) {
    return misc.toHex(hash.hash(misc.toCBOR(doc)));
}

},{"d29eefe720a7be37":"gpNaY","e4fa3f2c0ae5c71f":"1Mc9i"}],"2fYpZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ERR_VOTING_IS_CLOSED_CODE = exports.ERR_NOT_ELIGIBLE_CODE = exports.ERR_NO_SUCH_PROPOSAL_CODE = exports.ERR_NO_SUCH_UPGRADE_CODE = exports.ERR_UPGRADE_ALREADY_PENDING_CODE = exports.ERR_UPGRADE_TOO_SOON_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = exports.VOTE_ABSTAIN = exports.VOTE_NO = exports.VOTE_YES = exports.PROPOSAL_CONTENT_INVALID_TEXT = exports.STATE_FAILED = exports.STATE_REJECTED = exports.STATE_PASSED = exports.STATE_ACTIVE = exports.METHOD_CAST_VOTE = exports.METHOD_SUBMIT_PROPOSAL = void 0;
exports.submitProposalWrapper = submitProposalWrapper;
exports.castVoteWrapper = castVoteWrapper;
const consensus = require("d4c9b36f836302a3");
/**
 * MethodSubmitProposal submits a new consensus layer governance proposal.
 */ exports.METHOD_SUBMIT_PROPOSAL = 'governance.SubmitProposal';
/**
 * MethodCastVote casts a vote for a consensus layer governance proposal.
 */ exports.METHOD_CAST_VOTE = 'governance.CastVote';
exports.STATE_ACTIVE = 1;
exports.STATE_PASSED = 2;
exports.STATE_REJECTED = 3;
exports.STATE_FAILED = 4;
/**
 * ProposalContentInvalidText is the textual representation of an invalid
 * ProposalContent.
 */ exports.PROPOSAL_CONTENT_INVALID_TEXT = '(invalid)';
exports.VOTE_YES = 1;
exports.VOTE_NO = 2;
exports.VOTE_ABSTAIN = 3;
/**
 * ModuleName is a unique module name for the governance backend.
 */ exports.MODULE_NAME = 'governance';
/**
 * ErrInvalidArgument is the error returned on malformed argument(s).
 */ exports.ERR_INVALID_ARGUMENT_CODE = 1;
/**
 * ErrUpgradeTooSoon is the error returned when an upgrade is not enough in the future.
 */ exports.ERR_UPGRADE_TOO_SOON_CODE = 2;
/**
 * ErrUpgradeAlreadyPending is the error returned when an upgrade is already pending.
 */ exports.ERR_UPGRADE_ALREADY_PENDING_CODE = 3;
/**
 * ErrNoSuchUpgrade is the error returned when an upgrade does not exist.
 */ exports.ERR_NO_SUCH_UPGRADE_CODE = 4;
/**
 * ErrNoSuchProposal is the error retrued when a proposal does not exist.
 */ exports.ERR_NO_SUCH_PROPOSAL_CODE = 5;
/**
 * ErrNotEligible is the error returned when a vote caster is not eligible for a vote.
 */ exports.ERR_NOT_ELIGIBLE_CODE = 6;
/**
 * ErrVotingIsClosed is the error returned when a vote is cast for a non-active proposal.
 */ exports.ERR_VOTING_IS_CLOSED_CODE = 7;
function submitProposalWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_SUBMIT_PROPOSAL);
}
function castVoteWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_CAST_VOTE);
}

},{"d4c9b36f836302a3":"6XVjL"}],"VNWAo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HDKey = void 0;
const hmac_1 = require("1f6b06ffa13a97bd");
const sha512_1 = require("8f95ee133c7a0907");
const tweetnacl_1 = require("68ec01cc75dbb18e");
const bip39_1 = require("d87363649df20bf8");
const misc_1 = require("74b6a4fefd80bce");
const ED25519_CURVE = 'ed25519 seed';
const HARDENED_OFFSET = 0x80000000;
const pathRegex = new RegExp("^m(\\/[0-9]+')+$");
/**
 * HDKey handles hierarchical key generation according to ADR 0008
 * https://github.com/oasisprotocol/adrs/blob/main/0008-standard-account-key-generation.md
 */ class HDKey {
    /**
     * Generates the keypair matching the supplied parameters
     * @param mnemonic BIP-0039 Mnemonic
     * @param index Account index
     * @param passphrase Optional BIP-0039 passphrase
     * @returns SignKeyPair for these parameters
     */ static async getAccountSigner(mnemonic, index = 0, passphrase) {
        if (index < 0 || index > 0x7fffffff) throw new Error('Account number must be >= 0 and <= 2147483647');
        const seed = await (0, bip39_1.mnemonicToSeed)(mnemonic, passphrase);
        const key = HDKey.makeHDKey(ED25519_CURVE, seed);
        return key.derivePath(`m/44'/474'/${index}'`).keypair;
    }
    /**
     * Generates a mnemonic
     * @param strength Length in bits of the generated mnemonic
     * @returns Generated BIP-0039 Mnemonic
     */ static generateMnemonic(strength = 256) {
        return (0, bip39_1.generateMnemonic)(strength);
    }
    constructor(privateKey, chainCode){
        this.privateKey = privateKey;
        this.chainCode = chainCode;
        this.keypair = tweetnacl_1.sign.keyPair.fromSeed(privateKey);
    }
    /**
     * Returns the HDKey for the given derivation path
     * using SLIP-0010
     * @param path Derivation path, starting with m/
     * @returns Instance of HDKey
     */ derivePath(path) {
        if (!pathRegex.test(path)) throw new Error("Invalid derivation path. Valid paths must use a format similar to : m/44'/474'/0' and all indexes must be hardened");
        const segments = path.split('/').slice(1).map((val)=>val.replace("'", '')).map((el)=>parseInt(el, 10));
        return segments.reduce((parent, segment)=>parent.derive(segment + HARDENED_OFFSET), this);
    }
    /**
     * Derive the child key at the specified index
     * @param index
     * @returns Instance of HDKey
     */ derive(index) {
        const buffer = new ArrayBuffer(4);
        const view = new DataView(buffer);
        view.setUint32(0, index);
        const data = (0, misc_1.concat)(new Uint8Array([
            0
        ]), this.privateKey, new Uint8Array(buffer));
        return HDKey.makeHDKey(this.chainCode, data);
    }
    static makeHDKey(hmacKey, data) {
        const hash = (0, hmac_1.hmac)(sha512_1.sha512, hmacKey, data);
        const I = new Uint8Array(hash);
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        return new HDKey(IL, IR);
    }
}
exports.HDKey = HDKey;

},{"1f6b06ffa13a97bd":"cfxxP","8f95ee133c7a0907":"3uPma","68ec01cc75dbb18e":"5ZWFX","d87363649df20bf8":"8hadA","74b6a4fefd80bce":"1Mc9i"}],"cfxxP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hmac = exports.HMAC = void 0;
/**
 * HMAC: RFC2104 message authentication code.
 * @module
 */ const utils_ts_1 = require("4e6a7f5ac631fce5");
class HMAC extends utils_ts_1.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, utils_ts_1.ahash)(hash);
        const key = (0, utils_ts_1.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== 'function') throw new Error('Expected instance of class which extends utils.Hash');
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        (0, utils_ts_1.clean)(pad);
    }
    update(buf) {
        (0, utils_ts_1.aexists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, utils_ts_1.aexists)(this);
        (0, utils_ts_1.abytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash, iHash, finished, destroyed, blockLen, outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
exports.HMAC = HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 * @example
 * import { hmac } from '@noble/hashes/hmac';
 * import { sha256 } from '@noble/hashes/sha2';
 * const mac1 = hmac(sha256, 'key', 'message');
 */ const hmac = (hash, key, message)=>new HMAC(hash, key).update(message).digest();
exports.hmac = hmac;
exports.hmac.create = (hash, key)=>new HMAC(hash, key);

},{"4e6a7f5ac631fce5":"eZ1E0"}],"8hadA":[function(require,module,exports,__globalThis) {
var Buffer = require("ad6c208ed534fe78").Buffer;
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const sha256_1 = require("be2effb341cd7f75");
const sha512_1 = require("d8b171a06d384656");
const pbkdf2_1 = require("5a2385d1e7fed5f7");
const utils_1 = require("b3a9566b6481624b");
const _wordlists_1 = require("7e8652e50b1fc36d");
let DEFAULT_WORDLIST = _wordlists_1._default;
const INVALID_MNEMONIC = 'Invalid mnemonic';
const INVALID_ENTROPY = 'Invalid entropy';
const INVALID_CHECKSUM = 'Invalid mnemonic checksum';
const WORDLIST_REQUIRED = "A wordlist is required but a default could not be found.\nPlease pass a 2048 word array explicitly.";
function normalize(str) {
    return (str || '').normalize('NFKD');
}
function lpad(str, padString, length) {
    while(str.length < length)str = padString + str;
    return str;
}
function binaryToByte(bin) {
    return parseInt(bin, 2);
}
function bytesToBinary(bytes) {
    return bytes.map((x)=>lpad(x.toString(2), '0', 8)).join('');
}
function deriveChecksumBits(entropyBuffer) {
    const ENT = entropyBuffer.length * 8;
    const CS = ENT / 32;
    const hash = sha256_1.sha256(Uint8Array.from(entropyBuffer));
    return bytesToBinary(Array.from(hash)).slice(0, CS);
}
function salt(password) {
    return 'mnemonic' + (password || '');
}
function mnemonicToSeedSync(mnemonic, password) {
    const mnemonicBuffer = Uint8Array.from(Buffer.from(normalize(mnemonic), 'utf8'));
    const saltBuffer = Uint8Array.from(Buffer.from(salt(normalize(password)), 'utf8'));
    const res = pbkdf2_1.pbkdf2(sha512_1.sha512, mnemonicBuffer, saltBuffer, {
        c: 2048,
        dkLen: 64
    });
    return Buffer.from(res);
}
exports.mnemonicToSeedSync = mnemonicToSeedSync;
function mnemonicToSeed(mnemonic, password) {
    const mnemonicBuffer = Uint8Array.from(Buffer.from(normalize(mnemonic), 'utf8'));
    const saltBuffer = Uint8Array.from(Buffer.from(salt(normalize(password)), 'utf8'));
    return pbkdf2_1.pbkdf2Async(sha512_1.sha512, mnemonicBuffer, saltBuffer, {
        c: 2048,
        dkLen: 64
    }).then((res)=>Buffer.from(res));
}
exports.mnemonicToSeed = mnemonicToSeed;
function mnemonicToEntropy(mnemonic, wordlist) {
    wordlist = wordlist || DEFAULT_WORDLIST;
    if (!wordlist) throw new Error(WORDLIST_REQUIRED);
    const words = normalize(mnemonic).split(' ');
    if (words.length % 3 !== 0) throw new Error(INVALID_MNEMONIC);
    // convert word indices to 11 bit binary strings
    const bits = words.map((word)=>{
        const index = wordlist.indexOf(word);
        if (index === -1) throw new Error(INVALID_MNEMONIC);
        return lpad(index.toString(2), '0', 11);
    }).join('');
    // split the binary string into ENT/CS
    const dividerIndex = Math.floor(bits.length / 33) * 32;
    const entropyBits = bits.slice(0, dividerIndex);
    const checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    const entropyBytes = entropyBits.match(/(.{1,8})/g).map(binaryToByte);
    if (entropyBytes.length < 16) throw new Error(INVALID_ENTROPY);
    if (entropyBytes.length > 32) throw new Error(INVALID_ENTROPY);
    if (entropyBytes.length % 4 !== 0) throw new Error(INVALID_ENTROPY);
    const entropy = Buffer.from(entropyBytes);
    const newChecksum = deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) throw new Error(INVALID_CHECKSUM);
    return entropy.toString('hex');
}
exports.mnemonicToEntropy = mnemonicToEntropy;
function entropyToMnemonic(entropy, wordlist) {
    if (!Buffer.isBuffer(entropy)) entropy = Buffer.from(entropy, 'hex');
    wordlist = wordlist || DEFAULT_WORDLIST;
    if (!wordlist) throw new Error(WORDLIST_REQUIRED);
    // 128 <= ENT <= 256
    if (entropy.length < 16) throw new TypeError(INVALID_ENTROPY);
    if (entropy.length > 32) throw new TypeError(INVALID_ENTROPY);
    if (entropy.length % 4 !== 0) throw new TypeError(INVALID_ENTROPY);
    const entropyBits = bytesToBinary(Array.from(entropy));
    const checksumBits = deriveChecksumBits(entropy);
    const bits = entropyBits + checksumBits;
    const chunks = bits.match(/(.{1,11})/g);
    const words = chunks.map((binary)=>{
        const index = binaryToByte(binary);
        return wordlist[index];
    });
    return wordlist[0] === '\u3042\u3044\u3053\u304f\u3057\u3093' // Japanese wordlist
     ? words.join('\u3000') : words.join(' ');
}
exports.entropyToMnemonic = entropyToMnemonic;
function generateMnemonic(strength, rng, wordlist) {
    strength = strength || 128;
    if (strength % 32 !== 0) throw new TypeError(INVALID_ENTROPY);
    rng = rng || ((size)=>Buffer.from(utils_1.randomBytes(size)));
    return entropyToMnemonic(rng(strength / 8), wordlist);
}
exports.generateMnemonic = generateMnemonic;
function validateMnemonic(mnemonic, wordlist) {
    try {
        mnemonicToEntropy(mnemonic, wordlist);
    } catch (e) {
        return false;
    }
    return true;
}
exports.validateMnemonic = validateMnemonic;
function setDefaultWordlist(language) {
    const result = _wordlists_1.wordlists[language];
    if (result) DEFAULT_WORDLIST = result;
    else throw new Error('Could not find wordlist for language "' + language + '"');
}
exports.setDefaultWordlist = setDefaultWordlist;
function getDefaultWordlist() {
    if (!DEFAULT_WORDLIST) throw new Error('No Default Wordlist set');
    return Object.keys(_wordlists_1.wordlists).filter((lang)=>{
        if (lang === 'JA' || lang === 'EN') return false;
        return _wordlists_1.wordlists[lang].every((word, index)=>word === DEFAULT_WORDLIST[index]);
    })[0];
}
exports.getDefaultWordlist = getDefaultWordlist;
var _wordlists_2 = require("7e8652e50b1fc36d");
exports.wordlists = _wordlists_2.wordlists;

},{"ad6c208ed534fe78":"eXvXD","be2effb341cd7f75":"1Sjbu","d8b171a06d384656":"7eoAf","5a2385d1e7fed5f7":"8A9ZH","b3a9566b6481624b":"2YjGZ","7e8652e50b1fc36d":"dgJ4H"}],"eXvXD":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== 'number') throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

},{"9c62938f1dccc73c":"fuY5l","aceacb6a4531a9d2":"afQrv"}],"fuY5l":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"afQrv":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"1Sjbu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sha224 = exports.sha256 = void 0;
const _sha2_js_1 = require("f0369f0173e40550");
const utils_js_1 = require("dd2d5fab8dc388cf");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class SHA256 extends _sha2_js_1.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = IV[0] | 0;
        this.B = IV[1] | 0;
        this.C = IV[2] | 0;
        this.D = IV[3] | 0;
        this.E = IV[4] | 0;
        this.F = IV[5] | 0;
        this.G = IV[6] | 0;
        this.H = IV[7] | 0;
    }
    get() {
        const { A, B, C, D, E, F, G, H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = SHA256_W[i - 15];
            const W2 = SHA256_W[i - 2];
            const s0 = (0, utils_js_1.rotr)(W15, 7) ^ (0, utils_js_1.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, utils_js_1.rotr)(W2, 17) ^ (0, utils_js_1.rotr)(W2, 19) ^ W2 >>> 10;
            SHA256_W[i] = s1 + SHA256_W[i - 7] + s0 + SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A, B, C, D, E, F, G, H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, utils_js_1.rotr)(E, 6) ^ (0, utils_js_1.rotr)(E, 11) ^ (0, utils_js_1.rotr)(E, 25);
            const T1 = H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i] | 0;
            const sigma0 = (0, utils_js_1.rotr)(A, 2) ^ (0, utils_js_1.rotr)(A, 13) ^ (0, utils_js_1.rotr)(A, 22);
            const T2 = sigma0 + Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class SHA224 extends SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ exports.sha256 = (0, utils_js_1.wrapConstructor)(()=>new SHA256());
exports.sha224 = (0, utils_js_1.wrapConstructor)(()=>new SHA224());

},{"f0369f0173e40550":"e7KCv","dd2d5fab8dc388cf":"2YjGZ"}],"e7KCv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SHA2 = void 0;
const _assert_js_1 = require("96995f5a2c2249c4");
const utils_js_1 = require("c59c675893fdf798");
// Polyfill for Safari 14
function setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class SHA2 extends utils_js_1.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, utils_js_1.createView)(this.buffer);
    }
    update(data) {
        (0, _assert_js_1.exists)(this);
        const { view, buffer, blockLen } = this;
        data = (0, utils_js_1.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, utils_js_1.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, _assert_js_1.exists)(this);
        (0, _assert_js_1.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer, view, blockLen, isLE } = this;
        let { pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, utils_js_1.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer, outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen, buffer, length, finished, destroyed, pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
exports.SHA2 = SHA2;

},{"96995f5a2c2249c4":"7eSSE","c59c675893fdf798":"2YjGZ"}],"7eSSE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.output = exports.exists = exports.hash = exports.bytes = exports.bool = exports.number = void 0;
function number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
exports.number = number;
function bool(b) {
    if (typeof b !== 'boolean') throw new Error(`Expected boolean, not ${b}`);
}
exports.bool = bool;
// copied from utils
function isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === 'object' && a.constructor.name === 'Uint8Array';
}
function bytes(b, ...lengths) {
    if (!isBytes(b)) throw new Error('Expected Uint8Array');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
exports.bytes = bytes;
function hash(hash) {
    if (typeof hash !== 'function' || typeof hash.create !== 'function') throw new Error('Hash should be wrapped by utils.wrapConstructor');
    number(hash.outputLen);
    number(hash.blockLen);
}
exports.hash = hash;
function exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
exports.exists = exists;
function output(out, instance) {
    bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
exports.output = output;
const assert = {
    number,
    bool,
    bytes,
    hash,
    exists,
    output
};
exports.default = assert;

},{}],"2YjGZ":[function(require,module,exports,__globalThis) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.randomBytes = exports.wrapXOFConstructorWithOpts = exports.wrapConstructorWithOpts = exports.wrapConstructor = exports.checkOpts = exports.Hash = exports.concatBytes = exports.toBytes = exports.utf8ToBytes = exports.asyncLoop = exports.nextTick = exports.hexToBytes = exports.bytesToHex = exports.isLE = exports.rotr = exports.createView = exports.u32 = exports.u8 = void 0;
// We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const crypto_1 = require("308a0f9b8753b4af");
// Cast array to different type
const u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
exports.u8 = u8;
const u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
exports.u32 = u32;
function isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === 'object' && a.constructor.name === 'Uint8Array';
}
// Cast array to view
const createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
exports.createView = createView;
// The rotate right (circular right shift) operation for uint32
const rotr = (word, shift)=>word << 32 - shift | word >>> shift;
exports.rotr = rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
// Other libraries would silently corrupt the data instead of throwing an error,
// when they don't support it.
exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!exports.isLE) throw new Error('Non little-endian hardware is not supported');
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function bytesToHex(bytes) {
    if (!isBytes(bytes)) throw new Error('Uint8Array expected');
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += hexes[bytes[i]];
    return hex;
}
exports.bytesToHex = bytesToHex;
// We use optimized technique to convert hex string to byte array
const asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function asciiToBase16(char) {
    if (char >= asciis._0 && char <= asciis._9) return char - asciis._0;
    if (char >= asciis._A && char <= asciis._F) return char - (asciis._A - 10);
    if (char >= asciis._a && char <= asciis._f) return char - (asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function hexToBytes(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('padded hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = asciiToBase16(hex.charCodeAt(hi));
        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
exports.hexToBytes = hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const nextTick = async ()=>{};
exports.nextTick = nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, exports.nextTick)();
        ts += diff;
    }
}
exports.asyncLoop = asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
exports.utf8ToBytes = utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function toBytes(data) {
    if (typeof data === 'string') data = utf8ToBytes(data);
    if (!isBytes(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
exports.toBytes = toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        if (!isBytes(a)) throw new Error('Uint8Array expected');
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
exports.concatBytes = concatBytes;
// For runtime check if class implements interface
class Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
exports.Hash = Hash;
const toStr = {}.toString;
function checkOpts(defaults, opts) {
    if (opts !== undefined && toStr.call(opts) !== '[object Object]') throw new Error('Options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
exports.checkOpts = checkOpts;
function wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update(toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
exports.wrapConstructor = wrapConstructor;
function wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
exports.wrapConstructorWithOpts = wrapConstructorWithOpts;
function wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
exports.wrapXOFConstructorWithOpts = wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function randomBytes(bytesLength = 32) {
    if (crypto_1.crypto && typeof crypto_1.crypto.getRandomValues === 'function') return crypto_1.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error('crypto.getRandomValues must be defined');
}
exports.randomBytes = randomBytes;

},{"308a0f9b8753b4af":"3PDZY"}],"3PDZY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.crypto = void 0;
exports.crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;

},{}],"7eoAf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sha384 = exports.sha512_256 = exports.sha512_224 = exports.sha512 = exports.SHA512 = void 0;
const _sha2_js_1 = require("de63277d4b9ab571");
const _u64_js_1 = require("eda9289ed6a1f5f2");
const utils_js_1 = require("f18acd6c798648cc");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [SHA512_Kh, SHA512_Kl] = /* @__PURE__ */ (()=>_u64_js_1.default.split([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class SHA512 extends _sha2_js_1.SHA2 {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            SHA512_W_H[i] = view.getUint32(offset);
            SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = SHA512_W_H[i - 15] | 0;
            const W15l = SHA512_W_L[i - 15] | 0;
            const s0h = _u64_js_1.default.rotrSH(W15h, W15l, 1) ^ _u64_js_1.default.rotrSH(W15h, W15l, 8) ^ _u64_js_1.default.shrSH(W15h, W15l, 7);
            const s0l = _u64_js_1.default.rotrSL(W15h, W15l, 1) ^ _u64_js_1.default.rotrSL(W15h, W15l, 8) ^ _u64_js_1.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = SHA512_W_H[i - 2] | 0;
            const W2l = SHA512_W_L[i - 2] | 0;
            const s1h = _u64_js_1.default.rotrSH(W2h, W2l, 19) ^ _u64_js_1.default.rotrBH(W2h, W2l, 61) ^ _u64_js_1.default.shrSH(W2h, W2l, 6);
            const s1l = _u64_js_1.default.rotrSL(W2h, W2l, 19) ^ _u64_js_1.default.rotrBL(W2h, W2l, 61) ^ _u64_js_1.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = _u64_js_1.default.add4L(s0l, s1l, SHA512_W_L[i - 7], SHA512_W_L[i - 16]);
            const SUMh = _u64_js_1.default.add4H(SUMl, s0h, s1h, SHA512_W_H[i - 7], SHA512_W_H[i - 16]);
            SHA512_W_H[i] = SUMh | 0;
            SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = _u64_js_1.default.rotrSH(Eh, El, 14) ^ _u64_js_1.default.rotrSH(Eh, El, 18) ^ _u64_js_1.default.rotrBH(Eh, El, 41);
            const sigma1l = _u64_js_1.default.rotrSL(Eh, El, 14) ^ _u64_js_1.default.rotrSL(Eh, El, 18) ^ _u64_js_1.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = _u64_js_1.default.add5L(Hl, sigma1l, CHIl, SHA512_Kl[i], SHA512_W_L[i]);
            const T1h = _u64_js_1.default.add5H(T1ll, Hh, sigma1h, CHIh, SHA512_Kh[i], SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = _u64_js_1.default.rotrSH(Ah, Al, 28) ^ _u64_js_1.default.rotrBH(Ah, Al, 34) ^ _u64_js_1.default.rotrBH(Ah, Al, 39);
            const sigma0l = _u64_js_1.default.rotrSL(Ah, Al, 28) ^ _u64_js_1.default.rotrBL(Ah, Al, 34) ^ _u64_js_1.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = _u64_js_1.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = _u64_js_1.default.add3L(T1l, sigma0l, MAJl);
            Ah = _u64_js_1.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = _u64_js_1.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = _u64_js_1.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = _u64_js_1.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = _u64_js_1.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = _u64_js_1.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = _u64_js_1.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = _u64_js_1.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = _u64_js_1.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        SHA512_W_H.fill(0);
        SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
exports.SHA512 = SHA512;
class SHA512_224 extends SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class SHA512_256 extends SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class SHA384 extends SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
exports.sha512 = (0, utils_js_1.wrapConstructor)(()=>new SHA512());
exports.sha512_224 = (0, utils_js_1.wrapConstructor)(()=>new SHA512_224());
exports.sha512_256 = (0, utils_js_1.wrapConstructor)(()=>new SHA512_256());
exports.sha384 = (0, utils_js_1.wrapConstructor)(()=>new SHA384());

},{"de63277d4b9ab571":"e7KCv","eda9289ed6a1f5f2":"b1VgT","f18acd6c798648cc":"2YjGZ"}],"b1VgT":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.add5L = exports.add5H = exports.add4H = exports.add4L = exports.add3H = exports.add3L = exports.add = exports.rotlBL = exports.rotlBH = exports.rotlSL = exports.rotlSH = exports.rotr32L = exports.rotr32H = exports.rotrBL = exports.rotrBH = exports.rotrSL = exports.rotrSH = exports.shrSL = exports.shrSH = exports.toBig = exports.split = exports.fromBig = void 0;
const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const _32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function fromBig(n, le = false) {
    if (le) return {
        h: Number(n & U32_MASK64),
        l: Number(n >> _32n & U32_MASK64)
    };
    return {
        h: Number(n >> _32n & U32_MASK64) | 0,
        l: Number(n & U32_MASK64) | 0
    };
}
exports.fromBig = fromBig;
function split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h, l } = fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
exports.split = split;
const toBig = (h, l)=>BigInt(h >>> 0) << _32n | BigInt(l >>> 0);
exports.toBig = toBig;
// for Shift in [0, 32)
const shrSH = (h, _l, s)=>h >>> s;
exports.shrSH = shrSH;
const shrSL = (h, l, s)=>h << 32 - s | l >>> s;
exports.shrSL = shrSL;
// Right rotate for Shift in [1, 32)
const rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
exports.rotrSH = rotrSH;
const rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
exports.rotrSL = rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
exports.rotrBH = rotrBH;
const rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
exports.rotrBL = rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const rotr32H = (_h, l)=>l;
exports.rotr32H = rotr32H;
const rotr32L = (h, _l)=>h;
exports.rotr32L = rotr32L;
// Left rotate for Shift in [1, 32)
const rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
exports.rotlSH = rotlSH;
const rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
exports.rotlSL = rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
exports.rotlBH = rotlBH;
const rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
exports.rotlBL = rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
exports.add = add;
// Addition with more than 2 elements
const add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
exports.add3L = add3L;
const add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
exports.add3H = add3H;
const add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
exports.add4L = add4L;
const add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
exports.add4H = add4H;
const add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
exports.add5L = add5L;
const add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
exports.add5H = add5H;
// prettier-ignore
const u64 = {
    fromBig,
    split,
    toBig,
    shrSH,
    shrSL,
    rotrSH,
    rotrSL,
    rotrBH,
    rotrBL,
    rotr32H,
    rotr32L,
    rotlSH,
    rotlSL,
    rotlBH,
    rotlBL,
    add,
    add3L,
    add3H,
    add4L,
    add4H,
    add5H,
    add5L
};
exports.default = u64;

},{}],"8A9ZH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pbkdf2Async = exports.pbkdf2 = void 0;
const _assert_js_1 = require("fbef50acc9ab07d9");
const hmac_js_1 = require("956a90fd4950a619");
const utils_js_1 = require("704e31af7d37dfd5");
// Common prologue and epilogue for sync/async functions
function pbkdf2Init(hash, _password, _salt, _opts) {
    (0, _assert_js_1.hash)(hash);
    const opts = (0, utils_js_1.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c, dkLen, asyncTick } = opts;
    (0, _assert_js_1.number)(c);
    (0, _assert_js_1.number)(dkLen);
    (0, _assert_js_1.number)(asyncTick);
    if (c < 1) throw new Error('PBKDF2: iterations (c) should be >= 1');
    const password = (0, utils_js_1.toBytes)(_password);
    const salt = (0, utils_js_1.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = hmac_js_1.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c,
        dkLen,
        asyncTick,
        DK,
        PRF,
        PRFSalt
    };
}
function pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function pbkdf2(hash, password, salt, opts) {
    const { c, dkLen, DK, PRF, PRFSalt } = pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, utils_js_1.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
exports.pbkdf2 = pbkdf2;
async function pbkdf2Async(hash, password, salt, opts) {
    const { c, dkLen, asyncTick, DK, PRF, PRFSalt } = pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, utils_js_1.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, utils_js_1.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
exports.pbkdf2Async = pbkdf2Async;

},{"fbef50acc9ab07d9":"7eSSE","956a90fd4950a619":"iQWkY","704e31af7d37dfd5":"2YjGZ"}],"iQWkY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hmac = exports.HMAC = void 0;
const _assert_js_1 = require("88de570f0f701cc6");
const utils_js_1 = require("337359ae358d0fc");
// HMAC (RFC 2104)
class HMAC extends utils_js_1.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, _assert_js_1.hash)(hash);
        const key = (0, utils_js_1.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== 'function') throw new Error('Expected instance of class which extends utils.Hash');
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, _assert_js_1.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, _assert_js_1.exists)(this);
        (0, _assert_js_1.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash, iHash, finished, destroyed, blockLen, outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
exports.HMAC = HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const hmac = (hash, key, message)=>new HMAC(hash, key).update(message).digest();
exports.hmac = hmac;
exports.hmac.create = (hash, key)=>new HMAC(hash, key);

},{"88de570f0f701cc6":"7eSSE","337359ae358d0fc":"2YjGZ"}],"dgJ4H":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
// browserify by default only pulls in files that are hard coded in requires
// In order of last to first in this file, the default wordlist will be chosen
// based on what is present. (Bundles may remove wordlists they don't need)
const wordlists = {};
exports.wordlists = wordlists;
let _default;
exports._default = _default;
try {
    exports._default = _default = require("ff3f03d3fc43a6ce");
    wordlists.czech = _default;
} catch (err) {}
try {
    exports._default = _default = require("7e65066f2c672ad9");
    wordlists.chinese_simplified = _default;
} catch (err) {}
try {
    exports._default = _default = require("f5f37ba865037007");
    wordlists.chinese_traditional = _default;
} catch (err) {}
try {
    exports._default = _default = require("c7936e26193bfc08");
    wordlists.korean = _default;
} catch (err) {}
try {
    exports._default = _default = require("8162a10bcd0e099");
    wordlists.french = _default;
} catch (err) {}
try {
    exports._default = _default = require("9f2c4ed1777f7a2c");
    wordlists.italian = _default;
} catch (err) {}
try {
    exports._default = _default = require("a676371ce1b1a251");
    wordlists.spanish = _default;
} catch (err) {}
try {
    exports._default = _default = require("622c4295116a42ea");
    wordlists.japanese = _default;
    wordlists.JA = _default;
} catch (err) {}
try {
    exports._default = _default = require("7f2d986dc6b2cd78");
    wordlists.portuguese = _default;
} catch (err) {}
try {
    exports._default = _default = require("b3d0157140a0c238");
    wordlists.english = _default;
    wordlists.EN = _default;
} catch (err) {}

},{"ff3f03d3fc43a6ce":"8CQrS","7e65066f2c672ad9":"2qf6L","f5f37ba865037007":"4RmOe","c7936e26193bfc08":"5UaH2","8162a10bcd0e099":"maGKf","9f2c4ed1777f7a2c":"llrLD","a676371ce1b1a251":"4kHFs","622c4295116a42ea":"e2fnl","7f2d986dc6b2cd78":"N7qWy","b3d0157140a0c238":"9GDjG"}],"8CQrS":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("[\"abdikace\",\"abeceda\",\"adresa\",\"agrese\",\"akce\",\"aktovka\",\"alej\",\"alkohol\",\"amputace\",\"ananas\",\"andulka\",\"anekdota\",\"anketa\",\"antika\",\"anulovat\",\"archa\",\"arogance\",\"asfalt\",\"asistent\",\"aspirace\",\"astma\",\"astronom\",\"atlas\",\"atletika\",\"atol\",\"autobus\",\"azyl\",\"babka\",\"bachor\",\"bacil\",\"baculka\",\"badatel\",\"bageta\",\"bagr\",\"bahno\",\"bakterie\",\"balada\",\"baletka\",\"balkon\",\"balonek\",\"balvan\",\"balza\",\"bambus\",\"bankomat\",\"barbar\",\"baret\",\"barman\",\"baroko\",\"barva\",\"baterka\",\"batoh\",\"bavlna\",\"bazalka\",\"bazilika\",\"bazuka\",\"bedna\",\"beran\",\"beseda\",\"bestie\",\"beton\",\"bezinka\",\"bezmoc\",\"beztak\",\"bicykl\",\"bidlo\",\"biftek\",\"bikiny\",\"bilance\",\"biograf\",\"biolog\",\"bitva\",\"bizon\",\"blahobyt\",\"blatouch\",\"blecha\",\"bledule\",\"blesk\",\"blikat\",\"blizna\",\"blokovat\",\"bloudit\",\"blud\",\"bobek\",\"bobr\",\"bodlina\",\"bodnout\",\"bohatost\",\"bojkot\",\"bojovat\",\"bokorys\",\"bolest\",\"borec\",\"borovice\",\"bota\",\"boubel\",\"bouchat\",\"bouda\",\"boule\",\"bourat\",\"boxer\",\"bradavka\",\"brambora\",\"branka\",\"bratr\",\"brepta\",\"briketa\",\"brko\",\"brloh\",\"bronz\",\"broskev\",\"brunetka\",\"brusinka\",\"brzda\",\"brzy\",\"bublina\",\"bubnovat\",\"buchta\",\"buditel\",\"budka\",\"budova\",\"bufet\",\"bujarost\",\"bukvice\",\"buldok\",\"bulva\",\"bunda\",\"bunkr\",\"burza\",\"butik\",\"buvol\",\"buzola\",\"bydlet\",\"bylina\",\"bytovka\",\"bzukot\",\"capart\",\"carevna\",\"cedr\",\"cedule\",\"cejch\",\"cejn\",\"cela\",\"celer\",\"celkem\",\"celnice\",\"cenina\",\"cennost\",\"cenovka\",\"centrum\",\"cenzor\",\"cestopis\",\"cetka\",\"chalupa\",\"chapadlo\",\"charita\",\"chata\",\"chechtat\",\"chemie\",\"chichot\",\"chirurg\",\"chlad\",\"chleba\",\"chlubit\",\"chmel\",\"chmura\",\"chobot\",\"chochol\",\"chodba\",\"cholera\",\"chomout\",\"chopit\",\"choroba\",\"chov\",\"chrapot\",\"chrlit\",\"chrt\",\"chrup\",\"chtivost\",\"chudina\",\"chutnat\",\"chvat\",\"chvilka\",\"chvost\",\"chyba\",\"chystat\",\"chytit\",\"cibule\",\"cigareta\",\"cihelna\",\"cihla\",\"cinkot\",\"cirkus\",\"cisterna\",\"citace\",\"citrus\",\"cizinec\",\"cizost\",\"clona\",\"cokoliv\",\"couvat\",\"ctitel\",\"ctnost\",\"cudnost\",\"cuketa\",\"cukr\",\"cupot\",\"cvaknout\",\"cval\",\"cvik\",\"cvrkot\",\"cyklista\",\"daleko\",\"dareba\",\"datel\",\"datum\",\"dcera\",\"debata\",\"dechovka\",\"decibel\",\"deficit\",\"deflace\",\"dekl\",\"dekret\",\"demokrat\",\"deprese\",\"derby\",\"deska\",\"detektiv\",\"dikobraz\",\"diktovat\",\"dioda\",\"diplom\",\"disk\",\"displej\",\"divadlo\",\"divoch\",\"dlaha\",\"dlouho\",\"dluhopis\",\"dnes\",\"dobro\",\"dobytek\",\"docent\",\"dochutit\",\"dodnes\",\"dohled\",\"dohoda\",\"dohra\",\"dojem\",\"dojnice\",\"doklad\",\"dokola\",\"doktor\",\"dokument\",\"dolar\",\"doleva\",\"dolina\",\"doma\",\"dominant\",\"domluvit\",\"domov\",\"donutit\",\"dopad\",\"dopis\",\"doplnit\",\"doposud\",\"doprovod\",\"dopustit\",\"dorazit\",\"dorost\",\"dort\",\"dosah\",\"doslov\",\"dostatek\",\"dosud\",\"dosyta\",\"dotaz\",\"dotek\",\"dotknout\",\"doufat\",\"doutnat\",\"dovozce\",\"dozadu\",\"doznat\",\"dozorce\",\"drahota\",\"drak\",\"dramatik\",\"dravec\",\"draze\",\"drdol\",\"drobnost\",\"drogerie\",\"drozd\",\"drsnost\",\"drtit\",\"drzost\",\"duben\",\"duchovno\",\"dudek\",\"duha\",\"duhovka\",\"dusit\",\"dusno\",\"dutost\",\"dvojice\",\"dvorec\",\"dynamit\",\"ekolog\",\"ekonomie\",\"elektron\",\"elipsa\",\"email\",\"emise\",\"emoce\",\"empatie\",\"epizoda\",\"epocha\",\"epopej\",\"epos\",\"esej\",\"esence\",\"eskorta\",\"eskymo\",\"etiketa\",\"euforie\",\"evoluce\",\"exekuce\",\"exkurze\",\"expedice\",\"exploze\",\"export\",\"extrakt\",\"facka\",\"fajfka\",\"fakulta\",\"fanatik\",\"fantazie\",\"farmacie\",\"favorit\",\"fazole\",\"federace\",\"fejeton\",\"fenka\",\"fialka\",\"figurant\",\"filozof\",\"filtr\",\"finance\",\"finta\",\"fixace\",\"fjord\",\"flanel\",\"flirt\",\"flotila\",\"fond\",\"fosfor\",\"fotbal\",\"fotka\",\"foton\",\"frakce\",\"freska\",\"fronta\",\"fukar\",\"funkce\",\"fyzika\",\"galeje\",\"garant\",\"genetika\",\"geolog\",\"gilotina\",\"glazura\",\"glejt\",\"golem\",\"golfista\",\"gotika\",\"graf\",\"gramofon\",\"granule\",\"grep\",\"gril\",\"grog\",\"groteska\",\"guma\",\"hadice\",\"hadr\",\"hala\",\"halenka\",\"hanba\",\"hanopis\",\"harfa\",\"harpuna\",\"havran\",\"hebkost\",\"hejkal\",\"hejno\",\"hejtman\",\"hektar\",\"helma\",\"hematom\",\"herec\",\"herna\",\"heslo\",\"hezky\",\"historik\",\"hladovka\",\"hlasivky\",\"hlava\",\"hledat\",\"hlen\",\"hlodavec\",\"hloh\",\"hloupost\",\"hltat\",\"hlubina\",\"hluchota\",\"hmat\",\"hmota\",\"hmyz\",\"hnis\",\"hnojivo\",\"hnout\",\"hoblina\",\"hoboj\",\"hoch\",\"hodiny\",\"hodlat\",\"hodnota\",\"hodovat\",\"hojnost\",\"hokej\",\"holinka\",\"holka\",\"holub\",\"homole\",\"honitba\",\"honorace\",\"horal\",\"horda\",\"horizont\",\"horko\",\"horlivec\",\"hormon\",\"hornina\",\"horoskop\",\"horstvo\",\"hospoda\",\"hostina\",\"hotovost\",\"houba\",\"houf\",\"houpat\",\"houska\",\"hovor\",\"hradba\",\"hranice\",\"hravost\",\"hrazda\",\"hrbolek\",\"hrdina\",\"hrdlo\",\"hrdost\",\"hrnek\",\"hrobka\",\"hromada\",\"hrot\",\"hrouda\",\"hrozen\",\"hrstka\",\"hrubost\",\"hryzat\",\"hubenost\",\"hubnout\",\"hudba\",\"hukot\",\"humr\",\"husita\",\"hustota\",\"hvozd\",\"hybnost\",\"hydrant\",\"hygiena\",\"hymna\",\"hysterik\",\"idylka\",\"ihned\",\"ikona\",\"iluze\",\"imunita\",\"infekce\",\"inflace\",\"inkaso\",\"inovace\",\"inspekce\",\"internet\",\"invalida\",\"investor\",\"inzerce\",\"ironie\",\"jablko\",\"jachta\",\"jahoda\",\"jakmile\",\"jakost\",\"jalovec\",\"jantar\",\"jarmark\",\"jaro\",\"jasan\",\"jasno\",\"jatka\",\"javor\",\"jazyk\",\"jedinec\",\"jedle\",\"jednatel\",\"jehlan\",\"jekot\",\"jelen\",\"jelito\",\"jemnost\",\"jenom\",\"jepice\",\"jeseter\",\"jevit\",\"jezdec\",\"jezero\",\"jinak\",\"jindy\",\"jinoch\",\"jiskra\",\"jistota\",\"jitrnice\",\"jizva\",\"jmenovat\",\"jogurt\",\"jurta\",\"kabaret\",\"kabel\",\"kabinet\",\"kachna\",\"kadet\",\"kadidlo\",\"kahan\",\"kajak\",\"kajuta\",\"kakao\",\"kaktus\",\"kalamita\",\"kalhoty\",\"kalibr\",\"kalnost\",\"kamera\",\"kamkoliv\",\"kamna\",\"kanibal\",\"kanoe\",\"kantor\",\"kapalina\",\"kapela\",\"kapitola\",\"kapka\",\"kaple\",\"kapota\",\"kapr\",\"kapusta\",\"kapybara\",\"karamel\",\"karotka\",\"karton\",\"kasa\",\"katalog\",\"katedra\",\"kauce\",\"kauza\",\"kavalec\",\"kazajka\",\"kazeta\",\"kazivost\",\"kdekoliv\",\"kdesi\",\"kedluben\",\"kemp\",\"keramika\",\"kino\",\"klacek\",\"kladivo\",\"klam\",\"klapot\",\"klasika\",\"klaun\",\"klec\",\"klenba\",\"klepat\",\"klesnout\",\"klid\",\"klima\",\"klisna\",\"klobouk\",\"klokan\",\"klopa\",\"kloub\",\"klubovna\",\"klusat\",\"kluzkost\",\"kmen\",\"kmitat\",\"kmotr\",\"kniha\",\"knot\",\"koalice\",\"koberec\",\"kobka\",\"kobliha\",\"kobyla\",\"kocour\",\"kohout\",\"kojenec\",\"kokos\",\"koktejl\",\"kolaps\",\"koleda\",\"kolize\",\"kolo\",\"komando\",\"kometa\",\"komik\",\"komnata\",\"komora\",\"kompas\",\"komunita\",\"konat\",\"koncept\",\"kondice\",\"konec\",\"konfese\",\"kongres\",\"konina\",\"konkurs\",\"kontakt\",\"konzerva\",\"kopanec\",\"kopie\",\"kopnout\",\"koprovka\",\"korbel\",\"korektor\",\"kormidlo\",\"koroptev\",\"korpus\",\"koruna\",\"koryto\",\"korzet\",\"kosatec\",\"kostka\",\"kotel\",\"kotleta\",\"kotoul\",\"koukat\",\"koupelna\",\"kousek\",\"kouzlo\",\"kovboj\",\"koza\",\"kozoroh\",\"krabice\",\"krach\",\"krajina\",\"kralovat\",\"krasopis\",\"kravata\",\"kredit\",\"krejcar\",\"kresba\",\"kreveta\",\"kriket\",\"kritik\",\"krize\",\"krkavec\",\"krmelec\",\"krmivo\",\"krocan\",\"krok\",\"kronika\",\"kropit\",\"kroupa\",\"krovka\",\"krtek\",\"kruhadlo\",\"krupice\",\"krutost\",\"krvinka\",\"krychle\",\"krypta\",\"krystal\",\"kryt\",\"kudlanka\",\"kufr\",\"kujnost\",\"kukla\",\"kulajda\",\"kulich\",\"kulka\",\"kulomet\",\"kultura\",\"kuna\",\"kupodivu\",\"kurt\",\"kurzor\",\"kutil\",\"kvalita\",\"kvasinka\",\"kvestor\",\"kynolog\",\"kyselina\",\"kytara\",\"kytice\",\"kytka\",\"kytovec\",\"kyvadlo\",\"labrador\",\"lachtan\",\"ladnost\",\"laik\",\"lakomec\",\"lamela\",\"lampa\",\"lanovka\",\"lasice\",\"laso\",\"lastura\",\"latinka\",\"lavina\",\"lebka\",\"leckdy\",\"leden\",\"lednice\",\"ledovka\",\"ledvina\",\"legenda\",\"legie\",\"legrace\",\"lehce\",\"lehkost\",\"lehnout\",\"lektvar\",\"lenochod\",\"lentilka\",\"lepenka\",\"lepidlo\",\"letadlo\",\"letec\",\"letmo\",\"letokruh\",\"levhart\",\"levitace\",\"levobok\",\"libra\",\"lichotka\",\"lidojed\",\"lidskost\",\"lihovina\",\"lijavec\",\"lilek\",\"limetka\",\"linie\",\"linka\",\"linoleum\",\"listopad\",\"litina\",\"litovat\",\"lobista\",\"lodivod\",\"logika\",\"logoped\",\"lokalita\",\"loket\",\"lomcovat\",\"lopata\",\"lopuch\",\"lord\",\"losos\",\"lotr\",\"loudal\",\"louh\",\"louka\",\"louskat\",\"lovec\",\"lstivost\",\"lucerna\",\"lucifer\",\"lump\",\"lusk\",\"lustrace\",\"lvice\",\"lyra\",\"lyrika\",\"lysina\",\"madam\",\"madlo\",\"magistr\",\"mahagon\",\"majetek\",\"majitel\",\"majorita\",\"makak\",\"makovice\",\"makrela\",\"malba\",\"malina\",\"malovat\",\"malvice\",\"maminka\",\"mandle\",\"manko\",\"marnost\",\"masakr\",\"maskot\",\"masopust\",\"matice\",\"matrika\",\"maturita\",\"mazanec\",\"mazivo\",\"mazlit\",\"mazurka\",\"mdloba\",\"mechanik\",\"meditace\",\"medovina\",\"melasa\",\"meloun\",\"mentolka\",\"metla\",\"metoda\",\"metr\",\"mezera\",\"migrace\",\"mihnout\",\"mihule\",\"mikina\",\"mikrofon\",\"milenec\",\"milimetr\",\"milost\",\"mimika\",\"mincovna\",\"minibar\",\"minomet\",\"minulost\",\"miska\",\"mistr\",\"mixovat\",\"mladost\",\"mlha\",\"mlhovina\",\"mlok\",\"mlsat\",\"mluvit\",\"mnich\",\"mnohem\",\"mobil\",\"mocnost\",\"modelka\",\"modlitba\",\"mohyla\",\"mokro\",\"molekula\",\"momentka\",\"monarcha\",\"monokl\",\"monstrum\",\"montovat\",\"monzun\",\"mosaz\",\"moskyt\",\"most\",\"motivace\",\"motorka\",\"motyka\",\"moucha\",\"moudrost\",\"mozaika\",\"mozek\",\"mozol\",\"mramor\",\"mravenec\",\"mrkev\",\"mrtvola\",\"mrzet\",\"mrzutost\",\"mstitel\",\"mudrc\",\"muflon\",\"mulat\",\"mumie\",\"munice\",\"muset\",\"mutace\",\"muzeum\",\"muzikant\",\"myslivec\",\"mzda\",\"nabourat\",\"nachytat\",\"nadace\",\"nadbytek\",\"nadhoz\",\"nadobro\",\"nadpis\",\"nahlas\",\"nahnat\",\"nahodile\",\"nahradit\",\"naivita\",\"najednou\",\"najisto\",\"najmout\",\"naklonit\",\"nakonec\",\"nakrmit\",\"nalevo\",\"namazat\",\"namluvit\",\"nanometr\",\"naoko\",\"naopak\",\"naostro\",\"napadat\",\"napevno\",\"naplnit\",\"napnout\",\"naposled\",\"naprosto\",\"narodit\",\"naruby\",\"narychlo\",\"nasadit\",\"nasekat\",\"naslepo\",\"nastat\",\"natolik\",\"navenek\",\"navrch\",\"navzdory\",\"nazvat\",\"nebe\",\"nechat\",\"necky\",\"nedaleko\",\"nedbat\",\"neduh\",\"negace\",\"nehet\",\"nehoda\",\"nejen\",\"nejprve\",\"neklid\",\"nelibost\",\"nemilost\",\"nemoc\",\"neochota\",\"neonka\",\"nepokoj\",\"nerost\",\"nerv\",\"nesmysl\",\"nesoulad\",\"netvor\",\"neuron\",\"nevina\",\"nezvykle\",\"nicota\",\"nijak\",\"nikam\",\"nikdy\",\"nikl\",\"nikterak\",\"nitro\",\"nocleh\",\"nohavice\",\"nominace\",\"nora\",\"norek\",\"nositel\",\"nosnost\",\"nouze\",\"noviny\",\"novota\",\"nozdra\",\"nuda\",\"nudle\",\"nuget\",\"nutit\",\"nutnost\",\"nutrie\",\"nymfa\",\"obal\",\"obarvit\",\"obava\",\"obdiv\",\"obec\",\"obehnat\",\"obejmout\",\"obezita\",\"obhajoba\",\"obilnice\",\"objasnit\",\"objekt\",\"obklopit\",\"oblast\",\"oblek\",\"obliba\",\"obloha\",\"obluda\",\"obnos\",\"obohatit\",\"obojek\",\"obout\",\"obrazec\",\"obrna\",\"obruba\",\"obrys\",\"obsah\",\"obsluha\",\"obstarat\",\"obuv\",\"obvaz\",\"obvinit\",\"obvod\",\"obvykle\",\"obyvatel\",\"obzor\",\"ocas\",\"ocel\",\"ocenit\",\"ochladit\",\"ochota\",\"ochrana\",\"ocitnout\",\"odboj\",\"odbyt\",\"odchod\",\"odcizit\",\"odebrat\",\"odeslat\",\"odevzdat\",\"odezva\",\"odhadce\",\"odhodit\",\"odjet\",\"odjinud\",\"odkaz\",\"odkoupit\",\"odliv\",\"odluka\",\"odmlka\",\"odolnost\",\"odpad\",\"odpis\",\"odplout\",\"odpor\",\"odpustit\",\"odpykat\",\"odrazka\",\"odsoudit\",\"odstup\",\"odsun\",\"odtok\",\"odtud\",\"odvaha\",\"odveta\",\"odvolat\",\"odvracet\",\"odznak\",\"ofina\",\"ofsajd\",\"ohlas\",\"ohnisko\",\"ohrada\",\"ohrozit\",\"ohryzek\",\"okap\",\"okenice\",\"oklika\",\"okno\",\"okouzlit\",\"okovy\",\"okrasa\",\"okres\",\"okrsek\",\"okruh\",\"okupant\",\"okurka\",\"okusit\",\"olejnina\",\"olizovat\",\"omak\",\"omeleta\",\"omezit\",\"omladina\",\"omlouvat\",\"omluva\",\"omyl\",\"onehdy\",\"opakovat\",\"opasek\",\"operace\",\"opice\",\"opilost\",\"opisovat\",\"opora\",\"opozice\",\"opravdu\",\"oproti\",\"orbital\",\"orchestr\",\"orgie\",\"orlice\",\"orloj\",\"ortel\",\"osada\",\"oschnout\",\"osika\",\"osivo\",\"oslava\",\"oslepit\",\"oslnit\",\"oslovit\",\"osnova\",\"osoba\",\"osolit\",\"ospalec\",\"osten\",\"ostraha\",\"ostuda\",\"ostych\",\"osvojit\",\"oteplit\",\"otisk\",\"otop\",\"otrhat\",\"otrlost\",\"otrok\",\"otruby\",\"otvor\",\"ovanout\",\"ovar\",\"oves\",\"ovlivnit\",\"ovoce\",\"oxid\",\"ozdoba\",\"pachatel\",\"pacient\",\"padouch\",\"pahorek\",\"pakt\",\"palanda\",\"palec\",\"palivo\",\"paluba\",\"pamflet\",\"pamlsek\",\"panenka\",\"panika\",\"panna\",\"panovat\",\"panstvo\",\"pantofle\",\"paprika\",\"parketa\",\"parodie\",\"parta\",\"paruka\",\"paryba\",\"paseka\",\"pasivita\",\"pastelka\",\"patent\",\"patrona\",\"pavouk\",\"pazneht\",\"pazourek\",\"pecka\",\"pedagog\",\"pejsek\",\"peklo\",\"peloton\",\"penalta\",\"pendrek\",\"penze\",\"periskop\",\"pero\",\"pestrost\",\"petarda\",\"petice\",\"petrolej\",\"pevnina\",\"pexeso\",\"pianista\",\"piha\",\"pijavice\",\"pikle\",\"piknik\",\"pilina\",\"pilnost\",\"pilulka\",\"pinzeta\",\"pipeta\",\"pisatel\",\"pistole\",\"pitevna\",\"pivnice\",\"pivovar\",\"placenta\",\"plakat\",\"plamen\",\"planeta\",\"plastika\",\"platit\",\"plavidlo\",\"plaz\",\"plech\",\"plemeno\",\"plenta\",\"ples\",\"pletivo\",\"plevel\",\"plivat\",\"plnit\",\"plno\",\"plocha\",\"plodina\",\"plomba\",\"plout\",\"pluk\",\"plyn\",\"pobavit\",\"pobyt\",\"pochod\",\"pocit\",\"poctivec\",\"podat\",\"podcenit\",\"podepsat\",\"podhled\",\"podivit\",\"podklad\",\"podmanit\",\"podnik\",\"podoba\",\"podpora\",\"podraz\",\"podstata\",\"podvod\",\"podzim\",\"poezie\",\"pohanka\",\"pohnutka\",\"pohovor\",\"pohroma\",\"pohyb\",\"pointa\",\"pojistka\",\"pojmout\",\"pokazit\",\"pokles\",\"pokoj\",\"pokrok\",\"pokuta\",\"pokyn\",\"poledne\",\"polibek\",\"polknout\",\"poloha\",\"polynom\",\"pomalu\",\"pominout\",\"pomlka\",\"pomoc\",\"pomsta\",\"pomyslet\",\"ponechat\",\"ponorka\",\"ponurost\",\"popadat\",\"popel\",\"popisek\",\"poplach\",\"poprosit\",\"popsat\",\"popud\",\"poradce\",\"porce\",\"porod\",\"porucha\",\"poryv\",\"posadit\",\"posed\",\"posila\",\"poskok\",\"poslanec\",\"posoudit\",\"pospolu\",\"postava\",\"posudek\",\"posyp\",\"potah\",\"potkan\",\"potlesk\",\"potomek\",\"potrava\",\"potupa\",\"potvora\",\"poukaz\",\"pouto\",\"pouzdro\",\"povaha\",\"povidla\",\"povlak\",\"povoz\",\"povrch\",\"povstat\",\"povyk\",\"povzdech\",\"pozdrav\",\"pozemek\",\"poznatek\",\"pozor\",\"pozvat\",\"pracovat\",\"prahory\",\"praktika\",\"prales\",\"praotec\",\"praporek\",\"prase\",\"pravda\",\"princip\",\"prkno\",\"probudit\",\"procento\",\"prodej\",\"profese\",\"prohra\",\"projekt\",\"prolomit\",\"promile\",\"pronikat\",\"propad\",\"prorok\",\"prosba\",\"proton\",\"proutek\",\"provaz\",\"prskavka\",\"prsten\",\"prudkost\",\"prut\",\"prvek\",\"prvohory\",\"psanec\",\"psovod\",\"pstruh\",\"ptactvo\",\"puberta\",\"puch\",\"pudl\",\"pukavec\",\"puklina\",\"pukrle\",\"pult\",\"pumpa\",\"punc\",\"pupen\",\"pusa\",\"pusinka\",\"pustina\",\"putovat\",\"putyka\",\"pyramida\",\"pysk\",\"pytel\",\"racek\",\"rachot\",\"radiace\",\"radnice\",\"radon\",\"raft\",\"ragby\",\"raketa\",\"rakovina\",\"rameno\",\"rampouch\",\"rande\",\"rarach\",\"rarita\",\"rasovna\",\"rastr\",\"ratolest\",\"razance\",\"razidlo\",\"reagovat\",\"reakce\",\"recept\",\"redaktor\",\"referent\",\"reflex\",\"rejnok\",\"reklama\",\"rekord\",\"rekrut\",\"rektor\",\"reputace\",\"revize\",\"revma\",\"revolver\",\"rezerva\",\"riskovat\",\"riziko\",\"robotika\",\"rodokmen\",\"rohovka\",\"rokle\",\"rokoko\",\"romaneto\",\"ropovod\",\"ropucha\",\"rorejs\",\"rosol\",\"rostlina\",\"rotmistr\",\"rotoped\",\"rotunda\",\"roubenka\",\"roucho\",\"roup\",\"roura\",\"rovina\",\"rovnice\",\"rozbor\",\"rozchod\",\"rozdat\",\"rozeznat\",\"rozhodce\",\"rozinka\",\"rozjezd\",\"rozkaz\",\"rozloha\",\"rozmar\",\"rozpad\",\"rozruch\",\"rozsah\",\"roztok\",\"rozum\",\"rozvod\",\"rubrika\",\"ruchadlo\",\"rukavice\",\"rukopis\",\"ryba\",\"rybolov\",\"rychlost\",\"rydlo\",\"rypadlo\",\"rytina\",\"ryzost\",\"sadista\",\"sahat\",\"sako\",\"samec\",\"samizdat\",\"samota\",\"sanitka\",\"sardinka\",\"sasanka\",\"satelit\",\"sazba\",\"sazenice\",\"sbor\",\"schovat\",\"sebranka\",\"secese\",\"sedadlo\",\"sediment\",\"sedlo\",\"sehnat\",\"sejmout\",\"sekera\",\"sekta\",\"sekunda\",\"sekvoje\",\"semeno\",\"seno\",\"servis\",\"sesadit\",\"seshora\",\"seskok\",\"seslat\",\"sestra\",\"sesuv\",\"sesypat\",\"setba\",\"setina\",\"setkat\",\"setnout\",\"setrvat\",\"sever\",\"seznam\",\"shoda\",\"shrnout\",\"sifon\",\"silnice\",\"sirka\",\"sirotek\",\"sirup\",\"situace\",\"skafandr\",\"skalisko\",\"skanzen\",\"skaut\",\"skeptik\",\"skica\",\"skladba\",\"sklenice\",\"sklo\",\"skluz\",\"skoba\",\"skokan\",\"skoro\",\"skripta\",\"skrz\",\"skupina\",\"skvost\",\"skvrna\",\"slabika\",\"sladidlo\",\"slanina\",\"slast\",\"slavnost\",\"sledovat\",\"slepec\",\"sleva\",\"slezina\",\"slib\",\"slina\",\"sliznice\",\"slon\",\"sloupek\",\"slovo\",\"sluch\",\"sluha\",\"slunce\",\"slupka\",\"slza\",\"smaragd\",\"smetana\",\"smilstvo\",\"smlouva\",\"smog\",\"smrad\",\"smrk\",\"smrtka\",\"smutek\",\"smysl\",\"snad\",\"snaha\",\"snob\",\"sobota\",\"socha\",\"sodovka\",\"sokol\",\"sopka\",\"sotva\",\"souboj\",\"soucit\",\"soudce\",\"souhlas\",\"soulad\",\"soumrak\",\"souprava\",\"soused\",\"soutok\",\"souviset\",\"spalovna\",\"spasitel\",\"spis\",\"splav\",\"spodek\",\"spojenec\",\"spolu\",\"sponzor\",\"spornost\",\"spousta\",\"sprcha\",\"spustit\",\"sranda\",\"sraz\",\"srdce\",\"srna\",\"srnec\",\"srovnat\",\"srpen\",\"srst\",\"srub\",\"stanice\",\"starosta\",\"statika\",\"stavba\",\"stehno\",\"stezka\",\"stodola\",\"stolek\",\"stopa\",\"storno\",\"stoupat\",\"strach\",\"stres\",\"strhnout\",\"strom\",\"struna\",\"studna\",\"stupnice\",\"stvol\",\"styk\",\"subjekt\",\"subtropy\",\"suchar\",\"sudost\",\"sukno\",\"sundat\",\"sunout\",\"surikata\",\"surovina\",\"svah\",\"svalstvo\",\"svetr\",\"svatba\",\"svazek\",\"svisle\",\"svitek\",\"svoboda\",\"svodidlo\",\"svorka\",\"svrab\",\"sykavka\",\"sykot\",\"synek\",\"synovec\",\"sypat\",\"sypkost\",\"syrovost\",\"sysel\",\"sytost\",\"tabletka\",\"tabule\",\"tahoun\",\"tajemno\",\"tajfun\",\"tajga\",\"tajit\",\"tajnost\",\"taktika\",\"tamhle\",\"tampon\",\"tancovat\",\"tanec\",\"tanker\",\"tapeta\",\"tavenina\",\"tazatel\",\"technika\",\"tehdy\",\"tekutina\",\"telefon\",\"temnota\",\"tendence\",\"tenista\",\"tenor\",\"teplota\",\"tepna\",\"teprve\",\"terapie\",\"termoska\",\"textil\",\"ticho\",\"tiskopis\",\"titulek\",\"tkadlec\",\"tkanina\",\"tlapka\",\"tleskat\",\"tlukot\",\"tlupa\",\"tmel\",\"toaleta\",\"topinka\",\"topol\",\"torzo\",\"touha\",\"toulec\",\"tradice\",\"traktor\",\"tramp\",\"trasa\",\"traverza\",\"trefit\",\"trest\",\"trezor\",\"trhavina\",\"trhlina\",\"trochu\",\"trojice\",\"troska\",\"trouba\",\"trpce\",\"trpitel\",\"trpkost\",\"trubec\",\"truchlit\",\"truhlice\",\"trus\",\"trvat\",\"tudy\",\"tuhnout\",\"tuhost\",\"tundra\",\"turista\",\"turnaj\",\"tuzemsko\",\"tvaroh\",\"tvorba\",\"tvrdost\",\"tvrz\",\"tygr\",\"tykev\",\"ubohost\",\"uboze\",\"ubrat\",\"ubrousek\",\"ubrus\",\"ubytovna\",\"ucho\",\"uctivost\",\"udivit\",\"uhradit\",\"ujednat\",\"ujistit\",\"ujmout\",\"ukazatel\",\"uklidnit\",\"uklonit\",\"ukotvit\",\"ukrojit\",\"ulice\",\"ulita\",\"ulovit\",\"umyvadlo\",\"unavit\",\"uniforma\",\"uniknout\",\"upadnout\",\"uplatnit\",\"uplynout\",\"upoutat\",\"upravit\",\"uran\",\"urazit\",\"usednout\",\"usilovat\",\"usmrtit\",\"usnadnit\",\"usnout\",\"usoudit\",\"ustlat\",\"ustrnout\",\"utahovat\",\"utkat\",\"utlumit\",\"utonout\",\"utopenec\",\"utrousit\",\"uvalit\",\"uvolnit\",\"uvozovka\",\"uzdravit\",\"uzel\",\"uzenina\",\"uzlina\",\"uznat\",\"vagon\",\"valcha\",\"valoun\",\"vana\",\"vandal\",\"vanilka\",\"varan\",\"varhany\",\"varovat\",\"vcelku\",\"vchod\",\"vdova\",\"vedro\",\"vegetace\",\"vejce\",\"velbloud\",\"veletrh\",\"velitel\",\"velmoc\",\"velryba\",\"venkov\",\"veranda\",\"verze\",\"veselka\",\"veskrze\",\"vesnice\",\"vespodu\",\"vesta\",\"veterina\",\"veverka\",\"vibrace\",\"vichr\",\"videohra\",\"vidina\",\"vidle\",\"vila\",\"vinice\",\"viset\",\"vitalita\",\"vize\",\"vizitka\",\"vjezd\",\"vklad\",\"vkus\",\"vlajka\",\"vlak\",\"vlasec\",\"vlevo\",\"vlhkost\",\"vliv\",\"vlnovka\",\"vloupat\",\"vnucovat\",\"vnuk\",\"voda\",\"vodivost\",\"vodoznak\",\"vodstvo\",\"vojensky\",\"vojna\",\"vojsko\",\"volant\",\"volba\",\"volit\",\"volno\",\"voskovka\",\"vozidlo\",\"vozovna\",\"vpravo\",\"vrabec\",\"vracet\",\"vrah\",\"vrata\",\"vrba\",\"vrcholek\",\"vrhat\",\"vrstva\",\"vrtule\",\"vsadit\",\"vstoupit\",\"vstup\",\"vtip\",\"vybavit\",\"vybrat\",\"vychovat\",\"vydat\",\"vydra\",\"vyfotit\",\"vyhledat\",\"vyhnout\",\"vyhodit\",\"vyhradit\",\"vyhubit\",\"vyjasnit\",\"vyjet\",\"vyjmout\",\"vyklopit\",\"vykonat\",\"vylekat\",\"vymazat\",\"vymezit\",\"vymizet\",\"vymyslet\",\"vynechat\",\"vynikat\",\"vynutit\",\"vypadat\",\"vyplatit\",\"vypravit\",\"vypustit\",\"vyrazit\",\"vyrovnat\",\"vyrvat\",\"vyslovit\",\"vysoko\",\"vystavit\",\"vysunout\",\"vysypat\",\"vytasit\",\"vytesat\",\"vytratit\",\"vyvinout\",\"vyvolat\",\"vyvrhel\",\"vyzdobit\",\"vyznat\",\"vzadu\",\"vzbudit\",\"vzchopit\",\"vzdor\",\"vzduch\",\"vzdychat\",\"vzestup\",\"vzhledem\",\"vzkaz\",\"vzlykat\",\"vznik\",\"vzorek\",\"vzpoura\",\"vztah\",\"vztek\",\"xylofon\",\"zabrat\",\"zabydlet\",\"zachovat\",\"zadarmo\",\"zadusit\",\"zafoukat\",\"zahltit\",\"zahodit\",\"zahrada\",\"zahynout\",\"zajatec\",\"zajet\",\"zajistit\",\"zaklepat\",\"zakoupit\",\"zalepit\",\"zamezit\",\"zamotat\",\"zamyslet\",\"zanechat\",\"zanikat\",\"zaplatit\",\"zapojit\",\"zapsat\",\"zarazit\",\"zastavit\",\"zasunout\",\"zatajit\",\"zatemnit\",\"zatknout\",\"zaujmout\",\"zavalit\",\"zavelet\",\"zavinit\",\"zavolat\",\"zavrtat\",\"zazvonit\",\"zbavit\",\"zbrusu\",\"zbudovat\",\"zbytek\",\"zdaleka\",\"zdarma\",\"zdatnost\",\"zdivo\",\"zdobit\",\"zdroj\",\"zdvih\",\"zdymadlo\",\"zelenina\",\"zeman\",\"zemina\",\"zeptat\",\"zezadu\",\"zezdola\",\"zhatit\",\"zhltnout\",\"zhluboka\",\"zhotovit\",\"zhruba\",\"zima\",\"zimnice\",\"zjemnit\",\"zklamat\",\"zkoumat\",\"zkratka\",\"zkumavka\",\"zlato\",\"zlehka\",\"zloba\",\"zlom\",\"zlost\",\"zlozvyk\",\"zmapovat\",\"zmar\",\"zmatek\",\"zmije\",\"zmizet\",\"zmocnit\",\"zmodrat\",\"zmrzlina\",\"zmutovat\",\"znak\",\"znalost\",\"znamenat\",\"znovu\",\"zobrazit\",\"zotavit\",\"zoubek\",\"zoufale\",\"zplodit\",\"zpomalit\",\"zprava\",\"zprostit\",\"zprudka\",\"zprvu\",\"zrada\",\"zranit\",\"zrcadlo\",\"zrnitost\",\"zrno\",\"zrovna\",\"zrychlit\",\"zrzavost\",\"zticha\",\"ztratit\",\"zubovina\",\"zubr\",\"zvednout\",\"zvenku\",\"zvesela\",\"zvon\",\"zvrat\",\"zvukovod\",\"zvyk\"]");

},{}],"2qf6L":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('["\u7684","\u4E00","\u662F","\u5728","\u4E0D","\u4E86","\u6709","\u548C","\u4EBA","\u8FD9","\u4E2D","\u5927","\u4E3A","\u4E0A","\u4E2A","\u56FD","\u6211","\u4EE5","\u8981","\u4ED6","\u65F6","\u6765","\u7528","\u4EEC","\u751F","\u5230","\u4F5C","\u5730","\u4E8E","\u51FA","\u5C31","\u5206","\u5BF9","\u6210","\u4F1A","\u53EF","\u4E3B","\u53D1","\u5E74","\u52A8","\u540C","\u5DE5","\u4E5F","\u80FD","\u4E0B","\u8FC7","\u5B50","\u8BF4","\u4EA7","\u79CD","\u9762","\u800C","\u65B9","\u540E","\u591A","\u5B9A","\u884C","\u5B66","\u6CD5","\u6240","\u6C11","\u5F97","\u7ECF","\u5341","\u4E09","\u4E4B","\u8FDB","\u7740","\u7B49","\u90E8","\u5EA6","\u5BB6","\u7535","\u529B","\u91CC","\u5982","\u6C34","\u5316","\u9AD8","\u81EA","\u4E8C","\u7406","\u8D77","\u5C0F","\u7269","\u73B0","\u5B9E","\u52A0","\u91CF","\u90FD","\u4E24","\u4F53","\u5236","\u673A","\u5F53","\u4F7F","\u70B9","\u4ECE","\u4E1A","\u672C","\u53BB","\u628A","\u6027","\u597D","\u5E94","\u5F00","\u5B83","\u5408","\u8FD8","\u56E0","\u7531","\u5176","\u4E9B","\u7136","\u524D","\u5916","\u5929","\u653F","\u56DB","\u65E5","\u90A3","\u793E","\u4E49","\u4E8B","\u5E73","\u5F62","\u76F8","\u5168","\u8868","\u95F4","\u6837","\u4E0E","\u5173","\u5404","\u91CD","\u65B0","\u7EBF","\u5185","\u6570","\u6B63","\u5FC3","\u53CD","\u4F60","\u660E","\u770B","\u539F","\u53C8","\u4E48","\u5229","\u6BD4","\u6216","\u4F46","\u8D28","\u6C14","\u7B2C","\u5411","\u9053","\u547D","\u6B64","\u53D8","\u6761","\u53EA","\u6CA1","\u7ED3","\u89E3","\u95EE","\u610F","\u5EFA","\u6708","\u516C","\u65E0","\u7CFB","\u519B","\u5F88","\u60C5","\u8005","\u6700","\u7ACB","\u4EE3","\u60F3","\u5DF2","\u901A","\u5E76","\u63D0","\u76F4","\u9898","\u515A","\u7A0B","\u5C55","\u4E94","\u679C","\u6599","\u8C61","\u5458","\u9769","\u4F4D","\u5165","\u5E38","\u6587","\u603B","\u6B21","\u54C1","\u5F0F","\u6D3B","\u8BBE","\u53CA","\u7BA1","\u7279","\u4EF6","\u957F","\u6C42","\u8001","\u5934","\u57FA","\u8D44","\u8FB9","\u6D41","\u8DEF","\u7EA7","\u5C11","\u56FE","\u5C71","\u7EDF","\u63A5","\u77E5","\u8F83","\u5C06","\u7EC4","\u89C1","\u8BA1","\u522B","\u5979","\u624B","\u89D2","\u671F","\u6839","\u8BBA","\u8FD0","\u519C","\u6307","\u51E0","\u4E5D","\u533A","\u5F3A","\u653E","\u51B3","\u897F","\u88AB","\u5E72","\u505A","\u5FC5","\u6218","\u5148","\u56DE","\u5219","\u4EFB","\u53D6","\u636E","\u5904","\u961F","\u5357","\u7ED9","\u8272","\u5149","\u95E8","\u5373","\u4FDD","\u6CBB","\u5317","\u9020","\u767E","\u89C4","\u70ED","\u9886","\u4E03","\u6D77","\u53E3","\u4E1C","\u5BFC","\u5668","\u538B","\u5FD7","\u4E16","\u91D1","\u589E","\u4E89","\u6D4E","\u9636","\u6CB9","\u601D","\u672F","\u6781","\u4EA4","\u53D7","\u8054","\u4EC0","\u8BA4","\u516D","\u5171","\u6743","\u6536","\u8BC1","\u6539","\u6E05","\u7F8E","\u518D","\u91C7","\u8F6C","\u66F4","\u5355","\u98CE","\u5207","\u6253","\u767D","\u6559","\u901F","\u82B1","\u5E26","\u5B89","\u573A","\u8EAB","\u8F66","\u4F8B","\u771F","\u52A1","\u5177","\u4E07","\u6BCF","\u76EE","\u81F3","\u8FBE","\u8D70","\u79EF","\u793A","\u8BAE","\u58F0","\u62A5","\u6597","\u5B8C","\u7C7B","\u516B","\u79BB","\u534E","\u540D","\u786E","\u624D","\u79D1","\u5F20","\u4FE1","\u9A6C","\u8282","\u8BDD","\u7C73","\u6574","\u7A7A","\u5143","\u51B5","\u4ECA","\u96C6","\u6E29","\u4F20","\u571F","\u8BB8","\u6B65","\u7FA4","\u5E7F","\u77F3","\u8BB0","\u9700","\u6BB5","\u7814","\u754C","\u62C9","\u6797","\u5F8B","\u53EB","\u4E14","\u7A76","\u89C2","\u8D8A","\u7EC7","\u88C5","\u5F71","\u7B97","\u4F4E","\u6301","\u97F3","\u4F17","\u4E66","\u5E03","\u590D","\u5BB9","\u513F","\u987B","\u9645","\u5546","\u975E","\u9A8C","\u8FDE","\u65AD","\u6DF1","\u96BE","\u8FD1","\u77FF","\u5343","\u5468","\u59D4","\u7D20","\u6280","\u5907","\u534A","\u529E","\u9752","\u7701","\u5217","\u4E60","\u54CD","\u7EA6","\u652F","\u822C","\u53F2","\u611F","\u52B3","\u4FBF","\u56E2","\u5F80","\u9178","\u5386","\u5E02","\u514B","\u4F55","\u9664","\u6D88","\u6784","\u5E9C","\u79F0","\u592A","\u51C6","\u7CBE","\u503C","\u53F7","\u7387","\u65CF","\u7EF4","\u5212","\u9009","\u6807","\u5199","\u5B58","\u5019","\u6BDB","\u4EB2","\u5FEB","\u6548","\u65AF","\u9662","\u67E5","\u6C5F","\u578B","\u773C","\u738B","\u6309","\u683C","\u517B","\u6613","\u7F6E","\u6D3E","\u5C42","\u7247","\u59CB","\u5374","\u4E13","\u72B6","\u80B2","\u5382","\u4EAC","\u8BC6","\u9002","\u5C5E","\u5706","\u5305","\u706B","\u4F4F","\u8C03","\u6EE1","\u53BF","\u5C40","\u7167","\u53C2","\u7EA2","\u7EC6","\u5F15","\u542C","\u8BE5","\u94C1","\u4EF7","\u4E25","\u9996","\u5E95","\u6DB2","\u5B98","\u5FB7","\u968F","\u75C5","\u82CF","\u5931","\u5C14","\u6B7B","\u8BB2","\u914D","\u5973","\u9EC4","\u63A8","\u663E","\u8C08","\u7F6A","\u795E","\u827A","\u5462","\u5E2D","\u542B","\u4F01","\u671B","\u5BC6","\u6279","\u8425","\u9879","\u9632","\u4E3E","\u7403","\u82F1","\u6C27","\u52BF","\u544A","\u674E","\u53F0","\u843D","\u6728","\u5E2E","\u8F6E","\u7834","\u4E9A","\u5E08","\u56F4","\u6CE8","\u8FDC","\u5B57","\u6750","\u6392","\u4F9B","\u6CB3","\u6001","\u5C01","\u53E6","\u65BD","\u51CF","\u6811","\u6EB6","\u600E","\u6B62","\u6848","\u8A00","\u58EB","\u5747","\u6B66","\u56FA","\u53F6","\u9C7C","\u6CE2","\u89C6","\u4EC5","\u8D39","\u7D27","\u7231","\u5DE6","\u7AE0","\u65E9","\u671D","\u5BB3","\u7EED","\u8F7B","\u670D","\u8BD5","\u98DF","\u5145","\u5175","\u6E90","\u5224","\u62A4","\u53F8","\u8DB3","\u67D0","\u7EC3","\u5DEE","\u81F4","\u677F","\u7530","\u964D","\u9ED1","\u72AF","\u8D1F","\u51FB","\u8303","\u7EE7","\u5174","\u4F3C","\u4F59","\u575A","\u66F2","\u8F93","\u4FEE","\u6545","\u57CE","\u592B","\u591F","\u9001","\u7B14","\u8239","\u5360","\u53F3","\u8D22","\u5403","\u5BCC","\u6625","\u804C","\u89C9","\u6C49","\u753B","\u529F","\u5DF4","\u8DDF","\u867D","\u6742","\u98DE","\u68C0","\u5438","\u52A9","\u5347","\u9633","\u4E92","\u521D","\u521B","\u6297","\u8003","\u6295","\u574F","\u7B56","\u53E4","\u5F84","\u6362","\u672A","\u8DD1","\u7559","\u94A2","\u66FE","\u7AEF","\u8D23","\u7AD9","\u7B80","\u8FF0","\u94B1","\u526F","\u5C3D","\u5E1D","\u5C04","\u8349","\u51B2","\u627F","\u72EC","\u4EE4","\u9650","\u963F","\u5BA3","\u73AF","\u53CC","\u8BF7","\u8D85","\u5FAE","\u8BA9","\u63A7","\u5DDE","\u826F","\u8F74","\u627E","\u5426","\u7EAA","\u76CA","\u4F9D","\u4F18","\u9876","\u7840","\u8F7D","\u5012","\u623F","\u7A81","\u5750","\u7C89","\u654C","\u7565","\u5BA2","\u8881","\u51B7","\u80DC","\u7EDD","\u6790","\u5757","\u5242","\u6D4B","\u4E1D","\u534F","\u8BC9","\u5FF5","\u9648","\u4ECD","\u7F57","\u76D0","\u53CB","\u6D0B","\u9519","\u82E6","\u591C","\u5211","\u79FB","\u9891","\u9010","\u9760","\u6DF7","\u6BCD","\u77ED","\u76AE","\u7EC8","\u805A","\u6C7D","\u6751","\u4E91","\u54EA","\u65E2","\u8DDD","\u536B","\u505C","\u70C8","\u592E","\u5BDF","\u70E7","\u8FC5","\u5883","\u82E5","\u5370","\u6D32","\u523B","\u62EC","\u6FC0","\u5B54","\u641E","\u751A","\u5BA4","\u5F85","\u6838","\u6821","\u6563","\u4FB5","\u5427","\u7532","\u6E38","\u4E45","\u83DC","\u5473","\u65E7","\u6A21","\u6E56","\u8D27","\u635F","\u9884","\u963B","\u6BEB","\u666E","\u7A33","\u4E59","\u5988","\u690D","\u606F","\u6269","\u94F6","\u8BED","\u6325","\u9152","\u5B88","\u62FF","\u5E8F","\u7EB8","\u533B","\u7F3A","\u96E8","\u5417","\u9488","\u5218","\u554A","\u6025","\u5531","\u8BEF","\u8BAD","\u613F","\u5BA1","\u9644","\u83B7","\u8336","\u9C9C","\u7CAE","\u65A4","\u5B69","\u8131","\u786B","\u80A5","\u5584","\u9F99","\u6F14","\u7236","\u6E10","\u8840","\u6B22","\u68B0","\u638C","\u6B4C","\u6C99","\u521A","\u653B","\u8C13","\u76FE","\u8BA8","\u665A","\u7C92","\u4E71","\u71C3","\u77DB","\u4E4E","\u6740","\u836F","\u5B81","\u9C81","\u8D35","\u949F","\u7164","\u8BFB","\u73ED","\u4F2F","\u9999","\u4ECB","\u8FEB","\u53E5","\u4E30","\u57F9","\u63E1","\u5170","\u62C5","\u5F26","\u86CB","\u6C89","\u5047","\u7A7F","\u6267","\u7B54","\u4E50","\u8C01","\u987A","\u70DF","\u7F29","\u5F81","\u8138","\u559C","\u677E","\u811A","\u56F0","\u5F02","\u514D","\u80CC","\u661F","\u798F","\u4E70","\u67D3","\u4E95","\u6982","\u6162","\u6015","\u78C1","\u500D","\u7956","\u7687","\u4FC3","\u9759","\u8865","\u8BC4","\u7FFB","\u8089","\u8DF5","\u5C3C","\u8863","\u5BBD","\u626C","\u68C9","\u5E0C","\u4F24","\u64CD","\u5782","\u79CB","\u5B9C","\u6C22","\u5957","\u7763","\u632F","\u67B6","\u4EAE","\u672B","\u5BAA","\u5E86","\u7F16","\u725B","\u89E6","\u6620","\u96F7","\u9500","\u8BD7","\u5EA7","\u5C45","\u6293","\u88C2","\u80DE","\u547C","\u5A18","\u666F","\u5A01","\u7EFF","\u6676","\u539A","\u76DF","\u8861","\u9E21","\u5B59","\u5EF6","\u5371","\u80F6","\u5C4B","\u4E61","\u4E34","\u9646","\u987E","\u6389","\u5440","\u706F","\u5C81","\u63AA","\u675F","\u8010","\u5267","\u7389","\u8D75","\u8DF3","\u54E5","\u5B63","\u8BFE","\u51EF","\u80E1","\u989D","\u6B3E","\u7ECD","\u5377","\u9F50","\u4F1F","\u84B8","\u6B96","\u6C38","\u5B97","\u82D7","\u5DDD","\u7089","\u5CA9","\u5F31","\u96F6","\u6768","\u594F","\u6CBF","\u9732","\u6746","\u63A2","\u6ED1","\u9547","\u996D","\u6D53","\u822A","\u6000","\u8D76","\u5E93","\u593A","\u4F0A","\u7075","\u7A0E","\u9014","\u706D","\u8D5B","\u5F52","\u53EC","\u9F13","\u64AD","\u76D8","\u88C1","\u9669","\u5EB7","\u552F","\u5F55","\u83CC","\u7EAF","\u501F","\u7CD6","\u76D6","\u6A2A","\u7B26","\u79C1","\u52AA","\u5802","\u57DF","\u67AA","\u6DA6","\u5E45","\u54C8","\u7ADF","\u719F","\u866B","\u6CFD","\u8111","\u58E4","\u78B3","\u6B27","\u904D","\u4FA7","\u5BE8","\u6562","\u5F7B","\u8651","\u659C","\u8584","\u5EAD","\u7EB3","\u5F39","\u9972","\u4F38","\u6298","\u9EA6","\u6E7F","\u6697","\u8377","\u74E6","\u585E","\u5E8A","\u7B51","\u6076","\u6237","\u8BBF","\u5854","\u5947","\u900F","\u6881","\u5200","\u65CB","\u8FF9","\u5361","\u6C2F","\u9047","\u4EFD","\u6BD2","\u6CE5","\u9000","\u6D17","\u6446","\u7070","\u5F69","\u5356","\u8017","\u590F","\u62E9","\u5FD9","\u94DC","\u732E","\u786C","\u4E88","\u7E41","\u5708","\u96EA","\u51FD","\u4EA6","\u62BD","\u7BC7","\u9635","\u9634","\u4E01","\u5C3A","\u8FFD","\u5806","\u96C4","\u8FCE","\u6CDB","\u7238","\u697C","\u907F","\u8C0B","\u5428","\u91CE","\u732A","\u65D7","\u7D2F","\u504F","\u5178","\u9986","\u7D22","\u79E6","\u8102","\u6F6E","\u7237","\u8C46","\u5FFD","\u6258","\u60CA","\u5851","\u9057","\u6108","\u6731","\u66FF","\u7EA4","\u7C97","\u503E","\u5C1A","\u75DB","\u695A","\u8C22","\u594B","\u8D2D","\u78E8","\u541B","\u6C60","\u65C1","\u788E","\u9AA8","\u76D1","\u6355","\u5F1F","\u66B4","\u5272","\u8D2F","\u6B8A","\u91CA","\u8BCD","\u4EA1","\u58C1","\u987F","\u5B9D","\u5348","\u5C18","\u95FB","\u63ED","\u70AE","\u6B8B","\u51AC","\u6865","\u5987","\u8B66","\u7EFC","\u62DB","\u5434","\u4ED8","\u6D6E","\u906D","\u5F90","\u60A8","\u6447","\u8C37","\u8D5E","\u7BB1","\u9694","\u8BA2","\u7537","\u5439","\u56ED","\u7EB7","\u5510","\u8D25","\u5B8B","\u73BB","\u5DE8","\u8015","\u5766","\u8363","\u95ED","\u6E7E","\u952E","\u51E1","\u9A7B","\u9505","\u6551","\u6069","\u5265","\u51DD","\u78B1","\u9F7F","\u622A","\u70BC","\u9EBB","\u7EBA","\u7981","\u5E9F","\u76DB","\u7248","\u7F13","\u51C0","\u775B","\u660C","\u5A5A","\u6D89","\u7B52","\u5634","\u63D2","\u5CB8","\u6717","\u5E84","\u8857","\u85CF","\u59D1","\u8D38","\u8150","\u5974","\u5566","\u60EF","\u4E58","\u4F19","\u6062","\u5300","\u7EB1","\u624E","\u8FA9","\u8033","\u5F6A","\u81E3","\u4EBF","\u7483","\u62B5","\u8109","\u79C0","\u8428","\u4FC4","\u7F51","\u821E","\u5E97","\u55B7","\u7EB5","\u5BF8","\u6C57","\u6302","\u6D2A","\u8D3A","\u95EA","\u67EC","\u7206","\u70EF","\u6D25","\u7A3B","\u5899","\u8F6F","\u52C7","\u50CF","\u6EDA","\u5398","\u8499","\u82B3","\u80AF","\u5761","\u67F1","\u8361","\u817F","\u4EEA","\u65C5","\u5C3E","\u8F67","\u51B0","\u8D21","\u767B","\u9ECE","\u524A","\u94BB","\u52D2","\u9003","\u969C","\u6C28","\u90ED","\u5CF0","\u5E01","\u6E2F","\u4F0F","\u8F68","\u4EA9","\u6BD5","\u64E6","\u83AB","\u523A","\u6D6A","\u79D8","\u63F4","\u682A","\u5065","\u552E","\u80A1","\u5C9B","\u7518","\u6CE1","\u7761","\u7AE5","\u94F8","\u6C64","\u9600","\u4F11","\u6C47","\u820D","\u7267","\u7ED5","\u70B8","\u54F2","\u78F7","\u7EE9","\u670B","\u6DE1","\u5C16","\u542F","\u9677","\u67F4","\u5448","\u5F92","\u989C","\u6CEA","\u7A0D","\u5FD8","\u6CF5","\u84DD","\u62D6","\u6D1E","\u6388","\u955C","\u8F9B","\u58EE","\u950B","\u8D2B","\u865A","\u5F2F","\u6469","\u6CF0","\u5E7C","\u5EF7","\u5C0A","\u7A97","\u7EB2","\u5F04","\u96B6","\u7591","\u6C0F","\u5BAB","\u59D0","\u9707","\u745E","\u602A","\u5C24","\u7434","\u5FAA","\u63CF","\u819C","\u8FDD","\u5939","\u8170","\u7F18","\u73E0","\u7A77","\u68EE","\u679D","\u7AF9","\u6C9F","\u50AC","\u7EF3","\u5FC6","\u90A6","\u5269","\u5E78","\u6D46","\u680F","\u62E5","\u7259","\u8D2E","\u793C","\u6EE4","\u94A0","\u7EB9","\u7F62","\u62CD","\u54B1","\u558A","\u8896","\u57C3","\u52E4","\u7F5A","\u7126","\u6F5C","\u4F0D","\u58A8","\u6B32","\u7F1D","\u59D3","\u520A","\u9971","\u4EFF","\u5956","\u94DD","\u9B3C","\u4E3D","\u8DE8","\u9ED8","\u6316","\u94FE","\u626B","\u559D","\u888B","\u70AD","\u6C61","\u5E55","\u8BF8","\u5F27","\u52B1","\u6885","\u5976","\u6D01","\u707E","\u821F","\u9274","\u82EF","\u8BBC","\u62B1","\u6BC1","\u61C2","\u5BD2","\u667A","\u57D4","\u5BC4","\u5C4A","\u8DC3","\u6E21","\u6311","\u4E39","\u8270","\u8D1D","\u78B0","\u62D4","\u7239","\u6234","\u7801","\u68A6","\u82BD","\u7194","\u8D64","\u6E14","\u54ED","\u656C","\u9897","\u5954","\u94C5","\u4EF2","\u864E","\u7A00","\u59B9","\u4E4F","\u73CD","\u7533","\u684C","\u9075","\u5141","\u9686","\u87BA","\u4ED3","\u9B4F","\u9510","\u6653","\u6C2E","\u517C","\u9690","\u788D","\u8D6B","\u62E8","\u5FE0","\u8083","\u7F38","\u7275","\u62A2","\u535A","\u5DE7","\u58F3","\u5144","\u675C","\u8BAF","\u8BDA","\u78A7","\u7965","\u67EF","\u9875","\u5DE1","\u77E9","\u60B2","\u704C","\u9F84","\u4F26","\u7968","\u5BFB","\u6842","\u94FA","\u5723","\u6050","\u6070","\u90D1","\u8DA3","\u62AC","\u8352","\u817E","\u8D34","\u67D4","\u6EF4","\u731B","\u9614","\u8F86","\u59BB","\u586B","\u64A4","\u50A8","\u7B7E","\u95F9","\u6270","\u7D2B","\u7802","\u9012","\u620F","\u540A","\u9676","\u4F10","\u5582","\u7597","\u74F6","\u5A46","\u629A","\u81C2","\u6478","\u5FCD","\u867E","\u8721","\u90BB","\u80F8","\u5DE9","\u6324","\u5076","\u5F03","\u69FD","\u52B2","\u4E73","\u9093","\u5409","\u4EC1","\u70C2","\u7816","\u79DF","\u4E4C","\u8230","\u4F34","\u74DC","\u6D45","\u4E19","\u6682","\u71E5","\u6A61","\u67F3","\u8FF7","\u6696","\u724C","\u79E7","\u80C6","\u8BE6","\u7C27","\u8E0F","\u74F7","\u8C31","\u5446","\u5BBE","\u7CCA","\u6D1B","\u8F89","\u6124","\u7ADE","\u9699","\u6012","\u7C98","\u4E43","\u7EEA","\u80A9","\u7C4D","\u654F","\u6D82","\u7199","\u7686","\u4FA6","\u60AC","\u6398","\u4EAB","\u7EA0","\u9192","\u72C2","\u9501","\u6DC0","\u6068","\u7272","\u9738","\u722C","\u8D4F","\u9006","\u73A9","\u9675","\u795D","\u79D2","\u6D59","\u8C8C","\u5F79","\u5F7C","\u6089","\u9E2D","\u8D8B","\u51E4","\u6668","\u755C","\u8F88","\u79E9","\u5375","\u7F72","\u68AF","\u708E","\u6EE9","\u68CB","\u9A71","\u7B5B","\u5CE1","\u5192","\u5565","\u5BFF","\u8BD1","\u6D78","\u6CC9","\u5E3D","\u8FDF","\u7845","\u7586","\u8D37","\u6F0F","\u7A3F","\u51A0","\u5AE9","\u80C1","\u82AF","\u7262","\u53DB","\u8680","\u5965","\u9E23","\u5CAD","\u7F8A","\u51ED","\u4E32","\u5858","\u7ED8","\u9175","\u878D","\u76C6","\u9521","\u5E99","\u7B79","\u51BB","\u8F85","\u6444","\u88AD","\u7B4B","\u62D2","\u50DA","\u65F1","\u94BE","\u9E1F","\u6F06","\u6C88","\u7709","\u758F","\u6DFB","\u68D2","\u7A57","\u785D","\u97E9","\u903C","\u626D","\u4FA8","\u51C9","\u633A","\u7897","\u683D","\u7092","\u676F","\u60A3","\u998F","\u529D","\u8C6A","\u8FBD","\u52C3","\u9E3F","\u65E6","\u540F","\u62DC","\u72D7","\u57CB","\u8F8A","\u63A9","\u996E","\u642C","\u9A82","\u8F9E","\u52FE","\u6263","\u4F30","\u848B","\u7ED2","\u96FE","\u4E08","\u6735","\u59C6","\u62DF","\u5B87","\u8F91","\u9655","\u96D5","\u507F","\u84C4","\u5D07","\u526A","\u5021","\u5385","\u54AC","\u9A76","\u85AF","\u5237","\u65A5","\u756A","\u8D4B","\u5949","\u4F5B","\u6D47","\u6F2B","\u66FC","\u6247","\u9499","\u6843","\u6276","\u4ED4","\u8FD4","\u4FD7","\u4E8F","\u8154","\u978B","\u68F1","\u8986","\u6846","\u6084","\u53D4","\u649E","\u9A97","\u52D8","\u65FA","\u6CB8","\u5B64","\u5410","\u5B5F","\u6E20","\u5C48","\u75BE","\u5999","\u60DC","\u4EF0","\u72E0","\u80C0","\u8C10","\u629B","\u9709","\u6851","\u5C97","\u561B","\u8870","\u76D7","\u6E17","\u810F","\u8D56","\u6D8C","\u751C","\u66F9","\u9605","\u808C","\u54E9","\u5389","\u70C3","\u7EAC","\u6BC5","\u6628","\u4F2A","\u75C7","\u716E","\u53F9","\u9489","\u642D","\u830E","\u7B3C","\u9177","\u5077","\u5F13","\u9525","\u6052","\u6770","\u5751","\u9F3B","\u7FFC","\u7EB6","\u53D9","\u72F1","\u902E","\u7F50","\u7EDC","\u68DA","\u6291","\u81A8","\u852C","\u5BFA","\u9AA4","\u7A46","\u51B6","\u67AF","\u518C","\u5C38","\u51F8","\u7EC5","\u576F","\u727A","\u7130","\u8F70","\u6B23","\u664B","\u7626","\u5FA1","\u952D","\u9526","\u4E27","\u65EC","\u953B","\u5784","\u641C","\u6251","\u9080","\u4EAD","\u916F","\u8FC8","\u8212","\u8106","\u9176","\u95F2","\u5FE7","\u915A","\u987D","\u7FBD","\u6DA8","\u5378","\u4ED7","\u966A","\u8F9F","\u60E9","\u676D","\u59DA","\u809A","\u6349","\u98D8","\u6F02","\u6606","\u6B3A","\u543E","\u90CE","\u70F7","\u6C41","\u5475","\u9970","\u8427","\u96C5","\u90AE","\u8FC1","\u71D5","\u6492","\u59FB","\u8D74","\u5BB4","\u70E6","\u503A","\u5E10","\u6591","\u94C3","\u65E8","\u9187","\u8463","\u997C","\u96CF","\u59FF","\u62CC","\u5085","\u8179","\u59A5","\u63C9","\u8D24","\u62C6","\u6B6A","\u8461","\u80FA","\u4E22","\u6D69","\u5FBD","\u6602","\u57AB","\u6321","\u89C8","\u8D2A","\u6170","\u7F34","\u6C6A","\u614C","\u51AF","\u8BFA","\u59DC","\u8C0A","\u51F6","\u52A3","\u8BEC","\u8000","\u660F","\u8EBA","\u76C8","\u9A91","\u4E54","\u6EAA","\u4E1B","\u5362","\u62B9","\u95F7","\u54A8","\u522E","\u9A7E","\u7F06","\u609F","\u6458","\u94D2","\u63B7","\u9887","\u5E7B","\u67C4","\u60E0","\u60E8","\u4F73","\u4EC7","\u814A","\u7A9D","\u6DA4","\u5251","\u77A7","\u5821","\u6CFC","\u8471","\u7F69","\u970D","\u635E","\u80CE","\u82CD","\u6EE8","\u4FE9","\u6345","\u6E58","\u780D","\u971E","\u90B5","\u8404","\u75AF","\u6DEE","\u9042","\u718A","\u7CAA","\u70D8","\u5BBF","\u6863","\u6208","\u9A73","\u5AC2","\u88D5","\u5F99","\u7BAD","\u6350","\u80A0","\u6491","\u6652","\u8FA8","\u6BBF","\u83B2","\u644A","\u6405","\u9171","\u5C4F","\u75AB","\u54C0","\u8521","\u5835","\u6CAB","\u76B1","\u7545","\u53E0","\u9601","\u83B1","\u6572","\u8F96","\u94A9","\u75D5","\u575D","\u5DF7","\u997F","\u7978","\u4E18","\u7384","\u6E9C","\u66F0","\u903B","\u5F6D","\u5C1D","\u537F","\u59A8","\u8247","\u541E","\u97E6","\u6028","\u77EE","\u6B47"]');

},{}],"4RmOe":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('["\u7684","\u4E00","\u662F","\u5728","\u4E0D","\u4E86","\u6709","\u548C","\u4EBA","\u9019","\u4E2D","\u5927","\u70BA","\u4E0A","\u500B","\u570B","\u6211","\u4EE5","\u8981","\u4ED6","\u6642","\u4F86","\u7528","\u5011","\u751F","\u5230","\u4F5C","\u5730","\u65BC","\u51FA","\u5C31","\u5206","\u5C0D","\u6210","\u6703","\u53EF","\u4E3B","\u767C","\u5E74","\u52D5","\u540C","\u5DE5","\u4E5F","\u80FD","\u4E0B","\u904E","\u5B50","\u8AAA","\u7522","\u7A2E","\u9762","\u800C","\u65B9","\u5F8C","\u591A","\u5B9A","\u884C","\u5B78","\u6CD5","\u6240","\u6C11","\u5F97","\u7D93","\u5341","\u4E09","\u4E4B","\u9032","\u8457","\u7B49","\u90E8","\u5EA6","\u5BB6","\u96FB","\u529B","\u88E1","\u5982","\u6C34","\u5316","\u9AD8","\u81EA","\u4E8C","\u7406","\u8D77","\u5C0F","\u7269","\u73FE","\u5BE6","\u52A0","\u91CF","\u90FD","\u5169","\u9AD4","\u5236","\u6A5F","\u7576","\u4F7F","\u9EDE","\u5F9E","\u696D","\u672C","\u53BB","\u628A","\u6027","\u597D","\u61C9","\u958B","\u5B83","\u5408","\u9084","\u56E0","\u7531","\u5176","\u4E9B","\u7136","\u524D","\u5916","\u5929","\u653F","\u56DB","\u65E5","\u90A3","\u793E","\u7FA9","\u4E8B","\u5E73","\u5F62","\u76F8","\u5168","\u8868","\u9593","\u6A23","\u8207","\u95DC","\u5404","\u91CD","\u65B0","\u7DDA","\u5167","\u6578","\u6B63","\u5FC3","\u53CD","\u4F60","\u660E","\u770B","\u539F","\u53C8","\u9EBC","\u5229","\u6BD4","\u6216","\u4F46","\u8CEA","\u6C23","\u7B2C","\u5411","\u9053","\u547D","\u6B64","\u8B8A","\u689D","\u53EA","\u6C92","\u7D50","\u89E3","\u554F","\u610F","\u5EFA","\u6708","\u516C","\u7121","\u7CFB","\u8ECD","\u5F88","\u60C5","\u8005","\u6700","\u7ACB","\u4EE3","\u60F3","\u5DF2","\u901A","\u4E26","\u63D0","\u76F4","\u984C","\u9EE8","\u7A0B","\u5C55","\u4E94","\u679C","\u6599","\u8C61","\u54E1","\u9769","\u4F4D","\u5165","\u5E38","\u6587","\u7E3D","\u6B21","\u54C1","\u5F0F","\u6D3B","\u8A2D","\u53CA","\u7BA1","\u7279","\u4EF6","\u9577","\u6C42","\u8001","\u982D","\u57FA","\u8CC7","\u908A","\u6D41","\u8DEF","\u7D1A","\u5C11","\u5716","\u5C71","\u7D71","\u63A5","\u77E5","\u8F03","\u5C07","\u7D44","\u898B","\u8A08","\u5225","\u5979","\u624B","\u89D2","\u671F","\u6839","\u8AD6","\u904B","\u8FB2","\u6307","\u5E7E","\u4E5D","\u5340","\u5F37","\u653E","\u6C7A","\u897F","\u88AB","\u5E79","\u505A","\u5FC5","\u6230","\u5148","\u56DE","\u5247","\u4EFB","\u53D6","\u64DA","\u8655","\u968A","\u5357","\u7D66","\u8272","\u5149","\u9580","\u5373","\u4FDD","\u6CBB","\u5317","\u9020","\u767E","\u898F","\u71B1","\u9818","\u4E03","\u6D77","\u53E3","\u6771","\u5C0E","\u5668","\u58D3","\u5FD7","\u4E16","\u91D1","\u589E","\u722D","\u6FDF","\u968E","\u6CB9","\u601D","\u8853","\u6975","\u4EA4","\u53D7","\u806F","\u4EC0","\u8A8D","\u516D","\u5171","\u6B0A","\u6536","\u8B49","\u6539","\u6E05","\u7F8E","\u518D","\u63A1","\u8F49","\u66F4","\u55AE","\u98A8","\u5207","\u6253","\u767D","\u6559","\u901F","\u82B1","\u5E36","\u5B89","\u5834","\u8EAB","\u8ECA","\u4F8B","\u771F","\u52D9","\u5177","\u842C","\u6BCF","\u76EE","\u81F3","\u9054","\u8D70","\u7A4D","\u793A","\u8B70","\u8072","\u5831","\u9B25","\u5B8C","\u985E","\u516B","\u96E2","\u83EF","\u540D","\u78BA","\u624D","\u79D1","\u5F35","\u4FE1","\u99AC","\u7BC0","\u8A71","\u7C73","\u6574","\u7A7A","\u5143","\u6CC1","\u4ECA","\u96C6","\u6EAB","\u50B3","\u571F","\u8A31","\u6B65","\u7FA4","\u5EE3","\u77F3","\u8A18","\u9700","\u6BB5","\u7814","\u754C","\u62C9","\u6797","\u5F8B","\u53EB","\u4E14","\u7A76","\u89C0","\u8D8A","\u7E54","\u88DD","\u5F71","\u7B97","\u4F4E","\u6301","\u97F3","\u773E","\u66F8","\u5E03","\u590D","\u5BB9","\u5152","\u9808","\u969B","\u5546","\u975E","\u9A57","\u9023","\u65B7","\u6DF1","\u96E3","\u8FD1","\u7926","\u5343","\u9031","\u59D4","\u7D20","\u6280","\u5099","\u534A","\u8FA6","\u9752","\u7701","\u5217","\u7FD2","\u97FF","\u7D04","\u652F","\u822C","\u53F2","\u611F","\u52DE","\u4FBF","\u5718","\u5F80","\u9178","\u6B77","\u5E02","\u514B","\u4F55","\u9664","\u6D88","\u69CB","\u5E9C","\u7A31","\u592A","\u6E96","\u7CBE","\u503C","\u865F","\u7387","\u65CF","\u7DAD","\u5283","\u9078","\u6A19","\u5BEB","\u5B58","\u5019","\u6BDB","\u89AA","\u5FEB","\u6548","\u65AF","\u9662","\u67E5","\u6C5F","\u578B","\u773C","\u738B","\u6309","\u683C","\u990A","\u6613","\u7F6E","\u6D3E","\u5C64","\u7247","\u59CB","\u537B","\u5C08","\u72C0","\u80B2","\u5EE0","\u4EAC","\u8B58","\u9069","\u5C6C","\u5713","\u5305","\u706B","\u4F4F","\u8ABF","\u6EFF","\u7E23","\u5C40","\u7167","\u53C3","\u7D05","\u7D30","\u5F15","\u807D","\u8A72","\u9435","\u50F9","\u56B4","\u9996","\u5E95","\u6DB2","\u5B98","\u5FB7","\u96A8","\u75C5","\u8607","\u5931","\u723E","\u6B7B","\u8B1B","\u914D","\u5973","\u9EC3","\u63A8","\u986F","\u8AC7","\u7F6A","\u795E","\u85DD","\u5462","\u5E2D","\u542B","\u4F01","\u671B","\u5BC6","\u6279","\u71DF","\u9805","\u9632","\u8209","\u7403","\u82F1","\u6C27","\u52E2","\u544A","\u674E","\u53F0","\u843D","\u6728","\u5E6B","\u8F2A","\u7834","\u4E9E","\u5E2B","\u570D","\u6CE8","\u9060","\u5B57","\u6750","\u6392","\u4F9B","\u6CB3","\u614B","\u5C01","\u53E6","\u65BD","\u6E1B","\u6A39","\u6EB6","\u600E","\u6B62","\u6848","\u8A00","\u58EB","\u5747","\u6B66","\u56FA","\u8449","\u9B5A","\u6CE2","\u8996","\u50C5","\u8CBB","\u7DCA","\u611B","\u5DE6","\u7AE0","\u65E9","\u671D","\u5BB3","\u7E8C","\u8F15","\u670D","\u8A66","\u98DF","\u5145","\u5175","\u6E90","\u5224","\u8B77","\u53F8","\u8DB3","\u67D0","\u7DF4","\u5DEE","\u81F4","\u677F","\u7530","\u964D","\u9ED1","\u72AF","\u8CA0","\u64CA","\u8303","\u7E7C","\u8208","\u4F3C","\u9918","\u5805","\u66F2","\u8F38","\u4FEE","\u6545","\u57CE","\u592B","\u5920","\u9001","\u7B46","\u8239","\u4F54","\u53F3","\u8CA1","\u5403","\u5BCC","\u6625","\u8077","\u89BA","\u6F22","\u756B","\u529F","\u5DF4","\u8DDF","\u96D6","\u96DC","\u98DB","\u6AA2","\u5438","\u52A9","\u6607","\u967D","\u4E92","\u521D","\u5275","\u6297","\u8003","\u6295","\u58DE","\u7B56","\u53E4","\u5F91","\u63DB","\u672A","\u8DD1","\u7559","\u92FC","\u66FE","\u7AEF","\u8CAC","\u7AD9","\u7C21","\u8FF0","\u9322","\u526F","\u76E1","\u5E1D","\u5C04","\u8349","\u885D","\u627F","\u7368","\u4EE4","\u9650","\u963F","\u5BA3","\u74B0","\u96D9","\u8ACB","\u8D85","\u5FAE","\u8B93","\u63A7","\u5DDE","\u826F","\u8EF8","\u627E","\u5426","\u7D00","\u76CA","\u4F9D","\u512A","\u9802","\u790E","\u8F09","\u5012","\u623F","\u7A81","\u5750","\u7C89","\u6575","\u7565","\u5BA2","\u8881","\u51B7","\u52DD","\u7D55","\u6790","\u584A","\u5291","\u6E2C","\u7D72","\u5354","\u8A34","\u5FF5","\u9673","\u4ECD","\u7F85","\u9E7D","\u53CB","\u6D0B","\u932F","\u82E6","\u591C","\u5211","\u79FB","\u983B","\u9010","\u9760","\u6DF7","\u6BCD","\u77ED","\u76AE","\u7D42","\u805A","\u6C7D","\u6751","\u96F2","\u54EA","\u65E2","\u8DDD","\u885B","\u505C","\u70C8","\u592E","\u5BDF","\u71D2","\u8FC5","\u5883","\u82E5","\u5370","\u6D32","\u523B","\u62EC","\u6FC0","\u5B54","\u641E","\u751A","\u5BA4","\u5F85","\u6838","\u6821","\u6563","\u4FB5","\u5427","\u7532","\u904A","\u4E45","\u83DC","\u5473","\u820A","\u6A21","\u6E56","\u8CA8","\u640D","\u9810","\u963B","\u6BEB","\u666E","\u7A69","\u4E59","\u5ABD","\u690D","\u606F","\u64F4","\u9280","\u8A9E","\u63EE","\u9152","\u5B88","\u62FF","\u5E8F","\u7D19","\u91AB","\u7F3A","\u96E8","\u55CE","\u91DD","\u5289","\u554A","\u6025","\u5531","\u8AA4","\u8A13","\u9858","\u5BE9","\u9644","\u7372","\u8336","\u9BAE","\u7CE7","\u65A4","\u5B69","\u812B","\u786B","\u80A5","\u5584","\u9F8D","\u6F14","\u7236","\u6F38","\u8840","\u6B61","\u68B0","\u638C","\u6B4C","\u6C99","\u525B","\u653B","\u8B02","\u76FE","\u8A0E","\u665A","\u7C92","\u4E82","\u71C3","\u77DB","\u4E4E","\u6BBA","\u85E5","\u5BE7","\u9B6F","\u8CB4","\u9418","\u7164","\u8B80","\u73ED","\u4F2F","\u9999","\u4ECB","\u8FEB","\u53E5","\u8C50","\u57F9","\u63E1","\u862D","\u64D4","\u5F26","\u86CB","\u6C89","\u5047","\u7A7F","\u57F7","\u7B54","\u6A02","\u8AB0","\u9806","\u7159","\u7E2E","\u5FB5","\u81C9","\u559C","\u677E","\u8173","\u56F0","\u7570","\u514D","\u80CC","\u661F","\u798F","\u8CB7","\u67D3","\u4E95","\u6982","\u6162","\u6015","\u78C1","\u500D","\u7956","\u7687","\u4FC3","\u975C","\u88DC","\u8A55","\u7FFB","\u8089","\u8E10","\u5C3C","\u8863","\u5BEC","\u63DA","\u68C9","\u5E0C","\u50B7","\u64CD","\u5782","\u79CB","\u5B9C","\u6C2B","\u5957","\u7763","\u632F","\u67B6","\u4EAE","\u672B","\u61B2","\u6176","\u7DE8","\u725B","\u89F8","\u6620","\u96F7","\u92B7","\u8A69","\u5EA7","\u5C45","\u6293","\u88C2","\u80DE","\u547C","\u5A18","\u666F","\u5A01","\u7DA0","\u6676","\u539A","\u76DF","\u8861","\u96DE","\u5B6B","\u5EF6","\u5371","\u81A0","\u5C4B","\u9109","\u81E8","\u9678","\u9867","\u6389","\u5440","\u71C8","\u6B72","\u63AA","\u675F","\u8010","\u5287","\u7389","\u8D99","\u8DF3","\u54E5","\u5B63","\u8AB2","\u51F1","\u80E1","\u984D","\u6B3E","\u7D39","\u5377","\u9F4A","\u5049","\u84B8","\u6B96","\u6C38","\u5B97","\u82D7","\u5DDD","\u7210","\u5CA9","\u5F31","\u96F6","\u694A","\u594F","\u6CBF","\u9732","\u687F","\u63A2","\u6ED1","\u93AE","\u98EF","\u6FC3","\u822A","\u61F7","\u8D95","\u5EAB","\u596A","\u4F0A","\u9748","\u7A05","\u9014","\u6EC5","\u8CFD","\u6B78","\u53EC","\u9F13","\u64AD","\u76E4","\u88C1","\u96AA","\u5EB7","\u552F","\u9304","\u83CC","\u7D14","\u501F","\u7CD6","\u84CB","\u6A6B","\u7B26","\u79C1","\u52AA","\u5802","\u57DF","\u69CD","\u6F64","\u5E45","\u54C8","\u7ADF","\u719F","\u87F2","\u6FA4","\u8166","\u58E4","\u78B3","\u6B50","\u904D","\u5074","\u5BE8","\u6562","\u5FB9","\u616E","\u659C","\u8584","\u5EAD","\u7D0D","\u5F48","\u98FC","\u4F38","\u6298","\u9EA5","\u6FD5","\u6697","\u8377","\u74E6","\u585E","\u5E8A","\u7BC9","\u60E1","\u6236","\u8A2A","\u5854","\u5947","\u900F","\u6881","\u5200","\u65CB","\u8DE1","\u5361","\u6C2F","\u9047","\u4EFD","\u6BD2","\u6CE5","\u9000","\u6D17","\u64FA","\u7070","\u5F69","\u8CE3","\u8017","\u590F","\u64C7","\u5FD9","\u9285","\u737B","\u786C","\u4E88","\u7E41","\u5708","\u96EA","\u51FD","\u4EA6","\u62BD","\u7BC7","\u9663","\u9670","\u4E01","\u5C3A","\u8FFD","\u5806","\u96C4","\u8FCE","\u6CDB","\u7238","\u6A13","\u907F","\u8B00","\u5678","\u91CE","\u8C6C","\u65D7","\u7D2F","\u504F","\u5178","\u9928","\u7D22","\u79E6","\u8102","\u6F6E","\u723A","\u8C46","\u5FFD","\u6258","\u9A5A","\u5851","\u907A","\u6108","\u6731","\u66FF","\u7E96","\u7C97","\u50BE","\u5C1A","\u75DB","\u695A","\u8B1D","\u596E","\u8CFC","\u78E8","\u541B","\u6C60","\u65C1","\u788E","\u9AA8","\u76E3","\u6355","\u5F1F","\u66B4","\u5272","\u8CAB","\u6B8A","\u91CB","\u8A5E","\u4EA1","\u58C1","\u9813","\u5BF6","\u5348","\u5875","\u805E","\u63ED","\u70AE","\u6B98","\u51AC","\u6A4B","\u5A66","\u8B66","\u7D9C","\u62DB","\u5433","\u4ED8","\u6D6E","\u906D","\u5F90","\u60A8","\u6416","\u8C37","\u8D0A","\u7BB1","\u9694","\u8A02","\u7537","\u5439","\u5712","\u7D1B","\u5510","\u6557","\u5B8B","\u73BB","\u5DE8","\u8015","\u5766","\u69AE","\u9589","\u7063","\u9375","\u51E1","\u99D0","\u934B","\u6551","\u6069","\u525D","\u51DD","\u9E7C","\u9F52","\u622A","\u7149","\u9EBB","\u7D21","\u7981","\u5EE2","\u76DB","\u7248","\u7DE9","\u6DE8","\u775B","\u660C","\u5A5A","\u6D89","\u7B52","\u5634","\u63D2","\u5CB8","\u6717","\u838A","\u8857","\u85CF","\u59D1","\u8CBF","\u8150","\u5974","\u5566","\u6163","\u4E58","\u5925","\u6062","\u52FB","\u7D17","\u624E","\u8FAF","\u8033","\u5F6A","\u81E3","\u5104","\u7483","\u62B5","\u8108","\u79C0","\u85A9","\u4FC4","\u7DB2","\u821E","\u5E97","\u5674","\u7E31","\u5BF8","\u6C57","\u639B","\u6D2A","\u8CC0","\u9583","\u67EC","\u7206","\u70EF","\u6D25","\u7A3B","\u7246","\u8EDF","\u52C7","\u50CF","\u6EFE","\u5398","\u8499","\u82B3","\u80AF","\u5761","\u67F1","\u76EA","\u817F","\u5100","\u65C5","\u5C3E","\u8ECB","\u51B0","\u8CA2","\u767B","\u9ECE","\u524A","\u947D","\u52D2","\u9003","\u969C","\u6C28","\u90ED","\u5CF0","\u5E63","\u6E2F","\u4F0F","\u8ECC","\u755D","\u7562","\u64E6","\u83AB","\u523A","\u6D6A","\u79D8","\u63F4","\u682A","\u5065","\u552E","\u80A1","\u5CF6","\u7518","\u6CE1","\u7761","\u7AE5","\u9444","\u6E6F","\u95A5","\u4F11","\u532F","\u820D","\u7267","\u7E5E","\u70B8","\u54F2","\u78F7","\u7E3E","\u670B","\u6DE1","\u5C16","\u555F","\u9677","\u67F4","\u5448","\u5F92","\u984F","\u6DDA","\u7A0D","\u5FD8","\u6CF5","\u85CD","\u62D6","\u6D1E","\u6388","\u93E1","\u8F9B","\u58EF","\u92D2","\u8CA7","\u865B","\u5F4E","\u6469","\u6CF0","\u5E7C","\u5EF7","\u5C0A","\u7A97","\u7DB1","\u5F04","\u96B8","\u7591","\u6C0F","\u5BAE","\u59D0","\u9707","\u745E","\u602A","\u5C24","\u7434","\u5FAA","\u63CF","\u819C","\u9055","\u593E","\u8170","\u7DE3","\u73E0","\u7AAE","\u68EE","\u679D","\u7AF9","\u6E9D","\u50AC","\u7E69","\u61B6","\u90A6","\u5269","\u5E78","\u6F3F","\u6B04","\u64C1","\u7259","\u8CAF","\u79AE","\u6FFE","\u9209","\u7D0B","\u7F77","\u62CD","\u54B1","\u558A","\u8896","\u57C3","\u52E4","\u7F70","\u7126","\u6F5B","\u4F0D","\u58A8","\u6B32","\u7E2B","\u59D3","\u520A","\u98FD","\u4EFF","\u734E","\u92C1","\u9B3C","\u9E97","\u8DE8","\u9ED8","\u6316","\u93C8","\u6383","\u559D","\u888B","\u70AD","\u6C61","\u5E55","\u8AF8","\u5F27","\u52F5","\u6885","\u5976","\u6F54","\u707D","\u821F","\u9451","\u82EF","\u8A1F","\u62B1","\u6BC0","\u61C2","\u5BD2","\u667A","\u57D4","\u5BC4","\u5C46","\u8E8D","\u6E21","\u6311","\u4E39","\u8271","\u8C9D","\u78B0","\u62D4","\u7239","\u6234","\u78BC","\u5922","\u82BD","\u7194","\u8D64","\u6F01","\u54ED","\u656C","\u9846","\u5954","\u925B","\u4EF2","\u864E","\u7A00","\u59B9","\u4E4F","\u73CD","\u7533","\u684C","\u9075","\u5141","\u9686","\u87BA","\u5009","\u9B4F","\u92B3","\u66C9","\u6C2E","\u517C","\u96B1","\u7919","\u8D6B","\u64A5","\u5FE0","\u8085","\u7F38","\u727D","\u6436","\u535A","\u5DE7","\u6BBC","\u5144","\u675C","\u8A0A","\u8AA0","\u78A7","\u7965","\u67EF","\u9801","\u5DE1","\u77E9","\u60B2","\u704C","\u9F61","\u502B","\u7968","\u5C0B","\u6842","\u92EA","\u8056","\u6050","\u6070","\u912D","\u8DA3","\u62AC","\u8352","\u9A30","\u8CBC","\u67D4","\u6EF4","\u731B","\u95CA","\u8F1B","\u59BB","\u586B","\u64A4","\u5132","\u7C3D","\u9B27","\u64FE","\u7D2B","\u7802","\u905E","\u6232","\u540A","\u9676","\u4F10","\u9935","\u7642","\u74F6","\u5A46","\u64AB","\u81C2","\u6478","\u5FCD","\u8766","\u881F","\u9130","\u80F8","\u978F","\u64E0","\u5076","\u68C4","\u69FD","\u52C1","\u4E73","\u9127","\u5409","\u4EC1","\u721B","\u78DA","\u79DF","\u70CF","\u8266","\u4F34","\u74DC","\u6DFA","\u4E19","\u66AB","\u71E5","\u6A61","\u67F3","\u8FF7","\u6696","\u724C","\u79E7","\u81BD","\u8A73","\u7C27","\u8E0F","\u74F7","\u8B5C","\u5446","\u8CD3","\u7CCA","\u6D1B","\u8F1D","\u61A4","\u7AF6","\u9699","\u6012","\u7C98","\u4E43","\u7DD2","\u80A9","\u7C4D","\u654F","\u5857","\u7199","\u7686","\u5075","\u61F8","\u6398","\u4EAB","\u7CFE","\u9192","\u72C2","\u9396","\u6DC0","\u6068","\u7272","\u9738","\u722C","\u8CDE","\u9006","\u73A9","\u9675","\u795D","\u79D2","\u6D59","\u8C8C","\u5F79","\u5F7C","\u6089","\u9D28","\u8DA8","\u9CF3","\u6668","\u755C","\u8F29","\u79E9","\u5375","\u7F72","\u68AF","\u708E","\u7058","\u68CB","\u9A45","\u7BE9","\u5CFD","\u5192","\u5565","\u58FD","\u8B6F","\u6D78","\u6CC9","\u5E3D","\u9072","\u77FD","\u7586","\u8CB8","\u6F0F","\u7A3F","\u51A0","\u5AE9","\u8105","\u82AF","\u7262","\u53DB","\u8755","\u5967","\u9CF4","\u5DBA","\u7F8A","\u6191","\u4E32","\u5858","\u7E6A","\u9175","\u878D","\u76C6","\u932B","\u5EDF","\u7C4C","\u51CD","\u8F14","\u651D","\u8972","\u7B4B","\u62D2","\u50DA","\u65F1","\u9240","\u9CE5","\u6F06","\u6C88","\u7709","\u758F","\u6DFB","\u68D2","\u7A57","\u785D","\u97D3","\u903C","\u626D","\u50D1","\u6DBC","\u633A","\u7897","\u683D","\u7092","\u676F","\u60A3","\u993E","\u52F8","\u8C6A","\u907C","\u52C3","\u9D3B","\u65E6","\u540F","\u62DC","\u72D7","\u57CB","\u8F25","\u63A9","\u98F2","\u642C","\u7F75","\u8FAD","\u52FE","\u6263","\u4F30","\u8523","\u7D68","\u9727","\u4E08","\u6735","\u59C6","\u64EC","\u5B87","\u8F2F","\u965D","\u96D5","\u511F","\u84C4","\u5D07","\u526A","\u5021","\u5EF3","\u54AC","\u99DB","\u85AF","\u5237","\u65A5","\u756A","\u8CE6","\u5949","\u4F5B","\u6F86","\u6F2B","\u66FC","\u6247","\u9223","\u6843","\u6276","\u4ED4","\u8FD4","\u4FD7","\u8667","\u8154","\u978B","\u68F1","\u8986","\u6846","\u6084","\u53D4","\u649E","\u9A19","\u52D8","\u65FA","\u6CB8","\u5B64","\u5410","\u5B5F","\u6E20","\u5C48","\u75BE","\u5999","\u60DC","\u4EF0","\u72E0","\u8139","\u8AE7","\u62CB","\u9EF4","\u6851","\u5D17","\u561B","\u8870","\u76DC","\u6EF2","\u81DF","\u8CF4","\u6E67","\u751C","\u66F9","\u95B1","\u808C","\u54E9","\u53B2","\u70F4","\u7DEF","\u6BC5","\u6628","\u507D","\u75C7","\u716E","\u5606","\u91D8","\u642D","\u8396","\u7C60","\u9177","\u5077","\u5F13","\u9310","\u6046","\u5091","\u5751","\u9F3B","\u7FFC","\u7DB8","\u6558","\u7344","\u902E","\u7F50","\u7D61","\u68DA","\u6291","\u81A8","\u852C","\u5BFA","\u9A5F","\u7A46","\u51B6","\u67AF","\u518A","\u5C4D","\u51F8","\u7D33","\u576F","\u72A7","\u7130","\u8F5F","\u6B23","\u6649","\u7626","\u79A6","\u9320","\u9326","\u55AA","\u65EC","\u935B","\u58DF","\u641C","\u64B2","\u9080","\u4EAD","\u916F","\u9081","\u8212","\u8106","\u9176","\u9592","\u6182","\u915A","\u9811","\u7FBD","\u6F32","\u5378","\u4ED7","\u966A","\u95E2","\u61F2","\u676D","\u59DA","\u809A","\u6349","\u98C4","\u6F02","\u6606","\u6B3A","\u543E","\u90CE","\u70F7","\u6C41","\u5475","\u98FE","\u856D","\u96C5","\u90F5","\u9077","\u71D5","\u6492","\u59FB","\u8D74","\u5BB4","\u7169","\u50B5","\u5E33","\u6591","\u9234","\u65E8","\u9187","\u8463","\u9905","\u96DB","\u59FF","\u62CC","\u5085","\u8179","\u59A5","\u63C9","\u8CE2","\u62C6","\u6B6A","\u8461","\u80FA","\u4E1F","\u6D69","\u5FBD","\u6602","\u588A","\u64CB","\u89BD","\u8CAA","\u6170","\u7E73","\u6C6A","\u614C","\u99AE","\u8AFE","\u59DC","\u8ABC","\u5147","\u52A3","\u8AA3","\u8000","\u660F","\u8EBA","\u76C8","\u9A0E","\u55AC","\u6EAA","\u53E2","\u76E7","\u62B9","\u60B6","\u8AEE","\u522E","\u99D5","\u7E9C","\u609F","\u6458","\u927A","\u64F2","\u9817","\u5E7B","\u67C4","\u60E0","\u6158","\u4F73","\u4EC7","\u81D8","\u7AA9","\u6ECC","\u528D","\u77A7","\u5821","\u6F51","\u8525","\u7F69","\u970D","\u6488","\u80CE","\u84BC","\u6FF1","\u5006","\u6345","\u6E58","\u780D","\u971E","\u90B5","\u8404","\u760B","\u6DEE","\u9042","\u718A","\u7CDE","\u70D8","\u5BBF","\u6A94","\u6208","\u99C1","\u5AC2","\u88D5","\u5F99","\u7BAD","\u6350","\u8178","\u6490","\u66EC","\u8FA8","\u6BBF","\u84EE","\u6524","\u652A","\u91AC","\u5C4F","\u75AB","\u54C0","\u8521","\u5835","\u6CAB","\u76BA","\u66A2","\u758A","\u95A3","\u840A","\u6572","\u8F44","\u9264","\u75D5","\u58E9","\u5DF7","\u9913","\u798D","\u4E18","\u7384","\u6E9C","\u66F0","\u908F","\u5F6D","\u5617","\u537F","\u59A8","\u8247","\u541E","\u97CB","\u6028","\u77EE","\u6B47"]');

},{}],"5UaH2":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('["\u1100\u1161\u1100\u1167\u11A8","\u1100\u1161\u1101\u1173\u11B7","\u1100\u1161\u1102\u1161\u11AB","\u1100\u1161\u1102\u1173\u11BC","\u1100\u1161\u1103\u1173\u11A8","\u1100\u1161\u1105\u1173\u110E\u1175\u11B7","\u1100\u1161\u1106\u116E\u11B7","\u1100\u1161\u1107\u1161\u11BC","\u1100\u1161\u1109\u1161\u11BC","\u1100\u1161\u1109\u1173\u11B7","\u1100\u1161\u110B\u116E\u11AB\u1103\u1166","\u1100\u1161\u110B\u1173\u11AF","\u1100\u1161\u110B\u1175\u1103\u1173","\u1100\u1161\u110B\u1175\u11B8","\u1100\u1161\u110C\u1161\u11BC","\u1100\u1161\u110C\u1165\u11BC","\u1100\u1161\u110C\u1169\u11A8","\u1100\u1161\u110C\u116E\u11A8","\u1100\u1161\u11A8\u110B\u1169","\u1100\u1161\u11A8\u110C\u1161","\u1100\u1161\u11AB\u1100\u1167\u11A8","\u1100\u1161\u11AB\u1107\u116E","\u1100\u1161\u11AB\u1109\u1165\u11B8","\u1100\u1161\u11AB\u110C\u1161\u11BC","\u1100\u1161\u11AB\u110C\u1165\u11B8","\u1100\u1161\u11AB\u1111\u1161\u11AB","\u1100\u1161\u11AF\u1103\u1173\u11BC","\u1100\u1161\u11AF\u1107\u1175","\u1100\u1161\u11AF\u1109\u1162\u11A8","\u1100\u1161\u11AF\u110C\u1173\u11BC","\u1100\u1161\u11B7\u1100\u1161\u11A8","\u1100\u1161\u11B7\u1100\u1175","\u1100\u1161\u11B7\u1109\u1169","\u1100\u1161\u11B7\u1109\u116E\u1109\u1165\u11BC","\u1100\u1161\u11B7\u110C\u1161","\u1100\u1161\u11B7\u110C\u1165\u11BC","\u1100\u1161\u11B8\u110C\u1161\u1100\u1175","\u1100\u1161\u11BC\u1102\u1161\u11B7","\u1100\u1161\u11BC\u1103\u1161\u11BC","\u1100\u1161\u11BC\u1103\u1169","\u1100\u1161\u11BC\u1105\u1167\u11A8\u1112\u1175","\u1100\u1161\u11BC\u1107\u1167\u11AB","\u1100\u1161\u11BC\u1107\u116E\u11A8","\u1100\u1161\u11BC\u1109\u1161","\u1100\u1161\u11BC\u1109\u116E\u1105\u1163\u11BC","\u1100\u1161\u11BC\u110B\u1161\u110C\u1175","\u1100\u1161\u11BC\u110B\u116F\u11AB\u1103\u1169","\u1100\u1161\u11BC\u110B\u1174","\u1100\u1161\u11BC\u110C\u1166","\u1100\u1161\u11BC\u110C\u1169","\u1100\u1161\u11C0\u110B\u1175","\u1100\u1162\u1100\u116E\u1105\u1175","\u1100\u1162\u1102\u1161\u1105\u1175","\u1100\u1162\u1107\u1161\u11BC","\u1100\u1162\u1107\u1167\u11AF","\u1100\u1162\u1109\u1165\u11AB","\u1100\u1162\u1109\u1165\u11BC","\u1100\u1162\u110B\u1175\u11AB","\u1100\u1162\u11A8\u1100\u116A\u11AB\u110C\u1165\u11A8","\u1100\u1165\u1109\u1175\u11AF","\u1100\u1165\u110B\u1162\u11A8","\u1100\u1165\u110B\u116E\u11AF","\u1100\u1165\u110C\u1175\u11BA","\u1100\u1165\u1111\u116E\u11B7","\u1100\u1165\u11A8\u110C\u1165\u11BC","\u1100\u1165\u11AB\u1100\u1161\u11BC","\u1100\u1165\u11AB\u1106\u116E\u11AF","\u1100\u1165\u11AB\u1109\u1165\u11AF","\u1100\u1165\u11AB\u110C\u1169","\u1100\u1165\u11AB\u110E\u116E\u11A8","\u1100\u1165\u11AF\u110B\u1173\u11B7","\u1100\u1165\u11B7\u1109\u1161","\u1100\u1165\u11B7\u1110\u1169","\u1100\u1166\u1109\u1175\u1111\u1161\u11AB","\u1100\u1166\u110B\u1175\u11B7","\u1100\u1167\u110B\u116E\u11AF","\u1100\u1167\u11AB\u1112\u1162","\u1100\u1167\u11AF\u1100\u116A","\u1100\u1167\u11AF\u1100\u116E\u11A8","\u1100\u1167\u11AF\u1105\u1169\u11AB","\u1100\u1167\u11AF\u1109\u1165\u11A8","\u1100\u1167\u11AF\u1109\u1173\u11BC","\u1100\u1167\u11AF\u1109\u1175\u11B7","\u1100\u1167\u11AF\u110C\u1165\u11BC","\u1100\u1167\u11AF\u1112\u1169\u11AB","\u1100\u1167\u11BC\u1100\u1168","\u1100\u1167\u11BC\u1100\u1169","\u1100\u1167\u11BC\u1100\u1175","\u1100\u1167\u11BC\u1105\u1167\u11A8","\u1100\u1167\u11BC\u1107\u1169\u11A8\u1100\u116E\u11BC","\u1100\u1167\u11BC\u1107\u1175","\u1100\u1167\u11BC\u1109\u1161\u11BC\u1103\u1169","\u1100\u1167\u11BC\u110B\u1167\u11BC","\u1100\u1167\u11BC\u110B\u116E","\u1100\u1167\u11BC\u110C\u1162\u11BC","\u1100\u1167\u11BC\u110C\u1166","\u1100\u1167\u11BC\u110C\u116E","\u1100\u1167\u11BC\u110E\u1161\u11AF","\u1100\u1167\u11BC\u110E\u1175","\u1100\u1167\u11BC\u1112\u1163\u11BC","\u1100\u1167\u11BC\u1112\u1165\u11B7","\u1100\u1168\u1100\u1169\u11A8","\u1100\u1168\u1103\u1161\u11AB","\u1100\u1168\u1105\u1161\u11AB","\u1100\u1168\u1109\u1161\u11AB","\u1100\u1168\u1109\u1169\u11A8","\u1100\u1168\u110B\u1163\u11A8","\u1100\u1168\u110C\u1165\u11AF","\u1100\u1168\u110E\u1173\u11BC","\u1100\u1168\u1112\u116C\u11A8","\u1100\u1169\u1100\u1162\u11A8","\u1100\u1169\u1100\u116E\u1105\u1167","\u1100\u1169\u1100\u116E\u11BC","\u1100\u1169\u1100\u1173\u11B8","\u1100\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1100\u1169\u1106\u116E\u1109\u1175\u11AB","\u1100\u1169\u1106\u1175\u11AB","\u1100\u1169\u110B\u1163\u11BC\u110B\u1175","\u1100\u1169\u110C\u1161\u11BC","\u1100\u1169\u110C\u1165\u11AB","\u1100\u1169\u110C\u1175\u11B8","\u1100\u1169\u110E\u116E\u11BA\u1100\u1161\u1105\u116E","\u1100\u1169\u1110\u1169\u11BC","\u1100\u1169\u1112\u1163\u11BC","\u1100\u1169\u11A8\u1109\u1175\u11A8","\u1100\u1169\u11AF\u1106\u1169\u11A8","\u1100\u1169\u11AF\u110D\u1161\u1100\u1175","\u1100\u1169\u11AF\u1111\u1173","\u1100\u1169\u11BC\u1100\u1161\u11AB","\u1100\u1169\u11BC\u1100\u1162","\u1100\u1169\u11BC\u1100\u1167\u11A8","\u1100\u1169\u11BC\u1100\u116E\u11AB","\u1100\u1169\u11BC\u1100\u1173\u11B8","\u1100\u1169\u11BC\u1100\u1175","\u1100\u1169\u11BC\u1103\u1169\u11BC","\u1100\u1169\u11BC\u1106\u116E\u110B\u116F\u11AB","\u1100\u1169\u11BC\u1107\u116E","\u1100\u1169\u11BC\u1109\u1161","\u1100\u1169\u11BC\u1109\u1175\u11A8","\u1100\u1169\u11BC\u110B\u1165\u11B8","\u1100\u1169\u11BC\u110B\u1167\u11AB","\u1100\u1169\u11BC\u110B\u116F\u11AB","\u1100\u1169\u11BC\u110C\u1161\u11BC","\u1100\u1169\u11BC\u110D\u1161","\u1100\u1169\u11BC\u110E\u1162\u11A8","\u1100\u1169\u11BC\u1110\u1169\u11BC","\u1100\u1169\u11BC\u1111\u1169","\u1100\u1169\u11BC\u1112\u1161\u11BC","\u1100\u1169\u11BC\u1112\u1172\u110B\u1175\u11AF","\u1100\u116A\u1106\u1169\u11A8","\u1100\u116A\u110B\u1175\u11AF","\u1100\u116A\u110C\u1161\u11BC","\u1100\u116A\u110C\u1165\u11BC","\u1100\u116A\u1112\u1161\u11A8","\u1100\u116A\u11AB\u1100\u1162\u11A8","\u1100\u116A\u11AB\u1100\u1168","\u1100\u116A\u11AB\u1100\u116A\u11BC","\u1100\u116A\u11AB\u1102\u1167\u11B7","\u1100\u116A\u11AB\u1105\u1161\u11B7","\u1100\u116A\u11AB\u1105\u1167\u11AB","\u1100\u116A\u11AB\u1105\u1175","\u1100\u116A\u11AB\u1109\u1173\u11B8","\u1100\u116A\u11AB\u1109\u1175\u11B7","\u1100\u116A\u11AB\u110C\u1165\u11B7","\u1100\u116A\u11AB\u110E\u1161\u11AF","\u1100\u116A\u11BC\u1100\u1167\u11BC","\u1100\u116A\u11BC\u1100\u1169","\u1100\u116A\u11BC\u110C\u1161\u11BC","\u1100\u116A\u11BC\u110C\u116E","\u1100\u116C\u1105\u1169\u110B\u116E\u11B7","\u1100\u116C\u11BC\u110C\u1161\u11BC\u1112\u1175","\u1100\u116D\u1100\u116A\u1109\u1165","\u1100\u116D\u1106\u116E\u11AB","\u1100\u116D\u1107\u1169\u11A8","\u1100\u116D\u1109\u1175\u11AF","\u1100\u116D\u110B\u1163\u11BC","\u1100\u116D\u110B\u1172\u11A8","\u1100\u116D\u110C\u1161\u11BC","\u1100\u116D\u110C\u1175\u11A8","\u1100\u116D\u1110\u1169\u11BC","\u1100\u116D\u1112\u116A\u11AB","\u1100\u116D\u1112\u116E\u11AB","\u1100\u116E\u1100\u1167\u11BC","\u1100\u116E\u1105\u1173\u11B7","\u1100\u116E\u1106\u1165\u11BC","\u1100\u116E\u1107\u1167\u11AF","\u1100\u116E\u1107\u116E\u11AB","\u1100\u116E\u1109\u1165\u11A8","\u1100\u116E\u1109\u1165\u11BC","\u1100\u116E\u1109\u1169\u11A8","\u1100\u116E\u110B\u1167\u11A8","\u1100\u116E\u110B\u1175\u11B8","\u1100\u116E\u110E\u1165\u11BC","\u1100\u116E\u110E\u1166\u110C\u1165\u11A8","\u1100\u116E\u11A8\u1100\u1161","\u1100\u116E\u11A8\u1100\u1175","\u1100\u116E\u11A8\u1102\u1162","\u1100\u116E\u11A8\u1105\u1175\u11B8","\u1100\u116E\u11A8\u1106\u116E\u11AF","\u1100\u116E\u11A8\u1106\u1175\u11AB","\u1100\u116E\u11A8\u1109\u116E","\u1100\u116E\u11A8\u110B\u1165","\u1100\u116E\u11A8\u110B\u116A\u11BC","\u1100\u116E\u11A8\u110C\u1165\u11A8","\u1100\u116E\u11A8\u110C\u1166","\u1100\u116E\u11A8\u1112\u116C","\u1100\u116E\u11AB\u1103\u1162","\u1100\u116E\u11AB\u1109\u1161","\u1100\u116E\u11AB\u110B\u1175\u11AB","\u1100\u116E\u11BC\u1100\u1173\u11A8\u110C\u1165\u11A8","\u1100\u116F\u11AB\u1105\u1175","\u1100\u116F\u11AB\u110B\u1171","\u1100\u116F\u11AB\u1110\u116E","\u1100\u1171\u1100\u116E\u11A8","\u1100\u1171\u1109\u1175\u11AB","\u1100\u1172\u110C\u1165\u11BC","\u1100\u1172\u110E\u1175\u11A8","\u1100\u1172\u11AB\u1112\u1167\u11BC","\u1100\u1173\u1102\u1161\u11AF","\u1100\u1173\u1102\u1163\u11BC","\u1100\u1173\u1102\u1173\u11AF","\u1100\u1173\u1105\u1165\u1102\u1161","\u1100\u1173\u1105\u116E\u11B8","\u1100\u1173\u1105\u1173\u11BA","\u1100\u1173\u1105\u1175\u11B7","\u1100\u1173\u110C\u1166\u1109\u1165\u110B\u1163","\u1100\u1173\u1110\u1169\u1105\u1169\u11A8","\u1100\u1173\u11A8\u1107\u1169\u11A8","\u1100\u1173\u11A8\u1112\u1175","\u1100\u1173\u11AB\u1100\u1165","\u1100\u1173\u11AB\u1100\u116D","\u1100\u1173\u11AB\u1105\u1162","\u1100\u1173\u11AB\u1105\u1169","\u1100\u1173\u11AB\u1106\u116E","\u1100\u1173\u11AB\u1107\u1169\u11AB","\u1100\u1173\u11AB\u110B\u116F\u11AB","\u1100\u1173\u11AB\u110B\u1172\u11A8","\u1100\u1173\u11AB\u110E\u1165","\u1100\u1173\u11AF\u110A\u1175","\u1100\u1173\u11AF\u110C\u1161","\u1100\u1173\u11B7\u1100\u1161\u11BC\u1109\u1161\u11AB","\u1100\u1173\u11B7\u1100\u1169","\u1100\u1173\u11B7\u1102\u1167\u11AB","\u1100\u1173\u11B7\u1106\u1166\u1103\u1161\u11AF","\u1100\u1173\u11B7\u110B\u1162\u11A8","\u1100\u1173\u11B7\u110B\u1167\u11AB","\u1100\u1173\u11B7\u110B\u116D\u110B\u1175\u11AF","\u1100\u1173\u11B7\u110C\u1175","\u1100\u1173\u11BC\u110C\u1165\u11BC\u110C\u1165\u11A8","\u1100\u1175\u1100\u1161\u11AB","\u1100\u1175\u1100\u116A\u11AB","\u1100\u1175\u1102\u1167\u11B7","\u1100\u1175\u1102\u1173\u11BC","\u1100\u1175\u1103\u1169\u11A8\u1100\u116D","\u1100\u1175\u1103\u116E\u11BC","\u1100\u1175\u1105\u1169\u11A8","\u1100\u1175\u1105\u1173\u11B7","\u1100\u1175\u1107\u1165\u11B8","\u1100\u1175\u1107\u1169\u11AB","\u1100\u1175\u1107\u116E\u11AB","\u1100\u1175\u1108\u1173\u11B7","\u1100\u1175\u1109\u116E\u11A8\u1109\u1161","\u1100\u1175\u1109\u116E\u11AF","\u1100\u1175\u110B\u1165\u11A8","\u1100\u1175\u110B\u1165\u11B8","\u1100\u1175\u110B\u1169\u11AB","\u1100\u1175\u110B\u116E\u11AB","\u1100\u1175\u110B\u116F\u11AB","\u1100\u1175\u110C\u1165\u11A8","\u1100\u1175\u110C\u116E\u11AB","\u1100\u1175\u110E\u1175\u11B7","\u1100\u1175\u1112\u1169\u11AB","\u1100\u1175\u1112\u116C\u11A8","\u1100\u1175\u11AB\u1100\u1173\u11B8","\u1100\u1175\u11AB\u110C\u1161\u11BC","\u1100\u1175\u11AF\u110B\u1175","\u1100\u1175\u11B7\u1107\u1161\u11B8","\u1100\u1175\u11B7\u110E\u1175","\u1100\u1175\u11B7\u1111\u1169\u1100\u1169\u11BC\u1112\u1161\u11BC","\u1101\u1161\u11A8\u1103\u116E\u1100\u1175","\u1101\u1161\u11B7\u1108\u1161\u11A8","\u1101\u1162\u1103\u1161\u11AF\u110B\u1173\u11B7","\u1101\u1162\u1109\u1169\u1100\u1173\u11B7","\u1101\u1165\u11B8\u110C\u1175\u11AF","\u1101\u1169\u11A8\u1103\u1162\u1100\u1175","\u1101\u1169\u11BE\u110B\u1175\u11C1","\u1102\u1161\u1103\u1173\u11AF\u110B\u1175","\u1102\u1161\u1105\u1161\u11AB\u1112\u1175","\u1102\u1161\u1106\u1165\u110C\u1175","\u1102\u1161\u1106\u116E\u11AF","\u1102\u1161\u110E\u1175\u11B7\u1107\u1161\u11AB","\u1102\u1161\u1112\u1173\u11AF","\u1102\u1161\u11A8\u110B\u1167\u11B8","\u1102\u1161\u11AB\u1107\u1161\u11BC","\u1102\u1161\u11AF\u1100\u1162","\u1102\u1161\u11AF\u110A\u1175","\u1102\u1161\u11AF\u110D\u1161","\u1102\u1161\u11B7\u1102\u1167","\u1102\u1161\u11B7\u1103\u1162\u1106\u116E\u11AB","\u1102\u1161\u11B7\u1106\u1162","\u1102\u1161\u11B7\u1109\u1161\u11AB","\u1102\u1161\u11B7\u110C\u1161","\u1102\u1161\u11B7\u1111\u1167\u11AB","\u1102\u1161\u11B7\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1102\u1161\u11BC\u1107\u1175","\u1102\u1161\u11C0\u1106\u1161\u11AF","\u1102\u1162\u1102\u1167\u11AB","\u1102\u1162\u110B\u116D\u11BC","\u1102\u1162\u110B\u1175\u11AF","\u1102\u1162\u11B7\u1107\u1175","\u1102\u1162\u11B7\u1109\u1162","\u1102\u1162\u11BA\u1106\u116E\u11AF","\u1102\u1162\u11BC\u1103\u1169\u11BC","\u1102\u1162\u11BC\u1106\u1167\u11AB","\u1102\u1162\u11BC\u1107\u1161\u11BC","\u1102\u1162\u11BC\u110C\u1161\u11BC\u1100\u1169","\u1102\u1166\u11A8\u1110\u1161\u110B\u1175","\u1102\u1166\u11BA\u110D\u1162","\u1102\u1169\u1103\u1169\u11BC","\u1102\u1169\u1105\u1161\u11AB\u1109\u1162\u11A8","\u1102\u1169\u1105\u1167\u11A8","\u1102\u1169\u110B\u1175\u11AB","\u1102\u1169\u11A8\u110B\u1173\u11B7","\u1102\u1169\u11A8\u110E\u1161","\u1102\u1169\u11A8\u1112\u116A","\u1102\u1169\u11AB\u1105\u1175","\u1102\u1169\u11AB\u1106\u116E\u11AB","\u1102\u1169\u11AB\u110C\u1162\u11BC","\u1102\u1169\u11AF\u110B\u1175","\u1102\u1169\u11BC\u1100\u116E","\u1102\u1169\u11BC\u1103\u1161\u11B7","\u1102\u1169\u11BC\u1106\u1175\u11AB","\u1102\u1169\u11BC\u1107\u116E","\u1102\u1169\u11BC\u110B\u1165\u11B8","\u1102\u1169\u11BC\u110C\u1161\u11BC","\u1102\u1169\u11BC\u110E\u1169\u11AB","\u1102\u1169\u11C1\u110B\u1175","\u1102\u116E\u11AB\u1103\u1169\u11BC\u110C\u1161","\u1102\u116E\u11AB\u1106\u116E\u11AF","\u1102\u116E\u11AB\u110A\u1165\u11B8","\u1102\u1172\u110B\u116D\u11A8","\u1102\u1173\u1101\u1175\u11B7","\u1102\u1173\u11A8\u1103\u1162","\u1102\u1173\u11BC\u1103\u1169\u11BC\u110C\u1165\u11A8","\u1102\u1173\u11BC\u1105\u1167\u11A8","\u1103\u1161\u1107\u1161\u11BC","\u1103\u1161\u110B\u1163\u11BC\u1109\u1165\u11BC","\u1103\u1161\u110B\u1173\u11B7","\u1103\u1161\u110B\u1175\u110B\u1165\u1110\u1173","\u1103\u1161\u1112\u1162\u11BC","\u1103\u1161\u11AB\u1100\u1168","\u1103\u1161\u11AB\u1100\u1169\u11AF","\u1103\u1161\u11AB\u1103\u1169\u11A8","\u1103\u1161\u11AB\u1106\u1161\u11BA","\u1103\u1161\u11AB\u1109\u116E\u11AB","\u1103\u1161\u11AB\u110B\u1165","\u1103\u1161\u11AB\u110B\u1171","\u1103\u1161\u11AB\u110C\u1165\u11B7","\u1103\u1161\u11AB\u110E\u1166","\u1103\u1161\u11AB\u110E\u116E","\u1103\u1161\u11AB\u1111\u1167\u11AB","\u1103\u1161\u11AB\u1111\u116E\u11BC","\u1103\u1161\u11AF\u1100\u1163\u11AF","\u1103\u1161\u11AF\u1105\u1165","\u1103\u1161\u11AF\u1105\u1167\u11A8","\u1103\u1161\u11AF\u1105\u1175","\u1103\u1161\u11B0\u1100\u1169\u1100\u1175","\u1103\u1161\u11B7\u1103\u1161\u11BC","\u1103\u1161\u11B7\u1107\u1162","\u1103\u1161\u11B7\u110B\u116D","\u1103\u1161\u11B7\u110B\u1175\u11B7","\u1103\u1161\u11B8\u1107\u1167\u11AB","\u1103\u1161\u11B8\u110C\u1161\u11BC","\u1103\u1161\u11BC\u1100\u1173\u11AB","\u1103\u1161\u11BC\u1107\u116E\u11AB\u1100\u1161\u11AB","\u1103\u1161\u11BC\u110B\u1167\u11AB\u1112\u1175","\u1103\u1161\u11BC\u110C\u1161\u11BC","\u1103\u1162\u1100\u1172\u1106\u1169","\u1103\u1162\u1102\u1161\u11BD","\u1103\u1162\u1103\u1161\u11AB\u1112\u1175","\u1103\u1162\u1103\u1161\u11B8","\u1103\u1162\u1103\u1169\u1109\u1175","\u1103\u1162\u1105\u1163\u11A8","\u1103\u1162\u1105\u1163\u11BC","\u1103\u1162\u1105\u1172\u11A8","\u1103\u1162\u1106\u116E\u11AB","\u1103\u1162\u1107\u116E\u1107\u116E\u11AB","\u1103\u1162\u1109\u1175\u11AB","\u1103\u1162\u110B\u1173\u11BC","\u1103\u1162\u110C\u1161\u11BC","\u1103\u1162\u110C\u1165\u11AB","\u1103\u1162\u110C\u1165\u11B8","\u1103\u1162\u110C\u116E\u11BC","\u1103\u1162\u110E\u1162\u11A8","\u1103\u1162\u110E\u116E\u11AF","\u1103\u1162\u110E\u116E\u11BC","\u1103\u1162\u1110\u1169\u11BC\u1105\u1167\u11BC","\u1103\u1162\u1112\u1161\u11A8","\u1103\u1162\u1112\u1161\u11AB\u1106\u1175\u11AB\u1100\u116E\u11A8","\u1103\u1162\u1112\u1161\u11B8\u1109\u1175\u11AF","\u1103\u1162\u1112\u1167\u11BC","\u1103\u1165\u11BC\u110B\u1165\u1105\u1175","\u1103\u1166\u110B\u1175\u1110\u1173","\u1103\u1169\u1103\u1162\u110E\u1166","\u1103\u1169\u1103\u1165\u11A8","\u1103\u1169\u1103\u116E\u11A8","\u1103\u1169\u1106\u1161\u11BC","\u1103\u1169\u1109\u1165\u1100\u116A\u11AB","\u1103\u1169\u1109\u1175\u11B7","\u1103\u1169\u110B\u116E\u11B7","\u1103\u1169\u110B\u1175\u11B8","\u1103\u1169\u110C\u1161\u1100\u1175","\u1103\u1169\u110C\u1165\u1112\u1175","\u1103\u1169\u110C\u1165\u11AB","\u1103\u1169\u110C\u116E\u11BC","\u1103\u1169\u110E\u1161\u11A8","\u1103\u1169\u11A8\u1100\u1161\u11B7","\u1103\u1169\u11A8\u1105\u1175\u11B8","\u1103\u1169\u11A8\u1109\u1165","\u1103\u1169\u11A8\u110B\u1175\u11AF","\u1103\u1169\u11A8\u110E\u1161\u11BC\u110C\u1165\u11A8","\u1103\u1169\u11BC\u1112\u116A\u110E\u1162\u11A8","\u1103\u1171\u11BA\u1106\u1169\u1109\u1173\u11B8","\u1103\u1171\u11BA\u1109\u1161\u11AB","\u1104\u1161\u11AF\u110B\u1161\u110B\u1175","\u1106\u1161\u1102\u116E\u1105\u1161","\u1106\u1161\u1102\u1173\u11AF","\u1106\u1161\u1103\u1161\u11BC","\u1106\u1161\u1105\u1161\u1110\u1169\u11AB","\u1106\u1161\u1105\u1167\u11AB","\u1106\u1161\u1106\u116E\u1105\u1175","\u1106\u1161\u1109\u1161\u110C\u1175","\u1106\u1161\u110B\u1163\u11A8","\u1106\u1161\u110B\u116D\u1102\u1166\u110C\u1173","\u1106\u1161\u110B\u1173\u11AF","\u1106\u1161\u110B\u1173\u11B7","\u1106\u1161\u110B\u1175\u110F\u1173","\u1106\u1161\u110C\u116E\u11BC","\u1106\u1161\u110C\u1175\u1106\u1161\u11A8","\u1106\u1161\u110E\u1161\u11AB\u1100\u1161\u110C\u1175","\u1106\u1161\u110E\u1161\u11AF","\u1106\u1161\u1112\u1173\u11AB","\u1106\u1161\u11A8\u1100\u1165\u11AF\u1105\u1175","\u1106\u1161\u11A8\u1102\u1162","\u1106\u1161\u11A8\u1109\u1161\u11BC","\u1106\u1161\u11AB\u1102\u1161\u11B7","\u1106\u1161\u11AB\u1103\u116E","\u1106\u1161\u11AB\u1109\u1166","\u1106\u1161\u11AB\u110B\u1163\u11A8","\u1106\u1161\u11AB\u110B\u1175\u11AF","\u1106\u1161\u11AB\u110C\u1165\u11B7","\u1106\u1161\u11AB\u110C\u1169\u11A8","\u1106\u1161\u11AB\u1112\u116A","\u1106\u1161\u11AD\u110B\u1175","\u1106\u1161\u11AF\u1100\u1175","\u1106\u1161\u11AF\u110A\u1173\u11B7","\u1106\u1161\u11AF\u1110\u116E","\u1106\u1161\u11B7\u1103\u1162\u1105\u1169","\u1106\u1161\u11BC\u110B\u116F\u11AB\u1100\u1167\u11BC","\u1106\u1162\u1102\u1167\u11AB","\u1106\u1162\u1103\u1161\u11AF","\u1106\u1162\u1105\u1167\u11A8","\u1106\u1162\u1107\u1165\u11AB","\u1106\u1162\u1109\u1173\u110F\u1165\u11B7","\u1106\u1162\u110B\u1175\u11AF","\u1106\u1162\u110C\u1161\u11BC","\u1106\u1162\u11A8\u110C\u116E","\u1106\u1165\u11A8\u110B\u1175","\u1106\u1165\u11AB\u110C\u1165","\u1106\u1165\u11AB\u110C\u1175","\u1106\u1165\u11AF\u1105\u1175","\u1106\u1166\u110B\u1175\u11AF","\u1106\u1167\u1102\u1173\u1105\u1175","\u1106\u1167\u110E\u1175\u11AF","\u1106\u1167\u11AB\u1103\u1161\u11B7","\u1106\u1167\u11AF\u110E\u1175","\u1106\u1167\u11BC\u1103\u1161\u11AB","\u1106\u1167\u11BC\u1105\u1167\u11BC","\u1106\u1167\u11BC\u110B\u1168","\u1106\u1167\u11BC\u110B\u1174","\u1106\u1167\u11BC\u110C\u1165\u11AF","\u1106\u1167\u11BC\u110E\u1175\u11BC","\u1106\u1167\u11BC\u1112\u1161\u11B7","\u1106\u1169\u1100\u1173\u11B7","\u1106\u1169\u1102\u1175\u1110\u1165","\u1106\u1169\u1103\u1166\u11AF","\u1106\u1169\u1103\u1173\u11AB","\u1106\u1169\u1107\u1165\u11B7","\u1106\u1169\u1109\u1173\u11B8","\u1106\u1169\u110B\u1163\u11BC","\u1106\u1169\u110B\u1175\u11B7","\u1106\u1169\u110C\u1169\u1105\u1175","\u1106\u1169\u110C\u1175\u11B8","\u1106\u1169\u1110\u116E\u11BC\u110B\u1175","\u1106\u1169\u11A8\u1100\u1165\u11AF\u110B\u1175","\u1106\u1169\u11A8\u1105\u1169\u11A8","\u1106\u1169\u11A8\u1109\u1161","\u1106\u1169\u11A8\u1109\u1169\u1105\u1175","\u1106\u1169\u11A8\u1109\u116E\u11B7","\u1106\u1169\u11A8\u110C\u1165\u11A8","\u1106\u1169\u11A8\u1111\u116D","\u1106\u1169\u11AF\u1105\u1162","\u1106\u1169\u11B7\u1106\u1162","\u1106\u1169\u11B7\u1106\u116E\u1100\u1166","\u1106\u1169\u11B7\u1109\u1161\u11AF","\u1106\u1169\u11B7\u1109\u1169\u11A8","\u1106\u1169\u11B7\u110C\u1175\u11BA","\u1106\u1169\u11B7\u1110\u1169\u11BC","\u1106\u1169\u11B8\u1109\u1175","\u1106\u116E\u1100\u116A\u11AB\u1109\u1175\u11B7","\u1106\u116E\u1100\u116E\u11BC\u1112\u116A","\u1106\u116E\u1103\u1165\u110B\u1171","\u1106\u116E\u1103\u1165\u11B7","\u1106\u116E\u1105\u1173\u11C1","\u1106\u116E\u1109\u1173\u11AB","\u1106\u116E\u110B\u1165\u11BA","\u1106\u116E\u110B\u1167\u11A8","\u1106\u116E\u110B\u116D\u11BC","\u1106\u116E\u110C\u1169\u1100\u1165\u11AB","\u1106\u116E\u110C\u1175\u1100\u1162","\u1106\u116E\u110E\u1165\u11A8","\u1106\u116E\u11AB\u1100\u116E","\u1106\u116E\u11AB\u1103\u1173\u11A8","\u1106\u116E\u11AB\u1107\u1165\u11B8","\u1106\u116E\u11AB\u1109\u1165","\u1106\u116E\u11AB\u110C\u1166","\u1106\u116E\u11AB\u1112\u1161\u11A8","\u1106\u116E\u11AB\u1112\u116A","\u1106\u116E\u11AF\u1100\u1161","\u1106\u116E\u11AF\u1100\u1165\u11AB","\u1106\u116E\u11AF\u1100\u1167\u11AF","\u1106\u116E\u11AF\u1100\u1169\u1100\u1175","\u1106\u116E\u11AF\u1105\u1169\u11AB","\u1106\u116E\u11AF\u1105\u1175\u1112\u1161\u11A8","\u1106\u116E\u11AF\u110B\u1173\u11B7","\u1106\u116E\u11AF\u110C\u1175\u11AF","\u1106\u116E\u11AF\u110E\u1166","\u1106\u1175\u1100\u116E\u11A8","\u1106\u1175\u1103\u1175\u110B\u1165","\u1106\u1175\u1109\u1161\u110B\u1175\u11AF","\u1106\u1175\u1109\u116E\u11AF","\u1106\u1175\u110B\u1167\u11A8","\u1106\u1175\u110B\u116D\u11BC\u1109\u1175\u11AF","\u1106\u1175\u110B\u116E\u11B7","\u1106\u1175\u110B\u1175\u11AB","\u1106\u1175\u1110\u1175\u11BC","\u1106\u1175\u1112\u1169\u11AB","\u1106\u1175\u11AB\u1100\u1161\u11AB","\u1106\u1175\u11AB\u110C\u1169\u11A8","\u1106\u1175\u11AB\u110C\u116E","\u1106\u1175\u11AE\u110B\u1173\u11B7","\u1106\u1175\u11AF\u1100\u1161\u1105\u116E","\u1106\u1175\u11AF\u1105\u1175\u1106\u1175\u1110\u1165","\u1106\u1175\u11C0\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u1100\u1161\u110C\u1175","\u1107\u1161\u1100\u116E\u1102\u1175","\u1107\u1161\u1102\u1161\u1102\u1161","\u1107\u1161\u1102\u1173\u11AF","\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u1103\u1161\u11BA\u1100\u1161","\u1107\u1161\u1105\u1161\u11B7","\u1107\u1161\u110B\u1175\u1105\u1165\u1109\u1173","\u1107\u1161\u1110\u1161\u11BC","\u1107\u1161\u11A8\u1106\u116E\u11AF\u1100\u116A\u11AB","\u1107\u1161\u11A8\u1109\u1161","\u1107\u1161\u11A8\u1109\u116E","\u1107\u1161\u11AB\u1103\u1162","\u1107\u1161\u11AB\u1103\u1173\u1109\u1175","\u1107\u1161\u11AB\u1106\u1161\u11AF","\u1107\u1161\u11AB\u1107\u1161\u11AF","\u1107\u1161\u11AB\u1109\u1165\u11BC","\u1107\u1161\u11AB\u110B\u1173\u11BC","\u1107\u1161\u11AB\u110C\u1161\u11BC","\u1107\u1161\u11AB\u110C\u116E\u11A8","\u1107\u1161\u11AB\u110C\u1175","\u1107\u1161\u11AB\u110E\u1161\u11AB","\u1107\u1161\u11AE\u110E\u1175\u11B7","\u1107\u1161\u11AF\u1100\u1161\u1105\u1161\u11A8","\u1107\u1161\u11AF\u1100\u1165\u11AF\u110B\u1173\u11B7","\u1107\u1161\u11AF\u1100\u1167\u11AB","\u1107\u1161\u11AF\u1103\u1161\u11AF","\u1107\u1161\u11AF\u1105\u1166","\u1107\u1161\u11AF\u1106\u1169\u11A8","\u1107\u1161\u11AF\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u11AF\u1109\u1162\u11BC","\u1107\u1161\u11AF\u110B\u1173\u11B7","\u1107\u1161\u11AF\u110C\u1161\u1100\u116E\u11A8","\u1107\u1161\u11AF\u110C\u1165\u11AB","\u1107\u1161\u11AF\u1110\u1169\u11B8","\u1107\u1161\u11AF\u1111\u116D","\u1107\u1161\u11B7\u1112\u1161\u1102\u1173\u11AF","\u1107\u1161\u11B8\u1100\u1173\u1105\u1173\u11BA","\u1107\u1161\u11B8\u1106\u1161\u11BA","\u1107\u1161\u11B8\u1109\u1161\u11BC","\u1107\u1161\u11B8\u1109\u1169\u11C0","\u1107\u1161\u11BC\u1100\u1173\u11B7","\u1107\u1161\u11BC\u1106\u1167\u11AB","\u1107\u1161\u11BC\u1106\u116E\u11AB","\u1107\u1161\u11BC\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u11BC\u1107\u1165\u11B8","\u1107\u1161\u11BC\u1109\u1169\u11BC","\u1107\u1161\u11BC\u1109\u1175\u11A8","\u1107\u1161\u11BC\u110B\u1161\u11AB","\u1107\u1161\u11BC\u110B\u116E\u11AF","\u1107\u1161\u11BC\u110C\u1175","\u1107\u1161\u11BC\u1112\u1161\u11A8","\u1107\u1161\u11BC\u1112\u1162","\u1107\u1161\u11BC\u1112\u1163\u11BC","\u1107\u1162\u1100\u1167\u11BC","\u1107\u1162\u1101\u1169\u11B8","\u1107\u1162\u1103\u1161\u11AF","\u1107\u1162\u1103\u1173\u1106\u1175\u11AB\u1110\u1165\u11AB","\u1107\u1162\u11A8\u1103\u116E\u1109\u1161\u11AB","\u1107\u1162\u11A8\u1109\u1162\u11A8","\u1107\u1162\u11A8\u1109\u1165\u11BC","\u1107\u1162\u11A8\u110B\u1175\u11AB","\u1107\u1162\u11A8\u110C\u1166","\u1107\u1162\u11A8\u1112\u116A\u110C\u1165\u11B7","\u1107\u1165\u1105\u1173\u11BA","\u1107\u1165\u1109\u1165\u11BA","\u1107\u1165\u1110\u1173\u11AB","\u1107\u1165\u11AB\u1100\u1162","\u1107\u1165\u11AB\u110B\u1167\u11A8","\u1107\u1165\u11AB\u110C\u1175","\u1107\u1165\u11AB\u1112\u1169","\u1107\u1165\u11AF\u1100\u1173\u11B7","\u1107\u1165\u11AF\u1105\u1166","\u1107\u1165\u11AF\u110A\u1165","\u1107\u1165\u11B7\u110B\u1171","\u1107\u1165\u11B7\u110B\u1175\u11AB","\u1107\u1165\u11B7\u110C\u116C","\u1107\u1165\u11B8\u1105\u1172\u11AF","\u1107\u1165\u11B8\u110B\u116F\u11AB","\u1107\u1165\u11B8\u110C\u1165\u11A8","\u1107\u1165\u11B8\u110E\u1175\u11A8","\u1107\u1166\u110B\u1175\u110C\u1175\u11BC","\u1107\u1166\u11AF\u1110\u1173","\u1107\u1167\u11AB\u1100\u1167\u11BC","\u1107\u1167\u11AB\u1103\u1169\u11BC","\u1107\u1167\u11AB\u1106\u1167\u11BC","\u1107\u1167\u11AB\u1109\u1175\u11AB","\u1107\u1167\u11AB\u1112\u1169\u1109\u1161","\u1107\u1167\u11AB\u1112\u116A","\u1107\u1167\u11AF\u1103\u1169","\u1107\u1167\u11AF\u1106\u1167\u11BC","\u1107\u1167\u11AF\u110B\u1175\u11AF","\u1107\u1167\u11BC\u1109\u1175\u11AF","\u1107\u1167\u11BC\u110B\u1161\u1105\u1175","\u1107\u1167\u11BC\u110B\u116F\u11AB","\u1107\u1169\u1100\u116A\u11AB","\u1107\u1169\u1102\u1165\u1109\u1173","\u1107\u1169\u1105\u1161\u1109\u1162\u11A8","\u1107\u1169\u1105\u1161\u11B7","\u1107\u1169\u1105\u1173\u11B7","\u1107\u1169\u1109\u1161\u11BC","\u1107\u1169\u110B\u1161\u11AB","\u1107\u1169\u110C\u1161\u1100\u1175","\u1107\u1169\u110C\u1161\u11BC","\u1107\u1169\u110C\u1165\u11AB","\u1107\u1169\u110C\u1169\u11AB","\u1107\u1169\u1110\u1169\u11BC","\u1107\u1169\u1111\u1167\u11AB\u110C\u1165\u11A8","\u1107\u1169\u1112\u1165\u11B7","\u1107\u1169\u11A8\u1103\u1169","\u1107\u1169\u11A8\u1109\u1161","\u1107\u1169\u11A8\u1109\u116E\u11BC\u110B\u1161","\u1107\u1169\u11A8\u1109\u1173\u11B8","\u1107\u1169\u11A9\u110B\u1173\u11B7","\u1107\u1169\u11AB\u1100\u1167\u11A8\u110C\u1165\u11A8","\u1107\u1169\u11AB\u1105\u1162","\u1107\u1169\u11AB\u1107\u116E","\u1107\u1169\u11AB\u1109\u1161","\u1107\u1169\u11AB\u1109\u1165\u11BC","\u1107\u1169\u11AB\u110B\u1175\u11AB","\u1107\u1169\u11AB\u110C\u1175\u11AF","\u1107\u1169\u11AF\u1111\u1166\u11AB","\u1107\u1169\u11BC\u1109\u1161","\u1107\u1169\u11BC\u110C\u1175","\u1107\u1169\u11BC\u1110\u116E","\u1107\u116E\u1100\u1173\u11AB","\u1107\u116E\u1101\u1173\u1105\u1165\u110B\u116E\u11B7","\u1107\u116E\u1103\u1161\u11B7","\u1107\u116E\u1103\u1169\u11BC\u1109\u1161\u11AB","\u1107\u116E\u1106\u116E\u11AB","\u1107\u116E\u1107\u116E\u11AB","\u1107\u116E\u1109\u1161\u11AB","\u1107\u116E\u1109\u1161\u11BC","\u1107\u116E\u110B\u1165\u11BF","\u1107\u116E\u110B\u1175\u11AB","\u1107\u116E\u110C\u1161\u11A8\u110B\u116D\u11BC","\u1107\u116E\u110C\u1161\u11BC","\u1107\u116E\u110C\u1165\u11BC","\u1107\u116E\u110C\u1169\u11A8","\u1107\u116E\u110C\u1175\u1105\u1165\u11AB\u1112\u1175","\u1107\u116E\u110E\u1175\u11AB","\u1107\u116E\u1110\u1161\u11A8","\u1107\u116E\u1111\u116E\u11B7","\u1107\u116E\u1112\u116C\u110C\u1161\u11BC","\u1107\u116E\u11A8\u1107\u116E","\u1107\u116E\u11A8\u1112\u1161\u11AB","\u1107\u116E\u11AB\u1102\u1169","\u1107\u116E\u11AB\u1105\u1163\u11BC","\u1107\u116E\u11AB\u1105\u1175","\u1107\u116E\u11AB\u1106\u1167\u11BC","\u1107\u116E\u11AB\u1109\u1165\u11A8","\u1107\u116E\u11AB\u110B\u1163","\u1107\u116E\u11AB\u110B\u1171\u1100\u1175","\u1107\u116E\u11AB\u1111\u1175\u11AF","\u1107\u116E\u11AB\u1112\u1169\u11BC\u1109\u1162\u11A8","\u1107\u116E\u11AF\u1100\u1169\u1100\u1175","\u1107\u116E\u11AF\u1100\u116A","\u1107\u116E\u11AF\u1100\u116D","\u1107\u116E\u11AF\u1101\u1169\u11BE","\u1107\u116E\u11AF\u1106\u1161\u11AB","\u1107\u116E\u11AF\u1107\u1165\u11B8","\u1107\u116E\u11AF\u1107\u1175\u11BE","\u1107\u116E\u11AF\u110B\u1161\u11AB","\u1107\u116E\u11AF\u110B\u1175\u110B\u1175\u11A8","\u1107\u116E\u11AF\u1112\u1162\u11BC","\u1107\u1173\u1105\u1162\u11AB\u1103\u1173","\u1107\u1175\u1100\u1173\u11A8","\u1107\u1175\u1102\u1161\u11AB","\u1107\u1175\u1102\u1175\u11AF","\u1107\u1175\u1103\u116E\u11AF\u1100\u1175","\u1107\u1175\u1103\u1175\u110B\u1169","\u1107\u1175\u1105\u1169\u1109\u1169","\u1107\u1175\u1106\u1161\u11AB","\u1107\u1175\u1106\u1167\u11BC","\u1107\u1175\u1106\u1175\u11AF","\u1107\u1175\u1107\u1161\u1105\u1161\u11B7","\u1107\u1175\u1107\u1175\u11B7\u1107\u1161\u11B8","\u1107\u1175\u1109\u1161\u11BC","\u1107\u1175\u110B\u116D\u11BC","\u1107\u1175\u110B\u1172\u11AF","\u1107\u1175\u110C\u116E\u11BC","\u1107\u1175\u1110\u1161\u1106\u1175\u11AB","\u1107\u1175\u1111\u1161\u11AB","\u1107\u1175\u11AF\u1103\u1175\u11BC","\u1107\u1175\u11BA\u1106\u116E\u11AF","\u1107\u1175\u11BA\u1107\u1161\u11BC\u110B\u116E\u11AF","\u1107\u1175\u11BA\u110C\u116E\u11AF\u1100\u1175","\u1107\u1175\u11BE\u1101\u1161\u11AF","\u1108\u1161\u11AF\u1100\u1161\u11AB\u1109\u1162\u11A8","\u1108\u1161\u11AF\u1105\u1162","\u1108\u1161\u11AF\u1105\u1175","\u1109\u1161\u1100\u1165\u11AB","\u1109\u1161\u1100\u1168\u110C\u1165\u11AF","\u1109\u1161\u1102\u1161\u110B\u1175","\u1109\u1161\u1102\u1163\u11BC","\u1109\u1161\u1105\u1161\u11B7","\u1109\u1161\u1105\u1161\u11BC","\u1109\u1161\u1105\u1175\u11B8","\u1109\u1161\u1106\u1169\u1102\u1175\u11B7","\u1109\u1161\u1106\u116E\u11AF","\u1109\u1161\u1107\u1161\u11BC","\u1109\u1161\u1109\u1161\u11BC","\u1109\u1161\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1161\u1109\u1165\u11AF","\u1109\u1161\u1109\u1173\u11B7","\u1109\u1161\u1109\u1175\u11AF","\u1109\u1161\u110B\u1165\u11B8","\u1109\u1161\u110B\u116D\u11BC","\u1109\u1161\u110B\u116F\u11AF","\u1109\u1161\u110C\u1161\u11BC","\u1109\u1161\u110C\u1165\u11AB","\u1109\u1161\u110C\u1175\u11AB","\u1109\u1161\u110E\u1169\u11AB","\u1109\u1161\u110E\u116E\u11AB\u1100\u1175","\u1109\u1161\u1110\u1161\u11BC","\u1109\u1161\u1110\u116E\u1105\u1175","\u1109\u1161\u1112\u1173\u11AF","\u1109\u1161\u11AB\u1100\u1175\u11AF","\u1109\u1161\u11AB\u1107\u116E\u110B\u1175\u11AB\u1100\u116A","\u1109\u1161\u11AB\u110B\u1165\u11B8","\u1109\u1161\u11AB\u110E\u1162\u11A8","\u1109\u1161\u11AF\u1105\u1175\u11B7","\u1109\u1161\u11AF\u110B\u1175\u11AB","\u1109\u1161\u11AF\u110D\u1161\u11A8","\u1109\u1161\u11B7\u1100\u1168\u1110\u1161\u11BC","\u1109\u1161\u11B7\u1100\u116E\u11A8","\u1109\u1161\u11B7\u1109\u1175\u11B8","\u1109\u1161\u11B7\u110B\u116F\u11AF","\u1109\u1161\u11B7\u110E\u1169\u11AB","\u1109\u1161\u11BC\u1100\u116A\u11AB","\u1109\u1161\u11BC\u1100\u1173\u11B7","\u1109\u1161\u11BC\u1103\u1162","\u1109\u1161\u11BC\u1105\u1172","\u1109\u1161\u11BC\u1107\u1161\u11AB\u1100\u1175","\u1109\u1161\u11BC\u1109\u1161\u11BC","\u1109\u1161\u11BC\u1109\u1175\u11A8","\u1109\u1161\u11BC\u110B\u1165\u11B8","\u1109\u1161\u11BC\u110B\u1175\u11AB","\u1109\u1161\u11BC\u110C\u1161","\u1109\u1161\u11BC\u110C\u1165\u11B7","\u1109\u1161\u11BC\u110E\u1165","\u1109\u1161\u11BC\u110E\u116E","\u1109\u1161\u11BC\u1110\u1162","\u1109\u1161\u11BC\u1111\u116D","\u1109\u1161\u11BC\u1111\u116E\u11B7","\u1109\u1161\u11BC\u1112\u116A\u11BC","\u1109\u1162\u1107\u1167\u11A8","\u1109\u1162\u11A8\u1101\u1161\u11AF","\u1109\u1162\u11A8\u110B\u1167\u11AB\u1111\u1175\u11AF","\u1109\u1162\u11BC\u1100\u1161\u11A8","\u1109\u1162\u11BC\u1106\u1167\u11BC","\u1109\u1162\u11BC\u1106\u116E\u11AF","\u1109\u1162\u11BC\u1107\u1161\u11BC\u1109\u1169\u11BC","\u1109\u1162\u11BC\u1109\u1161\u11AB","\u1109\u1162\u11BC\u1109\u1165\u11AB","\u1109\u1162\u11BC\u1109\u1175\u11AB","\u1109\u1162\u11BC\u110B\u1175\u11AF","\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1165\u1105\u1161\u11B8","\u1109\u1165\u1105\u1173\u11AB","\u1109\u1165\u1106\u1167\u11BC","\u1109\u1165\u1106\u1175\u11AB","\u1109\u1165\u1107\u1175\u1109\u1173","\u1109\u1165\u110B\u1163\u11BC","\u1109\u1165\u110B\u116E\u11AF","\u1109\u1165\u110C\u1165\u11A8","\u1109\u1165\u110C\u1165\u11B7","\u1109\u1165\u110D\u1169\u11A8","\u1109\u1165\u110F\u1173\u11AF","\u1109\u1165\u11A8\u1109\u1161","\u1109\u1165\u11A8\u110B\u1172","\u1109\u1165\u11AB\u1100\u1165","\u1109\u1165\u11AB\u1106\u116E\u11AF","\u1109\u1165\u11AB\u1107\u1162","\u1109\u1165\u11AB\u1109\u1162\u11BC","\u1109\u1165\u11AB\u1109\u116E","\u1109\u1165\u11AB\u110B\u116F\u11AB","\u1109\u1165\u11AB\u110C\u1161\u11BC","\u1109\u1165\u11AB\u110C\u1165\u11AB","\u1109\u1165\u11AB\u1110\u1162\u11A8","\u1109\u1165\u11AB\u1111\u116E\u11BC\u1100\u1175","\u1109\u1165\u11AF\u1100\u1165\u110C\u1175","\u1109\u1165\u11AF\u1102\u1161\u11AF","\u1109\u1165\u11AF\u1105\u1165\u11BC\u1110\u1161\u11BC","\u1109\u1165\u11AF\u1106\u1167\u11BC","\u1109\u1165\u11AF\u1106\u116E\u11AB","\u1109\u1165\u11AF\u1109\u1161","\u1109\u1165\u11AF\u110B\u1161\u11A8\u1109\u1161\u11AB","\u1109\u1165\u11AF\u110E\u1175","\u1109\u1165\u11AF\u1110\u1161\u11BC","\u1109\u1165\u11B8\u110A\u1175","\u1109\u1165\u11BC\u1100\u1169\u11BC","\u1109\u1165\u11BC\u1103\u1161\u11BC","\u1109\u1165\u11BC\u1106\u1167\u11BC","\u1109\u1165\u11BC\u1107\u1167\u11AF","\u1109\u1165\u11BC\u110B\u1175\u11AB","\u1109\u1165\u11BC\u110C\u1161\u11BC","\u1109\u1165\u11BC\u110C\u1165\u11A8","\u1109\u1165\u11BC\u110C\u1175\u11AF","\u1109\u1165\u11BC\u1112\u1161\u11B7","\u1109\u1166\u1100\u1173\u11B7","\u1109\u1166\u1106\u1175\u1102\u1161","\u1109\u1166\u1109\u1161\u11BC","\u1109\u1166\u110B\u116F\u11AF","\u1109\u1166\u110C\u1169\u11BC\u1103\u1162\u110B\u116A\u11BC","\u1109\u1166\u1110\u1161\u11A8","\u1109\u1166\u11AB\u1110\u1165","\u1109\u1166\u11AB\u1110\u1175\u1106\u1175\u1110\u1165","\u1109\u1166\u11BA\u110D\u1162","\u1109\u1169\u1100\u1172\u1106\u1169","\u1109\u1169\u1100\u1173\u11A8\u110C\u1165\u11A8","\u1109\u1169\u1100\u1173\u11B7","\u1109\u1169\u1102\u1161\u1100\u1175","\u1109\u1169\u1102\u1167\u11AB","\u1109\u1169\u1103\u1173\u11A8","\u1109\u1169\u1106\u1161\u11BC","\u1109\u1169\u1106\u116E\u11AB","\u1109\u1169\u1109\u1165\u11AF","\u1109\u1169\u1109\u1169\u11A8","\u1109\u1169\u110B\u1161\u1100\u116A","\u1109\u1169\u110B\u116D\u11BC","\u1109\u1169\u110B\u116F\u11AB","\u1109\u1169\u110B\u1173\u11B7","\u1109\u1169\u110C\u116E\u11BC\u1112\u1175","\u1109\u1169\u110C\u1175\u1111\u116E\u11B7","\u1109\u1169\u110C\u1175\u11AF","\u1109\u1169\u1111\u116E\u11BC","\u1109\u1169\u1112\u1167\u11BC","\u1109\u1169\u11A8\u1103\u1161\u11B7","\u1109\u1169\u11A8\u1103\u1169","\u1109\u1169\u11A8\u110B\u1169\u11BA","\u1109\u1169\u11AB\u1100\u1161\u1105\u1161\u11A8","\u1109\u1169\u11AB\u1100\u1175\u11AF","\u1109\u1169\u11AB\u1102\u1167","\u1109\u1169\u11AB\u1102\u1175\u11B7","\u1109\u1169\u11AB\u1103\u1173\u11BC","\u1109\u1169\u11AB\u1106\u1169\u11A8","\u1109\u1169\u11AB\u1108\u1167\u11A8","\u1109\u1169\u11AB\u1109\u1175\u11AF","\u1109\u1169\u11AB\u110C\u1175\u11AF","\u1109\u1169\u11AB\u1110\u1169\u11B8","\u1109\u1169\u11AB\u1112\u1162","\u1109\u1169\u11AF\u110C\u1175\u11A8\u1112\u1175","\u1109\u1169\u11B7\u110A\u1175","\u1109\u1169\u11BC\u110B\u1161\u110C\u1175","\u1109\u1169\u11BC\u110B\u1175","\u1109\u1169\u11BC\u1111\u1167\u11AB","\u1109\u116C\u1100\u1169\u1100\u1175","\u1109\u116D\u1111\u1175\u11BC","\u1109\u116E\u1100\u1165\u11AB","\u1109\u116E\u1102\u1167\u11AB","\u1109\u116E\u1103\u1161\u11AB","\u1109\u116E\u1103\u1169\u11BA\u1106\u116E\u11AF","\u1109\u116E\u1103\u1169\u11BC\u110C\u1165\u11A8","\u1109\u116E\u1106\u1167\u11AB","\u1109\u116E\u1106\u1167\u11BC","\u1109\u116E\u1107\u1161\u11A8","\u1109\u116E\u1109\u1161\u11BC","\u1109\u116E\u1109\u1165\u11A8","\u1109\u116E\u1109\u116E\u11AF","\u1109\u116E\u1109\u1175\u1105\u1169","\u1109\u116E\u110B\u1165\u11B8","\u1109\u116E\u110B\u1167\u11B7","\u1109\u116E\u110B\u1167\u11BC","\u1109\u116E\u110B\u1175\u11B8","\u1109\u116E\u110C\u116E\u11AB","\u1109\u116E\u110C\u1175\u11B8","\u1109\u116E\u110E\u116E\u11AF","\u1109\u116E\u110F\u1165\u11BA","\u1109\u116E\u1111\u1175\u11AF","\u1109\u116E\u1112\u1161\u11A8","\u1109\u116E\u1112\u1165\u11B7\u1109\u1162\u11BC","\u1109\u116E\u1112\u116A\u1100\u1175","\u1109\u116E\u11A8\u1102\u1167","\u1109\u116E\u11A8\u1109\u1169","\u1109\u116E\u11A8\u110C\u1166","\u1109\u116E\u11AB\u1100\u1161\u11AB","\u1109\u116E\u11AB\u1109\u1165","\u1109\u116E\u11AB\u1109\u116E","\u1109\u116E\u11AB\u1109\u1175\u11A8\u1100\u1161\u11AB","\u1109\u116E\u11AB\u110B\u1171","\u1109\u116E\u11AE\u1100\u1161\u1105\u1161\u11A8","\u1109\u116E\u11AF\u1107\u1167\u11BC","\u1109\u116E\u11AF\u110C\u1175\u11B8","\u1109\u116E\u11BA\u110C\u1161","\u1109\u1173\u1102\u1175\u11B7","\u1109\u1173\u1106\u116E\u11AF","\u1109\u1173\u1109\u1173\u1105\u1169","\u1109\u1173\u1109\u1173\u11BC","\u1109\u1173\u110B\u1170\u1110\u1165","\u1109\u1173\u110B\u1171\u110E\u1175","\u1109\u1173\u110F\u1166\u110B\u1175\u1110\u1173","\u1109\u1173\u1110\u1172\u1103\u1175\u110B\u1169","\u1109\u1173\u1110\u1173\u1105\u1166\u1109\u1173","\u1109\u1173\u1111\u1169\u110E\u1173","\u1109\u1173\u11AF\u110D\u1165\u11A8","\u1109\u1173\u11AF\u1111\u1173\u11B7","\u1109\u1173\u11B8\u1100\u116A\u11AB","\u1109\u1173\u11B8\u1100\u1175","\u1109\u1173\u11BC\u1100\u1162\u11A8","\u1109\u1173\u11BC\u1105\u1175","\u1109\u1173\u11BC\u1107\u116E","\u1109\u1173\u11BC\u110B\u116D\u11BC\u110E\u1161","\u1109\u1173\u11BC\u110C\u1175\u11AB","\u1109\u1175\u1100\u1161\u11A8","\u1109\u1175\u1100\u1161\u11AB","\u1109\u1175\u1100\u1169\u11AF","\u1109\u1175\u1100\u1173\u11B7\u110E\u1175","\u1109\u1175\u1102\u1161\u1105\u1175\u110B\u1169","\u1109\u1175\u1103\u1162\u11A8","\u1109\u1175\u1105\u1175\u110C\u1173","\u1109\u1175\u1106\u1166\u11AB\u1110\u1173","\u1109\u1175\u1106\u1175\u11AB","\u1109\u1175\u1107\u116E\u1106\u1169","\u1109\u1175\u1109\u1165\u11AB","\u1109\u1175\u1109\u1165\u11AF","\u1109\u1175\u1109\u1173\u1110\u1166\u11B7","\u1109\u1175\u110B\u1161\u1107\u1165\u110C\u1175","\u1109\u1175\u110B\u1165\u1106\u1165\u1102\u1175","\u1109\u1175\u110B\u116F\u11AF","\u1109\u1175\u110B\u1175\u11AB","\u1109\u1175\u110B\u1175\u11AF","\u1109\u1175\u110C\u1161\u11A8","\u1109\u1175\u110C\u1161\u11BC","\u1109\u1175\u110C\u1165\u11AF","\u1109\u1175\u110C\u1165\u11B7","\u1109\u1175\u110C\u116E\u11BC","\u1109\u1175\u110C\u1173\u11AB","\u1109\u1175\u110C\u1175\u11B8","\u1109\u1175\u110E\u1165\u11BC","\u1109\u1175\u1112\u1161\u11B8","\u1109\u1175\u1112\u1165\u11B7","\u1109\u1175\u11A8\u1100\u116E","\u1109\u1175\u11A8\u1100\u1175","\u1109\u1175\u11A8\u1103\u1161\u11BC","\u1109\u1175\u11A8\u1105\u1163\u11BC","\u1109\u1175\u11A8\u1105\u116D\u1111\u116E\u11B7","\u1109\u1175\u11A8\u1106\u116E\u11AF","\u1109\u1175\u11A8\u1108\u1161\u11BC","\u1109\u1175\u11A8\u1109\u1161","\u1109\u1175\u11A8\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1175\u11A8\u110E\u1169","\u1109\u1175\u11A8\u1110\u1161\u11A8","\u1109\u1175\u11A8\u1111\u116E\u11B7","\u1109\u1175\u11AB\u1100\u1169","\u1109\u1175\u11AB\u1100\u1172","\u1109\u1175\u11AB\u1102\u1167\u11B7","\u1109\u1175\u11AB\u1106\u116E\u11AB","\u1109\u1175\u11AB\u1107\u1161\u11AF","\u1109\u1175\u11AB\u1107\u1175","\u1109\u1175\u11AB\u1109\u1161","\u1109\u1175\u11AB\u1109\u1166","\u1109\u1175\u11AB\u110B\u116D\u11BC","\u1109\u1175\u11AB\u110C\u1166\u1111\u116E\u11B7","\u1109\u1175\u11AB\u110E\u1165\u11BC","\u1109\u1175\u11AB\u110E\u1166","\u1109\u1175\u11AB\u1112\u116A","\u1109\u1175\u11AF\u1100\u1161\u11B7","\u1109\u1175\u11AF\u1102\u1162","\u1109\u1175\u11AF\u1105\u1167\u11A8","\u1109\u1175\u11AF\u1105\u1168","\u1109\u1175\u11AF\u1106\u1161\u11BC","\u1109\u1175\u11AF\u1109\u116E","\u1109\u1175\u11AF\u1109\u1173\u11B8","\u1109\u1175\u11AF\u1109\u1175","\u1109\u1175\u11AF\u110C\u1161\u11BC","\u1109\u1175\u11AF\u110C\u1165\u11BC","\u1109\u1175\u11AF\u110C\u1175\u11AF\u110C\u1165\u11A8","\u1109\u1175\u11AF\u110E\u1165\u11AB","\u1109\u1175\u11AF\u110E\u1166","\u1109\u1175\u11AF\u110F\u1165\u11BA","\u1109\u1175\u11AF\u1110\u1162","\u1109\u1175\u11AF\u1111\u1162","\u1109\u1175\u11AF\u1112\u1165\u11B7","\u1109\u1175\u11AF\u1112\u1167\u11AB","\u1109\u1175\u11B7\u1105\u1175","\u1109\u1175\u11B7\u1107\u116E\u1105\u1173\u11B7","\u1109\u1175\u11B7\u1109\u1161","\u1109\u1175\u11B7\u110C\u1161\u11BC","\u1109\u1175\u11B7\u110C\u1165\u11BC","\u1109\u1175\u11B7\u1111\u1161\u11AB","\u110A\u1161\u11BC\u1103\u116E\u11BC\u110B\u1175","\u110A\u1175\u1105\u1173\u11B7","\u110A\u1175\u110B\u1161\u11BA","\u110B\u1161\u1100\u1161\u110A\u1175","\u110B\u1161\u1102\u1161\u110B\u116E\u11AB\u1109\u1165","\u110B\u1161\u1103\u1173\u1102\u1175\u11B7","\u110B\u1161\u1103\u1173\u11AF","\u110B\u1161\u1109\u1171\u110B\u116E\u11B7","\u110B\u1161\u1109\u1173\u1111\u1161\u11AF\u1110\u1173","\u110B\u1161\u1109\u1175\u110B\u1161","\u110B\u1161\u110B\u116E\u11AF\u1105\u1165","\u110B\u1161\u110C\u1165\u110A\u1175","\u110B\u1161\u110C\u116E\u11B7\u1106\u1161","\u110B\u1161\u110C\u1175\u11A8","\u110B\u1161\u110E\u1175\u11B7","\u110B\u1161\u1111\u1161\u1110\u1173","\u110B\u1161\u1111\u1173\u1105\u1175\u110F\u1161","\u110B\u1161\u1111\u1173\u11B7","\u110B\u1161\u1112\u1169\u11B8","\u110B\u1161\u1112\u1173\u11AB","\u110B\u1161\u11A8\u1100\u1175","\u110B\u1161\u11A8\u1106\u1169\u11BC","\u110B\u1161\u11A8\u1109\u116E","\u110B\u1161\u11AB\u1100\u1162","\u110B\u1161\u11AB\u1100\u1167\u11BC","\u110B\u1161\u11AB\u1100\u116A","\u110B\u1161\u11AB\u1102\u1162","\u110B\u1161\u11AB\u1102\u1167\u11BC","\u110B\u1161\u11AB\u1103\u1169\u11BC","\u110B\u1161\u11AB\u1107\u1161\u11BC","\u110B\u1161\u11AB\u1107\u116E","\u110B\u1161\u11AB\u110C\u116E","\u110B\u1161\u11AF\u1105\u116E\u1106\u1175\u1102\u1172\u11B7","\u110B\u1161\u11AF\u110F\u1169\u110B\u1169\u11AF","\u110B\u1161\u11B7\u1109\u1175","\u110B\u1161\u11B7\u110F\u1165\u11BA","\u110B\u1161\u11B8\u1105\u1167\u11A8","\u110B\u1161\u11C1\u1102\u1161\u11AF","\u110B\u1161\u11C1\u1106\u116E\u11AB","\u110B\u1162\u110B\u1175\u11AB","\u110B\u1162\u110C\u1165\u11BC","\u110B\u1162\u11A8\u1109\u116E","\u110B\u1162\u11AF\u1107\u1165\u11B7","\u110B\u1163\u1100\u1161\u11AB","\u110B\u1163\u1103\u1161\u11AB","\u110B\u1163\u110B\u1169\u11BC","\u110B\u1163\u11A8\u1100\u1161\u11AB","\u110B\u1163\u11A8\u1100\u116E\u11A8","\u110B\u1163\u11A8\u1109\u1169\u11A8","\u110B\u1163\u11A8\u1109\u116E","\u110B\u1163\u11A8\u110C\u1165\u11B7","\u110B\u1163\u11A8\u1111\u116E\u11B7","\u110B\u1163\u11A8\u1112\u1169\u11AB\u1102\u1167","\u110B\u1163\u11BC\u1102\u1167\u11B7","\u110B\u1163\u11BC\u1105\u1167\u11A8","\u110B\u1163\u11BC\u1106\u1161\u11AF","\u110B\u1163\u11BC\u1107\u1162\u110E\u116E","\u110B\u1163\u11BC\u110C\u116E","\u110B\u1163\u11BC\u1111\u1161","\u110B\u1165\u1103\u116E\u11B7","\u110B\u1165\u1105\u1167\u110B\u116E\u11B7","\u110B\u1165\u1105\u1173\u11AB","\u110B\u1165\u110C\u1166\u11BA\u1107\u1161\u11B7","\u110B\u1165\u110D\u1162\u11BB\u1103\u1173\u11AB","\u110B\u1165\u110D\u1165\u1103\u1161\u1100\u1161","\u110B\u1165\u110D\u1165\u11AB\u110C\u1175","\u110B\u1165\u11AB\u1102\u1175","\u110B\u1165\u11AB\u1103\u1165\u11A8","\u110B\u1165\u11AB\u1105\u1169\u11AB","\u110B\u1165\u11AB\u110B\u1165","\u110B\u1165\u11AF\u1100\u116E\u11AF","\u110B\u1165\u11AF\u1105\u1173\u11AB","\u110B\u1165\u11AF\u110B\u1173\u11B7","\u110B\u1165\u11AF\u1111\u1175\u11BA","\u110B\u1165\u11B7\u1106\u1161","\u110B\u1165\u11B8\u1106\u116E","\u110B\u1165\u11B8\u110C\u1169\u11BC","\u110B\u1165\u11B8\u110E\u1166","\u110B\u1165\u11BC\u1103\u1165\u11BC\u110B\u1175","\u110B\u1165\u11BC\u1106\u1161\u11BC","\u110B\u1165\u11BC\u1110\u1165\u1105\u1175","\u110B\u1165\u11BD\u1100\u1173\u110C\u1166","\u110B\u1166\u1102\u1165\u110C\u1175","\u110B\u1166\u110B\u1165\u110F\u1165\u11AB","\u110B\u1166\u11AB\u110C\u1175\u11AB","\u110B\u1167\u1100\u1165\u11AB","\u110B\u1167\u1100\u1169\u1109\u1162\u11BC","\u110B\u1167\u1100\u116A\u11AB","\u110B\u1167\u1100\u116E\u11AB","\u110B\u1167\u1100\u116F\u11AB","\u110B\u1167\u1103\u1162\u1109\u1162\u11BC","\u110B\u1167\u1103\u1165\u11B2","\u110B\u1167\u1103\u1169\u11BC\u1109\u1162\u11BC","\u110B\u1167\u1103\u1173\u11AB","\u110B\u1167\u1105\u1169\u11AB","\u110B\u1167\u1105\u1173\u11B7","\u110B\u1167\u1109\u1165\u11BA","\u110B\u1167\u1109\u1165\u11BC","\u110B\u1167\u110B\u116A\u11BC","\u110B\u1167\u110B\u1175\u11AB","\u110B\u1167\u110C\u1165\u11AB\u1112\u1175","\u110B\u1167\u110C\u1175\u11A8\u110B\u116F\u11AB","\u110B\u1167\u1112\u1161\u11A8\u1109\u1162\u11BC","\u110B\u1167\u1112\u1162\u11BC","\u110B\u1167\u11A8\u1109\u1161","\u110B\u1167\u11A8\u1109\u1175","\u110B\u1167\u11A8\u1112\u1161\u11AF","\u110B\u1167\u11AB\u1100\u1167\u11AF","\u110B\u1167\u11AB\u1100\u116E","\u110B\u1167\u11AB\u1100\u1173\u11A8","\u110B\u1167\u11AB\u1100\u1175","\u110B\u1167\u11AB\u1105\u1161\u11A8","\u110B\u1167\u11AB\u1109\u1165\u11AF","\u110B\u1167\u11AB\u1109\u1166","\u110B\u1167\u11AB\u1109\u1169\u11A8","\u110B\u1167\u11AB\u1109\u1173\u11B8","\u110B\u1167\u11AB\u110B\u1162","\u110B\u1167\u11AB\u110B\u1168\u110B\u1175\u11AB","\u110B\u1167\u11AB\u110B\u1175\u11AB","\u110B\u1167\u11AB\u110C\u1161\u11BC","\u110B\u1167\u11AB\u110C\u116E","\u110B\u1167\u11AB\u110E\u116E\u11AF","\u110B\u1167\u11AB\u1111\u1175\u11AF","\u110B\u1167\u11AB\u1112\u1161\u11B8","\u110B\u1167\u11AB\u1112\u1172","\u110B\u1167\u11AF\u1100\u1175","\u110B\u1167\u11AF\u1106\u1162","\u110B\u1167\u11AF\u1109\u116C","\u110B\u1167\u11AF\u1109\u1175\u11B7\u1112\u1175","\u110B\u1167\u11AF\u110C\u1165\u11BC","\u110B\u1167\u11AF\u110E\u1161","\u110B\u1167\u11AF\u1112\u1173\u11AF","\u110B\u1167\u11B7\u1105\u1167","\u110B\u1167\u11B8\u1109\u1165","\u110B\u1167\u11BC\u1100\u116E\u11A8","\u110B\u1167\u11BC\u1102\u1161\u11B7","\u110B\u1167\u11BC\u1109\u1161\u11BC","\u110B\u1167\u11BC\u110B\u1163\u11BC","\u110B\u1167\u11BC\u110B\u1167\u11A8","\u110B\u1167\u11BC\u110B\u116E\u11BC","\u110B\u1167\u11BC\u110B\u116F\u11AB\u1112\u1175","\u110B\u1167\u11BC\u1112\u1161","\u110B\u1167\u11BC\u1112\u1163\u11BC","\u110B\u1167\u11BC\u1112\u1169\u11AB","\u110B\u1167\u11BC\u1112\u116A","\u110B\u1167\u11C1\u1100\u116E\u1105\u1175","\u110B\u1167\u11C1\u1107\u1161\u11BC","\u110B\u1167\u11C1\u110C\u1175\u11B8","\u110B\u1168\u1100\u1161\u11B7","\u110B\u1168\u1100\u1173\u11B7","\u110B\u1168\u1107\u1161\u11BC","\u110B\u1168\u1109\u1161\u11AB","\u110B\u1168\u1109\u1161\u11BC","\u110B\u1168\u1109\u1165\u11AB","\u110B\u1168\u1109\u116E\u11AF","\u110B\u1168\u1109\u1173\u11B8","\u110B\u1168\u1109\u1175\u11A8\u110C\u1161\u11BC","\u110B\u1168\u110B\u1163\u11A8","\u110B\u1168\u110C\u1165\u11AB","\u110B\u1168\u110C\u1165\u11AF","\u110B\u1168\u110C\u1165\u11BC","\u110B\u1168\u110F\u1165\u11AB\u1103\u1162","\u110B\u1168\u11BA\u1102\u1161\u11AF","\u110B\u1169\u1102\u1173\u11AF","\u110B\u1169\u1105\u1161\u11A8","\u110B\u1169\u1105\u1162\u11BA\u1103\u1169\u11BC\u110B\u1161\u11AB","\u110B\u1169\u1105\u1166\u11AB\u110C\u1175","\u110B\u1169\u1105\u1169\u110C\u1175","\u110B\u1169\u1105\u1173\u11AB\u1107\u1161\u11AF","\u110B\u1169\u1107\u1173\u11AB","\u110B\u1169\u1109\u1175\u11B8","\u110B\u1169\u110B\u1167\u11B7","\u110B\u1169\u110B\u116F\u11AF","\u110B\u1169\u110C\u1165\u11AB","\u110B\u1169\u110C\u1175\u11A8","\u110B\u1169\u110C\u1175\u11BC\u110B\u1165","\u110B\u1169\u1111\u1166\u1105\u1161","\u110B\u1169\u1111\u1175\u1109\u1173\u1110\u1166\u11AF","\u110B\u1169\u1112\u1175\u1105\u1167","\u110B\u1169\u11A8\u1109\u1161\u11BC","\u110B\u1169\u11A8\u1109\u116E\u1109\u116E","\u110B\u1169\u11AB\u1100\u1161\u11BD","\u110B\u1169\u11AB\u1105\u1161\u110B\u1175\u11AB","\u110B\u1169\u11AB\u1106\u1169\u11B7","\u110B\u1169\u11AB\u110C\u1169\u11BC\u110B\u1175\u11AF","\u110B\u1169\u11AB\u1110\u1169\u11BC","\u110B\u1169\u11AF\u1100\u1161\u110B\u1173\u11AF","\u110B\u1169\u11AF\u1105\u1175\u11B7\u1111\u1175\u11A8","\u110B\u1169\u11AF\u1112\u1162","\u110B\u1169\u11BA\u110E\u1161\u1105\u1175\u11B7","\u110B\u116A\u110B\u1175\u1109\u1167\u110E\u1173","\u110B\u116A\u110B\u1175\u11AB","\u110B\u116A\u11AB\u1109\u1165\u11BC","\u110B\u116A\u11AB\u110C\u1165\u11AB","\u110B\u116A\u11BC\u1107\u1175","\u110B\u116A\u11BC\u110C\u1161","\u110B\u116B\u1102\u1163\u1112\u1161\u1106\u1167\u11AB","\u110B\u116B\u11AB\u110C\u1175","\u110B\u116C\u1100\u1161\u11BA\u110C\u1175\u11B8","\u110B\u116C\u1100\u116E\u11A8","\u110B\u116C\u1105\u1169\u110B\u116E\u11B7","\u110B\u116C\u1109\u1161\u11B7\u110E\u1169\u11AB","\u110B\u116C\u110E\u116E\u11AF","\u110B\u116C\u110E\u1175\u11B7","\u110B\u116C\u1112\u1161\u11AF\u1106\u1165\u1102\u1175","\u110B\u116C\u11AB\u1107\u1161\u11AF","\u110B\u116C\u11AB\u1109\u1169\u11AB","\u110B\u116C\u11AB\u110D\u1169\u11A8","\u110B\u116D\u1100\u1173\u11B7","\u110B\u116D\u110B\u1175\u11AF","\u110B\u116D\u110C\u1173\u11B7","\u110B\u116D\u110E\u1165\u11BC","\u110B\u116D\u11BC\u1100\u1175","\u110B\u116D\u11BC\u1109\u1165","\u110B\u116D\u11BC\u110B\u1165","\u110B\u116E\u1109\u1161\u11AB","\u110B\u116E\u1109\u1165\u11AB","\u110B\u116E\u1109\u1173\u11BC","\u110B\u116E\u110B\u1167\u11AB\u1112\u1175","\u110B\u116E\u110C\u1165\u11BC","\u110B\u116E\u110E\u1166\u1100\u116E\u11A8","\u110B\u116E\u1111\u1167\u11AB","\u110B\u116E\u11AB\u1103\u1169\u11BC","\u110B\u116E\u11AB\u1106\u1167\u11BC","\u110B\u116E\u11AB\u1107\u1161\u11AB","\u110B\u116E\u11AB\u110C\u1165\u11AB","\u110B\u116E\u11AB\u1112\u1162\u11BC","\u110B\u116E\u11AF\u1109\u1161\u11AB","\u110B\u116E\u11AF\u110B\u1173\u11B7","\u110B\u116E\u11B7\u110C\u1175\u11A8\u110B\u1175\u11B7","\u110B\u116E\u11BA\u110B\u1165\u1105\u1173\u11AB","\u110B\u116E\u11BA\u110B\u1173\u11B7","\u110B\u116F\u1102\u1161\u11A8","\u110B\u116F\u11AB\u1100\u1169","\u110B\u116F\u11AB\u1105\u1162","\u110B\u116F\u11AB\u1109\u1165","\u110B\u116F\u11AB\u1109\u116E\u11BC\u110B\u1175","\u110B\u116F\u11AB\u110B\u1175\u11AB","\u110B\u116F\u11AB\u110C\u1161\u11BC","\u110B\u116F\u11AB\u1111\u1175\u1109\u1173","\u110B\u116F\u11AF\u1100\u1173\u11B8","\u110B\u116F\u11AF\u1103\u1173\u110F\u1165\u11B8","\u110B\u116F\u11AF\u1109\u1166","\u110B\u116F\u11AF\u110B\u116D\u110B\u1175\u11AF","\u110B\u1170\u110B\u1175\u1110\u1165","\u110B\u1171\u1107\u1161\u11AB","\u110B\u1171\u1107\u1165\u11B8","\u110B\u1171\u1109\u1165\u11BC","\u110B\u1171\u110B\u116F\u11AB","\u110B\u1171\u1112\u1165\u11B7","\u110B\u1171\u1112\u1167\u11B8","\u110B\u1171\u11BA\u1109\u1161\u1105\u1161\u11B7","\u110B\u1172\u1102\u1161\u11AB\u1112\u1175","\u110B\u1172\u1105\u1165\u11B8","\u110B\u1172\u1106\u1167\u11BC","\u110B\u1172\u1106\u116E\u11AF","\u110B\u1172\u1109\u1161\u11AB","\u110B\u1172\u110C\u1165\u11A8","\u110B\u1172\u110E\u1175\u110B\u116F\u11AB","\u110B\u1172\u1112\u1161\u11A8","\u110B\u1172\u1112\u1162\u11BC","\u110B\u1172\u1112\u1167\u11BC","\u110B\u1172\u11A8\u1100\u116E\u11AB","\u110B\u1172\u11A8\u1109\u1161\u11BC","\u110B\u1172\u11A8\u1109\u1175\u11B8","\u110B\u1172\u11A8\u110E\u1166","\u110B\u1173\u11AB\u1112\u1162\u11BC","\u110B\u1173\u11B7\u1105\u1167\u11A8","\u110B\u1173\u11B7\u1105\u116D","\u110B\u1173\u11B7\u1107\u1161\u11AB","\u110B\u1173\u11B7\u1109\u1165\u11BC","\u110B\u1173\u11B7\u1109\u1175\u11A8","\u110B\u1173\u11B7\u110B\u1161\u11A8","\u110B\u1173\u11B7\u110C\u116E","\u110B\u1174\u1100\u1167\u11AB","\u110B\u1174\u1102\u1169\u11AB","\u110B\u1174\u1106\u116E\u11AB","\u110B\u1174\u1107\u1169\u11A8","\u110B\u1174\u1109\u1175\u11A8","\u110B\u1174\u1109\u1175\u11B7","\u110B\u1174\u110B\u116C\u1105\u1169","\u110B\u1174\u110B\u116D\u11A8","\u110B\u1174\u110B\u116F\u11AB","\u110B\u1174\u1112\u1161\u11A8","\u110B\u1175\u1100\u1165\u11BA","\u110B\u1175\u1100\u1169\u11BA","\u110B\u1175\u1102\u1167\u11B7","\u110B\u1175\u1102\u1169\u11B7","\u110B\u1175\u1103\u1161\u11AF","\u110B\u1175\u1103\u1162\u1105\u1169","\u110B\u1175\u1103\u1169\u11BC","\u110B\u1175\u1105\u1165\u11C2\u1100\u1166","\u110B\u1175\u1105\u1167\u11A8\u1109\u1165","\u110B\u1175\u1105\u1169\u11AB\u110C\u1165\u11A8","\u110B\u1175\u1105\u1173\u11B7","\u110B\u1175\u1106\u1175\u11AB","\u110B\u1175\u1107\u1161\u11AF\u1109\u1169","\u110B\u1175\u1107\u1167\u11AF","\u110B\u1175\u1107\u116E\u11AF","\u110B\u1175\u1108\u1161\u11AF","\u110B\u1175\u1109\u1161\u11BC","\u110B\u1175\u1109\u1165\u11BC","\u110B\u1175\u1109\u1173\u11AF","\u110B\u1175\u110B\u1163\u1100\u1175","\u110B\u1175\u110B\u116D\u11BC","\u110B\u1175\u110B\u116E\u11BA","\u110B\u1175\u110B\u116F\u11AF","\u110B\u1175\u110B\u1173\u11A8\u1100\u1169","\u110B\u1175\u110B\u1175\u11A8","\u110B\u1175\u110C\u1165\u11AB","\u110B\u1175\u110C\u116E\u11BC","\u110B\u1175\u1110\u1173\u11AE\u1102\u1161\u11AF","\u110B\u1175\u1110\u1173\u11AF","\u110B\u1175\u1112\u1169\u11AB","\u110B\u1175\u11AB\u1100\u1161\u11AB","\u110B\u1175\u11AB\u1100\u1167\u11A8","\u110B\u1175\u11AB\u1100\u1169\u11BC","\u110B\u1175\u11AB\u1100\u116E","\u110B\u1175\u11AB\u1100\u1173\u11AB","\u110B\u1175\u11AB\u1100\u1175","\u110B\u1175\u11AB\u1103\u1169","\u110B\u1175\u11AB\u1105\u1172","\u110B\u1175\u11AB\u1106\u116E\u11AF","\u110B\u1175\u11AB\u1109\u1162\u11BC","\u110B\u1175\u11AB\u1109\u116B","\u110B\u1175\u11AB\u110B\u1167\u11AB","\u110B\u1175\u11AB\u110B\u116F\u11AB","\u110B\u1175\u11AB\u110C\u1162","\u110B\u1175\u11AB\u110C\u1169\u11BC","\u110B\u1175\u11AB\u110E\u1165\u11AB","\u110B\u1175\u11AB\u110E\u1166","\u110B\u1175\u11AB\u1110\u1165\u1102\u1166\u11BA","\u110B\u1175\u11AB\u1112\u1161","\u110B\u1175\u11AB\u1112\u1167\u11BC","\u110B\u1175\u11AF\u1100\u1169\u11B8","\u110B\u1175\u11AF\u1100\u1175","\u110B\u1175\u11AF\u1103\u1161\u11AB","\u110B\u1175\u11AF\u1103\u1162","\u110B\u1175\u11AF\u1103\u1173\u11BC","\u110B\u1175\u11AF\u1107\u1161\u11AB","\u110B\u1175\u11AF\u1107\u1169\u11AB","\u110B\u1175\u11AF\u1107\u116E","\u110B\u1175\u11AF\u1109\u1161\u11BC","\u110B\u1175\u11AF\u1109\u1162\u11BC","\u110B\u1175\u11AF\u1109\u1169\u11AB","\u110B\u1175\u11AF\u110B\u116D\u110B\u1175\u11AF","\u110B\u1175\u11AF\u110B\u116F\u11AF","\u110B\u1175\u11AF\u110C\u1165\u11BC","\u110B\u1175\u11AF\u110C\u1169\u11BC","\u110B\u1175\u11AF\u110C\u116E\u110B\u1175\u11AF","\u110B\u1175\u11AF\u110D\u1175\u11A8","\u110B\u1175\u11AF\u110E\u1166","\u110B\u1175\u11AF\u110E\u1175","\u110B\u1175\u11AF\u1112\u1162\u11BC","\u110B\u1175\u11AF\u1112\u116C\u110B\u116D\u11BC","\u110B\u1175\u11B7\u1100\u1173\u11B7","\u110B\u1175\u11B7\u1106\u116E","\u110B\u1175\u11B8\u1103\u1162","\u110B\u1175\u11B8\u1105\u1167\u11A8","\u110B\u1175\u11B8\u1106\u1161\u11BA","\u110B\u1175\u11B8\u1109\u1161","\u110B\u1175\u11B8\u1109\u116E\u11AF","\u110B\u1175\u11B8\u1109\u1175","\u110B\u1175\u11B8\u110B\u116F\u11AB","\u110B\u1175\u11B8\u110C\u1161\u11BC","\u110B\u1175\u11B8\u1112\u1161\u11A8","\u110C\u1161\u1100\u1161\u110B\u116D\u11BC","\u110C\u1161\u1100\u1167\u11A8","\u110C\u1161\u1100\u1173\u11A8","\u110C\u1161\u1103\u1169\u11BC","\u110C\u1161\u1105\u1161\u11BC","\u110C\u1161\u1107\u116E\u1109\u1175\u11B7","\u110C\u1161\u1109\u1175\u11A8","\u110C\u1161\u1109\u1175\u11AB","\u110C\u1161\u110B\u1167\u11AB","\u110C\u1161\u110B\u116F\u11AB","\u110C\u1161\u110B\u1172\u11AF","\u110C\u1161\u110C\u1165\u11AB\u1100\u1165","\u110C\u1161\u110C\u1165\u11BC","\u110C\u1161\u110C\u1169\u11AB\u1109\u1175\u11B7","\u110C\u1161\u1111\u1161\u11AB","\u110C\u1161\u11A8\u1100\u1161","\u110C\u1161\u11A8\u1102\u1167\u11AB","\u110C\u1161\u11A8\u1109\u1165\u11BC","\u110C\u1161\u11A8\u110B\u1165\u11B8","\u110C\u1161\u11A8\u110B\u116D\u11BC","\u110C\u1161\u11A8\u110B\u1173\u11AB\u1104\u1161\u11AF","\u110C\u1161\u11A8\u1111\u116E\u11B7","\u110C\u1161\u11AB\u1103\u1175","\u110C\u1161\u11AB\u1104\u1173\u11A8","\u110C\u1161\u11AB\u110E\u1175","\u110C\u1161\u11AF\u1106\u1169\u11BA","\u110C\u1161\u11B7\u1101\u1161\u11AB","\u110C\u1161\u11B7\u1109\u116E\u1112\u1161\u11B7","\u110C\u1161\u11B7\u1109\u1175","\u110C\u1161\u11B7\u110B\u1169\u11BA","\u110C\u1161\u11B7\u110C\u1161\u1105\u1175","\u110C\u1161\u11B8\u110C\u1175","\u110C\u1161\u11BC\u1100\u116A\u11AB","\u110C\u1161\u11BC\u1100\u116E\u11AB","\u110C\u1161\u11BC\u1100\u1175\u1100\u1161\u11AB","\u110C\u1161\u11BC\u1105\u1162","\u110C\u1161\u11BC\u1105\u1168","\u110C\u1161\u11BC\u1105\u1173","\u110C\u1161\u11BC\u1106\u1161","\u110C\u1161\u11BC\u1106\u1167\u11AB","\u110C\u1161\u11BC\u1106\u1169","\u110C\u1161\u11BC\u1106\u1175","\u110C\u1161\u11BC\u1107\u1175","\u110C\u1161\u11BC\u1109\u1161","\u110C\u1161\u11BC\u1109\u1169","\u110C\u1161\u11BC\u1109\u1175\u11A8","\u110C\u1161\u11BC\u110B\u1162\u110B\u1175\u11AB","\u110C\u1161\u11BC\u110B\u1175\u11AB","\u110C\u1161\u11BC\u110C\u1165\u11B7","\u110C\u1161\u11BC\u110E\u1161","\u110C\u1161\u11BC\u1112\u1161\u11A8\u1100\u1173\u11B7","\u110C\u1162\u1102\u1173\u11BC","\u110C\u1162\u1108\u1161\u11AF\u1105\u1175","\u110C\u1162\u1109\u1161\u11AB","\u110C\u1162\u1109\u1162\u11BC","\u110C\u1162\u110C\u1161\u11A8\u1102\u1167\u11AB","\u110C\u1162\u110C\u1165\u11BC","\u110C\u1162\u110E\u1162\u1100\u1175","\u110C\u1162\u1111\u1161\u11AB","\u110C\u1162\u1112\u1161\u11A8","\u110C\u1162\u1112\u116A\u11AF\u110B\u116D\u11BC","\u110C\u1165\u1100\u1165\u11BA","\u110C\u1165\u1100\u1169\u1105\u1175","\u110C\u1165\u1100\u1169\u11BA","\u110C\u1165\u1102\u1167\u11A8","\u110C\u1165\u1105\u1165\u11AB","\u110C\u1165\u1105\u1165\u11C2\u1100\u1166","\u110C\u1165\u1107\u1165\u11AB","\u110C\u1165\u110B\u116E\u11AF","\u110C\u1165\u110C\u1165\u11AF\u1105\u1169","\u110C\u1165\u110E\u116E\u11A8","\u110C\u1165\u11A8\u1100\u1173\u11A8","\u110C\u1165\u11A8\u1103\u1161\u11BC\u1112\u1175","\u110C\u1165\u11A8\u1109\u1165\u11BC","\u110C\u1165\u11A8\u110B\u116D\u11BC","\u110C\u1165\u11A8\u110B\u1173\u11BC","\u110C\u1165\u11AB\u1100\u1162","\u110C\u1165\u11AB\u1100\u1169\u11BC","\u110C\u1165\u11AB\u1100\u1175","\u110C\u1165\u11AB\u1103\u1161\u11AF","\u110C\u1165\u11AB\u1105\u1161\u1103\u1169","\u110C\u1165\u11AB\u1106\u1161\u11BC","\u110C\u1165\u11AB\u1106\u116E\u11AB","\u110C\u1165\u11AB\u1107\u1161\u11AB","\u110C\u1165\u11AB\u1107\u116E","\u110C\u1165\u11AB\u1109\u1166","\u110C\u1165\u11AB\u1109\u1175","\u110C\u1165\u11AB\u110B\u116D\u11BC","\u110C\u1165\u11AB\u110C\u1161","\u110C\u1165\u11AB\u110C\u1162\u11BC","\u110C\u1165\u11AB\u110C\u116E","\u110C\u1165\u11AB\u110E\u1165\u11AF","\u110C\u1165\u11AB\u110E\u1166","\u110C\u1165\u11AB\u1110\u1169\u11BC","\u110C\u1165\u11AB\u1112\u1167","\u110C\u1165\u11AB\u1112\u116E","\u110C\u1165\u11AF\u1103\u1162","\u110C\u1165\u11AF\u1106\u1161\u11BC","\u110C\u1165\u11AF\u1107\u1161\u11AB","\u110C\u1165\u11AF\u110B\u1163\u11A8","\u110C\u1165\u11AF\u110E\u1161","\u110C\u1165\u11B7\u1100\u1165\u11B7","\u110C\u1165\u11B7\u1109\u116E","\u110C\u1165\u11B7\u1109\u1175\u11B7","\u110C\u1165\u11B7\u110B\u116F\u11AB","\u110C\u1165\u11B7\u110C\u1165\u11B7","\u110C\u1165\u11B7\u110E\u1161","\u110C\u1165\u11B8\u1100\u1173\u11AB","\u110C\u1165\u11B8\u1109\u1175","\u110C\u1165\u11B8\u110E\u1169\u11A8","\u110C\u1165\u11BA\u1100\u1161\u1105\u1161\u11A8","\u110C\u1165\u11BC\u1100\u1165\u110C\u1161\u11BC","\u110C\u1165\u11BC\u1103\u1169","\u110C\u1165\u11BC\u1105\u1172\u110C\u1161\u11BC","\u110C\u1165\u11BC\u1105\u1175","\u110C\u1165\u11BC\u1106\u1161\u11AF","\u110C\u1165\u11BC\u1106\u1167\u11AB","\u110C\u1165\u11BC\u1106\u116E\u11AB","\u110C\u1165\u11BC\u1107\u1161\u11AB\u1103\u1162","\u110C\u1165\u11BC\u1107\u1169","\u110C\u1165\u11BC\u1107\u116E","\u110C\u1165\u11BC\u1107\u1175","\u110C\u1165\u11BC\u1109\u1161\u11BC","\u110C\u1165\u11BC\u1109\u1165\u11BC","\u110C\u1165\u11BC\u110B\u1169","\u110C\u1165\u11BC\u110B\u116F\u11AB","\u110C\u1165\u11BC\u110C\u1161\u11BC","\u110C\u1165\u11BC\u110C\u1175","\u110C\u1165\u11BC\u110E\u1175","\u110C\u1165\u11BC\u1112\u116A\u11A8\u1112\u1175","\u110C\u1166\u1100\u1169\u11BC","\u110C\u1166\u1100\u116A\u110C\u1165\u11B7","\u110C\u1166\u1103\u1162\u1105\u1169","\u110C\u1166\u1106\u1169\u11A8","\u110C\u1166\u1107\u1161\u11AF","\u110C\u1166\u1107\u1165\u11B8","\u110C\u1166\u1109\u1161\u11BA\u1102\u1161\u11AF","\u110C\u1166\u110B\u1161\u11AB","\u110C\u1166\u110B\u1175\u11AF","\u110C\u1166\u110C\u1161\u11A8","\u110C\u1166\u110C\u116E\u1103\u1169","\u110C\u1166\u110E\u116E\u11AF","\u110C\u1166\u1111\u116E\u11B7","\u110C\u1166\u1112\u1161\u11AB","\u110C\u1169\u1100\u1161\u11A8","\u110C\u1169\u1100\u1165\u11AB","\u110C\u1169\u1100\u1173\u11B7","\u110C\u1169\u1100\u1175\u11BC","\u110C\u1169\u1106\u1167\u11BC","\u110C\u1169\u1106\u1175\u1105\u116D","\u110C\u1169\u1109\u1161\u11BC","\u110C\u1169\u1109\u1165\u11AB","\u110C\u1169\u110B\u116D\u11BC\u1112\u1175","\u110C\u1169\u110C\u1165\u11AF","\u110C\u1169\u110C\u1165\u11BC","\u110C\u1169\u110C\u1175\u11A8","\u110C\u1169\u11AB\u1103\u1162\u11BA\u1106\u1161\u11AF","\u110C\u1169\u11AB\u110C\u1162","\u110C\u1169\u11AF\u110B\u1165\u11B8","\u110C\u1169\u11AF\u110B\u1173\u11B7","\u110C\u1169\u11BC\u1100\u116D","\u110C\u1169\u11BC\u1105\u1169","\u110C\u1169\u11BC\u1105\u1172","\u110C\u1169\u11BC\u1109\u1169\u1105\u1175","\u110C\u1169\u11BC\u110B\u1165\u11B8\u110B\u116F\u11AB","\u110C\u1169\u11BC\u110C\u1169\u11BC","\u110C\u1169\u11BC\u1112\u1161\u11B8","\u110C\u116A\u1109\u1165\u11A8","\u110C\u116C\u110B\u1175\u11AB","\u110C\u116E\u1100\u116A\u11AB\u110C\u1165\u11A8","\u110C\u116E\u1105\u1173\u11B7","\u110C\u116E\u1106\u1161\u11AF","\u110C\u116E\u1106\u1165\u1102\u1175","\u110C\u116E\u1106\u1165\u11A8","\u110C\u116E\u1106\u116E\u11AB","\u110C\u116E\u1106\u1175\u11AB","\u110C\u116E\u1107\u1161\u11BC","\u110C\u116E\u1107\u1167\u11AB","\u110C\u116E\u1109\u1175\u11A8","\u110C\u116E\u110B\u1175\u11AB","\u110C\u116E\u110B\u1175\u11AF","\u110C\u116E\u110C\u1161\u11BC","\u110C\u116E\u110C\u1165\u11AB\u110C\u1161","\u110C\u116E\u1110\u1162\u11A8","\u110C\u116E\u11AB\u1107\u1175","\u110C\u116E\u11AF\u1100\u1165\u1105\u1175","\u110C\u116E\u11AF\u1100\u1175","\u110C\u116E\u11AF\u1106\u116E\u1102\u1174","\u110C\u116E\u11BC\u1100\u1161\u11AB","\u110C\u116E\u11BC\u1100\u1168\u1107\u1161\u11BC\u1109\u1169\u11BC","\u110C\u116E\u11BC\u1100\u116E\u11A8","\u110C\u116E\u11BC\u1102\u1167\u11AB","\u110C\u116E\u11BC\u1103\u1161\u11AB","\u110C\u116E\u11BC\u1103\u1169\u11A8","\u110C\u116E\u11BC\u1107\u1161\u11AB","\u110C\u116E\u11BC\u1107\u116E","\u110C\u116E\u11BC\u1109\u1166","\u110C\u116E\u11BC\u1109\u1169\u1100\u1175\u110B\u1165\u11B8","\u110C\u116E\u11BC\u1109\u116E\u11AB","\u110C\u116E\u11BC\u110B\u1161\u11BC","\u110C\u116E\u11BC\u110B\u116D","\u110C\u116E\u11BC\u1112\u1161\u11A8\u1100\u116D","\u110C\u1173\u11A8\u1109\u1165\u11A8","\u110C\u1173\u11A8\u1109\u1175","\u110C\u1173\u11AF\u1100\u1165\u110B\u116E\u11B7","\u110C\u1173\u11BC\u1100\u1161","\u110C\u1173\u11BC\u1100\u1165","\u110C\u1173\u11BC\u1100\u116F\u11AB","\u110C\u1173\u11BC\u1109\u1161\u11BC","\u110C\u1173\u11BC\u1109\u1166","\u110C\u1175\u1100\u1161\u11A8","\u110C\u1175\u1100\u1161\u11B8","\u110C\u1175\u1100\u1167\u11BC","\u110C\u1175\u1100\u1173\u11A8\u1112\u1175","\u110C\u1175\u1100\u1173\u11B7","\u110C\u1175\u1100\u1173\u11B8","\u110C\u1175\u1102\u1173\u11BC","\u110C\u1175\u1105\u1173\u11B7\u1100\u1175\u11AF","\u110C\u1175\u1105\u1175\u1109\u1161\u11AB","\u110C\u1175\u1107\u1161\u11BC","\u110C\u1175\u1107\u116E\u11BC","\u110C\u1175\u1109\u1175\u11A8","\u110C\u1175\u110B\u1167\u11A8","\u110C\u1175\u110B\u116E\u1100\u1162","\u110C\u1175\u110B\u116F\u11AB","\u110C\u1175\u110C\u1165\u11A8","\u110C\u1175\u110C\u1165\u11B7","\u110C\u1175\u110C\u1175\u11AB","\u110C\u1175\u110E\u116E\u11AF","\u110C\u1175\u11A8\u1109\u1165\u11AB","\u110C\u1175\u11A8\u110B\u1165\u11B8","\u110C\u1175\u11A8\u110B\u116F\u11AB","\u110C\u1175\u11A8\u110C\u1161\u11BC","\u110C\u1175\u11AB\u1100\u1173\u11B8","\u110C\u1175\u11AB\u1103\u1169\u11BC","\u110C\u1175\u11AB\u1105\u1169","\u110C\u1175\u11AB\u1105\u116D","\u110C\u1175\u11AB\u1105\u1175","\u110C\u1175\u11AB\u110D\u1161","\u110C\u1175\u11AB\u110E\u1161\u11AF","\u110C\u1175\u11AB\u110E\u116E\u11AF","\u110C\u1175\u11AB\u1110\u1169\u11BC","\u110C\u1175\u11AB\u1112\u1162\u11BC","\u110C\u1175\u11AF\u1106\u116E\u11AB","\u110C\u1175\u11AF\u1107\u1167\u11BC","\u110C\u1175\u11AF\u1109\u1165","\u110C\u1175\u11B7\u110C\u1161\u11A8","\u110C\u1175\u11B8\u1103\u1161\u11AB","\u110C\u1175\u11B8\u110B\u1161\u11AB","\u110C\u1175\u11B8\u110C\u116E\u11BC","\u110D\u1161\u110C\u1173\u11BC","\u110D\u1175\u1101\u1165\u1100\u1175","\u110E\u1161\u1102\u1161\u11B7","\u110E\u1161\u1105\u1161\u1105\u1175","\u110E\u1161\u1105\u1163\u11BC","\u110E\u1161\u1105\u1175\u11B7","\u110E\u1161\u1107\u1167\u11AF","\u110E\u1161\u1109\u1165\u11AB","\u110E\u1161\u110E\u1173\u11B7","\u110E\u1161\u11A8\u1100\u1161\u11A8","\u110E\u1161\u11AB\u1106\u116E\u11AF","\u110E\u1161\u11AB\u1109\u1165\u11BC","\u110E\u1161\u11B7\u1100\u1161","\u110E\u1161\u11B7\u1100\u1175\u1105\u1173\u11B7","\u110E\u1161\u11B7\u1109\u1162","\u110E\u1161\u11B7\u1109\u1165\u11A8","\u110E\u1161\u11B7\u110B\u1167","\u110E\u1161\u11B7\u110B\u116C","\u110E\u1161\u11B7\u110C\u1169","\u110E\u1161\u11BA\u110C\u1161\u11AB","\u110E\u1161\u11BC\u1100\u1161","\u110E\u1161\u11BC\u1100\u1169","\u110E\u1161\u11BC\u1100\u116E","\u110E\u1161\u11BC\u1106\u116E\u11AB","\u110E\u1161\u11BC\u1107\u1161\u11A9","\u110E\u1161\u11BC\u110C\u1161\u11A8","\u110E\u1161\u11BC\u110C\u1169","\u110E\u1162\u1102\u1165\u11AF","\u110E\u1162\u110C\u1165\u11B7","\u110E\u1162\u11A8\u1100\u1161\u1107\u1161\u11BC","\u110E\u1162\u11A8\u1107\u1161\u11BC","\u110E\u1162\u11A8\u1109\u1161\u11BC","\u110E\u1162\u11A8\u110B\u1175\u11B7","\u110E\u1162\u11B7\u1111\u1175\u110B\u1165\u11AB","\u110E\u1165\u1107\u1165\u11AF","\u110E\u1165\u110B\u1173\u11B7","\u110E\u1165\u11AB\u1100\u116E\u11A8","\u110E\u1165\u11AB\u1103\u116E\u11BC","\u110E\u1165\u11AB\u110C\u1161\u11BC","\u110E\u1165\u11AB\u110C\u1162","\u110E\u1165\u11AB\u110E\u1165\u11AB\u1112\u1175","\u110E\u1165\u11AF\u1103\u1169","\u110E\u1165\u11AF\u110C\u1165\u1112\u1175","\u110E\u1165\u11AF\u1112\u1161\u11A8","\u110E\u1165\u11BA\u1102\u1161\u11AF","\u110E\u1165\u11BA\u110D\u1162","\u110E\u1165\u11BC\u1102\u1167\u11AB","\u110E\u1165\u11BC\u1107\u1161\u110C\u1175","\u110E\u1165\u11BC\u1109\u1169","\u110E\u1165\u11BC\u110E\u116E\u11AB","\u110E\u1166\u1100\u1168","\u110E\u1166\u1105\u1167\u11A8","\u110E\u1166\u110B\u1169\u11AB","\u110E\u1166\u110B\u1172\u11A8","\u110E\u1166\u110C\u116E\u11BC","\u110E\u1166\u1112\u1165\u11B7","\u110E\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC","\u110E\u1169\u1107\u1161\u11AB","\u110E\u1169\u1107\u1161\u11B8","\u110E\u1169\u1109\u1161\u11BC\u1112\u116A","\u110E\u1169\u1109\u116E\u11AB","\u110E\u1169\u110B\u1167\u1105\u1173\u11B7","\u110E\u1169\u110B\u116F\u11AB","\u110E\u1169\u110C\u1165\u1102\u1167\u11A8","\u110E\u1169\u110C\u1165\u11B7","\u110E\u1169\u110E\u1165\u11BC","\u110E\u1169\u110F\u1169\u11AF\u1105\u1175\u11BA","\u110E\u1169\u11BA\u1107\u116E\u11AF","\u110E\u1169\u11BC\u1100\u1161\u11A8","\u110E\u1169\u11BC\u1105\u1175","\u110E\u1169\u11BC\u110C\u1161\u11BC","\u110E\u116A\u11AF\u110B\u1167\u11BC","\u110E\u116C\u1100\u1173\u11AB","\u110E\u116C\u1109\u1161\u11BC","\u110E\u116C\u1109\u1165\u11AB","\u110E\u116C\u1109\u1175\u11AB","\u110E\u116C\u110B\u1161\u11A8","\u110E\u116C\u110C\u1169\u11BC","\u110E\u116E\u1109\u1165\u11A8","\u110E\u116E\u110B\u1165\u11A8","\u110E\u116E\u110C\u1175\u11AB","\u110E\u116E\u110E\u1165\u11AB","\u110E\u116E\u110E\u1173\u11A8","\u110E\u116E\u11A8\u1100\u116E","\u110E\u116E\u11A8\u1109\u1169","\u110E\u116E\u11A8\u110C\u1166","\u110E\u116E\u11A8\u1112\u1161","\u110E\u116E\u11AF\u1100\u1173\u11AB","\u110E\u116E\u11AF\u1107\u1161\u11AF","\u110E\u116E\u11AF\u1109\u1161\u11AB","\u110E\u116E\u11AF\u1109\u1175\u11AB","\u110E\u116E\u11AF\u110B\u1167\u11AB","\u110E\u116E\u11AF\u110B\u1175\u11B8","\u110E\u116E\u11AF\u110C\u1161\u11BC","\u110E\u116E\u11AF\u1111\u1161\u11AB","\u110E\u116E\u11BC\u1100\u1167\u11A8","\u110E\u116E\u11BC\u1100\u1169","\u110E\u116E\u11BC\u1103\u1169\u11AF","\u110E\u116E\u11BC\u1107\u116E\u11AB\u1112\u1175","\u110E\u116E\u11BC\u110E\u1165\u11BC\u1103\u1169","\u110E\u1171\u110B\u1165\u11B8","\u110E\u1171\u110C\u1175\u11A8","\u110E\u1171\u1112\u1163\u11BC","\u110E\u1175\u110B\u1163\u11A8","\u110E\u1175\u11AB\u1100\u116E","\u110E\u1175\u11AB\u110E\u1165\u11A8","\u110E\u1175\u11AF\u1109\u1175\u11B8","\u110E\u1175\u11AF\u110B\u116F\u11AF","\u110E\u1175\u11AF\u1111\u1161\u11AB","\u110E\u1175\u11B7\u1103\u1162","\u110E\u1175\u11B7\u1106\u116E\u11A8","\u110E\u1175\u11B7\u1109\u1175\u11AF","\u110E\u1175\u11BA\u1109\u1169\u11AF","\u110E\u1175\u11BC\u110E\u1161\u11AB","\u110F\u1161\u1106\u1166\u1105\u1161","\u110F\u1161\u110B\u116E\u11AB\u1110\u1165","\u110F\u1161\u11AF\u1100\u116E\u11A8\u1109\u116E","\u110F\u1162\u1105\u1175\u11A8\u1110\u1165","\u110F\u1162\u11B7\u1111\u1165\u1109\u1173","\u110F\u1162\u11B7\u1111\u1166\u110B\u1175\u11AB","\u110F\u1165\u1110\u1173\u11AB","\u110F\u1165\u11AB\u1103\u1175\u1109\u1167\u11AB","\u110F\u1165\u11AF\u1105\u1165","\u110F\u1165\u11B7\u1111\u1172\u1110\u1165","\u110F\u1169\u1101\u1175\u1105\u1175","\u110F\u1169\u1106\u1175\u1103\u1175","\u110F\u1169\u11AB\u1109\u1165\u1110\u1173","\u110F\u1169\u11AF\u1105\u1161","\u110F\u1169\u11B7\u1111\u1173\u11AF\u1105\u1166\u11A8\u1109\u1173","\u110F\u1169\u11BC\u1102\u1161\u1106\u116E\u11AF","\u110F\u116B\u1100\u1161\u11B7","\u110F\u116E\u1103\u1166\u1110\u1161","\u110F\u1173\u1105\u1175\u11B7","\u110F\u1173\u11AB\u1100\u1175\u11AF","\u110F\u1173\u11AB\u1104\u1161\u11AF","\u110F\u1173\u11AB\u1109\u1169\u1105\u1175","\u110F\u1173\u11AB\u110B\u1161\u1103\u1173\u11AF","\u110F\u1173\u11AB\u110B\u1165\u1106\u1165\u1102\u1175","\u110F\u1173\u11AB\u110B\u1175\u11AF","\u110F\u1173\u11AB\u110C\u1165\u11AF","\u110F\u1173\u11AF\u1105\u1162\u1109\u1175\u11A8","\u110F\u1173\u11AF\u1105\u1165\u11B8","\u110F\u1175\u11AF\u1105\u1169","\u1110\u1161\u110B\u1175\u11B8","\u1110\u1161\u110C\u1161\u1100\u1175","\u1110\u1161\u11A8\u1100\u116E","\u1110\u1161\u11A8\u110C\u1161","\u1110\u1161\u11AB\u1109\u1162\u11BC","\u1110\u1162\u1100\u116F\u11AB\u1103\u1169","\u1110\u1162\u110B\u1163\u11BC","\u1110\u1162\u1111\u116E\u11BC","\u1110\u1162\u11A8\u1109\u1175","\u1110\u1162\u11AF\u1105\u1165\u11AB\u1110\u1173","\u1110\u1165\u1102\u1165\u11AF","\u1110\u1165\u1106\u1175\u1102\u1165\u11AF","\u1110\u1166\u1102\u1175\u1109\u1173","\u1110\u1166\u1109\u1173\u1110\u1173","\u1110\u1166\u110B\u1175\u1107\u1173\u11AF","\u1110\u1166\u11AF\u1105\u1166\u1107\u1175\u110C\u1165\u11AB","\u1110\u1169\u1105\u1169\u11AB","\u1110\u1169\u1106\u1161\u1110\u1169","\u1110\u1169\u110B\u116D\u110B\u1175\u11AF","\u1110\u1169\u11BC\u1100\u1168","\u1110\u1169\u11BC\u1100\u116A","\u1110\u1169\u11BC\u1105\u1169","\u1110\u1169\u11BC\u1109\u1175\u11AB","\u1110\u1169\u11BC\u110B\u1167\u11A8","\u1110\u1169\u11BC\u110B\u1175\u11AF","\u1110\u1169\u11BC\u110C\u1161\u11BC","\u1110\u1169\u11BC\u110C\u1166","\u1110\u1169\u11BC\u110C\u1173\u11BC","\u1110\u1169\u11BC\u1112\u1161\u11B8","\u1110\u1169\u11BC\u1112\u116A","\u1110\u116C\u1100\u1173\u11AB","\u1110\u116C\u110B\u116F\u11AB","\u1110\u116C\u110C\u1175\u11A8\u1100\u1173\u11B7","\u1110\u1171\u1100\u1175\u11B7","\u1110\u1173\u1105\u1165\u11A8","\u1110\u1173\u11A8\u1100\u1173\u11B8","\u1110\u1173\u11A8\u1107\u1167\u11AF","\u1110\u1173\u11A8\u1109\u1165\u11BC","\u1110\u1173\u11A8\u1109\u116E","\u1110\u1173\u11A8\u110C\u1175\u11BC","\u1110\u1173\u11A8\u1112\u1175","\u1110\u1173\u11AB\u1110\u1173\u11AB\u1112\u1175","\u1110\u1175\u1109\u1167\u110E\u1173","\u1111\u1161\u1105\u1161\u11AB\u1109\u1162\u11A8","\u1111\u1161\u110B\u1175\u11AF","\u1111\u1161\u110E\u116E\u11AF\u1109\u1169","\u1111\u1161\u11AB\u1100\u1167\u11AF","\u1111\u1161\u11AB\u1103\u1161\u11AB","\u1111\u1161\u11AB\u1106\u1162","\u1111\u1161\u11AB\u1109\u1161","\u1111\u1161\u11AF\u1109\u1175\u11B8","\u1111\u1161\u11AF\u110B\u116F\u11AF","\u1111\u1161\u11B8\u1109\u1169\u11BC","\u1111\u1162\u1109\u1167\u11AB","\u1111\u1162\u11A8\u1109\u1173","\u1111\u1162\u11A8\u1109\u1175\u1106\u1175\u11AF\u1105\u1175","\u1111\u1162\u11AB\u1110\u1175","\u1111\u1165\u1109\u1166\u11AB\u1110\u1173","\u1111\u1166\u110B\u1175\u11AB\u1110\u1173","\u1111\u1167\u11AB\u1100\u1167\u11AB","\u1111\u1167\u11AB\u110B\u1174","\u1111\u1167\u11AB\u110C\u1175","\u1111\u1167\u11AB\u1112\u1175","\u1111\u1167\u11BC\u1100\u1161","\u1111\u1167\u11BC\u1100\u1172\u11AB","\u1111\u1167\u11BC\u1109\u1162\u11BC","\u1111\u1167\u11BC\u1109\u1169","\u1111\u1167\u11BC\u110B\u1163\u11BC","\u1111\u1167\u11BC\u110B\u1175\u11AF","\u1111\u1167\u11BC\u1112\u116A","\u1111\u1169\u1109\u1173\u1110\u1165","\u1111\u1169\u110B\u1175\u11AB\u1110\u1173","\u1111\u1169\u110C\u1161\u11BC","\u1111\u1169\u1112\u1161\u11B7","\u1111\u116D\u1106\u1167\u11AB","\u1111\u116D\u110C\u1165\u11BC","\u1111\u116D\u110C\u116E\u11AB","\u1111\u116D\u1112\u1167\u11AB","\u1111\u116E\u11B7\u1106\u1169\u11A8","\u1111\u116E\u11B7\u110C\u1175\u11AF","\u1111\u116E\u11BC\u1100\u1167\u11BC","\u1111\u116E\u11BC\u1109\u1169\u11A8","\u1111\u116E\u11BC\u1109\u1173\u11B8","\u1111\u1173\u1105\u1161\u11BC\u1109\u1173","\u1111\u1173\u1105\u1175\u11AB\u1110\u1165","\u1111\u1173\u11AF\u1105\u1161\u1109\u1173\u1110\u1175\u11A8","\u1111\u1175\u1100\u1169\u11AB","\u1111\u1175\u1106\u1161\u11BC","\u1111\u1175\u110B\u1161\u1102\u1169","\u1111\u1175\u11AF\u1105\u1173\u11B7","\u1111\u1175\u11AF\u1109\u116E","\u1111\u1175\u11AF\u110B\u116D","\u1111\u1175\u11AF\u110C\u1161","\u1111\u1175\u11AF\u1110\u1169\u11BC","\u1111\u1175\u11BC\u1100\u1168","\u1112\u1161\u1102\u1173\u1102\u1175\u11B7","\u1112\u1161\u1102\u1173\u11AF","\u1112\u1161\u1103\u1173\u110B\u1170\u110B\u1165","\u1112\u1161\u1105\u116E\u11BA\u1107\u1161\u11B7","\u1112\u1161\u1107\u1161\u11AB\u1100\u1175","\u1112\u1161\u1109\u116E\u11A8\u110C\u1175\u11B8","\u1112\u1161\u1109\u116E\u11AB","\u1112\u1161\u110B\u1167\u1110\u1173\u11AB","\u1112\u1161\u110C\u1175\u1106\u1161\u11AB","\u1112\u1161\u110E\u1165\u11AB","\u1112\u1161\u1111\u116E\u11B7","\u1112\u1161\u1111\u1175\u11AF","\u1112\u1161\u11A8\u1100\u116A","\u1112\u1161\u11A8\u1100\u116D","\u1112\u1161\u11A8\u1100\u1173\u11B8","\u1112\u1161\u11A8\u1100\u1175","\u1112\u1161\u11A8\u1102\u1167\u11AB","\u1112\u1161\u11A8\u1105\u1167\u11A8","\u1112\u1161\u11A8\u1107\u1165\u11AB","\u1112\u1161\u11A8\u1107\u116E\u1106\u1169","\u1112\u1161\u11A8\u1107\u1175","\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1112\u1161\u11A8\u1109\u116E\u11AF","\u1112\u1161\u11A8\u1109\u1173\u11B8","\u1112\u1161\u11A8\u110B\u116D\u11BC\u1111\u116E\u11B7","\u1112\u1161\u11A8\u110B\u116F\u11AB","\u1112\u1161\u11A8\u110B\u1171","\u1112\u1161\u11A8\u110C\u1161","\u1112\u1161\u11A8\u110C\u1165\u11B7","\u1112\u1161\u11AB\u1100\u1168","\u1112\u1161\u11AB\u1100\u1173\u11AF","\u1112\u1161\u11AB\u1101\u1165\u1107\u1165\u11AB\u110B\u1166","\u1112\u1161\u11AB\u1102\u1161\u11BD","\u1112\u1161\u11AB\u1102\u116E\u11AB","\u1112\u1161\u11AB\u1103\u1169\u11BC\u110B\u1161\u11AB","\u1112\u1161\u11AB\u1104\u1162","\u1112\u1161\u11AB\u1105\u1161\u1109\u1161\u11AB","\u1112\u1161\u11AB\u1106\u1161\u1103\u1175","\u1112\u1161\u11AB\u1106\u116E\u11AB","\u1112\u1161\u11AB\u1107\u1165\u11AB","\u1112\u1161\u11AB\u1107\u1169\u11A8","\u1112\u1161\u11AB\u1109\u1175\u11A8","\u1112\u1161\u11AB\u110B\u1167\u1105\u1173\u11B7","\u1112\u1161\u11AB\u110D\u1169\u11A8","\u1112\u1161\u11AF\u1106\u1165\u1102\u1175","\u1112\u1161\u11AF\u110B\u1161\u1107\u1165\u110C\u1175","\u1112\u1161\u11AF\u110B\u1175\u11AB","\u1112\u1161\u11B7\u1101\u1166","\u1112\u1161\u11B7\u1107\u116E\u1105\u1169","\u1112\u1161\u11B8\u1100\u1167\u11A8","\u1112\u1161\u11B8\u1105\u1175\u110C\u1165\u11A8","\u1112\u1161\u11BC\u1100\u1169\u11BC","\u1112\u1161\u11BC\u1100\u116E","\u1112\u1161\u11BC\u1109\u1161\u11BC","\u1112\u1161\u11BC\u110B\u1174","\u1112\u1162\u1100\u1167\u11AF","\u1112\u1162\u1100\u116E\u11AB","\u1112\u1162\u1103\u1161\u11B8","\u1112\u1162\u1103\u1161\u11BC","\u1112\u1162\u1106\u116E\u11AF","\u1112\u1162\u1109\u1165\u11A8","\u1112\u1162\u1109\u1165\u11AF","\u1112\u1162\u1109\u116E\u110B\u116D\u11A8\u110C\u1161\u11BC","\u1112\u1162\u110B\u1161\u11AB","\u1112\u1162\u11A8\u1109\u1175\u11B7","\u1112\u1162\u11AB\u1103\u1173\u1107\u1162\u11A8","\u1112\u1162\u11B7\u1107\u1165\u1100\u1165","\u1112\u1162\u11BA\u1107\u1167\u11C0","\u1112\u1162\u11BA\u1109\u1161\u11AF","\u1112\u1162\u11BC\u1103\u1169\u11BC","\u1112\u1162\u11BC\u1107\u1169\u11A8","\u1112\u1162\u11BC\u1109\u1161","\u1112\u1162\u11BC\u110B\u116E\u11AB","\u1112\u1162\u11BC\u110B\u1171","\u1112\u1163\u11BC\u1100\u1175","\u1112\u1163\u11BC\u1109\u1161\u11BC","\u1112\u1163\u11BC\u1109\u116E","\u1112\u1165\u1105\u1161\u11A8","\u1112\u1165\u110B\u116D\u11BC","\u1112\u1166\u11AF\u1100\u1175","\u1112\u1167\u11AB\u1100\u116A\u11AB","\u1112\u1167\u11AB\u1100\u1173\u11B7","\u1112\u1167\u11AB\u1103\u1162","\u1112\u1167\u11AB\u1109\u1161\u11BC","\u1112\u1167\u11AB\u1109\u1175\u11AF","\u1112\u1167\u11AB\u110C\u1161\u11BC","\u1112\u1167\u11AB\u110C\u1162","\u1112\u1167\u11AB\u110C\u1175","\u1112\u1167\u11AF\u110B\u1162\u11A8","\u1112\u1167\u11B8\u1105\u1167\u11A8","\u1112\u1167\u11BC\u1107\u116E","\u1112\u1167\u11BC\u1109\u1161","\u1112\u1167\u11BC\u1109\u116E","\u1112\u1167\u11BC\u1109\u1175\u11A8","\u1112\u1167\u11BC\u110C\u1166","\u1112\u1167\u11BC\u1110\u1162","\u1112\u1167\u11BC\u1111\u1167\u11AB","\u1112\u1168\u1110\u1162\u11A8","\u1112\u1169\u1100\u1175\u1109\u1175\u11B7","\u1112\u1169\u1102\u1161\u11B7","\u1112\u1169\u1105\u1161\u11BC\u110B\u1175","\u1112\u1169\u1107\u1161\u11A8","\u1112\u1169\u1110\u1166\u11AF","\u1112\u1169\u1112\u1173\u11B8","\u1112\u1169\u11A8\u1109\u1175","\u1112\u1169\u11AF\u1105\u1169","\u1112\u1169\u11B7\u1111\u1166\u110B\u1175\u110C\u1175","\u1112\u1169\u11BC\u1107\u1169","\u1112\u1169\u11BC\u1109\u116E","\u1112\u1169\u11BC\u110E\u1161","\u1112\u116A\u1106\u1167\u11AB","\u1112\u116A\u1107\u116E\u11AB","\u1112\u116A\u1109\u1161\u11AF","\u1112\u116A\u110B\u116D\u110B\u1175\u11AF","\u1112\u116A\u110C\u1161\u11BC","\u1112\u116A\u1112\u1161\u11A8","\u1112\u116A\u11A8\u1107\u1169","\u1112\u116A\u11A8\u110B\u1175\u11AB","\u1112\u116A\u11A8\u110C\u1161\u11BC","\u1112\u116A\u11A8\u110C\u1165\u11BC","\u1112\u116A\u11AB\u1100\u1161\u11B8","\u1112\u116A\u11AB\u1100\u1167\u11BC","\u1112\u116A\u11AB\u110B\u1167\u11BC","\u1112\u116A\u11AB\u110B\u1172\u11AF","\u1112\u116A\u11AB\u110C\u1161","\u1112\u116A\u11AF\u1100\u1175","\u1112\u116A\u11AF\u1103\u1169\u11BC","\u1112\u116A\u11AF\u1107\u1161\u11AF\u1112\u1175","\u1112\u116A\u11AF\u110B\u116D\u11BC","\u1112\u116A\u11AF\u110D\u1161\u11A8","\u1112\u116C\u1100\u1167\u11AB","\u1112\u116C\u1100\u116A\u11AB","\u1112\u116C\u1107\u1169\u11A8","\u1112\u116C\u1109\u1162\u11A8","\u1112\u116C\u110B\u116F\u11AB","\u1112\u116C\u110C\u1161\u11BC","\u1112\u116C\u110C\u1165\u11AB","\u1112\u116C\u11BA\u1109\u116E","\u1112\u116C\u11BC\u1103\u1161\u11AB\u1107\u1169\u1103\u1169","\u1112\u116D\u110B\u1172\u11AF\u110C\u1165\u11A8","\u1112\u116E\u1107\u1161\u11AB","\u1112\u116E\u110E\u116E\u11BA\u1100\u1161\u1105\u116E","\u1112\u116E\u11AB\u1105\u1167\u11AB","\u1112\u116F\u11AF\u110A\u1175\u11AB","\u1112\u1172\u1109\u1175\u11A8","\u1112\u1172\u110B\u1175\u11AF","\u1112\u1172\u11BC\u1102\u1162","\u1112\u1173\u1105\u1173\u11B7","\u1112\u1173\u11A8\u1107\u1162\u11A8","\u1112\u1173\u11A8\u110B\u1175\u11AB","\u1112\u1173\u11AB\u110C\u1165\u11A8","\u1112\u1173\u11AB\u1112\u1175","\u1112\u1173\u11BC\u1106\u1175","\u1112\u1173\u11BC\u1107\u116E\u11AB","\u1112\u1174\u1100\u1169\u11A8","\u1112\u1174\u1106\u1161\u11BC","\u1112\u1174\u1109\u1162\u11BC","\u1112\u1174\u11AB\u1109\u1162\u11A8","\u1112\u1175\u11B7\u1101\u1165\u11BA"]');

},{}],"maGKf":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('["abaisser","abandon","abdiquer","abeille","abolir","aborder","aboutir","aboyer","abrasif","abreuver","abriter","abroger","abrupt","absence","absolu","absurde","abusif","abyssal","acade\u0301mie","acajou","acarien","accabler","accepter","acclamer","accolade","accroche","accuser","acerbe","achat","acheter","aciduler","acier","acompte","acque\u0301rir","acronyme","acteur","actif","actuel","adepte","ade\u0301quat","adhe\u0301sif","adjectif","adjuger","admettre","admirer","adopter","adorer","adoucir","adresse","adroit","adulte","adverbe","ae\u0301rer","ae\u0301ronef","affaire","affecter","affiche","affreux","affubler","agacer","agencer","agile","agiter","agrafer","agre\u0301able","agrume","aider","aiguille","ailier","aimable","aisance","ajouter","ajuster","alarmer","alchimie","alerte","alge\u0300bre","algue","alie\u0301ner","aliment","alle\u0301ger","alliage","allouer","allumer","alourdir","alpaga","altesse","alve\u0301ole","amateur","ambigu","ambre","ame\u0301nager","amertume","amidon","amiral","amorcer","amour","amovible","amphibie","ampleur","amusant","analyse","anaphore","anarchie","anatomie","ancien","ane\u0301antir","angle","angoisse","anguleux","animal","annexer","annonce","annuel","anodin","anomalie","anonyme","anormal","antenne","antidote","anxieux","apaiser","ape\u0301ritif","aplanir","apologie","appareil","appeler","apporter","appuyer","aquarium","aqueduc","arbitre","arbuste","ardeur","ardoise","argent","arlequin","armature","armement","armoire","armure","arpenter","arracher","arriver","arroser","arsenic","arte\u0301riel","article","aspect","asphalte","aspirer","assaut","asservir","assiette","associer","assurer","asticot","astre","astuce","atelier","atome","atrium","atroce","attaque","attentif","attirer","attraper","aubaine","auberge","audace","audible","augurer","aurore","automne","autruche","avaler","avancer","avarice","avenir","averse","aveugle","aviateur","avide","avion","aviser","avoine","avouer","avril","axial","axiome","badge","bafouer","bagage","baguette","baignade","balancer","balcon","baleine","balisage","bambin","bancaire","bandage","banlieue","bannie\u0300re","banquier","barbier","baril","baron","barque","barrage","bassin","bastion","bataille","bateau","batterie","baudrier","bavarder","belette","be\u0301lier","belote","be\u0301ne\u0301fice","berceau","berger","berline","bermuda","besace","besogne","be\u0301tail","beurre","biberon","bicycle","bidule","bijou","bilan","bilingue","billard","binaire","biologie","biopsie","biotype","biscuit","bison","bistouri","bitume","bizarre","blafard","blague","blanchir","blessant","blinder","blond","bloquer","blouson","bobard","bobine","boire","boiser","bolide","bonbon","bondir","bonheur","bonifier","bonus","bordure","borne","botte","boucle","boueux","bougie","boulon","bouquin","bourse","boussole","boutique","boxeur","branche","brasier","brave","brebis","bre\u0300che","breuvage","bricoler","brigade","brillant","brioche","brique","brochure","broder","bronzer","brousse","broyeur","brume","brusque","brutal","bruyant","buffle","buisson","bulletin","bureau","burin","bustier","butiner","butoir","buvable","buvette","cabanon","cabine","cachette","cadeau","cadre","cafe\u0301ine","caillou","caisson","calculer","calepin","calibre","calmer","calomnie","calvaire","camarade","came\u0301ra","camion","campagne","canal","caneton","canon","cantine","canular","capable","caporal","caprice","capsule","capter","capuche","carabine","carbone","caresser","caribou","carnage","carotte","carreau","carton","cascade","casier","casque","cassure","causer","caution","cavalier","caverne","caviar","ce\u0301dille","ceinture","ce\u0301leste","cellule","cendrier","censurer","central","cercle","ce\u0301re\u0301bral","cerise","cerner","cerveau","cesser","chagrin","chaise","chaleur","chambre","chance","chapitre","charbon","chasseur","chaton","chausson","chavirer","chemise","chenille","che\u0301quier","chercher","cheval","chien","chiffre","chignon","chime\u0300re","chiot","chlorure","chocolat","choisir","chose","chouette","chrome","chute","cigare","cigogne","cimenter","cine\u0301ma","cintrer","circuler","cirer","cirque","citerne","citoyen","citron","civil","clairon","clameur","claquer","classe","clavier","client","cligner","climat","clivage","cloche","clonage","cloporte","cobalt","cobra","cocasse","cocotier","coder","codifier","coffre","cogner","cohe\u0301sion","coiffer","coincer","cole\u0300re","colibri","colline","colmater","colonel","combat","come\u0301die","commande","compact","concert","conduire","confier","congeler","connoter","consonne","contact","convexe","copain","copie","corail","corbeau","cordage","corniche","corpus","correct","corte\u0300ge","cosmique","costume","coton","coude","coupure","courage","couteau","couvrir","coyote","crabe","crainte","cravate","crayon","cre\u0301ature","cre\u0301diter","cre\u0301meux","creuser","crevette","cribler","crier","cristal","crite\u0300re","croire","croquer","crotale","crucial","cruel","crypter","cubique","cueillir","cuille\u0300re","cuisine","cuivre","culminer","cultiver","cumuler","cupide","curatif","curseur","cyanure","cycle","cylindre","cynique","daigner","damier","danger","danseur","dauphin","de\u0301battre","de\u0301biter","de\u0301border","de\u0301brider","de\u0301butant","de\u0301caler","de\u0301cembre","de\u0301chirer","de\u0301cider","de\u0301clarer","de\u0301corer","de\u0301crire","de\u0301cupler","de\u0301dale","de\u0301ductif","de\u0301esse","de\u0301fensif","de\u0301filer","de\u0301frayer","de\u0301gager","de\u0301givrer","de\u0301glutir","de\u0301grafer","de\u0301jeuner","de\u0301lice","de\u0301loger","demander","demeurer","de\u0301molir","de\u0301nicher","de\u0301nouer","dentelle","de\u0301nuder","de\u0301part","de\u0301penser","de\u0301phaser","de\u0301placer","de\u0301poser","de\u0301ranger","de\u0301rober","de\u0301sastre","descente","de\u0301sert","de\u0301signer","de\u0301sobe\u0301ir","dessiner","destrier","de\u0301tacher","de\u0301tester","de\u0301tourer","de\u0301tresse","devancer","devenir","deviner","devoir","diable","dialogue","diamant","dicter","diffe\u0301rer","dige\u0301rer","digital","digne","diluer","dimanche","diminuer","dioxyde","directif","diriger","discuter","disposer","dissiper","distance","divertir","diviser","docile","docteur","dogme","doigt","domaine","domicile","dompter","donateur","donjon","donner","dopamine","dortoir","dorure","dosage","doseur","dossier","dotation","douanier","double","douceur","douter","doyen","dragon","draper","dresser","dribbler","droiture","duperie","duplexe","durable","durcir","dynastie","e\u0301blouir","e\u0301carter","e\u0301charpe","e\u0301chelle","e\u0301clairer","e\u0301clipse","e\u0301clore","e\u0301cluse","e\u0301cole","e\u0301conomie","e\u0301corce","e\u0301couter","e\u0301craser","e\u0301cre\u0301mer","e\u0301crivain","e\u0301crou","e\u0301cume","e\u0301cureuil","e\u0301difier","e\u0301duquer","effacer","effectif","effigie","effort","effrayer","effusion","e\u0301galiser","e\u0301garer","e\u0301jecter","e\u0301laborer","e\u0301largir","e\u0301lectron","e\u0301le\u0301gant","e\u0301le\u0301phant","e\u0301le\u0300ve","e\u0301ligible","e\u0301litisme","e\u0301loge","e\u0301lucider","e\u0301luder","emballer","embellir","embryon","e\u0301meraude","e\u0301mission","emmener","e\u0301motion","e\u0301mouvoir","empereur","employer","emporter","emprise","e\u0301mulsion","encadrer","enche\u0300re","enclave","encoche","endiguer","endosser","endroit","enduire","e\u0301nergie","enfance","enfermer","enfouir","engager","engin","englober","e\u0301nigme","enjamber","enjeu","enlever","ennemi","ennuyeux","enrichir","enrobage","enseigne","entasser","entendre","entier","entourer","entraver","e\u0301nume\u0301rer","envahir","enviable","envoyer","enzyme","e\u0301olien","e\u0301paissir","e\u0301pargne","e\u0301patant","e\u0301paule","e\u0301picerie","e\u0301pide\u0301mie","e\u0301pier","e\u0301pilogue","e\u0301pine","e\u0301pisode","e\u0301pitaphe","e\u0301poque","e\u0301preuve","e\u0301prouver","e\u0301puisant","e\u0301querre","e\u0301quipe","e\u0301riger","e\u0301rosion","erreur","e\u0301ruption","escalier","espadon","espe\u0300ce","espie\u0300gle","espoir","esprit","esquiver","essayer","essence","essieu","essorer","estime","estomac","estrade","e\u0301tage\u0300re","e\u0301taler","e\u0301tanche","e\u0301tatique","e\u0301teindre","e\u0301tendoir","e\u0301ternel","e\u0301thanol","e\u0301thique","ethnie","e\u0301tirer","e\u0301toffer","e\u0301toile","e\u0301tonnant","e\u0301tourdir","e\u0301trange","e\u0301troit","e\u0301tude","euphorie","e\u0301valuer","e\u0301vasion","e\u0301ventail","e\u0301vidence","e\u0301viter","e\u0301volutif","e\u0301voquer","exact","exage\u0301rer","exaucer","exceller","excitant","exclusif","excuse","exe\u0301cuter","exemple","exercer","exhaler","exhorter","exigence","exiler","exister","exotique","expe\u0301dier","explorer","exposer","exprimer","exquis","extensif","extraire","exulter","fable","fabuleux","facette","facile","facture","faiblir","falaise","fameux","famille","farceur","farfelu","farine","farouche","fasciner","fatal","fatigue","faucon","fautif","faveur","favori","fe\u0301brile","fe\u0301conder","fe\u0301de\u0301rer","fe\u0301lin","femme","fe\u0301mur","fendoir","fe\u0301odal","fermer","fe\u0301roce","ferveur","festival","feuille","feutre","fe\u0301vrier","fiasco","ficeler","fictif","fide\u0300le","figure","filature","filetage","filie\u0300re","filleul","filmer","filou","filtrer","financer","finir","fiole","firme","fissure","fixer","flairer","flamme","flasque","flatteur","fle\u0301au","fle\u0300che","fleur","flexion","flocon","flore","fluctuer","fluide","fluvial","folie","fonderie","fongible","fontaine","forcer","forgeron","formuler","fortune","fossile","foudre","fouge\u0300re","fouiller","foulure","fourmi","fragile","fraise","franchir","frapper","frayeur","fre\u0301gate","freiner","frelon","fre\u0301mir","fre\u0301ne\u0301sie","fre\u0300re","friable","friction","frisson","frivole","froid","fromage","frontal","frotter","fruit","fugitif","fuite","fureur","furieux","furtif","fusion","futur","gagner","galaxie","galerie","gambader","garantir","gardien","garnir","garrigue","gazelle","gazon","ge\u0301ant","ge\u0301latine","ge\u0301lule","gendarme","ge\u0301ne\u0301ral","ge\u0301nie","genou","gentil","ge\u0301ologie","ge\u0301ome\u0300tre","ge\u0301ranium","germe","gestuel","geyser","gibier","gicler","girafe","givre","glace","glaive","glisser","globe","gloire","glorieux","golfeur","gomme","gonfler","gorge","gorille","goudron","gouffre","goulot","goupille","gourmand","goutte","graduel","graffiti","graine","grand","grappin","gratuit","gravir","grenat","griffure","griller","grimper","grogner","gronder","grotte","groupe","gruger","grutier","gruye\u0300re","gue\u0301pard","guerrier","guide","guimauve","guitare","gustatif","gymnaste","gyrostat","habitude","hachoir","halte","hameau","hangar","hanneton","haricot","harmonie","harpon","hasard","he\u0301lium","he\u0301matome","herbe","he\u0301risson","hermine","he\u0301ron","he\u0301siter","heureux","hiberner","hibou","hilarant","histoire","hiver","homard","hommage","homoge\u0300ne","honneur","honorer","honteux","horde","horizon","horloge","hormone","horrible","houleux","housse","hublot","huileux","humain","humble","humide","humour","hurler","hydromel","hygie\u0300ne","hymne","hypnose","idylle","ignorer","iguane","illicite","illusion","image","imbiber","imiter","immense","immobile","immuable","impact","impe\u0301rial","implorer","imposer","imprimer","imputer","incarner","incendie","incident","incliner","incolore","indexer","indice","inductif","ine\u0301dit","ineptie","inexact","infini","infliger","informer","infusion","inge\u0301rer","inhaler","inhiber","injecter","injure","innocent","inoculer","inonder","inscrire","insecte","insigne","insolite","inspirer","instinct","insulter","intact","intense","intime","intrigue","intuitif","inutile","invasion","inventer","inviter","invoquer","ironique","irradier","irre\u0301el","irriter","isoler","ivoire","ivresse","jaguar","jaillir","jambe","janvier","jardin","jauger","jaune","javelot","jetable","jeton","jeudi","jeunesse","joindre","joncher","jongler","joueur","jouissif","journal","jovial","joyau","joyeux","jubiler","jugement","junior","jupon","juriste","justice","juteux","juve\u0301nile","kayak","kimono","kiosque","label","labial","labourer","lace\u0301rer","lactose","lagune","laine","laisser","laitier","lambeau","lamelle","lampe","lanceur","langage","lanterne","lapin","largeur","larme","laurier","lavabo","lavoir","lecture","le\u0301gal","le\u0301ger","le\u0301gume","lessive","lettre","levier","lexique","le\u0301zard","liasse","libe\u0301rer","libre","licence","licorne","lie\u0300ge","lie\u0300vre","ligature","ligoter","ligue","limer","limite","limonade","limpide","line\u0301aire","lingot","lionceau","liquide","lisie\u0300re","lister","lithium","litige","littoral","livreur","logique","lointain","loisir","lombric","loterie","louer","lourd","loutre","louve","loyal","lubie","lucide","lucratif","lueur","lugubre","luisant","lumie\u0300re","lunaire","lundi","luron","lutter","luxueux","machine","magasin","magenta","magique","maigre","maillon","maintien","mairie","maison","majorer","malaxer","male\u0301fice","malheur","malice","mallette","mammouth","mandater","maniable","manquant","manteau","manuel","marathon","marbre","marchand","mardi","maritime","marqueur","marron","marteler","mascotte","massif","mate\u0301riel","matie\u0300re","matraque","maudire","maussade","mauve","maximal","me\u0301chant","me\u0301connu","me\u0301daille","me\u0301decin","me\u0301diter","me\u0301duse","meilleur","me\u0301lange","me\u0301lodie","membre","me\u0301moire","menacer","mener","menhir","mensonge","mentor","mercredi","me\u0301rite","merle","messager","mesure","me\u0301tal","me\u0301te\u0301ore","me\u0301thode","me\u0301tier","meuble","miauler","microbe","miette","mignon","migrer","milieu","million","mimique","mince","mine\u0301ral","minimal","minorer","minute","miracle","miroiter","missile","mixte","mobile","moderne","moelleux","mondial","moniteur","monnaie","monotone","monstre","montagne","monument","moqueur","morceau","morsure","mortier","moteur","motif","mouche","moufle","moulin","mousson","mouton","mouvant","multiple","munition","muraille","mure\u0300ne","murmure","muscle","muse\u0301um","musicien","mutation","muter","mutuel","myriade","myrtille","myste\u0300re","mythique","nageur","nappe","narquois","narrer","natation","nation","nature","naufrage","nautique","navire","ne\u0301buleux","nectar","ne\u0301faste","ne\u0301gation","ne\u0301gliger","ne\u0301gocier","neige","nerveux","nettoyer","neurone","neutron","neveu","niche","nickel","nitrate","niveau","noble","nocif","nocturne","noirceur","noisette","nomade","nombreux","nommer","normatif","notable","notifier","notoire","nourrir","nouveau","novateur","novembre","novice","nuage","nuancer","nuire","nuisible","nume\u0301ro","nuptial","nuque","nutritif","obe\u0301ir","objectif","obliger","obscur","observer","obstacle","obtenir","obturer","occasion","occuper","oce\u0301an","octobre","octroyer","octupler","oculaire","odeur","odorant","offenser","officier","offrir","ogive","oiseau","oisillon","olfactif","olivier","ombrage","omettre","onctueux","onduler","one\u0301reux","onirique","opale","opaque","ope\u0301rer","opinion","opportun","opprimer","opter","optique","orageux","orange","orbite","ordonner","oreille","organe","orgueil","orifice","ornement","orque","ortie","osciller","osmose","ossature","otarie","ouragan","ourson","outil","outrager","ouvrage","ovation","oxyde","oxyge\u0300ne","ozone","paisible","palace","palmare\u0300s","palourde","palper","panache","panda","pangolin","paniquer","panneau","panorama","pantalon","papaye","papier","papoter","papyrus","paradoxe","parcelle","paresse","parfumer","parler","parole","parrain","parsemer","partager","parure","parvenir","passion","paste\u0300que","paternel","patience","patron","pavillon","pavoiser","payer","paysage","peigne","peintre","pelage","pe\u0301lican","pelle","pelouse","peluche","pendule","pe\u0301ne\u0301trer","pe\u0301nible","pensif","pe\u0301nurie","pe\u0301pite","pe\u0301plum","perdrix","perforer","pe\u0301riode","permuter","perplexe","persil","perte","peser","pe\u0301tale","petit","pe\u0301trir","peuple","pharaon","phobie","phoque","photon","phrase","physique","piano","pictural","pie\u0300ce","pierre","pieuvre","pilote","pinceau","pipette","piquer","pirogue","piscine","piston","pivoter","pixel","pizza","placard","plafond","plaisir","planer","plaque","plastron","plateau","pleurer","plexus","pliage","plomb","plonger","pluie","plumage","pochette","poe\u0301sie","poe\u0300te","pointe","poirier","poisson","poivre","polaire","policier","pollen","polygone","pommade","pompier","ponctuel","ponde\u0301rer","poney","portique","position","posse\u0301der","posture","potager","poteau","potion","pouce","poulain","poumon","pourpre","poussin","pouvoir","prairie","pratique","pre\u0301cieux","pre\u0301dire","pre\u0301fixe","pre\u0301lude","pre\u0301nom","pre\u0301sence","pre\u0301texte","pre\u0301voir","primitif","prince","prison","priver","proble\u0300me","proce\u0301der","prodige","profond","progre\u0300s","proie","projeter","prologue","promener","propre","prospe\u0300re","prote\u0301ger","prouesse","proverbe","prudence","pruneau","psychose","public","puceron","puiser","pulpe","pulsar","punaise","punitif","pupitre","purifier","puzzle","pyramide","quasar","querelle","question","quie\u0301tude","quitter","quotient","racine","raconter","radieux","ragondin","raideur","raisin","ralentir","rallonge","ramasser","rapide","rasage","ratisser","ravager","ravin","rayonner","re\u0301actif","re\u0301agir","re\u0301aliser","re\u0301animer","recevoir","re\u0301citer","re\u0301clamer","re\u0301colter","recruter","reculer","recycler","re\u0301diger","redouter","refaire","re\u0301flexe","re\u0301former","refrain","refuge","re\u0301galien","re\u0301gion","re\u0301glage","re\u0301gulier","re\u0301ite\u0301rer","rejeter","rejouer","relatif","relever","relief","remarque","reme\u0300de","remise","remonter","remplir","remuer","renard","renfort","renifler","renoncer","rentrer","renvoi","replier","reporter","reprise","reptile","requin","re\u0301serve","re\u0301sineux","re\u0301soudre","respect","rester","re\u0301sultat","re\u0301tablir","retenir","re\u0301ticule","retomber","retracer","re\u0301union","re\u0301ussir","revanche","revivre","re\u0301volte","re\u0301vulsif","richesse","rideau","rieur","rigide","rigoler","rincer","riposter","risible","risque","rituel","rival","rivie\u0300re","rocheux","romance","rompre","ronce","rondin","roseau","rosier","rotatif","rotor","rotule","rouge","rouille","rouleau","routine","royaume","ruban","rubis","ruche","ruelle","rugueux","ruiner","ruisseau","ruser","rustique","rythme","sabler","saboter","sabre","sacoche","safari","sagesse","saisir","salade","salive","salon","saluer","samedi","sanction","sanglier","sarcasme","sardine","saturer","saugrenu","saumon","sauter","sauvage","savant","savonner","scalpel","scandale","sce\u0301le\u0301rat","sce\u0301nario","sceptre","sche\u0301ma","science","scinder","score","scrutin","sculpter","se\u0301ance","se\u0301cable","se\u0301cher","secouer","se\u0301cre\u0301ter","se\u0301datif","se\u0301duire","seigneur","se\u0301jour","se\u0301lectif","semaine","sembler","semence","se\u0301minal","se\u0301nateur","sensible","sentence","se\u0301parer","se\u0301quence","serein","sergent","se\u0301rieux","serrure","se\u0301rum","service","se\u0301same","se\u0301vir","sevrage","sextuple","side\u0301ral","sie\u0300cle","sie\u0301ger","siffler","sigle","signal","silence","silicium","simple","since\u0300re","sinistre","siphon","sirop","sismique","situer","skier","social","socle","sodium","soigneux","soldat","soleil","solitude","soluble","sombre","sommeil","somnoler","sonde","songeur","sonnette","sonore","sorcier","sortir","sosie","sottise","soucieux","soudure","souffle","soulever","soupape","source","soutirer","souvenir","spacieux","spatial","spe\u0301cial","sphe\u0300re","spiral","stable","station","sternum","stimulus","stipuler","strict","studieux","stupeur","styliste","sublime","substrat","subtil","subvenir","succe\u0300s","sucre","suffixe","sugge\u0301rer","suiveur","sulfate","superbe","supplier","surface","suricate","surmener","surprise","sursaut","survie","suspect","syllabe","symbole","syme\u0301trie","synapse","syntaxe","syste\u0300me","tabac","tablier","tactile","tailler","talent","talisman","talonner","tambour","tamiser","tangible","tapis","taquiner","tarder","tarif","tartine","tasse","tatami","tatouage","taupe","taureau","taxer","te\u0301moin","temporel","tenaille","tendre","teneur","tenir","tension","terminer","terne","terrible","te\u0301tine","texte","the\u0300me","the\u0301orie","the\u0301rapie","thorax","tibia","tie\u0300de","timide","tirelire","tiroir","tissu","titane","titre","tituber","toboggan","tole\u0301rant","tomate","tonique","tonneau","toponyme","torche","tordre","tornade","torpille","torrent","torse","tortue","totem","toucher","tournage","tousser","toxine","traction","trafic","tragique","trahir","train","trancher","travail","tre\u0300fle","tremper","tre\u0301sor","treuil","triage","tribunal","tricoter","trilogie","triomphe","tripler","triturer","trivial","trombone","tronc","tropical","troupeau","tuile","tulipe","tumulte","tunnel","turbine","tuteur","tutoyer","tuyau","tympan","typhon","typique","tyran","ubuesque","ultime","ultrason","unanime","unifier","union","unique","unitaire","univers","uranium","urbain","urticant","usage","usine","usuel","usure","utile","utopie","vacarme","vaccin","vagabond","vague","vaillant","vaincre","vaisseau","valable","valise","vallon","valve","vampire","vanille","vapeur","varier","vaseux","vassal","vaste","vecteur","vedette","ve\u0301ge\u0301tal","ve\u0301hicule","veinard","ve\u0301loce","vendredi","ve\u0301ne\u0301rer","venger","venimeux","ventouse","verdure","ve\u0301rin","vernir","verrou","verser","vertu","veston","ve\u0301te\u0301ran","ve\u0301tuste","vexant","vexer","viaduc","viande","victoire","vidange","vide\u0301o","vignette","vigueur","vilain","village","vinaigre","violon","vipe\u0300re","virement","virtuose","virus","visage","viseur","vision","visqueux","visuel","vital","vitesse","viticole","vitrine","vivace","vivipare","vocation","voguer","voile","voisin","voiture","volaille","volcan","voltiger","volume","vorace","vortex","voter","vouloir","voyage","voyelle","wagon","xe\u0301non","yacht","ze\u0300bre","ze\u0301nith","zeste","zoologie"]');

},{}],"llrLD":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("[\"abaco\",\"abbaglio\",\"abbinato\",\"abete\",\"abisso\",\"abolire\",\"abrasivo\",\"abrogato\",\"accadere\",\"accenno\",\"accusato\",\"acetone\",\"achille\",\"acido\",\"acqua\",\"acre\",\"acrilico\",\"acrobata\",\"acuto\",\"adagio\",\"addebito\",\"addome\",\"adeguato\",\"aderire\",\"adipe\",\"adottare\",\"adulare\",\"affabile\",\"affetto\",\"affisso\",\"affranto\",\"aforisma\",\"afoso\",\"africano\",\"agave\",\"agente\",\"agevole\",\"aggancio\",\"agire\",\"agitare\",\"agonismo\",\"agricolo\",\"agrumeto\",\"aguzzo\",\"alabarda\",\"alato\",\"albatro\",\"alberato\",\"albo\",\"albume\",\"alce\",\"alcolico\",\"alettone\",\"alfa\",\"algebra\",\"aliante\",\"alibi\",\"alimento\",\"allagato\",\"allegro\",\"allievo\",\"allodola\",\"allusivo\",\"almeno\",\"alogeno\",\"alpaca\",\"alpestre\",\"altalena\",\"alterno\",\"alticcio\",\"altrove\",\"alunno\",\"alveolo\",\"alzare\",\"amalgama\",\"amanita\",\"amarena\",\"ambito\",\"ambrato\",\"ameba\",\"america\",\"ametista\",\"amico\",\"ammasso\",\"ammenda\",\"ammirare\",\"ammonito\",\"amore\",\"ampio\",\"ampliare\",\"amuleto\",\"anacardo\",\"anagrafe\",\"analista\",\"anarchia\",\"anatra\",\"anca\",\"ancella\",\"ancora\",\"andare\",\"andrea\",\"anello\",\"angelo\",\"angolare\",\"angusto\",\"anima\",\"annegare\",\"annidato\",\"anno\",\"annuncio\",\"anonimo\",\"anticipo\",\"anzi\",\"apatico\",\"apertura\",\"apode\",\"apparire\",\"appetito\",\"appoggio\",\"approdo\",\"appunto\",\"aprile\",\"arabica\",\"arachide\",\"aragosta\",\"araldica\",\"arancio\",\"aratura\",\"arazzo\",\"arbitro\",\"archivio\",\"ardito\",\"arenile\",\"argento\",\"argine\",\"arguto\",\"aria\",\"armonia\",\"arnese\",\"arredato\",\"arringa\",\"arrosto\",\"arsenico\",\"arso\",\"artefice\",\"arzillo\",\"asciutto\",\"ascolto\",\"asepsi\",\"asettico\",\"asfalto\",\"asino\",\"asola\",\"aspirato\",\"aspro\",\"assaggio\",\"asse\",\"assoluto\",\"assurdo\",\"asta\",\"astenuto\",\"astice\",\"astratto\",\"atavico\",\"ateismo\",\"atomico\",\"atono\",\"attesa\",\"attivare\",\"attorno\",\"attrito\",\"attuale\",\"ausilio\",\"austria\",\"autista\",\"autonomo\",\"autunno\",\"avanzato\",\"avere\",\"avvenire\",\"avviso\",\"avvolgere\",\"azione\",\"azoto\",\"azzimo\",\"azzurro\",\"babele\",\"baccano\",\"bacino\",\"baco\",\"badessa\",\"badilata\",\"bagnato\",\"baita\",\"balcone\",\"baldo\",\"balena\",\"ballata\",\"balzano\",\"bambino\",\"bandire\",\"baraonda\",\"barbaro\",\"barca\",\"baritono\",\"barlume\",\"barocco\",\"basilico\",\"basso\",\"batosta\",\"battuto\",\"baule\",\"bava\",\"bavosa\",\"becco\",\"beffa\",\"belgio\",\"belva\",\"benda\",\"benevole\",\"benigno\",\"benzina\",\"bere\",\"berlina\",\"beta\",\"bibita\",\"bici\",\"bidone\",\"bifido\",\"biga\",\"bilancia\",\"bimbo\",\"binocolo\",\"biologo\",\"bipede\",\"bipolare\",\"birbante\",\"birra\",\"biscotto\",\"bisesto\",\"bisnonno\",\"bisonte\",\"bisturi\",\"bizzarro\",\"blando\",\"blatta\",\"bollito\",\"bonifico\",\"bordo\",\"bosco\",\"botanico\",\"bottino\",\"bozzolo\",\"braccio\",\"bradipo\",\"brama\",\"branca\",\"bravura\",\"bretella\",\"brevetto\",\"brezza\",\"briglia\",\"brillante\",\"brindare\",\"broccolo\",\"brodo\",\"bronzina\",\"brullo\",\"bruno\",\"bubbone\",\"buca\",\"budino\",\"buffone\",\"buio\",\"bulbo\",\"buono\",\"burlone\",\"burrasca\",\"bussola\",\"busta\",\"cadetto\",\"caduco\",\"calamaro\",\"calcolo\",\"calesse\",\"calibro\",\"calmo\",\"caloria\",\"cambusa\",\"camerata\",\"camicia\",\"cammino\",\"camola\",\"campale\",\"canapa\",\"candela\",\"cane\",\"canino\",\"canotto\",\"cantina\",\"capace\",\"capello\",\"capitolo\",\"capogiro\",\"cappero\",\"capra\",\"capsula\",\"carapace\",\"carcassa\",\"cardo\",\"carisma\",\"carovana\",\"carretto\",\"cartolina\",\"casaccio\",\"cascata\",\"caserma\",\"caso\",\"cassone\",\"castello\",\"casuale\",\"catasta\",\"catena\",\"catrame\",\"cauto\",\"cavillo\",\"cedibile\",\"cedrata\",\"cefalo\",\"celebre\",\"cellulare\",\"cena\",\"cenone\",\"centesimo\",\"ceramica\",\"cercare\",\"certo\",\"cerume\",\"cervello\",\"cesoia\",\"cespo\",\"ceto\",\"chela\",\"chiaro\",\"chicca\",\"chiedere\",\"chimera\",\"china\",\"chirurgo\",\"chitarra\",\"ciao\",\"ciclismo\",\"cifrare\",\"cigno\",\"cilindro\",\"ciottolo\",\"circa\",\"cirrosi\",\"citrico\",\"cittadino\",\"ciuffo\",\"civetta\",\"civile\",\"classico\",\"clinica\",\"cloro\",\"cocco\",\"codardo\",\"codice\",\"coerente\",\"cognome\",\"collare\",\"colmato\",\"colore\",\"colposo\",\"coltivato\",\"colza\",\"coma\",\"cometa\",\"commando\",\"comodo\",\"computer\",\"comune\",\"conciso\",\"condurre\",\"conferma\",\"congelare\",\"coniuge\",\"connesso\",\"conoscere\",\"consumo\",\"continuo\",\"convegno\",\"coperto\",\"copione\",\"coppia\",\"copricapo\",\"corazza\",\"cordata\",\"coricato\",\"cornice\",\"corolla\",\"corpo\",\"corredo\",\"corsia\",\"cortese\",\"cosmico\",\"costante\",\"cottura\",\"covato\",\"cratere\",\"cravatta\",\"creato\",\"credere\",\"cremoso\",\"crescita\",\"creta\",\"criceto\",\"crinale\",\"crisi\",\"critico\",\"croce\",\"cronaca\",\"crostata\",\"cruciale\",\"crusca\",\"cucire\",\"cuculo\",\"cugino\",\"cullato\",\"cupola\",\"curatore\",\"cursore\",\"curvo\",\"cuscino\",\"custode\",\"dado\",\"daino\",\"dalmata\",\"damerino\",\"daniela\",\"dannoso\",\"danzare\",\"datato\",\"davanti\",\"davvero\",\"debutto\",\"decennio\",\"deciso\",\"declino\",\"decollo\",\"decreto\",\"dedicato\",\"definito\",\"deforme\",\"degno\",\"delegare\",\"delfino\",\"delirio\",\"delta\",\"demenza\",\"denotato\",\"dentro\",\"deposito\",\"derapata\",\"derivare\",\"deroga\",\"descritto\",\"deserto\",\"desiderio\",\"desumere\",\"detersivo\",\"devoto\",\"diametro\",\"dicembre\",\"diedro\",\"difeso\",\"diffuso\",\"digerire\",\"digitale\",\"diluvio\",\"dinamico\",\"dinnanzi\",\"dipinto\",\"diploma\",\"dipolo\",\"diradare\",\"dire\",\"dirotto\",\"dirupo\",\"disagio\",\"discreto\",\"disfare\",\"disgelo\",\"disposto\",\"distanza\",\"disumano\",\"dito\",\"divano\",\"divelto\",\"dividere\",\"divorato\",\"doblone\",\"docente\",\"doganale\",\"dogma\",\"dolce\",\"domato\",\"domenica\",\"dominare\",\"dondolo\",\"dono\",\"dormire\",\"dote\",\"dottore\",\"dovuto\",\"dozzina\",\"drago\",\"druido\",\"dubbio\",\"dubitare\",\"ducale\",\"duna\",\"duomo\",\"duplice\",\"duraturo\",\"ebano\",\"eccesso\",\"ecco\",\"eclissi\",\"economia\",\"edera\",\"edicola\",\"edile\",\"editoria\",\"educare\",\"egemonia\",\"egli\",\"egoismo\",\"egregio\",\"elaborato\",\"elargire\",\"elegante\",\"elencato\",\"eletto\",\"elevare\",\"elfico\",\"elica\",\"elmo\",\"elsa\",\"eluso\",\"emanato\",\"emblema\",\"emesso\",\"emiro\",\"emotivo\",\"emozione\",\"empirico\",\"emulo\",\"endemico\",\"enduro\",\"energia\",\"enfasi\",\"enoteca\",\"entrare\",\"enzima\",\"epatite\",\"epilogo\",\"episodio\",\"epocale\",\"eppure\",\"equatore\",\"erario\",\"erba\",\"erboso\",\"erede\",\"eremita\",\"erigere\",\"ermetico\",\"eroe\",\"erosivo\",\"errante\",\"esagono\",\"esame\",\"esanime\",\"esaudire\",\"esca\",\"esempio\",\"esercito\",\"esibito\",\"esigente\",\"esistere\",\"esito\",\"esofago\",\"esortato\",\"esoso\",\"espanso\",\"espresso\",\"essenza\",\"esso\",\"esteso\",\"estimare\",\"estonia\",\"estroso\",\"esultare\",\"etilico\",\"etnico\",\"etrusco\",\"etto\",\"euclideo\",\"europa\",\"evaso\",\"evidenza\",\"evitato\",\"evoluto\",\"evviva\",\"fabbrica\",\"faccenda\",\"fachiro\",\"falco\",\"famiglia\",\"fanale\",\"fanfara\",\"fango\",\"fantasma\",\"fare\",\"farfalla\",\"farinoso\",\"farmaco\",\"fascia\",\"fastoso\",\"fasullo\",\"faticare\",\"fato\",\"favoloso\",\"febbre\",\"fecola\",\"fede\",\"fegato\",\"felpa\",\"feltro\",\"femmina\",\"fendere\",\"fenomeno\",\"fermento\",\"ferro\",\"fertile\",\"fessura\",\"festivo\",\"fetta\",\"feudo\",\"fiaba\",\"fiducia\",\"fifa\",\"figurato\",\"filo\",\"finanza\",\"finestra\",\"finire\",\"fiore\",\"fiscale\",\"fisico\",\"fiume\",\"flacone\",\"flamenco\",\"flebo\",\"flemma\",\"florido\",\"fluente\",\"fluoro\",\"fobico\",\"focaccia\",\"focoso\",\"foderato\",\"foglio\",\"folata\",\"folclore\",\"folgore\",\"fondente\",\"fonetico\",\"fonia\",\"fontana\",\"forbito\",\"forchetta\",\"foresta\",\"formica\",\"fornaio\",\"foro\",\"fortezza\",\"forzare\",\"fosfato\",\"fosso\",\"fracasso\",\"frana\",\"frassino\",\"fratello\",\"freccetta\",\"frenata\",\"fresco\",\"frigo\",\"frollino\",\"fronde\",\"frugale\",\"frutta\",\"fucilata\",\"fucsia\",\"fuggente\",\"fulmine\",\"fulvo\",\"fumante\",\"fumetto\",\"fumoso\",\"fune\",\"funzione\",\"fuoco\",\"furbo\",\"furgone\",\"furore\",\"fuso\",\"futile\",\"gabbiano\",\"gaffe\",\"galateo\",\"gallina\",\"galoppo\",\"gambero\",\"gamma\",\"garanzia\",\"garbo\",\"garofano\",\"garzone\",\"gasdotto\",\"gasolio\",\"gastrico\",\"gatto\",\"gaudio\",\"gazebo\",\"gazzella\",\"geco\",\"gelatina\",\"gelso\",\"gemello\",\"gemmato\",\"gene\",\"genitore\",\"gennaio\",\"genotipo\",\"gergo\",\"ghepardo\",\"ghiaccio\",\"ghisa\",\"giallo\",\"gilda\",\"ginepro\",\"giocare\",\"gioiello\",\"giorno\",\"giove\",\"girato\",\"girone\",\"gittata\",\"giudizio\",\"giurato\",\"giusto\",\"globulo\",\"glutine\",\"gnomo\",\"gobba\",\"golf\",\"gomito\",\"gommone\",\"gonfio\",\"gonna\",\"governo\",\"gracile\",\"grado\",\"grafico\",\"grammo\",\"grande\",\"grattare\",\"gravoso\",\"grazia\",\"greca\",\"gregge\",\"grifone\",\"grigio\",\"grinza\",\"grotta\",\"gruppo\",\"guadagno\",\"guaio\",\"guanto\",\"guardare\",\"gufo\",\"guidare\",\"ibernato\",\"icona\",\"identico\",\"idillio\",\"idolo\",\"idra\",\"idrico\",\"idrogeno\",\"igiene\",\"ignaro\",\"ignorato\",\"ilare\",\"illeso\",\"illogico\",\"illudere\",\"imballo\",\"imbevuto\",\"imbocco\",\"imbuto\",\"immane\",\"immerso\",\"immolato\",\"impacco\",\"impeto\",\"impiego\",\"importo\",\"impronta\",\"inalare\",\"inarcare\",\"inattivo\",\"incanto\",\"incendio\",\"inchino\",\"incisivo\",\"incluso\",\"incontro\",\"incrocio\",\"incubo\",\"indagine\",\"india\",\"indole\",\"inedito\",\"infatti\",\"infilare\",\"inflitto\",\"ingaggio\",\"ingegno\",\"inglese\",\"ingordo\",\"ingrosso\",\"innesco\",\"inodore\",\"inoltrare\",\"inondato\",\"insano\",\"insetto\",\"insieme\",\"insonnia\",\"insulina\",\"intasato\",\"intero\",\"intonaco\",\"intuito\",\"inumidire\",\"invalido\",\"invece\",\"invito\",\"iperbole\",\"ipnotico\",\"ipotesi\",\"ippica\",\"iride\",\"irlanda\",\"ironico\",\"irrigato\",\"irrorare\",\"isolato\",\"isotopo\",\"isterico\",\"istituto\",\"istrice\",\"italia\",\"iterare\",\"labbro\",\"labirinto\",\"lacca\",\"lacerato\",\"lacrima\",\"lacuna\",\"laddove\",\"lago\",\"lampo\",\"lancetta\",\"lanterna\",\"lardoso\",\"larga\",\"laringe\",\"lastra\",\"latenza\",\"latino\",\"lattuga\",\"lavagna\",\"lavoro\",\"legale\",\"leggero\",\"lembo\",\"lentezza\",\"lenza\",\"leone\",\"lepre\",\"lesivo\",\"lessato\",\"lesto\",\"letterale\",\"leva\",\"levigato\",\"libero\",\"lido\",\"lievito\",\"lilla\",\"limatura\",\"limitare\",\"limpido\",\"lineare\",\"lingua\",\"liquido\",\"lira\",\"lirica\",\"lisca\",\"lite\",\"litigio\",\"livrea\",\"locanda\",\"lode\",\"logica\",\"lombare\",\"londra\",\"longevo\",\"loquace\",\"lorenzo\",\"loto\",\"lotteria\",\"luce\",\"lucidato\",\"lumaca\",\"luminoso\",\"lungo\",\"lupo\",\"luppolo\",\"lusinga\",\"lusso\",\"lutto\",\"macabro\",\"macchina\",\"macero\",\"macinato\",\"madama\",\"magico\",\"maglia\",\"magnete\",\"magro\",\"maiolica\",\"malafede\",\"malgrado\",\"malinteso\",\"malsano\",\"malto\",\"malumore\",\"mana\",\"mancia\",\"mandorla\",\"mangiare\",\"manifesto\",\"mannaro\",\"manovra\",\"mansarda\",\"mantide\",\"manubrio\",\"mappa\",\"maratona\",\"marcire\",\"maretta\",\"marmo\",\"marsupio\",\"maschera\",\"massaia\",\"mastino\",\"materasso\",\"matricola\",\"mattone\",\"maturo\",\"mazurca\",\"meandro\",\"meccanico\",\"mecenate\",\"medesimo\",\"meditare\",\"mega\",\"melassa\",\"melis\",\"melodia\",\"meninge\",\"meno\",\"mensola\",\"mercurio\",\"merenda\",\"merlo\",\"meschino\",\"mese\",\"messere\",\"mestolo\",\"metallo\",\"metodo\",\"mettere\",\"miagolare\",\"mica\",\"micelio\",\"michele\",\"microbo\",\"midollo\",\"miele\",\"migliore\",\"milano\",\"milite\",\"mimosa\",\"minerale\",\"mini\",\"minore\",\"mirino\",\"mirtillo\",\"miscela\",\"missiva\",\"misto\",\"misurare\",\"mitezza\",\"mitigare\",\"mitra\",\"mittente\",\"mnemonico\",\"modello\",\"modifica\",\"modulo\",\"mogano\",\"mogio\",\"mole\",\"molosso\",\"monastero\",\"monco\",\"mondina\",\"monetario\",\"monile\",\"monotono\",\"monsone\",\"montato\",\"monviso\",\"mora\",\"mordere\",\"morsicato\",\"mostro\",\"motivato\",\"motosega\",\"motto\",\"movenza\",\"movimento\",\"mozzo\",\"mucca\",\"mucosa\",\"muffa\",\"mughetto\",\"mugnaio\",\"mulatto\",\"mulinello\",\"multiplo\",\"mummia\",\"munto\",\"muovere\",\"murale\",\"musa\",\"muscolo\",\"musica\",\"mutevole\",\"muto\",\"nababbo\",\"nafta\",\"nanometro\",\"narciso\",\"narice\",\"narrato\",\"nascere\",\"nastrare\",\"naturale\",\"nautica\",\"naviglio\",\"nebulosa\",\"necrosi\",\"negativo\",\"negozio\",\"nemmeno\",\"neofita\",\"neretto\",\"nervo\",\"nessuno\",\"nettuno\",\"neutrale\",\"neve\",\"nevrotico\",\"nicchia\",\"ninfa\",\"nitido\",\"nobile\",\"nocivo\",\"nodo\",\"nome\",\"nomina\",\"nordico\",\"normale\",\"norvegese\",\"nostrano\",\"notare\",\"notizia\",\"notturno\",\"novella\",\"nucleo\",\"nulla\",\"numero\",\"nuovo\",\"nutrire\",\"nuvola\",\"nuziale\",\"oasi\",\"obbedire\",\"obbligo\",\"obelisco\",\"oblio\",\"obolo\",\"obsoleto\",\"occasione\",\"occhio\",\"occidente\",\"occorrere\",\"occultare\",\"ocra\",\"oculato\",\"odierno\",\"odorare\",\"offerta\",\"offrire\",\"offuscato\",\"oggetto\",\"oggi\",\"ognuno\",\"olandese\",\"olfatto\",\"oliato\",\"oliva\",\"ologramma\",\"oltre\",\"omaggio\",\"ombelico\",\"ombra\",\"omega\",\"omissione\",\"ondoso\",\"onere\",\"onice\",\"onnivoro\",\"onorevole\",\"onta\",\"operato\",\"opinione\",\"opposto\",\"oracolo\",\"orafo\",\"ordine\",\"orecchino\",\"orefice\",\"orfano\",\"organico\",\"origine\",\"orizzonte\",\"orma\",\"ormeggio\",\"ornativo\",\"orologio\",\"orrendo\",\"orribile\",\"ortensia\",\"ortica\",\"orzata\",\"orzo\",\"osare\",\"oscurare\",\"osmosi\",\"ospedale\",\"ospite\",\"ossa\",\"ossidare\",\"ostacolo\",\"oste\",\"otite\",\"otre\",\"ottagono\",\"ottimo\",\"ottobre\",\"ovale\",\"ovest\",\"ovino\",\"oviparo\",\"ovocito\",\"ovunque\",\"ovviare\",\"ozio\",\"pacchetto\",\"pace\",\"pacifico\",\"padella\",\"padrone\",\"paese\",\"paga\",\"pagina\",\"palazzina\",\"palesare\",\"pallido\",\"palo\",\"palude\",\"pandoro\",\"pannello\",\"paolo\",\"paonazzo\",\"paprica\",\"parabola\",\"parcella\",\"parere\",\"pargolo\",\"pari\",\"parlato\",\"parola\",\"partire\",\"parvenza\",\"parziale\",\"passivo\",\"pasticca\",\"patacca\",\"patologia\",\"pattume\",\"pavone\",\"peccato\",\"pedalare\",\"pedonale\",\"peggio\",\"peloso\",\"penare\",\"pendice\",\"penisola\",\"pennuto\",\"penombra\",\"pensare\",\"pentola\",\"pepe\",\"pepita\",\"perbene\",\"percorso\",\"perdonato\",\"perforare\",\"pergamena\",\"periodo\",\"permesso\",\"perno\",\"perplesso\",\"persuaso\",\"pertugio\",\"pervaso\",\"pesatore\",\"pesista\",\"peso\",\"pestifero\",\"petalo\",\"pettine\",\"petulante\",\"pezzo\",\"piacere\",\"pianta\",\"piattino\",\"piccino\",\"picozza\",\"piega\",\"pietra\",\"piffero\",\"pigiama\",\"pigolio\",\"pigro\",\"pila\",\"pilifero\",\"pillola\",\"pilota\",\"pimpante\",\"pineta\",\"pinna\",\"pinolo\",\"pioggia\",\"piombo\",\"piramide\",\"piretico\",\"pirite\",\"pirolisi\",\"pitone\",\"pizzico\",\"placebo\",\"planare\",\"plasma\",\"platano\",\"plenario\",\"pochezza\",\"poderoso\",\"podismo\",\"poesia\",\"poggiare\",\"polenta\",\"poligono\",\"pollice\",\"polmonite\",\"polpetta\",\"polso\",\"poltrona\",\"polvere\",\"pomice\",\"pomodoro\",\"ponte\",\"popoloso\",\"porfido\",\"poroso\",\"porpora\",\"porre\",\"portata\",\"posa\",\"positivo\",\"possesso\",\"postulato\",\"potassio\",\"potere\",\"pranzo\",\"prassi\",\"pratica\",\"precluso\",\"predica\",\"prefisso\",\"pregiato\",\"prelievo\",\"premere\",\"prenotare\",\"preparato\",\"presenza\",\"pretesto\",\"prevalso\",\"prima\",\"principe\",\"privato\",\"problema\",\"procura\",\"produrre\",\"profumo\",\"progetto\",\"prolunga\",\"promessa\",\"pronome\",\"proposta\",\"proroga\",\"proteso\",\"prova\",\"prudente\",\"prugna\",\"prurito\",\"psiche\",\"pubblico\",\"pudica\",\"pugilato\",\"pugno\",\"pulce\",\"pulito\",\"pulsante\",\"puntare\",\"pupazzo\",\"pupilla\",\"puro\",\"quadro\",\"qualcosa\",\"quasi\",\"querela\",\"quota\",\"raccolto\",\"raddoppio\",\"radicale\",\"radunato\",\"raffica\",\"ragazzo\",\"ragione\",\"ragno\",\"ramarro\",\"ramingo\",\"ramo\",\"randagio\",\"rantolare\",\"rapato\",\"rapina\",\"rappreso\",\"rasatura\",\"raschiato\",\"rasente\",\"rassegna\",\"rastrello\",\"rata\",\"ravveduto\",\"reale\",\"recepire\",\"recinto\",\"recluta\",\"recondito\",\"recupero\",\"reddito\",\"redimere\",\"regalato\",\"registro\",\"regola\",\"regresso\",\"relazione\",\"remare\",\"remoto\",\"renna\",\"replica\",\"reprimere\",\"reputare\",\"resa\",\"residente\",\"responso\",\"restauro\",\"rete\",\"retina\",\"retorica\",\"rettifica\",\"revocato\",\"riassunto\",\"ribadire\",\"ribelle\",\"ribrezzo\",\"ricarica\",\"ricco\",\"ricevere\",\"riciclato\",\"ricordo\",\"ricreduto\",\"ridicolo\",\"ridurre\",\"rifasare\",\"riflesso\",\"riforma\",\"rifugio\",\"rigare\",\"rigettato\",\"righello\",\"rilassato\",\"rilevato\",\"rimanere\",\"rimbalzo\",\"rimedio\",\"rimorchio\",\"rinascita\",\"rincaro\",\"rinforzo\",\"rinnovo\",\"rinomato\",\"rinsavito\",\"rintocco\",\"rinuncia\",\"rinvenire\",\"riparato\",\"ripetuto\",\"ripieno\",\"riportare\",\"ripresa\",\"ripulire\",\"risata\",\"rischio\",\"riserva\",\"risibile\",\"riso\",\"rispetto\",\"ristoro\",\"risultato\",\"risvolto\",\"ritardo\",\"ritegno\",\"ritmico\",\"ritrovo\",\"riunione\",\"riva\",\"riverso\",\"rivincita\",\"rivolto\",\"rizoma\",\"roba\",\"robotico\",\"robusto\",\"roccia\",\"roco\",\"rodaggio\",\"rodere\",\"roditore\",\"rogito\",\"rollio\",\"romantico\",\"rompere\",\"ronzio\",\"rosolare\",\"rospo\",\"rotante\",\"rotondo\",\"rotula\",\"rovescio\",\"rubizzo\",\"rubrica\",\"ruga\",\"rullino\",\"rumine\",\"rumoroso\",\"ruolo\",\"rupe\",\"russare\",\"rustico\",\"sabato\",\"sabbiare\",\"sabotato\",\"sagoma\",\"salasso\",\"saldatura\",\"salgemma\",\"salivare\",\"salmone\",\"salone\",\"saltare\",\"saluto\",\"salvo\",\"sapere\",\"sapido\",\"saporito\",\"saraceno\",\"sarcasmo\",\"sarto\",\"sassoso\",\"satellite\",\"satira\",\"satollo\",\"saturno\",\"savana\",\"savio\",\"saziato\",\"sbadiglio\",\"sbalzo\",\"sbancato\",\"sbarra\",\"sbattere\",\"sbavare\",\"sbendare\",\"sbirciare\",\"sbloccato\",\"sbocciato\",\"sbrinare\",\"sbruffone\",\"sbuffare\",\"scabroso\",\"scadenza\",\"scala\",\"scambiare\",\"scandalo\",\"scapola\",\"scarso\",\"scatenare\",\"scavato\",\"scelto\",\"scenico\",\"scettro\",\"scheda\",\"schiena\",\"sciarpa\",\"scienza\",\"scindere\",\"scippo\",\"sciroppo\",\"scivolo\",\"sclerare\",\"scodella\",\"scolpito\",\"scomparto\",\"sconforto\",\"scoprire\",\"scorta\",\"scossone\",\"scozzese\",\"scriba\",\"scrollare\",\"scrutinio\",\"scuderia\",\"scultore\",\"scuola\",\"scuro\",\"scusare\",\"sdebitare\",\"sdoganare\",\"seccatura\",\"secondo\",\"sedano\",\"seggiola\",\"segnalato\",\"segregato\",\"seguito\",\"selciato\",\"selettivo\",\"sella\",\"selvaggio\",\"semaforo\",\"sembrare\",\"seme\",\"seminato\",\"sempre\",\"senso\",\"sentire\",\"sepolto\",\"sequenza\",\"serata\",\"serbato\",\"sereno\",\"serio\",\"serpente\",\"serraglio\",\"servire\",\"sestina\",\"setola\",\"settimana\",\"sfacelo\",\"sfaldare\",\"sfamato\",\"sfarzoso\",\"sfaticato\",\"sfera\",\"sfida\",\"sfilato\",\"sfinge\",\"sfocato\",\"sfoderare\",\"sfogo\",\"sfoltire\",\"sforzato\",\"sfratto\",\"sfruttato\",\"sfuggito\",\"sfumare\",\"sfuso\",\"sgabello\",\"sgarbato\",\"sgonfiare\",\"sgorbio\",\"sgrassato\",\"sguardo\",\"sibilo\",\"siccome\",\"sierra\",\"sigla\",\"signore\",\"silenzio\",\"sillaba\",\"simbolo\",\"simpatico\",\"simulato\",\"sinfonia\",\"singolo\",\"sinistro\",\"sino\",\"sintesi\",\"sinusoide\",\"sipario\",\"sisma\",\"sistole\",\"situato\",\"slitta\",\"slogatura\",\"sloveno\",\"smarrito\",\"smemorato\",\"smentito\",\"smeraldo\",\"smilzo\",\"smontare\",\"smottato\",\"smussato\",\"snellire\",\"snervato\",\"snodo\",\"sobbalzo\",\"sobrio\",\"soccorso\",\"sociale\",\"sodale\",\"soffitto\",\"sogno\",\"soldato\",\"solenne\",\"solido\",\"sollazzo\",\"solo\",\"solubile\",\"solvente\",\"somatico\",\"somma\",\"sonda\",\"sonetto\",\"sonnifero\",\"sopire\",\"soppeso\",\"sopra\",\"sorgere\",\"sorpasso\",\"sorriso\",\"sorso\",\"sorteggio\",\"sorvolato\",\"sospiro\",\"sosta\",\"sottile\",\"spada\",\"spalla\",\"spargere\",\"spatola\",\"spavento\",\"spazzola\",\"specie\",\"spedire\",\"spegnere\",\"spelatura\",\"speranza\",\"spessore\",\"spettrale\",\"spezzato\",\"spia\",\"spigoloso\",\"spillato\",\"spinoso\",\"spirale\",\"splendido\",\"sportivo\",\"sposo\",\"spranga\",\"sprecare\",\"spronato\",\"spruzzo\",\"spuntino\",\"squillo\",\"sradicare\",\"srotolato\",\"stabile\",\"stacco\",\"staffa\",\"stagnare\",\"stampato\",\"stantio\",\"starnuto\",\"stasera\",\"statuto\",\"stelo\",\"steppa\",\"sterzo\",\"stiletto\",\"stima\",\"stirpe\",\"stivale\",\"stizzoso\",\"stonato\",\"storico\",\"strappo\",\"stregato\",\"stridulo\",\"strozzare\",\"strutto\",\"stuccare\",\"stufo\",\"stupendo\",\"subentro\",\"succoso\",\"sudore\",\"suggerito\",\"sugo\",\"sultano\",\"suonare\",\"superbo\",\"supporto\",\"surgelato\",\"surrogato\",\"sussurro\",\"sutura\",\"svagare\",\"svedese\",\"sveglio\",\"svelare\",\"svenuto\",\"svezia\",\"sviluppo\",\"svista\",\"svizzera\",\"svolta\",\"svuotare\",\"tabacco\",\"tabulato\",\"tacciare\",\"taciturno\",\"tale\",\"talismano\",\"tampone\",\"tannino\",\"tara\",\"tardivo\",\"targato\",\"tariffa\",\"tarpare\",\"tartaruga\",\"tasto\",\"tattico\",\"taverna\",\"tavolata\",\"tazza\",\"teca\",\"tecnico\",\"telefono\",\"temerario\",\"tempo\",\"temuto\",\"tendone\",\"tenero\",\"tensione\",\"tentacolo\",\"teorema\",\"terme\",\"terrazzo\",\"terzetto\",\"tesi\",\"tesserato\",\"testato\",\"tetro\",\"tettoia\",\"tifare\",\"tigella\",\"timbro\",\"tinto\",\"tipico\",\"tipografo\",\"tiraggio\",\"tiro\",\"titanio\",\"titolo\",\"titubante\",\"tizio\",\"tizzone\",\"toccare\",\"tollerare\",\"tolto\",\"tombola\",\"tomo\",\"tonfo\",\"tonsilla\",\"topazio\",\"topologia\",\"toppa\",\"torba\",\"tornare\",\"torrone\",\"tortora\",\"toscano\",\"tossire\",\"tostatura\",\"totano\",\"trabocco\",\"trachea\",\"trafila\",\"tragedia\",\"tralcio\",\"tramonto\",\"transito\",\"trapano\",\"trarre\",\"trasloco\",\"trattato\",\"trave\",\"treccia\",\"tremolio\",\"trespolo\",\"tributo\",\"tricheco\",\"trifoglio\",\"trillo\",\"trincea\",\"trio\",\"tristezza\",\"triturato\",\"trivella\",\"tromba\",\"trono\",\"troppo\",\"trottola\",\"trovare\",\"truccato\",\"tubatura\",\"tuffato\",\"tulipano\",\"tumulto\",\"tunisia\",\"turbare\",\"turchino\",\"tuta\",\"tutela\",\"ubicato\",\"uccello\",\"uccisore\",\"udire\",\"uditivo\",\"uffa\",\"ufficio\",\"uguale\",\"ulisse\",\"ultimato\",\"umano\",\"umile\",\"umorismo\",\"uncinetto\",\"ungere\",\"ungherese\",\"unicorno\",\"unificato\",\"unisono\",\"unitario\",\"unte\",\"uovo\",\"upupa\",\"uragano\",\"urgenza\",\"urlo\",\"usanza\",\"usato\",\"uscito\",\"usignolo\",\"usuraio\",\"utensile\",\"utilizzo\",\"utopia\",\"vacante\",\"vaccinato\",\"vagabondo\",\"vagliato\",\"valanga\",\"valgo\",\"valico\",\"valletta\",\"valoroso\",\"valutare\",\"valvola\",\"vampata\",\"vangare\",\"vanitoso\",\"vano\",\"vantaggio\",\"vanvera\",\"vapore\",\"varano\",\"varcato\",\"variante\",\"vasca\",\"vedetta\",\"vedova\",\"veduto\",\"vegetale\",\"veicolo\",\"velcro\",\"velina\",\"velluto\",\"veloce\",\"venato\",\"vendemmia\",\"vento\",\"verace\",\"verbale\",\"vergogna\",\"verifica\",\"vero\",\"verruca\",\"verticale\",\"vescica\",\"vessillo\",\"vestale\",\"veterano\",\"vetrina\",\"vetusto\",\"viandante\",\"vibrante\",\"vicenda\",\"vichingo\",\"vicinanza\",\"vidimare\",\"vigilia\",\"vigneto\",\"vigore\",\"vile\",\"villano\",\"vimini\",\"vincitore\",\"viola\",\"vipera\",\"virgola\",\"virologo\",\"virulento\",\"viscoso\",\"visione\",\"vispo\",\"vissuto\",\"visura\",\"vita\",\"vitello\",\"vittima\",\"vivanda\",\"vivido\",\"viziare\",\"voce\",\"voga\",\"volatile\",\"volere\",\"volpe\",\"voragine\",\"vulcano\",\"zampogna\",\"zanna\",\"zappato\",\"zattera\",\"zavorra\",\"zefiro\",\"zelante\",\"zelo\",\"zenzero\",\"zerbino\",\"zibetto\",\"zinco\",\"zircone\",\"zitto\",\"zolla\",\"zotico\",\"zucchero\",\"zufolo\",\"zulu\",\"zuppa\"]");

},{}],"4kHFs":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('["a\u0301baco","abdomen","abeja","abierto","abogado","abono","aborto","abrazo","abrir","abuelo","abuso","acabar","academia","acceso","accio\u0301n","aceite","acelga","acento","aceptar","a\u0301cido","aclarar","acne\u0301","acoger","acoso","activo","acto","actriz","actuar","acudir","acuerdo","acusar","adicto","admitir","adoptar","adorno","aduana","adulto","ae\u0301reo","afectar","aficio\u0301n","afinar","afirmar","a\u0301gil","agitar","agoni\u0301a","agosto","agotar","agregar","agrio","agua","agudo","a\u0301guila","aguja","ahogo","ahorro","aire","aislar","ajedrez","ajeno","ajuste","alacra\u0301n","alambre","alarma","alba","a\u0301lbum","alcalde","aldea","alegre","alejar","alerta","aleta","alfiler","alga","algodo\u0301n","aliado","aliento","alivio","alma","almeja","almi\u0301bar","altar","alteza","altivo","alto","altura","alumno","alzar","amable","amante","amapola","amargo","amasar","a\u0301mbar","a\u0301mbito","ameno","amigo","amistad","amor","amparo","amplio","ancho","anciano","ancla","andar","ande\u0301n","anemia","a\u0301ngulo","anillo","a\u0301nimo","ani\u0301s","anotar","antena","antiguo","antojo","anual","anular","anuncio","an\u0303adir","an\u0303ejo","an\u0303o","apagar","aparato","apetito","apio","aplicar","apodo","aporte","apoyo","aprender","aprobar","apuesta","apuro","arado","aran\u0303a","arar","a\u0301rbitro","a\u0301rbol","arbusto","archivo","arco","arder","ardilla","arduo","a\u0301rea","a\u0301rido","aries","armoni\u0301a","arne\u0301s","aroma","arpa","arpo\u0301n","arreglo","arroz","arruga","arte","artista","asa","asado","asalto","ascenso","asegurar","aseo","asesor","asiento","asilo","asistir","asno","asombro","a\u0301spero","astilla","astro","astuto","asumir","asunto","atajo","ataque","atar","atento","ateo","a\u0301tico","atleta","a\u0301tomo","atraer","atroz","atu\u0301n","audaz","audio","auge","aula","aumento","ausente","autor","aval","avance","avaro","ave","avellana","avena","avestruz","avio\u0301n","aviso","ayer","ayuda","ayuno","azafra\u0301n","azar","azote","azu\u0301car","azufre","azul","baba","babor","bache","bahi\u0301a","baile","bajar","balanza","balco\u0301n","balde","bambu\u0301","banco","banda","ban\u0303o","barba","barco","barniz","barro","ba\u0301scula","basto\u0301n","basura","batalla","bateri\u0301a","batir","batuta","bau\u0301l","bazar","bebe\u0301","bebida","bello","besar","beso","bestia","bicho","bien","bingo","blanco","bloque","blusa","boa","bobina","bobo","boca","bocina","boda","bodega","boina","bola","bolero","bolsa","bomba","bondad","bonito","bono","bonsa\u0301i","borde","borrar","bosque","bote","boti\u0301n","bo\u0301veda","bozal","bravo","brazo","brecha","breve","brillo","brinco","brisa","broca","broma","bronce","brote","bruja","brusco","bruto","buceo","bucle","bueno","buey","bufanda","bufo\u0301n","bu\u0301ho","buitre","bulto","burbuja","burla","burro","buscar","butaca","buzo\u0301n","caballo","cabeza","cabina","cabra","cacao","cada\u0301ver","cadena","caer","cafe\u0301","cai\u0301da","caima\u0301n","caja","cajo\u0301n","cal","calamar","calcio","caldo","calidad","calle","calma","calor","calvo","cama","cambio","camello","camino","campo","ca\u0301ncer","candil","canela","canguro","canica","canto","can\u0303a","can\u0303o\u0301n","caoba","caos","capaz","capita\u0301n","capote","captar","capucha","cara","carbo\u0301n","ca\u0301rcel","careta","carga","carin\u0303o","carne","carpeta","carro","carta","casa","casco","casero","caspa","castor","catorce","catre","caudal","causa","cazo","cebolla","ceder","cedro","celda","ce\u0301lebre","celoso","ce\u0301lula","cemento","ceniza","centro","cerca","cerdo","cereza","cero","cerrar","certeza","ce\u0301sped","cetro","chacal","chaleco","champu\u0301","chancla","chapa","charla","chico","chiste","chivo","choque","choza","chuleta","chupar","ciclo\u0301n","ciego","cielo","cien","cierto","cifra","cigarro","cima","cinco","cine","cinta","cipre\u0301s","circo","ciruela","cisne","cita","ciudad","clamor","clan","claro","clase","clave","cliente","clima","cli\u0301nica","cobre","coccio\u0301n","cochino","cocina","coco","co\u0301digo","codo","cofre","coger","cohete","coji\u0301n","cojo","cola","colcha","colegio","colgar","colina","collar","colmo","columna","combate","comer","comida","co\u0301modo","compra","conde","conejo","conga","conocer","consejo","contar","copa","copia","corazo\u0301n","corbata","corcho","cordo\u0301n","corona","correr","coser","cosmos","costa","cra\u0301neo","cra\u0301ter","crear","crecer","crei\u0301do","crema","cri\u0301a","crimen","cripta","crisis","cromo","cro\u0301nica","croqueta","crudo","cruz","cuadro","cuarto","cuatro","cubo","cubrir","cuchara","cuello","cuento","cuerda","cuesta","cueva","cuidar","culebra","culpa","culto","cumbre","cumplir","cuna","cuneta","cuota","cupo\u0301n","cu\u0301pula","curar","curioso","curso","curva","cutis","dama","danza","dar","dardo","da\u0301til","deber","de\u0301bil","de\u0301cada","decir","dedo","defensa","definir","dejar","delfi\u0301n","delgado","delito","demora","denso","dental","deporte","derecho","derrota","desayuno","deseo","desfile","desnudo","destino","desvi\u0301o","detalle","detener","deuda","di\u0301a","diablo","diadema","diamante","diana","diario","dibujo","dictar","diente","dieta","diez","difi\u0301cil","digno","dilema","diluir","dinero","directo","dirigir","disco","disen\u0303o","disfraz","diva","divino","doble","doce","dolor","domingo","don","donar","dorado","dormir","dorso","dos","dosis","drago\u0301n","droga","ducha","duda","duelo","duen\u0303o","dulce","du\u0301o","duque","durar","dureza","duro","e\u0301bano","ebrio","echar","eco","ecuador","edad","edicio\u0301n","edificio","editor","educar","efecto","eficaz","eje","ejemplo","elefante","elegir","elemento","elevar","elipse","e\u0301lite","elixir","elogio","eludir","embudo","emitir","emocio\u0301n","empate","empen\u0303o","empleo","empresa","enano","encargo","enchufe","enci\u0301a","enemigo","enero","enfado","enfermo","engan\u0303o","enigma","enlace","enorme","enredo","ensayo","ensen\u0303ar","entero","entrar","envase","envi\u0301o","e\u0301poca","equipo","erizo","escala","escena","escolar","escribir","escudo","esencia","esfera","esfuerzo","espada","espejo","espi\u0301a","esposa","espuma","esqui\u0301","estar","este","estilo","estufa","etapa","eterno","e\u0301tica","etnia","evadir","evaluar","evento","evitar","exacto","examen","exceso","excusa","exento","exigir","exilio","existir","e\u0301xito","experto","explicar","exponer","extremo","fa\u0301brica","fa\u0301bula","fachada","fa\u0301cil","factor","faena","faja","falda","fallo","falso","faltar","fama","familia","famoso","farao\u0301n","farmacia","farol","farsa","fase","fatiga","fauna","favor","fax","febrero","fecha","feliz","feo","feria","feroz","fe\u0301rtil","fervor","festi\u0301n","fiable","fianza","fiar","fibra","ficcio\u0301n","ficha","fideo","fiebre","fiel","fiera","fiesta","figura","fijar","fijo","fila","filete","filial","filtro","fin","finca","fingir","finito","firma","flaco","flauta","flecha","flor","flota","fluir","flujo","flu\u0301or","fobia","foca","fogata","fogo\u0301n","folio","folleto","fondo","forma","forro","fortuna","forzar","fosa","foto","fracaso","fra\u0301gil","franja","frase","fraude","frei\u0301r","freno","fresa","fri\u0301o","frito","fruta","fuego","fuente","fuerza","fuga","fumar","funcio\u0301n","funda","furgo\u0301n","furia","fusil","fu\u0301tbol","futuro","gacela","gafas","gaita","gajo","gala","galeri\u0301a","gallo","gamba","ganar","gancho","ganga","ganso","garaje","garza","gasolina","gastar","gato","gavila\u0301n","gemelo","gemir","gen","ge\u0301nero","genio","gente","geranio","gerente","germen","gesto","gigante","gimnasio","girar","giro","glaciar","globo","gloria","gol","golfo","goloso","golpe","goma","gordo","gorila","gorra","gota","goteo","gozar","grada","gra\u0301fico","grano","grasa","gratis","grave","grieta","grillo","gripe","gris","grito","grosor","gru\u0301a","grueso","grumo","grupo","guante","guapo","guardia","guerra","gui\u0301a","guin\u0303o","guion","guiso","guitarra","gusano","gustar","haber","ha\u0301bil","hablar","hacer","hacha","hada","hallar","hamaca","harina","haz","hazan\u0303a","hebilla","hebra","hecho","helado","helio","hembra","herir","hermano","he\u0301roe","hervir","hielo","hierro","hi\u0301gado","higiene","hijo","himno","historia","hocico","hogar","hoguera","hoja","hombre","hongo","honor","honra","hora","hormiga","horno","hostil","hoyo","hueco","huelga","huerta","hueso","huevo","huida","huir","humano","hu\u0301medo","humilde","humo","hundir","huraca\u0301n","hurto","icono","ideal","idioma","i\u0301dolo","iglesia","iglu\u0301","igual","ilegal","ilusio\u0301n","imagen","ima\u0301n","imitar","impar","imperio","imponer","impulso","incapaz","i\u0301ndice","inerte","infiel","informe","ingenio","inicio","inmenso","inmune","innato","insecto","instante","intere\u0301s","i\u0301ntimo","intuir","inu\u0301til","invierno","ira","iris","ironi\u0301a","isla","islote","jabali\u0301","jabo\u0301n","jamo\u0301n","jarabe","jardi\u0301n","jarra","jaula","jazmi\u0301n","jefe","jeringa","jinete","jornada","joroba","joven","joya","juerga","jueves","juez","jugador","jugo","juguete","juicio","junco","jungla","junio","juntar","ju\u0301piter","jurar","justo","juvenil","juzgar","kilo","koala","labio","lacio","lacra","lado","ladro\u0301n","lagarto","la\u0301grima","laguna","laico","lamer","la\u0301mina","la\u0301mpara","lana","lancha","langosta","lanza","la\u0301piz","largo","larva","la\u0301stima","lata","la\u0301tex","latir","laurel","lavar","lazo","leal","leccio\u0301n","leche","lector","leer","legio\u0301n","legumbre","lejano","lengua","lento","len\u0303a","leo\u0301n","leopardo","lesio\u0301n","letal","letra","leve","leyenda","libertad","libro","licor","li\u0301der","lidiar","lienzo","liga","ligero","lima","li\u0301mite","limo\u0301n","limpio","lince","lindo","li\u0301nea","lingote","lino","linterna","li\u0301quido","liso","lista","litera","litio","litro","llaga","llama","llanto","llave","llegar","llenar","llevar","llorar","llover","lluvia","lobo","locio\u0301n","loco","locura","lo\u0301gica","logro","lombriz","lomo","lonja","lote","lucha","lucir","lugar","lujo","luna","lunes","lupa","lustro","luto","luz","maceta","macho","madera","madre","maduro","maestro","mafia","magia","mago","mai\u0301z","maldad","maleta","malla","malo","mama\u0301","mambo","mamut","manco","mando","manejar","manga","maniqui\u0301","manjar","mano","manso","manta","man\u0303ana","mapa","ma\u0301quina","mar","marco","marea","marfil","margen","marido","ma\u0301rmol","marro\u0301n","martes","marzo","masa","ma\u0301scara","masivo","matar","materia","matiz","matriz","ma\u0301ximo","mayor","mazorca","mecha","medalla","medio","me\u0301dula","mejilla","mejor","melena","melo\u0301n","memoria","menor","mensaje","mente","menu\u0301","mercado","merengue","me\u0301rito","mes","meso\u0301n","meta","meter","me\u0301todo","metro","mezcla","miedo","miel","miembro","miga","mil","milagro","militar","millo\u0301n","mimo","mina","minero","mi\u0301nimo","minuto","miope","mirar","misa","miseria","misil","mismo","mitad","mito","mochila","mocio\u0301n","moda","modelo","moho","mojar","molde","moler","molino","momento","momia","monarca","moneda","monja","monto","mon\u0303o","morada","morder","moreno","morir","morro","morsa","mortal","mosca","mostrar","motivo","mover","mo\u0301vil","mozo","mucho","mudar","mueble","muela","muerte","muestra","mugre","mujer","mula","muleta","multa","mundo","mun\u0303eca","mural","muro","mu\u0301sculo","museo","musgo","mu\u0301sica","muslo","na\u0301car","nacio\u0301n","nadar","naipe","naranja","nariz","narrar","nasal","natal","nativo","natural","na\u0301usea","naval","nave","navidad","necio","ne\u0301ctar","negar","negocio","negro","neo\u0301n","nervio","neto","neutro","nevar","nevera","nicho","nido","niebla","nieto","nin\u0303ez","nin\u0303o","ni\u0301tido","nivel","nobleza","noche","no\u0301mina","noria","norma","norte","nota","noticia","novato","novela","novio","nube","nuca","nu\u0301cleo","nudillo","nudo","nuera","nueve","nuez","nulo","nu\u0301mero","nutria","oasis","obeso","obispo","objeto","obra","obrero","observar","obtener","obvio","oca","ocaso","oce\u0301ano","ochenta","ocho","ocio","ocre","octavo","octubre","oculto","ocupar","ocurrir","odiar","odio","odisea","oeste","ofensa","oferta","oficio","ofrecer","ogro","oi\u0301do","oi\u0301r","ojo","ola","oleada","olfato","olivo","olla","olmo","olor","olvido","ombligo","onda","onza","opaco","opcio\u0301n","o\u0301pera","opinar","oponer","optar","o\u0301ptica","opuesto","oracio\u0301n","orador","oral","o\u0301rbita","orca","orden","oreja","o\u0301rgano","orgi\u0301a","orgullo","oriente","origen","orilla","oro","orquesta","oruga","osadi\u0301a","oscuro","osezno","oso","ostra","oton\u0303o","otro","oveja","o\u0301vulo","o\u0301xido","oxi\u0301geno","oyente","ozono","pacto","padre","paella","pa\u0301gina","pago","pai\u0301s","pa\u0301jaro","palabra","palco","paleta","pa\u0301lido","palma","paloma","palpar","pan","panal","pa\u0301nico","pantera","pan\u0303uelo","papa\u0301","papel","papilla","paquete","parar","parcela","pared","parir","paro","pa\u0301rpado","parque","pa\u0301rrafo","parte","pasar","paseo","pasio\u0301n","paso","pasta","pata","patio","patria","pausa","pauta","pavo","payaso","peato\u0301n","pecado","pecera","pecho","pedal","pedir","pegar","peine","pelar","peldan\u0303o","pelea","peligro","pellejo","pelo","peluca","pena","pensar","pen\u0303o\u0301n","peo\u0301n","peor","pepino","pequen\u0303o","pera","percha","perder","pereza","perfil","perico","perla","permiso","perro","persona","pesa","pesca","pe\u0301simo","pestan\u0303a","pe\u0301talo","petro\u0301leo","pez","pezun\u0303a","picar","picho\u0301n","pie","piedra","pierna","pieza","pijama","pilar","piloto","pimienta","pino","pintor","pinza","pin\u0303a","piojo","pipa","pirata","pisar","piscina","piso","pista","pito\u0301n","pizca","placa","plan","plata","playa","plaza","pleito","pleno","plomo","pluma","plural","pobre","poco","poder","podio","poema","poesi\u0301a","poeta","polen","polici\u0301a","pollo","polvo","pomada","pomelo","pomo","pompa","poner","porcio\u0301n","portal","posada","poseer","posible","poste","potencia","potro","pozo","prado","precoz","pregunta","premio","prensa","preso","previo","primo","pri\u0301ncipe","prisio\u0301n","privar","proa","probar","proceso","producto","proeza","profesor","programa","prole","promesa","pronto","propio","pro\u0301ximo","prueba","pu\u0301blico","puchero","pudor","pueblo","puerta","puesto","pulga","pulir","pulmo\u0301n","pulpo","pulso","puma","punto","pun\u0303al","pun\u0303o","pupa","pupila","pure\u0301","quedar","queja","quemar","querer","queso","quieto","qui\u0301mica","quince","quitar","ra\u0301bano","rabia","rabo","racio\u0301n","radical","rai\u0301z","rama","rampa","rancho","rango","rapaz","ra\u0301pido","rapto","rasgo","raspa","rato","rayo","raza","razo\u0301n","reaccio\u0301n","realidad","reban\u0303o","rebote","recaer","receta","rechazo","recoger","recreo","recto","recurso","red","redondo","reducir","reflejo","reforma","refra\u0301n","refugio","regalo","regir","regla","regreso","rehe\u0301n","reino","rei\u0301r","reja","relato","relevo","relieve","relleno","reloj","remar","remedio","remo","rencor","rendir","renta","reparto","repetir","reposo","reptil","res","rescate","resina","respeto","resto","resumen","retiro","retorno","retrato","reunir","reve\u0301s","revista","rey","rezar","rico","riego","rienda","riesgo","rifa","ri\u0301gido","rigor","rinco\u0301n","rin\u0303o\u0301n","ri\u0301o","riqueza","risa","ritmo","rito","rizo","roble","roce","rociar","rodar","rodeo","rodilla","roer","rojizo","rojo","romero","romper","ron","ronco","ronda","ropa","ropero","rosa","rosca","rostro","rotar","rubi\u0301","rubor","rudo","rueda","rugir","ruido","ruina","ruleta","rulo","rumbo","rumor","ruptura","ruta","rutina","sa\u0301bado","saber","sabio","sable","sacar","sagaz","sagrado","sala","saldo","salero","salir","salmo\u0301n","salo\u0301n","salsa","salto","salud","salvar","samba","sancio\u0301n","sandi\u0301a","sanear","sangre","sanidad","sano","santo","sapo","saque","sardina","sarte\u0301n","sastre","sata\u0301n","sauna","saxofo\u0301n","seccio\u0301n","seco","secreto","secta","sed","seguir","seis","sello","selva","semana","semilla","senda","sensor","sen\u0303al","sen\u0303or","separar","sepia","sequi\u0301a","ser","serie","sermo\u0301n","servir","sesenta","sesio\u0301n","seta","setenta","severo","sexo","sexto","sidra","siesta","siete","siglo","signo","si\u0301laba","silbar","silencio","silla","si\u0301mbolo","simio","sirena","sistema","sitio","situar","sobre","socio","sodio","sol","solapa","soldado","soledad","so\u0301lido","soltar","solucio\u0301n","sombra","sondeo","sonido","sonoro","sonrisa","sopa","soplar","soporte","sordo","sorpresa","sorteo","soste\u0301n","so\u0301tano","suave","subir","suceso","sudor","suegra","suelo","suen\u0303o","suerte","sufrir","sujeto","sulta\u0301n","sumar","superar","suplir","suponer","supremo","sur","surco","suren\u0303o","surgir","susto","sutil","tabaco","tabique","tabla","tabu\u0301","taco","tacto","tajo","talar","talco","talento","talla","talo\u0301n","taman\u0303o","tambor","tango","tanque","tapa","tapete","tapia","tapo\u0301n","taquilla","tarde","tarea","tarifa","tarjeta","tarot","tarro","tarta","tatuaje","tauro","taza","tazo\u0301n","teatro","techo","tecla","te\u0301cnica","tejado","tejer","tejido","tela","tele\u0301fono","tema","temor","templo","tenaz","tender","tener","tenis","tenso","teori\u0301a","terapia","terco","te\u0301rmino","ternura","terror","tesis","tesoro","testigo","tetera","texto","tez","tibio","tiburo\u0301n","tiempo","tienda","tierra","tieso","tigre","tijera","tilde","timbre","ti\u0301mido","timo","tinta","ti\u0301o","ti\u0301pico","tipo","tira","tiro\u0301n","tita\u0301n","ti\u0301tere","ti\u0301tulo","tiza","toalla","tobillo","tocar","tocino","todo","toga","toldo","tomar","tono","tonto","topar","tope","toque","to\u0301rax","torero","tormenta","torneo","toro","torpedo","torre","torso","tortuga","tos","tosco","toser","to\u0301xico","trabajo","tractor","traer","tra\u0301fico","trago","traje","tramo","trance","trato","trauma","trazar","tre\u0301bol","tregua","treinta","tren","trepar","tres","tribu","trigo","tripa","triste","triunfo","trofeo","trompa","tronco","tropa","trote","trozo","truco","trueno","trufa","tuberi\u0301a","tubo","tuerto","tumba","tumor","tu\u0301nel","tu\u0301nica","turbina","turismo","turno","tutor","ubicar","u\u0301lcera","umbral","unidad","unir","universo","uno","untar","un\u0303a","urbano","urbe","urgente","urna","usar","usuario","u\u0301til","utopi\u0301a","uva","vaca","vaci\u0301o","vacuna","vagar","vago","vaina","vajilla","vale","va\u0301lido","valle","valor","va\u0301lvula","vampiro","vara","variar","varo\u0301n","vaso","vecino","vector","vehi\u0301culo","veinte","vejez","vela","velero","veloz","vena","vencer","venda","veneno","vengar","venir","venta","venus","ver","verano","verbo","verde","vereda","verja","verso","verter","vi\u0301a","viaje","vibrar","vicio","vi\u0301ctima","vida","vi\u0301deo","vidrio","viejo","viernes","vigor","vil","villa","vinagre","vino","vin\u0303edo","violi\u0301n","viral","virgo","virtud","visor","vi\u0301spera","vista","vitamina","viudo","vivaz","vivero","vivir","vivo","volca\u0301n","volumen","volver","voraz","votar","voto","voz","vuelo","vulgar","yacer","yate","yegua","yema","yerno","yeso","yodo","yoga","yogur","zafiro","zanja","zapato","zarza","zona","zorro","zumo","zurdo"]');

},{}],"e2fnl":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('["\u3042\u3044\u3053\u304F\u3057\u3093","\u3042\u3044\u3055\u3064","\u3042\u3044\u305F\u3099","\u3042\u304A\u305D\u3099\u3089","\u3042\u304B\u3061\u3083\u3093","\u3042\u304D\u308B","\u3042\u3051\u304B\u3099\u305F","\u3042\u3051\u308B","\u3042\u3053\u304B\u3099\u308C\u308B","\u3042\u3055\u3044","\u3042\u3055\u3072","\u3042\u3057\u3042\u3068","\u3042\u3057\u3099\u308F\u3046","\u3042\u3059\u3099\u304B\u308B","\u3042\u3059\u3099\u304D","\u3042\u305D\u3075\u3099","\u3042\u305F\u3048\u308B","\u3042\u305F\u305F\u3081\u308B","\u3042\u305F\u308A\u307E\u3048","\u3042\u305F\u308B","\u3042\u3064\u3044","\u3042\u3064\u304B\u3046","\u3042\u3063\u3057\u3085\u304F","\u3042\u3064\u307E\u308A","\u3042\u3064\u3081\u308B","\u3042\u3066\u306A","\u3042\u3066\u306F\u307E\u308B","\u3042\u3072\u308B","\u3042\u3075\u3099\u3089","\u3042\u3075\u3099\u308B","\u3042\u3075\u308C\u308B","\u3042\u307E\u3044","\u3042\u307E\u3068\u3099","\u3042\u307E\u3084\u304B\u3059","\u3042\u307E\u308A","\u3042\u307F\u3082\u306E","\u3042\u3081\u308A\u304B","\u3042\u3084\u307E\u308B","\u3042\u3086\u3080","\u3042\u3089\u3044\u304F\u3099\u307E","\u3042\u3089\u3057","\u3042\u3089\u3059\u3057\u3099","\u3042\u3089\u305F\u3081\u308B","\u3042\u3089\u3086\u308B","\u3042\u3089\u308F\u3059","\u3042\u308A\u304B\u3099\u3068\u3046","\u3042\u308F\u305B\u308B","\u3042\u308F\u3066\u308B","\u3042\u3093\u3044","\u3042\u3093\u304B\u3099\u3044","\u3042\u3093\u3053","\u3042\u3093\u305B\u3099\u3093","\u3042\u3093\u3066\u3044","\u3042\u3093\u306A\u3044","\u3042\u3093\u307E\u308A","\u3044\u3044\u305F\u3099\u3059","\u3044\u304A\u3093","\u3044\u304B\u3099\u3044","\u3044\u304B\u3099\u304F","\u3044\u304D\u304A\u3044","\u3044\u304D\u306A\u308A","\u3044\u304D\u3082\u306E","\u3044\u304D\u308B","\u3044\u304F\u3057\u3099","\u3044\u304F\u3075\u3099\u3093","\u3044\u3051\u306F\u3099\u306A","\u3044\u3051\u3093","\u3044\u3053\u3046","\u3044\u3053\u304F","\u3044\u3053\u3064","\u3044\u3055\u307E\u3057\u3044","\u3044\u3055\u3093","\u3044\u3057\u304D","\u3044\u3057\u3099\u3085\u3046","\u3044\u3057\u3099\u3087\u3046","\u3044\u3057\u3099\u308F\u308B","\u3044\u3059\u3099\u307F","\u3044\u3059\u3099\u308C","\u3044\u305B\u3044","\u3044\u305B\u3048\u3072\u3099","\u3044\u305B\u304B\u3044","\u3044\u305B\u304D","\u3044\u305B\u3099\u3093","\u3044\u305D\u3046\u308D\u3046","\u3044\u305D\u304B\u3099\u3057\u3044","\u3044\u305F\u3099\u3044","\u3044\u305F\u3099\u304F","\u3044\u305F\u3059\u3099\u3089","\u3044\u305F\u307F","\u3044\u305F\u308A\u3042","\u3044\u3061\u304A\u3046","\u3044\u3061\u3057\u3099","\u3044\u3061\u3068\u3099","\u3044\u3061\u306F\u3099","\u3044\u3061\u3075\u3099","\u3044\u3061\u308A\u3085\u3046","\u3044\u3064\u304B","\u3044\u3063\u3057\u3085\u3093","\u3044\u3063\u305B\u3044","\u3044\u3063\u305D\u3046","\u3044\u3063\u305F\u3093","\u3044\u3063\u3061","\u3044\u3063\u3066\u3044","\u3044\u3063\u307B\u309A\u3046","\u3044\u3066\u3055\u3099","\u3044\u3066\u3093","\u3044\u3068\u3099\u3046","\u3044\u3068\u3053","\u3044\u306A\u3044","\u3044\u306A\u304B","\u3044\u306D\u3080\u308A","\u3044\u306E\u3061","\u3044\u306E\u308B","\u3044\u306F\u3064","\u3044\u306F\u3099\u308B","\u3044\u306F\u3093","\u3044\u3072\u3099\u304D","\u3044\u3072\u3093","\u3044\u3075\u304F","\u3044\u3078\u3093","\u3044\u307B\u3046","\u3044\u307F\u3093","\u3044\u3082\u3046\u3068","\u3044\u3082\u305F\u308C","\u3044\u3082\u308A","\u3044\u3084\u304B\u3099\u308B","\u3044\u3084\u3059","\u3044\u3088\u304B\u3093","\u3044\u3088\u304F","\u3044\u3089\u3044","\u3044\u3089\u3059\u3068","\u3044\u308A\u304F\u3099\u3061","\u3044\u308A\u3087\u3046","\u3044\u308C\u3044","\u3044\u308C\u3082\u306E","\u3044\u308C\u308B","\u3044\u308D\u3048\u3093\u3072\u309A\u3064","\u3044\u308F\u3044","\u3044\u308F\u3046","\u3044\u308F\u304B\u3093","\u3044\u308F\u306F\u3099","\u3044\u308F\u3086\u308B","\u3044\u3093\u3051\u3099\u3093\u307E\u3081","\u3044\u3093\u3055\u3064","\u3044\u3093\u3057\u3087\u3046","\u3044\u3093\u3088\u3046","\u3046\u3048\u304D","\u3046\u3048\u308B","\u3046\u304A\u3055\u3099","\u3046\u304B\u3099\u3044","\u3046\u304B\u3075\u3099","\u3046\u304B\u3078\u3099\u308B","\u3046\u304D\u308F","\u3046\u304F\u3089\u3044\u306A","\u3046\u304F\u308C\u308C","\u3046\u3051\u305F\u307E\u308F\u308B","\u3046\u3051\u3064\u3051","\u3046\u3051\u3068\u308B","\u3046\u3051\u3082\u3064","\u3046\u3051\u308B","\u3046\u3053\u3099\u304B\u3059","\u3046\u3053\u3099\u304F","\u3046\u3053\u3093","\u3046\u3055\u304D\u3099","\u3046\u3057\u306A\u3046","\u3046\u3057\u308D\u304B\u3099\u307F","\u3046\u3059\u3044","\u3046\u3059\u304D\u3099","\u3046\u3059\u304F\u3099\u3089\u3044","\u3046\u3059\u3081\u308B","\u3046\u305B\u3064","\u3046\u3061\u3042\u308F\u305B","\u3046\u3061\u304B\u3099\u308F","\u3046\u3061\u304D","\u3046\u3061\u3085\u3046","\u3046\u3063\u304B\u308A","\u3046\u3064\u304F\u3057\u3044","\u3046\u3063\u305F\u3048\u308B","\u3046\u3064\u308B","\u3046\u3068\u3099\u3093","\u3046\u306A\u304D\u3099","\u3046\u306A\u3057\u3099","\u3046\u306A\u3059\u3099\u304F","\u3046\u306A\u308B","\u3046\u306D\u308B","\u3046\u306E\u3046","\u3046\u3075\u3099\u3051\u3099","\u3046\u3075\u3099\u3053\u3099\u3048","\u3046\u307E\u308C\u308B","\u3046\u3081\u308B","\u3046\u3082\u3046","\u3046\u3084\u307E\u3046","\u3046\u3088\u304F","\u3046\u3089\u304B\u3099\u3048\u3059","\u3046\u3089\u304F\u3099\u3061","\u3046\u3089\u306A\u3044","\u3046\u308A\u3042\u3051\u3099","\u3046\u308A\u304D\u308C","\u3046\u308B\u3055\u3044","\u3046\u308C\u3057\u3044","\u3046\u308C\u3086\u304D","\u3046\u308C\u308B","\u3046\u308D\u3053","\u3046\u308F\u304D","\u3046\u308F\u3055","\u3046\u3093\u3053\u3046","\u3046\u3093\u3061\u3093","\u3046\u3093\u3066\u3093","\u3046\u3093\u3068\u3099\u3046","\u3048\u3044\u3048\u3093","\u3048\u3044\u304B\u3099","\u3048\u3044\u304D\u3087\u3046","\u3048\u3044\u3053\u3099","\u3048\u3044\u305B\u3044","\u3048\u3044\u3075\u3099\u3093","\u3048\u3044\u3088\u3046","\u3048\u3044\u308F","\u3048\u304A\u308A","\u3048\u304B\u3099\u304A","\u3048\u304B\u3099\u304F","\u3048\u304D\u305F\u3044","\u3048\u304F\u305B\u308B","\u3048\u3057\u3083\u304F","\u3048\u3059\u3066","\u3048\u3064\u3089\u3093","\u3048\u306E\u304F\u3099","\u3048\u307B\u3046\u307E\u304D","\u3048\u307B\u3093","\u3048\u307E\u304D","\u3048\u3082\u3057\u3099","\u3048\u3082\u306E","\u3048\u3089\u3044","\u3048\u3089\u3075\u3099","\u3048\u308A\u3042","\u3048\u3093\u3048\u3093","\u3048\u3093\u304B\u3044","\u3048\u3093\u304D\u3099","\u3048\u3093\u3051\u3099\u304D","\u3048\u3093\u3057\u3085\u3046","\u3048\u3093\u305B\u3099\u3064","\u3048\u3093\u305D\u304F","\u3048\u3093\u3061\u3087\u3046","\u3048\u3093\u3068\u3064","\u304A\u3044\u304B\u3051\u308B","\u304A\u3044\u3053\u3059","\u304A\u3044\u3057\u3044","\u304A\u3044\u3064\u304F","\u304A\u3046\u3048\u3093","\u304A\u3046\u3055\u307E","\u304A\u3046\u3057\u3099","\u304A\u3046\u305B\u3064","\u304A\u3046\u305F\u3044","\u304A\u3046\u3075\u304F","\u304A\u3046\u3078\u3099\u3044","\u304A\u3046\u3088\u3046","\u304A\u3048\u308B","\u304A\u304A\u3044","\u304A\u304A\u3046","\u304A\u304A\u3068\u3099\u304A\u308A","\u304A\u304A\u3084","\u304A\u304A\u3088\u305D","\u304A\u304B\u3048\u308A","\u304A\u304B\u3059\u3099","\u304A\u304B\u3099\u3080","\u304A\u304B\u308F\u308A","\u304A\u304D\u3099\u306A\u3046","\u304A\u304D\u308B","\u304A\u304F\u3055\u307E","\u304A\u304F\u3057\u3099\u3087\u3046","\u304A\u304F\u308A\u304B\u3099\u306A","\u304A\u304F\u308B","\u304A\u304F\u308C\u308B","\u304A\u3053\u3059","\u304A\u3053\u306A\u3046","\u304A\u3053\u308B","\u304A\u3055\u3048\u308B","\u304A\u3055\u306A\u3044","\u304A\u3055\u3081\u308B","\u304A\u3057\u3044\u308C","\u304A\u3057\u3048\u308B","\u304A\u3057\u3099\u304D\u3099","\u304A\u3057\u3099\u3055\u3093","\u304A\u3057\u3083\u308C","\u304A\u305D\u3089\u304F","\u304A\u305D\u308F\u308B","\u304A\u305F\u304B\u3099\u3044","\u304A\u305F\u304F","\u304A\u305F\u3099\u3084\u304B","\u304A\u3061\u3064\u304F","\u304A\u3063\u3068","\u304A\u3064\u308A","\u304A\u3066\u3099\u304B\u3051","\u304A\u3068\u3057\u3082\u306E","\u304A\u3068\u306A\u3057\u3044","\u304A\u3068\u3099\u308A","\u304A\u3068\u3099\u308D\u304B\u3059","\u304A\u306F\u3099\u3055\u3093","\u304A\u307E\u3044\u308A","\u304A\u3081\u3066\u3099\u3068\u3046","\u304A\u3082\u3044\u3066\u3099","\u304A\u3082\u3046","\u304A\u3082\u305F\u3044","\u304A\u3082\u3061\u3083","\u304A\u3084\u3064","\u304A\u3084\u3086\u3072\u3099","\u304A\u3088\u307B\u3099\u3059","\u304A\u3089\u3093\u305F\u3099","\u304A\u308D\u3059","\u304A\u3093\u304B\u3099\u304F","\u304A\u3093\u3051\u3044","\u304A\u3093\u3057\u3083","\u304A\u3093\u305B\u3093","\u304A\u3093\u305F\u3099\u3093","\u304A\u3093\u3061\u3085\u3046","\u304A\u3093\u3068\u3099\u3051\u3044","\u304B\u3042\u3064","\u304B\u3044\u304B\u3099","\u304B\u3099\u3044\u304D","\u304B\u3099\u3044\u3051\u3093","\u304B\u3099\u3044\u3053\u3046","\u304B\u3044\u3055\u3064","\u304B\u3044\u3057\u3083","\u304B\u3044\u3059\u3044\u3088\u304F","\u304B\u3044\u305B\u3099\u3093","\u304B\u3044\u305D\u3099\u3046\u3068\u3099","\u304B\u3044\u3064\u3046","\u304B\u3044\u3066\u3093","\u304B\u3044\u3068\u3046","\u304B\u3044\u3075\u304F","\u304B\u3099\u3044\u3078\u304D","\u304B\u3044\u307B\u3046","\u304B\u3044\u3088\u3046","\u304B\u3099\u3044\u3089\u3044","\u304B\u3044\u308F","\u304B\u3048\u308B","\u304B\u304A\u308A","\u304B\u304B\u3048\u308B","\u304B\u304B\u3099\u304F","\u304B\u304B\u3099\u3057","\u304B\u304B\u3099\u307F","\u304B\u304F\u3053\u3099","\u304B\u304F\u3068\u304F","\u304B\u3055\u3099\u308B","\u304B\u3099\u305D\u3099\u3046","\u304B\u305F\u3044","\u304B\u305F\u3061","\u304B\u3099\u3061\u3087\u3046","\u304B\u3099\u3063\u304D\u3085\u3046","\u304B\u3099\u3063\u3053\u3046","\u304B\u3099\u3063\u3055\u3093","\u304B\u3099\u3063\u3057\u3087\u3046","\u304B\u306A\u3055\u3099\u308F\u3057","\u304B\u306E\u3046","\u304B\u3099\u306F\u304F","\u304B\u3075\u3099\u304B","\u304B\u307B\u3046","\u304B\u307B\u3053\u3099","\u304B\u307E\u3046","\u304B\u307E\u307B\u3099\u3053","\u304B\u3081\u308C\u304A\u3093","\u304B\u3086\u3044","\u304B\u3088\u3046\u3072\u3099","\u304B\u3089\u3044","\u304B\u308B\u3044","\u304B\u308D\u3046","\u304B\u308F\u304F","\u304B\u308F\u3089","\u304B\u3099\u3093\u304B","\u304B\u3093\u3051\u3044","\u304B\u3093\u3053\u3046","\u304B\u3093\u3057\u3083","\u304B\u3093\u305D\u3046","\u304B\u3093\u305F\u3093","\u304B\u3093\u3061","\u304B\u3099\u3093\u306F\u3099\u308B","\u304D\u3042\u3044","\u304D\u3042\u3064","\u304D\u3044\u308D","\u304D\u3099\u3044\u3093","\u304D\u3046\u3044","\u304D\u3046\u3093","\u304D\u3048\u308B","\u304D\u304A\u3046","\u304D\u304A\u304F","\u304D\u304A\u3061","\u304D\u304A\u3093","\u304D\u304B\u3044","\u304D\u304B\u304F","\u304D\u304B\u3093\u3057\u3083","\u304D\u304D\u3066","\u304D\u304F\u306F\u3099\u308A","\u304D\u304F\u3089\u3051\u3099","\u304D\u3051\u3093\u305B\u3044","\u304D\u3053\u3046","\u304D\u3053\u3048\u308B","\u304D\u3053\u304F","\u304D\u3055\u3044","\u304D\u3055\u304F","\u304D\u3055\u307E","\u304D\u3055\u3089\u304D\u3099","\u304D\u3099\u3057\u3099\u304B\u304B\u3099\u304F","\u304D\u3099\u3057\u304D","\u304D\u3099\u3057\u3099\u305F\u3044\u3051\u3093","\u304D\u3099\u3057\u3099\u306B\u3063\u3066\u3044","\u304D\u3099\u3057\u3099\u3085\u3064\u3057\u3083","\u304D\u3059\u3046","\u304D\u305B\u3044","\u304D\u305B\u304D","\u304D\u305B\u3064","\u304D\u305D\u3046","\u304D\u305D\u3099\u304F","\u304D\u305D\u3099\u3093","\u304D\u305F\u3048\u308B","\u304D\u3061\u3087\u3046","\u304D\u3064\u3048\u3093","\u304D\u3099\u3063\u3061\u308A","\u304D\u3064\u3064\u304D","\u304D\u3064\u306D","\u304D\u3066\u3044","\u304D\u3068\u3099\u3046","\u304D\u3068\u3099\u304F","\u304D\u306A\u3044","\u304D\u306A\u304B\u3099","\u304D\u306A\u3053","\u304D\u306C\u3053\u3099\u3057","\u304D\u306D\u3093","\u304D\u306E\u3046","\u304D\u306E\u3057\u305F","\u304D\u306F\u304F","\u304D\u3072\u3099\u3057\u3044","\u304D\u3072\u3093","\u304D\u3075\u304F","\u304D\u3075\u3099\u3093","\u304D\u307B\u3099\u3046","\u304D\u307B\u3093","\u304D\u307E\u308B","\u304D\u307F\u3064","\u304D\u3080\u3059\u3099\u304B\u3057\u3044","\u304D\u3081\u308B","\u304D\u3082\u305F\u3099\u3081\u3057","\u304D\u3082\u3061","\u304D\u3082\u306E","\u304D\u3083\u304F","\u304D\u3084\u304F","\u304D\u3099\u3085\u3046\u306B\u304F","\u304D\u3088\u3046","\u304D\u3087\u3046\u308A\u3085\u3046","\u304D\u3089\u3044","\u304D\u3089\u304F","\u304D\u308A\u3093","\u304D\u308C\u3044","\u304D\u308C\u3064","\u304D\u308D\u304F","\u304D\u3099\u308D\u3093","\u304D\u308F\u3081\u308B","\u304D\u3099\u3093\u3044\u308D","\u304D\u3093\u304B\u304F\u3057\u3099","\u304D\u3093\u3057\u3099\u3087","\u304D\u3093\u3088\u3046\u3072\u3099","\u304F\u3099\u3042\u3044","\u304F\u3044\u3059\u3099","\u304F\u3046\u304B\u3093","\u304F\u3046\u304D","\u304F\u3046\u304F\u3099\u3093","\u304F\u3046\u3053\u3046","\u304F\u3099\u3046\u305B\u3044","\u304F\u3046\u305D\u3046","\u304F\u3099\u3046\u305F\u3089","\u304F\u3046\u3075\u304F","\u304F\u3046\u307B\u3099","\u304F\u304B\u3093","\u304F\u304D\u3087\u3046","\u304F\u3051\u3099\u3093","\u304F\u3099\u3053\u3046","\u304F\u3055\u3044","\u304F\u3055\u304D","\u304F\u3055\u306F\u3099\u306A","\u304F\u3055\u308B","\u304F\u3057\u3083\u307F","\u304F\u3057\u3087\u3046","\u304F\u3059\u306E\u304D","\u304F\u3059\u308A\u3086\u3072\u3099","\u304F\u305B\u3051\u3099","\u304F\u305B\u3093","\u304F\u3099\u305F\u3044\u3066\u304D","\u304F\u305F\u3099\u3055\u308B","\u304F\u305F\u3072\u3099\u308C\u308B","\u304F\u3061\u3053\u307F","\u304F\u3061\u3055\u304D","\u304F\u3064\u3057\u305F","\u304F\u3099\u3063\u3059\u308A","\u304F\u3064\u308D\u304F\u3099","\u304F\u3068\u3046\u3066\u3093","\u304F\u3068\u3099\u304F","\u304F\u306A\u3093","\u304F\u306D\u304F\u306D","\u304F\u306E\u3046","\u304F\u3075\u3046","\u304F\u307F\u3042\u308F\u305B","\u304F\u307F\u305F\u3066\u308B","\u304F\u3081\u308B","\u304F\u3084\u304F\u3057\u3087","\u304F\u3089\u3059","\u304F\u3089\u3078\u3099\u308B","\u304F\u308B\u307E","\u304F\u308C\u308B","\u304F\u308D\u3046","\u304F\u308F\u3057\u3044","\u304F\u3099\u3093\u304B\u3093","\u304F\u3099\u3093\u3057\u3087\u304F","\u304F\u3099\u3093\u305F\u3044","\u304F\u3099\u3093\u3066","\u3051\u3042\u306A","\u3051\u3044\u304B\u304F","\u3051\u3044\u3051\u3093","\u3051\u3044\u3053","\u3051\u3044\u3055\u3064","\u3051\u3099\u3044\u3057\u3099\u3085\u3064","\u3051\u3044\u305F\u3044","\u3051\u3099\u3044\u306E\u3046\u3057\u3099\u3093","\u3051\u3044\u308C\u304D","\u3051\u3044\u308D","\u3051\u304A\u3068\u3059","\u3051\u304A\u308A\u3082\u306E","\u3051\u3099\u304D\u304B","\u3051\u3099\u304D\u3051\u3099\u3093","\u3051\u3099\u304D\u305F\u3099\u3093","\u3051\u3099\u304D\u3061\u3093","\u3051\u3099\u304D\u3068\u3064","\u3051\u3099\u304D\u306F","\u3051\u3099\u304D\u3084\u304F","\u3051\u3099\u3053\u3046","\u3051\u3099\u3053\u304F\u3057\u3099\u3087\u3046","\u3051\u3099\u3055\u3099\u3044","\u3051\u3055\u304D","\u3051\u3099\u3055\u3099\u3093","\u3051\u3057\u304D","\u3051\u3057\u3053\u3099\u3080","\u3051\u3057\u3087\u3046","\u3051\u3099\u3059\u3068","\u3051\u305F\u306F\u3099","\u3051\u3061\u3083\u3063\u3075\u309A","\u3051\u3061\u3089\u3059","\u3051\u3064\u3042\u3064","\u3051\u3064\u3044","\u3051\u3064\u3048\u304D","\u3051\u3063\u3053\u3093","\u3051\u3064\u3057\u3099\u3087","\u3051\u3063\u305B\u304D","\u3051\u3063\u3066\u3044","\u3051\u3064\u307E\u3064","\u3051\u3099\u3064\u3088\u3046\u3072\u3099","\u3051\u3099\u3064\u308C\u3044","\u3051\u3064\u308D\u3093","\u3051\u3099\u3068\u3099\u304F","\u3051\u3068\u306F\u3099\u3059","\u3051\u3068\u308B","\u3051\u306A\u3051\u3099","\u3051\u306A\u3059","\u3051\u306A\u307F","\u3051\u306C\u304D","\u3051\u3099\u306D\u3064","\u3051\u306D\u3093","\u3051\u306F\u3044","\u3051\u3099\u3072\u3093","\u3051\u3075\u3099\u304B\u3044","\u3051\u3099\u307B\u3099\u304F","\u3051\u307E\u308A","\u3051\u307F\u304B\u308B","\u3051\u3080\u3057","\u3051\u3080\u308A","\u3051\u3082\u306E","\u3051\u3089\u3044","\u3051\u308D\u3051\u308D","\u3051\u308F\u3057\u3044","\u3051\u3093\u3044","\u3051\u3093\u3048\u3064","\u3051\u3093\u304A","\u3051\u3093\u304B","\u3051\u3099\u3093\u304D","\u3051\u3093\u3051\u3099\u3093","\u3051\u3093\u3053\u3046","\u3051\u3093\u3055\u304F","\u3051\u3093\u3057\u3085\u3046","\u3051\u3093\u3059\u3046","\u3051\u3099\u3093\u305D\u3046","\u3051\u3093\u3061\u304F","\u3051\u3093\u3066\u3044","\u3051\u3093\u3068\u3046","\u3051\u3093\u306A\u3044","\u3051\u3093\u306B\u3093","\u3051\u3099\u3093\u3075\u3099\u3064","\u3051\u3093\u307E","\u3051\u3093\u307F\u3093","\u3051\u3093\u3081\u3044","\u3051\u3093\u3089\u3093","\u3051\u3093\u308A","\u3053\u3042\u304F\u307E","\u3053\u3044\u306C","\u3053\u3044\u3072\u3099\u3068","\u3053\u3099\u3046\u3044","\u3053\u3046\u3048\u3093","\u3053\u3046\u304A\u3093","\u3053\u3046\u304B\u3093","\u3053\u3099\u3046\u304D\u3085\u3046","\u3053\u3099\u3046\u3051\u3044","\u3053\u3046\u3053\u3046","\u3053\u3046\u3055\u3044","\u3053\u3046\u3057\u3099","\u3053\u3046\u3059\u3044","\u3053\u3099\u3046\u305B\u3044","\u3053\u3046\u305D\u304F","\u3053\u3046\u305F\u3044","\u3053\u3046\u3061\u3083","\u3053\u3046\u3064\u3046","\u3053\u3046\u3066\u3044","\u3053\u3046\u3068\u3099\u3046","\u3053\u3046\u306A\u3044","\u3053\u3046\u306F\u3044","\u3053\u3099\u3046\u307B\u3046","\u3053\u3099\u3046\u307E\u3093","\u3053\u3046\u3082\u304F","\u3053\u3046\u308A\u3064","\u3053\u3048\u308B","\u3053\u304A\u308A","\u3053\u3099\u304B\u3044","\u3053\u3099\u304B\u3099\u3064","\u3053\u3099\u304B\u3093","\u3053\u304F\u3053\u3099","\u3053\u304F\u3055\u3044","\u3053\u304F\u3068\u3046","\u3053\u304F\u306A\u3044","\u3053\u304F\u306F\u304F","\u3053\u304F\u3099\u307E","\u3053\u3051\u3044","\u3053\u3051\u308B","\u3053\u3053\u306E\u304B","\u3053\u3053\u308D","\u3053\u3055\u3081","\u3053\u3057\u3064","\u3053\u3059\u3046","\u3053\u305B\u3044","\u3053\u305B\u304D","\u3053\u305B\u3099\u3093","\u3053\u305D\u305F\u3099\u3066","\u3053\u305F\u3044","\u3053\u305F\u3048\u308B","\u3053\u305F\u3064","\u3053\u3061\u3087\u3046","\u3053\u3063\u304B","\u3053\u3064\u3053\u3064","\u3053\u3064\u306F\u3099\u3093","\u3053\u3064\u3075\u3099","\u3053\u3066\u3044","\u3053\u3066\u3093","\u3053\u3068\u304B\u3099\u3089","\u3053\u3068\u3057","\u3053\u3068\u306F\u3099","\u3053\u3068\u308A","\u3053\u306A\u3053\u3099\u306A","\u3053\u306D\u3053\u306D","\u3053\u306E\u307E\u307E","\u3053\u306E\u307F","\u3053\u306E\u3088","\u3053\u3099\u306F\u3093","\u3053\u3072\u3064\u3057\u3099","\u3053\u3075\u3046","\u3053\u3075\u3093","\u3053\u307B\u3099\u308C\u308B","\u3053\u3099\u307E\u3042\u3075\u3099\u3089","\u3053\u307E\u304B\u3044","\u3053\u3099\u307E\u3059\u308A","\u3053\u307E\u3064\u306A","\u3053\u307E\u308B","\u3053\u3080\u304D\u3099\u3053","\u3053\u3082\u3057\u3099","\u3053\u3082\u3061","\u3053\u3082\u306E","\u3053\u3082\u3093","\u3053\u3084\u304F","\u3053\u3084\u307E","\u3053\u3086\u3046","\u3053\u3086\u3072\u3099","\u3053\u3088\u3044","\u3053\u3088\u3046","\u3053\u308A\u308B","\u3053\u308C\u304F\u3057\u3087\u3093","\u3053\u308D\u3063\u3051","\u3053\u308F\u3082\u3066","\u3053\u308F\u308C\u308B","\u3053\u3093\u3044\u3093","\u3053\u3093\u304B\u3044","\u3053\u3093\u304D","\u3053\u3093\u3057\u3085\u3046","\u3053\u3093\u3059\u3044","\u3053\u3093\u305F\u3099\u3066","\u3053\u3093\u3068\u3093","\u3053\u3093\u306A\u3093","\u3053\u3093\u3072\u3099\u306B","\u3053\u3093\u307B\u309A\u3093","\u3053\u3093\u307E\u3051","\u3053\u3093\u3084","\u3053\u3093\u308C\u3044","\u3053\u3093\u308F\u304F","\u3055\u3099\u3044\u3048\u304D","\u3055\u3044\u304B\u3044","\u3055\u3044\u304D\u3093","\u3055\u3099\u3044\u3051\u3099\u3093","\u3055\u3099\u3044\u3053","\u3055\u3044\u3057\u3087","\u3055\u3044\u305B\u3044","\u3055\u3099\u3044\u305F\u304F","\u3055\u3099\u3044\u3061\u3085\u3046","\u3055\u3044\u3066\u304D","\u3055\u3099\u3044\u308A\u3087\u3046","\u3055\u3046\u306A","\u3055\u304B\u3044\u3057","\u3055\u304B\u3099\u3059","\u3055\u304B\u306A","\u3055\u304B\u307F\u3061","\u3055\u304B\u3099\u308B","\u3055\u304D\u3099\u3087\u3046","\u3055\u304F\u3057","\u3055\u304F\u3072\u3093","\u3055\u304F\u3089","\u3055\u3053\u304F","\u3055\u3053\u3064","\u3055\u3059\u3099\u304B\u308B","\u3055\u3099\u305B\u304D","\u3055\u305F\u3093","\u3055\u3064\u3048\u3044","\u3055\u3099\u3064\u304A\u3093","\u3055\u3099\u3063\u304B","\u3055\u3099\u3064\u304B\u3099\u304F","\u3055\u3063\u304D\u3087\u304F","\u3055\u3099\u3063\u3057","\u3055\u3064\u3057\u3099\u3093","\u3055\u3099\u3063\u305D\u3046","\u3055\u3064\u305F\u306F\u3099","\u3055\u3064\u307E\u3044\u3082","\u3055\u3066\u3044","\u3055\u3068\u3044\u3082","\u3055\u3068\u3046","\u3055\u3068\u304A\u3084","\u3055\u3068\u3057","\u3055\u3068\u308B","\u3055\u306E\u3046","\u3055\u306F\u3099\u304F","\u3055\u3072\u3099\u3057\u3044","\u3055\u3078\u3099\u3064","\u3055\u307B\u3046","\u3055\u307B\u3068\u3099","\u3055\u307E\u3059","\u3055\u307F\u3057\u3044","\u3055\u307F\u305F\u3099\u308C","\u3055\u3080\u3051","\u3055\u3081\u308B","\u3055\u3084\u3048\u3093\u3068\u3099\u3046","\u3055\u3086\u3046","\u3055\u3088\u3046","\u3055\u3088\u304F","\u3055\u3089\u305F\u3099","\u3055\u3099\u308B\u305D\u306F\u3099","\u3055\u308F\u3084\u304B","\u3055\u308F\u308B","\u3055\u3093\u3044\u3093","\u3055\u3093\u304B","\u3055\u3093\u304D\u3083\u304F","\u3055\u3093\u3053\u3046","\u3055\u3093\u3055\u3044","\u3055\u3099\u3093\u3057\u3087","\u3055\u3093\u3059\u3046","\u3055\u3093\u305B\u3044","\u3055\u3093\u305D","\u3055\u3093\u3061","\u3055\u3093\u307E","\u3055\u3093\u307F","\u3055\u3093\u3089\u3093","\u3057\u3042\u3044","\u3057\u3042\u3051\u3099","\u3057\u3042\u3055\u3063\u3066","\u3057\u3042\u308F\u305B","\u3057\u3044\u304F","\u3057\u3044\u3093","\u3057\u3046\u3061","\u3057\u3048\u3044","\u3057\u304A\u3051","\u3057\u304B\u3044","\u3057\u304B\u304F","\u3057\u3099\u304B\u3093","\u3057\u3053\u3099\u3068","\u3057\u3059\u3046","\u3057\u3099\u305F\u3099\u3044","\u3057\u305F\u3046\u3051","\u3057\u305F\u304D\u3099","\u3057\u305F\u3066","\u3057\u305F\u307F","\u3057\u3061\u3087\u3046","\u3057\u3061\u308A\u3093","\u3057\u3063\u304B\u308A","\u3057\u3064\u3057\u3099","\u3057\u3064\u3082\u3093","\u3057\u3066\u3044","\u3057\u3066\u304D","\u3057\u3066\u3064","\u3057\u3099\u3066\u3093","\u3057\u3099\u3068\u3099\u3046","\u3057\u306A\u304D\u3099\u308C","\u3057\u306A\u3082\u306E","\u3057\u306A\u3093","\u3057\u306D\u307E","\u3057\u306D\u3093","\u3057\u306E\u304F\u3099","\u3057\u306E\u3075\u3099","\u3057\u306F\u3044","\u3057\u306F\u3099\u304B\u308A","\u3057\u306F\u3064","\u3057\u306F\u3089\u3044","\u3057\u306F\u3093","\u3057\u3072\u3087\u3046","\u3057\u3075\u304F","\u3057\u3099\u3075\u3099\u3093","\u3057\u3078\u3044","\u3057\u307B\u3046","\u3057\u307B\u3093","\u3057\u307E\u3046","\u3057\u307E\u308B","\u3057\u307F\u3093","\u3057\u3080\u3051\u308B","\u3057\u3099\u3080\u3057\u3087","\u3057\u3081\u3044","\u3057\u3081\u308B","\u3057\u3082\u3093","\u3057\u3083\u3044\u3093","\u3057\u3083\u3046\u3093","\u3057\u3083\u304A\u3093","\u3057\u3099\u3083\u304B\u3099\u3044\u3082","\u3057\u3084\u304F\u3057\u3087","\u3057\u3083\u304F\u307B\u3046","\u3057\u3083\u3051\u3093","\u3057\u3083\u3053","\u3057\u3083\u3055\u3099\u3044","\u3057\u3083\u3057\u3093","\u3057\u3083\u305B\u3093","\u3057\u3083\u305D\u3046","\u3057\u3083\u305F\u3044","\u3057\u3083\u3061\u3087\u3046","\u3057\u3083\u3063\u304D\u3093","\u3057\u3099\u3083\u307E","\u3057\u3083\u308A\u3093","\u3057\u3083\u308C\u3044","\u3057\u3099\u3086\u3046","\u3057\u3099\u3085\u3046\u3057\u3087","\u3057\u3085\u304F\u306F\u304F","\u3057\u3099\u3085\u3057\u3093","\u3057\u3085\u3063\u305B\u304D","\u3057\u3085\u307F","\u3057\u3085\u3089\u306F\u3099","\u3057\u3099\u3085\u3093\u306F\u3099\u3093","\u3057\u3087\u3046\u304B\u3044","\u3057\u3087\u304F\u305F\u304F","\u3057\u3087\u3063\u3051\u3093","\u3057\u3087\u3068\u3099\u3046","\u3057\u3087\u3082\u3064","\u3057\u3089\u305B\u308B","\u3057\u3089\u3078\u3099\u308B","\u3057\u3093\u304B","\u3057\u3093\u3053\u3046","\u3057\u3099\u3093\u3057\u3099\u3083","\u3057\u3093\u305B\u3044\u3057\u3099","\u3057\u3093\u3061\u304F","\u3057\u3093\u308A\u3093","\u3059\u3042\u3051\u3099","\u3059\u3042\u3057","\u3059\u3042\u306A","\u3059\u3099\u3042\u3093","\u3059\u3044\u3048\u3044","\u3059\u3044\u304B","\u3059\u3044\u3068\u3046","\u3059\u3099\u3044\u3075\u3099\u3093","\u3059\u3044\u3088\u3046\u3072\u3099","\u3059\u3046\u304B\u3099\u304F","\u3059\u3046\u3057\u3099\u3064","\u3059\u3046\u305B\u3093","\u3059\u304A\u3068\u3099\u308A","\u3059\u304D\u307E","\u3059\u304F\u3046","\u3059\u304F\u306A\u3044","\u3059\u3051\u308B","\u3059\u3053\u3099\u3044","\u3059\u3053\u3057","\u3059\u3099\u3055\u3093","\u3059\u3059\u3099\u3057\u3044","\u3059\u3059\u3080","\u3059\u3059\u3081\u308B","\u3059\u3063\u304B\u308A","\u3059\u3099\u3063\u3057\u308A","\u3059\u3099\u3063\u3068","\u3059\u3066\u304D","\u3059\u3066\u308B","\u3059\u306D\u308B","\u3059\u306E\u3053","\u3059\u306F\u305F\u3099","\u3059\u306F\u3099\u3089\u3057\u3044","\u3059\u3099\u3072\u3087\u3046","\u3059\u3099\u3075\u3099\u306C\u308C","\u3059\u3075\u3099\u308A","\u3059\u3075\u308C","\u3059\u3078\u3099\u3066","\u3059\u3078\u3099\u308B","\u3059\u3099\u307B\u3046","\u3059\u307B\u3099\u3093","\u3059\u307E\u3044","\u3059\u3081\u3057","\u3059\u3082\u3046","\u3059\u3084\u304D","\u3059\u3089\u3059\u3089","\u3059\u308B\u3081","\u3059\u308C\u3061\u304B\u3099\u3046","\u3059\u308D\u3063\u3068","\u3059\u308F\u308B","\u3059\u3093\u305B\u3099\u3093","\u3059\u3093\u307B\u309A\u3046","\u305B\u3042\u3075\u3099\u3089","\u305B\u3044\u304B\u3064","\u305B\u3044\u3051\u3099\u3093","\u305B\u3044\u3057\u3099","\u305B\u3044\u3088\u3046","\u305B\u304A\u3046","\u305B\u304B\u3044\u304B\u3093","\u305B\u304D\u306B\u3093","\u305B\u304D\u3080","\u305B\u304D\u3086","\u305B\u304D\u3089\u3093\u3046\u3093","\u305B\u3051\u3093","\u305B\u3053\u3046","\u305B\u3059\u3057\u3099","\u305B\u305F\u3044","\u305B\u305F\u3051","\u305B\u3063\u304B\u304F","\u305B\u3063\u304D\u3083\u304F","\u305B\u3099\u3063\u304F","\u305B\u3063\u3051\u3093","\u305B\u3063\u3053\u3064","\u305B\u3063\u3055\u305F\u304F\u307E","\u305B\u3064\u305D\u3099\u304F","\u305B\u3064\u305F\u3099\u3093","\u305B\u3064\u3066\u3099\u3093","\u305B\u3063\u306F\u309A\u3093","\u305B\u3064\u3072\u3099","\u305B\u3064\u3075\u3099\u3093","\u305B\u3064\u3081\u3044","\u305B\u3064\u308A\u3064","\u305B\u306A\u304B","\u305B\u306E\u3072\u3099","\u305B\u306F\u306F\u3099","\u305B\u3072\u3099\u308D","\u305B\u307B\u3099\u306D","\u305B\u307E\u3044","\u305B\u307E\u308B","\u305B\u3081\u308B","\u305B\u3082\u305F\u308C","\u305B\u308A\u3075","\u305B\u3099\u3093\u3042\u304F","\u305B\u3093\u3044","\u305B\u3093\u3048\u3044","\u305B\u3093\u304B","\u305B\u3093\u304D\u3087","\u305B\u3093\u304F","\u305B\u3093\u3051\u3099\u3093","\u305B\u3099\u3093\u3053\u3099","\u305B\u3093\u3055\u3044","\u305B\u3093\u3057\u3085","\u305B\u3093\u3059\u3044","\u305B\u3093\u305B\u3044","\u305B\u3093\u305D\u3099","\u305B\u3093\u305F\u304F","\u305B\u3093\u3061\u3087\u3046","\u305B\u3093\u3066\u3044","\u305B\u3093\u3068\u3046","\u305B\u3093\u306C\u304D","\u305B\u3093\u306D\u3093","\u305B\u3093\u306F\u309A\u3044","\u305B\u3099\u3093\u3075\u3099","\u305B\u3099\u3093\u307B\u309A\u3046","\u305B\u3093\u3080","\u305B\u3093\u3081\u3093\u3057\u3099\u3087","\u305B\u3093\u3082\u3093","\u305B\u3093\u3084\u304F","\u305B\u3093\u3086\u3046","\u305B\u3093\u3088\u3046","\u305B\u3099\u3093\u3089","\u305B\u3099\u3093\u308A\u3083\u304F","\u305B\u3093\u308C\u3044","\u305B\u3093\u308D","\u305D\u3042\u304F","\u305D\u3044\u3068\u3051\u3099\u308B","\u305D\u3044\u306D","\u305D\u3046\u304B\u3099\u3093\u304D\u3087\u3046","\u305D\u3046\u304D","\u305D\u3046\u3053\u3099","\u305D\u3046\u3057\u3093","\u305D\u3046\u305F\u3099\u3093","\u305D\u3046\u306A\u3093","\u305D\u3046\u3072\u3099","\u305D\u3046\u3081\u3093","\u305D\u3046\u308A","\u305D\u3048\u3082\u306E","\u305D\u3048\u3093","\u305D\u304B\u3099\u3044","\u305D\u3051\u3099\u304D","\u305D\u3053\u3046","\u305D\u3053\u305D\u3053","\u305D\u3055\u3099\u3044","\u305D\u3057\u306A","\u305D\u305B\u3044","\u305D\u305B\u3093","\u305D\u305D\u304F\u3099","\u305D\u305F\u3099\u3066\u308B","\u305D\u3064\u3046","\u305D\u3064\u3048\u3093","\u305D\u3063\u304B\u3093","\u305D\u3064\u304D\u3099\u3087\u3046","\u305D\u3063\u3051\u3064","\u305D\u3063\u3053\u3046","\u305D\u3063\u305B\u3093","\u305D\u3063\u3068","\u305D\u3068\u304B\u3099\u308F","\u305D\u3068\u3064\u3099\u3089","\u305D\u306A\u3048\u308B","\u305D\u306A\u305F","\u305D\u3075\u307B\u3099","\u305D\u307B\u3099\u304F","\u305D\u307B\u3099\u308D","\u305D\u307E\u3064","\u305D\u307E\u308B","\u305D\u3080\u304F","\u305D\u3080\u308A\u3048","\u305D\u3081\u308B","\u305D\u3082\u305D\u3082","\u305D\u3088\u304B\u305B\u3099","\u305D\u3089\u307E\u3081","\u305D\u308D\u3046","\u305D\u3093\u304B\u3044","\u305D\u3093\u3051\u3044","\u305D\u3093\u3055\u3099\u3044","\u305D\u3093\u3057\u3064","\u305D\u3093\u305D\u3099\u304F","\u305D\u3093\u3061\u3087\u3046","\u305D\u3099\u3093\u3072\u3099","\u305D\u3099\u3093\u3075\u3099\u3093","\u305D\u3093\u307F\u3093","\u305F\u3042\u3044","\u305F\u3044\u3044\u3093","\u305F\u3044\u3046\u3093","\u305F\u3044\u3048\u304D","\u305F\u3044\u304A\u3046","\u305F\u3099\u3044\u304B\u3099\u304F","\u305F\u3044\u304D","\u305F\u3044\u304F\u3099\u3046","\u305F\u3044\u3051\u3093","\u305F\u3044\u3053","\u305F\u3044\u3055\u3099\u3044","\u305F\u3099\u3044\u3057\u3099\u3087\u3046\u3075\u3099","\u305F\u3099\u3044\u3059\u304D","\u305F\u3044\u305B\u3064","\u305F\u3044\u305D\u3046","\u305F\u3099\u3044\u305F\u3044","\u305F\u3044\u3061\u3087\u3046","\u305F\u3044\u3066\u3044","\u305F\u3099\u3044\u3068\u3099\u3053\u308D","\u305F\u3044\u306A\u3044","\u305F\u3044\u306D\u3064","\u305F\u3044\u306E\u3046","\u305F\u3044\u306F\u3093","\u305F\u3099\u3044\u3072\u3087\u3046","\u305F\u3044\u3075\u3046","\u305F\u3044\u3078\u3093","\u305F\u3044\u307B","\u305F\u3044\u307E\u3064\u306F\u3099\u306A","\u305F\u3044\u307F\u3093\u304F\u3099","\u305F\u3044\u3080","\u305F\u3044\u3081\u3093","\u305F\u3044\u3084\u304D","\u305F\u3044\u3088\u3046","\u305F\u3044\u3089","\u305F\u3044\u308A\u3087\u304F","\u305F\u3044\u308B","\u305F\u3044\u308F\u3093","\u305F\u3046\u3048","\u305F\u3048\u308B","\u305F\u304A\u3059","\u305F\u304A\u308B","\u305F\u304A\u308C\u308B","\u305F\u304B\u3044","\u305F\u304B\u306D","\u305F\u304D\u3072\u3099","\u305F\u304F\u3055\u3093","\u305F\u3053\u304F","\u305F\u3053\u3084\u304D","\u305F\u3055\u3044","\u305F\u3057\u3055\u3099\u3093","\u305F\u3099\u3057\u3099\u3083\u308C","\u305F\u3059\u3051\u308B","\u305F\u3059\u3099\u3055\u308F\u308B","\u305F\u305D\u304B\u3099\u308C","\u305F\u305F\u304B\u3046","\u305F\u305F\u304F","\u305F\u305F\u3099\u3057\u3044","\u305F\u305F\u307F","\u305F\u3061\u306F\u3099\u306A","\u305F\u3099\u3063\u304B\u3044","\u305F\u3099\u3063\u304D\u3083\u304F","\u305F\u3099\u3063\u3053","\u305F\u3099\u3063\u3057\u3085\u3064","\u305F\u3099\u3063\u305F\u3044","\u305F\u3066\u308B","\u305F\u3068\u3048\u308B","\u305F\u306A\u306F\u3099\u305F","\u305F\u306B\u3093","\u305F\u306C\u304D","\u305F\u306E\u3057\u307F","\u305F\u306F\u3064","\u305F\u3075\u3099\u3093","\u305F\u3078\u3099\u308B","\u305F\u307B\u3099\u3046","\u305F\u307E\u3053\u3099","\u305F\u307E\u308B","\u305F\u3099\u3080\u308B","\u305F\u3081\u3044\u304D","\u305F\u3081\u3059","\u305F\u3081\u308B","\u305F\u3082\u3064","\u305F\u3084\u3059\u3044","\u305F\u3088\u308B","\u305F\u3089\u3059","\u305F\u308A\u304D\u307B\u3093\u304B\u3099\u3093","\u305F\u308A\u3087\u3046","\u305F\u308A\u308B","\u305F\u308B\u3068","\u305F\u308C\u308B","\u305F\u308C\u3093\u3068","\u305F\u308D\u3063\u3068","\u305F\u308F\u3080\u308C\u308B","\u305F\u3099\u3093\u3042\u3064","\u305F\u3093\u3044","\u305F\u3093\u304A\u3093","\u305F\u3093\u304B","\u305F\u3093\u304D","\u305F\u3093\u3051\u3093","\u305F\u3093\u3053\u3099","\u305F\u3093\u3055\u3093","\u305F\u3093\u3057\u3099\u3087\u3046\u3072\u3099","\u305F\u3099\u3093\u305B\u3044","\u305F\u3093\u305D\u304F","\u305F\u3093\u305F\u3044","\u305F\u3099\u3093\u3061","\u305F\u3093\u3066\u3044","\u305F\u3093\u3068\u3046","\u305F\u3099\u3093\u306A","\u305F\u3093\u306B\u3093","\u305F\u3099\u3093\u306D\u3064","\u305F\u3093\u306E\u3046","\u305F\u3093\u3072\u309A\u3093","\u305F\u3099\u3093\u307B\u3099\u3046","\u305F\u3093\u307E\u3064","\u305F\u3093\u3081\u3044","\u305F\u3099\u3093\u308C\u3064","\u305F\u3099\u3093\u308D","\u305F\u3099\u3093\u308F","\u3061\u3042\u3044","\u3061\u3042\u3093","\u3061\u3044\u304D","\u3061\u3044\u3055\u3044","\u3061\u3048\u3093","\u3061\u304B\u3044","\u3061\u304B\u3089","\u3061\u304D\u3085\u3046","\u3061\u304D\u3093","\u3061\u3051\u3044\u3059\u3099","\u3061\u3051\u3093","\u3061\u3053\u304F","\u3061\u3055\u3044","\u3061\u3057\u304D","\u3061\u3057\u308A\u3087\u3046","\u3061\u305B\u3044","\u3061\u305D\u3046","\u3061\u305F\u3044","\u3061\u305F\u3093","\u3061\u3061\u304A\u3084","\u3061\u3064\u3057\u3099\u3087","\u3061\u3066\u304D","\u3061\u3066\u3093","\u3061\u306C\u304D","\u3061\u306C\u308A","\u3061\u306E\u3046","\u3061\u3072\u3087\u3046","\u3061\u3078\u3044\u305B\u3093","\u3061\u307B\u3046","\u3061\u307E\u305F","\u3061\u307F\u3064","\u3061\u307F\u3068\u3099\u308D","\u3061\u3081\u3044\u3068\u3099","\u3061\u3083\u3093\u3053\u306A\u3078\u3099","\u3061\u3085\u3046\u3044","\u3061\u3086\u308A\u3087\u304F","\u3061\u3087\u3046\u3057","\u3061\u3087\u3055\u304F\u3051\u3093","\u3061\u3089\u3057","\u3061\u3089\u307F","\u3061\u308A\u304B\u3099\u307F","\u3061\u308A\u3087\u3046","\u3061\u308B\u3068\u3099","\u3061\u308F\u308F","\u3061\u3093\u305F\u3044","\u3061\u3093\u3082\u304F","\u3064\u3044\u304B","\u3064\u3044\u305F\u3061","\u3064\u3046\u304B","\u3064\u3046\u3057\u3099\u3087\u3046","\u3064\u3046\u306F\u3093","\u3064\u3046\u308F","\u3064\u304B\u3046","\u3064\u304B\u308C\u308B","\u3064\u304F\u306D","\u3064\u304F\u308B","\u3064\u3051\u306D","\u3064\u3051\u308B","\u3064\u3053\u3099\u3046","\u3064\u305F\u3048\u308B","\u3064\u3064\u3099\u304F","\u3064\u3064\u3057\u3099","\u3064\u3064\u3080","\u3064\u3068\u3081\u308B","\u3064\u306A\u304B\u3099\u308B","\u3064\u306A\u307F","\u3064\u306D\u3064\u3099\u306D","\u3064\u306E\u308B","\u3064\u3075\u3099\u3059","\u3064\u307E\u3089\u306A\u3044","\u3064\u307E\u308B","\u3064\u307F\u304D","\u3064\u3081\u305F\u3044","\u3064\u3082\u308A","\u3064\u3082\u308B","\u3064\u3088\u3044","\u3064\u308B\u307B\u3099","\u3064\u308B\u307F\u304F","\u3064\u308F\u3082\u306E","\u3064\u308F\u308A","\u3066\u3042\u3057","\u3066\u3042\u3066","\u3066\u3042\u307F","\u3066\u3044\u304A\u3093","\u3066\u3044\u304B","\u3066\u3044\u304D","\u3066\u3044\u3051\u3044","\u3066\u3044\u3053\u304F","\u3066\u3044\u3055\u3064","\u3066\u3044\u3057","\u3066\u3044\u305B\u3044","\u3066\u3044\u305F\u3044","\u3066\u3044\u3068\u3099","\u3066\u3044\u306D\u3044","\u3066\u3044\u3072\u3087\u3046","\u3066\u3044\u3078\u3093","\u3066\u3044\u307B\u3099\u3046","\u3066\u3046\u3061","\u3066\u304A\u304F\u308C","\u3066\u304D\u3068\u3046","\u3066\u304F\u3072\u3099","\u3066\u3099\u3053\u307B\u3099\u3053","\u3066\u3055\u304D\u3099\u3087\u3046","\u3066\u3055\u3051\u3099","\u3066\u3059\u308A","\u3066\u305D\u3046","\u3066\u3061\u304B\u3099\u3044","\u3066\u3061\u3087\u3046","\u3066\u3064\u304B\u3099\u304F","\u3066\u3064\u3064\u3099\u304D","\u3066\u3099\u3063\u306F\u309A","\u3066\u3064\u307B\u3099\u3046","\u3066\u3064\u3084","\u3066\u3099\u306C\u304B\u3048","\u3066\u306C\u304D","\u3066\u306C\u304F\u3099\u3044","\u3066\u306E\u3072\u3089","\u3066\u306F\u3044","\u3066\u3075\u3099\u304F\u308D","\u3066\u3075\u305F\u3099","\u3066\u307B\u3068\u3099\u304D","\u3066\u307B\u3093","\u3066\u307E\u3048","\u3066\u307E\u304D\u3059\u3099\u3057","\u3066\u307F\u3057\u3099\u304B","\u3066\u307F\u3084\u3051\u3099","\u3066\u3089\u3059","\u3066\u308C\u3072\u3099","\u3066\u308F\u3051","\u3066\u308F\u305F\u3057","\u3066\u3099\u3093\u3042\u3064","\u3066\u3093\u3044\u3093","\u3066\u3093\u304B\u3044","\u3066\u3093\u304D","\u3066\u3093\u304F\u3099","\u3066\u3093\u3051\u3093","\u3066\u3093\u3053\u3099\u304F","\u3066\u3093\u3055\u3044","\u3066\u3093\u3057","\u3066\u3093\u3059\u3046","\u3066\u3099\u3093\u3061","\u3066\u3093\u3066\u304D","\u3066\u3093\u3068\u3046","\u3066\u3093\u306A\u3044","\u3066\u3093\u3075\u309A\u3089","\u3066\u3093\u307B\u3099\u3046\u305F\u3099\u3044","\u3066\u3093\u3081\u3064","\u3066\u3093\u3089\u3093\u304B\u3044","\u3066\u3099\u3093\u308A\u3087\u304F","\u3066\u3099\u3093\u308F","\u3068\u3099\u3042\u3044","\u3068\u3044\u308C","\u3068\u3099\u3046\u304B\u3093","\u3068\u3046\u304D\u3085\u3046","\u3068\u3099\u3046\u304F\u3099","\u3068\u3046\u3057","\u3068\u3046\u3080\u304D\u3099","\u3068\u304A\u3044","\u3068\u304A\u304B","\u3068\u304A\u304F","\u3068\u304A\u3059","\u3068\u304A\u308B","\u3068\u304B\u3044","\u3068\u304B\u3059","\u3068\u304D\u304A\u308A","\u3068\u304D\u3068\u3099\u304D","\u3068\u304F\u3044","\u3068\u304F\u3057\u3085\u3046","\u3068\u304F\u3066\u3093","\u3068\u304F\u306B","\u3068\u304F\u3078\u3099\u3064","\u3068\u3051\u3044","\u3068\u3051\u308B","\u3068\u3053\u3084","\u3068\u3055\u304B","\u3068\u3057\u3087\u304B\u3093","\u3068\u305D\u3046","\u3068\u305F\u3093","\u3068\u3061\u3085\u3046","\u3068\u3063\u304D\u3085\u3046","\u3068\u3063\u304F\u3093","\u3068\u3064\u305B\u3099\u3093","\u3068\u3064\u306B\u3085\u3046","\u3068\u3068\u3099\u3051\u308B","\u3068\u3068\u306E\u3048\u308B","\u3068\u306A\u3044","\u3068\u306A\u3048\u308B","\u3068\u306A\u308A","\u3068\u306E\u3055\u307E","\u3068\u306F\u3099\u3059","\u3068\u3099\u3075\u3099\u304B\u3099\u308F","\u3068\u307B\u3046","\u3068\u307E\u308B","\u3068\u3081\u308B","\u3068\u3082\u305F\u3099\u3061","\u3068\u3082\u308B","\u3068\u3099\u3088\u3046\u3072\u3099","\u3068\u3089\u3048\u308B","\u3068\u3093\u304B\u3064","\u3068\u3099\u3093\u3075\u3099\u308A","\u306A\u3044\u304B\u304F","\u306A\u3044\u3053\u3046","\u306A\u3044\u3057\u3087","\u306A\u3044\u3059","\u306A\u3044\u305B\u3093","\u306A\u3044\u305D\u3046","\u306A\u304A\u3059","\u306A\u304B\u3099\u3044","\u306A\u304F\u3059","\u306A\u3051\u3099\u308B","\u306A\u3053\u3046\u3068\u3099","\u306A\u3055\u3051","\u306A\u305F\u3066\u3099\u3053\u3053","\u306A\u3063\u3068\u3046","\u306A\u3064\u3084\u3059\u307F","\u306A\u306A\u304A\u3057","\u306A\u306B\u3053\u3099\u3068","\u306A\u306B\u3082\u306E","\u306A\u306B\u308F","\u306A\u306E\u304B","\u306A\u3075\u305F\u3099","\u306A\u307E\u3044\u304D","\u306A\u307E\u3048","\u306A\u307E\u307F","\u306A\u307F\u305F\u3099","\u306A\u3081\u3089\u304B","\u306A\u3081\u308B","\u306A\u3084\u3080","\u306A\u3089\u3046","\u306A\u3089\u3072\u3099","\u306A\u3089\u3075\u3099","\u306A\u308C\u308B","\u306A\u308F\u3068\u3072\u3099","\u306A\u308F\u306F\u3099\u308A","\u306B\u3042\u3046","\u306B\u3044\u304B\u3099\u305F","\u306B\u3046\u3051","\u306B\u304A\u3044","\u306B\u304B\u3044","\u306B\u304B\u3099\u3066","\u306B\u304D\u3072\u3099","\u306B\u304F\u3057\u307F","\u306B\u304F\u307E\u3093","\u306B\u3051\u3099\u308B","\u306B\u3055\u3093\u304B\u305F\u3093\u305D","\u306B\u3057\u304D","\u306B\u305B\u3082\u306E","\u306B\u3061\u3057\u3099\u3087\u3046","\u306B\u3061\u3088\u3046\u3072\u3099","\u306B\u3063\u304B","\u306B\u3063\u304D","\u306B\u3063\u3051\u3044","\u306B\u3063\u3053\u3046","\u306B\u3063\u3055\u3093","\u306B\u3063\u3057\u3087\u304F","\u306B\u3063\u3059\u3046","\u306B\u3063\u305B\u304D","\u306B\u3063\u3066\u3044","\u306B\u306A\u3046","\u306B\u307B\u3093","\u306B\u307E\u3081","\u306B\u3082\u3064","\u306B\u3084\u308A","\u306B\u3085\u3046\u3044\u3093","\u306B\u308A\u3093\u3057\u3083","\u306B\u308F\u3068\u308A","\u306B\u3093\u3044","\u306B\u3093\u304B","\u306B\u3093\u304D","\u306B\u3093\u3051\u3099\u3093","\u306B\u3093\u3057\u304D","\u306B\u3093\u3059\u3099\u3046","\u306B\u3093\u305D\u3046","\u306B\u3093\u305F\u3044","\u306B\u3093\u3061","\u306B\u3093\u3066\u3044","\u306B\u3093\u306B\u304F","\u306B\u3093\u3075\u309A","\u306B\u3093\u307E\u308A","\u306B\u3093\u3080","\u306B\u3093\u3081\u3044","\u306B\u3093\u3088\u3046","\u306C\u3044\u304F\u304D\u3099","\u306C\u304B\u3059","\u306C\u304F\u3099\u3044\u3068\u308B","\u306C\u304F\u3099\u3046","\u306C\u304F\u3082\u308A","\u306C\u3059\u3080","\u306C\u307E\u3048\u3072\u3099","\u306C\u3081\u308A","\u306C\u3089\u3059","\u306C\u3093\u3061\u3083\u304F","\u306D\u3042\u3051\u3099","\u306D\u3044\u304D","\u306D\u3044\u308B","\u306D\u3044\u308D","\u306D\u304F\u3099\u305B","\u306D\u304F\u305F\u3044","\u306D\u304F\u3089","\u306D\u3053\u305B\u3099","\u306D\u3053\u3080","\u306D\u3055\u3051\u3099","\u306D\u3059\u3053\u3099\u3059","\u306D\u305D\u3078\u3099\u308B","\u306D\u305F\u3099\u3093","\u306D\u3064\u3044","\u306D\u3063\u3057\u3093","\u306D\u3064\u305D\u3099\u3046","\u306D\u3063\u305F\u3044\u304D\u3099\u3087","\u306D\u3075\u3099\u305D\u304F","\u306D\u3075\u305F\u3099","\u306D\u307B\u3099\u3046","\u306D\u307B\u308A\u306F\u307B\u308A","\u306D\u307E\u304D","\u306D\u307E\u308F\u3057","\u306D\u307F\u307F","\u306D\u3080\u3044","\u306D\u3080\u305F\u3044","\u306D\u3082\u3068","\u306D\u3089\u3046","\u306D\u308F\u3055\u3099","\u306D\u3093\u3044\u308A","\u306D\u3093\u304A\u3057","\u306D\u3093\u304B\u3093","\u306D\u3093\u304D\u3093","\u306D\u3093\u304F\u3099","\u306D\u3093\u3055\u3099","\u306D\u3093\u3057","\u306D\u3093\u3061\u3083\u304F","\u306D\u3093\u3068\u3099","\u306D\u3093\u3072\u309A","\u306D\u3093\u3075\u3099\u3064","\u306D\u3093\u307E\u3064","\u306D\u3093\u308A\u3087\u3046","\u306D\u3093\u308C\u3044","\u306E\u3044\u3059\u3099","\u306E\u304A\u3064\u3099\u307E","\u306E\u304B\u3099\u3059","\u306E\u304D\u306A\u307F","\u306E\u3053\u304D\u3099\u308A","\u306E\u3053\u3059","\u306E\u3053\u308B","\u306E\u305B\u308B","\u306E\u305D\u3099\u304F","\u306E\u305D\u3099\u3080","\u306E\u305F\u307E\u3046","\u306E\u3061\u307B\u3068\u3099","\u306E\u3063\u304F","\u306E\u306F\u3099\u3059","\u306E\u306F\u3089","\u306E\u3078\u3099\u308B","\u306E\u307B\u3099\u308B","\u306E\u307F\u3082\u306E","\u306E\u3084\u307E","\u306E\u3089\u3044\u306C","\u306E\u3089\u306D\u3053","\u306E\u308A\u3082\u306E","\u306E\u308A\u3086\u304D","\u306E\u308C\u3093","\u306E\u3093\u304D","\u306F\u3099\u3042\u3044","\u306F\u3042\u304F","\u306F\u3099\u3042\u3055\u3093","\u306F\u3099\u3044\u304B","\u306F\u3099\u3044\u304F","\u306F\u3044\u3051\u3093","\u306F\u3044\u3053\u3099","\u306F\u3044\u3057\u3093","\u306F\u3044\u3059\u3044","\u306F\u3044\u305B\u3093","\u306F\u3044\u305D\u3046","\u306F\u3044\u3061","\u306F\u3099\u3044\u306F\u3099\u3044","\u306F\u3044\u308C\u3064","\u306F\u3048\u308B","\u306F\u304A\u308B","\u306F\u304B\u3044","\u306F\u3099\u304B\u308A","\u306F\u304B\u308B","\u306F\u304F\u3057\u3085","\u306F\u3051\u3093","\u306F\u3053\u3075\u3099","\u306F\u3055\u307F","\u306F\u3055\u3093","\u306F\u3057\u3053\u3099","\u306F\u3099\u3057\u3087","\u306F\u3057\u308B","\u306F\u305B\u308B","\u306F\u309A\u305D\u3053\u3093","\u306F\u305D\u3093","\u306F\u305F\u3093","\u306F\u3061\u307F\u3064","\u306F\u3064\u304A\u3093","\u306F\u3063\u304B\u304F","\u306F\u3064\u3099\u304D","\u306F\u3063\u304D\u308A","\u306F\u3063\u304F\u3064","\u306F\u3063\u3051\u3093","\u306F\u3063\u3053\u3046","\u306F\u3063\u3055\u3093","\u306F\u3063\u3057\u3093","\u306F\u3063\u305F\u3064","\u306F\u3063\u3061\u3085\u3046","\u306F\u3063\u3066\u3093","\u306F\u3063\u3072\u309A\u3087\u3046","\u306F\u3063\u307B\u309A\u3046","\u306F\u306A\u3059","\u306F\u306A\u3072\u3099","\u306F\u306B\u304B\u3080","\u306F\u3075\u3099\u3089\u3057","\u306F\u307F\u304B\u3099\u304D","\u306F\u3080\u304B\u3046","\u306F\u3081\u3064","\u306F\u3084\u3044","\u306F\u3084\u3057","\u306F\u3089\u3046","\u306F\u308D\u3046\u3043\u3093","\u306F\u308F\u3044","\u306F\u3093\u3044","\u306F\u3093\u3048\u3044","\u306F\u3093\u304A\u3093","\u306F\u3093\u304B\u304F","\u306F\u3093\u304D\u3087\u3046","\u306F\u3099\u3093\u304F\u3099\u307F","\u306F\u3093\u3053","\u306F\u3093\u3057\u3083","\u306F\u3093\u3059\u3046","\u306F\u3093\u305F\u3099\u3093","\u306F\u309A\u3093\u3061","\u306F\u309A\u3093\u3064","\u306F\u3093\u3066\u3044","\u306F\u3093\u3068\u3057","\u306F\u3093\u306E\u3046","\u306F\u3093\u306F\u309A","\u306F\u3093\u3075\u3099\u3093","\u306F\u3093\u3078\u309A\u3093","\u306F\u3093\u307B\u3099\u3046\u304D","\u306F\u3093\u3081\u3044","\u306F\u3093\u3089\u3093","\u306F\u3093\u308D\u3093","\u3072\u3044\u304D","\u3072\u3046\u3093","\u3072\u3048\u308B","\u3072\u304B\u304F","\u3072\u304B\u308A","\u3072\u304B\u308B","\u3072\u304B\u3093","\u3072\u304F\u3044","\u3072\u3051\u3064","\u3072\u3053\u3046\u304D","\u3072\u3053\u304F","\u3072\u3055\u3044","\u3072\u3055\u3057\u3075\u3099\u308A","\u3072\u3055\u3093","\u3072\u3099\u3057\u3099\u3085\u3064\u304B\u3093","\u3072\u3057\u3087","\u3072\u305D\u304B","\u3072\u305D\u3080","\u3072\u305F\u3080\u304D","\u3072\u305F\u3099\u308A","\u3072\u305F\u308B","\u3072\u3064\u304D\u3099","\u3072\u3063\u3053\u3057","\u3072\u3063\u3057","\u3072\u3064\u3057\u3099\u3085\u3072\u3093","\u3072\u3063\u3059","\u3072\u3064\u305B\u3099\u3093","\u3072\u309A\u3063\u305F\u308A","\u3072\u309A\u3063\u3061\u308A","\u3072\u3064\u3088\u3046","\u3072\u3066\u3044","\u3072\u3068\u3053\u3099\u307F","\u3072\u306A\u307E\u3064\u308A","\u3072\u306A\u3093","\u3072\u306D\u308B","\u3072\u306F\u3093","\u3072\u3072\u3099\u304F","\u3072\u3072\u3087\u3046","\u3072\u307B\u3046","\u3072\u307E\u308F\u308A","\u3072\u307E\u3093","\u3072\u307F\u3064","\u3072\u3081\u3044","\u3072\u3081\u3057\u3099\u3057","\u3072\u3084\u3051","\u3072\u3084\u3059","\u3072\u3088\u3046","\u3072\u3099\u3087\u3046\u304D","\u3072\u3089\u304B\u3099\u306A","\u3072\u3089\u304F","\u3072\u308A\u3064","\u3072\u308A\u3087\u3046","\u3072\u308B\u307E","\u3072\u308B\u3084\u3059\u307F","\u3072\u308C\u3044","\u3072\u308D\u3044","\u3072\u308D\u3046","\u3072\u308D\u304D","\u3072\u308D\u3086\u304D","\u3072\u3093\u304B\u304F","\u3072\u3093\u3051\u3064","\u3072\u3093\u3053\u3093","\u3072\u3093\u3057\u3085","\u3072\u3093\u305D\u3046","\u3072\u309A\u3093\u3061","\u3072\u3093\u306F\u309A\u3093","\u3072\u3099\u3093\u307B\u3099\u3046","\u3075\u3042\u3093","\u3075\u3044\u3046\u3061","\u3075\u3046\u3051\u3044","\u3075\u3046\u305B\u3093","\u3075\u309A\u3046\u305F\u308D\u3046","\u3075\u3046\u3068\u3046","\u3075\u3046\u3075","\u3075\u3048\u308B","\u3075\u304A\u3093","\u3075\u304B\u3044","\u3075\u304D\u3093","\u3075\u304F\u3055\u3099\u3064","\u3075\u304F\u3075\u3099\u304F\u308D","\u3075\u3053\u3046","\u3075\u3055\u3044","\u3075\u3057\u304D\u3099","\u3075\u3057\u3099\u307F","\u3075\u3059\u307E","\u3075\u305B\u3044","\u3075\u305B\u304F\u3099","\u3075\u305D\u304F","\u3075\u3099\u305F\u306B\u304F","\u3075\u305F\u3093","\u3075\u3061\u3087\u3046","\u3075\u3064\u3046","\u3075\u3064\u304B","\u3075\u3063\u304B\u3064","\u3075\u3063\u304D","\u3075\u3063\u3053\u304F","\u3075\u3099\u3068\u3099\u3046","\u3075\u3068\u308B","\u3075\u3068\u3093","\u3075\u306E\u3046","\u3075\u306F\u3044","\u3075\u3072\u3087\u3046","\u3075\u3078\u3093","\u3075\u307E\u3093","\u3075\u307F\u3093","\u3075\u3081\u3064","\u3075\u3081\u3093","\u3075\u3088\u3046","\u3075\u308A\u3053","\u3075\u308A\u308B","\u3075\u308B\u3044","\u3075\u3093\u3044\u304D","\u3075\u3099\u3093\u304B\u3099\u304F","\u3075\u3099\u3093\u304F\u3099","\u3075\u3093\u3057\u3064","\u3075\u3099\u3093\u305B\u304D","\u3075\u3093\u305D\u3046","\u3075\u3099\u3093\u307B\u309A\u3046","\u3078\u3044\u3042\u3093","\u3078\u3044\u304A\u3093","\u3078\u3044\u304B\u3099\u3044","\u3078\u3044\u304D","\u3078\u3044\u3051\u3099\u3093","\u3078\u3044\u3053\u3046","\u3078\u3044\u3055","\u3078\u3044\u3057\u3083","\u3078\u3044\u305B\u3064","\u3078\u3044\u305D","\u3078\u3044\u305F\u304F","\u3078\u3044\u3066\u3093","\u3078\u3044\u306D\u3064","\u3078\u3044\u308F","\u3078\u304D\u304B\u3099","\u3078\u3053\u3080","\u3078\u3099\u306B\u3044\u308D","\u3078\u3099\u306B\u3057\u3087\u3046\u304B\u3099","\u3078\u3089\u3059","\u3078\u3093\u304B\u3093","\u3078\u3099\u3093\u304D\u3087\u3046","\u3078\u3099\u3093\u3053\u3099\u3057","\u3078\u3093\u3055\u3044","\u3078\u3093\u305F\u3044","\u3078\u3099\u3093\u308A","\u307B\u3042\u3093","\u307B\u3044\u304F","\u307B\u3099\u3046\u304D\u3099\u3087","\u307B\u3046\u3053\u304F","\u307B\u3046\u305D\u3046","\u307B\u3046\u307B\u3046","\u307B\u3046\u3082\u3093","\u307B\u3046\u308A\u3064","\u307B\u3048\u308B","\u307B\u304A\u3093","\u307B\u304B\u3093","\u307B\u304D\u3087\u3046","\u307B\u3099\u304D\u3093","\u307B\u304F\u308D","\u307B\u3051\u3064","\u307B\u3051\u3093","\u307B\u3053\u3046","\u307B\u3053\u308B","\u307B\u3057\u3044","\u307B\u3057\u3064","\u307B\u3057\u3085","\u307B\u3057\u3087\u3046","\u307B\u305B\u3044","\u307B\u305D\u3044","\u307B\u305D\u304F","\u307B\u305F\u3066","\u307B\u305F\u308B","\u307B\u309A\u3061\u3075\u3099\u304F\u308D","\u307B\u3063\u304D\u3087\u304F","\u307B\u3063\u3055","\u307B\u3063\u305F\u3093","\u307B\u3068\u3093\u3068\u3099","\u307B\u3081\u308B","\u307B\u3093\u3044","\u307B\u3093\u304D","\u307B\u3093\u3051","\u307B\u3093\u3057\u3064","\u307B\u3093\u3084\u304F","\u307E\u3044\u306B\u3061","\u307E\u304B\u3044","\u307E\u304B\u305B\u308B","\u307E\u304B\u3099\u308B","\u307E\u3051\u308B","\u307E\u3053\u3068","\u307E\u3055\u3064","\u307E\u3057\u3099\u3081","\u307E\u3059\u304F","\u307E\u305B\u3099\u308B","\u307E\u3064\u308A","\u307E\u3068\u3081","\u307E\u306A\u3075\u3099","\u307E\u306C\u3051","\u307E\u306D\u304F","\u307E\u307B\u3046","\u307E\u3082\u308B","\u307E\u3086\u3051\u3099","\u307E\u3088\u3046","\u307E\u308D\u3084\u304B","\u307E\u308F\u3059","\u307E\u308F\u308A","\u307E\u308F\u308B","\u307E\u3093\u304B\u3099","\u307E\u3093\u304D\u3064","\u307E\u3093\u305D\u3099\u304F","\u307E\u3093\u306A\u304B","\u307F\u3044\u3089","\u307F\u3046\u3061","\u307F\u3048\u308B","\u307F\u304B\u3099\u304F","\u307F\u304B\u305F","\u307F\u304B\u3093","\u307F\u3051\u3093","\u307F\u3053\u3093","\u307F\u3057\u3099\u304B\u3044","\u307F\u3059\u3044","\u307F\u3059\u3048\u308B","\u307F\u305B\u308B","\u307F\u3063\u304B","\u307F\u3064\u304B\u308B","\u307F\u3064\u3051\u308B","\u307F\u3066\u3044","\u307F\u3068\u3081\u308B","\u307F\u306A\u3068","\u307F\u306A\u307F\u304B\u3055\u3044","\u307F\u306D\u3089\u308B","\u307F\u306E\u3046","\u307F\u306E\u304B\u3099\u3059","\u307F\u307B\u3093","\u307F\u3082\u3068","\u307F\u3084\u3051\u3099","\u307F\u3089\u3044","\u307F\u308A\u3087\u304F","\u307F\u308F\u304F","\u307F\u3093\u304B","\u307F\u3093\u305D\u3099\u304F","\u3080\u3044\u304B","\u3080\u3048\u304D","\u3080\u3048\u3093","\u3080\u304B\u3044","\u3080\u304B\u3046","\u3080\u304B\u3048","\u3080\u304B\u3057","\u3080\u304D\u3099\u3061\u3083","\u3080\u3051\u308B","\u3080\u3051\u3099\u3093","\u3080\u3055\u307B\u3099\u308B","\u3080\u3057\u3042\u3064\u3044","\u3080\u3057\u306F\u3099","\u3080\u3057\u3099\u3085\u3093","\u3080\u3057\u308D","\u3080\u3059\u3046","\u3080\u3059\u3053","\u3080\u3059\u3075\u3099","\u3080\u3059\u3081","\u3080\u305B\u308B","\u3080\u305B\u3093","\u3080\u3061\u3085\u3046","\u3080\u306A\u3057\u3044","\u3080\u306E\u3046","\u3080\u3084\u307F","\u3080\u3088\u3046","\u3080\u3089\u3055\u304D","\u3080\u308A\u3087\u3046","\u3080\u308D\u3093","\u3081\u3044\u3042\u3093","\u3081\u3044\u3046\u3093","\u3081\u3044\u3048\u3093","\u3081\u3044\u304B\u304F","\u3081\u3044\u304D\u3087\u304F","\u3081\u3044\u3055\u3044","\u3081\u3044\u3057","\u3081\u3044\u305D\u3046","\u3081\u3044\u3075\u3099\u3064","\u3081\u3044\u308C\u3044","\u3081\u3044\u308F\u304F","\u3081\u304F\u3099\u307E\u308C\u308B","\u3081\u3055\u3099\u3059","\u3081\u3057\u305F","\u3081\u3059\u3099\u3089\u3057\u3044","\u3081\u305F\u3099\u3064","\u3081\u307E\u3044","\u3081\u3084\u3059","\u3081\u3093\u304D\u3087","\u3081\u3093\u305B\u304D","\u3081\u3093\u3068\u3099\u3046","\u3082\u3046\u3057\u3042\u3051\u3099\u308B","\u3082\u3046\u3068\u3099\u3046\u3051\u3093","\u3082\u3048\u308B","\u3082\u304F\u3057","\u3082\u304F\u3066\u304D","\u3082\u304F\u3088\u3046\u3072\u3099","\u3082\u3061\u308D\u3093","\u3082\u3068\u3099\u308B","\u3082\u3089\u3046","\u3082\u3093\u304F","\u3082\u3093\u305F\u3099\u3044","\u3084\u304A\u3084","\u3084\u3051\u308B","\u3084\u3055\u3044","\u3084\u3055\u3057\u3044","\u3084\u3059\u3044","\u3084\u3059\u305F\u308D\u3046","\u3084\u3059\u307F","\u3084\u305B\u308B","\u3084\u305D\u3046","\u3084\u305F\u3044","\u3084\u3061\u3093","\u3084\u3063\u3068","\u3084\u3063\u306F\u309A\u308A","\u3084\u3075\u3099\u308B","\u3084\u3081\u308B","\u3084\u3084\u3053\u3057\u3044","\u3084\u3088\u3044","\u3084\u308F\u3089\u304B\u3044","\u3086\u3046\u304D","\u3086\u3046\u3072\u3099\u3093\u304D\u3087\u304F","\u3086\u3046\u3078\u3099","\u3086\u3046\u3081\u3044","\u3086\u3051\u3064","\u3086\u3057\u3085\u3064","\u3086\u305B\u3093","\u3086\u305D\u3046","\u3086\u305F\u304B","\u3086\u3061\u3083\u304F","\u3086\u3066\u3099\u308B","\u3086\u306B\u3085\u3046","\u3086\u3072\u3099\u308F","\u3086\u3089\u3044","\u3086\u308C\u308B","\u3088\u3046\u3044","\u3088\u3046\u304B","\u3088\u3046\u304D\u3085\u3046","\u3088\u3046\u3057\u3099","\u3088\u3046\u3059","\u3088\u3046\u3061\u3048\u3093","\u3088\u304B\u305B\u3099","\u3088\u304B\u3093","\u3088\u304D\u3093","\u3088\u304F\u305B\u3044","\u3088\u304F\u307B\u3099\u3046","\u3088\u3051\u3044","\u3088\u3053\u3099\u308C\u308B","\u3088\u3055\u3093","\u3088\u3057\u3085\u3046","\u3088\u305D\u3046","\u3088\u305D\u304F","\u3088\u3063\u304B","\u3088\u3066\u3044","\u3088\u3068\u3099\u304B\u3099\u308F\u304F","\u3088\u306D\u3064","\u3088\u3084\u304F","\u3088\u3086\u3046","\u3088\u308D\u3053\u3075\u3099","\u3088\u308D\u3057\u3044","\u3089\u3044\u3046","\u3089\u304F\u304B\u3099\u304D","\u3089\u304F\u3053\u3099","\u3089\u304F\u3055\u3064","\u3089\u304F\u305F\u3099","\u3089\u3057\u3093\u306F\u3099\u3093","\u3089\u305B\u3093","\u3089\u305D\u3099\u304F","\u3089\u305F\u3044","\u3089\u3063\u304B","\u3089\u308C\u3064","\u308A\u3048\u304D","\u308A\u304B\u3044","\u308A\u304D\u3055\u304F","\u308A\u304D\u305B\u3064","\u308A\u304F\u304F\u3099\u3093","\u308A\u304F\u3064","\u308A\u3051\u3093","\u308A\u3053\u3046","\u308A\u305B\u3044","\u308A\u305D\u3046","\u308A\u305D\u304F","\u308A\u3066\u3093","\u308A\u306D\u3093","\u308A\u3086\u3046","\u308A\u3085\u3046\u304B\u3099\u304F","\u308A\u3088\u3046","\u308A\u3087\u3046\u308A","\u308A\u3087\u304B\u3093","\u308A\u3087\u304F\u3061\u3083","\u308A\u3087\u3053\u3046","\u308A\u308A\u304F","\u308A\u308C\u304D","\u308A\u308D\u3093","\u308A\u3093\u3053\u3099","\u308B\u3044\u3051\u3044","\u308B\u3044\u3055\u3044","\u308B\u3044\u3057\u3099","\u308B\u3044\u305B\u304D","\u308B\u3059\u306F\u3099\u3093","\u308B\u308A\u304B\u3099\u308F\u3089","\u308C\u3044\u304B\u3093","\u308C\u3044\u304D\u3099","\u308C\u3044\u305B\u3044","\u308C\u3044\u305D\u3099\u3046\u3053","\u308C\u3044\u3068\u3046","\u308C\u3044\u307B\u3099\u3046","\u308C\u304D\u3057","\u308C\u304D\u305F\u3099\u3044","\u308C\u3093\u3042\u3044","\u308C\u3093\u3051\u3044","\u308C\u3093\u3053\u3093","\u308C\u3093\u3055\u3044","\u308C\u3093\u3057\u3085\u3046","\u308C\u3093\u305D\u3099\u304F","\u308C\u3093\u3089\u304F","\u308D\u3046\u304B","\u308D\u3046\u3053\u3099","\u308D\u3046\u3057\u3099\u3093","\u308D\u3046\u305D\u304F","\u308D\u304F\u304B\u3099","\u308D\u3053\u3064","\u308D\u3057\u3099\u3046\u3089","\u308D\u3057\u3085\u3064","\u308D\u305B\u3093","\u308D\u3066\u3093","\u308D\u3081\u3093","\u308D\u308C\u3064","\u308D\u3093\u304D\u3099","\u308D\u3093\u306F\u309A","\u308D\u3093\u3075\u3099\u3093","\u308D\u3093\u308A","\u308F\u304B\u3059","\u308F\u304B\u3081","\u308F\u304B\u3084\u307E","\u308F\u304B\u308C\u308B","\u308F\u3057\u3064","\u308F\u3057\u3099\u307E\u3057","\u308F\u3059\u308C\u3082\u306E","\u308F\u3089\u3046","\u308F\u308C\u308B"]');

},{}],"N7qWy":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("[\"abacate\",\"abaixo\",\"abalar\",\"abater\",\"abduzir\",\"abelha\",\"aberto\",\"abismo\",\"abotoar\",\"abranger\",\"abreviar\",\"abrigar\",\"abrupto\",\"absinto\",\"absoluto\",\"absurdo\",\"abutre\",\"acabado\",\"acalmar\",\"acampar\",\"acanhar\",\"acaso\",\"aceitar\",\"acelerar\",\"acenar\",\"acervo\",\"acessar\",\"acetona\",\"achatar\",\"acidez\",\"acima\",\"acionado\",\"acirrar\",\"aclamar\",\"aclive\",\"acolhida\",\"acomodar\",\"acoplar\",\"acordar\",\"acumular\",\"acusador\",\"adaptar\",\"adega\",\"adentro\",\"adepto\",\"adequar\",\"aderente\",\"adesivo\",\"adeus\",\"adiante\",\"aditivo\",\"adjetivo\",\"adjunto\",\"admirar\",\"adorar\",\"adquirir\",\"adubo\",\"adverso\",\"advogado\",\"aeronave\",\"afastar\",\"aferir\",\"afetivo\",\"afinador\",\"afivelar\",\"aflito\",\"afluente\",\"afrontar\",\"agachar\",\"agarrar\",\"agasalho\",\"agenciar\",\"agilizar\",\"agiota\",\"agitado\",\"agora\",\"agradar\",\"agreste\",\"agrupar\",\"aguardar\",\"agulha\",\"ajoelhar\",\"ajudar\",\"ajustar\",\"alameda\",\"alarme\",\"alastrar\",\"alavanca\",\"albergue\",\"albino\",\"alcatra\",\"aldeia\",\"alecrim\",\"alegria\",\"alertar\",\"alface\",\"alfinete\",\"algum\",\"alheio\",\"aliar\",\"alicate\",\"alienar\",\"alinhar\",\"aliviar\",\"almofada\",\"alocar\",\"alpiste\",\"alterar\",\"altitude\",\"alucinar\",\"alugar\",\"aluno\",\"alusivo\",\"alvo\",\"amaciar\",\"amador\",\"amarelo\",\"amassar\",\"ambas\",\"ambiente\",\"ameixa\",\"amenizar\",\"amido\",\"amistoso\",\"amizade\",\"amolador\",\"amontoar\",\"amoroso\",\"amostra\",\"amparar\",\"ampliar\",\"ampola\",\"anagrama\",\"analisar\",\"anarquia\",\"anatomia\",\"andaime\",\"anel\",\"anexo\",\"angular\",\"animar\",\"anjo\",\"anomalia\",\"anotado\",\"ansioso\",\"anterior\",\"anuidade\",\"anunciar\",\"anzol\",\"apagador\",\"apalpar\",\"apanhado\",\"apego\",\"apelido\",\"apertada\",\"apesar\",\"apetite\",\"apito\",\"aplauso\",\"aplicada\",\"apoio\",\"apontar\",\"aposta\",\"aprendiz\",\"aprovar\",\"aquecer\",\"arame\",\"aranha\",\"arara\",\"arcada\",\"ardente\",\"areia\",\"arejar\",\"arenito\",\"aresta\",\"argiloso\",\"argola\",\"arma\",\"arquivo\",\"arraial\",\"arrebate\",\"arriscar\",\"arroba\",\"arrumar\",\"arsenal\",\"arterial\",\"artigo\",\"arvoredo\",\"asfaltar\",\"asilado\",\"aspirar\",\"assador\",\"assinar\",\"assoalho\",\"assunto\",\"astral\",\"atacado\",\"atadura\",\"atalho\",\"atarefar\",\"atear\",\"atender\",\"aterro\",\"ateu\",\"atingir\",\"atirador\",\"ativo\",\"atoleiro\",\"atracar\",\"atrevido\",\"atriz\",\"atual\",\"atum\",\"auditor\",\"aumentar\",\"aura\",\"aurora\",\"autismo\",\"autoria\",\"autuar\",\"avaliar\",\"avante\",\"avaria\",\"avental\",\"avesso\",\"aviador\",\"avisar\",\"avulso\",\"axila\",\"azarar\",\"azedo\",\"azeite\",\"azulejo\",\"babar\",\"babosa\",\"bacalhau\",\"bacharel\",\"bacia\",\"bagagem\",\"baiano\",\"bailar\",\"baioneta\",\"bairro\",\"baixista\",\"bajular\",\"baleia\",\"baliza\",\"balsa\",\"banal\",\"bandeira\",\"banho\",\"banir\",\"banquete\",\"barato\",\"barbado\",\"baronesa\",\"barraca\",\"barulho\",\"baseado\",\"bastante\",\"batata\",\"batedor\",\"batida\",\"batom\",\"batucar\",\"baunilha\",\"beber\",\"beijo\",\"beirada\",\"beisebol\",\"beldade\",\"beleza\",\"belga\",\"beliscar\",\"bendito\",\"bengala\",\"benzer\",\"berimbau\",\"berlinda\",\"berro\",\"besouro\",\"bexiga\",\"bezerro\",\"bico\",\"bicudo\",\"bienal\",\"bifocal\",\"bifurcar\",\"bigorna\",\"bilhete\",\"bimestre\",\"bimotor\",\"biologia\",\"biombo\",\"biosfera\",\"bipolar\",\"birrento\",\"biscoito\",\"bisneto\",\"bispo\",\"bissexto\",\"bitola\",\"bizarro\",\"blindado\",\"bloco\",\"bloquear\",\"boato\",\"bobagem\",\"bocado\",\"bocejo\",\"bochecha\",\"boicotar\",\"bolada\",\"boletim\",\"bolha\",\"bolo\",\"bombeiro\",\"bonde\",\"boneco\",\"bonita\",\"borbulha\",\"borda\",\"boreal\",\"borracha\",\"bovino\",\"boxeador\",\"branco\",\"brasa\",\"braveza\",\"breu\",\"briga\",\"brilho\",\"brincar\",\"broa\",\"brochura\",\"bronzear\",\"broto\",\"bruxo\",\"bucha\",\"budismo\",\"bufar\",\"bule\",\"buraco\",\"busca\",\"busto\",\"buzina\",\"cabana\",\"cabelo\",\"cabide\",\"cabo\",\"cabrito\",\"cacau\",\"cacetada\",\"cachorro\",\"cacique\",\"cadastro\",\"cadeado\",\"cafezal\",\"caiaque\",\"caipira\",\"caixote\",\"cajado\",\"caju\",\"calafrio\",\"calcular\",\"caldeira\",\"calibrar\",\"calmante\",\"calota\",\"camada\",\"cambista\",\"camisa\",\"camomila\",\"campanha\",\"camuflar\",\"canavial\",\"cancelar\",\"caneta\",\"canguru\",\"canhoto\",\"canivete\",\"canoa\",\"cansado\",\"cantar\",\"canudo\",\"capacho\",\"capela\",\"capinar\",\"capotar\",\"capricho\",\"captador\",\"capuz\",\"caracol\",\"carbono\",\"cardeal\",\"careca\",\"carimbar\",\"carneiro\",\"carpete\",\"carreira\",\"cartaz\",\"carvalho\",\"casaco\",\"casca\",\"casebre\",\"castelo\",\"casulo\",\"catarata\",\"cativar\",\"caule\",\"causador\",\"cautelar\",\"cavalo\",\"caverna\",\"cebola\",\"cedilha\",\"cegonha\",\"celebrar\",\"celular\",\"cenoura\",\"censo\",\"centeio\",\"cercar\",\"cerrado\",\"certeiro\",\"cerveja\",\"cetim\",\"cevada\",\"chacota\",\"chaleira\",\"chamado\",\"chapada\",\"charme\",\"chatice\",\"chave\",\"chefe\",\"chegada\",\"cheiro\",\"cheque\",\"chicote\",\"chifre\",\"chinelo\",\"chocalho\",\"chover\",\"chumbo\",\"chutar\",\"chuva\",\"cicatriz\",\"ciclone\",\"cidade\",\"cidreira\",\"ciente\",\"cigana\",\"cimento\",\"cinto\",\"cinza\",\"ciranda\",\"circuito\",\"cirurgia\",\"citar\",\"clareza\",\"clero\",\"clicar\",\"clone\",\"clube\",\"coado\",\"coagir\",\"cobaia\",\"cobertor\",\"cobrar\",\"cocada\",\"coelho\",\"coentro\",\"coeso\",\"cogumelo\",\"coibir\",\"coifa\",\"coiote\",\"colar\",\"coleira\",\"colher\",\"colidir\",\"colmeia\",\"colono\",\"coluna\",\"comando\",\"combinar\",\"comentar\",\"comitiva\",\"comover\",\"complexo\",\"comum\",\"concha\",\"condor\",\"conectar\",\"confuso\",\"congelar\",\"conhecer\",\"conjugar\",\"consumir\",\"contrato\",\"convite\",\"cooperar\",\"copeiro\",\"copiador\",\"copo\",\"coquetel\",\"coragem\",\"cordial\",\"corneta\",\"coronha\",\"corporal\",\"correio\",\"cortejo\",\"coruja\",\"corvo\",\"cosseno\",\"costela\",\"cotonete\",\"couro\",\"couve\",\"covil\",\"cozinha\",\"cratera\",\"cravo\",\"creche\",\"credor\",\"creme\",\"crer\",\"crespo\",\"criada\",\"criminal\",\"crioulo\",\"crise\",\"criticar\",\"crosta\",\"crua\",\"cruzeiro\",\"cubano\",\"cueca\",\"cuidado\",\"cujo\",\"culatra\",\"culminar\",\"culpar\",\"cultura\",\"cumprir\",\"cunhado\",\"cupido\",\"curativo\",\"curral\",\"cursar\",\"curto\",\"cuspir\",\"custear\",\"cutelo\",\"damasco\",\"datar\",\"debater\",\"debitar\",\"deboche\",\"debulhar\",\"decalque\",\"decimal\",\"declive\",\"decote\",\"decretar\",\"dedal\",\"dedicado\",\"deduzir\",\"defesa\",\"defumar\",\"degelo\",\"degrau\",\"degustar\",\"deitado\",\"deixar\",\"delator\",\"delegado\",\"delinear\",\"delonga\",\"demanda\",\"demitir\",\"demolido\",\"dentista\",\"depenado\",\"depilar\",\"depois\",\"depressa\",\"depurar\",\"deriva\",\"derramar\",\"desafio\",\"desbotar\",\"descanso\",\"desenho\",\"desfiado\",\"desgaste\",\"desigual\",\"deslize\",\"desmamar\",\"desova\",\"despesa\",\"destaque\",\"desviar\",\"detalhar\",\"detentor\",\"detonar\",\"detrito\",\"deusa\",\"dever\",\"devido\",\"devotado\",\"dezena\",\"diagrama\",\"dialeto\",\"didata\",\"difuso\",\"digitar\",\"dilatado\",\"diluente\",\"diminuir\",\"dinastia\",\"dinheiro\",\"diocese\",\"direto\",\"discreta\",\"disfarce\",\"disparo\",\"disquete\",\"dissipar\",\"distante\",\"ditador\",\"diurno\",\"diverso\",\"divisor\",\"divulgar\",\"dizer\",\"dobrador\",\"dolorido\",\"domador\",\"dominado\",\"donativo\",\"donzela\",\"dormente\",\"dorsal\",\"dosagem\",\"dourado\",\"doutor\",\"drenagem\",\"drible\",\"drogaria\",\"duelar\",\"duende\",\"dueto\",\"duplo\",\"duquesa\",\"durante\",\"duvidoso\",\"eclodir\",\"ecoar\",\"ecologia\",\"edificar\",\"edital\",\"educado\",\"efeito\",\"efetivar\",\"ejetar\",\"elaborar\",\"eleger\",\"eleitor\",\"elenco\",\"elevador\",\"eliminar\",\"elogiar\",\"embargo\",\"embolado\",\"embrulho\",\"embutido\",\"emenda\",\"emergir\",\"emissor\",\"empatia\",\"empenho\",\"empinado\",\"empolgar\",\"emprego\",\"empurrar\",\"emulador\",\"encaixe\",\"encenado\",\"enchente\",\"encontro\",\"endeusar\",\"endossar\",\"enfaixar\",\"enfeite\",\"enfim\",\"engajado\",\"engenho\",\"englobar\",\"engomado\",\"engraxar\",\"enguia\",\"enjoar\",\"enlatar\",\"enquanto\",\"enraizar\",\"enrolado\",\"enrugar\",\"ensaio\",\"enseada\",\"ensino\",\"ensopado\",\"entanto\",\"enteado\",\"entidade\",\"entortar\",\"entrada\",\"entulho\",\"envergar\",\"enviado\",\"envolver\",\"enxame\",\"enxerto\",\"enxofre\",\"enxuto\",\"epiderme\",\"equipar\",\"ereto\",\"erguido\",\"errata\",\"erva\",\"ervilha\",\"esbanjar\",\"esbelto\",\"escama\",\"escola\",\"escrita\",\"escuta\",\"esfinge\",\"esfolar\",\"esfregar\",\"esfumado\",\"esgrima\",\"esmalte\",\"espanto\",\"espelho\",\"espiga\",\"esponja\",\"espreita\",\"espumar\",\"esquerda\",\"estaca\",\"esteira\",\"esticar\",\"estofado\",\"estrela\",\"estudo\",\"esvaziar\",\"etanol\",\"etiqueta\",\"euforia\",\"europeu\",\"evacuar\",\"evaporar\",\"evasivo\",\"eventual\",\"evidente\",\"evoluir\",\"exagero\",\"exalar\",\"examinar\",\"exato\",\"exausto\",\"excesso\",\"excitar\",\"exclamar\",\"executar\",\"exemplo\",\"exibir\",\"exigente\",\"exonerar\",\"expandir\",\"expelir\",\"expirar\",\"explanar\",\"exposto\",\"expresso\",\"expulsar\",\"externo\",\"extinto\",\"extrato\",\"fabricar\",\"fabuloso\",\"faceta\",\"facial\",\"fada\",\"fadiga\",\"faixa\",\"falar\",\"falta\",\"familiar\",\"fandango\",\"fanfarra\",\"fantoche\",\"fardado\",\"farelo\",\"farinha\",\"farofa\",\"farpa\",\"fartura\",\"fatia\",\"fator\",\"favorita\",\"faxina\",\"fazenda\",\"fechado\",\"feijoada\",\"feirante\",\"felino\",\"feminino\",\"fenda\",\"feno\",\"fera\",\"feriado\",\"ferrugem\",\"ferver\",\"festejar\",\"fetal\",\"feudal\",\"fiapo\",\"fibrose\",\"ficar\",\"ficheiro\",\"figurado\",\"fileira\",\"filho\",\"filme\",\"filtrar\",\"firmeza\",\"fisgada\",\"fissura\",\"fita\",\"fivela\",\"fixador\",\"fixo\",\"flacidez\",\"flamingo\",\"flanela\",\"flechada\",\"flora\",\"flutuar\",\"fluxo\",\"focal\",\"focinho\",\"fofocar\",\"fogo\",\"foguete\",\"foice\",\"folgado\",\"folheto\",\"forjar\",\"formiga\",\"forno\",\"forte\",\"fosco\",\"fossa\",\"fragata\",\"fralda\",\"frango\",\"frasco\",\"fraterno\",\"freira\",\"frente\",\"fretar\",\"frieza\",\"friso\",\"fritura\",\"fronha\",\"frustrar\",\"fruteira\",\"fugir\",\"fulano\",\"fuligem\",\"fundar\",\"fungo\",\"funil\",\"furador\",\"furioso\",\"futebol\",\"gabarito\",\"gabinete\",\"gado\",\"gaiato\",\"gaiola\",\"gaivota\",\"galega\",\"galho\",\"galinha\",\"galocha\",\"ganhar\",\"garagem\",\"garfo\",\"gargalo\",\"garimpo\",\"garoupa\",\"garrafa\",\"gasoduto\",\"gasto\",\"gata\",\"gatilho\",\"gaveta\",\"gazela\",\"gelado\",\"geleia\",\"gelo\",\"gemada\",\"gemer\",\"gemido\",\"generoso\",\"gengiva\",\"genial\",\"genoma\",\"genro\",\"geologia\",\"gerador\",\"germinar\",\"gesso\",\"gestor\",\"ginasta\",\"gincana\",\"gingado\",\"girafa\",\"girino\",\"glacial\",\"glicose\",\"global\",\"glorioso\",\"goela\",\"goiaba\",\"golfe\",\"golpear\",\"gordura\",\"gorjeta\",\"gorro\",\"gostoso\",\"goteira\",\"governar\",\"gracejo\",\"gradual\",\"grafite\",\"gralha\",\"grampo\",\"granada\",\"gratuito\",\"graveto\",\"graxa\",\"grego\",\"grelhar\",\"greve\",\"grilo\",\"grisalho\",\"gritaria\",\"grosso\",\"grotesco\",\"grudado\",\"grunhido\",\"gruta\",\"guache\",\"guarani\",\"guaxinim\",\"guerrear\",\"guiar\",\"guincho\",\"guisado\",\"gula\",\"guloso\",\"guru\",\"habitar\",\"harmonia\",\"haste\",\"haver\",\"hectare\",\"herdar\",\"heresia\",\"hesitar\",\"hiato\",\"hibernar\",\"hidratar\",\"hiena\",\"hino\",\"hipismo\",\"hipnose\",\"hipoteca\",\"hoje\",\"holofote\",\"homem\",\"honesto\",\"honrado\",\"hormonal\",\"hospedar\",\"humorado\",\"iate\",\"ideia\",\"idoso\",\"ignorado\",\"igreja\",\"iguana\",\"ileso\",\"ilha\",\"iludido\",\"iluminar\",\"ilustrar\",\"imagem\",\"imediato\",\"imenso\",\"imersivo\",\"iminente\",\"imitador\",\"imortal\",\"impacto\",\"impedir\",\"implante\",\"impor\",\"imprensa\",\"impune\",\"imunizar\",\"inalador\",\"inapto\",\"inativo\",\"incenso\",\"inchar\",\"incidir\",\"incluir\",\"incolor\",\"indeciso\",\"indireto\",\"indutor\",\"ineficaz\",\"inerente\",\"infantil\",\"infestar\",\"infinito\",\"inflamar\",\"informal\",\"infrator\",\"ingerir\",\"inibido\",\"inicial\",\"inimigo\",\"injetar\",\"inocente\",\"inodoro\",\"inovador\",\"inox\",\"inquieto\",\"inscrito\",\"inseto\",\"insistir\",\"inspetor\",\"instalar\",\"insulto\",\"intacto\",\"integral\",\"intimar\",\"intocado\",\"intriga\",\"invasor\",\"inverno\",\"invicto\",\"invocar\",\"iogurte\",\"iraniano\",\"ironizar\",\"irreal\",\"irritado\",\"isca\",\"isento\",\"isolado\",\"isqueiro\",\"italiano\",\"janeiro\",\"jangada\",\"janta\",\"jararaca\",\"jardim\",\"jarro\",\"jasmim\",\"jato\",\"javali\",\"jazida\",\"jejum\",\"joaninha\",\"joelhada\",\"jogador\",\"joia\",\"jornal\",\"jorrar\",\"jovem\",\"juba\",\"judeu\",\"judoca\",\"juiz\",\"julgador\",\"julho\",\"jurado\",\"jurista\",\"juro\",\"justa\",\"labareda\",\"laboral\",\"lacre\",\"lactante\",\"ladrilho\",\"lagarta\",\"lagoa\",\"laje\",\"lamber\",\"lamentar\",\"laminar\",\"lampejo\",\"lanche\",\"lapidar\",\"lapso\",\"laranja\",\"lareira\",\"largura\",\"lasanha\",\"lastro\",\"lateral\",\"latido\",\"lavanda\",\"lavoura\",\"lavrador\",\"laxante\",\"lazer\",\"lealdade\",\"lebre\",\"legado\",\"legendar\",\"legista\",\"leigo\",\"leiloar\",\"leitura\",\"lembrete\",\"leme\",\"lenhador\",\"lentilha\",\"leoa\",\"lesma\",\"leste\",\"letivo\",\"letreiro\",\"levar\",\"leveza\",\"levitar\",\"liberal\",\"libido\",\"liderar\",\"ligar\",\"ligeiro\",\"limitar\",\"limoeiro\",\"limpador\",\"linda\",\"linear\",\"linhagem\",\"liquidez\",\"listagem\",\"lisura\",\"litoral\",\"livro\",\"lixa\",\"lixeira\",\"locador\",\"locutor\",\"lojista\",\"lombo\",\"lona\",\"longe\",\"lontra\",\"lorde\",\"lotado\",\"loteria\",\"loucura\",\"lousa\",\"louvar\",\"luar\",\"lucidez\",\"lucro\",\"luneta\",\"lustre\",\"lutador\",\"luva\",\"macaco\",\"macete\",\"machado\",\"macio\",\"madeira\",\"madrinha\",\"magnata\",\"magreza\",\"maior\",\"mais\",\"malandro\",\"malha\",\"malote\",\"maluco\",\"mamilo\",\"mamoeiro\",\"mamute\",\"manada\",\"mancha\",\"mandato\",\"manequim\",\"manhoso\",\"manivela\",\"manobrar\",\"mansa\",\"manter\",\"manusear\",\"mapeado\",\"maquinar\",\"marcador\",\"maresia\",\"marfim\",\"margem\",\"marinho\",\"marmita\",\"maroto\",\"marquise\",\"marreco\",\"martelo\",\"marujo\",\"mascote\",\"masmorra\",\"massagem\",\"mastigar\",\"matagal\",\"materno\",\"matinal\",\"matutar\",\"maxilar\",\"medalha\",\"medida\",\"medusa\",\"megafone\",\"meiga\",\"melancia\",\"melhor\",\"membro\",\"memorial\",\"menino\",\"menos\",\"mensagem\",\"mental\",\"merecer\",\"mergulho\",\"mesada\",\"mesclar\",\"mesmo\",\"mesquita\",\"mestre\",\"metade\",\"meteoro\",\"metragem\",\"mexer\",\"mexicano\",\"micro\",\"migalha\",\"migrar\",\"milagre\",\"milenar\",\"milhar\",\"mimado\",\"minerar\",\"minhoca\",\"ministro\",\"minoria\",\"miolo\",\"mirante\",\"mirtilo\",\"misturar\",\"mocidade\",\"moderno\",\"modular\",\"moeda\",\"moer\",\"moinho\",\"moita\",\"moldura\",\"moleza\",\"molho\",\"molinete\",\"molusco\",\"montanha\",\"moqueca\",\"morango\",\"morcego\",\"mordomo\",\"morena\",\"mosaico\",\"mosquete\",\"mostarda\",\"motel\",\"motim\",\"moto\",\"motriz\",\"muda\",\"muito\",\"mulata\",\"mulher\",\"multar\",\"mundial\",\"munido\",\"muralha\",\"murcho\",\"muscular\",\"museu\",\"musical\",\"nacional\",\"nadador\",\"naja\",\"namoro\",\"narina\",\"narrado\",\"nascer\",\"nativa\",\"natureza\",\"navalha\",\"navegar\",\"navio\",\"neblina\",\"nebuloso\",\"negativa\",\"negociar\",\"negrito\",\"nervoso\",\"neta\",\"neural\",\"nevasca\",\"nevoeiro\",\"ninar\",\"ninho\",\"nitidez\",\"nivelar\",\"nobreza\",\"noite\",\"noiva\",\"nomear\",\"nominal\",\"nordeste\",\"nortear\",\"notar\",\"noticiar\",\"noturno\",\"novelo\",\"novilho\",\"novo\",\"nublado\",\"nudez\",\"numeral\",\"nupcial\",\"nutrir\",\"nuvem\",\"obcecado\",\"obedecer\",\"objetivo\",\"obrigado\",\"obscuro\",\"obstetra\",\"obter\",\"obturar\",\"ocidente\",\"ocioso\",\"ocorrer\",\"oculista\",\"ocupado\",\"ofegante\",\"ofensiva\",\"oferenda\",\"oficina\",\"ofuscado\",\"ogiva\",\"olaria\",\"oleoso\",\"olhar\",\"oliveira\",\"ombro\",\"omelete\",\"omisso\",\"omitir\",\"ondulado\",\"oneroso\",\"ontem\",\"opcional\",\"operador\",\"oponente\",\"oportuno\",\"oposto\",\"orar\",\"orbitar\",\"ordem\",\"ordinal\",\"orfanato\",\"orgasmo\",\"orgulho\",\"oriental\",\"origem\",\"oriundo\",\"orla\",\"ortodoxo\",\"orvalho\",\"oscilar\",\"ossada\",\"osso\",\"ostentar\",\"otimismo\",\"ousadia\",\"outono\",\"outubro\",\"ouvido\",\"ovelha\",\"ovular\",\"oxidar\",\"oxigenar\",\"pacato\",\"paciente\",\"pacote\",\"pactuar\",\"padaria\",\"padrinho\",\"pagar\",\"pagode\",\"painel\",\"pairar\",\"paisagem\",\"palavra\",\"palestra\",\"palheta\",\"palito\",\"palmada\",\"palpitar\",\"pancada\",\"panela\",\"panfleto\",\"panqueca\",\"pantanal\",\"papagaio\",\"papelada\",\"papiro\",\"parafina\",\"parcial\",\"pardal\",\"parede\",\"partida\",\"pasmo\",\"passado\",\"pastel\",\"patamar\",\"patente\",\"patinar\",\"patrono\",\"paulada\",\"pausar\",\"peculiar\",\"pedalar\",\"pedestre\",\"pediatra\",\"pedra\",\"pegada\",\"peitoral\",\"peixe\",\"pele\",\"pelicano\",\"penca\",\"pendurar\",\"peneira\",\"penhasco\",\"pensador\",\"pente\",\"perceber\",\"perfeito\",\"pergunta\",\"perito\",\"permitir\",\"perna\",\"perplexo\",\"persiana\",\"pertence\",\"peruca\",\"pescado\",\"pesquisa\",\"pessoa\",\"petiscar\",\"piada\",\"picado\",\"piedade\",\"pigmento\",\"pilastra\",\"pilhado\",\"pilotar\",\"pimenta\",\"pincel\",\"pinguim\",\"pinha\",\"pinote\",\"pintar\",\"pioneiro\",\"pipoca\",\"piquete\",\"piranha\",\"pires\",\"pirueta\",\"piscar\",\"pistola\",\"pitanga\",\"pivete\",\"planta\",\"plaqueta\",\"platina\",\"plebeu\",\"plumagem\",\"pluvial\",\"pneu\",\"poda\",\"poeira\",\"poetisa\",\"polegada\",\"policiar\",\"poluente\",\"polvilho\",\"pomar\",\"pomba\",\"ponderar\",\"pontaria\",\"populoso\",\"porta\",\"possuir\",\"postal\",\"pote\",\"poupar\",\"pouso\",\"povoar\",\"praia\",\"prancha\",\"prato\",\"praxe\",\"prece\",\"predador\",\"prefeito\",\"premiar\",\"prensar\",\"preparar\",\"presilha\",\"pretexto\",\"prevenir\",\"prezar\",\"primata\",\"princesa\",\"prisma\",\"privado\",\"processo\",\"produto\",\"profeta\",\"proibido\",\"projeto\",\"prometer\",\"propagar\",\"prosa\",\"protetor\",\"provador\",\"publicar\",\"pudim\",\"pular\",\"pulmonar\",\"pulseira\",\"punhal\",\"punir\",\"pupilo\",\"pureza\",\"puxador\",\"quadra\",\"quantia\",\"quarto\",\"quase\",\"quebrar\",\"queda\",\"queijo\",\"quente\",\"querido\",\"quimono\",\"quina\",\"quiosque\",\"rabanada\",\"rabisco\",\"rachar\",\"racionar\",\"radial\",\"raiar\",\"rainha\",\"raio\",\"raiva\",\"rajada\",\"ralado\",\"ramal\",\"ranger\",\"ranhura\",\"rapadura\",\"rapel\",\"rapidez\",\"raposa\",\"raquete\",\"raridade\",\"rasante\",\"rascunho\",\"rasgar\",\"raspador\",\"rasteira\",\"rasurar\",\"ratazana\",\"ratoeira\",\"realeza\",\"reanimar\",\"reaver\",\"rebaixar\",\"rebelde\",\"rebolar\",\"recado\",\"recente\",\"recheio\",\"recibo\",\"recordar\",\"recrutar\",\"recuar\",\"rede\",\"redimir\",\"redonda\",\"reduzida\",\"reenvio\",\"refinar\",\"refletir\",\"refogar\",\"refresco\",\"refugiar\",\"regalia\",\"regime\",\"regra\",\"reinado\",\"reitor\",\"rejeitar\",\"relativo\",\"remador\",\"remendo\",\"remorso\",\"renovado\",\"reparo\",\"repelir\",\"repleto\",\"repolho\",\"represa\",\"repudiar\",\"requerer\",\"resenha\",\"resfriar\",\"resgatar\",\"residir\",\"resolver\",\"respeito\",\"ressaca\",\"restante\",\"resumir\",\"retalho\",\"reter\",\"retirar\",\"retomada\",\"retratar\",\"revelar\",\"revisor\",\"revolta\",\"riacho\",\"rica\",\"rigidez\",\"rigoroso\",\"rimar\",\"ringue\",\"risada\",\"risco\",\"risonho\",\"robalo\",\"rochedo\",\"rodada\",\"rodeio\",\"rodovia\",\"roedor\",\"roleta\",\"romano\",\"roncar\",\"rosado\",\"roseira\",\"rosto\",\"rota\",\"roteiro\",\"rotina\",\"rotular\",\"rouco\",\"roupa\",\"roxo\",\"rubro\",\"rugido\",\"rugoso\",\"ruivo\",\"rumo\",\"rupestre\",\"russo\",\"sabor\",\"saciar\",\"sacola\",\"sacudir\",\"sadio\",\"safira\",\"saga\",\"sagrada\",\"saibro\",\"salada\",\"saleiro\",\"salgado\",\"saliva\",\"salpicar\",\"salsicha\",\"saltar\",\"salvador\",\"sambar\",\"samurai\",\"sanar\",\"sanfona\",\"sangue\",\"sanidade\",\"sapato\",\"sarda\",\"sargento\",\"sarjeta\",\"saturar\",\"saudade\",\"saxofone\",\"sazonal\",\"secar\",\"secular\",\"seda\",\"sedento\",\"sediado\",\"sedoso\",\"sedutor\",\"segmento\",\"segredo\",\"segundo\",\"seiva\",\"seleto\",\"selvagem\",\"semanal\",\"semente\",\"senador\",\"senhor\",\"sensual\",\"sentado\",\"separado\",\"sereia\",\"seringa\",\"serra\",\"servo\",\"setembro\",\"setor\",\"sigilo\",\"silhueta\",\"silicone\",\"simetria\",\"simpatia\",\"simular\",\"sinal\",\"sincero\",\"singular\",\"sinopse\",\"sintonia\",\"sirene\",\"siri\",\"situado\",\"soberano\",\"sobra\",\"socorro\",\"sogro\",\"soja\",\"solda\",\"soletrar\",\"solteiro\",\"sombrio\",\"sonata\",\"sondar\",\"sonegar\",\"sonhador\",\"sono\",\"soprano\",\"soquete\",\"sorrir\",\"sorteio\",\"sossego\",\"sotaque\",\"soterrar\",\"sovado\",\"sozinho\",\"suavizar\",\"subida\",\"submerso\",\"subsolo\",\"subtrair\",\"sucata\",\"sucesso\",\"suco\",\"sudeste\",\"sufixo\",\"sugador\",\"sugerir\",\"sujeito\",\"sulfato\",\"sumir\",\"suor\",\"superior\",\"suplicar\",\"suposto\",\"suprimir\",\"surdina\",\"surfista\",\"surpresa\",\"surreal\",\"surtir\",\"suspiro\",\"sustento\",\"tabela\",\"tablete\",\"tabuada\",\"tacho\",\"tagarela\",\"talher\",\"talo\",\"talvez\",\"tamanho\",\"tamborim\",\"tampa\",\"tangente\",\"tanto\",\"tapar\",\"tapioca\",\"tardio\",\"tarefa\",\"tarja\",\"tarraxa\",\"tatuagem\",\"taurino\",\"taxativo\",\"taxista\",\"teatral\",\"tecer\",\"tecido\",\"teclado\",\"tedioso\",\"teia\",\"teimar\",\"telefone\",\"telhado\",\"tempero\",\"tenente\",\"tensor\",\"tentar\",\"termal\",\"terno\",\"terreno\",\"tese\",\"tesoura\",\"testado\",\"teto\",\"textura\",\"texugo\",\"tiara\",\"tigela\",\"tijolo\",\"timbrar\",\"timidez\",\"tingido\",\"tinteiro\",\"tiragem\",\"titular\",\"toalha\",\"tocha\",\"tolerar\",\"tolice\",\"tomada\",\"tomilho\",\"tonel\",\"tontura\",\"topete\",\"tora\",\"torcido\",\"torneio\",\"torque\",\"torrada\",\"torto\",\"tostar\",\"touca\",\"toupeira\",\"toxina\",\"trabalho\",\"tracejar\",\"tradutor\",\"trafegar\",\"trajeto\",\"trama\",\"trancar\",\"trapo\",\"traseiro\",\"tratador\",\"travar\",\"treino\",\"tremer\",\"trepidar\",\"trevo\",\"triagem\",\"tribo\",\"triciclo\",\"tridente\",\"trilogia\",\"trindade\",\"triplo\",\"triturar\",\"triunfal\",\"trocar\",\"trombeta\",\"trova\",\"trunfo\",\"truque\",\"tubular\",\"tucano\",\"tudo\",\"tulipa\",\"tupi\",\"turbo\",\"turma\",\"turquesa\",\"tutelar\",\"tutorial\",\"uivar\",\"umbigo\",\"unha\",\"unidade\",\"uniforme\",\"urologia\",\"urso\",\"urtiga\",\"urubu\",\"usado\",\"usina\",\"usufruir\",\"vacina\",\"vadiar\",\"vagaroso\",\"vaidoso\",\"vala\",\"valente\",\"validade\",\"valores\",\"vantagem\",\"vaqueiro\",\"varanda\",\"vareta\",\"varrer\",\"vascular\",\"vasilha\",\"vassoura\",\"vazar\",\"vazio\",\"veado\",\"vedar\",\"vegetar\",\"veicular\",\"veleiro\",\"velhice\",\"veludo\",\"vencedor\",\"vendaval\",\"venerar\",\"ventre\",\"verbal\",\"verdade\",\"vereador\",\"vergonha\",\"vermelho\",\"verniz\",\"versar\",\"vertente\",\"vespa\",\"vestido\",\"vetorial\",\"viaduto\",\"viagem\",\"viajar\",\"viatura\",\"vibrador\",\"videira\",\"vidraria\",\"viela\",\"viga\",\"vigente\",\"vigiar\",\"vigorar\",\"vilarejo\",\"vinco\",\"vinheta\",\"vinil\",\"violeta\",\"virada\",\"virtude\",\"visitar\",\"visto\",\"vitral\",\"viveiro\",\"vizinho\",\"voador\",\"voar\",\"vogal\",\"volante\",\"voleibol\",\"voltagem\",\"volumoso\",\"vontade\",\"vulto\",\"vuvuzela\",\"xadrez\",\"xarope\",\"xeque\",\"xeretar\",\"xerife\",\"xingar\",\"zangado\",\"zarpar\",\"zebu\",\"zelador\",\"zombar\",\"zoologia\",\"zumbido\"]");

},{}],"9GDjG":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("[\"abandon\",\"ability\",\"able\",\"about\",\"above\",\"absent\",\"absorb\",\"abstract\",\"absurd\",\"abuse\",\"access\",\"accident\",\"account\",\"accuse\",\"achieve\",\"acid\",\"acoustic\",\"acquire\",\"across\",\"act\",\"action\",\"actor\",\"actress\",\"actual\",\"adapt\",\"add\",\"addict\",\"address\",\"adjust\",\"admit\",\"adult\",\"advance\",\"advice\",\"aerobic\",\"affair\",\"afford\",\"afraid\",\"again\",\"age\",\"agent\",\"agree\",\"ahead\",\"aim\",\"air\",\"airport\",\"aisle\",\"alarm\",\"album\",\"alcohol\",\"alert\",\"alien\",\"all\",\"alley\",\"allow\",\"almost\",\"alone\",\"alpha\",\"already\",\"also\",\"alter\",\"always\",\"amateur\",\"amazing\",\"among\",\"amount\",\"amused\",\"analyst\",\"anchor\",\"ancient\",\"anger\",\"angle\",\"angry\",\"animal\",\"ankle\",\"announce\",\"annual\",\"another\",\"answer\",\"antenna\",\"antique\",\"anxiety\",\"any\",\"apart\",\"apology\",\"appear\",\"apple\",\"approve\",\"april\",\"arch\",\"arctic\",\"area\",\"arena\",\"argue\",\"arm\",\"armed\",\"armor\",\"army\",\"around\",\"arrange\",\"arrest\",\"arrive\",\"arrow\",\"art\",\"artefact\",\"artist\",\"artwork\",\"ask\",\"aspect\",\"assault\",\"asset\",\"assist\",\"assume\",\"asthma\",\"athlete\",\"atom\",\"attack\",\"attend\",\"attitude\",\"attract\",\"auction\",\"audit\",\"august\",\"aunt\",\"author\",\"auto\",\"autumn\",\"average\",\"avocado\",\"avoid\",\"awake\",\"aware\",\"away\",\"awesome\",\"awful\",\"awkward\",\"axis\",\"baby\",\"bachelor\",\"bacon\",\"badge\",\"bag\",\"balance\",\"balcony\",\"ball\",\"bamboo\",\"banana\",\"banner\",\"bar\",\"barely\",\"bargain\",\"barrel\",\"base\",\"basic\",\"basket\",\"battle\",\"beach\",\"bean\",\"beauty\",\"because\",\"become\",\"beef\",\"before\",\"begin\",\"behave\",\"behind\",\"believe\",\"below\",\"belt\",\"bench\",\"benefit\",\"best\",\"betray\",\"better\",\"between\",\"beyond\",\"bicycle\",\"bid\",\"bike\",\"bind\",\"biology\",\"bird\",\"birth\",\"bitter\",\"black\",\"blade\",\"blame\",\"blanket\",\"blast\",\"bleak\",\"bless\",\"blind\",\"blood\",\"blossom\",\"blouse\",\"blue\",\"blur\",\"blush\",\"board\",\"boat\",\"body\",\"boil\",\"bomb\",\"bone\",\"bonus\",\"book\",\"boost\",\"border\",\"boring\",\"borrow\",\"boss\",\"bottom\",\"bounce\",\"box\",\"boy\",\"bracket\",\"brain\",\"brand\",\"brass\",\"brave\",\"bread\",\"breeze\",\"brick\",\"bridge\",\"brief\",\"bright\",\"bring\",\"brisk\",\"broccoli\",\"broken\",\"bronze\",\"broom\",\"brother\",\"brown\",\"brush\",\"bubble\",\"buddy\",\"budget\",\"buffalo\",\"build\",\"bulb\",\"bulk\",\"bullet\",\"bundle\",\"bunker\",\"burden\",\"burger\",\"burst\",\"bus\",\"business\",\"busy\",\"butter\",\"buyer\",\"buzz\",\"cabbage\",\"cabin\",\"cable\",\"cactus\",\"cage\",\"cake\",\"call\",\"calm\",\"camera\",\"camp\",\"can\",\"canal\",\"cancel\",\"candy\",\"cannon\",\"canoe\",\"canvas\",\"canyon\",\"capable\",\"capital\",\"captain\",\"car\",\"carbon\",\"card\",\"cargo\",\"carpet\",\"carry\",\"cart\",\"case\",\"cash\",\"casino\",\"castle\",\"casual\",\"cat\",\"catalog\",\"catch\",\"category\",\"cattle\",\"caught\",\"cause\",\"caution\",\"cave\",\"ceiling\",\"celery\",\"cement\",\"census\",\"century\",\"cereal\",\"certain\",\"chair\",\"chalk\",\"champion\",\"change\",\"chaos\",\"chapter\",\"charge\",\"chase\",\"chat\",\"cheap\",\"check\",\"cheese\",\"chef\",\"cherry\",\"chest\",\"chicken\",\"chief\",\"child\",\"chimney\",\"choice\",\"choose\",\"chronic\",\"chuckle\",\"chunk\",\"churn\",\"cigar\",\"cinnamon\",\"circle\",\"citizen\",\"city\",\"civil\",\"claim\",\"clap\",\"clarify\",\"claw\",\"clay\",\"clean\",\"clerk\",\"clever\",\"click\",\"client\",\"cliff\",\"climb\",\"clinic\",\"clip\",\"clock\",\"clog\",\"close\",\"cloth\",\"cloud\",\"clown\",\"club\",\"clump\",\"cluster\",\"clutch\",\"coach\",\"coast\",\"coconut\",\"code\",\"coffee\",\"coil\",\"coin\",\"collect\",\"color\",\"column\",\"combine\",\"come\",\"comfort\",\"comic\",\"common\",\"company\",\"concert\",\"conduct\",\"confirm\",\"congress\",\"connect\",\"consider\",\"control\",\"convince\",\"cook\",\"cool\",\"copper\",\"copy\",\"coral\",\"core\",\"corn\",\"correct\",\"cost\",\"cotton\",\"couch\",\"country\",\"couple\",\"course\",\"cousin\",\"cover\",\"coyote\",\"crack\",\"cradle\",\"craft\",\"cram\",\"crane\",\"crash\",\"crater\",\"crawl\",\"crazy\",\"cream\",\"credit\",\"creek\",\"crew\",\"cricket\",\"crime\",\"crisp\",\"critic\",\"crop\",\"cross\",\"crouch\",\"crowd\",\"crucial\",\"cruel\",\"cruise\",\"crumble\",\"crunch\",\"crush\",\"cry\",\"crystal\",\"cube\",\"culture\",\"cup\",\"cupboard\",\"curious\",\"current\",\"curtain\",\"curve\",\"cushion\",\"custom\",\"cute\",\"cycle\",\"dad\",\"damage\",\"damp\",\"dance\",\"danger\",\"daring\",\"dash\",\"daughter\",\"dawn\",\"day\",\"deal\",\"debate\",\"debris\",\"decade\",\"december\",\"decide\",\"decline\",\"decorate\",\"decrease\",\"deer\",\"defense\",\"define\",\"defy\",\"degree\",\"delay\",\"deliver\",\"demand\",\"demise\",\"denial\",\"dentist\",\"deny\",\"depart\",\"depend\",\"deposit\",\"depth\",\"deputy\",\"derive\",\"describe\",\"desert\",\"design\",\"desk\",\"despair\",\"destroy\",\"detail\",\"detect\",\"develop\",\"device\",\"devote\",\"diagram\",\"dial\",\"diamond\",\"diary\",\"dice\",\"diesel\",\"diet\",\"differ\",\"digital\",\"dignity\",\"dilemma\",\"dinner\",\"dinosaur\",\"direct\",\"dirt\",\"disagree\",\"discover\",\"disease\",\"dish\",\"dismiss\",\"disorder\",\"display\",\"distance\",\"divert\",\"divide\",\"divorce\",\"dizzy\",\"doctor\",\"document\",\"dog\",\"doll\",\"dolphin\",\"domain\",\"donate\",\"donkey\",\"donor\",\"door\",\"dose\",\"double\",\"dove\",\"draft\",\"dragon\",\"drama\",\"drastic\",\"draw\",\"dream\",\"dress\",\"drift\",\"drill\",\"drink\",\"drip\",\"drive\",\"drop\",\"drum\",\"dry\",\"duck\",\"dumb\",\"dune\",\"during\",\"dust\",\"dutch\",\"duty\",\"dwarf\",\"dynamic\",\"eager\",\"eagle\",\"early\",\"earn\",\"earth\",\"easily\",\"east\",\"easy\",\"echo\",\"ecology\",\"economy\",\"edge\",\"edit\",\"educate\",\"effort\",\"egg\",\"eight\",\"either\",\"elbow\",\"elder\",\"electric\",\"elegant\",\"element\",\"elephant\",\"elevator\",\"elite\",\"else\",\"embark\",\"embody\",\"embrace\",\"emerge\",\"emotion\",\"employ\",\"empower\",\"empty\",\"enable\",\"enact\",\"end\",\"endless\",\"endorse\",\"enemy\",\"energy\",\"enforce\",\"engage\",\"engine\",\"enhance\",\"enjoy\",\"enlist\",\"enough\",\"enrich\",\"enroll\",\"ensure\",\"enter\",\"entire\",\"entry\",\"envelope\",\"episode\",\"equal\",\"equip\",\"era\",\"erase\",\"erode\",\"erosion\",\"error\",\"erupt\",\"escape\",\"essay\",\"essence\",\"estate\",\"eternal\",\"ethics\",\"evidence\",\"evil\",\"evoke\",\"evolve\",\"exact\",\"example\",\"excess\",\"exchange\",\"excite\",\"exclude\",\"excuse\",\"execute\",\"exercise\",\"exhaust\",\"exhibit\",\"exile\",\"exist\",\"exit\",\"exotic\",\"expand\",\"expect\",\"expire\",\"explain\",\"expose\",\"express\",\"extend\",\"extra\",\"eye\",\"eyebrow\",\"fabric\",\"face\",\"faculty\",\"fade\",\"faint\",\"faith\",\"fall\",\"false\",\"fame\",\"family\",\"famous\",\"fan\",\"fancy\",\"fantasy\",\"farm\",\"fashion\",\"fat\",\"fatal\",\"father\",\"fatigue\",\"fault\",\"favorite\",\"feature\",\"february\",\"federal\",\"fee\",\"feed\",\"feel\",\"female\",\"fence\",\"festival\",\"fetch\",\"fever\",\"few\",\"fiber\",\"fiction\",\"field\",\"figure\",\"file\",\"film\",\"filter\",\"final\",\"find\",\"fine\",\"finger\",\"finish\",\"fire\",\"firm\",\"first\",\"fiscal\",\"fish\",\"fit\",\"fitness\",\"fix\",\"flag\",\"flame\",\"flash\",\"flat\",\"flavor\",\"flee\",\"flight\",\"flip\",\"float\",\"flock\",\"floor\",\"flower\",\"fluid\",\"flush\",\"fly\",\"foam\",\"focus\",\"fog\",\"foil\",\"fold\",\"follow\",\"food\",\"foot\",\"force\",\"forest\",\"forget\",\"fork\",\"fortune\",\"forum\",\"forward\",\"fossil\",\"foster\",\"found\",\"fox\",\"fragile\",\"frame\",\"frequent\",\"fresh\",\"friend\",\"fringe\",\"frog\",\"front\",\"frost\",\"frown\",\"frozen\",\"fruit\",\"fuel\",\"fun\",\"funny\",\"furnace\",\"fury\",\"future\",\"gadget\",\"gain\",\"galaxy\",\"gallery\",\"game\",\"gap\",\"garage\",\"garbage\",\"garden\",\"garlic\",\"garment\",\"gas\",\"gasp\",\"gate\",\"gather\",\"gauge\",\"gaze\",\"general\",\"genius\",\"genre\",\"gentle\",\"genuine\",\"gesture\",\"ghost\",\"giant\",\"gift\",\"giggle\",\"ginger\",\"giraffe\",\"girl\",\"give\",\"glad\",\"glance\",\"glare\",\"glass\",\"glide\",\"glimpse\",\"globe\",\"gloom\",\"glory\",\"glove\",\"glow\",\"glue\",\"goat\",\"goddess\",\"gold\",\"good\",\"goose\",\"gorilla\",\"gospel\",\"gossip\",\"govern\",\"gown\",\"grab\",\"grace\",\"grain\",\"grant\",\"grape\",\"grass\",\"gravity\",\"great\",\"green\",\"grid\",\"grief\",\"grit\",\"grocery\",\"group\",\"grow\",\"grunt\",\"guard\",\"guess\",\"guide\",\"guilt\",\"guitar\",\"gun\",\"gym\",\"habit\",\"hair\",\"half\",\"hammer\",\"hamster\",\"hand\",\"happy\",\"harbor\",\"hard\",\"harsh\",\"harvest\",\"hat\",\"have\",\"hawk\",\"hazard\",\"head\",\"health\",\"heart\",\"heavy\",\"hedgehog\",\"height\",\"hello\",\"helmet\",\"help\",\"hen\",\"hero\",\"hidden\",\"high\",\"hill\",\"hint\",\"hip\",\"hire\",\"history\",\"hobby\",\"hockey\",\"hold\",\"hole\",\"holiday\",\"hollow\",\"home\",\"honey\",\"hood\",\"hope\",\"horn\",\"horror\",\"horse\",\"hospital\",\"host\",\"hotel\",\"hour\",\"hover\",\"hub\",\"huge\",\"human\",\"humble\",\"humor\",\"hundred\",\"hungry\",\"hunt\",\"hurdle\",\"hurry\",\"hurt\",\"husband\",\"hybrid\",\"ice\",\"icon\",\"idea\",\"identify\",\"idle\",\"ignore\",\"ill\",\"illegal\",\"illness\",\"image\",\"imitate\",\"immense\",\"immune\",\"impact\",\"impose\",\"improve\",\"impulse\",\"inch\",\"include\",\"income\",\"increase\",\"index\",\"indicate\",\"indoor\",\"industry\",\"infant\",\"inflict\",\"inform\",\"inhale\",\"inherit\",\"initial\",\"inject\",\"injury\",\"inmate\",\"inner\",\"innocent\",\"input\",\"inquiry\",\"insane\",\"insect\",\"inside\",\"inspire\",\"install\",\"intact\",\"interest\",\"into\",\"invest\",\"invite\",\"involve\",\"iron\",\"island\",\"isolate\",\"issue\",\"item\",\"ivory\",\"jacket\",\"jaguar\",\"jar\",\"jazz\",\"jealous\",\"jeans\",\"jelly\",\"jewel\",\"job\",\"join\",\"joke\",\"journey\",\"joy\",\"judge\",\"juice\",\"jump\",\"jungle\",\"junior\",\"junk\",\"just\",\"kangaroo\",\"keen\",\"keep\",\"ketchup\",\"key\",\"kick\",\"kid\",\"kidney\",\"kind\",\"kingdom\",\"kiss\",\"kit\",\"kitchen\",\"kite\",\"kitten\",\"kiwi\",\"knee\",\"knife\",\"knock\",\"know\",\"lab\",\"label\",\"labor\",\"ladder\",\"lady\",\"lake\",\"lamp\",\"language\",\"laptop\",\"large\",\"later\",\"latin\",\"laugh\",\"laundry\",\"lava\",\"law\",\"lawn\",\"lawsuit\",\"layer\",\"lazy\",\"leader\",\"leaf\",\"learn\",\"leave\",\"lecture\",\"left\",\"leg\",\"legal\",\"legend\",\"leisure\",\"lemon\",\"lend\",\"length\",\"lens\",\"leopard\",\"lesson\",\"letter\",\"level\",\"liar\",\"liberty\",\"library\",\"license\",\"life\",\"lift\",\"light\",\"like\",\"limb\",\"limit\",\"link\",\"lion\",\"liquid\",\"list\",\"little\",\"live\",\"lizard\",\"load\",\"loan\",\"lobster\",\"local\",\"lock\",\"logic\",\"lonely\",\"long\",\"loop\",\"lottery\",\"loud\",\"lounge\",\"love\",\"loyal\",\"lucky\",\"luggage\",\"lumber\",\"lunar\",\"lunch\",\"luxury\",\"lyrics\",\"machine\",\"mad\",\"magic\",\"magnet\",\"maid\",\"mail\",\"main\",\"major\",\"make\",\"mammal\",\"man\",\"manage\",\"mandate\",\"mango\",\"mansion\",\"manual\",\"maple\",\"marble\",\"march\",\"margin\",\"marine\",\"market\",\"marriage\",\"mask\",\"mass\",\"master\",\"match\",\"material\",\"math\",\"matrix\",\"matter\",\"maximum\",\"maze\",\"meadow\",\"mean\",\"measure\",\"meat\",\"mechanic\",\"medal\",\"media\",\"melody\",\"melt\",\"member\",\"memory\",\"mention\",\"menu\",\"mercy\",\"merge\",\"merit\",\"merry\",\"mesh\",\"message\",\"metal\",\"method\",\"middle\",\"midnight\",\"milk\",\"million\",\"mimic\",\"mind\",\"minimum\",\"minor\",\"minute\",\"miracle\",\"mirror\",\"misery\",\"miss\",\"mistake\",\"mix\",\"mixed\",\"mixture\",\"mobile\",\"model\",\"modify\",\"mom\",\"moment\",\"monitor\",\"monkey\",\"monster\",\"month\",\"moon\",\"moral\",\"more\",\"morning\",\"mosquito\",\"mother\",\"motion\",\"motor\",\"mountain\",\"mouse\",\"move\",\"movie\",\"much\",\"muffin\",\"mule\",\"multiply\",\"muscle\",\"museum\",\"mushroom\",\"music\",\"must\",\"mutual\",\"myself\",\"mystery\",\"myth\",\"naive\",\"name\",\"napkin\",\"narrow\",\"nasty\",\"nation\",\"nature\",\"near\",\"neck\",\"need\",\"negative\",\"neglect\",\"neither\",\"nephew\",\"nerve\",\"nest\",\"net\",\"network\",\"neutral\",\"never\",\"news\",\"next\",\"nice\",\"night\",\"noble\",\"noise\",\"nominee\",\"noodle\",\"normal\",\"north\",\"nose\",\"notable\",\"note\",\"nothing\",\"notice\",\"novel\",\"now\",\"nuclear\",\"number\",\"nurse\",\"nut\",\"oak\",\"obey\",\"object\",\"oblige\",\"obscure\",\"observe\",\"obtain\",\"obvious\",\"occur\",\"ocean\",\"october\",\"odor\",\"off\",\"offer\",\"office\",\"often\",\"oil\",\"okay\",\"old\",\"olive\",\"olympic\",\"omit\",\"once\",\"one\",\"onion\",\"online\",\"only\",\"open\",\"opera\",\"opinion\",\"oppose\",\"option\",\"orange\",\"orbit\",\"orchard\",\"order\",\"ordinary\",\"organ\",\"orient\",\"original\",\"orphan\",\"ostrich\",\"other\",\"outdoor\",\"outer\",\"output\",\"outside\",\"oval\",\"oven\",\"over\",\"own\",\"owner\",\"oxygen\",\"oyster\",\"ozone\",\"pact\",\"paddle\",\"page\",\"pair\",\"palace\",\"palm\",\"panda\",\"panel\",\"panic\",\"panther\",\"paper\",\"parade\",\"parent\",\"park\",\"parrot\",\"party\",\"pass\",\"patch\",\"path\",\"patient\",\"patrol\",\"pattern\",\"pause\",\"pave\",\"payment\",\"peace\",\"peanut\",\"pear\",\"peasant\",\"pelican\",\"pen\",\"penalty\",\"pencil\",\"people\",\"pepper\",\"perfect\",\"permit\",\"person\",\"pet\",\"phone\",\"photo\",\"phrase\",\"physical\",\"piano\",\"picnic\",\"picture\",\"piece\",\"pig\",\"pigeon\",\"pill\",\"pilot\",\"pink\",\"pioneer\",\"pipe\",\"pistol\",\"pitch\",\"pizza\",\"place\",\"planet\",\"plastic\",\"plate\",\"play\",\"please\",\"pledge\",\"pluck\",\"plug\",\"plunge\",\"poem\",\"poet\",\"point\",\"polar\",\"pole\",\"police\",\"pond\",\"pony\",\"pool\",\"popular\",\"portion\",\"position\",\"possible\",\"post\",\"potato\",\"pottery\",\"poverty\",\"powder\",\"power\",\"practice\",\"praise\",\"predict\",\"prefer\",\"prepare\",\"present\",\"pretty\",\"prevent\",\"price\",\"pride\",\"primary\",\"print\",\"priority\",\"prison\",\"private\",\"prize\",\"problem\",\"process\",\"produce\",\"profit\",\"program\",\"project\",\"promote\",\"proof\",\"property\",\"prosper\",\"protect\",\"proud\",\"provide\",\"public\",\"pudding\",\"pull\",\"pulp\",\"pulse\",\"pumpkin\",\"punch\",\"pupil\",\"puppy\",\"purchase\",\"purity\",\"purpose\",\"purse\",\"push\",\"put\",\"puzzle\",\"pyramid\",\"quality\",\"quantum\",\"quarter\",\"question\",\"quick\",\"quit\",\"quiz\",\"quote\",\"rabbit\",\"raccoon\",\"race\",\"rack\",\"radar\",\"radio\",\"rail\",\"rain\",\"raise\",\"rally\",\"ramp\",\"ranch\",\"random\",\"range\",\"rapid\",\"rare\",\"rate\",\"rather\",\"raven\",\"raw\",\"razor\",\"ready\",\"real\",\"reason\",\"rebel\",\"rebuild\",\"recall\",\"receive\",\"recipe\",\"record\",\"recycle\",\"reduce\",\"reflect\",\"reform\",\"refuse\",\"region\",\"regret\",\"regular\",\"reject\",\"relax\",\"release\",\"relief\",\"rely\",\"remain\",\"remember\",\"remind\",\"remove\",\"render\",\"renew\",\"rent\",\"reopen\",\"repair\",\"repeat\",\"replace\",\"report\",\"require\",\"rescue\",\"resemble\",\"resist\",\"resource\",\"response\",\"result\",\"retire\",\"retreat\",\"return\",\"reunion\",\"reveal\",\"review\",\"reward\",\"rhythm\",\"rib\",\"ribbon\",\"rice\",\"rich\",\"ride\",\"ridge\",\"rifle\",\"right\",\"rigid\",\"ring\",\"riot\",\"ripple\",\"risk\",\"ritual\",\"rival\",\"river\",\"road\",\"roast\",\"robot\",\"robust\",\"rocket\",\"romance\",\"roof\",\"rookie\",\"room\",\"rose\",\"rotate\",\"rough\",\"round\",\"route\",\"royal\",\"rubber\",\"rude\",\"rug\",\"rule\",\"run\",\"runway\",\"rural\",\"sad\",\"saddle\",\"sadness\",\"safe\",\"sail\",\"salad\",\"salmon\",\"salon\",\"salt\",\"salute\",\"same\",\"sample\",\"sand\",\"satisfy\",\"satoshi\",\"sauce\",\"sausage\",\"save\",\"say\",\"scale\",\"scan\",\"scare\",\"scatter\",\"scene\",\"scheme\",\"school\",\"science\",\"scissors\",\"scorpion\",\"scout\",\"scrap\",\"screen\",\"script\",\"scrub\",\"sea\",\"search\",\"season\",\"seat\",\"second\",\"secret\",\"section\",\"security\",\"seed\",\"seek\",\"segment\",\"select\",\"sell\",\"seminar\",\"senior\",\"sense\",\"sentence\",\"series\",\"service\",\"session\",\"settle\",\"setup\",\"seven\",\"shadow\",\"shaft\",\"shallow\",\"share\",\"shed\",\"shell\",\"sheriff\",\"shield\",\"shift\",\"shine\",\"ship\",\"shiver\",\"shock\",\"shoe\",\"shoot\",\"shop\",\"short\",\"shoulder\",\"shove\",\"shrimp\",\"shrug\",\"shuffle\",\"shy\",\"sibling\",\"sick\",\"side\",\"siege\",\"sight\",\"sign\",\"silent\",\"silk\",\"silly\",\"silver\",\"similar\",\"simple\",\"since\",\"sing\",\"siren\",\"sister\",\"situate\",\"six\",\"size\",\"skate\",\"sketch\",\"ski\",\"skill\",\"skin\",\"skirt\",\"skull\",\"slab\",\"slam\",\"sleep\",\"slender\",\"slice\",\"slide\",\"slight\",\"slim\",\"slogan\",\"slot\",\"slow\",\"slush\",\"small\",\"smart\",\"smile\",\"smoke\",\"smooth\",\"snack\",\"snake\",\"snap\",\"sniff\",\"snow\",\"soap\",\"soccer\",\"social\",\"sock\",\"soda\",\"soft\",\"solar\",\"soldier\",\"solid\",\"solution\",\"solve\",\"someone\",\"song\",\"soon\",\"sorry\",\"sort\",\"soul\",\"sound\",\"soup\",\"source\",\"south\",\"space\",\"spare\",\"spatial\",\"spawn\",\"speak\",\"special\",\"speed\",\"spell\",\"spend\",\"sphere\",\"spice\",\"spider\",\"spike\",\"spin\",\"spirit\",\"split\",\"spoil\",\"sponsor\",\"spoon\",\"sport\",\"spot\",\"spray\",\"spread\",\"spring\",\"spy\",\"square\",\"squeeze\",\"squirrel\",\"stable\",\"stadium\",\"staff\",\"stage\",\"stairs\",\"stamp\",\"stand\",\"start\",\"state\",\"stay\",\"steak\",\"steel\",\"stem\",\"step\",\"stereo\",\"stick\",\"still\",\"sting\",\"stock\",\"stomach\",\"stone\",\"stool\",\"story\",\"stove\",\"strategy\",\"street\",\"strike\",\"strong\",\"struggle\",\"student\",\"stuff\",\"stumble\",\"style\",\"subject\",\"submit\",\"subway\",\"success\",\"such\",\"sudden\",\"suffer\",\"sugar\",\"suggest\",\"suit\",\"summer\",\"sun\",\"sunny\",\"sunset\",\"super\",\"supply\",\"supreme\",\"sure\",\"surface\",\"surge\",\"surprise\",\"surround\",\"survey\",\"suspect\",\"sustain\",\"swallow\",\"swamp\",\"swap\",\"swarm\",\"swear\",\"sweet\",\"swift\",\"swim\",\"swing\",\"switch\",\"sword\",\"symbol\",\"symptom\",\"syrup\",\"system\",\"table\",\"tackle\",\"tag\",\"tail\",\"talent\",\"talk\",\"tank\",\"tape\",\"target\",\"task\",\"taste\",\"tattoo\",\"taxi\",\"teach\",\"team\",\"tell\",\"ten\",\"tenant\",\"tennis\",\"tent\",\"term\",\"test\",\"text\",\"thank\",\"that\",\"theme\",\"then\",\"theory\",\"there\",\"they\",\"thing\",\"this\",\"thought\",\"three\",\"thrive\",\"throw\",\"thumb\",\"thunder\",\"ticket\",\"tide\",\"tiger\",\"tilt\",\"timber\",\"time\",\"tiny\",\"tip\",\"tired\",\"tissue\",\"title\",\"toast\",\"tobacco\",\"today\",\"toddler\",\"toe\",\"together\",\"toilet\",\"token\",\"tomato\",\"tomorrow\",\"tone\",\"tongue\",\"tonight\",\"tool\",\"tooth\",\"top\",\"topic\",\"topple\",\"torch\",\"tornado\",\"tortoise\",\"toss\",\"total\",\"tourist\",\"toward\",\"tower\",\"town\",\"toy\",\"track\",\"trade\",\"traffic\",\"tragic\",\"train\",\"transfer\",\"trap\",\"trash\",\"travel\",\"tray\",\"treat\",\"tree\",\"trend\",\"trial\",\"tribe\",\"trick\",\"trigger\",\"trim\",\"trip\",\"trophy\",\"trouble\",\"truck\",\"true\",\"truly\",\"trumpet\",\"trust\",\"truth\",\"try\",\"tube\",\"tuition\",\"tumble\",\"tuna\",\"tunnel\",\"turkey\",\"turn\",\"turtle\",\"twelve\",\"twenty\",\"twice\",\"twin\",\"twist\",\"two\",\"type\",\"typical\",\"ugly\",\"umbrella\",\"unable\",\"unaware\",\"uncle\",\"uncover\",\"under\",\"undo\",\"unfair\",\"unfold\",\"unhappy\",\"uniform\",\"unique\",\"unit\",\"universe\",\"unknown\",\"unlock\",\"until\",\"unusual\",\"unveil\",\"update\",\"upgrade\",\"uphold\",\"upon\",\"upper\",\"upset\",\"urban\",\"urge\",\"usage\",\"use\",\"used\",\"useful\",\"useless\",\"usual\",\"utility\",\"vacant\",\"vacuum\",\"vague\",\"valid\",\"valley\",\"valve\",\"van\",\"vanish\",\"vapor\",\"various\",\"vast\",\"vault\",\"vehicle\",\"velvet\",\"vendor\",\"venture\",\"venue\",\"verb\",\"verify\",\"version\",\"very\",\"vessel\",\"veteran\",\"viable\",\"vibrant\",\"vicious\",\"victory\",\"video\",\"view\",\"village\",\"vintage\",\"violin\",\"virtual\",\"virus\",\"visa\",\"visit\",\"visual\",\"vital\",\"vivid\",\"vocal\",\"voice\",\"void\",\"volcano\",\"volume\",\"vote\",\"voyage\",\"wage\",\"wagon\",\"wait\",\"walk\",\"wall\",\"walnut\",\"want\",\"warfare\",\"warm\",\"warrior\",\"wash\",\"wasp\",\"waste\",\"water\",\"wave\",\"way\",\"wealth\",\"weapon\",\"wear\",\"weasel\",\"weather\",\"web\",\"wedding\",\"weekend\",\"weird\",\"welcome\",\"west\",\"wet\",\"whale\",\"what\",\"wheat\",\"wheel\",\"when\",\"where\",\"whip\",\"whisper\",\"wide\",\"width\",\"wife\",\"wild\",\"will\",\"win\",\"window\",\"wine\",\"wing\",\"wink\",\"winner\",\"winter\",\"wire\",\"wisdom\",\"wise\",\"wish\",\"witness\",\"wolf\",\"woman\",\"wonder\",\"wood\",\"wool\",\"word\",\"work\",\"world\",\"worry\",\"worth\",\"wrap\",\"wreck\",\"wrestle\",\"wrist\",\"write\",\"wrong\",\"yard\",\"year\",\"yellow\",\"you\",\"young\",\"youth\",\"zebra\",\"zero\",\"zone\",\"zoo\"]");

},{}],"4fmNM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ERR_NO_SUCH_STATUS_CODE = exports.MODULE_NAME = exports.METHOD_UPDATE_POLICY = void 0;
exports.updatePolicyWrapper = updatePolicyWrapper;
const consensus = require("a330902b09770e0c");
/**
 * MethodUpdatePolicy is the method name for policy updates.
 */ exports.METHOD_UPDATE_POLICY = 'keymanager.UpdatePolicy';
/**
 * ModuleName is a unique module name for the keymanager module.
 */ exports.MODULE_NAME = 'keymanager';
/**
 * ErrNoSuchStatus is the error returned when a key manager status does not
 * exist.
 */ exports.ERR_NO_SUCH_STATUS_CODE = 1;
function updatePolicyWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_UPDATE_POLICY);
}

},{"a330902b09770e0c":"6XVjL"}],"gPiTb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ERR_ENTITY_HAS_RUNTIMES_CODE = exports.ERR_RUNTIME_UPDATE_NOT_ALLOWED_CODE = exports.ERR_NODE_UPDATE_NOT_ALLOWED_CODE = exports.ERR_FORBIDDEN_CODE = exports.ERR_ENTITY_HAS_NODES_CODE = exports.ERR_NODE_CANNOT_BE_UNFROZEN_CODE = exports.ERR_NODE_EXPIRED_CODE = exports.ERR_INCORRECT_TX_SIGNER_CODE = exports.ERR_NO_SUCH_RUNTIME_CODE = exports.ERR_NO_SUCH_NODE_CODE = exports.ERR_NO_SUCH_ENTITY_CODE = exports.ERR_TEE_HARDWARE_MISMATCH_CODE = exports.ERR_BAD_CAPABILITIES_TEE_HARDWARE_CODE = exports.ERR_BAD_ENCLAVE_IDENTITY_CODE = exports.ERR_NO_ENCLAVE_FOR_RUNTIME_CODE = exports.ERR_BAD_ENTITY_FOR_RUNTIME_CODE = exports.ERR_BAD_ENTITY_FOR_NODE_CODE = exports.ERR_INVALID_SIGNATURE_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = exports.LATEST_RUNTIME_DESCRIPTOR_VERSION = exports.GOVERNANCE_MAX = exports.GOVERNANCE_CONSENSUS = exports.GOVERNANCE_RUNTIME = exports.GOVERNANCE_ENTITY = exports.GOVERNANCE_INVALID = exports.KIND_KEY_MANAGER = exports.KIND_COMPUTE = exports.KIND_INVALID = exports.GAS_OP_UPDATEKEY_MANAGER = exports.GAS_OP_RUNTIME_EPOCH_MAINTENANCE = exports.GAS_OP_REGISTER_RUNTIME = exports.GAS_OP_UNFREEZE_NODE = exports.GAS_OP_REGISTER_NODE = exports.GAS_OP_DEREGISTER_ENTITY = exports.GAS_OP_REGISTER_ENTITY = exports.METHOD_REGISTER_RUNTIME = exports.METHOD_UNFREEZE_NODE = exports.METHOD_REGISTER_NODE = exports.METHOD_DEREGISTER_ENTITY = exports.METHOD_REGISTER_ENTITY = exports.REGISTER_GENESIS_NODE_SIGNATURE_CONTEXT = exports.REGISTER_NODE_SIGNATURE_CONTEXT = exports.REGISTER_GENESIS_ENTITY_SIGNATURE_CONTEXT = exports.REGISTER_ENTITY_SIGNATURE_CONTEXT = void 0;
exports.registerEntityWrapper = registerEntityWrapper;
exports.deregisterEntityWrapper = deregisterEntityWrapper;
exports.registerNodeWrapper = registerNodeWrapper;
exports.unfreezeNodeWrapper = unfreezeNodeWrapper;
exports.registerRuntimeWrapper = registerRuntimeWrapper;
const consensus = require("f9b5173b089c3a54");
/**
 * RegisterEntitySignatureContext is the context used for entity
 * registration.
 */ exports.REGISTER_ENTITY_SIGNATURE_CONTEXT = 'oasis-core/registry: register entity';
/**
 * RegisterGenesisEntitySignatureContext is the context used for
 * entity registration in the genesis document.
 *
 * Note: This is identical to non-gensis registrations to support
 * migrating existing registrations into a new genesis document.
 */ exports.REGISTER_GENESIS_ENTITY_SIGNATURE_CONTEXT = exports.REGISTER_ENTITY_SIGNATURE_CONTEXT;
/**
 * RegisterNodeSignatureContext is the context used for node
 * registration.
 */ exports.REGISTER_NODE_SIGNATURE_CONTEXT = 'oasis-core/registry: register node';
/**
 * RegisterGenesisNodeSignatureContext is the context used for
 * node registration in the genesis document.
 *
 * Note: This is identical to non-gensis registrations to support
 * migrating existing registrations into a new genesis document.
 */ exports.REGISTER_GENESIS_NODE_SIGNATURE_CONTEXT = exports.REGISTER_NODE_SIGNATURE_CONTEXT;
/**
 * MethodRegisterEntity is the method name for entity registrations.
 */ exports.METHOD_REGISTER_ENTITY = 'registry.RegisterEntity';
/**
 * MethodDeregisterEntity is the method name for entity deregistrations.
 */ exports.METHOD_DEREGISTER_ENTITY = 'registry.DeregisterEntity';
/**
 * MethodRegisterNode is the method name for node registrations.
 */ exports.METHOD_REGISTER_NODE = 'registry.RegisterNode';
/**
 * MethodUnfreezeNode is the method name for unfreezing nodes.
 */ exports.METHOD_UNFREEZE_NODE = 'registry.UnfreezeNode';
/**
 * MethodRegisterRuntime is the method name for registering runtimes.
 */ exports.METHOD_REGISTER_RUNTIME = 'registry.RegisterRuntime';
/**
 * GasOpRegisterEntity is the gas operation identifier for entity registration.
 */ exports.GAS_OP_REGISTER_ENTITY = 'register_entity';
/**
 * GasOpDeregisterEntity is the gas operation identifier for entity deregistration.
 */ exports.GAS_OP_DEREGISTER_ENTITY = 'deregister_entity';
/**
 * GasOpRegisterNode is the gas operation identifier for entity registration.
 */ exports.GAS_OP_REGISTER_NODE = 'register_node';
/**
 * GasOpUnfreezeNode is the gas operation identifier for unfreezing nodes.
 */ exports.GAS_OP_UNFREEZE_NODE = 'unfreeze_node';
/**
 * GasOpRegisterRuntime is the gas operation identifier for runtime registration.
 */ exports.GAS_OP_REGISTER_RUNTIME = 'register_runtime';
/**
 * GasOpRuntimeEpochMaintenance is the gas operation identifier for per-epoch
 * runtime maintenance costs.
 */ exports.GAS_OP_RUNTIME_EPOCH_MAINTENANCE = 'runtime_epoch_maintenance';
/**
 * GasOpUpdateKeyManager is the gas operation identifier for key manager
 * policy updates costs.
 */ exports.GAS_OP_UPDATEKEY_MANAGER = 'update_keymanager';
/**
 * KindInvalid is an invalid runtime and should never be explicitly set.
 */ exports.KIND_INVALID = 0;
/**
 * KindCompute is a generic compute runtime.
 */ exports.KIND_COMPUTE = 1;
/**
 * KindKeyManager is a key manager runtime.
 */ exports.KIND_KEY_MANAGER = 2;
exports.GOVERNANCE_INVALID = 0;
exports.GOVERNANCE_ENTITY = 1;
exports.GOVERNANCE_RUNTIME = 2;
exports.GOVERNANCE_CONSENSUS = 3;
exports.GOVERNANCE_MAX = exports.GOVERNANCE_CONSENSUS;
/**
 * LatestRuntimeDescriptorVersion is the latest entity descriptor version that should be used
 * for all new descriptors. Using earlier versions may be rejected.
 */ exports.LATEST_RUNTIME_DESCRIPTOR_VERSION = 3;
/**
 * ModuleName is a unique module name for the registry module.
 */ exports.MODULE_NAME = 'registry';
/**
 * ErrInvalidArgument is the error returned on malformed argument(s).
 */ exports.ERR_INVALID_ARGUMENT_CODE = 1;
/**
 * ErrInvalidSignature is the error returned on an invalid signature.
 */ exports.ERR_INVALID_SIGNATURE_CODE = 2;
/**
 * ErrBadEntityForNode is the error returned when a node registration
 * with an unknown entity is attempted.
 */ exports.ERR_BAD_ENTITY_FOR_NODE_CODE = 3;
/**
 * ErrBadEntityForRuntime is the error returned when a runtime
 * attempts to register with an unknown entity.
 */ exports.ERR_BAD_ENTITY_FOR_RUNTIME_CODE = 4;
/**
 * ErrNoEnclaveForRuntime is the error returned when a TEE runtime
 * registers with no enclave IDs.
 */ exports.ERR_NO_ENCLAVE_FOR_RUNTIME_CODE = 5;
/**
 * ErrBadEnclaveIdentity is the error returned when a node tries to
 * register runtimes with wrong Enclave IDs.
 */ exports.ERR_BAD_ENCLAVE_IDENTITY_CODE = 6;
/**
 * ErrBadCapabilitiesTEEHardware is the error returned when a node tries to
 * register a runtime with bad Capabilities.TEE.Hardware.
 */ exports.ERR_BAD_CAPABILITIES_TEE_HARDWARE_CODE = 7;
/**
 * ErrTEEHardwareMismatch is the error returned when a node tries to
 * register a runtime and Capabilities.TEE.Hardware mismatches the one in
 * the registry.
 */ exports.ERR_TEE_HARDWARE_MISMATCH_CODE = 8;
/**
 * ErrNoSuchEntity is the error returned when an entity does not exist.
 */ exports.ERR_NO_SUCH_ENTITY_CODE = 9;
/**
 * ErrNoSuchNode is the error returned when an node does not exist.
 */ exports.ERR_NO_SUCH_NODE_CODE = 10;
/**
 * ErrNoSuchRuntime is the error returned when an runtime does not exist.
 */ exports.ERR_NO_SUCH_RUNTIME_CODE = 11;
/**
 * ErrIncorrectTxSigner is the error returned when the signer of the transaction
 * is not the correct one.
 */ exports.ERR_INCORRECT_TX_SIGNER_CODE = 12;
/**
 * ErrNodeExpired is the error returned when a node is expired.
 */ exports.ERR_NODE_EXPIRED_CODE = 13;
/**
 * ErrNodeCannotBeUnfrozen is the error returned when a node cannot yet be
 * unfrozen due to the freeze period not being over yet.
 */ exports.ERR_NODE_CANNOT_BE_UNFROZEN_CODE = 14;
/**
 * ErrEntityHasNodes is the error returned when an entity cannot be deregistered
 * as it still has nodes.
 */ exports.ERR_ENTITY_HAS_NODES_CODE = 15;
/**
 * ErrForbidden is the error returned when an operation is forbidden by
 * policy.
 */ exports.ERR_FORBIDDEN_CODE = 16;
/**
 * ErrNodeUpdateNotAllowed is the error returned when trying to update an existing node with
 * disallowed changes.
 */ exports.ERR_NODE_UPDATE_NOT_ALLOWED_CODE = 17;
/**
 * ErrRuntimeUpdateNotAllowed is the error returned when trying to update an existing runtime.
 */ exports.ERR_RUNTIME_UPDATE_NOT_ALLOWED_CODE = 18;
/**
 * ErrEntityHasRuntimes is the error returned when an entity cannot be deregistered as it still
 * has runtimes.
 */ exports.ERR_ENTITY_HAS_RUNTIMES_CODE = 19;
function registerEntityWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_REGISTER_ENTITY);
}
function deregisterEntityWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_DEREGISTER_ENTITY);
}
function registerNodeWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_REGISTER_NODE);
}
function unfreezeNodeWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_UNFREEZE_NODE);
}
function registerRuntimeWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_REGISTER_RUNTIME);
}

},{"f9b5173b089c3a54":"6XVjL"}],"2B2sv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ERR_NO_PROPOSER_COMMITMENT_CODE = exports.ERR_INVALID_ROUND_CODE = exports.ERR_MAJORITY_FAILURE_CODE = exports.ERR_NODE_IS_SCHEDULER_CODE = exports.ERR_TIMEOUT_NOT_CORRECT_ROUND_CODE = exports.ERR_INVALID_MESSAGES_CODE = exports.ERR_BAD_EXECUTOR_COMMITMENT_CODE = exports.ERR_INSUFFICIENT_VOTES_CODE = exports.ERR_STILL_WAITING_CODE = exports.ERR_DISCREPANCY_DETECTED_CODE = exports.ERR_NOT_BASED_ON_CORRECT_BLOCK_CODE = exports.ERR_ALREADY_COMMITTED_CODE = exports.ERR_NOT_IN_COMMITTEE_CODE = exports.ERR_RAK_SIG_INVALID_CODE = exports.ERR_INVALID_COMMITTEE_KIND_CODE = exports.ERR_NO_COMMITTEE_CODE = exports.ERR_NO_RUNTIME_CODE = exports.COMMITMENT_MODULE_NAME = exports.ERR_MAX_IN_MESSAGES_TOO_BIG_CODE = exports.ERR_INCOMING_MESSAGE_INSUFFICIENT_FEE_CODE = exports.ERR_INCOMING_MESSAGE_QUEUE_FULL_CODE = exports.ERR_INVALID_EVIDENCE_CODE = exports.ERR_DUPLICATE_EVIDENCE_CODE = exports.ERR_RUNTIME_DOES_NOT_SLASH_CODE = exports.ERR_MAX_MESSAGES_TOO_BIG_CODE = exports.ERR_PROPOSER_TIMEOUT_NOT_ALLOWED_CODE = exports.ERR_RUNTIME_SUSPENDED_CODE = exports.ERR_NO_EXECUTOR_POOL_CODE = exports.ERR_INVALID_RUNTIME_CODE = exports.ERR_NOT_FOUND_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = exports.FAILURE_STORAGE_UNAVAILABLE = exports.FAILURE_UNKNOWN = exports.FAILURE_NONE = exports.SUSPENDED = exports.EPOCH_TRANSITION = exports.ROUND_FAILED = exports.NORMAL = exports.INVALID = exports.GAS_OP_SUBMIT_MSG = exports.GAS_OP_EVIDENCE = exports.GAS_OP_PROPOSER_TIMEOUT = exports.GAS_OP_COMPUTE_COMMIT = exports.METHOD_SUBMIT_MSG = exports.METHOD_EVIDENCE = exports.METHOD_EXECUTOR_COMMIT = exports.PROPOSAL_SIGNATURE_CONTEXT = exports.COMPUTE_RESULTS_HEADER_SIGNATURE_CONTEXT = exports.EXECUTOR_SIGNATURE_CONTEXT = void 0;
exports.ERR_BAD_PROPOSER_COMMITMENT_CODE = void 0;
exports.verifyExecutorCommitment = verifyExecutorCommitment;
exports.signExecutorCommitment = signExecutorCommitment;
exports.verifyComputeResultsHeader = verifyComputeResultsHeader;
exports.signComputeResultsHeader = signComputeResultsHeader;
exports.verifyProposal = verifyProposal;
exports.signProposal = signProposal;
exports.executorCommitWrapper = executorCommitWrapper;
exports.evidenceWrapper = evidenceWrapper;
exports.submitMsgWrapper = submitMsgWrapper;
const consensus = require("c59e80cf516a049");
const misc = require("a34dcdb035dea7f");
const signature = require("d0153d9fde8971eb");
/**
 * ExecutorSignatureContext is the signature context used to sign executor
 * worker commitments.
 */ exports.EXECUTOR_SIGNATURE_CONTEXT = 'oasis-core/roothash: executor commitment';
/**
 * ComputeResultsHeaderSignatureContext is the signature context used to
 * sign compute results headers with RAK.
 */ exports.COMPUTE_RESULTS_HEADER_SIGNATURE_CONTEXT = 'oasis-core/roothash: compute results header';
/**
 * ProposalSignatureContext is the context used for signing propose batch dispatch messages.
 */ exports.PROPOSAL_SIGNATURE_CONTEXT = 'oasis-core/roothash: proposal';
/**
 * MethodExecutorCommit is the method name for executor commit submission.
 */ exports.METHOD_EXECUTOR_COMMIT = 'roothash.ExecutorCommit';
/**
 * MethodEvidence is the method name for submitting evidence of node misbehavior.
 */ exports.METHOD_EVIDENCE = 'roothash.Evidence';
/**
 * MethodSubmitMsg is the method name for queuing incoming runtime messages.
 */ exports.METHOD_SUBMIT_MSG = 'roothash.SubmitMsg';
/**
 * GasOpComputeCommit is the gas operation identifier for compute commits.
 */ exports.GAS_OP_COMPUTE_COMMIT = 'compute_commit';
/**
 * GasOpProposerTimeout is the gas operation identifier for executor propose timeout cost.
 */ exports.GAS_OP_PROPOSER_TIMEOUT = 'proposer_timeout';
/**
 * GasOpEvidence is the gas operation identifier for evidence submission transaction cost.
 */ exports.GAS_OP_EVIDENCE = 'evidence';
/**
 * GasOpSubmitMsg is the gas operation identifier for message submission transaction cost.
 */ exports.GAS_OP_SUBMIT_MSG = 'submit_msg';
/**
 * Invalid is an invalid header type and should never be stored.
 */ exports.INVALID = 0;
/**
 * Normal is a normal header.
 */ exports.NORMAL = 1;
/**
 * RoundFailed is a header resulting from a failed round. Such a
 * header contains no transactions but advances the round as normal
 * to prevent replays of old commitments.
 */ exports.ROUND_FAILED = 2;
/**
 * EpochTransition is a header resulting from an epoch transition.
 *
 * Such a header contains no transactions but advances the round as
 * normal.
 * TODO: Consider renaming this to CommitteeTransition.
 */ exports.EPOCH_TRANSITION = 3;
/**
 * Suspended is a header resulting from the runtime being suspended.
 *
 * Such a header contains no transactions but advances the round as
 * normal.
 */ exports.SUSPENDED = 4;
/**
 * FailureNone indicates that no failure has occurred.
 */ exports.FAILURE_NONE = 0;
/**
 * FailureUnknown indicates a generic failure.
 */ exports.FAILURE_UNKNOWN = 1;
/**
 * FailureStorageUnavailable indicates that batch processing failed due to
 * storage being unavailable.
 */ exports.FAILURE_STORAGE_UNAVAILABLE = 2;
/**
 * ModuleName is a unique module name for the roothash module.
 */ exports.MODULE_NAME = 'roothash';
/**
 * ErrInvalidArgument is the error returned on malformed argument(s).
 */ exports.ERR_INVALID_ARGUMENT_CODE = 1;
/**
 * ErrNotFound is the error returned when a block is not found.
 */ exports.ERR_NOT_FOUND_CODE = 2;
/**
 * ErrInvalidRuntime is the error returned when the passed runtime is invalid.
 */ exports.ERR_INVALID_RUNTIME_CODE = 3;
/**
 * ErrNoExecutorPool is the error returned when there is no executor pool.
 */ exports.ERR_NO_EXECUTOR_POOL_CODE = 4;
/**
 * ErrRuntimeSuspended is the error returned when the passed runtime is suspended.
 */ exports.ERR_RUNTIME_SUSPENDED_CODE = 5;
/**
 * ErrProposerTimeoutNotAllowed is the error returned when proposer timeout is not allowed.
 */ exports.ERR_PROPOSER_TIMEOUT_NOT_ALLOWED_CODE = 6;
/**
 * ErrMaxMessagesTooBig is the error returned when the MaxMessages parameter is set to a value
 * larger than the MaxRuntimeMessages specified in consensus parameters.
 */ exports.ERR_MAX_MESSAGES_TOO_BIG_CODE = 7;
/**
 * ErrRuntimeDoesNotSlash is the error returned when misbehaviour evidence is submitted for a
 * runtime that does not slash.
 */ exports.ERR_RUNTIME_DOES_NOT_SLASH_CODE = 8;
/**
 * ErrDuplicateEvidence is the error returned when submitting already existing evidence.
 */ exports.ERR_DUPLICATE_EVIDENCE_CODE = 9;
/**
 * ErrInvalidEvidence is the error returned when an invalid evidence is submitted.
 */ exports.ERR_INVALID_EVIDENCE_CODE = 10;
/**
 * ErrIncomingMessageQueueFull is the error returned when the incoming message queue is full.
 */ exports.ERR_INCOMING_MESSAGE_QUEUE_FULL_CODE = 11;
/**
 * ErrIncomingMessageInsufficientFee is the error returned when the provided fee is smaller than
 * the configured minimum incoming message submission fee.
 */ exports.ERR_INCOMING_MESSAGE_INSUFFICIENT_FEE_CODE = 12;
/**
 * ErrMaxInMessagesTooBig is the error returned when the MaxInMessages parameter is set to a
 * value larger than the MaxInRuntimeMessages specified in consensus parameters.
 */ exports.ERR_MAX_IN_MESSAGES_TOO_BIG_CODE = 13;
/**
 * moduleName is the module name used for namespacing errors.
 */ exports.COMMITMENT_MODULE_NAME = 'roothash/commitment';
exports.ERR_NO_RUNTIME_CODE = 1;
exports.ERR_NO_COMMITTEE_CODE = 2;
exports.ERR_INVALID_COMMITTEE_KIND_CODE = 3;
exports.ERR_RAK_SIG_INVALID_CODE = 4;
exports.ERR_NOT_IN_COMMITTEE_CODE = 5;
exports.ERR_ALREADY_COMMITTED_CODE = 6;
exports.ERR_NOT_BASED_ON_CORRECT_BLOCK_CODE = 7;
exports.ERR_DISCREPANCY_DETECTED_CODE = 8;
exports.ERR_STILL_WAITING_CODE = 9;
exports.ERR_INSUFFICIENT_VOTES_CODE = 10;
exports.ERR_BAD_EXECUTOR_COMMITMENT_CODE = 11;
exports.ERR_INVALID_MESSAGES_CODE = 13;
exports.ERR_TIMEOUT_NOT_CORRECT_ROUND_CODE = 15;
exports.ERR_NODE_IS_SCHEDULER_CODE = 16;
exports.ERR_MAJORITY_FAILURE_CODE = 17;
exports.ERR_INVALID_ROUND_CODE = 18;
exports.ERR_NO_PROPOSER_COMMITMENT_CODE = 19;
exports.ERR_BAD_PROPOSER_COMMITMENT_CODE = 20;
async function verifyExecutorCommitment(chainContext, runtimeID, commitment) {
    const context = `${signature.combineChainContext(exports.EXECUTOR_SIGNATURE_CONTEXT, chainContext)} for runtime ${misc.toHex(runtimeID)}`;
    return await signature.verify(commitment.node_id, context, misc.toCBOR(commitment.header), commitment.sig);
}
async function signExecutorCommitment(signer, chainContext, runtimeID, header) {
    const context = `${signature.combineChainContext(exports.EXECUTOR_SIGNATURE_CONTEXT, chainContext)} for runtime ${misc.toHex(runtimeID)}`;
    return await signer.sign(context, misc.toCBOR(header));
}
async function verifyComputeResultsHeader(rakPub, header, rakSig) {
    return await signature.verify(rakPub, exports.COMPUTE_RESULTS_HEADER_SIGNATURE_CONTEXT, misc.toCBOR(header), rakSig);
}
async function signComputeResultsHeader(rakSigner, header) {
    return await rakSigner.sign(exports.COMPUTE_RESULTS_HEADER_SIGNATURE_CONTEXT, misc.toCBOR(header));
}
async function verifyProposal(chainContext, runtimeID, proposal) {
    const context = `${signature.combineChainContext(exports.PROPOSAL_SIGNATURE_CONTEXT, chainContext)} for runtime ${misc.toHex(runtimeID)}`;
    return await signature.verify(proposal.node_id, context, misc.toCBOR(proposal.header), proposal.sig);
}
async function signProposal(signer, chainContext, runtimeID, header) {
    const context = `${signature.combineChainContext(exports.PROPOSAL_SIGNATURE_CONTEXT, chainContext)} for runtime ${misc.toHex(runtimeID)}`;
    return await signer.sign(context, misc.toCBOR(header));
}
function executorCommitWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_EXECUTOR_COMMIT);
}
function evidenceWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_EVIDENCE);
}
function submitMsgWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_SUBMIT_MSG);
}

},{"c59e80cf516a049":"6XVjL","a34dcdb035dea7f":"1Mc9i","d0153d9fde8971eb":"6UtA9"}],"4wpNN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HOST_PROTOCOL_ERR_NOT_READY_CODE = exports.HOST_PROTOCOL_MODULE_NAME = exports.CLIENT_ERR_NO_HOSTED_RUNTIME_CODE = exports.CLIENT_ERR_CHECK_TX_FAILED_CODE = exports.CLIENT_ERR_NOT_SYNCED_CODE = exports.CLIENT_ERR_TRANSACTION_EXPIRED_CODE = exports.CLIENT_ERR_INTERNAL_CODE = exports.CLIENT_ERR_NOT_FOUND_CODE = exports.CLIENT_MODULE_NAME = exports.CLIENT_ROUND_LATEST = void 0;
/**
 * RoundLatest is a special round number always referring to the latest round.
 */ exports.CLIENT_ROUND_LATEST = 0xffffffffffffffffn;
/**
 * ModuleName is the runtime client module name.
 */ exports.CLIENT_MODULE_NAME = 'runtime/client';
/**
 * ErrNotFound is an error returned when the item is not found.
 */ exports.CLIENT_ERR_NOT_FOUND_CODE = 1;
/**
 * ErrInternal is an error returned when an unspecified internal error occurs.
 */ exports.CLIENT_ERR_INTERNAL_CODE = 2;
/**
 * ErrTransactionExpired is an error returned when transaction expired.
 */ exports.CLIENT_ERR_TRANSACTION_EXPIRED_CODE = 3;
/**
 * ErrNotSynced is an error returned if transaction is submitted before node has finished
 * initial syncing.
 */ exports.CLIENT_ERR_NOT_SYNCED_CODE = 4;
/**
 * ErrCheckTxFailed is an error returned if the local transaction check fails.
 */ exports.CLIENT_ERR_CHECK_TX_FAILED_CODE = 5;
/**
 * ErrNoHostedRuntime is returned when the hosted runtime is not available locally.
 */ exports.CLIENT_ERR_NO_HOSTED_RUNTIME_CODE = 6;
exports.HOST_PROTOCOL_MODULE_NAME = 'rhp/internal';
/**
 * ErrNotReady is the error reported when the Runtime Host Protocol is not initialized.
 */ exports.HOST_PROTOCOL_ERR_NOT_READY_CODE = 1;

},{}],"gQCBS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_COMMITTEE_KIND = exports.KIND_COMPUTE_EXECUTOR = exports.KIND_INVALID = exports.ROLE_BACKUP_WORKER = exports.ROLE_WORKER = exports.ROLE_INVALID = void 0;
/**
 * RoleInvalid is an invalid role (should never appear on the wire).
 */ exports.ROLE_INVALID = 0;
/**
 * RoleWorker indicates the node is a worker.
 */ exports.ROLE_WORKER = 1;
/**
 * RoleBackupWorker indicates the node is a backup worker.
 */ exports.ROLE_BACKUP_WORKER = 2;
/**
 * KindInvalid is an invalid committee.
 */ exports.KIND_INVALID = 0;
/**
 * KindComputeExecutor is an executor committee.
 */ exports.KIND_COMPUTE_EXECUTOR = 1;
/**
 * MaxCommitteeKind is a dummy value used for iterating all committee kinds.
 */ exports.MAX_COMMITTEE_KIND = 2;

},{}],"4Jr43":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TOKEN_ERR_INVALID_TOKEN_VALUE_EXPONENT_CODE = exports.TOKEN_MODULE_NAME = exports.ERR_BALANCE_TOO_LOW_CODE = exports.ERR_UNDER_MIN_TRANSFER_AMOUNT_CODE = exports.ERR_UNDER_MIN_DELEGATION_AMOUNT_CODE = exports.ERR_TOO_MANY_ALLOWANCES_CODE = exports.ERR_INVALID_THRESHOLD_CODE = exports.ERR_FORBIDDEN_CODE = exports.ERR_INSUFFICIENT_STAKE_CODE = exports.ERR_INSUFFICIENT_BALANCE_CODE = exports.ERR_INVALID_SIGNATURE_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = exports.GAS_OP_WITHDRAW = exports.GAS_OP_ALLOW = exports.GAS_OP_AMEND_COMMISSION_SCHEDULE = exports.GAS_OP_RECLAIM_ESCROW = exports.GAS_OP_ADD_ESCROW = exports.GAS_OP_BURN = exports.GAS_OP_TRANSFER = exports.SLASH_RUNTIME_LIVENESS = exports.SLASH_RUNTIME_EQUIVOCATION = exports.SLASH_RUNTIME_INCORRECT_RESULTS = exports.SLASH_CONSENSUS_LIGHT_CLIENT_ATTACK = exports.SLASH_BEACON_NONPARTICIPATION = exports.SLASH_BEACON_INVALID_REVEAL = exports.SLASH_BEACON_INVALID_COMMIT = exports.SLASH_CONSENSUS_EQUIVOCATION = exports.KIND_MAX = exports.KIND_RUNTIME_KEY_MANAGER = exports.KIND_RUNTIME_COMPUTE = exports.KIND_NODE_KEY_MANAGER = exports.KIND_NODE_STORAGE = exports.KIND_NODE_COMPUTE = exports.KIND_NODE_VALIDATOR = exports.KIND_ENTITY = exports.METHOD_WITHDRAW = exports.METHOD_ALLOW = exports.METHOD_AMEND_COMMISSION_SCHEDULE = exports.METHOD_RECLAIM_ESCROW = exports.METHOD_ADD_ESCROW = exports.METHOD_BURN = exports.METHOD_TRANSFER = exports.ADDRESS_PREFIX = exports.ADDRESS_RUNTIME_V0_CONTEXT_VERSION = exports.ADDRESS_RUNTIME_V0_CONTEXT_IDENTIFIER = exports.ADDRESS_V0_CONTEXT_VERSION = exports.ADDRESS_V0_CONTEXT_IDENTIFIER = void 0;
exports.addressFromPublicKey = addressFromPublicKey;
exports.addressFromRuntimeID = addressFromRuntimeID;
exports.addressToBech32 = addressToBech32;
exports.addressFromBech32 = addressFromBech32;
exports.commonPoolAddress = commonPoolAddress;
exports.feeAccumulatorAddress = feeAccumulatorAddress;
exports.governanceDepositsAddress = governanceDepositsAddress;
exports.transferWrapper = transferWrapper;
exports.burnWrapper = burnWrapper;
exports.addEscrowWrapper = addEscrowWrapper;
exports.reclaimEscrowWrapper = reclaimEscrowWrapper;
exports.amendCommissionScheduleWrapper = amendCommissionScheduleWrapper;
exports.allowWrapper = allowWrapper;
exports.withdrawWrapper = withdrawWrapper;
const address = require("268de560fd7866ca");
const consensus = require("4c6779c2f7c0517b");
const misc = require("3032c700f44d2f83");
/**
 * AddressV0Context is the unique context for v0 staking account addresses.
 */ exports.ADDRESS_V0_CONTEXT_IDENTIFIER = 'oasis-core/address: staking';
/**
 * AddressV0Context is the unique context for v0 staking account addresses.
 */ exports.ADDRESS_V0_CONTEXT_VERSION = 0;
/**
 * AddressRuntimeV0Context is the unique context for v0 runtime account addresses.
 */ exports.ADDRESS_RUNTIME_V0_CONTEXT_IDENTIFIER = 'oasis-core/address: runtime';
/**
 * AddressRuntimeV0Context is the unique context for v0 runtime account addresses.
 */ exports.ADDRESS_RUNTIME_V0_CONTEXT_VERSION = 0;
/**
 * AddressBech32HRP is the unique human readable part of Bech32 encoded
 * staking account addresses.
 */ exports.ADDRESS_PREFIX = 'oasis';
/**
 * MethodTransfer is the method name for transfers.
 */ exports.METHOD_TRANSFER = 'staking.Transfer';
/**
 * MethodBurn is the method name for burns.
 */ exports.METHOD_BURN = 'staking.Burn';
/**
 * MethodAddEscrow is the method name for escrows.
 */ exports.METHOD_ADD_ESCROW = 'staking.AddEscrow';
/**
 * MethodReclaimEscrow is the method name for escrow reclamations.
 */ exports.METHOD_RECLAIM_ESCROW = 'staking.ReclaimEscrow';
/**
 * MethodAmendCommissionSchedule is the method name for amending commission schedules.
 */ exports.METHOD_AMEND_COMMISSION_SCHEDULE = 'staking.AmendCommissionSchedule';
/**
 * MethodAllow is the method name for setting a beneficiary allowance.
 */ exports.METHOD_ALLOW = 'staking.Allow';
/**
 * MethodWithdraw is the method name for
 */ exports.METHOD_WITHDRAW = 'staking.Withdraw';
exports.KIND_ENTITY = 0;
exports.KIND_NODE_VALIDATOR = 1;
exports.KIND_NODE_COMPUTE = 2;
exports.KIND_NODE_STORAGE = 3;
exports.KIND_NODE_KEY_MANAGER = 4;
exports.KIND_RUNTIME_COMPUTE = 5;
exports.KIND_RUNTIME_KEY_MANAGER = 6;
exports.KIND_MAX = exports.KIND_RUNTIME_KEY_MANAGER;
/**
 * SlashConsensusEquivocation is slashing due to equivocation.
 */ exports.SLASH_CONSENSUS_EQUIVOCATION = 0x00;
/**
 * SlashBeaconInvalidCommit is slashing due to invalid commit behavior.
 */ exports.SLASH_BEACON_INVALID_COMMIT = 0x01;
/**
 * SlashBeaconInvalidReveal is slashing due to invalid reveal behavior.
 */ exports.SLASH_BEACON_INVALID_REVEAL = 0x02;
/**
 * SlashBeaconNonparticipation is slashing due to nonparticipation.
 */ exports.SLASH_BEACON_NONPARTICIPATION = 0x03;
/**
 * SlashConsensusLightClientAttack is slashing due to light client attacks.
 */ exports.SLASH_CONSENSUS_LIGHT_CLIENT_ATTACK = 0x04;
/**
 * SlashRuntimeIncorrectResults is slashing due to submission of incorrect
 * results in runtime executor commitments.
 */ exports.SLASH_RUNTIME_INCORRECT_RESULTS = 0x80;
/**
 * SlashRuntimeEquivocation is slashing due to signing two different
 * executor commits or proposed batches for the same round.
 */ exports.SLASH_RUNTIME_EQUIVOCATION = 0x81;
/**
 * SlashRuntimeLiveness is slashing due to not doing the required work.
 */ exports.SLASH_RUNTIME_LIVENESS = 0x82;
/**
 * GasOpTransfer is the gas operation identifier for transfer.
 */ exports.GAS_OP_TRANSFER = 'transfer';
/**
 * GasOpBurn is the gas operation identifier for burn.
 */ exports.GAS_OP_BURN = 'burn';
/**
 * GasOpAddEscrow is the gas operation identifier for add escrow.
 */ exports.GAS_OP_ADD_ESCROW = 'add_escrow';
/**
 * GasOpReclaimEscrow is the gas operation identifier for reclaim escrow.
 */ exports.GAS_OP_RECLAIM_ESCROW = 'reclaim_escrow';
/**
 * GasOpAmendCommissionSchedule is the gas operation identifier for amend commission schedule.
 */ exports.GAS_OP_AMEND_COMMISSION_SCHEDULE = 'amend_commission_schedule';
/**
 * GasOpAllow is the gas operation identifier for allow.
 */ exports.GAS_OP_ALLOW = 'allow';
/**
 * GasOpWithdraw is the gas operation identifier for withdraw.
 */ exports.GAS_OP_WITHDRAW = 'withdraw';
/**
 * ModuleName is a unique module name for the staking module.
 */ exports.MODULE_NAME = 'staking';
/**
 * ErrInvalidArgument is the error returned on malformed arguments.
 */ exports.ERR_INVALID_ARGUMENT_CODE = 1;
/**
 * ErrInvalidSignature is the error returned on invalid signature.
 */ exports.ERR_INVALID_SIGNATURE_CODE = 2;
/**
 * ErrInsufficientBalance is the error returned when an operation
 * fails due to insufficient balance.
 */ exports.ERR_INSUFFICIENT_BALANCE_CODE = 3;
/**
 * ErrInsufficientStake is the error returned when an operation fails
 * due to insufficient stake.
 */ exports.ERR_INSUFFICIENT_STAKE_CODE = 4;
/**
 * ErrForbidden is the error returned when an operation is forbidden by
 * policy.
 */ exports.ERR_FORBIDDEN_CODE = 5;
/**
 * ErrInvalidThreshold is the error returned when an invalid threshold kind
 * is specified in a query.
 */ exports.ERR_INVALID_THRESHOLD_CODE = 6;
/**
 * ErrTooManyAllowances is the error returned when the number of allowances per account would
 * exceed the maximum allowed number.
 */ exports.ERR_TOO_MANY_ALLOWANCES_CODE = 7;
/**
 * ErrUnderMinDelegationAmount is the error returned when the given escrow
 * amount is lower than the minimum delegation amount specified in the
 * consensus parameters.
 */ exports.ERR_UNDER_MIN_DELEGATION_AMOUNT_CODE = 8;
/**
 * ErrUnderMinTransferAmount is the error returned when the given transfer
 * or burn or withdrawal amount is lower than the minimum transfer amount
 * specified in the consensus parameters.
 */ exports.ERR_UNDER_MIN_TRANSFER_AMOUNT_CODE = 9;
/**
 * ErrBalanceTooLow is the error returned when an account's balance is
 * below the minimum allowed amount.
 */ exports.ERR_BALANCE_TOO_LOW_CODE = 10;
/**
 * ModuleName is a unique module name for the staking/token module.
 */ exports.TOKEN_MODULE_NAME = 'staking/token';
/**
 * ErrInvalidTokenValueExponent is the error returned when an invalid token's
 * value base-10 exponent is specified.
 */ exports.TOKEN_ERR_INVALID_TOKEN_VALUE_EXPONENT_CODE = 1;
function addressFromPublicKey(pk) {
    return address.fromData(exports.ADDRESS_V0_CONTEXT_IDENTIFIER, exports.ADDRESS_V0_CONTEXT_VERSION, pk);
}
function addressFromRuntimeID(id) {
    return address.fromData(exports.ADDRESS_RUNTIME_V0_CONTEXT_IDENTIFIER, exports.ADDRESS_RUNTIME_V0_CONTEXT_VERSION, id);
}
function addressToBech32(addr) {
    return address.toBech32(exports.ADDRESS_PREFIX, addr);
}
function addressFromBech32(str) {
    return address.fromBech32(exports.ADDRESS_PREFIX, str);
}
/**
 * CommonPoolAddress is the common pool address.
 * The address is reserved to prevent it being accidentally used in the actual ledger.
 */ function commonPoolAddress() {
    return addressFromPublicKey(misc.fromHex('1abe11edc001ffffffffffffffffffffffffffffffffffffffffffffffffffff'));
}
/**
 * FeeAccumulatorAddress is the per-block fee accumulator address.
 * It holds all fees from txs in a block which are later disbursed to validators appropriately.
 * The address is reserved to prevent it being accidentally used in the actual ledger.
 */ function feeAccumulatorAddress() {
    return addressFromPublicKey(misc.fromHex('1abe11edfeeaccffffffffffffffffffffffffffffffffffffffffffffffffff'));
}
/**
 * GovernanceDepositsAddress is the governance deposits address.
 * This address is reserved to prevent it from being accidentally used in the actual ledger.
 */ function governanceDepositsAddress() {
    return addressFromPublicKey(misc.fromHex('1abe11eddeaccfffffffffffffffffffffffffffffffffffffffffffffffffff'));
}
function transferWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_TRANSFER);
}
function burnWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_BURN);
}
function addEscrowWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_ADD_ESCROW);
}
function reclaimEscrowWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_RECLAIM_ESCROW);
}
function amendCommissionScheduleWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_AMEND_COMMISSION_SCHEDULE);
}
function allowWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_ALLOW);
}
function withdrawWrapper() {
    return new consensus.TransactionWrapper(exports.METHOD_WITHDRAW);
}

},{"268de560fd7866ca":"4Tvi6","4c6779c2f7c0517b":"6XVjL","3032c700f44d2f83":"1Mc9i"}],"dayB8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MKVS_DB_ERR_UPGRADE_IN_PROGRESS_CODE = exports.MKVS_DB_ERR_INVALID_MULTIPART_VERSION_CODE = exports.MKVS_DB_ERR_MULTIPART_IN_PROGRESS_CODE = exports.MKVS_DB_ERR_READ_ONLY_CODE = exports.MKVS_DB_ERR_NOT_EARLIEST_CODE = exports.MKVS_DB_ERR_BAD_NAMESPACE_CODE = exports.MKVS_DB_ERR_ROOT_MUST_FOLLOW_OLD_CODE = exports.MKVS_DB_ERR_ROOT_NOT_FOUND_CODE = exports.MKVS_DB_ERR_VERSION_WENT_BACKWARDS_CODE = exports.MKVS_DB_ERR_PREVIOUS_VERSION_MISMATCH_CODE = exports.MKVS_DB_ERR_VERSION_NOT_FOUND_CODE = exports.MKVS_DB_ERR_ALREADY_FINALIZED_CODE = exports.MKVS_DB_ERR_NOT_FINALIZED_CODE = exports.MKVS_DB_ERR_WRITE_LOG_NOT_FOUND_CODE = exports.MKVS_DB_ERR_NODE_NOT_FOUND_CODE = exports.MKVS_DB_MODULE_NAME = exports.ERR_CHUNK_CORRUPTED_CODE = exports.ERR_CHUNK_PROOF_VERIFICATION_FAILED_CODE = exports.ERR_CHUNK_ALREADY_RESTORED_CODE = exports.ERR_NO_RESTORE_IN_PROGRESS_CODE = exports.ERR_RESTORE_ALREADY_IN_PROGRESS_CODE = exports.ERR_CHUNK_NOT_FOUND_CODE = exports.ERR_CHECKPOINT_NOT_FOUND_CODE = exports.MKVS_CHECKPOINT_MODULE_NAME = exports.ERR_LIMIT_REACHED_CODE = exports.ERR_UNSUPPORTED_CODE = exports.ERR_EXPECTED_ROOT_MISMATCH_CODE = exports.ERR_NO_ROOTS_CODE = exports.ERR_CANT_PROVE_CODE = exports.MODULE_NAME = exports.ROOT_TYPE_MAX = exports.ROOT_TYPE_IO = exports.ROOT_TYPE_STATE = exports.ROOT_TYPE_INVALID = exports.CHECKPOINT_VERSION = void 0;
exports.CHECKPOINT_VERSION = 1;
/**
 * RootTypeInvalid is an invalid/uninitialized root type.
 */ exports.ROOT_TYPE_INVALID = 0;
/**
 * RootTypeState is the type for state storage roots.
 */ exports.ROOT_TYPE_STATE = 1;
/**
 * RootTypeIO is the type for IO storage roots.
 */ exports.ROOT_TYPE_IO = 2;
/**
 * RootTypeMax is the number of different root types and should be kept at the last one.
 */ exports.ROOT_TYPE_MAX = 2;
/**
 * ModuleName is the storage module name.
 */ exports.MODULE_NAME = 'storage';
/**
 * ErrCantProve is the error returned when the backend is incapable
 * of generating proofs (unsupported, no key, etc).
 */ exports.ERR_CANT_PROVE_CODE = 1;
/**
 * ErrNoRoots is the error returned when the generated receipt would
 * not contain any roots.
 */ exports.ERR_NO_ROOTS_CODE = 2;
/**
 * ErrExpectedRootMismatch is the error returned when the expected root
 * does not match the computed root.
 */ exports.ERR_EXPECTED_ROOT_MISMATCH_CODE = 3;
/**
 * ErrUnsupported is the error returned when the called method is not
 * supported by the given backend.
 */ exports.ERR_UNSUPPORTED_CODE = 4;
/**
 * ErrLimitReached means that a configured limit has been reached.
 */ exports.ERR_LIMIT_REACHED_CODE = 5;
exports.MKVS_CHECKPOINT_MODULE_NAME = 'storage/mkvs/checkpoint';
/**
 * ErrCheckpointNotFound is the error when a checkpoint is not found.
 */ exports.ERR_CHECKPOINT_NOT_FOUND_CODE = 1;
/**
 * ErrChunkNotFound is the error when a chunk is not found.
 */ exports.ERR_CHUNK_NOT_FOUND_CODE = 2;
/**
 * ErrRestoreAlreadyInProgress is the error when a checkpoint restore is already in progress and
 * the caller wanted to start another restore.
 */ exports.ERR_RESTORE_ALREADY_IN_PROGRESS_CODE = 3;
/**
 * ErrNoRestoreInProgress is the error when no checkpoint restore is currently in progress.
 */ exports.ERR_NO_RESTORE_IN_PROGRESS_CODE = 4;
/**
 * ErrChunkAlreadyRestored is the error when a chunk has already been restored.
 */ exports.ERR_CHUNK_ALREADY_RESTORED_CODE = 5;
/**
 * ErrChunkProofVerificationFailed is the error when a chunk fails proof verification.
 */ exports.ERR_CHUNK_PROOF_VERIFICATION_FAILED_CODE = 6;
/**
 * ErrChunkCorrupted is the error when a chunk is corrupted.
 */ exports.ERR_CHUNK_CORRUPTED_CODE = 7;
/**
 * ModuleName is the module name.
 */ exports.MKVS_DB_MODULE_NAME = 'storage/mkvs/db';
/**
 * ErrNodeNotFound indicates that a node with the specified hash couldn't be found
 * in the database.
 */ exports.MKVS_DB_ERR_NODE_NOT_FOUND_CODE = 1;
/**
 * ErrWriteLogNotFound indicates that a write log for the specified storage hashes
 * couldn't be found.
 */ exports.MKVS_DB_ERR_WRITE_LOG_NOT_FOUND_CODE = 2;
/**
 * ErrNotFinalized indicates that the operation requires a version to be finalized
 * but the version is not yet finalized.
 */ exports.MKVS_DB_ERR_NOT_FINALIZED_CODE = 3;
/**
 * ErrAlreadyFinalized indicates that the given version has already been finalized.
 */ exports.MKVS_DB_ERR_ALREADY_FINALIZED_CODE = 4;
/**
 * ErrVersionNotFound indicates that the given version cannot be found.
 */ exports.MKVS_DB_ERR_VERSION_NOT_FOUND_CODE = 5;
/**
 * ErrPreviousVersionMismatch indicates that the version given for the old root does
 * not match the previous version.
 */ exports.MKVS_DB_ERR_PREVIOUS_VERSION_MISMATCH_CODE = 6;
/**
 * ErrVersionWentBackwards indicates that the new version is earlier than an already
 * inserted version.
 */ exports.MKVS_DB_ERR_VERSION_WENT_BACKWARDS_CODE = 7;
/**
 * ErrRootNotFound indicates that the given root cannot be found.
 */ exports.MKVS_DB_ERR_ROOT_NOT_FOUND_CODE = 8;
/**
 * ErrRootMustFollowOld indicates that the passed new root does not follow old root.
 */ exports.MKVS_DB_ERR_ROOT_MUST_FOLLOW_OLD_CODE = 9;
/**
 * ErrBadNamespace indicates that the passed namespace does not match what is
 * actually contained within the database.
 */ exports.MKVS_DB_ERR_BAD_NAMESPACE_CODE = 10;
/**
 * ErrNotEarliest indicates that the given version is not the earliest version.
 */ exports.MKVS_DB_ERR_NOT_EARLIEST_CODE = 11;
/**
 * ErrReadOnly indicates that a write operation failed due to a read-only database.
 */ exports.MKVS_DB_ERR_READ_ONLY_CODE = 12;
/**
 * ErrMultipartInProgress indicates that a multipart restore operation is already
 * in progress.
 */ exports.MKVS_DB_ERR_MULTIPART_IN_PROGRESS_CODE = 13;
/**
 * ErrInvalidMultipartVersion indicates that a Finalize, NewBatch or Commit was called with a version
 * that doesn't match the current multipart restore as set with StartMultipartRestore.
 */ exports.MKVS_DB_ERR_INVALID_MULTIPART_VERSION_CODE = 14;
/**
 * ErrUpgradeInProgress indicates that a database upgrade was started by the upgrader tool and the
 * database is therefore unusable. Run the upgrade tool to finish upgrading.
 */ exports.MKVS_DB_ERR_UPGRADE_IN_PROGRESS_CODE = 15;

},{}],"9Iba2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"247hr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ERR_BAD_DESCRIPTOR_CODE = exports.ERR_UPGRADE_NOT_FOUND_CODE = exports.ERR_UPGRADE_IN_PROGRESS_CODE = exports.ERR_ALREADY_PENDING_CODE = exports.ERR_STOP_FOR_UPGRADE_CODE = exports.MODULE_NAME = exports.LATEST_PENDING_UPGRADE_VERSION = exports.LATEST_DESCRIPTOR_VERSION = exports.INVALID_UPGRADE_HEIGHT = exports.UPGRADE_STAGE_LAST = exports.UPGRADE_STAGE_CONSENSUS = exports.UPGRADE_STAGE_STARTUP = void 0;
/**
 * UpgradeStageStartup is the startup upgrade stage, executed at the beginning of node startup.
 */ exports.UPGRADE_STAGE_STARTUP = 1;
/**
 * UpgradeStageConsensus is the upgrade stage carried out during consensus events.
 */ exports.UPGRADE_STAGE_CONSENSUS = 2;
exports.UPGRADE_STAGE_LAST = exports.UPGRADE_STAGE_CONSENSUS;
/**
 * InvalidUpgradeHeight means the upgrade epoch hasn't been reached yet.
 */ exports.INVALID_UPGRADE_HEIGHT = 0n;
/**
 * LatestDescriptorVersion is the latest upgrade descriptor version that should be used for
 * descriptors.
 */ exports.LATEST_DESCRIPTOR_VERSION = 1;
/**
 * LatestPendingUpgradeVersion is the latest pending upgrade struct version.
 */ exports.LATEST_PENDING_UPGRADE_VERSION = 1;
/**
 * ModuleName is the upgrade module name.
 */ exports.MODULE_NAME = 'upgrade';
/**
 * ErrStopForUpgrade is the error returned by the consensus upgrade function when it detects that
 * the consensus layer has reached the scheduled shutdown epoch and should be interrupted.
 */ exports.ERR_STOP_FOR_UPGRADE_CODE = 1;
/**
 * ErrAlreadyPending is the error returned from SubmitDescriptor when the specific upgrade is already pending.
 */ exports.ERR_ALREADY_PENDING_CODE = 5;
/**
 * ErrUpgradeInProgress is the error returned from CancelUpgrade when the upgrade being cancelled is already in progress.
 */ exports.ERR_UPGRADE_IN_PROGRESS_CODE = 6;
/**
 * ErrUpgradeNotFound is the error returned when the upgrade in question cannot be found.
 */ exports.ERR_UPGRADE_NOT_FOUND_CODE = 7;
/**
 * ErrBadDescriptor is the error returned when the provided descriptor is bad.
 */ exports.ERR_BAD_DESCRIPTOR_CODE = 8;

},{}],"dbLDa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.STORAGE_ERR_CANT_PAUSE_CHECKPOINTER = exports.STORAGE_ERR_RUNTIME_NOT_FOUND_CODE = exports.STORAGE_MODULE_NAME = void 0;
/**
 * ModuleName is the storage worker module name.
 */ exports.STORAGE_MODULE_NAME = 'worker/storage';
/**
 * ErrRuntimeNotFound is the error returned when the called references an unknown runtime.
 */ exports.STORAGE_ERR_RUNTIME_NOT_FOUND_CODE = 1;
/**
 * ErrCantPauseCheckpointer is the error returned when trying to pause the checkpointer without
 * setting the debug flag.
 */ exports.STORAGE_ERR_CANT_PAUSE_CHECKPOINTER = 2;

},{}],"3cfOb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "accountSlice", ()=>accountSlice);
parcelHelpers.export(exports, "accountActions", ()=>accountActions);
var _toolkit = require("utils/@reduxjs/toolkit");
const initialState = {
    address: '',
    available: null,
    debonding: null,
    delegations: null,
    total: null,
    accountError: undefined,
    transactions: [],
    transactionsError: undefined,
    loading: true,
    pendingTransactions: {
        local: [],
        testnet: [],
        mainnet: []
    },
    nonce: '0'
};
const accountSlice = (0, _toolkit.createSlice)({
    name: 'account',
    initialState,
    reducers: {
        openAccountPage (state, action) {},
        closeAccountPage (state) {},
        clearAccount (state, action) {
            Object.assign(state, initialState);
        },
        fetchAccount (state, action) {},
        accountLoaded (state, action) {
            state.accountError = undefined;
            Object.assign(state, action.payload);
        },
        accountError (state, action) {
            state.accountError = action.payload;
        },
        transactionsLoaded (state, action) {
            const { payload: { networkType, transactions } } = action;
            state.transactionsError = undefined;
            state.transactions = transactions;
            state.pendingTransactions = {
                ...state.pendingTransactions,
                [networkType]: state.pendingTransactions[networkType].filter(({ hash: pendingTxHash })=>!transactions.some(({ hash })=>pendingTxHash === hash))
            };
        },
        transactionsError (state, action) {
            state.transactionsError = action.payload;
            // TODO: keep old state if loading the same account
            state.transactions = [];
        },
        setLoading (state, action) {
            state.loading = action.payload;
        },
        addPendingTransaction (state, action) {
            const { payload: { networkType, transaction } } = action;
            if (transaction.from !== state.address && transaction.to !== state.address) return;
            state.pendingTransactions = {
                ...state.pendingTransactions,
                [networkType]: [
                    transaction,
                    ...state.pendingTransactions[networkType]
                ]
            };
        }
    }
});
const { actions: accountActions } = accountSlice;

},{"utils/@reduxjs/toolkit":"2wpnD","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dQQWe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "fatalErrorSlice", ()=>fatalErrorSlice);
parcelHelpers.export(exports, "fatalErrorActions", ()=>fatalErrorActions);
var _toolkit = require("utils/@reduxjs/toolkit");
const initialState = {};
const fatalErrorSlice = (0, _toolkit.createSlice)({
    name: 'fatalError',
    initialState,
    reducers: {
        setError (state, action) {
            state.error ??= action.payload;
        }
    }
});
const { actions: fatalErrorActions } = fatalErrorSlice;

},{"utils/@reduxjs/toolkit":"2wpnD","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eABjR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "importAccountsSlice", ()=>importAccountsSlice);
parcelHelpers.export(exports, "importAccountsActions", ()=>importAccountsActions);
var _toolkit = require("utils/@reduxjs/toolkit");
var _types = require("./types");
const initialState = {
    accounts: [],
    showAccountsSelectionModal: false,
    accountsSelectionPageNumber: 0,
    step: (0, _types.ImportAccountsStep).Idle,
    bleDevices: [],
    showBleLedgerDevicesModal: false
};
const importAccountsSlice = (0, _toolkit.createSlice)({
    name: 'importAccounts',
    initialState,
    reducers: {
        clear (state) {
            state.accounts = [];
            state.error = undefined;
            state.step = (0, _types.ImportAccountsStep).Idle;
            state.showAccountsSelectionModal = false;
            state.bleDevices = [];
            state.showBleLedgerDevicesModal = false;
        },
        enumerateDevicesFromBleLedger (state) {
            state.bleDevices = [];
            state.step = (0, _types.ImportAccountsStep).Idle;
            state.showBleLedgerDevicesModal = true;
            state.bleDevices = [];
            state.selectedBleDevice = undefined;
        },
        enumerateAccountsFromLedger (state, _action) {
            state.accounts = [];
            state.accountsSelectionPageNumber = 0;
            state.showAccountsSelectionModal = true;
            state.step = (0, _types.ImportAccountsStep).Idle;
        },
        enumerateMoreAccountsFromLedger (state, _action) {
            state.step = (0, _types.ImportAccountsStep).Idle;
        },
        enumerateAccountsFromMnemonic (state, _action) {
            state.step = (0, _types.ImportAccountsStep).Idle;
            state.accounts = [];
            state.accountsSelectionPageNumber = 0;
            state.showAccountsSelectionModal = true;
        },
        toggleAccount (state, action) {
            const account = state.accounts.find((a)=>a.address === action.payload);
            account.selected = !account.selected;
        },
        accountGenerated (state, action) {
            state.accounts.push(action.payload);
        },
        accountsListed (state, action) {
            state.accounts = action.payload;
        },
        updateAccountBalance (state, action) {
            const { address, balance } = action.payload;
            const account = state.accounts.find((a)=>a.address === address);
            if (account) account.balance = balance;
        },
        setPage (state, action) {
            state.accountsSelectionPageNumber = action.payload;
        },
        setStep (state, action) {
            state.step = action.payload;
        },
        operationFailed (state, action) {
            state.error = action.payload;
            state.step = (0, _types.ImportAccountsStep).Idle;
        },
        setBleDevices (state, { payload }) {
            state.bleDevices = payload;
        },
        setSelectedBleDevice (state, { payload }) {
            state.selectedBleDevice = payload;
        }
    }
});
const { actions: importAccountsActions } = importAccountsSlice;

},{"utils/@reduxjs/toolkit":"2wpnD","./types":"irNSx","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"irNSx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImportAccountsStep", ()=>ImportAccountsStep);
var ImportAccountsStep = /*#__PURE__*/ function(ImportAccountsStep) {
    ImportAccountsStep["Idle"] = "idle";
    ImportAccountsStep["AccessingLedger"] = "accessing_ledger";
    ImportAccountsStep["LoadingAccounts"] = "loading_accounts";
    ImportAccountsStep["LoadingBalances"] = "loading_balances";
    ImportAccountsStep["LoadingBleDevices"] = "loading_devices";
    return ImportAccountsStep;
}({});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8NDHR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "networkSlice", ()=>networkSlice);
parcelHelpers.export(exports, "networkActions", ()=>networkActions);
var _toolkit = require("utils/@reduxjs/toolkit");
const initialState = {
    ticker: '',
    chainContext: '',
    selectedNetwork: 'mainnet',
    epoch: 0,
    minimumStakingAmount: 0
};
const networkSlice = (0, _toolkit.createSlice)({
    name: 'network',
    initialState,
    reducers: {
        initializeNetwork () {},
        selectNetwork (state, action) {
            state.chainContext = initialState.chainContext;
            state.epoch = initialState.epoch;
        },
        initialNetworkSelected (state, action) {
            Object.assign(state, action.payload);
        },
        networkSelected (state, action) {
            Object.assign(state, action.payload, {
                chainContext: initialState.chainContext,
                epoch: initialState.epoch
            });
        },
        setChainContext (state, action) {
            state.chainContext = action.payload;
        },
        setEpoch (state, action) {
            state.epoch = action.payload;
        },
        getEpoch (state) {}
    }
});
const { actions: networkActions } = networkSlice;

},{"utils/@reduxjs/toolkit":"2wpnD","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"63sI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "paraTimesSlice", ()=>paraTimesSlice);
parcelHelpers.export(exports, "paraTimesActions", ()=>paraTimesActions);
var _toolkit = require("utils/@reduxjs/toolkit");
var _types = require("./types");
const initialState = {
    balance: '',
    isLoading: false,
    transactionForm: {
        amount: '',
        confirmTransfer: false,
        confirmTransferToValidator: false,
        confirmTransferToForeignAccount: false,
        defaultFeeAmount: '',
        ethPrivateKey: '',
        ethPrivateKeyRaw: '',
        feeAmount: '',
        feeGas: '',
        paraTime: undefined,
        recipient: '',
        type: undefined
    },
    transactionFormStep: (0, _types.TransactionFormSteps).TransferType
};
const paraTimesSlice = (0, _toolkit.createSlice)({
    name: 'paraTimes',
    initialState,
    reducers: {
        balanceLoaded (state, action) {
            state.balance = action.payload;
            state.isLoading = false;
        },
        clearTransactionForm (state, action) {
            state.transactionError = undefined;
            state.transactionForm = initialState.transactionForm;
            state.transactionFormStep = (0, _types.TransactionFormSteps).TransferType;
        },
        fetchBalanceUsingEthPrivateKey (state, action) {
            state.isLoading = true;
        },
        fetchBalanceUsingOasisAddress (state, action) {
            state.isLoading = true;
        },
        navigateToDeposit (state, action) {
            state.transactionForm.type = (0, _types.TransactionTypes).Deposit;
            state.transactionFormStep = (0, _types.TransactionFormSteps).ParaTimeSelection;
        },
        navigateToWithdraw (state, action) {
            state.transactionForm.type = (0, _types.TransactionTypes).Withdraw;
            state.transactionFormStep = (0, _types.TransactionFormSteps).ParaTimeSelection;
        },
        navigateToRecipient (state, action) {
            state.transactionFormStep = (0, _types.TransactionFormSteps).TransactionRecipient;
        },
        navigateToAmount (state, action) {
            state.transactionFormStep = (0, _types.TransactionFormSteps).TransactionAmount;
        },
        navigateToParaTimes (state, action) {
            state.transactionFormStep = (0, _types.TransactionFormSteps).TransferType;
        },
        navigateToConfirmation (state, action) {
            state.transactionFormStep = (0, _types.TransactionFormSteps).TransactionConfirmation;
        },
        navigateToSummary (state, action) {
            state.transactionFormStep = (0, _types.TransactionFormSteps).TransactionSummary;
        },
        setTransactionForm (state, action) {
            state.transactionForm = action.payload;
        },
        submitTransaction (state, action) {
            state.isLoading = true;
            state.transactionError = undefined;
        },
        transactionError (state, action) {
            state.isLoading = false;
            state.transactionError = action.payload;
            state.transactionFormStep = (0, _types.TransactionFormSteps).TransactionError;
        },
        transactionSubmitted (state, action) {
            state.isLoading = false;
            state.transactionFormStep = (0, _types.TransactionFormSteps).TransactionSummary;
        }
    }
});
const { actions: paraTimesActions } = paraTimesSlice;

},{"utils/@reduxjs/toolkit":"2wpnD","./types":"h4oxt","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"h4oxt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionFormSteps", ()=>TransactionFormSteps);
parcelHelpers.export(exports, "TransactionTypes", ()=>TransactionTypes);
var TransactionFormSteps = /*#__PURE__*/ function(TransactionFormSteps) {
    TransactionFormSteps["TransferType"] = "transferType";
    TransactionFormSteps["ParaTimeSelection"] = "paraTimeSelection";
    TransactionFormSteps["TransactionRecipient"] = "transactionRecipient";
    TransactionFormSteps["TransactionAmount"] = "transactionAmount";
    TransactionFormSteps["TransactionConfirmation"] = "transactionConfirmation";
    TransactionFormSteps["TransactionSummary"] = "transactionSummary";
    TransactionFormSteps["TransactionError"] = "transactionError";
    return TransactionFormSteps;
}({});
var TransactionTypes = /*#__PURE__*/ function(TransactionTypes) {
    TransactionTypes["Deposit"] = "deposit";
    TransactionTypes["Withdraw"] = "withdraw";
    return TransactionTypes;
}({});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8XKJG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "stakingSlice", ()=>stakingSlice);
parcelHelpers.export(exports, "stakingActions", ()=>stakingActions);
parcelHelpers.export(exports, "stakingReducer", ()=>stakingReducer);
var _toolkit = require("utils/@reduxjs/toolkit");
var _shuffle = require("lodash/shuffle");
var _shuffleDefault = parcelHelpers.interopDefault(_shuffle);
var _helpers = require("../../../vendors/helpers");
const initialState = {
    debondingDelegations: null,
    delegations: null,
    updateDelegationsError: undefined,
    validators: null,
    updateValidatorsError: undefined,
    selectedValidatorDetails: null,
    selectedValidator: null,
    loading: false
};
const stakingSlice = (0, _toolkit.createSlice)({
    name: 'staking',
    initialState,
    reducers: {
        setLoading (state, action) {
            state.loading = action.payload;
        },
        fetchAccount (state, action) {},
        updateValidators (state, action) {
            state.updateValidatorsError = undefined;
            state.validators = {
                ...action.payload,
                list: (0, _shuffleDefault.default)(action.payload.list).sort((0, _helpers.sortByStatus))
            };
        },
        updateValidatorsError (state, action) {
            state.updateValidatorsError = action.payload.error;
            state.validators = {
                ...action.payload.validators,
                list: (0, _shuffleDefault.default)(action.payload.validators.list).sort((0, _helpers.sortByStatus))
            };
        },
        updateDelegations (state, action) {
            state.updateDelegationsError = undefined;
            state.delegations = action.payload.delegations;
            state.debondingDelegations = action.payload.debondingDelegations;
        },
        updateDelegationsError (state, action) {
            state.updateDelegationsError = action.payload;
            // TODO: keep old state if loading the same account
            state.delegations = null;
            state.debondingDelegations = null;
        },
        validatorSelected (state, action) {
            state.selectedValidator = action.payload;
            state.selectedValidatorDetails = null;
        },
        validatorDeselected (state, action) {
            state.selectedValidator = null;
            state.selectedValidatorDetails = null;
        },
        updateValidatorDetails (state, action) {
            state.selectedValidatorDetails = action.payload;
        }
    }
});
const { actions: stakingActions, reducer: stakingReducer } = stakingSlice;

},{"utils/@reduxjs/toolkit":"2wpnD","lodash/shuffle":"ljNpU","../../../vendors/helpers":"f9DGv","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ljNpU":[function(require,module,exports,__globalThis) {
var arrayShuffle = require("bf7bded3c092b610"), baseShuffle = require("4960ad7dea498d4a"), isArray = require("ca17ed3ea0e44253");
/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */ function shuffle(collection) {
    var func = isArray(collection) ? arrayShuffle : baseShuffle;
    return func(collection);
}
module.exports = shuffle;

},{"bf7bded3c092b610":"hhYKL","4960ad7dea498d4a":"j0YNv","ca17ed3ea0e44253":"a55j0"}],"hhYKL":[function(require,module,exports,__globalThis) {
var copyArray = require("d09db94671f90ed5"), shuffleSelf = require("6a7495a17809ed21");
/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */ function arrayShuffle(array) {
    return shuffleSelf(copyArray(array));
}
module.exports = arrayShuffle;

},{"d09db94671f90ed5":"aU22s","6a7495a17809ed21":"3etZp"}],"aU22s":[function(require,module,exports,__globalThis) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = copyArray;

},{}],"3etZp":[function(require,module,exports,__globalThis) {
var baseRandom = require("42a224be1069d0ad");
/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */ function shuffleSelf(array, size) {
    var index = -1, length = array.length, lastIndex = length - 1;
    size = size === undefined ? length : size;
    while(++index < size){
        var rand = baseRandom(index, lastIndex), value = array[rand];
        array[rand] = array[index];
        array[index] = value;
    }
    array.length = size;
    return array;
}
module.exports = shuffleSelf;

},{"42a224be1069d0ad":"9yw0H"}],"9yw0H":[function(require,module,exports,__globalThis) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeFloor = Math.floor, nativeRandom = Math.random;
/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */ function baseRandom(lower, upper) {
    return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}
module.exports = baseRandom;

},{}],"j0YNv":[function(require,module,exports,__globalThis) {
var shuffleSelf = require("b7c9f75b332c7e09"), values = require("10253eed6061734f");
/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */ function baseShuffle(collection) {
    return shuffleSelf(values(collection));
}
module.exports = baseShuffle;

},{"b7c9f75b332c7e09":"3etZp","10253eed6061734f":"70s18"}],"70s18":[function(require,module,exports,__globalThis) {
var baseValues = require("f4ee8afbcaba5363"), keys = require("4f6b7e914d03d8e3");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function values(object) {
    return object == null ? [] : baseValues(object, keys(object));
}
module.exports = values;

},{"f4ee8afbcaba5363":"bJIu2","4f6b7e914d03d8e3":"38R6l"}],"bJIu2":[function(require,module,exports,__globalThis) {
var arrayMap = require("2696d06e8e2fc398");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function baseValues(object, props) {
    return arrayMap(props, function(key) {
        return object[key];
    });
}
module.exports = baseValues;

},{"2696d06e8e2fc398":"dASol"}],"dASol":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"38R6l":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"827if","e8453365fdacc8da":"aNMRS","7760b47b02971dfa":"iArNx"}],"827if":[function(require,module,exports,__globalThis) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"ddirU","9cdb51ffa56f149b":"ciKXP","38cd49f1e493b3d7":"a55j0","b379831fe1873fed":"km1jv","f362a34cd8321bb7":"kfQA8","c019db5297494469":"bhxaz"}],"ddirU":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"ciKXP":[function(require,module,exports,__globalThis) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;

},{"b56e5b7d86069686":"kYYWY","bead821d6af018b5":"1Sg5A"}],"kYYWY":[function(require,module,exports,__globalThis) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"gSxFQ","b6cdbe52dcf709f8":"1Sg5A"}],"gSxFQ":[function(require,module,exports,__globalThis) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"iL5tx","9b2aaf31b7bdd837":"f63ju","46d5beb3375f8a28":"bukPn"}],"iL5tx":[function(require,module,exports,__globalThis) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"eTfQu"}],"eTfQu":[function(require,module,exports,__globalThis) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

},{"cd92e8811deaabf5":"kJOZd"}],"kJOZd":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"f63ju":[function(require,module,exports,__globalThis) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"iL5tx"}],"bukPn":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"1Sg5A":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = isObjectLike;

},{}],"a55j0":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"km1jv":[function(require,module,exports,__globalThis) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"eTfQu","a1e87b138cf75d1d":"d8TDe"}],"d8TDe":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"kfQA8":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"bhxaz":[function(require,module,exports,__globalThis) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"eABIM","903f50eb1c16d257":"lq56V","fa49853a82034c30":"kruGz"}],"eABIM":[function(require,module,exports,__globalThis) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"gSxFQ","f661b3a120d7a4cb":"1EmOS","cdd86c83797c0618":"1Sg5A"}],"1EmOS":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"lq56V":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"kruGz":[function(require,module,exports,__globalThis) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"kJOZd"}],"aNMRS":[function(require,module,exports,__globalThis) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"dsw5q","3ec652610d8dd5d3":"kPw9J"}],"dsw5q":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"kPw9J":[function(require,module,exports,__globalThis) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"fJbG3"}],"fJbG3":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"iArNx":[function(require,module,exports,__globalThis) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"lK1OS","f3db08d4d1110aaf":"1EmOS"}],"lK1OS":[function(require,module,exports,__globalThis) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"gSxFQ","3cba3c966459d528":"fZtIe"}],"fZtIe":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;

},{}],"f9DGv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sortByStatus", ()=>sortByStatus);
parcelHelpers.export(exports, "throwAPIErrors", ()=>throwAPIErrors);
var _errors = require("types/errors");
const ValidatorStatusPriority = {
    active: 1,
    unknown: 2,
    inactive: 3
};
const sortByStatus = (a, b)=>ValidatorStatusPriority[a.status] - ValidatorStatusPriority[b.status];
const throwAPIErrors = {
    fetchApi: async (info, init)=>{
        try {
            const response = await window.fetch(info, init);
            // eslint-disable-next-line no-throw-literal
            if (response.status < 200 || response.status >= 300) throw `status ${response.status}` // Re-thrown below
            ;
            return response;
        } catch (err) {
            const url = new Request(info).url;
            throw new (0, _errors.WalletError)((0, _errors.WalletErrors).IndexerAPIError, `Request failed ${url} with ${err}`, err);
        }
    }
};

},{"types/errors":"gbx4q","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gbx4q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WalletError", ()=>WalletError);
parcelHelpers.export(exports, "WalletErrors", ()=>WalletErrors);
// Adds strict type-check that a type was exhausted
// https://www.typescriptlang.org/docs/handbook/2/narrowing.html#exhaustiveness-checking
// https://stackoverflow.com/questions/41102060/typescript-extending-error-class
parcelHelpers.export(exports, "ExhaustedTypeError", ()=>ExhaustedTypeError);
parcelHelpers.export(exports, "PasswordWrongError", ()=>PasswordWrongError);
class WalletError extends Error {
    constructor(type, message, originalError){
        super(message), this.type = type, this.originalError = originalError;
    }
}
var WalletErrors = /*#__PURE__*/ function(WalletErrors) {
    WalletErrors["UnknownError"] = "unknown";
    WalletErrors["UnknownGrpcError"] = "unknown_grpc";
    WalletErrors["InvalidAddress"] = "invalid_address";
    WalletErrors["InvalidPrivateKey"] = "invalid_private_key";
    WalletErrors["InsufficientBalance"] = "insufficient_balance";
    WalletErrors["CannotSendToSelf"] = "cannot_send_to_self";
    WalletErrors["InvalidNonce"] = "invalid_nonce";
    WalletErrors["DuplicateTransaction"] = "duplicate_transaction";
    WalletErrors["NoOpenWallet"] = "no_open_wallet";
    WalletErrors["USBTransportError"] = "usb_transport_error";
    WalletErrors["USBTransportNotSupported"] = "usb_transport_not_supported";
    WalletErrors["BluetoothTransportNotSupported"] = "bluetooth_transport_not_supported";
    WalletErrors["LedgerUnknownError"] = "unknown_ledger_error";
    WalletErrors["LedgerCannotOpenOasisApp"] = "cannot_open_oasis_app";
    WalletErrors["LedgerOasisAppIsNotOpen"] = "oasis_app_is_not_open";
    WalletErrors["LedgerNoDeviceSelected"] = "no_device_selected";
    WalletErrors["LedgerTransactionRejected"] = "transaction_rejected";
    WalletErrors["LedgerAppVersionNotSupported"] = "ledger_version_not_supported";
    WalletErrors["LedgerDerivedDifferentAccount"] = "ledger_derived_different_account";
    WalletErrors["LedgerLikelyFaultyFirmware"] = "ledger_likely_faulty_firmware";
    WalletErrors["IndexerAPIError"] = "indexer_api_error";
    WalletErrors["DisconnectedError"] = "disconnected_error";
    WalletErrors["ParaTimesUnknownError"] = "para_times_unknown_error";
    return WalletErrors;
}({});
class ExhaustedTypeError extends Error {
    constructor(messagePrefix, exhaustedType){
        super(`${messagePrefix}: Expected type to be exhausted, but this type was not handled: ${JSON.stringify(exhaustedType)}`);
    }
}
class PasswordWrongError extends Error {
    constructor(){
        super('Password wrong');
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"83A9K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "contactsSlice", ()=>contactsSlice);
parcelHelpers.export(exports, "contactsActions", ()=>contactsActions);
var _toolkit = require("utils/@reduxjs/toolkit");
const initialState = {};
const contactsSlice = (0, _toolkit.createSlice)({
    name: 'contacts',
    initialState,
    reducers: {
        add (state, action) {
            state[action.payload.address] = action.payload;
        },
        update (state, action) {
            state[action.payload.address] = action.payload;
        },
        delete (state, action) {
            delete state[action.payload];
        }
    }
});
const { actions: contactsActions } = contactsSlice;

},{"utils/@reduxjs/toolkit":"2wpnD","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dpUJw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "evmAccountsSlice", ()=>evmAccountsSlice);
parcelHelpers.export(exports, "evmAccountsActions", ()=>evmAccountsActions);
var _toolkit = require("utils/@reduxjs/toolkit");
var _ethHelpers = require("../../lib/eth-helpers");
const initialState = {};
const evmAccountsSlice = (0, _toolkit.createSlice)({
    name: 'evmAccounts',
    initialState,
    reducers: {
        add (state, action) {
            const ethAddress = (0, _ethHelpers.privateToEthAddress)(action.payload.ethPrivateKey);
            state[ethAddress] = {
                ethPrivateKey: action.payload.ethPrivateKey,
                ethAddress: ethAddress
            };
        },
        delete (state, action) {
            delete state[action.payload.ethAddress];
        }
    }
});
const { actions: evmAccountsActions } = evmAccountsSlice;

},{"utils/@reduxjs/toolkit":"2wpnD","../../lib/eth-helpers":"gcAe1","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gcAe1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidEthAddress", ()=>(0, _util.isValidAddress));
parcelHelpers.export(exports, "stripHexPrefix", ()=>(0, _util.stripHexPrefix));
parcelHelpers.export(exports, "isValidEthPrivateKey", ()=>isValidEthPrivateKey);
parcelHelpers.export(exports, "isValidEthPrivateKeyLength", ()=>isValidEthPrivateKeyLength);
parcelHelpers.export(exports, "privateToEthAddress", ()=>privateToEthAddress);
parcelHelpers.export(exports, "getEvmBech32Address", ()=>getEvmBech32Address);
var _client = require("@oasisprotocol/client");
var _clientRt = require("@oasisprotocol/client-rt");
var _util = require("@ethereumjs/util");
var _helpers = require("./helpers");
const isValidEthPrivateKey = (ethPrivateKey)=>{
    try {
        return (0, _util.isValidPrivate)((0, _helpers.hex2uint)(ethPrivateKey));
    } catch  {
        return false;
    }
};
const isValidEthPrivateKeyLength = (ethPrivateKey)=>ethPrivateKey.length === 64;
const privateToEthAddress = (ethPrivateKey)=>(0, _util.toChecksumAddress)((0, _util.bytesToHex)((0, _util.privateToAddress)((0, _helpers.hex2uint)(ethPrivateKey))));
async function getEvmBech32Address(evmAddress) {
    const evmBytes = _client.misc.fromHex(evmAddress.replace('0x', ''));
    const address = await _client.address.fromData(_clientRt.address.V0_SECP256K1ETH_CONTEXT_IDENTIFIER, _clientRt.address.V0_SECP256K1ETH_CONTEXT_VERSION, evmBytes);
    const bech32Address = _clientRt.address.toBech32(address);
    return bech32Address;
}

},{"@oasisprotocol/client":"9pxEg","@oasisprotocol/client-rt":"espd1","@ethereumjs/util":"dwaV1","./helpers":"bUnFy","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"espd1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wrapper = exports.types = exports.transaction = exports.token = exports.signatureSecp256k1 = exports.rewards = exports.mraeDeoxysii = exports.evm = exports.event = exports.core = exports.contracts = exports.consensusAccounts = exports.consensus = exports.callformat = exports.address = exports.accounts = void 0;
exports.accounts = require("6332cef9fffdf06a");
exports.address = require("c9f69ca4b44d455f");
exports.callformat = require("121ac5b3540b2087");
exports.consensus = require("b63d510ded6b0455");
exports.consensusAccounts = require("1d525571edbdb36b");
exports.contracts = require("d4c479c4be826bbc");
exports.core = require("232bc956f3f1c73d");
exports.event = require("6a1d7220aa158db4");
exports.evm = require("666b6d166d411787");
exports.mraeDeoxysii = require("4347924946e7a19a");
exports.rewards = require("b2914ec0b6b4b0f1");
exports.signatureSecp256k1 = require("92591680ba9a63c5");
exports.token = require("3a3bc16de6ae9ee0");
exports.transaction = require("f6dbd98fa7fd37ab");
exports.types = require("96fa2d7c6e768803");
exports.wrapper = require("b1ed2af0ab0fc6c4");

},{"6332cef9fffdf06a":"jDKei","c9f69ca4b44d455f":"fnlZJ","121ac5b3540b2087":"hQwUl","b63d510ded6b0455":"h9vOF","1d525571edbdb36b":"khy1A","d4c479c4be826bbc":"gl6pB","232bc956f3f1c73d":"ccPZK","6a1d7220aa158db4":"2Wbrv","666b6d166d411787":"8jTT0","4347924946e7a19a":"6RnZ1","b2914ec0b6b4b0f1":"kp7xj","92591680ba9a63c5":"82BcB","3a3bc16de6ae9ee0":"jAPjX","f6dbd98fa7fd37ab":"2HIGn","96fa2d7c6e768803":"aIE0N","b1ed2af0ab0fc6c4":"eyJxF"}],"jDKei":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Wrapper = exports.EVENT_MINT_CODE = exports.EVENT_BURN_CODE = exports.EVENT_TRANSFER_CODE = exports.METHOD_DENOMINATION_INFO = exports.METHOD_ADDRESSES = exports.METHOD_BALANCES = exports.METHOD_NONCE = exports.METHOD_TRANSFER = exports.ERR_NOT_FOUND_CODE = exports.ERR_FORBIDDEN_CODE = exports.ERR_INSUFFICIENT_BALANCE_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = void 0;
exports.moduleEventHandler = moduleEventHandler;
const wrapper = require("b3665878316c8151");
/**
 * Unique module name.
 */ exports.MODULE_NAME = 'accounts';
exports.ERR_INVALID_ARGUMENT_CODE = 1;
exports.ERR_INSUFFICIENT_BALANCE_CODE = 2;
exports.ERR_FORBIDDEN_CODE = 3;
exports.ERR_NOT_FOUND_CODE = 4;
// Callable methods.
exports.METHOD_TRANSFER = 'accounts.Transfer';
// Queries.
exports.METHOD_NONCE = 'accounts.Nonce';
exports.METHOD_BALANCES = 'accounts.Balances';
exports.METHOD_ADDRESSES = 'accounts.Addresses';
exports.METHOD_DENOMINATION_INFO = 'accounts.DenominationInfo';
exports.EVENT_TRANSFER_CODE = 1;
exports.EVENT_BURN_CODE = 2;
exports.EVENT_MINT_CODE = 3;
class Wrapper extends wrapper.Base {
    constructor(runtimeID){
        super(runtimeID);
    }
    callTransfer() {
        return this.call(exports.METHOD_TRANSFER);
    }
    queryNonce() {
        return this.query(exports.METHOD_NONCE);
    }
    queryBalances() {
        return this.query(exports.METHOD_BALANCES);
    }
    queryAddresses() {
        return this.query(exports.METHOD_ADDRESSES);
    }
    queryDenominationInfo() {
        return this.query(exports.METHOD_DENOMINATION_INFO);
    }
}
exports.Wrapper = Wrapper;
function moduleEventHandler(codes) {
    return [
        exports.MODULE_NAME,
        codes
    ];
}

},{"b3665878316c8151":"eyJxF"}],"eyJxF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Base = exports.QueryWrapper = exports.TransactionWrapper = void 0;
const oasis = require("837ce983c8299deb");
const token = require("3e1a5c6b82507fb2");
const transaction = require("831626837c9123b1");
class TransactionWrapper {
    constructor(runtimeID, method){
        this.runtimeID = runtimeID;
        this.transaction = {
            v: transaction.LATEST_TRANSACTION_VERSION,
            call: {
                method,
                body: undefined
            },
            ai: {
                si: [],
                fee: {
                    amount: [
                        oasis.quantity.fromBigInt(0n),
                        token.NATIVE_DENOMINATION
                    ],
                    gas: 0n,
                    consensus_messages: 0
                }
            }
        };
        this.unverifiedTransaction = null;
    }
    setBody(body) {
        this.transaction.call.body = body;
        return this;
    }
    setSignerInfo(signerInfo) {
        this.transaction.ai.si = signerInfo;
        return this;
    }
    setFeeAmount(amount) {
        this.transaction.ai.fee.amount = amount;
        return this;
    }
    setFeeGas(gas) {
        this.transaction.ai.fee.gas = gas;
        return this;
    }
    setFeeConsensusMessages(maxMessages) {
        this.transaction.ai.fee.consensus_messages = maxMessages;
        return this;
    }
    /**
     * @param proofProviders An array of providers matching the layout of the
     * transaction's signer info.
     */ async sign(proofProviders, consensusChainContext) {
        this.unverifiedTransaction = await transaction.signUnverifiedTransaction(proofProviders, this.runtimeID, consensusChainContext, this.transaction);
    }
    async submit(nic) {
        const response = await nic.runtimeClientSubmitTx({
            runtime_id: this.runtimeID,
            data: oasis.misc.toCBOR(this.unverifiedTransaction)
        });
        const result = oasis.misc.fromCBOR(response);
        if (result.fail) throw result.fail;
        return result.ok;
    }
    async submitNoWait(nic) {
        await nic.runtimeClientSubmitTxNoWait({
            runtime_id: this.runtimeID,
            data: oasis.misc.toCBOR(this.unverifiedTransaction)
        });
    }
}
exports.TransactionWrapper = TransactionWrapper;
class QueryWrapper {
    constructor(runtimeID, method){
        this.request = {
            runtime_id: runtimeID,
            round: oasis.runtime.CLIENT_ROUND_LATEST,
            method: method,
            args: oasis.misc.toCBOR(null)
        };
    }
    setArgs(args) {
        this.request.args = oasis.misc.toCBOR(args);
        return this;
    }
    setRound(round) {
        this.request.round = round;
        return this;
    }
    async query(nic) {
        const response = await nic.runtimeClientQuery(this.request);
        return oasis.misc.fromCBOR(response.data);
    }
}
exports.QueryWrapper = QueryWrapper;
class Base {
    constructor(runtimeID){
        this.runtimeID = runtimeID;
    }
    call(method) {
        return new TransactionWrapper(this.runtimeID, method);
    }
    query(method) {
        return new QueryWrapper(this.runtimeID, method);
    }
}
exports.Base = Base;

},{"837ce983c8299deb":"9pxEg","3e1a5c6b82507fb2":"jAPjX","831626837c9123b1":"2HIGn"}],"jAPjX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NATIVE_DENOMINATION = void 0;
/**
 * Denomination in native token.
 */ exports.NATIVE_DENOMINATION = new Uint8Array();

},{}],"2HIGn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CALLFORMAT_ENCRYPTED_X25519DEOXYSII = exports.CALLFORMAT_PLAIN = exports.LATEST_TRANSACTION_VERSION = exports.SIGNATURE_CONTEXT_BASE = void 0;
exports.deriveChainContext = deriveChainContext;
exports.signAny = signAny;
exports.proveSignature = proveSignature;
exports.proveMultisig = proveMultisig;
exports.proveAny = proveAny;
exports.signUnverifiedTransaction = signUnverifiedTransaction;
exports.visitCall = visitCall;
const oasis = require("94f6f23bb2520103");
/**
 * Transaction signature domain separation context base.
 */ exports.SIGNATURE_CONTEXT_BASE = 'oasis-runtime-sdk/tx: v0';
/**
 * The latest transaction format version.
 */ exports.LATEST_TRANSACTION_VERSION = 1;
/**
 * Plain text call data.
 */ exports.CALLFORMAT_PLAIN = 0;
/**
 * Encrypted call data using X25519 for key exchange and Deoxys-II for symmetric encryption.
 */ exports.CALLFORMAT_ENCRYPTED_X25519DEOXYSII = 1;
function deriveChainContext(runtimeID, consensusChainContext) {
    return oasis.misc.toHex(oasis.hash.hash(oasis.misc.concat(runtimeID, oasis.misc.fromString(consensusChainContext))));
}
async function signAny(pk, signer, context, body) {
    if (pk.ed25519) return await signer.sign(context, body);
    else if (pk.secp256k1) return await signer.sign(context, body);
    else throw new Error('unsupported public key type');
}
async function proveSignature(spec, signer, context, body) {
    if (spec.ed25519) return {
        signature: await signer.sign(context, body)
    };
    else if (spec.secp256k1eth) return {
        signature: await signer.sign(context, body)
    };
    else throw new Error('unsupported signature address specification type');
}
async function proveMultisig(config, signerSet, context, body) {
    const signatureSet = new Array(config.signers.length);
    for(let i = 0; i < config.signers.length; i++)if (signerSet[i]) signatureSet[i] = await signAny(config.signers[i].public_key, signerSet[i], context, body);
    else signatureSet[i] = null;
    return {
        multisig: signatureSet
    };
}
async function proveAny(addressSpec, proofProvider, context, body) {
    if (addressSpec.signature) return await proveSignature(addressSpec.signature, proofProvider, context, body);
    else if (addressSpec.multisig) return await proveMultisig(addressSpec.multisig, proofProvider, context, body);
    else throw new Error('unsupported address spec type');
}
/**
 * @param proofProviders An array of providers matching the layout of the
 * transaction's signer info.
 */ async function signUnverifiedTransaction(proofProviders, runtimeID, consensusChainContext, transaction) {
    const chainContext = deriveChainContext(runtimeID, consensusChainContext);
    const context = oasis.signature.combineChainContext(exports.SIGNATURE_CONTEXT_BASE, chainContext);
    const body = oasis.misc.toCBOR(transaction);
    const authProofs = new Array(transaction.ai.si.length);
    for(let i = 0; i < transaction.ai.si.length; i++)authProofs[i] = await proveAny(transaction.ai.si[i].address_spec, proofProviders[i], context, body);
    return [
        body,
        authProofs
    ];
}
function visitCall(handlers, call) {
    if (handlers[call.method]) {
        handlers[call.method](call.body);
        return true;
    }
    return false;
}

},{"94f6f23bb2520103":"9pxEg"}],"fnlZJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.V0_MULTISIG_CONTEXT_VERSION = exports.V0_MULTISIG_CONTEXT_IDENTIFIER = exports.V0_SECP256K1ETH_CONTEXT_VERSION = exports.V0_SECP256K1ETH_CONTEXT_IDENTIFIER = void 0;
exports.fromSigspec = fromSigspec;
exports.fromMultisigConfig = fromMultisigConfig;
exports.toBech32 = toBech32;
exports.fromBech32 = fromBech32;
const secp256k1_1 = require("a047b1ebb2371fb7");
const sha3_1 = require("e2971346d498a288");
const oasis = require("4f83ba146bf21943");
exports.V0_SECP256K1ETH_CONTEXT_IDENTIFIER = 'oasis-runtime-sdk/address: secp256k1eth';
exports.V0_SECP256K1ETH_CONTEXT_VERSION = 0;
exports.V0_MULTISIG_CONTEXT_IDENTIFIER = 'oasis-runtime-sdk/address: multisig';
exports.V0_MULTISIG_CONTEXT_VERSION = 0;
function fromSigspec(spec) {
    if (spec.ed25519) return oasis.staking.addressFromPublicKey(spec.ed25519);
    else if (spec.secp256k1eth) {
        // Use a scheme such that we can compute Secp256k1 addresses from Ethereum
        // addresses as this makes things more interoperable.
        const untaggedPk = secp256k1_1.secp256k1.ProjectivePoint.fromHex(spec.secp256k1eth).toRawBytes(false).slice(1);
        const pkData = (0, sha3_1.keccak_256)(new Uint8Array(untaggedPk)).slice(12);
        return oasis.address.fromData(exports.V0_SECP256K1ETH_CONTEXT_IDENTIFIER, exports.V0_SECP256K1ETH_CONTEXT_VERSION, pkData);
    } else throw new Error('unsupported signature address specification type');
}
function fromMultisigConfig(config) {
    const configU8 = oasis.misc.toCBOR(config);
    return oasis.address.fromData(exports.V0_MULTISIG_CONTEXT_IDENTIFIER, exports.V0_MULTISIG_CONTEXT_VERSION, configU8);
}
function toBech32(addr) {
    return oasis.staking.addressToBech32(addr);
}
function fromBech32(str) {
    return oasis.staking.addressFromBech32(str);
}

},{"a047b1ebb2371fb7":"ls7Nf","e2971346d498a288":"tKV6d","4f83ba146bf21943":"9pxEg"}],"ls7Nf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.encodeToCurve = exports.hashToCurve = exports.secp256k1_hasher = exports.schnorr = exports.secp256k1 = void 0;
/**
 * NIST secp256k1. See [pdf](https://www.secg.org/sec2-v2.pdf).
 *
 * Seems to be rigid (not backdoored)
 * [as per discussion](https://bitcointalk.org/index.php?topic=289795.msg3183975#msg3183975).
 *
 * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
 * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
 * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
 * [See explanation](https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066).
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const sha2_1 = require("f7aa67302fbe5b23");
const utils_1 = require("67cb6040c05fbcf3");
const _shortw_utils_ts_1 = require("480e042ded50e520");
const hash_to_curve_ts_1 = require("6c6b8caf875dcdeb");
const modular_ts_1 = require("23253e1e9c6b0c83");
const utils_ts_1 = require("3942b6ebf1a40dcf");
const weierstrass_ts_1 = require("9f838b61b916af26");
const secp256k1P = BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f');
const secp256k1N = BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141');
const _1n = BigInt(1);
const _2n = BigInt(2);
const divNearest = (a, b)=>(a + b / _2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function sqrtMod(y) {
    const P = secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, modular_ts_1.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, modular_ts_1.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, modular_ts_1.pow2)(b9, _2n, P) * b2 % P;
    const b22 = (0, modular_ts_1.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, modular_ts_1.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, modular_ts_1.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, modular_ts_1.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, modular_ts_1.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, modular_ts_1.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, modular_ts_1.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, modular_ts_1.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, modular_ts_1.pow2)(t2, _2n, P);
    if (!Fpk1.eql(Fpk1.sqr(root), y)) throw new Error('Cannot find square root');
    return root;
}
const Fpk1 = (0, modular_ts_1.Field)(secp256k1P, undefined, undefined, {
    sqrt: sqrtMod
});
/**
 * secp256k1 curve, ECDSA and ECDH methods.
 *
 * Field: `2n**256n - 2n**32n - 2n**9n - 2n**8n - 2n**7n - 2n**6n - 2n**4n - 1n`
 *
 * @example
 * ```js
 * import { secp256k1 } from '@noble/curves/secp256k1';
 * const priv = secp256k1.utils.randomPrivateKey();
 * const pub = secp256k1.getPublicKey(priv);
 * const msg = new Uint8Array(32).fill(1); // message hash (not message) in ecdsa
 * const sig = secp256k1.sign(msg, priv); // `{prehash: true}` option is available
 * const isValid = secp256k1.verify(sig, msg, pub) === true;
 * ```
 */ exports.secp256k1 = (0, _shortw_utils_ts_1.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: Fpk1,
    n: secp256k1N,
    Gx: BigInt('55066263022277343669578718895168534326250603453777594175500187360389116729240'),
    Gy: BigInt('32670510020758816978083085130507043184471273380659243275938904335757337482424'),
    h: BigInt(1),
    lowS: true,
    endo: {
        // Endomorphism, see above
        beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
        splitScalar: (k)=>{
            const n = secp256k1N;
            const a1 = BigInt('0x3086d221a7d46bcde86c90e49284eb15');
            const b1 = -_1n * BigInt('0xe4437ed6010e88286f547fa90abfe4c3');
            const a2 = BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8');
            const b2 = a1;
            const POW_2_128 = BigInt('0x100000000000000000000000000000000'); // (2n**128n).toString(16)
            const c1 = divNearest(b2 * k, n);
            const c2 = divNearest(-b1 * k, n);
            let k1 = (0, modular_ts_1.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, modular_ts_1.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error('splitScalar: Endomorphism failed, k=' + k);
            return {
                k1neg,
                k1,
                k2neg,
                k2
            };
        }
    }
}, sha2_1.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const _0n = BigInt(0);
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const TAGGED_HASH_PREFIXES = {};
function taggedHash(tag, ...messages) {
    let tagP = TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, sha2_1.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, utils_ts_1.concatBytes)(tagH, tagH);
        TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, sha2_1.sha256)((0, utils_ts_1.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const numTo32b = (n)=>(0, utils_ts_1.numberToBytesBE)(n, 32);
const modP = (x)=>(0, modular_ts_1.mod)(x, secp256k1P);
const modN = (x)=>(0, modular_ts_1.mod)(x, secp256k1N);
const Point = exports.secp256k1.ProjectivePoint;
const GmulAdd = (Q, a, b)=>Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function schnorrGetExtPubKey(priv) {
    let d_ = exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : modN(-d_);
    return {
        scalar: scalar,
        bytes: pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function lift_x(x) {
    (0, utils_ts_1.aInRange)('x', x, _1n, secp256k1P); // Fail if x ≥ p.
    const xx = modP(x * x);
    const c = modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % _2n !== _0n) y = modP(-y); // Return the unique point P such that x(P) = x and
    const p = new Point(x, y, _1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
const num = utils_ts_1.bytesToNumberBE;
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function challenge(...args) {
    return modN(num(taggedHash('BIP0340/challenge', ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function schnorrGetPublicKey(privateKey) {
    return schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function schnorrSign(message, privateKey, auxRand = (0, utils_1.randomBytes)(32)) {
    const m = (0, utils_ts_1.ensureBytes)('message', message);
    const { bytes: px, scalar: d } = schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, utils_ts_1.ensureBytes)('auxRand', auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = numTo32b(d ^ num(taggedHash('BIP0340/aux', a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = taggedHash('BIP0340/nonce', t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = modN(num(rand)); // Let k' = int(rand) mod n
    if (k_ === _0n) throw new Error('sign failed: k is zero'); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set(numTo32b(modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!schnorrVerify(sig, m, px)) throw new Error('sign: Invalid signature produced');
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function schnorrVerify(signature, message, publicKey) {
    const sig = (0, utils_ts_1.ensureBytes)('signature', signature, 64);
    const m = (0, utils_ts_1.ensureBytes)('message', message);
    const pub = (0, utils_ts_1.ensureBytes)('publicKey', publicKey, 32);
    try {
        const P = lift_x(num(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = num(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!(0, utils_ts_1.inRange)(r, _1n, secp256k1P)) return false;
        const s = num(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!(0, utils_ts_1.inRange)(s, _1n, secp256k1N)) return false;
        const e = challenge(numTo32b(r), pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = GmulAdd(P, s, modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
/**
 * Schnorr signatures over secp256k1.
 * https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
 * @example
 * ```js
 * import { schnorr } from '@noble/curves/secp256k1';
 * const priv = schnorr.utils.randomPrivateKey();
 * const pub = schnorr.getPublicKey(priv);
 * const msg = new TextEncoder().encode('hello');
 * const sig = schnorr.sign(msg, priv);
 * const isValid = schnorr.verify(sig, msg, pub);
 * ```
 */ exports.schnorr = (()=>({
        getPublicKey: schnorrGetPublicKey,
        sign: schnorrSign,
        verify: schnorrVerify,
        utils: {
            randomPrivateKey: exports.secp256k1.utils.randomPrivateKey,
            lift_x,
            pointToBytes,
            numberToBytesBE: utils_ts_1.numberToBytesBE,
            bytesToNumberBE: utils_ts_1.bytesToNumberBE,
            taggedHash,
            mod: modular_ts_1.mod
        }
    }))();
const isoMap = /* @__PURE__ */ (()=>(0, hash_to_curve_ts_1.isogenyMap)(Fpk1, [
        // xNum
        [
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7',
            '0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581',
            '0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262',
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c'
        ],
        // xDen
        [
            '0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b',
            '0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ],
        // yNum
        [
            '0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c',
            '0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3',
            '0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931',
            '0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84'
        ],
        // yDen
        [
            '0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b',
            '0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573',
            '0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const mapSWU = /* @__PURE__ */ (()=>(0, weierstrass_ts_1.mapToCurveSimpleSWU)(Fpk1, {
        A: BigInt('0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533'),
        B: BigInt('1771'),
        Z: Fpk1.create(BigInt('-11'))
    }))();
/** Hashing / encoding to secp256k1 points / field. RFC 9380 methods. */ exports.secp256k1_hasher = (()=>(0, hash_to_curve_ts_1.createHasher)(exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x, y } = mapSWU(Fpk1.create(scalars[0]));
        return isoMap(x, y);
    }, {
        DST: 'secp256k1_XMD:SHA-256_SSWU_RO_',
        encodeDST: 'secp256k1_XMD:SHA-256_SSWU_NU_',
        p: Fpk1.ORDER,
        m: 1,
        k: 128,
        expand: 'xmd',
        hash: sha2_1.sha256
    }))();
exports.hashToCurve = (()=>exports.secp256k1_hasher.hashToCurve)();
exports.encodeToCurve = (()=>exports.secp256k1_hasher.encodeToCurve)();

},{"f7aa67302fbe5b23":"d72fr","67cb6040c05fbcf3":"a63oH","480e042ded50e520":"85m8p","6c6b8caf875dcdeb":"7oQRn","23253e1e9c6b0c83":"9tvbn","3942b6ebf1a40dcf":"40YnT","9f838b61b916af26":"4mTBv"}],"d72fr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sha512_224 = exports.sha512_256 = exports.sha384 = exports.sha512 = exports.sha224 = exports.sha256 = exports.SHA512_256 = exports.SHA512_224 = exports.SHA384 = exports.SHA512 = exports.SHA224 = exports.SHA256 = void 0;
/**
 * SHA2 hash function. A.k.a. sha256, sha384, sha512, sha512_224, sha512_256.
 * SHA256 is the fastest hash implementable in JS, even faster than Blake3.
 * Check out [RFC 4634](https://datatracker.ietf.org/doc/html/rfc4634) and
 * [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 */ const _md_ts_1 = require("2cfc2fb347b3e0d2");
const u64 = require("3208421b58a7e0bc");
const utils_ts_1 = require("8370cf7a19e8b068");
/**
 * Round constants:
 * First 32 bits of fractional parts of the cube roots of the first 64 primes 2..311)
 */ // prettier-ignore
const SHA256_K = /* @__PURE__ */ Uint32Array.from([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Reusable temporary buffer. "W" comes straight from spec. */ const SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class SHA256 extends _md_ts_1.HashMD {
    constructor(outputLen = 32){
        super(64, outputLen, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = _md_ts_1.SHA256_IV[0] | 0;
        this.B = _md_ts_1.SHA256_IV[1] | 0;
        this.C = _md_ts_1.SHA256_IV[2] | 0;
        this.D = _md_ts_1.SHA256_IV[3] | 0;
        this.E = _md_ts_1.SHA256_IV[4] | 0;
        this.F = _md_ts_1.SHA256_IV[5] | 0;
        this.G = _md_ts_1.SHA256_IV[6] | 0;
        this.H = _md_ts_1.SHA256_IV[7] | 0;
    }
    get() {
        const { A, B, C, D, E, F, G, H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = SHA256_W[i - 15];
            const W2 = SHA256_W[i - 2];
            const s0 = (0, utils_ts_1.rotr)(W15, 7) ^ (0, utils_ts_1.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, utils_ts_1.rotr)(W2, 17) ^ (0, utils_ts_1.rotr)(W2, 19) ^ W2 >>> 10;
            SHA256_W[i] = s1 + SHA256_W[i - 7] + s0 + SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A, B, C, D, E, F, G, H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, utils_ts_1.rotr)(E, 6) ^ (0, utils_ts_1.rotr)(E, 11) ^ (0, utils_ts_1.rotr)(E, 25);
            const T1 = H + sigma1 + (0, _md_ts_1.Chi)(E, F, G) + SHA256_K[i] + SHA256_W[i] | 0;
            const sigma0 = (0, utils_ts_1.rotr)(A, 2) ^ (0, utils_ts_1.rotr)(A, 13) ^ (0, utils_ts_1.rotr)(A, 22);
            const T2 = sigma0 + (0, _md_ts_1.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        (0, utils_ts_1.clean)(SHA256_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        (0, utils_ts_1.clean)(this.buffer);
    }
}
exports.SHA256 = SHA256;
class SHA224 extends SHA256 {
    constructor(){
        super(28);
        this.A = _md_ts_1.SHA224_IV[0] | 0;
        this.B = _md_ts_1.SHA224_IV[1] | 0;
        this.C = _md_ts_1.SHA224_IV[2] | 0;
        this.D = _md_ts_1.SHA224_IV[3] | 0;
        this.E = _md_ts_1.SHA224_IV[4] | 0;
        this.F = _md_ts_1.SHA224_IV[5] | 0;
        this.G = _md_ts_1.SHA224_IV[6] | 0;
        this.H = _md_ts_1.SHA224_IV[7] | 0;
    }
}
exports.SHA224 = SHA224;
// SHA2-512 is slower than sha256 in js because u64 operations are slow.
// Round contants
// First 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409
// prettier-ignore
const K512 = /* @__PURE__ */ (()=>u64.split([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
const SHA512_Kh = /* @__PURE__ */ (()=>K512[0])();
const SHA512_Kl = /* @__PURE__ */ (()=>K512[1])();
// Reusable temporary buffers
const SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class SHA512 extends _md_ts_1.HashMD {
    constructor(outputLen = 64){
        super(128, outputLen, 16, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = _md_ts_1.SHA512_IV[0] | 0;
        this.Al = _md_ts_1.SHA512_IV[1] | 0;
        this.Bh = _md_ts_1.SHA512_IV[2] | 0;
        this.Bl = _md_ts_1.SHA512_IV[3] | 0;
        this.Ch = _md_ts_1.SHA512_IV[4] | 0;
        this.Cl = _md_ts_1.SHA512_IV[5] | 0;
        this.Dh = _md_ts_1.SHA512_IV[6] | 0;
        this.Dl = _md_ts_1.SHA512_IV[7] | 0;
        this.Eh = _md_ts_1.SHA512_IV[8] | 0;
        this.El = _md_ts_1.SHA512_IV[9] | 0;
        this.Fh = _md_ts_1.SHA512_IV[10] | 0;
        this.Fl = _md_ts_1.SHA512_IV[11] | 0;
        this.Gh = _md_ts_1.SHA512_IV[12] | 0;
        this.Gl = _md_ts_1.SHA512_IV[13] | 0;
        this.Hh = _md_ts_1.SHA512_IV[14] | 0;
        this.Hl = _md_ts_1.SHA512_IV[15] | 0;
    }
    // prettier-ignore
    get() {
        const { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            SHA512_W_H[i] = view.getUint32(offset);
            SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = SHA512_W_H[i - 15] | 0;
            const W15l = SHA512_W_L[i - 15] | 0;
            const s0h = u64.rotrSH(W15h, W15l, 1) ^ u64.rotrSH(W15h, W15l, 8) ^ u64.shrSH(W15h, W15l, 7);
            const s0l = u64.rotrSL(W15h, W15l, 1) ^ u64.rotrSL(W15h, W15l, 8) ^ u64.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = SHA512_W_H[i - 2] | 0;
            const W2l = SHA512_W_L[i - 2] | 0;
            const s1h = u64.rotrSH(W2h, W2l, 19) ^ u64.rotrBH(W2h, W2l, 61) ^ u64.shrSH(W2h, W2l, 6);
            const s1l = u64.rotrSL(W2h, W2l, 19) ^ u64.rotrBL(W2h, W2l, 61) ^ u64.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = u64.add4L(s0l, s1l, SHA512_W_L[i - 7], SHA512_W_L[i - 16]);
            const SUMh = u64.add4H(SUMl, s0h, s1h, SHA512_W_H[i - 7], SHA512_W_H[i - 16]);
            SHA512_W_H[i] = SUMh | 0;
            SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = u64.rotrSH(Eh, El, 14) ^ u64.rotrSH(Eh, El, 18) ^ u64.rotrBH(Eh, El, 41);
            const sigma1l = u64.rotrSL(Eh, El, 14) ^ u64.rotrSL(Eh, El, 18) ^ u64.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = u64.add5L(Hl, sigma1l, CHIl, SHA512_Kl[i], SHA512_W_L[i]);
            const T1h = u64.add5H(T1ll, Hh, sigma1h, CHIh, SHA512_Kh[i], SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = u64.rotrSH(Ah, Al, 28) ^ u64.rotrBH(Ah, Al, 34) ^ u64.rotrBH(Ah, Al, 39);
            const sigma0l = u64.rotrSL(Ah, Al, 28) ^ u64.rotrBL(Ah, Al, 34) ^ u64.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = u64.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = u64.add3L(T1l, sigma0l, MAJl);
            Ah = u64.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = u64.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = u64.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = u64.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = u64.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = u64.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = u64.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = u64.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = u64.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        (0, utils_ts_1.clean)(SHA512_W_H, SHA512_W_L);
    }
    destroy() {
        (0, utils_ts_1.clean)(this.buffer);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
exports.SHA512 = SHA512;
class SHA384 extends SHA512 {
    constructor(){
        super(48);
        this.Ah = _md_ts_1.SHA384_IV[0] | 0;
        this.Al = _md_ts_1.SHA384_IV[1] | 0;
        this.Bh = _md_ts_1.SHA384_IV[2] | 0;
        this.Bl = _md_ts_1.SHA384_IV[3] | 0;
        this.Ch = _md_ts_1.SHA384_IV[4] | 0;
        this.Cl = _md_ts_1.SHA384_IV[5] | 0;
        this.Dh = _md_ts_1.SHA384_IV[6] | 0;
        this.Dl = _md_ts_1.SHA384_IV[7] | 0;
        this.Eh = _md_ts_1.SHA384_IV[8] | 0;
        this.El = _md_ts_1.SHA384_IV[9] | 0;
        this.Fh = _md_ts_1.SHA384_IV[10] | 0;
        this.Fl = _md_ts_1.SHA384_IV[11] | 0;
        this.Gh = _md_ts_1.SHA384_IV[12] | 0;
        this.Gl = _md_ts_1.SHA384_IV[13] | 0;
        this.Hh = _md_ts_1.SHA384_IV[14] | 0;
        this.Hl = _md_ts_1.SHA384_IV[15] | 0;
    }
}
exports.SHA384 = SHA384;
/**
 * Truncated SHA512/256 and SHA512/224.
 * SHA512_IV is XORed with 0xa5a5a5a5a5a5a5a5, then used as "intermediary" IV of SHA512/t.
 * Then t hashes string to produce result IV.
 * See `test/misc/sha2-gen-iv.js`.
 */ /** SHA512/224 IV */ const T224_IV = /* @__PURE__ */ Uint32Array.from([
    0x8c3d37c8,
    0x19544da2,
    0x73e19966,
    0x89dcd4d6,
    0x1dfab7ae,
    0x32ff9c82,
    0x679dd514,
    0x582f9fcf,
    0x0f6d2b69,
    0x7bd44da8,
    0x77e36f73,
    0x04c48942,
    0x3f9d85a8,
    0x6a1d36c8,
    0x1112e6ad,
    0x91d692a1
]);
/** SHA512/256 IV */ const T256_IV = /* @__PURE__ */ Uint32Array.from([
    0x22312194,
    0xfc2bf72c,
    0x9f555fa3,
    0xc84c64c2,
    0x2393b86b,
    0x6f53b151,
    0x96387719,
    0x5940eabd,
    0x96283ee2,
    0xa88effe3,
    0xbe5e1e25,
    0x53863992,
    0x2b0199fc,
    0x2c85b8aa,
    0x0eb72ddc,
    0x81c52ca2
]);
class SHA512_224 extends SHA512 {
    constructor(){
        super(28);
        this.Ah = T224_IV[0] | 0;
        this.Al = T224_IV[1] | 0;
        this.Bh = T224_IV[2] | 0;
        this.Bl = T224_IV[3] | 0;
        this.Ch = T224_IV[4] | 0;
        this.Cl = T224_IV[5] | 0;
        this.Dh = T224_IV[6] | 0;
        this.Dl = T224_IV[7] | 0;
        this.Eh = T224_IV[8] | 0;
        this.El = T224_IV[9] | 0;
        this.Fh = T224_IV[10] | 0;
        this.Fl = T224_IV[11] | 0;
        this.Gh = T224_IV[12] | 0;
        this.Gl = T224_IV[13] | 0;
        this.Hh = T224_IV[14] | 0;
        this.Hl = T224_IV[15] | 0;
    }
}
exports.SHA512_224 = SHA512_224;
class SHA512_256 extends SHA512 {
    constructor(){
        super(32);
        this.Ah = T256_IV[0] | 0;
        this.Al = T256_IV[1] | 0;
        this.Bh = T256_IV[2] | 0;
        this.Bl = T256_IV[3] | 0;
        this.Ch = T256_IV[4] | 0;
        this.Cl = T256_IV[5] | 0;
        this.Dh = T256_IV[6] | 0;
        this.Dl = T256_IV[7] | 0;
        this.Eh = T256_IV[8] | 0;
        this.El = T256_IV[9] | 0;
        this.Fh = T256_IV[10] | 0;
        this.Fl = T256_IV[11] | 0;
        this.Gh = T256_IV[12] | 0;
        this.Gl = T256_IV[13] | 0;
        this.Hh = T256_IV[14] | 0;
        this.Hl = T256_IV[15] | 0;
    }
}
exports.SHA512_256 = SHA512_256;
/**
 * SHA2-256 hash function from RFC 4634.
 *
 * It is the fastest JS hash, even faster than Blake3.
 * To break sha256 using birthday attack, attackers need to try 2^128 hashes.
 * BTC network is doing 2^70 hashes/sec (2^95 hashes/year) as per 2025.
 */ exports.sha256 = (0, utils_ts_1.createHasher)(()=>new SHA256());
/** SHA2-224 hash function from RFC 4634 */ exports.sha224 = (0, utils_ts_1.createHasher)(()=>new SHA224());
/** SHA2-512 hash function from RFC 4634. */ exports.sha512 = (0, utils_ts_1.createHasher)(()=>new SHA512());
/** SHA2-384 hash function from RFC 4634. */ exports.sha384 = (0, utils_ts_1.createHasher)(()=>new SHA384());
/**
 * SHA2-512/256 "truncated" hash function, with improved resistance to length extension attacks.
 * See the paper on [truncated SHA512](https://eprint.iacr.org/2010/548.pdf).
 */ exports.sha512_256 = (0, utils_ts_1.createHasher)(()=>new SHA512_256());
/**
 * SHA2-512/224 "truncated" hash function, with improved resistance to length extension attacks.
 * See the paper on [truncated SHA512](https://eprint.iacr.org/2010/548.pdf).
 */ exports.sha512_224 = (0, utils_ts_1.createHasher)(()=>new SHA512_224());

},{"2cfc2fb347b3e0d2":"1oGGZ","3208421b58a7e0bc":"l02Bz","8370cf7a19e8b068":"a63oH"}],"1oGGZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SHA512_IV = exports.SHA384_IV = exports.SHA224_IV = exports.SHA256_IV = exports.HashMD = void 0;
exports.setBigUint64 = setBigUint64;
exports.Chi = Chi;
exports.Maj = Maj;
/**
 * Internal Merkle-Damgard hash utils.
 * @module
 */ const utils_ts_1 = require("cc379660ef7fbb20");
/** Polyfill for Safari 14. https://caniuse.com/mdn-javascript_builtins_dataview_setbiguint64 */ function setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === 'function') return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
/** Choice: a ? b : c */ function Chi(a, b, c) {
    return a & b ^ ~a & c;
}
/** Majority function, true if any two inputs is true. */ function Maj(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */ class HashMD extends utils_ts_1.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, utils_ts_1.createView)(this.buffer);
    }
    update(data) {
        (0, utils_ts_1.aexists)(this);
        data = (0, utils_ts_1.toBytes)(data);
        (0, utils_ts_1.abytes)(data);
        const { view, buffer, blockLen } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, utils_ts_1.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, utils_ts_1.aexists)(this);
        (0, utils_ts_1.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer, view, blockLen, isLE } = this;
        let { pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        (0, utils_ts_1.clean)(this.buffer.subarray(pos));
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, utils_ts_1.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen should be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer, outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen, buffer, length, finished, destroyed, pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
exports.HashMD = HashMD;
/**
 * Initial SHA-2 state: fractional parts of square roots of first 16 primes 2..53.
 * Check out `test/misc/sha2-gen-iv.js` for recomputation guide.
 */ /** Initial SHA256 state. Bits 0..32 of frac part of sqrt of primes 2..19 */ exports.SHA256_IV = Uint32Array.from([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
/** Initial SHA224 state. Bits 32..64 of frac part of sqrt of primes 23..53 */ exports.SHA224_IV = Uint32Array.from([
    0xc1059ed8,
    0x367cd507,
    0x3070dd17,
    0xf70e5939,
    0xffc00b31,
    0x68581511,
    0x64f98fa7,
    0xbefa4fa4
]);
/** Initial SHA384 state. Bits 0..64 of frac part of sqrt of primes 23..53 */ exports.SHA384_IV = Uint32Array.from([
    0xcbbb9d5d,
    0xc1059ed8,
    0x629a292a,
    0x367cd507,
    0x9159015a,
    0x3070dd17,
    0x152fecd8,
    0xf70e5939,
    0x67332667,
    0xffc00b31,
    0x8eb44a87,
    0x68581511,
    0xdb0c2e0d,
    0x64f98fa7,
    0x47b5481d,
    0xbefa4fa4
]);
/** Initial SHA512 state. Bits 0..64 of frac part of sqrt of primes 2..19 */ exports.SHA512_IV = Uint32Array.from([
    0x6a09e667,
    0xf3bcc908,
    0xbb67ae85,
    0x84caa73b,
    0x3c6ef372,
    0xfe94f82b,
    0xa54ff53a,
    0x5f1d36f1,
    0x510e527f,
    0xade682d1,
    0x9b05688c,
    0x2b3e6c1f,
    0x1f83d9ab,
    0xfb41bd6b,
    0x5be0cd19,
    0x137e2179
]);

},{"cc379660ef7fbb20":"a63oH"}],"a63oH":[function(require,module,exports,__globalThis) {
"use strict";
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wrapXOFConstructorWithOpts = exports.wrapConstructorWithOpts = exports.wrapConstructor = exports.Hash = exports.nextTick = exports.swap32IfBE = exports.byteSwapIfBE = exports.swap8IfBE = exports.isLE = void 0;
exports.isBytes = isBytes;
exports.anumber = anumber;
exports.abytes = abytes;
exports.ahash = ahash;
exports.aexists = aexists;
exports.aoutput = aoutput;
exports.u8 = u8;
exports.u32 = u32;
exports.clean = clean;
exports.createView = createView;
exports.rotr = rotr;
exports.rotl = rotl;
exports.byteSwap = byteSwap;
exports.byteSwap32 = byteSwap32;
exports.bytesToHex = bytesToHex;
exports.hexToBytes = hexToBytes;
exports.asyncLoop = asyncLoop;
exports.utf8ToBytes = utf8ToBytes;
exports.bytesToUtf8 = bytesToUtf8;
exports.toBytes = toBytes;
exports.kdfInputToBytes = kdfInputToBytes;
exports.concatBytes = concatBytes;
exports.checkOpts = checkOpts;
exports.createHasher = createHasher;
exports.createOptHasher = createOptHasher;
exports.createXOFer = createXOFer;
exports.randomBytes = randomBytes;
// We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const crypto_1 = require("e89da72b7e65ef63");
/** Checks if something is Uint8Array. Be careful: nodejs Buffer will return true. */ function isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
/** Asserts something is positive integer. */ function anumber(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('positive integer expected, got ' + n);
}
/** Asserts something is Uint8Array. */ function abytes(b, ...lengths) {
    if (!isBytes(b)) throw new Error('Uint8Array expected');
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error('Uint8Array expected of length ' + lengths + ', got length=' + b.length);
}
/** Asserts something is hash */ function ahash(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash should be wrapped by utils.createHasher');
    anumber(h.outputLen);
    anumber(h.blockLen);
}
/** Asserts a hash instance has not been destroyed / finished */ function aexists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
/** Asserts output is properly-sized byte array */ function aoutput(out, instance) {
    abytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}
/** Cast u8 / u16 / u32 to u8. */ function u8(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** Cast u8 / u16 / u32 to u32. */ function u32(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
/** Zeroize a byte array. Warning: JS provides no guarantees. */ function clean(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
/** Create DataView of an array for easy byte-level manipulation. */ function createView(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
/** The rotate right (circular right shift) operation for uint32 */ function rotr(word, shift) {
    return word << 32 - shift | word >>> shift;
}
/** The rotate left (circular left shift) operation for uint32 */ function rotl(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
/** Is current platform little-endian? Most are. Big-Endian platform: IBM */ exports.isLE = (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
/** The byte swap operation for uint32 */ function byteSwap(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
/** Conditionally byte swap if on a big-endian platform */ exports.swap8IfBE = exports.isLE ? (n)=>n : (n)=>byteSwap(n);
/** @deprecated */ exports.byteSwapIfBE = exports.swap8IfBE;
/** In place byte swap for Uint32Array */ function byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = byteSwap(arr[i]);
    return arr;
}
exports.swap32IfBE = exports.isLE ? (u)=>u : byteSwap32;
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * Convert byte array to hex string. Uses built-in function, when available.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function bytesToHex(bytes) {
    abytes(bytes);
    // @ts-ignore
    if (hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function asciiToBase16(ch) {
    if (ch >= asciis._0 && ch <= asciis._9) return ch - asciis._0; // '2' => 50-48
    if (ch >= asciis.A && ch <= asciis.F) return ch - (asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= asciis.a && ch <= asciis.f) return ch - (asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * Convert hex string to byte array. Uses built-in function, when available.
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function hexToBytes(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if (hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = asciiToBase16(hex.charCodeAt(hi));
        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
/**
 * There is no setImmediate in browser and setTimeout is slow.
 * Call of async fn will return Promise, which will be fullfiled only on
 * next scheduler queue processing step and this is exactly what we need.
 */ const nextTick = async ()=>{};
exports.nextTick = nextTick;
/** Returns control to thread each 'tick' ms to avoid blocking. */ async function asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, exports.nextTick)();
        ts += diff;
    }
}
/**
 * Converts string to bytes using UTF8 encoding.
 * @example utf8ToBytes('abc') // Uint8Array.from([97, 98, 99])
 */ function utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Converts bytes to string using UTF8 encoding.
 * @example bytesToUtf8(Uint8Array.from([97, 98, 99])) // 'abc'
 */ function bytesToUtf8(bytes) {
    return new TextDecoder().decode(bytes);
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function toBytes(data) {
    if (typeof data === 'string') data = utf8ToBytes(data);
    abytes(data);
    return data;
}
/**
 * Helper for KDFs: consumes uint8array or string.
 * When string is passed, does utf8 decoding, using TextDecoder.
 */ function kdfInputToBytes(data) {
    if (typeof data === 'string') data = utf8ToBytes(data);
    abytes(data);
    return data;
}
/** Copies several Uint8Arrays into one. */ function concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function checkOpts(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== '[object Object]') throw new Error('options should be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
/** For runtime check if class implements interface */ class Hash {
}
exports.Hash = Hash;
/** Wraps hash function, creating an interface on top of it */ function createHasher(hashCons) {
    const hashC = (msg)=>hashCons().update(toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function createOptHasher(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function createXOFer(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
exports.wrapConstructor = createHasher;
exports.wrapConstructorWithOpts = createOptHasher;
exports.wrapXOFConstructorWithOpts = createXOFer;
/** Cryptographically secure PRNG. Uses internal OS-level `crypto.getRandomValues`. */ function randomBytes(bytesLength = 32) {
    if (crypto_1.crypto && typeof crypto_1.crypto.getRandomValues === 'function') return crypto_1.crypto.getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if (crypto_1.crypto && typeof crypto_1.crypto.randomBytes === 'function') return Uint8Array.from(crypto_1.crypto.randomBytes(bytesLength));
    throw new Error('crypto.getRandomValues must be defined');
}

},{"e89da72b7e65ef63":"4HfOH"}],"4HfOH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.crypto = void 0;
exports.crypto = typeof globalThis === 'object' && 'crypto' in globalThis ? globalThis.crypto : undefined;

},{}],"l02Bz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toBig = exports.shrSL = exports.shrSH = exports.rotrSL = exports.rotrSH = exports.rotrBL = exports.rotrBH = exports.rotr32L = exports.rotr32H = exports.rotlSL = exports.rotlSH = exports.rotlBL = exports.rotlBH = exports.add5L = exports.add5H = exports.add4L = exports.add4H = exports.add3L = exports.add3H = void 0;
exports.add = add;
exports.fromBig = fromBig;
exports.split = split;
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const _32n = /* @__PURE__ */ BigInt(32);
function fromBig(n, le = false) {
    if (le) return {
        h: Number(n & U32_MASK64),
        l: Number(n >> _32n & U32_MASK64)
    };
    return {
        h: Number(n >> _32n & U32_MASK64) | 0,
        l: Number(n & U32_MASK64) | 0
    };
}
function split(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for(let i = 0; i < len; i++){
        const { h, l } = fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const toBig = (h, l)=>BigInt(h >>> 0) << _32n | BigInt(l >>> 0);
exports.toBig = toBig;
// for Shift in [0, 32)
const shrSH = (h, _l, s)=>h >>> s;
exports.shrSH = shrSH;
const shrSL = (h, l, s)=>h << 32 - s | l >>> s;
exports.shrSL = shrSL;
// Right rotate for Shift in [1, 32)
const rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
exports.rotrSH = rotrSH;
const rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
exports.rotrSL = rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
exports.rotrBH = rotrBH;
const rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
exports.rotrBL = rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const rotr32H = (_h, l)=>l;
exports.rotr32H = rotr32H;
const rotr32L = (h, _l)=>h;
exports.rotr32L = rotr32L;
// Left rotate for Shift in [1, 32)
const rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
exports.rotlSH = rotlSH;
const rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
exports.rotlSL = rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
exports.rotlBH = rotlBH;
const rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
exports.rotlBL = rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
exports.add3L = add3L;
const add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
exports.add3H = add3H;
const add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
exports.add4L = add4L;
const add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
exports.add4H = add4H;
const add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
exports.add5L = add5L;
const add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
exports.add5H = add5H;
// prettier-ignore
const u64 = {
    fromBig,
    split,
    toBig,
    shrSH,
    shrSL,
    rotrSH,
    rotrSL,
    rotrBH,
    rotrBL,
    rotr32H,
    rotr32L,
    rotlSH,
    rotlSL,
    rotlBH,
    rotlBL,
    add,
    add3L,
    add3H,
    add4L,
    add4H,
    add5H,
    add5L
};
exports.default = u64;

},{}],"85m8p":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getHash = getHash;
exports.createCurve = createCurve;
/**
 * Utilities for short weierstrass curves, combined with noble-hashes.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const hmac_1 = require("d0cb7aac96c9084b");
const utils_1 = require("e40d6fee57545a4d");
const weierstrass_ts_1 = require("79e497f3378bff32");
/** connects noble-curves to noble-hashes */ function getHash(hash) {
    return {
        hash,
        hmac: (key, ...msgs)=>(0, hmac_1.hmac)(hash, key, (0, utils_1.concatBytes)(...msgs)),
        randomBytes: utils_1.randomBytes
    };
}
function createCurve(curveDef, defHash) {
    const create = (hash)=>(0, weierstrass_ts_1.weierstrass)({
            ...curveDef,
            ...getHash(hash)
        });
    return {
        ...create(defHash),
        create
    };
}

},{"d0cb7aac96c9084b":"dvPH8","e40d6fee57545a4d":"a63oH","79e497f3378bff32":"4mTBv"}],"dvPH8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hmac = exports.HMAC = void 0;
/**
 * HMAC: RFC2104 message authentication code.
 * @module
 */ const utils_ts_1 = require("635a118ee79ea6aa");
class HMAC extends utils_ts_1.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, utils_ts_1.ahash)(hash);
        const key = (0, utils_ts_1.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== 'function') throw new Error('Expected instance of class which extends utils.Hash');
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        (0, utils_ts_1.clean)(pad);
    }
    update(buf) {
        (0, utils_ts_1.aexists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, utils_ts_1.aexists)(this);
        (0, utils_ts_1.abytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash, iHash, finished, destroyed, blockLen, outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
exports.HMAC = HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 * @example
 * import { hmac } from '@noble/hashes/hmac';
 * import { sha256 } from '@noble/hashes/sha2';
 * const mac1 = hmac(sha256, 'key', 'message');
 */ const hmac = (hash, key, message)=>new HMAC(hash, key).update(message).digest();
exports.hmac = hmac;
exports.hmac.create = (hash, key)=>new HMAC(hash, key);

},{"635a118ee79ea6aa":"a63oH"}],"4mTBv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DER = exports.DERErr = void 0;
exports.weierstrassPoints = weierstrassPoints;
exports.weierstrass = weierstrass;
exports.SWUFpSqrtRatio = SWUFpSqrtRatio;
exports.mapToCurveSimpleSWU = mapToCurveSimpleSWU;
/**
 * Short Weierstrass curve methods. The formula is: y² = x³ + ax + b.
 *
 * ### Parameters
 *
 * To initialize a weierstrass curve, one needs to pass following params:
 *
 * * a: formula param
 * * b: formula param
 * * Fp: finite Field over which we'll do calculations. Can be complex (Fp2, Fp12)
 * * n: Curve prime subgroup order, total count of valid points in the field
 * * Gx: Base point (x, y) aka generator point x coordinate
 * * Gy: ...y coordinate
 * * h: cofactor, usually 1. h*n = curve group order (n is only subgroup order)
 * * lowS: whether to enable (default) or disable "low-s" non-malleable signatures
 *
 * ### Design rationale for types
 *
 * * Interaction between classes from different curves should fail:
 *   `k256.Point.BASE.add(p256.Point.BASE)`
 * * For this purpose we want to use `instanceof` operator, which is fast and works during runtime
 * * Different calls of `curve()` would return different classes -
 *   `curve(params) !== curve(params)`: if somebody decided to monkey-patch their curve,
 *   it won't affect others
 *
 * TypeScript can't infer types for classes created inside a function. Classes is one instance
 * of nominative types in TypeScript and interfaces only check for shape, so it's hard to create
 * unique type for every function call.
 *
 * We can use generic types via some param, like curve opts, but that would:
 *     1. Enable interaction between `curve(params)` and `curve(params)` (curves of same params)
 *     which is hard to debug.
 *     2. Params can be generic and we can't enforce them to be constant value:
 *     if somebody creates curve from non-constant params,
 *     it would be allowed to interact with other curves with non-constant params
 *
 * @todo https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-7.html#unique-symbol
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // prettier-ignore
const curve_ts_1 = require("45691ba029262ce5");
// prettier-ignore
const modular_ts_1 = require("a8b017b618719623");
// prettier-ignore
const utils_ts_1 = require("ddb060cf893c1e6d");
function validateSigVerOpts(opts) {
    if (opts.lowS !== undefined) (0, utils_ts_1.abool)('lowS', opts.lowS);
    if (opts.prehash !== undefined) (0, utils_ts_1.abool)('prehash', opts.prehash);
}
function validatePointOpts(curve) {
    const opts = (0, curve_ts_1.validateBasic)(curve);
    (0, utils_ts_1.validateObject)(opts, {
        a: 'field',
        b: 'field'
    }, {
        allowedPrivateKeyLengths: 'array',
        wrapPrivateKey: 'boolean',
        isTorsionFree: 'function',
        clearCofactor: 'function',
        allowInfinityPoint: 'boolean',
        fromBytes: 'function',
        toBytes: 'function'
    });
    const { endo, Fp, a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error('invalid endomorphism, can only be defined for Koblitz curves that have a=0');
        if (typeof endo !== 'object' || typeof endo.beta !== 'bigint' || typeof endo.splitScalar !== 'function') throw new Error('invalid endomorphism, expected beta: bigint and splitScalar: function');
    }
    return Object.freeze({
        ...opts
    });
}
class DERErr extends Error {
    constructor(m = ''){
        super(m);
    }
}
exports.DERErr = DERErr;
/**
 * ASN.1 DER encoding utilities. ASN is very complex & fragile. Format:
 *
 *     [0x30 (SEQUENCE), bytelength, 0x02 (INTEGER), intLength, R, 0x02 (INTEGER), intLength, S]
 *
 * Docs: https://letsencrypt.org/docs/a-warm-welcome-to-asn1-and-der/, https://luca.ntop.org/Teaching/Appunti/asn1.html
 */ exports.DER = {
    // asn.1 DER encoding utils
    Err: DERErr,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
        encode: (tag, data)=>{
            const { Err: E } = exports.DER;
            if (tag < 0 || tag > 256) throw new E('tlv.encode: wrong tag');
            if (data.length & 1) throw new E('tlv.encode: unpadded data');
            const dataLen = data.length / 2;
            const len = (0, utils_ts_1.numberToHexUnpadded)(dataLen);
            if (len.length / 2 & 128) throw new E('tlv.encode: long form length too big');
            // length of length with long form flag
            const lenLen = dataLen > 127 ? (0, utils_ts_1.numberToHexUnpadded)(len.length / 2 | 128) : '';
            const t = (0, utils_ts_1.numberToHexUnpadded)(tag);
            return t + lenLen + len + data;
        },
        // v - value, l - left bytes (unparsed)
        decode (tag, data) {
            const { Err: E } = exports.DER;
            let pos = 0;
            if (tag < 0 || tag > 256) throw new E('tlv.encode: wrong tag');
            if (data.length < 2 || data[pos++] !== tag) throw new E('tlv.decode: wrong tlv');
            const first = data[pos++];
            const isLong = !!(first & 128); // First bit of first length byte is flag for short/long form
            let length = 0;
            if (!isLong) length = first;
            else {
                // Long form: [longFlag(1bit), lengthLength(7bit), length (BE)]
                const lenLen = first & 127;
                if (!lenLen) throw new E('tlv.decode(long): indefinite length not supported');
                if (lenLen > 4) throw new E('tlv.decode(long): byte length is too big'); // this will overflow u32 in js
                const lengthBytes = data.subarray(pos, pos + lenLen);
                if (lengthBytes.length !== lenLen) throw new E('tlv.decode: length bytes not complete');
                if (lengthBytes[0] === 0) throw new E('tlv.decode(long): zero leftmost byte');
                for (const b of lengthBytes)length = length << 8 | b;
                pos += lenLen;
                if (length < 128) throw new E('tlv.decode(long): not minimal encoding');
            }
            const v = data.subarray(pos, pos + length);
            if (v.length !== length) throw new E('tlv.decode: wrong value length');
            return {
                v,
                l: data.subarray(pos + length)
            };
        }
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
        encode (num) {
            const { Err: E } = exports.DER;
            if (num < _0n) throw new E('integer: negative integers are not allowed');
            let hex = (0, utils_ts_1.numberToHexUnpadded)(num);
            // Pad with zero byte if negative flag is present
            if (Number.parseInt(hex[0], 16) & 8) hex = '00' + hex;
            if (hex.length & 1) throw new E('unexpected DER parsing assertion: unpadded hex');
            return hex;
        },
        decode (data) {
            const { Err: E } = exports.DER;
            if (data[0] & 128) throw new E('invalid signature integer: negative');
            if (data[0] === 0x00 && !(data[1] & 128)) throw new E('invalid signature integer: unnecessary leading zero');
            return (0, utils_ts_1.bytesToNumberBE)(data);
        }
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E, _int: int, _tlv: tlv } = exports.DER;
        const data = (0, utils_ts_1.ensureBytes)('signature', hex);
        const { v: seqBytes, l: seqLeftBytes } = tlv.decode(0x30, data);
        if (seqLeftBytes.length) throw new E('invalid signature: left bytes after parsing');
        const { v: rBytes, l: rLeftBytes } = tlv.decode(0x02, seqBytes);
        const { v: sBytes, l: sLeftBytes } = tlv.decode(0x02, rLeftBytes);
        if (sLeftBytes.length) throw new E('invalid signature: left bytes after parsing');
        return {
            r: int.decode(rBytes),
            s: int.decode(sBytes)
        };
    },
    hexFromSig (sig) {
        const { _tlv: tlv, _int: int } = exports.DER;
        const rs = tlv.encode(0x02, int.encode(sig.r));
        const ss = tlv.encode(0x02, int.encode(sig.s));
        const seq = rs + ss;
        return tlv.encode(0x30, seq);
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3), _4n = BigInt(4);
function weierstrassPoints(opts) {
    const CURVE = validatePointOpts(opts);
    const { Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const Fn = (0, modular_ts_1.Field)(CURVE.n, CURVE.nBitLength);
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return (0, utils_ts_1.concatBytes)(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x,
            y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula. Takes x, returns y².
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a, b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error('bad generator point: equation left != right');
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return (0, utils_ts_1.inRange)(num, _1n, CURVE.n);
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength, wrapPrivateKey, n: N } = CURVE;
        if (lengths && typeof key !== 'bigint') {
            if ((0, utils_ts_1.isBytes)(key)) key = (0, utils_ts_1.bytesToHex)(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== 'string' || !lengths.includes(key.length)) throw new Error('invalid private key');
            key = key.padStart(nByteLength * 2, '0');
        }
        let num;
        try {
            num = typeof key === 'bigint' ? key : (0, utils_ts_1.bytesToNumberBE)((0, utils_ts_1.ensureBytes)('private key', key, nByteLength));
        } catch (error) {
            throw new Error('invalid private key, expected hex or ' + nByteLength + ' bytes, got ' + typeof key);
        }
        if (wrapPrivateKey) num = (0, modular_ts_1.mod)(num, N); // disabled by default, enabled for BLS
        (0, utils_ts_1.aInRange)('private key', num, _1n, N); // num in range [1..N-1]
        return num;
    }
    function aprjpoint(other) {
        if (!(other instanceof Point)) throw new Error('ProjectivePoint expected');
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    const toAffineMemo = (0, utils_ts_1.memoized)((p, iz)=>{
        const { px: x, py: y, pz: z } = p;
        // Fast-path for normalized points
        if (Fp.eql(z, Fp.ONE)) return {
            x,
            y
        };
        const is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
        const ax = Fp.mul(x, iz);
        const ay = Fp.mul(y, iz);
        const zz = Fp.mul(z, iz);
        if (is0) return {
            x: Fp.ZERO,
            y: Fp.ZERO
        };
        if (!Fp.eql(zz, Fp.ONE)) throw new Error('invZ was invalid');
        return {
            x: ax,
            y: ay
        };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    const assertValidMemo = (0, utils_ts_1.memoized)((p)=>{
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is invalid representation of ZERO.
            if (CURVE.allowInfinityPoint && !Fp.is0(p.py)) return;
            throw new Error('bad point: ZERO');
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        const { x, y } = p.toAffine();
        // Check if x, y are valid field elements
        if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error('bad point: x or y not FE');
        const left = Fp.sqr(y); // y²
        const right = weierstrassEquation(x); // x³ + ax + b
        if (!Fp.eql(left, right)) throw new Error('bad point: equation left != right');
        if (!p.isTorsionFree()) throw new Error('bad point: not in prime-order subgroup');
        return true;
    });
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            if (px == null || !Fp.isValid(px)) throw new Error('x required');
            if (py == null || !Fp.isValid(py) || Fp.is0(py)) throw new Error('y required');
            if (pz == null || !Fp.isValid(pz)) throw new Error('z required');
            this.px = px;
            this.py = py;
            this.pz = pz;
            Object.freeze(this);
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x, y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error('invalid affine point');
            if (p instanceof Point) throw new Error('projective point not allowed');
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = (0, modular_ts_1.FpInvertBatch)(Fp, points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, utils_ts_1.ensureBytes)('pointHex', hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // Multiscalar Multiplication
        static msm(points, scalars) {
            return (0, curve_ts_1.pippenger)(Point, Fn, points, scalars);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            wnaf.setWindowSize(this, windowSize);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            assertValidMemo(this);
        }
        hasEvenY() {
            const { y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            aprjpoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a, b } = CURVE;
            const b3 = Fp.mul(b, _3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            aprjpoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, _3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, n, Point.normalizeZ);
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(sc) {
            const { endo, n: N } = CURVE;
            (0, utils_ts_1.aInRange)('scalar', sc, _0n, N);
            const I = Point.ZERO;
            if (sc === _0n) return I;
            if (this.is0() || sc === _1n) return this;
            // Case a: no endomorphism. Case b: has precomputes.
            if (!endo || wnaf.hasPrecomputes(this)) return wnaf.wNAFCachedUnsafe(this, sc, Point.normalizeZ);
            // Case c: endomorphism
            let { k1neg, k1, k2neg, k2 } = endo.splitScalar(sc);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > _0n || k2 > _0n){
                if (k1 & _1n) k1p = k1p.add(d);
                if (k2 & _1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= _1n;
                k2 >>= _1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            const { endo, n: N } = CURVE;
            (0, utils_ts_1.aInRange)('scalar', scalar, _1n, N);
            let point, fake; // Fake point is used to const-time mult
            if (endo) {
                const { k1neg, k1, k2neg, k2 } = endo.splitScalar(scalar);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p, f } = this.wNAF(scalar);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === _0n || a === _1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            return toAffineMemo(this, iz);
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree } = CURVE;
            if (cofactor === _1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error('isTorsionFree() has not been declared for the elliptic curve');
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor } = CURVE;
            if (cofactor === _1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            (0, utils_ts_1.abool)('isCompressed', isCompressed);
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            (0, utils_ts_1.abool)('isCompressed', isCompressed);
            return (0, utils_ts_1.bytesToHex)(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO); // 0, 1, 0
    const _bits = CURVE.nBitLength;
    const wnaf = (0, curve_ts_1.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    return {
        CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar,
        weierstrassEquation,
        isWithinCurveOrder
    };
}
function validateOpts(curve) {
    const opts = (0, curve_ts_1.validateBasic)(curve);
    (0, utils_ts_1.validateObject)(opts, {
        hash: 'hash',
        hmac: 'function',
        randomBytes: 'function'
    }, {
        bits2int: 'function',
        bits2int_modN: 'function',
        lowS: 'boolean'
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
/**
 * Creates short weierstrass curve and ECDSA signature methods for it.
 * @example
 * import { Field } from '@noble/curves/abstract/modular';
 * // Before that, define BigInt-s: a, b, p, n, Gx, Gy
 * const curve = weierstrass({ a, b, Fp: Field(p), n, Gx, Gy, h: 1n })
 */ function weierstrass(curveDef) {
    const CURVE = validateOpts(curveDef);
    const { Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function modN(a) {
        return (0, modular_ts_1.mod)(a, CURVE_ORDER);
    }
    function invN(a) {
        return (0, modular_ts_1.invert)(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar, weierstrassEquation, isWithinCurveOrder } = weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = utils_ts_1.concatBytes;
            (0, utils_ts_1.abool)('isCompressed', isCompressed);
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = (0, utils_ts_1.bytesToNumberBE)(tail);
                if (!(0, utils_ts_1.inRange)(x, _1n, Fp.ORDER)) throw new Error('Point is not on curve');
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                } catch (sqrtError) {
                    const suffix = sqrtError instanceof Error ? ': ' + sqrtError.message : '';
                    throw new Error('Point is not on curve' + suffix);
                }
                const isYOdd = (y & _1n) === _1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x,
                    y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x,
                    y
                };
            } else {
                const cl = compressedLen;
                const ul = uncompressedLen;
                throw new Error('invalid Point, expected length of ' + cl + ', or uncompressed ' + ul + ', got ' + len);
            }
        }
    });
    const numToNByteHex = (num)=>(0, utils_ts_1.bytesToHex)((0, utils_ts_1.numberToBytesBE)(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> _1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>(0, utils_ts_1.bytesToNumberBE)(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            (0, utils_ts_1.aInRange)('r', r, _1n, CURVE_ORDER); // r in [1..N]
            (0, utils_ts_1.aInRange)('s', s, _1n, CURVE_ORDER); // s in [1..N]
            this.r = r;
            this.s = s;
            if (recovery != null) this.recovery = recovery;
            Object.freeze(this);
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, utils_ts_1.ensureBytes)('compactSignature', hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r, s } = exports.DER.toSig((0, utils_ts_1.ensureBytes)('DER', hex));
            return new Signature(r, s);
        }
        /**
         * @todo remove
         * @deprecated
         */ assertValidity() {}
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r, s, recovery: rec } = this;
            const h = bits2int_modN((0, utils_ts_1.ensureBytes)('msgHash', msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error('recovery id invalid');
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error('recovery id 2 or 3 invalid');
            const prefix = (rec & 1) === 0 ? '02' : '03';
            const R = Point.fromHex(prefix + numToNByteHex(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error('point at infinify'); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return (0, utils_ts_1.hexToBytes)(this.toDERHex());
        }
        toDERHex() {
            return exports.DER.hexFromSig(this);
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return (0, utils_ts_1.hexToBytes)(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteHex(this.r) + numToNByteHex(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = (0, modular_ts_1.getMinHashLength)(CURVE.n);
            return (0, modular_ts_1.mapHashToField)(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = (0, utils_ts_1.isBytes)(item);
        const str = typeof item === 'string';
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error('first arg must be private key');
        if (!isProbPub(publicB)) throw new Error('second arg must be public key');
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // Our custom check "just in case"
        if (bytes.length > 8192) throw new Error('input is too large');
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = (0, utils_ts_1.bytesToNumberBE)(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = (0, utils_ts_1.bitMask)(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        (0, utils_ts_1.aInRange)('num < 2^' + CURVE.nBitLength, num, _0n, ORDER_MASK);
        // works with order, can have different size than numToField!
        return (0, utils_ts_1.numberToBytesBE)(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order,
    // this will be invalid at least for P521. Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            'recovered',
            'canonical'
        ].some((k)=>k in opts)) throw new Error('sign() legacy options not supported');
        const { hash, randomBytes } = CURVE;
        let { lowS, prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, utils_ts_1.ensureBytes)('msgHash', msgHash);
        validateSigVerOpts(opts);
        if (prehash) msgHash = (0, utils_ts_1.ensureBytes)('prehashed msgHash', hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, utils_ts_1.ensureBytes)('extraEntropy', e)); // check for being bytes
        }
        const seed = (0, utils_ts_1.concatBytes)(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === _0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === _0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & _1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed,
            k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed, k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = (0, utils_ts_1.createHmacDrbg)(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, utils_ts_1.ensureBytes)('msgHash', msgHash);
        publicKey = (0, utils_ts_1.ensureBytes)('publicKey', publicKey);
        const { lowS, prehash, format } = opts;
        // Verify opts, deduce signature format
        validateSigVerOpts(opts);
        if ('strict' in opts) throw new Error('options.strict was renamed to lowS');
        if (format !== undefined && format !== 'compact' && format !== 'der') throw new Error('format must be compact or der');
        const isHex = typeof sg === 'string' || (0, utils_ts_1.isBytes)(sg);
        const isObj = !isHex && !format && typeof sg === 'object' && sg !== null && typeof sg.r === 'bigint' && typeof sg.s === 'bigint';
        if (!isHex && !isObj) throw new Error('invalid signature, expected Uint8Array, hex string or Signature instance');
        let _sig = undefined;
        let P;
        try {
            if (isObj) _sig = new Signature(sg.r, sg.s);
            if (isHex) {
                // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
                // Since DER can also be 2*nByteLength bytes, we check for it first.
                try {
                    if (format !== 'compact') _sig = Signature.fromDER(sg);
                } catch (derError) {
                    if (!(derError instanceof exports.DER.Err)) throw derError;
                }
                if (!_sig && format !== 'der') _sig = Signature.fromCompact(sg);
            }
            P = Point.fromHex(publicKey);
        } catch (error) {
            return false;
        }
        if (!_sig) return false;
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r, s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE,
        getPublicKey,
        getSharedSecret,
        sign,
        verify,
        ProjectivePoint: Point,
        Signature,
        utils
    };
}
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = _0n;
    for(let o = q - _1n; o % _2n === _0n; o /= _2n)l += _1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = _2n << c1 - _1n - _1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * _2n;
    const c2 = (q - _1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - _1n) / _2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - _1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + _1n) / _2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > _1n; i--){
            let tv5 = i - _2n; // 18.    tv5 = i - 2
            tv5 = _2n << tv5 - _1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % _4n === _3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - _3n) / _4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function mapToCurveSimpleSWU(Fp, opts) {
    (0, modular_ts_1.validateField)(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error('mapToCurveSimpleSWU: invalid opts');
    const sqrtRatio = SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error('Fp.isOdd is not implemented!');
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid, value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        const tv4_inv = (0, modular_ts_1.FpInvertBatch)(Fp, [
            tv4
        ], true)[0];
        x = Fp.mul(x, tv4_inv); // 25.   x = x / tv4
        return {
            x,
            y
        };
    };
}

},{"45691ba029262ce5":"e2u9v","a8b017b618719623":"9tvbn","ddb060cf893c1e6d":"40YnT"}],"e2u9v":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wNAF = wNAF;
exports.pippenger = pippenger;
exports.precomputeMSMUnsafe = precomputeMSMUnsafe;
exports.validateBasic = validateBasic;
/**
 * Methods for elliptic curve multiplication by scalars.
 * Contains wNAF, pippenger
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const modular_ts_1 = require("68c5bf7ca1ce77f8");
const utils_ts_1 = require("9e592d5a75527c54");
const _0n = BigInt(0);
const _1n = BigInt(1);
function constTimeNegate(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
function validateW(W, bits) {
    if (!Number.isSafeInteger(W) || W <= 0 || W > bits) throw new Error('invalid window size, expected [1..' + bits + '], got W=' + W);
}
function calcWOpts(W, scalarBits) {
    validateW(W, scalarBits);
    const windows = Math.ceil(scalarBits / W) + 1; // W=8 33. Not 32, because we skip zero
    const windowSize = 2 ** (W - 1); // W=8 128. Not 256, because we skip zero
    const maxNumber = 2 ** W; // W=8 256
    const mask = (0, utils_ts_1.bitMask)(W); // W=8 255 == mask 0b11111111
    const shiftBy = BigInt(W); // W=8 8
    return {
        windows,
        windowSize,
        mask,
        maxNumber,
        shiftBy
    };
}
function calcOffsets(n, window, wOpts) {
    const { windowSize, mask, maxNumber, shiftBy } = wOpts;
    let wbits = Number(n & mask); // extract W bits.
    let nextN = n >> shiftBy; // shift number by W bits.
    // What actually happens here:
    // const highestBit = Number(mask ^ (mask >> 1n));
    // let wbits2 = wbits - 1; // skip zero
    // if (wbits2 & highestBit) { wbits2 ^= Number(mask); // (~);
    // split if bits > max: +224 => 256-32
    if (wbits > windowSize) {
        // we skip zero, which means instead of `>= size-1`, we do `> size`
        wbits -= maxNumber; // -32, can be maxNumber - wbits, but then we need to set isNeg here.
        nextN += _1n; // +256 (carry)
    }
    const offsetStart = window * windowSize;
    const offset = offsetStart + Math.abs(wbits) - 1; // -1 because we skip zero
    const isZero = wbits === 0; // is current window slice a 0?
    const isNeg = wbits < 0; // is current window slice negative?
    const isNegF = window % 2 !== 0; // fake random statement for noise
    const offsetF = offsetStart; // fake offset for noise
    return {
        nextN,
        offset,
        isZero,
        isNeg,
        isNegF,
        offsetF
    };
}
function validateMSMPoints(points, c) {
    if (!Array.isArray(points)) throw new Error('array expected');
    points.forEach((p, i)=>{
        if (!(p instanceof c)) throw new Error('invalid point at index ' + i);
    });
}
function validateMSMScalars(scalars, field) {
    if (!Array.isArray(scalars)) throw new Error('array of scalars expected');
    scalars.forEach((s, i)=>{
        if (!field.isValid(s)) throw new Error('invalid scalar at index ' + i);
    });
}
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes.
// Allows to make points frozen / immutable.
const pointPrecomputes = new WeakMap();
const pointWindowSizes = new WeakMap();
function getW(P) {
    return pointWindowSizes.get(P) || 1;
}
/**
 * Elliptic curve multiplication of Point by scalar. Fragile.
 * Scalars should always be less than curve order: this should be checked inside of a curve itself.
 * Creates precomputation tables for fast multiplication:
 * - private scalar is split by fixed size windows of W bits
 * - every window point is collected from window's table & added to accumulator
 * - since windows are different, same point inside tables won't be accessed more than once per calc
 * - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
 * - +1 window is neccessary for wNAF
 * - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
 *
 * @todo Research returning 2d JS array of windows, instead of a single window.
 * This would allow windows to be in different memory locations
 */ function wNAF(c, bits) {
    return {
        constTimeNegate,
        hasPrecomputes (elm) {
            return getW(elm) !== 1;
        },
        // non-const time multiplication ladder
        unsafeLadder (elm, n, p = c.ZERO) {
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @param elm Point instance
         * @param W window size
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = calcWOpts(W, bits);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // i=1, bc we skip 0
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // Smaller version:
            // https://github.com/paulmillr/noble-secp256k1/blob/47cb1669b6e506ad66b35fe7d76132ae97465da2/index.ts#L502-L541
            // TODO: check the scalar is less than group order?
            // wNAF behavior is undefined otherwise. But have to carefully remove
            // other checks before wNAF. ORDER == bits here.
            // Accumulators
            let p = c.ZERO;
            let f = c.BASE;
            // This code was first written with assumption that 'f' and 'p' will never be infinity point:
            // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
            // there is negate now: it is possible that negated element from low value
            // would be the same as high element, which will create carry into next window.
            // It's not obvious how this can fail, but still worth investigating later.
            const wo = calcWOpts(W, bits);
            for(let window = 0; window < wo.windows; window++){
                // (n === _0n) is handled and not early-exited. isEven and offsetF are used for noise
                const { nextN, offset, isZero, isNeg, isNegF, offsetF } = calcOffsets(n, window, wo);
                n = nextN;
                if (isZero) // bits are 0: add garbage to fake point
                // Important part for const-time getPublicKey: add random "noise" point to f.
                f = f.add(constTimeNegate(isNegF, precomputes[offsetF]));
                else // bits are 1: add to result point
                p = p.add(constTimeNegate(isNeg, precomputes[offset]));
            }
            // Return both real and fake points: JIT won't eliminate f.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p,
                f
            };
        },
        /**
         * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @param acc accumulator point to add result of multiplication
         * @returns point
         */ wNAFUnsafe (W, precomputes, n, acc = c.ZERO) {
            const wo = calcWOpts(W, bits);
            for(let window = 0; window < wo.windows; window++){
                if (n === _0n) break; // Early-exit, skip 0 value
                const { nextN, offset, isZero, isNeg } = calcOffsets(n, window, wo);
                n = nextN;
                if (isZero) continue;
                else {
                    const item = precomputes[offset];
                    acc = acc.add(isNeg ? item.negate() : item); // Re-using acc allows to save adds in MSM
                }
            }
            return acc;
        },
        getPrecomputes (W, P, transform) {
            // Calculate precomputes on a first run, reuse them after
            let comp = pointPrecomputes.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) pointPrecomputes.set(P, transform(comp));
            }
            return comp;
        },
        wNAFCached (P, n, transform) {
            const W = getW(P);
            return this.wNAF(W, this.getPrecomputes(W, P, transform), n);
        },
        wNAFCachedUnsafe (P, n, transform, prev) {
            const W = getW(P);
            if (W === 1) return this.unsafeLadder(P, n, prev); // For W=1 ladder is ~x2 faster
            return this.wNAFUnsafe(W, this.getPrecomputes(W, P, transform), n, prev);
        },
        // We calculate precomputes for elliptic curve point multiplication
        // using windowed method. This specifies window size and
        // stores precomputed values. Usually only base point would be precomputed.
        setWindowSize (P, W) {
            validateW(W, bits);
            pointWindowSizes.set(P, W);
            pointPrecomputes.delete(P);
        }
    };
}
/**
 * Pippenger algorithm for multi-scalar multiplication (MSM, Pa + Qb + Rc + ...).
 * 30x faster vs naive addition on L=4096, 10x faster than precomputes.
 * For N=254bit, L=1, it does: 1024 ADD + 254 DBL. For L=5: 1536 ADD + 254 DBL.
 * Algorithmically constant-time (for same L), even when 1 point + scalar, or when scalar = 0.
 * @param c Curve Point constructor
 * @param fieldN field over CURVE.N - important that it's not over CURVE.P
 * @param points array of L curve points
 * @param scalars array of L scalars (aka private keys / bigints)
 */ function pippenger(c, fieldN, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    validateMSMPoints(points, c);
    validateMSMScalars(scalars, fieldN);
    if (points.length !== scalars.length) throw new Error('arrays of points and scalars must have equal length');
    const zero = c.ZERO;
    const wbits = (0, utils_ts_1.bitLen)(BigInt(points.length));
    const windowSize = wbits > 12 ? wbits - 3 : wbits > 4 ? wbits - 2 : wbits ? 2 : 1; // in bits
    const MASK = (0, utils_ts_1.bitMask)(windowSize);
    const buckets = new Array(Number(MASK) + 1).fill(zero); // +1 for zero array
    const lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    let sum = zero;
    for(let i = lastBits; i >= 0; i -= windowSize){
        buckets.fill(zero);
        for(let j = 0; j < scalars.length; j++){
            const scalar = scalars[j];
            const wbits = Number(scalar >> BigInt(i) & MASK);
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for(let j = buckets.length - 1, sumI = zero; j > 0; j--){
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0) for(let j = 0; j < windowSize; j++)sum = sum.double();
    }
    return sum;
}
/**
 * Precomputed multi-scalar multiplication (MSM, Pa + Qb + Rc + ...).
 * @param c Curve Point constructor
 * @param fieldN field over CURVE.N - important that it's not over CURVE.P
 * @param points array of L curve points
 * @returns function which multiplies points with scaars
 */ function precomputeMSMUnsafe(c, fieldN, points, windowSize) {
    /**
     * Performance Analysis of Window-based Precomputation
     *
     * Base Case (256-bit scalar, 8-bit window):
     * - Standard precomputation requires:
     *   - 31 additions per scalar × 256 scalars = 7,936 ops
     *   - Plus 255 summary additions = 8,191 total ops
     *   Note: Summary additions can be optimized via accumulator
     *
     * Chunked Precomputation Analysis:
     * - Using 32 chunks requires:
     *   - 255 additions per chunk
     *   - 256 doublings
     *   - Total: (255 × 32) + 256 = 8,416 ops
     *
     * Memory Usage Comparison:
     * Window Size | Standard Points | Chunked Points
     * ------------|-----------------|---------------
     *     4-bit   |     520         |      15
     *     8-bit   |    4,224        |     255
     *    10-bit   |   13,824        |   1,023
     *    16-bit   |  557,056        |  65,535
     *
     * Key Advantages:
     * 1. Enables larger window sizes due to reduced memory overhead
     * 2. More efficient for smaller scalar counts:
     *    - 16 chunks: (16 × 255) + 256 = 4,336 ops
     *    - ~2x faster than standard 8,191 ops
     *
     * Limitations:
     * - Not suitable for plain precomputes (requires 256 constant doublings)
     * - Performance degrades with larger scalar counts:
     *   - Optimal for ~256 scalars
     *   - Less efficient for 4096+ scalars (Pippenger preferred)
     */ validateW(windowSize, fieldN.BITS);
    validateMSMPoints(points, c);
    const zero = c.ZERO;
    const tableSize = 2 ** windowSize - 1; // table size (without zero)
    const chunks = Math.ceil(fieldN.BITS / windowSize); // chunks of item
    const MASK = (0, utils_ts_1.bitMask)(windowSize);
    const tables = points.map((p)=>{
        const res = [];
        for(let i = 0, acc = p; i < tableSize; i++){
            res.push(acc);
            acc = acc.add(p);
        }
        return res;
    });
    return (scalars)=>{
        validateMSMScalars(scalars, fieldN);
        if (scalars.length > points.length) throw new Error('array of scalars must be smaller than array of points');
        let res = zero;
        for(let i = 0; i < chunks; i++){
            // No need to double if accumulator is still zero.
            if (res !== zero) for(let j = 0; j < windowSize; j++)res = res.double();
            const shiftBy = BigInt(chunks * windowSize - (i + 1) * windowSize);
            for(let j = 0; j < scalars.length; j++){
                const n = scalars[j];
                const curr = Number(n >> shiftBy & MASK);
                if (!curr) continue; // skip zero scalars chunks
                res = res.add(tables[j][curr - 1]);
            }
        }
        return res;
    };
}
function validateBasic(curve) {
    (0, modular_ts_1.validateField)(curve.Fp);
    (0, utils_ts_1.validateObject)(curve, {
        n: 'bigint',
        h: 'bigint',
        Gx: 'field',
        Gy: 'field'
    }, {
        nBitLength: 'isSafeInteger',
        nByteLength: 'isSafeInteger'
    });
    // Set defaults
    return Object.freeze({
        ...(0, modular_ts_1.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

},{"68c5bf7ca1ce77f8":"9tvbn","9e592d5a75527c54":"40YnT"}],"9tvbn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isNegativeLE = void 0;
exports.mod = mod;
exports.pow = pow;
exports.pow2 = pow2;
exports.invert = invert;
exports.tonelliShanks = tonelliShanks;
exports.FpSqrt = FpSqrt;
exports.validateField = validateField;
exports.FpPow = FpPow;
exports.FpInvertBatch = FpInvertBatch;
exports.FpDiv = FpDiv;
exports.FpLegendre = FpLegendre;
exports.FpIsSquare = FpIsSquare;
exports.nLength = nLength;
exports.Field = Field;
exports.FpSqrtOdd = FpSqrtOdd;
exports.FpSqrtEven = FpSqrtEven;
exports.hashToPrivateScalar = hashToPrivateScalar;
exports.getFieldBytesLength = getFieldBytesLength;
exports.getMinHashLength = getMinHashLength;
exports.mapHashToField = mapHashToField;
/**
 * Utils for modular division and finite fields.
 * A finite field over 11 is integer number operations `mod 11`.
 * There is no division: it is replaced by modular multiplicative inverse.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const utils_1 = require("687581108d51c111");
const utils_ts_1 = require("484debf0031542ca");
// prettier-ignore
const _0n = BigInt(0), _1n = BigInt(1), _2n = /* @__PURE__ */ BigInt(2), _3n = /* @__PURE__ */ BigInt(3);
// prettier-ignore
const _4n = /* @__PURE__ */ BigInt(4), _5n = /* @__PURE__ */ BigInt(5), _8n = /* @__PURE__ */ BigInt(8);
// prettier-ignore
const _9n = /* @__PURE__ */ BigInt(9), _16n = /* @__PURE__ */ BigInt(16);
// Calculates a modulo b
function mod(a, b) {
    const result = a % b;
    return result >= _0n ? result : b + result;
}
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * TODO: remove.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ function pow(num, power, modulo) {
    if (power < _0n) throw new Error('invalid exponent, negatives unsupported');
    if (modulo <= _0n) throw new Error('invalid modulus');
    if (modulo === _1n) return _0n;
    let res = _1n;
    while(power > _0n){
        if (power & _1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= _1n;
    }
    return res;
}
/** Does `x^(2^power)` mod p. `pow2(30, 4)` == `30^(2^4)` */ function pow2(x, power, modulo) {
    let res = x;
    while(power-- > _0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
/**
 * Inverses number over modulo.
 * Implemented using [Euclidean GCD](https://brilliant.org/wiki/extended-euclidean-algorithm/).
 */ function invert(number, modulo) {
    if (number === _0n) throw new Error('invert: expected non-zero number');
    if (modulo <= _0n) throw new Error('invert: expected positive modulus, got ' + modulo);
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = _0n, y = _1n, u = _1n, v = _0n;
    while(a !== _0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== _1n) throw new Error('invert: does not exist');
    return mod(x, modulo);
}
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function tonelliShanks(P) {
    // Do expensive precomputation step
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p-1 == q*(2^s) with q odd
    let Q = P - _1n;
    let S = 0;
    while(Q % _2n === _0n){
        Q /= _2n;
        S++;
    }
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    let Z = _2n;
    const _Fp = Field(P);
    while(Z < P && FpIsSquare(_Fp, Z)){
        if (Z++ > 1000) throw new Error('Cannot find square root: probably non-prime P');
    }
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + _1n) / _4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + _1n) / _2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (!FpIsSquare(Fp, n)) throw new Error('Cannot find square root');
        let r = S;
        // TODO: test on Fp2 and others
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            // (4. If t = 0, return r = 0)
            // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO;
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift,
            // otherwise there will be overflow.
            const ge = Fp.pow(g, _1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
/**
 * Square root for a finite field. It will try to check if optimizations are applicable and fall back to 4:
 *
 * 1. P ≡ 3 (mod 4)
 * 2. P ≡ 5 (mod 8)
 * 3. P ≡ 9 (mod 16)
 * 4. Tonelli-Shanks algorithm
 *
 * Different algorithms can give different roots, it is up to user to decide which one they want.
 * For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
 */ function FpSqrt(P) {
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % _4n === _3n) // Not all roots possible!
    // const ORDER =
    //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
    // const NUM = 72057594037927816n;
    return function sqrt3mod4(Fp, n) {
        const p1div4 = (P + _1n) / _4n;
        const root = Fp.pow(n, p1div4);
        // Throw if root**2 != n
        if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
        return root;
    };
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % _8n === _5n) return function sqrt5mod8(Fp, n) {
        const n2 = Fp.mul(n, _2n);
        const c1 = (P - _5n) / _8n;
        const v = Fp.pow(n2, c1);
        const nv = Fp.mul(n, v);
        const i = Fp.mul(Fp.mul(nv, _2n), v);
        const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
        if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
        return root;
    };
    // P ≡ 9 (mod 16)
    _9n;
    // Other cases: Tonelli-Shanks algorithm
    return tonelliShanks(P);
}
// Little-endian check for first LE bit (last BE bit);
const isNegativeLE = (num, modulo)=>(mod(num, modulo) & _1n) === _1n;
exports.isNegativeLE = isNegativeLE;
// prettier-ignore
const FIELD_FIELDS = [
    'create',
    'isValid',
    'is0',
    'neg',
    'inv',
    'sqrt',
    'sqr',
    'eql',
    'add',
    'sub',
    'mul',
    'pow',
    'div',
    'addN',
    'subN',
    'mulN',
    'sqrN'
];
function validateField(field) {
    const initial = {
        ORDER: 'bigint',
        MASK: 'bigint',
        BYTES: 'isSafeInteger',
        BITS: 'isSafeInteger'
    };
    const opts = FIELD_FIELDS.reduce((map, val)=>{
        map[val] = 'function';
        return map;
    }, initial);
    return (0, utils_ts_1.validateObject)(field, opts);
}
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function FpPow(Fp, num, power) {
    if (power < _0n) throw new Error('invalid exponent, negatives unsupported');
    if (power === _0n) return Fp.ONE;
    if (power === _1n) return num;
    // @ts-ignore
    let p = Fp.ONE;
    let d = num;
    while(power > _0n){
        if (power & _1n) p = Fp.mul(p, d);
        d = Fp.sqr(d);
        power >>= _1n;
    }
    return p;
}
/**
 * Efficiently invert an array of Field elements.
 * Exception-free. Will return `undefined` for 0 elements.
 * @param passZero map 0 to 0 (instead of undefined)
 */ function FpInvertBatch(Fp, nums, passZero = false) {
    const inverted = new Array(nums.length).fill(passZero ? Fp.ZERO : undefined);
    // Walk from first to last, multiply them by each other MOD p
    const multipliedAcc = nums.reduce((acc, num, i)=>{
        if (Fp.is0(num)) return acc;
        inverted[i] = acc;
        return Fp.mul(acc, num);
    }, Fp.ONE);
    // Invert last element
    const invertedAcc = Fp.inv(multipliedAcc);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (Fp.is0(num)) return acc;
        inverted[i] = Fp.mul(acc, inverted[i]);
        return Fp.mul(acc, num);
    }, invertedAcc);
    return inverted;
}
// TODO: remove
function FpDiv(Fp, lhs, rhs) {
    return Fp.mul(lhs, typeof rhs === 'bigint' ? invert(rhs, Fp.ORDER) : Fp.inv(rhs));
}
/**
 * Legendre symbol.
 * Legendre constant is used to calculate Legendre symbol (a | p)
 * which denotes the value of a^((p-1)/2) (mod p)..
 *
 * * (a | p) ≡ 1    if a is a square (mod p), quadratic residue
 * * (a | p) ≡ -1   if a is not a square (mod p), quadratic non residue
 * * (a | p) ≡ 0    if a ≡ 0 (mod p)
 */ function FpLegendre(Fp, n) {
    const legc = (Fp.ORDER - _1n) / _2n;
    const powered = Fp.pow(n, legc);
    const yes = Fp.eql(powered, Fp.ONE);
    const zero = Fp.eql(powered, Fp.ZERO);
    const no = Fp.eql(powered, Fp.neg(Fp.ONE));
    if (!yes && !zero && !no) throw new Error('Cannot find square root: probably non-prime P');
    return yes ? 1 : zero ? 0 : -1;
}
// This function returns True whenever the value x is a square in the field F.
function FpIsSquare(Fp, n) {
    const l = FpLegendre(Fp, n);
    return l === 0 || l === 1;
}
// CURVE.n lengths
function nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    if (nBitLength !== undefined) (0, utils_1.anumber)(nBitLength);
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength
    };
}
/**
 * Initializes a finite field over prime.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * Fragile: always run a benchmark on a change.
 * Security note: operations don't check 'isValid' for all elements for performance reasons,
 * it is caller responsibility to check this.
 * This is low-level code, please make sure you know what you're doing.
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= _0n) throw new Error('invalid field: expected ORDER > 0, got ' + ORDER);
    const { nBitLength: BITS, nByteLength: BYTES } = nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error('invalid field: expected ORDER of <= 2048 bytes');
    let sqrtP; // cached sqrtP
    const f = Object.freeze({
        ORDER,
        isLE,
        BITS,
        BYTES,
        MASK: (0, utils_ts_1.bitMask)(BITS),
        ZERO: _0n,
        ONE: _1n,
        create: (num)=>mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== 'bigint') throw new Error('invalid field element: expected bigint, got ' + typeof num);
            return _0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === _0n,
        isOdd: (num)=>(num & _1n) === _1n,
        neg: (num)=>mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>mod(num * num, ORDER),
        add: (lhs, rhs)=>mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>mod(lhs * rhs, ORDER),
        pow: (num, power)=>FpPow(f, num, power),
        div: (lhs, rhs)=>mod(lhs * invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>{
            if (!sqrtP) sqrtP = FpSqrt(ORDER);
            return sqrtP(f, n);
        }),
        toBytes: (num)=>isLE ? (0, utils_ts_1.numberToBytesLE)(num, BYTES) : (0, utils_ts_1.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error('Field.fromBytes: expected ' + BYTES + ' bytes, got ' + bytes.length);
            return isLE ? (0, utils_ts_1.bytesToNumberLE)(bytes) : (0, utils_ts_1.bytesToNumberBE)(bytes);
        },
        // TODO: we don't need it here, move out to separate fn
        invertBatch: (lst)=>FpInvertBatch(f, lst),
        // We can't move this out because Fp6, Fp12 implement it
        // and it's unclear what to return in there.
        cmov: (a, b, c)=>c ? b : a
    });
    return Object.freeze(f);
}
function FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use `mapKeyToField` instead
 */ function hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, utils_ts_1.ensureBytes)('privateHash', hash);
    const hashLen = hash.length;
    const minLen = nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error('hashToPrivateScalar: expected ' + minLen + '-1024 bytes of input, got ' + hashLen);
    const num = isLE ? (0, utils_ts_1.bytesToNumberLE)(hash) : (0, utils_ts_1.bytesToNumberBE)(hash);
    return mod(num, groupOrder - _1n) + _1n;
}
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== 'bigint') throw new Error('field order must be bigint');
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function getMinHashLength(fieldOrder) {
    const length = getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = getFieldBytesLength(fieldOrder);
    const minLen = getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error('expected ' + minLen + '-1024 bytes of input, got ' + len);
    const num = isLE ? (0, utils_ts_1.bytesToNumberLE)(key) : (0, utils_ts_1.bytesToNumberBE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = mod(num, fieldOrder - _1n) + _1n;
    return isLE ? (0, utils_ts_1.numberToBytesLE)(reduced, fieldLen) : (0, utils_ts_1.numberToBytesBE)(reduced, fieldLen);
}

},{"687581108d51c111":"a63oH","484debf0031542ca":"40YnT"}],"40YnT":[function(require,module,exports,__globalThis) {
"use strict";
/**
 * Hex, bytes and number utilities.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.notImplemented = exports.bitMask = void 0;
exports.isBytes = isBytes;
exports.abytes = abytes;
exports.abool = abool;
exports.numberToHexUnpadded = numberToHexUnpadded;
exports.hexToNumber = hexToNumber;
exports.bytesToHex = bytesToHex;
exports.hexToBytes = hexToBytes;
exports.bytesToNumberBE = bytesToNumberBE;
exports.bytesToNumberLE = bytesToNumberLE;
exports.numberToBytesBE = numberToBytesBE;
exports.numberToBytesLE = numberToBytesLE;
exports.numberToVarBytesBE = numberToVarBytesBE;
exports.ensureBytes = ensureBytes;
exports.concatBytes = concatBytes;
exports.equalBytes = equalBytes;
exports.utf8ToBytes = utf8ToBytes;
exports.inRange = inRange;
exports.aInRange = aInRange;
exports.bitLen = bitLen;
exports.bitGet = bitGet;
exports.bitSet = bitSet;
exports.createHmacDrbg = createHmacDrbg;
exports.validateObject = validateObject;
exports.memoized = memoized;
// 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const _0n = /* @__PURE__ */ BigInt(0);
const _1n = /* @__PURE__ */ BigInt(1);
function isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
function abytes(item) {
    if (!isBytes(item)) throw new Error('Uint8Array expected');
}
function abool(title, value) {
    if (typeof value !== 'boolean') throw new Error(title + ' boolean expected, got ' + value);
}
// Used in weierstrass, der
function numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? '0' + hex : hex;
}
function hexToNumber(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    return hex === '' ? _0n : BigInt('0x' + hex); // Big Endian
}
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const hasHexBuiltin = // @ts-ignore
typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function';
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * Convert byte array to hex string. Uses built-in function, when available.
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function bytesToHex(bytes) {
    abytes(bytes);
    // @ts-ignore
    if (hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function asciiToBase16(ch) {
    if (ch >= asciis._0 && ch <= asciis._9) return ch - asciis._0; // '2' => 50-48
    if (ch >= asciis.A && ch <= asciis.F) return ch - (asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= asciis.a && ch <= asciis.f) return ch - (asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
/**
 * Convert hex string to byte array. Uses built-in function, when available.
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function hexToBytes(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if (hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = asciiToBase16(hex.charCodeAt(hi));
        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
// BE: Big Endian, LE: Little Endian
function bytesToNumberBE(bytes) {
    return hexToNumber(bytesToHex(bytes));
}
function bytesToNumberLE(bytes) {
    abytes(bytes);
    return hexToNumber(bytesToHex(Uint8Array.from(bytes).reverse()));
}
function numberToBytesBE(n, len) {
    return hexToBytes(n.toString(16).padStart(len * 2, '0'));
}
function numberToBytesLE(n, len) {
    return numberToBytesBE(n, len).reverse();
}
// Unpadded, rarely used
function numberToVarBytesBE(n) {
    return hexToBytes(numberToHexUnpadded(n));
}
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === 'string') try {
        res = hexToBytes(hex);
    } catch (e) {
        throw new Error(title + ' must be hex string or Uint8Array, cause: ' + e);
    }
    else if (isBytes(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(title + ' must be hex string or Uint8Array');
    const len = res.length;
    if (typeof expectedLength === 'number' && len !== expectedLength) throw new Error(title + ' of length ' + expectedLength + ' expected, got ' + len);
    return res;
}
/**
 * Copies several Uint8Arrays into one.
 */ function concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
// Compares 2 u8a-s in kinda constant time
function equalBytes(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
// Is positive bigint
const isPosBig = (n)=>typeof n === 'bigint' && _0n <= n;
function inRange(n, min, max) {
    return isPosBig(n) && isPosBig(min) && isPosBig(max) && min <= n && n < max;
}
/**
 * Asserts min <= n < max. NOTE: It's < max and not <= max.
 * @example
 * aInRange('x', x, 1n, 256n); // would assume x is in (1n..255n)
 */ function aInRange(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!inRange(n, min, max)) throw new Error('expected valid ' + title + ': ' + min + ' <= n < ' + max + ', got ' + n);
}
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 * TODO: merge with nLength in modular
 */ function bitLen(n) {
    let len;
    for(len = 0; n > _0n; n >>= _1n, len += 1);
    return len;
}
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function bitGet(n, pos) {
    return n >> BigInt(pos) & _1n;
}
/**
 * Sets single bit at position.
 */ function bitSet(n, pos, value) {
    return n | (value ? _1n : _0n) << BigInt(pos);
}
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const bitMask = (n)=>(_1n << BigInt(n)) - _1n;
exports.bitMask = bitMask;
// DRBG
const u8n = (len)=>new Uint8Array(len); // creates Uint8Array
const u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== 'number' || hashLen < 2) throw new Error('hashLen must be a number');
    if (typeof qByteLen !== 'number' || qByteLen < 2) throw new Error('qByteLen must be a number');
    if (typeof hmacFn !== 'function') throw new Error('hmacFn must be a function');
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = u8n(0))=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h(u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error('drbg: tried 1000 values');
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const validatorFns = {
    bigint: (val)=>typeof val === 'bigint',
    function: (val)=>typeof val === 'function',
    boolean: (val)=>typeof val === 'boolean',
    string: (val)=>typeof val === 'string',
    stringOrUint8Array: (val)=>typeof val === 'string' || isBytes(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === 'function' && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = validatorFns[type];
        if (typeof checkVal !== 'function') throw new Error('invalid validator function');
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error('param ' + String(fieldName) + ' is invalid. Expected ' + type + ', got ' + val);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
// validate type tests
// const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
// const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
// // Should fail type-check
// const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
// const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
// const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
// const z4 = validateObject(o, { a: 'boolean', z: 'bug' });
/**
 * throws not implemented error
 */ const notImplemented = ()=>{
    throw new Error('not implemented');
};
exports.notImplemented = notImplemented;
/**
 * Memoizes (caches) computation result.
 * Uses WeakMap: the value is going auto-cleaned by GC after last reference is removed.
 */ function memoized(fn) {
    const map = new WeakMap();
    return (arg, ...args)=>{
        const val = map.get(arg);
        if (val !== undefined) return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}

},{}],"7oQRn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.expand_message_xmd = expand_message_xmd;
exports.expand_message_xof = expand_message_xof;
exports.hash_to_field = hash_to_field;
exports.isogenyMap = isogenyMap;
exports.createHasher = createHasher;
const modular_ts_1 = require("b906c81d9de254ed");
const utils_ts_1 = require("22f47bd78d9568ba");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const os2ip = utils_ts_1.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function i2osp(value, length) {
    anum(value);
    anum(length);
    if (value < 0 || value >= 1 << 8 * length) throw new Error('invalid I2OSP input: ' + value);
    const res = Array.from({
        length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error('number expected');
}
/**
 * Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits.
 * [RFC 9380 5.3.1](https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1).
 */ function expand_message_xmd(msg, DST, lenInBytes, H) {
    (0, utils_ts_1.abytes)(msg);
    (0, utils_ts_1.abytes)(DST);
    anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, utils_ts_1.concatBytes)((0, utils_ts_1.utf8ToBytes)('H2C-OVERSIZE-DST-'), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (lenInBytes > 65535 || ell > 255) throw new Error('expand_message_xmd: invalid lenInBytes');
    const DST_prime = (0, utils_ts_1.concatBytes)(DST, i2osp(DST.length, 1));
    const Z_pad = i2osp(0, r_in_bytes);
    const l_i_b_str = i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, utils_ts_1.concatBytes)(Z_pad, msg, l_i_b_str, i2osp(0, 1), DST_prime));
    b[0] = H((0, utils_ts_1.concatBytes)(b_0, i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            strxor(b_0, b[i - 1]),
            i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, utils_ts_1.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, utils_ts_1.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
/**
 * Produces a uniformly random byte string using an extendable-output function (XOF) H.
 * 1. The collision resistance of H MUST be at least k bits.
 * 2. H MUST be an XOF that has been proved indifferentiable from
 *    a random oracle under a reasonable cryptographic assumption.
 * [RFC 9380 5.3.2](https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2).
 */ function expand_message_xof(msg, DST, lenInBytes, k, H) {
    (0, utils_ts_1.abytes)(msg);
    (0, utils_ts_1.abytes)(DST);
    anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen
        }).update((0, utils_ts_1.utf8ToBytes)('H2C-OVERSIZE-DST-')).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error('expand_message_xof: invalid lenInBytes');
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update(i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update(i2osp(DST.length, 1)).digest();
}
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F.
 * [RFC 9380 5.2](https://www.rfc-editor.org/rfc/rfc9380#section-5.2).
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function hash_to_field(msg, count, options) {
    (0, utils_ts_1.validateObject)(options, {
        DST: 'stringOrUint8Array',
        p: 'bigint',
        m: 'isSafeInteger',
        k: 'isSafeInteger',
        hash: 'hash'
    });
    const { p, k, m, hash, expand, DST: _DST } = options;
    (0, utils_ts_1.abytes)(msg);
    anum(count);
    const DST = typeof _DST === 'string' ? (0, utils_ts_1.utf8ToBytes)(_DST) : _DST;
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === 'xmd') prb = expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === 'xof') prb = expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === '_internal_pass') // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, modular_ts_1.mod)(os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function isogenyMap(field, map) {
    // Make same order as in spec
    const coeff = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xn, xd, yn, yd] = coeff.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        // 6.6.3
        // Exceptional cases of iso_map are inputs that cause the denominator of
        // either rational function to evaluate to zero; such cases MUST return
        // the identity point on E.
        const [xd_inv, yd_inv] = (0, modular_ts_1.FpInvertBatch)(field, [
            xd,
            yd
        ], true);
        x = field.mul(xn, xd_inv); // xNum / xDen
        y = field.mul(y, field.mul(yn, yd_inv)); // y * (yNum / yDev)
        return {
            x,
            y
        };
    };
}
/** Creates hash-to-curve methods from EC Point and mapToCurve function. */ function createHasher(Point, mapToCurve, defaults) {
    if (typeof mapToCurve !== 'function') throw new Error('mapToCurve() must be defined');
    function map(num) {
        return Point.fromAffine(mapToCurve(num));
    }
    function clear(initial) {
        const P = initial.clearCofactor();
        if (P.equals(Point.ZERO)) return Point.ZERO; // zero will throw in assert
        P.assertValidity();
        return P;
    }
    return {
        defaults,
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = hash_to_field(msg, 2, {
                ...defaults,
                DST: defaults.DST,
                ...options
            });
            const u0 = map(u[0]);
            const u1 = map(u[1]);
            return clear(u0.add(u1));
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = hash_to_field(msg, 1, {
                ...defaults,
                DST: defaults.encodeDST,
                ...options
            });
            return clear(map(u[0]));
        },
        // Same as encodeToCurve, but without hash
        mapToCurve (scalars) {
            if (!Array.isArray(scalars)) throw new Error('expected array of bigints');
            for (const i of scalars)if (typeof i !== 'bigint') throw new Error('expected array of bigints');
            return clear(map(scalars));
        }
    };
}

},{"b906c81d9de254ed":"9tvbn","22f47bd78d9568ba":"40YnT"}],"tKV6d":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shake256 = exports.shake128 = exports.keccak_512 = exports.keccak_384 = exports.keccak_256 = exports.keccak_224 = exports.sha3_512 = exports.sha3_384 = exports.sha3_256 = exports.sha3_224 = exports.Keccak = void 0;
exports.keccakP = keccakP;
/**
 * SHA3 (keccak) hash function, based on a new "Sponge function" design.
 * Different from older hashes, the internal state is bigger than output size.
 *
 * Check out [FIPS-202](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.202.pdf),
 * [Website](https://keccak.team/keccak.html),
 * [the differences between SHA-3 and Keccak](https://crypto.stackexchange.com/questions/15727/what-are-the-key-differences-between-the-draft-sha-3-standard-and-the-keccak-sub).
 *
 * Check out `sha3-addons` module for cSHAKE, k12, and others.
 * @module
 */ const _u64_ts_1 = require("b980b82b83f4fadf");
// prettier-ignore
const utils_ts_1 = require("ed074bc27344f428");
// No __PURE__ annotations in sha3 header:
// EVERYTHING is in fact used on every export.
// Various per round constants calculations
const _0n = BigInt(0);
const _1n = BigInt(1);
const _2n = BigInt(2);
const _7n = BigInt(7);
const _256n = BigInt(256);
const _0x71n = BigInt(0x71);
const SHA3_PI = [];
const SHA3_ROTL = [];
const _SHA3_IOTA = [];
for(let round = 0, R = _1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = _0n;
    for(let j = 0; j < 7; j++){
        R = (R << _1n ^ (R >> _7n) * _0x71n) % _256n;
        if (R & _2n) t ^= _1n << (_1n << /* @__PURE__ */ BigInt(j)) - _1n;
    }
    _SHA3_IOTA.push(t);
}
const IOTAS = (0, _u64_ts_1.split)(_SHA3_IOTA, true);
const SHA3_IOTA_H = IOTAS[0];
const SHA3_IOTA_L = IOTAS[1];
// Left rotation (without 0, 32, 64)
const rotlH = (h, l, s)=>s > 32 ? (0, _u64_ts_1.rotlBH)(h, l, s) : (0, _u64_ts_1.rotlSH)(h, l, s);
const rotlL = (h, l, s)=>s > 32 ? (0, _u64_ts_1.rotlBL)(h, l, s) : (0, _u64_ts_1.rotlSL)(h, l, s);
/** `keccakf1600` internal function, additionally allows to adjust round count. */ function keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = SHA3_ROTL[t];
            const Th = rotlH(curH, curL, shift);
            const Tl = rotlL(curH, curL, shift);
            const PI = SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= SHA3_IOTA_H[round];
        s[1] ^= SHA3_IOTA_L[round];
    }
    (0, utils_ts_1.clean)(B);
}
/** Keccak sponge function. */ class Keccak extends utils_ts_1.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        this.enableXOF = false;
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        // Can be passed from user as dkLen
        (0, utils_ts_1.anumber)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        // 0 < blockLen < 200
        if (!(0 < blockLen && blockLen < 200)) throw new Error('only keccak-f1600 function is supported');
        this.state = new Uint8Array(200);
        this.state32 = (0, utils_ts_1.u32)(this.state);
    }
    clone() {
        return this._cloneInto();
    }
    keccak() {
        (0, utils_ts_1.swap32IfBE)(this.state32);
        keccakP(this.state32, this.rounds);
        (0, utils_ts_1.swap32IfBE)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, utils_ts_1.aexists)(this);
        data = (0, utils_ts_1.toBytes)(data);
        (0, utils_ts_1.abytes)(data);
        const { blockLen, state } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state, suffix, pos, blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, utils_ts_1.aexists)(this, false);
        (0, utils_ts_1.abytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error('XOF is not possible for this instance');
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, utils_ts_1.anumber)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, utils_ts_1.aoutput)(out, this);
        if (this.finished) throw new Error('digest() was already called');
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        (0, utils_ts_1.clean)(this.state);
    }
    _cloneInto(to) {
        const { blockLen, suffix, outputLen, rounds, enableXOF } = this;
        to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
exports.Keccak = Keccak;
const gen = (suffix, blockLen, outputLen)=>(0, utils_ts_1.createHasher)(()=>new Keccak(blockLen, suffix, outputLen));
/** SHA3-224 hash function. */ exports.sha3_224 = (()=>gen(0x06, 144, 28))();
/** SHA3-256 hash function. Different from keccak-256. */ exports.sha3_256 = (()=>gen(0x06, 136, 32))();
/** SHA3-384 hash function. */ exports.sha3_384 = (()=>gen(0x06, 104, 48))();
/** SHA3-512 hash function. */ exports.sha3_512 = (()=>gen(0x06, 72, 64))();
/** keccak-224 hash function. */ exports.keccak_224 = (()=>gen(0x01, 144, 28))();
/** keccak-256 hash function. Different from SHA3-256. */ exports.keccak_256 = (()=>gen(0x01, 136, 32))();
/** keccak-384 hash function. */ exports.keccak_384 = (()=>gen(0x01, 104, 48))();
/** keccak-512 hash function. */ exports.keccak_512 = (()=>gen(0x01, 72, 64))();
const genShake = (suffix, blockLen, outputLen)=>(0, utils_ts_1.createXOFer)((opts = {})=>new Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
/** SHAKE128 XOF with 128-bit security. */ exports.shake128 = (()=>genShake(0x1f, 168, 16))();
/** SHAKE256 XOF with 256-bit security. */ exports.shake256 = (()=>genShake(0x1f, 136, 32))();

},{"b980b82b83f4fadf":"l02Bz","ed074bc27344f428":"a63oH"}],"hQwUl":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CALL_DATA_KEY_PAIR_ID_CONTEXT_BASE = void 0;
exports.encodeCallWithNonceAndKeys = encodeCallWithNonceAndKeys;
exports.encodeCall = encodeCall;
exports.decodeResult = decodeResult;
const oasis = require("cf1c46ff4b6d4b13");
const deoxysii = require("dbdff0ea2f21c99e");
const nacl = require("24fecc8853fc1b4");
const mraeDeoxysii = require("56533476ec3991dc");
const transaction = require("5c62e3088c019d40");
/**
 * Call data key pair ID domain separation context base.
 */ exports.CALL_DATA_KEY_PAIR_ID_CONTEXT_BASE = 'oasis-runtime-sdk/private: tx';
/**
 * encodeCallWithNonceAndKeys encodes a call based on its configured call format.
 * It returns the encoded call and any metadata needed to successfully decode the result.
 */ function encodeCallWithNonceAndKeys(nonce, sk, pk, call, format, config) {
    switch(format){
        case transaction.CALLFORMAT_PLAIN:
            return [
                call,
                undefined
            ];
        case transaction.CALLFORMAT_ENCRYPTED_X25519DEOXYSII:
            if (config?.publicKey === undefined) throw new Error('callformat: runtime call data public key not set');
            const rawCall = oasis.misc.toCBOR(call);
            const zeroBuffer = new Uint8Array(0);
            const sealedCall = mraeDeoxysii.boxSeal(nonce, rawCall, zeroBuffer, config.publicKey.key, sk);
            const envelope = {
                pk: pk,
                nonce: nonce,
                data: sealedCall
            };
            const encoded = {
                format: transaction.CALLFORMAT_ENCRYPTED_X25519DEOXYSII,
                method: '',
                body: oasis.misc.toCBOR(envelope)
            };
            const meta = {
                sk: sk,
                pk: config.publicKey.key
            };
            return [
                encoded,
                meta
            ];
        default:
            throw new Error(`callformat: unsupported call format: ${format}`);
    }
}
/**
 * encodeCall randomly generates nonce and keyPair and then call encodeCallWithNonceAndKeys
 * It returns the encoded call and any metadata needed to successfully decode the result.
 */ function encodeCall(call, format, config) {
    const nonce = new Uint8Array(deoxysii.NonceSize);
    crypto.getRandomValues(nonce);
    const keyPair = nacl.box.keyPair();
    return encodeCallWithNonceAndKeys(nonce, keyPair.secretKey, keyPair.publicKey, call, format, config);
}
/**
 * decodeResult performs result decoding based on the specified call format metadata.
 */ function decodeResult(result, format, meta) {
    switch(format){
        case transaction.CALLFORMAT_PLAIN:
            // In case of plain-text data format, we simply pass on the result unchanged.
            return result;
        case transaction.CALLFORMAT_ENCRYPTED_X25519DEOXYSII:
            if (result.unknown) {
                if (meta) {
                    const envelop = oasis.misc.fromCBOR(result.unknown);
                    const zeroBuffer = new Uint8Array(0);
                    const pt = mraeDeoxysii.boxOpen(envelop?.nonce, envelop?.data, zeroBuffer, meta.pk, meta.sk);
                    return oasis.misc.fromCBOR(pt);
                } else throw new Error(`callformat: MetaEncryptedX25519DeoxysII data is required for callformat: CALLFORMAT_ENCRYPTED_X25519DEOXYSII`);
            } else if (result.fail) throw new Error(`callformat: failed call: module: ${result.fail.module} code: ${result.fail.code} message: ${result.fail.message}`);
            throw Object.assign(new Error(`callformat: unexpected result: ${result.ok}`), {
                source: result
            });
        default:
            throw new Error(`callformat: unsupported call format: ${format}`);
    }
}

},{"cf1c46ff4b6d4b13":"9pxEg","dbdff0ea2f21c99e":"8OuI3","24fecc8853fc1b4":"5ZWFX","56533476ec3991dc":"6RnZ1","5c62e3088c019d40":"2HIGn"}],"8OuI3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AEAD", ()=>AEAD) /**
 * @license (c) Franz X Antesberger 2013
 */ ;
parcelHelpers.export(exports, "ErrKeySize", ()=>ErrKeySize);
parcelHelpers.export(exports, "ErrNonceSize", ()=>ErrNonceSize);
parcelHelpers.export(exports, "ErrOpen", ()=>ErrOpen);
parcelHelpers.export(exports, "KeySize", ()=>KeySize);
parcelHelpers.export(exports, "NonceSize", ()=>NonceSize);
parcelHelpers.export(exports, "TagSize", ()=>TagSize);
parcelHelpers.export(exports, "default", ()=>src_default);
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __publicField = (obj, key, value)=>{
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/deoxysii.ts
var deoxysii_exports = {};
__export(deoxysii_exports, {
    AEAD: ()=>AEAD,
    ErrKeySize: ()=>ErrKeySize,
    ErrNonceSize: ()=>ErrNonceSize,
    ErrOpen: ()=>ErrOpen,
    KeySize: ()=>KeySize,
    NonceSize: ()=>NonceSize,
    TagSize: ()=>TagSize
});
// src/uint32.ts
function uint32_fromBytesBigEndian(highByte, secondHighByte, thirdHighByte, lowByte) {
    return (highByte << 24 | secondHighByte << 16 | thirdHighByte << 8 | lowByte) >>> 0;
}
function uint32_or(uint32val0, ...argv) {
    let result = uint32val0;
    for (const x of argv)result = result | x;
    return result >>> 0;
}
function uint32_and(uint32val0, ...argv) {
    let result = uint32val0;
    for (const x of argv)result = result & x;
    return result >>> 0;
}
function uint32_xor3(a, b, c) {
    return (a ^ b ^ c) >>> 0;
}
function uint32_xor2(a, b) {
    return (a ^ b) >>> 0;
}
function uint32_xor(uint32val0, ...argv) {
    let result = uint32val0;
    for (const x of argv)result = result ^ x;
    return result >>> 0;
}
function uint32_not(uint32val) {
    return ~uint32val >>> 0;
}
function uint32_shiftLeft(uint32val, numBits) {
    return uint32val << numBits >>> 0;
}
function uint32_shiftRight(uint32val, numBits) {
    return uint32val >>> numBits;
}
function uint32_rotateRight(uint32val, numBits) {
    return (uint32val >>> numBits | uint32val << 32 - numBits >>> 0) >>> 0;
}
// src/aes.ts
var oddsMask = uint32_fromBytesBigEndian(85, 85, 85, 85);
var evensMask = uint32_fromBytesBigEndian(170, 170, 170, 170);
var cl4 = uint32_fromBytesBigEndian(51, 51, 51, 51);
var ch4 = uint32_fromBytesBigEndian(204, 204, 204, 204);
var cl8 = uint32_fromBytesBigEndian(15, 15, 15, 15);
var ch8 = uint32_fromBytesBigEndian(240, 240, 240, 240);
var shiftRowsMask0 = uint32_fromBytesBigEndian(0, 0, 0, 255);
var shiftRowsMask1 = uint32_fromBytesBigEndian(0, 0, 252, 0);
var shiftRowsMask2 = uint32_fromBytesBigEndian(0, 0, 3, 0);
var shiftRowsMask3 = uint32_fromBytesBigEndian(0, 240, 0, 0);
var shiftRowsMask4 = uint32_fromBytesBigEndian(0, 15, 0, 0);
var shiftRowsMask5 = uint32_fromBytesBigEndian(192, 0, 0, 0);
var shiftRowsMask6 = uint32_fromBytesBigEndian(63, 0, 0, 0);
function newQ() {
    return new Uint32Array(8);
}
function addRoundKey(q, sk) {
    q[0] = uint32_xor2(q[0], sk[0]);
    q[1] = uint32_xor2(q[1], sk[1]);
    q[2] = uint32_xor2(q[2], sk[2]);
    q[3] = uint32_xor2(q[3], sk[3]);
    q[4] = uint32_xor2(q[4], sk[4]);
    q[5] = uint32_xor2(q[5], sk[5]);
    q[6] = uint32_xor2(q[6], sk[6]);
    q[7] = uint32_xor2(q[7], sk[7]);
}
function subBytes(q) {
    const x0 = q[7];
    const x1 = q[6];
    const x2 = q[5];
    const x3 = q[4];
    const x4 = q[3];
    const x5 = q[2];
    const x6 = q[1];
    const x7 = q[0];
    const y14 = uint32_xor2(x3, x5);
    const y13 = uint32_xor2(x0, x6);
    const y9 = uint32_xor2(x0, x3);
    const y8 = uint32_xor2(x0, x5);
    const t0 = uint32_xor2(x1, x2);
    const y1 = uint32_xor2(t0, x7);
    const y4 = uint32_xor2(y1, x3);
    const y12 = uint32_xor2(y13, y14);
    const y2 = uint32_xor2(y1, x0);
    const y5 = uint32_xor2(y1, x6);
    const y3 = uint32_xor2(y5, y8);
    const t1 = uint32_xor2(x4, y12);
    const y15 = uint32_xor2(t1, x5);
    const y20 = uint32_xor2(t1, x1);
    const y6 = uint32_xor2(y15, x7);
    const y10 = uint32_xor2(y15, t0);
    const y11 = uint32_xor2(y20, y9);
    const y7 = uint32_xor2(x7, y11);
    const y17 = uint32_xor2(y10, y11);
    const y19 = uint32_xor2(y10, y8);
    const y16 = uint32_xor2(t0, y11);
    const y21 = uint32_xor2(y13, y16);
    const y18 = uint32_xor2(x0, y16);
    const t2 = uint32_and(y12, y15);
    const t3 = uint32_and(y3, y6);
    const t4 = uint32_xor2(t3, t2);
    const t5 = uint32_and(y4, x7);
    const t6 = uint32_xor2(t5, t2);
    const t7 = uint32_and(y13, y16);
    const t8 = uint32_and(y5, y1);
    const t9 = uint32_xor2(t8, t7);
    const t10 = uint32_and(y2, y7);
    const t11 = uint32_xor2(t10, t7);
    const t12 = uint32_and(y9, y11);
    const t13 = uint32_and(y14, y17);
    const t14 = uint32_xor2(t13, t12);
    const t15 = uint32_and(y8, y10);
    const t16 = uint32_xor2(t15, t12);
    const t17 = uint32_xor2(t4, t14);
    const t18 = uint32_xor2(t6, t16);
    const t19 = uint32_xor2(t9, t14);
    const t20 = uint32_xor2(t11, t16);
    const t21 = uint32_xor2(t17, y20);
    const t22 = uint32_xor2(t18, y19);
    const t23 = uint32_xor2(t19, y21);
    const t24 = uint32_xor2(t20, y18);
    const t25 = uint32_xor2(t21, t22);
    const t26 = uint32_and(t21, t23);
    const t27 = uint32_xor2(t24, t26);
    const t28 = uint32_and(t25, t27);
    const t29 = uint32_xor2(t28, t22);
    const t30 = uint32_xor2(t23, t24);
    const t31 = uint32_xor2(t22, t26);
    const t32 = uint32_and(t31, t30);
    const t33 = uint32_xor2(t32, t24);
    const t34 = uint32_xor2(t23, t33);
    const t35 = uint32_xor2(t27, t33);
    const t36 = uint32_and(t24, t35);
    const t37 = uint32_xor2(t36, t34);
    const t38 = uint32_xor2(t27, t36);
    const t39 = uint32_and(t29, t38);
    const t40 = uint32_xor2(t25, t39);
    const t41 = uint32_xor2(t40, t37);
    const t42 = uint32_xor2(t29, t33);
    const t43 = uint32_xor2(t29, t40);
    const t44 = uint32_xor2(t33, t37);
    const t45 = uint32_xor2(t42, t41);
    const z0 = uint32_and(t44, y15);
    const z1 = uint32_and(t37, y6);
    const z2 = uint32_and(t33, x7);
    const z3 = uint32_and(t43, y16);
    const z4 = uint32_and(t40, y1);
    const z5 = uint32_and(t29, y7);
    const z6 = uint32_and(t42, y11);
    const z7 = uint32_and(t45, y17);
    const z8 = uint32_and(t41, y10);
    const z9 = uint32_and(t44, y12);
    const z10 = uint32_and(t37, y3);
    const z11 = uint32_and(t33, y4);
    const z12 = uint32_and(t43, y13);
    const z13 = uint32_and(t40, y5);
    const z14 = uint32_and(t29, y2);
    const z15 = uint32_and(t42, y9);
    const z16 = uint32_and(t45, y14);
    const z17 = uint32_and(t41, y8);
    const t46 = uint32_xor2(z15, z16);
    const t47 = uint32_xor2(z10, z11);
    const t48 = uint32_xor2(z5, z13);
    const t49 = uint32_xor2(z9, z10);
    const t50 = uint32_xor2(z2, z12);
    const t51 = uint32_xor2(z2, z5);
    const t52 = uint32_xor2(z7, z8);
    const t53 = uint32_xor2(z0, z3);
    const t54 = uint32_xor2(z6, z7);
    const t55 = uint32_xor2(z16, z17);
    const t56 = uint32_xor2(z12, t48);
    const t57 = uint32_xor2(t50, t53);
    const t58 = uint32_xor2(z4, t46);
    const t59 = uint32_xor2(z3, t54);
    const t60 = uint32_xor2(t46, t57);
    const t61 = uint32_xor2(z14, t57);
    const t62 = uint32_xor2(t52, t58);
    const t63 = uint32_xor2(t49, t58);
    const t64 = uint32_xor2(z4, t59);
    const t65 = uint32_xor2(t61, t62);
    const t66 = uint32_xor2(z1, t63);
    const s0 = uint32_xor2(t59, t63);
    const s6 = uint32_xor2(t56, uint32_not(t62));
    const s7 = uint32_xor2(t48, uint32_not(t60));
    const t67 = uint32_xor2(t64, t65);
    const s3 = uint32_xor2(t53, t66);
    const s4 = uint32_xor2(t51, t66);
    const s5 = uint32_xor2(t47, t65);
    const s1 = uint32_xor2(t64, uint32_not(s3));
    const s2 = uint32_xor2(t55, uint32_not(t67));
    q[7] = s0;
    q[6] = s1;
    q[5] = s2;
    q[4] = s3;
    q[3] = s4;
    q[2] = s5;
    q[1] = s6;
    q[0] = s7;
}
function shiftRows(q) {
    for(let i = 0; i < 8; i++){
        const x = q[i];
        q[i] = uint32_or(uint32_and(x, shiftRowsMask0), uint32_shiftRight(uint32_and(x, shiftRowsMask1), 2), uint32_shiftLeft(uint32_and(x, shiftRowsMask2), 6), uint32_shiftRight(uint32_and(x, shiftRowsMask3), 4), uint32_shiftLeft(uint32_and(x, shiftRowsMask4), 4), uint32_shiftRight(uint32_and(x, shiftRowsMask5), 6), uint32_shiftLeft(uint32_and(x, shiftRowsMask6), 2));
    }
}
function mixColumns(q) {
    const q0 = q[0];
    const q1 = q[1];
    const q2 = q[2];
    const q3 = q[3];
    const q4 = q[4];
    const q5 = q[5];
    const q6 = q[6];
    const q7 = q[7];
    const r0 = uint32_or(uint32_shiftRight(q0, 8), uint32_shiftLeft(q0, 24));
    const r1 = uint32_or(uint32_shiftRight(q1, 8), uint32_shiftLeft(q1, 24));
    const r2 = uint32_or(uint32_shiftRight(q2, 8), uint32_shiftLeft(q2, 24));
    const r3 = uint32_or(uint32_shiftRight(q3, 8), uint32_shiftLeft(q3, 24));
    const r4 = uint32_or(uint32_shiftRight(q4, 8), uint32_shiftLeft(q4, 24));
    const r5 = uint32_or(uint32_shiftRight(q5, 8), uint32_shiftLeft(q5, 24));
    const r6 = uint32_or(uint32_shiftRight(q6, 8), uint32_shiftLeft(q6, 24));
    const r7 = uint32_or(uint32_shiftRight(q7, 8), uint32_shiftLeft(q7, 24));
    q[0] = uint32_xor(q7, r7, r0, uint32_rotateRight(uint32_xor2(q0, r0), 16));
    q[1] = uint32_xor(q0, r0, q7, r7, r1, uint32_rotateRight(uint32_xor2(q1, r1), 16));
    q[2] = uint32_xor(q1, r1, r2, uint32_rotateRight(uint32_xor2(q2, r2), 16));
    q[3] = uint32_xor(q2, r2, q7, r7, r3, uint32_rotateRight(uint32_xor2(q3, r3), 16));
    q[4] = uint32_xor(q3, r3, q7, r7, r4, uint32_rotateRight(uint32_xor2(q4, r4), 16));
    q[5] = uint32_xor(q4, r4, r5, uint32_rotateRight(uint32_xor2(q5, r5), 16));
    q[6] = uint32_xor(q5, r5, r6, uint32_rotateRight(uint32_xor2(q6, r6), 16));
    q[7] = uint32_xor(q6, r6, r7, uint32_rotateRight(uint32_xor2(q7, r7), 16));
}
function load4xU32(q, src) {
    const srcView = new DataView(src.buffer);
    q[0] = srcView.getUint32(0 + src.byteOffset, true);
    q[2] = srcView.getUint32(4 + src.byteOffset, true);
    q[4] = srcView.getUint32(8 + src.byteOffset, true);
    q[6] = srcView.getUint32(12 + src.byteOffset, true);
    q[1] = 0;
    q[3] = 0;
    q[5] = 0;
    q[7] = 0;
    ortho(q);
}
function load8xU32(q, src0, src1) {
    const src0View = new DataView(src0.buffer);
    const src1View = new DataView(src1.buffer);
    q[0] = src0View.getUint32(0 + src0.byteOffset, true);
    q[2] = src0View.getUint32(4 + src0.byteOffset, true);
    q[4] = src0View.getUint32(8 + src0.byteOffset, true);
    q[6] = src0View.getUint32(12 + src0.byteOffset, true);
    q[1] = src1View.getUint32(0 + src1.byteOffset, true);
    q[3] = src1View.getUint32(4 + src1.byteOffset, true);
    q[5] = src1View.getUint32(8 + src1.byteOffset, true);
    q[7] = src1View.getUint32(12 + src1.byteOffset, true);
    ortho(q);
}
function store4xU32(dst, q) {
    ortho(q);
    const dstView = new DataView(dst.buffer);
    dstView.setUint32(0 + dst.byteOffset, q[0], true);
    dstView.setUint32(4 + dst.byteOffset, q[2], true);
    dstView.setUint32(8 + dst.byteOffset, q[4], true);
    dstView.setUint32(12 + dst.byteOffset, q[6], true);
}
function store8xU32(dst0, dst1, q) {
    ortho(q);
    const dst0View = new DataView(dst0.buffer);
    const dst1View = new DataView(dst1.buffer);
    dst0View.setUint32(0 + dst0.byteOffset, q[0], true);
    dst0View.setUint32(4 + dst0.byteOffset, q[2], true);
    dst0View.setUint32(8 + dst0.byteOffset, q[4], true);
    dst0View.setUint32(12 + dst0.byteOffset, q[6], true);
    dst1View.setUint32(0 + dst1.byteOffset, q[1], true);
    dst1View.setUint32(4 + dst1.byteOffset, q[3], true);
    dst1View.setUint32(8 + dst1.byteOffset, q[5], true);
    dst1View.setUint32(12 + dst1.byteOffset, q[7], true);
}
function ortho(q) {
    for(let i = 0; i < 8; i += 2){
        const q0 = q[i];
        const q1 = q[i + 1];
        q[i] = uint32_or(uint32_and(q0, oddsMask), uint32_shiftLeft(uint32_and(q1, oddsMask), 1));
        q[i + 1] = uint32_or(uint32_shiftRight(uint32_and(q0, evensMask), 1), uint32_and(q1, evensMask));
    }
    for(let i = 0; i < 8; i += 4){
        const q0 = q[i];
        const q1 = q[i + 1];
        const q2 = q[i + 2];
        const q3 = q[i + 3];
        q[i] = uint32_or(uint32_and(q0, cl4), uint32_shiftLeft(uint32_and(q2, cl4), 2));
        q[i + 2] = uint32_or(uint32_shiftRight(uint32_and(q0, ch4), 2), uint32_and(q2, ch4));
        q[i + 1] = uint32_or(uint32_and(q1, cl4), uint32_shiftLeft(uint32_and(q3, cl4), 2));
        q[i + 3] = uint32_or(uint32_shiftRight(uint32_and(q1, ch4), 2), uint32_and(q3, ch4));
    }
    for(let i = 0; i < 4; i++){
        const q0 = q[i];
        const q4 = q[i + 4];
        q[i] = uint32_or(uint32_and(q0, cl8), uint32_shiftLeft(uint32_and(q4, cl8), 4));
        q[i + 4] = uint32_or(uint32_shiftRight(uint32_and(q0, ch8), 4), uint32_and(q4, ch8));
    }
}
function rkeyOrtho(q, key) {
    const keyView = new DataView(key.buffer);
    for(let i = 0; i < 4; i++){
        const x = keyView.getUint32(i * 4 + key.byteOffset, true);
        q[i * 2] = x;
        q[i * 2 + 1] = x;
    }
    ortho(q);
    for(let i = 0, j = 0; i < 4; i = i + 1, j = j + 2){
        let x = uint32_or(uint32_and(q[j + 0], oddsMask), uint32_and(q[j + 1], evensMask));
        let y = x;
        x = uint32_and(x, oddsMask);
        q[j] = uint32_or(x, uint32_shiftLeft(x, 1));
        y = uint32_and(y, evensMask);
        q[j + 1] = uint32_or(y, uint32_shiftRight(y, 1));
    }
}
// src/deoxysii.ts
var KeySize = 32;
var NonceSize = 15;
var TagSize = 16;
var stkSize = 16;
var rounds = 16;
var blockSize = 16;
var tweakSize = 16;
var prefixADBlock = 2;
var prefixADFinal = 6;
var prefixMsgBlock = 0;
var prefixMsgFinal = 4;
var prefixTag = 1;
var prefixShift = 4;
function xorBytes(dst, a, b, n) {
    for(let i = 0; i < n; i++)dst[i] = a[i] ^ b[i];
}
var rcons = new Uint8Array([
    47,
    94,
    188,
    99,
    198,
    151,
    53,
    106,
    212,
    179,
    125,
    250,
    239,
    197,
    145,
    57,
    114
]);
function h(t) {
    t.set(new Uint8Array([
        t[1],
        t[6],
        t[11],
        t[12],
        t[5],
        t[10],
        t[15],
        t[0],
        t[9],
        t[14],
        t[3],
        t[4],
        t[13],
        t[2],
        t[7],
        t[8]
    ]));
}
function lfsr2(t) {
    for(let i = 0; i < stkSize; i++){
        const x = t[i];
        const x7 = x >> 7;
        const x5 = x >> 5 & 1;
        t[i] = x << 1 | x7 ^ x5;
    }
}
function lfsr3(t) {
    for(let i = 0; i < stkSize; i++){
        const x = t[i];
        const x0 = x & 1;
        const x6 = x >> 6 & 1;
        t[i] = x >> 1 | (x0 ^ x6) << 7;
    }
}
function xorRC(t, i) {
    t[0] ^= 1;
    t[1] ^= 2;
    t[2] ^= 4;
    t[3] ^= 8;
    t[4] ^= rcons[i];
    t[5] ^= rcons[i];
    t[6] ^= rcons[i];
    t[7] ^= rcons[i];
}
function stkDeriveK(key, derivedKs) {
    const tk2 = key.subarray(16, 32);
    const tk3 = key.subarray(0, 16);
    xorBytes(derivedKs[0], tk2, tk3, stkSize);
    xorRC(derivedKs[0], 0);
    for(let i = 1; i <= rounds; i++){
        lfsr2(tk2);
        h(tk2);
        lfsr3(tk3);
        h(tk3);
        xorBytes(derivedKs[i], tk2, tk3, stkSize);
        xorRC(derivedKs[i], i);
    }
}
function deriveSubTweakKeys(stks, derivedKs, tweak) {
    const tk1 = new Uint8Array(tweak);
    xorBytes(stks[0], derivedKs[0], tk1, stkSize);
    for(let i = 1; i <= rounds; i++){
        h(tk1);
        xorBytes(stks[i], derivedKs[i], tk1, stkSize);
    }
}
function newStks() {
    const stks = [];
    for(let i = 0; i <= rounds; i++)stks.push(new Uint8Array(16));
    return stks;
}
function ct32_bcEncrypt(ciphertext, derivedKs, tweak, plaintext) {
    const stks = newStks();
    deriveSubTweakKeys(stks, derivedKs, tweak);
    const q = newQ();
    const stk = newQ();
    load4xU32(q, plaintext);
    load4xU32(stk, stks[0]);
    addRoundKey(q, stk);
    for(let i = 1; i <= rounds; i++){
        subBytes(q);
        shiftRows(q);
        mixColumns(q);
        load4xU32(stk, stks[i]);
        addRoundKey(q, stk);
    }
    store4xU32(ciphertext, q);
}
function ct32_bcKeystreamx2(ciphertext, derivedKs, tweaks, nonce) {
    const stks = [
        newStks(),
        newStks()
    ];
    for(let i = 0; i < 2; i++)deriveSubTweakKeys(stks[i], derivedKs, tweaks[i]);
    const q = newQ();
    const stk = newQ();
    rkeyOrtho(q, nonce);
    load8xU32(stk, stks[0][0], stks[1][0]);
    addRoundKey(q, stk);
    for(let i = 1; i <= rounds; i++){
        subBytes(q);
        shiftRows(q);
        mixColumns(q);
        load8xU32(stk, stks[0][i], stks[1][i]);
        addRoundKey(q, stk);
    }
    store8xU32(ciphertext.subarray(0, 16), ciphertext.subarray(16, 32), q);
}
function ct32_bcTagx1(tag, derivedKs, tweak, plaintext) {
    const stks = newStks();
    deriveSubTweakKeys(stks, derivedKs, tweak);
    const q = newQ();
    const stk = newQ();
    load4xU32(q, plaintext);
    load4xU32(stk, stks[0]);
    addRoundKey(q, stk);
    for(let i = 1; i <= rounds; i++){
        subBytes(q);
        shiftRows(q);
        mixColumns(q);
        load4xU32(stk, stks[i]);
        addRoundKey(q, stk);
    }
    const tagView = new DataView(tag.buffer);
    let tag0 = tagView.getUint32(0, true);
    let tag1 = tagView.getUint32(4, true);
    let tag2 = tagView.getUint32(8, true);
    let tag3 = tagView.getUint32(12, true);
    ortho(q);
    tag0 = uint32_xor2(tag0, q[0]);
    tag1 = uint32_xor2(tag1, q[2]);
    tag2 = uint32_xor2(tag2, q[4]);
    tag3 = uint32_xor2(tag3, q[6]);
    tagView.setUint32(0, tag0, true);
    tagView.setUint32(4, tag1, true);
    tagView.setUint32(8, tag2, true);
    tagView.setUint32(12, tag3, true);
}
function ct32_bcTagx2(tag, derivedKs, tweaks, plaintext) {
    const stks = [
        newStks(),
        newStks()
    ];
    for(let i = 0; i < 2; i++)deriveSubTweakKeys(stks[i], derivedKs, tweaks[i]);
    const q = newQ();
    const stk = newQ();
    load8xU32(q, plaintext.subarray(0, 16), plaintext.subarray(16, 32));
    load8xU32(stk, stks[0][0], stks[1][0]);
    addRoundKey(q, stk);
    for(let i = 1; i <= rounds; i++){
        subBytes(q);
        shiftRows(q);
        mixColumns(q);
        load8xU32(stk, stks[0][i], stks[1][i]);
        addRoundKey(q, stk);
    }
    const tagView = new DataView(tag.buffer);
    let tag0 = tagView.getUint32(0, true);
    let tag1 = tagView.getUint32(4, true);
    let tag2 = tagView.getUint32(8, true);
    let tag3 = tagView.getUint32(12, true);
    ortho(q);
    tag0 = uint32_xor3(tag0, q[0], q[1]);
    tag1 = uint32_xor3(tag1, q[2], q[3]);
    tag2 = uint32_xor3(tag2, q[4], q[5]);
    tag3 = uint32_xor3(tag3, q[6], q[7]);
    tagView.setUint32(0, tag0, true);
    tagView.setUint32(4, tag1, true);
    tagView.setUint32(8, tag2, true);
    tagView.setUint32(12, tag3, true);
}
function encodeTagTweak(out, prefix, blockNr) {
    out.set(new Uint8Array(12));
    new DataView(out.buffer).setUint32(12 + out.byteOffset, blockNr, false);
    out[0] = prefix << prefixShift;
}
function encodeEncTweak(out, tag, blockNr) {
    const tmp = new Uint8Array(4);
    new DataView(tmp.buffer).setUint32(0, blockNr, false);
    out.set(tag);
    out[0] |= 128;
    xorBytes(out.subarray(12, 16), out.subarray(12, 16), tmp, 4);
}
function newTweaks() {
    return [
        new Uint8Array(tweakSize),
        new Uint8Array(tweakSize)
    ];
}
function e(derivedKs, nonce, dst, ad, msg) {
    const tweaks = newTweaks();
    let i = 0;
    let j = 0;
    let adLen = ad.length;
    const auth = new Uint8Array(TagSize);
    for(i = 0; adLen >= 2 * blockSize; i += 2){
        encodeTagTweak(tweaks[0], prefixADBlock, i);
        encodeTagTweak(tweaks[1], prefixADBlock, i + 1);
        ct32_bcTagx2(auth, derivedKs, tweaks, ad.subarray(i * blockSize, (i + 2) * blockSize));
        adLen -= 2 * blockSize;
    }
    for(; adLen >= blockSize; i++){
        encodeTagTweak(tweaks[0], prefixADBlock, i);
        ct32_bcTagx1(auth, derivedKs, tweaks[0], ad.subarray(i * blockSize, (i + 1) * blockSize));
        adLen -= blockSize;
    }
    if (adLen > 0) {
        encodeTagTweak(tweaks[0], prefixADFinal, i);
        const aStar = new Uint8Array(blockSize);
        aStar.set(ad.subarray(ad.length - adLen));
        aStar[adLen] = 128;
        ct32_bcTagx1(auth, derivedKs, tweaks[0], aStar);
    }
    let msgLen = msg.length;
    for(j = 0; msgLen >= 2 * blockSize; j += 2){
        encodeTagTweak(tweaks[0], prefixMsgBlock, j);
        encodeTagTweak(tweaks[1], prefixMsgBlock, j + 1);
        ct32_bcTagx2(auth, derivedKs, tweaks, msg.subarray(j * blockSize, (j + 2) * blockSize));
        msgLen -= 2 * blockSize;
    }
    for(; msgLen >= blockSize; j++){
        encodeTagTweak(tweaks[0], prefixMsgBlock, j);
        ct32_bcTagx1(auth, derivedKs, tweaks[0], msg.subarray(j * blockSize, (j + 1) * blockSize));
        msgLen -= blockSize;
    }
    if (msgLen > 0) {
        encodeTagTweak(tweaks[0], prefixMsgFinal, j);
        const mStar = new Uint8Array(blockSize);
        mStar.set(msg.subarray(msg.length - msgLen));
        mStar[msgLen] = 128;
        ct32_bcTagx1(auth, derivedKs, tweaks[0], mStar);
    }
    const encNonce = new Uint8Array(blockSize);
    encNonce.set(nonce, 1);
    encNonce[0] = prefixTag << prefixShift;
    ct32_bcEncrypt(auth, derivedKs, encNonce, auth);
    encNonce[0] = 0;
    msgLen = msg.length;
    const encBlks = new Uint8Array(2 * blockSize);
    for(j = 0; msgLen >= 2 * blockSize; j += 2){
        encodeEncTweak(tweaks[0], auth, j);
        encodeEncTweak(tweaks[1], auth, j + 1);
        ct32_bcKeystreamx2(encBlks, derivedKs, tweaks, encNonce);
        xorBytes(dst.subarray(j * blockSize, (j + 2) * blockSize), msg.subarray(j * blockSize, (j + 2) * blockSize), encBlks, 2 * blockSize);
        msgLen -= 2 * blockSize;
    }
    for(; msgLen >= blockSize; j++){
        encodeEncTweak(tweaks[0], auth, j);
        ct32_bcEncrypt(encBlks, derivedKs, tweaks[0], encNonce);
        xorBytes(dst.subarray(j * blockSize, (j + 1) * blockSize), msg.subarray(j * blockSize, (j + 1) * blockSize), encBlks, blockSize);
        msgLen -= blockSize;
    }
    if (msgLen > 0) {
        encodeEncTweak(tweaks[0], auth, j);
        ct32_bcEncrypt(encBlks, derivedKs, tweaks[0], encNonce);
        xorBytes(dst.subarray(j * blockSize, msg.length), msg.subarray(j * blockSize), encBlks, msgLen);
    }
    dst.set(auth, msg.length);
}
function d(derivedKs, nonce, dst, ad, ct) {
    let ctLen = ct.length - TagSize;
    const ciphertext = ct.subarray(0, ctLen);
    const tag = ct.subarray(ctLen);
    let j = 0;
    const decTweaks = newTweaks();
    const decNonce = new Uint8Array(blockSize);
    decNonce.set(nonce, 1);
    const decBlks = new Uint8Array(2 * blockSize);
    for(j = 0; ctLen >= 2 * blockSize; j += 2){
        encodeEncTweak(decTweaks[0], tag, j);
        encodeEncTweak(decTweaks[1], tag, j + 1);
        ct32_bcKeystreamx2(decBlks, derivedKs, decTweaks, decNonce);
        xorBytes(dst.subarray(j * blockSize, (j + 2) * blockSize), ciphertext.subarray(j * blockSize, (j + 2) * blockSize), decBlks, 2 * blockSize);
        ctLen -= 2 * blockSize;
    }
    for(; ctLen >= blockSize; j++){
        encodeEncTweak(decTweaks[0], tag, j);
        ct32_bcEncrypt(decBlks, derivedKs, decTweaks[0], decNonce);
        xorBytes(dst.subarray(j * blockSize, (j + 1) * blockSize), ciphertext.subarray(j * blockSize, (j + 1) * blockSize), decBlks, blockSize);
        ctLen -= blockSize;
    }
    if (ctLen > 0) {
        encodeEncTweak(decTweaks[0], tag, j);
        ct32_bcEncrypt(decBlks, derivedKs, decTweaks[0], decNonce);
        xorBytes(dst.subarray(j * blockSize), ciphertext.subarray(j * blockSize), decBlks, ctLen);
    }
    let i = 0;
    let adLen = ad.length;
    const tweaks = newTweaks();
    const auth = new Uint8Array(TagSize);
    for(i = 0; adLen >= 2 * blockSize; i += 2){
        encodeTagTweak(tweaks[0], prefixADBlock, i);
        encodeTagTweak(tweaks[1], prefixADBlock, i + 1);
        ct32_bcTagx2(auth, derivedKs, tweaks, ad.subarray(i * blockSize, (i + 2) * blockSize));
        adLen -= 2 * blockSize;
    }
    for(; adLen >= blockSize; i++){
        encodeTagTweak(tweaks[0], prefixADBlock, i);
        ct32_bcTagx1(auth, derivedKs, tweaks[0], ad.subarray(i * blockSize, (i + 1) * blockSize));
        adLen -= blockSize;
    }
    if (adLen > 0) {
        encodeTagTweak(tweaks[0], prefixADFinal, i);
        const aStar = new Uint8Array(blockSize);
        aStar.set(ad.subarray(ad.length - adLen));
        aStar[adLen] = 128;
        ct32_bcTagx1(auth, derivedKs, tweaks[0], aStar);
    }
    let msgLen = dst.length;
    for(j = 0; msgLen >= 2 * blockSize; j += 2){
        encodeTagTweak(tweaks[0], prefixMsgBlock, j);
        encodeTagTweak(tweaks[1], prefixMsgBlock, j + 1);
        ct32_bcTagx2(auth, derivedKs, tweaks, dst.subarray(j * blockSize, (j + 2) * blockSize));
        msgLen -= 2 * blockSize;
    }
    for(; msgLen >= blockSize; j++){
        encodeTagTweak(tweaks[0], prefixMsgBlock, j);
        ct32_bcTagx1(auth, derivedKs, tweaks[0], dst.subarray(j * blockSize, (j + 1) * blockSize));
        msgLen -= blockSize;
    }
    if (msgLen > 0) {
        encodeTagTweak(tweaks[0], prefixMsgFinal, j);
        const mStar = new Uint8Array(blockSize);
        mStar.set(dst.subarray(dst.length - msgLen));
        mStar[msgLen] = 128;
        ct32_bcTagx1(auth, derivedKs, tweaks[0], mStar);
    }
    decNonce[0] = prefixTag << prefixShift;
    ct32_bcEncrypt(auth, derivedKs, decNonce, auth);
    if (auth.length !== tag.length) return false;
    let eql = true;
    for(i = 0; i < auth.length; i++)eql &= !(auth[i] ^ tag[i]);
    return eql;
}
var AEAD = class {
    constructor(key){
        __publicField(this, "derivedKs");
        if (key.length !== KeySize) throw ErrKeySize;
        this.derivedKs = newStks();
        stkDeriveK(key, this.derivedKs);
    }
    encrypt(nonce, plaintext = null, associatedData = null) {
        if (nonce.length !== NonceSize) throw ErrNonceSize;
        if (plaintext == null) plaintext = zeroBuffer;
        if (associatedData == null) associatedData = zeroBuffer;
        const dst = new Uint8Array(plaintext.length + TagSize);
        e(this.derivedKs, nonce, dst, associatedData, plaintext);
        return dst;
    }
    decrypt(nonce, ciphertext, associatedData = null) {
        if (nonce.length !== NonceSize) throw ErrNonceSize;
        if (ciphertext.length < TagSize) throw ErrOpen;
        if (associatedData == null) associatedData = zeroBuffer;
        const dst = new Uint8Array(ciphertext.length - TagSize);
        if (!d(this.derivedKs, nonce, dst, associatedData, ciphertext)) {
            dst.set(new Uint8Array(dst.length));
            throw ErrOpen;
        }
        return dst;
    }
};
var zeroBuffer = new Uint8Array(0);
var ErrKeySize = "deoxysii: invalid key size";
var ErrNonceSize = "deoxysii: invalid nonce size";
var ErrOpen = "deoxysii: message authentication failure";
// src/index.ts
var src_default = deoxysii_exports;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6RnZ1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deriveSymmetricKey = deriveSymmetricKey;
exports.boxSeal = boxSeal;
exports.boxOpen = boxOpen;
const hmac_1 = require("c53ba21e55dd74f3");
const sha512_1 = require("29a83d90d0ba59d5");
const deoxysii = require("32081e697c14c0a3");
const nacl = require("ea61341b4ac7c9cf");
const BOX_KDF_TWEAK = 'MRAE_Box_Deoxys-II-256-128';
/**
 * deriveSymmetricKey derives a MRAE AEAD symmetric key suitable for use with the asymmetric
 * box primitives from the provided X25519 public and private keys.
 */ function deriveSymmetricKey(publicKey, privateKey) {
    const pmk = nacl.scalarMult(privateKey, publicKey);
    return (0, hmac_1.hmac)(sha512_1.sha512_256, BOX_KDF_TWEAK, pmk);
}
/**
 * boxSeal boxes ("seals") the provided additional data and plaintext via
 * Deoxys-II-256-128 using a symmetric key derived from the provided
 * X25519 public and private keys.
 */ function boxSeal(nonce, plainText, associateData, publicKey, privateKey) {
    const sharedKey = deriveSymmetricKey(publicKey, privateKey);
    var aead = new deoxysii.AEAD(sharedKey);
    return aead.encrypt(nonce, plainText, associateData);
}
/**
 * boxOpen unboxes ("opens") the provided additional data and plaintext via
 * Deoxys-II-256-128 using a symmetric key derived from the provided
 * X25519 public and private keys.
 */ function boxOpen(nonce, ciperText, associateData, publicKey, privateKey) {
    const sharedKey = deriveSymmetricKey(publicKey, privateKey);
    var aead = new deoxysii.AEAD(sharedKey);
    return aead.decrypt(nonce, ciperText, associateData);
}

},{"c53ba21e55dd74f3":"dvPH8","29a83d90d0ba59d5":"6lhTf","32081e697c14c0a3":"8OuI3","ea61341b4ac7c9cf":"5ZWFX"}],"6lhTf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sha512_256 = exports.SHA512_256 = exports.sha512_224 = exports.SHA512_224 = exports.sha384 = exports.SHA384 = exports.sha512 = exports.SHA512 = void 0;
/**
 * SHA2-512 a.k.a. sha512 and sha384. It is slower than sha256 in js because u64 operations are slow.
 *
 * Check out [RFC 4634](https://datatracker.ietf.org/doc/html/rfc4634) and
 * [the paper on truncated SHA512/256](https://eprint.iacr.org/2010/548.pdf).
 * @module
 * @deprecated
 */ const sha2_ts_1 = require("d9eb95e81b63ed56");
/** @deprecated Use import from `noble/hashes/sha2` module */ exports.SHA512 = sha2_ts_1.SHA512;
/** @deprecated Use import from `noble/hashes/sha2` module */ exports.sha512 = sha2_ts_1.sha512;
/** @deprecated Use import from `noble/hashes/sha2` module */ exports.SHA384 = sha2_ts_1.SHA384;
/** @deprecated Use import from `noble/hashes/sha2` module */ exports.sha384 = sha2_ts_1.sha384;
/** @deprecated Use import from `noble/hashes/sha2` module */ exports.SHA512_224 = sha2_ts_1.SHA512_224;
/** @deprecated Use import from `noble/hashes/sha2` module */ exports.sha512_224 = sha2_ts_1.sha512_224;
/** @deprecated Use import from `noble/hashes/sha2` module */ exports.SHA512_256 = sha2_ts_1.SHA512_256;
/** @deprecated Use import from `noble/hashes/sha2` module */ exports.sha512_256 = sha2_ts_1.sha512_256;

},{"d9eb95e81b63ed56":"d72fr"}],"h9vOF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Wrapper = exports.METHOD_PARAMETERS = exports.ERR_AMOUNT_NOT_REPRESENTABLE_CODE = exports.ERR_CONSENSUS_INCOMPATIBLE_SIGNER_CODE = exports.ERR_INTERNAL_STATE_ERROR_CODE = exports.ERR_INVALID_DENOMINATION_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = void 0;
const wrapper = require("cbf0dd0b30accf9d");
/**
 * Unique module name.
 */ exports.MODULE_NAME = 'consensus';
exports.ERR_INVALID_ARGUMENT_CODE = 1;
exports.ERR_INVALID_DENOMINATION_CODE = 2;
exports.ERR_INTERNAL_STATE_ERROR_CODE = 3;
exports.ERR_CONSENSUS_INCOMPATIBLE_SIGNER_CODE = 4;
exports.ERR_AMOUNT_NOT_REPRESENTABLE_CODE = 5;
// Queries.
exports.METHOD_PARAMETERS = 'consensus.Parameters';
class Wrapper extends wrapper.Base {
    constructor(runtimeID){
        super(runtimeID);
    }
    queryAccount() {
        return this.query(exports.METHOD_PARAMETERS);
    }
}
exports.Wrapper = Wrapper;

},{"cbf0dd0b30accf9d":"eyJxF"}],"khy1A":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Wrapper = exports.EVENT_WITHDRAW_CODE = exports.EVENT_DEPOSIT_CODE = exports.METHOD_ACCOUNT = exports.METHOD_BALANCE = exports.METHOD_WITHDRAW = exports.METHOD_DEPOSIT = exports.ERR_INSUFFICIENT_WITHDRAW_BALANCE_CODE = exports.ERR_INVALID_DENOMINATION_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = void 0;
exports.moduleEventHandler = moduleEventHandler;
const wrapper = require("5a631a626d658c0a");
/**
 * Unique module name.
 */ exports.MODULE_NAME = 'consensus_accounts';
exports.ERR_INVALID_ARGUMENT_CODE = 1;
exports.ERR_INVALID_DENOMINATION_CODE = 2;
exports.ERR_INSUFFICIENT_WITHDRAW_BALANCE_CODE = 3;
// Callable methods.
exports.METHOD_DEPOSIT = 'consensus.Deposit';
exports.METHOD_WITHDRAW = 'consensus.Withdraw';
// Queries.
exports.METHOD_BALANCE = 'consensus.Balance';
exports.METHOD_ACCOUNT = 'consensus.Account';
// Events.
exports.EVENT_DEPOSIT_CODE = 1;
exports.EVENT_WITHDRAW_CODE = 2;
class Wrapper extends wrapper.Base {
    constructor(runtimeID){
        super(runtimeID);
    }
    callDeposit() {
        return this.call(exports.METHOD_DEPOSIT);
    }
    callWithdraw() {
        return this.call(exports.METHOD_WITHDRAW);
    }
    queryBalance() {
        return this.query(exports.METHOD_BALANCE);
    }
    queryAccount() {
        return this.query(exports.METHOD_ACCOUNT);
    }
}
exports.Wrapper = Wrapper;
function moduleEventHandler(codes) {
    return [
        exports.MODULE_NAME,
        codes
    ];
}

},{"5a631a626d658c0a":"eyJxF"}],"gl6pB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Wrapper = exports.PUBLIC_KEY_KIND_TRANSACTION = exports.STORE_KIND_CONFIDENTIAL = exports.STORE_KIND_PUBLIC = exports.METHOD_CUSTOM = exports.METHOD_PUBLIC_KEY = exports.METHOD_INSTANCE_RAW_STORAGE = exports.METHOD_INSTANCE_STORAGE = exports.METHOD_INSTANCE = exports.METHOD_CODE_STORAGE = exports.METHOD_CODE = exports.METHOD_CHANGE_UPGRADE_POLICY = exports.METHOD_UPGRADE = exports.METHOD_CALL = exports.METHOD_INSTANTIATE = exports.METHOD_UPLOAD = exports.ERR_CODE_ALREADY_UPGRADED_CODE = exports.ERR_TOO_MANY_SUBCALLS_CODE = exports.ERR_RESULT_TOO_LARGE_CODE = exports.ERR_CALL_DEPTH_EXCEEDED_CODE = exports.ERR_INSUFFICIENT_CALLER_BALANCE_CODE = exports.ERR_UNSUPPORTED_CODE = exports.ERR_FORBIDDEN_CODE = exports.ERR_EXECUTION_FAILED_CODE = exports.ERR_MODULE_LOADING_FAILED_CODE = exports.ERR_INSTANCE_NOT_FOUND_CODE = exports.ERR_CODE_NOT_FOUND_CODE = exports.ERR_CODE_DECLARES_TOO_MANY_MEMORIES_CODE = exports.ERR_CODE_DECLARES_START_FUNCTION_CODE = exports.ERR_CODE_DECLARES_RESERVED_EXPORT_CODE = exports.ERR_CODE_MISSING_REQUIRED_EXPORT_CODE = exports.ERR_UNSUPPORTED_ABI_CODE = exports.ERR_CODE_MALFORMED_CODE = exports.ERR_CODE_TOO_LARGE_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = void 0;
const wrapper = require("2b4bb6e4d8250eb6");
/**
 * Unique module name.
 */ exports.MODULE_NAME = 'contracts';
exports.ERR_INVALID_ARGUMENT_CODE = 1;
exports.ERR_CODE_TOO_LARGE_CODE = 2;
exports.ERR_CODE_MALFORMED_CODE = 3;
exports.ERR_UNSUPPORTED_ABI_CODE = 4;
exports.ERR_CODE_MISSING_REQUIRED_EXPORT_CODE = 5;
exports.ERR_CODE_DECLARES_RESERVED_EXPORT_CODE = 6;
exports.ERR_CODE_DECLARES_START_FUNCTION_CODE = 7;
exports.ERR_CODE_DECLARES_TOO_MANY_MEMORIES_CODE = 8;
exports.ERR_CODE_NOT_FOUND_CODE = 9;
exports.ERR_INSTANCE_NOT_FOUND_CODE = 10;
exports.ERR_MODULE_LOADING_FAILED_CODE = 11;
exports.ERR_EXECUTION_FAILED_CODE = 12;
exports.ERR_FORBIDDEN_CODE = 13;
exports.ERR_UNSUPPORTED_CODE = 14;
exports.ERR_INSUFFICIENT_CALLER_BALANCE_CODE = 15;
exports.ERR_CALL_DEPTH_EXCEEDED_CODE = 16;
exports.ERR_RESULT_TOO_LARGE_CODE = 17;
exports.ERR_TOO_MANY_SUBCALLS_CODE = 18;
exports.ERR_CODE_ALREADY_UPGRADED_CODE = 19;
// Callable methods.
exports.METHOD_UPLOAD = 'contracts.Upload';
exports.METHOD_INSTANTIATE = 'contracts.Instantiate';
exports.METHOD_CALL = 'contracts.Call';
exports.METHOD_UPGRADE = 'contracts.Upgrade';
exports.METHOD_CHANGE_UPGRADE_POLICY = 'contracts.ChangeUpgradePolicy';
// Queries.
exports.METHOD_CODE = 'contracts.Code';
exports.METHOD_CODE_STORAGE = 'contracts.CodeStorage';
exports.METHOD_INSTANCE = 'contracts.Instance';
exports.METHOD_INSTANCE_STORAGE = 'contracts.InstanceStorage';
exports.METHOD_INSTANCE_RAW_STORAGE = 'contracts.InstanceRawStorage';
exports.METHOD_PUBLIC_KEY = 'contracts.PublicKey';
exports.METHOD_CUSTOM = 'contracts.Custom';
// Store kind.
exports.STORE_KIND_PUBLIC = 0;
exports.STORE_KIND_CONFIDENTIAL = 1;
// Public key kind.
exports.PUBLIC_KEY_KIND_TRANSACTION = 1;
class Wrapper extends wrapper.Base {
    constructor(runtimeID){
        super(runtimeID);
    }
    callUpload() {
        return this.call(exports.METHOD_UPLOAD);
    }
    callInstantiate() {
        return this.call(exports.METHOD_INSTANTIATE);
    }
    callCall() {
        return this.call(exports.METHOD_CALL);
    }
    callUpgrade() {
        return this.call(exports.METHOD_UPGRADE);
    }
    callChangeUpgradePolicy() {
        return this.call(exports.METHOD_CHANGE_UPGRADE_POLICY);
    }
    queryCode() {
        return this.query(exports.METHOD_CODE);
    }
    queryCodeStorage() {
        return this.query(exports.METHOD_CODE_STORAGE);
    }
    queryInstance() {
        return this.query(exports.METHOD_INSTANCE);
    }
    queryInstanceStorage() {
        return this.query(exports.METHOD_INSTANCE_STORAGE);
    }
    queryInstanceRawStorage() {
        return this.query(exports.METHOD_INSTANCE_RAW_STORAGE);
    }
    queryPublicKey() {
        return this.query(exports.METHOD_PUBLIC_KEY);
    }
    queryCustom() {
        return this.query(exports.METHOD_CUSTOM);
    }
}
exports.Wrapper = Wrapper;

},{"2b4bb6e4d8250eb6":"eyJxF"}],"ccPZK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Wrapper = exports.METHODHANDLERKIND_MESSAGE_RESULT = exports.METHODHANDLERKIND_QUERY = exports.METHODHANDLERKIND_CALL = exports.EVENT_GAS_USED = exports.METHOD_RUNTIME_INFO = exports.METHOD_MIN_GAS_PRICE = exports.METHOD_CALL_DATA_PUBLIC_KEY = exports.METHOD_CHECK_INVARIANTS = exports.METHOD_ESTIMATE_GAS = exports.ERR_FORBIDDEN_BY_NODE_POLICY = exports.ERR_FORBIDDEN_IN_SECURE_BUILD = exports.ERR_GAS_PRICE_TOO_LOW_CODE = exports.ERR_NOT_AUTHENTICATED_CODE = exports.ERR_INVALID_CALL_FORMAT_CODE = exports.ERR_INVARIANT_VIOLATION_CODE = exports.ERR_MULTISIG_TOO_MANY_SIGNERS_CODE = exports.ERR_TOO_MANY_AUTH_CODE = exports.ERR_BATCH_OUT_OF_GAS_CODE = exports.ERR_BATCH_GAS_OVERFLOW_CODE = exports.ERR_OUT_OF_GAS_CODE = exports.ERR_GAS_OVERFLOW_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.ERR_MESSAGE_HANDLER_MISSING_CODE = exports.ERR_MESSAGE_NOT_HANDLED_CODE = exports.ERR_OUT_OF_MESSAGE_SLOTS_CODE = exports.ERR_INSUFFICIENT_FEE_BALANCE_CODE = exports.ERR_INVALID_NONCE_CODE = exports.ERR_INVALID_METHOD_CODE = exports.ERR_INVALID_TRANSACTION_CODE = exports.ERR_MALFORMED_TRANSACTION_CODE = exports.MODULE_NAME = void 0;
exports.moduleEventHandler = moduleEventHandler;
const wrapper = require("aab661974e712903");
/**
 * Unique module name.
 */ exports.MODULE_NAME = 'core';
exports.ERR_MALFORMED_TRANSACTION_CODE = 1;
exports.ERR_INVALID_TRANSACTION_CODE = 2;
exports.ERR_INVALID_METHOD_CODE = 3;
exports.ERR_INVALID_NONCE_CODE = 4;
exports.ERR_INSUFFICIENT_FEE_BALANCE_CODE = 5;
exports.ERR_OUT_OF_MESSAGE_SLOTS_CODE = 6;
exports.ERR_MESSAGE_NOT_HANDLED_CODE = 8;
exports.ERR_MESSAGE_HANDLER_MISSING_CODE = 9;
exports.ERR_INVALID_ARGUMENT_CODE = 10;
exports.ERR_GAS_OVERFLOW_CODE = 11;
exports.ERR_OUT_OF_GAS_CODE = 12;
exports.ERR_BATCH_GAS_OVERFLOW_CODE = 13;
exports.ERR_BATCH_OUT_OF_GAS_CODE = 14;
exports.ERR_TOO_MANY_AUTH_CODE = 15;
exports.ERR_MULTISIG_TOO_MANY_SIGNERS_CODE = 16;
exports.ERR_INVARIANT_VIOLATION_CODE = 17;
exports.ERR_INVALID_CALL_FORMAT_CODE = 18;
exports.ERR_NOT_AUTHENTICATED_CODE = 19;
exports.ERR_GAS_PRICE_TOO_LOW_CODE = 20;
exports.ERR_FORBIDDEN_IN_SECURE_BUILD = 21;
exports.ERR_FORBIDDEN_BY_NODE_POLICY = 22;
// Queries.
exports.METHOD_ESTIMATE_GAS = 'core.EstimateGas';
exports.METHOD_CHECK_INVARIANTS = 'core.CheckInvariants';
exports.METHOD_CALL_DATA_PUBLIC_KEY = 'core.CallDataPublicKey';
exports.METHOD_MIN_GAS_PRICE = 'core.MinGasPrice';
exports.METHOD_RUNTIME_INFO = 'core.RuntimeInfo';
// Events.
exports.EVENT_GAS_USED = 1;
// Introspection.
// Keep these in sync with `CoreMethodHandlerInfo.kind`
exports.METHODHANDLERKIND_CALL = 'call';
exports.METHODHANDLERKIND_QUERY = 'query';
exports.METHODHANDLERKIND_MESSAGE_RESULT = 'message_result';
class Wrapper extends wrapper.Base {
    constructor(runtimeID){
        super(runtimeID);
    }
    queryEstimateGas() {
        return this.query(exports.METHOD_ESTIMATE_GAS);
    }
    queryCheckInvariants() {
        return this.query(exports.METHOD_CHECK_INVARIANTS);
    }
    queryCallDataPublicKey() {
        return this.query(exports.METHOD_CALL_DATA_PUBLIC_KEY);
    }
    queryMinGasPrice() {
        return this.query(exports.METHOD_MIN_GAS_PRICE);
    }
    queryRuntimeInfo() {
        return this.query(exports.METHOD_RUNTIME_INFO);
    }
}
exports.Wrapper = Wrapper;
function moduleEventHandler(codes) {
    return [
        exports.MODULE_NAME,
        codes
    ];
}

},{"aab661974e712903":"eyJxF"}],"2Wbrv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Visitor = void 0;
exports.toKey = toKey;
const oasis = require("12a686e1e003f133");
function toKey(module, code) {
    const codeBuf = new ArrayBuffer(4);
    const codeDV = new DataView(codeBuf);
    codeDV.setUint32(0, code, false);
    return oasis.misc.concat(oasis.misc.fromString(module), new Uint8Array(codeBuf));
}
class Visitor {
    constructor(modules){
        this.handlers = {};
        for (const [module, codes] of modules)for(const code in codes)this.handlers[oasis.misc.toHex(toKey(module, +code))] = codes[code];
    }
    /**
     * Calls one of the handlers based on a given event's key.
     * @param e The event
     * @returns `true` if the event matched one of the handlers
     */ visit(e) {
        const keyHex = oasis.misc.toHex(e.key);
        if (this.handlers[keyHex]) {
            const values = oasis.misc.fromCBOR(e.value);
            for (const value of values)this.handlers[keyHex](e, value);
            return true;
        }
        return false;
    }
}
exports.Visitor = Visitor;

},{"12a686e1e003f133":"9pxEg"}],"8jTT0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Wrapper = exports.METHOD_SIMULATE_CALL = exports.METHOD_BALANCE = exports.METHOD_CODE = exports.METHOD_STORAGE = exports.METHOD_CALL = exports.METHOD_CREATE = exports.EVENT_LOG_CODE = exports.ERROR_SIMULATION_TOO_EXPENSIVE = exports.ERROR_REVERTED_CODE = exports.ERROR_FORBIDDEN_CODE = exports.ERR_INSUFFICIENT_BALANCE_CODE = exports.ERR_GAS_LIMIT_TOO_LOW_CODE = exports.ERR_FEE_OVERFLOW_CODE = exports.ERR_INVALID_SIGNER_TYPE_CODE = exports.ERR_EXECUTION_FAILED_CODE = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = void 0;
exports.moduleEventHandler = moduleEventHandler;
const wrapper = require("6e66f1b33519e667");
/**
 * Unique module name.
 */ exports.MODULE_NAME = 'evm';
exports.ERR_INVALID_ARGUMENT_CODE = 1;
exports.ERR_EXECUTION_FAILED_CODE = 2;
exports.ERR_INVALID_SIGNER_TYPE_CODE = 3;
exports.ERR_FEE_OVERFLOW_CODE = 4;
exports.ERR_GAS_LIMIT_TOO_LOW_CODE = 5;
exports.ERR_INSUFFICIENT_BALANCE_CODE = 6;
exports.ERROR_FORBIDDEN_CODE = 7;
exports.ERROR_REVERTED_CODE = 8;
exports.ERROR_SIMULATION_TOO_EXPENSIVE = 8;
exports.EVENT_LOG_CODE = 1;
// Callable methods.
exports.METHOD_CREATE = 'evm.Create';
exports.METHOD_CALL = 'evm.Call';
// Queries.
exports.METHOD_STORAGE = 'evm.Storage';
exports.METHOD_CODE = 'evm.Code';
exports.METHOD_BALANCE = 'evm.Balance';
exports.METHOD_SIMULATE_CALL = 'evm.SimulateCall';
class Wrapper extends wrapper.Base {
    constructor(runtimeID){
        super(runtimeID);
    }
    callCreate() {
        return this.call(exports.METHOD_CREATE);
    }
    callCall() {
        return this.call(exports.METHOD_CALL);
    }
    queryStorage() {
        return this.query(exports.METHOD_STORAGE);
    }
    queryCode() {
        return this.query(exports.METHOD_CODE);
    }
    queryBalance() {
        return this.query(exports.METHOD_BALANCE);
    }
    querySimulateCall() {
        return this.query(exports.METHOD_SIMULATE_CALL);
    }
}
exports.Wrapper = Wrapper;
function moduleEventHandler(codes) {
    return [
        exports.MODULE_NAME,
        codes
    ];
}

},{"6e66f1b33519e667":"eyJxF"}],"kp7xj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Wrapper = exports.METHOD_PARAMETERS = exports.ERR_INVALID_ARGUMENT_CODE = exports.MODULE_NAME = void 0;
const wrapper = require("bc17690ea5c12f2c");
/**
 * Unique module name.
 */ exports.MODULE_NAME = 'rewards';
exports.ERR_INVALID_ARGUMENT_CODE = 1;
// Queries.
exports.METHOD_PARAMETERS = 'rewards.Parameters';
class Wrapper extends wrapper.Base {
    constructor(runtimeID){
        super(runtimeID);
    }
    queryParameters() {
        return this.query(exports.METHOD_PARAMETERS);
    }
}
exports.Wrapper = Wrapper;

},{"bc17690ea5c12f2c":"eyJxF"}],"82BcB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NobleSigner = exports.BlindContextSigner = void 0;
exports.verify = verify;
const secp256k1_1 = require("ea40e87cc457139d");
const oasis = require("3d4505cdd9f592f0");
function verify(context, message, signature, publicKey) {
    const signerMessage = oasis.signature.prepareSignerMessage(context, message);
    return secp256k1_1.secp256k1.verify(signature, signerMessage, publicKey);
}
class BlindContextSigner {
    constructor(signer){
        this.signer = signer;
    }
    public() {
        return this.signer.public();
    }
    async sign(context, message) {
        const signerMessage = oasis.signature.prepareSignerMessage(context, message);
        return await this.signer.sign(signerMessage);
    }
}
exports.BlindContextSigner = BlindContextSigner;
class NobleSigner {
    constructor(key, note){
        if (note !== 'this key is not important') throw new Error('insecure signer implementation');
        this.key = key;
    }
    static fromRandom(note) {
        return new NobleSigner(secp256k1_1.secp256k1.utils.randomPrivateKey(), note);
    }
    static fromPrivate(priv, note) {
        return new NobleSigner(priv, note);
    }
    public() {
        return secp256k1_1.secp256k1.getPublicKey(this.key);
    }
    async sign(message) {
        const sig = secp256k1_1.secp256k1.sign(message, this.key, {
            lowS: true
        });
        return sig.toDERRawBytes();
    }
}
exports.NobleSigner = NobleSigner;

},{"ea40e87cc457139d":"ls7Nf","3d4505cdd9f592f0":"9pxEg"}],"aIE0N":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

},{}],"dwaV1":[function(require,module,exports,__globalThis) {
/**
 * Constants
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrayContainsArray", ()=>(0, _internalJs.arrayContainsArray));
parcelHelpers.export(exports, "fromAscii", ()=>(0, _internalJs.fromAscii));
parcelHelpers.export(exports, "fromUtf8", ()=>(0, _internalJs.fromUtf8));
parcelHelpers.export(exports, "getBinarySize", ()=>(0, _internalJs.getBinarySize));
parcelHelpers.export(exports, "getKeys", ()=>(0, _internalJs.getKeys));
parcelHelpers.export(exports, "isHexPrefixed", ()=>(0, _internalJs.isHexPrefixed));
parcelHelpers.export(exports, "isHexString", ()=>(0, _internalJs.isHexString));
parcelHelpers.export(exports, "padToEven", ()=>(0, _internalJs.padToEven));
parcelHelpers.export(exports, "stripHexPrefix", ()=>(0, _internalJs.stripHexPrefix));
parcelHelpers.export(exports, "toAscii", ()=>(0, _internalJs.toAscii));
var _constantsJs = require("./constants.js");
parcelHelpers.exportAll(_constantsJs, exports);
/**
 * Units helpers
 */ var _unitsJs = require("./units.js");
parcelHelpers.exportAll(_unitsJs, exports);
/**
 * Account class and helper functions
 */ var _accountJs = require("./account.js");
parcelHelpers.exportAll(_accountJs, exports);
/**
 * Address type
 */ var _addressJs = require("./address.js");
parcelHelpers.exportAll(_addressJs, exports);
/**
 * DB type
 */ var _dbJs = require("./db.js");
parcelHelpers.exportAll(_dbJs, exports);
/**
 * Withdrawal type
 */ var _withdrawalJs = require("./withdrawal.js");
parcelHelpers.exportAll(_withdrawalJs, exports);
/**
 * ECDSA signature
 */ var _signatureJs = require("./signature.js");
parcelHelpers.exportAll(_signatureJs, exports);
/**
 * Utilities for manipulating bytes, Uint8Arrays, etc.
 */ var _bytesJs = require("./bytes.js");
parcelHelpers.exportAll(_bytesJs, exports);
/**
 * Helpful TypeScript types
 */ var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
/**
 * Export ethjs-util methods
 */ var _asyncEventEmitterJs = require("./asyncEventEmitter.js");
parcelHelpers.exportAll(_asyncEventEmitterJs, exports);
var _blobsJs = require("./blobs.js");
parcelHelpers.exportAll(_blobsJs, exports);
var _genesisJs = require("./genesis.js");
parcelHelpers.exportAll(_genesisJs, exports);
var _internalJs = require("./internal.js");
var _kzgJs = require("./kzg.js");
parcelHelpers.exportAll(_kzgJs, exports);
var _lockJs = require("./lock.js");
parcelHelpers.exportAll(_lockJs, exports);
var _mapDBJs = require("./mapDB.js");
parcelHelpers.exportAll(_mapDBJs, exports);
var _providerJs = require("./provider.js");
parcelHelpers.exportAll(_providerJs, exports);

},{"./constants.js":"l5iLS","./units.js":"93fTV","./account.js":"g4QYD","./address.js":"kTrCm","./db.js":"97pyK","./withdrawal.js":"bjY5t","./signature.js":"qPPPA","./bytes.js":"c3kwx","./types.js":"lolJD","./asyncEventEmitter.js":"ksN6N","./blobs.js":"d85bP","./genesis.js":"ioihp","./internal.js":"cy716","./kzg.js":"8kwUs","./lock.js":"24Zb9","./mapDB.js":"icGhk","./provider.js":"eL9v3","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"l5iLS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_UINT64", ()=>MAX_UINT64);
parcelHelpers.export(exports, "MAX_INTEGER", ()=>MAX_INTEGER);
parcelHelpers.export(exports, "MAX_INTEGER_BIGINT", ()=>MAX_INTEGER_BIGINT);
parcelHelpers.export(exports, "SECP256K1_ORDER", ()=>SECP256K1_ORDER);
parcelHelpers.export(exports, "SECP256K1_ORDER_DIV_2", ()=>SECP256K1_ORDER_DIV_2);
parcelHelpers.export(exports, "TWO_POW256", ()=>TWO_POW256);
parcelHelpers.export(exports, "KECCAK256_NULL_S", ()=>KECCAK256_NULL_S);
parcelHelpers.export(exports, "KECCAK256_NULL", ()=>KECCAK256_NULL);
parcelHelpers.export(exports, "KECCAK256_RLP_ARRAY_S", ()=>KECCAK256_RLP_ARRAY_S);
parcelHelpers.export(exports, "KECCAK256_RLP_ARRAY", ()=>KECCAK256_RLP_ARRAY);
parcelHelpers.export(exports, "KECCAK256_RLP_S", ()=>KECCAK256_RLP_S);
parcelHelpers.export(exports, "KECCAK256_RLP", ()=>KECCAK256_RLP);
parcelHelpers.export(exports, "RLP_EMPTY_STRING", ()=>RLP_EMPTY_STRING);
parcelHelpers.export(exports, "MAX_WITHDRAWALS_PER_PAYLOAD", ()=>MAX_WITHDRAWALS_PER_PAYLOAD);
parcelHelpers.export(exports, "RIPEMD160_ADDRESS_STRING", ()=>RIPEMD160_ADDRESS_STRING);
parcelHelpers.export(exports, "BIGINT_NEG1", ()=>BIGINT_NEG1);
parcelHelpers.export(exports, "BIGINT_0", ()=>BIGINT_0);
parcelHelpers.export(exports, "BIGINT_1", ()=>BIGINT_1);
parcelHelpers.export(exports, "BIGINT_2", ()=>BIGINT_2);
parcelHelpers.export(exports, "BIGINT_3", ()=>BIGINT_3);
parcelHelpers.export(exports, "BIGINT_7", ()=>BIGINT_7);
parcelHelpers.export(exports, "BIGINT_8", ()=>BIGINT_8);
parcelHelpers.export(exports, "BIGINT_27", ()=>BIGINT_27);
parcelHelpers.export(exports, "BIGINT_28", ()=>BIGINT_28);
parcelHelpers.export(exports, "BIGINT_31", ()=>BIGINT_31);
parcelHelpers.export(exports, "BIGINT_32", ()=>BIGINT_32);
parcelHelpers.export(exports, "BIGINT_64", ()=>BIGINT_64);
parcelHelpers.export(exports, "BIGINT_128", ()=>BIGINT_128);
parcelHelpers.export(exports, "BIGINT_255", ()=>BIGINT_255);
parcelHelpers.export(exports, "BIGINT_256", ()=>BIGINT_256);
parcelHelpers.export(exports, "BIGINT_96", ()=>BIGINT_96);
parcelHelpers.export(exports, "BIGINT_100", ()=>BIGINT_100);
parcelHelpers.export(exports, "BIGINT_160", ()=>BIGINT_160);
parcelHelpers.export(exports, "BIGINT_224", ()=>BIGINT_224);
parcelHelpers.export(exports, "BIGINT_2EXP96", ()=>BIGINT_2EXP96);
parcelHelpers.export(exports, "BIGINT_2EXP160", ()=>BIGINT_2EXP160);
parcelHelpers.export(exports, "BIGINT_2EXP224", ()=>BIGINT_2EXP224);
parcelHelpers.export(exports, "BIGINT_2EXP256", ()=>BIGINT_2EXP256);
var _secp256K1Js = require("ethereum-cryptography/secp256k1.js");
var _bytesJs = require("./bytes.js");
const MAX_UINT64 = BigInt('0xffffffffffffffff');
const MAX_INTEGER = BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff');
const MAX_INTEGER_BIGINT = BigInt('115792089237316195423570985008687907853269984665640564039457584007913129639935');
const SECP256K1_ORDER = (0, _secp256K1Js.secp256k1).CURVE.n;
const SECP256K1_ORDER_DIV_2 = (0, _secp256K1Js.secp256k1).CURVE.n / BigInt(2);
const TWO_POW256 = BigInt('0x10000000000000000000000000000000000000000000000000000000000000000');
const KECCAK256_NULL_S = '0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470';
const KECCAK256_NULL = (0, _bytesJs.hexToBytes)(KECCAK256_NULL_S);
const KECCAK256_RLP_ARRAY_S = '0x1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347';
const KECCAK256_RLP_ARRAY = (0, _bytesJs.hexToBytes)(KECCAK256_RLP_ARRAY_S);
const KECCAK256_RLP_S = '0x56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421';
const KECCAK256_RLP = (0, _bytesJs.hexToBytes)(KECCAK256_RLP_S);
const RLP_EMPTY_STRING = Uint8Array.from([
    0x80
]);
const MAX_WITHDRAWALS_PER_PAYLOAD = 16;
const RIPEMD160_ADDRESS_STRING = '0000000000000000000000000000000000000003';
const BIGINT_NEG1 = BigInt(-1);
const BIGINT_0 = BigInt(0);
const BIGINT_1 = BigInt(1);
const BIGINT_2 = BigInt(2);
const BIGINT_3 = BigInt(3);
const BIGINT_7 = BigInt(7);
const BIGINT_8 = BigInt(8);
const BIGINT_27 = BigInt(27);
const BIGINT_28 = BigInt(28);
const BIGINT_31 = BigInt(31);
const BIGINT_32 = BigInt(32);
const BIGINT_64 = BigInt(64);
const BIGINT_128 = BigInt(128);
const BIGINT_255 = BigInt(255);
const BIGINT_256 = BigInt(256);
const BIGINT_96 = BigInt(96);
const BIGINT_100 = BigInt(100);
const BIGINT_160 = BigInt(160);
const BIGINT_224 = BigInt(224);
const BIGINT_2EXP96 = BigInt(79228162514264337593543950336);
const BIGINT_2EXP160 = BigInt(1461501637330902918203684832716283019655932542976);
const BIGINT_2EXP224 = BigInt(26959946667150639794667015087019630673637144422540572481103610249216);
const BIGINT_2EXP256 = BIGINT_2 ** BIGINT_256;

},{"ethereum-cryptography/secp256k1.js":"iD195","./bytes.js":"c3kwx","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iD195":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.secp256k1 = void 0;
var secp256k1_1 = require("506d8c52da52467c");
Object.defineProperty(exports, "secp256k1", {
    enumerable: true,
    get: function() {
        return secp256k1_1.secp256k1;
    }
});

},{"506d8c52da52467c":"9jYL1"}],"9jYL1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.encodeToCurve = exports.hashToCurve = exports.schnorr = exports.secp256k1 = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const sha256_1 = require("a89c1505decc763e");
const utils_1 = require("362802f5a451efcb");
const modular_js_1 = require("6a274edd04635854");
const weierstrass_js_1 = require("4687d8e71912c9bd");
const utils_js_1 = require("49209a65a14a4a44");
const hash_to_curve_js_1 = require("992867e7d1ef8b");
const _shortw_utils_js_1 = require("8a5ef77428763709");
const secp256k1P = BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f');
const secp256k1N = BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141');
const _1n = BigInt(1);
const _2n = BigInt(2);
const divNearest = (a, b)=>(a + b / _2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function sqrtMod(y) {
    const P = secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, modular_js_1.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, modular_js_1.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, modular_js_1.pow2)(b9, _2n, P) * b2 % P;
    const b22 = (0, modular_js_1.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, modular_js_1.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, modular_js_1.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, modular_js_1.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, modular_js_1.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, modular_js_1.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, modular_js_1.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, modular_js_1.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, modular_js_1.pow2)(t2, _2n, P);
    if (!Fp.eql(Fp.sqr(root), y)) throw new Error('Cannot find square root');
    return root;
}
const Fp = (0, modular_js_1.Field)(secp256k1P, undefined, undefined, {
    sqrt: sqrtMod
});
exports.secp256k1 = (0, _shortw_utils_js_1.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp,
    n: secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt('55066263022277343669578718895168534326250603453777594175500187360389116729240'),
    Gy: BigInt('32670510020758816978083085130507043184471273380659243275938904335757337482424'),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
        splitScalar: (k)=>{
            const n = secp256k1N;
            const a1 = BigInt('0x3086d221a7d46bcde86c90e49284eb15');
            const b1 = -_1n * BigInt('0xe4437ed6010e88286f547fa90abfe4c3');
            const a2 = BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8');
            const b2 = a1;
            const POW_2_128 = BigInt('0x100000000000000000000000000000000'); // (2n**128n).toString(16)
            const c1 = divNearest(b2 * k, n);
            const c2 = divNearest(-b1 * k, n);
            let k1 = (0, modular_js_1.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, modular_js_1.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error('splitScalar: Endomorphism failed, k=' + k);
            return {
                k1neg,
                k1,
                k2neg,
                k2
            };
        }
    }
}, sha256_1.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const _0n = BigInt(0);
const fe = (x)=>typeof x === 'bigint' && _0n < x && x < secp256k1P;
const ge = (x)=>typeof x === 'bigint' && _0n < x && x < secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const TAGGED_HASH_PREFIXES = {};
function taggedHash(tag, ...messages) {
    let tagP = TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, sha256_1.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, utils_js_1.concatBytes)(tagH, tagH);
        TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, sha256_1.sha256)((0, utils_js_1.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const numTo32b = (n)=>(0, utils_js_1.numberToBytesBE)(n, 32);
const modP = (x)=>(0, modular_js_1.mod)(x, secp256k1P);
const modN = (x)=>(0, modular_js_1.mod)(x, secp256k1N);
const Point = exports.secp256k1.ProjectivePoint;
const GmulAdd = (Q, a, b)=>Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function schnorrGetExtPubKey(priv) {
    let d_ = exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : modN(-d_);
    return {
        scalar: scalar,
        bytes: pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function lift_x(x) {
    if (!fe(x)) throw new Error('bad x: need 0 < x < p'); // Fail if x ≥ p.
    const xx = modP(x * x);
    const c = modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % _2n !== _0n) y = modP(-y); // Return the unique point P such that x(P) = x and
    const p = new Point(x, y, _1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function challenge(...args) {
    return modN((0, utils_js_1.bytesToNumberBE)(taggedHash('BIP0340/challenge', ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function schnorrGetPublicKey(privateKey) {
    return schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function schnorrSign(message, privateKey, auxRand = (0, utils_1.randomBytes)(32)) {
    const m = (0, utils_js_1.ensureBytes)('message', message);
    const { bytes: px, scalar: d } = schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, utils_js_1.ensureBytes)('auxRand', auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = numTo32b(d ^ (0, utils_js_1.bytesToNumberBE)(taggedHash('BIP0340/aux', a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = taggedHash('BIP0340/nonce', t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = modN((0, utils_js_1.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === _0n) throw new Error('sign failed: k is zero'); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set(numTo32b(modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!schnorrVerify(sig, m, px)) throw new Error('sign: Invalid signature produced');
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function schnorrVerify(signature, message, publicKey) {
    const sig = (0, utils_js_1.ensureBytes)('signature', signature, 64);
    const m = (0, utils_js_1.ensureBytes)('message', message);
    const pub = (0, utils_js_1.ensureBytes)('publicKey', publicKey, 32);
    try {
        const P = lift_x((0, utils_js_1.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, utils_js_1.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!fe(r)) return false;
        const s = (0, utils_js_1.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!ge(s)) return false;
        const e = challenge(numTo32b(r), pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = GmulAdd(P, s, modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
exports.schnorr = (()=>({
        getPublicKey: schnorrGetPublicKey,
        sign: schnorrSign,
        verify: schnorrVerify,
        utils: {
            randomPrivateKey: exports.secp256k1.utils.randomPrivateKey,
            lift_x,
            pointToBytes,
            numberToBytesBE: utils_js_1.numberToBytesBE,
            bytesToNumberBE: utils_js_1.bytesToNumberBE,
            taggedHash,
            mod: modular_js_1.mod
        }
    }))();
const isoMap = /* @__PURE__ */ (()=>(0, hash_to_curve_js_1.isogenyMap)(Fp, [
        // xNum
        [
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7',
            '0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581',
            '0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262',
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c'
        ],
        // xDen
        [
            '0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b',
            '0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ],
        // yNum
        [
            '0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c',
            '0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3',
            '0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931',
            '0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84'
        ],
        // yDen
        [
            '0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b',
            '0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573',
            '0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const mapSWU = /* @__PURE__ */ (()=>(0, weierstrass_js_1.mapToCurveSimpleSWU)(Fp, {
        A: BigInt('0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533'),
        B: BigInt('1771'),
        Z: Fp.create(BigInt('-11'))
    }))();
const htf = /* @__PURE__ */ (()=>(0, hash_to_curve_js_1.createHasher)(exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x, y } = mapSWU(Fp.create(scalars[0]));
        return isoMap(x, y);
    }, {
        DST: 'secp256k1_XMD:SHA-256_SSWU_RO_',
        encodeDST: 'secp256k1_XMD:SHA-256_SSWU_NU_',
        p: Fp.ORDER,
        m: 1,
        k: 128,
        expand: 'xmd',
        hash: sha256_1.sha256
    }))();
exports.hashToCurve = (()=>htf.hashToCurve)();
exports.encodeToCurve = (()=>htf.encodeToCurve)();

},{"a89c1505decc763e":"1Sjbu","362802f5a451efcb":"2YjGZ","6a274edd04635854":"4Qud4","4687d8e71912c9bd":"59o2S","49209a65a14a4a44":"dhHdv","992867e7d1ef8b":"brZhJ","8a5ef77428763709":"iUdYV"}],"4Qud4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapHashToField = exports.getMinHashLength = exports.getFieldBytesLength = exports.hashToPrivateScalar = exports.FpSqrtEven = exports.FpSqrtOdd = exports.Field = exports.nLength = exports.FpIsSquare = exports.FpDiv = exports.FpInvertBatch = exports.FpPow = exports.validateField = exports.isNegativeLE = exports.FpSqrt = exports.tonelliShanks = exports.invert = exports.pow2 = exports.pow = exports.mod = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields
const utils_js_1 = require("d8ac4b6c79c60614");
// prettier-ignore
const _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3);
// prettier-ignore
const _4n = BigInt(4), _5n = BigInt(5), _8n = BigInt(8);
// prettier-ignore
const _9n = BigInt(9), _16n = BigInt(16);
// Calculates a modulo b
function mod(a, b) {
    const result = a % b;
    return result >= _0n ? result : b + result;
}
exports.mod = mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function pow(num, power, modulo) {
    if (modulo <= _0n || power < _0n) throw new Error('Expected power/modulo > 0');
    if (modulo === _1n) return _0n;
    let res = _1n;
    while(power > _0n){
        if (power & _1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= _1n;
    }
    return res;
}
exports.pow = pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function pow2(x, power, modulo) {
    let res = x;
    while(power-- > _0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
exports.pow2 = pow2;
// Inverses number over modulo
function invert(number, modulo) {
    if (number === _0n || modulo <= _0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = _0n, y = _1n, u = _1n, v = _0n;
    while(a !== _0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== _1n) throw new Error('invert: does not exist');
    return mod(x, modulo);
}
exports.invert = invert;
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - _1n) / _2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - _1n, S = 0; Q % _2n === _0n; Q /= _2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = _2n; Z < P && pow(Z, legendreC, P) !== P - _1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + _1n) / _4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + _1n) / _2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error('Cannot find square root');
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, _1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
exports.tonelliShanks = tonelliShanks;
function FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % _4n === _3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + _1n) / _4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % _8n === _5n) {
        const c1 = (P - _5n) / _8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, _2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, _2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    _9n;
    // Other cases: Tonelli-Shanks algorithm
    return tonelliShanks(P);
}
exports.FpSqrt = FpSqrt;
// Little-endian check for first LE bit (last BE bit);
const isNegativeLE = (num, modulo)=>(mod(num, modulo) & _1n) === _1n;
exports.isNegativeLE = isNegativeLE;
// prettier-ignore
const FIELD_FIELDS = [
    'create',
    'isValid',
    'is0',
    'neg',
    'inv',
    'sqrt',
    'sqr',
    'eql',
    'add',
    'sub',
    'mul',
    'pow',
    'div',
    'addN',
    'subN',
    'mulN',
    'sqrN'
];
function validateField(field) {
    const initial = {
        ORDER: 'bigint',
        MASK: 'bigint',
        BYTES: 'isSafeInteger',
        BITS: 'isSafeInteger'
    };
    const opts = FIELD_FIELDS.reduce((map, val)=>{
        map[val] = 'function';
        return map;
    }, initial);
    return (0, utils_js_1.validateObject)(field, opts);
}
exports.validateField = validateField;
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < _0n) throw new Error('Expected power > 0');
    if (power === _0n) return f.ONE;
    if (power === _1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > _0n){
        if (power & _1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= _1n;
    }
    return p;
}
exports.FpPow = FpPow;
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
exports.FpInvertBatch = FpInvertBatch;
function FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === 'bigint' ? invert(rhs, f.ORDER) : f.inv(rhs));
}
exports.FpDiv = FpDiv;
// This function returns True whenever the value x is a square in the field F.
function FpIsSquare(f) {
    const legendreConst = (f.ORDER - _1n) / _2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
exports.FpIsSquare = FpIsSquare;
// CURVE.n lengths
function nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength
    };
}
exports.nLength = nLength;
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= _0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error('Field lengths over 2048 bytes are not supported');
    const sqrtP = FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER,
        BITS,
        BYTES,
        MASK: (0, utils_js_1.bitMask)(BITS),
        ZERO: _0n,
        ONE: _1n,
        create: (num)=>mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== 'bigint') throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return _0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === _0n,
        isOdd: (num)=>(num & _1n) === _1n,
        neg: (num)=>mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>mod(num * num, ORDER),
        add: (lhs, rhs)=>mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>mod(lhs * rhs, ORDER),
        pow: (num, power)=>FpPow(f, num, power),
        div: (lhs, rhs)=>mod(lhs * invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, utils_js_1.numberToBytesLE)(num, BYTES) : (0, utils_js_1.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, utils_js_1.bytesToNumberLE)(bytes) : (0, utils_js_1.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
exports.Field = Field;
function FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
exports.FpSqrtOdd = FpSqrtOdd;
function FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
exports.FpSqrtEven = FpSqrtEven;
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */ function hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, utils_js_1.ensureBytes)('privateHash', hash);
    const hashLen = hash.length;
    const minLen = nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, utils_js_1.bytesToNumberLE)(hash) : (0, utils_js_1.bytesToNumberBE)(hash);
    return mod(num, groupOrder - _1n) + _1n;
}
exports.hashToPrivateScalar = hashToPrivateScalar;
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== 'bigint') throw new Error('field order must be bigint');
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
exports.getFieldBytesLength = getFieldBytesLength;
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function getMinHashLength(fieldOrder) {
    const length = getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
exports.getMinHashLength = getMinHashLength;
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = getFieldBytesLength(fieldOrder);
    const minLen = getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, utils_js_1.bytesToNumberBE)(key) : (0, utils_js_1.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = mod(num, fieldOrder - _1n) + _1n;
    return isLE ? (0, utils_js_1.numberToBytesLE)(reduced, fieldLen) : (0, utils_js_1.numberToBytesBE)(reduced, fieldLen);
}
exports.mapHashToField = mapHashToField;

},{"d8ac4b6c79c60614":"dhHdv"}],"dhHdv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateObject = exports.createHmacDrbg = exports.bitMask = exports.bitSet = exports.bitGet = exports.bitLen = exports.utf8ToBytes = exports.equalBytes = exports.concatBytes = exports.ensureBytes = exports.numberToVarBytesBE = exports.numberToBytesLE = exports.numberToBytesBE = exports.bytesToNumberLE = exports.bytesToNumberBE = exports.hexToBytes = exports.hexToNumber = exports.numberToHexUnpadded = exports.bytesToHex = exports.isBytes = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const _0n = BigInt(0);
const _1n = BigInt(1);
const _2n = BigInt(2);
function isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === 'object' && a.constructor.name === 'Uint8Array';
}
exports.isBytes = isBytes;
// Array where index 0xf0 (240) is mapped to string 'f0'
const hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function bytesToHex(bytes) {
    if (!isBytes(bytes)) throw new Error('Uint8Array expected');
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += hexes[bytes[i]];
    return hex;
}
exports.bytesToHex = bytesToHex;
function numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
exports.numberToHexUnpadded = numberToHexUnpadded;
function hexToNumber(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    // Big Endian
    return BigInt(hex === '' ? '0' : `0x${hex}`);
}
exports.hexToNumber = hexToNumber;
// We use optimized technique to convert hex string to byte array
const asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function asciiToBase16(char) {
    if (char >= asciis._0 && char <= asciis._9) return char - asciis._0;
    if (char >= asciis._A && char <= asciis._F) return char - (asciis._A - 10);
    if (char >= asciis._a && char <= asciis._f) return char - (asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function hexToBytes(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('padded hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = asciiToBase16(hex.charCodeAt(hi));
        const n2 = asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
exports.hexToBytes = hexToBytes;
// BE: Big Endian, LE: Little Endian
function bytesToNumberBE(bytes) {
    return hexToNumber(bytesToHex(bytes));
}
exports.bytesToNumberBE = bytesToNumberBE;
function bytesToNumberLE(bytes) {
    if (!isBytes(bytes)) throw new Error('Uint8Array expected');
    return hexToNumber(bytesToHex(Uint8Array.from(bytes).reverse()));
}
exports.bytesToNumberLE = bytesToNumberLE;
function numberToBytesBE(n, len) {
    return hexToBytes(n.toString(16).padStart(len * 2, '0'));
}
exports.numberToBytesBE = numberToBytesBE;
function numberToBytesLE(n, len) {
    return numberToBytesBE(n, len).reverse();
}
exports.numberToBytesLE = numberToBytesLE;
// Unpadded, rarely used
function numberToVarBytesBE(n) {
    return hexToBytes(numberToHexUnpadded(n));
}
exports.numberToVarBytesBE = numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === 'string') try {
        res = hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if (isBytes(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === 'number' && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
exports.ensureBytes = ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        if (!isBytes(a)) throw new Error('Uint8Array expected');
        sum += a.length;
    }
    let res = new Uint8Array(sum);
    let pad = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
exports.concatBytes = concatBytes;
// Compares 2 u8a-s in kinda constant time
function equalBytes(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
exports.equalBytes = equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function utf8ToBytes(str) {
    if (typeof str !== 'string') throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
exports.utf8ToBytes = utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function bitLen(n) {
    let len;
    for(len = 0; n > _0n; n >>= _1n, len += 1);
    return len;
}
exports.bitLen = bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function bitGet(n, pos) {
    return n >> BigInt(pos) & _1n;
}
exports.bitGet = bitGet;
/**
 * Sets single bit at position.
 */ const bitSet = (n, pos, value)=>{
    return n | (value ? _1n : _0n) << BigInt(pos);
};
exports.bitSet = bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const bitMask = (n)=>(_2n << BigInt(n - 1)) - _1n;
exports.bitMask = bitMask;
// DRBG
const u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== 'number' || hashLen < 2) throw new Error('hashLen must be a number');
    if (typeof qByteLen !== 'number' || qByteLen < 2) throw new Error('qByteLen must be a number');
    if (typeof hmacFn !== 'function') throw new Error('hmacFn must be a function');
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h(u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error('drbg: tried 1000 values');
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
exports.createHmacDrbg = createHmacDrbg;
// Validating curves and fields
const validatorFns = {
    bigint: (val)=>typeof val === 'bigint',
    function: (val)=>typeof val === 'function',
    boolean: (val)=>typeof val === 'boolean',
    string: (val)=>typeof val === 'string',
    stringOrUint8Array: (val)=>typeof val === 'string' || isBytes(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === 'function' && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = validatorFns[type];
        if (typeof checkVal !== 'function') throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
exports.validateObject = validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

},{}],"59o2S":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapToCurveSimpleSWU = exports.SWUFpSqrtRatio = exports.weierstrass = exports.weierstrassPoints = exports.DER = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Short Weierstrass curve. The formula is: y² = x³ + ax + b
const mod = require("d8b1615c256fe3fa");
const ut = require("aae491f09795d5ee");
const utils_js_1 = require("aae491f09795d5ee");
const curve_js_1 = require("11f68d725b0f6f5d");
function validatePointOpts(curve) {
    const opts = (0, curve_js_1.validateBasic)(curve);
    ut.validateObject(opts, {
        a: 'field',
        b: 'field'
    }, {
        allowedPrivateKeyLengths: 'array',
        wrapPrivateKey: 'boolean',
        isTorsionFree: 'function',
        clearCofactor: 'function',
        allowInfinityPoint: 'boolean',
        fromBytes: 'function',
        toBytes: 'function'
    });
    const { endo, Fp, a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error('Endomorphism can only be defined for Koblitz curves that have a=0');
        if (typeof endo !== 'object' || typeof endo.beta !== 'bigint' || typeof endo.splitScalar !== 'function') throw new Error('Expected endomorphism with beta: bigint and splitScalar: function');
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: b2n, hexToBytes: h2b } = ut;
exports.DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ''){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = exports.DER;
        if (data.length < 2 || data[0] !== 0x02) throw new E('Invalid signature integer tag');
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E('Invalid signature integer: wrong length');
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E('Invalid signature integer: negative');
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E('Invalid signature integer: unnecessary leading zero');
        return {
            d: b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = exports.DER;
        const data = typeof hex === 'string' ? h2b(hex) : hex;
        if (!ut.isBytes(data)) throw new Error('ui8a expected');
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E('Invalid signature tag');
        if (data[1] !== l - 2) throw new E('Invalid signature: incorrect length');
        const { d: r, l: sBytes } = exports.DER._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = exports.DER._parseInt(sBytes);
        if (rBytesLeft.length) throw new E('Invalid signature: left bytes after parsing');
        return {
            r,
            s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? '00' + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const _0n = BigInt(0), _1n = BigInt(1), _2n = BigInt(2), _3n = BigInt(3), _4n = BigInt(4);
function weierstrassPoints(opts) {
    const CURVE = validatePointOpts(opts);
    const { Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return ut.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x,
            y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a, b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error('bad generator point: equation left != right');
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === 'bigint' && _0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error('Expected valid bigint: 0 < bigint < curve.n');
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength, wrapPrivateKey, n } = CURVE;
        if (lengths && typeof key !== 'bigint') {
            if (ut.isBytes(key)) key = ut.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== 'string' || !lengths.includes(key.length)) throw new Error('Invalid key');
            key = key.padStart(nByteLength * 2, '0');
        }
        let num;
        try {
            num = typeof key === 'bigint' ? key : ut.bytesToNumberBE((0, utils_js_1.ensureBytes)('private key', key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = mod.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error('ProjectivePoint expected');
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error('x required');
            if (py == null || !Fp.isValid(py)) throw new Error('y required');
            if (pz == null || !Fp.isValid(pz)) throw new Error('z required');
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x, y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error('invalid affine point');
            if (p instanceof Point) throw new Error('projective point not allowed');
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, utils_js_1.ensureBytes)('pointHex', hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error('bad point: ZERO');
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x, y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error('bad point: x or y not FE');
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error('bad point: equation left != right');
            if (!this.isTorsionFree()) throw new Error('bad point: not in prime-order subgroup');
        }
        hasEvenY() {
            const { y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a, b } = CURVE;
            const b3 = Fp.mul(b, _3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, _3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === _0n) return I;
            assertGE(n); // Will throw on 0
            if (n === _1n) return this;
            const { endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg, k1, k2neg, k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > _0n || k2 > _0n){
                if (k1 & _1n) k1p = k1p.add(d);
                if (k2 & _1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= _1n;
                k2 >>= _1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo } = CURVE;
            if (endo) {
                const { k1neg, k1, k2neg, k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p, f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === _0n || a === _1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error('invZ was invalid');
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree } = CURVE;
            if (cofactor === _1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error('isTorsionFree() has not been declared for the elliptic curve');
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor } = CURVE;
            if (cofactor === _1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return ut.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, curve_js_1.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar,
        weierstrassEquation,
        isWithinCurveOrder
    };
}
exports.weierstrassPoints = weierstrassPoints;
function validateOpts(curve) {
    const opts = (0, curve_js_1.validateBasic)(curve);
    ut.validateObject(opts, {
        hash: 'hash',
        hmac: 'function',
        randomBytes: 'function'
    }, {
        bits2int: 'function',
        bits2int_modN: 'function',
        lowS: 'boolean'
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function weierstrass(curveDef) {
    const CURVE = validateOpts(curveDef);
    const { Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return _0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return mod.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return mod.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar, weierstrassEquation, isWithinCurveOrder } = weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = ut.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = ut.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error('Point is not on curve');
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & _1n) === _1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x,
                    y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x,
                    y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>ut.bytesToHex(ut.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> _1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>ut.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, utils_js_1.ensureBytes)('compactSignature', hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r, s } = exports.DER.toSig((0, utils_js_1.ensureBytes)('DER', hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error('r must be 0 < r < CURVE.n');
            if (!isWithinCurveOrder(this.s)) throw new Error('s must be 0 < s < CURVE.n');
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r, s, recovery: rec } = this;
            const h = bits2int_modN((0, utils_js_1.ensureBytes)('msgHash', msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error('recovery id invalid');
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error('recovery id 2 or 3 invalid');
            const prefix = (rec & 1) === 0 ? '02' : '03';
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error('point at infinify'); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return ut.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return ut.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = mod.getMinHashLength(CURVE.n);
            return mod.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = ut.isBytes(item);
        const str = typeof item === 'string';
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error('first arg must be private key');
        if (!isProbPub(publicB)) throw new Error('second arg must be public key');
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = ut.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = ut.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== 'bigint') throw new Error('bigint expected');
        if (!(_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return ut.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            'recovered',
            'canonical'
        ].some((k)=>k in opts)) throw new Error('sign() legacy options not supported');
        const { hash, randomBytes } = CURVE;
        let { lowS, prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, utils_js_1.ensureBytes)('msgHash', msgHash);
        if (prehash) msgHash = (0, utils_js_1.ensureBytes)('prehashed msgHash', hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, utils_js_1.ensureBytes)('extraEntropy', e)); // check for being bytes
        }
        const seed = ut.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === _0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === _0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & _1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed,
            k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed, k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = ut.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, utils_js_1.ensureBytes)('msgHash', msgHash);
        publicKey = (0, utils_js_1.ensureBytes)('publicKey', publicKey);
        if ('strict' in opts) throw new Error('options.strict was renamed to lowS');
        const { lowS, prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === 'string' || ut.isBytes(sg)) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === 'object' && typeof sg.r === 'bigint' && typeof sg.s === 'bigint') {
                const { r, s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error('PARSE');
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === 'PARSE') throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r, s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE,
        getPublicKey,
        getSharedSecret,
        sign,
        verify,
        ProjectivePoint: Point,
        Signature,
        utils
    };
}
exports.weierstrass = weierstrass;
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = _0n;
    for(let o = q - _1n; o % _2n === _0n; o /= _2n)l += _1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = _2n << c1 - _1n - _1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * _2n;
    const c2 = (q - _1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - _1n) / _2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - _1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + _1n) / _2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > _1n; i--){
            let tv5 = i - _2n; // 18.    tv5 = i - 2
            tv5 = _2n << tv5 - _1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % _4n === _3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - _3n) / _4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
exports.SWUFpSqrtRatio = SWUFpSqrtRatio;
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function mapToCurveSimpleSWU(Fp, opts) {
    mod.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error('mapToCurveSimpleSWU: invalid opts');
    const sqrtRatio = SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error('Fp.isOdd is not implemented!');
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid, value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x,
            y
        };
    };
}
exports.mapToCurveSimpleSWU = mapToCurveSimpleSWU;

},{"d8b1615c256fe3fa":"4Qud4","aae491f09795d5ee":"dhHdv","11f68d725b0f6f5d":"4cArC"}],"4cArC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateBasic = exports.wNAF = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities
const modular_js_1 = require("72c8f755a25fddc3");
const utils_js_1 = require("f90fcba6ea31de55");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows,
            windowSize
        };
    };
    return {
        constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p,
                f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
exports.wNAF = wNAF;
function validateBasic(curve) {
    (0, modular_js_1.validateField)(curve.Fp);
    (0, utils_js_1.validateObject)(curve, {
        n: 'bigint',
        h: 'bigint',
        Gx: 'field',
        Gy: 'field'
    }, {
        nBitLength: 'isSafeInteger',
        nByteLength: 'isSafeInteger'
    });
    // Set defaults
    return Object.freeze({
        ...(0, modular_js_1.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
exports.validateBasic = validateBasic;

},{"72c8f755a25fddc3":"4Qud4","f90fcba6ea31de55":"dhHdv"}],"brZhJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createHasher = exports.isogenyMap = exports.hash_to_field = exports.expand_message_xof = exports.expand_message_xmd = void 0;
const modular_js_1 = require("eccb35e649679ca");
const utils_js_1 = require("202487820f28c009");
function validateDST(dst) {
    if ((0, utils_js_1.isBytes)(dst)) return dst;
    if (typeof dst === 'string') return (0, utils_js_1.utf8ToBytes)(dst);
    throw new Error('DST must be Uint8Array or string');
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const os2ip = utils_js_1.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function abytes(item) {
    if (!(0, utils_js_1.isBytes)(item)) throw new Error('Uint8Array expected');
}
function isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error('number expected');
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function expand_message_xmd(msg, DST, lenInBytes, H) {
    abytes(msg);
    abytes(DST);
    isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, utils_js_1.concatBytes)((0, utils_js_1.utf8ToBytes)('H2C-OVERSIZE-DST-'), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error('Invalid xmd length');
    const DST_prime = (0, utils_js_1.concatBytes)(DST, i2osp(DST.length, 1));
    const Z_pad = i2osp(0, r_in_bytes);
    const l_i_b_str = i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, utils_js_1.concatBytes)(Z_pad, msg, l_i_b_str, i2osp(0, 1), DST_prime));
    b[0] = H((0, utils_js_1.concatBytes)(b_0, i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            strxor(b_0, b[i - 1]),
            i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, utils_js_1.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, utils_js_1.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
exports.expand_message_xmd = expand_message_xmd;
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function expand_message_xof(msg, DST, lenInBytes, k, H) {
    abytes(msg);
    abytes(DST);
    isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen
        }).update((0, utils_js_1.utf8ToBytes)('H2C-OVERSIZE-DST-')).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error('expand_message_xof: invalid lenInBytes');
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update(i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update(i2osp(DST.length, 1)).digest();
}
exports.expand_message_xof = expand_message_xof;
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function hash_to_field(msg, count, options) {
    (0, utils_js_1.validateObject)(options, {
        DST: 'stringOrUint8Array',
        p: 'bigint',
        m: 'isSafeInteger',
        k: 'isSafeInteger',
        hash: 'hash'
    });
    const { p, k, m, hash, expand, DST: _DST } = options;
    abytes(msg);
    isNum(count);
    const DST = validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === 'xmd') prb = expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === 'xof') prb = expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === '_internal_pass') // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, modular_js_1.mod)(os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
exports.hash_to_field = hash_to_field;
function isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x,
            y
        };
    };
}
exports.isogenyMap = isogenyMap;
function createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== 'function') throw new Error('mapToCurve() must be defined');
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}
exports.createHasher = createHasher;

},{"eccb35e649679ca":"4Qud4","202487820f28c009":"dhHdv"}],"iUdYV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createCurve = exports.getHash = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ const hmac_1 = require("2bb3ed73a71161e3");
const utils_1 = require("808050cc11f056c7");
const weierstrass_js_1 = require("bceff96a5b87336d");
// connects noble-curves to noble-hashes
function getHash(hash) {
    return {
        hash,
        hmac: (key, ...msgs)=>(0, hmac_1.hmac)(hash, key, (0, utils_1.concatBytes)(...msgs)),
        randomBytes: utils_1.randomBytes
    };
}
exports.getHash = getHash;
function createCurve(curveDef, defHash) {
    const create = (hash)=>(0, weierstrass_js_1.weierstrass)({
            ...curveDef,
            ...getHash(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create
    });
}
exports.createCurve = createCurve;

},{"2bb3ed73a71161e3":"iQWkY","808050cc11f056c7":"2YjGZ","bceff96a5b87336d":"59o2S"}],"c3kwx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line no-restricted-imports
parcelHelpers.export(exports, "bytesToUtf8", ()=>(0, _utilsJs.bytesToUtf8));
parcelHelpers.export(exports, "equalsBytes", ()=>(0, _utilsJs.equalsBytes));
parcelHelpers.export(exports, "utf8ToBytes", ()=>(0, _utilsJs.utf8ToBytes));
parcelHelpers.export(exports, "bytesToUnprefixedHex", ()=>bytesToUnprefixedHex);
parcelHelpers.export(exports, "unprefixedHexToBytes", ()=>unprefixedHexToBytes);
parcelHelpers.export(exports, "bytesToHex", ()=>bytesToHex);
parcelHelpers.export(exports, "bytesToBigInt", ()=>bytesToBigInt);
parcelHelpers.export(exports, "bytesToInt", ()=>bytesToInt);
parcelHelpers.export(exports, "hexToBytes", ()=>hexToBytes);
parcelHelpers.export(exports, "intToHex", ()=>intToHex);
parcelHelpers.export(exports, "intToBytes", ()=>intToBytes);
parcelHelpers.export(exports, "bigIntToBytes", ()=>bigIntToBytes);
parcelHelpers.export(exports, "zeros", ()=>zeros);
parcelHelpers.export(exports, "setLengthLeft", ()=>setLengthLeft);
parcelHelpers.export(exports, "setLengthRight", ()=>setLengthRight);
parcelHelpers.export(exports, "unpadBytes", ()=>unpadBytes);
parcelHelpers.export(exports, "unpadArray", ()=>unpadArray);
parcelHelpers.export(exports, "unpadHex", ()=>unpadHex);
parcelHelpers.export(exports, "toBytes", ()=>toBytes);
parcelHelpers.export(exports, "fromSigned", ()=>fromSigned);
parcelHelpers.export(exports, "toUnsigned", ()=>toUnsigned);
parcelHelpers.export(exports, "addHexPrefix", ()=>addHexPrefix);
parcelHelpers.export(exports, "short", ()=>short);
parcelHelpers.export(exports, "validateNoLeadingZeroes", ()=>validateNoLeadingZeroes);
parcelHelpers.export(exports, "bigIntToHex", ()=>bigIntToHex);
parcelHelpers.export(exports, "bigIntMax", ()=>bigIntMax);
parcelHelpers.export(exports, "bigIntMin", ()=>bigIntMin);
parcelHelpers.export(exports, "bigIntToUnpaddedBytes", ()=>bigIntToUnpaddedBytes);
parcelHelpers.export(exports, "intToUnpaddedBytes", ()=>intToUnpaddedBytes);
parcelHelpers.export(exports, "compareBytes", ()=>compareBytes);
parcelHelpers.export(exports, "randomBytes", ()=>randomBytes);
parcelHelpers.export(exports, "concatBytes", ()=>concatBytes);
/**
 * @notice Convert a Uint8Array to a 32-bit integer
 * @param {Uint8Array} bytes The input Uint8Array from which to read the 32-bit integer.
 * @param {boolean} littleEndian True for little-endian, undefined or false for big-endian.
 * @return {number} The 32-bit integer read from the input Uint8Array.
 */ parcelHelpers.export(exports, "bytesToInt32", ()=>bytesToInt32);
/**
 * @notice Convert a Uint8Array to a 64-bit bigint
 * @param {Uint8Array} bytes The input Uint8Array from which to read the 64-bit bigint.
 * @param {boolean} littleEndian True for little-endian, undefined or false for big-endian.
 * @return {bigint} The 64-bit bigint read from the input Uint8Array.
 */ parcelHelpers.export(exports, "bytesToBigInt64", ()=>bytesToBigInt64);
/**
 * @notice Convert a 32-bit integer to a Uint8Array.
 * @param {number} value The 32-bit integer to convert.
 * @param {boolean} littleEndian True for little-endian, undefined or false for big-endian.
 * @return {Uint8Array} A Uint8Array of length 4 containing the integer.
 */ parcelHelpers.export(exports, "int32ToBytes", ()=>int32ToBytes);
/**
 * @notice Convert a 64-bit bigint to a Uint8Array.
 * @param {bigint} value The 64-bit bigint to convert.
 * @param {boolean} littleEndian True for little-endian, undefined or false for big-endian.
 * @return {Uint8Array} A Uint8Array of length 8 containing the bigint.
 */ parcelHelpers.export(exports, "bigInt64ToBytes", ()=>bigInt64ToBytes);
var _randomJs = require("ethereum-cryptography/random.js");
// eslint-disable-next-line no-restricted-imports
var _utilsJs = require("ethereum-cryptography/utils.js");
var _helpersJs = require("./helpers.js");
var _internalJs = require("./internal.js");
const BIGINT_0 = BigInt(0);
const bytesToUnprefixedHex = (0, _utilsJs.bytesToHex);
// hexToBytes cache
const hexToBytesMapFirstKey = {};
const hexToBytesMapSecondKey = {};
for(let i = 0; i < 16; i++){
    const vSecondKey = i;
    const vFirstKey = i * 16;
    const key = i.toString(16).toLowerCase();
    hexToBytesMapSecondKey[key] = vSecondKey;
    hexToBytesMapSecondKey[key.toUpperCase()] = vSecondKey;
    hexToBytesMapFirstKey[key] = vFirstKey;
    hexToBytesMapFirstKey[key.toUpperCase()] = vFirstKey;
}
/**
 * NOTE: only use this function if the string is even, and only consists of hex characters
 * If this is not the case, this function could return weird results
 * @deprecated
 */ function _unprefixedHexToBytes(hex) {
    const byteLen = hex.length;
    const bytes = new Uint8Array(byteLen / 2);
    for(let i = 0; i < byteLen; i += 2)bytes[i / 2] = hexToBytesMapFirstKey[hex[i]] + hexToBytesMapSecondKey[hex[i + 1]];
    return bytes;
}
const unprefixedHexToBytes = (inp)=>{
    if (inp.slice(0, 2) === '0x') throw new Error('hex string is prefixed with 0x, should be unprefixed');
    else return _unprefixedHexToBytes((0, _internalJs.padToEven)(inp));
};
/****************  Borrowed from @chainsafe/ssz */ // Caching this info costs about ~1000 bytes and speeds up toHexString() by x6
const hexByByte = Array.from({
    length: 256
}, (v, i)=>i.toString(16).padStart(2, '0'));
const bytesToHex = (bytes)=>{
    let hex = '0x';
    if (bytes === undefined || bytes.length === 0) return hex;
    for (const byte of bytes)hex += hexByByte[byte];
    return hex;
};
// BigInt cache for the numbers 0 - 256*256-1 (two-byte bytes)
const BIGINT_CACHE = [];
for(let i = 0; i <= 65535; i++)BIGINT_CACHE[i] = BigInt(i);
const bytesToBigInt = (bytes, littleEndian = false)=>{
    if (littleEndian) bytes.reverse();
    const hex = bytesToHex(bytes);
    if (hex === '0x') return BIGINT_0;
    if (hex.length === 4) // If the byte length is 1 (this is faster than checking `bytes.length === 1`)
    return BIGINT_CACHE[bytes[0]];
    if (hex.length === 6) return BIGINT_CACHE[bytes[0] * 256 + bytes[1]];
    return BigInt(hex);
};
const bytesToInt = (bytes)=>{
    const res = Number(bytesToBigInt(bytes));
    if (!Number.isSafeInteger(res)) throw new Error('Number exceeds 53 bits');
    return res;
};
const hexToBytes = (hex)=>{
    if (typeof hex !== 'string') throw new Error(`hex argument type ${typeof hex} must be of type string`);
    if (!/^0x[0-9a-fA-F]*$/.test(hex)) throw new Error(`Input must be a 0x-prefixed hexadecimal string, got ${hex}`);
    hex = hex.slice(2);
    if (hex.length % 2 !== 0) hex = (0, _internalJs.padToEven)(hex);
    return _unprefixedHexToBytes(hex);
};
const intToHex = (i)=>{
    if (!Number.isSafeInteger(i) || i < 0) throw new Error(`Received an invalid integer type: ${i}`);
    return `0x${i.toString(16)}`;
};
const intToBytes = (i)=>{
    const hex = intToHex(i);
    return hexToBytes(hex);
};
const bigIntToBytes = (num, littleEndian = false)=>{
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    const bytes = toBytes('0x' + (0, _internalJs.padToEven)(num.toString(16)));
    return littleEndian ? bytes.reverse() : bytes;
};
const zeros = (bytes)=>{
    return new Uint8Array(bytes);
};
/**
 * Pads a `Uint8Array` with zeros till it has `length` bytes.
 * Truncates the beginning or end of input if its length exceeds `length`.
 * @param {Uint8Array} msg the value to pad
 * @param {number} length the number of bytes the output should be
 * @param {boolean} right whether to start padding form the left or right
 * @return {Uint8Array}
 */ const setLength = (msg, length, right)=>{
    if (right) {
        if (msg.length < length) return new Uint8Array([
            ...msg,
            ...zeros(length - msg.length)
        ]);
        return msg.subarray(0, length);
    } else {
        if (msg.length < length) return new Uint8Array([
            ...zeros(length - msg.length),
            ...msg
        ]);
        return msg.subarray(-length);
    }
};
const setLengthLeft = (msg, length)=>{
    (0, _helpersJs.assertIsBytes)(msg);
    return setLength(msg, length, false);
};
const setLengthRight = (msg, length)=>{
    (0, _helpersJs.assertIsBytes)(msg);
    return setLength(msg, length, true);
};
/**
 * Trims leading zeros from a `Uint8Array`, `number[]` or PrefixedHexString`.
 * @param {Uint8Array|number[]|PrefixedHexString} a
 * @return {Uint8Array|number[]|PrefixedHexString}
 */ const stripZeros = (a)=>{
    let first = a[0];
    while(a.length > 0 && first.toString() === '0'){
        a = a.slice(1);
        first = a[0];
    }
    return a;
};
const unpadBytes = (a)=>{
    (0, _helpersJs.assertIsBytes)(a);
    return stripZeros(a);
};
const unpadArray = (a)=>{
    (0, _helpersJs.assertIsArray)(a);
    return stripZeros(a);
};
const unpadHex = (a)=>{
    (0, _helpersJs.assertIsHexString)(a);
    a = (0, _internalJs.stripHexPrefix)(a);
    return '0x' + stripZeros(a);
};
const toBytes = (v)=>{
    if (v === null || v === undefined) return new Uint8Array();
    if (Array.isArray(v) || v instanceof Uint8Array) return Uint8Array.from(v);
    if (typeof v === 'string') {
        if (!(0, _internalJs.isHexString)(v)) throw new Error(`Cannot convert string to Uint8Array. toBytes only supports 0x-prefixed hex strings and this string was given: ${v}`);
        return hexToBytes(v);
    }
    if (typeof v === 'number') return intToBytes(v);
    if (typeof v === 'bigint') {
        if (v < BIGINT_0) throw new Error(`Cannot convert negative bigint to Uint8Array. Given: ${v}`);
        let n = v.toString(16);
        if (n.length % 2) n = '0' + n;
        return unprefixedHexToBytes(n);
    }
    if (v.toBytes !== undefined) // converts a `TransformableToBytes` object to a Uint8Array
    return v.toBytes();
    throw new Error('invalid type');
};
const fromSigned = (num)=>{
    return BigInt.asIntN(256, bytesToBigInt(num));
};
const toUnsigned = (num)=>{
    return bigIntToBytes(BigInt.asUintN(256, num));
};
const addHexPrefix = (str)=>{
    if (typeof str !== 'string') return str;
    return (0, _internalJs.isHexPrefixed)(str) ? str : '0x' + str;
};
const short = (bytes, maxLength = 50)=>{
    const byteStr = bytes instanceof Uint8Array ? bytesToHex(bytes) : bytes;
    const len = byteStr.slice(0, 2) === '0x' ? maxLength + 2 : maxLength;
    if (byteStr.length <= len) return byteStr;
    return byteStr.slice(0, len) + "\u2026";
};
const validateNoLeadingZeroes = (values)=>{
    for (const [k, v] of Object.entries(values)){
        if (v !== undefined && v.length > 0 && v[0] === 0) throw new Error(`${k} cannot have leading zeroes, received: ${bytesToHex(v)}`);
    }
};
const bigIntToHex = (num)=>{
    return '0x' + num.toString(16);
};
const bigIntMax = (...args)=>args.reduce((m, e)=>e > m ? e : m);
const bigIntMin = (...args)=>args.reduce((m, e)=>e < m ? e : m);
const bigIntToUnpaddedBytes = (value)=>{
    return unpadBytes(bigIntToBytes(value));
};
const intToUnpaddedBytes = (value)=>{
    return unpadBytes(intToBytes(value));
};
const compareBytes = (value1, value2)=>{
    const bigIntValue1 = bytesToBigInt(value1);
    const bigIntValue2 = bytesToBigInt(value2);
    return bigIntValue1 > bigIntValue2 ? 1 : bigIntValue1 < bigIntValue2 ? -1 : 0;
};
const randomBytes = (length)=>{
    return (0, _randomJs.getRandomBytesSync)(length);
};
const concatBytes = (...arrays)=>{
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
};
function bytesToInt32(bytes, littleEndian = false) {
    if (bytes.length < 4) bytes = setLength(bytes, 4, littleEndian);
    const dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    return dataView.getUint32(0, littleEndian);
}
function bytesToBigInt64(bytes, littleEndian = false) {
    if (bytes.length < 8) bytes = setLength(bytes, 8, littleEndian);
    const dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    return dataView.getBigUint64(0, littleEndian);
}
function int32ToBytes(value, littleEndian = false) {
    const buffer = new ArrayBuffer(4);
    const dataView = new DataView(buffer);
    dataView.setUint32(0, value, littleEndian);
    return new Uint8Array(buffer);
}
function bigInt64ToBytes(value, littleEndian = false) {
    const buffer = new ArrayBuffer(8);
    const dataView = new DataView(buffer);
    dataView.setBigUint64(0, value, littleEndian);
    return new Uint8Array(buffer);
}

},{"ethereum-cryptography/random.js":"2DnlE","ethereum-cryptography/utils.js":"7odVe","./helpers.js":"52u5g","./internal.js":"cy716","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2DnlE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRandomBytes = exports.getRandomBytesSync = void 0;
const utils_1 = require("695303df10ec1086");
function getRandomBytesSync(bytes) {
    return (0, utils_1.randomBytes)(bytes);
}
exports.getRandomBytesSync = getRandomBytesSync;
async function getRandomBytes(bytes) {
    return (0, utils_1.randomBytes)(bytes);
}
exports.getRandomBytes = getRandomBytes;

},{"695303df10ec1086":"2YjGZ"}],"7odVe":[function(require,module,exports,__globalThis) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.crypto = exports.wrapHash = exports.equalsBytes = exports.hexToBytes = exports.bytesToUtf8 = exports.utf8ToBytes = exports.createView = exports.concatBytes = exports.toHex = exports.bytesToHex = exports.assertBytes = exports.assertBool = void 0;
const _assert_1 = __importDefault(require("a5ab7a5629530fc6"));
const utils_1 = require("eef052ebf8c98f84");
const assertBool = _assert_1.default.bool;
exports.assertBool = assertBool;
const assertBytes = _assert_1.default.bytes;
exports.assertBytes = assertBytes;
var utils_2 = require("eef052ebf8c98f84");
Object.defineProperty(exports, "bytesToHex", {
    enumerable: true,
    get: function() {
        return utils_2.bytesToHex;
    }
});
Object.defineProperty(exports, "toHex", {
    enumerable: true,
    get: function() {
        return utils_2.bytesToHex;
    }
});
Object.defineProperty(exports, "concatBytes", {
    enumerable: true,
    get: function() {
        return utils_2.concatBytes;
    }
});
Object.defineProperty(exports, "createView", {
    enumerable: true,
    get: function() {
        return utils_2.createView;
    }
});
Object.defineProperty(exports, "utf8ToBytes", {
    enumerable: true,
    get: function() {
        return utils_2.utf8ToBytes;
    }
});
// buf.toString('utf8') -> bytesToUtf8(buf)
function bytesToUtf8(data) {
    if (!(data instanceof Uint8Array)) throw new TypeError(`bytesToUtf8 expected Uint8Array, got ${typeof data}`);
    return new TextDecoder().decode(data);
}
exports.bytesToUtf8 = bytesToUtf8;
function hexToBytes(data) {
    const sliced = data.startsWith("0x") ? data.substring(2) : data;
    return (0, utils_1.hexToBytes)(sliced);
}
exports.hexToBytes = hexToBytes;
// buf.equals(buf2) -> equalsBytes(buf, buf2)
function equalsBytes(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
exports.equalsBytes = equalsBytes;
// Internal utils
function wrapHash(hash) {
    return (msg)=>{
        _assert_1.default.bytes(msg);
        return hash(msg);
    };
}
exports.wrapHash = wrapHash;
// TODO(v3): switch away from node crypto, remove this unnecessary variable.
exports.crypto = (()=>{
    const webCrypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;
    const nodeRequire = typeof module.require === "function" && module.require.bind(module);
    return {
        node: nodeRequire && !webCrypto ? nodeRequire("crypto") : undefined,
        web: webCrypto
    };
})();

},{"a5ab7a5629530fc6":"7eSSE","eef052ebf8c98f84":"2YjGZ"}],"52u5g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "assertIsHexString", ()=>assertIsHexString);
parcelHelpers.export(exports, "assertIsBytes", ()=>assertIsBytes);
parcelHelpers.export(exports, "assertIsArray", ()=>assertIsArray);
parcelHelpers.export(exports, "assertIsString", ()=>assertIsString);
var _internalJs = require("./internal.js");
const assertIsHexString = function(input) {
    if (!(0, _internalJs.isHexString)(input)) {
        const msg = `This method only supports 0x-prefixed hex strings but input was: ${input}`;
        throw new Error(msg);
    }
};
const assertIsBytes = function(input) {
    if (!(input instanceof Uint8Array)) {
        const msg = `This method only supports Uint8Array but input was: ${input}`;
        throw new Error(msg);
    }
};
const assertIsArray = function(input) {
    if (!Array.isArray(input)) {
        const msg = `This method only supports number arrays but input was: ${input}`;
        throw new Error(msg);
    }
};
const assertIsString = function(input) {
    if (typeof input !== 'string') {
        const msg = `This method only supports strings but input was: ${input}`;
        throw new Error(msg);
    }
};

},{"./internal.js":"cy716","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cy716":[function(require,module,exports,__globalThis) {
/*
The MIT License

Copyright (c) 2016 Nick Dodson. nickdodson.com

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns a `Boolean` on whether or not the a `String` starts with '0x'
 * @param str the string input value
 * @return a boolean if it is or is not hex prefixed
 * @throws if the str input is not a string
 */ parcelHelpers.export(exports, "isHexPrefixed", ()=>isHexPrefixed);
parcelHelpers.export(exports, "stripHexPrefix", ()=>stripHexPrefix);
/**
 * Pads a `String` to have an even length
 * @param value
 * @return output
 */ parcelHelpers.export(exports, "padToEven", ()=>padToEven);
/**
 * Get the binary size of a string
 * @param str
 * @returns the number of bytes contained within the string
 */ parcelHelpers.export(exports, "getBinarySize", ()=>getBinarySize);
/**
 * Returns TRUE if the first specified array contains all elements
 * from the second one. FALSE otherwise.
 *
 * @param superset
 * @param subset
 *
 */ parcelHelpers.export(exports, "arrayContainsArray", ()=>arrayContainsArray);
/**
 * Should be called to get ascii from its hex representation
 *
 * @param string in hex
 * @returns ascii string representation of hex value
 */ parcelHelpers.export(exports, "toAscii", ()=>toAscii);
/**
 * Should be called to get hex representation (prefixed by 0x) of utf8 string.
 * Strips leading and trailing 0's.
 *
 * @param string
 * @param optional padding
 * @returns hex representation of input string
 */ parcelHelpers.export(exports, "fromUtf8", ()=>fromUtf8);
/**
 * Should be called to get hex representation (prefixed by 0x) of ascii string
 *
 * @param  string
 * @param  optional padding
 * @returns  hex representation of input string
 */ parcelHelpers.export(exports, "fromAscii", ()=>fromAscii);
/**
 * Returns the keys from an array of objects.
 * @example
 * ```js
 * getKeys([{a: '1', b: '2'}, {a: '3', b: '4'}], 'a') => ['1', '3']
 *````
 * @param  params
 * @param  key
 * @param  allowEmpty
 * @returns output just a simple array of output keys
 */ parcelHelpers.export(exports, "getKeys", ()=>getKeys);
/**
 * Is the string a hex string.
 *
 * @param  value
 * @param  length
 * @returns  output the string is a hex string
 */ parcelHelpers.export(exports, "isHexString", ()=>isHexString);
var _bytesJs = require("./bytes.js");
function isHexPrefixed(str) {
    if (typeof str !== 'string') throw new Error(`[isHexPrefixed] input must be type 'string', received type ${typeof str}`);
    return str[0] === '0' && str[1] === 'x';
}
const stripHexPrefix = (str)=>{
    if (typeof str !== 'string') throw new Error(`[stripHexPrefix] input must be type 'string', received ${typeof str}`);
    return isHexPrefixed(str) ? str.slice(2) : str;
};
function padToEven(value) {
    let a = value;
    if (typeof a !== 'string') throw new Error(`[padToEven] value must be type 'string', received ${typeof a}`);
    if (a.length % 2) a = `0${a}`;
    return a;
}
function getBinarySize(str) {
    if (typeof str !== 'string') throw new Error(`[getBinarySize] method requires input type 'string', received ${typeof str}`);
    return (0, _bytesJs.utf8ToBytes)(str).byteLength;
}
function arrayContainsArray(superset, subset, some) {
    if (Array.isArray(superset) !== true) throw new Error(`[arrayContainsArray] method requires input 'superset' to be an array, got type '${typeof superset}'`);
    if (Array.isArray(subset) !== true) throw new Error(`[arrayContainsArray] method requires input 'subset' to be an array, got type '${typeof subset}'`);
    return subset[some === true ? 'some' : 'every']((value)=>superset.indexOf(value) >= 0);
}
function toAscii(hex) {
    let str = '';
    let i = 0;
    const l = hex.length;
    if (hex.substring(0, 2) === '0x') i = 2;
    for(; i < l; i += 2){
        const code = parseInt(hex.substr(i, 2), 16);
        str += String.fromCharCode(code);
    }
    return str;
}
function fromUtf8(stringValue) {
    const str = (0, _bytesJs.utf8ToBytes)(stringValue);
    return `0x${padToEven((0, _bytesJs.bytesToUnprefixedHex)(str)).replace(/^0+|0+$/g, '')}`;
}
function fromAscii(stringValue) {
    let hex = '';
    for(let i = 0; i < stringValue.length; i++){
        const code = stringValue.charCodeAt(i);
        const n = code.toString(16);
        hex += n.length < 2 ? `0${n}` : n;
    }
    return `0x${hex}`;
}
function getKeys(params, key, allowEmpty) {
    if (!Array.isArray(params)) throw new Error(`[getKeys] method expects input 'params' to be an array, got ${typeof params}`);
    if (typeof key !== 'string') throw new Error(`[getKeys] method expects input 'key' to be type 'string', got ${typeof params}`);
    const result = [];
    for(let i = 0; i < params.length; i++){
        let value = params[i][key];
        if (allowEmpty === true && !value) value = '';
        else if (typeof value !== 'string') throw new Error(`invalid abi - expected type 'string', received ${typeof value}`);
        result.push(value);
    }
    return result;
}
function isHexString(value, length) {
    if (typeof value !== 'string' || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (typeof length !== 'undefined' && length > 0 && value.length !== 2 + 2 * length) return false;
    return true;
}

},{"./bytes.js":"c3kwx","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"93fTV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GWEI_TO_WEI", ()=>GWEI_TO_WEI);
parcelHelpers.export(exports, "formatBigDecimal", ()=>formatBigDecimal);
var _constantsJs = require("./constants.js");
const GWEI_TO_WEI = BigInt(1000000000);
function formatBigDecimal(numerator, denominator, maxDecimalFactor) {
    if (denominator === (0, _constantsJs.BIGINT_0)) denominator = (0, _constantsJs.BIGINT_1);
    const full = numerator / denominator;
    const fraction = (numerator - full * denominator) * maxDecimalFactor / denominator;
    // zeros to be added post decimal are number of zeros in maxDecimalFactor - number of digits in fraction
    const zerosPostDecimal = String(maxDecimalFactor).length - 1 - String(fraction).length;
    return `${full}.${'0'.repeat(zerosPostDecimal)}${fraction}`;
}

},{"./constants.js":"l5iLS","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"g4QYD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Account", ()=>Account);
parcelHelpers.export(exports, "isValidAddress", ()=>isValidAddress);
parcelHelpers.export(exports, "toChecksumAddress", ()=>toChecksumAddress);
parcelHelpers.export(exports, "isValidChecksumAddress", ()=>isValidChecksumAddress);
parcelHelpers.export(exports, "generateAddress", ()=>generateAddress);
parcelHelpers.export(exports, "generateAddress2", ()=>generateAddress2);
parcelHelpers.export(exports, "isValidPrivate", ()=>isValidPrivate);
parcelHelpers.export(exports, "isValidPublic", ()=>isValidPublic);
parcelHelpers.export(exports, "pubToAddress", ()=>pubToAddress);
parcelHelpers.export(exports, "publicToAddress", ()=>publicToAddress);
parcelHelpers.export(exports, "privateToPublic", ()=>privateToPublic);
parcelHelpers.export(exports, "privateToAddress", ()=>privateToAddress);
parcelHelpers.export(exports, "importPublic", ()=>importPublic);
parcelHelpers.export(exports, "zeroAddress", ()=>zeroAddress);
parcelHelpers.export(exports, "isZeroAddress", ()=>isZeroAddress);
parcelHelpers.export(exports, "accountBodyFromSlim", ()=>accountBodyFromSlim);
parcelHelpers.export(exports, "accountBodyToSlim", ()=>accountBodyToSlim);
/**
 * Converts a slim account (per snap protocol spec) to the RLP encoded version of the account
 * @param body Array of 4 Uint8Array-like items to represent the account
 * @returns RLP encoded version of the account
 */ parcelHelpers.export(exports, "accountBodyToRLP", ()=>accountBodyToRLP);
var _rlp = require("@ethereumjs/rlp");
var _keccakJs = require("ethereum-cryptography/keccak.js");
var _secp256K1Js = require("ethereum-cryptography/secp256k1.js");
var _bytesJs = require("./bytes.js");
var _constantsJs = require("./constants.js");
var _helpersJs = require("./helpers.js");
var _internalJs = require("./internal.js");
class Account {
    /**
     * This constructor assigns and validates the values.
     * Use the static factory methods to assist in creating an Account from varying data types.
     */ constructor(nonce = (0, _constantsJs.BIGINT_0), balance = (0, _constantsJs.BIGINT_0), storageRoot = (0, _constantsJs.KECCAK256_RLP), codeHash = (0, _constantsJs.KECCAK256_NULL)){
        this.nonce = nonce;
        this.balance = balance;
        this.storageRoot = storageRoot;
        this.codeHash = codeHash;
        this._validate();
    }
    static fromAccountData(accountData) {
        const { nonce, balance, storageRoot, codeHash } = accountData;
        return new Account(nonce !== undefined ? (0, _bytesJs.bytesToBigInt)((0, _bytesJs.toBytes)(nonce)) : undefined, balance !== undefined ? (0, _bytesJs.bytesToBigInt)((0, _bytesJs.toBytes)(balance)) : undefined, storageRoot !== undefined ? (0, _bytesJs.toBytes)(storageRoot) : undefined, codeHash !== undefined ? (0, _bytesJs.toBytes)(codeHash) : undefined);
    }
    static fromRlpSerializedAccount(serialized) {
        const values = (0, _rlp.RLP).decode(serialized);
        if (!Array.isArray(values)) throw new Error('Invalid serialized account input. Must be array');
        return this.fromValuesArray(values);
    }
    static fromValuesArray(values) {
        const [nonce, balance, storageRoot, codeHash] = values;
        return new Account((0, _bytesJs.bytesToBigInt)(nonce), (0, _bytesJs.bytesToBigInt)(balance), storageRoot, codeHash);
    }
    _validate() {
        if (this.nonce < (0, _constantsJs.BIGINT_0)) throw new Error('nonce must be greater than zero');
        if (this.balance < (0, _constantsJs.BIGINT_0)) throw new Error('balance must be greater than zero');
        if (this.storageRoot.length !== 32) throw new Error('storageRoot must have a length of 32');
        if (this.codeHash.length !== 32) throw new Error('codeHash must have a length of 32');
    }
    /**
     * Returns an array of Uint8Arrays of the raw bytes for the account, in order.
     */ raw() {
        return [
            (0, _bytesJs.bigIntToUnpaddedBytes)(this.nonce),
            (0, _bytesJs.bigIntToUnpaddedBytes)(this.balance),
            this.storageRoot,
            this.codeHash
        ];
    }
    /**
     * Returns the RLP serialization of the account as a `Uint8Array`.
     */ serialize() {
        return (0, _rlp.RLP).encode(this.raw());
    }
    /**
     * Returns a `Boolean` determining if the account is a contract.
     */ isContract() {
        return !(0, _bytesJs.equalsBytes)(this.codeHash, (0, _constantsJs.KECCAK256_NULL));
    }
    /**
     * Returns a `Boolean` determining if the account is empty complying to the definition of
     * account emptiness in [EIP-161](https://eips.ethereum.org/EIPS/eip-161):
     * "An account is considered empty when it has no code and zero nonce and zero balance."
     */ isEmpty() {
        return this.balance === (0, _constantsJs.BIGINT_0) && this.nonce === (0, _constantsJs.BIGINT_0) && (0, _bytesJs.equalsBytes)(this.codeHash, (0, _constantsJs.KECCAK256_NULL));
    }
}
const isValidAddress = function(hexAddress) {
    try {
        (0, _helpersJs.assertIsString)(hexAddress);
    } catch (e) {
        return false;
    }
    return /^0x[0-9a-fA-F]{40}$/.test(hexAddress);
};
const toChecksumAddress = function(hexAddress, eip1191ChainId) {
    (0, _helpersJs.assertIsHexString)(hexAddress);
    const address = (0, _internalJs.stripHexPrefix)(hexAddress).toLowerCase();
    let prefix = '';
    if (eip1191ChainId !== undefined) {
        const chainId = (0, _bytesJs.bytesToBigInt)((0, _bytesJs.toBytes)(eip1191ChainId));
        prefix = chainId.toString() + '0x';
    }
    const bytes = (0, _bytesJs.utf8ToBytes)(prefix + address);
    const hash = (0, _bytesJs.bytesToHex)((0, _keccakJs.keccak256)(bytes)).slice(2);
    let ret = '0x';
    for(let i = 0; i < address.length; i++)if (parseInt(hash[i], 16) >= 8) ret += address[i].toUpperCase();
    else ret += address[i];
    return ret;
};
const isValidChecksumAddress = function(hexAddress, eip1191ChainId) {
    return isValidAddress(hexAddress) && toChecksumAddress(hexAddress, eip1191ChainId) === hexAddress;
};
const generateAddress = function(from, nonce) {
    (0, _helpersJs.assertIsBytes)(from);
    (0, _helpersJs.assertIsBytes)(nonce);
    if ((0, _bytesJs.bytesToBigInt)(nonce) === (0, _constantsJs.BIGINT_0)) // in RLP we want to encode null in the case of zero nonce
    // read the RLP documentation for an answer if you dare
    return (0, _keccakJs.keccak256)((0, _rlp.RLP).encode([
        from,
        Uint8Array.from([])
    ])).subarray(-20);
    // Only take the lower 160bits of the hash
    return (0, _keccakJs.keccak256)((0, _rlp.RLP).encode([
        from,
        nonce
    ])).subarray(-20);
};
const generateAddress2 = function(from, salt, initCode) {
    (0, _helpersJs.assertIsBytes)(from);
    (0, _helpersJs.assertIsBytes)(salt);
    (0, _helpersJs.assertIsBytes)(initCode);
    if (from.length !== 20) throw new Error('Expected from to be of length 20');
    if (salt.length !== 32) throw new Error('Expected salt to be of length 32');
    const address = (0, _keccakJs.keccak256)((0, _bytesJs.concatBytes)((0, _bytesJs.hexToBytes)('0xff'), from, salt, (0, _keccakJs.keccak256)(initCode)));
    return address.subarray(-20);
};
const isValidPrivate = function(privateKey) {
    return (0, _secp256K1Js.secp256k1).utils.isValidPrivateKey(privateKey);
};
const isValidPublic = function(publicKey, sanitize = false) {
    (0, _helpersJs.assertIsBytes)(publicKey);
    if (publicKey.length === 64) // Convert to SEC1 for secp256k1
    // Automatically checks whether point is on curve
    try {
        (0, _secp256K1Js.secp256k1).ProjectivePoint.fromHex((0, _bytesJs.concatBytes)(Uint8Array.from([
            4
        ]), publicKey));
        return true;
    } catch (e) {
        return false;
    }
    if (!sanitize) return false;
    try {
        (0, _secp256K1Js.secp256k1).ProjectivePoint.fromHex(publicKey);
        return true;
    } catch (e) {
        return false;
    }
};
const pubToAddress = function(pubKey, sanitize = false) {
    (0, _helpersJs.assertIsBytes)(pubKey);
    if (sanitize && pubKey.length !== 64) pubKey = (0, _secp256K1Js.secp256k1).ProjectivePoint.fromHex(pubKey).toRawBytes(false).slice(1);
    if (pubKey.length !== 64) throw new Error('Expected pubKey to be of length 64');
    // Only take the lower 160bits of the hash
    return (0, _keccakJs.keccak256)(pubKey).subarray(-20);
};
const publicToAddress = pubToAddress;
const privateToPublic = function(privateKey) {
    (0, _helpersJs.assertIsBytes)(privateKey);
    // skip the type flag and use the X, Y points
    return (0, _secp256K1Js.secp256k1).ProjectivePoint.fromPrivateKey(privateKey).toRawBytes(false).slice(1);
};
const privateToAddress = function(privateKey) {
    return publicToAddress(privateToPublic(privateKey));
};
const importPublic = function(publicKey) {
    (0, _helpersJs.assertIsBytes)(publicKey);
    if (publicKey.length !== 64) publicKey = (0, _secp256K1Js.secp256k1).ProjectivePoint.fromHex(publicKey).toRawBytes(false).slice(1);
    return publicKey;
};
const zeroAddress = function() {
    const addressLength = 20;
    const addr = (0, _bytesJs.zeros)(addressLength);
    return (0, _bytesJs.bytesToHex)(addr);
};
const isZeroAddress = function(hexAddress) {
    try {
        (0, _helpersJs.assertIsString)(hexAddress);
    } catch (e) {
        return false;
    }
    const zeroAddr = zeroAddress();
    return zeroAddr === hexAddress;
};
function accountBodyFromSlim(body) {
    const [nonce, balance, storageRoot, codeHash] = body;
    return [
        nonce,
        balance,
        storageRoot.length === 0 ? (0, _constantsJs.KECCAK256_RLP) : storageRoot,
        codeHash.length === 0 ? (0, _constantsJs.KECCAK256_NULL) : codeHash
    ];
}
const emptyUint8Arr = new Uint8Array(0);
function accountBodyToSlim(body) {
    const [nonce, balance, storageRoot, codeHash] = body;
    return [
        nonce,
        balance,
        (0, _bytesJs.equalsBytes)(storageRoot, (0, _constantsJs.KECCAK256_RLP)) ? emptyUint8Arr : storageRoot,
        (0, _bytesJs.equalsBytes)(codeHash, (0, _constantsJs.KECCAK256_NULL)) ? emptyUint8Arr : codeHash
    ];
}
function accountBodyToRLP(body, couldBeSlim = true) {
    const accountBody = couldBeSlim ? accountBodyFromSlim(body) : body;
    return (0, _rlp.RLP).encode(accountBody);
}

},{"@ethereumjs/rlp":"kMH5T","ethereum-cryptography/keccak.js":"fpcz0","ethereum-cryptography/secp256k1.js":"iD195","./bytes.js":"c3kwx","./constants.js":"l5iLS","./helpers.js":"52u5g","./internal.js":"cy716","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kMH5T":[function(require,module,exports,__globalThis) {
/**
 * RLP Encoding based on https://ethereum.org/en/developers/docs/data-structures-and-encoding/rlp/
 * This function takes in data, converts it to Uint8Array if not,
 * and adds a length for recursion.
 * @param input Will be converted to Uint8Array
 * @returns Uint8Array of encoded data
 **/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "encode", ()=>encode);
parcelHelpers.export(exports, "decode", ()=>decode);
parcelHelpers.export(exports, "utils", ()=>utils);
parcelHelpers.export(exports, "RLP", ()=>RLP);
function encode(input) {
    if (Array.isArray(input)) {
        const output = [];
        let outputLength = 0;
        for(let i = 0; i < input.length; i++){
            const encoded = encode(input[i]);
            output.push(encoded);
            outputLength += encoded.length;
        }
        return concatBytes(encodeLength(outputLength, 192), ...output);
    }
    const inputBuf = toBytes(input);
    if (inputBuf.length === 1 && inputBuf[0] < 128) return inputBuf;
    return concatBytes(encodeLength(inputBuf.length, 128), inputBuf);
}
/**
 * Slices a Uint8Array, throws if the slice goes out-of-bounds of the Uint8Array.
 * E.g. `safeSlice(hexToBytes('aa'), 1, 2)` will throw.
 * @param input
 * @param start
 * @param end
 */ function safeSlice(input, start, end) {
    if (end > input.length) throw new Error('invalid RLP (safeSlice): end slice of Uint8Array out-of-bounds');
    return input.slice(start, end);
}
/**
 * Parse integers. Check if there is no leading zeros
 * @param v The value to parse
 */ function decodeLength(v) {
    if (v[0] === 0) throw new Error('invalid RLP: extra zeros');
    return parseHexByte(bytesToHex(v));
}
function encodeLength(len, offset) {
    if (len < 56) return Uint8Array.from([
        len + offset
    ]);
    const hexLength = numberToHex(len);
    const lLength = hexLength.length / 2;
    const firstByte = numberToHex(offset + 55 + lLength);
    return Uint8Array.from(hexToBytes(firstByte + hexLength));
}
function decode(input, stream = false) {
    if (typeof input === 'undefined' || input === null || input.length === 0) return Uint8Array.from([]);
    const inputBytes = toBytes(input);
    const decoded = _decode(inputBytes);
    if (stream) return {
        data: decoded.data,
        remainder: decoded.remainder.slice()
    };
    if (decoded.remainder.length !== 0) throw new Error('invalid RLP: remainder must be zero');
    return decoded.data;
}
/** Decode an input with RLP */ function _decode(input) {
    let length, llength, data, innerRemainder, d;
    const decoded = [];
    const firstByte = input[0];
    if (firstByte <= 0x7f) // a single byte whose value is in the [0x00, 0x7f] range, that byte is its own RLP encoding.
    return {
        data: input.slice(0, 1),
        remainder: input.subarray(1)
    };
    else if (firstByte <= 0xb7) {
        // string is 0-55 bytes long. A single byte with value 0x80 plus the length of the string followed by the string
        // The range of the first byte is [0x80, 0xb7]
        length = firstByte - 0x7f;
        // set 0x80 null to 0
        if (firstByte === 0x80) data = Uint8Array.from([]);
        else data = safeSlice(input, 1, length);
        if (length === 2 && data[0] < 0x80) throw new Error('invalid RLP encoding: invalid prefix, single byte < 0x80 are not prefixed');
        return {
            data,
            remainder: input.subarray(length)
        };
    } else if (firstByte <= 0xbf) {
        // string is greater than 55 bytes long. A single byte with the value (0xb7 plus the length of the length),
        // followed by the length, followed by the string
        llength = firstByte - 0xb6;
        if (input.length - 1 < llength) throw new Error('invalid RLP: not enough bytes for string length');
        length = decodeLength(safeSlice(input, 1, llength));
        if (length <= 55) throw new Error('invalid RLP: expected string length to be greater than 55');
        data = safeSlice(input, llength, length + llength);
        return {
            data,
            remainder: input.subarray(length + llength)
        };
    } else if (firstByte <= 0xf7) {
        // a list between 0-55 bytes long
        length = firstByte - 0xbf;
        innerRemainder = safeSlice(input, 1, length);
        while(innerRemainder.length){
            d = _decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.subarray(length)
        };
    } else {
        // a list over 55 bytes long
        llength = firstByte - 0xf6;
        length = decodeLength(safeSlice(input, 1, llength));
        if (length < 56) throw new Error('invalid RLP: encoded list too short');
        const totalLength = llength + length;
        if (totalLength > input.length) throw new Error('invalid RLP: total length is larger than the data');
        innerRemainder = safeSlice(input, llength, totalLength);
        while(innerRemainder.length){
            d = _decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.subarray(totalLength)
        };
    }
}
const cachedHexes = Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, '0'));
function bytesToHex(uint8a) {
    // Pre-caching chars with `cachedHexes` speeds this up 6x
    let hex = '';
    for(let i = 0; i < uint8a.length; i++)hex += cachedHexes[uint8a[i]];
    return hex;
}
function parseHexByte(hexByte) {
    const byte = Number.parseInt(hexByte, 16);
    if (Number.isNaN(byte)) throw new Error('Invalid byte sequence');
    return byte;
}
// Caching slows it down 2-3x
function hexToBytes(hex) {
    if (typeof hex !== 'string') throw new TypeError('hexToBytes: expected string, got ' + typeof hex);
    if (hex.length % 2) throw new Error('hexToBytes: received invalid unpadded hex');
    const array = new Uint8Array(hex.length / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        array[i] = parseHexByte(hex.slice(j, j + 2));
    }
    return array;
}
/** Concatenates two Uint8Arrays into one. */ function concatBytes(...arrays) {
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
function utf8ToBytes(utf) {
    return new TextEncoder().encode(utf);
}
/** Transform an integer into its hexadecimal value */ function numberToHex(integer) {
    if (integer < 0) throw new Error('Invalid integer as argument, must be unsigned!');
    const hex = integer.toString(16);
    return hex.length % 2 ? `0${hex}` : hex;
}
/** Pad a string to be even */ function padToEven(a) {
    return a.length % 2 ? `0${a}` : a;
}
/** Check if a string is prefixed by 0x */ function isHexPrefixed(str) {
    return str.length >= 2 && str[0] === '0' && str[1] === 'x';
}
/** Removes 0x from a given String */ function stripHexPrefix(str) {
    if (typeof str !== 'string') return str;
    return isHexPrefixed(str) ? str.slice(2) : str;
}
/** Transform anything into a Uint8Array */ function toBytes(v) {
    if (v instanceof Uint8Array) return v;
    if (typeof v === 'string') {
        if (isHexPrefixed(v)) return hexToBytes(padToEven(stripHexPrefix(v)));
        return utf8ToBytes(v);
    }
    if (typeof v === 'number' || typeof v === 'bigint') {
        if (!v) return Uint8Array.from([]);
        return hexToBytes(numberToHex(v));
    }
    if (v === null || v === undefined) return Uint8Array.from([]);
    throw new Error('toBytes: received unsupported type ' + typeof v);
}
const utils = {
    bytesToHex,
    concatBytes,
    hexToBytes,
    utf8ToBytes
};
const RLP = {
    encode,
    decode
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fpcz0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.keccak512 = exports.keccak384 = exports.keccak256 = exports.keccak224 = void 0;
const sha3_1 = require("b47d5011a60c54b9");
const utils_js_1 = require("e9e893cd9eb08f36");
exports.keccak224 = (0, utils_js_1.wrapHash)(sha3_1.keccak_224);
exports.keccak256 = (()=>{
    const k = (0, utils_js_1.wrapHash)(sha3_1.keccak_256);
    k.create = sha3_1.keccak_256.create;
    return k;
})();
exports.keccak384 = (0, utils_js_1.wrapHash)(sha3_1.keccak_384);
exports.keccak512 = (0, utils_js_1.wrapHash)(sha3_1.keccak_512);

},{"b47d5011a60c54b9":"7xDX0","e9e893cd9eb08f36":"7odVe"}],"7xDX0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shake256 = exports.shake128 = exports.keccak_512 = exports.keccak_384 = exports.keccak_256 = exports.keccak_224 = exports.sha3_512 = exports.sha3_384 = exports.sha3_256 = exports.sha3_224 = exports.Keccak = exports.keccakP = void 0;
const _assert_js_1 = require("14db7b8ea2b5bceb");
const _u64_js_1 = require("45e8a44e40fd6b7f");
const utils_js_1 = require("5a04751f3e786b49");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [SHA3_PI, SHA3_ROTL, _SHA3_IOTA] = [
    [],
    [],
    []
];
const _0n = /* @__PURE__ */ BigInt(0);
const _1n = /* @__PURE__ */ BigInt(1);
const _2n = /* @__PURE__ */ BigInt(2);
const _7n = /* @__PURE__ */ BigInt(7);
const _256n = /* @__PURE__ */ BigInt(256);
const _0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = _1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = _0n;
    for(let j = 0; j < 7; j++){
        R = (R << _1n ^ (R >> _7n) * _0x71n) % _256n;
        if (R & _2n) t ^= _1n << (_1n << /* @__PURE__ */ BigInt(j)) - _1n;
    }
    _SHA3_IOTA.push(t);
}
const [SHA3_IOTA_H, SHA3_IOTA_L] = /* @__PURE__ */ (0, _u64_js_1.split)(_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const rotlH = (h, l, s)=>s > 32 ? (0, _u64_js_1.rotlBH)(h, l, s) : (0, _u64_js_1.rotlSH)(h, l, s);
const rotlL = (h, l, s)=>s > 32 ? (0, _u64_js_1.rotlBL)(h, l, s) : (0, _u64_js_1.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = SHA3_ROTL[t];
            const Th = rotlH(curH, curL, shift);
            const Tl = rotlL(curH, curL, shift);
            const PI = SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= SHA3_IOTA_H[round];
        s[1] ^= SHA3_IOTA_L[round];
    }
    B.fill(0);
}
exports.keccakP = keccakP;
class Keccak extends utils_js_1.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, _assert_js_1.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error('Sha3 supports only keccak-f1600 function');
        this.state = new Uint8Array(200);
        this.state32 = (0, utils_js_1.u32)(this.state);
    }
    keccak() {
        keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, _assert_js_1.exists)(this);
        const { blockLen, state } = this;
        data = (0, utils_js_1.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state, suffix, pos, blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, _assert_js_1.exists)(this, false);
        (0, _assert_js_1.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error('XOF is not possible for this instance');
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, _assert_js_1.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, _assert_js_1.output)(out, this);
        if (this.finished) throw new Error('digest() was already called');
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen, suffix, outputLen, rounds, enableXOF } = this;
        to || (to = new Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
exports.Keccak = Keccak;
const gen = (suffix, blockLen, outputLen)=>(0, utils_js_1.wrapConstructor)(()=>new Keccak(blockLen, suffix, outputLen));
exports.sha3_224 = gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ exports.sha3_256 = gen(0x06, 136, 32);
exports.sha3_384 = gen(0x06, 104, 48);
exports.sha3_512 = gen(0x06, 72, 64);
exports.keccak_224 = gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ exports.keccak_256 = gen(0x01, 136, 32);
exports.keccak_384 = gen(0x01, 104, 48);
exports.keccak_512 = gen(0x01, 72, 64);
const genShake = (suffix, blockLen, outputLen)=>(0, utils_js_1.wrapXOFConstructorWithOpts)((opts = {})=>new Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
exports.shake128 = genShake(0x1f, 168, 16);
exports.shake256 = genShake(0x1f, 136, 32);

},{"14db7b8ea2b5bceb":"7eSSE","45e8a44e40fd6b7f":"b1VgT","5a04751f3e786b49":"2YjGZ"}],"kTrCm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handling and generating Ethereum addresses
 */ parcelHelpers.export(exports, "Address", ()=>Address);
var _accountJs = require("./account.js");
var _bytesJs = require("./bytes.js");
var _constantsJs = require("./constants.js");
class Address {
    constructor(bytes){
        if (bytes.length !== 20) throw new Error('Invalid address length');
        this.bytes = bytes;
    }
    /**
     * Returns the zero address.
     */ static zero() {
        return new Address((0, _bytesJs.zeros)(20));
    }
    /**
     * Returns an Address object from a hex-encoded string.
     * @param str - Hex-encoded address
     */ static fromString(str) {
        if (!(0, _accountJs.isValidAddress)(str)) throw new Error('Invalid address');
        return new Address((0, _bytesJs.toBytes)(str));
    }
    /**
     * Returns an address for a given public key.
     * @param pubKey The two points of an uncompressed key
     */ static fromPublicKey(pubKey) {
        if (!(pubKey instanceof Uint8Array)) throw new Error('Public key should be Uint8Array');
        const bytes = (0, _accountJs.pubToAddress)(pubKey);
        return new Address(bytes);
    }
    /**
     * Returns an address for a given private key.
     * @param privateKey A private key must be 256 bits wide
     */ static fromPrivateKey(privateKey) {
        if (!(privateKey instanceof Uint8Array)) throw new Error('Private key should be Uint8Array');
        const bytes = (0, _accountJs.privateToAddress)(privateKey);
        return new Address(bytes);
    }
    /**
     * Generates an address for a newly created contract.
     * @param from The address which is creating this new address
     * @param nonce The nonce of the from account
     */ static generate(from, nonce) {
        if (typeof nonce !== 'bigint') throw new Error('Expected nonce to be a bigint');
        return new Address((0, _accountJs.generateAddress)(from.bytes, (0, _bytesJs.bigIntToBytes)(nonce)));
    }
    /**
     * Generates an address for a contract created using CREATE2.
     * @param from The address which is creating this new address
     * @param salt A salt
     * @param initCode The init code of the contract being created
     */ static generate2(from, salt, initCode) {
        if (!(salt instanceof Uint8Array)) throw new Error('Expected salt to be a Uint8Array');
        if (!(initCode instanceof Uint8Array)) throw new Error('Expected initCode to be a Uint8Array');
        return new Address((0, _accountJs.generateAddress2)(from.bytes, salt, initCode));
    }
    /**
     * Is address equal to another.
     */ equals(address) {
        return (0, _bytesJs.equalsBytes)(this.bytes, address.bytes);
    }
    /**
     * Is address zero.
     */ isZero() {
        return this.equals(Address.zero());
    }
    /**
     * True if address is in the address range defined
     * by EIP-1352
     */ isPrecompileOrSystemAddress() {
        const address = (0, _bytesJs.bytesToBigInt)(this.bytes);
        const rangeMin = (0, _constantsJs.BIGINT_0);
        const rangeMax = BigInt('0xffff');
        return address >= rangeMin && address <= rangeMax;
    }
    /**
     * Returns hex encoding of address.
     */ toString() {
        return (0, _bytesJs.bytesToHex)(this.bytes);
    }
    /**
     * Returns a new Uint8Array representation of address.
     */ toBytes() {
        return new Uint8Array(this.bytes);
    }
}

},{"./account.js":"g4QYD","./bytes.js":"c3kwx","./constants.js":"l5iLS","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"97pyK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyEncoding", ()=>KeyEncoding);
parcelHelpers.export(exports, "ValueEncoding", ()=>ValueEncoding);
var KeyEncoding;
(function(KeyEncoding) {
    KeyEncoding["String"] = "string";
    KeyEncoding["Bytes"] = "view";
    KeyEncoding["Number"] = "number";
})(KeyEncoding || (KeyEncoding = {}));
var ValueEncoding;
(function(ValueEncoding) {
    ValueEncoding["String"] = "string";
    ValueEncoding["Bytes"] = "view";
    ValueEncoding["JSON"] = "json";
})(ValueEncoding || (ValueEncoding = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bjY5t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Representation of EIP-4895 withdrawal data
 */ parcelHelpers.export(exports, "Withdrawal", ()=>Withdrawal);
var _addressJs = require("./address.js");
var _bytesJs = require("./bytes.js");
var _constantsJs = require("./constants.js");
var _typesJs = require("./types.js");
class Withdrawal {
    /**
     * This constructor assigns and validates the values.
     * Use the static factory methods to assist in creating a Withdrawal object from varying data types.
     * Its amount is in Gwei to match CL representation and for eventual ssz withdrawalsRoot
     */ constructor(index, validatorIndex, address, /**
     * withdrawal amount in Gwei to match the CL repesentation and eventually ssz withdrawalsRoot
     */ amount){
        this.index = index;
        this.validatorIndex = validatorIndex;
        this.address = address;
        this.amount = amount;
    }
    static fromWithdrawalData(withdrawalData) {
        const { index: indexData, validatorIndex: validatorIndexData, address: addressData, amount: amountData } = withdrawalData;
        const index = (0, _typesJs.toType)(indexData, (0, _typesJs.TypeOutput).BigInt);
        const validatorIndex = (0, _typesJs.toType)(validatorIndexData, (0, _typesJs.TypeOutput).BigInt);
        const address = addressData instanceof (0, _addressJs.Address) ? addressData : new (0, _addressJs.Address)((0, _bytesJs.toBytes)(addressData));
        const amount = (0, _typesJs.toType)(amountData, (0, _typesJs.TypeOutput).BigInt);
        return new Withdrawal(index, validatorIndex, address, amount);
    }
    static fromValuesArray(withdrawalArray) {
        if (withdrawalArray.length !== 4) throw Error(`Invalid withdrawalArray length expected=4 actual=${withdrawalArray.length}`);
        const [index, validatorIndex, address, amount] = withdrawalArray;
        return Withdrawal.fromWithdrawalData({
            index,
            validatorIndex,
            address,
            amount
        });
    }
    /**
     * Convert a withdrawal to a buffer array
     * @param withdrawal the withdrawal to convert
     * @returns buffer array of the withdrawal
     */ static toBytesArray(withdrawal) {
        const { index, validatorIndex, address, amount } = withdrawal;
        const indexBytes = (0, _typesJs.toType)(index, (0, _typesJs.TypeOutput).BigInt) === (0, _constantsJs.BIGINT_0) ? new Uint8Array() : (0, _typesJs.toType)(index, (0, _typesJs.TypeOutput).Uint8Array);
        const validatorIndexBytes = (0, _typesJs.toType)(validatorIndex, (0, _typesJs.TypeOutput).BigInt) === (0, _constantsJs.BIGINT_0) ? new Uint8Array() : (0, _typesJs.toType)(validatorIndex, (0, _typesJs.TypeOutput).Uint8Array);
        const addressBytes = address instanceof (0, _addressJs.Address) ? address.bytes : (0, _typesJs.toType)(address, (0, _typesJs.TypeOutput).Uint8Array);
        const amountBytes = (0, _typesJs.toType)(amount, (0, _typesJs.TypeOutput).BigInt) === (0, _constantsJs.BIGINT_0) ? new Uint8Array() : (0, _typesJs.toType)(amount, (0, _typesJs.TypeOutput).Uint8Array);
        return [
            indexBytes,
            validatorIndexBytes,
            addressBytes,
            amountBytes
        ];
    }
    raw() {
        return Withdrawal.toBytesArray(this);
    }
    toValue() {
        return {
            index: this.index,
            validatorIndex: this.validatorIndex,
            address: this.address.bytes,
            amount: this.amount
        };
    }
    toJSON() {
        return {
            index: (0, _bytesJs.bigIntToHex)(this.index),
            validatorIndex: (0, _bytesJs.bigIntToHex)(this.validatorIndex),
            address: (0, _bytesJs.bytesToHex)(this.address.bytes),
            amount: (0, _bytesJs.bigIntToHex)(this.amount)
        };
    }
}

},{"./address.js":"kTrCm","./bytes.js":"c3kwx","./constants.js":"l5iLS","./types.js":"lolJD","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lolJD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TypeOutput", ()=>TypeOutput);
parcelHelpers.export(exports, "toType", ()=>toType);
var _bytesJs = require("./bytes.js");
var _internalJs = require("./internal.js");
var TypeOutput;
(function(TypeOutput) {
    TypeOutput[TypeOutput["Number"] = 0] = "Number";
    TypeOutput[TypeOutput["BigInt"] = 1] = "BigInt";
    TypeOutput[TypeOutput["Uint8Array"] = 2] = "Uint8Array";
    TypeOutput[TypeOutput["PrefixedHexString"] = 3] = "PrefixedHexString";
})(TypeOutput || (TypeOutput = {}));
function toType(input, outputType) {
    if (input === null) return null;
    if (input === undefined) return undefined;
    if (typeof input === 'string' && !(0, _internalJs.isHexString)(input)) throw new Error(`A string must be provided with a 0x-prefix, given: ${input}`);
    else if (typeof input === 'number' && !Number.isSafeInteger(input)) throw new Error('The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)');
    const output = (0, _bytesJs.toBytes)(input);
    switch(outputType){
        case TypeOutput.Uint8Array:
            return output;
        case TypeOutput.BigInt:
            return (0, _bytesJs.bytesToBigInt)(output);
        case TypeOutput.Number:
            {
                const bigInt = (0, _bytesJs.bytesToBigInt)(output);
                if (bigInt > BigInt(Number.MAX_SAFE_INTEGER)) throw new Error('The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)');
                return Number(bigInt);
            }
        case TypeOutput.PrefixedHexString:
            return (0, _bytesJs.bytesToHex)(output);
        default:
            throw new Error('unknown outputType');
    }
}

},{"./bytes.js":"c3kwx","./internal.js":"cy716","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"qPPPA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the ECDSA signature of a message hash.
 *
 * If `chainId` is provided assume an EIP-155-style signature and calculate the `v` value
 * accordingly, otherwise return a "static" `v` just derived from the `recovery` bit
 */ parcelHelpers.export(exports, "ecsign", ()=>ecsign);
parcelHelpers.export(exports, "calculateSigRecovery", ()=>calculateSigRecovery);
parcelHelpers.export(exports, "ecrecover", ()=>ecrecover);
parcelHelpers.export(exports, "toRpcSig", ()=>toRpcSig);
parcelHelpers.export(exports, "toCompactSig", ()=>toCompactSig);
parcelHelpers.export(exports, "fromRpcSig", ()=>fromRpcSig);
parcelHelpers.export(exports, "isValidSignature", ()=>isValidSignature);
parcelHelpers.export(exports, "hashPersonalMessage", ()=>hashPersonalMessage);
var _keccakJs = require("ethereum-cryptography/keccak.js");
var _secp256K1Js = require("ethereum-cryptography/secp256k1.js");
var _bytesJs = require("./bytes.js");
var _constantsJs = require("./constants.js");
var _helpersJs = require("./helpers.js");
function ecsign(msgHash, privateKey, chainId) {
    const sig = (0, _secp256K1Js.secp256k1).sign(msgHash, privateKey);
    const buf = sig.toCompactRawBytes();
    const r = buf.slice(0, 32);
    const s = buf.slice(32, 64);
    const v = chainId === undefined ? BigInt(sig.recovery + 27) : BigInt(sig.recovery + 35) + BigInt(chainId) * (0, _constantsJs.BIGINT_2);
    return {
        r,
        s,
        v
    };
}
function calculateSigRecovery(v, chainId) {
    if (v === (0, _constantsJs.BIGINT_0) || v === (0, _constantsJs.BIGINT_1)) return v;
    if (chainId === undefined) return v - (0, _constantsJs.BIGINT_27);
    return v - (chainId * (0, _constantsJs.BIGINT_2) + BigInt(35));
}
function isValidSigRecovery(recovery) {
    return recovery === (0, _constantsJs.BIGINT_0) || recovery === (0, _constantsJs.BIGINT_1);
}
const ecrecover = function(msgHash, v, r, s, chainId) {
    const signature = (0, _bytesJs.concatBytes)((0, _bytesJs.setLengthLeft)(r, 32), (0, _bytesJs.setLengthLeft)(s, 32));
    const recovery = calculateSigRecovery(v, chainId);
    if (!isValidSigRecovery(recovery)) throw new Error('Invalid signature v value');
    const sig = (0, _secp256K1Js.secp256k1).Signature.fromCompact(signature).addRecoveryBit(Number(recovery));
    const senderPubKey = sig.recoverPublicKey(msgHash);
    return senderPubKey.toRawBytes(false).slice(1);
};
const toRpcSig = function(v, r, s, chainId) {
    const recovery = calculateSigRecovery(v, chainId);
    if (!isValidSigRecovery(recovery)) throw new Error('Invalid signature v value');
    // geth (and the RPC eth_sign method) uses the 65 byte format used by Bitcoin
    return (0, _bytesJs.bytesToHex)((0, _bytesJs.concatBytes)((0, _bytesJs.setLengthLeft)(r, 32), (0, _bytesJs.setLengthLeft)(s, 32), (0, _bytesJs.toBytes)(v)));
};
const toCompactSig = function(v, r, s, chainId) {
    const recovery = calculateSigRecovery(v, chainId);
    if (!isValidSigRecovery(recovery)) throw new Error('Invalid signature v value');
    const ss = Uint8Array.from([
        ...s
    ]);
    if (v > BigInt(28) && v % (0, _constantsJs.BIGINT_2) === (0, _constantsJs.BIGINT_1) || v === (0, _constantsJs.BIGINT_1) || v === BigInt(28)) ss[0] |= 0x80;
    return (0, _bytesJs.bytesToHex)((0, _bytesJs.concatBytes)((0, _bytesJs.setLengthLeft)(r, 32), (0, _bytesJs.setLengthLeft)(ss, 32)));
};
const fromRpcSig = function(sig) {
    const bytes = (0, _bytesJs.toBytes)(sig);
    let r;
    let s;
    let v;
    if (bytes.length >= 65) {
        r = bytes.subarray(0, 32);
        s = bytes.subarray(32, 64);
        v = (0, _bytesJs.bytesToBigInt)(bytes.subarray(64));
    } else if (bytes.length === 64) {
        // Compact Signature Representation (https://eips.ethereum.org/EIPS/eip-2098)
        r = bytes.subarray(0, 32);
        s = bytes.subarray(32, 64);
        v = BigInt((0, _bytesJs.bytesToInt)(bytes.subarray(32, 33)) >> 7);
        s[0] &= 0x7f;
    } else throw new Error('Invalid signature length');
    // support both versions of `eth_sign` responses
    if (v < 27) v = v + (0, _constantsJs.BIGINT_27);
    return {
        v,
        r,
        s
    };
};
const isValidSignature = function(v, r, s, homesteadOrLater = true, chainId) {
    if (r.length !== 32 || s.length !== 32) return false;
    if (!isValidSigRecovery(calculateSigRecovery(v, chainId))) return false;
    const rBigInt = (0, _bytesJs.bytesToBigInt)(r);
    const sBigInt = (0, _bytesJs.bytesToBigInt)(s);
    if (rBigInt === (0, _constantsJs.BIGINT_0) || rBigInt >= (0, _constantsJs.SECP256K1_ORDER) || sBigInt === (0, _constantsJs.BIGINT_0) || sBigInt >= (0, _constantsJs.SECP256K1_ORDER)) return false;
    if (homesteadOrLater && sBigInt >= (0, _constantsJs.SECP256K1_ORDER_DIV_2)) return false;
    return true;
};
const hashPersonalMessage = function(message) {
    (0, _helpersJs.assertIsBytes)(message);
    const prefix = (0, _bytesJs.utf8ToBytes)(`\u0019Ethereum Signed Message:\n${message.length}`);
    return (0, _keccakJs.keccak256)((0, _bytesJs.concatBytes)(prefix, message));
};

},{"ethereum-cryptography/keccak.js":"fpcz0","ethereum-cryptography/secp256k1.js":"iD195","./bytes.js":"c3kwx","./constants.js":"l5iLS","./helpers.js":"52u5g","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ksN6N":[function(require,module,exports,__globalThis) {
/**
 * Ported to Typescript from original implementation below:
 * https://github.com/ahultgren/async-eventemitter -- MIT licensed
 *
 * Type Definitions based on work by: patarapolw <https://github.com/patarapolw> -- MIT licensed
 * that was contributed to Definitely Typed below:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/async-eventemitter
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncEventEmitter", ()=>AsyncEventEmitter);
var _events = require("events");
async function runInSeries(context, tasks, data) {
    let error;
    for await (const task of tasks)try {
        if (task.length < 2) //sync
        task.call(context, data);
        else await new Promise((resolve, reject)=>{
            task.call(context, data, (error)=>{
                if (error) reject(error);
                else resolve();
            });
        });
    } catch (e) {
        error = e;
    }
    if (error) throw error;
}
class AsyncEventEmitter extends (0, _events.EventEmitter) {
    emit(event, ...args) {
        let [data, callback] = args;
        const self = this;
        let listeners = self._events[event] ?? [];
        // Optional data argument
        if (callback === undefined && typeof data === 'function') {
            callback = data;
            data = undefined;
        }
        // Special treatment of internal newListener and removeListener events
        if (event === 'newListener' || event === 'removeListener') {
            data = {
                event: data,
                fn: callback
            };
            callback = undefined;
        }
        // A single listener is just a function not an array...
        listeners = Array.isArray(listeners) ? listeners : [
            listeners
        ];
        runInSeries(self, listeners.slice(), data).then(callback).catch(callback);
        return self.listenerCount(event) > 0;
    }
    once(event, listener) {
        const self = this;
        let g;
        if (typeof listener !== 'function') throw new TypeError('listener must be a function');
        // Hack to support set arity
        if (listener.length >= 2) g = function(e, next) {
            self.removeListener(event, g);
            listener(e, next);
        };
        else g = function(e) {
            self.removeListener(event, g);
            listener(e, g);
        };
        self.on(event, g);
        return self;
    }
    first(event, listener) {
        let listeners = this._events[event] ?? [];
        // Contract
        if (typeof listener !== 'function') throw new TypeError('listener must be a function');
        // Listeners are not always an array
        if (!Array.isArray(listeners)) this._events[event] = listeners = [
            listeners
        ];
        listeners.unshift(listener);
        return this;
    }
    before(event, target, listener) {
        return this.beforeOrAfter(event, target, listener);
    }
    after(event, target, listener) {
        return this.beforeOrAfter(event, target, listener, 'after');
    }
    beforeOrAfter(event, target, listener, beforeOrAfter) {
        let listeners = this._events[event] ?? [];
        let i;
        let index;
        const add = beforeOrAfter === 'after' ? 1 : 0;
        // Contract
        if (typeof listener !== 'function') throw new TypeError('listener must be a function');
        if (typeof target !== 'function') throw new TypeError('target must be a function');
        // Listeners are not always an array
        if (!Array.isArray(listeners)) this._events[event] = listeners = [
            listeners
        ];
        index = listeners.length;
        for(i = listeners.length; i--;)if (listeners[i] === target) {
            index = i + add;
            break;
        }
        listeners.splice(index, 0, listener);
        return this;
    }
    on(event, listener) {
        return super.on(event, listener);
    }
    addListener(event, listener) {
        return super.addListener(event, listener);
    }
    prependListener(event, listener) {
        return super.prependListener(event, listener);
    }
    prependOnceListener(event, listener) {
        return super.prependOnceListener(event, listener);
    }
    removeAllListeners(event) {
        return super.removeAllListeners(event);
    }
    removeListener(event, listener) {
        return super.removeListener(event, listener);
    }
    eventNames() {
        return super.eventNames();
    }
    listeners(event) {
        return super.listeners(event);
    }
    listenerCount(event) {
        return super.listenerCount(event);
    }
    getMaxListeners() {
        return super.getMaxListeners();
    }
    setMaxListeners(maxListeners) {
        return super.setMaxListeners(maxListeners);
    }
}

},{"events":"8D3fc","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8D3fc":[function(require,module,exports,__globalThis) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var R = typeof Reflect === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function' ? R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') ReflectOwnKeys = R.ownKeys;
else if (Object.getOwnPropertySymbols) ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function EventEmitter() {
    EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;
// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;
EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;
function checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        defaultMaxListeners = arg;
    }
});
EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function _getMaxListeners(that) {
    if (that._maxListeners === undefined) return EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return _getMaxListeners(this);
};
EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = arrayClone(handler, len);
        for(var i = 0; i < len; ++i)ReflectApply(listeners[i], this, args);
    }
    return true;
};
function _addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = _getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            ProcessEmitWarning(w);
        }
    }
    return target;
}
EventEmitter.prototype.addListener = function addListener(type, listener) {
    return _addListener(this, type, listener, false);
};
EventEmitter.prototype.on = EventEmitter.prototype.addListener;
EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return _addListener(this, type, listener, true);
};
function onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function _onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
EventEmitter.prototype.once = function once(type, listener) {
    checkListener(listener);
    this.on(type, _onceWrap(this, type, listener));
    return this;
};
EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    checkListener(listener);
    this.prependListener(type, _onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function _listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}
EventEmitter.prototype.listeners = function listeners(type) {
    return _listeners(this, type, true);
};
EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return _listeners(this, type, false);
};
EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return listenerCount.call(emitter, type);
};
EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};
function arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

},{}],"d85bP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBlobs", ()=>getBlobs);
parcelHelpers.export(exports, "blobsToCommitments", ()=>blobsToCommitments);
parcelHelpers.export(exports, "blobsToProofs", ()=>blobsToProofs);
parcelHelpers.export(exports, "computeVersionedHash", ()=>computeVersionedHash);
parcelHelpers.export(exports, "commitmentsToVersionedHashes", ()=>commitmentsToVersionedHashes);
var _sha256Js = require("ethereum-cryptography/sha256.js");
var _bytesJs = require("./bytes.js");
/**
 * These utilities for constructing blobs are borrowed from https://github.com/Inphi/eip4844-interop.git
 */ const BYTES_PER_FIELD_ELEMENT = 32;
const FIELD_ELEMENTS_PER_BLOB = 4096;
const USEFUL_BYTES_PER_BLOB = 32 * FIELD_ELEMENTS_PER_BLOB;
const MAX_BLOBS_PER_TX = 2;
const MAX_USEFUL_BYTES_PER_TX = USEFUL_BYTES_PER_BLOB * MAX_BLOBS_PER_TX - 1;
const BLOB_SIZE = BYTES_PER_FIELD_ELEMENT * FIELD_ELEMENTS_PER_BLOB;
function get_padded(data, blobs_len) {
    const pdata = new Uint8Array(blobs_len * USEFUL_BYTES_PER_BLOB).fill(0);
    pdata.set(data);
    pdata[data.byteLength] = 0x80;
    return pdata;
}
function get_blob(data) {
    const blob = new Uint8Array(BLOB_SIZE);
    for(let i = 0; i < FIELD_ELEMENTS_PER_BLOB; i++){
        const chunk = new Uint8Array(32);
        chunk.set(data.subarray(i * 31, (i + 1) * 31), 0);
        blob.set(chunk, i * 32);
    }
    return blob;
}
const getBlobs = (input)=>{
    const data = (0, _bytesJs.utf8ToBytes)(input);
    const len = data.byteLength;
    if (len === 0) throw Error('invalid blob data');
    if (len > MAX_USEFUL_BYTES_PER_TX) throw Error('blob data is too large');
    const blobs_len = Math.ceil(len / USEFUL_BYTES_PER_BLOB);
    const pdata = get_padded(data, blobs_len);
    const blobs = [];
    for(let i = 0; i < blobs_len; i++){
        const chunk = pdata.subarray(i * USEFUL_BYTES_PER_BLOB, (i + 1) * USEFUL_BYTES_PER_BLOB);
        const blob = get_blob(chunk);
        blobs.push(blob);
    }
    return blobs;
};
const blobsToCommitments = (kzg, blobs)=>{
    const commitments = [];
    for (const blob of blobs)commitments.push(kzg.blobToKzgCommitment(blob));
    return commitments;
};
const blobsToProofs = (kzg, blobs, commitments)=>{
    const proofs = blobs.map((blob, ctx)=>kzg.computeBlobKzgProof(blob, commitments[ctx]));
    return proofs;
};
const computeVersionedHash = (commitment, blobCommitmentVersion)=>{
    const computedVersionedHash = new Uint8Array(32);
    computedVersionedHash.set([
        blobCommitmentVersion
    ], 0);
    computedVersionedHash.set((0, _sha256Js.sha256)(commitment).subarray(1), 1);
    return computedVersionedHash;
};
const commitmentsToVersionedHashes = (commitments)=>{
    const hashes = [];
    for (const commitment of commitments)hashes.push(computeVersionedHash(commitment, 0x01));
    return hashes;
};

},{"ethereum-cryptography/sha256.js":"9tiNH","./bytes.js":"c3kwx","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9tiNH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sha256 = void 0;
const sha256_1 = require("7ce5164216c73417");
const utils_js_1 = require("f8a15c9f2976d5e3");
exports.sha256 = (0, utils_js_1.wrapHash)(sha256_1.sha256);

},{"7ce5164216c73417":"1Sjbu","f8a15c9f2976d5e3":"7odVe"}],"ioihp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Parses the geth genesis state into Blockchain {@link GenesisState}
 * @param json representing the `alloc` key in a Geth genesis file
 */ parcelHelpers.export(exports, "parseGethGenesisState", ()=>parseGethGenesisState);
var _bytesJs = require("./bytes.js");
var _internalJs = require("./internal.js");
function parseGethGenesisState(json) {
    const state = {};
    for (let address of Object.keys(json.alloc)){
        let { balance, code, storage, nonce } = json.alloc[address];
        // create a map with lowercase for easy lookups
        address = (0, _bytesJs.addHexPrefix)(address.toLowerCase());
        balance = (0, _internalJs.isHexPrefixed)(balance) ? balance : (0, _bytesJs.bigIntToHex)(BigInt(balance));
        code = code !== undefined ? (0, _bytesJs.addHexPrefix)(code) : undefined;
        storage = storage !== undefined ? Object.entries(storage) : undefined;
        nonce = nonce !== undefined ? (0, _bytesJs.addHexPrefix)(nonce) : undefined;
        state[address] = [
            balance,
            code,
            storage,
            nonce
        ];
    }
    return state;
}

},{"./bytes.js":"c3kwx","./internal.js":"cy716","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8kwUs":[function(require,module,exports,__globalThis) {
/**
 * @deprecated This initialization method is deprecated since trusted setup loading is done directly in the reference KZG library
 * initialization or should othewise be assured independently before KZG libary usage.
 *
 * @param kzgLib a KZG implementation (defaults to c-kzg)
 * @param a dictionary of trusted setup options
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initKZG", ()=>initKZG);
function initKZG(kzg, _trustedSetupPath) {
    kzg.loadTrustedSetup();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"24Zb9":[function(require,module,exports,__globalThis) {
// Based on https://github.com/jsoendermann/semaphore-async-await/blob/master/src/Semaphore.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Lock", ()=>Lock);
class Lock {
    constructor(){
        this.permits = 1;
        this.promiseResolverQueue = [];
    }
    /**
     * Returns a promise used to wait for a permit to become available. This method should be awaited on.
     * @returns  A promise that gets resolved when execution is allowed to proceed.
     */ async acquire() {
        if (this.permits > 0) {
            this.permits -= 1;
            return Promise.resolve(true);
        }
        // If there is no permit available, we return a promise that resolves once the semaphore gets
        // signaled enough times that permits is equal to one.
        return new Promise((resolver)=>this.promiseResolverQueue.push(resolver));
    }
    /**
     * Increases the number of permits by one. If there are other functions waiting, one of them will
     * continue to execute in a future iteration of the event loop.
     */ release() {
        this.permits += 1;
        if (this.permits > 1 && this.promiseResolverQueue.length > 0) // eslint-disable-next-line no-console
        console.warn('Lock.permits should never be > 0 when there is someone waiting.');
        else if (this.permits === 1 && this.promiseResolverQueue.length > 0) {
            // If there is someone else waiting, immediately consume the permit that was released
            // at the beginning of this function and let the waiting function resume.
            this.permits -= 1;
            const nextResolver = this.promiseResolverQueue.shift();
            if (nextResolver) nextResolver(true);
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"icGhk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MapDB", ()=>MapDB);
var _bytesJs = require("./bytes.js");
class MapDB {
    constructor(database){
        this._database = database ?? new Map();
    }
    async get(key) {
        const dbKey = key instanceof Uint8Array ? (0, _bytesJs.bytesToUnprefixedHex)(key) : key.toString();
        return this._database.get(dbKey);
    }
    async put(key, val) {
        const dbKey = key instanceof Uint8Array ? (0, _bytesJs.bytesToUnprefixedHex)(key) : key.toString();
        this._database.set(dbKey, val);
    }
    async del(key) {
        const dbKey = key instanceof Uint8Array ? (0, _bytesJs.bytesToUnprefixedHex)(key) : key.toString();
        this._database.delete(dbKey);
    }
    async batch(opStack) {
        for (const op of opStack){
            if (op.type === 'del') await this.del(op.key);
            if (op.type === 'put') await this.put(op.key, op.value);
        }
    }
    /**
     * Note that the returned shallow copy will share the underlying database with the original
     *
     * @returns DB
     */ shallowCopy() {
        return new MapDB(this._database);
    }
    open() {
        return Promise.resolve();
    }
}

},{"./bytes.js":"c3kwx","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eL9v3":[function(require,module,exports,__globalThis) {
/**
 * Makes a simple RPC call to a remote Ethereum JSON-RPC provider and passes through the response.
 * No parameter or response validation is done.
 *
 * @param url the URL for the JSON RPC provider
 * @param params the parameters for the JSON-RPC method - refer to
 * https://ethereum.org/en/developers/docs/apis/json-rpc/ for details on RPC methods
 * @returns the `result` field from the JSON-RPC response
 * @example
 * ```ts
 * const provider = 'https://mainnet.infura.io/v3/...'
 * const params = {
 *   method: 'eth_getBlockByNumber',
 *   params: ['latest', false],
 * }
 *  const block = await fetchFromProvider(provider, params)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchFromProvider", ()=>fetchFromProvider);
parcelHelpers.export(exports, "getProvider", ()=>getProvider);
const fetchFromProvider = async (url, params)=>{
    const data = JSON.stringify({
        method: params.method,
        params: params.params,
        jsonrpc: '2.0',
        id: 1
    });
    const res = await fetch(url, {
        headers: {
            'content-type': 'application/json'
        },
        method: 'POST',
        body: data
    });
    if (!res.ok) throw new Error(`JSONRpcError: ${JSON.stringify({
        method: params.method,
        status: res.status,
        message: await res.text().catch(()=>{
            return 'Could not parse error message likely because of a network error';
        })
    }, null, 2)}`);
    const json = await res.json();
    // TODO we should check json.error here
    return json.result;
};
const getProvider = (provider)=>{
    if (typeof provider === 'string') return provider;
    else if (typeof provider === 'object' && provider._getConnection !== undefined) return provider._getConnection().url;
    else throw new Error('Must provide valid provider URL or Web3Provider');
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bUnFy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uint2hex", ()=>uint2hex);
parcelHelpers.export(exports, "hex2uint", ()=>hex2uint);
parcelHelpers.export(exports, "base64ToUint", ()=>base64ToUint);
parcelHelpers.export(exports, "uintToBase64", ()=>uintToBase64);
parcelHelpers.export(exports, "shortPublicKey", ()=>shortPublicKey);
parcelHelpers.export(exports, "publicKeyToAddress", ()=>publicKeyToAddress);
parcelHelpers.export(exports, "addressToPublicKey", ()=>addressToPublicKey);
parcelHelpers.export(exports, "uint2bigintString", ()=>uint2bigintString);
parcelHelpers.export(exports, "stringBigint2uint", ()=>stringBigint2uint);
parcelHelpers.export(exports, "isValidAddress", ()=>isValidAddress);
parcelHelpers.export(exports, "concat", ()=>concat);
parcelHelpers.export(exports, "parseRoseStringToBigNumber", ()=>parseRoseStringToBigNumber);
parcelHelpers.export(exports, "parseRoseStringToBaseUnitString", ()=>parseRoseStringToBaseUnitString);
parcelHelpers.export(exports, "isAmountGreaterThan", ()=>isAmountGreaterThan);
parcelHelpers.export(exports, "formatBaseUnitsAsRose", ()=>formatBaseUnitsAsRose);
parcelHelpers.export(exports, "formatWeiAsWrose", ()=>formatWeiAsWrose);
parcelHelpers.export(exports, "parseRpcBalance", ()=>parseRpcBalance);
parcelHelpers.export(exports, "formatCommissionPercent", ()=>formatCommissionPercent);
parcelHelpers.export(exports, "getFeeAmount", ()=>getFeeAmount);
parcelHelpers.export(exports, "getDefaultFeeAmount", ()=>getDefaultFeeAmount);
parcelHelpers.export(exports, "parseConsensusToLayerBaseUnit", ()=>parseConsensusToLayerBaseUnit);
parcelHelpers.export(exports, "removeTrailingZeros", ()=>removeTrailingZeros);
var _client = require("@oasisprotocol/client");
var _bignumberJs = require("bignumber.js");
var _bignumberJsDefault = parcelHelpers.interopDefault(_bignumberJs);
var _config = require("../../config");
var Buffer = require("844697a35770c654").Buffer;
const uint2hex = (uint)=>Buffer.from(uint).toString('hex');
const hex2uint = (hex)=>new Uint8Array(Buffer.from(hex, 'hex'));
const base64ToUint = (value)=>(0, _client.misc).fromBase64(value);
const uintToBase64 = (value)=>(0, _client.misc).toBase64(value);
const shortPublicKey = async (publicKey)=>{
    return await (0, _client.staking).addressFromPublicKey(publicKey);
};
const publicKeyToAddress = async (publicKey)=>{
    const data = await (0, _client.staking).addressFromPublicKey(publicKey);
    return (0, _client.staking).addressToBech32(data);
};
const addressToPublicKey = async (addr)=>{
    return (0, _client.staking).addressFromBech32(addr);
};
const uint2bigintString = (uint)=>(0, _client.quantity).toBigInt(uint).toString();
const stringBigint2uint = (number)=>(0, _client.quantity).fromBigInt(BigInt(number));
const isValidAddress = (addr)=>{
    try {
        (0, _client.staking).addressFromBech32(addr);
        return true;
    } catch (e) {
        return false;
    }
};
function concat(...parts) {
    let length = 0;
    for (const part of parts)length += part.length;
    const result = new Uint8Array(length);
    let pos = 0;
    for (const part of parts){
        result.set(part, pos);
        pos += part.length;
    }
    return result;
}
function parseRoseStringToBigNumber(value, decimals = 9) {
    const baseUnitBN = new (0, _bignumberJsDefault.default)(value).shiftedBy(decimals) // * 10 ** decimals
    ;
    if (baseUnitBN.isNaN()) throw new Error(`not a number in parseRoseStringToBigNumber(${value})`);
    if (baseUnitBN.decimalPlaces() > 0) console.error('lost precision in parseRoseStringToBigNumber(', value);
    return baseUnitBN.decimalPlaces(0);
}
function parseRoseStringToBaseUnitString(value) {
    const baseUnitBN = parseRoseStringToBigNumber(value);
    return BigInt(baseUnitBN.toFixed(0)).toString();
}
function getRoseString(roseBN, minimumFractionDigits, maximumFractionDigits) {
    return roseBN.toFormat(Math.min(Math.max(roseBN.decimalPlaces(), minimumFractionDigits), maximumFractionDigits));
}
function isAmountGreaterThan(amount, value) {
    return parseRoseStringToBigNumber(amount).isGreaterThan(parseRoseStringToBigNumber(value));
}
function formatBaseUnitsAsRose(amount, { minimumFractionDigits = 0, maximumFractionDigits = Infinity } = {}) {
    const roseBN = new (0, _bignumberJsDefault.default)(amount).shiftedBy(-9) // / 10 ** 9
    ;
    return getRoseString(roseBN, minimumFractionDigits, maximumFractionDigits);
}
function formatWeiAsWrose(amount, { minimumFractionDigits = 0, maximumFractionDigits = Infinity } = {}) {
    const roseBN = new (0, _bignumberJsDefault.default)(amount).shiftedBy(-18) // / 10 ** 18
    ;
    return getRoseString(roseBN, minimumFractionDigits, maximumFractionDigits);
}
function parseRpcBalance(account) {
    const zero = stringBigint2uint('0');
    return {
        available: uint2bigintString(account.general?.balance || zero),
        validator: {
            escrow: uint2bigintString(account.escrow?.active?.balance || zero),
            escrow_debonding: uint2bigintString(account.escrow?.debonding?.balance || zero)
        }
    };
}
function formatCommissionPercent(commission) {
    return new (0, _bignumberJsDefault.default)(commission).times(100).toFormat();
}
function getFeeAmount(gasPrice, feeGas) {
    // A wild guess: the minimum gas price times the default loose
    // overestimate of the gas.
    return (gasPrice * feeGas).toString();
}
const defaultDepositFeeAmount = '0';
const getDefaultFeeAmount = (isDepositing, paraTimeConfig)=>{
    return isDepositing ? defaultDepositFeeAmount : getFeeAmount(paraTimeConfig.gasPrice, paraTimeConfig.feeGas);
};
function parseConsensusToLayerBaseUnit(feeAmount, decimals) {
    return new (0, _bignumberJsDefault.default)(feeAmount).shiftedBy(decimals).shiftedBy(-(0, _config.consensusDecimals));
}
function removeTrailingZeros(value, zeros) {
    const bigValue = new (0, _bignumberJsDefault.default)(value);
    return bigValue.dividedBy(new (0, _bignumberJsDefault.default)(10).pow(zeros)).toFixed();
}

},{"844697a35770c654":"eXvXD","@oasisprotocol/client":"9pxEg","bignumber.js":"a7tdL","../../config":"akiw0","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"a7tdL":[function(require,module,exports,__globalThis) {
(function(globalObject) {
    'use strict';
    /*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = '[BigNumber Error] ', tooManyDigits = bignumberError + 'Number primitive has more than 15 significant digits: ', BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: '',
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ',',
            decimalSeparator: '.',
            fractionGroupSize: 0,
            fractionGroupSeparator: '\xA0',
            suffix: ''
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = '0123456789abcdefghijklmnopqrstuvwxyz', alphabetHasNormalDecimalDigits = true;
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == 'number') && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, 'Base');
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10 && alphabetHasNormalDecimalDigits) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == 'number') {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, '').length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == '.') // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += '0');
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == 'object') {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'DECIMAL_PLACES')) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'ROUNDING_MODE')) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'EXPONENTIAL_AT')) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = 'RANGE')) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + ' cannot be zero: ' + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = 'CRYPTO')) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != 'undefined' && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + 'crypto unavailable');
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + ' not true or false: ' + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'MODULO_MODE')) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = 'POW_PRECISION')) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = 'FORMAT')) {
                        v = obj[p];
                        if (typeof v == 'object') FORMAT = v;
                        else throw Error(bignumberError + p + ' not an object: ' + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = 'ALPHABET')) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == 'string' && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                            alphabetHasNormalDecimalDigits = v.slice(0, 10) == '0123456789';
                            ALPHABET = v;
                        } else throw Error(bignumberError + p + ' invalid: ' + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + 'Object expected: ' + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == '[object Array]') {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + 'Invalid BigNumber: ' + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, -1);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, 1);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + 'crypto unavailable');
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = '0123456789';
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf('.'), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace('.', '');
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, '0'), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ''; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, '0');
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += '0', len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, '0');
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += '.'; i--; str += '0');
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += '.';
                            for(; i--; str += '0');
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? '-' + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        // If any number is NaN, return NaN.
        function maxOrMin(args, n) {
            var k, y, i = 1, x = new BigNumber(args[0]);
            for(; i < args.length; i++){
                y = new BigNumber(args[i]);
                if (!y.s || (k = compare(x, y)) === n || k === 0 && x.s === n) x = y;
            }
            return x;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, '');
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == 'x' ? 16 : p2 == 'b' ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, '$1').replace(dotBefore, '0.$1');
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + 'Not a' + (b ? ' base ' + b : '') + ' number: ' + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = mathfloor(n / pows10[d - j - 1] % 10);
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : mathfloor(n / pows10[d - j - 1] % 10);
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, '0');
            return n.s < 0 ? '-' + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + 'Exponent not an integer: ' + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - isOdd(n)) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) {
                t = xc;
                xc = yc;
                yc = t;
                y.s = -y.s;
            }
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) {
                zc = xc;
                xc = yc;
                yc = zc;
                i = xcL;
                xcL = ycL;
                ycL = i;
            }
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) {
                t = yc;
                yc = xc;
                xc = t;
                b = a;
            }
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times('1e' + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber('0.5');
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += '0';
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = '5e' + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf('e') + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + '');
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == '9999' || !rep && n == '4999') {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == '5') {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == 'object') {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == 'object') {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != 'object') throw Error(bignumberError + 'Argument not an object: ' + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split('.'), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || '', intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) {
                    i = g1;
                    g1 = g2;
                    g2 = i;
                    len -= i;
                }
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = '-' + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || '') + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp('\\d{' + g2 + '}\\B', 'g'), '$&' + (format.fractionGroupSeparator || '')) : fractionPart) : intPart;
            }
            return (format.prefix || '') + str + (format.suffix || '');
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + 'Argument ' + (n.isInteger() ? 'out of range: ' : 'not an integer: ') + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = 'Infinity';
                    if (s < 0) str = '-' + str;
                } else str = 'NaN';
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, '0');
                else if (b === 10 && alphabetHasNormalDecimalDigits) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, '0');
                } else {
                    intCheck(b, 2, ALPHABET.length, 'Base');
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, '0'), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = '-' + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + '';
        for(; i < j;){
            s = a[i++] + '';
            z = LOG_BASE - s.length;
            for(; z--; s = '0' + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || 'Argument') + (typeof n == 'number' ? n < min || n > max ? ' out of range: ' : ' not an integer: ' : ' not a primitive number: ') + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + '.' + str.slice(1) : str) + (e < 0 ? 'e' : 'e+') + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + '.'; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber['default'] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != 'undefined' && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(this);

},{}],"akiw0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRANSACTIONS_LIMIT", ()=>TRANSACTIONS_LIMIT);
parcelHelpers.export(exports, "consensusDecimals", ()=>consensusDecimals);
parcelHelpers.export(exports, "BackendAPIs", ()=>BackendAPIs);
parcelHelpers.export(exports, "config", ()=>config);
parcelHelpers.export(exports, "RuntimeTypes", ()=>RuntimeTypes);
parcelHelpers.export(exports, "ParaTime", ()=>ParaTime);
parcelHelpers.export(exports, "paraTimesConfig", ()=>paraTimesConfig);
parcelHelpers.export(exports, "deploys", ()=>deploys);
const TRANSACTIONS_LIMIT = 20;
const consensusDecimals = 9;
var BackendAPIs = /*#__PURE__*/ function(BackendAPIs) {
    BackendAPIs["OasisScanV2"] = "oasisscanV2";
    BackendAPIs["Nexus"] = "nexus";
    return BackendAPIs;
}({});
const config = {
    mainnet: {
        grpc: 'https://grpc.oasis.io',
        ticker: 'ROSE',
        min_delegation: 100,
        ["oasisscanV2"]: {
            explorer: 'https://api.oasisscan.com/v2/mainnet',
            blockExplorer: 'https://oasisscan.com/transactions/{{txHash}}',
            blockExplorerParatimes: 'https://oasisscan.com/paratimes/transactions/{{txHash}}?runtime={{runtimeId}}',
            blockExplorerAccount: 'https://www.oasisscan.com/accounts/detail/{{address}}'
        },
        ["nexus"]: {
            explorer: 'https://nexus.oasis.io/v1',
            blockExplorer: 'https://explorer.oasis.io/mainnet/consensus/tx/{{txHash}}',
            blockExplorerParatimes: 'https://explorer.oasis.io/mainnet/{{runtimeId}}/tx/{{txHash}}',
            blockExplorerAccount: 'https://explorer.oasis.io/mainnet/consensus/address/{{address}}'
        }
    },
    testnet: {
        grpc: 'https://testnet.grpc.oasis.io',
        ticker: 'TEST',
        min_delegation: 100,
        ["oasisscanV2"]: {
            explorer: 'https://api.oasisscan.com/v2/testnet',
            blockExplorer: 'https://testnet.oasisscan.com/transactions/{{txHash}}',
            blockExplorerParatimes: 'https://testnet.oasisscan.com/paratimes/transactions/{{txHash}}?runtime={{runtimeId}}',
            blockExplorerAccount: 'https://testnet.oasisscan.com/accounts/detail/{{address}}'
        },
        ["nexus"]: {
            explorer: 'https://testnet.nexus.oasis.io/v1',
            blockExplorer: 'https://explorer.oasis.io/testnet/consensus/tx/{{txHash}}',
            blockExplorerParatimes: 'https://explorer.oasis.io/testnet/{{runtimeId}}/tx/{{txHash}}',
            blockExplorerAccount: 'https://explorer.oasis.io/testnet/consensus/address/{{address}}'
        }
    },
    local: {
        grpc: 'http://localhost:42280',
        ticker: 'TEST',
        min_delegation: 100,
        ["oasisscanV2"]: {
            explorer: 'http://localhost:9001',
            blockExplorer: 'http://localhost:9001/data/transactions?operation_id={{txHash}}',
            blockExplorerParatimes: 'http://localhost:9001/data/paratimes/transactions/{{txHash}}?runtime={{runtimeId}}',
            blockExplorerAccount: 'http://localhost:9001/data/accounts/detail/{{address}}'
        },
        ["nexus"]: {
            explorer: 'http://localhost:9001',
            blockExplorer: 'http://localhost:9001/data/transactions?operation_id={{txHash}}',
            blockExplorerParatimes: 'http://localhost:9001/data/paratimes/transactions/{{txHash}}?runtime={{runtimeId}}',
            blockExplorerAccount: 'http://localhost:9001/data/accounts/detail/{{address}}'
        }
    }
};
var RuntimeTypes = /*#__PURE__*/ function(RuntimeTypes) {
    RuntimeTypes["Evm"] = "evm";
    RuntimeTypes["Oasis"] = "oasis";
    return RuntimeTypes;
}({});
const emeraldConfig = {
    mainnet: {
        address: 'oasis1qzvlg0grjxwgjj58tx2xvmv26era6t2csqn22pte',
        runtimeId: '000000000000000000000000000000000000000000000000e2eaa99fc008f87f'
    },
    testnet: {
        address: 'oasis1qr629x0tg9gm5fyhedgs9lw5eh3d8ycdnsxf0run',
        runtimeId: '00000000000000000000000000000000000000000000000072c8215e60d5bca7'
    },
    local: {
        address: undefined,
        runtimeId: undefined
    },
    gasPrice: 100n,
    feeGas: 70000n,
    decimals: 18,
    displayOrder: 2,
    type: "evm"
};
const cipherConfig = {
    mainnet: {
        address: 'oasis1qrnu9yhwzap7rqh6tdcdcpz0zf86hwhycchkhvt8',
        runtimeId: '000000000000000000000000000000000000000000000000e199119c992377cb'
    },
    testnet: {
        address: 'oasis1qqdn25n5a2jtet2s5amc7gmchsqqgs4j0qcg5k0t',
        runtimeId: '0000000000000000000000000000000000000000000000000000000000000000'
    },
    local: {
        address: undefined,
        runtimeId: undefined
    },
    gasPrice: 5n,
    feeGas: 5000000n,
    decimals: 9,
    displayOrder: 3,
    type: "oasis"
};
const sapphireConfig = {
    mainnet: {
        address: 'oasis1qrd3mnzhhgst26hsp96uf45yhq6zlax0cuzdgcfc',
        runtimeId: '000000000000000000000000000000000000000000000000f80306c9858e7279'
    },
    testnet: {
        address: 'oasis1qqczuf3x6glkgjuf0xgtcpjjw95r3crf7y2323xd',
        runtimeId: '000000000000000000000000000000000000000000000000a6d1e3ebf60dff6c'
    },
    local: {
        address: undefined,
        runtimeId: undefined
    },
    gasPrice: 100n,
    feeGas: 70000n,
    decimals: 18,
    displayOrder: 1,
    type: "evm"
};
var ParaTime = /*#__PURE__*/ function(ParaTime) {
    ParaTime["Cipher"] = "cipher";
    ParaTime["Emerald"] = "emerald";
    ParaTime["Sapphire"] = "sapphire";
    return ParaTime;
}({});
const paraTimesConfig = {
    ["cipher"]: cipherConfig,
    ["emerald"]: emeraldConfig,
    ["sapphire"]: sapphireConfig
};
const splitUrls = (input)=>input ? input.split(',').filter((s)=>!!s).map((s)=>s.trim()) : [];
const deploys = {
    production: splitUrls("https://wallet.oasis.io, https://wallet.prd.oasis.io"),
    staging: splitUrls("https://wallet.stg.oasis.io"),
    extension: 'chrome-extension://ppdadbejkmjnefldpcdjhnkpbjkikoip',
    localhost: 'http://localhost:3000'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jax2p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "transactionSlice", ()=>transactionSlice);
parcelHelpers.export(exports, "transactionActions", ()=>transactionActions);
var _toolkit = require("utils/@reduxjs/toolkit");
const initialState = {
    success: false,
    active: false
};
const transactionSlice = (0, _toolkit.createSlice)({
    name: 'transaction',
    initialState,
    reducers: {
        clearTransaction (state, action) {
            state.preview = undefined;
            state.error = undefined;
            state.success = false;
            state.active = false;
        },
        confirmTransaction (state, action) {},
        abortTransaction (state, action) {},
        setStep (state, action) {
            state.step = action.payload;
        },
        addEscrow (state, action) {
            state.error = undefined;
            state.success = false;
            state.active = true;
        },
        paraTimeTransactionSent (state, action) {},
        reclaimEscrow (state, action) {
            state.error = undefined;
            state.success = false;
            state.active = true;
        },
        sendTransaction (state, action) {
            state.error = undefined;
            state.success = false;
            state.active = true;
        },
        updateTransactionPreview (state, action) {
            state.preview = Object.assign({}, action.payload);
        },
        transactionSent (state, action) {
            state.preview = undefined;
            state.success = true;
            state.active = false;
        },
        transactionFailed (state, action) {
            state.preview = undefined;
            state.error = action.payload;
            state.active = false;
        }
    }
});
const { actions: transactionActions } = transactionSlice;

},{"utils/@reduxjs/toolkit":"2wpnD","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iYAaC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "walletSlice", ()=>walletSlice);
parcelHelpers.export(exports, "walletActions", ()=>walletActions);
var _toolkit = require("@reduxjs/toolkit");
var _toolkit1 = require("utils/@reduxjs/toolkit");
const initialState = {
    wallets: {},
    selectedWallet: undefined
};
const walletSlice = (0, _toolkit1.createSlice)({
    name: 'wallet',
    initialState,
    reducers: {
        openWalletFromMnemonic (state, action) {},
        openWalletFromPrivateKey (state, action) {},
        openWalletsFromLedger (state, action) {},
        deleteWallet (state, action) {
            delete state.wallets[action.payload];
        },
        selectFirstWallet (state) {
            state.selectedWallet = Object.values((0, _toolkit.current)(state.wallets))[0].address;
        },
        selectWallet (state, action) {
            state.selectedWallet = action.payload;
        },
        fetchWallet (state, action) {},
        updateBalance (state, action) {
            // We simply ignore the updateBalance action in rare cases when opening a
            // second tab while account is loading:
            // - tab2 initializes
            // - tab1 dispatches updateBalance
            // - tab2 asks to sync state
            // - tab2 receives updateBalance for an account it doesn't have
            // - tab1 responds with state
            // - tab2 receives synced state with the account it didn't have
            //
            // Alternatives:
            // - Remove updateBalance from whitelistTabSyncActions and have an
            //   outdated balance in case tab2 makes a transaction.
            // - Refactor redux-state-sync to ignore actions until tab2 receives
            //   synced state. But tab1 needs to listen to actions too, even tho it
            //   never asks for synced state.
            if (state.wallets[action.payload.address]) state.wallets[action.payload.address].balance = {
                ...state.wallets[action.payload.address].balance,
                ...action.payload.balance
            };
        },
        walletOpened (state, action) {
            const newWallet = action.payload;
            state.wallets[newWallet.address] = newWallet;
            state.selectedWallet ??= newWallet.address;
        },
        setWalletName (state, action) {
            state.wallets[action.payload.address].name = action.payload.name;
        },
        verifyAddressOnLedger (state, _action) {
        // Handled in saga
        }
    }
});
const { actions: walletActions } = walletSlice;

},{"@reduxjs/toolkit":"9ol63","utils/@reduxjs/toolkit":"2wpnD","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"56nVt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInitialState", ()=>getInitialState);
parcelHelpers.export(exports, "themeSlice", ()=>themeSlice);
parcelHelpers.export(exports, "themeActions", ()=>themeActions);
var _toolkit = require("utils/@reduxjs/toolkit");
var _utils = require("../utils");
const getInitialState = ()=>({
        selected: (0, _utils.getThemeFromStorage)() || 'system'
    });
const themeSlice = (0, _toolkit.createSlice)({
    name: 'theme',
    initialState: ()=>getInitialState(),
    reducers: {
        changeTheme (state, action) {
            (0, _utils.saveTheme)(action.payload);
            state.selected = action.payload;
        }
    }
});
const { actions: themeActions } = themeSlice;

},{"utils/@reduxjs/toolkit":"2wpnD","../utils":"lNPdT","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lNPdT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSystemDark", ()=>isSystemDark);
parcelHelpers.export(exports, "getTargetTheme", ()=>getTargetTheme);
parcelHelpers.export(exports, "saveTheme", ()=>saveTheme);
/* istanbul ignore next line */ parcelHelpers.export(exports, "getThemeFromStorage", ()=>getThemeFromStorage);
const isSystemDark = window?.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)')?.matches : undefined;
const getTargetTheme = (theme)=>theme === 'system' ? isSystemDark ? 'dark' : 'light' : theme;
function saveTheme(theme) {
    window.localStorage.setItem('selectedTheme', theme);
}
function getThemeFromStorage() {
    return window.localStorage.getItem('selectedTheme');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hDJtm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInitialState", ()=>getInitialState);
parcelHelpers.export(exports, "settingsSlice", ()=>settingsSlice);
parcelHelpers.export(exports, "settingsActions", ()=>settingsActions);
var _toolkit = require("utils/@reduxjs/toolkit");
var _utils = require("../utils");
const getInitialState = ()=>({
        screenPrivacy: (0, _utils.getScreenPrivacyFromStorage)() || 'on'
    });
const settingsSlice = (0, _toolkit.createSlice)({
    name: 'settings',
    initialState: ()=>getInitialState(),
    reducers: {
        changeScreenPrivacy (state, action) {
            (0, _utils.saveScreenPrivacy)(action.payload);
            state.screenPrivacy = action.payload;
        }
    }
});
const { actions: settingsActions } = settingsSlice;

},{"utils/@reduxjs/toolkit":"2wpnD","../utils":"aJKOq","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aJKOq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "saveScreenPrivacy", ()=>saveScreenPrivacy);
parcelHelpers.export(exports, "getScreenPrivacyFromStorage", ()=>getScreenPrivacyFromStorage);
function saveScreenPrivacy(screenPrivacy) {
    window.localStorage.setItem('screenPrivacy', screenPrivacy);
}
function getScreenPrivacyFromStorage() {
    return window.localStorage.getItem('screenPrivacy');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4EgkS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>rootSagas);
var _typedReduxSaga = require("typed-redux-saga");
var _saga = require("app/state/account/saga");
var _saga1 = require("app/state/network/saga");
var _saga2 = require("app/state/importaccounts/saga");
var _saga3 = require("app/state/paratimes/saga");
var _saga4 = require("app/state/staking/saga");
var _saga5 = require("app/state/transaction/saga");
var _saga6 = require("app/state/wallet/saga");
var _saga7 = require("app/state/persist/saga");
function* rootSagas() {
    yield* (0, _typedReduxSaga.all)([
        (0, _saga.accountSaga)(),
        (0, _saga1.networkSaga)(),
        (0, _saga2.importAccountsSaga)(),
        (0, _saga3.paraTimesSaga)(),
        (0, _saga4.stakingSaga)(),
        (0, _saga5.transactionSaga)(),
        (0, _saga6.rootWalletSaga)(),
        (0, _saga7.persistSaga)()
    ]);
}

},{"typed-redux-saga":"1vcsM","app/state/account/saga":"9Fbe2","app/state/network/saga":"9acqo","app/state/importaccounts/saga":"4YSF4","app/state/paratimes/saga":"1LjGj","app/state/staking/saga":"cQkhB","app/state/transaction/saga":"fHkpP","app/state/wallet/saga":"g5qmL","app/state/persist/saga":"jaE7S","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1vcsM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "actionChannel", ()=>actionChannel);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "apply", ()=>apply);
parcelHelpers.export(exports, "call", ()=>call);
parcelHelpers.export(exports, "cancel", ()=>cancel);
parcelHelpers.export(exports, "cancelled", ()=>cancelled);
parcelHelpers.export(exports, "cps", ()=>cps);
parcelHelpers.export(exports, "debounce", ()=>debounce);
parcelHelpers.export(exports, "delay", ()=>delay);
parcelHelpers.export(exports, "flush", ()=>flush);
parcelHelpers.export(exports, "fork", ()=>fork);
parcelHelpers.export(exports, "getContext", ()=>getContext);
parcelHelpers.export(exports, "join", ()=>join);
parcelHelpers.export(exports, "put", ()=>put);
parcelHelpers.export(exports, "putResolve", ()=>putResolve);
parcelHelpers.export(exports, "race", ()=>race);
parcelHelpers.export(exports, "retry", ()=>retry);
parcelHelpers.export(exports, "select", ()=>select);
parcelHelpers.export(exports, "setContext", ()=>setContext);
parcelHelpers.export(exports, "spawn", ()=>spawn);
parcelHelpers.export(exports, "take", ()=>take);
parcelHelpers.export(exports, "takeEvery", ()=>takeEvery);
parcelHelpers.export(exports, "takeLatest", ()=>takeLatest);
parcelHelpers.export(exports, "takeLeading", ()=>takeLeading);
parcelHelpers.export(exports, "takeMaybe", ()=>takeMaybe);
parcelHelpers.export(exports, "throttle", ()=>throttle);
var _effects = require("redux-saga/effects");
/* This file is generated. Do not edit it. */ /* This file is generated. Do not edit it. */ function* take(...args) {
    return yield (0, _effects.take)(...args);
}
/* This file is generated. Do not edit it. */ function* takeMaybe(...args) {
    return yield (0, _effects.takeMaybe)(...args);
}
/* This file is generated. Do not edit it. */ function* takeEvery(...args) {
    return yield (0, _effects.takeEvery)(...args);
}
/* This file is generated. Do not edit it. */ function* takeLatest(...args) {
    return yield (0, _effects.takeLatest)(...args);
}
/* This file is generated. Do not edit it. */ function* takeLeading(...args) {
    return yield (0, _effects.takeLeading)(...args);
}
/* This file is generated. Do not edit it. */ function* put(...args) {
    return yield (0, _effects.put)(...args);
}
/* This file is generated. Do not edit it. */ function* putResolve(...args) {
    return yield (0, _effects.putResolve)(...args);
}
/* This file is generated. Do not edit it. */ function* call(...args) {
    return yield (0, _effects.call)(...args);
}
/* This file is generated. Do not edit it. */ function* apply(...args) {
    return yield (0, _effects.apply)(...args);
}
/* This file is generated. Do not edit it. */ function* cps(...args) {
    return yield (0, _effects.cps)(...args);
}
/* This file is generated. Do not edit it. */ function* fork(...args) {
    return yield (0, _effects.fork)(...args);
}
/* This file is generated. Do not edit it. */ function* spawn(...args) {
    return yield (0, _effects.spawn)(...args);
}
/* This file is generated. Do not edit it. */ function* join(...args) {
    return yield (0, _effects.join)(...args);
}
/* This file is generated. Do not edit it. */ function* cancel(...args) {
    return yield (0, _effects.cancel)(...args);
}
/* This file is generated. Do not edit it. */ function* select(...args) {
    return yield (0, _effects.select)(...args);
}
/* This file is generated. Do not edit it. */ function* actionChannel(...args) {
    return yield (0, _effects.actionChannel)(...args);
}
/* This file is generated. Do not edit it. */ function* flush(...args) {
    return yield (0, _effects.flush)(...args);
}
/* This file is generated. Do not edit it. */ function* cancelled(...args) {
    return yield (0, _effects.cancelled)(...args);
}
/* This file is generated. Do not edit it. */ function* setContext(...args) {
    return yield (0, _effects.setContext)(...args);
}
/* This file is generated. Do not edit it. */ function* getContext(...args) {
    return yield (0, _effects.getContext)(...args);
}
/* This file is generated. Do not edit it. */ function* delay(...args) {
    return yield (0, _effects.delay)(...args);
}
/* This file is generated. Do not edit it. */ function* throttle(...args) {
    return yield (0, _effects.throttle)(...args);
}
/* This file is generated. Do not edit it. */ function* debounce(...args) {
    return yield (0, _effects.debounce)(...args);
}
/* This file is generated. Do not edit it. */ function* retry(...args) {
    return yield (0, _effects.retry)(...args);
}
/* This file is generated. Do not edit it. */ function* all(...args) {
    return yield (0, _effects.all)(...args);
}
/* This file is generated. Do not edit it. */ function* race(...args) {
    return yield (0, _effects.race)(...args);
}

},{"redux-saga/effects":"1OhxO","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1OhxO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _effects = require("@redux-saga/core/effects");
parcelHelpers.exportAll(_effects, exports);

},{"@redux-saga/core/effects":"2H1zZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2H1zZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "actionChannel", ()=>(0, _io22Ea0Cf9Js.U));
parcelHelpers.export(exports, "all", ()=>(0, _io22Ea0Cf9Js.$));
parcelHelpers.export(exports, "apply", ()=>(0, _io22Ea0Cf9Js.a0));
parcelHelpers.export(exports, "call", ()=>(0, _io22Ea0Cf9Js.O));
parcelHelpers.export(exports, "cancel", ()=>(0, _io22Ea0Cf9Js.N));
parcelHelpers.export(exports, "cancelled", ()=>(0, _io22Ea0Cf9Js.a5));
parcelHelpers.export(exports, "cps", ()=>(0, _io22Ea0Cf9Js.a1));
parcelHelpers.export(exports, "delay", ()=>(0, _io22Ea0Cf9Js.Q));
parcelHelpers.export(exports, "effectTypes", ()=>(0, _io22Ea0Cf9Js.X));
parcelHelpers.export(exports, "flush", ()=>(0, _io22Ea0Cf9Js.a6));
parcelHelpers.export(exports, "fork", ()=>(0, _io22Ea0Cf9Js.M));
parcelHelpers.export(exports, "getContext", ()=>(0, _io22Ea0Cf9Js.a7));
parcelHelpers.export(exports, "join", ()=>(0, _io22Ea0Cf9Js.a3));
parcelHelpers.export(exports, "put", ()=>(0, _io22Ea0Cf9Js.Z));
parcelHelpers.export(exports, "putResolve", ()=>(0, _io22Ea0Cf9Js._));
parcelHelpers.export(exports, "race", ()=>(0, _io22Ea0Cf9Js.W));
parcelHelpers.export(exports, "select", ()=>(0, _io22Ea0Cf9Js.a4));
parcelHelpers.export(exports, "setContext", ()=>(0, _io22Ea0Cf9Js.a8));
parcelHelpers.export(exports, "spawn", ()=>(0, _io22Ea0Cf9Js.a2));
parcelHelpers.export(exports, "take", ()=>(0, _io22Ea0Cf9Js.L));
parcelHelpers.export(exports, "takeMaybe", ()=>(0, _io22Ea0Cf9Js.Y));
parcelHelpers.export(exports, "debounce", ()=>debounce);
parcelHelpers.export(exports, "retry", ()=>retry$1);
parcelHelpers.export(exports, "takeEvery", ()=>takeEvery$1);
parcelHelpers.export(exports, "takeLatest", ()=>takeLatest$1);
parcelHelpers.export(exports, "takeLeading", ()=>takeLeading$1);
parcelHelpers.export(exports, "throttle", ()=>throttle$1);
var _symbols = require("@redux-saga/symbols");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _is = require("@redux-saga/is");
var _io22Ea0Cf9Js = require("./io-22ea0cf9.js");
var _delayP = require("@redux-saga/delay-p");
var done = function done(value) {
    return {
        done: true,
        value: value
    };
};
var qEnd = {};
function safeName(patternOrChannel) {
    if ((0, _is.channel)(patternOrChannel)) return 'channel';
    if ((0, _is.stringableFunc)(patternOrChannel)) return String(patternOrChannel);
    if ((0, _is.func)(patternOrChannel)) return patternOrChannel.name;
    return String(patternOrChannel);
}
function fsmIterator(fsm, startState, name) {
    var stateUpdater, errorState, effect, nextState = startState;
    function next(arg, error) {
        if (nextState === qEnd) return done(arg);
        if (error && !errorState) {
            nextState = qEnd;
            throw error;
        } else {
            stateUpdater && stateUpdater(arg);
            var currentState = error ? fsm[errorState](error) : fsm[nextState]();
            nextState = currentState.nextState;
            effect = currentState.effect;
            stateUpdater = currentState.stateUpdater;
            errorState = currentState.errorState;
            return nextState === qEnd ? done(arg) : effect;
        }
    }
    return (0, _io22Ea0Cf9Js.q)(next, function(error) {
        return next(null, error);
    }, name);
}
function takeEvery(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, _io22Ea0Cf9Js.L)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, _io22Ea0Cf9Js.M).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action, setAction = function setAction(ac) {
        return action = ac;
    };
    return fsmIterator({
        q1: function q1() {
            return {
                nextState: 'q2',
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: 'q1',
                effect: yFork(action)
            };
        }
    }, 'q1', "takeEvery(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}
function takeLatest(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, _io22Ea0Cf9Js.L)(patternOrChannel)
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, _io22Ea0Cf9Js.M).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yCancel = function yCancel(task) {
        return {
            done: false,
            value: (0, _io22Ea0Cf9Js.N)(task)
        };
    };
    var task, action;
    var setTask = function setTask(t) {
        return task = t;
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return fsmIterator({
        q1: function q1() {
            return {
                nextState: 'q2',
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return task ? {
                nextState: 'q3',
                effect: yCancel(task)
            } : {
                nextState: 'q1',
                effect: yFork(action),
                stateUpdater: setTask
            };
        },
        q3: function q3() {
            return {
                nextState: 'q1',
                effect: yFork(action),
                stateUpdater: setTask
            };
        }
    }, 'q1', "takeLatest(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}
function takeLeading(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var yTake = {
        done: false,
        value: (0, _io22Ea0Cf9Js.L)(patternOrChannel)
    };
    var yCall = function yCall(ac) {
        return {
            done: false,
            value: (0, _io22Ea0Cf9Js.O).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var action;
    var setAction = function setAction(ac) {
        return action = ac;
    };
    return fsmIterator({
        q1: function q1() {
            return {
                nextState: 'q2',
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: 'q1',
                effect: yCall(action)
            };
        }
    }, 'q1', "takeLeading(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}
function throttle(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, channel$1;
    var yTake = function yTake() {
        return {
            done: false,
            value: (0, _io22Ea0Cf9Js.L)(channel$1)
        };
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, _io22Ea0Cf9Js.M).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yDelay = {
        done: false,
        value: (0, _io22Ea0Cf9Js.Q)(delayLength)
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setChannel = function setChannel(ch) {
        return channel$1 = ch;
    };
    var needsChannel = !(0, _is.channel)(patternOrChannel);
    if (!needsChannel) setChannel(patternOrChannel);
    return fsmIterator({
        q1: function q1() {
            var yActionChannel = {
                done: false,
                value: (0, _io22Ea0Cf9Js.U)(patternOrChannel, (0, _io22Ea0Cf9Js.V)(1))
            };
            return {
                nextState: 'q2',
                effect: yActionChannel,
                stateUpdater: setChannel
            };
        },
        q2: function q2() {
            return {
                nextState: 'q3',
                effect: yTake(),
                stateUpdater: setAction
            };
        },
        q3: function q3() {
            return {
                nextState: 'q4',
                effect: yFork(action)
            };
        },
        q4: function q4() {
            return {
                nextState: 'q2',
                effect: yDelay
            };
        }
    }, needsChannel ? 'q1' : 'q2', "throttle(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}
function retry(maxTries, delayLength, fn) {
    var counter = maxTries;
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var yCall = {
        done: false,
        value: (0, _io22Ea0Cf9Js.O).apply(void 0, [
            fn
        ].concat(args))
    };
    var yDelay = {
        done: false,
        value: (0, _io22Ea0Cf9Js.Q)(delayLength)
    };
    return fsmIterator({
        q1: function q1() {
            return {
                nextState: 'q2',
                effect: yCall,
                errorState: 'q10'
            };
        },
        q2: function q2() {
            return {
                nextState: qEnd
            };
        },
        q10: function q10(error) {
            counter -= 1;
            if (counter <= 0) throw error;
            return {
                nextState: 'q1',
                effect: yDelay
            };
        }
    }, 'q1', "retry(" + fn.name + ")");
}
function debounceHelper(delayLength, patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)args[_key - 3] = arguments[_key];
    var action, raceOutput;
    var yTake = {
        done: false,
        value: (0, _io22Ea0Cf9Js.L)(patternOrChannel)
    };
    var yRace = {
        done: false,
        value: (0, _io22Ea0Cf9Js.W)({
            action: (0, _io22Ea0Cf9Js.L)(patternOrChannel),
            debounce: (0, _io22Ea0Cf9Js.Q)(delayLength)
        })
    };
    var yFork = function yFork(ac) {
        return {
            done: false,
            value: (0, _io22Ea0Cf9Js.M).apply(void 0, [
                worker
            ].concat(args, [
                ac
            ]))
        };
    };
    var yNoop = function yNoop(value) {
        return {
            done: false,
            value: value
        };
    };
    var setAction = function setAction(ac) {
        return action = ac;
    };
    var setRaceOutput = function setRaceOutput(ro) {
        return raceOutput = ro;
    };
    return fsmIterator({
        q1: function q1() {
            return {
                nextState: 'q2',
                effect: yTake,
                stateUpdater: setAction
            };
        },
        q2: function q2() {
            return {
                nextState: 'q3',
                effect: yRace,
                stateUpdater: setRaceOutput
            };
        },
        q3: function q3() {
            return raceOutput.debounce ? {
                nextState: 'q1',
                effect: yFork(action)
            } : {
                nextState: 'q2',
                effect: yNoop(raceOutput.action),
                stateUpdater: setAction
            };
        }
    }, 'q1', "debounce(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}
var validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
    (0, _io22Ea0Cf9Js.c)(patternOrChannel, (0, _is.notUndef), fn.name + " requires a pattern or channel");
    (0, _io22Ea0Cf9Js.c)(worker, (0, _is.notUndef), fn.name + " requires a saga parameter");
};
function takeEvery$1(patternOrChannel, worker) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    return (0, _io22Ea0Cf9Js.M).apply(void 0, [
        takeEvery,
        patternOrChannel,
        worker
    ].concat(args));
}
function takeLatest$1(patternOrChannel, worker) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)args[_key2 - 2] = arguments[_key2];
    return (0, _io22Ea0Cf9Js.M).apply(void 0, [
        takeLatest,
        patternOrChannel,
        worker
    ].concat(args));
}
function takeLeading$1(patternOrChannel, worker) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)args[_key3 - 2] = arguments[_key3];
    return (0, _io22Ea0Cf9Js.M).apply(void 0, [
        takeLeading,
        patternOrChannel,
        worker
    ].concat(args));
}
function throttle$1(ms, patternOrChannel, worker) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++)args[_key4 - 3] = arguments[_key4];
    return (0, _io22Ea0Cf9Js.M).apply(void 0, [
        throttle,
        ms,
        patternOrChannel,
        worker
    ].concat(args));
}
function retry$1(maxTries, delayLength, worker) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++)args[_key5 - 3] = arguments[_key5];
    return (0, _io22Ea0Cf9Js.O).apply(void 0, [
        retry,
        maxTries,
        delayLength,
        worker
    ].concat(args));
}
function debounce(delayLength, pattern, worker) {
    for(var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++)args[_key6 - 3] = arguments[_key6];
    return (0, _io22Ea0Cf9Js.M).apply(void 0, [
        debounceHelper,
        delayLength,
        pattern,
        worker
    ].concat(args));
}

},{"@redux-saga/symbols":"9v4bk","@babel/runtime/helpers/esm/extends":"jGVGo","@redux-saga/is":"bCJA0","./io-22ea0cf9.js":"j4tzc","@redux-saga/delay-p":"6f1ut","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9Fbe2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchAccount", ()=>fetchAccount);
/**
 * When a transaction is done, and it is related to the account we currently have in state
 * refresh the data.
 */ parcelHelpers.export(exports, "refreshAccountOnTransaction", ()=>refreshAccountOnTransaction);
parcelHelpers.export(exports, "refreshAccountOnParaTimeTransaction", ()=>refreshAccountOnParaTimeTransaction);
parcelHelpers.export(exports, "fetchingOnAccountPage", ()=>fetchingOnAccountPage);
parcelHelpers.export(exports, "accountSaga", ()=>accountSaga);
var _typedReduxSaga = require("typed-redux-saga");
var _errors = require("types/errors");
var _ = require(".");
var _saga = require("../network/saga");
var _takeLatestCancelable = require("../takeLatestCancelable");
var _staking = require("../staking");
var _saga1 = require("../staking/saga");
var _saga2 = require("../wallet/saga");
var _transaction = require("../transaction");
var _selectors = require("../wallet/selectors");
var _selectors1 = require("./selectors");
var _getAccountBalanceWithFallback = require("../../lib/getAccountBalanceWithFallback");
var _wallet = require("../wallet");
var _selectors2 = require("../network/selectors");
var _config = require("../../../config");
const ACCOUNT_REFETCHING_INTERVAL = 10000;
function* fetchAccount(action) {
    const address = action.payload;
    yield* (0, _typedReduxSaga.put)((0, _.accountActions).setLoading(true));
    const { getTransactionsList } = yield* (0, _typedReduxSaga.call)((0, _saga.getExplorerAPIs));
    yield* (0, _typedReduxSaga.all)([
        (0, _typedReduxSaga.join)((yield* (0, _typedReduxSaga.fork)(function*() {
            try {
                const account = yield* (0, _typedReduxSaga.call)((0, _getAccountBalanceWithFallback.getAccountBalanceWithFallback), address);
                yield* (0, _typedReduxSaga.put)((0, _.accountActions).accountLoaded(account));
                yield* (0, _typedReduxSaga.put)((0, _wallet.walletActions).updateBalance({
                    address: account.address,
                    balance: account
                }));
            } catch (apiError) {
                if (apiError instanceof (0, _errors.WalletError)) yield* (0, _typedReduxSaga.put)((0, _.accountActions).accountError({
                    code: apiError.type,
                    message: apiError.message
                }));
                else yield* (0, _typedReduxSaga.put)((0, _.accountActions).accountError({
                    code: (0, _errors.WalletErrors).UnknownError,
                    message: apiError.message
                }));
            }
        }))),
        (0, _typedReduxSaga.join)((yield* (0, _typedReduxSaga.fork)(function*() {
            const networkType = yield* (0, _typedReduxSaga.select)((0, _selectors2.selectSelectedNetwork));
            try {
                const transactions = yield* (0, _typedReduxSaga.call)(getTransactionsList, {
                    accountId: address,
                    limit: (0, _config.TRANSACTIONS_LIMIT)
                });
                yield* (0, _typedReduxSaga.put)((0, _.accountActions).transactionsLoaded({
                    networkType,
                    transactions
                }));
            } catch (e) {
                console.error('get transactions list failed, continuing without updated list.', e);
                if (e instanceof (0, _errors.WalletError)) yield* (0, _typedReduxSaga.put)((0, _.accountActions).transactionsError({
                    code: e.type,
                    message: e.message
                }));
                else yield* (0, _typedReduxSaga.put)((0, _.accountActions).transactionsError({
                    code: (0, _errors.WalletErrors).UnknownError,
                    message: e.message
                }));
            }
        })))
    ]);
    yield* (0, _typedReduxSaga.put)((0, _.accountActions).setLoading(false));
}
function* refreshAccountOnTransaction() {
    while(true){
        const { payload } = yield* (0, _typedReduxSaga.take)((0, _transaction.transactionActions).transactionSent);
        const otherAddress = payload.type === 'transfer' ? payload.to : payload.validator;
        yield* (0, _typedReduxSaga.call)(refreshAccount, otherAddress);
    }
}
function* refreshAccountOnParaTimeTransaction() {
    while(true){
        const { payload } = yield* (0, _typedReduxSaga.take)((0, _transaction.transactionActions).paraTimeTransactionSent);
        // Increase the chance to get updated transactions from API.
        // Note: We can't rely on nonce to detect pending paratime transactions
        yield* (0, _typedReduxSaga.delay)(3000);
        yield* (0, _typedReduxSaga.call)(refreshAccount, payload);
        yield* (0, _typedReduxSaga.delay)(6000);
        yield* (0, _typedReduxSaga.call)(refreshAccount, payload);
        yield* (0, _typedReduxSaga.delay)(6000);
        yield* (0, _typedReduxSaga.call)(refreshAccount, payload);
    }
}
function* refreshAccount(address) {
    const from = yield* (0, _typedReduxSaga.select)((0, _selectors.selectAddress));
    const currentAccount = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectAccountAddress));
    if (currentAccount === from || currentAccount === address) {
        yield* (0, _typedReduxSaga.put)((0, _.accountActions).fetchAccount(currentAccount));
        yield* (0, _typedReduxSaga.put)((0, _staking.stakingActions).fetchAccount(currentAccount));
    }
}
function* fetchingOnAccountPage() {
    yield* (0, _takeLatestCancelable.takeLatestCancelable)({
        startOnAction: (0, _.accountActions).openAccountPage,
        cancelOnAction: (0, _.accountActions).closeAccountPage,
        task: function*(startAction) {
            const address = startAction.payload;
            try {
                // Note: tasks triggered by `put` can't get canceled by closeAccountPage.
                yield* (0, _typedReduxSaga.put)((0, _.accountActions).fetchAccount(address));
                yield* (0, _typedReduxSaga.put)((0, _staking.stakingActions).fetchAccount(address));
                yield* (0, _typedReduxSaga.take)((0, _.accountActions).accountLoaded);
                // Continuously refresh balance. If balance changes then fetch transactions and staking too.
                while(true){
                    yield* (0, _typedReduxSaga.delay)(ACCOUNT_REFETCHING_INTERVAL);
                    if (document.hidden) continue;
                    let refreshedAccount;
                    try {
                        const { getAccount } = yield* (0, _typedReduxSaga.call)((0, _saga.getExplorerAPIs));
                        refreshedAccount = yield* (0, _typedReduxSaga.call)(getAccount, address);
                    } catch (apiError) {
                        console.error('refetching account failed, continuing without updated account.', apiError);
                        continue; // Ignore error when refetching, and don't fallback to more expensive gRPC
                    }
                    const staleBalances = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectAccount));
                    const hasPendingTxs = yield* (0, _typedReduxSaga.select)((0, _selectors1.hasAccountUnknownPendingTransactions));
                    if (staleBalances.nonce !== refreshedAccount.nonce || // If a new transaction fails it won't change balances
                    staleBalances.available !== refreshedAccount.available || staleBalances.delegations !== refreshedAccount.delegations || staleBalances.debonding !== refreshedAccount.debonding || hasPendingTxs // TODO: reduce setLoading if reloaded transactions haven't changed
                    ) {
                        // Wait for oasisscan to update transactions (it updates balances faster)
                        yield* (0, _typedReduxSaga.call)(fetchAccount, startAction);
                        yield* (0, _typedReduxSaga.call)((0, _saga1.fetchAccount), startAction);
                        yield* (0, _typedReduxSaga.call)((0, _saga2.refreshAccount), address);
                    }
                }
            } finally{
                yield* (0, _typedReduxSaga.put)((0, _.accountActions).clearAccount());
            }
        }
    });
}
function* accountSaga() {
    yield* (0, _typedReduxSaga.fork)(fetchingOnAccountPage);
    yield* (0, _typedReduxSaga.fork)(refreshAccountOnTransaction);
    yield* (0, _typedReduxSaga.fork)(refreshAccountOnParaTimeTransaction);
    yield* (0, _typedReduxSaga.takeLatest)((0, _.accountActions).fetchAccount, fetchAccount);
}

},{"typed-redux-saga":"1vcsM","types/errors":"gbx4q",".":"3cfOb","../network/saga":"9acqo","../takeLatestCancelable":"2ZQXE","../staking":"8XKJG","../staking/saga":"cQkhB","../wallet/saga":"g5qmL","../transaction":"jax2p","../wallet/selectors":"cgtJ3","./selectors":"avcAi","../../lib/getAccountBalanceWithFallback":"ffPNL","../wallet":"iYAaC","../network/selectors":"2zit7","../../../config":"akiw0","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9acqo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Return a nic client for the specified network,
 * or by default, for the currently selected network
 */ parcelHelpers.export(exports, "getOasisNic", ()=>getOasisNic);
/**
 * Return the explorer APIs for the currently selected network
 */ parcelHelpers.export(exports, "getExplorerAPIs", ()=>getExplorerAPIs);
parcelHelpers.export(exports, "getChainContext", ()=>getChainContext);
parcelHelpers.export(exports, "getEpoch", ()=>getEpoch);
parcelHelpers.export(exports, "selectNetwork", ()=>selectNetwork);
parcelHelpers.export(exports, "networkSaga", ()=>networkSaga);
var _client = require("@oasisprotocol/client");
var _persist = require("app/state/persist");
var _selectors = require("app/state/persist/selectors");
var _config = require("config");
var _reduxStateSync = require("redux-state-sync");
var _typedReduxSaga = require("typed-redux-saga");
var _backend = require("vendors/backend");
var _ = require(".");
var _selectors1 = require("./selectors");
var _errors = require("types/errors");
function* getOasisNic(network) {
    const selectedNetwork = network ? network : yield* (0, _typedReduxSaga.select)((0, _selectors1.selectSelectedNetwork));
    const url = (0, _config.config)[selectedNetwork].grpc;
    const nic = new _client.client.NodeInternal(url);
    return nic;
}
function* getExplorerAPIs() {
    const selectedNetwork = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectSelectedNetwork));
    const url = (0, _config.config)[selectedNetwork][(0, _backend.backend)()].explorer;
    return (0, _backend.backendApi)(url);
}
function* getChainContext() {
    const chainContext = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectChainContext));
    if (chainContext) return chainContext;
    try {
        const selectedNetwork = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectSelectedNetwork));
        const nic = yield* (0, _typedReduxSaga.call)(getOasisNic, selectedNetwork);
        const fetchedChainContext = yield* (0, _typedReduxSaga.call)([
            nic,
            nic.consensusGetChainContext
        ]);
        yield* (0, _typedReduxSaga.put)((0, _.networkActions).setChainContext(fetchedChainContext));
        return fetchedChainContext;
    } catch (error) {
        throw new (0, _errors.WalletError)((0, _errors.WalletErrors).UnknownGrpcError, 'Could not fetch data');
    }
}
function* getEpoch() {
    const epoch = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectEpoch));
    if (epoch) return epoch;
    try {
        const selectedNetwork = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectSelectedNetwork));
        const nic = yield* (0, _typedReduxSaga.call)(getOasisNic, selectedNetwork);
        const fetchedEpoch = yield* (0, _typedReduxSaga.call)([
            nic,
            nic.beaconGetEpoch
        ], _client.consensus.HEIGHT_LATEST);
        const fetchedEpochNumber = Number(fetchedEpoch);
        yield* (0, _typedReduxSaga.put)((0, _.networkActions).setEpoch(fetchedEpochNumber));
        return fetchedEpochNumber;
    } catch (error) {
        throw new (0, _errors.WalletError)((0, _errors.WalletErrors).UnknownGrpcError, 'Could not fetch data');
    }
}
function* selectNetwork({ network, isInitializing }) {
    const networkState = {
        ticker: (0, _config.config)[network].ticker,
        selectedNetwork: network,
        minimumStakingAmount: (0, _config.config)[network].min_delegation
    };
    if (isInitializing) yield* (0, _typedReduxSaga.put)((0, _.networkActions).initialNetworkSelected(networkState));
    else yield* (0, _typedReduxSaga.put)((0, _.networkActions).networkSelected(networkState));
}
function* networkSaga() {
    yield* (0, _typedReduxSaga.takeLatest)([
        (0, _.networkActions).initializeNetwork,
        (0, _.networkActions).selectNetwork,
        (0, _persist.persistActions).setUnlockedRootState,
        (0, _persist.persistActions).resetRootState,
        (0, _reduxStateSync.RECEIVE_INIT_STATE)
    ], function*(action) {
        const currentNetworkType = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectSelectedNetwork));
        if ((0, _.networkActions).initializeNetwork.match(action)) yield* (0, _typedReduxSaga.call)(selectNetwork, {
            network: currentNetworkType,
            isInitializing: true
        });
        if ((0, _.networkActions).selectNetwork.match(action)) yield* (0, _typedReduxSaga.call)(selectNetwork, {
            network: action.payload,
            isInitializing: false
        });
        if ((0, _persist.persistActions).setUnlockedRootState.match(action)) {
            const rootState = action.payload.persistedRootState;
            yield* (0, _typedReduxSaga.call)(selectNetwork, {
                network: rootState.network.selectedNetwork,
                isInitializing: false
            });
        }
        if ((0, _persist.persistActions).resetRootState.match(action)) yield* (0, _typedReduxSaga.call)(selectNetwork, {
            network: currentNetworkType,
            isInitializing: false
        });
        if (action.type === (0, _reduxStateSync.RECEIVE_INIT_STATE)) {
            const rootState = action.payload;
            yield* (0, _typedReduxSaga.call)(selectNetwork, {
                network: rootState.network.selectedNetwork,
                isInitializing: false
            });
        }
    });
    yield* (0, _typedReduxSaga.takeLatest)((0, _persist.persistActions).resetRootState, function*() {
        const skipUnlockOnInit = yield* (0, _typedReduxSaga.select)((0, _selectors.selectSkipUnlockingOnInit));
        if (skipUnlockOnInit) yield* (0, _typedReduxSaga.put)((0, _persist.persistActions).skipUnlocking());
    });
    yield* (0, _typedReduxSaga.takeLatest)((0, _.networkActions).getEpoch, getEpoch);
    yield* (0, _typedReduxSaga.put)((0, _.networkActions).initializeNetwork());
}

},{"@oasisprotocol/client":"9pxEg","app/state/persist":"9hwZK","app/state/persist/selectors":"lDilG","config":"akiw0","redux-state-sync":"g1h73","typed-redux-saga":"1vcsM","vendors/backend":"aIngR",".":"8NDHR","./selectors":"2zit7","types/errors":"gbx4q","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lDilG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectSlice", ()=>selectSlice);
parcelHelpers.export(exports, "selectLoading", ()=>selectLoading);
parcelHelpers.export(exports, "selectEnteredWrongPassword", ()=>selectEnteredWrongPassword);
parcelHelpers.export(exports, "selectNeedsPassword", ()=>selectNeedsPassword);
parcelHelpers.export(exports, "selectHasV0StorageToMigrate", ()=>selectHasV0StorageToMigrate);
parcelHelpers.export(exports, "selectSkipUnlockingOnInit", ()=>selectSkipUnlockingOnInit);
parcelHelpers.export(exports, "selectIsPersistenceUnsupported", ()=>selectIsPersistenceUnsupported);
parcelHelpers.export(exports, "selectStringifiedEncryptionKey", ()=>selectStringifiedEncryptionKey);
var _toolkit = require("@reduxjs/toolkit");
var _ = require(".");
const selectSlice = (state)=>state.persist || (0, _.getInitialState)();
const selectLoading = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.loading);
const selectEnteredWrongPassword = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.enteredWrongPassword);
const selectNeedsPassword = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.hasPersistedProfiles && !state.stringifiedEncryptionKey);
const selectHasV0StorageToMigrate = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.hasV0StorageToMigrate);
const selectSkipUnlockingOnInit = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>!state.hasPersistedProfiles && !state.stringifiedEncryptionKey);
const selectIsPersistenceUnsupported = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.isPersistenceUnsupported);
const selectStringifiedEncryptionKey = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.stringifiedEncryptionKey);

},{"@reduxjs/toolkit":"9ol63",".":"9hwZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"g1h73":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initMessageListener = exports.initStateWithPrevTab = exports.withReduxStateSync = exports.createReduxStateSync = exports.createStateSyncMiddleware = exports.WINDOW_STATE_SYNC_ID = exports.INIT_MESSAGE_LISTENER = exports.RECEIVE_INIT_STATE = exports.SEND_INIT_STATE = exports.GET_INIT_STATE = undefined;
exports.generateUuidForAction = generateUuidForAction;
exports.isActionAllowed = isActionAllowed;
exports.isActionSynced = isActionSynced;
exports.MessageListener = MessageListener;
var _broadcastChannel = require("9078cf266ebf95d6");
var lastUuid = 0;
var GET_INIT_STATE = exports.GET_INIT_STATE = '&_GET_INIT_STATE';
var SEND_INIT_STATE = exports.SEND_INIT_STATE = '&_SEND_INIT_STATE';
var RECEIVE_INIT_STATE = exports.RECEIVE_INIT_STATE = '&_RECEIVE_INIT_STATE';
var INIT_MESSAGE_LISTENER = exports.INIT_MESSAGE_LISTENER = '&_INIT_MESSAGE_LISTENER';
var defaultConfig = {
    channel: 'redux_state_sync',
    predicate: null,
    blacklist: [],
    whitelist: [],
    broadcastChannelOption: undefined,
    prepareState: function prepareState(state) {
        return state;
    },
    receiveState: function receiveState(prevState, nextState) {
        return nextState;
    }
};
var getIniteState = function getIniteState() {
    return {
        type: GET_INIT_STATE
    };
};
var sendIniteState = function sendIniteState() {
    return {
        type: SEND_INIT_STATE
    };
};
var receiveIniteState = function receiveIniteState(state) {
    return {
        type: RECEIVE_INIT_STATE,
        payload: state
    };
};
var initListener = function initListener() {
    return {
        type: INIT_MESSAGE_LISTENER
    };
};
function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}
function guid() {
    return '' + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}
// generate current window unique id
var WINDOW_STATE_SYNC_ID = exports.WINDOW_STATE_SYNC_ID = guid();
// export for test
function generateUuidForAction(action) {
    var stampedAction = action;
    stampedAction.$uuid = guid();
    stampedAction.$wuid = WINDOW_STATE_SYNC_ID;
    return stampedAction;
}
// export for test
function isActionAllowed(_ref) {
    var predicate = _ref.predicate, blacklist = _ref.blacklist, whitelist = _ref.whitelist;
    var allowed = function allowed() {
        return true;
    };
    if (predicate && typeof predicate === 'function') allowed = predicate;
    else if (Array.isArray(blacklist)) allowed = function allowed(action) {
        return blacklist.indexOf(action.type) < 0;
    };
    else if (Array.isArray(whitelist)) allowed = function allowed(action) {
        return whitelist.indexOf(action.type) >= 0;
    };
    return allowed;
}
// export for test
function isActionSynced(action) {
    return !!action.$isSync;
}
// export for test
function MessageListener(_ref2) {
    var channel = _ref2.channel, dispatch = _ref2.dispatch, allowed = _ref2.allowed;
    var isSynced = false;
    var tabs = {};
    this.handleOnMessage = function(stampedAction) {
        // Ignore if this action is triggered by this window
        if (stampedAction.$wuid === WINDOW_STATE_SYNC_ID) return;
        // IE bug https://stackoverflow.com/questions/18265556/why-does-internet-explorer-fire-the-window-storage-event-on-the-window-that-st
        if (stampedAction.type === RECEIVE_INIT_STATE) return;
        // ignore other values that saved to localstorage.
        if (stampedAction.$uuid && stampedAction.$uuid !== lastUuid) {
            if (stampedAction.type === GET_INIT_STATE && !tabs[stampedAction.$wuid]) {
                tabs[stampedAction.$wuid] = true;
                dispatch(sendIniteState());
            } else if (stampedAction.type === SEND_INIT_STATE && !tabs[stampedAction.$wuid]) {
                if (!isSynced) {
                    isSynced = true;
                    dispatch(receiveIniteState(stampedAction.payload));
                }
            } else if (allowed(stampedAction)) {
                lastUuid = stampedAction.$uuid;
                dispatch(Object.assign(stampedAction, {
                    $isSync: true
                }));
            }
        }
    };
    this.messageChannel = channel;
    this.messageChannel.onmessage = this.handleOnMessage;
}
var createStateSyncMiddleware = exports.createStateSyncMiddleware = function createStateSyncMiddleware() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultConfig;
    var allowed = isActionAllowed(config);
    var channel = new _broadcastChannel.BroadcastChannel(config.channel, config.broadcastChannelOption);
    var prepareState = config.prepareState || defaultConfig.prepareState;
    var messageListener = null;
    return function(_ref3) {
        var getState = _ref3.getState, dispatch = _ref3.dispatch;
        return function(next) {
            return function(action) {
                // create message receiver
                if (!messageListener) messageListener = new MessageListener({
                    channel: channel,
                    dispatch: dispatch,
                    allowed: allowed
                });
                // post messages
                if (action && !action.$uuid) {
                    var stampedAction = generateUuidForAction(action);
                    lastUuid = stampedAction.$uuid;
                    try {
                        if (action.type === SEND_INIT_STATE) {
                            if (getState()) {
                                stampedAction.payload = prepareState(getState());
                                channel.postMessage(stampedAction);
                            }
                            return next(action);
                        }
                        if (allowed(stampedAction) || action.type === GET_INIT_STATE) channel.postMessage(stampedAction);
                    } catch (e) {
                        console.error("Your browser doesn't support cross tab communication");
                    }
                }
                return next(Object.assign(action, {
                    $isSync: typeof action.$isSync === 'undefined' ? false : action.$isSync
                }));
            };
        };
    };
};
// eslint-disable-next-line max-len
var createReduxStateSync = exports.createReduxStateSync = function createReduxStateSync(appReducer) {
    var receiveState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultConfig.receiveState;
    return function(state, action) {
        var initState = state;
        if (action.type === RECEIVE_INIT_STATE) initState = receiveState(state, action.payload);
        return appReducer(initState, action);
    };
};
// init state with other tab's state
var withReduxStateSync = exports.withReduxStateSync = createReduxStateSync;
var initStateWithPrevTab = exports.initStateWithPrevTab = function initStateWithPrevTab(_ref4) {
    var dispatch = _ref4.dispatch;
    dispatch(getIniteState());
};
/*
if don't dispath any action, the store.dispath will not be available for message listener.
therefor need to trigger an empty action to init the messageListener.

however, if already using initStateWithPrevTab, this function will be redundant
*/ var initMessageListener = exports.initMessageListener = function initMessageListener(_ref5) {
    var dispatch = _ref5.dispatch;
    dispatch(initListener());
};

},{"9078cf266ebf95d6":"3WroU"}],"3WroU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BroadcastChannel", ()=>(0, _broadcastChannel.BroadcastChannel));
parcelHelpers.export(exports, "clearNodeFolder", ()=>(0, _broadcastChannel.clearNodeFolder));
parcelHelpers.export(exports, "enforceOptions", ()=>(0, _broadcastChannel.enforceOptions));
parcelHelpers.export(exports, "createLeaderElection", ()=>(0, _leaderElection.createLeaderElection));
parcelHelpers.export(exports, "beLeader", ()=>(0, _leaderElection.beLeader));
var _broadcastChannel = require("./broadcast-channel");
var _leaderElection = require("./leader-election");

},{"./broadcast-channel":"duEyG","./leader-election":"4Wh5X","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"duEyG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BroadcastChannel", ()=>BroadcastChannel);
/**
 * clears the tmp-folder if is node
 * @return {Promise<boolean>} true if has run, false if not node
 */ parcelHelpers.export(exports, "clearNodeFolder", ()=>clearNodeFolder);
parcelHelpers.export(exports, "enforceOptions", ()=>enforceOptions) // PROTOTYPE
;
var _utilJs = require("./util.js");
var _methodChooserJs = require("./method-chooser.js");
var _optionsJs = require("./options.js");
var BroadcastChannel = function BroadcastChannel(name, options) {
    this.name = name;
    if (ENFORCED_OPTIONS) options = ENFORCED_OPTIONS;
    this.options = (0, _optionsJs.fillOptionsWithDefaults)(options);
    this.method = (0, _methodChooserJs.chooseMethod)(this.options); // isListening
    this._iL = false;
    /**
   * _onMessageListener
   * setting onmessage twice,
   * will overwrite the first listener
   */ this._onML = null;
    /**
   * _addEventListeners
   */ this._addEL = {
        message: [],
        internal: []
    };
    /**
   * Unsend message promises
   * where the sending is still in progress
   * @type {Set<Promise>}
   */ this._uMP = new Set();
    /**
   * _beforeClose
   * array of promises that will be awaited
   * before the channel is closed
   */ this._befC = [];
    /**
   * _preparePromise
   */ this._prepP = null;
    _prepareChannel(this);
}; // STATICS
/**
 * used to identify if someone overwrites
 * window.BroadcastChannel with this
 * See methods/native.js
 */ BroadcastChannel._pubkey = true;
function clearNodeFolder(options) {
    options = (0, _optionsJs.fillOptionsWithDefaults)(options);
    var method = (0, _methodChooserJs.chooseMethod)(options);
    if (method.type === 'node') return method.clearNodeFolder().then(function() {
        return true;
    });
    else return Promise.resolve(false);
}
/**
 * if set, this method is enforced,
 * no mather what the options are
 */ var ENFORCED_OPTIONS;
function enforceOptions(options) {
    ENFORCED_OPTIONS = options;
}
BroadcastChannel.prototype = {
    postMessage: function postMessage(msg) {
        if (this.closed) throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed");
        return _post(this, 'message', msg);
    },
    postInternal: function postInternal(msg) {
        return _post(this, 'internal', msg);
    },
    set onmessage (fn){
        var time = this.method.microSeconds();
        var listenObj = {
            time: time,
            fn: fn
        };
        _removeListenerObject(this, 'message', this._onML);
        if (fn && typeof fn === 'function') {
            this._onML = listenObj;
            _addListenerObject(this, 'message', listenObj);
        } else this._onML = null;
    },
    addEventListener: function addEventListener(type, fn1) {
        var time = this.method.microSeconds();
        var listenObj = {
            time: time,
            fn: fn1
        };
        _addListenerObject(this, type, listenObj);
    },
    removeEventListener: function removeEventListener(type, fn1) {
        var obj = this._addEL[type].find(function(obj) {
            return obj.fn === fn1;
        });
        _removeListenerObject(this, type, obj);
    },
    close: function close() {
        var _this = this;
        if (this.closed) return;
        this.closed = true;
        var awaitPrepare = this._prepP ? this._prepP : Promise.resolve();
        this._onML = null;
        this._addEL.message = [];
        return awaitPrepare // wait until all current sending are processed
        .then(function() {
            return Promise.all(Array.from(_this._uMP));
        }) // run before-close hooks
        .then(function() {
            return Promise.all(_this._befC.map(function(fn1) {
                return fn1();
            }));
        }) // close the channel
        .then(function() {
            return _this.method.close(_this._state);
        });
    },
    get type () {
        return this.method.type;
    },
    get isClosed () {
        return this.closed;
    }
};
/**
 * Post a message over the channel
 * @returns {Promise} that resolved when the message sending is done
 */ function _post(broadcastChannel, type, msg) {
    var time = broadcastChannel.method.microSeconds();
    var msgObj = {
        time: time,
        type: type,
        data: msg
    };
    var awaitPrepare = broadcastChannel._prepP ? broadcastChannel._prepP : Promise.resolve();
    return awaitPrepare.then(function() {
        var sendPromise = broadcastChannel.method.postMessage(broadcastChannel._state, msgObj); // add/remove to unsend messages list
        broadcastChannel._uMP.add(sendPromise);
        sendPromise["catch"]().then(function() {
            return broadcastChannel._uMP["delete"](sendPromise);
        });
        return sendPromise;
    });
}
function _prepareChannel(channel) {
    var maybePromise = channel.method.create(channel.name, channel.options);
    if ((0, _utilJs.isPromise)(maybePromise)) {
        channel._prepP = maybePromise;
        maybePromise.then(function(s) {
            // used in tests to simulate slow runtime
            /*if (channel.options.prepareDelay) {
           await new Promise(res => setTimeout(res, this.options.prepareDelay));
      }*/ channel._state = s;
        });
    } else channel._state = maybePromise;
}
function _hasMessageListeners(channel) {
    if (channel._addEL.message.length > 0) return true;
    if (channel._addEL.internal.length > 0) return true;
    return false;
}
function _addListenerObject(channel, type, obj) {
    channel._addEL[type].push(obj);
    _startListening(channel);
}
function _removeListenerObject(channel, type, obj) {
    channel._addEL[type] = channel._addEL[type].filter(function(o) {
        return o !== obj;
    });
    _stopListening(channel);
}
function _startListening(channel) {
    if (!channel._iL && _hasMessageListeners(channel)) {
        // someone is listening, start subscribing
        var listenerFn = function listenerFn(msgObj) {
            channel._addEL[msgObj.type].forEach(function(obj) {
                if (msgObj.time >= obj.time) obj.fn(msgObj.data);
            });
        };
        var time = channel.method.microSeconds();
        if (channel._prepP) channel._prepP.then(function() {
            channel._iL = true;
            channel.method.onMessage(channel._state, listenerFn, time);
        });
        else {
            channel._iL = true;
            channel.method.onMessage(channel._state, listenerFn, time);
        }
    }
}
function _stopListening(channel) {
    if (channel._iL && !_hasMessageListeners(channel)) {
        // noone is listening, stop subscribing
        channel._iL = false;
        var time = channel.method.microSeconds();
        channel.method.onMessage(channel._state, null, time);
    }
}

},{"./util.js":"goTO2","./method-chooser.js":"18QNV","./options.js":"hlruW","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"goTO2":[function(require,module,exports,__globalThis) {
/**
 * returns true if the given object is a promise
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
parcelHelpers.export(exports, "sleep", ()=>sleep);
parcelHelpers.export(exports, "randomInt", ()=>randomInt);
/**
 * https://stackoverflow.com/a/8084248
 */ parcelHelpers.export(exports, "randomToken", ()=>randomToken);
/**
 * returns the current time in micro-seconds,
 * WARNING: This is a pseudo-function
 * Performance.now is not reliable in webworkers, so we just make sure to never return the same time.
 * This is enough in browsers, and this function will not be used in nodejs.
 * The main reason for this hack is to ensure that BroadcastChannel behaves equal to production when it is used in fast-running unit tests.
 */ parcelHelpers.export(exports, "microSeconds", ()=>microSeconds);
parcelHelpers.export(exports, "isNode", ()=>isNode);
function isPromise(obj) {
    if (obj && typeof obj.then === 'function') return true;
    else return false;
}
function sleep(time) {
    if (!time) time = 0;
    return new Promise(function(res) {
        return setTimeout(res, time);
    });
}
function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
function randomToken() {
    return Math.random().toString(36).substring(2);
}
var lastMs = 0;
var additional = 0;
function microSeconds() {
    var ms = new Date().getTime();
    if (ms === lastMs) {
        additional++;
        return ms * 1000 + additional;
    } else {
        lastMs = ms;
        additional = 0;
        return ms * 1000;
    }
}
var isNode = Object.prototype.toString.call(0) === '[object process]';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"18QNV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chooseMethod", ()=>chooseMethod);
var _nativeJs = require("./methods/native.js");
var _nativeJsDefault = parcelHelpers.interopDefault(_nativeJs);
var _indexedDbJs = require("./methods/indexed-db.js");
var _indexedDbJsDefault = parcelHelpers.interopDefault(_indexedDbJs);
var _localstorageJs = require("./methods/localstorage.js");
var _localstorageJsDefault = parcelHelpers.interopDefault(_localstorageJs);
var _simulateJs = require("./methods/simulate.js");
var _simulateJsDefault = parcelHelpers.interopDefault(_simulateJs);
var _util = require("./util"); // order is important
var METHODS = [
    (0, _nativeJsDefault.default),
    (0, _indexedDbJsDefault.default),
    (0, _localstorageJsDefault.default)
];
/**
 * The NodeMethod is loaded lazy
 * so it will not get bundled in browser-builds
 */ if (0, _util.isNode) {
    /**
   * we use the non-transpiled code for nodejs
   * because it runs faster
   */ var NodeMethod = require("c8f58ca16f8b957b");
    /**
   * this will be false for webpackbuilds
   * which will shim the node-method with an empty object {}
   */ if (typeof NodeMethod.canBeUsed === 'function') METHODS.push(NodeMethod);
}
function chooseMethod(options) {
    var chooseMethods = [].concat(options.methods, METHODS).filter(Boolean); // directly chosen
    if (options.type) {
        if (options.type === 'simulate') // only use simulate-method if directly chosen
        return 0, _simulateJsDefault.default;
        var ret = chooseMethods.find(function(m) {
            return m.type === options.type;
        });
        if (!ret) throw new Error('method-type ' + options.type + ' not found');
        else return ret;
    }
    /**
   * if no webworker support is needed,
   * remove idb from the list so that localstorage is been chosen
   */ if (!options.webWorkerSupport && !(0, _util.isNode)) chooseMethods = chooseMethods.filter(function(m) {
        return m.type !== 'idb';
    });
    var useMethod = chooseMethods.find(function(method) {
        return method.canBeUsed();
    });
    if (!useMethod) throw new Error('No useable methode found:' + JSON.stringify(METHODS.map(function(m) {
        return m.type;
    })));
    else return useMethod;
}

},{"./methods/native.js":"7XUoL","./methods/indexed-db.js":"lF6w4","./methods/localstorage.js":"dH53Q","./methods/simulate.js":"2OLCC","./util":"goTO2","c8f58ca16f8b957b":"cIz3r","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7XUoL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "microSeconds", ()=>microSeconds);
parcelHelpers.export(exports, "type", ()=>type);
parcelHelpers.export(exports, "create", ()=>create);
parcelHelpers.export(exports, "close", ()=>close);
parcelHelpers.export(exports, "postMessage", ()=>postMessage);
parcelHelpers.export(exports, "onMessage", ()=>onMessage);
parcelHelpers.export(exports, "canBeUsed", ()=>canBeUsed);
parcelHelpers.export(exports, "averageResponseTime", ()=>averageResponseTime);
var _util = require("../util");
var microSeconds = (0, _util.microSeconds);
var type = 'native';
function create(channelName) {
    var state = {
        messagesCallback: null,
        bc: new BroadcastChannel(channelName),
        subFns: [] // subscriberFunctions
    };
    state.bc.onmessage = function(msg) {
        if (state.messagesCallback) state.messagesCallback(msg.data);
    };
    return state;
}
function close(channelState) {
    channelState.bc.close();
    channelState.subFns = [];
}
function postMessage(channelState, messageJson) {
    try {
        channelState.bc.postMessage(messageJson, false);
        return Promise.resolve();
    } catch (err) {
        return Promise.reject(err);
    }
}
function onMessage(channelState, fn) {
    channelState.messagesCallback = fn;
}
function canBeUsed() {
    /**
   * in the electron-renderer, isNode will be true even if we are in browser-context
   * so we also check if window is undefined
   */ if ((0, _util.isNode) && typeof window === 'undefined') return false;
    if (typeof BroadcastChannel === 'function') {
        if (BroadcastChannel._pubkey) throw new Error('BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill');
        return true;
    } else return false;
}
function averageResponseTime() {
    return 150;
}
exports.default = {
    create: create,
    close: close,
    onMessage: onMessage,
    postMessage: postMessage,
    canBeUsed: canBeUsed,
    type: type,
    averageResponseTime: averageResponseTime,
    microSeconds: microSeconds
};

},{"../util":"goTO2","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lF6w4":[function(require,module,exports,__globalThis) {
/**
 * this method uses indexeddb to store the messages
 * There is currently no observerAPI for idb
 * @link https://github.com/w3c/IndexedDB/issues/51
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "microSeconds", ()=>microSeconds);
parcelHelpers.export(exports, "type", ()=>type);
parcelHelpers.export(exports, "getIdb", ()=>getIdb);
parcelHelpers.export(exports, "createDatabase", ()=>createDatabase);
/**
 * writes the new message to the database
 * so other readers can find it
 */ parcelHelpers.export(exports, "writeMessage", ()=>writeMessage);
parcelHelpers.export(exports, "getAllMessages", ()=>getAllMessages);
parcelHelpers.export(exports, "getMessagesHigherThan", ()=>getMessagesHigherThan);
parcelHelpers.export(exports, "removeMessageById", ()=>removeMessageById);
parcelHelpers.export(exports, "getOldMessages", ()=>getOldMessages);
parcelHelpers.export(exports, "cleanOldMessages", ()=>cleanOldMessages);
parcelHelpers.export(exports, "create", ()=>create);
parcelHelpers.export(exports, "close", ()=>close);
parcelHelpers.export(exports, "postMessage", ()=>postMessage);
parcelHelpers.export(exports, "onMessage", ()=>onMessage);
parcelHelpers.export(exports, "canBeUsed", ()=>canBeUsed);
parcelHelpers.export(exports, "averageResponseTime", ()=>averageResponseTime);
var _utilJs = require("../util.js");
var _obliviousSet = require("oblivious-set");
var _options = require("../options");
var microSeconds = (0, _utilJs.microSeconds);
var DB_PREFIX = 'pubkey.broadcast-channel-0-';
var OBJECT_STORE_ID = 'messages';
var type = 'idb';
function getIdb() {
    if (typeof indexedDB !== 'undefined') return indexedDB;
    if (typeof window !== 'undefined') {
        if (typeof window.mozIndexedDB !== 'undefined') return window.mozIndexedDB;
        if (typeof window.webkitIndexedDB !== 'undefined') return window.webkitIndexedDB;
        if (typeof window.msIndexedDB !== 'undefined') return window.msIndexedDB;
    }
    return false;
}
function createDatabase(channelName) {
    var IndexedDB = getIdb(); // create table
    var dbName = DB_PREFIX + channelName;
    var openRequest = IndexedDB.open(dbName, 1);
    openRequest.onupgradeneeded = function(ev) {
        var db = ev.target.result;
        db.createObjectStore(OBJECT_STORE_ID, {
            keyPath: 'id',
            autoIncrement: true
        });
    };
    var dbPromise = new Promise(function(res, rej) {
        openRequest.onerror = function(ev) {
            return rej(ev);
        };
        openRequest.onsuccess = function() {
            res(openRequest.result);
        };
    });
    return dbPromise;
}
function writeMessage(db, readerUuid, messageJson) {
    var time = new Date().getTime();
    var writeObject = {
        uuid: readerUuid,
        time: time,
        data: messageJson
    };
    var transaction = db.transaction([
        OBJECT_STORE_ID
    ], 'readwrite');
    return new Promise(function(res, rej) {
        transaction.oncomplete = function() {
            return res();
        };
        transaction.onerror = function(ev) {
            return rej(ev);
        };
        var objectStore = transaction.objectStore(OBJECT_STORE_ID);
        objectStore.add(writeObject);
    });
}
function getAllMessages(db) {
    var objectStore = db.transaction(OBJECT_STORE_ID).objectStore(OBJECT_STORE_ID);
    var ret = [];
    return new Promise(function(res) {
        objectStore.openCursor().onsuccess = function(ev) {
            var cursor = ev.target.result;
            if (cursor) {
                ret.push(cursor.value); //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);
                cursor["continue"]();
            } else res(ret);
        };
    });
}
function getMessagesHigherThan(db, lastCursorId) {
    var objectStore = db.transaction(OBJECT_STORE_ID).objectStore(OBJECT_STORE_ID);
    var ret = [];
    function openCursor() {
        // Occasionally Safari will fail on IDBKeyRange.bound, this
        // catches that error, having it open the cursor to the first
        // item. When it gets data it will advance to the desired key.
        try {
            var keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);
            return objectStore.openCursor(keyRangeValue);
        } catch (e) {
            return objectStore.openCursor();
        }
    }
    return new Promise(function(res) {
        openCursor().onsuccess = function(ev) {
            var cursor = ev.target.result;
            if (cursor) {
                if (cursor.value.id < lastCursorId + 1) cursor["continue"](lastCursorId + 1);
                else {
                    ret.push(cursor.value);
                    cursor["continue"]();
                }
            } else res(ret);
        };
    });
}
function removeMessageById(db, id) {
    var request = db.transaction([
        OBJECT_STORE_ID
    ], 'readwrite').objectStore(OBJECT_STORE_ID)["delete"](id);
    return new Promise(function(res) {
        request.onsuccess = function() {
            return res();
        };
    });
}
function getOldMessages(db, ttl) {
    var olderThen = new Date().getTime() - ttl;
    var objectStore = db.transaction(OBJECT_STORE_ID).objectStore(OBJECT_STORE_ID);
    var ret = [];
    return new Promise(function(res) {
        objectStore.openCursor().onsuccess = function(ev) {
            var cursor = ev.target.result;
            if (cursor) {
                var msgObk = cursor.value;
                if (msgObk.time < olderThen) {
                    ret.push(msgObk); //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);
                    cursor["continue"]();
                } else {
                    // no more old messages,
                    res(ret);
                    return;
                }
            } else res(ret);
        };
    });
}
function cleanOldMessages(db, ttl) {
    return getOldMessages(db, ttl).then(function(tooOld) {
        return Promise.all(tooOld.map(function(msgObj) {
            return removeMessageById(db, msgObj.id);
        }));
    });
}
function create(channelName, options) {
    options = (0, _options.fillOptionsWithDefaults)(options);
    return createDatabase(channelName).then(function(db) {
        var state = {
            closed: false,
            lastCursorId: 0,
            channelName: channelName,
            options: options,
            uuid: (0, _utilJs.randomToken)(),
            /**
       * emittedMessagesIds
       * contains all messages that have been emitted before
       * @type {ObliviousSet}
       */ eMIs: new (0, _obliviousSet.ObliviousSet)(options.idb.ttl * 2),
            // ensures we do not read messages in parrallel
            writeBlockPromise: Promise.resolve(),
            messagesCallback: null,
            readQueuePromises: [],
            db: db
        };
        /**
     * Handle abrupt closes that do not originate from db.close().
     * This could happen, for example, if the underlying storage is
     * removed or if the user clears the database in the browser's
     * history preferences.
     */ db.onclose = function() {
            state.closed = true;
            if (options.idb.onclose) options.idb.onclose();
        };
        /**
     * if service-workers are used,
     * we have no 'storage'-event if they post a message,
     * therefore we also have to set an interval
     */ _readLoop(state);
        return state;
    });
}
function _readLoop(state) {
    if (state.closed) return;
    readNewMessages(state).then(function() {
        return (0, _utilJs.sleep)(state.options.idb.fallbackInterval);
    }).then(function() {
        return _readLoop(state);
    });
}
function _filterMessage(msgObj, state) {
    if (msgObj.uuid === state.uuid) return false; // send by own
    if (state.eMIs.has(msgObj.id)) return false; // already emitted
    if (msgObj.data.time < state.messagesCallbackTime) return false; // older then onMessageCallback
    return true;
}
/**
 * reads all new messages from the database and emits them
 */ function readNewMessages(state) {
    // channel already closed
    if (state.closed) return Promise.resolve(); // if no one is listening, we do not need to scan for new messages
    if (!state.messagesCallback) return Promise.resolve();
    return getMessagesHigherThan(state.db, state.lastCursorId).then(function(newerMessages) {
        var useMessages = newerMessages/**
     * there is a bug in iOS where the msgObj can be undefined some times
     * so we filter them out
     * @link https://github.com/pubkey/broadcast-channel/issues/19
     */ .filter(function(msgObj) {
            return !!msgObj;
        }).map(function(msgObj) {
            if (msgObj.id > state.lastCursorId) state.lastCursorId = msgObj.id;
            return msgObj;
        }).filter(function(msgObj) {
            return _filterMessage(msgObj, state);
        }).sort(function(msgObjA, msgObjB) {
            return msgObjA.time - msgObjB.time;
        }); // sort by time
        useMessages.forEach(function(msgObj) {
            if (state.messagesCallback) {
                state.eMIs.add(msgObj.id);
                state.messagesCallback(msgObj.data);
            }
        });
        return Promise.resolve();
    });
}
function close(channelState) {
    channelState.closed = true;
    channelState.db.close();
}
function postMessage(channelState, messageJson) {
    channelState.writeBlockPromise = channelState.writeBlockPromise.then(function() {
        return writeMessage(channelState.db, channelState.uuid, messageJson);
    }).then(function() {
        if ((0, _utilJs.randomInt)(0, 10) === 0) /* await (do not await) */ cleanOldMessages(channelState.db, channelState.options.idb.ttl);
    });
    return channelState.writeBlockPromise;
}
function onMessage(channelState, fn, time) {
    channelState.messagesCallbackTime = time;
    channelState.messagesCallback = fn;
    readNewMessages(channelState);
}
function canBeUsed() {
    if (0, _utilJs.isNode) return false;
    var idb = getIdb();
    if (!idb) return false;
    return true;
}
function averageResponseTime(options) {
    return options.idb.fallbackInterval * 2;
}
exports.default = {
    create: create,
    close: close,
    onMessage: onMessage,
    postMessage: postMessage,
    canBeUsed: canBeUsed,
    type: type,
    averageResponseTime: averageResponseTime,
    microSeconds: microSeconds
};

},{"../util.js":"goTO2","oblivious-set":"ku2yF","../options":"hlruW","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ku2yF":[function(require,module,exports,__globalThis) {
/**
 * this is a set which automatically forgets
 * a given entry when a new entry is set and the ttl
 * of the old one is over
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObliviousSet", ()=>ObliviousSet);
/**
 * Removes all entries from the set
 * where the TTL has expired
 */ parcelHelpers.export(exports, "removeTooOldValues", ()=>removeTooOldValues);
parcelHelpers.export(exports, "now", ()=>now);
var ObliviousSet = /** @class */ function() {
    function ObliviousSet(ttl) {
        this.ttl = ttl;
        this.set = new Set();
        this.timeMap = new Map();
    }
    ObliviousSet.prototype.has = function(value) {
        return this.set.has(value);
    };
    ObliviousSet.prototype.add = function(value) {
        var _this = this;
        this.timeMap.set(value, now());
        this.set.add(value);
        /**
         * When a new value is added,
         * start the cleanup at the next tick
         * to not block the cpu for more important stuff
         * that might happen.
         */ setTimeout(function() {
            removeTooOldValues(_this);
        }, 0);
    };
    ObliviousSet.prototype.clear = function() {
        this.set.clear();
        this.timeMap.clear();
    };
    return ObliviousSet;
}();
function removeTooOldValues(obliviousSet) {
    var olderThen = now() - obliviousSet.ttl;
    var iterator = obliviousSet.set[Symbol.iterator]();
    /**
     * Because we can assume the new values are added at the bottom,
     * we start from the top and stop as soon as we reach a non-too-old value.
     */ while(true){
        var value = iterator.next().value;
        if (!value) return; // no more elements
        var time = obliviousSet.timeMap.get(value);
        if (time < olderThen) {
            obliviousSet.timeMap.delete(value);
            obliviousSet.set.delete(value);
        } else // We reached a value that is not old enough
        return;
    }
}
function now() {
    return new Date().getTime();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hlruW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fillOptionsWithDefaults", ()=>fillOptionsWithDefaults);
function fillOptionsWithDefaults() {
    var originalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = JSON.parse(JSON.stringify(originalOptions)); // main
    if (typeof options.webWorkerSupport === 'undefined') options.webWorkerSupport = true; // indexed-db
    if (!options.idb) options.idb = {}; //  after this time the messages get deleted
    if (!options.idb.ttl) options.idb.ttl = 45000;
    if (!options.idb.fallbackInterval) options.idb.fallbackInterval = 150; //  handles abrupt db onclose events.
    if (originalOptions.idb && typeof originalOptions.idb.onclose === 'function') options.idb.onclose = originalOptions.idb.onclose; // localstorage
    if (!options.localstorage) options.localstorage = {};
    if (!options.localstorage.removeTimeout) options.localstorage.removeTimeout = 60000; // custom methods
    if (originalOptions.methods) options.methods = originalOptions.methods; // node
    if (!options.node) options.node = {};
    if (!options.node.ttl) options.node.ttl = 120000; // 2 minutes;
    if (typeof options.node.useFastPath === 'undefined') options.node.useFastPath = true;
    return options;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dH53Q":[function(require,module,exports,__globalThis) {
/**
 * A localStorage-only method which uses localstorage and its 'storage'-event
 * This does not work inside of webworkers because they have no access to locastorage
 * This is basically implemented to support IE9 or your grandmothers toaster.
 * @link https://caniuse.com/#feat=namevalue-storage
 * @link https://caniuse.com/#feat=indexeddb
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "microSeconds", ()=>microSeconds);
parcelHelpers.export(exports, "type", ()=>type);
/**
 * copied from crosstab
 * @link https://github.com/tejacques/crosstab/blob/master/src/crosstab.js#L32
 */ parcelHelpers.export(exports, "getLocalStorage", ()=>getLocalStorage);
parcelHelpers.export(exports, "storageKey", ()=>storageKey);
/**
* writes the new message to the storage
* and fires the storage-event so other readers can find it
*/ parcelHelpers.export(exports, "postMessage", ()=>postMessage);
parcelHelpers.export(exports, "addStorageEventListener", ()=>addStorageEventListener);
parcelHelpers.export(exports, "removeStorageEventListener", ()=>removeStorageEventListener);
parcelHelpers.export(exports, "create", ()=>create);
parcelHelpers.export(exports, "close", ()=>close);
parcelHelpers.export(exports, "onMessage", ()=>onMessage);
parcelHelpers.export(exports, "canBeUsed", ()=>canBeUsed);
parcelHelpers.export(exports, "averageResponseTime", ()=>averageResponseTime);
var _obliviousSet = require("oblivious-set");
var _options = require("../options");
var _util = require("../util");
var microSeconds = (0, _util.microSeconds);
var KEY_PREFIX = 'pubkey.broadcastChannel-';
var type = 'localstorage';
function getLocalStorage() {
    var localStorage;
    if (typeof window === 'undefined') return null;
    try {
        localStorage = window.localStorage;
        localStorage = window['ie8-eventlistener/storage'] || window.localStorage;
    } catch (e) {
    // if cookies are disabled. See
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1028153
    }
    return localStorage;
}
function storageKey(channelName) {
    return KEY_PREFIX + channelName;
}
function postMessage(channelState, messageJson) {
    return new Promise(function(res) {
        (0, _util.sleep)().then(function() {
            var key = storageKey(channelState.channelName);
            var writeObj = {
                token: (0, _util.randomToken)(),
                time: new Date().getTime(),
                data: messageJson,
                uuid: channelState.uuid
            };
            var value = JSON.stringify(writeObj);
            getLocalStorage().setItem(key, value);
            /**
       * StorageEvent does not fire the 'storage' event
       * in the window that changes the state of the local storage.
       * So we fire it manually
       */ var ev = document.createEvent('Event');
            ev.initEvent('storage', true, true);
            ev.key = key;
            ev.newValue = value;
            window.dispatchEvent(ev);
            res();
        });
    });
}
function addStorageEventListener(channelName, fn) {
    var key = storageKey(channelName);
    var listener = function listener(ev) {
        if (ev.key === key) fn(JSON.parse(ev.newValue));
    };
    window.addEventListener('storage', listener);
    return listener;
}
function removeStorageEventListener(listener) {
    window.removeEventListener('storage', listener);
}
function create(channelName, options) {
    options = (0, _options.fillOptionsWithDefaults)(options);
    if (!canBeUsed()) throw new Error('BroadcastChannel: localstorage cannot be used');
    var uuid = (0, _util.randomToken)();
    /**
   * eMIs
   * contains all messages that have been emitted before
   * @type {ObliviousSet}
   */ var eMIs = new (0, _obliviousSet.ObliviousSet)(options.localstorage.removeTimeout);
    var state = {
        channelName: channelName,
        uuid: uuid,
        eMIs: eMIs // emittedMessagesIds
    };
    state.listener = addStorageEventListener(channelName, function(msgObj) {
        if (!state.messagesCallback) return; // no listener
        if (msgObj.uuid === uuid) return; // own message
        if (!msgObj.token || eMIs.has(msgObj.token)) return; // already emitted
        if (msgObj.data.time && msgObj.data.time < state.messagesCallbackTime) return; // too old
        eMIs.add(msgObj.token);
        state.messagesCallback(msgObj.data);
    });
    return state;
}
function close(channelState) {
    removeStorageEventListener(channelState.listener);
}
function onMessage(channelState, fn, time) {
    channelState.messagesCallbackTime = time;
    channelState.messagesCallback = fn;
}
function canBeUsed() {
    if (0, _util.isNode) return false;
    var ls = getLocalStorage();
    if (!ls) return false;
    try {
        var key = '__broadcastchannel_check';
        ls.setItem(key, 'works');
        ls.removeItem(key);
    } catch (e) {
        // Safari 10 in private mode will not allow write access to local
        // storage and fail with a QuotaExceededError. See
        // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API#Private_Browsing_Incognito_modes
        return false;
    }
    return true;
}
function averageResponseTime() {
    var defaultTime = 120;
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('safari') && !userAgent.includes('chrome')) // safari is much slower so this time is higher
    return defaultTime * 2;
    return defaultTime;
}
exports.default = {
    create: create,
    close: close,
    onMessage: onMessage,
    postMessage: postMessage,
    canBeUsed: canBeUsed,
    type: type,
    averageResponseTime: averageResponseTime,
    microSeconds: microSeconds
};

},{"oblivious-set":"ku2yF","../options":"hlruW","../util":"goTO2","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2OLCC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "microSeconds", ()=>microSeconds);
parcelHelpers.export(exports, "type", ()=>type);
parcelHelpers.export(exports, "create", ()=>create);
parcelHelpers.export(exports, "close", ()=>close);
parcelHelpers.export(exports, "postMessage", ()=>postMessage);
parcelHelpers.export(exports, "onMessage", ()=>onMessage);
parcelHelpers.export(exports, "canBeUsed", ()=>canBeUsed);
parcelHelpers.export(exports, "averageResponseTime", ()=>averageResponseTime);
var _util = require("../util");
var microSeconds = (0, _util.microSeconds);
var type = 'simulate';
var SIMULATE_CHANNELS = new Set();
function create(channelName) {
    var state = {
        name: channelName,
        messagesCallback: null
    };
    SIMULATE_CHANNELS.add(state);
    return state;
}
function close(channelState) {
    SIMULATE_CHANNELS["delete"](channelState);
}
function postMessage(channelState, messageJson) {
    return new Promise(function(res) {
        return setTimeout(function() {
            var channelArray = Array.from(SIMULATE_CHANNELS);
            channelArray.filter(function(channel) {
                return channel.name === channelState.name;
            }).filter(function(channel) {
                return channel !== channelState;
            }).filter(function(channel) {
                return !!channel.messagesCallback;
            }).forEach(function(channel) {
                return channel.messagesCallback(messageJson);
            });
            res();
        }, 5);
    });
}
function onMessage(channelState, fn) {
    channelState.messagesCallback = fn;
}
function canBeUsed() {
    return true;
}
function averageResponseTime() {
    return 5;
}
exports.default = {
    create: create,
    close: close,
    onMessage: onMessage,
    postMessage: postMessage,
    canBeUsed: canBeUsed,
    type: type,
    averageResponseTime: averageResponseTime,
    microSeconds: microSeconds
};

},{"../util":"goTO2","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4Wh5X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "beLeader", ()=>beLeader);
parcelHelpers.export(exports, "createLeaderElection", ()=>createLeaderElection);
var _utilJs = require("./util.js");
var _unload = require("unload");
var _unloadDefault = parcelHelpers.interopDefault(_unload);
var LeaderElection = function LeaderElection(channel, options) {
    this._channel = channel;
    this._options = options;
    this.isLeader = false;
    this.isDead = false;
    this.token = (0, _utilJs.randomToken)();
    this._isApl = false; // _isApplying
    this._reApply = false; // things to clean up
    this._unl = []; // _unloads
    this._lstns = []; // _listeners
    this._invs = []; // _intervals
    this._dpL = function() {}; // onduplicate listener
    this._dpLC = false; // true when onduplicate called
};
LeaderElection.prototype = {
    applyOnce: function applyOnce() {
        var _this = this;
        if (this.isLeader) return Promise.resolve(false);
        if (this.isDead) return Promise.resolve(false); // do nothing if already running
        if (this._isApl) {
            this._reApply = true;
            return Promise.resolve(false);
        }
        this._isApl = true;
        var stopCriteria = false;
        var recieved = [];
        var handleMessage = function handleMessage(msg) {
            if (msg.context === 'leader' && msg.token != _this.token) {
                recieved.push(msg);
                if (msg.action === 'apply') // other is applying
                {
                    if (msg.token > _this.token) // other has higher token, stop applying
                    stopCriteria = true;
                }
                if (msg.action === 'tell') // other is already leader
                stopCriteria = true;
            }
        };
        this._channel.addEventListener('internal', handleMessage);
        var ret = _sendMessage(this, 'apply') // send out that this one is applying
        .then(function() {
            return (0, _utilJs.sleep)(_this._options.responseTime);
        }) // let others time to respond
        .then(function() {
            if (stopCriteria) return Promise.reject(new Error());
            else return _sendMessage(_this, 'apply');
        }).then(function() {
            return (0, _utilJs.sleep)(_this._options.responseTime);
        }) // let others time to respond
        .then(function() {
            if (stopCriteria) return Promise.reject(new Error());
            else return _sendMessage(_this);
        }).then(function() {
            return beLeader(_this);
        }) // no one disagreed -> this one is now leader
        .then(function() {
            return true;
        })["catch"](function() {
            return false;
        }) // apply not successfull
        .then(function(success) {
            _this._channel.removeEventListener('internal', handleMessage);
            _this._isApl = false;
            if (!success && _this._reApply) {
                _this._reApply = false;
                return _this.applyOnce();
            } else return success;
        });
        return ret;
    },
    awaitLeadership: function awaitLeadership() {
        if (/* _awaitLeadershipPromise */ !this._aLP) this._aLP = _awaitLeadershipOnce(this);
        return this._aLP;
    },
    set onduplicate (fn){
        this._dpL = fn;
    },
    die: function die() {
        var _this2 = this;
        if (this.isDead) return;
        this.isDead = true;
        this._lstns.forEach(function(listener) {
            return _this2._channel.removeEventListener('internal', listener);
        });
        this._invs.forEach(function(interval) {
            return clearInterval(interval);
        });
        this._unl.forEach(function(uFn) {
            uFn.remove();
        });
        return _sendMessage(this, 'death');
    }
};
function _awaitLeadershipOnce(leaderElector) {
    if (leaderElector.isLeader) return Promise.resolve();
    return new Promise(function(res) {
        var resolved = false;
        function finish() {
            if (resolved) return;
            resolved = true;
            clearInterval(interval);
            leaderElector._channel.removeEventListener('internal', whenDeathListener);
            res(true);
        } // try once now
        leaderElector.applyOnce().then(function() {
            if (leaderElector.isLeader) finish();
        }); // try on fallbackInterval
        var interval = setInterval(function() {
            leaderElector.applyOnce().then(function() {
                if (leaderElector.isLeader) finish();
            });
        }, leaderElector._options.fallbackInterval);
        leaderElector._invs.push(interval); // try when other leader dies
        var whenDeathListener = function whenDeathListener(msg) {
            if (msg.context === 'leader' && msg.action === 'death') leaderElector.applyOnce().then(function() {
                if (leaderElector.isLeader) finish();
            });
        };
        leaderElector._channel.addEventListener('internal', whenDeathListener);
        leaderElector._lstns.push(whenDeathListener);
    });
}
/**
 * sends and internal message over the broadcast-channel
 */ function _sendMessage(leaderElector, action) {
    var msgJson = {
        context: 'leader',
        action: action,
        token: leaderElector.token
    };
    return leaderElector._channel.postInternal(msgJson);
}
function beLeader(leaderElector) {
    leaderElector.isLeader = true;
    var unloadFn = (0, _unloadDefault.default).add(function() {
        return leaderElector.die();
    });
    leaderElector._unl.push(unloadFn);
    var isLeaderListener = function isLeaderListener(msg) {
        if (msg.context === 'leader' && msg.action === 'apply') _sendMessage(leaderElector, 'tell');
        if (msg.context === 'leader' && msg.action === 'tell' && !leaderElector._dpLC) {
            /**
       * another instance is also leader!
       * This can happen on rare events
       * like when the CPU is at 100% for long time
       * or the tabs are open very long and the browser throttles them.
       * @link https://github.com/pubkey/broadcast-channel/issues/414
       * @link https://github.com/pubkey/broadcast-channel/issues/385
       */ leaderElector._dpLC = true;
            leaderElector._dpL(); // message the lib user so the app can handle the problem
            _sendMessage(leaderElector, 'tell'); // ensure other leader also knows the problem
        }
    };
    leaderElector._channel.addEventListener('internal', isLeaderListener);
    leaderElector._lstns.push(isLeaderListener);
    return _sendMessage(leaderElector, 'tell');
}
function fillOptionsWithDefaults(options, channel) {
    if (!options) options = {};
    options = JSON.parse(JSON.stringify(options));
    if (!options.fallbackInterval) options.fallbackInterval = 3000;
    if (!options.responseTime) options.responseTime = channel.method.averageResponseTime(channel.options);
    return options;
}
function createLeaderElection(channel, options) {
    if (channel._leaderElector) throw new Error('BroadcastChannel already has a leader-elector');
    options = fillOptionsWithDefaults(options, channel);
    var elector = new LeaderElection(channel, options);
    channel._befC.push(function() {
        return elector.die();
    });
    channel._leaderElector = elector;
    return elector;
}

},{"./util.js":"goTO2","unload":"16liO","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"16liO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", ()=>add);
parcelHelpers.export(exports, "runAll", ()=>runAll);
parcelHelpers.export(exports, "removeAll", ()=>removeAll);
parcelHelpers.export(exports, "getSize", ()=>getSize);
var _detectNode = require("detect-node");
var _detectNodeDefault = parcelHelpers.interopDefault(_detectNode);
var _browserJs = require("./browser.js");
var _browserJsDefault = parcelHelpers.interopDefault(_browserJs);
var _nodeJs = require("./node.js");
var _nodeJsDefault = parcelHelpers.interopDefault(_nodeJs);
var USE_METHOD = (0, _detectNodeDefault.default) ? (0, _nodeJsDefault.default) : (0, _browserJsDefault.default);
var LISTENERS = new Set();
var startedListening = false;
function startListening() {
    if (startedListening) return;
    startedListening = true;
    USE_METHOD.add(runAll);
}
function add(fn) {
    startListening();
    if (typeof fn !== 'function') throw new Error('Listener is no function');
    LISTENERS.add(fn);
    var addReturn = {
        remove: function remove() {
            return LISTENERS["delete"](fn);
        },
        run: function run() {
            LISTENERS["delete"](fn);
            return fn();
        }
    };
    return addReturn;
}
function runAll() {
    var promises = [];
    LISTENERS.forEach(function(fn) {
        promises.push(fn());
        LISTENERS["delete"](fn);
    });
    return Promise.all(promises);
}
function removeAll() {
    LISTENERS.clear();
}
function getSize() {
    return LISTENERS.size;
}
exports.default = {
    add: add,
    runAll: runAll,
    removeAll: removeAll,
    getSize: getSize
};

},{"detect-node":"ktdU7","./browser.js":"gzrFC","./node.js":"cIz3r","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ktdU7":[function(require,module,exports,__globalThis) {
module.exports = false;

},{}],"gzrFC":[function(require,module,exports,__globalThis) {
/* global WorkerGlobalScope */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function add(fn) {
    if (typeof WorkerGlobalScope === 'function' && self instanceof WorkerGlobalScope) ;
    else {
        /**
     * if we are on react-native, there is no window.addEventListener
     * @link https://github.com/pubkey/unload/issues/6
     */ if (typeof window.addEventListener !== 'function') return;
        /**
     * for normal browser-windows, we use the beforeunload-event
     */ window.addEventListener('beforeunload', function() {
            fn();
        }, true);
        /**
     * for iframes, we have to use the unload-event
     * @link https://stackoverflow.com/q/47533670/3443137
     */ window.addEventListener('unload', function() {
            fn();
        }, true);
    }
/**
   * TODO add fallback for safari-mobile
   * @link https://stackoverflow.com/a/26193516/3443137
   */ }
exports.default = {
    add: add
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aIngR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "backend", ()=>backend);
parcelHelpers.export(exports, "backendApi", ()=>backendApi);
var _oasisscanV2 = require("vendors/oasisscan-v2");
var _nexus = require("vendors/nexus");
var _config = require("config");
const backendNameToApi = {
    [(0, _config.BackendAPIs).OasisScanV2]: (0, _oasisscanV2.getOasisscanV2APIs),
    [(0, _config.BackendAPIs).Nexus]: (0, _nexus.getNexusAPIs)
};
const backend = ()=>"nexus";
const backendApi = backendNameToApi[backend()];

},{"vendors/oasisscan-v2":"ft2IP","vendors/nexus":"9Czgc","config":"akiw0","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ft2IP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOasisscanV2APIs", ()=>getOasisscanV2APIs);
parcelHelpers.export(exports, "parseAccount", ()=>parseAccount);
parcelHelpers.export(exports, "parseValidatorsList", ()=>parseValidatorsList);
parcelHelpers.export(exports, "parseTransactionsList", ()=>parseTransactionsList);
parcelHelpers.export(exports, "parseDelegations", ()=>parseDelegations);
parcelHelpers.export(exports, "parseDebonding", ()=>parseDebonding);
var _types = require("app/state/transaction/types");
var _helpers = require("app/lib/helpers");
var _index = require("vendors/oasisscan-v2/index");
var _helpers1 = require("./helpers");
const getTransactionCacheMap = {};
const getRuntimeTransactionInfoCacheMap = {};
function getOasisscanV2APIs(url) {
    const explorerConfig = new (0, _index.Configuration)({
        basePath: url,
        ...(0, _helpers1.throwAPIErrors)
    });
    const accountApi = new (0, _index.AccountApi)(explorerConfig);
    const chainApi = new (0, _index.ChainApi)(explorerConfig);
    const validatorApi = new (0, _index.ValidatorApi)(explorerConfig);
    const runtimeApi = new (0, _index.RuntimeApi)(explorerConfig);
    async function getAccount(address) {
        const account = await accountApi.accountInfoHandler({
            address
        });
        if (!account) throw new Error('Wrong response code');
        return parseAccount(account);
    }
    async function getAllValidators() {
        const validators = await validatorApi.validatorListHandler({
            orderBy: 'escrow',
            sort: 'desc'
        });
        if (!validators) throw new Error('Wrong response code');
        return parseValidatorsList(validators.list);
    }
    function getRuntimeTransactionInfoUrl(filter) {
        const searchParams = new URLSearchParams(filter);
        searchParams.sort();
        return `${url}/runtime/transaction/info?${searchParams.toString()}`;
    }
    async function getRuntimeTransactionInfo(tx) {
        const cacheId = getRuntimeTransactionInfoUrl({
            id: tx.runtimeId,
            hash: tx.txHash
        });
        if (cacheId in getRuntimeTransactionInfoCacheMap) return getRuntimeTransactionInfoCacheMap[cacheId];
        const runtimeTransaction = await runtimeApi.runtimeTransactionInfoHandler({
            id: tx.runtimeId,
            hash: tx.txHash,
            round: tx.round
        });
        if (runtimeTransaction) getRuntimeTransactionInfoCacheMap[cacheId] = runtimeTransaction;
        return runtimeTransaction;
    }
    function getTransactionUrl({ hash }) {
        return `${url}/chain/transaction/${hash}`;
    }
    async function getTransaction({ hash }) {
        const cacheId = getTransactionUrl({
            hash
        });
        if (cacheId in getTransactionCacheMap) return getTransactionCacheMap[cacheId];
        const transaction = await chainApi.chainTransactionInfoHandler({
            hash
        });
        if (transaction) getTransactionCacheMap[cacheId] = transaction;
        return transaction;
    }
    async function getTransactionsList(params) {
        const transactionsList = await chainApi.chainTransactionsHandler({
            address: params.accountId,
            size: params.limit,
            page: 1,
            runtime: true
        });
        if (!transactionsList) throw new Error('Wrong response code');
        const list = await Promise.all(transactionsList.list.map(async (tx)=>{
            if (tx.txType === 'runtime') return await getRuntimeTransactionInfo(tx);
            else {
                const { nonce } = await getTransaction({
                    hash: tx.txHash
                });
                return {
                    ...tx,
                    nonce
                };
            }
        }));
        return parseTransactionsList(list);
    }
    async function getDelegations(params) {
        const delegations = await accountApi.accountDelegationsHandler({
            all: true,
            address: params.accountId,
            page: 1,
            size: 500
        });
        const debonding = await accountApi.accountDebondingHandler({
            address: params.accountId,
            page: 1,
            size: 500
        });
        if (!delegations) throw new Error('Wrong response code');
        if (!debonding) throw new Error('Wrong response code');
        return {
            delegations: parseDelegations(delegations.list),
            debonding: parseDebonding(debonding.list)
        };
    }
    return {
        getAccount,
        getAllValidators,
        getTransactionsList,
        getDelegations
    };
}
function parseAccount(account) {
    return {
        address: account.address,
        allowances: account.allowances.map((allowance)=>({
                address: allowance.address,
                amount: (0, _helpers.parseRoseStringToBaseUnitString)(allowance.amount)
            })),
        available: (0, _helpers.parseRoseStringToBaseUnitString)(account.available),
        delegations: (0, _helpers.parseRoseStringToBaseUnitString)(account.escrow),
        debonding: (0, _helpers.parseRoseStringToBaseUnitString)(account.debonding),
        total: (0, _helpers.parseRoseStringToBaseUnitString)(account.total),
        nonce: BigInt(account.nonce ?? 0).toString()
    };
}
function parseValidatorsList(validators) {
    return validators.map((v)=>{
        const parsed = {
            address: v.entityAddress,
            name: v.name ?? undefined,
            escrow: (0, _helpers.parseRoseStringToBaseUnitString)(v.escrow),
            current_rate: v.commission,
            status: v.status ? 'active' : 'inactive',
            media: {
                email_address: v.email ?? undefined,
                logotype: v.icon ?? undefined,
                twitter_acc: v.twitter ?? undefined,
                website_link: v.website ?? undefined
            },
            rank: v.rank
        };
        return parsed;
    });
}
function parseTransactionsList(list) {
    return list.map((t)=>{
        if ('ctx' in t) {
            const parsed = {
                amount: t.ctx.amount == null ? undefined : (0, _helpers.parseRoseStringToBaseUnitString)(t.ctx.amount),
                fee: undefined,
                from: t.ctx.from,
                hash: t.txHash,
                level: undefined,
                status: t.result ? (0, _types.TransactionStatus).Successful : (0, _types.TransactionStatus).Failed,
                timestamp: t.timestamp * 1000,
                to: t.ctx.to ?? undefined,
                type: t.ctx.method,
                runtimeName: t.runtimeName,
                runtimeId: t.runtimeId,
                round: t.round,
                nonce: t.ctx?.nonce ?? t.etx?.nonce != null ? BigInt(t.ctx?.nonce ?? t.etx?.nonce).toString() : undefined
            };
            return parsed;
        } else {
            const parsed = {
                amount: t.amount == null ? undefined : (0, _helpers.parseRoseStringToBaseUnitString)(t.amount),
                fee: t.fee ? (0, _helpers.parseRoseStringToBaseUnitString)(t.fee) : undefined,
                from: t.from,
                hash: t.txHash,
                level: t.height,
                status: t.status ? (0, _types.TransactionStatus).Successful : (0, _types.TransactionStatus).Failed,
                timestamp: t.timestamp ? t.timestamp * 1000 : undefined,
                to: t.to ?? undefined,
                type: t.method,
                runtimeName: undefined,
                runtimeId: undefined,
                round: undefined,
                nonce: undefined
            };
            return parsed;
        }
    });
}
function parseDelegations(delegations) {
    return delegations.map((delegation)=>{
        const parsed = {
            amount: (0, _helpers.parseRoseStringToBaseUnitString)(delegation.amount),
            shares: (0, _helpers.parseRoseStringToBaseUnitString)(delegation.shares),
            validatorAddress: delegation.validatorAddress ?? delegation.entityAddress
        };
        return parsed;
    });
}
function parseDebonding(debonding) {
    return debonding.map((debonding)=>{
        const parsed = {
            // TODO: use amount field, or share price when it is available. Until then,
            // using shares is inaccurate if debonding pool gets slashed.
            amount: (0, _helpers.parseRoseStringToBaseUnitString)(debonding.shares),
            shares: (0, _helpers.parseRoseStringToBaseUnitString)(debonding.shares),
            validatorAddress: debonding.validatorAddress,
            epoch: debonding.debondEnd
        };
        return parsed;
    });
}

},{"app/state/transaction/types":"idhb9","app/lib/helpers":"bUnFy","vendors/oasisscan-v2/index":"fNBKQ","./helpers":"f9DGv","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"idhb9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionType", ()=>TransactionType);
parcelHelpers.export(exports, "TransactionStatus", ()=>TransactionStatus);
parcelHelpers.export(exports, "TransactionStep", ()=>TransactionStep);
var TransactionType = /*#__PURE__*/ function(TransactionType) {
    TransactionType["StakingTransfer"] = "staking.Transfer";
    TransactionType["StakingAddEscrow"] = "staking.AddEscrow";
    TransactionType["StakingReclaimEscrow"] = "staking.ReclaimEscrow";
    TransactionType["StakingAmendCommissionSchedule"] = "staking.AmendCommissionSchedule";
    TransactionType["StakingAllow"] = "staking.Allow";
    TransactionType["StakingWithdraw"] = "staking.Withdraw";
    TransactionType["StakingBurn"] = "staking.Burn";
    TransactionType["RoothashExecutorCommit"] = "roothash.ExecutorCommit";
    TransactionType["RoothashExecutorProposerTimeout"] = "roothash.ExecutorProposerTimeout";
    TransactionType["RoothashSubmitMsg"] = "roothash.SubmitMsg";
    TransactionType["RegistryDeregisterEntity"] = "registry.DeregisterEntity";
    TransactionType["RegistryRegisterEntity"] = "registry.RegisterEntity";
    TransactionType["RegistryRegisterNode"] = "registry.RegisterNode";
    TransactionType["RegistryRegisterRuntime"] = "registry.RegisterRuntime";
    TransactionType["RegistryUnfreezeNode"] = "registry.UnfreezeNode";
    TransactionType["GovernanceCastVote"] = "governance.CastVote";
    TransactionType["GovernanceSubmitProposal"] = "governance.SubmitProposal";
    TransactionType["BeaconPvssCommit"] = "beacon.PVSSCommit";
    TransactionType["BeaconPvssReveal"] = "beacon.PVSSReveal";
    TransactionType["BeaconVrfProve"] = "beacon.VRFProve";
    TransactionType["ConsensusMeta"] = "consensus.Meta";
    TransactionType["VaultCreate"] = "vault.Create";
    // ParaTime
    TransactionType["ConsensusDeposit"] = "consensus.Deposit";
    TransactionType["ConsensusWithdraw"] = "consensus.Withdraw";
    TransactionType["ConsensusAccountsParameters"] = "consensus.Parameters";
    TransactionType["ConsensusBalance"] = "consensus.Balance";
    TransactionType["ConsensusAccount"] = "consensus.Account";
    return TransactionType;
}({});
var TransactionStatus = /*#__PURE__*/ function(TransactionStatus) {
    TransactionStatus[TransactionStatus["Failed"] = 0] = "Failed";
    TransactionStatus[TransactionStatus["Successful"] = 1] = "Successful";
    TransactionStatus[TransactionStatus["Pending"] = 2] = "Pending";
    return TransactionStatus;
}({});
var TransactionStep = /*#__PURE__*/ function(TransactionStep) {
    TransactionStep["Building"] = "building";
    TransactionStep["Preview"] = "preview";
    TransactionStep["Signing"] = "signing";
    TransactionStep["Submitting"] = "submitting";
    TransactionStep["Sent"] = "sent";
    return TransactionStep;
}({});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fNBKQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _runtime = require("./runtime");
parcelHelpers.exportAll(_runtime, exports);
var _apis = require("./apis");
parcelHelpers.exportAll(_apis, exports);
var _models = require("./models");
parcelHelpers.exportAll(_models, exports);

},{"./runtime":"cHxeU","./apis":"ldqhJ","./models":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cHxeU":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BASE_PATH", ()=>BASE_PATH);
/**
 * This is the base class for all generated API classes.
 */ parcelHelpers.export(exports, "BaseAPI", ()=>BaseAPI);
parcelHelpers.export(exports, "RequiredError", ()=>RequiredError);
parcelHelpers.export(exports, "COLLECTION_FORMATS", ()=>COLLECTION_FORMATS);
parcelHelpers.export(exports, "Configuration", ()=>Configuration);
parcelHelpers.export(exports, "exists", ()=>exists);
parcelHelpers.export(exports, "querystring", ()=>querystring);
parcelHelpers.export(exports, "mapValues", ()=>mapValues);
parcelHelpers.export(exports, "canConsumeForm", ()=>canConsumeForm);
parcelHelpers.export(exports, "JSONApiResponse", ()=>JSONApiResponse);
parcelHelpers.export(exports, "VoidApiResponse", ()=>VoidApiResponse);
parcelHelpers.export(exports, "BlobApiResponse", ()=>BlobApiResponse);
parcelHelpers.export(exports, "TextApiResponse", ()=>TextApiResponse);
const BASE_PATH = "https://api.oasisscan.com/v2/mainnet".replace(/\/+$/, "");
const isBlob = (value)=>typeof Blob !== 'undefined' && value instanceof Blob;
class BaseAPI {
    constructor(configuration = new Configuration()){
        this.configuration = configuration;
        this.fetchApi = async (url, init)=>{
            let fetchParams = {
                url,
                init
            };
            for (const middleware of this.middleware)if (middleware.pre) fetchParams = await middleware.pre({
                fetch: this.fetchApi,
                ...fetchParams
            }) || fetchParams;
            let response = await this.configuration.fetchApi(fetchParams.url, fetchParams.init);
            for (const middleware of this.middleware)if (middleware.post) response = await middleware.post({
                fetch: this.fetchApi,
                url,
                init,
                response: response.clone()
            }) || response;
            return response;
        };
        this.middleware = configuration.middleware;
    }
    withMiddleware(...middlewares) {
        const next = this.clone();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }
    withPreMiddleware(...preMiddlewares) {
        const middlewares = preMiddlewares.map((pre)=>({
                pre
            }));
        return this.withMiddleware(...middlewares);
    }
    withPostMiddleware(...postMiddlewares) {
        const middlewares = postMiddlewares.map((post)=>({
                post
            }));
        return this.withMiddleware(...middlewares);
    }
    async request(context) {
        const { url, init } = this.createFetchParams(context);
        const response = await this.fetchApi(url, init);
        if (response.status >= 200 && response.status < 300) return response;
        throw response;
    }
    createFetchParams(context) {
        let url = this.configuration.basePath + context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) // only add the querystring to the URL if there are query parameters.
        // this is done to avoid urls ending with a "?" character which buggy webservers
        // do not handle correctly sometimes.
        url += '?' + this.configuration.queryParamsStringify(context.query);
        const body = typeof FormData !== "undefined" && context.body instanceof FormData || context.body instanceof URLSearchParams || isBlob(context.body) ? context.body : JSON.stringify(context.body);
        const headers = Object.assign({}, this.configuration.headers, context.headers);
        const init = {
            method: context.method,
            headers: headers,
            body,
            credentials: this.configuration.credentials
        };
        return {
            url,
            init
        };
    }
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */ clone() {
        const constructor = this.constructor;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
}
class RequiredError extends Error {
    constructor(field, msg){
        super(msg), this.field = field, this.name = "RequiredError";
    }
}
const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|"
};
class Configuration {
    constructor(configuration = {}){
        this.configuration = configuration;
    }
    get basePath() {
        return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
    }
    get fetchApi() {
        return this.configuration.fetchApi || window.fetch.bind(window);
    }
    get middleware() {
        return this.configuration.middleware || [];
    }
    get queryParamsStringify() {
        return this.configuration.queryParamsStringify || querystring;
    }
    get username() {
        return this.configuration.username;
    }
    get password() {
        return this.configuration.password;
    }
    get apiKey() {
        const apiKey = this.configuration.apiKey;
        if (apiKey) return typeof apiKey === 'function' ? apiKey : ()=>apiKey;
        return undefined;
    }
    get accessToken() {
        const accessToken = this.configuration.accessToken;
        if (accessToken) return typeof accessToken === 'function' ? accessToken : ()=>accessToken;
        return undefined;
    }
    get headers() {
        return this.configuration.headers;
    }
    get credentials() {
        return this.configuration.credentials;
    }
}
function exists(json, key) {
    const value = json[key];
    return value !== null && value !== undefined;
}
function querystring(params, prefix = '') {
    return Object.keys(params).map((key)=>{
        const fullKey = prefix + (prefix.length ? `[${key}]` : key);
        const value = params[key];
        if (value instanceof Array) {
            const multiValue = value.map((singleValue)=>encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
            return `${encodeURIComponent(fullKey)}=${multiValue}`;
        }
        if (value instanceof Date) return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
        if (value instanceof Object) return querystring(value, fullKey);
        return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
    }).filter((part)=>part.length > 0).join('&');
}
function mapValues(data, fn) {
    return Object.keys(data).reduce((acc, key)=>({
            ...acc,
            [key]: fn(data[key])
        }), {});
}
function canConsumeForm(consumes) {
    for (const consume of consumes){
        if ('multipart/form-data' === consume.contentType) return true;
    }
    return false;
}
class JSONApiResponse {
    constructor(raw, transformer = (jsonValue)=>jsonValue){
        this.raw = raw;
        this.transformer = transformer;
    }
    async value() {
        return this.transformer(await this.raw.json());
    }
}
class VoidApiResponse {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return undefined;
    }
}
class BlobApiResponse {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return await this.raw.blob();
    }
}
class TextApiResponse {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return await this.raw.text();
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ldqhJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _accountApi = require("./AccountApi");
parcelHelpers.exportAll(_accountApi, exports);
var _chainApi = require("./ChainApi");
parcelHelpers.exportAll(_chainApi, exports);
var _commonApi = require("./CommonApi");
parcelHelpers.exportAll(_commonApi, exports);
var _governanceApi = require("./GovernanceApi");
parcelHelpers.exportAll(_governanceApi, exports);
var _marketApi = require("./MarketApi");
parcelHelpers.exportAll(_marketApi, exports);
var _runtimeApi = require("./RuntimeApi");
parcelHelpers.exportAll(_runtimeApi, exports);
var _validatorApi = require("./ValidatorApi");
parcelHelpers.exportAll(_validatorApi, exports);

},{"./AccountApi":"2RRRD","./ChainApi":"1GEB3","./CommonApi":"2l0CZ","./GovernanceApi":"g9w9e","./MarketApi":"l9RfY","./RuntimeApi":"1JnMI","./ValidatorApi":"gYXph","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2RRRD":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * 
 */ parcelHelpers.export(exports, "AccountApi", ()=>AccountApi);
var _runtime = require("../runtime");
var _models = require("../models");
class AccountApi extends _runtime.BaseAPI {
    /**
     */ async accountDebondingHandlerRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling accountDebondingHandler.');
        if (requestParameters.page === null || requestParameters.page === undefined) throw new _runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling accountDebondingHandler.');
        if (requestParameters.size === null || requestParameters.size === undefined) throw new _runtime.RequiredError('size', 'Required parameter requestParameters.size was null or undefined when calling accountDebondingHandler.');
        const queryParameters = {};
        if (requestParameters.address !== undefined) queryParameters['address'] = requestParameters.address;
        if (requestParameters.page !== undefined) queryParameters['page'] = requestParameters.page;
        if (requestParameters.size !== undefined) queryParameters['size'] = requestParameters.size;
        const headerParameters = {};
        const response = await this.request({
            path: `/account/debonding`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.AccountDebondingResponseFromJSON)(jsonValue.data));
    }
    /**
     */ async accountDebondingHandler(requestParameters) {
        const response = await this.accountDebondingHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async accountDelegationsHandlerRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling accountDelegationsHandler.');
        if (requestParameters.all === null || requestParameters.all === undefined) throw new _runtime.RequiredError('all', 'Required parameter requestParameters.all was null or undefined when calling accountDelegationsHandler.');
        if (requestParameters.page === null || requestParameters.page === undefined) throw new _runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling accountDelegationsHandler.');
        if (requestParameters.size === null || requestParameters.size === undefined) throw new _runtime.RequiredError('size', 'Required parameter requestParameters.size was null or undefined when calling accountDelegationsHandler.');
        const queryParameters = {};
        if (requestParameters.address !== undefined) queryParameters['address'] = requestParameters.address;
        if (requestParameters.all !== undefined) queryParameters['all'] = requestParameters.all;
        if (requestParameters.page !== undefined) queryParameters['page'] = requestParameters.page;
        if (requestParameters.size !== undefined) queryParameters['size'] = requestParameters.size;
        const headerParameters = {};
        const response = await this.request({
            path: `/account/delegations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.AccountDelegationsResponseFromJSON)(jsonValue.data));
    }
    /**
     */ async accountDelegationsHandler(requestParameters) {
        const response = await this.accountDelegationsHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async accountInfoHandlerRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling accountInfoHandler.');
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/account/info/{address}`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.AccountInfoResponseFromJSON)(jsonValue.data));
    }
    /**
     */ async accountInfoHandler(requestParameters) {
        const response = await this.accountInfoHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async accountRewardExportHandlerRaw(requestParameters) {
        if (requestParameters.account === null || requestParameters.account === undefined) throw new _runtime.RequiredError('account', 'Required parameter requestParameters.account was null or undefined when calling accountRewardExportHandler.');
        const queryParameters = {};
        if (requestParameters.account !== undefined) queryParameters['account'] = requestParameters.account;
        const headerParameters = {};
        const response = await this.request({
            path: `/account/reward/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response);
    }
    /**
     */ async accountRewardExportHandler(requestParameters) {
        const response = await this.accountRewardExportHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async accountRewardHandlerRaw(requestParameters) {
        if (requestParameters.account === null || requestParameters.account === undefined) throw new _runtime.RequiredError('account', 'Required parameter requestParameters.account was null or undefined when calling accountRewardHandler.');
        if (requestParameters.page === null || requestParameters.page === undefined) throw new _runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling accountRewardHandler.');
        if (requestParameters.size === null || requestParameters.size === undefined) throw new _runtime.RequiredError('size', 'Required parameter requestParameters.size was null or undefined when calling accountRewardHandler.');
        const queryParameters = {};
        if (requestParameters.account !== undefined) queryParameters['account'] = requestParameters.account;
        if (requestParameters.page !== undefined) queryParameters['page'] = requestParameters.page;
        if (requestParameters.size !== undefined) queryParameters['size'] = requestParameters.size;
        const headerParameters = {};
        const response = await this.request({
            path: `/account/reward/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.AccountRewardResponseFromJSON)(jsonValue));
    }
    /**
     */ async accountRewardHandler(requestParameters) {
        const response = await this.accountRewardHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async accountRewardStatsHandlerRaw(requestParameters) {
        if (requestParameters.account === null || requestParameters.account === undefined) throw new _runtime.RequiredError('account', 'Required parameter requestParameters.account was null or undefined when calling accountRewardStatsHandler.');
        const queryParameters = {};
        if (requestParameters.account !== undefined) queryParameters['account'] = requestParameters.account;
        const headerParameters = {};
        const response = await this.request({
            path: `/account/reward/stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.AccountRewardStatsResponseFromJSON)(jsonValue));
    }
    /**
     */ async accountRewardStatsHandler(requestParameters) {
        const response = await this.accountRewardStatsHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async accountStakingEventsHandlerRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling accountStakingEventsHandler.');
        if (requestParameters.page === null || requestParameters.page === undefined) throw new _runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling accountStakingEventsHandler.');
        if (requestParameters.size === null || requestParameters.size === undefined) throw new _runtime.RequiredError('size', 'Required parameter requestParameters.size was null or undefined when calling accountStakingEventsHandler.');
        const queryParameters = {};
        if (requestParameters.address !== undefined) queryParameters['address'] = requestParameters.address;
        if (requestParameters.page !== undefined) queryParameters['page'] = requestParameters.page;
        if (requestParameters.size !== undefined) queryParameters['size'] = requestParameters.size;
        const headerParameters = {};
        const response = await this.request({
            path: `/account/staking/events`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.AccountStakingEventsResponseFromJSON)(jsonValue));
    }
    /**
     */ async accountStakingEventsHandler(requestParameters) {
        const response = await this.accountStakingEventsHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async accountStakingEventsInfoHandlerRaw(requestParameters) {
        if (requestParameters.id === null || requestParameters.id === undefined) throw new _runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling accountStakingEventsInfoHandler.');
        const queryParameters = {};
        if (requestParameters.id !== undefined) queryParameters['id'] = requestParameters.id;
        const headerParameters = {};
        const response = await this.request({
            path: `/account/staking/events/info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.AccountStakingEventsInfoResponseFromJSON)(jsonValue));
    }
    /**
     */ async accountStakingEventsInfoHandler(requestParameters) {
        const response = await this.accountStakingEventsInfoHandlerRaw(requestParameters);
        return await response.value();
    }
}

},{"../runtime":"cHxeU","../models":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dB6QC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _accountAllowance = require("./AccountAllowance");
parcelHelpers.exportAll(_accountAllowance, exports);
var _accountDebondingInfo = require("./AccountDebondingInfo");
parcelHelpers.exportAll(_accountDebondingInfo, exports);
var _accountDebondingRequest = require("./AccountDebondingRequest");
parcelHelpers.exportAll(_accountDebondingRequest, exports);
var _accountDebondingResponse = require("./AccountDebondingResponse");
parcelHelpers.exportAll(_accountDebondingResponse, exports);
var _accountDelegationsInfo = require("./AccountDelegationsInfo");
parcelHelpers.exportAll(_accountDelegationsInfo, exports);
var _accountDelegationsRequest = require("./AccountDelegationsRequest");
parcelHelpers.exportAll(_accountDelegationsRequest, exports);
var _accountDelegationsResponse = require("./AccountDelegationsResponse");
parcelHelpers.exportAll(_accountDelegationsResponse, exports);
var _accountInfoResponse = require("./AccountInfoResponse");
parcelHelpers.exportAll(_accountInfoResponse, exports);
var _accountRewardExportRequest = require("./AccountRewardExportRequest");
parcelHelpers.exportAll(_accountRewardExportRequest, exports);
var _accountRewardInfo = require("./AccountRewardInfo");
parcelHelpers.exportAll(_accountRewardInfo, exports);
var _accountRewardRequest = require("./AccountRewardRequest");
parcelHelpers.exportAll(_accountRewardRequest, exports);
var _accountRewardResponse = require("./AccountRewardResponse");
parcelHelpers.exportAll(_accountRewardResponse, exports);
var _accountRewardStatsInfo = require("./AccountRewardStatsInfo");
parcelHelpers.exportAll(_accountRewardStatsInfo, exports);
var _accountRewardStatsItem = require("./AccountRewardStatsItem");
parcelHelpers.exportAll(_accountRewardStatsItem, exports);
var _accountRewardStatsRequest = require("./AccountRewardStatsRequest");
parcelHelpers.exportAll(_accountRewardStatsRequest, exports);
var _accountRewardStatsResponse = require("./AccountRewardStatsResponse");
parcelHelpers.exportAll(_accountRewardStatsResponse, exports);
var _accountStakingEventsInfo = require("./AccountStakingEventsInfo");
parcelHelpers.exportAll(_accountStakingEventsInfo, exports);
var _accountStakingEventsInfoRequest = require("./AccountStakingEventsInfoRequest");
parcelHelpers.exportAll(_accountStakingEventsInfoRequest, exports);
var _accountStakingEventsInfoResponse = require("./AccountStakingEventsInfoResponse");
parcelHelpers.exportAll(_accountStakingEventsInfoResponse, exports);
var _accountStakingEventsRequest = require("./AccountStakingEventsRequest");
parcelHelpers.exportAll(_accountStakingEventsRequest, exports);
var _accountStakingEventsResponse = require("./AccountStakingEventsResponse");
parcelHelpers.exportAll(_accountStakingEventsResponse, exports);
var _bound = require("./Bound");
parcelHelpers.exportAll(_bound, exports);
var _chainBlockInfo = require("./ChainBlockInfo");
parcelHelpers.exportAll(_chainBlockInfo, exports);
var _chainBlockInfoResponse = require("./ChainBlockInfoResponse");
parcelHelpers.exportAll(_chainBlockInfoResponse, exports);
var _chainBlocksRequest = require("./ChainBlocksRequest");
parcelHelpers.exportAll(_chainBlocksRequest, exports);
var _chainBlocksResponse = require("./ChainBlocksResponse");
parcelHelpers.exportAll(_chainBlocksResponse, exports);
var _chainMethodsResponse = require("./ChainMethodsResponse");
parcelHelpers.exportAll(_chainMethodsResponse, exports);
var _chainProposedBlocksRequest = require("./ChainProposedBlocksRequest");
parcelHelpers.exportAll(_chainProposedBlocksRequest, exports);
var _chainProposedBlocksResponse = require("./ChainProposedBlocksResponse");
parcelHelpers.exportAll(_chainProposedBlocksResponse, exports);
var _chainSearchRequest = require("./ChainSearchRequest");
parcelHelpers.exportAll(_chainSearchRequest, exports);
var _chainSearchResponse = require("./ChainSearchResponse");
parcelHelpers.exportAll(_chainSearchResponse, exports);
var _chainTransactionInfoResponse = require("./ChainTransactionInfoResponse");
parcelHelpers.exportAll(_chainTransactionInfoResponse, exports);
var _chainTransactionListInfo = require("./ChainTransactionListInfo");
parcelHelpers.exportAll(_chainTransactionListInfo, exports);
var _chainTransactionsRequest = require("./ChainTransactionsRequest");
parcelHelpers.exportAll(_chainTransactionsRequest, exports);
var _chainTransactionsResponse = require("./ChainTransactionsResponse");
parcelHelpers.exportAll(_chainTransactionsResponse, exports);
var _chart = require("./Chart");
parcelHelpers.exportAll(_chart, exports);
var _delegatorsInfo = require("./DelegatorsInfo");
parcelHelpers.exportAll(_delegatorsInfo, exports);
var _delegatorsRequest = require("./DelegatorsRequest");
parcelHelpers.exportAll(_delegatorsRequest, exports);
var _delegatorsResponse = require("./DelegatorsResponse");
parcelHelpers.exportAll(_delegatorsResponse, exports);
var _escrowStatus = require("./EscrowStatus");
parcelHelpers.exportAll(_escrowStatus, exports);
var _governanceProposalInfo = require("./GovernanceProposalInfo");
parcelHelpers.exportAll(_governanceProposalInfo, exports);
var _governanceProposalListResponse = require("./GovernanceProposalListResponse");
parcelHelpers.exportAll(_governanceProposalListResponse, exports);
var _governanceProposalWithVotesRequest = require("./GovernanceProposalWithVotesRequest");
parcelHelpers.exportAll(_governanceProposalWithVotesRequest, exports);
var _governanceProposalWithVotesResponse = require("./GovernanceProposalWithVotesResponse");
parcelHelpers.exportAll(_governanceProposalWithVotesResponse, exports);
var _governanceVotesRequest = require("./GovernanceVotesRequest");
parcelHelpers.exportAll(_governanceVotesRequest, exports);
var _governanceVotesResponse = require("./GovernanceVotesResponse");
parcelHelpers.exportAll(_governanceVotesResponse, exports);
var _marketChartResponse = require("./MarketChartResponse");
parcelHelpers.exportAll(_marketChartResponse, exports);
var _marketInfoResponse = require("./MarketInfoResponse");
parcelHelpers.exportAll(_marketInfoResponse, exports);
var _networkStatusResponse = require("./NetworkStatusResponse");
parcelHelpers.exportAll(_networkStatusResponse, exports);
var _networkTrendResponse = require("./NetworkTrendResponse");
parcelHelpers.exportAll(_networkTrendResponse, exports);
var _page = require("./Page");
parcelHelpers.exportAll(_page, exports);
var _proposalOption = require("./ProposalOption");
parcelHelpers.exportAll(_proposalOption, exports);
var _proposalVote = require("./ProposalVote");
parcelHelpers.exportAll(_proposalVote, exports);
var _rate = require("./Rate");
parcelHelpers.exportAll(_rate, exports);
var _runtimeListInfo = require("./RuntimeListInfo");
parcelHelpers.exportAll(_runtimeListInfo, exports);
var _runtimeListResponse = require("./RuntimeListResponse");
parcelHelpers.exportAll(_runtimeListResponse, exports);
var _runtimeRoundInfo = require("./RuntimeRoundInfo");
parcelHelpers.exportAll(_runtimeRoundInfo, exports);
var _runtimeRoundInfoRequest = require("./RuntimeRoundInfoRequest");
parcelHelpers.exportAll(_runtimeRoundInfoRequest, exports);
var _runtimeRoundInfoResponse = require("./RuntimeRoundInfoResponse");
parcelHelpers.exportAll(_runtimeRoundInfoResponse, exports);
var _runtimeRoundListRequest = require("./RuntimeRoundListRequest");
parcelHelpers.exportAll(_runtimeRoundListRequest, exports);
var _runtimeRoundListResponse = require("./RuntimeRoundListResponse");
parcelHelpers.exportAll(_runtimeRoundListResponse, exports);
var _runtimeStatsInfo = require("./RuntimeStatsInfo");
parcelHelpers.exportAll(_runtimeStatsInfo, exports);
var _runtimeStatsItem = require("./RuntimeStatsItem");
parcelHelpers.exportAll(_runtimeStatsItem, exports);
var _runtimeStatsRequest = require("./RuntimeStatsRequest");
parcelHelpers.exportAll(_runtimeStatsRequest, exports);
var _runtimeStatsResponse = require("./RuntimeStatsResponse");
parcelHelpers.exportAll(_runtimeStatsResponse, exports);
var _runtimeTransactionConsensusTx = require("./RuntimeTransactionConsensusTx");
parcelHelpers.exportAll(_runtimeTransactionConsensusTx, exports);
var _runtimeTransactionEventError = require("./RuntimeTransactionEventError");
parcelHelpers.exportAll(_runtimeTransactionEventError, exports);
var _runtimeTransactionEvmTx = require("./RuntimeTransactionEvmTx");
parcelHelpers.exportAll(_runtimeTransactionEvmTx, exports);
var _runtimeTransactionInfoRequest = require("./RuntimeTransactionInfoRequest");
parcelHelpers.exportAll(_runtimeTransactionInfoRequest, exports);
var _runtimeTransactionInfoResponse = require("./RuntimeTransactionInfoResponse");
parcelHelpers.exportAll(_runtimeTransactionInfoResponse, exports);
var _runtimeTransactionListInfo = require("./RuntimeTransactionListInfo");
parcelHelpers.exportAll(_runtimeTransactionListInfo, exports);
var _runtimeTransactionListRequest = require("./RuntimeTransactionListRequest");
parcelHelpers.exportAll(_runtimeTransactionListRequest, exports);
var _runtimeTransactionListResponse = require("./RuntimeTransactionListResponse");
parcelHelpers.exportAll(_runtimeTransactionListResponse, exports);
var _validatorBlocksStatsInfo = require("./ValidatorBlocksStatsInfo");
parcelHelpers.exportAll(_validatorBlocksStatsInfo, exports);
var _validatorBlocksStatsRequest = require("./ValidatorBlocksStatsRequest");
parcelHelpers.exportAll(_validatorBlocksStatsRequest, exports);
var _validatorBlocksStatsResponse = require("./ValidatorBlocksStatsResponse");
parcelHelpers.exportAll(_validatorBlocksStatsResponse, exports);
var _validatorEscrowEventRequest = require("./ValidatorEscrowEventRequest");
parcelHelpers.exportAll(_validatorEscrowEventRequest, exports);
var _validatorEscrowEventResponse = require("./ValidatorEscrowEventResponse");
parcelHelpers.exportAll(_validatorEscrowEventResponse, exports);
var _validatorEscrowStatsInfo = require("./ValidatorEscrowStatsInfo");
parcelHelpers.exportAll(_validatorEscrowStatsInfo, exports);
var _validatorEscrowStatsRequest = require("./ValidatorEscrowStatsRequest");
parcelHelpers.exportAll(_validatorEscrowStatsRequest, exports);
var _validatorEscrowStatsResponse = require("./ValidatorEscrowStatsResponse");
parcelHelpers.exportAll(_validatorEscrowStatsResponse, exports);
var _validatorInfo = require("./ValidatorInfo");
parcelHelpers.exportAll(_validatorInfo, exports);
var _validatorInfoRequest = require("./ValidatorInfoRequest");
parcelHelpers.exportAll(_validatorInfoRequest, exports);
var _validatorInfoResponse = require("./ValidatorInfoResponse");
parcelHelpers.exportAll(_validatorInfoResponse, exports);
var _validatorListRequest = require("./ValidatorListRequest");
parcelHelpers.exportAll(_validatorListRequest, exports);
var _validatorListResponse = require("./ValidatorListResponse");
parcelHelpers.exportAll(_validatorListResponse, exports);
var _validatorRuntime = require("./ValidatorRuntime");
parcelHelpers.exportAll(_validatorRuntime, exports);
var _validatorSignStatsInfo = require("./ValidatorSignStatsInfo");
parcelHelpers.exportAll(_validatorSignStatsInfo, exports);
var _validatorSignStatsRequest = require("./ValidatorSignStatsRequest");
parcelHelpers.exportAll(_validatorSignStatsRequest, exports);
var _validatorSignStatsResponse = require("./ValidatorSignStatsResponse");
parcelHelpers.exportAll(_validatorSignStatsResponse, exports);

},{"./AccountAllowance":"djYxs","./AccountDebondingInfo":"bg8yQ","./AccountDebondingRequest":"eRb6N","./AccountDebondingResponse":"aiALb","./AccountDelegationsInfo":"ew8wH","./AccountDelegationsRequest":"41vvK","./AccountDelegationsResponse":"gf5TF","./AccountInfoResponse":"favu0","./AccountRewardExportRequest":"4CEo0","./AccountRewardInfo":"gUgAy","./AccountRewardRequest":"2PIqX","./AccountRewardResponse":"bb50t","./AccountRewardStatsInfo":"lgnpr","./AccountRewardStatsItem":"9jYuh","./AccountRewardStatsRequest":"jI3rN","./AccountRewardStatsResponse":"80bAi","./AccountStakingEventsInfo":"bliHT","./AccountStakingEventsInfoRequest":"mSudo","./AccountStakingEventsInfoResponse":"lLz5p","./AccountStakingEventsRequest":"gV2Li","./AccountStakingEventsResponse":"e3VTw","./Bound":"lkrn0","./ChainBlockInfo":"9zChP","./ChainBlockInfoResponse":"lOtCY","./ChainBlocksRequest":"b4u5R","./ChainBlocksResponse":"2ebzE","./ChainMethodsResponse":"d7Vor","./ChainProposedBlocksRequest":"ezu1O","./ChainProposedBlocksResponse":"eMEgO","./ChainSearchRequest":"dayX3","./ChainSearchResponse":"2ucNe","./ChainTransactionInfoResponse":"ikT4L","./ChainTransactionListInfo":"gn7IQ","./ChainTransactionsRequest":"e216W","./ChainTransactionsResponse":"6gxl1","./Chart":"6m8E6","./DelegatorsInfo":"krnE1","./DelegatorsRequest":"dhQsY","./DelegatorsResponse":"8pRT3","./EscrowStatus":"80PKY","./GovernanceProposalInfo":"5dpcO","./GovernanceProposalListResponse":"2Zg1S","./GovernanceProposalWithVotesRequest":"cQcIZ","./GovernanceProposalWithVotesResponse":"l5Fnz","./GovernanceVotesRequest":"gQPDW","./GovernanceVotesResponse":"bDrpo","./MarketChartResponse":"kVRaB","./MarketInfoResponse":"cL19C","./NetworkStatusResponse":"iMN1H","./NetworkTrendResponse":"9mLfl","./Page":"fjWsw","./ProposalOption":"hXvrD","./ProposalVote":"kloE8","./Rate":"eZfZh","./RuntimeListInfo":"gjWlO","./RuntimeListResponse":"e5wbM","./RuntimeRoundInfo":"5aUi1","./RuntimeRoundInfoRequest":"1km9g","./RuntimeRoundInfoResponse":"9ebM9","./RuntimeRoundListRequest":"jnW1Z","./RuntimeRoundListResponse":"9Du3b","./RuntimeStatsInfo":"2abd6","./RuntimeStatsItem":"1vpZc","./RuntimeStatsRequest":"1Upw8","./RuntimeStatsResponse":"f3LYI","./RuntimeTransactionConsensusTx":"3whR8","./RuntimeTransactionEventError":"fKB0Z","./RuntimeTransactionEvmTx":"ha9Wt","./RuntimeTransactionInfoRequest":"6IGqt","./RuntimeTransactionInfoResponse":"bY7Ky","./RuntimeTransactionListInfo":"42SyS","./RuntimeTransactionListRequest":"9fb3y","./RuntimeTransactionListResponse":"84cXp","./ValidatorBlocksStatsInfo":"5a31V","./ValidatorBlocksStatsRequest":"9wZB0","./ValidatorBlocksStatsResponse":"2JWgY","./ValidatorEscrowEventRequest":"4c0P3","./ValidatorEscrowEventResponse":"gr8OD","./ValidatorEscrowStatsInfo":"lV43J","./ValidatorEscrowStatsRequest":"9hJ6O","./ValidatorEscrowStatsResponse":"fPNoo","./ValidatorInfo":"2O7kM","./ValidatorInfoRequest":"jJy2R","./ValidatorInfoResponse":"9T8Oo","./ValidatorListRequest":"bjxsu","./ValidatorListResponse":"1oDiX","./ValidatorRuntime":"82DDm","./ValidatorSignStatsInfo":"8i5aD","./ValidatorSignStatsRequest":"gL4XP","./ValidatorSignStatsResponse":"hA0iK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"djYxs":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountAllowanceFromJSON", ()=>AccountAllowanceFromJSON);
parcelHelpers.export(exports, "AccountAllowanceFromJSONTyped", ()=>AccountAllowanceFromJSONTyped);
parcelHelpers.export(exports, "AccountAllowanceToJSON", ()=>AccountAllowanceToJSON);
function AccountAllowanceFromJSON(json) {
    return AccountAllowanceFromJSONTyped(json, false);
}
function AccountAllowanceFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address'],
        'amount': json['amount']
    };
}
function AccountAllowanceToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address,
        'amount': value.amount
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bg8yQ":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountDebondingInfoFromJSON", ()=>AccountDebondingInfoFromJSON);
parcelHelpers.export(exports, "AccountDebondingInfoFromJSONTyped", ()=>AccountDebondingInfoFromJSONTyped);
parcelHelpers.export(exports, "AccountDebondingInfoToJSON", ()=>AccountDebondingInfoToJSON);
function AccountDebondingInfoFromJSON(json) {
    return AccountDebondingInfoFromJSONTyped(json, false);
}
function AccountDebondingInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'validatorAddress': json['validatorAddress'],
        'validatorName': json['validatorName'],
        'icon': json['icon'],
        'shares': json['shares'],
        'debondEnd': json['debondEnd'],
        'epochLeft': json['epochLeft']
    };
}
function AccountDebondingInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'validatorAddress': value.validatorAddress,
        'validatorName': value.validatorName,
        'icon': value.icon,
        'shares': value.shares,
        'debondEnd': value.debondEnd,
        'epochLeft': value.epochLeft
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eRb6N":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountDebondingRequestFromJSON", ()=>AccountDebondingRequestFromJSON);
parcelHelpers.export(exports, "AccountDebondingRequestFromJSONTyped", ()=>AccountDebondingRequestFromJSONTyped);
parcelHelpers.export(exports, "AccountDebondingRequestToJSON", ()=>AccountDebondingRequestToJSON);
function AccountDebondingRequestFromJSON(json) {
    return AccountDebondingRequestFromJSONTyped(json, false);
}
function AccountDebondingRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address'],
        'page': json['page'],
        'size': json['size']
    };
}
function AccountDebondingRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address,
        'page': value.page,
        'size': value.size
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aiALb":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountDebondingResponseFromJSON", ()=>AccountDebondingResponseFromJSON);
parcelHelpers.export(exports, "AccountDebondingResponseFromJSONTyped", ()=>AccountDebondingResponseFromJSONTyped);
parcelHelpers.export(exports, "AccountDebondingResponseToJSON", ()=>AccountDebondingResponseToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function AccountDebondingResponseFromJSON(json) {
    return AccountDebondingResponseFromJSONTyped(json, false);
}
function AccountDebondingResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list'].map((0, _.AccountDebondingInfoFromJSON)),
        'page': !(0, _runtime.exists)(json, 'page') ? undefined : json['page'],
        'size': !(0, _runtime.exists)(json, 'size') ? undefined : json['size'],
        'maxPage': !(0, _runtime.exists)(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !(0, _runtime.exists)(json, 'totalSize') ? undefined : json['totalSize']
    };
}
function AccountDebondingResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list.map((0, _.AccountDebondingInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize
    };
}

},{"../runtime":"cHxeU","./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ew8wH":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountDelegationsInfoFromJSON", ()=>AccountDelegationsInfoFromJSON);
parcelHelpers.export(exports, "AccountDelegationsInfoFromJSONTyped", ()=>AccountDelegationsInfoFromJSONTyped);
parcelHelpers.export(exports, "AccountDelegationsInfoToJSON", ()=>AccountDelegationsInfoToJSON);
function AccountDelegationsInfoFromJSON(json) {
    return AccountDelegationsInfoFromJSONTyped(json, false);
}
function AccountDelegationsInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'validatorAddress': json['validatorAddress'],
        'validatorName': json['validatorName'],
        'icon': json['icon'],
        'entityAddress': json['entityAddress'],
        'shares': json['shares'],
        'amount': json['amount'],
        'active': json['active']
    };
}
function AccountDelegationsInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'validatorAddress': value.validatorAddress,
        'validatorName': value.validatorName,
        'icon': value.icon,
        'entityAddress': value.entityAddress,
        'shares': value.shares,
        'amount': value.amount,
        'active': value.active
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"41vvK":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountDelegationsRequestFromJSON", ()=>AccountDelegationsRequestFromJSON);
parcelHelpers.export(exports, "AccountDelegationsRequestFromJSONTyped", ()=>AccountDelegationsRequestFromJSONTyped);
parcelHelpers.export(exports, "AccountDelegationsRequestToJSON", ()=>AccountDelegationsRequestToJSON);
function AccountDelegationsRequestFromJSON(json) {
    return AccountDelegationsRequestFromJSONTyped(json, false);
}
function AccountDelegationsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address'],
        'all': json['all'],
        'page': json['page'],
        'size': json['size']
    };
}
function AccountDelegationsRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address,
        'all': value.all,
        'page': value.page,
        'size': value.size
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gf5TF":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountDelegationsResponseFromJSON", ()=>AccountDelegationsResponseFromJSON);
parcelHelpers.export(exports, "AccountDelegationsResponseFromJSONTyped", ()=>AccountDelegationsResponseFromJSONTyped);
parcelHelpers.export(exports, "AccountDelegationsResponseToJSON", ()=>AccountDelegationsResponseToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function AccountDelegationsResponseFromJSON(json) {
    return AccountDelegationsResponseFromJSONTyped(json, false);
}
function AccountDelegationsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list'].map((0, _.AccountDelegationsInfoFromJSON)),
        'page': !(0, _runtime.exists)(json, 'page') ? undefined : json['page'],
        'size': !(0, _runtime.exists)(json, 'size') ? undefined : json['size'],
        'maxPage': !(0, _runtime.exists)(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !(0, _runtime.exists)(json, 'totalSize') ? undefined : json['totalSize']
    };
}
function AccountDelegationsResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list.map((0, _.AccountDelegationsInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize
    };
}

},{"../runtime":"cHxeU","./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"favu0":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountInfoResponseFromJSON", ()=>AccountInfoResponseFromJSON);
parcelHelpers.export(exports, "AccountInfoResponseFromJSONTyped", ()=>AccountInfoResponseFromJSONTyped);
parcelHelpers.export(exports, "AccountInfoResponseToJSON", ()=>AccountInfoResponseToJSON);
var _ = require("./");
function AccountInfoResponseFromJSON(json) {
    return AccountInfoResponseFromJSONTyped(json, false);
}
function AccountInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address'],
        'available': json['available'],
        'escrow': json['escrow'],
        'debonding': json['debonding'],
        'total': json['total'],
        'nonce': json['nonce'],
        'allowances': json['allowances'].map((0, _.AccountAllowanceFromJSON))
    };
}
function AccountInfoResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address,
        'available': value.available,
        'escrow': value.escrow,
        'debonding': value.debonding,
        'total': value.total,
        'nonce': value.nonce,
        'allowances': value.allowances.map((0, _.AccountAllowanceToJSON))
    };
}

},{"./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4CEo0":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountRewardExportRequestFromJSON", ()=>AccountRewardExportRequestFromJSON);
parcelHelpers.export(exports, "AccountRewardExportRequestFromJSONTyped", ()=>AccountRewardExportRequestFromJSONTyped);
parcelHelpers.export(exports, "AccountRewardExportRequestToJSON", ()=>AccountRewardExportRequestToJSON);
function AccountRewardExportRequestFromJSON(json) {
    return AccountRewardExportRequestFromJSONTyped(json, false);
}
function AccountRewardExportRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'account': json['account']
    };
}
function AccountRewardExportRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'account': value.account
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gUgAy":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountRewardInfoFromJSON", ()=>AccountRewardInfoFromJSON);
parcelHelpers.export(exports, "AccountRewardInfoFromJSONTyped", ()=>AccountRewardInfoFromJSONTyped);
parcelHelpers.export(exports, "AccountRewardInfoToJSON", ()=>AccountRewardInfoToJSON);
function AccountRewardInfoFromJSON(json) {
    return AccountRewardInfoFromJSONTyped(json, false);
}
function AccountRewardInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'validatorAddress': json['validatorAddress'],
        'validatorName': json['validatorName'],
        'validatorIcon': json['validatorIcon'],
        'epoch': json['epoch'],
        'timestamp': json['timestamp'],
        'reward': json['reward']
    };
}
function AccountRewardInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'validatorAddress': value.validatorAddress,
        'validatorName': value.validatorName,
        'validatorIcon': value.validatorIcon,
        'epoch': value.epoch,
        'timestamp': value.timestamp,
        'reward': value.reward
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2PIqX":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountRewardRequestFromJSON", ()=>AccountRewardRequestFromJSON);
parcelHelpers.export(exports, "AccountRewardRequestFromJSONTyped", ()=>AccountRewardRequestFromJSONTyped);
parcelHelpers.export(exports, "AccountRewardRequestToJSON", ()=>AccountRewardRequestToJSON);
function AccountRewardRequestFromJSON(json) {
    return AccountRewardRequestFromJSONTyped(json, false);
}
function AccountRewardRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'account': json['account'],
        'page': json['page'],
        'size': json['size']
    };
}
function AccountRewardRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'account': value.account,
        'page': value.page,
        'size': value.size
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bb50t":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountRewardResponseFromJSON", ()=>AccountRewardResponseFromJSON);
parcelHelpers.export(exports, "AccountRewardResponseFromJSONTyped", ()=>AccountRewardResponseFromJSONTyped);
parcelHelpers.export(exports, "AccountRewardResponseToJSON", ()=>AccountRewardResponseToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function AccountRewardResponseFromJSON(json) {
    return AccountRewardResponseFromJSONTyped(json, false);
}
function AccountRewardResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list'].map((0, _.AccountRewardInfoFromJSON)),
        'page': !(0, _runtime.exists)(json, 'page') ? undefined : json['page'],
        'size': !(0, _runtime.exists)(json, 'size') ? undefined : json['size'],
        'maxPage': !(0, _runtime.exists)(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !(0, _runtime.exists)(json, 'totalSize') ? undefined : json['totalSize']
    };
}
function AccountRewardResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list.map((0, _.AccountRewardInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize
    };
}

},{"../runtime":"cHxeU","./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lgnpr":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountRewardStatsInfoFromJSON", ()=>AccountRewardStatsInfoFromJSON);
parcelHelpers.export(exports, "AccountRewardStatsInfoFromJSONTyped", ()=>AccountRewardStatsInfoFromJSONTyped);
parcelHelpers.export(exports, "AccountRewardStatsInfoToJSON", ()=>AccountRewardStatsInfoToJSON);
var _ = require("./");
function AccountRewardStatsInfoFromJSON(json) {
    return AccountRewardStatsInfoFromJSONTyped(json, false);
}
function AccountRewardStatsInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'validatorName': json['validatorName'],
        'rewardList': json['rewardList'].map((0, _.AccountRewardStatsItemFromJSON)),
        'total': json['total']
    };
}
function AccountRewardStatsInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'validatorName': value.validatorName,
        'rewardList': value.rewardList.map((0, _.AccountRewardStatsItemToJSON)),
        'total': value.total
    };
}

},{"./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9jYuh":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountRewardStatsItemFromJSON", ()=>AccountRewardStatsItemFromJSON);
parcelHelpers.export(exports, "AccountRewardStatsItemFromJSONTyped", ()=>AccountRewardStatsItemFromJSONTyped);
parcelHelpers.export(exports, "AccountRewardStatsItemToJSON", ()=>AccountRewardStatsItemToJSON);
function AccountRewardStatsItemFromJSON(json) {
    return AccountRewardStatsItemFromJSONTyped(json, false);
}
function AccountRewardStatsItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'dateTime': json['dateTime'],
        'reward': json['reward']
    };
}
function AccountRewardStatsItemToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'dateTime': value.dateTime,
        'reward': value.reward
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jI3rN":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountRewardStatsRequestFromJSON", ()=>AccountRewardStatsRequestFromJSON);
parcelHelpers.export(exports, "AccountRewardStatsRequestFromJSONTyped", ()=>AccountRewardStatsRequestFromJSONTyped);
parcelHelpers.export(exports, "AccountRewardStatsRequestToJSON", ()=>AccountRewardStatsRequestToJSON);
function AccountRewardStatsRequestFromJSON(json) {
    return AccountRewardStatsRequestFromJSONTyped(json, false);
}
function AccountRewardStatsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'account': json['account']
    };
}
function AccountRewardStatsRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'account': value.account
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"80bAi":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountRewardStatsResponseFromJSON", ()=>AccountRewardStatsResponseFromJSON);
parcelHelpers.export(exports, "AccountRewardStatsResponseFromJSONTyped", ()=>AccountRewardStatsResponseFromJSONTyped);
parcelHelpers.export(exports, "AccountRewardStatsResponseToJSON", ()=>AccountRewardStatsResponseToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function AccountRewardStatsResponseFromJSON(json) {
    return AccountRewardStatsResponseFromJSONTyped(json, false);
}
function AccountRewardStatsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'stats': (0, _runtime.mapValues)(json['stats'], (0, _.AccountRewardStatsInfoFromJSON)),
        'time': json['time']
    };
}
function AccountRewardStatsResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'stats': (0, _runtime.mapValues)(value.stats, (0, _.AccountRewardStatsInfoToJSON)),
        'time': value.time
    };
}

},{"../runtime":"cHxeU","./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bliHT":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountStakingEventsInfoFromJSON", ()=>AccountStakingEventsInfoFromJSON);
parcelHelpers.export(exports, "AccountStakingEventsInfoFromJSONTyped", ()=>AccountStakingEventsInfoFromJSONTyped);
parcelHelpers.export(exports, "AccountStakingEventsInfoToJSON", ()=>AccountStakingEventsInfoToJSON);
function AccountStakingEventsInfoFromJSON(json) {
    return AccountStakingEventsInfoFromJSONTyped(json, false);
}
function AccountStakingEventsInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'id': json['id'],
        'height': json['height'],
        'txHash': json['txHash'],
        'kind': json['kind']
    };
}
function AccountStakingEventsInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'id': value.id,
        'height': value.height,
        'txHash': value.txHash,
        'kind': value.kind
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"mSudo":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountStakingEventsInfoRequestFromJSON", ()=>AccountStakingEventsInfoRequestFromJSON);
parcelHelpers.export(exports, "AccountStakingEventsInfoRequestFromJSONTyped", ()=>AccountStakingEventsInfoRequestFromJSONTyped);
parcelHelpers.export(exports, "AccountStakingEventsInfoRequestToJSON", ()=>AccountStakingEventsInfoRequestToJSON);
function AccountStakingEventsInfoRequestFromJSON(json) {
    return AccountStakingEventsInfoRequestFromJSONTyped(json, false);
}
function AccountStakingEventsInfoRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'id': json['id']
    };
}
function AccountStakingEventsInfoRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'id': value.id
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lLz5p":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountStakingEventsInfoResponseFromJSON", ()=>AccountStakingEventsInfoResponseFromJSON);
parcelHelpers.export(exports, "AccountStakingEventsInfoResponseFromJSONTyped", ()=>AccountStakingEventsInfoResponseFromJSONTyped);
parcelHelpers.export(exports, "AccountStakingEventsInfoResponseToJSON", ()=>AccountStakingEventsInfoResponseToJSON);
var _runtime = require("../runtime");
function AccountStakingEventsInfoResponseFromJSON(json) {
    return AccountStakingEventsInfoResponseFromJSONTyped(json, false);
}
function AccountStakingEventsInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'height': json['height'],
        'txHash': json['txHash'],
        'kind': json['kind'],
        'timestamp': json['timestamp'],
        'transafer': !(0, _runtime.exists)(json, 'transafer') ? undefined : json['transafer'],
        'burn': !(0, _runtime.exists)(json, 'burn') ? undefined : json['burn'],
        'escrow': !(0, _runtime.exists)(json, 'escrow') ? undefined : json['escrow'],
        'allowanceChange': !(0, _runtime.exists)(json, 'allowanceChange') ? undefined : json['allowanceChange']
    };
}
function AccountStakingEventsInfoResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'height': value.height,
        'txHash': value.txHash,
        'kind': value.kind,
        'timestamp': value.timestamp,
        'transafer': value.transafer,
        'burn': value.burn,
        'escrow': value.escrow,
        'allowanceChange': value.allowanceChange
    };
}

},{"../runtime":"cHxeU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gV2Li":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountStakingEventsRequestFromJSON", ()=>AccountStakingEventsRequestFromJSON);
parcelHelpers.export(exports, "AccountStakingEventsRequestFromJSONTyped", ()=>AccountStakingEventsRequestFromJSONTyped);
parcelHelpers.export(exports, "AccountStakingEventsRequestToJSON", ()=>AccountStakingEventsRequestToJSON);
function AccountStakingEventsRequestFromJSON(json) {
    return AccountStakingEventsRequestFromJSONTyped(json, false);
}
function AccountStakingEventsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address'],
        'page': json['page'],
        'size': json['size']
    };
}
function AccountStakingEventsRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address,
        'page': value.page,
        'size': value.size
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"e3VTw":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountStakingEventsResponseFromJSON", ()=>AccountStakingEventsResponseFromJSON);
parcelHelpers.export(exports, "AccountStakingEventsResponseFromJSONTyped", ()=>AccountStakingEventsResponseFromJSONTyped);
parcelHelpers.export(exports, "AccountStakingEventsResponseToJSON", ()=>AccountStakingEventsResponseToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function AccountStakingEventsResponseFromJSON(json) {
    return AccountStakingEventsResponseFromJSONTyped(json, false);
}
function AccountStakingEventsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list'].map((0, _.AccountStakingEventsInfoFromJSON)),
        'page': !(0, _runtime.exists)(json, 'page') ? undefined : json['page'],
        'size': !(0, _runtime.exists)(json, 'size') ? undefined : json['size'],
        'maxPage': !(0, _runtime.exists)(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !(0, _runtime.exists)(json, 'totalSize') ? undefined : json['totalSize']
    };
}
function AccountStakingEventsResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list.map((0, _.AccountStakingEventsInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize
    };
}

},{"../runtime":"cHxeU","./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lkrn0":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BoundFromJSON", ()=>BoundFromJSON);
parcelHelpers.export(exports, "BoundFromJSONTyped", ()=>BoundFromJSONTyped);
parcelHelpers.export(exports, "BoundToJSON", ()=>BoundToJSON);
function BoundFromJSON(json) {
    return BoundFromJSONTyped(json, false);
}
function BoundFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'start': json['start'],
        'min': json['min'],
        'max': json['max']
    };
}
function BoundToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'start': value.start,
        'min': value.min,
        'max': value.max
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9zChP":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChainBlockInfoFromJSON", ()=>ChainBlockInfoFromJSON);
parcelHelpers.export(exports, "ChainBlockInfoFromJSONTyped", ()=>ChainBlockInfoFromJSONTyped);
parcelHelpers.export(exports, "ChainBlockInfoToJSON", ()=>ChainBlockInfoToJSON);
function ChainBlockInfoFromJSON(json) {
    return ChainBlockInfoFromJSONTyped(json, false);
}
function ChainBlockInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'height': json['height'],
        'epoch': json['epoch'],
        'timestamp': json['timestamp'],
        'time': json['time'],
        'hash': json['hash'],
        'txs': json['txs'],
        'entityAddress': json['entityAddress'],
        'name': json['name']
    };
}
function ChainBlockInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'height': value.height,
        'epoch': value.epoch,
        'timestamp': value.timestamp,
        'time': value.time,
        'hash': value.hash,
        'txs': value.txs,
        'entityAddress': value.entityAddress,
        'name': value.name
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lOtCY":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChainBlockInfoResponseFromJSON", ()=>ChainBlockInfoResponseFromJSON);
parcelHelpers.export(exports, "ChainBlockInfoResponseFromJSONTyped", ()=>ChainBlockInfoResponseFromJSONTyped);
parcelHelpers.export(exports, "ChainBlockInfoResponseToJSON", ()=>ChainBlockInfoResponseToJSON);
var _runtime = require("../runtime");
function ChainBlockInfoResponseFromJSON(json) {
    return ChainBlockInfoResponseFromJSONTyped(json, false);
}
function ChainBlockInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'height': !(0, _runtime.exists)(json, 'height') ? undefined : json['height'],
        'epoch': !(0, _runtime.exists)(json, 'epoch') ? undefined : json['epoch'],
        'timestamp': !(0, _runtime.exists)(json, 'timestamp') ? undefined : json['timestamp'],
        'time': !(0, _runtime.exists)(json, 'time') ? undefined : json['time'],
        'hash': !(0, _runtime.exists)(json, 'hash') ? undefined : json['hash'],
        'txs': !(0, _runtime.exists)(json, 'txs') ? undefined : json['txs'],
        'entityAddress': !(0, _runtime.exists)(json, 'entityAddress') ? undefined : json['entityAddress'],
        'name': !(0, _runtime.exists)(json, 'name') ? undefined : json['name']
    };
}
function ChainBlockInfoResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'height': value.height,
        'epoch': value.epoch,
        'timestamp': value.timestamp,
        'time': value.time,
        'hash': value.hash,
        'txs': value.txs,
        'entityAddress': value.entityAddress,
        'name': value.name
    };
}

},{"../runtime":"cHxeU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"b4u5R":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChainBlocksRequestFromJSON", ()=>ChainBlocksRequestFromJSON);
parcelHelpers.export(exports, "ChainBlocksRequestFromJSONTyped", ()=>ChainBlocksRequestFromJSONTyped);
parcelHelpers.export(exports, "ChainBlocksRequestToJSON", ()=>ChainBlocksRequestToJSON);
function ChainBlocksRequestFromJSON(json) {
    return ChainBlocksRequestFromJSONTyped(json, false);
}
function ChainBlocksRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'page': json['page'],
        'size': json['size']
    };
}
function ChainBlocksRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'page': value.page,
        'size': value.size
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2ebzE":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChainBlocksResponseFromJSON", ()=>ChainBlocksResponseFromJSON);
parcelHelpers.export(exports, "ChainBlocksResponseFromJSONTyped", ()=>ChainBlocksResponseFromJSONTyped);
parcelHelpers.export(exports, "ChainBlocksResponseToJSON", ()=>ChainBlocksResponseToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function ChainBlocksResponseFromJSON(json) {
    return ChainBlocksResponseFromJSONTyped(json, false);
}
function ChainBlocksResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list'].map((0, _.ChainBlockInfoFromJSON)),
        'page': !(0, _runtime.exists)(json, 'page') ? undefined : json['page'],
        'size': !(0, _runtime.exists)(json, 'size') ? undefined : json['size'],
        'maxPage': !(0, _runtime.exists)(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !(0, _runtime.exists)(json, 'totalSize') ? undefined : json['totalSize']
    };
}
function ChainBlocksResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list.map((0, _.ChainBlockInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize
    };
}

},{"../runtime":"cHxeU","./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"d7Vor":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChainMethodsResponseFromJSON", ()=>ChainMethodsResponseFromJSON);
parcelHelpers.export(exports, "ChainMethodsResponseFromJSONTyped", ()=>ChainMethodsResponseFromJSONTyped);
parcelHelpers.export(exports, "ChainMethodsResponseToJSON", ()=>ChainMethodsResponseToJSON);
function ChainMethodsResponseFromJSON(json) {
    return ChainMethodsResponseFromJSONTyped(json, false);
}
function ChainMethodsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list']
    };
}
function ChainMethodsResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ezu1O":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChainProposedBlocksRequestFromJSON", ()=>ChainProposedBlocksRequestFromJSON);
parcelHelpers.export(exports, "ChainProposedBlocksRequestFromJSONTyped", ()=>ChainProposedBlocksRequestFromJSONTyped);
parcelHelpers.export(exports, "ChainProposedBlocksRequestToJSON", ()=>ChainProposedBlocksRequestToJSON);
var _runtime = require("../runtime");
function ChainProposedBlocksRequestFromJSON(json) {
    return ChainProposedBlocksRequestFromJSONTyped(json, false);
}
function ChainProposedBlocksRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': !(0, _runtime.exists)(json, 'address') ? undefined : json['address'],
        'page': json['page'],
        'size': json['size']
    };
}
function ChainProposedBlocksRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address,
        'page': value.page,
        'size': value.size
    };
}

},{"../runtime":"cHxeU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eMEgO":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChainProposedBlocksResponseFromJSON", ()=>ChainProposedBlocksResponseFromJSON);
parcelHelpers.export(exports, "ChainProposedBlocksResponseFromJSONTyped", ()=>ChainProposedBlocksResponseFromJSONTyped);
parcelHelpers.export(exports, "ChainProposedBlocksResponseToJSON", ()=>ChainProposedBlocksResponseToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function ChainProposedBlocksResponseFromJSON(json) {
    return ChainProposedBlocksResponseFromJSONTyped(json, false);
}
function ChainProposedBlocksResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list'].map((0, _.ChainBlockInfoFromJSON)),
        'page': !(0, _runtime.exists)(json, 'page') ? undefined : json['page'],
        'size': !(0, _runtime.exists)(json, 'size') ? undefined : json['size'],
        'maxPage': !(0, _runtime.exists)(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !(0, _runtime.exists)(json, 'totalSize') ? undefined : json['totalSize']
    };
}
function ChainProposedBlocksResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list.map((0, _.ChainBlockInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize
    };
}

},{"../runtime":"cHxeU","./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dayX3":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChainSearchRequestFromJSON", ()=>ChainSearchRequestFromJSON);
parcelHelpers.export(exports, "ChainSearchRequestFromJSONTyped", ()=>ChainSearchRequestFromJSONTyped);
parcelHelpers.export(exports, "ChainSearchRequestToJSON", ()=>ChainSearchRequestToJSON);
function ChainSearchRequestFromJSON(json) {
    return ChainSearchRequestFromJSONTyped(json, false);
}
function ChainSearchRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'key': json['key']
    };
}
function ChainSearchRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'key': value.key
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2ucNe":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChainSearchResponseFromJSON", ()=>ChainSearchResponseFromJSON);
parcelHelpers.export(exports, "ChainSearchResponseFromJSONTyped", ()=>ChainSearchResponseFromJSONTyped);
parcelHelpers.export(exports, "ChainSearchResponseToJSON", ()=>ChainSearchResponseToJSON);
function ChainSearchResponseFromJSON(json) {
    return ChainSearchResponseFromJSONTyped(json, false);
}
function ChainSearchResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'key': json['key'],
        'type': json['type'],
        'result': json['result']
    };
}
function ChainSearchResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'key': value.key,
        'type': value.type,
        'result': value.result
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ikT4L":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChainTransactionInfoResponseFromJSON", ()=>ChainTransactionInfoResponseFromJSON);
parcelHelpers.export(exports, "ChainTransactionInfoResponseFromJSONTyped", ()=>ChainTransactionInfoResponseFromJSONTyped);
parcelHelpers.export(exports, "ChainTransactionInfoResponseToJSON", ()=>ChainTransactionInfoResponseToJSON);
function ChainTransactionInfoResponseFromJSON(json) {
    return ChainTransactionInfoResponseFromJSONTyped(json, false);
}
function ChainTransactionInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'txHash': json['txHash'],
        'timestamp': json['timestamp'],
        'time': json['time'],
        'height': json['height'],
        'fee': json['fee'],
        'nonce': json['nonce'],
        'method': json['method'],
        'from': json['from'],
        'to': json['to'],
        'amount': json['amount'],
        'raw': json['raw'],
        'status': json['status'],
        'errorMessage': json['errorMessage']
    };
}
function ChainTransactionInfoResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'txHash': value.txHash,
        'timestamp': value.timestamp,
        'time': value.time,
        'height': value.height,
        'fee': value.fee,
        'nonce': value.nonce,
        'method': value.method,
        'from': value.from,
        'to': value.to,
        'amount': value.amount,
        'raw': value.raw,
        'status': value.status,
        'errorMessage': value.errorMessage
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gn7IQ":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChainTransactionListInfoFromJSON", ()=>ChainTransactionListInfoFromJSON);
parcelHelpers.export(exports, "ChainTransactionListInfoFromJSONTyped", ()=>ChainTransactionListInfoFromJSONTyped);
parcelHelpers.export(exports, "ChainTransactionListInfoToJSON", ()=>ChainTransactionListInfoToJSON);
var _runtime = require("../runtime");
function ChainTransactionListInfoFromJSON(json) {
    return ChainTransactionListInfoFromJSONTyped(json, false);
}
function ChainTransactionListInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'txType': json['txType'],
        'txHash': !(0, _runtime.exists)(json, 'txHash') ? undefined : json['txHash'],
        'height': !(0, _runtime.exists)(json, 'height') ? undefined : json['height'],
        'method': !(0, _runtime.exists)(json, 'method') ? undefined : json['method'],
        'fee': !(0, _runtime.exists)(json, 'fee') ? undefined : json['fee'],
        'amount': !(0, _runtime.exists)(json, 'amount') ? undefined : json['amount'],
        'shares': !(0, _runtime.exists)(json, 'shares') ? undefined : json['shares'],
        'add': !(0, _runtime.exists)(json, 'add') ? undefined : json['add'],
        'timestamp': !(0, _runtime.exists)(json, 'timestamp') ? undefined : json['timestamp'],
        'time': !(0, _runtime.exists)(json, 'time') ? undefined : json['time'],
        'status': !(0, _runtime.exists)(json, 'status') ? undefined : json['status'],
        'from': !(0, _runtime.exists)(json, 'from') ? undefined : json['from'],
        'to': !(0, _runtime.exists)(json, 'to') ? undefined : json['to'],
        'runtimeId': !(0, _runtime.exists)(json, 'runtimeId') ? undefined : json['runtimeId'],
        'runtimeName': !(0, _runtime.exists)(json, 'runtimeName') ? undefined : json['runtimeName'],
        'round': !(0, _runtime.exists)(json, 'round') ? undefined : json['round'],
        'result': !(0, _runtime.exists)(json, 'result') ? undefined : json['result'],
        'type': !(0, _runtime.exists)(json, 'type') ? undefined : json['type']
    };
}
function ChainTransactionListInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'txType': value.txType,
        'txHash': value.txHash,
        'height': value.height,
        'method': value.method,
        'fee': value.fee,
        'amount': value.amount,
        'shares': value.shares,
        'add': value.add,
        'timestamp': value.timestamp,
        'time': value.time,
        'status': value.status,
        'from': value.from,
        'to': value.to,
        'runtimeId': value.runtimeId,
        'runtimeName': value.runtimeName,
        'round': value.round,
        'result': value.result,
        'type': value.type
    };
}

},{"../runtime":"cHxeU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"e216W":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChainTransactionsRequestFromJSON", ()=>ChainTransactionsRequestFromJSON);
parcelHelpers.export(exports, "ChainTransactionsRequestFromJSONTyped", ()=>ChainTransactionsRequestFromJSONTyped);
parcelHelpers.export(exports, "ChainTransactionsRequestToJSON", ()=>ChainTransactionsRequestToJSON);
var _runtime = require("../runtime");
function ChainTransactionsRequestFromJSON(json) {
    return ChainTransactionsRequestFromJSONTyped(json, false);
}
function ChainTransactionsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'height': !(0, _runtime.exists)(json, 'height') ? undefined : json['height'],
        'address': !(0, _runtime.exists)(json, 'address') ? undefined : json['address'],
        'method': !(0, _runtime.exists)(json, 'method') ? undefined : json['method'],
        'runtime': json['runtime'],
        'page': json['page'],
        'size': json['size']
    };
}
function ChainTransactionsRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'height': value.height,
        'address': value.address,
        'method': value.method,
        'runtime': value.runtime,
        'page': value.page,
        'size': value.size
    };
}

},{"../runtime":"cHxeU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6gxl1":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChainTransactionsResponseFromJSON", ()=>ChainTransactionsResponseFromJSON);
parcelHelpers.export(exports, "ChainTransactionsResponseFromJSONTyped", ()=>ChainTransactionsResponseFromJSONTyped);
parcelHelpers.export(exports, "ChainTransactionsResponseToJSON", ()=>ChainTransactionsResponseToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function ChainTransactionsResponseFromJSON(json) {
    return ChainTransactionsResponseFromJSONTyped(json, false);
}
function ChainTransactionsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list'].map((0, _.ChainTransactionListInfoFromJSON)),
        'page': !(0, _runtime.exists)(json, 'page') ? undefined : json['page'],
        'size': !(0, _runtime.exists)(json, 'size') ? undefined : json['size'],
        'maxPage': !(0, _runtime.exists)(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !(0, _runtime.exists)(json, 'totalSize') ? undefined : json['totalSize']
    };
}
function ChainTransactionsResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list.map((0, _.ChainTransactionListInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize
    };
}

},{"../runtime":"cHxeU","./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6m8E6":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChartFromJSON", ()=>ChartFromJSON);
parcelHelpers.export(exports, "ChartFromJSONTyped", ()=>ChartFromJSONTyped);
parcelHelpers.export(exports, "ChartToJSON", ()=>ChartToJSON);
function ChartFromJSON(json) {
    return ChartFromJSONTyped(json, false);
}
function ChartFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'key': json['key'],
        'value': json['value']
    };
}
function ChartToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'key': value.key,
        'value': value.value
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"krnE1":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DelegatorsInfoFromJSON", ()=>DelegatorsInfoFromJSON);
parcelHelpers.export(exports, "DelegatorsInfoFromJSONTyped", ()=>DelegatorsInfoFromJSONTyped);
parcelHelpers.export(exports, "DelegatorsInfoToJSON", ()=>DelegatorsInfoToJSON);
function DelegatorsInfoFromJSON(json) {
    return DelegatorsInfoFromJSONTyped(json, false);
}
function DelegatorsInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address'],
        'amount': json['amount'],
        'shares': json['shares'],
        'percent': json['percent'],
        'self': json['self']
    };
}
function DelegatorsInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address,
        'amount': value.amount,
        'shares': value.shares,
        'percent': value.percent,
        'self': value.self
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dhQsY":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DelegatorsRequestFromJSON", ()=>DelegatorsRequestFromJSON);
parcelHelpers.export(exports, "DelegatorsRequestFromJSONTyped", ()=>DelegatorsRequestFromJSONTyped);
parcelHelpers.export(exports, "DelegatorsRequestToJSON", ()=>DelegatorsRequestToJSON);
function DelegatorsRequestFromJSON(json) {
    return DelegatorsRequestFromJSONTyped(json, false);
}
function DelegatorsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address'],
        'page': json['page'],
        'size': json['size']
    };
}
function DelegatorsRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address,
        'page': value.page,
        'size': value.size
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8pRT3":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DelegatorsResponseFromJSON", ()=>DelegatorsResponseFromJSON);
parcelHelpers.export(exports, "DelegatorsResponseFromJSONTyped", ()=>DelegatorsResponseFromJSONTyped);
parcelHelpers.export(exports, "DelegatorsResponseToJSON", ()=>DelegatorsResponseToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function DelegatorsResponseFromJSON(json) {
    return DelegatorsResponseFromJSONTyped(json, false);
}
function DelegatorsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list'].map((0, _.DelegatorsInfoFromJSON)),
        'page': !(0, _runtime.exists)(json, 'page') ? undefined : json['page'],
        'size': !(0, _runtime.exists)(json, 'size') ? undefined : json['size'],
        'maxPage': !(0, _runtime.exists)(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !(0, _runtime.exists)(json, 'totalSize') ? undefined : json['totalSize']
    };
}
function DelegatorsResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list.map((0, _.DelegatorsInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize
    };
}

},{"../runtime":"cHxeU","./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"80PKY":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EscrowStatusFromJSON", ()=>EscrowStatusFromJSON);
parcelHelpers.export(exports, "EscrowStatusFromJSONTyped", ()=>EscrowStatusFromJSONTyped);
parcelHelpers.export(exports, "EscrowStatusToJSON", ()=>EscrowStatusToJSON);
function EscrowStatusFromJSON(json) {
    return EscrowStatusFromJSONTyped(json, false);
}
function EscrowStatusFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'self': json['self'],
        'other': json['other'],
        'total': json['total']
    };
}
function EscrowStatusToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'self': value.self,
        'other': value.other,
        'total': value.total
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5dpcO":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GovernanceProposalInfoFromJSON", ()=>GovernanceProposalInfoFromJSON);
parcelHelpers.export(exports, "GovernanceProposalInfoFromJSONTyped", ()=>GovernanceProposalInfoFromJSONTyped);
parcelHelpers.export(exports, "GovernanceProposalInfoToJSON", ()=>GovernanceProposalInfoToJSON);
function GovernanceProposalInfoFromJSON(json) {
    return GovernanceProposalInfoFromJSONTyped(json, false);
}
function GovernanceProposalInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'id': json['id'],
        'title': json['title'],
        'type': json['type'],
        'submitter': json['submitter'],
        'state': json['state'],
        'deposit': json['deposit'],
        'created_at': json['created_at'],
        'closed_at': json['closed_at'],
        'created_time': json['created_time'],
        'closed_time': json['closed_time']
    };
}
function GovernanceProposalInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'id': value.id,
        'title': value.title,
        'type': value.type,
        'submitter': value.submitter,
        'state': value.state,
        'deposit': value.deposit,
        'created_at': value.created_at,
        'closed_at': value.closed_at,
        'created_time': value.created_time,
        'closed_time': value.closed_time
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2Zg1S":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GovernanceProposalListResponseFromJSON", ()=>GovernanceProposalListResponseFromJSON);
parcelHelpers.export(exports, "GovernanceProposalListResponseFromJSONTyped", ()=>GovernanceProposalListResponseFromJSONTyped);
parcelHelpers.export(exports, "GovernanceProposalListResponseToJSON", ()=>GovernanceProposalListResponseToJSON);
var _ = require("./");
function GovernanceProposalListResponseFromJSON(json) {
    return GovernanceProposalListResponseFromJSONTyped(json, false);
}
function GovernanceProposalListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list'].map((0, _.GovernanceProposalInfoFromJSON))
    };
}
function GovernanceProposalListResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list.map((0, _.GovernanceProposalInfoToJSON))
    };
}

},{"./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cQcIZ":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GovernanceProposalWithVotesRequestFromJSON", ()=>GovernanceProposalWithVotesRequestFromJSON);
parcelHelpers.export(exports, "GovernanceProposalWithVotesRequestFromJSONTyped", ()=>GovernanceProposalWithVotesRequestFromJSONTyped);
parcelHelpers.export(exports, "GovernanceProposalWithVotesRequestToJSON", ()=>GovernanceProposalWithVotesRequestToJSON);
function GovernanceProposalWithVotesRequestFromJSON(json) {
    return GovernanceProposalWithVotesRequestFromJSONTyped(json, false);
}
function GovernanceProposalWithVotesRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'id': json['id']
    };
}
function GovernanceProposalWithVotesRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'id': value.id
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"l5Fnz":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GovernanceProposalWithVotesResponseFromJSON", ()=>GovernanceProposalWithVotesResponseFromJSON);
parcelHelpers.export(exports, "GovernanceProposalWithVotesResponseFromJSONTyped", ()=>GovernanceProposalWithVotesResponseFromJSONTyped);
parcelHelpers.export(exports, "GovernanceProposalWithVotesResponseToJSON", ()=>GovernanceProposalWithVotesResponseToJSON);
var _ = require("./");
function GovernanceProposalWithVotesResponseFromJSON(json) {
    return GovernanceProposalWithVotesResponseFromJSONTyped(json, false);
}
function GovernanceProposalWithVotesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'options': json['options'].map((0, _.ProposalOptionFromJSON)),
        'votes': json['votes'].map((0, _.ProposalVoteFromJSON))
    };
}
function GovernanceProposalWithVotesResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'options': value.options.map((0, _.ProposalOptionToJSON)),
        'votes': value.votes.map((0, _.ProposalVoteToJSON))
    };
}

},{"./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gQPDW":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GovernanceVotesRequestFromJSON", ()=>GovernanceVotesRequestFromJSON);
parcelHelpers.export(exports, "GovernanceVotesRequestFromJSONTyped", ()=>GovernanceVotesRequestFromJSONTyped);
parcelHelpers.export(exports, "GovernanceVotesRequestToJSON", ()=>GovernanceVotesRequestToJSON);
var _runtime = require("../runtime");
function GovernanceVotesRequestFromJSON(json) {
    return GovernanceVotesRequestFromJSONTyped(json, false);
}
function GovernanceVotesRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'proposalId': !(0, _runtime.exists)(json, 'proposalId') ? undefined : json['proposalId'],
        'validator': !(0, _runtime.exists)(json, 'validator') ? undefined : json['validator'],
        'page': json['page'],
        'size': json['size']
    };
}
function GovernanceVotesRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'proposalId': value.proposalId,
        'validator': value.validator,
        'page': value.page,
        'size': value.size
    };
}

},{"../runtime":"cHxeU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bDrpo":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GovernanceVotesResponseFromJSON", ()=>GovernanceVotesResponseFromJSON);
parcelHelpers.export(exports, "GovernanceVotesResponseFromJSONTyped", ()=>GovernanceVotesResponseFromJSONTyped);
parcelHelpers.export(exports, "GovernanceVotesResponseToJSON", ()=>GovernanceVotesResponseToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function GovernanceVotesResponseFromJSON(json) {
    return GovernanceVotesResponseFromJSONTyped(json, false);
}
function GovernanceVotesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list'].map((0, _.ProposalVoteFromJSON)),
        'page': !(0, _runtime.exists)(json, 'page') ? undefined : json['page'],
        'size': !(0, _runtime.exists)(json, 'size') ? undefined : json['size'],
        'maxPage': !(0, _runtime.exists)(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !(0, _runtime.exists)(json, 'totalSize') ? undefined : json['totalSize']
    };
}
function GovernanceVotesResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list.map((0, _.ProposalVoteToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize
    };
}

},{"../runtime":"cHxeU","./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kVRaB":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarketChartResponseFromJSON", ()=>MarketChartResponseFromJSON);
parcelHelpers.export(exports, "MarketChartResponseFromJSONTyped", ()=>MarketChartResponseFromJSONTyped);
parcelHelpers.export(exports, "MarketChartResponseToJSON", ()=>MarketChartResponseToJSON);
var _ = require("./");
function MarketChartResponseFromJSON(json) {
    return MarketChartResponseFromJSONTyped(json, false);
}
function MarketChartResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'price': json['price'].map((0, _.ChartFromJSON)),
        'marketCap': json['marketCap'].map((0, _.ChartFromJSON)),
        'volume': json['volume'].map((0, _.ChartFromJSON))
    };
}
function MarketChartResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'price': value.price.map((0, _.ChartToJSON)),
        'marketCap': value.marketCap.map((0, _.ChartToJSON)),
        'volume': value.volume.map((0, _.ChartToJSON))
    };
}

},{"./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cL19C":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MarketInfoResponseFromJSON", ()=>MarketInfoResponseFromJSON);
parcelHelpers.export(exports, "MarketInfoResponseFromJSONTyped", ()=>MarketInfoResponseFromJSONTyped);
parcelHelpers.export(exports, "MarketInfoResponseToJSON", ()=>MarketInfoResponseToJSON);
function MarketInfoResponseFromJSON(json) {
    return MarketInfoResponseFromJSONTyped(json, false);
}
function MarketInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'price': json['price'],
        'priceChangePct24h': json['priceChangePct24h'],
        'rank': json['rank'],
        'marketCap': json['marketCap'],
        'marketCapChangePct24h': json['marketCapChangePct24h'],
        'volume': json['volume'],
        'volumeChangePct24h': json['volumeChangePct24h']
    };
}
function MarketInfoResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'price': value.price,
        'priceChangePct24h': value.priceChangePct24h,
        'rank': value.rank,
        'marketCap': value.marketCap,
        'marketCapChangePct24h': value.marketCapChangePct24h,
        'volume': value.volume,
        'volumeChangePct24h': value.volumeChangePct24h
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iMN1H":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NetworkStatusResponseFromJSON", ()=>NetworkStatusResponseFromJSON);
parcelHelpers.export(exports, "NetworkStatusResponseFromJSONTyped", ()=>NetworkStatusResponseFromJSONTyped);
parcelHelpers.export(exports, "NetworkStatusResponseToJSON", ()=>NetworkStatusResponseToJSON);
function NetworkStatusResponseFromJSON(json) {
    return NetworkStatusResponseFromJSONTyped(json, false);
}
function NetworkStatusResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'curHeight': json['curHeight'],
        'curEpoch': json['curEpoch'],
        'totalTxs': json['totalTxs'],
        'totalEscrow': json['totalEscrow'],
        'activeValidator': json['activeValidator'],
        'totalDelegator': json['totalDelegator']
    };
}
function NetworkStatusResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'curHeight': value.curHeight,
        'curEpoch': value.curEpoch,
        'totalTxs': value.totalTxs,
        'totalEscrow': value.totalEscrow,
        'activeValidator': value.activeValidator,
        'totalDelegator': value.totalDelegator
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9mLfl":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NetworkTrendResponseFromJSON", ()=>NetworkTrendResponseFromJSON);
parcelHelpers.export(exports, "NetworkTrendResponseFromJSONTyped", ()=>NetworkTrendResponseFromJSONTyped);
parcelHelpers.export(exports, "NetworkTrendResponseToJSON", ()=>NetworkTrendResponseToJSON);
var _ = require("./");
function NetworkTrendResponseFromJSON(json) {
    return NetworkTrendResponseFromJSONTyped(json, false);
}
function NetworkTrendResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'tx': json['tx'].map((0, _.ChartFromJSON)),
        'escrow': json['escrow'].map((0, _.ChartFromJSON))
    };
}
function NetworkTrendResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'tx': value.tx.map((0, _.ChartToJSON)),
        'escrow': value.escrow.map((0, _.ChartToJSON))
    };
}

},{"./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fjWsw":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageFromJSON", ()=>PageFromJSON);
parcelHelpers.export(exports, "PageFromJSONTyped", ()=>PageFromJSONTyped);
parcelHelpers.export(exports, "PageToJSON", ()=>PageToJSON);
function PageFromJSON(json) {
    return PageFromJSONTyped(json, false);
}
function PageFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'page': json['page'],
        'size': json['size'],
        'maxPage': json['maxPage'],
        'totalSize': json['totalSize']
    };
}
function PageToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hXvrD":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalOptionFromJSON", ()=>ProposalOptionFromJSON);
parcelHelpers.export(exports, "ProposalOptionFromJSONTyped", ()=>ProposalOptionFromJSONTyped);
parcelHelpers.export(exports, "ProposalOptionToJSON", ()=>ProposalOptionToJSON);
function ProposalOptionFromJSON(json) {
    return ProposalOptionFromJSONTyped(json, false);
}
function ProposalOptionFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'name': json['name'],
        'amount': json['amount'],
        'percent': json['percent']
    };
}
function ProposalOptionToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'name': value.name,
        'amount': value.amount,
        'percent': value.percent
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kloE8":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalVoteFromJSON", ()=>ProposalVoteFromJSON);
parcelHelpers.export(exports, "ProposalVoteFromJSONTyped", ()=>ProposalVoteFromJSONTyped);
parcelHelpers.export(exports, "ProposalVoteToJSON", ()=>ProposalVoteToJSON);
function ProposalVoteFromJSON(json) {
    return ProposalVoteFromJSONTyped(json, false);
}
function ProposalVoteFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'proposalId': json['proposalId'],
        'title': json['title'],
        'name': json['name'],
        'icon': json['icon'],
        'address': json['address'],
        'vote': json['vote'],
        'amount': json['amount'],
        'percent': json['percent']
    };
}
function ProposalVoteToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'proposalId': value.proposalId,
        'title': value.title,
        'name': value.name,
        'icon': value.icon,
        'address': value.address,
        'vote': value.vote,
        'amount': value.amount,
        'percent': value.percent
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eZfZh":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RateFromJSON", ()=>RateFromJSON);
parcelHelpers.export(exports, "RateFromJSONTyped", ()=>RateFromJSONTyped);
parcelHelpers.export(exports, "RateToJSON", ()=>RateToJSON);
function RateFromJSON(json) {
    return RateFromJSONTyped(json, false);
}
function RateFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'start': json['start'],
        'rate': json['rate']
    };
}
function RateToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'start': value.start,
        'rate': value.rate
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gjWlO":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeListInfoFromJSON", ()=>RuntimeListInfoFromJSON);
parcelHelpers.export(exports, "RuntimeListInfoFromJSONTyped", ()=>RuntimeListInfoFromJSONTyped);
parcelHelpers.export(exports, "RuntimeListInfoToJSON", ()=>RuntimeListInfoToJSON);
function RuntimeListInfoFromJSON(json) {
    return RuntimeListInfoFromJSONTyped(json, false);
}
function RuntimeListInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'runtimeId': json['runtimeId'],
        'name': json['name']
    };
}
function RuntimeListInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'runtimeId': value.runtimeId,
        'name': value.name
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"e5wbM":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeListResponseFromJSON", ()=>RuntimeListResponseFromJSON);
parcelHelpers.export(exports, "RuntimeListResponseFromJSONTyped", ()=>RuntimeListResponseFromJSONTyped);
parcelHelpers.export(exports, "RuntimeListResponseToJSON", ()=>RuntimeListResponseToJSON);
var _ = require("./");
function RuntimeListResponseFromJSON(json) {
    return RuntimeListResponseFromJSONTyped(json, false);
}
function RuntimeListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list'].map((0, _.RuntimeListInfoFromJSON))
    };
}
function RuntimeListResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list.map((0, _.RuntimeListInfoToJSON))
    };
}

},{"./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5aUi1":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeRoundInfoFromJSON", ()=>RuntimeRoundInfoFromJSON);
parcelHelpers.export(exports, "RuntimeRoundInfoFromJSONTyped", ()=>RuntimeRoundInfoFromJSONTyped);
parcelHelpers.export(exports, "RuntimeRoundInfoToJSON", ()=>RuntimeRoundInfoToJSON);
function RuntimeRoundInfoFromJSON(json) {
    return RuntimeRoundInfoFromJSONTyped(json, false);
}
function RuntimeRoundInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'version': json['version'],
        'runtimeId': json['runtimeId'],
        'runtimeName': json['runtimeName'],
        'round': json['round'],
        'timestamp': json['timestamp'],
        'header_type': json['header_type'],
        'previous_hash': json['previous_hash'],
        'io_root': json['io_root'],
        'state_root': json['state_root'],
        'messages_hash': json['messages_hash'],
        'next': json['next']
    };
}
function RuntimeRoundInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'version': value.version,
        'runtimeId': value.runtimeId,
        'runtimeName': value.runtimeName,
        'round': value.round,
        'timestamp': value.timestamp,
        'header_type': value.header_type,
        'previous_hash': value.previous_hash,
        'io_root': value.io_root,
        'state_root': value.state_root,
        'messages_hash': value.messages_hash,
        'next': value.next
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1km9g":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeRoundInfoRequestFromJSON", ()=>RuntimeRoundInfoRequestFromJSON);
parcelHelpers.export(exports, "RuntimeRoundInfoRequestFromJSONTyped", ()=>RuntimeRoundInfoRequestFromJSONTyped);
parcelHelpers.export(exports, "RuntimeRoundInfoRequestToJSON", ()=>RuntimeRoundInfoRequestToJSON);
function RuntimeRoundInfoRequestFromJSON(json) {
    return RuntimeRoundInfoRequestFromJSONTyped(json, false);
}
function RuntimeRoundInfoRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'id': json['id'],
        'round': json['round']
    };
}
function RuntimeRoundInfoRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'id': value.id,
        'round': value.round
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9ebM9":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeRoundInfoResponseFromJSON", ()=>RuntimeRoundInfoResponseFromJSON);
parcelHelpers.export(exports, "RuntimeRoundInfoResponseFromJSONTyped", ()=>RuntimeRoundInfoResponseFromJSONTyped);
parcelHelpers.export(exports, "RuntimeRoundInfoResponseToJSON", ()=>RuntimeRoundInfoResponseToJSON);
var _runtime = require("../runtime");
function RuntimeRoundInfoResponseFromJSON(json) {
    return RuntimeRoundInfoResponseFromJSONTyped(json, false);
}
function RuntimeRoundInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'version': !(0, _runtime.exists)(json, 'version') ? undefined : json['version'],
        'runtimeId': !(0, _runtime.exists)(json, 'runtimeId') ? undefined : json['runtimeId'],
        'runtimeName': !(0, _runtime.exists)(json, 'runtimeName') ? undefined : json['runtimeName'],
        'round': !(0, _runtime.exists)(json, 'round') ? undefined : json['round'],
        'timestamp': !(0, _runtime.exists)(json, 'timestamp') ? undefined : json['timestamp'],
        'header_type': !(0, _runtime.exists)(json, 'header_type') ? undefined : json['header_type'],
        'previous_hash': !(0, _runtime.exists)(json, 'previous_hash') ? undefined : json['previous_hash'],
        'io_root': !(0, _runtime.exists)(json, 'io_root') ? undefined : json['io_root'],
        'state_root': !(0, _runtime.exists)(json, 'state_root') ? undefined : json['state_root'],
        'messages_hash': !(0, _runtime.exists)(json, 'messages_hash') ? undefined : json['messages_hash'],
        'next': !(0, _runtime.exists)(json, 'next') ? undefined : json['next']
    };
}
function RuntimeRoundInfoResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'version': value.version,
        'runtimeId': value.runtimeId,
        'runtimeName': value.runtimeName,
        'round': value.round,
        'timestamp': value.timestamp,
        'header_type': value.header_type,
        'previous_hash': value.previous_hash,
        'io_root': value.io_root,
        'state_root': value.state_root,
        'messages_hash': value.messages_hash,
        'next': value.next
    };
}

},{"../runtime":"cHxeU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jnW1Z":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeRoundListRequestFromJSON", ()=>RuntimeRoundListRequestFromJSON);
parcelHelpers.export(exports, "RuntimeRoundListRequestFromJSONTyped", ()=>RuntimeRoundListRequestFromJSONTyped);
parcelHelpers.export(exports, "RuntimeRoundListRequestToJSON", ()=>RuntimeRoundListRequestToJSON);
function RuntimeRoundListRequestFromJSON(json) {
    return RuntimeRoundListRequestFromJSONTyped(json, false);
}
function RuntimeRoundListRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'id': json['id'],
        'page': json['page'],
        'size': json['size']
    };
}
function RuntimeRoundListRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'id': value.id,
        'page': value.page,
        'size': value.size
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9Du3b":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeRoundListResponseFromJSON", ()=>RuntimeRoundListResponseFromJSON);
parcelHelpers.export(exports, "RuntimeRoundListResponseFromJSONTyped", ()=>RuntimeRoundListResponseFromJSONTyped);
parcelHelpers.export(exports, "RuntimeRoundListResponseToJSON", ()=>RuntimeRoundListResponseToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function RuntimeRoundListResponseFromJSON(json) {
    return RuntimeRoundListResponseFromJSONTyped(json, false);
}
function RuntimeRoundListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list'].map((0, _.RuntimeRoundInfoFromJSON)),
        'page': !(0, _runtime.exists)(json, 'page') ? undefined : json['page'],
        'size': !(0, _runtime.exists)(json, 'size') ? undefined : json['size'],
        'maxPage': !(0, _runtime.exists)(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !(0, _runtime.exists)(json, 'totalSize') ? undefined : json['totalSize']
    };
}
function RuntimeRoundListResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list.map((0, _.RuntimeRoundInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize
    };
}

},{"../runtime":"cHxeU","./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2abd6":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeStatsInfoFromJSON", ()=>RuntimeStatsInfoFromJSON);
parcelHelpers.export(exports, "RuntimeStatsInfoFromJSONTyped", ()=>RuntimeStatsInfoFromJSONTyped);
parcelHelpers.export(exports, "RuntimeStatsInfoToJSON", ()=>RuntimeStatsInfoToJSON);
var _ = require("./");
function RuntimeStatsInfoFromJSON(json) {
    return RuntimeStatsInfoFromJSONTyped(json, false);
}
function RuntimeStatsInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'entityId': json['entityId'],
        'name': json['name'],
        'address': json['address'],
        'validator': json['validator'],
        'icon': json['icon'],
        'status': json['status'],
        'stats': (0, _.RuntimeStatsItemFromJSON)(json['stats'])
    };
}
function RuntimeStatsInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'entityId': value.entityId,
        'name': value.name,
        'address': value.address,
        'validator': value.validator,
        'icon': value.icon,
        'status': value.status,
        'stats': (0, _.RuntimeStatsItemToJSON)(value.stats)
    };
}

},{"./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1vpZc":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeStatsItemFromJSON", ()=>RuntimeStatsItemFromJSON);
parcelHelpers.export(exports, "RuntimeStatsItemFromJSONTyped", ()=>RuntimeStatsItemFromJSONTyped);
parcelHelpers.export(exports, "RuntimeStatsItemToJSON", ()=>RuntimeStatsItemToJSON);
function RuntimeStatsItemFromJSON(json) {
    return RuntimeStatsItemFromJSONTyped(json, false);
}
function RuntimeStatsItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'elected': json['elected'],
        'primary': json['primary'],
        'backup': json['backup'],
        'proposer': json['proposer']
    };
}
function RuntimeStatsItemToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'elected': value.elected,
        'primary': value.primary,
        'backup': value.backup,
        'proposer': value.proposer
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1Upw8":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeStatsRequestFromJSON", ()=>RuntimeStatsRequestFromJSON);
parcelHelpers.export(exports, "RuntimeStatsRequestFromJSONTyped", ()=>RuntimeStatsRequestFromJSONTyped);
parcelHelpers.export(exports, "RuntimeStatsRequestToJSON", ()=>RuntimeStatsRequestToJSON);
function RuntimeStatsRequestFromJSON(json) {
    return RuntimeStatsRequestFromJSONTyped(json, false);
}
function RuntimeStatsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'id': json['id']
    };
}
function RuntimeStatsRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'id': value.id
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"f3LYI":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeStatsResponseFromJSON", ()=>RuntimeStatsResponseFromJSON);
parcelHelpers.export(exports, "RuntimeStatsResponseFromJSONTyped", ()=>RuntimeStatsResponseFromJSONTyped);
parcelHelpers.export(exports, "RuntimeStatsResponseToJSON", ()=>RuntimeStatsResponseToJSON);
var _ = require("./");
function RuntimeStatsResponseFromJSON(json) {
    return RuntimeStatsResponseFromJSONTyped(json, false);
}
function RuntimeStatsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'online': json['online'],
        'offline': json['offline'],
        'list': json['list'].map((0, _.RuntimeStatsInfoFromJSON))
    };
}
function RuntimeStatsResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'online': value.online,
        'offline': value.offline,
        'list': value.list.map((0, _.RuntimeStatsInfoToJSON))
    };
}

},{"./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3whR8":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactionConsensusTxFromJSON", ()=>RuntimeTransactionConsensusTxFromJSON);
parcelHelpers.export(exports, "RuntimeTransactionConsensusTxFromJSONTyped", ()=>RuntimeTransactionConsensusTxFromJSONTyped);
parcelHelpers.export(exports, "RuntimeTransactionConsensusTxToJSON", ()=>RuntimeTransactionConsensusTxToJSON);
function RuntimeTransactionConsensusTxFromJSON(json) {
    return RuntimeTransactionConsensusTxFromJSONTyped(json, false);
}
function RuntimeTransactionConsensusTxFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'method': json['method'],
        'from': json['from'],
        'to': json['to'],
        'amount': json['amount'],
        'nonce': json['nonce']
    };
}
function RuntimeTransactionConsensusTxToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'method': value.method,
        'from': value.from,
        'to': value.to,
        'amount': value.amount,
        'nonce': value.nonce
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fKB0Z":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactionEventErrorFromJSON", ()=>RuntimeTransactionEventErrorFromJSON);
parcelHelpers.export(exports, "RuntimeTransactionEventErrorFromJSONTyped", ()=>RuntimeTransactionEventErrorFromJSONTyped);
parcelHelpers.export(exports, "RuntimeTransactionEventErrorToJSON", ()=>RuntimeTransactionEventErrorToJSON);
function RuntimeTransactionEventErrorFromJSON(json) {
    return RuntimeTransactionEventErrorFromJSONTyped(json, false);
}
function RuntimeTransactionEventErrorFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'code': json['code'],
        'module': json['module']
    };
}
function RuntimeTransactionEventErrorToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'code': value.code,
        'module': value.module
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ha9Wt":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactionEvmTxFromJSON", ()=>RuntimeTransactionEvmTxFromJSON);
parcelHelpers.export(exports, "RuntimeTransactionEvmTxFromJSONTyped", ()=>RuntimeTransactionEvmTxFromJSONTyped);
parcelHelpers.export(exports, "RuntimeTransactionEvmTxToJSON", ()=>RuntimeTransactionEvmTxToJSON);
function RuntimeTransactionEvmTxFromJSON(json) {
    return RuntimeTransactionEvmTxFromJSONTyped(json, false);
}
function RuntimeTransactionEvmTxFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'hash': json['hash'],
        'from': json['from'],
        'to': json['to'],
        'nonce': json['nonce'],
        'gasPrice': json['gasPrice'],
        'gasLimit': json['gasLimit'],
        'data': json['data'],
        'value': json['value']
    };
}
function RuntimeTransactionEvmTxToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'hash': value.hash,
        'from': value.from,
        'to': value.to,
        'nonce': value.nonce,
        'gasPrice': value.gasPrice,
        'gasLimit': value.gasLimit,
        'data': value.data,
        'value': value.value
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6IGqt":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactionInfoRequestFromJSON", ()=>RuntimeTransactionInfoRequestFromJSON);
parcelHelpers.export(exports, "RuntimeTransactionInfoRequestFromJSONTyped", ()=>RuntimeTransactionInfoRequestFromJSONTyped);
parcelHelpers.export(exports, "RuntimeTransactionInfoRequestToJSON", ()=>RuntimeTransactionInfoRequestToJSON);
function RuntimeTransactionInfoRequestFromJSON(json) {
    return RuntimeTransactionInfoRequestFromJSONTyped(json, false);
}
function RuntimeTransactionInfoRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'id': json['id'],
        'round': json['round'],
        'hash': json['hash']
    };
}
function RuntimeTransactionInfoRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'id': value.id,
        'round': value.round,
        'hash': value.hash
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bY7Ky":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactionInfoResponseFromJSON", ()=>RuntimeTransactionInfoResponseFromJSON);
parcelHelpers.export(exports, "RuntimeTransactionInfoResponseFromJSONTyped", ()=>RuntimeTransactionInfoResponseFromJSONTyped);
parcelHelpers.export(exports, "RuntimeTransactionInfoResponseToJSON", ()=>RuntimeTransactionInfoResponseToJSON);
var _ = require("./");
function RuntimeTransactionInfoResponseFromJSON(json) {
    return RuntimeTransactionInfoResponseFromJSONTyped(json, false);
}
function RuntimeTransactionInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'runtimeId': json['runtimeId'],
        'runtimeName': json['runtimeName'],
        'txHash': json['txHash'],
        'round': json['round'],
        'result': json['result'],
        'message': json['message'],
        'timestamp': json['timestamp'],
        'type': json['type'],
        'ctx': (0, _.RuntimeTransactionConsensusTxFromJSON)(json['ctx']),
        'etx': (0, _.RuntimeTransactionEvmTxFromJSON)(json['etx']),
        'events': json['events']
    };
}
function RuntimeTransactionInfoResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'runtimeId': value.runtimeId,
        'runtimeName': value.runtimeName,
        'txHash': value.txHash,
        'round': value.round,
        'result': value.result,
        'message': value.message,
        'timestamp': value.timestamp,
        'type': value.type,
        'ctx': (0, _.RuntimeTransactionConsensusTxToJSON)(value.ctx),
        'etx': (0, _.RuntimeTransactionEvmTxToJSON)(value.etx),
        'events': value.events
    };
}

},{"./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"42SyS":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactionListInfoFromJSON", ()=>RuntimeTransactionListInfoFromJSON);
parcelHelpers.export(exports, "RuntimeTransactionListInfoFromJSONTyped", ()=>RuntimeTransactionListInfoFromJSONTyped);
parcelHelpers.export(exports, "RuntimeTransactionListInfoToJSON", ()=>RuntimeTransactionListInfoToJSON);
function RuntimeTransactionListInfoFromJSON(json) {
    return RuntimeTransactionListInfoFromJSONTyped(json, false);
}
function RuntimeTransactionListInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'runtimeId': json['runtimeId'],
        'txHash': json['txHash'],
        'round': json['round'],
        'result': json['result'],
        'timestamp': json['timestamp'],
        'type': json['type']
    };
}
function RuntimeTransactionListInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'runtimeId': value.runtimeId,
        'txHash': value.txHash,
        'round': value.round,
        'result': value.result,
        'timestamp': value.timestamp,
        'type': value.type
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9fb3y":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactionListRequestFromJSON", ()=>RuntimeTransactionListRequestFromJSON);
parcelHelpers.export(exports, "RuntimeTransactionListRequestFromJSONTyped", ()=>RuntimeTransactionListRequestFromJSONTyped);
parcelHelpers.export(exports, "RuntimeTransactionListRequestToJSON", ()=>RuntimeTransactionListRequestToJSON);
var _runtime = require("../runtime");
function RuntimeTransactionListRequestFromJSON(json) {
    return RuntimeTransactionListRequestFromJSONTyped(json, false);
}
function RuntimeTransactionListRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'id': !(0, _runtime.exists)(json, 'id') ? undefined : json['id'],
        'address': !(0, _runtime.exists)(json, 'address') ? undefined : json['address'],
        'round': !(0, _runtime.exists)(json, 'round') ? undefined : json['round'],
        'page': json['page'],
        'size': json['size']
    };
}
function RuntimeTransactionListRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'id': value.id,
        'address': value.address,
        'round': value.round,
        'page': value.page,
        'size': value.size
    };
}

},{"../runtime":"cHxeU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"84cXp":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactionListResponseFromJSON", ()=>RuntimeTransactionListResponseFromJSON);
parcelHelpers.export(exports, "RuntimeTransactionListResponseFromJSONTyped", ()=>RuntimeTransactionListResponseFromJSONTyped);
parcelHelpers.export(exports, "RuntimeTransactionListResponseToJSON", ()=>RuntimeTransactionListResponseToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function RuntimeTransactionListResponseFromJSON(json) {
    return RuntimeTransactionListResponseFromJSONTyped(json, false);
}
function RuntimeTransactionListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list'].map((0, _.RuntimeTransactionListInfoFromJSON)),
        'page': !(0, _runtime.exists)(json, 'page') ? undefined : json['page'],
        'size': !(0, _runtime.exists)(json, 'size') ? undefined : json['size'],
        'maxPage': !(0, _runtime.exists)(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !(0, _runtime.exists)(json, 'totalSize') ? undefined : json['totalSize']
    };
}
function RuntimeTransactionListResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list.map((0, _.RuntimeTransactionListInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize
    };
}

},{"../runtime":"cHxeU","./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5a31V":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorBlocksStatsInfoFromJSON", ()=>ValidatorBlocksStatsInfoFromJSON);
parcelHelpers.export(exports, "ValidatorBlocksStatsInfoFromJSONTyped", ()=>ValidatorBlocksStatsInfoFromJSONTyped);
parcelHelpers.export(exports, "ValidatorBlocksStatsInfoToJSON", ()=>ValidatorBlocksStatsInfoToJSON);
function ValidatorBlocksStatsInfoFromJSON(json) {
    return ValidatorBlocksStatsInfoFromJSONTyped(json, false);
}
function ValidatorBlocksStatsInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'height': json['height'],
        'block': json['block']
    };
}
function ValidatorBlocksStatsInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'height': value.height,
        'block': value.block
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9wZB0":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorBlocksStatsRequestFromJSON", ()=>ValidatorBlocksStatsRequestFromJSON);
parcelHelpers.export(exports, "ValidatorBlocksStatsRequestFromJSONTyped", ()=>ValidatorBlocksStatsRequestFromJSONTyped);
parcelHelpers.export(exports, "ValidatorBlocksStatsRequestToJSON", ()=>ValidatorBlocksStatsRequestToJSON);
function ValidatorBlocksStatsRequestFromJSON(json) {
    return ValidatorBlocksStatsRequestFromJSONTyped(json, false);
}
function ValidatorBlocksStatsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address']
    };
}
function ValidatorBlocksStatsRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2JWgY":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorBlocksStatsResponseFromJSON", ()=>ValidatorBlocksStatsResponseFromJSON);
parcelHelpers.export(exports, "ValidatorBlocksStatsResponseFromJSONTyped", ()=>ValidatorBlocksStatsResponseFromJSONTyped);
parcelHelpers.export(exports, "ValidatorBlocksStatsResponseToJSON", ()=>ValidatorBlocksStatsResponseToJSON);
var _ = require("./");
function ValidatorBlocksStatsResponseFromJSON(json) {
    return ValidatorBlocksStatsResponseFromJSONTyped(json, false);
}
function ValidatorBlocksStatsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'signs': json['signs'].map((0, _.ValidatorBlocksStatsInfoFromJSON)),
        'proposals': json['proposals'].map((0, _.ValidatorBlocksStatsInfoFromJSON))
    };
}
function ValidatorBlocksStatsResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'signs': value.signs.map((0, _.ValidatorBlocksStatsInfoToJSON)),
        'proposals': value.proposals.map((0, _.ValidatorBlocksStatsInfoToJSON))
    };
}

},{"./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4c0P3":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorEscrowEventRequestFromJSON", ()=>ValidatorEscrowEventRequestFromJSON);
parcelHelpers.export(exports, "ValidatorEscrowEventRequestFromJSONTyped", ()=>ValidatorEscrowEventRequestFromJSONTyped);
parcelHelpers.export(exports, "ValidatorEscrowEventRequestToJSON", ()=>ValidatorEscrowEventRequestToJSON);
function ValidatorEscrowEventRequestFromJSON(json) {
    return ValidatorEscrowEventRequestFromJSONTyped(json, false);
}
function ValidatorEscrowEventRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address'],
        'page': json['page'],
        'size': json['size']
    };
}
function ValidatorEscrowEventRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address,
        'page': value.page,
        'size': value.size
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gr8OD":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorEscrowEventResponseFromJSON", ()=>ValidatorEscrowEventResponseFromJSON);
parcelHelpers.export(exports, "ValidatorEscrowEventResponseFromJSONTyped", ()=>ValidatorEscrowEventResponseFromJSONTyped);
parcelHelpers.export(exports, "ValidatorEscrowEventResponseToJSON", ()=>ValidatorEscrowEventResponseToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function ValidatorEscrowEventResponseFromJSON(json) {
    return ValidatorEscrowEventResponseFromJSONTyped(json, false);
}
function ValidatorEscrowEventResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list'].map((0, _.ChainTransactionListInfoFromJSON)),
        'page': !(0, _runtime.exists)(json, 'page') ? undefined : json['page'],
        'size': !(0, _runtime.exists)(json, 'size') ? undefined : json['size'],
        'maxPage': !(0, _runtime.exists)(json, 'maxPage') ? undefined : json['maxPage'],
        'totalSize': !(0, _runtime.exists)(json, 'totalSize') ? undefined : json['totalSize']
    };
}
function ValidatorEscrowEventResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list.map((0, _.ChainTransactionListInfoToJSON)),
        'page': value.page,
        'size': value.size,
        'maxPage': value.maxPage,
        'totalSize': value.totalSize
    };
}

},{"../runtime":"cHxeU","./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lV43J":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorEscrowStatsInfoFromJSON", ()=>ValidatorEscrowStatsInfoFromJSON);
parcelHelpers.export(exports, "ValidatorEscrowStatsInfoFromJSONTyped", ()=>ValidatorEscrowStatsInfoFromJSONTyped);
parcelHelpers.export(exports, "ValidatorEscrowStatsInfoToJSON", ()=>ValidatorEscrowStatsInfoToJSON);
function ValidatorEscrowStatsInfoFromJSON(json) {
    return ValidatorEscrowStatsInfoFromJSONTyped(json, false);
}
function ValidatorEscrowStatsInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'timestamp': json['timestamp'],
        'escrow': json['escrow']
    };
}
function ValidatorEscrowStatsInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'timestamp': value.timestamp,
        'escrow': value.escrow
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9hJ6O":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorEscrowStatsRequestFromJSON", ()=>ValidatorEscrowStatsRequestFromJSON);
parcelHelpers.export(exports, "ValidatorEscrowStatsRequestFromJSONTyped", ()=>ValidatorEscrowStatsRequestFromJSONTyped);
parcelHelpers.export(exports, "ValidatorEscrowStatsRequestToJSON", ()=>ValidatorEscrowStatsRequestToJSON);
function ValidatorEscrowStatsRequestFromJSON(json) {
    return ValidatorEscrowStatsRequestFromJSONTyped(json, false);
}
function ValidatorEscrowStatsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address']
    };
}
function ValidatorEscrowStatsRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fPNoo":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorEscrowStatsResponseFromJSON", ()=>ValidatorEscrowStatsResponseFromJSON);
parcelHelpers.export(exports, "ValidatorEscrowStatsResponseFromJSONTyped", ()=>ValidatorEscrowStatsResponseFromJSONTyped);
parcelHelpers.export(exports, "ValidatorEscrowStatsResponseToJSON", ()=>ValidatorEscrowStatsResponseToJSON);
var _ = require("./");
function ValidatorEscrowStatsResponseFromJSON(json) {
    return ValidatorEscrowStatsResponseFromJSONTyped(json, false);
}
function ValidatorEscrowStatsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list'].map((0, _.ValidatorEscrowStatsInfoFromJSON))
    };
}
function ValidatorEscrowStatsResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list.map((0, _.ValidatorEscrowStatsInfoToJSON))
    };
}

},{"./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2O7kM":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorInfoFromJSON", ()=>ValidatorInfoFromJSON);
parcelHelpers.export(exports, "ValidatorInfoFromJSONTyped", ()=>ValidatorInfoFromJSONTyped);
parcelHelpers.export(exports, "ValidatorInfoToJSON", ()=>ValidatorInfoToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function ValidatorInfoFromJSON(json) {
    return ValidatorInfoFromJSONTyped(json, false);
}
function ValidatorInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'rank': json['rank'],
        'entityId': json['entityId'],
        'entityAddress': json['entityAddress'],
        'nodeId': json['nodeId'],
        'nodeAddress': json['nodeAddress'],
        'name': json['name'],
        'icon': json['icon'],
        'website': json['website'],
        'twitter': json['twitter'],
        'keybase': json['keybase'],
        'email': json['email'],
        'description': json['description'],
        'escrow': json['escrow'],
        'escrowChange24': json['escrowChange24'],
        'escrowPercent': json['escrowPercent'],
        'balance': json['balance'],
        'totalShares': json['totalShares'],
        'signs': json['signs'],
        'proposals': json['proposals'],
        'nonce': json['nonce'],
        'score': json['score'],
        'delegators': json['delegators'],
        'nodes': !(0, _runtime.exists)(json, 'nodes') ? undefined : json['nodes'],
        'uptime': json['uptime'],
        'active': json['active'],
        'commission': json['commission'],
        'bound': !(0, _runtime.exists)(json, 'bound') ? undefined : (0, _.BoundFromJSON)(json['bound']),
        'rates': json['rates'].map((0, _.RateFromJSON)),
        'bounds': json['bounds'].map((0, _.BoundFromJSON)),
        'escrowSharesStatus': !(0, _runtime.exists)(json, 'escrowSharesStatus') ? undefined : (0, _.EscrowStatusFromJSON)(json['escrowSharesStatus']),
        'escrowAmountStatus': !(0, _runtime.exists)(json, 'escrowAmountStatus') ? undefined : (0, _.EscrowStatusFromJSON)(json['escrowAmountStatus']),
        'runtimes': !(0, _runtime.exists)(json, 'runtimes') ? undefined : json['runtimes'].map((0, _.ValidatorRuntimeFromJSON)),
        'status': json['status']
    };
}
function ValidatorInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'rank': value.rank,
        'entityId': value.entityId,
        'entityAddress': value.entityAddress,
        'nodeId': value.nodeId,
        'nodeAddress': value.nodeAddress,
        'name': value.name,
        'icon': value.icon,
        'website': value.website,
        'twitter': value.twitter,
        'keybase': value.keybase,
        'email': value.email,
        'description': value.description,
        'escrow': value.escrow,
        'escrowChange24': value.escrowChange24,
        'escrowPercent': value.escrowPercent,
        'balance': value.balance,
        'totalShares': value.totalShares,
        'signs': value.signs,
        'proposals': value.proposals,
        'nonce': value.nonce,
        'score': value.score,
        'delegators': value.delegators,
        'nodes': value.nodes,
        'uptime': value.uptime,
        'active': value.active,
        'commission': value.commission,
        'bound': (0, _.BoundToJSON)(value.bound),
        'rates': value.rates.map((0, _.RateToJSON)),
        'bounds': value.bounds.map((0, _.BoundToJSON)),
        'escrowSharesStatus': (0, _.EscrowStatusToJSON)(value.escrowSharesStatus),
        'escrowAmountStatus': (0, _.EscrowStatusToJSON)(value.escrowAmountStatus),
        'runtimes': value.runtimes === undefined ? undefined : value.runtimes.map((0, _.ValidatorRuntimeToJSON)),
        'status': value.status
    };
}

},{"../runtime":"cHxeU","./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jJy2R":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorInfoRequestFromJSON", ()=>ValidatorInfoRequestFromJSON);
parcelHelpers.export(exports, "ValidatorInfoRequestFromJSONTyped", ()=>ValidatorInfoRequestFromJSONTyped);
parcelHelpers.export(exports, "ValidatorInfoRequestToJSON", ()=>ValidatorInfoRequestToJSON);
function ValidatorInfoRequestFromJSON(json) {
    return ValidatorInfoRequestFromJSONTyped(json, false);
}
function ValidatorInfoRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address']
    };
}
function ValidatorInfoRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9T8Oo":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorInfoResponseFromJSON", ()=>ValidatorInfoResponseFromJSON);
parcelHelpers.export(exports, "ValidatorInfoResponseFromJSONTyped", ()=>ValidatorInfoResponseFromJSONTyped);
parcelHelpers.export(exports, "ValidatorInfoResponseToJSON", ()=>ValidatorInfoResponseToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function ValidatorInfoResponseFromJSON(json) {
    return ValidatorInfoResponseFromJSONTyped(json, false);
}
function ValidatorInfoResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'rank': !(0, _runtime.exists)(json, 'rank') ? undefined : json['rank'],
        'entityId': !(0, _runtime.exists)(json, 'entityId') ? undefined : json['entityId'],
        'entityAddress': !(0, _runtime.exists)(json, 'entityAddress') ? undefined : json['entityAddress'],
        'nodeId': !(0, _runtime.exists)(json, 'nodeId') ? undefined : json['nodeId'],
        'nodeAddress': !(0, _runtime.exists)(json, 'nodeAddress') ? undefined : json['nodeAddress'],
        'name': !(0, _runtime.exists)(json, 'name') ? undefined : json['name'],
        'icon': !(0, _runtime.exists)(json, 'icon') ? undefined : json['icon'],
        'website': !(0, _runtime.exists)(json, 'website') ? undefined : json['website'],
        'twitter': !(0, _runtime.exists)(json, 'twitter') ? undefined : json['twitter'],
        'keybase': !(0, _runtime.exists)(json, 'keybase') ? undefined : json['keybase'],
        'email': !(0, _runtime.exists)(json, 'email') ? undefined : json['email'],
        'description': !(0, _runtime.exists)(json, 'description') ? undefined : json['description'],
        'escrow': !(0, _runtime.exists)(json, 'escrow') ? undefined : json['escrow'],
        'escrowChange24': !(0, _runtime.exists)(json, 'escrowChange24') ? undefined : json['escrowChange24'],
        'escrowPercent': !(0, _runtime.exists)(json, 'escrowPercent') ? undefined : json['escrowPercent'],
        'balance': !(0, _runtime.exists)(json, 'balance') ? undefined : json['balance'],
        'totalShares': !(0, _runtime.exists)(json, 'totalShares') ? undefined : json['totalShares'],
        'signs': !(0, _runtime.exists)(json, 'signs') ? undefined : json['signs'],
        'proposals': !(0, _runtime.exists)(json, 'proposals') ? undefined : json['proposals'],
        'nonce': !(0, _runtime.exists)(json, 'nonce') ? undefined : json['nonce'],
        'score': !(0, _runtime.exists)(json, 'score') ? undefined : json['score'],
        'delegators': !(0, _runtime.exists)(json, 'delegators') ? undefined : json['delegators'],
        'nodes': !(0, _runtime.exists)(json, 'nodes') ? undefined : json['nodes'],
        'uptime': !(0, _runtime.exists)(json, 'uptime') ? undefined : json['uptime'],
        'active': !(0, _runtime.exists)(json, 'active') ? undefined : json['active'],
        'commission': !(0, _runtime.exists)(json, 'commission') ? undefined : json['commission'],
        'bound': !(0, _runtime.exists)(json, 'bound') ? undefined : (0, _.BoundFromJSON)(json['bound']),
        'rates': !(0, _runtime.exists)(json, 'rates') ? undefined : json['rates'].map((0, _.RateFromJSON)),
        'bounds': !(0, _runtime.exists)(json, 'bounds') ? undefined : json['bounds'].map((0, _.BoundFromJSON)),
        'escrowSharesStatus': !(0, _runtime.exists)(json, 'escrowSharesStatus') ? undefined : (0, _.EscrowStatusFromJSON)(json['escrowSharesStatus']),
        'escrowAmountStatus': !(0, _runtime.exists)(json, 'escrowAmountStatus') ? undefined : (0, _.EscrowStatusFromJSON)(json['escrowAmountStatus']),
        'runtimes': !(0, _runtime.exists)(json, 'runtimes') ? undefined : json['runtimes'].map((0, _.ValidatorRuntimeFromJSON)),
        'status': !(0, _runtime.exists)(json, 'status') ? undefined : json['status']
    };
}
function ValidatorInfoResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'rank': value.rank,
        'entityId': value.entityId,
        'entityAddress': value.entityAddress,
        'nodeId': value.nodeId,
        'nodeAddress': value.nodeAddress,
        'name': value.name,
        'icon': value.icon,
        'website': value.website,
        'twitter': value.twitter,
        'keybase': value.keybase,
        'email': value.email,
        'description': value.description,
        'escrow': value.escrow,
        'escrowChange24': value.escrowChange24,
        'escrowPercent': value.escrowPercent,
        'balance': value.balance,
        'totalShares': value.totalShares,
        'signs': value.signs,
        'proposals': value.proposals,
        'nonce': value.nonce,
        'score': value.score,
        'delegators': value.delegators,
        'nodes': value.nodes,
        'uptime': value.uptime,
        'active': value.active,
        'commission': value.commission,
        'bound': (0, _.BoundToJSON)(value.bound),
        'rates': value.rates === undefined ? undefined : value.rates.map((0, _.RateToJSON)),
        'bounds': value.bounds === undefined ? undefined : value.bounds.map((0, _.BoundToJSON)),
        'escrowSharesStatus': (0, _.EscrowStatusToJSON)(value.escrowSharesStatus),
        'escrowAmountStatus': (0, _.EscrowStatusToJSON)(value.escrowAmountStatus),
        'runtimes': value.runtimes === undefined ? undefined : value.runtimes.map((0, _.ValidatorRuntimeToJSON)),
        'status': value.status
    };
}

},{"../runtime":"cHxeU","./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bjxsu":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorListRequestFromJSON", ()=>ValidatorListRequestFromJSON);
parcelHelpers.export(exports, "ValidatorListRequestFromJSONTyped", ()=>ValidatorListRequestFromJSONTyped);
parcelHelpers.export(exports, "ValidatorListRequestToJSON", ()=>ValidatorListRequestToJSON);
function ValidatorListRequestFromJSON(json) {
    return ValidatorListRequestFromJSONTyped(json, false);
}
function ValidatorListRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'orderBy': json['orderBy'],
        'sort': json['sort']
    };
}
function ValidatorListRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'orderBy': value.orderBy,
        'sort': value.sort
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1oDiX":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorListResponseFromJSON", ()=>ValidatorListResponseFromJSON);
parcelHelpers.export(exports, "ValidatorListResponseFromJSONTyped", ()=>ValidatorListResponseFromJSONTyped);
parcelHelpers.export(exports, "ValidatorListResponseToJSON", ()=>ValidatorListResponseToJSON);
var _ = require("./");
function ValidatorListResponseFromJSON(json) {
    return ValidatorListResponseFromJSONTyped(json, false);
}
function ValidatorListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'list': json['list'].map((0, _.ValidatorInfoFromJSON)),
        'active': json['active'],
        'inactive': json['inactive'],
        'delegators': json['delegators']
    };
}
function ValidatorListResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'list': value.list.map((0, _.ValidatorInfoToJSON)),
        'active': value.active,
        'inactive': value.inactive,
        'delegators': value.delegators
    };
}

},{"./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"82DDm":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorRuntimeFromJSON", ()=>ValidatorRuntimeFromJSON);
parcelHelpers.export(exports, "ValidatorRuntimeFromJSONTyped", ()=>ValidatorRuntimeFromJSONTyped);
parcelHelpers.export(exports, "ValidatorRuntimeToJSON", ()=>ValidatorRuntimeToJSON);
function ValidatorRuntimeFromJSON(json) {
    return ValidatorRuntimeFromJSONTyped(json, false);
}
function ValidatorRuntimeFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'name': json['name'],
        'id': json['id'],
        'online': json['online']
    };
}
function ValidatorRuntimeToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'name': value.name,
        'id': value.id,
        'online': value.online
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8i5aD":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorSignStatsInfoFromJSON", ()=>ValidatorSignStatsInfoFromJSON);
parcelHelpers.export(exports, "ValidatorSignStatsInfoFromJSONTyped", ()=>ValidatorSignStatsInfoFromJSONTyped);
parcelHelpers.export(exports, "ValidatorSignStatsInfoToJSON", ()=>ValidatorSignStatsInfoToJSON);
function ValidatorSignStatsInfoFromJSON(json) {
    return ValidatorSignStatsInfoFromJSONTyped(json, false);
}
function ValidatorSignStatsInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'dateTime': json['dateTime'],
        'expected': json['expected'],
        'actual': json['actual']
    };
}
function ValidatorSignStatsInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'dateTime': value.dateTime,
        'expected': value.expected,
        'actual': value.actual
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gL4XP":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorSignStatsRequestFromJSON", ()=>ValidatorSignStatsRequestFromJSON);
parcelHelpers.export(exports, "ValidatorSignStatsRequestFromJSONTyped", ()=>ValidatorSignStatsRequestFromJSONTyped);
parcelHelpers.export(exports, "ValidatorSignStatsRequestToJSON", ()=>ValidatorSignStatsRequestToJSON);
function ValidatorSignStatsRequestFromJSON(json) {
    return ValidatorSignStatsRequestFromJSONTyped(json, false);
}
function ValidatorSignStatsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address']
    };
}
function ValidatorSignStatsRequestToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hA0iK":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorSignStatsResponseFromJSON", ()=>ValidatorSignStatsResponseFromJSON);
parcelHelpers.export(exports, "ValidatorSignStatsResponseFromJSONTyped", ()=>ValidatorSignStatsResponseFromJSONTyped);
parcelHelpers.export(exports, "ValidatorSignStatsResponseToJSON", ()=>ValidatorSignStatsResponseToJSON);
var _ = require("./");
function ValidatorSignStatsResponseFromJSON(json) {
    return ValidatorSignStatsResponseFromJSONTyped(json, false);
}
function ValidatorSignStatsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'stats': json['stats'].map((0, _.ValidatorSignStatsInfoFromJSON)),
        'time': json['time']
    };
}
function ValidatorSignStatsResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'stats': value.stats.map((0, _.ValidatorSignStatsInfoToJSON)),
        'time': value.time
    };
}

},{"./":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1GEB3":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * 
 */ parcelHelpers.export(exports, "ChainApi", ()=>ChainApi);
var _runtime = require("../runtime");
var _models = require("../models");
class ChainApi extends _runtime.BaseAPI {
    /**
     */ async chainBlockInfoHandlerRaw(requestParameters) {
        if (requestParameters.height === null || requestParameters.height === undefined) throw new _runtime.RequiredError('height', 'Required parameter requestParameters.height was null or undefined when calling chainBlockInfoHandler.');
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/chain/block/{height}`.replace(`{${"height"}}`, encodeURIComponent(String(requestParameters.height))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ChainBlockInfoResponseFromJSON)(jsonValue));
    }
    /**
     */ async chainBlockInfoHandler(requestParameters) {
        const response = await this.chainBlockInfoHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async chainBlocksHandlerRaw(requestParameters) {
        if (requestParameters.page === null || requestParameters.page === undefined) throw new _runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling chainBlocksHandler.');
        if (requestParameters.size === null || requestParameters.size === undefined) throw new _runtime.RequiredError('size', 'Required parameter requestParameters.size was null or undefined when calling chainBlocksHandler.');
        const queryParameters = {};
        if (requestParameters.page !== undefined) queryParameters['page'] = requestParameters.page;
        if (requestParameters.size !== undefined) queryParameters['size'] = requestParameters.size;
        const headerParameters = {};
        const response = await this.request({
            path: `/chain/blocks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ChainBlocksResponseFromJSON)(jsonValue));
    }
    /**
     */ async chainBlocksHandler(requestParameters) {
        const response = await this.chainBlocksHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async chainMethodsHandlerRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/chain/methods`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ChainMethodsResponseFromJSON)(jsonValue));
    }
    /**
     */ async chainMethodsHandler() {
        const response = await this.chainMethodsHandlerRaw();
        return await response.value();
    }
    /**
     */ async chainProposedBlocksHandlerRaw(requestParameters) {
        if (requestParameters.page === null || requestParameters.page === undefined) throw new _runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling chainProposedBlocksHandler.');
        if (requestParameters.size === null || requestParameters.size === undefined) throw new _runtime.RequiredError('size', 'Required parameter requestParameters.size was null or undefined when calling chainProposedBlocksHandler.');
        const queryParameters = {};
        if (requestParameters.address !== undefined) queryParameters['address'] = requestParameters.address;
        if (requestParameters.page !== undefined) queryParameters['page'] = requestParameters.page;
        if (requestParameters.size !== undefined) queryParameters['size'] = requestParameters.size;
        const headerParameters = {};
        const response = await this.request({
            path: `/chain/proposedblocks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ChainProposedBlocksResponseFromJSON)(jsonValue));
    }
    /**
     */ async chainProposedBlocksHandler(requestParameters) {
        const response = await this.chainProposedBlocksHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async chainSearchHandlerRaw(requestParameters) {
        if (requestParameters.key === null || requestParameters.key === undefined) throw new _runtime.RequiredError('key', 'Required parameter requestParameters.key was null or undefined when calling chainSearchHandler.');
        const queryParameters = {};
        if (requestParameters.key !== undefined) queryParameters['key'] = requestParameters.key;
        const headerParameters = {};
        const response = await this.request({
            path: `/chain/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ChainSearchResponseFromJSON)(jsonValue));
    }
    /**
     */ async chainSearchHandler(requestParameters) {
        const response = await this.chainSearchHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async chainTransactionInfoHandlerRaw(requestParameters) {
        if (requestParameters.hash === null || requestParameters.hash === undefined) throw new _runtime.RequiredError('hash', 'Required parameter requestParameters.hash was null or undefined when calling chainTransactionInfoHandler.');
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/chain/transaction/{hash}`.replace(`{${"hash"}}`, encodeURIComponent(String(requestParameters.hash))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ChainTransactionInfoResponseFromJSON)(jsonValue.data));
    }
    /**
     */ async chainTransactionInfoHandler(requestParameters) {
        const response = await this.chainTransactionInfoHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async chainTransactionsHandlerRaw(requestParameters) {
        if (requestParameters.runtime === null || requestParameters.runtime === undefined) throw new _runtime.RequiredError('runtime', 'Required parameter requestParameters.runtime was null or undefined when calling chainTransactionsHandler.');
        if (requestParameters.page === null || requestParameters.page === undefined) throw new _runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling chainTransactionsHandler.');
        if (requestParameters.size === null || requestParameters.size === undefined) throw new _runtime.RequiredError('size', 'Required parameter requestParameters.size was null or undefined when calling chainTransactionsHandler.');
        const queryParameters = {};
        if (requestParameters.height !== undefined) queryParameters['height'] = requestParameters.height;
        if (requestParameters.address !== undefined) queryParameters['address'] = requestParameters.address;
        if (requestParameters.method !== undefined) queryParameters['method'] = requestParameters.method;
        if (requestParameters.runtime !== undefined) queryParameters['runtime'] = requestParameters.runtime;
        if (requestParameters.page !== undefined) queryParameters['page'] = requestParameters.page;
        if (requestParameters.size !== undefined) queryParameters['size'] = requestParameters.size;
        const headerParameters = {};
        const response = await this.request({
            path: `/chain/transactions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ChainTransactionsResponseFromJSON)(jsonValue.data));
    }
    /**
     */ async chainTransactionsHandler(requestParameters) {
        const response = await this.chainTransactionsHandlerRaw(requestParameters);
        return await response.value();
    }
}

},{"../runtime":"cHxeU","../models":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2l0CZ":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * 
 */ parcelHelpers.export(exports, "CommonApi", ()=>CommonApi);
var _runtime = require("../runtime");
var _models = require("../models");
class CommonApi extends _runtime.BaseAPI {
    /**
     */ async healthHandlerRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/health`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response);
    }
    /**
     */ async healthHandler() {
        const response = await this.healthHandlerRaw();
        return await response.value();
    }
    /**
     */ async networkStatusHandlerRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/network/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.NetworkStatusResponseFromJSON)(jsonValue));
    }
    /**
     */ async networkStatusHandler() {
        const response = await this.networkStatusHandlerRaw();
        return await response.value();
    }
    /**
     */ async networkTrendHandlerRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/trend`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.NetworkTrendResponseFromJSON)(jsonValue));
    }
    /**
     */ async networkTrendHandler() {
        const response = await this.networkTrendHandlerRaw();
        return await response.value();
    }
}

},{"../runtime":"cHxeU","../models":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"g9w9e":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * 
 */ parcelHelpers.export(exports, "GovernanceApi", ()=>GovernanceApi);
var _runtime = require("../runtime");
var _models = require("../models");
class GovernanceApi extends _runtime.BaseAPI {
    /**
     */ async governanceProposalListHandlerRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/governance/proposallist`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.GovernanceProposalListResponseFromJSON)(jsonValue));
    }
    /**
     */ async governanceProposalListHandler() {
        const response = await this.governanceProposalListHandlerRaw();
        return await response.value();
    }
    /**
     */ async governanceProposalWithVotesHandlerRaw(requestParameters) {
        if (requestParameters.id === null || requestParameters.id === undefined) throw new _runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling governanceProposalWithVotesHandler.');
        const queryParameters = {};
        if (requestParameters.id !== undefined) queryParameters['id'] = requestParameters.id;
        const headerParameters = {};
        const response = await this.request({
            path: `/governance/proposalwithvotes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.GovernanceProposalWithVotesResponseFromJSON)(jsonValue));
    }
    /**
     */ async governanceProposalWithVotesHandler(requestParameters) {
        const response = await this.governanceProposalWithVotesHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async governanceVotesHandlerRaw(requestParameters) {
        if (requestParameters.page === null || requestParameters.page === undefined) throw new _runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling governanceVotesHandler.');
        if (requestParameters.size === null || requestParameters.size === undefined) throw new _runtime.RequiredError('size', 'Required parameter requestParameters.size was null or undefined when calling governanceVotesHandler.');
        const queryParameters = {};
        if (requestParameters.proposalId !== undefined) queryParameters['proposalId'] = requestParameters.proposalId;
        if (requestParameters.validator !== undefined) queryParameters['validator'] = requestParameters.validator;
        if (requestParameters.page !== undefined) queryParameters['page'] = requestParameters.page;
        if (requestParameters.size !== undefined) queryParameters['size'] = requestParameters.size;
        const headerParameters = {};
        const response = await this.request({
            path: `/governance/votes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.GovernanceVotesResponseFromJSON)(jsonValue));
    }
    /**
     */ async governanceVotesHandler(requestParameters) {
        const response = await this.governanceVotesHandlerRaw(requestParameters);
        return await response.value();
    }
}

},{"../runtime":"cHxeU","../models":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"l9RfY":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * 
 */ parcelHelpers.export(exports, "MarketApi", ()=>MarketApi);
var _runtime = require("../runtime");
var _models = require("../models");
class MarketApi extends _runtime.BaseAPI {
    /**
     */ async marketChartHandlerRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/market/chart`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.MarketChartResponseFromJSON)(jsonValue));
    }
    /**
     */ async marketChartHandler() {
        const response = await this.marketChartHandlerRaw();
        return await response.value();
    }
    /**
     */ async marketInfoHandlerRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/market/info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.MarketInfoResponseFromJSON)(jsonValue));
    }
    /**
     */ async marketInfoHandler() {
        const response = await this.marketInfoHandlerRaw();
        return await response.value();
    }
}

},{"../runtime":"cHxeU","../models":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1JnMI":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * 
 */ parcelHelpers.export(exports, "RuntimeApi", ()=>RuntimeApi);
var _runtime = require("../runtime");
var _models = require("../models");
class RuntimeApi extends _runtime.BaseAPI {
    /**
     */ async runtimeListHandlerRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/runtime/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.RuntimeListResponseFromJSON)(jsonValue));
    }
    /**
     */ async runtimeListHandler() {
        const response = await this.runtimeListHandlerRaw();
        return await response.value();
    }
    /**
     */ async runtimeRoundInfoHandlerRaw(requestParameters) {
        if (requestParameters.id === null || requestParameters.id === undefined) throw new _runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling runtimeRoundInfoHandler.');
        if (requestParameters.round === null || requestParameters.round === undefined) throw new _runtime.RequiredError('round', 'Required parameter requestParameters.round was null or undefined when calling runtimeRoundInfoHandler.');
        const queryParameters = {};
        if (requestParameters.id !== undefined) queryParameters['id'] = requestParameters.id;
        if (requestParameters.round !== undefined) queryParameters['round'] = requestParameters.round;
        const headerParameters = {};
        const response = await this.request({
            path: `/runtime/round/info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.RuntimeRoundInfoResponseFromJSON)(jsonValue));
    }
    /**
     */ async runtimeRoundInfoHandler(requestParameters) {
        const response = await this.runtimeRoundInfoHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async runtimeRoundListHandlerRaw(requestParameters) {
        if (requestParameters.id === null || requestParameters.id === undefined) throw new _runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling runtimeRoundListHandler.');
        if (requestParameters.page === null || requestParameters.page === undefined) throw new _runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling runtimeRoundListHandler.');
        if (requestParameters.size === null || requestParameters.size === undefined) throw new _runtime.RequiredError('size', 'Required parameter requestParameters.size was null or undefined when calling runtimeRoundListHandler.');
        const queryParameters = {};
        if (requestParameters.id !== undefined) queryParameters['id'] = requestParameters.id;
        if (requestParameters.page !== undefined) queryParameters['page'] = requestParameters.page;
        if (requestParameters.size !== undefined) queryParameters['size'] = requestParameters.size;
        const headerParameters = {};
        const response = await this.request({
            path: `/runtime/round/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.RuntimeRoundListResponseFromJSON)(jsonValue));
    }
    /**
     */ async runtimeRoundListHandler(requestParameters) {
        const response = await this.runtimeRoundListHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async runtimeStatsHandlerRaw(requestParameters) {
        if (requestParameters.id === null || requestParameters.id === undefined) throw new _runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling runtimeStatsHandler.');
        const queryParameters = {};
        if (requestParameters.id !== undefined) queryParameters['id'] = requestParameters.id;
        const headerParameters = {};
        const response = await this.request({
            path: `/runtime/stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.RuntimeStatsResponseFromJSON)(jsonValue));
    }
    /**
     */ async runtimeStatsHandler(requestParameters) {
        const response = await this.runtimeStatsHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async runtimeTransactionInfoHandlerRaw(requestParameters) {
        if (requestParameters.id === null || requestParameters.id === undefined) throw new _runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling runtimeTransactionInfoHandler.');
        if (requestParameters.round === null || requestParameters.round === undefined) throw new _runtime.RequiredError('round', 'Required parameter requestParameters.round was null or undefined when calling runtimeTransactionInfoHandler.');
        if (requestParameters.hash === null || requestParameters.hash === undefined) throw new _runtime.RequiredError('hash', 'Required parameter requestParameters.hash was null or undefined when calling runtimeTransactionInfoHandler.');
        const queryParameters = {};
        if (requestParameters.id !== undefined) queryParameters['id'] = requestParameters.id;
        if (requestParameters.round !== undefined) queryParameters['round'] = requestParameters.round;
        if (requestParameters.hash !== undefined) queryParameters['hash'] = requestParameters.hash;
        const headerParameters = {};
        const response = await this.request({
            path: `/runtime/transaction/info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.RuntimeTransactionInfoResponseFromJSON)(jsonValue.data));
    }
    /**
     */ async runtimeTransactionInfoHandler(requestParameters) {
        const response = await this.runtimeTransactionInfoHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async runtimeTransactionListHandlerRaw(requestParameters) {
        if (requestParameters.page === null || requestParameters.page === undefined) throw new _runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling runtimeTransactionListHandler.');
        if (requestParameters.size === null || requestParameters.size === undefined) throw new _runtime.RequiredError('size', 'Required parameter requestParameters.size was null or undefined when calling runtimeTransactionListHandler.');
        const queryParameters = {};
        if (requestParameters.id !== undefined) queryParameters['id'] = requestParameters.id;
        if (requestParameters.address !== undefined) queryParameters['address'] = requestParameters.address;
        if (requestParameters.round !== undefined) queryParameters['round'] = requestParameters.round;
        if (requestParameters.page !== undefined) queryParameters['page'] = requestParameters.page;
        if (requestParameters.size !== undefined) queryParameters['size'] = requestParameters.size;
        const headerParameters = {};
        const response = await this.request({
            path: `/runtime/transaction/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.RuntimeTransactionListResponseFromJSON)(jsonValue));
    }
    /**
     */ async runtimeTransactionListHandler(requestParameters) {
        const response = await this.runtimeTransactionListHandlerRaw(requestParameters);
        return await response.value();
    }
}

},{"../runtime":"cHxeU","../models":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gYXph":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * 
 */ parcelHelpers.export(exports, "ValidatorApi", ()=>ValidatorApi);
var _runtime = require("../runtime");
var _models = require("../models");
class ValidatorApi extends _runtime.BaseAPI {
    /**
     */ async delegatorsHandlerRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling delegatorsHandler.');
        if (requestParameters.page === null || requestParameters.page === undefined) throw new _runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling delegatorsHandler.');
        if (requestParameters.size === null || requestParameters.size === undefined) throw new _runtime.RequiredError('size', 'Required parameter requestParameters.size was null or undefined when calling delegatorsHandler.');
        const queryParameters = {};
        if (requestParameters.address !== undefined) queryParameters['address'] = requestParameters.address;
        if (requestParameters.page !== undefined) queryParameters['page'] = requestParameters.page;
        if (requestParameters.size !== undefined) queryParameters['size'] = requestParameters.size;
        const headerParameters = {};
        const response = await this.request({
            path: `/validator/delegators`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.DelegatorsResponseFromJSON)(jsonValue));
    }
    /**
     */ async delegatorsHandler(requestParameters) {
        const response = await this.delegatorsHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async validatorBlocksStatsHandlerRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling validatorBlocksStatsHandler.');
        const queryParameters = {};
        if (requestParameters.address !== undefined) queryParameters['address'] = requestParameters.address;
        const headerParameters = {};
        const response = await this.request({
            path: `/validator/blocksstats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ValidatorBlocksStatsResponseFromJSON)(jsonValue));
    }
    /**
     */ async validatorBlocksStatsHandler(requestParameters) {
        const response = await this.validatorBlocksStatsHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async validatorEscrowEventHandlerRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling validatorEscrowEventHandler.');
        if (requestParameters.page === null || requestParameters.page === undefined) throw new _runtime.RequiredError('page', 'Required parameter requestParameters.page was null or undefined when calling validatorEscrowEventHandler.');
        if (requestParameters.size === null || requestParameters.size === undefined) throw new _runtime.RequiredError('size', 'Required parameter requestParameters.size was null or undefined when calling validatorEscrowEventHandler.');
        const queryParameters = {};
        if (requestParameters.address !== undefined) queryParameters['address'] = requestParameters.address;
        if (requestParameters.page !== undefined) queryParameters['page'] = requestParameters.page;
        if (requestParameters.size !== undefined) queryParameters['size'] = requestParameters.size;
        const headerParameters = {};
        const response = await this.request({
            path: `/validator/escrowevent`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ValidatorEscrowEventResponseFromJSON)(jsonValue));
    }
    /**
     */ async validatorEscrowEventHandler(requestParameters) {
        const response = await this.validatorEscrowEventHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async validatorEscrowStatsHandlerRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling validatorEscrowStatsHandler.');
        const queryParameters = {};
        if (requestParameters.address !== undefined) queryParameters['address'] = requestParameters.address;
        const headerParameters = {};
        const response = await this.request({
            path: `/validator/escrowstats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ValidatorEscrowStatsResponseFromJSON)(jsonValue));
    }
    /**
     */ async validatorEscrowStatsHandler(requestParameters) {
        const response = await this.validatorEscrowStatsHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async validatorInfoHandlerRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling validatorInfoHandler.');
        const queryParameters = {};
        if (requestParameters.address !== undefined) queryParameters['address'] = requestParameters.address;
        const headerParameters = {};
        const response = await this.request({
            path: `/validator/info`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ValidatorInfoResponseFromJSON)(jsonValue));
    }
    /**
     */ async validatorInfoHandler(requestParameters) {
        const response = await this.validatorInfoHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async validatorListHandlerRaw(requestParameters) {
        if (requestParameters.orderBy === null || requestParameters.orderBy === undefined) throw new _runtime.RequiredError('orderBy', 'Required parameter requestParameters.orderBy was null or undefined when calling validatorListHandler.');
        if (requestParameters.sort === null || requestParameters.sort === undefined) throw new _runtime.RequiredError('sort', 'Required parameter requestParameters.sort was null or undefined when calling validatorListHandler.');
        const queryParameters = {};
        if (requestParameters.orderBy !== undefined) queryParameters['orderBy'] = requestParameters.orderBy;
        if (requestParameters.sort !== undefined) queryParameters['sort'] = requestParameters.sort;
        const headerParameters = {};
        const response = await this.request({
            path: `/validator/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ValidatorListResponseFromJSON)(jsonValue.data));
    }
    /**
     */ async validatorListHandler(requestParameters) {
        const response = await this.validatorListHandlerRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async validatorSignStatsHandlerRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling validatorSignStatsHandler.');
        const queryParameters = {};
        if (requestParameters.address !== undefined) queryParameters['address'] = requestParameters.address;
        const headerParameters = {};
        const response = await this.request({
            path: `/validator/signstats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ValidatorSignStatsResponseFromJSON)(jsonValue));
    }
    /**
     */ async validatorSignStatsHandler(requestParameters) {
        const response = await this.validatorSignStatsHandlerRaw(requestParameters);
        return await response.value();
    }
}

},{"../runtime":"cHxeU","../models":"dB6QC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9Czgc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNexusAPIs", ()=>getNexusAPIs);
parcelHelpers.export(exports, "parseValidatorsList", ()=>parseValidatorsList);
parcelHelpers.export(exports, "parseDelegations", ()=>parseDelegations);
parcelHelpers.export(exports, "transactionMethodMap", ()=>transactionMethodMap);
parcelHelpers.export(exports, "parseDebonding", ()=>parseDebonding);
var _index = require("vendors/nexus/index");
var _types = require("app/state/transaction/types");
var _helpers = require("./helpers");
var _helpers1 = require("app/lib/helpers");
var _config = require("../config");
function getNexusAPIs(url) {
    const explorerConfig = new (0, _index.Configuration)({
        basePath: url,
        ...(0, _helpers.throwAPIErrors)
    });
    const api = new (0, _index.DefaultApi)(explorerConfig);
    async function getAccount(address) {
        const account = await api.consensusAccountsAddressGet({
            address
        });
        if (!account) throw new Error('Wrong response code');
        return parseAccount(account);
    }
    async function getAllValidators() {
        const validatorsResponse = await api.consensusValidatorsGet({
            limit: 1000
        });
        if (!validatorsResponse) throw new Error('Wrong response code');
        return parseValidatorsList(validatorsResponse.validators);
    }
    function extendRuntimeTransaction(runtime, runtimeTransaction) {
        const config = runtime === (0, _index.Runtime).Sapphire ? (0, _config.paraTimesConfig).sapphire : runtime === (0, _index.Runtime).Emerald ? (0, _config.paraTimesConfig).emerald : undefined;
        return {
            ...runtimeTransaction,
            decimals: config?.decimals || (0, _config.consensusDecimals),
            runtimeId: runtime,
            runtimeName: runtime.charAt(0).toUpperCase() + runtime.slice(1)
        };
    }
    function mergeTransactions(limit, ...responses) {
        const mergedList = responses.flat();
        mergedList.sort((a, b)=>new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
        return mergedList.slice(0, limit);
    }
    async function getTransactionsList(params) {
        try {
            const [consensusResponse, sapphireResponse, emeraldResponse] = await Promise.all([
                api.consensusTransactionsGet({
                    rel: params.accountId,
                    limit: params.limit
                }),
                api.runtimeTransactionsGet({
                    runtime: (0, _index.Runtime).Sapphire,
                    rel: params.accountId,
                    limit: params.limit
                }),
                api.runtimeTransactionsGet({
                    runtime: (0, _index.Runtime).Emerald,
                    rel: params.accountId,
                    limit: params.limit
                })
            ]);
            const extendedSapphireResponse = sapphireResponse.transactions.map((runtimeTransaction)=>extendRuntimeTransaction((0, _index.Runtime).Sapphire, runtimeTransaction));
            const extendedEmeraldResponse = emeraldResponse.transactions.map((runtimeTransaction)=>extendRuntimeTransaction((0, _index.Runtime).Emerald, runtimeTransaction));
            const mergedTransactions = mergeTransactions(params.limit, consensusResponse.transactions, extendedSapphireResponse, extendedEmeraldResponse);
            // Temporary workaround for missing amount in staking.ReclaimEscrow
            const transactionsWithFixedAmount = await Promise.all(mergedTransactions.map(async (transaction)=>{
                if (transaction.method === (0, _index.ConsensusTxMethod).StakingReclaimEscrow && transaction.success) {
                    const eventsResponse = await api.consensusEventsGet({
                        limit: 1,
                        txHash: transaction.hash,
                        type: (0, _index.ConsensusEventType).StakingEscrowDebondingStart
                    });
                    const amount = eventsResponse.events[0]?.body?.amount;
                    return {
                        ...transaction,
                        body: {
                            ...transaction.body,
                            amount
                        }
                    };
                }
                return {
                    ...transaction
                };
            }));
            return parseTransactionsList(transactionsWithFixedAmount);
        } catch (error) {
            console.error('Could not fetch Nexus', error);
            throw error;
        }
    }
    async function getDelegations(params) {
        const delegations = await api.consensusAccountsAddressDelegationsGet({
            address: params.accountId
        });
        const debonding = await api.consensusAccountsAddressDebondingDelegationsGet({
            address: params.accountId
        });
        if (!delegations) throw new Error('Wrong response code');
        if (!debonding) throw new Error('Wrong response code');
        return {
            delegations: parseDelegations(delegations.delegations),
            debonding: parseDebonding(debonding.debonding_delegations)
        };
    }
    return {
        getAccount,
        getAllValidators,
        getTransactionsList,
        getDelegations
    };
}
function parseAccount(account) {
    const total = (BigInt(account.available) + BigInt(account.delegations_balance) + BigInt(account.debonding_delegations_balance)).toString();
    return {
        address: account.address,
        allowances: account.allowances.map((allowance)=>({
                address: allowance.address,
                amount: allowance.amount
            })),
        available: account.available,
        delegations: account.delegations_balance,
        debonding: account.debonding_delegations_balance,
        total,
        nonce: BigInt(account.nonce ?? 0).toString()
    };
}
function parseValidatorsList(validators) {
    return validators.map((v)=>{
        const parsed = {
            address: v.entity_address,
            name: v.media?.name ?? undefined,
            escrow: v.escrow.active_balance,
            current_rate: v.current_rate / 100000,
            status: v.active ? 'active' : 'inactive',
            media: {
                email_address: v.media?.email ?? undefined,
                logotype: v.media?.logoUrl ?? undefined,
                twitter_acc: v.media?.twitter ?? undefined,
                website_link: v.media?.url ?? undefined
            },
            rank: v.rank
        };
        return parsed;
    });
}
function parseDelegations(delegations) {
    return delegations.map((delegation)=>{
        const parsed = {
            amount: delegation.amount,
            shares: delegation.shares,
            validatorAddress: delegation.validator
        };
        return parsed;
    });
}
function getTransactionType(method) {
    const type = transactionMethodMap[method];
    // Not handled mappings are rendered as unrecognizedTransaction
    return type ?? method;
}
const transactionMethodMap = {
    [(0, _index.ConsensusTxMethod).StakingTransfer]: (0, _types.TransactionType).StakingTransfer,
    [(0, _index.ConsensusTxMethod).StakingAddEscrow]: (0, _types.TransactionType).StakingAddEscrow,
    [(0, _index.ConsensusTxMethod).StakingReclaimEscrow]: (0, _types.TransactionType).StakingReclaimEscrow,
    [(0, _index.ConsensusTxMethod).StakingAmendCommissionSchedule]: (0, _types.TransactionType).StakingAmendCommissionSchedule,
    [(0, _index.ConsensusTxMethod).StakingAllow]: (0, _types.TransactionType).StakingAllow,
    [(0, _index.ConsensusTxMethod).StakingWithdraw]: (0, _types.TransactionType).StakingWithdraw,
    [(0, _index.ConsensusTxMethod).StakingBurn]: (0, _types.TransactionType).StakingBurn,
    [(0, _index.ConsensusTxMethod).RoothashExecutorCommit]: (0, _types.TransactionType).RoothashExecutorCommit,
    [(0, _index.ConsensusTxMethod).RoothashExecutorProposerTimeout]: (0, _types.TransactionType).RoothashExecutorProposerTimeout,
    [(0, _index.ConsensusTxMethod).RoothashSubmitMsg]: (0, _types.TransactionType).RoothashSubmitMsg,
    [(0, _index.ConsensusTxMethod).RegistryDeregisterEntity]: (0, _types.TransactionType).RegistryDeregisterEntity,
    [(0, _index.ConsensusTxMethod).RegistryRegisterEntity]: (0, _types.TransactionType).RegistryRegisterEntity,
    [(0, _index.ConsensusTxMethod).RegistryRegisterNode]: (0, _types.TransactionType).RegistryRegisterNode,
    [(0, _index.ConsensusTxMethod).RegistryRegisterRuntime]: (0, _types.TransactionType).RegistryRegisterRuntime,
    [(0, _index.ConsensusTxMethod).RegistryUnfreezeNode]: (0, _types.TransactionType).RegistryUnfreezeNode,
    [(0, _index.ConsensusTxMethod).GovernanceCastVote]: (0, _types.TransactionType).GovernanceCastVote,
    [(0, _index.ConsensusTxMethod).GovernanceSubmitProposal]: (0, _types.TransactionType).GovernanceSubmitProposal,
    [(0, _index.ConsensusTxMethod).BeaconPvssCommit]: (0, _types.TransactionType).BeaconPvssCommit,
    [(0, _index.ConsensusTxMethod).BeaconPvssReveal]: (0, _types.TransactionType).BeaconPvssReveal,
    [(0, _index.ConsensusTxMethod).BeaconVrfProve]: (0, _types.TransactionType).BeaconVrfProve,
    [(0, _index.ConsensusTxMethod).ConsensusMeta]: (0, _types.TransactionType).ConsensusMeta,
    [(0, _index.ConsensusTxMethod).VaultCreate]: (0, _types.TransactionType).VaultCreate
};
function parseTransactionsList(list) {
    return list.map((t)=>{
        if ('round' in t) {
            const transactionDate = new Date(t.timestamp);
            const parsed = {
                amount: t.amount ? (0, _helpers1.removeTrailingZeros)(t.amount, t.decimals - (0, _config.consensusDecimals)) : undefined,
                fee: t.fee ? (0, _helpers1.removeTrailingZeros)(t.fee, t.decimals - (0, _config.consensusDecimals)) : undefined,
                from: t.sender_0_eth || t.sender_0,
                hash: t.hash,
                level: undefined,
                status: t.success === undefined ? (0, _types.TransactionStatus).Pending : t.success ? (0, _types.TransactionStatus).Successful : (0, _types.TransactionStatus).Failed,
                timestamp: transactionDate.getTime(),
                to: t.to_eth ?? t.to ?? t.body?.to ?? undefined,
                type: getTransactionType(t.method),
                runtimeName: t.runtimeName,
                runtimeId: t.runtimeId,
                round: t.round,
                nonce: BigInt(t.nonce_0).toString()
            };
            return parsed;
        } else {
            const transactionDate = new Date(t.timestamp);
            const parsed = {
                amount: t.body?.amount || t.body?.amount_change && (t.body?.negative ? `-${t.body.amount_change}` : t.body.amount_change) || undefined,
                fee: t.fee,
                from: t.sender,
                hash: t.hash,
                level: t.block,
                status: t.success ? (0, _types.TransactionStatus).Successful : (0, _types.TransactionStatus).Failed,
                timestamp: transactionDate.getTime(),
                to: t.body?.to || t.body?.beneficiary || t.body?.account || undefined,
                type: getTransactionType(t.method),
                runtimeName: undefined,
                runtimeId: undefined,
                round: undefined,
                nonce: BigInt(t.nonce).toString()
            };
            return parsed;
        }
    });
}
function parseDebonding(debonding) {
    return debonding.map((debonding)=>{
        const parsed = {
            amount: debonding.shares,
            shares: debonding.shares,
            validatorAddress: debonding.validator,
            epoch: debonding.debond_end
        };
        return parsed;
    });
}

},{"vendors/nexus/index":"6XqvA","app/state/transaction/types":"idhb9","./helpers":"f9DGv","app/lib/helpers":"bUnFy","../config":"akiw0","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6XqvA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _runtime = require("./runtime");
parcelHelpers.exportAll(_runtime, exports);
var _apis = require("./apis");
parcelHelpers.exportAll(_apis, exports);
var _models = require("./models");
parcelHelpers.exportAll(_models, exports);

},{"./runtime":"ecR7o","./apis":"7sGAS","./models":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ecR7o":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BASE_PATH", ()=>BASE_PATH);
/**
 * This is the base class for all generated API classes.
 */ parcelHelpers.export(exports, "BaseAPI", ()=>BaseAPI);
parcelHelpers.export(exports, "RequiredError", ()=>RequiredError);
parcelHelpers.export(exports, "COLLECTION_FORMATS", ()=>COLLECTION_FORMATS);
parcelHelpers.export(exports, "Configuration", ()=>Configuration);
parcelHelpers.export(exports, "exists", ()=>exists);
parcelHelpers.export(exports, "querystring", ()=>querystring);
parcelHelpers.export(exports, "mapValues", ()=>mapValues);
parcelHelpers.export(exports, "canConsumeForm", ()=>canConsumeForm);
parcelHelpers.export(exports, "JSONApiResponse", ()=>JSONApiResponse);
parcelHelpers.export(exports, "VoidApiResponse", ()=>VoidApiResponse);
parcelHelpers.export(exports, "BlobApiResponse", ()=>BlobApiResponse);
parcelHelpers.export(exports, "TextApiResponse", ()=>TextApiResponse);
const BASE_PATH = "https://nexus.oasis.io/v1".replace(/\/+$/, "");
const isBlob = (value)=>typeof Blob !== 'undefined' && value instanceof Blob;
class BaseAPI {
    constructor(configuration = new Configuration()){
        this.configuration = configuration;
        this.fetchApi = async (url, init)=>{
            let fetchParams = {
                url,
                init
            };
            for (const middleware of this.middleware)if (middleware.pre) fetchParams = await middleware.pre({
                fetch: this.fetchApi,
                ...fetchParams
            }) || fetchParams;
            let response = await this.configuration.fetchApi(fetchParams.url, fetchParams.init);
            for (const middleware of this.middleware)if (middleware.post) response = await middleware.post({
                fetch: this.fetchApi,
                url,
                init,
                response: response.clone()
            }) || response;
            return response;
        };
        this.middleware = configuration.middleware;
    }
    withMiddleware(...middlewares) {
        const next = this.clone();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }
    withPreMiddleware(...preMiddlewares) {
        const middlewares = preMiddlewares.map((pre)=>({
                pre
            }));
        return this.withMiddleware(...middlewares);
    }
    withPostMiddleware(...postMiddlewares) {
        const middlewares = postMiddlewares.map((post)=>({
                post
            }));
        return this.withMiddleware(...middlewares);
    }
    async request(context) {
        const { url, init } = this.createFetchParams(context);
        const response = await this.fetchApi(url, init);
        if (response.status >= 200 && response.status < 300) return response;
        throw response;
    }
    createFetchParams(context) {
        let url = this.configuration.basePath + context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) // only add the querystring to the URL if there are query parameters.
        // this is done to avoid urls ending with a "?" character which buggy webservers
        // do not handle correctly sometimes.
        url += '?' + this.configuration.queryParamsStringify(context.query);
        const body = typeof FormData !== "undefined" && context.body instanceof FormData || context.body instanceof URLSearchParams || isBlob(context.body) ? context.body : JSON.stringify(context.body);
        const headers = Object.assign({}, this.configuration.headers, context.headers);
        const init = {
            method: context.method,
            headers: headers,
            body,
            credentials: this.configuration.credentials
        };
        return {
            url,
            init
        };
    }
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */ clone() {
        const constructor = this.constructor;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
}
class RequiredError extends Error {
    constructor(field, msg){
        super(msg), this.field = field, this.name = "RequiredError";
    }
}
const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|"
};
class Configuration {
    constructor(configuration = {}){
        this.configuration = configuration;
    }
    get basePath() {
        return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
    }
    get fetchApi() {
        return this.configuration.fetchApi || window.fetch.bind(window);
    }
    get middleware() {
        return this.configuration.middleware || [];
    }
    get queryParamsStringify() {
        return this.configuration.queryParamsStringify || querystring;
    }
    get username() {
        return this.configuration.username;
    }
    get password() {
        return this.configuration.password;
    }
    get apiKey() {
        const apiKey = this.configuration.apiKey;
        if (apiKey) return typeof apiKey === 'function' ? apiKey : ()=>apiKey;
        return undefined;
    }
    get accessToken() {
        const accessToken = this.configuration.accessToken;
        if (accessToken) return typeof accessToken === 'function' ? accessToken : ()=>accessToken;
        return undefined;
    }
    get headers() {
        return this.configuration.headers;
    }
    get credentials() {
        return this.configuration.credentials;
    }
}
function exists(json, key) {
    const value = json[key];
    return value !== null && value !== undefined;
}
function querystring(params, prefix = '') {
    return Object.keys(params).map((key)=>{
        const fullKey = prefix + (prefix.length ? `[${key}]` : key);
        const value = params[key];
        if (value instanceof Array) {
            const multiValue = value.map((singleValue)=>encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
            return `${encodeURIComponent(fullKey)}=${multiValue}`;
        }
        if (value instanceof Date) return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
        if (value instanceof Object) return querystring(value, fullKey);
        return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
    }).filter((part)=>part.length > 0).join('&');
}
function mapValues(data, fn) {
    return Object.keys(data).reduce((acc, key)=>({
            ...acc,
            [key]: fn(data[key])
        }), {});
}
function canConsumeForm(consumes) {
    for (const consume of consumes){
        if ('multipart/form-data' === consume.contentType) return true;
    }
    return false;
}
class JSONApiResponse {
    constructor(raw, transformer = (jsonValue)=>jsonValue){
        this.raw = raw;
        this.transformer = transformer;
    }
    async value() {
        return this.transformer(await this.raw.json());
    }
}
class VoidApiResponse {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return undefined;
    }
}
class BlobApiResponse {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return await this.raw.blob();
    }
}
class TextApiResponse {
    constructor(raw){
        this.raw = raw;
    }
    async value() {
        return await this.raw.text();
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7sGAS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _defaultApi = require("./DefaultApi");
parcelHelpers.exportAll(_defaultApi, exports);

},{"./DefaultApi":"2XX8B","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2XX8B":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * 
 */ parcelHelpers.export(exports, "DefaultApi", ()=>DefaultApi);
parcelHelpers.export(exports, "RuntimeEvmTokensGetSortByEnum", ()=>RuntimeEvmTokensGetSortByEnum);
var _runtime = require("../runtime");
var _models = require("../models");
class DefaultApi extends _runtime.BaseAPI {
    /**
     * Returns an account\'s debonding delegations.
     */ async consensusAccountsAddressDebondingDelegationsGetRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling consensusAccountsAddressDebondingDelegationsGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/accounts/{address}/debonding_delegations`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.DebondingDelegationListFromJSON)(jsonValue));
    }
    /**
     * Returns an account\'s debonding delegations.
     */ async consensusAccountsAddressDebondingDelegationsGet(requestParameters) {
        const response = await this.consensusAccountsAddressDebondingDelegationsGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a list of debonding delegations to an account.
     */ async consensusAccountsAddressDebondingDelegationsToGetRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling consensusAccountsAddressDebondingDelegationsToGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/accounts/{address}/debonding_delegations_to`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.DebondingDelegationListFromJSON)(jsonValue));
    }
    /**
     * Returns a list of debonding delegations to an account.
     */ async consensusAccountsAddressDebondingDelegationsToGet(requestParameters) {
        const response = await this.consensusAccountsAddressDebondingDelegationsToGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns an account\'s delegations.
     */ async consensusAccountsAddressDelegationsGetRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling consensusAccountsAddressDelegationsGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/accounts/{address}/delegations`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.DelegationListFromJSON)(jsonValue));
    }
    /**
     * Returns an account\'s delegations.
     */ async consensusAccountsAddressDelegationsGet(requestParameters) {
        const response = await this.consensusAccountsAddressDelegationsGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a list of delegations to an account.
     */ async consensusAccountsAddressDelegationsToGetRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling consensusAccountsAddressDelegationsToGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/accounts/{address}/delegations_to`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.DelegationListFromJSON)(jsonValue));
    }
    /**
     * Returns a list of delegations to an account.
     */ async consensusAccountsAddressDelegationsToGet(requestParameters) {
        const response = await this.consensusAccountsAddressDelegationsToGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a consensus layer account.
     */ async consensusAccountsAddressGetRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling consensusAccountsAddressGet.');
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/accounts/{address}`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.AccountFromJSON)(jsonValue));
    }
    /**
     * Returns a consensus layer account.
     */ async consensusAccountsAddressGet(requestParameters) {
        const response = await this.consensusAccountsAddressGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a list of consensus layer accounts. Note that for performance reasons, the info returned by this endpoint may be slightly stale (<2 minutes). For the most up-to-date account state, query the single-account endpoint. 
     */ async consensusAccountsGetRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/accounts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.AccountListFromJSON)(jsonValue));
    }
    /**
     * Returns a list of consensus layer accounts. Note that for performance reasons, the info returned by this endpoint may be slightly stale (<2 minutes). For the most up-to-date account state, query the single-account endpoint. 
     */ async consensusAccountsGet(requestParameters) {
        const response = await this.consensusAccountsGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a list of consensus blocks, sorted from most to least recent.
     */ async consensusBlocksGetRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        if (requestParameters.from !== undefined) queryParameters['from'] = requestParameters.from;
        if (requestParameters.to !== undefined) queryParameters['to'] = requestParameters.to;
        if (requestParameters.after !== undefined) queryParameters['after'] = requestParameters.after.toISOString();
        if (requestParameters.before !== undefined) queryParameters['before'] = requestParameters.before.toISOString();
        if (requestParameters.hash !== undefined) queryParameters['hash'] = requestParameters.hash;
        if (requestParameters.proposedBy !== undefined) queryParameters['proposed_by'] = requestParameters.proposedBy;
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/blocks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.BlockListFromJSON)(jsonValue));
    }
    /**
     * Returns a list of consensus blocks, sorted from most to least recent.
     */ async consensusBlocksGet(requestParameters) {
        const response = await this.consensusBlocksGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a consensus block.
     */ async consensusBlocksHeightGetRaw(requestParameters) {
        if (requestParameters.height === null || requestParameters.height === undefined) throw new _runtime.RequiredError('height', 'Required parameter requestParameters.height was null or undefined when calling consensusBlocksHeightGet.');
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/blocks/{height}`.replace(`{${"height"}}`, encodeURIComponent(String(requestParameters.height))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.BlockFromJSON)(jsonValue));
    }
    /**
     * Returns a consensus block.
     */ async consensusBlocksHeightGet(requestParameters) {
        const response = await this.consensusBlocksHeightGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns an entity registered at the consensus layer.
     */ async consensusEntitiesAddressGetRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling consensusEntitiesAddressGet.');
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/entities/{address}`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.EntityFromJSON)(jsonValue));
    }
    /**
     * Returns an entity registered at the consensus layer.
     */ async consensusEntitiesAddressGet(requestParameters) {
        const response = await this.consensusEntitiesAddressGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a list of nodes registered at the consensus layer.
     */ async consensusEntitiesAddressNodesGetRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling consensusEntitiesAddressNodesGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/entities/{address}/nodes`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.NodeListFromJSON)(jsonValue));
    }
    /**
     * Returns a list of nodes registered at the consensus layer.
     */ async consensusEntitiesAddressNodesGet(requestParameters) {
        const response = await this.consensusEntitiesAddressNodesGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a node registered at the consensus layer.
     */ async consensusEntitiesAddressNodesNodeIdGetRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling consensusEntitiesAddressNodesNodeIdGet.');
        if (requestParameters.nodeId === null || requestParameters.nodeId === undefined) throw new _runtime.RequiredError('nodeId', 'Required parameter requestParameters.nodeId was null or undefined when calling consensusEntitiesAddressNodesNodeIdGet.');
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/entities/{address}/nodes/{node_id}`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))).replace(`{${"node_id"}}`, encodeURIComponent(String(requestParameters.nodeId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.NodeFromJSON)(jsonValue));
    }
    /**
     * Returns a node registered at the consensus layer.
     */ async consensusEntitiesAddressNodesNodeIdGet(requestParameters) {
        const response = await this.consensusEntitiesAddressNodesNodeIdGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a list of entities registered at the consensus layer.
     */ async consensusEntitiesGetRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/entities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.EntityListFromJSON)(jsonValue));
    }
    /**
     * Returns a list of entities registered at the consensus layer.
     */ async consensusEntitiesGet(requestParameters) {
        const response = await this.consensusEntitiesGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a consensus epoch.
     */ async consensusEpochsEpochGetRaw(requestParameters) {
        if (requestParameters.epoch === null || requestParameters.epoch === undefined) throw new _runtime.RequiredError('epoch', 'Required parameter requestParameters.epoch was null or undefined when calling consensusEpochsEpochGet.');
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/epochs/{epoch}`.replace(`{${"epoch"}}`, encodeURIComponent(String(requestParameters.epoch))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.EpochFromJSON)(jsonValue));
    }
    /**
     * Returns a consensus epoch.
     */ async consensusEpochsEpochGet(requestParameters) {
        const response = await this.consensusEpochsEpochGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a list of consensus epochs.
     */ async consensusEpochsGetRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/epochs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.EpochListFromJSON)(jsonValue));
    }
    /**
     * Returns a list of consensus epochs.
     */ async consensusEpochsGet(requestParameters) {
        const response = await this.consensusEpochsGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a list of consensus events.
     */ async consensusEventsGetRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        if (requestParameters.block !== undefined) queryParameters['block'] = requestParameters.block;
        if (requestParameters.txIndex !== undefined) queryParameters['tx_index'] = requestParameters.txIndex;
        if (requestParameters.txHash !== undefined) queryParameters['tx_hash'] = requestParameters.txHash;
        if (requestParameters.rel !== undefined) queryParameters['rel'] = requestParameters.rel;
        if (requestParameters.type !== undefined) queryParameters['type'] = requestParameters.type;
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/events`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ConsensusEventListFromJSON)(jsonValue));
    }
    /**
     * Returns a list of consensus events.
     */ async consensusEventsGet(requestParameters) {
        const response = await this.consensusEventsGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a list of governance proposals.
     */ async consensusProposalsGetRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        if (requestParameters.submitter !== undefined) queryParameters['submitter'] = requestParameters.submitter;
        if (requestParameters.state !== undefined) queryParameters['state'] = requestParameters.state;
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/proposals`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ProposalListFromJSON)(jsonValue));
    }
    /**
     * Returns a list of governance proposals.
     */ async consensusProposalsGet(requestParameters) {
        const response = await this.consensusProposalsGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a governance proposal.
     */ async consensusProposalsProposalIdGetRaw(requestParameters) {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) throw new _runtime.RequiredError('proposalId', 'Required parameter requestParameters.proposalId was null or undefined when calling consensusProposalsProposalIdGet.');
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/proposals/{proposal_id}`.replace(`{${"proposal_id"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ProposalFromJSON)(jsonValue));
    }
    /**
     * Returns a governance proposal.
     */ async consensusProposalsProposalIdGet(requestParameters) {
        const response = await this.consensusProposalsProposalIdGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a list of votes for a governance proposal.
     */ async consensusProposalsProposalIdVotesGetRaw(requestParameters) {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) throw new _runtime.RequiredError('proposalId', 'Required parameter requestParameters.proposalId was null or undefined when calling consensusProposalsProposalIdVotesGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/proposals/{proposal_id}/votes`.replace(`{${"proposal_id"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ProposalVotesFromJSON)(jsonValue));
    }
    /**
     * Returns a list of votes for a governance proposal.
     */ async consensusProposalsProposalIdVotesGet(requestParameters) {
        const response = await this.consensusProposalsProposalIdVotesGetRaw(requestParameters);
        return await response.value();
    }
    /**
     */ async consensusRoothashMessagesGetRaw(requestParameters) {
        if (requestParameters.runtime === null || requestParameters.runtime === undefined) throw new _runtime.RequiredError('runtime', 'Required parameter requestParameters.runtime was null or undefined when calling consensusRoothashMessagesGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        if (requestParameters.runtime !== undefined) queryParameters['runtime'] = requestParameters.runtime;
        if (requestParameters.round !== undefined) queryParameters['round'] = requestParameters.round;
        if (requestParameters.type !== undefined) queryParameters['type'] = requestParameters.type;
        if (requestParameters.rel !== undefined) queryParameters['rel'] = requestParameters.rel;
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/roothash_messages`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.RoothashMessageListFromJSON)(jsonValue));
    }
    /**
     */ async consensusRoothashMessagesGet(requestParameters) {
        const response = await this.consensusRoothashMessagesGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a list of consensus transactions.
     */ async consensusTransactionsGetRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        if (requestParameters.block !== undefined) queryParameters['block'] = requestParameters.block;
        if (requestParameters.method !== undefined) queryParameters['method'] = requestParameters.method;
        if (requestParameters.sender !== undefined) queryParameters['sender'] = requestParameters.sender;
        if (requestParameters.rel !== undefined) queryParameters['rel'] = requestParameters.rel;
        if (requestParameters.after !== undefined) queryParameters['after'] = requestParameters.after.toISOString();
        if (requestParameters.before !== undefined) queryParameters['before'] = requestParameters.before.toISOString();
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/transactions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.TransactionListFromJSON)(jsonValue));
    }
    /**
     * Returns a list of consensus transactions.
     */ async consensusTransactionsGet(requestParameters) {
        const response = await this.consensusTransactionsGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns consensus transactions with the given transaction hash.
     */ async consensusTransactionsTxHashGetRaw(requestParameters) {
        if (requestParameters.txHash === null || requestParameters.txHash === undefined) throw new _runtime.RequiredError('txHash', 'Required parameter requestParameters.txHash was null or undefined when calling consensusTransactionsTxHashGet.');
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/transactions/{tx_hash}`.replace(`{${"tx_hash"}}`, encodeURIComponent(String(requestParameters.txHash))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.TransactionListFromJSON)(jsonValue));
    }
    /**
     * Returns consensus transactions with the given transaction hash.
     */ async consensusTransactionsTxHashGet(requestParameters) {
        const response = await this.consensusTransactionsTxHashGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a validator registered at the consensus layer.
     */ async consensusValidatorsAddressGetRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling consensusValidatorsAddressGet.');
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/validators/{address}`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ValidatorListFromJSON)(jsonValue));
    }
    /**
     * Returns a validator registered at the consensus layer.
     */ async consensusValidatorsAddressGet(requestParameters) {
        const response = await this.consensusValidatorsAddressGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns historical information for a single validator.
     */ async consensusValidatorsAddressHistoryGetRaw(requestParameters) {
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling consensusValidatorsAddressHistoryGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        if (requestParameters.from !== undefined) queryParameters['from'] = requestParameters.from;
        if (requestParameters.to !== undefined) queryParameters['to'] = requestParameters.to;
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/validators/{address}/history`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ValidatorHistoryFromJSON)(jsonValue));
    }
    /**
     * Returns historical information for a single validator.
     */ async consensusValidatorsAddressHistoryGet(requestParameters) {
        const response = await this.consensusValidatorsAddressHistoryGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a list of validators registered at the consensus layer (the list includes all registered entities, even those without a currently active validator node).
     */ async consensusValidatorsGetRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        if (requestParameters.name !== undefined) queryParameters['name'] = requestParameters.name;
        const headerParameters = {};
        const response = await this.request({
            path: `/consensus/validators`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ValidatorListFromJSON)(jsonValue));
    }
    /**
     * Returns a list of validators registered at the consensus layer (the list includes all registered entities, even those without a currently active validator node).
     */ async consensusValidatorsGet(requestParameters) {
        const response = await this.consensusValidatorsGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns the status of indexing.
     */ async getStatusRaw() {
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.StatusFromJSON)(jsonValue));
    }
    /**
     * Returns the status of indexing.
     */ async getStatus() {
        const response = await this.getStatusRaw();
        return await response.value();
    }
    /**
     * Returns a (sliding) timeline of the recorded daily unique active accounts for either consensus or one of the paratimes. 
     */ async layerStatsActiveAccountsGetRaw(requestParameters) {
        if (requestParameters.layer === null || requestParameters.layer === undefined) throw new _runtime.RequiredError('layer', 'Required parameter requestParameters.layer was null or undefined when calling layerStatsActiveAccountsGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        if (requestParameters.windowStepSeconds !== undefined) queryParameters['window_step_seconds'] = requestParameters.windowStepSeconds;
        const headerParameters = {};
        const response = await this.request({
            path: `/{layer}/stats/active_accounts`.replace(`{${"layer"}}`, encodeURIComponent(String(requestParameters.layer))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.ActiveAccountsListFromJSON)(jsonValue));
    }
    /**
     * Returns a (sliding) timeline of the recorded daily unique active accounts for either consensus or one of the paratimes. 
     */ async layerStatsActiveAccountsGet(requestParameters) {
        const response = await this.layerStatsActiveAccountsGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a timeline of the transaction volume at the chosen granularity, for either consensus or one of the paratimes. 
     */ async layerStatsTxVolumeGetRaw(requestParameters) {
        if (requestParameters.layer === null || requestParameters.layer === undefined) throw new _runtime.RequiredError('layer', 'Required parameter requestParameters.layer was null or undefined when calling layerStatsTxVolumeGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        if (requestParameters.windowSizeSeconds !== undefined) queryParameters['window_size_seconds'] = requestParameters.windowSizeSeconds;
        if (requestParameters.windowStepSeconds !== undefined) queryParameters['window_step_seconds'] = requestParameters.windowStepSeconds;
        const headerParameters = {};
        const response = await this.request({
            path: `/{layer}/stats/tx_volume`.replace(`{${"layer"}}`, encodeURIComponent(String(requestParameters.layer))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.TxVolumeListFromJSON)(jsonValue));
    }
    /**
     * Returns a timeline of the transaction volume at the chosen granularity, for either consensus or one of the paratimes. 
     */ async layerStatsTxVolumeGet(requestParameters) {
        const response = await this.layerStatsTxVolumeGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a runtime account.
     */ async runtimeAccountsAddressGetRaw(requestParameters) {
        if (requestParameters.runtime === null || requestParameters.runtime === undefined) throw new _runtime.RequiredError('runtime', 'Required parameter requestParameters.runtime was null or undefined when calling runtimeAccountsAddressGet.');
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling runtimeAccountsAddressGet.');
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/{runtime}/accounts/{address}`.replace(`{${"runtime"}}`, encodeURIComponent(String(requestParameters.runtime))).replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.RuntimeAccountFromJSON)(jsonValue));
    }
    /**
     * Returns a runtime account.
     */ async runtimeAccountsAddressGet(requestParameters) {
        const response = await this.runtimeAccountsAddressGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns the list of non-fungible token (NFT) instances owned by an account. 
     */ async runtimeAccountsAddressNftsGetRaw(requestParameters) {
        if (requestParameters.runtime === null || requestParameters.runtime === undefined) throw new _runtime.RequiredError('runtime', 'Required parameter requestParameters.runtime was null or undefined when calling runtimeAccountsAddressNftsGet.');
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling runtimeAccountsAddressNftsGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        if (requestParameters.tokenAddress !== undefined) queryParameters['token_address'] = requestParameters.tokenAddress;
        const headerParameters = {};
        const response = await this.request({
            path: `/{runtime}/accounts/{address}/nfts`.replace(`{${"runtime"}}`, encodeURIComponent(String(requestParameters.runtime))).replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.EvmNftListFromJSON)(jsonValue));
    }
    /**
     * Returns the list of non-fungible token (NFT) instances owned by an account. 
     */ async runtimeAccountsAddressNftsGet(requestParameters) {
        const response = await this.runtimeAccountsAddressNftsGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a list of Runtime blocks.
     */ async runtimeBlocksGetRaw(requestParameters) {
        if (requestParameters.runtime === null || requestParameters.runtime === undefined) throw new _runtime.RequiredError('runtime', 'Required parameter requestParameters.runtime was null or undefined when calling runtimeBlocksGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        if (requestParameters.from !== undefined) queryParameters['from'] = requestParameters.from;
        if (requestParameters.to !== undefined) queryParameters['to'] = requestParameters.to;
        if (requestParameters.after !== undefined) queryParameters['after'] = requestParameters.after.toISOString();
        if (requestParameters.before !== undefined) queryParameters['before'] = requestParameters.before.toISOString();
        if (requestParameters.hash !== undefined) queryParameters['hash'] = requestParameters.hash;
        const headerParameters = {};
        const response = await this.request({
            path: `/{runtime}/blocks`.replace(`{${"runtime"}}`, encodeURIComponent(String(requestParameters.runtime))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.RuntimeBlockListFromJSON)(jsonValue));
    }
    /**
     * Returns a list of Runtime blocks.
     */ async runtimeBlocksGet(requestParameters) {
        const response = await this.runtimeBlocksGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a list of runtime events.
     */ async runtimeEventsGetRaw(requestParameters) {
        if (requestParameters.runtime === null || requestParameters.runtime === undefined) throw new _runtime.RequiredError('runtime', 'Required parameter requestParameters.runtime was null or undefined when calling runtimeEventsGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        if (requestParameters.block !== undefined) queryParameters['block'] = requestParameters.block;
        if (requestParameters.txIndex !== undefined) queryParameters['tx_index'] = requestParameters.txIndex;
        if (requestParameters.txHash !== undefined) queryParameters['tx_hash'] = requestParameters.txHash;
        if (requestParameters.type !== undefined) queryParameters['type'] = requestParameters.type;
        if (requestParameters.rel !== undefined) queryParameters['rel'] = requestParameters.rel;
        if (requestParameters.evmLogSignature !== undefined) queryParameters['evm_log_signature'] = requestParameters.evmLogSignature;
        if (requestParameters.contractAddress !== undefined) queryParameters['contract_address'] = requestParameters.contractAddress;
        if (requestParameters.nftId !== undefined) queryParameters['nft_id'] = requestParameters.nftId;
        const headerParameters = {};
        const response = await this.request({
            path: `/{runtime}/events`.replace(`{${"runtime"}}`, encodeURIComponent(String(requestParameters.runtime))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.RuntimeEventListFromJSON)(jsonValue));
    }
    /**
     * Returns a list of runtime events.
     */ async runtimeEventsGet(requestParameters) {
        const response = await this.runtimeEventsGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns info on an EVM (ERC-20, ...) token on the runtime.
     */ async runtimeEvmTokensAddressGetRaw(requestParameters) {
        if (requestParameters.runtime === null || requestParameters.runtime === undefined) throw new _runtime.RequiredError('runtime', 'Required parameter requestParameters.runtime was null or undefined when calling runtimeEvmTokensAddressGet.');
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling runtimeEvmTokensAddressGet.');
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/{runtime}/evm_tokens/{address}`.replace(`{${"runtime"}}`, encodeURIComponent(String(requestParameters.runtime))).replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.EvmTokenFromJSON)(jsonValue));
    }
    /**
     * Returns info on an EVM (ERC-20, ...) token on the runtime.
     */ async runtimeEvmTokensAddressGet(requestParameters) {
        const response = await this.runtimeEvmTokensAddressGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns the list of holders of an EVM (ERC-20, ...) token. This endpoint does not verify that `address` is actually an EVM token; if it is not, it will simply return an empty list. 
     */ async runtimeEvmTokensAddressHoldersGetRaw(requestParameters) {
        if (requestParameters.runtime === null || requestParameters.runtime === undefined) throw new _runtime.RequiredError('runtime', 'Required parameter requestParameters.runtime was null or undefined when calling runtimeEvmTokensAddressHoldersGet.');
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling runtimeEvmTokensAddressHoldersGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        const headerParameters = {};
        const response = await this.request({
            path: `/{runtime}/evm_tokens/{address}/holders`.replace(`{${"runtime"}}`, encodeURIComponent(String(requestParameters.runtime))).replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.TokenHolderListFromJSON)(jsonValue));
    }
    /**
     * Returns the list of holders of an EVM (ERC-20, ...) token. This endpoint does not verify that `address` is actually an EVM token; if it is not, it will simply return an empty list. 
     */ async runtimeEvmTokensAddressHoldersGet(requestParameters) {
        const response = await this.runtimeEvmTokensAddressHoldersGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns the list of non-fungible token (NFT) instances of an EVM (ERC-721, ...) token. This endpoint does not verify that `address` is actually an EVM token; if it is not, it will simply return an empty list. 
     */ async runtimeEvmTokensAddressNftsGetRaw(requestParameters) {
        if (requestParameters.runtime === null || requestParameters.runtime === undefined) throw new _runtime.RequiredError('runtime', 'Required parameter requestParameters.runtime was null or undefined when calling runtimeEvmTokensAddressNftsGet.');
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling runtimeEvmTokensAddressNftsGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        const headerParameters = {};
        const response = await this.request({
            path: `/{runtime}/evm_tokens/{address}/nfts`.replace(`{${"runtime"}}`, encodeURIComponent(String(requestParameters.runtime))).replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.EvmNftListFromJSON)(jsonValue));
    }
    /**
     * Returns the list of non-fungible token (NFT) instances of an EVM (ERC-721, ...) token. This endpoint does not verify that `address` is actually an EVM token; if it is not, it will simply return an empty list. 
     */ async runtimeEvmTokensAddressNftsGet(requestParameters) {
        const response = await this.runtimeEvmTokensAddressNftsGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns the non-fungible token (NFT) instance of an EVM (ERC-721, ...) token. 
     */ async runtimeEvmTokensAddressNftsIdGetRaw(requestParameters) {
        if (requestParameters.runtime === null || requestParameters.runtime === undefined) throw new _runtime.RequiredError('runtime', 'Required parameter requestParameters.runtime was null or undefined when calling runtimeEvmTokensAddressNftsIdGet.');
        if (requestParameters.address === null || requestParameters.address === undefined) throw new _runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling runtimeEvmTokensAddressNftsIdGet.');
        if (requestParameters.id === null || requestParameters.id === undefined) throw new _runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling runtimeEvmTokensAddressNftsIdGet.');
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/{runtime}/evm_tokens/{address}/nfts/{id}`.replace(`{${"runtime"}}`, encodeURIComponent(String(requestParameters.runtime))).replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.EvmNftFromJSON)(jsonValue));
    }
    /**
     * Returns the non-fungible token (NFT) instance of an EVM (ERC-721, ...) token. 
     */ async runtimeEvmTokensAddressNftsIdGet(requestParameters) {
        const response = await this.runtimeEvmTokensAddressNftsIdGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a list of EVM (ERC-20, ...) tokens on the runtime.
     */ async runtimeEvmTokensGetRaw(requestParameters) {
        if (requestParameters.runtime === null || requestParameters.runtime === undefined) throw new _runtime.RequiredError('runtime', 'Required parameter requestParameters.runtime was null or undefined when calling runtimeEvmTokensGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        if (requestParameters.name !== undefined) queryParameters['name'] = requestParameters.name;
        if (requestParameters.sortBy !== undefined) queryParameters['sort_by'] = requestParameters.sortBy;
        const headerParameters = {};
        const response = await this.request({
            path: `/{runtime}/evm_tokens`.replace(`{${"runtime"}}`, encodeURIComponent(String(requestParameters.runtime))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.EvmTokenListFromJSON)(jsonValue));
    }
    /**
     * Returns a list of EVM (ERC-20, ...) tokens on the runtime.
     */ async runtimeEvmTokensGet(requestParameters) {
        const response = await this.runtimeEvmTokensGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns the runtime status.
     */ async runtimeStatusGetRaw(requestParameters) {
        if (requestParameters.runtime === null || requestParameters.runtime === undefined) throw new _runtime.RequiredError('runtime', 'Required parameter requestParameters.runtime was null or undefined when calling runtimeStatusGet.');
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/{runtime}/status`.replace(`{${"runtime"}}`, encodeURIComponent(String(requestParameters.runtime))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.RuntimeStatusFromJSON)(jsonValue));
    }
    /**
     * Returns the runtime status.
     */ async runtimeStatusGet(requestParameters) {
        const response = await this.runtimeStatusGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns a list of Runtime transactions.
     */ async runtimeTransactionsGetRaw(requestParameters) {
        if (requestParameters.runtime === null || requestParameters.runtime === undefined) throw new _runtime.RequiredError('runtime', 'Required parameter requestParameters.runtime was null or undefined when calling runtimeTransactionsGet.');
        const queryParameters = {};
        if (requestParameters.limit !== undefined) queryParameters['limit'] = requestParameters.limit;
        if (requestParameters.offset !== undefined) queryParameters['offset'] = requestParameters.offset;
        if (requestParameters.block !== undefined) queryParameters['block'] = requestParameters.block;
        if (requestParameters.after !== undefined) queryParameters['after'] = requestParameters.after.toISOString();
        if (requestParameters.before !== undefined) queryParameters['before'] = requestParameters.before.toISOString();
        if (requestParameters.rel !== undefined) queryParameters['rel'] = requestParameters.rel;
        if (requestParameters.method !== undefined) queryParameters['method'] = requestParameters.method;
        const headerParameters = {};
        const response = await this.request({
            path: `/{runtime}/transactions`.replace(`{${"runtime"}}`, encodeURIComponent(String(requestParameters.runtime))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.RuntimeTransactionListFromJSON)(jsonValue));
    }
    /**
     * Returns a list of Runtime transactions.
     */ async runtimeTransactionsGet(requestParameters) {
        const response = await this.runtimeTransactionsGetRaw(requestParameters);
        return await response.value();
    }
    /**
     * Returns runtime transactions with the given transaction hash.
     */ async runtimeTransactionsTxHashGetRaw(requestParameters) {
        if (requestParameters.runtime === null || requestParameters.runtime === undefined) throw new _runtime.RequiredError('runtime', 'Required parameter requestParameters.runtime was null or undefined when calling runtimeTransactionsTxHashGet.');
        if (requestParameters.txHash === null || requestParameters.txHash === undefined) throw new _runtime.RequiredError('txHash', 'Required parameter requestParameters.txHash was null or undefined when calling runtimeTransactionsTxHashGet.');
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/{runtime}/transactions/{tx_hash}`.replace(`{${"runtime"}}`, encodeURIComponent(String(requestParameters.runtime))).replace(`{${"tx_hash"}}`, encodeURIComponent(String(requestParameters.txHash))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters
        });
        return new _runtime.JSONApiResponse(response, (jsonValue)=>(0, _models.RuntimeTransactionListFromJSON)(jsonValue));
    }
    /**
     * Returns runtime transactions with the given transaction hash.
     */ async runtimeTransactionsTxHashGet(requestParameters) {
        const response = await this.runtimeTransactionsTxHashGetRaw(requestParameters);
        return await response.value();
    }
}
var RuntimeEvmTokensGetSortByEnum = /*#__PURE__*/ function(RuntimeEvmTokensGetSortByEnum) {
    RuntimeEvmTokensGetSortByEnum["TotalHolders"] = "total_holders";
    RuntimeEvmTokensGetSortByEnum["MarketCap"] = "market_cap";
    return RuntimeEvmTokensGetSortByEnum;
}({});

},{"../runtime":"ecR7o","../models":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"K9U7a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _account = require("./Account");
parcelHelpers.exportAll(_account, exports);
var _accountList = require("./AccountList");
parcelHelpers.exportAll(_accountList, exports);
var _accountListAllOf = require("./AccountListAllOf");
parcelHelpers.exportAll(_accountListAllOf, exports);
var _accountStats = require("./AccountStats");
parcelHelpers.exportAll(_accountStats, exports);
var _activeAccounts = require("./ActiveAccounts");
parcelHelpers.exportAll(_activeAccounts, exports);
var _activeAccountsList = require("./ActiveAccountsList");
parcelHelpers.exportAll(_activeAccountsList, exports);
var _addressDerivationContext = require("./AddressDerivationContext");
parcelHelpers.exportAll(_addressDerivationContext, exports);
var _addressPreimage = require("./AddressPreimage");
parcelHelpers.exportAll(_addressPreimage, exports);
var _allowance = require("./Allowance");
parcelHelpers.exportAll(_allowance, exports);
var _bareTokenHolder = require("./BareTokenHolder");
parcelHelpers.exportAll(_bareTokenHolder, exports);
var _block = require("./Block");
parcelHelpers.exportAll(_block, exports);
var _blockList = require("./BlockList");
parcelHelpers.exportAll(_blockList, exports);
var _blockListAllOf = require("./BlockListAllOf");
parcelHelpers.exportAll(_blockListAllOf, exports);
var _consensusEvent = require("./ConsensusEvent");
parcelHelpers.exportAll(_consensusEvent, exports);
var _consensusEventList = require("./ConsensusEventList");
parcelHelpers.exportAll(_consensusEventList, exports);
var _consensusEventListAllOf = require("./ConsensusEventListAllOf");
parcelHelpers.exportAll(_consensusEventListAllOf, exports);
var _consensusEventType = require("./ConsensusEventType");
parcelHelpers.exportAll(_consensusEventType, exports);
var _consensusTxMethod = require("./ConsensusTxMethod");
parcelHelpers.exportAll(_consensusTxMethod, exports);
var _debondingDelegation = require("./DebondingDelegation");
parcelHelpers.exportAll(_debondingDelegation, exports);
var _debondingDelegationList = require("./DebondingDelegationList");
parcelHelpers.exportAll(_debondingDelegationList, exports);
var _debondingDelegationListAllOf = require("./DebondingDelegationListAllOf");
parcelHelpers.exportAll(_debondingDelegationListAllOf, exports);
var _delegation = require("./Delegation");
parcelHelpers.exportAll(_delegation, exports);
var _delegationList = require("./DelegationList");
parcelHelpers.exportAll(_delegationList, exports);
var _delegationListAllOf = require("./DelegationListAllOf");
parcelHelpers.exportAll(_delegationListAllOf, exports);
var _entity = require("./Entity");
parcelHelpers.exportAll(_entity, exports);
var _entityInfo = require("./EntityInfo");
parcelHelpers.exportAll(_entityInfo, exports);
var _entityList = require("./EntityList");
parcelHelpers.exportAll(_entityList, exports);
var _entityListAllOf = require("./EntityListAllOf");
parcelHelpers.exportAll(_entityListAllOf, exports);
var _epoch = require("./Epoch");
parcelHelpers.exportAll(_epoch, exports);
var _epochList = require("./EpochList");
parcelHelpers.exportAll(_epochList, exports);
var _epochListAllOf = require("./EpochListAllOf");
parcelHelpers.exportAll(_epochListAllOf, exports);
var _escrow = require("./Escrow");
parcelHelpers.exportAll(_escrow, exports);
var _evmAbiParam = require("./EvmAbiParam");
parcelHelpers.exportAll(_evmAbiParam, exports);
var _evmEventToken = require("./EvmEventToken");
parcelHelpers.exportAll(_evmEventToken, exports);
var _evmNft = require("./EvmNft");
parcelHelpers.exportAll(_evmNft, exports);
var _evmNftList = require("./EvmNftList");
parcelHelpers.exportAll(_evmNftList, exports);
var _evmNftListAllOf = require("./EvmNftListAllOf");
parcelHelpers.exportAll(_evmNftListAllOf, exports);
var _evmRefToken = require("./EvmRefToken");
parcelHelpers.exportAll(_evmRefToken, exports);
var _evmToken = require("./EvmToken");
parcelHelpers.exportAll(_evmToken, exports);
var _evmTokenList = require("./EvmTokenList");
parcelHelpers.exportAll(_evmTokenList, exports);
var _evmTokenListAllOf = require("./EvmTokenListAllOf");
parcelHelpers.exportAll(_evmTokenListAllOf, exports);
var _evmTokenSwap = require("./EvmTokenSwap");
parcelHelpers.exportAll(_evmTokenSwap, exports);
var _evmTokenType = require("./EvmTokenType");
parcelHelpers.exportAll(_evmTokenType, exports);
var _inlineResponse400 = require("./InlineResponse400");
parcelHelpers.exportAll(_inlineResponse400, exports);
var _layer = require("./Layer");
parcelHelpers.exportAll(_layer, exports);
var _list = require("./List");
parcelHelpers.exportAll(_list, exports);
var _node = require("./Node");
parcelHelpers.exportAll(_node, exports);
var _nodeList = require("./NodeList");
parcelHelpers.exportAll(_nodeList, exports);
var _nodeListAllOf = require("./NodeListAllOf");
parcelHelpers.exportAll(_nodeListAllOf, exports);
var _proposal = require("./Proposal");
parcelHelpers.exportAll(_proposal, exports);
var _proposalList = require("./ProposalList");
parcelHelpers.exportAll(_proposalList, exports);
var _proposalListAllOf = require("./ProposalListAllOf");
parcelHelpers.exportAll(_proposalListAllOf, exports);
var _proposalState = require("./ProposalState");
parcelHelpers.exportAll(_proposalState, exports);
var _proposalTarget = require("./ProposalTarget");
parcelHelpers.exportAll(_proposalTarget, exports);
var _proposalVote = require("./ProposalVote");
parcelHelpers.exportAll(_proposalVote, exports);
var _proposalVotes = require("./ProposalVotes");
parcelHelpers.exportAll(_proposalVotes, exports);
var _proposalVotesAllOf = require("./ProposalVotesAllOf");
parcelHelpers.exportAll(_proposalVotesAllOf, exports);
var _roothashMessage = require("./RoothashMessage");
parcelHelpers.exportAll(_roothashMessage, exports);
var _roothashMessageList = require("./RoothashMessageList");
parcelHelpers.exportAll(_roothashMessageList, exports);
var _roothashMessageListAllOf = require("./RoothashMessageListAllOf");
parcelHelpers.exportAll(_roothashMessageListAllOf, exports);
var _roothashMessageType = require("./RoothashMessageType");
parcelHelpers.exportAll(_roothashMessageType, exports);
var _runtime = require("./Runtime");
parcelHelpers.exportAll(_runtime, exports);
var _runtimeAccount = require("./RuntimeAccount");
parcelHelpers.exportAll(_runtimeAccount, exports);
var _runtimeBlock = require("./RuntimeBlock");
parcelHelpers.exportAll(_runtimeBlock, exports);
var _runtimeBlockList = require("./RuntimeBlockList");
parcelHelpers.exportAll(_runtimeBlockList, exports);
var _runtimeBlockListAllOf = require("./RuntimeBlockListAllOf");
parcelHelpers.exportAll(_runtimeBlockListAllOf, exports);
var _runtimeEvent = require("./RuntimeEvent");
parcelHelpers.exportAll(_runtimeEvent, exports);
var _runtimeEventList = require("./RuntimeEventList");
parcelHelpers.exportAll(_runtimeEventList, exports);
var _runtimeEventListAllOf = require("./RuntimeEventListAllOf");
parcelHelpers.exportAll(_runtimeEventListAllOf, exports);
var _runtimeEventType = require("./RuntimeEventType");
parcelHelpers.exportAll(_runtimeEventType, exports);
var _runtimeEvmBalance = require("./RuntimeEvmBalance");
parcelHelpers.exportAll(_runtimeEvmBalance, exports);
var _runtimeEvmContract = require("./RuntimeEvmContract");
parcelHelpers.exportAll(_runtimeEvmContract, exports);
var _runtimeEvmContractVerification = require("./RuntimeEvmContractVerification");
parcelHelpers.exportAll(_runtimeEvmContractVerification, exports);
var _runtimeSdkBalance = require("./RuntimeSdkBalance");
parcelHelpers.exportAll(_runtimeSdkBalance, exports);
var _runtimeStatus = require("./RuntimeStatus");
parcelHelpers.exportAll(_runtimeStatus, exports);
var _runtimeTransaction = require("./RuntimeTransaction");
parcelHelpers.exportAll(_runtimeTransaction, exports);
var _runtimeTransactionEncryptionEnvelope = require("./RuntimeTransactionEncryptionEnvelope");
parcelHelpers.exportAll(_runtimeTransactionEncryptionEnvelope, exports);
var _runtimeTransactionList = require("./RuntimeTransactionList");
parcelHelpers.exportAll(_runtimeTransactionList, exports);
var _runtimeTransactionListAllOf = require("./RuntimeTransactionListAllOf");
parcelHelpers.exportAll(_runtimeTransactionListAllOf, exports);
var _runtimeTransactionSigner = require("./RuntimeTransactionSigner");
parcelHelpers.exportAll(_runtimeTransactionSigner, exports);
var _status = require("./Status");
parcelHelpers.exportAll(_status, exports);
var _tokenHolderList = require("./TokenHolderList");
parcelHelpers.exportAll(_tokenHolderList, exports);
var _tokenHolderListAllOf = require("./TokenHolderListAllOf");
parcelHelpers.exportAll(_tokenHolderListAllOf, exports);
var _transaction = require("./Transaction");
parcelHelpers.exportAll(_transaction, exports);
var _transactionList = require("./TransactionList");
parcelHelpers.exportAll(_transactionList, exports);
var _transactionListAllOf = require("./TransactionListAllOf");
parcelHelpers.exportAll(_transactionListAllOf, exports);
var _txError = require("./TxError");
parcelHelpers.exportAll(_txError, exports);
var _txVolume = require("./TxVolume");
parcelHelpers.exportAll(_txVolume, exports);
var _txVolumeList = require("./TxVolumeList");
parcelHelpers.exportAll(_txVolumeList, exports);
var _validator = require("./Validator");
parcelHelpers.exportAll(_validator, exports);
var _validatorAggStats = require("./ValidatorAggStats");
parcelHelpers.exportAll(_validatorAggStats, exports);
var _validatorCommissionBound = require("./ValidatorCommissionBound");
parcelHelpers.exportAll(_validatorCommissionBound, exports);
var _validatorHistory = require("./ValidatorHistory");
parcelHelpers.exportAll(_validatorHistory, exports);
var _validatorHistoryAllOf = require("./ValidatorHistoryAllOf");
parcelHelpers.exportAll(_validatorHistoryAllOf, exports);
var _validatorHistoryPoint = require("./ValidatorHistoryPoint");
parcelHelpers.exportAll(_validatorHistoryPoint, exports);
var _validatorList = require("./ValidatorList");
parcelHelpers.exportAll(_validatorList, exports);
var _validatorListAllOf = require("./ValidatorListAllOf");
parcelHelpers.exportAll(_validatorListAllOf, exports);
var _validatorMedia = require("./ValidatorMedia");
parcelHelpers.exportAll(_validatorMedia, exports);
var _validatorSignedBlock = require("./ValidatorSignedBlock");
parcelHelpers.exportAll(_validatorSignedBlock, exports);
var _validatorsResponse = require("./ValidatorsResponse");
parcelHelpers.exportAll(_validatorsResponse, exports);
var _verificationLevel = require("./VerificationLevel");
parcelHelpers.exportAll(_verificationLevel, exports);

},{"./Account":"03WAh","./AccountList":"3euPk","./AccountListAllOf":"kHGya","./AccountStats":"kckty","./ActiveAccounts":"l9cDl","./ActiveAccountsList":"4OWyK","./AddressDerivationContext":"WOPaI","./AddressPreimage":"hU2JK","./Allowance":"9QqVy","./BareTokenHolder":"2C30M","./Block":"bUUa0","./BlockList":"6h4Ms","./BlockListAllOf":"K6pSg","./ConsensusEvent":"j7GLf","./ConsensusEventList":"cj5H6","./ConsensusEventListAllOf":"lAGgo","./ConsensusEventType":"eYgNH","./ConsensusTxMethod":"asu9W","./DebondingDelegation":"i28ZW","./DebondingDelegationList":"iYOiR","./DebondingDelegationListAllOf":"6IRC1","./Delegation":"hVF5m","./DelegationList":"eR2wY","./DelegationListAllOf":"eBSrC","./Entity":"3Mf3Y","./EntityInfo":"fw8Ns","./EntityList":"boO0I","./EntityListAllOf":"2Hhsf","./Epoch":"2379Z","./EpochList":"ia2V1","./EpochListAllOf":"4214I","./Escrow":"bdsWV","./EvmAbiParam":"kcq5K","./EvmEventToken":"aCxuy","./EvmNft":"1GqUO","./EvmNftList":"1t2Sa","./EvmNftListAllOf":"aZzRE","./EvmRefToken":"jIFuc","./EvmToken":"83P3o","./EvmTokenList":"67s8V","./EvmTokenListAllOf":"jOt5L","./EvmTokenSwap":"fwN6J","./EvmTokenType":"fFmAM","./InlineResponse400":"1UIYc","./Layer":"izs4s","./List":"9EEjB","./Node":"4r9cl","./NodeList":"55zUe","./NodeListAllOf":"1JA8E","./Proposal":"kvBSS","./ProposalList":"8H7NN","./ProposalListAllOf":"aEt6M","./ProposalState":"eladH","./ProposalTarget":"e1r2L","./ProposalVote":"3Cusi","./ProposalVotes":"gbPXA","./ProposalVotesAllOf":"4uvBJ","./RoothashMessage":"bY8HE","./RoothashMessageList":"SVgXQ","./RoothashMessageListAllOf":"jkxn6","./RoothashMessageType":"e7XB9","./Runtime":"dk0gk","./RuntimeAccount":"dzj5k","./RuntimeBlock":"jmje7","./RuntimeBlockList":"cEVaT","./RuntimeBlockListAllOf":"7n2i6","./RuntimeEvent":"lgUJK","./RuntimeEventList":"aaiKL","./RuntimeEventListAllOf":"hGbdF","./RuntimeEventType":"bZxjv","./RuntimeEvmBalance":"9SEfU","./RuntimeEvmContract":"eMonu","./RuntimeEvmContractVerification":"4mGD8","./RuntimeSdkBalance":"6XUfO","./RuntimeStatus":"6JMcZ","./RuntimeTransaction":"9hnFq","./RuntimeTransactionEncryptionEnvelope":"5nJYx","./RuntimeTransactionList":"cqVK4","./RuntimeTransactionListAllOf":"5XnIJ","./RuntimeTransactionSigner":"4fsyk","./Status":"airxR","./TokenHolderList":"1ch70","./TokenHolderListAllOf":"1cQw4","./Transaction":"7XkJD","./TransactionList":"5z0lS","./TransactionListAllOf":"2ice8","./TxError":"2o8GS","./TxVolume":"gs5NW","./TxVolumeList":"ainOa","./Validator":"4dxgM","./ValidatorAggStats":"gJcGg","./ValidatorCommissionBound":"2QCRe","./ValidatorHistory":"1x7cH","./ValidatorHistoryAllOf":"5ZeuE","./ValidatorHistoryPoint":"dC30c","./ValidatorList":"4vePM","./ValidatorListAllOf":"6bkDi","./ValidatorMedia":"9uT7X","./ValidatorSignedBlock":"aC6CP","./ValidatorsResponse":"6efum","./VerificationLevel":"5bKHs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"03WAh":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountFromJSON", ()=>AccountFromJSON);
parcelHelpers.export(exports, "AccountFromJSONTyped", ()=>AccountFromJSONTyped);
parcelHelpers.export(exports, "AccountToJSON", ()=>AccountToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function AccountFromJSON(json) {
    return AccountFromJSONTyped(json, false);
}
function AccountFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address'],
        'nonce': json['nonce'],
        'available': json['available'],
        'escrow': json['escrow'],
        'debonding': json['debonding'],
        'delegations_balance': json['delegations_balance'],
        'debonding_delegations_balance': json['debonding_delegations_balance'],
        'first_activity': !(0, _runtime.exists)(json, 'first_activity') ? undefined : new Date(json['first_activity']),
        'allowances': json['allowances'].map((0, _.AllowanceFromJSON)),
        'stats': (0, _.AccountStatsFromJSON)(json['stats'])
    };
}
function AccountToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address,
        'nonce': value.nonce,
        'available': value.available,
        'escrow': value.escrow,
        'debonding': value.debonding,
        'delegations_balance': value.delegations_balance,
        'debonding_delegations_balance': value.debonding_delegations_balance,
        'first_activity': value.first_activity === undefined ? undefined : value.first_activity.toISOString(),
        'allowances': value.allowances.map((0, _.AllowanceToJSON)),
        'stats': (0, _.AccountStatsToJSON)(value.stats)
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3euPk":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountListFromJSON", ()=>AccountListFromJSON);
parcelHelpers.export(exports, "AccountListFromJSONTyped", ()=>AccountListFromJSONTyped);
parcelHelpers.export(exports, "AccountListToJSON", ()=>AccountListToJSON);
var _ = require("./");
function AccountListFromJSON(json) {
    return AccountListFromJSONTyped(json, false);
}
function AccountListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'accounts': json['accounts'].map((0, _.AccountFromJSON))
    };
}
function AccountListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'accounts': value.accounts.map((0, _.AccountToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kHGya":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountListAllOfFromJSON", ()=>AccountListAllOfFromJSON);
parcelHelpers.export(exports, "AccountListAllOfFromJSONTyped", ()=>AccountListAllOfFromJSONTyped);
parcelHelpers.export(exports, "AccountListAllOfToJSON", ()=>AccountListAllOfToJSON);
var _ = require("./");
function AccountListAllOfFromJSON(json) {
    return AccountListAllOfFromJSONTyped(json, false);
}
function AccountListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'accounts': json['accounts'].map((0, _.AccountFromJSON))
    };
}
function AccountListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'accounts': value.accounts.map((0, _.AccountToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kckty":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountStatsFromJSON", ()=>AccountStatsFromJSON);
parcelHelpers.export(exports, "AccountStatsFromJSONTyped", ()=>AccountStatsFromJSONTyped);
parcelHelpers.export(exports, "AccountStatsToJSON", ()=>AccountStatsToJSON);
var _runtime = require("../runtime");
function AccountStatsFromJSON(json) {
    return AccountStatsFromJSONTyped(json, false);
}
function AccountStatsFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_sent': !(0, _runtime.exists)(json, 'total_sent') ? undefined : json['total_sent'],
        'total_received': !(0, _runtime.exists)(json, 'total_received') ? undefined : json['total_received'],
        'num_txns': json['num_txns']
    };
}
function AccountStatsToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_sent': value.total_sent,
        'total_received': value.total_received,
        'num_txns': value.num_txns
    };
}

},{"../runtime":"ecR7o","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"l9cDl":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActiveAccountsFromJSON", ()=>ActiveAccountsFromJSON);
parcelHelpers.export(exports, "ActiveAccountsFromJSONTyped", ()=>ActiveAccountsFromJSONTyped);
parcelHelpers.export(exports, "ActiveAccountsToJSON", ()=>ActiveAccountsToJSON);
function ActiveAccountsFromJSON(json) {
    return ActiveAccountsFromJSONTyped(json, false);
}
function ActiveAccountsFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'window_end': new Date(json['window_end']),
        'active_accounts': json['active_accounts']
    };
}
function ActiveAccountsToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'window_end': value.window_end.toISOString(),
        'active_accounts': value.active_accounts
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4OWyK":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActiveAccountsListFromJSON", ()=>ActiveAccountsListFromJSON);
parcelHelpers.export(exports, "ActiveAccountsListFromJSONTyped", ()=>ActiveAccountsListFromJSONTyped);
parcelHelpers.export(exports, "ActiveAccountsListToJSON", ()=>ActiveAccountsListToJSON);
var _ = require("./");
function ActiveAccountsListFromJSON(json) {
    return ActiveAccountsListFromJSONTyped(json, false);
}
function ActiveAccountsListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'window_size_seconds': json['window_size_seconds'],
        'windows': json['windows'].map((0, _.ActiveAccountsFromJSON))
    };
}
function ActiveAccountsListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'window_size_seconds': value.window_size_seconds,
        'windows': value.windows.map((0, _.ActiveAccountsToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"WOPaI":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddressDerivationContext", ()=>AddressDerivationContext);
parcelHelpers.export(exports, "AddressDerivationContextFromJSON", ()=>AddressDerivationContextFromJSON);
parcelHelpers.export(exports, "AddressDerivationContextFromJSONTyped", ()=>AddressDerivationContextFromJSONTyped);
parcelHelpers.export(exports, "AddressDerivationContextToJSON", ()=>AddressDerivationContextToJSON);
var AddressDerivationContext = /*#__PURE__*/ function(AddressDerivationContext) {
    AddressDerivationContext["CoreAddressStaking"] = "oasis-core/address: staking";
    AddressDerivationContext["RuntimeSdkAddressSecp256k1eth"] = "oasis-runtime-sdk/address: secp256k1eth";
    AddressDerivationContext["RuntimeSdkAddressSr25519"] = "oasis-runtime-sdk/address: sr25519";
    AddressDerivationContext["RuntimeSdkAddressMultisig"] = "oasis-runtime-sdk/address: multisig";
    AddressDerivationContext["RuntimeSdkAddressModule"] = "oasis-runtime-sdk/address: module";
    AddressDerivationContext["RuntimeSdkAddressRuntime"] = "oasis-runtime-sdk/address: runtime";
    return AddressDerivationContext;
}({});
function AddressDerivationContextFromJSON(json) {
    return AddressDerivationContextFromJSONTyped(json, false);
}
function AddressDerivationContextFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function AddressDerivationContextToJSON(value) {
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hU2JK":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddressPreimageFromJSON", ()=>AddressPreimageFromJSON);
parcelHelpers.export(exports, "AddressPreimageFromJSONTyped", ()=>AddressPreimageFromJSONTyped);
parcelHelpers.export(exports, "AddressPreimageToJSON", ()=>AddressPreimageToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function AddressPreimageFromJSON(json) {
    return AddressPreimageFromJSONTyped(json, false);
}
function AddressPreimageFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'context': (0, _.AddressDerivationContextFromJSON)(json['context']),
        'context_version': !(0, _runtime.exists)(json, 'context_version') ? undefined : json['context_version'],
        'address_data': json['address_data']
    };
}
function AddressPreimageToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'context': (0, _.AddressDerivationContextToJSON)(value.context),
        'context_version': value.context_version,
        'address_data': value.address_data
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9QqVy":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AllowanceFromJSON", ()=>AllowanceFromJSON);
parcelHelpers.export(exports, "AllowanceFromJSONTyped", ()=>AllowanceFromJSONTyped);
parcelHelpers.export(exports, "AllowanceToJSON", ()=>AllowanceToJSON);
function AllowanceFromJSON(json) {
    return AllowanceFromJSONTyped(json, false);
}
function AllowanceFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address'],
        'amount': json['amount']
    };
}
function AllowanceToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address,
        'amount': value.amount
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2C30M":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BareTokenHolderFromJSON", ()=>BareTokenHolderFromJSON);
parcelHelpers.export(exports, "BareTokenHolderFromJSONTyped", ()=>BareTokenHolderFromJSONTyped);
parcelHelpers.export(exports, "BareTokenHolderToJSON", ()=>BareTokenHolderToJSON);
var _runtime = require("../runtime");
function BareTokenHolderFromJSON(json) {
    return BareTokenHolderFromJSONTyped(json, false);
}
function BareTokenHolderFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'holder_address': json['holder_address'],
        'eth_holder_address': !(0, _runtime.exists)(json, 'eth_holder_address') ? undefined : json['eth_holder_address'],
        'balance': json['balance']
    };
}
function BareTokenHolderToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'holder_address': value.holder_address,
        'eth_holder_address': value.eth_holder_address,
        'balance': value.balance
    };
}

},{"../runtime":"ecR7o","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bUUa0":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlockFromJSON", ()=>BlockFromJSON);
parcelHelpers.export(exports, "BlockFromJSONTyped", ()=>BlockFromJSONTyped);
parcelHelpers.export(exports, "BlockToJSON", ()=>BlockToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function BlockFromJSON(json) {
    return BlockFromJSONTyped(json, false);
}
function BlockFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'height': json['height'],
        'hash': json['hash'],
        'timestamp': new Date(json['timestamp']),
        'num_transactions': json['num_transactions'],
        'gas_limit': json['gas_limit'],
        'size_limit': !(0, _runtime.exists)(json, 'size_limit') ? undefined : json['size_limit'],
        'epoch': json['epoch'],
        'state_root': json['state_root'],
        'proposer': (0, _.EntityInfoFromJSON)(json['proposer']),
        'signers': !(0, _runtime.exists)(json, 'signers') ? undefined : json['signers'].map((0, _.EntityInfoFromJSON))
    };
}
function BlockToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'height': value.height,
        'hash': value.hash,
        'timestamp': value.timestamp.toISOString(),
        'num_transactions': value.num_transactions,
        'gas_limit': value.gas_limit,
        'size_limit': value.size_limit,
        'epoch': value.epoch,
        'state_root': value.state_root,
        'proposer': (0, _.EntityInfoToJSON)(value.proposer),
        'signers': value.signers === undefined ? undefined : value.signers.map((0, _.EntityInfoToJSON))
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6h4Ms":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlockListFromJSON", ()=>BlockListFromJSON);
parcelHelpers.export(exports, "BlockListFromJSONTyped", ()=>BlockListFromJSONTyped);
parcelHelpers.export(exports, "BlockListToJSON", ()=>BlockListToJSON);
var _ = require("./");
function BlockListFromJSON(json) {
    return BlockListFromJSONTyped(json, false);
}
function BlockListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'blocks': json['blocks'].map((0, _.BlockFromJSON))
    };
}
function BlockListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'blocks': value.blocks.map((0, _.BlockToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"K6pSg":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BlockListAllOfFromJSON", ()=>BlockListAllOfFromJSON);
parcelHelpers.export(exports, "BlockListAllOfFromJSONTyped", ()=>BlockListAllOfFromJSONTyped);
parcelHelpers.export(exports, "BlockListAllOfToJSON", ()=>BlockListAllOfToJSON);
var _ = require("./");
function BlockListAllOfFromJSON(json) {
    return BlockListAllOfFromJSONTyped(json, false);
}
function BlockListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'blocks': json['blocks'].map((0, _.BlockFromJSON))
    };
}
function BlockListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'blocks': value.blocks.map((0, _.BlockToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"j7GLf":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusEventFromJSON", ()=>ConsensusEventFromJSON);
parcelHelpers.export(exports, "ConsensusEventFromJSONTyped", ()=>ConsensusEventFromJSONTyped);
parcelHelpers.export(exports, "ConsensusEventToJSON", ()=>ConsensusEventToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function ConsensusEventFromJSON(json) {
    return ConsensusEventFromJSONTyped(json, false);
}
function ConsensusEventFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'block': json['block'],
        'tx_index': !(0, _runtime.exists)(json, 'tx_index') ? undefined : json['tx_index'],
        'tx_hash': !(0, _runtime.exists)(json, 'tx_hash') ? undefined : json['tx_hash'],
        'roothash_runtime_id': !(0, _runtime.exists)(json, 'roothash_runtime_id') ? undefined : json['roothash_runtime_id'],
        'roothash_runtime': !(0, _runtime.exists)(json, 'roothash_runtime') ? undefined : (0, _.RuntimeFromJSON)(json['roothash_runtime']),
        'roothash_runtime_round': !(0, _runtime.exists)(json, 'roothash_runtime_round') ? undefined : json['roothash_runtime_round'],
        'timestamp': !(0, _runtime.exists)(json, 'timestamp') ? undefined : new Date(json['timestamp']),
        'type': (0, _.ConsensusEventTypeFromJSON)(json['type']),
        'body': json['body']
    };
}
function ConsensusEventToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'block': value.block,
        'tx_index': value.tx_index,
        'tx_hash': value.tx_hash,
        'roothash_runtime_id': value.roothash_runtime_id,
        'roothash_runtime': (0, _.RuntimeToJSON)(value.roothash_runtime),
        'roothash_runtime_round': value.roothash_runtime_round,
        'timestamp': value.timestamp === undefined ? undefined : value.timestamp.toISOString(),
        'type': (0, _.ConsensusEventTypeToJSON)(value.type),
        'body': value.body
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cj5H6":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusEventListFromJSON", ()=>ConsensusEventListFromJSON);
parcelHelpers.export(exports, "ConsensusEventListFromJSONTyped", ()=>ConsensusEventListFromJSONTyped);
parcelHelpers.export(exports, "ConsensusEventListToJSON", ()=>ConsensusEventListToJSON);
var _ = require("./");
function ConsensusEventListFromJSON(json) {
    return ConsensusEventListFromJSONTyped(json, false);
}
function ConsensusEventListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'events': json['events'].map((0, _.ConsensusEventFromJSON))
    };
}
function ConsensusEventListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'events': value.events.map((0, _.ConsensusEventToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lAGgo":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusEventListAllOfFromJSON", ()=>ConsensusEventListAllOfFromJSON);
parcelHelpers.export(exports, "ConsensusEventListAllOfFromJSONTyped", ()=>ConsensusEventListAllOfFromJSONTyped);
parcelHelpers.export(exports, "ConsensusEventListAllOfToJSON", ()=>ConsensusEventListAllOfToJSON);
var _ = require("./");
function ConsensusEventListAllOfFromJSON(json) {
    return ConsensusEventListAllOfFromJSONTyped(json, false);
}
function ConsensusEventListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'events': json['events'].map((0, _.ConsensusEventFromJSON))
    };
}
function ConsensusEventListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'events': value.events.map((0, _.ConsensusEventToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eYgNH":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusEventType", ()=>ConsensusEventType);
parcelHelpers.export(exports, "ConsensusEventTypeFromJSON", ()=>ConsensusEventTypeFromJSON);
parcelHelpers.export(exports, "ConsensusEventTypeFromJSONTyped", ()=>ConsensusEventTypeFromJSONTyped);
parcelHelpers.export(exports, "ConsensusEventTypeToJSON", ()=>ConsensusEventTypeToJSON);
var ConsensusEventType = /*#__PURE__*/ function(ConsensusEventType) {
    ConsensusEventType["GovernanceProposalExecuted"] = "governance.proposal_executed";
    ConsensusEventType["GovernanceProposalFinalized"] = "governance.proposal_finalized";
    ConsensusEventType["GovernanceProposalSubmitted"] = "governance.proposal_submitted";
    ConsensusEventType["GovernanceVote"] = "governance.vote";
    ConsensusEventType["RegistryEntity"] = "registry.entity";
    ConsensusEventType["RegistryNodeUnfrozen"] = "registry.node_unfrozen";
    ConsensusEventType["RegistryNode"] = "registry.node";
    ConsensusEventType["RegistryRuntime"] = "registry.runtime";
    ConsensusEventType["RegistryRuntimeSuspended"] = "registry.runtime_suspended";
    ConsensusEventType["RoothashExecutionDiscrepancy"] = "roothash.execution_discrepancy";
    ConsensusEventType["RoothashExecutorCommitted"] = "roothash.executor_committed";
    ConsensusEventType["RoothashFinalized"] = "roothash.finalized";
    ConsensusEventType["RoothashMessage"] = "roothash.message";
    ConsensusEventType["RoothashInMsgProcessed"] = "roothash.in_msg_processed";
    ConsensusEventType["StakingAllowanceChange"] = "staking.allowance_change";
    ConsensusEventType["StakingBurn"] = "staking.burn";
    ConsensusEventType["StakingEscrowAdd"] = "staking.escrow.add";
    ConsensusEventType["StakingEscrowDebondingStart"] = "staking.escrow.debonding_start";
    ConsensusEventType["StakingEscrowReclaim"] = "staking.escrow.reclaim";
    ConsensusEventType["StakingEscrowTake"] = "staking.escrow.take";
    ConsensusEventType["StakingTransfer"] = "staking.transfer";
    return ConsensusEventType;
}({});
function ConsensusEventTypeFromJSON(json) {
    return ConsensusEventTypeFromJSONTyped(json, false);
}
function ConsensusEventTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ConsensusEventTypeToJSON(value) {
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"asu9W":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConsensusTxMethod", ()=>ConsensusTxMethod);
parcelHelpers.export(exports, "ConsensusTxMethodFromJSON", ()=>ConsensusTxMethodFromJSON);
parcelHelpers.export(exports, "ConsensusTxMethodFromJSONTyped", ()=>ConsensusTxMethodFromJSONTyped);
parcelHelpers.export(exports, "ConsensusTxMethodToJSON", ()=>ConsensusTxMethodToJSON);
var ConsensusTxMethod = /*#__PURE__*/ function(ConsensusTxMethod) {
    ConsensusTxMethod["BeaconPvssCommit"] = "beacon.PVSSCommit";
    ConsensusTxMethod["BeaconPvssReveal"] = "beacon.PVSSReveal";
    ConsensusTxMethod["BeaconVrfProve"] = "beacon.VRFProve";
    ConsensusTxMethod["ConsensusMeta"] = "consensus.Meta";
    ConsensusTxMethod["GovernanceCastVote"] = "governance.CastVote";
    ConsensusTxMethod["GovernanceSubmitProposal"] = "governance.SubmitProposal";
    ConsensusTxMethod["KeymanagerPublishEphemeralSecret"] = "keymanager.PublishEphemeralSecret";
    ConsensusTxMethod["KeymanagerPublishMasterSecret"] = "keymanager.PublishMasterSecret";
    ConsensusTxMethod["KeymanagerUpdatePolicy"] = "keymanager.UpdatePolicy";
    ConsensusTxMethod["RegistryDeregisterEntity"] = "registry.DeregisterEntity";
    ConsensusTxMethod["RegistryProveFreshness"] = "registry.ProveFreshness";
    ConsensusTxMethod["RegistryRegisterEntity"] = "registry.RegisterEntity";
    ConsensusTxMethod["RegistryRegisterNode"] = "registry.RegisterNode";
    ConsensusTxMethod["RegistryRegisterRuntime"] = "registry.RegisterRuntime";
    ConsensusTxMethod["RegistryUnfreezeNode"] = "registry.UnfreezeNode";
    ConsensusTxMethod["RoothashEvidence"] = "roothash.Evidence";
    ConsensusTxMethod["RoothashExecutorCommit"] = "roothash.ExecutorCommit";
    ConsensusTxMethod["RoothashExecutorProposerTimeout"] = "roothash.ExecutorProposerTimeout";
    ConsensusTxMethod["RoothashSubmitMsg"] = "roothash.SubmitMsg";
    ConsensusTxMethod["StakingAddEscrow"] = "staking.AddEscrow";
    ConsensusTxMethod["StakingAllow"] = "staking.Allow";
    ConsensusTxMethod["StakingAmendCommissionSchedule"] = "staking.AmendCommissionSchedule";
    ConsensusTxMethod["StakingBurn"] = "staking.Burn";
    ConsensusTxMethod["StakingReclaimEscrow"] = "staking.ReclaimEscrow";
    ConsensusTxMethod["StakingTransfer"] = "staking.Transfer";
    ConsensusTxMethod["StakingWithdraw"] = "staking.Withdraw";
    ConsensusTxMethod["KeymanagerChurpApply"] = "keymanager/churp.Apply";
    ConsensusTxMethod["KeymanagerChurpConfirm"] = "keymanager/churp.Confirm";
    ConsensusTxMethod["KeymanagerChurpCreate"] = "keymanager/churp.Create";
    ConsensusTxMethod["KeymanagerChurpUpdate"] = "keymanager/churp.Update";
    ConsensusTxMethod["VaultAuthorizeAction"] = "vault.AuthorizeAction";
    ConsensusTxMethod["VaultCancelAction"] = "vault.CancelAction";
    ConsensusTxMethod["VaultCreate"] = "vault.Create";
    return ConsensusTxMethod;
}({});
function ConsensusTxMethodFromJSON(json) {
    return ConsensusTxMethodFromJSONTyped(json, false);
}
function ConsensusTxMethodFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ConsensusTxMethodToJSON(value) {
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"i28ZW":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DebondingDelegationFromJSON", ()=>DebondingDelegationFromJSON);
parcelHelpers.export(exports, "DebondingDelegationFromJSONTyped", ()=>DebondingDelegationFromJSONTyped);
parcelHelpers.export(exports, "DebondingDelegationToJSON", ()=>DebondingDelegationToJSON);
function DebondingDelegationFromJSON(json) {
    return DebondingDelegationFromJSONTyped(json, false);
}
function DebondingDelegationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'amount': json['amount'],
        'shares': json['shares'],
        'validator': json['validator'],
        'delegator': json['delegator'],
        'debond_end': json['debond_end']
    };
}
function DebondingDelegationToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'amount': value.amount,
        'shares': value.shares,
        'validator': value.validator,
        'delegator': value.delegator,
        'debond_end': value.debond_end
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iYOiR":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DebondingDelegationListFromJSON", ()=>DebondingDelegationListFromJSON);
parcelHelpers.export(exports, "DebondingDelegationListFromJSONTyped", ()=>DebondingDelegationListFromJSONTyped);
parcelHelpers.export(exports, "DebondingDelegationListToJSON", ()=>DebondingDelegationListToJSON);
var _ = require("./");
function DebondingDelegationListFromJSON(json) {
    return DebondingDelegationListFromJSONTyped(json, false);
}
function DebondingDelegationListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'debonding_delegations': json['debonding_delegations'].map((0, _.DebondingDelegationFromJSON))
    };
}
function DebondingDelegationListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'debonding_delegations': value.debonding_delegations.map((0, _.DebondingDelegationToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6IRC1":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DebondingDelegationListAllOfFromJSON", ()=>DebondingDelegationListAllOfFromJSON);
parcelHelpers.export(exports, "DebondingDelegationListAllOfFromJSONTyped", ()=>DebondingDelegationListAllOfFromJSONTyped);
parcelHelpers.export(exports, "DebondingDelegationListAllOfToJSON", ()=>DebondingDelegationListAllOfToJSON);
var _ = require("./");
function DebondingDelegationListAllOfFromJSON(json) {
    return DebondingDelegationListAllOfFromJSONTyped(json, false);
}
function DebondingDelegationListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'debonding_delegations': json['debonding_delegations'].map((0, _.DebondingDelegationFromJSON))
    };
}
function DebondingDelegationListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'debonding_delegations': value.debonding_delegations.map((0, _.DebondingDelegationToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hVF5m":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DelegationFromJSON", ()=>DelegationFromJSON);
parcelHelpers.export(exports, "DelegationFromJSONTyped", ()=>DelegationFromJSONTyped);
parcelHelpers.export(exports, "DelegationToJSON", ()=>DelegationToJSON);
function DelegationFromJSON(json) {
    return DelegationFromJSONTyped(json, false);
}
function DelegationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'amount': json['amount'],
        'shares': json['shares'],
        'validator': json['validator'],
        'delegator': json['delegator']
    };
}
function DelegationToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'amount': value.amount,
        'shares': value.shares,
        'validator': value.validator,
        'delegator': value.delegator
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eR2wY":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DelegationListFromJSON", ()=>DelegationListFromJSON);
parcelHelpers.export(exports, "DelegationListFromJSONTyped", ()=>DelegationListFromJSONTyped);
parcelHelpers.export(exports, "DelegationListToJSON", ()=>DelegationListToJSON);
var _ = require("./");
function DelegationListFromJSON(json) {
    return DelegationListFromJSONTyped(json, false);
}
function DelegationListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'delegations': json['delegations'].map((0, _.DelegationFromJSON))
    };
}
function DelegationListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'delegations': value.delegations.map((0, _.DelegationToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eBSrC":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DelegationListAllOfFromJSON", ()=>DelegationListAllOfFromJSON);
parcelHelpers.export(exports, "DelegationListAllOfFromJSONTyped", ()=>DelegationListAllOfFromJSONTyped);
parcelHelpers.export(exports, "DelegationListAllOfToJSON", ()=>DelegationListAllOfToJSON);
var _ = require("./");
function DelegationListAllOfFromJSON(json) {
    return DelegationListAllOfFromJSONTyped(json, false);
}
function DelegationListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'delegations': json['delegations'].map((0, _.DelegationFromJSON))
    };
}
function DelegationListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'delegations': value.delegations.map((0, _.DelegationToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3Mf3Y":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EntityFromJSON", ()=>EntityFromJSON);
parcelHelpers.export(exports, "EntityFromJSONTyped", ()=>EntityFromJSONTyped);
parcelHelpers.export(exports, "EntityToJSON", ()=>EntityToJSON);
function EntityFromJSON(json) {
    return EntityFromJSONTyped(json, false);
}
function EntityFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'id': json['id'],
        'address': json['address'],
        'nodes': json['nodes']
    };
}
function EntityToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'id': value.id,
        'address': value.address,
        'nodes': value.nodes
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fw8Ns":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EntityInfoFromJSON", ()=>EntityInfoFromJSON);
parcelHelpers.export(exports, "EntityInfoFromJSONTyped", ()=>EntityInfoFromJSONTyped);
parcelHelpers.export(exports, "EntityInfoToJSON", ()=>EntityInfoToJSON);
var _runtime = require("../runtime");
function EntityInfoFromJSON(json) {
    return EntityInfoFromJSONTyped(json, false);
}
function EntityInfoFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'entity_id': !(0, _runtime.exists)(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_address': !(0, _runtime.exists)(json, 'entity_address') ? undefined : json['entity_address'],
        'entity_metadata': !(0, _runtime.exists)(json, 'entity_metadata') ? undefined : json['entity_metadata']
    };
}
function EntityInfoToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'entity_id': value.entity_id,
        'entity_address': value.entity_address,
        'entity_metadata': value.entity_metadata
    };
}

},{"../runtime":"ecR7o","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"boO0I":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EntityListFromJSON", ()=>EntityListFromJSON);
parcelHelpers.export(exports, "EntityListFromJSONTyped", ()=>EntityListFromJSONTyped);
parcelHelpers.export(exports, "EntityListToJSON", ()=>EntityListToJSON);
var _ = require("./");
function EntityListFromJSON(json) {
    return EntityListFromJSONTyped(json, false);
}
function EntityListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'entities': json['entities'].map((0, _.EntityFromJSON))
    };
}
function EntityListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'entities': value.entities.map((0, _.EntityToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2Hhsf":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EntityListAllOfFromJSON", ()=>EntityListAllOfFromJSON);
parcelHelpers.export(exports, "EntityListAllOfFromJSONTyped", ()=>EntityListAllOfFromJSONTyped);
parcelHelpers.export(exports, "EntityListAllOfToJSON", ()=>EntityListAllOfToJSON);
var _ = require("./");
function EntityListAllOfFromJSON(json) {
    return EntityListAllOfFromJSONTyped(json, false);
}
function EntityListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'entities': json['entities'].map((0, _.EntityFromJSON))
    };
}
function EntityListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'entities': value.entities.map((0, _.EntityToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2379Z":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EpochFromJSON", ()=>EpochFromJSON);
parcelHelpers.export(exports, "EpochFromJSONTyped", ()=>EpochFromJSONTyped);
parcelHelpers.export(exports, "EpochToJSON", ()=>EpochToJSON);
var _runtime = require("../runtime");
function EpochFromJSON(json) {
    return EpochFromJSONTyped(json, false);
}
function EpochFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'id': json['id'],
        'start_height': json['start_height'],
        'end_height': !(0, _runtime.exists)(json, 'end_height') ? undefined : json['end_height']
    };
}
function EpochToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'id': value.id,
        'start_height': value.start_height,
        'end_height': value.end_height
    };
}

},{"../runtime":"ecR7o","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ia2V1":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EpochListFromJSON", ()=>EpochListFromJSON);
parcelHelpers.export(exports, "EpochListFromJSONTyped", ()=>EpochListFromJSONTyped);
parcelHelpers.export(exports, "EpochListToJSON", ()=>EpochListToJSON);
var _ = require("./");
function EpochListFromJSON(json) {
    return EpochListFromJSONTyped(json, false);
}
function EpochListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'epochs': json['epochs'].map((0, _.EpochFromJSON))
    };
}
function EpochListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'epochs': value.epochs.map((0, _.EpochToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4214I":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EpochListAllOfFromJSON", ()=>EpochListAllOfFromJSON);
parcelHelpers.export(exports, "EpochListAllOfFromJSONTyped", ()=>EpochListAllOfFromJSONTyped);
parcelHelpers.export(exports, "EpochListAllOfToJSON", ()=>EpochListAllOfToJSON);
var _ = require("./");
function EpochListAllOfFromJSON(json) {
    return EpochListAllOfFromJSONTyped(json, false);
}
function EpochListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'epochs': json['epochs'].map((0, _.EpochFromJSON))
    };
}
function EpochListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'epochs': value.epochs.map((0, _.EpochToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bdsWV":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EscrowFromJSON", ()=>EscrowFromJSON);
parcelHelpers.export(exports, "EscrowFromJSONTyped", ()=>EscrowFromJSONTyped);
parcelHelpers.export(exports, "EscrowToJSON", ()=>EscrowToJSON);
var _runtime = require("../runtime");
function EscrowFromJSON(json) {
    return EscrowFromJSONTyped(json, false);
}
function EscrowFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'active_balance': !(0, _runtime.exists)(json, 'active_balance') ? undefined : json['active_balance'],
        'active_shares': !(0, _runtime.exists)(json, 'active_shares') ? undefined : json['active_shares'],
        'debonding_balance': !(0, _runtime.exists)(json, 'debonding_balance') ? undefined : json['debonding_balance'],
        'debonding_shares': !(0, _runtime.exists)(json, 'debonding_shares') ? undefined : json['debonding_shares'],
        'self_delegation_balance': !(0, _runtime.exists)(json, 'self_delegation_balance') ? undefined : json['self_delegation_balance'],
        'self_delegation_shares': !(0, _runtime.exists)(json, 'self_delegation_shares') ? undefined : json['self_delegation_shares'],
        'active_balance_24': !(0, _runtime.exists)(json, 'active_balance_24') ? undefined : json['active_balance_24'],
        'num_delegators': !(0, _runtime.exists)(json, 'num_delegators') ? undefined : json['num_delegators']
    };
}
function EscrowToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'active_balance': value.active_balance,
        'active_shares': value.active_shares,
        'debonding_balance': value.debonding_balance,
        'debonding_shares': value.debonding_shares,
        'self_delegation_balance': value.self_delegation_balance,
        'self_delegation_shares': value.self_delegation_shares,
        'active_balance_24': value.active_balance_24,
        'num_delegators': value.num_delegators
    };
}

},{"../runtime":"ecR7o","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kcq5K":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EvmAbiParamFromJSON", ()=>EvmAbiParamFromJSON);
parcelHelpers.export(exports, "EvmAbiParamFromJSONTyped", ()=>EvmAbiParamFromJSONTyped);
parcelHelpers.export(exports, "EvmAbiParamToJSON", ()=>EvmAbiParamToJSON);
function EvmAbiParamFromJSON(json) {
    return EvmAbiParamFromJSONTyped(json, false);
}
function EvmAbiParamFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'name': json['name'],
        'evm_type': json['evm_type'],
        'value': json['value']
    };
}
function EvmAbiParamToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'name': value.name,
        'evm_type': value.evm_type,
        'value': value.value
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aCxuy":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EvmEventTokenFromJSON", ()=>EvmEventTokenFromJSON);
parcelHelpers.export(exports, "EvmEventTokenFromJSONTyped", ()=>EvmEventTokenFromJSONTyped);
parcelHelpers.export(exports, "EvmEventTokenToJSON", ()=>EvmEventTokenToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function EvmEventTokenFromJSON(json) {
    return EvmEventTokenFromJSONTyped(json, false);
}
function EvmEventTokenFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'type': !(0, _runtime.exists)(json, 'type') ? undefined : (0, _.EvmTokenTypeFromJSON)(json['type']),
        'symbol': !(0, _runtime.exists)(json, 'symbol') ? undefined : json['symbol'],
        'decimals': !(0, _runtime.exists)(json, 'decimals') ? undefined : json['decimals']
    };
}
function EvmEventTokenToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'type': (0, _.EvmTokenTypeToJSON)(value.type),
        'symbol': value.symbol,
        'decimals': value.decimals
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1GqUO":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EvmNftFromJSON", ()=>EvmNftFromJSON);
parcelHelpers.export(exports, "EvmNftFromJSONTyped", ()=>EvmNftFromJSONTyped);
parcelHelpers.export(exports, "EvmNftToJSON", ()=>EvmNftToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function EvmNftFromJSON(json) {
    return EvmNftFromJSONTyped(json, false);
}
function EvmNftFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'token': (0, _.EvmTokenFromJSON)(json['token']),
        'id': json['id'],
        'owner': !(0, _runtime.exists)(json, 'owner') ? undefined : json['owner'],
        'owner_eth': !(0, _runtime.exists)(json, 'owner_eth') ? undefined : json['owner_eth'],
        'num_transfers': !(0, _runtime.exists)(json, 'num_transfers') ? undefined : json['num_transfers'],
        'metadata_uri': !(0, _runtime.exists)(json, 'metadata_uri') ? undefined : json['metadata_uri'],
        'metadata_accessed': !(0, _runtime.exists)(json, 'metadata_accessed') ? undefined : json['metadata_accessed'],
        'metadata': !(0, _runtime.exists)(json, 'metadata') ? undefined : json['metadata'],
        'name': !(0, _runtime.exists)(json, 'name') ? undefined : json['name'],
        'description': !(0, _runtime.exists)(json, 'description') ? undefined : json['description'],
        'image': !(0, _runtime.exists)(json, 'image') ? undefined : json['image']
    };
}
function EvmNftToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'token': (0, _.EvmTokenToJSON)(value.token),
        'id': value.id,
        'owner': value.owner,
        'owner_eth': value.owner_eth,
        'num_transfers': value.num_transfers,
        'metadata_uri': value.metadata_uri,
        'metadata_accessed': value.metadata_accessed,
        'metadata': value.metadata,
        'name': value.name,
        'description': value.description,
        'image': value.image
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1t2Sa":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EvmNftListFromJSON", ()=>EvmNftListFromJSON);
parcelHelpers.export(exports, "EvmNftListFromJSONTyped", ()=>EvmNftListFromJSONTyped);
parcelHelpers.export(exports, "EvmNftListToJSON", ()=>EvmNftListToJSON);
var _ = require("./");
function EvmNftListFromJSON(json) {
    return EvmNftListFromJSONTyped(json, false);
}
function EvmNftListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'evm_nfts': json['evm_nfts'].map((0, _.EvmNftFromJSON))
    };
}
function EvmNftListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'evm_nfts': value.evm_nfts.map((0, _.EvmNftToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aZzRE":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EvmNftListAllOfFromJSON", ()=>EvmNftListAllOfFromJSON);
parcelHelpers.export(exports, "EvmNftListAllOfFromJSONTyped", ()=>EvmNftListAllOfFromJSONTyped);
parcelHelpers.export(exports, "EvmNftListAllOfToJSON", ()=>EvmNftListAllOfToJSON);
var _ = require("./");
function EvmNftListAllOfFromJSON(json) {
    return EvmNftListAllOfFromJSONTyped(json, false);
}
function EvmNftListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'evm_nfts': json['evm_nfts'].map((0, _.EvmNftFromJSON))
    };
}
function EvmNftListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'evm_nfts': value.evm_nfts.map((0, _.EvmNftToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jIFuc":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EvmRefTokenFromJSON", ()=>EvmRefTokenFromJSON);
parcelHelpers.export(exports, "EvmRefTokenFromJSONTyped", ()=>EvmRefTokenFromJSONTyped);
parcelHelpers.export(exports, "EvmRefTokenToJSON", ()=>EvmRefTokenToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function EvmRefTokenFromJSON(json) {
    return EvmRefTokenFromJSONTyped(json, false);
}
function EvmRefTokenFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'type': (0, _.EvmTokenTypeFromJSON)(json['type']),
        'name': !(0, _runtime.exists)(json, 'name') ? undefined : json['name'],
        'symbol': !(0, _runtime.exists)(json, 'symbol') ? undefined : json['symbol'],
        'decimals': !(0, _runtime.exists)(json, 'decimals') ? undefined : json['decimals']
    };
}
function EvmRefTokenToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'type': (0, _.EvmTokenTypeToJSON)(value.type),
        'name': value.name,
        'symbol': value.symbol,
        'decimals': value.decimals
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"83P3o":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EvmTokenFromJSON", ()=>EvmTokenFromJSON);
parcelHelpers.export(exports, "EvmTokenFromJSONTyped", ()=>EvmTokenFromJSONTyped);
parcelHelpers.export(exports, "EvmTokenToJSON", ()=>EvmTokenToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function EvmTokenFromJSON(json) {
    return EvmTokenFromJSONTyped(json, false);
}
function EvmTokenFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'contract_addr': json['contract_addr'],
        'eth_contract_addr': json['eth_contract_addr'],
        'name': !(0, _runtime.exists)(json, 'name') ? undefined : json['name'],
        'symbol': !(0, _runtime.exists)(json, 'symbol') ? undefined : json['symbol'],
        'decimals': !(0, _runtime.exists)(json, 'decimals') ? undefined : json['decimals'],
        'type': (0, _.EvmTokenTypeFromJSON)(json['type']),
        'total_supply': !(0, _runtime.exists)(json, 'total_supply') ? undefined : json['total_supply'],
        'num_transfers': !(0, _runtime.exists)(json, 'num_transfers') ? undefined : json['num_transfers'],
        'num_holders': json['num_holders'],
        'ref_swap': !(0, _runtime.exists)(json, 'ref_swap') ? undefined : (0, _.EvmTokenSwapFromJSON)(json['ref_swap']),
        'ref_token': !(0, _runtime.exists)(json, 'ref_token') ? undefined : (0, _.EvmRefTokenFromJSON)(json['ref_token']),
        'relative_token_address': !(0, _runtime.exists)(json, 'relative_token_address') ? undefined : json['relative_token_address'],
        'relative_price': !(0, _runtime.exists)(json, 'relative_price') ? undefined : json['relative_price'],
        'relative_total_value': !(0, _runtime.exists)(json, 'relative_total_value') ? undefined : json['relative_total_value'],
        'is_verified': json['is_verified'],
        'verification_level': !(0, _runtime.exists)(json, 'verification_level') ? undefined : (0, _.VerificationLevelFromJSON)(json['verification_level'])
    };
}
function EvmTokenToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'contract_addr': value.contract_addr,
        'eth_contract_addr': value.eth_contract_addr,
        'name': value.name,
        'symbol': value.symbol,
        'decimals': value.decimals,
        'type': (0, _.EvmTokenTypeToJSON)(value.type),
        'total_supply': value.total_supply,
        'num_transfers': value.num_transfers,
        'num_holders': value.num_holders,
        'ref_swap': (0, _.EvmTokenSwapToJSON)(value.ref_swap),
        'ref_token': (0, _.EvmRefTokenToJSON)(value.ref_token),
        'relative_token_address': value.relative_token_address,
        'relative_price': value.relative_price,
        'relative_total_value': value.relative_total_value,
        'is_verified': value.is_verified,
        'verification_level': (0, _.VerificationLevelToJSON)(value.verification_level)
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"67s8V":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EvmTokenListFromJSON", ()=>EvmTokenListFromJSON);
parcelHelpers.export(exports, "EvmTokenListFromJSONTyped", ()=>EvmTokenListFromJSONTyped);
parcelHelpers.export(exports, "EvmTokenListToJSON", ()=>EvmTokenListToJSON);
var _ = require("./");
function EvmTokenListFromJSON(json) {
    return EvmTokenListFromJSONTyped(json, false);
}
function EvmTokenListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'evm_tokens': json['evm_tokens'].map((0, _.EvmTokenFromJSON))
    };
}
function EvmTokenListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'evm_tokens': value.evm_tokens.map((0, _.EvmTokenToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jOt5L":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EvmTokenListAllOfFromJSON", ()=>EvmTokenListAllOfFromJSON);
parcelHelpers.export(exports, "EvmTokenListAllOfFromJSONTyped", ()=>EvmTokenListAllOfFromJSONTyped);
parcelHelpers.export(exports, "EvmTokenListAllOfToJSON", ()=>EvmTokenListAllOfToJSON);
var _ = require("./");
function EvmTokenListAllOfFromJSON(json) {
    return EvmTokenListAllOfFromJSONTyped(json, false);
}
function EvmTokenListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'evm_tokens': json['evm_tokens'].map((0, _.EvmTokenFromJSON))
    };
}
function EvmTokenListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'evm_tokens': value.evm_tokens.map((0, _.EvmTokenToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fwN6J":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EvmTokenSwapFromJSON", ()=>EvmTokenSwapFromJSON);
parcelHelpers.export(exports, "EvmTokenSwapFromJSONTyped", ()=>EvmTokenSwapFromJSONTyped);
parcelHelpers.export(exports, "EvmTokenSwapToJSON", ()=>EvmTokenSwapToJSON);
var _runtime = require("../runtime");
function EvmTokenSwapFromJSON(json) {
    return EvmTokenSwapFromJSONTyped(json, false);
}
function EvmTokenSwapFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'pair_address': json['pair_address'],
        'pair_address_eth': !(0, _runtime.exists)(json, 'pair_address_eth') ? undefined : json['pair_address_eth'],
        'factory_address': !(0, _runtime.exists)(json, 'factory_address') ? undefined : json['factory_address'],
        'factory_address_eth': !(0, _runtime.exists)(json, 'factory_address_eth') ? undefined : json['factory_address_eth'],
        'token0_address': !(0, _runtime.exists)(json, 'token0_address') ? undefined : json['token0_address'],
        'token0_address_eth': !(0, _runtime.exists)(json, 'token0_address_eth') ? undefined : json['token0_address_eth'],
        'token1_address': !(0, _runtime.exists)(json, 'token1_address') ? undefined : json['token1_address'],
        'token1_address_eth': !(0, _runtime.exists)(json, 'token1_address_eth') ? undefined : json['token1_address_eth'],
        'create_round': !(0, _runtime.exists)(json, 'create_round') ? undefined : json['create_round'],
        'reserve0': !(0, _runtime.exists)(json, 'reserve0') ? undefined : json['reserve0'],
        'reserve1': !(0, _runtime.exists)(json, 'reserve1') ? undefined : json['reserve1'],
        'last_sync_round': !(0, _runtime.exists)(json, 'last_sync_round') ? undefined : json['last_sync_round']
    };
}
function EvmTokenSwapToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'pair_address': value.pair_address,
        'pair_address_eth': value.pair_address_eth,
        'factory_address': value.factory_address,
        'factory_address_eth': value.factory_address_eth,
        'token0_address': value.token0_address,
        'token0_address_eth': value.token0_address_eth,
        'token1_address': value.token1_address,
        'token1_address_eth': value.token1_address_eth,
        'create_round': value.create_round,
        'reserve0': value.reserve0,
        'reserve1': value.reserve1,
        'last_sync_round': value.last_sync_round
    };
}

},{"../runtime":"ecR7o","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fFmAM":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 * The type of a EVM token.
 * @export
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EvmTokenType", ()=>EvmTokenType);
parcelHelpers.export(exports, "EvmTokenTypeFromJSON", ()=>EvmTokenTypeFromJSON);
parcelHelpers.export(exports, "EvmTokenTypeFromJSONTyped", ()=>EvmTokenTypeFromJSONTyped);
parcelHelpers.export(exports, "EvmTokenTypeToJSON", ()=>EvmTokenTypeToJSON);
var EvmTokenType = /*#__PURE__*/ function(EvmTokenType) {
    EvmTokenType["Erc20"] = "ERC20";
    EvmTokenType["Erc721"] = "ERC721";
    return EvmTokenType;
}({});
function EvmTokenTypeFromJSON(json) {
    return EvmTokenTypeFromJSONTyped(json, false);
}
function EvmTokenTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function EvmTokenTypeToJSON(value) {
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1UIYc":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InlineResponse400FromJSON", ()=>InlineResponse400FromJSON);
parcelHelpers.export(exports, "InlineResponse400FromJSONTyped", ()=>InlineResponse400FromJSONTyped);
parcelHelpers.export(exports, "InlineResponse400ToJSON", ()=>InlineResponse400ToJSON);
function InlineResponse400FromJSON(json) {
    return InlineResponse400FromJSONTyped(json, false);
}
function InlineResponse400FromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'msg': json['msg']
    };
}
function InlineResponse400ToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'msg': value.msg
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"izs4s":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layer", ()=>Layer);
parcelHelpers.export(exports, "LayerFromJSON", ()=>LayerFromJSON);
parcelHelpers.export(exports, "LayerFromJSONTyped", ()=>LayerFromJSONTyped);
parcelHelpers.export(exports, "LayerToJSON", ()=>LayerToJSON);
var Layer = /*#__PURE__*/ function(Layer) {
    Layer["Emerald"] = "emerald";
    Layer["Sapphire"] = "sapphire";
    Layer["Pontusxtest"] = "pontusxtest";
    Layer["Pontusxdev"] = "pontusxdev";
    Layer["Cipher"] = "cipher";
    Layer["Consensus"] = "consensus";
    return Layer;
}({});
function LayerFromJSON(json) {
    return LayerFromJSONTyped(json, false);
}
function LayerFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function LayerToJSON(value) {
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9EEjB":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListFromJSON", ()=>ListFromJSON);
parcelHelpers.export(exports, "ListFromJSONTyped", ()=>ListFromJSONTyped);
parcelHelpers.export(exports, "ListToJSON", ()=>ListToJSON);
function ListFromJSON(json) {
    return ListFromJSONTyped(json, false);
}
function ListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped']
    };
}
function ListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4r9cl":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NodeFromJSON", ()=>NodeFromJSON);
parcelHelpers.export(exports, "NodeFromJSONTyped", ()=>NodeFromJSONTyped);
parcelHelpers.export(exports, "NodeToJSON", ()=>NodeToJSON);
function NodeFromJSON(json) {
    return NodeFromJSONTyped(json, false);
}
function NodeFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'id': json['id'],
        'entity_id': json['entity_id'],
        'expiration': json['expiration'],
        'tls_pubkey': json['tls_pubkey'],
        'tls_next_pubkey': json['tls_next_pubkey'],
        'p2p_pubkey': json['p2p_pubkey'],
        'consensus_pubkey': json['consensus_pubkey'],
        'roles': json['roles']
    };
}
function NodeToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'id': value.id,
        'entity_id': value.entity_id,
        'expiration': value.expiration,
        'tls_pubkey': value.tls_pubkey,
        'tls_next_pubkey': value.tls_next_pubkey,
        'p2p_pubkey': value.p2p_pubkey,
        'consensus_pubkey': value.consensus_pubkey,
        'roles': value.roles
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"55zUe":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NodeListFromJSON", ()=>NodeListFromJSON);
parcelHelpers.export(exports, "NodeListFromJSONTyped", ()=>NodeListFromJSONTyped);
parcelHelpers.export(exports, "NodeListToJSON", ()=>NodeListToJSON);
var _ = require("./");
function NodeListFromJSON(json) {
    return NodeListFromJSONTyped(json, false);
}
function NodeListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'entity_id': json['entity_id'],
        'nodes': json['nodes'].map((0, _.NodeFromJSON))
    };
}
function NodeListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'entity_id': value.entity_id,
        'nodes': value.nodes.map((0, _.NodeToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1JA8E":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NodeListAllOfFromJSON", ()=>NodeListAllOfFromJSON);
parcelHelpers.export(exports, "NodeListAllOfFromJSONTyped", ()=>NodeListAllOfFromJSONTyped);
parcelHelpers.export(exports, "NodeListAllOfToJSON", ()=>NodeListAllOfToJSON);
var _ = require("./");
function NodeListAllOfFromJSON(json) {
    return NodeListAllOfFromJSONTyped(json, false);
}
function NodeListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'entity_id': json['entity_id'],
        'nodes': json['nodes'].map((0, _.NodeFromJSON))
    };
}
function NodeListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'entity_id': value.entity_id,
        'nodes': value.nodes.map((0, _.NodeToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kvBSS":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalFromJSON", ()=>ProposalFromJSON);
parcelHelpers.export(exports, "ProposalFromJSONTyped", ()=>ProposalFromJSONTyped);
parcelHelpers.export(exports, "ProposalToJSON", ()=>ProposalToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function ProposalFromJSON(json) {
    return ProposalFromJSONTyped(json, false);
}
function ProposalFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'id': json['id'],
        'submitter': json['submitter'],
        'state': (0, _.ProposalStateFromJSON)(json['state']),
        'deposit': json['deposit'],
        'title': !(0, _runtime.exists)(json, 'title') ? undefined : json['title'],
        'description': !(0, _runtime.exists)(json, 'description') ? undefined : json['description'],
        'handler': !(0, _runtime.exists)(json, 'handler') ? undefined : json['handler'],
        'target': !(0, _runtime.exists)(json, 'target') ? undefined : (0, _.ProposalTargetFromJSON)(json['target']),
        'epoch': !(0, _runtime.exists)(json, 'epoch') ? undefined : json['epoch'],
        'cancels': !(0, _runtime.exists)(json, 'cancels') ? undefined : json['cancels'],
        'parameters_change_module': !(0, _runtime.exists)(json, 'parameters_change_module') ? undefined : json['parameters_change_module'],
        'parameters_change': !(0, _runtime.exists)(json, 'parameters_change') ? undefined : json['parameters_change'],
        'created_at': json['created_at'],
        'closes_at': json['closes_at'],
        'invalid_votes': json['invalid_votes']
    };
}
function ProposalToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'id': value.id,
        'submitter': value.submitter,
        'state': (0, _.ProposalStateToJSON)(value.state),
        'deposit': value.deposit,
        'title': value.title,
        'description': value.description,
        'handler': value.handler,
        'target': (0, _.ProposalTargetToJSON)(value.target),
        'epoch': value.epoch,
        'cancels': value.cancels,
        'parameters_change_module': value.parameters_change_module,
        'parameters_change': value.parameters_change,
        'created_at': value.created_at,
        'closes_at': value.closes_at,
        'invalid_votes': value.invalid_votes
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8H7NN":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalListFromJSON", ()=>ProposalListFromJSON);
parcelHelpers.export(exports, "ProposalListFromJSONTyped", ()=>ProposalListFromJSONTyped);
parcelHelpers.export(exports, "ProposalListToJSON", ()=>ProposalListToJSON);
var _ = require("./");
function ProposalListFromJSON(json) {
    return ProposalListFromJSONTyped(json, false);
}
function ProposalListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'proposals': json['proposals'].map((0, _.ProposalFromJSON))
    };
}
function ProposalListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'proposals': value.proposals.map((0, _.ProposalToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aEt6M":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalListAllOfFromJSON", ()=>ProposalListAllOfFromJSON);
parcelHelpers.export(exports, "ProposalListAllOfFromJSONTyped", ()=>ProposalListAllOfFromJSONTyped);
parcelHelpers.export(exports, "ProposalListAllOfToJSON", ()=>ProposalListAllOfToJSON);
var _ = require("./");
function ProposalListAllOfFromJSON(json) {
    return ProposalListAllOfFromJSONTyped(json, false);
}
function ProposalListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'proposals': json['proposals'].map((0, _.ProposalFromJSON))
    };
}
function ProposalListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'proposals': value.proposals.map((0, _.ProposalToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eladH":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 * The state of the proposal.
 * @export
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalState", ()=>ProposalState);
parcelHelpers.export(exports, "ProposalStateFromJSON", ()=>ProposalStateFromJSON);
parcelHelpers.export(exports, "ProposalStateFromJSONTyped", ()=>ProposalStateFromJSONTyped);
parcelHelpers.export(exports, "ProposalStateToJSON", ()=>ProposalStateToJSON);
var ProposalState = /*#__PURE__*/ function(ProposalState) {
    ProposalState["Active"] = "active";
    ProposalState["Passed"] = "passed";
    ProposalState["Failed"] = "failed";
    ProposalState["Rejected"] = "rejected";
    return ProposalState;
}({});
function ProposalStateFromJSON(json) {
    return ProposalStateFromJSONTyped(json, false);
}
function ProposalStateFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ProposalStateToJSON(value) {
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"e1r2L":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalTargetFromJSON", ()=>ProposalTargetFromJSON);
parcelHelpers.export(exports, "ProposalTargetFromJSONTyped", ()=>ProposalTargetFromJSONTyped);
parcelHelpers.export(exports, "ProposalTargetToJSON", ()=>ProposalTargetToJSON);
var _runtime = require("../runtime");
function ProposalTargetFromJSON(json) {
    return ProposalTargetFromJSONTyped(json, false);
}
function ProposalTargetFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'consensus_protocol': !(0, _runtime.exists)(json, 'consensus_protocol') ? undefined : json['consensus_protocol'],
        'runtime_host_protocol': !(0, _runtime.exists)(json, 'runtime_host_protocol') ? undefined : json['runtime_host_protocol'],
        'runtime_committee_protocol': !(0, _runtime.exists)(json, 'runtime_committee_protocol') ? undefined : json['runtime_committee_protocol']
    };
}
function ProposalTargetToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'consensus_protocol': value.consensus_protocol,
        'runtime_host_protocol': value.runtime_host_protocol,
        'runtime_committee_protocol': value.runtime_committee_protocol
    };
}

},{"../runtime":"ecR7o","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3Cusi":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalVoteFromJSON", ()=>ProposalVoteFromJSON);
parcelHelpers.export(exports, "ProposalVoteFromJSONTyped", ()=>ProposalVoteFromJSONTyped);
parcelHelpers.export(exports, "ProposalVoteToJSON", ()=>ProposalVoteToJSON);
var _runtime = require("../runtime");
function ProposalVoteFromJSON(json) {
    return ProposalVoteFromJSONTyped(json, false);
}
function ProposalVoteFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address'],
        'vote': json['vote'],
        'height': !(0, _runtime.exists)(json, 'height') ? undefined : json['height'],
        'timestamp': !(0, _runtime.exists)(json, 'timestamp') ? undefined : new Date(json['timestamp'])
    };
}
function ProposalVoteToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address,
        'vote': value.vote,
        'height': value.height,
        'timestamp': value.timestamp === undefined ? undefined : value.timestamp.toISOString()
    };
}

},{"../runtime":"ecR7o","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gbPXA":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalVotesFromJSON", ()=>ProposalVotesFromJSON);
parcelHelpers.export(exports, "ProposalVotesFromJSONTyped", ()=>ProposalVotesFromJSONTyped);
parcelHelpers.export(exports, "ProposalVotesToJSON", ()=>ProposalVotesToJSON);
var _ = require("./");
function ProposalVotesFromJSON(json) {
    return ProposalVotesFromJSONTyped(json, false);
}
function ProposalVotesFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'proposal_id': json['proposal_id'],
        'votes': json['votes'].map((0, _.ProposalVoteFromJSON))
    };
}
function ProposalVotesToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'proposal_id': value.proposal_id,
        'votes': value.votes.map((0, _.ProposalVoteToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4uvBJ":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProposalVotesAllOfFromJSON", ()=>ProposalVotesAllOfFromJSON);
parcelHelpers.export(exports, "ProposalVotesAllOfFromJSONTyped", ()=>ProposalVotesAllOfFromJSONTyped);
parcelHelpers.export(exports, "ProposalVotesAllOfToJSON", ()=>ProposalVotesAllOfToJSON);
var _ = require("./");
function ProposalVotesAllOfFromJSON(json) {
    return ProposalVotesAllOfFromJSONTyped(json, false);
}
function ProposalVotesAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'proposal_id': json['proposal_id'],
        'votes': json['votes'].map((0, _.ProposalVoteFromJSON))
    };
}
function ProposalVotesAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'proposal_id': value.proposal_id,
        'votes': value.votes.map((0, _.ProposalVoteToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bY8HE":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RoothashMessageFromJSON", ()=>RoothashMessageFromJSON);
parcelHelpers.export(exports, "RoothashMessageFromJSONTyped", ()=>RoothashMessageFromJSONTyped);
parcelHelpers.export(exports, "RoothashMessageToJSON", ()=>RoothashMessageToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function RoothashMessageFromJSON(json) {
    return RoothashMessageFromJSONTyped(json, false);
}
function RoothashMessageFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'runtime': json['runtime'],
        'round': json['round'],
        'index': json['index'],
        'type': !(0, _runtime.exists)(json, 'type') ? undefined : (0, _.RoothashMessageTypeFromJSON)(json['type']),
        'body': !(0, _runtime.exists)(json, 'body') ? undefined : json['body'],
        'error_module': !(0, _runtime.exists)(json, 'error_module') ? undefined : json['error_module'],
        'error_code': !(0, _runtime.exists)(json, 'error_code') ? undefined : json['error_code'],
        'result': !(0, _runtime.exists)(json, 'result') ? undefined : json['result']
    };
}
function RoothashMessageToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'runtime': value.runtime,
        'round': value.round,
        'index': value.index,
        'type': (0, _.RoothashMessageTypeToJSON)(value.type),
        'body': value.body,
        'error_module': value.error_module,
        'error_code': value.error_code,
        'result': value.result
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"SVgXQ":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RoothashMessageListFromJSON", ()=>RoothashMessageListFromJSON);
parcelHelpers.export(exports, "RoothashMessageListFromJSONTyped", ()=>RoothashMessageListFromJSONTyped);
parcelHelpers.export(exports, "RoothashMessageListToJSON", ()=>RoothashMessageListToJSON);
var _ = require("./");
function RoothashMessageListFromJSON(json) {
    return RoothashMessageListFromJSONTyped(json, false);
}
function RoothashMessageListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'roothash_messages': json['roothash_messages'].map((0, _.RoothashMessageFromJSON))
    };
}
function RoothashMessageListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'roothash_messages': value.roothash_messages.map((0, _.RoothashMessageToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jkxn6":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RoothashMessageListAllOfFromJSON", ()=>RoothashMessageListAllOfFromJSON);
parcelHelpers.export(exports, "RoothashMessageListAllOfFromJSONTyped", ()=>RoothashMessageListAllOfFromJSONTyped);
parcelHelpers.export(exports, "RoothashMessageListAllOfToJSON", ()=>RoothashMessageListAllOfToJSON);
var _ = require("./");
function RoothashMessageListAllOfFromJSON(json) {
    return RoothashMessageListAllOfFromJSONTyped(json, false);
}
function RoothashMessageListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'roothash_messages': json['roothash_messages'].map((0, _.RoothashMessageFromJSON))
    };
}
function RoothashMessageListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'roothash_messages': value.roothash_messages.map((0, _.RoothashMessageToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"e7XB9":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RoothashMessageType", ()=>RoothashMessageType);
parcelHelpers.export(exports, "RoothashMessageTypeFromJSON", ()=>RoothashMessageTypeFromJSON);
parcelHelpers.export(exports, "RoothashMessageTypeFromJSONTyped", ()=>RoothashMessageTypeFromJSONTyped);
parcelHelpers.export(exports, "RoothashMessageTypeToJSON", ()=>RoothashMessageTypeToJSON);
var RoothashMessageType = /*#__PURE__*/ function(RoothashMessageType) {
    RoothashMessageType["StakingTransfer"] = "staking.transfer";
    RoothashMessageType["StakingWithdraw"] = "staking.withdraw";
    RoothashMessageType["StakingAddEscrow"] = "staking.add_escrow";
    RoothashMessageType["StakingReclaimEscrow"] = "staking.reclaim_escrow";
    RoothashMessageType["RegistryUpdateRuntime"] = "registry.update_runtime";
    RoothashMessageType["GovernanceCastVote"] = "governance.cast_vote";
    RoothashMessageType["GovernanceSubmitProposal"] = "governance.submit_proposal";
    return RoothashMessageType;
}({});
function RoothashMessageTypeFromJSON(json) {
    return RoothashMessageTypeFromJSONTyped(json, false);
}
function RoothashMessageTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function RoothashMessageTypeToJSON(value) {
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dk0gk":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Runtime", ()=>Runtime);
parcelHelpers.export(exports, "RuntimeFromJSON", ()=>RuntimeFromJSON);
parcelHelpers.export(exports, "RuntimeFromJSONTyped", ()=>RuntimeFromJSONTyped);
parcelHelpers.export(exports, "RuntimeToJSON", ()=>RuntimeToJSON);
var Runtime = /*#__PURE__*/ function(Runtime) {
    Runtime["Emerald"] = "emerald";
    Runtime["Sapphire"] = "sapphire";
    Runtime["Pontusxtest"] = "pontusxtest";
    Runtime["Pontusxdev"] = "pontusxdev";
    Runtime["Cipher"] = "cipher";
    return Runtime;
}({});
function RuntimeFromJSON(json) {
    return RuntimeFromJSONTyped(json, false);
}
function RuntimeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function RuntimeToJSON(value) {
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dzj5k":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeAccountFromJSON", ()=>RuntimeAccountFromJSON);
parcelHelpers.export(exports, "RuntimeAccountFromJSONTyped", ()=>RuntimeAccountFromJSONTyped);
parcelHelpers.export(exports, "RuntimeAccountToJSON", ()=>RuntimeAccountToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function RuntimeAccountFromJSON(json) {
    return RuntimeAccountFromJSONTyped(json, false);
}
function RuntimeAccountFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address'],
        'address_preimage': !(0, _runtime.exists)(json, 'address_preimage') ? undefined : (0, _.AddressPreimageFromJSON)(json['address_preimage']),
        'balances': json['balances'].map((0, _.RuntimeSdkBalanceFromJSON)),
        'evm_contract': !(0, _runtime.exists)(json, 'evm_contract') ? undefined : (0, _.RuntimeEvmContractFromJSON)(json['evm_contract']),
        'evm_balances': json['evm_balances'].map((0, _.RuntimeEvmBalanceFromJSON)),
        'stats': (0, _.AccountStatsFromJSON)(json['stats'])
    };
}
function RuntimeAccountToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address,
        'address_preimage': (0, _.AddressPreimageToJSON)(value.address_preimage),
        'balances': value.balances.map((0, _.RuntimeSdkBalanceToJSON)),
        'evm_contract': (0, _.RuntimeEvmContractToJSON)(value.evm_contract),
        'evm_balances': value.evm_balances.map((0, _.RuntimeEvmBalanceToJSON)),
        'stats': (0, _.AccountStatsToJSON)(value.stats)
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jmje7":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeBlockFromJSON", ()=>RuntimeBlockFromJSON);
parcelHelpers.export(exports, "RuntimeBlockFromJSONTyped", ()=>RuntimeBlockFromJSONTyped);
parcelHelpers.export(exports, "RuntimeBlockToJSON", ()=>RuntimeBlockToJSON);
function RuntimeBlockFromJSON(json) {
    return RuntimeBlockFromJSONTyped(json, false);
}
function RuntimeBlockFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'round': json['round'],
        'hash': json['hash'],
        'timestamp': new Date(json['timestamp']),
        'num_transactions': json['num_transactions'],
        'size': json['size'],
        'gas_used': json['gas_used']
    };
}
function RuntimeBlockToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'round': value.round,
        'hash': value.hash,
        'timestamp': value.timestamp.toISOString(),
        'num_transactions': value.num_transactions,
        'size': value.size,
        'gas_used': value.gas_used
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cEVaT":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeBlockListFromJSON", ()=>RuntimeBlockListFromJSON);
parcelHelpers.export(exports, "RuntimeBlockListFromJSONTyped", ()=>RuntimeBlockListFromJSONTyped);
parcelHelpers.export(exports, "RuntimeBlockListToJSON", ()=>RuntimeBlockListToJSON);
var _ = require("./");
function RuntimeBlockListFromJSON(json) {
    return RuntimeBlockListFromJSONTyped(json, false);
}
function RuntimeBlockListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'blocks': json['blocks'].map((0, _.RuntimeBlockFromJSON))
    };
}
function RuntimeBlockListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'blocks': value.blocks.map((0, _.RuntimeBlockToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7n2i6":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeBlockListAllOfFromJSON", ()=>RuntimeBlockListAllOfFromJSON);
parcelHelpers.export(exports, "RuntimeBlockListAllOfFromJSONTyped", ()=>RuntimeBlockListAllOfFromJSONTyped);
parcelHelpers.export(exports, "RuntimeBlockListAllOfToJSON", ()=>RuntimeBlockListAllOfToJSON);
var _ = require("./");
function RuntimeBlockListAllOfFromJSON(json) {
    return RuntimeBlockListAllOfFromJSONTyped(json, false);
}
function RuntimeBlockListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'blocks': json['blocks'].map((0, _.RuntimeBlockFromJSON))
    };
}
function RuntimeBlockListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'blocks': value.blocks.map((0, _.RuntimeBlockToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lgUJK":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeEventFromJSON", ()=>RuntimeEventFromJSON);
parcelHelpers.export(exports, "RuntimeEventFromJSONTyped", ()=>RuntimeEventFromJSONTyped);
parcelHelpers.export(exports, "RuntimeEventToJSON", ()=>RuntimeEventToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function RuntimeEventFromJSON(json) {
    return RuntimeEventFromJSONTyped(json, false);
}
function RuntimeEventFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'round': json['round'],
        'tx_index': !(0, _runtime.exists)(json, 'tx_index') ? undefined : json['tx_index'],
        'tx_hash': !(0, _runtime.exists)(json, 'tx_hash') ? undefined : json['tx_hash'],
        'eth_tx_hash': !(0, _runtime.exists)(json, 'eth_tx_hash') ? undefined : json['eth_tx_hash'],
        'timestamp': new Date(json['timestamp']),
        'type': (0, _.RuntimeEventTypeFromJSON)(json['type']),
        'body': json['body'],
        'evm_log_name': !(0, _runtime.exists)(json, 'evm_log_name') ? undefined : json['evm_log_name'],
        'evm_log_params': !(0, _runtime.exists)(json, 'evm_log_params') ? undefined : json['evm_log_params'].map((0, _.EvmAbiParamFromJSON)),
        'evm_token': !(0, _runtime.exists)(json, 'evm_token') ? undefined : (0, _.EvmEventTokenFromJSON)(json['evm_token'])
    };
}
function RuntimeEventToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'round': value.round,
        'tx_index': value.tx_index,
        'tx_hash': value.tx_hash,
        'eth_tx_hash': value.eth_tx_hash,
        'timestamp': value.timestamp.toISOString(),
        'type': (0, _.RuntimeEventTypeToJSON)(value.type),
        'body': value.body,
        'evm_log_name': value.evm_log_name,
        'evm_log_params': value.evm_log_params === undefined ? undefined : value.evm_log_params.map((0, _.EvmAbiParamToJSON)),
        'evm_token': (0, _.EvmEventTokenToJSON)(value.evm_token)
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aaiKL":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeEventListFromJSON", ()=>RuntimeEventListFromJSON);
parcelHelpers.export(exports, "RuntimeEventListFromJSONTyped", ()=>RuntimeEventListFromJSONTyped);
parcelHelpers.export(exports, "RuntimeEventListToJSON", ()=>RuntimeEventListToJSON);
var _ = require("./");
function RuntimeEventListFromJSON(json) {
    return RuntimeEventListFromJSONTyped(json, false);
}
function RuntimeEventListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'events': json['events'].map((0, _.RuntimeEventFromJSON))
    };
}
function RuntimeEventListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'events': value.events.map((0, _.RuntimeEventToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hGbdF":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeEventListAllOfFromJSON", ()=>RuntimeEventListAllOfFromJSON);
parcelHelpers.export(exports, "RuntimeEventListAllOfFromJSONTyped", ()=>RuntimeEventListAllOfFromJSONTyped);
parcelHelpers.export(exports, "RuntimeEventListAllOfToJSON", ()=>RuntimeEventListAllOfToJSON);
var _ = require("./");
function RuntimeEventListAllOfFromJSON(json) {
    return RuntimeEventListAllOfFromJSONTyped(json, false);
}
function RuntimeEventListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'events': json['events'].map((0, _.RuntimeEventFromJSON))
    };
}
function RuntimeEventListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'events': value.events.map((0, _.RuntimeEventToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bZxjv":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 * 
 * @export
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeEventType", ()=>RuntimeEventType);
parcelHelpers.export(exports, "RuntimeEventTypeFromJSON", ()=>RuntimeEventTypeFromJSON);
parcelHelpers.export(exports, "RuntimeEventTypeFromJSONTyped", ()=>RuntimeEventTypeFromJSONTyped);
parcelHelpers.export(exports, "RuntimeEventTypeToJSON", ()=>RuntimeEventTypeToJSON);
var RuntimeEventType = /*#__PURE__*/ function(RuntimeEventType) {
    RuntimeEventType["AccountsTransfer"] = "accounts.transfer";
    RuntimeEventType["AccountsBurn"] = "accounts.burn";
    RuntimeEventType["AccountsMint"] = "accounts.mint";
    RuntimeEventType["ConsensusAccountsDeposit"] = "consensus_accounts.deposit";
    RuntimeEventType["ConsensusAccountsWithdraw"] = "consensus_accounts.withdraw";
    RuntimeEventType["ConsensusAccountsDelegate"] = "consensus_accounts.delegate";
    RuntimeEventType["ConsensusAccountsUndelegateStart"] = "consensus_accounts.undelegate_start";
    RuntimeEventType["ConsensusAccountsUndelegateDone"] = "consensus_accounts.undelegate_done";
    RuntimeEventType["CoreGasUsed"] = "core.gas_used";
    RuntimeEventType["EvmLog"] = "evm.log";
    RuntimeEventType["RoflAppCreated"] = "rofl.app_created";
    RuntimeEventType["RoflAppUpdated"] = "rofl.app_updated";
    RuntimeEventType["RoflAppRemoved"] = "rofl.app_removed";
    return RuntimeEventType;
}({});
function RuntimeEventTypeFromJSON(json) {
    return RuntimeEventTypeFromJSONTyped(json, false);
}
function RuntimeEventTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function RuntimeEventTypeToJSON(value) {
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9SEfU":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeEvmBalanceFromJSON", ()=>RuntimeEvmBalanceFromJSON);
parcelHelpers.export(exports, "RuntimeEvmBalanceFromJSONTyped", ()=>RuntimeEvmBalanceFromJSONTyped);
parcelHelpers.export(exports, "RuntimeEvmBalanceToJSON", ()=>RuntimeEvmBalanceToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function RuntimeEvmBalanceFromJSON(json) {
    return RuntimeEvmBalanceFromJSONTyped(json, false);
}
function RuntimeEvmBalanceFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'balance': json['balance'],
        'token_contract_addr': json['token_contract_addr'],
        'token_contract_addr_eth': json['token_contract_addr_eth'],
        'token_symbol': !(0, _runtime.exists)(json, 'token_symbol') ? undefined : json['token_symbol'],
        'token_name': !(0, _runtime.exists)(json, 'token_name') ? undefined : json['token_name'],
        'token_type': (0, _.EvmTokenTypeFromJSON)(json['token_type']),
        'token_decimals': json['token_decimals']
    };
}
function RuntimeEvmBalanceToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'balance': value.balance,
        'token_contract_addr': value.token_contract_addr,
        'token_contract_addr_eth': value.token_contract_addr_eth,
        'token_symbol': value.token_symbol,
        'token_name': value.token_name,
        'token_type': (0, _.EvmTokenTypeToJSON)(value.token_type),
        'token_decimals': value.token_decimals
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eMonu":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeEvmContractFromJSON", ()=>RuntimeEvmContractFromJSON);
parcelHelpers.export(exports, "RuntimeEvmContractFromJSONTyped", ()=>RuntimeEvmContractFromJSONTyped);
parcelHelpers.export(exports, "RuntimeEvmContractToJSON", ()=>RuntimeEvmContractToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function RuntimeEvmContractFromJSON(json) {
    return RuntimeEvmContractFromJSONTyped(json, false);
}
function RuntimeEvmContractFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'creation_tx': !(0, _runtime.exists)(json, 'creation_tx') ? undefined : json['creation_tx'],
        'eth_creation_tx': !(0, _runtime.exists)(json, 'eth_creation_tx') ? undefined : json['eth_creation_tx'],
        'creation_bytecode': !(0, _runtime.exists)(json, 'creation_bytecode') ? undefined : json['creation_bytecode'],
        'runtime_bytecode': !(0, _runtime.exists)(json, 'runtime_bytecode') ? undefined : json['runtime_bytecode'],
        'gas_used': json['gas_used'],
        'verification': !(0, _runtime.exists)(json, 'verification') ? undefined : (0, _.RuntimeEvmContractVerificationFromJSON)(json['verification'])
    };
}
function RuntimeEvmContractToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'creation_tx': value.creation_tx,
        'eth_creation_tx': value.eth_creation_tx,
        'creation_bytecode': value.creation_bytecode,
        'runtime_bytecode': value.runtime_bytecode,
        'gas_used': value.gas_used,
        'verification': (0, _.RuntimeEvmContractVerificationToJSON)(value.verification)
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4mGD8":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeEvmContractVerificationFromJSON", ()=>RuntimeEvmContractVerificationFromJSON);
parcelHelpers.export(exports, "RuntimeEvmContractVerificationFromJSONTyped", ()=>RuntimeEvmContractVerificationFromJSONTyped);
parcelHelpers.export(exports, "RuntimeEvmContractVerificationToJSON", ()=>RuntimeEvmContractVerificationToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function RuntimeEvmContractVerificationFromJSON(json) {
    return RuntimeEvmContractVerificationFromJSONTyped(json, false);
}
function RuntimeEvmContractVerificationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'verification_level': !(0, _runtime.exists)(json, 'verification_level') ? undefined : (0, _.VerificationLevelFromJSON)(json['verification_level']),
        'compilation_metadata': !(0, _runtime.exists)(json, 'compilation_metadata') ? undefined : json['compilation_metadata'],
        'source_files': !(0, _runtime.exists)(json, 'source_files') ? undefined : json['source_files']
    };
}
function RuntimeEvmContractVerificationToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'verification_level': (0, _.VerificationLevelToJSON)(value.verification_level),
        'compilation_metadata': value.compilation_metadata,
        'source_files': value.source_files
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6XUfO":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeSdkBalanceFromJSON", ()=>RuntimeSdkBalanceFromJSON);
parcelHelpers.export(exports, "RuntimeSdkBalanceFromJSONTyped", ()=>RuntimeSdkBalanceFromJSONTyped);
parcelHelpers.export(exports, "RuntimeSdkBalanceToJSON", ()=>RuntimeSdkBalanceToJSON);
function RuntimeSdkBalanceFromJSON(json) {
    return RuntimeSdkBalanceFromJSONTyped(json, false);
}
function RuntimeSdkBalanceFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'balance': json['balance'],
        'token_symbol': json['token_symbol'],
        'token_decimals': json['token_decimals']
    };
}
function RuntimeSdkBalanceToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'balance': value.balance,
        'token_symbol': value.token_symbol,
        'token_decimals': value.token_decimals
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6JMcZ":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeStatusFromJSON", ()=>RuntimeStatusFromJSON);
parcelHelpers.export(exports, "RuntimeStatusFromJSONTyped", ()=>RuntimeStatusFromJSONTyped);
parcelHelpers.export(exports, "RuntimeStatusToJSON", ()=>RuntimeStatusToJSON);
function RuntimeStatusFromJSON(json) {
    return RuntimeStatusFromJSONTyped(json, false);
}
function RuntimeStatusFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'active_nodes': json['active_nodes'],
        'latest_block': json['latest_block'],
        'latest_block_time': new Date(json['latest_block_time']),
        'latest_update_age_ms': json['latest_update_age_ms']
    };
}
function RuntimeStatusToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'active_nodes': value.active_nodes,
        'latest_block': value.latest_block,
        'latest_block_time': value.latest_block_time.toISOString(),
        'latest_update_age_ms': value.latest_update_age_ms
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9hnFq":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactionFromJSON", ()=>RuntimeTransactionFromJSON);
parcelHelpers.export(exports, "RuntimeTransactionFromJSONTyped", ()=>RuntimeTransactionFromJSONTyped);
parcelHelpers.export(exports, "RuntimeTransactionToJSON", ()=>RuntimeTransactionToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function RuntimeTransactionFromJSON(json) {
    return RuntimeTransactionFromJSONTyped(json, false);
}
function RuntimeTransactionFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'round': json['round'],
        'index': json['index'],
        'timestamp': new Date(json['timestamp']),
        'hash': json['hash'],
        'eth_hash': !(0, _runtime.exists)(json, 'eth_hash') ? undefined : json['eth_hash'],
        'signers': json['signers'].map((0, _.RuntimeTransactionSignerFromJSON)),
        'sender_0': json['sender_0'],
        'sender_0_eth': !(0, _runtime.exists)(json, 'sender_0_eth') ? undefined : json['sender_0_eth'],
        'nonce_0': json['nonce_0'],
        'fee': json['fee'],
        'fee_symbol': json['fee_symbol'],
        'fee_proxy_module': !(0, _runtime.exists)(json, 'fee_proxy_module') ? undefined : json['fee_proxy_module'],
        'fee_proxy_id': !(0, _runtime.exists)(json, 'fee_proxy_id') ? undefined : json['fee_proxy_id'],
        'gas_limit': json['gas_limit'],
        'gas_used': json['gas_used'],
        'charged_fee': json['charged_fee'],
        'size': json['size'],
        'oasis_encryption_envelope': !(0, _runtime.exists)(json, 'oasis_encryption_envelope') ? undefined : (0, _.RuntimeTransactionEncryptionEnvelopeFromJSON)(json['oasis_encryption_envelope']),
        'method': !(0, _runtime.exists)(json, 'method') ? undefined : json['method'],
        'body': !(0, _runtime.exists)(json, 'body') ? undefined : json['body'],
        'is_likely_native_token_transfer': !(0, _runtime.exists)(json, 'is_likely_native_token_transfer') ? undefined : json['is_likely_native_token_transfer'],
        'to': !(0, _runtime.exists)(json, 'to') ? undefined : json['to'],
        'to_eth': !(0, _runtime.exists)(json, 'to_eth') ? undefined : json['to_eth'],
        'amount': !(0, _runtime.exists)(json, 'amount') ? undefined : json['amount'],
        'amount_symbol': !(0, _runtime.exists)(json, 'amount_symbol') ? undefined : json['amount_symbol'],
        'encryption_envelope': !(0, _runtime.exists)(json, 'encryption_envelope') ? undefined : (0, _.RuntimeTransactionEncryptionEnvelopeFromJSON)(json['encryption_envelope']),
        'success': !(0, _runtime.exists)(json, 'success') ? undefined : json['success'],
        'evm_fn_name': !(0, _runtime.exists)(json, 'evm_fn_name') ? undefined : json['evm_fn_name'],
        'evm_fn_params': !(0, _runtime.exists)(json, 'evm_fn_params') ? undefined : json['evm_fn_params'].map((0, _.EvmAbiParamFromJSON)),
        'error': !(0, _runtime.exists)(json, 'error') ? undefined : (0, _.TxErrorFromJSON)(json['error'])
    };
}
function RuntimeTransactionToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'round': value.round,
        'index': value.index,
        'timestamp': value.timestamp.toISOString(),
        'hash': value.hash,
        'eth_hash': value.eth_hash,
        'signers': value.signers.map((0, _.RuntimeTransactionSignerToJSON)),
        'sender_0': value.sender_0,
        'sender_0_eth': value.sender_0_eth,
        'nonce_0': value.nonce_0,
        'fee': value.fee,
        'fee_symbol': value.fee_symbol,
        'fee_proxy_module': value.fee_proxy_module,
        'fee_proxy_id': value.fee_proxy_id,
        'gas_limit': value.gas_limit,
        'gas_used': value.gas_used,
        'charged_fee': value.charged_fee,
        'size': value.size,
        'oasis_encryption_envelope': (0, _.RuntimeTransactionEncryptionEnvelopeToJSON)(value.oasis_encryption_envelope),
        'method': value.method,
        'body': value.body,
        'is_likely_native_token_transfer': value.is_likely_native_token_transfer,
        'to': value.to,
        'to_eth': value.to_eth,
        'amount': value.amount,
        'amount_symbol': value.amount_symbol,
        'encryption_envelope': (0, _.RuntimeTransactionEncryptionEnvelopeToJSON)(value.encryption_envelope),
        'success': value.success,
        'evm_fn_name': value.evm_fn_name,
        'evm_fn_params': value.evm_fn_params === undefined ? undefined : value.evm_fn_params.map((0, _.EvmAbiParamToJSON)),
        'error': (0, _.TxErrorToJSON)(value.error)
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5nJYx":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactionEncryptionEnvelopeFromJSON", ()=>RuntimeTransactionEncryptionEnvelopeFromJSON);
parcelHelpers.export(exports, "RuntimeTransactionEncryptionEnvelopeFromJSONTyped", ()=>RuntimeTransactionEncryptionEnvelopeFromJSONTyped);
parcelHelpers.export(exports, "RuntimeTransactionEncryptionEnvelopeToJSON", ()=>RuntimeTransactionEncryptionEnvelopeToJSON);
var _runtime = require("../runtime");
function RuntimeTransactionEncryptionEnvelopeFromJSON(json) {
    return RuntimeTransactionEncryptionEnvelopeFromJSONTyped(json, false);
}
function RuntimeTransactionEncryptionEnvelopeFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'format': json['format'],
        'public_key': !(0, _runtime.exists)(json, 'public_key') ? undefined : json['public_key'],
        'data_nonce': !(0, _runtime.exists)(json, 'data_nonce') ? undefined : json['data_nonce'],
        'data': !(0, _runtime.exists)(json, 'data') ? undefined : json['data'],
        'result_nonce': !(0, _runtime.exists)(json, 'result_nonce') ? undefined : json['result_nonce'],
        'result': !(0, _runtime.exists)(json, 'result') ? undefined : json['result']
    };
}
function RuntimeTransactionEncryptionEnvelopeToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'format': value.format,
        'public_key': value.public_key,
        'data_nonce': value.data_nonce,
        'data': value.data,
        'result_nonce': value.result_nonce,
        'result': value.result
    };
}

},{"../runtime":"ecR7o","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cqVK4":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactionListFromJSON", ()=>RuntimeTransactionListFromJSON);
parcelHelpers.export(exports, "RuntimeTransactionListFromJSONTyped", ()=>RuntimeTransactionListFromJSONTyped);
parcelHelpers.export(exports, "RuntimeTransactionListToJSON", ()=>RuntimeTransactionListToJSON);
var _ = require("./");
function RuntimeTransactionListFromJSON(json) {
    return RuntimeTransactionListFromJSONTyped(json, false);
}
function RuntimeTransactionListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'transactions': json['transactions'].map((0, _.RuntimeTransactionFromJSON))
    };
}
function RuntimeTransactionListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'transactions': value.transactions.map((0, _.RuntimeTransactionToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5XnIJ":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactionListAllOfFromJSON", ()=>RuntimeTransactionListAllOfFromJSON);
parcelHelpers.export(exports, "RuntimeTransactionListAllOfFromJSONTyped", ()=>RuntimeTransactionListAllOfFromJSONTyped);
parcelHelpers.export(exports, "RuntimeTransactionListAllOfToJSON", ()=>RuntimeTransactionListAllOfToJSON);
var _ = require("./");
function RuntimeTransactionListAllOfFromJSON(json) {
    return RuntimeTransactionListAllOfFromJSONTyped(json, false);
}
function RuntimeTransactionListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'transactions': json['transactions'].map((0, _.RuntimeTransactionFromJSON))
    };
}
function RuntimeTransactionListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'transactions': value.transactions.map((0, _.RuntimeTransactionToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4fsyk":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RuntimeTransactionSignerFromJSON", ()=>RuntimeTransactionSignerFromJSON);
parcelHelpers.export(exports, "RuntimeTransactionSignerFromJSONTyped", ()=>RuntimeTransactionSignerFromJSONTyped);
parcelHelpers.export(exports, "RuntimeTransactionSignerToJSON", ()=>RuntimeTransactionSignerToJSON);
var _runtime = require("../runtime");
function RuntimeTransactionSignerFromJSON(json) {
    return RuntimeTransactionSignerFromJSONTyped(json, false);
}
function RuntimeTransactionSignerFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': json['address'],
        'address_eth': !(0, _runtime.exists)(json, 'address_eth') ? undefined : json['address_eth'],
        'nonce': json['nonce']
    };
}
function RuntimeTransactionSignerToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address,
        'address_eth': value.address_eth,
        'nonce': value.nonce
    };
}

},{"../runtime":"ecR7o","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"airxR":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusFromJSON", ()=>StatusFromJSON);
parcelHelpers.export(exports, "StatusFromJSONTyped", ()=>StatusFromJSONTyped);
parcelHelpers.export(exports, "StatusToJSON", ()=>StatusToJSON);
function StatusFromJSON(json) {
    return StatusFromJSONTyped(json, false);
}
function StatusFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'latest_block': json['latest_block'],
        'latest_node_block': json['latest_node_block'],
        'latest_block_time': new Date(json['latest_block_time']),
        'latest_update_age_ms': json['latest_update_age_ms']
    };
}
function StatusToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'latest_block': value.latest_block,
        'latest_node_block': value.latest_node_block,
        'latest_block_time': value.latest_block_time.toISOString(),
        'latest_update_age_ms': value.latest_update_age_ms
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1ch70":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenHolderListFromJSON", ()=>TokenHolderListFromJSON);
parcelHelpers.export(exports, "TokenHolderListFromJSONTyped", ()=>TokenHolderListFromJSONTyped);
parcelHelpers.export(exports, "TokenHolderListToJSON", ()=>TokenHolderListToJSON);
var _ = require("./");
function TokenHolderListFromJSON(json) {
    return TokenHolderListFromJSONTyped(json, false);
}
function TokenHolderListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'holders': json['holders'].map((0, _.BareTokenHolderFromJSON))
    };
}
function TokenHolderListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'holders': value.holders.map((0, _.BareTokenHolderToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1cQw4":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TokenHolderListAllOfFromJSON", ()=>TokenHolderListAllOfFromJSON);
parcelHelpers.export(exports, "TokenHolderListAllOfFromJSONTyped", ()=>TokenHolderListAllOfFromJSONTyped);
parcelHelpers.export(exports, "TokenHolderListAllOfToJSON", ()=>TokenHolderListAllOfToJSON);
var _ = require("./");
function TokenHolderListAllOfFromJSON(json) {
    return TokenHolderListAllOfFromJSONTyped(json, false);
}
function TokenHolderListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'holders': json['holders'].map((0, _.BareTokenHolderFromJSON))
    };
}
function TokenHolderListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'holders': value.holders.map((0, _.BareTokenHolderToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7XkJD":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionFromJSON", ()=>TransactionFromJSON);
parcelHelpers.export(exports, "TransactionFromJSONTyped", ()=>TransactionFromJSONTyped);
parcelHelpers.export(exports, "TransactionToJSON", ()=>TransactionToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function TransactionFromJSON(json) {
    return TransactionFromJSONTyped(json, false);
}
function TransactionFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'block': json['block'],
        'index': json['index'],
        'timestamp': new Date(json['timestamp']),
        'hash': json['hash'],
        'sender': json['sender'],
        'nonce': json['nonce'],
        'fee': json['fee'],
        'gas_limit': json['gas_limit'],
        'method': (0, _.ConsensusTxMethodFromJSON)(json['method']),
        'body': json['body'],
        'success': json['success'],
        'error': !(0, _runtime.exists)(json, 'error') ? undefined : (0, _.TxErrorFromJSON)(json['error'])
    };
}
function TransactionToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'block': value.block,
        'index': value.index,
        'timestamp': value.timestamp.toISOString(),
        'hash': value.hash,
        'sender': value.sender,
        'nonce': value.nonce,
        'fee': value.fee,
        'gas_limit': value.gas_limit,
        'method': (0, _.ConsensusTxMethodToJSON)(value.method),
        'body': value.body,
        'success': value.success,
        'error': (0, _.TxErrorToJSON)(value.error)
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5z0lS":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionListFromJSON", ()=>TransactionListFromJSON);
parcelHelpers.export(exports, "TransactionListFromJSONTyped", ()=>TransactionListFromJSONTyped);
parcelHelpers.export(exports, "TransactionListToJSON", ()=>TransactionListToJSON);
var _ = require("./");
function TransactionListFromJSON(json) {
    return TransactionListFromJSONTyped(json, false);
}
function TransactionListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'transactions': json['transactions'].map((0, _.TransactionFromJSON))
    };
}
function TransactionListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'transactions': value.transactions.map((0, _.TransactionToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2ice8":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionListAllOfFromJSON", ()=>TransactionListAllOfFromJSON);
parcelHelpers.export(exports, "TransactionListAllOfFromJSONTyped", ()=>TransactionListAllOfFromJSONTyped);
parcelHelpers.export(exports, "TransactionListAllOfToJSON", ()=>TransactionListAllOfToJSON);
var _ = require("./");
function TransactionListAllOfFromJSON(json) {
    return TransactionListAllOfFromJSONTyped(json, false);
}
function TransactionListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'transactions': json['transactions'].map((0, _.TransactionFromJSON))
    };
}
function TransactionListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'transactions': value.transactions.map((0, _.TransactionToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2o8GS":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TxErrorFromJSON", ()=>TxErrorFromJSON);
parcelHelpers.export(exports, "TxErrorFromJSONTyped", ()=>TxErrorFromJSONTyped);
parcelHelpers.export(exports, "TxErrorToJSON", ()=>TxErrorToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function TxErrorFromJSON(json) {
    return TxErrorFromJSONTyped(json, false);
}
function TxErrorFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'module': !(0, _runtime.exists)(json, 'module') ? undefined : json['module'],
        'code': json['code'],
        'message': !(0, _runtime.exists)(json, 'message') ? undefined : json['message'],
        'revert_params': !(0, _runtime.exists)(json, 'revert_params') ? undefined : json['revert_params'].map((0, _.EvmAbiParamFromJSON))
    };
}
function TxErrorToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'module': value.module,
        'code': value.code,
        'message': value.message,
        'revert_params': value.revert_params === undefined ? undefined : value.revert_params.map((0, _.EvmAbiParamToJSON))
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gs5NW":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TxVolumeFromJSON", ()=>TxVolumeFromJSON);
parcelHelpers.export(exports, "TxVolumeFromJSONTyped", ()=>TxVolumeFromJSONTyped);
parcelHelpers.export(exports, "TxVolumeToJSON", ()=>TxVolumeToJSON);
function TxVolumeFromJSON(json) {
    return TxVolumeFromJSONTyped(json, false);
}
function TxVolumeFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'window_end': new Date(json['window_end']),
        'tx_volume': json['tx_volume']
    };
}
function TxVolumeToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'window_end': value.window_end.toISOString(),
        'tx_volume': value.tx_volume
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ainOa":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TxVolumeListFromJSON", ()=>TxVolumeListFromJSON);
parcelHelpers.export(exports, "TxVolumeListFromJSONTyped", ()=>TxVolumeListFromJSONTyped);
parcelHelpers.export(exports, "TxVolumeListToJSON", ()=>TxVolumeListToJSON);
var _ = require("./");
function TxVolumeListFromJSON(json) {
    return TxVolumeListFromJSONTyped(json, false);
}
function TxVolumeListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'window_size_seconds': json['window_size_seconds'],
        'windows': json['windows'].map((0, _.TxVolumeFromJSON))
    };
}
function TxVolumeListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'window_size_seconds': value.window_size_seconds,
        'windows': value.windows.map((0, _.TxVolumeToJSON))
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4dxgM":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorFromJSON", ()=>ValidatorFromJSON);
parcelHelpers.export(exports, "ValidatorFromJSONTyped", ()=>ValidatorFromJSONTyped);
parcelHelpers.export(exports, "ValidatorToJSON", ()=>ValidatorToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function ValidatorFromJSON(json) {
    return ValidatorFromJSONTyped(json, false);
}
function ValidatorFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'entity_address': json['entity_address'],
        'entity_id': json['entity_id'],
        'node_id': !(0, _runtime.exists)(json, 'node_id') ? undefined : json['node_id'],
        'escrow': (0, _.EscrowFromJSON)(json['escrow']),
        'voting_power': json['voting_power'],
        'voting_power_cumulative': !(0, _runtime.exists)(json, 'voting_power_cumulative') ? undefined : json['voting_power_cumulative'],
        'active': json['active'],
        'start_date': json['start_date'],
        'rank': json['rank'],
        'in_validator_set': json['in_validator_set'],
        'media': !(0, _runtime.exists)(json, 'media') ? undefined : (0, _.ValidatorMediaFromJSON)(json['media']),
        'current_rate': json['current_rate'],
        'current_commission_bound': (0, _.ValidatorCommissionBoundFromJSON)(json['current_commission_bound']),
        'signed_blocks': !(0, _runtime.exists)(json, 'signed_blocks') ? undefined : json['signed_blocks'].map((0, _.ValidatorSignedBlockFromJSON))
    };
}
function ValidatorToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'entity_address': value.entity_address,
        'entity_id': value.entity_id,
        'node_id': value.node_id,
        'escrow': (0, _.EscrowToJSON)(value.escrow),
        'voting_power': value.voting_power,
        'voting_power_cumulative': value.voting_power_cumulative,
        'active': value.active,
        'start_date': value.start_date,
        'rank': value.rank,
        'in_validator_set': value.in_validator_set,
        'media': (0, _.ValidatorMediaToJSON)(value.media),
        'current_rate': value.current_rate,
        'current_commission_bound': (0, _.ValidatorCommissionBoundToJSON)(value.current_commission_bound),
        'signed_blocks': value.signed_blocks === undefined ? undefined : value.signed_blocks.map((0, _.ValidatorSignedBlockToJSON))
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gJcGg":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorAggStatsFromJSON", ()=>ValidatorAggStatsFromJSON);
parcelHelpers.export(exports, "ValidatorAggStatsFromJSONTyped", ()=>ValidatorAggStatsFromJSONTyped);
parcelHelpers.export(exports, "ValidatorAggStatsToJSON", ()=>ValidatorAggStatsToJSON);
function ValidatorAggStatsFromJSON(json) {
    return ValidatorAggStatsFromJSONTyped(json, false);
}
function ValidatorAggStatsFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_voting_power': json['total_voting_power'],
        'total_delegators': json['total_delegators'],
        'total_staked_balance': json['total_staked_balance']
    };
}
function ValidatorAggStatsToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_voting_power': value.total_voting_power,
        'total_delegators': value.total_delegators,
        'total_staked_balance': value.total_staked_balance
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2QCRe":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorCommissionBoundFromJSON", ()=>ValidatorCommissionBoundFromJSON);
parcelHelpers.export(exports, "ValidatorCommissionBoundFromJSONTyped", ()=>ValidatorCommissionBoundFromJSONTyped);
parcelHelpers.export(exports, "ValidatorCommissionBoundToJSON", ()=>ValidatorCommissionBoundToJSON);
function ValidatorCommissionBoundFromJSON(json) {
    return ValidatorCommissionBoundFromJSONTyped(json, false);
}
function ValidatorCommissionBoundFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'lower': json['lower'],
        'upper': json['upper'],
        'epoch_start': json['epoch_start'],
        'epoch_end': json['epoch_end']
    };
}
function ValidatorCommissionBoundToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'lower': value.lower,
        'upper': value.upper,
        'epoch_start': value.epoch_start,
        'epoch_end': value.epoch_end
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1x7cH":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorHistoryFromJSON", ()=>ValidatorHistoryFromJSON);
parcelHelpers.export(exports, "ValidatorHistoryFromJSONTyped", ()=>ValidatorHistoryFromJSONTyped);
parcelHelpers.export(exports, "ValidatorHistoryToJSON", ()=>ValidatorHistoryToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function ValidatorHistoryFromJSON(json) {
    return ValidatorHistoryFromJSONTyped(json, false);
}
function ValidatorHistoryFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'address': !(0, _runtime.exists)(json, 'address') ? undefined : json['address'],
        'history': json['history'].map((0, _.ValidatorHistoryPointFromJSON))
    };
}
function ValidatorHistoryToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'address': value.address,
        'history': value.history.map((0, _.ValidatorHistoryPointToJSON))
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5ZeuE":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorHistoryAllOfFromJSON", ()=>ValidatorHistoryAllOfFromJSON);
parcelHelpers.export(exports, "ValidatorHistoryAllOfFromJSONTyped", ()=>ValidatorHistoryAllOfFromJSONTyped);
parcelHelpers.export(exports, "ValidatorHistoryAllOfToJSON", ()=>ValidatorHistoryAllOfToJSON);
var _runtime = require("../runtime");
var _ = require("./");
function ValidatorHistoryAllOfFromJSON(json) {
    return ValidatorHistoryAllOfFromJSONTyped(json, false);
}
function ValidatorHistoryAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'address': !(0, _runtime.exists)(json, 'address') ? undefined : json['address'],
        'history': json['history'].map((0, _.ValidatorHistoryPointFromJSON))
    };
}
function ValidatorHistoryAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'address': value.address,
        'history': value.history.map((0, _.ValidatorHistoryPointToJSON))
    };
}

},{"../runtime":"ecR7o","./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dC30c":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorHistoryPointFromJSON", ()=>ValidatorHistoryPointFromJSON);
parcelHelpers.export(exports, "ValidatorHistoryPointFromJSONTyped", ()=>ValidatorHistoryPointFromJSONTyped);
parcelHelpers.export(exports, "ValidatorHistoryPointToJSON", ()=>ValidatorHistoryPointToJSON);
var _runtime = require("../runtime");
function ValidatorHistoryPointFromJSON(json) {
    return ValidatorHistoryPointFromJSONTyped(json, false);
}
function ValidatorHistoryPointFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'epoch': json['epoch'],
        'active_balance': !(0, _runtime.exists)(json, 'active_balance') ? undefined : json['active_balance'],
        'active_shares': !(0, _runtime.exists)(json, 'active_shares') ? undefined : json['active_shares'],
        'debonding_balance': !(0, _runtime.exists)(json, 'debonding_balance') ? undefined : json['debonding_balance'],
        'debonding_shares': !(0, _runtime.exists)(json, 'debonding_shares') ? undefined : json['debonding_shares'],
        'num_delegators': !(0, _runtime.exists)(json, 'num_delegators') ? undefined : json['num_delegators']
    };
}
function ValidatorHistoryPointToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'epoch': value.epoch,
        'active_balance': value.active_balance,
        'active_shares': value.active_shares,
        'debonding_balance': value.debonding_balance,
        'debonding_shares': value.debonding_shares,
        'num_delegators': value.num_delegators
    };
}

},{"../runtime":"ecR7o","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4vePM":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorListFromJSON", ()=>ValidatorListFromJSON);
parcelHelpers.export(exports, "ValidatorListFromJSONTyped", ()=>ValidatorListFromJSONTyped);
parcelHelpers.export(exports, "ValidatorListToJSON", ()=>ValidatorListToJSON);
var _ = require("./");
function ValidatorListFromJSON(json) {
    return ValidatorListFromJSONTyped(json, false);
}
function ValidatorListFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'validators': json['validators'].map((0, _.ValidatorFromJSON)),
        'stats': (0, _.ValidatorAggStatsFromJSON)(json['stats'])
    };
}
function ValidatorListToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'validators': value.validators.map((0, _.ValidatorToJSON)),
        'stats': (0, _.ValidatorAggStatsToJSON)(value.stats)
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6bkDi":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorListAllOfFromJSON", ()=>ValidatorListAllOfFromJSON);
parcelHelpers.export(exports, "ValidatorListAllOfFromJSONTyped", ()=>ValidatorListAllOfFromJSONTyped);
parcelHelpers.export(exports, "ValidatorListAllOfToJSON", ()=>ValidatorListAllOfToJSON);
var _ = require("./");
function ValidatorListAllOfFromJSON(json) {
    return ValidatorListAllOfFromJSONTyped(json, false);
}
function ValidatorListAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'validators': json['validators'].map((0, _.ValidatorFromJSON)),
        'stats': (0, _.ValidatorAggStatsFromJSON)(json['stats'])
    };
}
function ValidatorListAllOfToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'validators': value.validators.map((0, _.ValidatorToJSON)),
        'stats': (0, _.ValidatorAggStatsToJSON)(value.stats)
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9uT7X":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorMediaFromJSON", ()=>ValidatorMediaFromJSON);
parcelHelpers.export(exports, "ValidatorMediaFromJSONTyped", ()=>ValidatorMediaFromJSONTyped);
parcelHelpers.export(exports, "ValidatorMediaToJSON", ()=>ValidatorMediaToJSON);
var _runtime = require("../runtime");
function ValidatorMediaFromJSON(json) {
    return ValidatorMediaFromJSONTyped(json, false);
}
function ValidatorMediaFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'url': !(0, _runtime.exists)(json, 'url') ? undefined : json['url'],
        'email': !(0, _runtime.exists)(json, 'email') ? undefined : json['email'],
        'twitter': !(0, _runtime.exists)(json, 'twitter') ? undefined : json['twitter'],
        'keybase': !(0, _runtime.exists)(json, 'keybase') ? undefined : json['keybase'],
        'name': !(0, _runtime.exists)(json, 'name') ? undefined : json['name'],
        'logoUrl': !(0, _runtime.exists)(json, 'logoUrl') ? undefined : json['logoUrl']
    };
}
function ValidatorMediaToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'url': value.url,
        'email': value.email,
        'twitter': value.twitter,
        'keybase': value.keybase,
        'name': value.name,
        'logoUrl': value.logoUrl
    };
}

},{"../runtime":"ecR7o","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aC6CP":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorSignedBlockFromJSON", ()=>ValidatorSignedBlockFromJSON);
parcelHelpers.export(exports, "ValidatorSignedBlockFromJSONTyped", ()=>ValidatorSignedBlockFromJSONTyped);
parcelHelpers.export(exports, "ValidatorSignedBlockToJSON", ()=>ValidatorSignedBlockToJSON);
function ValidatorSignedBlockFromJSON(json) {
    return ValidatorSignedBlockFromJSONTyped(json, false);
}
function ValidatorSignedBlockFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'height': json['height'],
        'signed': json['signed']
    };
}
function ValidatorSignedBlockToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'height': value.height,
        'signed': value.signed
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6efum":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorsResponseFromJSON", ()=>ValidatorsResponseFromJSON);
parcelHelpers.export(exports, "ValidatorsResponseFromJSONTyped", ()=>ValidatorsResponseFromJSONTyped);
parcelHelpers.export(exports, "ValidatorsResponseToJSON", ()=>ValidatorsResponseToJSON);
var _ = require("./");
function ValidatorsResponseFromJSON(json) {
    return ValidatorsResponseFromJSONTyped(json, false);
}
function ValidatorsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) return json;
    return {
        'validator_list': (0, _.ValidatorListFromJSON)(json['validator_list']),
        'stats': (0, _.ValidatorAggStatsFromJSON)(json['stats'])
    };
}
function ValidatorsResponseToJSON(value) {
    if (value === undefined) return undefined;
    if (value === null) return null;
    return {
        'validator_list': (0, _.ValidatorListToJSON)(value.validator_list),
        'stats': (0, _.ValidatorAggStatsToJSON)(value.stats)
    };
}

},{"./":"K9U7a","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5bKHs":[function(require,module,exports,__globalThis) {
/* tslint:disable */ /* eslint-disable */ /**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */ /**
 * The level of verification of a smart contract, as defined by Sourcify.
 * An absence of this field means that the contract has not been verified.
 * See also https://docs.sourcify.dev/docs/full-vs-partial-match/
 * @export
 * @enum {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VerificationLevel", ()=>VerificationLevel);
parcelHelpers.export(exports, "VerificationLevelFromJSON", ()=>VerificationLevelFromJSON);
parcelHelpers.export(exports, "VerificationLevelFromJSONTyped", ()=>VerificationLevelFromJSONTyped);
parcelHelpers.export(exports, "VerificationLevelToJSON", ()=>VerificationLevelToJSON);
var VerificationLevel = /*#__PURE__*/ function(VerificationLevel) {
    VerificationLevel["Partial"] = "partial";
    VerificationLevel["Full"] = "full";
    return VerificationLevel;
}({});
function VerificationLevelFromJSON(json) {
    return VerificationLevelFromJSONTyped(json, false);
}
function VerificationLevelFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function VerificationLevelToJSON(value) {
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2zit7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectSelectedNetwork", ()=>selectSelectedNetwork);
parcelHelpers.export(exports, "selectTicker", ()=>selectTicker);
parcelHelpers.export(exports, "selectChainContext", ()=>selectChainContext);
parcelHelpers.export(exports, "selectEpoch", ()=>selectEpoch);
parcelHelpers.export(exports, "selectMinStaking", ()=>selectMinStaking);
var _toolkit = require("@reduxjs/toolkit");
var _ = require(".");
const selectSlice = (state)=>state.network || (0, _.initialState);
const selectSelectedNetwork = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.selectedNetwork);
const selectTicker = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.ticker);
const selectChainContext = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.chainContext);
const selectEpoch = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.epoch);
const selectMinStaking = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.minimumStakingAmount);

},{"@reduxjs/toolkit":"9ol63",".":"8NDHR","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2ZQXE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Like takeLatest, but also cancels running task early if cancelOnAction is dispatched */ parcelHelpers.export(exports, "takeLatestCancelable", ()=>takeLatestCancelable);
var _typedReduxSaga = require("typed-redux-saga");
function takeLatestCancelable({ startOnAction, cancelOnAction, task }) {
    return (0, _typedReduxSaga.fork)(function*() {
        while(true)yield* (0, _typedReduxSaga.race)({
            task: (0, _typedReduxSaga.takeLatest)(startOnAction, task),
            cancel: (0, _typedReduxSaga.take)(cancelOnAction)
        });
    });
}

},{"typed-redux-saga":"1vcsM","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cQkhB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "refreshValidators", ()=>refreshValidators);
parcelHelpers.export(exports, "now", ()=>now);
parcelHelpers.export(exports, "getMainnetDumpValidators", ()=>getMainnetDumpValidators);
parcelHelpers.export(exports, "getValidatorDetails", ()=>getValidatorDetails);
parcelHelpers.export(exports, "fetchAccount", ()=>fetchAccount);
parcelHelpers.export(exports, "stakingSaga", ()=>stakingSaga);
var _client = require("@oasisprotocol/client");
var _helpers = require("app/lib/helpers");
var _typedReduxSaga = require("typed-redux-saga");
var _errors = require("types/errors");
var _nexus = require("vendors/nexus");
var _ = require(".");
var _saga = require("../network/saga");
var _selectors = require("../network/selectors");
var _selectors1 = require("./selectors");
function* loadDelegations(address) {
    const nic = yield* (0, _typedReduxSaga.call)((0, _saga.getOasisNic));
    const { getDelegations } = yield* (0, _typedReduxSaga.call)((0, _saga.getExplorerAPIs));
    const validators = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectValidators));
    try {
        const delegationsResponse = yield* (0, _typedReduxSaga.call)(getDelegations, {
            accountId: address,
            nic: nic
        });
        const delegations = delegationsResponse.delegations.map((delegation)=>({
                ...delegation,
                validator: validators.find((v)=>v.address === delegation.validatorAddress)
            }));
        const debondingDelegations = delegationsResponse.debonding.map((delegation)=>({
                ...delegation,
                validator: validators.find((v)=>v.address === delegation.validatorAddress)
            }));
        yield* (0, _typedReduxSaga.put)((0, _.stakingActions).updateDelegations({
            delegations,
            debondingDelegations
        }));
    } catch (e) {
        console.error('get delegations failed, continuing without updated list.', e);
        if (e instanceof (0, _errors.WalletError)) yield* (0, _typedReduxSaga.put)((0, _.stakingActions).updateDelegationsError({
            code: e.type,
            message: e.message
        }));
        else yield* (0, _typedReduxSaga.put)((0, _.stakingActions).updateDelegationsError({
            code: (0, _errors.WalletErrors).UnknownError,
            message: e.message
        }));
    }
}
function* refreshValidators() {
    const existingValidators = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectValidators));
    const existingValidatorsNetwork = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectValidatorsNetwork));
    const network = yield* (0, _typedReduxSaga.select)((0, _selectors.selectSelectedNetwork));
    // Skip if validators are already in store, and network didn't change
    if (existingValidators.length > 0 && network === existingValidatorsNetwork) return;
    const { getAllValidators } = yield* (0, _typedReduxSaga.call)((0, _saga.getExplorerAPIs));
    try {
        const validators = yield* (0, _typedReduxSaga.call)(getAllValidators);
        yield* (0, _typedReduxSaga.put)((0, _.stakingActions).updateValidators({
            timestamp: yield* (0, _typedReduxSaga.call)(now),
            network: network,
            list: validators
        }));
    } catch (errorApi) {
        console.error('get validators list failed', errorApi);
        const fallback = yield* (0, _typedReduxSaga.call)(getFallbackValidators, network, errorApi);
        yield* (0, _typedReduxSaga.put)((0, _.stakingActions).updateValidatorsError({
            error: {
                code: fallback.error instanceof (0, _errors.WalletError) ? fallback.error.type : (0, _errors.WalletErrors).UnknownError,
                message: fallback.error.message
            },
            validators: fallback.validators
        }));
    }
}
function* getFallbackValidators(network, errorApi) {
    let fallbackValidators = {
        timestamp: yield* (0, _typedReduxSaga.call)(now),
        network: network,
        list: []
    };
    // If API fails on testnet/local, fall back to empty list
    if (network !== 'mainnet') return {
        error: errorApi,
        validators: fallbackValidators
    };
    try {
        const dump_validators = yield* (0, _typedReduxSaga.call)(getMainnetDumpValidators);
        fallbackValidators = {
            timestamp: dump_validators.dump_timestamp,
            network: 'mainnet',
            list: (0, _nexus.parseValidatorsList)(dump_validators.list).map((v)=>{
                return {
                    ...v,
                    status: 'unknown'
                };
            })
        };
    } catch (errorDumpValidators) {
        // If fetching dump_validators fails, fall back to empty list
        return {
            error: new (0, _errors.WalletError)((0, _errors.WalletErrors).DisconnectedError, 'Lost connection'),
            validators: fallbackValidators
        };
    }
    // If API fails on mainnet, fall back to dump_validators, and refresh validators' status with RPC
    const nic = yield* (0, _typedReduxSaga.call)((0, _saga.getOasisNic));
    let rpcActiveValidators;
    try {
        rpcActiveValidators = yield* (0, _typedReduxSaga.call)([
            nic,
            nic.schedulerGetValidators
        ], (0, _client.consensus).HEIGHT_LATEST);
    } catch (errorRpc) {
        // If RPC fails, fall back to dump_validators with unknown validators' status
        return {
            error: errorApi,
            validators: fallbackValidators
        };
    }
    // Fall back to dump_validators with refreshed validators' status from RPC
    const activeNodes = {};
    for (const rpcValidator of rpcActiveValidators){
        const address = yield* (0, _typedReduxSaga.call)((0, _helpers.publicKeyToAddress), rpcValidator.entity_id);
        activeNodes[address] = true;
    }
    fallbackValidators = {
        ...fallbackValidators,
        list: fallbackValidators.list.map((v)=>{
            return {
                ...v,
                status: activeNodes[v.address] ? 'active' : 'inactive'
            };
        })
    };
    return {
        error: errorApi,
        validators: fallbackValidators
    };
}
function now() {
    return Date.now();
}
async function getMainnetDumpValidators() {
    return await require("fd836132c02bafac");
}
function* getValidatorDetails({ payload: address }) {
    const nic = yield* (0, _typedReduxSaga.call)((0, _saga.getOasisNic));
    const publicKey = yield* (0, _typedReduxSaga.call)((0, _helpers.addressToPublicKey), address);
    const account = yield* (0, _typedReduxSaga.call)([
        nic,
        nic.stakingAccount
    ], {
        owner: publicKey,
        height: 0
    });
    const currentEpoch = yield* (0, _typedReduxSaga.call)((0, _saga.getEpoch));
    let rawBounds = account.escrow?.commission_schedule?.bounds;
    if (!rawBounds) rawBounds = [];
    const bounds = rawBounds.map((b)=>({
            epochStart: b.start ? Number(b.start) : 0,
            lower: b.rate_min ? Number((0, _client.quantity).toBigInt(b.rate_min)) / 100000 : 0,
            upper: b.rate_max ? Number((0, _client.quantity).toBigInt(b.rate_max)) / 100000 : 0
        }))// Always clone before sort so it doesn't mutate source
    .slice().sort((a, b)=>a.epochStart - b.epochStart)// If we have another bound after this one, attach the epochEnd to this one
    .map((b, i, array)=>({
            ...b,
            epochEnd: array[i + 1] ? array[i + 1].epochStart - 1 : undefined
        }))// Filter out bounds that ended in the past
    .filter((b)=>!b.epochEnd || b.epochEnd > currentEpoch);
    yield* (0, _typedReduxSaga.put)((0, _.stakingActions).updateValidatorDetails({
        scheduledCommissionBounds: bounds
    }));
}
function* fetchAccount({ payload: address }) {
    yield* (0, _typedReduxSaga.put)((0, _.stakingActions).setLoading(true));
    yield* (0, _typedReduxSaga.call)(refreshValidators);
    yield* (0, _typedReduxSaga.call)(loadDelegations, address);
    yield* (0, _typedReduxSaga.put)((0, _.stakingActions).setLoading(false));
}
function* stakingSaga() {
    yield* (0, _typedReduxSaga.takeLatest)((0, _.stakingActions).fetchAccount, fetchAccount);
    yield* (0, _typedReduxSaga.takeLatest)((0, _.stakingActions).validatorSelected, getValidatorDetails);
}

},{"@oasisprotocol/client":"9pxEg","app/lib/helpers":"bUnFy","typed-redux-saga":"1vcsM","types/errors":"gbx4q","vendors/nexus":"9Czgc",".":"8XKJG","../network/saga":"9acqo","../network/selectors":"2zit7","./selectors":"jY45G","fd836132c02bafac":"eov4Z","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jY45G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectStaking", ()=>selectStaking);
parcelHelpers.export(exports, "selectValidators", ()=>selectValidators);
parcelHelpers.export(exports, "selectValidatorsTimestamp", ()=>selectValidatorsTimestamp);
parcelHelpers.export(exports, "selectUpdateValidatorsError", ()=>selectUpdateValidatorsError);
parcelHelpers.export(exports, "selectValidatorsNetwork", ()=>selectValidatorsNetwork);
parcelHelpers.export(exports, "selectSelectedAddress", ()=>selectSelectedAddress);
parcelHelpers.export(exports, "selectValidatorDetails", ()=>selectValidatorDetails);
parcelHelpers.export(exports, "selectActiveDelegations", ()=>selectActiveDelegations);
parcelHelpers.export(exports, "selectDebondingDelegations", ()=>selectDebondingDelegations);
var _toolkit = require("@reduxjs/toolkit");
var _ = require(".");
const selectSlice = (state)=>state.staking || (0, _.initialState);
const selectStaking = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state);
const selectValidators = (0, _toolkit.createSelector)([
    selectStaking
], (state)=>state.validators?.list ?? []);
const selectValidatorsTimestamp = (0, _toolkit.createSelector)([
    selectStaking
], (state)=>state.validators?.timestamp);
const selectUpdateValidatorsError = (0, _toolkit.createSelector)([
    selectStaking
], (state)=>state.updateValidatorsError);
const selectValidatorsNetwork = (0, _toolkit.createSelector)([
    selectStaking
], (state)=>state.validators?.network ?? undefined);
const selectSelectedAddress = (0, _toolkit.createSelector)([
    selectStaking
], (state)=>state.selectedValidator);
const selectValidatorDetails = (0, _toolkit.createSelector)([
    selectStaking
], (state)=>state.selectedValidatorDetails);
const selectActiveDelegations = (0, _toolkit.createSelector)([
    selectStaking
], (state)=>state.delegations);
const selectDebondingDelegations = (0, _toolkit.createSelector)([
    selectStaking
], (state)=>state.debondingDelegations);

},{"@reduxjs/toolkit":"9ol63",".":"8XKJG","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eov4Z":[function(require,module,exports,__globalThis) {
module.exports = require("a16e6117f9e4c132")(module.bundle.resolve("eUCok")).then(()=>module.bundle.root('lpoae'));

},{"a16e6117f9e4c132":"bxWlo"}],"bxWlo":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"70R9B"}],"70R9B":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"g5qmL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rootWalletSaga", ()=>rootWalletSaga);
/**
 * Take multiple ledger accounts that we want to open
 */ parcelHelpers.export(exports, "openWalletsFromLedger", ()=>openWalletsFromLedger);
parcelHelpers.export(exports, "openWalletFromPrivateKey", ()=>openWalletFromPrivateKey);
parcelHelpers.export(exports, "openWalletFromMnemonic", ()=>openWalletFromMnemonic);
/**
 * Adds a wallet to the existing wallets
 * If the wallet exists already, do nothing
 * If it has "selectImmediately", we select it immediately
 */ parcelHelpers.export(exports, "addWallet", ()=>addWallet);
parcelHelpers.export(exports, "refreshAccount", ()=>refreshAccount);
parcelHelpers.export(exports, "verifyAddressOnLedger", ()=>verifyAddressOnLedger);
var _helpers = require("app/lib/helpers");
var _tweetnacl = require("tweetnacl");
var _tweetnaclDefault = parcelHelpers.interopDefault(_tweetnacl);
var _typedReduxSaga = require("typed-redux-saga");
var _selectors = require("app/state/importaccounts/selectors");
var _ = require(".");
var _importaccounts = require("../importaccounts");
var _transaction = require("../transaction");
var _selectors1 = require("./selectors");
var _types = require("./types");
var _persist = require("app/state/persist");
var _getAccountBalanceWithFallback = require("../../lib/getAccountBalanceWithFallback");
var _network = require("../network");
var _ledger = require("app/lib/ledger");
var _saga = require("../importaccounts/saga");
function* rootWalletSaga() {
    // Wait for an openWallet action (Mnemonic, Private Key, Ledger) and add them if requested
    yield* (0, _typedReduxSaga.takeEvery)((0, _.walletActions).openWalletFromPrivateKey, openWalletFromPrivateKey);
    yield* (0, _typedReduxSaga.takeEvery)((0, _.walletActions).openWalletFromMnemonic, openWalletFromMnemonic);
    yield* (0, _typedReduxSaga.takeEvery)((0, _.walletActions).openWalletsFromLedger, openWalletsFromLedger);
    // Reload balance of matching wallets when a transaction occurs
    yield* (0, _typedReduxSaga.fork)(refreshAccountOnTransaction);
    yield* (0, _typedReduxSaga.fork)(refreshAccountOnParaTimeTransaction);
    yield* (0, _typedReduxSaga.takeEvery)((0, _.walletActions).fetchWallet, fetchWallet);
    // Reload wallet balances if network changes
    yield* (0, _typedReduxSaga.takeEvery)((0, _network.networkActions).networkSelected, refreshOnNetworkChange);
    yield* (0, _typedReduxSaga.takeLeading)((0, _.walletActions).verifyAddressOnLedger, verifyAddressOnLedger);
}
function* getWalletByAddress(address) {
    const wallets = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectWallets));
    const wallet = Object.values(wallets).find((w)=>w.address === address);
    return wallet ? wallet : undefined;
}
function* openWalletsFromLedger({ payload }) {
    const accounts = yield* (0, _typedReduxSaga.select)((0, _selectors.selectSelectedAccounts));
    yield* (0, _typedReduxSaga.put)((0, _importaccounts.importAccountsActions).clear());
    for (const account of accounts)yield* (0, _typedReduxSaga.call)(addWallet, {
        address: account.address,
        publicKey: account.publicKey,
        type: account.type,
        balance: account.balance,
        path: account.path,
        pathDisplay: account.pathDisplay,
        selectImmediately: account === accounts[0]
    });
    if (payload.choosePassword) yield* (0, _typedReduxSaga.put)((0, _persist.persistActions).setPasswordAsync({
        password: payload.choosePassword
    }));
}
function* openWalletFromPrivateKey({ payload }) {
    const type = (0, _types.WalletType).PrivateKey;
    const publicKeyBytes = (0, _tweetnaclDefault.default).sign.keyPair.fromSecretKey((0, _helpers.hex2uint)(payload.privateKey)).publicKey;
    const walletAddress = yield* (0, _typedReduxSaga.call)((0, _helpers.publicKeyToAddress), publicKeyBytes);
    const publicKey = (0, _helpers.uint2hex)(publicKeyBytes);
    const balance = yield* (0, _typedReduxSaga.call)((0, _getAccountBalanceWithFallback.getAccountBalanceWithFallback), walletAddress);
    yield* (0, _typedReduxSaga.call)(addWallet, {
        address: walletAddress,
        publicKey,
        privateKey: payload.privateKey,
        type: type,
        balance,
        selectImmediately: true
    });
    if (payload.choosePassword) yield* (0, _typedReduxSaga.put)((0, _persist.persistActions).setPasswordAsync({
        password: payload.choosePassword
    }));
}
function* openWalletFromMnemonic({ payload }) {
    const accounts = yield* (0, _typedReduxSaga.select)((0, _selectors.selectSelectedAccounts));
    yield* (0, _typedReduxSaga.put)((0, _importaccounts.importAccountsActions).clear());
    for (const account of accounts)yield* (0, _typedReduxSaga.call)(addWallet, {
        address: account.address,
        balance: account.balance,
        path: account.path,
        pathDisplay: account.pathDisplay,
        privateKey: account.privateKey,
        publicKey: account.publicKey,
        type: account.type,
        selectImmediately: account === accounts[0]
    });
    if (payload.choosePassword) yield* (0, _typedReduxSaga.put)((0, _persist.persistActions).setPasswordAsync({
        password: payload.choosePassword
    }));
}
function* addWallet(payload) {
    const { selectImmediately, ...newWallet } = payload;
    const existingWallet = yield* (0, _typedReduxSaga.call)(getWalletByAddress, newWallet.address);
    if (!existingWallet) yield* (0, _typedReduxSaga.put)((0, _.walletActions).walletOpened(newWallet));
    if (selectImmediately) {
        yield* (0, _typedReduxSaga.put)((0, _.walletActions).selectWallet(undefined)) // Workaround so useRouteRedirects detects selecting the same account
        ;
        yield* (0, _typedReduxSaga.delay)(1) // Workaround to avoid React batching state updates
        ;
        yield* (0, _typedReduxSaga.put)((0, _.walletActions).selectWallet(newWallet.address));
    }
}
function* fetchWallet(action) {
    const wallet = action.payload;
    const balance = yield* (0, _typedReduxSaga.call)((0, _getAccountBalanceWithFallback.getAccountBalanceWithFallback), wallet.address);
    yield* (0, _typedReduxSaga.put)((0, _.walletActions).updateBalance({
        address: wallet.address,
        balance
    }));
}
/**
 * When a transaction is done, and it is related to the account we currently have in state
 * refresh the data.
 */ function* refreshAccountOnTransaction() {
    while(true){
        const { payload } = yield* (0, _typedReduxSaga.take)((0, _transaction.transactionActions).transactionSent);
        const otherAddress = payload.type === 'transfer' ? payload.to : payload.validator;
        yield* (0, _typedReduxSaga.call)(refreshAccount, otherAddress);
    }
}
function* refreshAccountOnParaTimeTransaction() {
    while(true){
        const { payload } = yield* (0, _typedReduxSaga.take)((0, _transaction.transactionActions).paraTimeTransactionSent);
        // Increase the chance to get updated balance from API.
        yield* (0, _typedReduxSaga.delay)(3000);
        yield* (0, _typedReduxSaga.call)(refreshAccount, payload);
    }
}
function* refreshAccount(address) {
    const from = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectAddress));
    const wallets = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectWallets));
    const matchingWallets = Object.values(wallets).filter((wallet)=>wallet.address === address || wallet.address === from);
    for (const wallet of matchingWallets)yield* (0, _typedReduxSaga.put)((0, _.walletActions).fetchWallet(wallet));
}
function* refreshOnNetworkChange() {
    const wallets = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectWallets));
    for (const wallet of Object.values(wallets))yield* (0, _typedReduxSaga.put)((0, _.walletActions).fetchWallet(wallet));
}
function* verifyAddressOnLedger(action) {
    const wallet = action.payload;
    if (wallet.type !== (0, _types.WalletType).UsbLedger && wallet.type !== (0, _types.WalletType).BleLedger) return;
    if (!wallet.path) return;
    let transport;
    try {
        if (wallet.type === (0, _types.WalletType).BleLedger) {
            const bleDevice = yield* (0, _typedReduxSaga.select)((0, _selectors.selectSelectedBleDevice));
            // TODO: this doesn't work after restarting mobile app and unlocking profile
            transport = yield* (0, _saga.getBluetoothTransport)(bleDevice);
        } else transport = yield* (0, _saga.getUSBTransport)();
        const app = yield* (0, _typedReduxSaga.call)((0, _ledger.Ledger).getOasisApp, transport);
        yield* (0, _typedReduxSaga.call)([
            app,
            app.showAddressAndPubKey_ed25519
        ], wallet.path);
    // Ignore response
    } catch (e) {
    // Ignore error
    } finally{
        if (transport) yield* (0, _typedReduxSaga.call)([
            transport,
            transport.close
        ]);
    }
}

},{"app/lib/helpers":"bUnFy","tweetnacl":"5ZWFX","typed-redux-saga":"1vcsM","app/state/importaccounts/selectors":"6bs0S",".":"iYAaC","../importaccounts":"eABjR","../transaction":"jax2p","./selectors":"cgtJ3","./types":"b0U5N","app/state/persist":"9hwZK","../../lib/getAccountBalanceWithFallback":"ffPNL","../network":"8NDHR","app/lib/ledger":"bREEn","../importaccounts/saga":"4YSF4","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6bs0S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectError", ()=>selectError);
parcelHelpers.export(exports, "selectImportAccounts", ()=>selectImportAccounts);
parcelHelpers.export(exports, "selectImportAccountsFullList", ()=>selectImportAccountsFullList);
parcelHelpers.export(exports, "selectShowAccountsSelectionModal", ()=>selectShowAccountsSelectionModal);
parcelHelpers.export(exports, "selectImportAccountsPageNumber", ()=>selectImportAccountsPageNumber);
parcelHelpers.export(exports, "selectImportAccountsOnCurrentPage", ()=>selectImportAccountsOnCurrentPage);
parcelHelpers.export(exports, "selectImportAccountHasMissingBalances", ()=>selectImportAccountHasMissingBalances);
parcelHelpers.export(exports, "selectSelectedAccounts", ()=>selectSelectedAccounts);
parcelHelpers.export(exports, "selectBleDevices", ()=>selectBleDevices);
parcelHelpers.export(exports, "selectSelectedBleDevice", ()=>selectSelectedBleDevice);
parcelHelpers.export(exports, "selectImportAccountsStep", ()=>selectImportAccountsStep);
parcelHelpers.export(exports, "selectShowBleLedgerDevicesModal", ()=>selectShowBleLedgerDevicesModal);
var _toolkit = require("@reduxjs/toolkit");
var _ = require(".");
var _saga = require("./saga");
const selectSlice = (state)=>state.importAccounts || (0, _.initialState);
const selectError = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.error);
const selectImportAccounts = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state);
const selectImportAccountsFullList = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.accounts);
const selectShowAccountsSelectionModal = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.showAccountsSelectionModal);
const selectImportAccountsPageNumber = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.accountsSelectionPageNumber);
const selectImportAccountsOnCurrentPage = (0, _toolkit.createSelector)([
    selectImportAccountsFullList,
    selectImportAccountsPageNumber
], (fullList, pageNumber)=>fullList.slice(pageNumber * (0, _saga.accountsPerPage), (pageNumber + 1) * (0, _saga.accountsPerPage)));
const selectImportAccountHasMissingBalances = (0, _toolkit.createSelector)([
    selectImportAccountsOnCurrentPage
], (list)=>list.some((a)=>!a.balance));
const selectSelectedAccounts = (0, _toolkit.createSelector)([
    selectImportAccountsFullList
], (state)=>state.filter((a)=>a.selected));
const selectBleDevices = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.bleDevices);
const selectSelectedBleDevice = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.selectedBleDevice);
const selectImportAccountsStep = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.step);
const selectShowBleLedgerDevicesModal = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.showBleLedgerDevicesModal);

},{"@reduxjs/toolkit":"9ol63",".":"eABjR","./saga":"4YSF4","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4YSF4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBluetoothTransport", ()=>getBluetoothTransport);
parcelHelpers.export(exports, "getUSBTransport", ()=>getUSBTransport);
parcelHelpers.export(exports, "accountsPerPage", ()=>accountsPerPage);
parcelHelpers.export(exports, "numberOfAccountPages", ()=>numberOfAccountPages);
parcelHelpers.export(exports, "sign", ()=>sign);
parcelHelpers.export(exports, "importAccountsSaga", ()=>importAccountsSaga);
var _hwTransportWebusb = require("@ledgerhq/hw-transport-webusb");
var _hwTransportWebusbDefault = parcelHelpers.interopDefault(_hwTransportWebusb);
var _client = require("@oasisprotocol/client");
var _helpers = require("app/lib/helpers");
var _ledger = require("app/lib/ledger");
var _transaction = require("app/lib/transaction");
var _typedReduxSaga = require("typed-redux-saga");
var _errors = require("types/errors");
var _types = require("app/state/wallet/types");
var _ = require(".");
var _types1 = require("./types");
var _selectors = require("./selectors");
var _getAccountBalanceWithFallback = require("../../lib/getAccountBalanceWithFallback");
var _lib = require("@oasisprotocol/ionic-ledger-hw-transport-ble/lib");
var _libDefault = parcelHelpers.interopDefault(_lib);
var _saga = require("../network/saga");
class TransportWebUSBDetectLedgerLikelyFaultyFirmware extends (0, _hwTransportWebusbDefault.default) {
    static async open(a) {
        const response = await Promise.race([
            super.open(a),
            new Promise((resolve, reject)=>setTimeout(()=>reject(new (0, _errors.WalletError)((0, _errors.WalletErrors).LedgerLikelyFaultyFirmware, 'timeout')), 8000))
        ]);
        return response;
    }
}
function* setStep(step) {
    yield* (0, _typedReduxSaga.put)((0, _.importAccountsActions).setStep(step));
}
function* isBluetoothSupported() {
    const isSupported = yield* (0, _typedReduxSaga.call)([
        (0, _libDefault.default),
        (0, _libDefault.default).isSupported
    ]);
    // https://github.com/WebBluetoothCG/web-bluetooth/blob/main/implementation-status.md#scanning-api
    // !navigator.bluetooth
    if (!isSupported) throw new (0, _errors.WalletError)((0, _errors.WalletErrors).BluetoothTransportNotSupported, 'Bluetooth Transport unsupported');
}
function* getBluetoothDevices() {
    yield* (0, _typedReduxSaga.call)(isBluetoothSupported);
    return yield* (0, _typedReduxSaga.call)((0, _libDefault.default).list);
}
function* getBluetoothTransport(device) {
    yield* (0, _typedReduxSaga.call)(isBluetoothSupported);
    if (!device) throw new (0, _errors.WalletError)((0, _errors.WalletErrors).LedgerNoDeviceSelected, 'No device selected');
    try {
        return yield* (0, _typedReduxSaga.call)((0, _libDefault.default).open, device);
    } catch (e) {
        if (e.message.match(/No device selected/)) throw new (0, _errors.WalletError)((0, _errors.WalletErrors).LedgerNoDeviceSelected, e.message);
        else throw new (0, _errors.WalletError)((0, _errors.WalletErrors).USBTransportError, e.message);
    }
}
function* getUSBTransport() {
    const isSupported = yield* (0, _typedReduxSaga.call)([
        (0, _hwTransportWebusbDefault.default),
        (0, _hwTransportWebusbDefault.default).isSupported
    ]);
    if (!isSupported) throw new (0, _errors.WalletError)((0, _errors.WalletErrors).USBTransportNotSupported, 'TransportWebUSB unsupported');
    try {
        return yield* (0, _typedReduxSaga.call)([
            TransportWebUSBDetectLedgerLikelyFaultyFirmware,
            TransportWebUSBDetectLedgerLikelyFaultyFirmware.create
        ]);
    } catch (e) {
        if (e instanceof (0, _errors.WalletError)) throw e;
        else if (e.message.match(/No device selected/)) throw new (0, _errors.WalletError)((0, _errors.WalletErrors).LedgerNoDeviceSelected, e.message);
        else throw new (0, _errors.WalletError)((0, _errors.WalletErrors).USBTransportError, e.message);
    }
}
const accountsPerPage = 4;
const numberOfAccountPages = 12;
function* enumerateAccountsFromMnemonic(action) {
    const wallets = [];
    const mnemonic = action.payload;
    try {
        yield* setStep((0, _types1.ImportAccountsStep).LoadingAccounts);
        // Pre-derive all pages of accounts so we don't need to store mnemonic in redux.
        for(let i = 0; i < accountsPerPage * numberOfAccountPages; i++){
            const signer = yield* (0, _typedReduxSaga.call)(_client.hdkey.HDKey.getAccountSigner, mnemonic, i);
            const address = yield* (0, _typedReduxSaga.call)((0, _helpers.publicKeyToAddress), signer.publicKey);
            wallets.push({
                address,
                path: [
                    44,
                    474,
                    i
                ],
                pathDisplay: `m/44'/474'/${i}'`,
                privateKey: (0, _helpers.uint2hex)(signer.secretKey),
                publicKey: (0, _helpers.uint2hex)(signer.publicKey),
                selected: i === 0,
                type: (0, _types.WalletType).Mnemonic
            });
            // Prevent freezing UI rendering. Especially noticeable on a phone.
            yield* (0, _typedReduxSaga.delay)(0);
        }
        yield* (0, _typedReduxSaga.put)((0, _.importAccountsActions).accountsListed(wallets));
        yield* setStep((0, _types1.ImportAccountsStep).Idle);
    } catch (e) {
        let payload;
        if (e instanceof (0, _errors.WalletError)) payload = {
            code: e.type,
            message: e.message
        };
        else payload = {
            code: (0, _errors.WalletErrors).UnknownError,
            message: e.message
        };
        yield* (0, _typedReduxSaga.put)((0, _.importAccountsActions).operationFailed(payload));
    }
    yield* ensureAllBalancesArePresentOnCurrentPage();
}
function* fetchBalanceForAccount(account) {
    let currentStep = (yield* (0, _typedReduxSaga.select)((0, _selectors.selectImportAccounts))).step;
    if (currentStep === (0, _types1.ImportAccountsStep).Idle) yield* setStep((0, _types1.ImportAccountsStep).LoadingBalances);
    const balance = yield* (0, _typedReduxSaga.call)((0, _getAccountBalanceWithFallback.getAccountBalanceWithFallback), account.address);
    yield* (0, _typedReduxSaga.put)((0, _.importAccountsActions).updateAccountBalance({
        address: account.address,
        balance
    }));
    currentStep = (yield* (0, _typedReduxSaga.select)((0, _selectors.selectImportAccounts))).step;
    const hasMissingBalances = yield* (0, _typedReduxSaga.select)((0, _selectors.selectImportAccountHasMissingBalances));
    if (currentStep === (0, _types1.ImportAccountsStep).LoadingBalances && !hasMissingBalances) yield* setStep((0, _types1.ImportAccountsStep).Idle);
}
function* ensureAllBalancesArePresentOnCurrentPage() {
    const accounts = yield* (0, _typedReduxSaga.select)((0, _selectors.selectImportAccountsOnCurrentPage));
    yield* (0, _typedReduxSaga.all)(accounts.filter((a)=>!a.balance).map((a)=>(0, _typedReduxSaga.call)(fetchBalanceForAccount, a)));
}
function* enumerateDevicesFromBleLedger() {
    yield* setStep((0, _types1.ImportAccountsStep).LoadingBleDevices);
    const devices = yield* getBluetoothDevices();
    yield* (0, _typedReduxSaga.put)((0, _.importAccountsActions).setBleDevices(devices));
    yield* setStep((0, _types1.ImportAccountsStep).Idle);
}
/**
 * Enumerate more accounts from Ledger, enough to fill up one page.
 */ function* enumerateAccountsFromLedger(action) {
    const existingAccounts = yield* (0, _typedReduxSaga.select)((0, _selectors.selectImportAccountsFullList));
    const pageNumber = yield* (0, _typedReduxSaga.select)((0, _selectors.selectImportAccountsPageNumber));
    if (existingAccounts.length >= (pageNumber + 1) * accountsPerPage) // Selected page was already enumerated.
    return;
    yield* setStep((0, _types1.ImportAccountsStep).AccessingLedger);
    let transport;
    try {
        if (action.payload === (0, _types.WalletType).BleLedger) {
            const device = yield* (0, _typedReduxSaga.select)((0, _selectors.selectSelectedBleDevice));
            transport = yield* getBluetoothTransport(device);
        } else transport = yield* getUSBTransport();
        const existingAccounts = yield* (0, _typedReduxSaga.select)((0, _selectors.selectImportAccountsFullList));
        const start = existingAccounts.length;
        yield* setStep((0, _types1.ImportAccountsStep).LoadingAccounts);
        const app = yield* (0, _typedReduxSaga.call)((0, _ledger.Ledger).getOasisApp, transport);
        for(let index = start; index < start + accountsPerPage; index++){
            const account = yield* (0, _typedReduxSaga.call)((0, _ledger.Ledger).deriveAccountUsingOasisApp, app, index);
            const address = yield* (0, _typedReduxSaga.call)((0, _helpers.publicKeyToAddress), account.publicKey);
            const wallet = {
                publicKey: (0, _helpers.uint2hex)(account.publicKey),
                path: account.path,
                pathDisplay: account.pathDisplay,
                address,
                // We select the first account by default
                selected: index === 0,
                type: action.payload
            };
            yield* (0, _typedReduxSaga.put)((0, _.importAccountsActions).accountGenerated(wallet));
            yield* (0, _typedReduxSaga.fork)(fetchBalanceForAccount, wallet);
        }
        yield* setStep((0, _types1.ImportAccountsStep).LoadingBalances);
    } catch (e) {
        let payload;
        if (e instanceof (0, _errors.WalletError)) payload = {
            code: e.type,
            message: e.message
        };
        else payload = {
            code: (0, _errors.WalletErrors).UnknownError,
            message: e.message
        };
        yield* (0, _typedReduxSaga.put)((0, _.importAccountsActions).operationFailed(payload));
    } finally{
        if (transport) try {
            yield* (0, _typedReduxSaga.call)([
                transport,
                transport.close
            ]);
        } catch (error) {
            console.log('Error while closing Ledger USB interface:', error);
        }
    }
}
function* sign(signer, tw) {
    let transport;
    if (signer.transportType === (0, _types.WalletType).BleLedger) {
        const bleDevice = yield* (0, _typedReduxSaga.select)((0, _selectors.selectSelectedBleDevice));
        // TODO: this doesn't work after restarting mobile app and unlocking profile
        transport = yield* getBluetoothTransport(bleDevice);
    } else transport = yield* getUSBTransport();
    const chainContext = yield* (0, _typedReduxSaga.call)((0, _saga.getChainContext));
    signer.setTransport(transport);
    try {
        yield* (0, _typedReduxSaga.call)([
            (0, _transaction.OasisTransaction),
            (0, _transaction.OasisTransaction).signUsingLedger
        ], chainContext, signer, tw);
    } finally{
        yield* (0, _typedReduxSaga.call)([
            transport,
            transport.close
        ]);
    }
}
function* importAccountsSaga() {
    yield* (0, _typedReduxSaga.takeEvery)((0, _.importAccountsActions).enumerateAccountsFromLedger, enumerateAccountsFromLedger);
    yield* (0, _typedReduxSaga.takeEvery)((0, _.importAccountsActions).enumerateMoreAccountsFromLedger, enumerateAccountsFromLedger);
    yield* (0, _typedReduxSaga.takeEvery)((0, _.importAccountsActions).enumerateAccountsFromMnemonic, enumerateAccountsFromMnemonic);
    yield* (0, _typedReduxSaga.takeEvery)((0, _.importAccountsActions).setPage, ensureAllBalancesArePresentOnCurrentPage);
    yield* (0, _typedReduxSaga.takeEvery)((0, _.importAccountsActions).enumerateDevicesFromBleLedger, enumerateDevicesFromBleLedger);
}

},{"@ledgerhq/hw-transport-webusb":"6FpvD","@oasisprotocol/client":"9pxEg","app/lib/helpers":"bUnFy","app/lib/ledger":"bREEn","app/lib/transaction":"bOzng","typed-redux-saga":"1vcsM","types/errors":"gbx4q","app/state/wallet/types":"b0U5N",".":"eABjR","./types":"irNSx","./selectors":"6bs0S","../../lib/getAccountBalanceWithFallback":"ffPNL","@oasisprotocol/ionic-ledger-hw-transport-ble/lib":"l4CqL","../network/saga":"9acqo","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6FpvD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _hwTransport = require("@ledgerhq/hw-transport");
var _hwTransportDefault = parcelHelpers.interopDefault(_hwTransport);
var _hidFraming = require("@ledgerhq/devices/hid-framing");
var _hidFramingDefault = parcelHelpers.interopDefault(_hidFraming);
var _devices = require("@ledgerhq/devices");
var _logs = require("@ledgerhq/logs");
var _errors = require("@ledgerhq/errors");
var _webusb = require("./webusb");
var Buffer = require("2f1c1569be106a3").Buffer;
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const configurationValue = 1;
const endpointNumber = 3;
/**
 * WebUSB Transport implementation
 * @example
 * import TransportWebUSB from "@ledgerhq/hw-transport-webusb";
 * ...
 * TransportWebUSB.create().then(transport => ...)
 */ class TransportWebUSB extends (0, _hwTransportDefault.default) {
    constructor(device, interfaceNumber){
        super();
        this.channel = Math.floor(Math.random() * 0xffff);
        this.packetSize = 64;
        this._disconnectEmitted = false;
        this._emitDisconnect = (e)=>{
            if (this._disconnectEmitted) return;
            this._disconnectEmitted = true;
            this.emit("disconnect", e);
        };
        this.device = device;
        this.interfaceNumber = interfaceNumber;
        this.deviceModel = (0, _devices.identifyUSBProductId)(device.productId);
    }
    /**
     * Similar to create() except it will always display the device permission (even if some devices are already accepted).
     */ static request() {
        return __awaiter(this, void 0, void 0, function*() {
            const device = yield (0, _webusb.requestLedgerDevice)();
            return TransportWebUSB.open(device);
        });
    }
    /**
     * Similar to create() except it will never display the device permission (it returns a Promise<?Transport>, null if it fails to find a device).
     */ static openConnected() {
        return __awaiter(this, void 0, void 0, function*() {
            const devices = yield (0, _webusb.getLedgerDevices)();
            if (devices.length === 0) return null;
            return TransportWebUSB.open(devices[0]);
        });
    }
    /**
     * Create a Ledger transport with a USBDevice
     */ static open(device) {
        return __awaiter(this, void 0, void 0, function*() {
            yield device.open();
            if (device.configuration === null) yield device.selectConfiguration(configurationValue);
            yield gracefullyResetDevice(device);
            const iface = device.configurations[0].interfaces.find(({ alternates })=>alternates.some((a)=>a.interfaceClass === 255));
            if (!iface) throw new (0, _errors.TransportInterfaceNotAvailable)("No WebUSB interface found for your Ledger device. Please upgrade firmware or contact techsupport.");
            const interfaceNumber = iface.interfaceNumber;
            try {
                yield device.claimInterface(interfaceNumber);
            } catch (e) {
                yield device.close();
                throw new (0, _errors.TransportInterfaceNotAvailable)(e.message);
            }
            const transport = new TransportWebUSB(device, interfaceNumber);
            const onDisconnect = (e)=>{
                if (device === e.device) {
                    // $FlowFixMe
                    navigator.usb.removeEventListener("disconnect", onDisconnect);
                    transport._emitDisconnect(new (0, _errors.DisconnectedDevice)());
                }
            };
            // $FlowFixMe
            navigator.usb.addEventListener("disconnect", onDisconnect);
            return transport;
        });
    }
    /**
     * Release the transport device
     */ close() {
        return __awaiter(this, void 0, void 0, function*() {
            yield this.exchangeBusyPromise;
            yield this.device.releaseInterface(this.interfaceNumber);
            yield gracefullyResetDevice(this.device);
            yield this.device.close();
        });
    }
    /**
     * Exchange with the device using APDU protocol.
     * @param apdu
     * @returns a promise of apdu response
     */ exchange(apdu) {
        return __awaiter(this, void 0, void 0, function*() {
            const b = yield this.exchangeAtomicImpl(()=>__awaiter(this, void 0, void 0, function*() {
                    const { channel, packetSize } = this;
                    (0, _logs.log)("apdu", "=> " + apdu.toString("hex"));
                    const framing = (0, _hidFramingDefault.default)(channel, packetSize);
                    // Write...
                    const blocks = framing.makeBlocks(apdu);
                    for(let i = 0; i < blocks.length; i++)yield this.device.transferOut(endpointNumber, blocks[i]);
                    // Read...
                    let result;
                    let acc;
                    while(!(result = framing.getReducedResult(acc))){
                        const r = yield this.device.transferIn(endpointNumber, packetSize);
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        const buffer = Buffer.from(r.data.buffer);
                        acc = framing.reduceResponse(acc, buffer);
                    }
                    (0, _logs.log)("apdu", "<= " + result.toString("hex"));
                    return result;
                })).catch((e)=>{
                if (e && e.message && e.message.includes("disconnected")) {
                    this._emitDisconnect(e);
                    throw new (0, _errors.DisconnectedDeviceDuringOperation)(e.message);
                }
                throw e;
            });
            return b;
        });
    }
    setScrambleKey() {}
}
/**
 * Check if WebUSB transport is supported.
 */ TransportWebUSB.isSupported = (0, _webusb.isSupported);
/**
 * List the WebUSB devices that was previously authorized by the user.
 */ TransportWebUSB.list = (0, _webusb.getLedgerDevices);
/**
 * Actively listen to WebUSB devices and emit ONE device
 * that was either accepted before, if not it will trigger the native permission UI.
 *
 * Important: it must be called in the context of a UI click!
 */ TransportWebUSB.listen = (observer)=>{
    let unsubscribed = false;
    (0, _webusb.getFirstLedgerDevice)().then((device)=>{
        if (!unsubscribed) {
            const deviceModel = (0, _devices.identifyUSBProductId)(device.productId);
            observer.next({
                type: "add",
                descriptor: device,
                deviceModel
            });
            observer.complete();
        }
    }, (error)=>{
        if (window.DOMException && error instanceof window.DOMException && error.code === 18) observer.error(new (0, _errors.TransportWebUSBGestureRequired)(error.message));
        else observer.error(new (0, _errors.TransportOpenUserCancelled)(error.message));
    });
    function unsubscribe() {
        unsubscribed = true;
    }
    return {
        unsubscribe
    };
};
exports.default = TransportWebUSB;
function gracefullyResetDevice(device) {
    return __awaiter(this, void 0, void 0, function*() {
        try {
            yield device.reset();
        } catch (err) {
            console.warn(err);
        }
    });
}

},{"2f1c1569be106a3":"eXvXD","@ledgerhq/hw-transport":"4g6bl","@ledgerhq/devices/hid-framing":"liuPa","@ledgerhq/devices":"j8MQh","@ledgerhq/logs":"2hpLA","@ledgerhq/errors":"7T5AD","./webusb":"03IVP","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4g6bl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransportError", ()=>(0, _errors.TransportError));
parcelHelpers.export(exports, "TransportStatusError", ()=>(0, _errors.TransportStatusError));
parcelHelpers.export(exports, "StatusCodes", ()=>(0, _errors.StatusCodes));
parcelHelpers.export(exports, "getAltStatusMessage", ()=>(0, _errors.getAltStatusMessage));
var _events = require("events");
var _eventsDefault = parcelHelpers.interopDefault(_events);
var _errors = require("@ledgerhq/errors");
var _logs = require("@ledgerhq/logs");
var Buffer = require("88b312045e1ca92b").Buffer;
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const DEFAULT_LOG_TYPE = "transport";
/**
 * The Transport class defines a generic interface for communicating with a Ledger hardware wallet.
 * There are different kind of transports based on the technology (channels like U2F, HID, Bluetooth, Webusb) and environment (Node, Web,...).
 * It is an abstract class that needs to be implemented.
 */ class Transport {
    constructor({ context, logType } = {}){
        this.exchangeTimeout = 30000;
        this.unresponsiveTimeout = 15000;
        this.deviceModel = null;
        this._events = new (0, _eventsDefault.default)();
        /**
         * Send data to the device using the higher level API.
         *
         * @param {number} cla - The instruction class for the command.
         * @param {number} ins - The instruction code for the command.
         * @param {number} p1 - The first parameter for the instruction.
         * @param {number} p2 - The second parameter for the instruction.
         * @param {Buffer} data - The data to be sent. Defaults to an empty buffer.
         * @param {Array<number>} statusList - A list of acceptable status codes for the response. Defaults to [StatusCodes.OK].
         * @param {Object} options - Contains optional options for the exchange function
         *  - abortTimeoutMs: stop the send after a given timeout. Another timeout exists
         *    to detect unresponsive device (see `unresponsiveTimeout`). This timeout aborts the exchange.
         * @returns {Promise<Buffer>} A promise that resolves with the response data from the device.
         */ this.send = (cla_1, ins_1, p1_1, p2_1, ...args_1)=>__awaiter(this, [
                cla_1,
                ins_1,
                p1_1,
                p2_1,
                ...args_1
            ], void 0, function*(cla, ins, p1, p2, data = Buffer.alloc(0), statusList = [
                (0, _errors.StatusCodes).OK
            ], { abortTimeoutMs } = {}) {
                const tracer = this.tracer.withUpdatedContext({
                    function: "send"
                });
                if (data.length >= 256) {
                    tracer.trace("data.length exceeded 256 bytes limit", {
                        dataLength: data.length
                    });
                    throw new (0, _errors.TransportError)("data.length exceed 256 bytes limit. Got: " + data.length, "DataLengthTooBig");
                }
                tracer.trace("Starting an exchange", {
                    abortTimeoutMs
                });
                const response = yield this.exchange(// The size of the data is added in 1 byte just before `data`
                Buffer.concat([
                    Buffer.from([
                        cla,
                        ins,
                        p1,
                        p2
                    ]),
                    Buffer.from([
                        data.length
                    ]),
                    data
                ]), {
                    abortTimeoutMs
                });
                tracer.trace("Received response from exchange");
                const sw = response.readUInt16BE(response.length - 2);
                if (!statusList.some((s)=>s === sw)) throw new (0, _errors.TransportStatusError)(sw);
                return response;
            });
        this._appAPIlock = null;
        this.tracer = new (0, _logs.LocalTracer)(logType !== null && logType !== void 0 ? logType : DEFAULT_LOG_TYPE, context);
    }
    /**
     * Send data to the device using a low level API.
     * It's recommended to use the "send" method for a higher level API.
     * @param {Buffer} apdu - The data to send.
     * @param {Object} options - Contains optional options for the exchange function
     *  - abortTimeoutMs: stop the exchange after a given timeout. Another timeout exists
     *    to detect unresponsive device (see `unresponsiveTimeout`). This timeout aborts the exchange.
     * @returns {Promise<Buffer>} A promise that resolves with the response data from the device.
     */ exchange(_apdu, { abortTimeoutMs: _abortTimeoutMs } = {}) {
        throw new Error("exchange not implemented");
    }
    /**
     * Send apdus in batch to the device using a low level API.
     * The default implementation is to call exchange for each apdu.
     * @param {Array<Buffer>} apdus - array of apdus to send.
     * @param {Observer<Buffer>} observer - an observer that will receive the response of each apdu.
     * @returns {Subscription} A Subscription object on which you can call ".unsubscribe()" to stop sending apdus.
     */ exchangeBulk(apdus, observer) {
        let unsubscribed = false;
        const unsubscribe = ()=>{
            unsubscribed = true;
        };
        const main = ()=>__awaiter(this, void 0, void 0, function*() {
                if (unsubscribed) return;
                for (const apdu of apdus){
                    const r = yield this.exchange(apdu);
                    if (unsubscribed) return;
                    const status = r.readUInt16BE(r.length - 2);
                    if (status !== (0, _errors.StatusCodes).OK) throw new (0, _errors.TransportStatusError)(status);
                    observer.next(r);
                }
            });
        main().then(()=>!unsubscribed && observer.complete(), (e)=>!unsubscribed && observer.error(e));
        return {
            unsubscribe
        };
    }
    /**
     * Set the "scramble key" for the next data exchanges with the device.
     * Each app can have a different scramble key and it is set internally during instantiation.
     * @param {string} key - The scramble key to set.
     * deprecated This method is no longer needed for modern transports and should be migrated away from.
     * no @ before deprecated as it breaks documentationjs on version 14.0.2
     * https://github.com/documentationjs/documentation/issues/1596
     */ setScrambleKey(_key) {}
    /**
     * Close the connection with the device.
     *
     * Note: for certain transports (hw-transport-node-hid-singleton for ex), once the promise resolved,
     * the transport instance is actually still cached, and the device is disconnected only after a defined timeout.
     * But for the consumer of the Transport, this does not matter and it can consider the transport to be closed.
     *
     * @returns {Promise<void>} A promise that resolves when the transport is closed.
     */ close() {
        return Promise.resolve();
    }
    /**
     * Listen for an event on the transport instance.
     * Transport implementations may have specific events. Common events include:
     * "disconnect" : triggered when the transport is disconnected.
     * @param {string} eventName - The name of the event to listen for.
     * @param {(...args: Array<any>) => any} cb - The callback function to be invoked when the event occurs.
     */ on(eventName, cb) {
        this._events.on(eventName, cb);
    }
    /**
     * Stop listening to an event on an instance of transport.
     */ off(eventName, cb) {
        this._events.removeListener(eventName, cb);
    }
    emit(event, ...args) {
        this._events.emit(event, ...args);
    }
    /**
     * Enable or not logs of the binary exchange
     */ setDebugMode() {
        console.warn("setDebugMode is deprecated. use @ledgerhq/logs instead. No logs are emitted in this anymore.");
    }
    /**
     * Set a timeout (in milliseconds) for the exchange call. Only some transport might implement it. (e.g. U2F)
     */ setExchangeTimeout(exchangeTimeout) {
        this.exchangeTimeout = exchangeTimeout;
    }
    /**
     * Define the delay before emitting "unresponsive" on an exchange that does not respond
     */ setExchangeUnresponsiveTimeout(unresponsiveTimeout) {
        this.unresponsiveTimeout = unresponsiveTimeout;
    }
    /**
     * create() allows to open the first descriptor available or
     * throw if there is none or if timeout is reached.
     * This is a light helper, alternative to using listen() and open() (that you may need for any more advanced usecase)
     * @example
    TransportFoo.create().then(transport => ...)
     */ static create(openTimeout = 3000, listenTimeout) {
        return new Promise((resolve, reject)=>{
            let found = false;
            const sub = this.listen({
                next: (e)=>{
                    found = true;
                    if (sub) sub.unsubscribe();
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    this.open(e.descriptor, openTimeout).then(resolve, reject);
                },
                error: (e)=>{
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    reject(e);
                },
                complete: ()=>{
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    if (!found) reject(new (0, _errors.TransportError)(this.ErrorMessage_NoDeviceFound, "NoDeviceFound"));
                }
            });
            const listenTimeoutId = listenTimeout ? setTimeout(()=>{
                sub.unsubscribe();
                reject(new (0, _errors.TransportError)(this.ErrorMessage_ListenTimeout, "ListenTimeout"));
            }, listenTimeout) : null;
        });
    }
    /**
     * Wrapper to make an exchange "atomic" (blocking any other exchange)
     *
     * It also handles "unresponsiveness" by emitting "unresponsive" and "responsive" events.
     *
     * @param f The exchange job, using the transport to run
     * @returns a Promise resolving with the output of the given job
     */ exchangeAtomicImpl(f) {
        return __awaiter(this, void 0, void 0, function*() {
            const tracer = this.tracer.withUpdatedContext({
                function: "exchangeAtomicImpl",
                unresponsiveTimeout: this.unresponsiveTimeout
            });
            if (this.exchangeBusyPromise) {
                tracer.trace("Atomic exchange is already busy");
                throw new (0, _errors.TransportRaceCondition)("An action was already pending on the Ledger device. Please deny or reconnect.");
            }
            // Sets the atomic guard
            let resolveBusy;
            const busyPromise = new Promise((r)=>{
                resolveBusy = r;
            });
            this.exchangeBusyPromise = busyPromise;
            // The device unresponsiveness handler
            let unresponsiveReached = false;
            const timeout = setTimeout(()=>{
                tracer.trace(`Timeout reached, emitting Transport event "unresponsive"`, {
                    unresponsiveTimeout: this.unresponsiveTimeout
                });
                unresponsiveReached = true;
                this.emit("unresponsive");
            }, this.unresponsiveTimeout);
            try {
                const res = yield f();
                if (unresponsiveReached) {
                    tracer.trace("Device was unresponsive, emitting responsive");
                    this.emit("responsive");
                }
                return res;
            } finally{
                tracer.trace("Finalize, clearing busy guard");
                clearTimeout(timeout);
                if (resolveBusy) resolveBusy();
                this.exchangeBusyPromise = null;
            }
        });
    }
    decorateAppAPIMethods(self, methods, scrambleKey) {
        for (const methodName of methods)self[methodName] = this.decorateAppAPIMethod(methodName, self[methodName], self, scrambleKey);
    }
    decorateAppAPIMethod(methodName, f, ctx, scrambleKey) {
        return (...args)=>__awaiter(this, void 0, void 0, function*() {
                const { _appAPIlock } = this;
                if (_appAPIlock) return Promise.reject(new (0, _errors.TransportError)("Ledger Device is busy (lock " + _appAPIlock + ")", "TransportLocked"));
                try {
                    this._appAPIlock = methodName;
                    this.setScrambleKey(scrambleKey);
                    return yield f.apply(ctx, args);
                } finally{
                    this._appAPIlock = null;
                }
            });
    }
    /**
     * Sets the context used by the logging/tracing mechanism
     *
     * Useful when re-using (cached) the same Transport instance,
     * but with a new tracing context.
     *
     * @param context A TraceContext, that can undefined to reset the context
     */ setTraceContext(context) {
        this.tracer = this.tracer.withContext(context);
    }
    /**
     * Updates the context used by the logging/tracing mechanism
     *
     * The update only overrides the key-value that are already defined in the current context.
     *
     * @param contextToAdd A TraceContext that will be added to the current context
     */ updateTraceContext(contextToAdd) {
        this.tracer.updateContext(contextToAdd);
    }
    /**
     * Gets the tracing context of the transport instance
     */ getTraceContext() {
        return this.tracer.getContext();
    }
}
Transport.ErrorMessage_ListenTimeout = "No Ledger device found (timeout)";
Transport.ErrorMessage_NoDeviceFound = "No Ledger device found";
exports.default = Transport;

},{"88b312045e1ca92b":"eXvXD","events":"8D3fc","@ledgerhq/errors":"7T5AD","@ledgerhq/logs":"2hpLA","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7T5AD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "serializeError", ()=>(0, _helpers.serializeError));
parcelHelpers.export(exports, "deserializeError", ()=>(0, _helpers.deserializeError));
parcelHelpers.export(exports, "createCustomErrorClass", ()=>(0, _helpers.createCustomErrorClass));
parcelHelpers.export(exports, "addCustomErrorDeserializer", ()=>(0, _helpers.addCustomErrorDeserializer));
parcelHelpers.export(exports, "AccountNameRequiredError", ()=>AccountNameRequiredError);
parcelHelpers.export(exports, "AccountNotSupported", ()=>AccountNotSupported);
parcelHelpers.export(exports, "AccountAwaitingSendPendingOperations", ()=>AccountAwaitingSendPendingOperations);
parcelHelpers.export(exports, "AmountRequired", ()=>AmountRequired);
parcelHelpers.export(exports, "BluetoothRequired", ()=>BluetoothRequired);
parcelHelpers.export(exports, "BtcUnmatchedApp", ()=>BtcUnmatchedApp);
parcelHelpers.export(exports, "CantOpenDevice", ()=>CantOpenDevice);
parcelHelpers.export(exports, "CashAddrNotSupported", ()=>CashAddrNotSupported);
parcelHelpers.export(exports, "ClaimRewardsFeesWarning", ()=>ClaimRewardsFeesWarning);
parcelHelpers.export(exports, "CurrencyNotSupported", ()=>CurrencyNotSupported);
parcelHelpers.export(exports, "DeviceAppVerifyNotSupported", ()=>DeviceAppVerifyNotSupported);
parcelHelpers.export(exports, "DeviceGenuineSocketEarlyClose", ()=>DeviceGenuineSocketEarlyClose);
parcelHelpers.export(exports, "DeviceNotGenuineError", ()=>DeviceNotGenuineError);
parcelHelpers.export(exports, "DeviceOnDashboardExpected", ()=>DeviceOnDashboardExpected);
parcelHelpers.export(exports, "DeviceOnDashboardUnexpected", ()=>DeviceOnDashboardUnexpected);
parcelHelpers.export(exports, "DeviceInOSUExpected", ()=>DeviceInOSUExpected);
parcelHelpers.export(exports, "DeviceHalted", ()=>DeviceHalted);
parcelHelpers.export(exports, "DeviceNameInvalid", ()=>DeviceNameInvalid);
parcelHelpers.export(exports, "DeviceSocketFail", ()=>DeviceSocketFail);
parcelHelpers.export(exports, "DeviceSocketNoBulkStatus", ()=>DeviceSocketNoBulkStatus);
parcelHelpers.export(exports, "DeviceNeedsRestart", ()=>DeviceNeedsRestart);
parcelHelpers.export(exports, "UnresponsiveDeviceError", ()=>UnresponsiveDeviceError);
parcelHelpers.export(exports, "DisconnectedDevice", ()=>DisconnectedDevice);
parcelHelpers.export(exports, "DisconnectedDeviceDuringOperation", ()=>DisconnectedDeviceDuringOperation);
parcelHelpers.export(exports, "DeviceExtractOnboardingStateError", ()=>DeviceExtractOnboardingStateError);
parcelHelpers.export(exports, "DeviceOnboardingStatePollingError", ()=>DeviceOnboardingStatePollingError);
parcelHelpers.export(exports, "EnpointConfigError", ()=>EnpointConfigError);
parcelHelpers.export(exports, "EthAppPleaseEnableContractData", ()=>EthAppPleaseEnableContractData);
parcelHelpers.export(exports, "FeeEstimationFailed", ()=>FeeEstimationFailed);
parcelHelpers.export(exports, "FirmwareNotRecognized", ()=>FirmwareNotRecognized);
parcelHelpers.export(exports, "HardResetFail", ()=>HardResetFail);
parcelHelpers.export(exports, "InvalidXRPTag", ()=>InvalidXRPTag);
parcelHelpers.export(exports, "InvalidAddress", ()=>InvalidAddress);
parcelHelpers.export(exports, "InvalidNonce", ()=>InvalidNonce);
parcelHelpers.export(exports, "InvalidAddressBecauseDestinationIsAlsoSource", ()=>InvalidAddressBecauseDestinationIsAlsoSource);
parcelHelpers.export(exports, "LatestMCUInstalledError", ()=>LatestMCUInstalledError);
parcelHelpers.export(exports, "UnknownMCU", ()=>UnknownMCU);
parcelHelpers.export(exports, "LedgerAPIError", ()=>LedgerAPIError);
parcelHelpers.export(exports, "LedgerAPIErrorWithMessage", ()=>LedgerAPIErrorWithMessage);
parcelHelpers.export(exports, "LedgerAPINotAvailable", ()=>LedgerAPINotAvailable);
parcelHelpers.export(exports, "ManagerAppAlreadyInstalledError", ()=>ManagerAppAlreadyInstalledError);
parcelHelpers.export(exports, "ManagerAppRelyOnBTCError", ()=>ManagerAppRelyOnBTCError);
parcelHelpers.export(exports, "ManagerAppDepInstallRequired", ()=>ManagerAppDepInstallRequired);
parcelHelpers.export(exports, "ManagerAppDepUninstallRequired", ()=>ManagerAppDepUninstallRequired);
parcelHelpers.export(exports, "ManagerDeviceLockedError", ()=>ManagerDeviceLockedError);
parcelHelpers.export(exports, "ManagerFirmwareNotEnoughSpaceError", ()=>ManagerFirmwareNotEnoughSpaceError);
parcelHelpers.export(exports, "ManagerNotEnoughSpaceError", ()=>ManagerNotEnoughSpaceError);
parcelHelpers.export(exports, "ManagerUninstallBTCDep", ()=>ManagerUninstallBTCDep);
parcelHelpers.export(exports, "NetworkDown", ()=>NetworkDown);
parcelHelpers.export(exports, "NetworkError", ()=>NetworkError);
parcelHelpers.export(exports, "NoAddressesFound", ()=>NoAddressesFound);
parcelHelpers.export(exports, "NotEnoughBalance", ()=>NotEnoughBalance);
parcelHelpers.export(exports, "NotEnoughBalanceSwap", ()=>NotEnoughBalanceSwap);
parcelHelpers.export(exports, "NotEnoughBalanceToDelegate", ()=>NotEnoughBalanceToDelegate);
parcelHelpers.export(exports, "NotEnoughBalanceInParentAccount", ()=>NotEnoughBalanceInParentAccount);
parcelHelpers.export(exports, "NotEnoughSpendableBalance", ()=>NotEnoughSpendableBalance);
parcelHelpers.export(exports, "NotEnoughBalanceBecauseDestinationNotCreated", ()=>NotEnoughBalanceBecauseDestinationNotCreated);
parcelHelpers.export(exports, "NoAccessToCamera", ()=>NoAccessToCamera);
parcelHelpers.export(exports, "NotEnoughGas", ()=>NotEnoughGas);
parcelHelpers.export(exports, "NotEnoughGasSwap", ()=>NotEnoughGasSwap);
parcelHelpers.export(exports, "TronEmptyAccount", ()=>TronEmptyAccount);
parcelHelpers.export(exports, "MaybeKeepTronAccountAlive", ()=>MaybeKeepTronAccountAlive);
parcelHelpers.export(exports, "NotSupportedLegacyAddress", ()=>NotSupportedLegacyAddress);
parcelHelpers.export(exports, "GasLessThanEstimate", ()=>GasLessThanEstimate);
parcelHelpers.export(exports, "PriorityFeeTooLow", ()=>PriorityFeeTooLow);
parcelHelpers.export(exports, "PriorityFeeTooHigh", ()=>PriorityFeeTooHigh);
parcelHelpers.export(exports, "PriorityFeeHigherThanMaxFee", ()=>PriorityFeeHigherThanMaxFee);
parcelHelpers.export(exports, "MaxFeeTooLow", ()=>MaxFeeTooLow);
parcelHelpers.export(exports, "PasswordsDontMatchError", ()=>PasswordsDontMatchError);
parcelHelpers.export(exports, "PasswordIncorrectError", ()=>PasswordIncorrectError);
parcelHelpers.export(exports, "RecommendSubAccountsToEmpty", ()=>RecommendSubAccountsToEmpty);
parcelHelpers.export(exports, "RecommendUndelegation", ()=>RecommendUndelegation);
parcelHelpers.export(exports, "TimeoutTagged", ()=>TimeoutTagged);
parcelHelpers.export(exports, "UnexpectedBootloader", ()=>UnexpectedBootloader);
parcelHelpers.export(exports, "MCUNotGenuineToDashboard", ()=>MCUNotGenuineToDashboard);
parcelHelpers.export(exports, "RecipientRequired", ()=>RecipientRequired);
parcelHelpers.export(exports, "UnavailableTezosOriginatedAccountReceive", ()=>UnavailableTezosOriginatedAccountReceive);
parcelHelpers.export(exports, "UnavailableTezosOriginatedAccountSend", ()=>UnavailableTezosOriginatedAccountSend);
parcelHelpers.export(exports, "UpdateFetchFileFail", ()=>UpdateFetchFileFail);
parcelHelpers.export(exports, "UpdateIncorrectHash", ()=>UpdateIncorrectHash);
parcelHelpers.export(exports, "UpdateIncorrectSig", ()=>UpdateIncorrectSig);
parcelHelpers.export(exports, "UpdateYourApp", ()=>UpdateYourApp);
parcelHelpers.export(exports, "UserRefusedDeviceNameChange", ()=>UserRefusedDeviceNameChange);
parcelHelpers.export(exports, "UserRefusedAddress", ()=>UserRefusedAddress);
parcelHelpers.export(exports, "UserRefusedFirmwareUpdate", ()=>UserRefusedFirmwareUpdate);
parcelHelpers.export(exports, "UserRefusedAllowManager", ()=>UserRefusedAllowManager);
parcelHelpers.export(exports, "UserRefusedOnDevice", ()=>UserRefusedOnDevice);
parcelHelpers.export(exports, "PinNotSet", ()=>PinNotSet);
parcelHelpers.export(exports, "ExpertModeRequired", ()=>ExpertModeRequired);
parcelHelpers.export(exports, "TransportOpenUserCancelled", ()=>TransportOpenUserCancelled);
parcelHelpers.export(exports, "TransportInterfaceNotAvailable", ()=>TransportInterfaceNotAvailable);
parcelHelpers.export(exports, "TransportRaceCondition", ()=>TransportRaceCondition);
parcelHelpers.export(exports, "TransportWebUSBGestureRequired", ()=>TransportWebUSBGestureRequired);
parcelHelpers.export(exports, "TransactionHasBeenValidatedError", ()=>TransactionHasBeenValidatedError);
parcelHelpers.export(exports, "TransportExchangeTimeoutError", ()=>TransportExchangeTimeoutError);
parcelHelpers.export(exports, "DeviceShouldStayInApp", ()=>DeviceShouldStayInApp);
parcelHelpers.export(exports, "WebsocketConnectionError", ()=>WebsocketConnectionError);
parcelHelpers.export(exports, "WebsocketConnectionFailed", ()=>WebsocketConnectionFailed);
parcelHelpers.export(exports, "WrongDeviceForAccount", ()=>WrongDeviceForAccount);
parcelHelpers.export(exports, "WrongDeviceForAccountPayout", ()=>WrongDeviceForAccountPayout);
parcelHelpers.export(exports, "WrongDeviceForAccountRefund", ()=>WrongDeviceForAccountRefund);
parcelHelpers.export(exports, "WrongAppForCurrency", ()=>WrongAppForCurrency);
parcelHelpers.export(exports, "ETHAddressNonEIP", ()=>ETHAddressNonEIP);
parcelHelpers.export(exports, "CantScanQRCode", ()=>CantScanQRCode);
parcelHelpers.export(exports, "FeeNotLoaded", ()=>FeeNotLoaded);
parcelHelpers.export(exports, "FeeNotLoadedSwap", ()=>FeeNotLoadedSwap);
parcelHelpers.export(exports, "FeeRequired", ()=>FeeRequired);
parcelHelpers.export(exports, "FeeTooHigh", ()=>FeeTooHigh);
parcelHelpers.export(exports, "PendingOperation", ()=>PendingOperation);
parcelHelpers.export(exports, "SyncError", ()=>SyncError);
parcelHelpers.export(exports, "PairingFailed", ()=>PairingFailed);
parcelHelpers.export(exports, "PeerRemovedPairing", ()=>PeerRemovedPairing);
parcelHelpers.export(exports, "GenuineCheckFailed", ()=>GenuineCheckFailed);
parcelHelpers.export(exports, "LedgerAPI4xx", ()=>LedgerAPI4xx);
parcelHelpers.export(exports, "LedgerAPI5xx", ()=>LedgerAPI5xx);
parcelHelpers.export(exports, "FirmwareOrAppUpdateRequired", ()=>FirmwareOrAppUpdateRequired);
parcelHelpers.export(exports, "ReplacementTransactionUnderpriced", ()=>ReplacementTransactionUnderpriced);
parcelHelpers.export(exports, "OpReturnDataSizeLimit", ()=>OpReturnDataSizeLimit);
parcelHelpers.export(exports, "DustLimit", ()=>DustLimit);
parcelHelpers.export(exports, "LanguageNotFound", ()=>LanguageNotFound);
parcelHelpers.export(exports, "NoDBPathGiven", ()=>NoDBPathGiven);
parcelHelpers.export(exports, "DBWrongPassword", ()=>DBWrongPassword);
parcelHelpers.export(exports, "DBNotReset", ()=>DBNotReset);
parcelHelpers.export(exports, "SequenceNumberError", ()=>SequenceNumberError);
parcelHelpers.export(exports, "DisabledTransactionBroadcastError", ()=>DisabledTransactionBroadcastError);
parcelHelpers.export(exports, "HwTransportErrorType", ()=>HwTransportErrorType);
/**
 * Represents an error coming from the usage of any Transport implementation.
 *
 * Needed to map a specific implementation error into an error that
 * can be managed by any code unaware of the specific Transport implementation
 * that was used.
 */ parcelHelpers.export(exports, "HwTransportError", ()=>HwTransportError);
/**
 * TransportError is used for any generic transport errors.
 * e.g. Error thrown when data received by exchanges are incorrect or if exchanged failed to communicate with the device for various reason.
 */ parcelHelpers.export(exports, "TransportError", ()=>TransportError);
parcelHelpers.export(exports, "StatusCodes", ()=>StatusCodes);
parcelHelpers.export(exports, "getAltStatusMessage", ()=>getAltStatusMessage);
/**
 * Error thrown when a device returned a non success status.
 * the error.statusCode is one of the `StatusCodes` exported by this library.
 */ parcelHelpers.export(exports, "TransportStatusError", ()=>TransportStatusError);
parcelHelpers.export(exports, "LockedDeviceError", ()=>LockedDeviceError);
var _helpers = require("./helpers");
const AccountNameRequiredError = (0, _helpers.createCustomErrorClass)("AccountNameRequired");
const AccountNotSupported = (0, _helpers.createCustomErrorClass)("AccountNotSupported");
const AccountAwaitingSendPendingOperations = (0, _helpers.createCustomErrorClass)("AccountAwaitingSendPendingOperations");
const AmountRequired = (0, _helpers.createCustomErrorClass)("AmountRequired");
const BluetoothRequired = (0, _helpers.createCustomErrorClass)("BluetoothRequired");
const BtcUnmatchedApp = (0, _helpers.createCustomErrorClass)("BtcUnmatchedApp");
const CantOpenDevice = (0, _helpers.createCustomErrorClass)("CantOpenDevice");
const CashAddrNotSupported = (0, _helpers.createCustomErrorClass)("CashAddrNotSupported");
const ClaimRewardsFeesWarning = (0, _helpers.createCustomErrorClass)("ClaimRewardsFeesWarning");
const CurrencyNotSupported = (0, _helpers.createCustomErrorClass)("CurrencyNotSupported");
const DeviceAppVerifyNotSupported = (0, _helpers.createCustomErrorClass)("DeviceAppVerifyNotSupported");
const DeviceGenuineSocketEarlyClose = (0, _helpers.createCustomErrorClass)("DeviceGenuineSocketEarlyClose");
const DeviceNotGenuineError = (0, _helpers.createCustomErrorClass)("DeviceNotGenuine");
const DeviceOnDashboardExpected = (0, _helpers.createCustomErrorClass)("DeviceOnDashboardExpected");
const DeviceOnDashboardUnexpected = (0, _helpers.createCustomErrorClass)("DeviceOnDashboardUnexpected");
const DeviceInOSUExpected = (0, _helpers.createCustomErrorClass)("DeviceInOSUExpected");
const DeviceHalted = (0, _helpers.createCustomErrorClass)("DeviceHalted");
const DeviceNameInvalid = (0, _helpers.createCustomErrorClass)("DeviceNameInvalid");
const DeviceSocketFail = (0, _helpers.createCustomErrorClass)("DeviceSocketFail");
const DeviceSocketNoBulkStatus = (0, _helpers.createCustomErrorClass)("DeviceSocketNoBulkStatus");
const DeviceNeedsRestart = (0, _helpers.createCustomErrorClass)("DeviceSocketNoBulkStatus");
const UnresponsiveDeviceError = (0, _helpers.createCustomErrorClass)("UnresponsiveDeviceError");
const DisconnectedDevice = (0, _helpers.createCustomErrorClass)("DisconnectedDevice");
const DisconnectedDeviceDuringOperation = (0, _helpers.createCustomErrorClass)("DisconnectedDeviceDuringOperation");
const DeviceExtractOnboardingStateError = (0, _helpers.createCustomErrorClass)("DeviceExtractOnboardingStateError");
const DeviceOnboardingStatePollingError = (0, _helpers.createCustomErrorClass)("DeviceOnboardingStatePollingError");
const EnpointConfigError = (0, _helpers.createCustomErrorClass)("EnpointConfig");
const EthAppPleaseEnableContractData = (0, _helpers.createCustomErrorClass)("EthAppPleaseEnableContractData");
const FeeEstimationFailed = (0, _helpers.createCustomErrorClass)("FeeEstimationFailed");
const FirmwareNotRecognized = (0, _helpers.createCustomErrorClass)("FirmwareNotRecognized");
const HardResetFail = (0, _helpers.createCustomErrorClass)("HardResetFail");
const InvalidXRPTag = (0, _helpers.createCustomErrorClass)("InvalidXRPTag");
const InvalidAddress = (0, _helpers.createCustomErrorClass)("InvalidAddress");
const InvalidNonce = (0, _helpers.createCustomErrorClass)("InvalidNonce");
const InvalidAddressBecauseDestinationIsAlsoSource = (0, _helpers.createCustomErrorClass)("InvalidAddressBecauseDestinationIsAlsoSource");
const LatestMCUInstalledError = (0, _helpers.createCustomErrorClass)("LatestMCUInstalledError");
const UnknownMCU = (0, _helpers.createCustomErrorClass)("UnknownMCU");
const LedgerAPIError = (0, _helpers.createCustomErrorClass)("LedgerAPIError");
const LedgerAPIErrorWithMessage = (0, _helpers.createCustomErrorClass)("LedgerAPIErrorWithMessage");
const LedgerAPINotAvailable = (0, _helpers.createCustomErrorClass)("LedgerAPINotAvailable");
const ManagerAppAlreadyInstalledError = (0, _helpers.createCustomErrorClass)("ManagerAppAlreadyInstalled");
const ManagerAppRelyOnBTCError = (0, _helpers.createCustomErrorClass)("ManagerAppRelyOnBTC");
const ManagerAppDepInstallRequired = (0, _helpers.createCustomErrorClass)("ManagerAppDepInstallRequired");
const ManagerAppDepUninstallRequired = (0, _helpers.createCustomErrorClass)("ManagerAppDepUninstallRequired");
const ManagerDeviceLockedError = (0, _helpers.createCustomErrorClass)("ManagerDeviceLocked");
const ManagerFirmwareNotEnoughSpaceError = (0, _helpers.createCustomErrorClass)("ManagerFirmwareNotEnoughSpace");
const ManagerNotEnoughSpaceError = (0, _helpers.createCustomErrorClass)("ManagerNotEnoughSpace");
const ManagerUninstallBTCDep = (0, _helpers.createCustomErrorClass)("ManagerUninstallBTCDep");
const NetworkDown = (0, _helpers.createCustomErrorClass)("NetworkDown");
const NetworkError = (0, _helpers.createCustomErrorClass)("NetworkError");
const NoAddressesFound = (0, _helpers.createCustomErrorClass)("NoAddressesFound");
const NotEnoughBalance = (0, _helpers.createCustomErrorClass)("NotEnoughBalance");
const NotEnoughBalanceSwap = (0, _helpers.createCustomErrorClass)("NotEnoughBalanceSwap");
const NotEnoughBalanceToDelegate = (0, _helpers.createCustomErrorClass)("NotEnoughBalanceToDelegate");
const NotEnoughBalanceInParentAccount = (0, _helpers.createCustomErrorClass)("NotEnoughBalanceInParentAccount");
const NotEnoughSpendableBalance = (0, _helpers.createCustomErrorClass)("NotEnoughSpendableBalance");
const NotEnoughBalanceBecauseDestinationNotCreated = (0, _helpers.createCustomErrorClass)("NotEnoughBalanceBecauseDestinationNotCreated");
const NoAccessToCamera = (0, _helpers.createCustomErrorClass)("NoAccessToCamera");
const NotEnoughGas = (0, _helpers.createCustomErrorClass)("NotEnoughGas");
const NotEnoughGasSwap = (0, _helpers.createCustomErrorClass)("NotEnoughGasSwap");
const TronEmptyAccount = (0, _helpers.createCustomErrorClass)("TronEmptyAccount");
const MaybeKeepTronAccountAlive = (0, _helpers.createCustomErrorClass)("MaybeKeepTronAccountAlive");
const NotSupportedLegacyAddress = (0, _helpers.createCustomErrorClass)("NotSupportedLegacyAddress");
const GasLessThanEstimate = (0, _helpers.createCustomErrorClass)("GasLessThanEstimate");
const PriorityFeeTooLow = (0, _helpers.createCustomErrorClass)("PriorityFeeTooLow");
const PriorityFeeTooHigh = (0, _helpers.createCustomErrorClass)("PriorityFeeTooHigh");
const PriorityFeeHigherThanMaxFee = (0, _helpers.createCustomErrorClass)("PriorityFeeHigherThanMaxFee");
const MaxFeeTooLow = (0, _helpers.createCustomErrorClass)("MaxFeeTooLow");
const PasswordsDontMatchError = (0, _helpers.createCustomErrorClass)("PasswordsDontMatch");
const PasswordIncorrectError = (0, _helpers.createCustomErrorClass)("PasswordIncorrect");
const RecommendSubAccountsToEmpty = (0, _helpers.createCustomErrorClass)("RecommendSubAccountsToEmpty");
const RecommendUndelegation = (0, _helpers.createCustomErrorClass)("RecommendUndelegation");
const TimeoutTagged = (0, _helpers.createCustomErrorClass)("TimeoutTagged");
const UnexpectedBootloader = (0, _helpers.createCustomErrorClass)("UnexpectedBootloader");
const MCUNotGenuineToDashboard = (0, _helpers.createCustomErrorClass)("MCUNotGenuineToDashboard");
const RecipientRequired = (0, _helpers.createCustomErrorClass)("RecipientRequired");
const UnavailableTezosOriginatedAccountReceive = (0, _helpers.createCustomErrorClass)("UnavailableTezosOriginatedAccountReceive");
const UnavailableTezosOriginatedAccountSend = (0, _helpers.createCustomErrorClass)("UnavailableTezosOriginatedAccountSend");
const UpdateFetchFileFail = (0, _helpers.createCustomErrorClass)("UpdateFetchFileFail");
const UpdateIncorrectHash = (0, _helpers.createCustomErrorClass)("UpdateIncorrectHash");
const UpdateIncorrectSig = (0, _helpers.createCustomErrorClass)("UpdateIncorrectSig");
const UpdateYourApp = (0, _helpers.createCustomErrorClass)("UpdateYourApp");
const UserRefusedDeviceNameChange = (0, _helpers.createCustomErrorClass)("UserRefusedDeviceNameChange");
const UserRefusedAddress = (0, _helpers.createCustomErrorClass)("UserRefusedAddress");
const UserRefusedFirmwareUpdate = (0, _helpers.createCustomErrorClass)("UserRefusedFirmwareUpdate");
const UserRefusedAllowManager = (0, _helpers.createCustomErrorClass)("UserRefusedAllowManager");
const UserRefusedOnDevice = (0, _helpers.createCustomErrorClass)("UserRefusedOnDevice"); // TODO rename because it's just for transaction refusal
const PinNotSet = (0, _helpers.createCustomErrorClass)("PinNotSet");
const ExpertModeRequired = (0, _helpers.createCustomErrorClass)("ExpertModeRequired");
const TransportOpenUserCancelled = (0, _helpers.createCustomErrorClass)("TransportOpenUserCancelled");
const TransportInterfaceNotAvailable = (0, _helpers.createCustomErrorClass)("TransportInterfaceNotAvailable");
const TransportRaceCondition = (0, _helpers.createCustomErrorClass)("TransportRaceCondition");
const TransportWebUSBGestureRequired = (0, _helpers.createCustomErrorClass)("TransportWebUSBGestureRequired");
const TransactionHasBeenValidatedError = (0, _helpers.createCustomErrorClass)("TransactionHasBeenValidatedError");
const TransportExchangeTimeoutError = (0, _helpers.createCustomErrorClass)("TransportExchangeTimeoutError");
const DeviceShouldStayInApp = (0, _helpers.createCustomErrorClass)("DeviceShouldStayInApp");
const WebsocketConnectionError = (0, _helpers.createCustomErrorClass)("WebsocketConnectionError");
const WebsocketConnectionFailed = (0, _helpers.createCustomErrorClass)("WebsocketConnectionFailed");
const WrongDeviceForAccount = (0, _helpers.createCustomErrorClass)("WrongDeviceForAccount");
const WrongDeviceForAccountPayout = (0, _helpers.createCustomErrorClass)("WrongDeviceForAccountPayout");
const WrongDeviceForAccountRefund = (0, _helpers.createCustomErrorClass)("WrongDeviceForAccountRefund");
const WrongAppForCurrency = (0, _helpers.createCustomErrorClass)("WrongAppForCurrency");
const ETHAddressNonEIP = (0, _helpers.createCustomErrorClass)("ETHAddressNonEIP");
const CantScanQRCode = (0, _helpers.createCustomErrorClass)("CantScanQRCode");
const FeeNotLoaded = (0, _helpers.createCustomErrorClass)("FeeNotLoaded");
const FeeNotLoadedSwap = (0, _helpers.createCustomErrorClass)("FeeNotLoadedSwap");
const FeeRequired = (0, _helpers.createCustomErrorClass)("FeeRequired");
const FeeTooHigh = (0, _helpers.createCustomErrorClass)("FeeTooHigh");
const PendingOperation = (0, _helpers.createCustomErrorClass)("PendingOperation");
const SyncError = (0, _helpers.createCustomErrorClass)("SyncError");
const PairingFailed = (0, _helpers.createCustomErrorClass)("PairingFailed");
const PeerRemovedPairing = (0, _helpers.createCustomErrorClass)("PeerRemovedPairing");
const GenuineCheckFailed = (0, _helpers.createCustomErrorClass)("GenuineCheckFailed");
const LedgerAPI4xx = (0, _helpers.createCustomErrorClass)("LedgerAPI4xx");
const LedgerAPI5xx = (0, _helpers.createCustomErrorClass)("LedgerAPI5xx");
const FirmwareOrAppUpdateRequired = (0, _helpers.createCustomErrorClass)("FirmwareOrAppUpdateRequired");
const ReplacementTransactionUnderpriced = (0, _helpers.createCustomErrorClass)("ReplacementTransactionUnderpriced");
const OpReturnDataSizeLimit = (0, _helpers.createCustomErrorClass)("OpReturnSizeLimit");
const DustLimit = (0, _helpers.createCustomErrorClass)("DustLimit");
const LanguageNotFound = (0, _helpers.createCustomErrorClass)("LanguageNotFound");
const NoDBPathGiven = (0, _helpers.createCustomErrorClass)("NoDBPathGiven");
const DBWrongPassword = (0, _helpers.createCustomErrorClass)("DBWrongPassword");
const DBNotReset = (0, _helpers.createCustomErrorClass)("DBNotReset");
const SequenceNumberError = (0, _helpers.createCustomErrorClass)("SequenceNumberError");
const DisabledTransactionBroadcastError = (0, _helpers.createCustomErrorClass)("DisabledTransactionBroadcastError");
var HwTransportErrorType;
(function(HwTransportErrorType) {
    HwTransportErrorType["Unknown"] = "Unknown";
    HwTransportErrorType["LocationServicesDisabled"] = "LocationServicesDisabled";
    HwTransportErrorType["LocationServicesUnauthorized"] = "LocationServicesUnauthorized";
    HwTransportErrorType["BluetoothScanStartFailed"] = "BluetoothScanStartFailed";
})(HwTransportErrorType || (HwTransportErrorType = {}));
class HwTransportError extends Error {
    constructor(type, message){
        super(message);
        this.name = "HwTransportError";
        this.type = type;
        // Needed as long as we target < ES6
        Object.setPrototypeOf(this, HwTransportError.prototype);
    }
}
class TransportError extends Error {
    constructor(message, id){
        const name = "TransportError";
        super(message || name);
        this.name = name;
        this.message = message;
        this.stack = new Error(message).stack;
        this.id = id;
    }
}
(0, _helpers.addCustomErrorDeserializer)("TransportError", (e)=>new TransportError(e.message, e.id));
const StatusCodes = {
    ACCESS_CONDITION_NOT_FULFILLED: 0x9804,
    ALGORITHM_NOT_SUPPORTED: 0x9484,
    CLA_NOT_SUPPORTED: 0x6e00,
    CODE_BLOCKED: 0x9840,
    CODE_NOT_INITIALIZED: 0x9802,
    COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 0x6981,
    CONDITIONS_OF_USE_NOT_SATISFIED: 0x6985,
    CONTRADICTION_INVALIDATION: 0x9810,
    CONTRADICTION_SECRET_CODE_STATUS: 0x9808,
    DEVICE_IN_RECOVERY_MODE: 0x662f,
    CUSTOM_IMAGE_EMPTY: 0x662e,
    FILE_ALREADY_EXISTS: 0x6a89,
    FILE_NOT_FOUND: 0x9404,
    GP_AUTH_FAILED: 0x6300,
    HALTED: 0x6faa,
    INCONSISTENT_FILE: 0x9408,
    INCORRECT_DATA: 0x6a80,
    INCORRECT_LENGTH: 0x6700,
    INCORRECT_P1_P2: 0x6b00,
    INS_NOT_SUPPORTED: 0x6d00,
    DEVICE_NOT_ONBOARDED: 0x6d07,
    DEVICE_NOT_ONBOARDED_2: 0x6611,
    INVALID_KCV: 0x9485,
    INVALID_OFFSET: 0x9402,
    LICENSING: 0x6f42,
    LOCKED_DEVICE: 0x5515,
    MAX_VALUE_REACHED: 0x9850,
    MEMORY_PROBLEM: 0x9240,
    MISSING_CRITICAL_PARAMETER: 0x6800,
    NO_EF_SELECTED: 0x9400,
    NOT_ENOUGH_MEMORY_SPACE: 0x6a84,
    OK: 0x9000,
    PIN_REMAINING_ATTEMPTS: 0x63c0,
    REFERENCED_DATA_NOT_FOUND: 0x6a88,
    SECURITY_STATUS_NOT_SATISFIED: 0x6982,
    TECHNICAL_PROBLEM: 0x6f00,
    UNKNOWN_APDU: 0x6d02,
    USER_REFUSED_ON_DEVICE: 0x5501,
    NOT_ENOUGH_SPACE: 0x5102,
    APP_NOT_FOUND_OR_INVALID_CONTEXT: 0x5123,
    INVALID_APP_NAME_LENGTH: 0x670a,
    GEN_AES_KEY_FAILED: 0x5419,
    INTERNAL_CRYPTO_OPERATION_FAILED: 0x541a,
    INTERNAL_COMPUTE_AES_CMAC_FAILED: 0x541b,
    ENCRYPT_APP_STORAGE_FAILED: 0x541c,
    INVALID_BACKUP_STATE: 0x6642,
    PIN_NOT_SET: 0x5502,
    INVALID_BACKUP_LENGTH: 0x6733,
    INVALID_RESTORE_STATE: 0x6643,
    INVALID_CHUNK_LENGTH: 0x6734,
    INVALID_BACKUP_HEADER: 0x684a,
    // Not documented:
    TRUSTCHAIN_WRONG_SEED: 0xb007
};
function getAltStatusMessage(code) {
    switch(code){
        // improve text of most common errors
        case 0x6700:
            return "Incorrect length";
        case 0x6800:
            return "Missing critical parameter";
        case 0x6982:
            return "Security not satisfied (dongle locked or have invalid access rights)";
        case 0x6985:
            return "Condition of use not satisfied (denied by the user?)";
        case 0x6a80:
            return "Invalid data received";
        case 0x6b00:
            return "Invalid parameter received";
        case 0x5515:
            return "Locked device";
    }
    if (0x6f00 <= code && code <= 0x6fff) return "Internal error, please report";
}
class TransportStatusError extends Error {
    /**
     * @param statusCode The error status code coming from a Transport implementation
     * @param options containing:
     *  - canBeMappedToChildError: enable the mapping of TransportStatusError to an error extending/inheriting from it
     *  . Ex: LockedDeviceError. Default to true.
     */ constructor(statusCode, { canBeMappedToChildError = true } = {}){
        const statusText = Object.keys(StatusCodes).find((k)=>StatusCodes[k] === statusCode) || "UNKNOWN_ERROR";
        const smsg = getAltStatusMessage(statusCode) || statusText;
        const statusCodeStr = statusCode.toString(16);
        const message = `Ledger device: ${smsg} (0x${statusCodeStr})`;
        super(message);
        this.name = "TransportStatusError";
        this.statusCode = statusCode;
        this.statusText = statusText;
        Object.setPrototypeOf(this, TransportStatusError.prototype);
        // Maps to a LockedDeviceError
        if (canBeMappedToChildError && statusCode === StatusCodes.LOCKED_DEVICE) return new LockedDeviceError(message);
    }
}
class LockedDeviceError extends TransportStatusError {
    constructor(message){
        super(StatusCodes.LOCKED_DEVICE, {
            canBeMappedToChildError: false
        });
        if (message) this.message = message;
        this.name = "LockedDeviceError";
        Object.setPrototypeOf(this, LockedDeviceError.prototype);
    }
}
(0, _helpers.addCustomErrorDeserializer)("TransportStatusError", (e)=>new TransportStatusError(e.statusCode));

},{"./helpers":"20Lm4","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"20Lm4":[function(require,module,exports,__globalThis) {
/* eslint-disable no-continue */ /* eslint-disable no-unused-vars */ /* eslint-disable no-param-reassign */ /* eslint-disable no-prototype-builtins */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addCustomErrorDeserializer", ()=>addCustomErrorDeserializer);
parcelHelpers.export(exports, "createCustomErrorClass", ()=>createCustomErrorClass);
parcelHelpers.export(exports, "deserializeError", ()=>deserializeError);
parcelHelpers.export(exports, "serializeError", ()=>serializeError);
const errorClasses = {};
const deserializers = {};
const addCustomErrorDeserializer = (name, deserializer)=>{
    deserializers[name] = deserializer;
};
const createCustomErrorClass = (name)=>{
    class CustomErrorClass extends Error {
        constructor(message, fields, options){
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            super(message || name, options);
            // Set the prototype explicitly. See https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
            Object.setPrototypeOf(this, CustomErrorClass.prototype);
            this.name = name;
            if (fields) for(const k in fields)// eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this[k] = fields[k];
            if (options && isObject(options) && "cause" in options && !("cause" in this)) {
                // .cause was specified but the superconstructor
                // did not create an instance property.
                const cause = options.cause;
                this.cause = cause;
                if ("stack" in cause) this.stack = this.stack + "\nCAUSE: " + cause.stack;
            }
        }
    }
    errorClasses[name] = CustomErrorClass;
    return CustomErrorClass;
};
function isObject(value) {
    return typeof value === "object";
}
const deserializeError = (object)=>{
    if (object && typeof object === "object") {
        try {
            if (typeof object.message === "string") {
                const msg = JSON.parse(object.message);
                if (msg.message && msg.name) object = msg;
            }
        } catch (e) {
        // nothing
        }
        let error;
        if (typeof object.name === "string") {
            const { name } = object;
            const des = deserializers[name];
            if (des) error = des(object);
            else {
                let constructor = name === "Error" ? Error : errorClasses[name];
                if (!constructor) {
                    console.warn("deserializing an unknown class '" + name + "'");
                    constructor = createCustomErrorClass(name);
                }
                error = Object.create(constructor.prototype);
                try {
                    for(const prop in object)if (object.hasOwnProperty(prop)) error[prop] = object[prop];
                } catch (e) {
                // sometimes setting a property can fail (e.g. .name)
                }
            }
        } else if (typeof object.message === "string") error = new Error(object.message);
        if (error && !error.stack && Error.captureStackTrace) Error.captureStackTrace(error, deserializeError);
        return error;
    }
    return new Error(String(object));
};
const serializeError = (value)=>{
    if (!value) return value;
    if (typeof value === "object") return destroyCircular(value, []);
    if (typeof value === "function") return `[Function: ${value.name || "anonymous"}]`;
    return value;
};
// https://www.npmjs.com/package/destroy-circular
function destroyCircular(from, seen) {
    const to = {};
    seen.push(from);
    for (const key of Object.keys(from)){
        const value = from[key];
        if (typeof value === "function") continue;
        if (!value || typeof value !== "object") {
            to[key] = value;
            continue;
        }
        if (seen.indexOf(from[key]) === -1) {
            to[key] = destroyCircular(from[key], seen.slice(0));
            continue;
        }
        to[key] = "[Circular]";
    }
    if (typeof from.name === "string") to.name = from.name;
    if (typeof from.message === "string") to.message = from.message;
    if (typeof from.stack === "string") to.stack = from.stack;
    return to;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2hpLA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "log", ()=>log);
parcelHelpers.export(exports, "trace", ()=>trace);
/**
 * A simple tracer class, that can be used to avoid repetition when using the `trace` function
 *
 * Its goal is to capture more context than a log function.
 * This is simple for now, but can be improved later.
 *
 * @param type A given type (not level) for the current local tracer ("hw", "withDevice", etc.)
 * @param context Anything representing the context where the log occurred
 */ parcelHelpers.export(exports, "LocalTracer", ()=>LocalTracer);
parcelHelpers.export(exports, "listen", ()=>listen);
let id = 0;
const subscribers = [];
const log = (type, message, data)=>{
    const obj = {
        type,
        id: String(++id),
        date: new Date()
    };
    if (message) obj.message = message;
    if (data) obj.data = data;
    dispatch(obj);
};
const trace = ({ type, message, data, context })=>{
    const obj = {
        type,
        id: String(++id),
        date: new Date()
    };
    if (message) obj.message = message;
    if (data) obj.data = data;
    if (context) obj.context = context;
    dispatch(obj);
};
class LocalTracer {
    constructor(type, context){
        this.type = type;
        this.context = context;
    }
    trace(message, data) {
        trace({
            type: this.type,
            message,
            data,
            context: this.context
        });
    }
    getContext() {
        return this.context;
    }
    setContext(context) {
        this.context = context;
    }
    updateContext(contextToAdd) {
        this.context = Object.assign(Object.assign({}, this.context), contextToAdd);
    }
    getType() {
        return this.type;
    }
    setType(type) {
        this.type = type;
    }
    /**
     * Create a new instance of the LocalTracer with an updated `type`
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     */ withType(type) {
        return new LocalTracer(type, this.context);
    }
    /**
     * Create a new instance of the LocalTracer with a new `context`
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     *
     * @param context A TraceContext, that can undefined to reset the context
     */ withContext(context) {
        return new LocalTracer(this.type, context);
    }
    /**
     * Create a new instance of the LocalTracer with an updated `context`,
     * on which an additional context is merged with the existing one.
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     */ withUpdatedContext(contextToAdd) {
        return new LocalTracer(this.type, Object.assign(Object.assign({}, this.context), contextToAdd));
    }
}
const listen = (cb)=>{
    subscribers.push(cb);
    return ()=>{
        const i = subscribers.indexOf(cb);
        if (i !== -1) {
            // equivalent of subscribers.splice(i, 1) // https://twitter.com/Rich_Harris/status/1125850391155965952
            subscribers[i] = subscribers[subscribers.length - 1];
            subscribers.pop();
        }
    };
};
function dispatch(log) {
    for(let i = 0; i < subscribers.length; i++)try {
        subscribers[i](log);
    } catch (e) {
        console.error(e);
    }
}
if (typeof window !== "undefined") window.__ledgerLogsListen = listen;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"liuPa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _errors = require("@ledgerhq/errors");
var Buffer = require("ebb2a684f25c5c57").Buffer;
const Tag = 0x05;
function asUInt16BE(value) {
    const b = Buffer.alloc(2);
    b.writeUInt16BE(value, 0);
    return b;
}
const initialAcc = {
    data: Buffer.alloc(0),
    dataLength: 0,
    sequence: 0
};
/**
 * Object to handle HID frames (encoding and decoding)
 *
 * @param channel
 * @param packetSize The HID protocol packet size in bytes (usually 64)
 */ const createHIDframing = (channel, packetSize)=>{
    return {
        /**
         * Frames/encodes an APDU message into HID USB packets/frames
         *
         * @param apdu The APDU message to send, in a Buffer containing [cla, ins, p1, p2, data length, data(if not empty)]
         * @returns an array of HID USB frames ready to be sent
         */ makeBlocks (apdu) {
            // Encodes the APDU length in 2 bytes before the APDU itself.
            // The length is measured as the number of bytes.
            // As the size of the APDU `data` should have been added in 1 byte just before `data`,
            // the minimum size of an APDU is 5 bytes.
            let data = Buffer.concat([
                asUInt16BE(apdu.length),
                apdu
            ]);
            const blockSize = packetSize - 5;
            const nbBlocks = Math.ceil(data.length / blockSize);
            // Fills data with 0-padding
            data = Buffer.concat([
                data,
                Buffer.alloc(nbBlocks * blockSize - data.length + 1).fill(0)
            ]);
            const blocks = [];
            for(let i = 0; i < nbBlocks; i++){
                const head = Buffer.alloc(5);
                head.writeUInt16BE(channel, 0);
                head.writeUInt8(Tag, 2);
                head.writeUInt16BE(i, 3);
                // `slice` and not `subarray`: this might not be a Node Buffer, but probably only a Uint8Array
                const chunk = data.slice(i * blockSize, (i + 1) * blockSize);
                blocks.push(Buffer.concat([
                    head,
                    chunk
                ]));
            }
            return blocks;
        },
        /**
         * Reduces HID USB packets/frames to one response.
         *
         * @param acc The value resulting from (accumulating) the previous call of reduceResponse.
         *   On first call initialized to `initialAcc`. The accumulator enables handling multi-frames messages.
         * @param chunk Current chunk to reduce into accumulator
         * @returns An accumulator value updated with the current chunk
         */ reduceResponse (acc, chunk) {
            let { data, dataLength, sequence } = acc || initialAcc;
            if (chunk.readUInt16BE(0) !== channel) throw new (0, _errors.TransportError)("Invalid channel", "InvalidChannel");
            if (chunk.readUInt8(2) !== Tag) throw new (0, _errors.TransportError)("Invalid tag", "InvalidTag");
            if (chunk.readUInt16BE(3) !== sequence) throw new (0, _errors.TransportError)("Invalid sequence", "InvalidSequence");
            // Gets the total length of the response from the 1st frame
            if (!acc) dataLength = chunk.readUInt16BE(5);
            sequence++;
            // The total length on the 1st frame takes 2 more bytes
            const chunkData = chunk.slice(acc ? 5 : 7);
            data = Buffer.concat([
                data,
                chunkData
            ]);
            // Removes any 0 padding
            if (data.length > dataLength) data = data.slice(0, dataLength);
            return {
                data,
                dataLength,
                sequence
            };
        },
        /**
         * Returns the response message that has been reduced from the HID USB frames
         *
         * @param acc The accumulator
         * @returns A Buffer containing the cleaned response message, or null if no response message, or undefined if the
         *   accumulator is incorrect (message length is not valid)
         */ getReducedResult (acc) {
            if (acc && acc.dataLength === acc.data.length) return acc.data;
        }
    };
};
exports.default = createHIDframing;

},{"ebb2a684f25c5c57":"eXvXD","@ledgerhq/errors":"7T5AD","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"j8MQh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IIGenericHID", ()=>IIGenericHID);
parcelHelpers.export(exports, "IIKeyboardHID", ()=>IIKeyboardHID);
parcelHelpers.export(exports, "IIU2F", ()=>IIU2F);
parcelHelpers.export(exports, "IICCID", ()=>IICCID);
parcelHelpers.export(exports, "IIWebUSB", ()=>IIWebUSB);
parcelHelpers.export(exports, "DeviceModelId", ()=>DeviceModelId);
parcelHelpers.export(exports, "ledgerUSBVendorId", ()=>ledgerUSBVendorId);
parcelHelpers.export(exports, "getDeviceModel", ()=>getDeviceModel);
parcelHelpers.export(exports, "identifyTargetId", ()=>identifyTargetId);
parcelHelpers.export(exports, "identifyUSBProductId", ()=>identifyUSBProductId);
parcelHelpers.export(exports, "identifyProductName", ()=>identifyProductName);
parcelHelpers.export(exports, "getBluetoothServiceUuids", ()=>getBluetoothServiceUuids);
parcelHelpers.export(exports, "getInfosForServiceUuid", ()=>getInfosForServiceUuid);
var _semver = require("semver");
var _semverDefault = parcelHelpers.interopDefault(_semver);
const IIGenericHID = 0x01;
const IIKeyboardHID = 0x02;
const IIU2F = 0x04;
const IICCID = 0x08;
const IIWebUSB = 0x10;
var DeviceModelId;
(function(DeviceModelId) {
    /** Ledger Blue */ DeviceModelId["blue"] = "blue";
    /** Ledger Nano S */ DeviceModelId["nanoS"] = "nanoS";
    /** Ledger Nano S Plus */ DeviceModelId["nanoSP"] = "nanoSP";
    /** Ledger Nano X */ DeviceModelId["nanoX"] = "nanoX";
    /** Ledger Stax */ DeviceModelId["stax"] = "stax";
    /** Ledger Flex ("europa" is the internal name) */ DeviceModelId["europa"] = "europa";
})(DeviceModelId || (DeviceModelId = {}));
const devices = {
    [DeviceModelId.blue]: {
        id: DeviceModelId.blue,
        productName: "Ledger\xa0Blue",
        productIdMM: 0x00,
        legacyUsbProductId: 0x0000,
        usbOnly: true,
        memorySize: 491520,
        masks: [
            0x31000000,
            0x31010000
        ],
        getBlockSize: (_firwareVersion)=>4096
    },
    [DeviceModelId.nanoS]: {
        id: DeviceModelId.nanoS,
        productName: "Ledger\xa0Nano\xa0S",
        productIdMM: 0x10,
        legacyUsbProductId: 0x0001,
        usbOnly: true,
        memorySize: 327680,
        masks: [
            0x31100000
        ],
        getBlockSize: (firmwareVersion)=>{
            var _a;
            return (0, _semverDefault.default).lt((_a = (0, _semverDefault.default).coerce(firmwareVersion)) !== null && _a !== void 0 ? _a : "", "2.0.0") ? 4096 : 2048;
        }
    },
    [DeviceModelId.nanoX]: {
        id: DeviceModelId.nanoX,
        productName: "Ledger\xa0Nano\xa0X",
        productIdMM: 0x40,
        legacyUsbProductId: 0x0004,
        usbOnly: false,
        memorySize: 2097152,
        masks: [
            0x33000000
        ],
        getBlockSize: (_firwareVersion)=>4096,
        bluetoothSpec: [
            {
                serviceUuid: "13d63400-2c97-0004-0000-4c6564676572",
                notifyUuid: "13d63400-2c97-0004-0001-4c6564676572",
                writeUuid: "13d63400-2c97-0004-0002-4c6564676572",
                writeCmdUuid: "13d63400-2c97-0004-0003-4c6564676572"
            }
        ]
    },
    [DeviceModelId.nanoSP]: {
        id: DeviceModelId.nanoSP,
        productName: "Ledger Nano S Plus",
        productIdMM: 0x50,
        legacyUsbProductId: 0x0005,
        usbOnly: true,
        memorySize: 1569792,
        masks: [
            0x33100000
        ],
        getBlockSize: (_firmwareVersion)=>32
    },
    [DeviceModelId.stax]: {
        id: DeviceModelId.stax,
        productName: "Ledger\xa0Stax",
        productIdMM: 0x60,
        legacyUsbProductId: 0x0006,
        usbOnly: false,
        memorySize: 1569792,
        masks: [
            0x33200000
        ],
        getBlockSize: (_firmwareVersion)=>32,
        bluetoothSpec: [
            {
                serviceUuid: "13d63400-2c97-6004-0000-4c6564676572",
                notifyUuid: "13d63400-2c97-6004-0001-4c6564676572",
                writeUuid: "13d63400-2c97-6004-0002-4c6564676572",
                writeCmdUuid: "13d63400-2c97-6004-0003-4c6564676572"
            }
        ]
    },
    [DeviceModelId.europa]: {
        id: DeviceModelId.europa,
        productName: "Ledger\xa0Flex",
        productIdMM: 0x70,
        legacyUsbProductId: 0x0007,
        usbOnly: false,
        memorySize: 1569792,
        masks: [
            0x33300000
        ],
        getBlockSize: (_firmwareVersion)=>32,
        bluetoothSpec: [
            {
                serviceUuid: "13d63400-2c97-3004-0000-4c6564676572",
                notifyUuid: "13d63400-2c97-3004-0001-4c6564676572",
                writeUuid: "13d63400-2c97-3004-0002-4c6564676572",
                writeCmdUuid: "13d63400-2c97-3004-0003-4c6564676572"
            }
        ]
    }
};
const productMap = {
    Blue: DeviceModelId.blue,
    "Nano S": DeviceModelId.nanoS,
    "Nano S Plus": DeviceModelId.nanoSP,
    "Nano X": DeviceModelId.nanoX,
    Stax: DeviceModelId.stax,
    Europa: DeviceModelId.europa
};
const devicesList = Object.values(devices);
const ledgerUSBVendorId = 0x2c97;
const getDeviceModel = (id)=>{
    const info = devices[id];
    if (!info) throw new Error("device '" + id + "' does not exist");
    return info;
};
const identifyTargetId = (targetId)=>{
    const deviceModel = devicesList.find(({ masks })=>masks.find((mask)=>(targetId & 0xffff0000) === mask));
    return deviceModel;
};
const identifyUSBProductId = (usbProductId)=>{
    const legacy = devicesList.find((d)=>d.legacyUsbProductId === usbProductId);
    if (legacy) return legacy;
    const mm = usbProductId >> 8;
    const deviceModel = devicesList.find((d)=>d.productIdMM === mm);
    return deviceModel;
};
const identifyProductName = (productName)=>{
    const deviceModel = devicesList.find((d)=>d.id === productMap[productName]);
    return deviceModel;
};
const bluetoothServices = [];
const serviceUuidToInfos = {};
for(const id in devices){
    const deviceModel = devices[id];
    const { bluetoothSpec } = deviceModel;
    if (bluetoothSpec) for(let i = 0; i < bluetoothSpec.length; i++){
        const spec = bluetoothSpec[i];
        bluetoothServices.push(spec.serviceUuid);
        serviceUuidToInfos[spec.serviceUuid] = serviceUuidToInfos[spec.serviceUuid.replace(/-/g, "")] = Object.assign({
            deviceModel
        }, spec);
    }
}
const getBluetoothServiceUuids = ()=>bluetoothServices;
const getInfosForServiceUuid = (uuid)=>serviceUuidToInfos[uuid.toLowerCase()];

},{"semver":"5PxCY","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5PxCY":[function(require,module,exports,__globalThis) {
// just pre-load all the stuff that index.js lazily exports
const internalRe = require("2ef367e729437dbf");
const constants = require("15796d6f714ec7ac");
const SemVer = require("784948b06600d9b2");
const identifiers = require("70f963db887a798c");
const parse = require("3f445ade66470b21");
const valid = require("f44378b7de87a0b4");
const clean = require("7742c78cf22bae39");
const inc = require("a751dd1df28d6bbb");
const diff = require("e000803318fe9f2f");
const major = require("d290038a9a954b0a");
const minor = require("c5e4bbab325a5aae");
const patch = require("5c0bb8d32de60bb3");
const prerelease = require("323f12e5af5ebd1e");
const compare = require("29cf114a56181e64");
const rcompare = require("827db0815bb2f2cd");
const compareLoose = require("b644f26560ec8124");
const compareBuild = require("606d0e43dd66a24c");
const sort = require("1560ed361cfa42e6");
const rsort = require("f9e1f00918a8cfd7");
const gt = require("3694a9720f15d6ac");
const lt = require("4559dbda8a777185");
const eq = require("14a4b88a0b1fd3a5");
const neq = require("416d9b63c3df2ead");
const gte = require("d39630b19344a843");
const lte = require("3fb74c9a41c1cef6");
const cmp = require("3435ca1bbec7b99");
const coerce = require("d67409238c8fc031");
const Comparator = require("1d07035d00450bca");
const Range = require("b280ab3e26924ac1");
const satisfies = require("ba9d0d2a3e49b569");
const toComparators = require("e6b2802b2233287d");
const maxSatisfying = require("2bfdfb0adcbcb71b");
const minSatisfying = require("264df1ba0d261fad");
const minVersion = require("cd4980125683761f");
const validRange = require("a0319a4a98954087");
const outside = require("fc457e2bda4345b2");
const gtr = require("c885d2b556186a1a");
const ltr = require("58740c779f187b15");
const intersects = require("22421cf146448c92");
const simplifyRange = require("439ddbc649d6486");
const subset = require("f1e57a2c808f532d");
module.exports = {
    parse,
    valid,
    clean,
    inc,
    diff,
    major,
    minor,
    patch,
    prerelease,
    compare,
    rcompare,
    compareLoose,
    compareBuild,
    sort,
    rsort,
    gt,
    lt,
    eq,
    neq,
    gte,
    lte,
    cmp,
    coerce,
    Comparator,
    Range,
    satisfies,
    toComparators,
    maxSatisfying,
    minSatisfying,
    minVersion,
    validRange,
    outside,
    gtr,
    ltr,
    intersects,
    simplifyRange,
    subset,
    SemVer,
    re: internalRe.re,
    src: internalRe.src,
    tokens: internalRe.t,
    SEMVER_SPEC_VERSION: constants.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: constants.RELEASE_TYPES,
    compareIdentifiers: identifiers.compareIdentifiers,
    rcompareIdentifiers: identifiers.rcompareIdentifiers
};

},{"2ef367e729437dbf":"ahY0i","15796d6f714ec7ac":"lfhvd","784948b06600d9b2":"loFEZ","70f963db887a798c":"bgZMp","3f445ade66470b21":"h8VuZ","f44378b7de87a0b4":"6Eh5C","7742c78cf22bae39":"kHwlf","a751dd1df28d6bbb":"4i7oK","e000803318fe9f2f":"37cEm","d290038a9a954b0a":"gd4HA","c5e4bbab325a5aae":"bZCHU","5c0bb8d32de60bb3":"4voJ2","323f12e5af5ebd1e":"1ZA3l","29cf114a56181e64":"fHXFx","827db0815bb2f2cd":"iGUTV","b644f26560ec8124":"3c8Xe","606d0e43dd66a24c":"7zvEB","1560ed361cfa42e6":"id0w0","f9e1f00918a8cfd7":"bH2cw","3694a9720f15d6ac":"i1m4Z","4559dbda8a777185":"03kmD","14a4b88a0b1fd3a5":"kyf4W","416d9b63c3df2ead":"jJjaa","d39630b19344a843":"5i3dk","3fb74c9a41c1cef6":"lLxsa","3435ca1bbec7b99":"kAioK","d67409238c8fc031":"6yyVj","1d07035d00450bca":"5XmUp","b280ab3e26924ac1":"6uOU5","ba9d0d2a3e49b569":"lkmhj","e6b2802b2233287d":"ddkMu","2bfdfb0adcbcb71b":"3c0x2","264df1ba0d261fad":"kAq8q","cd4980125683761f":"hzOfo","a0319a4a98954087":"jl3nN","fc457e2bda4345b2":"k3qRG","c885d2b556186a1a":"1GFfK","58740c779f187b15":"koYUe","22421cf146448c92":"hmSQS","439ddbc649d6486":"XuZrU","f1e57a2c808f532d":"hHqHN"}],"ahY0i":[function(require,module,exports,__globalThis) {
const { MAX_SAFE_COMPONENT_LENGTH, MAX_SAFE_BUILD_LENGTH, MAX_LENGTH } = require("9328c2484f003df4");
const debug = require("9075cfb365332427");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = '[a-zA-Z0-9-]';
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        '\\s',
        1
    ],
    [
        '\\d',
        MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    debug(name, index, value);
    t[name] = index;
    src[index] = value;
    re[index] = new RegExp(value, isGlobal ? 'g' : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? 'g' : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken('NUMERICIDENTIFIER', '0|[1-9]\\d*');
createToken('NUMERICIDENTIFIERLOOSE', '\\d+');
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken('NONNUMERICIDENTIFIER', `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken('MAINVERSION', `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken('MAINVERSIONLOOSE', `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken('PRERELEASEIDENTIFIER', `(?:${src[t.NUMERICIDENTIFIER]}|${src[t.NONNUMERICIDENTIFIER]})`);
createToken('PRERELEASEIDENTIFIERLOOSE', `(?:${src[t.NUMERICIDENTIFIERLOOSE]}|${src[t.NONNUMERICIDENTIFIER]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken('PRERELEASE', `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken('PRERELEASELOOSE', `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken('BUILDIDENTIFIER', `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken('BUILD', `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken('FULLPLAIN', `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken('FULL', `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken('LOOSEPLAIN', `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken('LOOSE', `^${src[t.LOOSEPLAIN]}$`);
createToken('GTLT', '((?:<|>)?=?)');
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken('XRANGEIDENTIFIERLOOSE', `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken('XRANGEIDENTIFIER', `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken('XRANGEPLAIN', `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGEPLAINLOOSE', `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken('XRANGE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken('XRANGELOOSE', `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken('COERCE', `${"(^|[^\\d])(\\d{1,"}${MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:$|[^\\d])`);
createToken('COERCERTL', src[t.COERCE], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken('LONETILDE', '(?:~>?)');
createToken('TILDETRIM', `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = '$1~';
createToken('TILDE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken('TILDELOOSE', `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken('LONECARET', '(?:\\^)');
createToken('CARETTRIM', `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = '$1^';
createToken('CARET', `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken('CARETLOOSE', `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken('COMPARATORLOOSE', `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken('COMPARATOR', `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken('COMPARATORTRIM', `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = '$1$2$3';
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken('HYPHENRANGE', `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken('HYPHENRANGELOOSE', `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken('STAR', '(<|>)?=?\\s*\\*');
// >=0.0.0 is like a star
createToken('GTE0', '^\\s*>=\\s*0\\.0\\.0\\s*$');
createToken('GTE0PRE', '^\\s*>=\\s*0\\.0\\.0-0\\s*$');

},{"9328c2484f003df4":"lfhvd","9075cfb365332427":"1MZgN"}],"lfhvd":[function(require,module,exports,__globalThis) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const SEMVER_SPEC_VERSION = '2.0.0';
const MAX_LENGTH = 256;
const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const MAX_SAFE_BUILD_LENGTH = MAX_LENGTH - 6;
const RELEASE_TYPES = [
    'major',
    'premajor',
    'minor',
    'preminor',
    'patch',
    'prepatch',
    'prerelease'
];
module.exports = {
    MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER,
    RELEASE_TYPES,
    SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

},{}],"1MZgN":[function(require,module,exports,__globalThis) {
const debug = ()=>{};
module.exports = debug;

},{}],"loFEZ":[function(require,module,exports,__globalThis) {
const debug = require("595c172e7d863d06");
const { MAX_LENGTH, MAX_SAFE_INTEGER } = require("bd8d57fbca62978a");
const { safeRe: re, t } = require("2b364a26e67d9817");
const parseOptions = require("f1a723539d6cc9b5");
const { compareIdentifiers } = require("2451a15946a38fcd");
class SemVer {
    constructor(version, options){
        options = parseOptions(options);
        if (version instanceof SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== 'string') throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > MAX_LENGTH) throw new TypeError(`version is longer than ${MAX_LENGTH} characters`);
        debug('SemVer', version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? re[t.LOOSE] : re[t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > MAX_SAFE_INTEGER || this.major < 0) throw new TypeError('Invalid major version');
        if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError('Invalid minor version');
        if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError('Invalid patch version');
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split('.').map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split('.') : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join('.')}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        debug('SemVer.compare', this.version, this.options, other);
        if (!(other instanceof SemVer)) {
            if (typeof other === 'string' && other === this.version) return 0;
            other = new SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
        return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
    }
    comparePre(other) {
        if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            debug('prerelease compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            debug('prerelease compare', i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        switch(release){
            case 'premajor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'preminor':
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc('pre', identifier, identifierBase);
                break;
            case 'prepatch':
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case 'prerelease':
                if (this.prerelease.length === 0) this.inc('patch', identifier, identifierBase);
                this.inc('pre', identifier, identifierBase);
                break;
            case 'major':
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'minor':
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case 'patch':
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case 'pre':
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (!identifier && identifierBase === false) throw new Error('invalid increment argument: identifier is empty');
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === 'number') {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join('.') && identifierBase === false) throw new Error('invalid increment argument: identifier already exists');
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if (compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join('.')}`;
        return this;
    }
}
module.exports = SemVer;

},{"595c172e7d863d06":"1MZgN","bd8d57fbca62978a":"lfhvd","2b364a26e67d9817":"ahY0i","f1a723539d6cc9b5":"1r27j","2451a15946a38fcd":"bgZMp"}],"1r27j":[function(require,module,exports,__globalThis) {
// parse out just the options we care about
const looseOption = Object.freeze({
    loose: true
});
const emptyOpts = Object.freeze({});
const parseOptions = (options)=>{
    if (!options) return emptyOpts;
    if (typeof options !== 'object') return looseOption;
    return options;
};
module.exports = parseOptions;

},{}],"bgZMp":[function(require,module,exports,__globalThis) {
const numeric = /^[0-9]+$/;
const compareIdentifiers = (a, b)=>{
    const anum = numeric.test(a);
    const bnum = numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const rcompareIdentifiers = (a, b)=>compareIdentifiers(b, a);
module.exports = {
    compareIdentifiers,
    rcompareIdentifiers
};

},{}],"h8VuZ":[function(require,module,exports,__globalThis) {
const SemVer = require("575e97778d3944c0");
const parse = (version, options, throwErrors = false)=>{
    if (version instanceof SemVer) return version;
    try {
        return new SemVer(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
module.exports = parse;

},{"575e97778d3944c0":"loFEZ"}],"6Eh5C":[function(require,module,exports,__globalThis) {
const parse = require("6a6e19c11f3ced24");
const valid = (version, options)=>{
    const v = parse(version, options);
    return v ? v.version : null;
};
module.exports = valid;

},{"6a6e19c11f3ced24":"h8VuZ"}],"kHwlf":[function(require,module,exports,__globalThis) {
const parse = require("661ff2c6ff41830b");
const clean = (version, options)=>{
    const s = parse(version.trim().replace(/^[=v]+/, ''), options);
    return s ? s.version : null;
};
module.exports = clean;

},{"661ff2c6ff41830b":"h8VuZ"}],"4i7oK":[function(require,module,exports,__globalThis) {
const SemVer = require("9a4ed023da196604");
const inc = (version, release, options, identifier, identifierBase)=>{
    if (typeof options === 'string') {
        identifierBase = identifier;
        identifier = options;
        options = undefined;
    }
    try {
        return new SemVer(version instanceof SemVer ? version.version : version, options).inc(release, identifier, identifierBase).version;
    } catch (er) {
        return null;
    }
};
module.exports = inc;

},{"9a4ed023da196604":"loFEZ"}],"37cEm":[function(require,module,exports,__globalThis) {
const parse = require("3b6d0e3ec696b30a");
const diff = (version1, version2)=>{
    const v1 = parse(version1, null, true);
    const v2 = parse(version2, null, true);
    const comparison = v1.compare(v2);
    if (comparison === 0) return null;
    const v1Higher = comparison > 0;
    const highVersion = v1Higher ? v1 : v2;
    const lowVersion = v1Higher ? v2 : v1;
    const highHasPre = !!highVersion.prerelease.length;
    const lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
        // Going from prerelease -> no prerelease requires some special casing
        // If the low version has only a major, then it will always be a major
        // Some examples:
        // 1.0.0-1 -> 1.0.0
        // 1.0.0-1 -> 1.1.1
        // 1.0.0-1 -> 2.0.0
        if (!lowVersion.patch && !lowVersion.minor) return 'major';
        // Otherwise it can be determined by checking the high version
        if (highVersion.patch) // anything higher than a patch bump would result in the wrong version
        return 'patch';
        if (highVersion.minor) // anything higher than a minor bump would result in the wrong version
        return 'minor';
        // bumping major/minor/patch all have same result
        return 'major';
    }
    // add the `pre` prefix if we are going to a prerelease version
    const prefix = highHasPre ? 'pre' : '';
    if (v1.major !== v2.major) return prefix + 'major';
    if (v1.minor !== v2.minor) return prefix + 'minor';
    if (v1.patch !== v2.patch) return prefix + 'patch';
    // high and low are preleases
    return 'prerelease';
};
module.exports = diff;

},{"3b6d0e3ec696b30a":"h8VuZ"}],"gd4HA":[function(require,module,exports,__globalThis) {
const SemVer = require("53a097ab5c27a647");
const major = (a, loose)=>new SemVer(a, loose).major;
module.exports = major;

},{"53a097ab5c27a647":"loFEZ"}],"bZCHU":[function(require,module,exports,__globalThis) {
const SemVer = require("f130a90acb01ac10");
const minor = (a, loose)=>new SemVer(a, loose).minor;
module.exports = minor;

},{"f130a90acb01ac10":"loFEZ"}],"4voJ2":[function(require,module,exports,__globalThis) {
const SemVer = require("54b9ac3bbdf83b31");
const patch = (a, loose)=>new SemVer(a, loose).patch;
module.exports = patch;

},{"54b9ac3bbdf83b31":"loFEZ"}],"1ZA3l":[function(require,module,exports,__globalThis) {
const parse = require("ff5ab55da1933db3");
const prerelease = (version, options)=>{
    const parsed = parse(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
module.exports = prerelease;

},{"ff5ab55da1933db3":"h8VuZ"}],"fHXFx":[function(require,module,exports,__globalThis) {
const SemVer = require("f16c9f4397244ee0");
const compare = (a, b, loose)=>new SemVer(a, loose).compare(new SemVer(b, loose));
module.exports = compare;

},{"f16c9f4397244ee0":"loFEZ"}],"iGUTV":[function(require,module,exports,__globalThis) {
const compare = require("4bfcc14a9711a47b");
const rcompare = (a, b, loose)=>compare(b, a, loose);
module.exports = rcompare;

},{"4bfcc14a9711a47b":"fHXFx"}],"3c8Xe":[function(require,module,exports,__globalThis) {
const compare = require("95c8404dc369c13b");
const compareLoose = (a, b)=>compare(a, b, true);
module.exports = compareLoose;

},{"95c8404dc369c13b":"fHXFx"}],"7zvEB":[function(require,module,exports,__globalThis) {
const SemVer = require("3659675d95d38f3");
const compareBuild = (a, b, loose)=>{
    const versionA = new SemVer(a, loose);
    const versionB = new SemVer(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
module.exports = compareBuild;

},{"3659675d95d38f3":"loFEZ"}],"id0w0":[function(require,module,exports,__globalThis) {
const compareBuild = require("7c22e552e691e157");
const sort = (list, loose)=>list.sort((a, b)=>compareBuild(a, b, loose));
module.exports = sort;

},{"7c22e552e691e157":"7zvEB"}],"bH2cw":[function(require,module,exports,__globalThis) {
const compareBuild = require("468f4992c854a69a");
const rsort = (list, loose)=>list.sort((a, b)=>compareBuild(b, a, loose));
module.exports = rsort;

},{"468f4992c854a69a":"7zvEB"}],"i1m4Z":[function(require,module,exports,__globalThis) {
const compare = require("85515ef2889f4f89");
const gt = (a, b, loose)=>compare(a, b, loose) > 0;
module.exports = gt;

},{"85515ef2889f4f89":"fHXFx"}],"03kmD":[function(require,module,exports,__globalThis) {
const compare = require("9d2d7734c37f90e6");
const lt = (a, b, loose)=>compare(a, b, loose) < 0;
module.exports = lt;

},{"9d2d7734c37f90e6":"fHXFx"}],"kyf4W":[function(require,module,exports,__globalThis) {
const compare = require("d6abf8ed12ec38c1");
const eq = (a, b, loose)=>compare(a, b, loose) === 0;
module.exports = eq;

},{"d6abf8ed12ec38c1":"fHXFx"}],"jJjaa":[function(require,module,exports,__globalThis) {
const compare = require("5232df27c4c4faa9");
const neq = (a, b, loose)=>compare(a, b, loose) !== 0;
module.exports = neq;

},{"5232df27c4c4faa9":"fHXFx"}],"5i3dk":[function(require,module,exports,__globalThis) {
const compare = require("9183f7fbecba58ae");
const gte = (a, b, loose)=>compare(a, b, loose) >= 0;
module.exports = gte;

},{"9183f7fbecba58ae":"fHXFx"}],"lLxsa":[function(require,module,exports,__globalThis) {
const compare = require("e55eadc974580af5");
const lte = (a, b, loose)=>compare(a, b, loose) <= 0;
module.exports = lte;

},{"e55eadc974580af5":"fHXFx"}],"kAioK":[function(require,module,exports,__globalThis) {
const eq = require("bff7f16298b8dbaa");
const neq = require("6a1bb69c2d499261");
const gt = require("dca4b9c05150a919");
const gte = require("7b5dc70556970d6c");
const lt = require("a3a3bcc6e4d6bbdf");
const lte = require("5f1835ee4d0596f3");
const cmp = (a, op, b, loose)=>{
    switch(op){
        case '===':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a === b;
        case '!==':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a !== b;
        case '':
        case '=':
        case '==':
            return eq(a, b, loose);
        case '!=':
            return neq(a, b, loose);
        case '>':
            return gt(a, b, loose);
        case '>=':
            return gte(a, b, loose);
        case '<':
            return lt(a, b, loose);
        case '<=':
            return lte(a, b, loose);
        default:
            throw new TypeError(`Invalid operator: ${op}`);
    }
};
module.exports = cmp;

},{"bff7f16298b8dbaa":"kyf4W","6a1bb69c2d499261":"jJjaa","dca4b9c05150a919":"i1m4Z","7b5dc70556970d6c":"5i3dk","a3a3bcc6e4d6bbdf":"03kmD","5f1835ee4d0596f3":"lLxsa"}],"6yyVj":[function(require,module,exports,__globalThis) {
const SemVer = require("25529d97ade3ccdf");
const parse = require("90724e3140f56906");
const { safeRe: re, t } = require("49971e907f1359e9");
const coerce = (version, options)=>{
    if (version instanceof SemVer) return version;
    if (typeof version === 'number') version = String(version);
    if (typeof version !== 'string') return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match(re[t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        let next;
        while((next = re[t.COERCERTL].exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            re[t.COERCERTL].lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        re[t.COERCERTL].lastIndex = -1;
    }
    if (match === null) return null;
    return parse(`${match[2]}.${match[3] || '0'}.${match[4] || '0'}`, options);
};
module.exports = coerce;

},{"25529d97ade3ccdf":"loFEZ","90724e3140f56906":"h8VuZ","49971e907f1359e9":"ahY0i"}],"5XmUp":[function(require,module,exports,__globalThis) {
const ANY = Symbol('SemVer ANY');
// hoisted class for cyclic dependency
class Comparator {
    static get ANY() {
        return ANY;
    }
    constructor(comp, options){
        options = parseOptions(options);
        if (comp instanceof Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        comp = comp.trim().split(/\s+/).join(' ');
        debug('comparator', comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === ANY) this.value = '';
        else this.value = this.operator + this.semver.version;
        debug('comp', this);
    }
    parse(comp) {
        const r = this.options.loose ? re[t.COMPARATORLOOSE] : re[t.COMPARATOR];
        const m = comp.match(r);
        if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
        this.operator = m[1] !== undefined ? m[1] : '';
        if (this.operator === '=') this.operator = '';
        // if it literally is just '>' or '' then allow anything.
        if (!m[2]) this.semver = ANY;
        else this.semver = new SemVer(m[2], this.options.loose);
    }
    toString() {
        return this.value;
    }
    test(version) {
        debug('Comparator.test', version, this.options.loose);
        if (this.semver === ANY || version === ANY) return true;
        if (typeof version === 'string') try {
            version = new SemVer(version, this.options);
        } catch (er) {
            return false;
        }
        return cmp(version, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
        if (!(comp instanceof Comparator)) throw new TypeError('a Comparator is required');
        if (this.operator === '') {
            if (this.value === '') return true;
            return new Range(comp.value, options).test(this.value);
        } else if (comp.operator === '') {
            if (comp.value === '') return true;
            return new Range(this.value, options).test(comp.semver);
        }
        options = parseOptions(options);
        // Special cases where nothing can possibly be lower
        if (options.includePrerelease && (this.value === '<0.0.0-0' || comp.value === '<0.0.0-0')) return false;
        if (!options.includePrerelease && (this.value.startsWith('<0.0.0') || comp.value.startsWith('<0.0.0'))) return false;
        // Same direction increasing (> or >=)
        if (this.operator.startsWith('>') && comp.operator.startsWith('>')) return true;
        // Same direction decreasing (< or <=)
        if (this.operator.startsWith('<') && comp.operator.startsWith('<')) return true;
        // same SemVer and both sides are inclusive (<= or >=)
        if (this.semver.version === comp.semver.version && this.operator.includes('=') && comp.operator.includes('=')) return true;
        // opposite directions less than
        if (cmp(this.semver, '<', comp.semver, options) && this.operator.startsWith('>') && comp.operator.startsWith('<')) return true;
        // opposite directions greater than
        if (cmp(this.semver, '>', comp.semver, options) && this.operator.startsWith('<') && comp.operator.startsWith('>')) return true;
        return false;
    }
}
module.exports = Comparator;
const parseOptions = require("b6563e9809bd921f");
const { safeRe: re, t } = require("f844ee6695e23038");
const cmp = require("e62b495d112b67cb");
const debug = require("13b490d953a8241f");
const SemVer = require("f688b7fbae163ad8");
const Range = require("b8839ba12a91a5c9");

},{"b6563e9809bd921f":"1r27j","f844ee6695e23038":"ahY0i","e62b495d112b67cb":"kAioK","13b490d953a8241f":"1MZgN","f688b7fbae163ad8":"loFEZ","b8839ba12a91a5c9":"6uOU5"}],"6uOU5":[function(require,module,exports,__globalThis) {
// hoisted class for cyclic dependency
class Range {
    constructor(range, options){
        options = parseOptions(options);
        if (range instanceof Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new Range(range.raw, options);
        }
        if (range instanceof Comparator) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.format();
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First reduce all whitespace as much as possible so we do not have to rely
        // on potentially slow regexes like \s*. This is then stored and used for
        // future error messages as well.
        this.raw = range.trim().split(/\s+/).join(' ');
        // First, split on ||
        this.set = this.raw.split('||')// map the range to a 2d array of comparators
        .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter((c)=>c.length);
        if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            const first = this.set[0];
            this.set = this.set.filter((c)=>!isNullSet(c[0]));
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                // if we have any that are *, then the range is just *
                for (const c of this.set)if (c.length === 1 && isAny(c[0])) {
                    this.set = [
                        c
                    ];
                    break;
                }
            }
        }
        this.format();
    }
    format() {
        this.range = this.set.map((comps)=>comps.join(' ').trim()).join('||').trim();
        return this.range;
    }
    toString() {
        return this.range;
    }
    parseRange(range) {
        // memoize range parsing for performance.
        // this is a very hot path, and fully deterministic.
        const memoOpts = (this.options.includePrerelease && FLAG_INCLUDE_PRERELEASE) | (this.options.loose && FLAG_LOOSE);
        const memoKey = memoOpts + ':' + range;
        const cached = cache.get(memoKey);
        if (cached) return cached;
        const loose = this.options.loose;
        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
        const hr = loose ? re[t.HYPHENRANGELOOSE] : re[t.HYPHENRANGE];
        range = range.replace(hr, hyphenReplace(this.options.includePrerelease));
        debug('hyphen replace', range);
        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
        range = range.replace(re[t.COMPARATORTRIM], comparatorTrimReplace);
        debug('comparator trim', range);
        // `~ 1.2.3` => `~1.2.3`
        range = range.replace(re[t.TILDETRIM], tildeTrimReplace);
        debug('tilde trim', range);
        // `^ 1.2.3` => `^1.2.3`
        range = range.replace(re[t.CARETTRIM], caretTrimReplace);
        debug('caret trim', range);
        // At this point, the range is completely trimmed and
        // ready to be split into comparators.
        let rangeList = range.split(' ').map((comp)=>parseComparator(comp, this.options)).join(' ').split(/\s+/)// >=0.0.0 is equivalent to *
        .map((comp)=>replaceGTE0(comp, this.options));
        if (loose) // in loose mode, throw out any that are not valid comparators
        rangeList = rangeList.filter((comp)=>{
            debug('loose invalid filter', comp, this.options);
            return !!comp.match(re[t.COMPARATORLOOSE]);
        });
        debug('range list', rangeList);
        // if any comparators are the null set, then replace with JUST null set
        // if more than one comparator, remove any * comparators
        // also, don't include the same comparator more than once
        const rangeMap = new Map();
        const comparators = rangeList.map((comp)=>new Comparator(comp, this.options));
        for (const comp of comparators){
            if (isNullSet(comp)) return [
                comp
            ];
            rangeMap.set(comp.value, comp);
        }
        if (rangeMap.size > 1 && rangeMap.has('')) rangeMap.delete('');
        const result = [
            ...rangeMap.values()
        ];
        cache.set(memoKey, result);
        return result;
    }
    intersects(range, options) {
        if (!(range instanceof Range)) throw new TypeError('a Range is required');
        return this.set.some((thisComparators)=>{
            return isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                return isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                    return rangeComparators.every((rangeComparator)=>{
                        return thisComparator.intersects(rangeComparator, options);
                    });
                });
            });
        });
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version) {
        if (!version) return false;
        if (typeof version === 'string') try {
            version = new SemVer(version, this.options);
        } catch (er) {
            return false;
        }
        for(let i = 0; i < this.set.length; i++){
            if (testSet(this.set[i], version, this.options)) return true;
        }
        return false;
    }
}
module.exports = Range;
const LRU = require("f98d093917001b0e");
const cache = new LRU({
    max: 1000
});
const parseOptions = require("17bb122b9b0740d9");
const Comparator = require("df9131adcc191f91");
const debug = require("1c7c6c8abfe9bd3b");
const SemVer = require("d77fd978650b507f");
const { safeRe: re, t, comparatorTrimReplace, tildeTrimReplace, caretTrimReplace } = require("9bd5ca5276add1c4");
const { FLAG_INCLUDE_PRERELEASE, FLAG_LOOSE } = require("8c8074dc7fc46964");
const isNullSet = (c)=>c.value === '<0.0.0-0';
const isAny = (c)=>c.value === '';
// take a set of comparators and determine whether there
// exists a version which can satisfy it
const isSatisfiable = (comparators, options)=>{
    let result = true;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every((otherComparator)=>{
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
const parseComparator = (comp, options)=>{
    debug('comp', comp, options);
    comp = replaceCarets(comp, options);
    debug('caret', comp);
    comp = replaceTildes(comp, options);
    debug('tildes', comp);
    comp = replaceXRanges(comp, options);
    debug('xrange', comp);
    comp = replaceStars(comp, options);
    debug('stars', comp);
    return comp;
};
const isX = (id)=>!id || id.toLowerCase() === 'x' || id === '*';
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
const replaceTildes = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>replaceTilde(c, options)).join(' ');
};
const replaceTilde = (comp, options)=>{
    const r = options.loose ? re[t.TILDELOOSE] : re[t.TILDE];
    return comp.replace(r, (_, M, m, p, pr)=>{
        debug('tilde', comp, _, M, m, p, pr);
        let ret;
        if (isX(M)) ret = '';
        else if (isX(m)) ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
        else if (isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
        else if (pr) {
            debug('replaceTilde pr', pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
        debug('tilde return', ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
const replaceCarets = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>replaceCaret(c, options)).join(' ');
};
const replaceCaret = (comp, options)=>{
    debug('caret', comp, options);
    const r = options.loose ? re[t.CARETLOOSE] : re[t.CARET];
    const z = options.includePrerelease ? '-0' : '';
    return comp.replace(r, (_, M, m, p, pr)=>{
        debug('caret', comp, _, M, m, p, pr);
        let ret;
        if (isX(M)) ret = '';
        else if (isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if (isX(p)) {
            if (M === '0') ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
        } else if (pr) {
            debug('replaceCaret pr', pr);
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
        } else {
            debug('no pr');
            if (M === '0') {
                if (m === '0') ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
        }
        debug('caret return', ret);
        return ret;
    });
};
const replaceXRanges = (comp, options)=>{
    debug('replaceXRanges', comp, options);
    return comp.split(/\s+/).map((c)=>replaceXRange(c, options)).join(' ');
};
const replaceXRange = (comp, options)=>{
    comp = comp.trim();
    const r = options.loose ? re[t.XRANGELOOSE] : re[t.XRANGE];
    return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
        debug('xRange', comp, ret, gtlt, M, m, p, pr);
        const xM = isX(M);
        const xm = xM || isX(m);
        const xp = xm || isX(p);
        const anyX = xp;
        if (gtlt === '=' && anyX) gtlt = '';
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? '-0' : '';
        if (xM) {
            if (gtlt === '>' || gtlt === '<') // nothing is allowed
            ret = '<0.0.0-0';
            else // nothing is forbidden
            ret = '*';
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === '>') {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = '>=';
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === '<=') {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = '<';
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === '<') pr = '-0';
            ret = `${gtlt + M}.${m}.${p}${pr}`;
        } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
        else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
        debug('xRange return', ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
const replaceStars = (comp, options)=>{
    debug('replaceStars', comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace(re[t.STAR], '');
};
const replaceGTE0 = (comp, options)=>{
    debug('replaceGTE0', comp, options);
    return comp.trim().replace(re[options.includePrerelease ? t.GTE0PRE : t.GTE0], '');
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
const hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb)=>{
        if (isX(fM)) from = '';
        else if (isX(fm)) from = `>=${fM}.0.0${incPr ? '-0' : ''}`;
        else if (isX(fp)) from = `>=${fM}.${fm}.0${incPr ? '-0' : ''}`;
        else if (fpr) from = `>=${from}`;
        else from = `>=${from}${incPr ? '-0' : ''}`;
        if (isX(tM)) to = '';
        else if (isX(tm)) to = `<${+tM + 1}.0.0-0`;
        else if (isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
        else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
        else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
        else to = `<=${to}`;
        return `${from} ${to}`.trim();
    };
const testSet = (set, version, options)=>{
    for(let i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(let i = 0; i < set.length; i++){
            debug(set[i].semver);
            if (set[i].semver === Comparator.ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                const allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};

},{"f98d093917001b0e":"aq2c3","17bb122b9b0740d9":"1r27j","df9131adcc191f91":"5XmUp","1c7c6c8abfe9bd3b":"1MZgN","d77fd978650b507f":"loFEZ","9bd5ca5276add1c4":"ahY0i","8c8074dc7fc46964":"lfhvd"}],"aq2c3":[function(require,module,exports,__globalThis) {
'use strict';
// A linked list to keep track of recently-used-ness
const Yallist = require("f6aab322aadb8044");
const MAX = Symbol('max');
const LENGTH = Symbol('length');
const LENGTH_CALCULATOR = Symbol('lengthCalculator');
const ALLOW_STALE = Symbol('allowStale');
const MAX_AGE = Symbol('maxAge');
const DISPOSE = Symbol('dispose');
const NO_DISPOSE_ON_SET = Symbol('noDisposeOnSet');
const LRU_LIST = Symbol('lruList');
const CACHE = Symbol('cache');
const UPDATE_AGE_ON_GET = Symbol('updateAgeOnGet');
const naiveLength = ()=>1;
// lruList is a yallist where the head is the youngest
// item, and the tail is the oldest.  the list contains the Hit
// objects as the entries.
// Each Hit object has a reference to its Yallist.Node.  This
// never changes.
//
// cache is a Map (or PseudoMap) that matches the keys to
// the Yallist.Node object.
class LRUCache {
    constructor(options){
        if (typeof options === 'number') options = {
            max: options
        };
        if (!options) options = {};
        if (options.max && (typeof options.max !== 'number' || options.max < 0)) throw new TypeError('max must be a non-negative number');
        // Kind of weird to have a default max of Infinity, but oh well.
        const max = this[MAX] = options.max || Infinity;
        const lc = options.length || naiveLength;
        this[LENGTH_CALCULATOR] = typeof lc !== 'function' ? naiveLength : lc;
        this[ALLOW_STALE] = options.stale || false;
        if (options.maxAge && typeof options.maxAge !== 'number') throw new TypeError('maxAge must be a number');
        this[MAX_AGE] = options.maxAge || 0;
        this[DISPOSE] = options.dispose;
        this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
        this[UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
        this.reset();
    }
    // resize the cache when the max changes.
    set max(mL) {
        if (typeof mL !== 'number' || mL < 0) throw new TypeError('max must be a non-negative number');
        this[MAX] = mL || Infinity;
        trim(this);
    }
    get max() {
        return this[MAX];
    }
    set allowStale(allowStale) {
        this[ALLOW_STALE] = !!allowStale;
    }
    get allowStale() {
        return this[ALLOW_STALE];
    }
    set maxAge(mA) {
        if (typeof mA !== 'number') throw new TypeError('maxAge must be a non-negative number');
        this[MAX_AGE] = mA;
        trim(this);
    }
    get maxAge() {
        return this[MAX_AGE];
    }
    // resize the cache when the lengthCalculator changes.
    set lengthCalculator(lC) {
        if (typeof lC !== 'function') lC = naiveLength;
        if (lC !== this[LENGTH_CALCULATOR]) {
            this[LENGTH_CALCULATOR] = lC;
            this[LENGTH] = 0;
            this[LRU_LIST].forEach((hit)=>{
                hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key);
                this[LENGTH] += hit.length;
            });
        }
        trim(this);
    }
    get lengthCalculator() {
        return this[LENGTH_CALCULATOR];
    }
    get length() {
        return this[LENGTH];
    }
    get itemCount() {
        return this[LRU_LIST].length;
    }
    rforEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[LRU_LIST].tail; walker !== null;){
            const prev = walker.prev;
            forEachStep(this, fn, walker, thisp);
            walker = prev;
        }
    }
    forEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[LRU_LIST].head; walker !== null;){
            const next = walker.next;
            forEachStep(this, fn, walker, thisp);
            walker = next;
        }
    }
    keys() {
        return this[LRU_LIST].toArray().map((k)=>k.key);
    }
    values() {
        return this[LRU_LIST].toArray().map((k)=>k.value);
    }
    reset() {
        if (this[DISPOSE] && this[LRU_LIST] && this[LRU_LIST].length) this[LRU_LIST].forEach((hit)=>this[DISPOSE](hit.key, hit.value));
        this[CACHE] = new Map() // hash of items by key
        ;
        this[LRU_LIST] = new Yallist() // list of items in order of use recency
        ;
        this[LENGTH] = 0 // length of items in the list
        ;
    }
    dump() {
        return this[LRU_LIST].map((hit)=>isStale(this, hit) ? false : {
                k: hit.key,
                v: hit.value,
                e: hit.now + (hit.maxAge || 0)
            }).toArray().filter((h)=>h);
    }
    dumpLru() {
        return this[LRU_LIST];
    }
    set(key, value, maxAge) {
        maxAge = maxAge || this[MAX_AGE];
        if (maxAge && typeof maxAge !== 'number') throw new TypeError('maxAge must be a number');
        const now = maxAge ? Date.now() : 0;
        const len = this[LENGTH_CALCULATOR](value, key);
        if (this[CACHE].has(key)) {
            if (len > this[MAX]) {
                del(this, this[CACHE].get(key));
                return false;
            }
            const node = this[CACHE].get(key);
            const item = node.value;
            // dispose of the old one before overwriting
            // split out into 2 ifs for better coverage tracking
            if (this[DISPOSE]) {
                if (!this[NO_DISPOSE_ON_SET]) this[DISPOSE](key, item.value);
            }
            item.now = now;
            item.maxAge = maxAge;
            item.value = value;
            this[LENGTH] += len - item.length;
            item.length = len;
            this.get(key);
            trim(this);
            return true;
        }
        const hit = new Entry(key, value, len, now, maxAge);
        // oversized objects fall out of cache automatically.
        if (hit.length > this[MAX]) {
            if (this[DISPOSE]) this[DISPOSE](key, value);
            return false;
        }
        this[LENGTH] += hit.length;
        this[LRU_LIST].unshift(hit);
        this[CACHE].set(key, this[LRU_LIST].head);
        trim(this);
        return true;
    }
    has(key) {
        if (!this[CACHE].has(key)) return false;
        const hit = this[CACHE].get(key).value;
        return !isStale(this, hit);
    }
    get(key) {
        return get(this, key, true);
    }
    peek(key) {
        return get(this, key, false);
    }
    pop() {
        const node = this[LRU_LIST].tail;
        if (!node) return null;
        del(this, node);
        return node.value;
    }
    del(key) {
        del(this, this[CACHE].get(key));
    }
    load(arr) {
        // reset the cache
        this.reset();
        const now = Date.now();
        // A previous serialized cache has the most recent items first
        for(let l = arr.length - 1; l >= 0; l--){
            const hit = arr[l];
            const expiresAt = hit.e || 0;
            if (expiresAt === 0) // the item was created without expiration in a non aged cache
            this.set(hit.k, hit.v);
            else {
                const maxAge = expiresAt - now;
                // dont add already expired items
                if (maxAge > 0) this.set(hit.k, hit.v, maxAge);
            }
        }
    }
    prune() {
        this[CACHE].forEach((value, key)=>get(this, key, false));
    }
}
const get = (self, key, doUse)=>{
    const node = self[CACHE].get(key);
    if (node) {
        const hit = node.value;
        if (isStale(self, hit)) {
            del(self, node);
            if (!self[ALLOW_STALE]) return undefined;
        } else if (doUse) {
            if (self[UPDATE_AGE_ON_GET]) node.value.now = Date.now();
            self[LRU_LIST].unshiftNode(node);
        }
        return hit.value;
    }
};
const isStale = (self, hit)=>{
    if (!hit || !hit.maxAge && !self[MAX_AGE]) return false;
    const diff = Date.now() - hit.now;
    return hit.maxAge ? diff > hit.maxAge : self[MAX_AGE] && diff > self[MAX_AGE];
};
const trim = (self)=>{
    if (self[LENGTH] > self[MAX]) for(let walker = self[LRU_LIST].tail; self[LENGTH] > self[MAX] && walker !== null;){
        // We know that we're about to delete this one, and also
        // what the next least recently used key will be, so just
        // go ahead and set it now.
        const prev = walker.prev;
        del(self, walker);
        walker = prev;
    }
};
const del = (self, node)=>{
    if (node) {
        const hit = node.value;
        if (self[DISPOSE]) self[DISPOSE](hit.key, hit.value);
        self[LENGTH] -= hit.length;
        self[CACHE].delete(hit.key);
        self[LRU_LIST].removeNode(node);
    }
};
class Entry {
    constructor(key, value, length, now, maxAge){
        this.key = key;
        this.value = value;
        this.length = length;
        this.now = now;
        this.maxAge = maxAge || 0;
    }
}
const forEachStep = (self, fn, node, thisp)=>{
    let hit = node.value;
    if (isStale(self, hit)) {
        del(self, node);
        if (!self[ALLOW_STALE]) hit = undefined;
    }
    if (hit) fn.call(thisp, hit.value, hit.key, self);
};
module.exports = LRUCache;

},{"f6aab322aadb8044":"jxzL3"}],"jxzL3":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = Yallist;
Yallist.Node = Node;
Yallist.create = Yallist;
function Yallist(list) {
    var self = this;
    if (!(self instanceof Yallist)) self = new Yallist();
    self.tail = null;
    self.head = null;
    self.length = 0;
    if (list && typeof list.forEach === 'function') list.forEach(function(item) {
        self.push(item);
    });
    else if (arguments.length > 0) for(var i = 0, l = arguments.length; i < l; i++)self.push(arguments[i]);
    return self;
}
Yallist.prototype.removeNode = function(node) {
    if (node.list !== this) throw new Error('removing node which does not belong to this list');
    var next = node.next;
    var prev = node.prev;
    if (next) next.prev = prev;
    if (prev) prev.next = next;
    if (node === this.head) this.head = next;
    if (node === this.tail) this.tail = prev;
    node.list.length--;
    node.next = null;
    node.prev = null;
    node.list = null;
    return next;
};
Yallist.prototype.unshiftNode = function(node) {
    if (node === this.head) return;
    if (node.list) node.list.removeNode(node);
    var head = this.head;
    node.list = this;
    node.next = head;
    if (head) head.prev = node;
    this.head = node;
    if (!this.tail) this.tail = node;
    this.length++;
};
Yallist.prototype.pushNode = function(node) {
    if (node === this.tail) return;
    if (node.list) node.list.removeNode(node);
    var tail = this.tail;
    node.list = this;
    node.prev = tail;
    if (tail) tail.next = node;
    this.tail = node;
    if (!this.head) this.head = node;
    this.length++;
};
Yallist.prototype.push = function() {
    for(var i = 0, l = arguments.length; i < l; i++)push(this, arguments[i]);
    return this.length;
};
Yallist.prototype.unshift = function() {
    for(var i = 0, l = arguments.length; i < l; i++)unshift(this, arguments[i]);
    return this.length;
};
Yallist.prototype.pop = function() {
    if (!this.tail) return undefined;
    var res = this.tail.value;
    this.tail = this.tail.prev;
    if (this.tail) this.tail.next = null;
    else this.head = null;
    this.length--;
    return res;
};
Yallist.prototype.shift = function() {
    if (!this.head) return undefined;
    var res = this.head.value;
    this.head = this.head.next;
    if (this.head) this.head.prev = null;
    else this.tail = null;
    this.length--;
    return res;
};
Yallist.prototype.forEach = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.head, i = 0; walker !== null; i++){
        fn.call(thisp, walker.value, i, this);
        walker = walker.next;
    }
};
Yallist.prototype.forEachReverse = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.tail, i = this.length - 1; walker !== null; i--){
        fn.call(thisp, walker.value, i, this);
        walker = walker.prev;
    }
};
Yallist.prototype.get = function(n) {
    for(var i = 0, walker = this.head; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.next;
    if (i === n && walker !== null) return walker.value;
};
Yallist.prototype.getReverse = function(n) {
    for(var i = 0, walker = this.tail; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.prev;
    if (i === n && walker !== null) return walker.value;
};
Yallist.prototype.map = function(fn, thisp) {
    thisp = thisp || this;
    var res = new Yallist();
    for(var walker = this.head; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.next;
    }
    return res;
};
Yallist.prototype.mapReverse = function(fn, thisp) {
    thisp = thisp || this;
    var res = new Yallist();
    for(var walker = this.tail; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.prev;
    }
    return res;
};
Yallist.prototype.reduce = function(fn, initial) {
    var acc;
    var walker = this.head;
    if (arguments.length > 1) acc = initial;
    else if (this.head) {
        walker = this.head.next;
        acc = this.head.value;
    } else throw new TypeError('Reduce of empty list with no initial value');
    for(var i = 0; walker !== null; i++){
        acc = fn(acc, walker.value, i);
        walker = walker.next;
    }
    return acc;
};
Yallist.prototype.reduceReverse = function(fn, initial) {
    var acc;
    var walker = this.tail;
    if (arguments.length > 1) acc = initial;
    else if (this.tail) {
        walker = this.tail.prev;
        acc = this.tail.value;
    } else throw new TypeError('Reduce of empty list with no initial value');
    for(var i = this.length - 1; walker !== null; i--){
        acc = fn(acc, walker.value, i);
        walker = walker.prev;
    }
    return acc;
};
Yallist.prototype.toArray = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.head; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.next;
    }
    return arr;
};
Yallist.prototype.toArrayReverse = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.tail; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.prev;
    }
    return arr;
};
Yallist.prototype.slice = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = 0, walker = this.head; walker !== null && i < from; i++)walker = walker.next;
    for(; walker !== null && i < to; i++, walker = walker.next)ret.push(walker.value);
    return ret;
};
Yallist.prototype.sliceReverse = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = this.length, walker = this.tail; walker !== null && i > to; i--)walker = walker.prev;
    for(; walker !== null && i > from; i--, walker = walker.prev)ret.push(walker.value);
    return ret;
};
Yallist.prototype.splice = function(start, deleteCount, ...nodes) {
    if (start > this.length) start = this.length - 1;
    if (start < 0) start = this.length + start;
    for(var i = 0, walker = this.head; walker !== null && i < start; i++)walker = walker.next;
    var ret = [];
    for(var i = 0; walker && i < deleteCount; i++){
        ret.push(walker.value);
        walker = this.removeNode(walker);
    }
    if (walker === null) walker = this.tail;
    if (walker !== this.head && walker !== this.tail) walker = walker.prev;
    for(var i = 0; i < nodes.length; i++)walker = insert(this, walker, nodes[i]);
    return ret;
};
Yallist.prototype.reverse = function() {
    var head = this.head;
    var tail = this.tail;
    for(var walker = head; walker !== null; walker = walker.prev){
        var p = walker.prev;
        walker.prev = walker.next;
        walker.next = p;
    }
    this.head = tail;
    this.tail = head;
    return this;
};
function insert(self, node, value) {
    var inserted = node === self.head ? new Node(value, null, node, self) : new Node(value, node, node.next, self);
    if (inserted.next === null) self.tail = inserted;
    if (inserted.prev === null) self.head = inserted;
    self.length++;
    return inserted;
}
function push(self, item) {
    self.tail = new Node(item, self.tail, null, self);
    if (!self.head) self.head = self.tail;
    self.length++;
}
function unshift(self, item) {
    self.head = new Node(item, null, self.head, self);
    if (!self.tail) self.tail = self.head;
    self.length++;
}
function Node(value, prev, next, list) {
    if (!(this instanceof Node)) return new Node(value, prev, next, list);
    this.list = list;
    this.value = value;
    if (prev) {
        prev.next = this;
        this.prev = prev;
    } else this.prev = null;
    if (next) {
        next.prev = this;
        this.next = next;
    } else this.next = null;
}
try {
    // add if support for Symbol.iterator is present
    require("d680a8272731d358")(Yallist);
} catch (er) {}

},{"d680a8272731d358":"eVhr1"}],"eVhr1":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = function(Yallist) {
    Yallist.prototype[Symbol.iterator] = function*() {
        for(let walker = this.head; walker; walker = walker.next)yield walker.value;
    };
};

},{}],"lkmhj":[function(require,module,exports,__globalThis) {
const Range = require("b60a47303a13d107");
const satisfies = (version, range, options)=>{
    try {
        range = new Range(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
module.exports = satisfies;

},{"b60a47303a13d107":"6uOU5"}],"ddkMu":[function(require,module,exports,__globalThis) {
const Range = require("f497be9904aac7c0");
// Mostly just for testing and legacy API reasons
const toComparators = (range, options)=>new Range(range, options).set.map((comp)=>comp.map((c)=>c.value).join(' ').trim().split(' '));
module.exports = toComparators;

},{"f497be9904aac7c0":"6uOU5"}],"3c0x2":[function(require,module,exports,__globalThis) {
const SemVer = require("96d622a81d57358d");
const Range = require("f2865e94142488ab");
const maxSatisfying = (versions, range, options)=>{
    let max = null;
    let maxSV = null;
    let rangeObj = null;
    try {
        rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new SemVer(max, options);
            }
        }
    });
    return max;
};
module.exports = maxSatisfying;

},{"96d622a81d57358d":"loFEZ","f2865e94142488ab":"6uOU5"}],"kAq8q":[function(require,module,exports,__globalThis) {
const SemVer = require("fea3851ba09d8834");
const Range = require("9d2799b098b5c4c7");
const minSatisfying = (versions, range, options)=>{
    let min = null;
    let minSV = null;
    let rangeObj = null;
    try {
        rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new SemVer(min, options);
            }
        }
    });
    return min;
};
module.exports = minSatisfying;

},{"fea3851ba09d8834":"loFEZ","9d2799b098b5c4c7":"6uOU5"}],"hzOfo":[function(require,module,exports,__globalThis) {
const SemVer = require("4c531b1d555da497");
const Range = require("76327127dc36ed58");
const gt = require("a5ac47b45ae8684c");
const minVersion = (range, loose)=>{
    range = new Range(range, loose);
    let minver = new SemVer('0.0.0');
    if (range.test(minver)) return minver;
    minver = new SemVer('0.0.0-0');
    if (range.test(minver)) return minver;
    minver = null;
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let setMin = null;
        comparators.forEach((comparator)=>{
            // Clone to avoid manipulating the comparator's semver object.
            const compver = new SemVer(comparator.semver.version);
            switch(comparator.operator){
                case '>':
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case '':
                case '>=':
                    if (!setMin || gt(compver, setMin)) setMin = compver;
                    break;
                case '<':
                case '<=':
                    break;
                /* istanbul ignore next */ default:
                    throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
        });
        if (setMin && (!minver || gt(minver, setMin))) minver = setMin;
    }
    if (minver && range.test(minver)) return minver;
    return null;
};
module.exports = minVersion;

},{"4c531b1d555da497":"loFEZ","76327127dc36ed58":"6uOU5","a5ac47b45ae8684c":"i1m4Z"}],"jl3nN":[function(require,module,exports,__globalThis) {
const Range = require("fd2c35053245b1fd");
const validRange = (range, options)=>{
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new Range(range, options).range || '*';
    } catch (er) {
        return null;
    }
};
module.exports = validRange;

},{"fd2c35053245b1fd":"6uOU5"}],"k3qRG":[function(require,module,exports,__globalThis) {
const SemVer = require("65977c6c7fab41e0");
const Comparator = require("8b0890ac7a0294ed");
const { ANY } = Comparator;
const Range = require("9baad77301d611e2");
const satisfies = require("1a3d276234841886");
const gt = require("8f784c6ef2cd1972");
const lt = require("3c234e2ddd9db68a");
const lte = require("88893a74cd9f934");
const gte = require("6cccfcce37ef6329");
const outside = (version, range, hilo, options)=>{
    version = new SemVer(version, options);
    range = new Range(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case '>':
            gtfn = gt;
            ltefn = lte;
            ltfn = lt;
            comp = '>';
            ecomp = '>=';
            break;
        case '<':
            gtfn = lt;
            ltefn = gte;
            ltfn = gt;
            comp = '<';
            ecomp = '<=';
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if (satisfies(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let high = null;
        let low = null;
        comparators.forEach((comparator)=>{
            if (comparator.semver === ANY) comparator = new Comparator('>=0.0.0');
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
};
module.exports = outside;

},{"65977c6c7fab41e0":"loFEZ","8b0890ac7a0294ed":"5XmUp","9baad77301d611e2":"6uOU5","1a3d276234841886":"lkmhj","8f784c6ef2cd1972":"i1m4Z","3c234e2ddd9db68a":"03kmD","88893a74cd9f934":"lLxsa","6cccfcce37ef6329":"5i3dk"}],"1GFfK":[function(require,module,exports,__globalThis) {
// Determine if version is greater than all the versions possible in the range.
const outside = require("be5e984e16e512b9");
const gtr = (version, range, options)=>outside(version, range, '>', options);
module.exports = gtr;

},{"be5e984e16e512b9":"k3qRG"}],"koYUe":[function(require,module,exports,__globalThis) {
const outside = require("b7f00e21a32b75a5");
// Determine if version is less than all the versions possible in the range
const ltr = (version, range, options)=>outside(version, range, '<', options);
module.exports = ltr;

},{"b7f00e21a32b75a5":"k3qRG"}],"hmSQS":[function(require,module,exports,__globalThis) {
const Range = require("5205f80872e81710");
const intersects = (r1, r2, options)=>{
    r1 = new Range(r1, options);
    r2 = new Range(r2, options);
    return r1.intersects(r2, options);
};
module.exports = intersects;

},{"5205f80872e81710":"6uOU5"}],"XuZrU":[function(require,module,exports,__globalThis) {
// given a set of versions and a range, create a "simplified" range
// that includes the same versions that the original range does
// If the original range is shorter than the simplified one, return that.
const satisfies = require("e72123f17434788");
const compare = require("3eb9817061c82995");
module.exports = (versions, range, options)=>{
    const set = [];
    let first = null;
    let prev = null;
    const v = versions.sort((a, b)=>compare(a, b, options));
    for (const version of v){
        const included = satisfies(version, range, options);
        if (included) {
            prev = version;
            if (!first) first = version;
        } else {
            if (prev) set.push([
                first,
                prev
            ]);
            prev = null;
            first = null;
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    const ranges = [];
    for (const [min, max] of set){
        if (min === max) ranges.push(min);
        else if (!max && min === v[0]) ranges.push('*');
        else if (!max) ranges.push(`>=${min}`);
        else if (min === v[0]) ranges.push(`<=${max}`);
        else ranges.push(`${min} - ${max}`);
    }
    const simplified = ranges.join(' || ');
    const original = typeof range.raw === 'string' ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};

},{"e72123f17434788":"lkmhj","3eb9817061c82995":"fHXFx"}],"hHqHN":[function(require,module,exports,__globalThis) {
const Range = require("c141b0432e6ae71b");
const Comparator = require("94bed966a1054073");
const { ANY } = Comparator;
const satisfies = require("acfaf6445a9794b");
const compare = require("d9ed82a69c119cf4");
// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
const subset = (sub, dom, options = {})=>{
    if (sub === dom) return true;
    sub = new Range(sub, options);
    dom = new Range(dom, options);
    let sawNonNull = false;
    OUTER: for (const simpleSub of sub.set){
        for (const simpleDom of dom.set){
            const isSub = simpleSubset(simpleSub, simpleDom, options);
            sawNonNull = sawNonNull || isSub !== null;
            if (isSub) continue OUTER;
        }
        // the null set is a subset of everything, but null simple ranges in
        // a complex range should be ignored.  so if we saw a non-null range,
        // then we know this isn't a subset, but if EVERY simple range was null,
        // then it is a subset.
        if (sawNonNull) return false;
    }
    return true;
};
const minimumVersionWithPreRelease = [
    new Comparator('>=0.0.0-0')
];
const minimumVersion = [
    new Comparator('>=0.0.0')
];
const simpleSubset = (sub, dom, options)=>{
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === ANY) {
        if (dom.length === 1 && dom[0].semver === ANY) return true;
        else if (options.includePrerelease) sub = minimumVersionWithPreRelease;
        else sub = minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === ANY) {
        if (options.includePrerelease) return true;
        else dom = minimumVersion;
    }
    const eqSet = new Set();
    let gt, lt;
    for (const c of sub){
        if (c.operator === '>' || c.operator === '>=') gt = higherGT(gt, c, options);
        else if (c.operator === '<' || c.operator === '<=') lt = lowerLT(lt, c, options);
        else eqSet.add(c.semver);
    }
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt && lt) {
        gtltComp = compare(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== '>=' || lt.operator !== '<=')) return null;
    }
    // will iterate one or zero times
    for (const eq of eqSet){
        if (gt && !satisfies(eq, String(gt), options)) return null;
        if (lt && !satisfies(eq, String(lt), options)) return null;
        for (const c of dom){
            if (!satisfies(eq, String(c), options)) return false;
        }
        return true;
    }
    let higher, lower;
    let hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === '<' && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    for (const c of dom){
        hasDomGT = hasDomGT || c.operator === '>' || c.operator === '>=';
        hasDomLT = hasDomLT || c.operator === '<' || c.operator === '<=';
        if (gt) {
            if (needDomGTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) needDomGTPre = false;
            }
            if (c.operator === '>' || c.operator === '>=') {
                higher = higherGT(gt, c, options);
                if (higher === c && higher !== gt) return false;
            } else if (gt.operator === '>=' && !satisfies(gt.semver, String(c), options)) return false;
        }
        if (lt) {
            if (needDomLTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) needDomLTPre = false;
            }
            if (c.operator === '<' || c.operator === '<=') {
                lower = lowerLT(lt, c, options);
                if (lower === c && lower !== lt) return false;
            } else if (lt.operator === '<=' && !satisfies(lt.semver, String(c), options)) return false;
        }
        if (!c.operator && (lt || gt) && gtltComp !== 0) return false;
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
const higherGT = (a, b, options)=>{
    if (!a) return b;
    const comp = compare(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === '>' && a.operator === '>=' ? b : a;
};
// <=1.2.3 is higher than <1.2.3
const lowerLT = (a, b, options)=>{
    if (!a) return b;
    const comp = compare(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === '<' && a.operator === '<=' ? b : a;
};
module.exports = subset;

},{"c141b0432e6ae71b":"6uOU5","94bed966a1054073":"5XmUp","acfaf6445a9794b":"lkmhj","d9ed82a69c119cf4":"fHXFx"}],"03IVP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestLedgerDevice", ()=>requestLedgerDevice);
parcelHelpers.export(exports, "getLedgerDevices", ()=>getLedgerDevices);
parcelHelpers.export(exports, "getFirstLedgerDevice", ()=>getFirstLedgerDevice);
parcelHelpers.export(exports, "isSupported", ()=>isSupported);
var _devices = require("@ledgerhq/devices");
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const ledgerDevices = [
    {
        vendorId: (0, _devices.ledgerUSBVendorId)
    }
];
function requestLedgerDevice() {
    return __awaiter(this, void 0, void 0, function*() {
        const device = yield navigator.usb.requestDevice({
            filters: ledgerDevices
        });
        return device;
    });
}
function getLedgerDevices() {
    return __awaiter(this, void 0, void 0, function*() {
        const devices = yield navigator.usb.getDevices();
        return devices.filter((d)=>d.vendorId === (0, _devices.ledgerUSBVendorId));
    });
}
function getFirstLedgerDevice() {
    return __awaiter(this, void 0, void 0, function*() {
        const existingDevices = yield getLedgerDevices();
        if (existingDevices.length > 0) return existingDevices[0];
        return requestLedgerDevice();
    });
}
const isSupported = ()=>Promise.resolve(!!navigator && !!navigator.usb && typeof navigator.usb.getDevices === "function");

},{"@ledgerhq/devices":"j8MQh","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bREEn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canAccessNavigatorUsb", ()=>canAccessNavigatorUsb);
parcelHelpers.export(exports, "canAccessBle", ()=>canAccessBle);
parcelHelpers.export(exports, "Ledger", ()=>Ledger);
parcelHelpers.export(exports, "LedgerSigner", ()=>LedgerSigner);
var _ledger = require("@oasisprotocol/ledger");
var _ledgerDefault = parcelHelpers.interopDefault(_ledger);
var _types = require("app/state/wallet/types");
var _errors = require("types/errors");
var _helpers = require("./helpers");
var _hwTransportWebusb = require("@ledgerhq/hw-transport-webusb");
var _hwTransportWebusbDefault = parcelHelpers.interopDefault(_hwTransportWebusb);
var _lib = require("@oasisprotocol/ionic-ledger-hw-transport-ble/lib");
var _libDefault = parcelHelpers.interopDefault(_lib);
var _runtimeIs = require("app/lib/runtimeIs");
var Buffer = require("359310df6bf0c03c").Buffer;
async function canAccessNavigatorUsb() {
    return await (0, _hwTransportWebusbDefault.default).isSupported();
}
async function canAccessBle() {
    const hasBLE = await (0, _libDefault.default).isEnabled().catch(()=>false);
    // Scan depends on requestLEScan method, which is not available on the web(feature flag)
    const hasLEScan = (0, _runtimeIs.runtimeIs) === 'mobile-app' || !!navigator?.bluetooth?.requestLEScan;
    return hasBLE && hasLEScan;
}
function successOrThrowWalletError(response, message) {
    try {
        return (0, _ledger.successOrThrow)(response);
    } catch (err) {
        const errResponse = err;
        switch(errResponse.return_code){
            case 0x6400:
                throw new (0, _errors.WalletError)((0, _errors.WalletErrors).LedgerAppVersionNotSupported, errResponse.error_message);
            case 0x6986:
                throw new (0, _errors.WalletError)((0, _errors.WalletErrors).LedgerTransactionRejected, errResponse.error_message);
            case 0x6804:
                throw new (0, _errors.WalletError)((0, _errors.WalletErrors).LedgerCannotOpenOasisApp, errResponse.error_message);
            default:
                throw new (0, _errors.WalletError)((0, _errors.WalletErrors).LedgerUnknownError, errResponse.error_message);
        }
    }
}
class Ledger {
    static async getOasisApp(transport) {
        const app = new (0, _ledgerDefault.default)(transport);
        const appInfo = successOrThrowWalletError(await app.appInfo(), 'ledger app info');
        if (appInfo.appName !== 'Oasis') throw new (0, _errors.WalletError)((0, _errors.WalletErrors).LedgerOasisAppIsNotOpen, 'Oasis App is not open');
        return app;
    }
    static async deriveAccountUsingOasisApp(app, addressIndex) {
        const path = [
            44,
            474,
            0,
            0,
            addressIndex
        ];
        const pathDisplay = `m/44'/474'/0'/0'/${addressIndex}'` // Hardening should match app.publicKey implementation
        ;
        const publicKeyResponse = successOrThrowWalletError(await app.publicKey(path), 'ledger public key');
        return {
            path,
            pathDisplay,
            publicKey: new Uint8Array(publicKeyResponse.pk)
        };
    }
    static async enumerateAccounts(transport, count = 5, start = 0) {
        const app = await Ledger.getOasisApp(transport);
        const accounts = [];
        for(let i = start; i < start + count; i++)accounts.push(await Ledger.deriveAccountUsingOasisApp(app, i));
        return accounts;
    }
    static async validateAccountDerivation(app, path, expectedPublicKey) {
        const expectedAddress = await (0, _helpers.publicKeyToAddress)(expectedPublicKey);
        const publicKeyResponse = successOrThrowWalletError(await app.publicKey(path), 'ledger public key');
        const publicKey = new Uint8Array(publicKeyResponse.pk);
        const reDerivedAddress = await (0, _helpers.publicKeyToAddress)(publicKey);
        if (expectedAddress !== reDerivedAddress) throw new (0, _errors.WalletError)((0, _errors.WalletErrors).LedgerDerivedDifferentAccount, `expected to derive ${expectedAddress} but ledger derived ${reDerivedAddress}`);
    }
}
class LedgerSigner {
    constructor(wallet){
        if (!wallet.path || wallet.type !== (0, _types.WalletType).UsbLedger && wallet.type !== (0, _types.WalletType).BleLedger) throw new Error('Given wallet is not a ledger wallet');
        this.path = wallet.path;
        this.publicKey = (0, _helpers.hex2uint)(wallet.publicKey);
        this.transportType = wallet.type;
    }
    setTransport(transport) {
        this.transport = transport;
    }
    public() {
        return this.publicKey;
    }
    async sign(context, message) {
        if (!this.transport) throw new Error('Cannot sign using ledger without an active WebUSB transport');
        const app = new (0, _ledgerDefault.default)(this.transport);
        await Ledger.validateAccountDerivation(app, this.path, this.publicKey);
        const response = successOrThrowWalletError(await app.sign(this.path, context, Buffer.from(message)), 'ledger sign');
        return new Uint8Array(response.signature);
    }
}

},{"359310df6bf0c03c":"eXvXD","@oasisprotocol/ledger":"3E9mo","app/state/wallet/types":"b0U5N","types/errors":"gbx4q","./helpers":"bUnFy","@ledgerhq/hw-transport-webusb":"6FpvD","@oasisprotocol/ionic-ledger-hw-transport-ble/lib":"l4CqL","app/lib/runtimeIs":"fboJV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3E9mo":[function(require,module,exports,__globalThis) {
var Buffer = require("2fefeacb467b890b").Buffer;
"use strict";
var _interopRequireDefault = require("b2787917c4ae4211");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.successOrThrow = successOrThrow;
var _regenerator = _interopRequireDefault(require("cd9406309a4962f9"));
var _asyncToGenerator2 = _interopRequireDefault(require("cd47c13f43f62283"));
var _classCallCheck2 = _interopRequireDefault(require("f3d6ac40e86ec962"));
var _createClass2 = _interopRequireDefault(require("8958f459bb648bda"));
var _helperV = require("c1e834492d9c45b2");
var _common = require("7f77b730dcda4307");
/** ******************************************************************************
 *  (c) 2019 ZondaX GmbH
 *  (c) 2016-2017 Ledger
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 ******************************************************************************* */ function processGetAddrEd25519Response(response) {
    var errorCodeData = response.slice(-2);
    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
    var pk = Buffer.from(response.slice(0, 32));
    var bech32Address = Buffer.from(response.slice(32, -2)).toString();
    return {
        bech32_address: bech32Address,
        pk: pk,
        return_code: returnCode,
        error_message: (0, _common.errorCodeToString)(returnCode)
    };
}
function processGetAddrSecp256k1Response(response) {
    var errorCodeData = response.slice(-2);
    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
    var pk = Buffer.from(response.slice(0, 33));
    var hexAddress = Buffer.from(response.slice(33, 73)).toString();
    return {
        pk: pk,
        hex_address: hexAddress,
        return_code: returnCode,
        error_message: (0, _common.errorCodeToString)(returnCode)
    };
}
/**
 * @template T
 * @param {import('./types').Response<T>} response
 */ function successOrThrow(response) {
    if (response.return_code !== 0x9000) throw response;
    return /** @type { T } */ response;
}
var OasisApp = /*#__PURE__*/ function() {
    /** @param {import('./types').Transport} transport */ function OasisApp(transport) {
        var scrambleKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _common.APP_KEY;
        (0, _classCallCheck2.default)(this, OasisApp);
        if (!transport) throw new Error("Transport has not been defined");
        /** @type {Awaited<ReturnType<typeof getVersion>>} */ this.versionResponse = undefined;
        this.transport = transport;
        transport.decorateAppAPIMethods(this, [
            "getVersion",
            "sign",
            "signRtEd25519",
            "signRtSecp256k1",
            "getAddressAndPubKey_ed25519",
            "getAddressAndPubKey_secp256k1",
            "appInfo",
            "deviceInfo"
        ], scrambleKey);
    }
    /** @param {import('./types').DerivationPath} path */ (0, _createClass2.default)(OasisApp, [
        {
            key: "serializePath",
            value: function() {
                var _serializePath = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(path) {
                    return _regenerator.default.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 2;
                                return (0, _common.getVersion)(this.transport);
                            case 2:
                                this.versionResponse = _context.sent;
                                _context.t0 = this.versionResponse.major;
                                _context.next = _context.t0 === 0 ? 6 : _context.t0 === 1 ? 6 : _context.t0 === 2 ? 6 : 7;
                                break;
                            case 6:
                                return _context.abrupt("return", (0, _helperV.serializePathv1)(path));
                            case 7:
                                return _context.abrupt("return", {
                                    return_code: 0x6400,
                                    error_message: "App Version is not supported"
                                });
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function serializePath(_x) {
                    return _serializePath.apply(this, arguments);
                }
                return serializePath;
            }()
        },
        {
            key: "serializePathBip44",
            value: function() {
                var _serializePathBip = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee2(path) {
                    return _regenerator.default.wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 2;
                                return (0, _common.getVersion)(this.transport);
                            case 2:
                                this.versionResponse = _context2.sent;
                                _context2.t0 = this.versionResponse.major;
                                _context2.next = _context2.t0 === 0 ? 6 : _context2.t0 === 1 ? 6 : _context2.t0 === 2 ? 6 : 7;
                                break;
                            case 6:
                                return _context2.abrupt("return", (0, _helperV.serializePathBip44v1)(path));
                            case 7:
                                return _context2.abrupt("return", {
                                    return_code: 0x6400,
                                    error_message: "App Version is not supported"
                                });
                            case 8:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function serializePathBip44(_x2) {
                    return _serializePathBip.apply(this, arguments);
                }
                return serializePathBip44;
            }()
        },
        {
            key: "signGetChunks",
            value: /** @param {import('./types').DerivationPath} path */ function() {
                var _signGetChunks = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee3(path, context, message, ins) {
                    var serializedPath;
                    return _regenerator.default.wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                _context3.next = 2;
                                return this.serializePath(path);
                            case 2:
                                serializedPath = _context3.sent;
                                if (!(ins === _common.INS.SIGN_RT_SECP256K1)) {
                                    _context3.next = 7;
                                    break;
                                }
                                _context3.next = 6;
                                return this.serializePathBip44(path);
                            case 6:
                                serializedPath = _context3.sent;
                            case 7:
                                if (!("return_code" in serializedPath && serializedPath.return_code !== 0x9000)) {
                                    _context3.next = 9;
                                    break;
                                }
                                return _context3.abrupt("return", serializedPath);
                            case 9:
                                if (!(ins === _common.INS.SIGN_ED25519)) {
                                    _context3.next = 11;
                                    break;
                                }
                                return _context3.abrupt("return", OasisApp.prepareChunks(serializedPath, context, message));
                            case 11:
                                return _context3.abrupt("return", OasisApp.prepareMetaChunks(serializedPath, context, message));
                            case 12:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function signGetChunks(_x3, _x4, _x5, _x6) {
                    return _signGetChunks.apply(this, arguments);
                }
                return signGetChunks;
            }()
        },
        {
            key: "getVersion",
            value: function() {
                var _getVersion2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee4() {
                    return _regenerator.default.wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return (0, _common.getVersion)(this.transport);
                            case 2:
                                this.versionResponse = _context4.sent;
                                return _context4.abrupt("return", this.versionResponse);
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function getVersion() {
                    return _getVersion2.apply(this, arguments);
                }
                return getVersion;
            }()
        },
        {
            key: "appInfo",
            value: function() {
                var _appInfo = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee5() {
                    return _regenerator.default.wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                return _context5.abrupt("return", this.transport.send(0xb0, 0x01, 0, 0).then(function(response) {
                                    var errorCodeData = response.slice(-2);
                                    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                                    var result = {};
                                    var appName = "err";
                                    var appVersion = "err";
                                    var flagLen = 0;
                                    var flagsValue = 0;
                                    if (response[0] !== 1) {
                                        // Ledger responds with format ID 1. There is no spec for any format != 1
                                        result.error_message = "response format ID not recognized";
                                        result.return_code = 0x9001;
                                    } else {
                                        var appNameLen = response[1];
                                        appName = response.slice(2, 2 + appNameLen).toString("ascii");
                                        var idx = 2 + appNameLen;
                                        var appVersionLen = response[idx];
                                        idx += 1;
                                        appVersion = response.slice(idx, idx + appVersionLen).toString("ascii");
                                        idx += appVersionLen;
                                        var appFlagsLen = response[idx];
                                        idx += 1;
                                        flagLen = appFlagsLen;
                                        flagsValue = response[idx];
                                    }
                                    return {
                                        return_code: returnCode,
                                        error_message: (0, _common.errorCodeToString)(returnCode),
                                        // //
                                        appName: appName,
                                        appVersion: appVersion,
                                        flagLen: flagLen,
                                        flagsValue: flagsValue,
                                        // eslint-disable-next-line no-bitwise
                                        flag_recovery: (flagsValue & 1) !== 0,
                                        // eslint-disable-next-line no-bitwise
                                        flag_signed_mcu_code: (flagsValue & 2) !== 0,
                                        // eslint-disable-next-line no-bitwise
                                        flag_onboarded: (flagsValue & 4) !== 0,
                                        // eslint-disable-next-line no-bitwise
                                        flag_pin_validated: (flagsValue & 128) !== 0
                                    };
                                }, _common.processErrorResponse));
                            case 1:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function appInfo() {
                    return _appInfo.apply(this, arguments);
                }
                return appInfo;
            }()
        },
        {
            key: "deviceInfo",
            value: function() {
                var _deviceInfo = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee6() {
                    return _regenerator.default.wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                return _context6.abrupt("return", this.transport.send(0xe0, 0x01, 0, 0, Buffer.from([]), [
                                    0x9000,
                                    0x6e00
                                ]).then(function(response) {
                                    var errorCodeData = response.slice(-2);
                                    var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                                    if (returnCode === 0x6e00) return {
                                        return_code: returnCode,
                                        error_message: "This command is only available in the Dashboard"
                                    };
                                    var targetId = response.slice(0, 4).toString("hex");
                                    var pos = 4;
                                    var secureElementVersionLen = response[pos];
                                    pos += 1;
                                    var seVersion = response.slice(pos, pos + secureElementVersionLen).toString();
                                    pos += secureElementVersionLen;
                                    var flagsLen = response[pos];
                                    pos += 1;
                                    var flag = response.slice(pos, pos + flagsLen).toString("hex");
                                    pos += flagsLen;
                                    var mcuVersionLen = response[pos];
                                    pos += 1; // Patch issue in mcu version
                                    var tmp = response.slice(pos, pos + mcuVersionLen);
                                    if (tmp[mcuVersionLen - 1] === 0) tmp = response.slice(pos, pos + mcuVersionLen - 1);
                                    var mcuVersion = tmp.toString(); // Note: must save to variable before returning, so that inferred type is
                                    // `{error_message} | {mcuVersion}` instead of `{error_message, mcuVersion?}`.
                                    // https://github.com/oasisprotocol/ledger-js/pull/415#discussion_r833791641
                                    var info = {
                                        return_code: returnCode,
                                        error_message: (0, _common.errorCodeToString)(returnCode),
                                        // //
                                        targetId: targetId,
                                        seVersion: seVersion,
                                        flag: flag,
                                        mcuVersion: mcuVersion
                                    };
                                    return info;
                                }, _common.processErrorResponse));
                            case 1:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function deviceInfo() {
                    return _deviceInfo.apply(this, arguments);
                }
                return deviceInfo;
            }()
        },
        {
            key: "publicKey",
            value: function() {
                var _publicKey = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee7(path) {
                    var serializedPath;
                    return _regenerator.default.wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                _context7.next = 2;
                                return this.serializePath(path);
                            case 2:
                                serializedPath = _context7.sent;
                                if (!("return_code" in serializedPath && serializedPath.return_code !== 0x9000)) {
                                    _context7.next = 5;
                                    break;
                                }
                                return _context7.abrupt("return", serializedPath);
                            case 5:
                                return _context7.abrupt("return", (0, _helperV.publicKeyv1)(this, serializedPath));
                            case 6:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function publicKey(_x7) {
                    return _publicKey.apply(this, arguments);
                }
                return publicKey;
            }()
        },
        {
            key: "getAddressAndPubKey_ed25519",
            value: function() {
                var _getAddressAndPubKey_ed = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee8(path) {
                    var data;
                    return _regenerator.default.wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                _context8.next = 2;
                                return this.serializePath(path);
                            case 2:
                                data = _context8.sent;
                                if (!("return_code" in data && data.return_code !== 0x9000)) {
                                    _context8.next = 5;
                                    break;
                                }
                                return _context8.abrupt("return", data);
                            case 5:
                                return _context8.abrupt("return", this.transport.send(_common.CLA, _common.INS.GET_ADDR_ED25519, _common.P1_VALUES.ONLY_RETRIEVE, 0, data, [
                                    0x9000
                                ]).then(processGetAddrEd25519Response, _common.processErrorResponse));
                            case 6:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this);
                }));
                function getAddressAndPubKey_ed25519(_x8) {
                    return _getAddressAndPubKey_ed.apply(this, arguments);
                }
                return getAddressAndPubKey_ed25519;
            }()
        },
        {
            key: "getAddressAndPubKey_secp256k1",
            value: function() {
                var _getAddressAndPubKey_secp256k = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee9(path) {
                    var data;
                    return _regenerator.default.wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                _context9.next = 2;
                                return this.serializePathBip44(path);
                            case 2:
                                data = _context9.sent;
                                if (!("return_code" in data && data.return_code !== 0x9000)) {
                                    _context9.next = 5;
                                    break;
                                }
                                return _context9.abrupt("return", data);
                            case 5:
                                return _context9.abrupt("return", this.transport.send(_common.CLA, _common.INS.GET_ADDR_SECP256K1, _common.P1_VALUES.ONLY_RETRIEVE, 0, data, [
                                    0x9000
                                ]).then(processGetAddrSecp256k1Response, _common.processErrorResponse));
                            case 6:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this);
                }));
                function getAddressAndPubKey_secp256k1(_x9) {
                    return _getAddressAndPubKey_secp256k.apply(this, arguments);
                }
                return getAddressAndPubKey_secp256k1;
            }()
        },
        {
            key: "showAddressAndPubKey_ed25519",
            value: function() {
                var _showAddressAndPubKey_ed = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee10(path) {
                    var data;
                    return _regenerator.default.wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                _context10.next = 2;
                                return this.serializePath(path);
                            case 2:
                                data = _context10.sent;
                                if (!("return_code" in data && data.return_code !== 0x9000)) {
                                    _context10.next = 5;
                                    break;
                                }
                                return _context10.abrupt("return", data);
                            case 5:
                                return _context10.abrupt("return", this.transport.send(_common.CLA, _common.INS.GET_ADDR_ED25519, _common.P1_VALUES.SHOW_ADDRESS_IN_DEVICE, 0, data, [
                                    0x9000
                                ]).then(processGetAddrEd25519Response, _common.processErrorResponse));
                            case 6:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this);
                }));
                function showAddressAndPubKey_ed25519(_x10) {
                    return _showAddressAndPubKey_ed.apply(this, arguments);
                }
                return showAddressAndPubKey_ed25519;
            }()
        },
        {
            key: "showAddressAndPubKey_secp256k1",
            value: function() {
                var _showAddressAndPubKey_secp256k = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee11(path) {
                    var data;
                    return _regenerator.default.wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                _context11.next = 2;
                                return this.serializePathBip44(path);
                            case 2:
                                data = _context11.sent;
                                if (!("return_code" in data && data.return_code !== 0x9000)) {
                                    _context11.next = 5;
                                    break;
                                }
                                return _context11.abrupt("return", data);
                            case 5:
                                return _context11.abrupt("return", this.transport.send(_common.CLA, _common.INS.GET_ADDR_SECP256K1, _common.P1_VALUES.SHOW_ADDRESS_IN_DEVICE, 0, data, [
                                    0x9000
                                ]).then(processGetAddrSecp256k1Response, _common.processErrorResponse));
                            case 6:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this);
                }));
                function showAddressAndPubKey_secp256k1(_x11) {
                    return _showAddressAndPubKey_secp256k.apply(this, arguments);
                }
                return showAddressAndPubKey_secp256k1;
            }()
        },
        {
            key: "signSendChunk",
            value: function() {
                var _signSendChunk = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee12(chunkIdx, chunkNum, chunk, ins) {
                    return _regenerator.default.wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                _context12.t0 = this.versionResponse.major;
                                _context12.next = _context12.t0 === 0 ? 3 : _context12.t0 === 1 ? 3 : _context12.t0 === 2 ? 3 : 4;
                                break;
                            case 3:
                                return _context12.abrupt("return", (0, _helperV.signSendChunkv1)(this, chunkIdx, chunkNum, chunk, ins));
                            case 4:
                                return _context12.abrupt("return", {
                                    return_code: 0x6400,
                                    error_message: "App Version is not supported"
                                });
                            case 5:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this);
                }));
                function signSendChunk(_x12, _x13, _x14, _x15) {
                    return _signSendChunk.apply(this, arguments);
                }
                return signSendChunk;
            }()
        },
        {
            key: "sign",
            value: function() {
                var _sign = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee14(path, context, message) {
                    var _this = this;
                    var chunks;
                    return _regenerator.default.wrap(function _callee14$(_context14) {
                        while(true)switch(_context14.prev = _context14.next){
                            case 0:
                                _context14.next = 2;
                                return this.signGetChunks(path, context, message, _common.INS.SIGN_ED25519);
                            case 2:
                                chunks = _context14.sent;
                                if (!("return_code" in chunks && chunks.return_code !== 0x9000)) {
                                    _context14.next = 5;
                                    break;
                                }
                                return _context14.abrupt("return", chunks);
                            case 5:
                                return _context14.abrupt("return", this.signSendChunk(1, chunks.length, chunks[0], _common.INS.SIGN_ED25519).then(/*#__PURE__*/ function() {
                                    var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee13(response) {
                                        var result, i;
                                        return _regenerator.default.wrap(function _callee13$(_context13) {
                                            while(true)switch(_context13.prev = _context13.next){
                                                case 0:
                                                    if (!(response.return_code !== 0x9000)) {
                                                        _context13.next = 2;
                                                        break;
                                                    }
                                                    return _context13.abrupt("return", response);
                                                case 2:
                                                    result = {
                                                        return_code: response.return_code,
                                                        error_message: response.error_message,
                                                        /** @type {null | Buffer} */ signature: null
                                                    };
                                                    i = 1;
                                                case 4:
                                                    if (!(i < chunks.length)) {
                                                        _context13.next = 13;
                                                        break;
                                                    }
                                                    _context13.next = 7;
                                                    return _this.signSendChunk(1 + i, chunks.length, chunks[i], _common.INS.SIGN_ED25519);
                                                case 7:
                                                    result = _context13.sent;
                                                    if (!(result.return_code !== 0x9000)) {
                                                        _context13.next = 10;
                                                        break;
                                                    }
                                                    return _context13.abrupt("break", 13);
                                                case 10:
                                                    i += 1;
                                                    _context13.next = 4;
                                                    break;
                                                case 13:
                                                    return _context13.abrupt("return", {
                                                        return_code: result.return_code,
                                                        error_message: result.error_message,
                                                        // ///
                                                        signature: result.signature
                                                    });
                                                case 14:
                                                case "end":
                                                    return _context13.stop();
                                            }
                                        }, _callee13);
                                    }));
                                    return function(_x19) {
                                        return _ref.apply(this, arguments);
                                    };
                                }(), _common.processErrorResponse));
                            case 6:
                            case "end":
                                return _context14.stop();
                        }
                    }, _callee14, this);
                }));
                function sign(_x16, _x17, _x18) {
                    return _sign.apply(this, arguments);
                }
                return sign;
            }()
        },
        {
            key: "signRtEd25519",
            value: function() {
                var _signRtEd = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee16(path, context, message) {
                    var _this2 = this;
                    var chunks;
                    return _regenerator.default.wrap(function _callee16$(_context16) {
                        while(true)switch(_context16.prev = _context16.next){
                            case 0:
                                _context16.next = 2;
                                return this.signGetChunks(path, context, message, _common.INS.SIGN_RT_ED25519);
                            case 2:
                                chunks = _context16.sent;
                                if (!("return_code" in chunks && chunks.return_code !== 0x9000)) {
                                    _context16.next = 5;
                                    break;
                                }
                                return _context16.abrupt("return", chunks);
                            case 5:
                                return _context16.abrupt("return", this.signSendChunk(1, chunks.length, chunks[0], _common.INS.SIGN_RT_ED25519).then(/*#__PURE__*/ function() {
                                    var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee15(response) {
                                        var result, i;
                                        return _regenerator.default.wrap(function _callee15$(_context15) {
                                            while(true)switch(_context15.prev = _context15.next){
                                                case 0:
                                                    if (!(response.return_code !== 0x9000)) {
                                                        _context15.next = 2;
                                                        break;
                                                    }
                                                    return _context15.abrupt("return", response);
                                                case 2:
                                                    result = {
                                                        return_code: response.return_code,
                                                        error_message: response.error_message,
                                                        /** @type {null | Buffer} */ signature: null
                                                    };
                                                    i = 1;
                                                case 4:
                                                    if (!(i < chunks.length)) {
                                                        _context15.next = 13;
                                                        break;
                                                    }
                                                    _context15.next = 7;
                                                    return _this2.signSendChunk(1 + i, chunks.length, chunks[i], _common.INS.SIGN_RT_ED25519);
                                                case 7:
                                                    result = _context15.sent;
                                                    if (!(result.return_code !== 0x9000)) {
                                                        _context15.next = 10;
                                                        break;
                                                    }
                                                    return _context15.abrupt("break", 13);
                                                case 10:
                                                    i += 1;
                                                    _context15.next = 4;
                                                    break;
                                                case 13:
                                                    return _context15.abrupt("return", {
                                                        return_code: result.return_code,
                                                        error_message: result.error_message,
                                                        // ///
                                                        signature: result.signature
                                                    });
                                                case 14:
                                                case "end":
                                                    return _context15.stop();
                                            }
                                        }, _callee15);
                                    }));
                                    return function(_x23) {
                                        return _ref2.apply(this, arguments);
                                    };
                                }(), _common.processErrorResponse));
                            case 6:
                            case "end":
                                return _context16.stop();
                        }
                    }, _callee16, this);
                }));
                function signRtEd25519(_x20, _x21, _x22) {
                    return _signRtEd.apply(this, arguments);
                }
                return signRtEd25519;
            }()
        },
        {
            key: "signRtSecp256k1",
            value: function() {
                var _signRtSecp256k = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee18(path, context, message) {
                    var _this3 = this;
                    var chunks;
                    return _regenerator.default.wrap(function _callee18$(_context18) {
                        while(true)switch(_context18.prev = _context18.next){
                            case 0:
                                _context18.next = 2;
                                return this.signGetChunks(path, context, message, _common.INS.SIGN_RT_SECP256K1);
                            case 2:
                                chunks = _context18.sent;
                                if (!("return_code" in chunks && chunks.return_code !== 0x9000)) {
                                    _context18.next = 5;
                                    break;
                                }
                                return _context18.abrupt("return", chunks);
                            case 5:
                                return _context18.abrupt("return", this.signSendChunk(1, chunks.length, chunks[0], _common.INS.SIGN_RT_SECP256K1).then(/*#__PURE__*/ function() {
                                    var _ref3 = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee17(response) {
                                        var result, i;
                                        return _regenerator.default.wrap(function _callee17$(_context17) {
                                            while(true)switch(_context17.prev = _context17.next){
                                                case 0:
                                                    if (!(response.return_code !== 0x9000)) {
                                                        _context17.next = 2;
                                                        break;
                                                    }
                                                    return _context17.abrupt("return", response);
                                                case 2:
                                                    result = {
                                                        return_code: response.return_code,
                                                        error_message: response.error_message,
                                                        /** @type {null | Buffer} */ signature: null
                                                    };
                                                    i = 1;
                                                case 4:
                                                    if (!(i < chunks.length)) {
                                                        _context17.next = 13;
                                                        break;
                                                    }
                                                    _context17.next = 7;
                                                    return _this3.signSendChunk(1 + i, chunks.length, chunks[i], _common.INS.SIGN_RT_SECP256K1);
                                                case 7:
                                                    result = _context17.sent;
                                                    if (!(result.return_code !== 0x9000)) {
                                                        _context17.next = 10;
                                                        break;
                                                    }
                                                    return _context17.abrupt("break", 13);
                                                case 10:
                                                    i += 1;
                                                    _context17.next = 4;
                                                    break;
                                                case 13:
                                                    return _context17.abrupt("return", {
                                                        return_code: result.return_code,
                                                        error_message: result.error_message,
                                                        // ///
                                                        signature: result.signature
                                                    });
                                                case 14:
                                                case "end":
                                                    return _context17.stop();
                                            }
                                        }, _callee17);
                                    }));
                                    return function(_x27) {
                                        return _ref3.apply(this, arguments);
                                    };
                                }(), _common.processErrorResponse));
                            case 6:
                            case "end":
                                return _context18.stop();
                        }
                    }, _callee18, this);
                }));
                function signRtSecp256k1(_x24, _x25, _x26) {
                    return _signRtSecp256k.apply(this, arguments);
                }
                return signRtSecp256k1;
            }()
        }
    ], [
        {
            key: "prepareChunks",
            value: function prepareChunks(serializedPathBuffer, context, message) {
                /** @type {Buffer[]} */ var chunks = []; // First chunk (only path)
                chunks.push(serializedPathBuffer);
                var contextSizeBuffer = Buffer.from([
                    context.length
                ]);
                var contextBuffer = Buffer.from(context);
                var messageBuffer = Buffer.from(message);
                if (context.length > 255) throw new Error("Maximum supported context size is 255 bytes");
                if (contextSizeBuffer.length > 1) throw new Error("Context size buffer should be exactly 1 byte");
                 // Now split context length + context + message into more chunks
                var buffer = Buffer.concat([
                    contextSizeBuffer,
                    contextBuffer,
                    messageBuffer
                ]);
                for(var i = 0; i < buffer.length; i += _common.CHUNK_SIZE){
                    var end = i + _common.CHUNK_SIZE;
                    if (i > buffer.length) end = buffer.length;
                    chunks.push(buffer.slice(i, end));
                }
                return chunks;
            }
        },
        {
            key: "prepareMetaChunks",
            value: function prepareMetaChunks(serializedPathBuffer, meta, message) {
                /** @type {Buffer[]} */ var chunks = []; // First chunk (only path)
                chunks.push(serializedPathBuffer);
                var MetaBuffer = Buffer.from(meta);
                var messageBuffer = Buffer.from(message); // Now split context length + context + message into more chunks
                var buffer = Buffer.concat([
                    MetaBuffer,
                    messageBuffer
                ]);
                for(var i = 0; i < buffer.length; i += _common.CHUNK_SIZE){
                    var end = i + _common.CHUNK_SIZE;
                    if (i > buffer.length) end = buffer.length;
                    chunks.push(buffer.slice(i, end));
                }
                return chunks;
            }
        }
    ]);
    return OasisApp;
}();
exports.default = OasisApp;

},{"2fefeacb467b890b":"eXvXD","b2787917c4ae4211":"lVzA4","cd9406309a4962f9":"2OHgN","cd47c13f43f62283":"b7d89","f3d6ac40e86ec962":"0lSKi","8958f459bb648bda":"3Ycxx","c1e834492d9c45b2":"98i2E","7f77b730dcda4307":"8hVmm"}],"lVzA4":[function(require,module,exports,__globalThis) {
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"2OHgN":[function(require,module,exports,__globalThis) {
// TODO(Babel 8): Remove this file.
var runtime = require("1716bf03fd9b86cf")();
module.exports = runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = runtime;
    else Function("r", "regeneratorRuntime = r")(runtime);
}

},{"1716bf03fd9b86cf":"8WlDj"}],"8WlDj":[function(require,module,exports,__globalThis) {
var _typeof = require("921e792370458e88")["default"];
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw new Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError(_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw new Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"921e792370458e88":"aDt81"}],"aDt81":[function(require,module,exports,__globalThis) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"b7d89":[function(require,module,exports,__globalThis) {
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"0lSKi":[function(require,module,exports,__globalThis) {
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"3Ycxx":[function(require,module,exports,__globalThis) {
var toPropertyKey = require("b03a9e1e96a7e901");
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"b03a9e1e96a7e901":"107Bb"}],"107Bb":[function(require,module,exports,__globalThis) {
var _typeof = require("a14bd529aa4ac1cd")["default"];
var toPrimitive = require("2713647ce51d8c75");
function _toPropertyKey(arg) {
    var key = toPrimitive(arg, "string");
    return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"a14bd529aa4ac1cd":"aDt81","2713647ce51d8c75":"6eObm"}],"6eObm":[function(require,module,exports,__globalThis) {
var _typeof = require("e0211298897b2d31")["default"];
function _toPrimitive(input, hint) {
    if (_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{"e0211298897b2d31":"aDt81"}],"98i2E":[function(require,module,exports,__globalThis) {
var Buffer = require("31c2666489c87ea1").Buffer;
"use strict";
var _interopRequireDefault = require("d2c81162838dbc76");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.publicKeyv1 = publicKeyv1;
exports.serializePathBip44v1 = serializePathBip44v1;
exports.serializePathv1 = serializePathv1;
exports.signSendChunkv1 = signSendChunkv1;
var _regenerator = _interopRequireDefault(require("12e2b0973d107565"));
var _asyncToGenerator2 = _interopRequireDefault(require("3aa422a43a22e16a"));
var _common = require("4c023af40809d964");
var HARDENED = 0x80000000;
/** @param {import('./types').DerivationPath} path */ function serializePathv1(path) {
    // length 3: ADR 8 derivation path
    // length 5: Legacy derivation path
    if (!(path instanceof Array)) throw new Error("Path must be array of numbers");
    if (path.length !== 3 && path.length !== 5) throw new Error("Invalid path.");
    /* eslint no-bitwise: "off", no-plusplus: "off" */ var buf = Buffer.alloc(path.length * 4);
    for(var i = 0; i < path.length; i++){
        // Harden all path components by ORing them with 0x80000000.
        var hardened = (0x80000000 | path[i]) >>> 0;
        buf.writeUInt32LE(hardened, i * 4);
    }
    return buf;
}
/** @param {import('./types').DerivationPath} path */ function serializePathBip44v1(path) {
    if (!(path instanceof Array)) throw new Error("Path must be array of numbers");
    if (path.length !== 5) throw new Error("Invalid path.");
    /* eslint no-bitwise: "off", no-plusplus: "off" */ var buf = Buffer.alloc(path.length * 4);
    for(var i = 0; i < path.length; i++){
        if (path[i] >= HARDENED) throw new Error("Incorrect child value (bigger or equal to 0x80000000)");
        var value = i < 3 ? (HARDENED | path[i]) >>> 0 : path[i];
        buf.writeUInt32LE(value, i * 4);
    }
    return buf;
}
/** @param {import('./types').App} app */ function signSendChunkv1(_x, _x2, _x3, _x4, _x5) {
    return _signSendChunkv.apply(this, arguments);
}
/** @param {import('./types').App} app */ function _signSendChunkv() {
    _signSendChunkv = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(app, chunkIdx, chunkNum, chunk, ins) {
        var payloadType;
        return _regenerator.default.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    payloadType = _common.PAYLOAD_TYPE.ADD;
                    if (chunkIdx === 1) payloadType = _common.PAYLOAD_TYPE.INIT;
                    if (chunkIdx === chunkNum) payloadType = _common.PAYLOAD_TYPE.LAST;
                    return _context.abrupt("return", app.transport.send(_common.CLA, ins, payloadType, 0, chunk, [
                        0x9000,
                        0x6984,
                        0x6a80
                    ]).then(function(response) {
                        var errorCodeData = response.slice(-2);
                        var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                        var errorMessage = (0, _common.errorCodeToString)(returnCode);
                        if (returnCode === 0x6a80 || returnCode === 0x6984) errorMessage = "".concat(errorMessage, " : ").concat(response.slice(0, response.length - 2).toString("ascii"));
                        var signature = null;
                        if (response.length > 2) signature = response.slice(0, response.length - 2);
                        return {
                            signature: signature,
                            return_code: returnCode,
                            error_message: errorMessage
                        };
                    }, _common.processErrorResponse));
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return _signSendChunkv.apply(this, arguments);
}
function publicKeyv1(_x6, _x7) {
    return _publicKeyv.apply(this, arguments);
}
function _publicKeyv() {
    _publicKeyv = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee2(app, data) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    return _context2.abrupt("return", app.transport.send(_common.CLA, _common.INS.GET_ADDR_ED25519, 0, 0, data, [
                        0x9000
                    ]).then(function(response) {
                        var errorCodeData = response.slice(-2);
                        var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                        return {
                            pk: Buffer.from(response.slice(0, 32)),
                            return_code: returnCode,
                            error_message: (0, _common.errorCodeToString)(returnCode)
                        };
                    }, _common.processErrorResponse));
                case 1:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return _publicKeyv.apply(this, arguments);
}

},{"31c2666489c87ea1":"eXvXD","d2c81162838dbc76":"lVzA4","12e2b0973d107565":"2OHgN","3aa422a43a22e16a":"b7d89","4c023af40809d964":"8hVmm"}],"8hVmm":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("646da52c282fb6ca");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PAYLOAD_TYPE = exports.P1_VALUES = exports.INS = exports.DEFAULT_HRP = exports.CLA = exports.CHUNK_SIZE = exports.APP_KEY = void 0;
exports.errorCodeToString = errorCodeToString;
exports.getVersion = getVersion;
exports.processErrorResponse = processErrorResponse;
var _regenerator = _interopRequireDefault(require("3cdb4331570cf001"));
var _asyncToGenerator2 = _interopRequireDefault(require("29f1d6ef092edb98"));
var CLA = 0x05;
exports.CLA = CLA;
var CHUNK_SIZE = 250;
exports.CHUNK_SIZE = CHUNK_SIZE;
var APP_KEY = "OAS";
exports.APP_KEY = APP_KEY;
var INS = {
    GET_VERSION: 0x00,
    GET_ADDR_ED25519: 0x01,
    SIGN_ED25519: 0x02,
    GET_ADDR_SECP256K1: 0x04,
    SIGN_RT_ED25519: 0x05,
    SIGN_RT_SECP256K1: 0x07
};
exports.INS = INS;
var DEFAULT_HRP = "oasis";
exports.DEFAULT_HRP = DEFAULT_HRP;
var PAYLOAD_TYPE = {
    INIT: 0x00,
    ADD: 0x01,
    LAST: 0x02
};
exports.PAYLOAD_TYPE = PAYLOAD_TYPE;
var P1_VALUES = {
    ONLY_RETRIEVE: 0x00,
    SHOW_ADDRESS_IN_DEVICE: 0x01
};
exports.P1_VALUES = P1_VALUES;
var ERROR_DESCRIPTION = {
    1: "U2F: Unknown",
    2: "U2F: Bad request",
    3: "U2F: Configuration unsupported",
    4: "U2F: Device Ineligible",
    5: "U2F: Timeout",
    14: "Timeout",
    0x9000: "No errors",
    0x9001: "Device is busy",
    0x6802: "Error deriving keys",
    0x6400: "Execution Error",
    0x6700: "Wrong Length",
    0x6982: "Empty Buffer",
    0x6983: "Output buffer too small",
    0x6984: "Data is invalid",
    0x6985: "Conditions not satisfied",
    0x6986: "Transaction rejected",
    0x6a80: "Bad key handle",
    0x6b00: "Invalid P1/P2",
    0x6d00: "Instruction not supported",
    0x6e00: "Oasis app does not seem to be open",
    0x6f00: "Unknown error",
    0x6f01: "Sign/verify error"
};
/** @returns {string} */ function errorCodeToString(statusCode) {
    if (statusCode in ERROR_DESCRIPTION) return ERROR_DESCRIPTION[statusCode];
    return "Unknown Status Code: ".concat(statusCode);
}
/** @param {import('./types').TransportStatusError} response */ function processErrorResponse(response) {
    // Leave non-Ledger errors as they are.
    if (!("statusCode" in response)) throw response;
    return {
        return_code: response.statusCode,
        error_message: errorCodeToString(response.statusCode)
    };
}
/** @param {import('./types').Transport} transport */ function getVersion(_x) {
    return _getVersion.apply(this, arguments);
}
function _getVersion() {
    _getVersion = (0, _asyncToGenerator2.default)(/*#__PURE__*/ _regenerator.default.mark(function _callee(transport) {
        return _regenerator.default.wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    return _context.abrupt("return", transport.send(CLA, INS.GET_VERSION, 0, 0).then(function(response) {
                        var errorCodeData = response.slice(-2);
                        var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                        var targetId = 0;
                        if (response.length >= 9) /* eslint-disable no-bitwise */ targetId = (response[5] << 24) + (response[6] << 16) + (response[7] << 8) + (response[8] << 0);
                        return {
                            return_code: returnCode,
                            error_message: errorCodeToString(returnCode),
                            // ///
                            test_mode: response[0] !== 0,
                            major: response[1],
                            minor: response[2],
                            patch: response[3],
                            device_locked: response[4] === 1,
                            target_id: targetId.toString(16)
                        };
                    }, processErrorResponse));
                case 1:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return _getVersion.apply(this, arguments);
}

},{"646da52c282fb6ca":"lVzA4","3cdb4331570cf001":"2OHgN","29f1d6ef092edb98":"b7d89"}],"b0U5N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WalletType", ()=>WalletType);
var WalletType = /*#__PURE__*/ function(WalletType) {
    WalletType["UsbLedger"] = "ledger";
    WalletType["BleLedger"] = "ble_ledger";
    WalletType["PrivateKey"] = "private_key";
    WalletType["Mnemonic"] = "mnemonic";
    return WalletType;
}({});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"l4CqL":[function(require,module,exports,__globalThis) {
var Buffer = require("c49fa2a32150fc44").Buffer;
var global = arguments[3];
"use strict";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var _a;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.monitorCharacteristic = void 0;
const hw_transport_1 = __importDefault(require("34706c862d7b5a1d"));
const bluetooth_le_1 = require("3442207cfebb2fe3");
const sendAPDU_1 = require("bc78d662537d357f");
const receiveAPDU_1 = require("9f511d522dff6726");
const devices_1 = require("ce7b32a84fa69f85");
const logs_1 = require("32c5831cb958f91b");
const rxjs_1 = require("9eb2fad55404cfe5");
const operators_1 = require("4004a4a4ae24460a");
const errors_1 = require("ea78038e512eac91");
const TAG = "ble-verbose";
const monitorCharacteristic = (deviceId, service, characteristic)=>{
    (0, logs_1.log)("ble-verbose", "start monitor " + service);
    return new rxjs_1.Observable((subscriber)=>{
        bluetooth_le_1.BleClient.startNotifications(deviceId, service, characteristic, (rawData)=>{
            const value = Buffer.from(rawData.buffer, rawData.byteOffset, rawData.byteLength);
            subscriber.next(value);
        });
        return ()=>__awaiter(void 0, void 0, void 0, function*() {
                yield bluetooth_le_1.BleClient.stopNotifications(deviceId, service, characteristic);
            });
    });
};
exports.monitorCharacteristic = monitorCharacteristic;
const transportsCache = {};
let _bleClient = null;
const bleInstance = ()=>{
    if (!_bleClient) {
        bluetooth_le_1.BleClient.initialize({
            androidNeverForLocation: true
        });
        _bleClient = bluetooth_le_1.BleClient;
    }
    return _bleClient;
};
const clearDisconnectTimeout = (deviceId)=>{
    const cachedTransport = transportsCache[deviceId];
    if (cachedTransport && cachedTransport.disconnectTimeout) {
        (0, logs_1.log)(TAG, "Clearing queued disconnect");
        clearTimeout(cachedTransport.disconnectTimeout);
    }
};
const open = (scanResult)=>__awaiter(void 0, void 0, void 0, function*() {
        (0, logs_1.log)(TAG, `Tries to open device: ${scanResult}`);
        const closedSubscription = new rxjs_1.Subject();
        try {
            (0, logs_1.log)(TAG, `connectToDevice(${scanResult})`);
            yield BleTransport.connect(scanResult.device.deviceId, ()=>{
                closedSubscription.next();
            });
        } catch (error) {
            (0, logs_1.log)(TAG, `error code ${String(error)}`);
            throw new errors_1.CantOpenDevice();
        }
        let bluetoothInfos;
        let characteristics = [];
        for (const uuid of (0, devices_1.getBluetoothServiceUuids)())if (scanResult.uuids) {
            const peripheralCharacteristic = scanResult.uuids.filter((service)=>service === uuid);
            if (peripheralCharacteristic.length) {
                characteristics.push(...peripheralCharacteristic);
                bluetoothInfos = (0, devices_1.getInfosForServiceUuid)(uuid);
                break;
            }
        }
        if (!bluetoothInfos) throw new errors_1.TransportError("service not found", "BLEServiceNotFound");
        const { deviceModel, serviceUuid, writeUuid, writeCmdUuid, notifyUuid } = bluetoothInfos;
        if (!characteristics) {
            if (scanResult.uuids) {
                const characteristic = scanResult.uuids.find((uuid)=>uuid === serviceUuid);
                if (characteristic) characteristics = [
                    characteristic
                ];
            }
        }
        if (!characteristics.length) throw new errors_1.TransportError("service not found", "BLEServiceNotFound");
        if (!writeUuid) throw new errors_1.TransportError("write characteristic not found", "BLECharacteristicNotFound");
        if (!notifyUuid) throw new errors_1.TransportError("notify characteristic not found", "BLECharacteristicNotFound");
        if (!writeUuid) throw new errors_1.TransportError("write cmd characteristic not found", "BLECharacteristicInvalid");
        const notifyObservable = (0, exports.monitorCharacteristic)(scanResult.device.deviceId, serviceUuid, notifyUuid).pipe((0, operators_1.share)());
        const notifySubscription = notifyObservable.subscribe();
        const transport = new BleTransport(scanResult, writeUuid, writeCmdUuid, notifyObservable, deviceModel, bluetoothInfos);
        closedSubscription.pipe((0, operators_1.first)(), (0, operators_1.tap)(()=>{
            transport.isConnected = false;
            notifySubscription.unsubscribe();
            clearDisconnectTimeout(transport.id);
            delete transportsCache[transport.id];
            (0, logs_1.log)(TAG, `BleTransport(${transport.id}) disconnected`);
            transport.emit("disconnect");
        })).subscribe();
        transportsCache[transport.id] = transport;
        yield transport.inferMTU();
        return transport;
    });
/**
 * Ionic bluetooth BLE implementation
 */ class BleTransport extends hw_transport_1.default {
    static open(scanResult) {
        return __awaiter(this, void 0, void 0, function*() {
            return open(scanResult);
        });
    }
    constructor(device, writeCharacteristic, writeCmdCharacteristic, notifyObservable, deviceModel, bluetoothInfos){
        super();
        this.disconnectTimeout = null;
        this.isConnected = true;
        this.mtuSize = 20;
        /**
         * Send data to the device using a low level API.
         * It's recommended to use the "send" method for a higher level API.
         * @param {Buffer} apdu - The data to send.
         * @returns {Promise<Buffer>} A promise that resolves with the response data from the device.
         */ this.exchange = (apdu)=>__awaiter(this, void 0, void 0, function*() {
                if (!this.isConnected) throw new errors_1.DisconnectedDeviceDuringOperation("Device not connected");
                return this.exchangeAtomicImpl(()=>__awaiter(this, void 0, void 0, function*() {
                        try {
                            const msgIn = apdu.toString("hex");
                            (0, logs_1.log)("apdu", `=> ${msgIn}`);
                            const dataObservable = (0, rxjs_1.merge)(this.notifyObservable.pipe(receiveAPDU_1.receiveAPDU), (0, sendAPDU_1.sendAPDU)(this.write, apdu, this.mtuSize));
                            const data = yield (0, rxjs_1.firstValueFrom)(dataObservable);
                            if (!data) throw new Error("Received data is undefined");
                            const msgOut = data.toString("hex");
                            (0, logs_1.log)("apdu", `<= ${msgOut}`);
                            return data;
                        } catch (e) {
                            (0, logs_1.log)("ble-error", "exchange got " + String(e));
                        }
                    }));
            });
        /**
         * Do not call this directly unless you know what you're doing. Communication
         * with a Ledger device should be through the {@link exchange} method.
         * @param buffer
         */ this.write = (buffer)=>__awaiter(this, void 0, void 0, function*() {
                (0, logs_1.log)("ble-frame", "=> " + buffer.toString("hex"));
                if (this.writeCmdCharacteristic) try {
                    const data = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
                    return yield bleInstance().writeWithoutResponse(this.device.device.deviceId, this.bluetoothInfos.serviceUuid, this.bluetoothInfos.writeCmdUuid, data);
                } catch (e) {
                    throw new errors_1.DisconnectedDeviceDuringOperation(String(e));
                }
                else try {
                    const data = new DataView(buffer.buffer, buffer.byteOffset, buffer.byteLength);
                    return yield bleInstance().write(this.device.device.deviceId, this.bluetoothInfos.serviceUuid, this.bluetoothInfos.writeUuid, data);
                } catch (e) {
                    throw new errors_1.DisconnectedDeviceDuringOperation(String(e));
                }
            });
        this.id = device.device.deviceId;
        this.device = device;
        this.writeCharacteristic = writeCharacteristic;
        this.writeCmdCharacteristic = writeCmdCharacteristic;
        this.notifyObservable = notifyObservable;
        this.deviceModel = deviceModel;
        this.bluetoothInfos = bluetoothInfos;
        (0, logs_1.log)(TAG, `BLE(${String(this.id)}) new instance`);
        clearDisconnectTimeout(this.id);
    }
    /**
     * Negotiate with the device the maximum transfer unit for the ble frames
     * @returns Promise<number>
     */ inferMTU() {
        return __awaiter(this, void 0, void 0, function*() {
            let mtu = this.mtuSize;
            yield this.exchangeAtomicImpl(()=>__awaiter(this, void 0, void 0, function*() {
                    try {
                        const mtuObservable = (0, rxjs_1.merge)(this.notifyObservable.pipe((0, operators_1.tap)((maybeError)=>{
                            if (maybeError instanceof Error) throw maybeError;
                        }), (0, operators_1.first)((buffer)=>buffer.readUInt8(0) === 0x08), (0, operators_1.map)((buffer)=>buffer.readUInt8(5))), (0, rxjs_1.defer)(()=>(0, rxjs_1.from)(this.write(Buffer.from([
                                0x08,
                                0,
                                0,
                                0,
                                0
                            ])))).pipe((0, operators_1.ignoreElements)()));
                        mtu = yield (0, rxjs_1.firstValueFrom)(mtuObservable);
                        if (mtu === undefined) throw new Error("MTU negotiation failed, received undefined");
                    } catch (e) {
                        (0, logs_1.log)("ble-error", "inferMTU got " + JSON.stringify(e));
                        try {
                            yield bleInstance().disconnect(this.device.device.deviceId);
                        } catch (ex) {
                        // Ignore error
                        }
                        throw e;
                    }
                }));
            if (mtu > 20) {
                this.mtuSize = mtu;
                (0, logs_1.log)(TAG, `BleTransport(${this.id}) mtu set to ${this.mtuSize}`);
            }
            return this.mtuSize;
        });
    }
    /**
     * We intentionally do not immediately close a transport connection.
     * Instead, we queue the disconnect and wait for a future connection to dismiss the event.
     * This approach prevents unnecessary disconnects and reconnects. We use the isConnected
     * flag to ensure that we do not trigger a disconnect if the current cached transport has
     * already been disconnected.
     * @returns {Promise<void>}
     */ close() {
        return __awaiter(this, void 0, void 0, function*() {
            let resolve;
            const disconnectPromise = new Promise((innerResolve)=>{
                resolve = innerResolve;
            });
            clearDisconnectTimeout(this.id);
            (0, logs_1.log)(TAG, "Queuing a disconnect");
            this.disconnectTimeout = global.setTimeout(()=>__awaiter(this, void 0, void 0, function*() {
                    (0, logs_1.log)(TAG, `Triggering a disconnect from ${this.id}`);
                    if (this.isConnected) try {
                        yield BleTransport.disconnect(this.id);
                    } finally{
                        resolve();
                    }
                    else resolve();
                }), BleTransport.disconnectTimeoutMs);
            // The closure will occur no later than 5s, triggered either by disconnection
            // or the actual response of the apdu.
            yield Promise.race([
                this.exchangeBusyPromise || Promise.resolve(),
                disconnectPromise
            ]);
            return;
        });
    }
}
_a = BleTransport;
BleTransport.disconnectTimeoutMs = 5000;
BleTransport.isSupported = ()=>Promise.resolve(typeof bluetooth_le_1.BleClient === "object");
BleTransport.isEnabled = ()=>bleInstance().isEnabled();
BleTransport.connect = (deviceId, onDisconnect)=>{
    return bleInstance().connect(deviceId, onDisconnect);
};
BleTransport.list = (stopScanTimeout = BleTransport.disconnectTimeoutMs)=>{
    let devices = [];
    return new Promise((resolve, reject)=>{
        bleInstance().requestLEScan({
            services: (0, devices_1.getBluetoothServiceUuids)()
        }, (data)=>{
            devices = [
                ...devices.filter((prevDevice)=>prevDevice.device.deviceId !== data.device.deviceId),
                data
            ];
        });
        setTimeout(()=>__awaiter(void 0, void 0, void 0, function*() {
                yield bleInstance().stopLEScan();
                try {
                    (0, logs_1.log)(TAG, 'BLE scan complete');
                    resolve(devices);
                } catch (err) {
                    (0, logs_1.log)(TAG, 'BLE scan failed');
                    reject(err);
                }
            }), stopScanTimeout);
    });
};
/**
 * Exposed method from the @capacitor-community/bluetooth-le library
 * Disconnects from {@link ScanResult} if it's connected or cancels pending connection.
 */ BleTransport.disconnect = (id)=>__awaiter(void 0, void 0, void 0, function*() {
        (0, logs_1.log)(TAG, `user disconnect(${id})`);
        yield bleInstance().disconnect(id);
        (0, logs_1.log)(TAG, "disconnected");
    });
exports.default = BleTransport;

},{"c49fa2a32150fc44":"eXvXD","34706c862d7b5a1d":"4g6bl","3442207cfebb2fe3":"atp5h","bc78d662537d357f":"gryeB","9f511d522dff6726":"2kBSB","ce7b32a84fa69f85":"j8MQh","32c5831cb958f91b":"2hpLA","9eb2fad55404cfe5":"had2o","4004a4a4ae24460a":"b21MU","ea78038e512eac91":"7T5AD"}],"atp5h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _definitions = require("./definitions");
parcelHelpers.exportAll(_definitions, exports);
var _bleClient = require("./bleClient");
parcelHelpers.exportAll(_bleClient, exports);
var _conversion = require("./conversion");
parcelHelpers.exportAll(_conversion, exports);
var _plugin = require("./plugin");
parcelHelpers.exportAll(_plugin, exports);
var _config = require("./config");
parcelHelpers.exportAll(_config, exports);

},{"./definitions":"6W7A2","./bleClient":"189OK","./conversion":"yAHyt","./plugin":"13kUf","./config":"6x2Vi","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6W7A2":[function(require,module,exports,__globalThis) {
/**
 * Android scan mode
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScanMode", ()=>ScanMode);
parcelHelpers.export(exports, "ConnectionPriority", ()=>ConnectionPriority);
var ScanMode;
(function(ScanMode) {
    /**
     * Perform Bluetooth LE scan in low power mode. This mode is enforced if the scanning application is not in foreground.
     * https://developer.android.com/reference/android/bluetooth/le/ScanSettings#SCAN_MODE_LOW_POWER
     */ ScanMode[ScanMode["SCAN_MODE_LOW_POWER"] = 0] = "SCAN_MODE_LOW_POWER";
    /**
     * Perform Bluetooth LE scan in balanced power mode. (default) Scan results are returned at a rate that provides a good trade-off between scan frequency and power consumption.
     * https://developer.android.com/reference/android/bluetooth/le/ScanSettings#SCAN_MODE_BALANCED
     */ ScanMode[ScanMode["SCAN_MODE_BALANCED"] = 1] = "SCAN_MODE_BALANCED";
    /**
     * Scan using highest duty cycle. It's recommended to only use this mode when the application is running in the foreground.
     * https://developer.android.com/reference/android/bluetooth/le/ScanSettings#SCAN_MODE_LOW_LATENCY
     */ ScanMode[ScanMode["SCAN_MODE_LOW_LATENCY"] = 2] = "SCAN_MODE_LOW_LATENCY";
})(ScanMode || (ScanMode = {}));
var ConnectionPriority;
(function(ConnectionPriority) {
    /**
     * Use the connection parameters recommended by the Bluetooth SIG. This is the default value if no connection parameter update is requested.
     * https://developer.android.com/reference/android/bluetooth/BluetoothGatt#CONNECTION_PRIORITY_BALANCED
     */ ConnectionPriority[ConnectionPriority["CONNECTION_PRIORITY_BALANCED"] = 0] = "CONNECTION_PRIORITY_BALANCED";
    /**
     * Request a high priority, low latency connection. An application should only request high priority connection parameters to transfer large amounts of data over LE quickly. Once the transfer is complete, the application should request CONNECTION_PRIORITY_BALANCED connection parameters to reduce energy use.
     * https://developer.android.com/reference/android/bluetooth/BluetoothGatt#CONNECTION_PRIORITY_HIGH
     */ ConnectionPriority[ConnectionPriority["CONNECTION_PRIORITY_HIGH"] = 1] = "CONNECTION_PRIORITY_HIGH";
    /**
     * Request low power, reduced data rate connection parameters.
     * https://developer.android.com/reference/android/bluetooth/BluetoothGatt#CONNECTION_PRIORITY_LOW_POWER
     */ ConnectionPriority[ConnectionPriority["CONNECTION_PRIORITY_LOW_POWER"] = 2] = "CONNECTION_PRIORITY_LOW_POWER";
})(ConnectionPriority || (ConnectionPriority = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"189OK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BleClient", ()=>BleClient);
var _core = require("@capacitor/core");
var _conversion = require("./conversion");
var _plugin = require("./plugin");
var _queue = require("./queue");
var _validators = require("./validators");
class BleClientClass {
    constructor(){
        this.scanListener = null;
        this.eventListeners = new Map();
        this.queue = (0, _queue.getQueue)(true);
    }
    enableQueue() {
        this.queue = (0, _queue.getQueue)(true);
    }
    disableQueue() {
        this.queue = (0, _queue.getQueue)(false);
    }
    async initialize(options) {
        await this.queue(async ()=>{
            await (0, _plugin.BluetoothLe).initialize(options);
        });
    }
    async isEnabled() {
        const enabled = await this.queue(async ()=>{
            const result = await (0, _plugin.BluetoothLe).isEnabled();
            return result.value;
        });
        return enabled;
    }
    async requestEnable() {
        await this.queue(async ()=>{
            await (0, _plugin.BluetoothLe).requestEnable();
        });
    }
    async enable() {
        await this.queue(async ()=>{
            await (0, _plugin.BluetoothLe).enable();
        });
    }
    async disable() {
        await this.queue(async ()=>{
            await (0, _plugin.BluetoothLe).disable();
        });
    }
    async startEnabledNotifications(callback) {
        await this.queue(async ()=>{
            var _a;
            const key = `onEnabledChanged`;
            await ((_a = this.eventListeners.get(key)) === null || _a === void 0 ? void 0 : _a.remove());
            const listener = await (0, _plugin.BluetoothLe).addListener(key, (result)=>{
                callback(result.value);
            });
            this.eventListeners.set(key, listener);
            await (0, _plugin.BluetoothLe).startEnabledNotifications();
        });
    }
    async stopEnabledNotifications() {
        await this.queue(async ()=>{
            var _a;
            const key = `onEnabledChanged`;
            await ((_a = this.eventListeners.get(key)) === null || _a === void 0 ? void 0 : _a.remove());
            this.eventListeners.delete(key);
            await (0, _plugin.BluetoothLe).stopEnabledNotifications();
        });
    }
    async isLocationEnabled() {
        const enabled = await this.queue(async ()=>{
            const result = await (0, _plugin.BluetoothLe).isLocationEnabled();
            return result.value;
        });
        return enabled;
    }
    async openLocationSettings() {
        await this.queue(async ()=>{
            await (0, _plugin.BluetoothLe).openLocationSettings();
        });
    }
    async openBluetoothSettings() {
        await this.queue(async ()=>{
            await (0, _plugin.BluetoothLe).openBluetoothSettings();
        });
    }
    async openAppSettings() {
        await this.queue(async ()=>{
            await (0, _plugin.BluetoothLe).openAppSettings();
        });
    }
    async setDisplayStrings(displayStrings) {
        await this.queue(async ()=>{
            await (0, _plugin.BluetoothLe).setDisplayStrings(displayStrings);
        });
    }
    async requestDevice(options) {
        options = options ? this.validateRequestBleDeviceOptions(options) : undefined;
        const result = await this.queue(async ()=>{
            const device = await (0, _plugin.BluetoothLe).requestDevice(options);
            return device;
        });
        return result;
    }
    async requestLEScan(options, callback) {
        options = this.validateRequestBleDeviceOptions(options);
        await this.queue(async ()=>{
            var _a;
            await ((_a = this.scanListener) === null || _a === void 0 ? void 0 : _a.remove());
            this.scanListener = await (0, _plugin.BluetoothLe).addListener('onScanResult', (resultInternal)=>{
                const result = Object.assign(Object.assign({}, resultInternal), {
                    manufacturerData: this.convertObject(resultInternal.manufacturerData),
                    serviceData: this.convertObject(resultInternal.serviceData),
                    rawAdvertisement: resultInternal.rawAdvertisement ? this.convertValue(resultInternal.rawAdvertisement) : undefined
                });
                callback(result);
            });
            await (0, _plugin.BluetoothLe).requestLEScan(options);
        });
    }
    async stopLEScan() {
        await this.queue(async ()=>{
            var _a;
            await ((_a = this.scanListener) === null || _a === void 0 ? void 0 : _a.remove());
            this.scanListener = null;
            await (0, _plugin.BluetoothLe).stopLEScan();
        });
    }
    async getDevices(deviceIds) {
        if (!Array.isArray(deviceIds)) throw new Error('deviceIds must be an array');
        return this.queue(async ()=>{
            const result = await (0, _plugin.BluetoothLe).getDevices({
                deviceIds
            });
            return result.devices;
        });
    }
    async getConnectedDevices(services) {
        if (!Array.isArray(services)) throw new Error('services must be an array');
        services = services.map((0, _validators.parseUUID));
        return this.queue(async ()=>{
            const result = await (0, _plugin.BluetoothLe).getConnectedDevices({
                services
            });
            return result.devices;
        });
    }
    async getBondedDevices() {
        return this.queue(async ()=>{
            const result = await (0, _plugin.BluetoothLe).getBondedDevices();
            return result.devices;
        });
    }
    async connect(deviceId, onDisconnect, options) {
        await this.queue(async ()=>{
            var _a;
            if (onDisconnect) {
                const key = `disconnected|${deviceId}`;
                await ((_a = this.eventListeners.get(key)) === null || _a === void 0 ? void 0 : _a.remove());
                const listener = await (0, _plugin.BluetoothLe).addListener(key, ()=>{
                    onDisconnect(deviceId);
                });
                this.eventListeners.set(key, listener);
            }
            await (0, _plugin.BluetoothLe).connect(Object.assign({
                deviceId
            }, options));
        });
    }
    async createBond(deviceId, options) {
        await this.queue(async ()=>{
            await (0, _plugin.BluetoothLe).createBond(Object.assign({
                deviceId
            }, options));
        });
    }
    async isBonded(deviceId) {
        const isBonded = await this.queue(async ()=>{
            const result = await (0, _plugin.BluetoothLe).isBonded({
                deviceId
            });
            return result.value;
        });
        return isBonded;
    }
    async disconnect(deviceId) {
        await this.queue(async ()=>{
            await (0, _plugin.BluetoothLe).disconnect({
                deviceId
            });
        });
    }
    async getServices(deviceId) {
        const services = await this.queue(async ()=>{
            const result = await (0, _plugin.BluetoothLe).getServices({
                deviceId
            });
            return result.services;
        });
        return services;
    }
    async discoverServices(deviceId) {
        await this.queue(async ()=>{
            await (0, _plugin.BluetoothLe).discoverServices({
                deviceId
            });
        });
    }
    async getMtu(deviceId) {
        const value = await this.queue(async ()=>{
            const result = await (0, _plugin.BluetoothLe).getMtu({
                deviceId
            });
            return result.value;
        });
        return value;
    }
    async requestConnectionPriority(deviceId, connectionPriority) {
        await this.queue(async ()=>{
            await (0, _plugin.BluetoothLe).requestConnectionPriority({
                deviceId,
                connectionPriority
            });
        });
    }
    async readRssi(deviceId) {
        const value = await this.queue(async ()=>{
            const result = await (0, _plugin.BluetoothLe).readRssi({
                deviceId
            });
            return parseFloat(result.value);
        });
        return value;
    }
    async read(deviceId, service, characteristic, options) {
        service = (0, _validators.parseUUID)(service);
        characteristic = (0, _validators.parseUUID)(characteristic);
        const value = await this.queue(async ()=>{
            const result = await (0, _plugin.BluetoothLe).read(Object.assign({
                deviceId,
                service,
                characteristic
            }, options));
            return this.convertValue(result.value);
        });
        return value;
    }
    async write(deviceId, service, characteristic, value, options) {
        service = (0, _validators.parseUUID)(service);
        characteristic = (0, _validators.parseUUID)(characteristic);
        return this.queue(async ()=>{
            if (!(value === null || value === void 0 ? void 0 : value.buffer)) throw new Error('Invalid data.');
            let writeValue = value;
            if ((0, _core.Capacitor).getPlatform() !== 'web') // on native we can only write strings
            writeValue = (0, _conversion.dataViewToHexString)(value);
            await (0, _plugin.BluetoothLe).write(Object.assign({
                deviceId,
                service,
                characteristic,
                value: writeValue
            }, options));
        });
    }
    async writeWithoutResponse(deviceId, service, characteristic, value, options) {
        service = (0, _validators.parseUUID)(service);
        characteristic = (0, _validators.parseUUID)(characteristic);
        await this.queue(async ()=>{
            if (!(value === null || value === void 0 ? void 0 : value.buffer)) throw new Error('Invalid data.');
            let writeValue = value;
            if ((0, _core.Capacitor).getPlatform() !== 'web') // on native we can only write strings
            writeValue = (0, _conversion.dataViewToHexString)(value);
            await (0, _plugin.BluetoothLe).writeWithoutResponse(Object.assign({
                deviceId,
                service,
                characteristic,
                value: writeValue
            }, options));
        });
    }
    async readDescriptor(deviceId, service, characteristic, descriptor, options) {
        service = (0, _validators.parseUUID)(service);
        characteristic = (0, _validators.parseUUID)(characteristic);
        descriptor = (0, _validators.parseUUID)(descriptor);
        const value = await this.queue(async ()=>{
            const result = await (0, _plugin.BluetoothLe).readDescriptor(Object.assign({
                deviceId,
                service,
                characteristic,
                descriptor
            }, options));
            return this.convertValue(result.value);
        });
        return value;
    }
    async writeDescriptor(deviceId, service, characteristic, descriptor, value, options) {
        service = (0, _validators.parseUUID)(service);
        characteristic = (0, _validators.parseUUID)(characteristic);
        descriptor = (0, _validators.parseUUID)(descriptor);
        return this.queue(async ()=>{
            if (!(value === null || value === void 0 ? void 0 : value.buffer)) throw new Error('Invalid data.');
            let writeValue = value;
            if ((0, _core.Capacitor).getPlatform() !== 'web') // on native we can only write strings
            writeValue = (0, _conversion.dataViewToHexString)(value);
            await (0, _plugin.BluetoothLe).writeDescriptor(Object.assign({
                deviceId,
                service,
                characteristic,
                descriptor,
                value: writeValue
            }, options));
        });
    }
    async startNotifications(deviceId, service, characteristic, callback, options) {
        service = (0, _validators.parseUUID)(service);
        characteristic = (0, _validators.parseUUID)(characteristic);
        await this.queue(async ()=>{
            var _a;
            const key = `notification|${deviceId}|${service}|${characteristic}`;
            await ((_a = this.eventListeners.get(key)) === null || _a === void 0 ? void 0 : _a.remove());
            const listener = await (0, _plugin.BluetoothLe).addListener(key, (event)=>{
                callback(this.convertValue(event === null || event === void 0 ? void 0 : event.value));
            });
            this.eventListeners.set(key, listener);
            await (0, _plugin.BluetoothLe).startNotifications(Object.assign({
                deviceId,
                service,
                characteristic
            }, options));
        });
    }
    async stopNotifications(deviceId, service, characteristic) {
        service = (0, _validators.parseUUID)(service);
        characteristic = (0, _validators.parseUUID)(characteristic);
        await this.queue(async ()=>{
            var _a;
            const key = `notification|${deviceId}|${service}|${characteristic}`;
            await ((_a = this.eventListeners.get(key)) === null || _a === void 0 ? void 0 : _a.remove());
            this.eventListeners.delete(key);
            await (0, _plugin.BluetoothLe).stopNotifications({
                deviceId,
                service,
                characteristic
            });
        });
    }
    validateRequestBleDeviceOptions(options) {
        if (options.services) options.services = options.services.map((0, _validators.parseUUID));
        if (options.optionalServices) options.optionalServices = options.optionalServices.map((0, _validators.parseUUID));
        return options;
    }
    convertValue(value) {
        if (typeof value === 'string') return (0, _conversion.hexStringToDataView)(value);
        else if (value === undefined) return new DataView(new ArrayBuffer(0));
        return value;
    }
    convertObject(obj) {
        if (obj === undefined) return undefined;
        const result = {};
        for (const key of Object.keys(obj))result[key] = this.convertValue(obj[key]);
        return result;
    }
}
const BleClient = new BleClientClass();

},{"@capacitor/core":"9nVQl","./conversion":"yAHyt","./plugin":"13kUf","./queue":"fF7Dw","./validators":"5L6Sd","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"yAHyt":[function(require,module,exports,__globalThis) {
/**
 * Convert an array of numbers into a DataView.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numbersToDataView", ()=>numbersToDataView);
/**
 * Convert a DataView into an array of numbers.
 */ parcelHelpers.export(exports, "dataViewToNumbers", ()=>dataViewToNumbers);
/**
 * Convert a string into a DataView.
 */ parcelHelpers.export(exports, "textToDataView", ()=>textToDataView);
/**
 * Convert a DataView into a string.
 */ parcelHelpers.export(exports, "dataViewToText", ()=>dataViewToText);
/**
 * Convert a 16 bit UUID into a 128 bit UUID string
 * @param value number, e.g. 0x180d
 * @return string, e.g. '0000180d-0000-1000-8000-00805f9b34fb'
 */ parcelHelpers.export(exports, "numberToUUID", ()=>numberToUUID);
/**
 * Convert a string of hex into a DataView of raw bytes.
 * Note: characters other than [0-9a-fA-F] are ignored
 * @param hex string of values, e.g. "00 01 02" or "000102"
 * @return DataView of raw bytes
 */ parcelHelpers.export(exports, "hexStringToDataView", ()=>hexStringToDataView);
parcelHelpers.export(exports, "dataViewToHexString", ()=>dataViewToHexString);
parcelHelpers.export(exports, "webUUIDToString", ()=>webUUIDToString);
parcelHelpers.export(exports, "mapToObject", ()=>mapToObject);
function numbersToDataView(value) {
    return new DataView(Uint8Array.from(value).buffer);
}
function dataViewToNumbers(value) {
    return Array.from(new Uint8Array(value.buffer, value.byteOffset, value.byteLength));
}
function textToDataView(value) {
    return numbersToDataView(value.split('').map((s)=>s.charCodeAt(0)));
}
function dataViewToText(value) {
    return String.fromCharCode(...dataViewToNumbers(value));
}
function numberToUUID(value) {
    return `0000${value.toString(16).padStart(4, '0')}-0000-1000-8000-00805f9b34fb`;
}
function hexStringToDataView(hex) {
    const bin = [];
    let i, c, isEmpty = 1, buffer = 0;
    for(i = 0; i < hex.length; i++){
        c = hex.charCodeAt(i);
        if (c > 47 && c < 58 || c > 64 && c < 71 || c > 96 && c < 103) {
            buffer = buffer << 4 ^ (c > 64 ? c + 9 : c) & 15;
            if (isEmpty ^= 1) bin.push(buffer & 0xff);
        }
    }
    return numbersToDataView(bin);
}
function dataViewToHexString(value) {
    return dataViewToNumbers(value).map((n)=>{
        let s = n.toString(16);
        if (s.length == 1) s = '0' + s;
        return s;
    }).join('');
}
function webUUIDToString(uuid) {
    if (typeof uuid === 'string') return uuid;
    else if (typeof uuid === 'number') return numberToUUID(uuid);
    else throw new Error('Invalid UUID');
}
function mapToObject(map) {
    const obj = {};
    if (!map) return undefined;
    map.forEach((value, key)=>{
        obj[key.toString()] = value;
    });
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"13kUf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BluetoothLe", ()=>BluetoothLe);
var _core = require("@capacitor/core");
const BluetoothLe = (0, _core.registerPlugin)('BluetoothLe', {
    web: ()=>require("1a9a85c87830f4b1").then((m)=>new m.BluetoothLeWeb())
});

},{"@capacitor/core":"9nVQl","1a9a85c87830f4b1":"7yT9G","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7yT9G":[function(require,module,exports,__globalThis) {
module.exports = require("8bdbc8dc583f656f")(module.bundle.resolve("jq7EE")).then(()=>module.bundle.root('1zCwZ'));

},{"8bdbc8dc583f656f":"bxWlo"}],"fF7Dw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getQueue", ()=>getQueue);
const makeQueue = ()=>{
    let currentTask = Promise.resolve();
    // create a new promise so that errors can be bubbled
    // up to the caller without being caught by the queue
    return (fn)=>new Promise((resolve, reject)=>{
            currentTask = currentTask.then(()=>fn()).then(resolve).catch(reject);
        });
};
function getQueue(enabled) {
    if (enabled) return makeQueue();
    return (fn)=>fn();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5L6Sd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseUUID", ()=>parseUUID);
function parseUUID(uuid) {
    if (typeof uuid !== 'string') throw new Error(`Invalid UUID type ${typeof uuid}. Expected string.`);
    uuid = uuid.toLowerCase();
    const is128BitUuid = uuid.search(/^[0-9a-f]{8}\b-[0-9a-f]{4}\b-[0-9a-f]{4}\b-[0-9a-f]{4}\b-[0-9a-f]{12}$/) >= 0;
    if (!is128BitUuid) throw new Error(`Invalid UUID format ${uuid}. Expected 128 bit string (e.g. "0000180d-0000-1000-8000-00805f9b34fb").`);
    return uuid;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6x2Vi":[function(require,module,exports,__globalThis) {
/// <reference types="@capacitor/cli" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gryeB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sendAPDU", ()=>sendAPDU);
var _rxjs = require("rxjs");
var _logs = require("@ledgerhq/logs");
var Buffer = require("80b5ba593b944efc").Buffer;
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const TagId = 0x05;
/**
 * Creates a list of chunked buffer from one buffer
 *
 * If this is using a Node buffer: the chunked buffers reference to the same memory as the original buffer.
 * If this is using a Uint8Array: each part of the original buffer is copied into the chunked buffers
 *
 * @param buffer a Node Buffer, or a Uint8Array
 * @param sizeForIndex A function that takes an index (on the buffer) and returns the size of the chunk at that index
 * @returns a list of chunked buffers
 */ function createChunkedBuffers(buffer, sizeForIndex) {
    const chunks = [];
    for(let i = 0, size = sizeForIndex(0); i < buffer.length; i += size, size = sizeForIndex(i))// If this is a Node buffer: this chunked buffer points to the same memory but with cropped starting and ending indices
    // `slice` and not `subarray`: this might not be a Node Buffer, but probably only a Uint8Array.
    chunks.push(buffer.slice(i, i + size));
    return chunks;
}
const sendAPDU = (write, apdu, mtuSize, { context } = {})=>{
    // Prepares the data to be sent in chunks, by adding a header to chunked of the APDU
    // The first chunk will contain the total length of the APDU, which reduces the size of the data written in the first chunk.
    // The total length of the APDU is encoded in 2 bytes (so 5 bytes for the header with the tag id and the chunk index).
    const chunks = createChunkedBuffers(apdu, (i)=>mtuSize - (i === 0 ? 5 : 3)).map((buffer, i)=>{
        const head = Buffer.alloc(i === 0 ? 5 : 3);
        head.writeUInt8(TagId, 0);
        // Index of the chunk as the 2 next bytes
        head.writeUInt16BE(i, 1);
        // The total length of the APDU is written on the first chunk
        if (i === 0) head.writeUInt16BE(apdu.length, 3);
        // No 0-padding is needed
        return Buffer.concat([
            head,
            buffer
        ]);
    });
    return new (0, _rxjs.Observable)((o)=>{
        let terminated = false;
        function main() {
            return __awaiter(this, void 0, void 0, function*() {
                for (const chunk of chunks){
                    if (terminated) return;
                    yield write(chunk);
                }
            });
        }
        main().then(()=>{
            terminated = true;
            o.complete();
        }, (error)=>{
            terminated = true;
            (0, _logs.trace)({
                type: "ble-error",
                message: `sendAPDU failure: ${error}`,
                data: {
                    error
                },
                context
            });
            o.error(error);
        });
        const unsubscribe = ()=>{
            if (!terminated) {
                (0, _logs.trace)({
                    type: "ble-error",
                    message: "sendAPDU interruption",
                    context
                });
                terminated = true;
            }
        };
        return unsubscribe;
    });
};

},{"80b5ba593b944efc":"eXvXD","rxjs":"had2o","@ledgerhq/logs":"2hpLA","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"had2o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>(0, _observable.Observable));
parcelHelpers.export(exports, "ConnectableObservable", ()=>(0, _connectableObservable.ConnectableObservable));
parcelHelpers.export(exports, "observable", ()=>(0, _observable1.observable));
parcelHelpers.export(exports, "animationFrames", ()=>(0, _animationFrames.animationFrames));
parcelHelpers.export(exports, "Subject", ()=>(0, _subject.Subject));
parcelHelpers.export(exports, "BehaviorSubject", ()=>(0, _behaviorSubject.BehaviorSubject));
parcelHelpers.export(exports, "ReplaySubject", ()=>(0, _replaySubject.ReplaySubject));
parcelHelpers.export(exports, "AsyncSubject", ()=>(0, _asyncSubject.AsyncSubject));
parcelHelpers.export(exports, "asap", ()=>(0, _asap.asap));
parcelHelpers.export(exports, "asapScheduler", ()=>(0, _asap.asapScheduler));
parcelHelpers.export(exports, "async", ()=>(0, _async.async));
parcelHelpers.export(exports, "asyncScheduler", ()=>(0, _async.asyncScheduler));
parcelHelpers.export(exports, "queue", ()=>(0, _queue.queue));
parcelHelpers.export(exports, "queueScheduler", ()=>(0, _queue.queueScheduler));
parcelHelpers.export(exports, "animationFrame", ()=>(0, _animationFrame.animationFrame));
parcelHelpers.export(exports, "animationFrameScheduler", ()=>(0, _animationFrame.animationFrameScheduler));
parcelHelpers.export(exports, "VirtualTimeScheduler", ()=>(0, _virtualTimeScheduler.VirtualTimeScheduler));
parcelHelpers.export(exports, "VirtualAction", ()=>(0, _virtualTimeScheduler.VirtualAction));
parcelHelpers.export(exports, "Scheduler", ()=>(0, _scheduler.Scheduler));
parcelHelpers.export(exports, "Subscription", ()=>(0, _subscription.Subscription));
parcelHelpers.export(exports, "Subscriber", ()=>(0, _subscriber.Subscriber));
parcelHelpers.export(exports, "Notification", ()=>(0, _notification.Notification));
parcelHelpers.export(exports, "NotificationKind", ()=>(0, _notification.NotificationKind));
parcelHelpers.export(exports, "pipe", ()=>(0, _pipe.pipe));
parcelHelpers.export(exports, "noop", ()=>(0, _noop.noop));
parcelHelpers.export(exports, "identity", ()=>(0, _identity.identity));
parcelHelpers.export(exports, "isObservable", ()=>(0, _isObservable.isObservable));
parcelHelpers.export(exports, "lastValueFrom", ()=>(0, _lastValueFrom.lastValueFrom));
parcelHelpers.export(exports, "firstValueFrom", ()=>(0, _firstValueFrom.firstValueFrom));
parcelHelpers.export(exports, "ArgumentOutOfRangeError", ()=>(0, _argumentOutOfRangeError.ArgumentOutOfRangeError));
parcelHelpers.export(exports, "EmptyError", ()=>(0, _emptyError.EmptyError));
parcelHelpers.export(exports, "NotFoundError", ()=>(0, _notFoundError.NotFoundError));
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>(0, _objectUnsubscribedError.ObjectUnsubscribedError));
parcelHelpers.export(exports, "SequenceError", ()=>(0, _sequenceError.SequenceError));
parcelHelpers.export(exports, "TimeoutError", ()=>(0, _timeout.TimeoutError));
parcelHelpers.export(exports, "UnsubscriptionError", ()=>(0, _unsubscriptionError.UnsubscriptionError));
parcelHelpers.export(exports, "bindCallback", ()=>(0, _bindCallback.bindCallback));
parcelHelpers.export(exports, "bindNodeCallback", ()=>(0, _bindNodeCallback.bindNodeCallback));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "connectable", ()=>(0, _connectable.connectable));
parcelHelpers.export(exports, "defer", ()=>(0, _defer.defer));
parcelHelpers.export(exports, "empty", ()=>(0, _empty.empty));
parcelHelpers.export(exports, "forkJoin", ()=>(0, _forkJoin.forkJoin));
parcelHelpers.export(exports, "from", ()=>(0, _from.from));
parcelHelpers.export(exports, "fromEvent", ()=>(0, _fromEvent.fromEvent));
parcelHelpers.export(exports, "fromEventPattern", ()=>(0, _fromEventPattern.fromEventPattern));
parcelHelpers.export(exports, "generate", ()=>(0, _generate.generate));
parcelHelpers.export(exports, "iif", ()=>(0, _iif.iif));
parcelHelpers.export(exports, "interval", ()=>(0, _interval.interval));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "never", ()=>(0, _never.never));
parcelHelpers.export(exports, "of", ()=>(0, _of.of));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNext.onErrorResumeNext));
parcelHelpers.export(exports, "pairs", ()=>(0, _pairs.pairs));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "range", ()=>(0, _range.range));
parcelHelpers.export(exports, "throwError", ()=>(0, _throwError.throwError));
parcelHelpers.export(exports, "timer", ()=>(0, _timer.timer));
parcelHelpers.export(exports, "using", ()=>(0, _using.using));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "scheduled", ()=>(0, _scheduled.scheduled));
parcelHelpers.export(exports, "EMPTY", ()=>(0, _empty.EMPTY));
parcelHelpers.export(exports, "NEVER", ()=>(0, _never.NEVER));
parcelHelpers.export(exports, "config", ()=>(0, _config.config));
parcelHelpers.export(exports, "audit", ()=>(0, _audit.audit));
parcelHelpers.export(exports, "auditTime", ()=>(0, _auditTime.auditTime));
parcelHelpers.export(exports, "buffer", ()=>(0, _buffer.buffer));
parcelHelpers.export(exports, "bufferCount", ()=>(0, _bufferCount.bufferCount));
parcelHelpers.export(exports, "bufferTime", ()=>(0, _bufferTime.bufferTime));
parcelHelpers.export(exports, "bufferToggle", ()=>(0, _bufferToggle.bufferToggle));
parcelHelpers.export(exports, "bufferWhen", ()=>(0, _bufferWhen.bufferWhen));
parcelHelpers.export(exports, "catchError", ()=>(0, _catchError.catchError));
parcelHelpers.export(exports, "combineAll", ()=>(0, _combineAll.combineAll));
parcelHelpers.export(exports, "combineLatestAll", ()=>(0, _combineLatestAll.combineLatestAll));
parcelHelpers.export(exports, "combineLatestWith", ()=>(0, _combineLatestWith.combineLatestWith));
parcelHelpers.export(exports, "concatAll", ()=>(0, _concatAll.concatAll));
parcelHelpers.export(exports, "concatMap", ()=>(0, _concatMap.concatMap));
parcelHelpers.export(exports, "concatMapTo", ()=>(0, _concatMapTo.concatMapTo));
parcelHelpers.export(exports, "concatWith", ()=>(0, _concatWith.concatWith));
parcelHelpers.export(exports, "connect", ()=>(0, _connect.connect));
parcelHelpers.export(exports, "count", ()=>(0, _count.count));
parcelHelpers.export(exports, "debounce", ()=>(0, _debounce.debounce));
parcelHelpers.export(exports, "debounceTime", ()=>(0, _debounceTime.debounceTime));
parcelHelpers.export(exports, "defaultIfEmpty", ()=>(0, _defaultIfEmpty.defaultIfEmpty));
parcelHelpers.export(exports, "delay", ()=>(0, _delay.delay));
parcelHelpers.export(exports, "delayWhen", ()=>(0, _delayWhen.delayWhen));
parcelHelpers.export(exports, "dematerialize", ()=>(0, _dematerialize.dematerialize));
parcelHelpers.export(exports, "distinct", ()=>(0, _distinct.distinct));
parcelHelpers.export(exports, "distinctUntilChanged", ()=>(0, _distinctUntilChanged.distinctUntilChanged));
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>(0, _distinctUntilKeyChanged.distinctUntilKeyChanged));
parcelHelpers.export(exports, "elementAt", ()=>(0, _elementAt.elementAt));
parcelHelpers.export(exports, "endWith", ()=>(0, _endWith.endWith));
parcelHelpers.export(exports, "every", ()=>(0, _every.every));
parcelHelpers.export(exports, "exhaust", ()=>(0, _exhaust.exhaust));
parcelHelpers.export(exports, "exhaustAll", ()=>(0, _exhaustAll.exhaustAll));
parcelHelpers.export(exports, "exhaustMap", ()=>(0, _exhaustMap.exhaustMap));
parcelHelpers.export(exports, "expand", ()=>(0, _expand.expand));
parcelHelpers.export(exports, "filter", ()=>(0, _filter.filter));
parcelHelpers.export(exports, "finalize", ()=>(0, _finalize.finalize));
parcelHelpers.export(exports, "find", ()=>(0, _find.find));
parcelHelpers.export(exports, "findIndex", ()=>(0, _findIndex.findIndex));
parcelHelpers.export(exports, "first", ()=>(0, _first.first));
parcelHelpers.export(exports, "groupBy", ()=>(0, _groupBy.groupBy));
parcelHelpers.export(exports, "ignoreElements", ()=>(0, _ignoreElements.ignoreElements));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _isEmpty.isEmpty));
parcelHelpers.export(exports, "last", ()=>(0, _last.last));
parcelHelpers.export(exports, "map", ()=>(0, _map.map));
parcelHelpers.export(exports, "mapTo", ()=>(0, _mapTo.mapTo));
parcelHelpers.export(exports, "materialize", ()=>(0, _materialize.materialize));
parcelHelpers.export(exports, "max", ()=>(0, _max.max));
parcelHelpers.export(exports, "mergeAll", ()=>(0, _mergeAll.mergeAll));
parcelHelpers.export(exports, "flatMap", ()=>(0, _flatMap.flatMap));
parcelHelpers.export(exports, "mergeMap", ()=>(0, _mergeMap.mergeMap));
parcelHelpers.export(exports, "mergeMapTo", ()=>(0, _mergeMapTo.mergeMapTo));
parcelHelpers.export(exports, "mergeScan", ()=>(0, _mergeScan.mergeScan));
parcelHelpers.export(exports, "mergeWith", ()=>(0, _mergeWith.mergeWith));
parcelHelpers.export(exports, "min", ()=>(0, _min.min));
parcelHelpers.export(exports, "multicast", ()=>(0, _multicast.multicast));
parcelHelpers.export(exports, "observeOn", ()=>(0, _observeOn.observeOn));
parcelHelpers.export(exports, "onErrorResumeNextWith", ()=>(0, _onErrorResumeNextWith.onErrorResumeNextWith));
parcelHelpers.export(exports, "pairwise", ()=>(0, _pairwise.pairwise));
parcelHelpers.export(exports, "pluck", ()=>(0, _pluck.pluck));
parcelHelpers.export(exports, "publish", ()=>(0, _publish.publish));
parcelHelpers.export(exports, "publishBehavior", ()=>(0, _publishBehavior.publishBehavior));
parcelHelpers.export(exports, "publishLast", ()=>(0, _publishLast.publishLast));
parcelHelpers.export(exports, "publishReplay", ()=>(0, _publishReplay.publishReplay));
parcelHelpers.export(exports, "raceWith", ()=>(0, _raceWith.raceWith));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduce.reduce));
parcelHelpers.export(exports, "repeat", ()=>(0, _repeat.repeat));
parcelHelpers.export(exports, "repeatWhen", ()=>(0, _repeatWhen.repeatWhen));
parcelHelpers.export(exports, "retry", ()=>(0, _retry.retry));
parcelHelpers.export(exports, "retryWhen", ()=>(0, _retryWhen.retryWhen));
parcelHelpers.export(exports, "refCount", ()=>(0, _refCount.refCount));
parcelHelpers.export(exports, "sample", ()=>(0, _sample.sample));
parcelHelpers.export(exports, "sampleTime", ()=>(0, _sampleTime.sampleTime));
parcelHelpers.export(exports, "scan", ()=>(0, _scan.scan));
parcelHelpers.export(exports, "sequenceEqual", ()=>(0, _sequenceEqual.sequenceEqual));
parcelHelpers.export(exports, "share", ()=>(0, _share.share));
parcelHelpers.export(exports, "shareReplay", ()=>(0, _shareReplay.shareReplay));
parcelHelpers.export(exports, "single", ()=>(0, _single.single));
parcelHelpers.export(exports, "skip", ()=>(0, _skip.skip));
parcelHelpers.export(exports, "skipLast", ()=>(0, _skipLast.skipLast));
parcelHelpers.export(exports, "skipUntil", ()=>(0, _skipUntil.skipUntil));
parcelHelpers.export(exports, "skipWhile", ()=>(0, _skipWhile.skipWhile));
parcelHelpers.export(exports, "startWith", ()=>(0, _startWith.startWith));
parcelHelpers.export(exports, "subscribeOn", ()=>(0, _subscribeOn.subscribeOn));
parcelHelpers.export(exports, "switchAll", ()=>(0, _switchAll.switchAll));
parcelHelpers.export(exports, "switchMap", ()=>(0, _switchMap.switchMap));
parcelHelpers.export(exports, "switchMapTo", ()=>(0, _switchMapTo.switchMapTo));
parcelHelpers.export(exports, "switchScan", ()=>(0, _switchScan.switchScan));
parcelHelpers.export(exports, "take", ()=>(0, _take.take));
parcelHelpers.export(exports, "takeLast", ()=>(0, _takeLast.takeLast));
parcelHelpers.export(exports, "takeUntil", ()=>(0, _takeUntil.takeUntil));
parcelHelpers.export(exports, "takeWhile", ()=>(0, _takeWhile.takeWhile));
parcelHelpers.export(exports, "tap", ()=>(0, _tap.tap));
parcelHelpers.export(exports, "throttle", ()=>(0, _throttle.throttle));
parcelHelpers.export(exports, "throttleTime", ()=>(0, _throttleTime.throttleTime));
parcelHelpers.export(exports, "throwIfEmpty", ()=>(0, _throwIfEmpty.throwIfEmpty));
parcelHelpers.export(exports, "timeInterval", ()=>(0, _timeInterval.timeInterval));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeout.timeout));
parcelHelpers.export(exports, "timeoutWith", ()=>(0, _timeoutWith.timeoutWith));
parcelHelpers.export(exports, "timestamp", ()=>(0, _timestamp.timestamp));
parcelHelpers.export(exports, "toArray", ()=>(0, _toArray.toArray));
parcelHelpers.export(exports, "window", ()=>(0, _window.window));
parcelHelpers.export(exports, "windowCount", ()=>(0, _windowCount.windowCount));
parcelHelpers.export(exports, "windowTime", ()=>(0, _windowTime.windowTime));
parcelHelpers.export(exports, "windowToggle", ()=>(0, _windowToggle.windowToggle));
parcelHelpers.export(exports, "windowWhen", ()=>(0, _windowWhen.windowWhen));
parcelHelpers.export(exports, "withLatestFrom", ()=>(0, _withLatestFrom.withLatestFrom));
parcelHelpers.export(exports, "zipAll", ()=>(0, _zipAll.zipAll));
parcelHelpers.export(exports, "zipWith", ()=>(0, _zipWith.zipWith));
var _observable = require("./internal/Observable");
var _connectableObservable = require("./internal/observable/ConnectableObservable");
var _observable1 = require("./internal/symbol/observable");
var _animationFrames = require("./internal/observable/dom/animationFrames");
var _subject = require("./internal/Subject");
var _behaviorSubject = require("./internal/BehaviorSubject");
var _replaySubject = require("./internal/ReplaySubject");
var _asyncSubject = require("./internal/AsyncSubject");
var _asap = require("./internal/scheduler/asap");
var _async = require("./internal/scheduler/async");
var _queue = require("./internal/scheduler/queue");
var _animationFrame = require("./internal/scheduler/animationFrame");
var _virtualTimeScheduler = require("./internal/scheduler/VirtualTimeScheduler");
var _scheduler = require("./internal/Scheduler");
var _subscription = require("./internal/Subscription");
var _subscriber = require("./internal/Subscriber");
var _notification = require("./internal/Notification");
var _pipe = require("./internal/util/pipe");
var _noop = require("./internal/util/noop");
var _identity = require("./internal/util/identity");
var _isObservable = require("./internal/util/isObservable");
var _lastValueFrom = require("./internal/lastValueFrom");
var _firstValueFrom = require("./internal/firstValueFrom");
var _argumentOutOfRangeError = require("./internal/util/ArgumentOutOfRangeError");
var _emptyError = require("./internal/util/EmptyError");
var _notFoundError = require("./internal/util/NotFoundError");
var _objectUnsubscribedError = require("./internal/util/ObjectUnsubscribedError");
var _sequenceError = require("./internal/util/SequenceError");
var _timeout = require("./internal/operators/timeout");
var _unsubscriptionError = require("./internal/util/UnsubscriptionError");
var _bindCallback = require("./internal/observable/bindCallback");
var _bindNodeCallback = require("./internal/observable/bindNodeCallback");
var _combineLatest = require("./internal/observable/combineLatest");
var _concat = require("./internal/observable/concat");
var _connectable = require("./internal/observable/connectable");
var _defer = require("./internal/observable/defer");
var _empty = require("./internal/observable/empty");
var _forkJoin = require("./internal/observable/forkJoin");
var _from = require("./internal/observable/from");
var _fromEvent = require("./internal/observable/fromEvent");
var _fromEventPattern = require("./internal/observable/fromEventPattern");
var _generate = require("./internal/observable/generate");
var _iif = require("./internal/observable/iif");
var _interval = require("./internal/observable/interval");
var _merge = require("./internal/observable/merge");
var _never = require("./internal/observable/never");
var _of = require("./internal/observable/of");
var _onErrorResumeNext = require("./internal/observable/onErrorResumeNext");
var _pairs = require("./internal/observable/pairs");
var _partition = require("./internal/observable/partition");
var _race = require("./internal/observable/race");
var _range = require("./internal/observable/range");
var _throwError = require("./internal/observable/throwError");
var _timer = require("./internal/observable/timer");
var _using = require("./internal/observable/using");
var _zip = require("./internal/observable/zip");
var _scheduled = require("./internal/scheduled/scheduled");
var _types = require("./internal/types");
parcelHelpers.exportAll(_types, exports);
var _config = require("./internal/config");
var _audit = require("./internal/operators/audit");
var _auditTime = require("./internal/operators/auditTime");
var _buffer = require("./internal/operators/buffer");
var _bufferCount = require("./internal/operators/bufferCount");
var _bufferTime = require("./internal/operators/bufferTime");
var _bufferToggle = require("./internal/operators/bufferToggle");
var _bufferWhen = require("./internal/operators/bufferWhen");
var _catchError = require("./internal/operators/catchError");
var _combineAll = require("./internal/operators/combineAll");
var _combineLatestAll = require("./internal/operators/combineLatestAll");
var _combineLatestWith = require("./internal/operators/combineLatestWith");
var _concatAll = require("./internal/operators/concatAll");
var _concatMap = require("./internal/operators/concatMap");
var _concatMapTo = require("./internal/operators/concatMapTo");
var _concatWith = require("./internal/operators/concatWith");
var _connect = require("./internal/operators/connect");
var _count = require("./internal/operators/count");
var _debounce = require("./internal/operators/debounce");
var _debounceTime = require("./internal/operators/debounceTime");
var _defaultIfEmpty = require("./internal/operators/defaultIfEmpty");
var _delay = require("./internal/operators/delay");
var _delayWhen = require("./internal/operators/delayWhen");
var _dematerialize = require("./internal/operators/dematerialize");
var _distinct = require("./internal/operators/distinct");
var _distinctUntilChanged = require("./internal/operators/distinctUntilChanged");
var _distinctUntilKeyChanged = require("./internal/operators/distinctUntilKeyChanged");
var _elementAt = require("./internal/operators/elementAt");
var _endWith = require("./internal/operators/endWith");
var _every = require("./internal/operators/every");
var _exhaust = require("./internal/operators/exhaust");
var _exhaustAll = require("./internal/operators/exhaustAll");
var _exhaustMap = require("./internal/operators/exhaustMap");
var _expand = require("./internal/operators/expand");
var _filter = require("./internal/operators/filter");
var _finalize = require("./internal/operators/finalize");
var _find = require("./internal/operators/find");
var _findIndex = require("./internal/operators/findIndex");
var _first = require("./internal/operators/first");
var _groupBy = require("./internal/operators/groupBy");
var _ignoreElements = require("./internal/operators/ignoreElements");
var _isEmpty = require("./internal/operators/isEmpty");
var _last = require("./internal/operators/last");
var _map = require("./internal/operators/map");
var _mapTo = require("./internal/operators/mapTo");
var _materialize = require("./internal/operators/materialize");
var _max = require("./internal/operators/max");
var _mergeAll = require("./internal/operators/mergeAll");
var _flatMap = require("./internal/operators/flatMap");
var _mergeMap = require("./internal/operators/mergeMap");
var _mergeMapTo = require("./internal/operators/mergeMapTo");
var _mergeScan = require("./internal/operators/mergeScan");
var _mergeWith = require("./internal/operators/mergeWith");
var _min = require("./internal/operators/min");
var _multicast = require("./internal/operators/multicast");
var _observeOn = require("./internal/operators/observeOn");
var _onErrorResumeNextWith = require("./internal/operators/onErrorResumeNextWith");
var _pairwise = require("./internal/operators/pairwise");
var _pluck = require("./internal/operators/pluck");
var _publish = require("./internal/operators/publish");
var _publishBehavior = require("./internal/operators/publishBehavior");
var _publishLast = require("./internal/operators/publishLast");
var _publishReplay = require("./internal/operators/publishReplay");
var _raceWith = require("./internal/operators/raceWith");
var _reduce = require("./internal/operators/reduce");
var _repeat = require("./internal/operators/repeat");
var _repeatWhen = require("./internal/operators/repeatWhen");
var _retry = require("./internal/operators/retry");
var _retryWhen = require("./internal/operators/retryWhen");
var _refCount = require("./internal/operators/refCount");
var _sample = require("./internal/operators/sample");
var _sampleTime = require("./internal/operators/sampleTime");
var _scan = require("./internal/operators/scan");
var _sequenceEqual = require("./internal/operators/sequenceEqual");
var _share = require("./internal/operators/share");
var _shareReplay = require("./internal/operators/shareReplay");
var _single = require("./internal/operators/single");
var _skip = require("./internal/operators/skip");
var _skipLast = require("./internal/operators/skipLast");
var _skipUntil = require("./internal/operators/skipUntil");
var _skipWhile = require("./internal/operators/skipWhile");
var _startWith = require("./internal/operators/startWith");
var _subscribeOn = require("./internal/operators/subscribeOn");
var _switchAll = require("./internal/operators/switchAll");
var _switchMap = require("./internal/operators/switchMap");
var _switchMapTo = require("./internal/operators/switchMapTo");
var _switchScan = require("./internal/operators/switchScan");
var _take = require("./internal/operators/take");
var _takeLast = require("./internal/operators/takeLast");
var _takeUntil = require("./internal/operators/takeUntil");
var _takeWhile = require("./internal/operators/takeWhile");
var _tap = require("./internal/operators/tap");
var _throttle = require("./internal/operators/throttle");
var _throttleTime = require("./internal/operators/throttleTime");
var _throwIfEmpty = require("./internal/operators/throwIfEmpty");
var _timeInterval = require("./internal/operators/timeInterval");
var _timeoutWith = require("./internal/operators/timeoutWith");
var _timestamp = require("./internal/operators/timestamp");
var _toArray = require("./internal/operators/toArray");
var _window = require("./internal/operators/window");
var _windowCount = require("./internal/operators/windowCount");
var _windowTime = require("./internal/operators/windowTime");
var _windowToggle = require("./internal/operators/windowToggle");
var _windowWhen = require("./internal/operators/windowWhen");
var _withLatestFrom = require("./internal/operators/withLatestFrom");
var _zipAll = require("./internal/operators/zipAll");
var _zipWith = require("./internal/operators/zipWith");

},{"./internal/Observable":"jrGyK","./internal/observable/ConnectableObservable":"kYoRv","./internal/symbol/observable":"7NSqh","./internal/observable/dom/animationFrames":"2QK3H","./internal/Subject":"4Icpn","./internal/BehaviorSubject":"cMDx8","./internal/ReplaySubject":"hpUH1","./internal/AsyncSubject":"6p0u8","./internal/scheduler/asap":"8q2VM","./internal/scheduler/async":"fZcBE","./internal/scheduler/queue":"k88In","./internal/scheduler/animationFrame":"2NZsb","./internal/scheduler/VirtualTimeScheduler":"16km3","./internal/Scheduler":"gLsi1","./internal/Subscription":"iuJZ4","./internal/Subscriber":"c8fGB","./internal/Notification":"46g2P","./internal/util/pipe":"1ZGFK","./internal/util/noop":"bmpBW","./internal/util/identity":"2CmIP","./internal/util/isObservable":"iGTcd","./internal/lastValueFrom":"3sHJf","./internal/firstValueFrom":"01hrx","./internal/util/ArgumentOutOfRangeError":"1Vgkw","./internal/util/EmptyError":"Cu2oV","./internal/util/NotFoundError":"LNpui","./internal/util/ObjectUnsubscribedError":"9Z7qV","./internal/util/SequenceError":"jNLLd","./internal/operators/timeout":"d6r3h","./internal/util/UnsubscriptionError":"hJmDs","./internal/observable/bindCallback":"lpND8","./internal/observable/bindNodeCallback":"9Vyj2","./internal/observable/combineLatest":"6HhEz","./internal/observable/concat":"a3Gor","./internal/observable/connectable":"5Zxgo","./internal/observable/defer":"jrwvq","./internal/observable/empty":"tKukk","./internal/observable/forkJoin":"ebE61","./internal/observable/from":"hSPWH","./internal/observable/fromEvent":"hw20y","./internal/observable/fromEventPattern":"lgInP","./internal/observable/generate":"imCMc","./internal/observable/iif":"c2dFs","./internal/observable/interval":"ex0hC","./internal/observable/merge":"5Ayeg","./internal/observable/never":"hLtGt","./internal/observable/of":"cH8fx","./internal/observable/onErrorResumeNext":"bJQtP","./internal/observable/pairs":"bXikl","./internal/observable/partition":"42MUk","./internal/observable/race":"024Zl","./internal/observable/range":"21yES","./internal/observable/throwError":"hryQb","./internal/observable/timer":"bUIVF","./internal/observable/using":"9FOQn","./internal/observable/zip":"er6av","./internal/scheduled/scheduled":"eiqdN","./internal/types":"bu2bz","./internal/config":"fnJOC","./internal/operators/audit":"daTGs","./internal/operators/auditTime":"gDfyR","./internal/operators/buffer":"dVnzm","./internal/operators/bufferCount":"2SWMG","./internal/operators/bufferTime":"9VQL7","./internal/operators/bufferToggle":"bZtzK","./internal/operators/bufferWhen":"CfKBQ","./internal/operators/catchError":"j7N3U","./internal/operators/combineAll":"1lMLg","./internal/operators/combineLatestAll":"h2M72","./internal/operators/combineLatestWith":"bj420","./internal/operators/concatAll":"7HZAl","./internal/operators/concatMap":"5uG7j","./internal/operators/concatMapTo":"cw85e","./internal/operators/concatWith":"brG7g","./internal/operators/connect":"6NlD1","./internal/operators/count":"5uqKy","./internal/operators/debounce":"e2TQl","./internal/operators/debounceTime":"a3jha","./internal/operators/defaultIfEmpty":"5xf0S","./internal/operators/delay":"fSMvT","./internal/operators/delayWhen":"96Cih","./internal/operators/dematerialize":"5V8Z3","./internal/operators/distinct":"hwb2B","./internal/operators/distinctUntilChanged":"cttga","./internal/operators/distinctUntilKeyChanged":"9BKLM","./internal/operators/elementAt":"bOBBu","./internal/operators/endWith":"fx8gJ","./internal/operators/every":"c5eHD","./internal/operators/exhaust":"2SUOw","./internal/operators/exhaustAll":"l7Zrp","./internal/operators/exhaustMap":"kstpi","./internal/operators/expand":"2ALAW","./internal/operators/filter":"5uWPs","./internal/operators/finalize":"81pRQ","./internal/operators/find":"h3LwP","./internal/operators/findIndex":"9cmYI","./internal/operators/first":"3wDHa","./internal/operators/groupBy":"hx2TZ","./internal/operators/ignoreElements":"9axK3","./internal/operators/isEmpty":"1QgiI","./internal/operators/last":"4fDgS","./internal/operators/map":"axudj","./internal/operators/mapTo":"811pe","./internal/operators/materialize":"bfk5y","./internal/operators/max":"cTEAZ","./internal/operators/mergeAll":"74yhD","./internal/operators/flatMap":"L6jye","./internal/operators/mergeMap":"ehxC3","./internal/operators/mergeMapTo":"l9u0a","./internal/operators/mergeScan":"ko59c","./internal/operators/mergeWith":"cbWWZ","./internal/operators/min":"cVBv7","./internal/operators/multicast":"jhjD3","./internal/operators/observeOn":"0Qy0C","./internal/operators/onErrorResumeNextWith":"8dj7U","./internal/operators/pairwise":"24DPj","./internal/operators/pluck":"iO80A","./internal/operators/publish":"diZb6","./internal/operators/publishBehavior":"e5QSX","./internal/operators/publishLast":"7KiIc","./internal/operators/publishReplay":"eKmm3","./internal/operators/raceWith":"CtY2T","./internal/operators/reduce":"fAhkL","./internal/operators/repeat":"iv6eo","./internal/operators/repeatWhen":"fkbVy","./internal/operators/retry":"1mz4x","./internal/operators/retryWhen":"8VrMd","./internal/operators/refCount":"cPuI1","./internal/operators/sample":"2POSe","./internal/operators/sampleTime":"kFfWs","./internal/operators/scan":"5J7S5","./internal/operators/sequenceEqual":"l7y9t","./internal/operators/share":"krelF","./internal/operators/shareReplay":"8TWOu","./internal/operators/single":"ja2wH","./internal/operators/skip":"1TuW2","./internal/operators/skipLast":"dBVoW","./internal/operators/skipUntil":"4WepI","./internal/operators/skipWhile":"ap7Sm","./internal/operators/startWith":"jgIyl","./internal/operators/subscribeOn":"3TbCm","./internal/operators/switchAll":"ibUC1","./internal/operators/switchMap":"8lUXl","./internal/operators/switchMapTo":"bicdE","./internal/operators/switchScan":"bciWE","./internal/operators/take":"5bXD5","./internal/operators/takeLast":"eW2If","./internal/operators/takeUntil":"K9ueE","./internal/operators/takeWhile":"kF7EX","./internal/operators/tap":"HoAKu","./internal/operators/throttle":"j4uQU","./internal/operators/throttleTime":"av7pG","./internal/operators/throwIfEmpty":"al37L","./internal/operators/timeInterval":"2XvlZ","./internal/operators/timeoutWith":"5Q2q8","./internal/operators/timestamp":"dXtXd","./internal/operators/toArray":"iKZD7","./internal/operators/window":"kR8qq","./internal/operators/windowCount":"1A4qo","./internal/operators/windowTime":"gyiZl","./internal/operators/windowToggle":"irJ6l","./internal/operators/windowWhen":"3oqS8","./internal/operators/withLatestFrom":"kEbSA","./internal/operators/zipAll":"4f9g0","./internal/operators/zipWith":"aYnFy","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jrGyK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", ()=>Observable);
var _subscriber = require("./Subscriber");
var _subscription = require("./Subscription");
var _observable = require("./symbol/observable");
var _pipe = require("./util/pipe");
var _config = require("./config");
var _isFunction = require("./util/isFunction");
var _errorContext = require("./util/errorContext");
var Observable = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new (0, _subscriber.SafeSubscriber)(observerOrNext, error, complete);
        (0, _errorContext.errorContext)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, _subscriber.SafeSubscriber)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, _observable.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, _pipe.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, _config.config).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function isObserver(value) {
    return value && (0, _isFunction.isFunction)(value.next) && (0, _isFunction.isFunction)(value.error) && (0, _isFunction.isFunction)(value.complete);
}
function isSubscriber(value) {
    return value && value instanceof (0, _subscriber.Subscriber) || isObserver(value) && (0, _subscription.isSubscription)(value);
}

},{"./Subscriber":"c8fGB","./Subscription":"iuJZ4","./symbol/observable":"7NSqh","./util/pipe":"1ZGFK","./config":"fnJOC","./util/isFunction":"eS6zV","./util/errorContext":"3uvIm","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"c8fGB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscriber", ()=>Subscriber);
parcelHelpers.export(exports, "SafeSubscriber", ()=>SafeSubscriber);
parcelHelpers.export(exports, "EMPTY_OBSERVER", ()=>EMPTY_OBSERVER);
var _tslib = require("tslib");
var _isFunction = require("./util/isFunction");
var _subscription = require("./Subscription");
var _config = require("./config");
var _reportUnhandledError = require("./util/reportUnhandledError");
var _noop = require("./util/noop");
var _notificationFactories = require("./NotificationFactories");
var _timeoutProvider = require("./scheduler/timeoutProvider");
var _errorContext = require("./util/errorContext");
var Subscriber = function(_super) {
    (0, _tslib.__extends)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, _subscription.isSubscription)(destination)) destination.add(_this);
        } else _this.destination = EMPTY_OBSERVER;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new SafeSubscriber(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) handleStoppedNotification((0, _notificationFactories.nextNotification)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) handleStoppedNotification((0, _notificationFactories.errorNotification)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) handleStoppedNotification((0, _notificationFactories.COMPLETE_NOTIFICATION), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, _subscription.Subscription));
var _bind = Function.prototype.bind;
function bind(fn, thisArg) {
    return _bind.call(fn, thisArg);
}
var ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            handleUnhandledError(error);
        }
        else handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var SafeSubscriber = function(_super) {
    (0, _tslib.__extends)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, _isFunction.isFunction)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, _config.config).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}(Subscriber);
function handleUnhandledError(error) {
    if ((0, _config.config).useDeprecatedSynchronousErrorHandling) (0, _errorContext.captureError)(error);
    else (0, _reportUnhandledError.reportUnhandledError)(error);
}
function defaultErrorHandler(err) {
    throw err;
}
function handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, _config.config).onStoppedNotification;
    onStoppedNotification && (0, _timeoutProvider.timeoutProvider).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var EMPTY_OBSERVER = {
    closed: true,
    next: (0, _noop.noop),
    error: defaultErrorHandler,
    complete: (0, _noop.noop)
};

},{"tslib":"jH8wD","./util/isFunction":"eS6zV","./Subscription":"iuJZ4","./config":"fnJOC","./util/reportUnhandledError":"9O8mG","./util/noop":"bmpBW","./NotificationFactories":"dDnQ0","./scheduler/timeoutProvider":"jP9lT","./util/errorContext":"3uvIm","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jH8wD":[function(require,module,exports,__globalThis) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", ()=>__extends);
parcelHelpers.export(exports, "__assign", ()=>__assign);
parcelHelpers.export(exports, "__rest", ()=>__rest);
parcelHelpers.export(exports, "__decorate", ()=>__decorate);
parcelHelpers.export(exports, "__param", ()=>__param);
parcelHelpers.export(exports, "__esDecorate", ()=>__esDecorate);
parcelHelpers.export(exports, "__runInitializers", ()=>__runInitializers);
parcelHelpers.export(exports, "__propKey", ()=>__propKey);
parcelHelpers.export(exports, "__setFunctionName", ()=>__setFunctionName);
parcelHelpers.export(exports, "__metadata", ()=>__metadata);
parcelHelpers.export(exports, "__awaiter", ()=>__awaiter);
parcelHelpers.export(exports, "__generator", ()=>__generator);
parcelHelpers.export(exports, "__createBinding", ()=>__createBinding);
parcelHelpers.export(exports, "__exportStar", ()=>__exportStar);
parcelHelpers.export(exports, "__values", ()=>__values);
parcelHelpers.export(exports, "__read", ()=>__read);
/** @deprecated */ parcelHelpers.export(exports, "__spread", ()=>__spread);
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", ()=>__spreadArrays);
parcelHelpers.export(exports, "__spreadArray", ()=>__spreadArray);
parcelHelpers.export(exports, "__await", ()=>__await);
parcelHelpers.export(exports, "__asyncGenerator", ()=>__asyncGenerator);
parcelHelpers.export(exports, "__asyncDelegator", ()=>__asyncDelegator);
parcelHelpers.export(exports, "__asyncValues", ()=>__asyncValues);
parcelHelpers.export(exports, "__makeTemplateObject", ()=>__makeTemplateObject);
parcelHelpers.export(exports, "__importStar", ()=>__importStar);
parcelHelpers.export(exports, "__importDefault", ()=>__importDefault);
parcelHelpers.export(exports, "__classPrivateFieldGet", ()=>__classPrivateFieldGet);
parcelHelpers.export(exports, "__classPrivateFieldSet", ()=>__classPrivateFieldSet);
parcelHelpers.export(exports, "__classPrivateFieldIn", ()=>__classPrivateFieldIn);
parcelHelpers.export(exports, "__addDisposableResource", ()=>__addDisposableResource);
parcelHelpers.export(exports, "__disposeResources", ()=>__disposeResources);
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eS6zV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFunction", ()=>isFunction);
function isFunction(value) {
    return typeof value === 'function';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iuJZ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscription", ()=>Subscription);
parcelHelpers.export(exports, "EMPTY_SUBSCRIPTION", ()=>EMPTY_SUBSCRIPTION);
parcelHelpers.export(exports, "isSubscription", ()=>isSubscription);
var _tslib = require("tslib");
var _isFunction = require("./util/isFunction");
var _unsubscriptionError = require("./util/UnsubscriptionError");
var _arrRemove = require("./util/arrRemove");
var Subscription = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, _tslib.__values)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, _isFunction.isFunction)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, _unsubscriptionError.UnsubscriptionError) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, _tslib.__values)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, _unsubscriptionError.UnsubscriptionError)) errors = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(errors)), (0, _tslib.__read)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, _unsubscriptionError.UnsubscriptionError)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, _arrRemove.arrRemove)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, _arrRemove.arrRemove)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(value) {
    return value instanceof Subscription || value && 'closed' in value && (0, _isFunction.isFunction)(value.remove) && (0, _isFunction.isFunction)(value.add) && (0, _isFunction.isFunction)(value.unsubscribe);
}
function execFinalizer(finalizer) {
    if ((0, _isFunction.isFunction)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}

},{"tslib":"jH8wD","./util/isFunction":"eS6zV","./util/UnsubscriptionError":"hJmDs","./util/arrRemove":"HRHom","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hJmDs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnsubscriptionError", ()=>UnsubscriptionError);
var _createErrorClass = require("./createErrorClass");
var UnsubscriptionError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});

},{"./createErrorClass":"lwxRU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lwxRU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createErrorClass", ()=>createErrorClass);
function createErrorClass(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"HRHom":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrRemove", ()=>arrRemove);
function arrRemove(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fnJOC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "config", ()=>config);
var config = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9O8mG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reportUnhandledError", ()=>reportUnhandledError);
var _config = require("../config");
var _timeoutProvider = require("../scheduler/timeoutProvider");
function reportUnhandledError(err) {
    (0, _timeoutProvider.timeoutProvider).setTimeout(function() {
        var onUnhandledError = (0, _config.config).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}

},{"../config":"fnJOC","../scheduler/timeoutProvider":"jP9lT","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jP9lT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutProvider", ()=>timeoutProvider);
var _tslib = require("tslib");
var timeoutProvider = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = timeoutProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, _tslib.__spreadArray)([
            handler,
            timeout
        ], (0, _tslib.__read)(args)));
        return setTimeout.apply(void 0, (0, _tslib.__spreadArray)([
            handler,
            timeout
        ], (0, _tslib.__read)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = timeoutProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};

},{"tslib":"jH8wD","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bmpBW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", ()=>noop);
function noop() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dDnQ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COMPLETE_NOTIFICATION", ()=>COMPLETE_NOTIFICATION);
parcelHelpers.export(exports, "errorNotification", ()=>errorNotification);
parcelHelpers.export(exports, "nextNotification", ()=>nextNotification);
parcelHelpers.export(exports, "createNotification", ()=>createNotification);
var COMPLETE_NOTIFICATION = function() {
    return createNotification('C', undefined, undefined);
}();
function errorNotification(error) {
    return createNotification('E', undefined, error);
}
function nextNotification(value) {
    return createNotification('N', value, undefined);
}
function createNotification(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3uvIm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorContext", ()=>errorContext);
parcelHelpers.export(exports, "captureError", ()=>captureError);
var _config = require("../config");
var context = null;
function errorContext(cb) {
    if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !context;
        if (isRoot) context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = context, errorThrown = _a.errorThrown, error = _a.error;
            context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function captureError(err) {
    if ((0, _config.config).useDeprecatedSynchronousErrorHandling && context) {
        context.errorThrown = true;
        context.error = err;
    }
}

},{"../config":"fnJOC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7NSqh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observable", ()=>observable);
var observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1ZGFK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pipe", ()=>pipe);
parcelHelpers.export(exports, "pipeFromArray", ()=>pipeFromArray);
var _identity = require("./identity");
function pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) return 0, _identity.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

},{"./identity":"2CmIP","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2CmIP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", ()=>identity);
function identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kYoRv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConnectableObservable", ()=>ConnectableObservable);
var _tslib = require("tslib");
var _observable = require("../Observable");
var _subscription = require("../Subscription");
var _refCount = require("../operators/refCount");
var _operatorSubscriber = require("../operators/OperatorSubscriber");
var _lift = require("../util/lift");
var ConnectableObservable = function(_super) {
    (0, _tslib.__extends)(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._subject = null;
        _this._refCount = 0;
        _this._connection = null;
        if ((0, _lift.hasLift)(source)) _this.lift = source.lift;
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function(subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function() {
        var subject = this._subject;
        if (!subject || subject.isStopped) this._subject = this.subjectFactory();
        return this._subject;
    };
    ConnectableObservable.prototype._teardown = function() {
        this._refCount = 0;
        var _connection = this._connection;
        this._subject = this._connection = null;
        _connection === null || _connection === void 0 || _connection.unsubscribe();
    };
    ConnectableObservable.prototype.connect = function() {
        var _this = this;
        var connection = this._connection;
        if (!connection) {
            connection = this._connection = new (0, _subscription.Subscription)();
            var subject_1 = this.getSubject();
            connection.add(this.source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subject_1, undefined, function() {
                _this._teardown();
                subject_1.complete();
            }, function(err) {
                _this._teardown();
                subject_1.error(err);
            }, function() {
                return _this._teardown();
            })));
            if (connection.closed) {
                this._connection = null;
                connection = (0, _subscription.Subscription).EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function() {
        return (0, _refCount.refCount)()(this);
    };
    return ConnectableObservable;
}((0, _observable.Observable));

},{"tslib":"jH8wD","../Observable":"jrGyK","../Subscription":"iuJZ4","../operators/refCount":"cPuI1","../operators/OperatorSubscriber":"aQPgL","../util/lift":"4nOIb","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cPuI1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "refCount", ()=>refCount);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function refCount() {
    return (0, _lift.operate)(function(source, subscriber) {
        var connection = null;
        source._refCount++;
        var refCounter = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, undefined, undefined, undefined, function() {
            if (!source || source._refCount <= 0 || 0 < --source._refCount) {
                connection = null;
                return;
            }
            var sharedConnection = source._connection;
            var conn = connection;
            connection = null;
            if (sharedConnection && (!conn || sharedConnection === conn)) sharedConnection.unsubscribe();
            subscriber.unsubscribe();
        });
        source.subscribe(refCounter);
        if (!refCounter.closed) connection = source.connect();
    });
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4nOIb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasLift", ()=>hasLift);
parcelHelpers.export(exports, "operate", ()=>operate);
var _isFunction = require("./isFunction");
function hasLift(source) {
    return (0, _isFunction.isFunction)(source === null || source === void 0 ? void 0 : source.lift);
}
function operate(init) {
    return function(source) {
        if (hasLift(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}

},{"./isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aQPgL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createOperatorSubscriber", ()=>createOperatorSubscriber);
parcelHelpers.export(exports, "OperatorSubscriber", ()=>OperatorSubscriber);
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
    return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
}
var OperatorSubscriber = function(_super) {
    (0, _tslib.__extends)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"jH8wD","../Subscriber":"c8fGB","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2QK3H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animationFrames", ()=>animationFrames);
var _observable = require("../../Observable");
var _performanceTimestampProvider = require("../../scheduler/performanceTimestampProvider");
var _animationFrameProvider = require("../../scheduler/animationFrameProvider");
function animationFrames(timestampProvider) {
    return timestampProvider ? animationFramesFactory(timestampProvider) : DEFAULT_ANIMATION_FRAMES;
}
function animationFramesFactory(timestampProvider) {
    return new (0, _observable.Observable)(function(subscriber) {
        var provider = timestampProvider || (0, _performanceTimestampProvider.performanceTimestampProvider);
        var start = provider.now();
        var id = 0;
        var run = function() {
            if (!subscriber.closed) id = (0, _animationFrameProvider.animationFrameProvider).requestAnimationFrame(function(timestamp) {
                id = 0;
                var now = provider.now();
                subscriber.next({
                    timestamp: timestampProvider ? now : timestamp,
                    elapsed: now - start
                });
                run();
            });
        };
        run();
        return function() {
            if (id) (0, _animationFrameProvider.animationFrameProvider).cancelAnimationFrame(id);
        };
    });
}
var DEFAULT_ANIMATION_FRAMES = animationFramesFactory();

},{"../../Observable":"jrGyK","../../scheduler/performanceTimestampProvider":"ixJb0","../../scheduler/animationFrameProvider":"gbyib","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ixJb0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "performanceTimestampProvider", ()=>performanceTimestampProvider);
var performanceTimestampProvider = {
    now: function() {
        return (performanceTimestampProvider.delegate || performance).now();
    },
    delegate: undefined
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gbyib":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animationFrameProvider", ()=>animationFrameProvider);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var animationFrameProvider = {
    schedule: function(callback) {
        var request = requestAnimationFrame;
        var cancel = cancelAnimationFrame;
        var delegate = animationFrameProvider.delegate;
        if (delegate) {
            request = delegate.requestAnimationFrame;
            cancel = delegate.cancelAnimationFrame;
        }
        var handle = request(function(timestamp) {
            cancel = undefined;
            callback(timestamp);
        });
        return new (0, _subscription.Subscription)(function() {
            return cancel === null || cancel === void 0 ? void 0 : cancel(handle);
        });
    },
    requestAnimationFrame: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = animationFrameProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.requestAnimationFrame) || requestAnimationFrame).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(args)));
    },
    cancelAnimationFrame: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = animationFrameProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.cancelAnimationFrame) || cancelAnimationFrame).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(args)));
    },
    delegate: undefined
};

},{"tslib":"jH8wD","../Subscription":"iuJZ4","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4Icpn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subject", ()=>Subject);
parcelHelpers.export(exports, "AnonymousSubject", ()=>AnonymousSubject);
var _tslib = require("tslib");
var _observable = require("./Observable");
var _subscription = require("./Subscription");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var _arrRemove = require("./util/arrRemove");
var _errorContext = require("./util/errorContext");
var Subject = function(_super) {
    (0, _tslib.__extends)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, _errorContext.errorContext)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, _tslib.__values)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, _errorContext.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, _errorContext.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, _subscription.EMPTY_SUBSCRIPTION;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, _subscription.Subscription)(function() {
            _this.currentObservers = null;
            (0, _arrRemove.arrRemove)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, _observable.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}((0, _observable.Observable));
var AnonymousSubject = function(_super) {
    (0, _tslib.__extends)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, _subscription.EMPTY_SUBSCRIPTION);
    };
    return AnonymousSubject;
}(Subject);

},{"tslib":"jH8wD","./Observable":"jrGyK","./Subscription":"iuJZ4","./util/ObjectUnsubscribedError":"9Z7qV","./util/arrRemove":"HRHom","./util/errorContext":"3uvIm","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9Z7qV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectUnsubscribedError", ()=>ObjectUnsubscribedError);
var _createErrorClass = require("./createErrorClass");
var ObjectUnsubscribedError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});

},{"./createErrorClass":"lwxRU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cMDx8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BehaviorSubject", ()=>BehaviorSubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var BehaviorSubject = function(_super) {
    (0, _tslib.__extends)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, _subject.Subject));

},{"tslib":"jH8wD","./Subject":"4Icpn","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hpUH1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReplaySubject", ()=>ReplaySubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var _dateTimestampProvider = require("./scheduler/dateTimestampProvider");
var ReplaySubject = function(_super) {
    (0, _tslib.__extends)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = (0, _dateTimestampProvider.dateTimestampProvider);
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}((0, _subject.Subject));

},{"tslib":"jH8wD","./Subject":"4Icpn","./scheduler/dateTimestampProvider":"lCnpT","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lCnpT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateTimestampProvider", ()=>dateTimestampProvider);
var dateTimestampProvider = {
    now: function() {
        return (dateTimestampProvider.delegate || Date).now();
    },
    delegate: undefined
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6p0u8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncSubject", ()=>AsyncSubject);
var _tslib = require("tslib");
var _subject = require("./Subject");
var AsyncSubject = function(_super) {
    (0, _tslib.__extends)(AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._value = null;
        _this._hasValue = false;
        _this._isComplete = false;
        return _this;
    }
    AsyncSubject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, _hasValue = _a._hasValue, _value = _a._value, thrownError = _a.thrownError, isStopped = _a.isStopped, _isComplete = _a._isComplete;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped || _isComplete) {
            _hasValue && subscriber.next(_value);
            subscriber.complete();
        }
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.isStopped) {
            this._value = value;
            this._hasValue = true;
        }
    };
    AsyncSubject.prototype.complete = function() {
        var _a = this, _hasValue = _a._hasValue, _value = _a._value, _isComplete = _a._isComplete;
        if (!_isComplete) {
            this._isComplete = true;
            _hasValue && _super.prototype.next.call(this, _value);
            _super.prototype.complete.call(this);
        }
    };
    return AsyncSubject;
}((0, _subject.Subject));

},{"tslib":"jH8wD","./Subject":"4Icpn","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8q2VM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asapScheduler", ()=>asapScheduler);
parcelHelpers.export(exports, "asap", ()=>asap);
var _asapAction = require("./AsapAction");
var _asapScheduler = require("./AsapScheduler");
var asapScheduler = new (0, _asapScheduler.AsapScheduler)((0, _asapAction.AsapAction));
var asap = asapScheduler;

},{"./AsapAction":"65FJN","./AsapScheduler":"exD6T","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"65FJN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapAction", ()=>AsapAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var _immediateProvider = require("./immediateProvider");
var AsapAction = function(_super) {
    (0, _tslib.__extends)(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = (0, _immediateProvider.immediateProvider).setImmediate(scheduler.flush.bind(scheduler, undefined)));
    };
    AsapAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (delay != null ? delay > 0 : this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        var actions = scheduler.actions;
        if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
            (0, _immediateProvider.immediateProvider).clearImmediate(id);
            if (scheduler._scheduled === id) scheduler._scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"jH8wD","./AsyncAction":"dMb91","./immediateProvider":"iHduU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dMb91":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncAction", ()=>AsyncAction);
var _tslib = require("tslib");
var _action = require("./Action");
var _intervalProvider = require("./intervalProvider");
var _arrRemove = require("../util/arrRemove");
var AsyncAction = function(_super) {
    (0, _tslib.__extends)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, _intervalProvider.intervalProvider).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, _intervalProvider.intervalProvider).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, _arrRemove.arrRemove)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, _action.Action));

},{"tslib":"jH8wD","./Action":"jRXpJ","./intervalProvider":"5j3yv","../util/arrRemove":"HRHom","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jRXpJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Action", ()=>Action);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var Action = function(_super) {
    (0, _tslib.__extends)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, _subscription.Subscription));

},{"tslib":"jH8wD","../Subscription":"iuJZ4","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5j3yv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "intervalProvider", ()=>intervalProvider);
var _tslib = require("tslib");
var intervalProvider = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = intervalProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, _tslib.__spreadArray)([
            handler,
            timeout
        ], (0, _tslib.__read)(args)));
        return setInterval.apply(void 0, (0, _tslib.__spreadArray)([
            handler,
            timeout
        ], (0, _tslib.__read)(args)));
    },
    clearInterval: function(handle) {
        var delegate = intervalProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};

},{"tslib":"jH8wD","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iHduU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "immediateProvider", ()=>immediateProvider);
var _tslib = require("tslib");
var _immediate = require("../util/Immediate");
var setImmediate = (0, _immediate.Immediate).setImmediate, clearImmediate = (0, _immediate.Immediate).clearImmediate;
var immediateProvider = {
    setImmediate: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = immediateProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.setImmediate) || setImmediate).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(args)));
    },
    clearImmediate: function(handle) {
        var delegate = immediateProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearImmediate) || clearImmediate)(handle);
    },
    delegate: undefined
};

},{"tslib":"jH8wD","../util/Immediate":"c8cXk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"c8cXk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immediate", ()=>Immediate);
parcelHelpers.export(exports, "TestTools", ()=>TestTools);
var nextHandle = 1;
var resolved;
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
var Immediate = {
    setImmediate: function(cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        if (!resolved) resolved = Promise.resolve();
        resolved.then(function() {
            return findAndClearHandle(handle) && cb();
        });
        return handle;
    },
    clearImmediate: function(handle) {
        findAndClearHandle(handle);
    }
};
var TestTools = {
    pending: function() {
        return Object.keys(activeHandles).length;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"exD6T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsapScheduler", ()=>AsapScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var AsapScheduler = function(_super) {
    (0, _tslib.__extends)(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function(action) {
        this._active = true;
        var flushId = this._scheduled;
        this._scheduled = undefined;
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
            while((action = actions[0]) && action.id === flushId && actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsapScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"jH8wD","./AsyncScheduler":"b8IpQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"b8IpQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncScheduler", ()=>AsyncScheduler);
var _tslib = require("tslib");
var _scheduler = require("../Scheduler");
var AsyncScheduler = function(_super) {
    (0, _tslib.__extends)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, _scheduler.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, _scheduler.Scheduler));

},{"tslib":"jH8wD","../Scheduler":"gLsi1","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gLsi1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scheduler", ()=>Scheduler);
var _dateTimestampProvider = require("./scheduler/dateTimestampProvider");
var Scheduler = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, _dateTimestampProvider.dateTimestampProvider).now;
    return Scheduler;
}();

},{"./scheduler/dateTimestampProvider":"lCnpT","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fZcBE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asyncScheduler", ()=>asyncScheduler);
parcelHelpers.export(exports, "async", ()=>async);
var _asyncAction = require("./AsyncAction");
var _asyncScheduler = require("./AsyncScheduler");
var asyncScheduler = new (0, _asyncScheduler.AsyncScheduler)((0, _asyncAction.AsyncAction));
var async = asyncScheduler;

},{"./AsyncAction":"dMb91","./AsyncScheduler":"b8IpQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"k88In":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queueScheduler", ()=>queueScheduler);
parcelHelpers.export(exports, "queue", ()=>queue);
var _queueAction = require("./QueueAction");
var _queueScheduler = require("./QueueScheduler");
var queueScheduler = new (0, _queueScheduler.QueueScheduler)((0, _queueAction.QueueAction));
var queue = queueScheduler;

},{"./QueueAction":"bdJb1","./QueueScheduler":"798HO","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bdJb1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueAction", ()=>QueueAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var QueueAction = function(_super) {
    (0, _tslib.__extends)(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (delay > 0) return _super.prototype.schedule.call(this, state, delay);
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function(state, delay) {
        return delay > 0 || this.closed ? _super.prototype.execute.call(this, state, delay) : this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && delay > 0 || delay == null && this.delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.flush(this);
        return 0;
    };
    return QueueAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"jH8wD","./AsyncAction":"dMb91","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"798HO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueueScheduler", ()=>QueueScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var QueueScheduler = function(_super) {
    (0, _tslib.__extends)(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"jH8wD","./AsyncScheduler":"b8IpQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2NZsb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animationFrameScheduler", ()=>animationFrameScheduler);
parcelHelpers.export(exports, "animationFrame", ()=>animationFrame);
var _animationFrameAction = require("./AnimationFrameAction");
var _animationFrameScheduler = require("./AnimationFrameScheduler");
var animationFrameScheduler = new (0, _animationFrameScheduler.AnimationFrameScheduler)((0, _animationFrameAction.AnimationFrameAction));
var animationFrame = animationFrameScheduler;

},{"./AnimationFrameAction":"9i5tp","./AnimationFrameScheduler":"acmkt","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9i5tp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimationFrameAction", ()=>AnimationFrameAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var _animationFrameProvider = require("./animationFrameProvider");
var AnimationFrameAction = function(_super) {
    (0, _tslib.__extends)(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = (0, _animationFrameProvider.animationFrameProvider).requestAnimationFrame(function() {
            return scheduler.flush(undefined);
        }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (delay != null ? delay > 0 : this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        var actions = scheduler.actions;
        if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
            (0, _animationFrameProvider.animationFrameProvider).cancelAnimationFrame(id);
            scheduler._scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"jH8wD","./AsyncAction":"dMb91","./animationFrameProvider":"gbyib","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"acmkt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimationFrameScheduler", ()=>AnimationFrameScheduler);
var _tslib = require("tslib");
var _asyncScheduler = require("./AsyncScheduler");
var AnimationFrameScheduler = function(_super) {
    (0, _tslib.__extends)(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function(action) {
        this._active = true;
        var flushId = this._scheduled;
        this._scheduled = undefined;
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
            while((action = actions[0]) && action.id === flushId && actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AnimationFrameScheduler;
}((0, _asyncScheduler.AsyncScheduler));

},{"tslib":"jH8wD","./AsyncScheduler":"b8IpQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"16km3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VirtualTimeScheduler", ()=>VirtualTimeScheduler);
parcelHelpers.export(exports, "VirtualAction", ()=>VirtualAction);
var _tslib = require("tslib");
var _asyncAction = require("./AsyncAction");
var _subscription = require("../Subscription");
var _asyncScheduler = require("./AsyncScheduler");
var VirtualTimeScheduler = function(_super) {
    (0, _tslib.__extends)(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(schedulerActionCtor, maxFrames) {
        if (schedulerActionCtor === void 0) schedulerActionCtor = VirtualAction;
        if (maxFrames === void 0) maxFrames = Infinity;
        var _this = _super.call(this, schedulerActionCtor, function() {
            return _this.frame;
        }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function() {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error;
        var action;
        while((action = actions[0]) && action.delay <= maxFrames){
            actions.shift();
            this.frame = action.delay;
            if (error = action.execute(action.state, action.delay)) break;
        }
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}((0, _asyncScheduler.AsyncScheduler));
var VirtualAction = function(_super) {
    (0, _tslib.__extends)(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) index = scheduler.index += 1;
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        if (Number.isFinite(delay)) {
            if (!this.id) return _super.prototype.schedule.call(this, state, delay);
            this.active = false;
            var action = new VirtualAction(this.scheduler, this.work);
            this.add(action);
            return action.schedule(state, delay);
        } else return (0, _subscription.Subscription).EMPTY;
    };
    VirtualAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return 1;
    };
    VirtualAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        return undefined;
    };
    VirtualAction.prototype._execute = function(state, delay) {
        if (this.active === true) return _super.prototype._execute.call(this, state, delay);
    };
    VirtualAction.sortActions = function(a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) return 0;
            else if (a.index > b.index) return 1;
            else return -1;
        } else if (a.delay > b.delay) return 1;
        else return -1;
    };
    return VirtualAction;
}((0, _asyncAction.AsyncAction));

},{"tslib":"jH8wD","./AsyncAction":"dMb91","../Subscription":"iuJZ4","./AsyncScheduler":"b8IpQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"46g2P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotificationKind", ()=>NotificationKind);
parcelHelpers.export(exports, "Notification", ()=>Notification);
parcelHelpers.export(exports, "observeNotification", ()=>observeNotification);
var _empty = require("./observable/empty");
var _of = require("./observable/of");
var _throwError = require("./observable/throwError");
var _isFunction = require("./util/isFunction");
var NotificationKind;
(function(NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind || (NotificationKind = {}));
var Notification = function() {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function(observer) {
        return observeNotification(this, observer);
    };
    Notification.prototype.do = function(nextHandler, errorHandler, completeHandler) {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        return kind === 'N' ? nextHandler === null || nextHandler === void 0 ? void 0 : nextHandler(value) : kind === 'E' ? errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(error) : completeHandler === null || completeHandler === void 0 ? void 0 : completeHandler();
    };
    Notification.prototype.accept = function(nextOrObserver, error, complete) {
        var _a;
        return (0, _isFunction.isFunction)((_a = nextOrObserver) === null || _a === void 0 ? void 0 : _a.next) ? this.observe(nextOrObserver) : this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function() {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        var result = kind === 'N' ? (0, _of.of)(value) : kind === 'E' ? (0, _throwError.throwError)(function() {
            return error;
        }) : kind === 'C' ? (0, _empty.EMPTY) : 0;
        if (!result) throw new TypeError("Unexpected notification kind " + kind);
        return result;
    };
    Notification.createNext = function(value) {
        return new Notification('N', value);
    };
    Notification.createError = function(err) {
        return new Notification('E', undefined, err);
    };
    Notification.createComplete = function() {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    return Notification;
}();
function observeNotification(notification, observer) {
    var _a, _b, _c;
    var _d = notification, kind = _d.kind, value = _d.value, error = _d.error;
    if (typeof kind !== 'string') throw new TypeError('Invalid notification, missing "kind"');
    kind === 'N' ? (_a = observer.next) === null || _a === void 0 || _a.call(observer, value) : kind === 'E' ? (_b = observer.error) === null || _b === void 0 || _b.call(observer, error) : (_c = observer.complete) === null || _c === void 0 || _c.call(observer);
}

},{"./observable/empty":"tKukk","./observable/of":"cH8fx","./observable/throwError":"hryQb","./util/isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"tKukk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY", ()=>EMPTY);
parcelHelpers.export(exports, "empty", ()=>empty);
var _observable = require("../Observable");
var EMPTY = new (0, _observable.Observable)(function(subscriber) {
    return subscriber.complete();
});
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

},{"../Observable":"jrGyK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cH8fx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "of", ()=>of);
var _args = require("../util/args");
var _from = require("./from");
function of() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, _args.popScheduler)(args);
    return (0, _from.from)(args, scheduler);
}

},{"../util/args":"6vW91","./from":"hSPWH","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6vW91":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popResultSelector", ()=>popResultSelector);
parcelHelpers.export(exports, "popScheduler", ()=>popScheduler);
parcelHelpers.export(exports, "popNumber", ()=>popNumber);
var _isFunction = require("./isFunction");
var _isScheduler = require("./isScheduler");
function last(arr) {
    return arr[arr.length - 1];
}
function popResultSelector(args) {
    return (0, _isFunction.isFunction)(last(args)) ? args.pop() : undefined;
}
function popScheduler(args) {
    return (0, _isScheduler.isScheduler)(last(args)) ? args.pop() : undefined;
}
function popNumber(args, defaultValue) {
    return typeof last(args) === 'number' ? args.pop() : defaultValue;
}

},{"./isFunction":"eS6zV","./isScheduler":"sl099","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"sl099":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isScheduler", ()=>isScheduler);
var _isFunction = require("./isFunction");
function isScheduler(value) {
    return value && (0, _isFunction.isFunction)(value.schedule);
}

},{"./isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hSPWH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "from", ()=>from);
var _scheduled = require("../scheduled/scheduled");
var _innerFrom = require("./innerFrom");
function from(input, scheduler) {
    return scheduler ? (0, _scheduled.scheduled)(input, scheduler) : (0, _innerFrom.innerFrom)(input);
}

},{"../scheduled/scheduled":"eiqdN","./innerFrom":"88jOZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eiqdN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduled", ()=>scheduled);
var _scheduleObservable = require("./scheduleObservable");
var _schedulePromise = require("./schedulePromise");
var _scheduleArray = require("./scheduleArray");
var _scheduleIterable = require("./scheduleIterable");
var _scheduleAsyncIterable = require("./scheduleAsyncIterable");
var _isInteropObservable = require("../util/isInteropObservable");
var _isPromise = require("../util/isPromise");
var _isArrayLike = require("../util/isArrayLike");
var _isIterable = require("../util/isIterable");
var _isAsyncIterable = require("../util/isAsyncIterable");
var _throwUnobservableError = require("../util/throwUnobservableError");
var _isReadableStreamLike = require("../util/isReadableStreamLike");
var _scheduleReadableStreamLike = require("./scheduleReadableStreamLike");
function scheduled(input, scheduler) {
    if (input != null) {
        if ((0, _isInteropObservable.isInteropObservable)(input)) return (0, _scheduleObservable.scheduleObservable)(input, scheduler);
        if ((0, _isArrayLike.isArrayLike)(input)) return (0, _scheduleArray.scheduleArray)(input, scheduler);
        if ((0, _isPromise.isPromise)(input)) return (0, _schedulePromise.schedulePromise)(input, scheduler);
        if ((0, _isAsyncIterable.isAsyncIterable)(input)) return (0, _scheduleAsyncIterable.scheduleAsyncIterable)(input, scheduler);
        if ((0, _isIterable.isIterable)(input)) return (0, _scheduleIterable.scheduleIterable)(input, scheduler);
        if ((0, _isReadableStreamLike.isReadableStreamLike)(input)) return (0, _scheduleReadableStreamLike.scheduleReadableStreamLike)(input, scheduler);
    }
    throw (0, _throwUnobservableError.createInvalidObservableTypeError)(input);
}

},{"./scheduleObservable":"cLiVw","./schedulePromise":"41lI7","./scheduleArray":"dxjKf","./scheduleIterable":"hkvyy","./scheduleAsyncIterable":"7dMLP","../util/isInteropObservable":"j67Hj","../util/isPromise":"hSkNF","../util/isArrayLike":"chfYX","../util/isIterable":"1pWWm","../util/isAsyncIterable":"a3Pmf","../util/throwUnobservableError":"g8grk","../util/isReadableStreamLike":"ixnAJ","./scheduleReadableStreamLike":"jiQMi","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cLiVw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleObservable", ()=>scheduleObservable);
var _innerFrom = require("../observable/innerFrom");
var _observeOn = require("../operators/observeOn");
var _subscribeOn = require("../operators/subscribeOn");
function scheduleObservable(input, scheduler) {
    return (0, _innerFrom.innerFrom)(input).pipe((0, _subscribeOn.subscribeOn)(scheduler), (0, _observeOn.observeOn)(scheduler));
}

},{"../observable/innerFrom":"88jOZ","../operators/observeOn":"0Qy0C","../operators/subscribeOn":"3TbCm","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"88jOZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "innerFrom", ()=>innerFrom);
parcelHelpers.export(exports, "fromInteropObservable", ()=>fromInteropObservable);
parcelHelpers.export(exports, "fromArrayLike", ()=>fromArrayLike);
parcelHelpers.export(exports, "fromPromise", ()=>fromPromise);
parcelHelpers.export(exports, "fromIterable", ()=>fromIterable);
parcelHelpers.export(exports, "fromAsyncIterable", ()=>fromAsyncIterable);
parcelHelpers.export(exports, "fromReadableStreamLike", ()=>fromReadableStreamLike);
var _tslib = require("tslib");
var _isArrayLike = require("../util/isArrayLike");
var _isPromise = require("../util/isPromise");
var _observable = require("../Observable");
var _isInteropObservable = require("../util/isInteropObservable");
var _isAsyncIterable = require("../util/isAsyncIterable");
var _throwUnobservableError = require("../util/throwUnobservableError");
var _isIterable = require("../util/isIterable");
var _isReadableStreamLike = require("../util/isReadableStreamLike");
var _isFunction = require("../util/isFunction");
var _reportUnhandledError = require("../util/reportUnhandledError");
var _observable1 = require("../symbol/observable");
function innerFrom(input) {
    if (input instanceof (0, _observable.Observable)) return input;
    if (input != null) {
        if ((0, _isInteropObservable.isInteropObservable)(input)) return fromInteropObservable(input);
        if ((0, _isArrayLike.isArrayLike)(input)) return fromArrayLike(input);
        if ((0, _isPromise.isPromise)(input)) return fromPromise(input);
        if ((0, _isAsyncIterable.isAsyncIterable)(input)) return fromAsyncIterable(input);
        if ((0, _isIterable.isIterable)(input)) return fromIterable(input);
        if ((0, _isReadableStreamLike.isReadableStreamLike)(input)) return fromReadableStreamLike(input);
    }
    throw (0, _throwUnobservableError.createInvalidObservableTypeError)(input);
}
function fromInteropObservable(obj) {
    return new (0, _observable.Observable)(function(subscriber) {
        var obs = obj[0, _observable1.observable]();
        if ((0, _isFunction.isFunction)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function fromArrayLike(array) {
    return new (0, _observable.Observable)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function fromPromise(promise) {
    return new (0, _observable.Observable)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, _reportUnhandledError.reportUnhandledError));
    });
}
function fromIterable(iterable) {
    return new (0, _observable.Observable)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, _tslib.__values)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function fromAsyncIterable(asyncIterable) {
    return new (0, _observable.Observable)(function(subscriber) {
        process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function fromReadableStreamLike(readableStream) {
    return fromAsyncIterable((0, _isReadableStreamLike.readableStreamLikeToAsyncGenerator)(readableStream));
}
function process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, _tslib.__asyncValues)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}

},{"tslib":"jH8wD","../util/isArrayLike":"chfYX","../util/isPromise":"hSkNF","../Observable":"jrGyK","../util/isInteropObservable":"j67Hj","../util/isAsyncIterable":"a3Pmf","../util/throwUnobservableError":"g8grk","../util/isIterable":"1pWWm","../util/isReadableStreamLike":"ixnAJ","../util/isFunction":"eS6zV","../util/reportUnhandledError":"9O8mG","../symbol/observable":"7NSqh","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"chfYX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayLike", ()=>isArrayLike);
var isArrayLike = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hSkNF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPromise", ()=>isPromise);
var _isFunction = require("./isFunction");
function isPromise(value) {
    return (0, _isFunction.isFunction)(value === null || value === void 0 ? void 0 : value.then);
}

},{"./isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"j67Hj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInteropObservable", ()=>isInteropObservable);
var _observable = require("../symbol/observable");
var _isFunction = require("./isFunction");
function isInteropObservable(input) {
    return (0, _isFunction.isFunction)(input[0, _observable.observable]);
}

},{"../symbol/observable":"7NSqh","./isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"a3Pmf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAsyncIterable", ()=>isAsyncIterable);
var _isFunction = require("./isFunction");
function isAsyncIterable(obj) {
    return Symbol.asyncIterator && (0, _isFunction.isFunction)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

},{"./isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"g8grk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createInvalidObservableTypeError", ()=>createInvalidObservableTypeError);
function createInvalidObservableTypeError(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1pWWm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isIterable", ()=>isIterable);
var _iterator = require("../symbol/iterator");
var _isFunction = require("./isFunction");
function isIterable(input) {
    return (0, _isFunction.isFunction)(input === null || input === void 0 ? void 0 : input[0, _iterator.iterator]);
}

},{"../symbol/iterator":"evsQu","./isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"evsQu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSymbolIterator", ()=>getSymbolIterator);
parcelHelpers.export(exports, "iterator", ()=>iterator);
function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var iterator = getSymbolIterator();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ixnAJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readableStreamLikeToAsyncGenerator", ()=>readableStreamLikeToAsyncGenerator);
parcelHelpers.export(exports, "isReadableStreamLike", ()=>isReadableStreamLike);
var _tslib = require("tslib");
var _isFunction = require("./isFunction");
function readableStreamLikeToAsyncGenerator(readableStream) {
    return (0, _tslib.__asyncGenerator)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, _tslib.__await)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, _tslib.__await)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, _tslib.__await)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function isReadableStreamLike(obj) {
    return (0, _isFunction.isFunction)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

},{"tslib":"jH8wD","./isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"0Qy0C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeOn", ()=>observeOn);
var _executeSchedule = require("../util/executeSchedule");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, _lift.operate)(function(source, subscriber) {
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}

},{"../util/executeSchedule":"lgbnE","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lgbnE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "executeSchedule", ()=>executeSchedule);
function executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3TbCm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeOn", ()=>subscribeOn);
var _lift = require("../util/lift");
function subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, _lift.operate)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}

},{"../util/lift":"4nOIb","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"41lI7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schedulePromise", ()=>schedulePromise);
var _innerFrom = require("../observable/innerFrom");
var _observeOn = require("../operators/observeOn");
var _subscribeOn = require("../operators/subscribeOn");
function schedulePromise(input, scheduler) {
    return (0, _innerFrom.innerFrom)(input).pipe((0, _subscribeOn.subscribeOn)(scheduler), (0, _observeOn.observeOn)(scheduler));
}

},{"../observable/innerFrom":"88jOZ","../operators/observeOn":"0Qy0C","../operators/subscribeOn":"3TbCm","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dxjKf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleArray", ()=>scheduleArray);
var _observable = require("../Observable");
function scheduleArray(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}

},{"../Observable":"jrGyK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hkvyy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleIterable", ()=>scheduleIterable);
var _observable = require("../Observable");
var _iterator = require("../symbol/iterator");
var _isFunction = require("../util/isFunction");
var _executeSchedule = require("../util/executeSchedule");
function scheduleIterable(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var iterator;
        (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
            iterator = input[0, _iterator.iterator]();
            (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, _isFunction.isFunction)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}

},{"../Observable":"jrGyK","../symbol/iterator":"evsQu","../util/isFunction":"eS6zV","../util/executeSchedule":"lgbnE","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7dMLP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleAsyncIterable", ()=>scheduleAsyncIterable);
var _observable = require("../Observable");
var _executeSchedule = require("../util/executeSchedule");
function scheduleAsyncIterable(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, _observable.Observable)(function(subscriber) {
        (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}

},{"../Observable":"jrGyK","../util/executeSchedule":"lgbnE","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jiQMi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleReadableStreamLike", ()=>scheduleReadableStreamLike);
var _scheduleAsyncIterable = require("./scheduleAsyncIterable");
var _isReadableStreamLike = require("../util/isReadableStreamLike");
function scheduleReadableStreamLike(input, scheduler) {
    return (0, _scheduleAsyncIterable.scheduleAsyncIterable)((0, _isReadableStreamLike.readableStreamLikeToAsyncGenerator)(input), scheduler);
}

},{"./scheduleAsyncIterable":"7dMLP","../util/isReadableStreamLike":"ixnAJ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hryQb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwError", ()=>throwError);
var _observable = require("../Observable");
var _isFunction = require("../util/isFunction");
function throwError(errorOrErrorFactory, scheduler) {
    var errorFactory = (0, _isFunction.isFunction)(errorOrErrorFactory) ? errorOrErrorFactory : function() {
        return errorOrErrorFactory;
    };
    var init = function(subscriber) {
        return subscriber.error(errorFactory());
    };
    return new (0, _observable.Observable)(scheduler ? function(subscriber) {
        return scheduler.schedule(init, 0, subscriber);
    } : init);
}

},{"../Observable":"jrGyK","../util/isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iGTcd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObservable", ()=>isObservable);
var _observable = require("../Observable");
var _isFunction = require("./isFunction");
function isObservable(obj) {
    return !!obj && (obj instanceof (0, _observable.Observable) || (0, _isFunction.isFunction)(obj.lift) && (0, _isFunction.isFunction)(obj.subscribe));
}

},{"../Observable":"jrGyK","./isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3sHJf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lastValueFrom", ()=>lastValueFrom);
var _emptyError = require("./util/EmptyError");
function lastValueFrom(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function(resolve, reject) {
        var _hasValue = false;
        var _value;
        source.subscribe({
            next: function(value) {
                _value = value;
                _hasValue = true;
            },
            error: reject,
            complete: function() {
                if (_hasValue) resolve(_value);
                else if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, _emptyError.EmptyError)());
            }
        });
    });
}

},{"./util/EmptyError":"Cu2oV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"Cu2oV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmptyError", ()=>EmptyError);
var _createErrorClass = require("./createErrorClass");
var EmptyError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = 'EmptyError';
        this.message = 'no elements in sequence';
    };
});

},{"./createErrorClass":"lwxRU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"01hrx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "firstValueFrom", ()=>firstValueFrom);
var _emptyError = require("./util/EmptyError");
var _subscriber = require("./Subscriber");
function firstValueFrom(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function(resolve, reject) {
        var subscriber = new (0, _subscriber.SafeSubscriber)({
            next: function(value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function() {
                if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, _emptyError.EmptyError)());
            }
        });
        source.subscribe(subscriber);
    });
}

},{"./util/EmptyError":"Cu2oV","./Subscriber":"c8fGB","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1Vgkw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ArgumentOutOfRangeError", ()=>ArgumentOutOfRangeError);
var _createErrorClass = require("./createErrorClass");
var ArgumentOutOfRangeError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function ArgumentOutOfRangeErrorImpl() {
        _super(this);
        this.name = 'ArgumentOutOfRangeError';
        this.message = 'argument out of range';
    };
});

},{"./createErrorClass":"lwxRU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"LNpui":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotFoundError", ()=>NotFoundError);
var _createErrorClass = require("./createErrorClass");
var NotFoundError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function NotFoundErrorImpl(message) {
        _super(this);
        this.name = 'NotFoundError';
        this.message = message;
    };
});

},{"./createErrorClass":"lwxRU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jNLLd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SequenceError", ()=>SequenceError);
var _createErrorClass = require("./createErrorClass");
var SequenceError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function SequenceErrorImpl(message) {
        _super(this);
        this.name = 'SequenceError';
        this.message = message;
    };
});

},{"./createErrorClass":"lwxRU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"d6r3h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeoutError", ()=>TimeoutError);
parcelHelpers.export(exports, "timeout", ()=>timeout);
var _async = require("../scheduler/async");
var _isDate = require("../util/isDate");
var _lift = require("../util/lift");
var _innerFrom = require("../observable/innerFrom");
var _createErrorClass = require("../util/createErrorClass");
var _operatorSubscriber = require("./OperatorSubscriber");
var _executeSchedule = require("../util/executeSchedule");
var TimeoutError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function TimeoutErrorImpl(info) {
        if (info === void 0) info = null;
        _super(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        this.info = info;
    };
});
function timeout(config, schedulerArg) {
    var _a = (0, _isDate.isValidDate)(config) ? {
        first: config
    } : typeof config === 'number' ? {
        each: config
    } : config, first = _a.first, each = _a.each, _b = _a.with, _with = _b === void 0 ? timeoutErrorFactory : _b, _c = _a.scheduler, scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : (0, _async.asyncScheduler) : _c, _d = _a.meta, meta = _d === void 0 ? null : _d;
    if (first == null && each == null) throw new TypeError('No timeout provided.');
    return (0, _lift.operate)(function(source, subscriber) {
        var originalSourceSubscription;
        var timerSubscription;
        var lastValue = null;
        var seen = 0;
        var startTimer = function(delay) {
            timerSubscription = (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                try {
                    originalSourceSubscription.unsubscribe();
                    (0, _innerFrom.innerFrom)(_with({
                        meta: meta,
                        lastValue: lastValue,
                        seen: seen
                    })).subscribe(subscriber);
                } catch (err) {
                    subscriber.error(err);
                }
            }, delay);
        };
        originalSourceSubscription = source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            seen++;
            subscriber.next(lastValue = value);
            each > 0 && startTimer(each);
        }, undefined, undefined, function() {
            if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            lastValue = null;
        }));
        !seen && startTimer(first != null ? typeof first === 'number' ? first : +first - scheduler.now() : each);
    });
}
function timeoutErrorFactory(info) {
    throw new TimeoutError(info);
}

},{"../scheduler/async":"fZcBE","../util/isDate":"9ikls","../util/lift":"4nOIb","../observable/innerFrom":"88jOZ","../util/createErrorClass":"lwxRU","./OperatorSubscriber":"aQPgL","../util/executeSchedule":"lgbnE","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9ikls":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidDate", ()=>isValidDate);
function isValidDate(value) {
    return value instanceof Date && !isNaN(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lpND8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindCallback", ()=>bindCallback);
var _bindCallbackInternals = require("./bindCallbackInternals");
function bindCallback(callbackFunc, resultSelector, scheduler) {
    return (0, _bindCallbackInternals.bindCallbackInternals)(false, callbackFunc, resultSelector, scheduler);
}

},{"./bindCallbackInternals":"adHa3","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"adHa3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindCallbackInternals", ()=>bindCallbackInternals);
var _tslib = require("tslib");
var _isScheduler = require("../util/isScheduler");
var _observable = require("../Observable");
var _subscribeOn = require("../operators/subscribeOn");
var _mapOneOrManyArgs = require("../util/mapOneOrManyArgs");
var _observeOn = require("../operators/observeOn");
var _asyncSubject = require("../AsyncSubject");
function bindCallbackInternals(isNodeStyle, callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if ((0, _isScheduler.isScheduler)(resultSelector)) scheduler = resultSelector;
        else return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return bindCallbackInternals(isNodeStyle, callbackFunc, scheduler).apply(this, args).pipe((0, _mapOneOrManyArgs.mapOneOrManyArgs)(resultSelector));
        };
    }
    if (scheduler) return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return bindCallbackInternals(isNodeStyle, callbackFunc).apply(this, args).pipe((0, _subscribeOn.subscribeOn)(scheduler), (0, _observeOn.observeOn)(scheduler));
    };
    return function() {
        var _this = this;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var subject = new (0, _asyncSubject.AsyncSubject)();
        var uninitialized = true;
        return new (0, _observable.Observable)(function(subscriber) {
            var subs = subject.subscribe(subscriber);
            if (uninitialized) {
                uninitialized = false;
                var isAsync_1 = false;
                var isComplete_1 = false;
                callbackFunc.apply(_this, (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(args)), [
                    function() {
                        var results = [];
                        for(var _i = 0; _i < arguments.length; _i++)results[_i] = arguments[_i];
                        if (isNodeStyle) {
                            var err = results.shift();
                            if (err != null) {
                                subject.error(err);
                                return;
                            }
                        }
                        subject.next(1 < results.length ? results : results[0]);
                        isComplete_1 = true;
                        if (isAsync_1) subject.complete();
                    }
                ]));
                if (isComplete_1) subject.complete();
                isAsync_1 = true;
            }
            return subs;
        });
    };
}

},{"tslib":"jH8wD","../util/isScheduler":"sl099","../Observable":"jrGyK","../operators/subscribeOn":"3TbCm","../util/mapOneOrManyArgs":"4t6bM","../operators/observeOn":"0Qy0C","../AsyncSubject":"6p0u8","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4t6bM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapOneOrManyArgs", ()=>mapOneOrManyArgs);
var _tslib = require("tslib");
var _map = require("../operators/map");
var isArray = Array.isArray;
function callOrApply(fn, args) {
    return isArray(args) ? fn.apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(args))) : fn(args);
}
function mapOneOrManyArgs(fn) {
    return (0, _map.map)(function(args) {
        return callOrApply(fn, args);
    });
}

},{"tslib":"jH8wD","../operators/map":"axudj","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"axudj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", ()=>map);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function map(project, thisArg) {
    return (0, _lift.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9Vyj2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindNodeCallback", ()=>bindNodeCallback);
var _bindCallbackInternals = require("./bindCallbackInternals");
function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    return (0, _bindCallbackInternals.bindCallbackInternals)(true, callbackFunc, resultSelector, scheduler);
}

},{"./bindCallbackInternals":"adHa3","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6HhEz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineLatest", ()=>combineLatest);
parcelHelpers.export(exports, "combineLatestInit", ()=>combineLatestInit);
var _observable = require("../Observable");
var _argsArgArrayOrObject = require("../util/argsArgArrayOrObject");
var _from = require("./from");
var _identity = require("../util/identity");
var _mapOneOrManyArgs = require("../util/mapOneOrManyArgs");
var _args = require("../util/args");
var _createObject = require("../util/createObject");
var _operatorSubscriber = require("../operators/OperatorSubscriber");
var _executeSchedule = require("../util/executeSchedule");
function combineLatest() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, _args.popScheduler)(args);
    var resultSelector = (0, _args.popResultSelector)(args);
    var _a = (0, _argsArgArrayOrObject.argsArgArrayOrObject)(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) return (0, _from.from)([], scheduler);
    var result = new (0, _observable.Observable)(combineLatestInit(observables, scheduler, keys ? function(values) {
        return (0, _createObject.createObject)(keys, values);
    } : (0, _identity.identity)));
    return resultSelector ? result.pipe((0, _mapOneOrManyArgs.mapOneOrManyArgs)(resultSelector)) : result;
}
function combineLatestInit(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) valueTransform = (0, _identity.identity);
    return function(subscriber) {
        maybeSchedule(scheduler, function() {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function(i) {
                maybeSchedule(scheduler, function() {
                    var source = (0, _from.from)(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) subscriber.next(valueTransform(values.slice()));
                    }, function() {
                        if (!--active) subscriber.complete();
                    }));
                }, subscriber);
            };
            for(var i = 0; i < length; i++)_loop_1(i);
        }, subscriber);
    };
}
function maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) (0, _executeSchedule.executeSchedule)(subscription, scheduler, execute);
    else execute();
}

},{"../Observable":"jrGyK","../util/argsArgArrayOrObject":"2auqk","./from":"hSPWH","../util/identity":"2CmIP","../util/mapOneOrManyArgs":"4t6bM","../util/args":"6vW91","../util/createObject":"k43Bc","../operators/OperatorSubscriber":"aQPgL","../util/executeSchedule":"lgbnE","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2auqk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "argsArgArrayOrObject", ()=>argsArgArrayOrObject);
var isArray = Array.isArray;
var getPrototypeOf = Object.getPrototypeOf, objectProto = Object.prototype, getKeys = Object.keys;
function argsArgArrayOrObject(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if (isArray(first_1)) return {
            args: first_1,
            keys: null
        };
        if (isPOJO(first_1)) {
            var keys = getKeys(first_1);
            return {
                args: keys.map(function(key) {
                    return first_1[key];
                }),
                keys: keys
            };
        }
    }
    return {
        args: args,
        keys: null
    };
}
function isPOJO(obj) {
    return obj && typeof obj === 'object' && getPrototypeOf(obj) === objectProto;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"k43Bc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createObject", ()=>createObject);
function createObject(keys, values) {
    return keys.reduce(function(result, key, i) {
        return result[key] = values[i], result;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"a3Gor":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concat", ()=>concat);
var _concatAll = require("../operators/concatAll");
var _args = require("../util/args");
var _from = require("./from");
function concat() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, _concatAll.concatAll)()((0, _from.from)(args, (0, _args.popScheduler)(args)));
}

},{"../operators/concatAll":"7HZAl","../util/args":"6vW91","./from":"hSPWH","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7HZAl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatAll", ()=>concatAll);
var _mergeAll = require("./mergeAll");
function concatAll() {
    return (0, _mergeAll.mergeAll)(1);
}

},{"./mergeAll":"74yhD","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"74yhD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeAll", ()=>mergeAll);
var _mergeMap = require("./mergeMap");
var _identity = require("../util/identity");
function mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, _mergeMap.mergeMap)((0, _identity.identity), concurrent);
}

},{"./mergeMap":"ehxC3","../util/identity":"2CmIP","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ehxC3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeMap", ()=>mergeMap);
var _map = require("./map");
var _innerFrom = require("../observable/innerFrom");
var _lift = require("../util/lift");
var _mergeInternals = require("./mergeInternals");
var _isFunction = require("../util/isFunction");
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, _isFunction.isFunction)(resultSelector)) return mergeMap(function(a, i) {
        return (0, _map.map)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, _innerFrom.innerFrom)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, _lift.operate)(function(source, subscriber) {
        return (0, _mergeInternals.mergeInternals)(source, subscriber, project, concurrent);
    });
}

},{"./map":"axudj","../observable/innerFrom":"88jOZ","../util/lift":"4nOIb","./mergeInternals":"hoGHO","../util/isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hoGHO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeInternals", ()=>mergeInternals);
var _innerFrom = require("../observable/innerFrom");
var _executeSchedule = require("../util/executeSchedule");
var _operatorSubscriber = require("./OperatorSubscriber");
function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, _innerFrom.innerFrom)(project(value, index++)).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, _executeSchedule.executeSchedule)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}

},{"../observable/innerFrom":"88jOZ","../util/executeSchedule":"lgbnE","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5Zxgo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "connectable", ()=>connectable);
var _subject = require("../Subject");
var _observable = require("../Observable");
var _defer = require("./defer");
var DEFAULT_CONFIG = {
    connector: function() {
        return new (0, _subject.Subject)();
    },
    resetOnDisconnect: true
};
function connectable(source, config) {
    if (config === void 0) config = DEFAULT_CONFIG;
    var connection = null;
    var connector = config.connector, _a = config.resetOnDisconnect, resetOnDisconnect = _a === void 0 ? true : _a;
    var subject = connector();
    var result = new (0, _observable.Observable)(function(subscriber) {
        return subject.subscribe(subscriber);
    });
    result.connect = function() {
        if (!connection || connection.closed) {
            connection = (0, _defer.defer)(function() {
                return source;
            }).subscribe(subject);
            if (resetOnDisconnect) connection.add(function() {
                return subject = connector();
            });
        }
        return connection;
    };
    return result;
}

},{"../Subject":"4Icpn","../Observable":"jrGyK","./defer":"jrwvq","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jrwvq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defer", ()=>defer);
var _observable = require("../Observable");
var _innerFrom = require("./innerFrom");
function defer(observableFactory) {
    return new (0, _observable.Observable)(function(subscriber) {
        (0, _innerFrom.innerFrom)(observableFactory()).subscribe(subscriber);
    });
}

},{"../Observable":"jrGyK","./innerFrom":"88jOZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ebE61":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forkJoin", ()=>forkJoin);
var _observable = require("../Observable");
var _argsArgArrayOrObject = require("../util/argsArgArrayOrObject");
var _innerFrom = require("./innerFrom");
var _args = require("../util/args");
var _operatorSubscriber = require("../operators/OperatorSubscriber");
var _mapOneOrManyArgs = require("../util/mapOneOrManyArgs");
var _createObject = require("../util/createObject");
function forkJoin() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resultSelector = (0, _args.popResultSelector)(args);
    var _a = (0, _argsArgArrayOrObject.argsArgArrayOrObject)(args), sources = _a.args, keys = _a.keys;
    var result = new (0, _observable.Observable)(function(subscriber) {
        var length = sources.length;
        if (!length) {
            subscriber.complete();
            return;
        }
        var values = new Array(length);
        var remainingCompletions = length;
        var remainingEmissions = length;
        var _loop_1 = function(sourceIndex) {
            var hasValue = false;
            (0, _innerFrom.innerFrom)(sources[sourceIndex]).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
                if (!hasValue) {
                    hasValue = true;
                    remainingEmissions--;
                }
                values[sourceIndex] = value;
            }, function() {
                return remainingCompletions--;
            }, undefined, function() {
                if (!remainingCompletions || !hasValue) {
                    if (!remainingEmissions) subscriber.next(keys ? (0, _createObject.createObject)(keys, values) : values);
                    subscriber.complete();
                }
            }));
        };
        for(var sourceIndex = 0; sourceIndex < length; sourceIndex++)_loop_1(sourceIndex);
    });
    return resultSelector ? result.pipe((0, _mapOneOrManyArgs.mapOneOrManyArgs)(resultSelector)) : result;
}

},{"../Observable":"jrGyK","../util/argsArgArrayOrObject":"2auqk","./innerFrom":"88jOZ","../util/args":"6vW91","../operators/OperatorSubscriber":"aQPgL","../util/mapOneOrManyArgs":"4t6bM","../util/createObject":"k43Bc","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hw20y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromEvent", ()=>fromEvent);
var _tslib = require("tslib");
var _innerFrom = require("../observable/innerFrom");
var _observable = require("../Observable");
var _mergeMap = require("../operators/mergeMap");
var _isArrayLike = require("../util/isArrayLike");
var _isFunction = require("../util/isFunction");
var _mapOneOrManyArgs = require("../util/mapOneOrManyArgs");
var nodeEventEmitterMethods = [
    'addListener',
    'removeListener'
];
var eventTargetMethods = [
    'addEventListener',
    'removeEventListener'
];
var jqueryMethods = [
    'on',
    'off'
];
function fromEvent(target, eventName, options, resultSelector) {
    if ((0, _isFunction.isFunction)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return fromEvent(target, eventName, options).pipe((0, _mapOneOrManyArgs.mapOneOrManyArgs)(resultSelector));
    var _a = (0, _tslib.__read)(isEventTarget(target) ? eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : isNodeStyleEventEmitter(target) ? nodeEventEmitterMethods.map(toCommonHandlerRegistry(target, eventName)) : isJQueryStyleEventEmitter(target) ? jqueryMethods.map(toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, _isArrayLike.isArrayLike)(target)) return (0, _mergeMap.mergeMap)(function(subTarget) {
            return fromEvent(subTarget, eventName, options);
        })((0, _innerFrom.innerFrom)(target));
    }
    if (!add) throw new TypeError('Invalid event target');
    return new (0, _observable.Observable)(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function isNodeStyleEventEmitter(target) {
    return (0, _isFunction.isFunction)(target.addListener) && (0, _isFunction.isFunction)(target.removeListener);
}
function isJQueryStyleEventEmitter(target) {
    return (0, _isFunction.isFunction)(target.on) && (0, _isFunction.isFunction)(target.off);
}
function isEventTarget(target) {
    return (0, _isFunction.isFunction)(target.addEventListener) && (0, _isFunction.isFunction)(target.removeEventListener);
}

},{"tslib":"jH8wD","../observable/innerFrom":"88jOZ","../Observable":"jrGyK","../operators/mergeMap":"ehxC3","../util/isArrayLike":"chfYX","../util/isFunction":"eS6zV","../util/mapOneOrManyArgs":"4t6bM","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lgInP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromEventPattern", ()=>fromEventPattern);
var _observable = require("../Observable");
var _isFunction = require("../util/isFunction");
var _mapOneOrManyArgs = require("../util/mapOneOrManyArgs");
function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) return fromEventPattern(addHandler, removeHandler).pipe((0, _mapOneOrManyArgs.mapOneOrManyArgs)(resultSelector));
    return new (0, _observable.Observable)(function(subscriber) {
        var handler = function() {
            var e = [];
            for(var _i = 0; _i < arguments.length; _i++)e[_i] = arguments[_i];
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue = addHandler(handler);
        return (0, _isFunction.isFunction)(removeHandler) ? function() {
            return removeHandler(handler, retValue);
        } : undefined;
    });
}

},{"../Observable":"jrGyK","../util/isFunction":"eS6zV","../util/mapOneOrManyArgs":"4t6bM","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"imCMc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generate", ()=>generate);
var _tslib = require("tslib");
var _identity = require("../util/identity");
var _isScheduler = require("../util/isScheduler");
var _defer = require("./defer");
var _scheduleIterable = require("../scheduled/scheduleIterable");
function generate(initialStateOrOptions, condition, iterate, resultSelectorOrScheduler, scheduler) {
    var _a, _b;
    var resultSelector;
    var initialState;
    if (arguments.length === 1) _a = initialStateOrOptions, initialState = _a.initialState, condition = _a.condition, iterate = _a.iterate, _b = _a.resultSelector, resultSelector = _b === void 0 ? (0, _identity.identity) : _b, scheduler = _a.scheduler;
    else {
        initialState = initialStateOrOptions;
        if (!resultSelectorOrScheduler || (0, _isScheduler.isScheduler)(resultSelectorOrScheduler)) {
            resultSelector = (0, _identity.identity);
            scheduler = resultSelectorOrScheduler;
        } else resultSelector = resultSelectorOrScheduler;
    }
    function gen() {
        var state;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    state = initialState;
                    _a.label = 1;
                case 1:
                    if (!(!condition || condition(state))) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        resultSelector(state)
                    ];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    state = iterate(state);
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }
    return (0, _defer.defer)(scheduler ? function() {
        return (0, _scheduleIterable.scheduleIterable)(gen(), scheduler);
    } : gen);
}

},{"tslib":"jH8wD","../util/identity":"2CmIP","../util/isScheduler":"sl099","./defer":"jrwvq","../scheduled/scheduleIterable":"hkvyy","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"c2dFs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "iif", ()=>iif);
var _defer = require("./defer");
function iif(condition, trueResult, falseResult) {
    return (0, _defer.defer)(function() {
        return condition() ? trueResult : falseResult;
    });
}

},{"./defer":"jrwvq","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ex0hC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interval", ()=>interval);
var _async = require("../scheduler/async");
var _timer = require("./timer");
function interval(period, scheduler) {
    if (period === void 0) period = 0;
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    if (period < 0) period = 0;
    return (0, _timer.timer)(period, period, scheduler);
}

},{"../scheduler/async":"fZcBE","./timer":"bUIVF","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bUIVF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timer", ()=>timer);
var _observable = require("../Observable");
var _async = require("../scheduler/async");
var _isScheduler = require("../util/isScheduler");
var _isDate = require("../util/isDate");
function timer(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = (0, _async.async);
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ((0, _isScheduler.isScheduler)(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new (0, _observable.Observable)(function(subscriber) {
        var due = (0, _isDate.isValidDate)(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}

},{"../Observable":"jrGyK","../scheduler/async":"fZcBE","../util/isScheduler":"sl099","../util/isDate":"9ikls","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5Ayeg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", ()=>merge);
var _mergeAll = require("../operators/mergeAll");
var _innerFrom = require("./innerFrom");
var _empty = require("./empty");
var _args = require("../util/args");
var _from = require("./from");
function merge() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, _args.popScheduler)(args);
    var concurrent = (0, _args.popNumber)(args, Infinity);
    var sources = args;
    return !sources.length ? (0, _empty.EMPTY) : sources.length === 1 ? (0, _innerFrom.innerFrom)(sources[0]) : (0, _mergeAll.mergeAll)(concurrent)((0, _from.from)(sources, scheduler));
}

},{"../operators/mergeAll":"74yhD","./innerFrom":"88jOZ","./empty":"tKukk","../util/args":"6vW91","./from":"hSPWH","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hLtGt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NEVER", ()=>NEVER);
parcelHelpers.export(exports, "never", ()=>never);
var _observable = require("../Observable");
var _noop = require("../util/noop");
var NEVER = new (0, _observable.Observable)((0, _noop.noop));
function never() {
    return NEVER;
}

},{"../Observable":"jrGyK","../util/noop":"bmpBW","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bJQtP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onErrorResumeNext", ()=>onErrorResumeNext);
var _observable = require("../Observable");
var _argsOrArgArray = require("../util/argsOrArgArray");
var _operatorSubscriber = require("../operators/OperatorSubscriber");
var _noop = require("../util/noop");
var _innerFrom = require("./innerFrom");
function onErrorResumeNext() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    var nextSources = (0, _argsOrArgArray.argsOrArgArray)(sources);
    return new (0, _observable.Observable)(function(subscriber) {
        var sourceIndex = 0;
        var subscribeNext = function() {
            if (sourceIndex < nextSources.length) {
                var nextSource = void 0;
                try {
                    nextSource = (0, _innerFrom.innerFrom)(nextSources[sourceIndex++]);
                } catch (err) {
                    subscribeNext();
                    return;
                }
                var innerSubscriber = new (0, _operatorSubscriber.OperatorSubscriber)(subscriber, undefined, (0, _noop.noop), (0, _noop.noop));
                nextSource.subscribe(innerSubscriber);
                innerSubscriber.add(subscribeNext);
            } else subscriber.complete();
        };
        subscribeNext();
    });
}

},{"../Observable":"jrGyK","../util/argsOrArgArray":"e5KrS","../operators/OperatorSubscriber":"aQPgL","../util/noop":"bmpBW","./innerFrom":"88jOZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"e5KrS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "argsOrArgArray", ()=>argsOrArgArray);
var isArray = Array.isArray;
function argsOrArgArray(args) {
    return args.length === 1 && isArray(args[0]) ? args[0] : args;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bXikl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pairs", ()=>pairs);
var _from = require("./from");
function pairs(obj, scheduler) {
    return (0, _from.from)(Object.entries(obj), scheduler);
}

},{"./from":"hSPWH","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"42MUk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "partition", ()=>partition);
var _not = require("../util/not");
var _filter = require("../operators/filter");
var _innerFrom = require("./innerFrom");
function partition(source, predicate, thisArg) {
    return [
        (0, _filter.filter)(predicate, thisArg)((0, _innerFrom.innerFrom)(source)),
        (0, _filter.filter)((0, _not.not)(predicate, thisArg))((0, _innerFrom.innerFrom)(source))
    ];
}

},{"../util/not":"8g14G","../operators/filter":"5uWPs","./innerFrom":"88jOZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8g14G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "not", ()=>not);
function not(pred, thisArg) {
    return function(value, index) {
        return !pred.call(thisArg, value, index);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5uWPs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filter", ()=>filter);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function filter(predicate, thisArg) {
    return (0, _lift.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"024Zl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "race", ()=>race);
parcelHelpers.export(exports, "raceInit", ()=>raceInit);
var _observable = require("../Observable");
var _innerFrom = require("./innerFrom");
var _argsOrArgArray = require("../util/argsOrArgArray");
var _operatorSubscriber = require("../operators/OperatorSubscriber");
function race() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    sources = (0, _argsOrArgArray.argsOrArgArray)(sources);
    return sources.length === 1 ? (0, _innerFrom.innerFrom)(sources[0]) : new (0, _observable.Observable)(raceInit(sources));
}
function raceInit(sources) {
    return function(subscriber) {
        var subscriptions = [];
        var _loop_1 = function(i) {
            subscriptions.push((0, _innerFrom.innerFrom)(sources[i]).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
                if (subscriptions) {
                    for(var s = 0; s < subscriptions.length; s++)s !== i && subscriptions[s].unsubscribe();
                    subscriptions = null;
                }
                subscriber.next(value);
            })));
        };
        for(var i = 0; subscriptions && !subscriber.closed && i < sources.length; i++)_loop_1(i);
    };
}

},{"../Observable":"jrGyK","./innerFrom":"88jOZ","../util/argsOrArgArray":"e5KrS","../operators/OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"21yES":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "range", ()=>range);
var _observable = require("../Observable");
var _empty = require("./empty");
function range(start, count, scheduler) {
    if (count == null) {
        count = start;
        start = 0;
    }
    if (count <= 0) return 0, _empty.EMPTY;
    var end = count + start;
    return new (0, _observable.Observable)(scheduler ? function(subscriber) {
        var n = start;
        return scheduler.schedule(function() {
            if (n < end) {
                subscriber.next(n++);
                this.schedule();
            } else subscriber.complete();
        });
    } : function(subscriber) {
        var n = start;
        while(n < end && !subscriber.closed)subscriber.next(n++);
        subscriber.complete();
    });
}

},{"../Observable":"jrGyK","./empty":"tKukk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9FOQn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "using", ()=>using);
var _observable = require("../Observable");
var _innerFrom = require("./innerFrom");
var _empty = require("./empty");
function using(resourceFactory, observableFactory) {
    return new (0, _observable.Observable)(function(subscriber) {
        var resource = resourceFactory();
        var result = observableFactory(resource);
        var source = result ? (0, _innerFrom.innerFrom)(result) : (0, _empty.EMPTY);
        source.subscribe(subscriber);
        return function() {
            if (resource) resource.unsubscribe();
        };
    });
}

},{"../Observable":"jrGyK","./innerFrom":"88jOZ","./empty":"tKukk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"er6av":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zip", ()=>zip);
var _tslib = require("tslib");
var _observable = require("../Observable");
var _innerFrom = require("./innerFrom");
var _argsOrArgArray = require("../util/argsOrArgArray");
var _empty = require("./empty");
var _operatorSubscriber = require("../operators/OperatorSubscriber");
var _args = require("../util/args");
function zip() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resultSelector = (0, _args.popResultSelector)(args);
    var sources = (0, _argsOrArgArray.argsOrArgArray)(args);
    return sources.length ? new (0, _observable.Observable)(function(subscriber) {
        var buffers = sources.map(function() {
            return [];
        });
        var completed = sources.map(function() {
            return false;
        });
        subscriber.add(function() {
            buffers = completed = null;
        });
        var _loop_1 = function(sourceIndex) {
            (0, _innerFrom.innerFrom)(sources[sourceIndex]).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
                buffers[sourceIndex].push(value);
                if (buffers.every(function(buffer) {
                    return buffer.length;
                })) {
                    var result = buffers.map(function(buffer) {
                        return buffer.shift();
                    });
                    subscriber.next(resultSelector ? resultSelector.apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(result))) : result);
                    if (buffers.some(function(buffer, i) {
                        return !buffer.length && completed[i];
                    })) subscriber.complete();
                }
            }, function() {
                completed[sourceIndex] = true;
                !buffers[sourceIndex].length && subscriber.complete();
            }));
        };
        for(var sourceIndex = 0; !subscriber.closed && sourceIndex < sources.length; sourceIndex++)_loop_1(sourceIndex);
        return function() {
            buffers = completed = null;
        };
    }) : (0, _empty.EMPTY);
}

},{"tslib":"jH8wD","../Observable":"jrGyK","./innerFrom":"88jOZ","../util/argsOrArgArray":"e5KrS","./empty":"tKukk","../operators/OperatorSubscriber":"aQPgL","../util/args":"6vW91","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bu2bz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"daTGs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audit", ()=>audit);
var _lift = require("../util/lift");
var _innerFrom = require("../observable/innerFrom");
var _operatorSubscriber = require("./OperatorSubscriber");
function audit(durationSelector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        var durationSubscriber = null;
        var isComplete = false;
        var endDuration = function() {
            durationSubscriber === null || durationSubscriber === void 0 || durationSubscriber.unsubscribe();
            durationSubscriber = null;
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
            isComplete && subscriber.complete();
        };
        var cleanupDuration = function() {
            durationSubscriber = null;
            isComplete && subscriber.complete();
        };
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            lastValue = value;
            if (!durationSubscriber) (0, _innerFrom.innerFrom)(durationSelector(value)).subscribe(durationSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, endDuration, cleanupDuration));
        }, function() {
            isComplete = true;
            (!hasValue || !durationSubscriber || durationSubscriber.closed) && subscriber.complete();
        }));
    });
}

},{"../util/lift":"4nOIb","../observable/innerFrom":"88jOZ","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gDfyR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "auditTime", ()=>auditTime);
var _async = require("../scheduler/async");
var _audit = require("./audit");
var _timer = require("../observable/timer");
function auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    return (0, _audit.audit)(function() {
        return (0, _timer.timer)(duration, scheduler);
    });
}

},{"../scheduler/async":"fZcBE","./audit":"daTGs","../observable/timer":"bUIVF","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dVnzm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buffer", ()=>buffer);
var _lift = require("../util/lift");
var _noop = require("../util/noop");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
function buffer(closingNotifier) {
    return (0, _lift.operate)(function(source, subscriber) {
        var currentBuffer = [];
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return currentBuffer.push(value);
        }, function() {
            subscriber.next(currentBuffer);
            subscriber.complete();
        }));
        (0, _innerFrom.innerFrom)(closingNotifier).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
            var b = currentBuffer;
            currentBuffer = [];
            subscriber.next(b);
        }, (0, _noop.noop)));
        return function() {
            currentBuffer = null;
        };
    });
}

},{"../util/lift":"4nOIb","../util/noop":"bmpBW","./OperatorSubscriber":"aQPgL","../observable/innerFrom":"88jOZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2SWMG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferCount", ()=>bufferCount);
var _tslib = require("tslib");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _arrRemove = require("../util/arrRemove");
function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) startBufferEvery = null;
    startBufferEvery = startBufferEvery !== null && startBufferEvery !== void 0 ? startBufferEvery : bufferSize;
    return (0, _lift.operate)(function(source, subscriber) {
        var buffers = [];
        var count = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var e_1, _a, e_2, _b;
            var toEmit = null;
            if (count++ % startBufferEvery === 0) buffers.push([]);
            try {
                for(var buffers_1 = (0, _tslib.__values)(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()){
                    var buffer = buffers_1_1.value;
                    buffer.push(value);
                    if (bufferSize <= buffer.length) {
                        toEmit = toEmit !== null && toEmit !== void 0 ? toEmit : [];
                        toEmit.push(buffer);
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            if (toEmit) try {
                for(var toEmit_1 = (0, _tslib.__values)(toEmit), toEmit_1_1 = toEmit_1.next(); !toEmit_1_1.done; toEmit_1_1 = toEmit_1.next()){
                    var buffer = toEmit_1_1.value;
                    (0, _arrRemove.arrRemove)(buffers, buffer);
                    subscriber.next(buffer);
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (toEmit_1_1 && !toEmit_1_1.done && (_b = toEmit_1.return)) _b.call(toEmit_1);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
        }, function() {
            var e_3, _a;
            try {
                for(var buffers_2 = (0, _tslib.__values)(buffers), buffers_2_1 = buffers_2.next(); !buffers_2_1.done; buffers_2_1 = buffers_2.next()){
                    var buffer = buffers_2_1.value;
                    subscriber.next(buffer);
                }
            } catch (e_3_1) {
                e_3 = {
                    error: e_3_1
                };
            } finally{
                try {
                    if (buffers_2_1 && !buffers_2_1.done && (_a = buffers_2.return)) _a.call(buffers_2);
                } finally{
                    if (e_3) throw e_3.error;
                }
            }
            subscriber.complete();
        }, undefined, function() {
            buffers = null;
        }));
    });
}

},{"tslib":"jH8wD","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","../util/arrRemove":"HRHom","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9VQL7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferTime", ()=>bufferTime);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _arrRemove = require("../util/arrRemove");
var _async = require("../scheduler/async");
var _args = require("../util/args");
var _executeSchedule = require("../util/executeSchedule");
function bufferTime(bufferTimeSpan) {
    var _a, _b;
    var otherArgs = [];
    for(var _i = 1; _i < arguments.length; _i++)otherArgs[_i - 1] = arguments[_i];
    var scheduler = (_a = (0, _args.popScheduler)(otherArgs)) !== null && _a !== void 0 ? _a : (0, _async.asyncScheduler);
    var bufferCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
    var maxBufferSize = otherArgs[1] || Infinity;
    return (0, _lift.operate)(function(source, subscriber) {
        var bufferRecords = [];
        var restartOnEmit = false;
        var emit = function(record) {
            var buffer = record.buffer, subs = record.subs;
            subs.unsubscribe();
            (0, _arrRemove.arrRemove)(bufferRecords, record);
            subscriber.next(buffer);
            restartOnEmit && startBuffer();
        };
        var startBuffer = function() {
            if (bufferRecords) {
                var subs = new (0, _subscription.Subscription)();
                subscriber.add(subs);
                var buffer = [];
                var record_1 = {
                    buffer: buffer,
                    subs: subs
                };
                bufferRecords.push(record_1);
                (0, _executeSchedule.executeSchedule)(subs, scheduler, function() {
                    return emit(record_1);
                }, bufferTimeSpan);
            }
        };
        if (bufferCreationInterval !== null && bufferCreationInterval >= 0) (0, _executeSchedule.executeSchedule)(subscriber, scheduler, startBuffer, bufferCreationInterval, true);
        else restartOnEmit = true;
        startBuffer();
        var bufferTimeSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var e_1, _a;
            var recordsCopy = bufferRecords.slice();
            try {
                for(var recordsCopy_1 = (0, _tslib.__values)(recordsCopy), recordsCopy_1_1 = recordsCopy_1.next(); !recordsCopy_1_1.done; recordsCopy_1_1 = recordsCopy_1.next()){
                    var record = recordsCopy_1_1.value;
                    var buffer = record.buffer;
                    buffer.push(value);
                    maxBufferSize <= buffer.length && emit(record);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (recordsCopy_1_1 && !recordsCopy_1_1.done && (_a = recordsCopy_1.return)) _a.call(recordsCopy_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }, function() {
            while(bufferRecords === null || bufferRecords === void 0 ? void 0 : bufferRecords.length)subscriber.next(bufferRecords.shift().buffer);
            bufferTimeSubscriber === null || bufferTimeSubscriber === void 0 || bufferTimeSubscriber.unsubscribe();
            subscriber.complete();
            subscriber.unsubscribe();
        }, undefined, function() {
            return bufferRecords = null;
        });
        source.subscribe(bufferTimeSubscriber);
    });
}

},{"tslib":"jH8wD","../Subscription":"iuJZ4","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","../util/arrRemove":"HRHom","../scheduler/async":"fZcBE","../util/args":"6vW91","../util/executeSchedule":"lgbnE","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bZtzK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferToggle", ()=>bufferToggle);
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var _lift = require("../util/lift");
var _innerFrom = require("../observable/innerFrom");
var _operatorSubscriber = require("./OperatorSubscriber");
var _noop = require("../util/noop");
var _arrRemove = require("../util/arrRemove");
function bufferToggle(openings, closingSelector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var buffers = [];
        (0, _innerFrom.innerFrom)(openings).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(openValue) {
            var buffer = [];
            buffers.push(buffer);
            var closingSubscription = new (0, _subscription.Subscription)();
            var emitBuffer = function() {
                (0, _arrRemove.arrRemove)(buffers, buffer);
                subscriber.next(buffer);
                closingSubscription.unsubscribe();
            };
            closingSubscription.add((0, _innerFrom.innerFrom)(closingSelector(openValue)).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, emitBuffer, (0, _noop.noop))));
        }, (0, _noop.noop)));
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var e_1, _a;
            try {
                for(var buffers_1 = (0, _tslib.__values)(buffers), buffers_1_1 = buffers_1.next(); !buffers_1_1.done; buffers_1_1 = buffers_1.next()){
                    var buffer = buffers_1_1.value;
                    buffer.push(value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (buffers_1_1 && !buffers_1_1.done && (_a = buffers_1.return)) _a.call(buffers_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }, function() {
            while(buffers.length > 0)subscriber.next(buffers.shift());
            subscriber.complete();
        }));
    });
}

},{"tslib":"jH8wD","../Subscription":"iuJZ4","../util/lift":"4nOIb","../observable/innerFrom":"88jOZ","./OperatorSubscriber":"aQPgL","../util/noop":"bmpBW","../util/arrRemove":"HRHom","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"CfKBQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bufferWhen", ()=>bufferWhen);
var _lift = require("../util/lift");
var _noop = require("../util/noop");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
function bufferWhen(closingSelector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var buffer = null;
        var closingSubscriber = null;
        var openBuffer = function() {
            closingSubscriber === null || closingSubscriber === void 0 || closingSubscriber.unsubscribe();
            var b = buffer;
            buffer = [];
            b && subscriber.next(b);
            (0, _innerFrom.innerFrom)(closingSelector()).subscribe(closingSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, openBuffer, (0, _noop.noop)));
        };
        openBuffer();
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return buffer === null || buffer === void 0 ? void 0 : buffer.push(value);
        }, function() {
            buffer && subscriber.next(buffer);
            subscriber.complete();
        }, undefined, function() {
            return buffer = closingSubscriber = null;
        }));
    });
}

},{"../util/lift":"4nOIb","../util/noop":"bmpBW","./OperatorSubscriber":"aQPgL","../observable/innerFrom":"88jOZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"j7N3U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "catchError", ()=>catchError);
var _innerFrom = require("../observable/innerFrom");
var _operatorSubscriber = require("./OperatorSubscriber");
var _lift = require("../util/lift");
function catchError(selector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, undefined, undefined, function(err) {
            handledResult = (0, _innerFrom.innerFrom)(selector(err, catchError(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}

},{"../observable/innerFrom":"88jOZ","./OperatorSubscriber":"aQPgL","../util/lift":"4nOIb","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1lMLg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineAll", ()=>combineAll);
var _combineLatestAll = require("./combineLatestAll");
var combineAll = (0, _combineLatestAll.combineLatestAll);

},{"./combineLatestAll":"h2M72","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"h2M72":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineLatestAll", ()=>combineLatestAll);
var _combineLatest = require("../observable/combineLatest");
var _joinAllInternals = require("./joinAllInternals");
function combineLatestAll(project) {
    return (0, _joinAllInternals.joinAllInternals)((0, _combineLatest.combineLatest), project);
}

},{"../observable/combineLatest":"6HhEz","./joinAllInternals":"crQT5","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"crQT5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "joinAllInternals", ()=>joinAllInternals);
var _identity = require("../util/identity");
var _mapOneOrManyArgs = require("../util/mapOneOrManyArgs");
var _pipe = require("../util/pipe");
var _mergeMap = require("./mergeMap");
var _toArray = require("./toArray");
function joinAllInternals(joinFn, project) {
    return (0, _pipe.pipe)((0, _toArray.toArray)(), (0, _mergeMap.mergeMap)(function(sources) {
        return joinFn(sources);
    }), project ? (0, _mapOneOrManyArgs.mapOneOrManyArgs)(project) : (0, _identity.identity));
}

},{"../util/identity":"2CmIP","../util/mapOneOrManyArgs":"4t6bM","../util/pipe":"1ZGFK","./mergeMap":"ehxC3","./toArray":"iKZD7","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iKZD7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toArray", ()=>toArray);
var _reduce = require("./reduce");
var _lift = require("../util/lift");
var arrReducer = function(arr, value) {
    return arr.push(value), arr;
};
function toArray() {
    return (0, _lift.operate)(function(source, subscriber) {
        (0, _reduce.reduce)(arrReducer, [])(source).subscribe(subscriber);
    });
}

},{"./reduce":"fAhkL","../util/lift":"4nOIb","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fAhkL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reduce", ()=>reduce);
var _scanInternals = require("./scanInternals");
var _lift = require("../util/lift");
function reduce(accumulator, seed) {
    return (0, _lift.operate)((0, _scanInternals.scanInternals)(accumulator, seed, arguments.length >= 2, false, true));
}

},{"./scanInternals":"bQBl1","../util/lift":"4nOIb","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bQBl1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scanInternals", ()=>scanInternals);
var _operatorSubscriber = require("./OperatorSubscriber");
function scanInternals(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function(source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var i = index++;
            state = hasState ? accumulator(state, value, i) : (hasState = true, value);
            emitOnNext && subscriber.next(state);
        }, emitBeforeComplete && function() {
            hasState && subscriber.next(state);
            subscriber.complete();
        }));
    };
}

},{"./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bj420":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineLatestWith", ()=>combineLatestWith);
var _tslib = require("tslib");
var _combineLatest = require("./combineLatest");
function combineLatestWith() {
    var otherSources = [];
    for(var _i = 0; _i < arguments.length; _i++)otherSources[_i] = arguments[_i];
    return (0, _combineLatest.combineLatest).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(otherSources)));
}

},{"tslib":"jH8wD","./combineLatest":"1ffJ9","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1ffJ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineLatest", ()=>combineLatest);
var _tslib = require("tslib");
var _combineLatest = require("../observable/combineLatest");
var _lift = require("../util/lift");
var _argsOrArgArray = require("../util/argsOrArgArray");
var _mapOneOrManyArgs = require("../util/mapOneOrManyArgs");
var _pipe = require("../util/pipe");
var _args = require("../util/args");
function combineLatest() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var resultSelector = (0, _args.popResultSelector)(args);
    return resultSelector ? (0, _pipe.pipe)(combineLatest.apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(args))), (0, _mapOneOrManyArgs.mapOneOrManyArgs)(resultSelector)) : (0, _lift.operate)(function(source, subscriber) {
        (0, _combineLatest.combineLatestInit)((0, _tslib.__spreadArray)([
            source
        ], (0, _tslib.__read)((0, _argsOrArgArray.argsOrArgArray)(args))))(subscriber);
    });
}

},{"tslib":"jH8wD","../observable/combineLatest":"6HhEz","../util/lift":"4nOIb","../util/argsOrArgArray":"e5KrS","../util/mapOneOrManyArgs":"4t6bM","../util/pipe":"1ZGFK","../util/args":"6vW91","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5uG7j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatMap", ()=>concatMap);
var _mergeMap = require("./mergeMap");
var _isFunction = require("../util/isFunction");
function concatMap(project, resultSelector) {
    return (0, _isFunction.isFunction)(resultSelector) ? (0, _mergeMap.mergeMap)(project, resultSelector, 1) : (0, _mergeMap.mergeMap)(project, 1);
}

},{"./mergeMap":"ehxC3","../util/isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cw85e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatMapTo", ()=>concatMapTo);
var _concatMap = require("./concatMap");
var _isFunction = require("../util/isFunction");
function concatMapTo(innerObservable, resultSelector) {
    return (0, _isFunction.isFunction)(resultSelector) ? (0, _concatMap.concatMap)(function() {
        return innerObservable;
    }, resultSelector) : (0, _concatMap.concatMap)(function() {
        return innerObservable;
    });
}

},{"./concatMap":"5uG7j","../util/isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"brG7g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatWith", ()=>concatWith);
var _tslib = require("tslib");
var _concat = require("./concat");
function concatWith() {
    var otherSources = [];
    for(var _i = 0; _i < arguments.length; _i++)otherSources[_i] = arguments[_i];
    return (0, _concat.concat).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(otherSources)));
}

},{"tslib":"jH8wD","./concat":"3ntID","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3ntID":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concat", ()=>concat);
var _tslib = require("tslib");
var _lift = require("../util/lift");
var _concatAll = require("./concatAll");
var _args = require("../util/args");
var _from = require("../observable/from");
function concat() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, _args.popScheduler)(args);
    return (0, _lift.operate)(function(source, subscriber) {
        (0, _concatAll.concatAll)()((0, _from.from)((0, _tslib.__spreadArray)([
            source
        ], (0, _tslib.__read)(args)), scheduler)).subscribe(subscriber);
    });
}

},{"tslib":"jH8wD","../util/lift":"4nOIb","./concatAll":"7HZAl","../util/args":"6vW91","../observable/from":"hSPWH","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6NlD1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "connect", ()=>connect);
var _subject = require("../Subject");
var _innerFrom = require("../observable/innerFrom");
var _lift = require("../util/lift");
var _fromSubscribable = require("../observable/fromSubscribable");
var DEFAULT_CONFIG = {
    connector: function() {
        return new (0, _subject.Subject)();
    }
};
function connect(selector, config) {
    if (config === void 0) config = DEFAULT_CONFIG;
    var connector = config.connector;
    return (0, _lift.operate)(function(source, subscriber) {
        var subject = connector();
        (0, _innerFrom.innerFrom)(selector((0, _fromSubscribable.fromSubscribable)(subject))).subscribe(subscriber);
        subscriber.add(source.subscribe(subject));
    });
}

},{"../Subject":"4Icpn","../observable/innerFrom":"88jOZ","../util/lift":"4nOIb","../observable/fromSubscribable":"3XnuG","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3XnuG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromSubscribable", ()=>fromSubscribable);
var _observable = require("../Observable");
function fromSubscribable(subscribable) {
    return new (0, _observable.Observable)(function(subscriber) {
        return subscribable.subscribe(subscriber);
    });
}

},{"../Observable":"jrGyK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5uqKy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "count", ()=>count);
var _reduce = require("./reduce");
function count(predicate) {
    return (0, _reduce.reduce)(function(total, value, i) {
        return !predicate || predicate(value, i) ? total + 1 : total;
    }, 0);
}

},{"./reduce":"fAhkL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"e2TQl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", ()=>debounce);
var _lift = require("../util/lift");
var _noop = require("../util/noop");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
function debounce(durationSelector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        var durationSubscriber = null;
        var emit = function() {
            durationSubscriber === null || durationSubscriber === void 0 || durationSubscriber.unsubscribe();
            durationSubscriber = null;
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            durationSubscriber === null || durationSubscriber === void 0 || durationSubscriber.unsubscribe();
            hasValue = true;
            lastValue = value;
            durationSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, emit, (0, _noop.noop));
            (0, _innerFrom.innerFrom)(durationSelector(value)).subscribe(durationSubscriber);
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = durationSubscriber = null;
        }));
    });
}

},{"../util/lift":"4nOIb","../util/noop":"bmpBW","./OperatorSubscriber":"aQPgL","../observable/innerFrom":"88jOZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"a3jha":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounceTime", ()=>debounceTime);
var _async = require("../scheduler/async");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    return (0, _lift.operate)(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function() {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = activeTask = null;
        }));
    });
}

},{"../scheduler/async":"fZcBE","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5xf0S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultIfEmpty", ()=>defaultIfEmpty);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function defaultIfEmpty(defaultValue) {
    return (0, _lift.operate)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            if (!hasValue) subscriber.next(defaultValue);
            subscriber.complete();
        }));
    });
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fSMvT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delay", ()=>delay);
var _async = require("../scheduler/async");
var _delayWhen = require("./delayWhen");
var _timer = require("../observable/timer");
function delay(due, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    var duration = (0, _timer.timer)(due, scheduler);
    return (0, _delayWhen.delayWhen)(function() {
        return duration;
    });
}

},{"../scheduler/async":"fZcBE","./delayWhen":"96Cih","../observable/timer":"bUIVF","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"96Cih":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delayWhen", ()=>delayWhen);
var _concat = require("../observable/concat");
var _take = require("./take");
var _ignoreElements = require("./ignoreElements");
var _mapTo = require("./mapTo");
var _mergeMap = require("./mergeMap");
var _innerFrom = require("../observable/innerFrom");
function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return (0, _concat.concat)(subscriptionDelay.pipe((0, _take.take)(1), (0, _ignoreElements.ignoreElements)()), source.pipe(delayWhen(delayDurationSelector)));
    };
    return (0, _mergeMap.mergeMap)(function(value, index) {
        return (0, _innerFrom.innerFrom)(delayDurationSelector(value, index)).pipe((0, _take.take)(1), (0, _mapTo.mapTo)(value));
    });
}

},{"../observable/concat":"a3Gor","./take":"5bXD5","./ignoreElements":"9axK3","./mapTo":"811pe","./mergeMap":"ehxC3","../observable/innerFrom":"88jOZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5bXD5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "take", ()=>take);
var _empty = require("../observable/empty");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function take(count) {
    return count <= 0 ? function() {
        return 0, _empty.EMPTY;
    } : (0, _lift.operate)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}

},{"../observable/empty":"tKukk","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9axK3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ignoreElements", ()=>ignoreElements);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _noop = require("../util/noop");
function ignoreElements() {
    return (0, _lift.operate)(function(source, subscriber) {
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, (0, _noop.noop)));
    });
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","../util/noop":"bmpBW","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"811pe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapTo", ()=>mapTo);
var _map = require("./map");
function mapTo(value) {
    return (0, _map.map)(function() {
        return value;
    });
}

},{"./map":"axudj","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5V8Z3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dematerialize", ()=>dematerialize);
var _notification = require("../Notification");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function dematerialize() {
    return (0, _lift.operate)(function(source, subscriber) {
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(notification) {
            return (0, _notification.observeNotification)(notification, subscriber);
        }));
    });
}

},{"../Notification":"46g2P","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hwb2B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distinct", ()=>distinct);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _noop = require("../util/noop");
var _innerFrom = require("../observable/innerFrom");
function distinct(keySelector, flushes) {
    return (0, _lift.operate)(function(source, subscriber) {
        var distinctKeys = new Set();
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var key = keySelector ? keySelector(value) : value;
            if (!distinctKeys.has(key)) {
                distinctKeys.add(key);
                subscriber.next(value);
            }
        }));
        flushes && (0, _innerFrom.innerFrom)(flushes).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
            return distinctKeys.clear();
        }, (0, _noop.noop)));
    });
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","../util/noop":"bmpBW","../observable/innerFrom":"88jOZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cttga":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distinctUntilChanged", ()=>distinctUntilChanged);
var _identity = require("../util/identity");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function distinctUntilChanged(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, _identity.identity);
    comparator = comparator !== null && comparator !== void 0 ? comparator : defaultCompare;
    return (0, _lift.operate)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function defaultCompare(a, b) {
    return a === b;
}

},{"../util/identity":"2CmIP","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9BKLM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>distinctUntilKeyChanged);
var _distinctUntilChanged = require("./distinctUntilChanged");
function distinctUntilKeyChanged(key, compare) {
    return (0, _distinctUntilChanged.distinctUntilChanged)(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}

},{"./distinctUntilChanged":"cttga","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bOBBu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "elementAt", ()=>elementAt);
var _argumentOutOfRangeError = require("../util/ArgumentOutOfRangeError");
var _filter = require("./filter");
var _throwIfEmpty = require("./throwIfEmpty");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _take = require("./take");
function elementAt(index, defaultValue) {
    if (index < 0) throw new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError)();
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe((0, _filter.filter)(function(v, i) {
            return i === index;
        }), (0, _take.take)(1), hasDefaultValue ? (0, _defaultIfEmpty.defaultIfEmpty)(defaultValue) : (0, _throwIfEmpty.throwIfEmpty)(function() {
            return new (0, _argumentOutOfRangeError.ArgumentOutOfRangeError)();
        }));
    };
}

},{"../util/ArgumentOutOfRangeError":"1Vgkw","./filter":"5uWPs","./throwIfEmpty":"al37L","./defaultIfEmpty":"5xf0S","./take":"5bXD5","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"al37L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throwIfEmpty", ()=>throwIfEmpty);
var _emptyError = require("../util/EmptyError");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function throwIfEmpty(errorFactory) {
    if (errorFactory === void 0) errorFactory = defaultErrorFactory;
    return (0, _lift.operate)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            return hasValue ? subscriber.complete() : subscriber.error(errorFactory());
        }));
    });
}
function defaultErrorFactory() {
    return new (0, _emptyError.EmptyError)();
}

},{"../util/EmptyError":"Cu2oV","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fx8gJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "endWith", ()=>endWith);
var _tslib = require("tslib");
var _concat = require("../observable/concat");
var _of = require("../observable/of");
function endWith() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return function(source) {
        return (0, _concat.concat)(source, (0, _of.of).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(values))));
    };
}

},{"tslib":"jH8wD","../observable/concat":"a3Gor","../observable/of":"cH8fx","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"c5eHD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "every", ()=>every);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function every(predicate, thisArg) {
    return (0, _lift.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            if (!predicate.call(thisArg, value, index++, source)) {
                subscriber.next(false);
                subscriber.complete();
            }
        }, function() {
            subscriber.next(true);
            subscriber.complete();
        }));
    });
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2SUOw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exhaust", ()=>exhaust);
var _exhaustAll = require("./exhaustAll");
var exhaust = (0, _exhaustAll.exhaustAll);

},{"./exhaustAll":"l7Zrp","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"l7Zrp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exhaustAll", ()=>exhaustAll);
var _exhaustMap = require("./exhaustMap");
var _identity = require("../util/identity");
function exhaustAll() {
    return (0, _exhaustMap.exhaustMap)((0, _identity.identity));
}

},{"./exhaustMap":"kstpi","../util/identity":"2CmIP","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kstpi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exhaustMap", ()=>exhaustMap);
var _map = require("./map");
var _innerFrom = require("../observable/innerFrom");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function exhaustMap(project, resultSelector) {
    if (resultSelector) return function(source) {
        return source.pipe(exhaustMap(function(a, i) {
            return (0, _innerFrom.innerFrom)(project(a, i)).pipe((0, _map.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }));
    };
    return (0, _lift.operate)(function(source, subscriber) {
        var index = 0;
        var innerSub = null;
        var isComplete = false;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(outerValue) {
            if (!innerSub) {
                innerSub = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, undefined, function() {
                    innerSub = null;
                    isComplete && subscriber.complete();
                });
                (0, _innerFrom.innerFrom)(project(outerValue, index++)).subscribe(innerSub);
            }
        }, function() {
            isComplete = true;
            !innerSub && subscriber.complete();
        }));
    });
}

},{"./map":"axudj","../observable/innerFrom":"88jOZ","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2ALAW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "expand", ()=>expand);
var _lift = require("../util/lift");
var _mergeInternals = require("./mergeInternals");
function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Infinity;
    concurrent = (concurrent || 0) < 1 ? Infinity : concurrent;
    return (0, _lift.operate)(function(source, subscriber) {
        return (0, _mergeInternals.mergeInternals)(source, subscriber, project, concurrent, undefined, true, scheduler);
    });
}

},{"../util/lift":"4nOIb","./mergeInternals":"hoGHO","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"81pRQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "finalize", ()=>finalize);
var _lift = require("../util/lift");
function finalize(callback) {
    return (0, _lift.operate)(function(source, subscriber) {
        try {
            source.subscribe(subscriber);
        } finally{
            subscriber.add(callback);
        }
    });
}

},{"../util/lift":"4nOIb","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"h3LwP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "find", ()=>find);
parcelHelpers.export(exports, "createFind", ()=>createFind);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function find(predicate, thisArg) {
    return (0, _lift.operate)(createFind(predicate, thisArg, 'value'));
}
function createFind(predicate, thisArg, emit) {
    var findIndex = emit === 'index';
    return function(source, subscriber) {
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var i = index++;
            if (predicate.call(thisArg, value, i, source)) {
                subscriber.next(findIndex ? i : value);
                subscriber.complete();
            }
        }, function() {
            subscriber.next(findIndex ? -1 : undefined);
            subscriber.complete();
        }));
    };
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9cmYI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findIndex", ()=>findIndex);
var _lift = require("../util/lift");
var _find = require("./find");
function findIndex(predicate, thisArg) {
    return (0, _lift.operate)((0, _find.createFind)(predicate, thisArg, 'index'));
}

},{"../util/lift":"4nOIb","./find":"h3LwP","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3wDHa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "first", ()=>first);
var _emptyError = require("../util/EmptyError");
var _filter = require("./filter");
var _take = require("./take");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _throwIfEmpty = require("./throwIfEmpty");
var _identity = require("../util/identity");
function first(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, _filter.filter)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, _identity.identity), (0, _take.take)(1), hasDefaultValue ? (0, _defaultIfEmpty.defaultIfEmpty)(defaultValue) : (0, _throwIfEmpty.throwIfEmpty)(function() {
            return new (0, _emptyError.EmptyError)();
        }));
    };
}

},{"../util/EmptyError":"Cu2oV","./filter":"5uWPs","./take":"5bXD5","./defaultIfEmpty":"5xf0S","./throwIfEmpty":"al37L","../util/identity":"2CmIP","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hx2TZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "groupBy", ()=>groupBy);
var _observable = require("../Observable");
var _innerFrom = require("../observable/innerFrom");
var _subject = require("../Subject");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function groupBy(keySelector, elementOrOptions, duration, connector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var element;
        if (!elementOrOptions || typeof elementOrOptions === 'function') element = elementOrOptions;
        else duration = elementOrOptions.duration, element = elementOrOptions.element, connector = elementOrOptions.connector;
        var groups = new Map();
        var notify = function(cb) {
            groups.forEach(cb);
            cb(subscriber);
        };
        var handleError = function(err) {
            return notify(function(consumer) {
                return consumer.error(err);
            });
        };
        var activeGroups = 0;
        var teardownAttempted = false;
        var groupBySourceSubscriber = new (0, _operatorSubscriber.OperatorSubscriber)(subscriber, function(value) {
            try {
                var key_1 = keySelector(value);
                var group_1 = groups.get(key_1);
                if (!group_1) {
                    groups.set(key_1, group_1 = connector ? connector() : new (0, _subject.Subject)());
                    var grouped = createGroupedObservable(key_1, group_1);
                    subscriber.next(grouped);
                    if (duration) {
                        var durationSubscriber_1 = (0, _operatorSubscriber.createOperatorSubscriber)(group_1, function() {
                            group_1.complete();
                            durationSubscriber_1 === null || durationSubscriber_1 === void 0 || durationSubscriber_1.unsubscribe();
                        }, undefined, undefined, function() {
                            return groups.delete(key_1);
                        });
                        groupBySourceSubscriber.add((0, _innerFrom.innerFrom)(duration(grouped)).subscribe(durationSubscriber_1));
                    }
                }
                group_1.next(element ? element(value) : value);
            } catch (err) {
                handleError(err);
            }
        }, function() {
            return notify(function(consumer) {
                return consumer.complete();
            });
        }, handleError, function() {
            return groups.clear();
        }, function() {
            teardownAttempted = true;
            return activeGroups === 0;
        });
        source.subscribe(groupBySourceSubscriber);
        function createGroupedObservable(key, groupSubject) {
            var result = new (0, _observable.Observable)(function(groupSubscriber) {
                activeGroups++;
                var innerSub = groupSubject.subscribe(groupSubscriber);
                return function() {
                    innerSub.unsubscribe();
                    --activeGroups === 0 && teardownAttempted && groupBySourceSubscriber.unsubscribe();
                };
            });
            result.key = key;
            return result;
        }
    });
}

},{"../Observable":"jrGyK","../observable/innerFrom":"88jOZ","../Subject":"4Icpn","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1QgiI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function isEmpty() {
    return (0, _lift.operate)(function(source, subscriber) {
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
            subscriber.next(false);
            subscriber.complete();
        }, function() {
            subscriber.next(true);
            subscriber.complete();
        }));
    });
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4fDgS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "last", ()=>last);
var _emptyError = require("../util/EmptyError");
var _filter = require("./filter");
var _takeLast = require("./takeLast");
var _throwIfEmpty = require("./throwIfEmpty");
var _defaultIfEmpty = require("./defaultIfEmpty");
var _identity = require("../util/identity");
function last(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, _filter.filter)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, _identity.identity), (0, _takeLast.takeLast)(1), hasDefaultValue ? (0, _defaultIfEmpty.defaultIfEmpty)(defaultValue) : (0, _throwIfEmpty.throwIfEmpty)(function() {
            return new (0, _emptyError.EmptyError)();
        }));
    };
}

},{"../util/EmptyError":"Cu2oV","./filter":"5uWPs","./takeLast":"eW2If","./throwIfEmpty":"al37L","./defaultIfEmpty":"5xf0S","../util/identity":"2CmIP","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eW2If":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takeLast", ()=>takeLast);
var _tslib = require("tslib");
var _empty = require("../observable/empty");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function takeLast(count) {
    return count <= 0 ? function() {
        return 0, _empty.EMPTY;
    } : (0, _lift.operate)(function(source, subscriber) {
        var buffer = [];
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            buffer.push(value);
            count < buffer.length && buffer.shift();
        }, function() {
            var e_1, _a;
            try {
                for(var buffer_1 = (0, _tslib.__values)(buffer), buffer_1_1 = buffer_1.next(); !buffer_1_1.done; buffer_1_1 = buffer_1.next()){
                    var value = buffer_1_1.value;
                    subscriber.next(value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (buffer_1_1 && !buffer_1_1.done && (_a = buffer_1.return)) _a.call(buffer_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            subscriber.complete();
        }, undefined, function() {
            buffer = null;
        }));
    });
}

},{"tslib":"jH8wD","../observable/empty":"tKukk","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bfk5y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "materialize", ()=>materialize);
var _notification = require("../Notification");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function materialize() {
    return (0, _lift.operate)(function(source, subscriber) {
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next((0, _notification.Notification).createNext(value));
        }, function() {
            subscriber.next((0, _notification.Notification).createComplete());
            subscriber.complete();
        }, function(err) {
            subscriber.next((0, _notification.Notification).createError(err));
            subscriber.complete();
        }));
    });
}

},{"../Notification":"46g2P","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cTEAZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", ()=>max);
var _reduce = require("./reduce");
var _isFunction = require("../util/isFunction");
function max(comparer) {
    return (0, _reduce.reduce)((0, _isFunction.isFunction)(comparer) ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    });
}

},{"./reduce":"fAhkL","../util/isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"L6jye":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "flatMap", ()=>flatMap);
var _mergeMap = require("./mergeMap");
var flatMap = (0, _mergeMap.mergeMap);

},{"./mergeMap":"ehxC3","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"l9u0a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeMapTo", ()=>mergeMapTo);
var _mergeMap = require("./mergeMap");
var _isFunction = require("../util/isFunction");
function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, _isFunction.isFunction)(resultSelector)) return (0, _mergeMap.mergeMap)(function() {
        return innerObservable;
    }, resultSelector, concurrent);
    if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, _mergeMap.mergeMap)(function() {
        return innerObservable;
    }, concurrent);
}

},{"./mergeMap":"ehxC3","../util/isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ko59c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeScan", ()=>mergeScan);
var _lift = require("../util/lift");
var _mergeInternals = require("./mergeInternals");
function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, _lift.operate)(function(source, subscriber) {
        var state = seed;
        return (0, _mergeInternals.mergeInternals)(source, subscriber, function(value, index) {
            return accumulator(state, value, index);
        }, concurrent, function(value) {
            state = value;
        }, false, undefined, function() {
            return state = null;
        });
    });
}

},{"../util/lift":"4nOIb","./mergeInternals":"hoGHO","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cbWWZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeWith", ()=>mergeWith);
var _tslib = require("tslib");
var _merge = require("./merge");
function mergeWith() {
    var otherSources = [];
    for(var _i = 0; _i < arguments.length; _i++)otherSources[_i] = arguments[_i];
    return (0, _merge.merge).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(otherSources)));
}

},{"tslib":"jH8wD","./merge":"evr4l","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"evr4l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", ()=>merge);
var _tslib = require("tslib");
var _lift = require("../util/lift");
var _argsOrArgArray = require("../util/argsOrArgArray");
var _mergeAll = require("./mergeAll");
var _args = require("../util/args");
var _from = require("../observable/from");
function merge() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, _args.popScheduler)(args);
    var concurrent = (0, _args.popNumber)(args, Infinity);
    args = (0, _argsOrArgArray.argsOrArgArray)(args);
    return (0, _lift.operate)(function(source, subscriber) {
        (0, _mergeAll.mergeAll)(concurrent)((0, _from.from)((0, _tslib.__spreadArray)([
            source
        ], (0, _tslib.__read)(args)), scheduler)).subscribe(subscriber);
    });
}

},{"tslib":"jH8wD","../util/lift":"4nOIb","../util/argsOrArgArray":"e5KrS","./mergeAll":"74yhD","../util/args":"6vW91","../observable/from":"hSPWH","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cVBv7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "min", ()=>min);
var _reduce = require("./reduce");
var _isFunction = require("../util/isFunction");
function min(comparer) {
    return (0, _reduce.reduce)((0, _isFunction.isFunction)(comparer) ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    });
}

},{"./reduce":"fAhkL","../util/isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jhjD3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "multicast", ()=>multicast);
var _connectableObservable = require("../observable/ConnectableObservable");
var _isFunction = require("../util/isFunction");
var _connect = require("./connect");
function multicast(subjectOrSubjectFactory, selector) {
    var subjectFactory = (0, _isFunction.isFunction)(subjectOrSubjectFactory) ? subjectOrSubjectFactory : function() {
        return subjectOrSubjectFactory;
    };
    if ((0, _isFunction.isFunction)(selector)) return (0, _connect.connect)(selector, {
        connector: subjectFactory
    });
    return function(source) {
        return new (0, _connectableObservable.ConnectableObservable)(source, subjectFactory);
    };
}

},{"../observable/ConnectableObservable":"kYoRv","../util/isFunction":"eS6zV","./connect":"6NlD1","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8dj7U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onErrorResumeNextWith", ()=>onErrorResumeNextWith);
parcelHelpers.export(exports, "onErrorResumeNext", ()=>onErrorResumeNext);
var _tslib = require("tslib");
var _argsOrArgArray = require("../util/argsOrArgArray");
var _onErrorResumeNext = require("../observable/onErrorResumeNext");
function onErrorResumeNextWith() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    var nextSources = (0, _argsOrArgArray.argsOrArgArray)(sources);
    return function(source) {
        return (0, _onErrorResumeNext.onErrorResumeNext).apply(void 0, (0, _tslib.__spreadArray)([
            source
        ], (0, _tslib.__read)(nextSources)));
    };
}
var onErrorResumeNext = onErrorResumeNextWith;

},{"tslib":"jH8wD","../util/argsOrArgArray":"e5KrS","../observable/onErrorResumeNext":"bJQtP","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"24DPj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pairwise", ()=>pairwise);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function pairwise() {
    return (0, _lift.operate)(function(source, subscriber) {
        var prev;
        var hasPrev = false;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var p = prev;
            prev = value;
            hasPrev && subscriber.next([
                p,
                value
            ]);
            hasPrev = true;
        }));
    });
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iO80A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pluck", ()=>pluck);
var _map = require("./map");
function pluck() {
    var properties = [];
    for(var _i = 0; _i < arguments.length; _i++)properties[_i] = arguments[_i];
    var length = properties.length;
    if (length === 0) throw new Error('list of properties cannot be empty.');
    return (0, _map.map)(function(x) {
        var currentProp = x;
        for(var i = 0; i < length; i++){
            var p = currentProp === null || currentProp === void 0 ? void 0 : currentProp[properties[i]];
            if (typeof p !== 'undefined') currentProp = p;
            else return undefined;
        }
        return currentProp;
    });
}

},{"./map":"axudj","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"diZb6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publish", ()=>publish);
var _subject = require("../Subject");
var _multicast = require("./multicast");
var _connect = require("./connect");
function publish(selector) {
    return selector ? function(source) {
        return (0, _connect.connect)(selector)(source);
    } : function(source) {
        return (0, _multicast.multicast)(new (0, _subject.Subject)())(source);
    };
}

},{"../Subject":"4Icpn","./multicast":"jhjD3","./connect":"6NlD1","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"e5QSX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publishBehavior", ()=>publishBehavior);
var _behaviorSubject = require("../BehaviorSubject");
var _connectableObservable = require("../observable/ConnectableObservable");
function publishBehavior(initialValue) {
    return function(source) {
        var subject = new (0, _behaviorSubject.BehaviorSubject)(initialValue);
        return new (0, _connectableObservable.ConnectableObservable)(source, function() {
            return subject;
        });
    };
}

},{"../BehaviorSubject":"cMDx8","../observable/ConnectableObservable":"kYoRv","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7KiIc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publishLast", ()=>publishLast);
var _asyncSubject = require("../AsyncSubject");
var _connectableObservable = require("../observable/ConnectableObservable");
function publishLast() {
    return function(source) {
        var subject = new (0, _asyncSubject.AsyncSubject)();
        return new (0, _connectableObservable.ConnectableObservable)(source, function() {
            return subject;
        });
    };
}

},{"../AsyncSubject":"6p0u8","../observable/ConnectableObservable":"kYoRv","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eKmm3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publishReplay", ()=>publishReplay);
var _replaySubject = require("../ReplaySubject");
var _multicast = require("./multicast");
var _isFunction = require("../util/isFunction");
function publishReplay(bufferSize, windowTime, selectorOrScheduler, timestampProvider) {
    if (selectorOrScheduler && !(0, _isFunction.isFunction)(selectorOrScheduler)) timestampProvider = selectorOrScheduler;
    var selector = (0, _isFunction.isFunction)(selectorOrScheduler) ? selectorOrScheduler : undefined;
    return function(source) {
        return (0, _multicast.multicast)(new (0, _replaySubject.ReplaySubject)(bufferSize, windowTime, timestampProvider), selector)(source);
    };
}

},{"../ReplaySubject":"hpUH1","./multicast":"jhjD3","../util/isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"CtY2T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "raceWith", ()=>raceWith);
var _tslib = require("tslib");
var _race = require("../observable/race");
var _lift = require("../util/lift");
var _identity = require("../util/identity");
function raceWith() {
    var otherSources = [];
    for(var _i = 0; _i < arguments.length; _i++)otherSources[_i] = arguments[_i];
    return !otherSources.length ? (0, _identity.identity) : (0, _lift.operate)(function(source, subscriber) {
        (0, _race.raceInit)((0, _tslib.__spreadArray)([
            source
        ], (0, _tslib.__read)(otherSources)))(subscriber);
    });
}

},{"tslib":"jH8wD","../observable/race":"024Zl","../util/lift":"4nOIb","../util/identity":"2CmIP","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iv6eo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "repeat", ()=>repeat);
var _empty = require("../observable/empty");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
var _timer = require("../observable/timer");
function repeat(countOrConfig) {
    var _a;
    var count = Infinity;
    var delay;
    if (countOrConfig != null) {
        if (typeof countOrConfig === 'object') _a = countOrConfig.count, count = _a === void 0 ? Infinity : _a, delay = countOrConfig.delay;
        else count = countOrConfig;
    }
    return count <= 0 ? function() {
        return 0, _empty.EMPTY;
    } : (0, _lift.operate)(function(source, subscriber) {
        var soFar = 0;
        var sourceSub;
        var resubscribe = function() {
            sourceSub === null || sourceSub === void 0 || sourceSub.unsubscribe();
            sourceSub = null;
            if (delay != null) {
                var notifier = typeof delay === 'number' ? (0, _timer.timer)(delay) : (0, _innerFrom.innerFrom)(delay(soFar));
                var notifierSubscriber_1 = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
                    notifierSubscriber_1.unsubscribe();
                    subscribeToSource();
                });
                notifier.subscribe(notifierSubscriber_1);
            } else subscribeToSource();
        };
        var subscribeToSource = function() {
            var syncUnsub = false;
            sourceSub = source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, undefined, function() {
                if (++soFar < count) {
                    if (sourceSub) resubscribe();
                    else syncUnsub = true;
                } else subscriber.complete();
            }));
            if (syncUnsub) resubscribe();
        };
        subscribeToSource();
    });
}

},{"../observable/empty":"tKukk","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","../observable/innerFrom":"88jOZ","../observable/timer":"bUIVF","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fkbVy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "repeatWhen", ()=>repeatWhen);
var _innerFrom = require("../observable/innerFrom");
var _subject = require("../Subject");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function repeatWhen(notifier) {
    return (0, _lift.operate)(function(source, subscriber) {
        var innerSub;
        var syncResub = false;
        var completions$;
        var isNotifierComplete = false;
        var isMainComplete = false;
        var checkComplete = function() {
            return isMainComplete && isNotifierComplete && (subscriber.complete(), true);
        };
        var getCompletionSubject = function() {
            if (!completions$) {
                completions$ = new (0, _subject.Subject)();
                (0, _innerFrom.innerFrom)(notifier(completions$)).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
                    if (innerSub) subscribeForRepeatWhen();
                    else syncResub = true;
                }, function() {
                    isNotifierComplete = true;
                    checkComplete();
                }));
            }
            return completions$;
        };
        var subscribeForRepeatWhen = function() {
            isMainComplete = false;
            innerSub = source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, undefined, function() {
                isMainComplete = true;
                !checkComplete() && getCompletionSubject().next();
            }));
            if (syncResub) {
                innerSub.unsubscribe();
                innerSub = null;
                syncResub = false;
                subscribeForRepeatWhen();
            }
        };
        subscribeForRepeatWhen();
    });
}

},{"../observable/innerFrom":"88jOZ","../Subject":"4Icpn","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1mz4x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retry", ()=>retry);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _identity = require("../util/identity");
var _timer = require("../observable/timer");
var _innerFrom = require("../observable/innerFrom");
function retry(configOrCount) {
    if (configOrCount === void 0) configOrCount = Infinity;
    var config;
    if (configOrCount && typeof configOrCount === 'object') config = configOrCount;
    else config = {
        count: configOrCount
    };
    var _a = config.count, count = _a === void 0 ? Infinity : _a, delay = config.delay, _b = config.resetOnSuccess, resetOnSuccess = _b === void 0 ? false : _b;
    return count <= 0 ? (0, _identity.identity) : (0, _lift.operate)(function(source, subscriber) {
        var soFar = 0;
        var innerSub;
        var subscribeForRetry = function() {
            var syncUnsub = false;
            innerSub = source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
                if (resetOnSuccess) soFar = 0;
                subscriber.next(value);
            }, undefined, function(err) {
                if (soFar++ < count) {
                    var resub_1 = function() {
                        if (innerSub) {
                            innerSub.unsubscribe();
                            innerSub = null;
                            subscribeForRetry();
                        } else syncUnsub = true;
                    };
                    if (delay != null) {
                        var notifier = typeof delay === 'number' ? (0, _timer.timer)(delay) : (0, _innerFrom.innerFrom)(delay(err, soFar));
                        var notifierSubscriber_1 = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
                            notifierSubscriber_1.unsubscribe();
                            resub_1();
                        }, function() {
                            subscriber.complete();
                        });
                        notifier.subscribe(notifierSubscriber_1);
                    } else resub_1();
                } else subscriber.error(err);
            }));
            if (syncUnsub) {
                innerSub.unsubscribe();
                innerSub = null;
                subscribeForRetry();
            }
        };
        subscribeForRetry();
    });
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","../util/identity":"2CmIP","../observable/timer":"bUIVF","../observable/innerFrom":"88jOZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8VrMd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retryWhen", ()=>retryWhen);
var _innerFrom = require("../observable/innerFrom");
var _subject = require("../Subject");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function retryWhen(notifier) {
    return (0, _lift.operate)(function(source, subscriber) {
        var innerSub;
        var syncResub = false;
        var errors$;
        var subscribeForRetryWhen = function() {
            innerSub = source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, undefined, undefined, function(err) {
                if (!errors$) {
                    errors$ = new (0, _subject.Subject)();
                    (0, _innerFrom.innerFrom)(notifier(errors$)).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
                        return innerSub ? subscribeForRetryWhen() : syncResub = true;
                    }));
                }
                if (errors$) errors$.next(err);
            }));
            if (syncResub) {
                innerSub.unsubscribe();
                innerSub = null;
                syncResub = false;
                subscribeForRetryWhen();
            }
        };
        subscribeForRetryWhen();
    });
}

},{"../observable/innerFrom":"88jOZ","../Subject":"4Icpn","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2POSe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sample", ()=>sample);
var _innerFrom = require("../observable/innerFrom");
var _lift = require("../util/lift");
var _noop = require("../util/noop");
var _operatorSubscriber = require("./OperatorSubscriber");
function sample(notifier) {
    return (0, _lift.operate)(function(source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            lastValue = value;
        }));
        (0, _innerFrom.innerFrom)(notifier).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
            if (hasValue) {
                hasValue = false;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        }, (0, _noop.noop)));
    });
}

},{"../observable/innerFrom":"88jOZ","../util/lift":"4nOIb","../util/noop":"bmpBW","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kFfWs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sampleTime", ()=>sampleTime);
var _async = require("../scheduler/async");
var _sample = require("./sample");
var _interval = require("../observable/interval");
function sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    return (0, _sample.sample)((0, _interval.interval)(period, scheduler));
}

},{"../scheduler/async":"fZcBE","./sample":"2POSe","../observable/interval":"ex0hC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5J7S5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scan", ()=>scan);
var _lift = require("../util/lift");
var _scanInternals = require("./scanInternals");
function scan(accumulator, seed) {
    return (0, _lift.operate)((0, _scanInternals.scanInternals)(accumulator, seed, arguments.length >= 2, true));
}

},{"../util/lift":"4nOIb","./scanInternals":"bQBl1","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"l7y9t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sequenceEqual", ()=>sequenceEqual);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
function sequenceEqual(compareTo, comparator) {
    if (comparator === void 0) comparator = function(a, b) {
        return a === b;
    };
    return (0, _lift.operate)(function(source, subscriber) {
        var aState = createState();
        var bState = createState();
        var emit = function(isEqual) {
            subscriber.next(isEqual);
            subscriber.complete();
        };
        var createSubscriber = function(selfState, otherState) {
            var sequenceEqualSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(a) {
                var buffer = otherState.buffer, complete = otherState.complete;
                if (buffer.length === 0) complete ? emit(false) : selfState.buffer.push(a);
                else !comparator(a, buffer.shift()) && emit(false);
            }, function() {
                selfState.complete = true;
                var complete = otherState.complete, buffer = otherState.buffer;
                complete && emit(buffer.length === 0);
                sequenceEqualSubscriber === null || sequenceEqualSubscriber === void 0 || sequenceEqualSubscriber.unsubscribe();
            });
            return sequenceEqualSubscriber;
        };
        source.subscribe(createSubscriber(aState, bState));
        (0, _innerFrom.innerFrom)(compareTo).subscribe(createSubscriber(bState, aState));
    });
}
function createState() {
    return {
        buffer: [],
        complete: false
    };
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","../observable/innerFrom":"88jOZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"krelF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "share", ()=>share);
var _tslib = require("tslib");
var _innerFrom = require("../observable/innerFrom");
var _subject = require("../Subject");
var _subscriber = require("../Subscriber");
var _lift = require("../util/lift");
function share(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, _subject.Subject)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, _lift.operate)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, _subscriber.SafeSubscriber)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, _innerFrom.innerFrom)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, _subscriber.SafeSubscriber)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, _innerFrom.innerFrom)(on.apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(args)))).subscribe(onSubscriber);
}

},{"tslib":"jH8wD","../observable/innerFrom":"88jOZ","../Subject":"4Icpn","../Subscriber":"c8fGB","../util/lift":"4nOIb","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8TWOu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shareReplay", ()=>shareReplay);
var _replaySubject = require("../ReplaySubject");
var _share = require("./share");
function shareReplay(configOrBufferSize, windowTime, scheduler) {
    var _a, _b, _c;
    var bufferSize;
    var refCount = false;
    if (configOrBufferSize && typeof configOrBufferSize === 'object') _a = configOrBufferSize.bufferSize, bufferSize = _a === void 0 ? Infinity : _a, _b = configOrBufferSize.windowTime, windowTime = _b === void 0 ? Infinity : _b, _c = configOrBufferSize.refCount, refCount = _c === void 0 ? false : _c, scheduler = configOrBufferSize.scheduler;
    else bufferSize = configOrBufferSize !== null && configOrBufferSize !== void 0 ? configOrBufferSize : Infinity;
    return (0, _share.share)({
        connector: function() {
            return new (0, _replaySubject.ReplaySubject)(bufferSize, windowTime, scheduler);
        },
        resetOnError: true,
        resetOnComplete: false,
        resetOnRefCountZero: refCount
    });
}

},{"../ReplaySubject":"hpUH1","./share":"krelF","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ja2wH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "single", ()=>single);
var _emptyError = require("../util/EmptyError");
var _sequenceError = require("../util/SequenceError");
var _notFoundError = require("../util/NotFoundError");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function single(predicate) {
    return (0, _lift.operate)(function(source, subscriber) {
        var hasValue = false;
        var singleValue;
        var seenValue = false;
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            seenValue = true;
            if (!predicate || predicate(value, index++, source)) {
                hasValue && subscriber.error(new (0, _sequenceError.SequenceError)('Too many matching values'));
                hasValue = true;
                singleValue = value;
            }
        }, function() {
            if (hasValue) {
                subscriber.next(singleValue);
                subscriber.complete();
            } else subscriber.error(seenValue ? new (0, _notFoundError.NotFoundError)('No matching values') : new (0, _emptyError.EmptyError)());
        }));
    });
}

},{"../util/EmptyError":"Cu2oV","../util/SequenceError":"jNLLd","../util/NotFoundError":"LNpui","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1TuW2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skip", ()=>skip);
var _filter = require("./filter");
function skip(count) {
    return (0, _filter.filter)(function(_, index) {
        return count <= index;
    });
}

},{"./filter":"5uWPs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dBVoW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skipLast", ()=>skipLast);
var _identity = require("../util/identity");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function skipLast(skipCount) {
    return skipCount <= 0 ? (0, _identity.identity) : (0, _lift.operate)(function(source, subscriber) {
        var ring = new Array(skipCount);
        var seen = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var valueIndex = seen++;
            if (valueIndex < skipCount) ring[valueIndex] = value;
            else {
                var index = valueIndex % skipCount;
                var oldValue = ring[index];
                ring[index] = value;
                subscriber.next(oldValue);
            }
        }));
        return function() {
            ring = null;
        };
    });
}

},{"../util/identity":"2CmIP","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4WepI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skipUntil", ()=>skipUntil);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
var _noop = require("../util/noop");
function skipUntil(notifier) {
    return (0, _lift.operate)(function(source, subscriber) {
        var taking = false;
        var skipSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
            skipSubscriber === null || skipSubscriber === void 0 || skipSubscriber.unsubscribe();
            taking = true;
        }, (0, _noop.noop));
        (0, _innerFrom.innerFrom)(notifier).subscribe(skipSubscriber);
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return taking && subscriber.next(value);
        }));
    });
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","../observable/innerFrom":"88jOZ","../util/noop":"bmpBW","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ap7Sm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "skipWhile", ()=>skipWhile);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function skipWhile(predicate) {
    return (0, _lift.operate)(function(source, subscriber) {
        var taking = false;
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return (taking || (taking = !predicate(value, index++))) && subscriber.next(value);
        }));
    });
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jgIyl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startWith", ()=>startWith);
var _concat = require("../observable/concat");
var _args = require("../util/args");
var _lift = require("../util/lift");
function startWith() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = (0, _args.popScheduler)(values);
    return (0, _lift.operate)(function(source, subscriber) {
        (scheduler ? (0, _concat.concat)(values, source, scheduler) : (0, _concat.concat)(values, source)).subscribe(subscriber);
    });
}

},{"../observable/concat":"a3Gor","../util/args":"6vW91","../util/lift":"4nOIb","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ibUC1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchAll", ()=>switchAll);
var _switchMap = require("./switchMap");
var _identity = require("../util/identity");
function switchAll() {
    return (0, _switchMap.switchMap)((0, _identity.identity));
}

},{"./switchMap":"8lUXl","../util/identity":"2CmIP","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8lUXl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchMap", ()=>switchMap);
var _innerFrom = require("../observable/innerFrom");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function switchMap(project, resultSelector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, _innerFrom.innerFrom)(project(value, outerIndex)).subscribe(innerSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}

},{"../observable/innerFrom":"88jOZ","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bicdE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchMapTo", ()=>switchMapTo);
var _switchMap = require("./switchMap");
var _isFunction = require("../util/isFunction");
function switchMapTo(innerObservable, resultSelector) {
    return (0, _isFunction.isFunction)(resultSelector) ? (0, _switchMap.switchMap)(function() {
        return innerObservable;
    }, resultSelector) : (0, _switchMap.switchMap)(function() {
        return innerObservable;
    });
}

},{"./switchMap":"8lUXl","../util/isFunction":"eS6zV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bciWE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchScan", ()=>switchScan);
var _switchMap = require("./switchMap");
var _lift = require("../util/lift");
function switchScan(accumulator, seed) {
    return (0, _lift.operate)(function(source, subscriber) {
        var state = seed;
        (0, _switchMap.switchMap)(function(value, index) {
            return accumulator(state, value, index);
        }, function(_, innerValue) {
            return state = innerValue, innerValue;
        })(source).subscribe(subscriber);
        return function() {
            state = null;
        };
    });
}

},{"./switchMap":"8lUXl","../util/lift":"4nOIb","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"K9ueE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takeUntil", ()=>takeUntil);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
var _noop = require("../util/noop");
function takeUntil(notifier) {
    return (0, _lift.operate)(function(source, subscriber) {
        (0, _innerFrom.innerFrom)(notifier).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
            return subscriber.complete();
        }, (0, _noop.noop)));
        !subscriber.closed && source.subscribe(subscriber);
    });
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","../observable/innerFrom":"88jOZ","../util/noop":"bmpBW","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kF7EX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "takeWhile", ()=>takeWhile);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function takeWhile(predicate, inclusive) {
    if (inclusive === void 0) inclusive = false;
    return (0, _lift.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var result = predicate(value, index++);
            (result || inclusive) && subscriber.next(value);
            !result && subscriber.complete();
        }));
    });
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"HoAKu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tap", ()=>tap);
var _isFunction = require("../util/isFunction");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _identity = require("../util/identity");
function tap(observerOrNext, error, complete) {
    var tapObserver = (0, _isFunction.isFunction)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, _lift.operate)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, _identity.identity);
}

},{"../util/isFunction":"eS6zV","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","../util/identity":"2CmIP","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"j4uQU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throttle", ()=>throttle);
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
function throttle(durationSelector, config) {
    return (0, _lift.operate)(function(source, subscriber) {
        var _a = config !== null && config !== void 0 ? config : {}, _b = _a.leading, leading = _b === void 0 ? true : _b, _c = _a.trailing, trailing = _c === void 0 ? false : _c;
        var hasValue = false;
        var sendValue = null;
        var throttled = null;
        var isComplete = false;
        var endThrottling = function() {
            throttled === null || throttled === void 0 || throttled.unsubscribe();
            throttled = null;
            if (trailing) {
                send();
                isComplete && subscriber.complete();
            }
        };
        var cleanupThrottling = function() {
            throttled = null;
            isComplete && subscriber.complete();
        };
        var startThrottle = function(value) {
            return throttled = (0, _innerFrom.innerFrom)(durationSelector(value)).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, endThrottling, cleanupThrottling));
        };
        var send = function() {
            if (hasValue) {
                hasValue = false;
                var value = sendValue;
                sendValue = null;
                subscriber.next(value);
                !isComplete && startThrottle(value);
            }
        };
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            hasValue = true;
            sendValue = value;
            !(throttled && !throttled.closed) && (leading ? send() : startThrottle(value));
        }, function() {
            isComplete = true;
            !(trailing && hasValue && throttled && !throttled.closed) && subscriber.complete();
        }));
    });
}

},{"../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","../observable/innerFrom":"88jOZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"av7pG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "throttleTime", ()=>throttleTime);
var _async = require("../scheduler/async");
var _throttle = require("./throttle");
var _timer = require("../observable/timer");
function throttleTime(duration, scheduler, config) {
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    var duration$ = (0, _timer.timer)(duration, scheduler);
    return (0, _throttle.throttle)(function() {
        return duration$;
    }, config);
}

},{"../scheduler/async":"fZcBE","./throttle":"j4uQU","../observable/timer":"bUIVF","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2XvlZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeInterval", ()=>timeInterval);
parcelHelpers.export(exports, "TimeInterval", ()=>TimeInterval);
var _async = require("../scheduler/async");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    return (0, _lift.operate)(function(source, subscriber) {
        var last = scheduler.now();
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var now = scheduler.now();
            var interval = now - last;
            last = now;
            subscriber.next(new TimeInterval(value, interval));
        }));
    });
}
var TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();

},{"../scheduler/async":"fZcBE","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5Q2q8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutWith", ()=>timeoutWith);
var _async = require("../scheduler/async");
var _isDate = require("../util/isDate");
var _timeout = require("./timeout");
function timeoutWith(due, withObservable, scheduler) {
    var first;
    var each;
    var _with;
    scheduler = scheduler !== null && scheduler !== void 0 ? scheduler : (0, _async.async);
    if ((0, _isDate.isValidDate)(due)) first = due;
    else if (typeof due === 'number') each = due;
    if (withObservable) _with = function() {
        return withObservable;
    };
    else throw new TypeError('No observable provided to switch to');
    if (first == null && each == null) throw new TypeError('No timeout provided.');
    return (0, _timeout.timeout)({
        first: first,
        each: each,
        scheduler: scheduler,
        with: _with
    });
}

},{"../scheduler/async":"fZcBE","../util/isDate":"9ikls","./timeout":"d6r3h","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dXtXd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timestamp", ()=>timestamp);
var _dateTimestampProvider = require("../scheduler/dateTimestampProvider");
var _map = require("./map");
function timestamp(timestampProvider) {
    if (timestampProvider === void 0) timestampProvider = (0, _dateTimestampProvider.dateTimestampProvider);
    return (0, _map.map)(function(value) {
        return {
            value: value,
            timestamp: timestampProvider.now()
        };
    });
}

},{"../scheduler/dateTimestampProvider":"lCnpT","./map":"axudj","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kR8qq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "window", ()=>window);
var _subject = require("../Subject");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _noop = require("../util/noop");
var _innerFrom = require("../observable/innerFrom");
function window(windowBoundaries) {
    return (0, _lift.operate)(function(source, subscriber) {
        var windowSubject = new (0, _subject.Subject)();
        subscriber.next(windowSubject.asObservable());
        var errorHandler = function(err) {
            windowSubject.error(err);
            subscriber.error(err);
        };
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return windowSubject === null || windowSubject === void 0 ? void 0 : windowSubject.next(value);
        }, function() {
            windowSubject.complete();
            subscriber.complete();
        }, errorHandler));
        (0, _innerFrom.innerFrom)(windowBoundaries).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
            windowSubject.complete();
            subscriber.next(windowSubject = new (0, _subject.Subject)());
        }, (0, _noop.noop), errorHandler));
        return function() {
            windowSubject === null || windowSubject === void 0 || windowSubject.unsubscribe();
            windowSubject = null;
        };
    });
}

},{"../Subject":"4Icpn","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","../util/noop":"bmpBW","../observable/innerFrom":"88jOZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1A4qo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowCount", ()=>windowCount);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    var startEvery = startWindowEvery > 0 ? startWindowEvery : windowSize;
    return (0, _lift.operate)(function(source, subscriber) {
        var windows = [
            new (0, _subject.Subject)()
        ];
        var starts = [];
        var count = 0;
        subscriber.next(windows[0].asObservable());
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var e_1, _a;
            try {
                for(var windows_1 = (0, _tslib.__values)(windows), windows_1_1 = windows_1.next(); !windows_1_1.done; windows_1_1 = windows_1.next()){
                    var window_1 = windows_1_1.value;
                    window_1.next(value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (windows_1_1 && !windows_1_1.done && (_a = windows_1.return)) _a.call(windows_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            var c = count - windowSize + 1;
            if (c >= 0 && c % startEvery === 0) windows.shift().complete();
            if (++count % startEvery === 0) {
                var window_2 = new (0, _subject.Subject)();
                windows.push(window_2);
                subscriber.next(window_2.asObservable());
            }
        }, function() {
            while(windows.length > 0)windows.shift().complete();
            subscriber.complete();
        }, function(err) {
            while(windows.length > 0)windows.shift().error(err);
            subscriber.error(err);
        }, function() {
            starts = null;
            windows = null;
        }));
    });
}

},{"tslib":"jH8wD","../Subject":"4Icpn","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gyiZl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowTime", ()=>windowTime);
var _subject = require("../Subject");
var _async = require("../scheduler/async");
var _subscription = require("../Subscription");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _arrRemove = require("../util/arrRemove");
var _args = require("../util/args");
var _executeSchedule = require("../util/executeSchedule");
function windowTime(windowTimeSpan) {
    var _a, _b;
    var otherArgs = [];
    for(var _i = 1; _i < arguments.length; _i++)otherArgs[_i - 1] = arguments[_i];
    var scheduler = (_a = (0, _args.popScheduler)(otherArgs)) !== null && _a !== void 0 ? _a : (0, _async.asyncScheduler);
    var windowCreationInterval = (_b = otherArgs[0]) !== null && _b !== void 0 ? _b : null;
    var maxWindowSize = otherArgs[1] || Infinity;
    return (0, _lift.operate)(function(source, subscriber) {
        var windowRecords = [];
        var restartOnClose = false;
        var closeWindow = function(record) {
            var window = record.window, subs = record.subs;
            window.complete();
            subs.unsubscribe();
            (0, _arrRemove.arrRemove)(windowRecords, record);
            restartOnClose && startWindow();
        };
        var startWindow = function() {
            if (windowRecords) {
                var subs = new (0, _subscription.Subscription)();
                subscriber.add(subs);
                var window_1 = new (0, _subject.Subject)();
                var record_1 = {
                    window: window_1,
                    subs: subs,
                    seen: 0
                };
                windowRecords.push(record_1);
                subscriber.next(window_1.asObservable());
                (0, _executeSchedule.executeSchedule)(subs, scheduler, function() {
                    return closeWindow(record_1);
                }, windowTimeSpan);
            }
        };
        if (windowCreationInterval !== null && windowCreationInterval >= 0) (0, _executeSchedule.executeSchedule)(subscriber, scheduler, startWindow, windowCreationInterval, true);
        else restartOnClose = true;
        startWindow();
        var loop = function(cb) {
            return windowRecords.slice().forEach(cb);
        };
        var terminate = function(cb) {
            loop(function(_a) {
                var window = _a.window;
                return cb(window);
            });
            cb(subscriber);
            subscriber.unsubscribe();
        };
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            loop(function(record) {
                record.window.next(value);
                maxWindowSize <= ++record.seen && closeWindow(record);
            });
        }, function() {
            return terminate(function(consumer) {
                return consumer.complete();
            });
        }, function(err) {
            return terminate(function(consumer) {
                return consumer.error(err);
            });
        }));
        return function() {
            windowRecords = null;
        };
    });
}

},{"../Subject":"4Icpn","../scheduler/async":"fZcBE","../Subscription":"iuJZ4","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","../util/arrRemove":"HRHom","../util/args":"6vW91","../util/executeSchedule":"lgbnE","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"irJ6l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowToggle", ()=>windowToggle);
var _tslib = require("tslib");
var _subject = require("../Subject");
var _subscription = require("../Subscription");
var _lift = require("../util/lift");
var _innerFrom = require("../observable/innerFrom");
var _operatorSubscriber = require("./OperatorSubscriber");
var _noop = require("../util/noop");
var _arrRemove = require("../util/arrRemove");
function windowToggle(openings, closingSelector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var windows = [];
        var handleError = function(err) {
            while(0 < windows.length)windows.shift().error(err);
            subscriber.error(err);
        };
        (0, _innerFrom.innerFrom)(openings).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(openValue) {
            var window = new (0, _subject.Subject)();
            windows.push(window);
            var closingSubscription = new (0, _subscription.Subscription)();
            var closeWindow = function() {
                (0, _arrRemove.arrRemove)(windows, window);
                window.complete();
                closingSubscription.unsubscribe();
            };
            var closingNotifier;
            try {
                closingNotifier = (0, _innerFrom.innerFrom)(closingSelector(openValue));
            } catch (err) {
                handleError(err);
                return;
            }
            subscriber.next(window.asObservable());
            closingSubscription.add(closingNotifier.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, closeWindow, (0, _noop.noop), handleError)));
        }, (0, _noop.noop)));
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var e_1, _a;
            var windowsCopy = windows.slice();
            try {
                for(var windowsCopy_1 = (0, _tslib.__values)(windowsCopy), windowsCopy_1_1 = windowsCopy_1.next(); !windowsCopy_1_1.done; windowsCopy_1_1 = windowsCopy_1.next()){
                    var window_1 = windowsCopy_1_1.value;
                    window_1.next(value);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (windowsCopy_1_1 && !windowsCopy_1_1.done && (_a = windowsCopy_1.return)) _a.call(windowsCopy_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }, function() {
            while(0 < windows.length)windows.shift().complete();
            subscriber.complete();
        }, handleError, function() {
            while(0 < windows.length)windows.shift().unsubscribe();
        }));
    });
}

},{"tslib":"jH8wD","../Subject":"4Icpn","../Subscription":"iuJZ4","../util/lift":"4nOIb","../observable/innerFrom":"88jOZ","./OperatorSubscriber":"aQPgL","../util/noop":"bmpBW","../util/arrRemove":"HRHom","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3oqS8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "windowWhen", ()=>windowWhen);
var _subject = require("../Subject");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
function windowWhen(closingSelector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var window;
        var closingSubscriber;
        var handleError = function(err) {
            window.error(err);
            subscriber.error(err);
        };
        var openWindow = function() {
            closingSubscriber === null || closingSubscriber === void 0 || closingSubscriber.unsubscribe();
            window === null || window === void 0 || window.complete();
            window = new (0, _subject.Subject)();
            subscriber.next(window.asObservable());
            var closingNotifier;
            try {
                closingNotifier = (0, _innerFrom.innerFrom)(closingSelector());
            } catch (err) {
                handleError(err);
                return;
            }
            closingNotifier.subscribe(closingSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, openWindow, openWindow, handleError));
        };
        openWindow();
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return window.next(value);
        }, function() {
            window.complete();
            subscriber.complete();
        }, handleError, function() {
            closingSubscriber === null || closingSubscriber === void 0 || closingSubscriber.unsubscribe();
            window = null;
        }));
    });
}

},{"../Subject":"4Icpn","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","../observable/innerFrom":"88jOZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kEbSA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withLatestFrom", ()=>withLatestFrom);
var _tslib = require("tslib");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
var _identity = require("../util/identity");
var _noop = require("../util/noop");
var _args = require("../util/args");
function withLatestFrom() {
    var inputs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputs[_i] = arguments[_i];
    var project = (0, _args.popResultSelector)(inputs);
    return (0, _lift.operate)(function(source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function() {
            return false;
        });
        var ready = false;
        var _loop_1 = function(i) {
            (0, _innerFrom.innerFrom)(inputs[i]).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
                otherValues[i] = value;
                if (!ready && !hasValue[i]) {
                    hasValue[i] = true;
                    (ready = hasValue.every((0, _identity.identity))) && (hasValue = null);
                }
            }, (0, _noop.noop)));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            if (ready) {
                var values = (0, _tslib.__spreadArray)([
                    value
                ], (0, _tslib.__read)(otherValues));
                subscriber.next(project ? project.apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(values))) : values);
            }
        }));
    });
}

},{"tslib":"jH8wD","../util/lift":"4nOIb","./OperatorSubscriber":"aQPgL","../observable/innerFrom":"88jOZ","../util/identity":"2CmIP","../util/noop":"bmpBW","../util/args":"6vW91","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4f9g0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zipAll", ()=>zipAll);
var _zip = require("../observable/zip");
var _joinAllInternals = require("./joinAllInternals");
function zipAll(project) {
    return (0, _joinAllInternals.joinAllInternals)((0, _zip.zip), project);
}

},{"../observable/zip":"er6av","./joinAllInternals":"crQT5","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aYnFy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zipWith", ()=>zipWith);
var _tslib = require("tslib");
var _zip = require("./zip");
function zipWith() {
    var otherInputs = [];
    for(var _i = 0; _i < arguments.length; _i++)otherInputs[_i] = arguments[_i];
    return (0, _zip.zip).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(otherInputs)));
}

},{"tslib":"jH8wD","./zip":"a4BnD","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"a4BnD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zip", ()=>zip);
var _tslib = require("tslib");
var _zip = require("../observable/zip");
var _lift = require("../util/lift");
function zip() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return (0, _lift.operate)(function(source, subscriber) {
        (0, _zip.zip).apply(void 0, (0, _tslib.__spreadArray)([
            source
        ], (0, _tslib.__read)(sources))).subscribe(subscriber);
    });
}

},{"tslib":"jH8wD","../observable/zip":"er6av","../util/lift":"4nOIb","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2kBSB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "receiveAPDU", ()=>receiveAPDU);
var _errors = require("@ledgerhq/errors");
var _rxjs = require("rxjs");
var _logs = require("@ledgerhq/logs");
var Buffer = require("151289245a775fdc").Buffer;
const TagId = 0x05;
const receiveAPDU = (rawStream, { context } = {})=>new (0, _rxjs.Observable)((o)=>{
        let notifiedIndex = 0;
        let notifiedDataLength = 0;
        let notifiedData = Buffer.alloc(0);
        const subscriptionCleaner = new (0, _rxjs.ReplaySubject)();
        // The raw stream is listened/subscribed to until a full message (that can be made of several frames) is received
        rawStream.pipe((0, _rxjs.takeUntil)(subscriptionCleaner)).subscribe({
            complete: ()=>{
                o.error(new (0, _errors.DisconnectedDevice)());
            },
            error: (error)=>{
                (0, _logs.trace)({
                    type: "ble-error",
                    message: `Error in receiveAPDU: ${error}`,
                    data: {
                        error
                    },
                    context
                });
                o.error(error);
            },
            next: (value)=>{
                // Silences emitted errors in next
                if (value instanceof Error) {
                    (0, _logs.trace)({
                        type: "ble-error",
                        message: `Error emitted to receiveAPDU next: ${value}`,
                        data: {
                            error: value
                        },
                        context
                    });
                    return;
                }
                const tag = value.readUInt8(0);
                const chunkIndex = value.readUInt16BE(1);
                // `slice` and not `subarray`: this is not a Node Buffer, but probably only a Uint8Array.
                let chunkData = value.slice(3);
                if (tag !== TagId) {
                    o.error(new (0, _errors.TransportError)("Invalid tag " + tag.toString(16), "InvalidTag"));
                    return;
                }
                // A chunk was probably missed
                if (notifiedIndex !== chunkIndex) {
                    o.error(new (0, _errors.TransportError)(`BLE: Invalid sequence number. discontinued chunk. Received ${chunkIndex} but expected ${notifiedIndex}`, "InvalidSequence"));
                    return;
                }
                // The total length of the response is located on the next 2 bytes on the 1st chunk
                if (chunkIndex === 0) {
                    notifiedDataLength = chunkData.readUInt16BE(0);
                    // `slice` and not `subarray`: this is not a Node Buffer, but probably only a Uint8Array.
                    chunkData = chunkData.slice(2);
                }
                notifiedIndex++;
                // The cost of creating a new buffer for each received chunk is low because the response is often contained in 1 chunk.
                // Allocating `notifiedData` buffer with the received total length and mutating it will probably not improve any performance.
                notifiedData = Buffer.concat([
                    notifiedData,
                    chunkData
                ]);
                if (notifiedData.length > notifiedDataLength) {
                    o.error(new (0, _errors.TransportError)(`BLE: received too much data. discontinued chunk. Received ${notifiedData.length} but expected ${notifiedDataLength}`, "BLETooMuchData"));
                    return;
                }
                if (notifiedData.length === notifiedDataLength) {
                    o.next(notifiedData);
                    o.complete();
                    // Tries to unsubscribe from the raw stream as soon as we complete the parent observer
                    subscriptionCleaner.next();
                }
            }
        });
        return ()=>{
            subscriptionCleaner.next();
        };
    });

},{"151289245a775fdc":"eXvXD","@ledgerhq/errors":"7T5AD","rxjs":"had2o","@ledgerhq/logs":"2hpLA","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"b21MU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "audit", ()=>(0, _audit.audit));
parcelHelpers.export(exports, "auditTime", ()=>(0, _auditTime.auditTime));
parcelHelpers.export(exports, "buffer", ()=>(0, _buffer.buffer));
parcelHelpers.export(exports, "bufferCount", ()=>(0, _bufferCount.bufferCount));
parcelHelpers.export(exports, "bufferTime", ()=>(0, _bufferTime.bufferTime));
parcelHelpers.export(exports, "bufferToggle", ()=>(0, _bufferToggle.bufferToggle));
parcelHelpers.export(exports, "bufferWhen", ()=>(0, _bufferWhen.bufferWhen));
parcelHelpers.export(exports, "catchError", ()=>(0, _catchError.catchError));
parcelHelpers.export(exports, "combineAll", ()=>(0, _combineAll.combineAll));
parcelHelpers.export(exports, "combineLatestAll", ()=>(0, _combineLatestAll.combineLatestAll));
parcelHelpers.export(exports, "combineLatest", ()=>(0, _combineLatest.combineLatest));
parcelHelpers.export(exports, "combineLatestWith", ()=>(0, _combineLatestWith.combineLatestWith));
parcelHelpers.export(exports, "concat", ()=>(0, _concat.concat));
parcelHelpers.export(exports, "concatAll", ()=>(0, _concatAll.concatAll));
parcelHelpers.export(exports, "concatMap", ()=>(0, _concatMap.concatMap));
parcelHelpers.export(exports, "concatMapTo", ()=>(0, _concatMapTo.concatMapTo));
parcelHelpers.export(exports, "concatWith", ()=>(0, _concatWith.concatWith));
parcelHelpers.export(exports, "connect", ()=>(0, _connect.connect));
parcelHelpers.export(exports, "count", ()=>(0, _count.count));
parcelHelpers.export(exports, "debounce", ()=>(0, _debounce.debounce));
parcelHelpers.export(exports, "debounceTime", ()=>(0, _debounceTime.debounceTime));
parcelHelpers.export(exports, "defaultIfEmpty", ()=>(0, _defaultIfEmpty.defaultIfEmpty));
parcelHelpers.export(exports, "delay", ()=>(0, _delay.delay));
parcelHelpers.export(exports, "delayWhen", ()=>(0, _delayWhen.delayWhen));
parcelHelpers.export(exports, "dematerialize", ()=>(0, _dematerialize.dematerialize));
parcelHelpers.export(exports, "distinct", ()=>(0, _distinct.distinct));
parcelHelpers.export(exports, "distinctUntilChanged", ()=>(0, _distinctUntilChanged.distinctUntilChanged));
parcelHelpers.export(exports, "distinctUntilKeyChanged", ()=>(0, _distinctUntilKeyChanged.distinctUntilKeyChanged));
parcelHelpers.export(exports, "elementAt", ()=>(0, _elementAt.elementAt));
parcelHelpers.export(exports, "endWith", ()=>(0, _endWith.endWith));
parcelHelpers.export(exports, "every", ()=>(0, _every.every));
parcelHelpers.export(exports, "exhaust", ()=>(0, _exhaust.exhaust));
parcelHelpers.export(exports, "exhaustAll", ()=>(0, _exhaustAll.exhaustAll));
parcelHelpers.export(exports, "exhaustMap", ()=>(0, _exhaustMap.exhaustMap));
parcelHelpers.export(exports, "expand", ()=>(0, _expand.expand));
parcelHelpers.export(exports, "filter", ()=>(0, _filter.filter));
parcelHelpers.export(exports, "finalize", ()=>(0, _finalize.finalize));
parcelHelpers.export(exports, "find", ()=>(0, _find.find));
parcelHelpers.export(exports, "findIndex", ()=>(0, _findIndex.findIndex));
parcelHelpers.export(exports, "first", ()=>(0, _first.first));
parcelHelpers.export(exports, "groupBy", ()=>(0, _groupBy.groupBy));
parcelHelpers.export(exports, "ignoreElements", ()=>(0, _ignoreElements.ignoreElements));
parcelHelpers.export(exports, "isEmpty", ()=>(0, _isEmpty.isEmpty));
parcelHelpers.export(exports, "last", ()=>(0, _last.last));
parcelHelpers.export(exports, "map", ()=>(0, _map.map));
parcelHelpers.export(exports, "mapTo", ()=>(0, _mapTo.mapTo));
parcelHelpers.export(exports, "materialize", ()=>(0, _materialize.materialize));
parcelHelpers.export(exports, "max", ()=>(0, _max.max));
parcelHelpers.export(exports, "merge", ()=>(0, _merge.merge));
parcelHelpers.export(exports, "mergeAll", ()=>(0, _mergeAll.mergeAll));
parcelHelpers.export(exports, "flatMap", ()=>(0, _flatMap.flatMap));
parcelHelpers.export(exports, "mergeMap", ()=>(0, _mergeMap.mergeMap));
parcelHelpers.export(exports, "mergeMapTo", ()=>(0, _mergeMapTo.mergeMapTo));
parcelHelpers.export(exports, "mergeScan", ()=>(0, _mergeScan.mergeScan));
parcelHelpers.export(exports, "mergeWith", ()=>(0, _mergeWith.mergeWith));
parcelHelpers.export(exports, "min", ()=>(0, _min.min));
parcelHelpers.export(exports, "multicast", ()=>(0, _multicast.multicast));
parcelHelpers.export(exports, "observeOn", ()=>(0, _observeOn.observeOn));
parcelHelpers.export(exports, "onErrorResumeNext", ()=>(0, _onErrorResumeNextWith.onErrorResumeNext));
parcelHelpers.export(exports, "pairwise", ()=>(0, _pairwise.pairwise));
parcelHelpers.export(exports, "partition", ()=>(0, _partition.partition));
parcelHelpers.export(exports, "pluck", ()=>(0, _pluck.pluck));
parcelHelpers.export(exports, "publish", ()=>(0, _publish.publish));
parcelHelpers.export(exports, "publishBehavior", ()=>(0, _publishBehavior.publishBehavior));
parcelHelpers.export(exports, "publishLast", ()=>(0, _publishLast.publishLast));
parcelHelpers.export(exports, "publishReplay", ()=>(0, _publishReplay.publishReplay));
parcelHelpers.export(exports, "race", ()=>(0, _race.race));
parcelHelpers.export(exports, "raceWith", ()=>(0, _raceWith.raceWith));
parcelHelpers.export(exports, "reduce", ()=>(0, _reduce.reduce));
parcelHelpers.export(exports, "repeat", ()=>(0, _repeat.repeat));
parcelHelpers.export(exports, "repeatWhen", ()=>(0, _repeatWhen.repeatWhen));
parcelHelpers.export(exports, "retry", ()=>(0, _retry.retry));
parcelHelpers.export(exports, "retryWhen", ()=>(0, _retryWhen.retryWhen));
parcelHelpers.export(exports, "refCount", ()=>(0, _refCount.refCount));
parcelHelpers.export(exports, "sample", ()=>(0, _sample.sample));
parcelHelpers.export(exports, "sampleTime", ()=>(0, _sampleTime.sampleTime));
parcelHelpers.export(exports, "scan", ()=>(0, _scan.scan));
parcelHelpers.export(exports, "sequenceEqual", ()=>(0, _sequenceEqual.sequenceEqual));
parcelHelpers.export(exports, "share", ()=>(0, _share.share));
parcelHelpers.export(exports, "shareReplay", ()=>(0, _shareReplay.shareReplay));
parcelHelpers.export(exports, "single", ()=>(0, _single.single));
parcelHelpers.export(exports, "skip", ()=>(0, _skip.skip));
parcelHelpers.export(exports, "skipLast", ()=>(0, _skipLast.skipLast));
parcelHelpers.export(exports, "skipUntil", ()=>(0, _skipUntil.skipUntil));
parcelHelpers.export(exports, "skipWhile", ()=>(0, _skipWhile.skipWhile));
parcelHelpers.export(exports, "startWith", ()=>(0, _startWith.startWith));
parcelHelpers.export(exports, "subscribeOn", ()=>(0, _subscribeOn.subscribeOn));
parcelHelpers.export(exports, "switchAll", ()=>(0, _switchAll.switchAll));
parcelHelpers.export(exports, "switchMap", ()=>(0, _switchMap.switchMap));
parcelHelpers.export(exports, "switchMapTo", ()=>(0, _switchMapTo.switchMapTo));
parcelHelpers.export(exports, "switchScan", ()=>(0, _switchScan.switchScan));
parcelHelpers.export(exports, "take", ()=>(0, _take.take));
parcelHelpers.export(exports, "takeLast", ()=>(0, _takeLast.takeLast));
parcelHelpers.export(exports, "takeUntil", ()=>(0, _takeUntil.takeUntil));
parcelHelpers.export(exports, "takeWhile", ()=>(0, _takeWhile.takeWhile));
parcelHelpers.export(exports, "tap", ()=>(0, _tap.tap));
parcelHelpers.export(exports, "throttle", ()=>(0, _throttle.throttle));
parcelHelpers.export(exports, "throttleTime", ()=>(0, _throttleTime.throttleTime));
parcelHelpers.export(exports, "throwIfEmpty", ()=>(0, _throwIfEmpty.throwIfEmpty));
parcelHelpers.export(exports, "timeInterval", ()=>(0, _timeInterval.timeInterval));
parcelHelpers.export(exports, "timeout", ()=>(0, _timeout.timeout));
parcelHelpers.export(exports, "timeoutWith", ()=>(0, _timeoutWith.timeoutWith));
parcelHelpers.export(exports, "timestamp", ()=>(0, _timestamp.timestamp));
parcelHelpers.export(exports, "toArray", ()=>(0, _toArray.toArray));
parcelHelpers.export(exports, "window", ()=>(0, _window.window));
parcelHelpers.export(exports, "windowCount", ()=>(0, _windowCount.windowCount));
parcelHelpers.export(exports, "windowTime", ()=>(0, _windowTime.windowTime));
parcelHelpers.export(exports, "windowToggle", ()=>(0, _windowToggle.windowToggle));
parcelHelpers.export(exports, "windowWhen", ()=>(0, _windowWhen.windowWhen));
parcelHelpers.export(exports, "withLatestFrom", ()=>(0, _withLatestFrom.withLatestFrom));
parcelHelpers.export(exports, "zip", ()=>(0, _zip.zip));
parcelHelpers.export(exports, "zipAll", ()=>(0, _zipAll.zipAll));
parcelHelpers.export(exports, "zipWith", ()=>(0, _zipWith.zipWith));
var _audit = require("../internal/operators/audit");
var _auditTime = require("../internal/operators/auditTime");
var _buffer = require("../internal/operators/buffer");
var _bufferCount = require("../internal/operators/bufferCount");
var _bufferTime = require("../internal/operators/bufferTime");
var _bufferToggle = require("../internal/operators/bufferToggle");
var _bufferWhen = require("../internal/operators/bufferWhen");
var _catchError = require("../internal/operators/catchError");
var _combineAll = require("../internal/operators/combineAll");
var _combineLatestAll = require("../internal/operators/combineLatestAll");
var _combineLatest = require("../internal/operators/combineLatest");
var _combineLatestWith = require("../internal/operators/combineLatestWith");
var _concat = require("../internal/operators/concat");
var _concatAll = require("../internal/operators/concatAll");
var _concatMap = require("../internal/operators/concatMap");
var _concatMapTo = require("../internal/operators/concatMapTo");
var _concatWith = require("../internal/operators/concatWith");
var _connect = require("../internal/operators/connect");
var _count = require("../internal/operators/count");
var _debounce = require("../internal/operators/debounce");
var _debounceTime = require("../internal/operators/debounceTime");
var _defaultIfEmpty = require("../internal/operators/defaultIfEmpty");
var _delay = require("../internal/operators/delay");
var _delayWhen = require("../internal/operators/delayWhen");
var _dematerialize = require("../internal/operators/dematerialize");
var _distinct = require("../internal/operators/distinct");
var _distinctUntilChanged = require("../internal/operators/distinctUntilChanged");
var _distinctUntilKeyChanged = require("../internal/operators/distinctUntilKeyChanged");
var _elementAt = require("../internal/operators/elementAt");
var _endWith = require("../internal/operators/endWith");
var _every = require("../internal/operators/every");
var _exhaust = require("../internal/operators/exhaust");
var _exhaustAll = require("../internal/operators/exhaustAll");
var _exhaustMap = require("../internal/operators/exhaustMap");
var _expand = require("../internal/operators/expand");
var _filter = require("../internal/operators/filter");
var _finalize = require("../internal/operators/finalize");
var _find = require("../internal/operators/find");
var _findIndex = require("../internal/operators/findIndex");
var _first = require("../internal/operators/first");
var _groupBy = require("../internal/operators/groupBy");
var _ignoreElements = require("../internal/operators/ignoreElements");
var _isEmpty = require("../internal/operators/isEmpty");
var _last = require("../internal/operators/last");
var _map = require("../internal/operators/map");
var _mapTo = require("../internal/operators/mapTo");
var _materialize = require("../internal/operators/materialize");
var _max = require("../internal/operators/max");
var _merge = require("../internal/operators/merge");
var _mergeAll = require("../internal/operators/mergeAll");
var _flatMap = require("../internal/operators/flatMap");
var _mergeMap = require("../internal/operators/mergeMap");
var _mergeMapTo = require("../internal/operators/mergeMapTo");
var _mergeScan = require("../internal/operators/mergeScan");
var _mergeWith = require("../internal/operators/mergeWith");
var _min = require("../internal/operators/min");
var _multicast = require("../internal/operators/multicast");
var _observeOn = require("../internal/operators/observeOn");
var _onErrorResumeNextWith = require("../internal/operators/onErrorResumeNextWith");
var _pairwise = require("../internal/operators/pairwise");
var _partition = require("../internal/operators/partition");
var _pluck = require("../internal/operators/pluck");
var _publish = require("../internal/operators/publish");
var _publishBehavior = require("../internal/operators/publishBehavior");
var _publishLast = require("../internal/operators/publishLast");
var _publishReplay = require("../internal/operators/publishReplay");
var _race = require("../internal/operators/race");
var _raceWith = require("../internal/operators/raceWith");
var _reduce = require("../internal/operators/reduce");
var _repeat = require("../internal/operators/repeat");
var _repeatWhen = require("../internal/operators/repeatWhen");
var _retry = require("../internal/operators/retry");
var _retryWhen = require("../internal/operators/retryWhen");
var _refCount = require("../internal/operators/refCount");
var _sample = require("../internal/operators/sample");
var _sampleTime = require("../internal/operators/sampleTime");
var _scan = require("../internal/operators/scan");
var _sequenceEqual = require("../internal/operators/sequenceEqual");
var _share = require("../internal/operators/share");
var _shareReplay = require("../internal/operators/shareReplay");
var _single = require("../internal/operators/single");
var _skip = require("../internal/operators/skip");
var _skipLast = require("../internal/operators/skipLast");
var _skipUntil = require("../internal/operators/skipUntil");
var _skipWhile = require("../internal/operators/skipWhile");
var _startWith = require("../internal/operators/startWith");
var _subscribeOn = require("../internal/operators/subscribeOn");
var _switchAll = require("../internal/operators/switchAll");
var _switchMap = require("../internal/operators/switchMap");
var _switchMapTo = require("../internal/operators/switchMapTo");
var _switchScan = require("../internal/operators/switchScan");
var _take = require("../internal/operators/take");
var _takeLast = require("../internal/operators/takeLast");
var _takeUntil = require("../internal/operators/takeUntil");
var _takeWhile = require("../internal/operators/takeWhile");
var _tap = require("../internal/operators/tap");
var _throttle = require("../internal/operators/throttle");
var _throttleTime = require("../internal/operators/throttleTime");
var _throwIfEmpty = require("../internal/operators/throwIfEmpty");
var _timeInterval = require("../internal/operators/timeInterval");
var _timeout = require("../internal/operators/timeout");
var _timeoutWith = require("../internal/operators/timeoutWith");
var _timestamp = require("../internal/operators/timestamp");
var _toArray = require("../internal/operators/toArray");
var _window = require("../internal/operators/window");
var _windowCount = require("../internal/operators/windowCount");
var _windowTime = require("../internal/operators/windowTime");
var _windowToggle = require("../internal/operators/windowToggle");
var _windowWhen = require("../internal/operators/windowWhen");
var _withLatestFrom = require("../internal/operators/withLatestFrom");
var _zip = require("../internal/operators/zip");
var _zipAll = require("../internal/operators/zipAll");
var _zipWith = require("../internal/operators/zipWith");

},{"../internal/operators/audit":"daTGs","../internal/operators/auditTime":"gDfyR","../internal/operators/buffer":"dVnzm","../internal/operators/bufferCount":"2SWMG","../internal/operators/bufferTime":"9VQL7","../internal/operators/bufferToggle":"bZtzK","../internal/operators/bufferWhen":"CfKBQ","../internal/operators/catchError":"j7N3U","../internal/operators/combineAll":"1lMLg","../internal/operators/combineLatestAll":"h2M72","../internal/operators/combineLatest":"1ffJ9","../internal/operators/combineLatestWith":"bj420","../internal/operators/concat":"3ntID","../internal/operators/concatAll":"7HZAl","../internal/operators/concatMap":"5uG7j","../internal/operators/concatMapTo":"cw85e","../internal/operators/concatWith":"brG7g","../internal/operators/connect":"6NlD1","../internal/operators/count":"5uqKy","../internal/operators/debounce":"e2TQl","../internal/operators/debounceTime":"a3jha","../internal/operators/defaultIfEmpty":"5xf0S","../internal/operators/delay":"fSMvT","../internal/operators/delayWhen":"96Cih","../internal/operators/dematerialize":"5V8Z3","../internal/operators/distinct":"hwb2B","../internal/operators/distinctUntilChanged":"cttga","../internal/operators/distinctUntilKeyChanged":"9BKLM","../internal/operators/elementAt":"bOBBu","../internal/operators/endWith":"fx8gJ","../internal/operators/every":"c5eHD","../internal/operators/exhaust":"2SUOw","../internal/operators/exhaustAll":"l7Zrp","../internal/operators/exhaustMap":"kstpi","../internal/operators/expand":"2ALAW","../internal/operators/filter":"5uWPs","../internal/operators/finalize":"81pRQ","../internal/operators/find":"h3LwP","../internal/operators/findIndex":"9cmYI","../internal/operators/first":"3wDHa","../internal/operators/groupBy":"hx2TZ","../internal/operators/ignoreElements":"9axK3","../internal/operators/isEmpty":"1QgiI","../internal/operators/last":"4fDgS","../internal/operators/map":"axudj","../internal/operators/mapTo":"811pe","../internal/operators/materialize":"bfk5y","../internal/operators/max":"cTEAZ","../internal/operators/merge":"evr4l","../internal/operators/mergeAll":"74yhD","../internal/operators/flatMap":"L6jye","../internal/operators/mergeMap":"ehxC3","../internal/operators/mergeMapTo":"l9u0a","../internal/operators/mergeScan":"ko59c","../internal/operators/mergeWith":"cbWWZ","../internal/operators/min":"cVBv7","../internal/operators/multicast":"jhjD3","../internal/operators/observeOn":"0Qy0C","../internal/operators/onErrorResumeNextWith":"8dj7U","../internal/operators/pairwise":"24DPj","../internal/operators/partition":"jkQGe","../internal/operators/pluck":"iO80A","../internal/operators/publish":"diZb6","../internal/operators/publishBehavior":"e5QSX","../internal/operators/publishLast":"7KiIc","../internal/operators/publishReplay":"eKmm3","../internal/operators/race":"f6427","../internal/operators/raceWith":"CtY2T","../internal/operators/reduce":"fAhkL","../internal/operators/repeat":"iv6eo","../internal/operators/repeatWhen":"fkbVy","../internal/operators/retry":"1mz4x","../internal/operators/retryWhen":"8VrMd","../internal/operators/refCount":"cPuI1","../internal/operators/sample":"2POSe","../internal/operators/sampleTime":"kFfWs","../internal/operators/scan":"5J7S5","../internal/operators/sequenceEqual":"l7y9t","../internal/operators/share":"krelF","../internal/operators/shareReplay":"8TWOu","../internal/operators/single":"ja2wH","../internal/operators/skip":"1TuW2","../internal/operators/skipLast":"dBVoW","../internal/operators/skipUntil":"4WepI","../internal/operators/skipWhile":"ap7Sm","../internal/operators/startWith":"jgIyl","../internal/operators/subscribeOn":"3TbCm","../internal/operators/switchAll":"ibUC1","../internal/operators/switchMap":"8lUXl","../internal/operators/switchMapTo":"bicdE","../internal/operators/switchScan":"bciWE","../internal/operators/take":"5bXD5","../internal/operators/takeLast":"eW2If","../internal/operators/takeUntil":"K9ueE","../internal/operators/takeWhile":"kF7EX","../internal/operators/tap":"HoAKu","../internal/operators/throttle":"j4uQU","../internal/operators/throttleTime":"av7pG","../internal/operators/throwIfEmpty":"al37L","../internal/operators/timeInterval":"2XvlZ","../internal/operators/timeout":"d6r3h","../internal/operators/timeoutWith":"5Q2q8","../internal/operators/timestamp":"dXtXd","../internal/operators/toArray":"iKZD7","../internal/operators/window":"kR8qq","../internal/operators/windowCount":"1A4qo","../internal/operators/windowTime":"gyiZl","../internal/operators/windowToggle":"irJ6l","../internal/operators/windowWhen":"3oqS8","../internal/operators/withLatestFrom":"kEbSA","../internal/operators/zip":"a4BnD","../internal/operators/zipAll":"4f9g0","../internal/operators/zipWith":"aYnFy","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jkQGe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "partition", ()=>partition);
var _not = require("../util/not");
var _filter = require("./filter");
function partition(predicate, thisArg) {
    return function(source) {
        return [
            (0, _filter.filter)(predicate, thisArg)(source),
            (0, _filter.filter)((0, _not.not)(predicate, thisArg))(source)
        ];
    };
}

},{"../util/not":"8g14G","./filter":"5uWPs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"f6427":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "race", ()=>race);
var _tslib = require("tslib");
var _argsOrArgArray = require("../util/argsOrArgArray");
var _raceWith = require("./raceWith");
function race() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, _raceWith.raceWith).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)((0, _argsOrArgArray.argsOrArgArray)(args))));
}

},{"tslib":"jH8wD","../util/argsOrArgArray":"e5KrS","./raceWith":"CtY2T","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bOzng":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "signerFromPrivateKey", ()=>signerFromPrivateKey);
parcelHelpers.export(exports, "signerFromEthPrivateKey", ()=>signerFromEthPrivateKey);
parcelHelpers.export(exports, "OasisTransaction", ()=>OasisTransaction);
var _client = require("@oasisprotocol/client");
var _clientRt = require("@oasisprotocol/client-rt");
var _errors = require("types/errors");
var _ethHelpers = require("app/lib/eth-helpers");
var _types = require("app/state/paratimes/types");
var _helpers = require("./helpers");
const signerFromPrivateKey = (privateKey)=>{
    return _client.signature.NaclSigner.fromSecret(privateKey, 'this key is not important');
};
const signerFromEthPrivateKey = (ethPrivateKey)=>{
    return _clientRt.signatureSecp256k1.NobleSigner.fromPrivate(ethPrivateKey, 'this key is not important');
};
class OasisTransaction {
    static async buildReclaimEscrow(nic, signer, account, shares) {
        const tw = _client.staking.reclaimEscrowWrapper();
        const nonce = await OasisTransaction.getNonce(nic, signer);
        tw.setNonce(nonce);
        tw.setFeeAmount(_client.quantity.fromBigInt(0n));
        tw.setBody({
            account: await (0, _helpers.addressToPublicKey)(account),
            shares: _client.quantity.fromBigInt(shares)
        });
        const gas = await tw.estimateGas(nic, signer.public());
        tw.setFeeGas(gas);
        return tw;
    }
    static async buildAddEscrow(nic, signer, account, amount) {
        const tw = _client.staking.addEscrowWrapper();
        const nonce = await OasisTransaction.getNonce(nic, signer);
        tw.setNonce(nonce);
        tw.setFeeAmount(_client.quantity.fromBigInt(0n));
        tw.setBody({
            account: await (0, _helpers.addressToPublicKey)(account),
            amount: _client.quantity.fromBigInt(amount)
        });
        const gas = await tw.estimateGas(nic, signer.public());
        tw.setFeeGas(gas);
        return tw;
    }
    static async buildTransfer(nic, signer, to, amount) {
        const tw = _client.staking.transferWrapper();
        const nonce = await OasisTransaction.getNonce(nic, signer);
        tw.setNonce(nonce);
        tw.setFeeAmount(_client.quantity.fromBigInt(0n));
        tw.setBody({
            to: await (0, _helpers.addressToPublicKey)(to),
            amount: _client.quantity.fromBigInt(amount)
        });
        const gas = await tw.estimateGas(nic, signer.public());
        tw.setFeeGas(gas);
        return tw;
    }
    static async buildStakingAllowTransfer(nic, signer, to, amount) {
        const tw = _client.staking.allowWrapper();
        const nonce = await OasisTransaction.getNonce(nic, signer);
        const beneficiary = await (0, _helpers.addressToPublicKey)(to);
        tw.setNonce(nonce);
        tw.setFeeAmount(_client.quantity.fromBigInt(0n));
        tw.setBody({
            beneficiary,
            negative: false,
            amount_change: _client.quantity.fromBigInt(amount)
        });
        const gas = await tw.estimateGas(nic, signer.public());
        tw.setFeeGas(gas);
        return tw;
    }
    /**
   * Note: uses raw user input amounts in ROSE as parameter instead of
   * normalized bigint base units, because it needs to convert to base units
   * dependent on paratime decimals.
   */ static async buildParaTimeTransfer(nic, signer, transaction, fromAddress, runtime) {
        const { amount, recipient: targetAddress, type } = transaction;
        const isDepositing = type === (0, _types.TransactionTypes).Deposit;
        const rtw = isDepositing ? new _clientRt.consensusAccounts.Wrapper(_client.misc.fromHex(runtime.id)).callDeposit() : new _clientRt.consensusAccounts.Wrapper(_client.misc.fromHex(runtime.id)).callWithdraw();
        const accountsWrapper = new _clientRt.accounts.Wrapper(_client.misc.fromHex(runtime.id));
        const nonce = await accountsWrapper.queryNonce().setArgs({
            address: _client.staking.addressFromBech32(fromAddress)
        }).query(nic);
        const feeAmount = BigInt((0, _helpers.parseConsensusToLayerBaseUnit)(transaction.feeAmount, runtime.decimals).toFixed(0));
        const feeGas = transaction.feeGas ? BigInt(transaction.feeGas) : runtime.feeGas;
        const signerInfo = {
            address_spec: {
                signature: {
                    [transaction.ethPrivateKey ? 'secp256k1eth' : 'ed25519']: signer.public()
                }
            },
            nonce
        };
        rtw.setBody({
            amount: [
                _client.quantity.fromBigInt(BigInt((0, _helpers.parseRoseStringToBigNumber)(amount, runtime.decimals).toFixed(0))),
                _clientRt.token.NATIVE_DENOMINATION
            ],
            to: _client.staking.addressFromBech32((0, _ethHelpers.isValidEthAddress)(targetAddress) ? await (0, _ethHelpers.getEvmBech32Address)(targetAddress) : targetAddress)
        }).setFeeAmount([
            _client.quantity.fromBigInt(feeAmount),
            _clientRt.token.NATIVE_DENOMINATION
        ]).setFeeGas(feeGas).setFeeConsensusMessages(1).setSignerInfo([
            signerInfo
        ]);
        return rtw;
    }
    static async signUsingLedger(chainContext, signer, tw) {
        await tw.sign(signer, chainContext);
        // @todo Upstream bug in oasis-app, the signature is larger than 64 bytes
        tw.signedTransaction.signature.signature = tw.signedTransaction.signature.signature.slice(0, 64);
    }
    static async sign(chainContext, signer, tw) {
        return tw.sign(new _client.signature.BlindContextSigner(signer), chainContext);
    }
    static async signParaTime(chainContext, signer, tw) {
        return tw.sign([
            new _client.signature.BlindContextSigner(signer)
        ], chainContext);
    }
    static async submit(nic, tw) {
        try {
            await tw.submit(nic);
        } catch (e) {
            const grpcError = e?.cause?.metadata?.['grpc-message'] || e.message;
            if (!grpcError) throw new (0, _errors.WalletError)((0, _errors.WalletErrors).UnknownError, grpcError, e);
            switch(grpcError){
                case 'transaction: invalid nonce':
                    throw new (0, _errors.WalletError)((0, _errors.WalletErrors).InvalidNonce, 'Invalid nonce');
                case 'consensus: duplicate transaction':
                    throw new (0, _errors.WalletError)((0, _errors.WalletErrors).DuplicateTransaction, 'Duplicate transaction');
                default:
                    throw new (0, _errors.WalletError)((0, _errors.WalletErrors).UnknownGrpcError, grpcError, e);
            }
        }
    }
    static async getNonce(nic, signer) {
        const nonce = await nic.consensusGetSignerNonce({
            account_address: await (0, _helpers.shortPublicKey)(signer.public()),
            height: 0
        });
        return BigInt(nonce || 0);
    }
}

},{"@oasisprotocol/client":"9pxEg","@oasisprotocol/client-rt":"espd1","types/errors":"gbx4q","app/lib/eth-helpers":"gcAe1","app/state/paratimes/types":"h4oxt","./helpers":"bUnFy","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ffPNL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAccountBalanceWithFallback", ()=>getAccountBalanceWithFallback);
var _helpers = require("app/lib/helpers");
var _typedReduxSaga = require("typed-redux-saga");
var _saga = require("../state/network/saga");
function* getBalanceGRPC(address) {
    const nic = yield* (0, _typedReduxSaga.call)((0, _saga.getOasisNic));
    const publicKey = yield* (0, _typedReduxSaga.call)((0, _helpers.addressToPublicKey), address);
    const account = yield* (0, _typedReduxSaga.call)([
        nic,
        nic.stakingAccount
    ], {
        owner: publicKey,
        height: 0
    });
    const grpcBalance = (0, _helpers.parseRpcBalance)(account);
    return {
        address,
        available: grpcBalance.available,
        delegations: null,
        debonding: null,
        total: null,
        nonce: account.general?.nonce?.toString() ?? '0'
    };
}
function* getAccountBalanceWithFallback(address) {
    const { getAccount } = yield* (0, _typedReduxSaga.call)((0, _saga.getExplorerAPIs));
    try {
        const account = yield* (0, _typedReduxSaga.call)(getAccount, address);
        return account;
    } catch (apiError) {
        console.error('get account failed, continuing to RPC fallback.', apiError);
        try {
            const account = yield* (0, _typedReduxSaga.call)(getBalanceGRPC, address);
            return account;
        } catch (rpcError) {
            console.error('get account with RPC failed, continuing without updated account.', rpcError);
            throw apiError;
        }
    }
}

},{"app/lib/helpers":"bUnFy","typed-redux-saga":"1vcsM","../state/network/saga":"9acqo","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cgtJ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectActiveWallet", ()=>selectActiveWallet);
parcelHelpers.export(exports, "selectWallets", ()=>selectWallets);
parcelHelpers.export(exports, "selectAddress", ()=>selectAddress);
parcelHelpers.export(exports, "selectWalletsAddresses", ()=>selectWalletsAddresses);
parcelHelpers.export(exports, "selectPublicKey", ()=>selectPublicKey);
parcelHelpers.export(exports, "selectBalance", ()=>selectBalance);
parcelHelpers.export(exports, "selectType", ()=>selectType);
parcelHelpers.export(exports, "selectHasAccounts", ()=>selectHasAccounts);
parcelHelpers.export(exports, "selectHasOneAccount", ()=>selectHasOneAccount);
var _toolkit = require("@reduxjs/toolkit");
var _ = require(".");
const selectSlice = (state)=>state.wallet || (0, _.initialState);
const selectActiveWallet = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>{
    if (state.selectedWallet == null) return undefined;
    else return state.wallets[state.selectedWallet];
});
const selectWallets = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.wallets ?? {});
const selectAddress = (0, _toolkit.createSelector)([
    selectActiveWallet
], (wallet)=>wallet?.address);
const selectWalletsAddresses = (0, _toolkit.createSelector)([
    selectWallets
], (wallets)=>Object.values(wallets).map((w)=>w.address));
const selectPublicKey = (0, _toolkit.createSelector)([
    selectActiveWallet
], (wallet)=>wallet?.publicKey ?? '');
const selectBalance = (0, _toolkit.createSelector)([
    selectActiveWallet
], (wallet)=>wallet?.balance);
const selectType = (0, _toolkit.createSelector)([
    selectActiveWallet
], (wallet)=>wallet?.type);
const selectHasAccounts = (0, _toolkit.createSelector)([
    selectWallets
], (wallets)=>Object.keys(wallets).length > 0);
const selectHasOneAccount = (0, _toolkit.createSelector)([
    selectWallets
], (wallets)=>Object.keys(wallets).length === 1);

},{"@reduxjs/toolkit":"9ol63",".":"iYAaC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"avcAi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectAccount", ()=>selectAccount);
parcelHelpers.export(exports, "selectTransactions", ()=>selectTransactions);
parcelHelpers.export(exports, "selectTransactionsError", ()=>selectTransactionsError);
parcelHelpers.export(exports, "selectAccountAddress", ()=>selectAccountAddress);
parcelHelpers.export(exports, "selectAccountAvailableBalance", ()=>selectAccountAvailableBalance);
parcelHelpers.export(exports, "selectAccountIsLoading", ()=>selectAccountIsLoading);
parcelHelpers.export(exports, "selectAccountAllowances", ()=>selectAccountAllowances);
parcelHelpers.export(exports, "selectPendingTransactions", ()=>selectPendingTransactions);
parcelHelpers.export(exports, "selectAccountNonce", ()=>selectAccountNonce);
parcelHelpers.export(exports, "selectPendingTransactionForAccount", ()=>selectPendingTransactionForAccount);
parcelHelpers.export(exports, "hasAccountUnknownPendingTransactions", ()=>hasAccountUnknownPendingTransactions);
var _toolkit = require("@reduxjs/toolkit");
var _ = require(".");
var _selectors = require("../network/selectors");
var _config = require("../../../config");
var _types = require("../transaction/types");
const selectSlice = (state)=>state.account || (0, _.initialState);
const selectAccount = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state);
const selectTransactions = (0, _toolkit.createSelector)([
    selectAccount
], (account)=>account.transactions);
const selectTransactionsError = (0, _toolkit.createSelector)([
    selectAccount
], (account)=>account.transactionsError);
const selectAccountAddress = (0, _toolkit.createSelector)([
    selectAccount
], (account)=>account.address);
const selectAccountAvailableBalance = (0, _toolkit.createSelector)([
    selectAccount
], (account)=>account.available);
const selectAccountIsLoading = (0, _toolkit.createSelector)([
    selectAccount
], (account)=>account.loading);
const selectAccountAllowances = (0, _toolkit.createSelector)([
    selectAccount
], (account)=>account.allowances);
const selectPendingTransactions = (0, _toolkit.createSelector)([
    selectAccount
], (account)=>account.pendingTransactions);
const selectAccountNonce = (0, _toolkit.createSelector)([
    selectAccount
], (account)=>account.nonce ?? '0');
const selectPendingTransactionForAccount = (0, _toolkit.createSelector)([
    selectPendingTransactions,
    (0, _selectors.selectSelectedNetwork)
], (pendingTransactions, networkType)=>pendingTransactions[networkType] ?? []);
const hasAccountUnknownPendingTransactions = (0, _toolkit.createSelector)([
    selectAccountNonce,
    selectTransactions,
    selectAccountAddress
], (accountNonce, transactions, accountAddress)=>{
    !transactions.length && accountNonce;
    if (transactions.some((tx)=>tx.status === (0, _types.TransactionStatus).Pending)) // After paratime deposit transaction is submitted, Nexus API returns empty status until one block later.
    // https://github.com/oasisprotocol/explorer/issues/528
    return true;
    const noncesFromTxs = transactions.filter((tx)=>!tx.runtimeId).filter((tx)=>tx.from !== undefined).filter((tx)=>tx.from === accountAddress).filter((tx)=>tx.nonce !== undefined).map((tx)=>BigInt(tx.nonce));
    if (noncesFromTxs.length <= 0) {
        // TODO: last transaction that affected nonce is not in the initial page of account's transactions
        if (transactions.length >= (0, _config.TRANSACTIONS_LIMIT)) return false;
        // if we cannot find any noncesFromTxs this probably means that account is missing some part of historical data
        noncesFromTxs.length;
        // Waiting for first transactions
        return BigInt(accountNonce) > 0n;
    }
    const maxNonceFromTxs = noncesFromTxs.reduce((acc, nonce)=>nonce > acc ? nonce : acc);
    return BigInt(accountNonce) > maxNonceFromTxs + 1n;
});

},{"@reduxjs/toolkit":"9ol63",".":"3cfOb","../network/selectors":"2zit7","../../../config":"akiw0","../transaction/types":"idhb9","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1LjGj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRuntimeBalance", ()=>getRuntimeBalance);
parcelHelpers.export(exports, "fetchBalance", ()=>fetchBalance);
parcelHelpers.export(exports, "fetchBalanceUsingEthPrivateKey", ()=>fetchBalanceUsingEthPrivateKey);
parcelHelpers.export(exports, "fetchBalanceUsingOasisAddress", ()=>fetchBalanceUsingOasisAddress);
parcelHelpers.export(exports, "submitTransaction", ()=>submitTransaction);
parcelHelpers.export(exports, "paraTimesSaga", ()=>paraTimesSaga);
var _typedReduxSaga = require("typed-redux-saga");
var _client = require("@oasisprotocol/client");
var _clientRt = require("@oasisprotocol/client-rt");
var _ethHelpers = require("app/lib/eth-helpers");
var _saga = require("app/state/transaction/saga");
var _saga1 = require("app/state/network/saga");
var _selectors = require("app/state/network/selectors");
var _selectors1 = require("app/state/wallet/selectors");
var _errors = require("types/errors");
var _ = require(".");
var _selectors2 = require("./selectors");
var _config = require("../../../config");
var _evmAccounts = require("../evmAccounts");
async function getRuntimeBalance(address, runtimeId, nic) {
    const accountsWrapper = new (0, _clientRt.accounts).Wrapper(_client.misc.fromHex(runtimeId));
    const accountBalances = await accountsWrapper.queryBalances().setArgs({
        address: await _client.staking.addressFromBech32(address)
    }).query(nic);
    let nativeDenominationBalanceBI = 0n;
    if (accountBalances.balances) {
        const nativeDenominationHex = _client.misc.toHex((0, _clientRt.token).NATIVE_DENOMINATION);
        for (const [denomination, amount] of accountBalances.balances){
            const denominationHex = _client.misc.toHex(denomination);
            if (denominationHex === nativeDenominationHex) {
                nativeDenominationBalanceBI = _client.quantity.toBigInt(amount);
                break;
            }
        }
    }
    return nativeDenominationBalanceBI;
}
function* fetchBalance(oasisAddress, paraTime) {
    try {
        const nic = yield* (0, _typedReduxSaga.call)((0, _saga1.getOasisNic));
        const selectedNetwork = yield* (0, _typedReduxSaga.select)((0, _selectors.selectSelectedNetwork));
        const balance = yield* (0, _typedReduxSaga.call)(getRuntimeBalance, oasisAddress, (0, _config.paraTimesConfig)[paraTime][selectedNetwork].runtimeId, nic);
        yield* (0, _typedReduxSaga.put)((0, _.paraTimesActions).balanceLoaded(balance.toString()));
    } catch (error) {
        throw new (0, _errors.WalletError)((0, _errors.WalletErrors).ParaTimesUnknownError, error);
    }
}
function* fetchBalanceUsingEthPrivateKey() {
    const { transactionForm } = yield* (0, _typedReduxSaga.select)((0, _selectors2.selectParaTimes));
    try {
        const address = (0, _ethHelpers.privateToEthAddress)(transactionForm.ethPrivateKey);
        const oasisAddress = yield* (0, _typedReduxSaga.call)((0, _ethHelpers.getEvmBech32Address), address);
        yield* (0, _typedReduxSaga.call)(fetchBalance, oasisAddress, transactionForm.paraTime);
    } catch (error) {
        throw new (0, _errors.WalletError)((0, _errors.WalletErrors).ParaTimesUnknownError, error);
    }
}
function* fetchBalanceUsingOasisAddress() {
    const address = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectAddress));
    const { transactionForm } = yield* (0, _typedReduxSaga.select)((0, _selectors2.selectParaTimes));
    yield* (0, _typedReduxSaga.call)(fetchBalance, address, transactionForm.paraTime);
}
function* submitTransaction() {
    try {
        const selectedNetwork = yield* (0, _typedReduxSaga.select)((0, _selectors.selectSelectedNetwork));
        const { transactionForm } = yield* (0, _typedReduxSaga.select)((0, _selectors2.selectParaTimes));
        const paraTimeConfig = (0, _config.paraTimesConfig)[transactionForm.paraTime];
        const runtime = {
            address: paraTimeConfig[selectedNetwork].address,
            id: paraTimeConfig[selectedNetwork].runtimeId,
            decimals: paraTimeConfig.decimals,
            feeGas: paraTimeConfig.feeGas
        };
        if (transactionForm.ethPrivateKey) yield* (0, _typedReduxSaga.put)((0, _evmAccounts.evmAccountsActions).add({
            ethPrivateKey: transactionForm.ethPrivateKey
        }));
        yield* (0, _typedReduxSaga.call)((0, _saga.submitParaTimeTransaction), runtime, {
            amount: transactionForm.amount,
            ethPrivateKey: transactionForm.ethPrivateKey,
            feeAmount: transactionForm.feeAmount || transactionForm.defaultFeeAmount,
            feeGas: transactionForm.feeGas,
            recipient: transactionForm.recipient,
            type: transactionForm.type
        });
        yield* (0, _typedReduxSaga.put)((0, _.paraTimesActions).transactionSubmitted());
    } catch (error) {
        yield* (0, _typedReduxSaga.put)((0, _.paraTimesActions).transactionError({
            code: error instanceof (0, _errors.WalletError) ? error.type : (0, _errors.WalletErrors).ParaTimesUnknownError,
            message: error.message
        }));
    }
}
function* paraTimesSaga() {
    yield* (0, _typedReduxSaga.takeLatest)((0, _.paraTimesActions).submitTransaction, submitTransaction);
    yield* (0, _typedReduxSaga.takeLatest)((0, _.paraTimesActions).fetchBalanceUsingOasisAddress, fetchBalanceUsingOasisAddress);
    yield* (0, _typedReduxSaga.takeLatest)((0, _.paraTimesActions).fetchBalanceUsingEthPrivateKey, fetchBalanceUsingEthPrivateKey);
}

},{"typed-redux-saga":"1vcsM","@oasisprotocol/client":"9pxEg","@oasisprotocol/client-rt":"espd1","app/lib/eth-helpers":"gcAe1","app/state/transaction/saga":"fHkpP","app/state/network/saga":"9acqo","app/state/network/selectors":"2zit7","app/state/wallet/selectors":"cgtJ3","types/errors":"gbx4q",".":"63sI2","./selectors":"kgZsW","../../../config":"akiw0","../evmAccounts":"dpUJw","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fHkpP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transactionSaga", ()=>transactionSaga);
/**
 * Generate transaction, sign, push to node
 *
 * Build the transaction (and validate it client-side)
 * Wait for either confirm or cancel, exit saga on cancel
 */ parcelHelpers.export(exports, "doTransaction", ()=>doTransaction);
parcelHelpers.export(exports, "getAllowanceDifference", ()=>getAllowanceDifference);
parcelHelpers.export(exports, "setAllowance", ()=>setAllowance);
parcelHelpers.export(exports, "submitParaTimeTransaction", ()=>submitParaTimeTransaction);
var _client = require("@oasisprotocol/client");
var _helpers = require("app/lib/helpers");
var _ledger = require("app/lib/ledger");
var _transaction = require("app/lib/transaction");
var _ethHelpers = require("app/lib/eth-helpers");
var _typedReduxSaga = require("typed-redux-saga");
var _errors = require("types/errors");
var _ = require(".");
var _saga = require("../importaccounts/saga");
var _saga1 = require("../network/saga");
var _selectors = require("../account/selectors");
var _selectors1 = require("../network/selectors");
var _selectors2 = require("../wallet/selectors");
var _types = require("../wallet/types");
var _types1 = require("./types");
var _types2 = require("../paratimes/types");
var _account = require("../account");
var _consensus = require("@oasisprotocol/client/dist/consensus");
function* transactionSaga() {
    yield* (0, _typedReduxSaga.takeEvery)((0, _.transactionActions).sendTransaction, doTransaction);
    yield* (0, _typedReduxSaga.takeEvery)((0, _.transactionActions).addEscrow, doTransaction);
    yield* (0, _typedReduxSaga.takeEvery)((0, _.transactionActions).reclaimEscrow, doTransaction);
}
function* setStep(step) {
    yield* (0, _typedReduxSaga.put)((0, _.transactionActions).setStep(step));
}
/**
 * When we are previewing a transaction, await either a confirm action,
 * or an abort action.
 */ function* expectConfirmation() {
    const { confirm } = yield* (0, _typedReduxSaga.race)({
        confirm: (0, _typedReduxSaga.take)((0, _.transactionActions).confirmTransaction),
        abort: (0, _typedReduxSaga.take)((0, _.transactionActions).abortTransaction)
    });
    if (confirm) return true;
    else return false;
}
/**
 * Yields the appropriate signer for the currently active wallet
 */ function* getSigner() {
    const wallet = yield* (0, _typedReduxSaga.select)((0, _selectors2.selectActiveWallet));
    if (!wallet) throw new (0, _errors.WalletError)((0, _errors.WalletErrors).NoOpenWallet, 'Cannot send transaction without an active wallet');
    const privateKey = wallet.privateKey;
    let signer;
    if (wallet.type === (0, _types.WalletType).PrivateKey || wallet.type === (0, _types.WalletType).Mnemonic) {
        const bytes = (0, _helpers.hex2uint)(privateKey);
        signer = yield* (0, _typedReduxSaga.call)((0, _transaction.signerFromPrivateKey), bytes);
    } else if (wallet.type === (0, _types.WalletType).UsbLedger || wallet.type === (0, _types.WalletType).BleLedger) signer = new (0, _ledger.LedgerSigner)(wallet);
    else throw new (0, _errors.ExhaustedTypeError)('Invalid wallet type', wallet.type);
    return signer;
}
function* prepareTransfer(signer, amount, to) {
    const nic = yield* (0, _typedReduxSaga.call)((0, _saga1.getOasisNic));
    yield* (0, _typedReduxSaga.call)(assertWalletIsOpen);
    yield* (0, _typedReduxSaga.call)(assertValidAddress, to);
    yield* (0, _typedReduxSaga.call)(assertSufficientBalance, amount);
    yield* (0, _typedReduxSaga.call)(assertRecipientNotSelf, to);
    return yield* (0, _typedReduxSaga.call)((0, _transaction.OasisTransaction).buildTransfer, nic, signer, to, amount);
}
/**
 * Set allowance for ParaTime transaction
 */ function* prepareStakingAllowTransfer(signer, amount, to) {
    const nic = yield* (0, _typedReduxSaga.call)((0, _saga1.getOasisNic));
    yield* (0, _typedReduxSaga.call)(assertWalletIsOpen);
    yield* (0, _typedReduxSaga.call)(assertValidAddress, to);
    yield* (0, _typedReduxSaga.call)(assertSufficientBalance, amount);
    yield* (0, _typedReduxSaga.call)(assertRecipientNotSelf, to);
    return yield* (0, _typedReduxSaga.call)((0, _transaction.OasisTransaction).buildStakingAllowTransfer, nic, signer, to, amount);
}
function* prepareParatimeTransfer(nic, signer, transaction, from, runtime) {
    yield* (0, _typedReduxSaga.call)(assertWalletIsOpen);
    if (transaction.type === (0, _types2.TransactionTypes).Deposit) yield* (0, _typedReduxSaga.call)(assertSufficientBalance, BigInt((0, _helpers.parseRoseStringToBaseUnitString)(transaction.amount)));
    return yield* (0, _typedReduxSaga.call)((0, _transaction.OasisTransaction).buildParaTimeTransfer, nic, signer, transaction, from, runtime);
}
function* prepareAddEscrow(signer, amount, validator) {
    const nic = yield* (0, _typedReduxSaga.call)((0, _saga1.getOasisNic));
    yield* (0, _typedReduxSaga.call)(assertWalletIsOpen);
    yield* (0, _typedReduxSaga.call)(assertValidAddress, validator);
    yield* (0, _typedReduxSaga.call)(assertSufficientBalance, amount);
    return yield* (0, _typedReduxSaga.call)((0, _transaction.OasisTransaction).buildAddEscrow, nic, signer, validator, amount);
}
function* prepareReclaimEscrow(signer, shares, validator) {
    const nic = yield* (0, _typedReduxSaga.call)((0, _saga1.getOasisNic));
    yield* (0, _typedReduxSaga.call)(assertWalletIsOpen);
    yield* (0, _typedReduxSaga.call)(assertValidAddress, validator);
    return yield* (0, _typedReduxSaga.call)((0, _transaction.OasisTransaction).buildReclaimEscrow, nic, signer, validator, shares);
}
function* doTransaction(action) {
    const wallet = yield* (0, _typedReduxSaga.select)((0, _selectors2.selectActiveWallet));
    const nic = yield* (0, _typedReduxSaga.call)((0, _saga1.getOasisNic));
    const chainContext = yield* (0, _typedReduxSaga.call)((0, _saga1.getChainContext));
    const networkType = yield* (0, _typedReduxSaga.select)((0, _selectors1.selectSelectedNetwork));
    try {
        yield* setStep((0, _types1.TransactionStep).Building);
        yield* (0, _typedReduxSaga.call)(assertWalletIsOpen);
        const activeWallet = wallet;
        const signer = yield* getSigner();
        let tw;
        switch(action.payload.type){
            case 'transfer':
                tw = yield* (0, _typedReduxSaga.call)(prepareTransfer, signer, BigInt(action.payload.amount), action.payload.to);
                break;
            case 'addEscrow':
                tw = yield* (0, _typedReduxSaga.call)(prepareAddEscrow, signer, BigInt(action.payload.amount), action.payload.validator);
                break;
            case 'reclaimEscrow':
                tw = yield* (0, _typedReduxSaga.call)(prepareReclaimEscrow, signer, BigInt(action.payload.shares), action.payload.validator);
                break;
            default:
                throw new (0, _errors.ExhaustedTypeError)('Unsupported transaction type', action.payload);
        }
        yield* (0, _typedReduxSaga.put)((0, _.transactionActions).updateTransactionPreview({
            transaction: action.payload,
            fee: (0, _helpers.uint2bigintString)(tw.transaction.fee?.amount),
            gas: BigInt(tw.transaction.fee?.gas).toString()
        }));
        yield* setStep((0, _types1.TransactionStep).Preview);
        const confirmed = yield* expectConfirmation();
        if (!confirmed) {
            yield* (0, _typedReduxSaga.put)((0, _.transactionActions).clearTransaction());
            return;
        }
        yield* setStep((0, _types1.TransactionStep).Signing);
        if (activeWallet.type === (0, _types.WalletType).UsbLedger || activeWallet.type === (0, _types.WalletType).BleLedger) yield* (0, _typedReduxSaga.call)((0, _saga.sign), signer, tw);
        else yield* (0, _typedReduxSaga.call)((0, _transaction.OasisTransaction).sign, chainContext, signer, tw);
        yield* setStep((0, _types1.TransactionStep).Submitting);
        yield* (0, _typedReduxSaga.call)((0, _transaction.OasisTransaction).submit, nic, tw);
        // Notify that the transaction was a success
        yield* (0, _typedReduxSaga.put)((0, _.transactionActions).transactionSent(action.payload));
        const hash = yield* (0, _typedReduxSaga.call)([
            tw,
            tw.hash
        ]);
        const transaction = {
            hash,
            type: tw.transaction.method,
            from: activeWallet.address,
            amount: action.payload.amount,
            to: undefined,
            ...action.payload.type === 'transfer' ? {
                to: action.payload.to
            } : {},
            ...action.payload.type === 'addEscrow' ? {
                to: action.payload.validator
            } : {},
            ...action.payload.type === 'reclaimEscrow' ? {
                to: action.payload.validator
            } : {},
            status: (0, _types1.TransactionStatus).Pending,
            fee: undefined,
            level: undefined,
            round: undefined,
            runtimeId: undefined,
            runtimeName: undefined,
            timestamp: undefined,
            nonce: undefined
        };
        yield* (0, _typedReduxSaga.put)((0, _account.accountActions).addPendingTransaction({
            transaction,
            networkType
        }));
    } catch (e) {
        let payload;
        if (e instanceof (0, _errors.WalletError)) payload = {
            code: e.type,
            message: e.message
        };
        else payload = {
            code: (0, _errors.WalletErrors).UnknownError,
            message: e.message
        };
        yield* (0, _typedReduxSaga.put)((0, _.transactionActions).transactionFailed(payload));
    }
}
function* getAllowanceDifference(amount, runtimeAddress) {
    const allowances = yield* (0, _typedReduxSaga.select)((0, _selectors.selectAccountAllowances));
    const allowance = allowances ? allowances.find((item)=>item.address === runtimeAddress)?.amount ?? 0 // No allowance set yet
     : 0 // Allowance info is missing
    ;
    return BigInt((0, _helpers.parseRoseStringToBaseUnitString)(amount)) - BigInt(allowance);
}
function* setAllowance(nic, chainContext, amount, runtimeAddress) {
    const allowanceDifference = yield* (0, _typedReduxSaga.call)(getAllowanceDifference, amount, runtimeAddress);
    if (allowanceDifference > 0n) {
        const signer = yield* getSigner();
        const tw = yield* (0, _typedReduxSaga.call)(prepareStakingAllowTransfer, signer, allowanceDifference, runtimeAddress);
        yield* (0, _typedReduxSaga.call)((0, _transaction.OasisTransaction).sign, chainContext, signer, tw);
        yield* (0, _typedReduxSaga.call)((0, _transaction.OasisTransaction).submit, nic, tw);
        yield* (0, _typedReduxSaga.put)((0, _account.accountActions).addPendingTransaction({
            transaction: {
                hash: yield* (0, _typedReduxSaga.call)([
                    tw,
                    tw.hash
                ]),
                type: tw.transaction.method,
                from: yield* (0, _typedReduxSaga.call)((0, _helpers.publicKeyToAddress), signer.public()),
                amount: allowanceDifference.toString(),
                to: undefined,
                status: (0, _types1.TransactionStatus).Pending,
                fee: undefined,
                level: undefined,
                round: undefined,
                runtimeId: undefined,
                runtimeName: undefined,
                timestamp: undefined,
                nonce: undefined
            },
            networkType: yield* (0, _typedReduxSaga.select)((0, _selectors1.selectSelectedNetwork))
        }));
    }
}
function* submitParaTimeTransaction(runtime, transaction) {
    const fromOasisAddress = transaction.ethPrivateKey ? yield* (0, _typedReduxSaga.call)((0, _ethHelpers.getEvmBech32Address), (0, _ethHelpers.privateToEthAddress)(transaction.ethPrivateKey)) : yield* (0, _typedReduxSaga.select)((0, _selectors.selectAccountAddress));
    const fromAddress = transaction.ethPrivateKey ? (0, _ethHelpers.privateToEthAddress)(transaction.ethPrivateKey) : yield* (0, _typedReduxSaga.select)((0, _selectors.selectAccountAddress));
    const nic = yield* (0, _typedReduxSaga.call)((0, _saga1.getOasisNic));
    const chainContext = yield* (0, _typedReduxSaga.call)((0, _saga1.getChainContext));
    const paraTimeTransactionSigner = transaction.ethPrivateKey ? yield* (0, _typedReduxSaga.call)((0, _transaction.signerFromEthPrivateKey), (0, _client.misc).fromHex(transaction.ethPrivateKey)) : yield* getSigner();
    if (transaction.type === (0, _types2.TransactionTypes).Deposit) yield* (0, _typedReduxSaga.call)(setAllowance, nic, chainContext, transaction.amount, runtime.address);
    const rtw = yield* (0, _typedReduxSaga.call)(prepareParatimeTransfer, nic, paraTimeTransactionSigner, transaction, fromOasisAddress, runtime);
    yield* (0, _typedReduxSaga.call)((0, _transaction.OasisTransaction).signParaTime, chainContext, paraTimeTransactionSigner, rtw);
    yield* (0, _typedReduxSaga.call)((0, _transaction.OasisTransaction).submit, nic, rtw);
    yield* (0, _typedReduxSaga.put)((0, _.transactionActions).paraTimeTransactionSent(transaction.recipient));
    const hash = yield* (0, _typedReduxSaga.call)((0, _consensus.hashSignedTransaction), rtw.unverifiedTransaction) // TODO use rtw.hash when added
    ;
    yield* (0, _typedReduxSaga.put)((0, _account.accountActions).addPendingTransaction({
        transaction: {
            hash: hash,
            type: rtw.transaction.call.method,
            from: fromAddress,
            amount: (0, _helpers.parseRoseStringToBaseUnitString)(transaction.amount),
            to: transaction.recipient,
            status: (0, _types1.TransactionStatus).Pending,
            fee: undefined,
            level: undefined,
            round: undefined,
            runtimeId: undefined,
            runtimeName: undefined,
            timestamp: undefined,
            nonce: undefined
        },
        networkType: yield* (0, _typedReduxSaga.select)((0, _selectors1.selectSelectedNetwork))
    }));
}
function* assertWalletIsOpen() {
    const wallet = yield* (0, _typedReduxSaga.select)((0, _selectors2.selectActiveWallet));
    if (!wallet) throw new (0, _errors.WalletError)((0, _errors.WalletErrors).NoOpenWallet, 'Cannot send transaction without an active wallet');
}
function assertValidAddress(address) {
    if (!(0, _helpers.isValidAddress)(address)) throw new (0, _errors.WalletError)((0, _errors.WalletErrors).InvalidAddress, 'Invalid address');
}
function* assertSufficientBalance(amount) {
    const wallet = yield* (0, _typedReduxSaga.select)((0, _selectors2.selectActiveWallet));
    // If balance is missing, allow this to pass. It's just more likely that transaction will fail after submitting.
    if (wallet?.balance?.available == null) return;
    const balance = BigInt(wallet.balance.available);
    if (amount > balance) throw new (0, _errors.WalletError)((0, _errors.WalletErrors).InsufficientBalance, 'Insufficient balance');
}
function* assertRecipientNotSelf(recipient) {
    const wallet = yield* (0, _typedReduxSaga.select)((0, _selectors2.selectActiveWallet));
    if (wallet.address === recipient) throw new (0, _errors.WalletError)((0, _errors.WalletErrors).CannotSendToSelf, 'Cannot send to your own account');
}

},{"@oasisprotocol/client":"9pxEg","app/lib/helpers":"bUnFy","app/lib/ledger":"bREEn","app/lib/transaction":"bOzng","app/lib/eth-helpers":"gcAe1","typed-redux-saga":"1vcsM","types/errors":"gbx4q",".":"jax2p","../importaccounts/saga":"4YSF4","../network/saga":"9acqo","../account/selectors":"avcAi","../network/selectors":"2zit7","../wallet/selectors":"cgtJ3","../wallet/types":"b0U5N","./types":"idhb9","../paratimes/types":"h4oxt","../account":"3cfOb","@oasisprotocol/client/dist/consensus":"6XVjL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kgZsW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectParaTimes", ()=>selectParaTimes);
var _toolkit = require("@reduxjs/toolkit");
var _ = require(".");
const selectSlice = (state)=>state.paraTimes || (0, _.initialState);
const selectParaTimes = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state);

},{"@reduxjs/toolkit":"9ol63",".":"63sI2","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jaE7S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "persistSaga", ()=>persistSaga);
var _typedReduxSaga = require("typed-redux-saga");
var _reduxStateSync = require("redux-state-sync");
var _index = require("./index");
var _encryption = require("./encryption");
var _errors = require("types/errors");
var _wallet = require("app/state/wallet");
var _selectUnlockedStatus = require("app/state/selectUnlockedStatus");
var _runtimeIs = require("app/lib/runtimeIs");
var _walletExtensionV0 = require("../../../utils/walletExtensionV0");
var _selectors = require("./selectors");
function* watchPersistAsync() {
    yield* (0, _typedReduxSaga.fork)(function*() {
        const channelQueue = yield* (0, _typedReduxSaga.actionChannel)('*');
        while(true){
            // TODO: could flush(channelQueue) to speedup multiple consecutive writes
            const action = yield* (0, _typedReduxSaga.take)(channelQueue);
            // Make queue of async operations, without forking, to avoid race
            // conditions (e.g. multiple writes to localStorage in wrong order).
            // Problems with queue:
            // - select() returns latest state instead of state when action was dispatched.
            //   I think that still works correctly.
            yield* (0, _typedReduxSaga.call)(handleAsyncPersistActions, action);
        }
    });
}
function* handleAsyncPersistActions(action) {
    if ((0, _index.persistActions).setPasswordAsync.match(action)) yield* (0, _typedReduxSaga.call)(setPasswordAsync, action.payload.password);
    else if ((0, _index.persistActions).unlockAsync.match(action)) yield* (0, _typedReduxSaga.call)(unlockAsync, action);
    else if ((0, _index.persistActions).lockAsync.match(action)) yield* (0, _typedReduxSaga.call)(lockAsync, action);
    else if ((0, _index.persistActions).deleteProfileAsync.match(action)) yield* (0, _typedReduxSaga.call)(deleteProfileAsync, action);
    else if ((0, _index.persistActions).updatePasswordAsync.match(action)) yield* (0, _typedReduxSaga.call)(updatePasswordAsync, action);
    else if ((0, _index.persistActions).setUnlockedRootState.match(action)) ;
    else if ((0, _index.persistActions).resetRootState.match(action)) // Skip encrypting the empty state
    yield* (0, _typedReduxSaga.call)(resetRootState, action);
    else if ((0, _index.persistActions).setWrongPassword.match(action)) ;
    else if ((0, _index.persistActions).finishV0Migration.match(action)) yield* (0, _typedReduxSaga.call)(finishV0Migration, action);
    else // Encrypt after other actions
    yield* (0, _typedReduxSaga.call)(encryptAndPersistState, action);
}
// Handlers
function* setPasswordAsync(password) {
    /**
   * Latest state does not match state immediately after action was dispatched,
   * but when it is queued by {@link watchPersistAsync}.
   */ const latestState = yield* (0, _typedReduxSaga.select)();
    if (latestState.persist.isPersistenceUnsupported) throw new Error('Persistence not supported');
    const keyWithSalt = yield* (0, _typedReduxSaga.call)((0, _encryption.deriveKeyFromPassword), password);
    const encryptedState = yield* (0, _typedReduxSaga.call)(encryptState, latestState, keyWithSalt);
    window.localStorage.setItem((0, _index.STORAGE_FIELD), encryptedState);
    const encryptedState2 = window.localStorage.getItem((0, _index.STORAGE_FIELD));
    const unlockedPayload = yield* (0, _typedReduxSaga.call)(decryptState, encryptedState2, password);
    yield* (0, _typedReduxSaga.put)((0, _index.persistActions).setUnlockedRootState(unlockedPayload));
}
function* unlockAsync(action) {
    const encryptedState = window.localStorage.getItem((0, _index.STORAGE_FIELD));
    if (!encryptedState) throw new Error('Unexpected unlock action while no state is locked');
    try {
        const unlockedPayload = yield* (0, _typedReduxSaga.call)(decryptState, encryptedState, action.payload.password);
        yield* (0, _typedReduxSaga.put)((0, _index.persistActions).setUnlockedRootState(unlockedPayload));
    } catch (error) {
        if (error instanceof (0, _errors.PasswordWrongError)) yield* (0, _typedReduxSaga.put)((0, _index.persistActions).setWrongPassword());
        else throw error;
    }
}
function* updatePasswordAsync(action) {
    const encryptedState = window.localStorage.getItem((0, _index.STORAGE_FIELD));
    if (!encryptedState) throw new Error('Unexpected update password action while no state is locked');
    try {
        // used only for a current password validation, doesn't use decrypted result
        yield* (0, _typedReduxSaga.call)(decryptState, encryptedState, action.payload.currentPassword);
        yield* (0, _typedReduxSaga.put)((0, _index.persistActions).setPasswordAsync({
            password: action.payload.password
        }));
    } catch (error) {
        if (error instanceof (0, _errors.PasswordWrongError)) yield* (0, _typedReduxSaga.put)((0, _index.persistActions).setWrongPassword());
        else throw error;
    }
}
function* lockAsync(action) {
    yield* (0, _typedReduxSaga.put)((0, _index.persistActions).resetRootState());
// Implies state.loading = false
}
function* deleteProfileAsync(action) {
    yield* (0, _typedReduxSaga.call)([
        window.localStorage,
        window.localStorage.removeItem
    ], (0, _index.STORAGE_FIELD));
    yield* (0, _typedReduxSaga.put)((0, _index.persistActions).resetRootState());
// Implies state.loading = false
}
function* resetRootState(action) {
    const unlockedStatus = yield* (0, _typedReduxSaga.select)((0, _selectUnlockedStatus.selectUnlockedStatus));
    // Redirect home to prevent infinite loading if user closes unpersisted wallet in another tab.
    if ((0, _reduxStateSync.isActionSynced)(action) && unlockedStatus === 'emptyUnpersisted') // Note: requires saga to be running in popup in extension, not in a service worker.
    yield* (0, _typedReduxSaga.call)([
        window.location,
        window.location.assign
    ], '/');
}
function* finishV0Migration(action) {
    yield* (0, _typedReduxSaga.put)((0, _index.persistActions).setUnlockedRootState({
        persistedRootState: action.payload.persistedRootState,
        stringifiedEncryptionKey: 'skipped'
    }));
    yield* (0, _typedReduxSaga.call)(setPasswordAsync, action.payload.password);
    // Just being extra careful before deleting old state
    const stateAfterMigration = yield* (0, _typedReduxSaga.select)();
    if (Object.values(action.payload.persistedRootState.wallet.wallets).length !== Object.values(stateAfterMigration.wallet.wallets).length) throw new Error('Something went wrong during V0 state migration');
    yield* (0, _typedReduxSaga.call)((0, _walletExtensionV0.backupAndDeleteV0ExtProfile));
}
// Encrypting
async function encryptState(state, keyWithSalt) {
    const persistedRootState = {
        contacts: state.contacts,
        evmAccounts: state.evmAccounts,
        settings: state.settings,
        theme: state.theme,
        wallet: state.wallet,
        network: state.network
    };
    const encryptedState = await (0, _encryption.encryptWithKey)(keyWithSalt, persistedRootState);
    return encryptedState;
}
async function decryptState(encryptedState, password) {
    const persistedRootState = await (0, _encryption.decryptWithPassword)(password, encryptedState);
    const keyWithSalt = await (0, _encryption.deriveKeyFromPassword)(password);
    const stringifiedEncryptionKey = (0, _encryption.base64andStringify)(keyWithSalt);
    return {
        persistedRootState,
        stringifiedEncryptionKey
    };
}
function* encryptAndPersistState(action) {
    /**
   * Latest state does not match state immediately after action was dispatched,
   * but when it is queued by {@link watchPersistAsync}.
   */ const latestState = yield* (0, _typedReduxSaga.select)();
    if (latestState.persist.stringifiedEncryptionKey === 'skipped') return;
    if (action.type.startsWith('@')) return; // Ignore @@INIT from redux-devtools-instrument
    if (action.type.startsWith('&')) return; // Ignore e.g. &_GET_INIT_STATE from redux-state-sync
    if ((0, _reduxStateSync.isActionSynced)(action)) return; // Ignore actions synced across tabs from redux-state-sync
    // Handle actions while state is locked
    // TODO: If we used private/public key-pair we could encrypt and persist
    // state while state is locked. But not if we support multiple profiles.
    if (!latestState.persist.stringifiedEncryptionKey) {
        if ((0, _wallet.walletActions).walletOpened.match(action)) throw new Error('Could not add account while state is locked.');
        else return; // Ignore non-essential actions emitted while state is locked.
    }
    const keyWithSalt = (0, _encryption.fromBase64andParse)(latestState.persist.stringifiedEncryptionKey);
    const encryptedState = yield* (0, _typedReduxSaga.call)(encryptState, latestState, keyWithSalt);
    window.localStorage.setItem((0, _index.STORAGE_FIELD), encryptedState);
}
function* retainEncryptionKeyBetweenPopupReopenings() {
    yield* (0, _typedReduxSaga.fork)(function*() {
        if ((0, _runtimeIs.runtimeIs) !== 'extension') return;
        // Read before rewriting.
        const encryptedState = window.localStorage.getItem((0, _index.STORAGE_FIELD));
        if (encryptedState) try {
            const stringifiedEncryptionKey = yield* (0, _typedReduxSaga.call)(readSharedExtMemory);
            if (!stringifiedEncryptionKey) throw new Error('skip');
            if (stringifiedEncryptionKey === 'skipped') throw new Error('skip');
            const keyWithSalt = (0, _encryption.fromBase64andParse)(stringifiedEncryptionKey);
            const persistedRootState = yield* (0, _typedReduxSaga.call)((0, _encryption.decryptWithKey), keyWithSalt, encryptedState);
            yield* (0, _typedReduxSaga.put)((0, _index.persistActions).setUnlockedRootState({
                persistedRootState,
                stringifiedEncryptionKey
            }));
        } catch (error) {
        // Ignore
        }
        const channelQueue = yield* (0, _typedReduxSaga.actionChannel)('*');
        let previousStringifiedEncryptionKey = undefined;
        while(true){
            yield* (0, _typedReduxSaga.take)(channelQueue);
            const stringifiedEncryptionKey = yield* (0, _typedReduxSaga.select)((0, _selectors.selectStringifiedEncryptionKey));
            if (stringifiedEncryptionKey !== previousStringifiedEncryptionKey) {
                previousStringifiedEncryptionKey = stringifiedEncryptionKey;
                yield* (0, _typedReduxSaga.call)(writeSharedExtMemory, stringifiedEncryptionKey);
            }
        }
    });
}
async function writeSharedExtMemory(stringifiedEncryptionKey) {
    if ((0, _runtimeIs.runtimeIs) !== 'extension') return;
    const browser = await require("7ec606d737f0499");
    // Chrome ignores undefined values https://github.com/w3c/webextensions/issues/263
    if (stringifiedEncryptionKey) await browser.storage.session.set({
        stringifiedEncryptionKey
    });
    else await browser.storage.session.remove('stringifiedEncryptionKey');
}
async function readSharedExtMemory() {
    if ((0, _runtimeIs.runtimeIs) !== 'extension') return;
    const browser = await require("7ec606d737f0499");
    const storage = await browser.storage.session.get('stringifiedEncryptionKey');
    return storage.stringifiedEncryptionKey;
}
function* persistSaga() {
    yield* watchPersistAsync();
    yield* retainEncryptionKeyBetweenPopupReopenings();
    const storageV0 = yield* (0, _typedReduxSaga.call)((0, _walletExtensionV0.readStorageV0));
    yield* (0, _typedReduxSaga.put)((0, _index.persistActions).setHasV0StorageToMigrate(!!storageV0?.chromeStorageLocal.keyringData));
}

},{"typed-redux-saga":"1vcsM","redux-state-sync":"g1h73","./index":"9hwZK","./encryption":"aN5Qo","types/errors":"gbx4q","app/state/wallet":"iYAaC","app/state/selectUnlockedStatus":"aRpzm","app/lib/runtimeIs":"fboJV","../../../utils/walletExtensionV0":"7XgZH","./selectors":"lDilG","7ec606d737f0499":"aKZJC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aN5Qo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deriveKeyFromPassword", ()=>deriveKeyFromPassword);
parcelHelpers.export(exports, "encryptWithKey", ()=>encryptWithKey);
parcelHelpers.export(exports, "decryptWithPassword", ()=>decryptWithPassword);
parcelHelpers.export(exports, "decryptWithKey", ()=>decryptWithKey);
parcelHelpers.export(exports, "base64andStringify", ()=>base64andStringify);
parcelHelpers.export(exports, "fromBase64andParse", ()=>fromBase64andParse);
var _tweetnacl = require("tweetnacl");
var _tweetnaclDefault = parcelHelpers.interopDefault(_tweetnacl);
var _errors = require("types/errors");
var Buffer = require("9c609ba7fc85d37d").Buffer;
async function deriveKeyFromPassword(password, salt = crypto.getRandomValues(new Uint8Array(32))) {
    const key = await crypto.subtle.importKey('raw', new TextEncoder().encode(password), {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]);
    const passwordDerivedBits = await crypto.subtle.deriveBits({
        name: 'PBKDF2',
        salt: salt,
        iterations: 310000,
        hash: 'SHA-256'
    }, key, (0, _tweetnaclDefault.default).secretbox.keyLength * 8);
    return {
        key: new Uint8Array(passwordDerivedBits),
        salt: salt
    };
}
async function encryptWithKey(keyWithSalt, dataObj) {
    const dataBytes = new TextEncoder().encode(JSON.stringify(dataObj));
    const nonce = (0, _tweetnaclDefault.default).randomBytes((0, _tweetnaclDefault.default).secretbox.nonceLength);
    const encryptedObj = {
        secretbox: (0, _tweetnaclDefault.default).secretbox(dataBytes, nonce, keyWithSalt.key),
        nonce: nonce,
        salt: keyWithSalt.salt
    };
    const encryptedString = base64andStringify(encryptedObj);
    return encryptedString;
}
async function decryptWithPassword(password, encryptedString) {
    const encryptedObj = fromBase64andParse(encryptedString);
    const derivedKeyWithSalt = await deriveKeyFromPassword(password, encryptedObj.salt);
    return await decryptWithKey(derivedKeyWithSalt, encryptedString);
}
async function decryptWithKey(derivedKeyWithSalt, encryptedString) {
    const encryptedObj = fromBase64andParse(encryptedString);
    const dataBytes = (0, _tweetnaclDefault.default).secretbox.open(encryptedObj.secretbox, encryptedObj.nonce, derivedKeyWithSalt.key);
    if (!dataBytes) throw new (0, _errors.PasswordWrongError)();
    const dataObj = JSON.parse(new TextDecoder().decode(dataBytes));
    return dataObj;
}
function base64andStringify(obj) {
    return JSON.stringify(obj, (k, v)=>{
        if (v instanceof Uint8Array) return {
            $Uint8Array$: Buffer.from(v).toString('base64')
        };
        return v;
    });
}
function fromBase64andParse(str) {
    return JSON.parse(str, (k, v)=>{
        if (typeof v === 'object' && '$Uint8Array$' in v) return new Uint8Array(Buffer.from(v.$Uint8Array$, 'base64'));
        return v;
    });
}

},{"9c609ba7fc85d37d":"eXvXD","tweetnacl":"5ZWFX","types/errors":"gbx4q","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aRpzm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectUnlockedStatus", ()=>selectUnlockedStatus);
var _toolkit = require("@reduxjs/toolkit");
var _selectors = require("app/state/persist/selectors");
var _selectors1 = require("app/state/wallet/selectors");
const selectUnlockedStatus = (0, _toolkit.createSelector)([
    (0, _selectors.selectSlice),
    (0, _selectors1.selectHasAccounts)
], (state, hasAccounts)=>{
    if (state.hasPersistedProfiles) {
        if (state.stringifiedEncryptionKey === 'skipped') {
            if (hasAccounts) return 'openSkippedUnlockingProfile';
            return 'emptySkippedUnlockingProfile';
        }
        if (state.stringifiedEncryptionKey) return 'unlockedProfile';
        return 'lockedProfile';
    } else {
        if (hasAccounts) return 'openUnpersisted';
        return 'emptyUnpersisted';
    }
});

},{"@reduxjs/toolkit":"9ol63","app/state/persist/selectors":"lDilG","app/state/wallet/selectors":"cgtJ3","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7XgZH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "backupAndDeleteV0ExtProfile", ()=>backupAndDeleteV0ExtProfile);
parcelHelpers.export(exports, "readStorageV0", ()=>readStorageV0);
parcelHelpers.export(exports, "readAndMigrateLanguageV0", ()=>readAndMigrateLanguageV0);
parcelHelpers.export(exports, "decryptWithPasswordV0", ()=>decryptWithPasswordV0);
var _runtimeIs = require("app/lib/runtimeIs");
var _browserPassworder = require("@metamask/browser-passworder");
var _network = require("../app/state/network");
var _types = require("../app/state/wallet/types");
var _helpers = require("../app/lib/helpers");
var _key = require("../app/lib/key");
var _errors = require("../types/errors");
async function backupAndDeleteV0ExtProfile() {
    if ((0, _runtimeIs.runtimeIs) !== 'extension') throw new Error('Can only delete V0 profile in an extension');
    const browser = await require("45f2f98174899c4b");
    const backupStorage = await readStorageV0();
    window.localStorage.setItem('oasis_wallet_backup_v0', JSON.stringify(backupStorage));
    await browser.storage.local.remove('keyringData');
    window.localStorage.removeItem('ADDRESS_BOOK_CONFIG');
    window.localStorage.removeItem('LANGUAGE_CONFIG');
    window.localStorage.removeItem('NETWORK_CONFIG');
    window.localStorage.removeItem('DISMISSED_NEW_EXTENSION_WARNING');
}
async function readStorageV0() {
    if ((0, _runtimeIs.runtimeIs) !== 'extension') return;
    const browser = await require("45f2f98174899c4b");
    return {
        chromeStorageLocal: {
            keyringData: (await browser.storage.local.get('keyringData')).keyringData
        },
        localStorage: {
            ADDRESS_BOOK_CONFIG: window.localStorage.getItem('ADDRESS_BOOK_CONFIG') ?? '[]',
            LANGUAGE_CONFIG: window.localStorage.getItem('LANGUAGE_CONFIG') ?? undefined,
            NETWORK_CONFIG: window.localStorage.getItem('NETWORK_CONFIG') ?? undefined,
            DISMISSED_NEW_EXTENSION_WARNING: window.localStorage.getItem('DISMISSED_NEW_EXTENSION_WARNING') ?? undefined
        }
    };
}
async function typedMetamaskDecrypt(password, encrypted) {
    try {
        return await (0, _browserPassworder.decrypt)(password, encrypted);
    } catch (error) {
        throw new (0, _errors.PasswordWrongError)();
    }
}
function typedJsonParse(str) {
    return JSON.parse(str);
}
function validateAndExpandPrivateKey(privateKeyLongOrShortOrTyposHex) {
    try {
        return (0, _helpers.uint2hex)((0, _key.OasisKey).fromPrivateKey((0, _helpers.hex2uint)(privateKeyLongOrShortOrTyposHex)));
    } catch (e) {
        return '';
    }
}
function readAndMigrateLanguageV0() {
    return window.localStorage.getItem('LANGUAGE_CONFIG') === 'zh_CN' ? 'zh_CN' : 'en';
}
async function decryptWithPasswordV0(password, extensionV0State) {
    if (!extensionV0State.chromeStorageLocal.keyringData) throw new Error('No v0 encrypted data');
    const keyringData = (await typedMetamaskDecrypt(password, extensionV0State.chromeStorageLocal.keyringData))[0];
    const mnemonic = await typedMetamaskDecrypt(password, keyringData.mnemonic);
    const decryptedAccounts = await Promise.all(keyringData.accounts.map(async (acc)=>{
        if (!('privateKey' in acc)) return acc;
        const privateKeyLongOrShortOrTypos = await typedMetamaskDecrypt(password, acc.privateKey);
        if (acc.type === 'WALLET_OUTSIDE_SECP256K1') return {
            ...acc,
            privateKey: privateKeyLongOrShortOrTypos,
            privateKeyLongOrShortOrTypos
        };
        const privateKey = validateAndExpandPrivateKey(privateKeyLongOrShortOrTypos);
        return {
            ...acc,
            privateKey,
            privateKeyLongOrShortOrTypos
        };
    }));
    const [validAccounts, invalidAccounts] = [
        decryptedAccounts.map((acc)=>'privateKey' in acc && acc.privateKey === '' ? undefined : acc).filter((a)=>!!a),
        decryptedAccounts.map((acc)=>'privateKey' in acc && acc.privateKey === '' ? acc : undefined).filter((a)=>!!a)
    ];
    const wallets = Object.fromEntries(validAccounts.map((acc)=>{
        if (acc.type === 'WALLET_INSIDE') return {
            publicKey: acc.publicKey,
            address: acc.address,
            type: (0, _types.WalletType).Mnemonic,
            path: [
                44,
                474,
                acc.hdPath
            ],
            pathDisplay: `m/44'/474'/${acc.hdPath}'`,
            privateKey: acc.privateKey,
            balance: {
                available: null,
                debonding: null,
                delegations: null,
                total: null,
                nonce: '0'
            },
            name: acc.accountName
        };
        if (acc.type === 'WALLET_OUTSIDE') return {
            publicKey: acc.publicKey,
            address: acc.address,
            type: (0, _types.WalletType).PrivateKey,
            privateKey: acc.privateKey,
            balance: {
                available: null,
                debonding: null,
                delegations: null,
                total: null,
                nonce: '0'
            },
            name: acc.accountName
        };
        if (acc.type === 'WALLET_LEDGER') return {
            publicKey: acc.publicKey,
            address: acc.address,
            type: (0, _types.WalletType).UsbLedger,
            path: [
                44,
                474,
                0,
                0,
                acc.ledgerHdIndex
            ],
            pathDisplay: `m/44'/474'/0'/0'/${acc.ledgerHdIndex}'`,
            balance: {
                available: null,
                debonding: null,
                delegations: null,
                total: null,
                nonce: '0'
            },
            name: acc.accountName
        };
        return undefined;
    }).filter((a)=>!!a).map((a)=>[
            a.address,
            a
        ]));
    const invalidPrivateKeys = invalidAccounts.map((a)=>({
            privateKeyWithTypos: a.privateKeyLongOrShortOrTypos,
            name: a.accountName,
            address: a.address
        }));
    const evmAccounts = Object.fromEntries(validAccounts.map((acc)=>{
        if (acc.type !== 'WALLET_OUTSIDE_SECP256K1') return undefined;
        return {
            ethPrivateKey: acc.privateKey,
            ethAddress: acc.evmAddress
        };
    }).filter((a)=>!!a).map((a)=>[
            a.ethAddress,
            a
        ]));
    const observedAccounts = validAccounts.filter((acc)=>acc.type === 'WALLET_OBSERVE').map((acc)=>({
            name: acc.accountName,
            address: acc.address
        }));
    const addressBookAccounts = typedJsonParse(extensionV0State.localStorage.ADDRESS_BOOK_CONFIG);
    const contacts = Object.fromEntries([
        ...observedAccounts,
        ...addressBookAccounts
    ].map((a)=>[
            a.address,
            a
        ]));
    const state = {
        contacts: contacts,
        evmAccounts: evmAccounts,
        settings: {
            screenPrivacy: 'on'
        },
        network: (0, _network.initialState),
        theme: {
            selected: 'light'
        },
        wallet: {
            selectedWallet: keyringData.currentAddress,
            wallets: wallets
        }
    };
    return {
        mnemonic,
        invalidPrivateKeys,
        state
    };
}

},{"app/lib/runtimeIs":"fboJV","@metamask/browser-passworder":"jiH8X","../app/state/network":"8NDHR","../app/state/wallet/types":"b0U5N","../app/lib/helpers":"bUnFy","../app/lib/key":"a61Hw","../types/errors":"gbx4q","45f2f98174899c4b":"aKZJC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jiH8X":[function(require,module,exports,__globalThis) {
var Buffer = require("271fbde312fd5df3").Buffer;
var global = arguments[3];
"use strict";
/**
 * Encrypts a data object that can be any serializable value using
 * a provided password.
 *
 * @param {string} password - password to use for encryption
 * @param {R} dataObj - data to encrypt
 * @returns {Promise<string>} cypher text
 */ function encrypt(password, dataObj) {
    const salt = generateSalt();
    return keyFromPassword(password, salt).then(function(passwordDerivedKey) {
        return encryptWithKey(passwordDerivedKey, dataObj);
    }).then(function(payload) {
        payload.salt = salt;
        return JSON.stringify(payload);
    });
}
/**
 * Encrypts the provided serializable javascript object using the
 * provided CryptoKey and returns an object containing the cypher text and
 * the initialization vector used.
 * @param {CryptoKey} key - CryptoKey to encrypt with
 * @param {R} dataObj - Serializable javascript object to encrypt
 * @returns {EncryptionResult}
 */ function encryptWithKey(key, dataObj) {
    const data = JSON.stringify(dataObj);
    const dataBuffer = Buffer.from(data, 'utf-8');
    const vector = global.crypto.getRandomValues(new Uint8Array(16));
    return global.crypto.subtle.encrypt({
        name: 'AES-GCM',
        iv: vector
    }, key, dataBuffer).then(function(buf) {
        const buffer = new Uint8Array(buf);
        const vectorStr = Buffer.from(vector).toString('base64');
        const vaultStr = Buffer.from(buffer).toString('base64');
        return {
            data: vaultStr,
            iv: vectorStr
        };
    });
}
/**
 * Given a password and a cypher text, decrypts the text and returns
 * the resulting value
 * @param {string} password - password to decrypt with
 * @param {string} text - cypher text to decrypt
 */ function decrypt(password, text) {
    const payload = JSON.parse(text);
    const { salt } = payload;
    return keyFromPassword(password, salt).then(function(key) {
        return decryptWithKey(key, payload);
    });
}
/**
 * Given a CryptoKey and an EncryptionResult object containing the initialization
 * vector (iv) and data to decrypt, return the resulting decrypted value.
 * @param {CryptoKey} key - CryptoKey to decrypt with
 * @param {EncryptionResult} payload - payload returned from an encryption method
 */ function decryptWithKey(key, payload) {
    const encryptedData = Buffer.from(payload.data, 'base64');
    const vector = Buffer.from(payload.iv, 'base64');
    return crypto.subtle.decrypt({
        name: 'AES-GCM',
        iv: vector
    }, key, encryptedData).then(function(result) {
        const decryptedData = new Uint8Array(result);
        const decryptedStr = Buffer.from(decryptedData).toString('utf-8');
        const decryptedObj = JSON.parse(decryptedStr);
        return decryptedObj;
    }).catch(function(_error) {
        throw new Error('Incorrect password');
    });
}
/**
 * Generate a CryptoKey from a password and random salt
 * @param {string} password - The password to use to generate key
 * @param {string} salt - The salt string to use in key derivation
 */ function keyFromPassword(password, salt) {
    const passBuffer = Buffer.from(password, 'utf-8');
    const saltBuffer = Buffer.from(salt, 'base64');
    return global.crypto.subtle.importKey('raw', passBuffer, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits',
        'deriveKey'
    ]).then(function(key) {
        return global.crypto.subtle.deriveKey({
            name: 'PBKDF2',
            salt: saltBuffer,
            iterations: 10000,
            hash: 'SHA-256'
        }, key, {
            name: 'AES-GCM',
            length: 256
        }, false, [
            'encrypt',
            'decrypt'
        ]);
    });
}
/**
 * Converts a hex string into a buffer.
 * @param {string} str - hex encoded string
 * @returns {Uint8Array}
 */ function serializeBufferFromStorage(str) {
    const stripStr = str.slice(0, 2) === '0x' ? str.slice(2) : str;
    const buf = new Uint8Array(stripStr.length / 2);
    for(let i = 0; i < stripStr.length; i += 2){
        const seg = stripStr.substr(i, 2);
        buf[i / 2] = parseInt(seg, 16);
    }
    return buf;
}
/**
 * Converts a buffer into a hex string ready for storage
 * @param {Uint8Array} buffer - Buffer to serialize
 * @returns {string} hex encoded string
 */ function serializeBufferForStorage(buffer) {
    let result = '0x';
    const len = buffer.length || buffer.byteLength;
    for(let i = 0; i < len; i++)result += unprefixedHex(buffer[i]);
    return result;
}
/**
 * Converts a number into hex value, and ensures proper leading 0
 * for single characters strings.
 * @param {number} num - number to convert to string
 * @returns {string} hex string
 */ function unprefixedHex(num) {
    let hex = num.toString(16);
    while(hex.length < 2)hex = `0${hex}`;
    return hex;
}
/**
 * Generates a random string for use as a salt in CryptoKey generation
 * @param {number} byteCount - Number of bytes to generate
 * @returns {string} randomly generated string
 */ function generateSalt(byteCount = 32) {
    const view = new Uint8Array(byteCount);
    global.crypto.getRandomValues(view);
    // Uint8Array is a fixed length array and thus does not have methods like pop, etc
    // so TypeScript complains about casting it to an array. Array.from() works here for
    // getting the proper type, but it results in a functional difference. In order to
    // cast, you have to first cast view to unknown then cast the unknown value to number[]
    // TypeScript ftw: double opt in to write potentially type-mismatched code.
    const b64encoded = btoa(String.fromCharCode.apply(null, view));
    return b64encoded;
}
module.exports = {
    // Simple encryption methods:
    encrypt,
    decrypt,
    // More advanced encryption methods:
    keyFromPassword,
    encryptWithKey,
    decryptWithKey,
    // Buffer <-> Hex string methods
    serializeBufferForStorage,
    serializeBufferFromStorage,
    generateSalt
};

},{"271fbde312fd5df3":"eXvXD"}],"a61Hw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OasisKey", ()=>OasisKey);
var _tweetnacl = require("tweetnacl");
var _tweetnaclDefault = parcelHelpers.interopDefault(_tweetnacl);
var _helpers = require("./helpers");
/**
 * Verify if a key pair is actually usable for signatures
 */ function canSignWith(keyPair) {
    const { secretKey, publicKey } = keyPair;
    const testMessage = Uint8Array.from([
        1,
        2,
        3
    ]);
    const signedTestMessage = (0, _tweetnaclDefault.default).sign(testMessage, secretKey);
    const testDecoded = (0, _tweetnaclDefault.default).sign.open(signedTestMessage, publicKey);
    return testDecoded && (0, _helpers.uint2hex)(testDecoded) === (0, _helpers.uint2hex)(testMessage);
}
class OasisKey {
    static fromBase64PrivateKey(key) {
        const keyWithoutEnvelope = key.replace(/\n/gm, '').replace(/ /g, '').replace(/^-----.*?-----/, '').replace(/-----.*?-----$/, '');
        const key_bytes = (0, _helpers.base64ToUint)(keyWithoutEnvelope);
        return OasisKey.fromPrivateKey(key_bytes);
    }
    /**
   * @param key 32-bytes seed or 64-bytes secret (seed + public)
   * @returns 64-bytes secret
   */ static fromPrivateKey(key) {
        if (key.length === 32) return (0, _tweetnaclDefault.default).sign.keyPair.fromSeed(key).secretKey;
        else if (key.length === 64) {
            const keyPair = (0, _tweetnaclDefault.default).sign.keyPair.fromSecretKey(key);
            if (!canSignWith(keyPair)) throw new Error('Invalid private key. There must a typo somewhere.');
            return keyPair.secretKey;
        } else throw new Error('Invalid private key shape');
    }
}

},{"tweetnacl":"5ZWFX","./helpers":"bUnFy","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aKZJC":[function(require,module,exports,__globalThis) {
module.exports = require("a8d168fb26725f97")(module.bundle.resolve("hx2cG")).then(()=>module.bundle.root('4eUkX'));

},{"a8d168fb26725f97":"bxWlo"}],"eR10q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * When opening a second tab it initially syncs these state slices.
 */ parcelHelpers.export(exports, "receiveInitialTabSyncState", ()=>receiveInitialTabSyncState);
parcelHelpers.export(exports, "whitelistTabSyncActions", ()=>whitelistTabSyncActions);
/** Wrap configureStore with redux-state-sync if native BroadcastChannel is supported. */ parcelHelpers.export(exports, "configureStoreWithSyncTabs", ()=>configureStoreWithSyncTabs);
var _toolkit = require("@reduxjs/toolkit");
var _persist = require("app/state/persist");
var _reduxStateSync = require("redux-state-sync");
var _slices = require("../../../store/slices");
function receiveInitialTabSyncState(prevState, initialSyncState) {
    return {
        // Explicitly list every field instead of `...prevState` to force developers
        // to consider if their new slice should be synced.
        account: prevState.account,
        createWallet: prevState.createWallet,
        fatalError: prevState.fatalError,
        importAccounts: prevState.importAccounts,
        paraTimes: prevState.paraTimes,
        staking: prevState.staking,
        transaction: prevState.transaction,
        settings: initialSyncState.settings,
        theme: initialSyncState.theme,
        wallet: initialSyncState.wallet,
        evmAccounts: initialSyncState.evmAccounts,
        contacts: initialSyncState.contacts,
        network: initialSyncState.network,
        persist: initialSyncState.persist
    };
}
const whitelistTabSyncActions = {
    [(0, _slices.rootSlices).contacts.actions.add.type]: true,
    [(0, _slices.rootSlices).contacts.actions.update.type]: true,
    [(0, _slices.rootSlices).contacts.actions.delete.type]: true,
    [(0, _slices.rootSlices).evmAccounts.actions.add.type]: true,
    [(0, _slices.rootSlices).evmAccounts.actions.delete.type]: true,
    [(0, _slices.rootSlices).settings.actions.changeScreenPrivacy.type]: true,
    [(0, _slices.rootSlices).theme.actions.changeTheme.type]: true,
    [(0, _slices.rootSlices).wallet.actions.walletOpened.type]: true,
    [(0, _slices.rootSlices).wallet.actions.updateBalance.type]: true,
    [(0, _slices.rootSlices).network.actions.networkSelected.type]: true,
    [(0, _slices.rootSlices).network.actions.setChainContext.type]: true,
    [(0, _slices.rootSlices).network.actions.getEpoch.type]: true,
    [(0, _slices.rootSlices).network.actions.setEpoch.type]: true,
    [(0, _slices.rootSlices).persist.actions.setUnlockedRootState.type]: true,
    [(0, _slices.rootSlices).persist.actions.resetRootState.type]: true,
    [(0, _slices.rootSlices).persist.actions.skipUnlocking.type]: true,
    // Require listing every action to force developers to consider if their new
    // actions should be persisted.
    [(0, _slices.rootSlices).network.actions.initialNetworkSelected.type]: false,
    [(0, _slices.rootSlices).network.actions.initializeNetwork.type]: false,
    [(0, _slices.rootSlices).network.actions.selectNetwork.type]: false,
    [(0, _slices.rootSlices).account.actions.accountError.type]: false,
    [(0, _slices.rootSlices).account.actions.accountLoaded.type]: false,
    [(0, _slices.rootSlices).account.actions.clearAccount.type]: false,
    [(0, _slices.rootSlices).account.actions.closeAccountPage.type]: false,
    [(0, _slices.rootSlices).account.actions.fetchAccount.type]: false,
    [(0, _slices.rootSlices).account.actions.openAccountPage.type]: false,
    [(0, _slices.rootSlices).account.actions.setLoading.type]: false,
    [(0, _slices.rootSlices).account.actions.transactionsError.type]: false,
    [(0, _slices.rootSlices).account.actions.transactionsLoaded.type]: false,
    [(0, _slices.rootSlices).account.actions.addPendingTransaction.type]: false,
    [(0, _slices.rootSlices).createWallet.actions.clear.type]: false,
    [(0, _slices.rootSlices).createWallet.actions.generateMnemonic.type]: false,
    [(0, _slices.rootSlices).createWallet.actions.setChecked.type]: false,
    [(0, _slices.rootSlices).fatalError.actions.setError.type]: false,
    [(0, _slices.rootSlices).importAccounts.actions.accountGenerated.type]: false,
    [(0, _slices.rootSlices).importAccounts.actions.accountsListed.type]: false,
    [(0, _slices.rootSlices).importAccounts.actions.clear.type]: false,
    [(0, _slices.rootSlices).importAccounts.actions.enumerateAccountsFromLedger.type]: false,
    [(0, _slices.rootSlices).importAccounts.actions.enumerateAccountsFromMnemonic.type]: false,
    [(0, _slices.rootSlices).importAccounts.actions.enumerateDevicesFromBleLedger.type]: false,
    [(0, _slices.rootSlices).importAccounts.actions.enumerateMoreAccountsFromLedger.type]: false,
    [(0, _slices.rootSlices).importAccounts.actions.operationFailed.type]: false,
    [(0, _slices.rootSlices).importAccounts.actions.setBleDevices.type]: false,
    [(0, _slices.rootSlices).importAccounts.actions.setPage.type]: false,
    [(0, _slices.rootSlices).importAccounts.actions.setSelectedBleDevice.type]: false,
    [(0, _slices.rootSlices).importAccounts.actions.setStep.type]: false,
    [(0, _slices.rootSlices).importAccounts.actions.toggleAccount.type]: false,
    [(0, _slices.rootSlices).importAccounts.actions.updateAccountBalance.type]: false,
    [(0, _slices.rootSlices).paraTimes.actions.balanceLoaded.type]: false,
    [(0, _slices.rootSlices).paraTimes.actions.clearTransactionForm.type]: false,
    [(0, _slices.rootSlices).paraTimes.actions.fetchBalanceUsingEthPrivateKey.type]: false,
    [(0, _slices.rootSlices).paraTimes.actions.fetchBalanceUsingOasisAddress.type]: false,
    [(0, _slices.rootSlices).paraTimes.actions.navigateToAmount.type]: false,
    [(0, _slices.rootSlices).paraTimes.actions.navigateToConfirmation.type]: false,
    [(0, _slices.rootSlices).paraTimes.actions.navigateToDeposit.type]: false,
    [(0, _slices.rootSlices).paraTimes.actions.navigateToParaTimes.type]: false,
    [(0, _slices.rootSlices).paraTimes.actions.navigateToRecipient.type]: false,
    [(0, _slices.rootSlices).paraTimes.actions.navigateToSummary.type]: false,
    [(0, _slices.rootSlices).paraTimes.actions.navigateToWithdraw.type]: false,
    [(0, _slices.rootSlices).paraTimes.actions.setTransactionForm.type]: false,
    [(0, _slices.rootSlices).paraTimes.actions.submitTransaction.type]: false,
    [(0, _slices.rootSlices).paraTimes.actions.transactionError.type]: false,
    [(0, _slices.rootSlices).paraTimes.actions.transactionSubmitted.type]: false,
    [(0, _slices.rootSlices).staking.actions.fetchAccount.type]: false,
    [(0, _slices.rootSlices).staking.actions.setLoading.type]: false,
    [(0, _slices.rootSlices).staking.actions.updateDelegations.type]: false,
    [(0, _slices.rootSlices).staking.actions.updateDelegationsError.type]: false,
    [(0, _slices.rootSlices).staking.actions.updateValidatorDetails.type]: false,
    [(0, _slices.rootSlices).staking.actions.updateValidators.type]: false,
    [(0, _slices.rootSlices).staking.actions.updateValidatorsError.type]: false,
    [(0, _slices.rootSlices).staking.actions.validatorDeselected.type]: false,
    [(0, _slices.rootSlices).staking.actions.validatorSelected.type]: false,
    [(0, _slices.rootSlices).transaction.actions.abortTransaction.type]: false,
    [(0, _slices.rootSlices).transaction.actions.addEscrow.type]: false,
    [(0, _slices.rootSlices).transaction.actions.clearTransaction.type]: false,
    [(0, _slices.rootSlices).transaction.actions.confirmTransaction.type]: false,
    [(0, _slices.rootSlices).transaction.actions.paraTimeTransactionSent.type]: false,
    [(0, _slices.rootSlices).transaction.actions.reclaimEscrow.type]: false,
    [(0, _slices.rootSlices).transaction.actions.sendTransaction.type]: false,
    [(0, _slices.rootSlices).transaction.actions.setStep.type]: false,
    [(0, _slices.rootSlices).transaction.actions.transactionFailed.type]: false,
    [(0, _slices.rootSlices).transaction.actions.transactionSent.type]: false,
    [(0, _slices.rootSlices).transaction.actions.updateTransactionPreview.type]: false,
    [(0, _slices.rootSlices).wallet.actions.deleteWallet.type]: false,
    [(0, _slices.rootSlices).wallet.actions.fetchWallet.type]: false,
    [(0, _slices.rootSlices).wallet.actions.openWalletFromMnemonic.type]: false,
    [(0, _slices.rootSlices).wallet.actions.openWalletFromPrivateKey.type]: false,
    [(0, _slices.rootSlices).wallet.actions.openWalletsFromLedger.type]: false,
    [(0, _slices.rootSlices).wallet.actions.selectFirstWallet.type]: false,
    [(0, _slices.rootSlices).wallet.actions.selectWallet.type]: false,
    [(0, _slices.rootSlices).wallet.actions.setWalletName.type]: false,
    [(0, _slices.rootSlices).wallet.actions.verifyAddressOnLedger.type]: false,
    [(0, _slices.rootSlices).persist.actions.deleteProfileAsync.type]: false,
    [(0, _slices.rootSlices).persist.actions.finishV0Migration.type]: false,
    [(0, _slices.rootSlices).persist.actions.lockAsync.type]: false,
    [(0, _slices.rootSlices).persist.actions.resetWrongPassword.type]: false,
    [(0, _slices.rootSlices).persist.actions.setHasV0StorageToMigrate.type]: false,
    [(0, _slices.rootSlices).persist.actions.setPasswordAsync.type]: false,
    [(0, _slices.rootSlices).persist.actions.setWrongPassword.type]: false,
    [(0, _slices.rootSlices).persist.actions.unlockAsync.type]: false,
    [(0, _slices.rootSlices).persist.actions.updatePasswordAsync.type]: false
};
const stateSyncConfig = {
    channel: 'oasis_wallet_broadcast_channel',
    broadcastChannelOption: {
        type: 'native'
    },
    whitelist: Object.entries(whitelistTabSyncActions).filter(([_key, value])=>value).map(([key, _value])=>key),
    prepareState: (state)=>{
        return {
            contacts: state.contacts,
            evmAccounts: state.evmAccounts,
            settings: state.settings,
            theme: state.theme,
            wallet: state.wallet,
            network: state.network,
            persist: state.persist
        };
    }
};
function configureStoreWithSyncTabs(options) {
    if (typeof options.middleware !== 'function') throw new Error('Unsupported type of options.middleware');
    if (typeof options.reducer !== 'function') throw new Error('Unsupported type of options.reducer');
    if (!(0, _persist.needsSyncingTabs)) return (0, _toolkit.configureStore)(options);
    if (!(0, _persist.isSyncingTabsSupported)) {
        console.warn('Syncing between tabs is not supported');
        return (0, _toolkit.configureStore)(options);
    }
    const optionsMiddleware = options.middleware;
    const store = (0, _toolkit.configureStore)({
        ...options,
        reducer: (0, _reduxStateSync.withReduxStateSync)(options.reducer, receiveInitialTabSyncState),
        middleware: (getDefaultMiddleware)=>optionsMiddleware(getDefaultMiddleware).concat((0, _reduxStateSync.createStateSyncMiddleware)(stateSyncConfig))
    });
    (0, _reduxStateSync.initStateWithPrevTab)(store);
    return store;
}

},{"@reduxjs/toolkit":"9ol63","app/state/persist":"9hwZK","redux-state-sync":"g1h73","../../../store/slices":"8A4Y5","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dIepd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeProvider", ()=>ThemeProvider);
parcelHelpers.export(exports, "ThemeProviderWithoutRedux", ()=>ThemeProviderWithoutRedux);
var _jsxRuntime = require("react/jsx-runtime");
var _grommet = require("grommet/es6/components/Grommet");
var _themes = require("grommet/es6/themes");
var _utils = require("grommet/es6/utils");
var _react = require("react");
var _reactDataTableComponent = require("react-data-table-component");
var _reactRedux = require("react-redux");
var _selectors = require("./slice/selectors");
var _dataTableTheme = require("./dataTableTheme");
var _styledComponents = require("styled-components");
var _utils1 = require("./utils");
var _slice = require("./slice");
/**
 * React-data-table by default sets its own background and text colors
 * we make sure that they do not override grommet's
 */ (0, _reactDataTableComponent.createTheme)('blank', (0, _dataTableTheme.dataTableTheme));
const grommetCustomTheme = {
    anchor: {
        color: 'link'
    },
    button: {
        primary: {
            background: {
                dark: 'red',
                light: 'green'
            }
        },
        border: {
            radius: '4px'
        },
        badge: {
            size: {
                medium: '20px'
            },
            container: {
                extend: `
          margin-top: -10px;
          margin-right: -10px;
        `
            }
        }
    },
    textInput: {
        extend: (0, _styledComponents.css)`
      &::placeholder {
        font-size: 14px;
      }
    `
    },
    textArea: {
        extend: (0, _styledComponents.css)`
      &::placeholder {
        font-size: 14px;
      }
    `
    },
    tip: {
        content: {
            // Default background is background-contrast, but we made that one transparent
            background: 'background-front',
            border: 'all',
            elevation: 'none'
        }
    },
    select: {
        container: {
            // Remove padding from selects with custom elements inside options.
            // Needed to match ParaTimeOption when displayed as value and as option
            extend: (0, _styledComponents.css)`
        button > div:has(span *) {
          padding: 0;
        }
      `
        }
    },
    global: {
        colors: {
            oasisIndigo: '#310081',
            oasisMinty: '#4CD4A9',
            oasisLightGray: '#ececec',
            brand: {
                dark: '#6EFFFA',
                light: '#0500e2'
            },
            oasisBlue2: '#4db3f9',
            oasisBlue3: '#26a2f8',
            grayMedium: {
                dark: '#d5d6d7',
                light: '#565b61'
            },
            link: 'brand',
            ticker: 'brand',
            focus: {
                dark: '#00A9FF',
                light: '#00A9FF'
            },
            active: 'rgba(183, 183, 183, 0.5)',
            'accent-1': 'focus',
            'brand-background-light': '#e3e8ed',
            'brand-white': '#f8f8f8',
            white: '#ffffff',
            'brand-blue': '#0500e2',
            'brand-light-blue': '#e8f5ff',
            'brand-gray-medium': '#d5d6d7',
            'brand-gray-extra-dark': '#06152b',
            'status-ok': '#2ad5ab',
            'status-warning': {
                dark: '#f3d45e',
                light: '#e1a809'
            },
            'status-error': '#d24c00',
            'alert-box-info': {
                dark: '#0500e2',
                light: '#0500e2'
            },
            'alert-box-info-background': {
                dark: '#d4ebff',
                light: '#d4ebff'
            },
            'alert-box-ok-weak': {
                dark: '#2ad5ab',
                light: '#2ad5ab'
            },
            'alert-box-ok-weak-background': {
                dark: '#17464b',
                light: '#c2f5ea'
            },
            'alert-box-ok': {
                dark: '#2ad5ab',
                light: '#c2f5ea'
            },
            'alert-box-ok-background': {
                dark: '#c2f5ea',
                light: '#2ad5ab'
            },
            'alert-box-warning': {
                dark: '#f3d45e',
                light: '#f0e8cb'
            },
            'alert-box-warning-background': {
                dark: '#f0e8cb',
                light: '#f3d45e'
            },
            'alert-box-warning-weak-background': {
                dark: '#f0e8cb',
                light: '#fcf1d0'
            },
            'alert-box-error': {
                dark: '#f26111',
                light: '#ffe7d9'
            },
            'alert-box-error-background': {
                dark: '#ffe7d9',
                light: '#f26111'
            },
            lightText: '#a3a3a3',
            neutral: {
                dark: '#310081FF',
                light: '#310081FF'
            },
            'neutral-2': {
                dark: '#0500e2bb',
                light: '#0500e2bb'
            },
            'background-back': {
                dark: '#1A1A2e',
                light: '#EFEFEF'
            },
            'background-front': {
                dark: '#16213e',
                light: '#FFFFFF'
            },
            'background-front-lighter': {
                dark: '#222938',
                light: '#FFFFFF'
            },
            'background-front-border': {
                dark: '#111111',
                light: '#EDEDED'
            },
            'background-contrast': {
                dark: '#FFFFFF08',
                light: '#11111108'
            },
            'background-contrast-2': {
                dark: '#FFFFFF33',
                light: '#11111133'
            },
            'background-custom': {
                dark: '#0E5265',
                light: '#00C8FF'
            },
            'background-custom-2': {
                dark: '#6EFFFA',
                light: '#E8F5FF'
            },
            'component-toolbar': {
                dark: '#0f346088',
                light: '#26a2f844'
            },
            'component-sidebar': {
                dark: '#16213e',
                light: '#fafafa'
            },
            'successful-label': {
                dark: '#00fd79',
                light: '#3fa900'
            },
            'text-custom': {
                dark: '#16213E',
                light: '#31435A'
            },
            text: {
                dark: '#F8F8F8',
                light: '#16213E'
            },
            icon: 'currentColor'
        },
        font: {
            family: 'Rubik, sans-serif',
            size: '16px',
            height: '20px'
        },
        input: {
            padding: {
                horizontal: '5px',
                vertical: '12px'
            }
        },
        selected: {
            background: 'control'
        }
    },
    text: {
        medium: {
            size: '16px',
            height: '20px'
        }
    },
    paragraph: {
        medium: {
            size: '16px',
            height: '20px'
        }
    },
    heading: {
        level: {
            1: (0, _themes.base).heading?.level?.['2'],
            2: (0, _themes.base).heading?.level?.['3'],
            3: (0, _themes.base).heading?.level?.['4'],
            4: (0, _themes.base).heading?.level?.['5'],
            5: (0, _themes.base).heading?.level?.['6']
        }
    },
    notification: {
        toast: {
            time: 2000,
            container: {
                border: 'all',
                elevation: 'none'
            }
        }
    },
    tab: {
        color: 'text',
        active: {
            color: 'brand'
        },
        border: {
            side: 'bottom',
            color: 'transparent',
            active: {
                color: 'brand'
            }
        },
        margin: {
            horizontal: 'xsmall'
        }
    },
    tabs: {
        header: {
            alignSelf: 'start'
        },
        panel: {
            extend: (props)=>(0, _styledComponents.css)`
        padding-top: ${props.theme.global?.edgeSize?.medium};
        display: flex;
        flex-direction: column;
        flex-grow: 1;
      `
        },
        extend: (0, _styledComponents.css)`
      display: flex;
      flex-direction: column;
      flex-grow: 1;

      // Arrows displayed when overflowing should be smaller on small screens
      & > [role='tablist'] > button {
        padding-left: 0;
        padding-right: 0;

        svg {
          width: 14px;
          margin-top: -5px;
        }
      }
    `
    },
    icon: {
        size: {
            medium: '20px'
        }
    },
    radioButton: {
        icon: {
            size: '20px'
        }
    },
    checkBox: {
        size: '20px',
        icon: {
            size: '20px'
        },
        toggle: {
            size: '40px',
            color: {
                dark: 'text',
                light: 'grayMedium'
            }
        },
        border: {
            color: 'text'
        },
        hover: {
            border: {
                color: 'focus'
            }
        },
        gap: '1.5ex',
        extend: (0, _styledComponents.css)`
      font-size: 14px;
      line-height: 1.25;
    `
    },
    layer: {
        /**
     * Replace 100vh with 100dvh in https://github.com/grommet/grommet/blob/9e1ef40/src/js/components/Layer/StyledLayer.js
     * to fix scrolling to bottom despite URL bar on phones. Note: doesn't reliably reproduce on dev server.
     */ extend: (props)=>{
            if (props.responsive && props.theme.layer.responsiveBreakpoint) {
                const breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];
                return (0, _styledComponents.css)`
          @media only screen and (max-width: ${breakpoint.value}px) {
            min-height: 100dvh;
          }
        `;
            }
            return (0, _styledComponents.css)``;
        },
        container: {
            extend: (props)=>{
                if (props.responsive && props.theme.layer.responsiveBreakpoint) {
                    const breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];
                    return (0, _styledComponents.css)`
            @media only screen and (max-width: ${breakpoint.value}px) {
              height: 100dvh;
            }
          `;
                }
                return (0, _styledComponents.css)``;
            }
        }
    },
    grommet: {
        /**
     * Replace 100vh with 100dvh in https://github.com/grommet/grommet/blob/9e1ef40/src/js/components/Grommet/StyledGrommet.js
     * to fix scrolling to bottom despite URL bar on phones. Note: doesn't reliably reproduce on dev server.
     */ extend: (props)=>{
            if (props.full) return (0, _styledComponents.css)`
          height: 100dvh;
        `;
            return (0, _styledComponents.css)``;
        }
    }
};
const GlobalStyle = (0, _styledComponents.createGlobalStyle)`
  :root {
    color-scheme: ${({ theme })=>theme.dark ? 'dark' : 'light'};
  }
`;
const ThemeProvider = (props)=>{
    const theme = (0, _utils.deepMerge)((0, _themes.grommet), grommetCustomTheme);
    const mode = (0, _reactRedux.useSelector)((0, _selectors.selectTheme));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _grommet.Grommet), {
        theme: theme,
        themeMode: (0, _utils1.getTargetTheme)(mode),
        style: {
            minHeight: '100dvh'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(GlobalStyle, {}),
            _react.Children.only(props.children)
        ]
    });
};
const ThemeProviderWithoutRedux = (props)=>{
    const theme = (0, _utils.deepMerge)((0, _themes.grommet), grommetCustomTheme);
    const mode = (0, _slice.getInitialState)().selected;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grommet.Grommet), {
        theme: theme,
        themeMode: (0, _utils1.getTargetTheme)(mode),
        style: {
            minHeight: '100dvh'
        },
        children: _react.Children.only(props.children)
    });
};

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Grommet":"aCIGs","grommet/es6/themes":"fQIua","grommet/es6/utils":"fx31z","react":"8CCva","react-data-table-component":"kgfAv","react-redux":"azV3Y","./slice/selectors":"9i0Ji","./dataTableTheme":"kVz1A","styled-components":"6bGrk","./utils":"lNPdT","./slice":"56nVt","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aCIGs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Grommet", ()=>(0, _grommet.Grommet));
var _grommet = require("./Grommet");

},{"./Grommet":"5MIiL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5MIiL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Grommet", ()=>Grommet);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _contexts = require("../../contexts");
var _utils = require("../../utils");
var _themes = require("../../themes");
var _styledGrommet = require("./StyledGrommet");
var _rootsContext = require("../../contexts/RootsContext");
var _optionsContext = require("../../contexts/OptionsContext");
var _messageContext = require("../../contexts/MessageContext");
var _defaultJson = require("../../languages/default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
var _propTypes = require("./propTypes");
var _analyticsContext = require("../../contexts/AnalyticsContext");
var _excluded = [
    "children",
    "full",
    "containerTarget",
    "theme",
    "options",
    "messages",
    "onAnalytics"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var FullGlobalStyle = (0, _styledComponents.createGlobalStyle)([
    "body{margin:0;}"
]);
var defaultOptions = {};
var Grommet = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var children = props.children, full = props.full, _props$containerTarge = props.containerTarget, containerTarget = _props$containerTarge === void 0 ? typeof document === 'object' ? document.body : undefined : _props$containerTarge, themeProp = props.theme, _props$options = props.options, options = _props$options === void 0 ? defaultOptions : _props$options, messagesProp = props.messages, onAnalytics = props.onAnalytics, rest = _objectWithoutPropertiesLoose(props, _excluded);
    var background = props.background, dir = props.dir, themeMode = props.themeMode, userAgent = props.userAgent;
    var _useState = (0, _react.useState)(), stateResponsive = _useState[0], setResponsive = _useState[1];
    var theme = (0, _react.useMemo)(function() {
        var nextTheme = (0, _utils.deepMerge)((0, _themes.base), themeProp || {});
        // if user provides specific menu alignment, we don't want
        // the defaults to be included at all (can cause issues with controlMirror)
        // override merged value with themeProp value
        if (themeProp && themeProp.menu && themeProp.menu.drop && themeProp.menu.drop.align) {
            delete nextTheme.menu.drop.align;
            nextTheme.menu.drop.align = themeProp.menu.drop.align;
        }
        var themeBackground = nextTheme.global.colors.background;
        nextTheme.dark = (themeMode || nextTheme.defaultMode) === 'dark';
        if (themeMode === 'auto' && typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) nextTheme.dark = true;
        var color = (0, _utils.normalizeColor)(background || themeBackground, nextTheme);
        nextTheme.dark = (0, _utils.backgroundIsDark)(color, nextTheme);
        nextTheme.baseBackground = background || themeBackground;
        // This allows DataTable to intelligently set the background of a pinned
        // header or footer.
        nextTheme.background = nextTheme.baseBackground;
        if (dir) nextTheme.dir = dir;
        return nextTheme;
    }, [
        background,
        dir,
        themeMode,
        themeProp
    ]);
    var messages = (0, _react.useMemo)(function() {
        // combine the passed in messages, if any, with the default
        // messages and format function.
        var nextMessages = (0, _utils.deepMerge)((0, _defaultJsonDefault.default), (messagesProp == null ? void 0 : messagesProp.messages) || {});
        return {
            messages: nextMessages,
            format: function format(opts) {
                var message = (messagesProp == null ? void 0 : messagesProp.format) && messagesProp.format(opts);
                return typeof message !== 'undefined' ? message : (0, _messageContext.format)(opts, nextMessages);
            }
        };
    }, [
        messagesProp
    ]);
    (0, _react.useEffect)(function() {
        var onResize = function onResize() {
            setResponsive((0, _utils.getBreakpoint)(document.body.clientWidth, theme));
        };
        window.addEventListener('resize', onResize);
        onResize();
        return function() {
            window.removeEventListener('resize', onResize);
        };
    }, [
        theme
    ]);
    var responsive = stateResponsive || (0, _utils.deviceResponsive)(userAgent, theme) || theme.global.deviceBreakpoints.tablet;
    var grommetRef = (0, _utils.useForwardedRef)(ref);
    // track open FocusedContainers in a global array to manage
    // focus event listeners for trapFocus
    var roots = (0, _react.useRef)([]);
    (0, _react.useEffect)(function() {
        if (grommetRef.current) roots.current.push(grommetRef.current);
    }, [
        grommetRef
    ]);
    var rootsContextValue = (0, _react.useMemo)(function() {
        return {
            roots: roots
        };
    }, []);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contexts.ThemeContext).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contexts.ResponsiveContext).Provider, {
        value: responsive
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _rootsContext.RootsContext).Provider, {
        value: rootsContextValue
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contexts.ContainerTargetContext).Provider, {
        value: containerTarget
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _optionsContext.OptionsContext).Provider, {
        value: options
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _messageContext.MessageContext).Provider, {
        value: messages
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _analyticsContext.AnalyticsProvider), {
        onAnalytics: onAnalytics
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledGrommet.StyledGrommet), _extends({
        full: full
    }, rest, {
        ref: grommetRef
    }), children), full && /*#__PURE__*/ (0, _reactDefault.default).createElement(FullGlobalStyle, null))))))));
});
Grommet.displayName = 'Grommet';
Grommet.propTypes = (0, _propTypes.GrommetPropTypes);

},{"react":"8CCva","styled-components":"6bGrk","../../contexts":"8InEz","../../utils":"fx31z","../../themes":"fQIua","./StyledGrommet":"dROnj","../../contexts/RootsContext":"7S2c8","../../contexts/OptionsContext":"5kzBX","../../contexts/MessageContext":"9V5sq","../../languages/default.json":"iO6JM","./propTypes":"bgMzG","../../contexts/AnalyticsContext":"7ryyN","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6bGrk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServerStyleSheet", ()=>Ue);
parcelHelpers.export(exports, "StyleSheetConsumer", ()=>ue);
parcelHelpers.export(exports, "StyleSheetContext", ()=>ce);
parcelHelpers.export(exports, "StyleSheetManager", ()=>me);
parcelHelpers.export(exports, "ThemeConsumer", ()=>Ge);
parcelHelpers.export(exports, "ThemeContext", ()=>Me);
parcelHelpers.export(exports, "ThemeProvider", ()=>Le);
parcelHelpers.export(exports, "__PRIVATE__", ()=>Ze);
parcelHelpers.export(exports, "createGlobalStyle", ()=>$e);
parcelHelpers.export(exports, "css", ()=>Ae);
parcelHelpers.export(exports, "isStyledComponent", ()=>_);
parcelHelpers.export(exports, "keyframes", ()=>We);
parcelHelpers.export(exports, "useTheme", ()=>Xe);
parcelHelpers.export(exports, "version", ()=>A);
parcelHelpers.export(exports, "withTheme", ()=>Je);
var _reactIs = require("react-is");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _shallowequal = require("shallowequal");
var _shallowequalDefault = parcelHelpers.interopDefault(_shallowequal);
var _stylis = require("@emotion/stylis");
var _stylisDefault = parcelHelpers.interopDefault(_stylis);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
function y() {
    return (y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, _reactIs.typeOf)(t);
}, S = Object.freeze([]), w = Object.freeze({});
function E(e) {
    return "function" == typeof e;
}
function b(e) {
    return (0, e.displayName) || e.name || "Component";
}
function _(e) {
    return e && "string" == typeof e.styledComponentId;
}
var N = "data-styled", A = "5.3.11", C = "undefined" != typeof window && "HTMLElement" in window, I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), P = {}, O = {};
function R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), T = new Map, x = new Map, k = 1, V = function(e) {
    if (T.has(e)) return T.get(e);
    for(; x.has(k);)k++;
    var t = k++;
    return T.set(e, t), x.set(t, e), t;
}, B = function(e) {
    return x.get(e);
}, z = function(e, t) {
    t >= k && (k = t + 1), T.set(e, t), x.set(t, e);
}, M = "style[" + N + '][data-styled-version="5.3.11"]', G = new RegExp("^" + N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match(G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && (z(u, c), L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute(N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute(N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, H = function() {
    function e(e) {
        var t = this.element = q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $ = function() {
    function e(e) {
        var t = this.element = q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), U = C, J = {
    isServer: !C,
    useCSSOMInjection: !I
}, X = function() {
    function e(e, t, n) {
        void 0 === e && (e = w), void 0 === t && (t = {}), this.options = y({}, J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && C && U && (U = !1, function(e) {
            for(var t = document.querySelectorAll(M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute(N) && (F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e(y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new W(o) : r ? new H(o) : new $(o), new j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if (V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules(V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup(V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), Z = /(a)(d)/gi, K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = K(t % 52) + n;
    return (K(t % 52) + n).replace(Z, "$1-$2");
}
var ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, te = function(e) {
    return ee(5381, e);
};
function ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if (E(n) && !_(n)) return !1;
    }
    return !0;
}
var re = te("5.3.11"), oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && ne(e), this.componentId = t, this.baseHash = ee(re, t), this.baseStyle = n, X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = _e(this.rules, e, t, n).join(""), i = Q(ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = _e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), se = /^\s*\/\/.*$/gm, ie = [
    ":",
    "[",
    ".",
    "#"
];
function ae(e) {
    var t, n, r, o, s = void 0 === e ? w : e, i = s.options, a = void 0 === i ? w : i, c = s.plugins, u = void 0 === c ? S : c, l = new (0, _stylisDefault.default)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace(se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || D(15), ee(e, t.name);
    }, 5381).toString() : "", m;
}
var ce = (0, _reactDefault.default).createContext(), ue = ce.Consumer, le = (0, _reactDefault.default).createContext(), de = (le.Consumer, new X), he = ae();
function pe() {
    return (0, _react.useContext)(ce) || de;
}
function fe() {
    return (0, _react.useContext)(le) || he;
}
function me(e) {
    var t = (0, _react.useState)(e.stylisPlugins), n = t[0], s = t[1], c = pe(), u = (0, _react.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, _react.useMemo)(function() {
        return ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, _react.useEffect)(function() {
        (0, _shallowequalDefault.default)(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, _reactDefault.default).createElement(ce.Provider, {
        value: u
    }, (0, _reactDefault.default).createElement(le.Provider, {
        value: l
    }, (0, e.children)));
}
var ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = he), this.name + e.hash;
    }, e;
}(), ve = /([A-Z])/, ge = /([A-Z])/g, Se = /^ms-/, we = function(e) {
    return "-" + e.toLowerCase();
};
function Ee(e) {
    return ve.test(e) ? e.replace(ge, we).replace(Se, "-ms-") : e;
}
var be = function(e) {
    return null == e || !1 === e || "" === e;
};
function _e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = _e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if (be(e)) return "";
    if (_(e)) return "." + e.styledComponentId;
    if (E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return _e(u, n, r, o);
    }
    var l;
    return e instanceof ye ? r ? (e.inject(r, o), e.getName(o)) : e : g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || E(t[i]) ? s.push(Ee(i) + ":", t[i], ";") : g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push(Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, _unitlessDefault.default) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function Ae(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return E(e) || g(e) ? Ne(_e(v(S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : Ne(_e(v(e, n)));
}
var Ce = /invalid hook call/i, Ie = new Set, Pe = function(e, t) {
    var n, r, o, e1;
}, Oe = function(e, t, n) {
    return void 0 === n && (n = w), e.theme !== n.theme && e.theme || t || n.theme;
}, Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, De = /(^-|-$)/g;
function je(e) {
    return e.replace(Re, "-").replace(De, "");
}
var Te = function(e) {
    return Q(te(e) >>> 0);
};
function xe(e) {
    return "string" == typeof e && true;
}
var ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function Be(e, t, n) {
    var r = e[n];
    ke(t) && ke(r) ? ze(r, t) : e[n] = t;
}
function ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if (ke(i)) for(var a in i)Ve(a) && Be(e, i[a], a);
    }
    return e;
}
var Me = (0, _reactDefault.default).createContext(), Ge = Me.Consumer;
function Le(e) {
    var t = (0, _react.useContext)(Me), n = (0, _react.useMemo)(function() {
        return function(e, t) {
            if (!e) return D(14);
            if (E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? D(8) : t ? y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, _reactDefault.default).createElement(Me.Provider, {
        value: n
    }, e.children) : null;
}
var Fe = {};
function Ye(e, t, n) {
    var o = _(e), i = !xe(e), a = t.attrs, c = void 0 === a ? S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : je(e);
        Fe[n] = (Fe[n] || 0) + 1;
        var r = n + "-" + Te("5.3.11" + n + Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return xe(e) ? "styled." + e : "Styled(" + b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = w);
                var r = y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }(Oe(t, (0, _react.useContext)(Me), a) || w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = pe(), s = fe(), i = t ? e.generateAndInjectStyles(w, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = xe(b), N = v !== t ? y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, _isPropValidDefault.default), b) : !_ || (0, _isPropValidDefault.default)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, _react.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, _reactDefault.default).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + (xe(e) ? e : je(b(e)));
        return Ye(e, y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, _hoistNonReactStaticsDefault.default)(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = w), !(0, _reactIs.isValidElementType)(r)) return D(1, String(r));
        var s = function() {
            return t(r, o, Ae.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }(Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    qe[e] = qe(e);
});
var He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = ne(e), X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r(_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = Ae.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + Te(JSON.stringify(i)), u = new He(i, a);
    function d(e) {
        var t = pe(), n = fe(), o = (0, _react.useContext)(Me), d = (0, _react.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(d, e, t, o, n), (0, _react.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, P, n, o);
        else {
            var s = y({}, t, {
                theme: Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, _reactDefault.default).memo(d);
}
function We(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = Ae.apply(void 0, [
        e
    ].concat(n)).join(""), s = Te(o);
    return new ye(s, o);
}
var Ue = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return D(2);
            var n = ((t = {})[N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = Y();
            return o && (n.nonce = o), [
                (0, _reactDefault.default).createElement("style", y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? D(2) : (0, _reactDefault.default).createElement(me, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return D(3);
    }, e;
}(), Je = function(e) {
    var t = (0, _reactDefault.default).forwardRef(function(t, n) {
        var o = (0, _react.useContext)(Me), i = e.defaultProps, a = Oe(t, o, i);
        return (0, _reactDefault.default).createElement(e, y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, _hoistNonReactStaticsDefault.default)(t, e), t.displayName = "WithTheme(" + b(e) + ")", t;
}, Xe = function() {
    return (0, _react.useContext)(Me);
}, Ze = {
    StyleSheet: X,
    masterSheet: de
};
exports.default = qe;

},{"react-is":"hjLEw","react":"8CCva","shallowequal":"f2IhI","@emotion/stylis":"2TKHv","@emotion/unitless":"hqK0a","@emotion/is-prop-valid":"8dUDx","hoist-non-react-statics":"1FRbW","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hjLEw":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("f93b3bf7385544f5");

},{"f93b3bf7385544f5":"1S4z9"}],"1S4z9":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = "function" === typeof Symbol && Symbol.for, c = b ? Symbol.for("react.element") : 60103, d = b ? Symbol.for("react.portal") : 60106, e = b ? Symbol.for("react.fragment") : 60107, f = b ? Symbol.for("react.strict_mode") : 60108, g = b ? Symbol.for("react.profiler") : 60114, h = b ? Symbol.for("react.provider") : 60109, k = b ? Symbol.for("react.context") : 60110, l = b ? Symbol.for("react.async_mode") : 60111, m = b ? Symbol.for("react.concurrent_mode") : 60111, n = b ? Symbol.for("react.forward_ref") : 60112, p = b ? Symbol.for("react.suspense") : 60113, q = b ? Symbol.for("react.suspense_list") : 60120, r = b ? Symbol.for("react.memo") : 60115, t = b ? Symbol.for("react.lazy") : 60116, v = b ? Symbol.for("react.block") : 60121, w = b ? Symbol.for("react.fundamental") : 60117, x = b ? Symbol.for("react.responder") : 60118, y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case c:
                switch(a = a.type, a){
                    case l:
                    case m:
                    case e:
                    case g:
                    case f:
                    case p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case n:
                            case t:
                            case r:
                            case h:
                                return a;
                            default:
                                return u;
                        }
                }
            case d:
                return u;
        }
    }
}
function A(a) {
    return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
    return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
    return z(a) === k;
};
exports.isContextProvider = function(a) {
    return z(a) === h;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
    return z(a) === n;
};
exports.isFragment = function(a) {
    return z(a) === e;
};
exports.isLazy = function(a) {
    return z(a) === t;
};
exports.isMemo = function(a) {
    return z(a) === r;
};
exports.isPortal = function(a) {
    return z(a) === d;
};
exports.isProfiler = function(a) {
    return z(a) === g;
};
exports.isStrictMode = function(a) {
    return z(a) === f;
};
exports.isSuspense = function(a) {
    return z(a) === p;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;

},{}],"2TKHv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
exports.default = stylis_min;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hqK0a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
exports.default = unitlessKeys;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8dUDx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var isPropValid = /* #__PURE__ */ (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
exports.default = isPropValid;

},{"@emotion/memoize":"1uxCS","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1uxCS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
exports.default = memoize;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1FRbW":[function(require,module,exports,__globalThis) {
'use strict';
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"hjLEw"}],"8InEz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _analyticsContext = require("./AnalyticsContext");
parcelHelpers.exportAll(_analyticsContext, exports);
var _announceContext = require("./AnnounceContext");
parcelHelpers.exportAll(_announceContext, exports);
var _containerTargetContext = require("./ContainerTargetContext");
parcelHelpers.exportAll(_containerTargetContext, exports);
var _dataContext = require("./DataContext");
parcelHelpers.exportAll(_dataContext, exports);
var _responsiveContext = require("./ResponsiveContext");
parcelHelpers.exportAll(_responsiveContext, exports);
var _responsiveContainerContext = require("./ResponsiveContainerContext");
parcelHelpers.exportAll(_responsiveContainerContext, exports);
var _rootsContext = require("./RootsContext");
parcelHelpers.exportAll(_rootsContext, exports);
var _themeContext = require("./ThemeContext");
parcelHelpers.exportAll(_themeContext, exports);

},{"./AnalyticsContext":"7ryyN","./AnnounceContext":"fESY4","./ContainerTargetContext":"i3UJm","./DataContext":false,"./ResponsiveContext":"7EsNN","./ResponsiveContainerContext":"g0Mji","./RootsContext":false,"./ThemeContext":"d77SS","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7ryyN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _analyticsContext = require("./AnalyticsContext");
parcelHelpers.exportAll(_analyticsContext, exports);

},{"./AnalyticsContext":"1QG5F","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1QG5F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnalyticsContext", ()=>AnalyticsContext);
parcelHelpers.export(exports, "useAnalytics", ()=>useAnalytics);
parcelHelpers.export(exports, "AnalyticsProvider", ()=>AnalyticsProvider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var AnalyticsContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(function() {});
var useAnalytics = function useAnalytics() {
    return (0, _react.useContext)(AnalyticsContext);
};
var AnalyticsProvider = function AnalyticsProvider(_ref) {
    var onAnalytics = _ref.onAnalytics, children = _ref.children;
    var lastUrlRef = (0, _react.useRef)();
    var sendAnalytics = (0, _react.useCallback)(function(data) {
        return onAnalytics && onAnalytics(data);
    }, [
        onAnalytics
    ]);
    (0, _react.useEffect)(function() {
        var observer;
        if (onAnalytics) {
            observer = new window.MutationObserver(function() {
                var _window;
                var url = (_window = window) == null || (_window = _window.location) == null ? void 0 : _window.href;
                var previousUrl = lastUrlRef.current;
                if (url !== previousUrl) {
                    lastUrlRef.current = url;
                    sendAnalytics({
                        type: 'pageView',
                        url: url,
                        previousUrl: previousUrl
                    });
                }
            });
            observer.observe(document, {
                subtree: true,
                childList: true
            });
        }
        return function() {
            var _observer;
            return (_observer = observer) == null ? void 0 : _observer.disconnect();
        };
    }, [
        sendAnalytics,
        onAnalytics
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(AnalyticsContext.Provider, {
        value: sendAnalytics
    }, children);
};

},{"react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fESY4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnnounceContext", ()=>(0, _announceContext.AnnounceContext));
var _announceContext = require("./AnnounceContext");

},{"./AnnounceContext":"6iWX9","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6iWX9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnnounceContext", ()=>AnnounceContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("./propTypes");
var createAnnouncer = function createAnnouncer() {
    var announcer = document.createElement('div');
    announcer.id = 'grommet-announcer';
    announcer.style.left = '-100%';
    announcer.style.right = '100%';
    announcer.style.position = 'fixed';
    announcer.style['z-index'] = '-1';
    document.body.insertBefore(announcer, document.body.firstChild);
    return announcer;
};
var AnnounceContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(function(message, mode, timeout) {
    if (mode === void 0) mode = 'polite';
    if (timeout === void 0) timeout = 500;
    // we only create a new container if we don't have one already
    // we create a separate node so that grommet does not set aria-hidden to it
    var announcer = document.body.querySelector("#grommet-announcer[aria-live]") || createAnnouncer();
    announcer.setAttribute('aria-live', 'off');
    announcer.innerHTML = message;
    announcer.setAttribute('aria-live', mode);
    setTimeout(function() {
        announcer.innerHTML = '';
    }, timeout);
});
AnnounceContext.propTypes = (0, _propTypes.AnnounceContextPropTypes);

},{"react":"8CCva","./propTypes":"dleWC","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dleWC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnnounceContextPropTypes", ()=>AnnounceContextPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PropType = {};
var AnnounceContextPropTypes = PropType;

},{"prop-types":"j03Ye","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"i3UJm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContainerTargetContext", ()=>(0, _containerTargetContext.ContainerTargetContext));
var _containerTargetContext = require("./ContainerTargetContext");

},{"./ContainerTargetContext":"29KAm","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"29KAm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContainerTargetContext", ()=>ContainerTargetContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var ContainerTargetContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(typeof document === 'object' ? document.body : undefined);

},{"react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7EsNN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResponsiveContext", ()=>(0, _responsiveContext.ResponsiveContext));
var _responsiveContext = require("./ResponsiveContext");

},{"./ResponsiveContext":"amiLU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"amiLU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResponsiveContext", ()=>ResponsiveContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("./propTypes");
var ResponsiveContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(undefined);
ResponsiveContext.propTypes = (0, _propTypes.ResponsiveContextPropTypes);

},{"react":"8CCva","./propTypes":"kqJ11","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kqJ11":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResponsiveContextPropTypes", ()=>ResponsiveContextPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PropType = {};
var ResponsiveContextPropTypes = PropType;

},{"prop-types":"j03Ye","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"g0Mji":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResponsiveContainerContext", ()=>ResponsiveContainerContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var ResponsiveContainerContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(false);

},{"react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7S2c8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RootsContext", ()=>RootsContext);
parcelHelpers.export(exports, "useRoots", ()=>useRoots);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var RootsContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(undefined);
var useRoots = function useRoots() {
    // If FocusedContainer is within Grommet React tree, there will be a value
    // from RootsContext. If not, set up a default value that can be passed
    // to drops that might open from within a drop.
    var defaultRoots = (0, _react.useRef)([]);
    var defaultValue = (0, _react.useMemo)(function() {
        return {
            roots: defaultRoots
        };
    }, []);
    var existingRoots = (0, _react.useContext)(RootsContext);
    return {
        contextValue: existingRoots || defaultValue,
        hasRoots: (existingRoots == null ? void 0 : existingRoots.roots) !== undefined
    };
};

},{"react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"d77SS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _themeContext.ThemeContext));
var _themeContext = require("./ThemeContext");

},{"./ThemeContext":"g36CN","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"g36CN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeContext", ()=>(0, _styledComponents.ThemeContext));
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _styledComponents = require("styled-components");
var _utils = require("../../utils");
var _propTypes1 = require("./propTypes");
(0, _styledComponents.ThemeContext).Extend = function(_ref) {
    var children = _ref.children, value = _ref.value;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledComponents.ThemeContext).Consumer, null, function(theme) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledComponents.ThemeContext).Provider, {
            value: (0, _utils.deepMerge)(theme, value)
        }, children);
    });
};
(0, _styledComponents.ThemeContext).Extend.propTypes = {
    children: (0, _propTypesDefault.default).node.isRequired,
    value: (0, _propTypesDefault.default).shape({}).isRequired
};
(0, _styledComponents.ThemeContext).propTypes = (0, _propTypes1.ThemeContextPropTypes);

},{"react":"8CCva","prop-types":"j03Ye","styled-components":"6bGrk","../../utils":"fx31z","./propTypes":"1MZHF","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fx31z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _animation = require("./animation");
parcelHelpers.exportAll(_animation, exports);
var _mixins = require("./mixins");
parcelHelpers.exportAll(_mixins, exports);
var _background = require("./background");
parcelHelpers.exportAll(_background, exports);
var _border = require("./border");
parcelHelpers.exportAll(_border, exports);
var _colors = require("./colors");
parcelHelpers.exportAll(_colors, exports);
var _dates = require("./dates");
parcelHelpers.exportAll(_dates, exports);
var _dom = require("./DOM");
parcelHelpers.exportAll(_dom, exports);
var _graphics = require("./graphics");
parcelHelpers.exportAll(_graphics, exports);
var _icon = require("./icon");
parcelHelpers.exportAll(_icon, exports);
var _styles = require("./styles");
parcelHelpers.exportAll(_styles, exports);
var _object = require("./object");
parcelHelpers.exportAll(_object, exports);
var _pagination = require("./pagination");
parcelHelpers.exportAll(_pagination, exports);
var _portalContext = require("./PortalContext");
parcelHelpers.exportAll(_portalContext, exports);
var _readOnly = require("./readOnly");
parcelHelpers.exportAll(_readOnly, exports);
var _refs = require("./refs");
parcelHelpers.exportAll(_refs, exports);
var _responsive = require("./responsive");
parcelHelpers.exportAll(_responsive, exports);
var _useKeyboard = require("./use-keyboard");
parcelHelpers.exportAll(_useKeyboard, exports);
var _useId = require("./useId");
parcelHelpers.exportAll(_useId, exports);

},{"./animation":false,"./mixins":"gx4wP","./background":"bX8Dm","./border":"4pVSC","./colors":"f3J10","./dates":false,"./DOM":"gCfo1","./graphics":false,"./icon":"71gIT","./styles":"4m6LZ","./object":"go0Cn","./pagination":false,"./PortalContext":"dLXd6","./readOnly":false,"./refs":"jeN98","./responsive":"6Wzh6","./use-keyboard":"hlK0O","./useId":false,"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3w9LG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animationBounds", ()=>animationBounds);
parcelHelpers.export(exports, "normalizeTiming", ()=>normalizeTiming);
parcelHelpers.export(exports, "animationEnding", ()=>animationEnding);
parcelHelpers.export(exports, "animationObjectStyle", ()=>animationObjectStyle);
var _styledComponents = require("styled-components");
var PULSE_SIZES = {
    xsmall: 1.001,
    small: 1.01,
    medium: 1.1,
    large: 1.5,
    xlarge: 2
};
var SLIDE_SIZES = {
    xsmall: 1,
    small: 5,
    medium: 10,
    large: 50,
    xlarge: 200
};
var JIGGLE_SIZES = {
    xsmall: 0.1,
    small: 1,
    medium: 5,
    large: 400,
    xlarge: 1000
};
var ZOOM_SIZES = {
    xsmall: 0.001,
    small: 0.01,
    medium: 0.05,
    large: 0.1,
    xlarge: 0.5
};
var animationBounds = function animationBounds(type, size) {
    if (size === void 0) size = 'medium';
    if (type === 'draw') return [
        '',
        "stroke-dashoffset: 0"
    ];
    if (type === 'fadeIn') return [
        'opacity: 0;',
        'opacity: 1;'
    ];
    if (type === 'fadeOut') return [
        'opacity: 1;',
        'opacity: 0;'
    ];
    if (type === 'jiggle') {
        var deg = JIGGLE_SIZES[size];
        return [
            "transform: rotate(-" + deg + "deg);",
            "transform: rotate(" + deg + "deg);"
        ];
    }
    if (type === 'pulse') return [
        'transform: scale(1);',
        "transform: scale(" + PULSE_SIZES[size] + ")"
    ];
    if (type === 'rotateRight') return [
        "transform: rotate(0deg);",
        "transform: rotate(359deg);"
    ];
    if (type === 'rotateLeft') return [
        "transform: rotate(0deg);",
        "transform: rotate(-359deg);"
    ];
    if (type === 'flipIn') return [
        'transform: rotateY(90deg);',
        'transform: rotateY(0);'
    ];
    if (type === 'flipOut') return [
        'transform: rotateY(0);',
        'transform: rotateY(90deg);'
    ];
    if (type === 'slideDown') return [
        "transform: translateY(-" + SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'slideLeft') return [
        "transform: translateX(" + SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'slideRight') return [
        "transform: translateX(-" + SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'slideUp') return [
        "transform: translateY(" + SLIDE_SIZES[size] + "%);",
        'transform: none;'
    ];
    if (type === 'zoomIn') return [
        "transform: scale(" + (1 - ZOOM_SIZES[size]) + ");",
        'transform: none;'
    ];
    if (type === 'zoomOut') return [
        "transform: scale(" + (1 + ZOOM_SIZES[size]) + ");",
        'transform: none;'
    ];
    return [];
};
var normalizeTiming = function normalizeTiming(time, defaultTiming) {
    return typeof time === 'number' ? time / 1000.0 + "s" : time || defaultTiming;
};
var animationEnding = function animationEnding(type) {
    if (type === 'draw') return 'linear forwards';
    if (type === 'jiggle') return 'alternate infinite';
    if (type === 'pulse') return 'alternate infinite';
    if (type === 'rotateRight' || type === 'rotateLeft') return 'infinite linear';
    return 'forwards';
};
var animationObjectStyle = function animationObjectStyle(animation, theme, themeObj) {
    var bounds = animationBounds(animation.type, animation.size);
    var animationTheme = themeObj && themeObj.animation || theme.global.animation;
    if (bounds) {
        var animationTransition = (0, _styledComponents.css)([
            "from{",
            ";}to{",
            ";}"
        ], bounds[0], bounds[1]);
        var defaultDuration = function defaultDuration() {
            return normalizeTiming(animationTheme[animation.type] ? animationTheme[animation.type].duration : animation.duration, animationTheme.duration);
        };
        return (0, _styledComponents.css)([
            "",
            " ",
            " ",
            " ",
            ""
        ], (0, _styledComponents.keyframes)([
            "",
            ""
        ], animationTransition), normalizeTiming(animation.duration, defaultDuration()), normalizeTiming(animation.delay, '0s'), animationEnding(animation.type));
    }
    return '';
};

},{"styled-components":"6bGrk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gx4wP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseMetricToNum", ()=>parseMetricToNum);
parcelHelpers.export(exports, "edgeToNum", ()=>edgeToNum);
parcelHelpers.export(exports, "fontSize", ()=>fontSize);
parcelHelpers.export(exports, "breakpointStyle", ()=>breakpointStyle);
parcelHelpers.export(exports, "findAllByType", ()=>_findAllByType);
parcelHelpers.export(exports, "getAvailableAtBadge", ()=>getAvailableAtBadge);
var _styledComponents = require("styled-components");
var parseMetricToNum = function parseMetricToNum(metric) {
    if (typeof metric === 'number') return metric;
    metric.match(/\s/);
    return parseFloat(metric.match(/\d+(\.\d+)?/), 10);
};
var edgeToNum = function edgeToNum(size, theme) {
    return size ? parseMetricToNum(theme.global.edgeSize[size] || size) : 0;
};
var fontSize = function fontSize(size, lineHeight) {
    return (0, _styledComponents.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], function(props) {
        return parseMetricToNum(size) / parseMetricToNum(props.theme.global.font.size) * 1 + "rem";
    }, function(props) {
        return lineHeight || Math.ceil(parseMetricToNum(size) / parseMetricToNum(props.theme.global.lineHeight)) * (parseMetricToNum(props.theme.global.lineHeight) / parseMetricToNum(size)) + "px";
    });
};
var breakpointStyle = function breakpointStyle(breakpoint, content, responsive) {
    var px = typeof (breakpoint == null ? void 0 : breakpoint.value) === 'string' && breakpoint.value.endsWith('px') ? '' : 'px';
    var st = responsive === 'container' ? (0, _styledComponents.css)([
        "@container ",
        "{",
        ";}"
    ], breakpoint.value && "(max-width: " + breakpoint.value + px + ")", content) : (0, _styledComponents.css)([
        "@media only screen ",
        "{",
        ";}"
    ], breakpoint.value && "and (max-width: " + breakpoint.value + px + ")", content);
    return st;
};
var _findAllByType = function findAllByType(component, type) {
    var matches = [];
    if (component.type === type) matches.push(component);
    if (component.children) component.children.forEach(function(child) {
        matches = matches.concat(_findAllByType(child, type));
    });
    return matches;
};
var getAvailableAtBadge = function getAvailableAtBadge(availableAt, componentType) {
    return [
        {
            url: "https://storybook.grommet.io/?selectedKind=" + componentType + "-" + availableAt + "&full=0&stories=1&panelRight=0",
            badge: 'https://cdn-images-1.medium.com/fit/c/120/120/1*TD1P0HtIH9zF0UEH28zYtw.png',
            label: 'Storybook'
        },
        {
            url: "https://codesandbox.io/s/github/grommet/grommet-sandbox?initialpath=/" + availableAt.toLowerCase() + "&module=%2Fsrc%2F" + availableAt + ".js",
            badge: 'https://codesandbox.io/static/img/play-codesandbox.svg',
            label: 'CodeSandbox'
        }
    ];
};

},{"styled-components":"6bGrk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bX8Dm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeBackground", ()=>normalizeBackground);
parcelHelpers.export(exports, "backgroundIsDark", ()=>backgroundIsDark);
parcelHelpers.export(exports, "backgroundAndTextColors", ()=>backgroundAndTextColors);
parcelHelpers.export(exports, "backgroundStyle", ()=>backgroundStyle);
parcelHelpers.export(exports, "activeStyle", ()=>activeStyle);
parcelHelpers.export(exports, "selectedStyle", ()=>selectedStyle);
parcelHelpers.export(exports, "getHoverIndicatorStyle", ()=>getHoverIndicatorStyle);
var _styledComponents = require("styled-components");
var _colors = require("./colors");
// evalStyle() converts a styled-components item into a string
var evalStyle = function evalStyle(arg, theme) {
    if (arg && Array.isArray(arg) && typeof arg[0] === 'function') return arg[0]({
        theme: theme
    });
    return arg;
};
var normalizeBackground = function normalizeBackground(backgroundArg, theme) {
    var _theme$global$backgro;
    var background = ((_theme$global$backgro = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro[backgroundArg]) || backgroundArg;
    var result = background;
    // If the background has a light or dark object, use that
    if (background) {
        if (theme.dark && background.dark && typeof background.dark !== 'boolean') result = background.dark;
        else if (!theme.dark && background.light && typeof background.light !== 'boolean') result = background.light;
        result = evalStyle(result, theme);
    }
    return result;
};
var normalizeBackgroundColor = function normalizeBackgroundColor(backgroundArg, theme) {
    var _theme$global$backgro2;
    var background = backgroundArg.color || backgroundArg;
    var result = (0, _colors.normalizeColor)(// Background color may be defined by theme.global.backgrounds or
    // theme.global.colors.
    ((_theme$global$backgro2 = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro2[background]) || background, theme, backgroundArg.dark);
    return result;
};
var _normalizeBackgroundImage = function normalizeBackgroundImage(background, theme) {
    var result;
    if (background.image) {
        var _theme$global$backgro3, _theme$global$backgro4;
        result = normalizeBackground(background.dark ? (_theme$global$backgro3 = theme.global.backgrounds) == null || (_theme$global$backgro3 = _theme$global$backgro3[background.image]) == null ? void 0 : _theme$global$backgro3.dark : (_theme$global$backgro4 = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro4[background.image], theme) || background.image;
    } else {
        var _theme$global$backgro5;
        var normalized = normalizeBackground((_theme$global$backgro5 = theme.global.backgrounds) == null ? void 0 : _theme$global$backgro5[background], theme);
        result = typeof normalized === 'object' ? _normalizeBackgroundImage(normalized, theme) : normalized;
    }
    return result;
};
var rotateBackground = function rotateBackground(background, theme) {
    var backgroundImage = _normalizeBackgroundImage(background, theme);
    var result = backgroundImage;
    if (backgroundImage.lastIndexOf('linear-gradient', 0) === 0) {
        var regex = /\d{1,}deg\b,/gm; // Contains rotation specified in degrees. Only targets 'deg' string with a trailing comma. Do not match 'deg' string for hsl, etc..
        result = backgroundImage.lastIndexOf('deg,') >= 0 ? backgroundImage.replace(regex, background.rotate + "deg,") : backgroundImage.replace('linear-gradient(', "linear-gradient(" + background.rotate + "deg, ");
    } else console.warn("'background.rotate' property only supports 'background.image' containing a linear-gradient string.");
    return result;
};
var backgroundIsDark = function backgroundIsDark(backgroundArg, theme) {
    var background = normalizeBackground(backgroundArg, theme);
    var result;
    if (background) {
        if (typeof background === 'object') {
            var color = background.color, dark = background.dark, opacity = background.opacity;
            if (typeof dark === 'boolean') result = dark;
            else if (color && // weak opacity means we keep the existing darkness
            (!opacity || opacity !== 'weak')) {
                var backgroundColor = (0, _colors.normalizeColor)(background.color, theme);
                if (backgroundColor) result = (0, _colors.colorIsDark)(backgroundColor);
            }
        } else {
            var _color = (0, _colors.normalizeColor)(background, theme);
            if (_color) result = (0, _colors.colorIsDark)(_color);
        }
    }
    return result;
};
var darkContext = function darkContext(backgroundColor) {
    var isDark = (0, _colors.colorIsDark)(backgroundColor);
    if (isDark === undefined) return undefined;
    return isDark ? 'dark' : 'light';
};
var backgroundAndTextColors = function backgroundAndTextColors(backgroundArg, textArg, theme) {
    if (!backgroundArg) return [
        undefined,
        textArg
    ];
    var global = theme.global;
    var background = normalizeBackground(backgroundArg, theme);
    var text = textArg || global.colors.text;
    var backgroundColor;
    var textColor;
    if (typeof background === 'object') {
        if (background.dark === false) textColor = text.light || text;
        else if (background.dark) textColor = text.dark || text;
        if (background.color) {
            var color = normalizeBackgroundColor(background, theme);
            var opacity = background.opacity === true ? global.opacity.medium : global.opacity[background.opacity] || background.opacity;
            backgroundColor = (0, _colors.getRGBA)(color, opacity) || color;
            // If we don't have a textColor already, and we aren't too translucent,
            // set the textColor to have the best contrast against the background
            // color.
            if (!textColor && (opacity === undefined || opacity > 0.3)) {
                var shade = darkContext(backgroundColor, theme);
                textColor = (0, _colors.normalizeColor)(shade && text[shade] || text, theme);
            }
        }
    } else {
        backgroundColor = normalizeBackgroundColor(background, theme);
        var _shade = darkContext(backgroundColor, theme);
        var transparent;
        if (backgroundColor && (0, _colors.canExtractRGBArray)(backgroundColor)) {
            var colorArray = (0, _colors.getRGBArray)(backgroundColor);
            // check if the alpha value is less than 0.5
            if (colorArray[3] < 0.5) transparent = true;
        }
        if (_shade) textColor = (0, _colors.normalizeColor)(text[_shade] || text, theme, _shade === 'dark');
        else if (transparent && text) textColor = (0, _colors.normalizeColor)(text, theme);
        else {
            // If we can't determine the shade, we assume this isn't a simple color.
            // It could be a gradient. backgroundStyle() will take care of that case.
            if (backgroundColor !== 'transparent') backgroundColor = undefined;
            if (text) textColor = (0, _colors.normalizeColor)(text, theme);
        }
    }
    // if textArg is false, we don't want the textColor, used for Button hover
    if (textArg === false) textColor = undefined;
    return [
        backgroundColor,
        textColor
    ];
};
var backgroundStyle = function backgroundStyle(backgroundArg, theme, textColorArg) {
    // for Grommet component, if the background isn't defined, don't set it
    if (backgroundArg === undefined) return undefined;
    var background = normalizeBackground(backgroundArg, theme);
    var _backgroundAndTextCol = backgroundAndTextColors(background, textColorArg, theme), backgroundColor = _backgroundAndTextCol[0], textColor = _backgroundAndTextCol[1];
    var backgroundImage = background.rotate ? rotateBackground(background, theme) : _normalizeBackgroundImage(background, theme);
    var backgroundClipStyle = '';
    if (background.clip) backgroundClipStyle = background.clip === 'text' ? "-webkit-text-fill-color: transparent; \n           -webkit-background-clip: text; \n           background-clip: text;" : "background-clip: " + background.clip + ";";
    if (typeof background === 'string' && background.lastIndexOf('url', 0) === 0) return (0, _styledComponents.css)([
        "background:",
        " no-repeat center center;background-size:cover;"
    ], background);
    if (backgroundImage) {
        var backgroundStyles = "\n      " + (backgroundColor ? "background-color: " + backgroundColor + ";" : '') + "\n      background-image: " + backgroundImage + ";\n      background-repeat: " + (typeof background === 'object' && background.repeat || 'no-repeat') + ";\n      background-position: " + (background.position || 'center center') + ";\n      background-size: " + (background.size || 'cover') + ";\n      " + backgroundClipStyle + "\n    ";
        // allow both background color and image, in case the image doesn't fill
        // when image and opacity are used together, we need to use pseudo :before
        // to ensure that only image and background color are affected by opacity
        // but not the container contents
        return (0, _styledComponents.css)([
            "",
            " ",
            ""
        ], textColor ? "color: " + textColor + ";" : '', !background.opacity ? backgroundStyles : "position: relative;\n        z-index: 0;\n        &:before {\n          content: '';\n          position: absolute;\n          top: 0;\n          right: 0;\n          left: 0;\n          bottom: 0;\n          z-index: -1;\n          border-radius: inherit;\n          " + backgroundStyles + "\n          opacity: " + (background.opacity === true ? theme.global.opacity.medium : theme.global.opacity[background.opacity] || background.opacity) + ";\n        }");
    }
    if (backgroundColor) return (0, _styledComponents.css)([
        "background-color:",
        ";",
        ""
    ], backgroundColor, textColor ? "color: " + textColor + ";" : '');
    if (typeof background === 'string') // This case takes care of gradients
    // or theme colors that use CSS names like 'crimson' that we don't parse
    return (0, _styledComponents.css)([
        "background:",
        ";"
    ], (0, _colors.normalizeColor)(background, theme));
    return undefined;
};
var activeStyle = (0, _styledComponents.css)([
    "",
    ""
], function(props) {
    return backgroundStyle((0, _colors.normalizeColor)(props.theme.global.active.background, props.theme), props.theme, props.theme.global.active.color);
});
var selectedStyle = (0, _styledComponents.css)([
    "",
    ""
], function(props) {
    return backgroundStyle((0, _colors.normalizeColor)(props.theme.global.selected.background, props.theme), props.theme, props.theme.global.selected.color);
});
var getHoverIndicatorStyle = function getHoverIndicatorStyle(hoverIndicator, theme) {
    var background;
    var elevation;
    if (hoverIndicator === true || hoverIndicator === 'background') background = theme.global.hover.background;
    else if (typeof hoverIndicator === 'object') {
        if (hoverIndicator.elevation || hoverIndicator.background) {
            elevation = hoverIndicator.elevation;
            background = hoverIndicator.background;
        } else background = hoverIndicator;
    } else background = hoverIndicator;
    return (0, _styledComponents.css)([
        "",
        " ",
        ""
    ], backgroundStyle(background, theme, theme.global.hover.color), elevation && "box-shadow: " + theme.global.elevation[theme.dark ? 'dark' : 'light'][elevation] + ";");
};

},{"styled-components":"6bGrk","./colors":"f3J10","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"f3J10":[function(require,module,exports,__globalThis) {
// Returns the specific color that should be used according to the theme.
// If 'dark' is supplied, it takes precedence over 'theme.dark'.
// Can return undefined.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeColor", ()=>_normalizeColor);
parcelHelpers.export(exports, "canExtractRGBArray", ()=>canExtractRGBArray);
parcelHelpers.export(exports, "getRGBArray", ()=>getRGBArray);
parcelHelpers.export(exports, "colorIsDark", ()=>colorIsDark);
parcelHelpers.export(exports, "getRGBA", ()=>getRGBA);
var _normalizeColor = function normalizeColor(color, theme, dark) {
    var colorSpec = theme.global && theme.global.colors[color] !== undefined ? theme.global.colors[color] : color;
    // If the color has a light or dark object, use that
    var result = colorSpec;
    if (colorSpec) {
        if ((dark === true || dark === undefined && theme.dark) && colorSpec.dark !== undefined) result = colorSpec.dark;
        else if ((dark === false || !theme.dark) && colorSpec.light !== undefined) result = colorSpec.light;
    }
    // allow one level of indirection in color names
    if (result && theme.global && theme.global.colors[result] !== undefined) result = _normalizeColor(result, theme, dark);
    return result;
};
var parseHexToRGB = function parseHexToRGB(color) {
    return color.length < 7 // 7 is what's needed for '#RRGGBB'
     ? color.match(/[A-Za-z0-9]{1}/g).map(function(v) {
        return parseInt("" + v + v, 16);
    }) : // https://stackoverflow.com/a/42429333
    color.match(/[A-Za-z0-9]{2}/g).map(function(v) {
        return parseInt(v, 16);
    });
};
// From: https://stackoverflow.com/a/9493060/8513067
// Converts an HSL color value to RGB. Conversion formula
// adapted from http://en.wikipedia.org/wiki/HSL_color_space.
// Assumes h, s, and l are contained in the set [0, 1] and
// returns r, g, and b in the set [0, 255].
var hslToRGB = function hslToRGB(h, s, l) {
    var r;
    var g;
    var b;
    if (s === 0 || s === '0') {
        // achromatic
        r = l;
        g = l;
        b = l;
    } else {
        var hue2rgb = function hue2rgb(p, q, inT) {
            var t = inT;
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 0.16666667) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 0.66666667) return p + (q - p) * (0.66666667 - t) * 6;
            return p;
        };
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 0.33333333);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 0.33333333);
    }
    return [
        Math.round(r * 255),
        Math.round(g * 255),
        Math.round(b * 255)
    ];
};
// allow for alpha: #RGB, #RGBA, #RRGGBB, or #RRGGBBAA
var hexExp = /^#[A-Za-z0-9]{3,4}$|^#[A-Za-z0-9]{6,8}$/;
var rgbExp = /^rgba?\(\s?([0-9]*)\s?,\s?([0-9]*)\s?,\s?([0-9]*)\s?\)/;
var rgbaExp = /^rgba?\(\s?([0-9]*)\s?,\s?([0-9]*)\s?,\s?([0-9]*)\s?,\s?([.0-9]*)\s?\)/;
// e.g. hsl(240, 60%, 50%)
var hslExp = /^hsla?\(\s?([0-9]*)\s?,\s?([0-9]*)%?\s?,\s?([0-9]*)%?\s?.*?\)/;
var canExtractRGBArray = function canExtractRGBArray(color) {
    return hexExp.test(color) || rgbExp.test(color) || rgbaExp.test(color) || hslExp.test(color);
};
var getRGBArray = function getRGBArray(color) {
    if (hexExp.test(color)) {
        var _parseHexToRGB = parseHexToRGB(color), red = _parseHexToRGB[0], green = _parseHexToRGB[1], blue = _parseHexToRGB[2], alpha = _parseHexToRGB[3];
        return [
            red,
            green,
            blue,
            alpha !== undefined ? alpha / 255.0 : undefined
        ];
    }
    var match = color.match(rgbExp);
    if (match) return match.splice(1).map(function(v) {
        return parseInt(v, 10);
    });
    match = color.match(rgbaExp);
    if (match) return match.splice(1).map(function(v) {
        return parseFloat(v, 10);
    });
    match = color.match(hslExp);
    if (match) {
        var _match$splice$map = match.splice(1).map(function(v) {
            return parseInt(v, 10);
        }), h = _match$splice$map[0], s = _match$splice$map[1], l = _match$splice$map[2];
        return hslToRGB(h / 360.0, s / 100.0, l / 100.0);
    }
    return color;
};
var colorIsDark = function colorIsDark(color) {
    if (color && canExtractRGBArray(color)) {
        var _getRGBArray = getRGBArray(color), red = _getRGBArray[0], green = _getRGBArray[1], blue = _getRGBArray[2], alpha = _getRGBArray[3];
        // if there is an alpha and it's greater than 50%, we can't really tell
        if (alpha < 0.5) return undefined;
        var brightness = (299 * red + 587 * green + 114 * blue) / 1000;
        // From: http://www.had2know.com/technology/color-contrast-calculator-web-design.html
        // Above domain is no longer registered.
        return brightness < 125;
    }
    return undefined;
};
var getRGBA = function getRGBA(color, opacity) {
    if (color && canExtractRGBArray(color)) {
        var _getRGBArray2 = getRGBArray(color), red = _getRGBArray2[0], green = _getRGBArray2[1], blue = _getRGBArray2[2], alpha = _getRGBArray2[3];
        var normalizedAlpha;
        if (opacity !== undefined) normalizedAlpha = opacity;
        else if (alpha !== undefined) normalizedAlpha = alpha;
        else normalizedAlpha = 1;
        return "rgba(" + red + ", " + green + ", " + blue + ", " + normalizedAlpha + ")";
    }
    return undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4pVSC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "responsiveBorderStyle", ()=>responsiveBorderStyle);
parcelHelpers.export(exports, "borderStyle", ()=>borderStyle);
var _styledComponents = require("styled-components");
var _colors = require("./colors");
var _mixins = require("./mixins");
var responsiveBorderStyle = function responsiveBorderStyle(data, theme) {
    var color = (0, _colors.normalizeColor)(data.color || 'border', theme);
    var borderSize = data.size || 'xsmall';
    var style = data.style || 'solid';
    var side = typeof data === 'string' ? data : data.side || 'all';
    var breakpoint = theme.box.responsiveBreakpoint && theme.global.breakpoints[theme.box.responsiveBreakpoint];
    if (!breakpoint.borderSize) breakpoint.borderSize = theme.global.borderSize;
    var value = breakpoint && (breakpoint.borderSize[borderSize] || borderSize) && style + " " + (breakpoint.borderSize[borderSize] || borderSize) + " " + color;
    if (!value) return undefined;
    if (side === 'top' || side === 'bottom' || side === 'left' || side === 'right') return "border-" + side + ": " + value + ";";
    if (side === 'end' || side === 'start') return "border-inline-" + side + ": " + value + ";";
    if (side === 'vertical') return "\n      border-left: " + value + ";\n      border-right: " + value + ";\n    ";
    if (side === 'horizontal') return "\n      border-top: " + value + ";\n      border-bottom: " + value + ";\n    ";
    if (side === 'between') return undefined; // no-op
    return "border: " + value + ";";
};
var borderStyle = function borderStyle(borderData, responsive, theme) {
    var borderStyles = [];
    (Array.isArray(borderData) ? borderData : [
        borderData
    ]).forEach(function(data) {
        var styles = [];
        var color = (0, _colors.normalizeColor)(data.color || 'border', theme);
        var borderSize = data.size || 'xsmall';
        var style = data.style || 'solid';
        var side = typeof data === 'string' ? data : data.side || 'all';
        var value = style + " " + (theme.global.borderSize[borderSize] || borderSize) + " " + color;
        var responsiveStyle = responsive && responsiveBorderStyle(data, theme);
        var breakpoint = responsiveStyle && theme.box.responsiveBreakpoint && theme.global.breakpoints[theme.box.responsiveBreakpoint];
        if (side === 'top' || side === 'bottom' || side === 'left' || side === 'right') {
            styles.push("border-" + side + ": " + value + ";");
            if (responsiveStyle) styles.push((0, _mixins.breakpointStyle)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'end' || side === 'start') {
            styles.push((0, _styledComponents.css)([
                "border-inline-",
                ":",
                ";"
            ], side, value));
            if (responsiveStyle) styles.push((0, _mixins.breakpointStyle)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'vertical') {
            styles.push((0, _styledComponents.css)([
                "border-left:",
                ";border-right:",
                ";"
            ], value, value));
            if (responsiveStyle) styles.push((0, _mixins.breakpointStyle)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'horizontal') {
            styles.push((0, _styledComponents.css)([
                "border-top:",
                ";border-bottom:",
                ";"
            ], value, value));
            if (responsiveStyle) styles.push((0, _mixins.breakpointStyle)(breakpoint, responsiveStyle, responsive));
        } else if (side === 'between') ;
        else {
            styles.push((0, _styledComponents.css)([
                "border:",
                ";"
            ], value));
            if (responsiveStyle) styles.push((0, _mixins.breakpointStyle)(breakpoint, responsiveStyle, responsive));
        }
        borderStyles.push(styles);
    });
    return borderStyles;
};

},{"styled-components":"6bGrk","./colors":"f3J10","./mixins":"gx4wP","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gCfo1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findScrollParent", ()=>findScrollParent);
parcelHelpers.export(exports, "findScrollParents", ()=>findScrollParents);
parcelHelpers.export(exports, "containsFocus", ()=>containsFocus);
parcelHelpers.export(exports, "withinDropPortal", ()=>withinDropPortal);
parcelHelpers.export(exports, "isFocusable", ()=>isFocusable);
parcelHelpers.export(exports, "getFirstFocusableDescendant", ()=>getFirstFocusableDescendant);
parcelHelpers.export(exports, "shouldKeepFocus", ()=>shouldKeepFocus);
parcelHelpers.export(exports, "getNewContainer", ()=>getNewContainer);
parcelHelpers.export(exports, "setFocusWithoutScroll", ()=>setFocusWithoutScroll);
parcelHelpers.export(exports, "makeNodeFocusable", ()=>makeNodeFocusable);
parcelHelpers.export(exports, "makeNodeUnfocusable", ()=>makeNodeUnfocusable);
parcelHelpers.export(exports, "findVisibleParent", ()=>_findVisibleParent);
parcelHelpers.export(exports, "isNodeAfterScroll", ()=>isNodeAfterScroll);
parcelHelpers.export(exports, "isNodeBeforeScroll", ()=>isNodeBeforeScroll);
parcelHelpers.export(exports, "findButtonParent", ()=>_findButtonParent);
var findScrollParent = function findScrollParent(element, horizontal) {
    var result;
    if (element) {
        var parent = element.parentNode;
        while(!result && parent && parent.getBoundingClientRect){
            var rect = parent.getBoundingClientRect();
            // 10px is to account for borders and scrollbars in a lazy way
            if (horizontal) {
                if (rect.width && parent.scrollWidth > rect.width + 10) result = parent;
            } else if (rect.height && parent.scrollHeight > rect.height + 10) result = parent;
            parent = parent.parentNode;
        }
        // last scrollable element will be the document
        // if nothing else is scrollable in the page
        if (!result) result = document;
        else if (result.tagName.toLowerCase() === 'body') result = document;
    }
    return result;
};
var documentTags = [
    'html',
    'body'
];
var findScrollParents = function findScrollParents(element, horizontal) {
    var result = [];
    if (element) {
        var parent = element.parentNode;
        while(parent && parent.getBoundingClientRect){
            var rect = parent.getBoundingClientRect();
            // 10px is to account for borders and scrollbars in a lazy way
            if (horizontal) {
                if (rect.width && parent.scrollWidth > rect.width + 10) result.push(parent);
            } else if (rect.height && parent.scrollHeight > rect.height + 10) result.push(parent);
            parent = parent.parentNode;
        }
        if (result.length && documentTags.includes(result[0].tagName.toLowerCase())) result.length = 0;
        // last scrollable element will be the document
        result.push(document);
    }
    return result;
};
var containsFocus = function containsFocus(node) {
    var root = node.getRootNode();
    var element = root.activeElement;
    while(element){
        if (element === node) break;
        element = element.parentElement;
    }
    return !!element;
};
var withinDropPortal = function withinDropPortal(node, portalContext) {
    var root = node == null ? void 0 : node.getRootNode();
    var element = node;
    var portalId;
    while(element && element !== root)if (element.hasAttribute('data-g-portal-id')) {
        portalId = element.getAttribute('data-g-portal-id');
        element = root;
    } else element = element.parentElement;
    // if portalContext doesn't contain the portalId then the
    // portal is new and node is within a drop that just opened
    if (portalId === undefined || portalContext.indexOf(parseInt(portalId, 10)) !== -1) return false;
    return true;
};
var isFocusable = function isFocusable(element) {
    var tagName = element.tagName.toLowerCase();
    return tagName === 'input' || tagName === 'select' || tagName === 'textarea';
};
var getFirstFocusableDescendant = function getFirstFocusableDescendant(element) {
    var children = element.getElementsByTagName('*');
    for(var i = 0; i < children.length; i += 1){
        var child = children[i];
        if (isFocusable(child)) return child;
    }
    return undefined;
};
var shouldKeepFocus = function shouldKeepFocus(root) {
    var element = root.activeElement;
    if (isFocusable(element)) return true;
    return !!getFirstFocusableDescendant(element);
};
var getNewContainer = function getNewContainer(target, targetChildPosition) {
    if (target === void 0) target = document.body;
    // setup DOM
    var container = document.createElement('div');
    if (targetChildPosition === 'first') // for SkipLinks
    target.prepend(container);
    else target.appendChild(container);
    return container;
};
var setFocusWithoutScroll = function setFocusWithoutScroll(element) {
    var x = window.scrollX;
    var y = window.scrollY;
    element.focus();
    window.scrollTo(x, y);
};
var TABINDEX = 'tabindex';
var TABINDEX_STATE = 'data-g-tabindex';
var makeNodeFocusable = function makeNodeFocusable(node) {
    // do not touch aria live containers so that announcements work
    if (!node.hasAttribute('aria-live')) {
        node.removeAttribute('aria-hidden');
        // allow children to receive focus again
        var elements = node.getElementsByTagName('*');
        // only reset elements we've changed in makeNodeUnfocusable()
        Array.prototype.filter.call(elements || [], function(element) {
            return element.hasAttribute(TABINDEX_STATE);
        }).forEach(function(element) {
            var prior = element.getAttribute(TABINDEX_STATE);
            if (prior >= 0) element.setAttribute(TABINDEX, element.getAttribute(TABINDEX_STATE));
            else if (prior === 'none') element.removeAttribute(TABINDEX);
            element.removeAttribute(TABINDEX_STATE);
        });
    }
};
// Using ^ and $ to match the whole tagName, and not e.g. <meta> and <data>.
var autoFocusingTags = /^(a|area|input|select|textarea|button|iframe)$/;
var makeNodeUnfocusable = function makeNodeUnfocusable(node) {
    // do not touch aria live containers so that announcements work
    if (!node.hasAttribute('aria-live')) {
        node.setAttribute('aria-hidden', true);
        // prevent children to receive focus
        var elements = node.getElementsByTagName('*');
        // first, save off the tabIndex of any element with one
        Array.prototype.filter.call(elements || [], function(element) {
            return element.getAttribute(TABINDEX) !== null;
        }).forEach(function(element) {
            // if TABINDEX_STATE already exists, it's holding the original value
            if (!element.getAttribute(TABINDEX_STATE)) element.setAttribute(TABINDEX_STATE, element.getAttribute(TABINDEX));
            element.setAttribute(TABINDEX, -1);
        });
        // then, if any element is inherently focusable and not handled above,
        // give it a tabIndex of -1 so it can't receive focus
        Array.prototype.filter.call(elements || [], function(element) {
            var currentTag = element.tagName.toLowerCase();
            return currentTag.match(autoFocusingTags) && element.focus && element.getAttribute(TABINDEX_STATE) === null;
        }).forEach(function(element) {
            element.setAttribute(TABINDEX_STATE, 'none');
            element.setAttribute(TABINDEX, -1);
        });
    }
};
var _findVisibleParent = function findVisibleParent(element) {
    if (element) // Get the closest ancestor element that is positioned.
    return element.offsetParent ? element : _findVisibleParent(element.parentElement) || element;
    return undefined;
};
var isNodeAfterScroll = function isNodeAfterScroll(node, target) {
    var _node$getBoundingClie = node.getBoundingClientRect(), bottom = _node$getBoundingClie.bottom;
    // target will be the document from findScrollParent()
    var _ref = target.getBoundingClientRect ? target.getBoundingClientRect() : {
        height: 0,
        top: 0
    }, height = _ref.height, top = _ref.top;
    return bottom >= top + height;
};
var isNodeBeforeScroll = function isNodeBeforeScroll(node, target) {
    var _node$getBoundingClie2 = node.getBoundingClientRect(), top = _node$getBoundingClie2.top;
    // target will be the document from findScrollParent()
    var _ref2 = target.getBoundingClientRect ? target.getBoundingClientRect() : {
        top: 0
    }, targetTop = _ref2.top;
    return top <= targetTop;
};
var _findButtonParent = function findButtonParent(element) {
    if (element && element.nodeName !== 'BUTTON' && element.nodeName !== 'A') return _findButtonParent(element.parentElement);
    return element;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"71gIT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSizedIcon", ()=>useSizedIcon);
var _react = require("react");
var useSizedIcon = function useSizedIcon(icon, size, theme) {
    var _theme$icon;
    return icon && theme != null && (_theme$icon = theme.icon) != null && _theme$icon.matchSize && !icon.props.size ? /*#__PURE__*/ (0, _react.cloneElement)(icon, {
        size: size
    }) : icon;
};

},{"react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4m6LZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "styledComponentsConfig", ()=>styledComponentsConfig);
parcelHelpers.export(exports, "baseStyle", ()=>baseStyle);
parcelHelpers.export(exports, "controlBorderStyle", ()=>controlBorderStyle);
parcelHelpers.export(exports, "edgeStyle", ()=>edgeStyle);
parcelHelpers.export(exports, "fillStyle", ()=>fillStyle);
parcelHelpers.export(exports, "focusStyle", ()=>focusStyle);
parcelHelpers.export(exports, "unfocusStyle", ()=>unfocusStyle);
parcelHelpers.export(exports, "getInputPadBySide", ()=>getInputPadBySide);
parcelHelpers.export(exports, "inputStyle", ()=>inputStyle);
parcelHelpers.export(exports, "inputPadForIcon", ()=>inputPadForIcon);
parcelHelpers.export(exports, "overflowStyle", ()=>overflowStyle);
parcelHelpers.export(exports, "genericStyles", ()=>genericStyles);
parcelHelpers.export(exports, "disabledStyle", ()=>disabledStyle);
parcelHelpers.export(exports, "sizeStyle", ()=>sizeStyle);
parcelHelpers.export(exports, "plainInputStyle", ()=>plainInputStyle);
parcelHelpers.export(exports, "elevationStyle", ()=>elevationStyle);
parcelHelpers.export(exports, "kindPartStyles", ()=>kindPartStyles);
parcelHelpers.export(exports, "roundStyle", ()=>roundStyle);
parcelHelpers.export(exports, "textAlignStyle", ()=>textAlignStyle);
parcelHelpers.export(exports, "alignStyle", ()=>alignStyle);
parcelHelpers.export(exports, "alignContentStyle", ()=>alignContentStyle);
parcelHelpers.export(exports, "widthStyle", ()=>widthStyle);
parcelHelpers.export(exports, "heightStyle", ()=>heightStyle);
var _styledComponents = require("styled-components");
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var _background = require("./background");
var _colors = require("./colors");
var _responsive = require("./responsive");
var _mixins = require("./mixins");
var styledComponentsConfig = {
    shouldForwardProp: (0, _isPropValidDefault.default)
};
var baseStyle = (0, _styledComponents.css)([
    "font-family:",
    ";font-size:",
    ";line-height:",
    ";font-weight:",
    ";",
    " ",
    " box-sizing:border-box;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;"
], function(props) {
    return props.theme.global.font.family;
}, function(props) {
    return props.theme.global.font.size;
}, function(props) {
    return props.theme.global.font.height;
}, function(props) {
    return props.theme.global.font.weight;
}, function(props) {
    return props.theme.global.font.variant && "\n    font-variant:" + props.theme.global.font.variant + ";\n  ";
}, function(props) {
    return !props.plain && (0, _background.backgroundStyle)(props.theme.baseBackground, props.theme);
});
var controlBorderStyle = (0, _styledComponents.css)([
    "border:",
    " solid ",
    ";border-radius:",
    ";"
], function(props) {
    return props.theme.global.control.border.width;
}, function(props) {
    return (0, _colors.normalizeColor)(props.theme.global.control.border.color || 'border', props.theme);
}, function(props) {
    return props.theme.global.control.border.radius;
});
var edgeStyle = function edgeStyle(kind, data, responsive, responsiveBreakpoint, theme) {
    var breakpoint = responsiveBreakpoint && theme.global.breakpoints[responsiveBreakpoint];
    if (typeof data === 'string') return (0, _styledComponents.css)([
        "",
        ":",
        ";",
        ";"
    ], kind, theme.global.edgeSize[data] || data, responsive && breakpoint ? (0, _mixins.breakpointStyle)(breakpoint, "\n        " + kind + ": " + (breakpoint.edgeSize[data] || data) + ";\n      ", responsive) : '');
    var result = [];
    var horizontal = data.horizontal, vertical = data.vertical, top = data.top, bottom = data.bottom, left = data.left, right = data.right;
    // if horizontal and vertical are equal OR all sides are equal,
    // we can just return a single css value such as padding: 12px
    // instead of breaking out by sides.
    var horizontalVerticalEqual = horizontal && vertical && horizontal === vertical;
    var allSidesEqual = top && bottom && left && right && top === bottom === left === right;
    if (horizontalVerticalEqual || allSidesEqual) {
        // since the values will be the same between vertical & horizontal OR
        // left, right, top, & bottom, we can just choose one
        var value = horizontalVerticalEqual ? horizontal : top;
        return (0, _styledComponents.css)([
            "",
            ":",
            ";",
            ";"
        ], kind, theme.global.edgeSize[value] || value, responsive && breakpoint ? (0, _mixins.breakpointStyle)(breakpoint, "\n        " + kind + ": " + (breakpoint.edgeSize[value] || value) + ";\n      ", responsive) : '');
    }
    if (horizontal) result.push((0, _styledComponents.css)([
        "",
        "-left:",
        ";",
        "-right:",
        ";",
        ";"
    ], kind, theme.global.edgeSize[horizontal] || horizontal, kind, theme.global.edgeSize[horizontal] || horizontal, responsive && breakpoint ? (0, _mixins.breakpointStyle)(breakpoint, "\n          " + kind + "-left: " + (breakpoint.edgeSize[horizontal] || horizontal) + ";\n          " + kind + "-right: " + (breakpoint.edgeSize[horizontal] || horizontal) + ";\n        ", responsive) : ''));
    if (vertical) result.push((0, _styledComponents.css)([
        "",
        "-top:",
        ";",
        "-bottom:",
        ";",
        ";"
    ], kind, theme.global.edgeSize[vertical] || vertical, kind, theme.global.edgeSize[vertical] || vertical, responsive && breakpoint ? (0, _mixins.breakpointStyle)(breakpoint, "\n          " + kind + "-top: " + (breakpoint.edgeSize[vertical] || vertical) + ";\n          " + kind + "-bottom: " + (breakpoint.edgeSize[vertical] || vertical) + ";\n        ", responsive) : ''));
    if (top) result.push((0, _styledComponents.css)([
        "",
        "-top:",
        ";",
        ";"
    ], kind, theme.global.edgeSize[top] || top, responsive && breakpoint ? (0, _mixins.breakpointStyle)(breakpoint, "\n          " + kind + "-top: " + (breakpoint.edgeSize[top] || top) + ";\n        ", responsive) : ''));
    if (bottom) result.push((0, _styledComponents.css)([
        "",
        "-bottom:",
        ";",
        ";"
    ], kind, theme.global.edgeSize[bottom] || bottom, responsive && breakpoint ? (0, _mixins.breakpointStyle)(breakpoint, "\n          " + kind + "-bottom: " + (breakpoint.edgeSize[bottom] || bottom) + ";\n        ", responsive) : ''));
    if (left) result.push((0, _styledComponents.css)([
        "",
        "-left:",
        ";",
        ";"
    ], kind, theme.global.edgeSize[left] || left, responsive && breakpoint ? (0, _mixins.breakpointStyle)(breakpoint, "\n          " + kind + "-left: " + (breakpoint.edgeSize[left] || left) + ";\n        ", responsive) : ''));
    if (right) result.push((0, _styledComponents.css)([
        "",
        "-right:",
        ";",
        ";"
    ], kind, theme.global.edgeSize[right] || right, responsive && breakpoint ? (0, _mixins.breakpointStyle)(breakpoint, "\n          " + kind + "-right: " + (breakpoint.edgeSize[right] || right) + ";\n        ", responsive) : ''));
    if (data.start) result.push((0, _styledComponents.css)([
        "",
        "-inline-start:",
        ";",
        ";"
    ], kind, theme.global.edgeSize[data.start] || data.start, responsive && breakpoint ? (0, _mixins.breakpointStyle)(breakpoint, "\n          " + kind + "-inline-start: " + (breakpoint.edgeSize[data.start] || data.start) + ";\n        ", responsive) : ''));
    if (data.end) result.push((0, _styledComponents.css)([
        "",
        "-inline-end:",
        ";",
        ";"
    ], kind, theme.global.edgeSize[data.end] || data.end, responsive && breakpoint ? (0, _mixins.breakpointStyle)(breakpoint, "\n          " + kind + "-inline-end: " + (breakpoint.edgeSize[data.end] || data.end) + ";\n        ", responsive) : ''));
    return result;
};
var fillStyle = function fillStyle(fillProp) {
    if (fillProp === 'horizontal') return 'width: 100%;';
    if (fillProp === 'vertical') return 'height: 100%;';
    if (fillProp) return "\n      width: 100%;\n      height: 100%;\n    ";
    return undefined;
};
var focusStyles = function focusStyles(props, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, forceOutline = _ref.forceOutline, justBorder = _ref.justBorder;
    var focus = props.theme.global.focus;
    var compoundFocusStyle = '';
    if (!focus || forceOutline && !focus.outline) {
        var color = (0, _colors.normalizeColor)('focus', props.theme);
        if (color) return "outline: 2px solid " + color + ";";
        return ''; // native
    }
    if (focus.outline && (!focus.border || !justBorder)) {
        if (typeof focus.outline === 'object') {
            var _color = (0, _colors.normalizeColor)(focus.outline.color || 'focus', props.theme);
            var size = focus.outline.size || '2px';
            var offset = focus.outline.offset || '0px';
            var outlineStyle = "\n        outline-offset: " + offset + ";\n        outline: " + size + " solid " + _color + ";\n      ";
            compoundFocusStyle += outlineStyle;
            if (!focus.twoColor) return outlineStyle;
        } else {
            var _outlineStyle = "outline: " + focus.outline + ";";
            compoundFocusStyle += _outlineStyle;
            if (!focus.twoColor) return _outlineStyle;
        }
    }
    if (focus.shadow && (!focus.border || !justBorder)) {
        if (typeof focus.shadow === 'object') {
            var _color2 = (0, _colors.normalizeColor)(// If there is a focus.border.color, use that for shadow too.
            // This is for backwards compatibility in v2.
            focus.border && focus.border.color || focus.shadow.color || 'focus', props.theme);
            var _size = focus.shadow.size || '2px'; // backwards compatible default
            var blur = focus.shadow.blur || _size; // backwards compatible default
            var inset = focus.shadow.inset ? 'inset ' : '';
            var shadowStyle = "box-shadow: 0 0 " + blur + " " + _size + " " + _color2 + (inset ? " " + inset : '') + ";";
            compoundFocusStyle += shadowStyle;
            if (!focus.twoColor) return "\n        outline: none;\n      " + shadowStyle;
        } else {
            var _shadowStyle = "box-shadow: " + focus.shadow + ";";
            compoundFocusStyle += _shadowStyle;
            if (!focus.twoColor) return "outline: none; " + _shadowStyle;
        }
    }
    if (focus.border) {
        var _color3 = (0, _colors.normalizeColor)(focus.border.color || 'focus', props.theme);
        var borderStyle = "border-color: " + _color3 + ";";
        compoundFocusStyle += borderStyle;
        if (!focus.twoColor) return "outline: none; " + borderStyle;
    }
    if (focus.twoColor && compoundFocusStyle.length) return compoundFocusStyle;
    return ''; // defensive
};
var unfocusStyles = function unfocusStyles(props, _temp2) {
    var _ref2 = _temp2 === void 0 ? {} : _temp2, forceOutline = _ref2.forceOutline, justBorder = _ref2.justBorder;
    var focus = props.theme.global.focus;
    var compoundFocusStyle = '';
    if (!focus || forceOutline && !focus.outline) {
        var color = (0, _colors.normalizeColor)('focus', props.theme);
        if (color) return "outline: none;";
        return ''; // native
    }
    if (focus.outline && (!focus.border || !justBorder)) {
        if (typeof focus.outline === 'object') {
            var outlineStyle = "\n        outline-offset: 0px;\n        outline: none;\n      ";
            compoundFocusStyle += outlineStyle;
            if (!focus.twoColor) return "\n        outline-offset: 0px;\n        outline: none;\n      ";
        } else {
            var _outlineStyle2 = "outline: none;";
            compoundFocusStyle += _outlineStyle2;
            if (!focus.twoColor) return _outlineStyle2;
        }
    }
    if (focus.shadow && (!focus.border || !justBorder)) {
        if (typeof focus.shadow === 'object') {
            var shadowStyle = "\n        outline: none;\n        box-shadow: none;\n      ";
            compoundFocusStyle += shadowStyle;
            if (!focus.twoColor) return shadowStyle;
        } else {
            var _shadowStyle2 = "\n        outline: none;\n        box-shadow: none;\n      ";
            compoundFocusStyle += _shadowStyle2;
            if (!focus.twoColor) return _shadowStyle2;
        }
    }
    if (focus.border) {
        var borderStyle = "\n      outline: none;\n      border-color: none;\n    ";
        compoundFocusStyle += borderStyle;
        if (!focus.twoColor) return borderStyle;
    }
    if (focus.twoColor && compoundFocusStyle.length) return compoundFocusStyle;
    return ''; // defensive
};
var focusStyle = function focusStyle(_temp3) {
    var _ref3 = _temp3 === void 0 ? {} : _temp3, forceOutline = _ref3.forceOutline, justBorder = _ref3.justBorder, skipSvgChildren = _ref3.skipSvgChildren;
    return (0, _styledComponents.css)([
        "",
        " ",
        " ",
        ""
    ], function(props) {
        return !skipSvgChildren && "\n  > circle,\n  > ellipse,\n  > line,\n  > path,\n  > polygon,\n  > polyline,\n  > rect {\n    " + focusStyles(props) + "\n  }";
    }, function(props) {
        return focusStyles(props, {
            forceOutline: forceOutline,
            justBorder: justBorder
        });
    }, !forceOutline && "\n  ::-moz-focus-inner {\n    border: 0;\n  }\n  ");
};
var unfocusStyle = function unfocusStyle(_temp4) {
    var _ref4 = _temp4 === void 0 ? {} : _temp4, forceOutline = _ref4.forceOutline, justBorder = _ref4.justBorder, skipSvgChildren = _ref4.skipSvgChildren;
    return (0, _styledComponents.css)([
        "",
        " ",
        " ",
        ""
    ], function(props) {
        return !skipSvgChildren && "\n  > circle,\n  > ellipse,\n  > line,\n  > path,\n  > polygon,\n  > polyline,\n  > rect {\n    " + unfocusStyles(props) + "\n  }";
    }, function(props) {
        return unfocusStyles(props, {
            forceOutline: forceOutline,
            justBorder: justBorder
        });
    }, !forceOutline && "\n  ::-moz-focus-inner {\n    border: 0;\n  }\n  ");
};
// For backwards compatibility we need to add back the control border width.
// Based on how grommet was functioning prior to https://github.com/grommet/grommet/pull/3939,
// the padding was subtracting the border width from the theme value, but the
// placeholder was not. Because we're now placing the subtraction into the
// theme itself, we have to add back in the border width here.
// This is used for placeholder/icon in TextInput and MaskedInput.
var adjustPad = function adjustPad(props, value) {
    return (0, _mixins.parseMetricToNum)((props.theme.global.edgeSize[value] || value) + "px") + (0, _mixins.parseMetricToNum)(props.theme.global.control.border.width + "px") + "px";
};
var getInputPadBySide = function getInputPadBySide(props, side) {
    if (typeof props.theme.global.input.padding !== 'object') {
        var _adjustedPad = adjustPad(props, props.theme.global.input.padding);
        return _adjustedPad;
    }
    var orientation;
    if (side === 'left' || side === 'right') orientation = 'horizontal';
    else if (side === 'top' || side === 'bottom') orientation = 'vertical';
    else orientation = undefined;
    // if individual side isn't available, fallback to the
    // orientation if possible
    var pad = props.theme.global.input.padding[side] || props.theme.global.input.padding[orientation];
    var adjustedPad = adjustPad(props, pad);
    return adjustedPad;
};
var placeholderColor = (0, _styledComponents.css)([
    "color:",
    ";"
], function(props) {
    return (0, _colors.normalizeColor)(props.theme.global.colors.placeholder, props.theme);
});
var placeholderStyle = (0, _styledComponents.css)([
    "&::-webkit-input-placeholder{",
    ";}&::-moz-placeholder{",
    ";}&:-ms-input-placeholder{",
    ";}"
], placeholderColor, placeholderColor, placeholderColor);
var inputSizeStyle = function inputSizeStyle(props) {
    var data = props.theme.text[props.size];
    if (!data) return (0, _styledComponents.css)([
        "font-size:",
        ";"
    ], props.size);
    return (0, _styledComponents.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, data.height);
};
var inputStyle = (0, _styledComponents.css)([
    "box-sizing:border-box;",
    " font-family:inherit;border:none;-webkit-appearance:none;background:transparent;color:inherit;width:100%;",
    " ",
    " ",
    " margin:0;",
    " &:focus{",
    ";}",
    " ",
    " ::-webkit-search-decoration{-webkit-appearance:none;}&::-moz-focus-inner{border:none;outline:none;}&:-moz-placeholder,&::-moz-placeholder{opacity:1;}",
    ""
], function(props) {
    var _props$theme$text$pro;
    return "font-size: " + (props.theme.global.input.font.size ? ((_props$theme$text$pro = props.theme.text[props.theme.global.input.font.size]) == null ? void 0 : _props$theme$text$pro.size) || props.theme.global.input.font.size : 'inherit') + ";";
}, function(props) {
    return props.theme.global.input.font.height && "line-height: " + props.theme.global.input.font.height + ";";
}, function(props) {
    return props.theme.global.input.padding && typeof props.theme.global.input.padding !== 'object' ? // just the edgeStyle could remain. Currently, this is needed for
    // backwards compatibility since we are placing the calculation in
    // base.js
    "padding: " + ((0, _mixins.parseMetricToNum)(props.theme.global.edgeSize[props.theme.global.input.padding] || props.theme.global.input.padding) - (0, _mixins.parseMetricToNum)(props.theme.global.control.border.width)) + "px;" : edgeStyle('padding', props.theme.global.input.padding, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return(// for backwards compatibility, check if props.theme.global.input.weight
    (props.theme.global.input.weight || props.theme.global.input.font.weight) && (0, _styledComponents.css)([
        "font-weight:",
        ";"
    ], props.theme.global.input.weight || props.theme.global.input.font.weight));
}, function(props) {
    return props.size && inputSizeStyle(props);
}, function(props) {
    return (!props.plain || props.focusIndicator) && focusStyle();
}, controlBorderStyle, placeholderStyle, function(props) {
    return props.theme.global.input.extend;
});
var inputPadForIcon = (0, _styledComponents.css)([
    "",
    ""
], function(props) {
    var _props$theme, _props$theme$icon;
    var pad = (_props$theme = props.theme) != null && (_props$theme = _props$theme.icon) != null && _props$theme.matchSize ? (0, _mixins.parseMetricToNum)((_props$theme$icon = props.theme.icon) == null || (_props$theme$icon = _props$theme$icon.size) == null ? void 0 : _props$theme$icon[(props == null ? void 0 : props.size) || 'medium']) + (0, _mixins.parseMetricToNum)(props.theme.global.edgeSize.medium) + "px" : props.theme.global.edgeSize.large;
    return props.reverse ? "padding-right: " + pad + ";" : "padding-left: " + pad + ";";
});
var overflowStyle = function overflowStyle(overflowProp) {
    if (typeof overflowProp === 'string') return (0, _styledComponents.css)([
        "overflow:",
        ";"
    ], overflowProp);
    return (0, _styledComponents.css)([
        "",
        " ",
        ";"
    ], overflowProp.horizontal && "overflow-x: " + overflowProp.horizontal + ";", overflowProp.vertical && "overflow-y: " + overflowProp.vertical + ";");
};
var ALIGN_SELF_MAP = {
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch',
    baseline: 'baseline'
};
var genericStyles = (0, _styledComponents.css)([
    "",
    " ",
    " ",
    ""
], function(props) {
    return props.alignSelf && "align-self: " + ALIGN_SELF_MAP[props.alignSelf] + ";";
}, function(props) {
    return props.gridArea && "grid-area: " + props.gridArea + ";";
}, function(props) {
    return props.margin && props.theme.global && edgeStyle('margin', props.margin, props.responsive, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
});
var disabledStyle = function disabledStyle(componentStyle) {
    return (0, _styledComponents.css)([
        "opacity:",
        ";cursor:default;"
    ], function(props) {
        return componentStyle || props.theme.global.control.disabled.opacity;
    });
};
var sizeStyle = function sizeStyle(name, value, theme) {
    return (0, _styledComponents.css)([
        "",
        ":",
        ";"
    ], name, theme.global.size[value] || value);
};
var plainInputStyle = (0, _styledComponents.css)([
    "outline:none;border:none;"
]);
var elevationStyle = function elevationStyle(elevation) {
    return (0, _styledComponents.css)([
        "box-shadow:",
        ";"
    ], function(props) {
        return props.theme.global.elevation[props.theme.dark ? 'dark' : 'light'][elevation];
    });
};
var kindPartStyles = function kindPartStyles(obj, theme, colorValue) {
    var styles = [];
    if (obj.padding || obj.pad) {
        // button uses `padding` but other components use Grommet `pad`
        var pad = obj.padding || obj.pad;
        if (pad.vertical || pad.horizontal) styles.push("padding: " + (theme.global.edgeSize[pad.vertical] || pad.vertical || 0) + " " + (theme.global.edgeSize[pad.horizontal] || pad.horizontal || 0) + ";");
        else styles.push("padding: " + (theme.global.edgeSize[pad] || pad || 0) + ";");
    }
    if (obj.background) styles.push((0, _background.backgroundStyle)(colorValue || obj.background, theme, obj.color || (Object.prototype.hasOwnProperty.call(obj, 'color') && obj.color === undefined ? false : undefined)));
    else if (obj.color) styles.push("color: " + (0, _colors.normalizeColor)(obj.color, theme) + ";");
    if (obj.border) {
        if (obj.border.width) styles.push((0, _styledComponents.css)([
            "border-style:solid;border-width:",
            ";"
        ], obj.border.width));
        if (obj.border.color) styles.push((0, _styledComponents.css)([
            "border-color:",
            ";"
        ], (0, _colors.normalizeColor)(!obj.background && colorValue || obj.border.color || 'border', theme)));
        if (obj.border.radius) styles.push((0, _styledComponents.css)([
            "border-radius:",
            ";"
        ], obj.border.radius));
    } else if (obj.border === false) styles.push('border: none;');
    if (colorValue && !obj.border && !obj.background) styles.push("color: " + (0, _colors.normalizeColor)(colorValue, theme) + ";");
    if (obj.font) {
        if (obj.font.size) styles.push("font-size: " + (theme.text[obj.font.size].size || obj.font.size) + ";");
        if (obj.font.height) styles.push("line-height: " + obj.font.height + ";");
        if (obj.font.weight) styles.push("font-weight: " + obj.font.weight + ";");
    }
    if (obj.opacity) {
        var opacity = obj.opacity === true ? theme.global.opacity.medium : theme.global.opacity[obj.opacity] || obj.opacity;
        styles.push("opacity: " + opacity + ";");
    }
    if (obj.elevation) styles.push(elevationStyle(obj.elevation));
    if (obj.extend) styles.push(obj.extend);
    return styles;
};
var ROUND_MAP = {
    full: '100%'
};
var roundStyle = function roundStyle(data, responsive, theme) {
    var breakpoint = (0, _responsive.getBreakpointStyle)(theme, theme.box.responsiveBreakpoint);
    // fallback to edgeSize for backwards compatibility
    var radius = theme.global.radius ? 'radius' : 'edgeSize';
    var styles = [];
    if (typeof data === 'object') {
        var _breakpoint$radius;
        var size = ROUND_MAP[data.size] || theme.global[radius][data.size || 'medium'] || data.size;
        var responsiveSize = responsive && breakpoint && ((_breakpoint$radius = breakpoint[radius]) == null ? void 0 : _breakpoint$radius[data.size]) && (breakpoint[radius][data.size] || data.size);
        if (data.corner === 'top') {
            styles.push((0, _styledComponents.css)([
                "border-top-left-radius:",
                ";border-top-right-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, _mixins.breakpointStyle)(breakpoint, "\n          border-top-left-radius: " + responsiveSize + ";\n          border-top-right-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner === 'bottom') {
            styles.push((0, _styledComponents.css)([
                "border-bottom-left-radius:",
                ";border-bottom-right-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, _mixins.breakpointStyle)(breakpoint, "\n          border-bottom-left-radius: " + responsiveSize + ";\n          border-bottom-right-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner === 'left') {
            styles.push((0, _styledComponents.css)([
                "border-top-left-radius:",
                ";border-bottom-left-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, _mixins.breakpointStyle)(breakpoint, "\n          border-top-left-radius: " + responsiveSize + ";\n          border-bottom-left-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner === 'right') {
            styles.push((0, _styledComponents.css)([
                "border-top-right-radius:",
                ";border-bottom-right-radius:",
                ";"
            ], size, size));
            if (responsiveSize) styles.push((0, _mixins.breakpointStyle)(breakpoint, "\n          border-top-right-radius: " + responsiveSize + ";\n          border-bottom-right-radius: " + responsiveSize + ";\n        ", responsive));
        } else if (data.corner) {
            styles.push((0, _styledComponents.css)([
                "border-",
                "-radius:",
                ";"
            ], data.corner, size));
            if (responsiveSize) styles.push((0, _mixins.breakpointStyle)(breakpoint, "\n          border-" + data.corner + "-radius: " + responsiveSize + ";\n        ", responsive));
        } else {
            styles.push((0, _styledComponents.css)([
                "border-radius:",
                ";"
            ], size));
            if (responsiveSize) styles.push((0, _mixins.breakpointStyle)(breakpoint, "\n          border-radius: " + responsiveSize + ";\n        ", responsive));
        }
    } else {
        var _theme$global$radius, _breakpoint$radius2;
        var _size2 = data === true ? 'medium' : data;
        styles.push((0, _styledComponents.css)([
            "border-radius:",
            ";"
        ], ROUND_MAP[_size2] || ((_theme$global$radius = theme.global[radius]) == null ? void 0 : _theme$global$radius[_size2]) || _size2));
        var _responsiveSize = responsive && breakpoint && ((_breakpoint$radius2 = breakpoint[radius]) == null ? void 0 : _breakpoint$radius2[_size2]);
        if (_responsiveSize) styles.push((0, _mixins.breakpointStyle)(breakpoint, "\n        border-radius: " + _responsiveSize + ";\n      ", responsive));
    }
    return styles;
};
var TEXT_ALIGN_MAP = {
    center: 'center',
    end: 'right',
    justify: 'justify',
    start: 'left'
};
var textAlignStyle = (0, _styledComponents.css)([
    "text-align:",
    ";"
], function(props) {
    return TEXT_ALIGN_MAP[props.textAlign];
});
var ALIGN_ITEMS_MAP = {
    baseline: 'baseline',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var alignStyle = (0, _styledComponents.css)([
    "align-items:",
    ";"
], function(props) {
    var _ALIGN_ITEMS_MAP$prop;
    return (_ALIGN_ITEMS_MAP$prop = ALIGN_ITEMS_MAP[props.align]) != null ? _ALIGN_ITEMS_MAP$prop : props.align;
});
var ALIGN_CONTENT_MAP = {
    around: 'space-around',
    baseline: 'baseline',
    between: 'space-between',
    center: 'center',
    evenly: 'space-evenly',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var alignContentStyle = (0, _styledComponents.css)([
    "align-content:",
    ";"
], function(props) {
    var _ALIGN_CONTENT_MAP$pr;
    return (_ALIGN_CONTENT_MAP$pr = ALIGN_CONTENT_MAP[props.alignContent]) != null ? _ALIGN_CONTENT_MAP$pr : props.alignContent;
});
var getSize = function getSize(theme, size) {
    return theme.global.size[size] || size;
};
var widthObjectStyle = function widthObjectStyle(width, theme) {
    var result = [];
    if (width.max) result.push((0, _styledComponents.css)([
        "max-width:",
        ";"
    ], getSize(theme, width.max)));
    if (width.min) result.push((0, _styledComponents.css)([
        "min-width:",
        ";"
    ], getSize(theme, width.min)));
    if (width.width) result.push((0, _styledComponents.css)([
        "width:",
        ";"
    ], getSize(theme, width.width)));
    return result;
};
var widthStringStyle = function widthStringStyle(width, theme) {
    return (0, _styledComponents.css)([
        "width:",
        ";"
    ], getSize(theme, width));
};
var widthStyle = function widthStyle(width, theme) {
    return typeof width === 'object' ? widthObjectStyle(width, theme) : widthStringStyle(width, theme);
};
var heightObjectStyle = function heightObjectStyle(height, theme) {
    var result = [];
    if (height.max) result.push((0, _styledComponents.css)([
        "max-height:",
        ";"
    ], getSize(theme, height.max)));
    if (height.min) result.push((0, _styledComponents.css)([
        "min-height:",
        ";"
    ], getSize(theme, height.min)));
    // backwards compatibile
    if (height.width) result.push((0, _styledComponents.css)([
        "height:",
        ";"
    ], getSize(theme, height.height)));
    if (height.height) result.push((0, _styledComponents.css)([
        "height:",
        ";"
    ], getSize(theme, height.height)));
    return result;
};
var heightStringStyle = function heightStringStyle(height, theme) {
    return (0, _styledComponents.css)([
        "height:",
        ";"
    ], getSize(theme, height));
};
var heightStyle = function heightStyle(height, theme) {
    return typeof height === 'object' ? heightObjectStyle(height, theme) : heightStringStyle(height, theme);
};

},{"styled-components":"6bGrk","@emotion/is-prop-valid":"db6x2","./background":"bX8Dm","./colors":"f3J10","./responsive":"6Wzh6","./mixins":"gx4wP","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"db6x2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isPropValid);
var _memoize = require("@emotion/memoize");
var _memoizeDefault = parcelHelpers.interopDefault(_memoize);
// eslint-disable-next-line no-undef
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var isPropValid = /* #__PURE__ */ (0, _memoizeDefault.default)(function(prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

},{"@emotion/memoize":"J8SEu","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"J8SEu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>memoize);
function memoize(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6Wzh6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBreakpoint", ()=>getBreakpoint);
parcelHelpers.export(exports, "getDeviceBreakpoint", ()=>getDeviceBreakpoint);
parcelHelpers.export(exports, "getBreakpointStyle", ()=>getBreakpointStyle);
parcelHelpers.export(exports, "isSmall", ()=>isSmall);
parcelHelpers.export(exports, "deviceResponsive", ()=>deviceResponsive);
parcelHelpers.export(exports, "supportsContainerQueries", ()=>supportsContainerQueries);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var getBreakpoint = function getBreakpoint(viewportWidth, theme) {
    var sortedBreakpoints = Object.keys(theme.global.breakpoints).sort(function(a, b) {
        var first = theme.global.breakpoints[a];
        var second = theme.global.breakpoints[b];
        if (!first) return 1;
        if (!second) return -1;
        if (!first.value) return 1;
        if (!second.value) return -1;
        return first.value - second.value;
    });
    // the last breakpoint on the sorted array should have
    // no windowWidth boundaries
    var lastBreakpoint = sortedBreakpoints[sortedBreakpoints.length - 1];
    var result = sortedBreakpoints.find(function(name) {
        var breakpoint = theme.global.breakpoints[name];
        return !breakpoint.value || breakpoint.value >= viewportWidth ? name : false;
    });
    return result || lastBreakpoint;
};
var getDeviceBreakpoint = function getDeviceBreakpoint(type, theme) {
    return theme.global.deviceBreakpoints[type];
};
var getBreakpointStyle = function getBreakpointStyle(theme, breakpointSize) {
    var breakpoint = breakpointSize && theme.global.breakpoints[breakpointSize] || {};
    if (!breakpoint.edgeSize) breakpoint.edgeSize = theme.global.edgeSize;
    if (!breakpoint.borderSize) breakpoint.borderSize = theme.global.borderSize;
    if (!breakpoint.radius) breakpoint.radius = theme.global.radius;
    if (!breakpoint.size) breakpoint.size = theme.global.size;
    return breakpoint;
};
var isSmall = function isSmall(size) {
    return [
        'xsmall',
        'small'
    ].includes(size);
};
var deviceResponsive = function deviceResponsive(userAgent, theme) {
    // log('--deviceResponsive', userAgent, theme);
    /*
   * Regexes provided for mobile and tablet detection are meant to replace
   * a full-featured specific library due to contributing a considerable size
   * into the bundle.
   *
   * User agents found https://deviceatlas.com/blog/list-of-user-agent-strings
   */ if (userAgent) {
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobile))/i.test(userAgent)) return getDeviceBreakpoint('tablet', theme);
        if (/Mobile|iPhone|Android/.test(userAgent)) return getDeviceBreakpoint('phone', theme);
        return getDeviceBreakpoint('computer', theme);
    }
    return undefined;
};
// styled-components v6 and later do not have a withComponent
// method. We need v6 or later to support container queries.
var testComp = (0, _styledComponentsDefault.default).div.withConfig({
    displayName: "responsive__testComp",
    componentId: "sc-336m7y-0"
})([
    "display:flex;"
]);
var supportsContainerQueries = function supportsContainerQueries() {
    var isPreV6 = typeof testComp.withComponent === 'function';
    return !isPreV6;
};

},{"styled-components":"6bGrk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"go0Cn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "deepFreeze", ()=>deepFreeze);
parcelHelpers.export(exports, "deepMerge", ()=>_deepMerge);
parcelHelpers.export(exports, "removeUndefined", ()=>removeUndefined);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var isObject = function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
};
var deepFreeze = function deepFreeze(obj) {
    Object.keys(obj).forEach(function(key) {
        return key && isObject(obj[key]) && Object.freeze(obj[key]);
    });
    return Object.freeze(obj);
};
var _deepMerge = function deepMerge(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    // making sure to not change target (immutable)
    var output = _extends({}, target);
    sources.forEach(function(source) {
        if (isObject(source)) Object.keys(source).forEach(function(key) {
            if (isObject(source[key])) {
                if (!output[key]) output[key] = _extends({}, source[key]);
                else output[key] = _deepMerge(output[key], source[key]);
            } else output[key] = source[key];
        });
    });
    return output;
};
var removeUndefined = function removeUndefined(obj) {
    var result = {};
    Object.keys(obj).forEach(function(key) {
        if (obj[key] !== undefined) result[key] = obj[key];
    });
    return result;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dLXd6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PortalContext", ()=>PortalContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var PortalContext = /*#__PURE__*/ (0, _reactDefault.default).createContext([]);

},{"react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fhTT5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readOnlyStyle", ()=>readOnlyStyle);
var _styledComponents = require("styled-components");
var _background = require("./background");
var _colors = require("./colors");
var readOnlyStyle = function readOnlyStyle(theme) {
    var _theme$global$input$r, _theme$global$input$r2, _theme$global$input$r3;
    var styles = [];
    if (theme != null && (_theme$global$input$r = theme.global.input.readOnly) != null && (_theme$global$input$r = _theme$global$input$r.border) != null && _theme$global$input$r.color) styles.push((0, _styledComponents.css)([
        "border-color:",
        ";"
    ], (0, _colors.normalizeColor)(theme.global.input.readOnly.border.color, theme)));
    if (theme != null && (_theme$global$input$r2 = theme.global.input.readOnly) != null && _theme$global$input$r2.background) styles.push((0, _background.backgroundStyle)((_theme$global$input$r3 = theme.global.input.readOnly) == null ? void 0 : _theme$global$input$r3.background, theme));
    return styles;
};

},{"styled-components":"6bGrk","./background":"bX8Dm","./colors":"f3J10","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jeN98":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useForwardedRef", ()=>useForwardedRef);
var _react = require("react");
var useForwardedRef = function useForwardedRef(ref) {
    var innerRef = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(ref, function() {
        return innerRef.current;
    }, [
        innerRef
    ]);
    return innerRef;
};

},{"react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hlK0O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useKeyboard", ()=>useKeyboard);
var _react = require("react");
var useKeyboard = function useKeyboard() {
    var _useState = (0, _react.useState)(), usingKeyboard = _useState[0], setUsingKeyboard = _useState[1];
    (0, _react.useEffect)(function() {
        var onMouseDown = function onMouseDown() {
            return setUsingKeyboard(false);
        };
        var onKeyDown = function onKeyDown() {
            return setUsingKeyboard(true);
        };
        document.addEventListener('mousedown', onMouseDown);
        document.addEventListener('keydown', onKeyDown);
        return function() {
            document.removeEventListener('mousedown', onMouseDown);
            document.removeEventListener('keydown', onKeyDown);
        };
    }, []);
    return usingKeyboard;
};
exports.default = useKeyboard;

},{"react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1MZHF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeContextPropTypes", ()=>ThemeContextPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PropType = {};
var ThemeContextPropTypes = PropType;

},{"prop-types":"j03Ye","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fQIua":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base", ()=>(0, _base.base));
parcelHelpers.export(exports, "generate", ()=>(0, _base.generate));
parcelHelpers.export(exports, "grommet", ()=>(0, _grommet.grommet));
parcelHelpers.export(exports, "dark", ()=>(0, _dark.dark));
parcelHelpers.export(exports, "hacktoberfest2022", ()=>(0, _hacktoberfest2022.hacktoberfest2022));
var _base = require("./base");
var _grommet = require("./grommet");
var _dark = require("./dark");
var _hacktoberfest2022 = require("./hacktoberfest2022");

},{"./base":"7ra6d","./grommet":"jbZCB","./dark":false,"./hacktoberfest2022":false,"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7ra6d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generate", ()=>generate);
parcelHelpers.export(exports, "base", ()=>base);
var _actions = require("grommet-icons/icons/Actions");
var _assistListening = require("grommet-icons/icons/AssistListening");
var _circleInformation = require("grommet-icons/icons/CircleInformation");
var _closedCaption = require("grommet-icons/icons/ClosedCaption");
var _expand = require("grommet-icons/icons/Expand");
var _formClose = require("grommet-icons/icons/FormClose");
var _formDown = require("grommet-icons/icons/FormDown");
var _formNext = require("grommet-icons/icons/FormNext");
var _formPrevious = require("grommet-icons/icons/FormPrevious");
var _formUp = require("grommet-icons/icons/FormUp");
var _next = require("grommet-icons/icons/Next");
var _pause = require("grommet-icons/icons/Pause");
var _play = require("grommet-icons/icons/Play");
var _formPin = require("grommet-icons/icons/FormPin");
var _previous = require("grommet-icons/icons/Previous");
var _statusCriticalSmall = require("grommet-icons/icons/StatusCriticalSmall");
var _statusGoodSmall = require("grommet-icons/icons/StatusGoodSmall");
var _statusWarningSmall = require("grommet-icons/icons/StatusWarningSmall");
var _statusUnknownSmall = require("grommet-icons/icons/StatusUnknownSmall");
var _subtract = require("grommet-icons/icons/Subtract");
var _volume = require("grommet-icons/icons/Volume");
var _volumeLow = require("grommet-icons/icons/VolumeLow");
var _base = require("grommet-icons/themes/base");
var _object = require("../utils/object");
var _mixins = require("../utils/mixins");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var brandColor = '#7D4CDB';
var accentColors = [
    '#6FFFB0',
    '#FD6FFF',
    '#81FCED',
    '#FFCA58'
];
var neutralColors = [
    '#00873D',
    '#3D138D',
    '#00739D',
    '#A2423D'
];
var statusColors = {
    critical: '#EB0000',
    error: '#B30000',
    warning: '#C27B00',
    ok: '#009E67',
    unknown: '#919191',
    disabled: '#CCCCCC'
};
var darkColors = [
    '#333333',
    '#555555',
    '#777777',
    '#999999',
    '#999999',
    '#999999'
];
var lightColors = [
    '#F8F8F8',
    '#F2F2F2',
    '#EDEDED',
    '#DADADA',
    '#DADADA',
    '#DADADA'
];
var focusColor = accentColors[0];
var colors = {
    active: 'rgba(221, 221, 221, 0.5)',
    'background-back': {
        dark: '#33333308',
        light: '#EDEDED'
    },
    'background-front': {
        dark: '#444444',
        light: '#FFFFFF'
    },
    'background-contrast': {
        light: '#33333310',
        dark: '#FFFFFF18'
    },
    'active-background': 'background-contrast',
    'active-text': 'text-strong',
    black: '#000000',
    border: {
        dark: 'rgba(255, 255, 255, 0.33)',
        light: 'rgba(0, 0, 0, 0.33)'
    },
    brand: brandColor,
    control: {
        dark: 'accent-1',
        light: 'brand'
    },
    focus: focusColor,
    'graph-0': 'accent-1',
    'graph-1': 'neutral-1',
    'graph-2': 'neutral-2',
    'graph-3': 'neutral-3',
    'graph-4': 'neutral-4',
    placeholder: '#AAAAAA',
    selected: 'brand',
    text: {
        dark: '#f8f8f8',
        light: '#444444'
    },
    'text-strong': {
        dark: '#FFFFFF',
        light: '#000000'
    },
    'text-weak': {
        dark: '#CCCCCC',
        light: '#555555'
    },
    'text-xweak': {
        dark: '#BBBBBB',
        light: '#666666'
    },
    icon: {
        dark: '#f8f8f8',
        light: '#666666'
    },
    'selected-background': 'brand',
    'selected-text': 'text-strong',
    white: '#FFFFFF'
};
var colorArray = function colorArray(array, prefix) {
    return array.forEach(function(color, index) {
        colors[prefix + "-" + (index + 1)] = color;
    });
};
colorArray(accentColors, 'accent');
colorArray(darkColors, 'dark');
colorArray(lightColors, 'light');
colorArray(neutralColors, 'neutral');
Object.keys(statusColors).forEach(function(color) {
    colors["status-" + color] = statusColors[color];
});
var generate = function generate(baseSpacing, scale) {
    if (baseSpacing === void 0) baseSpacing = 24;
    if (scale === void 0) scale = 6;
    // 24
    var baseFontSize = baseSpacing * 0.75; // 18
    var fontScale = baseSpacing / scale; // 4
    var fontSizing = function fontSizing(factor) {
        return {
            size: baseFontSize + factor * fontScale + "px",
            height: baseSpacing + factor * fontScale + "px",
            // maxWidth chosen to be ~50 characters wide
            // see: https://ux.stackexchange.com/a/34125
            maxWidth: baseSpacing * (baseFontSize + factor * fontScale) + "px"
        };
    };
    var borderWidth = 2;
    var controlBorderWidth = 1;
    var result = (0, _object.deepMerge)((0, _base.base), {
        global: {
            active: {
                background: {
                    color: 'active',
                    opacity: 'medium'
                },
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            animation: {
                duration: '1s',
                jiggle: {
                    duration: '0.1s'
                }
            },
            // backgrounds: undefined,
            borderSize: {
                xsmall: '1px',
                small: '2px',
                medium: baseSpacing / 6 + "px",
                // 4
                large: baseSpacing / 2 + "px",
                // 12
                xlarge: baseSpacing + "px" // 24
            },
            breakpoints: {
                small: {
                    value: baseSpacing * 32,
                    // 768
                    borderSize: {
                        xsmall: '1px',
                        small: '2px',
                        medium: baseSpacing / 6 + "px",
                        // 4
                        large: baseSpacing / 4 + "px",
                        // 6
                        xlarge: baseSpacing / 2 + "px" // 12
                    },
                    edgeSize: {
                        none: '0px',
                        hair: '1px',
                        // for Chart
                        xxsmall: '2px',
                        xsmall: baseSpacing / 8 + "px",
                        // 3
                        small: baseSpacing / 4 + "px",
                        // 6
                        medium: baseSpacing / 2 + "px",
                        // 12
                        large: baseSpacing + "px",
                        // 24
                        xlarge: baseSpacing * 2 + "px" // 48
                    },
                    // radius: {},
                    size: {
                        xxsmall: baseSpacing + "px",
                        // 24
                        xsmall: baseSpacing * 2 + "px",
                        // 48
                        small: baseSpacing * 4 + "px",
                        // 96
                        medium: baseSpacing * 8 + "px",
                        // 192
                        large: baseSpacing * 16 + "px",
                        // 384
                        xlarge: baseSpacing * 32 + "px",
                        // 768
                        full: '100%'
                    }
                },
                medium: {
                    value: baseSpacing * 64 // 1536
                },
                large: {} // anything above 'medium'
            },
            // Breakpoints used at Server Side Rendering for the initial rendering
            // These values correspond to the theme breakpoints
            deviceBreakpoints: {
                phone: 'small',
                tablet: 'medium',
                computer: 'large'
            },
            colors: colors,
            control: {
                border: {
                    width: controlBorderWidth + "px",
                    radius: '4px',
                    color: 'border'
                },
                disabled: {
                    opacity: 0.3
                }
            },
            // The time to wait after the user stopped typing, measured in ms.
            // A half second (500ms) debounce can be a helpful starting point.
            // You want to give the user time to fill out a field, but capture
            // their attention before they move on past it. 2 second (2000ms)
            // might be too long depending on how fast people type, and 200ms
            // would be an eye blink
            debounceDelay: 500,
            drop: {
                // intelligentMargin: undefined,
                background: {
                    dark: 'black',
                    light: 'white'
                },
                border: {
                    radius: '0px'
                },
                // margin: undefined
                shadowSize: 'small',
                // shadowSize is deprecated, use 'elevation'
                zIndex: '20'
            },
            edgeSize: {
                none: '0px',
                hair: '1px',
                // for Chart
                xxsmall: baseSpacing / 8 + "px",
                // 3
                xsmall: baseSpacing / 4 + "px",
                // 6
                small: baseSpacing / 2 + "px",
                // 12
                medium: baseSpacing + "px",
                // 24
                large: baseSpacing * 2 + "px",
                // 48
                xlarge: baseSpacing * 4 + "px",
                // 96
                responsiveBreakpoint: 'small'
            },
            elevation: {
                light: {
                    none: 'none',
                    xsmall: '0px 1px 2px rgba(0, 0, 0, 0.20)',
                    small: '0px 2px 4px rgba(0, 0, 0, 0.20)',
                    medium: '0px 4px 8px rgba(0, 0, 0, 0.20)',
                    large: '0px 8px 16px rgba(0, 0, 0, 0.20)',
                    xlarge: '0px 12px 24px rgba(0, 0, 0, 0.20)'
                },
                dark: {
                    none: 'none',
                    xsmall: '0px 2px 2px rgba(255, 255, 255, 0.40)',
                    small: '0px 4px 4px rgba(255, 255, 255, 0.40)',
                    medium: '0px 6px 8px rgba(255, 255, 255, 0.40)',
                    large: '0px 8px 16px rgba(255, 255, 255, 0.40)',
                    xlarge: '0px 12px 24px rgba(255, 255, 255, 0.40)'
                }
            },
            focus: {
                // shadow or outline are required for accessibility
                border: {
                    // remove to only have shadow
                    color: 'focus'
                },
                // outline: { color: undefined, size: undefined },
                shadow: {
                    color: 'focus',
                    size: '2px'
                },
                twoColor: undefined
            },
            font: _extends({}, fontSizing(0)),
            hover: {
                background: {
                    color: 'active',
                    opacity: 'medium'
                },
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            input: {
                padding: {
                    horizontal: (0, _mixins.parseMetricToNum)(baseSpacing / 2 + "px") - (0, _mixins.parseMetricToNum)(controlBorderWidth + "px") + "px",
                    vertical: (0, _mixins.parseMetricToNum)(baseSpacing / 2 + "px") - (0, _mixins.parseMetricToNum)(controlBorderWidth + "px") + "px"
                },
                font: {
                    // size: undefined,
                    // height: undefined,
                    weight: 600
                },
                // deprecate in v3
                // weight: undefined,
                readOnly: {
                }
            },
            opacity: {
                strong: 0.8,
                medium: 0.4,
                weak: 0.1
            },
            // radius: {},
            selected: {
                background: 'selected',
                color: 'white'
            },
            spacing: baseSpacing + "px",
            size: {
                xxsmall: baseSpacing * 2 + "px",
                // 48
                xsmall: baseSpacing * 4 + "px",
                // 96
                small: baseSpacing * 8 + "px",
                // 192
                medium: baseSpacing * 16 + "px",
                // 384
                large: baseSpacing * 32 + "px",
                // 768
                xlarge: baseSpacing * 48 + "px",
                // 1152
                xxlarge: baseSpacing * 64 + "px",
                // 1536
                full: '100%'
            }
        },
        // icon: {
        //   extennd: undefined,
        //   matchSize: undefined,
        //   size: undefined,
        // },
        accordion: {
            panel: {
            },
            border: {
                side: 'bottom',
                color: 'border'
            },
            heading: {
                level: '4' // level ranges from 1-6
            },
            hover: {
                // background: undefined,
                color: {
                    dark: 'light-4',
                    light: 'dark-3'
                },
                // deprecated
                heading: {
                    color: {
                        dark: 'light-4',
                        light: 'dark-3'
                    }
                }
            },
            icons: {
                collapse: (0, _formUp.FormUp),
                expand: (0, _formDown.FormDown)
            }
        },
        anchor: {
            color: {
                dark: 'accent-1',
                light: 'brand'
            },
            gap: 'small',
            hover: {
                textDecoration: 'underline'
            },
            // icon: {
            //   color: undefined
            // },
            textDecoration: 'none',
            fontWeight: 600
        },
        avatar: {
            // extend: undefined,
            size: {
                xsmall: baseSpacing * 0.75 + "px",
                // 18px
                small: baseSpacing + "px",
                // 24px
                medium: baseSpacing * 2 + "px",
                // default 48px
                large: baseSpacing * 3 + "px",
                // 72px
                xlarge: baseSpacing * 4 + "px",
                // 96px
                '2xl': baseSpacing * 5 + "px",
                // 120px
                '3xl': baseSpacing * 6 + "px",
                // 144px
                '4xl': baseSpacing * 7 + "px",
                // 168px
                '5xl': baseSpacing * 8 + "px" // 192px
            },
            text: {
                size: {
                    xsmall: 'small',
                    // 14px
                    small: 'medium',
                    // 18px
                    medium: 'large',
                    // 22px
                    large: 'xlarge',
                    // 26px
                    xlarge: 'xxlarge',
                    // 34px
                    '2xl': '3xl',
                    // 42px
                    '3xl': '4xl',
                    // 54px
                    '4xl': '5xl',
                    // 70px
                    '5xl': '6xl' // 90px
                }
            }
        },
        box: {
            responsiveBreakpoint: 'small' // when we switch rows to columns
        },
        button: {
            intelligentPad: true,
            // background: undefined,
            badge: {
                // align: undefined,,
                container: {
                    background: 'brand'
                },
                size: {
                    medium: baseSpacing + "px" // 24px
                },
                text: {
                    size: {
                        medium: 'small' // 14px
                    }
                }
            },
            gap: 'small',
            size: {
                small: {
                    border: {
                        radius: baseSpacing * 0.75 + "px"
                    },
                    pad: {
                        vertical: baseSpacing / 4 - borderWidth + "px",
                        // 4px
                        horizontal: baseSpacing - borderWidth * 2 + "px" // 20px,
                    }
                },
                medium: {
                    border: {
                        radius: baseSpacing * 0.75 + "px" // 18px
                    },
                    pad: {
                        vertical: baseSpacing / 4 - borderWidth + "px",
                        // 4px
                        horizontal: baseSpacing - borderWidth + "px" // 22px
                    }
                },
                large: {
                    border: {
                        radius: baseSpacing + "px" // 24px
                    },
                    pad: {
                        vertical: baseSpacing / 4 + borderWidth + "px",
                        // 8px
                        horizontal: baseSpacing + borderWidth * 4 + "px" // 32px,
                    }
                }
            },
            border: {
                // color: { dark: undefined, light: undefined }
                width: borderWidth + "px",
                radius: baseSpacing * 0.75 + "px"
            },
            // color: { dark: undefined, light: undefined },
            // elevation: undefined,
            // default: {
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   font: {
            //     size: undefined,
            //     weight: undefined,
            //   },
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            // primary: {
            //   font: {
            //     size: undefined,
            //     weight: undefined,
            //   },
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            // secondary: {
            //   font: {
            //     size: undefined,
            //     weight: undefined,
            //   },
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            // option: {
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   direction: undefined,
            //   elevation: undefined,
            //   icon: undefined,
            //   padding: {
            //     vertical: undefined,
            //     horizontal: undefined,
            //   },
            //   reverse: undefined,
            //   extend: undefined,
            // },
            active: {
                background: 'active-background',
                //   border: undefined,
                color: 'active-text'
            },
            disabled: {
                //   background: undefined,
                //   border: undefined,
                //   color: undefined,
                opacity: 0.3
            },
            // hover: {
            //   background: undefined,
            //   border: undefined,
            //   color: undefined,
            //   extend: undefined,
            //   default: {},
            //   primary: {},
            //   secondary: {},
            // },
            padding: {
                vertical: baseSpacing / 4 - borderWidth + "px",
                horizontal: baseSpacing - borderWidth + "px"
            },
            transition: {
                timing: 'ease-in-out',
                duration: 0.1,
                properties: [
                    'color',
                    'background-color',
                    'border-color',
                    'box-shadow'
                ]
            },
            skeleton: {
                width: {
                    min: '100px'
                }
            }
        },
        calendar: {
            day: {
                // adjacent: {
                //   color: undefined,
                // },
                // hover: {
                //   background: undefined,
                //   color: undefined,
                // },
                selected: {
                    // background: undefined,
                    // color: undefined,
                    font: {
                        weight: 'bold'
                    }
                },
                inRange: {
                    // color: undefined,
                    font: {
                        weight: 'bold'
                    }
                }
            },
            // range: {
            //   background: undefined,
            // },
            // daySize must align with global.size
            small: {
                // day: {
                //   round: undefined,
                // },
                // range: {
                //   round: undefined,
                //   start: {
                //     round: undefined,
                //   },
                //   end: {
                //     round: undefined,
                //   },
                // },
                // title: {},
                fontSize: baseFontSize - fontScale + "px",
                lineHeight: 1.375,
                daySize: baseSpacing * 8 / 7 + "px",
                slideDuration: '0.2s'
            },
            medium: {
                // day: {
                //   round: undefined,
                // },
                // range: {
                //   round: undefined,
                //   start: {
                //     round: undefined,
                //   },
                //   end: {
                //     round: undefined,
                //   },
                // },
                // title: {},
                fontSize: baseFontSize + "px",
                lineHeight: 1.45,
                daySize: baseSpacing * 16 / 7 + "px",
                slideDuration: '0.5s'
            },
            large: {
                // day: {
                //   round: undefined,
                // },
                // range: {
                //   round: undefined,
                //   start: {
                //     round: undefined,
                //   },
                //   end: {
                //     round: undefined,
                //   },
                // },
                // title: {},
                fontSize: baseFontSize + 3 * fontScale + "px",
                lineHeight: 1.11,
                daySize: baseSpacing * 32 / 7 + "px",
                slideDuration: '0.8s'
            },
            icons: {
                previous: (0, _previous.Previous),
                next: (0, _next.Next),
                small: {
                    previous: (0, _formPrevious.FormPrevious),
                    next: (0, _formNext.FormNext)
                }
            },
            heading: {
                level: '4'
            } // level ranges from 1-6
        },
        card: {
            container: {
                round: 'small',
                elevation: 'small'
            },
            // hover: {
            //   container: {
            //     elevation: undefined,
            //   },
            // },
            header: {},
            body: {},
            footer: {}
        },
        cards: {
            container: {
                // any box props
                gap: 'xsmall'
            }
        },
        carousel: {
            icons: {
                current: (0, _subtract.Subtract),
                next: (0, _next.Next),
                previous: (0, _previous.Previous)
            },
            animation: {
                duration: 1000
            },
            disabled: {
                icons: {
                }
            }
        },
        chart: {
            color: 'graph-0'
        },
        checkBox: {
            border: {
                color: {
                    dark: 'rgba(255, 255, 255, 0.5)',
                    light: 'rgba(0, 0, 0, 0.15)'
                },
                width: '2px'
            },
            check: {
                // extend: undefined,
                radius: '4px',
                thickness: '4px'
            },
            label: {
                align: 'center'
            },
            // color: { dark: undefined, light: undefined },
            // extend: undefined,
            // gap: undefined
            hover: {
                border: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                }
            },
            icon: {
            },
            icons: {
            },
            // pad: undefined,
            size: baseSpacing + "px",
            toggle: {
                // background: undefined
                color: {
                    dark: '#d9d9d9',
                    light: '#d9d9d9'
                },
                knob: {
                },
                radius: baseSpacing + "px",
                size: baseSpacing * 2 + "px"
            }
        },
        checkBoxGroup: {
        },
        clock: {
            analog: {
                // extend: undefined,
                hour: {
                    color: {
                        dark: 'light-2',
                        light: 'dark-3'
                    },
                    width: baseSpacing / 3 + "px",
                    size: baseSpacing + "px",
                    shape: 'round'
                },
                minute: {
                    color: {
                        dark: 'light-4',
                        light: 'dark-3'
                    },
                    width: baseSpacing / 6 + "px",
                    size: Math.round(baseSpacing / 2) + "px",
                    shape: 'round'
                },
                second: {
                    color: {
                        dark: 'accent-1',
                        light: 'accent-1'
                    },
                    width: baseSpacing / 8 + "px",
                    size: Math.round(baseSpacing / 2.666) + "px",
                    shape: 'round'
                },
                size: {
                    xsmall: baseSpacing * 2 + "px",
                    small: baseSpacing * 3 + "px",
                    medium: baseSpacing * 4 + "px",
                    large: baseSpacing * 6 + "px",
                    xlarge: baseSpacing * 9 + "px",
                    xxlarge: baseSpacing * 12 + "px",
                    huge: baseSpacing * 12 + "px" // kept for backwards compatibility
                }
            },
            digital: {
                text: {
                    xsmall: {
                        size: baseFontSize - 2 * fontScale + "px",
                        height: 1.5
                    },
                    small: {
                        size: baseFontSize - fontScale + "px",
                        height: 1.43
                    },
                    medium: {
                        size: baseFontSize + "px",
                        height: 1.375
                    },
                    large: {
                        size: baseFontSize + fontScale + "px",
                        height: 1.167
                    },
                    xlarge: {
                        size: baseFontSize + 2 * fontScale + "px",
                        height: 1.1875
                    },
                    xxlarge: {
                        size: baseFontSize + 4 * fontScale + "px",
                        height: 1.125
                    }
                }
            }
        },
        collapsible: {
            minSpeed: 200,
            baseline: 500
        },
        data: {
        },
        dateInput: {
            container: {
                round: 'xxsmall'
            }
        },
        dataTable: {
            // body: {
            //   extend: undefined,
            //   row: {
            //     extend: undefined,
            //   }
            //   selected: undefined,
            // },
            pinned: {
                // body: {
                //    background: undefined,
                //    extend: undefined,
                // },
                header: {
                    background: {
                        opacity: 'strong'
                    }
                },
                footer: {
                    background: {
                        opacity: 'strong'
                    }
                }
            },
            container: {
                // any box props
                gap: 'xsmall'
            },
            groupHeader: {
            },
            groupEnd: {
                border: {
                    side: 'bottom',
                    size: 'xsmall'
                }
            },
            header: {
                // background: undefined,
                // border: undefined,
                // color: undefined,
                // extend: undefined,
                // font: {
                //   weight: undefined,
                //   size: undefined,
                // },
                gap: 'small',
                // hover: {
                //   background: undefined,
                // },
                // pad: undefined,
                units: {
                    color: 'text-xweak',
                    margin: {
                        left: 'xsmall'
                    },
                    alignSelf: 'end'
                }
            },
            icons: {
                ascending: (0, _formDown.FormDown),
                contract: (0, _formUp.FormUp),
                descending: (0, _formUp.FormUp),
                expand: (0, _formDown.FormDown)
            },
            primary: {
                weight: 'bold'
            },
            resize: {
                border: {
                    color: 'border',
                    side: 'end'
                }
            }
        },
        diagram: {
            // extend: undefined,
            line: {
                color: 'graph-0'
            }
        },
        // drop: {
        //   extend: undefined,
        //   maxHeight: undefined,
        // },
        fileInput: {
            // background: {},
            border: {
                // color: undefined,
                side: 'all',
                size: 'small',
                style: 'dashed'
            },
            dragOver: {
                border: {
                    color: 'control'
                }
            },
            hover: {
                border: {
                    color: 'brand'
                }
            },
            icons: {
                remove: (0, _formClose.FormClose)
            },
            // pad: {},
            label: {
                margin: 'small'
            },
            message: {
                margin: 'small'
            }
        },
        formField: {
            // [inputname]: {
            //  container: {
            //    extend: undefined,
            //   }
            // }
            border: {
                color: 'border',
                error: {
                    color: {
                        dark: 'white',
                        light: 'status-critical'
                    }
                },
                position: 'inner',
                side: 'bottom'
            },
            // checkBox: {
            //   pad: undefined,
            // },
            content: {
                // margin: undefined,
                pad: 'small'
            },
            disabled: {
                background: {
                    color: 'status-disabled',
                    opacity: 'medium'
                }
            },
            focus: {
                containerFocus: true
            },
            error: {
                color: 'status-critical',
                margin: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                }
            },
            // extend: undefined,
            help: {
                color: 'dark-2',
                margin: {
                    start: 'small'
                }
            },
            info: {
                color: 'text-xweak',
                margin: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                }
            },
            label: {
                margin: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                }
            },
            margin: {
                bottom: 'small'
            },
            // round: undefined,
            survey: {
                label: {
                    margin: {
                        bottom: 'xsmall'
                    },
                    size: 'medium',
                    weight: 400
                }
            }
        },
        grommet: {
        },
        header: {
            sticky: {
                zIndex: '20'
            }
        },
        heading: {
            // color: undefined,
            font: {
            },
            level: {
                1: {
                    font: {
                    },
                    small: _extends({}, fontSizing(4)),
                    medium: _extends({}, fontSizing(8)),
                    large: _extends({}, fontSizing(16)),
                    xlarge: _extends({}, fontSizing(24))
                },
                2: {
                    font: {
                    },
                    small: _extends({}, fontSizing(2)),
                    medium: _extends({}, fontSizing(4)),
                    large: _extends({}, fontSizing(8)),
                    xlarge: _extends({}, fontSizing(12))
                },
                3: {
                    font: {
                    },
                    small: _extends({}, fontSizing(1)),
                    medium: _extends({}, fontSizing(2)),
                    large: _extends({}, fontSizing(4)),
                    xlarge: _extends({}, fontSizing(6))
                },
                4: {
                    font: {
                    },
                    small: _extends({}, fontSizing(0)),
                    medium: _extends({}, fontSizing(0)),
                    large: _extends({}, fontSizing(0)),
                    xlarge: _extends({}, fontSizing(0))
                },
                5: {
                    font: {
                    },
                    small: _extends({}, fontSizing(-0.5)),
                    medium: _extends({}, fontSizing(-0.5)),
                    large: _extends({}, fontSizing(-0.5)),
                    xlarge: _extends({}, fontSizing(-0.5))
                },
                6: {
                    font: {
                    },
                    small: _extends({}, fontSizing(-1)),
                    medium: _extends({}, fontSizing(-1)),
                    large: _extends({}, fontSizing(-1)),
                    xlarge: _extends({}, fontSizing(-1))
                }
            },
            responsiveBreakpoint: 'small',
            // when we scale the font size down
            weight: 600,
            skeleton: {
                width: {
                    min: '150px',
                    max: '200px'
                }
            }
        },
        layer: {
            background: {
                dark: 'black',
                light: 'white'
            },
            border: {
                radius: '4px'
            },
            container: {
                // elevation: undefined,
                zIndex: '20'
            },
            // extend: undefined,
            overlay: {
                background: 'rgba(0, 0, 0, 0.5)'
            },
            responsiveBreakpoint: 'small',
            // when Layer takes over the full screen
            zIndex: '20'
        },
        list: {
            container: {
                // any box props
                gap: 'xsmall'
            },
            item: {
                // background: undefined,
                border: 'horizontal',
                disabled: {
                    color: 'status-disabled',
                    cursor: 'default'
                },
                pinned: {
                    background: 'background-contrast',
                    icon: {
                        size: 'medium',
                        pad: 'small'
                    }
                },
                pad: {
                    horizontal: 'medium',
                    vertical: 'small'
                }
            },
            primaryKey: {
                // any text props
                weight: 'bold'
            },
            icons: {
                down: (0, _formDown.FormDown),
                up: (0, _formUp.FormUp),
                pin: (0, _formPin.FormPin)
            }
        },
        maskedInput: {
        },
        menu: {
            // background: undefined,
            // item: undefined,
            // extend: undefined,
            drop: {
                align: {
                    top: 'top',
                    left: 'left'
                }
            },
            // container: {
            //   // any box props
            // },
            group: {
                container: {
                    pad: {
                        vertical: 'xsmall'
                    }
                },
                separator: {
                    color: 'border',
                    size: 'xsmall',
                    pad: {
                        horizontal: 'small'
                    }
                }
            },
            icons: {
                down: (0, _formDown.FormDown)
            }
        },
        meter: {
            color: 'graph-0'
        },
        nameValueList: {
            gap: {
                column: 'large',
                row: 'small'
            },
            pair: {
                column: {
                    gap: {
                        column: 'large',
                        row: 'medium'
                    }
                }
            },
            name: {
                width: 'small'
            },
            value: {
                width: 'medium'
            }
        },
        nameValuePair: {
            column: {
                gap: 'xxsmall'
            },
            name: {
                // any text props
                color: 'text',
                weight: 'bold'
            },
            value: {
                // any text props
                color: 'text'
            }
        },
        notification: {
            actions: {
            },
            direction: 'column',
            container: {
                // any box props
                round: 'xsmall',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                background: {
                    color: 'background-front'
                }
            },
            global: {
                direction: 'row',
                container: {
                    // any box props
                    round: 'none',
                    pad: {
                        horizontal: 'large',
                        vertical: 'xsmall'
                    }
                }
            },
            toast: {
                // direction: undefined,
                container: {
                    // any box props
                    elevation: 'medium',
                    width: 'medium'
                },
                layer: {
                    position: 'top',
                    margin: 'medium'
                },
                time: 8000
            },
            iconContainer: {
                // any box props
                pad: {
                    right: 'small'
                },
                flex: false
            },
            textContainer: {
                // any box props
                gap: 'medium'
            },
            title: {
                // any text props
                weight: 'bold'
            },
            message: {
                // any text props
                margin: 'none'
            },
            close: {
                icon: (0, _formClose.FormClose)
            },
            critical: {
                icon: (0, _statusCriticalSmall.StatusCriticalSmall),
                background: {
                    color: 'status-critical',
                    opacity: 'weak'
                },
                color: 'status-critical',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            warning: {
                icon: (0, _statusWarningSmall.StatusWarningSmall),
                background: {
                    color: 'status-warning',
                    opacity: 'weak'
                },
                color: 'status-warning',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            normal: {
                icon: (0, _statusGoodSmall.StatusGoodSmall),
                background: {
                    color: 'status-ok',
                    opacity: 'weak'
                },
                color: 'status-ok',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            info: {
                icon: (0, _circleInformation.CircleInformation),
                background: 'background-contrast',
                color: 'text-strong',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            unknown: {
                icon: (0, _statusUnknownSmall.StatusUnknownSmall),
                background: {
                    color: 'status-unknown',
                    opacity: 'weak'
                },
                color: 'status-unknown',
                // message: {
                //   color: undefined,
                // },
                // title: {
                //   color: undefined,
                // },
                // global: {},
                toast: {
                    background: 'background-front'
                }
            },
            // deprecate "undefined" in v3
            // and if undefined, no icon
            undefined: {
                icon: (0, _statusUnknownSmall.StatusUnknownSmall),
                // background: undefined,
                color: 'status-unknown'
            }
        },
        page: {
            wide: {
                alignSelf: 'center',
                width: {
                    min: 'medium',
                    max: 'xxlarge'
                },
                small: {
                    pad: {
                        horizontal: 'large'
                    }
                },
                medium: {
                    pad: {
                        horizontal: 'medium'
                    }
                },
                large: {
                    pad: {
                        horizontal: 'large'
                    }
                }
            },
            narrow: {
                alignSelf: 'center',
                width: {
                    min: 'medium',
                    max: 'large'
                },
                small: {
                    pad: {
                        horizontal: 'large'
                    }
                },
                medium: {
                    pad: {
                        horizontal: 'medium'
                    }
                },
                large: {
                    pad: {
                        horizontal: 'large'
                    }
                }
            },
            full: {
                alignSelf: 'start',
                width: {
                    min: 'medium',
                    max: '100%'
                },
                small: {
                    pad: {
                        horizontal: 'large'
                    }
                },
                medium: {
                    pad: {
                        horizontal: 'medium'
                    }
                },
                large: {
                    pad: {
                        horizontal: 'large'
                    }
                }
            }
        },
        pageHeader: {
            actions: {
                // any box props
                align: 'end'
            },
            pad: {
                top: 'large',
                bottom: 'medium'
            },
            parent: {
                // any box props
                align: 'start'
            },
            responsive: {
                actions: {
                    // any box props
                    align: 'start',
                    pad: {
                        top: 'small'
                    }
                },
                areas: [
                    [
                        'parent'
                    ],
                    [
                        'title'
                    ],
                    [
                        'subtitle'
                    ],
                    [
                        'actions'
                    ]
                ],
                breakpoints: [
                    'small'
                ],
                columns: [
                    'auto'
                ],
                rows: [
                    'auto'
                ]
            },
            subtitle: {
                // any paragraph props
                margin: 'none'
            },
            title: {
                // any heading props
                margin: 'none',
                fill: true
            },
            size: {
                small: {
                    pad: {
                        top: 'medium',
                        bottom: 'small'
                    },
                    subtitle: {
                        size: 'small'
                    },
                    title: {
                        size: 'small'
                    }
                },
                // medium: {
                //   // pad: undefined,
                //   // subtitle: {},
                //   // title: {},
                // },
                large: {
                    pad: {
                        top: 'xlarge',
                        bottom: 'large'
                    },
                    subtitle: {
                        size: 'large'
                    },
                    title: {
                        size: 'large'
                    }
                }
            },
            small: {
                areas: [
                    [
                        'parent',
                        'parent'
                    ],
                    [
                        'title',
                        'actions'
                    ],
                    [
                        'subtitle',
                        'actions'
                    ]
                ],
                columns: [
                    [
                        'small',
                        'flex'
                    ],
                    'auto'
                ],
                rows: [
                    'auto',
                    'auto',
                    'auto'
                ],
                gap: {
                    row: 'xsmall',
                    column: 'large'
                }
            },
            medium: {
                areas: [
                    [
                        'parent',
                        'parent'
                    ],
                    [
                        'title',
                        'actions'
                    ],
                    [
                        'subtitle',
                        'actions'
                    ]
                ],
                columns: [
                    [
                        'medium',
                        'flex'
                    ],
                    'auto'
                ],
                rows: [
                    'auto',
                    'auto',
                    'auto'
                ],
                gap: {
                    row: 'xsmall',
                    column: 'medium'
                }
            },
            large: {
                areas: [
                    [
                        'parent',
                        'parent'
                    ],
                    [
                        'title',
                        'actions'
                    ],
                    [
                        'subtitle',
                        'actions'
                    ]
                ],
                columns: [
                    [
                        'medium',
                        'flex'
                    ],
                    'auto'
                ],
                rows: [
                    'auto',
                    'auto',
                    'auto'
                ],
                gap: {
                    row: 'xsmall',
                    column: 'large'
                }
            }
        },
        pagination: {
            button: {
                active: {
                    background: {
                        color: 'active-background'
                    }
                },
                color: 'text-strong',
                hover: {
                    background: {
                        color: 'background-contrast'
                    },
                    color: undefined
                },
                size: {
                    small: {
                        border: {
                            radius: baseSpacing / 8 + "px",
                            // 3
                            width: '2px'
                        },
                        pad: {
                            vertical: "4px",
                            horizontal: "4px"
                        },
                        font: _extends({}, fontSizing(-1)),
                        height: baseSpacing * 1.25 + "px",
                        width: baseSpacing * 1.25 + "px"
                    },
                    medium: {
                        border: {
                            radius: baseSpacing / 6 + "px",
                            // 4
                            width: '2px'
                        },
                        pad: {
                            vertical: "4px",
                            horizontal: "4px"
                        },
                        font: _extends({}, fontSizing(0)),
                        height: baseSpacing * 1.5 + "px",
                        width: baseSpacing * 1.5 + "px"
                    },
                    large: {
                        border: {
                            radius: baseSpacing / 4 + "px",
                            // 6
                            width: '2px'
                        },
                        pad: {
                            vertical: "4px",
                            horizontal: "4px"
                        },
                        font: _extends({}, fontSizing(1)),
                        height: baseSpacing * 2 + "px",
                        width: baseSpacing * 2 + "px"
                    }
                }
            },
            // container: {
            //   // any box props,
            //   extend: undefined,
            // },
            controls: {
                align: 'center',
                direction: 'row',
                gap: 'xxsmall',
                margin: 'none',
                pad: 'none'
            },
            icons: {
                // color: undefined,
                next: (0, _next.Next),
                previous: (0, _previous.Previous)
            }
        },
        paragraph: {
            font: {
            },
            small: _extends({}, fontSizing(-1)),
            medium: _extends({}, fontSizing(0)),
            large: _extends({}, fontSizing(1)),
            xlarge: _extends({}, fontSizing(2)),
            xxlarge: _extends({}, fontSizing(4))
        },
        thumbsRating: {
        },
        spinner: {
            container: {
                animation: 'rotateRight',
                color: 'brand',
                pad: 'small',
                round: 'full',
                size: 'small'
            },
            // icon: undefined
            size: {
                xsmall: baseSpacing * 0.75 + "px",
                small: baseSpacing + "px",
                // default 24
                medium: baseSpacing * 2 + "px",
                large: baseSpacing * 3 + "px",
                xlarge: baseSpacing * 4 + "px"
            }
        },
        radioButton: {
            border: {
                color: {
                    dark: 'rgba(255, 255, 255, 0.5)',
                    light: 'rgba(0, 0, 0, 0.15)'
                },
                width: '2px'
            },
            // background: {
            //   color: undefined,
            // },
            check: {
                radius: '100%'
            },
            // color: undefined,
            hover: {
                // background: {
                //   color: undefined,
                // },
                border: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                }
            },
            icon: {
            },
            icons: {
            },
            gap: 'small',
            size: baseSpacing + "px",
            font: {
            },
            container: {
            }
        },
        radioButtonGroup: {
        },
        rangeInput: {
            disabled: {
                opacity: 0.3
            },
            // extend: undefined
            track: {
                height: '4px',
                color: 'border'
            },
            thumb: {
            }
        },
        rangeSelector: {
            background: {
                invert: {
                    color: 'light-4'
                }
            }
        },
        select: {
            // background: undefined,
            clear: {
                container: {
                    pad: 'small',
                    background: 'background-contrast'
                },
                // any box props
                text: {
                    color: 'text-weak'
                } // any text props
            },
            container: {
            },
            control: {
            },
            // emptySearchMessage: {
            //   container: {}, // any box props
            //   text: {}, // any text props
            // },
            icons: {
                // color: { dark: undefined, light: undefined },
                margin: {
                    horizontal: 'small'
                },
                down: (0, _formDown.FormDown)
            },
            // listbox: {
            //   extend: undefined,
            // },
            options: {
                container: {
                    align: 'start',
                    pad: 'small'
                },
                text: {
                    margin: 'none'
                }
            },
            // searchInput: undefined,
            step: 20
        },
        selectMultiple: {
            maxInline: 5
        },
        skeleton: {
            border: false,
            colors: {
                dark: [
                    'background',
                    'background-front'
                ],
                light: [
                    'background',
                    'background-back'
                ]
            }
        },
        skipLinks: {
            position: 'top',
            container: {
                elevation: 'large',
                round: 'small',
                pad: 'medium'
            },
            label: {
                margin: {
                    bottom: 'medium'
                },
                size: 'medium'
            }
        },
        starRating: {
        },
        tab: {
            active: {
                color: 'text'
            },
            // background: undefined,
            border: {
                side: 'bottom',
                size: 'small',
                color: {
                    dark: 'accent-1',
                    light: 'brand'
                },
                active: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                },
                disabled: {
                },
                hover: {
                    color: {
                        dark: 'white',
                        light: 'black'
                    }
                }
            },
            color: 'control',
            // disabled: {
            //   color: undefined,
            // },
            // extend: undefined,
            hover: {
                // background: undefined,
                // extend: undefined,
                color: {
                    dark: 'white',
                    light: 'black'
                }
            },
            margin: {
                vertical: 'xxsmall',
                horizontal: 'small'
            },
            pad: {
                bottom: 'xsmall'
            }
        },
        tabs: {
            // background: undefined,
            // extend: undefined,
            // gap: undefined,
            header: {
            },
            panel: {
            },
            step: {
                small: 1,
                medium: 3,
                large: 3
            }
        },
        table: {
            header: {
                align: 'start',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                border: 'bottom'
            },
            body: {
                align: 'start',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                }
            },
            // row: {
            //   hover: {
            //     background: undefined,
            //     color: undefined,
            //   },
            // },
            footer: {
                align: 'start',
                pad: {
                    horizontal: 'small',
                    vertical: 'xsmall'
                },
                border: 'top'
            }
        },
        tag: {
            // background: undefined,
            border: true,
            round: 'large',
            // name: undefined,
            pad: {
                horizontal: 'small',
                vertical: 'xsmall'
            },
            remove: {
                margin: {
                    right: 'xsmall'
                }
            },
            separator: ' : ',
            size: {
                xsmall: {
                    pad: {
                        horizontal: baseSpacing / 3 + "px",
                        vertical: 'xxsmall'
                    },
                    icon: {
                        size: baseSpacing * 0.75 + "px"
                    }
                },
                small: {
                    pad: {
                        horizontal: baseSpacing * 0.4 + "px",
                        vertical: 'xxsmall'
                    },
                    icon: {
                        size: baseSpacing * 0.75 + "px"
                    }
                },
                large: {
                    pad: {
                        horizontal: baseSpacing / 3 * 2 + "px",
                        vertical: "xsmall"
                    },
                    icon: {
                        size: baseSpacing * 1.25 + "px"
                    }
                },
                xlarge: {
                    pad: {
                        horizontal: baseSpacing * 0.75 + "px",
                        vertical: 'xsmall'
                    },
                    icon: {
                        size: baseSpacing * 1.5 + "px"
                    }
                }
            },
            value: {
                weight: 600
            },
            icons: {
                remove: (0, _formClose.FormClose)
            }
        },
        text: {
            font: {
            },
            xsmall: _extends({}, fontSizing(-1.5)),
            small: _extends({}, fontSizing(-1)),
            medium: _extends({}, fontSizing(0)),
            // 18px
            large: _extends({}, fontSizing(1)),
            // 22px
            xlarge: _extends({}, fontSizing(2)),
            xxlarge: _extends({}, fontSizing(4)),
            '2xl': _extends({}, fontSizing(4)),
            '3xl': _extends({}, fontSizing(6)),
            '4xl': _extends({}, fontSizing(9)),
            '5xl': _extends({}, fontSizing(13)),
            '6xl': _extends({}, fontSizing(18)),
            skeleton: {
                width: {
                    width: '100px',
                    min: '100px'
                },
                margin: {
                    vertical: 'xsmall'
                },
                colors: {
                    dark: [
                        'border',
                        'border'
                    ],
                    light: [
                        'background-front',
                        'background-back'
                    ]
                }
            }
        },
        textArea: {
        },
        textInput: {
        },
        tip: {
            content: {
                // any Box props
                background: 'background-contrast',
                elevation: 'small',
                margin: 'xsmall',
                pad: {
                    vertical: 'xsmall',
                    horizontal: 'small'
                },
                round: 'small'
            },
            drop: {
                // any props for the drop
                align: {
                    top: 'bottom'
                },
                // most common use case is Header with Buttons
                background: 'none',
                elevation: 'none',
                margin: 'none'
            }
        },
        toggleGroup: {
            button: {
                // border: {
                //   radius: undefined,
                // }
                // iconOnly: {
                //   pad: undefined,
                // },
                // kind: undefined,
                pad: {
                    horizontal: '11px',
                    vertical: '11px'
                }
            },
            container: {
                round: 'xsmall',
                border: true
            },
            divider: {
                color: 'border'
            }
        },
        video: {
            captions: {
                background: 'rgba(0, 0, 0, 0.7)'
            },
            // controls: { background: undefined },
            icons: {
                closedCaption: (0, _closedCaption.ClosedCaption),
                configure: (0, _actions.Actions),
                fullScreen: (0, _expand.Expand),
                pause: (0, _pause.Pause),
                play: (0, _play.Play),
                reduceVolume: (0, _volumeLow.VolumeLow),
                volume: (0, _volume.Volume),
                description: (0, _assistListening.AssistListening)
            },
            scrubber: {
                color: 'light-4',
                interval: 10
            }
        },
        worldMap: {
            color: 'light-3',
            continent: {
                active: '8px',
                base: '6px'
            },
            hover: {
                color: 'light-4'
            },
            place: {
                active: '20px',
                base: '8px'
            }
        }
    });
    return (0, _object.deepFreeze)(result);
};
var base = generate(24);

},{"grommet-icons/icons/Actions":"lydUO","grommet-icons/icons/AssistListening":"5nl3I","grommet-icons/icons/CircleInformation":"b10G5","grommet-icons/icons/ClosedCaption":"90RXH","grommet-icons/icons/Expand":"hNKCq","grommet-icons/icons/FormClose":"4faFm","grommet-icons/icons/FormDown":"d4NF6","grommet-icons/icons/FormNext":"aJ0sD","grommet-icons/icons/FormPrevious":"lt1cP","grommet-icons/icons/FormUp":"b65DD","grommet-icons/icons/Next":"jIfyP","grommet-icons/icons/Pause":"5aPc1","grommet-icons/icons/Play":"fPBDc","grommet-icons/icons/FormPin":"9QKoz","grommet-icons/icons/Previous":"bSul7","grommet-icons/icons/StatusCriticalSmall":"1bGUx","grommet-icons/icons/StatusGoodSmall":"89Utf","grommet-icons/icons/StatusWarningSmall":"02Qvt","grommet-icons/icons/StatusUnknownSmall":"eRJFV","grommet-icons/icons/Subtract":"cadUP","grommet-icons/icons/Volume":"8WFGy","grommet-icons/icons/VolumeLow":"lI7gD","grommet-icons/themes/base":"dw0lc","../utils/object":"go0Cn","../utils/mixins":"gx4wP","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lydUO":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.Actions = void 0;
var _react = _interopRequireWildcard(require("866934f4d2df8643"));
var _StyledIcon = require("f4bfae37ca472607");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Actions = exports.Actions = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Actions"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 17.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zm0-11V1m0 22v-5.5M1 12h5.5m11 0H23M4.437 4.437l4.125 4.125m6.876 6.876 4.124 4.124m0-15.125-4.125 4.125m-6.874 6.876-4.126 4.124"
    }));
});
Actions.displayName = 'Actions';

},{"866934f4d2df8643":"8CCva","f4bfae37ca472607":"7Xr4o"}],"7Xr4o":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.StyledIcon = void 0;
var _react = _interopRequireWildcard(require("4e505d1188cfed89"));
var _styledComponents = _interopRequireWildcard(require("6fb1c14d4298b991"));
var _defaultProps = require("772ad348be83807b");
var _utils = require("b9d4261e2d78c5ef");
var _excluded = [
    "a11yTitle",
    "color",
    "size",
    "theme"
];
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Returns the specific color that should be used according to the theme.
// If 'dark' is supplied, it takes precedence over 'theme.dark'.
// Can return undefined.
var normalizeColor = function normalizeColor(color, theme, dark) {
    var colorSpec = theme.global && theme.global.colors[color] !== undefined ? theme.global.colors[color] : color;
    // If the color has a light or dark object, use that
    var result = colorSpec;
    if (colorSpec) {
        if ((dark === true || dark === undefined && theme.dark) && colorSpec.dark !== undefined) result = colorSpec.dark;
        else if ((dark === false || !theme.dark) && colorSpec.light !== undefined) result = colorSpec.light;
    }
    // allow one level of indirection in color names
    if (result && theme.global && theme.global.colors[result] !== undefined) result = normalizeColor(result, theme, dark);
    return result;
};
var colorStyle = function colorStyle(name, value, theme, required) {
    return (0, _styledComponents.css)([
        "",
        ":",
        ";"
    ], name, normalizeColor(value, theme, required));
};
var colorCss = (0, _styledComponents.css)([
    "",
    " ",
    " g{fill:inherit;stroke:inherit;}*:not([stroke]){&[fill='none']{stroke-width:0;}}*[stroke*='#'],*[STROKE*='#']{stroke:inherit;fill:none;}*[fill-rule],*[FILL-RULE],*[fill*='#'],*[FILL*='#']{fill:inherit;stroke:none;}"
], function(props) {
    return colorStyle('fill', props.color || props.theme.global.colors.icon, props.theme);
}, function(props) {
    return colorStyle('stroke', props.color || props.theme.global.colors.icon, props.theme);
});
var IconInner = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, color = _ref.color, size = _ref.size, theme = _ref.theme, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/ _react["default"].createElement("svg", _extends({
        ref: ref,
        "aria-label": a11yTitle
    }, rest));
});
IconInner.displayName = 'Icon';
var StyledIcon = exports.StyledIcon = (0, _styledComponents["default"])(IconInner).withConfig({
    // don't let height attribute leak to DOM
    // https://styled-components.com/docs/api#shouldforwardprop
    shouldForwardProp: function shouldForwardProp(prop) {
        return ![
            'height',
            'width'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledIcon",
    componentId: "sc-ofa7kd-0"
})([
    "display:inline-block;flex:0 0 auto;",
    " ",
    " ",
    " ",
    ""
], function(_ref2) {
    var _size$match;
    var _ref2$size = _ref2.size, sizeProp = _ref2$size === void 0 ? 'medium' : _ref2$size, theme = _ref2.theme, viewBox = _ref2.viewBox;
    var _split = (viewBox || '0 0 24 24').split(' '), w = _split[2], h = _split[3];
    var scale = w / h;
    var size = theme.icon.size[sizeProp] || sizeProp;
    var dimension = (0, _utils.parseMetricToNum)(size);
    // grab rem, em, px value from resolved size value
    var unit = ((_size$match = size.match(/[a-z]+$/)) == null ? void 0 : _size$match[0]) || 'px';
    if (w < h) return "\n      width: " + dimension + unit + ";\n      height: " + dimension / scale + unit + ";\n    ";
    if (h < w) return "\n      width: " + dimension * scale + unit + ";\n      height: " + dimension + unit + ";\n    ";
    return "\n      width: " + dimension + unit + ";\n      height: " + dimension + unit + ";\n    ";
}, function(_ref3) {
    var color = _ref3.color;
    return color !== 'plain' && colorCss;
}, function(props) {
    return (props.height || props.width) && (0, _utils.iconPad)(props);
}, function(_ref4) {
    var theme = _ref4.theme;
    return theme && theme.icon.extend;
});
StyledIcon.defaultProps = {};
Object.setPrototypeOf(StyledIcon.defaultProps, _defaultProps.defaultProps);

},{"4e505d1188cfed89":"8CCva","6fb1c14d4298b991":"6bGrk","772ad348be83807b":"K5U7q","b9d4261e2d78c5ef":"dP1kS"}],"K5U7q":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.extendDefaultTheme = exports.defaultProps = void 0;
var _utils = require("bf6b0fcf2dd8be4f");
var _themes = require("6b86cd59f28aa248");
var defaultProps = exports.defaultProps = {
    theme: _themes.base
};
var extendDefaultTheme = exports.extendDefaultTheme = function extendDefaultTheme(theme) {
    defaultProps.theme = (0, _utils.deepMerge)(_themes.base, theme);
};

},{"bf6b0fcf2dd8be4f":"dP1kS","6b86cd59f28aa248":"htzDC"}],"dP1kS":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.deepMerge = deepMerge;
exports.generatePrefix = exports["default"] = void 0;
exports.iconPad = iconPad;
exports.isObject = isObject;
exports.parseMetricToNum = void 0;
exports.useScaleProps = useScaleProps;
var _react = require("471d9ae5ebfaf282");
var _styledComponents = require("d59a5469b7f529d1");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
function deepMerge(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    // making sure to not change target (immutable)
    var output = _extends({}, target);
    sources.forEach(function(source) {
        if (isObject(source)) Object.keys(source).forEach(function(key) {
            if (isObject(source[key])) {
                if (!output[key]) output[key] = _extends({}, source[key]);
                else output[key] = deepMerge(output[key], source[key]);
            } else output[key] = source[key];
        });
    });
    return output;
}
var parseMetricToNum = exports.parseMetricToNum = function parseMetricToNum(string) {
    if (string === void 0) string = '';
    return parseFloat(string.match(/\d+(\.\d+)?/), 10);
};
// scaleProps sets path properties to prevent scaling the stroke
// when the theme doesn't want it for small sizes.
function useScaleProps(props) {
    var _theme$icon;
    var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
    var size = props.size;
    var result = {};
    if (theme != null && (_theme$icon = theme.icon) != null && _theme$icon.disableScaleDown) {
        var dimension = parseMetricToNum(theme.icon.size[size] || size);
        if (dimension < 24) result.vectorEffect = 'non-scaling-stroke';
    }
    return result;
}
var calculatePad = function calculatePad(value, iconDimension) {
    return (value - iconDimension) / 2 + "px";
};
// iconPad applies padding to icon to ensure it aligns
// with text line-height or desired width
function iconPad(props) {
    var _theme$icon2, _theme$text, _theme$text2;
    var height = props.height, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, width = props.width;
    var theme = (0, _react.useContext)(_styledComponents.ThemeContext);
    var iconDimension = parseMetricToNum((theme == null || (_theme$icon2 = theme.icon) == null || (_theme$icon2 = _theme$icon2.size) == null ? void 0 : _theme$icon2[size]) || size);
    var style = '';
    // browser default is 16px, but accommodate if app has modified
    // include fallback in case window is undefined
    var FALLBACK = '16px';
    var rootFontSize = parseMetricToNum(FALLBACK);
    if (typeof window !== 'undefined') {
        var _window;
        rootFontSize = parseMetricToNum(((_window = window) == null ? void 0 : _window.getComputedStyle(document.body).getPropertyValue('font-size')) || FALLBACK);
    }
    if (height && theme != null && (_theme$text = theme.text) != null && (_theme$text = _theme$text[height]) != null && _theme$text.height) {
        // the unit on theme text
        var _theme$text$height$he = theme.text[height].height.match(/(px|rem)/), unit = _theme$text$height$he[0];
        var lineHeight = parseMetricToNum(theme.text[height].height);
        if (unit === 'rem') lineHeight *= rootFontSize;
        if (lineHeight > iconDimension) {
            var pad = calculatePad(lineHeight, iconDimension);
            style += "padding-top: " + pad + "; padding-bottom: " + pad + ";";
        }
    }
    if (width && theme != null && (_theme$text2 = theme.text) != null && (_theme$text2 = _theme$text2[width]) != null && _theme$text2.height) {
        // the unit on theme text
        var _theme$text$width$hei = theme.text[width].height.match(/(px|rem)/), _unit = _theme$text$width$hei[0];
        var desiredWidth = parseMetricToNum(theme.text[width].height);
        if (_unit === 'rem') desiredWidth *= rootFontSize;
        if (desiredWidth > iconDimension) {
            var _pad = calculatePad(desiredWidth, iconDimension);
            style += "padding-left: " + _pad + "; padding-right: " + _pad + ";";
        }
    }
    return style;
}
// ensure icons that rely on urls don't have id collision
// Date.now + Math.random is unique enough for icon use cases
var generatePrefix = exports.generatePrefix = function generatePrefix(name) {
    return "_grommeticons-" + name + "-" + (Date.now() + Math.random());
};
var _default = exports["default"] = {
    deepMerge: deepMerge,
    isObject: isObject,
    parseMetricToNum: parseMetricToNum,
    iconPad: iconPad,
    useScaleProps: useScaleProps
};

},{"471d9ae5ebfaf282":"8CCva","d59a5469b7f529d1":"6bGrk"}],"htzDC":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.base = void 0;
var _base = require("be2db1c9fb6c71a");
exports.base = _base.base;

},{"be2db1c9fb6c71a":"dw0lc"}],"dw0lc":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.base = void 0;
var base = exports.base = {
    global: {
        colors: {
            icon: '#666666'
        }
    },
    icon: {
        size: {
            small: '12px',
            medium: '24px',
            large: '48px',
            xlarge: '96px'
        }
    }
};

},{}],"5nl3I":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.AssistListening = void 0;
var _react = _interopRequireWildcard(require("13d77e57569194bc"));
var _StyledIcon = require("41e54762db080dc4");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var AssistListening = exports.AssistListening = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "AssistListening"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M11 21c.757.667 1.424 1 2 1 2 0 3-1 3-3 0-1.333.667-2.667 2-4 1.267-1.267 2-3.067 2-5a7 7 0 0 0-14 0m11 0a4 4 0 1 0-8 0M3 20l5-6 1 4 5-6"
    }));
});
AssistListening.displayName = 'AssistListening';

},{"13d77e57569194bc":"8CCva","41e54762db080dc4":"7Xr4o"}],"b10G5":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.CircleInformation = void 0;
var _react = _interopRequireWildcard(require("a0e6338e87e68ad4"));
var _StyledIcon = require("9e943c3cc13b1c5");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var CircleInformation = exports.CircleInformation = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CircleInformation"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-12v8m0-12v2"
    }));
});
CircleInformation.displayName = 'CircleInformation';

},{"a0e6338e87e68ad4":"8CCva","9e943c3cc13b1c5":"7Xr4o"}],"90RXH":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.ClosedCaption = void 0;
var _react = _interopRequireWildcard(require("90f5229ee3d47b3e"));
var _StyledIcon = require("9ec02e9d9454c971");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var ClosedCaption = exports.ClosedCaption = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ClosedCaption"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 12c0-7 1.5-8 11-8s11 1 11 8-1.5 8-11 8-11-1-11-8zm4.25 2c0 1.5.75 2 2.5 2s2.5-.5 2.5-2h-.271c0 1.25-1 2-2.229 2-1.23 0-2.229-.75-2.229-2v-4C5.5 8.75 6.5 8 7.75 8s2.25.75 2.229 2h.271c0-1.25-1.021-2-2.5-2s-2.5.75-2.5 2v4zm8 0c0 1.5.75 2 2.5 2s2.5-.5 2.5-2h-.271c0 1.25-1 2-2.229 2-1.23 0-2.229-.75-2.229-2v-4c-.021-1.25.979-2 2.229-2s2.25.75 2.229 2h.271c0-1.25-1.021-2-2.5-2s-2.5.75-2.5 2v4z"
    }));
});
ClosedCaption.displayName = 'ClosedCaption';

},{"90f5229ee3d47b3e":"8CCva","9ec02e9d9454c971":"7Xr4o"}],"hNKCq":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.Expand = void 0;
var _react = _interopRequireWildcard(require("364718daefa19723"));
var _StyledIcon = require("9c4ba3adda35e3c4");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Expand = exports.Expand = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Expand"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m10 14-8 8m-1-7v8h8M22 2l-8 8m1-9h8v8"
    }));
});
Expand.displayName = 'Expand';

},{"364718daefa19723":"8CCva","9c4ba3adda35e3c4":"7Xr4o"}],"4faFm":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.FormClose = void 0;
var _react = _interopRequireWildcard(require("b7182a5cadba7521"));
var _StyledIcon = require("66c06c3875da9da4");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var FormClose = exports.FormClose = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormClose"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m7 7 10 10M7 17 17 7"
    }));
});
FormClose.displayName = 'FormClose';

},{"b7182a5cadba7521":"8CCva","66c06c3875da9da4":"7Xr4o"}],"d4NF6":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.FormDown = void 0;
var _react = _interopRequireWildcard(require("8949f0048fca7b92"));
var _StyledIcon = require("85a175789a304d32");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var FormDown = exports.FormDown = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormDown"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m18 9-6 6-6-6"
    }));
});
FormDown.displayName = 'FormDown';

},{"8949f0048fca7b92":"8CCva","85a175789a304d32":"7Xr4o"}],"aJ0sD":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.FormNext = void 0;
var _react = _interopRequireWildcard(require("15bb065e79b9621c"));
var _StyledIcon = require("4336cf3fd9b53e4c");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var FormNext = exports.FormNext = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormNext"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m9 6 6 6-6 6"
    }));
});
FormNext.displayName = 'FormNext';

},{"15bb065e79b9621c":"8CCva","4336cf3fd9b53e4c":"7Xr4o"}],"lt1cP":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.FormPrevious = void 0;
var _react = _interopRequireWildcard(require("cb3bf70170f1911d"));
var _StyledIcon = require("72ab7ad3e8002bf1");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var FormPrevious = exports.FormPrevious = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormPrevious"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m15 6-6 6 6 6"
    }));
});
FormPrevious.displayName = 'FormPrevious';

},{"cb3bf70170f1911d":"8CCva","72ab7ad3e8002bf1":"7Xr4o"}],"b65DD":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.FormUp = void 0;
var _react = _interopRequireWildcard(require("657dcd31eb8c0bb9"));
var _StyledIcon = require("8fe7db53d5006393");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var FormUp = exports.FormUp = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormUp"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m18 15-6-6-6 6"
    }));
});
FormUp.displayName = 'FormUp';

},{"657dcd31eb8c0bb9":"8CCva","8fe7db53d5006393":"7Xr4o"}],"jIfyP":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.Next = void 0;
var _react = _interopRequireWildcard(require("b53a47d0f735980f"));
var _StyledIcon = require("63c685617ed39c52");
var _utils = require("bac4a8d186f45818");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Next = exports.Next = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var scaleProps = (0, _utils.useScaleProps)(props);
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Next"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", _extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m7 2 10 10L7 22"
    }, scaleProps)));
});
Next.displayName = 'Next';

},{"b53a47d0f735980f":"8CCva","63c685617ed39c52":"7Xr4o","bac4a8d186f45818":"dP1kS"}],"5aPc1":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.Pause = void 0;
var _react = _interopRequireWildcard(require("e37f6893e66403ac"));
var _StyledIcon = require("afe98ed05bfdd748");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Pause = exports.Pause = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Pause"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M3 21h6V3H3v18zm12 0h6V3h-6v18z"
    }));
});
Pause.displayName = 'Pause';

},{"e37f6893e66403ac":"8CCva","afe98ed05bfdd748":"7Xr4o"}],"fPBDc":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.Play = void 0;
var _react = _interopRequireWildcard(require("b431ac5f3939ef4"));
var _StyledIcon = require("2ef7d10c509218cf");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Play = exports.Play = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Play"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m3 22 18-10L3 2z"
    }));
});
Play.displayName = 'Play';

},{"b431ac5f3939ef4":"8CCva","2ef7d10c509218cf":"7Xr4o"}],"9QKoz":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.FormPin = void 0;
var _react = _interopRequireWildcard(require("12b54d1ccefe7d6"));
var _StyledIcon = require("bef178eb81462543");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var FormPin = exports.FormPin = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormPin"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m4 19 4.455-4.454M12.273 5 18 10.727m-4.454-4.454L9.727 10.09s-2.545-.636-4.454 1.273l6.363 6.363c1.91-1.909 1.273-4.454 1.273-4.454l3.818-3.818-3.181-3.182Z"
    }));
});
FormPin.displayName = 'FormPin';

},{"12b54d1ccefe7d6":"8CCva","bef178eb81462543":"7Xr4o"}],"bSul7":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.Previous = void 0;
var _react = _interopRequireWildcard(require("77c42f21e5aa86e0"));
var _StyledIcon = require("2be355ccd2ff1351");
var _utils = require("2899cfeff285bce4");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Previous = exports.Previous = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var scaleProps = (0, _utils.useScaleProps)(props);
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Previous"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", _extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M17 2 7 12l10 10"
    }, scaleProps)));
});
Previous.displayName = 'Previous';

},{"77c42f21e5aa86e0":"8CCva","2be355ccd2ff1351":"7Xr4o","2899cfeff285bce4":"dP1kS"}],"1bGUx":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.StatusCriticalSmall = void 0;
var _react = _interopRequireWildcard(require("43a7fb3b2fad8464"));
var _StyledIcon = require("3a2dffa070470c23");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var StatusCriticalSmall = exports.StatusCriticalSmall = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 12 12",
        a11yTitle: "Status is critical"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        stroke: "#000",
        d: "M6.712 1.263a1.005 1.005 0 0 0-1.424 0L1.263 5.288a1.005 1.005 0 0 0 0 1.424l4.025 4.025a1.005 1.005 0 0 0 1.424 0l4.025-4.025a1.005 1.005 0 0 0 0-1.424L6.712 1.263z"
    }));
});
StatusCriticalSmall.displayName = 'StatusCriticalSmall';

},{"43a7fb3b2fad8464":"8CCva","3a2dffa070470c23":"7Xr4o"}],"89Utf":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.StatusGoodSmall = void 0;
var _react = _interopRequireWildcard(require("22b3f3151ea0281c"));
var _StyledIcon = require("f1b254b63c970158");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var StatusGoodSmall = exports.StatusGoodSmall = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 12 12",
        a11yTitle: "Status is okay"
    }, props), /*#__PURE__*/ _react["default"].createElement("circle", {
        cx: "6",
        cy: "6",
        r: "5",
        fillRule: "evenodd",
        stroke: "#000"
    }));
});
StatusGoodSmall.displayName = 'StatusGoodSmall';

},{"22b3f3151ea0281c":"8CCva","f1b254b63c970158":"7Xr4o"}],"02Qvt":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.StatusWarningSmall = void 0;
var _react = _interopRequireWildcard(require("7caf568dfe874482"));
var _StyledIcon = require("23ef7c7e5b70d882");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var StatusWarningSmall = exports.StatusWarningSmall = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 12 12",
        a11yTitle: "Status is warning"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fillRule: "evenodd",
        stroke: "#000",
        strokeLinejoin: "round",
        d: "m6 1 5 9H1z"
    }));
});
StatusWarningSmall.displayName = 'StatusWarningSmall';

},{"7caf568dfe874482":"8CCva","23ef7c7e5b70d882":"7Xr4o"}],"eRJFV":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.StatusUnknownSmall = void 0;
var _react = _interopRequireWildcard(require("5494d1aa7f260472"));
var _StyledIcon = require("6f960e7b1218412c");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var StatusUnknownSmall = exports.StatusUnknownSmall = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 12 12",
        a11yTitle: "Status is unknown"
    }, props), /*#__PURE__*/ _react["default"].createElement("rect", {
        width: "10",
        height: "10",
        x: "1",
        y: "1",
        fillRule: "evenodd",
        stroke: "#000",
        rx: "1"
    }));
});
StatusUnknownSmall.displayName = 'StatusUnknownSmall';

},{"5494d1aa7f260472":"8CCva","6f960e7b1218412c":"7Xr4o"}],"cadUP":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.Subtract = void 0;
var _react = _interopRequireWildcard(require("e5e6ba8e831a10ff"));
var _StyledIcon = require("4468f2359901310f");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Subtract = exports.Subtract = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Subtract"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 12h20"
    }));
});
Subtract.displayName = 'Subtract';

},{"e5e6ba8e831a10ff":"8CCva","4468f2359901310f":"7Xr4o"}],"8WFGy":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.Volume = void 0;
var _react = _interopRequireWildcard(require("23f39ba85adc0c67"));
var _StyledIcon = require("323e09f3850dfcfa");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Volume = exports.Volume = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Volume"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M15 16a4 4 0 0 0 0-8m0 12c5 0 8-3.589 8-8s-3.589-8-8-8M1 12V8h5l6-5v18l-6-5H1v-4"
    }));
});
Volume.displayName = 'Volume';

},{"23f39ba85adc0c67":"8CCva","323e09f3850dfcfa":"7Xr4o"}],"lI7gD":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.VolumeLow = void 0;
var _react = _interopRequireWildcard(require("168e47b2401e959a"));
var _StyledIcon = require("41e261de02ffc167");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var VolumeLow = exports.VolumeLow = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "VolumeLow"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 8v8h5.099L12 21V3L6 8H1zm14 8a4 4 0 1 0 0-8"
    }));
});
VolumeLow.displayName = 'VolumeLow';

},{"168e47b2401e959a":"8CCva","41e261de02ffc167":"7Xr4o"}],"jbZCB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "grommet", ()=>grommet);
var _styledComponents = require("styled-components");
var _object = require("../utils/object");
var grommet = (0, _object.deepFreeze)({
    global: {
        colors: {
            background: {
                light: '#ffffff',
                dark: '#000000'
            }
        },
        backgrounds: {
            stack: {
                color: 'light-1',
                image: "url(https://v2.grommet.io/img/stak-hurrah.svg)"
            },
            'gradient-purple-blue': {
                color: 'neutral-3',
                image: "linear-gradient(\n          #3D138D 0%, /* neutral-2 */\n          #00739D 100% /* neutral-3 */\n        );",
                rotate: 145
            },
            'gradient-purple-gold': {
                color: 'neutral-2',
                image: "linear-gradient(\n          #3D138D 0%, /* neutral-2 */\n          #EB0F79 75%,\n          #FFCA58 100% /* accent-4 */\n        );"
            }
        },
        font: {
            family: "-apple-system,\n         BlinkMacSystemFont, \n         \"Segoe UI\", \n         Roboto, \n         Oxygen, \n         Ubuntu, \n         Cantarell, \n         \"Fira Sans\", \n         \"Droid Sans\",  \n         \"Helvetica Neue\", \n         Arial, sans-serif,  \n         \"Apple Color Emoji\", \n         \"Segoe UI Emoji\", \n         \"Segoe UI Symbol\""
        }
    },
    button: {
        extend: (0, _styledComponents.css)([
            "",
            ""
        ], function(props) {
            return !props.plain && 'font-weight: bold;';
        })
    }
});

},{"styled-components":"6bGrk","../utils/object":"go0Cn","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dROnj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledGrommet", ()=>StyledGrommet);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var fullStyle = function fullStyle(full) {
    if (full === 'min') return (0, _styledComponents.css)([
        "min-height:100vh;"
    ]);
    return (0, _styledComponents.css)([
        "width:100vw;height:100vh;overflow:auto;"
    ]);
};
var StyledGrommet = (0, _styledComponentsDefault.default).div.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledGrommet",
    componentId: "sc-19lkkz7-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return !props.plain && (0, _utils.baseStyle);
}, function(props) {
    return props.full && fullStyle(props.full);
}, function(props) {
    return props.theme.global.font.face;
}, function(props) {
    return props.theme.grommet.extend;
}, function(props) {
    return props.cssVars && Object.keys(props.theme.global.colors).filter(function(k) {
        return typeof props.theme.global.colors[k] === 'string';
    }).map(function(k) {
        return "--" + k + ": " + props.theme.global.colors[k] + ";";
    }).join('\n');
});

},{"styled-components":"6bGrk","../../utils":"fx31z","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5kzBX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OptionsContext", ()=>OptionsContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var OptionsContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({});

},{"react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9V5sq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>(0, _messageContext.format));
parcelHelpers.export(exports, "MessageContext", ()=>(0, _messageContext.MessageContext));
var _messageContext = require("./MessageContext");

},{"./MessageContext":"7GNPX","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7GNPX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>_format);
parcelHelpers.export(exports, "MessageContext", ()=>MessageContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _defaultJson = require("../../languages/default.json");
var _defaultJsonDefault = parcelHelpers.interopDefault(_defaultJson);
// options:
//   id: message id
//   messages: (optional) an object of message overrides
//   values: (optional) currently unused but in the future
//     will be an object with substitution values for
//     positional variables in the message text.
//   defaultMessage: (optional) default message to use if
//     the message isn't found elsewhere.
var _format = function format(options, messages) {
    var _options$id;
    // Message id's are hierarchical. For the component-specific
    // message objects passed as options.messages, just use the last
    // component in the id for backwards compatibility.
    //
    // For overall messages passed to grommet, use the hierarchical
    // id. For that messages object, the messages are in an object
    // hierarchy by component, similar to how the theme works.
    //
    // Applications that typically keep their messages in flat
    // objects with a single key string per message can override
    // this format function to get the grommet messages from
    // their bundles that way and don't need to pass the messages
    // themselves in this property, just the format function.
    var idParts = ((_options$id = options.id) == null ? void 0 : _options$id.split('.')) || [];
    // eslint-disable-next-line no-unsafe-optional-chaining
    var baseId = idParts[(idParts == null ? void 0 : idParts.length) - 1];
    var messageObj = messages;
    idParts.forEach(function(idPart) {
        if (typeof messageObj === 'object') messageObj = messageObj[idPart];
    });
    var message = (options.messages ? options.messages[baseId] : undefined) || messageObj || options.defaultMessage;
    var values = options.values;
    var newMessage = message;
    var tokens = message == null ? void 0 : message.match(/\{(.+?)\}/g);
    tokens == null || tokens.forEach(function(token) {
        var names = token.substr(1, token.length - 2);
        var value = values[names];
        newMessage = newMessage.replace(token, value);
    });
    return values ? newMessage : message;
};
var defaultValue = {
    messages: (0, _defaultJsonDefault.default),
    format: function format(options) {
        return _format(options, (0, _defaultJsonDefault.default));
    }
};
var MessageContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(defaultValue);

},{"react":"8CCva","../../languages/default.json":"iO6JM","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iO6JM":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"button\":{\"busy\":\"button is in a busy state\",\"success\":\"button action succeeded\"},\"calendar\":{\"previousMove\":\"Moved to {date}\",\"previous\":\"Go to {date}\",\"nextMove\":\"Moved to {date}\",\"next\":\"Go to {date}\"},\"carousel\":{\"previous\":\"Go to slide {slide}\",\"next\":\"Go to slide {slide}\",\"jump\":\"Jump to slide {slide}\"},\"dateInput\":{\"openCalendar\":\"Press space to open calendar\",\"enterCalendar\":\"Calendar is open, use arrow keys and enter to select a date.\",\"exitCalendar\":\"Exited calendar dialog\"},\"dataChart\":{\"detailTitle\":\"Data chart\",\"detailFocus\":\"Use the left and right arrow keys to navigate the chart data.\"},\"dataFilters\":{\"clear\":\"Clear filters\",\"heading\":\"Filters\",\"open\":\"Open filters\",\"openSet\":{\"singular\":\"Open filters, {number} filter applied\",\"plural\":\"Open filters, {number} filters applied\"}},\"dataForm\":{\"submit\":\"Apply filters\"},\"dataSearch\":{\"label\":\"Search\",\"open\":\"Open search\"},\"dataSort\":{\"ascending\":\"Ascending\",\"by\":\"Sort by\",\"descending\":\"Descending\",\"direction\":\"Sort direction\",\"open\":\"Open sort\"},\"dataSummary\":{\"filtered\":\"{filteredTotal} results of {total} {items}\",\"filteredSingle\":\"{filteredTotal} result of {total} {items}\",\"items\":\"items\",\"itemsSingle\":\"item\",\"selected\":\"{selected} selected\",\"total\":\"{total} {items}\",\"totalSingle\":\"{total} {items}\"},\"dataTableColumns\":{\"open\":\"Open column selector\",\"order\":\"Order columns\",\"select\":\"Select columns\",\"tip\":\"Manage columns\"},\"dataTableGroupBy\":{\"clear\":\"Clear group\",\"label\":\"Group by\"},\"dataView\":{\"label\":\"View\"},\"fileInput\":{\"browse\":\"browse\",\"dropPrompt\":\"Drop file here or\",\"dropPromptMultiple\":\"Drop files here or\",\"files\":\"files\",\"maxFile\":\"Attach a maximum of {max} files only.\",\"maxSizeSingle\":\"The file is too large. Select a file no larger than {maxSize}.\",\"maxSizeMultiple\":{\"singular\":\"One file is too large. Select files which are no larger than {maxSize}.\",\"plural\":\"{numOfFiles} files are too large. Select files which are no larger than {maxSize}.\"},\"remove\":\"remove\",\"removeAll\":\"remove all\"},\"form\":{\"invalid\":\"invalid\",\"required\":\"required\"},\"formField\":{\"maxCharacters\":{\"remaining\":{\"singular\":\"{number} character left\",\"plural\":\"{number} characters left\"},\"overLimit\":{\"singular\":\"{number} character over limit\",\"plural\":\"{number} characters over limit\"}}},\"input\":{\"readOnlyCopy\":{\"prompt\":\"Copy to clipboard\",\"validation\":\"Copied\"}},\"menu\":{\"openMenu\":\"Open Menu\",\"closeMenu\":\"Close Menu\"},\"meter\":{\"bar\":{\"singular\":\"Bar meter with value {meterValue} out of {max}\",\"plural\":\"Bar meter with values {meterValue} out of {max}\"},\"circle\":{\"singular\":\"Circle meter with value {meterValue} out of {max}\",\"plural\":\"Circle meter with values {meterValue} out of {max}\"},\"pie\":{\"singular\":\"Pie meter with value {meterValue} out of {max}\",\"plural\":\"Pie meter with values {meterValue} out of {max}\"},\"semicircle\":{\"singular\":\"Semicircle meter with value {meterValue} out of {max}\",\"plural\":\"Semicircle meter with values {meterValue} out of {max}\"}},\"pagination\":{\"stepLabel\":\"Items per page\",\"summary\":\"Showing {start}-{end} of {total}\",\"summaryNoItems\":\"0 items\"},\"rangeSelector\":{\"lower\":\"Lower Bounds\",\"upper\":\"Upper Bounds\"},\"select\":{\"multiple\":\"multiple\",\"selected\":\"; Selected: {currentSelectedValue}\"},\"selectMultiple\":{\"clearAll\":\"Clear All\",\"clearAllA11y\":\"{selected} options selected. Clear all?\",\"open\":\"Open drop\",\"optionNotSelected\":\"{optionLabel} not selected\",\"optionSelected\":\"{optionLabel} selected\",\"search\":\"Search to filter options\",\"selectAll\":\"Select All\",\"selectAllA11y\":\"Select all {total} options\",\"selectDrop\":\"Select dropdown\",\"selected\":\"{selected} selected\",\"selectedOfTotal\":\"{selected} selected of {total}\",\"selectedOptions\":\"Selected options\",\"showMore\":\"+ {remaining} more\",\"summarizedValue\":\"{selected} selected\"},\"skipLinks\":{\"skipTo\":\"Skip To:\"},\"tabs\":{\"tabContents\":\"Tab Contents\"},\"tag\":{\"removeLabel\":{\"nameAndValue\":\"Remove {name}: {value}\",\"valueOnly\":\"Remove {value}\"}},\"textInput\":{\"enterSelect\":\"(Press Enter to Select)\",\"suggestionsCount\":\"suggestions available\",\"suggestionsExist\":\"This input has suggestions use arrow keys to navigate\",\"suggestionIsOpen\":\"Suggestions drop is open, continue to use arrow keys to navigate\"},\"video\":{\"audioDescriptions\":\"video audio description\",\"captions\":\"closed captions\",\"closeMenu\":\"close menu\",\"description\":\"video audio description\",\"fullScreen\":\"full screen\",\"progressMeter\":\"video progress\",\"scrubber\":\"scrubber\",\"openMenu\":\"open menu\",\"pauseButton\":\"pause\",\"playButton\":\"play\",\"volumeDown\":\"volume down\",\"volumeUp\":\"volume up\"}}");

},{}],"bgMzG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GrommetPropTypes", ()=>GrommetPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
var PropType = {};
var GrommetPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hOGZs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a11yTitlePropType", ()=>a11yTitlePropType);
parcelHelpers.export(exports, "alignPropType", ()=>alignPropType);
parcelHelpers.export(exports, "animationPropType", ()=>animationPropType);
parcelHelpers.export(exports, "colorPropType", ()=>colorPropType);
parcelHelpers.export(exports, "backgroundPropType", ()=>backgroundPropType);
parcelHelpers.export(exports, "backgroundDoc", ()=>backgroundDoc);
parcelHelpers.export(exports, "MARGIN_SIZES", ()=>MARGIN_SIZES);
parcelHelpers.export(exports, "marginProp", ()=>marginProp);
parcelHelpers.export(exports, "padPropType", ()=>padPropType);
parcelHelpers.export(exports, "genericProps", ()=>genericProps);
parcelHelpers.export(exports, "elevationPropType", ()=>elevationPropType);
parcelHelpers.export(exports, "hoverIndicatorPropType", ()=>hoverIndicatorPropType);
parcelHelpers.export(exports, "pointPropType", ()=>pointPropType);
parcelHelpers.export(exports, "patternPropType", ()=>patternPropType);
parcelHelpers.export(exports, "roundPropType", ()=>roundPropType);
parcelHelpers.export(exports, "skeletonColorsPropType", ()=>skeletonColorsPropType);
parcelHelpers.export(exports, "skeletonPropType", ()=>skeletonPropType);
parcelHelpers.export(exports, "heightPropType", ()=>heightPropType);
parcelHelpers.export(exports, "widthPropType", ()=>widthPropType);
parcelHelpers.export(exports, "OVERFLOW_VALUES", ()=>OVERFLOW_VALUES);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var a11yTitlePropType = (0, _propTypesDefault.default).string;
var alignPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).oneOf([
        'baseline',
        'center',
        'end',
        'start',
        'stretch'
    ]),
    (0, _propTypesDefault.default).string
]);
var ANIMATION_TYPE = (0, _propTypesDefault.default).oneOf([
    'fadeIn',
    'fadeOut',
    'jiggle',
    'pulse',
    'rotateLeft',
    'rotateRight',
    'slideUp',
    'slideDown',
    'slideLeft',
    'slideRight',
    'zoomIn',
    'zoomOut'
]);
var ANIMATION_SHAPE = (0, _propTypesDefault.default).shape({
    type: ANIMATION_TYPE,
    delay: (0, _propTypesDefault.default).number,
    duration: (0, _propTypesDefault.default).number,
    size: (0, _propTypesDefault.default).oneOf([
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ])
});
var animationPropType = (0, _propTypesDefault.default).oneOfType([
    ANIMATION_TYPE,
    ANIMATION_SHAPE,
    (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
        ANIMATION_TYPE,
        ANIMATION_SHAPE
    ]))
]);
var colorPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).shape({
        dark: (0, _propTypesDefault.default).string,
        light: (0, _propTypesDefault.default).string
    })
]);
var backgroundPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).shape({
        clip: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf([
                'text'
            ]),
            (0, _propTypesDefault.default).string
        ]),
        color: colorPropType,
        dark: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).bool,
            (0, _propTypesDefault.default).string
        ]),
        image: (0, _propTypesDefault.default).string,
        position: (0, _propTypesDefault.default).string,
        opacity: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).bool,
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).oneOf([
                'weak',
                'medium',
                'strong'
            ])
        ]),
        repeat: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf([
                'no-repeat',
                'repeat'
            ]),
            (0, _propTypesDefault.default).string
        ]),
        rotate: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).string
        ]),
        size: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf([
                'cover',
                'contain'
            ]),
            (0, _propTypesDefault.default).string
        ]),
        light: (0, _propTypesDefault.default).string
    })
]);
var backgroundDoc = backgroundPropType;
var MARGIN_SIZES = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge'
];
var marginProp = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).oneOf([
        'none'
    ].concat(MARGIN_SIZES)),
    (0, _propTypesDefault.default).shape({
        bottom: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf(MARGIN_SIZES),
            (0, _propTypesDefault.default).string
        ]),
        end: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf(MARGIN_SIZES),
            (0, _propTypesDefault.default).string
        ]),
        horizontal: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf(MARGIN_SIZES),
            (0, _propTypesDefault.default).string
        ]),
        left: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf(MARGIN_SIZES),
            (0, _propTypesDefault.default).string
        ]),
        right: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf(MARGIN_SIZES),
            (0, _propTypesDefault.default).string
        ]),
        start: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf(MARGIN_SIZES),
            (0, _propTypesDefault.default).string
        ]),
        top: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf(MARGIN_SIZES),
            (0, _propTypesDefault.default).string
        ]),
        vertical: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf(MARGIN_SIZES),
            (0, _propTypesDefault.default).string
        ])
    }),
    (0, _propTypesDefault.default).string
]);
var PAD_SIZES = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge'
];
var padPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).oneOf([
        'none'
    ].concat(PAD_SIZES)),
    (0, _propTypesDefault.default).shape({
        bottom: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf(PAD_SIZES),
            (0, _propTypesDefault.default).string
        ]),
        end: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf(PAD_SIZES),
            (0, _propTypesDefault.default).string
        ]),
        horizontal: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf(PAD_SIZES),
            (0, _propTypesDefault.default).string
        ]),
        left: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf(PAD_SIZES),
            (0, _propTypesDefault.default).string
        ]),
        right: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf(PAD_SIZES),
            (0, _propTypesDefault.default).string
        ]),
        start: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf(PAD_SIZES),
            (0, _propTypesDefault.default).string
        ]),
        top: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf(PAD_SIZES),
            (0, _propTypesDefault.default).string
        ]),
        vertical: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf(PAD_SIZES),
            (0, _propTypesDefault.default).string
        ])
    }),
    (0, _propTypesDefault.default).string
]);
var genericProps = {
    a11yTitle: a11yTitlePropType,
    alignSelf: (0, _propTypesDefault.default).oneOf([
        'start',
        'center',
        'end',
        'stretch',
        'baseline'
    ]),
    gridArea: (0, _propTypesDefault.default).string,
    margin: marginProp
};
var elevationPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).oneOf([
        'none',
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge'
    ]),
    (0, _propTypesDefault.default).string
]);
var hoverIndicatorPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).bool,
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).oneOf([
        'background'
    ]),
    backgroundPropType,
    (0, _propTypesDefault.default).shape({
        background: backgroundPropType,
        elevation: elevationPropType
    })
]);
var pointPropType = (0, _propTypesDefault.default).oneOf([
    'circle',
    'diamond',
    'square',
    'star',
    'triangle',
    'triangleDown'
]);
var patternPropType = (0, _propTypesDefault.default).oneOf([
    'squares',
    'circles',
    'stripesHorizontal',
    'stripesVertical',
    'stripesDiagonalDown',
    'stripesDiagonalUp'
]);
var roundPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).bool,
    (0, _propTypesDefault.default).oneOf([
        'xsmall',
        'small',
        'medium',
        'large',
        'xlarge',
        'full'
    ]),
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).shape({
        corner: (0, _propTypesDefault.default).oneOf([
            'top',
            'left',
            'bottom',
            'right',
            'top-left',
            'top-right',
            'bottom-left',
            'bottom-right'
        ]),
        size: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).oneOf([
                'xsmall',
                'small',
                'medium',
                'large',
                'xlarge'
            ]),
            (0, _propTypesDefault.default).string
        ])
    })
]);
var skeletonColorsPropType = (0, _propTypesDefault.default).shape({
    dark: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string),
    light: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).string)
});
var skeletonPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).bool,
    (0, _propTypesDefault.default).shape({
        animation: animationPropType,
        colors: skeletonColorsPropType,
        depth: (0, _propTypesDefault.default).number,
        message: (0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).shape({
                start: (0, _propTypesDefault.default).string,
                end: (0, _propTypesDefault.default).string
            })
        ])
    })
]);
var dimSizeType = (0, _propTypesDefault.default).oneOf([
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'xxlarge'
]);
var heightPropType = (0, _propTypesDefault.default).oneOfType([
    dimSizeType,
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).shape({
        height: (0, _propTypesDefault.default).oneOfType([
            dimSizeType,
            (0, _propTypesDefault.default).string
        ]),
        min: (0, _propTypesDefault.default).oneOfType([
            dimSizeType,
            (0, _propTypesDefault.default).string
        ]),
        max: (0, _propTypesDefault.default).oneOfType([
            dimSizeType,
            (0, _propTypesDefault.default).string
        ])
    })
]);
var widthPropType = (0, _propTypesDefault.default).oneOfType([
    dimSizeType,
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).shape({
        width: (0, _propTypesDefault.default).oneOfType([
            dimSizeType,
            (0, _propTypesDefault.default).string
        ]),
        min: (0, _propTypesDefault.default).oneOfType([
            dimSizeType,
            (0, _propTypesDefault.default).string
        ]),
        max: (0, _propTypesDefault.default).oneOfType([
            dimSizeType,
            (0, _propTypesDefault.default).string
        ])
    })
]);
var OVERFLOW_VALUES = [
    'auto',
    'hidden',
    'scroll',
    'visible'
];

},{"prop-types":"j03Ye","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kgfAv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
});
var e = require("b91c585cdb3f88fd"), t = require("27ecfcd84a010800");
function n(e) {
    return e && "object" == typeof e && "default" in e ? e : {
        default: e
    };
}
function o(e) {
    if (e && e.__esModule) return e;
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function(n) {
        if ("default" !== n) {
            var o = Object.getOwnPropertyDescriptor(e, n);
            Object.defineProperty(t, n, o.get ? o : {
                enumerable: !0,
                get: function() {
                    return e[n];
                }
            });
        }
    }), t.default = e, Object.freeze(t);
}
var a, l = o(e), r = n(e), i = n(t);
function s(e, t) {
    return e[t];
}
function d(e = [], t, n = 0) {
    return [
        ...e.slice(0, n),
        t,
        ...e.slice(n)
    ];
}
function c(e = [], t, n = "id") {
    const o = e.slice(), a = s(t, n);
    return a ? o.splice(o.findIndex((e)=>s(e, n) === a), 1) : o.splice(o.findIndex((e)=>e === t), 1), o;
}
function g(e) {
    return e.map((e, t)=>{
        const n = Object.assign(Object.assign({}, e), {
            sortable: e.sortable || !!e.sortFunction || void 0
        });
        return e.id || (n.id = t + 1), n;
    });
}
function u(e, t) {
    return Math.ceil(e / t);
}
function p(e, t) {
    return Math.min(e, t);
}
!function(e) {
    e.ASC = "asc", e.DESC = "desc";
}(a || (a = {}));
const b = ()=>null;
function m(e, t = [], n = []) {
    let o = {}, a = [
        ...n
    ];
    return t.length && t.forEach((t)=>{
        if (!t.when || "function" != typeof t.when) throw new Error('"when" must be defined in the conditional style object and must be function');
        t.when(e) && (o = t.style || {}, t.classNames && (a = [
            ...a,
            ...t.classNames
        ]), "function" == typeof t.style && (o = t.style(e) || {}));
    }), {
        conditionalStyle: o,
        classNames: a.join(" ")
    };
}
function f(e, t = [], n = "id") {
    const o = s(e, n);
    return o ? t.some((e)=>s(e, n) === o) : t.some((t)=>t === e);
}
function h(e, t) {
    return t ? e.findIndex((e)=>w(e.id, t)) : -1;
}
function w(e, t) {
    return e == t;
}
function x(e, t) {
    const n = !e.toggleOnSelectedRowsChange;
    switch(t.type){
        case "SELECT_ALL_ROWS":
            {
                const { keyField: n, rows: o, rowCount: a, mergeSelections: l } = t, r = !e.allSelected, i = !e.toggleOnSelectedRowsChange;
                if (l) {
                    const t = r ? [
                        ...e.selectedRows,
                        ...o.filter((t)=>!f(t, e.selectedRows, n))
                    ] : e.selectedRows.filter((e)=>!f(e, o, n));
                    return Object.assign(Object.assign({}, e), {
                        allSelected: r,
                        selectedCount: t.length,
                        selectedRows: t,
                        toggleOnSelectedRowsChange: i
                    });
                }
                return Object.assign(Object.assign({}, e), {
                    allSelected: r,
                    selectedCount: r ? a : 0,
                    selectedRows: r ? o : [],
                    toggleOnSelectedRowsChange: i
                });
            }
        case "SELECT_SINGLE_ROW":
            {
                const { keyField: o, row: a, isSelected: l, rowCount: r, singleSelect: i } = t;
                return i ? l ? Object.assign(Object.assign({}, e), {
                    selectedCount: 0,
                    allSelected: !1,
                    selectedRows: [],
                    toggleOnSelectedRowsChange: n
                }) : Object.assign(Object.assign({}, e), {
                    selectedCount: 1,
                    allSelected: !1,
                    selectedRows: [
                        a
                    ],
                    toggleOnSelectedRowsChange: n
                }) : l ? Object.assign(Object.assign({}, e), {
                    selectedCount: e.selectedRows.length > 0 ? e.selectedRows.length - 1 : 0,
                    allSelected: !1,
                    selectedRows: c(e.selectedRows, a, o),
                    toggleOnSelectedRowsChange: n
                }) : Object.assign(Object.assign({}, e), {
                    selectedCount: e.selectedRows.length + 1,
                    allSelected: e.selectedRows.length + 1 === r,
                    selectedRows: d(e.selectedRows, a),
                    toggleOnSelectedRowsChange: n
                });
            }
        case "SELECT_MULTIPLE_ROWS":
            {
                const { keyField: o, selectedRows: a, totalRows: l, mergeSelections: r } = t;
                if (r) {
                    const t = [
                        ...e.selectedRows,
                        ...a.filter((t)=>!f(t, e.selectedRows, o))
                    ];
                    return Object.assign(Object.assign({}, e), {
                        selectedCount: t.length,
                        allSelected: !1,
                        selectedRows: t,
                        toggleOnSelectedRowsChange: n
                    });
                }
                return Object.assign(Object.assign({}, e), {
                    selectedCount: a.length,
                    allSelected: a.length === l,
                    selectedRows: a,
                    toggleOnSelectedRowsChange: n
                });
            }
        case "CLEAR_SELECTED_ROWS":
            {
                const { selectedRowsFlag: n } = t;
                return Object.assign(Object.assign({}, e), {
                    allSelected: !1,
                    selectedCount: 0,
                    selectedRows: [],
                    selectedRowsFlag: n
                });
            }
        case "SORT_CHANGE":
            {
                const { sortDirection: o, selectedColumn: a, clearSelectedOnSort: l } = t;
                return Object.assign(Object.assign(Object.assign({}, e), {
                    selectedColumn: a,
                    sortDirection: o,
                    currentPage: 1
                }), l && {
                    allSelected: !1,
                    selectedCount: 0,
                    selectedRows: [],
                    toggleOnSelectedRowsChange: n
                });
            }
        case "CHANGE_PAGE":
            {
                const { page: o, paginationServer: a, visibleOnly: l, persistSelectedOnPageChange: r } = t, i = a && r, s = a && !r || l;
                return Object.assign(Object.assign(Object.assign(Object.assign({}, e), {
                    currentPage: o
                }), i && {
                    allSelected: !1
                }), s && {
                    allSelected: !1,
                    selectedCount: 0,
                    selectedRows: [],
                    toggleOnSelectedRowsChange: n
                });
            }
        case "CHANGE_ROWS_PER_PAGE":
            {
                const { rowsPerPage: n, page: o } = t;
                return Object.assign(Object.assign({}, e), {
                    currentPage: o,
                    rowsPerPage: n
                });
            }
    }
}
const C = t.css`
	pointer-events: none;
	opacity: 0.4;
`, y = i.default.div`
	position: relative;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	max-width: 100%;
	${({ disabled: e })=>e && C};
	${({ theme: e })=>e.table.style};
`, v = t.css`
	position: sticky;
	position: -webkit-sticky; /* Safari */
	top: 0;
	z-index: 1;
`, R = i.default.div`
	display: flex;
	width: 100%;
	${({ $fixedHeader: e })=>e && v};
	${({ theme: e })=>e.head.style};
`, S = i.default.div`
	display: flex;
	align-items: stretch;
	width: 100%;
	${({ theme: e })=>e.headRow.style};
	${({ $dense: e, theme: t })=>e && t.headRow.denseStyle};
`, E = (e, ...n)=>t.css`
		@media screen and (max-width: ${599}px) {
			${t.css(e, ...n)}
		}
	`, O = (e, ...n)=>t.css`
		@media screen and (max-width: ${959}px) {
			${t.css(e, ...n)}
		}
	`, $ = (e, ...n)=>t.css`
		@media screen and (max-width: ${1280}px) {
			${t.css(e, ...n)}
		}
	`, P = (e)=>(n, ...o)=>t.css`
			@media screen and (max-width: ${e}px) {
				${t.css(n, ...o)}
			}
		`, k = i.default.div`
	position: relative;
	display: flex;
	align-items: center;
	box-sizing: border-box;
	line-height: normal;
	${({ theme: e, $headCell: t })=>e[t ? "headCells" : "cells"].style};
	${({ $noPadding: e })=>e && "padding: 0"};
`, D = i.default(k)`
	flex-grow: ${({ button: e, grow: t })=>0 === t || e ? 0 : t || 1};
	flex-shrink: 0;
	flex-basis: 0;
	max-width: ${({ maxWidth: e })=>e || "100%"};
	min-width: ${({ minWidth: e })=>e || "100px"};
	${({ width: e })=>e && t.css`
			min-width: ${e};
			max-width: ${e};
		`};
	${({ right: e })=>e && "justify-content: flex-end"};
	${({ button: e, center: t })=>(t || e) && "justify-content: center"};
	${({ compact: e, button: t })=>(e || t) && "padding: 0"};

	/* handle hiding cells */
	${({ hide: e })=>e && "sm" === e && E`
    display: none;
  `};
	${({ hide: e })=>e && "md" === e && O`
    display: none;
  `};
	${({ hide: e })=>e && "lg" === e && $`
    display: none;
  `};
	${({ hide: e })=>e && Number.isInteger(e) && P(e)`
    display: none;
  `};
`, H = t.css`
	div:first-child {
		white-space: ${({ $wrapCell: e })=>e ? "normal" : "nowrap"};
		overflow: ${({ $allowOverflow: e })=>e ? "visible" : "hidden"};
		text-overflow: ellipsis;
	}
`, j = i.default(D).attrs((e)=>({
        style: e.style
    }))`
	${({ $renderAsCell: e })=>!e && H};
	${({ theme: e, $isDragging: t })=>t && e.cells.draggingStyle};
	${({ $cellStyle: e })=>e};
`;
var F = l.memo(function({ id: e, column: t, row: n, rowIndex: o, dataTag: a, isDragging: r, onDragStart: i, onDragOver: s, onDragEnd: d, onDragEnter: c, onDragLeave: g }) {
    const { conditionalStyle: u, classNames: p } = m(n, t.conditionalCellStyles, [
        "rdt_TableCell"
    ]);
    return l.createElement(j, {
        id: e,
        "data-column-id": t.id,
        role: "cell",
        className: p,
        "data-tag": a,
        $cellStyle: t.style,
        $renderAsCell: !!t.cell,
        $allowOverflow: t.allowOverflow,
        button: t.button,
        center: t.center,
        compact: t.compact,
        grow: t.grow,
        hide: t.hide,
        maxWidth: t.maxWidth,
        minWidth: t.minWidth,
        right: t.right,
        width: t.width,
        $wrapCell: t.wrap,
        style: u,
        $isDragging: r,
        onDragStart: i,
        onDragOver: s,
        onDragEnd: d,
        onDragEnter: c,
        onDragLeave: g
    }, !t.cell && l.createElement("div", {
        "data-tag": a
    }, function(e, t, n, o) {
        return t ? n && "function" == typeof n ? n(e, o) : t(e, o) : null;
    }(n, t.selector, t.format, o)), t.cell && t.cell(n, o, t, e));
});
const T = "input";
var I = l.memo(function({ name: e, component: t = T, componentOptions: n = {
    style: {}
}, indeterminate: o = !1, checked: a = !1, disabled: r = !1, onClick: i = b }) {
    const s = t, d = s !== T ? n.style : ((e)=>Object.assign(Object.assign({
            fontSize: "18px"
        }, !e && {
            cursor: "pointer"
        }), {
            padding: 0,
            marginTop: "1px",
            verticalAlign: "middle",
            position: "relative"
        }))(r), c = l.useMemo(()=>(function(e, ...t) {
            let n;
            return Object.keys(e).map((t)=>e[t]).forEach((o, a)=>{
                const l = e;
                "function" == typeof o && (n = Object.assign(Object.assign({}, l), {
                    [Object.keys(e)[a]]: o(...t)
                }));
            }), n || e;
        })(n, o), [
        n,
        o
    ]);
    return l.createElement(s, Object.assign({
        type: "checkbox",
        ref: (e)=>{
            e && (e.indeterminate = o);
        },
        style: d,
        onClick: r ? b : i,
        name: e,
        "aria-label": e,
        checked: a,
        disabled: r
    }, c, {
        onChange: b
    }));
});
const M = i.default(k)`
	flex: 0 0 48px;
	min-width: 48px;
	justify-content: center;
	align-items: center;
	user-select: none;
	white-space: nowrap;
`;
function A({ name: e, keyField: t, row: n, rowCount: o, selected: a, selectableRowsComponent: r, selectableRowsComponentProps: i, selectableRowsSingle: s, selectableRowDisabled: d, onSelectedRow: c }) {
    const g = !(!d || !d(n));
    return l.createElement(M, {
        onClick: (e)=>e.stopPropagation(),
        className: "rdt_TableCell",
        $noPadding: !0
    }, l.createElement(I, {
        name: e,
        component: r,
        componentOptions: i,
        checked: a,
        "aria-checked": a,
        onClick: ()=>{
            c({
                type: "SELECT_SINGLE_ROW",
                row: n,
                isSelected: a,
                keyField: t,
                rowCount: o,
                singleSelect: s
            });
        },
        disabled: g
    }));
}
const L = i.default.button`
	display: inline-flex;
	align-items: center;
	user-select: none;
	white-space: nowrap;
	border: none;
	background-color: transparent;
	${({ theme: e })=>e.expanderButton.style};
`;
function _({ disabled: e = !1, expanded: t = !1, expandableIcon: n, id: o, row: a, onToggled: r }) {
    const i = t ? n.expanded : n.collapsed;
    return l.createElement(L, {
        "aria-disabled": e,
        onClick: ()=>r && r(a),
        "data-testid": `expander-button-${o}`,
        disabled: e,
        "aria-label": t ? "Collapse Row" : "Expand Row",
        role: "button",
        type: "button"
    }, i);
}
const z = i.default(k)`
	white-space: nowrap;
	font-weight: 400;
	min-width: 48px;
	${({ theme: e })=>e.expanderCell.style};
`;
function N({ row: e, expanded: t = !1, expandableIcon: n, id: o, onToggled: a, disabled: r = !1 }) {
    return l.createElement(z, {
        onClick: (e)=>e.stopPropagation(),
        $noPadding: !0
    }, l.createElement(_, {
        id: o,
        row: e,
        expanded: t,
        expandableIcon: n,
        disabled: r,
        onToggled: a
    }));
}
const W = i.default.div`
	width: 100%;
	box-sizing: border-box;
	${({ theme: e })=>e.expanderRow.style};
	${({ $extendedRowStyle: e })=>e};
`;
var B = l.memo(function({ data: e, ExpanderComponent: t, expanderComponentProps: n, extendedRowStyle: o, extendedClassNames: a }) {
    const r = [
        "rdt_ExpanderRow",
        ...a.split(" ").filter((e)=>"rdt_TableRow" !== e)
    ].join(" ");
    return l.createElement(W, {
        className: r,
        $extendedRowStyle: o
    }, l.createElement(t, Object.assign({
        data: e
    }, n)));
});
const G = "allowRowEvents";
var V, U, q;
exports.Direction = void 0, (V = exports.Direction || (exports.Direction = {})).LTR = "ltr", V.RTL = "rtl", V.AUTO = "auto", exports.Alignment = void 0, (U = exports.Alignment || (exports.Alignment = {})).LEFT = "left", U.RIGHT = "right", U.CENTER = "center", exports.Media = void 0, (q = exports.Media || (exports.Media = {})).SM = "sm", q.MD = "md", q.LG = "lg";
const Y = t.css`
	&:hover {
		${({ $highlightOnHover: e, theme: t })=>e && t.rows.highlightOnHoverStyle};
	}
`, K = t.css`
	&:hover {
		cursor: pointer;
	}
`, J = i.default.div.attrs((e)=>({
        style: e.style
    }))`
	display: flex;
	align-items: stretch;
	align-content: stretch;
	width: 100%;
	box-sizing: border-box;
	${({ theme: e })=>e.rows.style};
	${({ $dense: e, theme: t })=>e && t.rows.denseStyle};
	${({ $striped: e, theme: t })=>e && t.rows.stripedStyle};
	${({ $highlightOnHover: e })=>e && Y};
	${({ $pointerOnHover: e })=>e && K};
	${({ $selected: e, theme: t })=>e && t.rows.selectedHighlightStyle};
	${({ $conditionalStyle: e })=>e};
`;
function Q({ columns: e = [], conditionalRowStyles: t = [], defaultExpanded: n = !1, defaultExpanderDisabled: o = !1, dense: a = !1, expandableIcon: r, expandableRows: i = !1, expandableRowsComponent: d, expandableRowsComponentProps: c, expandableRowsHideExpander: g, expandOnRowClicked: u = !1, expandOnRowDoubleClicked: p = !1, highlightOnHover: f = !1, id: h, expandableInheritConditionalStyles: x, keyField: C, onRowClicked: y = b, onRowDoubleClicked: v = b, onRowMouseEnter: R = b, onRowMouseLeave: S = b, onRowExpandToggled: E = b, onSelectedRow: O = b, pointerOnHover: $ = !1, row: P, rowCount: k, rowIndex: D, selectableRowDisabled: H = null, selectableRows: j = !1, selectableRowsComponent: T, selectableRowsComponentProps: I, selectableRowsHighlight: M = !1, selectableRowsSingle: L = !1, selected: _, striped: z = !1, draggingColumnId: W, onDragStart: V, onDragOver: U, onDragEnd: q, onDragEnter: Y, onDragLeave: K }) {
    const [Q, X] = l.useState(n);
    l.useEffect(()=>{
        X(n);
    }, [
        n
    ]);
    const Z = l.useCallback(()=>{
        X(!Q), E(!Q, P);
    }, [
        Q,
        E,
        P
    ]), ee = $ || i && (u || p), te = l.useCallback((e)=>{
        e.target.getAttribute("data-tag") === G && (y(P, e), !o && i && u && Z());
    }, [
        o,
        u,
        i,
        Z,
        y,
        P
    ]), ne = l.useCallback((e)=>{
        e.target.getAttribute("data-tag") === G && (v(P, e), !o && i && p && Z());
    }, [
        o,
        p,
        i,
        Z,
        v,
        P
    ]), oe = l.useCallback((e)=>{
        R(P, e);
    }, [
        R,
        P
    ]), ae = l.useCallback((e)=>{
        S(P, e);
    }, [
        S,
        P
    ]), le = s(P, C), { conditionalStyle: re, classNames: ie } = m(P, t, [
        "rdt_TableRow"
    ]), se = M && _, de = x ? re : {}, ce = z && D % 2 == 0;
    return l.createElement(l.Fragment, null, l.createElement(J, {
        id: `row-${h}`,
        role: "row",
        $striped: ce,
        $highlightOnHover: f,
        $pointerOnHover: !o && ee,
        $dense: a,
        onClick: te,
        onDoubleClick: ne,
        onMouseEnter: oe,
        onMouseLeave: ae,
        className: ie,
        $selected: se,
        $conditionalStyle: re
    }, j && l.createElement(A, {
        name: `select-row-${le}`,
        keyField: C,
        row: P,
        rowCount: k,
        selected: _,
        selectableRowsComponent: T,
        selectableRowsComponentProps: I,
        selectableRowDisabled: H,
        selectableRowsSingle: L,
        onSelectedRow: O
    }), i && !g && l.createElement(N, {
        id: le,
        expandableIcon: r,
        expanded: Q,
        row: P,
        onToggled: Z,
        disabled: o
    }), e.map((e)=>e.omit ? null : l.createElement(F, {
            id: `cell-${e.id}-${le}`,
            key: `cell-${e.id}-${le}`,
            dataTag: e.ignoreRowClick || e.button ? null : G,
            column: e,
            row: P,
            rowIndex: D,
            isDragging: w(W, e.id),
            onDragStart: V,
            onDragOver: U,
            onDragEnd: q,
            onDragEnter: Y,
            onDragLeave: K
        }))), i && Q && l.createElement(B, {
        key: `expander-${le}`,
        data: P,
        extendedRowStyle: de,
        extendedClassNames: ie,
        ExpanderComponent: d,
        expanderComponentProps: c
    }));
}
const X = i.default.span`
	padding: 2px;
	color: inherit;
	flex-grow: 0;
	flex-shrink: 0;
	${({ $sortActive: e })=>e ? "opacity: 1" : "opacity: 0"};
	${({ $sortDirection: e })=>"desc" === e && "transform: rotate(180deg)"};
`, Z = ({ sortActive: e, sortDirection: t })=>r.default.createElement(X, {
        $sortActive: e,
        $sortDirection: t
    }, "\u25B2"), ee = i.default(D)`
	${({ button: e })=>e && "text-align: center"};
	${({ theme: e, $isDragging: t })=>t && e.headCells.draggingStyle};
`, te = t.css`
	cursor: pointer;
	span.__rdt_custom_sort_icon__ {
		i,
		svg {
			transform: 'translate3d(0, 0, 0)';
			${({ $sortActive: e })=>e ? "opacity: 1" : "opacity: 0"};
			color: inherit;
			font-size: 18px;
			height: 18px;
			width: 18px;
			backface-visibility: hidden;
			transform-style: preserve-3d;
			transition-duration: 95ms;
			transition-property: transform;
		}

		&.asc i,
		&.asc svg {
			transform: rotate(180deg);
		}
	}

	${({ $sortActive: e })=>!e && t.css`
			&:hover,
			&:focus {
				opacity: 0.7;

				span,
				span.__rdt_custom_sort_icon__ * {
					opacity: 0.7;
				}
			}
		`};
`, ne = i.default.div`
	display: inline-flex;
	align-items: center;
	justify-content: inherit;
	height: 100%;
	width: 100%;
	outline: none;
	user-select: none;
	overflow: hidden;
	${({ disabled: e })=>!e && te};
`, oe = i.default.div`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;
var ae = l.memo(function({ column: e, disabled: t, draggingColumnId: n, selectedColumn: o = {}, sortDirection: r, sortIcon: i, sortServer: s, pagination: d, paginationServer: c, persistSelectedOnSort: g, selectableRowsVisibleOnly: u, onSort: p, onDragStart: b, onDragOver: m, onDragEnd: f, onDragEnter: h, onDragLeave: x }) {
    l.useEffect(()=>{
        "string" == typeof e.selector && console.error(`Warning: ${e.selector} is a string based column selector which has been deprecated as of v7 and will be removed in v8. Instead, use a selector function e.g. row => row[field]...`);
    }, []);
    const [C, y] = l.useState(!1), v = l.useRef(null);
    if (l.useEffect(()=>{
        v.current && y(v.current.scrollWidth > v.current.clientWidth);
    }, [
        C
    ]), e.omit) return null;
    const R = ()=>{
        if (!e.sortable && !e.selector) return;
        let t = r;
        w(o.id, e.id) && (t = r === a.ASC ? a.DESC : a.ASC), p({
            type: "SORT_CHANGE",
            sortDirection: t,
            selectedColumn: e,
            clearSelectedOnSort: d && c && !g || s || u
        });
    }, S = (e)=>l.createElement(Z, {
            sortActive: e,
            sortDirection: r
        }), E = ()=>l.createElement("span", {
            className: [
                r,
                "__rdt_custom_sort_icon__"
            ].join(" ")
        }, i), O = !(!e.sortable || !w(o.id, e.id)), $ = !e.sortable || t, P = e.sortable && !i && !e.right, k = e.sortable && !i && e.right, D = e.sortable && i && !e.right, H = e.sortable && i && e.right;
    return l.createElement(ee, {
        "data-column-id": e.id,
        className: "rdt_TableCol",
        $headCell: !0,
        allowOverflow: e.allowOverflow,
        button: e.button,
        compact: e.compact,
        grow: e.grow,
        hide: e.hide,
        maxWidth: e.maxWidth,
        minWidth: e.minWidth,
        right: e.right,
        center: e.center,
        width: e.width,
        draggable: e.reorder,
        $isDragging: w(e.id, n),
        onDragStart: b,
        onDragOver: m,
        onDragEnd: f,
        onDragEnter: h,
        onDragLeave: x
    }, e.name && l.createElement(ne, {
        "data-column-id": e.id,
        "data-sort-id": e.id,
        role: "columnheader",
        tabIndex: 0,
        className: "rdt_TableCol_Sortable",
        onClick: $ ? void 0 : R,
        onKeyPress: $ ? void 0 : (e)=>{
            "Enter" === e.key && R();
        },
        $sortActive: !$ && O,
        disabled: $
    }, !$ && H && E(), !$ && k && S(O), "string" == typeof e.name ? l.createElement(oe, {
        title: C ? e.name : void 0,
        ref: v,
        "data-column-id": e.id
    }, e.name) : e.name, !$ && D && E(), !$ && P && S(O)));
});
const le = i.default(k)`
	flex: 0 0 48px;
	justify-content: center;
	align-items: center;
	user-select: none;
	white-space: nowrap;
	font-size: unset;
`;
function re({ headCell: e = !0, rowData: t, keyField: n, allSelected: o, mergeSelections: a, selectedRows: r, selectableRowsComponent: i, selectableRowsComponentProps: s, selectableRowDisabled: d, onSelectAllRows: c }) {
    const g = r.length > 0 && !o, u = d ? t.filter((e)=>!d(e)) : t, p = 0 === u.length, b = Math.min(t.length, u.length);
    return l.createElement(le, {
        className: "rdt_TableCol",
        $headCell: e,
        $noPadding: !0
    }, l.createElement(I, {
        name: "select-all-rows",
        component: i,
        componentOptions: s,
        onClick: ()=>{
            c({
                type: "SELECT_ALL_ROWS",
                rows: u,
                rowCount: b,
                mergeSelections: a,
                keyField: n
            });
        },
        checked: o,
        indeterminate: g,
        disabled: p
    }));
}
function ie(e = exports.Direction.AUTO) {
    const t = "object" == typeof window, [n, o] = l.useState(!1);
    return l.useEffect(()=>{
        if (t) {
            if ("auto" !== e) o("rtl" === e);
            else {
                const e = !(!window.document || !window.document.createElement), t = document.getElementsByTagName("BODY")[0], n = document.getElementsByTagName("HTML")[0], a = "rtl" === t.dir || "rtl" === n.dir;
                o(e && a);
            }
        }
    }, [
        e,
        t
    ]), n;
}
const se = i.default.div`
	display: flex;
	align-items: center;
	flex: 1 0 auto;
	height: 100%;
	color: ${({ theme: e })=>e.contextMenu.fontColor};
	font-size: ${({ theme: e })=>e.contextMenu.fontSize};
	font-weight: 400;
`, de = i.default.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	flex-wrap: wrap;
`, ce = i.default.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	box-sizing: inherit;
	z-index: 1;
	align-items: center;
	justify-content: space-between;
	display: flex;
	${({ $rtl: e })=>e && "direction: rtl"};
	${({ theme: e })=>e.contextMenu.style};
	${({ theme: e, $visible: t })=>t && e.contextMenu.activeStyle};
`;
function ge({ contextMessage: e, contextActions: t, contextComponent: n, selectedCount: o, direction: a }) {
    const r = ie(a), i = o > 0;
    return n ? l.createElement(ce, {
        $visible: i
    }, l.cloneElement(n, {
        selectedCount: o
    })) : l.createElement(ce, {
        $visible: i,
        $rtl: r
    }, l.createElement(se, null, ((e, t, n)=>{
        if (0 === t) return null;
        const o = 1 === t ? e.singular : e.plural;
        return n ? `${t} ${e.message || ""} ${o}` : `${t} ${o} ${e.message || ""}`;
    })(e, o, r)), l.createElement(de, null, t));
}
const ue = i.default.div`
	position: relative;
	box-sizing: border-box;
	overflow: hidden;
	display: flex;
	flex: 1 1 auto;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	flex-wrap: wrap;
	${({ theme: e })=>e.header.style}
`, pe = i.default.div`
	flex: 1 0 auto;
	color: ${({ theme: e })=>e.header.fontColor};
	font-size: ${({ theme: e })=>e.header.fontSize};
	font-weight: 400;
`, be = i.default.div`
	flex: 1 0 auto;
	display: flex;
	align-items: center;
	justify-content: flex-end;

	> * {
		margin-left: 5px;
	}
`, me = ({ title: e, actions: t = null, contextMessage: n, contextActions: o, contextComponent: a, selectedCount: r, direction: i, showMenu: s = !0 })=>l.createElement(ue, {
        className: "rdt_TableHeader",
        role: "heading",
        "aria-level": 1
    }, l.createElement(pe, null, e), t && l.createElement(be, null, t), s && l.createElement(ge, {
        contextMessage: n,
        contextActions: o,
        contextComponent: a,
        direction: i,
        selectedCount: r
    }));
function fe(e, t) {
    var n = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var a = 0;
        for(o = Object.getOwnPropertySymbols(e); a < o.length; a++)t.indexOf(o[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[a]) && (n[o[a]] = e[o[a]]);
    }
    return n;
}
"function" == typeof SuppressedError && SuppressedError;
const he = {
    left: "flex-start",
    right: "flex-end",
    center: "center"
}, we = i.default.header`
	position: relative;
	display: flex;
	flex: 1 1 auto;
	box-sizing: border-box;
	align-items: center;
	padding: 4px 16px 4px 24px;
	width: 100%;
	justify-content: ${({ align: e })=>he[e]};
	flex-wrap: ${({ $wrapContent: e })=>e ? "wrap" : "nowrap"};
	${({ theme: e })=>e.subHeader.style}
`, xe = (e)=>{
    var { align: t = "right", wrapContent: n = !0 } = e, o = fe(e, [
        "align",
        "wrapContent"
    ]);
    return l.createElement(we, Object.assign({
        align: t,
        $wrapContent: n
    }, o));
}, Ce = i.default.div`
	display: flex;
	flex-direction: column;
`, ye = i.default.div`
	position: relative;
	width: 100%;
	border-radius: inherit;
	${({ $responsive: e, $fixedHeader: n })=>e && t.css`
			overflow-x: auto;

			// hidden prevents vertical scrolling in firefox when fixedHeader is disabled
			overflow-y: ${n ? "auto" : "hidden"};
			min-height: 0;
		`};

	${({ $fixedHeader: e = !1, $fixedHeaderScrollHeight: n = "100vh" })=>e && t.css`
			max-height: ${n};
			-webkit-overflow-scrolling: touch;
		`};

	${({ theme: e })=>e.responsiveWrapper.style};
`, ve = i.default.div`
	position: relative;
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	${(e)=>e.theme.progress.style};
`, Re = i.default.div`
	position: relative;
	width: 100%;
	${({ theme: e })=>e.tableWrapper.style};
`, Se = i.default(k)`
	white-space: nowrap;
	${({ theme: e })=>e.expanderCell.style};
`, Ee = i.default.div`
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	${({ theme: e })=>e.noData.style};
`, Oe = ()=>r.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, r.default.createElement("path", {
        d: "M7 10l5 5 5-5z"
    }), r.default.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    })), $e = i.default.select`
	cursor: pointer;
	height: 24px;
	max-width: 100%;
	user-select: none;
	padding-left: 8px;
	padding-right: 24px;
	box-sizing: content-box;
	font-size: inherit;
	color: inherit;
	border: none;
	background-color: transparent;
	appearance: none;
	direction: ltr;
	flex-shrink: 0;

	&::-ms-expand {
		display: none;
	}

	&:disabled::-ms-expand {
		background: #f60;
	}

	option {
		color: initial;
	}
`, Pe = i.default.div`
	position: relative;
	flex-shrink: 0;
	font-size: inherit;
	color: inherit;
	margin-top: 1px;

	svg {
		top: 0;
		right: 0;
		color: inherit;
		position: absolute;
		fill: currentColor;
		width: 24px;
		height: 24px;
		display: inline-block;
		user-select: none;
		pointer-events: none;
	}
`, ke = (e)=>{
    var { defaultValue: t, onChange: n } = e, o = fe(e, [
        "defaultValue",
        "onChange"
    ]);
    return l.createElement(Pe, null, l.createElement($e, Object.assign({
        onChange: n,
        defaultValue: t
    }, o)), l.createElement(Oe, null));
}, De = {
    columns: [],
    data: [],
    title: "",
    keyField: "id",
    selectableRows: !1,
    selectableRowsHighlight: !1,
    selectableRowsNoSelectAll: !1,
    selectableRowSelected: null,
    selectableRowDisabled: null,
    selectableRowsComponent: "input",
    selectableRowsComponentProps: {},
    selectableRowsVisibleOnly: !1,
    selectableRowsSingle: !1,
    clearSelectedRows: !1,
    expandableRows: !1,
    expandableRowDisabled: null,
    expandableRowExpanded: null,
    expandOnRowClicked: !1,
    expandableRowsHideExpander: !1,
    expandOnRowDoubleClicked: !1,
    expandableInheritConditionalStyles: !1,
    expandableRowsComponent: function() {
        return r.default.createElement("div", null, "To add an expander pass in a component instance via ", r.default.createElement("strong", null, "expandableRowsComponent"), ". You can then access props.data from this component.");
    },
    expandableIcon: {
        collapsed: r.default.createElement(()=>r.default.createElement("svg", {
                fill: "currentColor",
                height: "24",
                viewBox: "0 0 24 24",
                width: "24",
                xmlns: "http://www.w3.org/2000/svg"
            }, r.default.createElement("path", {
                d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
            }), r.default.createElement("path", {
                d: "M0-.25h24v24H0z",
                fill: "none"
            })), null),
        expanded: r.default.createElement(()=>r.default.createElement("svg", {
                fill: "currentColor",
                height: "24",
                viewBox: "0 0 24 24",
                width: "24",
                xmlns: "http://www.w3.org/2000/svg"
            }, r.default.createElement("path", {
                d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
            }), r.default.createElement("path", {
                d: "M0-.75h24v24H0z",
                fill: "none"
            })), null)
    },
    expandableRowsComponentProps: {},
    progressPending: !1,
    progressComponent: r.default.createElement("div", {
        style: {
            fontSize: "24px",
            fontWeight: 700,
            padding: "24px"
        }
    }, "Loading..."),
    persistTableHead: !1,
    sortIcon: null,
    sortFunction: null,
    sortServer: !1,
    striped: !1,
    highlightOnHover: !1,
    pointerOnHover: !1,
    noContextMenu: !1,
    contextMessage: {
        singular: "item",
        plural: "items",
        message: "selected"
    },
    actions: null,
    contextActions: null,
    contextComponent: null,
    defaultSortFieldId: null,
    defaultSortAsc: !0,
    responsive: !0,
    noDataComponent: r.default.createElement("div", {
        style: {
            padding: "24px"
        }
    }, "There are no records to display"),
    disabled: !1,
    noTableHead: !1,
    noHeader: !1,
    subHeader: !1,
    subHeaderAlign: exports.Alignment.RIGHT,
    subHeaderWrap: !0,
    subHeaderComponent: null,
    fixedHeader: !1,
    fixedHeaderScrollHeight: "100vh",
    pagination: !1,
    paginationServer: !1,
    paginationServerOptions: {
        persistSelectedOnSort: !1,
        persistSelectedOnPageChange: !1
    },
    paginationDefaultPage: 1,
    paginationResetDefaultPage: !1,
    paginationTotalRows: 0,
    paginationPerPage: 10,
    paginationRowsPerPageOptions: [
        10,
        15,
        20,
        25,
        30
    ],
    paginationComponent: null,
    paginationComponentOptions: {},
    paginationIconFirstPage: r.default.createElement(()=>r.default.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "aria-hidden": "true",
            role: "presentation"
        }, r.default.createElement("path", {
            d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
        }), r.default.createElement("path", {
            fill: "none",
            d: "M24 24H0V0h24v24z"
        })), null),
    paginationIconLastPage: r.default.createElement(()=>r.default.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "aria-hidden": "true",
            role: "presentation"
        }, r.default.createElement("path", {
            d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
        }), r.default.createElement("path", {
            fill: "none",
            d: "M0 0h24v24H0V0z"
        })), null),
    paginationIconNext: r.default.createElement(()=>r.default.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "aria-hidden": "true",
            role: "presentation"
        }, r.default.createElement("path", {
            d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
        }), r.default.createElement("path", {
            d: "M0 0h24v24H0z",
            fill: "none"
        })), null),
    paginationIconPrevious: r.default.createElement(()=>r.default.createElement("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            "aria-hidden": "true",
            role: "presentation"
        }, r.default.createElement("path", {
            d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
        }), r.default.createElement("path", {
            d: "M0 0h24v24H0z",
            fill: "none"
        })), null),
    dense: !1,
    conditionalRowStyles: [],
    theme: "default",
    customStyles: {},
    direction: exports.Direction.AUTO,
    onChangePage: b,
    onChangeRowsPerPage: b,
    onRowClicked: b,
    onRowDoubleClicked: b,
    onRowMouseEnter: b,
    onRowMouseLeave: b,
    onRowExpandToggled: b,
    onSelectedRowsChange: b,
    onSort: b,
    onColumnOrderChange: b
}, He = {
    rowsPerPageText: "Rows per page:",
    rangeSeparatorText: "of",
    noRowsPerPage: !1,
    selectAllRowsItem: !1,
    selectAllRowsItemText: "All"
}, je = i.default.nav`
	display: flex;
	flex: 1 1 auto;
	justify-content: flex-end;
	align-items: center;
	box-sizing: border-box;
	padding-right: 8px;
	padding-left: 8px;
	width: 100%;
	${({ theme: e })=>e.pagination.style};
`, Fe = i.default.button`
	position: relative;
	display: block;
	user-select: none;
	border: none;
	${({ theme: e })=>e.pagination.pageButtonsStyle};
	${({ $isRTL: e })=>e && "transform: scale(-1, -1)"};
`, Te = i.default.div`
	display: flex;
	align-items: center;
	border-radius: 4px;
	white-space: nowrap;
	${E`
    width: 100%;
    justify-content: space-around;
  `};
`, Ie = i.default.span`
	flex-shrink: 1;
	user-select: none;
`, Me = i.default(Ie)`
	margin: 0 24px;
`, Ae = i.default(Ie)`
	margin: 0 4px;
`;
var Le = l.memo(function({ rowsPerPage: e, rowCount: t, currentPage: n, direction: o = De.direction, paginationRowsPerPageOptions: a = De.paginationRowsPerPageOptions, paginationIconLastPage: r = De.paginationIconLastPage, paginationIconFirstPage: i = De.paginationIconFirstPage, paginationIconNext: s = De.paginationIconNext, paginationIconPrevious: d = De.paginationIconPrevious, paginationComponentOptions: c = De.paginationComponentOptions, onChangeRowsPerPage: g = De.onChangeRowsPerPage, onChangePage: p = De.onChangePage }) {
    const b = (()=>{
        const e = "object" == typeof window;
        function t() {
            return {
                width: e ? window.innerWidth : void 0,
                height: e ? window.innerHeight : void 0
            };
        }
        const [n, o] = l.useState(t);
        return l.useEffect(()=>{
            if (!e) return ()=>null;
            function n() {
                o(t());
            }
            return window.addEventListener("resize", n), ()=>window.removeEventListener("resize", n);
        }, []), n;
    })(), m = ie(o), f = b.width && b.width > 599, h = u(t, e), w = n * e, x = w - e + 1, C = 1 === n, y = n === h, v = Object.assign(Object.assign({}, He), c), R = n === h ? `${x}-${t} ${v.rangeSeparatorText} ${t}` : `${x}-${w} ${v.rangeSeparatorText} ${t}`, S = l.useCallback(()=>p(n - 1), [
        n,
        p
    ]), E = l.useCallback(()=>p(n + 1), [
        n,
        p
    ]), O = l.useCallback(()=>p(1), [
        p
    ]), $ = l.useCallback(()=>p(u(t, e)), [
        p,
        t,
        e
    ]), P = l.useCallback((e)=>g(Number(e.target.value), n), [
        n,
        g
    ]), k = a.map((e)=>l.createElement("option", {
            key: e,
            value: e
        }, e));
    v.selectAllRowsItem && k.push(l.createElement("option", {
        key: -1,
        value: t
    }, v.selectAllRowsItemText));
    const D = l.createElement(ke, {
        onChange: P,
        defaultValue: e,
        "aria-label": v.rowsPerPageText
    }, k);
    return l.createElement(je, {
        className: "rdt_Pagination"
    }, !v.noRowsPerPage && f && l.createElement(l.Fragment, null, l.createElement(Ae, null, v.rowsPerPageText), D), f && l.createElement(Me, null, R), l.createElement(Te, null, l.createElement(Fe, {
        id: "pagination-first-page",
        type: "button",
        "aria-label": "First Page",
        "aria-disabled": C,
        onClick: O,
        disabled: C,
        $isRTL: m
    }, i), l.createElement(Fe, {
        id: "pagination-previous-page",
        type: "button",
        "aria-label": "Previous Page",
        "aria-disabled": C,
        onClick: S,
        disabled: C,
        $isRTL: m
    }, d), !v.noRowsPerPage && !f && D, l.createElement(Fe, {
        id: "pagination-next-page",
        type: "button",
        "aria-label": "Next Page",
        "aria-disabled": y,
        onClick: E,
        disabled: y,
        $isRTL: m
    }, s), l.createElement(Fe, {
        id: "pagination-last-page",
        type: "button",
        "aria-label": "Last Page",
        "aria-disabled": y,
        onClick: $,
        disabled: y,
        $isRTL: m
    }, r)));
});
const _e = (e, t)=>{
    const n = l.useRef(!0);
    l.useEffect(()=>{
        n.current ? n.current = !1 : e();
    }, t);
};
function ze(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ne = function(e) {
    return function(e) {
        return !!e && "object" == typeof e;
    }(e) && !function(e) {
        var t = Object.prototype.toString.call(e);
        return "[object RegExp]" === t || "[object Date]" === t || function(e) {
            return e.$$typeof === We;
        }(e);
    }(e);
};
var We = "function" == typeof Symbol && Symbol.for ? Symbol.for("react.element") : 60103;
function Be(e, t) {
    var n;
    return !1 !== t.clone && t.isMergeableObject(e) ? Ye((n = e, Array.isArray(n) ? [] : {}), e, t) : e;
}
function Ge(e, t, n) {
    return e.concat(t).map(function(e) {
        return Be(e, n);
    });
}
function Ve(e) {
    return Object.keys(e).concat(function(e) {
        return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
            return Object.propertyIsEnumerable.call(e, t);
        }) : [];
    }(e));
}
function Ue(e, t) {
    try {
        return t in e;
    } catch (e) {
        return !1;
    }
}
function qe(e, t, n) {
    var o = {};
    return n.isMergeableObject(e) && Ve(e).forEach(function(t) {
        o[t] = Be(e[t], n);
    }), Ve(t).forEach(function(a) {
        (function(e, t) {
            return Ue(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
        })(e, a) || (Ue(e, a) && n.isMergeableObject(t[a]) ? o[a] = (function(e, t) {
            if (!t.customMerge) return Ye;
            var n = t.customMerge(e);
            return "function" == typeof n ? n : Ye;
        })(a, n)(e[a], t[a], n) : o[a] = Be(t[a], n));
    }), o;
}
function Ye(e, t, n) {
    (n = n || {}).arrayMerge = n.arrayMerge || Ge, n.isMergeableObject = n.isMergeableObject || Ne, n.cloneUnlessOtherwiseSpecified = Be;
    var o = Array.isArray(t);
    return o === Array.isArray(e) ? o ? n.arrayMerge(e, t, n) : qe(e, t, n) : Be(t, n);
}
Ye.all = function(e, t) {
    if (!Array.isArray(e)) throw new Error("first argument should be an array");
    return e.reduce(function(e, n) {
        return Ye(e, n, t);
    }, {});
};
var Ke = ze(Ye);
const Je = {
    text: {
        primary: "rgba(0, 0, 0, 0.87)",
        secondary: "rgba(0, 0, 0, 0.54)",
        disabled: "rgba(0, 0, 0, 0.38)"
    },
    background: {
        default: "#FFFFFF"
    },
    context: {
        background: "#e3f2fd",
        text: "rgba(0, 0, 0, 0.87)"
    },
    divider: {
        default: "rgba(0,0,0,.12)"
    },
    button: {
        default: "rgba(0,0,0,.54)",
        focus: "rgba(0,0,0,.12)",
        hover: "rgba(0,0,0,.12)",
        disabled: "rgba(0, 0, 0, .18)"
    },
    selected: {
        default: "#e3f2fd",
        text: "rgba(0, 0, 0, 0.87)"
    },
    highlightOnHover: {
        default: "#EEEEEE",
        text: "rgba(0, 0, 0, 0.87)"
    },
    striped: {
        default: "#FAFAFA",
        text: "rgba(0, 0, 0, 0.87)"
    }
}, Qe = {
    default: Je,
    light: Je,
    dark: {
        text: {
            primary: "#FFFFFF",
            secondary: "rgba(255, 255, 255, 0.7)",
            disabled: "rgba(0,0,0,.12)"
        },
        background: {
            default: "#424242"
        },
        context: {
            background: "#E91E63",
            text: "#FFFFFF"
        },
        divider: {
            default: "rgba(81, 81, 81, 1)"
        },
        button: {
            default: "#FFFFFF",
            focus: "rgba(255, 255, 255, .54)",
            hover: "rgba(255, 255, 255, .12)",
            disabled: "rgba(255, 255, 255, .18)"
        },
        selected: {
            default: "rgba(0, 0, 0, .7)",
            text: "#FFFFFF"
        },
        highlightOnHover: {
            default: "rgba(0, 0, 0, .7)",
            text: "#FFFFFF"
        },
        striped: {
            default: "rgba(0, 0, 0, .87)",
            text: "#FFFFFF"
        }
    }
};
function Xe(e, t, n, o) {
    const [r, i] = l.useState(()=>g(e)), [s, d] = l.useState(""), c = l.useRef("");
    _e(()=>{
        i(g(e));
    }, [
        e
    ]);
    const u = l.useCallback((e)=>{
        var t, n, o;
        const { attributes: a } = e.target, l = null === (t = a.getNamedItem("data-column-id")) || void 0 === t ? void 0 : t.value;
        l && (c.current = (null === (o = null === (n = r[h(r, l)]) || void 0 === n ? void 0 : n.id) || void 0 === o ? void 0 : o.toString()) || "", d(c.current));
    }, [
        r
    ]), p = l.useCallback((e)=>{
        var n;
        const { attributes: o } = e.target, a = null === (n = o.getNamedItem("data-column-id")) || void 0 === n ? void 0 : n.value;
        if (a && c.current && a !== c.current) {
            const e = h(r, c.current), n = h(r, a), o = [
                ...r
            ];
            o[e] = r[n], o[n] = r[e], i(o), t(o);
        }
    }, [
        t,
        r
    ]), b = l.useCallback((e)=>{
        e.preventDefault();
    }, []), m = l.useCallback((e)=>{
        e.preventDefault();
    }, []), f = l.useCallback((e)=>{
        e.preventDefault(), c.current = "", d("");
    }, []), w = function(e = !1) {
        return e ? a.ASC : a.DESC;
    }(o), x = l.useMemo(()=>r[h(r, null == n ? void 0 : n.toString())] || {}, [
        n,
        r
    ]);
    return {
        tableColumns: r,
        draggingColumnId: s,
        handleDragStart: u,
        handleDragEnter: p,
        handleDragOver: b,
        handleDragLeave: m,
        handleDragEnd: f,
        defaultSortDirection: w,
        defaultSortColumn: x
    };
}
var Ze = l.memo(function(e) {
    const { data: n = De.data, columns: o = De.columns, title: r = De.title, actions: i = De.actions, keyField: d = De.keyField, striped: c = De.striped, highlightOnHover: g = De.highlightOnHover, pointerOnHover: b = De.pointerOnHover, dense: m = De.dense, selectableRows: h = De.selectableRows, selectableRowsSingle: w = De.selectableRowsSingle, selectableRowsHighlight: C = De.selectableRowsHighlight, selectableRowsNoSelectAll: v = De.selectableRowsNoSelectAll, selectableRowsVisibleOnly: E = De.selectableRowsVisibleOnly, selectableRowSelected: O = De.selectableRowSelected, selectableRowDisabled: $ = De.selectableRowDisabled, selectableRowsComponent: P = De.selectableRowsComponent, selectableRowsComponentProps: D = De.selectableRowsComponentProps, onRowExpandToggled: H = De.onRowExpandToggled, onSelectedRowsChange: j = De.onSelectedRowsChange, expandableIcon: F = De.expandableIcon, onChangeRowsPerPage: T = De.onChangeRowsPerPage, onChangePage: I = De.onChangePage, paginationServer: M = De.paginationServer, paginationServerOptions: A = De.paginationServerOptions, paginationTotalRows: L = De.paginationTotalRows, paginationDefaultPage: _ = De.paginationDefaultPage, paginationResetDefaultPage: z = De.paginationResetDefaultPage, paginationPerPage: N = De.paginationPerPage, paginationRowsPerPageOptions: W = De.paginationRowsPerPageOptions, paginationIconLastPage: B = De.paginationIconLastPage, paginationIconFirstPage: G = De.paginationIconFirstPage, paginationIconNext: V = De.paginationIconNext, paginationIconPrevious: U = De.paginationIconPrevious, paginationComponent: q = De.paginationComponent, paginationComponentOptions: Y = De.paginationComponentOptions, responsive: K = De.responsive, progressPending: J = De.progressPending, progressComponent: X = De.progressComponent, persistTableHead: Z = De.persistTableHead, noDataComponent: ee = De.noDataComponent, disabled: te = De.disabled, noTableHead: ne = De.noTableHead, noHeader: oe = De.noHeader, fixedHeader: le = De.fixedHeader, fixedHeaderScrollHeight: ie = De.fixedHeaderScrollHeight, pagination: se = De.pagination, subHeader: de = De.subHeader, subHeaderAlign: ce = De.subHeaderAlign, subHeaderWrap: ge = De.subHeaderWrap, subHeaderComponent: ue = De.subHeaderComponent, noContextMenu: pe = De.noContextMenu, contextMessage: be = De.contextMessage, contextActions: fe = De.contextActions, contextComponent: he = De.contextComponent, expandableRows: we = De.expandableRows, onRowClicked: Oe = De.onRowClicked, onRowDoubleClicked: $e = De.onRowDoubleClicked, onRowMouseEnter: Pe = De.onRowMouseEnter, onRowMouseLeave: ke = De.onRowMouseLeave, sortIcon: He = De.sortIcon, onSort: je = De.onSort, sortFunction: Fe = De.sortFunction, sortServer: Te = De.sortServer, expandableRowsComponent: Ie = De.expandableRowsComponent, expandableRowsComponentProps: Me = De.expandableRowsComponentProps, expandableRowDisabled: Ae = De.expandableRowDisabled, expandableRowsHideExpander: ze = De.expandableRowsHideExpander, expandOnRowClicked: Ne = De.expandOnRowClicked, expandOnRowDoubleClicked: We = De.expandOnRowDoubleClicked, expandableRowExpanded: Be = De.expandableRowExpanded, expandableInheritConditionalStyles: Ge = De.expandableInheritConditionalStyles, defaultSortFieldId: Ve = De.defaultSortFieldId, defaultSortAsc: Ue = De.defaultSortAsc, clearSelectedRows: qe = De.clearSelectedRows, conditionalRowStyles: Ye = De.conditionalRowStyles, theme: Je = De.theme, customStyles: Ze = De.customStyles, direction: et = De.direction, onColumnOrderChange: tt = De.onColumnOrderChange, className: nt, ariaLabel: ot } = e, { tableColumns: at, draggingColumnId: lt, handleDragStart: rt, handleDragEnter: it, handleDragOver: st, handleDragLeave: dt, handleDragEnd: ct, defaultSortDirection: gt, defaultSortColumn: ut } = Xe(o, tt, Ve, Ue), [{ rowsPerPage: pt, currentPage: bt, selectedRows: mt, allSelected: ft, selectedCount: ht, selectedColumn: wt, sortDirection: xt, toggleOnSelectedRowsChange: Ct }, yt] = l.useReducer(x, {
        allSelected: !1,
        selectedCount: 0,
        selectedRows: [],
        selectedColumn: ut,
        toggleOnSelectedRowsChange: !1,
        sortDirection: gt,
        currentPage: _,
        rowsPerPage: N,
        selectedRowsFlag: !1,
        contextMessage: De.contextMessage
    }), { persistSelectedOnSort: vt = !1, persistSelectedOnPageChange: Rt = !1 } = A, St = !(!M || !Rt && !vt), Et = se && !J && n.length > 0, Ot = q || Le, $t = l.useMemo(()=>((e = {}, t = "default", n = "default")=>{
            const o = Qe[t] ? t : n;
            var a;
            return Ke({
                table: {
                    style: {
                        color: (a = Qe[o]).text.primary,
                        backgroundColor: a.background.default
                    }
                },
                tableWrapper: {
                    style: {
                        display: "table"
                    }
                },
                responsiveWrapper: {
                    style: {}
                },
                header: {
                    style: {
                        fontSize: "22px",
                        color: a.text.primary,
                        backgroundColor: a.background.default,
                        minHeight: "56px",
                        paddingLeft: "16px",
                        paddingRight: "8px"
                    }
                },
                subHeader: {
                    style: {
                        backgroundColor: a.background.default,
                        minHeight: "52px"
                    }
                },
                head: {
                    style: {
                        color: a.text.primary,
                        fontSize: "12px",
                        fontWeight: 500
                    }
                },
                headRow: {
                    style: {
                        backgroundColor: a.background.default,
                        minHeight: "52px",
                        borderBottomWidth: "1px",
                        borderBottomColor: a.divider.default,
                        borderBottomStyle: "solid"
                    },
                    denseStyle: {
                        minHeight: "32px"
                    }
                },
                headCells: {
                    style: {
                        paddingLeft: "16px",
                        paddingRight: "16px"
                    },
                    draggingStyle: {
                        cursor: "move"
                    }
                },
                contextMenu: {
                    style: {
                        backgroundColor: a.context.background,
                        fontSize: "18px",
                        fontWeight: 400,
                        color: a.context.text,
                        paddingLeft: "16px",
                        paddingRight: "8px",
                        transform: "translate3d(0, -100%, 0)",
                        transitionDuration: "125ms",
                        transitionTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
                        willChange: "transform"
                    },
                    activeStyle: {
                        transform: "translate3d(0, 0, 0)"
                    }
                },
                cells: {
                    style: {
                        paddingLeft: "16px",
                        paddingRight: "16px",
                        wordBreak: "break-word"
                    },
                    draggingStyle: {}
                },
                rows: {
                    style: {
                        fontSize: "13px",
                        fontWeight: 400,
                        color: a.text.primary,
                        backgroundColor: a.background.default,
                        minHeight: "48px",
                        "&:not(:last-of-type)": {
                            borderBottomStyle: "solid",
                            borderBottomWidth: "1px",
                            borderBottomColor: a.divider.default
                        }
                    },
                    denseStyle: {
                        minHeight: "32px"
                    },
                    selectedHighlightStyle: {
                        "&:nth-of-type(n)": {
                            color: a.selected.text,
                            backgroundColor: a.selected.default,
                            borderBottomColor: a.background.default
                        }
                    },
                    highlightOnHoverStyle: {
                        color: a.highlightOnHover.text,
                        backgroundColor: a.highlightOnHover.default,
                        transitionDuration: "0.15s",
                        transitionProperty: "background-color",
                        borderBottomColor: a.background.default,
                        outlineStyle: "solid",
                        outlineWidth: "1px",
                        outlineColor: a.background.default
                    },
                    stripedStyle: {
                        color: a.striped.text,
                        backgroundColor: a.striped.default
                    }
                },
                expanderRow: {
                    style: {
                        color: a.text.primary,
                        backgroundColor: a.background.default
                    }
                },
                expanderCell: {
                    style: {
                        flex: "0 0 48px"
                    }
                },
                expanderButton: {
                    style: {
                        color: a.button.default,
                        fill: a.button.default,
                        backgroundColor: "transparent",
                        borderRadius: "2px",
                        transition: "0.25s",
                        height: "100%",
                        width: "100%",
                        "&:hover:enabled": {
                            cursor: "pointer"
                        },
                        "&:disabled": {
                            color: a.button.disabled
                        },
                        "&:hover:not(:disabled)": {
                            cursor: "pointer",
                            backgroundColor: a.button.hover
                        },
                        "&:focus": {
                            outline: "none",
                            backgroundColor: a.button.focus
                        },
                        svg: {
                            margin: "auto"
                        }
                    }
                },
                pagination: {
                    style: {
                        color: a.text.secondary,
                        fontSize: "13px",
                        minHeight: "56px",
                        backgroundColor: a.background.default,
                        borderTopStyle: "solid",
                        borderTopWidth: "1px",
                        borderTopColor: a.divider.default
                    },
                    pageButtonsStyle: {
                        borderRadius: "50%",
                        height: "40px",
                        width: "40px",
                        padding: "8px",
                        margin: "px",
                        cursor: "pointer",
                        transition: "0.4s",
                        color: a.button.default,
                        fill: a.button.default,
                        backgroundColor: "transparent",
                        "&:disabled": {
                            cursor: "unset",
                            color: a.button.disabled,
                            fill: a.button.disabled
                        },
                        "&:hover:not(:disabled)": {
                            backgroundColor: a.button.hover
                        },
                        "&:focus": {
                            outline: "none",
                            backgroundColor: a.button.focus
                        }
                    }
                },
                noData: {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: a.text.primary,
                        backgroundColor: a.background.default
                    }
                },
                progress: {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: a.text.primary,
                        backgroundColor: a.background.default
                    }
                }
            }, e);
        })(Ze, Je), [
        Ze,
        Je
    ]), Pt = l.useMemo(()=>Object.assign({}, "auto" !== et && {
            dir: et
        }), [
        et
    ]), kt = l.useMemo(()=>{
        if (Te) return n;
        if ((null == wt ? void 0 : wt.sortFunction) && "function" == typeof wt.sortFunction) {
            const e = wt.sortFunction, t = xt === a.ASC ? e : (t, n)=>-1 * e(t, n);
            return [
                ...n
            ].sort(t);
        }
        return function(e, t, n, o) {
            return t ? o && "function" == typeof o ? o(e.slice(0), t, n) : e.slice(0).sort((e, o)=>{
                const a = t(e), l = t(o);
                if ("asc" === n) {
                    if (a < l) return -1;
                    if (a > l) return 1;
                }
                if ("desc" === n) {
                    if (a > l) return -1;
                    if (a < l) return 1;
                }
                return 0;
            }) : e;
        }(n, null == wt ? void 0 : wt.selector, xt, Fe);
    }, [
        Te,
        wt,
        xt,
        n,
        Fe
    ]), Dt = l.useMemo(()=>{
        if (se && !M) {
            const e = bt * pt, t = e - pt;
            return kt.slice(t, e);
        }
        return kt;
    }, [
        bt,
        se,
        M,
        pt,
        kt
    ]), Ht = l.useCallback((e)=>{
        yt(e);
    }, []), jt = l.useCallback((e)=>{
        yt(e);
    }, []), Ft = l.useCallback((e)=>{
        yt(e);
    }, []), Tt = l.useCallback((e, t)=>Oe(e, t), [
        Oe
    ]), It = l.useCallback((e, t)=>$e(e, t), [
        $e
    ]), Mt = l.useCallback((e, t)=>Pe(e, t), [
        Pe
    ]), At = l.useCallback((e, t)=>ke(e, t), [
        ke
    ]), Lt = l.useCallback((e)=>yt({
            type: "CHANGE_PAGE",
            page: e,
            paginationServer: M,
            visibleOnly: E,
            persistSelectedOnPageChange: Rt
        }), [
        M,
        Rt,
        E
    ]), _t = l.useCallback((e)=>{
        const t = u(L || Dt.length, e), n = p(bt, t);
        M || Lt(n), yt({
            type: "CHANGE_ROWS_PER_PAGE",
            page: n,
            rowsPerPage: e
        });
    }, [
        bt,
        Lt,
        M,
        L,
        Dt.length
    ]);
    if (se && !M && kt.length > 0 && 0 === Dt.length) {
        const e = u(kt.length, pt), t = p(bt, e);
        Lt(t);
    }
    _e(()=>{
        j({
            allSelected: ft,
            selectedCount: ht,
            selectedRows: mt.slice(0)
        });
    }, [
        Ct
    ]), _e(()=>{
        je(wt, xt, kt.slice(0));
    }, [
        wt,
        xt
    ]), _e(()=>{
        I(bt, L || kt.length);
    }, [
        bt
    ]), _e(()=>{
        T(pt, bt);
    }, [
        pt
    ]), _e(()=>{
        Lt(_);
    }, [
        _,
        z
    ]), _e(()=>{
        if (se && M && L > 0) {
            const e = u(L, pt), t = p(bt, e);
            bt !== t && Lt(t);
        }
    }, [
        L
    ]), l.useEffect(()=>{
        yt({
            type: "CLEAR_SELECTED_ROWS",
            selectedRowsFlag: qe
        });
    }, [
        w,
        qe
    ]), l.useEffect(()=>{
        if (!O) return;
        const e = kt.filter((e)=>O(e)), t = w ? e.slice(0, 1) : e;
        yt({
            type: "SELECT_MULTIPLE_ROWS",
            keyField: d,
            selectedRows: t,
            totalRows: kt.length,
            mergeSelections: St
        });
    }, [
        n,
        O
    ]);
    const zt = E ? Dt : kt, Nt = Rt || w || v;
    return l.createElement(t.ThemeProvider, {
        theme: $t
    }, !oe && (!!r || !!i) && l.createElement(me, {
        title: r,
        actions: i,
        showMenu: !pe,
        selectedCount: ht,
        direction: et,
        contextActions: fe,
        contextComponent: he,
        contextMessage: be
    }), de && l.createElement(xe, {
        align: ce,
        wrapContent: ge
    }, ue), l.createElement(ye, Object.assign({
        $responsive: K,
        $fixedHeader: le,
        $fixedHeaderScrollHeight: ie,
        className: nt
    }, Pt), l.createElement(Re, null, J && !Z && l.createElement(ve, null, X), l.createElement(y, Object.assign({
        disabled: te,
        className: "rdt_Table",
        role: "table"
    }, ot && {
        "aria-label": ot
    }), !ne && (!!Z || kt.length > 0 && !J) && l.createElement(R, {
        className: "rdt_TableHead",
        role: "rowgroup",
        $fixedHeader: le
    }, l.createElement(S, {
        className: "rdt_TableHeadRow",
        role: "row",
        $dense: m
    }, h && (Nt ? l.createElement(k, {
        style: {
            flex: "0 0 48px"
        }
    }) : l.createElement(re, {
        allSelected: ft,
        selectedRows: mt,
        selectableRowsComponent: P,
        selectableRowsComponentProps: D,
        selectableRowDisabled: $,
        rowData: zt,
        keyField: d,
        mergeSelections: St,
        onSelectAllRows: jt
    })), we && !ze && l.createElement(Se, null), at.map((e)=>l.createElement(ae, {
            key: e.id,
            column: e,
            selectedColumn: wt,
            disabled: J || 0 === kt.length,
            pagination: se,
            paginationServer: M,
            persistSelectedOnSort: vt,
            selectableRowsVisibleOnly: E,
            sortDirection: xt,
            sortIcon: He,
            sortServer: Te,
            onSort: Ht,
            onDragStart: rt,
            onDragOver: st,
            onDragEnd: ct,
            onDragEnter: it,
            onDragLeave: dt,
            draggingColumnId: lt
        })))), !kt.length && !J && l.createElement(Ee, null, ee), J && Z && l.createElement(ve, null, X), !J && kt.length > 0 && l.createElement(Ce, {
        className: "rdt_TableBody",
        role: "rowgroup"
    }, Dt.map((e, t)=>{
        const n = s(e, d), o = function(e = "") {
            return "number" != typeof e && (!e || 0 === e.length);
        }(n) ? t : n, a = f(e, mt, d), r = !!(we && Be && Be(e)), i = !!(we && Ae && Ae(e));
        return l.createElement(Q, {
            id: o,
            key: o,
            keyField: d,
            "data-row-id": o,
            columns: at,
            row: e,
            rowCount: kt.length,
            rowIndex: t,
            selectableRows: h,
            expandableRows: we,
            expandableIcon: F,
            highlightOnHover: g,
            pointerOnHover: b,
            dense: m,
            expandOnRowClicked: Ne,
            expandOnRowDoubleClicked: We,
            expandableRowsComponent: Ie,
            expandableRowsComponentProps: Me,
            expandableRowsHideExpander: ze,
            defaultExpanderDisabled: i,
            defaultExpanded: r,
            expandableInheritConditionalStyles: Ge,
            conditionalRowStyles: Ye,
            selected: a,
            selectableRowsHighlight: C,
            selectableRowsComponent: P,
            selectableRowsComponentProps: D,
            selectableRowDisabled: $,
            selectableRowsSingle: w,
            striped: c,
            onRowExpandToggled: H,
            onRowClicked: Tt,
            onRowDoubleClicked: It,
            onRowMouseEnter: Mt,
            onRowMouseLeave: At,
            onSelectedRow: Ft,
            draggingColumnId: lt,
            onDragStart: rt,
            onDragOver: st,
            onDragEnd: ct,
            onDragEnter: it,
            onDragLeave: dt
        });
    }))))), Et && l.createElement("div", null, l.createElement(Ot, {
        onChangePage: Lt,
        onChangeRowsPerPage: _t,
        rowCount: L || kt.length,
        currentPage: bt,
        rowsPerPage: pt,
        direction: et,
        paginationRowsPerPageOptions: W,
        paginationIconLastPage: B,
        paginationIconFirstPage: G,
        paginationIconNext: V,
        paginationIconPrevious: U,
        paginationComponentOptions: Y
    })));
});
exports.STOP_PROP_TAG = G, exports.createTheme = function(e = "default", t, n = "default") {
    return Qe[e] || (Qe[e] = Ke(Qe[n], t || {})), Qe[e] = Ke(Qe[e], t || {}), Qe[e];
}, exports.default = Ze, exports.defaultThemes = Qe;

},{"b91c585cdb3f88fd":"8CCva","27ecfcd84a010800":"6bGrk"}],"9i0Ji":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectTheme", ()=>selectTheme);
var _toolkit = require("@reduxjs/toolkit");
var _ = require(".");
const selectSlice = (state)=>state.theme || (0, _.getInitialState)();
const selectTheme = (0, _toolkit.createSelector)([
    selectSlice
], (theme)=>theme.selected);

},{"@reduxjs/toolkit":"9ol63",".":"56nVt","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kVz1A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dataTableTheme", ()=>dataTableTheme);
parcelHelpers.export(exports, "dataTableCustomStyles", ()=>dataTableCustomStyles);
const dataTableTheme = {
    background: {
        default: 'unset'
    },
    highlightOnHover: {
        default: '#88888833',
        text: 'unset'
    },
    text: {
        primary: 'unset',
        secondary: 'unset',
        disabled: 'unset'
    },
    sortFocus: {
        default: 'unset'
    },
    divider: {
        default: '#AAAAAAaa'
    }
};
const dataTableCustomStyles = {
    headCells: {
        style: {
            fontSize: '16px'
        }
    },
    rows: {
        style: {
            fontSize: '16px'
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aQTIh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "translationsJson", ()=>translationsJson);
parcelHelpers.export(exports, "languageLabels", ()=>languageLabels);
parcelHelpers.export(exports, "i18n", ()=>i18n);
var _i18Next = require("i18next");
var _i18NextDefault = parcelHelpers.interopDefault(_i18Next);
var _reactI18Next = require("react-i18next");
var _i18NextBrowserLanguagedetector = require("i18next-browser-languagedetector");
var _i18NextBrowserLanguagedetectorDefault = parcelHelpers.interopDefault(_i18NextBrowserLanguagedetector);
var _translationJson = require("./de/translation.json");
var _translationJsonDefault = parcelHelpers.interopDefault(_translationJson);
var _translationJson1 = require("./en/translation.json");
var _translationJsonDefault1 = parcelHelpers.interopDefault(_translationJson1);
var _translationJson2 = require("./es/translation.json");
var _translationJsonDefault2 = parcelHelpers.interopDefault(_translationJson2);
var _translationJson3 = require("./fr/translation.json");
var _translationJsonDefault3 = parcelHelpers.interopDefault(_translationJson3);
var _translationJson4 = require("./sl/translation.json");
var _translationJsonDefault4 = parcelHelpers.interopDefault(_translationJson4);
var _translationJson5 = require("./tr/translation.json");
var _translationJsonDefault5 = parcelHelpers.interopDefault(_translationJson5);
var _translationJson6 = require("./vi/translation.json");
var _translationJsonDefault6 = parcelHelpers.interopDefault(_translationJson6);
var _translationJson7 = require("./zh_CN/translation.json");
var _translationJsonDefault7 = parcelHelpers.interopDefault(_translationJson7);
const translationsJson = {
    de: {
        translation: (0, _translationJsonDefault.default)
    },
    en: {
        translation: (0, _translationJsonDefault1.default)
    },
    es: {
        translation: (0, _translationJsonDefault2.default)
    },
    fr: {
        translation: (0, _translationJsonDefault3.default)
    },
    sl: {
        translation: (0, _translationJsonDefault4.default)
    },
    tr: {
        translation: (0, _translationJsonDefault5.default)
    },
    vi: {
        translation: (0, _translationJsonDefault6.default)
    },
    zh_CN: {
        translation: (0, _translationJsonDefault7.default)
    }
};
const languageLabels = [
    [
        'en',
        'English'
    ],
    [
        'de',
        'Deutsch'
    ],
    [
        'es',
        "Espa\xf1ol"
    ],
    [
        'fr',
        "Fran\xe7ais"
    ],
    [
        'sl',
        "Sloven\u0161\u010Dina"
    ],
    [
        'tr',
        "T\xfcrk\xe7e"
    ],
    [
        'vi',
        "Vi\u1EC7t"
    ],
    [
        'zh_CN',
        "\u4E2D\u6587"
    ]
];
const i18n = (0, _i18NextDefault.default)// pass the i18n instance to react-i18next.
.use((0, _reactI18Next.initReactI18next))// detect user language
// learn more: https://github.com/i18next/i18next-browser-languageDetector
.use((0, _i18NextBrowserLanguagedetectorDefault.default))// init i18next
// for all options read: https://www.i18next.com/overview/configuration-options
.init({
    resources: translationsJson,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
        escapeValue: false
    },
    react: {
        // Fix Google Translate issue: https://github.com/facebook/react/issues/11538#issuecomment-390386520
        // Fix from https://react.i18next.com/latest/trans-component#i18next-options
        transWrapTextNodes: 'span'
    }
});

},{"i18next":"gKjwO","react-i18next":"7GUHL","i18next-browser-languagedetector":"4XMiP","./de/translation.json":"1cXpK","./en/translation.json":"p0rWn","./es/translation.json":"elZZS","./fr/translation.json":"5XSjN","./sl/translation.json":"d1aD5","./tr/translation.json":"gRbpH","./vi/translation.json":"8Wygw","./zh_CN/translation.json":"283g6","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gKjwO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "changeLanguage", ()=>changeLanguage);
parcelHelpers.export(exports, "createInstance", ()=>createInstance);
parcelHelpers.export(exports, "default", ()=>instance);
parcelHelpers.export(exports, "dir", ()=>dir);
parcelHelpers.export(exports, "exists", ()=>exists);
parcelHelpers.export(exports, "getFixedT", ()=>getFixedT);
parcelHelpers.export(exports, "hasLoadedNamespace", ()=>hasLoadedNamespace);
parcelHelpers.export(exports, "init", ()=>init);
parcelHelpers.export(exports, "loadLanguages", ()=>loadLanguages);
parcelHelpers.export(exports, "loadNamespaces", ()=>loadNamespaces);
parcelHelpers.export(exports, "loadResources", ()=>loadResources);
parcelHelpers.export(exports, "reloadResources", ()=>reloadResources);
parcelHelpers.export(exports, "setDefaultNamespace", ()=>setDefaultNamespace);
parcelHelpers.export(exports, "t", ()=>t);
parcelHelpers.export(exports, "use", ()=>use);
const consoleLogger = {
    type: 'logger',
    log (args) {
        this.output('log', args);
    },
    warn (args) {
        this.output('warn', args);
    },
    error (args) {
        this.output('error', args);
    },
    output (type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
class Logger {
    constructor(concreteLogger){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.init(concreteLogger, options);
    }
    init(concreteLogger) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.prefix = options.prefix || 'i18next:';
        this.logger = concreteLogger || consoleLogger;
        this.options = options;
        this.debug = options.debug;
    }
    log() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return this.forward(args, 'log', '', true);
    }
    warn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return this.forward(args, 'warn', '', true);
    }
    error() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return this.forward(args, 'error', '');
    }
    deprecate() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
    forward(args, lvl, prefix, debugOnly) {
        if (debugOnly && !this.debug) return null;
        if (typeof args[0] === 'string') args[0] = `${prefix}${this.prefix} ${args[0]}`;
        return this.logger[lvl](args);
    }
    create(moduleName) {
        return new Logger(this.logger, {
            prefix: `${this.prefix}:${moduleName}:`,
            ...this.options
        });
    }
    clone(options) {
        options = options || this.options;
        options.prefix = options.prefix || this.prefix;
        return new Logger(this.logger, options);
    }
}
var baseLogger = new Logger();
class EventEmitter {
    constructor(){
        this.observers = {};
    }
    on(events, listener) {
        events.split(' ').forEach((event)=>{
            this.observers[event] = this.observers[event] || [];
            this.observers[event].push(listener);
        });
        return this;
    }
    off(event, listener) {
        if (!this.observers[event]) return;
        if (!listener) {
            delete this.observers[event];
            return;
        }
        this.observers[event] = this.observers[event].filter((l)=>l !== listener);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (this.observers[event]) {
            const cloned = [].concat(this.observers[event]);
            cloned.forEach((observer)=>{
                observer(...args);
            });
        }
        if (this.observers['*']) {
            const cloned = [].concat(this.observers['*']);
            cloned.forEach((observer)=>{
                observer.apply(observer, [
                    event,
                    ...args
                ]);
            });
        }
    }
}
function defer() {
    let res;
    let rej;
    const promise = new Promise((resolve, reject)=>{
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function makeString(object) {
    if (object == null) return '';
    return '' + object;
}
function copy(a, s, t) {
    a.forEach((m)=>{
        if (s[m]) t[m] = s[m];
    });
}
function getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === 'string';
    }
    const stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        const key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function setPath(object, path, newValue) {
    const { obj, k } = getLastOfPath(object, path, Object);
    obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
    const { obj, k } = getLastOfPath(object, path, Object);
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
    const { obj, k } = getLastOfPath(object, path);
    if (!obj) return undefined;
    return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
    const value = getPath(data, key);
    if (value !== undefined) return value;
    return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
    for(const prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
function escape(data) {
    if (typeof data === 'string') return data.replace(/[&<>"'\/]/g, (s)=>_entityMap[s]);
    return data;
}
const chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    const possibleChars = chars.filter((c)=>nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
    if (possibleChars.length === 0) return true;
    const r = new RegExp(`(${possibleChars.map((c)=>c === '?' ? '\\?' : c).join('|')})`);
    let matched = !r.test(key);
    if (!matched) {
        const ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function deepFind(obj, path) {
    let keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    const paths = path.split(keySeparator);
    let current = obj;
    for(let i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            let j = 2;
            let p = paths.slice(i, i + j).join(keySeparator);
            let mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === 'string') return mix;
                if (p && typeof mix[p] === 'string') return mix[p];
            }
            const joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function getCleanedCode(code) {
    if (code && code.indexOf('_') > 0) return code.replace('_', '-');
    return code;
}
class ResourceStore extends EventEmitter {
    constructor(data){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        super();
        this.data = data || {};
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        if (this.options.ignoreJSONStructure === undefined) this.options.ignoreJSONStructure = true;
    }
    addNamespaces(ns) {
        if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
    }
    removeNamespaces(ns) {
        const index = this.options.ns.indexOf(ns);
        if (index > -1) this.options.ns.splice(index, 1);
    }
    getResource(lng, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
        let path = [
            lng,
            ns
        ];
        if (key && typeof key !== 'string') path = path.concat(key);
        if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) path = lng.split('.');
        const result = getPath(this.data, path);
        if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
        return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
    addResource(lng, ns, key, value) {
        let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            silent: false
        };
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let path = [
            lng,
            ns
        ];
        if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            value = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        setPath(this.data, path, value);
        if (!options.silent) this.emit('added', lng, ns, key, value);
    }
    addResources(lng, ns, resources) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
            silent: false
        };
        for(const m in resources)if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
            silent: true
        });
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    addResourceBundle(lng, ns, resources, deep, overwrite) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
            silent: false
        };
        let path = [
            lng,
            ns
        ];
        if (lng.indexOf('.') > -1) {
            path = lng.split('.');
            deep = resources;
            resources = ns;
            ns = path[1];
        }
        this.addNamespaces(ns);
        let pack = getPath(this.data, path) || {};
        if (deep) deepExtend(pack, resources, overwrite);
        else pack = {
            ...pack,
            ...resources
        };
        setPath(this.data, path, pack);
        if (!options.silent) this.emit('added', lng, ns, resources);
    }
    removeResourceBundle(lng, ns) {
        if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
        this.removeNamespaces(ns);
        this.emit('removed', lng, ns);
    }
    hasResourceBundle(lng, ns) {
        return this.getResource(lng, ns) !== undefined;
    }
    getResourceBundle(lng, ns) {
        if (!ns) ns = this.options.defaultNS;
        if (this.options.compatibilityAPI === 'v1') return {
            ...this.getResource(lng, ns)
        };
        return this.getResource(lng, ns);
    }
    getDataByLanguage(lng) {
        return this.data[lng];
    }
    hasLanguageSomeTranslations(lng) {
        const data = this.getDataByLanguage(lng);
        const n = data && Object.keys(data) || [];
        return !!n.find((v)=>data[v] && Object.keys(data[v]).length > 0);
    }
    toJSON() {
        return this.data;
    }
}
var postProcessor = {
    processors: {},
    addPostProcessor (module) {
        this.processors[module.name] = module;
    },
    handle (processors, value, key, options, translator) {
        processors.forEach((processor)=>{
            if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
const checkedLoadedFor = {};
class Translator extends EventEmitter {
    constructor(services){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, this);
        this.options = options;
        if (this.options.keySeparator === undefined) this.options.keySeparator = '.';
        this.logger = baseLogger.create('translator');
    }
    changeLanguage(lng) {
        if (lng) this.language = lng;
    }
    exists(key) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        if (key === undefined || key === null) return false;
        const resolved = this.resolve(key, options);
        return resolved && resolved.res !== undefined;
    }
    extractFromKey(key, options) {
        let nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
        if (nsSeparator === undefined) nsSeparator = ':';
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        let namespaces = options.ns || this.options.defaultNS || [];
        const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
        const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
        if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
            const m = key.match(this.interpolator.nestingRegexp);
            if (m && m.length > 0) return {
                key,
                namespaces
            };
            const parts = key.split(nsSeparator);
            if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
            key = parts.join(keySeparator);
        }
        if (typeof namespaces === 'string') namespaces = [
            namespaces
        ];
        return {
            key,
            namespaces
        };
    }
    translate(keys, options, lastKey) {
        if (typeof options !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
        if (typeof options === 'object') options = {
            ...options
        };
        if (!options) options = {};
        if (keys === undefined || keys === null) return '';
        if (!Array.isArray(keys)) keys = [
            String(keys)
        ];
        const returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
        const keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
        const { key, namespaces } = this.extractFromKey(keys[keys.length - 1], options);
        const namespace = namespaces[namespaces.length - 1];
        const lng = options.lng || this.language;
        const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
        if (lng && lng.toLowerCase() === 'cimode') {
            if (appendNamespaceToCIMode) {
                const nsSeparator = options.nsSeparator || this.options.nsSeparator;
                if (returnDetails) return {
                    res: `${namespace}${nsSeparator}${key}`,
                    usedKey: key,
                    exactUsedKey: key,
                    usedLng: lng,
                    usedNS: namespace,
                    usedParams: this.getUsedParamsDetails(options)
                };
                return `${namespace}${nsSeparator}${key}`;
            }
            if (returnDetails) return {
                res: key,
                usedKey: key,
                exactUsedKey: key,
                usedLng: lng,
                usedNS: namespace,
                usedParams: this.getUsedParamsDetails(options)
            };
            return key;
        }
        const resolved = this.resolve(keys, options);
        let res = resolved && resolved.res;
        const resUsedKey = resolved && resolved.usedKey || key;
        const resExactUsedKey = resolved && resolved.exactUsedKey || key;
        const resType = Object.prototype.toString.apply(res);
        const noObject = [
            '[object Number]',
            '[object Function]',
            '[object RegExp]'
        ];
        const joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
        const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
        const handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
        if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
            if (!options.returnObjects && !this.options.returnObjects) {
                if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
                    ...options,
                    ns: namespaces
                }) : `key '${key} (${this.language})' returned an object instead of string.`;
                if (returnDetails) {
                    resolved.res = r;
                    resolved.usedParams = this.getUsedParamsDetails(options);
                    return resolved;
                }
                return r;
            }
            if (keySeparator) {
                const resTypeIsArray = resType === '[object Array]';
                const copy = resTypeIsArray ? [] : {};
                const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                for(const m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                    const deepKey = `${newKeyToUse}${keySeparator}${m}`;
                    copy[m] = this.translate(deepKey, {
                        ...options,
                        joinArrays: false,
                        ns: namespaces
                    });
                    if (copy[m] === deepKey) copy[m] = res[m];
                }
                res = copy;
            }
        } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
            res = res.join(joinArrays);
            if (res) res = this.extendTranslation(res, keys, options, lastKey);
        } else {
            let usedDefault = false;
            let usedKey = false;
            const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
            const hasDefaultValue = Translator.hasDefaultValue(options);
            const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
            const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
                ordinal: false
            }) : '';
            const defaultValue = options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
            if (!this.isValidLookup(res) && hasDefaultValue) {
                usedDefault = true;
                res = defaultValue;
            }
            if (!this.isValidLookup(res)) {
                usedKey = true;
                res = key;
            }
            const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
            const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
            const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
            if (usedKey || usedDefault || updateMissing) {
                this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                if (keySeparator) {
                    const fk = this.resolve(key, {
                        ...options,
                        keySeparator: false
                    });
                    if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                }
                let lngs = [];
                const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(let i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                else lngs.push(options.lng || this.language);
                const send = (l, k, specificDefaultValue)=>{
                    const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                    if (this.options.missingKeyHandler) this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                    else if (this.backendConnector && this.backendConnector.saveMissing) this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                    this.emit('missingKey', l, namespace, k, res);
                };
                if (this.options.saveMissing) {
                    if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach((language)=>{
                        this.pluralResolver.getSuffixes(language, options).forEach((suffix)=>{
                            send([
                                language
                            ], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
                        });
                    });
                    else send(lngs, key, defaultValue);
                }
            }
            res = this.extendTranslation(res, keys, options, resolved, lastKey);
            if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
            if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                if (this.options.compatibilityAPI !== 'v1') res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : undefined);
                else res = this.options.parseMissingKeyHandler(res);
            }
        }
        if (returnDetails) {
            resolved.res = res;
            resolved.usedParams = this.getUsedParamsDetails(options);
            return resolved;
        }
        return res;
    }
    extendTranslation(res, key, options, resolved, lastKey) {
        var _this = this;
        if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, {
            ...this.options.interpolation.defaultVariables,
            ...options
        }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
            resolved
        });
        else if (!options.skipInterpolation) {
            if (options.interpolation) this.interpolator.init({
                ...options,
                interpolation: {
                    ...this.options.interpolation,
                    ...options.interpolation
                }
            });
            const skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
            let nestBef;
            if (skipOnVariables) {
                const nb = res.match(this.interpolator.nestingRegexp);
                nestBef = nb && nb.length;
            }
            let data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
            if (this.options.interpolation.defaultVariables) data = {
                ...this.options.interpolation.defaultVariables,
                ...data
            };
            res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
            if (skipOnVariables) {
                const na = res.match(this.interpolator.nestingRegexp);
                const nestAft = na && na.length;
                if (nestBef < nestAft) options.nest = false;
            }
            if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = resolved.usedLng;
            if (options.nest !== false) res = this.interpolator.nest(res, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (lastKey && lastKey[0] === args[0] && !options.context) {
                    _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
                    return null;
                }
                return _this.translate(...args, key);
            }, options);
            if (options.interpolation) this.interpolator.reset();
        }
        const postProcess = options.postProcess || this.options.postProcess;
        const postProcessorNames = typeof postProcess === 'string' ? [
            postProcess
        ] : postProcess;
        if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
            i18nResolved: resolved,
            ...options
        } : options, this);
        return res;
    }
    resolve(keys) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let found;
        let usedKey;
        let exactUsedKey;
        let usedLng;
        let usedNS;
        if (typeof keys === 'string') keys = [
            keys
        ];
        keys.forEach((k)=>{
            if (this.isValidLookup(found)) return;
            const extracted = this.extractFromKey(k, options);
            const key = extracted.key;
            usedKey = key;
            let namespaces = extracted.namespaces;
            if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
            const needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
            const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
            const needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
            const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
            namespaces.forEach((ns)=>{
                if (this.isValidLookup(found)) return;
                usedNS = ns;
                if (!checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
                    checkedLoadedFor[`${codes[0]}-${ns}`] = true;
                    this.logger.warn(`key "${usedKey}" for languages "${codes.join(', ')}" won't get resolved as namespace "${usedNS}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                }
                codes.forEach((code)=>{
                    if (this.isValidLookup(found)) return;
                    usedLng = code;
                    const finalKeys = [
                        key
                    ];
                    if (this.i18nFormat && this.i18nFormat.addLookupKeys) this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                    else {
                        let pluralSuffix;
                        if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
                        const zeroSuffix = `${this.options.pluralSeparator}zero`;
                        const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
                        if (needsPluralHandling) {
                            finalKeys.push(key + pluralSuffix);
                            if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                            if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                        }
                        if (needsContextHandling) {
                            const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
                            finalKeys.push(contextKey);
                            if (needsPluralHandling) {
                                finalKeys.push(contextKey + pluralSuffix);
                                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                                if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                            }
                        }
                    }
                    let possibleKey;
                    while(possibleKey = finalKeys.pop())if (!this.isValidLookup(found)) {
                        exactUsedKey = possibleKey;
                        found = this.getResource(code, ns, possibleKey, options);
                    }
                });
            });
        });
        return {
            res: found,
            usedKey,
            exactUsedKey,
            usedLng,
            usedNS
        };
    }
    isValidLookup(res) {
        return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
    getResource(code, ns, key) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
        return this.resourceStore.getResource(code, ns, key, options);
    }
    getUsedParamsDetails() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const optionsKeys = [
            'defaultValue',
            'ordinal',
            'context',
            'replace',
            'lng',
            'lngs',
            'fallbackLng',
            'ns',
            'keySeparator',
            'nsSeparator',
            'returnObjects',
            'returnDetails',
            'joinArrays',
            'postProcess',
            'interpolation'
        ];
        const useOptionsReplaceForData = options.replace && typeof options.replace !== 'string';
        let data = useOptionsReplaceForData ? options.replace : options;
        if (useOptionsReplaceForData && typeof options.count !== 'undefined') data.count = options.count;
        if (this.options.interpolation.defaultVariables) data = {
            ...this.options.interpolation.defaultVariables,
            ...data
        };
        if (!useOptionsReplaceForData) {
            data = {
                ...data
            };
            for (const key of optionsKeys)delete data[key];
        }
        return data;
    }
    static hasDefaultValue(options) {
        const prefix = 'defaultValue';
        for(const option in options){
            if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
        }
        return false;
    }
}
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
class LanguageUtil {
    constructor(options){
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = baseLogger.create('languageUtils');
    }
    getScriptPartFromCode(code) {
        code = getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return null;
        const p = code.split('-');
        if (p.length === 2) return null;
        p.pop();
        if (p[p.length - 1].toLowerCase() === 'x') return null;
        return this.formatLanguageCode(p.join('-'));
    }
    getLanguagePartFromCode(code) {
        code = getCleanedCode(code);
        if (!code || code.indexOf('-') < 0) return code;
        const p = code.split('-');
        return this.formatLanguageCode(p[0]);
    }
    formatLanguageCode(code) {
        if (typeof code === 'string' && code.indexOf('-') > -1) {
            const specialCases = [
                'hans',
                'hant',
                'latn',
                'cyrl',
                'cans',
                'mong',
                'arab'
            ];
            let p = code.split('-');
            if (this.options.lowerCaseLng) p = p.map((part)=>part.toLowerCase());
            else if (p.length === 2) {
                p[0] = p[0].toLowerCase();
                p[1] = p[1].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
            } else if (p.length === 3) {
                p[0] = p[0].toLowerCase();
                if (p[1].length === 2) p[1] = p[1].toUpperCase();
                if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
            }
            return p.join('-');
        }
        return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
    isSupportedCode(code) {
        if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
        return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
    getBestMatchFromCodes(codes) {
        if (!codes) return null;
        let found;
        codes.forEach((code)=>{
            if (found) return;
            const cleanedLng = this.formatLanguageCode(code);
            if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
        });
        if (!found && this.options.supportedLngs) codes.forEach((code)=>{
            if (found) return;
            const lngOnly = this.getLanguagePartFromCode(code);
            if (this.isSupportedCode(lngOnly)) return found = lngOnly;
            found = this.options.supportedLngs.find((supportedLng)=>{
                if (supportedLng === lngOnly) return supportedLng;
                if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
            });
        });
        if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
        return found;
    }
    getFallbackCodes(fallbacks, code) {
        if (!fallbacks) return [];
        if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
        if (typeof fallbacks === 'string') fallbacks = [
            fallbacks
        ];
        if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
        if (!code) return fallbacks.default || [];
        let found = fallbacks[code];
        if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
        if (!found) found = fallbacks[this.formatLanguageCode(code)];
        if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
        if (!found) found = fallbacks.default;
        return found || [];
    }
    toResolveHierarchy(code, fallbackCode) {
        const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
        const codes = [];
        const addCode = (c)=>{
            if (!c) return;
            if (this.isSupportedCode(c)) codes.push(c);
            else this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
        };
        if (typeof code === 'string' && (code.indexOf('-') > -1 || code.indexOf('_') > -1)) {
            if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
            if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
            if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
        } else if (typeof code === 'string') addCode(this.formatLanguageCode(code));
        fallbackCodes.forEach((fc)=>{
            if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
        });
        return codes;
    }
}
let sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
let _rulesPluralsTypes = {
    1: function(n) {
        return Number(n > 1);
    },
    2: function(n) {
        return Number(n != 1);
    },
    3: function(n) {
        return 0;
    },
    4: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function(n) {
        return Number(n >= 2);
    },
    10: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function(n) {
        return Number(n !== 0);
    },
    14: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
const nonIntlVersions = [
    'v1',
    'v2',
    'v3'
];
const intlVersions = [
    'v4'
];
const suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function createRules() {
    const rules = {};
    sets.forEach((set)=>{
        set.lngs.forEach((l)=>{
            rules[l] = {
                numbers: set.nr,
                plurals: _rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
class PluralResolver {
    constructor(languageUtils){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = baseLogger.create('pluralResolver');
        if ((!this.options.compatibilityJSON || intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
            this.options.compatibilityJSON = 'v3';
            this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
        }
        this.rules = createRules();
    }
    addRule(lng, obj) {
        this.rules[lng] = obj;
    }
    getRule(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this.shouldUseIntlApi()) try {
            return new Intl.PluralRules(getCleanedCode(code), {
                type: options.ordinal ? 'ordinal' : 'cardinal'
            });
        } catch  {
            return;
        }
        return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
    needsPlural(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
        return rule && rule.numbers.length > 1;
    }
    getPluralFormsOfKey(code, key) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return this.getSuffixes(code, options).map((suffix)=>`${key}${suffix}`);
    }
    getSuffixes(code) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const rule = this.getRule(code, options);
        if (!rule) return [];
        if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2)=>suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2]).map((pluralCategory)=>`${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${pluralCategory}`);
        return rule.numbers.map((number)=>this.getSuffix(code, number, options));
    }
    getSuffix(code, count) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const rule = this.getRule(code, options);
        if (rule) {
            if (this.shouldUseIntlApi()) return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ''}${rule.select(count)}`;
            return this.getSuffixRetroCompatible(rule, count);
        }
        this.logger.warn(`no plural rule found for: ${code}`);
        return '';
    }
    getSuffixRetroCompatible(rule, count) {
        const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        let suffix = rule.numbers[idx];
        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
            if (suffix === 2) suffix = 'plural';
            else if (suffix === 1) suffix = '';
        }
        const returnSuffix = ()=>this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
        if (this.options.compatibilityJSON === 'v1') {
            if (suffix === 1) return '';
            if (typeof suffix === 'number') return `_plural_${suffix.toString()}`;
            return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
        else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
    shouldUseIntlApi() {
        return !nonIntlVersions.includes(this.options.compatibilityJSON);
    }
}
function deepFindWithDefaults(data, defaultData, key) {
    let keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    let path = getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === 'string') {
        path = deepFind(data, key, keySeparator);
        if (path === undefined) path = deepFind(defaultData, key, keySeparator);
    }
    return path;
}
class Interpolator {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || ((value)=>value);
        this.init(options);
    }
    init() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (!options.interpolation) options.interpolation = {
            escapeValue: true
        };
        const iOpts = options.interpolation;
        this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
        this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
        this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
        this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
        this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
        this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
        this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
        this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
        this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
        this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
        this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
        this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
        this.resetRegExp();
    }
    reset() {
        if (this.options) this.init(this.options);
    }
    resetRegExp() {
        const regexpStr = `${this.prefix}(.+?)${this.suffix}`;
        this.regexp = new RegExp(regexpStr, 'g');
        const regexpUnescapeStr = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`;
        this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
        const nestingRegexpStr = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
        this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
    interpolate(str, data, lng, options) {
        let match;
        let value;
        let replaces;
        const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
        function regexSafe(val) {
            return val.replace(/\$/g, '$$$$');
        }
        const handleFormat = (key)=>{
            if (key.indexOf(this.formatSeparator) < 0) {
                const path = deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
                return this.alwaysFormat ? this.format(path, undefined, lng, {
                    ...options,
                    ...data,
                    interpolationkey: key
                }) : path;
            }
            const p = key.split(this.formatSeparator);
            const k = p.shift().trim();
            const f = p.join(this.formatSeparator).trim();
            return this.format(deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
                ...options,
                ...data,
                interpolationkey: k
            });
        };
        this.resetRegExp();
        const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
        const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
        const todos = [
            {
                regex: this.regexpUnescape,
                safeValue: (val)=>regexSafe(val)
            },
            {
                regex: this.regexp,
                safeValue: (val)=>this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
            }
        ];
        todos.forEach((todo)=>{
            replaces = 0;
            while(match = todo.regex.exec(str)){
                const matchedVar = match[1].trim();
                value = handleFormat(matchedVar);
                if (value === undefined) {
                    if (typeof missingInterpolationHandler === 'function') {
                        const temp = missingInterpolationHandler(str, match, options);
                        value = typeof temp === 'string' ? temp : '';
                    } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                    else if (skipOnVariables) {
                        value = match[0];
                        continue;
                    } else {
                        this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
                        value = '';
                    }
                } else if (typeof value !== 'string' && !this.useRawValueToEscape) value = makeString(value);
                const safeValue = todo.safeValue(value);
                str = str.replace(match[0], safeValue);
                if (skipOnVariables) {
                    todo.regex.lastIndex += value.length;
                    todo.regex.lastIndex -= match[0].length;
                } else todo.regex.lastIndex = 0;
                replaces++;
                if (replaces >= this.maxReplaces) break;
            }
        });
        return str;
    }
    nest(str, fc) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let match;
        let value;
        let clonedOptions;
        function handleHasOptions(key, inheritedOptions) {
            const sep = this.nestingOptionsSeparator;
            if (key.indexOf(sep) < 0) return key;
            const c = key.split(new RegExp(`${sep}[ ]*{`));
            let optionsString = `{${c[1]}`;
            key = c[0];
            optionsString = this.interpolate(optionsString, clonedOptions);
            const matchedSingleQuotes = optionsString.match(/'/g);
            const matchedDoubleQuotes = optionsString.match(/"/g);
            if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
            try {
                clonedOptions = JSON.parse(optionsString);
                if (inheritedOptions) clonedOptions = {
                    ...inheritedOptions,
                    ...clonedOptions
                };
            } catch (e) {
                this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
                return `${key}${sep}${optionsString}`;
            }
            delete clonedOptions.defaultValue;
            return key;
        }
        while(match = this.nestingRegexp.exec(str)){
            let formatters = [];
            clonedOptions = {
                ...options
            };
            clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== 'string' ? clonedOptions.replace : clonedOptions;
            clonedOptions.applyPostProcessor = false;
            delete clonedOptions.defaultValue;
            let doReduce = false;
            if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                const r = match[1].split(this.formatSeparator).map((elem)=>elem.trim());
                match[1] = r.shift();
                formatters = r;
                doReduce = true;
            }
            value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
            if (value && match[0] === str && typeof value !== 'string') return value;
            if (typeof value !== 'string') value = makeString(value);
            if (!value) {
                this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
                value = '';
            }
            if (doReduce) value = formatters.reduce((v, f)=>this.format(v, f, options.lng, {
                    ...options,
                    interpolationkey: match[1].trim()
                }), value.trim());
            str = str.replace(match[0], value);
            this.regexp.lastIndex = 0;
        }
        return str;
    }
}
function parseFormatStr(formatStr) {
    let formatName = formatStr.toLowerCase().trim();
    const formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        const p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        const optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            const opts = optStr.split(';');
            opts.forEach((opt)=>{
                if (!opt) return;
                const [key, ...rest] = opt.split(':');
                const val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === 'false') formatOptions[key.trim()] = false;
                if (val === 'true') formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName,
        formatOptions
    };
}
function createCachedFormatter(fn) {
    const cache = {};
    return function invokeFormatter(val, lng, options) {
        const key = lng + JSON.stringify(options);
        let formatter = cache[key];
        if (!formatter) {
            formatter = fn(getCleanedCode(lng), options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
class Formatter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.logger = baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            currency: createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.NumberFormat(lng, {
                    ...opt,
                    style: 'currency'
                });
                return (val)=>formatter.format(val);
            }),
            datetime: createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.DateTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            }),
            relativetime: createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.RelativeTimeFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val, opt.range || 'day');
            }),
            list: createCachedFormatter((lng, opt)=>{
                const formatter = new Intl.ListFormat(lng, {
                    ...opt
                });
                return (val)=>formatter.format(val);
            })
        };
        this.init(options);
    }
    init(services) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            interpolation: {}
        };
        const iOpts = options.interpolation;
        this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
    add(name, fc) {
        this.formats[name.toLowerCase().trim()] = fc;
    }
    addCached(name, fc) {
        this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
    format(value, format, lng) {
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        const formats = format.split(this.formatSeparator);
        const result = formats.reduce((mem, f)=>{
            const { formatName, formatOptions } = parseFormatStr(f);
            if (this.formats[formatName]) {
                let formatted = mem;
                try {
                    const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                    const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                    formatted = this.formats[formatName](mem, l, {
                        ...formatOptions,
                        ...options,
                        ...valOptions
                    });
                } catch (error) {
                    this.logger.warn(error);
                }
                return formatted;
            } else this.logger.warn(`there was no format function for ${formatName}`);
            return mem;
        }, value);
        return result;
    }
}
function removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
class Connector extends EventEmitter {
    constructor(backend, store, services){
        let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        super();
        this.backend = backend;
        this.store = store;
        this.services = services;
        this.languageUtils = services.languageUtils;
        this.options = options;
        this.logger = baseLogger.create('backendConnector');
        this.waitingReads = [];
        this.maxParallelReads = options.maxParallelReads || 10;
        this.readingCalls = 0;
        this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        this.state = {};
        this.queue = [];
        if (this.backend && this.backend.init) this.backend.init(services, options.backend, options);
    }
    queueLoad(languages, namespaces, options, callback) {
        const toLoad = {};
        const pending = {};
        const toLoadLanguages = {};
        const toLoadNamespaces = {};
        languages.forEach((lng)=>{
            let hasAllNamespaces = true;
            namespaces.forEach((ns)=>{
                const name = `${lng}|${ns}`;
                if (!options.reload && this.store.hasResourceBundle(lng, ns)) this.state[name] = 2;
                else if (this.state[name] < 0) ;
                else if (this.state[name] === 1) {
                    if (pending[name] === undefined) pending[name] = true;
                } else {
                    this.state[name] = 1;
                    hasAllNamespaces = false;
                    if (pending[name] === undefined) pending[name] = true;
                    if (toLoad[name] === undefined) toLoad[name] = true;
                    if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                }
            });
            if (!hasAllNamespaces) toLoadLanguages[lng] = true;
        });
        if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
            pending,
            pendingCount: Object.keys(pending).length,
            loaded: {},
            errors: [],
            callback
        });
        return {
            toLoad: Object.keys(toLoad),
            pending: Object.keys(pending),
            toLoadLanguages: Object.keys(toLoadLanguages),
            toLoadNamespaces: Object.keys(toLoadNamespaces)
        };
    }
    loaded(name, err, data) {
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        if (err) this.emit('failedLoading', lng, ns, err);
        if (data) this.store.addResourceBundle(lng, ns, data);
        this.state[name] = err ? -1 : 2;
        const loaded = {};
        this.queue.forEach((q)=>{
            pushPath(q.loaded, [
                lng
            ], ns);
            removePending(q, name);
            if (err) q.errors.push(err);
            if (q.pendingCount === 0 && !q.done) {
                Object.keys(q.loaded).forEach((l)=>{
                    if (!loaded[l]) loaded[l] = {};
                    const loadedKeys = q.loaded[l];
                    if (loadedKeys.length) loadedKeys.forEach((n)=>{
                        if (loaded[l][n] === undefined) loaded[l][n] = true;
                    });
                });
                q.done = true;
                if (q.errors.length) q.callback(q.errors);
                else q.callback();
            }
        });
        this.emit('loaded', loaded);
        this.queue = this.queue.filter((q)=>!q.done);
    }
    read(lng, ns, fcName) {
        let tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        let wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
        let callback = arguments.length > 5 ? arguments[5] : undefined;
        if (!lng.length) return callback(null, {});
        if (this.readingCalls >= this.maxParallelReads) {
            this.waitingReads.push({
                lng,
                ns,
                fcName,
                tried,
                wait,
                callback
            });
            return;
        }
        this.readingCalls++;
        const resolver = (err, data)=>{
            this.readingCalls--;
            if (this.waitingReads.length > 0) {
                const next = this.waitingReads.shift();
                this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
            }
            if (err && data && tried < this.maxRetries) {
                setTimeout(()=>{
                    this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
                }, wait);
                return;
            }
            callback(err, data);
        };
        const fc = this.backend[fcName].bind(this.backend);
        if (fc.length === 2) {
            try {
                const r = fc(lng, ns);
                if (r && typeof r.then === 'function') r.then((data)=>resolver(null, data)).catch(resolver);
                else resolver(null, r);
            } catch (err) {
                resolver(err);
            }
            return;
        }
        return fc(lng, ns, resolver);
    }
    prepareLoading(languages, namespaces) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        let callback = arguments.length > 3 ? arguments[3] : undefined;
        if (!this.backend) {
            this.logger.warn('No backend was added via i18next.use. Will not load resources.');
            return callback && callback();
        }
        if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
        if (typeof namespaces === 'string') namespaces = [
            namespaces
        ];
        const toLoad = this.queueLoad(languages, namespaces, options, callback);
        if (!toLoad.toLoad.length) {
            if (!toLoad.pending.length) callback();
            return null;
        }
        toLoad.toLoad.forEach((name)=>{
            this.loadOne(name);
        });
    }
    load(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {}, callback);
    }
    reload(languages, namespaces, callback) {
        this.prepareLoading(languages, namespaces, {
            reload: true
        }, callback);
    }
    loadOne(name) {
        let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const s = name.split('|');
        const lng = s[0];
        const ns = s[1];
        this.read(lng, ns, 'read', undefined, undefined, (err, data)=>{
            if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
            if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
            this.loaded(name, err, data);
        });
    }
    saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
        let options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        let clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : ()=>{};
        if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
            this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
            return;
        }
        if (key === undefined || key === null || key === '') return;
        if (this.backend && this.backend.create) {
            const opts = {
                ...options,
                isUpdate
            };
            const fc = this.backend.create.bind(this.backend);
            if (fc.length < 6) try {
                let r;
                if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                else r = fc(languages, namespace, key, fallbackValue);
                if (r && typeof r.then === 'function') r.then((data)=>clb(null, data)).catch(clb);
                else clb(null, r);
            } catch (err) {
                clb(err);
            }
            else fc(languages, namespace, key, fallbackValue, clb, opts);
        }
        if (!languages || !languages[0]) return;
        this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
}
function get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: false,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            let ret = {};
            if (typeof args[1] === 'object') ret = args[1];
            if (typeof args[1] === 'string') ret.defaultValue = args[1];
            if (typeof args[2] === 'string') ret.tDescription = args[2];
            if (typeof args[2] === 'object' || typeof args[3] === 'object') {
                const options = args[3] || args[2];
                Object.keys(options).forEach((key)=>{
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: (value, format, lng, options)=>value,
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function transformOptions(options) {
    if (typeof options.ns === 'string') options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === 'string') options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === 'string') options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
}
function noop() {}
function bindMemberFunctions(inst) {
    const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach((mem)=>{
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
}
class I18n extends EventEmitter {
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        super();
        this.options = transformOptions(options);
        this.services = {};
        this.logger = baseLogger;
        this.modules = {
            external: []
        };
        bindMemberFunctions(this);
        if (callback && !this.isInitialized && !options.isClone) {
            if (!this.options.initImmediate) {
                this.init(options, callback);
                return this;
            }
            setTimeout(()=>{
                this.init(options, callback);
            }, 0);
        }
    }
    init() {
        var _this = this;
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        if (!options.defaultNS && options.defaultNS !== false && options.ns) {
            if (typeof options.ns === 'string') options.defaultNS = options.ns;
            else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
        }
        const defOpts = get();
        this.options = {
            ...defOpts,
            ...this.options,
            ...transformOptions(options)
        };
        if (this.options.compatibilityAPI !== 'v1') this.options.interpolation = {
            ...defOpts.interpolation,
            ...this.options.interpolation
        };
        if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
        if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
        function createClassOnDemand(ClassOrObject) {
            if (!ClassOrObject) return null;
            if (typeof ClassOrObject === 'function') return new ClassOrObject();
            return ClassOrObject;
        }
        if (!this.options.isClone) {
            if (this.modules.logger) baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
            else baseLogger.init(null, this.options);
            let formatter;
            if (this.modules.formatter) formatter = this.modules.formatter;
            else if (typeof Intl !== 'undefined') formatter = Formatter;
            const lu = new LanguageUtil(this.options);
            this.store = new ResourceStore(this.options.resources, this.options);
            const s = this.services;
            s.logger = baseLogger;
            s.resourceStore = this.store;
            s.languageUtils = lu;
            s.pluralResolver = new PluralResolver(lu, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
            });
            if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                s.formatter = createClassOnDemand(formatter);
                s.formatter.init(s, this.options);
                this.options.interpolation.format = s.formatter.format.bind(s.formatter);
            }
            s.interpolator = new Interpolator(this.options);
            s.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
            };
            s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
            s.backendConnector.on('*', function(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                _this.emit(event, ...args);
            });
            if (this.modules.languageDetector) {
                s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
            }
            if (this.modules.i18nFormat) {
                s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                if (s.i18nFormat.init) s.i18nFormat.init(this);
            }
            this.translator = new Translator(this.services, this.options);
            this.translator.on('*', function(event) {
                for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                _this.emit(event, ...args);
            });
            this.modules.external.forEach((m)=>{
                if (m.init) m.init(this);
            });
        }
        this.format = this.options.interpolation.format;
        if (!callback) callback = noop;
        if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
            const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
            if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
        }
        if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
        const storeApi = [
            'getResource',
            'hasResourceBundle',
            'getResourceBundle',
            'getDataByLanguage'
        ];
        storeApi.forEach((fcName)=>{
            this[fcName] = function() {
                return _this.store[fcName](...arguments);
            };
        });
        const storeApiChained = [
            'addResource',
            'addResources',
            'addResourceBundle',
            'removeResourceBundle'
        ];
        storeApiChained.forEach((fcName)=>{
            this[fcName] = function() {
                _this.store[fcName](...arguments);
                return _this;
            };
        });
        const deferred = defer();
        const load = ()=>{
            const finish = (err, t)=>{
                if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn('init: i18next is already initialized. You should call init just once!');
                this.isInitialized = true;
                if (!this.options.isClone) this.logger.log('initialized', this.options);
                this.emit('initialized', this.options);
                deferred.resolve(t);
                callback(err, t);
            };
            if (this.languages && this.options.compatibilityAPI !== 'v1' && !this.isInitialized) return finish(null, this.t.bind(this));
            this.changeLanguage(this.options.lng, finish);
        };
        if (this.options.resources || !this.options.initImmediate) load();
        else setTimeout(load, 0);
        return deferred;
    }
    loadResources(language) {
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
        let usedCallback = callback;
        const usedLng = typeof language === 'string' ? language : this.language;
        if (typeof language === 'function') usedCallback = language;
        if (!this.options.resources || this.options.partialBundledLanguages) {
            if (usedLng && usedLng.toLowerCase() === 'cimode' && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
            const toLoad = [];
            const append = (lng)=>{
                if (!lng) return;
                if (lng === 'cimode') return;
                const lngs = this.services.languageUtils.toResolveHierarchy(lng);
                lngs.forEach((l)=>{
                    if (l === 'cimode') return;
                    if (toLoad.indexOf(l) < 0) toLoad.push(l);
                });
            };
            if (!usedLng) {
                const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                fallbacks.forEach((l)=>append(l));
            } else append(usedLng);
            if (this.options.preload) this.options.preload.forEach((l)=>append(l));
            this.services.backendConnector.load(toLoad, this.options.ns, (e)=>{
                if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
                usedCallback(e);
            });
        } else usedCallback(null);
    }
    reloadResources(lngs, ns, callback) {
        const deferred = defer();
        if (!lngs) lngs = this.languages;
        if (!ns) ns = this.options.ns;
        if (!callback) callback = noop;
        this.services.backendConnector.reload(lngs, ns, (err)=>{
            deferred.resolve();
            callback(err);
        });
        return deferred;
    }
    use(module) {
        if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
        if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
        if (module.type === 'backend') this.modules.backend = module;
        if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
        if (module.type === 'languageDetector') this.modules.languageDetector = module;
        if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
        if (module.type === 'postProcessor') postProcessor.addPostProcessor(module);
        if (module.type === 'formatter') this.modules.formatter = module;
        if (module.type === '3rdParty') this.modules.external.push(module);
        return this;
    }
    setResolvedLanguage(l) {
        if (!l || !this.languages) return;
        if ([
            'cimode',
            'dev'
        ].indexOf(l) > -1) return;
        for(let li = 0; li < this.languages.length; li++){
            const lngInLngs = this.languages[li];
            if ([
                'cimode',
                'dev'
            ].indexOf(lngInLngs) > -1) continue;
            if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                this.resolvedLanguage = lngInLngs;
                break;
            }
        }
    }
    changeLanguage(lng, callback) {
        var _this2 = this;
        this.isLanguageChangingTo = lng;
        const deferred = defer();
        this.emit('languageChanging', lng);
        const setLngProps = (l)=>{
            this.language = l;
            this.languages = this.services.languageUtils.toResolveHierarchy(l);
            this.resolvedLanguage = undefined;
            this.setResolvedLanguage(l);
        };
        const done = (err, l)=>{
            if (l) {
                setLngProps(l);
                this.translator.changeLanguage(l);
                this.isLanguageChangingTo = undefined;
                this.emit('languageChanged', l);
                this.logger.log('languageChanged', l);
            } else this.isLanguageChangingTo = undefined;
            deferred.resolve(function() {
                return _this2.t(...arguments);
            });
            if (callback) callback(err, function() {
                return _this2.t(...arguments);
            });
        };
        const setLng = (lngs)=>{
            if (!lng && !lngs && this.services.languageDetector) lngs = [];
            const l = typeof lngs === 'string' ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
            if (l) {
                if (!this.language) setLngProps(l);
                if (!this.translator.language) this.translator.changeLanguage(l);
                if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
            }
            this.loadResources(l, (err)=>{
                done(err, l);
            });
        };
        if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
        else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
            if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
            else this.services.languageDetector.detect(setLng);
        } else setLng(lng);
        return deferred;
    }
    getFixedT(lng, ns, keyPrefix) {
        var _this3 = this;
        const fixedT = function(key, opts) {
            let options;
            if (typeof opts !== 'object') {
                for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                options = _this3.options.overloadTranslationOptionHandler([
                    key,
                    opts
                ].concat(rest));
            } else options = {
                ...opts
            };
            options.lng = options.lng || fixedT.lng;
            options.lngs = options.lngs || fixedT.lngs;
            options.ns = options.ns || fixedT.ns;
            options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
            const keySeparator = _this3.options.keySeparator || '.';
            let resultKey;
            if (options.keyPrefix && Array.isArray(key)) resultKey = key.map((k)=>`${options.keyPrefix}${keySeparator}${k}`);
            else resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
            return _this3.t(resultKey, options);
        };
        if (typeof lng === 'string') fixedT.lng = lng;
        else fixedT.lngs = lng;
        fixedT.ns = ns;
        fixedT.keyPrefix = keyPrefix;
        return fixedT;
    }
    t() {
        return this.translator && this.translator.translate(...arguments);
    }
    exists() {
        return this.translator && this.translator.exists(...arguments);
    }
    setDefaultNamespace(ns) {
        this.options.defaultNS = ns;
    }
    hasLoadedNamespace(ns) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.isInitialized) {
            this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
            return false;
        }
        if (!this.languages || !this.languages.length) {
            this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
            return false;
        }
        const lng = options.lng || this.resolvedLanguage || this.languages[0];
        const fallbackLng = this.options ? this.options.fallbackLng : false;
        const lastLng = this.languages[this.languages.length - 1];
        if (lng.toLowerCase() === 'cimode') return true;
        const loadNotPending = (l, n)=>{
            const loadState = this.services.backendConnector.state[`${l}|${n}`];
            return loadState === -1 || loadState === 2;
        };
        if (options.precheck) {
            const preResult = options.precheck(this, loadNotPending);
            if (preResult !== undefined) return preResult;
        }
        if (this.hasResourceBundle(lng, ns)) return true;
        if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
        if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
        return false;
    }
    loadNamespaces(ns, callback) {
        const deferred = defer();
        if (!this.options.ns) {
            if (callback) callback();
            return Promise.resolve();
        }
        if (typeof ns === 'string') ns = [
            ns
        ];
        ns.forEach((n)=>{
            if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
        });
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    loadLanguages(lngs, callback) {
        const deferred = defer();
        if (typeof lngs === 'string') lngs = [
            lngs
        ];
        const preloaded = this.options.preload || [];
        const newLngs = lngs.filter((lng)=>preloaded.indexOf(lng) < 0);
        if (!newLngs.length) {
            if (callback) callback();
            return Promise.resolve();
        }
        this.options.preload = preloaded.concat(newLngs);
        this.loadResources((err)=>{
            deferred.resolve();
            if (callback) callback(err);
        });
        return deferred;
    }
    dir(lng) {
        if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
        if (!lng) return 'rtl';
        const rtlLngs = [
            'ar',
            'shu',
            'sqr',
            'ssh',
            'xaa',
            'yhd',
            'yud',
            'aao',
            'abh',
            'abv',
            'acm',
            'acq',
            'acw',
            'acx',
            'acy',
            'adf',
            'ads',
            'aeb',
            'aec',
            'afb',
            'ajp',
            'apc',
            'apd',
            'arb',
            'arq',
            'ars',
            'ary',
            'arz',
            'auz',
            'avl',
            'ayh',
            'ayl',
            'ayn',
            'ayp',
            'bbz',
            'pga',
            'he',
            'iw',
            'ps',
            'pbt',
            'pbu',
            'pst',
            'prp',
            'prd',
            'ug',
            'ur',
            'ydd',
            'yds',
            'yih',
            'ji',
            'yi',
            'hbo',
            'men',
            'xmn',
            'fa',
            'jpr',
            'peo',
            'pes',
            'prs',
            'dv',
            'sam',
            'ckb'
        ];
        const languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
        return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
    static createInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 ? arguments[1] : undefined;
        return new I18n(options, callback);
    }
    cloneInstance() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
        const forkResourceStore = options.forkResourceStore;
        if (forkResourceStore) delete options.forkResourceStore;
        const mergedOptions = {
            ...this.options,
            ...options,
            isClone: true
        };
        const clone = new I18n(mergedOptions);
        if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
        const membersToCopy = [
            'store',
            'services',
            'language'
        ];
        membersToCopy.forEach((m)=>{
            clone[m] = this[m];
        });
        clone.services = {
            ...this.services
        };
        clone.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        if (forkResourceStore) {
            clone.store = new ResourceStore(this.store.data, mergedOptions);
            clone.services.resourceStore = clone.store;
        }
        clone.translator = new Translator(clone.services, mergedOptions);
        clone.translator.on('*', function(event) {
            for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
            clone.emit(event, ...args);
        });
        clone.init(mergedOptions, callback);
        clone.translator.options = mergedOptions;
        clone.translator.backendConnector.services.utils = {
            hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
        };
        return clone;
    }
    toJSON() {
        return {
            options: this.options,
            store: this.store,
            language: this.language,
            languages: this.languages,
            resolvedLanguage: this.resolvedLanguage
        };
    }
}
const instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
const createInstance = instance.createInstance;
const dir = instance.dir;
const init = instance.init;
const loadResources = instance.loadResources;
const reloadResources = instance.reloadResources;
const use = instance.use;
const changeLanguage = instance.changeLanguage;
const getFixedT = instance.getFixedT;
const t = instance.t;
const exists = instance.exists;
const setDefaultNamespace = instance.setDefaultNamespace;
const hasLoadedNamespace = instance.hasLoadedNamespace;
const loadNamespaces = instance.loadNamespaces;
const loadLanguages = instance.loadLanguages;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7GUHL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Trans", ()=>(0, _transJs.Trans));
parcelHelpers.export(exports, "TransWithoutContext", ()=>(0, _transWithoutContextJs.Trans));
parcelHelpers.export(exports, "useTranslation", ()=>(0, _useTranslationJs.useTranslation));
parcelHelpers.export(exports, "withTranslation", ()=>(0, _withTranslationJs.withTranslation));
parcelHelpers.export(exports, "Translation", ()=>(0, _translationJs.Translation));
parcelHelpers.export(exports, "I18nextProvider", ()=>(0, _i18NextProviderJs.I18nextProvider));
parcelHelpers.export(exports, "withSSR", ()=>(0, _withSSRJs.withSSR));
parcelHelpers.export(exports, "useSSR", ()=>(0, _useSSRJs.useSSR));
parcelHelpers.export(exports, "initReactI18next", ()=>(0, _initReactI18NextJs.initReactI18next));
parcelHelpers.export(exports, "setDefaults", ()=>(0, _defaultsJs.setDefaults));
parcelHelpers.export(exports, "getDefaults", ()=>(0, _defaultsJs.getDefaults));
parcelHelpers.export(exports, "setI18n", ()=>(0, _i18NInstanceJs.setI18n));
parcelHelpers.export(exports, "getI18n", ()=>(0, _i18NInstanceJs.getI18n));
parcelHelpers.export(exports, "I18nContext", ()=>(0, _contextJs.I18nContext));
parcelHelpers.export(exports, "composeInitialProps", ()=>(0, _contextJs.composeInitialProps));
parcelHelpers.export(exports, "getInitialProps", ()=>(0, _contextJs.getInitialProps));
parcelHelpers.export(exports, "date", ()=>date);
parcelHelpers.export(exports, "time", ()=>time);
parcelHelpers.export(exports, "number", ()=>number);
parcelHelpers.export(exports, "select", ()=>select);
parcelHelpers.export(exports, "plural", ()=>plural);
parcelHelpers.export(exports, "selectOrdinal", ()=>selectOrdinal);
var _transJs = require("./Trans.js");
var _transWithoutContextJs = require("./TransWithoutContext.js");
var _useTranslationJs = require("./useTranslation.js");
var _withTranslationJs = require("./withTranslation.js");
var _translationJs = require("./Translation.js");
var _i18NextProviderJs = require("./I18nextProvider.js");
var _withSSRJs = require("./withSSR.js");
var _useSSRJs = require("./useSSR.js");
var _initReactI18NextJs = require("./initReactI18next.js");
var _defaultsJs = require("./defaults.js");
var _i18NInstanceJs = require("./i18nInstance.js");
var _contextJs = require("./context.js");
const date = ()=>'';
const time = ()=>'';
const number = ()=>'';
const select = ()=>'';
const plural = ()=>'';
const selectOrdinal = ()=>'';

},{"./Trans.js":"DgwPh","./TransWithoutContext.js":"sHApd","./useTranslation.js":"20fWi","./withTranslation.js":"gVFJu","./Translation.js":"a8d3V","./I18nextProvider.js":"dlLKF","./withSSR.js":"jRNsH","./useSSR.js":"8nH6V","./initReactI18next.js":"d7BbE","./defaults.js":"bxdFm","./i18nInstance.js":"8EQST","./context.js":"8QR7S","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"DgwPh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nodesToString", ()=>(0, _transWithoutContextJs.nodesToString));
parcelHelpers.export(exports, "Trans", ()=>Trans);
var _react = require("react");
var _transWithoutContextJs = require("./TransWithoutContext.js");
var _contextJs = require("./context.js");
function Trans(_ref) {
    let { children, count, parent, i18nKey, context, tOptions = {}, values, defaults, components, ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape, ...additionalProps } = _ref;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, _react.useContext)((0, _contextJs.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, _contextJs.getI18n)();
    const t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, _transWithoutContextJs.Trans)({
        children,
        count,
        parent,
        i18nKey,
        context,
        tOptions,
        values,
        defaults,
        components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n,
        t: tFromProps,
        shouldUnescape,
        ...additionalProps
    });
}

},{"react":"8CCva","./TransWithoutContext.js":"sHApd","./context.js":"8QR7S","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"sHApd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nodesToString", ()=>nodesToString);
parcelHelpers.export(exports, "Trans", ()=>Trans);
var _extends = require("@babel/runtime/helpers/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _htmlParseStringify = require("html-parse-stringify");
var _htmlParseStringifyDefault = parcelHelpers.interopDefault(_htmlParseStringify);
var _utilsJs = require("./utils.js");
var _defaultsJs = require("./defaults.js");
var _i18NInstanceJs = require("./i18nInstance.js");
function hasChildren(node, checkLength) {
    if (!node) return false;
    const base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function getChildren(node) {
    if (!node) return [];
    const children = node.props ? node.props.children : node.children;
    return node.props && node.props.i18nIsDynamicList ? getAsArray(children) : children;
}
function hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== '[object Array]') return false;
    return children.every((child)=>(0, _react.isValidElement)(child));
}
function getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function mergeProps(source, target) {
    const newTarget = {
        ...target
    };
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function nodesToString(children, i18nOptions) {
    if (!children) return '';
    let stringNode = '';
    const childrenArray = getAsArray(children);
    const keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach((child, childIndex)=>{
        if (typeof child === 'string') stringNode += `${child}`;
        else if ((0, _react.isValidElement)(child)) {
            const childPropsCount = Object.keys(child.props).length;
            const shouldKeepChild = keepArray.indexOf(child.type) > -1;
            const childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += `<${child.type}/>`;
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += `<${childIndex}></${childIndex}>`;
            else if (child.props.i18nIsDynamicList) stringNode += `<${childIndex}></${childIndex}>`;
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') stringNode += `<${child.type}>${childChildren}</${child.type}>`;
            else {
                const content = nodesToString(childChildren, i18nOptions);
                stringNode += `<${childIndex}>${content}</${childIndex}>`;
            }
        } else if (child === null) (0, _utilsJs.warn)(`Trans: the passed in value is invalid - seems you passed in a null child.`);
        else if (typeof child === 'object') {
            const { format, ...clone } = child;
            const keys = Object.keys(clone);
            if (keys.length === 1) {
                const value = format ? `${keys[0]}, ${format}` : keys[0];
                stringNode += `{{${value}}}`;
            } else (0, _utilsJs.warn)(`react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.`, child);
        } else (0, _utilsJs.warn)(`Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.`, child);
    });
    return stringNode;
}
function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === '') return [];
    const keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    const emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.map((keep)=>`<${keep}`).join('|')).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling && !shouldUnescape) return [
        targetString
    ];
    const data = {};
    function getData(childs) {
        const childrenArray = getAsArray(childs);
        childrenArray.forEach((child)=>{
            if (typeof child === 'string') return;
            if (hasChildren(child)) getData(getChildren(child));
            else if (typeof child === 'object' && !(0, _react.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    const ast = (0, _htmlParseStringifyDefault.default).parse(`<0>${targetString}</0>`);
    const opts = {
        ...data,
        ...combinedTOpts
    };
    function renderInner(child, node, rootReactNode) {
        const childs = getChildren(child);
        const mappedChildren = mapAST(childs, node.children, rootReactNode);
        return hasValidReactChildren(childs) && mappedChildren.length === 0 || child.props && child.props.i18nIsDynamicList ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) {
            child.children = inner;
            mem.push((0, _react.cloneElement)(child, {
                key: i
            }, isVoid ? undefined : inner));
        } else mem.push(...(0, _react.Children).map([
            child
        ], (c)=>{
            const props = {
                ...c.props
            };
            delete props.i18nIsDynamicList;
            return (0, _reactDefault.default).createElement(c.type, (0, _extendsDefault.default)({}, props, {
                key: i,
                ref: c.ref
            }, isVoid ? {} : {
                children: inner
            }));
        }));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        const reactNodes = getAsArray(reactNode);
        const astNodes = getAsArray(astNode);
        return astNodes.reduce((mem, node, i)=>{
            const translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                let tmp = reactNodes[parseInt(node.name, 10)];
                if (rootReactNode.length === 1 && !tmp) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                const child = Object.keys(node.attrs).length !== 0 ? mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                const isElement = (0, _react.isValidElement)(child);
                const isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
                const isEmptyTransWithHTML = emptyChildrenButNeedsHandling && typeof child === 'object' && child.dummy && !isElement;
                const isKnownComponent = typeof children === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === 'string') {
                    const value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if (hasChildren(child) || isValidTranslationWithChildren) {
                    const inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    const inner = mapAST(reactNodes, node.children, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        const inner = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, inner, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, _react.createElement)(node.name, {
                            key: `${node.name}-${i}`
                        }));
                        else {
                            const inner = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, _react.createElement)(node.name, {
                                key: `${node.name}-${i}`
                            }, inner));
                        }
                    } else if (node.voidElement) mem.push(`<${node.name} />`);
                    else {
                        const inner = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push(`<${node.name}>${inner}</${node.name}>`);
                    }
                } else if (typeof child === 'object' && !isElement) {
                    const content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else pushTranslatedJSX(child, translationContent, mem, i, node.children.length !== 1 || !translationContent);
            } else if (node.type === 'text') {
                const wrapTextNodes = i18nOptions.transWrapTextNodes;
                const content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, _react.createElement)(wrapTextNodes, {
                    key: `${node.name}-${i}`
                }, content));
                else mem.push(content);
            }
            return mem;
        }, []);
    }
    const result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, getAsArray(children || []));
    return getChildren(result[0]);
}
function Trans(_ref) {
    let { children, count, parent, i18nKey, context, tOptions = {}, values, defaults, components, ns, i18n: i18nFromProps, t: tFromProps, shouldUnescape, ...additionalProps } = _ref;
    const i18n = i18nFromProps || (0, _i18NInstanceJs.getI18n)();
    if (!i18n) {
        (0, _utilsJs.warnOnce)('You will need to pass in an i18next instance by using i18nextReactModule');
        return children;
    }
    const t = tFromProps || i18n.t.bind(i18n) || ((k)=>k);
    if (context) tOptions.context = context;
    const reactI18nextOptions = {
        ...(0, _defaultsJs.getDefaults)(),
        ...i18n.options && i18n.options.react
    };
    let namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    const nodeAsString = nodesToString(children, reactI18nextOptions);
    const defaultValue = defaults || nodeAsString || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    const { hashTransKey } = reactI18nextOptions;
    const key = i18nKey || (hashTransKey ? hashTransKey(nodeAsString || defaultValue) : nodeAsString || defaultValue);
    if (i18n.options && i18n.options.interpolation && i18n.options.interpolation.defaultVariables) values = values && Object.keys(values).length > 0 ? {
        ...values,
        ...i18n.options.interpolation.defaultVariables
    } : {
        ...i18n.options.interpolation.defaultVariables
    };
    const interpolationOverride = values ? tOptions.interpolation : {
        interpolation: {
            ...tOptions.interpolation,
            prefix: '#$?',
            suffix: '?$#'
        }
    };
    const combinedTOpts = {
        ...tOptions,
        count,
        ...values,
        ...interpolationOverride,
        defaultValue,
        ns: namespaces
    };
    const translation = key ? t(key, combinedTOpts) : defaultValue;
    const content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    const useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, _react.createElement)(useAsParent, additionalProps, content) : content;
}

},{"@babel/runtime/helpers/extends":"7fKUa","react":"8CCva","html-parse-stringify":"2drIO","./utils.js":"dSbW7","./defaults.js":"bxdFm","./i18nInstance.js":"8EQST","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7fKUa":[function(require,module,exports,__globalThis) {
function _extends() {
    module.exports = _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"2drIO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _voidElements = require("void-elements");
var _voidElementsDefault = parcelHelpers.interopDefault(_voidElements);
var t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, _voidElementsDefault.default)[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp(t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, i = /^\s*$/, s = Object.create(null);
function a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce(a, "") + "</" + t.name + ">";
        case "comment":
            return e + "\x3c!--" + t.comment + "--\x3e";
    }
}
var c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace(r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("\x3c!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + a("", t);
        }, "");
    }
};
exports.default = c;

},{"void-elements":"7BcbG","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7BcbG":[function(require,module,exports,__globalThis) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

},{}],"dSbW7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warn", ()=>warn);
parcelHelpers.export(exports, "warnOnce", ()=>warnOnce);
parcelHelpers.export(exports, "loadNamespaces", ()=>loadNamespaces);
parcelHelpers.export(exports, "loadLanguages", ()=>loadLanguages);
parcelHelpers.export(exports, "hasLoadedNamespace", ()=>hasLoadedNamespace);
parcelHelpers.export(exports, "getDisplayName", ()=>getDisplayName);
function warn() {
    if (console && console.warn) {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === 'string') args[0] = `react-i18next:: ${args[0]}`;
        console.warn(...args);
    }
}
const alreadyWarned = {};
function warnOnce() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
    if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
    warn(...args);
}
const loadedClb = (i18n, cb)=>()=>{
        if (i18n.isInitialized) cb();
        else {
            const initialized = ()=>{
                setTimeout(()=>{
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
function loadNamespaces(i18n, ns, cb) {
    i18n.loadNamespaces(ns, loadedClb(i18n, cb));
}
function loadLanguages(i18n, lng, ns, cb) {
    if (typeof ns === 'string') ns = [
        ns
    ];
    ns.forEach((n)=>{
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, loadedClb(i18n, cb));
}
function oldI18nextHasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const lng = i18n.languages[0];
    const fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    const lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    const loadNotPending = (l, n)=>{
        const loadState = i18n.services.backendConnector.state[`${l}|${n}`];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function hasLoadedNamespace(ns, i18n) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        warnOnce('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    const isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: (i18nInstance, loadNotPending)=>{
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function getDisplayName(Component) {
    return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bxdFm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setDefaults", ()=>setDefaults);
parcelHelpers.export(exports, "getDefaults", ()=>getDefaults);
var _unescapeJs = require("./unescape.js");
let defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: (0, _unescapeJs.unescape)
};
function setDefaults() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    defaultOptions = {
        ...defaultOptions,
        ...options
    };
}
function getDefaults() {
    return defaultOptions;
}

},{"./unescape.js":"dJzBb","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dJzBb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unescape", ()=>unescape);
const matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
const htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
const unescapeHtmlEntity = (m)=>htmlEntities[m];
const unescape = (text)=>text.replace(matchHtmlEntity, unescapeHtmlEntity);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8EQST":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setI18n", ()=>setI18n);
parcelHelpers.export(exports, "getI18n", ()=>getI18n);
let i18nInstance;
function setI18n(instance) {
    i18nInstance = instance;
}
function getI18n() {
    return i18nInstance;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8QR7S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaults", ()=>(0, _defaultsJs.getDefaults));
parcelHelpers.export(exports, "setDefaults", ()=>(0, _defaultsJs.setDefaults));
parcelHelpers.export(exports, "getI18n", ()=>(0, _i18NInstanceJs.getI18n));
parcelHelpers.export(exports, "setI18n", ()=>(0, _i18NInstanceJs.setI18n));
parcelHelpers.export(exports, "initReactI18next", ()=>(0, _initReactI18NextJs.initReactI18next));
parcelHelpers.export(exports, "I18nContext", ()=>I18nContext);
parcelHelpers.export(exports, "ReportNamespaces", ()=>ReportNamespaces);
parcelHelpers.export(exports, "composeInitialProps", ()=>composeInitialProps);
parcelHelpers.export(exports, "getInitialProps", ()=>getInitialProps);
var _react = require("react");
var _defaultsJs = require("./defaults.js");
var _i18NInstanceJs = require("./i18nInstance.js");
var _initReactI18NextJs = require("./initReactI18next.js");
const I18nContext = (0, _react.createContext)();
class ReportNamespaces {
    constructor(){
        this.usedNamespaces = {};
    }
    addUsedNamespaces(namespaces) {
        namespaces.forEach((ns)=>{
            if (!this.usedNamespaces[ns]) this.usedNamespaces[ns] = true;
        });
    }
    getUsedNamespaces() {
        return Object.keys(this.usedNamespaces);
    }
}
function composeInitialProps(ForComponent) {
    return (ctx)=>new Promise((resolve)=>{
            const i18nInitialProps = getInitialProps();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then((componentsInitialProps)=>{
                resolve({
                    ...componentsInitialProps,
                    ...i18nInitialProps
                });
            });
            else resolve(i18nInitialProps);
        });
}
function getInitialProps() {
    const i18n = (0, _i18NInstanceJs.getI18n)();
    const namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    const ret = {};
    const initialI18nStore = {};
    i18n.languages.forEach((l)=>{
        initialI18nStore[l] = {};
        namespaces.forEach((ns)=>{
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}

},{"react":"8CCva","./defaults.js":"bxdFm","./i18nInstance.js":"8EQST","./initReactI18next.js":"d7BbE","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"d7BbE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initReactI18next", ()=>initReactI18next);
var _defaultsJs = require("./defaults.js");
var _i18NInstanceJs = require("./i18nInstance.js");
const initReactI18next = {
    type: '3rdParty',
    init (instance) {
        (0, _defaultsJs.setDefaults)(instance.options.react);
        (0, _i18NInstanceJs.setI18n)(instance);
    }
};

},{"./defaults.js":"bxdFm","./i18nInstance.js":"8EQST","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"20fWi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTranslation", ()=>useTranslation);
var _react = require("react");
var _contextJs = require("./context.js");
var _utilsJs = require("./utils.js");
const usePrevious = (value, ignore)=>{
    const ref = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function useTranslation(ns) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext, defaultNS: defaultNSFromContext } = (0, _react.useContext)((0, _contextJs.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, _contextJs.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, _contextJs.ReportNamespaces)();
    if (!i18n) {
        (0, _utilsJs.warnOnce)('You will need to pass in an i18next instance by using initReactI18next');
        const notReadyT = (k, optsOrDefaultValue)=>{
            if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
            if (optsOrDefaultValue && typeof optsOrDefaultValue === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        const retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, _utilsJs.warnOnce)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    const i18nOptions = {
        ...(0, _contextJs.getDefaults)(),
        ...i18n.options.react,
        ...props
    };
    const { useSuspense, keyPrefix } = i18nOptions;
    let namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    const ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every((n)=>(0, _utilsJs.hasLoadedNamespace)(n, i18n, i18nOptions));
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    }
    const [t, setT] = (0, _react.useState)(getT);
    let joinedNS = namespaces.join();
    if (props.lng) joinedNS = `${props.lng}${joinedNS}`;
    const previousJoinedNS = usePrevious(joinedNS);
    const isMounted = (0, _react.useRef)(true);
    (0, _react.useEffect)(()=>{
        const { bindI18n, bindI18nStore } = i18nOptions;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, _utilsJs.loadLanguages)(i18n, props.lng, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
            else (0, _utilsJs.loadNamespaces)(i18n, namespaces, ()=>{
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return ()=>{
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach((e)=>i18n.off(e, boundReset));
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach((e)=>i18n.store.off(e, boundReset));
        };
    }, [
        i18n,
        joinedNS
    ]);
    const isInitial = (0, _react.useRef)(true);
    (0, _react.useEffect)(()=>{
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    const ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise((resolve)=>{
        if (props.lng) (0, _utilsJs.loadLanguages)(i18n, props.lng, namespaces, ()=>resolve());
        else (0, _utilsJs.loadNamespaces)(i18n, namespaces, ()=>resolve());
    });
}

},{"react":"8CCva","./context.js":"8QR7S","./utils.js":"dSbW7","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gVFJu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withTranslation", ()=>withTranslation);
var _react = require("react");
var _useTranslationJs = require("./useTranslation.js");
var _utilsJs = require("./utils.js");
function withTranslation(ns) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            let { forwardedRef, ...rest } = _ref;
            const [t, i18n, ready] = (0, _useTranslationJs.useTranslation)(ns, {
                ...rest,
                keyPrefix: options.keyPrefix
            });
            const passDownProps = {
                ...rest,
                t,
                i18n,
                tReady: ready
            };
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, _react.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = `withI18nextTranslation(${(0, _utilsJs.getDisplayName)(WrappedComponent)})`;
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        const forwardRef = (props, ref)=>(0, _react.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        return options.withRef ? (0, _react.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}

},{"react":"8CCva","./useTranslation.js":"20fWi","./utils.js":"dSbW7","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"a8d3V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Translation", ()=>Translation);
var _useTranslationJs = require("./useTranslation.js");
function Translation(props) {
    const { ns, children, ...options } = props;
    const [t, i18n, ready] = (0, _useTranslationJs.useTranslation)(ns, options);
    return children(t, {
        i18n,
        lng: i18n.language
    }, ready);
}

},{"./useTranslation.js":"20fWi","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dlLKF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "I18nextProvider", ()=>I18nextProvider);
var _react = require("react");
var _contextJs = require("./context.js");
function I18nextProvider(_ref) {
    let { i18n, defaultNS, children } = _ref;
    const value = (0, _react.useMemo)(()=>({
            i18n,
            defaultNS
        }), [
        i18n,
        defaultNS
    ]);
    return (0, _react.createElement)((0, _contextJs.I18nContext).Provider, {
        value
    }, children);
}

},{"react":"8CCva","./context.js":"8QR7S","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jRNsH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withSSR", ()=>withSSR);
var _react = require("react");
var _useSSRJs = require("./useSSR.js");
var _contextJs = require("./context.js");
var _utilsJs = require("./utils.js");
function withSSR() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            let { initialI18nStore, initialLanguage, ...rest } = _ref;
            (0, _useSSRJs.useSSR)(initialI18nStore, initialLanguage);
            return (0, _react.createElement)(WrappedComponent, {
                ...rest
            });
        }
        I18nextWithSSR.getInitialProps = (0, _contextJs.composeInitialProps)(WrappedComponent);
        I18nextWithSSR.displayName = `withI18nextSSR(${(0, _utilsJs.getDisplayName)(WrappedComponent)})`;
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}

},{"react":"8CCva","./useSSR.js":"8nH6V","./context.js":"8QR7S","./utils.js":"dSbW7","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8nH6V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSSR", ()=>useSSR);
var _react = require("react");
var _contextJs = require("./context.js");
function useSSR(initialI18nStore, initialLanguage) {
    let props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const { i18n: i18nFromProps } = props;
    const { i18n: i18nFromContext } = (0, _react.useContext)((0, _contextJs.I18nContext)) || {};
    const i18n = i18nFromProps || i18nFromContext || (0, _contextJs.getI18n)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce((mem, lngResources)=>{
            Object.keys(lngResources).forEach((ns)=>{
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}

},{"react":"8CCva","./context.js":"8QR7S","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4XMiP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Browser);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
    each.call(slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || '/';
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
};
var cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, '', -1);
    }
};
var cookie$1 = {
    name: 'cookie',
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== 'undefined') {
            var c = cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== 'undefined') cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var querystring = {
    name: 'querystring',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            var query = search.substring(1);
            var params = query.split('&');
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf('=');
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var hasLocalStorageSupport = null;
var localStorageAvailable = function localStorageAvailable() {
    if (hasLocalStorageSupport !== null) return hasLocalStorageSupport;
    try {
        hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        hasLocalStorageSupport = false;
    }
    return hasLocalStorageSupport;
};
var localStorage = {
    name: 'localStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var hasSessionStorageSupport = null;
var sessionStorageAvailable = function sessionStorageAvailable() {
    if (hasSessionStorageSupport !== null) return hasSessionStorageSupport;
    try {
        hasSessionStorageSupport = window !== 'undefined' && window.sessionStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        hasSessionStorageSupport = false;
    }
    return hasSessionStorageSupport;
};
var sessionStorage = {
    name: 'sessionStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var navigator$1 = {
    name: 'navigator',
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== 'undefined') {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var htmlTag = {
    name: 'htmlTag',
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === 'function') found = htmlTag.getAttribute('lang');
        return found;
    }
};
var path = {
    name: 'path',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === 'number') {
                    if (typeof language[options.lookupFromPathIndex] !== 'string') return undefined;
                    found = language[options.lookupFromPathIndex].replace('/', '');
                } else found = language[0].replace('/', '');
            }
        }
        return found;
    }
};
var subdomain = {
    name: 'subdomain',
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === 'number' ? options.lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== 'undefined' && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function getDefaults() {
    return {
        order: [
            'querystring',
            'cookie',
            'localStorage',
            'sessionStorage',
            'navigator',
            'htmlTag'
        ],
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: function convertDetectedLanguage(l) {
            return l;
        }
    };
}
var Browser = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, _classCallCheckDefault.default)(this, Browser);
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    (0, _createClassDefault.default)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services || {
                    languageUtils: {}
                }; // this way the language detector can be used without i18next
                this.options = defaults(options, this.options || {}, getDefaults());
                if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = function(l) {
                    return l.replace('-', '_');
                };
                // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector(cookie$1);
                this.addDetector(querystring);
                this.addDetector(localStorage);
                this.addDetector(sessionStorage);
                this.addDetector(navigator$1);
                this.addDetector(htmlTag);
                this.addDetector(path);
                this.addDetector(subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === 'string') lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                detected = detected.map(function(d) {
                    return _this.options.convertDetectedLanguage(d);
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
Browser.type = 'languageDetector';

},{"@babel/runtime/helpers/esm/classCallCheck":"7lrRq","@babel/runtime/helpers/esm/createClass":"hRISD","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7lrRq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_classCallCheck);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hRISD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createClass);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, _toPropertyKeyJsDefault.default)(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

},{"./toPropertyKey.js":"gQwWE","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gQwWE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function _toPropertyKey(arg) {
    var key = (0, _toPrimitiveJsDefault.default)(arg, "string");
    return (0, _typeofJsDefault.default)(key) === "symbol" ? key : String(key);
}

},{"./typeof.js":"fK3vB","./toPrimitive.js":"cGSUl","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fK3vB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cGSUl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function _toPrimitive(input, hint) {
    if ((0, _typeofJsDefault.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, _typeofJsDefault.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

},{"./typeof.js":"fK3vB","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1cXpK":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"account":{"addEscrow":{"availableAmount":"Verf\xfcgbar:","confirmDelegatingToInactive":{"description":"Der Status dieses Validators ist {{validatorStatus}}. Deine Delegation generiert m\xf6glicherweise keine Rewards","title":"Bist du sicher, dass du fortfahren m\xf6chtest?"},"confirmDelegatingToTop":{"acknowledge":"Trotzdem delegieren","description":"Dieser Validator ist in den Top 20 nach Stake. Bitte ziehe in Erw\xe4gung, zu einen kleineren Validator zu delegieren, um die Netzwerksicherheit und Dezentralisierung zu erh\xf6hen."},"delegate":"Delegieren"},"addressCopied":"Adresse kopiert.","emptyActiveDelegationsList":"Derzeit gibt es keine aktiven Delegationen f\xfcr dieses Konto.","emptyDebondingDelegationsList":"Derzeit gibt es kein Debonding von Delegationen f\xfcr dieses Konto.","loading":"Konto wird geladen","loadingError":"Konto konnte nicht geladen werden.","reclaimEscrow":{"reclaim":"Zur\xfcckfordern","reclaimAll":"Alles zur\xfcckfordern","reclaimableAmount":"Verf\xfcgbar:"},"sendTransaction":{"confirmSendingToValidator":{"description":"Dies ist die Adresse eines Validators. \xdcberweisungen an diese Adresse staken dein Guthaben nicht beim Validator.","title":"Bist du sicher, dass du fortfahren m\xf6chtest?"},"enterAddress":"Adresse eingeben","enterAmount":"Betrag eingeben","recipient":"Empf\xe4nger","send":"Senden","success":"Transaktion erfolgreich gesendet. Es kann bis zu einer Minute dauern, bis die Transaktion auf deinem Konto erscheint."},"subnavigation":{"activeDelegations":"Staked","debondingDelegations":"Debonding","mobileActiveDelegations":"Staked","mobileDebondingDelegations":"Debonding"},"summary":{"activity":"Aktivit\xe4t","balance":{"available":"Verf\xfcgbar","debonding":"Debonding","delegations":"Staked","total":"Gesamt"},"noTransactionFound":"Keine Transaktionen gefunden.","noWalletIsOpen":"Um {{ticker}}-Tokens zu senden, empfangen, staken oder tauschen, <HomeLink>\xf6ffne deine Wallet</HomeLink>.","notYourAccount":"Dies ist nicht dein Konto.","pendingTransactions":"Ausstehende Transaktionen","someTxsInPendingState":"Einige Transaktionen sind im Moment noch ausstehend.","viewAccountTxs":"Kontotransaktionen ansehen"},"transaction":{"addEscrow":{"sent":"Delegierte <Amount/> an Validator"},"explorerLink":"Transaktionen im Explorer ansehen","failed":"Fehlgeschlagen","genericTransaction":{"destination":"Andere Adresse"},"loadingError":"Transaktionen konnten nicht geladen werden.","pending":"Ausstehend","successful":"Erfolgreich","transfer":{"received":"Erhalten <Amount/>","sent":{"header":"Gesendet <Amount/>"}},"unrecognizedTransaction":{"destination":"Andere Adresse","header":"Unbekannte Transaktion, Methode \'{{method}}\'"}},"validator":{"loadingError":"Validatoren konnten nicht geladen werden."}},"backends":{"oasisscan":"Oasis Scan API"},"banner":{"buildStaging":"Bitte beachte, dass dies die Testversion der ROSE Wallet ist. VERWENDE SIE NUR ZU TESTZWECKEN."},"common":{"amount":"Betrag","block":"Block","cancel":"Abbrechen","confirm":"Best\xe4tigen","delegator":"Delegator","from":"Von","hash":"Tx Hash","round":"Runde","time":"Zeit","to":"Zu","unavailable":"Nicht verf\xfcgbar","validator":"Validator","validators":"Validatoren"},"createWallet":{"confirmSaved":"Ich habe meine mnemonic gespeichert.","doNotShare":"Gib niemals deine mnemonic weiter, denn jeder, der deine mnemonic hat, kann auf deine Wallet und deine Token zugreifen."},"delegations":{"activeDelegations":"Aktive Delegationen","delegatedAmount":"Delegierter Betrag","loadingError":"Delegationen konnten nicht geladen werden.","reclaimedAmount":"Betrag zur R\xfcckerstattung"},"deleteForm":{"confirm":"Ja, l\xf6schen","confirmationKeyword":"l\xf6schen","hint":"Eingeben \'<strong>{{confirmationKeyword}}</strong>\'"},"errors":{"LedgerDerivedDifferentAccount":"Dieses Konto geh\xf6rt nicht zu dem aktuell verbundenen Ledger.","LedgerOasisAppIsNotOpen":"Die Oasis App auf Ledger ist geschlossen.","bluetoothTransportNotSupported":"Dein Ger\xe4t unterst\xfctzt kein Bluetooth.","cannotSendToSelf":"Kann nicht an sich selbst senden","disconnectedError":"Verbindung verloren.","duplicateTransaction":"Doppelte Transaktion","insufficientBalance":"Unzureichendes Guthaben","invalidAddress":"Ung\xfcltige Adresse","invalidNonce":"Ung\xfcltige Nonce (Transaktionsnummer)","invalidPrivateKey":"Ung\xfcltiger privater Schl\xfcssel","ledgerTransactionRejected":"Transaktion auf Ledger abgelehnt.","noOpenWallet":"Kein Wallet ge\xf6ffnet","unknown":"Unbekannter Fehler: {{message}}","unknownGrpc":"Unbekannter gRPC-Fehler: {{message}}","unknownLedgerError":"Unbekannter Ledger-Fehler: {{message}}","unknownParaTimeError":"Unbekannter ParaTime-Fehler: {{message}}","usbTransportError":"USB Transportfehler: {{message}}.","usbTransportNotSupported":"Dein Browser unterst\xfctzt kein WebUSB (z.B. Firefox). Versuche es mit Chrome."},"fatalError":{"copied":"Fehler in die Zwischenablage kopiert","copy":"Fehler in die Zwischenablage kopieren","reloadApp":"App neu laden"},"footer":{"terms":"<TermsLink>Allgemeine Gesch\xe4ftsbedingungen</TermsLink>","version":"Version: <ReleaseLink/> (commit: <CommitLink/>) gebaut um {{buildTime}}."},"home":{"create":{"button":"Wallet erstellen","header":"Neue Wallet erstellen"},"existing":{"button":"Wallet \xf6ffnen","header":"Auf vorhandene Wallet zugreifen"}},"icons":{"bluetooth":"Bluetooth","mnemonic":"Mnemonic","privateKey":"Privater Schl\xfcssel","usb":"Usb","wallet":{"label":"Wallet"}},"infoBox":{"valueCopied":"{{label}} kopiert."},"language":"Sprache","ledger":{"extension":{"connect":"Ledger-Ger\xe4t verbinden","failed":"Verbindung fehlgeschlagen","grantAccess":"Gew\xe4hre Zugriff auf dein USB Ledger.","succeed":"Ger\xe4t verbunden"},"instructionSteps":{"header":"Schritte:"},"steps":{"loadingAccounts":"Kontodetails werden geladen","loadingBluetoothDevices":"Bluetooth-Ger\xe4te werden geladen","openingUsb":"\xd6ffne Ledger \xfcber USB"}},"menu":{"addAccounts":"Konten hinzuf\xfcgen","closeWallet":"Wallet schlie\xdfen","home":"Home","lockProfile":"Profil sperren","openMenu":"Men\xfc","paraTimes":"ParaTimes","stake":"ROSE staken","stake-mobile":"Stake","unlockProfile":"Profil entsperren","wallet":"Konto"},"migrateV0Extension":{"finishMigration":"\xd6ffne die neue Version der Wallet","nextStep":"Weiter","requiredField":"Dieses Feld ist erforderlich","title":"Wichtiges Wallet-Update"},"mobileUpdate":{"later":"Sp\xe4ter","retry":"Wiederholen","unknownTitle":"Unbekannter Fehler","updateAvailableTitle":"Aktualisierung ausstehend...","updateInProgressTitle":"Aktualisierung am laufen..","updateNow":"Jetzt aktualisieren"},"openWallet":{"header":"Wie m\xf6chtest du dein Wallet \xf6ffnen?","importAccounts":{"accountCounter_one":"Ein Konto ausgew\xe4hlt","accountCounter_zero":"Kein Konto ausgew\xe4hlt","bluetoothLedger":"Bluetooth Ledger","next":"Weiter","openWallets":"\xd6ffnen","prev":"Zur\xfcck"},"method":{"ledger":"Ledger","mnemonic":"Mnemonic","privateKey":"Privater Schl\xfcssel"},"mnemonic":{"import":"Importiere mein Wallet"},"privateKey":{"error":"Ung\xfcltiger privater Schl\xfcssel"}},"paraTimes":{"amount":{"advanced":"Erweitert","available":"Verf\xfcgbar:","emptyAccount":"Das Konto ist leer. Es gibt nichts abzuheben.","tooltip":"Der Maximalwert kann durch die Geb\xfchr verringert werden."},"common":{"cipher":"Cipher"},"confirmation":{"confirmTransferLabel":"Ich best\xe4tige, dass der Betrag und die Adresse korrekt sind.","confirmTransferToForeignAccount":"Ich best\xe4tige, dass ich direkt auf ein externes Konto abheben m\xf6chte.","depositLabel":"Einzahlen","withdrawLabel":"Abheben"},"footer":{"back":"Zur\xfcck","next":"Weiter"},"recipient":{"placeholder":"0x..."},"selection":{"cancel":"\xdcbertragung abbrechen","evmc":"EVMc"},"transfers":{"deposit":"Auf ParaTime einzahlen","withdraw":"Von ParaTime abheben"},"unsupportedFormStep":"Nicht unterst\xfctzter Formularschritt","validation":{"insufficientBalanceToPayFee":"Unzureichendes Guthaben, um die Geb\xfchr zu bezahlen","invalidEthPrivateKeyLength":"Der private Schl\xfcssel sollte 64 Zeichen lang sein","invalidFee":"Der Wert muss eine ganze Zahl sein, die gr\xf6\xdfer oder gleich 0 ist","required":"Feld ist erforderlich"}},"persist":{"createProfile":{"choosePassword":"Passwort w\xe4hlen","repeatPassword":"Passwort erneut eingeben"},"loading":"Laden","loginToProfile":{"deleteProfile":{"button":"Profil l\xf6schen","title":"Profil l\xf6schen"},"hidePassword":"Passwort verbergen","showPassword":"Passwort anzeigen","skipUnlocking":"Weiter ohne das Profil","title":"Willkommen zur\xfcck!","unlock":"Entsperren","wrongPassword":"Falsches Passwort"}},"theme":{"title":"Theme"},"toolbar":{"contacts":{"add":"Kontakt hinzuf\xfcgen","address":"Adresse","cancel":"Abbrechen","delete":{"button":"Kontakt l\xf6schen","confirm":"Ja, l\xf6schen","description":"Bist du sicher, dass du diesen Kontakt l\xf6schen m\xf6chtest?","title":"Kontakt l\xf6schen"},"emptyList":"Du hast noch keine Kontakte.","manage":"Kontakt verwalten","name":"Name","save":"Speichern","validation":{"addressError":"Bitte gib eine g\xfcltige Wallet-Adresse ein.","addressNotUniqueError":"Adresse existiert bereits","nameLengthError":"Nicht mehr als 16 Zeichen","required":"Feld ist erforderlich"}},"networks":{"local":"Lokal","mainnet":"Mainnet","selector":"Netzwerk ausw\xe4hlen","testnet":"Testnet"},"profile":{"deletion":"L\xf6schung","password":{"current":"Aktuelles Passwort","enterCurrent":"Aktuelles Passwort eingeben","enterNewPassword":"Neues Passwort","reenterNewPassword":"Erneut neues Passwort eingeben","submit":"Passwort aktualisieren","success":"Passwort aktualisiert.","title":"Setze ein neues Passwort"}},"settings":{"cancel":"Abbrechen","contacts":"Kontakte","delete":{"description":"Bist du sicher, dass du das folgende Konto l\xf6schen m\xf6chtest?","inputHelp":"Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden. Um fortzufahren, gib bitte \'<strong>{{confirmationKeyword}}</strong>\' unten ein.","title":"Konto l\xf6schen","tooltip":"Du musst immer mindestens ein Konto haben."},"exportPrivateKey":{"copied":"Privater Schl\xfcssel kopiert.","hint1":"Der private Schl\xfcssel besteht aus einer Reihe von Zeichen. Jeder, der Zugriff auf deinen privaten Schl\xfcssel hat, hat direkten Zugriff auf das Verm\xf6gen des Kontos.","title":"Privaten Schl\xfcssel exportieren"},"manageAccount":"Verwalten","myAccountsTab":"Meine Konten","nameLengthError":"Nicht mehr als 16 Zeichen","optionalName":"Name (optional)","profile":"Profil","save":"Speichern","settings":"Einstellungen"},"wallets":{"select":"Ausw\xe4hlen"}},"transaction":{"cancel":"Abbrechen","confirm":"Best\xe4tigen","preview":{"amount":"Betrag","fee":"Geb\xfchr","from":"Von","to":"Zu","type":"Typ","validator":"Validator"},"step":{"preview":"Vorschau Transaktion"}},"validator":{"boundsNotSet":"Keine Grenzen festgelegt (0% - 100%)","commission":"Kommission","fee":"Geb\xfchr","name":"Name","rank":"Rang","status":"Status","statusActive":"Aktiv","statusInactive":"Inaktiv","statusUnknown":"Unbekannt","unknownValidator":"Unbekannter Validator"}}');

},{}],"p0rWn":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"account":{"addEscrow":{"availableAmount":"Available:","confirmDelegatingToInactive":{"description":"Status of this validator is {{validatorStatus}}. Your delegation might not generate any rewards.","title":"Are you sure you want to continue?"},"confirmDelegatingToTop":{"acknowledge":"Delegate anyway","description":"This validator is ranked in the top 20 by stake. Please consider delegating to a smaller validator to increase network security and decentralization."},"delegate":"Delegate"},"addressCopied":"Address copied.","emptyActiveDelegationsList":"There are currently no active delegations for this account.","emptyDebondingDelegationsList":"There are no debonding delegations for this account.","loading":"Loading account","loadingError":"Couldn\'t load account.","reclaimEscrow":{"convertedToShares":"Corresponding number of shares: {{shares}}","reclaim":"Reclaim","reclaimAll":"Reclaim all","reclaimableAmount":"Available:"},"sendTransaction":{"confirmSendingToValidator":{"description":"This is a validator address. Transfers to this address do not stake your funds with the validator.","title":"Are you sure you want to continue?"},"enterAddress":"Enter an address","enterAmount":"Enter an amount","recipient":"Recipient","send":"Send","success":"Transaction successfully sent. The transaction might take up to a minute to appear on your account."},"subnavigation":{"activeDelegations":"Staked","debondingDelegations":"Debonding","mobileActiveDelegations":"Staked","mobileDebondingDelegations":"Debonding"},"summary":{"activity":"Activity","balance":{"available":"Available","debonding":"Debonding","delegations":"Staked","total":"Total"},"noTransactionFound":"No transactions found.","noTransactionFoundOasisscanV2":"No transactions since November 29, 2023.","noWalletIsOpen":"To send, receive, stake and swap {{ticker}} tokens, <HomeLink>open your wallet</HomeLink>.","notYourAccount":"This is not your account.","pendingTransactions":"Pending transactions","someTxsInPendingState":"Some transactions are currently in a pending state.","viewAccountTxs":"View account transactions"},"transaction":{"addEscrow":{"received":"Received <Amount/> delegation in escrow","sent":"Delegated <Amount/> to validator"},"consensusDeposit":{"received":"Received <Amount/> deposit into {{runtimeName}} ParaTime","sent":"Deposited <Amount/> into {{runtimeName}} ParaTime"},"consensusWithdraw":{"received":"Withdrew <Amount/> out of {{runtimeName}} ParaTime","sent":"Received <Amount/> from withdrawal out of {{runtimeName}} ParaTime"},"explorerLink":"View transaction records through explorer","failed":"Failed","genericTransaction":{"destination":"Other address","header":"Method \'{{method}}\'"},"loadingError":"Couldn\'t load transactions.","pending":"Pending","reclaimEscrow":{"received":"<Amount/> reclaimed by delegator","sent":"Reclaimed <Amount/> from validator"},"stakingAllow":{"received":"Received <Amount/> allowance","sent":"Changed allowance <Amount />","sentToParaTime":"Changed allowance <Amount /> for {{runtimeName}} ParaTime"},"stakingBurn":{"sent":"Burned <Amount/>"},"successful":"Successful","transfer":{"received":"Received <Amount/>","sent":{"header":"Sent <Amount/>"}},"unrecognizedTransaction":{"destination":"Other address","header":"Unrecognized transaction, method \'{{method}}\'"}},"validator":{"loadingError":"Couldn\'t load validators.","showingStale":"Showing validator list as of {{staleTimestamp}}."}},"appTitle":"ROSE Wallet","backends":{"nexus":"Nexus API","oasisscanV2":"Oasis Scan API v2"},"banner":{"buildPreview":"Please note this is an experimental build of ROSE Wallet and your secrets are not safe. ONLY USE IT FOR TESTING.","buildStaging":"Please note this is the staging deployment of ROSE Wallet. ONLY USE IT FOR TESTING."},"common":{"amount":"Amount","block":"Block","cancel":"Cancel","confirm":"Confirm","delegator":"Delegator","from":"From","hash":"Tx Hash","postfixAmountInBillions":"B","round":"Round","time":"Time","to":"To","unavailable":"Unavailable","validator":"Validator","validators":"Validators"},"createWallet":{"confirmSaved":"I\u2019ve safely stored my mnemonic","doNotShare":"Never share your mnemonic, anyone with your mnemonic can access your wallet and your tokens.","instruction":"Save your mnemonic <strong>in the right order</strong> in a secure location, you will need it to open your wallet.","mnemonicMismatch":"Entered mnemonic does not match.","newMnemonic":"Generate a new mnemonic","thisIsYourPhrase":"This is your mnemonic"},"delegations":{"debondingTimeEnd":"End of debonding","delegatedAmount":"Delegated amount","loadingError":"Couldn\'t load delegations.","reclaimedAmount":"Amount to reclaim"},"deleteForm":{"confirm":"Yes, delete","confirmationKeyword":"delete","hint":"Type <strong>{{confirmationKeyword}}</strong>"},"errors":{"LedgerDerivedDifferentAccount":"This account does not belong to the currently connected Ledger.","LedgerLikelyFaultyFirmware":"Connecting to Ledger timed out. This is likely due to faulty Ledger firmware: Nano X 2.5.0, Nano S Plus 1.4.0, Stax 1.8.0, Flex 1.4.0. Update to the next firmware version and try again.","LedgerOasisAppIsNotOpen":"Oasis App on Ledger is closed.","bluetoothTransportNotSupported":"Bluetooth may be turned off or your current platform does not support Bluetooth capability.","cannotSendToSelf":"Cannot send to yourself","disconnectedError":"Lost connection.","duplicateTransaction":"Duplicate transaction","indexerAPIError":"{{indexerName}} appears to be down, some information may be missing or out of date. Please, come back later.","insufficientBalance":"Insufficient balance","invalidAddress":"Invalid address","invalidNonce":"Invalid nonce (transaction number)","invalidPrivateKey":"Invalid private key","ledgerAppVersionNotSupported":"Oasis App on Ledger is closed or outdated. Make sure Ledger is unlocked, the Oasis App is opened and up to date.","ledgerCannotOpenOasisApp":"Could not open Oasis App on Ledger. Make sure Ledger is unlocked and the Oasis App is opened.","ledgerNoDeviceSelected":"No Ledger device selected. Make sure it is connected, <LedgerHelp>check common USB connection issues with Ledger</LedgerHelp>, and <ChromeHelp>check site permissions don\'t block USB devices</ChromeHelp>.","ledgerTransactionRejected":"Transaction rejected on Ledger.","noOpenWallet":"No wallet opened","unknown":"Unknown error: {{message}}","unknownGrpc":"Unknown gRPC error: {{message}}","unknownLedgerError":"Unknown ledger error: {{message}}","unknownParaTimeError":"Unknown ParaTime error: {{message}}","usbTransportError":"USB Transport error: {{message}}.","usbTransportNotSupported":"Current platform does not support WebUSB capability. Try on different platform or browser (preferably Chrome)."},"fatalError":{"checkStatus":"Check network status","copied":"Error copied to clipboard","copy":"Copy error to clipboard","description":"The error that has occurred triggers the wallet to stop. <strong>Your funds are safe.</strong><br/><br/>Please try refreshing the page and reopening your wallet to see if the issue persists. You can check the current status of the network below.","heading":"An error occurred.","instruction":"If the issue is not resolved after refreshing, please email our support team at  <Email/> and attach the error report.","reloadApp":"Reload app"},"footer":{"feedback":"We\u2019d love your feedback at <EmailLink>wallet@oasisprotocol.org</EmailLink>","github":"ROSE Wallet is <GithubLink>open source</GithubLink> and powered by","poweredBy":{"nexus":"Nexus API & Oasis gRPC","oasisscanV2":"Oasis Scan API v2 & Oasis gRPC"},"terms":"<TermsLink>Terms and Conditions</TermsLink>","version":"Version: <ReleaseLink/> (commit: <CommitLink/>) built at {{buildTime}}"},"home":{"create":{"button":"Create wallet","description":"Create a brand new wallet to send, receive, stake and swap ROSE tokens.","header":"Create new wallet"},"existing":{"button":"Open wallet","description":"Open your existing wallet stored on Ledger, import a private key or a mnemonic phrase.","header":"Access existing wallet"}},"icons":{"bluetooth":"Bluetooth","mnemonic":"Mnemonic","privateKey":"Private key","usb":"Usb","wallet":{"label":"Wallet"}},"infoBox":{"valueCopied":"{{label}} copied."},"language":"Language","ledger":{"extension":{"closingPopup":"Closing... Please re-open the wallet app","connect":"Connect Ledger device","failed":"Connection failed","grantAccess":"Grant access to your USB Ledger","succeed":"Device connected"},"instructionSteps":{"closeLedgerLive":"Close the Ledger Live app on your computer","connectBluetoothLedger":"Connect your Ledger to this device via Bluetooth","connectUsbLedger":"Connect your Ledger to this device via USB","deviceIsPaired":"Make sure your Ledger is paired with this device","header":"Steps:","openOasisApp":"Open the Oasis app on your Ledger"},"steps":{"accessingLedger":"Connecting with Ledger device","idle":"Idle","loadingAccounts":"Loading account details","loadingBalances":"Loading balance details","loadingBluetoothDevices":"Loading bluetooth devices"},"verifyAddressOnLedger":"Verify address on Ledger"},"menu":{"addAccounts":"Add accounts","closeWallet":"Close wallet","home":"Home","lockProfile":"Lock profile","openMenu":"Menu","paraTimes":"ParaTimes","stake":"Stake ROSE","stake-mobile":"Stake","unlockProfile":"Unlock profile","wallet":"Account"},"migrateV0Extension":{"backupInvalidPrivateKeys":{"confirm":"I\u2019ve safely stored my private keys","description":"{{count}} of your private keys have typos and won\u2019t be stored by the new wallet extension. Please make sure to copy them and store them elsewhere before proceeding, so you can correct them later.","description_one":"1 of your private keys has typos and won\u2019t be stored by the new wallet extension. Please make sure to copy it and store it elsewhere before proceeding, so you can correct it later.","description_plural":"{{count}} of your private keys have typos and won\u2019t be stored by the new wallet extension. Please make sure to copy them and store them elsewhere before proceeding, so you can correct them later.","reveal":"Tap to show invalid private key"},"backupMnemonic":{"description":"The new version of the wallet extension will no longer store your mnemonic. This phrase is the only way to restore your account if you have lost access. You now have a final chance to backup your mnemonic.","reveal":"Tap to show your mnemonic"},"finishMigration":"Open the new version of the wallet","nextStep":"Next","requiredField":"This field is required","title":"Important Wallet Update"},"mobileUpdate":{"errorTitle":"Unexpected error","later":"Later","retry":"Retry","unknownOrErrorDescription":"Apologies for the inconvenience, an unexpected error has transpired. Please verify your internet connection and retry by clicking on the \\"{{retryButtonLabel}}\\" button.","unknownTitle":"Unknown error","updateAvailableDescription":"A new update is available for your ROSE Wallet. We recommend updating to the latest version for bug fixes, enhanced security and new features.","updateAvailableTitle":"Update pending...","updateInProgressDescription":"Your ROSE Wallet is currently undergoing an update. Please check back at later time. Alternatively, you may choose to retry by clicking on the \\"{{retryButtonLabel}}\\" button.","updateInProgressTitle":"Update in progress...","updateNow":"Update now"},"openWallet":{"bitpie":{"warning":"\u2757 BitPie wallet users: You cannot import the mnemonic phrase directly from your BitPie wallet. <DocsLink>Check documentation for details.</DocsLink>"},"header":"How do you want to open your wallet?","importAccounts":{"NoBLEDevicesFound":"No Bluetooth devices found","accountCounter":"{{count}} accounts selected","accountCounter_one":"One account selected","accountCounter_plural":"{{count}} accounts selected","accountCounter_zero":"No account selected","bluetoothLedger":"Bluetooth Ledger","connectDeviceHeader":"How do you want to connect your Ledger device?","next":"Next","openWallets":"Open","pageNumber":"Page {{pageNum}} of {{totalPages}}","prev":"Prev","selectDevice":"Select device","selectLedgerDevice":"Select Ledger device","selectWallets":"Select accounts to open","usbLedger":"USB Ledger"},"ledger":{"header":"Open from Ledger device"},"method":{"ledger":"Ledger","mnemonic":"Mnemonic","privateKey":"Private key"},"mnemonic":{"enterPhraseHere":"Enter your mnemonic here","error":"Invalid mnemonic. Please make sure to input the words in the right order, all lowercase.","header":"Enter your mnemonic","import":"Import my wallet","instruction":"Enter all your mnemonic words below separated by spaces. Most mnemonics are made of either 24 or 12 words."},"privateKey":{"enterPrivateKeyHere":"Enter your private key here","error":"Invalid private key","errorKeyIsInEthFormat":"This input is intended for Oasis Consensus private keys. The private key you entered looks like an Ethereum-compatible private key (e.g. from MetaMask for Sapphire). If you want to use your Ethereum-compatible private key to move ROSE from Sapphire to Consensus, click \\"{{paratimesMenu}}\\", then \\"{{withdrawButton}}\\", and paste it there.","header":"Enter your private key","hidePrivateKey":"Hide private key","instruction":"Enter your private key in Base64 format.","showPrivateKey":"Show private key"}},"paraTimes":{"amount":{"advanced":"Advanced","available":"Available:","depositDescription":"Please enter the amount of {{ticker}} to deposit and then click \\"{{nextButtonLabel}}\\"","emptyAccount":"The account is empty. There is nothing to withdraw.","feeAmountPlaceholder":"Fee Amount (nano {{ticker}})","feeGasPlaceholder":"Fee Gas","max":"MAX","tooltip":"Max value may be decreased by the fee","withdrawDescription":"Please enter the amount of {{ticker}} to withdraw and then click \\"{{nextButtonLabel}}\\""},"common":{"cipher":"Cipher","discouragedType":"(experimental)","emerald":"Emerald","evmcType":"(EVMc)","header":"ParaTime Transfers","sapphire":"Sapphire"},"confirmation":{"confirmDepositDescription":"Please confirm the deposit amount and the recipient address are correct and then click \\"{{nextButtonLabel}}\\".","confirmDepositToForeignAccountDescription":"Destination address does not match any of the accounts in your wallet! Some services such as exchanges, may not support direct deposits to fund your account. For better compatibility, we strongly recommend that you first deposit to your ParaTime account and then transfer {{ticker}} to the destination address.","confirmTransferLabel":"I confirm the amount and the address are correct","confirmTransferToForeignAccount":"I confirm I want to directly withdraw to an external account","confirmTransferToValidatorLabel":"I confirm I want to transfer {{ticker}} to a validator address","confirmWithdrawDescription":"Please confirm the withdrawal amount and the recipient address are correct and then click \\"{{nextButtonLabel}}\\".","confirmWithdrawToForeignAccountDescription":"Destination address does not match any of the accounts in your wallet! Some services such as exchanges, may not support direct withdrawals to fund the account. For better compatibility, we strongly recommend that you first withdraw to your consensus account and then transfer {{ticker}} to the destination address.","depositDescription":"You are about to deposit <strong>{{value}} {{ticker}}</strong> to <strong>{{address}}</strong> on <strong>{{paraTime}}</strong> {{paratimeType}}","depositLabel":"Deposit","withdrawDescription":"You are about to withdraw <strong>{{value}} {{ticker}}</strong> from <strong>{{paraTime}}</strong> {{paratimeType}} to <strong>{{address}}</strong>","withdrawLabel":"Withdraw"},"error":{"depositDescription":"Transaction failed. We were not able to complete deposit of <strong>{{value}} {{ticker}}</strong> to <strong>{{address}}</strong> on <strong>{{paraTime}}</strong> {{paratimeType}}","withdrawDescription":"Transaction failed. We were not able to complete withdrawal of <strong>{{value}} {{ticker}}</strong> from <strong>{{paraTime}}</strong> {{paratimeType}} to <strong>{{address}}</strong>"},"footer":{"back":"Back","next":"Next","notice":"* EVMc - compatible with Ethereum Virtual Machine"},"pageInaccessible":{"foreignAccount":"Transfers are not available.","ledgerAccount":"Ledger account is not supported."},"recipient":{"depositDescription":"Please enter the recipient address on <strong>{{paraTime}}</strong> {{paratimeType}} and then click \\"{{nextButtonLabel}}\\"","ethPrivateKeyPlaceholder":"Enter Ethereum-compatible private key","ethPrivateKeySelectInstructions":"Type a private key or select a previously entered ParaTime account","evmcWithdrawDescription":"Please enter the private key of the account on ParaTime, the recipient address on consensus and click \\"{{nextButtonLabel}}\\"","placeholder":"0x...","withdrawDescription":"Please enter the recipient address on consensus and click \\"{{nextButtonLabel}}\\""},"selection":{"cancel":"Cancel transfer","depositDescription":"Please select which ParaTime you wish to deposit your {{ticker}} to and then click \\"{{nextButtonLabel}}\\".","evmc":"EVMc","select":"Select a ParaTime","withdrawDescription":"Please select which ParaTime you wish to withdraw your {{ticker}} from and then click \\"{{nextButtonLabel}}\\"."},"summary":{"depositDescription":"You have successfully deposited <strong>{{value}} {{ticker}}</strong> to <strong>{{address}}</strong> on <strong>{{paraTime}}</strong> {{paratimeType}}","navigate":"Navigate to ParaTime Transfers","withdrawDescription":"You have successfully withdrawn <strong>{{value}} {{ticker}}</strong> from <strong>{{paraTime}}</strong> {{paratimeType}} to <strong>{{address}}</strong>"},"transfers":{"deposit":"Deposit to ParaTime","depositDisabled":"You don\'t have any {{ticker}} tokens to transfer","description":"Click on the \\"{{depositButtonLabel}}\\" button to deposit your {{ticker}} from consensus to a ParaTime of your choice or \\"{{withdrawButtonLabel}}\\" to withdraw your {{ticker}} from a ParaTime back to consensus.","withdraw":"Withdraw from ParaTime"},"unsupportedFormStep":"Unsupported form step","validation":{"insufficientBalanceToPayFee":"Insufficient balance to pay the fee","invalidDecimalValue":"Maximum of {{decimals}} decimal places is allowed","invalidEthPrivateKey":"Ethereum-compatible private key is invalid","invalidEthPrivateKeyLength":"Private key should be 64 characters long","invalidFee":"Value must be integer greater than or equal to 0","required":"Field is required","unsupportedParaTime":"Unsupported ParaTime"}},"persist":{"createProfile":{"passwordMismatch":"Entered password does not match","repeatPassword":"Confirm your password","requiredField":"This field is required","startPersisting":"Store your private keys locally and protect them with a password by creating a profile.","startPersistingToggle":"Create a profile","undependableAcknowledge":"I understand this password and profile do not substitute my mnemonic.","unsupported":"Persistence is not supported in this browser."},"loading":"Loading","loginToProfile":{"deleteProfile":{"button":"Delete profile","description":"This will <strong>permanently remove your private keys from this device.</strong><br/><br/>To confirm and proceed, please type <strong>{{confirmationKeyword}}</strong> below.","forgotPasswordButton":"Forgot password?","forgotPasswordDescription":"ROSE Wallet does not store your password and cannot help you retrieve it. If you forgot your password, you can delete your locked profile here. After that, you can create a new one using your mnemonic phrase or private keys, and use your ROSE tokens again.","title":"Delete Profile"},"description":"Enter your password to access your existing wallets on this device.","enterPasswordHere":"Enter your password","hidePassword":"Hide password","showPassword":"Show password","skipUnlocking":"Continue without the profile","title":"Welcome Back!","unlock":"Unlock","wrongPassword":"Wrong password"}},"screenPrivacy":{"off":"Off","on":"On","title":"Screen Privacy","tooltip":"Prevent sensitive information from being visible in app switchers and when leaving an app."},"theme":{"darkMode":"Dark mode","lightMode":"Light mode","system":"System","title":"Theme"},"toolbar":{"contacts":{"add":"Add contact","address":"Address","cancel":"Cancel","delete":{"button":"Delete contact","confirm":"Yes, delete","description":"Are you sure you want to delete this contact?","title":"Delete Contact"},"emptyList":"You have no contacts yet.","manage":"Manage Contact","name":"Name","notAvailable":"To start adding contacts create a profile while <OpenWalletButton>opening a wallet</OpenWalletButton>.","save":"Save","validation":{"addressError":"Please enter a valid wallet address","addressNotUniqueError":"Address already exists","nameLengthError":"No more than 16 characters","required":"Field is required"}},"networks":{"local":"Local","mainnet":"Mainnet","selector":"Select network","testnet":"Testnet"},"profile":{"notAvailable":"You can setup your profile while <OpenWalletButton>opening a wallet</OpenWalletButton>.","password":{"current":"Current password","enterCurrent":"Enter your current password","enterNewPassword":"New password","reenterNewPassword":"Re-enter new password","submit":"Update password","success":"Password updated.","title":"Set a new password"}},"settings":{"accountNamingNotAvailable":"To name your account create a profile while <OpenWalletButton>opening a wallet</OpenWalletButton>.","cancel":"Cancel","contacts":"Contacts","delete":{"description":"Are you sure you want to delete the following account?","inputHelp":"This action cannot be undone. To continue please type <strong>{{confirmationKeyword}}</strong> below.","title":"Delete Account","tooltip":"You must have at least one account at all times."},"exportPrivateKey":{"confirm":"I understand, reveal my private key","copied":"Private key copied.","hint1":"The private key consists of a string of characters. Anyone with access to your private key has direct access to the assets of that account.","hint2":"If the private key is lost, it cannot be retrieved. Please make sure to backup the private key and keep it in a safe place.","title":"Export Private Key"},"manageAccount":"Manage","myAccountsTab":"My Accounts","nameLengthError":"No more than 16 characters","optionalName":"Name (optional)","profile":"Profile","save":"Save","settings":"Settings"},"wallets":{"select":"Select"}},"transaction":{"cancel":"Cancel","confirm":"Confirm","preview":{"amount":"Amount","fee":"Fee","from":"From","gas":"Gas","genesisHash":"Genesis hash","shares":"Shares","to":"To","type":"Type","validator":"Validator","warning":"Once you confirm this transaction you will not be able to cancel it. Carefully review it, and confirm once you are sure that you want to send it."},"step":{"building":"Building transaction","preview":"Preview transaction","signing":"Signing transaction","submitting":"Submitting transaction"},"types":{"addEscrow":"delegating your tokens to a validator and generate rewards","reclaimEscrow":"reclaiming your tokens delegated to a validator","transfer":"sending tokens from your account to another"}},"validator":{"boundsNotSet":"No bounds set (0% - 100%)","commission":"Commission","commissionBounds":{"current":"<strong>{{lowerBound}}% - {{upperBound}}%</strong> at current Epoch {{epoch}}","future":"{{lowerBound}}% - {{upperBound}}% starting from Epoch {{epoch}}","label":"Commission bounds"},"escrow":"Escrow","fee":"Fee","name":"Name","rank":"Rank","status":"Status","statusActive":"Active","statusInactive":"Inactive","statusUnknown":"Unknown","totalEscrow":"Total escrow","unknownValidator":"Unknown validator"}}');

},{}],"elZZS":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"account":{"addEscrow":{"availableAmount":"Disponible:","confirmDelegatingToInactive":{"description":"El estado de este validador es {{validatorStatus}}. Es posible que tu delegaci\xf3n no genere ninguna recompensa.","title":"\xbfEst\xe1s seguro de que quieres continuar?"},"confirmDelegatingToTop":{"acknowledge":"Delegar de todos modos"},"delegate":"Delegar"},"loading":"Cargando cuenta","loadingError":"No se pudo cargar la cuenta.","reclaimEscrow":{"reclaim":"Reclamar","reclaimableAmount":"Disponible:"},"sendTransaction":{"confirmSendingToValidator":{"title":"\xbfEst\xe1s seguro de que quieres continuar?"},"enterAddress":"Introduce una direcci\xf3n","recipient":"Destinatario","send":"Enviar","success":"Transacci\xf3n enviada con \xe9xito. La transacci\xf3n puede tardar hasta un minuto en aparecer en tu cuenta."},"subnavigation":{"activeDelegations":"Delegaciones activas"},"summary":{"balance":{"available":"Disponible","total":"Saldo total"},"noTransactionFound":"No se han encontrado transacciones.","notYourAccount":"Esta no es tu cuenta."},"transaction":{"genericTransaction":{"destination":"Otra direcci\xf3n"},"loadingError":"No se ha podido cargar las transacciones.","reclaimEscrow":{"received":"<Amount/> reclamado por el delegador"},"transfer":{"received":"Recibido <Amount/>","sent":{"header":"Enviado <Amount/>"}},"unrecognizedTransaction":{"destination":"Otra direcci\xf3n","header":"Transacci\xf3n no reconocida \'{{method}}\'"}},"validator":{"loadingError":"No se han podido cargar los validadores."}},"backends":{"oasisscan":"API de Oasis Scan"},"common":{"amount":"Cantidad","block":"Bloque","cancel":"Cancelar","confirm":"Confirmar","delegator":"Delegador","from":"De","to":"A","unavailable":"No disponible","validator":"Validador","validators":"Validadores"},"createWallet":{"confirmSaved":"He guardado mi frase semilla","doNotShare":"Nunca compartas tu frase semilla, cualquiera con tu frase semilla puede acceder a tu billetera y tus tokens.","instruction":"Guarda tu frase semilla <strong>en el orden correcto</strong> en un lugar seguro, la necesitar\xe1s para abrir tu billetera.","mnemonicMismatch":"La frase semilla introducida no coincide.","newMnemonic":"Generar una frase semilla nueva","thisIsYourPhrase":"Esta es tu frase semilla."},"delegations":{"activeDelegations":"Delegaciones activas","delegatedAmount":"Cantidad delegada"},"errors":{"LedgerOasisAppIsNotOpen":"La aplicaci\xf3n de Oasis en Ledger est\xe1 cerrada.","cannotSendToSelf":"No puedes enviarte a ti mismo","disconnectedError":"Se ha perdido la conexi\xf3n.","duplicateTransaction":"Transacci\xf3n duplicada","insufficientBalance":"Saldo insuficiente","invalidAddress":"Direcci\xf3n inv\xe1lida","invalidNonce":"Nonce inv\xe1lido (n\xfamero de transacci\xf3n)","invalidPrivateKey":"Clave privada inv\xe1lida","unknown":"Error desconocido: {{message}}","unknownGrpc":"Error gRPC desconocido: {{message}}","usbTransportNotSupported":"Tu navegador no es compatible con WebUSB ( por ejemplo, Firefox). Intenta utilizar Chrome."},"fatalError":{"copied":"Error copiado al portapapeles","copy":"Copiar error al portapapeles"},"footer":{"terms":"<TermsLink>Condiciones generales</TermsLink>"},"home":{"create":{"button":"Crear billetera","header":"Crear una billetera nueva"},"existing":{"button":"Abrir billetera","header":"Acceder a una billetera existente"}},"icons":{"mnemonic":"Frase semilla","privateKey":"Clave privada","wallet":{"label":"Billetera"}},"ledger":{"instructionSteps":{"connectUsbLedger":"Conecta tu dispositivo USB Ledger al equipo","header":"Pasos:","openOasisApp":"Abre la aplicaci\xf3n de Oasis en tu dispositivo Ledger"},"steps":{"loadingAccounts":"Cargando los datos de la cuenta","loadingBalances":"Cargando detalles del saldo","openingUsb":"Abriendo Ledger a trav\xe9s de USB"}},"menu":{"closeWallet":"Cerrar billetera","home":"Inicio","wallet":"Billetera"},"openWallet":{"header":"\xbfC\xf3mo quieres abrir tu billetera?","ledger":{"header":"Abrir desde dispositivo Ledger"},"method":{"ledger":"Ledger","mnemonic":"Frase semilla","privateKey":"Clave privada"},"mnemonic":{"enterPhraseHere":"Introduce aqu\xed tu frase semilla","error":"Frase semilla inv\xe1lida. Por favor, aseg\xfarate de introducir las palabras en el orden correcto, todas en min\xfasculas.","header":"Introduce tu frase semilla","import":"Importar mi billetera","instruction":"A continuaci\xf3n, introduce todas las palabras de tu frase semilla separadas por espacios. La mayor\xeda de las frases semilla se componen de 24 o 12 palabras."},"privateKey":{"enterPrivateKeyHere":"Introduce aqu\xed tu clave privada","error":"Clave privada inv\xe1lida","header":"Introduce tu clave privada","hidePrivateKey":"Ocultar la clave privada","instruction":"Introduce tu clave privada en formato Base64.","showPrivateKey":"Mostrar la clave privada"}},"paraTimes":{"amount":{"available":"Disponible:"}},"theme":{"darkMode":"Modo oscuro","lightMode":"Modo claro"},"toolbar":{"networks":{"local":"Local","mainnet":"Mainnet","testnet":"Testnet"},"wallets":{"type":{"mnemonic":"Frase semilla","privateKey":"Clave privada"}}},"transaction":{"confirm":"Confirmar","preview":{"amount":"Cantidad","from":"De","gas":"Gas","to":"A","type":"Tipo","validator":"Validador","warning":"Una vez que confirmes la transacci\xf3n, no podr\xe1s cancelarla. Rev\xedsala cuidadosamente y confirma una vez que est\xe9s seguro de que quieres enviarla."},"step":{"signing":"Firmando la transacci\xf3n","submitting":"Enviando la transacci\xf3n"},"types":{"addEscrow":"delegando tus tokens a un validador para generar recompensas"}},"validator":{"commission":"Comisi\xf3n","commissionBounds":{"label":"L\xedmites de comisi\xf3n"},"name":"Nombre","status":"Estado","statusActive":"Activo","statusInactive":"Inactivo","statusUnknown":"Desconocido","unknownValidator":"Validador desconocido"}}');

},{}],"5XSjN":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"account":{"addEscrow":{"availableAmount":"Disponible:","confirmDelegatingToInactive":{"description":"Le statut de ce validateur est {{validatorStatus}}. Votre d\xe9l\xe9gation pourrait ne g\xe9n\xe9rer aucune r\xe9compense.","title":"Etes-vous s\xfbr de vouloir continuer ?"},"delegate":"D\xe9l\xe9guer"},"loading":"Chargement du compte","loadingError":"Impossible de charger le compte. Des informations peuvent \xeatre manquantes ou obsol\xe8tes.","reclaimEscrow":{"reclaim":"R\xe9clamer","reclaimableAmount":"Disponible:"},"sendTransaction":{"confirmSendingToValidator":{"description":"Il s\'agit d\'une adresse de validation. Les transferts \xe0 cette adresse ne jalonnent pas vos fonds aupr\xe8s du validateur.","title":"Etes-vous s\xfbr de vouloir continuer ?"},"enterAddress":"Entrez une adresse","recipient":"Destinataire","send":"Envoyer","success":"Transaction effectu\xe9e. La transaction peut mettre une minute avant d\'appara\xeetre sur votre compte."},"subnavigation":{"activeDelegations":"D\xe9l\xe9gation active","debondingDelegations":"D\xe9l\xe9gations r\xe9clam\xe9es"},"summary":{"balance":{"available":"Disponible","debonding":"R\xe9clam\xe9","delegations":"D\xe9l\xe9gu\xe9 (stake)","total":"Solde total"},"noTransactionFound":"Aucune transaction trouv\xe9e","noWalletIsOpen":"Pour envoyer, recevoir, jalonner et \xe9changer vos jetons {{ticker}}, <HomeLink>Ouvrez votre portefeuille</HomeLink> !","notYourAccount":"Ce compte n\'est pas le v\xf4tre."},"transaction":{"addEscrow":{"received":"D\xe9l\xe9gation de <Amount/> re\xe7ue","sent":"<Amount/> d\xe9l\xe9gu\xe9s au validateur"},"genericTransaction":{"destination":"Autre adresse","header":"Type \'{{method}}\'"},"loadingError":"Impossible de charger les transactions. La liste peut \xeatre vide ou obsol\xe8te.","reclaimEscrow":{"received":"<Amount/> r\xe9clam\xe9s par le d\xe9l\xe9gateur","sent":"<Amount/> r\xe9clam\xe9s au validateur"},"transfer":{"received":"<Amount/> re\xe7us","sent":{"header":"<Amount/> envoy\xe9s"}},"unrecognizedTransaction":{"destination":"Autre adresse","header":"Transaction non reconnue, le type \'{{method}}\'"}},"validator":{"loadingError":"Impossible de charger les validateurs.","showingStale":"La liste peut \xeatre vide ou obsol\xe8te {{staleTimestamp}}."}},"common":{"amount":"Montant","block":"Bloc","cancel":"Cancel","confirm":"Confirmer","delegator":"D\xe9l\xe9gateur","from":"De","to":"\xc0","unavailable":"Indisponible","validator":"Validateur","validators":"Validateurs"},"createWallet":{"confirmSaved":"J\'ai sauvegard\xe9 ma phrase secr\xe8te.","doNotShare":"Ne partagez jamais votre phrase secr\xe8te, l\'acc\xe8s \xe0 votre phrase secr\xe8te permet d\'acc\xe9der \xe0 votre portefeuille ainsi qu\'\xe0 vos tokens.","instruction":"Sauvegardez votre phrase secr\xe8te <strong>dans le bon ordre</strong> et dans un endroit s\xe9curis\xe9, vous en aurez besoin pour ouvrir votre portefeuille \xe0 nouveau.","mnemonicMismatch":"La phrase mn\xe9monique saisie ne correspond pas.","newMnemonic":"G\xe9n\xe9rer une nouvelle phrase secr\xe8te","thisIsYourPhrase":"Voici votre phrase secr\xe8te"},"delegations":{"activeDelegations":"D\xe9l\xe9gations actives","debondingDelegations":"D\xe9l\xe9gations r\xe9clam\xe9es","delegatedAmount":"Montant d\xe9l\xe9gu\xe9","reclaimedAmount":"Montant r\xe9clam\xe9"},"errors":{"LedgerOasisAppIsNotOpen":"L\'application Oasis sur le Ledger est ferm\xe9e.","cannotSendToSelf":"Impossible d\'effectuer une transaction vers votre propre compte","duplicateTransaction":"Transaction doublon","insufficientBalance":"Solde insuffisant","invalidAddress":"Adresse invalide","invalidNonce":"Nonce invalide (num\xe9ro de transaction)","invalidPrivateKey":"Cl\xe9 priv\xe9e invalide","ledgerAppVersionNotSupported":"Erreur re\xe7ue : \\"Ledger App Version not supported\\", cette erreur peut \xeatre un faux positif, relancez ROSE Wallet et r\xe9essayez. Si l\'erreur persiste, mettez \xe0 jour l\'application Oasis dans votre Ledger.","ledgerCannotOpenOasisApp":"Impossible d\'acc\xe9der \xe0 l\'application Oasis sur le Ledger. Assurez vous qu\'il est d\xe9v\xe9rouill\xe9 et que l\'application Oasis est ouverte.","ledgerNoDeviceSelected":"Aucun mat\xe9riel Ledger d\xe9tect\xe9. V\xe9rifiez qu\'il soit connect\xe9. <LedgerHelp>V\xe9rifiez les probl\xe8mes de connexion USB courants avec le mat\xe9riel Ledger</LedgerHelp>. <ChromeHelp>V\xe9rifiez que les permissions du site ne bloque pas les appareils de type USB</ChromeHelp>.","ledgerTransactionRejected":"Transaction rejet\xe9e sur le Ledger.","noOpenWallet":"Aucun portefeuille ouvert","unknown":"Erreur inconnue : {{message}}","unknownGrpc":"Erreur inconnue gRPC: {{message}}","unknownLedgerError":"Erreur Ledger inconnue : {{message}}","usbTransportError":"Erreur USB : {{message}}","usbTransportNotSupported":"Votre navigateur Web ne prend pas en charge l\'API WebUSB (par exemple Firefox). Essayez d\'utiliser Chrome."},"fatalError":{"copied":"Erreur copi\xe9e","copy":"Copier l\'erreur","heading":"Une erreur s\'est produite","instruction":"Essayez d\'actualiser la page et d\'ouvrir \xe0 nouveau votre portefeuille pour voir si le probl\xe8me persiste. Si le probl\xe8me persiste, veuillez contacter notre \xe9quipe d\'assistance via l\'e-mail <Email/>. Envoyez l\'email et joignez le rapport ci-dessous."},"footer":{"github":"ROSE Wallet est enti\xe8rement <GithubLink>open source</GithubLink> - N\'h\xe9sitez pas \xe0 remonter tout probl\xe8me !","poweredBy":{"oasisscan":"Aliment\xe9 par Oasis Scan API & Oasis gRPC"},"terms":"<TermsLink>Termes et Conditions</TermsLink>","version":"Version: <ReleaseLink/> (commit: <CommitLink/>) construit \xe0 {{buildTime}}"},"home":{"create":{"button":"Cr\xe9er un portefeuille","description":"Cr\xe9ez un tout nouveau portefeuille pour envoyer, re\xe7evoir, stake et \xe9changer des tokens ROSE.","header":"Cr\xe9er un nouveau portefeuille"},"existing":{"button":"Ouvrir mon portefeuille","description":"Ouvrez votre portefeuille existant stock\xe9 sur un Ledger, importez une cl\xe9 priv\xe9e ou une phrase mn\xe9monique.","header":"Ouvrir un portefeuille existant"}},"icons":{"mnemonic":"Phrase secr\xe8te","privateKey":"Cl\xe9 priv\xe9e"},"ledger":{"instructionSteps":{"closeLedgerLive":"Fermer l\'application Ledger Live sur l\'ordinateur","connectUsbLedger":"Connectez votre mat\xe9riel USB Ledger \xe0 l\'ordinateur","header":"Etapes","openOasisApp":"Ouvrez l\'application Oasis sur votre mat\xe9riel Ledger"},"steps":{"loadingAccounts":"Chargement des adresses","loadingBalances":"Chargement du solde des adresses","openingUsb":"Ouverture du Ledger via USB"}},"menu":{"closeWallet":"Refermer le portefeuille","home":"Accueil","stake":"Staking","wallet":"Portefeuille"},"openWallet":{"bitpie":{"warning":"\u2757 Utilisateurs du portefeuille BitPie : vous ne pouvez pas importer la phrase mn\xe9monique secr\xe8te directement depuis votre portefeuille BitPie. <DocsLink>Consultez la documentation pour plus de d\xe9tails.</DocsLink>"},"header":"Comment souhaitez-vous ouvrir votre portefeuille ?","ledger":{"header":"Ouvrir \xe0 partir d\'un mat\xe9riel Ledger"},"method":{"ledger":"Ledger","mnemonic":"Phrase secr\xe8te","privateKey":"Cl\xe9 priv\xe9e"},"mnemonic":{"enterPhraseHere":"Entrez votre phrase secr\xe8te ici","error":"Phrase secr\xe8te invalide. Entrez chaque mot s\xe9par\xe9 d\'un espace et dans le bon ordre.","header":"Entrez votre phrase secr\xe8te","import":"Importer mon portefeuille","instruction":"Entrez ci-dessous tous les mots qui composent votre phrase secr\xe8te (s\xe9par\xe9s par des espaces). La plupart des phrases secr\xe8tes sont compos\xe9es de 24 ou 12 mots."},"privateKey":{"enterPrivateKeyHere":"Entrez votre cl\xe9 priv\xe9e ici","error":"Cl\xe9 priv\xe9e invalide","header":"Entrez votre cl\xe9 priv\xe9e","hidePrivateKey":"Masquer la cl\xe9 priv\xe9e","instruction":"Entrez votre cl\xe9 priv\xe9e au format base64 ci-dessous.","showPrivateKey":"Montrer la cl\xe9 priv\xe9e"}},"paraTimes":{"amount":{"available":"Disponible:"}},"theme":{"darkMode":"Th\xe8me nuit","lightMode":"Th\xe8me clair"},"toolbar":{"networks":{"local":"Local","mainnet":"Mainnet","testnet":"Testnet"},"wallets":{"type":{"mnemonic":"Phrase secr\xe8te","privateKey":"Cl\xe9 priv\xe9e"}}},"transaction":{"confirm":"Confirmer","preview":{"amount":"Montant","fee":"Frais","from":"Depuis","gas":"Gas","genesisHash":"Genesis Hash","shares":"Parts","to":"Vers","type":"Type","validator":"Validateur","warning":"Vous ne pourrez plus annuler votre transaction apr\xe8s avoir confirm\xe9. Prenez le temps de v\xe9rifier les montants et adresse avant de confirmer."},"step":{"building":"Construction de la transaction","preview":"Pr\xe9visualisez la transaction","signing":"Signature de la transaction","submitting":"Envoi de la transaction"},"types":{"addEscrow":"D\xe9l\xe9guer vos tokens \xe0 un validateur pour g\xe9n\xe9rer des r\xe9compenses","reclaimEscrow":"R\xe9clamer vos tokens d\xe9l\xe9gu\xe9s \xe0 un validateur","transfer":"Transfert de tokens de votre compte \xe0 un autre"}},"validator":{"boundsNotSet":"Pas de bornes d\xe9finies (0% - 100%)","commission":"Commission","commissionBounds":{"current":"<strong>{{lowerBound}}% - {{upperBound}}%</strong> \xe0 l\'Epoch {{epoch}}","future":"{{lowerBound}}% - {{upperBound}}% \xe0 partir de l\'Epoch {{epoch}}","label":"Bornes de commissions"},"escrow":"Escrow","fee":"Frais","name":"Nom","rank":"Rang","status":"Statut","statusActive":"Actif","statusInactive":"Inactif","statusUnknown":"Inconnu","totalEscrow":"Escrow total","unknownValidator":"Validateur inconnue"}}');

},{}],"d1aD5":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"account":{"addEscrow":{"availableAmount":"Na voljo:","confirmDelegatingToInactive":{"description":"Stanje overitelja je {{validatorStatus}}. Va\u0161e delegiranje morda ne bo prineslo nagrad.","title":"Ste prepri\u010Dani, da \u017Eelite nadaljevati?"},"confirmDelegatingToTop":{"acknowledge":"Vseeno delegiraj","description":"Izbran overitelj je med 20 najve\u010Djimi. Za izbolj\u0161anje varnosti omre\u017Eja in enakomernej\u0161o porazdelitev predlagamo, da delegirate manj\u0161emu overitelju."},"delegate":"Delegiraj"},"addressCopied":"Naslov skopiran.","loading":"Nalaganje ra\u010Duna","loadingError":"Ra\u010Duna ni mogo\u010De nalo\u017Eiti.","reclaimEscrow":{"convertedToShares":"\u0160tevilo dele\u017Eev: {{shares}}","reclaim":"Oddelegiraj","reclaimAll":"Oddelegiraj vse","reclaimableAmount":"Na voljo:"},"sendTransaction":{"confirmSendingToValidator":{"description":"Prejemnikov naslov pripada overitelju. Prenos na ta naslov mu sredstev ne bo delegiral, temve\u010D nakazal.","title":"Ste prepri\u010Dani, da \u017Eelite nadaljevati?"},"enterAddress":"Vnesite naslov","enterAmount":"Vnesite znesek","recipient":"Prejemnik","send":"Po\u0161lji","success":"Transakcija uspe\u0161no izvr\u0161ena. Novo stanje na va\u0161em ra\u010Dunu bo prikazano v kratkem."},"subnavigation":{"activeDelegations":"Delegacije","debondingDelegations":"Delegacije v razvezi","mobileActiveDelegations":"Delegacije","mobileDebondingDelegations":"V razvezi"},"summary":{"balance":{"available":"Na voljo","debonding":"V razvezi","delegations":"Delegirano","total":"Stanje"},"noTransactionFound":"Ni transakcij","noWalletIsOpen":"Za po\u0161iljanje, sprejemanje, vlaganje in menjavo {{ticker}} morate <HomeLink>odpreti va\u0161o denarnico</HomeLink>!","notYourAccount":"To ni va\u0161 ra\u010Dun."},"transaction":{"addEscrow":{"received":"Prejeto <Amount/> v delegiranje","sent":"Delegirano <Amount/> overitelju"},"consensusDeposit":{"received":"Prejet polog <Amount/> na ParaTime {{runtimeName}}","sent":"Polog <Amount/> na ParaTime {{runtimeName}}"},"consensusWithdraw":{"received":"Dvig <Amount/> s ParaTima {{runtimeName}}","sent":"Prejet dvig <Amount/> s ParaTima {{runtimeName}}"},"explorerLink":"Pregled transakcije v raziskovalcu blokov","failed":"Spodletelo","genericTransaction":{"destination":"Drug naslov","header":"Metoda \'{{method}}\'"},"loadingError":"Transakcij ni bilo mogo\u010De pridobiti.","reclaimEscrow":{"received":"Vra\u010Dilo <Amount/> investitorju","sent":"Zahtevano <Amount/> od overitelja"},"stakingAllow":{"received":"Dobljeno dovoljenje za <Amount/>","sent":"Dano dovoljenje za <Amount/>"},"successful":"Uspe\u0161no","transfer":{"received":"Prejeto <Amount/>","sent":{"header":"Poslano <Amount/>"}},"unrecognizedTransaction":{"destination":"Drug naslov","header":"Nepoznana transakcija, metoda \'{{method}}\'"}},"validator":{"loadingError":"Ni mogo\u010De nalo\u017Eiti overiteljev.","showingStale":"Seznam overiteljev z dne {{staleTimestamp}}"}},"backends":{"oasisscan":"Oasis Scan API"},"banner":{"buildPreview":"Uporabljate eksperimentalno razli\u010Dico ROSE Walleta in va\u0161i klju\u010Di so morda ogro\u017Eeni. UPORABLJAJTE LE KLJU\u010CE ZA TESTIRANJE.","buildStaging":"Uporabljate razvojno razli\u010Dico ROSE Walleta. UPORABLJAJTE GA LE ZA TESTIRANJE."},"common":{"amount":"Znesek","block":"Blok","cancel":"Prekli\u010Di","confirm":"Potrdi","delegator":"Delegator","from":"Od","hash":"Zgo\u0161\u010Dena vrednost transakcije","round":"Krog","time":"\u010Cas","to":"Za","unavailable":"Nedosegljiv","validator":"Overitelj","validators":"Overitelji"},"createWallet":{"confirmSaved":"Klju\u010Dne besede sem shranil","doNotShare":"Klju\u010Dnih besed nikomur ne ka\u017Eite, saj z njimi lahko dostopa do va\u0161e denarnice in kovancev.","instruction":"Klju\u010Dne besede mnemonika shranite na varno mesto in <strong>v pravilnem vrstnem redu</strong>. Potrebovali jih boste ob vsakem odpiranju denarnice.","mnemonicMismatch":"Vne\u0161en mnemonik se ne ujema.","newMnemonic":"Ustvari nov mnemonik","thisIsYourPhrase":"To je va\u0161 mnemonik"},"delegations":{"activeDelegations":"Aktivne delegacije","debondingDelegations":"Delegacije v razvezi","debondingTimeEnd":"Konec razveze","delegatedAmount":"Delegiran znesek","loadingError":"Ni mogo\u010De nalo\u017Eiti delegacij.","reclaimedAmount":"Vra\u010Dilo"},"deleteForm":{"confirm":"Da, izbri\u0161i","confirmationKeyword":"izbri\u0161i","hint":"Vtipkajte \'<strong>{{confirmationKeyword}}</strong>\'"},"errors":{"LedgerDerivedDifferentAccount":"Ra\u010Dun ne pripada trenutno povezanemu Ledgerju","LedgerOasisAppIsNotOpen":"Oasis App na Ledgerju je zaprt.","bluetoothTransportNotSupported":"Bluetooth je izkopljen ali pa ni podprt na napravi.","cannotSendToSelf":"Ni mogo\u010De po\u0161iljati samemu sebi","disconnectedError":"Izgubljena povezava.","duplicateTransaction":"Podvojena transakcija","indexerAPIError":"{{indexerName}} ni dosegljiv, zato informacije o ra\u010Dunu ne bodo a\u017Eurne. Prosimo, poskusite kasneje.","insufficientBalance":"Stanje na ra\u010Dunu prenizko","invalidAddress":"Neveljaven naslov","invalidNonce":"Neveljavno unikatno \u0161tevilo (\u0161tevilka transakcije)","invalidPrivateKey":"Neveljaven zasebni klju\u010D","ledgerAppVersionNotSupported":"Aplikacija Oasis na Ledgerju je zaprta ali zastarela. Poskrbite, da je Ledger odklenjen in da je zadnja razli\u010Dica aplikacije Oasis zagnana.","ledgerCannotOpenOasisApp":"Ni mogo\u010De odpreti aplikacije Oasis na Ledgerju. Poskrbite, da je naprava odklenjena in aplikacija Oasis zagnana.","ledgerNoDeviceSelected":"Ledger ni izbran. Preverite, \u010De je povezan. <LedgerHelp>Preverite obi\u010Dajne napake s povezavo USB</LedgerHelp> in da <ChromeHelp>dovoljenja spletne strani omogo\u010Dajo dostop do USB</ChromeHelp>.","ledgerTransactionRejected":"Transakcija na Ledgerju zavrnjena","noOpenWallet":"Ni odprte denarnice","unknown":"Neznana napaka: {{message}}","unknownGrpc":"Neznana napaka gRPC: {{message}}","unknownLedgerError":"Neznana napaka na Ledgerju: {{message}}","unknownParaTimeError":"Neznana napaka v ParaTime: {{message}}","usbTransportError":"Napaka na prenosu prek USB: {{message}}","usbTransportNotSupported":"Va\u0161 brskalnik ne podpira WebUSB (npr. Firefox). Poskusite z uporabo Chroma."},"fatalError":{"copied":"Napaka skopirana v odlo\u017Ei\u0161\u010De","copy":"Skopiraj napako v odlo\u017Ei\u0161\u010De","heading":"Pojavila se je napaka","instruction":"Poskusite ponovno nalo\u017Eiti stran in odpreti va\u0161o denarnico, da preverite, \u010De se napaka ponovi. V tem primeru vas prosimo, da obvestite podporno ekipo na e-naslov <Email/> in pripnete spodnje poro\u010Dilo."},"footer":{"github":"ROSE Wallet je <GithubLink>odprtokodna aplikacija</GithubLink>. Dobrodo\u0161li odzivi in morebitna poro\u010Dila o te\u017Eavah!","poweredBy":{"oasisscan":"Deluje s pomo\u010Djo Oasis Scan API & Oasis gRPC"},"terms":"<TermsLink>Pogoji uporabe</TermsLink>","version":"Razli\u010Dica <ReleaseLink/> (commit <CommitLink/>) zgrajena {{buildTime}}"},"home":{"create":{"button":"Ustvari denarnico","description":"Ustvarite novo denarnico za sprejemanje, po\u0161iljanje in menjavo kovancev ROSE.","header":"Ustvari denarnico"},"existing":{"button":"Odpri denarnico","description":"Odprite obstoje\u010Do denarnico na Ledgerju, uvozite zasebni klju\u010D ali mnemonik.","header":"Odpri denarnico"}},"infoBox":{"valueCopied":"{{label}} kopiran."},"language":"Jezik","ledger":{"extension":{"connect":"Priklopi Ledger","failed":"Priklop spodeletel","grantAccess":"Dovoli dostop USB Ledgerju","succeed":"Naprava priklopljena"},"instructionSteps":{"closeLedgerLive":"Zaprite Ledger Live app na ra\u010Dunalniku.","connectUsbLedger":"Pove\u017Eite va\u0161 USB Ledger z ra\u010Dunalnikom.","header":"Koraki:","openOasisApp":"Odprite Oasis App na va\u0161em Ledgerju."},"steps":{"idle":"Na voljo","loadingAccounts":"Nalaganje podrobnosti ra\u010Duna","loadingBalances":"Nalaganje podrobnosti stanja","loadingBluetoothDevices":"Nalaganje naprav bluetooth","openingUsb":"Odpiranje Ledgerja prek USB"}},"menu":{"addAccounts":"Dodaj ra\u010Dune","closeWallet":"Zapri denarnico","home":"Domov","lockProfile":"Zakleni profil","openMenu":"Meni","paraTimes":"ParaTimi","stake":"Vlaganje ROSE","stake-mobile":"Vlaganje","unlockProfile":"Odkleni profil","wallet":"Denarnica"},"migrateV0Extension":{"backupInvalidPrivateKeys":{"confirm":"Varno sem shranil svoje zasebne klju\u010De","description":"{{count}} va\u0161ih zasebnih klju\u010Dev ima napake in ne bodo shranjene v novo denarnico. Prosimo, da jih pred nadaljevanjem skopirate in shranite na lo\u010Deno mesto, kasneje pa jih boste preverili in ustrezno popravili.","description_one":"1 zasebni klju\u010D ima napako in ne bo shranjen v novo denarnico. Prosimo, da ga pred nadaljevanjem skopirate in shranite na lo\u010Deno mesto, kasneje pa ga boste preverili in ustrezno popravili.","description_plural":"{{count}} va\u0161ih zasebnih klju\u010Dev ima napake in ne bodo shranjene v novo denarnico. Prosimo, da jih pred nadaljevanjem skopirate in shranite na lo\u010Deno mesto, kasneje pa jih boste preverili in ustrezno popravili.","reveal":"Kliknite, da odkrijete neveljaven zasebni klju\u010D"},"backupMnemonic":{"description":"Nova razli\u010Dica dodatka za brskalnik ne bo ve\u010D shranila mnemonika, temve\u010D le izvedene zasebne klju\u010De. Uporaba mnemonika je edini na\u010Din za dostop do va\u0161ega ra\u010Duna, v primeru, da se vam ra\u010Dunalnik oz. naprava s klju\u010Di pokvari. Zdaj imate zadnjo mo\u017Enost, da arhivirate va\u0161 mnemonik.","reveal":"Klikni za prikaz mnemonika"},"finishMigration":"Odpri novo razli\u010Dico denarnice","nextStep":"Naprej","requiredField":"To polje je obvezno","title":"Pomembna novost"},"openWallet":{"bitpie":{"warning":"\u2757 Uporabniki denarnice BitPie: Uvoz va\u0161ega BitPie mnemonika neposredno v Oasis denarnico ni mogo\u010Da. <DocsLink>Za ve\u010D informacij preverite dokumentacijo.</DocsLink>"},"header":"Kako \u017Eelite odpreti denarnico?","importAccounts":{"accountCounter":"{{count}} izbran ra\u010Dun","accountCounter_one":"Izbran en ra\u010Dun","accountCounter_plural":"{{count}} izbrani ra\u010Duni","accountCounter_zero":"Ni izbranega ra\u010Duna","next":"Nadaljuj","openWallets":"Odpri","pageNumber":"Stran {{pageNum}} od {{totalPages}}","prev":"Nazaj","selectWallets":"Izberite ra\u010Dune"},"ledger":{"header":"Odpri z Ledgerjem"},"method":{"ledger":"Z Ledgerjem","mnemonic":"Z mnemonikom","privateKey":"Z zasebnim klju\u010Dem"},"mnemonic":{"enterPhraseHere":"Sem vnesite klju\u010Dne besede","error":"Neveljavne klju\u010Dne besede. Preverite, ali so besede v pravem zaporedju in z malo za\u010Detnico.","header":"Vnesite klju\u010Dne besede","import":"Uvozi denarnico","instruction":"Vnesite vse besede va\u0161ega mnemonika, lo\u010Dene s presledkom. Obi\u010Dajno jih je 12 ali 24."},"privateKey":{"enterPrivateKeyHere":"Sem vnesite zasebni klju\u010D","error":"Neveljaven zasebni klju\u010D","header":"Vnesite zasebni klju\u010D","hidePrivateKey":"Skrij zasebni klju\u010D","instruction":"Vnesite va\u0161 zasebni klju\u010D v zapisu Base64.","showPrivateKey":"Poka\u017Ei zasebni klju\u010D"}},"paraTimes":{"amount":{"advanced":"Napredno","available":"Na voljo:","depositDescription":"Vnesite znesek {{ticker}} za polog in kliknite \\"{{nextButtonLabel}}\\"","emptyAccount":"Ra\u010Dun je prazen. Dvig ni mogo\u010D.","feeAmountPlaceholder":"Znesek provizije (nano {{ticker}})","feeGasPlaceholder":"Gas za provizijo","max":"MAX","tooltip":"Maks. vrednost bo lahko zmanj\u0161ana za provizijo","withdrawDescription":"Vnesite znesek {{ticker}} za dvig in kliknite \\"{{nextButtonLabel}}\\""},"common":{"cipher":"Cipher","emerald":"Emerald","evmcType":"(EVMc)","header":"Prenosi ParaTime","sapphire":"Sapphire"},"confirmation":{"confirmDepositDescription":"Preverite, da sta znesek in naslova prejemnika pravilna in kliknite \\"{{nextButtonLabel}}\\".","confirmDepositToForeignAccountDescription":"Naslov prejemnika se ne ujema z nobenim od ra\u010Dunov v va\u0161i denarnici! Nekatere storitve (npr. menjalnice) ne podpirajo neposrednih pologov na va\u0161 ra\u010Dun. Za bolj\u0161o zdru\u017Eljivost priporo\u010Damo, da najprej izvr\u0161ite polog na va\u0161 ParaTime ra\u010Dun, nato pa prenos {{ticker}} na prejemnikov naslov.","confirmTransferLabel":"Potrjujem pravilnost zneska in naslova","confirmTransferToForeignAccount":"Potrjujem neposredni polog na zunanji ra\u010Dun","confirmTransferToValidatorLabel":"Potrjujemo nakazilo {{ticker}} na ra\u010Dun overitelja","confirmWithdrawDescription":"Preverite, da sta znesek in naslov prejemnika pravilna in kliknite \\"{{nextButtonLabel}}\\".","confirmWithdrawToForeignAccountDescription":"Naslov prejemnika se ne ujema z nobenim od ra\u010Dunov v va\u0161i denarnici! Nekatere storitve (npr. menjalnice) ne podpirajo neposrednih dvigov na va\u0161 ra\u010Dun. Za bolj\u0161o zdru\u017Eljivost priporo\u010Damo, da najprej izvr\u0161ite dvig na va\u0161 osebni ra\u010Dun, nato pa prenos {{ticker}} na prejemnikov naslov.","depositDescription":"Polo\u017Eili boste <strong>{{value}} {{ticker}}</strong> na naslov <strong>{{address}}</strong> na ParaTime <strong>{{paraTime}}</strong> {{paratimeType}}","depositLabel":"Polo\u017Ei","withdrawDescription":"Dvignili boste <strong>{{value}} {{ticker}}</strong> s ParaTima <strong>{{paraTime}}</strong> {{paratimeType}} na naslov <strong>{{address}}</strong>","withdrawLabel":"Dvigni"},"error":{"depositDescription":"Transakcija je spodletela. Polog <strong>{{value}} {{ticker}}</strong> na naslov <strong>{{address}}</strong> na ParaTime <strong>{{paraTime}}</strong> {{paratimeType}} ni uspel.","withdrawDescription":"Transakcija je spodletela. Dvig <strong>{{value}} {{ticker}}</strong> s ParaTima <strong>{{paraTime}}</strong> {{paratimeType}} na naslov <strong>{{address}}</strong> ni uspel."},"footer":{"back":"Nazaj","next":"Naprej","notice":"* EVMc - zdru\u017Eljiv z Ethereum Virtual Machine"},"pageInaccessible":{"foreignAccount":"Prenosi niso na voljo","ledgerAccount":"Ledgerjev ra\u010Dun ni podprt."},"recipient":{"depositDescription":"Vnestie naslov prejemnika na ParaTimu <strong>{{paraTime}}</strong> {{paratimeType}} in kliknite \\"{{nextButtonLabel}}\\"","ethPrivateKeyPlaceholder":"Vnesite zasebni klju\u010D zdru\u017Eljiv z Ethereumom","evmcWithdrawDescription":"Vnesite zasebni klju\u010D ra\u010Duna na ParaTimu, naslov prejemnika na nivo konsenza in kliknite \\"{{nextButtonLabel}}\\"","placeholder":"0x...","withdrawDescription":"Vnesite prejemnikov naslov na nivo konsenza in kliknite \\"{{nextButtonLabel}}\\""},"selection":{"cancel":"Prekli\u010Di prenos","depositDescription":"Izberite ParaTime, na katerega \u017Eelite polo\u017Eiti {{ticker}} in kliknite \\"{{nextButtonLabel}}\\".","evmc":"EVMc","select":"Izberite ParaTime","withdrawDescription":"Izberite Paratime s katerega \u017Eelite dvigniti {{ticker}} in kliknite \\"{{nextButtonLabel}}\\"."},"summary":{"depositDescription":"Polog <strong>{{value}} {{ticker}}</strong> na naslov <strong>{{address}}</strong> na ParaTime <strong>{{paraTime}}</strong> {{paratimeType}} je bil uspe\u0161en.","navigate":"Nadaljuj na prenose ParaTime","withdrawDescription":"Dvig <strong>{{value}} {{ticker}}</strong> s ParaTima <strong>{{paraTime}}</strong> {{paratimeType}} na naslov <strong>{{address}}</strong> je bil uspe\u0161en."},"transfers":{"deposit":"Polog na ParaTime","depositDisabled":"Sredstev {{ticker}} za prenos ni na voljo","description":"Kliknite na gumb \\"{{depositButtonLabel}}\\" za polog {{ticker}} z nivoja konsenza na izbran ParaTime ali \\"{{withdrawButtonLabel}}\\" za dvig {{ticker}} s ParaTima na nivo konsenza.","withdraw":"Dvig s ParaTima"},"unsupportedFormStep":"Nepodprt korak obrazca","validation":{"insufficientBalanceToPayFee":"Stanje prenizko za pla\u010Dilo provizije","invalidDecimalValue":"Dovoljenih najve\u010D {{decimals}} decimalk","invalidEthPrivateKey":"Neveljaven zasebni klju\u010D Ethereum","invalidEthPrivateKeyLength":"Zasebni klju\u010D mora biti dolg 64 znakov","invalidFee":"Vrednost mora biti \u0161tevilo, ve\u010Dje ali enako 0","required":"Polje je zahtevano","unsupportedParaTime":"Nepodprt ParaTime"}},"persist":{"createProfile":{"choosePassword":"Izberite geslo","passwordMismatch":"Geslo se ne ujema","repeatPassword":"Ponovno vnesite geslo","startPersisting":"Lokalno shrani zasebne klju\u010De, za\u0161\u010Ditene z geslom","unsupported":"Shramba na tem brskalniku ni podprta"},"loading":"Nalaganje","loginToProfile":{"deleteProfile":{"button":"Izbri\u0161i profil","description":"To bo <strong>izbrisalo va\u0161e zasebne klju\u010De</strong> in ne bo jih mogo\u010De obnoviti. <br/><br/> \u010Ce \u017Eelite nadaljevati vnesite \'<strong>{{confirmationKeyword}}</strong>\'.","title":"Izbri\u0161i Profil"},"description":"Vnesite geslo za dostop do obstoje\u010De denarnice.","enterPasswordHere":"Vnesite geslo","hidePassword":"Skrij geslo","showPassword":"Prika\u017Ei gesl","skipUnlocking":"Nadaljuj brez uporabe profila","title":"Dobrodo\u0161li nazaj!","unlock":"Odkleni","wrongPassword":"Napa\u010Dno geslo"}},"theme":{"darkMode":"Temni na\u010Din","lightMode":"Svetli na\u010Din","title":"Tema"},"toolbar":{"contacts":{"add":"Dodaj stik","address":"Naslov","cancel":"Prekli\u010Di","delete":{"button":"Izbri\u0161i stik","confirm":"Da, izbri\u0161i","description":"Ste prepri\u010Dani, da \u017Eelite izbrisati ta stik?","title":"Izbri\u0161i Stik"},"emptyList":"Nimate stikov.","manage":"Upravljaj stik","name":"Ime","notAvailable":"Da pri\u010Dnete dodajati stike, najprej ustvarite profil med <OpenWalletButton>odpiranjem denarnice</OpenWalletButton>.","save":"Shrani","validation":{"addressError":"Vnesite veljaven naslov denarnice.","addressNotUniqueError":"Naslov \u017Ee obstaja","nameLengthError":"Najve\u010D 16 znakov","required":"Polje je obvezno"}},"networks":{"local":"Lokalno","mainnet":"Mainnet","selector":"Izberite omre\u017Eje","testnet":"Testnet"},"profile":{"deletion":"Brisanje","notAvailable":"Va\u0161 profil lahko urejate, ko <OpenWalletButton>odprete denarnico</OpenWalletButton>.","password":{"current":"Trenutno geslo","enterCurrent":"Vnesite obstoje\u010De geslo","enterNewPassword":"Novo geslo","reenterNewPassword":"Ponovno vnesite geslo","submit":"Posodobi geslo","success":"Geslo posodobljeno.","title":"Nastavi novo geslo"}},"settings":{"accountNamingNotAvailable":"Za poimenovanje ra\u010Duna ustvarite profil, ko <OpenWalletButton>odpirate denarnico</OpenWalletButton>.","cancel":"Prekli\u010Di","contacts":"Stiki","delete":{"description":"Ali ste prepri\u010Dani, da \u017Eelite izbrisati ta ra\u010Dun?","inputHelp":"Tega ne bo mogo\u010De razveljaviti. \u010Ce \u017Eelite nadaljevati vnesite \'<strong>{{confirmationKeyword}}</strong>\'.","title":"Izbri\u0161i Ra\u010Dun","tooltip":"V denarnici morate imeti vsaj en ra\u010Dun."},"exportPrivateKey":{"confirm":"Razumem, razkrij zasebni klju\u010D","copied":"Zasebni klju\u010D kopiran.","hint1":"Zasebni klju\u010D je sestavljen iz niza znakov. Kdor ima dostop do zasebnega klju\u010Da, lahko z njim upravlja s sredstvi na pripadajo\u010Dem ra\u010Dunu.","hint2":"Klju\u010Da ni mogo\u010De obnoviti, \u010De ga izgubite. Poskrbite, da imate varnostno kopijo zasebnega klju\u010Da shranjeno na varnem mestu.","title":"Izvozi Zasebni Klju\u010D"},"manageAccount":"Uredi","myAccountsTab":"Moji ra\u010Duni","nameLengthError":"Najve\u010D 16 znakov","optionalName":"Ime (opcijsko)","profile":"Profil","save":"Shrani","settings":"Nastavitve"},"wallets":{"select":"Izberi"}},"transaction":{"cancel":"Prekli\u010Di","confirm":"Potrdi","preview":{"amount":"Znesek","fee":"Provizija","from":"Od","gas":"Gas","genesisHash":"Zgo\u0161\u010Dena vrednost za\u010Detnega bloka","shares":"Dele\u017Ei","to":"Za","type":"Tip","validator":"Overitelj","warning":"Transakcijo skrbno preglejte in jo potrdite. Po potrditvi je ne bo mogo\u010De ve\u010D preklicati."},"step":{"building":"Izdelava transakcije","preview":"Predogled transakcije","signing":"Podpisovanje transakcije","submitting":"Po\u0161iljanje transakcije"},"types":{"addEscrow":"delegiranje va\u0161ih kovancev overiteljem","reclaimEscrow":"vra\u010Dilo delegiranih kovancev na va\u0161 ra\u010Dun","transfer":"prenos kovancev z va\u0161ega na tuj ra\u010Dun"}},"validator":{"boundsNotSet":"Brez omejitev (0% - 100%)","commission":"Provizija","commissionBounds":{"current":"<strong>{{lowerBound}}% - {{upperBound}}%</strong> v trenutni epohi {{epoch}}","future":"{{lowerBound}}% - {{upperBound}}% z za\u010Detkom pri epohi {{epoch}}","label":"Meje provizije"},"escrow":"Znesek v hrambi","fee":"Provizija","name":"Ime","rank":"Rang","status":"Stanje","statusActive":"Dejaven","statusInactive":"Nedejaven","statusUnknown":"Neznano","totalEscrow":"Celotna vrednost","unknownValidator":"Neznan overitelj"}}');

},{}],"gRbpH":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"account":{"addEscrow":{"availableAmount":"Mevcut:","confirmDelegatingToInactive":{"description":"Do\u011Frulay\u0131c\u0131n\u0131n durumu: {{validatorStatus}}. Yapt\u0131\u011F\u0131n\u0131z delegasyonla herhangi bir \xf6d\xfcl elde edemeyebilirsiniz.","title":"Devam etmek istedi\u011Finize emin misiniz?"},"confirmDelegatingToTop":{"acknowledge":"Yine de delege et","description":"Bu do\u011Frulay\u0131c\u0131, bahis miktar\u0131na g\xf6re ilk 20\'de yer almaktad\u0131r. A\u011F g\xfcvenli\u011Fini ve merkezi olmayan y\xf6netimi art\u0131rmak i\xe7in l\xfctfen daha k\xfc\xe7\xfck bir do\u011Frulay\u0131c\u0131ya yetki vermeyi d\xfc\u015F\xfcn\xfcn."},"delegate":"Delege"},"addressCopied":"Adres kopyaland\u0131.","loading":"Hesap y\xfckleniyor","loadingError":"Hesap y\xfcklenemedi.","reclaimEscrow":{"convertedToShares":"Kar\u015F\u0131l\u0131k gelen shares say\u0131s\u0131: {{shares}}","reclaim":"Al","reclaimAll":"Hepsini al.","reclaimableAmount":"Mevcut:"},"sendTransaction":{"confirmSendingToValidator":{"description":"Bu adres do\u011Frulay\u0131c\u0131ya aittir. Bu adrese yap\u0131lan transferler, birikiminizi do\u011Frulay\u0131c\u0131da stake ettirtmez.","title":"Devam etmek istedi\u011Fine emin misin?"},"enterAddress":"Bir adres girin","enterAmount":"Bir miktar girin.","recipient":"Al\u0131c\u0131","send":"G\xf6nder","success":"\u0130\u015Fleminiz ba\u015Far\u0131yla g\xf6nderildi. \u0130\u015Flemin hesab\u0131n\u0131za ge\xe7mesi bir dakikaya yak\u0131n s\xfcrebilmektedir."},"subnavigation":{"activeDelegations":"Delegasyonlar","debondingDelegations":"Debonding","mobileActiveDelegations":"Delegasyonlar","mobileDebondingDelegations":"Debonding"},"summary":{"balance":{"available":"Mevcut","debonding":"Ayr\u0131lm\u0131\u015F","delegations":"Stake Edilmi\u015F","total":"Toplam"},"noTransactionFound":"\u0130\u015Flem bulunamad\u0131","noWalletIsOpen":"{{ticker}} token g\xf6ndermek, almak, stake etmek ve takas etmek i\xe7in <HomeLink> c\xfczdan\u0131n\u0131z\u0131 a\xe7\u0131n </HomeLink>","notYourAccount":"Bu sizin hesab\u0131n\u0131z de\u011Fil."},"transaction":{"addEscrow":{"received":"<Amount/> heyet emanette kabul edildi","sent":"<Amount/> validat\xf6r\xfcne delege edildi."},"consensusDeposit":{"received":"{{runtimeName}}ParaTime\'a<Amount/> depozito al\u0131nd\u0131","sent":"{{runtimeName}} ParaTime\'a <Amount/> yat\u0131r\u0131ld\u0131"},"consensusWithdraw":{"received":"{{runtimeName}}ParaTime\'dan <Amount/> tanesi \xe7ekildi","sent":"{{runtimeName}}ParaTime\'dan \xe7ekilmeden <Amount/> al\u0131nd\u0131"},"explorerLink":"Explorer arac\u0131l\u0131\u011F\u0131yla i\u015Flem kay\u0131tlar\u0131n\u0131 g\xf6r\xfcnt\xfcle","failed":"Hata","genericTransaction":{"destination":"Di\u011Fer adres","header":"Y\xf6ntem {{method}}"},"loadingError":"\u0130\u015Flemler y\xfcklenemedi.","reclaimEscrow":{"received":"<Amount/>delege taraf\u0131ndan geri talep edildi","sent":"<Amount/>do\u011Frulay\u0131c\u0131 taraf\u0131ndan geri talep edildi"},"stakingAllow":{"received":"<Amount/>\xf6denek ald\u0131","sent":"<Amount/>\xd6denek ayarla"},"successful":"Ba\u015Far\u0131l\u0131","transfer":{"received":"Al\u0131nd\u0131 <Amount/>","sent":{"header":"G\xf6nderildi <Amount/>"}},"unrecognizedTransaction":{"destination":"Di\u011Fer adres","header":"Tan\u0131nmayan i\u015Flem, y\xf6ntem {{method}}"}},"validator":{"loadingError":"Do\u011Frulay\u0131c\u0131lar\u0131 y\xfckleyemiyoruz.","showingStale":"Do\u011Frulay\u0131c\u0131 listesini g\xf6steriyoruz: {{staleTimestamp}}."}},"backends":{"oasisscan":"Oasis Arama API"},"banner":{"buildPreview":"L\xfctfen bunun ROSE Wallet\'\u0131n deneysel bir yap\u0131s\u0131 oldu\u011Funu ve s\u0131rlar\u0131n\u0131z\u0131n g\xfcvende olmad\u0131\u011F\u0131n\u0131 unutmay\u0131n. SADECE TEST AMA\xc7LI KULLANIN.","buildStaging":"L\xfctfen bunun ROSE Wallet\'\u0131n haz\u0131rl\u0131k da\u011F\u0131t\u0131m\u0131 oldu\u011Funu unutmay\u0131n. SADECE TEST AMA\xc7LI KULLANIN."},"common":{"amount":"Miktar","block":"Engelle","cancel":"\u0130ptal et","confirm":"Onayla","delegator":"Delegat\xf6r","from":"Kimden","hash":"Tx \xc7\u0131kt\u0131s\u0131","round":"Raund","time":"Zaman","to":"Kime","unavailable":"Uygun de\u011Fil","validator":"Do\u011Frulay\u0131c\u0131","validators":"Do\u011Frulay\u0131c\u0131lar"},"createWallet":{"confirmSaved":"Anahtar kelimelerimi kaydettim","doNotShare":"Anahtar kelimenizi asla payla\u015Fmay\u0131n, anahtar kelimelerinizi bilen herkes c\xfczdan\u0131n\u0131za ve tokenlar\u0131n\u0131za eri\u015Febilir.","instruction":"Anahtar kelimenizi <strong>do\u011Fru s\u0131rayla </strong> g\xfcvenli bir konuma kaydedin; c\xfczdan\u0131n\u0131z\u0131 a\xe7mak i\xe7in buna ihtiyac\u0131n\u0131z olacak.","mnemonicMismatch":"Girdi\u011Finiz an\u0131msat\u0131c\u0131lar birbiriyle e\u015Fle\u015Fmiyor.","newMnemonic":"Yeni bir mnemonic olu\u015Ftur","thisIsYourPhrase":"Size ait olan mnemonic"},"delegations":{"activeDelegations":"Aktif delegasyonlar","debondingDelegations":"Ayr\u0131lan delegasyonlar","debondingTimeEnd":"Ayr\u0131lman\u0131n sonu","delegatedAmount":"Devredilen miktar","loadingError":"Yetkiler y\xfcklenemedi.","reclaimedAmount":"Al\u0131nan miktar"},"deleteForm":{"confirm":"Evet, Sil","confirmationKeyword":"Sil","hint":"\'<strong>{{confirmationKeyword}}</strong>\' yaz\u0131n"},"errors":{"LedgerDerivedDifferentAccount":"Bu hesap \u015Fu anda ba\u011Fl\u0131 olan Ledger\'a ait de\u011Fil.","LedgerOasisAppIsNotOpen":"Ledger \xfczerindeki Oasis Uygulamas\u0131 kapal\u0131.","bluetoothTransportNotSupported":"Cihaz\u0131n\u0131z Bluetooth desteklemiyor.","cannotSendToSelf":"Kendinize g\xf6nderemezsiniz","disconnectedError":"Ba\u011Flant\u0131 koptu.","duplicateTransaction":"Tekrarlayan i\u015Flem","indexerAPIError":"{{indexerName}} \xe7al\u0131\u015Fm\u0131yor gibi g\xf6r\xfcn\xfcyor, baz\u0131 bilgiler eksik veya g\xfcncel olmayabilir. L\xfctfen daha sonra tekrar gelin.","insufficientBalance":"Yetersiz bakiye","invalidAddress":"Ge\xe7ersiz adres","invalidNonce":"Ge\xe7ersiz Nonce (transaction number)","invalidPrivateKey":"Ge\xe7ersiz anahtar kelime","ledgerAppVersionNotSupported":"Al\u0131nd\u0131 : \\"Ledger uygulama versiyonu desteklenmiyor\\", bu yanl\u0131\u015F bir i\u015Flem olabilir, i\u015Flemi tekrar edin, e\u011Fer hata devam ederse Ledger\'\u0131n\u0131zdaki Oasis uygulamas\u0131n\u0131 g\xfcncelleyin.","ledgerCannotOpenOasisApp":"Oasis uygulamas\u0131n\u0131 Ledger \xfczerinde a\xe7amad\u0131, kilidin a\xe7\u0131k oldu\u011Fundan ve Oasis uygulamas\u0131n\u0131n a\xe7\u0131k oldu\u011Fundan emin olun.","ledgerNoDeviceSelected":"Hi\xe7bir Ledger cihaz\u0131 se\xe7ilmedi. Ba\u011Fl\u0131 oldu\u011Fundan emin olun, <LedgerHelp>Ledger</LedgerHelp> ile yayg\u0131n USB ba\u011Flant\u0131 sorunlar\u0131n\u0131 kontrol edin ve <ChromeHelp>site izinlerinin USB cihazlar\u0131n\u0131 engellemedi\u011Fini kontrol edin</ChromeHelp>.","ledgerTransactionRejected":"\u0130\u015Flem, Ledger taraf\u0131ndan reddedildi","noOpenWallet":"Hi\xe7bir c\xfczdan a\xe7\u0131k de\u011Fil.","unknown":"Bilinmeyen hata : {{message}}","unknownGrpc":"Bilinmeyen gRPC hatas\u0131: {{message}}","unknownLedgerError":"Bilinmeyen ledger hatas\u0131 : {{message}}","unknownParaTimeError":"Bilinmeyen ParaTime hatas\u0131: 1 {{message}}","usbTransportError":"USB hatas\u0131 : {{message}}","usbTransportNotSupported":"Kulland\u0131\u011F\u0131n\u0131z taraf\u0131y\u0131c\u0131 WebUSB\'yi desteklemiyor. (\xd6rne\u011Fin Firefox). L\xfctfen Chrome kullanmay\u0131 deneyin."},"fatalError":{"copied":"Hata panoya kopyaland\u0131","copy":"Hatay\u0131 panoya kopyala","heading":"Bir hata olu\u015Ftu","instruction":"Sorunun devam edip etmedi\u011Fini g\xf6rmek i\xe7in sayfay\u0131 yenilemeyi ve c\xfczdan\u0131n\u0131z\u0131 yeniden a\xe7may\u0131 deneyin. Sorun devam ederse l\xfctfen <Email/> e-posta yoluyla destek ekibimizle ileti\u015Fime ge\xe7in ve raporu a\u015Fa\u011F\u0131ya ekleyin."},"footer":{"github":"Oasis C\xfczdan tamamen <GithubLink>a\xe7\u0131k kaynakt\u0131r</GithubLink> - Geri bildirimler ve sorunlar takdir edilmektedir!","poweredBy":{"oasisscan":"Oasis Scan API & Oasis gRPC taraf\u0131ndan destekleniyor"},"terms":"<TermsLink>\u015Eartlar ve Ko\u015Fullar</TermsLink>","version":"S\xfcr\xfcm: <ReleaseLink/> (i\u015Flem: <CommitLink/>) {{buildTime}} tarihinde olu\u015Fturuldu"},"home":{"create":{"button":"C\xfczdan olu\u015Ftur","description":"ROSE tokenlar\u0131n\u0131z\u0131 g\xf6ndermek, almak, stake etmek ve swap yapmak i\xe7in yepyeni bir c\xfczdan olu\u015Fturun","header":"Yeni c\xfczdan olu\u015Ftur"},"existing":{"button":"C\xfczdan a\xe7","description":"Ledger \xfczerinde saklanan mevcut c\xfczdan\u0131n\u0131z\u0131 a\xe7\u0131n, gizli anahtar\u0131n\u0131z\u0131 ya da an\u0131msat\u0131c\u0131 kelimelerinizi i\xe7eriye aktar\u0131n.","header":"Mevcut c\xfczdana giri\u015F yap"}},"infoBox":{"valueCopied":"{{label}}kopyaland\u0131"},"language":"Dil","ledger":{"extension":{"connect":"Ledger cihaz\u0131n\u0131z\u0131 ba\u011Flay\u0131n.","failed":"Ba\u011Flant\u0131 ba\u015Far\u0131s\u0131z.","grantAccess":"USB Ledger\u0131n\u0131za eri\u015Fim izni verin","succeed":"Cihaz ba\u011Fland\u0131"},"instructionSteps":{"closeLedgerLive":"Bilgisayar\u0131n\u0131zdan Ledger Live Uygulamas\u0131n\u0131 kapat\u0131n.","connectUsbLedger":"L\xfctfen USB Ledger cihaz\u0131n\u0131z\u0131 bilgisayar\u0131n\u0131za ba\u011Flay\u0131n","header":"Ad\u0131mlar:","openOasisApp":"Oasis Uygulamas\u0131n\u0131, Ledger cihaz\u0131n\u0131zda a\xe7\u0131n\u0131z."},"steps":{"idle":"Bo\u015Fta","loadingAccounts":"Hesap detaylar\u0131 y\xfckleniyor","loadingBalances":"Bakiye detaylar\u0131 y\xfckleniyor","loadingBluetoothDevices":"Bluetooth cihazlar\u0131 y\xfckleniyor.","openingUsb":"Ledger USB \xdczerinden A\xe7\u0131l\u0131yor"}},"menu":{"addAccounts":"Hesap ekle","closeWallet":"C\xfczdan\u0131 kapat","home":"Ana Sayfa","lockProfile":"Profili kilitle.","openMenu":"Men\xfc","paraTimes":"ParaTimelar","unlockProfile":"Profilin kilidini a\xe7."},"migrateV0Extension":{"backupInvalidPrivateKeys":{"confirm":"\xd6zel anahtar\u0131m\u0131 g\xfcvenle saklad\u0131m.","reveal":"Ge\xe7ersiz \xf6zel anahtar\u0131 g\xf6stermek i\xe7in dokunun"},"backupMnemonic":{"description":"C\xfczdan uzant\u0131s\u0131n\u0131n yeni s\xfcr\xfcm\xfc art\u0131k an\u0131msat\u0131c\u0131n\u0131z\u0131 saklamayacakt\u0131r. Bu ifade, eri\u015Fiminizi kaybettiyseniz hesab\u0131n\u0131z\u0131 geri y\xfcklemenin tek yoludur. An\u0131msat\u0131c\u0131n\u0131z\u0131 yedeklemek i\xe7in son bir \u015Fans\u0131n\u0131z var.","reveal":"\xd6zel Kelimelerinizi g\xf6stermek i\xe7in t\u0131klay\u0131n."},"finishMigration":"C\xfczdan\u0131n yeni s\xfcr\xfcm\xfcn\xfc a\xe7\u0131n","nextStep":"Sonraki","requiredField":"Bu alan zorunludur.","title":"\xd6nemli C\xfczdan G\xfcncellemesi"},"openWallet":{"bitpie":{"warning":"\u2757 BitPie c\xfczdan kullan\u0131c\u0131lar\u0131: An\u0131msat\u0131c\u0131 ifadeyi do\u011Frudan BitPie c\xfczdan\u0131n\u0131zdan i\xe7e aktaramazs\u0131n\u0131z. <DocsLink>Ayr\u0131nt\u0131lar i\xe7in belgelere bak\u0131n.</DocsLink>"},"header":"C\xfczdan\u0131n\u0131z\u0131 nas\u0131l a\xe7mak istersiniz?","importAccounts":{"accountCounter":"{{count}}hesaplar se\xe7ildi.","accountCounter_one":"Bir hesap se\xe7ildi","accountCounter_plural":"{{count}}hesaplar se\xe7ildi.","accountCounter_zero":"Se\xe7ilen Hesap bulunamad\u0131.","next":"Sonraki","openWallets":"A\xe7","pageNumber":"Sayfa {{pageNum}} / {{totalPages}}","prev":"\xd6nceki","selectWallets":"A\xe7\u0131lacak hesaplar\u0131 se\xe7in"},"ledger":{"header":"Ledger cihaz\u0131n\u0131zdan a\xe7\u0131n\u0131z"},"method":{"ledger":"Ledger","mnemonic":"Mnemonic","privateKey":"\xd6zel anahtar"},"mnemonic":{"enterPhraseHere":"Anahtar kelimelerinizi buraya girin","error":"Ge\xe7ersiz anahtar kelime. L\xfctfen kelimeleri do\u011Fru s\u0131rayla girdi\u011Finizden emin olun, hepsi k\xfc\xe7\xfck harf olmal\u0131.","header":"Anahtar kelimelerinizi girin","import":"C\xfczdan\u0131m\u0131 i\xe7e aktar","instruction":"12, 18 veya 24 kelimelik anahtar kelimenizi a\u015Fa\u011F\u0131ya girin, her kelime bo\u015Flukla ayr\u0131lm\u0131\u015Ft\u0131r."},"privateKey":{"enterPrivateKeyHere":"\xd6zel anahtar\u0131n\u0131z\u0131 buraya girin","error":"Ge\xe7ersiz \xf6zel anahtar","header":"\xd6zel anahtar\u0131n\u0131z\u0131 girin","hidePrivateKey":"\xd6zel anahtar\u0131 gizle","instruction":"Base-64 ile \u015Fifrelenmi\u015F \xf6zel anahtar\u0131n\u0131z\u0131 girin","showPrivateKey":"\xd6zel anahtar\u0131 g\xf6ster"}},"paraTimes":{"amount":{"advanced":"Geli\u015Fmi\u015F","available":"Mevcut","depositDescription":"L\xfctfen yat\u0131r\u0131lacak {{ticker}} miktar\u0131n\u0131 girin ve ard\u0131ndan {{nextButtonLabel}} d\xfc\u011Fmesine t\u0131klay\u0131n","emptyAccount":"Hesap bo\u015F. \xc7ekilecek bir \u015Fey yok.","feeAmountPlaceholder":"Gas \xfccreti (nano {{ticker}})","feeGasPlaceholder":"Gas \xfccreti","max":"MAKS","tooltip":"Maksimum de\u011Fer \xfccrete g\xf6re azalabilir","withdrawDescription":"L\xfctfen \xe7ekilecek {{ticker}}tutar\u0131n\u0131 girin ve ard\u0131ndan {{nextButtonLabel}} d\xfc\u011Fmesine t\u0131klay\u0131n"},"common":{"cipher":"\u015Fifre","emerald":"Z\xfcmr\xfct","evmcType":"(EVMc)","header":"ParaTime Transferleri","sapphire":"Safir"},"confirmation":{"confirmDepositDescription":"L\xfctfen yat\u0131r\u0131lan tutar\u0131n ve al\u0131c\u0131 adresinin do\u011Fru oldu\u011Funu onaylay\u0131n ve ard\u0131ndan \\"{{nextButtonLabel}}\\" se\xe7ene\u011Fine t\u0131klay\u0131n.","confirmDepositToForeignAccountDescription":"Hedef adres c\xfczdan\u0131n\u0131zdaki hesaplar\u0131n hi\xe7biriyle e\u015Fle\u015Fmiyor! Borsalar gibi baz\u0131 hizmetler, hesab\u0131n\u0131za para yat\u0131rmak i\xe7in do\u011Frudan para yat\u0131rma i\u015Flemini desteklemeyebilir. Daha iyi uyumluluk i\xe7in \xf6ncelikle ParaTime hesab\u0131n\u0131za para yat\u0131rman\u0131z\u0131 ve ard\u0131ndan {{ticker}}\'\u0131 hedef adrese aktarman\u0131z\u0131 \xf6nemle tavsiye ederiz.","confirmTransferLabel":"Tutar\u0131n ve adresin do\u011Fru oldu\u011Funu onayl\u0131yorum","confirmTransferToForeignAccount":"Do\u011Frudan harici bir hesaba para \xe7ekmek istedi\u011Fimi onayl\u0131yorum","confirmTransferToValidatorLabel":"{{ticker}}\'u bir do\u011Frulay\u0131c\u0131 adresine aktarmak istedi\u011Fimi onayl\u0131yorum","confirmWithdrawDescription":"L\xfctfen \xe7ekilen tutar\u0131n ve al\u0131c\u0131 adresinin do\u011Fru oldu\u011Funu onaylay\u0131n ve ard\u0131ndan \\"{{nextButtonLabel}}\\" se\xe7ene\u011Fine t\u0131klay\u0131n.","confirmWithdrawToForeignAccountDescription":"Hedef adres c\xfczdan\u0131n\u0131zdaki hesaplar\u0131n hi\xe7biriyle e\u015Fle\u015Fmiyor! Borsalar gibi baz\u0131 hizmetler, hesaba para yat\u0131rmak i\xe7in do\u011Frudan para \xe7ekme i\u015Flemlerini desteklemeyebilir. Daha iyi uyumluluk i\xe7in \xf6ncelikle konsens\xfcs hesab\u0131n\u0131za para \xe7ekmenizi ve ard\u0131ndan {{ticker}}\'\u0131 hedef adrese aktarman\u0131z\u0131 \xf6nemle tavsiye ederiz.","depositDescription":"<strong>{{paraTime}}</strong> {{paratimeType}}\'a <strong>{{value}} {{ticker}}</strong> ila <strong>{{address}}</strong> yat\u0131rmak \xfczeresiniz","depositLabel":"Yat\u0131r","withdrawLabel":"\xc7ek"},"footer":{"back":"Geri","next":"\u0130leri","notice":"EVMC - Ethereum Sanal Makine ile uyumlu"},"pageInaccessible":{"foreignAccount":"Transferler mevcut de\u011Fil"},"recipient":{"depositDescription":"L\xfctfen al\u0131c\u0131 adresini <strong>{{paraTime}}</strong> {{paratimeType}} alan\u0131na girin ve ard\u0131ndan {{nextButtonLabel}} se\xe7ene\u011Fine t\u0131klay\u0131n","ethPrivateKeyPlaceholder":"Ethereum uyumlu \xf6zel anahtar\u0131n\u0131z\u0131 girin","placeholder":"0x...","withdrawDescription":"L\xfctfen al\u0131c\u0131 adresini fikir birli\u011Fiyle girin ve {{nextButtonLabel}} d\xfc\u011Fmesini t\u0131klay\u0131n"},"selection":{"cancel":"Transferi iptal et.","depositDescription":"L\xfctfen {{ticker}}\'\u0131n\u0131z\u0131 hangi ParaTime\'a yat\u0131rmak istedi\u011Finizi se\xe7in ve ard\u0131ndan {{nextButtonLabel}} se\xe7ene\u011Fine t\u0131klay\u0131n.","evmc":"EVMc","select":"ParaTime se\xe7","withdrawDescription":"L\xfctfen {{ticker}}\'\u0131n\u0131z\u0131 hangi ParaTime\'dan \xe7ekmek istedi\u011Finizi se\xe7in ve ard\u0131ndan {{nextButtonLabel}} \xf6\u011Fesine t\u0131klay\u0131n."},"summary":{"navigate":"ParaTime Transferlerine gidin"},"transfers":{"deposit":"ParaTime\'a yat\u0131r","depositDisabled":"Aktar\u0131lacak {{ticker}} jetonunuz yok","withdraw":"ParaTime\'dan \xe7ek"},"unsupportedFormStep":"Desteklenmeyen ad\u0131m","validation":{"insufficientBalanceToPayFee":"Komisyonu \xf6demek i\xe7in yeterli bakiyeniz yok.","invalidDecimalValue":"Maksimum {{decimals}} ondal\u0131k basama\u011Fa izin verilir","invalidEthPrivateKey":"Ethereum destekli \xf6zel anahtar\u0131n\u0131z ge\xe7erli de\u011Fil.","invalidEthPrivateKeyLength":"\xd6zel anahtar\u0131n\u0131z 64 haneli olmal\u0131d\u0131r.","invalidFee":"De\u011Fer 0\'dan b\xfcy\xfck veya 0\'a e\u015Fit bir tam say\u0131 olmal\u0131d\u0131r","required":"Alan gereklidir","unsupportedParaTime":"Desteklenmeyen ParaTime"}},"persist":{"createProfile":{"choosePassword":"\u015Eifre se\xe7in.","passwordMismatch":"Girilen paralolar uyu\u015Fmuyor","repeatPassword":"Paralonuzu tekrardan girin.","startPersisting":"\xd6zel anahtarlar\u0131 bir parolayla korunarak yerel olarak saklay\u0131n","unsupported":"Kal\u0131c\u0131l\u0131k bu taray\u0131c\u0131da desteklenmiyor."},"loading":"Y\xfckleniyor","loginToProfile":{"deleteProfile":{"button":"Profili Sil","title":"Profili sil"},"description":"Zaten ekledi\u011Finiz c\xfczdanlara eri\u015Fmek i\xe7in bu bilgisayardaki mevcut kullan\u0131c\u0131 profilinizde oturum a\xe7\u0131n.","enterPasswordHere":"Buraya \u015Fifrenizi girin.","hidePassword":"Parolay\u0131 sakla","showPassword":"Parolay\u0131 g\xf6ster","skipUnlocking":"Profil olmadan devam et","title":"Tekrar ho\u015Fgeldiniz!","unlock":"Kilidi A\xe7","wrongPassword":"Yanl\u0131\u015F \u015Fifre"}},"theme":{"darkMode":"Gece modu","lightMode":"G\xfcnd\xfcz Modu","title":"Tema"},"toolbar":{"contacts":{"add":"Kontakt Ekle","address":"Adres","cancel":"\u0130ptal","delete":{"button":"Kontakt\u0131 sil","confirm":"Evet, sil","description":"Bu kontakt\u0131 silmek istedi\u011Finize emin misiniz?","title":"Kontakt\u0131 sil"},"emptyList":"Kontrat\u0131n\u0131z bulunmuyor","manage":"Kontakt\u0131 d\xfczenle","name":"\u0130sim","notAvailable":"Ki\u015Fi eklemeye ba\u015Flamak i\xe7in <OpenWalletButton>bir c\xfczdan a\xe7arken</OpenWalletButton> bir profil olu\u015Fturun.","save":"Kaydet","validation":{"addressError":"L\xfctfen ge\xe7erli bir c\xfczdan adresi girin.","addressNotUniqueError":"Adres zaten bulunuyor","nameLengthError":"16 haneden daha fazla girmeyin","required":"Bu alan gerekli."}},"networks":{"local":"Yerel","mainnet":"Mainnet","selector":"A\u011F se\xe7","testnet":"Testnet"},"profile":{"deletion":"Silme","notAvailable":"<OpenWalletButton>Bir c\xfczdan a\xe7arken</OpenWalletButton> profilinizi ayarlayabilirsiniz.","password":{"current":"Mevcut \u015Fifre","enterCurrent":"Mevcut \u015Fifrenizi girin","enterNewPassword":"Yeni \u015Fifre","reenterNewPassword":"Yeni \u015Fifrenizi tekrar girin","submit":"\u015Eifreyi g\xfcncelle","success":"\u015Eifre g\xfcncellendi.","title":"Yeni bir \u015Fifre girin"}},"settings":{"accountNamingNotAvailable":"Hesab\u0131n\u0131z\u0131 adland\u0131rmak i\xe7in<OpenWalletButton>bir c\xfczdan a\xe7arken</OpenWalletButton> bir profil olu\u015Fturun.","cancel":"\u0130ptal","contacts":"Kontaklar","delete":{"description":"A\u015Fa\u011F\u0131daki hesab\u0131 silmek istedi\u011Finizden emin misiniz?","inputHelp":"Bu eylem geri al\u0131namaz. Devam etmek i\xe7in l\xfctfen a\u015Fa\u011F\u0131ya <strong>{{confirmationKeyword}}</strong> girin.","title":"Hesab\u0131 sil","tooltip":"Her zaman en az bir hesab\u0131n\u0131z\u0131n olmas\u0131 gerekir."},"exportPrivateKey":{"confirm":"Anlad\u0131m, \xf6zel anahtar\u0131m\u0131 g\xf6ster","copied":"\xd6zel anahtar kopyaland\u0131.","hint1":"\xd6zel anahtar bir dizi karakterden olu\u015Fur. \xd6zel anahtar\u0131n\u0131za eri\u015Fimi olan herkes, o hesab\u0131n varl\u0131klar\u0131na do\u011Frudan eri\u015Febilir.","hint2":"\xd6zel anahtar kayboldu\u011Funda geri al\u0131namaz. L\xfctfen \xf6zel anahtar\u0131 yedekledi\u011Finizden ve g\xfcvenli bir yerde saklad\u0131\u011F\u0131n\u0131zdan emin olun.","title":"\xd6zel Anahtar\u0131 D\u0131\u015Fa Aktar"},"manageAccount":"Y\xf6net","myAccountsTab":"Hesaplar\u0131m","nameLengthError":"En fazla 16 karakter","optionalName":"\u0130sim: (\u0130ste\u011Fe ba\u011Fl\u0131)","profile":"Profil","save":"Kaydet","settings":"Ayarlar"},"wallets":{"select":"Se\xe7"}},"transaction":{"cancel":"iptal","confirm":"Onayla","preview":{"amount":"Miktar","fee":"\u0130\u015Flem \xfccreti","from":"Kimden","gas":"Gas","genesisHash":"Genesis Hash","shares":"Payla\u015F\u0131mlar","to":"Kime","type":"Tip","validator":"Do\u011Frulay\u0131c\u0131","warning":"Bu i\u015Flemi onaylad\u0131ktan sonra iptal edemezsiniz. Dikkatlice inceleyin ve g\xf6ndermek istedi\u011Finizden emin oldu\u011Funuzda onaylay\u0131n."},"step":{"building":"\u0130\u015Flem olu\u015Fturuluyor","preview":"\u0130\u015Flemi \xf6nizle","signing":"\u0130\u015Flem imzalan\u0131yor","submitting":"\u0130\u015Flem g\xf6nderiliyor"},"types":{"addEscrow":"Tokenlar\u0131n\u0131z\u0131 bir do\u011Frulay\u0131c\u0131ya devretmek ve \xf6d\xfcller olu\u015Ftur","reclaimEscrow":"Bir do\u011Frulay\u0131c\u0131ya devredilen jetonlar\u0131n\u0131z\u0131 geri talep etme","transfer":"hesab\u0131n\u0131zdan di\u011Ferine jeton g\xf6nderme"}},"validator":{"boundsNotSet":"S\u0131n\u0131r ayarlanmad\u0131 (0% - 100%)","commission":"Komisyon","commissionBounds":{"current":"Ge\xe7erli Epoch {{epoch}}\'ta <strong>{{lowerBound}}% - {{upperBound}}%</strong>","future":"{{lowerBound}}% - {{upperBound}}%  d\xf6nemden ba\u015Fl\u0131yor {{epoch}}","label":"Komisyon s\u0131n\u0131rlar\u0131"},"escrow":"Al\u0131koyma","fee":"\u0130\u015Flem \xfccreti","name":"\u0130sim","rank":"R\xfctbe","status":"Durum","statusActive":"Aktif","statusInactive":"\u0130naktif","statusUnknown":"Bilinmeyen","totalEscrow":"Toplam Escrow","unknownValidator":"Bilinmeyen do\u011Frulay\u0131c\u0131"}}');

},{}],"8Wygw":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"account":{"addEscrow":{"availableAmount":"Kh\u1EA3 d\u1EE5ng:","confirmDelegatingToInactive":{"description":"Tr\u1EA1ng th\xe1i c\u1EE7a tr\xecnh x\xe1c th\u1EF1c n\xe0y l\xe0 {{validatorStatus}} . Vi\u1EC7c \u1EE7y quy\u1EC1n c\u1EE7a b\u1EA1n c\xf3 th\u1EC3 kh\xf4ng t\u1EA1o ra ph\u1EA7n th\u01B0\u1EDFng.","title":"B\u1EA1n c\xf3 mu\u1ED1n ti\u1EBFp t\u1EE5c kh\xf4ng?"},"confirmDelegatingToTop":{"acknowledge":"\u1EE6y quy\u1EC1n ngay","description":"Tr\xecnh x\xe1c th\u1EF1c n\xe0y \u0111\u01B0\u1EE3c x\u1EBFp h\u1EA1ng trong top 20 theo stake. Vui l\xf2ng c\xe2n nh\u1EAFc \u1EE7y quy\u1EC1n cho m\u1ED9t tr\xecnh x\xe1c th\u1EF1c nh\u1ECF h\u01A1n \u0111\u1EC3 t\u0103ng c\u01B0\u1EDDng b\u1EA3o m\u1EADt v\xe0 ph\xe2n quy\u1EC1n cho m\u1EA1ng l\u01B0\u1EDBi."},"delegate":"\u1EE6y quy\u1EC1n"},"addressCopied":"\u0110\xe3 sao ch\xe9p \u0111\u1ECBa ch\u1EC9","emptyActiveDelegationsList":"T\xe0i kho\u1EA3n ch\u01B0a c\xf3 staking n\xe0o \u0111ang ho\u1EA1t \u0111\u1ED9ng","emptyDebondingDelegationsList":"T\xe0i kho\u1EA3n kh\xf4ng c\xf3 staking n\xe0o \u0111ang r\xfat","loading":"\u0110ang t\u1EA3i t\xe0i kho\u1EA3n","loadingError":"Kh\xf4ng th\u1EC3 t\u1EA3i t\xe0i kho\u1EA3n","reclaimEscrow":{"convertedToShares":"S\u1ED1 l\u01B0\u1EE3ng c\u1ED5 ph\u1EA7n staking t\u01B0\u01A1ng \u1EE9ng {{shares}}","reclaim":"Nh\u1EADn l\u1EA1i","reclaimAll":"Nh\u1EADn l\u1EA1i t\u1EA5t c\u1EA3","reclaimableAmount":"Kh\u1EA3 d\u1EE5ng:"},"sendTransaction":{"confirmSendingToValidator":{"description":"\u0110\xe2y l\xe0 \u0111\u1ECBa ch\u1EC9 c\u1EE7a tr\xecnh x\xe1c th\u1EF1c. Vi\u1EC7c chuy\u1EC3n ti\u1EC1n \u0111\u1EBFn \u0111\u1ECBa ch\u1EC9 n\xe0y kh\xf4ng \u0111\u1ED3ng ngh\u0129a v\u1EDBi vi\u1EC7c \u0111\u1EB7t c\u1ECDc t\xe0i s\u1EA3n c\u1EE7a b\u1EA1n v\u1EDBi tr\xecnh x\xe1c th\u1EF1c.","title":"B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n ti\u1EBFp t\u1EE5c kh\xf4ng?"},"enterAddress":"Nh\u1EADp \u0111\u1ECBa ch\u1EC9 ","enterAmount":"Nh\u1EADp s\u1ED1 l\u01B0\u1EE3ng","recipient":"Ng\u01B0\u1EDDi nh\u1EADn","send":"G\u1EEDi","success":"Giao d\u1ECBch \u0111\xe3 \u0111\u01B0\u1EE3c g\u1EEDi th\xe0nh c\xf4ng. Giao d\u1ECBch c\xf3 th\u1EC3 m\u1EA5t \u0111\u1EBFn m\u1ED9t ph\xfat \u0111\u1EC3 hi\u1EC3n th\u1ECB trong t\xe0i kho\u1EA3n c\u1EE7a b\u1EA1n."},"subnavigation":{"activeDelegations":"\u0110\xe3 stake","debondingDelegations":"\u0110ang h\u1EE7y \u1EE7y quy\u1EC1n","mobileActiveDelegations":"\u0110\xe3 stake","mobileDebondingDelegations":"\u0110ang r\xfat"},"summary":{"activity":"Ho\u1EA1t \u0111\u1ED9ng","balance":{"available":"Kh\u1EA3 d\u1EE5ng","debonding":"\u0110ang r\xfat","delegations":"\u0110\xe3 stake","total":"T\u1ED5ng"},"noTransactionFound":"Kh\xf4ng c\xf3 giao d\u1ECBch \u0111\u01B0\u1EE3c t\xecm th\u1EA5y","noTransactionFoundOasisscanV2":"Kh\xf4ng c\xf3 giao d\u1ECBch t\u1EEB 29 th\xe1ng 10, 2023","noWalletIsOpen":"\u0110\u1EC3 g\u1EEDi, nh\u1EADn, stake v\xe0 \u0111\u1ED5i {{ticker}} \u0111\u1ED3ng, <HomeLink> m\u1EDF v\xed c\u1EE7a b\u1EA1n </HomeLink>.","notYourAccount":"\u0110\xe2y kh\xf4ng ph\u1EA3i t\xe0i kho\u1EA3n c\u1EE7a b\u1EA1n","pendingTransactions":"\u0110ang x\u1EED l\xed giao d\u1ECBch","someTxsInPendingState":"M\u1ED9t s\u1ED1 giao d\u1ECBch hi\u1EC7n \u0111ang \u1EDF tr\u1EA1ng th\xe1i ch\u1EDD x\u1EED l\xfd.","viewAccountTxs":"Xem giao d\u1ECBch c\u1EE7a t\xe0i kho\u1EA3n"},"transaction":{"addEscrow":{"received":"\u0110\xe3 nh\u1EADn <Amount/> \u1EE7y quy\u1EC1n trong t\xe0i kho\u1EA3n k\xfd qu\u1EF9","sent":"\u0110\xe3 \u1EE7y <Amount/> quy\u1EC1n cho tr\xecnh x\xe1c th\u1EF1c"},"consensusDeposit":{"received":"\u0110\xe3 nh\u1EADn <Amount/> r\xfat v\u1EC1 {{runtimeName}} ParaTime","sent":"N\u1EA1p <Amount/> v\xe0o {{runtimeName}} ParaTime"},"consensusWithdraw":{"received":"\u0110\xe3 r\xfat <Amount/> trong s\u1ED1 {{runtimeName}} ParaTime","sent":"\u0110\xe3 nh\u1EADn <Amount/> t\u1EEB vi\u1EC7c r\xfat ra kh\u1ECFi {{runtimeName}} ParaTime"},"explorerLink":"Xem l\u1ECBch s\u1EED giao d\u1ECBch qua tr\xecnh kh\xe1m ph\xe1 blockchain","failed":"Th\u1EA5t b\u1EA1i","genericTransaction":{"destination":"\u0110\u1ECBa ch\u1EC9 kh\xe1c ","header":"Ph\u01B0\u01A1ng ph\xe1p \'{{method}}\'"},"loadingError":"Kh\xf4ng th\u1EC3 t\u1EA3i giao d\u1ECBch","pending":"\u0110ang ch\u1EDD x\xe1c nh\u1EADn","reclaimEscrow":{"received":"<Amount/> \u0111\xe3 \u0111\u01B0\u1EE3c ng\u01B0\u1EDDi \u1EE7y quy\u1EC1n thu h\u1ED3i","sent":"\u0110\xe3 nh\u1EADn <Amount/> t\u1EEB tr\xecnh x\xe1c th\u1EF1c"},"stakingAllow":{"received":"\u0110\xe3 nh\u1EADn \u0111\u01B0\u1EE3c <Amount/> h\u1EA1n m\u1EE9c","sent":"\u0110\u1EB7t <Amount/> h\u1EA1n m\u1EE9c"},"stakingBurn":{"sent":"S\u1ED1 \u0111\u1ED3ng \u0111\xe3 b\u1ECB \u0111\u1ED1t <Amount/>"},"successful":"Th\xe0nh c\xf4ng","transfer":{"received":"\u0110\xe3 nh\u1EADn <Amount/>","sent":{"header":"\u0110\xe3 g\u1EEDi <Amount/>"}},"unrecognizedTransaction":{"destination":"\u0110\u1ECBa ch\u1EC9 kh\xe1c","header":"Giao d\u1ECBch kh\xf4ng x\xe1c \u0111\u1ECBnh, ph\u01B0\u01A1ng ph\xe1p  \'{{method}}\'"}},"validator":{"loadingError":"Kh\xf4ng th\u1EC3 t\u1EA3i danh s\xe1ch c\xe1c tr\xecnh x\xe1c th\u1EF1c.","showingStale":"Hi\u1EC3n th\u1ECB danh s\xe1ch tr\xecnh x\xe1c th\u1EF1c t\xednh \u0111\u1EBFn {{staleTimestamp}}"}},"appTitle":"V\xed Rose","backends":{"nexus":"API Nexus","oasisscanV2":"API Oasis Scan v2"},"banner":{"buildPreview":"L\u01B0u \xfd: \u0110\xe2y l\xe0 phi\xean b\u1EA3n th\u1EED nghi\u1EC7m c\u1EE7a ROSE Wallet v\xe0 th\xf4ng tin b\u1EA3o m\u1EADt c\u1EE7a b\u1EA1n kh\xf4ng \u0111\u01B0\u1EE3c \u0111\u1EA3m b\u1EA3o an to\xe0n. CH\u1EC8 S\u1EEC D\u1EE4NG CHO M\u1EE4C \u0110\xcdCH TH\u1EEC NGHI\u1EC6M.","buildStaging":"L\u01B0u \xfd: \u0110\xe2y l\xe0 b\u1EA3n tri\u1EC3n khai th\u1EED nghi\u1EC7m c\u1EE7a ROSE Wallet. CH\u1EC8 S\u1EEC D\u1EE4NG CHO M\u1EE4C \u0110\xcdCH TH\u1EEC NGHI\u1EC6M."},"common":{"amount":"S\u1ED1 l\u01B0\u1EE3ng","block":"Kh\u1ED1i","cancel":"H\u1EE7y","confirm":"X\xe1c nh\u1EADn","delegator":"Nh\xe0 \u0111\u1EA7u t\u01B0","from":"T\u1EEB","hash":"M\xe3 giao d\u1ECBch","postfixAmountInBillions":"\xa0t\u1EC9","round":"Chu k\u1EF3 kh\u1ED1i","time":"Th\u1EDDi gian","to":"\u0110\u1EBFn","unavailable":"Kh\xf4ng kh\u1EA3 d\u1EE5ng","validator":"Tr\xecnh x\xe1c th\u1EF1c","validators":"Danh s\xe1ch tr\xecnh x\xe1c th\u1EF1c"},"createWallet":{"confirmSaved":"T\xf4i \u0111\xe3 l\u01B0u tr\u1EEF c\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c c\u1EE7a m\xecnh m\u1ED9t c\xe1ch an to\xe0n","doNotShare":"Kh\xf4ng bao gi\u1EDD chia s\u1EBB c\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c c\u1EE7a b\u1EA1n, b\u1EA5t k\u1EF3 ai c\xf3 \u0111\u01B0\u1EE3c n\xf3 \u0111\u1EC1u c\xf3 th\u1EC3 truy c\u1EADp v\xe0o v\xed v\xe0 token c\u1EE7a b\u1EA1n","instruction":"L\u01B0u c\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c <strong> c\u1EE7a b\u1EA1n theo \u0111\xfang th\u1EE9 t\u1EF1 </strong> \u1EDF m\u1ED9t n\u01A1i an to\xe0n, b\u1EA1n s\u1EBD c\u1EA7n n\xf3 \u0111\u1EC3 m\u1EDF v\xed c\u1EE7a m\xecnh.","mnemonicMismatch":"C\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c \u0111\xe3 nh\u1EADp kh\xf4ng kh\u1EDBp.","newMnemonic":"T\u1EA1o m\u1ED9t c\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c m\u1EDBi","thisIsYourPhrase":"\u0110\xe2y l\xe0 c\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c c\u1EE7a b\u1EA1n"},"delegations":{"debondingTimeEnd":"Qu\xe1 tr\xecnh debonding k\u1EBFt th\xfac","delegatedAmount":"S\u1ED1 l\u01B0\u1EE3ng \u0111\xe3 \u1EE7y quy\u1EC1n","loadingError":"Kh\xf4ng th\u1EC3 t\u1EA3i danh s\xe1ch \u0111\xe3 stake.","reclaimedAmount":"S\u1ED1 l\u01B0\u1EE3ng c\xf3 th\u1EC3 nh\u1EADn l\u1EA1i"},"deleteForm":{"confirm":"\u0110\u1ED3ng \xfd, x\xf3a","confirmationKeyword":"x\xf3a","hint":"G\xf5 <strong>{{confirmationKeyword}}</strong>"},"errors":{"LedgerDerivedDifferentAccount":"T\xe0i kho\u1EA3n n\xe0y kh\xf4ng thu\u1ED9c Ledger hi\u1EC7n \u0111ang k\u1EBFt n\u1ED1i.","LedgerOasisAppIsNotOpen":"\u1EE8ng d\u1EE5ng Oasis tr\xean Ledger \u0111\xe3 \u0111\xf3ng.","bluetoothTransportNotSupported":"Bluetooth c\xf3 th\u1EC3 \u0111\xe3 t\u1EAFt ho\u1EB7c n\u1EC1n t\u1EA3ng b\u1EA1n \u0111ang s\u1EED d\u1EE5ng kh\xf4ng h\u1ED7 tr\u1EE3 Bluetooth.","cannotSendToSelf":"Kh\xf4ng th\u1EC3 g\u1EEDi cho ch\xednh b\u1EA1n.","disconnectedError":"M\u1EA5t k\u1EBFt n\u1ED1i.","duplicateTransaction":"Giao d\u1ECBch tr\xf9ng l\u1EB7p","indexerAPIError":"{{indexerName}} c\xf3 v\u1EBB nh\u01B0 h\u1EC7 th\u1ED1ng \u0111ang g\u1EB7p s\u1EF1 c\u1ED1, m\u1ED9t s\u1ED1 th\xf4ng tin c\xf3 th\u1EC3 b\u1ECB thi\u1EBFu ho\u1EB7c \u0111\xe3 thay \u0111\u1ED5i. Vui l\xf2ng th\u1EED l\u1EA1i sau.","insufficientBalance":"S\u1ED1 d\u01B0 kh\xf4ng kh\u1EA3 d\u1EE5ng","invalidAddress":"\u0110\u1ECBa ch\u1EC9 kh\xf4ng kh\u1EA3 d\u1EE5ng","invalidNonce":"Kh\xf4ng h\u1EE3p l\u1EC7 (s\u1ED1 giao d\u1ECBch)","invalidPrivateKey":"Kh\xf3a ri\xeang t\u01B0 kh\xf4ng h\u1EE3p l\u1EC7","ledgerAppVersionNotSupported":"\u1EE8ng d\u1EE5ng Oasis tr\xean Ledger \u0111\xe3 \u0111\xf3ng ho\u1EB7c ch\u01B0a c\u1EADp nh\u1EADt. H\xe3y \u0111\u1EA3m b\u1EA3o Ledger \u0111\xe3 \u0111\u01B0\u1EE3c m\u1EDF kh\xf3a, \u1EE9ng d\u1EE5ng Oasis \u0111ang ch\u1EA1y v\xe0 l\xe0 phi\xean b\u1EA3n m\u1EDBi nh\u1EA5t.","ledgerCannotOpenOasisApp":"Kh\xf4ng th\u1EC3 m\u1EDF \u1EE9ng d\u1EE5ng Oasis tr\xean Ledger. H\xe3y \u0111\u1EA3m b\u1EA3o Ledger \u0111\xe3 \u0111\u01B0\u1EE3c m\u1EDF kh\xf3a v\xe0 \u1EE9ng d\u1EE5ng Oasis \u0111ang ch\u1EA1y.","ledgerNoDeviceSelected":"Ch\u01B0a ch\u1ECDn thi\u1EBFt b\u1ECB Ledger. H\xe3y \u0111\u1EA3m b\u1EA3o thi\u1EBFt b\u1ECB \u0111\xe3 \u0111\u01B0\u1EE3c k\u1EBFt n\u1ED1i,<LedgerHelp> ki\u1EC3m tra c\xe1c s\u1EF1 c\u1ED1 k\u1EBFt n\u1ED1i USB th\u01B0\u1EDDng g\u1EB7p v\u1EDBi Ledger</LedgerHelp>, v\xe0 <ChromeHelp>\u0111\u1EA3m b\u1EA3o quy\u1EC1n truy c\u1EADp trang web kh\xf4ng ch\u1EB7n thi\u1EBFt b\u1ECB USB</ChromeHelp>.","ledgerTransactionRejected":"Giao d\u1ECBch b\u1ECB t\u1EEB ch\u1ED1i tr\xean Ledger.","noOpenWallet":"Kh\xf4ng c\xf3 v\xed \u0111\u01B0\u1EE3c m\u1EDF","unknown":"L\u1ED7i kh\xf4ng x\xe1c \u0111\u1ECBnh: {{message}}","unknownGrpc":"L\u1ED7i gRPC kh\xf4ng x\xe1c \u0111\u1ECBnh: {{message}}","unknownLedgerError":"L\u1ED7i ledger kh\xf4ng x\xe1c \u0111\u1ECBnh: {{message}}","unknownParaTimeError":"L\u1ED7i ParaTime kh\xf4ng x\xe1c \u0111\u1ECBnh : {{message}}","usbTransportError":"L\u1ED7i truy\u1EC1n d\u1EEF li\u1EC7u USB: {{message}}","usbTransportNotSupported":"N\u1EC1n t\u1EA3ng hi\u1EC7n t\u1EA1i kh\xf4ng h\u1ED7 tr\u1EE3 WebUSB. H\xe3y th\u1EED tr\xean n\u1EC1n t\u1EA3ng ho\u1EB7c tr\xecnh duy\u1EC7t kh\xe1c (\u01B0u ti\xean Chrome)."},"fatalError":{"checkStatus":"Ki\u1EC3m tra t\xecnh tr\u1EA1ng m\u1EA1ng","copied":"\u0110\xe3 sao ch\xe9p l\u1ED7i v\xe0o b\u1ED9 nh\u1EDB t\u1EA1m","copy":"Sao ch\xe9p l\u1ED7i v\xe0o b\u1ED9 nh\u1EDB t\u1EA1m","description":"L\u1ED7i x\u1EA3y ra khi\u1EBFn v\xed d\u1EEBng ho\u1EA1t \u0111\u1ED9ng.<strong> T\xe0i s\u1EA3n c\u1EE7a b\u1EA1n v\u1EABn an to\xe0n.</strong><br/><br/> Vui l\xf2ng th\u1EED l\xe0m m\u1EDBi trang v\xe0 m\u1EDF l\u1EA1i v\xed \u0111\u1EC3 ki\u1EC3m tra xem s\u1EF1 c\u1ED1 c\xf3 ti\u1EBFp di\u1EC5n hay kh\xf4ng. B\u1EA1n c\xf3 th\u1EC3 ki\u1EC3m tra tr\u1EA1ng th\xe1i hi\u1EC7n t\u1EA1i c\u1EE7a m\u1EA1ng b\xean d\u01B0\u1EDBi.","heading":"M\u1ED9t l\u1ED7i \u0111\xe3 x\u1EA3y ra.","instruction":"N\u1EBFu s\u1EF1 c\u1ED1 ch\u01B0a \u0111\u01B0\u1EE3c kh\u1EAFc ph\u1EE5c sau khi l\xe0m m\u1EDBi, vui l\xf2ng g\u1EEDi email cho \u0111\u1ED9i ng\u0169 h\u1ED7 tr\u1EE3 c\u1EE7a ch\xfang t\xf4i t\u1EA1i <Email/> v\xe0 \u0111\xednh k\xe8m b\xe1o c\xe1o l\u1ED7i.","reloadApp":"T\u1EA3i l\u1EA1i app"},"footer":{"feedback":"Ch\xfang t\xf4i s\u1EBD r\u1EA5t vui khi nh\u1EADn \u0111\u01B0\u1EE3c ph\u1EA3n h\u1ED3i c\u1EE7a b\u1EA1n t\u1EA1i <EmailLink>wallet@oasisprotocol.org</EmailLink>","github":"V\xed ROSE l\xe0 <GithubLink>m\xe3 ngu\u1ED3n m\u1EDF</GithubLink> v\xe0 \u0111\u01B0\u1EE3c v\u1EADn h\xe0nh b\u1EDFi ","poweredBy":{"nexus":"Nexus API & Oasis gRPC","oasisscanV2":"API Oasis Scan v2 & Oasis gRPC"},"terms":"<TermsLink>\u0110i\u1EC1u kho\u1EA3n v\xe0 \u0110i\u1EC1u ki\u1EC7n</TermsLink>","version":"Phi\xean b\u1EA3n: <ReleaseLink/> (cam k\u1EBFt: <CommitLink/>) \u0111\u01B0\u1EE3c x\xe2y d\u1EF1ng v\xe0o {{buildTime}}"},"home":{"create":{"button":"T\u1EA1o v\xed","description":"T\u1EA1o v\xed m\u1EDBi \u0111\u1EC3 g\u1EEDi, nh\u1EADn, stake v\xe0 ho\xe1n \u0111\u1ED5i \u0111\u1ED3ng ROSE.","header":"T\u1EA1o v\xed m\u1EDBi"},"existing":{"button":"M\u1EDF v\xed","description":"M\u1EDF v\xed hi\u1EC7n c\xf3 tr\xean Ledger, nh\u1EADp kh\xf3a ri\xeang t\u01B0 ho\u1EB7c c\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c.","header":"Truy c\u1EADp v\xed hi\u1EC7n c\xf3"}},"icons":{"bluetooth":"Bluetooth","mnemonic":"C\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c","privateKey":"Kh\xf3a ri\xeang t\u01B0","usb":"Usb","wallet":{"label":"V\xed"}},"infoBox":{"valueCopied":"{{label}} \u0111\xe3 sao ch\xe9p"},"language":"Ng\xf4n ng\u1EEF","ledger":{"extension":{"closingPopup":"\u0110ang \u0111\xf3ng... Vui l\xf2ng m\u1EDF l\u1EA1i \u1EE9ng d\u1EE5ng v\xed","connect":"K\u1EBFt n\u1ED1i thi\u1EBFt b\u1ECB Ledger","failed":"K\u1EBFt n\u1ED1i th\u1EA5t b\u1EA1i","grantAccess":"C\u1EA5p quy\u1EC1n truy c\u1EADp v\xe0o thi\u1EBFt b\u1ECB Ledger qua USB","succeed":"Thi\u1EBFt b\u1ECB \u0111\xe3 \u0111\u01B0\u1EE3c k\u1EBFt n\u1ED1i"},"instructionSteps":{"closeLedgerLive":"\u0110\xf3ng \u1EE9ng d\u1EE5ng Ledger Live tr\xean m\xe1y t\xednh c\u1EE7a b\u1EA1n","connectBluetoothLedger":"K\u1EBFt n\u1ED1i Ledger v\u1EDBi thi\u1EBFt b\u1ECB n\xe0y qua Bluetooth","connectUsbLedger":"K\u1EBFt n\u1ED1i Ledger v\u1EDBi thi\u1EBFt b\u1ECB n\xe0y qua USB","deviceIsPaired":"\u0110\u1EA3m b\u1EA3o Ledger c\u1EE7a b\u1EA1n \u0111\xe3 \u0111\u01B0\u1EE3c gh\xe9p n\u1ED1i v\u1EDBi thi\u1EBFt b\u1ECB n\xe0y","header":"C\xe1c b\u01B0\u1EDBc :","openOasisApp":"M\u1EDF app Oasis tr\xean Ledger c\u1EE7a b\u1EA1n"},"steps":{"accessingLedger":"\u0110ang k\u1EBFt n\u1ED1i v\u1EDBi thi\u1EBFt b\u1ECB Ledger","idle":"Ch\u01B0a ho\u1EA1t \u0111\u1ED9ng","loadingAccounts":"\u0110ang t\u1EA3i th\xf4ng tin t\xe0i kho\u1EA3n","loadingBalances":"\u0110ang t\u1EA3i th\xf4ng tin s\u1ED1 d\u01B0","loadingBluetoothDevices":"\u0110ang t\u1EA3i thi\u1EBFt b\u1ECB bluetooth"}},"menu":{"addAccounts":"Th\xeam t\xe0i kho\u1EA3n","closeWallet":"\u0110\xf3ng v\xed","home":"M\xe0n h\xecnh ch\xednh","lockProfile":"Kh\xf3a h\u1ED3 s\u01A1","openMenu":"Menu","paraTimes":"ParaTimes","stake":"Stake ROSE","stake-mobile":"Stake","unlockProfile":"M\u1EDF kh\xf3a h\u1ED3 s\u01A1","wallet":"T\xe0i kho\u1EA3n"},"migrateV0Extension":{"backupInvalidPrivateKeys":{"confirm":"T\xf4i \u0111\xe3 l\u01B0u tr\u1EEF kh\xf3a ri\xeang c\u1EE7a m\xecnh m\u1ED9t c\xe1ch an to\xe0n.","description":"{{count}} kh\xf3a ri\xeang t\u01B0 c\u1EE7a b\u1EA1n c\xf3 l\u1ED7i ch\xednh t\u1EA3 v\xe0 s\u1EBD kh\xf4ng \u0111\u01B0\u1EE3c l\u01B0u tr\u1EEF b\u1EDFi ti\u1EC7n \xedch m\u1EDF r\u1ED9ng v\xed m\u1EDBi. Vui l\xf2ng sao ch\xe9p ch\xfang v\xe0 l\u01B0u tr\u1EEF \u1EDF n\u01A1i kh\xe1c tr\u01B0\u1EDBc khi ti\u1EBFp t\u1EE5c, \u0111\u1EC3 b\u1EA1n c\xf3 th\u1EC3 s\u1EEDa l\u1EA1i sau.","description_one":"1 trong c\xe1c kh\xf3a ri\xeang t\u01B0 c\u1EE7a b\u1EA1n c\xf3 l\u1ED7i ch\xednh t\u1EA3 v\xe0 s\u1EBD kh\xf4ng \u0111\u01B0\u1EE3c l\u01B0u tr\u1EEF b\u1EDFi ti\u1EC7n \xedch m\u1EDF r\u1ED9ng v\xed m\u1EDBi. Vui l\xf2ng sao ch\xe9p kh\xf3a n\xe0y v\xe0 l\u01B0u tr\u1EEF \u1EDF n\u01A1i kh\xe1c tr\u01B0\u1EDBc khi ti\u1EBFp t\u1EE5c, \u0111\u1EC3 b\u1EA1n c\xf3 th\u1EC3 s\u1EEDa l\u1EA1i sau","description_plural":"{{count}} kh\xf3a ri\xeang t\u01B0 c\u1EE7a b\u1EA1n c\xf3 l\u1ED7i ch\xednh t\u1EA3 v\xe0 s\u1EBD kh\xf4ng \u0111\u01B0\u1EE3c l\u01B0u tr\u1EEF b\u1EDFi ti\u1EC7n \xedch m\u1EDF r\u1ED9ng v\xed m\u1EDBi. Vui l\xf2ng sao ch\xe9p ch\xfang v\xe0 l\u01B0u tr\u1EEF \u1EDF n\u01A1i kh\xe1c tr\u01B0\u1EDBc khi ti\u1EBFp t\u1EE5c, \u0111\u1EC3 b\u1EA1n c\xf3 th\u1EC3 s\u1EEDa l\u1EA1i sau.","reveal":"Ch\u1EA1m \u0111\u1EC3 hi\u1EC3n th\u1ECB kh\xf3a ri\xeang t\u01B0 kh\xf4ng h\u1EE3p l\u1EC7"},"backupMnemonic":{"description":"Phi\xean b\u1EA3n m\u1EDBi c\u1EE7a ti\u1EC7n \xedch v\xed m\u1EDF r\u1ED9ng s\u1EBD kh\xf4ng c\xf2n l\u01B0u tr\u1EEF c\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c c\u1EE7a b\u1EA1n. C\u1EE5m t\u1EEB n\xe0y l\xe0 c\xe1ch duy nh\u1EA5t \u0111\u1EC3 kh\xf4i ph\u1EE5c t\xe0i kho\u1EA3n n\u1EBFu b\u1EA1n m\u1EA5t quy\u1EC1n truy c\u1EADp. Hi\u1EC7n gi\u1EDD b\u1EA1n c\xf3 c\u01A1 h\u1ED9i cu\u1ED1i c\xf9ng \u0111\u1EC3 sao l\u01B0u c\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c c\u1EE7a m\xecnh.","reveal":"Ch\u1EA1m \u0111\u1EC3 hi\u1EC3n th\u1ECB c\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c c\u1EE7a b\u1EA1n"},"finishMigration":"M\u1EDF phi\xean b\u1EA3n m\u1EDBi c\u1EE7a v\xed","nextStep":"Ti\u1EBFp theo","requiredField":"Th\xf4ng tin n\xe0y l\xe0 b\u1EAFt bu\u1ED9c","title":"C\u1EADp nh\u1EADt v\xed quan tr\u1ECDng"},"mobileUpdate":{"errorTitle":"L\u1ED7i kh\xf4ng mong mu\u1ED1n","later":"Sau","retry":"Th\u1EED l\u1EA1i","unknownOrErrorDescription":"Xin l\u1ED7i v\xec s\u1EF1 b\u1EA5t ti\u1EC7n n\xe0y, m\u1ED9t l\u1ED7i kh\xf4ng mong mu\u1ED1n \u0111\xe3 x\u1EA3y ra. Vui l\xf2ng ki\u1EC3m tra k\u1EBFt n\u1ED1i internet c\u1EE7a b\u1EA1n v\xe0 th\u1EED l\u1EA1i b\u1EB1ng c\xe1ch nh\u1EA5p v\xe0o n\xfat \\"{{retryButtonLabel}}\\"","unknownTitle":"L\u1ED7i kh\xf4ng x\xe1c \u0111\u1ECBnh","updateAvailableDescription":"C\xf3 b\u1EA3n c\u1EADp nh\u1EADt m\u1EDBi cho ROSE Wallet c\u1EE7a b\u1EA1n. Ch\xfang t\xf4i khuy\u1EBFn ngh\u1ECB b\u1EA1n c\u1EADp nh\u1EADt l\xean phi\xean b\u1EA3n m\u1EDBi nh\u1EA5t \u0111\u1EC3 s\u1EEDa l\u1ED7i, c\u1EA3i thi\u1EC7n b\u1EA3o m\u1EADt v\xe0 tr\u1EA3i nghi\u1EC7m t\xednh n\u0103ng m\u1EDBi.","updateAvailableTitle":"\u0110ang ch\u1EDD c\u1EADp nh\u1EADt...","updateInProgressDescription":"ROSE Wallet c\u1EE7a b\u1EA1n hi\u1EC7n \u0111ang \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt. Vui l\xf2ng quay l\u1EA1i sau. Ngo\xe0i ra, b\u1EA1n c\u0169ng c\xf3 th\u1EC3 th\u1EED l\u1EA1i b\u1EB1ng c\xe1ch nh\u1EA5p v\xe0o n\xfat \\"{{retryButtonLabel}}\\"","updateInProgressTitle":"\u0110ang c\u1EADp nh\u1EADt...","updateNow":"C\u1EADp nh\u1EADt ngay b\xe2y gi\u1EDD"},"openWallet":{"bitpie":{"warning":"\u2757 Ng\u01B0\u1EDDi d\xf9ng v\xed BitPie: B\u1EA1n kh\xf4ng th\u1EC3 nh\u1EADp tr\u1EF1c ti\u1EBFp c\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c t\u1EEB v\xed BitPie.<DocsLink>ki\u1EC3m tra t\xe0i li\u1EC7u h\u01B0\u1EDBng d\u1EABn \u0111\u1EC3 bi\u1EBFt th\xeam chi ti\u1EBFt.</DocsLink>"},"header":"B\u1EA1n mu\u1ED1n m\u1EDF v\xed c\u1EE7a m\xecnh nh\u01B0 th\u1EBF n\xe0o?","importAccounts":{"NoBLEDevicesFound":"Kh\xf4ng c\xf3 thi\u1EBFt b\u1ECB Bluetooth \u0111\u01B0\u1EE3c t\xecm th\u1EA5y","accountCounter":"{{count}} t\xe0i kho\u1EA3n \u0111\xe3 \u0111\u01B0\u1EE3c ch\u1ECDn ","accountCounter_one":"M\u1ED9t t\xe0i kho\u1EA3n \u0111\u01B0\u1EE3c ch\u1ECDn","accountCounter_plural":"{{count}} t\xe0i kho\u1EA3n \u0111\xe3 \u0111\u01B0\u1EE3c ch\u1ECDn","accountCounter_zero":"Kh\xf4ng c\xf3 t\xe0i kho\u1EA3n \u0111\u01B0\u1EE3c ch\u1ECDn","bluetoothLedger":"Bluetooth Ledger","connectDeviceHeader":"B\u1EA1n mu\u1ED1n k\u1EBFt n\u1ED1i thi\u1EBFt b\u1ECB Ledger nh\u01B0 th\u1EBF n\xe0o?","next":"Ti\u1EBFp theo","openWallets":"M\u1EDF","pageNumber":"Trang {{pageNum}} tr\xean {{totalPages}}","prev":"Quay l\u1EA1i","selectDevice":"Ch\u1ECDn thi\u1EBFt b\u1ECB","selectLedgerDevice":"Ch\u1ECDn thi\u1EBFt b\u1ECB Ledger","selectWallets":"Ch\u1ECDn t\xe0i kho\u1EA3n \u0111\u1EC3 m\u1EDF","usbLedger":"USB Ledger"},"ledger":{"header":"M\u1EDF t\u1EEB thi\u1EBFt b\u1ECB Ledger"},"method":{"ledger":"Ledger","mnemonic":"C\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c","privateKey":"Kh\xf3a ri\xeang t\u01B0"},"mnemonic":{"enterPhraseHere":"Nh\u1EADp c\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c c\u1EE7a b\u1EA1n \u1EDF \u0111\xe2y","error":"C\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c kh\xf4ng h\u1EE3p l\u1EC7. Vui l\xf2ng nh\u1EADp \u0111\xfang th\u1EE9 t\u1EF1, t\u1EA5t c\u1EA3 b\u1EB1ng ch\u1EEF th\u01B0\u1EDDng.","header":"Nh\u1EADp c\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c c\u1EE7a b\u1EA1n","import":"Nh\u1EADp v\xed c\u1EE7a t\xf4i","instruction":"H\xe3y nh\u1EADp t\u1EA5t c\u1EA3 c\xe1c t\u1EEB kh\xf4i ph\u1EE5c c\u1EE7a b\u1EA1n, c\xe1ch nhau b\u1EB1ng d\u1EA5u c\xe1ch. Th\xf4ng th\u01B0\u1EDDng, c\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c s\u1EBD g\u1ED3m 12 ho\u1EB7c 24 t\u1EEB."},"privateKey":{"enterPrivateKeyHere":"Nh\u1EADp kh\xf3a ri\xeang t\u01B0 c\u1EE7a b\u1EA1n t\u1EA1i \u0111\xe2y.","error":"Kh\xf3a ri\xeang t\u01B0 kh\xf4ng kh\u1EA3 d\u1EE5ng","errorKeyIsInEthFormat":"Tr\u01B0\u1EDDng nh\u1EADp li\u1EC7u n\xe0y d\xe0nh cho kh\xf3a ri\xeang t\u01B0 c\u1EE7a Oasis Consensus. Kh\xf3a ri\xeang b\u1EA1n \u0111\xe3 nh\u1EADp c\xf3 v\u1EBB l\xe0 kh\xf3a ri\xeang t\u01B0 t\u01B0\u01A1ng th\xedch v\u1EDBi Ethereum (v\xed d\u1EE5: t\u1EEB MetaMask cho Sapphire). N\u1EBFu b\u1EA1n mu\u1ED1n s\u1EED d\u1EE5ng kh\xf3a ri\xeang t\u01B0 t\u01B0\u01A1ng th\xedch v\u1EDBi Ethereum \u0111\u1EC3 chuy\u1EC3n ROSE t\u1EEB Sapphire sang Consensus, h\xe3y nh\u1EA5p v\xe0o \\"{{paratimesMenu}}\\", sau \u0111\xf3 \\"{{withdrawButton}}\\", r\u1ED3i d\xe1n kh\xf3a ri\xeang t\u01B0 v\xe0o \u0111\xf3.","header":"Nh\u1EADp kh\xf3a ri\xeang t\u01B0 c\u1EE7a b\u1EA1n","hidePrivateKey":"\u1EA8n kh\xf3a ri\xeang t\u01B0 c\u1EE7a b\u1EA1n","instruction":"Nh\u1EADp kh\xf3a ri\xeang t\u01B0 c\u1EE7a b\u1EA1n d\u01B0\u1EDBi \u0111\u1ECBnh d\u1EA1ng Base64.","showPrivateKey":"Hi\u1EC3n th\u1ECB kh\xf3a ri\xeang t\u01B0"}},"paraTimes":{"amount":{"advanced":"N\xe2ng cao","available":"Kh\u1EA3 d\u1EE5ng: ","depositDescription":"Vui l\xf2ng nh\u1EADp s\u1ED1 l\u01B0\u1EE3ng c\u1EE7a {{ticker}}, \u0111\u1EC3 n\u1EA1p sau \u0111\xf3 nh\u1EA5p v\xe0o \\"{{nextButtonLabel}}\\"","emptyAccount":"T\xe0i kho\u1EA3n tr\u1ED1ng. Kh\xf4ng c\xf3 g\xec \u0111\u1EC3 r\xfat.","feeAmountPlaceholder":"S\u1ED1 ti\u1EC1n ph\xed (nano {{ticker}})","feeGasPlaceholder":"Ph\xed giao d\u1ECBch","max":"MAX","tooltip":"Gi\xe1 tr\u1ECB t\u1ED1i \u0111a c\xf3 th\u1EC3 b\u1ECB gi\u1EA3m do ph\xed giao d\u1ECBch","withdrawDescription":"Vui l\xf2ng nh\u1EADp s\u1ED1 l\u01B0\u1EE3ng c\u1EE7a \\"{{ticker}}\\" , \u0111\u1EC3 r\xfat sau \u0111\xf3 nh\u1EA5p v\xe0o \\"{{nextButtonLabel}}\\""},"common":{"cipher":"Cipher","discouragedType":"(mang t\xednh th\u1EED nghi\u1EC7m)","emerald":"Emerald","evmcType":"(EVMc)","header":"Giao d\u1ECBch ParaTime","sapphire":"Sapphire"},"confirmation":{"confirmDepositDescription":"Vui l\xf2ng x\xe1c nh\u1EADn s\u1ED1 ti\u1EC1n n\u1EA1p v\xe0 \u0111\u1ECBa ch\u1EC9 ng\u01B0\u1EDDi nh\u1EADn ch\xednh x\xe1c, sau \u0111\xf3 nh\u1EA5p v\xe0o \\"{{nextButtonLabel}}\\"","confirmDepositToForeignAccountDescription":"\u0110\u1ECBa ch\u1EC9 \u0111\xedch kh\xf4ng kh\u1EDBp v\u1EDBi b\u1EA5t k\u1EF3 t\xe0i kho\u1EA3n n\xe0o trong v\xed c\u1EE7a b\u1EA1n! M\u1ED9t s\u1ED1 d\u1ECBch v\u1EE5, ch\u1EB3ng h\u1EA1n nh\u01B0 s\xe0n giao d\u1ECBch, c\xf3 th\u1EC3 kh\xf4ng h\u1ED7 tr\u1EE3 n\u1EA1p ti\u1EC1n tr\u1EF1c ti\u1EBFp v\xe0o t\xe0i kho\u1EA3n. \u0110\u1EC3 \u0111\u1EA3m b\u1EA3o t\u01B0\u01A1ng th\xedch t\u1ED1t h\u01A1n, ch\xfang t\xf4i khuy\u1EBFn ngh\u1ECB b\u1EA1n n\xean n\u1EA1p ti\u1EC1n v\xe0o t\xe0i kho\u1EA3n ParaTime tr\u01B0\u1EDBc, sau \u0111\xf3 chuy\u1EC3n {{ticker}} \u0111\u1EBFn \u0111\u1ECBa ch\u1EC9 \u0111\xedch.","confirmTransferLabel":"T\xf4i x\xe1c nh\u1EADn s\u1ED1 ti\u1EC1n v\xe0 \u0111\u1ECBa ch\u1EC9 \u0111\u1EC1u ch\xednh x\xe1c","confirmTransferToForeignAccount":"T\xf4i x\xe1c nh\u1EADn mu\u1ED1n r\xfat ti\u1EC1n tr\u1EF1c ti\u1EBFp \u0111\u1EBFn t\xe0i kho\u1EA3n b\xean ngo\xe0i","confirmTransferToValidatorLabel":"T\xf4i x\xe1c nh\u1EADn mu\u1ED1n chuy\u1EC3n {{ticker}} \u0111\u1EBFn \u0111\u1ECBa ch\u1EC9 tr\xecnh x\xe1c th\u1EF1c","confirmWithdrawDescription":"Vui l\xf2ng x\xe1c nh\u1EADn s\u1ED1 ti\u1EC1n r\xfat v\xe0 \u0111\u1ECBa ch\u1EC9 ng\u01B0\u1EDDi nh\u1EADn ch\xednh x\xe1c, sau \u0111\xf3 nh\u1EA5p v\xe0o \\"{{nextButtonLabel}}\\"","confirmWithdrawToForeignAccountDescription":"\u0110\u1ECBa ch\u1EC9 \u0111\xedch kh\xf4ng kh\u1EDBp v\u1EDBi b\u1EA5t k\u1EF3 t\xe0i kho\u1EA3n n\xe0o trong v\xed c\u1EE7a b\u1EA1n! M\u1ED9t s\u1ED1 d\u1ECBch v\u1EE5, ch\u1EB3ng h\u1EA1n nh\u01B0 s\xe0n giao d\u1ECBch, c\xf3 th\u1EC3 kh\xf4ng h\u1ED7 tr\u1EE3 r\xfat ti\u1EC1n tr\u1EF1c ti\u1EBFp \u0111\u1EC3 n\u1EA1p v\xe0o t\xe0i kho\u1EA3n. \u0110\u1EC3 \u0111\u1EA3m b\u1EA3o t\u01B0\u01A1ng th\xedch t\u1ED1t h\u01A1n, ch\xfang t\xf4i khuy\u1EBFn ngh\u1ECB b\u1EA1n n\xean r\xfat ti\u1EC1n v\xe0o t\xe0i kho\u1EA3n l\u1EDBp \u0111\u1ED3ng thu\u1EADn tr\u01B0\u1EDBc, sau \u0111\xf3 chuy\u1EC3n \u0111\u1EBFn {{ticker}} \u0111\u1ECBa ch\u1EC9 \u0111\xedch danh.","depositDescription":"B\u1EA1n s\u1EAFp th\u1EF1c hi\u1EC7n giao d\u1ECBch n\u1EA1p <strong>{{value}} {{ticker}}</strong> t\u1EDBi <strong>{{address}}</strong> \u1EDF <strong>{{paraTime}}</strong> {{paratimeType}}","depositLabel":"N\u1EA1p","withdrawDescription":"B\u1EA1n s\u1EAFp th\u1EF1c hi\u1EC7n r\xfat <strong>{{value}} {{ticker}}</strong> t\u1EEB <strong>{{paraTime}}</strong> {{paratimeType}} t\u1EDBi <strong>{{address}}</strong>","withdrawLabel":"R\xfat"},"error":{"depositDescription":"Giao d\u1ECBch th\u1EA5t b\u1EA1i. Ch\xfang t\xf4i kh\xf4ng th\u1EC3 ho\xe0n t\u1EA5t vi\u1EC7c n\u1EA1p ti\u1EC1n t\u1EEB <strong>{{value}} {{ticker}}</strong> t\u1EDBi <strong>{{address}}</strong> \u1EDF <strong>{{paraTime}}</strong> {{paratimeType}}","withdrawDescription":"Giao d\u1ECBch th\u1EA5t b\u1EA1i. Ch\xfang t\xf4i kh\xf4ng th\u1EC3 ho\xe0n t\u1EA5t vi\u1EC7c r\xfat t\u1EEB <strong>{{value}} {{ticker}}</strong> t\u1EEB <strong>{{paraTime}}</strong> {{paratimeType}} \u0111\u1EBFn <strong>{{address}}</strong>"},"footer":{"back":"Tr\u1EDF l\u1EA1i","next":"Ti\u1EBFp theo","notice":"*EVMc - t\u01B0\u01A1ng th\xedch v\u1EDBi Ethereum Virtual Machine"},"pageInaccessible":{"foreignAccount":"T\xednh n\u0103ng chuy\u1EC3n hi\u1EC7n kh\xf4ng ho\u1EA1t \u0111\u1ED9ng.","ledgerAccount":"T\xe0i kho\u1EA3n Ledger kh\xf4ng \u0111\u01B0\u1EE3c h\u1ED7 tr\u1EE3."},"recipient":{"depositDescription":"Vui l\xf2ng nh\u1EADp \u0111\u1ECBa ch\u1EC9 ng\u01B0\u1EDDi nh\u1EADn tr\xean <strong>{{paraTime}}</strong> {{paratimeType}} sau \u0111\xf3 nh\u1EA5p v\xe0o \\"{{nextButtonLabel}}\\"","ethPrivateKeyPlaceholder":"Nh\u1EADp kh\xf3a ri\xeang t\u01B0 t\u01B0\u01A1ng th\xedch v\u1EDBi Ethereum.","evmcWithdrawDescription":"Vui l\xf2ng nh\u1EADp kh\xf3a ri\xeang t\u01B0 c\u1EE7a t\xe0i kho\u1EA3n tr\xean ParaTime, \u0111\u1ECBa ch\u1EC9 ng\u01B0\u1EDDi nh\u1EADn tr\xean Consensus, sau \u0111\xf3 nh\u1EA5p v\xe0o \\"{{nextButtonLabel}}\\"","placeholder":"0x...","withdrawDescription":"Vui l\xf2ng nh\u1EADp \u0111\u1ECBa ch\u1EC9 ng\u01B0\u1EDDi nh\u1EADn tr\xean l\u1EDBp \u0111\u1ED3ng thu\u1EADn v\xe0 nh\u1EA5p v\xe0o \\"{{nextButtonLabel}}\\""},"selection":{"cancel":"H\u1EE7y giao d\u1ECBch chuy\u1EC3n ti\u1EC1n","depositDescription":"Vui l\xf2ng ch\u1ECDn ParaTime m\xe0 b\u1EA1n mu\u1ED1n n\u1EA1p {{ticker}} v\xe0 sau \u0111\xf3 nh\u1EA5p v\xe0o \\"{{nextButtonLabel}}\\"","evmc":"EVMc","select":"Ch\u1ECDn ParaTime","withdrawDescription":"Vui l\xf2ng ch\u1ECDn ParaTime m\xe0 b\u1EA1n mu\u1ED1n r\xfat {{ticker}} t\u1EEB \u0111\xf3, sau \u0111\xf3 nh\u1EA5p v\xe0o \\"{{nextButtonLabel}}\\""},"summary":{"depositDescription":"B\u1EA1n \u0111\xe3 n\u1EA1p ti\u1EC1n th\xe0nh c\xf4ng <strong>{{value}} {{ticker}}</strong> t\u1EDBi <strong>{{address}}</strong> v\xe0o <strong>{{paraTime}}</strong> {{paratimeType}}","navigate":"Chuy\u1EC3n \u0111\u1EBFn m\u1EE5c Chuy\u1EC3n kho\u1EA3n ParaTime","withdrawDescription":"B\u1EA1n \u0111\xe3 r\xfat ti\u1EC1n th\xe0nh c\xf4ng <strong>{{value}} {{ticker}}</strong> t\u1EEB <strong>{{paraTime}}</strong> {{paratimeType}} t\u1EDBi <strong>{{address}}</strong>"},"transfers":{"deposit":"N\u1EA1p ti\u1EC1n v\xe0o ParaTime","depositDisabled":"B\u1EA1n kh\xf4ng c\xf2n b\u1EA5t k\xec {{ticker}} \u0111\u1ED3ng n\xe0o \u0111\u1EC3 giao d\u1ECBch","description":"Nh\u1EA5p v\xe0o n\xfat \\"{{depositButtonLabel}}\\" \u0111\u1EC3 n\u1EA1p {{ticker}} t\u1EEB m\u1EA1ng \u0111\u1ED3ng thu\u1EADn v\xe0o ParaTime b\u1EA1n ch\u1ECDn ho\u1EB7c \\"{{withdrawButtonLabel}}\\" \u0111\u1EC3 r\xfat {{ticker}} t\u1EEB ParaTime v\u1EC1 M\u1EA1ng \u0111\u1ED3ng thu\u1EADn.","withdraw":"R\xfat ti\u1EC1n t\u1EEB ParaTime "},"unsupportedFormStep":"Bi\u1EC3u m\u1EABu kh\xf4ng h\u1ED7 tr\u1EE3 b\u01B0\u1EDBc n\xe0y ","validation":{"insufficientBalanceToPayFee":"S\u1ED1 d\u01B0 kh\xf4ng \u0111\u1EE7 \u0111\u1EC3 thanh to\xe1n ph\xed","invalidDecimalValue":"Cho ph\xe9p t\u1ED1i \u0111a {{decimals}} s\u1ED1 ch\u1EEF s\u1ED1 th\u1EADp ph\xe2n","invalidEthPrivateKey":"Kh\xf3a ri\xeang t\u01B0 t\u01B0\u01A1ng th\xedch v\u1EDBi Ethereum kh\xf4ng h\u1EE3p l\u1EC7","invalidEthPrivateKeyLength":"Kh\xf3a ri\xeang t\u01B0 ph\u1EA3i c\xf3 \u0111\u1ED9 d\xe0i 64 k\xfd t\u1EF1","invalidFee":"Gi\xe1 tr\u1ECB ph\u1EA3i l\xe0 s\u1ED1 nguy\xean l\u1EDBn h\u01A1n ho\u1EB7c b\u1EB1ng 0","required":"Ph\u1EA7n n\xe0y l\xe0 b\u1EAFt bu\u1ED9c","unsupportedParaTime":"ParaTime kh\xf4ng \u0111\u01B0\u1EE3c h\u1ED7 tr\u1EE3"}},"persist":{"createProfile":{"passwordMismatch":"M\u1EADt kh\u1EA9u \u0111\xe3 nh\u1EADp kh\xf4ng kh\u1EDBp","repeatPassword":"X\xe1c nh\u1EADn m\u1EADt kh\u1EA9u c\u1EE7a b\u1EA1n","requiredField":"Tr\u01B0\u1EDDng n\xe0y l\xe0 b\u1EAFt bu\u1ED9c","startPersisting":"L\u01B0u tr\u1EEF kh\xf3a ri\xeang t\u01B0 c\u1EE7a b\u1EA1n v\u1EC1 c\u1EE5c b\u1ED9 v\xe0 b\u1EA3o v\u1EC7 ch\xfang b\u1EB1ng m\u1EADt kh\u1EA9u b\u1EB1ng c\xe1ch t\u1EA1o h\u1ED3 s\u01A1.","startPersistingToggle":"T\u1EA1o h\u1ED3 s\u01A1","undependableAcknowledge":"T\xf4i hi\u1EC3u r\u1EB1ng m\u1EADt kh\u1EA9u v\xe0 h\u1ED3 s\u01A1 n\xe0y kh\xf4ng th\u1EC3 thay c\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c c\u1EE7a t\xf4i.","unsupported":"Tr\xecnh duy\u1EC7t n\xe0y kh\xf4ng h\u1ED7 tr\u1EE3 t\xednh n\u0103ng l\u01B0u tr\u1EEF d\u1EEF li\u1EC7u."},"loading":"\u0110ang t\u1EA3i","loginToProfile":{"deleteProfile":{"button":"X\xf3a h\u1ED3 s\u01A1","description":"Thao t\xe1c n\xe0y <strong> s\u1EBD x\xf3a v\u0129nh vi\u1EC5n kh\xf3a ri\xeang t\u01B0 kh\u1ECFi thi\u1EBFt b\u1ECB n\xe0y. </strong> <br/> <br/> \u0110\u1EC3 x\xe1c nh\u1EADn v\xe0 ti\u1EBFp t\u1EE5c, vui l\xf2ng nh\u1EADp <strong>{{confirmationKeyword}}</strong> b\xean d\u01B0\u1EDBi.","forgotPasswordButton":"Qu\xean m\u1EADt kh\u1EA9u?","forgotPasswordDescription":"V\xed ROSE kh\xf4ng l\u01B0u tr\u1EEF m\u1EADt kh\u1EA9u c\u1EE7a b\u1EA1n v\xe0 kh\xf4ng th\u1EC3 gi\xfap b\u1EA1n kh\xf4i ph\u1EE5c n\xf3. N\u1EBFu qu\xean m\u1EADt kh\u1EA9u, b\u1EA1n c\xf3 th\u1EC3 x\xf3a h\u1ED3 s\u01A1 b\u1ECB kh\xf3a t\u1EA1i \u0111\xe2y. Sau \u0111\xf3, b\u1EA1n c\xf3 th\u1EC3 t\u1EA1o h\u1ED3 s\u01A1 m\u1EDBi b\u1EB1ng c\u1EE5m t\u1EEB kh\xf4i ph\u1EE5c ho\u1EB7c kh\xf3a ri\xeang t\u01B0 \u0111\u1EC3 ti\u1EBFp t\u1EE5c s\u1EED d\u1EE5ng \u0111\u1ED3ng ROSE c\u1EE7a m\xecnh.","title":"X\xf3a h\u1ED3 s\u01A1"},"description":"Nh\u1EADp m\u1EADt kh\u1EA9u \u0111\u1EC3 truy c\u1EADp c\xe1c v\xed hi\u1EC7n c\xf3 tr\xean thi\u1EBFt b\u1ECB n\xe0y.","enterPasswordHere":"Nh\u1EADp m\u1EADt kh\u1EA9u c\u1EE7a b\u1EA1n","hidePassword":"\u1EA8n m\u1EADt kh\u1EA9u","showPassword":"Hi\u1EC3n th\u1ECB m\u1EADt kh\u1EA9u","skipUnlocking":"Ti\u1EBFp t\u1EE5c m\xe0 kh\xf4ng c\u1EA7n t\xe0i kho\u1EA3n","title":"Ch\xe0o m\u1EEBng quay tr\u1EDF l\u1EA1i!","unlock":"M\u1EDF kh\xf3a","wrongPassword":"Sai m\u1EADt kh\u1EA9u"}},"theme":{"darkMode":"Ch\u1EBF \u0111\u1ED9 t\u1ED1i","lightMode":"Ch\u1EBF \u0111\u1ED9 s\xe1ng","system":"H\u1EC7 th\u1ED1ng","title":"Ch\u1EE7 \u0111\u1EC1"},"toolbar":{"contacts":{"add":"Th\xeam li\xean h\u1EC7","address":"\u0110\u1ECBa ch\u1EC9","cancel":"H\u1EE7y","delete":{"button":"X\xf3a li\xean h\u1EC7","confirm":"C\xf3, h\xe3y x\xf3a","description":"B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n x\xf3a li\xean h\u1EC7 n\xe0y kh\xf4ng?","title":"X\xf3a li\xean h\u1EC7"},"emptyList":"B\u1EA1n ch\u01B0a c\xf3 li\xean h\u1EC7 n\xe0o.","manage":"Qu\u1EA3n l\xed li\xean h\u1EC7","name":"T\xean","notAvailable":"\u0110\u1EC3 b\u1EAFt \u0111\u1EA7u th\xeam li\xean h\u1EC7 cho t\xe0i kho\u1EA3n c\u1EE7a b\u1EA1n <OpenWalletButton> m\u1EDF v\xed </OpenWalletButton>. ","save":"L\u01B0u","validation":{"addressError":"Vui l\xf2ng nh\u1EADp \u0111\u1ECBa ch\u1EC9 v\xed h\u1EE3p l\u1EC7","addressNotUniqueError":"\u0110\u1ECBa ch\u1EC9 \u0111\xe3 t\u1ED3n t\u1EA1i","nameLengthError":"Kh\xf4ng qu\xe1 16 k\xed t\u1EF1","required":"Th\xf4ng tin n\xe0y l\xe0 b\u1EAFt bu\u1ED9c"}},"networks":{"local":"C\u1EE5c b\u1ED9","mainnet":"M\u1EA1ng l\u01B0\u1EDBi ch\xednh","selector":"Ch\u1ECDn m\u1EA1ng l\u01B0\u1EDBi","testnet":"M\u1EA1ng l\u01B0\u1EDBi th\u1EED nghi\u1EC7m"},"profile":{"notAvailable":"B\u1EA1n c\xf3 th\u1EC3 thi\u1EBFt l\u1EADp h\u1ED3 s\u01A1 c\u1EE7a m\xecnh khi <OpenWalletButton>t\u1EA1o v\xed</OpenWalletButton>.","password":{"current":"M\u1EADt kh\u1EA9u hi\u1EC7n t\u1EA1i","enterCurrent":"Nh\u1EADp m\u1EADt kh\u1EA9u hi\u1EC7n t\u1EA1i c\u1EE7a b\u1EA1n","enterNewPassword":"M\u1EADt kh\u1EA9u m\u1EDBi","reenterNewPassword":"Nh\u1EADp l\u1EA1i m\u1EADt kh\u1EA9u m\u1EDBi","submit":"C\u1EADp nh\u1EADt m\u1EADt kh\u1EA9u","success":"M\u1EADt kh\u1EA9u \u0111\xe3 \u0111\u01B0\u1EE3c c\u1EADp nh\u1EADt.","title":"\u0110\u1EB7t m\u1EADt kh\u1EA9u m\u1EDBi"}},"settings":{"accountNamingNotAvailable":"\u0110\u1EC3 \u0111\u1EB7t t\xean cho t\xe0i kho\u1EA3n c\u1EE7a b\u1EA1n, h\xe3y t\u1EA1o h\u1ED3 s\u01A1 trong khi <OpenWalletButton>m\u1EDF v\xed</OpenWalletButton>","cancel":"H\u1EE7y","contacts":"\u0110\u1ECBa ch\u1EC9 v\xed \u0111\xe3 l\u01B0u","delete":{"description":"B\u1EA1n c\xf3 ch\u1EAFc mu\u1ED1n x\xf3a t\xe0i kho\u1EA3n n\xe0y kh\xf4ng ?","inputHelp":"H\xe0nh \u0111\u1ED9ng n\xe0y kh\xf4ng th\u1EC3 ho\xe0n t\xe1c. \u0110\u1EC3 ti\u1EBFp t\u1EE5c, vui l\xf2ng nh\u1EADp<strong>{{confirmationKeyword}}</strong> b\xean d\u01B0\u1EDBi.","title":"X\xf3a t\xe0i kho\u1EA3n","tooltip":"B\u1EA1n ph\u1EA3i lu\xf4n c\xf3 \xedt nh\u1EA5t m\u1ED9t t\xe0i kho\u1EA3n."},"exportPrivateKey":{"confirm":"T\xf4i hi\u1EC3u, hi\u1EC3n th\u1ECB kh\xf3a ri\xeang t\u01B0 c\u1EE7a t\xf4i.","copied":"\u0110\xe3 sao ch\xe9p kh\xf3a ri\xeang t\u01B0.","hint1":"Kh\xf3a ri\xeang t\u01B0 l\xe0 m\u1ED9t chu\u1ED7i k\xfd t\u1EF1. B\u1EA5t k\u1EF3 ai c\xf3 \u0111\u01B0\u1EE3c kh\xf3a n\xe0y \u0111\u1EC1u c\xf3 th\u1EC3 truy c\u1EADp tr\u1EF1c ti\u1EBFp v\xe0o t\xe0i s\u1EA3n trong t\xe0i kho\u1EA3n c\u1EE7a b\u1EA1n.","hint2":"N\u1EBFu b\u1EA1n m\u1EA5t kh\xf3a ri\xeang t\u01B0, s\u1EBD kh\xf4ng th\u1EC3 kh\xf4i ph\u1EE5c l\u1EA1i. H\xe3y sao l\u01B0u v\xe0 l\u01B0u tr\u1EEF kh\xf3a \u1EDF n\u01A1i an to\xe0n \u0111\u1EC3 b\u1EA3o v\u1EC7 t\xe0i s\u1EA3n c\u1EE7a b\u1EA1n.","title":"Xu\u1EA5t kh\xf3a ri\xeang t\u01B0"},"manageAccount":"Qu\u1EA3n l\xfd","myAccountsTab":"T\xe0i kho\u1EA3n c\u1EE7a t\xf4i","nameLengthError":"Kh\xf4ng qu\xe1 16 k\xed t\u1EF1","optionalName":"T\xean hi\u1EC3n th\u1ECB ( t\xf9y ch\u1ECDn )","profile":"H\u1ED3 s\u01A1","save":"L\u01B0u","settings":"C\xe0i \u0111\u1EB7t"},"wallets":{"select":"Ch\u1ECDn"}},"transaction":{"cancel":"H\u1EE7y","confirm":"X\xe1c nh\u1EADn","preview":{"amount":"S\u1ED1 l\u01B0\u1EE3ng","fee":"Ph\xed ","from":"T\u1EEB","gas":"Ph\xed giao d\u1ECBch","genesisHash":"M\xe3 b\u0103m kh\u1EDFi t\u1EA1o","shares":"C\u1ED5 ph\u1EA7n staking","to":"T\u1EDBi","type":"Lo\u1EA1i","validator":"Tr\xecnh x\xe1c th\u1EF1c","warning":"Sau khi b\u1EA1n x\xe1c nh\u1EADn giao d\u1ECBch n\xe0y, b\u1EA1n s\u1EBD kh\xf4ng th\u1EC3 h\u1EE7y b\u1ECF. Vui l\xf2ng ki\u1EC3m tra k\u1EF9 v\xe0 ch\u1EC9 x\xe1c nh\u1EADn khi b\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n g\u1EEDi."},"step":{"building":"\u0110ang t\u1EA1o giao d\u1ECBch","preview":"Xem tr\u01B0\u1EDBc giao d\u1ECBch","signing":"K\xfd x\xe1c nh\u1EADn giao d\u1ECBch","submitting":"\u0110ang g\u1EEDi giao d\u1ECBch"},"types":{"addEscrow":"\u1EE6y quy\u1EC1n token c\u1EE7a b\u1EA1n cho tr\xecnh x\xe1c th\u1EF1c v\xe0 t\u1EA1o ph\u1EA7n th\u01B0\u1EDFng","reclaimEscrow":"Nh\u1EADn l\u1EA1i token b\u1EA1n \u0111\xe3 \u1EE7y quy\u1EC1n cho tr\xecnh x\xe1c th\u1EF1c","transfer":"g\u1EEDi token t\u1EEB t\xe0i kho\u1EA3n c\u1EE7a b\u1EA1n t\u1EDBi t\xe0i kho\u1EA3n kh\xe1c"}},"validator":{"boundsNotSet":"Kh\xf4ng c\xf3 gi\u1EDBi h\u1EA1n \u0111\u01B0\u1EE3c \u0111\u1EB7t (0% - 100%)","commission":"Hoa h\u1ED3ng","commissionBounds":{"current":"<strong>{{lowerBound}}% - {{upperBound}}%</strong> \u1EDF Epoch hi\u1EC7n t\u1EA1i {{epoch}}","future":"{{lowerBound}}% - {{upperBound}}% b\u1EAFt \u0111\u1EA7u t\u1EEB Epoch {{epoch}}","label":"Gi\u1EDBi h\u1EA1n hoa h\u1ED3ng"},"escrow":"K\xfd qu\u1EF9","fee":"Ph\xed","name":"T\xean","rank":"X\u1EBFp h\u1EA1ng","status":"Tr\u1EA1ng th\xe1i","statusActive":"Ho\u1EA1t \u0111\u1ED9ng","statusInactive":"Kh\xf4ng ho\u1EA1t \u0111\u1ED9ng","statusUnknown":"Kh\xf4ng x\xe1c \u0111\u1ECBnh","totalEscrow":"T\u1ED5ng s\u1ED1 ti\u1EC1n k\xfd qu\u1EF9","unknownValidator":"Tr\xecnh x\xe1c th\u1EF1c kh\xf4ng x\xe1c \u0111\u1ECBnh"}}');

},{}],"283g6":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse('{"account":{"addEscrow":{"availableAmount":"\u53EF\u7528\uFF1A","confirmDelegatingToInactive":{"description":"\u8BE5\u8282\u70B9\u7684\u72B6\u6001\u4E3A{{validatorStatus}}\uFF0C\u4F60\u7684\u8D28\u62BC\u6216\u65E0\u6CD5\u4EA7\u751F\u6536\u76CA\u3002","title":"\u786E\u8BA4\u7EE7\u7EED\u5417\uFF1F"},"confirmDelegatingToTop":{"acknowledge":"\u4ECD\u8981\u8D28\u62BC","description":"\u8BE5\u8282\u70B9\u7684\u8D28\u62BC\u603B\u91CF\u4F4D\u4E8E\u524D20\uFF0C\u8BF7\u8003\u8651\u7ED9\u66F4\u5C0F\u7684\u8282\u70B9\u8D28\u62BC\uFF0C\u4EE5\u589E\u5F3A\u7F51\u7EDC\u7684\u5B89\u5168\u548C\u53BB\u4E2D\u5FC3\u5316\u7A0B\u5EA6\u3002"},"delegate":"\u8D28\u62BC"},"addressCopied":"\u5730\u5740\u5DF2\u590D\u5236","loading":"\u8D26\u6237\u52A0\u8F7D\u4E2D","loadingError":"\u65E0\u6CD5\u52A0\u8F7D\u8D26\u6237","reclaimEscrow":{"convertedToShares":"\u5BF9\u5E94\u7684share\u6570\u91CF\uFF1A{{shares}}","reclaim":"\u53D6\u56DE","reclaimAll":"\u53D6\u56DE\u5168\u90E8","reclaimableAmount":"\u53EF\u7528\uFF1A"},"sendTransaction":{"confirmSendingToValidator":{"description":"\u6B64\u4E3A\u8282\u70B9\u5730\u5740\uFF0C\u76F4\u63A5\u8F6C\u8D26\u5230\u8BE5\u5730\u5740\u65E0\u6CD5\u4E3A\u8BE5\u8282\u70B9\u8D28\u62BC","title":"\u786E\u8BA4\u7EE7\u7EED\u5417\uFF1F"},"enterAddress":"\u8F93\u5165\u5730\u5740","enterAmount":"\u8F93\u5165\u91D1\u989D","recipient":"\u6536\u6B3E\u5730\u5740","send":"\u53D1\u9001","success":"\u4EA4\u6613\u6210\u529F\u53D1\u9001\uFF01\u4EA4\u6613\u53EF\u80FD\u9700\u8981\u4E00\u5206\u949F\u624D\u4F1A\u663E\u793A\u5728\u60A8\u7684\u8D26\u6237\u4E0A"},"subnavigation":{"activeDelegations":"\u8D28\u62BC\u8FDB\u884C\u4E2D","debondingDelegations":"\u8D28\u62BC\u53D6\u56DE\u4E2D","mobileActiveDelegations":"\u8D28\u62BC","mobileDebondingDelegations":"\u53D6\u56DE\u4E2D","transactions":"\u4EA4\u6613"},"summary":{"balance":{"available":"\u53EF\u7528","debonding":"\u53D6\u56DE\u4E2D","delegations":"\u8D28\u62BC","total":"\u603B\u989D"},"noTransactionFound":"\u4EA4\u6613\u65E0\u6CD5\u627E\u5230","noWalletIsOpen":"\u8F6C\u8D26\u3001\u63A5\u6536\u3001\u8D28\u62BC{{ticker}}\u4EE3\u5E01\uFF0C<HomeLink>\u6253\u5F00\u94B1\u5305</HomeLink>","notYourAccount":"\u8FD9\u4E0D\u662F\u60A8\u7684\u8D26\u6237"},"transaction":{"addEscrow":{"received":"\u63A5\u6536\u5230<Amount/>\u8D28\u62BC\u59D4\u6258","sent":"\u8D28\u62BC<Amount/>\u7ED9\u8282\u70B9"},"consensusDeposit":{"received":"\u6536\u5230<Amount/>\u5B58\u6B3E\u5230{{runtimeName}} ParaTime","sent":"\u5B58<Amount/>\u5230{{runtimeName}} ParaTime"},"consensusWithdraw":{"received":"\u4ECE{{runtimeName}}ParaTime\u53D6\u51FA<Amount/>","sent":"\u6536\u5230\u4ECE{{runtimeName}}ParaTime\u53D6\u51FA\u7684<Amount/>"},"explorerLink":"\u5728\u533A\u5757\u6D4F\u89C8\u5668\u67E5\u770B\u8F6C\u8D26\u8BB0\u5F55","failed":"\u5931\u8D25","genericTransaction":{"destination":"\u5176\u4ED6\u5730\u5740","header":"\u65B9\u6CD5\'{{method}}\'"},"loadingError":"\u65E0\u6CD5\u52A0\u8F7D\u4EA4\u6613","reclaimEscrow":{"received":"\u8D28\u62BC\u4EBA\u53D6\u56DE<Amount/>","sent":"\u4ECE\u8282\u70B9\u53D6\u56DE<Amount/>"},"stakingAllow":{"received":"\u6536\u5230<Amount/>\u914D\u989D","sent":"\u8BBE\u5B9A<Amount/>\u914D\u989D"},"successful":"\u6210\u529F","transfer":{"received":"\u6536\u5230<Amount/>","sent":{"header":"\u8F6C\u51FA<Amount/>"}},"unrecognizedTransaction":{"destination":"\u5176\u4ED6\u5730\u5740","header":"\u672A\u8BC6\u522B\u7684\u4EA4\u6613\uFF0C\u65B9\u6CD5 \u201C{{method}}\u201D"}},"validator":{"loadingError":"\u65E0\u6CD5\u52A0\u8F7D\u8282\u70B9","showingStale":"\u663E\u793A\u8282\u70B9\u5217\u8868{{staleTimestamp}}"}},"backends":{"oasisscan":"Oasis Scan API"},"banner":{"buildPreview":"\u6CE8\u610F\uFF1A\u8FD9\u662F ROSE \u94B1\u5305\u7684\u5B9E\u9A8C\u7248\u672C\uFF0C\u60A8\u7684\u673A\u5BC6\u4FE1\u606F\u4E0D\u5B89\u5168\u3002\u4EC5\u4F9B\u6D4B\u8BD5\u4F7F\u7528","buildStaging":"\u6CE8\u610F\uFF1A\u8FD9\u662F ROSE \u94B1\u5305\u7684\u6D4B\u8BD5\u73AF\u5883\u3002\u4EC5\u7528\u4E8E\u6D4B\u8BD5"},"common":{"amount":"\u91D1\u989D","block":"\u533A\u5757","cancel":"\u53D6\u6D88","confirm":"\u786E\u8BA4","delegator":"\u8D28\u62BC\u8005","from":"\u4ECE","hash":"\u4EA4\u6613\u54C8\u5E0C","round":"\u8F6E","time":"\u65F6\u95F4","to":"\u5230","unavailable":"\u4E0D\u53EF\u7528","validator":"\u8282\u70B9","validators":"\u8282\u70B9"},"createWallet":{"confirmSaved":"\u6211\u5DF2\u7ECF\u5B89\u5168\u5730\u5B58\u50A8\u4E86\u6211\u7684\u52A9\u8BB0\u8BCD","doNotShare":"\u6C38\u8FDC\u4E0D\u8981\u5206\u4EAB\u60A8\u7684\u52A9\u8BB0\u8BCD\uFF0C\u4EFB\u4F55\u4EBA\u62E5\u6709\u60A8\u7684\u52A9\u8BB0\u8BCD\u90FD\u53EF\u4EE5\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u548C\u4EE3\u5E01","instruction":"\u5C06\u60A8\u7684\u52A9\u8BB0\u8BCD<strong>\u6309\u6B63\u786E\u987A\u5E8F</strong>\u4FDD\u5B58\u5728\u5B89\u5168\u7684\u4F4D\u7F6E\uFF0C\u60A8\u5C06\u9700\u8981\u5B83\u6765\u6253\u5F00\u94B1\u5305","mnemonicMismatch":"\u52A9\u8BB0\u8BCD\u4E0D\u5339\u914D","newMnemonic":"\u751F\u6210\u65B0\u7684\u52A9\u8BB0\u8BCD","thisIsYourPhrase":"\u8FD9\u662F\u60A8\u7684\u52A9\u8BB0\u8BCD"},"delegations":{"activeDelegations":"\u8D28\u62BC\u8FDB\u884C\u4E2D","debondingDelegations":"\u8D28\u62BC\u53D6\u56DE\u4E2D","debondingTimeEnd":"\u8D28\u62BC\u53D6\u56DE\u7ED3\u675F","delegatedAmount":"\u8D28\u62BC\u989D","loadingError":"\u65E0\u6CD5\u8F7D\u5165\u8D28\u62BC","reclaimedAmount":"\u53D6\u56DE\u6570\u989D"},"deleteForm":{"confirm":"\u786E\u8BA4\u5220\u9664","confirmationKeyword":"\u5220\u9664","hint":"\u8F93\u5165 \u201C<strong>{{confirmationKeyword}}</strong>\u201D"},"errors":{"LedgerDerivedDifferentAccount":"\u8BE5\u8D26\u6237\u4E0D\u5C5E\u4E8E\u5F53\u524D\u8FDE\u63A5\u7684Ledger","LedgerOasisAppIsNotOpen":"Oasis \u5E94\u7528\u5728 Ledger \u4E0A\u5DF2\u5173\u95ED","bluetoothTransportNotSupported":"\u60A8\u7684\u8BBE\u5907\u4E0D\u652F\u6301\u84DD\u7259","cannotSendToSelf":"\u4E0D\u80FD\u53D1\u9001\u7ED9\u81EA\u5DF1","disconnectedError":"\u5931\u53BB\u8FDE\u63A5","duplicateTransaction":"\u91CD\u590D\u4EA4\u6613","indexerAPIError":"{{indexerName}}\u4F3C\u4E4E\u5DF2\u7ECF\u505C\u6B62\u5DE5\u4F5C\uFF0C\u4E00\u4E9B\u4FE1\u606F\u53EF\u80FD\u7F3A\u5C11\u6216\u8FC7\u65F6\uFF0C\u8BF7\u7A0D\u540E\u518D\u56DE\u6765","insufficientBalance":"\u4F59\u989D\u4E0D\u8DB3","invalidAddress":"\u65E0\u6548\u5730\u5740","invalidNonce":"\u65E0\u6548\u7684nonce\uFF08\u4EA4\u6613\u53F7\uFF09","invalidPrivateKey":"\u65E0\u6548\u7684\u79C1\u94A5","ledgerAppVersionNotSupported":"Oasis \u5E94\u7528\u5728 Ledger \u4E0A\u5DF2\u5173\u95ED\u6216\u672A\u66F4\u65B0\u3002\u8BF7\u786E\u4FDD Ledger \u5DF2\u89E3\u9501\uFF0COasis \u5E94\u7528\u5DF2\u6253\u5F00\u5E76\u66F4\u65B0\u81F3\u6700\u65B0\u7248\u672C","ledgerCannotOpenOasisApp":"\u65E0\u6CD5\u5728Ledger\u4E0A\u6253\u5F00Oasis\u5E94\u7528\u3002\u8BF7\u786E\u4FDDLedger\u5DF2\u89E3\u9501\u4E14Oasis\u5E94\u7528\u5DF2\u6253\u5F00","ledgerNoDeviceSelected":"\u672A\u9009\u62E9\u4EFB\u4F55Ledger\u8BBE\u5907\uFF0C\u8BF7\u786E\u4FDD\u5DF2\u8FDE\u63A5\uFF0C<LedgerHelp>\u68C0\u67E5Ledger\u5E38\u89C1\u7684USB\u8FDE\u63A5\u95EE\u9898</LedgerHelp>\uFF0C\u5E76<ChromeHelp>\u68C0\u67E5\u7F51\u7AD9\u6743\u9650\u662F\u5426\u963B\u6B62USB\u8BBE\u5907</ChromeHelp>","ledgerTransactionRejected":"\u4EA4\u6613\u5728Ledger\u4E0A\u88AB\u62D2\u7EDD","noOpenWallet":"\u672A\u6253\u5F00\u94B1\u5305","unknown":"\u672A\u77E5\u9519\u8BEF\uFF1A{{message}}","unknownGrpc":"\u672A\u77E5\u7684 gRPC \u9519\u8BEF: {{message}}","unknownLedgerError":"\u672A\u77E5\u8D26\u672C\u9519\u8BEF\uFF1A{{message}}","unknownParaTimeError":"\u672A\u77E5\u7684ParaTime\u9519\u8BEF\uFF1A{{message}}","usbTransportError":"USB\u4F20\u8F93\u9519\u8BEF\uFF1A{{message}}\u3002","usbTransportNotSupported":"\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301WebUSB\uFF08\u5982Firefox\uFF09\uFF0C\u8BF7\u4F7F\u7528Chrome\u518D\u8BD5"},"fatalError":{"copied":"\u9519\u8BEF\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F","copy":"\u590D\u5236\u9519\u8BEF\u5230\u526A\u8D34\u677F","heading":"\u53D1\u751F\u9519\u8BEF","instruction":"\u5C1D\u8BD5\u5237\u65B0\u9875\u9762\u5E76\u91CD\u65B0\u6253\u5F00\u94B1\u5305\uFF0C\u82E5\u95EE\u9898\u4ECD\u7136\u5B58\u5728\uFF0C\u8BF7\u901A\u8FC7<Email/>\u7535\u5B50\u90AE\u4EF6\u8054\u7CFB\u6211\u4EEC\u56E2\u961F\uFF0C\u5E76\u9644\u4E0A\u4E0B\u9762\u7684\u62A5\u544A"},"footer":{"github":"Oasis\u94B1\u5305\u662F\u5B8C\u5168<GithubLink>\u5F00\u6E90</GithubLink>\u7684\uFF0C\u6B22\u8FCE\u53CD\u9988\u95EE\u9898\uFF01","poweredBy":{"oasisscan":"\u7531 Oasis Scan API \u548C Oasis gRPC \u652F\u6301"},"terms":"<TermsLink>\u6761\u6B3E</TermsLink>","version":"\u7248\u672C\uFF1A <ReleaseLink/> \uFF08\u63D0\u4EA4\uFF1A <CommitLink/>\uFF09\u5728 {{buildTime}} \u6784\u5EFA"},"home":{"create":{"button":"\u521B\u5EFA\u94B1\u5305","description":"\u521B\u5EFA\u4E00\u4E2A\u65B0\u94B1\u5305\u6765\u53D1\u9001\u3001\u63A5\u6536\u3001\u8D28\u62BC\u53CA\u4EA4\u6613ROSE\u4EE3\u5E01","header":"\u521B\u5EFA\u65B0\u94B1\u5305"},"existing":{"button":"\u6253\u5F00\u94B1\u5305","description":"\u6253\u5F00\u5B58\u50A8\u5728Ledger\u4E0A\u7684\u73B0\u6709\u94B1\u5305\uFF0C\u5BFC\u5165\u79C1\u94A5\u6216\u52A9\u8BB0\u8BCD","header":"\u8BBF\u95EE\u73B0\u6709\u94B1\u5305"}},"icons":{"mnemonic":"\u52A9\u8BB0\u8BCD","privateKey":"\u79C1\u94A5","wallet":{"label":"\u94B1\u5305"}},"infoBox":{"valueCopied":"{{label}}\u5DF2\u590D\u5236"},"language":"\u8BED\u8A00","ledger":{"extension":{"connect":"\u8FDE\u63A5Ledger\u8BBE\u5907","failed":"\u8FDE\u63A5\u5931\u8D25","grantAccess":"\u6388\u4E88 Ledger \u8BBF\u95EE\u6743\u9650","instructionStep":"\u8BBE\u5907\u8FDE\u63A5\u540E\uFF0C\u7EE7\u7EED\u5728\u94B1\u5305\u5E94\u7528\u4E2D\u8FDB\u884C\u64CD\u4F5C","succeed":"\u8BBE\u5907\u5DF2\u8FDE\u63A5"},"instructionSteps":{"closeLedgerLive":"\u5173\u95ED\u7535\u8111\u4E0A\u7684Ledger Live\u5E94\u7528","connectUsbLedger":"\u8FDE\u63A5\u60A8\u7684USB Ledger\u8BBE\u5907\u5230\u7535\u8111","header":"\u6B65\u9AA4\uFF1A","openOasisApp":"\u6253\u5F00Ledger\u8BBE\u5907\u4E0A\u7684Oasis\u5E94\u7528"},"steps":{"idle":"\u95F2\u7F6E","loadingAccounts":"\u6B63\u5728\u52A0\u8F7D\u5E10\u6237\u4FE1\u606F","loadingBalances":"\u6B63\u5728\u52A0\u8F7D\u4F59\u989D\u8BE6\u60C5","loadingBluetoothDevices":"\u6B63\u5728\u52A0\u8F7D\u84DD\u7259\u8BBE\u5907","openingUsb":"\u6B63\u5728\u901A\u8FC7USB\u6253\u5F00Ledger"}},"menu":{"addAccounts":"\u6DFB\u52A0\u8D26\u6237","closeWallet":"\u5173\u95ED\u94B1\u5305","home":"\u4E3B\u9875","lockProfile":"\u9501\u5B9A\u4E2A\u4EBA\u8D44\u6599","openMenu":"\u83DC\u5355","paraTimes":"ParaTimes","stake":"\u8D28\u62BC","stake-mobile":"\u8D28\u62BC","unlockProfile":"\u89E3\u9501\u4E2A\u4EBA\u8D44\u6599","wallet":"\u94B1\u5305"},"migrateV0Extension":{"backupInvalidPrivateKeys":{"confirm":"\u6211\u5DF2\u7ECF\u5B89\u5168\u5730\u5B58\u50A8\u4E86\u6211\u7684\u79C1\u94A5","description":"{{count}}\u4E2A\u79C1\u94A5\u5B58\u5728\u62FC\u5199\u9519\u8BEF\uFF0C\u65B0\u7684\u94B1\u5305\u6269\u5C55\u7A0B\u5E8F\u5C06\u4E0D\u4F1A\u5B58\u50A8\u5B83\u4EEC\u3002\u5728\u7EE7\u7EED\u4E4B\u524D\uFF0C\u8BF7\u786E\u4FDD\u5C06\u5C06\u5176\u590D\u5236\u5E76\u5B58\u50A8\u5728\u5176\u4ED6\u5730\u65B9\uFF0C\u4EE5\u4FBF\u7A0D\u540E\u66F4\u6B63","description_one":"1 \u4E2A\u79C1\u94A5\u5B58\u5728\u62FC\u5199\u9519\u8BEF\uFF0C\u65B0\u7684\u94B1\u5305\u6269\u5C55\u7A0B\u5E8F\u5C06\u4E0D\u4F1A\u5B58\u50A8\u5B83\u4EEC\u3002\u5728\u7EE7\u7EED\u4E4B\u524D\uFF0C\u8BF7\u786E\u4FDD\u5C06\u5C06\u5176\u590D\u5236\u5E76\u5B58\u50A8\u5728\u5176\u4ED6\u5730\u65B9\uFF0C\u4EE5\u4FBF\u7A0D\u540E\u66F4\u6B63","description_plural":"{{count}}\u4E2A\u79C1\u94A5\u5B58\u5728\u62FC\u5199\u9519\u8BEF\uFF0C\u65B0\u7684\u94B1\u5305\u6269\u5C55\u7A0B\u5E8F\u5C06\u4E0D\u4F1A\u5B58\u50A8\u5B83\u4EEC\u3002\u5728\u7EE7\u7EED\u4E4B\u524D\uFF0C\u8BF7\u786E\u4FDD\u5C06\u5C06\u5176\u590D\u5236\u5E76\u5B58\u50A8\u5728\u5176\u4ED6\u5730\u65B9\uFF0C\u4EE5\u4FBF\u7A0D\u540E\u66F4\u6B63","reveal":"\u70B9\u51FB\u4EE5\u663E\u793A\u65E0\u6548\u7684\u79C1\u94A5"},"backupMnemonic":{"description":"\u65B0\u7248\u672C\u7684\u94B1\u5305\u6269\u5C55\u5E94\u7528\u5C06\u4E0D\u518D\u5B58\u50A8\u60A8\u7684\u52A9\u8BB0\u8BCD\u3002\u5982\u679C\u60A8\u4E22\u5931\u8BBF\u95EE\u6743\u9650\uFF0C\u8BE5\u52A9\u8BB0\u8BCD\u662F\u6062\u590D\u60A8\u7684\u8D26\u6237\u7684\u552F\u4E00\u65B9\u5F0F\u3002\u73B0\u5728\u60A8\u6709\u6700\u540E\u4E00\u6B21\u673A\u4F1A\u5907\u4EFD\u60A8\u7684\u52A9\u8BB0\u8BCD\u3002","reveal":"\u70B9\u51FB\u663E\u793A\u60A8\u7684\u52A9\u8BB0\u8BCD"},"finishMigration":"\u6253\u5F00\u94B1\u5305\u7684\u65B0\u7248\u672C","nextStep":"\u4E0B\u4E00\u6B65","requiredField":"\u6B64\u680F\u4E3A\u5FC5\u586B\u9879","title":"\u91CD\u8981\u7684\u94B1\u5305\u66F4\u65B0"},"openWallet":{"bitpie":{"warning":"\u2757 BitPie\u94B1\u5305\u7528\u6237\u6CE8\u610F\uFF1A\u60A8\u4E0D\u80FD\u76F4\u63A5\u4ECEBitPie\u94B1\u5305\u5BFC\u5165\u52A9\u8BB0\u8BCD\u3002 <DocsLink>\u8BF7\u67E5\u770B\u6587\u6863\u4EE5\u83B7\u53D6\u8BE6\u7EC6\u4FE1\u606F\u3002</DocsLink>"},"header":"\u60A8\u60F3\u5982\u4F55\u6253\u5F00\u94B1\u5305\uFF1F","importAccounts":{"accountCounter":"{{count}}\u4E2A\u8D26\u6237\u5DF2\u9009\u62E9","accountCounter_one":"\u4E00\u4E2A\u8D26\u6237\u88AB\u9009\u4E2D","accountCounter_plural":"{{count}}\u4E2A\u8D26\u6237\u5DF2\u9009\u62E9","accountCounter_zero":"\u672A\u9009\u62E9\u5E10\u6237","next":"\u4E0B\u4E00\u6B65","openWallets":"\u6253\u5F00","pageNumber":"\u7B2C {{pageNum}} \u9875\uFF0C\u5171 {{totalPages}} \u9875","prev":"\u4E0A\u4E00\u9875","selectWallets":"\u9009\u62E9\u8981\u6253\u5F00\u7684\u8D26\u6237"},"ledger":{"header":"\u4ECELedger\u8BBE\u5907\u6253\u5F00"},"method":{"ledger":"Ledger","mnemonic":"\u52A9\u8BB0\u8BCD","privateKey":"\u79C1\u94A5"},"mnemonic":{"enterPhraseHere":"\u8F93\u5165\u60A8\u7684\u52A9\u8BB0\u8BCD","error":"\u65E0\u6548\u7684\u52A9\u8BB0\u8BCD\uFF0C\u8BF7\u786E\u4FDD\u987A\u5E8F\u6B63\u786E\u4E14\u6240\u6709\u5B57\u6BCD\u5747\u4E3A\u5C0F\u5199","header":"\u8F93\u5165\u60A8\u7684\u52A9\u8BB0\u8BCD","import":"\u5BFC\u5165\u6211\u7684\u94B1\u5305","instruction":"\u8F93\u5165\u52A9\u8BB0\u8BCD\uFF0C\u7528\u7A7A\u683C\u5206\u9694\u3002\u5927\u90E8\u5206\u52A9\u8BB0\u8BCD\u753124\u4E2A\u621612\u4E2A\u5355\u8BCD\u7EC4\u6210"},"privateKey":{"enterPrivateKeyHere":"\u8F93\u5165\u60A8\u7684\u79C1\u94A5","error":"\u65E0\u6548\u7684\u79C1\u94A5","header":"\u8F93\u5165\u60A8\u7684\u79C1\u94A5","hidePrivateKey":"\u9690\u85CF\u79C1\u94A5","instruction":"\u8F93\u5165Base64\u683C\u5F0F\u7684\u79C1\u94A5","showPrivateKey":"\u663E\u793A\u79C1\u94A5"}},"paraTimes":{"amount":{"advanced":"\u9AD8\u7EA7","available":"\u53EF\u7528\uFF1A","depositDescription":"\u8BF7\u8F93\u5165\u8981\u5B58\u5165\u7684{{ticker}}\u91D1\u989D\uFF0C\u7136\u540E\u70B9\u51FB\\"{{nextButtonLabel}}\\"\u3002","emptyAccount":"\u8D26\u6237\u662F\u7A7A\u7684\u3002\u65E0\u91D1\u989D\u53EF\u63D0\u53D6\u3002","feeAmountPlaceholder":"\u8D39\u7528\u91D1\u989D\uFF08\u5341\u4EBF\u5206\u4E4B\u4E00 {{ticker}}\uFF09","feeGasPlaceholder":"Gas\u8D39","max":"\u6700\u5927","tooltip":"\u6700\u5927\u503C\u6216\u56E0\u8D39\u7528\u800C\u51CF\u5C11","withdrawDescription":"\u8BF7\u8F93\u5165\u8981\u63D0\u53D6\u7684{{ticker}}\u91D1\u989D\uFF0C\u7136\u540E\u70B9\u51FB\\"{{nextButtonLabel}}\\""},"common":{"cipher":"Cipher","emerald":"Emerald","evmcType":"(EVMc)","header":"ParaTime\u8F6C\u8D26","sapphire":"Sapphire"},"confirmation":{"confirmDepositDescription":"\u8BF7\u786E\u8BA4\u5B58\u6B3E\u91D1\u989D\u548C\u6536\u6B3E\u5730\u5740\u6B63\u786E\uFF0C\u7136\u540E\u70B9\u51FB\u201C{{nextButtonLabel}}\u201D","confirmDepositToForeignAccountDescription":"\u76EE\u6807\u5730\u5740\u4E0E\u60A8\u94B1\u5305\u4E2D\u7684\u4EFB\u4F55\u5E10\u6237\u4E0D\u5339\u914D\uFF01\u4E00\u4E9B\u670D\u52A1\uFF08\u5982\u4EA4\u6613\u6240\uFF09\u53EF\u80FD\u4E0D\u652F\u6301\u76F4\u63A5\u5B58\u6B3E\u6765\u5230\u60A8\u7684\u5E10\u6237\u3002\u4E3A\u4E86\u66F4\u597D\u7684\u517C\u5BB9\u6027\uFF0C\u6211\u4EEC\u5F3A\u70C8\u5EFA\u8BAE\u60A8\u9996\u5148\u5B58\u5165\u60A8\u7684ParaTime\u5E10\u6237\uFF0C\u7136\u540E\u5C06{{ticker}}\u8F6C\u79FB\u5230\u76EE\u6807\u5730\u5740\u3002","confirmTransferLabel":"\u6211\u786E\u8BA4\u91D1\u989D\u548C\u5730\u5740\u662F\u6B63\u786E\u7684","confirmTransferToForeignAccount":"\u6211\u786E\u8BA4\u6211\u60F3\u76F4\u63A5\u63D0\u53D6\u5230\u5916\u90E8\u8D26\u6237","confirmTransferToValidatorLabel":"\u6211\u786E\u8BA4\u6211\u60F3\u8F6C\u8D26{{ticker}}\u5230\u8282\u70B9\u5730\u5740","confirmWithdrawDescription":"\u8BF7\u786E\u8BA4\u63D0\u6B3E\u91D1\u989D\u548C\u6536\u6B3E\u5730\u5740\u6B63\u786E\uFF0C\u7136\u540E\u70B9\u51FB\u201C{{nextButtonLabel}}\u201D","confirmWithdrawToForeignAccountDescription":"\u76EE\u6807\u5730\u5740\u4E0E\u60A8\u94B1\u5305\u4E2D\u7684\u5E10\u6237\u4E0D\u5339\u914D\uFF01\u4E00\u4E9B\u670D\u52A1\uFF08\u5982\u4EA4\u6613\u6240\uFF09\u53EF\u80FD\u4E0D\u652F\u6301\u76F4\u63A5\u63D0\u53D6\u8D44\u91D1\u5230\u8BE5\u5E10\u6237\u3002\u4E3A\u4E86\u66F4\u597D\u7684\u517C\u5BB9\u6027\uFF0C\u6211\u4EEC\u5F3A\u70C8\u5EFA\u8BAE\u60A8\u5148\u63D0\u53D6\u5230\u60A8\u7684\u5171\u8BC6\u5C42\u8D26\u6237\uFF0C\u7136\u540E\u5C06{{ticker}}\u8F6C\u8D26\u5230\u76EE\u6807\u5730\u5740","depositDescription":"\u60A8\u5373\u5C06\u5728<strong>{{paraTime}}</strong> {{paratimeType}}\u5C06<strong>{{value}} {{ticker}}</strong>\u5B58\u5165<strong>{{address}}</strong>\u3002","depositLabel":"\u5B58\u6B3E","withdrawDescription":"\u60A8\u5373\u5C06\u4ECE<strong>{{paraTime}}</strong>{{paratimeType}}\u63D0\u53D6<strong>{{value}} {{ticker}}</strong>\u5230<strong>{{address}}</strong>","withdrawLabel":"\u53D6\u56DE"},"error":{"depositDescription":"\u4EA4\u6613\u5931\u8D25\u3002\u6211\u4EEC\u65E0\u6CD5\u5B8C\u6210\u5728 <strong>{{paraTime}}</strong>{{paratimeType}}\u4E0A\u8F6C\u8D26\u5230<strong>{{address}}</strong>\u7684<strong>{{value}}{{ticker}}</strong>\u7684\u5B58\u5165\u4EA4\u6613","withdrawDescription":"\u4EA4\u6613\u5931\u8D25\u3002\u6211\u4EEC\u65E0\u6CD5\u5B8C\u6210\u5728<strong>{{paraTime}}</strong>{{paratimeType}}\u4E0A\u8F6C\u8D26\u5230<strong>{{address}}</strong>\u7684<strong>{{value}}{{ticker}}</strong>\u7684\u53D6\u56DE\u4EA4\u6613"},"footer":{"back":"\u540E\u9000","next":"\u524D\u8FDB","notice":"* EVMc - \u517C\u5BB9\u4EE5\u592A\u574A\u865A\u62DF\u673A"},"pageInaccessible":{"foreignAccount":"\u8F6C\u8D26\u4E0D\u53EF\u7528","ledgerAccount":"\u6682\u4E0D\u652F\u6301Ledger\u8D26\u6237"},"recipient":{"depositDescription":"\u8BF7\u5728<strong>{{paraTime}}</strong> {{paratimeType}}\u4E0A\u8F93\u5165\u6536\u6B3E\u5730\u5740\uFF0C\u7136\u540E\u70B9\u51FB\u201C{{nextButtonLabel}}\u201D","ethPrivateKeyPlaceholder":"\u8F93\u5165\u4EE5\u592A\u574A\u517C\u5BB9\u7684\u79C1\u94A5","evmcWithdrawDescription":"\u8BF7\u8F93\u5165ParaTime\u4E0A\u7684\u8D26\u6237\u79C1\u94A5\uFF0C\u5728\u5171\u8BC6\u5C42\u4E0A\u7684\u63A5\u6536\u5730\u5740\uFF0C\u7136\u540E\u70B9\u51FB\\"{{nextButtonLabel}}\\"","placeholder":"0x...","withdrawDescription":"\u8BF7\u8F93\u5165\u5728\u5171\u8BC6\u5C42\u4E0A\u7684\u6536\u6B3E\u5730\u5740\u5E76\u70B9\u51FB\\"{{nextButtonLabel}}\\""},"selection":{"cancel":"\u53D6\u6D88\u8F6C\u8D26","depositDescription":"\u8BF7\u9009\u62E9\u60A8\u5E0C\u671B\u5C06{{ticker}}\u5B58\u5165\u7684ParaTime\uFF0C\u7136\u540E\u70B9\u51FB\\"{{nextButtonLabel}}\\"","evmc":"EVMc","select":"\u9009\u62E9\u4E00\u4E2AParaTime","withdrawDescription":"\u8BF7\u9009\u62E9\u60A8\u5E0C\u671B\u4ECE\u54EA\u4E2AParaTime\u63D0\u53D6{{ticker}}\uFF0C\u7136\u540E\u70B9\u51FB\\"{{nextButtonLabel}}\\""},"summary":{"depositDescription":"\u60A8\u5DF2\u6210\u529F\u5728<strong>{{paraTime}}</strong>{{paratimeType}}\u4E0A\u5B58\u5165<strong>{{value}}{{ticker}}</strong>\u81F3<strong>{{address}}</strong> ","navigate":"\u8DF3\u8F6C\u5230ParaTime\u8F6C\u8D26","withdrawDescription":"\u60A8\u5DF2\u6210\u529F\u4ECE<strong>{{paraTime}}</strong> {{paratimeType}}\u63D0\u53D6<strong>{{value}} {{ticker}}</strong>\u81F3<strong>{{address}}</strong>"},"transfers":{"deposit":"\u5B58\u5230ParaTime","depositDisabled":"\u60A8\u6CA1\u6709\u4EFB\u4F55{{ticker}}\u4EE3\u5E01\u53EF\u8F6C\u79FB","description":"\u70B9\u51FB\u201C{{depositButtonLabel}}\u201D\u6309\u94AE\uFF0C\u5C06\u60A8\u7684{{ticker}}\u4ECE\u5171\u8BC6\u5C42\u5B58\u5165\u60A8\u9009\u62E9\u7684ParaTime\uFF0C\u6216\u70B9\u51FB\u201C{{withdrawButtonLabel}}\u201D\u6309\u94AE\uFF0C\u5C06\u60A8\u7684{{ticker}}\u4ECEParaTime\u53D6\u56DE\u5230\u5171\u8BC6\u5C42\u3002","withdraw":"\u4ECEParaTime\u53D6\u56DE"},"unsupportedFormStep":"\u4E0D\u652F\u6301\u7684\u8868\u5355\u6B65\u9AA4","validation":{"insufficientBalanceToPayFee":"\u4F59\u989D\u4E0D\u8DB3\u4EE5\u652F\u4ED8\u8D39\u7528","invalidDecimalValue":"\u6700\u591A\u5141\u8BB8{{decimals}}\u4F4D\u5C0F\u6570","invalidEthPrivateKey":"\u4EE5\u592A\u574A\u517C\u5BB9\u79C1\u94A5\u65E0\u6548","invalidEthPrivateKeyLength":"\u79C1\u94A5\u9700\u4E3A64\u4E2A\u5B57\u7B26\u957F\u5EA6","invalidFee":"\u503C\u5FC5\u987B\u662F\u5927\u4E8E\u6216\u7B49\u4E8E0\u7684\u6574\u6570","required":"\u680F\u4E3A\u5FC5\u586B","unsupportedParaTime":"\u4E0D\u652F\u6301\u7684ParaTime"}},"persist":{"createProfile":{"choosePassword":"\u9009\u62E9\u4E00\u4E2A\u5BC6\u7801","passwordMismatch":"\u8F93\u5165\u7684\u5BC6\u7801\u4E0D\u5339\u914D","repeatPassword":"\u91CD\u65B0\u8F93\u5165\u60A8\u7684\u5BC6\u7801","startPersisting":"\u672C\u5730\u5B58\u50A8\u79C1\u94A5\uFF0C\u901A\u8FC7\u5BC6\u7801\u4FDD\u62A4","unsupported":"Persistence \u5728\u6B64\u6D4F\u89C8\u5668\u4E2D\u4E0D\u53D7\u652F\u6301 "},"loading":"\u52A0\u8F7D\u4E2D","loginToProfile":{"deleteProfile":{"button":"\u5220\u9664\u4E2A\u4EBA\u8D44\u6599","description":"\u6B64\u64CD\u4F5C\u65E0\u6CD5\u64A4\u9500\uFF0C\u5E76\u5C06<strong>\u64E6\u9664\u60A8\u7684\u79C1\u94A5</strong>\u3002<br/><br/>\u8981\u7EE7\u7EED\uFF0C\u8BF7\u5728\u4E0B\u65B9\u8F93\u5165\u201C<strong>{{confirmationKeyword}}</strong>\u201D\u3002","title":"\u5220\u9664\u4E2A\u4EBA\u8D44\u6599"},"description":"\u767B\u5F55\u60A8\u5728\u6B64\u8BA1\u7B97\u673A\u4E0A\u7684\u73B0\u6709\u7528\u6237\u6863\u6848\uFF0C\u4EE5\u8BBF\u95EE\u60A8\u5DF2\u6DFB\u52A0\u7684\u94B1\u5305\u3002","enterPasswordHere":"\u5728\u6B64\u8F93\u5165\u5BC6\u7801","hidePassword":"\u9690\u85CF\u5BC6\u7801","showPassword":"\u663E\u793A\u5BC6\u7801","skipUnlocking":"\u8DF3\u8FC7\u4E2A\u4EBA\u8D44\u6599\uFF0C\u7EE7\u7EED","title":"\u6B22\u8FCE\u56DE\u6765\uFF01","unlock":"\u89E3\u9501","wrongPassword":"\u5BC6\u7801\u9519\u8BEF"}},"theme":{"darkMode":"\u9ED1\u591C\u6A21\u5F0F","lightMode":"\u6D45\u8272\u6A21\u5F0F","title":"\u4E3B\u9898"},"toolbar":{"contacts":{"add":"\u6DFB\u52A0\u8054\u7CFB\u4EBA","address":"\u5730\u5740","cancel":"\u53D6\u6D88","delete":{"button":"\u5220\u9664\u8054\u7CFB\u4EBA","confirm":"\u786E\u8BA4\u5220\u9664","description":"\u786E\u5B9A\u8981\u5220\u9664\u8FD9\u4E2A\u8054\u7CFB\u4EBA\u5417\uFF1F","title":"\u5220\u9664\u8054\u7CFB\u4EBA"},"emptyList":"\u672A\u6DFB\u52A0\u8054\u7CFB\u4EBA","manage":"\u7BA1\u7406\u8054\u7CFB\u4EBA","name":"\u540D\u79F0","notAvailable":"\u5F00\u59CB\u6DFB\u52A0\u8054\u7CFB\u4EBA\u65F6\uFF0C\u8BF7\u5728<OpenWalletButton>\u6253\u5F00\u94B1\u5305</OpenWalletButton>\u65F6\u521B\u5EFA\u4E2A\u4EBA\u8D44\u6599\u3002","save":"\u4FDD\u5B58","validation":{"addressError":"\u8BF7\u8F93\u5165\u4E00\u4E2A\u6709\u6548\u7684\u94B1\u5305\u5730\u5740","addressNotUniqueError":"\u5730\u5740\u5DF2\u5B58\u5728","nameLengthError":"\u4E0D\u8D85\u8FC716\u4E2A\u5B57\u7B26","required":"\u680F\u4E3A\u5FC5\u586B"}},"networks":{"local":"\u672C\u5730","mainnet":"\u4E3B\u7F51","selector":"\u9009\u62E9\u7F51\u7EDC","testnet":"\u6D4B\u8BD5\u7F51"},"profile":{"deletion":"\u5220\u9664","notAvailable":"\u60A8\u53EF\u4EE5\u5728<OpenWalletButton>\u6253\u5F00\u94B1\u5305</OpenWalletButton>\u65F6\u8BBE\u7F6E\u4E2A\u4EBA\u8D44\u6599","password":{"current":"\u5F53\u524D\u5BC6\u7801","enterCurrent":"\u8F93\u5165\u60A8\u5F53\u524D\u7684\u5BC6\u7801","enterNewPassword":"\u65B0\u5BC6\u7801","reenterNewPassword":"\u91CD\u65B0\u8F93\u5165\u65B0\u5BC6\u7801","submit":"\u66F4\u65B0\u5BC6\u7801","success":"\u5BC6\u7801\u5DF2\u66F4\u65B0","title":"\u8BBE\u7F6E\u4E00\u4E2A\u65B0\u5BC6\u7801"}},"settings":{"accountNamingNotAvailable":"\u547D\u540D\u8D26\u6237\u65F6\uFF0C\u8BF7\u521B\u5EFA\u4E2A\u4EBA\u8D44\u6599\uFF0C\u540C\u65F6<OpenWalletButton>\u6253\u5F00\u94B1\u5305</OpenWalletButton>","cancel":"\u53D6\u6D88","contacts":"\u8054\u7CFB\u4EBA","delete":{"description":"\u60A8\u786E\u5B9A\u8981\u5220\u9664\u4EE5\u4E0B\u8D26\u6237\u5417\uFF1F","inputHelp":"\u6B64\u64CD\u4F5C\u65E0\u6CD5\u64A4\u9500\u3002\u82E5\u8981\u7EE7\u7EED\uFF0C\u8BF7\u5728\u4E0B\u65B9\u8F93\u5165\u201C<strong>{{confirmationKeyword}}</strong>\u201D","title":"\u5220\u9664\u8D26\u6237","tooltip":"\u4F60\u5FC5\u987B\u59CB\u7EC8\u62E5\u6709\u81F3\u5C11\u4E00\u4E2A\u8D26\u6237"},"exportPrivateKey":{"confirm":"\u660E\u767D\uFF0C\u663E\u793A\u6211\u7684\u79C1\u94A5","copied":"\u79C1\u94A5\u5DF2\u590D\u5236","hint1":"\u79C1\u94A5\u7531\u4E00\u4E32\u5B57\u7B26\u7EC4\u6210\uFF0C\u62E5\u6709\u79C1\u94A5\u4EFB\u4F55\u7684\u4EBA\u90FD\u53EF\u4EE5\u76F4\u63A5\u8BBF\u95EE\u8BE5\u8D26\u6237\u7684\u8D44\u4EA7\u3002","hint2":"\u4E00\u65E6\u79C1\u94A5\u4E22\u5931\uFF0C\u5C06\u65E0\u6CD5\u627E\u56DE\u3002\u8BF7\u786E\u4FDD\u5907\u4EFD\u79C1\u94A5\u5E76\u5C06\u5176\u4FDD\u5B58\u5728\u5B89\u5168\u7684\u5730\u65B9\u3002","title":"\u5BFC\u51FA\u79C1\u94A5"},"manageAccount":"\u7BA1\u7406","myAccountsTab":"\u6211\u7684\u8D26\u6237","nameLengthError":"\u4E0D\u8D85\u8FC716\u4E2A\u5B57\u7B26","optionalName":"\u540D\u79F0\uFF08\u975E\u5FC5\u586B\uFF09","profile":"\u4E2A\u4EBA\u8D44\u6599","save":"\u4FDD\u5B58","settings":"\u8BBE\u7F6E"},"wallets":{"select":"\u9009\u62E9"}},"transaction":{"cancel":"\u53D6\u6D88","confirm":"\u786E\u8BA4","preview":{"amount":"\u91D1\u989D","fee":"\u8D39\u7528","from":"\u4ECE","gas":"Gas","genesisHash":"\u521B\u4E16\u54C8\u5E0C","to":"\u81F3","type":"\u7C7B\u578B","validator":"\u8282\u70B9","warning":"\u4E00\u65E6\u60A8\u786E\u8BA4\u6B64\u4EA4\u6613\uFF0C\u60A8\u5C06\u65E0\u6CD5\u53D6\u6D88\u3002\u8BF7\u4ED4\u7EC6\u5BA1\u67E5\uFF0C\u786E\u4FDD\u65E0\u8BEF\u540E\u786E\u8BA4\u53D1\u9001\u3002"},"step":{"building":"\u5EFA\u7ACB\u4EA4\u6613\u4E2D","preview":"\u9884\u89C8\u4EA4\u6613","signing":"\u7B7E\u7F72\u4EA4\u6613\u4E2D","submitting":"\u63D0\u4EA4\u4EA4\u6613\u4E2D"},"types":{"addEscrow":"\u8D28\u62BC\u4EE3\u5E01\u5230\u8282\u70B9\u5E76\u83B7\u5F97\u5956\u52B1","reclaimEscrow":"\u53D6\u56DE\u8D28\u62BC\u5728\u8282\u70B9\u7684\u4EE3\u5E01","transfer":"\u4ECE\u60A8\u7684\u8D26\u6237\u53D1\u9001\u4EE3\u5E01\u5230\u5176\u4ED6\u8D26\u6237"}},"validator":{"boundsNotSet":"\u6CA1\u6709\u8BBE\u7F6E\u8FB9\u754C\uFF080% - 100%\uFF09","commission":"\u4F63\u91D1","commissionBounds":{"current":"<strong>{{lowerBound}}% - {{upperBound}}%</strong> \u5728\u5F53\u524D Epoch {{epoch}}","future":"{{lowerBound}}% - {{upperBound}}% \u4ECE Epoch {{epoch}} \u5F00\u59CB","label":"\u4F63\u91D1\u8303\u56F4"},"escrow":"\u6258\u7BA1","fee":"\u8D39\u7528","name":"\u540D\u79F0","rank":"\u7B49\u7EA7","status":"\u72B6\u6001","statusActive":"\u6D3B\u8DC3","statusInactive":"\u505C\u7528","statusUnknown":"\u672A\u77E5","totalEscrow":"\u603B\u6258\u7BA1\u989D","unknownValidator":"\u672A\u77E5\u7684\u8282\u70B9"}}');

},{}],"fuHzr":[function() {},{}],"yuQiW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "routes", ()=>routes);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _app = require("app");
var _openWalletPage = require("app/pages/OpenWalletPage");
var _commonRoutes = require("./commonRoutes");
var _fromLedger = require("./app/pages/OpenWalletPage/Features/FromLedger");
const routes = [
    {
        path: '/*',
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _app.App), {}),
        children: [
            ...(0, _commonRoutes.commonRoutes),
            {
                path: 'open-wallet',
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _openWalletPage.OpenWalletPage), {})
            },
            {
                path: 'open-wallet/ledger',
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fromLedger.FromLedger), {})
            }
        ]
    }
];

},{"react/jsx-runtime":"6pm7f","react":"8CCva","app":"ltYdh","app/pages/OpenWalletPage":"bH0UT","./commonRoutes":"4sM6J","./app/pages/OpenWalletPage/Features/FromLedger":"lRLtj","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ltYdh":[function(require,module,exports,__globalThis) {
/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "App", ()=>App);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("grommet/es6/components/Box");
var _main = require("grommet/es6/components/Main");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _react = require("react");
var _reactHelmetAsync = require("react-helmet-async");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _fatalErrorHandler = require("./components/FatalErrorHandler");
var _pageFooter = require("./components/Footer/PageFooter");
var _sidebar = require("./components/Sidebar");
var _toolbar = require("./components/Toolbar");
var _modal = require("./components/Modal");
var _useRouteRedirects = require("./useRouteRedirects");
var _persistLoadingGate = require("app/components/Persist/PersistLoadingGate");
var _unlockGate = require("app/components/Persist/UnlockGate");
var _buildBanner = require("app/components/BuildBanner");
var _ionicNativePlatformProvider = require("./components/Ionic/components/IonicNativePlatformProvider");
function App() {
    (0, _useRouteRedirects.useRouteRedirects)();
    const { i18n } = (0, _reactI18Next.useTranslation)();
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fatalErrorHandler.FatalErrorHandler), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ionicNativePlatformProvider.IonicNativePlatformProvider), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _modal.ModalProvider), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHelmetAsync.Helmet), {
                        titleTemplate: "%s - ROSE Wallet",
                        defaultTitle: "ROSE Wallet",
                        htmlAttributes: {
                            lang: i18n.language
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                            name: "description",
                            content: "A wallet for Oasis"
                        })
                    }),
                    !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildBanner.BuildBanner), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        direction: "row-responsive",
                        background: "background-back",
                        fill: true,
                        style: {
                            minHeight: '100dvh'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _persistLoadingGate.PersistLoadingGate), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _unlockGate.UnlockGate), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.Navigation), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                        flex: true,
                                        pad: {
                                            top: isMobile ? '64px' : undefined
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _main.Main), {
                                            children: [
                                                isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildBanner.BuildBanner), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _toolbar.Toolbar), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Outlet), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageFooter.PageFooter), {})
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Box":"4o01A","grommet/es6/components/Main":"2Yqxq","grommet/es6/contexts/ResponsiveContext":"7EsNN","react":"8CCva","react-helmet-async":"vfvPp","react-i18next":"7GUHL","react-router-dom":"9pTjq","./components/FatalErrorHandler":"kJa2L","./components/Footer/PageFooter":"bDcgi","./components/Sidebar":"5xMev","./components/Toolbar":"cWbYg","./components/Modal":"3R41W","./useRouteRedirects":"aE6Lf","app/components/Persist/PersistLoadingGate":"2IxRw","app/components/Persist/UnlockGate":"giF2b","app/components/BuildBanner":"jZ0S8","./components/Ionic/components/IonicNativePlatformProvider":"ebtkn","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4o01A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Box", ()=>(0, _box.Box));
var _box = require("./Box");

},{"./Box":"cCDso","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cCDso":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Box", ()=>Box);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _utils = require("../../utils");
var _keyboard = require("../Keyboard");
var _styledBox = require("./StyledBox");
var _propTypes = require("./propTypes");
var _skeleton = require("../Skeleton");
var _announceContext = require("../../contexts/AnnounceContext");
var _optionsContext = require("../../contexts/OptionsContext");
var _contexts = require("../../contexts");
var _responsiveContainerProvider = require("./ResponsiveContainerProvider");
var _useThemeValue = require("../../utils/useThemeValue");
var _responsive = require("../../utils/responsive");
var _excluded = [
    "a11yTitle",
    "background",
    "border",
    "children",
    "cssGap",
    "direction",
    "elevation",
    "fill",
    "gap",
    "kind",
    "onBlur",
    "onClick",
    "onFocus",
    "overflow",
    "responsive",
    "tag",
    "as",
    "wrap",
    "width",
    "height",
    "tabIndex",
    "skeleton"
], _excluded2 = [
    "colors",
    "size"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var Box = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, refProp) {
    var a11yTitle = _ref.a11yTitle, backgroundProp = _ref.background, border = _ref.border, children = _ref.children, cssGap = _ref.cssGap, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? 'column' : _ref$direction, elevation = _ref.elevation, fill = _ref.fill, gap = _ref.gap, kind = _ref.kind, _onBlur = _ref.onBlur, onClick = _ref.onClick, _onFocus = _ref.onFocus, overflow = _ref.overflow, _ref$responsive = _ref.responsive, responsiveProp = _ref$responsive === void 0 ? true : _ref$responsive, tag = _ref.tag, as = _ref.as, wrap = _ref.wrap, width = _ref.width, height = _ref.height, tabIndex = _ref.tabIndex, skeletonProp = _ref.skeleton, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme, passThemeFlag = _useThemeValue1.passThemeFlag;
    // boxOptions was created to preserve backwards compatibility but
    // should not be supported in v3
    var _useContext = (0, _react.useContext)((0, _optionsContext.OptionsContext)), boxOptions = _useContext.box;
    var skeleton = (0, _skeleton.useSkeleton)();
    var _useState = (0, _react.useState)(undefined), containerElement = _useState[0], setContainerElement = _useState[1];
    var responsiveContainer = (0, _react.useContext)((0, _contexts.ResponsiveContainerContext));
    var responsive = responsiveContainer && responsiveProp ? 'container' : responsiveProp;
    var background = backgroundProp;
    var announce = (0, _react.useContext)((0, _announceContext.AnnounceContext));
    var containerRef = (0, _utils.useForwardedRef)(refProp);
    // Save the ref as a state if we're in a responsive container.
    // We only need it in the responsive container case and it
    // needs to be in a state to cause a re-render.
    (0, _react.useEffect)(function() {
        if (responsiveProp === 'container' && containerRef.current) setContainerElement(containerRef.current);
    }, [
        containerRef,
        responsiveProp
    ]);
    (0, _react.useEffect)(function() {
        if (typeof as === 'function') {
            if (refProp) console.warn('ref and as={function} are incompatible. The ref will not get set.');
            if (responsiveProp === 'container') console.warn(// eslint-disable-next-line max-len
            'responsive="container" and as={function} are incompatible. Use one or the other.');
        }
    }, [
        refProp,
        as,
        responsiveProp
    ]);
    (0, _react.useEffect)(function() {
        var _skeletonProp$message;
        if (skeletonProp != null && (_skeletonProp$message = skeletonProp.message) != null && _skeletonProp$message.start) announce(skeletonProp.message.start);
        else if (typeof (skeletonProp == null ? void 0 : skeletonProp.message) === 'string') announce(skeletonProp.message);
        return function() {
            var _skeletonProp$message2;
            return (skeletonProp == null || (_skeletonProp$message2 = skeletonProp.message) == null ? void 0 : _skeletonProp$message2.end) && announce(skeletonProp.message.end);
        };
    }, [
        announce,
        skeletonProp
    ]);
    var focusable = (0, _react.useMemo)(function() {
        return onClick && !(tabIndex < 0);
    }, [
        onClick,
        tabIndex
    ]);
    var _useState2 = (0, _react.useState)(), focus = _useState2[0], setFocus = _useState2[1];
    var clickProps = (0, _react.useMemo)(function() {
        if (focusable) return {
            onClick: onClick,
            onFocus: function onFocus(event) {
                setFocus(true);
                if (_onFocus) _onFocus(event);
            },
            onBlur: function onBlur(event) {
                setFocus(false);
                if (_onBlur) _onBlur(event);
            }
        };
        var result = {};
        if (_onBlur) result.onBlur = _onBlur;
        if (onClick) result.onClick = onClick;
        if (_onFocus) result.onFocus = _onFocus;
        return result;
    }, [
        focusable,
        onClick,
        _onFocus,
        _onBlur
    ]);
    var adjustedTabIndex = (0, _react.useMemo)(function() {
        if (tabIndex !== undefined) return tabIndex;
        if (focusable) return 0;
        return undefined;
    }, [
        focusable,
        tabIndex
    ]);
    if ((border === 'between' || border && border.side === 'between' || Array.isArray(border) && border.find(function(b) {
        return b.side === 'between';
    })) && !gap) console.warn('Box must have a gap to use border between');
    var contents = children;
    if (gap && gap !== 'none' && (!(boxOptions != null && boxOptions.cssGap || cssGap || typeof gap === 'object') || // need this approach to show border between
    border === 'between' || (border == null ? void 0 : border.side) === 'between' || Array.isArray(border) && border.find(function(b) {
        return b.side === 'between';
    }))) {
        // if border is an array, we need to extract the border between object
        var styledBoxGapBorder = Array.isArray(border) ? border.find(function(b) {
            return b.side === 'between';
        }) : border;
        var boxAs = !as && tag ? tag : as;
        contents = [];
        var firstIndex;
        (0, _react.Children).forEach(children, function(child, index) {
            if (child) {
                if (firstIndex === undefined) firstIndex = index;
                else contents.push(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledBox.StyledBoxGap), _extends({
                    key: "gap-" + index,
                    as: boxAs === 'span' ? boxAs : 'div',
                    gap: gap,
                    directionProp: direction,
                    responsive: responsive,
                    border: styledBoxGapBorder
                }, passThemeFlag)));
            }
            contents.push(child);
        });
    }
    var nextSkeleton = (0, _react.useMemo)(function() {
        // Decide if we need to add a new SkeletonContext. We need one if:
        //   1. skeleton info was set in a property OR
        //   2. there already is a SkeletonContext but this box has a
        //      background or border. This means the box probably is more
        //      distinguishable from the area around it.
        // We keep track of a depth so we know how to alternate backgrounds.
        if (skeletonProp || (background || border) && skeleton) {
            var depth = skeleton ? skeleton.depth + 1 : 0;
            return _extends({}, skeleton, {
                depth: depth
            }, typeof skeletonProp === 'object' ? skeletonProp : {});
        }
        return undefined;
    }, [
        background,
        border,
        skeleton,
        skeletonProp
    ]);
    var skeletonProps = {};
    if (nextSkeleton) {
        var _theme$skeleton = theme.skeleton, skeletonThemeColors = _theme$skeleton.colors, skeletonThemeSize = _theme$skeleton.size, skeletonThemeProps = _objectWithoutPropertiesLoose(_theme$skeleton, _excluded2);
        var skeletonColors = nextSkeleton.colors ? nextSkeleton.colors[theme.dark ? 'dark' : 'light'] : skeletonThemeColors == null ? void 0 : skeletonThemeColors[theme.dark ? 'dark' : 'light'];
        skeletonProps = _extends({}, skeletonThemeProps);
        background = skeletonColors[nextSkeleton.depth % skeletonColors.length];
        if (skeletonProp != null && skeletonProp.animation) skeletonProps.animation = skeletonProp.animation;
        contents = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _skeleton.SkeletonContext).Provider, {
            value: nextSkeleton
        }, contents);
    }
    // construct a new theme object in case we have a background that wants
    // to change the background color context
    var nextTheme = (0, _react.useMemo)(function() {
        var result;
        if (background || theme.darkChanged) {
            var dark = (0, _utils.backgroundIsDark)(background, theme);
            var darkChanged = dark !== undefined && dark !== theme.dark;
            if (darkChanged || theme.darkChanged) {
                result = _extends({}, theme);
                result.dark = dark === undefined ? theme.dark : dark;
                result.background = background;
            } else if (background) {
                // This allows DataTable to intelligently set the background
                // of a pinned header or footer.
                result = _extends({}, theme);
                result.background = background;
            }
        }
        return result || theme;
    }, [
        background,
        theme
    ]);
    // Only pass along the ref if the as prop is not a function.
    // The styled component will throw a warning if we try to pass
    // a ref when the as prop is a function. We do a console.warn
    // about this above in this case.
    var ref = typeof as === 'function' ? undefined : containerRef;
    var content = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledBox.StyledBox), _extends({
        as: !as && tag ? tag : as,
        "aria-label": a11yTitle,
        background: background,
        border: border,
        ref: ref,
        directionProp: direction,
        elevationProp: elevation,
        fillProp: fill,
        focus: focus,
        gap: ((boxOptions == null ? void 0 : boxOptions.cssGap) || cssGap || typeof gap === 'object') && gap && gap !== 'none' && border !== 'between' && (border == null ? void 0 : border.side) !== 'between' && (!Array.isArray(border) || !border.find(function(b) {
            return b.side === 'between';
        })) && gap,
        kindProp: kind,
        overflowProp: overflow,
        wrapProp: wrap,
        widthProp: width,
        heightProp: height,
        responsive: responsive,
        responsiveContainer: responsiveProp === 'container',
        tabIndex: adjustedTabIndex
    }, clickProps, passThemeFlag, rest, skeletonProps), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledComponents.ThemeContext).Provider, {
        value: nextTheme
    }, contents));
    if (responsiveProp === 'container') {
        if ((0, _responsive.supportsContainerQueries)()) content = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _responsiveContainerProvider.ResponsiveContainerProvider), {
            container: containerElement,
            theme: theme
        }, content);
        else console.warn('<Box responsive="container"> requires styled-components v6 or later');
    }
    if (onClick) content = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keyboard.Keyboard), {
        onEnter: onClick
    }, content);
    return content;
});
Box.displayName = 'Box';
Box.propTypes = (0, _propTypes.BoxPropTypes);

},{"react":"8CCva","styled-components":"6bGrk","../../utils":"fx31z","../Keyboard":"7WukC","./StyledBox":"knum4","./propTypes":"1Wgtt","../Skeleton":"aLlmA","../../contexts/AnnounceContext":"fESY4","../../contexts/OptionsContext":"5kzBX","../../contexts":"8InEz","./ResponsiveContainerProvider":"crlHA","../../utils/useThemeValue":"6LfDQ","../../utils/responsive":"6Wzh6","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7WukC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Keyboard", ()=>(0, _keyboard.Keyboard));
var _keyboard = require("./Keyboard");

},{"./Keyboard":"gjXwY","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gjXwY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Keyboard", ()=>Keyboard);
var _react = require("react");
var _propTypes = require("./propTypes");
var _excluded = [
    "capture",
    "target",
    "children",
    "onKeyDown"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var KEYS = {
    8: 'onBackspace',
    9: 'onTab',
    13: 'onEnter',
    27: 'onEsc',
    32: 'onSpace',
    37: 'onLeft',
    38: 'onUp',
    39: 'onRight',
    40: 'onDown',
    188: 'onComma',
    16: 'onShift'
};
var Keyboard = function Keyboard(_ref) {
    var capture = _ref.capture, target = _ref.target, children = _ref.children, onKeyDown = _ref.onKeyDown, restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
    var onKeyDownHandler = (0, _react.useCallback)(function(event) {
        var key = event.keyCode ? event.keyCode : event.which;
        var callbackName = KEYS[key];
        for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        if (callbackName && restProps[callbackName]) restProps[callbackName].apply(restProps, [
            event
        ].concat(rest));
        if (onKeyDown) onKeyDown.apply(void 0, [
            event
        ].concat(rest));
    }, [
        onKeyDown,
        restProps
    ]);
    (0, _react.useEffect)(function() {
        if (target === 'document') document.addEventListener('keydown', onKeyDownHandler, capture);
        return function() {
            if (target === 'document') document.removeEventListener('keydown', onKeyDownHandler, capture);
        };
    }, [
        capture,
        onKeyDownHandler,
        target
    ]);
    return target === 'document' ? children : /*#__PURE__*/ (0, _react.cloneElement)((0, _react.Children).only(children), {
        onKeyDown: onKeyDownHandler
    });
};
Keyboard.propTypes = (0, _propTypes.KeyboardPropTypes);

},{"react":"8CCva","./propTypes":"kOpiS","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kOpiS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyboardPropTypes", ()=>KeyboardPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PropType = {};
var KeyboardPropTypes = PropType;

},{"prop-types":"j03Ye","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"knum4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledBox", ()=>StyledBox);
parcelHelpers.export(exports, "StyledBoxGap", ()=>StyledBoxGap);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var _utils = require("../../utils");
var _styles = require("../../utils/styles");
var _animation = require("../../utils/animation");
var _FLEX_MAP;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var BASIS_MAP = {
    auto: 'auto',
    full: '100%',
    '1/2': '50%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/3': '33.33%',
    '2/3': '66.66%'
};
var basisStyle = (0, _styledComponents.css)([
    "flex-basis:",
    ";"
], function(props) {
    return BASIS_MAP[props.basis] || props.theme.global.size[props.basis] || props.basis;
});
// min-width and min-height needed because of this
// https://stackoverflow.com/questions/36247140/why-doesnt-flex-item-shrink-past-content-size
// we assume we are in the context of a Box going the other direction
// TODO: revisit this
var directionStyle = function directionStyle(direction, responsive, theme) {
    var styles = [
        (0, _styledComponents.css)([
            "min-width:0;min-height:0;flex-direction:",
            ";"
        ], direction === 'row-responsive' ? 'row' : direction)
    ];
    if (direction === 'row-responsive' && theme.box.responsiveBreakpoint) {
        var breakpoint = (0, _utils.getBreakpointStyle)(theme, theme.box.responsiveBreakpoint);
        if (breakpoint) styles.push((0, _utils.breakpointStyle)(breakpoint, "\n        flex-direction: column;\n        flex-basis: auto;\n        justify-content: flex-start;\n        align-items: stretch;\n      ", responsive));
    }
    return styles;
};
var FLEX_MAP = (_FLEX_MAP = {}, _FLEX_MAP[true] = '1 1', _FLEX_MAP[false] = '0 0', _FLEX_MAP.grow = '1 0', _FLEX_MAP.shrink = '0 1', _FLEX_MAP);
var flexGrowShrinkProp = function flexGrowShrinkProp(flex) {
    if (typeof flex === 'boolean' || typeof flex === 'string') return FLEX_MAP[flex];
    return (flex.grow ? flex.grow : 0) + " " + (flex.shrink ? flex.shrink : 0);
};
var flexStyle = (0, _styledComponents.css)([
    "flex:",
    ";"
], function(props) {
    return "" + flexGrowShrinkProp(props.flex) + (props.flex !== true && !props.basis ? ' auto' : '');
});
var JUSTIFY_MAP = {
    around: 'space-around',
    between: 'space-between',
    center: 'center',
    end: 'flex-end',
    evenly: 'space-evenly',
    start: 'flex-start'
};
var justifyStyle = (0, _styledComponents.css)([
    "justify-content:",
    ";"
], function(props) {
    return JUSTIFY_MAP[props.justify];
});
var WRAP_MAP = {
    "true": 'wrap',
    reverse: 'wrap-reverse'
};
var wrapStyle = (0, _styledComponents.css)([
    "flex-wrap:",
    ";"
], function(props) {
    return WRAP_MAP[props.wrapProp];
});
var _animationItemStyle = function animationItemStyle(item, theme) {
    if (typeof item === 'string') return (0, _animation.animationObjectStyle)({
        type: item
    }, theme);
    if (Array.isArray(item)) return item.reduce(function(style, a, index) {
        return (0, _styledComponents.css)([
            "",
            "",
            " ",
            ""
        ], style, index > 0 ? ',' : '', _animationItemStyle(a, theme));
    }, '');
    if (typeof item === 'object') return (0, _animation.animationObjectStyle)(item, theme);
    return '';
};
var animationAncilaries = function animationAncilaries(animation) {
    if (animation.type === 'flipIn' || animation.type === 'flipOut') return 'perspective: 1000px; transform-style: preserve-3d;';
    return '';
};
var animationObjectInitialStyle = function animationObjectInitialStyle(animation) {
    var bounds = (0, _animation.animationBounds)(animation.type, animation.size);
    if (bounds) return bounds[0] + " " + animationAncilaries(animation);
    return '';
};
var animationInitialStyle = function animationInitialStyle(item) {
    if (typeof item === 'string') return animationObjectInitialStyle({
        type: item
    });
    if (Array.isArray(item)) return item.map(function(a) {
        return typeof a === 'string' ? animationObjectInitialStyle({
            type: a
        }) : animationObjectInitialStyle(a);
    }).join('');
    if (typeof item === 'object') return animationObjectInitialStyle(item);
    return '';
};
var animationStyle = (0, _styledComponents.css)([
    "",
    ";"
], function(props) {
    return (0, _styledComponents.css)([
        "",
        " animation:",
        ";"
    ], animationInitialStyle(props.animation), _animationItemStyle(props.animation, props.theme));
});
var interactiveStyle = (0, _styledComponents.css)([
    "cursor:pointer;&:hover{",
    " ",
    "}"
], function(props) {
    var _props$kindProp;
    return ((_props$kindProp = props.kindProp) == null ? void 0 : _props$kindProp.hover) && (0, _utils.getHoverIndicatorStyle)(props.kindProp.hover, props.theme);
}, function(props) {
    return props.hoverIndicator && (0, _utils.getHoverIndicatorStyle)(props.hoverIndicator, props.theme);
});
var gapStyle = function gapStyle(directionProp, gap, responsive, wrap, theme) {
    var metric = theme.global.edgeSize[gap] || gap;
    var breakpoint = (0, _utils.getBreakpointStyle)(theme, theme.box.responsiveBreakpoint);
    var responsiveMetric = responsive && breakpoint && breakpoint.edgeSize[gap];
    var styles = [];
    if (typeof gap === 'object') {
        var responsiveColumnMetric = responsive && breakpoint && breakpoint.edgeSize[gap.column];
        var responsiveRowMetric = responsive && breakpoint && breakpoint.edgeSize[gap.row];
        if (gap.row !== undefined && gap.column !== undefined) {
            styles.push("gap: " + (theme.global.edgeSize[gap.row] || gap.row) + " " + (theme.global.edgeSize[gap.column] || gap.column) + ";");
            if (responsiveRowMetric || responsiveColumnMetric) styles.push((0, _utils.breakpointStyle)(breakpoint, "gap: " + (responsiveRowMetric || gap.row) + " " + (responsiveColumnMetric || gap.column) + ";", responsive));
        } else if (gap.row !== undefined) {
            styles.push("row-gap: " + (theme.global.edgeSize[gap.row] || gap.row) + ";");
            if (responsiveRowMetric) styles.push((0, _utils.breakpointStyle)(breakpoint, "row-gap: " + responsiveRowMetric + ";", responsive));
        } else if (gap.column !== undefined) {
            styles.push("column-gap: " + (theme.global.edgeSize[gap.column] || gap.column) + ";");
            if (responsiveColumnMetric) styles.push((0, _utils.breakpointStyle)(breakpoint, "column-gap: " + responsiveColumnMetric + ";", responsive));
        }
    } else if (directionProp === 'column' || directionProp === 'column-reverse') {
        styles.push("row-gap: " + metric + ";");
        if (responsiveMetric) styles.push((0, _utils.breakpointStyle)(breakpoint, "row-gap: " + responsiveMetric + ";", responsive));
    } else {
        styles.push("column-gap: " + metric + ";");
        if (wrap) styles.push("row-gap: " + metric + ";");
        if (responsiveMetric) {
            if (directionProp === 'row' || directionProp === 'row-reverse') styles.push((0, _utils.breakpointStyle)(breakpoint, "column-gap: " + responsiveMetric + ";", responsive));
            else if (directionProp === 'row-responsive') styles.push((0, _utils.breakpointStyle)(breakpoint, "row-gap: " + responsiveMetric + ";", responsive));
        }
    }
    return styles;
};
var responsiveContainerStyle = (0, _styledComponents.css)([
    "container-type:inline-size;"
]);
// NOTE: basis must be after flex! Otherwise, flex overrides basis
// After upgrading to react 19 the 'selected' prop is leaking through
// to the DOM, added a check to prevent this.
var StyledBox = (0, _styledComponentsDefault.default).div.withConfig({
    shouldForwardProp: function shouldForwardProp(prop) {
        return (0, _isPropValidDefault.default)(prop) && ![
            'selected'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledBox",
    componentId: "sc-13pk1d4-0"
})([
    "display:flex;box-sizing:border-box;",
    ";",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return !props.basis && 'max-width: 100%;';
}, (0, _utils.genericStyles), function(props) {
    return props.align && (0, _utils.alignStyle);
}, function(props) {
    return props.alignContent && (0, _utils.alignContentStyle);
}, function(props) {
    return props.background && (0, _utils.backgroundStyle)(props.background, props.theme);
}, function(props) {
    return props.border && (0, _utils.borderStyle)(props.border, props.responsive, props.theme);
}, function(props) {
    return props.directionProp && directionStyle(props.directionProp, props.responsive, props.theme);
}, function(props) {
    return props.heightProp && (0, _utils.heightStyle)(props.heightProp, props.theme);
}, function(props) {
    return props.widthProp && (0, _utils.widthStyle)(props.widthProp, props.theme);
}, function(props) {
    return props.flex !== undefined && flexStyle;
}, function(props) {
    return props.basis && basisStyle;
}, function(props) {
    return props.fillProp && (0, _utils.fillStyle)(props.fillProp);
}, function(props) {
    return props.justify && justifyStyle;
}, function(props) {
    return props.pad && (0, _utils.edgeStyle)('padding', props.pad, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.round && (0, _styles.roundStyle)(props.round, props.responsive, props.theme);
}, function(props) {
    return props.wrapProp && wrapStyle;
}, function(props) {
    return props.overflowProp && (0, _utils.overflowStyle)(props.overflowProp);
}, function(props) {
    return props.elevationProp && (0, _utils.elevationStyle)(props.elevationProp);
}, function(props) {
    return props.gap && gapStyle(props.directionProp, props.gap, props.responsive, props.wrapProp, props.theme);
}, function(props) {
    return props.animation && animationStyle;
}, function(props) {
    return props.onClick && interactiveStyle;
}, function(props) {
    return props.onClick && props.focus && props.focusIndicator !== false && (0, _utils.focusStyle)();
}, function(props) {
    return props.theme.box && props.theme.box.extend;
}, function(props) {
    return props.kindProp && props.kindProp.extend;
}, function(props) {
    return props.responsiveContainer ? responsiveContainerStyle : '';
});
var gapGapStyle = function gapGapStyle(directionProp, gap, responsive, border, theme) {
    var metric = theme.global.edgeSize[gap] || gap;
    var breakpoint = (0, _utils.getBreakpointStyle)(theme, theme.box.responsiveBreakpoint);
    var responsiveMetric = responsive && breakpoint && breakpoint.edgeSize[gap];
    var styles = [];
    if (directionProp === 'column' || directionProp === 'column-reverse') {
        styles.push("height: " + metric + ";");
        if (responsiveMetric) styles.push((0, _utils.breakpointStyle)(breakpoint, "height: " + responsiveMetric + ";", responsive));
    } else {
        styles.push("width: " + metric + ";");
        if (responsiveMetric) {
            if (directionProp === 'row' || directionProp === 'row-reverse') styles.push((0, _utils.breakpointStyle)(breakpoint, "width: " + responsiveMetric + ";", responsive));
            else if (directionProp === 'row-responsive') styles.push((0, _utils.breakpointStyle)(breakpoint, "\n          width: auto;\n          height: " + responsiveMetric + ";\n        ", responsive));
        }
    }
    if (border === 'between' || border && border.side === 'between') {
        var borderSize = border.size || 'xsmall';
        var borderMetric = theme.global.borderSize[borderSize] || borderSize;
        var borderOffset = (0, _utils.parseMetricToNum)(metric) / 2 - (0, _utils.parseMetricToNum)(borderMetric) / 2 + "px";
        var responsiveBorderMetric = responsive && breakpoint && (breakpoint.borderSize[borderSize] || borderSize);
        var responsiveBorderOffset = responsiveBorderMetric && (0, _utils.parseMetricToNum)(responsiveMetric || metric) / 2 - (0, _utils.parseMetricToNum)(responsiveBorderMetric) / 2 + "px";
        if (directionProp === 'column' || directionProp === 'column-reverse') {
            var adjustedBorder = typeof border === 'string' ? 'top' : _extends({}, border, {
                side: 'top'
            });
            styles.push((0, _styledComponents.css)([
                "position:relative;&:after{content:'';position:absolute;width:100%;top:",
                ";",
                "}"
            ], borderOffset, (0, _utils.borderStyle)(adjustedBorder, responsive, theme)));
            if (responsiveBorderOffset) styles.push((0, _utils.breakpointStyle)(breakpoint, "\n            &:after {\n              content: '';\n              top: " + responsiveBorderOffset + ";\n            }", responsive));
        } else {
            var _adjustedBorder = typeof border === 'string' ? 'left' : _extends({}, border, {
                side: 'left'
            });
            styles.push((0, _styledComponents.css)([
                "position:relative;&:after{content:'';position:absolute;height:100%;left:",
                ";",
                "}"
            ], borderOffset, (0, _utils.borderStyle)(_adjustedBorder, directionProp !== 'row-responsive' && responsive, theme)));
            if (responsiveBorderOffset) {
                if (directionProp === 'row' || directionProp === 'row-reverse') styles.push((0, _utils.breakpointStyle)(breakpoint, "\n              &:after {\n                content: '';\n                left: " + responsiveBorderOffset + ";\n              }", responsive));
                else if (directionProp === 'row-responsive') {
                    var adjustedBorder2 = typeof border === 'string' ? 'top' : _extends({}, border, {
                        side: 'top'
                    });
                    styles.push((0, _utils.breakpointStyle)(breakpoint, "\n              &:after {\n                content: '';\n                height: auto;\n                left: unset;\n                width: 100%;\n                top: " + responsiveBorderOffset + ";\n                border-left: none;\n                " + (0, _utils.responsiveBorderStyle)(adjustedBorder2, theme) + "\n              }", responsive));
                }
            }
        }
    }
    return styles;
};
var StyledBoxGap = (0, _styledComponentsDefault.default).div.withConfig((0, _styles.styledComponentsConfig)).withConfig({
    displayName: "StyledBox__StyledBoxGap",
    componentId: "sc-13pk1d4-1"
})([
    "flex:0 0 auto;align-self:stretch;",
    ";"
], function(props) {
    return props.gap && gapGapStyle(props.directionProp, props.gap, props.responsive, props.border, props.theme);
});

},{"styled-components":"6bGrk","@emotion/is-prop-valid":"db6x2","../../utils":"fx31z","../../utils/styles":"4m6LZ","../../utils/animation":"3w9LG","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1Wgtt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BoxPropTypes", ()=>BoxPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var OVERFLOW_VALUES = [
    'auto',
    'hidden',
    'scroll',
    'visible'
];
var BORDER_SHAPE = (0, _propTypesDefault.default).shape({
    color: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).shape({
            dark: (0, _propTypesDefault.default).string,
            light: (0, _propTypesDefault.default).string
        })
    ]),
    side: (0, _propTypesDefault.default).oneOf([
        'top',
        'left',
        'bottom',
        'right',
        'start',
        'end',
        'horizontal',
        'vertical',
        'all',
        'between'
    ]),
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, _propTypesDefault.default).string
    ]),
    style: (0, _propTypesDefault.default).oneOf([
        'solid',
        'dashed',
        'dotted',
        'double',
        'groove',
        'ridge',
        'inset',
        'outset',
        'hidden'
    ])
});
// if you update values here, make sure to update in Drop/doc too.
var overflowPropType = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).oneOf(OVERFLOW_VALUES),
    (0, _propTypesDefault.default).shape({
        horizontal: (0, _propTypesDefault.default).oneOf(OVERFLOW_VALUES),
        vertical: (0, _propTypesDefault.default).oneOf(OVERFLOW_VALUES)
    }),
    (0, _propTypesDefault.default).string
]);
var PropType = {};
var BoxPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aLlmA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Skeleton", ()=>(0, _skeleton.Skeleton));
var _skeleton = require("./Skeleton");
var _skeletonContext = require("./SkeletonContext");
parcelHelpers.exportAll(_skeletonContext, exports);

},{"./Skeleton":"e9SGy","./SkeletonContext":"k6hRa","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"e9SGy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Skeleton", ()=>Skeleton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _propTypes = require("./propTypes");
var _skeletonContext = require("./SkeletonContext");
var _styledSkeleton = require("./StyledSkeleton");
var _useThemeValue = require("../../utils/useThemeValue");
var _contexts = require("../../contexts");
var _excluded = [
    "as",
    "colors",
    "width",
    "height",
    "responsive"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var Skeleton = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var _theme$skeleton;
    var as = _ref.as, colorsProp = _ref.colors, widthProp = _ref.width, heightProp = _ref.height, responsiveProp = _ref.responsive, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme, passThemeFlag = _useThemeValue1.passThemeFlag;
    var skeleton = (0, _skeletonContext.useSkeleton)();
    var depth = (skeleton == null ? void 0 : skeleton.depth) || 0;
    var responsiveContainer = (0, _react.useContext)((0, _contexts.ResponsiveContainerContext));
    var responsive = responsiveContainer && responsiveProp ? 'container' : responsiveProp;
    var colors = colorsProp || (theme == null || (_theme$skeleton = theme.skeleton) == null ? void 0 : _theme$skeleton.colors);
    var themeColors = colors[theme.dark ? 'dark' : 'light'];
    var background = themeColors[(depth + 1) % themeColors.length];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledSkeleton.StyledSkeleton), _extends({
        ref: ref,
        as: as,
        background: background,
        widthProp: widthProp,
        heightProp: heightProp,
        responsive: responsive
    }, passThemeFlag, rest));
});
Skeleton.displayName = 'Skeleton';
Skeleton.propTypes = (0, _propTypes.SkeletonPropTypes);

},{"react":"8CCva","./propTypes":"4ibuf","./SkeletonContext":"k6hRa","./StyledSkeleton":"frQcP","../../utils/useThemeValue":"6LfDQ","../../contexts":"8InEz","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4ibuf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkeletonPropTypes", ()=>SkeletonPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var PropType = {};
var SkeletonPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"k6hRa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkeletonContext", ()=>SkeletonContext);
parcelHelpers.export(exports, "useSkeleton", ()=>useSkeleton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var SkeletonContext = /*#__PURE__*/ (0, _reactDefault.default).createContext();
var useSkeleton = function useSkeleton() {
    return (0, _react.useContext)(SkeletonContext);
};

},{"react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"frQcP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledSkeleton", ()=>StyledSkeleton);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var _mixins = require("../../utils/mixins");
var StyledSkeleton = (0, _styledComponentsDefault.default).div.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledSkeleton",
    componentId: "sc-1omqm6u-0"
})([
    "display:flex;box-sizing:border-box;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, _utils.genericStyles), function(props) {
    return props.background && (0, _utils.backgroundStyle)(props.background, props.theme);
}, function(props) {
    var _props$theme$text;
    return (0, _utils.heightStyle)(props.heightProp || ((_props$theme$text = props.theme.text) == null || (_props$theme$text = _props$theme$text.medium) == null ? void 0 : _props$theme$text.height), props.theme);
}, function(props) {
    return (0, _utils.widthStyle)(props.widthProp || '100%', props.theme);
}, function(props) {
    return props.pad && (0, _utils.edgeStyle)('padding', props.pad, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.round && (0, _utils.roundStyle)(props.round, props.responsive, props.theme);
}, function(props) {
    var _props$theme;
    return (_props$theme = props.theme) == null || (_props$theme = _props$theme.skeleton) == null ? void 0 : _props$theme.extend;
}, function(props) {
    return props.responsiveSize && (0, _mixins.breakpointStyle)(props.responsiveSize.breakpoint, (0, _utils.heightStyle)(props.responsiveSize.height, props.theme), props.responsive);
});

},{"styled-components":"6bGrk","../../utils":"fx31z","../../utils/mixins":"gx4wP","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6LfDQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useThemeValue", ()=>useThemeValue);
var _react = require("react");
var _styledComponents = require("styled-components");
var _defaultProps = require("../default-props");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
/*
  Hook that returns theme value along with a flag to determine if we are 
  outside of a theme context provider, if so pass the base theme.
  If used outside of `<Grommet>` wrapper, falls back to base theme.
*/ var useThemeValue = function useThemeValue() {
    var context = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    var theme = context || (0, _defaultProps.defaultProps).theme;
    return {
        theme: theme,
        passThemeFlag: _extends({}, context === undefined ? {
            theme: theme
        } : {})
    };
};

},{"react":"8CCva","styled-components":"6bGrk","../default-props":"gZoER","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gZoER":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultProps", ()=>defaultProps);
parcelHelpers.export(exports, "extendDefaultTheme", ()=>extendDefaultTheme);
parcelHelpers.export(exports, "withTheme", ()=>withTheme);
var _utils = require("./utils");
var _base = require("./themes/base");
var defaultProps = {
    theme: (0, _base.base)
};
var extendDefaultTheme = function extendDefaultTheme(theme) {
    defaultProps.theme = (0, _utils.deepMerge)((0, _base.base), theme);
};
var withTheme = function withTheme(props) {
    return {
        theme: (0, _utils.deepMerge)(defaultProps.theme, props.theme)
    };
};

},{"./utils":"fx31z","./themes/base":"7ra6d","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"crlHA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResponsiveContainerProvider", ()=>ResponsiveContainerProvider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _contexts = require("../../contexts");
var _responsive = require("../../utils/responsive");
// The value of ResponsiveContainerContext
// when we're within a responsive container
var responsiveContainerValue = true;
var ResponsiveContainerProvider = function ResponsiveContainerProvider(_ref) {
    var container = _ref.container, theme = _ref.theme, children = _ref.children;
    var _useState = (0, _react.useState)(function() {
        var _theme$global;
        return (0, _responsive.deviceResponsive)(navigator.userAgent, theme) || (theme == null || (_theme$global = theme.global) == null ? void 0 : _theme$global.deviceBreakpoints.tablet);
    }), value = _useState[0], setValue = _useState[1];
    (0, _react.useEffect)(function() {
        if (!container) return undefined;
        // Track what breakpoint width of the container is at
        // and update the ResponsiveContext value accordingly.
        var resizeObserver;
        if (typeof window !== 'undefined' && window.ResizeObserver) {
            resizeObserver = new window.ResizeObserver(function(entries) {
                window.requestAnimationFrame(function() {
                    var _entries$;
                    if (!Array.isArray(entries) || !entries.length) return;
                    var size = (_entries$ = entries[0]) == null || (_entries$ = _entries$.borderBoxSize) == null || (_entries$ = _entries$[0]) == null ? void 0 : _entries$.inlineSize;
                    if (size) setValue((0, _responsive.getBreakpoint)(size, theme));
                });
            });
            resizeObserver.observe(container);
        }
        // Initial size for ResponsiveContext in responsive container mode.
        // Also is a fallback for server side rendering
        var containerWidth = container.getBoundingClientRect().width;
        setValue((0, _responsive.getBreakpoint)(containerWidth, theme));
        return function() {
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        container,
        theme
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contexts.ResponsiveContainerContext).Provider, {
        value: responsiveContainerValue
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contexts.ResponsiveContext).Provider, {
        value: value
    }, children));
};

},{"react":"8CCva","../../contexts":"8InEz","../../utils/responsive":"6Wzh6","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2Yqxq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Main", ()=>(0, _main.Main));
var _main = require("./Main");

},{"./Main":"3hQLe","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3hQLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Main", ()=>Main);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("../Box");
function _objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Main = function Main(_ref) {
    var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), _extends({
        as: "main",
        fill: "vertical",
        flex: "grow",
        overflow: "auto"
    }, rest));
};

},{"react":"8CCva","../Box":"4o01A","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kJa2L":[function(require,module,exports,__globalThis) {
/**
 *
 * FatalError
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FatalErrorHandler", ()=>FatalErrorHandler);
var _jsxRuntime = require("react/jsx-runtime");
var _selectors = require("app/state/fatalerror/selectors");
var _copyToClipboard = require("copy-to-clipboard");
var _copyToClipboardDefault = parcelHelpers.interopDefault(_copyToClipboard);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _anchor = require("grommet/es6/components/Anchor");
var _box = require("grommet/es6/components/Box");
var _heading = require("grommet/es6/components/Heading");
var _textArea = require("grommet/es6/components/TextArea");
var _text = require("grommet/es6/components/Text");
var _copy = require("grommet-icons/es6/icons/Copy");
var _dashboard = require("grommet-icons/es6/icons/Dashboard");
var _refresh = require("grommet-icons/es6/icons/Refresh");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _utils = require("grommet/es6/utils");
var _responsiveLayer = require("../ResponsiveLayer");
var _iconBlue192Png = require("../../../../public/Icon Blue 192.png");
var _iconBlue192PngDefault = parcelHelpers.interopDefault(_iconBlue192Png);
var _runtimeIs = require("app/lib/runtimeIs");
var _button = require("../Button");
const StyledTextArea = (0, _styledComponentsDefault.default)((0, _textArea.TextArea))`
  // Opacity is a workaround for browsers anti-aliasing issue triggered by border-radius.
  // Without it text is blurry.
  background-color: ${({ theme })=>`${(0, _utils.normalizeColor)('brand-background-light', theme)}fe`};
  font-family: 'Roboto mono', monospace;
  letter-spacing: 0;
  font-size: 13px;
  color: ${({ theme })=>(0, _utils.normalizeColor)('text-custom', theme)};
`;
function FatalErrorHandler({ children }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    const theme = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    const fatalError = (0, _reactRedux.useSelector)((0, _selectors.selectFatalError));
    const [copied, setCopied] = (0, _react.useState)(false);
    const isExtension = (0, _runtimeIs.runtimeIs) === 'extension';
    if (!fatalError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: children
    });
    const combinedStacktrace = `${fatalError.message}\n\n${fatalError.sagaStack}\n\n${fatalError.stack}`;
    const copyError = ()=>{
        (0, _copyToClipboardDefault.default)(combinedStacktrace);
        setCopied(true);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _responsiveLayer.ResponsiveLayer), {
        modal: true,
        background: "background-front",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                align: "end",
                margin: {
                    horizontal: 'large',
                    top: 'medium'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: (0, _iconBlue192PngDefault.default),
                    alt: t('appTitle', 'ROSE Wallet'),
                    width: "45",
                    height: "45"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                margin: {
                    horizontal: 'large',
                    bottom: 'large'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        direction: "row",
                        align: "center",
                        gap: "small",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _heading.Heading), {
                            style: {
                                fontSize: '20px'
                            },
                            children: t('fatalError.heading', 'An error occurred.')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                        size: "small",
                        margin: {
                            bottom: 'small'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                            i18nKey: "fatalError.description",
                            defaults: "The error that has occurred triggers the wallet to stop. <strong>Your funds are safe.</strong><br/><br/>Please try refreshing the page and reopening your wallet to see if the issue persists. You can check the current status of the network below.",
                            t: t
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        direction: isMobile ? 'column' : 'row',
                        margin: {
                            bottom: isMobile ? 'xlarge' : 'large'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.BrandButton), {
                            brandVariant: isExtension ? 'brand-gray-medium' : undefined,
                            href: "https://status.oasis.io",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboard.Dashboard), {}),
                            label: t('fatalError.checkStatus', 'Check network status')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        direction: "row",
                        justify: "end",
                        margin: {
                            bottom: isMobile ? 'medium' : 'small'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledTextArea, {
                            "data-testid": "fatalerror-stacktrace",
                            readOnly: true,
                            rows: 6,
                            value: combinedStacktrace
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        align: isMobile ? 'stretch' : 'end',
                        margin: {
                            bottom: isExtension ? 'small' : isMobile ? 'xlarge' : 'large'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.BrandButton), {
                            brandVariant: "brand-gray-medium",
                            onClick: ()=>copyError(),
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copy.Copy), {}),
                            label: !copied ? t('fatalError.copy', 'Copy error to clipboard') : t('fatalError.copied', 'Error copied to clipboard')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        align: isMobile ? 'stretch' : 'end',
                        margin: {
                            bottom: isMobile ? 'xlarge' : 'large'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.BrandButton), {
                            onClick: ()=>{
                                window.chrome?.runtime?.reload();
                                window.location.reload();
                            },
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _refresh.Refresh), {}),
                            label: t('fatalError.reloadApp', 'Reload app')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                        size: "small",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                            i18nKey: "fatalError.instruction",
                            defaults: "If the issue is not resolved after refreshing, please email our support team at  <Email/> and attach the error report.",
                            t: t,
                            components: {
                                Email: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _anchor.Anchor), {
                                    href: "mailto:wallet@oasisprotocol.org",
                                    label: "wallet@oasisprotocol.org",
                                    style: {
                                        color: (0, _utils.normalizeColor)('brand-blue', theme)
                                    }
                                })
                            }
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","app/state/fatalerror/selectors":"eC6o6","copy-to-clipboard":"bIAYJ","styled-components":"6bGrk","grommet/es6/contexts/ResponsiveContext":"7EsNN","grommet/es6/components/Anchor":"arBWH","grommet/es6/components/Box":"4o01A","grommet/es6/components/Heading":"1SnMZ","grommet/es6/components/TextArea":"8mQse","grommet/es6/components/Text":"kz1Ni","grommet-icons/es6/icons/Copy":"iSuj5","grommet-icons/es6/icons/Dashboard":"eokGU","grommet-icons/es6/icons/Refresh":"7BwqO","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","grommet/es6/utils":"fx31z","../ResponsiveLayer":"3jeKP","../../../../public/Icon Blue 192.png":"8NBZt","app/lib/runtimeIs":"fboJV","../Button":"joaEK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eC6o6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectFatalError", ()=>selectFatalError);
var _toolkit = require("@reduxjs/toolkit");
var _ = require(".");
const selectSlice = (state)=>state.fatalError || (0, _.initialState);
const selectFatalError = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state.error);

},{"@reduxjs/toolkit":"9ol63",".":"dQQWe","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bIAYJ":[function(require,module,exports,__globalThis) {
"use strict";
var deselectCurrent = require("b270149f26797c52");
var clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var defaultMessage = "Copy to clipboard: #{key}, Enter";
function format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = deselectCurrent();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = format("message" in options ? options.message : defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
module.exports = copy;

},{"b270149f26797c52":"9lbfr"}],"9lbfr":[function(require,module,exports,__globalThis) {
module.exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};

},{}],"arBWH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Anchor", ()=>(0, _anchor.Anchor));
var _anchor = require("./Anchor");

},{"./Anchor":"5qeQw","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5qeQw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Anchor", ()=>Anchor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("../../utils");
var _box = require("../Box");
var _styledAnchor = require("./StyledAnchor");
var _propTypes = require("./propTypes");
var _analyticsContext = require("../../contexts/AnalyticsContext");
var _textContext = require("../Text/TextContext");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "a11yTitle",
    "aria-label",
    "children",
    "color",
    "disabled",
    "gap",
    "href",
    "icon",
    "label",
    "onBlur",
    "onClick",
    "onFocus",
    "reverse",
    "size"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var Anchor = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var _theme$anchor3, _theme$anchor4;
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], children = _ref.children, color = _ref.color, disabled = _ref.disabled, gap = _ref.gap, href = _ref.href, icon = _ref.icon, label = _ref.label, _onBlur = _ref.onBlur, onClickProp = _ref.onClick, _onFocus = _ref.onFocus, reverse = _ref.reverse, sizeProp = _ref.size, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme, passThemeFlag = _useThemeValue1.passThemeFlag;
    var _useState = (0, _react.useState)(), focus = _useState[0], setFocus = _useState[1];
    var _useContext = (0, _react.useContext)((0, _textContext.TextContext)), size = _useContext.size;
    var sendAnalytics = (0, _analyticsContext.useAnalytics)();
    var onClick = (0, _react.useCallback)(function(event) {
        sendAnalytics({
            type: 'anchorClick',
            element: (0, _utils.findButtonParent)(event.target),
            event: event,
            href: href,
            label: typeof label === 'string' ? label : undefined
        });
        if (onClickProp) onClickProp(event);
    }, [
        onClickProp,
        sendAnalytics,
        label,
        href
    ]);
    (0, _react.useEffect)(function() {
        if ((icon || label) && children) console.warn('Anchor should not have children if icon or label is provided');
    }, [
        children,
        icon,
        label
    ]);
    var coloredIcon = icon;
    if (icon && !icon.props.color) {
        var _theme$anchor, _theme$anchor2;
        coloredIcon = /*#__PURE__*/ (0, _react.cloneElement)(icon, {
            color: (0, _utils.normalizeColor)(color || ((_theme$anchor = theme.anchor) == null || (_theme$anchor = _theme$anchor.icon) == null ? void 0 : _theme$anchor.color) || ((_theme$anchor2 = theme.anchor) == null || (_theme$anchor2 = _theme$anchor2.size) == null || (_theme$anchor2 = _theme$anchor2[sizeProp || size]) == null ? void 0 : _theme$anchor2.color) || theme.anchor.color, theme)
        });
    }
    var anchorIcon = (0, _utils.useSizedIcon)(coloredIcon, sizeProp || size, theme);
    var first = reverse ? label : anchorIcon;
    var second = reverse ? anchorIcon : label;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledAnchor.StyledAnchor), _extends({}, rest, {
        ref: ref,
        "aria-label": ariaLabel || a11yTitle,
        colorProp: color,
        disabled: disabled,
        hasIcon: !!icon,
        focus: focus,
        hasLabel: label,
        reverse: reverse,
        href: !disabled ? href : undefined,
        onClick: !disabled ? onClick : undefined,
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        size: sizeProp || size
    }, passThemeFlag), first && second ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
        as: "span",
        direction: "row",
        align: "center",
        gap: gap || ((_theme$anchor3 = theme.anchor) == null || (_theme$anchor3 = _theme$anchor3.size) == null || (_theme$anchor3 = _theme$anchor3[sizeProp]) == null ? void 0 : _theme$anchor3.gap) || ((_theme$anchor4 = theme.anchor) == null ? void 0 : _theme$anchor4.gap),
        responsive: false
    }, first, second) : first || second || children);
});
Anchor.displayName = 'Anchor';
Anchor.propTypes = (0, _propTypes.AnchorPropTypes);

},{"react":"8CCva","../../utils":"fx31z","../Box":"4o01A","./StyledAnchor":"a5WEq","./propTypes":"egBYR","../../contexts/AnalyticsContext":"7ryyN","../Text/TextContext":"SHhZ0","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"a5WEq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledAnchor", ()=>StyledAnchor);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var disabledStyle = "\n  opacity: 0.3;\n  cursor: default;\n  text-decoration: none;\n";
var sizeStyle = function sizeStyle(props) {
    if (props.size) {
        var size = props.size || 'medium';
        var data = props.theme.text[size];
        return (0, _styledComponents.css)([
            "font-size:",
            ";line-height:",
            ";"
        ], data ? data.size : size, data ? data.height : 'normal');
    }
    return (0, _styledComponents.css)([
        "font-size:inherit;line-height:inherit;"
    ]);
};
var StyledAnchor = (0, _styledComponentsDefault.default).a.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledAnchor",
    componentId: "sc-1rp7lwl-0"
})([
    "box-sizing:border-box;display:inline-flex;",
    " color:",
    ";",
    " text-decoration:",
    ";cursor:pointer;",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return sizeStyle(props);
}, function(props) {
    var _props$theme$anchor;
    return (0, _utils.normalizeColor)(props.colorProp || ((_props$theme$anchor = props.theme.anchor) == null || (_props$theme$anchor = _props$theme$anchor.size) == null || (_props$theme$anchor = _props$theme$anchor[props.size]) == null ? void 0 : _props$theme$anchor.color) || props.theme.anchor.color, props.theme);
}, function(props) {
    var _props$theme$anchor2, _props$theme$anchor3;
    return props.weight ? "font-weight: " + props.weight + ";" : (((_props$theme$anchor2 = props.theme.anchor) == null || (_props$theme$anchor2 = _props$theme$anchor2.size) == null || (_props$theme$anchor2 = _props$theme$anchor2[props.size]) == null ? void 0 : _props$theme$anchor2.fontWeight) || props.theme.anchor.fontWeight) && "font-weight: " + (((_props$theme$anchor3 = props.theme.anchor) == null || (_props$theme$anchor3 = _props$theme$anchor3.size) == null || (_props$theme$anchor3 = _props$theme$anchor3[props.size]) == null ? void 0 : _props$theme$anchor3.fontWeight) || props.theme.anchor.fontWeight) + ";";
}, function(props) {
    var _props$theme$anchor4;
    return props.hasIcon ? 'none' : ((_props$theme$anchor4 = props.theme.anchor) == null || (_props$theme$anchor4 = _props$theme$anchor4.size) == null || (_props$theme$anchor4 = _props$theme$anchor4[props.size]) == null ? void 0 : _props$theme$anchor4.textDecoration) || props.theme.anchor.textDecoration;
}, (0, _utils.genericStyles), function(props) {
    return !props.disabled && props.theme.anchor.hover && (0, _styledComponents.css)([
        "&:hover{",
        " ",
        " ",
        "}"
    ], props.theme.anchor.hover.textDecoration && "text-decoration: " + props.theme.anchor.hover.textDecoration + ";", props.theme.anchor.hover.fontWeight && "font-weight: " + props.theme.anchor.hover.fontWeight + ";", props.theme.anchor.hover.extend);
}, function(props) {
    return props.hasIcon && !props.hasLabel && "\n    padding: " + props.theme.global.edgeSize.small + ";\n  ";
}, function(props) {
    return props.disabled && disabledStyle;
}, function(props) {
    return props.focus && (0, _utils.focusStyle)();
}, function(props) {
    return props.theme.anchor.extend;
});

},{"styled-components":"6bGrk","../../utils":"fx31z","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"egBYR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnchorPropTypes", ()=>AnchorPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var PropType = {};
var AnchorPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"SHhZ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextContext", ()=>TextContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var TextContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({});

},{"react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1SnMZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Heading", ()=>(0, _heading.Heading));
var _heading = require("./Heading");

},{"./Heading":"fDDfJ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fDDfJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Heading", ()=>Heading);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useIsomorphicLayoutEffect = require("../../utils/use-isomorphic-layout-effect");
var _styledHeading = require("./StyledHeading");
var _propTypes = require("./propTypes");
var _utils = require("../../utils");
var _skeleton = require("../Skeleton");
var _headingSkeleton = require("./HeadingSkeleton");
var _useThemeValue = require("../../utils/useThemeValue");
var _contexts = require("../../contexts");
var _excluded = [
    "children",
    "color",
    "fill",
    "level",
    "overflowWrap",
    "responsive",
    "weight"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var Heading = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref // munged to avoid styled-components putting it in the DOM
) {
    var children = _ref.children, color = _ref.color, fill = _ref.fill, _ref$level = _ref.level, level = _ref$level === void 0 ? 1 : _ref$level, overflowWrapProp = _ref.overflowWrap, _ref$responsive = _ref.responsive, responsiveProp = _ref$responsive === void 0 ? true : _ref$responsive, weight = _ref.weight, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), passThemeFlag = _useThemeValue1.passThemeFlag;
    var headingRef = (0, _utils.useForwardedRef)(ref);
    var _useState = (0, _react.useState)(overflowWrapProp || 'break-word'), overflowWrap = _useState[0], setOverflowWrap = _useState[1];
    var responsiveContainer = (0, _react.useContext)((0, _contexts.ResponsiveContainerContext));
    var responsive = responsiveContainer && responsiveProp ? 'container' : responsiveProp;
    var skeleton = (0, _skeleton.useSkeleton)();
    // handle overflowWrap of heading
    (0, _useIsomorphicLayoutEffect.useLayoutEffect)(function() {
        var updateOverflowWrap = function updateOverflowWrap() {
            var wrap;
            if (!overflowWrapProp && headingRef.current) {
                wrap = headingRef.current.scrollWidth > headingRef.current.offsetWidth ? 'anywhere' : 'break-word';
                setOverflowWrap(wrap);
            }
        };
        window.addEventListener('resize', updateOverflowWrap);
        updateOverflowWrap();
        return function() {
            return window.removeEventListener('resize', updateOverflowWrap);
        };
    }, [
        headingRef,
        overflowWrapProp
    ]);
    var content = children;
    if (skeleton) content = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _headingSkeleton.HeadingSkeleton), _extends({
        level: level,
        fill: fill,
        responsive: responsive
    }, rest));
    return(/*#__PURE__*/ // enforce level to be a number
    (0, _reactDefault.default).createElement((0, _styledHeading.StyledHeading), _extends({
        as: "h" + level,
        colorProp: color,
        fillProp: fill,
        level: +level,
        overflowWrap: overflowWrap,
        responsive: responsive,
        weight: weight
    }, passThemeFlag, rest, {
        ref: headingRef
    }), content));
});
Heading.displayName = 'Heading';
Heading.propTypes = (0, _propTypes.HeadingPropTypes);

},{"react":"8CCva","../../utils/use-isomorphic-layout-effect":"jThNw","./StyledHeading":"2GWxz","./propTypes":"9ddyc","../../utils":"fx31z","../Skeleton":"aLlmA","./HeadingSkeleton":"c7i3t","../../utils/useThemeValue":"6LfDQ","../../contexts":"8InEz","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jThNw":[function(require,module,exports,__globalThis) {
/* eslint-disable no-restricted-imports */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLayoutEffect", ()=>useLayoutEffect);
var _react = require("react");
var useLayoutEffect = typeof window !== 'undefined' ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
exports.default = useLayoutEffect;

},{"react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2GWxz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledHeading", ()=>StyledHeading);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var sizeStyle = function sizeStyle(props) {
    // size is a combination of the level and size properties
    var size = props.size || 'medium';
    var headingTheme = props.theme.heading;
    var levelStyle = headingTheme.level[props.level];
    if (levelStyle) {
        var data = levelStyle[size];
        var styles = [
            (0, _styledComponents.css)([
                "font-size:",
                ";line-height:",
                ";max-width:",
                ";font-weight:",
                ";overflow-wrap:",
                ";"
            ], data ? data.size : size, data ? data.height : 'normal', props.fillProp && 'none' || data && data.maxWidth || levelStyle.medium.maxWidth, props.weight || levelStyle.font.weight || headingTheme.weight, props.overflowWrap)
        ];
        if (props.responsive && headingTheme.responsiveBreakpoint) {
            var breakpoint = props.theme.global.breakpoints[headingTheme.responsiveBreakpoint];
            if (breakpoint) {
                var responsiveData = headingTheme.level[props.level + 1] ? headingTheme.level[props.level + 1][size] : headingTheme.level[props.level][size];
                if (responsiveData) styles.push((0, _utils.breakpointStyle)(breakpoint, "\n            font-size: " + responsiveData.size + ";\n            line-height: " + responsiveData.height + ";\n            max-width: " + (props.fillProp && 'none' || responsiveData.maxWidth) + ";\n          ", props.responsive));
            }
        }
        return styles;
    }
    console.warn("Heading level " + props.level + " is not defined in your theme.");
    return '';
};
var fontFamily = function fontFamily(props) {
    var _ref = props.theme.heading.level[props.level] || {}, font = _ref.font;
    if (font && font.family) return (0, _styledComponents.css)([
        "font-family:",
        ";"
    ], font.family);
    return props.theme.heading.font ? (0, _styledComponents.css)([
        "font-family:",
        ";"
    ], props.theme.heading.font.family) : '';
};
var truncateStyle = "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n";
var colorStyle = (0, _styledComponents.css)([
    "color:",
    ";"
], function(props) {
    return (0, _utils.normalizeColor)(props.colorProp || props.theme.heading.color, props.theme);
});
var StyledHeading = (0, _styledComponentsDefault.default).h1.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledHeading",
    componentId: "sc-1rdh4aw-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, _utils.genericStyles), function(props) {
    return fontFamily(props);
}, function(props) {
    return sizeStyle(props);
}, function(props) {
    return props.textAlign && (0, _utils.textAlignStyle);
}, function(props) {
    return props.truncate && truncateStyle;
}, function(props) {
    return (props.colorProp || props.theme.heading.color) && colorStyle;
}, function(props) {
    return props.theme.heading && props.theme.heading.extend;
});

},{"styled-components":"6bGrk","../../utils":"fx31z","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9ddyc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeadingPropTypes", ()=>HeadingPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var PropType = {};
var HeadingPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"c7i3t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HeadingSkeleton", ()=>HeadingSkeleton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("../Skeleton");
var _useThemeValue = require("../../utils/useThemeValue");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var HeadingSkeleton = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var _theme$heading$level$;
    var as = _ref.as, _ref$level = _ref.level, level = _ref$level === void 0 ? 1 : _ref$level, _ref$size = _ref.size, size = _ref$size === void 0 ? 'medium' : _ref$size, responsive = _ref.responsive;
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme;
    var height = ((_theme$heading$level$ = theme.heading.level[level]) == null || (_theme$heading$level$ = _theme$heading$level$[size]) == null ? void 0 : _theme$heading$level$.height) || size;
    var responsiveSize;
    if (responsive && theme.heading.responsiveBreakpoint) {
        var breakpoint = theme.global.breakpoints[theme.heading.responsiveBreakpoint];
        if (breakpoint) {
            var _theme$heading$level$2, _theme$heading$level$3;
            var responsiveHeight = theme.heading.level[level + 1] ? (_theme$heading$level$2 = theme.heading.level[level + 1][size]) == null ? void 0 : _theme$heading$level$2.height : (_theme$heading$level$3 = theme.heading.level[level][size]) == null ? void 0 : _theme$heading$level$3.height;
            responsiveSize = {
                breakpoint: breakpoint,
                height: responsiveHeight || height
            };
        }
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _skeleton.Skeleton), _extends({
        as: as,
        ref: ref,
        height: height,
        responsive: responsive,
        responsiveSize: responsiveSize
    }, theme.heading.skeleton));
});
HeadingSkeleton.displayName = 'HeadingSkeleton';

},{"react":"8CCva","../Skeleton":"aLlmA","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8mQse":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextArea", ()=>(0, _textArea.TextArea));
var _textArea = require("./TextArea");

},{"./TextArea":"gE0hk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gE0hk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextArea", ()=>TextArea);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _formContext = require("../Form/FormContext");
var _keyboard = require("../Keyboard");
var _styledTextArea = require("./StyledTextArea");
var _propTypes = require("./propTypes");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "a11yTitle",
    "fill",
    "focusIndicator",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onKeyDown",
    "value"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var TextArea = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, fill = _ref.fill, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, name = _ref.name, _onBlur = _ref.onBlur, _onChange = _ref.onChange, _onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, valueProp = _ref.value, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), passThemeFlag = _useThemeValue1.passThemeFlag;
    var formContext = (0, _react.useContext)((0, _formContext.FormContext));
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var _useState = (0, _react.useState)(), focus = _useState[0], setFocus = _useState[1];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keyboard.Keyboard), {
        onEsc: function onEsc(event) {
            // we have to stop both synthetic events and native events
            // drop and layer should not close by pressing esc on this input
            event.stopPropagation();
            event.nativeEvent.stopImmediatePropagation();
        },
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledTextArea.StyledTextArea), _extends({
        "aria-label": a11yTitle,
        ref: ref,
        name: name,
        fillArg: fill,
        focus: focus,
        value: value,
        focusIndicator: focusIndicator
    }, passThemeFlag, rest, {
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onChange: function onChange(event) {
            setValue(event.target.value);
            if (_onChange) _onChange(event);
        }
    })));
});
TextArea.displayName = 'TextArea';
TextArea.propTypes = (0, _propTypes.TextAreaPropTypes);

},{"react":"8CCva","../Form/FormContext":"ky7Rv","../Keyboard":"7WukC","./StyledTextArea":"9f2QD","./propTypes":"28QR3","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ky7Rv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormContext", ()=>FormContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// When not a descendant of a Form, FormContext still provides a basic
// useFormInput. It doesn't do anything for components like TextInput.
// But, it does store the value for components like CheckBox or Select
// where the grommet component needs to know the value in order to
// render custom visuals.
var useFormInput = function useFormInput(_ref) {
    var valueProp = _ref.value, initialValue = _ref.initialValue;
    var _useState = (0, _react.useState)(valueProp !== undefined ? valueProp : initialValue), value = _useState[0], setValue = _useState[1];
    // Returns an array [value and function to set the value]
    return [
        valueProp !== undefined ? valueProp : value,
        function(nextValue) {
            if (initialValue !== undefined) setValue(nextValue);
        }
    ];
};
var useFormField = function useFormField(_ref2) {
    var error = _ref2.error, info = _ref2.info, disabled = _ref2.disabled;
    return {
        error: error,
        info: info,
        disabled: disabled
    };
};
var FormContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({
    useFormField: useFormField,
    useFormInput: useFormInput
});

},{"react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9f2QD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledTextArea", ()=>StyledTextArea);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var plainStyle = (0, _styledComponents.css)([
    "outline:none;border:none;width:100%;-webkit-appearance:none;"
]);
var resizeStyle = function resizeStyle(resize) {
    if (resize === 'horizontal') return 'resize: horizontal;';
    if (resize === 'vertical') return 'resize: vertical;';
    if (resize) return 'resize: both;';
    return 'resize: none;';
};
var StyledTextArea = (0, _styledComponentsDefault.default).textarea.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledTextArea",
    componentId: "sc-17i3mwp-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    ";max-width:100%;"
], (0, _utils.inputStyle), function(props) {
    return props.resize !== undefined && resizeStyle(props.resize);
}, function(props) {
    return props.fillArg && 'height: 100%;';
}, function(props) {
    return props.plain && plainStyle;
}, function(props) {
    return props.disabled && (0, _utils.disabledStyle)(props.theme.textArea.disabled && props.theme.textArea.disabled.opacity);
}, function(props) {
    return props.theme.textArea && props.theme.textArea.extend;
});

},{"styled-components":"6bGrk","../../utils":"fx31z","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"28QR3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextAreaPropTypes", ()=>TextAreaPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PropType = {};
var TextAreaPropTypes = PropType;

},{"prop-types":"j03Ye","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kz1Ni":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Text", ()=>(0, _text.Text));
var _text = require("./Text");

},{"./Text":"9R5IT","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9R5IT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Text", ()=>Text);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useIsomorphicLayoutEffect = require("../../utils/use-isomorphic-layout-effect");
var _styledText = require("./StyledText");
var _tip = require("../Tip");
var _utils = require("../../utils");
var _propTypes = require("./propTypes");
var _skeleton = require("../Skeleton");
var _textSkeleton = require("./TextSkeleton");
var _textContext = require("./TextContext");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "children",
    "color",
    "tag",
    "as",
    "tip",
    "a11yTitle",
    "truncate",
    "size",
    "skeleton",
    "level"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var Text = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var children = _ref.children, color = _ref.color, tag = _ref.tag, as = _ref.as, tipProp = _ref.tip, _ref$a11yTitle = _ref.a11yTitle, a11yTitle = _ref$a11yTitle === void 0 ? typeof tipProp === 'string' && tipProp || (tipProp == null ? void 0 : tipProp.content) || undefined : _ref$a11yTitle, truncate = _ref.truncate, size = _ref.size, skeletonProp = _ref.skeleton, _ref$level = _ref.level, level = _ref$level === void 0 ? 1 : _ref$level, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), passThemeFlag = _useThemeValue1.passThemeFlag;
    var textRef = (0, _utils.useForwardedRef)(ref);
    var _useState = (0, _react.useState)(false), textTruncated = _useState[0], setTextTruncated = _useState[1];
    var textContextValue = (0, _react.useMemo)(function() {
        return {
            size: size
        };
    }, [
        size
    ]);
    var skeleton = (0, _skeleton.useSkeleton)();
    (0, _useIsomorphicLayoutEffect.useLayoutEffect)(function() {
        var updateTip = function updateTip() {
            setTextTruncated(false);
            if (truncate === 'tip' && textRef.current && textRef.current.scrollWidth > textRef.current.offsetWidth) setTextTruncated(true);
        };
        window.addEventListener('resize', updateTip);
        window.addEventListener('pagechange', updateTip);
        updateTip();
        return function() {
            window.removeEventListener('resize', updateTip);
            window.removeEventListener('pagechange', updateTip);
        };
    }, [
        textRef,
        truncate
    ]);
    if (skeleton) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textSkeleton.TextSkeleton), _extends({
        ref: ref,
        as: as,
        level: level,
        size: size
    }, skeletonProp, rest));
    var styledTextResult = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledText.StyledText), _extends({
        as: !as && tag ? tag : as,
        colorProp: color,
        "aria-label": a11yTitle,
        level: level,
        truncate: truncate,
        size: size
    }, passThemeFlag, rest, {
        ref: textRef
    }), children !== undefined ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textContext.TextContext).Provider, {
        value: textContextValue
    }, children) : undefined);
    var tipProps = tipProp && typeof tipProp === 'object' ? tipProp : {};
    if (tipProp || textTruncated) {
        // place the text content in a tip if truncate === 'tip'
        // and the text has been truncated
        if (textTruncated) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tip.Tip), _extends({
            content: children
        }, tipProps), styledTextResult);
        // place the text content in a tip if truncate !== 'tip'
        // it displays even if the text has not truncated
        if (truncate !== 'tip') return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tip.Tip), tipProps, styledTextResult);
    }
    return styledTextResult;
});
Text.displayName = 'Text';
Text.propTypes = (0, _propTypes.TextPropTypes);

},{"react":"8CCva","../../utils/use-isomorphic-layout-effect":"jThNw","./StyledText":"2zzFf","../Tip":"55RvR","../../utils":"fx31z","./propTypes":"bfgU7","../Skeleton":"aLlmA","./TextSkeleton":"htNUU","./TextContext":"SHhZ0","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2zzFf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledText", ()=>StyledText);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var sizeStyle = function sizeStyle(props) {
    var size = props.size || 'medium';
    var data = props.theme.text[size];
    if (data) return (0, _styledComponents.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, data.height);
    return (0, _styledComponents.css)([
        "font-size:",
        ";line-height:normal;"
    ], size);
};
var truncateStyle = "\n  white-space: nowrap;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n";
var colorStyle = (0, _styledComponents.css)([
    "color:",
    ";"
], function(props) {
    return (0, _utils.normalizeColor)(props.colorProp, props.theme);
});
var weightStyle = (0, _styledComponents.css)([
    "font-weight:",
    ";"
], function(props) {
    return props.weight;
});
var wordBreakStyle = (0, _styledComponents.css)([
    "word-break:",
    ";"
], function(props) {
    return props.wordBreak;
});
var fontFamily = (0, _styledComponents.css)([
    "font-family:",
    ";"
], function(props) {
    return props.theme.text.font.family;
});
var StyledText = (0, _styledComponentsDefault.default)('span').withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledText",
    componentId: "sc-1sadyjn-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, _utils.genericStyles), function(props) {
    return sizeStyle(props);
}, function(props) {
    return props.textAlign && (0, _utils.textAlignStyle);
}, function(props) {
    return props.truncate && truncateStyle;
}, function(props) {
    return props.colorProp && colorStyle;
}, function(props) {
    return props.weight && weightStyle;
}, function(props) {
    return props.wordBreak && wordBreakStyle;
}, function(props) {
    return props.theme.text.font && props.theme.text.font.family && fontFamily;
}, function(props) {
    return props.theme.text && props.theme.text.extend;
});

},{"styled-components":"6bGrk","../../utils":"fx31z","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"55RvR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tip", ()=>(0, _tip.Tip));
var _tip = require("./Tip");

},{"./Tip":"2utpU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2utpU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tip", ()=>Tip);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("../Box");
var _drop = require("../Drop");
var _keyboard = require("../Keyboard");
var _utils = require("../../utils");
var _propTypes = require("./propTypes");
var _useThemeValue = require("../../utils/useThemeValue");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
/*
 * This function getReactNodeRef is adapted from
 * [Material UI] (https://github.com/mui/material-ui)
 * Licensed under the MIT License (c) 2024 aarongarciah
 * The function has been modified from its original version.
 */ var getReactNodeRef = function getReactNodeRef(element) {
    if (!element || !/*#__PURE__*/ (0, _reactDefault.default).isValidElement(element)) return null;
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to
    // children in older versions
    return ({}).propertyIsEnumerable.call(element.props, 'ref') ? element.props.ref : element.ref;
};
var Tip = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, tipRef) {
    var children = _ref.children, content = _ref.content, _ref$defaultVisible = _ref.defaultVisible, defaultVisible = _ref$defaultVisible === void 0 ? false : _ref$defaultVisible, dropProps = _ref.dropProps, plain = _ref.plain;
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme;
    var _useState = (0, _react.useState)(false), over = _useState[0], setOver = _useState[1];
    var _useState2 = (0, _react.useState)(false), tooltipOver = _useState2[0], setTooltipOver = _useState2[1];
    var usingKeyboard = (0, _utils.useKeyboard)();
    var componentRef = (0, _utils.useForwardedRef)(tipRef);
    // Three use case for children
    // 1. Tip has a single child + it is a React Element => Great!
    // 2. Tip has a single child +  not React Element =>
    // span will wrap the child so we can use ref and events.
    // 3. Tip has more than one child => Abort, display Children.only error
    var child = (0, _react.Children).count(children) <= 1 && !/*#__PURE__*/ (0, _reactDefault.default).isValidElement(children) && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, children) || (0, _react.Children).only(children);
    var clonedChild = /*#__PURE__*/ (0, _react.cloneElement)(child, {
        onMouseEnter: function onMouseEnter(event) {
            var _child$props;
            setOver(true);
            if ((_child$props = child.props) != null && _child$props.onMouseEnter) child.props.onMouseEnter(event);
        },
        onMouseLeave: function onMouseLeave(event) {
            var _child$props2;
            setOver(false);
            if ((_child$props2 = child.props) != null && _child$props2.onMouseLeave) child.props.onMouseLeave(event);
        },
        onFocus: function onFocus(event) {
            var _child$props3;
            if (usingKeyboard) setOver(true);
            if ((_child$props3 = child.props) != null && _child$props3.onFocus) child.props.onFocus(event);
        },
        onBlur: function onBlur(event) {
            var _child$props4;
            if (usingKeyboard) setOver(false);
            if ((_child$props4 = child.props) != null && _child$props4.onBlur) child.props.onBlur(event);
        },
        key: 'tip-child',
        ref: function ref(node) {
            // https://github.com/facebook/react/issues/8873#issuecomment-287873307
            if (typeof componentRef === 'function') componentRef(node);
            else if (componentRef) componentRef.current = node;
            // Call the original ref, if any
            var callerRef = getReactNodeRef(child);
            if (typeof callerRef === 'function') callerRef(node);
            else if (callerRef) callerRef.current = node;
        }
    });
    (0, _react.useEffect)(function() {
        setOver(defaultVisible);
    }, [
        defaultVisible
    ]);
    return [
        clonedChild,
        (over || tooltipOver) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keyboard.Keyboard), {
            key: "tip-keyboard",
            onEsc: function onEsc() {
                setOver(false);
                setTooltipOver(false);
            }
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _drop.Drop), _extends({
            target: componentRef.current,
            trapFocus: false,
            key: "tip-drop"
        }, theme.tip.drop, dropProps, {
            onMouseEnter: function onMouseEnter() {
                return setTooltipOver(true);
            },
            onMouseLeave: function onMouseLeave() {
                return setTooltipOver(false);
            }
        }), plain ? content : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), theme.tip.content, content)))
    ];
});
Tip.displayName = 'Tip';
Tip.propTypes = (0, _propTypes.TipPropTypes);

},{"react":"8CCva","../Box":"4o01A","../Drop":"hXFtw","../Keyboard":"7WukC","../../utils":"fx31z","./propTypes":"cskNL","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hXFtw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Drop", ()=>(0, _drop.Drop));
var _drop = require("./Drop");

},{"./Drop":"fFUNX","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fFUNX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Drop", ()=>Drop);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _utils = require("../../utils");
var _dropContainer = require("./DropContainer");
var _containerTargetContext = require("../../contexts/ContainerTargetContext");
var _propTypes = require("./propTypes");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "inline",
    "restrictFocus",
    "target",
    "trapFocus"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var Drop = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var inline = _ref.inline, restrictFocus = _ref.restrictFocus, dropTarget = _ref.target, _ref$trapFocus = _ref.trapFocus, trapFocus = _ref$trapFocus === void 0 ? true : _ref$trapFocus, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme;
    var _useState = (0, _react.useState)(), originalFocusedElement = _useState[0], setOriginalFocusedElement = _useState[1];
    (0, _react.useEffect)(function() {
        return setOriginalFocusedElement(document.activeElement);
    }, []);
    var _useState2 = (0, _react.useState)(), dropContainer = _useState2[0], setDropContainer = _useState2[1];
    var containerTarget = (0, _react.useContext)((0, _containerTargetContext.ContainerTargetContext));
    var containerChildNodesLength = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        // we need this condition to prevent getNewContainer to run multiple times
        // in the event that the component gets created, destroyed, and recreated.
        // see https://reactjs.org/docs/strict-mode.html#ensuring-reusable-state
        if (!(containerChildNodesLength != null && containerChildNodesLength.current)) {
            containerChildNodesLength.current = containerTarget.childNodes.length;
            setDropContainer(!inline ? (0, _utils.getNewContainer)(containerTarget) : undefined);
        }
    }, [
        containerTarget,
        inline
    ]);
    // just a few things to clean up when the Drop is unmounted
    (0, _react.useEffect)(function() {
        return function() {
            if (restrictFocus && originalFocusedElement) {
                if (originalFocusedElement.focus) (0, _utils.setFocusWithoutScroll)(originalFocusedElement);
                else if (originalFocusedElement.parentNode && originalFocusedElement.parentNode.focus) // required for IE11 and Edge
                (0, _utils.setFocusWithoutScroll)(originalFocusedElement.parentNode);
            }
            if (dropContainer) containerTarget.removeChild(dropContainer);
        };
    }, [
        containerTarget,
        dropContainer,
        originalFocusedElement,
        restrictFocus
    ]);
    var content = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dropContainer.DropContainer), _extends({
        ref: ref,
        dir: theme && theme.dir,
        dropTarget: dropTarget,
        restrictFocus: restrictFocus,
        trapFocus: trapFocus
    }, rest));
    if (inline) return content;
    if (dropContainer) return /*#__PURE__*/ (0, _reactDom.createPortal)(content, dropContainer);
    return null;
});
Drop.displayName = 'Drop';
Drop.propTypes = (0, _propTypes.DropPropTypes);

},{"react":"8CCva","react-dom":"ggrpy","../../utils":"fx31z","./DropContainer":"aw5Lq","../../contexts/ContainerTargetContext":"i3UJm","./propTypes":"fFjze","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aw5Lq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropContainer", ()=>DropContainer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _containerTargetContext = require("../../contexts/ContainerTargetContext");
var _focusedContainer = require("../FocusedContainer");
var _utils = require("../../utils");
var _keyboard = require("../Keyboard");
var _styledDrop = require("./StyledDrop");
var _optionsContext = require("../../contexts/OptionsContext");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "a11yTitle",
    "aria-label",
    "align",
    "background",
    "onAlign",
    "children",
    "dropTarget",
    "elevation",
    "onClickOutside",
    "onEsc",
    "onKeyDown",
    "overflow",
    "plain",
    "responsive",
    "restrictFocus",
    "stretch",
    "trapFocus"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// using react synthetic event to be able to stop propagation that
// would otherwise close the layer on ESC.
var preventLayerClose = function preventLayerClose(event) {
    var key = event.keyCode ? event.keyCode : event.which;
    if (key === 27) event.stopPropagation();
};
// Gets the closest ancestor positioned element
var getParentNode = function getParentNode(element) {
    var _element$offsetParent;
    return (_element$offsetParent = element.offsetParent) != null ? _element$offsetParent : element.parentNode;
};
// return the containing block
var getContainingBlock = function getContainingBlock(element) {
    var currentNode = getParentNode(element);
    while(currentNode instanceof window.HTMLElement && ![
        'html',
        'body'
    ].includes(currentNode.nodeName.toLowerCase())){
        var _currentNode;
        var css = window.getComputedStyle(currentNode);
        // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if ((css.transform ? css.transform !== 'none' : false) || (css.perspective ? css.perspective !== 'none' : false) || (css.backdropFilter ? css.backdropFilter !== 'none' : false) || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].includes(css.willChange) || css.willChange === 'filter' || (css.filter ? css.filter !== 'none' : false)) return currentNode;
        currentNode = (_currentNode = currentNode) == null ? void 0 : _currentNode.parentNode;
    }
    return null;
};
var defaultAlign = {
    top: 'top',
    left: 'left'
};
var DropContainer = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], _ref$align = _ref.align, align = _ref$align === void 0 ? defaultAlign : _ref$align, background = _ref.background, onAlign = _ref.onAlign, children = _ref.children, dropTarget = _ref.dropTarget, elevation = _ref.elevation, onClickOutside = _ref.onClickOutside, onEsc = _ref.onEsc, onKeyDown = _ref.onKeyDown, _ref$overflow = _ref.overflow, overflow = _ref$overflow === void 0 ? 'auto' : _ref$overflow, plain = _ref.plain, _ref$responsive = _ref.responsive, responsive = _ref$responsive === void 0 ? true : _ref$responsive, restrictFocus = _ref.restrictFocus, _ref$stretch = _ref.stretch, stretch = _ref$stretch === void 0 ? 'width' : _ref$stretch, trapFocus = _ref.trapFocus, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var containerTarget = (0, _react.useContext)((0, _containerTargetContext.ContainerTargetContext));
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme, passThemeFlag = _useThemeValue1.passThemeFlag;
    // dropOptions was created to preserve backwards compatibility
    var _useContext = (0, _react.useContext)((0, _optionsContext.OptionsContext)), dropOptions = _useContext.drop;
    var portalContext = (0, _react.useContext)((0, _utils.PortalContext));
    var portalId = (0, _react.useMemo)(function() {
        return portalContext.length;
    }, [
        portalContext
    ]);
    var nextPortalContext = (0, _react.useMemo)(function() {
        return [].concat(portalContext, [
            portalId
        ]);
    }, [
        portalContext,
        portalId
    ]);
    var dropRef = (0, _utils.useForwardedRef)(ref);
    (0, _react.useEffect)(function() {
        var onClickDocument = function onClickDocument(event) {
            // determine which portal id the target is in, if any
            var clickedPortalId = null;
            var node = event.composed && event.composedPath()[0] || event.target;
            while(clickedPortalId === null && node && node !== document && !(node instanceof ShadowRoot)){
                var attr = node.getAttribute('data-g-portal-id');
                if (attr !== null) clickedPortalId = parseInt(attr, 10);
                node = node.parentNode;
            }
            // Check if the click happened within the dropTarget
            var clickInsideDropTarget = (dropTarget == null ? void 0 : dropTarget.current) && dropTarget.current.contains(event.target) || dropTarget && typeof dropTarget.contains === 'function' && dropTarget.contains(event.target);
            if (!clickInsideDropTarget && clickedPortalId === null || portalContext.indexOf(clickedPortalId) !== -1) onClickOutside(event);
        };
        if (onClickOutside) document.addEventListener('mousedown', onClickDocument);
        return function() {
            if (onClickOutside) document.removeEventListener('mousedown', onClickDocument);
        };
    }, [
        onClickOutside,
        containerTarget,
        portalContext,
        dropTarget
    ]);
    (0, _react.useEffect)(function() {
        var target = (dropTarget == null ? void 0 : dropTarget.current) || dropTarget;
        var notifyAlign = function notifyAlign() {
            var _dropRef$current;
            var styleCurrent = dropRef == null || (_dropRef$current = dropRef.current) == null ? void 0 : _dropRef$current.style;
            var alignControl = (styleCurrent == null ? void 0 : styleCurrent.top) !== '' ? 'top' : 'bottom';
            onAlign(alignControl);
        };
        // We try to preserve the maxHeight as changing it causes any scroll
        // position to be lost. We set the maxHeight on mount and if the window
        // is resized.
        var place = function place(preserveHeight) {
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;
            var container = dropRef.current;
            if (container && target) {
                var _containingBlockRect$, _containingBlockRect, _containingBlockRect$2, _containingBlockRect2, _containingBlockRect$3, _containingBlockRect3, _containingBlock$scro, _containingBlock2, _containingBlock$scro2, _containingBlock3;
                // clear prior styling
                container.style.left = '';
                container.style.top = '';
                container.style.bottom = '';
                container.style.width = '';
                if (!preserveHeight) container.style.maxHeight = '';
                // get bounds
                var targetRect = target.getBoundingClientRect();
                var containerRect = container.getBoundingClientRect();
                // determine width
                var width;
                if (stretch) width = Math.min(stretch === 'align' ? Math.min(targetRect.width, containerRect.width) : Math.max(targetRect.width, containerRect.width), windowWidth);
                else width = Math.min(containerRect.width, windowWidth);
                // set left position
                var left;
                if (align.left) {
                    if (align.left === 'left') left = targetRect.left;
                    else if (align.left === 'right') left = targetRect.left + targetRect.width;
                } else if (align.right) {
                    if (align.right === 'left') left = targetRect.left - width;
                    else if (align.right === 'right') left = targetRect.left + targetRect.width - width;
                } else left = targetRect.left + targetRect.width / 2 - width / 2;
                if (left + width > windowWidth) left -= left + width - windowWidth;
                else if (left < 0) left = 0;
                // set top or bottom position
                var top;
                var bottom;
                var maxHeight = containerRect.height;
                /* If responsive is true and the Drop doesn't have enough room
          to be fully visible and there is more room in the other
          direction, change the Drop to display above/below. If there is
          less room in the other direction leave the Drop in its current
          position. */ if (responsive && // drop is above target
                align.bottom === 'top' && // drop is overflowing above window
                targetRect.top - containerRect.height <= 0 && // there is room to display the drop below the target
                targetRect.bottom + containerRect.height < windowHeight) {
                    // top of drop is aligned to bottom of target
                    top = targetRect.bottom;
                    maxHeight = top;
                } else if (responsive && // top of drop is aligned to top of target
                align.top === 'top' && // drop is overflowing below window
                targetRect.top + containerRect.height >= windowHeight && // height of the drop is larger than the target.
                targetRect.top + containerRect.height > targetRect.bottom && // there is room to display the drop above the target
                targetRect.bottom - containerRect.height > 0) {
                    // bottom of drop is aligned to bottom of target
                    bottom = targetRect.bottom;
                    maxHeight = top;
                } else if (responsive && // top of drop is aligned to bottom of target
                align.top === 'bottom' && // drop is overflowing below window
                targetRect.bottom + containerRect.height >= windowHeight && // there is room to display the drop above the target
                targetRect.top - containerRect.height > 0) {
                    // bottom of drop is aligned to top of target
                    bottom = targetRect.top;
                    maxHeight = bottom;
                } else if (responsive && // bottom of drop is aligned to bottom of target
                align.bottom === 'bottom' && // drop is overflowing above window
                targetRect.bottom - containerRect.height <= 0 && // height of the drop is larger than the target.
                targetRect.bottom - containerRect.height > targetRect.top && // there is room to display the drop below the target
                targetRect.top + containerRect.height > 0) {
                    // top of drop is aligned to top of target
                    top = targetRect.top;
                    maxHeight = bottom;
                } else if (align.top === 'top') {
                    top = targetRect.top;
                    maxHeight = windowHeight - top;
                } else if (align.top === 'bottom') {
                    top = targetRect.bottom;
                    maxHeight = windowHeight - top;
                } else if (align.bottom === 'top') {
                    bottom = targetRect.top;
                    maxHeight = bottom;
                } else if (align.bottom === 'bottom') {
                    bottom = targetRect.bottom;
                    maxHeight = bottom;
                } else top = targetRect.top + targetRect.height / 2 - containerRect.height / 2;
                var containingBlock;
                var containingBlockRect;
                // dropOptions was created to preserve backwards compatibility
                if (dropOptions != null && dropOptions.checkContainingBlock) {
                    var _containingBlock;
                    // return the containing block for absolute elements or `null`
                    // for fixed elements
                    containingBlock = getContainingBlock(container);
                    containingBlockRect = (_containingBlock = containingBlock) == null ? void 0 : _containingBlock.getBoundingClientRect();
                }
                // compute viewport offsets
                var viewportOffsetLeft = (_containingBlockRect$ = (_containingBlockRect = containingBlockRect) == null ? void 0 : _containingBlockRect.left) != null ? _containingBlockRect$ : 0;
                var viewportOffsetTop = (_containingBlockRect$2 = (_containingBlockRect2 = containingBlockRect) == null ? void 0 : _containingBlockRect2.top) != null ? _containingBlockRect$2 : 0;
                var viewportOffsetBottom = (_containingBlockRect$3 = (_containingBlockRect3 = containingBlockRect) == null ? void 0 : _containingBlockRect3.bottom) != null ? _containingBlockRect$3 : windowHeight;
                var containerOffsetLeft = (_containingBlock$scro = (_containingBlock2 = containingBlock) == null ? void 0 : _containingBlock2.scrollLeft) != null ? _containingBlock$scro : 0;
                var containerOffsetTop = (_containingBlock$scro2 = (_containingBlock3 = containingBlock) == null ? void 0 : _containingBlock3.scrollTop) != null ? _containingBlock$scro2 : 0;
                container.style.left = left - viewportOffsetLeft + containerOffsetLeft + "px";
                if (stretch) // offset width by 0.1 to avoid a bug in ie11 that
                // unnecessarily wraps the text if width is the same
                // NOTE: turned off for now
                container.style.width = width + 0.1 + "px";
                // the (position:absolute + scrollTop)
                // is presenting issues with desktop scroll flickering
                if (top !== '') container.style.top = top - viewportOffsetTop + containerOffsetTop + "px";
                if (bottom !== '') container.style.bottom = viewportOffsetBottom - bottom - containerOffsetTop + "px";
                if (!preserveHeight) {
                    if (theme.drop && theme.drop.maxHeight) maxHeight = Math.min(maxHeight, (0, _utils.parseMetricToNum)(theme.drop.maxHeight));
                    container.style.maxHeight = maxHeight + "px";
                }
            }
            if (onAlign) notifyAlign();
        };
        var scrollParents;
        var addScrollListeners = function addScrollListeners() {
            scrollParents = (0, _utils.findScrollParents)(target);
            scrollParents.forEach(function(scrollParent) {
                return scrollParent.addEventListener('scroll', place);
            });
        };
        var removeScrollListeners = function removeScrollListeners() {
            scrollParents.forEach(function(scrollParent) {
                return scrollParent.removeEventListener('scroll', place);
            });
            scrollParents = [];
        };
        var onResize = function onResize() {
            removeScrollListeners();
            addScrollListeners();
            place(false);
        };
        addScrollListeners();
        window.addEventListener('resize', onResize);
        place(false);
        return function() {
            removeScrollListeners();
            window.removeEventListener('resize', onResize);
        };
    }, [
        align,
        containerTarget,
        onAlign,
        dropTarget,
        portalContext,
        portalId,
        responsive,
        restrictFocus,
        stretch,
        theme.drop,
        dropRef,
        dropOptions
    ]);
    // Once drop is open the focus will be put on the drop container
    // if restrictFocus is true. If the caller put focus
    // on an element already, we honor that. Otherwise, we put
    // the focus on the drop container.
    (0, _react.useEffect)(function() {
        if (restrictFocus) {
            var dropContainer = dropRef.current;
            if (dropContainer) {
                if (!dropContainer.contains(document.activeElement)) dropContainer.focus();
            }
        }
    }, [
        dropRef,
        restrictFocus
    ]);
    var content = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledDrop.StyledDrop), _extends({
        "aria-label": a11yTitle || ariaLabel,
        ref: dropRef,
        background: background,
        plain: plain,
        elevation: !plain ? elevation || theme.global.drop.elevation || theme.global.drop.shadowSize || // backward compatibility
        'small' : undefined,
        tabIndex: "-1",
        alignProp: align,
        overflow: overflow,
        "data-g-portal-id": portalId
    }, passThemeFlag, rest), children);
    var themeContextValue = (0, _react.useMemo)(function() {
        var dark;
        if (background || theme.global.drop.background) dark = (0, _utils.backgroundIsDark)(background || theme.global.drop.background, theme);
        return _extends({}, theme, {
            dark: dark
        });
    }, [
        background,
        theme
    ]);
    var dark = themeContextValue.dark;
    if (dark !== undefined && dark !== theme.dark) content = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledComponents.ThemeContext).Provider, {
        value: themeContextValue
    }, content);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.PortalContext).Provider, {
        value: nextPortalContext
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focusedContainer.FocusedContainer), {
        onKeyDown: onEsc && preventLayerClose,
        trapFocus: trapFocus
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keyboard.Keyboard), {
        capture: true,
        onEsc: onEsc ? function(event) {
            event.stopPropagation();
            onEsc(event);
        } : undefined,
        onKeyDown: onKeyDown,
        target: "document"
    }, content)));
});

},{"react":"8CCva","styled-components":"6bGrk","../../contexts/ContainerTargetContext":"i3UJm","../FocusedContainer":"do0zH","../../utils":"fx31z","../Keyboard":"7WukC","./StyledDrop":"kWniX","../../contexts/OptionsContext":"5kzBX","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"do0zH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusedContainer", ()=>FocusedContainer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("../utils");
var _rootsContext = require("../contexts/RootsContext");
var _excluded = [
    "hidden",
    "restrictScroll",
    "children",
    "trapFocus"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var isFocusable = function isFocusable(element) {
    if ((element == null ? void 0 : element.tabIndex) < 0 || element != null && element.disabled) return false;
    switch(element == null ? void 0 : element.nodeName){
        case 'A':
            return !!element.href && element.rel !== 'ignore';
        case 'INPUT':
            return element.type !== 'hidden';
        case 'BUTTON':
        case 'SELECT':
        case 'TEXTAREA':
            return true;
        case 'DIV':
            return element.tabIndex >= 0;
        default:
            return false;
    }
};
var FocusedContainer = function FocusedContainer(_ref) {
    var _ref$hidden = _ref.hidden, hidden = _ref$hidden === void 0 ? false : _ref$hidden, _ref$restrictScroll = _ref.restrictScroll, restrictScroll = _ref$restrictScroll === void 0 ? false : _ref$restrictScroll, children = _ref.children, trapFocus = _ref.trapFocus, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useState = (0, _react.useState)(''), bodyOverflowStyle = _useState[0], setBodyOverflowStyle = _useState[1];
    var ref = (0, _react.useRef)(null);
    var preNodeRef = (0, _react.useRef)(null);
    var postNodeRef = (0, _react.useRef)(null);
    var _useRoots = (0, _rootsContext.useRoots)(), contextValue = _useRoots.contextValue, hasRoots = _useRoots.hasRoots;
    var contextRoots = contextValue.roots;
    // When attemptFocus moves focus around to find the focusable element,
    // set this to true so handleTrapFocus doesn't focus the element.
    var ignoreUtilFocusRef = (0, _react.useRef)(false);
    var lastFocusRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        var container = ref.current;
        var roots = contextRoots.current;
        var attemptFocus = function attemptFocus(element) {
            // Check if the element is focusable; if not, return false
            if (!isFocusable(element)) return false;
            ignoreUtilFocusRef.current = true;
            try {
                element.focus();
            } catch (_unused) {
            // continue regardless of error
            }
            ignoreUtilFocusRef.current = false;
            // Return true if the element is currently the active element or has focus
            return document.activeElement === element;
        };
        var _focusFirstDescendant = function focusFirstDescendant(element) {
            // Iterate through all child nodes of the provided element
            for(var i = 0; i < element.childNodes.length; i += 1){
                var child = element.childNodes[i];
                if (attemptFocus(child) || _focusFirstDescendant(child)) return true;
            }
            // If no focusable child or descendant was found, return false
            return false;
        };
        var _focusLastDescendant = function focusLastDescendant(element) {
            for(var i = element.childNodes.length - 1; i >= 0; i -= 1){
                var child = element.childNodes[i];
                if (attemptFocus(child) || _focusLastDescendant(child)) return true;
            }
            return false;
        };
        var handleTrapFocus = function handleTrapFocus(e) {
            if (!hidden && trapFocus && ignoreUtilFocusRef.current === false && container && // only perform focus if this is the most recently opened drop
            roots[roots.length - 1] === container) {
                if (container.contains(e.target)) lastFocusRef.current = e.target;
                else {
                    _focusFirstDescendant(container);
                    if (lastFocusRef.current === document.activeElement) _focusLastDescendant(container);
                    lastFocusRef.current = document.activeElement;
                }
            }
        };
        // add container to the global roots
        if (container) roots.push(container);
        // Create and insert focusable nodes to help track when focus
        // has left this container but without letting focus be noticeably
        // placed on anything outside the container
        if (!hidden && trapFocus) {
            var preDiv = document.createElement('div');
            var postDiv = document.createElement('div');
            var commonStyles = {
                position: 'absolute',
                height: '1px',
                left: '0',
                right: '0'
            };
            Object.assign(preDiv.style, _extends({}, commonStyles, {
                top: '0'
            }));
            Object.assign(postDiv.style, _extends({}, commonStyles, {
                bottom: '0'
            }));
            preNodeRef.current = container.parentNode.insertBefore(preDiv, container);
            postNodeRef.current = container.parentNode.insertBefore(postDiv, container.nextSibling);
            preNodeRef.current.tabIndex = 0;
            postNodeRef.current.tabIndex = 0;
        }
        document.addEventListener('focus', handleTrapFocus, true);
        return function() {
            var _preNodeRef$current, _postNodeRef$current;
            // remove from global roots array
            if (roots.includes(container)) roots.splice(roots.indexOf(container), 1);
            document.removeEventListener('focus', handleTrapFocus, true);
            if (roots != null && roots[roots.length - 1]) (0, _utils.makeNodeFocusable)(roots[roots.length - 1]);
            preNodeRef == null || (_preNodeRef$current = preNodeRef.current) == null || _preNodeRef$current.remove();
            postNodeRef == null || (_postNodeRef$current = postNodeRef.current) == null || _postNodeRef$current.remove();
        };
    }, [
        hidden,
        contextRoots,
        trapFocus
    ]);
    (0, _react.useEffect)(function() {
        if (bodyOverflowStyle !== 'hidden' && !hidden && restrictScroll && trapFocus) {
            setBodyOverflowStyle(document.body.style.overflow);
            document.body.style.overflow = 'hidden';
        }
        return function() {
            if (bodyOverflowStyle !== 'hidden' && !hidden && restrictScroll && trapFocus) document.body.style.overflow = bodyOverflowStyle;
        };
    }, [
        bodyOverflowStyle,
        hidden,
        trapFocus,
        restrictScroll
    ]);
    (0, _react.useEffect)(function() {
        var roots = contextRoots.current;
        var timer = setTimeout(function() {
            if (!hidden && trapFocus) // make every root before this one unfocusable
            roots == null || roots.forEach(function(root, index) {
                if (index < roots.length - 1) (0, _utils.makeNodeUnfocusable)(root);
            });
        }, 0);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        hidden,
        contextRoots,
        trapFocus
    ]);
    var focusedContainer = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({
        ref: ref,
        "aria-hidden": hidden
    }, rest), children);
    if (hasRoots) return focusedContainer;
    return(/*#__PURE__*/ // for cases outside of Grommet React tree, manage trapFocus when
    // Drop/Layer opens another Drop/Layer
    (0, _reactDefault.default).createElement((0, _rootsContext.RootsContext).Provider, {
        value: contextValue
    }, focusedContainer));
};

},{"react":"8CCva","../utils":"fx31z","../contexts/RootsContext":"7S2c8","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kWniX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledDrop", ()=>StyledDrop);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _box = require("../Box");
var _styles = require("../../utils/styles");
var _background = require("../../utils/background");
function getTransformOriginStyle(align) {
    var vertical = 'top';
    if (align.bottom) vertical = 'bottom';
    var horizontal = 'left';
    if (align.right) horizontal = 'right';
    return vertical + " " + horizontal;
}
var dropKeyFrames = (0, _styledComponents.keyframes)([
    "0%{opacity:0.5;transform:scale(0.8);}100%{opacity:1;transform:scale(1);}"
]);
// The desired margin may be adjusted depending on drops alignment
var marginStyle = function marginStyle(theme, align, data, responsive, marginProp) {
    // NOTE: If marginProp is passed, it overrides the alignment-aware
    //  margin logic and uses the provided value instead.
    var margin = theme.global.edgeSize[data] || data;
    var adjustedMargin = {};
    // if user provides CSS string such as '50px 12px', apply that always
    var customCSS = typeof margin === 'string' && margin.split(' ').length > 1;
    if (theme.global.drop.intelligentMargin === true && !customCSS && typeof margin === 'string') {
        if (align.top === 'bottom') adjustedMargin.top = margin;
        else if (align.bottom === 'top') adjustedMargin.bottom = margin;
        if (align.right === 'left') adjustedMargin.left = "-" + margin;
        else if (align.left === 'right') adjustedMargin.left = margin;
        if (!Object.keys(adjustedMargin)) adjustedMargin = 'none';
    } else return (0, _styles.edgeStyle)('margin', marginProp || theme.global.drop.margin, responsive, theme.global.edgeSize.responsiveBreakpoint, theme);
    return (0, _styles.edgeStyle)('margin', marginProp || adjustedMargin, responsive, theme.global.edgeSize.responsiveBreakpoint, theme);
};
var StyledDrop = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "StyledDrop",
    componentId: "sc-16s5rx8-0"
})([
    "",
    " ",
    " position:fixed;z-index:",
    ";outline:none;",
    " ",
    " opacity:0;transform-origin:",
    ";animation:",
    " 0.1s forwards;animation-delay:0.01s;@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){display:flex;align-items:stretch;}",
    ""
], (0, _styles.baseStyle), function(props) {
    return !props.plain && (props.round && (0, _styles.roundStyle)(props.round, props.responsive || true, props.theme) || "border-radius: " + props.theme.global.drop.border.radius + ";");
}, function(props) {
    return props.theme.global.drop.zIndex;
}, function(props) {
    return !props.plain && (0, _background.backgroundStyle)(props.background || props.theme.global.drop.background, props.theme);
}, function(props) {
    return !props.plain && (props.margin || props.theme.global.drop.margin) && props.theme.global && marginStyle(props.theme, props.alignProp, props.theme.global.drop.margin, props.responsive, props.margin);
}, function(props) {
    return getTransformOriginStyle(props.alignProp);
}, dropKeyFrames, function(props) {
    return props.theme.global.drop && props.theme.global.drop.extend;
});

},{"styled-components":"6bGrk","../Box":"4o01A","../../utils/styles":"4m6LZ","../../utils/background":"bX8Dm","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fFjze":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropPropTypes", ()=>DropPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
// if you update values here, make sure to update in Box too.
var dropOverflowPropTypes = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).oneOf((0, _generalPropTypes.OVERFLOW_VALUES)),
    (0, _propTypesDefault.default).shape({
        horizontal: (0, _propTypesDefault.default).oneOf((0, _generalPropTypes.OVERFLOW_VALUES)),
        vertical: (0, _propTypesDefault.default).oneOf((0, _generalPropTypes.OVERFLOW_VALUES))
    }),
    (0, _propTypesDefault.default).string
]);
var PropType = {};
var DropPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cskNL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TipPropTypes", ()=>TipPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PropType = {};
var TipPropTypes = PropType;

},{"prop-types":"j03Ye","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bfgU7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextPropTypes", ()=>TextPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var PropType = {};
var TextPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"htNUU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextSkeleton", ()=>TextSkeleton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("../Skeleton");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "as",
    "size"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var TextSkeleton = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var as = _ref.as, sizeProp = _ref.size, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme;
    var size = sizeProp || 'medium';
    var data = theme.text[size];
    var height = data ? data.size : sizeProp;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _skeleton.Skeleton), _extends({
        ref: ref,
        as: as,
        height: height
    }, theme.text.skeleton, rest));
});
TextSkeleton.displayName = 'TextSkeleton';

},{"react":"8CCva","../Skeleton":"aLlmA","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iSuj5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Copy", ()=>Copy);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Copy = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Copy"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M9 15h8-8zm0-4h10H9zm0-4h4-4zm7-6v6h6M6 5H2v18h16v-4m4 0H6V1h11l5 5v13z"
    }));
});
Copy.displayName = 'Copy';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6hZZK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledIcon", ()=>StyledIcon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _defaultProps = require("./default-props");
var _utils = require("./utils");
var _excluded = [
    "a11yTitle",
    "color",
    "size",
    "theme"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Returns the specific color that should be used according to the theme.
// If 'dark' is supplied, it takes precedence over 'theme.dark'.
// Can return undefined.
var normalizeColor = function normalizeColor(color, theme, dark) {
    var colorSpec = theme.global && theme.global.colors[color] !== undefined ? theme.global.colors[color] : color;
    // If the color has a light or dark object, use that
    var result = colorSpec;
    if (colorSpec) {
        if ((dark === true || dark === undefined && theme.dark) && colorSpec.dark !== undefined) result = colorSpec.dark;
        else if ((dark === false || !theme.dark) && colorSpec.light !== undefined) result = colorSpec.light;
    }
    // allow one level of indirection in color names
    if (result && theme.global && theme.global.colors[result] !== undefined) result = normalizeColor(result, theme, dark);
    return result;
};
var colorStyle = function colorStyle(name, value, theme, required) {
    return (0, _styledComponents.css)([
        "",
        ":",
        ";"
    ], name, normalizeColor(value, theme, required));
};
var colorCss = (0, _styledComponents.css)([
    "",
    " ",
    " g{fill:inherit;stroke:inherit;}*:not([stroke]){&[fill='none']{stroke-width:0;}}*[stroke*='#'],*[STROKE*='#']{stroke:inherit;fill:none;}*[fill-rule],*[FILL-RULE],*[fill*='#'],*[FILL*='#']{fill:inherit;stroke:none;}"
], function(props) {
    return colorStyle('fill', props.color || props.theme.global.colors.icon, props.theme);
}, function(props) {
    return colorStyle('stroke', props.color || props.theme.global.colors.icon, props.theme);
});
var IconInner = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, color = _ref.color, size = _ref.size, theme = _ref.theme, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", _extends({
        ref: ref,
        "aria-label": a11yTitle
    }, rest));
});
IconInner.displayName = 'Icon';
var StyledIcon = (0, _styledComponentsDefault.default)(IconInner).withConfig({
    // don't let height attribute leak to DOM
    // https://styled-components.com/docs/api#shouldforwardprop
    shouldForwardProp: function shouldForwardProp(prop) {
        return ![
            'height',
            'width'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledIcon",
    componentId: "sc-ofa7kd-0"
})([
    "display:inline-block;flex:0 0 auto;",
    " ",
    " ",
    " ",
    ""
], function(_ref2) {
    var _size$match;
    var _ref2$size = _ref2.size, sizeProp = _ref2$size === void 0 ? 'medium' : _ref2$size, theme = _ref2.theme, viewBox = _ref2.viewBox;
    var _split = (viewBox || '0 0 24 24').split(' '), w = _split[2], h = _split[3];
    var scale = w / h;
    var size = theme.icon.size[sizeProp] || sizeProp;
    var dimension = (0, _utils.parseMetricToNum)(size);
    // grab rem, em, px value from resolved size value
    var unit = ((_size$match = size.match(/[a-z]+$/)) == null ? void 0 : _size$match[0]) || 'px';
    if (w < h) return "\n      width: " + dimension + unit + ";\n      height: " + dimension / scale + unit + ";\n    ";
    if (h < w) return "\n      width: " + dimension * scale + unit + ";\n      height: " + dimension + unit + ";\n    ";
    return "\n      width: " + dimension + unit + ";\n      height: " + dimension + unit + ";\n    ";
}, function(_ref3) {
    var color = _ref3.color;
    return color !== 'plain' && colorCss;
}, function(props) {
    return (props.height || props.width) && (0, _utils.iconPad)(props);
}, function(_ref4) {
    var theme = _ref4.theme;
    return theme && theme.icon.extend;
});
StyledIcon.defaultProps = {};
Object.setPrototypeOf(StyledIcon.defaultProps, (0, _defaultProps.defaultProps));

},{"react":"8CCva","styled-components":"6bGrk","./default-props":"dHtlZ","./utils":"l0e2b","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dHtlZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultProps", ()=>defaultProps);
parcelHelpers.export(exports, "extendDefaultTheme", ()=>extendDefaultTheme);
var _utils = require("./utils");
var _themes = require("./themes");
var defaultProps = {
    theme: (0, _themes.base)
};
var extendDefaultTheme = function extendDefaultTheme(theme) {
    defaultProps.theme = (0, _utils.deepMerge)((0, _themes.base), theme);
};

},{"./utils":"l0e2b","./themes":"eVGVa","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"l0e2b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObject", ()=>isObject);
parcelHelpers.export(exports, "deepMerge", ()=>deepMerge);
parcelHelpers.export(exports, "parseMetricToNum", ()=>parseMetricToNum);
// scaleProps sets path properties to prevent scaling the stroke
// when the theme doesn't want it for small sizes.
parcelHelpers.export(exports, "useScaleProps", ()=>useScaleProps);
// iconPad applies padding to icon to ensure it aligns
// with text line-height or desired width
parcelHelpers.export(exports, "iconPad", ()=>iconPad);
parcelHelpers.export(exports, "generatePrefix", ()=>generatePrefix);
var _react = require("react");
var _styledComponents = require("styled-components");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function isObject(item) {
    return item && typeof item === 'object' && !Array.isArray(item);
}
function deepMerge(target) {
    for(var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)sources[_key - 1] = arguments[_key];
    if (!sources.length) return target;
    // making sure to not change target (immutable)
    var output = _extends({}, target);
    sources.forEach(function(source) {
        if (isObject(source)) Object.keys(source).forEach(function(key) {
            if (isObject(source[key])) {
                if (!output[key]) output[key] = _extends({}, source[key]);
                else output[key] = deepMerge(output[key], source[key]);
            } else output[key] = source[key];
        });
    });
    return output;
}
var parseMetricToNum = function parseMetricToNum(string) {
    if (string === void 0) string = '';
    return parseFloat(string.match(/\d+(\.\d+)?/), 10);
};
function useScaleProps(props) {
    var _theme$icon;
    var theme = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    var size = props.size;
    var result = {};
    if (theme != null && (_theme$icon = theme.icon) != null && _theme$icon.disableScaleDown) {
        var dimension = parseMetricToNum(theme.icon.size[size] || size);
        if (dimension < 24) result.vectorEffect = 'non-scaling-stroke';
    }
    return result;
}
var calculatePad = function calculatePad(value, iconDimension) {
    return (value - iconDimension) / 2 + "px";
};
function iconPad(props) {
    var _theme$icon2, _theme$text, _theme$text2;
    var height = props.height, _props$size = props.size, size = _props$size === void 0 ? 'medium' : _props$size, width = props.width;
    var theme = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    var iconDimension = parseMetricToNum((theme == null || (_theme$icon2 = theme.icon) == null || (_theme$icon2 = _theme$icon2.size) == null ? void 0 : _theme$icon2[size]) || size);
    var style = '';
    // browser default is 16px, but accommodate if app has modified
    // include fallback in case window is undefined
    var FALLBACK = '16px';
    var rootFontSize = parseMetricToNum(FALLBACK);
    if (typeof window !== 'undefined') {
        var _window;
        rootFontSize = parseMetricToNum(((_window = window) == null ? void 0 : _window.getComputedStyle(document.body).getPropertyValue('font-size')) || FALLBACK);
    }
    if (height && theme != null && (_theme$text = theme.text) != null && (_theme$text = _theme$text[height]) != null && _theme$text.height) {
        // the unit on theme text
        var _theme$text$height$he = theme.text[height].height.match(/(px|rem)/), unit = _theme$text$height$he[0];
        var lineHeight = parseMetricToNum(theme.text[height].height);
        if (unit === 'rem') lineHeight *= rootFontSize;
        if (lineHeight > iconDimension) {
            var pad = calculatePad(lineHeight, iconDimension);
            style += "padding-top: " + pad + "; padding-bottom: " + pad + ";";
        }
    }
    if (width && theme != null && (_theme$text2 = theme.text) != null && (_theme$text2 = _theme$text2[width]) != null && _theme$text2.height) {
        // the unit on theme text
        var _theme$text$width$hei = theme.text[width].height.match(/(px|rem)/), _unit = _theme$text$width$hei[0];
        var desiredWidth = parseMetricToNum(theme.text[width].height);
        if (_unit === 'rem') desiredWidth *= rootFontSize;
        if (desiredWidth > iconDimension) {
            var _pad = calculatePad(desiredWidth, iconDimension);
            style += "padding-left: " + _pad + "; padding-right: " + _pad + ";";
        }
    }
    return style;
}
var generatePrefix = function generatePrefix(name) {
    return "_grommeticons-" + name + "-" + (Date.now() + Math.random());
};
exports.default = {
    deepMerge: deepMerge,
    isObject: isObject,
    parseMetricToNum: parseMetricToNum,
    iconPad: iconPad,
    useScaleProps: useScaleProps
};

},{"react":"8CCva","styled-components":"6bGrk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eVGVa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base", ()=>(0, _base.base));
var _base = require("./base");

},{"./base":"ktiUV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ktiUV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "base", ()=>base);
var base = {
    global: {
        colors: {
            icon: '#666666'
        }
    },
    icon: {
        size: {
            small: '12px',
            medium: '24px',
            large: '48px',
            xlarge: '96px'
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eokGU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dashboard", ()=>Dashboard);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Dashboard = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Dashboard"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm3-6a3 3 0 0 0-6 0M5 5l2 2m5 0v6m0-10v2m7 7h2M3 12h2m12-5 2-2M3 17h18"
    }));
});
Dashboard.displayName = 'Dashboard';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7BwqO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Refresh", ()=>Refresh);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Refresh = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Refresh"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M20 8c-1.403-2.96-4.463-5-8-5a9 9 0 1 0 0 18 9 9 0 0 0 9-9m0-9v6h-6"
    }));
});
Refresh.displayName = 'Refresh';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3jeKP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Wraps grommet's layer with body-scroll-lock
 * @param props Grommet Layer props
 */ parcelHelpers.export(exports, "ResponsiveLayer", ()=>ResponsiveLayer);
var _jsxRuntime = require("react/jsx-runtime");
var _bodyScrollLock = require("body-scroll-lock");
var _layer = require("grommet/es6/components/Layer");
var _react = require("react");
var _box = require("grommet/es6/components/Box");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
function useRefWithCallback(onMount, onUnmount) {
    const nodeRef = (0, _react.useRef)(null);
    const setRef = (0, _react.useCallback)((node)=>{
        if (nodeRef.current) onUnmount(nodeRef.current);
        nodeRef.current = node;
        if (nodeRef.current) onMount(nodeRef.current);
    }, [
        onMount,
        onUnmount
    ]);
    return setRef;
}
function ResponsiveLayer(props) {
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    const layerRef = useRefWithCallback((0, _react.useCallback)((node)=>(0, _bodyScrollLock.disableBodyScroll)(node), []), (0, _react.useCallback)((node)=>(0, _bodyScrollLock.enableBodyScroll)(node), []));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layer.Layer), {
        ...props,
        ref: layerRef,
        className: "fix-responsive-layer",
        style: {
            overflowY: 'auto',
            ...props.style
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
            // Prevents Grommet flex overlap issue in smaller viewport
            flex: {
                shrink: 0,
                grow: 1
            },
            style: {
                minHeight: isMobile ? '100dvh' : 'auto'
            },
            children: props.children
        })
    });
}

},{"react/jsx-runtime":"6pm7f","body-scroll-lock":"4J1mN","grommet/es6/components/Layer":"3gh0x","react":"8CCva","grommet/es6/components/Box":"4o01A","grommet/es6/contexts/ResponsiveContext":"7EsNN","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4J1mN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "disableBodyScroll", ()=>disableBodyScroll);
parcelHelpers.export(exports, "clearAllBodyScrollLocks", ()=>clearAllBodyScrollLocks);
parcelHelpers.export(exports, "enableBodyScroll", ()=>enableBodyScroll);
function _toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var hasPassiveEvents = false;
if (typeof window !== 'undefined') {
    var passiveTestOptions = {
        get passive () {
            hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener('testPassive', null, passiveTestOptions);
    window.removeEventListener('testPassive', null, passiveTestOptions);
}
var isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
var locks = [];
var documentListenerAdded = false;
var initialClientY = -1;
var previousBodyOverflowSetting = void 0;
var previousBodyPosition = void 0;
var previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var allowTouchMove = function allowTouchMove(el) {
    return locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if (allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if (previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            var computedBodyPaddingRight = parseInt(window.getComputedStyle(document.body).getPropertyValue('padding-right'), 10);
            previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = computedBodyPaddingRight + scrollBarGap + 'px';
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if (previousBodyOverflowSetting === undefined) {
        previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
    }
};
var restoreOverflowSetting = function restoreOverflowSetting() {
    if (previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        previousBodyPaddingRight = undefined;
    }
    if (previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        previousBodyOverflowSetting = undefined;
    }
};
var setPositionFixed = function setPositionFixed() {
    return window.requestAnimationFrame(function() {
        // If previousBodyPosition is already set, don't set it again.
        if (previousBodyPosition === undefined) {
            previousBodyPosition = {
                position: document.body.style.position,
                top: document.body.style.top,
                left: document.body.style.left
            };
            // Update the dom inside an animation frame 
            var _window = window, scrollY = _window.scrollY, scrollX = _window.scrollX, innerHeight = _window.innerHeight;
            document.body.style.position = 'fixed';
            document.body.style.top = -scrollY;
            document.body.style.left = -scrollX;
            setTimeout(function() {
                return window.requestAnimationFrame(function() {
                    // Attempt to check if the bottom bar appeared due to the position change
                    var bottomBarHeight = innerHeight - window.innerHeight;
                    if (bottomBarHeight && scrollY >= innerHeight) // Move the content further up so that the bottom bar doesn't hide it
                    document.body.style.top = -(scrollY + bottomBarHeight);
                });
            }, 300);
        }
    });
};
var restorePositionSetting = function restorePositionSetting() {
    if (previousBodyPosition !== undefined) {
        // Convert the position from "px" to Int
        var y = -parseInt(document.body.style.top, 10);
        var x = -parseInt(document.body.style.left, 10);
        // Restore styles
        document.body.style.position = previousBodyPosition.position;
        document.body.style.top = previousBodyPosition.top;
        document.body.style.left = previousBodyPosition.left;
        // Restore scroll
        window.scrollTo(x, y);
        previousBodyPosition = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - initialClientY;
    if (allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return preventDefault(event);
    if (isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return preventDefault(event);
    event.stopPropagation();
    return true;
};
var disableBodyScroll = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if (locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    locks = [].concat(_toConsumableArray(locks), [
        lock
    ]);
    if (isIosDevice) setPositionFixed();
    else setOverflowHidden(options);
    if (isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            handleScroll(event, targetElement);
        };
        if (!documentListenerAdded) {
            document.addEventListener('touchmove', preventDefault, hasPassiveEvents ? {
                passive: false
            } : undefined);
            documentListenerAdded = true;
        }
    }
};
var clearAllBodyScrollLocks = function clearAllBodyScrollLocks() {
    if (isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if (documentListenerAdded) {
            document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? {
                passive: false
            } : undefined);
            documentListenerAdded = false;
        }
        // Reset initial clientY.
        initialClientY = -1;
    }
    if (isIosDevice) restorePositionSetting();
    else restoreOverflowSetting();
    locks = [];
};
var enableBodyScroll = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
        return;
    }
    locks = locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if (isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if (documentListenerAdded && locks.length === 0) {
            document.removeEventListener('touchmove', preventDefault, hasPassiveEvents ? {
                passive: false
            } : undefined);
            documentListenerAdded = false;
        }
    }
    if (isIosDevice) restorePositionSetting();
    else restoreOverflowSetting();
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3gh0x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layer", ()=>(0, _layer.Layer));
var _layer = require("./Layer");

},{"./Layer":"bsunU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bsunU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layer", ()=>Layer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _useIsomorphicLayoutEffect = require("../../utils/use-isomorphic-layout-effect");
var _utils = require("../../utils");
var _layerContainer = require("./LayerContainer");
var _styledLayer = require("./StyledLayer");
var _containerTargetContext = require("../../contexts/ContainerTargetContext");
var _propTypes = require("./propTypes");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Layer = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var animate = props.animate, animation = props.animation, targetChildPosition = props.targetChildPosition;
    var _useState = (0, _react.useState)(), originalFocusedElement = _useState[0], setOriginalFocusedElement = _useState[1];
    (0, _react.useEffect)(function() {
        return setOriginalFocusedElement(document.activeElement);
    }, []);
    var _useState2 = (0, _react.useState)(), layerContainer = _useState2[0], setLayerContainer = _useState2[1];
    var containerTarget = (0, _react.useContext)((0, _containerTargetContext.ContainerTargetContext));
    (0, _react.useEffect)(function() {
        return setLayerContainer((0, _utils.getNewContainer)(containerTarget, targetChildPosition));
    }, [
        containerTarget,
        targetChildPosition
    ]);
    // just a few things to clean up when the Layer is unmounted
    (0, _useIsomorphicLayoutEffect.useLayoutEffect)(function() {
        return function() {
            if (originalFocusedElement) {
                if (originalFocusedElement.focus) // wait for the fixed positioning to come back to normal
                // see layer styling for reference
                setTimeout(function() {
                    return originalFocusedElement.focus();
                }, 0);
                else if (originalFocusedElement.parentNode && originalFocusedElement.parentNode.focus) // required for IE11 and Edge
                originalFocusedElement.parentNode.focus();
            }
            if (layerContainer) {
                var activeAnimation = animation !== undefined ? animation : animate;
                if (activeAnimation !== false) {
                    // undefined uses 'slide' as the default
                    // animate out and remove later
                    var layerClone = layerContainer.cloneNode(true);
                    layerClone.id = 'layerClone';
                    containerTarget.appendChild(layerClone);
                    var clonedContainer = layerClone.querySelector('[class*="StyledLayer__StyledContainer"]');
                    if (clonedContainer && clonedContainer.style) clonedContainer.style.animationDirection = 'reverse';
                    setTimeout(function() {
                        // we add the id and query here so the unit tests work
                        var clone = containerTarget.getRootNode().getElementById('layerClone');
                        if (clone) {
                            if (containerTarget.contains(clone)) containerTarget.removeChild(clone);
                            layerContainer.remove();
                        }
                    }, (0, _styledLayer.animationDuration));
                } else if (containerTarget.contains(layerContainer)) containerTarget.removeChild(layerContainer);
            }
        };
    }, [
        animate,
        animation,
        containerTarget,
        layerContainer,
        originalFocusedElement
    ]);
    return layerContainer ? /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layerContainer.LayerContainer), _extends({
        ref: ref
    }, props)), layerContainer) : null;
});
Layer.displayName = 'Layer';
Layer.propTypes = (0, _propTypes.LayerPropTypes);

},{"react":"8CCva","react-dom":"ggrpy","../../utils/use-isomorphic-layout-effect":"jThNw","../../utils":"fx31z","./LayerContainer":"kZRCq","./StyledLayer":"8uugy","../../contexts/ContainerTargetContext":"i3UJm","./propTypes":"hZxXF","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kZRCq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayerContainer", ()=>LayerContainer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _focusedContainer = require("../FocusedContainer");
var _keyboard = require("../Keyboard");
var _responsiveContext = require("../../contexts/ResponsiveContext");
var _optionsContext = require("../../contexts/OptionsContext");
var _containerTargetContext = require("../../contexts/ContainerTargetContext");
var _analyticsContext = require("../../contexts/AnalyticsContext");
var _utils = require("../../utils");
var _styledLayer = require("./StyledLayer");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "background",
    "children",
    "full",
    "id",
    "margin",
    "modal",
    "onClickOutside",
    "onEsc",
    "plain",
    "position",
    "responsive",
    "target"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var LayerContainer = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var background = _ref.background, children = _ref.children, _ref$full = _ref.full, full = _ref$full === void 0 ? false : _ref$full, id = _ref.id, _ref$margin = _ref.margin, margin = _ref$margin === void 0 ? 'none' : _ref$margin, _ref$modal = _ref.modal, modal = _ref$modal === void 0 ? true : _ref$modal, onClickOutside = _ref.onClickOutside, onEsc = _ref.onEsc, plain = _ref.plain, _ref$position = _ref.position, position = _ref$position === void 0 ? 'center' : _ref$position, _ref$responsive = _ref.responsive, responsive = _ref$responsive === void 0 ? true : _ref$responsive, layerTarget = _ref.target, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var containerTarget = (0, _react.useContext)((0, _containerTargetContext.ContainerTargetContext));
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme, passThemeFlag = _useThemeValue1.passThemeFlag;
    var size = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext));
    // layerOptions was created to preserve backwards compatibility but
    // should not be supported in v3
    var _useContext = (0, _react.useContext)((0, _optionsContext.OptionsContext)), layerOptions = _useContext.layer;
    var containerRef = (0, _react.useRef)();
    var layerRef = (0, _react.useRef)();
    var portalContext = (0, _react.useContext)((0, _utils.PortalContext));
    var portalId = (0, _react.useMemo)(function() {
        return portalContext.length;
    }, [
        portalContext
    ]);
    var nextPortalContext = (0, _react.useMemo)(function() {
        return [].concat(portalContext, [
            portalId
        ]);
    }, [
        portalContext,
        portalId
    ]);
    var sendAnalytics = (0, _analyticsContext.useAnalytics)();
    (0, _react.useEffect)(function() {
        var start = new Date();
        var element = layerRef.current;
        var isHidden = position === 'hidden';
        if (!isHidden) sendAnalytics({
            type: 'layerOpen',
            element: element
        });
        return function() {
            if (!isHidden) sendAnalytics({
                type: 'layerClose',
                element: element,
                elapsed: new Date().getTime() - start.getTime()
            });
        };
    }, [
        sendAnalytics,
        layerRef,
        position
    ]);
    (0, _react.useEffect)(function() {
        if (position !== 'hidden') {
            var node = layerRef.current || containerRef.current || ref.current;
            if (node && node.scrollIntoView) node.scrollIntoView();
            // Once layer is open we make sure it has focus so that you
            // can start tabbing inside the layer. If the caller put focus
            // on an element already, we honor that. Otherwise, we put
            // the focus within the layer. Look at FocusedContainer.js for
            // more details.
            var element = document.activeElement;
            while(element){
                if (element === containerRef.current) break;
                element = element.parentElement;
            }
        }
    }, [
        modal,
        position,
        ref
    ]);
    (0, _react.useEffect)(function() {
        if (position !== 'hidden') {
            var node = layerRef.current || containerRef.current || ref.current;
            if (node && node.scrollIntoView) node.scrollIntoView();
        }
    }, [
        position,
        ref
    ]);
    (0, _react.useEffect)(function() {
        var onClickDocument = function onClickDocument(event) {
            // determine which portal id the target is in, if any
            var clickedPortalId = null;
            var node = event.composed && event.composedPath()[0] || event.target;
            while(clickedPortalId === null && node && node !== document && !(node instanceof ShadowRoot)){
                // check if user click occurred within the layer
                var attr = node.getAttribute('data-g-portal-id');
                if (attr !== null && attr !== '') clickedPortalId = parseInt(attr, 10);
                else node = node.parentNode;
            }
            if ((clickedPortalId === null || portalContext.indexOf(clickedPortalId) !== -1) && node !== null) // if the click occurred outside of the Layer portal, call
            // the user's onClickOutside function
            onClickOutside(event);
        };
        // if user provides an onClickOutside function, listen for mousedown event
        if (onClickOutside) document.addEventListener('mousedown', onClickDocument);
        if (layerTarget) {
            var updateBounds = function updateBounds() {
                var windowWidth = window.innerWidth;
                var windowHeight = window.innerHeight;
                var target = (0, _utils.findVisibleParent)(layerTarget);
                // affects StyledLayer
                var layer = layerRef.current;
                if (layer && target) {
                    // clear prior styling
                    layer.style.left = '';
                    layer.style.top = '';
                    layer.style.bottom = '';
                    layer.style.width = '';
                    // get bounds
                    var targetRect = target.getBoundingClientRect();
                    var layerRect = layer.getBoundingClientRect();
                    // ensure that layer moves with the target
                    layer.style.left = targetRect.left + "px";
                    layer.style.right = windowWidth - targetRect.right + "px";
                    layer.style.top = targetRect.top + "px";
                    layer.style.bottom = windowHeight - targetRect.bottom + "px";
                    layer.style.maxHeight = targetRect.height;
                    layer.style.maxWidth = Math.min(layerRect.width, windowWidth);
                }
            };
            updateBounds();
            window.addEventListener('resize', updateBounds);
            window.addEventListener('scroll', updateBounds, true);
            return function() {
                window.removeEventListener('resize', updateBounds);
                window.removeEventListener('scroll', updateBounds, true);
                if (onClickOutside) document.removeEventListener('mousedown', onClickDocument);
            };
        }
        return function() {
            if (onClickOutside) document.removeEventListener('mousedown', onClickDocument);
        };
    }, [
        containerTarget,
        layerTarget,
        onClickOutside,
        portalContext,
        portalId
    ]);
    var content = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledLayer.StyledContainer), _extends({
        ref: ref || containerRef,
        background: background,
        elevation: theme.layer.container.elevation,
        id: layerOptions && layerOptions.singleId ? id + "__container" : id,
        full: full,
        margin: margin,
        modal: modal
    }, passThemeFlag, rest, {
        position: position,
        plain: plain,
        responsive: responsive,
        layerTarget: layerTarget,
        dir: theme.dir,
        "data-g-portal-id": portalId
    }), children);
    content = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledLayer.StyledLayer), _extends({
        ref: layerRef,
        id: id,
        plain: plain,
        position: position,
        responsive: responsive,
        layerTarget: layerTarget,
        tabIndex: "-1",
        dir: theme.dir
    }, passThemeFlag), modal && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledLayer.StyledOverlay), _extends({
        plain: plain,
        responsive: responsive,
        onMouseDown: onClickOutside
    }, passThemeFlag)), content);
    if (onEsc) content = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keyboard.Keyboard), {
        onEsc: onEsc ? function(event) {
            // prevent further capturing or bubbling of event to other
            // child or parent elements
            event.stopPropagation();
            onEsc(event);
        } : undefined,
        target: modal === false ? 'document' : undefined
    }, content);
    var themeContextValue = (0, _react.useMemo)(function() {
        var dark = (0, _utils.backgroundIsDark)(theme.layer.background, theme);
        return _extends({}, theme, {
            dark: dark
        });
    }, [
        theme
    ]);
    if (theme.layer.background) {
        var dark = themeContextValue.dark;
        if (dark !== undefined && dark !== theme.dark) content = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledComponents.ThemeContext).Provider, {
            value: themeContextValue
        }, content);
    }
    content = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _utils.PortalContext).Provider, {
        value: nextPortalContext
    }, content);
    var hitResponsiveBreakpoint = responsive && size === theme.layer.responsiveBreakpoint;
    // if layer is responsive and we've hit the breakpoint,
    // the layer will be filling the viewport, so we want to
    // restrict the scroll to the layer and not allow the
    // body to scroll
    if (modal || hitResponsiveBreakpoint) content = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _focusedContainer.FocusedContainer), {
        hidden: position === 'hidden',
        restrictScroll: !layerTarget && (modal || hitResponsiveBreakpoint) ? true : undefined,
        trapFocus: true
    }, content);
    return content;
});

},{"react":"8CCva","styled-components":"6bGrk","../FocusedContainer":"do0zH","../Keyboard":"7WukC","../../contexts/ResponsiveContext":"7EsNN","../../contexts/OptionsContext":"5kzBX","../../contexts/ContainerTargetContext":"i3UJm","../../contexts/AnalyticsContext":"7ryyN","../../utils":"fx31z","./StyledLayer":"8uugy","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8uugy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animationDuration", ()=>animationDuration);
parcelHelpers.export(exports, "StyledLayer", ()=>StyledLayer);
parcelHelpers.export(exports, "StyledOverlay", ()=>StyledOverlay);
parcelHelpers.export(exports, "StyledContainer", ()=>StyledContainer);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var _utils = require("../../utils");
var hiddenPositionStyle = (0, _styledComponents.css)([
    "left:-100%;right:100%;z-index:-1;position:fixed;"
]);
var desktopLayerStyle = "\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  bottom: 0px;\n";
var responsiveLayerStyle = "\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  min-height: 100vh;\n";
var StyledLayer = (0, _styledComponentsDefault.default).div.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledLayer",
    componentId: "sc-rmtehz-0"
})([
    "",
    " background:transparent;position:relative;z-index:",
    ";pointer-events:none;outline:none;",
    " ",
    ";"
], (0, _utils.baseStyle), function(props) {
    return props.theme.layer.zIndex;
}, function(props) {
    if (props.position === 'hidden') return hiddenPositionStyle;
    var styles = [];
    styles.push(desktopLayerStyle);
    if (props.responsive && props.theme.layer.responsiveBreakpoint && !props.layerTarget) {
        var breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];
        styles.push((0, _utils.breakpointStyle)(breakpoint, responsiveLayerStyle));
    }
    return styles;
}, function(props) {
    return props.theme.layer && props.theme.layer.extend;
});
var StyledOverlay = (0, _styledComponentsDefault.default).div.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledLayer__StyledOverlay",
    componentId: "sc-rmtehz-1"
})([
    "position:absolute;",
    " top:0px;left:0px;right:0px;bottom:0px;",
    " ",
    " pointer-events:all;will-change:transform;"
], function(props) {
    if (props.responsive && props.theme.layer.responsiveBreakpoint) {
        var breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];
        return (0, _utils.breakpointStyle)(breakpoint, 'position: relative;');
    }
    return '';
}, function(props) {
    return props.theme.layer.overlay.backdropFilter && "backdrop-filter: " + props.theme.layer.overlay.backdropFilter + ";";
}, function(props) {
    return !props.plain && props.theme.layer.overlay.background && (0, _utils.backgroundStyle)(props.theme.layer.overlay.background, props.theme);
});
var getMargin = function getMargin(margin, theme, position) {
    var axis = position.indexOf('top') !== -1 || position.indexOf('bottom') !== -1 ? 'vertical' : 'horizontal';
    var marginValue = margin[position] || margin[axis] || margin;
    var marginApplied = theme.global.edgeSize[marginValue] || marginValue;
    var marginInTheme = !!theme.global.edgeSize[marginValue];
    return !marginInTheme && typeof marginValue !== 'string' ? 0 : (0, _utils.parseMetricToNum)(marginApplied);
};
var getBounds = function getBounds(bounds, margin, theme, position) {
    if (position === void 0) position = undefined;
    if (position) return bounds[position] + getMargin(margin, theme, position);
    return {
        bottom: bounds.bottom + getMargin(margin, theme, 'bottom'),
        // 'bottom-left': getMargin(margin, theme, 'bottom-left'),
        // 'bottom-right': getMargin(margin, theme, 'bottom-right'),
        end: bounds.right + getMargin(margin, theme, 'end'),
        left: bounds.left + getMargin(margin, theme, 'left'),
        right: bounds.right + getMargin(margin, theme, 'right'),
        start: bounds.left + getMargin(margin, theme, 'start'),
        top: bounds.top + getMargin(margin, theme, 'top')
    };
};
var KEYFRAMES = {
    center: {
        vertical: (0, _styledComponents.keyframes)([
            "0%{transform:translateX(-50%) scale(0.8);}100%{transform:translateX(-50%) scale(1);}"
        ]),
        horizontal: (0, _styledComponents.keyframes)([
            "0%{transform:translateY(-50%) scale(0.8);}100%{transform:translateY(-50) scale(1);}"
        ]),
        "true": (0, _styledComponents.keyframes)([
            "0%{transform:scale(0.8);}100%{transform:scale(1);}"
        ]),
        "false": (0, _styledComponents.keyframes)([
            "0%{transform:translate(-50%,-50%) scale(0.8);}100%{transform:translate(-50%,-50%) scale(1);}"
        ])
    },
    top: {
        vertical: (0, _styledComponents.keyframes)([
            "0%{transform:translate(-50%,-100%);}100%{transform:translate(-50%,0);}"
        ]),
        horizontal: (0, _styledComponents.keyframes)([
            "0%{transform:translateY(-100%);}100%{transform:translateY(0);}"
        ]),
        "true": (0, _styledComponents.keyframes)([
            "0%{transform:translateY(-100%);}100%{transform:translateY(0);}"
        ]),
        "false": (0, _styledComponents.keyframes)([
            "0%{transform:translate(-50%,-100%);}100%{transform:translate(-50%,0);}"
        ])
    },
    bottom: {
        vertical: (0, _styledComponents.keyframes)([
            "0%{transform:translate(-50%,100%);}100%{transform:translate(-50%,0);}"
        ]),
        horizontal: (0, _styledComponents.keyframes)([
            "0%{transform:translateY(100%);}100%{transform:translateY(0);}"
        ]),
        "true": (0, _styledComponents.keyframes)([
            "0%{transform:translateY(100%);}100%{transform:translateY(0);}"
        ]),
        "false": (0, _styledComponents.keyframes)([
            "0%{transform:translate(-50%,100%);}100%{transform:translate(-50%,0);}"
        ])
    },
    left: {
        vertical: (0, _styledComponents.keyframes)([
            "0%{transform:translateX(-100%);}100%{transform:translateX(0);}"
        ]),
        horizontal: (0, _styledComponents.keyframes)([
            "0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"
        ]),
        "true": (0, _styledComponents.keyframes)([
            "0%{transform:translateX(-100%);}100%{transform:translateX(0);}"
        ]),
        "false": (0, _styledComponents.keyframes)([
            "0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"
        ])
    },
    right: {
        vertical: (0, _styledComponents.keyframes)([
            "0%{transform:translateX(100%);}100%{transform:translateX(0);}"
        ]),
        horizontal: (0, _styledComponents.keyframes)([
            "0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"
        ]),
        "true": (0, _styledComponents.keyframes)([
            "0%{transform:translateX(100%);}100%{transform:translateX(0);}"
        ]),
        "false": (0, _styledComponents.keyframes)([
            "0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"
        ])
    },
    start: {
        vertical: (0, _styledComponents.keyframes)([
            "0%{transform:translateX(-100%);}100%{transform:translateX(0);}"
        ]),
        horizontal: (0, _styledComponents.keyframes)([
            "0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"
        ]),
        "true": (0, _styledComponents.keyframes)([
            "0%{transform:translateX(-100%);}100%{transform:translateX(0);}"
        ]),
        "false": (0, _styledComponents.keyframes)([
            "0%{transform:translate(-100%,-50%);}100%{transform:translate(0,-50%);}"
        ])
    },
    end: {
        vertical: (0, _styledComponents.keyframes)([
            "0%{transform:translateX(100%);}100%{transform:translateX(0);}"
        ]),
        horizontal: (0, _styledComponents.keyframes)([
            "0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"
        ]),
        "true": (0, _styledComponents.keyframes)([
            "0%{transform:translateX(100%);}100%{transform:translateX(0);}"
        ]),
        "false": (0, _styledComponents.keyframes)([
            "0%{transform:translate(100%,-50%);}100%{transform:translate(0,-50%);}"
        ])
    }
};
var animationDuration = 200;
var getAnimationStyle = function getAnimationStyle(props, position, full) {
    var animation = props.animation !== undefined ? props.animation : props.animate;
    if (animation === undefined) animation = 'slide';
    var keys;
    if (animation === 'slide' || animation === true) keys = KEYFRAMES[position][full];
    else if (animation === 'fadeIn') keys = (0, _styledComponents.keyframes)([
        "0%{opacity:0}100%{opacity:1}"
    ]);
    return keys ? (0, _styledComponents.css)([
        "animation:",
        " ",
        "s ease-in-out forwards;"
    ], keys, animationDuration / 1000.0) : '';
};
// POSITIONS combines 'position', 'full', and 'margin' properties, since
// they are all interdependent.
// Basically, non-full axes combine 50% position with -50% translation.
// full axes pin to the window edges offset by any margin.
// The keyframe animations are included as they are done via translations
// as well so they must take into account the non-animated positioning.
var POSITIONS = {
    center: {
        vertical: function vertical(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:50%;transform:translateX(-50%);",
                ""
            ], bounds.top, bounds.bottom, function(props) {
                return getAnimationStyle(props, 'center', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, _styledComponents.css)([
                "left:",
                "px;right:",
                "px;top:50%;transform:translateY(-50%);",
                ""
            ], bounds.left, bounds.right, function(props) {
                return getAnimationStyle(props, 'center', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return getAnimationStyle(props, 'center', 'true');
            });
        },
        "false": function _false() {
            return (0, _styledComponents.css)([
                "top:50%;left:50%;transform:translate(-50%,-50%);",
                ""
            ], function(props) {
                return getAnimationStyle(props, 'center', 'false');
            });
        }
    },
    top: {
        vertical: function vertical(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:50%;transform:translate(-50%,0%);",
                ""
            ], bounds.top, bounds.bottom, function(props) {
                return getAnimationStyle(props, 'top', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, _styledComponents.css)([
                "left:",
                "px;right:",
                "px;top:",
                "px;transform:translateY(0);",
                ""
            ], bounds.left, bounds.right, bounds.top, function(props) {
                return getAnimationStyle(props, 'top', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateY(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return getAnimationStyle(props, 'top', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;left:50%;transform:translate(-50%,0);",
                ""
            ], bounds.top, function(props) {
                return getAnimationStyle(props, 'top', 'false');
            });
        }
    },
    bottom: {
        vertical: function vertical(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:50%;transform:translate(-50%,0);",
                ""
            ], bounds.top, bounds.bottom, function(props) {
                return getAnimationStyle(props, 'bottom', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, _styledComponents.css)([
                "left:",
                "px;right:",
                "px;bottom:",
                "px;transform:translateY(0);",
                ""
            ], bounds.left, bounds.top, bounds.bottom, function(props) {
                return getAnimationStyle(props, 'bottom', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateY(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, _styledComponents.css)([
                "bottom:",
                "px;left:50%;transform:translate(-50%,0);",
                ""
            ], bounds.bottom, function(props) {
                return getAnimationStyle(props, 'bottom', 'false');
            });
        }
    },
    left: {
        vertical: function vertical(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, function(props) {
                return getAnimationStyle(props, 'left', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, _styledComponents.css)([
                "left:",
                "px;right:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.left, bounds.right, function(props) {
                return getAnimationStyle(props, 'left', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return getAnimationStyle(props, 'left', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, _styledComponents.css)([
                "left:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.left, function(props) {
                return getAnimationStyle(props, 'left', 'false');
            });
        }
    },
    right: {
        vertical: function vertical(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.right, function(props) {
                return getAnimationStyle(props, 'right', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, _styledComponents.css)([
                "left:",
                "px;right:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.left, bounds.right, function(props) {
                return getAnimationStyle(props, 'right', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return getAnimationStyle(props, 'right', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, _styledComponents.css)([
                "right:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.right, function(props) {
                return getAnimationStyle(props, 'right', 'false');
            });
        }
    },
    start: {
        vertical: function vertical(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;inset-inline-start:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.start, function(props) {
                return getAnimationStyle(props, 'start', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, _styledComponents.css)([
                "inset-inline-start:",
                "px;inset-inline-end:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.start, bounds.end, function(props) {
                return getAnimationStyle(props, 'start', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;inset-inline-start:",
                "px;inset-inline-end:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.start, bounds.end, function(props) {
                return getAnimationStyle(props, 'start', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, _styledComponents.css)([
                "inset-inline-start:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.start, function(props) {
                return getAnimationStyle(props, 'start', 'false');
            });
        }
    },
    end: {
        vertical: function vertical(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;inset-inline-end:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.end, function(props) {
                return getAnimationStyle(props, 'end', 'vertical');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, _styledComponents.css)([
                "inset-inline-start:",
                "px;inset-inline-end:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.start, bounds.end, function(props) {
                return getAnimationStyle(props, 'end', 'horizontal');
            });
        },
        "true": function _true(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;inset-inline-start:",
                "px;inset-inline-end:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.start, bounds.end, function(props) {
                return getAnimationStyle(props, 'end', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, _styledComponents.css)([
                "inset-inline-end:",
                "px;top:50%;transform:translate(0,-50%);",
                ""
            ], bounds.end, function(props) {
                return getAnimationStyle(props, 'end', 'false');
            });
        }
    },
    'top-right': {
        vertical: function vertical(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;right:",
                "px;transform:translateX(0);",
                ";"
            ], bounds.top, bounds.bottom, bounds.right, function(props) {
                return getAnimationStyle(props, 'top', 'true');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, _styledComponents.css)([
                "left:",
                "px;right:",
                "px;top:0;transform:translateX(0);",
                ";"
            ], bounds.left, bounds.right, function(props) {
                return getAnimationStyle(props, 'top', 'true');
            });
        },
        "true": function _true(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ";"
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return getAnimationStyle(props, 'top', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;right:",
                "px;transform:translateY(0);",
                ";"
            ], bounds.top, bounds.right, function(props) {
                return getAnimationStyle(props, 'top', 'true');
            });
        }
    },
    'top-left': {
        vertical: function vertical(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, function(props) {
                return getAnimationStyle(props, 'top', 'true');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, _styledComponents.css)([
                "left:",
                "px;right:",
                "px;top:0;transform:translateX(0);",
                ""
            ], bounds.left, bounds.right, function(props) {
                return getAnimationStyle(props, 'top', 'true');
            });
        },
        "true": function _true(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return getAnimationStyle(props, 'top', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;left:",
                "px;transform:translateY(0);",
                ""
            ], bounds.top, bounds.left, function(props) {
                return getAnimationStyle(props, 'top', 'true');
            });
        }
    },
    'bottom-right': {
        vertical: function vertical(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.right, function(props) {
                return getAnimationStyle(props, 'bottom', 'true');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, _styledComponents.css)([
                "left:",
                "px;right:",
                "px;bottom:",
                "px;transform:translateY(0);",
                ""
            ], bounds.left, bounds.right, bounds.bottom, function(props) {
                return getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "true": function _true(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, _styledComponents.css)([
                "bottom:",
                "px;right:",
                "px;transform:translateY(0);",
                ""
            ], bounds.bottom, bounds.right, function(props) {
                return getAnimationStyle(props, 'bottom', 'true');
            });
        }
    },
    'bottom-left': {
        vertical: function vertical(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, function(props) {
                return getAnimationStyle(props, 'bottom', 'true');
            });
        },
        horizontal: function horizontal(bounds) {
            return (0, _styledComponents.css)([
                "left:",
                "px;right:",
                "px;bottom:",
                "px;transform:translateY(0);",
                ""
            ], bounds.left, bounds.right, bounds.bottom, function(props) {
                return getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "true": function _true(bounds) {
            return (0, _styledComponents.css)([
                "top:",
                "px;bottom:",
                "px;left:",
                "px;right:",
                "px;transform:translateX(0);",
                ""
            ], bounds.top, bounds.bottom, bounds.left, bounds.right, function(props) {
                return getAnimationStyle(props, 'bottom', 'true');
            });
        },
        "false": function _false(bounds) {
            return (0, _styledComponents.css)([
                "bottom:",
                "px;left:",
                "px;transform:translateY(0);",
                ""
            ], bounds.bottom, bounds.left, function(props) {
                return getAnimationStyle(props, 'bottom', 'true');
            });
        }
    }
};
var roundStyle = function roundStyle(data, theme, position, margin) {
    var styles = [];
    var size = data === true ? 'medium' : data;
    // fallback to edgeSize for backwards compatibility
    var round = theme.global[theme.global.radius ? 'radius' : 'edgeSize'][size] || size;
    // if user provides CSS string such as '50px 12px', apply that always
    var customCSS = round.split(' ').length > 1;
    if (margin === 'none' && !customCSS && theme.layer.border.intelligentRounding === true) {
        if (position === 'bottom') styles.push((0, _styledComponents.css)([
            "border-radius:",
            " ",
            " 0 0;"
        ], round, round));
        else if (position === 'bottom-left') styles.push((0, _styledComponents.css)([
            "border-radius:0 ",
            " 0 0;"
        ], round));
        else if (position === 'bottom-right') styles.push((0, _styledComponents.css)([
            "border-radius:",
            " 0 0 0;"
        ], round));
        else if (position === 'end') // only works on Firefox, what should be fallback?
        styles.push((0, _styledComponents.css)([
            "border-start-start-radius:",
            ";border-end-start-radius:",
            ";"
        ], round, round));
        else if (position === 'left') styles.push((0, _styledComponents.css)([
            "border-radius:0 ",
            " ",
            " 0;"
        ], round, round));
        else if (position === 'right') styles.push((0, _styledComponents.css)([
            "border-radius:",
            " 0 0 ",
            ";"
        ], round, round));
        else if (position === 'start') // only works on Firefox, what should be fallback?
        styles.push((0, _styledComponents.css)([
            "border-end-end-radius:",
            ";border-start-end-radius:",
            ";"
        ], round, round));
        else if (position === 'top') styles.push((0, _styledComponents.css)([
            "border-radius:0 0 ",
            " ",
            ";"
        ], round, round));
        else if (position === 'top-left') styles.push((0, _styledComponents.css)([
            "border-radius:0 0 ",
            " 0;"
        ], round));
        else if (position === 'top-right') styles.push((0, _styledComponents.css)([
            "border-radius:0 0 0 ",
            ";"
        ], round));
        else // position is center, apply uniform border-radius
        styles.push((0, _styledComponents.css)([
            "border-radius:",
            ";"
        ], round));
    } else // if there's a margin apply uniform border-radius, or if user has supplied
    // a complex CSS string such as "50px 20px" apply this
    styles.push((0, _styledComponents.css)([
        "border-radius:",
        ";"
    ], round));
    return styles;
};
var bounds = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
};
var desktopContainerStyle = (0, _styledComponents.css)([
    "",
    " max-height:",
    ";max-width:",
    ";",
    ";",
    ";"
], function(props) {
    if (!props.modal && props.position === 'hidden') return hiddenPositionStyle;
    return (0, _styledComponents.css)([
        "position:",
        ";"
    ], props.modal || props.layerTarget ? 'absolute' : 'fixed');
}, function(props) {
    return "calc(100% - " + getBounds(bounds, props.margin, props.theme, 'top') + "px - " + getBounds(bounds, props.margin, props.theme, 'bottom') + "px)";
}, function(props) {
    return "calc(100% - " + getBounds(bounds, props.margin, props.theme, 'left') + "px - " + getBounds(bounds, props.margin, props.theme, 'right') + "px)";
}, function(props) {
    return props.plain || props.full && props.margin === 'none' ? "border-radius: 0;" : roundStyle(props.theme.layer.border.radius, props.theme, props.position, props.margin);
}, function(props) {
    return props.position !== 'hidden' && POSITIONS[props.position][props.full](getBounds(bounds, props.margin, props.theme), bounds) || '';
});
var responsiveContainerStyle = function responsiveContainerStyle(props) {
    return (0, _styledComponents.css)([
        "position:relative;max-height:none;max-width:none;border-radius:0;height:",
        ";width:",
        ";"
    ], !props.layerTarget ? '100vh' : '100%', !props.layerTarget ? '100vw' : '100%');
};
var elevationStyle = (0, _styledComponents.css)([
    "box-shadow:",
    ";"
], function(props) {
    return props.theme.global.elevation[props.theme.dark ? 'dark' : 'light'][props.theme.layer.container.elevation];
});
var StyledContainer = (0, _styledComponentsDefault.default).div.withConfig({
    shouldForwardProp: function shouldForwardProp(prop) {
        return (0, _isPropValidDefault.default)(prop) && ![
            'elevation'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledLayer__StyledContainer",
    componentId: "sc-rmtehz-2"
})([
    "",
    " display:flex;flex-direction:column;min-height:",
    ";",
    " outline:none;pointer-events:all;z-index:",
    ";",
    " ",
    " ",
    ";",
    ";"
], function(props) {
    return !props.modal ? (0, _utils.baseStyle) : '';
}, function(props) {
    return props.theme.global.size.xxsmall;
}, function(props) {
    return !props.plain && (props.background || props.theme.layer.background) && (0, _utils.backgroundStyle)(props.background || props.theme.layer.background, props.theme);
}, function(props) {
    return props.theme.layer.container.zIndex;
}, function(props) {
    return !props.plain && props.theme.layer.container.elevation && elevationStyle;
}, desktopContainerStyle, function(props) {
    if (props.responsive && props.theme.layer.responsiveBreakpoint) {
        var breakpoint = props.theme.global.breakpoints[props.theme.layer.responsiveBreakpoint];
        if (breakpoint) return (0, _utils.breakpointStyle)(breakpoint, responsiveContainerStyle);
    }
    return '';
}, function(props) {
    return props.theme.layer.container && props.theme.layer.container.extend;
});

},{"styled-components":"6bGrk","@emotion/is-prop-valid":"db6x2","../../utils":"fx31z","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hZxXF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayerPropTypes", ()=>LayerPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
var PAD_SIZES = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large'
];
var PropType = {};
var LayerPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8NBZt":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("elqBb");

},{}],"joaEK":[function(require,module,exports,__globalThis) {
/*
 * Used for time being until Wallet redesign is done
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrandButton", ()=>BrandButton);
var _jsxRuntime = require("react/jsx-runtime");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _button = require("grommet/es6/components/Button");
const StyledButton = (0, _styledComponentsDefault.default)((0, _button.Button))`
  font-size: 14px;
  border-radius: 8px;
  border-width: 1px;
  border-style: solid;
`;
function BrandButton(props) {
    const { brandVariant = 'brand-blue', size = 'large', ...rest } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledButton, {
        ...rest,
        primary: true,
        color: brandVariant,
        size: size
    });
}

},{"react/jsx-runtime":"6pm7f","styled-components":"6bGrk","grommet/es6/components/Button":"fVON6","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fVON6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>(0, _button.Button));
var _button = require("./Button");

},{"./Button":"dtW4F","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dtW4F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var _propTypes = require("./propTypes");
var _announceContext = require("../../contexts/AnnounceContext");
var _messageContext = require("../../contexts/MessageContext");
var _box = require("../Box");
var _tip = require("../Tip");
var _badge = require("./Badge");
var _styledButton = require("./StyledButton");
var _styledButtonKind = require("./StyledButtonKind");
var _analyticsContext = require("../../contexts/AnalyticsContext");
var _skeleton = require("../Skeleton");
var _busyAnimation = require("./BusyAnimation");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "active",
    "align",
    "aria-label",
    "badge",
    "busy",
    "color",
    "children",
    "disabled",
    "icon",
    "focusIndicator",
    "gap",
    "fill",
    "href",
    "justify",
    "kind",
    "label",
    "messages",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseOut",
    "onMouseOver",
    "pad",
    "plain",
    "primary",
    "reverse",
    "secondary",
    "selected",
    "size",
    "success",
    "tip",
    "type",
    "a11yTitle",
    "as"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var RelativeBox = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "Button__RelativeBox",
    componentId: "sc-zuqsuw-0"
})([
    "position:relative;"
]);
// We have two Styled* components to separate
// the newer default|primary|secondary approach,
// which we use the term "kind" to refer to,
// from the previous approach. Hopefully, when we get to grommet v3,
// we can drop the old way and just use kind.
//
// In the kind approach, we rely on the basic structure of the theme
// being repeated. For example: button.default, button.active,
// button.active.default all refer to a similar object containing
// { background, border, color, padding }.
// This allows us to use the same code to evaluate color and generate CSS.
// We just need to build up CSS, since selectors override previous ones.
// See StyledButtonKind.kindStyles() for this.
// And we build down to determine icon color, once we have a color from
// the latest applicable state, we can stop. See Button.getIconColor() for this.
// backgroundAndTextColor() is used in both cases to ensure we are determining
// color in the same way, so the icon and label align.
// only when default is in the theme
// Used to get the color for the icon to match what StyledButtonKind
// and backgroundStyle() will do for the label.
// The paths are ordered from basic to specific. Go through them
// specific to base until we find one that has a color and use that.
var getIconColor = function getIconColor(paths, theme, colorProp, kind) {
    if (paths === void 0) paths = [];
    var result = [];
    var index = paths.length - 1;
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    if (typeof kind === 'object') index = 0;
    // stop when we have a color or no more paths
    while(index >= 0 && !result[1]){
        var baseObj = typeof kind === 'object' && kind || theme.button;
        var obj = baseObj;
        // find sub-object under the button theme that corresponds with this path
        // for example: 'active.primary'
        if (paths[index]) {
            var parts = paths[index].split('.');
            while(obj && parts.length)obj = obj[parts.shift()];
        }
        if (obj) {
            var _obj;
            // use passed in color for background if the theme has a background color
            var background = colorProp && obj.background && obj.background.color ? colorProp : obj.background;
            // if theme object explicitly sets the color to undefined, pass false
            // to indicate that the theme doesn't want any text color
            var objColor = obj.color || (Object.prototype.hasOwnProperty.call(obj, 'color') && obj.color === undefined ? false : undefined);
            var color = void 0;
            if ((_obj = obj) != null && (_obj = _obj.icon) != null && (_obj = _obj.props) != null && _obj.color) color = obj.icon.props.color;
            else if (paths[index + 1]) {
                var _obj2;
                var _parts = paths[index + 1].split('.');
                while(baseObj && _parts.length)obj = baseObj[_parts.shift()];
                if ((_obj2 = obj) != null && (_obj2 = _obj2.icon) != null && (_obj2 = _obj2.props) != null && _obj2.color) color = obj.icon.props.color;
            }
            // use passed in color for text if the theme doesn't have
            // background or border color
            if (!color) color = colorProp && (!obj.background || !obj.background.color) && (!obj.border || !obj.border.color) ? colorProp : objColor;
            result = (0, _utils.backgroundAndTextColors)(background, color, theme);
        }
        index -= 1;
    }
    return result[1] || undefined;
};
// get the icon for the current button state
var getKindIcon = function getKindIcon(paths, theme, kind) {
    if (paths === void 0) paths = [];
    var result;
    var index = paths.length - 1;
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    if (typeof kind === 'object') index = 0;
    // stop when we have a color or no more paths
    while(index >= 0 && !result){
        var _obj3;
        var obj = typeof kind === 'object' && kind || theme.button;
        // find sub-object under the button theme that corresponds with this path
        // for example: 'active.primary'
        if (paths[index]) {
            var parts = paths[index].split('.');
            while(obj && parts.length)obj = obj[parts.shift()];
        }
        if ((_obj3 = obj) != null && _obj3.icon) result = obj.icon;
        index -= 1;
    }
    return result || undefined;
};
var getPropertyColor = function getPropertyColor(property, paths, theme, kind, primary) {
    if (paths === void 0) paths = [];
    var result;
    if (kind) {
        var obj = typeof kind === 'object' && kind || theme.button;
        // index 0 is default state
        if (paths[0]) {
            var parts = paths[0].split('.');
            while(obj && parts.length)obj = obj[parts.shift()];
        }
        if (obj) result = obj[property] || obj[property] && obj[property].color;
    } else if (primary && theme && theme.button && theme.button.primary) result = theme.button.primary[property] || theme.button.primary[property] && theme.button.primary[property].color;
    else result = theme && theme.button && theme.button[property] || theme && theme.button && theme.button[property] && theme.button[property].color;
    return result;
};
var Button = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var _theme$button$kind, _theme$button2;
    var active = _ref.active, _ref$align = _ref.align, align = _ref$align === void 0 ? 'center' : _ref$align, ariaLabel = _ref['aria-label'], badgeProp = _ref.badge, busy = _ref.busy, color = _ref.color, children = _ref.children, disabled = _ref.disabled, icon = _ref.icon, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, gap = _ref.gap, fill = _ref.fill, href = _ref.href, justify = _ref.justify, kindArg = _ref.kind, label = _ref.label, messages = _ref.messages, _onBlur = _ref.onBlur, onClickProp = _ref.onClick, _onFocus = _ref.onFocus, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, pad = _ref.pad, plain = _ref.plain, primary = _ref.primary, reverseProp = _ref.reverse, secondary = _ref.secondary, selected = _ref.selected, sizeProp = _ref.size, success = _ref.success, tip = _ref.tip, _ref$type = _ref.type, type = _ref$type === void 0 ? 'button' : _ref$type, _ref$a11yTitle = _ref.a11yTitle, a11yTitle = _ref$a11yTitle === void 0 ? typeof tip === 'string' ? tip : undefined : _ref$a11yTitle, as = _ref.as, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme, passThemeFlag = _useThemeValue1.passThemeFlag;
    var _useState = (0, _react.useState)(), focus = _useState[0], setFocus = _useState[1];
    var _useState2 = (0, _react.useState)(false), hover = _useState2[0], setHover = _useState2[1];
    var announce = (0, _react.useContext)((0, _announceContext.AnnounceContext));
    var _useContext = (0, _react.useContext)((0, _messageContext.MessageContext)), format = _useContext.format;
    if (busy && success) console.warn('Button cannot have both busy and success set to true.');
    (0, _react.useEffect)(function() {
        if (busy) announce(format({
            id: 'button.busy',
            messages: messages
        }));
        else if (success) announce(format({
            id: 'button.success',
            messages: messages
        }));
    }, [
        announce,
        busy,
        format,
        messages,
        success
    ]);
    if ((icon || label) && children) console.warn('Button should not have children if icon or label is provided');
    var skeleton = (0, _skeleton.useSkeleton)();
    var sendAnalytics = (0, _analyticsContext.useAnalytics)();
    var onClick = (0, _react.useCallback)(function(event) {
        sendAnalytics({
            type: 'buttonClick',
            element: (0, _utils.findButtonParent)(event.target),
            event: event,
            href: href,
            label: typeof label === 'string' ? label : undefined
        });
        if (onClickProp) onClickProp(event);
    }, [
        onClickProp,
        sendAnalytics,
        href,
        label
    ]);
    // kindArg is object if we are referencing a theme object
    // outside of theme.button
    var kindObj = (0, _react.useMemo)(function() {
        return typeof kindArg === 'object';
    }, [
        kindArg
    ]);
    // if the theme has button.default, what kind of Button is this
    var kind = (0, _react.useMemo)(function() {
        if (theme.button["default"] || kindObj) {
            if (kindArg) return kindArg;
            if (primary) return 'primary';
            if (secondary) return 'secondary';
            return 'default';
        }
        return undefined; // pre-default, no kind
    }, [
        kindArg,
        kindObj,
        primary,
        secondary,
        theme
    ]);
    // for backwards compatibility, no-kind button theme did not
    // default to size "medium" on buttons with no size prop
    var size = sizeProp || kind && 'medium' || undefined;
    // When we have a kind and are not plain, themePaths stores the relative
    // paths within the theme for the current kind and state of the button.
    // These paths are used with getIconColor() above and kindStyle() within
    // StyledButtonKind.
    var themePaths = (0, _react.useMemo)(function() {
        if (!kind || plain) return undefined;
        var result = {
            base: [],
            hover: []
        };
        if (!kindObj) result.base.push(kind);
        if (selected) {
            result.base.push('selected');
            if (!kindObj) result.base.push("selected." + kind);
        }
        if (disabled) {
            result.base.push('disabled');
            if (!kindObj) result.base.push("disabled." + kind);
        } else {
            if (active) {
                result.base.push('active');
                if (!kindObj) result.base.push("active." + kind);
            }
            result.hover.push('hover');
            if (!kindObj) result.hover.push("hover." + kind);
            if (active) {
                result.hover.push("hover.active");
                if (!kindObj) result.hover.push("hover.active." + kind);
            }
        }
        return result;
    }, [
        active,
        disabled,
        kind,
        kindObj,
        plain,
        selected
    ]);
    // only used when theme does not have button.default
    var isDarkBackground = function isDarkBackground() {
        var backgroundColor = (0, _utils.normalizeBackground)((0, _utils.normalizeColor)(color || theme.button.primary && theme.button.primary.color || theme.global.colors.control || 'brand', theme), theme);
        return (0, _utils.colorIsDark)(backgroundColor, theme);
    };
    var onMouseOverButton = function onMouseOverButton(event) {
        setHover(true);
        if (onMouseOver) onMouseOver(event);
    };
    var onMouseOutButton = function onMouseOutButton(event) {
        setHover(false);
        if (onMouseOut) onMouseOut(event);
    };
    var kindIcon = hover && getKindIcon(themePaths == null ? void 0 : themePaths.hover, theme, kind) || getKindIcon(themePaths == null ? void 0 : themePaths.base, theme, kind);
    var buttonIcon = icon || kindIcon;
    // only change color if user did not specify the color themselves...
    if (icon && !icon.props.color) {
        if (kind) {
            if (!plain) {
                // match what the label will use
                var iconColor = hover && getIconColor(themePaths.hover, theme) || getIconColor(themePaths.base, theme, color, kind);
                if (iconColor) buttonIcon = /*#__PURE__*/ (0, _react.cloneElement)(icon, {
                    color: iconColor
                });
            }
        } else if (primary) buttonIcon = /*#__PURE__*/ (0, _react.cloneElement)(icon, {
            color: theme.global.colors.text[isDarkBackground() ? 'dark' : 'light']
        });
    } else if (kindIcon && !plain) {
        var _iconColor = hover && getIconColor(themePaths.hover, theme) || getIconColor(themePaths.base, theme, color, kind);
        if (_iconColor) buttonIcon = /*#__PURE__*/ (0, _react.cloneElement)(kindIcon, {
            color: _iconColor
        });
    }
    buttonIcon = (0, _utils.useSizedIcon)(buttonIcon, size, theme);
    if (skeleton) {
        var _theme$text, _theme$button$size;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _skeleton.Skeleton), _extends({
            ref: ref,
            height: ((_theme$text = theme.text[size || 'medium']) == null ? void 0 : _theme$text.height) || size,
            a11yTitle: a11yTitle
        }, rest, (_theme$button$size = theme.button.size) == null ? void 0 : _theme$button$size[size || 'medium'], theme.button.skeleton));
    }
    var reverse = reverseProp != null ? reverseProp : (_theme$button$kind = theme.button[kind]) == null ? void 0 : _theme$button$kind.reverse;
    var domTag = !as && href ? 'a' : as;
    var first = reverse ? label : buttonIcon;
    var second = reverse ? buttonIcon : label;
    var contents;
    if (first && second) {
        var _theme$button;
        contents = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
            direction: ((_theme$button = theme.button) == null || (_theme$button = _theme$button[kind]) == null ? void 0 : _theme$button.direction) || 'row',
            align: "center",
            justify: justify || (align === 'center' ? 'center' : 'between'),
            gap: gap || theme.button.gap,
            responsive: false
        }, first, second);
    } else if (typeof children === 'function') contents = children({
        active: active,
        disabled: disabled,
        hover: hover,
        focus: focus
    });
    else contents = first || second || children;
    var background = getPropertyColor('background', themePaths && themePaths.base, theme, kind, primary);
    var border = getPropertyColor('border', themePaths && themePaths.base, theme, kind, primary);
    // set the badge relative to the button content
    // when the button doesn't have background or border
    // (!kind && icon && !label) is necessary because for old button logic,
    // if button has icon but not label, it will be considered "plain",
    // so no border or background will be applied
    var innerBadge = ((_theme$button2 = theme.button) == null || (_theme$button2 = _theme$button2.badge) == null ? void 0 : _theme$button2.align) !== 'container' && (!background && !border || !kind && icon && !label);
    if (badgeProp && innerBadge) contents = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _badge.Badge), {
        content: badgeProp
    }, contents);
    if (busy || success) {
        // match what the label will use
        var animationColor;
        if (kind) {
            if (!plain) animationColor = hover && getIconColor(themePaths.hover, theme) || getIconColor(themePaths.base, theme, color, kind);
        } else if (primary) animationColor = theme.global.colors.text[isDarkBackground() ? 'dark' : 'light'];
        contents = /*#__PURE__*/ // position relative is necessary to have the animation
        // display over the button content
        (0, _reactDefault.default).createElement(RelativeBox, {
            flex: false
        }, busy && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _busyAnimation.EllipsisAnimation), null), success && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
            style: {
                position: 'absolute'
            },
            fill: true,
            alignContent: "center",
            justify: "center"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _busyAnimation.GrowCheckmark), {
            color: animationColor,
            "aria-hidden": true
        })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _busyAnimation.StyledBusyContents), {
            animating: busy || success
        }, contents));
    }
    var styledButtonResult;
    if (kind) styledButtonResult = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledButtonKind.StyledButtonKind), _extends({}, rest, {
        as: domTag,
        ref: ref,
        active: active,
        align: align,
        "aria-label": ariaLabel || a11yTitle,
        busy: busy,
        badge: badgeProp,
        colorValue: color,
        disabled: disabled,
        hasIcon: !!icon,
        gap: gap,
        hasLabel: !!label,
        icon: icon,
        fillContainer: fill,
        focus: focus,
        focusIndicator: focusIndicator,
        href: href,
        kind: kind,
        themePaths: themePaths,
        onClick: !busy && !success ? onClick : undefined,
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onMouseOver: onMouseOverButton,
        onMouseOut: onMouseOutButton,
        pad: pad,
        plain: plain || (0, _react.Children).count(children) > 0,
        primary: primary,
        selected: selected,
        sizeProp: size,
        success: success,
        type: !href ? type : undefined
    }, passThemeFlag), contents);
    else styledButtonResult = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledButton.StyledButton), _extends({}, rest, {
        as: domTag,
        ref: ref,
        "aria-label": ariaLabel || a11yTitle,
        busy: busy,
        colorValue: color,
        active: active,
        selected: selected,
        disabled: disabled,
        hasIcon: !!icon,
        gap: gap,
        hasLabel: !!label,
        fillContainer: fill,
        focus: focus,
        focusIndicator: focusIndicator,
        href: href,
        kind: kind,
        themePaths: themePaths,
        onClick: !busy && !success ? onClick : undefined,
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onMouseOver: onMouseOverButton,
        onMouseOut: onMouseOutButton,
        pad: pad || !plain,
        plain: typeof plain !== 'undefined' ? plain : (0, _react.Children).count(children) > 0 || icon && !label,
        primary: primary,
        sizeProp: size,
        success: success,
        type: !href ? type : undefined
    }, passThemeFlag), contents);
    if (tip) {
        if (typeof tip === 'string') styledButtonResult = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tip.Tip), {
            content: tip
        }, styledButtonResult);
        else styledButtonResult = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tip.Tip), tip, styledButtonResult);
    }
    // if button has background or border, place badge relative
    // to outer edge of button
    if (badgeProp && !innerBadge) styledButtonResult = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _badge.Badge), {
        content: badgeProp
    }, styledButtonResult);
    return styledButtonResult;
});
Button.displayName = 'Button';
Button.propTypes = (0, _propTypes.ButtonPropTypes);

},{"react":"8CCva","styled-components":"6bGrk","../../utils":"fx31z","./propTypes":"B8SoQ","../../contexts/AnnounceContext":"fESY4","../../contexts/MessageContext":"9V5sq","../Box":"4o01A","../Tip":"55RvR","./Badge":"fW2f5","./StyledButton":"8Ojla","./StyledButtonKind":"7y4MQ","../../contexts/AnalyticsContext":"7ryyN","../Skeleton":"aLlmA","./BusyAnimation":"iyBo3","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"B8SoQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonPropTypes", ()=>ButtonPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var PropType = {};
var ButtonPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fW2f5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Badge", ()=>Badge);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var _useIsomorphicLayoutEffect = require("../../utils/use-isomorphic-layout-effect");
var _box = require("../Box");
var _stack = require("../Stack");
var _text = require("../Text");
var _useThemeValue = require("../../utils/useThemeValue");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var StyledBadgeContainer = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "Badge__StyledBadgeContainer",
    componentId: "sc-1es4ws1-0"
})([
    "",
    ""
], function(props) {
    return props.theme.button.badge.container.extend;
});
var Badge = function Badge(_ref) {
    var children = _ref.children, content = _ref.content;
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme, passThemeFlag = _useThemeValue1.passThemeFlag;
    var containerRef = (0, _react.useRef)();
    var contentRef = (0, _react.useRef)();
    var stackRef = (0, _react.useRef)();
    var defaultBadgeDimension = typeof content === 'boolean' || content && content.value && typeof content.value === 'boolean' ? // after experimenting with various values
    (0, _utils.parseMetricToNum)(theme.button.badge.size.medium) / 2 + "px" : theme.button.badge.size.medium;
    // scale badge to fit its contents, leaving space horizontally
    // that is proportional to vertical space
    (0, _useIsomorphicLayoutEffect.useLayoutEffect)(function() {
        // when window resizes and hits a responsive breakpoint, width of the badge
        // can change (because pad is responsive, etc.). we want to recalculate
        // width since badge offset is reliant on its dimensions.
        var onResize = function onResize() {
            if (containerRef != null && containerRef.current) {
                containerRef.current.style.minHeight = '';
                containerRef.current.style.minWidth = '';
                if (contentRef != null && contentRef.current) {
                    if (typeof content === 'number' || typeof content === 'object' && content.value) {
                        containerRef.current.style.minHeight = defaultBadgeDimension;
                        containerRef.current.style.minWidth = defaultBadgeDimension;
                        var _contentRef$current$g = contentRef.current.getBoundingClientRect(), contentHeight = _contentRef$current$g.height, contentWidth = _contentRef$current$g.width;
                        // only adjust the width if contentHeight > 0
                        // jest returns 0 for all getBoundingClientRect values,
                        // so this ensures snapshots are closer to correct values
                        if (contentHeight) {
                            // height of content includes extra space around font from
                            // line-height. account for this extra space with 2.5 multiplier
                            // to add proportional horizontal space
                            var height = defaultBadgeDimension;
                            var width = defaultBadgeDimension;
                            var verticalSpace = ((0, _utils.parseMetricToNum)(height) - contentHeight) * 2.5;
                            containerRef.current.style.minHeight = height;
                            containerRef.current.style.minWidth = Math.max((0, _utils.parseMetricToNum)(width), Math.ceil(contentWidth + verticalSpace)) + "px";
                        }
                    } else {
                        // caller has provided custom JSX
                        containerRef.current.style.minHeight = contentRef.current.getBoundingClientRect().width;
                        containerRef.current.style.minWidth = contentRef.current.getBoundingClientRect().height;
                    }
                } else {
                    containerRef.current.style.minHeight = defaultBadgeDimension;
                    containerRef.current.style.minWidth = defaultBadgeDimension;
                }
            }
        };
        window.addEventListener('resize', onResize);
        onResize();
        return function() {
            window.removeEventListener('resize', onResize);
        };
    }, [
        content,
        defaultBadgeDimension
    ]);
    // offset the badge so it overlaps content
    (0, _useIsomorphicLayoutEffect.useLayoutEffect)(function() {
        if (stackRef != null && stackRef.current) {
            // when badge has content, offset should be 50%.
            // when badge is empty, offset by a smaller amount to keep the badge
            // closer to the content. this value was chosen as a reasonable default
            // after testing with various grommet icons.
            var offset = typeof content === 'boolean' || content && content.value === true ? '25%' : '50%';
            // second child of Stack is the div that receives absolute positioning
            // and contains our badge content
            stackRef.current.children[1].style.top = 0;
            stackRef.current.children[1].style.right = 0;
            // eslint-disable-next-line max-len
            stackRef.current.children[1].style.transform = "translate(" + offset + ", -" + offset + ")";
            stackRef.current.children[1].style.transformOrigin = '100% 0%';
        }
    }, [
        content
    ]);
    var value;
    if (typeof content === 'number') value = content;
    else if (typeof content === 'object') value = content.value;
    var badge;
    if (typeof value === 'number' || typeof value === 'boolean' || typeof content === 'boolean') {
        if (typeof value === 'number') {
            var max = content.max || 9;
            badge = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
                color: "text-strong",
                size: theme.button.badge.text.size.medium,
                weight: "normal",
                ref: contentRef
            }, value > max ? max + "+" : value);
        }
        badge = /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledBadgeContainer, _extends({
            ref: containerRef,
            align: "center",
            background: content.background || theme.button.badge.container.background,
            flex: false,
            justify: "center",
            round: true,
            pad: !(typeof value === 'boolean' || typeof content === 'boolean') ? theme.button.badge.container.pad : undefined
        }, passThemeFlag), badge);
    // caller has provided their own JSX and we will just render that
    } else badge = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
        ref: contentRef
    }, content);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _stack.Stack), {
        ref: stackRef,
        anchor: "top-right"
    }, children, badge);
};

},{"react":"8CCva","styled-components":"6bGrk","../../utils":"fx31z","../../utils/use-isomorphic-layout-effect":"jThNw","../Box":"4o01A","../Stack":"4gdMC","../Text":"kz1Ni","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4gdMC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Stack", ()=>(0, _stack.Stack));
var _stack = require("./Stack");

},{"./Stack":"bnL37","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bnL37":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Stack", ()=>Stack);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledStack = require("./StyledStack");
var _propTypes = require("./propTypes");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "anchor",
    "children",
    "fill",
    "guidingChild",
    "interactiveChild"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var buildStyledChildren = function buildStyledChildren(_ref) {
    var anchor = _ref.anchor, fill = _ref.fill, guidingIndex = _ref.guidingIndex, interactiveChild = _ref.interactiveChild, interactiveIndex = _ref.interactiveIndex;
    return function(child, index) {
        var interactive = interactiveChild === undefined || interactiveIndex === index;
        var isGuidingIndex = index === guidingIndex;
        var props = isGuidingIndex ? {
            guiding: true,
            fillContainer: fill
        } : {
            anchor: anchor
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledStack.StyledStackLayer), _extends({
            key: index,
            interactive: interactive
        }, props), child);
    };
};
var Stack = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref2, ref) {
    var anchor = _ref2.anchor, children = _ref2.children, fill = _ref2.fill, guidingChild = _ref2.guidingChild, interactiveChild = _ref2.interactiveChild, rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), passThemeFlag = _useThemeValue1.passThemeFlag;
    var prunedChildren = (0, _react.Children).toArray(children).filter(function(c) {
        return c;
    });
    var toChildIndex = function toChildIndex(child) {
        var index = child;
        if (index === 'first' || !index) index = 0;
        else if (index === 'last') index = prunedChildren.length - 1;
        return index;
    };
    var guidingIndex = toChildIndex(guidingChild);
    var interactiveIndex = interactiveChild && toChildIndex(interactiveChild);
    var styledChildren = prunedChildren.map(buildStyledChildren({
        anchor: anchor,
        fill: fill,
        guidingIndex: guidingIndex,
        interactiveChild: interactiveChild,
        interactiveIndex: interactiveIndex
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledStack.StyledStack), _extends({
        ref: ref,
        fillContainer: fill
    }, passThemeFlag, rest), styledChildren);
});
Stack.displayName = 'Stack';
Stack.propTypes = (0, _propTypes.StackPropTypes);

},{"react":"8CCva","./StyledStack":"cahDr","./propTypes":"fBRQV","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cahDr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledStack", ()=>StyledStack);
parcelHelpers.export(exports, "StyledStackLayer", ()=>StyledStackLayer);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var fillStyle = (0, _styledComponents.css)([
    "",
    " ",
    " flex-grow:1;display:flex;"
], function(props) {
    return props.fillContainer === true || props.fillContainer === 'horizontal' ? "\n        width: 100%;\n        max-width: none;\n      " : '';
}, function(props) {
    return props.fillContainer === true || props.fillContainer === 'vertical' ? 'height: 100%;' : '';
});
var StyledStack = (0, _styledComponentsDefault.default).div.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledStack",
    componentId: "sc-ajspsk-0"
})([
    "position:relative;",
    " ",
    " ",
    ""
], (0, _utils.genericStyles), function(props) {
    return props.fillContainer && fillStyle;
}, function(props) {
    return props.theme.stack && props.theme.stack.extend;
});
var styleMap = {
    fill: "\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  ",
    center: "\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  ",
    left: "\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n  ",
    right: "\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n  ",
    top: "\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  ",
    bottom: "\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n  ",
    'top-left': "\n    top: 0;\n    left: 0;\n  ",
    'bottom-left': "\n    bottom: 0;\n    left: 0;\n  ",
    'top-right': "\n    top: 0;\n    right: 0;\n  ",
    'bottom-right': "\n    bottom: 0;\n    right: 0;\n  "
};
var StyledStackLayer = (0, _styledComponentsDefault.default).div.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledStack__StyledStackLayer",
    componentId: "sc-ajspsk-1"
})([
    "position:",
    ";",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return props.guiding ? 'relative' : 'absolute';
}, function(props) {
    return props.guiding && 'display: block;';
}, function(props) {
    return !props.guiding && styleMap[props.anchor || 'fill'] + ";";
}, function(props) {
    return props.fillContainer && "\n    width: 100%;\n    height: 100%;\n  ";
}, function(props) {
    return !props.interactive && "pointer-events: none;";
});

},{"styled-components":"6bGrk","../../utils":"fx31z","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fBRQV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StackPropTypes", ()=>StackPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var PropType = {};
var StackPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8Ojla":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledButton", ()=>StyledButton);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var _styles = require("../../utils/styles");
var radiusStyle = function radiusStyle(props) {
    // border.radius shouldn't impact an only-icon rendering.
    var isIconOnly = props.hasIcon && !props.hasLabel;
    var size = props.sizeProp;
    if (!isIconOnly && size && props.theme.button.size && props.theme.button.size[size]) return props.theme.button.size[size].border.radius;
    return props.theme.button.border.radius;
};
var fontStyle = function fontStyle(props) {
    var size = props.sizeProp || 'medium';
    var data = props.theme.text[size];
    return (0, _styledComponents.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, data.height);
};
var padStyle = function padStyle(props) {
    var size = props.sizeProp;
    if (size && props.theme.button.size && props.theme.button.size[size]) return (0, _styledComponents.css)([
        "",
        " ",
        ""
    ], props.theme.button.size[size].pad.vertical, props.theme.button.size[size].pad.horizontal);
    return (0, _styledComponents.css)([
        "",
        " ",
        ""
    ], props.theme.button.padding.vertical, props.theme.button.padding.horizontal);
};
var basicStyle = function basicStyle(props) {
    return (0, _styledComponents.css)([
        "border:",
        " solid ",
        ";border-radius:",
        ";",
        " color:",
        ";padding:",
        ";",
        ""
    ], props.theme.button.border.width, (0, _utils.normalizeColor)(props.colorValue || props.theme.button.border.color || 'control', props.theme), radiusStyle(props), props.theme.button.elevation && (0, _styles.elevationStyle)(props.theme.button.elevation), (0, _utils.normalizeColor)(props.theme.button.color || 'text', props.theme), padStyle(props), fontStyle(props));
};
var primaryStyle = function primaryStyle(props) {
    var _props$theme$button$p, _props$theme$button$p2;
    return (0, _styledComponents.css)([
        "",
        " border-radius:",
        ";",
        " ",
        ""
    ], (0, _utils.backgroundStyle)((0, _utils.normalizeColor)(props.colorValue || props.theme.button.primary && props.theme.button.primary.color || 'control', props.theme), props.theme, props.theme.button.color), radiusStyle(props), ((_props$theme$button$p = props.theme.button.primary) == null ? void 0 : _props$theme$button$p.elevation) && (0, _styles.elevationStyle)((_props$theme$button$p2 = props.theme.button.primary) == null ? void 0 : _props$theme$button$p2.elevation), props.theme.button.primary && props.theme.button.primary.extend);
};
function getHoverColor(props) {
    if (props.colorValue) return (0, _utils.normalizeColor)(props.colorValue, props.theme);
    if (props.active && props.primary && props.theme.button.primary && props.theme.button.primary.active && props.theme.button.primary.active.border && props.theme.button.primary.active.border.color) return (0, _utils.normalizeColor)(props.theme.button.primary.active.border.color, props.theme);
    return (0, _utils.normalizeColor)(props.theme.button.border.color || 'control', props.theme);
}
var hoverStyle = (0, _styledComponents.css)([
    "&:hover{",
    " ",
    ";}"
], function(props) {
    return props.hoverIndicator && (0, _utils.getHoverIndicatorStyle)(props.hoverIndicator, props.theme);
}, function(props) {
    return !props.plain && (0, _styledComponents.css)([
        "box-shadow:0px 0px 0px 2px ",
        ";"
    ], getHoverColor(props));
});
var fillStyle = function fillStyle(fillContainer) {
    if (fillContainer === 'horizontal') return 'width: 100%;';
    if (fillContainer === 'vertical') return 'height: 100%;';
    if (fillContainer) return "\n      width: 100%;\n      height: 100%;\n      max-width: none;\n      flex: 1 0 auto;\n    ";
    return undefined;
};
var plainStyle = function plainStyle(props) {
    return (0, _styledComponents.css)([
        "color:",
        ";outline:none;border:none;padding:0;text-align:inherit;"
    ], (0, _utils.normalizeColor)(props.colorValue || 'inherit', props.theme));
};
var activeButtonStyle = function activeButtonStyle(props) {
    return (0, _styledComponents.css)([
        "",
        " ",
        " ",
        ""
    ], (0, _utils.activeStyle), props.primary && props.theme.button.primary && props.theme.button.primary.active && props.theme.button.primary.active.border && props.theme.button.primary.active.border.color && "border: " + props.theme.button.border.width + " solid\n    " + (0, _utils.normalizeColor)(props.theme.button.primary.active.border.color, props.theme) + ";\n    ", props.primary && props.theme.button.primary && props.theme.button.primary.active && props.theme.button.primary.active.extend);
};
var disabledButtonStyle = function disabledButtonStyle(props) {
    return (0, _styledComponents.css)([
        "",
        " ",
        " ",
        " ",
        ""
    ], (0, _utils.disabledStyle)(props.theme.button.disabled.opacity), !props.plain && props.theme.button.disabled.border && props.theme.button.disabled.border.color && "border: " + props.theme.button.border.width + " solid\n    " + (0, _utils.normalizeColor)(props.theme.button.disabled.border.color, props.theme) + ";", props.theme.button.disabled.color && // if primary button, apply disabled color to background. otherwise,
    // apply disabled color to the label
    (props.primary ? (0, _utils.backgroundStyle)((0, _utils.normalizeColor)(props.theme.button.disabled.color, props.theme), props.theme, props.theme.button.color) : "color: " + (0, _utils.normalizeColor)(props.theme.button.disabled.color, props.theme) + ";"), props.theme.button.disabled && props.theme.button.disabled.extend);
};
// Deprecate props.theme.button.disabled.opacity in V3
var StyledButton = (0, _styledComponentsDefault.default).button.withConfig((0, _styles.styledComponentsConfig)).withConfig({
    displayName: "StyledButton",
    componentId: "sc-323bzc-0"
})([
    "display:inline-block;box-sizing:border-box;cursor:pointer;font:inherit;text-decoration:none;margin:0;background:transparent;overflow:visible;text-transform:none;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " &:focus{",
    "}&:focus:not(:focus-visible){",
    "}",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, _utils.genericStyles), function(props) {
    return props.plain && plainStyle(props);
}, function(props) {
    return !props.plain && basicStyle(props);
}, function(props) {
    return props.primary && primaryStyle(props);
}, function(props) {
    return !props.disabled && !props.selected && !props.focus && !props.busy && !props.success && hoverStyle;
}, function(props) {
    return !props.disabled && props.active && activeButtonStyle(props);
}, function(props) {
    return props.disabled && props.theme.button && props.theme.button.disabled && disabledButtonStyle(props);
}, function(props) {
    return (!props.plain || props.focusIndicator) && (0, _utils.focusStyle)();
}, (0, _utils.unfocusStyle)(), function(props) {
    return !props.plain && props.theme.button.transition && "\n    transition-property: " + props.theme.button.transition.properties.join(',') + ";\n    transition-duration: " + props.theme.button.transition.duration + "s;\n    transition-timing-function: " + props.theme.button.transition.timing + ";\n  ";
}, function(props) {
    return props.fillContainer && fillStyle(props.fillContainer);
}, function(props) {
    return props.hasIcon && !props.hasLabel && "\n    line-height: 0;\n  ";
}, function(props) {
    return props.pad === true && props.hasIcon && !props.hasLabel && "\n    padding: " + props.theme.global.edgeSize.small + ";\n  ";
}, function(props) {
    return !props.plain && props.pad && (0, _utils.edgeStyle)('padding', props.pad, false, undefined, props.theme);
}, function(props) {
    return props.theme.button && props.theme.button.extend;
}, function(props) {
    return (props.busy || props.success) && "\n    cursor: default;\n  ";
});

},{"styled-components":"6bGrk","../../utils":"fx31z","../../utils/styles":"4m6LZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7y4MQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledButtonKind", ()=>StyledButtonKind);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _isPropValid = require("@emotion/is-prop-valid");
var _isPropValidDefault = parcelHelpers.interopDefault(_isPropValid);
var _utils = require("../../utils");
var radiusStyle = function radiusStyle(props) {
    var size = props.sizeProp;
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    var themeObj = typeof props.kind === 'object' ? props.kind : props.theme.button;
    if (size && themeObj.size && themeObj.size[size]) return (0, _styledComponents.css)([
        "border-radius:",
        ";"
    ], themeObj.size[size].border.radius);
    if (themeObj.border && themeObj.border.radius) return (0, _styledComponents.css)([
        "border-radius:",
        ";"
    ], themeObj.border.radius);
    return '';
};
var fontStyle = function fontStyle(props) {
    var size = props.sizeProp || 'medium';
    var data = props.theme.text[size];
    return (0, _styledComponents.css)([
        "font-size:",
        ";line-height:",
        ";"
    ], data.size, props.hasIcon && !props.hasLabel ? 0 : data.height);
};
var padFromTheme = function padFromTheme(size, theme, themeObj, kind, iconOnly) {
    var _themeObj$size, _themeObj$size3;
    if (size === void 0) size = 'medium';
    if (size && iconOnly && themeObj != null && (_themeObj$size = themeObj.size) != null && (_themeObj$size = _themeObj$size[size]) != null && (_themeObj$size = _themeObj$size.iconOnly) != null && _themeObj$size.pad) {
        var _themeObj$size2;
        var pad = themeObj == null || (_themeObj$size2 = themeObj.size) == null || (_themeObj$size2 = _themeObj$size2[size]) == null || (_themeObj$size2 = _themeObj$size2.iconOnly) == null ? void 0 : _themeObj$size2.pad;
        return {
            vertical: typeof pad === 'string' ? pad : pad.vertical,
            horizontal: typeof pad === 'string' ? pad : pad.horizontal
        };
    }
    if (size && themeObj != null && (_themeObj$size3 = themeObj.size) != null && (_themeObj$size3 = _themeObj$size3[size]) != null && (_themeObj$size3 = _themeObj$size3[kind]) != null && _themeObj$size3.pad) return themeObj.size[size][kind].pad;
    if (size && themeObj.size && themeObj.size[size] && themeObj.size[size].pad) return {
        vertical: themeObj.size[size].pad.vertical,
        horizontal: themeObj.size[size].pad.horizontal
    };
    if (theme.button.padding) return {
        vertical: theme.global.edgeSize[theme.button.padding.vertical] || theme.button.padding.vertical,
        horizontal: theme.global.edgeSize[theme.button.padding.horizontal] || theme.button.padding.horizontal
    };
    return undefined;
};
var padStyle = function padStyle(_ref) {
    var hasIcon = _ref.hasIcon, hasLabel = _ref.hasLabel, size = _ref.sizeProp, theme = _ref.theme, kind = _ref.kind;
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    var themeObj = typeof kind === 'object' ? kind : theme.button;
    var iconOnly = hasIcon && !hasLabel;
    var pad = padFromTheme(size, theme, themeObj, kind, iconOnly);
    return pad ? (0, _styledComponents.css)([
        "padding:",
        " ",
        ";"
    ], pad.vertical, pad.horizontal) : '';
};
var basicStyle = function basicStyle(props) {
    return (0, _styledComponents.css)([
        "border:none;",
        ";",
        " ",
        " ",
        ""
    ], radiusStyle(props), padStyle(props), fontStyle(props), props.icon && "\n    > svg {\n      display: flex;\n      align-self: center;\n      vertical-align: middle;\n    }\n  ");
};
var getPath = function getPath(theme, path) {
    var obj;
    if (path) {
        obj = theme;
        var parts = path.split('.');
        while(obj && parts.length)obj = obj[parts.shift()];
    }
    return obj;
};
var adjustPadStyle = function adjustPadStyle(pad, width, theme) {
    var _theme$button;
    var intelligentPad = theme == null || (_theme$button = theme.button) == null ? void 0 : _theme$button.intelligentPad;
    if (intelligentPad === true) {
        var offset = (0, _utils.parseMetricToNum)(width);
        return (0, _styledComponents.css)([
            "padding:",
            "px ",
            "px;"
        ], Math.max((0, _utils.parseMetricToNum)(pad.vertical) - offset, 0), Math.max((0, _utils.parseMetricToNum)(pad.horizontal) - offset, 0));
    }
    // If intelligentPad is false return padding without adjustment
    return (0, _styledComponents.css)([
        "padding:",
        " ",
        ";"
    ], pad.vertical, pad.horizontal);
};
// build up CSS from basic to specific based on the supplied sub-object paths
var kindStyle = function kindStyle(_ref2) {
    var busy = _ref2.busy, colorValue = _ref2.colorValue, hasIcon = _ref2.hasIcon, hasLabel = _ref2.hasLabel, kind = _ref2.kind, size = _ref2.sizeProp, success = _ref2.success, themePaths = _ref2.themePaths, theme = _ref2.theme;
    var styles = [];
    // caller has specified a themeObj to use for styling
    // relevant for cases like pagination which looks to theme.pagination.button
    var themeObj = typeof kind === 'object' ? kind : theme.button;
    var iconOnly = hasIcon && !hasLabel;
    var pad = padFromTheme(size, theme, themeObj, kind, iconOnly);
    themePaths.base.forEach(function(themePath) {
        var obj = getPath(themeObj, themePath);
        if (obj) {
            styles.push((0, _utils.kindPartStyles)(obj, theme, colorValue));
            if (obj.border && obj.border.width && pad && !obj.padding) // Adjust padding from the button.size or just top button.padding
            // to deal with the kind's border width. But don't override any
            // padding in the kind itself for backward compatibility
            styles.push(adjustPadStyle(pad, obj.border.width, theme));
        }
    });
    // do the styling from the root of the object if caller passes one
    if (!themePaths.base.length && typeof kind === 'object') {
        var obj = kind;
        if (obj) {
            styles.push((0, _utils.kindPartStyles)(obj, theme, colorValue));
            if (obj.border && obj.border.width && pad && !obj.padding) // Adjust padding from the button.size or just top button.padding
            // to deal with the kind's border width. But don't override any
            // padding in the kind itself for backward compatibility
            styles.push(adjustPadStyle(pad, obj.border.width, theme));
        }
    }
    themePaths.hover.forEach(function(themePath) {
        var obj = getPath(themeObj, themePath);
        if (obj) {
            var partStyles = (0, _utils.kindPartStyles)(obj, theme);
            var adjPadStyles = '';
            if (obj.border && obj.border.width && pad && !obj.padding) // Adjust padding from the button.size or just top button.padding
            // to deal with the hover's border width. But don't override any
            // padding in the hover or hover.kind itself for backward compatibility
            adjPadStyles = adjustPadStyle(pad, obj.border.width, theme);
            if (partStyles.length > 0 && !busy && !success) styles.push((0, _styledComponents.css)([
                "&:hover{",
                " ",
                "}"
            ], partStyles, adjPadStyles));
        }
    });
    return styles;
};
var hoverIndicatorStyle = function hoverIndicatorStyle(_ref3) {
    var hoverIndicator = _ref3.hoverIndicator, theme = _ref3.theme;
    var themishObj = {};
    if (hoverIndicator === true || hoverIndicator === 'background') themishObj.background = theme.global.hover.background;
    else if (hoverIndicator.color || hoverIndicator.background) {
        if (hoverIndicator.background) themishObj.background = hoverIndicator.background;
        if (hoverIndicator.color) themishObj.color = hoverIndicator.color;
    } else themishObj.background = hoverIndicator;
    var styles = (0, _utils.kindPartStyles)(themishObj, theme);
    if (styles.length > 0) return (0, _styledComponents.css)([
        "&:hover{",
        "}"
    ], styles);
    return '';
};
var fillStyle = function fillStyle(fillContainer) {
    if (fillContainer === 'horizontal') return 'width: 100%;';
    if (fillContainer === 'vertical') return 'height: 100%;';
    if (fillContainer) return "\n      width: 100%;\n      height: 100%;\n      max-width: none;\n      flex: 1 0 auto;\n    ";
    return undefined;
};
var plainStyle = function plainStyle(props) {
    return (0, _styledComponents.css)([
        "outline:none;border:none;padding:0;text-align:inherit;color:inherit;",
        " ",
        ""
    ], props.icon && "\n    > svg {\n      display: flex;\n      align-self: center;\n      vertical-align: middle;\n    }\n  ", props.hasIcon && !props.hasLabel && "line-height: 0;");
};
var StyledButtonKind = (0, _styledComponentsDefault.default).button.withConfig({
    shouldForwardProp: function shouldForwardProp(prop) {
        return (0, _isPropValidDefault.default)(prop) && ![
            'kind'
        ].includes(prop);
    }
}).withConfig({
    displayName: "StyledButtonKind",
    componentId: "sc-1vhfpnt-0"
})([
    "display:inline-block;box-sizing:border-box;cursor:pointer;font:inherit;text-decoration:none;margin:0;background:transparent;overflow:visible;text-transform:none;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " &:focus{",
    "}&:focus:not(:focus-visible){",
    "}",
    " ",
    " ",
    " ",
    ""
], (0, _utils.genericStyles), function(props) {
    return props.plain && plainStyle(props);
}, function(props) {
    return !props.disabled && props.active && (0, _utils.activeStyle);
}, function(props) {
    return !props.plain && basicStyle(props);
}, function(props) {
    return !props.plain && kindStyle(props);
}, function(props) {
    return !props.plain && props.pad && (0, _utils.edgeStyle)('padding', props.pad, false, undefined, props.theme);
}, function(props) {
    return !props.plain && props.align && "\n    text-align: " + props.align + ";\n    ";
}, function(props) {
    return !props.disabled && props.hoverIndicator && !props.busy && !props.success && hoverIndicatorStyle(props);
}, function(props) {
    return props.disabled && (0, _utils.disabledStyle)(props.theme.button.disabled.opacity);
}, function(props) {
    return (!props.plain || props.focusIndicator) && (0, _utils.focusStyle)();
}, (0, _utils.unfocusStyle)(), function(props) {
    return !props.plain && props.theme.button.transition && "\n    transition-property: " + props.theme.button.transition.properties.join(',') + ";\n    transition-duration: " + props.theme.button.transition.duration + "s;\n    transition-timing-function: " + props.theme.button.transition.timing + ";\n  ";
}, function(props) {
    return props.fillContainer && fillStyle(props.fillContainer);
}, function(props) {
    return props.theme.button && props.theme.button.extend;
}, function(props) {
    return (props.busy || props.success) && "\n    cursor: default;\n  ";
});

},{"styled-components":"6bGrk","@emotion/is-prop-valid":"db6x2","../../utils":"fx31z","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iyBo3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EllipsisAnimation", ()=>EllipsisAnimation);
parcelHelpers.export(exports, "GrowCheckmark", ()=>GrowCheckmark);
parcelHelpers.export(exports, "StyledBusyContents", ()=>StyledBusyContents);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _checkmark = require("grommet-icons/icons/Checkmark");
var _box = require("../Box");
var _styles = require("../../utils/styles");
var bounceDelay = (0, _styledComponents.keyframes)([
    "0%,80%,100%{transform:scale(0.4);}40%{transform:scale(0.8);}"
]);
var bounceDelayRule = (0, _styledComponents.css)([
    "animation:",
    " 1.4s infinite ease-in-out both;"
], bounceDelay);
var Dot = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "BusyAnimation__Dot",
    componentId: "sc-feuivs-0"
})([
    "background-color:currentColor;width:8px;height:8px;border-radius:100%;display:inline-block;",
    " ",
    ""
], bounceDelayRule, function(props) {
    return props.delay && "animation-delay: " + props.delay + ";";
});
var EllipsisAnimation = function EllipsisAnimation() {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
        style: {
            position: 'absolute'
        },
        fill: true,
        alignContent: "center",
        justify: "center"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
        alignSelf: "center",
        direction: "row",
        gap: "small"
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Dot, {
        delay: "-0.32s"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Dot, {
        delay: "-0.16s"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement(Dot, null)));
};
var grow = (0, _styledComponents.keyframes)([
    "0%{opacity:0;transform:scale(.3);}20%{opacity:1;transform:scale(1.15);}30%{transform:scale(.9);}45%{transform:scale(1.05);}55%{transform:scale(1);}100%{transform:scale(1);}"
]);
var GrowCheckmark = (0, _styledComponentsDefault.default)((0, _checkmark.Checkmark)).withConfig({
    displayName: "BusyAnimation__GrowCheckmark",
    componentId: "sc-feuivs-1"
})([
    "position:absolute;align-self:center;animation:",
    " 0.9s ease-in-out;"
], grow);
var StyledBusyContents = (0, _styledComponentsDefault.default).div.withConfig((0, _styles.styledComponentsConfig)).withConfig({
    displayName: "BusyAnimation__StyledBusyContents",
    componentId: "sc-feuivs-2"
})([
    "opacity:",
    ";}"
], function(props) {
    return props.animating ? 0 : 1;
});

},{"react":"8CCva","styled-components":"6bGrk","grommet-icons/icons/Checkmark":"dibm3","../Box":"4o01A","../../utils/styles":"4m6LZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dibm3":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.Checkmark = void 0;
var _react = _interopRequireWildcard(require("e1b88d7866e1d58a"));
var _StyledIcon = require("64b7ba1ea688a619");
var _utils = require("a0095f556c3f8b48");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Checkmark = exports.Checkmark = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var scaleProps = (0, _utils.useScaleProps)(props);
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Checkmark"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", _extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2 14 7 6L22 4"
    }, scaleProps)));
});
Checkmark.displayName = 'Checkmark';

},{"e1b88d7866e1d58a":"8CCva","64b7ba1ea688a619":"7Xr4o","a0095f556c3f8b48":"dP1kS"}],"bDcgi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PageFooter", ()=>PageFooter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _box = require("grommet/es6/components/Box");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _selectors = require("app/state/wallet/selectors");
var _mobileFooterNavigation = require("../MobileFooterNavigation");
var _ = require(".");
const PageFooter = ()=>{
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    const isDesktop = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'large';
    const walletHasAccounts = (0, _reactRedux.useSelector)((0, _selectors.selectHasAccounts));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            walletHasAccounts && isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                pad: "xlarge",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobileFooterNavigation.MobileFooterNavigation), {})
            }),
            (walletHasAccounts && isDesktop || !walletHasAccounts) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.Footer), {})
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-redux":"azV3Y","grommet/es6/components/Box":"4o01A","grommet/es6/contexts/ResponsiveContext":"7EsNN","app/state/wallet/selectors":"cgtJ3","../MobileFooterNavigation":"eOv8D",".":"btUFa","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eOv8D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobileFooterNavigation", ()=>MobileFooterNavigation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactI18Next = require("react-i18next");
var _box = require("grommet/es6/components/Box");
var _text = require("grommet/es6/components/Text");
var _lineChart = require("grommet-icons/es6/icons/LineChart");
var _inherit = require("grommet-icons/es6/icons/Inherit");
var _muiWalletIcon = require("../../../styles/theme/icons/mui-icons/MuiWalletIcon");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("grommet/es6/utils");
var _reactRouterDom = require("react-router-dom");
var _selectors = require("app/state/wallet/selectors");
var _useParaTimesNavigation = require("app/pages/ParaTimesPage/useParaTimesNavigation");
var _elementSizes = require("../../../styles/theme/elementSizes");
const StyledMobileFooterNavigation = (0, _styledComponentsDefault.default).nav`
  background-color: ${({ theme })=>(0, _utils.normalizeColor)('background-front', theme)};
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${(0, _elementSizes.mobileFooterNavigationHeight)};
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  box-shadow: ${({ theme })=>`0px 0px ${theme.global?.borderSize?.xsmall} ${(0, _utils.normalizeColor)('background-front-border', theme)}`};
  border-top: ${({ theme })=>`solid ${theme.global?.borderSize?.xsmall} ${(0, _utils.normalizeColor)('background-contrast', theme)}`};
  flex-direction: row;
`;
const StyledNavLink = (0, _styledComponentsDefault.default)((0, _reactRouterDom.NavLink))`
  // Make items equal width
  flex-grow: 1;
  flex-basis: 0;

  &:hover {
    color: ${({ theme })=>(0, _utils.normalizeColor)('text', theme)};
    background-color: ${({ theme })=>(0, _utils.normalizeColor)('active', theme)};
  }

  &.active {
    color: ${({ theme })=>(0, _utils.normalizeColor)('text', theme, true)};
    background-color: ${({ theme })=>(0, _utils.normalizeColor)('control', theme)};
  }
`;
const MobileFooterNavigation = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const address = (0, _reactRedux.useSelector)((0, _selectors.selectAddress));
    const { getParaTimesRoutePath, paraTimesRouteLabel } = (0, _useParaTimesNavigation.useParaTimesNavigation)();
    const getMenuItems = (0, _react.useMemo)(()=>{
        const menuItems = [
            {
                label: t('menu.wallet', 'Account'),
                Icon: (0, _muiWalletIcon.MuiWalletIcon),
                to: `/account/${address}`,
                exactActive: true
            },
            {
                label: t('menu.stake-mobile', 'Stake'),
                Icon: (0, _lineChart.LineChart),
                to: `/account/${address}/stake`
            },
            {
                label: paraTimesRouteLabel,
                Icon: (0, _inherit.Inherit),
                to: getParaTimesRoutePath(address)
            }
        ];
        return menuItems;
    }, [
        address,
        getParaTimesRoutePath,
        paraTimesRouteLabel,
        t
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledMobileFooterNavigation, {
        "data-testid": "mobile-footer-navigation",
        children: getMenuItems.map((params)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileFooterButton, {
                ...params
            }, params.to))
    });
};
function MobileFooterButton({ label, Icon, to, exactActive }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledNavLink, {
        to: to,
        end: exactActive,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            as: "span",
            justify: "center",
            align: "center",
            fill: "vertical",
            gap: "small",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                    size: "24px"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                    size: "small",
                    textAlign: "center",
                    style: {
                        lineHeight: 1
                    },
                    children: label
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-redux":"azV3Y","react-i18next":"7GUHL","grommet/es6/components/Box":"4o01A","grommet/es6/components/Text":"kz1Ni","grommet-icons/es6/icons/LineChart":"6ydAo","grommet-icons/es6/icons/Inherit":"lgvk0","../../../styles/theme/icons/mui-icons/MuiWalletIcon":"bOkiZ","styled-components":"6bGrk","grommet/es6/utils":"fx31z","react-router-dom":"9pTjq","app/state/wallet/selectors":"cgtJ3","app/pages/ParaTimesPage/useParaTimesNavigation":"70fv0","../../../styles/theme/elementSizes":"2rYRG","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6ydAo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LineChart", ()=>LineChart);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var LineChart = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "LineChart"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m1 16 7-7 5 5L23 4M0 22h23.999M16 4h7v7"
    }));
});
LineChart.displayName = 'LineChart';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lgvk0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Inherit", ()=>Inherit);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Inherit = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Inherit"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#231F20",
        strokeWidth: "2",
        d: "m17 18-5-3 5 3zM7 18l5-3v-4m5 9a3 3 0 1 0 6 0 3 3 0 0 0-6 0zM4 17a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM17 6a5 5 0 1 1-10.001-.001A5 5 0 0 1 17 6z"
    }));
});
Inherit.displayName = 'Inherit';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bOkiZ":[function(require,module,exports,__globalThis) {
/**
 * Copyright 2024 https://github.com/google/material-design-icons
 * SPDX-License-Identifier: Apache-2.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MuiWalletIcon", ()=>MuiWalletIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _blank = require("grommet-icons/es6/icons/Blank");
var _reactI18Next = require("react-i18next");
const MuiWalletIcon = (props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blank.Blank), {
        "aria-label": t('icons.wallet.label', 'Wallet'),
        viewBox: "0 -960 960 960",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M240-160q-66 0-113-47T80-320v-320q0-66 47-113t113-47h480q66 0 113 47t47 113v320q0 66-47 113t-113 47H240Zm0-480h480q22 0 42 5t38 16v-21q0-33-23.5-56.5T720-720H240q-33 0-56.5 23.5T160-640v21q18-11 38-16t42-5Zm-74 130 445 108q9 2 18 0t17-8l139-116q-11-15-28-24.5t-37-9.5H240q-26 0-45.5 13.5T166-510Z"
        })
    });
};

},{"react/jsx-runtime":"6pm7f","grommet-icons/es6/icons/Blank":"frgvY","react-i18next":"7GUHL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"frgvY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Blank", ()=>Blank);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Blank = function Blank(props) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        viewBox: "0 0 24 24",
        "aria-hidden": true
    }, props));
};

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"70fv0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useParaTimesNavigation", ()=>useParaTimesNavigation);
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactI18Next = require("react-i18next");
var _paratimes = require("app/state/paratimes");
const useParaTimesNavigation = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const getParaTimesRoutePath = (address)=>`/account/${address}/paratimes`;
    const navigateToDeposit = (0, _react.useCallback)(()=>dispatch((0, _paratimes.paraTimesActions).navigateToDeposit()), [
        dispatch
    ]);
    const navigateToWithdraw = (0, _react.useCallback)(()=>dispatch((0, _paratimes.paraTimesActions).navigateToWithdraw()), [
        dispatch
    ]);
    const navigateToParaTimes = (0, _react.useCallback)(()=>dispatch((0, _paratimes.paraTimesActions).navigateToParaTimes()), [
        dispatch
    ]);
    const navigateToRecipient = (0, _react.useCallback)(()=>dispatch((0, _paratimes.paraTimesActions).navigateToRecipient()), [
        dispatch
    ]);
    const navigateToAmount = (0, _react.useCallback)(()=>dispatch((0, _paratimes.paraTimesActions).navigateToAmount()), [
        dispatch
    ]);
    const navigateToConfirmation = (0, _react.useCallback)(()=>dispatch((0, _paratimes.paraTimesActions).navigateToConfirmation()), [
        dispatch
    ]);
    const navigateToSummary = (0, _react.useCallback)(()=>dispatch((0, _paratimes.paraTimesActions).navigateToSummary()), [
        dispatch
    ]);
    const paraTimesRouteLabel = t('menu.paraTimes', 'ParaTimes');
    return {
        getParaTimesRoutePath,
        navigateToAmount,
        navigateToConfirmation,
        navigateToDeposit,
        navigateToParaTimes,
        navigateToRecipient,
        navigateToSummary,
        navigateToWithdraw,
        paraTimesRouteLabel
    };
};

},{"react":"8CCva","react-redux":"azV3Y","react-i18next":"7GUHL","app/state/paratimes":"63sI2","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2rYRG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sidebarSmallSizeLogo", ()=>sidebarSmallSizeLogo);
parcelHelpers.export(exports, "sidebarMediumSizeLogo", ()=>sidebarMediumSizeLogo);
parcelHelpers.export(exports, "sidebarLargeSizeLogo", ()=>sidebarLargeSizeLogo);
parcelHelpers.export(exports, "mobileToolbarZIndex", ()=>mobileToolbarZIndex);
parcelHelpers.export(exports, "mobileToolbarButtonsZIndex", ()=>mobileToolbarButtonsZIndex);
parcelHelpers.export(exports, "buildBannerZIndex", ()=>buildBannerZIndex);
parcelHelpers.export(exports, "mobileFooterNavigationHeight", ()=>mobileFooterNavigationHeight);
const sidebarSmallSizeLogo = 32;
const sidebarMediumSizeLogo = 40;
const sidebarLargeSizeLogo = 40;
const mobileToolbarZIndex = 3;
const mobileToolbarButtonsZIndex = mobileToolbarZIndex + 1;
const buildBannerZIndex = mobileToolbarZIndex - 1;
const mobileFooterNavigationHeight = '4rem';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"btUFa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Footer", ()=>Footer);
var _jsxRuntime = require("react/jsx-runtime");
var _anchor = require("grommet/es6/components/Anchor");
var _box = require("grommet/es6/components/Box");
var _text = require("grommet/es6/components/Text");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _reactI18Next = require("react-i18next");
var _selectors = require("app/state/wallet/selectors");
var _intlDateTimeFormat = require("../DateFormatter/intlDateTimeFormat");
var _backend = require("vendors/backend");
var _config = require("config");
var _i18Next = require("i18next");
const githubLink = 'https://github.com/oasisprotocol/wallet/';
const githubReleaseLink = (tag)=>`${githubLink}releases/tag/${tag}`;
function NoReleaseLink() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: "-"
    });
}
const Footer = /*#__PURE__*/ (0, _react.memo)(()=>{
    const walletHasAccounts = (0, _reactRedux.useSelector)((0, _selectors.selectHasAccounts));
    const responsiveContext = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext));
    const isMobileOrTablet = responsiveContext === 'small' || responsiveContext === 'medium';
    const { t } = (0, _reactI18Next.useTranslation)();
    const backendToLabel = {
        [(0, _config.BackendAPIs).OasisScanV2]: t('footer.poweredBy.oasisscanV2', 'Oasis Scan API v2 & Oasis gRPC'),
        [(0, _config.BackendAPIs).Nexus]: t('footer.poweredBy.nexus', 'Nexus API & Oasis gRPC')
    };
    const poweredByLabel = backendToLabel[(0, _backend.backend)()];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        as: "footer",
        direction: isMobileOrTablet ? 'column' : 'row',
        justify: isMobileOrTablet ? 'center' : 'between',
        align: "center",
        round: "5px",
        pad: {
            horizontal: 'medium',
            top: isMobileOrTablet ? '1rem' : 'medium'
        },
        margin: {
            bottom: isMobileOrTablet && !walletHasAccounts || !isMobileOrTablet ? 'medium' : 'none',
            top: 'auto'
        },
        "data-testid": "footer",
        gap: isMobileOrTablet ? '0' : '20px',
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                style: {
                    flex: 1,
                    alignSelf: isMobileOrTablet ? 'center ' : 'flex-start'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                    size: "small",
                    textAlign: isMobileOrTablet ? 'center' : 'start',
                    margin: {
                        bottom: isMobileOrTablet ? 'small' : 'none'
                    },
                    style: {
                        display: 'inline-flex',
                        flexDirection: isMobileOrTablet ? 'column' : 'row'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                                i18nKey: "footer.github",
                                t: t,
                                components: {
                                    GithubLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _anchor.Anchor), {
                                        href: githubLink,
                                        target: "_blank",
                                        rel: "noopener noreferrer"
                                    })
                                },
                                values: {
                                    poweredBy: poweredByLabel
                                },
                                defaults: "ROSE Wallet is <GithubLink>open source</GithubLink> and powered by"
                            }),
                            isMobileOrTablet ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: " "
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: poweredByLabel
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                style: {
                    flex: 1,
                    alignSelf: isMobileOrTablet ? 'center ' : 'flex-start'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                    size: "small",
                    textAlign: isMobileOrTablet ? 'center' : 'end',
                    margin: {
                        top: isMobileOrTablet ? 'small' : 'none'
                    },
                    children: isMobileOrTablet ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TermsAndConditions, {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Version, {})
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(Version, {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TermsAndConditions, {})
                        ]
                    })
                })
            }),
            isMobileOrTablet && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                size: "small",
                textAlign: "center",
                margin: {
                    top: 'small'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                    i18nKey: "footer.feedback",
                    t: t,
                    components: {
                        EmailLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _anchor.Anchor), {
                            href: "mailto:wallet@oasisprotocol.org"
                        })
                    },
                    defaults: "We\u2019d love your feedback at <EmailLink>wallet@oasisprotocol.org</EmailLink>"
                })
            })
        ]
    });
});
const TermsAndConditions = ()=>{
    const responsiveContext = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext));
    const isMobileOrTablet = responsiveContext === 'small' || responsiveContext === 'medium';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        style: {
            display: 'inline-flex',
            flexDirection: isMobileOrTablet ? 'row' : 'row-reverse'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                i18nKey: "footer.terms",
                t: (0, _i18Next.t),
                components: {
                    TermsLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _anchor.Anchor), {
                        href: "https://wallet.oasis.io/t-c.pdf",
                        target: "_blank",
                        rel: "noopener noreferrer"
                    })
                },
                defaults: "<TermsLink>Terms and Conditions</TermsLink>"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                margin: {
                    right: 'xsmall',
                    left: 'xsmall'
                },
                style: {
                    display: 'inline-block'
                },
                children: "|"
            })
        ]
    });
};
const Version = ()=>{
    const responsiveContext = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext));
    const isMobileOrTablet = responsiveContext === 'small' || responsiveContext === 'medium';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            i18nKey: "footer.version",
            t: (0, _i18Next.t),
            components: {
                ReleaseLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)(NoReleaseLink, {}),
                CommitLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _anchor.Anchor), {
                    href: `${githubLink}commit/${"0a065d7cc566b556c4d7d023d5edd1cdb5fe0907"}`,
                    label: "0a065d7cc566b556c4d7d023d5edd1cdb5fe0907".substring(0, 7),
                    target: "_blank",
                    rel: "noopener noreferrer"
                })
            },
            values: {
                buildTime: (0, _intlDateTimeFormat.intlDateTimeFormat)(Number("1767946592102"))
            },
            defaults: "Version: <ReleaseLink/> (commit: <CommitLink/>) built at {{buildTime}}"
        })
    });
};

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Anchor":"arBWH","grommet/es6/components/Box":"4o01A","grommet/es6/components/Text":"kz1Ni","grommet/es6/contexts/ResponsiveContext":"7EsNN","react":"8CCva","react-redux":"azV3Y","react-i18next":"7GUHL","app/state/wallet/selectors":"cgtJ3","../DateFormatter/intlDateTimeFormat":"f8Mrn","vendors/backend":"aIngR","config":"akiw0","i18next":"gKjwO","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"f8Mrn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "intlDateTimeFormat", ()=>intlDateTimeFormat);
var process = require("1d10fdb8e0660293");
const dateFormat = new Intl.DateTimeFormat(process?.env?.NODE_ENV === 'test' ? 'en-US' : undefined, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZone: process?.env?.NODE_ENV === 'test' ? 'UTC' : undefined
});
/**
 * Narrow No-Brake Space
 *
 * This is used by the date formatter.
 * See https://unicodeplus.com/U+202F
 */ const NNBSP = '\u202F';
const intlDateTimeFormat = (date)=>dateFormat.format(date).replaceAll(NNBSP, ' ');

},{"1d10fdb8e0660293":"fQ8R7","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fQ8R7":[function(require,module,exports,__globalThis) {
// shim for using process in browser
var process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var cachedSetTimeout;
var cachedClearTimeout;
function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') cachedSetTimeout = setTimeout;
        else cachedSetTimeout = defaultSetTimout;
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') cachedClearTimeout = clearTimeout;
        else cachedClearTimeout = defaultClearTimeout;
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;
function cleanUpNextTick() {
    if (!draining || !currentQueue) return;
    draining = false;
    if (currentQueue.length) queue = currentQueue.concat(queue);
    else queueIndex = -1;
    if (queue.length) drainQueue();
}
function drainQueue() {
    if (draining) return;
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;
    while(len){
        currentQueue = queue;
        queue = [];
        while(++queueIndex < len)if (currentQueue) currentQueue[queueIndex].run();
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}
process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) runTimeout(drainQueue);
};
// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};
function noop() {}
process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;
process.listeners = function(name) {
    return [];
};
process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
process.cwd = function() {
    return '/';
};
process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() {
    return 0;
};

},{}],"5xMev":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SidebarButton", ()=>SidebarButton);
parcelHelpers.export(exports, "Sidebar", ()=>Sidebar);
parcelHelpers.export(exports, "Navigation", ()=>Navigation);
var _jsxRuntime = require("react/jsx-runtime");
var _selectors = require("app/state/wallet/selectors");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _layer = require("grommet/es6/components/Layer");
var _menu = require("grommet/es6/components/Menu");
var _nav = require("grommet/es6/components/Nav");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _sidebar = require("grommet/es6/components/Sidebar");
var _text = require("grommet/es6/components/Text");
var _utils = require("grommet/es6/utils");
var _github = require("grommet-icons/es6/icons/Github");
var _formDown = require("grommet-icons/es6/icons/FormDown");
var _home = require("grommet-icons/es6/icons/Home");
var _inherit = require("grommet-icons/es6/icons/Inherit");
var _lineChart = require("grommet-icons/es6/icons/LineChart");
var _muiLockIcon = require("../../../styles/theme/icons/mui-icons/MuiLockIcon");
var _logout = require("grommet-icons/es6/icons/Logout");
var _menu1 = require("grommet-icons/es6/icons/Menu");
var _muiWalletIcon = require("../../../styles/theme/icons/mui-icons/MuiWalletIcon");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _language = require("../../../styles/theme/icons/language/Language");
var _useParaTimesNavigation = require("app/pages/ParaTimesPage/useParaTimesNavigation");
var _themeSwitcher = require("../ThemeSwitcher");
var _roseWalletBlueSvg = require("../../../../public/Rose Wallet Blue.svg");
var _roseWalletBlueSvgDefault = parcelHelpers.interopDefault(_roseWalletBlueSvg);
var _roseWalletWhiteSvg = require("../../../../public/Rose Wallet White.svg");
var _roseWalletWhiteSvgDefault = parcelHelpers.interopDefault(_roseWalletWhiteSvg);
var _i18N = require("../../../locales/i18n");
var _selectIsLockableOrCloseable = require("app/state/selectIsLockableOrCloseable");
var _persist = require("app/state/persist");
var _elementSizes = require("../../../styles/theme/elementSizes");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const UnstyledSidebarButton = ({ needsWalletOpen, icon, label, route, newTab, exactActive, onClick, ...rest })=>{
    const walletHasAccounts = (0, _reactRedux.useSelector)((0, _selectors.selectHasAccounts));
    if (!walletHasAccounts && needsWalletOpen) return null;
    const component = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        pad: {
            vertical: 'small',
            left: 'medium'
        },
        responsive: false,
        direction: "row",
        gap: "medium",
        justify: "start",
        children: [
            icon,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                children: label
            })
        ]
    });
    if (route) {
        const isAbsoluteUrl = route.startsWith('https://') || route.startsWith('http://') || route.startsWith('//');
        if (!newTab && isAbsoluteUrl) throw new Error('Must use newTab with absolute URLs. React-router Link component uses relative routes.');
        return newTab ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
            "aria-label": label,
            href: route,
            target: "_blank",
            rel: "noopener",
            ...rest,
            children: component
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.NavLink), {
            "aria-label": label,
            to: route,
            end: exactActive,
            ...rest,
            children: component
        });
    } else return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
        a11yTitle: label,
        fill: "horizontal",
        onClick: onClick,
        ...rest,
        children: component
    });
};
const SidebarButton = (0, _styledComponentsDefault.default)(UnstyledSidebarButton)`
  &:hover {
    color: ${({ theme })=>(0, _utils.normalizeColor)('text', theme)};
    background-color: ${({ theme })=>(0, _utils.normalizeColor)('active', theme)};
  }

  &.active {
    color: ${({ theme })=>(0, _utils.normalizeColor)('text', theme, true)};
    background-color: ${({ theme })=>(0, _utils.normalizeColor)('control', theme)};
  }
`;
const SidebarHeader = (props)=>{
    const { dark } = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    const size = props.size;
    const sizeLogo = {
        small: `${(0, _elementSizes.sidebarSmallSizeLogo)}px`,
        medium: `${(0, _elementSizes.sidebarMediumSizeLogo)}px`,
        large: `${(0, _elementSizes.sidebarLargeSizeLogo)}px`
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        align: "center",
        margin: {
            bottom: size !== 'small' ? 'medium' : undefined
        },
        pad: {
            horizontal: 'medium',
            vertical: 'small'
        },
        alignSelf: size === 'large' ? undefined : 'center',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
            to: "/",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                alt: "ROSE Wallet logo",
                src: dark ? (0, _roseWalletWhiteSvgDefault.default) : (0, _roseWalletBlueSvgDefault.default),
                style: {
                    height: sizeLogo[size]
                }
            })
        })
    });
};
const SidebarFooter = (props)=>{
    const { t, i18n } = (0, _reactI18Next.useTranslation)();
    const size = props.size;
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const isLockableOrCloseable = (0, _reactRedux.useSelector)((0, _selectIsLockableOrCloseable.selectIsLockableOrCloseable));
    const setLanguage = (ln)=>{
        i18n.changeLanguage(ln);
    };
    const closeWallet = ()=>{
        navigate('/');
        dispatch((0, _persist.persistActions).lockAsync());
    };
    const lockProfile = ()=>{
        dispatch((0, _persist.persistActions).lockAsync());
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _nav.Nav), {
        gap: "small",
        children: [
            !isLockableOrCloseable && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeSwitcher.ThemeSwitcher), {}),
            isLockableOrCloseable === 'closeable' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarButton, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logout.Logout), {}),
                label: t('menu.closeWallet', 'Close wallet'),
                onClick: ()=>closeWallet()
            }),
            isLockableOrCloseable === 'unlockable' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarButton, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logout.Logout), {}),
                label: t('menu.unlockProfile', 'Unlock profile'),
                onClick: ()=>closeWallet()
            }),
            isLockableOrCloseable === 'lockable' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarButton, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _muiLockIcon.MuiLockIcon), {}),
                label: t('menu.lockProfile', 'Lock profile'),
                onClick: ()=>lockProfile()
            }),
            size === 'small' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                pad: "small",
                align: "start",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Menu), {
                    hoverIndicator: false,
                    dropProps: {
                        align: {
                            bottom: 'bottom',
                            left: 'left'
                        }
                    },
                    items: (0, _i18N.languageLabels).map(([key, label])=>({
                            label: label,
                            onClick: ()=>setLanguage(key),
                            primary: key === i18n.resolvedLanguage
                        })),
                    a11yTitle: "Language",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                pad: "small",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _language.Language), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                pad: "small",
                                flex: "grow",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                    children: "Language"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                pad: "small",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formDown.FormDown), {})
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarButton, {
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _github.Github), {}),
                label: "GitHub",
                route: "https://github.com/oasisprotocol/wallet",
                newTab: true
            })
        ]
    });
};
/** See also {@link MobileFooterNavigation} */ function SidebarMenuItems() {
    const address = (0, _reactRedux.useSelector)((0, _selectors.selectAddress));
    const { t } = (0, _reactI18Next.useTranslation)();
    const { getParaTimesRoutePath, paraTimesRouteLabel } = (0, _useParaTimesNavigation.useParaTimesNavigation)();
    const menu = {
        home: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarButton, {
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _home.Home), {}),
            label: t('menu.home', 'Home'),
            route: "/",
            exactActive: true,
            "data-testid": "nav-home"
        }),
        wallet: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarButton, {
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _muiWalletIcon.MuiWalletIcon), {}),
            label: t('menu.wallet', 'Account'),
            needsWalletOpen: true,
            route: `/account/${address}`,
            exactActive: true,
            "data-testid": "nav-myaccount"
        }),
        stake: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarButton, {
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lineChart.LineChart), {}),
            label: t('menu.stake', 'Stake ROSE'),
            needsWalletOpen: true,
            route: `/account/${address}/stake`,
            "data-testid": "nav-stake"
        }),
        paraTimes: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarButton, {
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inherit.Inherit), {}),
            label: paraTimesRouteLabel,
            needsWalletOpen: true,
            route: getParaTimesRoutePath(address),
            "data-testid": "nav-paratime"
        })
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _nav.Nav), {
        gap: "small",
        pad: "none",
        className: "SidebarMenuItems",
        children: [
            menu.home,
            menu.wallet,
            menu.stake,
            menu.paraTimes
        ]
    });
}
const StyledGSidebar = (0, _styledComponentsDefault.default)((0, _sidebar.Sidebar))`
  height: fit-content;
  min-height: 100dvh;
  position: sticky;
  top: 0px;

  // Make it scrollable if screen is too short
  overflow-y: auto;
  max-height: 100vh;

  div:has(> .SidebarMenuItems) {
    flex-shrink: 0;
  }
`;
function Sidebar() {
    const size = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledGSidebar, {
        background: "component-sidebar",
        header: size !== 'small' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarHeader, {
            size: size
        }) : undefined,
        footer: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarFooter, {
            size: size
        }),
        pad: {
            left: 'none',
            right: 'none',
            vertical: 'medium'
        },
        gap: "small",
        width: "220px",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarMenuItems, {})
    });
}
function Navigation() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const size = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext));
    const [sidebarVisible, setSidebarVisible] = _react.useState(false);
    const isLockableOrCloseable = (0, _reactRedux.useSelector)((0, _selectIsLockableOrCloseable.selectIsLockableOrCloseable));
    const toggleSidebar = ()=>{
        setSidebarVisible(!sidebarVisible);
    };
    const location = (0, _reactRouterDom.useLocation)();
    _react.useEffect(()=>{
        // If the location changed, hide the sidebar
        setSidebarVisible(false);
    }, [
        location
    ]);
    const hasMenuOnRightSide = !isLockableOrCloseable || isLockableOrCloseable === 'unlockable';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            size === 'small' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                background: "background-front",
                border: {
                    color: 'background-contrast',
                    side: 'bottom'
                },
                height: "64px",
                fill: "horizontal",
                direction: "row",
                style: {
                    position: 'fixed',
                    top: 0,
                    width: '100%',
                    zIndex: (0, _elementSizes.mobileToolbarZIndex),
                    flexDirection: hasMenuOnRightSide ? 'row-reverse' : 'row',
                    justifyContent: hasMenuOnRightSide ? 'space-between' : 'flex-start'
                },
                children: [
                    hasMenuOnRightSide && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        onClick: ()=>toggleSidebar(),
                        a11yTitle: t('menu.openMenu', 'Menu'),
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu1.Menu), {}),
                        focusIndicator: false
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        justify: "center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(SidebarHeader, {
                            size: "small"
                        })
                    })
                ]
            }),
            size === 'small' && sidebarVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layer.Layer), {
                position: "right",
                onClickOutside: toggleSidebar,
                onEsc: toggleSidebar,
                full: "vertical",
                modal: true,
                animation: "slide",
                responsive: false,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Sidebar, {})
            }),
            size !== 'small' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Sidebar, {})
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","app/state/wallet/selectors":"cgtJ3","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Layer":"3gh0x","grommet/es6/components/Menu":"fQpGz","grommet/es6/components/Nav":"g5GDL","grommet/es6/contexts/ResponsiveContext":"7EsNN","grommet/es6/components/Sidebar":"e6Wgp","grommet/es6/components/Text":"kz1Ni","grommet/es6/utils":"fx31z","grommet-icons/es6/icons/Github":"e38EX","grommet-icons/es6/icons/FormDown":"9LwnH","grommet-icons/es6/icons/Home":"6RgCv","grommet-icons/es6/icons/Inherit":"lgvk0","grommet-icons/es6/icons/LineChart":"6ydAo","../../../styles/theme/icons/mui-icons/MuiLockIcon":"dbeW0","grommet-icons/es6/icons/Logout":"dMVk6","grommet-icons/es6/icons/Menu":"jA7pp","../../../styles/theme/icons/mui-icons/MuiWalletIcon":"bOkiZ","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","react-router-dom":"9pTjq","../../../styles/theme/icons/language/Language":"k4h3O","app/pages/ParaTimesPage/useParaTimesNavigation":"70fv0","../ThemeSwitcher":"27whc","../../../../public/Rose Wallet Blue.svg":"hfBEW","../../../../public/Rose Wallet White.svg":"4JEgD","../../../locales/i18n":"aQTIh","app/state/selectIsLockableOrCloseable":"92Jcs","app/state/persist":"9hwZK","../../../styles/theme/elementSizes":"2rYRG","styled-components":"6bGrk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fQpGz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Menu", ()=>(0, _menu.Menu));
var _menu = require("./Menu");

},{"./Menu":"eMnWf","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eMnWf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Menu", ()=>Menu);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _box = require("../Box");
var _button = require("../Button");
var _dropButton = require("../DropButton");
var _keyboard = require("../Keyboard");
var _text = require("../Text");
var _utils = require("../../utils");
var _messageContext = require("../../contexts/MessageContext");
var _propTypes = require("./propTypes");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "a11yTitle",
    "aria-label",
    "children",
    "disabled",
    "dropAlign",
    "dropBackground",
    "dropProps",
    "dropTarget",
    "justifyContent",
    "icon",
    "items",
    "label",
    "messages",
    "onKeyDown",
    "open",
    "plain",
    "size"
], _excluded2 = [
    "align"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var ContainerBox = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "Menu__ContainerBox",
    componentId: "sc-17fcys9-0"
})([
    "max-height:inherit;@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:100%;}&:focus{outline:none;}",
    ";"
], function(props) {
    return props.theme.menu.extend;
});
/* Notes on keyboard interactivity (based on W3) // For details reference: https://www.w3.org/TR/wai-aria-practices/#menu

To open menu when menu button is focused:
- Space/Enter/Up arrow/Down arrow will open menu

To navigate within menu:
- Up/down arrow keys can be used and will loop through options
(keeping focus within the Menu)
- Tab can be used, but once the last menu item is reached, Tab will close the
Menu and continue through page content.

To close the menu:
- Tabbing beyond the first or last menu item.
- Esc will close the menu
- Select a menu item

To make a selection:
- Enter key is pressed.
- Space is pressed.
*/ var defaultItems = [];
var Menu = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var a11yTitle = props.a11yTitle, ariaLabel = props['aria-label'], children = props.children, disabled = props.disabled, dropAlign = props.dropAlign, dropBackground = props.dropBackground, dropProps = props.dropProps, dropTarget = props.dropTarget, _props$justifyContent = props.justifyContent, justifyContent = _props$justifyContent === void 0 ? 'start' : _props$justifyContent, icon = props.icon, _props$items = props.items, items = _props$items === void 0 ? defaultItems : _props$items, label = props.label, messages = props.messages, onKeyDown = props.onKeyDown, open = props.open, plain = props.plain, size = props.size, rest = _objectWithoutPropertiesLoose(props, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme, passThemeFlag = _useThemeValue1.passThemeFlag;
    var _useContext = (0, _react.useContext)((0, _messageContext.MessageContext)), format = _useContext.format;
    var iconColor = (0, _utils.normalizeColor)(theme.menu.icons.color || 'control', theme);
    // need to destructure the align otherwise it will get passed through
    // to DropButton and override prop values
    var _theme$menu$drop = theme.menu.drop, themeDropAlign = _theme$menu$drop.align, themeDropProps = _objectWithoutPropertiesLoose(_theme$menu$drop, _excluded2);
    var a11y = ariaLabel || a11yTitle;
    // total number of menu items
    var itemCount = (0, _react.useMemo)(function() {
        var count = 0;
        if (items && Array.isArray(items[0])) items.forEach(function(group) {
            count += group.length;
        });
        else count = items.length;
        return count;
    }, [
        items
    ]);
    var align = dropProps && dropProps.align || dropAlign || themeDropAlign;
    var controlButtonIndex = (0, _react.useMemo)(function() {
        if (align.top === 'top') return -1;
        if (align.bottom === 'bottom') return itemCount;
        return undefined;
    }, [
        align,
        itemCount
    ]);
    // Keeps track of whether menu options should be mirrored
    // when there's not enough space below DropButton. This state
    // is modified on /Drop/DropContainer.js.
    var _useState = (0, _react.useState)(), alignControlMirror = _useState[0], setAlignControlMirror = _useState[1];
    var initialAlignTop = alignControlMirror === align.top;
    var dropContainerRef = (0, _react.useRef)();
    var buttonRefs = (0, _react.useRef)([]);
    var constants = (0, _react.useMemo)(function() {
        return {
            none: 'none',
            tab: 9,
            // Menu control button included on top of menu items
            controlTop: align.top === 'top' || undefined,
            // Menu control button included on the bottom of menu items
            controlBottom: align.bottom === 'bottom' || undefined,
            controlButtonIndex: controlButtonIndex
        };
    }, [
        align,
        controlButtonIndex
    ]);
    var _useState2 = (0, _react.useState)(constants.none), activeItemIndex = _useState2[0], setActiveItemIndex = _useState2[1];
    var _useState3 = (0, _react.useState)(open || false), isOpen = _useState3[0], setOpen = _useState3[1];
    var MenuIcon = isOpen && theme.menu.icons.up ? theme.menu.icons.up : theme.menu.icons.down;
    var onDropClose = (0, _react.useCallback)(function() {
        setActiveItemIndex(constants.none);
        setOpen(false);
    }, [
        constants.none
    ]);
    var onDropOpen = (0, _react.useCallback)(function() {
        setOpen(true);
    }, []);
    (0, _react.useEffect)(function() {
        // need to wait for Drop to be ready
        var timer = setTimeout(function() {
            if (isOpen) {
                var optionsNode = dropContainerRef.current;
                if (optionsNode) optionsNode.focus();
            }
        }, 100);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        isOpen
    ]);
    var onSelectMenuItem = function onSelectMenuItem(event) {
        if (isOpen) {
            if (activeItemIndex >= 0) {
                event.preventDefault();
                event.stopPropagation();
                buttonRefs.current[activeItemIndex].click();
            }
        } else onDropOpen();
    };
    var isTab = function isTab(event) {
        return event.keyCode === constants.tab || event.which === constants.tab;
    };
    var onNextMenuItem = function onNextMenuItem(event) {
        event.preventDefault();
        if (!isOpen) onDropOpen();
        else if (isTab(event) && (!constants.controlBottom && activeItemIndex === itemCount - 1 || constants.controlBottom && activeItemIndex === controlButtonIndex)) // User has reached end of the menu, this tab will close
        // the menu drop because there are no more "next items" to access
        onDropClose();
        else {
            var index;
            if (// This checks if the user has reached the end of the menu.
            // In the case the the menu control button is located at the
            // bottom of the menu, it checks if the user has reached the button.
            // Otherwise, it checks if the user is at the last menu item.
            constants.controlBottom && activeItemIndex === controlButtonIndex || !constants.controlBottom && activeItemIndex === itemCount - 1 || activeItemIndex === constants.none) // place focus on the first menu item
            index = 0;
            else index = activeItemIndex + 1;
            setActiveItemIndex(index);
            if (buttonRefs.current[index]) buttonRefs.current[index].focus();
        }
    };
    var onPreviousMenuItem = function onPreviousMenuItem(event) {
        event.preventDefault();
        if (!isOpen) onDropOpen();
        else if (isTab(event) && (constants.controlTop && activeItemIndex === controlButtonIndex || !constants.controlTop && activeItemIndex - 1 < 0)) // User has reached beginning of the menu, this tab will close
        // the menu drop because there are no more "previous items" to access
        onDropClose();
        else {
            var index;
            if (activeItemIndex === 'none') index = itemCount - 1;
            else if (activeItemIndex - 1 < 0) {
                if (constants.controlTop && activeItemIndex - 1 === controlButtonIndex) index = itemCount;
                else index = itemCount - 1;
            } else index = activeItemIndex - 1;
            setActiveItemIndex(index);
            if (buttonRefs.current[index]) buttonRefs.current[index].focus();
        }
    };
    var menuIcon = icon !== false ? icon !== true && icon || /*#__PURE__*/ (0, _reactDefault.default).createElement(MenuIcon, {
        color: iconColor,
        size: size
    }) : null;
    var buttonProps = {
        plain: plain,
        size: size
    };
    var content;
    if (children) content = children;
    else if (!theme.button["default"]) content = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
        direction: "row",
        justify: justifyContent,
        align: "center",
        pad: "small",
        gap: label && icon !== false ? 'small' : undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        size: size
    }, label), menuIcon);
    else {
        // when a theme has theme.button.default, keep content as
        // undefined so we can rely on Button label & icon props
        buttonProps = {
            icon: menuIcon,
            label: label,
            plain: plain,
            reverse: true,
            size: size
        };
        content = undefined;
    }
    var controlMirror = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
        flex: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), _extends({
        ref: function ref(r) {
            // make it accessible at the end of all menu items
            buttonRefs.current[itemCount] = r;
        },
        a11yTitle: a11y || format({
            id: 'menu.closeMenu',
            messages: messages
        }),
        active: activeItemIndex === controlButtonIndex,
        focusIndicator: false,
        hoverIndicator: "background",
        onClick: onDropClose,
        onFocus: function onFocus() {
            return setActiveItemIndex(controlButtonIndex);
        },
        tabIndex: activeItemIndex === constants.none ? '-1' : undefined
    }, theme.menu.item, buttonProps), typeof content === 'function' ? function() {
        return content(_extends({}, props, {
            drop: true
        }));
    } : content));
    var menuItem = function menuItem(item, index) {
        var _theme$menu$item, _theme$menu$item2, _theme$menu$item3, _theme$menu$item4;
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var child = !theme.button.option ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
            align: ((_theme$menu$item = theme.menu.item) == null ? void 0 : _theme$menu$item.align) || 'start',
            pad: "small",
            direction: "row",
            gap: item.gap || ((_theme$menu$item2 = theme.menu.item) == null ? void 0 : _theme$menu$item2.gap),
            justify: item.justify || ((_theme$menu$item3 = theme.menu.item) == null ? void 0 : _theme$menu$item3.justify)
        }, item.reverse && item.label, item.icon, !item.reverse && item.label) : undefined;
        // if we have a child, turn on plain, and hoverIndicator
        return(/*#__PURE__*/ // lint isn't flagging this but we shouldn't use index as a key
        // see no-array-index-key lint rule
        (0, _reactDefault.default).createElement((0, _box.Box), {
            key: index,
            flex: false,
            role: "none"
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), _extends({
            ref: function ref(r) {
                buttonRefs.current[index] = r;
            },
            role: "menuitem",
            onFocus: function onFocus() {
                setActiveItemIndex(index);
            },
            active: activeItemIndex === index,
            focusIndicator: false,
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            hoverIndicator: !child ? undefined : 'background'
        }, theme.menu.item, {
            justify: item.justify || ((_theme$menu$item4 = theme.menu.item) == null ? void 0 : _theme$menu$item4.justify)
        }, !child ? item : _extends({}, item, {
            gap: undefined,
            icon: undefined,
            label: undefined,
            reverse: undefined
        }), {
            onClick: function onClick() {
                if (item.onClick) item.onClick.apply(item, arguments);
                if (item.close !== false) onDropClose();
            }
        }), child)));
    };
    var menuContent;
    var grouped = itemCount && Array.isArray(items[0]);
    if (grouped) {
        var index = 0;
        menuContent = items.map(function(group, groupIndex) {
            var _theme$menu$group, _theme$menu$group2, _theme$menu$group3;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
                key: groupIndex,
                flex: false
            }, groupIndex > 0 && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
                pad: theme.menu.group.separator.pad
            }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
                border: {
                    side: 'top',
                    color: (_theme$menu$group = theme.menu.group) == null || (_theme$menu$group = _theme$menu$group.separator) == null ? void 0 : _theme$menu$group.color,
                    size: (_theme$menu$group2 = theme.menu.group) == null || (_theme$menu$group2 = _theme$menu$group2.separator) == null ? void 0 : _theme$menu$group2.size
                }
            })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), _extends({}, theme.menu.container, (_theme$menu$group3 = theme.menu.group) == null ? void 0 : _theme$menu$group3.container), group.map(function(item) {
                // item index needs to be its index in the entire menu as if
                // it were a flat array
                var currentIndex = index;
                index += 1;
                return menuItem(item, currentIndex);
            })));
        });
    } else menuContent = items.map(function(item, index) {
        return menuItem(item, index);
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keyboard.Keyboard), {
        onDown: onDropOpen,
        onUp: onDropOpen,
        onSpace: onSelectMenuItem,
        onEsc: onDropClose,
        onTab: onDropClose,
        onKeyDown: onKeyDown
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _dropButton.DropButton), _extends({
        ref: ref
    }, rest, buttonProps, {
        a11yTitle: a11y || format({
            id: 'menu.openMenu',
            messages: messages
        }),
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        onAlign: setAlignControlMirror,
        disabled: disabled,
        dropAlign: align,
        dropTarget: dropTarget,
        dropProps: dropProps || themeDropProps,
        open: isOpen,
        onOpen: onDropOpen,
        onClose: onDropClose,
        dropContent: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keyboard.Keyboard), {
            onTab: function onTab(event) {
                return event.shiftKey ? onPreviousMenuItem(event) : onNextMenuItem(event);
            },
            onDown: onNextMenuItem,
            onUp: onPreviousMenuItem,
            onEnter: onSelectMenuItem
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(ContainerBox, _extends({
            ref: dropContainerRef,
            tabIndex: -1,
            background: dropBackground || theme.menu.background
        }, passThemeFlag), alignControlMirror === 'top' && align.bottom !== 'top' && align.top !== 'bottom' ? controlMirror : undefined, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), _extends({
            overflow: "auto",
            role: "menu",
            a11yTitle: a11y
        }, !grouped ? theme.menu.container : {}), menuContent), !initialAlignTop && // don't show controlMirror if caller is using
        // align.bottom === 'top'
        alignControlMirror === 'bottom' && align.bottom !== 'top' && align.top !== 'bottom' ? controlMirror : undefined))
    }), content));
});
Menu.displayName = 'Menu';
Menu.propTypes = (0, _propTypes.MenuPropTypes);

},{"react":"8CCva","styled-components":"6bGrk","../Box":"4o01A","../Button":"fVON6","../DropButton":"7Dx1v","../Keyboard":"7WukC","../Text":"kz1Ni","../../utils":"fx31z","../../contexts/MessageContext":"9V5sq","./propTypes":"cujlK","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7Dx1v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropButton", ()=>(0, _dropButton.DropButton));
var _dropButton = require("./DropButton");

},{"./DropButton":"jzpw4","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jzpw4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropButton", ()=>DropButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("../Button");
var _drop = require("../Drop");
var _utils = require("../../utils");
var _propTypes = require("./propTypes");
var _excluded = [
    "a11yTitle",
    "onAlign",
    "disabled",
    "dropAlign",
    "dropProps",
    "dropContent",
    "dropTarget",
    "id",
    "open",
    "onClick",
    "onClose",
    "onOpen"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var defaultDropAlign = {
    top: 'top',
    left: 'left'
};
var DropButton = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var _ref$a11yTitle = _ref.a11yTitle, a11yTitle = _ref$a11yTitle === void 0 ? 'Open Drop' : _ref$a11yTitle, onAlign = _ref.onAlign, disabled = _ref.disabled, _ref$dropAlign = _ref.dropAlign, dropAlign = _ref$dropAlign === void 0 ? defaultDropAlign : _ref$dropAlign, dropProps = _ref.dropProps, dropContent = _ref.dropContent, dropTarget = _ref.dropTarget, id = _ref.id, open = _ref.open, onClick = _ref.onClick, onClose = _ref.onClose, onOpen = _ref.onOpen, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var buttonRef = (0, _utils.useForwardedRef)(ref);
    var _useState = (0, _react.useState)(), show = _useState[0], setShow = _useState[1];
    (0, _react.useEffect)(function() {
        if (open !== undefined && open !== show) setShow(open);
    }, [
        open,
        show
    ]);
    var onDropClose = (0, _react.useCallback)(function(event) {
        // if the user has clicked on our Button, don't do anything here,
        // handle that in onClickInternal() below.
        var node = event.composed && event.composedPath()[0] || event.target;
        while(node && node !== document && !(node instanceof ShadowRoot) && node !== buttonRef.current)node = node.parentNode;
        if (node !== buttonRef.current) {
            // don't change internal state if caller is driving
            if (open === undefined) setShow(false);
            if (onClose) onClose(event);
        }
    }, [
        buttonRef,
        onClose,
        open
    ]);
    var onClickInternal = (0, _react.useCallback)(function(event) {
        if (!show) {
            setShow(true);
            if (onOpen) onOpen(event);
        } else {
            setShow(false);
            if (onClose) onClose(event);
        }
        if (onClick) onClick(event);
    }, [
        onClick,
        onClose,
        onOpen,
        show
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), _extends({
        id: id,
        ref: buttonRef,
        a11yTitle: a11yTitle,
        disabled: disabled
    }, rest, {
        onClick: onClickInternal
    })), show && buttonRef.current && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _drop.Drop), _extends({
        id: id ? id + "__drop" : undefined,
        onAlign: onAlign,
        restrictFocus: true,
        align: dropAlign,
        target: dropTarget || buttonRef,
        onClickOutside: onDropClose,
        onEsc: onDropClose
    }, dropProps), dropContent));
});
DropButton.displayName = 'DropButton';
DropButton.propTypes = (0, _propTypes.DropButtonPropTypes);

},{"react":"8CCva","../Button":"fVON6","../Drop":"hXFtw","../../utils":"fx31z","./propTypes":"12hVt","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"12hVt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DropButtonPropTypes", ()=>DropButtonPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var PropType = {};
var DropButtonPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cujlK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuPropTypes", ()=>MenuPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var VERTICAL_ALIGN_OPTIONS = [
    'top',
    'bottom'
];
var HORIZONTAL_ALIGN_OPTIONS = [
    'right',
    'left'
];
var PropType = {};
var MenuPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"g5GDL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Nav", ()=>(0, _nav.Nav));
var _nav = require("./Nav");

},{"./Nav":"5DpdQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5DpdQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Nav", ()=>Nav);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("../Box");
function _objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Nav = function Nav(_ref) {
    var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), _extends({
        as: "nav",
        flex: false,
        gap: "medium"
    }, rest));
};

},{"react":"8CCva","../Box":"4o01A","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"e6Wgp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sidebar", ()=>(0, _sidebar.Sidebar));
var _sidebar = require("./Sidebar");

},{"./Sidebar":"cWZlr","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cWZlr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sidebar", ()=>Sidebar);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("../Box");
var _propTypes = require("./propTypes");
var _excluded = [
    "children",
    "footer",
    "header"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var Sidebar = function Sidebar(_ref) {
    var children = _ref.children, footer = _ref.footer, header = _ref.header, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), _extends({
        pad: "small",
        gap: "large",
        height: {
            min: '100%'
        }
    }, rest), header, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
        flex: true
    }, children), footer);
};
Sidebar.propTypes = (0, _propTypes.SidebarPropTypes);

},{"react":"8CCva","../Box":"4o01A","./propTypes":"4aDk8","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4aDk8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SidebarPropTypes", ()=>SidebarPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PropType = {};
var SidebarPropTypes = PropType;

},{"prop-types":"j03Ye","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"e38EX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Github", ()=>Github);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Github = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Github"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#333",
        fillRule: "evenodd",
        d: "M11.999 1C5.926 1 1 5.925 1 12c0 4.86 3.152 8.983 7.523 10.437.55.102.75-.238.75-.53 0-.26-.009-.952-.014-1.87-3.06.664-3.706-1.475-3.706-1.475-.5-1.27-1.221-1.61-1.221-1.61-.999-.681.075-.668.075-.668 1.105.078 1.685 1.134 1.685 1.134.981 1.68 2.575 1.195 3.202.914.1-.71.384-1.195.698-1.47-2.442-.278-5.01-1.222-5.01-5.437 0-1.2.428-2.183 1.132-2.952-.114-.278-.491-1.397.108-2.91 0 0 .923-.297 3.025 1.127A10.536 10.536 0 0 1 12 6.32a10.49 10.49 0 0 1 2.754.37c2.1-1.424 3.022-1.128 3.022-1.128.6 1.514.223 2.633.11 2.911.705.769 1.13 1.751 1.13 2.952 0 4.226-2.572 5.156-5.022 5.428.395.34.747 1.01.747 2.037 0 1.47-.014 2.657-.014 3.017 0 .295.199.637.756.53C19.851 20.979 23 16.859 23 12c0-6.075-4.926-11-11.001-11"
    }));
});
Github.displayName = 'Github';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9LwnH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormDown", ()=>FormDown);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var FormDown = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormDown"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m18 9-6 6-6-6"
    }));
});
FormDown.displayName = 'FormDown';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6RgCv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Home", ()=>Home);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Home = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Home"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m1 11 11-9 11 9m-8 12v-8H9v8m-5 0V9m16 14V9"
    }));
});
Home.displayName = 'Home';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dbeW0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MuiLockIcon", ()=>MuiLockIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _blank = require("grommet-icons/es6/icons/Blank");
const MuiLockIcon = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blank.Blank), {
        "aria-hidden": undefined,
        "aria-label": "Lock",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#333",
            d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1z"
        })
    });

},{"react/jsx-runtime":"6pm7f","grommet-icons/es6/icons/Blank":"frgvY","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dMVk6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Logout", ()=>Logout);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Logout = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Logout"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#231F20",
        strokeWidth: "2",
        d: "M13 9V2H1v20h12v-7m9-3H5m12-5 5 5-5 5"
    }));
});
Logout.displayName = 'Logout';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jA7pp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Menu", ()=>Menu);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Menu = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Menu"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 19h20M2 5h20M2 12h20"
    }));
});
Menu.displayName = 'Menu';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"k4h3O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Language", ()=>Language);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _blank = require("grommet-icons/es6/icons/Blank");
const Language = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blank.Blank), {
        "aria-hidden": undefined,
        "aria-label": "Language",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#333",
            d: "M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
        })
    });

},{"react/jsx-runtime":"6pm7f","react":"8CCva","grommet-icons/es6/icons/Blank":"frgvY","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"27whc":[function(require,module,exports,__globalThis) {
/**
 *
 * ThemeSwitcher
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThemeSwitcher", ()=>ThemeSwitcher);
parcelHelpers.export(exports, "ThemeSelect", ()=>ThemeSelect);
var _jsxRuntime = require("react/jsx-runtime");
var _moon = require("grommet-icons/es6/icons/Moon");
var _sun = require("grommet-icons/es6/icons/Sun");
var _system = require("grommet-icons/es6/icons/System");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _slice = require("styles/theme/slice");
var _selectors = require("styles/theme/slice/selectors");
var _selectWithIcon = require("../SelectWithIcon");
var _sidebar = require("../Sidebar");
var _utils = require("styles/theme/utils");
const getThemesIcons = (t, size)=>({
        light: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sun.Sun), {
            "aria-label": t('theme.lightMode', 'Light mode'),
            size: size
        }),
        dark: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moon.Moon), {
            "aria-label": t('theme.darkMode', 'Dark mode'),
            size: size
        }),
        system: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _system.System), {
            "aria-label": t('theme.system', 'System'),
            size: size
        })
    });
const ThemeSwitcher = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const theme = (0, _reactRedux.useSelector)((0, _selectors.selectTheme));
    const dispatch = (0, _reactRedux.useDispatch)();
    const icons = getThemesIcons(t);
    const modes = {
        light: {
            icon: icons.dark,
            label: t('theme.darkMode', 'Dark mode')
        },
        dark: {
            icon: icons.light,
            label: t('theme.lightMode', 'Light mode')
        }
    };
    const currentMode = modes[(0, _utils.getTargetTheme)(theme)];
    const switchTheme = ()=>{
        const newTheme = (0, _utils.getTargetTheme)(theme) === 'dark' ? 'light' : 'dark';
        dispatch((0, _slice.themeActions).changeTheme(newTheme));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.SidebarButton), {
        icon: currentMode.icon,
        label: currentMode.label,
        onClick: switchTheme
    });
});
const ThemeSelect = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const theme = (0, _reactRedux.useSelector)((0, _selectors.selectTheme));
    const dispatch = (0, _reactRedux.useDispatch)();
    const icons = getThemesIcons(t, '24px');
    const themeOptions = [
        {
            value: 'light',
            label: t('theme.lightMode', 'Light mode')
        },
        {
            value: 'dark',
            label: t('theme.darkMode', 'Dark mode')
        },
        {
            value: 'system',
            label: t('theme.system', 'System')
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectWithIcon.SelectWithIcon), {
        label: t('theme.title', 'Theme'),
        id: "theme",
        name: "theme",
        icon: icons[theme],
        value: theme,
        options: themeOptions,
        onChange: (option)=>dispatch((0, _slice.themeActions).changeTheme(option))
    });
};

},{"react/jsx-runtime":"6pm7f","grommet-icons/es6/icons/Moon":"5mkg0","grommet-icons/es6/icons/Sun":"dAphN","grommet-icons/es6/icons/System":"3JT9X","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","styles/theme/slice":"56nVt","styles/theme/slice/selectors":"9i0Ji","../SelectWithIcon":"hmeUh","../Sidebar":"5xMev","styles/theme/utils":"lNPdT","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5mkg0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Moon", ()=>Moon);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Moon = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Moon"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        stroke: "#000",
        fill: "none",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M9.874 5.008c2.728-1.68 6.604-1.014 8.25.197-2.955.84-5.11 3.267-5.242 6.415-.18 4.28 3.006 6.588 5.24 7.152-1.964 1.343-4.36 1.293-5.235 1.172-3.568-.492-6.902-3.433-7.007-7.711-.106-4.278 2.573-6.35 3.994-7.225z"
    }));
});
Moon.displayName = 'Moon';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dAphN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sun", ()=>Sun);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Sun = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Sun"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        stroke: "#000",
        fill: "none",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2",
        d: "M12 4V2m0 20v-2m8-8h2M2 12h2m13.657-5.657L19.07 4.93M4.93 19.07l1.414-1.414m0-11.314L4.93 4.93m14.14 14.14-1.414-1.414M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
    }));
});
Sun.displayName = 'Sun';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3JT9X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "System", ()=>System);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var System = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "System"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 19h22V1H1v18zm4 4h14H5zm3 0h8v-4H8v4zM7.757 5.757l2.122 2.122-2.122-2.122zM9 10H6h3zm.879 2.121-2.122 2.122 2.122-2.122zM12 13v3-3zm2.121-.879 2.122 2.122-2.122-2.122zM18 10h-3 3zm-1.757-4.243-2.122 2.122 2.122-2.122zM12 7V4v3zm0 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"
    }));
});
System.displayName = 'System';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hmeUh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectWithIcon", ()=>SelectWithIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _box = require("grommet/es6/components/Box");
var _formField = require("grommet/es6/components/FormField");
var _select = require("grommet/es6/components/Select");
var _tip = require("grommet/es6/components/Tip");
var _circleQuestion = require("grommet-icons/es6/icons/CircleQuestion");
const StyledBox = (0, _styledComponentsDefault.default)((0, _box.Box))`
  position: relative;
  flex-direction: row;
`;
const StyledIconContainer = (0, _styledComponentsDefault.default)((0, _box.Box))`
  position: absolute;
  top: 10px;
  left: 12px;
`;
function SelectWithIcon({ icon, id, label, name, onChange, options, value, tooltip }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
        name: name,
        label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                label,
                tooltip && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        ' ',
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tip.Tip), {
                            content: tooltip,
                            dropProps: {
                                align: {
                                    bottom: 'top'
                                }
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circleQuestion.CircleQuestion), {
                                size: "16px"
                            })
                        })
                    ]
                })
            ]
        }),
        contentProps: {
            border: false
        },
        style: {
            margin: 0
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBox, {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledIconContainer, {
                    children: icon
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.Select), {
                    id: id,
                    labelKey: "label",
                    name: name,
                    onChange: ({ option })=>onChange(option.value),
                    options: options,
                    style: {
                        paddingLeft: '50px'
                    },
                    value: value,
                    valueKey: {
                        key: 'value',
                        reduce: true
                    }
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"6pm7f","styled-components":"6bGrk","grommet/es6/components/Box":"4o01A","grommet/es6/components/FormField":"dcsVI","grommet/es6/components/Select":"glb1P","grommet/es6/components/Tip":"55RvR","grommet-icons/es6/icons/CircleQuestion":"cf0k8","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dcsVI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormField", ()=>(0, _formField.FormField));
var _formField = require("./FormField");

},{"./FormField":"fnapi","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fnapi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormField", ()=>FormField);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var _useDebounce = require("../../utils/use-debounce");
var _styles = require("../../utils/styles");
var _mixins = require("../../utils/mixins");
var _refs = require("../../utils/refs");
var _box = require("../Box");
var _checkBox = require("../CheckBox");
var _checkBoxGroup = require("../CheckBoxGroup");
var _radioButtonGroup = require("../RadioButtonGroup");
var _text = require("../Text");
var _textInput = require("../TextInput");
var _formContext = require("../Form/FormContext");
var _propTypes = require("./propTypes");
var _useThemeValue = require("../../utils/useThemeValue");
var _announceContext = require("../../contexts/AnnounceContext");
var _excluded = [
    "error",
    "info",
    "message",
    "type"
], _excluded2 = [
    "component",
    "disabled",
    "invalid",
    "name",
    "onChange"
], _excluded3 = [
    "children",
    "className",
    "component",
    "contentProps",
    "disabled",
    "error",
    "help",
    "htmlFor",
    "info",
    "label",
    "margin",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "pad",
    "required",
    "style",
    "validate",
    "validateOn"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var grommetInputFocusNames = [
    'CheckBox',
    'CheckBoxGroup',
    'RadioButton',
    'RadioButtonGroup',
    'RangeInput',
    'RangeSelector',
    'StarRating',
    'ThumbsRating'
];
var grommetInputNames = [
    'CheckBox',
    'CheckBoxGroup',
    'TextInput',
    'Select',
    'MaskedInput',
    'SelectMultiple',
    'TextArea',
    'DateInput',
    'FileInput',
    'RadioButton',
    'RadioButtonGroup',
    'RangeInput',
    'RangeSelector',
    'StarRating',
    'ThumbsRating'
];
var grommetInputPadNames = [
    'CheckBox',
    'CheckBoxGroup',
    'RadioButton',
    'RadioButtonGroup',
    'RangeInput',
    'RangeSelector'
];
var isGrommetInput = function isGrommetInput(comp) {
    return comp && (grommetInputNames.indexOf(comp.displayName) !== -1 || grommetInputPadNames.indexOf(comp.displayName) !== -1);
};
var getFocusStyle = function getFocusStyle(props) {
    var _props$theme$formFiel;
    if (props.focus && props.containerFocus === false && ((_props$theme$formFiel = props.theme.formField) == null || (_props$theme$formFiel = _props$theme$formFiel.focus) == null ? void 0 : _props$theme$formFiel.containerFocus) === false) return null;
    return props.focus ? (0, _styles.focusStyle)({
        justBorder: true
    }) : undefined;
};
var FormFieldBox = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "FormField__FormFieldBox",
    componentId: "sc-m9hood-0"
})([
    "",
    " ",
    ""
], function(props) {
    return getFocusStyle(props);
}, function(props) {
    var _props$theme$formFiel2;
    return (_props$theme$formFiel2 = props.theme.formField) == null ? void 0 : _props$theme$formFiel2.extend;
});
var FormFieldContentBox = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "FormField__FormFieldContentBox",
    componentId: "sc-m9hood-1"
})([
    "",
    " ",
    ""
], function(props) {
    return getFocusStyle(props);
}, function(props) {
    var _props$theme$formFiel3;
    return props.theme.formField && ((_props$theme$formFiel3 = props.theme.formField[props == null ? void 0 : props.componentName]) == null || (_props$theme$formFiel3 = _props$theme$formFiel3.container) == null ? void 0 : _props$theme$formFiel3.extend);
});
var StyledContentsBox = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "FormField__StyledContentsBox",
    componentId: "sc-m9hood-2"
})([
    "",
    ""
], function(props) {
    var _props$theme$formFiel4;
    return props.theme.formField && ((_props$theme$formFiel4 = props.theme.formField[props == null ? void 0 : props.componentName]) == null || (_props$theme$formFiel4 = _props$theme$formFiel4.container) == null ? void 0 : _props$theme$formFiel4.extend);
});
var StyledMessageContainer = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "FormField__StyledMessageContainer",
    componentId: "sc-m9hood-3"
})([
    "",
    ""
], function(props) {
    return props.messageType && props.theme.formField[props.messageType].container && props.theme.formField[props.messageType].container.extend;
});
var RequiredText = (0, _styledComponentsDefault.default)((0, _text.Text)).withConfig({
    displayName: "FormField__RequiredText",
    componentId: "sc-m9hood-4"
})([
    "color:inherit;font-weight:inherit;line-height:inherit;"
]);
var ScreenReaderOnly = (0, _styledComponentsDefault.default)((0, _text.Text)).withConfig({
    displayName: "FormField__ScreenReaderOnly",
    componentId: "sc-m9hood-5"
})([
    "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0;"
]);
var Message = function Message(_ref) {
    var error = _ref.error, info = _ref.info, message = _ref.message, type = _ref.type, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme, passThemeFlag = _useThemeValue1.passThemeFlag;
    if (message) {
        var icon;
        var containerProps;
        if (type) {
            icon = theme.formField[type] && theme.formField[type].icon;
            containerProps = theme.formField[type] && theme.formField[type].container;
        }
        var messageContent;
        if (typeof message === 'string') messageContent = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), rest, message);
        else messageContent = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), rest, message);
        return icon || containerProps ? /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledMessageContainer, _extends({
            direction: "row",
            messageType: type
        }, containerProps, passThemeFlag), icon && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
            flex: false
        }, icon), messageContent) : messageContent;
    }
    return null;
};
var Input = function Input(_ref2) {
    var component = _ref2.component, disabled = _ref2.disabled, invalid = _ref2.invalid, name = _ref2.name, _onChange = _ref2.onChange, rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    var formContext = (0, _react.useContext)((0, _formContext.FormContext));
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: rest.value
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var InputComponent = component || (0, _textInput.TextInput);
    // Grommet input components already check for FormContext
    // and, using their `name`, end up calling the useFormInput.setValue()
    // already. For custom components, we expect they will call
    // this onChange() and we'll call setValue() here, primarily
    // for backwards compatibility.
    var extraProps = isGrommetInput(InputComponent) ? {
        focusIndicator: false,
        onChange: _onChange,
        plain: true
    } : {
        value: value,
        onChange: function onChange(event) {
            setValue(event.value !== undefined ? event.value : event.target.value);
            if (_onChange) _onChange(event);
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(InputComponent, _extends({
        name: name,
        disabled: disabled,
        "aria-invalid": invalid || undefined
    }, rest, extraProps));
};
var FormField = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref3, ref) {
    var _theme$formField2, _theme$global$input, _formFieldTheme$disab, _formFieldTheme$disab2;
    var children = _ref3.children, className = _ref3.className, component = _ref3.component, contentProps = _ref3.contentProps, disabled = _ref3.disabled, errorProp = _ref3.error, help = _ref3.help, htmlFor = _ref3.htmlFor, infoProp = _ref3.info, label = _ref3.label, margin = _ref3.margin, name = _ref3.name, _onBlur = _ref3.onBlur, onChange = _ref3.onChange, _onFocus = _ref3.onFocus, pad = _ref3.pad, required = _ref3.required, style = _ref3.style, validate = _ref3.validate, validateOn = _ref3.validateOn, rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
    var _useThemeValue2 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue2.theme, passThemeFlag = _useThemeValue2.passThemeFlag;
    var formContext = (0, _react.useContext)((0, _formContext.FormContext));
    var _formContext$useFormF = formContext.useFormField({
        disabled: disabled,
        error: errorProp,
        info: infoProp,
        name: name,
        required: required,
        validate: validate,
        validateOn: validateOn
    }), error = _formContext$useFormF.error, info = _formContext$useFormF.info, inForm = _formContext$useFormF.inForm, contextOnBlur = _formContext$useFormF.onBlur, contextOnChange = _formContext$useFormF.onChange;
    var formKind = formContext.kind;
    var _useState = (0, _react.useState)(), focus = _useState[0], setFocus = _useState[1];
    var formFieldRef = (0, _refs.useForwardedRef)(ref);
    var formFieldTheme = theme.formField;
    var themeBorder = formFieldTheme.border;
    var debounce = (0, _useDebounce.useDebounce)();
    var portalContext = (0, _react.useContext)((0, _utils.PortalContext));
    var announce = (0, _react.useContext)((0, _announceContext.AnnounceContext));
    (0, _react.useEffect)(function() {
        if (error && validate != null && validate.max) announce(error, 'polite', 5000);
    }, [
        error,
        announce,
        validate == null ? void 0 : validate.max
    ]);
    var readOnlyField = (0, _react.useMemo)(function() {
        var readOnly = false;
        if (children) (0, _react.Children).map(children, function(child) {
            var _child$props, _child$props2;
            if (((child == null || (_child$props = child.props) == null ? void 0 : _child$props.readOnly) === true || (child == null || (_child$props2 = child.props) == null ? void 0 : _child$props2.readOnlyCopy) === true) && child.type && ('TextInput'.indexOf(child.type.displayName) !== -1 || 'DateInput'.indexOf(child.type.displayName) !== -1)) readOnly = true;
        });
        return readOnly;
    }, [
        children
    ]);
    var containerFocus = (0, _react.useMemo)(function() {
        var focusIndicatorFlag = true;
        (0, _react.Children).forEach(children, function(child) {
            var _theme$formField;
            if (child && child.type && grommetInputFocusNames.includes(child.type.displayName) && ((_theme$formField = theme.formField) == null || (_theme$formField = _theme$formField.focus) == null ? void 0 : _theme$formField.containerFocus) !== true) focusIndicatorFlag = false;
        });
        return focusIndicatorFlag;
    }, [
        children,
        (_theme$formField2 = theme.formField) == null || (_theme$formField2 = _theme$formField2.focus) == null ? void 0 : _theme$formField2.containerFocus
    ]);
    // This is here for backwards compatibility. In case the child is a grommet
    // input component, set plain and focusIndicator props, if they aren't
    // already set.
    var wantContentPad = component && (component === (0, _checkBox.CheckBox) || component === (0, _checkBoxGroup.CheckBoxGroup) || component === (0, _radioButtonGroup.RadioButtonGroup));
    var contents = themeBorder && children && (0, _react.Children).map(children, function(child) {
        if (child && child.type && grommetInputPadNames.indexOf(child.type.displayName) !== -1) wantContentPad = true;
        var isInputComponent = child && child.type && grommetInputNames.indexOf(child.type.displayName) !== -1;
        if (isInputComponent && child.props.plain === undefined && child.props.focusIndicator === undefined) {
            var _formFieldTheme$check;
            return /*#__PURE__*/ (0, _react.cloneElement)(child, {
                plain: true,
                focusIndicator: !containerFocus,
                pad: 'CheckBox'.indexOf(child.type.displayName) !== -1 ? formFieldTheme == null || (_formFieldTheme$check = formFieldTheme.checkBox) == null ? void 0 : _formFieldTheme$check.pad : undefined
            });
        }
        return child;
    }) || children;
    // put rest on container, unless we use internal Input
    var containerRest = rest;
    if (inForm) {
        if (!contents) containerRest = {};
        contents = contents || /*#__PURE__*/ (0, _reactDefault.default).createElement(Input, _extends({
            component: component,
            disabled: disabled,
            invalid: !!error,
            name: name,
            label: component === (0, _checkBox.CheckBox) ? label : undefined
        }, rest));
    }
    var themeContentProps = _extends({}, formFieldTheme.content);
    if (!pad && !wantContentPad) themeContentProps.pad = undefined;
    if (themeBorder && themeBorder.position === 'inner') {
        if (readOnlyField) {
            var _theme$global$input$r;
            themeContentProps.background = (_theme$global$input$r = theme.global.input.readOnly) == null ? void 0 : _theme$global$input$r.background;
        } else if (error && formFieldTheme.error) themeContentProps.background = formFieldTheme.error.background;
        else if (disabled && formFieldTheme.disabled) themeContentProps.background = formFieldTheme.disabled.background;
    }
    // fileinput handle
    // use fileinput plain use formfield to drive the border
    var isFileInputComponent;
    children && (0, _react.Children).forEach(children, function(child) {
        if (child && child.type && 'FileInput'.indexOf(child.type.displayName) !== -1) isFileInputComponent = true;
    });
    if (component && component.displayName === 'FileInput' && !isFileInputComponent) isFileInputComponent = true;
    var childName;
    (0, _react.Children).forEach(children, function(child) {
        if (child && child.type) {
            var _childName;
            childName = child.type.displayName;
            // camelCase component name to match theme object key
            if (((_childName = childName) == null ? void 0 : _childName.length) > 0) childName = childName.charAt(0).toLowerCase() + childName.slice(1);
        }
    });
    if (!themeBorder) contents = /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledContentsBox, _extends({
        disabledProp: disabled,
        error: error,
        componentName: childName
    }, themeContentProps, contentProps), contents);
    var borderColor;
    if (disabled && formFieldTheme.disabled.border && formFieldTheme.disabled.border.color) borderColor = formFieldTheme.disabled.border.color;
    else if (readOnlyField && (_theme$global$input = theme.global.input) != null && (_theme$global$input = _theme$global$input.readOnly) != null && (_theme$global$input = _theme$global$input.border) != null && _theme$global$input.color) {
        var _theme$global$input2;
        borderColor = (_theme$global$input2 = theme.global.input) == null || (_theme$global$input2 = _theme$global$input2.readOnly) == null || (_theme$global$input2 = _theme$global$input2.border) == null ? void 0 : _theme$global$input2.color;
    } else if (// backward compatibility check
    error && themeBorder && themeBorder.error.color || error && formFieldTheme.error && formFieldTheme.error.border) {
        if (themeBorder.error.color && formFieldTheme.error.border === undefined) borderColor = themeBorder.error.color || 'status-critical';
        else if (formFieldTheme.error.border && formFieldTheme.error.border.color) borderColor = formFieldTheme.error.border.color || 'status-critical';
    } else if (focus && formFieldTheme.focus && formFieldTheme.focus.border && formFieldTheme.focus.border.color) borderColor = formFieldTheme.focus.border.color;
    else borderColor = themeBorder && themeBorder.color || 'border';
    var labelStyle;
    if (formKind) labelStyle = _extends({}, formFieldTheme[formKind].label);
    else labelStyle = _extends({}, formFieldTheme.label);
    if (disabled) labelStyle.color = formFieldTheme.disabled && formFieldTheme.disabled.label ? formFieldTheme.disabled.label.color : labelStyle.color;
    var themeHelpProps = _extends({}, formFieldTheme.help, disabled && {
        color: formFieldTheme == null || (_formFieldTheme$disab = formFieldTheme.disabled) == null || (_formFieldTheme$disab = _formFieldTheme$disab.help) == null ? void 0 : _formFieldTheme$disab.color
    });
    var themeInfoProps = _extends({}, formFieldTheme.info, disabled && {
        color: formFieldTheme == null || (_formFieldTheme$disab2 = formFieldTheme.disabled) == null || (_formFieldTheme$disab2 = _formFieldTheme$disab2.info) == null ? void 0 : _formFieldTheme$disab2.color
    });
    var abut;
    var abutMargin;
    var outerStyle = style;
    // If fileinput is wrapped in a formfield we want to use
    // the border style from the fileInput.theme. We also do not
    // want the foocus around the formfield since the the focus
    // is on the anchor/button inside fileinput
    if (themeBorder) {
        var innerProps = themeBorder.position === 'inner' ? {
            border: _extends({}, themeBorder, {
                size: isFileInputComponent ? theme.fileInput.border.size : undefined,
                style: isFileInputComponent ? theme.fileInput.border.style : undefined,
                side: isFileInputComponent ? theme.fileInput.border.side : themeBorder.side || 'bottom',
                color: borderColor
            }),
            round: formFieldTheme.round,
            focus: isFileInputComponent ? undefined : focus
        } : {};
        contents = /*#__PURE__*/ (0, _reactDefault.default).createElement(FormFieldContentBox, _extends({
            disabledProp: disabled,
            error: error,
            componentName: childName
        }, themeContentProps, innerProps, contentProps, {
            containerFocus: containerFocus // internal prop
        }, passThemeFlag), contents);
        var mergedMargin = margin || formFieldTheme.margin;
        abut = themeBorder.position === 'outer' && (themeBorder.side === 'all' || themeBorder.side === 'horizontal' || !themeBorder.side) && !(mergedMargin && (typeof mergedMargin === 'string' && mergedMargin !== 'none' || mergedMargin.bottom && mergedMargin.bottom !== 'none' || mergedMargin.horizontal && mergedMargin.horizontal !== 'none'));
        if (abut) {
            // marginBottom is set to overlap adjacent fields
            abutMargin = {
                bottom: '-1px'
            };
            if (margin) abutMargin = margin;
            else if (themeBorder.size) // if the user defines a margin,
            // then the default margin below will be overridden
            abutMargin = {
                bottom: "-" + (0, _mixins.parseMetricToNum)(theme.global.borderSize[themeBorder.size] || themeBorder.size) + "px"
            };
            outerStyle = _extends({
                position: focus ? 'relative' : undefined,
                zIndex: focus ? 10 : undefined
            }, style);
        }
    }
    var outerBackground;
    if (themeBorder && themeBorder.position === 'outer') {
        if (error && formFieldTheme.error && formFieldTheme.error.background) outerBackground = formFieldTheme.error.background;
        else if (focus && formFieldTheme.focus && formFieldTheme.focus.background && formFieldTheme.focus.background.color) outerBackground = formFieldTheme.focus.background.color;
        else if (disabled && formFieldTheme.disabled && formFieldTheme.disabled.background) outerBackground = formFieldTheme.disabled.background;
    }
    var outerProps = themeBorder && themeBorder.position === 'outer' ? {
        border: _extends({}, themeBorder, {
            color: borderColor
        }),
        round: formFieldTheme.round,
        focus: focus
    } : {};
    var requiredIndicator = theme.formField.label.requiredIndicator;
    if (requiredIndicator === true) // accessibility resource: https://www.deque.com/blog/anatomy-of-accessible-forms-required-form-fields/
    // this approach allows the required indicator to be hidden visually,
    // but present for assistive tech.
    // using aria-hidden so screen does not read out "star" and
    // just reads out "required"
    requiredIndicator = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement(RequiredText, {
        "aria-hidden": "true"
    }, "*"), /*#__PURE__*/ (0, _reactDefault.default).createElement(ScreenReaderOnly, null, "required"));
    var showRequiredIndicator = required && requiredIndicator;
    if (typeof required === 'object' && required.indicator === false) showRequiredIndicator = false;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(FormFieldBox, _extends({
        ref: formFieldRef,
        className: className,
        background: outerBackground,
        margin: abut ? abutMargin : margin || _extends({}, formFieldTheme.margin)
    }, outerProps, {
        style: outerStyle,
        containerFocus: containerFocus // internal prop
        ,
        onFocus: function onFocus(event) {
            var _formFieldRef$current;
            var root = (_formFieldRef$current = formFieldRef.current) == null ? void 0 : _formFieldRef$current.getRootNode();
            if (root) setFocus((0, _utils.containsFocus)(formFieldRef.current) && (0, _utils.shouldKeepFocus)(root));
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            // if input has a drop and focus is within drop
            // prevent onBlur validation from running until
            // focus is no longer within the drop or input
            if (contextOnBlur && !formFieldRef.current.contains(event.relatedTarget) && !(0, _utils.withinDropPortal)(event.relatedTarget, portalContext)) contextOnBlur(event);
            if (_onBlur) _onBlur(event);
        },
        onChange: contextOnChange || onChange ? function(event) {
            event.persist();
            if (onChange) onChange(event);
            if (contextOnChange) debounce(function() {
                return function() {
                    return contextOnChange(event);
                };
            });
        } : undefined
    }, containerRest, passThemeFlag), label && component !== (0, _checkBox.CheckBox) || help ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, label && component !== (0, _checkBox.CheckBox) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({
        as: "label",
        htmlFor: htmlFor
    }, labelStyle), label, showRequiredIndicator ? requiredIndicator : undefined), /*#__PURE__*/ (0, _reactDefault.default).createElement(Message, _extends({
        message: help
    }, themeHelpProps))) : undefined, contents, /*#__PURE__*/ (0, _reactDefault.default).createElement(Message, _extends({
        type: "error",
        message: error
    }, formFieldTheme.error)), /*#__PURE__*/ (0, _reactDefault.default).createElement(Message, _extends({
        type: "info",
        message: info
    }, themeInfoProps)));
});
FormField.displayName = 'FormField';
FormField.propTypes = (0, _propTypes.FormFieldPropTypes);

},{"react":"8CCva","styled-components":"6bGrk","../../utils":"fx31z","../../utils/use-debounce":"ubSJt","../../utils/styles":"4m6LZ","../../utils/mixins":"gx4wP","../../utils/refs":"jeN98","../Box":"4o01A","../CheckBox":"gaRRO","../CheckBoxGroup":"iDUvn","../RadioButtonGroup":"kbiv9","../Text":"kz1Ni","../TextInput":"cL4wi","../Form/FormContext":"ky7Rv","./propTypes":"9grNg","../../utils/useThemeValue":"6LfDQ","../../contexts/AnnounceContext":"fESY4","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ubSJt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDebounce", ()=>useDebounce);
var _react = require("react");
var _useThemeValue = require("./useThemeValue");
var useDebounce = function useDebounce(debounceDelay) {
    var _useState = (0, _react.useState)(), func = _useState[0], setFunc = _useState[1];
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme;
    var delay = debounceDelay || theme.global.debounceDelay;
    (0, _react.useEffect)(function() {
        var timer;
        if (func) timer = setTimeout(function() {
            return func();
        }, delay);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        func,
        delay
    ]);
    return setFunc;
};
exports.default = useDebounce;

},{"react":"8CCva","./useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gaRRO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckBox", ()=>(0, _checkBox.CheckBox));
var _checkBox = require("./CheckBox");

},{"./CheckBox":"gC4E5","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gC4E5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckBox", ()=>CheckBox);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _object = require("../../utils/object");
var _formContext = require("../Form/FormContext");
var _propTypes = require("./propTypes");
var _styledCheckBox = require("./StyledCheckBox");
var _utils = require("../../utils");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "a11yTitle",
    "aria-label",
    "checked",
    "children",
    "containerProps",
    "defaultChecked",
    "disabled",
    "fill",
    "focus",
    "focusIndicator",
    "id",
    "label",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseOut",
    "onMouseOver",
    "pad",
    "reverse",
    "toggle",
    "indeterminate"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var stopLabelClick = function stopLabelClick(event) {
    // prevents clicking on the label trigging the event twice
    // https://stackoverflow.com/questions/24501497/why-the-onclick-element-will-trigger-twice-for-label-element
    if (event.target.type !== 'checkbox') event.stopPropagation();
};
var CheckBox = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var _ref2;
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], checkedProp = _ref.checked, children = _ref.children, containerProps = _ref.containerProps, _ref$defaultChecked = _ref.defaultChecked, defaultChecked = _ref$defaultChecked === void 0 ? false : _ref$defaultChecked, disabled = _ref.disabled, fill = _ref.fill, focusProp = _ref.focus, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, id = _ref.id, label = _ref.label, name = _ref.name, _onBlur = _ref.onBlur, _onChange = _ref.onChange, _onFocus = _ref.onFocus, _onMouseEnter = _ref.onMouseEnter, _onMouseLeave = _ref.onMouseLeave, _onMouseOut = _ref.onMouseOut, _onMouseOver = _ref.onMouseOver, pad = _ref.pad, reverse = _ref.reverse, toggle = _ref.toggle, indeterminate = _ref.indeterminate, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme, passThemeFlag = _useThemeValue1.passThemeFlag;
    var formContext = (0, _react.useContext)((0, _formContext.FormContext));
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: checkedProp,
        initialValue: defaultChecked
    }), checked = _formContext$useFormI[0], setChecked = _formContext$useFormI[1];
    var _useState = (0, _react.useState)(focusProp), focus = _useState[0], setFocus = _useState[1];
    (0, _react.useEffect)(function() {
        // don't allow checkbox to have focus when disabled
        if (disabled && focusProp) setFocus(false);
        else setFocus(focusProp);
    }, [
        disabled,
        focusProp
    ]);
    (0, _react.useEffect)(function() {
        if (checkedProp && indeterminate) console.warn('Checkbox cannot be "checked" and "indeterminate" at the same time.');
        if (toggle && indeterminate) console.warn('Checkbox of type toggle does not have "indeterminate" state.');
    }, [
        checkedProp,
        toggle,
        indeterminate
    ]);
    var themeableProps = {
        checked: checked,
        disabled: disabled,
        focus: focus,
        // when contained in a FormField, focusIndicator = false,
        // so that the FormField has focus style. However, we still
        // need to visually indicate when a CheckBox is active.
        // If focus = true but focusIndicator = false,
        // we will apply the hover treament.
        focusIndicator: focusIndicator,
        reverse: reverse,
        toggle: toggle,
        indeterminate: indeterminate
    };
    var hidden;
    if (disabled && checked) hidden = /*#__PURE__*/ (0, _reactDefault.default).createElement("input", {
        name: name,
        type: "hidden",
        value: "true"
    });
    var _theme$checkBox$icons = theme.checkBox.icons, CheckedIcon = _theme$checkBox$icons.checked, IndeterminateIcon = _theme$checkBox$icons.indeterminate;
    var borderColor = (0, _utils.normalizeColor)(theme.checkBox.border.color, theme);
    if (checked) borderColor = (0, _utils.normalizeColor)(theme.checkBox.color || 'control', theme);
    var visual = toggle ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledCheckBox.StyledCheckBoxToggle), _extends({}, passThemeFlag, themeableProps), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledCheckBox.StyledCheckBoxKnob), _extends({}, passThemeFlag, themeableProps))) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledCheckBox.StyledCheckBoxBox), _extends({
        align: "center",
        justify: "center",
        width: theme.checkBox.size,
        height: theme.checkBox.size,
        border: {
            size: theme.checkBox.border.width,
            color: borderColor
        },
        round: theme.checkBox.check.radius
    }, passThemeFlag, themeableProps), !indeterminate && checked && (CheckedIcon ? /*#__PURE__*/ (0, _reactDefault.default).createElement(CheckedIcon, {
        theme: theme,
        as: (0, _styledCheckBox.StyledCheckBoxIcon)
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledCheckBox.StyledCheckBoxIcon), _extends({
        theme: theme,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "xMidYMid meet"
    }, themeableProps), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        d: "M6,11.3 L10.3,16 L18,6.2"
    }))), !checked && indeterminate && (IndeterminateIcon ? /*#__PURE__*/ (0, _reactDefault.default).createElement(IndeterminateIcon, {
        theme: theme,
        as: (0, _styledCheckBox.StyledCheckBoxIcon)
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledCheckBox.StyledCheckBoxIcon), _extends({
        theme: theme,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "xMidYMid meet"
    }, themeableProps), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        d: "M6,12 L18,12"
    }))));
    var side = !reverse !== !theme.dir ? 'left' : 'right';
    var checkBoxNode = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledCheckBox.StyledCheckBox), _extends({
        align: "center",
        justify: "center",
        margin: label && (_ref2 = {}, _ref2[side] = theme.checkBox.gap || 'small', _ref2)
    }, themeableProps), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledCheckBox.StyledCheckBoxInput), _extends({
        "aria-label": ariaLabel || a11yTitle
    }, passThemeFlag, rest, {
        ref: ref,
        type: "checkbox"
    }, (0, _object.removeUndefined)({
        id: id,
        name: name,
        checked: checked,
        disabled: disabled
    }), themeableProps, {
        onFocus: function onFocus(event) {
            setFocus(true);
            if (_onFocus) _onFocus(event);
        },
        onBlur: function onBlur(event) {
            setFocus(false);
            if (_onBlur) _onBlur(event);
        },
        onChange: function onChange(event) {
            setChecked(event.target.checked);
            if (_onChange) _onChange(event);
        }
    })), children ? children({
        checked: checked,
        indeterminate: indeterminate
    }) : visual, hidden);
    var normalizedLabel = typeof label === 'string' ? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", null, label) : label;
    var first = reverse ? normalizedLabel : checkBoxNode;
    var second = reverse ? checkBoxNode : normalizedLabel;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledCheckBox.StyledCheckBoxContainer), _extends({
        fillProp: fill,
        reverse: reverse
    }, (0, _object.removeUndefined)({
        htmlFor: id,
        disabled: disabled
    }), {
        checked: checked,
        labelProp: label,
        onClick: stopLabelClick,
        pad: pad,
        onMouseEnter: function onMouseEnter(event) {
            return _onMouseEnter == null ? void 0 : _onMouseEnter(event);
        },
        onMouseOver: function onMouseOver(event) {
            return _onMouseOver == null ? void 0 : _onMouseOver(event);
        },
        onMouseLeave: function onMouseLeave(event) {
            return _onMouseLeave == null ? void 0 : _onMouseLeave(event);
        },
        onMouseOut: function onMouseOut(event) {
            return _onMouseOut == null ? void 0 : _onMouseOut(event);
        }
    }, passThemeFlag, themeableProps, containerProps), first, second);
});
CheckBox.displayName = 'CheckBox';
CheckBox.propTypes = (0, _propTypes.CheckBoxPropTypes);

},{"react":"8CCva","../../utils/object":"go0Cn","../Form/FormContext":"ky7Rv","./propTypes":"ia949","./StyledCheckBox":"fwJxu","../../utils":"fx31z","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ia949":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckBoxPropTypes", ()=>CheckBoxPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
var PropType = {};
var CheckBoxPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fwJxu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledCheckBoxIcon", ()=>StyledCheckBoxIcon);
parcelHelpers.export(exports, "StyledCheckBoxContainer", ()=>StyledCheckBoxContainer);
parcelHelpers.export(exports, "StyledCheckBoxInput", ()=>StyledCheckBoxInput);
parcelHelpers.export(exports, "StyledCheckBoxBox", ()=>StyledCheckBoxBox);
parcelHelpers.export(exports, "StyledCheckBoxToggle", ()=>StyledCheckBoxToggle);
parcelHelpers.export(exports, "StyledCheckBoxKnob", ()=>StyledCheckBoxKnob);
parcelHelpers.export(exports, "StyledCheckBox", ()=>StyledCheckBox);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var _box = require("../Box");
// Note: since `fillStyle` is only used in one place, `justify-content` was
// added to it to simplify its logic. If this is ever reused somewhere else,
// consider the need of separating those once again.
var fillStyle = function fillStyle() {
    return "\n      width: auto;\n      height: 100%;\n      max-width: none;\n      flex: 1 0 auto;\n      justify-content: space-between;\n    ";
};
var disabledStyle = "\n  opacity: 0.5;\n  cursor: default;\n";
var hoverStyle = (0, _styledComponents.css)([
    "&:hover input:not([disabled]) + div,&:hover input:not([disabled]) + span{border-color:",
    ";",
    "}&:hover{background-color:",
    ";}"
], function(props) {
    var _props$theme$checkBox;
    return (0, _utils.normalizeColor)((_props$theme$checkBox = props.theme.checkBox.hover) == null || (_props$theme$checkBox = _props$theme$checkBox.border) == null ? void 0 : _props$theme$checkBox.color, props.theme);
}, function(props) {
    var _props$theme$checkBox2;
    return (_props$theme$checkBox2 = props.theme.checkBox.hover) == null ? void 0 : _props$theme$checkBox2.extend;
}, function(props) {
    var _props$theme$checkBox3;
    return (0, _utils.normalizeColor)(!props.disabled && ((_props$theme$checkBox3 = props.theme.checkBox.hover) == null || (_props$theme$checkBox3 = _props$theme$checkBox3.background) == null ? void 0 : _props$theme$checkBox3.color), props.theme);
});
var StyledCheckBoxIcon = (0, _styledComponentsDefault.default).svg.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxIcon",
    componentId: "sc-1dbk5ju-0"
})([
    "box-sizing:border-box;stroke-width:",
    ";stroke:",
    ";width:",
    ";height:",
    ";",
    ";"
], function(props) {
    return props.theme.checkBox.check.thickness;
}, function(props) {
    return (0, _utils.normalizeColor)(props.theme.checkBox.color || 'control', props.theme);
}, function(props) {
    return props.theme.checkBox.icon.size || props.theme.checkBox.size;
}, function(props) {
    return props.theme.checkBox.icon.size || props.theme.checkBox.size;
}, function(props) {
    return props.theme.checkBox.icon.extend;
});
var StyledCheckBoxContainer = (0, _styledComponentsDefault.default).label.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxContainer",
    componentId: "sc-1dbk5ju-1"
})([
    "display:flex;flex-direction:row;align-items:",
    ";user-select:none;-webkit-user-select:none;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], function(props) {
    return typeof props.labelProp === 'string' ? props.theme.checkBox.label.align : undefined;
}, function(props) {
    return props.fillProp ? fillStyle() : 'width: fit-content;';
}, function(props) {
    return (props.pad || props.theme.checkBox.pad) && (0, _utils.edgeStyle)('padding', props.pad || props.theme.checkBox.pad, props.responsive, props.theme.box.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.disabled && disabledStyle;
}, function(props) {
    return !props.disabled && 'cursor: pointer;';
}, hoverStyle, function(props) {
    var _props$theme$checkBox4, _props$theme$checkBox5;
    return props.focus && !props.focusIndicator && "\n    input:not([disabled]) + div,\n    input:not([disabled]) + span {\n      border-color: " + (0, _utils.normalizeColor)((_props$theme$checkBox4 = props.theme.checkBox.hover) == null || (_props$theme$checkBox4 = _props$theme$checkBox4.border) == null ? void 0 : _props$theme$checkBox4.color, props.theme) + ";\n    }\n\n    background-color: " + (0, _utils.normalizeColor)(!props.disabled && ((_props$theme$checkBox5 = props.theme.checkBox.hover) == null || (_props$theme$checkBox5 = _props$theme$checkBox5.background) == null ? void 0 : _props$theme$checkBox5.color), props.theme) + ";";
}, function(props) {
    return props.theme.checkBox.extend;
});
var StyledCheckBoxInput = (0, _styledComponentsDefault.default).input.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxInput",
    componentId: "sc-1dbk5ju-2"
})([
    "opacity:0;-moz-appearance:none;width:0;height:0;margin:0;",
    " &:checked + span > span{",
    ":calc( ",
    " - ",
    " );background:",
    ";}"
], function(props) {
    return !props.disabled && 'cursor: pointer;';
}, function(props) {
    return !props.theme.dir ? 'left' : 'right';
}, function(props) {
    return props.theme.checkBox.toggle.size;
}, function(props) {
    return props.theme.checkBox.size;
}, function(props) {
    return (0, _utils.normalizeColor)(props.theme.checkBox.color || 'control', props.theme);
});
var StyledCheckBoxBox = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxBox",
    componentId: "sc-1dbk5ju-3"
})([
    "",
    ";",
    ";"
], function(props) {
    return props.focus && props.focusIndicator && (0, _utils.focusStyle)();
}, function(props) {
    return props.theme.checkBox.check.extend;
});
var StyledCheckBoxToggle = (0, _styledComponentsDefault.default).span.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxToggle",
    componentId: "sc-1dbk5ju-4"
})([
    "box-sizing:border-box;vertical-align:middle;display:inline-block;width:",
    ";height:",
    ";border:",
    " solid;border-color:",
    ";border-radius:",
    ";background-color:",
    ";",
    ";",
    ";"
], function(props) {
    return props.theme.checkBox.toggle.size;
}, function(props) {
    return props.theme.checkBox.size;
}, function(props) {
    return props.theme.checkBox.border.width;
}, function(props) {
    return (0, _utils.normalizeColor)(props.theme.checkBox.border.color, props.theme);
}, function(props) {
    return props.theme.checkBox.toggle.radius;
}, function(props) {
    return props.theme.checkBox.toggle.background ? (0, _utils.normalizeColor)(props.theme.checkBox.toggle.background, props.theme) : 'transparent';
}, function(props) {
    return props.focus && props.focusIndicator && (0, _utils.focusStyle)();
}, function(props) {
    return props.theme.checkBox.toggle.extend;
});
var StyledCheckBoxKnob = (0, _styledComponentsDefault.default).span.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledCheckBox__StyledCheckBoxKnob",
    componentId: "sc-1dbk5ju-5"
})([
    "box-sizing:border-box;position:relative;display:inherit;top:-",
    ";",
    ":-",
    ";transition:all 0.3s;width:",
    ";height:",
    ";background:",
    ";border-radius:",
    ";",
    ";"
], function(props) {
    return props.theme.checkBox.border.width;
}, function(props) {
    return !props.theme.dir ? 'left' : 'right';
}, function(props) {
    return props.theme.checkBox.border.width;
}, function(props) {
    return props.theme.checkBox.size;
}, function(props) {
    return props.theme.checkBox.size;
}, function(props) {
    return (0, _utils.normalizeColor)(props.theme.checkBox.toggle.color, props.theme);
}, function(props) {
    return props.theme.checkBox.toggle.radius;
}, function(props) {
    return props.theme.checkBox.toggle.knob.extend;
});
var StyledCheckBox = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "StyledCheckBox",
    componentId: "sc-1dbk5ju-6"
})([
    "flex-shrink:0;"
]);

},{"styled-components":"6bGrk","../../utils":"fx31z","../Box":"4o01A","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iDUvn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckBoxGroup", ()=>(0, _checkBoxGroup.CheckBoxGroup));
var _checkBoxGroup = require("./CheckBoxGroup");

},{"./CheckBoxGroup":"4daXS","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4daXS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckBoxGroup", ()=>CheckBoxGroup);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _checkBox = require("../CheckBox");
var _formContext = require("../Form/FormContext");
var _styledCheckBoxGroup = require("./StyledCheckBoxGroup");
var _propTypes = require("./propTypes");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "children",
    "defaultValue",
    "value",
    "disabled",
    "focusIndicator",
    "gap",
    "labelKey",
    "valueKey",
    "onChange",
    "options",
    "name"
], _excluded2 = [
    "value"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var CheckBoxGroup = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var children = _ref.children, defaultValue = _ref.defaultValue, valueProp = _ref.value, disabledProp = _ref.disabled, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, gap = _ref.gap, labelKey = _ref.labelKey, valueKey = _ref.valueKey, onChange = _ref.onChange, optionsProp = _ref.options, name = _ref.name, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var formContext = (0, _react.useContext)((0, _formContext.FormContext));
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme, passThemeFlag = _useThemeValue1.passThemeFlag;
    // In case option is a string, normalize it to be an object
    var options = optionsProp.map(function(option) {
        return typeof option === 'string' ? {
            disabled: disabledProp,
            value: option,
            label: option
        } : option;
    });
    // 'value' is an array of checked valueKeys
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: defaultValue || []
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    // Logic is necessary to maintain a proper data structure for Form logic
    var onCheckBoxChange = function onCheckBoxChange(event, optionValue, option) {
        // deep copy of value
        var nextValue = JSON.parse(JSON.stringify(value)) || [];
        var optionIndex = nextValue.indexOf(optionValue);
        // If the value option isn't in the array, add it.
        // Otherwise, remove it.
        if (optionIndex < 0) nextValue.push(optionValue);
        else nextValue.splice(optionIndex, 1);
        setValue(nextValue);
        // Similar functionality to Select onChange()
        if (onChange) {
            event.persist(); // extract from React synthetic event pool
            var adjustedEvent = event;
            adjustedEvent.value = nextValue;
            adjustedEvent.option = option;
            onChange(adjustedEvent);
        }
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledCheckBoxGroup.StyledCheckBoxGroup), _extends({
        ref: ref,
        role: "group"
    }, theme.checkBoxGroup.container, {
        gap: gap || (theme.checkBoxGroup.container && theme.checkBoxGroup.container.gap ? theme.checkBoxGroup.container.gap : 'small' // consistent with RadioButtonGroup default
        )
    }, passThemeFlag, rest), options.map(function(option, index) {
        var optionValue = option.value;
        var label = labelKey ? option[labelKey] : option.label;
        var valueOption = valueKey ? option[valueKey] : optionValue;
        var checked = value.indexOf(valueOption) >= 0;
        var disabled = disabledProp || option.disabled;
        var key = label + "-" + valueOption;
        if (option.checked) console.warn("'checked' prop of an individual CheckBox shouldn't be used in a CheckBoxGroup component. Use the CheckBoxGroup 'value' prop instead.");
        // value shouldn't propagate the input field and the onChange option
        var omit = option.value, optionRest = _objectWithoutPropertiesLoose(option, _excluded2);
        var optionProps = _extends({}, optionRest, {
            label: label,
            disabled: disabled
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _checkBox.CheckBox), _extends({
            key: key
        }, optionProps, {
            disabled: disabled,
            checked: checked,
            focusIndicator: focusIndicator,
            label: label,
            onChange: function onChange(event) {
                return onCheckBoxChange(event, valueOption, optionProps);
            }
        }), children ? function(state) {
            return children(options[index], state);
        } : null);
    }));
});
CheckBoxGroup.displayName = 'CheckBoxGroup';
CheckBoxGroup.propTypes = (0, _propTypes.CheckBoxGroupPropTypes);

},{"react":"8CCva","../CheckBox":"gaRRO","../Form/FormContext":"ky7Rv","./StyledCheckBoxGroup":"mNKh1","./propTypes":"cVpc2","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"mNKh1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledCheckBoxGroup", ()=>StyledCheckBoxGroup);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _box = require("../Box");
var StyledCheckBoxGroup = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "StyledCheckBoxGroup",
    componentId: "sc-2nhc5d-0"
})([
    "",
    ""
], function(props) {
    return props.theme.checkBoxGroup && props.theme.checkBoxGroup.container && props.theme.checkBoxGroup.container.extend;
});

},{"styled-components":"6bGrk","../Box":"4o01A","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cVpc2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckBoxGroupPropTypes", ()=>CheckBoxGroupPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PropType = {};
var CheckBoxGroupPropTypes = PropType;

},{"prop-types":"j03Ye","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kbiv9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioButtonGroup", ()=>(0, _radioButtonGroup.RadioButtonGroup));
var _radioButtonGroup = require("./RadioButtonGroup");

},{"./RadioButtonGroup":"8gXWw","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8gXWw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioButtonGroup", ()=>RadioButtonGroup);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _formContext = require("../Form/FormContext");
var _keyboard = require("../Keyboard");
var _box = require("../Box");
var _radioButton = require("../RadioButton");
var _propTypes = require("./propTypes");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "children",
    "defaultValue",
    "disabled",
    "focusIndicator",
    "name",
    "onChange",
    "options",
    "value",
    "gap"
], _excluded2 = [
    "disabled",
    "id",
    "label",
    "value"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var RadioButtonGroup = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var children = _ref.children, defaultValue = _ref.defaultValue, disabled = _ref.disabled, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, name = _ref.name, onChange = _ref.onChange, optionsProp = _ref.options, valueProp = _ref.value, gap = _ref.gap, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var formContext = (0, _react.useContext)((0, _formContext.FormContext));
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme;
    // normalize options to always use an object
    var options = optionsProp.map(function(o) {
        return typeof o !== 'object' ? {
            disabled: disabled,
            id: rest.id ? rest.id + "-" + o : "" + o,
            // force string
            label: typeof o !== 'string' ? JSON.stringify(o) : o,
            value: o
        } : _extends({
            disabled: disabled
        }, o);
    });
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: defaultValue != null ? defaultValue : ''
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    // track if focus is on one of the radio buttons
    var _useState = (0, _react.useState)(), focus = _useState[0], setFocus = _useState[1];
    var optionRefs = (0, _react.useRef)([]);
    var valueIndex = (0, _reactDefault.default).useMemo(function() {
        var result;
        options.some(function(option, index) {
            if (option.value === value) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }, [
        options,
        value
    ]);
    var onNext = function onNext() {
        if (valueIndex !== undefined && valueIndex < options.length - 1) {
            var nextIndex = valueIndex + 1;
            // ensure change event occurs
            optionRefs.current[nextIndex].click();
        }
    };
    var onPrevious = function onPrevious() {
        if (valueIndex > 0) {
            var nextIndex = valueIndex - 1;
            // ensure change event occurs
            optionRefs.current[nextIndex].click();
        }
    };
    var onFocus = function onFocus() {
        // Delay just a wee bit so Chrome doesn't missing turning the button on.
        // Chrome behaves differently in that focus is given to radio buttons
        // when the user selects one, unlike Safari and Firefox.
        setTimeout(function() {
            setFocus(true);
        }, 1);
    };
    var onRadioButtonChange = function onRadioButtonChange(event, optionValue) {
        setValue(optionValue);
        if (onChange) {
            event.persist(); // extract from React synthetic event pool
            // event.target.value gives value as a string which needs to be
            // manually typecasted according to the type of original option value.
            // return the original option value attached with the event.
            var adjustedEvent = event;
            adjustedEvent.value = optionValue;
            onChange(adjustedEvent);
        }
    };
    var onBlur = function onBlur() {
        return setFocus(false);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keyboard.Keyboard), {
        target: "document",
        onUp: focus ? onPrevious : undefined,
        onDown: focus ? onNext : undefined,
        onLeft: focus ? onPrevious : undefined,
        onRight: focus ? onNext : undefined
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), _extends({
        ref: ref,
        role: "radiogroup"
    }, theme.radioButtonGroup.container, {
        gap: gap || (theme.radioButtonGroup.container && theme.radioButtonGroup.container.gap ? theme.radioButtonGroup.container.gap : 'small')
    }, rest), options.map(function(_ref2, index) {
        var optionDisabled = _ref2.disabled, id = _ref2.id, label = _ref2.label, optionValue = _ref2.value, optionRest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
        // if focus is within the RadioButtonGroup, determine
        // which radio button should be the active one
        var focusable = optionValue === value || value === undefined && !index || // when nothing has been selected, show focus
        // on the first radiobutton
        value === '' && index === 0;
        if (optionRest.checked) console.warn("'checked' prop of an individual RadioButton shouldn't be used in a RadioButtonGroup component. Use the RadioButtonGroup 'value' prop instead.");
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _radioButton.RadioButton), _extends({
            ref: function ref(aRef) {
                optionRefs.current[index] = aRef;
            },
            key: optionValue,
            name: name,
            label: !children ? label : undefined,
            disabled: optionDisabled,
            checked: optionValue === value,
            focus: focus && focusable,
            focusIndicator: focusIndicator,
            id: id,
            value: optionValue,
            onFocus: onFocus,
            onBlur: onBlur,
            onChange: function onChange(event) {
                return onRadioButtonChange(event, optionValue);
            },
            tabIndex: focusable ? '0' : '-1' // necessary for Firefox
        }, optionRest), children ? function(state) {
            return children(optionsProp[index], state);
        } : null);
    })));
});
RadioButtonGroup.displayName = 'RadioButtonGroup';
RadioButtonGroup.propTypes = (0, _propTypes.RadioButtonGroupPropTypes);

},{"react":"8CCva","../Form/FormContext":"ky7Rv","../Keyboard":"7WukC","../Box":"4o01A","../RadioButton":"98sBg","./propTypes":"l7Qid","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"98sBg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioButton", ()=>(0, _radioButton.RadioButton));
var _radioButton = require("./RadioButton");

},{"./RadioButton":"5lGG4","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5lGG4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioButton", ()=>RadioButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("../../utils");
var _styledRadioButton = require("./StyledRadioButton");
var _propTypes = require("./propTypes");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "a11yTitle",
    "checked",
    "children",
    "disabled",
    "focus",
    "focusIndicator",
    "id",
    "label",
    "name",
    "onChange"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var RadioButton = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var _theme$radioButton$ba;
    var a11yTitle = _ref.a11yTitle, checked = _ref.checked, children = _ref.children, disabled = _ref.disabled, focusProp = _ref.focus, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, id = _ref.id, label = _ref.label, name = _ref.name, onChange = _ref.onChange, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme, passThemeFlag = _useThemeValue1.passThemeFlag;
    var _useState = (0, _react.useState)(), hover = _useState[0], setHover = _useState[1];
    var _useState2 = (0, _react.useState)(focusProp), focus = _useState2[0], setFocus = _useState2[1];
    var usingKeyboard = (0, _utils.useKeyboard)();
    var normalizedLabel = typeof label === 'string' ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledRadioButton.StyledRadioButtonLabel), passThemeFlag, label) : label;
    var Icon = theme.radioButton.icons.circle;
    var borderColor = (0, _utils.normalizeColor)(theme.radioButton.border.color, theme);
    var backgroundColor = (0, _utils.normalizeColor)((_theme$radioButton$ba = theme.radioButton.background) == null ? void 0 : _theme$radioButton$ba.color, theme);
    if (checked) {
        var _theme$radioButton$ch;
        borderColor = (0, _utils.normalizeColor)(theme.radioButton.color || 'control', theme);
        if ((_theme$radioButton$ch = theme.radioButton.check) != null && (_theme$radioButton$ch = _theme$radioButton$ch.background) != null && _theme$radioButton$ch.color) backgroundColor = (0, _utils.normalizeColor)(theme.radioButton.check.background.color, theme);
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledRadioButton.StyledRadioButtonContainer), _extends({}, (0, _utils.removeUndefined)({
        htmlFor: id,
        disabled: disabled
    }), {
        onClick: function onClick(event) {
            // prevents clicking on the label trigging the event twice
            // https://stackoverflow.com/questions/24501497/why-the-onclick-element-will-trigger-twice-for-label-element
            if (event.target.type !== 'radio') event.stopPropagation();
        },
        focus: focus,
        focusIndicator: focusIndicator,
        onFocus: function onFocus() {
            return setFocus(true);
        },
        onBlur: function onBlur() {
            return setFocus(false);
        },
        onMouseEnter: function onMouseEnter() {
            return setHover(true);
        },
        onMouseLeave: function onMouseLeave() {
            return setHover(false);
        }
    }, passThemeFlag), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledRadioButton.StyledRadioButton), _extends({
        flex: false,
        margin: label ? {
            right: theme.radioButton.gap || 'small'
        } : undefined
    }, passThemeFlag), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledRadioButton.StyledRadioButtonInput), _extends({
        "aria-label": a11yTitle
    }, rest, {
        ref: ref,
        type: "radio"
    }, (0, _utils.removeUndefined)({
        id: id,
        name: name,
        checked: checked,
        disabled: disabled,
        onChange: onChange
    }))), children ? children({
        checked: checked,
        focus: focus && focusIndicator,
        hover: hover
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledRadioButton.StyledRadioButtonBox), _extends({
        focus: focus && focusIndicator && usingKeyboard,
        align: "center",
        justify: "center",
        width: theme.radioButton.size,
        height: theme.radioButton.size,
        border: {
            size: theme.radioButton.border.width,
            color: borderColor
        },
        backgroundColor: backgroundColor,
        round: theme.radioButton.check.radius
    }, passThemeFlag), checked && (Icon ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
        theme: theme,
        as: (0, _styledRadioButton.StyledRadioButtonIcon)
    }) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledRadioButton.StyledRadioButtonIcon), _extends({
        viewBox: "0 0 24 24",
        preserveAspectRatio: "xMidYMid meet"
    }, passThemeFlag), /*#__PURE__*/ (0, _reactDefault.default).createElement("circle", {
        cx: 12,
        cy: 12,
        r: 6
    }))))), normalizedLabel);
});
RadioButton.displayName = 'RadioButton';
RadioButton.propTypes = (0, _propTypes.RadioButtonPropTypes);

},{"react":"8CCva","../../utils":"fx31z","./StyledRadioButton":"9vNbm","./propTypes":"aWkG9","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9vNbm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledRadioButtonContainer", ()=>StyledRadioButtonContainer);
parcelHelpers.export(exports, "StyledRadioButtonInput", ()=>StyledRadioButtonInput);
parcelHelpers.export(exports, "StyledRadioButtonLabel", ()=>StyledRadioButtonLabel);
parcelHelpers.export(exports, "StyledRadioButtonIcon", ()=>StyledRadioButtonIcon);
parcelHelpers.export(exports, "StyledRadioButtonBox", ()=>StyledRadioButtonBox);
parcelHelpers.export(exports, "StyledRadioButton", ()=>StyledRadioButton);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var _box = require("../Box");
var disabledStyle = "\n  opacity: 0.5;\n  cursor: default;\n";
var StyledRadioButtonContainer = (0, _styledComponentsDefault.default).label.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonContainer",
    componentId: "sc-g1f6ld-0"
})([
    "display:flex;flex-direction:row;align-items:center;user-select:none;width:fit-content;",
    " ",
    " &:hover input:not([disabled]) + div,&:hover input:not([disabled]) + span{border-color:",
    ";}&:hover{background-color:",
    ";}",
    " ",
    ";"
], function(props) {
    return props.disabled && disabledStyle;
}, function(props) {
    return !props.disabled && 'cursor: pointer;';
}, function(props) {
    return (0, _utils.normalizeColor)(props.theme.radioButton.hover.border.color, props.theme);
}, function(props) {
    return (0, _utils.normalizeColor)(!props.disabled && props.theme.radioButton.hover && props.theme.radioButton.hover.background && props.theme.radioButton.hover.background.color, props.theme);
}, function(props) {
    return props.focus && !props.focusIndicator && "\n      input:not([disabled]) + div,\n      input:not([disabled]) + span {\n      border-color: " + (0, _utils.normalizeColor)(props.theme.radioButton.hover.border.color, props.theme) + ";\n    }\n    background-color: " + (0, _utils.normalizeColor)(!props.disabled && props.theme.radioButton.hover && props.theme.radioButton.hover.background && props.theme.radioButton.hover.background.color, props.theme) + ";\n    ";
}, function(props) {
    return props.theme.radioButton.container.extend;
});
var StyledRadioButtonInput = (0, _styledComponentsDefault.default).input.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonInput",
    componentId: "sc-g1f6ld-1"
})([
    "opacity:0;-moz-appearance:none;width:0;height:0;margin:0;",
    ";"
], function(props) {
    return !props.disabled && 'cursor: pointer;';
});
var StyledRadioButtonLabel = (0, _styledComponentsDefault.default).span.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonLabel",
    componentId: "sc-g1f6ld-2"
})([
    "",
    ""
], function(props) {
    return props.theme.radioButton.font.weight && (0, _styledComponents.css)([
        "font-weight:",
        ";"
    ], props.theme.radioButton.font.weight);
});
var StyledRadioButtonIcon = (0, _styledComponentsDefault.default).svg.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonIcon",
    componentId: "sc-g1f6ld-3"
})([
    "box-sizing:border-box;width:",
    ";height:",
    ";fill:",
    ";",
    ";"
], function(props) {
    return props.theme.radioButton.icon.size || props.theme.radioButton.size;
}, function(props) {
    return props.theme.radioButton.icon.size || props.theme.radioButton.size;
}, function(props) {
    return (0, _utils.normalizeColor)(props.theme.radioButton.check.color || 'control', props.theme);
}, function(props) {
    return props.theme.radioButton.icon.extend;
});
var StyledRadioButtonBox = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "StyledRadioButton__StyledRadioButtonBox",
    componentId: "sc-g1f6ld-4"
})([
    "background-color:",
    ";",
    ";",
    ";"
], function(props) {
    return props.backgroundColor;
}, function(props) {
    return props.focus && (0, _utils.focusStyle)();
}, function(props) {
    return props.theme.radioButton.check.extend;
});
var StyledRadioButton = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "StyledRadioButton",
    componentId: "sc-g1f6ld-5"
})([
    "",
    ";"
], function(props) {
    return props.theme.radioButton && props.theme.radioButton.extend;
});

},{"styled-components":"6bGrk","../../utils":"fx31z","../Box":"4o01A","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aWkG9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioButtonPropTypes", ()=>RadioButtonPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PropType = {};
var RadioButtonPropTypes = PropType;

},{"prop-types":"j03Ye","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"l7Qid":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioButtonGroupPropTypes", ()=>RadioButtonGroupPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PropType = {};
var RadioButtonGroupPropTypes = PropType;

},{"prop-types":"j03Ye","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cL4wi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextInput", ()=>(0, _textInput.TextInput));
var _textInput = require("./TextInput");

},{"./TextInput":"64DXZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"64DXZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextInput", ()=>TextInput);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _box = require("../Box");
var _button = require("../Button");
var _drop = require("../Drop");
var _infiniteScroll = require("../InfiniteScroll");
var _keyboard = require("../Keyboard");
var _formContext = require("../Form/FormContext");
var _contexts = require("../../contexts");
var _utils = require("../../utils");
var _styledTextInput = require("./StyledTextInput");
var _messageContext = require("../../contexts/MessageContext");
var _propTypes = require("./propTypes");
var _copyButton = require("./CopyButton");
var _useThemeValue = require("../../utils/useThemeValue");
var global = arguments[3];
var _excluded = [
    "a11yTitle",
    "defaultSuggestion",
    "defaultValue",
    "dropAlign",
    "dropHeight",
    "dropTarget",
    "dropProps",
    "focusIndicator",
    "icon",
    "id",
    "messages",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "onKeyDown",
    "onSelect",
    "onSuggestionSelect",
    "onSuggestionsClose",
    "onSuggestionsOpen",
    "placeholder",
    "plain",
    "readOnly",
    "readOnlyCopy",
    "reverse",
    "suggestions",
    "textAlign",
    "value",
    "width"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var renderLabel = function renderLabel(suggestion) {
    if (suggestion && typeof suggestion === 'object') return suggestion.label || suggestion.value;
    return suggestion;
};
var stringLabel = function stringLabel(suggestion) {
    if (suggestion && typeof suggestion === 'object') {
        if (suggestion.label && typeof suggestion.label === 'string') return suggestion.label;
        return suggestion.value;
    }
    return suggestion;
};
var ContainerBox = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "TextInput__ContainerBox",
    componentId: "sc-1ai0c08-0"
})([
    "",
    ";@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:100%;}"
], function(props) {
    return props.dropHeight ? (0, _utils.sizeStyle)('max-height', props.dropHeight, props.theme) : 'max-height: inherit;';
});
var defaultDropAlign = {
    top: 'bottom',
    left: 'left'
};
var TextInput = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var _inputRef$current, _inputRef$current2;
    var a11yTitle = _ref.a11yTitle, defaultSuggestion = _ref.defaultSuggestion, defaultValue = _ref.defaultValue, _ref$dropAlign = _ref.dropAlign, dropAlign = _ref$dropAlign === void 0 ? defaultDropAlign : _ref$dropAlign, dropHeight = _ref.dropHeight, dropTarget = _ref.dropTarget, dropProps = _ref.dropProps, _ref$focusIndicator = _ref.focusIndicator, focusIndicator = _ref$focusIndicator === void 0 ? true : _ref$focusIndicator, icon = _ref.icon, id = _ref.id, messages = _ref.messages, name = _ref.name, _onBlur = _ref.onBlur, onChange = _ref.onChange, _onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, onSelect = _ref.onSelect, onSuggestionSelect = _ref.onSuggestionSelect, onSuggestionsClose = _ref.onSuggestionsClose, onSuggestionsOpen = _ref.onSuggestionsOpen, placeholder = _ref.placeholder, plain = _ref.plain, readOnlyProp = _ref.readOnly, readOnlyCopy = _ref.readOnlyCopy, reverse = _ref.reverse, suggestions = _ref.suggestions, textAlign = _ref.textAlign, valueProp = _ref.value, widthProp = _ref.width, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme, passThemeFlag = _useThemeValue1.passThemeFlag;
    var _useContext = (0, _react.useContext)((0, _messageContext.MessageContext)), format = _useContext.format;
    var announce = (0, _react.useContext)((0, _contexts.AnnounceContext));
    var formContext = (0, _react.useContext)((0, _formContext.FormContext));
    var inputRef = (0, _utils.useForwardedRef)(ref);
    var dropRef = (0, _react.useRef)();
    var suggestionsRef = (0, _react.useRef)();
    var readOnly = readOnlyProp || readOnlyCopy;
    // if this is a readOnly property, don't set a name with the form context
    // this allows Select to control the form context for the name.
    var _formContext$useFormI = formContext.useFormInput({
        name: readOnly ? undefined : name,
        value: valueProp
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    var _useState = (0, _react.useState)(), focus = _useState[0], setFocus = _useState[1];
    var _useState2 = (0, _react.useState)(false), showDrop = _useState2[0], setShowDrop = _useState2[1];
    var handleSuggestionSelect = (0, _react.useMemo)(function() {
        return onSelect && !onSuggestionSelect ? onSelect : onSuggestionSelect;
    }, [
        onSelect,
        onSuggestionSelect
    ]);
    var handleTextSelect = (0, _react.useMemo)(function() {
        return onSelect && onSuggestionSelect ? onSelect : undefined;
    }, [
        onSelect,
        onSuggestionSelect
    ]);
    var _useState3 = (0, _react.useState)(), suggestionsAtClose = _useState3[0], setSuggestionsAtClose = _useState3[1];
    var readOnlyCopyValidation = format({
        id: 'input.readOnlyCopy.validation',
        messages: messages
    });
    var readOnlyCopyPrompt = format({
        id: 'input.readOnlyCopy.prompt',
        messages: messages
    });
    var _useState4 = (0, _react.useState)(readOnlyCopyPrompt), tip = _useState4[0], setTip = _useState4[1];
    var onClickCopy = function onClickCopy() {
        global.navigator.clipboard.writeText(value);
        announce(readOnlyCopyValidation, 'assertive');
        setTip(readOnlyCopyValidation);
    };
    var onBlurCopy = function onBlurCopy() {
        if (tip === readOnlyCopyValidation) setTip(readOnlyCopyPrompt);
    };
    var openDrop = (0, _react.useCallback)(function() {
        setShowDrop(true);
        announce(format({
            id: 'textInput.suggestionIsOpen',
            messages: messages
        }));
        announce(suggestions.length + " " + format({
            id: 'textInput.suggestionsCount',
            messages: messages
        }));
        if (onSuggestionsOpen) onSuggestionsOpen();
    }, [
        announce,
        messages,
        format,
        onSuggestionsOpen,
        suggestions
    ]);
    var closeDrop = (0, _react.useCallback)(function() {
        setSuggestionsAtClose(suggestions); // must be before closing drop
        setShowDrop(false);
        if (onSuggestionsClose) onSuggestionsClose();
    }, [
        onSuggestionsClose,
        suggestions
    ]);
    var clickOutside = (0, _react.useCallback)(function(event) {
        if (event.target !== inputRef.current) closeDrop();
    }, [
        inputRef,
        closeDrop
    ]);
    // Handle scenarios where we have focus, the drop isn't showing,
    // and the suggestions change. We don't want to open the drop if
    // the drop has been closed by onEsc and the suggestions haven't
    // changed. So, we remember the suggestions we are showing when
    // the drop was closed and only re-open it when the suggestions
    // subsequently change.
    (0, _react.useEffect)(function() {
        if (focus && !showDrop && suggestions && suggestions.length && (!suggestionsAtClose || suggestionsAtClose.length !== suggestions.length)) openDrop();
    }, [
        focus,
        openDrop,
        showDrop,
        suggestions,
        suggestionsAtClose
    ]);
    // if we have no suggestions, close drop if it's open
    (0, _react.useEffect)(function() {
        if (showDrop && (!suggestions || !suggestions.length)) closeDrop();
    }, [
        closeDrop,
        showDrop,
        suggestions
    ]);
    var valueSuggestionIndex = (0, _react.useMemo)(function() {
        return suggestions ? suggestions.map(function(suggestion) {
            return typeof suggestion === 'object' ? suggestion.value : suggestion;
        }).indexOf(value) : -1;
    }, [
        suggestions,
        value
    ]);
    // choose the best suggestion, either the explicit default or the one
    // that matches the current value
    var resetSuggestionIndex = (0, _react.useMemo)(function() {
        if (valueSuggestionIndex === -1 && typeof defaultSuggestion === 'number') return defaultSuggestion;
        return valueSuggestionIndex;
    }, [
        defaultSuggestion,
        valueSuggestionIndex
    ]);
    // activeSuggestionIndex unifies mouse and keyboard interaction of
    // the suggestions
    var _useState5 = (0, _react.useState)(resetSuggestionIndex), activeSuggestionIndex = _useState5[0], setActiveSuggestionIndex = _useState5[1];
    // Only update active suggestion index when the mouse actually moves,
    // not when suggestions are moving under the mouse.
    var _useState6 = (0, _react.useState)(), mouseMovedSinceLastKey = _useState6[0], setMouseMovedSinceLastKey = _useState6[1];
    // set activeSuggestionIndex when value changes
    (0, _react.useEffect)(function() {
        return setActiveSuggestionIndex(valueSuggestionIndex);
    }, [
        valueSuggestionIndex
    ]);
    // reset activeSuggestionIndex when the drop is closed
    (0, _react.useEffect)(function() {
        if (!showDrop) setActiveSuggestionIndex(resetSuggestionIndex);
    }, [
        resetSuggestionIndex,
        showDrop
    ]);
    // announce active suggestion
    (0, _react.useEffect)(function() {
        if (activeSuggestionIndex >= 0) {
            var label = stringLabel(suggestions[activeSuggestionIndex]);
            announce(label + " " + format({
                id: 'textInput.enterSelect',
                messages: messages
            }));
        }
    }, [
        activeSuggestionIndex,
        announce,
        messages,
        format,
        suggestions
    ]);
    // make sure activeSuggestion is visible in scroll
    (0, _react.useEffect)(function() {
        var timer = setTimeout(function() {
            var list = suggestionsRef.current;
            if (showDrop && activeSuggestionIndex !== -1 && list) {
                var container = list.parentNode;
                var item = list.children[activeSuggestionIndex];
                if (container.scrollTo) {
                    if ((0, _utils.isNodeAfterScroll)(item, container)) container.scrollTo(0, item.offsetTop - (container.getBoundingClientRect().height - item.getBoundingClientRect().height));
                    else if ((0, _utils.isNodeBeforeScroll)(item, container)) container.scrollTo(0, item.offsetTop);
                }
            }
        }, 50); // delay to allow Drop to animate in
        return function() {
            return clearTimeout(timer);
        };
    }, [
        activeSuggestionIndex,
        showDrop
    ]);
    (0, _react.useEffect)(function() {
        if (readOnly && inputRef != null && inputRef.current && inputRef.current.scrollLeft > 0) inputRef.current.scrollLeft = 0;
    }, [
        readOnly,
        inputRef,
        inputRef == null || (_inputRef$current = inputRef.current) == null ? void 0 : _inputRef$current.scrollLeft
    ]);
    var setValueFromSuggestion = function setValueFromSuggestion(event, suggestion) {
        // if we stole the focus in the drop, perhaps by interacting with
        // a suggestion button or the scrollbar, give it back
        inputRef.current.focus();
        inputRef.current.value = suggestion; // needed for uncontrolled cases
        closeDrop();
        if (handleSuggestionSelect) {
            if (event.persist) event.persist();
            var adjustedEvent = event;
            adjustedEvent.suggestion = suggestion;
            handleSuggestionSelect(adjustedEvent);
        }
        setValue(suggestion);
    };
    var onNextSuggestion = (0, _react.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = Math.min(activeSuggestionIndex + 1, suggestions.length - 1);
        setActiveSuggestionIndex(nextActiveIndex);
        setMouseMovedSinceLastKey(false);
    }, [
        activeSuggestionIndex,
        suggestions
    ]);
    var onPreviousSuggestion = (0, _react.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = Math.max(activeSuggestionIndex - 1, 0);
        setActiveSuggestionIndex(nextActiveIndex);
        setMouseMovedSinceLastKey(false);
    }, [
        activeSuggestionIndex
    ]);
    // account for input value in both controlled and uncontrolled scenarios
    var hasValue = value || ((_inputRef$current2 = inputRef.current) == null ? void 0 : _inputRef$current2.value);
    var showStyledPlaceholder = (0, _react.useMemo)(function() {
        return placeholder && typeof placeholder !== 'string' && !hasValue;
    }, [
        hasValue,
        placeholder
    ]);
    var drop;
    var extraProps = {
        onSelect: handleTextSelect
    };
    if (showDrop) drop = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _drop.Drop), _extends({
        ref: dropRef,
        id: id ? "text-input-drop__" + id : undefined,
        align: dropAlign,
        responsive: false,
        target: dropTarget || inputRef.current,
        onClickOutside: clickOutside,
        onEsc: closeDrop,
        trapFocus: false
    }, dropProps), /*#__PURE__*/ (0, _reactDefault.default).createElement(ContainerBox, _extends({
        id: id ? "listbox__" + id : undefined,
        role: "listbox",
        overflow: "auto",
        dropHeight: dropHeight,
        onMouseMove: function onMouseMove() {
            return setMouseMovedSinceLastKey(true);
        }
    }, passThemeFlag), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledTextInput.StyledSuggestions), _extends({
        ref: suggestionsRef
    }, passThemeFlag), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _infiniteScroll.InfiniteScroll), {
        items: suggestions,
        step: theme.select.step,
        show: activeSuggestionIndex !== -1 ? activeSuggestionIndex : undefined
    }, function(suggestion, index, itemRef) {
        var active = activeSuggestionIndex === index;
        var selected = suggestion === value;
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var renderedLabel = renderLabel(suggestion);
        var child;
        if (typeof renderedLabel !== 'string') // must be an element rendered by suggestions.label
        child = renderedLabel;
        else if (!theme.button.option) // don't have theme support, need to layout here
        child = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
            align: "start",
            pad: "small"
        }, renderedLabel);
        // if we have a child, turn on plain
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("li", {
            key: stringLabel(suggestion) + "-" + index,
            ref: itemRef
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
            id: id ? "listbox-option-" + index + "__" + id : undefined,
            role: "option",
            "aria-selected": selected ? 'true' : 'false',
            active: active,
            fill: "horizontal",
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            label: !child ? renderedLabel : undefined,
            onClick: function onClick(event) {
                return setValueFromSuggestion(event, suggestion);
            },
            onMouseMove: mouseMovedSinceLastKey && activeSuggestionIndex !== index ? function() {
                return setActiveSuggestionIndex(index);
            } : undefined,
            keyboard: !mouseMovedSinceLastKey
        }, child));
    }))));
    var keyboardProps = {
        onKeyDown: onKeyDown
    };
    if (showDrop) {
        keyboardProps.onEnter = function(event) {
            // prevent submitting forms via Enter when the drop is open
            event.preventDefault();
            if (activeSuggestionIndex >= 0) setValueFromSuggestion(event, suggestions[activeSuggestionIndex]);
            else closeDrop();
        };
        if (activeSuggestionIndex > 0) keyboardProps.onUp = onPreviousSuggestion;
        if (activeSuggestionIndex < suggestions.length - 1) keyboardProps.onDown = onNextSuggestion;
        keyboardProps.onTab = closeDrop;
    } else if (suggestions && suggestions.length > 0) keyboardProps.onDown = openDrop;
    /*
  If the text input has a list of suggestions, add the WAI-ARIA 1.2
  combobox role and states.
  */ var comboboxProps = {};
    var activeOptionID;
    if (id && (suggestions == null ? void 0 : suggestions.length) > -1) {
        if (showDrop && activeSuggestionIndex > -1) activeOptionID = "listbox-option-" + activeSuggestionIndex + "__" + id;
        comboboxProps = {
            'aria-activedescendant': activeOptionID,
            'aria-autocomplete': 'list',
            'aria-expanded': showDrop ? 'true' : 'false',
            'aria-controls': showDrop ? "listbox__" + id : undefined,
            role: 'combobox'
        };
    }
    // For the Keyboard target below, if we have focus,
    // either on the input element or within the drop,
    // then we set the target to the document,
    // otherwise we only listen to onDown on the input element itself,
    // primarily for tests.
    var textInputIcon = (0, _utils.useSizedIcon)(icon, rest.size, theme);
    var ReadOnlyCopyButton = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copyButton.CopyButton), {
        onBlurCopy: onBlurCopy,
        onClickCopy: onClickCopy,
        readOnlyCopyPrompt: readOnlyCopyPrompt,
        tip: tip,
        value: value
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledTextInput.StyledTextInputContainer), _extends({
        readOnlyProp: readOnly // readOnlyProp to avoid passing to DOM
        ,
        readOnlyCopy: readOnlyCopy,
        plain: plain,
        border: !plain,
        onMouseMove: function onMouseMove() {
            return setMouseMovedSinceLastKey(true);
        }
    }, passThemeFlag), reverse && readOnlyCopy && ReadOnlyCopyButton, showStyledPlaceholder && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledTextInput.StyledPlaceholder), passThemeFlag, placeholder), textInputIcon && !readOnly && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledTextInput.StyledIcon), {
        reverse: reverse,
        theme: theme
    }, textInputIcon), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keyboard.Keyboard), _extends({
        target: focus ? 'document' : undefined
    }, keyboardProps), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledTextInput.StyledTextInput), _extends({
        "aria-label": a11yTitle,
        ref: inputRef,
        id: id,
        name: name,
        autoComplete: "off",
        plain: plain,
        placeholder: typeof placeholder === 'string' ? placeholder : undefined,
        icon: !readOnly && icon,
        reverse: reverse,
        focus: focus,
        focusIndicator: focusIndicator,
        textAlign: textAlign,
        widthProp: widthProp
    }, passThemeFlag, rest, extraProps, comboboxProps, {
        defaultValue: renderLabel(defaultValue),
        value: renderLabel(value),
        readOnly: readOnly,
        readOnlyCopy: readOnlyCopy,
        onFocus: function onFocus(event) {
            // Don't do anything if we are acting like we already have
            // focus. This can happen when this input loses focus temporarily
            // to our drop, see onBlur() handler below.
            if (!focus) {
                setFocus(true);
                if (suggestions && suggestions.length > 0) {
                    announce(format({
                        id: 'textInput.suggestionsExist',
                        messages: messages
                    }));
                    openDrop();
                }
                if (_onFocus) _onFocus(event);
            }
        },
        onBlur: function onBlur(event) {
            // Only treat it as a blur if the element receiving focus
            // isn't in our drop. The relatedTarget will be our drop
            // when the user clicks on a suggestion or interacts with the
            // scrollbar in the drop.
            if (!event.relatedTarget || event.relatedTarget !== dropRef.current) {
                setFocus(false);
                if (_onBlur) _onBlur(event);
            }
        },
        onChange: readOnly ? undefined : function(event) {
            // when TextInput is not contained in a Form, no re-render
            // will come from this onChange and remove the placeholder
            // so we need to update state to ensure the styled
            // placeholder only appears when there is no value
            if (suggestions && focus && !showDrop) openDrop();
            setValue(event.target.value);
            setActiveSuggestionIndex(resetSuggestionIndex);
            if (onChange) onChange(event);
        }
    }))), !reverse && readOnlyCopy && ReadOnlyCopyButton, !readOnly && drop);
});
TextInput.displayName = 'TextInput';
TextInput.propTypes = (0, _propTypes.TextInputPropTypes);

},{"react":"8CCva","styled-components":"6bGrk","../Box":"4o01A","../Button":"fVON6","../Drop":"hXFtw","../InfiniteScroll":"9S1JB","../Keyboard":"7WukC","../Form/FormContext":"ky7Rv","../../contexts":"8InEz","../../utils":"fx31z","./StyledTextInput":"3mxa1","../../contexts/MessageContext":"9V5sq","./propTypes":"9Nxat","./CopyButton":"9eJAz","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9S1JB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InfiniteScroll", ()=>(0, _infiniteScroll.InfiniteScroll));
var _infiniteScroll = require("./InfiniteScroll");

},{"./InfiniteScroll":"bjltO","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bjltO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InfiniteScroll", ()=>InfiniteScroll);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useIsomorphicLayoutEffect = require("../../utils/use-isomorphic-layout-effect");
var _utils = require("../../utils");
var _box = require("../Box");
var _propTypes = require("./propTypes");
function _readOnlyError(r) {
    throw new TypeError('"' + r + '" is read-only');
}
var calculateLastPageBound = function calculateLastPageBound(show, step) {
    return show ? Math.floor((show + step) / step) - 1 : 0;
};
var InfiniteScroll = function InfiniteScroll(_ref) {
    var children = _ref.children, _ref$items = _ref.items, items = _ref$items === void 0 ? [] : _ref$items, onMore = _ref.onMore, renderMarker = _ref.renderMarker, replace = _ref.replace, show = _ref.show, _ref$step = _ref.step, step = _ref$step === void 0 ? 50 : _ref$step;
    // item index to be made visible initially
    var _useState = (0, _react.useState)(), scrollShow = _useState[0], setScrollShow = _useState[1];
    // the last page we have items for
    var lastPage = (0, _react.useMemo)(function() {
        return Math.max(0, Math.ceil(items.length / step) - 1);
    }, [
        items.length,
        step
    ]);
    // the pages we are rendering
    var _useState2 = (0, _react.useState)([
        0,
        calculateLastPageBound(show, step)
    ]), renderPageBounds = _useState2[0], setRenderPageBounds = _useState2[1];
    // the heights of the pages, approximated after we render the first page
    // and then updated for pages that have rendered
    var _useState3 = (0, _react.useState)([]), pageHeights = _useState3[0], setPageHeights = _useState3[1];
    // what we're waiting for onMore to give us
    var _useState4 = (0, _react.useState)(0), pendingLength = _useState4[0], setPendingLength = _useState4[1];
    var aboveMarkerRef = (0, _react.useRef)(); // only when replacing
    var belowMarkerRef = (0, _react.useRef)();
    // scroll and resize handling
    (0, _react.useEffect)(function() {
        var scrollParents;
        var evaluate = function evaluate() {
            if (!scrollParents) return;
            var scrollParent = scrollParents[0];
            // Determine the scroll position of the scroll container
            var top;
            var height;
            if (scrollParent === document) {
                top = document.documentElement.scrollTop || document.body.scrollTop;
                height = window.innerHeight;
            } else {
                top = scrollParent.scrollTop;
                var rect = scrollParent.getBoundingClientRect();
                height = rect.height;
            }
            var offset = height / 4; // so we pre-load when the user scrolls slowly
            // Use the pageHeights to determine what pages we should render based
            // on the current scroll window.
            var nextBeginPage = 0;
            var index = 0;
            var pagesHeight = pageHeights[index] || 0;
            while(pageHeights[index + 1] && pagesHeight < top - offset){
                index += 1;
                nextBeginPage += 1;
                pagesHeight += pageHeights[index];
            }
            var nextEndPage = nextBeginPage;
            while(pageHeights[index] !== undefined && pagesHeight < top + height + offset){
                index += 1;
                nextEndPage += 1;
                // when we haven't rendered the nextEndPage and we aren't replacing,
                // we might not have a height for it yet
                pagesHeight += pageHeights[index] || 0;
            }
            if (!replace) {
                // when not replacing, never shrink bounds
                nextBeginPage = 0;
                nextEndPage = Math.max(renderPageBounds[1], nextEndPage);
            }
            if (show) {
                // ensure we try to render any show page
                var showPage = calculateLastPageBound(show, step);
                nextBeginPage = Math.min(showPage, nextBeginPage);
                nextEndPage = Math.max(showPage, nextEndPage);
            }
            if (nextBeginPage !== renderPageBounds[0] || nextEndPage !== renderPageBounds[1]) setRenderPageBounds([
                nextBeginPage,
                nextEndPage
            ]);
        };
        var timer;
        var debounce = function debounce() {
            clearTimeout(timer);
            timer = setTimeout(evaluate, 10);
        };
        // might not be there yet or might have already rendered everything
        if (belowMarkerRef.current) {
            scrollParents = (0, _utils.findScrollParents)(belowMarkerRef.current);
            scrollParents.forEach(function(sp) {
                return sp.addEventListener('scroll', debounce);
            });
        }
        window.addEventListener('resize', debounce);
        evaluate();
        return function() {
            if (scrollParents) scrollParents.forEach(function(sp) {
                return sp.removeEventListener('scroll', debounce);
            });
            window.removeEventListener('resize', debounce);
            clearTimeout(timer);
        };
    }, [
        pageHeights,
        renderPageBounds,
        replace,
        show,
        step
    ]);
    // check if we need to ask for more
    (0, _react.useEffect)(function() {
        if (onMore && renderPageBounds[1] === lastPage && items.length >= pendingLength && items.length > 0) {
            // remember we've asked for more, so we don't keep asking if it takes
            // a while
            setPendingLength(items.length + 1);
            onMore();
        }
    }, [
        items.length,
        lastPage,
        onMore,
        pendingLength,
        renderPageBounds,
        step
    ]);
    (0, _react.useEffect)(function() {
        if (items.length === 0 && lastPage === 0 && pendingLength !== 0) {
            setPageHeights([]);
            setPendingLength(0);
            setRenderPageBounds([
                0,
                calculateLastPageBound(show, step)
            ]);
        }
    }, [
        lastPage,
        pendingLength,
        show,
        step,
        items.length
    ]);
    // scroll to any 'show'
    (0, _useIsomorphicLayoutEffect.useLayoutEffect)(function() {
        // ride out any animation delays, 100ms empirically measured
        var timer = setTimeout(function() {
            if (show && belowMarkerRef.current && show !== scrollShow) {
                // calculate show index based on beginPage
                var showIndex = show - renderPageBounds[0] * step + (renderPageBounds[0] ? 1 : 0);
                var showNode = belowMarkerRef.current.parentNode.children.item(showIndex);
                if (showNode) {
                    var scrollParent = (0, _utils.findScrollParent)(showNode);
                    if ((0, _utils.isNodeBeforeScroll)(showNode, scrollParent)) showNode.scrollIntoView(true);
                    else if ((0, _utils.isNodeAfterScroll)(showNode, scrollParent)) showNode.scrollIntoView(false);
                    // clean up after having shown
                    setScrollShow(show);
                }
            }
        }, 100);
        return function() {
            return clearTimeout(timer);
        };
    // Omitting scrollShow as a dependency due to concern that setScrollShow
    // is being called within the timer. If left included, re-renders and other
    // dependency values could change in an unpredictable manner during timer
    // and potentially result in an infinite loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        renderPageBounds,
        show,
        step
    ]);
    // calculate and keep track of page heights
    (0, _useIsomorphicLayoutEffect.useLayoutEffect)(function() {
        // if don't have a belowMarker, we must have rendered everything already
        if (!belowMarkerRef.current) return;
        // calculate page heights for rendered pages
        var rendered = belowMarkerRef.current.parentNode.children;
        // ensure we've rendered the state we have
        // above? + items in rendered pages + below === rendered DOM elements length
        if ((aboveMarkerRef.current ? 1 : 0) + (renderPageBounds[1] - renderPageBounds[0] + 1) * step + 1 === rendered.length) {
            var nextPageHeights;
            // step through each page
            var i = renderPageBounds[0];
            var lastBottom;
            while(i <= renderPageBounds[1]){
                var topIndex = (aboveMarkerRef.current ? 1 : 0) + (i - renderPageBounds[0]) * step;
                var bottomIndex = Math.min(topIndex + step - 1, rendered.length - 1);
                // we use lastBottom for top to ensure grid layouts work
                var top = lastBottom !== undefined ? lastBottom : rendered.item(topIndex).getBoundingClientRect().top;
                var _rendered$item$getBou = rendered.item(bottomIndex).getBoundingClientRect(), bottom = _rendered$item$getBou.bottom;
                var height = bottom - top;
                if (bottom && (!pageHeights || pageHeights[i] !== height)) {
                    if (!nextPageHeights) nextPageHeights = [].concat(pageHeights || []);
                    nextPageHeights[i] = height;
                }
                lastBottom = bottom;
                i += 1;
            }
            // estimate page heights for pages we haven't rendered yet
            while(replace && i <= lastPage){
                if (!pageHeights[i] && pageHeights[i] !== pageHeights[0]) {
                    if (!nextPageHeights) nextPageHeights = [].concat(pageHeights || []);
                    // set to first page height
                    var _nextPageHeights = nextPageHeights;
                    nextPageHeights[i] = _nextPageHeights[0];
                }
                i += 1;
            }
            if (nextPageHeights) setPageHeights(nextPageHeights);
        }
    }, [
        lastPage,
        pageHeights,
        renderPageBounds,
        replace,
        step
    ]);
    // calculate the height above the first rendered page using the pageHeights
    var aboveHeight = (0, _react.useMemo)(function() {
        if (!replace) return 0;
        var height = 0;
        var i = 0;
        while(i < renderPageBounds[0]){
            height += pageHeights[i] || 0;
            i += 1;
        }
        return height;
    }, [
        pageHeights,
        renderPageBounds,
        replace
    ]);
    // calculate the height below the last rendered page using the pageHeights
    var belowHeight = (0, _react.useMemo)(function() {
        if (!replace) return 0;
        var height = 0;
        var i = renderPageBounds[1] + 1;
        while(i <= lastPage){
            height += pageHeights[i] || 0;
            i += 1;
        }
        return height;
    }, [
        lastPage,
        pageHeights,
        renderPageBounds,
        replace
    ]);
    var firstIndex = renderPageBounds[0] * step;
    var lastIndex = Math.min((renderPageBounds[1] + 1) * step, items.length) - 1;
    var result = [];
    if (aboveHeight) {
        var marker = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
            key: "above",
            ref: aboveMarkerRef,
            flex: false,
            height: aboveHeight + "px"
        });
        if (renderMarker) // need to give it a key
        marker = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(renderMarker(marker), {
            key: 'above'
        });
        result.push(marker);
    }
    items.slice(firstIndex, lastIndex + 1).forEach(function(item, index) {
        var itemsIndex = firstIndex + index;
        var child = children(item, itemsIndex);
        result.push(child);
    });
    if (replace || renderPageBounds[1] < lastPage || onMore) {
        var _marker = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
            key: "below",
            ref: !renderMarker && belowMarkerRef || undefined,
            flex: false,
            height: (belowHeight || 0) + "px"
        });
        if (renderMarker) {
            // need to give it a key
            var renderedMarker = renderMarker(_marker);
            _marker = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(renderedMarker, {
                key: 'below',
                // We need to make sure our belowMarkerRef is tied to a component
                // that has the same parent as the items being rendered. This is so
                // we can use belowMarkerRef.current.parentNode.children to
                // get a reference to the items in the DOM for calculating pageHeights.
                //
                // Since the caller might have included a ref in what their
                // renderMarker returns, we have to take care of both refs.
                // https://github.com/facebook/react/issues/8873#issuecomment-489579878
                ref: function ref(node) {
                    // Keep your own reference
                    belowMarkerRef.current = node;
                    // Call the original ref, if any
                    var ref = renderedMarker.ref;
                    if (typeof ref === 'function') ref(node);
                    else if (ref !== null) ref.current = node;
                }
            });
        }
        result.push(_marker);
    }
    return result;
};
InfiniteScroll.propTypes = (0, _propTypes.InfiniteScrollPropTypes);

},{"react":"8CCva","../../utils/use-isomorphic-layout-effect":"jThNw","../../utils":"fx31z","../Box":"4o01A","./propTypes":"TxKm3","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"TxKm3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InfiniteScrollPropTypes", ()=>InfiniteScrollPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PropType = {};
var InfiniteScrollPropTypes = PropType;

},{"prop-types":"j03Ye","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3mxa1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledTextInput", ()=>StyledTextInput);
parcelHelpers.export(exports, "StyledTextInputContainer", ()=>StyledTextInputContainer);
parcelHelpers.export(exports, "StyledPlaceholder", ()=>StyledPlaceholder);
parcelHelpers.export(exports, "StyledIcon", ()=>StyledIcon);
parcelHelpers.export(exports, "StyledSuggestions", ()=>StyledSuggestions);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var _styles = require("../../utils/styles");
var _readOnly = require("../../utils/readOnly");
var getPlainStyle = function getPlainStyle(plain) {
    if (plain === 'full') return (0, _styledComponents.css)([
        "",
        " padding:0;"
    ], (0, _utils.plainInputStyle));
    return plain && (0, _utils.plainInputStyle);
};
var StyledTextInput = (0, _styledComponentsDefault.default).input.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledTextInput",
    componentId: "sc-1x30a0s-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ";"
], (0, _utils.inputStyle), function(props) {
    return props.readOnlyCopy ? "padding-" + (props.reverse ? 'left' : 'right') + ": 0px;" : '';
}, function(props) {
    return props.readOnly && "border: none;";
}, function(props) {
    return getPlainStyle(props.plain);
}, function(props) {
    return props.icon && (0, _styles.inputPadForIcon);
}, function(props) {
    return props.disabled && (0, _utils.disabledStyle)(props.theme.textInput.disabled && props.theme.textInput.disabled.opacity);
}, function(props) {
    return props.textAlign && (0, _utils.textAlignStyle);
}, function(props) {
    return props.widthProp && (0, _utils.widthStyle)(props.widthProp, props.theme);
}, function(props) {
    return props.theme.textInput && props.theme.textInput.extend;
});
var StyledTextInputContainer = (0, _styledComponentsDefault.default).div.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledTextInput__StyledTextInputContainer",
    componentId: "sc-1x30a0s-1"
})([
    "position:relative;width:100%;",
    ";",
    ";",
    " ",
    ";"
], function(props) {
    return props.readOnlyProp && !props.plain && (0, _utils.controlBorderStyle);
}, function(props) {
    return props.readOnlyCopy && "\n    box-sizing: border-box;\n    flex-direction: row;\n    display: flex;\n  ";
}, function(props) {
    return props.readOnlyProp && !props.plain && (0, _readOnly.readOnlyStyle)(props.theme);
}, function(props) {
    return props.theme.textInput && props.theme.textInput.container && props.theme.textInput.container.extend;
});
var StyledPlaceholder = (0, _styledComponentsDefault.default).div.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledTextInput__StyledPlaceholder",
    componentId: "sc-1x30a0s-2"
})([
    "position:absolute;left:",
    "px;top:50%;transform:translateY(-50%);display:flex;justify-content:center;pointer-events:none;",
    ";"
], function(props) {
    return (0, _utils.parseMetricToNum)((0, _utils.getInputPadBySide)(props, 'left')) - (0, _utils.parseMetricToNum)(props.theme.global.control.border.width);
}, function(props) {
    return props.theme.textInput && props.theme.textInput.placeholder && props.theme.textInput.placeholder.extend;
});
var StyledIcon = (0, _styledComponentsDefault.default).div.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledTextInput__StyledIcon",
    componentId: "sc-1x30a0s-3"
})([
    "position:absolute;display:flex;justify:center;top:50%;transform:translateY(-50%);pointer-events:none;",
    ""
], function(props) {
    return props.reverse ? "right: " + (0, _utils.getInputPadBySide)(props, 'right') + ";" : "left: " + (0, _utils.getInputPadBySide)(props, 'left') + ";";
});
var StyledSuggestions = (0, _styledComponentsDefault.default).ol.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledTextInput__StyledSuggestions",
    componentId: "sc-1x30a0s-4"
})([
    "border-top-left-radius:0;border-top-right-radius:0;margin:0;padding:0;list-style-type:none;",
    ";"
], function(props) {
    return props.theme.textInput && props.theme.textInput.suggestions && props.theme.textInput.suggestions.extend;
});

},{"styled-components":"6bGrk","../../utils":"fx31z","../../utils/styles":"4m6LZ","../../utils/readOnly":"fhTT5","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9Nxat":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextInputPropTypes", ()=>TextInputPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
var PropType = {};
var TextInputPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9eJAz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CopyButton", ()=>CopyButton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _copy = require("grommet-icons/icons/Copy");
var _button = require("../Button");
var _tip = require("../Tip");
var _styles = require("../../utils/styles");
var _useThemeValue = require("../../utils/useThemeValue");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
// to overcome `plain` styling due to (icon && !label) condition
// in buttons without theme.button.default, apply the padding here
var StyledButton = (0, _styledComponentsDefault.default)((0, _button.Button)).withConfig({
    displayName: "CopyButton__StyledButton",
    componentId: "sc-1bp1m18-0"
})([
    "border-radius:",
    ";",
    ""
], function(props) {
    return props.theme.global.control.border.radius;
}, function(props) {
    return !props.theme.button["default"] ? (0, _styles.edgeStyle)('padding', props.pad, false, undefined, props.theme) : '';
});
var CopyButton = function CopyButton(_ref) {
    var _theme$global$input$p, _theme$global$input$p2, _theme$global$input$p3;
    var onClickCopy = _ref.onClickCopy, onBlurCopy = _ref.onBlurCopy, readOnlyCopyPrompt = _ref.readOnlyCopyPrompt, tip = _ref.tip, value = _ref.value;
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme, passThemeFlag = _useThemeValue1.passThemeFlag;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tip.Tip), {
        dropProps: {
            align: {
                bottom: 'top'
            }
        },
        content: tip
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledButton, _extends({
        onClick: onClickCopy,
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _copy.Copy), null),
        pad: {
            horizontal: (_theme$global$input$p = theme.global.input.padding) == null ? void 0 : _theme$global$input$p.horizontal,
            left: (_theme$global$input$p2 = theme.global.input.padding) == null ? void 0 : _theme$global$input$p2.left,
            right: (_theme$global$input$p3 = theme.global.input.padding) == null ? void 0 : _theme$global$input$p3.right,
            // only apply horizontal padding since button will
            // fill height of input
            top: '0',
            bottom: '0'
        },
        onBlur: onBlurCopy,
        onMouseOut: onBlurCopy,
        "aria-label": readOnlyCopyPrompt + " " + value
    }, passThemeFlag)));
};

},{"react":"8CCva","styled-components":"6bGrk","grommet-icons/icons/Copy":"gkNXz","../Button":"fVON6","../Tip":"55RvR","../../utils/styles":"4m6LZ","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gkNXz":[function(require,module,exports,__globalThis) {
"use strict";
exports.__esModule = true;
exports.Copy = void 0;
var _react = _interopRequireWildcard(require("64bcf62dd2a79e3b"));
var _StyledIcon = require("1a44d56760bd098c");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        "default": e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Copy = exports.Copy = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ _react["default"].createElement(_StyledIcon.StyledIcon, _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Copy"
    }, props), /*#__PURE__*/ _react["default"].createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M9 15h8-8zm0-4h10H9zm0-4h4-4zm7-6v6h6M6 5H2v18h16v-4m4 0H6V1h11l5 5v13z"
    }));
});
Copy.displayName = 'Copy';

},{"64bcf62dd2a79e3b":"8CCva","1a44d56760bd098c":"7Xr4o"}],"9grNg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormFieldPropTypes", ()=>FormFieldPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
var PropType = {};
var FormFieldPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"glb1P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", ()=>(0, _select.Select));
var _select = require("./Select");

},{"./Select":"i5hl5","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"i5hl5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", ()=>Select);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("../../utils");
var _box = require("../Box");
var _keyboard = require("../Keyboard");
var _formContext = require("../Form/FormContext");
var _selectContainer = require("./SelectContainer");
var _styledSelect = require("./StyledSelect");
var _utils1 = require("./utils");
var _defaultSelectTextInput = require("./DefaultSelectTextInput");
var _messageContext = require("../../contexts/MessageContext");
var _propTypes = require("./propTypes");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "a11yTitle",
    "aria-label",
    "alignSelf",
    "children",
    "clear",
    "closeOnChange",
    "defaultValue",
    "disabled",
    "disabledKey",
    "dropAlign",
    "dropHeight",
    "dropProps",
    "dropTarget",
    "emptySearchMessage",
    "focusIndicator",
    "gridArea",
    "id",
    "icon",
    "labelKey",
    "margin",
    "messages",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onClose",
    "onFocus",
    "onKeyDown",
    "onMore",
    "onOpen",
    "onSearch",
    "open",
    "options",
    "placeholder",
    "plain",
    "replace",
    "searchPlaceholder",
    "selected",
    "size",
    "value",
    "valueKey",
    "valueLabel"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var defaultDropAlign = {
    top: 'bottom',
    left: 'left'
};
var Select = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var a11yTitle = _ref.a11yTitle, ariaLabel = _ref['aria-label'], alignSelf = _ref.alignSelf, children = _ref.children, _ref$clear = _ref.clear, clear = _ref$clear === void 0 ? false : _ref$clear, _ref$closeOnChange = _ref.closeOnChange, closeOnChange = _ref$closeOnChange === void 0 ? true : _ref$closeOnChange, defaultValue = _ref.defaultValue, disabled = _ref.disabled, disabledKey = _ref.disabledKey, _ref$dropAlign = _ref.dropAlign, dropAlign = _ref$dropAlign === void 0 ? defaultDropAlign : _ref$dropAlign, dropHeight = _ref.dropHeight, dropProps = _ref.dropProps, dropTarget = _ref.dropTarget, emptySearchMessage = _ref.emptySearchMessage, focusIndicator = _ref.focusIndicator, gridArea = _ref.gridArea, id = _ref.id, icon = _ref.icon, labelKeyProp = _ref.labelKey, margin = _ref.margin, messages = _ref.messages, multiple = _ref.multiple, name = _ref.name, onBlur = _ref.onBlur, onChange = _ref.onChange, onClick = _ref.onClick, onClose = _ref.onClose, onFocus = _ref.onFocus, onKeyDown = _ref.onKeyDown, onMore = _ref.onMore, onOpen = _ref.onOpen, onSearch = _ref.onSearch, propOpen = _ref.open, optionsProp = _ref.options, placeholder = _ref.placeholder, plain = _ref.plain, replace = _ref.replace, searchPlaceholder = _ref.searchPlaceholder, selected = _ref.selected, size = _ref.size, valueProp = _ref.value, valueKeyProp = _ref.valueKey, valueLabel = _ref.valueLabel, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme;
    var inputRef = (0, _react.useRef)();
    var formContext = (0, _react.useContext)((0, _formContext.FormContext));
    var _useContext = (0, _react.useContext)((0, _messageContext.MessageContext)), format = _useContext.format;
    // For greater resilience, use labelKey if valueKey isn't provided and
    // vice versa. https://github.com/grommet/grommet/pull/6299
    var valueKey = valueKeyProp || labelKeyProp;
    var labelKey = labelKeyProp || valueKeyProp;
    // Determine if the Select is opened with the keyboard. If so,
    // focus should be set on the first option when the drop opens
    // see set initial focus code in SelectContainer.js
    var usingKeyboard = (0, _utils.useKeyboard)();
    // value is used for what we receive in valueProp and the basis for
    // what we send with onChange
    // When 'valueKey' sets 'reduce', the value(s) here should match
    // what the 'valueKey' would return for the corresponding
    // selected option object.
    // Otherwise, the value(s) should match the selected options.
    var _formContext$useFormI = formContext.useFormInput({
        name: name,
        value: valueProp,
        initialValue: defaultValue || ''
    }), value = _formContext$useFormI[0], setValue = _formContext$useFormI[1];
    // normalizedValue is the value mapped with any valueKey applied
    // When the options array contains objects, this property indicates how
    // to retrieve the value of each option.
    // If a string is provided, it is used as the key to retrieve a
    // property of an option object.
    // If a function is provided, it is called with the option and should
    // return the value.
    // If reduce is true, this value will be used for the 'value'
    // delivered via 'onChange'.
    var normalizedValue = (0, _react.useMemo)(function() {
        return (0, _utils1.getNormalizedValue)(value, valueKey);
    }, [
        value,
        valueKey
    ]);
    // search input value
    var _useState = (0, _react.useState)(), search = _useState[0], setSearch = _useState[1];
    // All select option indices and values
    var _useState2 = (0, _react.useState)(optionsProp), allOptions = _useState2[0], setAllOptions = _useState2[1];
    // Track changes to options property, except when options are being
    // updated due to search activity. Allows option's initial index value
    // to be referenced when filtered by search.
    (0, _react.useEffect)(function() {
        if (!search) setAllOptions(optionsProp);
    }, [
        optionsProp,
        search
    ]);
    // the option indexes present in the value
    var optionIndexesInValue = (0, _react.useMemo)(function() {
        var result = [];
        if (selected !== undefined) {
            if (Array.isArray(selected)) {
                var validSelections = selected.filter(function(i) {
                    return i in allOptions;
                });
                result.push.apply(result, validSelections);
            } else if (selected in allOptions) result.push(selected);
        } else if (Array.isArray(normalizedValue)) normalizedValue.forEach(function(v) {
            var index = allOptions.map(function(option) {
                return (0, _utils1.applyKey)(option, valueKey);
            }).indexOf(v);
            if (index !== -1) result.push(index);
        });
        else {
            var index = allOptions.map(function(option) {
                return (0, _utils1.applyKey)(option, valueKey);
            }).indexOf(normalizedValue);
            if (index !== -1) result.push(index);
        }
        return result;
    }, [
        allOptions,
        selected,
        valueKey,
        normalizedValue
    ]);
    var _useState3 = (0, _react.useState)(propOpen), open = _useState3[0], setOpen = _useState3[1];
    (0, _react.useEffect)(function() {
        return setOpen(propOpen);
    }, [
        propOpen
    ]);
    var onRequestOpen = (0, _react.useCallback)(function() {
        if (open) return;
        setOpen(true);
        if (onOpen) onOpen();
    }, [
        onOpen,
        open
    ]);
    var onRequestClose = (0, _react.useCallback)(function() {
        setOpen(false);
        if (onClose) onClose();
        setSearch();
    }, [
        onClose
    ]);
    var triggerChangeEvent = (0, _react.useCallback)(function(nextValue) {
        return (0, _utils1.changeEvent)(inputRef, nextValue);
    }, []);
    var onSelectChange = (0, _react.useCallback)(function(event, _ref2) {
        var option = _ref2.option, nextValue = _ref2.value, nextSelected = _ref2.selected;
        if (closeOnChange) onRequestClose();
        // nextValue must not be of type object to set value directly on the
        // input. if it is an object, then the user has not provided necessary
        // props to reduce object option
        if ((typeof nextValue !== 'object' || multiple) && nextValue !== event.target.value && inputRef.current) // select registers changing option as a click event or keydown.
        // when in a form, we need to programatically trigger a change
        // event in order for the change event to be registered upstream
        // necessary for change validation in form
        triggerChangeEvent(nextValue);
        setValue(nextValue);
        if (onChange) {
            event.persist();
            var adjustedEvent;
            // support for native event used by Preact
            if (event instanceof Event) {
                adjustedEvent = new event.constructor(event.type, event);
                Object.defineProperties(adjustedEvent, {
                    target: {
                        value: inputRef.current
                    },
                    value: {
                        value: nextValue
                    },
                    option: {
                        value: option
                    },
                    selected: {
                        value: nextSelected
                    }
                });
            } else {
                adjustedEvent = event;
                adjustedEvent.target = inputRef.current;
                adjustedEvent.value = nextValue;
                adjustedEvent.option = option;
                adjustedEvent.selected = nextSelected;
            }
            onChange(adjustedEvent);
        }
    }, [
        closeOnChange,
        multiple,
        onChange,
        onRequestClose,
        setValue,
        triggerChangeEvent
    ]);
    var SelectIcon = (0, _utils1.getSelectIcon)(icon, theme, open);
    // element to show, trumps inputValue
    var selectValue = (0, _react.useMemo)(function() {
        if (valueLabel instanceof Function) {
            if (value || value === 0 || value === false) return valueLabel(value);
        } else if (valueLabel) return valueLabel;
        else if (/*#__PURE__*/ (0, _reactDefault.default).isValidElement(value)) return value; // deprecated
        return undefined;
    }, [
        value,
        valueLabel
    ]);
    var displayLabelKey = (0, _react.useMemo)(function() {
        return (0, _utils1.getDisplayLabelKey)(labelKey, allOptions, optionIndexesInValue, selectValue);
    }, [
        labelKey,
        allOptions,
        optionIndexesInValue,
        selectValue
    ]);
    // text to show
    // When the options array contains objects, this property indicates how
    // to retrieve the value of each option.
    // If a string is provided, it is used as the key to retrieve a
    // property of an option object.
    // If a function is provided, it is called with the option and should
    // return the value.
    // If reduce is true, this value will be used for the 'value'
    // delivered via 'onChange'.
    var inputValue = (0, _react.useMemo)(function() {
        if (!selectValue) {
            if (optionIndexesInValue.length === 0) return '';
            if (optionIndexesInValue.length === 1) return (0, _utils1.applyKey)(allOptions[optionIndexesInValue[0]], labelKey);
            return format({
                id: 'select.multiple',
                messages: messages
            });
        }
        return undefined;
    }, [
        labelKey,
        messages,
        format,
        optionIndexesInValue,
        allOptions,
        selectValue
    ]);
    var iconColor = (0, _utils1.getIconColor)(theme);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keyboard.Keyboard), {
        onDown: onRequestOpen,
        onUp: onRequestOpen
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledSelect.StyledSelectDropButton), {
        ref: ref,
        a11yTitle: "" + (ariaLabel || a11yTitle || placeholder || 'Open Drop') + (value ? format({
            id: 'select.selected',
            messages: messages,
            values: {
                currentSelectedValue: (0, _utils1.formatValueForA11y)(value, labelKey)
            }
        }) : ''),
        "aria-expanded": Boolean(open),
        "aria-haspopup": "listbox",
        id: id,
        disabled: disabled === true || undefined,
        dropAlign: dropAlign,
        dropTarget: dropTarget,
        open: open,
        alignSelf: alignSelf,
        focusIndicator: plain ? focusIndicator : true,
        onFocus: onFocus,
        onBlur: onBlur,
        gridArea: gridArea,
        margin: margin,
        onOpen: onRequestOpen,
        onClose: onRequestClose,
        onClick: onClick,
        dropContent: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _selectContainer.SelectContainer), {
            clear: clear,
            disabled: disabled,
            disabledKey: disabledKey,
            dropHeight: dropHeight,
            emptySearchMessage: emptySearchMessage,
            id: id,
            labelKey: labelKey,
            multiple: multiple,
            name: name,
            onChange: onSelectChange,
            onKeyDown: onKeyDown,
            onMore: onMore,
            onSearch: onSearch,
            options: optionsProp,
            allOptions: allOptions,
            optionIndexesInValue: optionIndexesInValue,
            replace: replace,
            searchPlaceholder: searchPlaceholder,
            search: search,
            setSearch: setSearch,
            selected: selected,
            usingKeyboard: usingKeyboard,
            value: value,
            valueKey: valueKey
        }, children),
        plainSelect: plain,
        plain: true // Button should be plain
        ,
        dropProps: dropProps,
        theme: theme
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
        align: "center",
        direction: "row",
        justify: "between",
        background: theme.select.background
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
        direction: "row",
        flex: true,
        basis: "auto"
    }, selectValue || displayLabelKey ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, selectValue || displayLabelKey, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledSelect.HiddenInput), {
        type: "text",
        name: name,
        id: id ? id + "__input" : undefined,
        inert: (0, _utils1.inertTrueValue),
        value: inputValue,
        ref: inputRef,
        readOnly: true
    })) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _defaultSelectTextInput.DefaultSelectTextInput), _extends({
        a11yTitle: (ariaLabel || a11yTitle) && "" + (ariaLabel || a11yTitle) + (value && typeof value === 'string' ? ", " + value : ''),
        disabled: disabled,
        id: id,
        inert: (0, _utils1.inertTrueValue),
        name: name,
        ref: inputRef,
        placeholder: placeholder,
        value: inputValue,
        size: size,
        theme: theme
    }, rest))), SelectIcon && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
        margin: theme.select.icons.margin,
        flex: false,
        style: {
            minWidth: 'auto'
        }
    }, /*#__PURE__*/ (0, _react.isValidElement)(SelectIcon) ? SelectIcon : /*#__PURE__*/ (0, _reactDefault.default).createElement(SelectIcon, {
        color: iconColor,
        size: size
    })))));
});
Select.displayName = 'Select';
Select.propTypes = (0, _propTypes.SelectPropTypes);

},{"react":"8CCva","../../utils":"fx31z","../Box":"4o01A","../Keyboard":"7WukC","../Form/FormContext":"ky7Rv","./SelectContainer":"6WHmd","./StyledSelect":"e6glK","./utils":"3997d","./DefaultSelectTextInput":"ffyQa","../../contexts/MessageContext":"9V5sq","./propTypes":"hazo6","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6WHmd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectContainer", ()=>SelectContainer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var _box = require("../Box");
var _button = require("../Button");
var _infiniteScroll = require("../InfiniteScroll");
var _keyboard = require("../Keyboard");
var _text = require("../Text");
var _textInput = require("../TextInput");
var _styledSelect = require("./StyledSelect");
var _utils1 = require("./utils");
var _emptySearchOption = require("./EmptySearchOption");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "clear",
    "onClear",
    "name",
    "theme"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
// ensure ClearButton receives visual indication of keyboard
var StyledButton = (0, _styledComponentsDefault.default)((0, _button.Button)).withConfig({
    displayName: "SelectContainer__StyledButton",
    componentId: "sc-1wi0ul8-0"
})([
    "&:focus{",
    "}"
], function(props) {
    return (0, _utils.getHoverIndicatorStyle)('background', props.theme);
});
var ClearButton = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var clear = _ref.clear, onClear = _ref.onClear, name = _ref.name, theme = _ref.theme, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var label = clear.label, position = clear.position;
    var align = position !== 'bottom' ? 'start' : 'center';
    var buttonLabel = label || "Clear " + (name || 'selection');
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), passThemeFlag = _useThemeValue1.passThemeFlag;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(StyledButton, _extends({
        a11yTitle: buttonLabel + ". Or, press " + (position === 'bottom' ? 'shift tab' : 'down arrow') + " to move to select options",
        fill: "horizontal",
        ref: ref,
        onClick: onClear,
        focusIndicator: false,
        plain: true
    }, passThemeFlag, rest), function(_ref2) {
        var _theme$select$clear;
        var hover = _ref2.hover;
        var boxProps = _extends({}, theme.select.clear.container);
        delete boxProps.hover; // avoid passing hover object to Box
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), _extends({}, boxProps, hover ? (_theme$select$clear = theme.select.clear) == null || (_theme$select$clear = _theme$select$clear.container) == null ? void 0 : _theme$select$clear.hover : {}, {
            align: align
        }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), theme.select.clear.text, buttonLabel));
    });
});
var SelectContainer = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref3, ref) {
    var clear = _ref3.clear, _ref3$children = _ref3.children, children = _ref3$children === void 0 ? null : _ref3$children, disabled = _ref3.disabled, disabledKey = _ref3.disabledKey, dropHeight = _ref3.dropHeight, _ref3$emptySearchMess = _ref3.emptySearchMessage, emptySearchMessage = _ref3$emptySearchMess === void 0 ? 'No matches found' : _ref3$emptySearchMess, id = _ref3.id, labelKey = _ref3.labelKey, multiple = _ref3.multiple, name = _ref3.name, onChange = _ref3.onChange, onKeyDown = _ref3.onKeyDown, onMore = _ref3.onMore, onSearch = _ref3.onSearch, optionIndexesInValue = _ref3.optionIndexesInValue, options = _ref3.options, allOptions = _ref3.allOptions, searchPlaceholder = _ref3.searchPlaceholder, search = _ref3.search, setSearch = _ref3.setSearch, selected = _ref3.selected, usingKeyboard = _ref3.usingKeyboard, _ref3$value = _ref3.value, value = _ref3$value === void 0 ? '' : _ref3$value, valueKey = _ref3.valueKey, _ref3$replace = _ref3.replace, replace = _ref3$replace === void 0 ? true : _ref3$replace;
    var _useThemeValue2 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue2.theme, passThemeFlag = _useThemeValue2.passThemeFlag;
    var shouldShowClearButton = (0, _react.useCallback)(function(position) {
        var hasValue = Boolean(multiple && value ? value.length : value);
        var showAtPosition = position === 'bottom' ? (clear == null ? void 0 : clear.position) === 'bottom' : (clear == null ? void 0 : clear.position) !== 'bottom';
        return clear && hasValue && showAtPosition;
    }, [
        clear,
        multiple,
        value
    ]);
    var isDisabled = (0, _utils1.useDisabled)(disabled, disabledKey, options, valueKey || labelKey);
    var _useState = (0, _react.useState)(usingKeyboard && !shouldShowClearButton('top') && !onSearch ? 0 : -1), activeIndex = _useState[0], setActiveIndex = _useState[1];
    var _useState2 = (0, _react.useState)(usingKeyboard), keyboardNavigation = _useState2[0], setKeyboardNavigation = _useState2[1];
    var searchRef = (0, _react.useRef)();
    var optionsRef = (0, _react.useRef)();
    var clearRef = (0, _react.useRef)();
    var activeRef = (0, _react.useRef)();
    // for keyboard/screenreader, keep the active option in focus
    (0, _react.useEffect)(function() {
        var _activeRef$current;
        if (activeIndex >= 0) (_activeRef$current = activeRef.current) == null || _activeRef$current.focus();
    }, [
        activeIndex
    ]);
    // set initial focus
    (0, _react.useEffect)(function() {
        // need to wait for Drop to be ready
        var timer = setTimeout(function() {
            var optionsNode = optionsRef.current;
            var clearButton = clearRef.current;
            if (onSearch) {
                var searchInput = searchRef.current;
                if (searchInput && searchInput.focus && !activeRef.current) (0, _utils.setFocusWithoutScroll)(searchInput);
            } else if (clear && clearButton && clearButton.focus && clear.position !== 'bottom') (0, _utils.setFocusWithoutScroll)(clearButton);
            else if (usingKeyboard && activeRef.current) (0, _utils.setFocusWithoutScroll)(activeRef.current);
            else if (optionsNode) (0, _utils.setFocusWithoutScroll)(optionsNode);
        }, 100);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        onSearch,
        usingKeyboard,
        clear
    ]);
    var isSelected = (0, _react.useCallback)(function(index) {
        var result;
        if (selected) // deprecated in favor of value
        result = selected.indexOf(index) !== -1;
        else {
            var optionVal = (0, _utils1.getOptionValue)(index, options, valueKey);
            if (Array.isArray(value)) {
                if (value.length === 0) result = false;
                else if (typeof value[0] !== 'object') result = value.indexOf(optionVal) !== -1;
                else if (valueKey) result = value.some(function(valueItem) {
                    var valueValue = typeof valueKey === 'function' ? valueKey(valueItem) : valueItem[valueKey] || valueItem[valueKey.key];
                    return valueValue === optionVal;
                });
            } else if (valueKey && value !== null && typeof value === 'object') {
                var valueValue = typeof valueKey === 'function' ? valueKey(value) : value[valueKey];
                result = valueValue === optionVal;
            } else result = value === optionVal;
        }
        return result;
    }, [
        selected,
        value,
        valueKey,
        options
    ]);
    var selectOption = (0, _react.useCallback)(function(index) {
        return function(event) {
            if (onChange) {
                var nextValue;
                var nextSelected;
                if (multiple) {
                    var nextOptionIndexesInValue = optionIndexesInValue.slice(0);
                    var allOptionsIndex = allOptions.indexOf(options[index]);
                    var valueIndex = optionIndexesInValue.indexOf(allOptionsIndex);
                    if (valueIndex === -1) nextOptionIndexesInValue.push(allOptionsIndex);
                    else nextOptionIndexesInValue.splice(valueIndex, 1);
                    nextValue = nextOptionIndexesInValue.map(function(i) {
                        return valueKey && valueKey.reduce ? (0, _utils1.applyKey)(allOptions[i], valueKey) : allOptions[i];
                    });
                    nextSelected = nextOptionIndexesInValue;
                } else {
                    nextValue = valueKey && valueKey.reduce ? (0, _utils1.applyKey)(options[index], valueKey) : options[index];
                    nextSelected = index;
                }
                onChange(event, {
                    option: options[index],
                    value: nextValue,
                    selected: nextSelected
                });
            }
        };
    }, [
        multiple,
        onChange,
        optionIndexesInValue,
        options,
        allOptions,
        valueKey
    ]);
    var onClear = (0, _react.useCallback)(function(event) {
        onChange(event, {
            option: undefined,
            value: '',
            selected: ''
        });
    }, [
        onChange
    ]);
    var onNextOption = (0, _react.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = activeIndex + 1;
        while(nextActiveIndex < options.length && isDisabled(nextActiveIndex))nextActiveIndex += 1;
        if (nextActiveIndex !== options.length) {
            setActiveIndex(nextActiveIndex);
            setKeyboardNavigation(true);
        }
    }, [
        activeIndex,
        options,
        isDisabled
    ]);
    var onPreviousOption = (0, _react.useCallback)(function(event) {
        event.preventDefault();
        var nextActiveIndex = activeIndex - 1;
        if (nextActiveIndex === -1) {
            var searchInput = searchRef.current;
            var clearButton = clearRef.current;
            if (clearButton && clearButton.focus && shouldShowClearButton('top')) {
                setActiveIndex(nextActiveIndex);
                (0, _utils.setFocusWithoutScroll)(clearButton);
            } else if (searchInput && searchInput.focus) {
                setActiveIndex(nextActiveIndex);
                (0, _utils.setFocusWithoutScroll)(searchInput);
            }
        }
        while(nextActiveIndex >= 0 && isDisabled(nextActiveIndex))nextActiveIndex -= 1;
        if (nextActiveIndex >= 0) {
            setActiveIndex(nextActiveIndex);
            setKeyboardNavigation(true);
        }
    }, [
        activeIndex,
        isDisabled,
        shouldShowClearButton
    ]);
    var onKeyDownOption = (0, _react.useCallback)(function(event) {
        if (!onSearch) {
            var nextActiveIndex = options.findIndex(function(e, index) {
                var label;
                if (typeof e === 'object') label = e.label || (0, _utils1.applyKey)(e, labelKey);
                else label = e;
                return typeof label === 'string' && label.charAt(0).toLowerCase() === event.key.toLowerCase() && !isDisabled(index);
            });
            if (nextActiveIndex >= 0) {
                event.preventDefault();
                setActiveIndex(nextActiveIndex);
                setKeyboardNavigation(true);
            }
        }
        if (onKeyDown) onKeyDown(event);
    }, [
        isDisabled,
        labelKey,
        onKeyDown,
        options,
        onSearch
    ]);
    var onActiveOption = (0, _react.useCallback)(function(index) {
        return function() {
            if (!keyboardNavigation) setActiveIndex(index);
        };
    }, [
        keyboardNavigation
    ]);
    var onSelectOption = (0, _react.useCallback)(function(event) {
        if ((shouldShowClearButton('bottom') || shouldShowClearButton('top')) && (0, _utils.containsFocus)(clearRef.current)) onChange(event, {
            option: undefined,
            value: '',
            selected: ''
        });
        else if (activeIndex >= 0 && activeIndex < options.length) {
            event.preventDefault(); // prevent submitting forms
            selectOption(activeIndex)(event);
        }
    }, [
        activeIndex,
        selectOption,
        options,
        onChange,
        shouldShowClearButton
    ]);
    var customSearchInput = theme.select.searchInput;
    var SelectTextInput = customSearchInput || (0, _textInput.TextInput);
    var selectOptionsStyle = theme.select.options ? _extends({}, theme.select.options.box, theme.select.options.container) : {};
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _keyboard.Keyboard), {
        onEnter: onSelectOption,
        onSpace: onSelectOption,
        onUp: onPreviousOption,
        onDown: onNextOption,
        onKeyDown: onKeyDownOption
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledSelect.StyledContainer), _extends({
        ref: ref,
        id: id ? id + "__select-drop" : undefined,
        dropHeight: dropHeight
    }, passThemeFlag), onSearch && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
        pad: !customSearchInput ? 'xsmall' : undefined,
        flex: false
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(SelectTextInput, {
        focusIndicator: !customSearchInput,
        size: "small",
        ref: searchRef,
        type: "search",
        value: search || '',
        placeholder: searchPlaceholder,
        onChange: function onChange(event) {
            var nextSearch = event.target.value;
            setSearch(nextSearch);
            setActiveIndex(-1);
            onSearch(nextSearch);
        }
    })), shouldShowClearButton('top') && /*#__PURE__*/ (0, _reactDefault.default).createElement(ClearButton, {
        ref: clearRef,
        clear: clear,
        name: name,
        onClear: onClear,
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        onMouseOver: function onMouseOver() {
            return setActiveIndex(-1);
        },
        theme: theme
    }), options.length > 0 ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledSelect.OptionsContainer), {
        role: "listbox",
        tabIndex: "-1",
        ref: optionsRef,
        "aria-multiselectable": multiple,
        onMouseMove: function onMouseMove() {
            return setKeyboardNavigation(false);
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _infiniteScroll.InfiniteScroll), {
        items: options,
        step: theme.select.step,
        onMore: onMore,
        replace: replace,
        show: activeIndex !== -1 ? activeIndex : undefined
    }, function(option, index, optionRef) {
        var optionDisabled = isDisabled(index);
        var optionSelected = isSelected(index);
        var optionActive = activeIndex === index;
        // Determine whether the label is done as a child or
        // as an option Button kind property.
        var child;
        var textComponent = false;
        if (children) {
            child = children(option, index, options, {
                active: optionActive,
                disabled: optionDisabled,
                selected: optionSelected
            });
            if (typeof child === 'string' || child.props && child.props.children && typeof child.props.children === 'string') textComponent = true;
        } else if (theme.select.options) {
            child = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), selectOptionsStyle, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), theme.select.options.text, (0, _utils1.getOptionLabel)(index, options, labelKey)));
            textComponent = true;
        }
        // if we have a child, turn on plain, and hoverIndicator
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledSelect.SelectOption), _extends({
            key: index,
            ref: function ref(node) {
                // eslint-disable-next-line no-param-reassign
                if (optionRef) optionRef.current = node;
                if (optionActive) activeRef.current = node;
            },
            tabIndex: optionSelected ? '0' : '-1',
            role: "option",
            "aria-setsize": options.length,
            "aria-posinset": index + 1,
            "aria-selected": optionSelected,
            focusIndicator: false,
            "aria-disabled": optionDisabled || undefined,
            plain: !child ? undefined : true,
            align: "start",
            kind: !child ? 'option' : undefined,
            label: !child ? (0, _utils1.getOptionLabel)(index, options, labelKey || valueKey) : undefined,
            disabled: optionDisabled || undefined,
            active: optionActive,
            selected: optionSelected,
            onFocus: function onFocus() {
                return setActiveIndex(index);
            },
            onMouseOver: !optionDisabled ? onActiveOption(index) : undefined,
            onMouseOut: !optionDisabled ? onActiveOption(-1) : undefined,
            onClick: !optionDisabled ? selectOption(index) : undefined,
            textComponent: textComponent
        }, passThemeFlag), child);
    })) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _emptySearchOption.EmptySearchOption), {
        emptySearchMessage: emptySearchMessage,
        selectOptionsStyle: selectOptionsStyle,
        theme: theme
    }), shouldShowClearButton('bottom') && /*#__PURE__*/ (0, _reactDefault.default).createElement(ClearButton, {
        ref: clearRef,
        clear: clear,
        name: name,
        onClear: onClear,
        onFocus: function onFocus() {
            return setActiveIndex(-1);
        },
        onMouseOver: function onMouseOver() {
            return setActiveIndex(-1);
        },
        theme: theme
    })));
});

},{"react":"8CCva","styled-components":"6bGrk","../../utils":"fx31z","../Box":"4o01A","../Button":"fVON6","../InfiniteScroll":"9S1JB","../Keyboard":"7WukC","../Text":"kz1Ni","../TextInput":"cL4wi","./StyledSelect":"e6glK","./utils":"3997d","./EmptySearchOption":"86i3i","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"e6glK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledContainer", ()=>StyledContainer);
parcelHelpers.export(exports, "OptionsContainer", ()=>OptionsContainer);
parcelHelpers.export(exports, "HiddenInput", ()=>HiddenInput);
parcelHelpers.export(exports, "SelectOption", ()=>SelectOption);
parcelHelpers.export(exports, "SelectTextInput", ()=>SelectTextInput);
parcelHelpers.export(exports, "StyledSelectDropButton", ()=>StyledSelectDropButton);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _box = require("../Box");
var _button = require("../Button");
var _dropButton = require("../DropButton");
var _textInput = require("../TextInput");
var _utils = require("../../utils");
var StyledContainer = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "StyledSelect__StyledContainer",
    componentId: "sc-znp66n-0"
})([
    "@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:100%;}",
    ";",
    ";"
], function(props) {
    return props.dropHeight ? (0, _utils.sizeStyle)('max-height', props.dropHeight, props.theme) : 'max-height: inherit;';
}, function(props) {
    return props.theme.select.container && props.theme.select.container.extend;
});
var OptionsContainer = (0, _styledComponentsDefault.default).div.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledSelect__OptionsContainer",
    componentId: "sc-znp66n-1"
})([
    "position:relative;scroll-behavior:smooth;overflow:auto;outline:none;",
    ";"
], function(props) {
    if (props.selectMultiple) return props.theme.selectMultiple.listbox && props.theme.selectMultiple.listbox.extend;
    return props.theme.select.listbox && props.theme.select.listbox.extend;
});
var HiddenInput = (0, _styledComponentsDefault.default).input.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledSelect__HiddenInput",
    componentId: "sc-znp66n-2"
})([
    "display:none;"
]);
var SelectOption = (0, _styledComponentsDefault.default)((0, _button.Button)).withConfig({
    displayName: "StyledSelect__SelectOption",
    componentId: "sc-znp66n-3"
})([
    "",
    " ",
    " &:focus{",
    "}display:block;width:100%;",
    ";"
], function(props) {
    return props.selected && props.textComponent && (0, _utils.selectedStyle);
}, function(props) {
    return props.active && (0, _utils.getHoverIndicatorStyle)(!props.children && !props.theme.select.options ? undefined : 'background', props.theme);
}, function(props) {
    return props.active && (0, _utils.getHoverIndicatorStyle)(!props.children && !props.theme.select.options ? undefined : 'background', props.theme);
}, function(props) {
    return props["aria-disabled"] && "cursor: default";
});
var SelectTextInput = (0, _styledComponentsDefault.default)((0, _textInput.TextInput)).withConfig({
    displayName: "StyledSelect__SelectTextInput",
    componentId: "sc-znp66n-4"
})([
    "cursor:",
    ";"
], function(props) {
    return props.defaultCursor ? 'default' : 'pointer';
});
var StyledSelectDropButton = (0, _styledComponentsDefault.default)((0, _dropButton.DropButton)).withConfig({
    displayName: "StyledSelect__StyledSelectDropButton",
    componentId: "sc-znp66n-5"
})([
    "",
    ";",
    ";",
    ";"
], function(props) {
    return !props.plainSelect && (0, _utils.controlBorderStyle);
}, function(props) {
    var _props$theme$select;
    return (_props$theme$select = props.theme.select) == null || (_props$theme$select = _props$theme$select.control) == null ? void 0 : _props$theme$select.extend;
}, function(props) {
    var _props$theme$select2;
    return props.open && ((_props$theme$select2 = props.theme.select) == null || (_props$theme$select2 = _props$theme$select2.control) == null ? void 0 : _props$theme$select2.open);
});

},{"styled-components":"6bGrk","../Box":"4o01A","../Button":"fVON6","../DropButton":"7Dx1v","../TextInput":"cL4wi","../../utils":"fx31z","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3997d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyKey", ()=>_applyKey);
parcelHelpers.export(exports, "getOptionLabel", ()=>getOptionLabel);
parcelHelpers.export(exports, "getOptionValue", ()=>getOptionValue);
parcelHelpers.export(exports, "getOptionIndex", ()=>getOptionIndex);
parcelHelpers.export(exports, "arrayIncludes", ()=>arrayIncludes);
parcelHelpers.export(exports, "useDisabled", ()=>useDisabled);
parcelHelpers.export(exports, "getNormalizedValue", ()=>getNormalizedValue);
parcelHelpers.export(exports, "changeEvent", ()=>changeEvent);
parcelHelpers.export(exports, "getSelectIcon", ()=>getSelectIcon);
parcelHelpers.export(exports, "getDisplayLabelKey", ()=>getDisplayLabelKey);
parcelHelpers.export(exports, "getIconColor", ()=>getIconColor);
// In react 18 and below the inert attribute is not supported
// so we use an empty string instead of true. In react 19 and above
// inert is supported so we should use true. The use function is
// used to determine the react version because it is only available
// in react 19 and above.
parcelHelpers.export(exports, "formatValueForA11y", ()=>_formatValueForA11y);
parcelHelpers.export(exports, "inertTrueValue", ()=>inertTrueValue);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("../../utils");
var _applyKey = function applyKey(option, key) {
    if (/*#__PURE__*/ (0, _react.isValidElement)(option)) return option;
    if (option === undefined || option === null) return undefined;
    if (typeof key === 'object') return _applyKey(option, key.key);
    if (typeof key === 'function') return key(option);
    if (key !== undefined && typeof option === 'object') return option[key];
    if (typeof option === 'object' && Object.keys(option).length > 0) return option[Object.keys(option)[0]];
    return option;
};
var getOptionLabel = function getOptionLabel(index, options, labelKey) {
    return _applyKey(options[index], labelKey);
};
var getOptionValue = function getOptionValue(index, options, valueKey) {
    return _applyKey(options[index], valueKey);
};
var getOptionIndex = function getOptionIndex(options, i, valueKey) {
    if (options) {
        if (typeof i === 'object') return options.findIndex(function(x) {
            return _applyKey(x, valueKey) === _applyKey(i, valueKey);
        });
        return options.indexOf(i);
    }
    return undefined;
};
var arrayIncludes = function arrayIncludes(arr, i, valueKey) {
    if (arr) {
        if (typeof i === 'object') return arr.some(function(x) {
            return _applyKey(x, valueKey) === _applyKey(i, valueKey);
        });
        return arr.includes(i);
    }
    return undefined;
};
var useDisabled = function useDisabled(disabled, disabledKey, options, valueKey) {
    return (0, _react.useCallback)(function(index) {
        var option = options[index];
        var result;
        if (disabledKey) result = _applyKey(option, disabledKey);
        else if (Array.isArray(disabled)) {
            if (typeof disabled[0] === 'number') result = disabled.indexOf(index) !== -1;
            else {
                var optionVal = getOptionValue(index, options, valueKey);
                result = getOptionIndex(disabled, options[index], valueKey) !== -1 || getOptionIndex(disabled, optionVal, valueKey) !== -1;
            }
        }
        return result;
    }, [
        disabled,
        disabledKey,
        options,
        valueKey
    ]);
};
var getNormalizedValue = function getNormalizedValue(value, valueKey) {
    if (Array.isArray(value)) return value.map(function(v) {
        return valueKey && valueKey.reduce ? v : _applyKey(v, valueKey);
    });
    return valueKey && valueKey.reduce ? value : _applyKey(value, valueKey);
};
var changeEvent = function changeEvent(inputRef, nextValue) {
    // Calling set value function directly on input because React library
    // overrides setter `event.target.value =` and loses original event
    // target fidelity.
    // https://stackoverflow.com/a/46012210
    var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
    nativeInputValueSetter.call(inputRef.current, nextValue);
    var event = new Event('input', {
        bubbles: true
    });
    inputRef.current.dispatchEvent(event);
};
var getSelectIcon = function getSelectIcon(icon, theme, open) {
    var SelectIcon;
    switch(icon){
        case false:
            break;
        case true:
        case undefined:
            SelectIcon = open && theme.select.icons.up ? theme.select.icons.up : theme.select.icons.down;
            break;
        default:
            SelectIcon = icon;
    }
    return SelectIcon;
};
var getDisplayLabelKey = function getDisplayLabelKey(labelKey, allOptions, optionIndexesInValue, selectValue) {
    var optionLabelKey = _applyKey(allOptions[optionIndexesInValue[0]], labelKey);
    if (!selectValue && optionIndexesInValue.length === 1 && typeof optionLabelKey === 'object') return optionLabelKey;
    return undefined;
};
var getIconColor = function getIconColor(theme) {
    return (0, _utils.normalizeColor)(theme.select.icons.color || 'control', theme);
};
var _formatValueForA11y = function formatValueForA11y(value, labelKey) {
    if (typeof value === 'string') return value;
    if (/*#__PURE__*/ (0, _react.isValidElement)(value)) return value.toString();
    if (Array.isArray(value)) return value.map(function(item) {
        return _formatValueForA11y(item, labelKey);
    }).join(', ');
    return _applyKey(value, labelKey);
};
var inertTrueValue = (0, _reactDefault.default).use ? true : '';

},{"react":"8CCva","../../utils":"fx31z","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"86i3i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmptySearchOption", ()=>EmptySearchOption);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("../Box");
var _text = require("../Text");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var EmptySearchOption = function EmptySearchOption(_ref) {
    var _theme$select, _theme$select2, _theme$select3;
    var emptySearchMessage = _ref.emptySearchMessage, selectOptionsStyle = _ref.selectOptionsStyle, theme = _ref.theme;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), (theme == null || (_theme$select = theme.select) == null || (_theme$select = _theme$select.emptySearchMessage) == null ? void 0 : _theme$select.container) || selectOptionsStyle, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({
        "aria-live": "polite",
        role: "alert"
    }, (theme == null || (_theme$select2 = theme.select) == null || (_theme$select2 = _theme$select2.emptySearchMessage) == null ? void 0 : _theme$select2.text) || ((_theme$select3 = theme.select) == null || (_theme$select3 = _theme$select3.options) == null ? void 0 : _theme$select3.text)), emptySearchMessage));
};

},{"react":"8CCva","../Box":"4o01A","../Text":"kz1Ni","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ffyQa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultSelectTextInput", ()=>DefaultSelectTextInput);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledSelect = require("./StyledSelect");
var _excluded = [
    "disabled",
    "id"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var DefaultSelectTextInput = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var disabled = _ref.disabled, id = _ref.id, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledSelect.SelectTextInput), _extends({
        defaultCursor: disabled === true || undefined,
        focusIndicator: false,
        id: id ? id + "__input" : undefined,
        ref: ref
    }, rest, {
        tabIndex: "-1",
        type: "text",
        plain: true,
        readOnly: true
    }));
});

},{"react":"8CCva","./StyledSelect":"e6glK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hazo6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "genericSelectProps", ()=>genericSelectProps);
parcelHelpers.export(exports, "SelectPropTypes", ()=>SelectPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var genericSelectProps = _extends({}, (0, _generalPropTypes.genericProps), {
    children: (0, _propTypesDefault.default).func,
    disabled: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
            (0, _propTypesDefault.default).number,
            (0, _propTypesDefault.default).string,
            (0, _propTypesDefault.default).object
        ]))
    ]),
    disabledKey: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    dropAlign: (0, _propTypesDefault.default).shape({
        top: (0, _propTypesDefault.default).oneOf([
            'top',
            'bottom'
        ]),
        bottom: (0, _propTypesDefault.default).oneOf([
            'top',
            'bottom'
        ]),
        right: (0, _propTypesDefault.default).oneOf([
            'left',
            'right'
        ]),
        left: (0, _propTypesDefault.default).oneOf([
            'left',
            'right'
        ])
    }),
    dropHeight: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, _propTypesDefault.default).string
    ]),
    dropTarget: (0, _propTypesDefault.default).object,
    dropProps: (0, _propTypesDefault.default).object,
    emptySearchMessage: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).node
    ]),
    focusIndicator: (0, _propTypesDefault.default).bool,
    icon: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).elementType
    ]),
    labelKey: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func
    ]),
    messages: (0, _propTypesDefault.default).shape({
        multiple: (0, _propTypesDefault.default).string
    }),
    name: (0, _propTypesDefault.default).string,
    onChange: (0, _propTypesDefault.default).func,
    onClose: (0, _propTypesDefault.default).func,
    onOpen: (0, _propTypesDefault.default).func,
    onSearch: (0, _propTypesDefault.default).func,
    onMore: (0, _propTypesDefault.default).func,
    options: (0, _propTypesDefault.default).arrayOf((0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).number,
        (0, _propTypesDefault.default).bool,
        (0, _propTypesDefault.default).element,
        (0, _propTypesDefault.default).object
    ])).isRequired,
    open: (0, _propTypesDefault.default).bool,
    placeholder: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).element,
        (0, _propTypesDefault.default).node
    ]),
    plain: (0, _propTypesDefault.default).bool,
    replace: (0, _propTypesDefault.default).bool,
    searchPlaceholder: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).element,
        (0, _propTypesDefault.default).node
    ]),
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).oneOf([
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, _propTypesDefault.default).string
    ]),
    valueLabel: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).node,
        (0, _propTypesDefault.default).func
    ]),
    valueKey: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).func,
        (0, _propTypesDefault.default).shape({
            key: (0, _propTypesDefault.default).string,
            reduce: (0, _propTypesDefault.default).bool
        })
    ])
});
var PropType = {};
var SelectPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cf0k8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CircleQuestion", ()=>CircleQuestion);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var CircleQuestion = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CircleQuestion"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-7v-1c0-1 0-1.5 1-2s2-1 2-2.5c0-1-1-2.5-3-2.5s-3 1.264-3 3m3 6v2"
    }));
});
CircleQuestion.displayName = 'CircleQuestion';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hfBEW":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("C42q3");

},{}],"4JEgD":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("6uEBH");

},{}],"92Jcs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectIsLockableOrCloseable", ()=>selectIsLockableOrCloseable);
var _toolkit = require("@reduxjs/toolkit");
var _selectUnlockedStatus = require("app/state/selectUnlockedStatus");
var _errors = require("types/errors");
const selectIsLockableOrCloseable = (0, _toolkit.createSelector)([
    (0, _selectUnlockedStatus.selectUnlockedStatus)
], (unlockedStatus)=>{
    if (unlockedStatus === 'openSkippedUnlockingProfile') return 'closeable';
    if (unlockedStatus === 'emptySkippedUnlockingProfile') return 'unlockable';
    if (unlockedStatus === 'unlockedProfile') return 'lockable';
    if (unlockedStatus === 'openUnpersisted') return 'closeable';
    if (unlockedStatus === 'lockedProfile') return false;
    if (unlockedStatus === 'emptyUnpersisted') return false;
    throw new (0, _errors.ExhaustedTypeError)('Invalid unlocked status', unlockedStatus);
});

},{"@reduxjs/toolkit":"9ol63","app/state/selectUnlockedStatus":"aRpzm","types/errors":"gbx4q","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cWbYg":[function(require,module,exports,__globalThis) {
/**
 *
 * Toolbar
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Toolbar", ()=>Toolbar);
var _jsxRuntime = require("react/jsx-runtime");
var _selectors = require("app/state/wallet/selectors");
var _box = require("grommet/es6/components/Box");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _react = require("react");
var _reactRedux = require("react-redux");
var _selectIsLockableOrCloseable = require("app/state/selectIsLockableOrCloseable");
var _languageSelect = require("app/components/LanguageSelect");
var _profileModalButton = require("./Features/ProfileModalButton");
var _networkSelector = require("./Features/NetworkSelector");
var _elementSizes = require("../../../styles/theme/elementSizes");
const StyledToolbar = (0, _styledComponentsDefault.default)((0, _box.Box))`
  @media only screen and (min-width: ${({ theme })=>`${theme.global?.breakpoints?.small?.value}px`}) {
    padding: ${({ theme })=>`${theme.global?.edgeSize?.small} ${theme.global?.edgeSize?.small} 0`};
  }

  @media only screen and (max-width: ${({ theme })=>`${theme.global?.breakpoints?.small?.value}px`}) {
    position: fixed;
    top: 0;
    right: 0;
    z-index: ${(0, _elementSizes.mobileToolbarButtonsZIndex)};
    padding: ${({ theme })=>theme.global?.breakpoints?.small?.edgeSize?.small};
  }
`;
function Toolbar() {
    const hasAccounts = (0, _reactRedux.useSelector)((0, _selectors.selectHasAccounts));
    const isLockableOrCloseable = (0, _reactRedux.useSelector)((0, _selectIsLockableOrCloseable.selectIsLockableOrCloseable));
    const isMobile = _react.useContext((0, _responsiveContext.ResponsiveContext)) === 'small';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledToolbar, {
        direction: "row",
        gap: "small",
        justify: "end",
        margin: {
            right: (!isLockableOrCloseable || isLockableOrCloseable === 'unlockable') && isMobile ? '30px' : 'none'
        },
        children: [
            (!isLockableOrCloseable || isLockableOrCloseable === 'unlockable') && !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                style: {
                    marginTop: '2px',
                    width: '220px'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _languageSelect.LanguageMenu), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                background: isMobile ? 'transparent' : 'background-front',
                justify: "end",
                round: "5px",
                border: {
                    color: 'background-front-border',
                    size: isMobile ? 'none' : 'xsmall'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _networkSelector.NetworkSelector), {})
            }),
            hasAccounts && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                justify: "center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileModalButton.ProfileModalButton), {})
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","app/state/wallet/selectors":"cgtJ3","grommet/es6/components/Box":"4o01A","grommet/es6/contexts/ResponsiveContext":"7EsNN","styled-components":"6bGrk","react":"8CCva","react-redux":"azV3Y","app/state/selectIsLockableOrCloseable":"92Jcs","app/components/LanguageSelect":"gsyi8","./Features/ProfileModalButton":"fI2mY","./Features/NetworkSelector":"bIzxE","../../../styles/theme/elementSizes":"2rYRG","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gsyi8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LanguageSelect", ()=>LanguageSelect);
parcelHelpers.export(exports, "LanguageMenu", ()=>LanguageMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _box = require("grommet/es6/components/Box");
var _menu = require("grommet/es6/components/Menu");
var _text = require("grommet/es6/components/Text");
var _language = require("styles/theme/icons/language/Language");
var _selectWithIcon = require("../SelectWithIcon");
var _i18N = require("../../../locales/i18n");
const languageOptions = (0, _i18N.languageLabels).map((lang)=>({
        value: lang[0],
        label: lang[1]
    }));
const LanguageSelect = ()=>{
    const { t, i18n } = (0, _reactI18Next.useTranslation)();
    if (!i18n.resolvedLanguage) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectWithIcon.SelectWithIcon), {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _language.Language), {
            size: "24px"
        }),
        id: "language",
        label: t('language', 'Language'),
        name: "language",
        onChange: (option)=>i18n.changeLanguage(option),
        options: languageOptions,
        value: i18n.resolvedLanguage
    });
};
const LanguageMenu = ()=>{
    const { i18n } = (0, _reactI18Next.useTranslation)();
    if (!i18n.resolvedLanguage) return null;
    const languageOptions = (0, _i18N.languageLabels).map(([key, label])=>({
            value: key,
            label: label,
            onClick: ()=>i18n.changeLanguage(key),
            primary: key === i18n.resolvedLanguage
        }));
    const selectedLabel = languageOptions.find((lang)=>lang.value === i18n.resolvedLanguage)?.label;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        background: 'background-front',
        justify: "end",
        round: "5px",
        border: {
            color: 'background-front-border',
            size: 'xsmall'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Menu), {
            size: "small",
            style: {
                border: 0
            },
            dropProps: {
                align: {
                    top: 'bottom',
                    left: 'left'
                },
                elevation: 'xlarge'
            },
            items: languageOptions,
            fill: true,
            a11yTitle: "Language",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                direction: "row",
                gap: "small",
                pad: "small",
                responsive: false,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _language.Language), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                        children: selectedLabel
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react-i18next":"7GUHL","grommet/es6/components/Box":"4o01A","grommet/es6/components/Menu":"fQpGz","grommet/es6/components/Text":"kz1Ni","styles/theme/icons/language/Language":"k4h3O","../SelectWithIcon":"hmeUh","../../../locales/i18n":"aQTIh","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fI2mY":[function(require,module,exports,__globalThis) {
/**
 *
 * ProfileModalButton
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProfileModalButton", ()=>ProfileModalButton);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("grommet/es6/components/Button");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _selectors = require("app/state/wallet/selectors");
var _accountSelector = require("../AccountSelector");
var _jazzIcon = require("../../../JazzIcon");
var _elementSizes = require("../../../../../styles/theme/elementSizes");
var _addressToJazzIconSeed = require("./addressToJazzIconSeed");
var _userSettings = require("grommet-icons/es6/icons/UserSettings");
var _tabs = require("grommet/es6/components/Tabs");
var _tab = require("grommet/es6/components/Tab");
var _reactI18Next = require("react-i18next");
var _contacts = require("../Contacts");
var _profile = require("../Profile");
var _settings = require("../Settings");
var _layerContainer = require("../LayerContainer");
const ProfileModalButton = /*#__PURE__*/ (0, _react.memo)(()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const walletHasAccounts = (0, _reactRedux.useSelector)((0, _selectors.selectHasAccounts));
    const address = (0, _reactRedux.useSelector)((0, _selectors.selectAddress));
    const [layerVisibility, setLayerVisibility] = (0, _react.useState)(false);
    const isMobile = (0, _reactDefault.default).useContext((0, _responsiveContext.ResponsiveContext)) === 'small';
    const hideLayer = ()=>setLayerVisibility(false);
    if (!walletHasAccounts) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                onClick: ()=>setLayerVisibility(true),
                "data-testid": "account-selector",
                children: address ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jazzIcon.JazzIcon), {
                    diameter: isMobile ? (0, _elementSizes.sidebarSmallSizeLogo) : (0, _elementSizes.sidebarMediumSizeLogo),
                    seed: (0, _addressToJazzIconSeed.addressToJazzIconSeed)(address)
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userSettings.UserSettings), {})
            }),
            layerVisibility && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layerContainer.LayerContainer), {
                animation: true,
                hideLayer: hideLayer,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tabs.Tabs), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tab.Tab), {
                            title: t('toolbar.settings.myAccountsTab', 'My Accounts'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountSelector.AccountSelector), {
                                closeHandler: hideLayer
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tab.Tab), {
                            "data-testid": "toolbar-contacts-tab",
                            title: t('toolbar.settings.contacts', 'Contacts'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contacts.Contacts), {
                                closeHandler: hideLayer
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tab.Tab), {
                            "data-testid": "toolbar-profile-tab",
                            title: t('toolbar.settings.profile', 'Profile'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profile.Profile), {
                                closeHandler: hideLayer
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tab.Tab), {
                            "data-testid": "toolbar-contacts-settings",
                            title: t('toolbar.settings.settings', 'Settings'),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settings.Settings), {})
                        })
                    ]
                })
            })
        ]
    });
});

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Button":"fVON6","grommet/es6/contexts/ResponsiveContext":"7EsNN","react":"8CCva","react-redux":"azV3Y","app/state/wallet/selectors":"cgtJ3","../AccountSelector":"1Ya4J","../../../JazzIcon":"kyOPT","../../../../../styles/theme/elementSizes":"2rYRG","./addressToJazzIconSeed":"bvuQg","grommet-icons/es6/icons/UserSettings":"crRSf","grommet/es6/components/Tabs":"hlkTL","grommet/es6/components/Tab":"ljnB8","react-i18next":"7GUHL","../Contacts":"glXVd","../Profile":"tlOFg","../Settings":"7U2xG","../LayerContainer":"fZ8B7","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1Ya4J":[function(require,module,exports,__globalThis) {
/**
 *
 * AccountSelector
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountSelector", ()=>AccountSelector);
var _jsxRuntime = require("react/jsx-runtime");
var _wallet = require("app/state/wallet");
var _selectors = require("app/state/wallet/selectors");
var _selectUnlockedStatus = require("app/state/selectUnlockedStatus");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _manageableAccount = require("../Account/ManageableAccount");
var _scrollableContainer = require("../ScrollableContainer");
var _buttonLink = require("../../../ButtonLink");
var _add = require("grommet-icons/es6/icons/Add");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
const AccountSelector = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const wallets = (0, _reactRedux.useSelector)((0, _selectors.selectWallets));
    const activeAddress = (0, _reactRedux.useSelector)((0, _selectors.selectAddress));
    const hasOneAccount = (0, _reactRedux.useSelector)((0, _selectors.selectHasOneAccount));
    const unlockedStatus = (0, _reactRedux.useSelector)((0, _selectUnlockedStatus.selectUnlockedStatus));
    const unlockedProfile = unlockedStatus === 'unlockedProfile';
    const selectWallet = (address)=>{
        dispatch((0, _wallet.walletActions).selectWallet(address));
        props.closeHandler();
    };
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    const accounts = Object.values(wallets).map((wallet)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _manageableAccount.ManageableAccount), {
            closeHandler: props.closeHandler,
            editWallet: unlockedProfile ? (name)=>{
                dispatch((0, _wallet.walletActions).setWalletName({
                    address: wallet.address,
                    name
                }));
            } : undefined,
            wallet: wallet,
            deleteWallet: hasOneAccount ? undefined : (address)=>{
                dispatch((0, _wallet.walletActions).deleteWallet(address));
                wallet.address === activeAddress && dispatch((0, _wallet.walletActions).selectFirstWallet());
            },
            selectWallet: selectWallet,
            isActive: wallet.address === activeAddress
        }, wallet.address));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        flex: "grow",
        justify: "between",
        gap: "medium",
        style: {
            height: isMobile ? '0' : 'auto'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scrollableContainer.ScrollableContainer), {
                children: accounts
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                direction: "row",
                justify: "between",
                gap: "medium",
                flex: "grow",
                align: "end",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLink.ButtonLink), {
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _add.Add), {
                            a11yTitle: undefined
                        }),
                        label: t('menu.addAccounts', 'Add accounts'),
                        to: "/",
                        onClick: ()=>props.closeHandler()
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        primary: true,
                        label: t('toolbar.wallets.select', 'Select'),
                        onClick: props.closeHandler
                    })
                ]
            })
        ]
    });
});

},{"react/jsx-runtime":"6pm7f","app/state/wallet":"iYAaC","app/state/wallet/selectors":"cgtJ3","app/state/selectUnlockedStatus":"aRpzm","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","../Account/ManageableAccount":"5rZFQ","../ScrollableContainer":"aqCoJ","../../../ButtonLink":"8j6EN","grommet-icons/es6/icons/Add":"kULLY","grommet/es6/contexts/ResponsiveContext":"7EsNN","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5rZFQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManageableAccount", ()=>ManageableAccount);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _account = require("./Account");
var _manageableAccountDetails = require("./ManageableAccountDetails");
const ManageableAccount = ({ editWallet, closeHandler, wallet, isActive, deleteWallet, selectWallet })=>{
    const [layerVisibility, setLayerVisibility] = (0, _react.useState)(false);
    const handleDelete = deleteWallet ? (address)=>{
        deleteWallet(address);
        setLayerVisibility(false);
    } : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _account.Account), {
                address: wallet.address,
                balance: wallet.balance,
                onClick: selectWallet,
                isActive: isActive,
                path: wallet.path,
                displayBalance: true,
                displayDerivation: {
                    type: wallet.type,
                    pathDisplay: wallet.pathDisplay
                },
                displayManageButton: {
                    onClickManage: ()=>setLayerVisibility(true)
                },
                name: wallet.name
            }),
            layerVisibility && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _manageableAccountDetails.ManageableAccountDetails), {
                closeParentHandler: closeHandler,
                closeHandler: ()=>setLayerVisibility(false),
                deleteAccount: handleDelete,
                editAccount: editWallet,
                wallet: wallet
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","./Account":"72YoH","./ManageableAccountDetails":"6LK8d","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"72YoH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Account", ()=>Account);
var _jsxRuntime = require("react/jsx-runtime");
var _amountFormatter = require("app/components/AmountFormatter");
var _prettyAddress = require("app/components/PrettyAddress");
var _shortAddress = require("app/components/ShortAddress");
var _box = require("grommet/es6/components/Box");
var _checkBox = require("grommet/es6/components/CheckBox");
var _spinner = require("grommet/es6/components/Spinner");
var _text = require("grommet/es6/components/Text");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _button = require("grommet/es6/components/Button");
var _derivationFormatter = require("./DerivationFormatter");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
const StyledManageButton = (0, _styledComponentsDefault.default)((0, _button.Button)).attrs({
    color: {
        light: 'brand',
        dark: 'white'
    },
    size: 'small',
    primary: true,
    hoverIndicator: true
})`
  border-radius: ${({ theme })=>theme.button?.border?.radius};
`;
const Account = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const size = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext));
    const { dark } = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    const address = size === 'small' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shortAddress.ShortAddress), {
        address: props.address
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _prettyAddress.PrettyAddress), {
        address: props.address
    });
    const accountNumber = props.path ? props.path.at(-1) : '?';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        "data-testid": "account-choice",
        round: "5px",
        background: props.isActive ? 'control' : undefined,
        border: {
            color: 'control'
        },
        pad: "small",
        flex: {
            shrink: 0
        },
        role: "checkbox",
        "aria-checked": props.isActive,
        onClick: props.onClick ? ()=>props.onClick(props.address) : undefined,
        hoverIndicator: !props.isActive && {
            color: 'active',
            dark: dark
        },
        direction: "row",
        children: [
            props.displayCheckbox && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                alignSelf: "center",
                pad: {
                    left: 'small',
                    right: 'medium'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkBox.CheckBox), {
                    checked: props.isActive,
                    hidden: true
                })
            }),
            props.displayAccountNumber && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                alignSelf: "center",
                pad: {
                    left: 'small',
                    right: 'small'
                },
                style: {
                    minWidth: '2.5em'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                    weight: "bold",
                    style: {
                        width: '2em'
                    },
                    children: accountNumber
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                fill: "horizontal",
                gap: size === 'small' ? undefined : 'xsmall',
                children: [
                    props.name && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        "data-testid": "account-name",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                            weight: "bold",
                            children: props.name
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                            weight: "bold",
                            children: address
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                        direction: "row",
                        gap: "small",
                        wrap: true,
                        children: [
                            props.displayManageButton && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                direction: "row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledManageButton, {
                                    label: t('toolbar.settings.manageAccount', 'Manage'),
                                    onClick: (e)=>{
                                        // TODO: clicking using Tab + Enter on Manage only triggers parent listener `props.onClick`.
                                        props.displayManageButton?.onClickManage(props.address);
                                        e.stopPropagation();
                                    }
                                })
                            }),
                            props.displayDerivation && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _derivationFormatter.DerivationFormatter), {
                                ...props.displayDerivation
                            }),
                            props.displayBalance && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                height: "24px",
                                margin: {
                                    left: 'auto'
                                },
                                alignSelf: "center",
                                children: props.balance ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                                    amount: props.balance.total
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinner.Spinner), {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
});

},{"react/jsx-runtime":"6pm7f","app/components/AmountFormatter":"dRP3j","app/components/PrettyAddress":"eOPA7","app/components/ShortAddress":"kAiso","grommet/es6/components/Box":"4o01A","grommet/es6/components/CheckBox":"gaRRO","grommet/es6/components/Spinner":"bxfAK","grommet/es6/components/Text":"kz1Ni","grommet/es6/contexts/ResponsiveContext":"7EsNN","react":"8CCva","react-i18next":"7GUHL","grommet/es6/components/Button":"fVON6","./DerivationFormatter":"1hQF9","styled-components":"6bGrk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dRP3j":[function(require,module,exports,__globalThis) {
/**
 *
 * AmountFormatter
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmountFormatter", ()=>AmountFormatter);
var _jsxRuntime = require("react/jsx-runtime");
var _selectors = require("app/state/network/selectors");
var _react = require("react");
var _reactRedux = require("react-redux");
var _box = require("grommet/es6/components/Box");
var _text = require("grommet/es6/components/Text");
var _helpers = require("app/lib/helpers");
var _noTranslate = require("../NoTranslate");
const AmountFormatter = /*#__PURE__*/ (0, _react.memo)(({ amount, amountUnit = 'baseUnits', minimumFractionDigits, maximumFractionDigits, hideTicker, size, smallTicker, plainTicker, isRelative })=>{
    const ticker = (0, _reactRedux.useSelector)((0, _selectors.selectTicker));
    const isUsingBaseUnits = amountUnit === 'baseUnits';
    if (amount == null) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: "-"
    });
    const formatter = isUsingBaseUnits ? (0, _helpers.formatBaseUnitsAsRose) : (0, _helpers.formatWeiAsWrose);
    let amountString = formatter(amount, {
        minimumFractionDigits: minimumFractionDigits ?? 1,
        maximumFractionDigits: maximumFractionDigits ?? (isUsingBaseUnits ? 15 : 18)
    });
    if (isRelative && !amount.startsWith('-')) amountString = `+${amountString}`;
    const tickerProps = smallTicker ? {
        size: 'xsmall',
        weight: 600
    } : {};
    const colorProps = plainTicker ? {} : {
        color: 'ticker'
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                style: {
                    display: 'inline-flex',
                    whiteSpace: 'nowrap',
                    fontFamily: '"Roboto mono", monospace',
                    letterSpacing: 0
                },
                children: amountString
            }),
            !hideTicker && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                size: size,
                ...tickerProps,
                ...colorProps,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noTranslate.NoTranslate), {
                    children: ` ${ticker}`
                })
            })
        ]
    });
});

},{"react/jsx-runtime":"6pm7f","app/state/network/selectors":"2zit7","react":"8CCva","react-redux":"azV3Y","grommet/es6/components/Box":"4o01A","grommet/es6/components/Text":"kz1Ni","app/lib/helpers":"bUnFy","../NoTranslate":"jUKdq","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jUKdq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Disable Google Translate on child element
 * https://cloud.google.com/translate/troubleshooting
 *
 * Main usage is to display generated mnemonic without modifications, and
 * without sending it to Google servers.
 */ parcelHelpers.export(exports, "NoTranslate", ()=>NoTranslate);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
function NoTranslate(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "notranslate",
        translate: "no",
        children: props.children
    });
}

},{"react/jsx-runtime":"6pm7f","react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eOPA7":[function(require,module,exports,__globalThis) {
/**
 *
 * PrettyAddress
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PrettyAddress", ()=>PrettyAddress);
var _jsxRuntime = require("react/jsx-runtime");
var _noTranslate = require("app/components/NoTranslate");
var _helpers = require("app/lib/helpers");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _text = require("grommet/es6/components/Text");
const PrettyAddress = /*#__PURE__*/ (0, _react.memo)((props)=>{
    // Bech32 - 1 is used to split the HRP and the pub key
    if (!props.address || props.address === '') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {});
    if ((0, _helpers.isValidAddress)(props.address)) {
        const parts = props.address.split('1');
        const hrp = parts[0];
        const publicKey = parts[1].match(/.{1,4}/g)?.join(' ');
        const prettyAddress = `${hrp}1 ${publicKey}`;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
            size: "inherit",
            style: {
                fontFamily: '"Roboto mono", monospace',
                letterSpacing: 0
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noTranslate.NoTranslate), {
                children: prettyAddress
            })
        });
    } else throw new Error('Invalid bech32 address');
});

},{"react/jsx-runtime":"6pm7f","app/components/NoTranslate":"jUKdq","app/lib/helpers":"bUnFy","react":"8CCva","grommet/es6/components/Text":"kz1Ni","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kAiso":[function(require,module,exports,__globalThis) {
/**
 *
 * ShortAddress
 *
 * Used to render short address or hash.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ShortAddress", ()=>ShortAddress);
var _jsxRuntime = require("react/jsx-runtime");
var _noTranslate = require("app/components/NoTranslate");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _trimLongString = require("./trimLongString");
function ShortAddress(props) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const short = props.address ? (0, _trimLongString.trimLongString)(props.address) : t('common.unavailable', 'Unavailable');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noTranslate.NoTranslate), {
        children: short
    });
}

},{"react/jsx-runtime":"6pm7f","app/components/NoTranslate":"jUKdq","react":"8CCva","react-i18next":"7GUHL","./trimLongString":"1sxUU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1sxUU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trimLongString", ()=>trimLongString);
function trimLongString(value, trimStart = 10, trimEnd = 8) {
    const trimmedLength = trimStart + 3 + trimEnd;
    if (trimmedLength > value.length) // If the "trimmed" version would be longer, don't bother
    // (This also covers the case when the length is et most trimStart)
    return value;
    return `${value.slice(0, trimStart)}...${value.slice(-trimEnd)}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bxfAK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Spinner", ()=>(0, _spinner.Spinner));
var _spinner = require("./Spinner");

},{"./Spinner":"bQOLm","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bQOLm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Spinner", ()=>Spinner);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _announceContext = require("../../contexts/AnnounceContext");
var _box = require("../Box");
var _propTypes = require("./propTypes");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "ref",
    "size"
], _excluded2 = [
    "children",
    "color",
    "size",
    "message"
], _excluded3 = [
    "size",
    "color",
    "border"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var BasicSpinner = function BasicSpinner(_ref) {
    var ref = _ref.ref, size = _ref.size, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), _extends({
        flex: false,
        height: size,
        width: size,
        ref: ref
    }, rest));
};
/**
 * If the user is calling <Spinner>…</Spinner> with children, it will take
 * precedence over theme styling. Yet, it will still inherit the
 * default animation and size of the spinner, and of course any additional
 * given props.
 *
 * If the user is providing an icon/svg via the theme.spinner.icon,
 * the Spinner will use it as a child and will include all its relevant
 * theme props (size/color/pad…) as well,
 * user will only need to type <Spinner />.
 * If the icon has its own animation, user can turn it off via the theme.
 *
 * If none of the above is provider, <Spinner /> will provide its default
 * border, size and friends, all configurable via theme or props.
 */ var Spinner = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children, colorProp = _ref2.color, size = _ref2.size, message = _ref2.message, rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme;
    var announce = (0, _react.useContext)((0, _announceContext.AnnounceContext));
    (0, _react.useEffect)(function() {
        if (message != null && message.start) announce(message.start);
        else if (typeof message === 'string') announce(message);
        return function() {
            return (message == null ? void 0 : message.end) && announce(message.end);
        };
    }, [
        announce,
        message
    ]);
    // Avoid color and size leaking into the DOM
    var _theme$spinner$contai = theme.spinner.container, sizeThemeProp = _theme$spinner$contai.size, colorThemeProp = _theme$spinner$contai.color, borderThemeProp = _theme$spinner$contai.border, themeProps = _objectWithoutPropertiesLoose(_theme$spinner$contai, _excluded3);
    var normalizedSize = size || sizeThemeProp;
    var spinnerSize = theme.spinner.size[normalizedSize] || normalizedSize;
    var color = colorProp || colorThemeProp;
    var Icon = theme.spinner.icon;
    var defaultBorder = [
        {
            side: 'all',
            color: 'background-contrast',
            size: size
        },
        {
            side: 'top',
            color: color,
            size: size
        }
    ];
    var spinnerBorder = Array.isArray(borderThemeProp) ? borderThemeProp.map(function(borderSide) {
        return _extends({}, borderSide, {
            color: borderSide.side === 'all' ? borderSide.color || 'background-contrast' : color
        });
    }) : borderThemeProp;
    // children will take precedence over theme attributes
    if (children) return /*#__PURE__*/ (0, _reactDefault.default).createElement(BasicSpinner, _extends({
        size: spinnerSize,
        ref: ref
    }, rest), children);
    // In case icon is provided by the theme
    if (Icon) return /*#__PURE__*/ (0, _reactDefault.default).createElement(BasicSpinner, _extends({
        size: spinnerSize,
        ref: ref
    }, themeProps, rest), /*#__PURE__*/ (0, _react.isValidElement)(Icon) ? Icon : /*#__PURE__*/ (0, _reactDefault.default).createElement(Icon, {
        size: spinnerSize,
        color: color
    }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(BasicSpinner, _extends({
        size: spinnerSize,
        ref: ref,
        border: typeof borderThemeProp === 'undefined' ? defaultBorder : spinnerBorder
    }, themeProps, rest));
});
Spinner.displayName = 'Spinner';
Spinner.propTypes = (0, _propTypes.SpinnerPropTypes);

},{"react":"8CCva","../../contexts/AnnounceContext":"fESY4","../Box":"4o01A","./propTypes":"4o60y","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4o60y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SpinnerPropTypes", ()=>SpinnerPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PropType = {};
var SpinnerPropTypes = PropType;

},{"prop-types":"j03Ye","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1hQF9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DerivationFormatter", ()=>DerivationFormatter);
var _jsxRuntime = require("react/jsx-runtime");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _types = require("app/state/wallet/types");
var _box = require("grommet/es6/components/Box");
var _text = require("grommet/es6/components/Text");
var _muiUsbIcon = require("styles/theme/icons/mui-icons/MuiUsbIcon");
var _muiBluetoothIcon = require("styles/theme/icons/mui-icons/MuiBluetoothIcon");
var _muiMarginIcon = require("styles/theme/icons/mui-icons/MuiMarginIcon");
var _muiVpnKeyIcon = require("styles/theme/icons/mui-icons/MuiVpnKeyIcon");
const iconProps = {
    size: '20px',
    color: '#fff'
};
const DerivationFormatter = (props)=>{
    const walletTypes = {
        [(0, _types.WalletType).UsbLedger]: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Circle, {
            color: "#0092F6",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _muiUsbIcon.MuiUsbIcon), {
                ...iconProps
            })
        }),
        [(0, _types.WalletType).BleLedger]: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Circle, {
            color: "#3333c4",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _muiBluetoothIcon.MuiBluetoothIcon), {
                ...iconProps
            })
        }),
        [(0, _types.WalletType).Mnemonic]: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Circle, {
            color: "#6665D8",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _muiMarginIcon.MuiMarginIcon), {
                ...iconProps
            })
        }),
        [(0, _types.WalletType).PrivateKey]: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Circle, {
            color: "#0500E1",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _muiVpnKeyIcon.MuiVpnKeyIcon), {
                ...iconProps
            })
        })
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        align: "center",
        gap: "xsmall",
        direction: "row",
        children: [
            props.type && walletTypes[props.type],
            props.pathDisplay && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _text.Text), {
                size: "small",
                children: [
                    "(",
                    props.pathDisplay,
                    ")"
                ]
            })
        ]
    });
};
const StyledCircle = (0, _styledComponentsDefault.default).div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  min-width: 32px;
  border-radius: 50%;
  background-color: ${(props)=>props.color};
`;
const Circle = ({ color, children })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledCircle, {
        color: color,
        children: children
    });
};

},{"react/jsx-runtime":"6pm7f","styled-components":"6bGrk","app/state/wallet/types":"b0U5N","grommet/es6/components/Box":"4o01A","grommet/es6/components/Text":"kz1Ni","styles/theme/icons/mui-icons/MuiUsbIcon":"11Y6M","styles/theme/icons/mui-icons/MuiBluetoothIcon":"6zCfv","styles/theme/icons/mui-icons/MuiMarginIcon":"4uabk","styles/theme/icons/mui-icons/MuiVpnKeyIcon":"3b1UK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"11Y6M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MuiUsbIcon", ()=>MuiUsbIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _blank = require("grommet-icons/es6/icons/Blank");
const MuiUsbIcon = (props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blank.Blank), {
        "aria-hidden": undefined,
        "aria-label": t('icons.usb', 'Usb'),
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95 0 1.22.99 2.2 2.2 2.2 1.21 0 2.2-.98 2.2-2.2 0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7z"
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react-i18next":"7GUHL","grommet-icons/es6/icons/Blank":"frgvY","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6zCfv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MuiBluetoothIcon", ()=>MuiBluetoothIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _blank = require("grommet-icons/es6/icons/Blank");
const MuiBluetoothIcon = (props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blank.Blank), {
        "aria-hidden": undefined,
        "aria-label": t('icons.bluetooth', 'Bluetooth'),
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M17.71 7.71 12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29zM13 5.83l1.88 1.88L13 9.59zm1.88 10.46L13 18.17v-3.76z"
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react-i18next":"7GUHL","grommet-icons/es6/icons/Blank":"frgvY","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4uabk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MuiMarginIcon", ()=>MuiMarginIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _blank = require("grommet-icons/es6/icons/Blank");
const MuiMarginIcon = (props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blank.Blank), {
        "aria-hidden": undefined,
        "aria-label": t('icons.mnemonic', 'Mnemonic'),
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M3 3v18h18V3zm16 16H5V5h14zM11 7h2v2h-2zM7 7h2v2H7zm8 0h2v2h-2zm-8 4h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react-i18next":"7GUHL","grommet-icons/es6/icons/Blank":"frgvY","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3b1UK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MuiVpnKeyIcon", ()=>MuiVpnKeyIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _blank = require("grommet-icons/es6/icons/Blank");
const MuiVpnKeyIcon = (props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _blank.Blank), {
        "aria-hidden": undefined,
        "aria-label": t('icons.privateKey', 'Private key'),
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2"
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react-i18next":"7GUHL","grommet-icons/es6/icons/Blank":"frgvY","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6LK8d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManageableAccountDetails", ()=>ManageableAccountDetails);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _form = require("grommet/es6/components/Form");
var _formField = require("grommet/es6/components/FormField");
var _tab = require("grommet/es6/components/Tab");
var _tabs = require("grommet/es6/components/Tabs");
var _text = require("grommet/es6/components/Text");
var _textInput = require("grommet/es6/components/TextInput");
var _tip = require("grommet/es6/components/Tip");
var _circleInformation = require("grommet-icons/es6/icons/CircleInformation");
var _reactI18Next = require("react-i18next");
var _types = require("../../../../state/wallet/types");
var _derivationFormatter = require("./DerivationFormatter");
var _addressBox = require("../../../AddressBox");
var _layerContainer = require("./../LayerContainer");
var _deleteAccount = require("./DeleteAccount");
var _privateKeyFormatter = require("../../../PrivateKeyFormatter");
var _revealOverlayButton = require("../../../RevealOverlayButton");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _wallet = require("../../../../state/wallet");
var _reactRedux = require("react-redux");
const StyledForm = (0, _styledComponentsDefault.default)((0, _form.Form))`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
`;
const StyledDeleteButton = (0, _styledComponentsDefault.default)((0, _button.Button)).attrs({
    plain: true,
    color: 'status-error'
})`
  text-align: center;
`;
const ManageableAccountDetails = ({ animation, closeHandler, closeParentHandler, deleteAccount, editAccount, wallet })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [value, setValue] = (0, _react.useState)({
        name: wallet.name || ''
    });
    const [layerVisibility, setLayerVisibility] = (0, _react.useState)(false);
    const [deleteLayerVisibility, setDeleteLayerVisibility] = (0, _react.useState)(false);
    const hideLayer = ()=>{
        setLayerVisibility(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layerContainer.LayerContainer), {
                animation: animation,
                hideLayer: closeHandler,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabs.Tabs), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tab.Tab), {
                        title: t('toolbar.settings.myAccountsTab', 'My Accounts'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledForm, {
                            onSubmit: ({ value })=>{
                                if (!editAccount) return;
                                editAccount(value.name);
                                closeHandler();
                            },
                            value: value,
                            onChange: (nextValue)=>setValue(nextValue),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                                    gap: "medium",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
                                            disabled: !editAccount,
                                            info: !editAccount ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                                                    i18nKey: "toolbar.settings.accountNamingNotAvailable",
                                                    t: t,
                                                    components: {
                                                        OpenWalletButton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                            color: "link",
                                                            onClick: ()=>{
                                                                closeParentHandler ? closeParentHandler() : closeHandler();
                                                                navigate('/open-wallet');
                                                            }
                                                        })
                                                    },
                                                    defaults: "To name your account create a profile while <OpenWalletButton>opening a wallet</OpenWalletButton>."
                                                })
                                            }) : undefined,
                                            name: "name",
                                            validate: (name)=>name.trim().length > 16 ? {
                                                    message: t('toolbar.settings.nameLengthError', 'No more than 16 characters'),
                                                    status: 'error'
                                                } : undefined,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInput.TextInput), {
                                                disabled: !editAccount,
                                                name: "name",
                                                placeholder: t('toolbar.settings.optionalName', 'Name (optional)')
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressBox.AddressBox), {
                                                    address: wallet.address,
                                                    border: true
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                                    size: "small",
                                                    margin: {
                                                        top: 'small'
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _derivationFormatter.DerivationFormatter), {
                                                        pathDisplay: wallet.pathDisplay,
                                                        type: wallet.type
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                                            justify: "between",
                                            direction: "row-responsive",
                                            gap: "large",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                    label: t('toolbar.settings.exportPrivateKey.title', 'Export Private Key'),
                                                    disabled: !wallet.privateKey,
                                                    onClick: ()=>setLayerVisibility(true)
                                                }),
                                                deleteAccount ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDeleteButton, {
                                                    label: t('toolbar.settings.delete.title', 'Delete Account'),
                                                    onClick: ()=>setDeleteLayerVisibility(true)
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tip.Tip), {
                                                    content: t('toolbar.settings.delete.tooltip', 'You must have at least one account at all times.'),
                                                    dropProps: {
                                                        align: {
                                                            bottom: 'top'
                                                        }
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledDeleteButton, {
                                                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _circleInformation.CircleInformation), {
                                                                size: "18px",
                                                                color: "status-error"
                                                            }),
                                                            disabled: true,
                                                            label: t('toolbar.settings.delete.title', 'Delete Account'),
                                                            onClick: ()=>setDeleteLayerVisibility(true)
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                            justify: "between",
                                            direction: "row-responsive",
                                            gap: "large",
                                            children: (wallet.type === (0, _types.WalletType).UsbLedger || wallet.type === (0, _types.WalletType).BleLedger) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                onClick: ()=>dispatch((0, _wallet.walletActions).verifyAddressOnLedger(wallet)),
                                                label: t('ledger.verifyAddressOnLedger', 'Verify address on Ledger')
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                                    direction: "row",
                                    justify: "between",
                                    pad: {
                                        top: 'large'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            secondary: true,
                                            label: t('toolbar.settings.cancel', 'Cancel'),
                                            onClick: closeHandler
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            primary: true,
                                            label: t('toolbar.settings.save', 'Save'),
                                            type: "submit"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            layerVisibility && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layerContainer.LayerContainer), {
                hideLayer: hideLayer,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabs.Tabs), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tab.Tab), {
                        title: t('toolbar.settings.exportPrivateKey.title', 'Export Private Key'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                            flex: "grow",
                            justify: "between",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                                    gap: "medium",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                            children: t('toolbar.settings.exportPrivateKey.hint1', 'The private key consists of a string of characters. Anyone with access to your private key has direct access to the assets of that account.')
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                            children: t('toolbar.settings.exportPrivateKey.hint2', 'If the private key is lost, it cannot be retrieved. Please make sure to backup the private key and keep it in a safe place.')
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _revealOverlayButton.RevealOverlayButton), {
                                            label: t('toolbar.settings.exportPrivateKey.confirm', 'I understand, reveal my private key'),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _privateKeyFormatter.PrivateKeyFormatter), {
                                                privateKey: wallet.privateKey
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                    direction: "row",
                                    justify: "between",
                                    pad: {
                                        top: 'large'
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        secondary: true,
                                        label: t('toolbar.settings.cancel', 'Cancel'),
                                        onClick: hideLayer
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            deleteLayerVisibility && deleteAccount && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteAccount.DeleteAccount), {
                onDelete: ()=>deleteAccount(wallet.address),
                onCancel: ()=>setDeleteLayerVisibility(false),
                wallet: wallet
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-router-dom":"9pTjq","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Form":"kRCRN","grommet/es6/components/FormField":"dcsVI","grommet/es6/components/Tab":"ljnB8","grommet/es6/components/Tabs":"hlkTL","grommet/es6/components/Text":"kz1Ni","grommet/es6/components/TextInput":"cL4wi","grommet/es6/components/Tip":"55RvR","grommet-icons/es6/icons/CircleInformation":"f2FRf","react-i18next":"7GUHL","../../../../state/wallet/types":"b0U5N","./DerivationFormatter":"1hQF9","../../../AddressBox":"70dJ2","./../LayerContainer":"fZ8B7","./DeleteAccount":"gFQZ9","../../../PrivateKeyFormatter":"iwqT0","../../../RevealOverlayButton":"6jvAW","styled-components":"6bGrk","../../../../state/wallet":"iYAaC","react-redux":"azV3Y","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kRCRN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Form", ()=>(0, _form.Form));
parcelHelpers.export(exports, "FormContext", ()=>(0, _formContext.FormContext));
var _form = require("./Form");
var _formContext = require("./FormContext");

},{"./Form":"7HnTU","./FormContext":false,"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7HnTU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Form", ()=>Form);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _contexts = require("../../contexts");
var _messageContext = require("../../contexts/MessageContext");
var _utils = require("../../utils");
var _formContext = require("./FormContext");
var _propTypes = require("./propTypes");
var _excluded = [
    "children",
    "errors",
    "infos",
    "messages",
    "kind",
    "onChange",
    "onReset",
    "onSubmit",
    "onValidate",
    "validate",
    "value"
];
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var defaultValue = {};
var defaultTouched = {};
var defaultValidationResults = {
    errors: {},
    infos: {}
};
var defaultThreshold = 0.5;
var stringToArray = function stringToArray(string) {
    var match = string == null ? void 0 : string.match(/^(.+)\[([0-9]+)\]\.(.*)$/);
    if (match) {
        var arrayName = match[1], indexOfArray = match[2], arrayObjName = match[3];
        return {
            indexOfArray: indexOfArray,
            arrayName: arrayName,
            arrayObjName: arrayObjName
        };
    }
    return undefined;
};
var _getValueAt = function getValueAt(valueObject, pathArg) {
    if (valueObject === undefined) return undefined;
    var path = Array.isArray(pathArg) ? pathArg : pathArg.split('.');
    if (path.length === 1) return valueObject[path];
    return _getValueAt(valueObject[path.shift()], path);
};
var _setValueAt = function setValueAt(valueObject, pathArg, value) {
    var object = valueObject;
    var path = Array.isArray(pathArg) ? pathArg : pathArg.split('.');
    if (path.length === 1) object[path] = value;
    else {
        var key = path.shift();
        if (!object[key]) object[key] = {};
        _setValueAt(object[key], path, value);
    }
};
var getFieldValue = function getFieldValue(name, value) {
    var isArrayField = stringToArray(name);
    if (isArrayField) {
        var _value$arrayName;
        var indexOfArray = isArrayField.indexOfArray, arrayName = isArrayField.arrayName, arrayObjName = isArrayField.arrayObjName;
        var obj = (_value$arrayName = value[arrayName]) == null ? void 0 : _value$arrayName[indexOfArray];
        return arrayObjName ? obj == null ? void 0 : obj[arrayObjName] : obj;
    }
    return _getValueAt(value, name);
};
var setFieldValue = function setFieldValue(name, componentValue, prevValue) {
    var nextValue = _extends({}, prevValue);
    var isArrayField = stringToArray(name);
    if (isArrayField) {
        var indexOfArray = isArrayField.indexOfArray, arrayName = isArrayField.arrayName, arrayObjName = isArrayField.arrayObjName;
        if (!nextValue[arrayName]) nextValue[arrayName] = [];
        if (arrayObjName) {
            var _nextValue$arrayName$;
            if (!nextValue[arrayName][indexOfArray]) nextValue[arrayName][indexOfArray] = (_nextValue$arrayName$ = {}, _nextValue$arrayName$[arrayObjName] = componentValue, _nextValue$arrayName$);
            nextValue[arrayName][indexOfArray][arrayObjName] = componentValue;
        } else nextValue[arrayName][indexOfArray] = componentValue;
    } else _setValueAt(nextValue, name, componentValue);
    return nextValue;
};
var validateCharacterCount = function validateCharacterCount(format, rule, value) {
    var max = rule.max, threshold = rule.threshold;
    var getMessage = function getMessage() {
        var charactersRemaining = function charactersRemaining(plural) {
            return {
                id: "formField.maxCharacters.remaining." + (plural ? 'plural' : 'singular'),
                values: {
                    number: max - value.length
                }
            };
        };
        var charactersOverLimit = function charactersOverLimit(plural) {
            return {
                id: "formField.maxCharacters.overLimit." + (plural ? 'plural' : 'singular'),
                values: {
                    number: value.length - max
                }
            };
        };
        if (max - value.length >= 0) return format(charactersRemaining(max - value.length > 1));
        return format(charactersOverLimit(value.length - max > 1));
    };
    return value.length / max > (threshold != null ? threshold : defaultThreshold) ? {
        status: max - value.length >= 0 ? 'info' : 'error',
        message: getMessage()
    } : undefined;
};
// Apply validation rule to field value and send correct messaging.
var validate = function validate(rule, fieldValue, formValue, format, messages) {
    var result;
    if (typeof rule === 'function') result = rule(fieldValue, formValue);
    else if (rule.regexp) {
        if (!rule.regexp.test(fieldValue)) {
            result = rule.message || format({
                id: 'form.invalid',
                messages: messages
            });
            if (rule.status) result = {
                message: result,
                status: rule.status
            };
        }
    } else if (rule.max) result = validateCharacterCount(format, rule, fieldValue);
    return result;
};
// Validates particular key in formValue
var validateName = function validateName(validationRules, required) {
    return function(name, formValue, format, messages) {
        var fieldValue = getFieldValue(name, formValue);
        var validationResult;
        if (required && // false is for CheckBox
        (fieldValue === undefined || fieldValue === '' || fieldValue === false || Array.isArray(fieldValue) && !fieldValue.length)) validationResult = format({
            id: 'form.required',
            messages: messages
        });
        else if (validationRules) {
            if (Array.isArray(validationRules)) validationRules.some(function(rule) {
                validationResult = validate(rule, fieldValue, formValue, format, messages);
                return !!validationResult;
            });
            else validationResult = validate(validationRules, fieldValue, formValue, format, messages);
        }
        return validationResult;
    };
};
// Validates all keys in formValue
var validateForm = function validateForm(validationRules, formValue, format, messages, omitValid) {
    var nextErrors = {};
    var nextInfos = {};
    validationRules.forEach(function(_ref) {
        var name = _ref[0], _ref$ = _ref[1], field = _ref$.field, input = _ref$.input, validateOn = _ref$.validateOn;
        if (!omitValid) {
            nextErrors[name] = undefined;
            nextInfos[name] = undefined;
        }
        if (!validateOn) return;
        var result;
        if (input) // input() a validation function supplied through useFormInput()
        result = input(name, formValue, format, messages);
        if (field && !result) // field() a validation function supplied through useFormField()
        result = field(name, formValue, format, messages);
        // typeof error === 'object' is implied for both cases of error with
        // a status message and for an error object that is a react node
        if (typeof result === 'object') {
            if (result.status === 'info') nextInfos[name] = result.message;
            else nextErrors[name] = result.message || result; // could be a node
        } else if (typeof result === 'string') nextErrors[name] = result;
    });
    return [
        nextErrors,
        nextInfos
    ];
};
var isInstantValidate = function isInstantValidate(validateOn) {
    return [
        'blur',
        'change'
    ].includes(validateOn);
};
var Form = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref2, ref) {
    var children = _ref2.children, _ref2$errors = _ref2.errors, errorsProp = _ref2$errors === void 0 ? defaultValidationResults.errors : _ref2$errors, _ref2$infos = _ref2.infos, infosProp = _ref2$infos === void 0 ? defaultValidationResults.infos : _ref2$infos, messages = _ref2.messages, kind = _ref2.kind, onChange = _ref2.onChange, _onReset = _ref2.onReset, _onSubmit = _ref2.onSubmit, onValidate = _ref2.onValidate, _ref2$validate = _ref2.validate, validateOnProp = _ref2$validate === void 0 ? 'submit' : _ref2$validate, valueProp = _ref2.value, rest = _objectWithoutPropertiesLoose(_ref2, _excluded);
    var formRef = (0, _utils.useForwardedRef)(ref);
    var _useContext = (0, _react.useContext)((0, _messageContext.MessageContext)), format = _useContext.format;
    var _useState = (0, _react.useState)(valueProp || defaultValue), valueState = _useState[0], setValueState = _useState[1];
    var value = (0, _react.useMemo)(function() {
        return valueProp || valueState;
    }, [
        valueProp,
        valueState
    ]);
    var _useState2 = (0, _react.useState)(defaultTouched), touched = _useState2[0], setTouched = _useState2[1];
    var _useState3 = (0, _react.useState)(validateOnProp), validateOn = _useState3[0], setValidateOn = _useState3[1];
    var _useState4 = (0, _react.useState)({
        errors: errorsProp,
        infos: infosProp
    }), validationResults = _useState4[0], setValidationResults = _useState4[1];
    // maintain a copy of validationResults in a ref for useEffects
    // which can't depend on validationResults directly without
    // causing infinite renders.
    var validationResultsRef = (0, _react.useRef)({});
    // Simulated onMount state. Consider Form to be mounted once it has
    // accounted for values originating from controlled inputs (available
    // at second rendering).
    var _useState5 = (0, _react.useState)('unmounted'), mounted = _useState5[0], setMounted = _useState5[1];
    (0, _react.useEffect)(function() {
        if (!mounted) setMounted('mounting');
        else if (mounted === 'mounting') setMounted('mounted');
    }, [
        mounted
    ]);
    // `pendingValidation` is the name of the FormField awaiting validation.
    var _useState6 = (0, _react.useState)(undefined), pendingValidation = _useState6[0], setPendingValidation = _useState6[1];
    var validationRulesRef = (0, _react.useRef)({});
    var requiredFields = (0, _react.useRef)([]);
    var analyticsRef = (0, _react.useRef)({
        start: new Date(),
        errors: {}
    });
    var sendAnalytics = (0, _contexts.useAnalytics)();
    var buildValid = (0, _react.useCallback)(function(nextErrors) {
        var valid = false;
        valid = requiredFields.current.filter(function(n) {
            return Object.keys(validationRulesRef.current).includes(n);
        }).every(function(field) {
            return value[field] && (value[field] !== '' || value[field] !== false);
        });
        if (Object.keys(nextErrors).length > 0) valid = false;
        return valid;
    }, [
        value
    ]);
    // Only keep validation results for current form fields. In the case of a
    // dynamic form, a field possessing an error may have been removed from the
    // form; need to clean up any previous related validation results.
    var filterRemovedFields = function filterRemovedFields(prevValidations) {
        var nextValidations = prevValidations;
        return Object.keys(nextValidations).filter(function(n) {
            return !validationRulesRef.current[n] || nextValidations[n] === undefined;
        }).forEach(function(n) {
            return delete nextValidations[n];
        });
    };
    var updateAnalytics = function updateAnalytics() {
        var _validationResultsRef;
        var errorFields = Object.keys((_validationResultsRef = validationResultsRef.current) == null ? void 0 : _validationResultsRef.errors);
        var errorCounts = analyticsRef.current.errors;
        if (errorFields.length > 0) errorFields.forEach(function(key) {
            errorCounts[key] = (errorCounts[key] || 0) + 1;
        });
    };
    var applyValidationRules = (0, _react.useCallback)(function(validationRules) {
        var _validateForm = validateForm(validationRules, value, format, messages), validatedErrors = _validateForm[0], validatedInfos = _validateForm[1];
        setValidationResults(function(prevValidationResults) {
            // Keep any previous errors and infos for untouched keys,
            // these may have come from a Submit.
            var nextErrors = _extends({}, prevValidationResults.errors, validatedErrors);
            var nextInfos = _extends({}, prevValidationResults.infos, validatedInfos);
            // Remove previous errors and infos for keys no longer in the
            // form, these may have been fields removed from a dynamic form.
            filterRemovedFields(nextErrors);
            filterRemovedFields(nextInfos);
            var nextValidationResults = {
                errors: nextErrors,
                infos: nextInfos
            };
            if (onValidate) onValidate(_extends({}, nextValidationResults, {
                valid: buildValid(nextErrors)
            }));
            validationResultsRef.current = nextValidationResults;
            updateAnalytics();
            return nextValidationResults;
        });
    }, [
        buildValid,
        format,
        messages,
        onValidate,
        value
    ]);
    // Validate all fields holding values onMount if set to
    // validate when blur or change.
    (0, _react.useEffect)(function() {
        var validationRules = Object.entries(validationRulesRef.current);
        // Use simulated onMount state to account for values provided by
        // controlled inputs.
        if (mounted !== 'mounted' && (isInstantValidate(validateOn) || validationRules.some(function(_ref3) {
            var v = _ref3[1];
            return isInstantValidate(v.validateOn);
        })) && Object.keys(value).length > 0 && Object.keys(touched).length === 0) applyValidationRules(validationRules.filter(function(_ref4) {
            var n = _ref4[0], v = _ref4[1];
            return getFieldValue(n, value) && v.validateOn;
        })// Exlude empty arrays which may be initial values in
        // an input such as DateInput.
        .filter(function(_ref5) {
            var n = _ref5[0];
            return !(Array.isArray(getFieldValue(n, value)) && getFieldValue(n, value).length === 0);
        }));
    }, [
        applyValidationRules,
        mounted,
        touched,
        validateOn,
        value
    ]);
    // Run validation against fields with pendingValidations from onBlur
    // and/or onChange.
    (0, _react.useEffect)(function() {
        var validationRules = Object.entries(validationRulesRef.current);
        var timer = setTimeout(function() {
            if (pendingValidation && (isInstantValidate(validateOn) || validationRules.some(function(_ref6) {
                var v = _ref6[1];
                return isInstantValidate(v.validateOn);
            }))) {
                applyValidationRules(validationRules.filter(function(_ref7) {
                    var n = _ref7[0], v = _ref7[1];
                    return (touched[n] || pendingValidation.includes(n)) && v.validateOn;
                }));
                setPendingValidation(undefined);
            }
        // Complete any potential click events before running onBlur validation.
        // Otherwise, click events like reset, etc. may not be registered. For a
        // detailed scenario/discussion, see: https://github.com/grommet/grommet/issues/4863
        // Values empirically tested; 120 was selected because it is the largest
        // Chrome: 100, Safari: 120, Firefox: 80
        }, 120);
        return function() {
            return clearTimeout(timer);
        };
    }, [
        applyValidationRules,
        pendingValidation,
        touched,
        validateOn
    ]);
    // Re-run validation rules for all fields with prior errors.
    // if validate=blur this helps re-validate if there are errors
    // as the user fixes them (basically act like validate=change for that)
    (0, _react.useEffect)(function() {
        var _validationResultsRef2;
        var validationRules = Object.entries(validationRulesRef.current);
        if ((_validationResultsRef2 = validationResultsRef.current) != null && _validationResultsRef2.errors && Object.keys(validationResultsRef.current.errors).length > 0) applyValidationRules(validationRules.filter(function(_ref8) {
            var n = _ref8[0];
            return touched[n] && validationResultsRef.current.errors[n];
        }));
    }, [
        applyValidationRules,
        touched
    ]);
    (0, _react.useEffect)(function() {
        var element = formRef.current;
        analyticsRef.current = {
            start: new Date(),
            errors: {}
        };
        sendAnalytics({
            type: 'formOpen',
            element: element
        });
        return function() {
            if (!analyticsRef.current.submitted) sendAnalytics({
                type: 'formClose',
                element: element,
                errors: analyticsRef.current.errors,
                elapsed: new Date().getTime() - analyticsRef.current.start.getTime()
            });
        };
    }, [
        sendAnalytics,
        formRef
    ]);
    // There are three basic patterns of handling form input value state:
    //
    // 1 - form controlled
    //
    // In this model, the caller sets `value` and `onChange` properties
    // on the Form component to supply the values used by the input fields.
    // In useFormContext(), componentValue would be undefined and formValue
    // is be set to whatever the form state has. Whenever the form state
    // changes, we update the contextValue so the input component will use
    // that. When the input component changes, we will call update() to
    // update the form state.
    //
    // 2 - input controlled
    //
    // In this model, the caller sets `value` and `onChange` properties
    // on the input components, like TextInput, to supply the value for it.
    // In useFormContext(), componentValue is this value and we ensure to
    // update the form state, via update(), and set the contextValue from
    // the componentValue. When the input component changes, we will
    // call update() to update the form state.
    //
    // 3 - uncontrolled
    //
    // In this model, the caller doesn't set a `value` or `onChange` property
    // at either the form or input component levels.
    // In useFormContext(), componentValue is undefined and valueProp is
    // undefined and nothing much happens here. That is, unless the
    // calling component needs to know the state in order to work, such
    // as CheckBox or Select. In this case, those components supply
    // an initialValue, which will trigger updating the contextValue so
    // they can have access to it.
    //
    var formContextValue = (0, _react.useMemo)(function() {
        var useFormInput = function useFormInput(_ref9) {
            var name = _ref9.name, componentValue = _ref9.value, initialValue = _ref9.initialValue, validateArg = _ref9.validate;
            var _useState7 = (0, _react.useState)(initialValue), inputValue = _useState7[0], setInputValue = _useState7[1];
            var formValue = name ? getFieldValue(name, value) : undefined;
            // for dynamic forms, we need to track when an input has been added to
            // the form value. if the input is unmounted, we will delete its
            // key/value from the form value.
            var keyCreated = (0, _react.useRef)(false);
            // This effect is for pattern #2, where the controlled input
            // component is driving the value via componentValue.
            (0, _react.useEffect)(function() {
                if (name && // we have somewhere to put this
                componentValue !== undefined && // input driving
                (Array.isArray(componentValue) && Array.isArray(formValue) ? componentValue.toString() !== formValue.toString() : componentValue !== formValue // don't already have it
                )) setValueState(function(prevValue) {
                    return setFieldValue(name, componentValue, prevValue);
                });
            }, [
                componentValue,
                formValue,
                name
            ]);
            // on unmount, if the form is uncontrolled, remove the key/value
            // from the form value
            (0, _react.useEffect)(function() {
                return function() {
                    if (keyCreated.current) {
                        keyCreated.current = false;
                        setValueState(function(prevValue) {
                            var nextValue = _extends({}, prevValue);
                            var isArrayField = stringToArray(name);
                            if (isArrayField) {
                                var arrayName = isArrayField.arrayName;
                                delete nextValue[arrayName];
                            } else delete nextValue[name];
                            return nextValue;
                        });
                    }
                };
            }, // eslint-disable-next-line react-hooks/exhaustive-deps
            [] // only run onmount and unmount
            );
            // Create validation rules for fields
            (0, _react.useEffect)(function() {
                if (validateArg) {
                    if (!validationRulesRef.current[name]) validationRulesRef.current[name] = {};
                    validationRulesRef.current[name].input = validateName(validateArg);
                    return function() {
                        return delete validationRulesRef.current[name].input;
                    };
                }
                return undefined;
            }, [
                validateArg,
                name
            ]);
            var useValue;
            if (componentValue !== undefined) // input component drives, pattern #2
            useValue = componentValue;
            else if (valueProp && name && formValue !== undefined) // form drives, pattern #1
            useValue = formValue;
            else if (formValue === undefined && name) // form has reset, so reset input value as well
            useValue = initialValue;
            else useValue = inputValue;
            return [
                useValue,
                function(nextComponentValue) {
                    if (name) {
                        // we have somewhere to put this
                        var nextTouched = _extends({}, touched);
                        nextTouched[name] = true;
                        if (!touched[name]) // don't update if not needed
                        setTouched(nextTouched);
                        // if nextValue doesn't have a key for name, this must be
                        // uncontrolled form. we will flag this field was added so
                        // we know to remove its value from the form if it is dynamically
                        // removed
                        if (!(name in value)) keyCreated.current = true;
                        var nextValue = setFieldValue(name, nextComponentValue, value);
                        setValueState(nextValue);
                        if (onChange) onChange(nextValue, {
                            touched: nextTouched
                        });
                    }
                    if (initialValue !== undefined) setInputValue(nextComponentValue);
                }
            ];
        };
        var useFormField = function useFormField(_ref10) {
            var errorArg = _ref10.error, infoArg = _ref10.info, name = _ref10.name, required = _ref10.required, disabled = _ref10.disabled, validateArg = _ref10.validate, validateOnArg = _ref10.validateOn;
            var error = disabled ? undefined : errorArg || validationResults.errors[name];
            var info = infoArg || validationResults.infos[name];
            (0, _react.useEffect)(function() {
                setValidateOn(function(prevValues) {
                    var _extends2;
                    if (typeof prevValues === 'string') {
                        var _ref11;
                        return _ref11 = {}, _ref11[name] = validateOnArg || validateOnProp, _ref11;
                    }
                    return _extends({}, prevValues, (_extends2 = {}, _extends2[name] = validateOnArg || validateOnProp, _extends2));
                });
            }, [
                validateOnArg,
                name
            ]);
            // Create validation rules for field
            (0, _react.useEffect)(function() {
                var index = requiredFields.current.indexOf(name);
                if (required) {
                    if (index === -1) requiredFields.current.push(name);
                } else if (index !== -1) requiredFields.current.splice(index, 1);
                if (validateArg || required) {
                    if (!validationRulesRef.current[name]) validationRulesRef.current[name] = {};
                    validationRulesRef.current[name].field = validateName(validateArg, required);
                    // priority is given to validateOn prop on formField, if it is
                    // undefined, then we will use the validate prop value of Form.
                    // The reason we don't want to add validateOn = "submit" here is
                    // because we don't want to trigger validation of "submit" field
                    // when the user is typing in the instant (blur, change)
                    // validation fields.
                    if (validateOnArg && validateOnArg !== 'submit') validationRulesRef.current[name].validateOn = validateOnArg;
                    else if (!validateOnArg && validateOnProp !== 'submit') validationRulesRef.current[name].validateOn = validateOnProp;
                    return function() {
                        delete validationRulesRef.current[name].field;
                        delete validationRulesRef.current[name].validateOn;
                        var requiredFieldIndex = requiredFields.current.indexOf(name);
                        if (requiredFieldIndex !== -1) requiredFields.current.splice(requiredFieldIndex, 1);
                    };
                }
                return undefined;
            }, [
                error,
                name,
                required,
                validateArg,
                disabled,
                validateOnArg
            ]);
            return {
                error: error,
                info: info,
                inForm: true,
                onBlur: validateOnArg === 'blur' || validateOn[name] === 'blur' ? function() {
                    return setPendingValidation(pendingValidation ? [].concat(pendingValidation, [
                        name
                    ]) : [
                        name
                    ]);
                } : undefined,
                onChange: validateOnArg === 'change' || validateOn[name] === 'change' ? function() {
                    return setPendingValidation(pendingValidation ? [].concat(pendingValidation, [
                        name
                    ]) : [
                        name
                    ]);
                } : undefined
            };
        };
        return {
            useFormField: useFormField,
            useFormInput: useFormInput,
            kind: kind
        };
    }, [
        onChange,
        kind,
        pendingValidation,
        touched,
        validateOn,
        validationResults.errors,
        validationResults.infos,
        value,
        valueProp,
        validateOnProp
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("form", _extends({
        ref: formRef
    }, rest, {
        onReset: function onReset(event) {
            sendAnalytics({
                type: 'formReset',
                element: formRef.current,
                data: event,
                errors: analyticsRef.current.errors,
                elapsed: new Date().getTime() - analyticsRef.current.start.getTime()
            });
            setPendingValidation(undefined);
            if (!valueProp) {
                setValueState(defaultValue);
                if (onChange) onChange(defaultValue, {
                    touched: defaultTouched
                });
            }
            setTouched(defaultTouched);
            setValidationResults(defaultValidationResults);
            analyticsRef.current = {
                start: new Date(),
                errors: {}
            };
            if (_onReset) {
                event.persist(); // extract from React's synthetic event pool
                var adjustedEvent = event;
                adjustedEvent.value = defaultValue;
                _onReset(adjustedEvent);
            }
        },
        onSubmit: function onSubmit(event) {
            // Don't submit the form via browser form action. We don't want it
            // if the validation fails. And, we assume a javascript action handler
            // otherwise.
            event.preventDefault();
            // Prevent any "outer" forms from performing `onSubmit`.
            // Nesting forms is not recommended in HTML. However, with React
            // portals, if the portal (such as Grommet's Layer) contains a form
            // and is nested within another form in the React tree, the event
            // bubbles up to the "outer" form even though in the DOM the portal
            // doesn't render as child of the "outer" form.
            // https://legacy.reactjs.org/docs/portals.html#event-bubbling-through-portals
            if (formRef.current && (event.target === formRef.current || event.target.form === formRef.current)) {
                setPendingValidation(undefined);
                // adding validateOn: "submit" prop to the undefined validateOn
                // fields as we want to trigger "submit" validation once form
                // is submitted
                var newValidationRulesRef = Object.keys(validationRulesRef.current).reduce(function(acc, key) {
                    acc[key] = validationRulesRef.current[key];
                    if (!acc[key].validateOn) acc[key] = _extends({}, validationRulesRef.current[key], {
                        validateOn: 'submit'
                    });
                    return acc;
                }, {});
                var _validateForm2 = validateForm(Object.entries(newValidationRulesRef), value, format, messages, true), nextErrors = _validateForm2[0], nextInfos = _validateForm2[1];
                setValidationResults(function() {
                    var nextValidationResults = {
                        errors: nextErrors,
                        infos: nextInfos,
                        // Show form's validity when clicking on Submit
                        valid: buildValid(nextErrors)
                    };
                    if (onValidate) onValidate(nextValidationResults);
                    validationResultsRef.current = nextValidationResults;
                    updateAnalytics();
                    return nextValidationResults;
                });
                if (Object.keys(nextErrors).length === 0 && _onSubmit) {
                    event.persist(); // extract from React's synthetic event pool
                    var adjustedEvent = event;
                    adjustedEvent.value = value;
                    adjustedEvent.touched = touched;
                    _onSubmit(adjustedEvent);
                    sendAnalytics({
                        type: 'formSubmit',
                        element: formRef.current,
                        data: adjustedEvent,
                        errors: analyticsRef.current.errors,
                        elapsed: new Date().getTime() - analyticsRef.current.start.getTime()
                    });
                    analyticsRef.current.errors = {};
                    analyticsRef.current.submitted = true;
                }
            }
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _formContext.FormContext).Provider, {
        value: formContextValue
    }, children));
});
Form.displayName = 'Form';
Form.propTypes = (0, _propTypes.FormPropTypes);

},{"react":"8CCva","../../contexts":"8InEz","../../contexts/MessageContext":"9V5sq","../../utils":"fx31z","./FormContext":"ky7Rv","./propTypes":"gdSAH","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gdSAH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormPropTypes", ()=>FormPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PropType = {};
var FormPropTypes = PropType;

},{"prop-types":"j03Ye","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ljnB8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tab", ()=>(0, _tab.Tab));
var _tab = require("./Tab");

},{"./Tab":"fRBGe","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fRBGe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tab", ()=>Tab);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("../Button");
var _text = require("../Text");
var _tabsContext = require("../Tabs/TabsContext");
var _utils = require("../../utils");
var _styledTab = require("./StyledTab");
var _propTypes = require("./propTypes");
var _useIsomorphicLayoutEffect = require("../../utils/use-isomorphic-layout-effect");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "active",
    "disabled",
    "children",
    "icon",
    "plain",
    "title",
    "onBlur",
    "onFocus",
    "onMouseOver",
    "onMouseOut",
    "reverse",
    "onClick"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var Tab = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var activeProp = _ref.active, disabled = _ref.disabled, children = _ref.children, icon = _ref.icon, plain = _ref.plain, title = _ref.title, _onBlur = _ref.onBlur, _onFocus = _ref.onFocus, onMouseOver = _ref.onMouseOver, onMouseOut = _ref.onMouseOut, reverse = _ref.reverse, onClick = _ref.onClick, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useContext = (0, _react.useContext)((0, _tabsContext.TabsContext)), active = _useContext.active, activeIndex = _useContext.activeIndex, index = _useContext.index, tabsContextRef = _useContext.ref, onActivate = _useContext.onActivate, setActiveContent = _useContext.setActiveContent, setActiveTitle = _useContext.setActiveTitle, setFocusIndex = _useContext.setFocusIndex;
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme, passThemeFlag = _useThemeValue1.passThemeFlag;
    var _useState = (0, _react.useState)(undefined), over = _useState[0], setOver = _useState[1];
    var normalizedTitle = title;
    var tabStyles = {};
    var tabRef = (0, _utils.useForwardedRef)(ref);
    (0, _useIsomorphicLayoutEffect.useLayoutEffect)(function() {
        if (tabRef.current && tabsContextRef) tabsContextRef.current = tabRef.current;
    });
    (0, _react.useEffect)(function() {
        if (active) {
            setActiveContent(children);
            var activeTitle = typeof title === 'string' ? title : activeIndex + 1;
            setActiveTitle(activeTitle);
        }
    }, [
        active,
        activeIndex,
        children,
        setActiveContent,
        setActiveTitle,
        title
    ]);
    var onMouseOverTab = function onMouseOverTab(event) {
        setOver(true);
        if (onMouseOver) onMouseOver(event);
    };
    var onMouseOutTab = function onMouseOutTab(event) {
        setOver(undefined);
        if (onMouseOut) onMouseOut(event);
    };
    if (!plain) {
        if (typeof title !== 'string') normalizedTitle = title;
        else if (active) normalizedTitle = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), theme.tab.active, title);
        else if (disabled && theme.tab.disabled) normalizedTitle = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), theme.tab.disabled, title);
        else normalizedTitle = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            color: over ? theme.tab.hover.color : theme.tab.color
        }, title);
    }
    var onClickTab = function onClickTab(event) {
        if (event) event.preventDefault();
        onActivate();
        if (onClick) onClick(event);
    };
    if (active && disabled) console.warn("Warning: Tab props 'active' and 'disabled' have both been set to TRUE on the same Tab resulting in an interesting Tab state. Is this your intent?");
    if (!plain) {
        if (typeof title !== 'string') normalizedTitle = title;
        else if (active) normalizedTitle = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), theme.tab.active, title);
        else if (disabled && theme.tab.disabled) normalizedTitle = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), theme.tab.disabled, title);
        else normalizedTitle = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
            color: over ? theme.tab.hover.color : theme.tab.color
        }, title);
        if (theme.tab.border) {
            var borderColor = theme.tab.border.color || theme.global.control.border.color;
            if (active) borderColor = theme.tab.border.active.color || borderColor;
            else if (disabled && theme.tab.border.disabled) borderColor = theme.tab.border.disabled.color || borderColor;
            else if (over) borderColor = theme.tab.border.hover.color || borderColor;
            borderColor = (0, _utils.normalizeColor)(borderColor, theme);
            tabStyles.border = {
                side: theme.tab.border.side,
                size: theme.tab.border.size,
                color: borderColor
            };
        }
        tabStyles.background = active ? theme.tab.active.background || theme.tab.background : theme.tab.background;
        tabStyles.pad = theme.tab.pad;
        tabStyles.margin = theme.tab.margin;
    }
    // needed to apply hover/active styles to the icon
    var renderIcon = function renderIcon(iconProp) {
        if (active) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(iconProp, _extends({}, theme.tab.active));
        if (disabled) return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(iconProp, _extends({}, theme.tab.disabled));
        return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(iconProp, {
            color: over ? theme.tab.hover.color : theme.tab.color
        });
    };
    var normalizedIcon;
    if (icon) normalizedIcon = renderIcon(icon);
    var first = reverse ? normalizedTitle : normalizedIcon;
    var second = reverse ? normalizedIcon : normalizedTitle;
    var withIconStyles;
    if (first && second) withIconStyles = {
        direction: 'row',
        align: 'center',
        justify: 'center',
        gap: 'small'
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), _extends({
        ref: tabRef,
        plain: true,
        role: "tab",
        "aria-selected": active,
        "aria-expanded": active,
        disabled: disabled
    }, rest, {
        onClick: onClickTab,
        onMouseOver: onMouseOverTab,
        onMouseOut: onMouseOutTab,
        onFocus: function onFocus() {
            if (_onFocus) _onFocus();
            setFocusIndex(index);
        },
        onBlur: function onBlur() {
            if (_onBlur) _onBlur();
            setFocusIndex(-1);
        }
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledTab.StyledTab), _extends({
        disabled: disabled,
        plain: plain
    }, withIconStyles, tabStyles, passThemeFlag), first, second));
});
Tab.displayName = 'Tab';
Tab.propTypes = (0, _propTypes.TabPropTypes);

},{"react":"8CCva","../Button":"fVON6","../Text":"kz1Ni","../Tabs/TabsContext":"h4hPc","../../utils":"fx31z","./StyledTab":"5WIeZ","./propTypes":"1fC6r","../../utils/use-isomorphic-layout-effect":"jThNw","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"h4hPc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabsContext", ()=>TabsContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var TabsContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({});

},{"react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5WIeZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledTab", ()=>StyledTab);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _box = require("../Box");
var _utils = require("../../utils");
var tabHoverStyle = (0, _styledComponents.css)([
    "&:hover{",
    " ",
    " ",
    ";}&:focus{z-index:1;}"
], function(props) {
    return props.theme.tab.hover.background && (0, _styledComponents.css)([
        "background:",
        ";"
    ], (0, _utils.normalizeColor)(props.theme.tab.hover.background, props.theme));
}, function(props) {
    return props.theme.tab.hover.color && (0, _styledComponents.css)([
        "color:",
        ";"
    ], (0, _utils.normalizeColor)(props.theme.tab.hover.color, props.theme));
}, function(props) {
    return props.theme.tab.hover.extend;
});
var StyledTab = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "StyledTab",
    componentId: "sc-1nnwnsb-0"
})([
    "white-space:nowrap;",
    " ",
    " ",
    " ",
    ""
], (0, _utils.genericStyles), function(props) {
    return !props.plain && !props.disabled && props.theme.tab.hover && tabHoverStyle;
}, function(props) {
    return props.disabled && props.theme.tab.disabled;
}, function(props) {
    return props.theme.tab.extend;
});

},{"styled-components":"6bGrk","../Box":"4o01A","../../utils":"fx31z","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1fC6r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabPropTypes", ()=>TabPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PropType = {};
var TabPropTypes = PropType;

},{"prop-types":"j03Ye","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hlkTL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tabs", ()=>(0, _tabs.Tabs));
var _tabs = require("./Tabs");

},{"./Tabs":"aBrM8","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aBrM8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tabs", ()=>Tabs);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _previous = require("grommet-icons/icons/Previous");
var _next = require("grommet-icons/icons/Next");
var _useIsomorphicLayoutEffect = require("../../utils/use-isomorphic-layout-effect");
var _box = require("../Box");
var _button = require("../Button");
var _tabsContext = require("./TabsContext");
var _responsiveContext = require("../../contexts/ResponsiveContext");
var _styledTabs = require("./StyledTabs");
var _utils = require("../../utils");
var _messageContext = require("../../contexts/MessageContext");
var _propTypes = require("./propTypes");
var _analyticsContext = require("../../contexts/AnalyticsContext/AnalyticsContext");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "alignControls",
    "children",
    "flex",
    "justify",
    "messages",
    "responsive"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var Tabs = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var _theme$tabs$header;
    var alignControls = _ref.alignControls, children = _ref.children, flex = _ref.flex, _ref$justify = _ref.justify, justify = _ref$justify === void 0 ? 'center' : _ref$justify, messages = _ref.messages, _ref$responsive = _ref.responsive, responsive = _ref$responsive === void 0 ? true : _ref$responsive, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme, passThemeFlag = _useThemeValue1.passThemeFlag;
    var _useContext = (0, _react.useContext)((0, _messageContext.MessageContext)), format = _useContext.format;
    var propsActiveIndex = rest.activeIndex, onActive = rest.onActive;
    var _useState = (0, _react.useState)(rest.activeIndex || 0), activeIndex = _useState[0], setActiveIndex = _useState[1];
    var _useState2 = (0, _react.useState)(), activeContent = _useState2[0], setActiveContent = _useState2[1];
    var _useState3 = (0, _react.useState)(), activeTitle = _useState3[0], setActiveTitle = _useState3[1];
    var _useState4 = (0, _react.useState)(), disableLeftArrow = _useState4[0], setDisableLeftArrow = _useState4[1];
    var _useState5 = (0, _react.useState)(), disableRightArrow = _useState5[0], setDisableRightArrow = _useState5[1];
    var _useState6 = (0, _react.useState)(), overflow = _useState6[0], setOverflow = _useState6[1];
    var _useState7 = (0, _react.useState)(-1), focusIndex = _useState7[0], setFocusIndex = _useState7[1];
    var headerRef = (0, _react.useRef)();
    var size = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext));
    var sendAnalytics = (0, _analyticsContext.useAnalytics)();
    if (activeIndex !== propsActiveIndex && propsActiveIndex !== undefined) setActiveIndex(propsActiveIndex);
    // Safari v15.5 has an issue with scrolling when overflow='hidden'
    // and scroll-behavior='smooth'. For now we are detecting if the browser
    // is safari to workaround this issue. The issue should be resolved soon
    // and we can remove this. https://github.com/WebKit/WebKit/pull/1387
    var isSafari = typeof window !== 'undefined' ? /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent) : true;
    /* eslint-disable no-param-reassign */ delete rest.activeIndex;
    delete rest.onActive;
    /* eslint-enable no-param-reassign */ var tabRefs = (0, _react.useMemo)(function() {
        return (0, _reactDefault.default).Children.map(children, function() {
            return /*#__PURE__*/ (0, _reactDefault.default).createRef();
        });
    }, [
        children
    ]);
    // check if tab is in view
    var isVisible = (0, _react.useCallback)(function(index) {
        if (tabRefs[index].current) {
            var _headerRef$current;
            var tabRect = tabRefs[index].current.getBoundingClientRect();
            var headerRect = (_headerRef$current = headerRef.current) == null ? void 0 : _headerRef$current.getBoundingClientRect();
            if (tabRect && headerRect) // the -1 and +1 allow a little leniency when calculating if a tab
            // is in view. Without the -1 and +1 a tab could be fully in view
            // but isVisible will return false.
            return tabRect.left >= headerRect.left - 1 && tabRect.right <= headerRect.right + 1;
        }
        return undefined;
    }, [
        headerRef,
        tabRefs
    ]);
    var updateArrowState = (0, _react.useCallback)(function() {
        setDisableLeftArrow(isVisible(0));
        setDisableRightArrow(isVisible(tabRefs.length - 1));
    }, [
        tabRefs,
        isVisible
    ]);
    var scrollTo = (0, _react.useCallback)(function(index, keyboard) {
        var tabRect = tabRefs[index].current.getBoundingClientRect();
        var headerRect = headerRef.current.getBoundingClientRect();
        var amountHidden = 0;
        if (tabRect.left >= headerRect.left && tabRect.left <= headerRect.right) amountHidden = tabRect.width - (headerRect.right - tabRect.left);
        else if (tabRect.right >= headerRect.left && tabRect.right <= headerRect.right) {
            amountHidden = tabRect.width - (tabRect.right - headerRect.left);
            amountHidden = 0 - amountHidden;
        } else if (tabRect.left >= headerRect.right) amountHidden = tabRect.right - headerRect.right;
        else if (tabRect.right <= headerRect.left) {
            amountHidden = headerRect.left - tabRect.left;
            amountHidden = 0 - amountHidden;
        }
        // We are adding or subtracting 2 from amountHidden to
        // ensure the focusIndicator is visible when navigating
        // by keyboard
        if (keyboard) {
            if (amountHidden < 0) amountHidden -= 2;
            if (amountHidden > 0) amountHidden += 2;
        }
        if (isSafari) headerRef.current.scrollBy({
            left: amountHidden
        });
        else headerRef.current.scrollBy({
            left: amountHidden,
            behavior: 'smooth'
        });
        // wait for scroll animation to finish
        // checks every 50 milliseconds for 1000 milliseconds
        // if the scroll animation has finished. Most scroll
        // animations will finish in 1000 milliseconds unless
        // the tab name is very long.
        if (isSafari) updateArrowState();
        else {
            var checkVisible = setInterval(function() {
                if (tabRefs[index].current && isVisible(index)) {
                    updateArrowState();
                    clearInterval(checkVisible);
                }
            }, 50);
            setTimeout(function() {
                updateArrowState();
                clearInterval(checkVisible);
            }, 1000);
        }
    }, [
        tabRefs,
        headerRef,
        isVisible,
        updateArrowState,
        isSafari
    ]);
    var moveByArrowKey = function moveByArrowKey(direction) {
        var previous = direction === 'previous';
        var index = direction === 'previous' ? 0 : tabRefs.length - 1;
        var scrolledToIndex;
        var moveBy = theme.tabs.step[size] - 1 || 0;
        while(scrolledToIndex === undefined && (previous && index < tabRefs.length - 1 || !previous && index > 0)){
            if (!isVisible(index) && (previous && isVisible(index + 1) || !previous && isVisible(index - 1))) {
                if (previous) {
                    if (index - moveBy >= 0) {
                        scrollTo(index - moveBy, false);
                        scrolledToIndex = index - moveBy;
                    } else {
                        scrollTo(0, false);
                        scrolledToIndex = 0;
                    }
                } else if (index + moveBy < tabRefs.length) {
                    scrollTo(index + moveBy, false);
                    scrolledToIndex = index + moveBy;
                } else {
                    scrollTo(tabRefs.length - 1, false);
                    scrolledToIndex = tabRefs.length - 1;
                }
            }
            index = previous ? index + 1 : index - 1;
        }
    };
    (0, _react.useEffect)(function() {
        var _tabRefs$activeIndex;
        // if the active tab isn't visible scroll to it
        if (overflow && tabRefs && (_tabRefs$activeIndex = tabRefs[activeIndex]) != null && _tabRefs$activeIndex.current && !isVisible(activeIndex)) scrollTo(activeIndex, true);
    }, [
        overflow,
        activeIndex,
        tabRefs,
        isVisible,
        scrollTo
    ]);
    (0, _react.useEffect)(function() {
        // scroll focus item into view if it is not already visible
        if (overflow && focusIndex !== -1 && !isVisible(focusIndex)) scrollTo(focusIndex, true);
        else if (overflow && focusIndex !== -1) {
            // If the browser scrolled the focused item into view and
            // the focusedTab is on the edge of the header container
            // scroll slightly further to show the focusIndicator
            var tabRect = tabRefs[focusIndex].current.getBoundingClientRect();
            var headerRect = headerRef.current.getBoundingClientRect();
            var amountHidden = 0;
            if (tabRect.left >= headerRect.left && tabRect.right <= headerRect.right && tabRect.right + 2 >= headerRect.right) amountHidden = 2;
            else if (tabRect.right <= headerRect.right && tabRect.left >= headerRect.left && tabRect.left - 2 <= headerRect.left) amountHidden = -2;
            headerRef.current.scrollBy({
                left: amountHidden
            });
        }
    }, [
        overflow,
        tabRefs,
        focusIndex,
        isVisible,
        scrollTo
    ]);
    (0, _useIsomorphicLayoutEffect.useLayoutEffect)(function() {
        var onResize = function onResize() {
            // check if tabs are overflowing
            if (headerRef.current.scrollWidth > headerRef.current.offsetWidth) setOverflow(true);
            else setOverflow(false);
            updateArrowState();
        };
        onResize();
        window.addEventListener('resize', onResize);
        return function() {
            return window.removeEventListener('resize', onResize);
        };
    }, [
        tabRefs,
        disableLeftArrow,
        disableRightArrow,
        activeIndex,
        headerRef,
        overflow,
        updateArrowState
    ]);
    var getTabsContext = (0, _react.useCallback)(function(index) {
        var activateTab = function activateTab(nextIndex) {
            sendAnalytics({
                type: 'activateTab',
                element: tabRefs[nextIndex].current
            });
            if (propsActiveIndex === undefined) setActiveIndex(nextIndex);
            if (onActive) onActive(nextIndex);
        };
        return {
            activeIndex: activeIndex,
            active: activeIndex === index,
            index: index,
            ref: tabRefs[index],
            onActivate: function onActivate() {
                return activateTab(index);
            },
            setActiveContent: setActiveContent,
            setActiveTitle: setActiveTitle,
            setFocusIndex: setFocusIndex
        };
    }, [
        activeIndex,
        onActive,
        propsActiveIndex,
        sendAnalytics,
        tabRefs
    ]);
    var tabs = (0, _reactDefault.default).Children.map(children, function(child, index) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tabsContext.TabsContext).Provider, {
            value: getTabsContext(index)
        }, child ? /*#__PURE__*/ // cloneElement is needed for backward compatibility with custom
        // styled components that rely on props.active. We should reassess
        // if it is still necessary in our next major release.
        (0, _reactDefault.default).cloneElement(child, {
            active: activeIndex === index
        }) : child);
    });
    var tabsHeaderStyles = {};
    if (theme.tabs.header && theme.tabs.header.border) {
        var borderColor = theme.tabs.header.border.color || theme.global.control.border.color;
        borderColor = (0, _utils.normalizeColor)(borderColor, theme);
        tabsHeaderStyles.border = {
            side: theme.tabs.header.border.side,
            size: theme.tabs.header.border.size,
            style: theme.tabs.header.border.style,
            color: borderColor
        };
    }
    var tabContentTitle = (activeTitle || '') + " " + format({
        id: 'tabs.tabContents',
        messages: messages
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledTabs.StyledTabs), _extends({
        ref: ref,
        flex: flex,
        responsive: responsive
    }, passThemeFlag, rest, {
        background: theme.tabs.background
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), _extends({
        alignSelf: alignControls || ((_theme$tabs$header = theme.tabs.header) == null ? void 0 : _theme$tabs$header.alignSelf),
        flex: false,
        direction: overflow ? 'row' : 'column'
    }, tabsHeaderStyles), overflow && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        a11yTitle: "Previous Tab",
        disabled: disableLeftArrow,
        tabIndex: -1,
        onClick: function onClick() {
            return moveByArrowKey('previous');
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
        pad: {
            vertical: 'xsmall',
            horizontal: 'small'
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _previous.Previous), {
        color: disableLeftArrow ? theme.button.disabled.color : theme.global.colors.text
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledTabs.StyledTabsHeader), _extends({
        role: "tablist",
        ref: headerRef,
        direction: "row",
        justify: overflow ? 'start' : justify,
        flex: !!overflow,
        wrap: false,
        overflow: overflow ? 'hidden' : 'visible',
        background: theme.tabs.header.background,
        gap: theme.tabs.gap,
        pad: overflow ? '2px' : undefined,
        margin: overflow ? '-2px' : undefined
    }, passThemeFlag), tabs), overflow && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        a11yTitle: "Next Tab",
        disabled: disableRightArrow,
        tabIndex: -1,
        onClick: function onClick() {
            return moveByArrowKey('next');
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
        pad: {
            vertical: 'xsmall',
            horizontal: 'small'
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _next.Next), {
        color: disableRightArrow ? theme.button.disabled.color : theme.global.colors.text
    })))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledTabs.StyledTabPanel), _extends({
        flex: flex,
        "aria-label": tabContentTitle,
        role: "tabpanel"
    }, passThemeFlag), activeContent));
});
Tabs.displayName = 'Tabs';
Tabs.propTypes = (0, _propTypes.TabsPropTypes);

},{"react":"8CCva","grommet-icons/icons/Previous":"bSul7","grommet-icons/icons/Next":"jIfyP","../../utils/use-isomorphic-layout-effect":"jThNw","../Box":"4o01A","../Button":"fVON6","./TabsContext":"h4hPc","../../contexts/ResponsiveContext":"7EsNN","./StyledTabs":"luTif","../../utils":"fx31z","../../contexts/MessageContext":"9V5sq","./propTypes":"dBnvl","../../contexts/AnalyticsContext/AnalyticsContext":"1QG5F","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"luTif":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledTabsHeader", ()=>StyledTabsHeader);
parcelHelpers.export(exports, "StyledTabPanel", ()=>StyledTabPanel);
parcelHelpers.export(exports, "StyledTabs", ()=>StyledTabs);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _box = require("../Box");
var _utils = require("../../utils");
var _FLEX_MAP;
var StyledTabsHeader = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "StyledTabs__StyledTabsHeader",
    componentId: "sc-a4fwxl-0"
})([
    "",
    ";"
], function(props) {
    return props.theme.tabs.header.extend;
});
var FLEX_MAP = (_FLEX_MAP = {}, _FLEX_MAP[true] = '1 1', _FLEX_MAP[false] = '0 0', _FLEX_MAP.grow = '1 0', _FLEX_MAP.shrink = '0 1', _FLEX_MAP);
var flexStyle = (0, _styledComponents.css)([
    "flex:",
    ";"
], function(props) {
    return "" + FLEX_MAP[props.flex] + (props.flex !== true ? ' auto' : '');
});
var StyledTabPanel = (0, _styledComponentsDefault.default).div.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledTabs__StyledTabPanel",
    componentId: "sc-a4fwxl-1"
})([
    "min-height:0;",
    " ",
    ";"
], function(props) {
    return props.flex && flexStyle;
}, function(props) {
    return props.theme.tabs.panel.extend;
});
var StyledTabs = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "StyledTabs",
    componentId: "sc-a4fwxl-2"
})([
    "",
    " ",
    ";"
], (0, _utils.genericStyles), function(props) {
    return props.theme.tabs.extend;
});

},{"styled-components":"6bGrk","../Box":"4o01A","../../utils":"fx31z","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dBnvl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TabsPropTypes", ()=>TabsPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var PropType = {};
var TabsPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"f2FRf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CircleInformation", ()=>CircleInformation);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var CircleInformation = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "CircleInformation"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-12v8m0-12v2"
    }));
});
CircleInformation.displayName = 'CircleInformation';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"70dJ2":[function(require,module,exports,__globalThis) {
/**
 *
 * AddressBox
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddressBox", ()=>AddressBox);
parcelHelpers.export(exports, "EditableAddressBox", ()=>EditableAddressBox);
parcelHelpers.export(exports, "EditableNameBox", ()=>EditableNameBox);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _copyToClipboard = require("copy-to-clipboard");
var _copyToClipboardDefault = parcelHelpers.interopDefault(_copyToClipboard);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("grommet/es6/utils");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _text = require("grommet/es6/components/Text");
var _notification = require("grommet/es6/components/Notification");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _copy = require("grommet-icons/es6/icons/Copy");
var _edit = require("grommet-icons/es6/icons/Edit");
var _reactI18Next = require("react-i18next");
var _trimLongString = require("../ShortAddress/trimLongString");
var _prettyAddress = require("../PrettyAddress");
const StyledBox = (0, _styledComponentsDefault.default)((0, _box.Box))`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  font-weight: 700;
  padding-top: ${({ theme })=>theme.global?.edgeSize?.xsmall};
  padding-bottom: ${({ theme })=>theme.global?.edgeSize?.xsmall};

  ${({ theme, plain })=>!plain && (0, _styledComponents.css)`
      background-color: ${(0, _utils.normalizeColor)('background-custom-2', theme)};
      border-radius: ${theme.button?.border?.radius};
      color: ${(0, _utils.normalizeColor)('text-custom', theme)};
      padding-right: ${`${theme.global?.edgeSize?.medium}`};
      padding-left: ${`${theme.global?.edgeSize?.medium}`};
      border: ${`solid ${theme.global?.borderSize?.xsmall} ${(0, _utils.normalizeColor)('brand', theme)}`};
    `}
`;
const Container = ({ address, border, children, copyToClipboard, separator })=>{
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            align: "center",
            border: border && {
                color: 'brand'
            },
            direction: isMobile ? 'column' : 'row',
            gap: isMobile ? 'medium' : undefined,
            pad: {
                right: 'small'
            },
            round: "5px",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    align: "center",
                    border: separator ? {
                        color: 'background-front-border',
                        side: 'bottom'
                    } : undefined,
                    direction: "row",
                    flex: true,
                    pad: {
                        bottom: isMobile ? 'small' : separator ? 'xsmall' : undefined
                    },
                    margin: {
                        right: isMobile ? undefined : 'large'
                    },
                    width: "min(690px, 100%)" // keep the same width for address and name variants
                    ,
                    children: [
                        copyToClipboard === 'icon' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CopyAddressButton, {
                            address: address
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                            flex: true,
                            children: children
                        })
                    ]
                }),
                copyToClipboard === 'button' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileAddress, {
                    address: address
                })
            ]
        })
    });
};
const TextWrapper = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
        weight: "bold",
        size: "inherit",
        wordBreak: "break-word",
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flex: 1
        },
        children: children
    });
const AddressBox = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Container, {
        address: props.address,
        border: props.border,
        copyToClipboard: props.trimMobile && isMobile ? undefined : 'icon',
        separator: props.separator,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(TextWrapper, {
            children: [
                props.trimMobile && isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)(MobileAddress, {
                    address: props.address,
                    plain: true
                }),
                (!props.trimMobile || !isMobile) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _prettyAddress.PrettyAddress), {
                    address: props.address
                }),
                props.children
            ]
        })
    });
});
const EditableAddressBox = ({ address, openEditModal })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(AddressBox, {
        address: address,
        separator: true,
        trimMobile: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
            onClick: openEditModal,
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {
                color: "link",
                size: "16px"
            }),
            "data-testid": "editable-address-edit-button"
        })
    });
const EditableNameBox = ({ address, openEditModal, name })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Container, {
        address: address,
        copyToClipboard: "button",
        separator: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            direction: "row",
            pad: {
                left: 'small'
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(TextWrapper, {
                    children: name
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                    onClick: openEditModal,
                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _edit.Edit), {
                        color: "link",
                        size: "16px",
                        "data-testid": "editable-name-edit-button"
                    })
                })
            ]
        })
    });
const MobileAddress = ({ address, plain })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(CopyAddressButton, {
        address: address,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBox, {
            plain: plain,
            children: [
                (0, _trimLongString.trimLongString)(address, 8, 6),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copy.Copy), {
                    size: "18px"
                })
            ]
        })
    });
};
const CopyAddressButton = ({ address, children })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const [notificationVisible, setNotificationVisible] = (0, _react.useState)(false);
    const hideNotification = ()=>setNotificationVisible(false);
    const copyAddress = ()=>{
        const wasCopied = (0, _copyToClipboardDefault.default)(address);
        if (wasCopied) setNotificationVisible(true);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                onClick: ()=>copyAddress(),
                icon: children ? undefined : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copy.Copy), {
                    size: "18px"
                }),
                "data-testid": "copy-address-button",
                children: children
            }),
            notificationVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notification.Notification), {
                toast: true,
                status: 'normal',
                title: t('account.addressCopied', 'Address copied.'),
                onClose: hideNotification
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","copy-to-clipboard":"bIAYJ","styled-components":"6bGrk","grommet/es6/utils":"fx31z","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Text":"kz1Ni","grommet/es6/components/Notification":"1osU9","grommet/es6/contexts/ResponsiveContext":"7EsNN","grommet-icons/es6/icons/Copy":"iSuj5","grommet-icons/es6/icons/Edit":"kFQap","react-i18next":"7GUHL","../ShortAddress/trimLongString":"1sxUU","../PrettyAddress":"eOPA7","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1osU9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Notification", ()=>(0, _notification.Notification));
var _notification = require("./Notification");

},{"./Notification":"jZtDj","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jZtDj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Notification", ()=>Notification);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _anchor = require("../Anchor");
var _box = require("../Box");
var _button = require("../Button");
var _layer = require("../Layer");
var _paragraph = require("../Paragraph");
var _text = require("../Text");
var _propTypes = require("./propTypes");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "fill",
    "direction"
], _excluded2 = [
    "actions",
    "message",
    "onClose",
    "id",
    "global",
    "status",
    "title",
    "toast",
    "icon",
    "time"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var Message = function Message(_ref) {
    var fill = _ref.fill, direction = _ref.direction, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return direction === 'row' ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), rest) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _paragraph.Paragraph), _extends({}, rest, {
        fill: fill || false
    }));
};
var adaptThemeStyle = function adaptThemeStyle(value, theme) {
    var textStyle = value;
    var closeButtonStyle = value;
    if (typeof value === 'string' && theme.global.edgeSize[value]) {
        textStyle = {
            vertical: value,
            left: value,
            right: undefined
        };
        closeButtonStyle = {
            vertical: value,
            right: value
        };
    } else if (typeof value === 'object') {
        var left = value.left, right = value.right, top = value.top, bottom = value.bottom, horizontal = value.horizontal, vertical = value.vertical;
        textStyle = {
            top: top || vertical,
            bottom: bottom || vertical,
            left: left || horizontal,
            right: undefined
        };
        closeButtonStyle = {
            top: top || vertical,
            bottom: bottom || vertical,
            right: right || horizontal
        };
    }
    return [
        textStyle,
        closeButtonStyle
    ];
};
var getTextColor = function getTextColor(part, status, kind, theme) {
    var _theme$notification, _theme$notification2, _theme$notification3, _theme$notification4, _theme$notification5;
    var color;
    if ((_theme$notification = theme.notification) != null && (_theme$notification = _theme$notification[status]) != null && (_theme$notification = _theme$notification[kind]) != null && (_theme$notification = _theme$notification[part]) != null && _theme$notification.color) color = (_theme$notification2 = theme.notification) == null || (_theme$notification2 = _theme$notification2[status]) == null || (_theme$notification2 = _theme$notification2[kind]) == null || (_theme$notification2 = _theme$notification2[part]) == null ? void 0 : _theme$notification2.color;
    else if ((_theme$notification3 = theme.notification) != null && (_theme$notification3 = _theme$notification3[status]) != null && (_theme$notification3 = _theme$notification3[part]) != null && _theme$notification3.color) color = (_theme$notification4 = theme.notification) == null || (_theme$notification4 = _theme$notification4[status]) == null || (_theme$notification4 = _theme$notification4[part]) == null ? void 0 : _theme$notification4.color;
    else color = (_theme$notification5 = theme.notification) == null || (_theme$notification5 = _theme$notification5[part]) == null ? void 0 : _theme$notification5.color;
    return color;
};
var NotificationAnchor = (0, _styledComponentsDefault.default)((0, _anchor.Anchor)).withConfig({
    displayName: "Notification__NotificationAnchor",
    componentId: "sc-1yq09yz-0"
})([
    "white-space:nowrap;"
]);
var Notification = function Notification(_ref2) {
    var _theme$notification6, _theme$notification7, _theme$notification8, _theme$notification9, _theme$notification10;
    var actionsProp = _ref2.actions, messageProp = _ref2.message, onClose = _ref2.onClose, id = _ref2.id, global = _ref2.global, _ref2$status = _ref2.status, status = _ref2$status === void 0 ? 'unknown' : _ref2$status, title = _ref2.title, _ref2$toast = _ref2.toast, toast = _ref2$toast === void 0 ? false : _ref2$toast, icon = _ref2.icon, time = _ref2.time, rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    var autoClose = toast && (toast == null ? void 0 : toast.autoClose) === undefined ? true : toast.autoClose;
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme;
    var _useState = (0, _react.useState)(true), visible = _useState[0], setVisible = _useState[1];
    var position = (0, _react.useMemo)(function() {
        return toast && (toast == null ? void 0 : toast.position) || 'top';
    }, [
        toast
    ]);
    var close = (0, _react.useCallback)(function(event) {
        setVisible(false);
        if (onClose) onClose(event);
    }, [
        onClose
    ]);
    (0, _react.useEffect)(function() {
        if (autoClose) {
            var timer = setTimeout(close, time || theme.notification.toast.time || theme.notification.time);
            return function() {
                return clearTimeout(timer);
            };
        }
        return undefined;
    }, [
        autoClose,
        close,
        theme.notification.toast.time,
        theme.notification.time,
        time
    ]);
    var CloseIcon = theme.notification.close.icon;
    var _ref3 = ((_theme$notification6 = theme.notification) == null ? void 0 : _theme$notification6[status]) || theme.notification.unknown, StatusIcon = _ref3.icon, color = _ref3.color;
    var closeIconColor = theme.notification.close.color;
    var kind = (0, _react.useMemo)(function() {
        if (toast) return 'toast';
        if (global) return 'global';
        return undefined;
    }, [
        global,
        toast
    ]);
    var direction;
    if (kind && theme.notification[kind].direction) direction = theme.notification[kind].direction;
    else direction = theme.notification.direction;
    var background;
    if (kind && (_theme$notification7 = theme.notification) != null && (_theme$notification7 = _theme$notification7[status]) != null && (_theme$notification7 = _theme$notification7[kind]) != null && _theme$notification7.background) background = theme.notification[status][kind].background;
    else if ((_theme$notification8 = theme.notification) != null && (_theme$notification8 = _theme$notification8[status]) != null && _theme$notification8.background) background = theme.notification[status].background;
    else background = ((_theme$notification9 = theme.notification) == null || (_theme$notification9 = _theme$notification9[kind]) == null || (_theme$notification9 = _theme$notification9.container) == null ? void 0 : _theme$notification9.background) || theme.notification.container.background;
    var TextWrapper = direction === 'row' ? (0, _text.Text) : (0, _react.Fragment);
    // notification is built with two child boxes that contain:
    // 1. icon + text (wrapped in button when clickable)
    // 2. close button
    // pad needs to be applied to the child boxes, but we don't want to apply
    // extra padding between the icon + text and the button.
    var pad;
    if (kind && theme.notification[kind].container.pad) pad = theme.notification[kind].container.pad;
    else pad = theme.notification.container.pad;
    var textPad;
    var closeButtonPad;
    if (onClose) {
        var _adaptThemeStyle = adaptThemeStyle(pad, theme);
        textPad = _adaptThemeStyle[0];
        closeButtonPad = _adaptThemeStyle[1];
    } else textPad = pad;
    var actions;
    var message = messageProp;
    var messageColor = getTextColor('message', status, kind, theme);
    var titleColor = getTextColor('title', status, kind, theme);
    if (actionsProp) actions = actionsProp.map(function(action) {
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _react.Fragment), {
            key: action.label
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(NotificationAnchor, _extends({
            margin: {
                right: 'xsmall'
            }
        }, action, theme.notification.actions)), ' ');
    });
    if (message || actions) message = typeof message === 'string' ? /*#__PURE__*/ (0, _reactDefault.default).createElement(Message, _extends({}, theme.notification.message, {
        color: messageColor,
        direction: direction
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), {
        margin: {
            right: 'xsmall'
        }
    }, message), actions) : message;
    var iconDimension = ((_theme$notification10 = theme.notification) == null || (_theme$notification10 = _theme$notification10.message) == null ? void 0 : _theme$notification10.size) || 'medium';
    var content = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), _extends({}, theme.notification.container, global ? _extends({}, theme.notification.global.container) : {}, toast ? _extends({}, theme.notification.toast.container) : {}, {
        background: background,
        pad: undefined,
        direction: "row",
        gap: "small",
        id: toast ? undefined : id
    }, rest), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
        direction: "row",
        pad: textPad,
        flex: true
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), theme.notification.iconContainer, icon || /*#__PURE__*/ (0, _reactDefault.default).createElement(StatusIcon, {
        color: color,
        height: iconDimension
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), theme.notification.textContainer, /*#__PURE__*/ (0, _reactDefault.default).createElement(TextWrapper, null, title && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _text.Text), _extends({}, theme.notification.title, {
        color: titleColor
    }), title), message && title && direction === 'row' && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, "\xA0"), message))), onClose && /*#__PURE__*/ // theme.notification.container and textContainer may both have pad,
    // account for both
    (0, _reactDefault.default).createElement((0, _box.Box), {
        pad: closeButtonPad
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), theme.notification.textContainer, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _button.Button), {
        icon: /*#__PURE__*/ (0, _reactDefault.default).createElement(CloseIcon, {
            color: closeIconColor,
            height: iconDimension,
            width: iconDimension
        }),
        onClick: close,
        hoverIndicator: true,
        plain: true
    }))));
    if (toast) content = visible && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _layer.Layer), _extends({}, theme.notification.toast.layer, {
        role: "log",
        modal: false,
        onEsc: onClose,
        id: id,
        responsive: false,
        plain: true,
        position: position
    }), content);
    return content;
};
Notification.displayName = 'Notification';
Notification.propTypes = (0, _propTypes.NotificationType);

},{"react":"8CCva","styled-components":"6bGrk","../Anchor":"arBWH","../Box":"4o01A","../Button":"fVON6","../Layer":"3gh0x","../Paragraph":"kg9QN","../Text":"kz1Ni","./propTypes":"kaZCp","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kg9QN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Paragraph", ()=>(0, _paragraph.Paragraph));
var _paragraph = require("./Paragraph");

},{"./Paragraph":"as7aU","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"as7aU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Paragraph", ()=>Paragraph);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledParagraph = require("./StyledParagraph");
var _propTypes = require("./propTypes");
var _skeleton = require("../Skeleton");
var _paragraphSkeleton = require("./ParagraphSkeleton");
var _textContext = require("../Text/TextContext");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "children",
    "color",
    "fill",
    "size"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var Paragraph = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var children = _ref.children, color = _ref.color, fill = _ref.fill, size = _ref.size, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), passThemeFlag = _useThemeValue1.passThemeFlag;
    var skeleton = (0, _skeleton.useSkeleton)();
    var textContextValue = (0, _react.useMemo)(function() {
        return {
            size: size
        };
    }, [
        size
    ]);
    if (skeleton) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _paragraphSkeleton.ParagraphSkeleton), _extends({
        ref: ref,
        fill: fill,
        size: size
    }, rest), children);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledParagraph.StyledParagraph), _extends({
        ref: ref,
        colorProp: color,
        fillProp: fill,
        size: size
    }, passThemeFlag, rest), children !== undefined ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _textContext.TextContext).Provider, {
        value: textContextValue
    }, children) : undefined);
});
Paragraph.displayName = 'Paragraph';
Paragraph.prototype = (0, _propTypes.ParagraphPropTypes);

},{"react":"8CCva","./StyledParagraph":"5ky8r","./propTypes":"ccIID","../Skeleton":"aLlmA","./ParagraphSkeleton":"4cDH1","../Text/TextContext":"SHhZ0","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5ky8r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledParagraph", ()=>StyledParagraph);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var colorStyle = (0, _styledComponents.css)([
    "color:",
    ";"
], function(props) {
    return (0, _utils.normalizeColor)(props.colorProp, props.theme);
});
var sizeStyle = function sizeStyle(props) {
    var size = props.size || 'medium';
    var data = props.theme.paragraph[size];
    return (0, _styledComponents.css)([
        "font-size:",
        ";line-height:",
        ";max-width:",
        ";"
    ], data ? data.size : size, data ? data.height : 'normal', props.fillProp ? 'none' : data && data.maxWidth);
};
var fontFamily = (0, _styledComponents.css)([
    "font-family:",
    ";"
], function(props) {
    return props.theme.paragraph.font.family;
});
var maxlinesStyle = function maxlinesStyle(props) {
    return props.maxLines && (0, _styledComponents.css)([
        "display:-webkit-box;-webkit-line-clamp:",
        ";-webkit-box-orient:vertical;overflow:hidden;"
    ], props.maxLines);
};
var StyledParagraph = (0, _styledComponentsDefault.default).p.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledParagraph",
    componentId: "sc-tbetod-0"
})([
    "",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, _utils.genericStyles), function(props) {
    return maxlinesStyle(props);
}, function(props) {
    return sizeStyle(props);
}, function(props) {
    return props.textAlign && (0, _utils.textAlignStyle);
}, function(props) {
    return props.colorProp && colorStyle;
}, function(props) {
    return props.theme.paragraph.font && props.theme.paragraph.font.family && fontFamily;
}, function(props) {
    return props.theme.paragraph && props.theme.paragraph.extend;
});

},{"styled-components":"6bGrk","../../utils":"fx31z","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ccIID":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParagraphPropTypes", ()=>ParagraphPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var PropType = {};
var ParagraphPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4cDH1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParagraphSkeleton", ()=>ParagraphSkeleton);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _skeleton = require("../Skeleton");
var _box = require("../Box");
var _useThemeValue = require("../../utils/useThemeValue");
var ParagraphSkeleton = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var fill = _ref.fill, sizeProp = _ref.size;
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme;
    var size = sizeProp || 'medium';
    var data = theme.paragraph[size];
    var height = data ? data.size : size;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), {
        ref: ref,
        gap: "xsmall",
        width: {
            max: fill ? 'none' : data && data.maxWidth
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _skeleton.Skeleton), {
        height: height
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _skeleton.Skeleton), {
        height: height
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _skeleton.Skeleton), {
        height: height,
        width: "30%"
    }));
});
ParagraphSkeleton.displayName = 'ParagraphSkeleton';

},{"react":"8CCva","../Skeleton":"aLlmA","../Box":"4o01A","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kaZCp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotificationType", ()=>NotificationType);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _propTypes1 = require("../Anchor/propTypes");
var PropType = {};
var NotificationType = PropType;

},{"prop-types":"j03Ye","../Anchor/propTypes":"egBYR","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kFQap":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Edit", ()=>Edit);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Edit = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Edit"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m14 4 6 6-6-6zm8.294 1.294c.39.39.387 1.025-.008 1.42L9 20l-7 2 2-7L17.286 1.714a1 1 0 0 1 1.42-.008l3.588 3.588zM3 19l2 2m2-4 8-8"
    }));
});
Edit.displayName = 'Edit';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fZ8B7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayerContainer", ()=>LayerContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _close = require("grommet-icons/es6/icons/Close");
var _responsiveLayer = require("../../../ResponsiveLayer");
var _layer = require("../layer");
const LayerContainer = ({ animation, children, hideLayer })=>{
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveLayer.ResponsiveLayer), {
        onClickOutside: hideLayer,
        onEsc: hideLayer,
        animation: animation ? 'slide' : 'none',
        background: "background-front",
        modal: true,
        position: "center",
        style: {
            width: '100%',
            maxWidth: isMobile ? 'none' : '760px',
            minHeight: `min(${(0, _layer.layerOverlayMinHeight)}, 90dvh)`
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            flex: "grow",
            margin: {
                top: 'small',
                bottom: 'medium',
                horizontal: 'medium'
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                    align: "end",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        "data-testid": "close-settings-modal",
                        onClick: hideLayer,
                        secondary: true,
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _close.Close), {
                            size: "18px"
                        })
                    })
                }),
                children
            ]
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/contexts/ResponsiveContext":"7EsNN","grommet-icons/es6/icons/Close":"8LUZt","../../../ResponsiveLayer":"3jeKP","../layer":"hvFQu","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8LUZt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Close", ()=>Close);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
var _utils = require("../utils");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Close = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var scaleProps = (0, _utils.useScaleProps)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Close"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m3 3 18 18M3 21 21 3"
    }, scaleProps)));
});
Close.displayName = 'Close';

},{"react":"8CCva","../StyledIcon":"6hZZK","../utils":"l0e2b","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hvFQu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "layerScrollableAreaHeight", ()=>layerScrollableAreaHeight);
parcelHelpers.export(exports, "layerOverlayMinHeight", ()=>layerOverlayMinHeight);
const layerScrollableAreaHeight = '400px';
const layerOverlayMinHeight = '600px' // Keep child modals height in sync with parent modal
;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gFQZ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeleteAccount", ()=>DeleteAccount);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _box = require("grommet/es6/components/Box");
var _paragraph = require("grommet/es6/components/Paragraph");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _text = require("grommet/es6/components/Text");
var _responsiveLayer = require("../../../ResponsiveLayer");
var _deleteInputForm = require("../../../../components/DeleteInputForm");
var _account = require("../Account/Account");
const DeleteAccount = ({ onCancel, onDelete, wallet })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveLayer.ResponsiveLayer), {
        onClickOutside: onCancel,
        onEsc: onCancel,
        animation: "none",
        background: "background-front",
        modal: true,
        margin: isMobile ? 'none' : 'xlarge',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
            margin: "medium",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                flex: "grow",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                        weight: "bold",
                        size: "medium",
                        textAlign: "center",
                        margin: {
                            bottom: 'large'
                        },
                        children: t('toolbar.settings.delete.title', 'Delete Account')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                        size: "medium",
                        textAlign: "center",
                        margin: {
                            bottom: 'medium'
                        },
                        children: t('toolbar.settings.delete.description', 'Are you sure you want to delete the following account?')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _account.Account), {
                        address: wallet.address,
                        balance: undefined,
                        displayBalance: false,
                        isActive: true,
                        name: wallet.name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteInputForm.DeleteInputForm), {
                        onCancel: onCancel,
                        onConfirm: onDelete,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "type_delete",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paragraph.Paragraph), {
                                fill: true,
                                textAlign: "center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                                    i18nKey: "toolbar.settings.delete.inputHelp",
                                    t: t,
                                    defaults: "This action cannot be undone. To continue please type <strong>{{confirmationKeyword}}</strong> below.",
                                    values: {
                                        confirmationKeyword: t('deleteForm.confirmationKeyword', 'delete')
                                    }
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-i18next":"7GUHL","grommet/es6/components/Box":"4o01A","grommet/es6/components/Paragraph":"kg9QN","grommet/es6/contexts/ResponsiveContext":"7EsNN","grommet/es6/components/Text":"kz1Ni","../../../ResponsiveLayer":"3jeKP","../../../../components/DeleteInputForm":"T2xGV","../Account/Account":"72YoH","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"T2xGV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeleteInputForm", ()=>DeleteInputForm);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _reactI18Next = require("react-i18next");
var _textInput = require("grommet/es6/components/TextInput");
var _form = require("grommet/es6/components/Form");
var _formField = require("grommet/es6/components/FormField");
function DeleteInputForm({ children, onCancel, onConfirm }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
        onSubmit: onConfirm,
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
                name: "type_delete",
                validate: (value)=>!value || value.toLowerCase() !== t('deleteForm.confirmationKeyword', 'delete').toLowerCase() ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                            i18nKey: "deleteForm.hint",
                            t: t,
                            defaults: "Type <strong>{{confirmationKeyword}}</strong>",
                            values: {
                                confirmationKeyword: t('deleteForm.confirmationKeyword', 'delete')
                            }
                        })
                    }) : undefined,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInput.TextInput), {
                    "data-testid": "account-delete-confirmation-input",
                    id: "type_delete",
                    name: "type_delete"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                direction: "row",
                justify: "between",
                pad: {
                    top: 'large'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        secondary: true,
                        label: t('common.cancel', 'Cancel'),
                        onClick: onCancel
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        type: "submit",
                        label: t('deleteForm.confirm', 'Yes, delete'),
                        primary: true,
                        color: "status-error"
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","react-i18next":"7GUHL","grommet/es6/components/TextInput":"cL4wi","grommet/es6/components/Form":"kRCRN","grommet/es6/components/FormField":"dcsVI","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iwqT0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PrivateKeyFormatter", ()=>PrivateKeyFormatter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _copyToClipboard = require("copy-to-clipboard");
var _copyToClipboardDefault = parcelHelpers.interopDefault(_copyToClipboard);
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _notification = require("grommet/es6/components/Notification");
var _copy = require("grommet-icons/es6/icons/Copy");
var _reactI18Next = require("react-i18next");
var _noTranslate = require("app/components/NoTranslate");
var _helpers = require("../../lib/helpers");
const PrivateKeyFormatter = ({ privateKey })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const [notificationVisible, setNotificationVisible] = (0, _react.useState)(false);
    const copyAddress = ()=>{
        const wasCopied = (0, _copyToClipboardDefault.default)((0, _helpers.uintToBase64)((0, _helpers.hex2uint)(privateKey)));
        if (wasCopied) setNotificationVisible(true);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                direction: "row",
                gap: "small",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        round: "5px",
                        border: {
                            color: 'brand'
                        },
                        pad: "small",
                        style: {
                            display: 'block'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noTranslate.NoTranslate), {
                            children: (0, _helpers.uintToBase64)((0, _helpers.hex2uint)(privateKey))
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        onClick: ()=>copyAddress(),
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copy.Copy), {
                            size: "18px"
                        }),
                        "data-testid": "copy-address"
                    })
                ]
            }),
            notificationVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notification.Notification), {
                toast: true,
                status: 'normal',
                title: t('toolbar.settings.exportPrivateKey.copied', 'Private key copied.'),
                onClose: ()=>setNotificationVisible(false)
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","copy-to-clipboard":"bIAYJ","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Notification":"1osU9","grommet-icons/es6/icons/Copy":"iSuj5","react-i18next":"7GUHL","app/components/NoTranslate":"jUKdq","../../lib/helpers":"bUnFy","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6jvAW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RevealOverlayButton", ()=>RevealOverlayButton);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("grommet/es6/components/Button");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("grommet/es6/components/Box");
var _text = require("grommet/es6/components/Text");
const RevealOverlayButton = (props)=>{
    const [hasRevealed, setHasRevealed] = (0, _react.useState)(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        style: {
            position: 'relative'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                    color: "link",
                    weight: "bold",
                    children: props.label
                }),
                style: {
                    visibility: hasRevealed ? 'hidden' : 'visible',
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0
                },
                color: "lightText",
                onClick: ()=>setHasRevealed(true)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                style: {
                    visibility: hasRevealed ? 'visible' : 'hidden'
                },
                children: props.children
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Button":"fVON6","react":"8CCva","grommet/es6/components/Box":"4o01A","grommet/es6/components/Text":"kz1Ni","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aqCoJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollableContainer", ()=>ScrollableContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _box = require("grommet/es6/components/Box");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _layer = require("../layer");
const spaceForFocusIndicator = '2px';
const ScrollableContainer = ({ children })=>{
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        gap: "small",
        pad: {
            right: 'small',
            left: spaceForFocusIndicator
        },
        overflow: {
            vertical: 'auto'
        },
        style: {
            maxHeight: isMobile ? undefined : (0, _layer.layerScrollableAreaHeight)
        },
        margin: {
            bottom: isMobile ? 'large' : 'none',
            left: `-${spaceForFocusIndicator}`
        },
        children: children
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","grommet/es6/components/Box":"4o01A","grommet/es6/contexts/ResponsiveContext":"7EsNN","../layer":"hvFQu","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8j6EN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ButtonLink", ()=>ButtonLink);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("grommet/es6/components/Button");
var _reactRouterDom = require("react-router-dom");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ButtonLink = (props)=>{
    const { label, to, ...buttonProps } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
        "aria-label": label,
        to: to,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
            ...buttonProps,
            label: label,
            tabIndex: -1
        })
    });
};

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Button":"fVON6","react-router-dom":"9pTjq","react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kULLY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Add", ()=>Add);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
var _utils = require("../utils");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Add = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var scaleProps = (0, _utils.useScaleProps)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Add"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22V2M2 12h20"
    }, scaleProps)));
});
Add.displayName = 'Add';

},{"react":"8CCva","../StyledIcon":"6hZZK","../utils":"l0e2b","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kyOPT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JazzIcon", ()=>JazzIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _jazzicon = require("@metamask/jazzicon");
var _jazziconDefault = parcelHelpers.interopDefault(_jazzicon);
var _box = require("grommet/es6/components/Box");
const JazzIcon = /*#__PURE__*/ (0, _react.memo)(({ diameter, seed })=>{
    const ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (ref?.current) {
            const icon = (0, _jazziconDefault.default)(diameter, seed);
            ref.current.replaceChildren(icon);
        }
    }, [
        diameter,
        ref,
        seed
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        ref: ref
    });
});

},{"react/jsx-runtime":"6pm7f","react":"8CCva","@metamask/jazzicon":"gdDNO","grommet/es6/components/Box":"4o01A","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gdDNO":[function(require,module,exports,__globalThis) {
var MersenneTwister = require("632bf711dc750cfe");
var paperGen = require("2e73a57693c664db");
var Color = require("a27f612defa7de29");
var colors = require("2fd502038527568");
var shapeCount = 4;
var svgns = 'http://www.w3.org/2000/svg';
module.exports = generateIdenticon;
var generator;
function generateIdenticon(diameter, seed) {
    generator = new MersenneTwister(seed);
    var remainingColors = hueShift(colors.slice(), generator);
    var elements = paperGen(diameter, genColor(remainingColors));
    var container = elements.container;
    var svg = document.createElementNS(svgns, 'svg');
    svg.setAttributeNS(null, 'x', '0');
    svg.setAttributeNS(null, 'y', '0');
    svg.setAttributeNS(null, 'width', diameter);
    svg.setAttributeNS(null, 'height', diameter);
    container.appendChild(svg);
    for(var i = 0; i < shapeCount - 1; i++)genShape(remainingColors, diameter, i, shapeCount - 1, svg);
    return container;
}
function genShape(remainingColors, diameter, i, total, svg) {
    var center = diameter / 2;
    var shape = document.createElementNS(svgns, 'rect');
    shape.setAttributeNS(null, 'x', '0');
    shape.setAttributeNS(null, 'y', '0');
    shape.setAttributeNS(null, 'width', diameter);
    shape.setAttributeNS(null, 'height', diameter);
    var firstRot = generator.random();
    var angle = Math.PI * 2 * firstRot;
    var velocity = diameter / total * generator.random() + i * diameter / total;
    var tx = Math.cos(angle) * velocity;
    var ty = Math.sin(angle) * velocity;
    var translate = 'translate(' + tx + ' ' + ty + ')';
    // Third random is a shape rotation on top of all of that.
    var secondRot = generator.random();
    var rot = firstRot * 360 + secondRot * 180;
    var rotate = 'rotate(' + rot.toFixed(1) + ' ' + center + ' ' + center + ')';
    var transform = translate + ' ' + rotate;
    shape.setAttributeNS(null, 'transform', transform);
    var fill = genColor(remainingColors);
    shape.setAttributeNS(null, 'fill', fill);
    svg.appendChild(shape);
}
function genColor(colors) {
    var rand = generator.random();
    var idx = Math.floor(colors.length * generator.random());
    var color = colors.splice(idx, 1)[0];
    return color;
}
var wobble = 30;
function hueShift(colors, generator) {
    var amount = generator.random() * 30 - wobble / 2;
    return colors.map(function(hex) {
        var color = Color(hex);
        color.rotate(amount);
        return color.hexString();
    });
}

},{"632bf711dc750cfe":"7IK00","2e73a57693c664db":"ijNdT","a27f612defa7de29":"2qGKK","2fd502038527568":"8H3MU"}],"7IK00":[function(require,module,exports,__globalThis) {
/*
  https://github.com/banksean wrapped Makoto Matsumoto and Takuji Nishimura's code in a namespace
  so it's better encapsulated. Now you can have multiple random number generators
  and they won't stomp all over eachother's state.

  If you want to use this as a substitute for Math.random(), use the random()
  method like so:

  var m = new MersenneTwister();
  var randomNumber = m.random();

  You can also call the other genrand_{foo}() methods on the instance.

  If you want to use a specific seed in order to get a repeatable random
  sequence, pass an integer into the constructor:

  var m = new MersenneTwister(123);

  and that will always produce the same random sequence.

  Sean McCullough (banksean@gmail.com)
*/ /*
   A C-program for MT19937, with initialization improved 2002/1/26.
   Coded by Takuji Nishimura and Makoto Matsumoto.

   Before using, initialize the state by using init_seed(seed)
   or init_by_array(init_key, key_length).

   Copyright (C) 1997 - 2002, Makoto Matsumoto and Takuji Nishimura,
   All rights reserved.

   Redistribution and use in source and binary forms, with or without
   modification, are permitted provided that the following conditions
   are met:

     1. Redistributions of source code must retain the above copyright
        notice, this list of conditions and the following disclaimer.

     2. Redistributions in binary form must reproduce the above copyright
        notice, this list of conditions and the following disclaimer in the
        documentation and/or other materials provided with the distribution.

     3. The names of its contributors may not be used to endorse or promote
        products derived from this software without specific prior written
        permission.

   THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
   "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
   LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
   A PARTICULAR PURPOSE ARE DISCLAIMED.  IN NO EVENT SHALL THE COPYRIGHT OWNER OR
   CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
   EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
   PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
   PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
   LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
   NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
   SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.


   Any feedback is very welcome.
   http://www.math.sci.hiroshima-u.ac.jp/~m-mat/MT/emt.html
   email: m-mat @ math.sci.hiroshima-u.ac.jp (remove space)
*/ var MersenneTwister = function(seed) {
    if (seed == undefined) seed = new Date().getTime();
    /* Period parameters */ this.N = 624;
    this.M = 397;
    this.MATRIX_A = 0x9908b0df; /* constant vector a */ 
    this.UPPER_MASK = 0x80000000; /* most significant w-r bits */ 
    this.LOWER_MASK = 0x7fffffff; /* least significant r bits */ 
    this.mt = new Array(this.N); /* the array for the state vector */ 
    this.mti = this.N + 1; /* mti==N+1 means mt[N] is not initialized */ 
    if (seed.constructor == Array) this.init_by_array(seed, seed.length);
    else this.init_seed(seed);
};
/* initializes mt[N] with a seed */ /* origin name init_genrand */ MersenneTwister.prototype.init_seed = function(s) {
    this.mt[0] = s >>> 0;
    for(this.mti = 1; this.mti < this.N; this.mti++){
        var s = this.mt[this.mti - 1] ^ this.mt[this.mti - 1] >>> 30;
        this.mt[this.mti] = (((s & 0xffff0000) >>> 16) * 1812433253 << 16) + (s & 0x0000ffff) * 1812433253 + this.mti;
        /* See Knuth TAOCP Vol2. 3rd Ed. P.106 for multiplier. */ /* In the previous versions, MSBs of the seed affect   */ /* only MSBs of the array mt[].                        */ /* 2002/01/09 modified by Makoto Matsumoto             */ this.mt[this.mti] >>>= 0;
    /* for >32 bit machines */ }
};
/* initialize by an array with array-length */ /* init_key is the array for initializing keys */ /* key_length is its length */ /* slight change for C++, 2004/2/26 */ MersenneTwister.prototype.init_by_array = function(init_key, key_length) {
    var i, j, k;
    this.init_seed(19650218);
    i = 1;
    j = 0;
    k = this.N > key_length ? this.N : key_length;
    for(; k; k--){
        var s = this.mt[i - 1] ^ this.mt[i - 1] >>> 30;
        this.mt[i] = (this.mt[i] ^ (((s & 0xffff0000) >>> 16) * 1664525 << 16) + (s & 0x0000ffff) * 1664525) + init_key[j] + j; /* non linear */ 
        this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */ 
        i++;
        j++;
        if (i >= this.N) {
            this.mt[0] = this.mt[this.N - 1];
            i = 1;
        }
        if (j >= key_length) j = 0;
    }
    for(k = this.N - 1; k; k--){
        var s = this.mt[i - 1] ^ this.mt[i - 1] >>> 30;
        this.mt[i] = (this.mt[i] ^ (((s & 0xffff0000) >>> 16) * 1566083941 << 16) + (s & 0x0000ffff) * 1566083941) - i; /* non linear */ 
        this.mt[i] >>>= 0; /* for WORDSIZE > 32 machines */ 
        i++;
        if (i >= this.N) {
            this.mt[0] = this.mt[this.N - 1];
            i = 1;
        }
    }
    this.mt[0] = 0x80000000; /* MSB is 1; assuring non-zero initial array */ 
};
/* generates a random number on [0,0xffffffff]-interval */ /* origin name genrand_int32 */ MersenneTwister.prototype.random_int = function() {
    var y;
    var mag01 = new Array(0x0, this.MATRIX_A);
    /* mag01[x] = x * MATRIX_A  for x=0,1 */ if (this.mti >= this.N) {
        var kk;
        if (this.mti == this.N + 1) /* if init_seed() has not been called, */ this.init_seed(5489); /* a default initial seed is used */ 
        for(kk = 0; kk < this.N - this.M; kk++){
            y = this.mt[kk] & this.UPPER_MASK | this.mt[kk + 1] & this.LOWER_MASK;
            this.mt[kk] = this.mt[kk + this.M] ^ y >>> 1 ^ mag01[y & 0x1];
        }
        for(; kk < this.N - 1; kk++){
            y = this.mt[kk] & this.UPPER_MASK | this.mt[kk + 1] & this.LOWER_MASK;
            this.mt[kk] = this.mt[kk + (this.M - this.N)] ^ y >>> 1 ^ mag01[y & 0x1];
        }
        y = this.mt[this.N - 1] & this.UPPER_MASK | this.mt[0] & this.LOWER_MASK;
        this.mt[this.N - 1] = this.mt[this.M - 1] ^ y >>> 1 ^ mag01[y & 0x1];
        this.mti = 0;
    }
    y = this.mt[this.mti++];
    /* Tempering */ y ^= y >>> 11;
    y ^= y << 7 & 0x9d2c5680;
    y ^= y << 15 & 0xefc60000;
    y ^= y >>> 18;
    return y >>> 0;
};
/* generates a random number on [0,0x7fffffff]-interval */ /* origin name genrand_int31 */ MersenneTwister.prototype.random_int31 = function() {
    return this.random_int() >>> 1;
};
/* generates a random number on [0,1]-real-interval */ /* origin name genrand_real1 */ MersenneTwister.prototype.random_incl = function() {
    return this.random_int() * (1.0 / 4294967295.0);
/* divided by 2^32-1 */ };
/* generates a random number on [0,1)-real-interval */ MersenneTwister.prototype.random = function() {
    return this.random_int() * (1.0 / 4294967296.0);
/* divided by 2^32 */ };
/* generates a random number on (0,1)-real-interval */ /* origin name genrand_real3 */ MersenneTwister.prototype.random_excl = function() {
    return (this.random_int() + 0.5) * (1.0 / 4294967296.0);
/* divided by 2^32 */ };
/* generates a random number on [0,1) with 53-bit resolution*/ /* origin name genrand_res53 */ MersenneTwister.prototype.random_long = function() {
    var a = this.random_int() >>> 5, b = this.random_int() >>> 6;
    return (a * 67108864.0 + b) * (1.0 / 9007199254740992.0);
};
/* These real versions are due to Isaku Wada, 2002/01/09 added */ module.exports = MersenneTwister;

},{}],"ijNdT":[function(require,module,exports,__globalThis) {
function newPaper(diameter, color) {
    var container = document.createElement('div');
    container.style.borderRadius = '50px';
    container.style.overflow = 'hidden';
    container.style.padding = '0px';
    container.style.margin = '0px';
    container.style.width = '' + diameter + 'px';
    container.style.height = '' + diameter + 'px';
    container.style.display = 'inline-block';
    container.style.background = color;
    return {
        container: container
    };
}
module.exports = newPaper;

},{}],"2qGKK":[function(require,module,exports,__globalThis) {
/* MIT license */ var clone = require("5dace8876896bf8a");
var convert = require("c094f2fb379d5867");
var string = require("71b6e3b39cf59f9f");
var Color = function(obj) {
    if (obj instanceof Color) return obj;
    if (!(this instanceof Color)) return new Color(obj);
    this.values = {
        rgb: [
            0,
            0,
            0
        ],
        hsl: [
            0,
            0,
            0
        ],
        hsv: [
            0,
            0,
            0
        ],
        hwb: [
            0,
            0,
            0
        ],
        cmyk: [
            0,
            0,
            0,
            0
        ],
        alpha: 1
    };
    // parse Color() argument
    var vals;
    if (typeof obj === 'string') {
        vals = string.getRgba(obj);
        if (vals) this.setValues('rgb', vals);
        else if (vals = string.getHsla(obj)) this.setValues('hsl', vals);
        else if (vals = string.getHwb(obj)) this.setValues('hwb', vals);
        else throw new Error('Unable to parse color from string "' + obj + '"');
    } else if (typeof obj === 'object') {
        vals = obj;
        if (vals.r !== undefined || vals.red !== undefined) this.setValues('rgb', vals);
        else if (vals.l !== undefined || vals.lightness !== undefined) this.setValues('hsl', vals);
        else if (vals.v !== undefined || vals.value !== undefined) this.setValues('hsv', vals);
        else if (vals.w !== undefined || vals.whiteness !== undefined) this.setValues('hwb', vals);
        else if (vals.c !== undefined || vals.cyan !== undefined) this.setValues('cmyk', vals);
        else throw new Error('Unable to parse color from object ' + JSON.stringify(obj));
    }
};
Color.prototype = {
    rgb: function() {
        return this.setSpace('rgb', arguments);
    },
    hsl: function() {
        return this.setSpace('hsl', arguments);
    },
    hsv: function() {
        return this.setSpace('hsv', arguments);
    },
    hwb: function() {
        return this.setSpace('hwb', arguments);
    },
    cmyk: function() {
        return this.setSpace('cmyk', arguments);
    },
    rgbArray: function() {
        return this.values.rgb;
    },
    hslArray: function() {
        return this.values.hsl;
    },
    hsvArray: function() {
        return this.values.hsv;
    },
    hwbArray: function() {
        if (this.values.alpha !== 1) return this.values.hwb.concat([
            this.values.alpha
        ]);
        return this.values.hwb;
    },
    cmykArray: function() {
        return this.values.cmyk;
    },
    rgbaArray: function() {
        var rgb = this.values.rgb;
        return rgb.concat([
            this.values.alpha
        ]);
    },
    rgbaArrayNormalized: function() {
        var rgb = this.values.rgb;
        var glRgba = [];
        for(var i = 0; i < 3; i++)glRgba[i] = rgb[i] / 255;
        glRgba.push(this.values.alpha);
        return glRgba;
    },
    hslaArray: function() {
        var hsl = this.values.hsl;
        return hsl.concat([
            this.values.alpha
        ]);
    },
    alpha: function(val) {
        if (val === undefined) return this.values.alpha;
        this.setValues('alpha', val);
        return this;
    },
    red: function(val) {
        return this.setChannel('rgb', 0, val);
    },
    green: function(val) {
        return this.setChannel('rgb', 1, val);
    },
    blue: function(val) {
        return this.setChannel('rgb', 2, val);
    },
    hue: function(val) {
        if (val) {
            val %= 360;
            val = val < 0 ? 360 + val : val;
        }
        return this.setChannel('hsl', 0, val);
    },
    saturation: function(val) {
        return this.setChannel('hsl', 1, val);
    },
    lightness: function(val) {
        return this.setChannel('hsl', 2, val);
    },
    saturationv: function(val) {
        return this.setChannel('hsv', 1, val);
    },
    whiteness: function(val) {
        return this.setChannel('hwb', 1, val);
    },
    blackness: function(val) {
        return this.setChannel('hwb', 2, val);
    },
    value: function(val) {
        return this.setChannel('hsv', 2, val);
    },
    cyan: function(val) {
        return this.setChannel('cmyk', 0, val);
    },
    magenta: function(val) {
        return this.setChannel('cmyk', 1, val);
    },
    yellow: function(val) {
        return this.setChannel('cmyk', 2, val);
    },
    black: function(val) {
        return this.setChannel('cmyk', 3, val);
    },
    hexString: function() {
        return string.hexString(this.values.rgb);
    },
    rgbString: function() {
        return string.rgbString(this.values.rgb, this.values.alpha);
    },
    rgbaString: function() {
        return string.rgbaString(this.values.rgb, this.values.alpha);
    },
    percentString: function() {
        return string.percentString(this.values.rgb, this.values.alpha);
    },
    hslString: function() {
        return string.hslString(this.values.hsl, this.values.alpha);
    },
    hslaString: function() {
        return string.hslaString(this.values.hsl, this.values.alpha);
    },
    hwbString: function() {
        return string.hwbString(this.values.hwb, this.values.alpha);
    },
    keyword: function() {
        return string.keyword(this.values.rgb, this.values.alpha);
    },
    rgbNumber: function() {
        return this.values.rgb[0] << 16 | this.values.rgb[1] << 8 | this.values.rgb[2];
    },
    luminosity: function() {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        var rgb = this.values.rgb;
        var lum = [];
        for(var i = 0; i < rgb.length; i++){
            var chan = rgb[i] / 255;
            lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast: function(color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        var lum1 = this.luminosity();
        var lum2 = color2.luminosity();
        if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level: function(color2) {
        var contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7.1) return 'AAA';
        return contrastRatio >= 4.5 ? 'AA' : '';
    },
    dark: function() {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        var rgb = this.values.rgb;
        var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
        return yiq < 128;
    },
    light: function() {
        return !this.dark();
    },
    negate: function() {
        var rgb = [];
        for(var i = 0; i < 3; i++)rgb[i] = 255 - this.values.rgb[i];
        this.setValues('rgb', rgb);
        return this;
    },
    lighten: function(ratio) {
        this.values.hsl[2] += this.values.hsl[2] * ratio;
        this.setValues('hsl', this.values.hsl);
        return this;
    },
    darken: function(ratio) {
        this.values.hsl[2] -= this.values.hsl[2] * ratio;
        this.setValues('hsl', this.values.hsl);
        return this;
    },
    saturate: function(ratio) {
        this.values.hsl[1] += this.values.hsl[1] * ratio;
        this.setValues('hsl', this.values.hsl);
        return this;
    },
    desaturate: function(ratio) {
        this.values.hsl[1] -= this.values.hsl[1] * ratio;
        this.setValues('hsl', this.values.hsl);
        return this;
    },
    whiten: function(ratio) {
        this.values.hwb[1] += this.values.hwb[1] * ratio;
        this.setValues('hwb', this.values.hwb);
        return this;
    },
    blacken: function(ratio) {
        this.values.hwb[2] += this.values.hwb[2] * ratio;
        this.setValues('hwb', this.values.hwb);
        return this;
    },
    greyscale: function() {
        var rgb = this.values.rgb;
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        this.setValues('rgb', [
            val,
            val,
            val
        ]);
        return this;
    },
    clearer: function(ratio) {
        this.setValues('alpha', this.values.alpha - this.values.alpha * ratio);
        return this;
    },
    opaquer: function(ratio) {
        this.setValues('alpha', this.values.alpha + this.values.alpha * ratio);
        return this;
    },
    rotate: function(degrees) {
        var hue = this.values.hsl[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        this.values.hsl[0] = hue;
        this.setValues('hsl', this.values.hsl);
        return this;
    },
    /**
	 * Ported from sass implementation in C
	 * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
	 */ mix: function(mixinColor, weight) {
        var color1 = this;
        var color2 = mixinColor;
        var p = weight === undefined ? 0.5 : weight;
        var w = 2 * p - 1;
        var a = color1.alpha() - color2.alpha();
        var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
        var w2 = 1 - w1;
        return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
    },
    toJSON: function() {
        return this.rgb();
    },
    clone: function() {
        var col = new Color();
        col.values = clone(this.values);
        return col;
    }
};
Color.prototype.getValues = function(space) {
    var vals = {};
    for(var i = 0; i < space.length; i++)vals[space.charAt(i)] = this.values[space][i];
    if (this.values.alpha !== 1) vals.a = this.values.alpha;
    // {r: 255, g: 255, b: 255, a: 0.4}
    return vals;
};
Color.prototype.setValues = function(space, vals) {
    var spaces = {
        rgb: [
            'red',
            'green',
            'blue'
        ],
        hsl: [
            'hue',
            'saturation',
            'lightness'
        ],
        hsv: [
            'hue',
            'saturation',
            'value'
        ],
        hwb: [
            'hue',
            'whiteness',
            'blackness'
        ],
        cmyk: [
            'cyan',
            'magenta',
            'yellow',
            'black'
        ]
    };
    var maxes = {
        rgb: [
            255,
            255,
            255
        ],
        hsl: [
            360,
            100,
            100
        ],
        hsv: [
            360,
            100,
            100
        ],
        hwb: [
            360,
            100,
            100
        ],
        cmyk: [
            100,
            100,
            100,
            100
        ]
    };
    var i;
    var alpha = 1;
    if (space === 'alpha') alpha = vals;
    else if (vals.length) {
        // [10, 10, 10]
        this.values[space] = vals.slice(0, space.length);
        alpha = vals[space.length];
    } else if (vals[space.charAt(0)] !== undefined) {
        // {r: 10, g: 10, b: 10}
        for(i = 0; i < space.length; i++)this.values[space][i] = vals[space.charAt(i)];
        alpha = vals.a;
    } else if (vals[spaces[space][0]] !== undefined) {
        // {red: 10, green: 10, blue: 10}
        var chans = spaces[space];
        for(i = 0; i < space.length; i++)this.values[space][i] = vals[chans[i]];
        alpha = vals.alpha;
    }
    this.values.alpha = Math.max(0, Math.min(1, alpha === undefined ? this.values.alpha : alpha));
    if (space === 'alpha') return false;
    var capped;
    // cap values of the space prior converting all values
    for(i = 0; i < space.length; i++){
        capped = Math.max(0, Math.min(maxes[space][i], this.values[space][i]));
        this.values[space][i] = Math.round(capped);
    }
    // convert to all the other color spaces
    for(var sname in spaces){
        if (sname !== space) this.values[sname] = convert[space][sname](this.values[space]);
        // cap values
        for(i = 0; i < sname.length; i++){
            capped = Math.max(0, Math.min(maxes[sname][i], this.values[sname][i]));
            this.values[sname][i] = Math.round(capped);
        }
    }
    return true;
};
Color.prototype.setSpace = function(space, args) {
    var vals = args[0];
    if (vals === undefined) // color.rgb()
    return this.getValues(space);
    // color.rgb(10, 10, 10)
    if (typeof vals === 'number') vals = Array.prototype.slice.call(args);
    this.setValues(space, vals);
    return this;
};
Color.prototype.setChannel = function(space, index, val) {
    if (val === undefined) // color.red()
    return this.values[space][index];
    else if (val === this.values[space][index]) // color.red(color.red())
    return this;
    // color.red(100)
    this.values[space][index] = val;
    this.setValues(space, this.values[space]);
    return this;
};
module.exports = Color;

},{"5dace8876896bf8a":"4ScYR","c094f2fb379d5867":"iS5hC","71b6e3b39cf59f9f":"5ZmYW"}],"4ScYR":[function(require,module,exports,__globalThis) {
var Buffer = require("ed8dd23fba769fd1").Buffer;
var clone = function() {
    'use strict';
    /**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
*/ function clone(parent, circular, depth, prototype) {
        var filter;
        if (typeof circular === 'object') {
            depth = circular.depth;
            prototype = circular.prototype;
            filter = circular.filter;
            circular = circular.circular;
        }
        // maintain two arrays for circular references, where corresponding parents
        // and children have the same index
        var allParents = [];
        var allChildren = [];
        var useBuffer = typeof Buffer != 'undefined';
        if (typeof circular == 'undefined') circular = true;
        if (typeof depth == 'undefined') depth = Infinity;
        // recurse this function so we don't reset allParents and allChildren
        function _clone(parent, depth) {
            // cloning null always returns null
            if (parent === null) return null;
            if (depth == 0) return parent;
            var child;
            var proto;
            if (typeof parent != 'object') return parent;
            if (clone.__isArray(parent)) child = [];
            else if (clone.__isRegExp(parent)) {
                child = new RegExp(parent.source, __getRegExpFlags(parent));
                if (parent.lastIndex) child.lastIndex = parent.lastIndex;
            } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
            else if (useBuffer && Buffer.isBuffer(parent)) {
                if (Buffer.allocUnsafe) // Node.js >= 4.5.0
                child = Buffer.allocUnsafe(parent.length);
                else // Older Node.js versions
                child = new Buffer(parent.length);
                parent.copy(child);
                return child;
            } else if (typeof prototype == 'undefined') {
                proto = Object.getPrototypeOf(parent);
                child = Object.create(proto);
            } else {
                child = Object.create(prototype);
                proto = prototype;
            }
            if (circular) {
                var index = allParents.indexOf(parent);
                if (index != -1) return allChildren[index];
                allParents.push(parent);
                allChildren.push(child);
            }
            for(var i in parent){
                var attrs;
                if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                if (attrs && attrs.set == null) continue;
                child[i] = _clone(parent[i], depth - 1);
            }
            return child;
        }
        return _clone(parent, depth);
    }
    /**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */ clone.clonePrototype = function clonePrototype(parent) {
        if (parent === null) return null;
        var c = function() {};
        c.prototype = parent;
        return new c();
    };
    // private utility functions
    function __objToStr(o) {
        return Object.prototype.toString.call(o);
    }
    clone.__objToStr = __objToStr;
    function __isDate(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Date]';
    }
    clone.__isDate = __isDate;
    function __isArray(o) {
        return typeof o === 'object' && __objToStr(o) === '[object Array]';
    }
    clone.__isArray = __isArray;
    function __isRegExp(o) {
        return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
    }
    clone.__isRegExp = __isRegExp;
    function __getRegExpFlags(re) {
        var flags = '';
        if (re.global) flags += 'g';
        if (re.ignoreCase) flags += 'i';
        if (re.multiline) flags += 'm';
        return flags;
    }
    clone.__getRegExpFlags = __getRegExpFlags;
    return clone;
}();
if (0, module.exports) module.exports = clone;

},{"ed8dd23fba769fd1":"eXvXD"}],"iS5hC":[function(require,module,exports,__globalThis) {
var conversions = require("739980f7990d3c32");
var route = require("30ea0c7ee5f3dd94");
var convert = {};
var models = Object.keys(conversions);
function wrapRaw(fn) {
    var wrappedFn = function(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        return fn(args);
    };
    // preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function wrapRounded(fn) {
    var wrappedFn = function(args) {
        if (args === undefined || args === null) return args;
        if (arguments.length > 1) args = Array.prototype.slice.call(arguments);
        var result = fn(args);
        // we're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === 'object') for(var len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // preserve .conversion property if there is one
    if ('conversion' in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
models.forEach(function(fromModel) {
    convert[fromModel] = {};
    Object.defineProperty(convert[fromModel], 'channels', {
        value: conversions[fromModel].channels
    });
    Object.defineProperty(convert[fromModel], 'labels', {
        value: conversions[fromModel].labels
    });
    var routes = route(fromModel);
    var routeModels = Object.keys(routes);
    routeModels.forEach(function(toModel) {
        var fn = routes[toModel];
        convert[fromModel][toModel] = wrapRounded(fn);
        convert[fromModel][toModel].raw = wrapRaw(fn);
    });
});
module.exports = convert;

},{"739980f7990d3c32":"ktony","30ea0c7ee5f3dd94":"kKA9p"}],"ktony":[function(require,module,exports,__globalThis) {
/* MIT license */ var cssKeywords = require("efc99055946c4df8");
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
var reverseKeywords = {};
for(var key in cssKeywords)if (cssKeywords.hasOwnProperty(key)) reverseKeywords[cssKeywords[key]] = key;
var convert = module.exports = {
    rgb: {
        channels: 3,
        labels: 'rgb'
    },
    hsl: {
        channels: 3,
        labels: 'hsl'
    },
    hsv: {
        channels: 3,
        labels: 'hsv'
    },
    hwb: {
        channels: 3,
        labels: 'hwb'
    },
    cmyk: {
        channels: 4,
        labels: 'cmyk'
    },
    xyz: {
        channels: 3,
        labels: 'xyz'
    },
    lab: {
        channels: 3,
        labels: 'lab'
    },
    lch: {
        channels: 3,
        labels: 'lch'
    },
    hex: {
        channels: 1,
        labels: [
            'hex'
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            'keyword'
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            'ansi16'
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            'ansi256'
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            'h',
            'c',
            'g'
        ]
    },
    apple: {
        channels: 3,
        labels: [
            'r16',
            'g16',
            'b16'
        ]
    },
    gray: {
        channels: 1,
        labels: [
            'gray'
        ]
    }
};
// hide .channels and .labels properties
for(var model in convert)if (convert.hasOwnProperty(model)) {
    if (!('channels' in convert[model])) throw new Error('missing channels property: ' + model);
    if (!('labels' in convert[model])) throw new Error('missing channel labels property: ' + model);
    if (convert[model].labels.length !== convert[model].channels) throw new Error('channel and label counts mismatch: ' + model);
    var channels = convert[model].channels;
    var labels = convert[model].labels;
    delete convert[model].channels;
    delete convert[model].labels;
    Object.defineProperty(convert[model], 'channels', {
        value: channels
    });
    Object.defineProperty(convert[model], 'labels', {
        value: labels
    });
}
convert.rgb.hsl = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var min = Math.min(r, g, b);
    var max = Math.max(r, g, b);
    var delta = max - min;
    var h;
    var s;
    var l;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
convert.rgb.hsv = function(rgb) {
    var rdif;
    var gdif;
    var bdif;
    var h;
    var s;
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var v = Math.max(r, g, b);
    var diff = v - Math.min(r, g, b);
    var diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) h = s = 0;
    else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
convert.rgb.hwb = function(rgb) {
    var r = rgb[0];
    var g = rgb[1];
    var b = rgb[2];
    var h = convert.rgb.hsl(rgb)[0];
    var w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
convert.rgb.cmyk = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var c;
    var m;
    var y;
    var k;
    k = Math.min(1 - r, 1 - g, 1 - b);
    c = (1 - r - k) / (1 - k) || 0;
    m = (1 - g - k) / (1 - k) || 0;
    y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
/**
 * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
 * */ function comparativeDistance(x, y) {
    return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
}
convert.rgb.keyword = function(rgb) {
    var reversed = reverseKeywords[rgb];
    if (reversed) return reversed;
    var currentClosestDistance = Infinity;
    var currentClosestKeyword;
    for(var keyword in cssKeywords)if (cssKeywords.hasOwnProperty(keyword)) {
        var value = cssKeywords[keyword];
        // Compute comparative distance
        var distance = comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
convert.keyword.rgb = function(keyword) {
    return cssKeywords[keyword];
};
convert.rgb.xyz = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    // assume sRGB
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
convert.rgb.lab = function(rgb) {
    var xyz = convert.rgb.xyz(rgb);
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
convert.hsl.rgb = function(hsl) {
    var h = hsl[0] / 360;
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var t1;
    var t2;
    var t3;
    var rgb;
    var val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    t1 = 2 * l - t2;
    rgb = [
        0,
        0,
        0
    ];
    for(var i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
convert.hsl.hsv = function(hsl) {
    var h = hsl[0];
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var smin = s;
    var lmin = Math.max(l, 0.01);
    var sv;
    var v;
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    v = (l + s) / 2;
    sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
convert.hsv.rgb = function(hsv) {
    var h = hsv[0] / 60;
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var hi = Math.floor(h) % 6;
    var f = h - Math.floor(h);
    var p = 255 * v * (1 - s);
    var q = 255 * v * (1 - s * f);
    var t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
convert.hsv.hsl = function(hsv) {
    var h = hsv[0];
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var vmin = Math.max(v, 0.01);
    var lmin;
    var sl;
    var l;
    l = (2 - s) * v;
    lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
convert.hwb.rgb = function(hwb) {
    var h = hwb[0] / 360;
    var wh = hwb[1] / 100;
    var bl = hwb[2] / 100;
    var ratio = wh + bl;
    var i;
    var v;
    var f;
    var n;
    // wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    i = Math.floor(6 * h);
    v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    n = wh + f * (v - wh); // linear interpolation
    var r;
    var g;
    var b;
    switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
convert.cmyk.rgb = function(cmyk) {
    var c = cmyk[0] / 100;
    var m = cmyk[1] / 100;
    var y = cmyk[2] / 100;
    var k = cmyk[3] / 100;
    var r;
    var g;
    var b;
    r = 1 - Math.min(1, c * (1 - k) + k);
    g = 1 - Math.min(1, m * (1 - k) + k);
    b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
convert.xyz.rgb = function(xyz) {
    var x = xyz[0] / 100;
    var y = xyz[1] / 100;
    var z = xyz[2] / 100;
    var r;
    var g;
    var b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // assume sRGB
    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
convert.xyz.lab = function(xyz) {
    var x = xyz[0];
    var y = xyz[1];
    var z = xyz[2];
    var l;
    var a;
    var b;
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    l = 116 * y - 16;
    a = 500 * (x - y);
    b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
convert.lab.xyz = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var x;
    var y;
    var z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    var y2 = Math.pow(y, 3);
    var x2 = Math.pow(x, 3);
    var z2 = Math.pow(z, 3);
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
convert.lab.lch = function(lab) {
    var l = lab[0];
    var a = lab[1];
    var b = lab[2];
    var hr;
    var h;
    var c;
    hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
convert.lch.lab = function(lch) {
    var l = lch[0];
    var c = lch[1];
    var h = lch[2];
    var a;
    var b;
    var hr;
    hr = h / 360 * 2 * Math.PI;
    a = c * Math.cos(hr);
    b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
convert.rgb.ansi16 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
convert.hsv.ansi16 = function(args) {
    // optimization here; we already know the value and don't need to get
    // it converted for us.
    return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
};
convert.rgb.ansi256 = function(args) {
    var r = args[0];
    var g = args[1];
    var b = args[2];
    // we use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
convert.ansi16.rgb = function(args) {
    var color = args % 10;
    // handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    var mult = (~~(args > 50) + 1) * 0.5;
    var r = (color & 1) * mult * 255;
    var g = (color >> 1 & 1) * mult * 255;
    var b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
convert.ansi256.rgb = function(args) {
    // handle greyscale
    if (args >= 232) {
        var c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    var rem;
    var r = Math.floor(args / 36) / 5 * 255;
    var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    var b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
convert.rgb.hex = function(args) {
    var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    var string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
convert.hex.rgb = function(args) {
    var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    var colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split('').map(function(char) {
        return char + char;
    }).join('');
    var integer = parseInt(colorString, 16);
    var r = integer >> 16 & 0xFF;
    var g = integer >> 8 & 0xFF;
    var b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
convert.rgb.hcg = function(rgb) {
    var r = rgb[0] / 255;
    var g = rgb[1] / 255;
    var b = rgb[2] / 255;
    var max = Math.max(Math.max(r, g), b);
    var min = Math.min(Math.min(r, g), b);
    var chroma = max - min;
    var grayscale;
    var hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma + 4;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
convert.hsl.hcg = function(hsl) {
    var s = hsl[1] / 100;
    var l = hsl[2] / 100;
    var c = 1;
    var f = 0;
    if (l < 0.5) c = 2.0 * s * l;
    else c = 2.0 * s * (1.0 - l);
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
convert.hsv.hcg = function(hsv) {
    var s = hsv[1] / 100;
    var v = hsv[2] / 100;
    var c = s * v;
    var f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
convert.hcg.rgb = function(hcg) {
    var h = hcg[0] / 360;
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    var pure = [
        0,
        0,
        0
    ];
    var hi = h % 1 * 6;
    var v = hi % 1;
    var w = 1 - v;
    var mg = 0;
    switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
convert.hcg.hsv = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    var f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
convert.hcg.hsl = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var l = g * (1.0 - c) + 0.5 * c;
    var s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
convert.hcg.hwb = function(hcg) {
    var c = hcg[1] / 100;
    var g = hcg[2] / 100;
    var v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
convert.hwb.hcg = function(hwb) {
    var w = hwb[1] / 100;
    var b = hwb[2] / 100;
    var v = 1 - b;
    var c = v - w;
    var g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
convert.gray.hsl = convert.gray.hsv = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
convert.gray.hex = function(gray) {
    var val = Math.round(gray[0] / 100 * 255) & 0xFF;
    var integer = (val << 16) + (val << 8) + val;
    var string = integer.toString(16).toUpperCase();
    return '000000'.substring(string.length) + string;
};
convert.rgb.gray = function(rgb) {
    var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};

},{"efc99055946c4df8":"jFlGZ"}],"jFlGZ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

},{}],"kKA9p":[function(require,module,exports,__globalThis) {
var conversions = require("22442592002c5ac3");
/*
	this function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function buildGraph() {
    var graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    var models = Object.keys(conversions);
    for(var len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function deriveBFS(fromModel) {
    var graph = buildGraph();
    var queue = [
        fromModel
    ]; // unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        var current = queue.pop();
        var adjacents = Object.keys(conversions[current]);
        for(var len = adjacents.length, i = 0; i < len; i++){
            var adjacent = adjacents[i];
            var node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function wrapConversion(toModel, graph) {
    var path = [
        graph[toModel].parent,
        toModel
    ];
    var fn = conversions[graph[toModel].parent][toModel];
    var cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = link(conversions[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
module.exports = function(fromModel) {
    var graph = deriveBFS(fromModel);
    var conversion = {};
    var models = Object.keys(graph);
    for(var len = models.length, i = 0; i < len; i++){
        var toModel = models[i];
        var node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = wrapConversion(toModel, graph);
    }
    return conversion;
};

},{"22442592002c5ac3":"ktony"}],"5ZmYW":[function(require,module,exports,__globalThis) {
/* MIT license */ var colorNames = require("9e8c28b9071d0061");
module.exports = {
    getRgba: getRgba,
    getHsla: getHsla,
    getRgb: getRgb,
    getHsl: getHsl,
    getHwb: getHwb,
    getAlpha: getAlpha,
    hexString: hexString,
    rgbString: rgbString,
    rgbaString: rgbaString,
    percentString: percentString,
    percentaString: percentaString,
    hslString: hslString,
    hslaString: hslaString,
    hwbString: hwbString,
    keyword: keyword
};
function getRgba(string) {
    if (!string) return;
    var abbr = /^#([a-fA-F0-9]{3})$/, hex = /^#([a-fA-F0-9]{6})$/, rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/, per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/, keyword = /(\D+)/;
    var rgb = [
        0,
        0,
        0
    ], a = 1, match = string.match(abbr);
    if (match) {
        match = match[1];
        for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i] + match[i], 16);
    } else if (match = string.match(hex)) {
        match = match[1];
        for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
    } else if (match = string.match(rgba)) {
        for(var i = 0; i < rgb.length; i++)rgb[i] = parseInt(match[i + 1]);
        a = parseFloat(match[4]);
    } else if (match = string.match(per)) {
        for(var i = 0; i < rgb.length; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        a = parseFloat(match[4]);
    } else if (match = string.match(keyword)) {
        if (match[1] == "transparent") return [
            0,
            0,
            0,
            0
        ];
        rgb = colorNames[match[1]];
        if (!rgb) return;
    }
    for(var i = 0; i < rgb.length; i++)rgb[i] = scale(rgb[i], 0, 255);
    if (!a && a != 0) a = 1;
    else a = scale(a, 0, 1);
    rgb[3] = a;
    return rgb;
}
function getHsla(string) {
    if (!string) return;
    var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = scale(parseInt(match[1]), 0, 360), s = scale(parseFloat(match[2]), 0, 100), l = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
}
function getHwb(string) {
    if (!string) return;
    var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = scale(parseInt(match[1]), 0, 360), w = scale(parseFloat(match[2]), 0, 100), b = scale(parseFloat(match[3]), 0, 100), a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
}
function getRgb(string) {
    var rgba = getRgba(string);
    return rgba && rgba.slice(0, 3);
}
function getHsl(string) {
    var hsla = getHsla(string);
    return hsla && hsla.slice(0, 3);
}
function getAlpha(string) {
    var vals = getRgba(string);
    if (vals) return vals[3];
    else if (vals = getHsla(string)) return vals[3];
    else if (vals = getHwb(string)) return vals[3];
}
// generators
function hexString(rgb) {
    return "#" + hexDouble(rgb[0]) + hexDouble(rgb[1]) + hexDouble(rgb[2]);
}
function rgbString(rgba, alpha) {
    if (alpha < 1 || rgba[3] && rgba[3] < 1) return rgbaString(rgba, alpha);
    return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
}
function rgbaString(rgba, alpha) {
    if (alpha === undefined) alpha = rgba[3] !== undefined ? rgba[3] : 1;
    return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
}
function percentString(rgba, alpha) {
    if (alpha < 1 || rgba[3] && rgba[3] < 1) return percentaString(rgba, alpha);
    var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
    return "rgb(" + r + "%, " + g + "%, " + b + "%)";
}
function percentaString(rgba, alpha) {
    var r = Math.round(rgba[0] / 255 * 100), g = Math.round(rgba[1] / 255 * 100), b = Math.round(rgba[2] / 255 * 100);
    return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
}
function hslString(hsla, alpha) {
    if (alpha < 1 || hsla[3] && hsla[3] < 1) return hslaString(hsla, alpha);
    return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
}
function hslaString(hsla, alpha) {
    if (alpha === undefined) alpha = hsla[3] !== undefined ? hsla[3] : 1;
    return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
}
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
function hwbString(hwb, alpha) {
    if (alpha === undefined) alpha = hwb[3] !== undefined ? hwb[3] : 1;
    return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
}
function keyword(rgb) {
    return reverseNames[rgb.slice(0, 3)];
}
// helpers
function scale(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function hexDouble(num) {
    var str = num.toString(16).toUpperCase();
    return str.length < 2 ? "0" + str : str;
}
//create a list of reverse color names
var reverseNames = {};
for(var name in colorNames)reverseNames[colorNames[name]] = name;

},{"9e8c28b9071d0061":"cFX3f"}],"cFX3f":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

},{}],"8H3MU":[function(require,module,exports,__globalThis) {
module.exports = [
    '#01888C',
    '#FC7500',
    '#034F5D',
    '#F73F01',
    '#FC1960',
    '#C7144C',
    '#F3C100',
    '#1598F2',
    '#2465E1',
    '#F19E02'
];

},{}],"bvuQg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addressToJazzIconSeed", ()=>addressToJazzIconSeed);
var _client = require("@oasisprotocol/client");
const addressToJazzIconSeed = (address)=>{
    // https://github.com/oasisprotocol/oasis-wallet-ext/blob/da7ad67/src/popup/component/AccountIcon/index.js#L26
    const addressU8 = (0, _client.staking).addressFromBech32(address);
    const seed = addressU8[20] | addressU8[19] << 8 | addressU8[18] << 16 | addressU8[17] << 24;
    return seed;
};

},{"@oasisprotocol/client":"9pxEg","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"crRSf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UserSettings", ()=>UserSettings);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var UserSettings = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "UserSettings"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M18 21c-1.655 0-3-1.346-3-3s1.345-3 3-3c1.654 0 3 1.346 3 3s-1.346 3-3 3zm6-3h-3 3zm-3.879 2.122 2.121 2.12-2.12-2.12zM18.001 24v-3 3zm-4.244-1.757 2.121-2.122-2.12 2.122zM12 18h3-3zm3.878-2.121-2.12-2.121 2.12 2.12zm2.122-.88v-3 3zm2.121.88 2.121-2.121-2.12 2.12zM12.5 12.5C11.266 11.446 9.775 11 8 11c-3.866 0-7 2.03-7 7v5h10M8 11A5 5 0 1 0 8 1a5 5 0 0 0 0 10z"
    }));
});
UserSettings.displayName = 'UserSettings';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"glXVd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Contacts", ()=>Contacts);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _inbox = require("grommet-icons/es6/icons/Inbox");
var _selectors = require("app/state/contacts/selectors");
var _selectUnlockedStatus = require("app/state/selectUnlockedStatus");
var _contactAccount = require("./ContactAccount");
var _addContact = require("./AddContact");
var _scrollableContainer = require("../ScrollableContainer");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
const ContactsListEmptyState = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        flex: "grow",
        gap: "medium",
        align: "center",
        pad: {
            top: 'large'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inbox.Inbox), {
                size: "36px"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                flex: "grow",
                pad: "large",
                children: children
            })
        ]
    });
const Contacts = ({ closeHandler })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const [layerVisibility, setLayerVisibility] = (0, _react.useState)(false);
    const contacts = (0, _reactRedux.useSelector)((0, _selectors.selectContactsList));
    const unlockedStatus = (0, _reactRedux.useSelector)((0, _selectUnlockedStatus.selectUnlockedStatus));
    const isAvailable = unlockedStatus === 'unlockedProfile';
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    const navigate = (0, _reactRouterDom.useNavigate)();
    if (!isAvailable) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContactsListEmptyState, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
            style: {
                display: 'block'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                i18nKey: "toolbar.contacts.notAvailable",
                t: t,
                components: {
                    OpenWalletButton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        color: "link",
                        onClick: ()=>{
                            closeHandler();
                            navigate('/open-wallet');
                        }
                    })
                },
                defaults: "To start adding contacts create a profile while <OpenWalletButton>opening a wallet</OpenWalletButton>."
            })
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                flex: "grow",
                justify: "between",
                gap: "medium",
                style: {
                    height: isMobile ? '0' : 'auto'
                },
                children: [
                    !contacts.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContactsListEmptyState, {
                        children: t('toolbar.contacts.emptyList', 'You have no contacts yet.')
                    }),
                    !!contacts.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scrollableContainer.ScrollableContainer), {
                        children: contacts.map((contact)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contactAccount.ContactAccount), {
                                contact: contact
                            }, contact.address))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        direction: "row",
                        justify: "end",
                        gap: "medium",
                        flex: "grow",
                        align: "end",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            primary: true,
                            label: t('toolbar.contacts.add', 'Add contact'),
                            onClick: ()=>setLayerVisibility(true)
                        })
                    })
                ]
            }),
            layerVisibility && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addContact.AddContact), {
                setLayerVisibility: setLayerVisibility
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-redux":"azV3Y","react-i18next":"7GUHL","react-router-dom":"9pTjq","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet-icons/es6/icons/Inbox":"cDkIg","app/state/contacts/selectors":"iLmat","app/state/selectUnlockedStatus":"aRpzm","./ContactAccount":"6yAWJ","./AddContact":"6g0fm","../ScrollableContainer":"aqCoJ","grommet/es6/contexts/ResponsiveContext":"7EsNN","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cDkIg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Inbox", ()=>Inbox);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Inbox = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Inbox"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 13 6 2h12l5 11v9H1v-9zm0 0h7v3h8v-3h7"
    }));
});
Inbox.displayName = 'Inbox';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iLmat":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectContactsList", ()=>selectContactsList);
parcelHelpers.export(exports, "selectContact", ()=>selectContact);
var _toolkit = require("@reduxjs/toolkit");
var _ = require(".");
const selectSlice = (state)=>state.contacts || (0, _.initialState);
const selectContactsList = (0, _toolkit.createSelector)([
    selectSlice
], (contacts)=>Object.values(contacts));
const selectContact = (address)=>(0, _toolkit.createSelector)([
        selectContactsList
    ], (contacts)=>contacts.find((contact)=>contact.address === address));

},{"@reduxjs/toolkit":"9ol63",".":"83A9K","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6yAWJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContactAccount", ()=>ContactAccount);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactI18Next = require("react-i18next");
var _box = require("grommet/es6/components/Box");
var _tabs = require("grommet/es6/components/Tabs");
var _tab = require("grommet/es6/components/Tab");
var _contacts = require("app/state/contacts");
var _account = require("../Account/Account");
var _contactAccountForm = require("./ContactAccountForm");
var _layerContainer = require("../LayerContainer");
const ContactAccount = ({ contact })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const [layerVisibility, setLayerVisibility] = (0, _react.useState)(false);
    const dispatch = (0, _reactRedux.useDispatch)();
    const submitHandler = (contact)=>dispatch((0, _contacts.contactsActions).update(contact));
    const deleteHandler = (address)=>dispatch((0, _contacts.contactsActions).delete(address));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _account.Account), {
                address: contact.address,
                balance: undefined,
                displayBalance: false,
                displayManageButton: {
                    onClickManage: ()=>setLayerVisibility(true)
                },
                isActive: false,
                name: contact.name,
                onClick: ()=>setLayerVisibility(true)
            }, contact.address),
            layerVisibility && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layerContainer.LayerContainer), {
                hideLayer: ()=>setLayerVisibility(false),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabs.Tabs), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tab.Tab), {
                        title: t('toolbar.contacts.manage', 'Manage Contact'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                            flex: "grow",
                            justify: "center",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contactAccountForm.ContactAccountForm), {
                                contact: contact,
                                onDelete: (address)=>{
                                    deleteHandler(address);
                                    setLayerVisibility(false);
                                },
                                onCancel: ()=>setLayerVisibility(false),
                                onSave: (contract)=>{
                                    submitHandler(contract);
                                    setLayerVisibility(false);
                                }
                            })
                        })
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-redux":"azV3Y","react-i18next":"7GUHL","grommet/es6/components/Box":"4o01A","grommet/es6/components/Tabs":"hlkTL","grommet/es6/components/Tab":"ljnB8","app/state/contacts":"83A9K","../Account/Account":"72YoH","./ContactAccountForm":"g4NiO","../LayerContainer":"fZ8B7","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"g4NiO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContactAccountForm", ()=>ContactAccountForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactI18Next = require("react-i18next");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _form = require("grommet/es6/components/Form");
var _formField = require("grommet/es6/components/FormField");
var _textInput = require("grommet/es6/components/TextInput");
var _textArea = require("grommet/es6/components/TextArea");
var _selectors = require("app/state/contacts/selectors");
var _helpers = require("app/lib/helpers");
var _deleteContact = require("./DeleteContact");
const ContactAccountForm = ({ contact, onDelete, onCancel, onSave })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const [deleteLayerVisibility, setDeleteLayerVisibility] = (0, _react.useState)(false);
    const [value, setValue] = (0, _react.useState)({
        name: contact?.name || '',
        address: contact?.address || ''
    });
    const contacts = (0, _reactRedux.useSelector)((0, _selectors.selectContactsList));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
        style: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column'
        },
        messages: {
            required: t('toolbar.contacts.validation.required', 'Field is required')
        },
        onChange: (nextValue)=>setValue(nextValue),
        onSubmit: ({ value })=>onSave({
                address: value.address.replaceAll(' ', ''),
                name: value.name.trim()
            }),
        value: value,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                flex: "grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
                        name: "name",
                        required: true,
                        validate: (name)=>name.trim().length > 16 ? {
                                message: t('toolbar.contacts.validation.nameLengthError', 'No more than 16 characters'),
                                status: 'error'
                            } : undefined,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInput.TextInput), {
                            name: "name",
                            placeholder: t('toolbar.contacts.name', 'Name')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
                        disabled: !!contact,
                        name: "address",
                        required: true,
                        validate: (address)=>!(0, _helpers.isValidAddress)(address.replaceAll(' ', '')) ? {
                                message: t('toolbar.contacts.validation.addressError', 'Please enter a valid wallet address'),
                                status: 'error'
                            } : !contact && contacts.find((contact)=>contact.address === address.replaceAll(' ', '')) ? {
                                message: t('toolbar.contacts.validation.addressNotUniqueError', 'Address already exists'),
                                status: 'error'
                            } : undefined,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textArea.TextArea), {
                            disabled: !!contact,
                            rows: 3,
                            name: "address",
                            placeholder: t('toolbar.contacts.address', 'Address')
                        })
                    }),
                    contact && onDelete && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                        align: "end",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                style: {
                                    fontSize: '14px',
                                    fontWeight: 600
                                },
                                margin: {
                                    vertical: 'medium'
                                },
                                color: "status-error",
                                label: t('toolbar.contacts.delete.button', 'Delete contact'),
                                onClick: ()=>setDeleteLayerVisibility(true),
                                plain: true
                            }),
                            deleteLayerVisibility && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteContact.DeleteContact), {
                                onDelete: ()=>onDelete(contact.address),
                                onCancel: ()=>setDeleteLayerVisibility(false)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                direction: "row",
                align: "center",
                justify: "between",
                pad: {
                    top: 'medium'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        label: t('toolbar.contacts.cancel', 'Cancel'),
                        onClick: onCancel
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        type: "submit",
                        label: t('toolbar.contacts.save', 'Save'),
                        primary: true
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-redux":"azV3Y","react-i18next":"7GUHL","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Form":"kRCRN","grommet/es6/components/FormField":"dcsVI","grommet/es6/components/TextInput":"cL4wi","grommet/es6/components/TextArea":"8mQse","app/state/contacts/selectors":"iLmat","app/lib/helpers":"bUnFy","./DeleteContact":"9qXI2","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9qXI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeleteContact", ()=>DeleteContact);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _text = require("grommet/es6/components/Text");
var _responsiveLayer = require("../../../ResponsiveLayer");
const DeleteContact = ({ onCancel, onDelete })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveLayer.ResponsiveLayer), {
        onClickOutside: onCancel,
        onEsc: onCancel,
        animation: "none",
        background: "background-front",
        modal: true,
        margin: isMobile ? 'none' : 'xlarge',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            margin: "medium",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    flex: "grow",
                    justify: "center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                            weight: "bold",
                            size: "medium",
                            alignSelf: "center",
                            margin: {
                                bottom: 'large'
                            },
                            children: t('toolbar.contacts.delete.title', 'Delete Contact')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                            size: "medium",
                            alignSelf: "center",
                            margin: {
                                bottom: 'medium'
                            },
                            children: t('toolbar.contacts.delete.description', 'Are you sure you want to delete this contact?')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    direction: "row",
                    align: "center",
                    justify: "between",
                    pad: {
                        top: 'medium'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            label: t('toolbar.contacts.cancel', 'Cancel'),
                            onClick: onCancel
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            onClick: onDelete,
                            label: t('toolbar.contacts.delete.confirm', 'Yes, delete'),
                            color: "status-error",
                            primary: true
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-i18next":"7GUHL","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/contexts/ResponsiveContext":"7EsNN","grommet/es6/components/Text":"kz1Ni","../../../ResponsiveLayer":"3jeKP","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6g0fm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddContact", ()=>AddContact);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _reactI18Next = require("react-i18next");
var _box = require("grommet/es6/components/Box");
var _tabs = require("grommet/es6/components/Tabs");
var _tab = require("grommet/es6/components/Tab");
var _contacts = require("app/state/contacts");
var _contactAccountForm = require("./ContactAccountForm");
var _layerContainer = require("../LayerContainer");
const AddContact = ({ setLayerVisibility })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const submitHandler = (contact)=>dispatch((0, _contacts.contactsActions).add(contact));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layerContainer.LayerContainer), {
        hideLayer: ()=>setLayerVisibility(false),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tabs.Tabs), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tab.Tab), {
                title: t('toolbar.contacts.add', 'Add contact'),
                style: {
                    textTransform: 'capitalize'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                    flex: "grow",
                    justify: "center",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contactAccountForm.ContactAccountForm), {
                        onCancel: ()=>setLayerVisibility(false),
                        onSave: (contract)=>{
                            submitHandler(contract);
                            setLayerVisibility(false);
                        }
                    })
                })
            })
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react-redux":"azV3Y","react-i18next":"7GUHL","grommet/es6/components/Box":"4o01A","grommet/es6/components/Tabs":"hlkTL","grommet/es6/components/Tab":"ljnB8","app/state/contacts":"83A9K","./ContactAccountForm":"g4NiO","../LayerContainer":"fZ8B7","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"tlOFg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Profile", ()=>Profile);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _reactI18Next = require("react-i18next");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _user = require("grommet-icons/es6/icons/User");
var _selectUnlockedStatus = require("app/state/selectUnlockedStatus");
var _updatePassword = require("./UpdatePassword");
var _deleteProfileButton = require("../../../Persist/DeleteProfileButton");
var _muiLockIcon = require("../../../../../styles/theme/icons/mui-icons/MuiLockIcon");
var _logout = require("grommet-icons/es6/icons/Logout");
var _selectIsLockableOrCloseable = require("app/state/selectIsLockableOrCloseable");
var _persist = require("app/state/persist");
const ProfileEmptyState = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        gap: "medium",
        align: "center",
        pad: {
            top: 'large'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _user.User), {
                size: "36px"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                pad: "large",
                children: children
            })
        ]
    });
const Profile = ({ closeHandler })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const unlockedStatus = (0, _reactRedux.useSelector)((0, _selectUnlockedStatus.selectUnlockedStatus));
    const isProfileAvailable = unlockedStatus === 'unlockedProfile';
    const navigate = (0, _reactRouterDom.useNavigate)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const isLockableOrCloseable = (0, _reactRedux.useSelector)((0, _selectIsLockableOrCloseable.selectIsLockableOrCloseable));
    const closeWallet = ()=>{
        navigate('/');
        dispatch((0, _persist.persistActions).lockAsync());
    };
    const lockProfile = ()=>{
        dispatch((0, _persist.persistActions).lockAsync());
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                flex: "grow",
                children: [
                    !isProfileAvailable && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProfileEmptyState, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                            style: {
                                display: 'block'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                                i18nKey: "toolbar.profile.notAvailable",
                                t: t,
                                components: {
                                    OpenWalletButton: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        color: "link",
                                        onClick: ()=>{
                                            closeHandler();
                                            navigate('/open-wallet');
                                        }
                                    })
                                },
                                defaults: "You can setup your profile while <OpenWalletButton>opening a wallet</OpenWalletButton>."
                            })
                        })
                    }),
                    isProfileAvailable && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _updatePassword.UpdatePassword), {})
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                direction: "row",
                justify: "between",
                gap: "medium",
                margin: {
                    top: '40px'
                },
                children: [
                    isProfileAvailable ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteProfileButton.DeleteProfileButton), {
                        prominent: true,
                        variant: "voluntary"
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {}),
                    isLockableOrCloseable === 'closeable' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        "data-testid": "profile-modal-close-wallet",
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logout.Logout), {}),
                        label: t('menu.closeWallet', 'Close wallet'),
                        onClick: ()=>closeWallet()
                    }),
                    isLockableOrCloseable === 'lockable' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        "data-testid": "profile-modal-lock-wallet",
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _muiLockIcon.MuiLockIcon), {}),
                        label: t('menu.lockProfile', 'Lock profile'),
                        onClick: ()=>lockProfile()
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react-redux":"azV3Y","react-router-dom":"9pTjq","react-i18next":"7GUHL","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet-icons/es6/icons/User":"9QaBV","app/state/selectUnlockedStatus":"aRpzm","./UpdatePassword":"9Zq1W","../../../Persist/DeleteProfileButton":"6sLVF","../../../../../styles/theme/icons/mui-icons/MuiLockIcon":"dbeW0","grommet-icons/es6/icons/Logout":"dMVk6","app/state/selectIsLockableOrCloseable":"92Jcs","app/state/persist":"9hwZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9QaBV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "User", ()=>User);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var User = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "User"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M8 24v-5m8 5v-5M3 24v-5c0-4.97 4.03-8 9-8s9 3.03 9 8v5m-9-13a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
    }));
});
User.displayName = 'User';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9Zq1W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpdatePassword", ()=>UpdatePassword);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactI18Next = require("react-i18next");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _form = require("grommet/es6/components/Form");
var _notification = require("grommet/es6/components/Notification");
var _choosePasswordInputFields = require("app/components/Persist/ChoosePasswordInputFields");
var _passwordField = require("app/components/PasswordField");
var _preventSavingInputsToUserData = require("app/lib/preventSavingInputsToUserData");
var _persist = require("app/state/persist");
var _selectors = require("app/state/persist/selectors");
const defaultFormValue = {
    currentPassword: '',
    password1: '',
    password2: ''
};
const UpdatePassword = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const [notificationVisible, setNotificationVisible] = (0, _react.useState)(false);
    const enteredWrongPassword = (0, _reactRedux.useSelector)((0, _selectors.selectEnteredWrongPassword));
    const isProfileReloadingAfterPasswordUpdate = (0, _reactRedux.useSelector)((0, _selectors.selectLoading));
    const [value, setValue] = (0, _react.useState)(defaultFormValue);
    const onSubmit = ({ value })=>{
        if (!value.currentPassword || !value.password1) return;
        dispatch((0, _persist.persistActions).updatePasswordAsync({
            currentPassword: value.currentPassword,
            password: value.password1
        }));
    };
    (0, _react.useEffect)(()=>{
        return ()=>{
            dispatch((0, _persist.persistActions).resetWrongPassword());
        };
    }, [
        dispatch
    ]);
    (0, _react.useEffect)(()=>{
        // reloading occurs after successful password update
        if (isProfileReloadingAfterPasswordUpdate) {
            setNotificationVisible(true);
            setValue(defaultFormValue);
        }
    }, [
        isProfileReloadingAfterPasswordUpdate
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
        onSubmit: onSubmit,
        ...(0, _preventSavingInputsToUserData.preventSavingInputsToUserData),
        onChange: (nextValue)=>{
            dispatch((0, _persist.persistActions).resetWrongPassword());
            setValue(nextValue);
        },
        value: value,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                htmlFor: "currentPassword",
                children: t('toolbar.profile.password.title', 'Set a new password')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _passwordField.PasswordField), {
                placeholder: t('toolbar.profile.password.current', 'Current password'),
                inputElementId: "currentPassword",
                name: "currentPassword",
                validate: (value)=>value ? undefined : t('toolbar.profile.password.enterCurrent', 'Enter your current password'),
                error: enteredWrongPassword ? t('persist.loginToProfile.wrongPassword', 'Wrong password') : false,
                showTip: t('persist.loginToProfile.showPassword', 'Show password'),
                hideTip: t('persist.loginToProfile.hidePassword', 'Hide password'),
                width: "medium"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _choosePasswordInputFields.ChoosePasswordInputFields), {
                password1Placeholder: t('toolbar.profile.password.enterNewPassword', 'New password'),
                password2Placeholder: t('toolbar.profile.password.reenterNewPassword', 'Re-enter new password')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                direction: "row",
                margin: {
                    top: 'medium'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                    primary: true,
                    type: "submit",
                    label: t('toolbar.profile.password.submit', 'Update password')
                })
            }),
            notificationVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notification.Notification), {
                toast: true,
                status: 'normal',
                title: t('toolbar.profile.password.success', 'Password updated.'),
                onClose: ()=>setNotificationVisible(false)
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-redux":"azV3Y","react-i18next":"7GUHL","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Form":"kRCRN","grommet/es6/components/Notification":"1osU9","app/components/Persist/ChoosePasswordInputFields":"5oBbr","app/components/PasswordField":"hEUcp","app/lib/preventSavingInputsToUserData":"idfdE","app/state/persist":"9hwZK","app/state/persist/selectors":"lDilG","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5oBbr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChoosePasswordInputFields", ()=>ChoosePasswordInputFields);
var _jsxRuntime = require("react/jsx-runtime");
var _passwordField = require("app/components/PasswordField");
var _reactI18Next = require("react-i18next");
function ChoosePasswordInputFields({ password1Placeholder, password2Placeholder }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _passwordField.PasswordField), {
                placeholder: password1Placeholder,
                inputElementId: "password1",
                name: "password1",
                validate: (value)=>value ? undefined : t('persist.loginToProfile.enterPasswordHere', 'Enter your password'),
                showTip: t('persist.loginToProfile.showPassword', 'Show password'),
                hideTip: t('persist.loginToProfile.hidePassword', 'Hide password'),
                width: "medium"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _passwordField.PasswordField), {
                placeholder: password2Placeholder,
                inputElementId: "password2",
                name: "password2",
                validate: (value, form)=>form.password1 !== form.password2 ? t('persist.createProfile.passwordMismatch', 'Entered password does not match') : undefined,
                showTip: t('persist.loginToProfile.showPassword', 'Show password'),
                hideTip: t('persist.loginToProfile.hidePassword', 'Hide password'),
                width: "medium"
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","app/components/PasswordField":"hEUcp","react-i18next":"7GUHL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hEUcp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PasswordField", ()=>PasswordField);
var _jsxRuntime = require("react/jsx-runtime");
var _preventSavingInputsToUserData = require("app/lib/preventSavingInputsToUserData");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _formField = require("grommet/es6/components/FormField");
var _textInput = require("grommet/es6/components/TextInput");
var _tip = require("grommet/es6/components/Tip");
var _view = require("grommet-icons/es6/icons/View");
var _hide = require("grommet-icons/es6/icons/Hide");
var _react = require("react");
function PasswordField(props) {
    const [passwordIsVisible, setPasswordIsVisible] = _react.useState(false);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        width: {
            max: props.width
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
            name: props.name,
            htmlFor: props.inputElementId,
            label: props.label,
            validate: props.validate,
            error: props.error ? props.error : '',
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                direction: "row",
                align: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInput.TextInput), {
                        id: props.inputElementId,
                        name: props.name,
                        placeholder: props.placeholder,
                        value: props.value,
                        onChange: props.onChange,
                        type: passwordIsVisible ? 'text' : 'password',
                        required: props.required,
                        autoFocus: props.autoFocus,
                        plain: true,
                        suggestions: props.suggestions,
                        ...(0, _preventSavingInputsToUserData.preventSavingInputsToUserData)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tip.Tip), {
                        content: passwordIsVisible ? props.hideTip : props.showTip,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            onClick: ()=>setPasswordIsVisible(!passwordIsVisible),
                            icon: passwordIsVisible ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _view.View), {
                                size: "24px"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hide.Hide), {
                                size: "24px"
                            }),
                            a11yTitle: passwordIsVisible ? props.hideTip : props.showTip
                        })
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"6pm7f","app/lib/preventSavingInputsToUserData":"idfdE","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/FormField":"dcsVI","grommet/es6/components/TextInput":"cL4wi","grommet/es6/components/Tip":"55RvR","grommet-icons/es6/icons/View":"KnlXo","grommet-icons/es6/icons/Hide":"8Uhrk","react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"idfdE":[function(require,module,exports,__globalThis) {
/**
 * Usage: Add to sensitive inputs, textareas, and parent forms (because Chrome
 * doesn't support it on textareas).
 *
 * Browsers write visible input fields from any website to user data to enable
 * restoring sessions. Browsers exclude inputs with autocomplete="off" from
 * cached form data in the session history (even though they ignore it and still
 * offer autofill from saved passwords). Browsers with enhanced spellcheck also
 * send it to the cloud.
 *
 * To ensure this fixes vulnerability:
 * - Manually checked
 *   grep --text t.e.s.t.M.n.e.m.o.n.i.c -r ~/.config/google-chrome
 *   grep --text testMnemonic -r ~/.mozilla/firefox
 * - Added CSS to visually warn about sensitive input fields missing
 *   preventSavingInputsToUserData
 * - Added E2E tests that check for plaintext mnemonic, privatekey, and password
 *   inside user data
 *
 * References:
 * - https://nvd.nist.gov/vuln/detail/CVE-2022-32969
 * - https://coinyuppie.com/slow-mist-a-brief-analysis-of-the-metamask-wallet-demonic-vulnerability/
 * - https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
 * - https://nvd.nist.gov/vuln/detail/CVE-2022-0167
 * - https://www.otto-js.com/news/article/spell-jacking-enhanced-spellcheck-features-send-pii-even-passwords
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "preventSavingInputsToUserData", ()=>preventSavingInputsToUserData);
const preventSavingInputsToUserData = {
    autoComplete: 'off',
    autoCapitalize: 'off',
    autoCorrect: 'off',
    spellCheck: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"KnlXo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "View", ()=>View);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var View = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "View"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 21c-5 0-11-5-11-9s6-9 11-9 11 5 11 9-6 9-11 9zm0-14a5 5 0 1 0 0 10 5 5 0 0 0 0-10z"
    }));
});
View.displayName = 'View';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8Uhrk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hide", ()=>Hide);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Hide = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Hide"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 17c-2.727 0-6-2.778-6-5s3.273-5 6-5 6 2.778 6 5-3.273 5-6 5zm-1-5a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm9-7L4 19"
    }));
});
Hide.displayName = 'Hide';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6sLVF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DeleteProfileButton", ()=>DeleteProfileButton);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("grommet/es6/components/Button");
var _persist = require("app/state/persist");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactI18Next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _paragraph = require("grommet/es6/components/Paragraph");
var _deleteInputForm = require("../../components/DeleteInputForm");
var _box = require("grommet/es6/components/Box");
var _layer = require("grommet/es6/components/Layer");
var _header = require("app/components/Header");
function DeleteProfileButton({ prominent, variant }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [layerVisibility, setLayerVisibility] = (0, _react.useState)(false);
    const onCancel = ()=>{
        setLayerVisibility(false);
    };
    const onConfirm = ()=>{
        navigate('/');
        dispatch((0, _persist.persistActions).deleteProfileAsync());
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                color: "status-error",
                label: variant === 'forgot-password' ? t('persist.loginToProfile.deleteProfile.forgotPasswordButton', 'Forgot password?') : t('persist.loginToProfile.deleteProfile.button', 'Delete profile'),
                onClick: ()=>setLayerVisibility(true),
                primary: prominent,
                plain: !prominent
            }),
            layerVisibility && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ModalLayout, {
                title: t('persist.loginToProfile.deleteProfile.title', 'Delete Profile'),
                onClickOutside: onCancel,
                onEsc: onCancel,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteInputForm.DeleteInputForm), {
                    onCancel: onCancel,
                    onConfirm: onConfirm,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paragraph.Paragraph), {
                        fill: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            htmlFor: "type_delete",
                            children: [
                                variant === 'forgot-password' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    children: [
                                        t('persist.loginToProfile.deleteProfile.forgotPasswordDescription', 'ROSE Wallet does not store your password and cannot help you retrieve it. If you forgot your password, you can delete your locked profile here. After that, you can create a new one using your mnemonic phrase or private keys, and use your ROSE tokens again.'),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                                    t: t,
                                    i18nKey: "persist.loginToProfile.deleteProfile.description",
                                    defaults: "This will <strong>permanently remove your private keys from this device.</strong><br/><br/>To confirm and proceed, please type <strong>{{confirmationKeyword}}</strong> below.",
                                    values: {
                                        confirmationKeyword: t('deleteForm.confirmationKeyword', 'delete')
                                    }
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
}
function ModalLayout(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layer.Layer), {
        modal: true,
        background: "background-front",
        onClickOutside: props.onClickOutside,
        onEsc: props.onEsc,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            pad: "medium",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.Header), {
                    level: 2,
                    fill: true,
                    textAlign: "center",
                    margin: {
                        top: 'medium'
                    },
                    children: props.title
                }),
                props.children
            ]
        })
    });
}

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Button":"fVON6","app/state/persist":"9hwZK","react":"8CCva","react-redux":"azV3Y","react-i18next":"7GUHL","react-router-dom":"9pTjq","grommet/es6/components/Paragraph":"kg9QN","../../components/DeleteInputForm":"T2xGV","grommet/es6/components/Box":"4o01A","grommet/es6/components/Layer":"3gh0x","app/components/Header":"bHFRk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bHFRk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", ()=>Header);
parcelHelpers.export(exports, "ModalHeader", ()=>ModalHeader);
parcelHelpers.export(exports, "ModalSplitHeader", ()=>ModalSplitHeader);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("grommet/es6/components/Box");
var _heading = require("grommet/es6/components/Heading");
var _text = require("grommet/es6/components/Text");
const Header = ({ children, level = 2, margin = {
    top: 'none'
}, textAlign, fill, ...props })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _heading.Heading), {
        level: level,
        margin: margin,
        textAlign: textAlign,
        fill: fill,
        ...props,
        children: children
    });
const ModalHeader = ({ children, ...props })=>{
    const { level, ...rest } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
        level: level || 2,
        size: "medium",
        fill: true,
        ...rest,
        children: children
    });
};
const ModalSplitHeader = ({ children, side })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(Header, {
        level: 2,
        size: "medium",
        fill: true,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            direction: "row-responsive",
            gap: "medium",
            justify: "between",
            align: "baseline",
            children: [
                children,
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                    weight: "normal",
                    children: side
                })
            ]
        })
    });

},{"react/jsx-runtime":"6pm7f","react":"8CCva","grommet/es6/components/Box":"4o01A","grommet/es6/components/Heading":"1SnMZ","grommet/es6/components/Text":"kz1Ni","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7U2xG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Settings", ()=>Settings);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _box = require("grommet/es6/components/Box");
var _themeSwitcher = require("app/components/ThemeSwitcher");
var _languageSelect = require("app/components/LanguageSelect");
var _screenPrivacySelect = require("app/components/ScreenPrivacySelect");
var _footer = require("app/components/Footer");
const Settings = ()=>{
    const responsiveContext = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext));
    const isMobileOrTablet = responsiveContext === 'small' || responsiveContext === 'medium';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        gap: "small",
        style: {
            flex: 1,
            justifyContent: 'space-between'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _languageSelect.LanguageSelect), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeSwitcher.ThemeSelect), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _screenPrivacySelect.ScreenPrivacySelect), {})
                ]
            }),
            isMobileOrTablet && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footer.Footer), {})
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","grommet/es6/contexts/ResponsiveContext":"7EsNN","grommet/es6/components/Box":"4o01A","app/components/ThemeSwitcher":"27whc","app/components/LanguageSelect":"gsyi8","app/components/ScreenPrivacySelect":"6qb3B","app/components/Footer":"btUFa","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6qb3B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScreenPrivacySelect", ()=>ScreenPrivacySelect);
var _jsxRuntime = require("react/jsx-runtime");
var _lock = require("grommet-icons/es6/icons/Lock");
var _unlock = require("grommet-icons/es6/icons/Unlock");
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _slice = require("app/state/settings/slice");
var _selectors = require("app/state/settings/slice/selectors");
var _selectWithIcon = require("../SelectWithIcon");
var _runtimeIs = require("app/lib/runtimeIs");
var _privacyScreen = require("app/lib/privacyScreen");
const getScreenPrivacyIcons = (t, size)=>({
        on: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lock.Lock), {
            "aria-label": t('screenPrivacy.on', 'On'),
            size: size
        }),
        off: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unlock.Unlock), {
            "aria-label": t('screenPrivacy.off', 'Off'),
            size: size
        })
    });
const ScreenPrivacySelect = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const screenPrivacy = (0, _reactRedux.useSelector)((0, _selectors.selectScreenPrivacy));
    const dispatch = (0, _reactRedux.useDispatch)();
    const icons = getScreenPrivacyIcons(t, '24px');
    const screenPrivacyOptions = [
        {
            value: 'on',
            label: t('screenPrivacy.on', 'On')
        },
        {
            value: 'off',
            label: t('screenPrivacy.off', 'Off')
        }
    ];
    const handlePrivacyChange = async (newValue)=>{
        try {
            await (0, _privacyScreen.setPrivacyScreen)(newValue);
            dispatch((0, _slice.settingsActions).changeScreenPrivacy(newValue));
        } catch (error) {
            console.error('Failed to change privacy screen:', error);
        }
    };
    if ((0, _runtimeIs.runtimeIs) !== 'mobile-app') return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectWithIcon.SelectWithIcon), {
        label: t('screenPrivacy.title', 'Screen Privacy'),
        id: "screenPrivacy",
        name: "screenPrivacy",
        icon: icons[screenPrivacy],
        value: screenPrivacy,
        options: screenPrivacyOptions,
        onChange: handlePrivacyChange,
        tooltip: t('screenPrivacy.tooltip', 'Prevent sensitive information from being visible in app switchers and when leaving an app.')
    });
};

},{"react/jsx-runtime":"6pm7f","grommet-icons/es6/icons/Lock":"g2CFN","grommet-icons/es6/icons/Unlock":"cAidM","react-i18next":"7GUHL","react-redux":"azV3Y","app/state/settings/slice":"hDJtm","app/state/settings/slice/selectors":"5hbX7","../SelectWithIcon":"hmeUh","app/lib/runtimeIs":"fboJV","app/lib/privacyScreen":"xFp3W","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"g2CFN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Lock", ()=>Lock);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Lock = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Lock"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M19 23V11H5v12h14zm-7-8v4m5-8V7c0-3 0-6-5-6S7 4 7 7v4"
    }));
});
Lock.displayName = 'Lock';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cAidM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Unlock", ()=>Unlock);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Unlock = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Unlock"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M23 23V11H9v12h14zm-9-6h4m-7-6V7c0-3 0-6-5-6S1 4 1 7v4"
    }));
});
Unlock.displayName = 'Unlock';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5hbX7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectScreenPrivacy", ()=>selectScreenPrivacy);
var _toolkit = require("@reduxjs/toolkit");
var _ = require(".");
const selectSlice = (state)=>state.settings || (0, _.getInitialState)();
const selectScreenPrivacy = (0, _toolkit.createSelector)([
    selectSlice
], (settings)=>settings.screenPrivacy);

},{"@reduxjs/toolkit":"9ol63",".":"hDJtm","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"xFp3W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setPrivacyScreen", ()=>setPrivacyScreen);
var _privacyScreen = require("@capacitor/privacy-screen");
var _runtimeIs = require("app/lib/runtimeIs");
const setPrivacyScreen = async (state)=>{
    if ((0, _runtimeIs.runtimeIs) !== 'mobile-app') return;
    if (state === 'on') await (0, _privacyScreen.PrivacyScreen).enable({
        android: {
            preventScreenshots: true,
            dimBackground: true,
            privacyModeOnActivityHidden: 'dim'
        },
        ios: {
            blurEffect: 'dark'
        }
    });
    else await (0, _privacyScreen.PrivacyScreen).disable();
};

},{"@capacitor/privacy-screen":"9P14V","app/lib/runtimeIs":"fboJV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9P14V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PrivacyScreen", ()=>i);
var _core = require("@capacitor/core");
const i = (0, _core.registerPlugin)("PrivacyScreen", {
    web: ()=>require("1402327d1df94b3f").then((e)=>new e.PrivacyScreenWeb())
});

},{"@capacitor/core":"9nVQl","1402327d1df94b3f":"i9mSO","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"i9mSO":[function(require,module,exports,__globalThis) {
module.exports = require("a854edd50864bf21")(module.bundle.resolve("MUzWr")).then(()=>module.bundle.root('84laS'));

},{"a854edd50864bf21":"bxWlo"}],"bIzxE":[function(require,module,exports,__globalThis) {
/**
 *
 * NetworkSelector
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NetworkSelector", ()=>NetworkSelector);
var _jsxRuntime = require("react/jsx-runtime");
var _network = require("app/state/network");
var _selectors = require("app/state/network/selectors");
var _box = require("grommet/es6/components/Box");
var _menu = require("grommet/es6/components/Menu");
var _text = require("grommet/es6/components/Text");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _network1 = require("grommet-icons/es6/icons/Network");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
const NetworkSelector = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const size = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext));
    const selectedNetworkType = (0, _reactRedux.useSelector)((0, _selectors.selectSelectedNetwork));
    const dispatch = (0, _reactRedux.useDispatch)();
    const switchNetwork = (network)=>{
        dispatch((0, _network.networkActions).selectNetwork(network));
    };
    const networkLabels = {
        local: t('toolbar.networks.local', 'Local'),
        mainnet: t('toolbar.networks.mainnet', 'Mainnet'),
        testnet: t('toolbar.networks.testnet', 'Testnet')
    };
    const network = networkLabels[selectedNetworkType];
    const networks = [
        'mainnet',
        'testnet'
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menu.Menu), {
        size: "small",
        style: {
            border: 0
        },
        dropProps: {
            align: {
                top: 'bottom',
                left: 'left'
            },
            elevation: 'xlarge'
        },
        items: networks.map((value)=>({
                label: networkLabels[value],
                onClick: ()=>switchNetwork(value),
                primary: value === selectedNetworkType
            })),
        fill: true,
        a11yTitle: t('toolbar.networks.selector', 'Select network'),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            direction: "row",
            gap: "small",
            pad: "small",
            responsive: false,
            "data-testid": "network-selector",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _network1.Network), {}),
                size !== 'small' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                    "data-testid": "active-network",
                    children: network
                })
            ]
        })
    });
});

},{"react/jsx-runtime":"6pm7f","app/state/network":"8NDHR","app/state/network/selectors":"2zit7","grommet/es6/components/Box":"4o01A","grommet/es6/components/Menu":"fQpGz","grommet/es6/components/Text":"kz1Ni","grommet/es6/contexts/ResponsiveContext":"7EsNN","grommet-icons/es6/icons/Network":"ldSIE","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ldSIE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Network", ()=>Network);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Network = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Network"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M7.5 7v8.514c0 4.243 5.5 2.829 5.5 6.6V24m-2-14L7.5 7 4 10m12.5-8v8.44c0 4.068-3.5 2.712-3.5 6.328V24m0-19 3.5-3L20 5"
    }));
});
Network.displayName = 'Network';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3R41W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModalProvider", ()=>ModalProvider);
parcelHelpers.export(exports, "useModal", ()=>useModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _modalContainer = require("./ModalContainer");
const ModalContext = /*#__PURE__*/ (0, _react.createContext)({});
const ModalProvider = (props)=>{
    const [modal, setModal] = (0, _react.useState)(null);
    const closeModal = (0, _react.useCallback)(()=>{
        setModal(null);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ModalContext.Provider, {
        value: {
            closeModal,
            launchModal: setModal
        },
        children: [
            props.children,
            modal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _modalContainer.ModalContainer), {
                modal: modal,
                closeModal: closeModal
            })
        ]
    });
};
const useModal = ()=>{
    const context = (0, _react.useContext)(ModalContext);
    if (context === undefined) throw new Error('useModal must be used within a ModalProvider');
    return context;
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","./ModalContainer":"3QN6U","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3QN6U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModalContainer", ()=>ModalContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _layer = require("grommet/es6/components/Layer");
var _paragraph = require("grommet/es6/components/Paragraph");
var _reactI18Next = require("react-i18next");
var _alert = require("grommet-icons/es6/icons/Alert");
var _checkmark = require("grommet-icons/es6/icons/Checkmark");
var _close = require("grommet-icons/es6/icons/Close");
var _header = require("app/components/Header");
const ModalContainer = ({ modal, closeModal })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const confirm = (0, _react.useCallback)(()=>{
        modal.handleConfirm();
        closeModal();
    }, [
        closeModal,
        modal
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layer.Layer), {
        modal: true,
        onEsc: closeModal,
        onClickOutside: closeModal,
        background: "background-front",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            margin: "medium",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.ModalHeader), {
                    children: modal.title
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paragraph.Paragraph), {
                    fill: true,
                    children: modal.description
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    direction: "row",
                    gap: "small",
                    justify: "between",
                    pad: {
                        top: 'large'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            label: t('common.cancel', 'Cancel'),
                            onClick: closeModal,
                            secondary: true,
                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _close.Close), {
                                size: "18px"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            label: t('common.confirm', 'Confirm'),
                            onClick: confirm,
                            disabled: modal.isDangerous,
                            primary: modal.isDangerous,
                            color: modal.isDangerous ? 'status-error' : '',
                            icon: modal.isDangerous ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                                size: "18px"
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmark.Checkmark), {
                                size: "18px"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Layer":"3gh0x","grommet/es6/components/Paragraph":"kg9QN","react-i18next":"7GUHL","grommet-icons/es6/icons/Alert":"ik8QA","grommet-icons/es6/icons/Checkmark":"6KJBZ","grommet-icons/es6/icons/Close":"8LUZt","app/components/Header":"bHFRk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ik8QA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Alert", ()=>Alert);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Alert = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Alert"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 17v2m0-9v6m0-13L2 22h20L12 3z"
    }));
});
Alert.displayName = 'Alert';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6KJBZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkmark", ()=>Checkmark);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
var _utils = require("../utils");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Checkmark = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var scaleProps = (0, _utils.useScaleProps)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Checkmark"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2 14 7 6L22 4"
    }, scaleProps)));
});
Checkmark.displayName = 'Checkmark';

},{"react":"8CCva","../StyledIcon":"6hZZK","../utils":"l0e2b","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aE6Lf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRouteRedirects", ()=>useRouteRedirects);
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _selectors = require("app/state/wallet/selectors");
const useRouteRedirects = ()=>{
    const address = (0, _reactRedux.useSelector)((0, _selectors.selectAddress));
    const navigate = (0, _reactRouterDom.useNavigate)();
    (0, _react.useEffect)(()=>{
        const hasRecentlyGrantedUsbAccess = Date.now() - parseInt(window.localStorage.getItem('oasis_wallet_granted_usb_ledger_timestamp') ?? '0') < 300000;
        if (hasRecentlyGrantedUsbAccess) {
            // When we implement auto-locking, this won't correctly redirect if wallet
            // gets locked within 5min (useEffect called with address=undefined before unlocking).
            navigate(`/open-wallet/ledger`);
            // Delay is needed as workaround for React.StrictMode.
            setTimeout(()=>window.localStorage.removeItem('oasis_wallet_granted_usb_ledger_timestamp'), 1000);
        } else if (address) navigate(`/account/${address}`);
    }, [
        address,
        navigate
    ]);
};

},{"react":"8CCva","react-redux":"azV3Y","react-router-dom":"9pTjq","app/state/wallet/selectors":"cgtJ3","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2IxRw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Prevent new actions while order-sensitive actions are in persist queue.
 */ parcelHelpers.export(exports, "PersistLoadingGate", ()=>PersistLoadingGate);
var _jsxRuntime = require("react/jsx-runtime");
var _selectors = require("app/state/persist/selectors");
var _box = require("grommet/es6/components/Box");
var _layer = require("grommet/es6/components/Layer");
var _spinner = require("grommet/es6/components/Spinner");
var _text = require("grommet/es6/components/Text");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
function PersistLoadingGate(props) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const loading = (0, _reactRedux.useSelector)((0, _selectors.selectLoading));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            loading && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layer.Layer), {
                modal: true,
                background: "background-front",
                responsive: false,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    pad: "medium",
                    gap: "medium",
                    direction: "row",
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinner.Spinner), {
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                            size: "medium",
                            children: t('persist.loading', 'Loading')
                        })
                    ]
                })
            }),
            props.children
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","app/state/persist/selectors":"lDilG","grommet/es6/components/Box":"4o01A","grommet/es6/components/Layer":"3gh0x","grommet/es6/components/Spinner":"bxfAK","grommet/es6/components/Text":"kz1Ni","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"giF2b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Ask for password if user has encrypted state in localStorage, and no password in state.
 * Otherwise show child element.
 */ parcelHelpers.export(exports, "UnlockGate", ()=>UnlockGate);
var _jsxRuntime = require("react/jsx-runtime");
var _selectors = require("app/state/persist/selectors");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _unlockForm = require("app/components/Persist/UnlockForm");
var _migrateV0StateForm = require("app/components/Persist/MigrateV0StateForm");
function UnlockGate(props) {
    const needsPassword = (0, _reactRedux.useSelector)((0, _selectors.selectNeedsPassword));
    const hasV0StorageToMigrate = (0, _reactRedux.useSelector)((0, _selectors.selectHasV0StorageToMigrate));
    if (needsPassword) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unlockForm.UnlockForm), {});
    if (hasV0StorageToMigrate) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _migrateV0StateForm.MigrateV0StateForm), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: props.children
    });
}

},{"react/jsx-runtime":"6pm7f","app/state/persist/selectors":"lDilG","react":"8CCva","react-redux":"azV3Y","app/components/Persist/UnlockForm":"dlQhk","app/components/Persist/MigrateV0StateForm":"1Kk58","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dlQhk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnlockForm", ()=>UnlockForm);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _form = require("grommet/es6/components/Form");
var _paragraph = require("grommet/es6/components/Paragraph");
var _persist = require("app/state/persist");
var _selectors = require("app/state/persist/selectors");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _reactI18Next = require("react-i18next");
var _passwordField = require("app/components/PasswordField");
var _preventSavingInputsToUserData = require("app/lib/preventSavingInputsToUserData");
var _deleteProfileButton = require("./DeleteProfileButton");
var _loginModalLayout = require("./LoginModalLayout");
function UnlockForm() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const enteredWrongPassword = (0, _reactRedux.useSelector)((0, _selectors.selectEnteredWrongPassword));
    const [password, setPassword] = (0, _reactDefault.default).useState('');
    const onSubmit = ()=>dispatch((0, _persist.persistActions).unlockAsync({
            password: password
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _loginModalLayout.LoginModalLayout), {
        title: t('persist.loginToProfile.title', 'Welcome Back!'),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                onSubmit: onSubmit,
                ...(0, _preventSavingInputsToUserData.preventSavingInputsToUserData),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paragraph.Paragraph), {
                        fill: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "password",
                            children: t('persist.loginToProfile.description', 'Enter your password to access your existing wallets on this device.')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _passwordField.PasswordField), {
                        placeholder: t('persist.loginToProfile.enterPasswordHere', 'Enter your password'),
                        name: "password",
                        inputElementId: "password",
                        autoFocus: true,
                        value: password,
                        onChange: (event)=>setPassword(event.target.value),
                        error: enteredWrongPassword ? t('persist.loginToProfile.wrongPassword', 'Wrong password') : false,
                        showTip: t('persist.loginToProfile.showPassword', 'Show password'),
                        hideTip: t('persist.loginToProfile.hidePassword', 'Hide password'),
                        width: "auto"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        direction: "row-responsive",
                        gap: "large",
                        justify: "between",
                        margin: {
                            top: 'medium'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            type: "submit",
                            label: t('persist.loginToProfile.unlock', 'Unlock'),
                            primary: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                direction: "row",
                margin: {
                    top: 'large'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteProfileButton.DeleteProfileButton), {
                    variant: "forgot-password"
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Form":"kRCRN","grommet/es6/components/Paragraph":"kg9QN","app/state/persist":"9hwZK","app/state/persist/selectors":"lDilG","react":"8CCva","react-redux":"azV3Y","react-i18next":"7GUHL","app/components/PasswordField":"hEUcp","app/lib/preventSavingInputsToUserData":"idfdE","./DeleteProfileButton":"6sLVF","./LoginModalLayout":"lbW2v","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lbW2v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoginModalLayout", ()=>LoginModalLayout);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("grommet/es6/components/Box");
var _responsiveLayer = require("../ResponsiveLayer");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _header = require("app/components/Header");
var _sidebar = require("../Sidebar");
var _roseWalletBlueSvg = require("../../../../public/Rose Wallet Blue.svg");
var _roseWalletBlueSvgDefault = parcelHelpers.interopDefault(_roseWalletBlueSvg);
var _roseWalletWhiteSvg = require("../../../../public/Rose Wallet White.svg");
var _roseWalletWhiteSvgDefault = parcelHelpers.interopDefault(_roseWalletWhiteSvg);
var _styledComponents = require("styled-components");
function LoginModalLayout(props) {
    const { dark } = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        direction: "row-responsive",
        background: "background-back",
        fill: true,
        style: {
            minHeight: '100dvh'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.Navigation), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveLayer.ResponsiveLayer), {
                modal: true,
                responsive: false,
                style: {
                    width: '100%',
                    maxWidth: '500px'
                },
                background: "background-front",
                onClickOutside: props.onClickOutside,
                onEsc: props.onEsc,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    pad: "medium",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                            align: "center",
                            margin: {
                                vertical: 'large'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                alt: "ROSE Wallet logo",
                                src: dark ? (0, _roseWalletWhiteSvgDefault.default) : (0, _roseWalletBlueSvgDefault.default),
                                style: {
                                    height: '60px'
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.Header), {
                            fill: true,
                            textAlign: "center",
                            children: props.title
                        }),
                        props.children
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Box":"4o01A","../ResponsiveLayer":"3jeKP","react":"8CCva","app/components/Header":"bHFRk","../Sidebar":"5xMev","../../../../public/Rose Wallet Blue.svg":"hfBEW","../../../../public/Rose Wallet White.svg":"4JEgD","styled-components":"6bGrk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1Kk58":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MigrateV0StateForm", ()=>MigrateV0StateForm);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _form = require("grommet/es6/components/Form");
var _paragraph = require("grommet/es6/components/Paragraph");
var _persist = require("app/state/persist");
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactI18Next = require("react-i18next");
var _passwordField = require("app/components/PasswordField");
var _preventSavingInputsToUserData = require("app/lib/preventSavingInputsToUserData");
var _loginModalLayout = require("./LoginModalLayout");
var _walletExtensionV0 = require("../../../utils/walletExtensionV0");
var _noTranslate = require("../NoTranslate");
var _checkBox = require("grommet/es6/components/CheckBox");
var _formField = require("grommet/es6/components/FormField");
var _addressFormatter = require("../AddressFormatter");
var _slice = require("../../../styles/theme/slice");
var _revealOverlayButton = require("../RevealOverlayButton");
var _privateKeyFormatter = require("../PrivateKeyFormatter");
var _errors = require("../../../types/errors");
var _countdownButton = require("../CountdownButton");
function MigrateV0StateForm() {
    const { t, i18n } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const [password, setPassword] = (0, _react.useState)('');
    const [enteredWrongPassword, setWrongPassword] = (0, _react.useState)(false);
    const [migratingV0State, setMigratingV0State] = (0, _react.useState)(undefined);
    const [hasSavedMnemonic, setHasSavedMnemonic] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        // Old extension used light theme
        dispatch((0, _slice.themeActions).changeTheme('light'));
    }, [
        dispatch
    ]);
    (0, _react.useEffect)(()=>{
        // Switch to zh_CN if it was used in old extension. We don't have a language selector in migration UI.
        i18n.changeLanguage((0, _walletExtensionV0.readAndMigrateLanguageV0)());
    }, [
        i18n
    ]);
    const onSubmitPassword = async ()=>{
        const storageV0 = await (0, _walletExtensionV0.readStorageV0)();
        if (!storageV0) throw new Error('No v0 storage to migrate');
        try {
            setWrongPassword(false);
            const decrypted = await (0, _walletExtensionV0.decryptWithPasswordV0)(password, storageV0);
            setMigratingV0State(decrypted);
        } catch (err) {
            if (err instanceof (0, _errors.PasswordWrongError)) setWrongPassword(true);
            else throw err;
        }
    };
    const onSubmitSavedMnemonic = ()=>{
        if (!migratingV0State) throw new Error('No v0 storage to migrate');
        if (migratingV0State.invalidPrivateKeys.length > 0) setHasSavedMnemonic(true);
        else onSubmitSavedInvalidPrivateKeys();
    };
    const onSubmitSavedInvalidPrivateKeys = ()=>{
        finishMigration();
    };
    const finishMigration = ()=>{
        if (!migratingV0State) throw new Error('No v0 storage to migrate');
        dispatch((0, _persist.persistActions).finishV0Migration({
            persistedRootState: migratingV0State.state,
            password: password
        }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _loginModalLayout.LoginModalLayout), {
        title: t('migrateV0Extension.title', 'Important Wallet Update'),
        children: [
            !migratingV0State && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                onSubmit: onSubmitPassword,
                messages: {
                    required: t('migrateV0Extension.requiredField', 'This field is required')
                },
                ...(0, _preventSavingInputsToUserData.preventSavingInputsToUserData),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paragraph.Paragraph), {
                        fill: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            htmlFor: "password",
                            children: t('persist.loginToProfile.description', 'Enter your password to access your existing wallets on this device.')
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _passwordField.PasswordField), {
                        placeholder: t('persist.loginToProfile.enterPasswordHere', 'Enter your password'),
                        name: "password",
                        inputElementId: "password",
                        autoFocus: true,
                        value: password,
                        onChange: (event)=>setPassword(event.target.value),
                        error: enteredWrongPassword ? t('persist.loginToProfile.wrongPassword', 'Wrong password') : false,
                        showTip: t('persist.loginToProfile.showPassword', 'Show password'),
                        hideTip: t('persist.loginToProfile.hidePassword', 'Hide password'),
                        width: "auto"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        direction: "row-responsive",
                        gap: "medium",
                        justify: "between",
                        margin: {
                            top: 'medium'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            type: "submit",
                            label: t('persist.loginToProfile.unlock', 'Unlock'),
                            primary: true
                        })
                    })
                ]
            }),
            migratingV0State && !hasSavedMnemonic && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                onSubmit: onSubmitSavedMnemonic,
                messages: {
                    required: t('migrateV0Extension.requiredField', 'This field is required')
                },
                ...(0, _preventSavingInputsToUserData.preventSavingInputsToUserData),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paragraph.Paragraph), {
                        fill: true,
                        children: t('migrateV0Extension.backupMnemonic.description', 'The new version of the wallet extension will no longer store your mnemonic. This phrase is the only way to restore your account if you have lost access. You now have a final chance to backup your mnemonic.')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _revealOverlayButton.RevealOverlayButton), {
                        label: t('migrateV0Extension.backupMnemonic.reveal', 'Tap to show your mnemonic'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                            margin: {
                                vertical: 'small'
                            },
                            pad: "small",
                            background: "background-contrast",
                            style: {
                                wordSpacing: '14px'
                            },
                            width: "medium",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noTranslate.NoTranslate), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: migratingV0State.mnemonic
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
                        contentProps: {
                            border: false
                        },
                        required: true,
                        name: "backupMnemonicConfirm",
                        margin: {
                            vertical: 'medium'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkBox.CheckBox), {
                            name: "backupMnemonicConfirm",
                            label: t('createWallet.confirmSaved', "I\u2019ve safely stored my mnemonic")
                        })
                    }),
                    migratingV0State.invalidPrivateKeys.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countdownButton.CountdownButton), {
                        type: "submit",
                        label: t('migrateV0Extension.nextStep', 'Next'),
                        fill: "horizontal",
                        primary: true
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countdownButton.CountdownButton), {
                        type: "submit",
                        label: t('migrateV0Extension.finishMigration', 'Open the new version of the wallet'),
                        fill: "horizontal",
                        primary: true
                    })
                ]
            }),
            migratingV0State && hasSavedMnemonic && migratingV0State.invalidPrivateKeys.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                onSubmit: onSubmitSavedInvalidPrivateKeys,
                messages: {
                    required: t('migrateV0Extension.requiredField', 'This field is required')
                },
                ...(0, _preventSavingInputsToUserData.preventSavingInputsToUserData),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: t('migrateV0Extension.backupInvalidPrivateKeys.description_one', "1 of your private keys has typos and won\u2019t be stored by the new wallet extension. Please make sure to copy it and store it elsewhere before proceeding, so you can correct it later.") && null
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paragraph.Paragraph), {
                        fill: true,
                        children: t('migrateV0Extension.backupInvalidPrivateKeys.description', "{{count}} of your private keys have typos and won\u2019t be stored by the new wallet extension. Please make sure to copy them and store them elsewhere before proceeding, so you can correct them later.", {
                            count: migratingV0State.invalidPrivateKeys.length
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        width: "medium",
                        gap: "large",
                        children: migratingV0State.invalidPrivateKeys.map((acc)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressFormatter.AddressFormatter), {
                                        address: acc.address,
                                        name: acc.name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _revealOverlayButton.RevealOverlayButton), {
                                        label: t('migrateV0Extension.backupInvalidPrivateKeys.reveal', 'Tap to show invalid private key'),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _privateKeyFormatter.PrivateKeyFormatter), {
                                            privateKey: acc.privateKeyWithTypos
                                        })
                                    })
                                ]
                            }, acc.privateKeyWithTypos))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
                        contentProps: {
                            border: false
                        },
                        required: true,
                        name: "backupInvalidPrivateKeysConfirm",
                        margin: {
                            vertical: 'medium'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkBox.CheckBox), {
                            name: "backupInvalidPrivateKeysConfirm",
                            label: t('migrateV0Extension.backupInvalidPrivateKeys.confirm', "I\u2019ve safely stored my private keys")
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _countdownButton.CountdownButton), {
                        type: "submit",
                        label: t('migrateV0Extension.finishMigration', 'Open the new version of the wallet'),
                        fill: "horizontal",
                        primary: true
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Form":"kRCRN","grommet/es6/components/Paragraph":"kg9QN","app/state/persist":"9hwZK","react":"8CCva","react-redux":"azV3Y","react-i18next":"7GUHL","app/components/PasswordField":"hEUcp","app/lib/preventSavingInputsToUserData":"idfdE","./LoginModalLayout":"lbW2v","../../../utils/walletExtensionV0":"7XgZH","../NoTranslate":"jUKdq","grommet/es6/components/CheckBox":"gaRRO","grommet/es6/components/FormField":"dcsVI","../AddressFormatter":"70nG2","../../../styles/theme/slice":"56nVt","../RevealOverlayButton":"6jvAW","../PrivateKeyFormatter":"iwqT0","../../../types/errors":"gbx4q","../CountdownButton":"fGuHA","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"70nG2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddressFormatter", ()=>AddressFormatter);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _box = require("grommet/es6/components/Box");
var _text = require("grommet/es6/components/Text");
var _utils = require("grommet/es6/utils");
var _trimLongString = require("../ShortAddress/trimLongString");
var _selectors = require("app/state/contacts/selectors");
const StyledBox = (0, _styledComponentsDefault.default)((0, _box.Box))`
  display: inline-flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: ${({ theme })=>theme.global?.edgeSize?.xxsmall};
`;
const StyledText = (0, _styledComponentsDefault.default)((0, _text.Text))`
  padding-right: ${({ theme })=>theme.global?.edgeSize?.small};
  white-space: nowrap;
  font-weight: bold;
  color: ${({ theme })=>(0, _utils.normalizeColor)('grayMedium', theme)};
`;
const AddressFormatter = (props)=>{
    const contactAddress = (0, _reactRedux.useSelector)((0, _selectors.selectContact)(props.address));
    const name = props.name || contactAddress?.name;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledBox, {
        children: [
            name && /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledText, {
                size: "inherit",
                "data-testid": "address-formatter-name",
                children: name
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                size: "inherit",
                style: {
                    overflowWrap: 'anywhere'
                },
                children: (0, _trimLongString.trimLongString)(props.address)
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react-redux":"azV3Y","styled-components":"6bGrk","grommet/es6/components/Box":"4o01A","grommet/es6/components/Text":"kz1Ni","grommet/es6/utils":"fx31z","../ShortAddress/trimLongString":"1sxUU","app/state/contacts/selectors":"iLmat","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fGuHA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CountdownButton", ()=>CountdownButton);
var _jsxRuntime = require("react/jsx-runtime");
var _button = require("grommet/es6/components/Button");
var _react = require("react");
const CountdownButton = (props)=>{
    const [countdown, setCountdown] = (0, _react.useState)(5);
    const isDisabled = countdown > 0;
    (0, _react.useEffect)(()=>{
        const timerId = setInterval(()=>{
            setCountdown((prevCountdown)=>{
                const newCount = prevCountdown - 1;
                if (newCount <= 0) clearInterval(timerId);
                return newCount;
            });
        }, 1000);
        return ()=>clearInterval(timerId);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
        ...props,
        primary: true,
        disabled: isDisabled,
        label: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                props.label,
                " ",
                isDisabled && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        "(",
                        countdown,
                        ")"
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Button":"fVON6","react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jZ0S8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuildBanner", ()=>BuildBanner);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _alert = require("grommet-icons/es6/icons/Alert");
var _box = require("grommet/es6/components/Box");
var _alertBox = require("app/components/AlertBox");
var _elementSizes = require("../../../styles/theme/elementSizes");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _config = require("../../../config");
var _runtimeIs = require("../../lib/runtimeIs");
const StickyBanner = (0, _styledComponentsDefault.default)((0, _box.Box))`
  position: sticky;
  top: 0;
  z-index: ${(0, _elementSizes.buildBannerZIndex)};
`;
const BuildBanner = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    if (window.location.origin === (0, _config.deploys).localhost) return null;
    if (window.location.origin === (0, _config.deploys).extension) return null;
    if ((0, _runtimeIs.runtimeIs) === 'mobile-app') // On web we want to deploy the exact same bundle on staging and then production, so we
    // show banner based on location. That can't work with apk files.
    return null;
    if ((0, _config.deploys).production.includes(window.location.origin)) return null;
    if ((0, _config.deploys).staging.includes(window.location.origin)) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StickyBanner, {
        "data-testid": "build-banner",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBox.AlertBox), {
            status: "warning",
            justify: "center",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                size: "20px"
            }),
            children: t('banner.buildStaging', 'Please note this is the staging deployment of ROSE Wallet. ONLY USE IT FOR TESTING.')
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StickyBanner, {
        "data-testid": "build-banner",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBox.AlertBox), {
            status: "warning",
            justify: "center",
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                size: "20px"
            }),
            children: t('banner.buildPreview', 'Please note this is an experimental build of ROSE Wallet and your secrets are not safe. ONLY USE IT FOR TESTING.')
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react-i18next":"7GUHL","grommet-icons/es6/icons/Alert":"ik8QA","grommet/es6/components/Box":"4o01A","app/components/AlertBox":"ivux6","../../../styles/theme/elementSizes":"2rYRG","styled-components":"6bGrk","../../../config":"akiw0","../../lib/runtimeIs":"fboJV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ivux6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AlertBox", ()=>AlertBox);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("grommet/es6/components/Box");
var _text = require("grommet/es6/components/Text");
var _utils = require("grommet/es6/utils");
var _react = require("react");
var _styledComponents = require("styled-components");
const mapStatus = {
    error: {
        color: 'alert-box-error',
        background: 'alert-box-error-background'
    },
    warning: {
        color: 'alert-box-warning',
        background: 'alert-box-warning-background'
    },
    'warning-weak': {
        color: 'alert-box-warning',
        background: 'alert-box-warning-weak-background'
    },
    ok: {
        color: 'alert-box-ok',
        background: 'alert-box-ok-background'
    },
    'ok-weak': {
        color: 'alert-box-ok-weak',
        background: 'alert-box-ok-weak-background'
    },
    info: {
        color: 'alert-box-info',
        background: 'alert-box-info-background'
    }
};
function AlertBox(props) {
    const theme = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    // If we don't normalize upfront then grommet auto-detects darkness of background, and decides to use ['alert-box-warning'].dark with ['alert-box-warning-background'].dark
    const color = (0, _utils.normalizeColor)(mapStatus[props.status].color, theme);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        border: props.status === 'warning-weak' ? undefined : {
            color: color,
            side: 'left',
            size: '3px'
        },
        background: {
            color: mapStatus[props.status].background
        },
        pad: {
            horizontal: 'small'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            direction: "row",
            justify: props.justify ?? 'start',
            pad: {
                vertical: 'xsmall'
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    direction: "row",
                    gap: "small",
                    align: "center",
                    children: [
                        props.icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                            color: color,
                            children: props.icon
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                            size: "xsmall",
                            weight: "bold",
                            style: {
                                verticalAlign: 'middle'
                            },
                            children: props.children
                        })
                    ]
                }),
                props.endSlot
            ]
        })
    });
}

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Box":"4o01A","grommet/es6/components/Text":"kz1Ni","grommet/es6/utils":"fx31z","react":"8CCva","styled-components":"6bGrk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ebtkn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IonicNativePlatformProvider", ()=>IonicNativePlatformProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _runtimeIs = require("app/lib/runtimeIs");
var _ionicProvider = require("../../providers/IonicProvider");
var _updateGate = require("../UpdateGate");
var _privacyScreen = require("app/lib/privacyScreen");
var _selectors = require("app/state/settings/slice/selectors");
var _reactRedux = require("react-redux");
var _capacitorAndroidEdgeToEdgeSupport = require("@capawesome/capacitor-android-edge-to-edge-support");
var _statusBar = require("@capacitor/status-bar");
var _selectors1 = require("styles/theme/slice/selectors");
var _utils = require("styles/theme/utils");
const IonicNativePlatformProvider = ({ children })=>{
    const screenPrivacy = (0, _reactRedux.useSelector)((0, _selectors.selectScreenPrivacy));
    const theme = (0, _reactRedux.useSelector)((0, _selectors1.selectTheme));
    const targetTheme = (0, _utils.getTargetTheme)(theme);
    (0, _react.useEffect)(()=>{
        (0, _privacyScreen.setPrivacyScreen)(screenPrivacy).catch((error)=>{
            console.error('Failed to initialize PrivacyScreen on app startup:', error);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, _react.useEffect)(()=>{
        if ((0, _runtimeIs.runtimeIs) !== 'mobile-app') return;
        const setEdgeToEdgeBackground = async ()=>{
            if (targetTheme === 'dark') {
                await (0, _capacitorAndroidEdgeToEdgeSupport.EdgeToEdge).setBackgroundColor({
                    color: '#1a1a2e'
                });
                await (0, _statusBar.StatusBar).setStyle({
                    style: (0, _statusBar.Style).Dark
                });
            } else {
                await (0, _capacitorAndroidEdgeToEdgeSupport.EdgeToEdge).setBackgroundColor({
                    color: '#efefef'
                });
                await (0, _statusBar.StatusBar).setStyle({
                    style: (0, _statusBar.Style).Light
                });
            }
        };
        setEdgeToEdgeBackground();
    }, [
        targetTheme
    ]);
    if ((0, _runtimeIs.runtimeIs) === 'mobile-app') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ionicProvider.IonicContextProvider), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _updateGate.UpdateGate), {
            children: children
        })
    });
    return children;
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","app/lib/runtimeIs":"fboJV","../../providers/IonicProvider":"lSB1G","../UpdateGate":"2sl0N","app/lib/privacyScreen":"xFp3W","app/state/settings/slice/selectors":"5hbX7","react-redux":"azV3Y","@capawesome/capacitor-android-edge-to-edge-support":"lu90J","@capacitor/status-bar":"i3xKk","styles/theme/slice/selectors":"9i0Ji","styles/theme/utils":"lNPdT","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lSB1G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IonicContextProvider", ()=>IonicContextProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _useIonicBackButtonListener = require("../hooks/useIonicBackButtonListener");
var _useIonicAppStateChangeListener = require("../hooks/useIonicAppStateChangeListener");
var _ionicContext = require("./IonicContext");
var _useIonicRequiresUpdate = require("../hooks/useIonicRequiresUpdate");
const IonicContextProvider = ({ children })=>{
    const { requiresUpdateState, checkForUpdateAvailability, skipUpdate } = (0, _useIonicRequiresUpdate.useIonicRequiresUpdate)();
    (0, _useIonicAppStateChangeListener.useIonicAppStateChangeListener)();
    (0, _useIonicBackButtonListener.useIonicBackButtonListener)();
    const providerState = {
        requiresUpdateState,
        checkForUpdateAvailability,
        skipUpdate
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _ionicContext.IonicContext).Provider, {
        value: providerState,
        children: children
    });
};

},{"react/jsx-runtime":"6pm7f","../hooks/useIonicBackButtonListener":"3ueGb","../hooks/useIonicAppStateChangeListener":"13ddy","./IonicContext":"jbaAX","../hooks/useIonicRequiresUpdate":"i4fm5","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3ueGb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIonicBackButtonListener", ()=>useIonicBackButtonListener);
var _react = require("react");
var _app = require("@capacitor/app");
var _reactRouterDom = require("react-router-dom");
const useIonicBackButtonListener = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    (0, _react.useEffect)(()=>{
        /**
     * The back button refers to the physical back button on an Android device and should not be confused
     * with either the browser back button or ion-back-button.
     */ const backButtonListenerHandle = (0, _app.App).addListener('backButton', ({ canGoBack })=>{
            if (!canGoBack) (0, _app.App).exitApp();
            else navigate(-1);
        });
        return ()=>{
            backButtonListenerHandle.then((pluginListenerHandle)=>pluginListenerHandle.remove());
        };
    }, [
        navigate
    ]);
};

},{"react":"8CCva","@capacitor/app":"1LYhg","react-router-dom":"9pTjq","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1LYhg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "App", ()=>App);
var _core = require("@capacitor/core");
var _definitions = require("./definitions");
parcelHelpers.exportAll(_definitions, exports);
const App = (0, _core.registerPlugin)('App', {
    web: ()=>require("9bff7f85abd6f3b9").then((m)=>new m.AppWeb())
});

},{"@capacitor/core":"9nVQl","9bff7f85abd6f3b9":"jzJrf","./definitions":"7rH9F","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jzJrf":[function(require,module,exports,__globalThis) {
module.exports = require("52ab2fdcdd98825b")(module.bundle.resolve("dP98J")).then(()=>module.bundle.root('iE9sc'));

},{"52ab2fdcdd98825b":"bxWlo"}],"7rH9F":[function(require,module,exports,__globalThis) {
/// <reference types="@capacitor/cli" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"13ddy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIonicAppStateChangeListener", ()=>useIonicAppStateChangeListener);
var _react = require("react");
var _app = require("@capacitor/app");
var _ionicConfig = require("../../../../ionicConfig");
var _persist = require("../../../state/persist");
var _reactRedux = require("react-redux");
const useIonicAppStateChangeListener = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const lockTimestamp = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        const appStateChangeListenerHandle = (0, _app.App).addListener('appStateChange', ({ isActive })=>{
            const shouldLock = lockTimestamp.current && Date.now() - lockTimestamp.current > (0, _ionicConfig.deltaMsToLockProfile);
            if (isActive && shouldLock) dispatch((0, _persist.persistActions).lockAsync());
            else if (isActive && !shouldLock) lockTimestamp.current = undefined;
            if (!isActive) lockTimestamp.current = Date.now();
        });
        return ()=>{
            appStateChangeListenerHandle.then((pluginListenerHandle)=>pluginListenerHandle.remove());
        };
    }, [
        dispatch
    ]);
};

},{"react":"8CCva","@capacitor/app":"1LYhg","../../../../ionicConfig":"kL1Lq","../../../state/persist":"9hwZK","react-redux":"azV3Y","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kL1Lq":[function(require,module,exports,__globalThis) {
/**
 * Represents the duration in milliseconds to lock a profile.
 *
 * @type {number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deltaMsToLockProfile", ()=>deltaMsToLockProfile);
const deltaMsToLockProfile = 30000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jbaAX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpdateAvailability", ()=>UpdateAvailability);
parcelHelpers.export(exports, "IonicContext", ()=>IonicContext);
var _react = require("react");
var UpdateAvailability = /*#__PURE__*/ function(UpdateAvailability) {
    UpdateAvailability[UpdateAvailability["NOT_INITIALIZED"] = 0] = "NOT_INITIALIZED";
    UpdateAvailability[UpdateAvailability["LOADING"] = 1] = "LOADING";
    UpdateAvailability[UpdateAvailability["UPDATE_AVAILABLE"] = 2] = "UPDATE_AVAILABLE";
    UpdateAvailability[UpdateAvailability["UPDATE_NOT_AVAILABLE"] = 3] = "UPDATE_NOT_AVAILABLE";
    UpdateAvailability[UpdateAvailability["UPDATE_IN_PROGRESS"] = 4] = "UPDATE_IN_PROGRESS";
    UpdateAvailability[UpdateAvailability["ERROR"] = 5] = "ERROR";
    UpdateAvailability[UpdateAvailability["UNKNOWN"] = 6] = "UNKNOWN";
    return UpdateAvailability;
}({});
const IonicContext = (0, _react.createContext)({});

},{"react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"i4fm5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIonicRequiresUpdate", ()=>useIonicRequiresUpdate);
var _react = require("react");
var _ionicContext = require("../providers/IonicContext");
var _capacitorAppUpdate = require("../utils/capacitor-app-update");
const ionicRequiresUpdateInitialState = {
    updateAvailability: (0, _ionicContext.UpdateAvailability).NOT_INITIALIZED,
    error: null
};
const useIonicRequiresUpdate = ()=>{
    const [state, setState] = (0, _react.useState)({
        ...ionicRequiresUpdateInitialState
    });
    const checkForUpdateAvailability = async ()=>{
        if (state.updateAvailability === (0, _ionicContext.UpdateAvailability).LOADING) return;
        setState((prevState)=>({
                ...prevState,
                updateAvailability: (0, _ionicContext.UpdateAvailability).LOADING
            }));
        try {
            const updateAvailability = await (0, _capacitorAppUpdate.updateAvailable)();
            setState((prevState)=>({
                    ...prevState,
                    updateAvailability
                }));
        } catch (error) {
            setState((prevState)=>({
                    ...prevState,
                    updateAvailability: (0, _ionicContext.UpdateAvailability).ERROR,
                    error: error
                }));
        }
    };
    (0, _react.useEffect)(()=>{
        checkForUpdateAvailability();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const skipUpdate = ()=>{
        setState((prevState)=>({
                ...prevState,
                updateAvailability: (0, _ionicContext.UpdateAvailability).UPDATE_NOT_AVAILABLE
            }));
    };
    return {
        requiresUpdateState: state,
        checkForUpdateAvailability,
        skipUpdate
    };
};

},{"react":"8CCva","../providers/IonicContext":"jbaAX","../utils/capacitor-app-update":"4AqYm","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4AqYm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateAvailable", ()=>updateAvailable);
parcelHelpers.export(exports, "navigateToAppStore", ()=>navigateToAppStore);
var _capacitorAppUpdate = require("@capawesome/capacitor-app-update");
var _core = require("@capacitor/core");
var _ionicContext = require("../providers/IonicContext");
const updateAvailable = async ()=>{
    const result = await (0, _capacitorAppUpdate.AppUpdate).getAppUpdateInfo();
    const { updateAvailability, currentVersionCode, availableVersionCode } = result;
    switch(updateAvailability){
        case (0, _capacitorAppUpdate.AppUpdateAvailability).UPDATE_IN_PROGRESS:
            return (0, _ionicContext.UpdateAvailability).UPDATE_IN_PROGRESS;
        case (0, _capacitorAppUpdate.AppUpdateAvailability).UPDATE_NOT_AVAILABLE:
            return (0, _ionicContext.UpdateAvailability).UPDATE_NOT_AVAILABLE;
        // Returns UNKNOWN when unable to determine with mobile app store if update is available or not
        case (0, _capacitorAppUpdate.AppUpdateAvailability).UNKNOWN:
            return (0, _ionicContext.UpdateAvailability).UNKNOWN;
    }
    // Example of version code -> "1", "2", ...
    if ((0, _core.Capacitor).getPlatform() === 'android' && parseInt(availableVersionCode ?? `${Number.MAX_SAFE_INTEGER}`, 10) > parseInt(currentVersionCode ?? '0', 10)) return (0, _ionicContext.UpdateAvailability).UPDATE_AVAILABLE;
    // TODO: Add for iOS
    // Compare semVer between currentVersionName and availableVersionName
    throw new Error('Unknown Capacitor platform!');
};
const navigateToAppStore = async ()=>{
    await (0, _capacitorAppUpdate.AppUpdate).openAppStore();
};

},{"@capawesome/capacitor-app-update":"60qZX","@capacitor/core":"9nVQl","../providers/IonicContext":"jbaAX","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"60qZX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppUpdate", ()=>AppUpdate);
var _core = require("@capacitor/core");
var _definitions = require("./definitions");
parcelHelpers.exportAll(_definitions, exports);
const AppUpdate = (0, _core.registerPlugin)('AppUpdate', {
    web: ()=>require("4917430d691084db").then((m)=>new m.AppUpdateWeb())
});

},{"@capacitor/core":"9nVQl","4917430d691084db":"lNf23","./definitions":"beIJO","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lNf23":[function(require,module,exports,__globalThis) {
module.exports = require("d653b66c27ee7c91")(module.bundle.resolve("bjDAz")).then(()=>module.bundle.root('hZlYr'));

},{"d653b66c27ee7c91":"bxWlo"}],"beIJO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppUpdateAvailability", ()=>AppUpdateAvailability);
parcelHelpers.export(exports, "FlexibleUpdateInstallStatus", ()=>FlexibleUpdateInstallStatus);
parcelHelpers.export(exports, "AppUpdateResultCode", ()=>AppUpdateResultCode);
var AppUpdateAvailability;
(function(AppUpdateAvailability) {
    AppUpdateAvailability[AppUpdateAvailability["UNKNOWN"] = 0] = "UNKNOWN";
    AppUpdateAvailability[AppUpdateAvailability["UPDATE_NOT_AVAILABLE"] = 1] = "UPDATE_NOT_AVAILABLE";
    AppUpdateAvailability[AppUpdateAvailability["UPDATE_AVAILABLE"] = 2] = "UPDATE_AVAILABLE";
    AppUpdateAvailability[AppUpdateAvailability["UPDATE_IN_PROGRESS"] = 3] = "UPDATE_IN_PROGRESS";
})(AppUpdateAvailability || (AppUpdateAvailability = {}));
var FlexibleUpdateInstallStatus;
(function(FlexibleUpdateInstallStatus) {
    FlexibleUpdateInstallStatus[FlexibleUpdateInstallStatus["UNKNOWN"] = 0] = "UNKNOWN";
    FlexibleUpdateInstallStatus[FlexibleUpdateInstallStatus["PENDING"] = 1] = "PENDING";
    FlexibleUpdateInstallStatus[FlexibleUpdateInstallStatus["DOWNLOADING"] = 2] = "DOWNLOADING";
    FlexibleUpdateInstallStatus[FlexibleUpdateInstallStatus["INSTALLING"] = 3] = "INSTALLING";
    FlexibleUpdateInstallStatus[FlexibleUpdateInstallStatus["INSTALLED"] = 4] = "INSTALLED";
    FlexibleUpdateInstallStatus[FlexibleUpdateInstallStatus["FAILED"] = 5] = "FAILED";
    FlexibleUpdateInstallStatus[FlexibleUpdateInstallStatus["CANCELED"] = 6] = "CANCELED";
    FlexibleUpdateInstallStatus[FlexibleUpdateInstallStatus["DOWNLOADED"] = 11] = "DOWNLOADED";
})(FlexibleUpdateInstallStatus || (FlexibleUpdateInstallStatus = {}));
var AppUpdateResultCode;
(function(AppUpdateResultCode) {
    /**
     * The user has accepted the update.
     */ AppUpdateResultCode[AppUpdateResultCode["OK"] = 0] = "OK";
    /**
     * The user has denied or cancelled the update.
     */ AppUpdateResultCode[AppUpdateResultCode["CANCELED"] = 1] = "CANCELED";
    /**
     * Some other error prevented either the user from providing consent or the update to proceed.
     */ AppUpdateResultCode[AppUpdateResultCode["FAILED"] = 2] = "FAILED";
    /**
     * No update available.
     */ AppUpdateResultCode[AppUpdateResultCode["NOT_AVAILABLE"] = 3] = "NOT_AVAILABLE";
    /**
     * Update type not allowed.
     */ AppUpdateResultCode[AppUpdateResultCode["NOT_ALLOWED"] = 4] = "NOT_ALLOWED";
    /**
     * App update info missing.
     * You must call `getAppUpdateInfo()` before requesting an update.
     */ AppUpdateResultCode[AppUpdateResultCode["INFO_MISSING"] = 5] = "INFO_MISSING";
})(AppUpdateResultCode || (AppUpdateResultCode = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2sl0N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpdateGate", ()=>UpdateGate);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ionicContext = require("../../providers/IonicContext");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _capacitorAppUpdate = require("../../utils/capacitor-app-update");
var _paragraph = require("grommet/es6/components/Paragraph");
var _roseWalletWhiteSvg = require("../../../../../../public/Rose Wallet White.svg");
var _roseWalletWhiteSvgDefault = parcelHelpers.interopDefault(_roseWalletWhiteSvg);
var _text = require("grommet/es6/components/Text");
var _shareRounded = require("grommet-icons/es6/icons/ShareRounded");
var _refresh = require("grommet-icons/es6/icons/Refresh");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("grommet/es6/utils");
var _muiWalletIcon = require("../../../../../styles/theme/icons/mui-icons/MuiWalletIcon");
var _spinner = require("grommet/es6/components/Spinner");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _reactI18Next = require("react-i18next");
const SpinKeyFrames = (0, _styledComponents.keyframes)`
  0% {
    transform: rotate(0deg)
  }

  100% {
    transform: rotate(359deg)
  }
`;
// TODO: Merge with Spinner.icon when grommet dependency is updated
const RefreshSpin = (0, _styledComponentsDefault.default)((0, _refresh.Refresh))`
  transform: rotate(0deg);
  animation: ${SpinKeyFrames} 1s 0s infinite linear;
`;
const CTAButton = (0, _styledComponentsDefault.default)((0, _button.Button))`
  background-color: ${({ theme })=>(0, _utils.normalizeColor)('brand-light-blue', theme)};
  border-width: 0;
  border-radius: 8px;
`;
const getUpdateStatusMap = (t)=>({
        [(0, _ionicContext.UpdateAvailability).UPDATE_AVAILABLE]: {
            title: t('mobileUpdate.updateAvailableTitle', 'Update pending...'),
            desc: t('mobileUpdate.updateAvailableDescription', 'A new update is available for your ROSE Wallet. We recommend updating to the latest version for bug fixes, enhanced security and new features.')
        },
        [(0, _ionicContext.UpdateAvailability).UPDATE_IN_PROGRESS]: {
            title: t('mobileUpdate.updateInProgressTitle', 'Update in progress...'),
            desc: t('mobileUpdate.updateInProgressDescription', 'Your ROSE Wallet is currently undergoing an update. Please check back at later time. Alternatively, you may choose to retry by clicking on the "{{retryButtonLabel}}" button.', {
                retryButtonLabel: t('mobileUpdate.retry', 'Retry')
            })
        },
        [(0, _ionicContext.UpdateAvailability).UNKNOWN]: {
            title: t('mobileUpdate.unknownTitle', 'Unknown error'),
            desc: t('mobileUpdate.unknownOrErrorDescription', 'Apologies for the inconvenience, an unexpected error has transpired. Please verify your internet connection and retry by clicking on the "{{retryButtonLabel}}" button.', {
                retryButtonLabel: t('mobileUpdate.retry', 'Retry')
            })
        },
        [(0, _ionicContext.UpdateAvailability).ERROR]: {
            title: t('mobileUpdate.errorTitle', 'Unexpected error'),
            desc: t('mobileUpdate.unknownOrErrorDescription', 'Apologies for the inconvenience, an unexpected error has transpired. Please verify your internet connection and retry by clicking on the "{{retryButtonLabel}}" button.', {
                retryButtonLabel: t('mobileUpdate.retry', 'Retry')
            })
        }
    });
const UpdateGate = ({ children })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    const { requiresUpdateState: { updateAvailability }, checkForUpdateAvailability, skipUpdate } = (0, _react.useContext)((0, _ionicContext.IonicContext));
    if (updateAvailability === (0, _ionicContext.UpdateAvailability).UPDATE_NOT_AVAILABLE) return children;
    const handleNavigateToAppStore = ()=>{
        (0, _capacitorAppUpdate.navigateToAppStore)();
    };
    const updateStatusMap = getUpdateStatusMap(t);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        direction: "column",
        background: "brand-blue",
        fill: true,
        pad: "large",
        style: {
            minHeight: '100dvh'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                alignSelf: isMobile ? 'start' : 'center',
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    alt: "ROSE Wallet",
                    src: (0, _roseWalletWhiteSvgDefault.default),
                    style: {
                        height: '35px'
                    }
                })
            }),
            [
                (0, _ionicContext.UpdateAvailability).NOT_INITIALIZED,
                (0, _ionicContext.UpdateAvailability).LOADING
            ].includes(updateAvailability) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                align: "center",
                justify: "center",
                flex: "grow",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinner.Spinner), {})
            }),
            [
                (0, _ionicContext.UpdateAvailability).UPDATE_AVAILABLE,
                (0, _ionicContext.UpdateAvailability).UPDATE_IN_PROGRESS,
                (0, _ionicContext.UpdateAvailability).UNKNOWN,
                (0, _ionicContext.UpdateAvailability).ERROR
            ].includes(updateAvailability) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                flex: "grow",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                        align: "center",
                        justify: "center",
                        flex: "grow",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                                margin: {
                                    bottom: '70px',
                                    top: 'none'
                                },
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(RefreshSpin, {
                                        color: "white",
                                        size: "44"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _muiWalletIcon.MuiWalletIcon), {
                                        color: "white",
                                        size: "84px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paragraph.Paragraph), {
                                size: "medium",
                                color: "brand-light-blue",
                                alignSelf: isMobile ? 'start' : 'center',
                                textAlign: isMobile ? 'start' : 'center',
                                margin: {
                                    bottom: 'small',
                                    top: 'none'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                    weight: "bolder",
                                    children: updateStatusMap[updateAvailability]?.title
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paragraph.Paragraph), {
                                size: "small",
                                color: "brand-light-blue",
                                alignSelf: isMobile ? 'start' : 'center',
                                textAlign: isMobile ? 'start' : 'center',
                                margin: "none",
                                children: updateStatusMap[updateAvailability]?.desc
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                        align: "center",
                        justify: "end",
                        flex: "shrink",
                        children: [
                            updateAvailability === (0, _ionicContext.UpdateAvailability).UPDATE_AVAILABLE && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CTAButton, {
                                type: "button",
                                onClick: handleNavigateToAppStore,
                                margin: "medium",
                                pad: {
                                    vertical: 'small',
                                    horizontal: 'large'
                                },
                                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                    color: "brand-blue",
                                    weight: "bolder",
                                    size: "medium",
                                    children: t('mobileUpdate.updateNow', 'Update now')
                                }),
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shareRounded.ShareRounded), {
                                    color: "brand-blue",
                                    size: "18px"
                                }),
                                reverse: true
                            }),
                            updateAvailability !== (0, _ionicContext.UpdateAvailability).UPDATE_AVAILABLE && /*#__PURE__*/ (0, _jsxRuntime.jsx)(CTAButton, {
                                type: "button",
                                onClick: checkForUpdateAvailability,
                                margin: "medium",
                                pad: {
                                    vertical: 'small',
                                    horizontal: 'large'
                                },
                                label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                    color: "brand-blue",
                                    weight: "bolder",
                                    size: "medium",
                                    children: t('mobileUpdate.retry', 'Retry')
                                })
                            }),
                            [
                                (0, _ionicContext.UpdateAvailability).UNKNOWN,
                                (0, _ionicContext.UpdateAvailability).ERROR
                            ].includes(updateAvailability) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                type: "button",
                                onClick: skipUpdate,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                    color: "white",
                                    weight: "bolder",
                                    size: "small",
                                    children: t('mobileUpdate.later', 'Later')
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","../../providers/IonicContext":"jbaAX","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","../../utils/capacitor-app-update":"4AqYm","grommet/es6/components/Paragraph":"kg9QN","../../../../../../public/Rose Wallet White.svg":"4JEgD","grommet/es6/components/Text":"kz1Ni","grommet-icons/es6/icons/ShareRounded":"iTxBD","grommet-icons/es6/icons/Refresh":"7BwqO","styled-components":"6bGrk","grommet/es6/utils":"fx31z","../../../../../styles/theme/icons/mui-icons/MuiWalletIcon":"bOkiZ","grommet/es6/components/Spinner":"bxfAK","grommet/es6/contexts/ResponsiveContext":"7EsNN","react-i18next":"7GUHL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iTxBD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ShareRounded", ()=>ShareRounded);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var ShareRounded = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ShareRounded"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.924 3.617a.997.997 0 0 0-.215-.322l-.004-.004A.997.997 0 0 0 20 3h-6a1 1 0 1 0 0 2h3.586l-7.293 7.293a1 1 0 1 0 1.414 1.414L19 6.414V10a1 1 0 1 0 2 0V3.997a.999.999 0 0 0-.076-.38zM3 8a5 5 0 0 1 5-5h1a1 1 0 0 1 0 2H8a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3v-1a1 1 0 1 1 2 0v1a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8z",
        fill: "#000"
    }));
});
ShareRounded.displayName = 'ShareRounded';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lu90J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EdgeToEdge", ()=>EdgeToEdge);
var _core = require("@capacitor/core");
var _definitions = require("./definitions");
parcelHelpers.exportAll(_definitions, exports);
const EdgeToEdge = (0, _core.registerPlugin)('EdgeToEdge', {});

},{"@capacitor/core":"9nVQl","./definitions":"77qIe","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"77qIe":[function(require,module,exports,__globalThis) {
/// <reference types="@capacitor/cli" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"i3xKk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusBar", ()=>StatusBar);
var _core = require("@capacitor/core");
var _definitions = require("./definitions");
parcelHelpers.exportAll(_definitions, exports);
const StatusBar = (0, _core.registerPlugin)('StatusBar');

},{"@capacitor/core":"9nVQl","./definitions":"aq1VT","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aq1VT":[function(require,module,exports,__globalThis) {
/// <reference types="@capacitor/cli" />
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Style", ()=>Style);
parcelHelpers.export(exports, "Animation", ()=>Animation);
parcelHelpers.export(exports, "StatusBarAnimation", ()=>StatusBarAnimation);
parcelHelpers.export(exports, "StatusBarStyle", ()=>StatusBarStyle);
var Style;
(function(Style) {
    /**
     * Light text for dark backgrounds.
     *
     * @since 1.0.0
     */ Style["Dark"] = "DARK";
    /**
     * Dark text for light backgrounds.
     *
     * @since 1.0.0
     */ Style["Light"] = "LIGHT";
    /**
     * The style is based on the device appearance.
     * If the device is using Dark mode, the statusbar text will be light.
     * If the device is using Light mode, the statusbar text will be dark.
     *
     * @since 1.0.0
     */ Style["Default"] = "DEFAULT";
})(Style || (Style = {}));
var Animation;
(function(Animation) {
    /**
     * No animation during show/hide.
     *
     * @since 1.0.0
     */ Animation["None"] = "NONE";
    /**
     * Slide animation during show/hide.
     * It doesn't work on iOS 15+.
     *
     * @deprecated Use Animation.Fade or Animation.None instead.
     *
     * @since 1.0.0
     */ Animation["Slide"] = "SLIDE";
    /**
     * Fade animation during show/hide.
     *
     * @since 1.0.0
     */ Animation["Fade"] = "FADE";
})(Animation || (Animation = {}));
const StatusBarAnimation = Animation;
const StatusBarStyle = Style;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bH0UT":[function(require,module,exports,__globalThis) {
/**
 *
 * OpenWalletPage
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectOpenMethod", ()=>SelectOpenMethod);
parcelHelpers.export(exports, "OpenWalletPage", ()=>OpenWalletPage);
var _jsxRuntime = require("react/jsx-runtime");
var _anchor = require("grommet/es6/components/Anchor");
var _box = require("grommet/es6/components/Box");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _buttonLink = require("app/components/ButtonLink");
var _header = require("app/components/Header");
function SelectOpenMethod() {
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        round: "5px",
        border: {
            color: 'background-front-border',
            size: '1px'
        },
        background: "background-front",
        margin: "small",
        pad: "medium",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.Header), {
                children: t('openWallet.header', 'How do you want to open your wallet?')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                direction: "row-responsive",
                justify: "start",
                margin: {
                    top: 'medium'
                },
                gap: "medium",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLink.ButtonLink), {
                            to: "mnemonic",
                            label: t('openWallet.method.mnemonic', 'Mnemonic'),
                            primary: true
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLink.ButtonLink), {
                            to: "private-key",
                            label: t('openWallet.method.privateKey', 'Private key'),
                            primary: true
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLink.ButtonLink), {
                            to: "ledger",
                            label: t('openWallet.method.ledger', 'Ledger'),
                            primary: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                direction: "row-responsive",
                justify: "start",
                margin: {
                    top: 'medium'
                },
                gap: "medium",
                style: {
                    whiteSpace: 'pre-wrap',
                    display: 'inline'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                    i18nKey: "openWallet.bitpie.warning",
                    t: t,
                    defaults: "\u2757 BitPie wallet users: You cannot import the mnemonic phrase directly from your BitPie wallet. <DocsLink>Check documentation for details.</DocsLink>",
                    components: {
                        DocsLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _anchor.Anchor), {
                            href: "https://docs.oasis.io/general/manage-tokens/faq"
                        })
                    }
                })
            })
        ]
    });
}
function OpenWalletPage() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectOpenMethod, {});
}

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Anchor":"arBWH","grommet/es6/components/Box":"4o01A","react":"8CCva","react-i18next":"7GUHL","app/components/ButtonLink":"8j6EN","app/components/Header":"bHFRk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4sM6J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "commonRoutes", ()=>commonRoutes);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _createWalletPage = require("app/pages/CreateWalletPage");
var _homePage = require("app/pages/HomePage");
var _fromMnemonic = require("app/pages/OpenWalletPage/Features/FromMnemonic");
var _fromPrivateKey = require("app/pages/OpenWalletPage/Features/FromPrivateKey");
var _accountPage = require("app/pages/AccountPage");
var _validateAccountPageRoute = require("app/pages/AccountPage/validateAccountPageRoute");
var _accountDetails = require("app/pages/AccountPage/Features/AccountDetails");
var _validatorList = require("app/pages/StakingPage/Features/ValidatorList");
var _activeDelegationList = require("app/pages/StakingPage/Features/DelegationList/ActiveDelegationList");
var _debondingDelegationList = require("app/pages/StakingPage/Features/DelegationList/DebondingDelegationList");
var _paraTimesPage = require("app/pages/ParaTimesPage");
var _errorBoundary = require("app/components/ErrorBoundary");
var _fromBleLedger = require("./app/pages/OpenWalletPage/Features/FromBleLedger");
var _fromUsbLedger = require("./app/pages/OpenWalletPage/Features/FromUsbLedger");
const commonRoutes = [
    {
        path: '',
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _homePage.HomePage), {})
    },
    {
        path: 'create-wallet',
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createWalletPage.CreateWalletPage), {})
    },
    {
        path: 'account/:address/*',
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountPage.AccountPage), {}),
        errorElement: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorBoundary.ErrorBoundary), {}),
        loader: async ({ params })=>{
            return (0, _validateAccountPageRoute.validateAccountPageRoute)(params);
        },
        children: [
            {
                path: '',
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountDetails.AccountDetails), {})
            },
            {
                path: 'stake',
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorList.ValidatorList), {})
            },
            {
                path: 'stake/active-delegations',
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _activeDelegationList.ActiveDelegationList), {})
            },
            {
                path: 'stake/debonding-delegations',
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _debondingDelegationList.DebondingDelegationList), {})
            },
            {
                path: 'paratimes',
                element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimesPage.ParaTimes), {})
            }
        ]
    },
    {
        path: 'open-wallet/mnemonic',
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fromMnemonic.FromMnemonic), {})
    },
    {
        path: 'open-wallet/private-key',
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fromPrivateKey.FromPrivateKey), {})
    },
    {
        path: 'open-wallet/ledger/usb',
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fromUsbLedger.FromUsbLedger), {})
    },
    {
        path: 'open-wallet/ledger/ble',
        element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fromBleLedger.FromBleLedger), {})
    }
];

},{"react/jsx-runtime":"6pm7f","react":"8CCva","app/pages/CreateWalletPage":"aVwG5","app/pages/HomePage":"ggGX9","app/pages/OpenWalletPage/Features/FromMnemonic":"bne1n","app/pages/OpenWalletPage/Features/FromPrivateKey":"fxulb","app/pages/AccountPage":"f5POx","app/pages/AccountPage/validateAccountPageRoute":"j7vza","app/pages/AccountPage/Features/AccountDetails":"9tZlC","app/pages/StakingPage/Features/ValidatorList":"5IWyP","app/pages/StakingPage/Features/DelegationList/ActiveDelegationList":"lCWWS","app/pages/StakingPage/Features/DelegationList/DebondingDelegationList":"im1Wq","app/pages/ParaTimesPage":"bDRBN","app/components/ErrorBoundary":"5AebO","./app/pages/OpenWalletPage/Features/FromBleLedger":"54cKp","./app/pages/OpenWalletPage/Features/FromUsbLedger":"apWf9","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aVwG5":[function(require,module,exports,__globalThis) {
/**
 *
 * CreateWalletPage
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CreateWalletPage", ()=>CreateWalletPage);
var _jsxRuntime = require("react/jsx-runtime");
var _alertBox = require("app/components/AlertBox");
var _mnemonicGrid = require("app/components/MnemonicGrid");
var _mnemonicValidation = require("app/components/MnemonicValidation");
var _noTranslate = require("app/components/NoTranslate");
var _responsiveLayer = require("app/components/ResponsiveLayer");
var _importaccounts = require("app/state/importaccounts");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _checkBox = require("grommet/es6/components/CheckBox");
var _grid = require("grommet/es6/components/Grid");
var _themeContext = require("grommet/es6/contexts/ThemeContext");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _text = require("grommet/es6/components/Text");
var _refresh = require("grommet-icons/es6/icons/Refresh");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _header = require("app/components/Header");
var _importAccountsSelectionModal = require("app/pages/OpenWalletPage/Features/ImportAccountsSelectionModal");
var _selectors = require("app/state/importaccounts/selectors");
var _slice = require("./slice");
var _selectors1 = require("./slice/selectors");
function CreateWalletPage(props) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const showAccountsSelectionModal = (0, _reactRedux.useSelector)((0, _selectors.selectShowAccountsSelectionModal));
    const [showConfirmation, setConfirmation] = (0, _react.useState)(false);
    const [showMnemonicMismatch, setMnemonicMismatch] = (0, _react.useState)(false);
    const size = _react.useContext((0, _responsiveContext.ResponsiveContext));
    const dispatch = (0, _reactRedux.useDispatch)();
    const mnemonic = (0, _reactRedux.useSelector)((0, _selectors1.selectMnemonic));
    const checked = (0, _reactRedux.useSelector)((0, _selectors1.selectCheckbox));
    const setChecked = (value)=>dispatch((0, _slice.createWalletActions).setChecked(value));
    const regenerateMnemonic = ()=>dispatch((0, _slice.createWalletActions).generateMnemonic());
    const openWallet = (enteredMnemonic)=>{
        const doesMnemonicMatch = enteredMnemonic === mnemonic.join(' ');
        setMnemonicMismatch(!doesMnemonicMatch);
        setConfirmation(false);
        if (doesMnemonicMatch) dispatch((0, _importaccounts.importAccountsActions).enumerateAccountsFromMnemonic(enteredMnemonic));
    };
    _react.useEffect(()=>{
        // Clean-up when leaving this page
        return ()=>{
            dispatch((0, _slice.createWalletActions).clear());
        };
    }, [
        dispatch
    ]);
    //@TODO Remove when firefox supports backdropFilter (used inside MnemonicValidation)
    // https://github.com/oasisprotocol/wallet/issues/287
    const blurMnemonicInFirefox = showConfirmation ? {
        filter: 'blur(5px)'
    } : {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            showMnemonicMismatch && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBox.AlertBox), {
                status: "error",
                children: t('createWallet.mnemonicMismatch', 'Entered mnemonic does not match.')
            }),
            showConfirmation && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _themeContext.ThemeContext).Extend, {
                value: {
                    layer: {
                        overlay: {
                            backdropFilter: 'blur(5px)'
                        }
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveLayer.ResponsiveLayer), {
                    style: {
                        width: {
                            small: '100vw',
                            medium: '90vw',
                            large: '1500px'
                        }[size]
                    },
                    background: "background-front",
                    onEsc: ()=>setConfirmation(false),
                    onClickOutside: ()=>setConfirmation(false),
                    modal: true,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mnemonicValidation.MnemonicValidation), {
                        successHandler: openWallet,
                        abortHandler: ()=>setConfirmation(false)
                    })
                })
            }),
            showAccountsSelectionModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importAccountsSelectionModal.ImportAccountsSelectionModal), {
                abort: ()=>{
                    dispatch((0, _importaccounts.importAccountsActions).clear());
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _grid.Grid), {
                gap: "small",
                pad: "small",
                columns: size === 'small' ? [
                    'auto'
                ] : [
                    '2fr',
                    '2fr'
                ],
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                        background: "background-front",
                        style: blurMnemonicInFirefox,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mnemonicGrid.MnemonicGrid), {
                                mnemonic: mnemonic.length > 0 ? mnemonic : new Array(24).fill('')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                                margin: "xsmall",
                                pad: "small",
                                background: "background-contrast",
                                style: {
                                    wordSpacing: '14px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _noTranslate.NoTranslate), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                "data-testid": "generated-mnemonic",
                                                children: mnemonic.join(' ')
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                style: {
                                                    userSelect: 'none'
                                                }
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                        direction: "row",
                                        justify: "start",
                                        margin: {
                                            top: 'medium'
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _refresh.Refresh), {}),
                                            label: t('createWallet.newMnemonic', 'Generate a new mnemonic'),
                                            primary: true,
                                            onClick: regenerateMnemonic
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                        pad: "medium",
                        background: "background-front",
                        round: "5px",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.Header), {
                                children: t('createWallet.thisIsYourPhrase', 'This is your mnemonic')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                width: "100%",
                                justify: "evenly",
                                margin: {
                                    vertical: 'small'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                    margin: "0",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                                        i18nKey: "createWallet.instruction",
                                        t: t,
                                        defaults: "Save your mnemonic <strong>in the right order</strong> in a secure location, you will need it to open your wallet."
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBox.AlertBox), {
                                status: "warning",
                                children: t('createWallet.doNotShare', 'Never share your mnemonic, anyone with your mnemonic can access your wallet and your tokens.')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                                pad: {
                                    vertical: 'medium'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkBox.CheckBox), {
                                        label: t('createWallet.confirmSaved', "I\u2019ve safely stored my mnemonic"),
                                        disabled: mnemonic.length <= 0,
                                        checked: checked,
                                        onChange: (event)=>setChecked(event.target.checked)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                        direction: "row",
                                        justify: "between",
                                        margin: {
                                            top: 'medium'
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            type: "submit",
                                            label: t('openWallet.mnemonic.import', 'Import my wallet'),
                                            primary: true,
                                            disabled: !checked,
                                            onClick: ()=>{
                                                setConfirmation(true);
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","app/components/AlertBox":"ivux6","app/components/MnemonicGrid":"1ahhZ","app/components/MnemonicValidation":"dJ5Z7","app/components/NoTranslate":"jUKdq","app/components/ResponsiveLayer":"3jeKP","app/state/importaccounts":"eABjR","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/CheckBox":"gaRRO","grommet/es6/components/Grid":"2rRn7","grommet/es6/contexts/ThemeContext":"d77SS","grommet/es6/contexts/ResponsiveContext":"7EsNN","grommet/es6/components/Text":"kz1Ni","grommet-icons/es6/icons/Refresh":"7BwqO","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","app/components/Header":"bHFRk","app/pages/OpenWalletPage/Features/ImportAccountsSelectionModal":"dCGWz","app/state/importaccounts/selectors":"6bs0S","./slice":"apnKj","./slice/selectors":"aWdux","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1ahhZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MnemonicGrid", ()=>MnemonicGrid);
var _jsxRuntime = require("react/jsx-runtime");
var _noTranslate = require("app/components/NoTranslate");
var _box = require("grommet/es6/components/Box");
var _grid = require("grommet/es6/components/Grid");
var _text = require("grommet/es6/components/Text");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _react = require("react");
var _bip39 = require("bip39");
var _runtimeIs = require("app/lib/runtimeIs");
const validWords = new Set((0, _bip39.wordlists)[(0, _bip39.getDefaultWordlist)()]);
const noSelect = {
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    userSelect: 'none'
};
function MnemonicWord(props) {
    const isWordValid = validWords.has(props.word);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        background: "background-contrast",
        margin: "xsmall",
        direction: "row",
        pad: "xsmall",
        border: {
            side: 'bottom'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                pad: {
                    right: 'small'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _text.Text), {
                    style: {
                        ...noSelect,
                        fontSize: (0, _runtimeIs.runtimeIs) === 'mobile-app' ? '14px' : '16px'
                    },
                    children: [
                        props.id,
                        "."
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noTranslate.NoTranslate), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        style: {
                            whiteSpace: 'pre',
                            textDecoration: isWordValid ? undefined : 'red wavy underline',
                            fontSize: (0, _runtimeIs.runtimeIs) === 'mobile-app' ? '14px' : '16px'
                        },
                        children: props.word
                    })
                })
            })
        ]
    });
}
function MnemonicGrid({ mnemonic }) {
    const size = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext));
    const maxEnglishLength = 8;
    const numberDotSpaceLength = 4;
    const columnSize = size === 'large' ? [
        '1fr',
        '1fr',
        '1fr',
        '1fr'
    ] : (0, _runtimeIs.runtimeIs) === 'mobile-app' && size === 'small' ? [
        '1fr',
        '1fr',
        '1fr'
    ] : `${maxEnglishLength + numberDotSpaceLength + 2}ch`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noTranslate.NoTranslate), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _grid.Grid), {
            columns: columnSize,
            "data-testid": "mnemonic-grid",
            children: mnemonic.map((word, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(MnemonicWord, {
                    id: index + 1,
                    word: word
                }, index + 1))
        })
    });
}

},{"react/jsx-runtime":"6pm7f","app/components/NoTranslate":"jUKdq","grommet/es6/components/Box":"4o01A","grommet/es6/components/Grid":"2rRn7","grommet/es6/components/Text":"kz1Ni","grommet/es6/contexts/ResponsiveContext":"7EsNN","react":"8CCva","bip39":"8hadA","app/lib/runtimeIs":"fboJV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2rRn7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Grid", ()=>(0, _grid.Grid));
var _grid = require("./Grid");

},{"./Grid":"iXAq8","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iXAq8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Grid", ()=>Grid);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledGrid = require("./StyledGrid");
var _propTypes = require("./propTypes");
var _useThemeValue = require("../../utils/useThemeValue");
var _contexts = require("../../contexts");
var _excluded = [
    "a11yTitle",
    "aria-label",
    "border",
    "fill",
    "height",
    "responsive",
    "rows",
    "tag",
    "as",
    "width"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var Grid = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var a11yTitle = props.a11yTitle, ariaLabel = props['aria-label'], border = props.border, fill = props.fill, height = props.height, _props$responsive = props.responsive, responsiveProp = _props$responsive === void 0 ? true : _props$responsive, rows = props.rows, tag = props.tag, as = props.as, width = props.width, rest = _objectWithoutPropertiesLoose(props, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), passThemeFlag = _useThemeValue1.passThemeFlag;
    var responsiveContainer = (0, _react.useContext)((0, _contexts.ResponsiveContainerContext));
    var responsive = responsiveContainer && responsiveProp ? 'container' : responsiveProp;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledGrid.StyledGrid), _extends({
        ref: ref,
        "aria-label": ariaLabel || a11yTitle,
        as: !as && tag ? tag : as,
        border: border,
        fillContainer: fill,
        heightProp: height,
        responsive: responsive,
        rowsProp: rows,
        widthProp: width
    }, passThemeFlag, rest));
});
Grid.displayName = 'Grid';
Grid.propTypes = (0, _propTypes.GridPropTypes);
// Defualting to true to support existing code that relies on
// grid.available to create a fallback option
Grid.available = true;

},{"react":"8CCva","./StyledGrid":"ekcTf","./propTypes":"b8Ls8","../../utils/useThemeValue":"6LfDQ","../../contexts":"8InEz","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ekcTf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StyledGrid", ()=>StyledGrid);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("../../utils");
var fillStyle = function fillStyle(fill) {
    if (!fill) return fill;
    if (fill === 'horizontal') return 'width: 100%;';
    if (fill === 'vertical') return 'height: 100%;';
    return "\n      width: 100%;\n      height: 100%;\n    ";
};
var JUSTIFY_MAP = {
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var justifyStyle = (0, _styledComponents.css)([
    "justify-items:",
    ";"
], function(props) {
    return JUSTIFY_MAP[props.justify];
});
var JUSTIFY_CONTENT_MAP = {
    around: 'space-around',
    between: 'space-between',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start',
    stretch: 'stretch'
};
var justifyContentStyle = (0, _styledComponents.css)([
    "justify-content:",
    ";"
], function(props) {
    return JUSTIFY_CONTENT_MAP[props.justifyContent];
});
var gapSizes = function gapSizes(props) {
    var result = [];
    if (typeof props.gap === 'string') {
        var size = props.theme.global.edgeSize[props.gap] || props.gap;
        result[0] = size;
        result[1] = size;
    } else if (props.gap) {
        if (props.gap.row) result[0] = props.theme.global.edgeSize[props.gap.row] || props.gap.row;
        if (props.gap.column) result[1] = props.theme.global.edgeSize[props.gap.column] || props.gap.column;
    }
    return result;
};
var gapStyle = function gapStyle(props) {
    var sizes = gapSizes(props);
    if (sizes[0] !== undefined && sizes[1] !== undefined) return "grid-gap: " + sizes[0] + " " + sizes[1] + ";";
    if (sizes[0] !== undefined) return "grid-row-gap: " + sizes[0] + ";";
    if (sizes[1] !== undefined) return "grid-column-gap: " + sizes[1] + ";";
    return '';
};
var SIZE_MAP = {
    flex: '1fr',
    full: '100%',
    '1/2': '50%',
    '1/4': '25%',
    '2/4': '50%',
    '3/4': '75%',
    '1/3': '33.33%',
    '2/3': '66.66%'
};
var normalizeSize = function normalizeSize(size, props) {
    return SIZE_MAP[size] || props.theme.global.size[size] || size;
};
var getRepeatCount = function getRepeatCount(count) {
    return typeof count === 'number' ? count : "auto-" + (count || 'fit');
};
var getRepeatSize = function getRepeatSize(size, props) {
    if (size === 'flex') return '1fr';
    var gaps = gapSizes(props);
    var min;
    var max;
    var minFill;
    if (Array.isArray(size)) {
        var _size$ = size[0], minSize = _size$ === void 0 ? 'auto' : _size$, _size$2 = size[1], maxSize = _size$2 === void 0 ? 'auto' : _size$2;
        min = normalizeSize(minSize, props);
        if (min.search(/px/) !== -1) minFill = true;
        max = normalizeSize(maxSize, props);
        if (gaps[1] !== undefined) {
            // account for the column gap when using fractional sizes, e.g. 1/3
            if (minSize.indexOf('/') !== -1) min = "calc(" + min + " - (" + gaps[1] + " * (1 - " + minSize + ")))";
            if (maxSize.indexOf('/') !== -1) max = "calc(" + max + " - (" + gaps[1] + " * (1 - " + maxSize + ")))";
        }
    } else {
        min = normalizeSize(size, props);
        if (min.search(/px/) !== -1) minFill = true;
        max = '1fr';
        if (gaps[1] !== undefined) // account for column gap with fractional sizes, e.g. 1/3
        {
            if (size.indexOf('/') !== -1) min = "calc(" + min + " - (" + gaps[1] + " * (1 - " + size + ")))";
        }
    }
    if (minFill) // ensure we never go beyond the container width,
    // for mobile/narrow situations
    min = "min(" + min + ", 100%)";
    return "minmax(" + min + ", " + max + ")";
};
var columnsStyle = function columnsStyle(props) {
    if (Array.isArray(props.columns)) return (0, _styledComponents.css)([
        "grid-template-columns:",
        ";"
    ], props.columns.map(function(s) {
        if (Array.isArray(s)) return "minmax(" + normalizeSize(s[0], props) + ", " + normalizeSize(s[1], props) + ")";
        return normalizeSize(s, props);
    }).join(' '));
    if (typeof props.columns === 'object') return (0, _styledComponents.css)([
        "grid-template-columns:repeat( ",
        ",",
        " );"
    ], getRepeatCount(props.columns.count), getRepeatSize(props.columns.size, props));
    return (0, _styledComponents.css)([
        "grid-template-columns:repeat( auto-fill,",
        " );"
    ], getRepeatSize(props.columns, props));
};
var rowsStyle = function rowsStyle(props) {
    if (Array.isArray(props.rowsProp)) return (0, _styledComponents.css)([
        "grid-template-rows:",
        ";"
    ], props.rowsProp.map(function(s) {
        if (Array.isArray(s)) return "minmax(" + normalizeSize(s[0], props) + ", " + normalizeSize(s[1], props) + ")";
        return normalizeSize(s, props);
    }).join(' '));
    return (0, _styledComponents.css)([
        "grid-auto-rows:",
        ";"
    ], props.theme.global.size[props.rowsProp]);
};
var areasStyle = function areasStyle(props) {
    // translate areas objects into grid-template-areas syntax
    if (!Array.isArray(props.rowsProp) || !Array.isArray(props.columns)) console.warn('Grid `areas` requires `rows` and `columns` to be arrays.');
    if (Array.isArray(props.areas) && props.areas.every(function(area) {
        return Array.isArray(area);
    })) return "grid-template-areas: " + props.areas.map(function(area) {
        return "\"" + area.join(' ') + "\"";
    }).join(' ') + ";";
    var cells = props.rowsProp.map(function() {
        return props.columns.map(function() {
            return '.';
        });
    });
    props.areas.forEach(function(area) {
        for(var row = area.start[1]; row <= area.end[1]; row += 1)for(var column = area.start[0]; column <= area.end[0]; column += 1)cells[row][column] = area.name;
    });
    return "grid-template-areas: " + cells.map(function(r) {
        return "\"" + r.join(' ') + "\"";
    }).join(' ') + ";";
};
var StyledGrid = (0, _styledComponentsDefault.default).div.withConfig((0, _utils.styledComponentsConfig)).withConfig({
    displayName: "StyledGrid",
    componentId: "sc-1wofa1l-0"
})([
    "display:grid;box-sizing:border-box;",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    " ",
    ""
], (0, _utils.genericStyles), function(props) {
    return props.border && (0, _utils.borderStyle)(props.border, props.responsive, props.theme);
}, function(props) {
    return fillStyle(props.fillContainer);
}, function(props) {
    return props.align && (0, _utils.alignStyle);
}, function(props) {
    return props.alignContent && (0, _utils.alignContentStyle);
}, function(props) {
    return props.areas && areasStyle(props);
}, function(props) {
    return props.columns && columnsStyle(props);
}, function(props) {
    return props.gap && gapStyle(props);
}, function(props) {
    return props.justify && justifyStyle;
}, function(props) {
    return props.justifyContent && justifyContentStyle;
}, function(props) {
    return props.pad && (0, _utils.edgeStyle)('padding', props.pad, props.responsive, props.theme.global.edgeSize.responsiveBreakpoint, props.theme);
}, function(props) {
    return props.rowsProp && rowsStyle(props);
}, function(props) {
    return props.heightProp && (0, _utils.heightStyle)(props.heightProp, props.theme);
}, function(props) {
    return props.widthProp && (0, _utils.widthStyle)(props.widthProp, props.theme);
}, function(props) {
    return props.theme.grid && props.theme.grid.extend;
});

},{"styled-components":"6bGrk","../../utils":"fx31z","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"b8Ls8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridPropTypes", ()=>GridPropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _generalPropTypes = require("../../utils/general-prop-types");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var fixedSizes = [
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge'
];
var sizes = [
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'full',
    '1/2',
    '1/3',
    '2/3',
    '1/4',
    '2/4',
    '3/4',
    'flex',
    'auto'
];
var edgeSizes = [
    'xxsmall',
    'xsmall',
    'small',
    'medium',
    'large',
    'xlarge',
    'none'
];
var BORDER_SHAPE = (0, _propTypesDefault.default).shape({
    color: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).string,
        (0, _propTypesDefault.default).shape({
            dark: (0, _propTypesDefault.default).string,
            light: (0, _propTypesDefault.default).string
        })
    ]),
    side: (0, _propTypesDefault.default).oneOf([
        'top',
        'left',
        'bottom',
        'right',
        'start',
        'end',
        'horizontal',
        'vertical',
        'all',
        'between'
    ]),
    size: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).oneOf([
            'xsmall',
            'small',
            'medium',
            'large',
            'xlarge'
        ]),
        (0, _propTypesDefault.default).string
    ]),
    style: (0, _propTypesDefault.default).oneOf([
        'solid',
        'dashed',
        'dotted',
        'double',
        'groove',
        'ridge',
        'inset',
        'outset',
        'hidden'
    ])
});
var PropType = {};
var GridPropTypes = PropType;

},{"prop-types":"j03Ye","../../utils/general-prop-types":"hOGZs","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dJ5Z7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MnemonicValidation", ()=>MnemonicValidation);
var _jsxRuntime = require("react/jsx-runtime");
var _mnemonicGrid = require("app/components/MnemonicGrid");
var _bip39 = require("bip39");
var _grid = require("grommet/es6/components/Grid");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _form = require("grommet/es6/components/Form");
var _paragraph = require("grommet/es6/components/Paragraph");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _header = require("app/components/Header");
var _mnemonicField = require("app/components/MnemonicField");
var _preventSavingInputsToUserData = require("app/lib/preventSavingInputsToUserData");
var _runtimeIs = require("app/lib/runtimeIs");
function MnemonicValidation(props) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const [rawMnemonic, setRawMnemonic] = (0, _react.useState)('');
    const [mnemonicIsValid, setMnemonicIsValid] = (0, _react.useState)(true);
    const size = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext));
    const mnemonicFieldBoxRef = (0, _react.useRef)(null);
    const mnemonic = rawMnemonic.trim().replace(/[ \n]+/g, ' ');
    const onChange = (event)=>{
        setRawMnemonic(event.target.value);
    };
    (0, _react.useEffect)(()=>{
        if ((0, _runtimeIs.runtimeIs) !== 'mobile-app') return;
        const wordCount = mnemonic.split(' ').length;
        // Arbitrary value when to force scroll down the view
        if (wordCount >= 10 && mnemonicFieldBoxRef.current) mnemonicFieldBoxRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }, [
        mnemonic
    ]);
    const onSubmit = ()=>{
        const isValid = (0, _bip39.validateMnemonic)(mnemonic);
        setMnemonicIsValid(isValid);
        if (isValid) props.successHandler(mnemonic);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        background: "background-front",
        margin: "small",
        pad: "medium",
        round: "5px",
        border: {
            color: 'background-front-border',
            size: '1px'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _grid.Grid), {
            gap: "small",
            pad: "none",
            columns: size === 'small' ? '100%' : [
                '1fr',
                '1fr'
            ],
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                    onSubmit: onSubmit,
                    ...(0, _preventSavingInputsToUserData.preventSavingInputsToUserData),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.Header), {
                            children: t('openWallet.mnemonic.header', 'Enter your mnemonic')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paragraph.Paragraph), {
                            children: t('openWallet.mnemonic.instruction', 'Enter all your mnemonic words below separated by spaces. Most mnemonics are made of either 24 or 12 words.')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                            ref: mnemonicFieldBoxRef,
                            style: {
                                scrollMarginTop: '70px'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mnemonicField.MnemonicField), {
                                inputElementId: "mnemonic",
                                placeholder: t('openWallet.mnemonic.enterPhraseHere', 'Enter your mnemonic here'),
                                autoFocus: true,
                                value: rawMnemonic,
                                onChange: onChange,
                                error: mnemonicIsValid === false ? t('openWallet.mnemonic.error', 'Invalid mnemonic. Please make sure to input the words in the right order, all lowercase.') : ''
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                            direction: "row",
                            gap: "small",
                            margin: {
                                top: 'medium'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    type: "submit",
                                    label: t('openWallet.mnemonic.import', 'Import my wallet'),
                                    primary: true
                                }),
                                props.abortHandler && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    label: t('common.cancel', 'Cancel'),
                                    secondary: true,
                                    onClick: props.abortHandler
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                    background: "background-contrast",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mnemonicGrid.MnemonicGrid), {
                        mnemonic: mnemonic.split(' ')
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"6pm7f","app/components/MnemonicGrid":"1ahhZ","bip39":"8hadA","grommet/es6/components/Grid":"2rRn7","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Form":"kRCRN","grommet/es6/components/Paragraph":"kg9QN","grommet/es6/contexts/ResponsiveContext":"7EsNN","react":"8CCva","react-i18next":"7GUHL","app/components/Header":"bHFRk","app/components/MnemonicField":"4bxoL","app/lib/preventSavingInputsToUserData":"idfdE","app/lib/runtimeIs":"fboJV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4bxoL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MnemonicField", ()=>MnemonicField);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _formField = require("grommet/es6/components/FormField");
var _textArea = require("grommet/es6/components/TextArea");
var _runtimeIs = require("app/lib/runtimeIs");
var _preventSavingInputsToUserData = require("app/lib/preventSavingInputsToUserData");
function MnemonicField(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
        htmlFor: props.inputElementId,
        error: props.error ? props.error : '',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textArea.TextArea), {
            id: props.inputElementId,
            placeholder: props.placeholder,
            value: props.value,
            onChange: props.onChange,
            autoFocus: props.autoFocus,
            focusIndicator: true,
            size: "medium",
            rows: (0, _runtimeIs.runtimeIs) === 'mobile-app' ? 3 : 5,
            fill: true,
            ...(0, _preventSavingInputsToUserData.preventSavingInputsToUserData)
        })
    });
}

},{"react/jsx-runtime":"6pm7f","react":"8CCva","grommet/es6/components/FormField":"dcsVI","grommet/es6/components/TextArea":"8mQse","app/lib/runtimeIs":"fboJV","app/lib/preventSavingInputsToUserData":"idfdE","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dCGWz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImportAccountsSelectionModal", ()=>ImportAccountsSelectionModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _alertBox = require("app/components/AlertBox");
var _errorFormatter = require("app/components/ErrorFormatter");
var _header = require("app/components/Header");
var _importAccountsStepFormatter = require("app/components/ImportAccountsStepFormatter");
var _responsiveLayer = require("app/components/ResponsiveLayer");
var _importableAccount = require("app/components/Toolbar/Features/Account/ImportableAccount");
var _importaccounts = require("app/state/importaccounts");
var _selectors = require("app/state/importaccounts/selectors");
var _types = require("app/state/importaccounts/types");
var _wallet = require("app/state/wallet");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _form = require("grommet/es6/components/Form");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _spinner = require("grommet/es6/components/Spinner");
var _text = require("grommet/es6/components/Text");
var _saga = require("app/state/importaccounts/saga");
var _types1 = require("app/state/wallet/types");
var _choosePasswordFields = require("app/components/Persist/ChoosePasswordFields");
var _preventSavingInputsToUserData = require("app/lib/preventSavingInputsToUserData");
function ImportAccountsSelector({ accounts }) {
    const dispatch = (0, _reactRedux.useDispatch)();
    const toggleAccount = (address)=>dispatch((0, _importaccounts.importAccountsActions).toggleAccount(address));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        gap: "small",
        children: accounts.map((a)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importableAccount.ImportableAccount), {
                account: a,
                onClick: toggleAccount
            }, a.address))
    });
}
function ImportAccountsSelectionModal(props) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const size = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext));
    const importAccounts = (0, _reactRedux.useSelector)((0, _selectors.selectImportAccounts));
    const accounts = (0, _reactRedux.useSelector)((0, _selectors.selectImportAccountsOnCurrentPage));
    const pageNum = (0, _reactRedux.useSelector)((0, _selectors.selectImportAccountsPageNumber));
    const error = importAccounts.error;
    const selectedAccounts = (0, _reactRedux.useSelector)((0, _selectors.selectSelectedAccounts));
    const dispatch = (0, _reactRedux.useDispatch)();
    const type = accounts.length > 0 ? accounts[0].type : undefined;
    const openAccounts = ({ value })=>{
        dispatch(type === (0, _types1.WalletType).UsbLedger ? (0, _wallet.walletActions).openWalletsFromLedger({
            choosePassword: value.password2
        }) : (0, _wallet.walletActions).openWalletFromMnemonic({
            choosePassword: value.password2
        }));
    };
    const isBusyImporting = importAccounts.step !== (0, _types.ImportAccountsStep).Idle;
    const cancelDisabled = isBusyImporting && !error;
    const confirmDisabled = isBusyImporting || selectedAccounts.length === 0;
    const canGoPrev = pageNum > 0 && !isBusyImporting && !error;
    const canGoNext = pageNum < (0, _saga.numberOfAccountPages) - 1 && !isBusyImporting && !error;
    const onPrev = ()=>{
        dispatch((0, _importaccounts.importAccountsActions).setPage(pageNum - 1));
    };
    const onNext = ()=>{
        dispatch((0, _importaccounts.importAccountsActions).setPage(pageNum + 1));
        if (type === (0, _types1.WalletType).UsbLedger || type === (0, _types1.WalletType).BleLedger) dispatch((0, _importaccounts.importAccountsActions).enumerateMoreAccountsFromLedger(type));
    };
    // Workaround for i18next-scanner to pickup plurals correctly, because it is missing
    // defaultValue_zero, defaultValue_one, defaultValue_other here:
    // https://github.com/i18next/i18next-scanner/blob/4687b6a/src/parser.js#L502-L503
    t('openWallet.importAccounts.accountCounter_zero', 'No account selected');
    t('openWallet.importAccounts.accountCounter_one', 'One account selected');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveLayer.ResponsiveLayer), {
        onEsc: props.abort,
        onClickOutside: props.abort,
        modal: true,
        background: "background-front",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Form), {
            onSubmit: openAccounts,
            ...(0, _preventSavingInputsToUserData.preventSavingInputsToUserData),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                width: "800px",
                pad: "medium",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.ModalSplitHeader), {
                        side: t('openWallet.importAccounts.accountCounter', '{{count}} accounts selected', {
                            count: selectedAccounts.length
                        }),
                        children: t('openWallet.importAccounts.selectWallets', 'Select accounts to open')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                        style: {
                            minHeight: '362px'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ImportAccountsSelector, {
                                accounts: accounts
                            }),
                            ![
                                (0, _types.ImportAccountsStep).Idle,
                                (0, _types.ImportAccountsStep).LoadingBalances
                            ].includes(importAccounts.step) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                                direction: "row",
                                gap: "medium",
                                alignContent: "center",
                                pad: {
                                    top: 'small'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinner.Spinner), {
                                        size: "medium"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                        alignSelf: "center",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                            size: "medium",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importAccountsStepFormatter.ImportAccountsStepFormatter), {
                                                step: importAccounts.step
                                            })
                                        })
                                    })
                                ]
                            }),
                            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBox.AlertBox), {
                                status: "error",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorFormatter.ErrorFormatter), {
                                    code: error.code,
                                    message: error.message
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                        direction: "row",
                        gap: "large",
                        justify: "center",
                        align: "baseline",
                        pad: {
                            top: 'medium'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                disabled: !canGoPrev,
                                label: size === 'small' ? '<' : `< ${t('openWallet.importAccounts.prev', 'Prev')}`,
                                size: 'small',
                                a11yTitle: t('openWallet.importAccounts.prev', 'Prev'),
                                onClick: onPrev
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: t('openWallet.importAccounts.pageNumber', 'Page {{pageNum}} of {{totalPages}}', {
                                        pageNum: importAccounts.accountsSelectionPageNumber + 1,
                                        totalPages: (0, _saga.numberOfAccountPages)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                disabled: !canGoNext,
                                label: size === 'small' ? '>' : `${t('openWallet.importAccounts.next', 'Next')} >`,
                                size: 'small',
                                a11yTitle: t('openWallet.importAccounts.next', 'Next'),
                                onClick: onNext
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _choosePasswordFields.ChoosePasswordFields), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                        direction: "row",
                        gap: "small",
                        justify: "between",
                        pad: {
                            top: 'medium'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                secondary: true,
                                label: t('common.cancel', 'Cancel'),
                                onClick: props.abort,
                                disabled: cancelDisabled
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                type: "submit",
                                primary: true,
                                "data-testid": "ledger-open-accounts",
                                label: t('openWallet.importAccounts.openWallets', 'Open'),
                                disabled: confirmDisabled
                            })
                        ]
                    })
                ]
            })
        })
    });
}

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","app/components/AlertBox":"ivux6","app/components/ErrorFormatter":"9p32r","app/components/Header":"bHFRk","app/components/ImportAccountsStepFormatter":"lIxa3","app/components/ResponsiveLayer":"3jeKP","app/components/Toolbar/Features/Account/ImportableAccount":"dYaY9","app/state/importaccounts":"eABjR","app/state/importaccounts/selectors":"6bs0S","app/state/importaccounts/types":"irNSx","app/state/wallet":"iYAaC","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Form":"kRCRN","grommet/es6/contexts/ResponsiveContext":"7EsNN","grommet/es6/components/Spinner":"bxfAK","grommet/es6/components/Text":"kz1Ni","app/state/importaccounts/saga":"4YSF4","app/state/wallet/types":"b0U5N","app/components/Persist/ChoosePasswordFields":"2r09x","app/lib/preventSavingInputsToUserData":"idfdE","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9p32r":[function(require,module,exports,__globalThis) {
/**
 *
 * ErrorFormatter
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorFormatter", ()=>ErrorFormatter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _anchor = require("grommet/es6/components/Anchor");
var _errors = require("types/errors");
var _backend = require("vendors/backend");
var _config = require("config");
function ErrorFormatter(props) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const message = props.message;
    const backendToLabel = {
        [(0, _config.BackendAPIs).OasisScanV2]: t('backends.oasisscanV2', 'Oasis Scan API v2'),
        [(0, _config.BackendAPIs).Nexus]: t('backends.nexus', 'Nexus API')
    };
    const ledgerNoDeviceSelectedHelp = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
        i18nKey: "errors.ledgerNoDeviceSelected",
        t: t,
        defaults: "No Ledger device selected. Make sure it is connected, <LedgerHelp>check common USB connection issues with Ledger</LedgerHelp>, and <ChromeHelp>check site permissions don't block USB devices</ChromeHelp>.",
        components: {
            LedgerHelp: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _anchor.Anchor), {
                href: "https://support.ledger.com/article/115005165269-zd",
                target: "_blank",
                rel: "noopener",
                style: {
                    display: 'inline'
                }
            }),
            ChromeHelp: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _anchor.Anchor), {
                href: "https://support.google.com/chrome/answer/114662",
                target: "_blank",
                rel: "noopener",
                style: {
                    display: 'inline'
                }
            })
        }
    });
    const errorMap = {
        [(0, _errors.WalletErrors).UnknownError]: t('errors.unknown', 'Unknown error: {{message}}', {
            message
        }),
        [(0, _errors.WalletErrors).UnknownGrpcError]: t('errors.unknownGrpc', 'Unknown gRPC error: {{message}}', {
            message
        }),
        [(0, _errors.WalletErrors).InvalidAddress]: t('errors.invalidAddress', 'Invalid address'),
        [(0, _errors.WalletErrors).InvalidPrivateKey]: t('errors.invalidPrivateKey', 'Invalid private key'),
        [(0, _errors.WalletErrors).InsufficientBalance]: t('errors.insufficientBalance', 'Insufficient balance'),
        [(0, _errors.WalletErrors).CannotSendToSelf]: t('errors.cannotSendToSelf', 'Cannot send to yourself'),
        [(0, _errors.WalletErrors).InvalidNonce]: t('errors.invalidNonce', 'Invalid nonce (transaction number)'),
        [(0, _errors.WalletErrors).DuplicateTransaction]: t('errors.duplicateTransaction', 'Duplicate transaction'),
        [(0, _errors.WalletErrors).NoOpenWallet]: t('errors.noOpenWallet', 'No wallet opened'),
        [(0, _errors.WalletErrors).USBTransportNotSupported]: t('errors.usbTransportNotSupported', 'Current platform does not support WebUSB capability. Try on different platform or browser (preferably Chrome).'),
        [(0, _errors.WalletErrors).USBTransportError]: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                t('errors.usbTransportError', 'USB Transport error: {{message}}.', {
                    message
                }),
                ' ',
                ledgerNoDeviceSelectedHelp
            ]
        }),
        [(0, _errors.WalletErrors).LedgerAppVersionNotSupported]: t('errors.ledgerAppVersionNotSupported', 'Oasis App on Ledger is closed or outdated. Make sure Ledger is unlocked, the Oasis App is opened and up to date.'),
        [(0, _errors.WalletErrors).LedgerTransactionRejected]: t('errors.ledgerTransactionRejected', 'Transaction rejected on Ledger.'),
        [(0, _errors.WalletErrors).LedgerNoDeviceSelected]: ledgerNoDeviceSelectedHelp,
        [(0, _errors.WalletErrors).LedgerCannotOpenOasisApp]: t('errors.ledgerCannotOpenOasisApp', 'Could not open Oasis App on Ledger. Make sure Ledger is unlocked and the Oasis App is opened.'),
        [(0, _errors.WalletErrors).LedgerOasisAppIsNotOpen]: t('errors.LedgerOasisAppIsNotOpen', 'Oasis App on Ledger is closed.'),
        [(0, _errors.WalletErrors).LedgerDerivedDifferentAccount]: t('errors.LedgerDerivedDifferentAccount', 'This account does not belong to the currently connected Ledger.'),
        [(0, _errors.WalletErrors).LedgerLikelyFaultyFirmware]: t('errors.LedgerLikelyFaultyFirmware', 'Connecting to Ledger timed out. This is likely due to faulty Ledger firmware: Nano X 2.5.0, Nano S Plus 1.4.0, Stax 1.8.0, Flex 1.4.0. Update to the next firmware version and try again.'),
        [(0, _errors.WalletErrors).LedgerUnknownError]: t('errors.unknownLedgerError', 'Unknown ledger error: {{message}}', {
            message
        }),
        [(0, _errors.WalletErrors).IndexerAPIError]: t('errors.indexerAPIError', '{{indexerName}} appears to be down, some information may be missing or out of date. Please, come back later.', {
            indexerName: backendToLabel[(0, _backend.backend)()]
        }),
        [(0, _errors.WalletErrors).DisconnectedError]: t('errors.disconnectedError', 'Lost connection.'),
        [(0, _errors.WalletErrors).ParaTimesUnknownError]: t('errors.unknownParaTimeError', 'Unknown ParaTime error: {{message}}', {
            message
        }),
        [(0, _errors.WalletErrors).BluetoothTransportNotSupported]: t('errors.bluetoothTransportNotSupported', 'Bluetooth may be turned off or your current platform does not support Bluetooth capability.')
    };
    const error = errorMap[props.code];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: error
    });
}

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-i18next":"7GUHL","grommet/es6/components/Anchor":"arBWH","types/errors":"gbx4q","vendors/backend":"aIngR","config":"akiw0","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lIxa3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImportAccountsStepFormatter", ()=>ImportAccountsStepFormatter);
var _jsxRuntime = require("react/jsx-runtime");
var _types = require("app/state/importaccounts/types");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
const ImportAccountsStepFormatter = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const step = props.step;
    const stepMap = {
        [(0, _types.ImportAccountsStep).Idle]: t('ledger.steps.idle', 'Idle'),
        [(0, _types.ImportAccountsStep).AccessingLedger]: t('ledger.steps.accessingLedger', 'Connecting with Ledger device'),
        [(0, _types.ImportAccountsStep).LoadingAccounts]: t('ledger.steps.loadingAccounts', 'Loading account details'),
        [(0, _types.ImportAccountsStep).LoadingBalances]: t('ledger.steps.loadingBalances', 'Loading balance details'),
        [(0, _types.ImportAccountsStep).LoadingBleDevices]: t('ledger.steps.loadingBluetoothDevices', 'Loading bluetooth devices')
    };
    const message = stepMap[step];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: message
    });
});

},{"react/jsx-runtime":"6pm7f","app/state/importaccounts/types":"irNSx","react":"8CCva","react-i18next":"7GUHL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dYaY9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ImportableAccount", ()=>ImportableAccount);
var _jsxRuntime = require("react/jsx-runtime");
var _account = require("./Account");
const ImportableAccount = ({ account, onClick })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _account.Account), {
        address: account.address,
        balance: account.balance,
        onClick: onClick,
        isActive: account.selected,
        displayBalance: true,
        displayCheckbox: true,
        displayAccountNumber: true,
        displayDerivation: {
            pathDisplay: account.pathDisplay
        },
        path: account.path
    });
};

},{"react/jsx-runtime":"6pm7f","./Account":"72YoH","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2r09x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChoosePasswordFields", ()=>ChoosePasswordFields);
var _jsxRuntime = require("react/jsx-runtime");
var _selectors = require("app/state/persist/selectors");
var _selectUnlockedStatus = require("app/state/selectUnlockedStatus");
var _box = require("grommet/es6/components/Box");
var _text = require("grommet/es6/components/Text");
var _checkBox = require("grommet/es6/components/CheckBox");
var _formField = require("grommet/es6/components/FormField");
var _paragraph = require("grommet/es6/components/Paragraph");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _choosePasswordInputFields = require("./ChoosePasswordInputFields");
var _runtimeIs = require("app/lib/runtimeIs");
function ChoosePasswordFields() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const unlockedStatus = (0, _reactRedux.useSelector)((0, _selectUnlockedStatus.selectUnlockedStatus));
    const isPersistenceUnsupported = (0, _reactRedux.useSelector)((0, _selectors.selectIsPersistenceUnsupported));
    const hasUnpersistedAccounts = unlockedStatus === 'openUnpersisted';
    const [startPersisting, setStartPersisting] = (0, _react.useState)(!hasUnpersistedAccounts);
    const isExtension = (0, _runtimeIs.runtimeIs) === 'extension';
    const isChoiceDisabled = isPersistenceUnsupported || unlockedStatus === 'unlockedProfile' || unlockedStatus === 'emptySkippedUnlockingProfile' || unlockedStatus === 'openSkippedUnlockingProfile';
    const isChoosingPassword = !isChoiceDisabled && startPersisting;
    if (isPersistenceUnsupported) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
        children: t('persist.createProfile.unsupported', 'Persistence is not supported in this browser.')
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        as: "fieldset",
        margin: {
            top: 'medium'
        },
        pad: "medium",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
                contentProps: {
                    border: false,
                    pad: 'none'
                },
                margin: {
                    top: 'xsmall'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkBox.CheckBox), {
                    label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                        children: t('persist.createProfile.startPersistingToggle', 'Create a profile')
                    }),
                    toggle: true,
                    onChange: (event)=>setStartPersisting(event.target.checked),
                    ...isChoiceDisabled ? {
                        disabled: true,
                        checked: unlockedStatus === 'unlockedProfile'
                    } : isExtension ? {
                        disabled: true,
                        // Force creating a profile in Manifest v3 extension because we can't keep state in memory.
                        // User would lose all progress every time popup closes.
                        checked: true
                    } : {
                        checked: startPersisting
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paragraph.Paragraph), {
                size: "small",
                fill: true,
                children: t('persist.createProfile.startPersisting', 'Store your private keys locally and protect them with a password by creating a profile.')
            }),
            isChoosingPassword && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _choosePasswordInputFields.ChoosePasswordInputFields), {
                        password1Placeholder: t('persist.loginToProfile.enterPasswordHere', 'Enter your password'),
                        password2Placeholder: t('persist.createProfile.repeatPassword', 'Confirm your password')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
                        name: "profileStorageUndependableAcknowledge",
                        validate: (value)=>value ? undefined : t('persist.createProfile.requiredField', 'This field is required'),
                        contentProps: {
                            border: false,
                            pad: 'none'
                        },
                        margin: {
                            top: 'xsmall'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkBox.CheckBox), {
                            name: "profileStorageUndependableAcknowledge",
                            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paragraph.Paragraph), {
                                size: "small",
                                fill: true,
                                children: t('persist.createProfile.undependableAcknowledge', 'I understand this password and profile do not substitute my mnemonic.')
                            })
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","app/state/persist/selectors":"lDilG","app/state/selectUnlockedStatus":"aRpzm","grommet/es6/components/Box":"4o01A","grommet/es6/components/Text":"kz1Ni","grommet/es6/components/CheckBox":"gaRRO","grommet/es6/components/FormField":"dcsVI","grommet/es6/components/Paragraph":"kg9QN","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","./ChoosePasswordInputFields":"5oBbr","app/lib/runtimeIs":"fboJV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aWdux":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectCreateWallet", ()=>selectCreateWallet);
parcelHelpers.export(exports, "selectMnemonic", ()=>selectMnemonic);
parcelHelpers.export(exports, "selectCheckbox", ()=>selectCheckbox);
var _toolkit = require("@reduxjs/toolkit");
var _ = require(".");
const selectSlice = (state)=>state.createWallet || (0, _.initialState);
const selectCreateWallet = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state);
const selectMnemonic = (0, _toolkit.createSelector)([
    selectCreateWallet
], (wallet)=>wallet.mnemonic);
const selectCheckbox = (0, _toolkit.createSelector)([
    selectCreateWallet
], (wallet)=>wallet.checkbox);

},{"@reduxjs/toolkit":"9ol63",".":"apnKj","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ggGX9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HomePage", ()=>HomePage);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("grommet/es6/components/Box");
var _grid = require("grommet/es6/components/Grid");
var _paragraph = require("grommet/es6/components/Paragraph");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _add = require("grommet-icons/es6/icons/Add");
var _unlock = require("grommet-icons/es6/icons/Unlock");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _buttonLink = require("app/components/ButtonLink");
var _header = require("app/components/Header");
function HomePage() {
    const size = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext));
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _grid.Grid), {
            gap: "small",
            pad: "small",
            columns: size === 'small' ? [
                'auto'
            ] : [
                '2fr',
                '2fr'
            ],
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    round: "5px",
                    border: {
                        color: 'background-front-border',
                        size: '1px'
                    },
                    background: "background-front",
                    pad: "large",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.Header), {
                            children: t('home.existing.header', 'Access existing wallet')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paragraph.Paragraph), {
                            children: t('home.existing.description', 'Open your existing wallet stored on Ledger, import a private key or a mnemonic phrase.')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                            direction: "row",
                            justify: "between",
                            margin: {
                                top: 'medium'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLink.ButtonLink), {
                                to: "open-wallet",
                                label: t('home.existing.button', 'Open wallet'),
                                primary: true,
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unlock.Unlock), {
                                    a11yTitle: undefined
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    round: "5px",
                    border: {
                        color: 'background-front-border',
                        size: '1px'
                    },
                    background: "background-front",
                    pad: "large",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.Header), {
                            children: t('home.create.header', 'Create new wallet')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paragraph.Paragraph), {
                            children: t('home.create.description', 'Create a brand new wallet to send, receive, stake and swap ROSE tokens.')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                            direction: "row",
                            justify: "between",
                            margin: {
                                top: 'medium'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLink.ButtonLink), {
                                to: "create-wallet",
                                label: t('home.create.button', 'Create wallet'),
                                primary: true,
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _add.Add), {
                                    a11yTitle: undefined
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Box":"4o01A","grommet/es6/components/Grid":"2rRn7","grommet/es6/components/Paragraph":"kg9QN","grommet/es6/contexts/ResponsiveContext":"7EsNN","grommet-icons/es6/icons/Add":"kULLY","grommet-icons/es6/icons/Unlock":"cAidM","react":"8CCva","react-i18next":"7GUHL","app/components/ButtonLink":"8j6EN","app/components/Header":"bHFRk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bne1n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FromMnemonic", ()=>FromMnemonic);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _mnemonicValidation = require("app/components/MnemonicValidation");
var _importaccounts = require("app/state/importaccounts");
var _importAccountsSelectionModal = require("app/pages/OpenWalletPage/Features/ImportAccountsSelectionModal");
var _selectors = require("app/state/importaccounts/selectors");
function FromMnemonic() {
    const dispatch = (0, _reactRedux.useDispatch)();
    const showAccountsSelectionModal = (0, _reactRedux.useSelector)((0, _selectors.selectShowAccountsSelectionModal));
    const successHandler = (mnemonic)=>{
        dispatch((0, _importaccounts.importAccountsActions).enumerateAccountsFromMnemonic(mnemonic));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mnemonicValidation.MnemonicValidation), {
                successHandler: successHandler
            }),
            showAccountsSelectionModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importAccountsSelectionModal.ImportAccountsSelectionModal), {
                abort: ()=>{
                    dispatch((0, _importaccounts.importAccountsActions).clear());
                }
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-redux":"azV3Y","app/components/MnemonicValidation":"dJ5Z7","app/state/importaccounts":"eABjR","app/pages/OpenWalletPage/Features/ImportAccountsSelectionModal":"dCGWz","app/state/importaccounts/selectors":"6bs0S","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fxulb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FromPrivateKey", ()=>FromPrivateKey);
var _jsxRuntime = require("react/jsx-runtime");
var _wallet = require("app/state/wallet");
var _box = require("grommet/es6/components/Box");
var _form = require("grommet/es6/components/Form");
var _paragraph = require("grommet/es6/components/Paragraph");
var _button = require("grommet/es6/components/Button");
var _react = require("react");
var _reactRedux = require("react-redux");
var _key = require("app/lib/key");
var _helpers = require("app/lib/helpers");
var _reactI18Next = require("react-i18next");
var _passwordField = require("app/components/PasswordField");
var _header = require("app/components/Header");
var _choosePasswordFields = require("app/components/Persist/ChoosePasswordFields");
var _preventSavingInputsToUserData = require("app/lib/preventSavingInputsToUserData");
var _ethHelpers = require("app/lib/eth-helpers");
const isValidKey = (privateKey)=>{
    try {
        (0, _key.OasisKey).fromBase64PrivateKey(privateKey);
        return true;
    } catch (e) {
        return false;
    }
};
function FromPrivateKey(props) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const onSubmit = ({ value })=>{
        const secret = (0, _key.OasisKey).fromBase64PrivateKey(value.privateKey);
        dispatch((0, _wallet.walletActions).openWalletFromPrivateKey({
            privateKey: (0, _helpers.uint2hex)(secret),
            choosePassword: value.password2
        }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        background: "background-front",
        margin: "small",
        pad: "medium",
        round: "5px",
        border: {
            color: 'background-front-border',
            size: '1px'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
            onSubmit: onSubmit,
            ...(0, _preventSavingInputsToUserData.preventSavingInputsToUserData),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.Header), {
                    children: t('openWallet.privateKey.header', 'Enter your private key')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paragraph.Paragraph), {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "privatekey",
                        children: t('openWallet.privateKey.instruction', 'Enter your private key in Base64 format.')
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _passwordField.PasswordField), {
                    inputElementId: "privatekey",
                    name: "privateKey",
                    placeholder: t('openWallet.privateKey.enterPrivateKeyHere', 'Enter your private key here'),
                    autoFocus: true,
                    validate: (privateKey)=>isValidKey(privateKey) ? undefined : (0, _ethHelpers.isValidEthPrivateKey)((0, _ethHelpers.stripHexPrefix)(privateKey)) ? t('openWallet.privateKey.errorKeyIsInEthFormat', 'This input is intended for Oasis Consensus private keys. The private key you entered looks like an Ethereum-compatible private key (e.g. from MetaMask for Sapphire). If you want to use your Ethereum-compatible private key to move ROSE from Sapphire to Consensus, click "{{paratimesMenu}}", then "{{withdrawButton}}", and paste it there.', {
                            paratimesMenu: t('menu.paraTimes', 'ParaTimes'),
                            withdrawButton: t('paraTimes.transfers.withdraw', 'Withdraw from ParaTime')
                        }) : t('openWallet.privateKey.error', 'Invalid private key'),
                    showTip: t('openWallet.privateKey.showPrivateKey', 'Show private key'),
                    hideTip: t('openWallet.privateKey.hidePrivateKey', 'Hide private key'),
                    width: "xlarge"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _choosePasswordFields.ChoosePasswordFields), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                    pad: {
                        vertical: 'medium'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        direction: "row",
                        justify: "between",
                        margin: {
                            top: 'medium'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            type: "submit",
                            label: t('openWallet.mnemonic.import', 'Import my wallet'),
                            primary: true
                        })
                    })
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"6pm7f","app/state/wallet":"iYAaC","grommet/es6/components/Box":"4o01A","grommet/es6/components/Form":"kRCRN","grommet/es6/components/Paragraph":"kg9QN","grommet/es6/components/Button":"fVON6","react":"8CCva","react-redux":"azV3Y","app/lib/key":"a61Hw","app/lib/helpers":"bUnFy","react-i18next":"7GUHL","app/components/PasswordField":"hEUcp","app/components/Header":"bHFRk","app/components/Persist/ChoosePasswordFields":"2r09x","app/lib/preventSavingInputsToUserData":"idfdE","app/lib/eth-helpers":"gcAe1","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"f5POx":[function(require,module,exports,__globalThis) {
/**
 *
 * AccountPage
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountPage", ()=>AccountPage);
var _jsxRuntime = require("react/jsx-runtime");
var _alertBox = require("app/components/AlertBox");
var _errorFormatter = require("app/components/ErrorFormatter");
var _transactionModal = require("app/components/TransactionModal");
var _selectors = require("app/state/network/selectors");
var _selectors1 = require("app/state/staking/selectors");
var _selectors2 = require("app/state/transaction/selectors");
var _box = require("grommet/es6/components/Box");
var _layer = require("grommet/es6/components/Layer");
var _spinner = require("grommet/es6/components/Spinner");
var _text = require("grommet/es6/components/Text");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _account = require("app/state/account");
var _selectors3 = require("app/state/account/selectors");
var _selectors4 = require("app/state/wallet/selectors");
var _wallet = require("app/state/wallet");
var _accountSummary = require("./Features/AccountSummary");
function AccountPage() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const address = (0, _reactRouterDom.useParams)().address;
    const dispatch = (0, _reactRedux.useDispatch)();
    const account = (0, _reactRedux.useSelector)((0, _selectors3.selectAccount));
    const stake = (0, _reactRedux.useSelector)((0, _selectors1.selectStaking));
    const walletHasAccounts = (0, _reactRedux.useSelector)((0, _selectors4.selectHasAccounts));
    const wallet = (0, _reactRedux.useSelector)((0, _selectors4.selectActiveWallet));
    const selectedNetwork = (0, _reactRedux.useSelector)((0, _selectors.selectSelectedNetwork));
    const { active } = (0, _reactRedux.useSelector)((0, _selectors2.selectTransaction));
    const hasOneAccount = (0, _reactRedux.useSelector)((0, _selectors4.selectHasOneAccount));
    const balanceDelegations = stake.delegations?.reduce((acc, v)=>acc + BigInt(v.amount), 0n);
    const balanceDebondingDelegations = stake.debondingDelegations?.reduce((acc, v)=>acc + BigInt(v.amount), 0n);
    const balance = {
        available: account.available,
        delegations: balanceDelegations?.toString() ?? null,
        debonding: balanceDebondingDelegations?.toString() ?? null,
        total: account.available == null || balanceDelegations == null || balanceDebondingDelegations == null ? null : (BigInt(account.available) + balanceDelegations + balanceDebondingDelegations).toString(),
        nonce: account.nonce
    };
    // Restart fetching account balances if address or network changes
    (0, _react.useEffect)(()=>{
        dispatch((0, _account.accountActions).openAccountPage(address));
        return ()=>{
            dispatch((0, _account.accountActions).closeAccountPage());
        };
    }, [
        dispatch,
        address,
        selectedNetwork
    ]);
    const isStakeInitialLoading = stake.loading && stake.delegations === null;
    const isAccountInitialLoading = account.loading && !account.address;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        pad: "small",
        children: [
            active && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionModal.TransactionModal), {}),
            (isStakeInitialLoading || isAccountInitialLoading) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _layer.Layer), {
                modal: true,
                background: "background-front",
                responsive: false,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    pad: "medium",
                    gap: "medium",
                    direction: "row",
                    align: "center",
                    width: "max-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinner.Spinner), {
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                            size: "medium",
                            children: t('account.loading', 'Loading account')
                        })
                    ]
                })
            }),
            account.accountError && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alertBox.AlertBox), {
                status: "error",
                children: [
                    t('account.loadingError', "Couldn't load account."),
                    ' ',
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorFormatter.ErrorFormatter), {
                        code: account.accountError.code,
                        message: account.accountError.message
                    })
                ]
            }),
            stake.updateDelegationsError && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _alertBox.AlertBox), {
                status: "error",
                children: [
                    t('delegations.loadingError', "Couldn't load delegations."),
                    ' ',
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorFormatter.ErrorFormatter), {
                        code: stake.updateDelegationsError.code,
                        message: stake.updateDelegationsError.message
                    })
                ]
            }),
            address && address !== '' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _accountSummary.AccountSummary), {
                        address: address,
                        balance: balance,
                        deleteWallet: hasOneAccount && wallet ? undefined : (address)=>{
                            dispatch((0, _wallet.walletActions).deleteWallet(address));
                            wallet.address === address && dispatch((0, _wallet.walletActions).selectFirstWallet());
                        },
                        wallet: wallet,
                        walletHasAccounts: walletHasAccounts
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        margin: {
                            bottom: 'small'
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Outlet), {})
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","app/components/AlertBox":"ivux6","app/components/ErrorFormatter":"9p32r","app/components/TransactionModal":"iZav7","app/state/network/selectors":"2zit7","app/state/staking/selectors":"jY45G","app/state/transaction/selectors":"8LlWj","grommet/es6/components/Box":"4o01A","grommet/es6/components/Layer":"3gh0x","grommet/es6/components/Spinner":"bxfAK","grommet/es6/components/Text":"kz1Ni","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","react-router-dom":"9pTjq","app/state/account":"3cfOb","app/state/account/selectors":"avcAi","app/state/wallet/selectors":"cgtJ3","app/state/wallet":"iYAaC","./Features/AccountSummary":"c8Fjt","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iZav7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 *
 * TransactionModal
 *
 * Takes a transaction payload as input - then through the modal:
 *
 * - Review the transaction (Display the raw body)
 * - Submit
 * - If ledger, display a loader and a message telling to sign on ledger
 * - Display transaction sent
 *
 */ parcelHelpers.export(exports, "TransactionModal", ()=>TransactionModal);
var _jsxRuntime = require("react/jsx-runtime");
var _alertBox = require("app/components/AlertBox");
var _header = require("app/components/Header");
var _selectors = require("app/state/network/selectors");
var _transaction = require("app/state/transaction");
var _selectors1 = require("app/state/transaction/selectors");
var _types = require("app/state/transaction/types");
var _selectors2 = require("app/state/wallet/selectors");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _spinner = require("grommet/es6/components/Spinner");
var _text = require("grommet/es6/components/Text");
var _alert = require("grommet-icons/es6/icons/Alert");
var _checkmark = require("grommet-icons/es6/icons/Checkmark");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _react = require("react");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _responsiveLayer = require("../ResponsiveLayer");
var _transactionPreview = require("../TransactionPreview");
const StyledBox = (0, _styledComponentsDefault.default)((0, _box.Box))`
  margin-bottom: ${({ theme })=>theme.global?.edgeSize?.medium};

  @media only screen and (max-width: ${({ theme })=>`${theme.global?.breakpoints?.small?.value}px`}) {
    max-width: initial;
    margin-left: -${({ theme })=>theme.global?.edgeSize?.small};
    margin-right: -${({ theme })=>theme.global?.edgeSize?.small};
  }
`;
function TransactionModal() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const { preview, step } = (0, _reactRedux.useSelector)((0, _selectors1.selectTransaction));
    const walletAddress = (0, _reactRedux.useSelector)((0, _selectors2.selectAddress));
    const chainContext = (0, _reactRedux.useSelector)((0, _selectors.selectChainContext));
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    const dispatch = (0, _reactRedux.useDispatch)();
    const abortTransaction = ()=>{
        dispatch((0, _transaction.transactionActions).abortTransaction());
    };
    const confirmTransaction = ()=>{
        dispatch((0, _transaction.transactionActions).confirmTransaction());
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveLayer.ResponsiveLayer), {
        modal: true,
        position: "center",
        background: "background-front",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            pad: "medium",
            gap: "medium",
            width: "800px",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.ModalHeader), {
                            level: 3,
                            margin: {
                                top: 'xsmall',
                                bottom: 'medium'
                            },
                            children: t('transaction.step.preview', 'Preview transaction')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledBox, {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBox.AlertBox), {
                                status: "warning-weak",
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                    pad: isMobile ? {
                                        horizontal: 'small'
                                    } : undefined,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alert.Alert), {
                                        size: "20px",
                                        color: "alert-box-warning-background"
                                    })
                                }),
                                children: t('transaction.preview.warning', 'Once you confirm this transaction you will not be able to cancel it. Carefully review it, and confirm once you are sure that you want to send it.')
                            })
                        }),
                        preview && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionPreview.TransactionPreview), {
                            chainContext: chainContext,
                            preview: preview,
                            walletAddress: walletAddress
                        }),
                        step === (0, _types.TransactionStep).Preview && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                            direction: "row",
                            gap: "small",
                            alignSelf: "end",
                            pad: {
                                top: 'large'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    secondary: true,
                                    label: t('transaction.cancel', 'Cancel'),
                                    onClick: abortTransaction
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    primary: true,
                                    label: t('transaction.confirm', 'Confirm'),
                                    onClick: confirmTransaction,
                                    icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmark.Checkmark), {
                                        size: "18px"
                                    }),
                                    alignSelf: "end"
                                })
                            ]
                        })
                    ]
                }),
                step === (0, _types.TransactionStep).Building && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    direction: "row",
                    align: "center",
                    gap: "medium",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinner.Spinner), {
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                            size: "medium",
                            children: t('transaction.step.building', 'Building transaction')
                        })
                    ]
                }),
                step === (0, _types.TransactionStep).Signing && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    direction: "row",
                    align: "center",
                    gap: "medium",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinner.Spinner), {
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                            size: "medium",
                            children: t('transaction.step.signing', 'Signing transaction')
                        })
                    ]
                }),
                step === (0, _types.TransactionStep).Submitting && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    direction: "row",
                    align: "center",
                    gap: "medium",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinner.Spinner), {
                            size: "medium"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                            size: "medium",
                            children: t('transaction.step.submitting', 'Submitting transaction')
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"6pm7f","app/components/AlertBox":"ivux6","app/components/Header":"bHFRk","app/state/network/selectors":"2zit7","app/state/transaction":"jax2p","app/state/transaction/selectors":"8LlWj","app/state/transaction/types":"idhb9","app/state/wallet/selectors":"cgtJ3","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Spinner":"bxfAK","grommet/es6/components/Text":"kz1Ni","grommet-icons/es6/icons/Alert":"ik8QA","grommet-icons/es6/icons/Checkmark":"6KJBZ","grommet/es6/contexts/ResponsiveContext":"7EsNN","react-i18next":"7GUHL","react-redux":"azV3Y","react":"8CCva","styled-components":"6bGrk","../ResponsiveLayer":"3jeKP","../TransactionPreview":"grnyt","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8LlWj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectTransaction", ()=>selectTransaction);
parcelHelpers.export(exports, "selectTransactionStep", ()=>selectTransactionStep);
parcelHelpers.export(exports, "selectTransactionPreview", ()=>selectTransactionPreview);
var _toolkit = require("@reduxjs/toolkit");
var _ = require(".");
const selectSlice = (state)=>state.transaction || (0, _.initialState);
const selectTransaction = (0, _toolkit.createSelector)([
    selectSlice
], (state)=>state);
const selectTransactionStep = (0, _toolkit.createSelector)([
    selectTransaction
], (transaction)=>transaction.step);
const selectTransactionPreview = (0, _toolkit.createSelector)([
    selectTransaction
], (transaction)=>transaction.preview);

},{"@reduxjs/toolkit":"9ol63",".":"jax2p","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"grnyt":[function(require,module,exports,__globalThis) {
/**
 *
 * TransactionPreview
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionPreview", ()=>TransactionPreview);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("grommet/es6/components/Box");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _react = require("react");
var _text = require("grommet/es6/components/Text");
var _amountFormatter = require("../AmountFormatter");
var _responsiveGridRow = require("../ResponsiveGridRow");
var _reactI18Next = require("react-i18next");
var _transactionTypeFormatter = require("../TransactionTypeFormatter");
const TransactionPreview = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    const { preview, walletAddress, chainContext } = props;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        gap: isMobile ? 'medium' : 'xsmall',
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveGridRow.PreviewRow), {
                label: t('transaction.preview.type', 'Type'),
                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionTypeFormatter.TransactionTypeFormatter), {
                    type: preview.transaction.type
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveGridRow.AddressPreviewRow), {
                label: t('transaction.preview.from', 'From'),
                value: walletAddress
            }),
            preview.transaction.type === 'transfer' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveGridRow.AddressPreviewRow), {
                label: t('transaction.preview.to', 'To'),
                value: preview.transaction.to
            }),
            (preview.transaction.type === 'addEscrow' || preview.transaction.type === 'reclaimEscrow') && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveGridRow.AddressPreviewRow), {
                label: t('transaction.preview.validator', 'Validator'),
                value: preview.transaction.validator
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveGridRow.PreviewRow), {
                label: t('transaction.preview.amount', 'Amount'),
                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                    amount: preview.transaction.amount,
                    size: "inherit"
                })
            }),
            preview.transaction.type === 'reclaimEscrow' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveGridRow.PreviewRow), {
                label: t('transaction.preview.shares', 'Shares'),
                value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                            amount: preview.transaction.shares,
                            hideTicker: true
                        }),
                        t('common.postfixAmountInBillions', 'B')
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveGridRow.PreviewRow), {
                label: t('transaction.preview.fee', 'Fee'),
                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                    amount: preview.fee,
                    size: "inherit"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveGridRow.PreviewRow), {
                label: t('transaction.preview.gas', 'Gas'),
                value: preview.gas
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveGridRow.PreviewRow), {
                label: t('transaction.preview.genesisHash', 'Genesis hash'),
                value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                    border: {
                        color: 'background-contrast-2',
                        side: 'left',
                        size: '6px'
                    },
                    background: {
                        color: 'background-contrast',
                        opacity: 0.04
                    },
                    pad: {
                        vertical: 'xsmall',
                        horizontal: 'small'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                        color: "grayMedium",
                        size: "small",
                        style: {
                            fontFamily: '"Roboto mono", monospace',
                            letterSpacing: 0
                        },
                        children: chainContext
                    })
                })
            })
        ]
    });
});

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Box":"4o01A","grommet/es6/contexts/ResponsiveContext":"7EsNN","react":"8CCva","grommet/es6/components/Text":"kz1Ni","../AmountFormatter":"dRP3j","../ResponsiveGridRow":"cvHS9","react-i18next":"7GUHL","../TransactionTypeFormatter":"3X2aq","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cvHS9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResponsiveGridRow", ()=>ResponsiveGridRow);
parcelHelpers.export(exports, "PreviewRow", ()=>PreviewRow);
parcelHelpers.export(exports, "AddressPreviewRow", ()=>AddressPreviewRow);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRedux = require("react-redux");
var _box = require("grommet/es6/components/Box");
var _text = require("grommet/es6/components/Text");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _selectors = require("app/state/contacts/selectors");
var _prettyAddress = require("../PrettyAddress");
const ResponsiveGridRow = /*#__PURE__*/ (0, _react.memo)(({ label, value })=>{
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                    weight: "bold",
                    size: isMobile ? 'small' : 'medium',
                    children: label
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                margin: {
                    bottom: 'small'
                },
                direction: "row",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                    size: isMobile ? 'small' : 'medium',
                    children: value
                })
            })
        ]
    });
});
const PreviewRow = ({ label, value })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                weight: "bold",
                size: "small",
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                color: "grayMedium",
                size: "small",
                children: value
            })
        ]
    });
const AddressPreviewRow = ({ label, value })=>{
    const contactAddress = (0, _reactRedux.useSelector)((0, _selectors.selectContact)(value));
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(PreviewRow, {
        label: label,
        value: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            direction: isMobile ? 'column' : 'row',
            gap: isMobile ? 'none' : 'small',
            children: [
                contactAddress && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                    color: "text",
                    size: "small",
                    weight: "bold",
                    children: contactAddress.name
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _prettyAddress.PrettyAddress), {
                    address: value
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react-redux":"azV3Y","grommet/es6/components/Box":"4o01A","grommet/es6/components/Text":"kz1Ni","grommet/es6/contexts/ResponsiveContext":"7EsNN","react":"8CCva","app/state/contacts/selectors":"iLmat","../PrettyAddress":"eOPA7","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3X2aq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionTypeFormatter", ()=>TransactionTypeFormatter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _text = require("grommet/es6/components/Text");
const TransactionTypeFormatter = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const type = props.type;
    const typeMap = {
        addEscrow: t('transaction.types.addEscrow', 'delegating your tokens to a validator and generate rewards'),
        reclaimEscrow: t('transaction.types.reclaimEscrow', 'reclaiming your tokens delegated to a validator'),
        transfer: t('transaction.types.transfer', 'sending tokens from your account to another')
    };
    const typeMessage = typeMap[type];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                color: "grayMedium",
                size: "small",
                style: {
                    textTransform: 'capitalize',
                    fontWeight: 600
                },
                children: type
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _text.Text), {
                color: "grayMedium",
                size: "xsmall",
                style: {
                    letterSpacing: 0
                },
                children: [
                    "\xa0(",
                    typeMessage,
                    ")"
                ]
            })
        ]
    });
});

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-i18next":"7GUHL","grommet/es6/components/Text":"kz1Ni","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"c8Fjt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountSummary", ()=>AccountSummary);
var _jsxRuntime = require("react/jsx-runtime");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _addressBox = require("app/components/AddressBox");
var _alertBox = require("app/components/AlertBox");
var _amountFormatter = require("app/components/AmountFormatter");
var _anchorLink = require("app/components/AnchorLink");
var _box = require("grommet/es6/components/Box");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _qrcodeReact = require("qrcode.react");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _wallet = require("app/state/wallet");
var _selectors = require("app/state/network/selectors");
var _manageableAccountDetails = require("app/components/Toolbar/Features/Account/ManageableAccountDetails");
var _selectUnlockedStatus = require("app/state/selectUnlockedStatus");
const StyledDescriptionList = (0, _styledComponentsDefault.default).dl`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: ${({ theme })=>theme.global?.edgeSize?.xsmall} 0 0;
  padding: ${({ theme })=>`${theme.global?.edgeSize?.small} ${theme.global?.edgeSize?.small} ${theme.global?.edgeSize?.xsmall}`};

  dt,
  dd {
    margin: 0;

    :first-of-type {
      font-weight: bold;
    }
  }

  @media only screen and (min-width: ${({ theme })=>`${theme.global?.breakpoints?.small?.value}px`}) {
    dt {
      width: 40%;
    }

    dd {
      width: 60%;
    }

    dt,
    dd {
      :not(:last-of-type) {
        margin-bottom: ${({ theme })=>theme.global?.edgeSize?.xsmall};
      }
    }
  }

  @media only screen and (max-width: ${({ theme })=>`${theme.global?.breakpoints?.small?.value}px`}) {
    dt {
      width: 30%;
    }

    dd {
      width: 70%;
      text-align: right;
    }

    dt,
    dd {
      font-size: 16px;

      :not(:last-of-type) {
        margin-bottom: ${({ theme })=>theme.global?.edgeSize?.xxsmall};
      }
    }
  }
`;
function AccountSummary({ address, balance, deleteWallet, wallet, walletHasAccounts }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const [layerVisibility, setLayerVisibility] = (0, _react.useState)(false);
    const { dark } = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    const ticker = (0, _reactRedux.useSelector)((0, _selectors.selectTicker));
    const unlockedStatus = (0, _reactRedux.useSelector)((0, _selectUnlockedStatus.selectUnlockedStatus));
    const canEditName = unlockedStatus === 'unlockedProfile' && address === wallet?.address;
    const editAccount = (name)=>{
        if (!wallet) throw new Error('Wallet not provided');
        dispatch((0, _wallet.walletActions).setWalletName({
            address: wallet.address,
            name
        }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                margin: {
                    bottom: 'small'
                },
                children: [
                    (!walletHasAccounts || wallet?.address !== address) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBox.AlertBox), {
                        status: "error",
                        children: t('account.summary.notYourAccount', 'This is not your account.')
                    }),
                    !walletHasAccounts && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBox.AlertBox), {
                        status: "error",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                            i18nKey: "account.summary.noWalletIsOpen",
                            t: t,
                            components: {
                                HomeLink: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _anchorLink.AnchorLink), {
                                    to: "/"
                                })
                            },
                            values: {
                                ticker
                            },
                            defaults: "To send, receive, stake and swap {{ticker}} tokens, <HomeLink>open your wallet</HomeLink>."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                round: "5px",
                border: {
                    color: 'background-front-border',
                    size: '1px'
                },
                background: "background-front",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    pad: "small",
                    direction: "row-responsive",
                    flex: true,
                    justify: "between",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                            width: {
                                max: isMobile ? '100%' : '75%'
                            },
                            children: [
                                !canEditName && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressBox.AddressBox), {
                                    address: address,
                                    separator: true,
                                    trimMobile: true
                                }),
                                canEditName && !wallet?.name && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressBox.EditableAddressBox), {
                                    address: address,
                                    openEditModal: ()=>setLayerVisibility(true)
                                }),
                                canEditName && wallet?.name && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressBox.EditableNameBox), {
                                    address: address,
                                    openEditModal: ()=>setLayerVisibility(true),
                                    name: wallet.name
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledDescriptionList, {
                                    "data-testid": "account-balance-summary",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                            children: t('account.summary.balance.total', 'Total')
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                            "data-testid": "account-balance-total",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                                                amount: balance.total,
                                                smallTicker: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                            children: t('account.summary.balance.available', 'Available')
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                                                amount: balance.available,
                                                smallTicker: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("dt", {
                                            children: [
                                                " ",
                                                t('account.summary.balance.delegations', 'Staked')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                                                amount: balance.delegations,
                                                smallTicker: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dt", {
                                            children: t('account.summary.balance.debonding', 'Debonding')
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("dd", {
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                                                amount: balance.debonding,
                                                smallTicker: true
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                            align: "end",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _qrcodeReact.QRCodeCanvas), {
                                value: address,
                                fgColor: dark ? '#e8e8e8' : '#333333',
                                bgColor: "#00000000"
                            })
                        })
                    ]
                })
            }),
            layerVisibility && wallet && canEditName && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _manageableAccountDetails.ManageableAccountDetails), {
                animation: true,
                closeHandler: ()=>setLayerVisibility(false),
                deleteAccount: deleteWallet ? (address)=>{
                    deleteWallet(address);
                    setLayerVisibility(false);
                } : undefined,
                editAccount: editAccount,
                wallet: wallet
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","styled-components":"6bGrk","app/components/AddressBox":"70dJ2","app/components/AlertBox":"ivux6","app/components/AmountFormatter":"dRP3j","app/components/AnchorLink":"6fYA9","grommet/es6/components/Box":"4o01A","grommet/es6/contexts/ResponsiveContext":"7EsNN","qrcode.react":"hUeD2","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","app/state/wallet":"iYAaC","app/state/network/selectors":"2zit7","app/components/Toolbar/Features/Account/ManageableAccountDetails":"6LK8d","app/state/selectUnlockedStatus":"aRpzm","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6fYA9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnchorLink", ()=>AnchorLink);
var _jsxRuntime = require("react/jsx-runtime");
var _anchor = require("grommet/es6/components/Anchor");
var _reactRouterDom = require("react-router-dom");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const AnchorLink = (props)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _anchor.Anchor), {
        as: (0, _reactRouterDom.Link),
        ...props
    });
};

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Anchor":"arBWH","react-router-dom":"9pTjq","react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hUeD2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QRCodeCanvas", ()=>QRCodeCanvas);
parcelHelpers.export(exports, "QRCodeSVG", ()=>QRCodeSVG);
parcelHelpers.export(exports, "default", ()=>QRCode);
// src/index.tsx
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/third-party/qrcodegen/index.ts
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */ var qrcodegen;
((qrcodegen2)=>{
    const _QrCode = class {
        constructor(version, errorCorrectionLevel, dataCodewords, msk){
            this.version = version;
            this.errorCorrectionLevel = errorCorrectionLevel;
            this.modules = [];
            this.isFunction = [];
            if (version < _QrCode.MIN_VERSION || version > _QrCode.MAX_VERSION) throw new RangeError("Version value out of range");
            if (msk < -1 || msk > 7) throw new RangeError("Mask value out of range");
            this.size = version * 4 + 17;
            let row = [];
            for(let i = 0; i < this.size; i++)row.push(false);
            for(let i = 0; i < this.size; i++){
                this.modules.push(row.slice());
                this.isFunction.push(row.slice());
            }
            this.drawFunctionPatterns();
            const allCodewords = this.addEccAndInterleave(dataCodewords);
            this.drawCodewords(allCodewords);
            if (msk == -1) {
                let minPenalty = 1e9;
                for(let i = 0; i < 8; i++){
                    this.applyMask(i);
                    this.drawFormatBits(i);
                    const penalty = this.getPenaltyScore();
                    if (penalty < minPenalty) {
                        msk = i;
                        minPenalty = penalty;
                    }
                    this.applyMask(i);
                }
            }
            assert(0 <= msk && msk <= 7);
            this.mask = msk;
            this.applyMask(msk);
            this.drawFormatBits(msk);
            this.isFunction = [];
        }
        static encodeText(text, ecl) {
            const segs = qrcodegen2.QrSegment.makeSegments(text);
            return _QrCode.encodeSegments(segs, ecl);
        }
        static encodeBinary(data, ecl) {
            const seg = qrcodegen2.QrSegment.makeBytes(data);
            return _QrCode.encodeSegments([
                seg
            ], ecl);
        }
        static encodeSegments(segs, ecl, minVersion = 1, maxVersion = 40, mask = -1, boostEcl = true) {
            if (!(_QrCode.MIN_VERSION <= minVersion && minVersion <= maxVersion && maxVersion <= _QrCode.MAX_VERSION) || mask < -1 || mask > 7) throw new RangeError("Invalid value");
            let version;
            let dataUsedBits;
            for(version = minVersion;; version++){
                const dataCapacityBits2 = _QrCode.getNumDataCodewords(version, ecl) * 8;
                const usedBits = QrSegment.getTotalBits(segs, version);
                if (usedBits <= dataCapacityBits2) {
                    dataUsedBits = usedBits;
                    break;
                }
                if (version >= maxVersion) throw new RangeError("Data too long");
            }
            for (const newEcl of [
                _QrCode.Ecc.MEDIUM,
                _QrCode.Ecc.QUARTILE,
                _QrCode.Ecc.HIGH
            ])if (boostEcl && dataUsedBits <= _QrCode.getNumDataCodewords(version, newEcl) * 8) ecl = newEcl;
            let bb = [];
            for (const seg of segs){
                appendBits(seg.mode.modeBits, 4, bb);
                appendBits(seg.numChars, seg.mode.numCharCountBits(version), bb);
                for (const b of seg.getData())bb.push(b);
            }
            assert(bb.length == dataUsedBits);
            const dataCapacityBits = _QrCode.getNumDataCodewords(version, ecl) * 8;
            assert(bb.length <= dataCapacityBits);
            appendBits(0, Math.min(4, dataCapacityBits - bb.length), bb);
            appendBits(0, (8 - bb.length % 8) % 8, bb);
            assert(bb.length % 8 == 0);
            for(let padByte = 236; bb.length < dataCapacityBits; padByte ^= 253)appendBits(padByte, 8, bb);
            let dataCodewords = [];
            while(dataCodewords.length * 8 < bb.length)dataCodewords.push(0);
            bb.forEach((b, i)=>dataCodewords[i >>> 3] |= b << 7 - (i & 7));
            return new _QrCode(version, ecl, dataCodewords, mask);
        }
        getModule(x, y) {
            return 0 <= x && x < this.size && 0 <= y && y < this.size && this.modules[y][x];
        }
        getModules() {
            return this.modules;
        }
        drawFunctionPatterns() {
            for(let i = 0; i < this.size; i++){
                this.setFunctionModule(6, i, i % 2 == 0);
                this.setFunctionModule(i, 6, i % 2 == 0);
            }
            this.drawFinderPattern(3, 3);
            this.drawFinderPattern(this.size - 4, 3);
            this.drawFinderPattern(3, this.size - 4);
            const alignPatPos = this.getAlignmentPatternPositions();
            const numAlign = alignPatPos.length;
            for(let i = 0; i < numAlign; i++){
                for(let j = 0; j < numAlign; j++)if (!(i == 0 && j == 0 || i == 0 && j == numAlign - 1 || i == numAlign - 1 && j == 0)) this.drawAlignmentPattern(alignPatPos[i], alignPatPos[j]);
            }
            this.drawFormatBits(0);
            this.drawVersion();
        }
        drawFormatBits(mask) {
            const data = this.errorCorrectionLevel.formatBits << 3 | mask;
            let rem = data;
            for(let i = 0; i < 10; i++)rem = rem << 1 ^ (rem >>> 9) * 1335;
            const bits = (data << 10 | rem) ^ 21522;
            assert(bits >>> 15 == 0);
            for(let i = 0; i <= 5; i++)this.setFunctionModule(8, i, getBit(bits, i));
            this.setFunctionModule(8, 7, getBit(bits, 6));
            this.setFunctionModule(8, 8, getBit(bits, 7));
            this.setFunctionModule(7, 8, getBit(bits, 8));
            for(let i = 9; i < 15; i++)this.setFunctionModule(14 - i, 8, getBit(bits, i));
            for(let i = 0; i < 8; i++)this.setFunctionModule(this.size - 1 - i, 8, getBit(bits, i));
            for(let i = 8; i < 15; i++)this.setFunctionModule(8, this.size - 15 + i, getBit(bits, i));
            this.setFunctionModule(8, this.size - 8, true);
        }
        drawVersion() {
            if (this.version < 7) return;
            let rem = this.version;
            for(let i = 0; i < 12; i++)rem = rem << 1 ^ (rem >>> 11) * 7973;
            const bits = this.version << 12 | rem;
            assert(bits >>> 18 == 0);
            for(let i = 0; i < 18; i++){
                const color = getBit(bits, i);
                const a = this.size - 11 + i % 3;
                const b = Math.floor(i / 3);
                this.setFunctionModule(a, b, color);
                this.setFunctionModule(b, a, color);
            }
        }
        drawFinderPattern(x, y) {
            for(let dy = -4; dy <= 4; dy++)for(let dx = -4; dx <= 4; dx++){
                const dist = Math.max(Math.abs(dx), Math.abs(dy));
                const xx = x + dx;
                const yy = y + dy;
                if (0 <= xx && xx < this.size && 0 <= yy && yy < this.size) this.setFunctionModule(xx, yy, dist != 2 && dist != 4);
            }
        }
        drawAlignmentPattern(x, y) {
            for(let dy = -2; dy <= 2; dy++)for(let dx = -2; dx <= 2; dx++)this.setFunctionModule(x + dx, y + dy, Math.max(Math.abs(dx), Math.abs(dy)) != 1);
        }
        setFunctionModule(x, y, isDark) {
            this.modules[y][x] = isDark;
            this.isFunction[y][x] = true;
        }
        addEccAndInterleave(data) {
            const ver = this.version;
            const ecl = this.errorCorrectionLevel;
            if (data.length != _QrCode.getNumDataCodewords(ver, ecl)) throw new RangeError("Invalid argument");
            const numBlocks = _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
            const blockEccLen = _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver];
            const rawCodewords = Math.floor(_QrCode.getNumRawDataModules(ver) / 8);
            const numShortBlocks = numBlocks - rawCodewords % numBlocks;
            const shortBlockLen = Math.floor(rawCodewords / numBlocks);
            let blocks = [];
            const rsDiv = _QrCode.reedSolomonComputeDivisor(blockEccLen);
            for(let i = 0, k = 0; i < numBlocks; i++){
                let dat = data.slice(k, k + shortBlockLen - blockEccLen + (i < numShortBlocks ? 0 : 1));
                k += dat.length;
                const ecc = _QrCode.reedSolomonComputeRemainder(dat, rsDiv);
                if (i < numShortBlocks) dat.push(0);
                blocks.push(dat.concat(ecc));
            }
            let result = [];
            for(let i = 0; i < blocks[0].length; i++)blocks.forEach((block, j)=>{
                if (i != shortBlockLen - blockEccLen || j >= numShortBlocks) result.push(block[i]);
            });
            assert(result.length == rawCodewords);
            return result;
        }
        drawCodewords(data) {
            if (data.length != Math.floor(_QrCode.getNumRawDataModules(this.version) / 8)) throw new RangeError("Invalid argument");
            let i = 0;
            for(let right = this.size - 1; right >= 1; right -= 2){
                if (right == 6) right = 5;
                for(let vert = 0; vert < this.size; vert++)for(let j = 0; j < 2; j++){
                    const x = right - j;
                    const upward = (right + 1 & 2) == 0;
                    const y = upward ? this.size - 1 - vert : vert;
                    if (!this.isFunction[y][x] && i < data.length * 8) {
                        this.modules[y][x] = getBit(data[i >>> 3], 7 - (i & 7));
                        i++;
                    }
                }
            }
            assert(i == data.length * 8);
        }
        applyMask(mask) {
            if (mask < 0 || mask > 7) throw new RangeError("Mask value out of range");
            for(let y = 0; y < this.size; y++)for(let x = 0; x < this.size; x++){
                let invert;
                switch(mask){
                    case 0:
                        invert = (x + y) % 2 == 0;
                        break;
                    case 1:
                        invert = y % 2 == 0;
                        break;
                    case 2:
                        invert = x % 3 == 0;
                        break;
                    case 3:
                        invert = (x + y) % 3 == 0;
                        break;
                    case 4:
                        invert = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 == 0;
                        break;
                    case 5:
                        invert = x * y % 2 + x * y % 3 == 0;
                        break;
                    case 6:
                        invert = (x * y % 2 + x * y % 3) % 2 == 0;
                        break;
                    case 7:
                        invert = ((x + y) % 2 + x * y % 3) % 2 == 0;
                        break;
                    default:
                        throw new Error("Unreachable");
                }
                if (!this.isFunction[y][x] && invert) this.modules[y][x] = !this.modules[y][x];
            }
        }
        getPenaltyScore() {
            let result = 0;
            for(let y = 0; y < this.size; y++){
                let runColor = false;
                let runX = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let x = 0; x < this.size; x++)if (this.modules[y][x] == runColor) {
                    runX++;
                    if (runX == 5) result += _QrCode.PENALTY_N1;
                    else if (runX > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runX, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runX = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runX, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let x = 0; x < this.size; x++){
                let runColor = false;
                let runY = 0;
                let runHistory = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let y = 0; y < this.size; y++)if (this.modules[y][x] == runColor) {
                    runY++;
                    if (runY == 5) result += _QrCode.PENALTY_N1;
                    else if (runY > 5) result++;
                } else {
                    this.finderPenaltyAddHistory(runY, runHistory);
                    if (!runColor) result += this.finderPenaltyCountPatterns(runHistory) * _QrCode.PENALTY_N3;
                    runColor = this.modules[y][x];
                    runY = 1;
                }
                result += this.finderPenaltyTerminateAndCount(runColor, runY, runHistory) * _QrCode.PENALTY_N3;
            }
            for(let y = 0; y < this.size - 1; y++)for(let x = 0; x < this.size - 1; x++){
                const color = this.modules[y][x];
                if (color == this.modules[y][x + 1] && color == this.modules[y + 1][x] && color == this.modules[y + 1][x + 1]) result += _QrCode.PENALTY_N2;
            }
            let dark = 0;
            for (const row of this.modules)dark = row.reduce((sum, color)=>sum + (color ? 1 : 0), dark);
            const total = this.size * this.size;
            const k = Math.ceil(Math.abs(dark * 20 - total * 10) / total) - 1;
            assert(0 <= k && k <= 9);
            result += k * _QrCode.PENALTY_N4;
            assert(0 <= result && result <= 2568888);
            return result;
        }
        getAlignmentPatternPositions() {
            if (this.version == 1) return [];
            else {
                const numAlign = Math.floor(this.version / 7) + 2;
                const step = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (numAlign * 2 - 2)) * 2;
                let result = [
                    6
                ];
                for(let pos = this.size - 7; result.length < numAlign; pos -= step)result.splice(1, 0, pos);
                return result;
            }
        }
        static getNumRawDataModules(ver) {
            if (ver < _QrCode.MIN_VERSION || ver > _QrCode.MAX_VERSION) throw new RangeError("Version number out of range");
            let result = (16 * ver + 128) * ver + 64;
            if (ver >= 2) {
                const numAlign = Math.floor(ver / 7) + 2;
                result -= (25 * numAlign - 10) * numAlign - 55;
                if (ver >= 7) result -= 36;
            }
            assert(208 <= result && result <= 29648);
            return result;
        }
        static getNumDataCodewords(ver, ecl) {
            return Math.floor(_QrCode.getNumRawDataModules(ver) / 8) - _QrCode.ECC_CODEWORDS_PER_BLOCK[ecl.ordinal][ver] * _QrCode.NUM_ERROR_CORRECTION_BLOCKS[ecl.ordinal][ver];
        }
        static reedSolomonComputeDivisor(degree) {
            if (degree < 1 || degree > 255) throw new RangeError("Degree out of range");
            let result = [];
            for(let i = 0; i < degree - 1; i++)result.push(0);
            result.push(1);
            let root = 1;
            for(let i = 0; i < degree; i++){
                for(let j = 0; j < result.length; j++){
                    result[j] = _QrCode.reedSolomonMultiply(result[j], root);
                    if (j + 1 < result.length) result[j] ^= result[j + 1];
                }
                root = _QrCode.reedSolomonMultiply(root, 2);
            }
            return result;
        }
        static reedSolomonComputeRemainder(data, divisor) {
            let result = divisor.map((_)=>0);
            for (const b of data){
                const factor = b ^ result.shift();
                result.push(0);
                divisor.forEach((coef, i)=>result[i] ^= _QrCode.reedSolomonMultiply(coef, factor));
            }
            return result;
        }
        static reedSolomonMultiply(x, y) {
            if (x >>> 8 != 0 || y >>> 8 != 0) throw new RangeError("Byte out of range");
            let z = 0;
            for(let i = 7; i >= 0; i--){
                z = z << 1 ^ (z >>> 7) * 285;
                z ^= (y >>> i & 1) * x;
            }
            assert(z >>> 8 == 0);
            return z;
        }
        finderPenaltyCountPatterns(runHistory) {
            const n = runHistory[1];
            assert(n <= this.size * 3);
            const core = n > 0 && runHistory[2] == n && runHistory[3] == n * 3 && runHistory[4] == n && runHistory[5] == n;
            return (core && runHistory[0] >= n * 4 && runHistory[6] >= n ? 1 : 0) + (core && runHistory[6] >= n * 4 && runHistory[0] >= n ? 1 : 0);
        }
        finderPenaltyTerminateAndCount(currentRunColor, currentRunLength, runHistory) {
            if (currentRunColor) {
                this.finderPenaltyAddHistory(currentRunLength, runHistory);
                currentRunLength = 0;
            }
            currentRunLength += this.size;
            this.finderPenaltyAddHistory(currentRunLength, runHistory);
            return this.finderPenaltyCountPatterns(runHistory);
        }
        finderPenaltyAddHistory(currentRunLength, runHistory) {
            if (runHistory[0] == 0) currentRunLength += this.size;
            runHistory.pop();
            runHistory.unshift(currentRunLength);
        }
    };
    let QrCode = _QrCode;
    QrCode.MIN_VERSION = 1;
    QrCode.MAX_VERSION = 40;
    QrCode.PENALTY_N1 = 3;
    QrCode.PENALTY_N2 = 3;
    QrCode.PENALTY_N3 = 40;
    QrCode.PENALTY_N4 = 10;
    QrCode.ECC_CODEWORDS_PER_BLOCK = [
        [
            -1,
            7,
            10,
            15,
            20,
            26,
            18,
            20,
            24,
            30,
            18,
            20,
            24,
            26,
            30,
            22,
            24,
            28,
            30,
            28,
            28,
            28,
            28,
            30,
            30,
            26,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        [
            -1,
            10,
            16,
            26,
            18,
            24,
            16,
            18,
            22,
            22,
            26,
            30,
            22,
            22,
            24,
            24,
            28,
            28,
            26,
            26,
            26,
            26,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28,
            28
        ],
        [
            -1,
            13,
            22,
            18,
            26,
            18,
            24,
            18,
            22,
            20,
            24,
            28,
            26,
            24,
            20,
            30,
            24,
            28,
            28,
            26,
            30,
            28,
            30,
            30,
            30,
            30,
            28,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ],
        [
            -1,
            17,
            28,
            22,
            16,
            22,
            28,
            26,
            26,
            24,
            28,
            24,
            28,
            22,
            24,
            24,
            30,
            28,
            28,
            26,
            28,
            30,
            24,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30,
            30
        ]
    ];
    QrCode.NUM_ERROR_CORRECTION_BLOCKS = [
        [
            -1,
            1,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            4,
            4,
            4,
            4,
            4,
            6,
            6,
            6,
            6,
            7,
            8,
            8,
            9,
            9,
            10,
            12,
            12,
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19,
            19,
            20,
            21,
            22,
            24,
            25
        ],
        [
            -1,
            1,
            1,
            1,
            2,
            2,
            4,
            4,
            4,
            5,
            5,
            5,
            8,
            9,
            9,
            10,
            10,
            11,
            13,
            14,
            16,
            17,
            17,
            18,
            20,
            21,
            23,
            25,
            26,
            28,
            29,
            31,
            33,
            35,
            37,
            38,
            40,
            43,
            45,
            47,
            49
        ],
        [
            -1,
            1,
            1,
            2,
            2,
            4,
            4,
            6,
            6,
            8,
            8,
            8,
            10,
            12,
            16,
            12,
            17,
            16,
            18,
            21,
            20,
            23,
            23,
            25,
            27,
            29,
            34,
            34,
            35,
            38,
            40,
            43,
            45,
            48,
            51,
            53,
            56,
            59,
            62,
            65,
            68
        ],
        [
            -1,
            1,
            1,
            2,
            4,
            4,
            4,
            5,
            6,
            8,
            8,
            11,
            11,
            16,
            16,
            18,
            16,
            19,
            21,
            25,
            25,
            25,
            34,
            30,
            32,
            35,
            37,
            40,
            42,
            45,
            48,
            51,
            54,
            57,
            60,
            63,
            66,
            70,
            74,
            77,
            81
        ]
    ];
    qrcodegen2.QrCode = QrCode;
    function appendBits(val, len, bb) {
        if (len < 0 || len > 31 || val >>> len != 0) throw new RangeError("Value out of range");
        for(let i = len - 1; i >= 0; i--)bb.push(val >>> i & 1);
    }
    function getBit(x, i) {
        return (x >>> i & 1) != 0;
    }
    function assert(cond) {
        if (!cond) throw new Error("Assertion error");
    }
    const _QrSegment = class {
        constructor(mode, numChars, bitData){
            this.mode = mode;
            this.numChars = numChars;
            this.bitData = bitData;
            if (numChars < 0) throw new RangeError("Invalid argument");
            this.bitData = bitData.slice();
        }
        static makeBytes(data) {
            let bb = [];
            for (const b of data)appendBits(b, 8, bb);
            return new _QrSegment(_QrSegment.Mode.BYTE, data.length, bb);
        }
        static makeNumeric(digits) {
            if (!_QrSegment.isNumeric(digits)) throw new RangeError("String contains non-numeric characters");
            let bb = [];
            for(let i = 0; i < digits.length;){
                const n = Math.min(digits.length - i, 3);
                appendBits(parseInt(digits.substr(i, n), 10), n * 3 + 1, bb);
                i += n;
            }
            return new _QrSegment(_QrSegment.Mode.NUMERIC, digits.length, bb);
        }
        static makeAlphanumeric(text) {
            if (!_QrSegment.isAlphanumeric(text)) throw new RangeError("String contains unencodable characters in alphanumeric mode");
            let bb = [];
            let i;
            for(i = 0; i + 2 <= text.length; i += 2){
                let temp = _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)) * 45;
                temp += _QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i + 1));
                appendBits(temp, 11, bb);
            }
            if (i < text.length) appendBits(_QrSegment.ALPHANUMERIC_CHARSET.indexOf(text.charAt(i)), 6, bb);
            return new _QrSegment(_QrSegment.Mode.ALPHANUMERIC, text.length, bb);
        }
        static makeSegments(text) {
            if (text == "") return [];
            else if (_QrSegment.isNumeric(text)) return [
                _QrSegment.makeNumeric(text)
            ];
            else if (_QrSegment.isAlphanumeric(text)) return [
                _QrSegment.makeAlphanumeric(text)
            ];
            else return [
                _QrSegment.makeBytes(_QrSegment.toUtf8ByteArray(text))
            ];
        }
        static makeEci(assignVal) {
            let bb = [];
            if (assignVal < 0) throw new RangeError("ECI assignment value out of range");
            else if (assignVal < 128) appendBits(assignVal, 8, bb);
            else if (assignVal < 16384) {
                appendBits(2, 2, bb);
                appendBits(assignVal, 14, bb);
            } else if (assignVal < 1e6) {
                appendBits(6, 3, bb);
                appendBits(assignVal, 21, bb);
            } else throw new RangeError("ECI assignment value out of range");
            return new _QrSegment(_QrSegment.Mode.ECI, 0, bb);
        }
        static isNumeric(text) {
            return _QrSegment.NUMERIC_REGEX.test(text);
        }
        static isAlphanumeric(text) {
            return _QrSegment.ALPHANUMERIC_REGEX.test(text);
        }
        getData() {
            return this.bitData.slice();
        }
        static getTotalBits(segs, version) {
            let result = 0;
            for (const seg of segs){
                const ccbits = seg.mode.numCharCountBits(version);
                if (seg.numChars >= 1 << ccbits) return Infinity;
                result += 4 + ccbits + seg.bitData.length;
            }
            return result;
        }
        static toUtf8ByteArray(str) {
            str = encodeURI(str);
            let result = [];
            for(let i = 0; i < str.length; i++)if (str.charAt(i) != "%") result.push(str.charCodeAt(i));
            else {
                result.push(parseInt(str.substr(i + 1, 2), 16));
                i += 2;
            }
            return result;
        }
    };
    let QrSegment = _QrSegment;
    QrSegment.NUMERIC_REGEX = /^[0-9]*$/;
    QrSegment.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/;
    QrSegment.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
    qrcodegen2.QrSegment = QrSegment;
})(qrcodegen || (qrcodegen = {}));
((qrcodegen2)=>{
    let QrCode;
    ((QrCode2)=>{
        const _Ecc = class {
            constructor(ordinal, formatBits){
                this.ordinal = ordinal;
                this.formatBits = formatBits;
            }
        };
        let Ecc = _Ecc;
        Ecc.LOW = new _Ecc(0, 1);
        Ecc.MEDIUM = new _Ecc(1, 0);
        Ecc.QUARTILE = new _Ecc(2, 3);
        Ecc.HIGH = new _Ecc(3, 2);
        QrCode2.Ecc = Ecc;
    })(QrCode = qrcodegen2.QrCode || (qrcodegen2.QrCode = {}));
})(qrcodegen || (qrcodegen = {}));
((qrcodegen2)=>{
    let QrSegment;
    ((QrSegment2)=>{
        const _Mode = class {
            constructor(modeBits, numBitsCharCount){
                this.modeBits = modeBits;
                this.numBitsCharCount = numBitsCharCount;
            }
            numCharCountBits(ver) {
                return this.numBitsCharCount[Math.floor((ver + 7) / 17)];
            }
        };
        let Mode = _Mode;
        Mode.NUMERIC = new _Mode(1, [
            10,
            12,
            14
        ]);
        Mode.ALPHANUMERIC = new _Mode(2, [
            9,
            11,
            13
        ]);
        Mode.BYTE = new _Mode(4, [
            8,
            16,
            16
        ]);
        Mode.KANJI = new _Mode(8, [
            8,
            10,
            12
        ]);
        Mode.ECI = new _Mode(7, [
            0,
            0,
            0
        ]);
        QrSegment2.Mode = Mode;
    })(QrSegment = qrcodegen2.QrSegment || (qrcodegen2.QrSegment = {}));
})(qrcodegen || (qrcodegen = {}));
var qrcodegen_default = qrcodegen;
// src/index.tsx
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */ var ERROR_LEVEL_MAP = {
    L: qrcodegen_default.QrCode.Ecc.LOW,
    M: qrcodegen_default.QrCode.Ecc.MEDIUM,
    Q: qrcodegen_default.QrCode.Ecc.QUARTILE,
    H: qrcodegen_default.QrCode.Ecc.HIGH
};
var DEFAULT_SIZE = 128;
var DEFAULT_LEVEL = "L";
var DEFAULT_BGCOLOR = "#FFFFFF";
var DEFAULT_FGCOLOR = "#000000";
var DEFAULT_INCLUDEMARGIN = false;
var MARGIN_SIZE = 4;
var DEFAULT_IMG_SCALE = 0.1;
function generatePath(modules, margin = 0) {
    const ops = [];
    modules.forEach(function(row, y) {
        let start = null;
        row.forEach(function(cell, x) {
            if (!cell && start !== null) {
                ops.push(`M${start + margin} ${y + margin}h${x - start}v1H${start + margin}z`);
                start = null;
                return;
            }
            if (x === row.length - 1) {
                if (!cell) return;
                if (start === null) ops.push(`M${x + margin},${y + margin} h1v1H${x + margin}z`);
                else ops.push(`M${start + margin},${y + margin} h${x + 1 - start}v1H${start + margin}z`);
                return;
            }
            if (cell && start === null) start = x;
        });
    });
    return ops.join("");
}
function excavateModules(modules, excavation) {
    return modules.slice().map((row, y)=>{
        if (y < excavation.y || y >= excavation.y + excavation.h) return row;
        return row.map((cell, x)=>{
            if (x < excavation.x || x >= excavation.x + excavation.w) return cell;
            return false;
        });
    });
}
function getImageSettings(cells, size, includeMargin, imageSettings) {
    if (imageSettings == null) return null;
    const margin = includeMargin ? MARGIN_SIZE : 0;
    const numCells = cells.length + margin * 2;
    const defaultSize = Math.floor(size * DEFAULT_IMG_SCALE);
    const scale = numCells / size;
    const w = (imageSettings.width || defaultSize) * scale;
    const h = (imageSettings.height || defaultSize) * scale;
    const x = imageSettings.x == null ? cells.length / 2 - w / 2 : imageSettings.x * scale;
    const y = imageSettings.y == null ? cells.length / 2 - h / 2 : imageSettings.y * scale;
    let excavation = null;
    if (imageSettings.excavate) {
        let floorX = Math.floor(x);
        let floorY = Math.floor(y);
        let ceilW = Math.ceil(w + x - floorX);
        let ceilH = Math.ceil(h + y - floorY);
        excavation = {
            x: floorX,
            y: floorY,
            w: ceilW,
            h: ceilH
        };
    }
    return {
        x,
        y,
        h,
        w,
        excavation
    };
}
var SUPPORTS_PATH2D = function() {
    try {
        new Path2D().addPath(new Path2D());
    } catch (e) {
        return false;
    }
    return true;
}();
function QRCodeCanvas(props) {
    const _a = props, { value, size = DEFAULT_SIZE, level = DEFAULT_LEVEL, bgColor = DEFAULT_BGCOLOR, fgColor = DEFAULT_FGCOLOR, includeMargin = DEFAULT_INCLUDEMARGIN, style, imageSettings } = _a, otherProps = __objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "style",
        "imageSettings"
    ]);
    const imgSrc = imageSettings == null ? void 0 : imageSettings.src;
    const _canvas = (0, _reactDefault.default).useRef(null);
    const _image = (0, _reactDefault.default).useRef(null);
    const [isImgLoaded, setIsImageLoaded] = (0, _reactDefault.default).useState(false);
    (0, _reactDefault.default).useEffect(()=>{
        if (_canvas.current != null) {
            const canvas = _canvas.current;
            const ctx = canvas.getContext("2d");
            if (!ctx) return;
            let cells = qrcodegen_default.QrCode.encodeText(value, ERROR_LEVEL_MAP[level]).getModules();
            const margin = includeMargin ? MARGIN_SIZE : 0;
            const numCells = cells.length + margin * 2;
            const calculatedImageSettings = getImageSettings(cells, size, includeMargin, imageSettings);
            const image = _image.current;
            const haveImageToRender = calculatedImageSettings != null && image !== null && image.complete && image.naturalHeight !== 0 && image.naturalWidth !== 0;
            if (haveImageToRender) {
                if (calculatedImageSettings.excavation != null) cells = excavateModules(cells, calculatedImageSettings.excavation);
            }
            const pixelRatio = window.devicePixelRatio || 1;
            canvas.height = canvas.width = size * pixelRatio;
            const scale = size / numCells * pixelRatio;
            ctx.scale(scale, scale);
            ctx.fillStyle = bgColor;
            ctx.fillRect(0, 0, numCells, numCells);
            ctx.fillStyle = fgColor;
            if (SUPPORTS_PATH2D) ctx.fill(new Path2D(generatePath(cells, margin)));
            else cells.forEach(function(row, rdx) {
                row.forEach(function(cell, cdx) {
                    if (cell) ctx.fillRect(cdx + margin, rdx + margin, 1, 1);
                });
            });
            if (haveImageToRender) ctx.drawImage(image, calculatedImageSettings.x + margin, calculatedImageSettings.y + margin, calculatedImageSettings.w, calculatedImageSettings.h);
        }
    });
    (0, _reactDefault.default).useEffect(()=>{
        setIsImageLoaded(false);
    }, [
        imgSrc
    ]);
    const canvasStyle = __spreadValues({
        height: size,
        width: size
    }, style);
    let img = null;
    if (imgSrc != null) img = /* @__PURE__ */ (0, _reactDefault.default).createElement("img", {
        src: imgSrc,
        key: imgSrc,
        style: {
            display: "none"
        },
        onLoad: ()=>{
            setIsImageLoaded(true);
        },
        ref: _image
    });
    return /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /* @__PURE__ */ (0, _reactDefault.default).createElement("canvas", __spreadValues({
        style: canvasStyle,
        height: size,
        width: size,
        ref: _canvas
    }, otherProps)), img);
}
function QRCodeSVG(props) {
    const _a = props, { value, size = DEFAULT_SIZE, level = DEFAULT_LEVEL, bgColor = DEFAULT_BGCOLOR, fgColor = DEFAULT_FGCOLOR, includeMargin = DEFAULT_INCLUDEMARGIN, imageSettings } = _a, otherProps = __objRest(_a, [
        "value",
        "size",
        "level",
        "bgColor",
        "fgColor",
        "includeMargin",
        "imageSettings"
    ]);
    let cells = qrcodegen_default.QrCode.encodeText(value, ERROR_LEVEL_MAP[level]).getModules();
    const margin = includeMargin ? MARGIN_SIZE : 0;
    const numCells = cells.length + margin * 2;
    const calculatedImageSettings = getImageSettings(cells, size, includeMargin, imageSettings);
    let image = null;
    if (imageSettings != null && calculatedImageSettings != null) {
        if (calculatedImageSettings.excavation != null) cells = excavateModules(cells, calculatedImageSettings.excavation);
        image = /* @__PURE__ */ (0, _reactDefault.default).createElement("image", {
            xlinkHref: imageSettings.src,
            height: calculatedImageSettings.h,
            width: calculatedImageSettings.w,
            x: calculatedImageSettings.x + margin,
            y: calculatedImageSettings.y + margin,
            preserveAspectRatio: "none"
        });
    }
    const fgPath = generatePath(cells, margin);
    return /* @__PURE__ */ (0, _reactDefault.default).createElement("svg", __spreadValues({
        height: size,
        width: size,
        viewBox: `0 0 ${numCells} ${numCells}`
    }, otherProps), /* @__PURE__ */ (0, _reactDefault.default).createElement("path", {
        fill: bgColor,
        d: `M0,0 h${numCells}v${numCells}H0z`,
        shapeRendering: "crispEdges"
    }), /* @__PURE__ */ (0, _reactDefault.default).createElement("path", {
        fill: fgColor,
        d: fgPath,
        shapeRendering: "crispEdges"
    }), image);
}
var QRCode = (props)=>{
    const _a = props, { renderAs } = _a, otherProps = __objRest(_a, [
        "renderAs"
    ]);
    if (renderAs === "svg") return /* @__PURE__ */ (0, _reactDefault.default).createElement(QRCodeSVG, __spreadValues({}, otherProps));
    return /* @__PURE__ */ (0, _reactDefault.default).createElement(QRCodeCanvas, __spreadValues({}, otherProps));
};

},{"react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"j7vza":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "validateAccountPageRoute", ()=>validateAccountPageRoute);
var _helpers = require("../../lib/helpers");
var _errors = require("types/errors");
function validateAccountPageRoute(params) {
    const isValid = (0, _helpers.isValidAddress)(params.address);
    if (!isValid) throw new (0, _errors.WalletError)((0, _errors.WalletErrors).InvalidAddress, 'Invalid address');
    return isValid;
}

},{"../../lib/helpers":"bUnFy","types/errors":"gbx4q","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"9tZlC":[function(require,module,exports,__globalThis) {
/**
 *
 * AccountDetails
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountDetails", ()=>AccountDetails);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("grommet/es6/components/Box");
var _react = require("react");
var _reactRedux = require("react-redux");
var _sendTransaction = require("../SendTransaction");
var _transactionHistory = require("../TransactionHistory");
var _selectIsAddressInWallet = require("app/state/selectIsAddressInWallet");
const AccountDetails = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const isAddressInWallet = (0, _reactRedux.useSelector)((0, _selectIsAddressInWallet.selectIsAddressInWallet));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            direction: "row",
            wrap: true,
            style: {
                gap: '24px'
            },
            children: [
                isAddressInWallet && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                    flex: {
                        grow: 1
                    },
                    basis: "32ex",
                    width: {
                        max: '100%'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sendTransaction.SendTransaction), {
                        isAddressInWallet: isAddressInWallet
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                    flex: {
                        grow: 3
                    },
                    basis: "80ex",
                    width: {
                        max: '100%'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionHistory.TransactionHistory), {})
                })
            ]
        })
    });
});

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Box":"4o01A","react":"8CCva","react-redux":"azV3Y","../SendTransaction":"c8X5h","../TransactionHistory":"968n9","app/state/selectIsAddressInWallet":"4FmWe","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"c8X5h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SendTransaction", ()=>SendTransaction);
var _jsxRuntime = require("react/jsx-runtime");
var _transactionStatus = require("app/components/TransactionStatus");
var _modal = require("app/components/Modal");
var _transaction = require("app/state/transaction");
var _selectors = require("app/state/transaction/selectors");
var _selectors1 = require("app/state/staking/selectors");
var _selectors2 = require("app/state/contacts/selectors");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _form = require("grommet/es6/components/Form");
var _formField = require("grommet/es6/components/FormField");
var _textInput = require("grommet/es6/components/TextInput");
var _text = require("grommet/es6/components/Text");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _helpers = require("app/lib/helpers");
var _selectors3 = require("app/state/network/selectors");
var _usePreventChangeOnNumberInputScroll = require("app/lib/usePreventChangeOnNumberInputScroll");
var _heading = require("grommet/es6/components/Heading");
function SendTransaction(props) {
    if (!props.isAddressInWallet) throw new Error('SendTransaction component should only appear on your accounts');
    const { t } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const { launchModal } = (0, _modal.useModal)();
    const { error, success } = (0, _reactRedux.useSelector)((0, _selectors.selectTransaction));
    const validators = (0, _reactRedux.useSelector)((0, _selectors1.selectValidators));
    const contacts = (0, _reactRedux.useSelector)((0, _selectors2.selectContactsList));
    const ticker = (0, _reactRedux.useSelector)((0, _selectors3.selectTicker));
    const [recipient, setRecipient] = (0, _react.useState)('');
    const [amount, setAmount] = (0, _react.useState)('');
    const sendTransaction = ()=>dispatch((0, _transaction.transactionActions).sendTransaction({
            type: 'transfer',
            amount: (0, _helpers.parseRoseStringToBaseUnitString)(amount),
            to: recipient.replaceAll(' ', '')
        }));
    const onSubmit = ()=>{
        if (validators?.some((validator)=>validator.address === recipient)) launchModal({
            title: t('account.sendTransaction.confirmSendingToValidator.title', 'Are you sure you want to continue?'),
            description: t('account.sendTransaction.confirmSendingToValidator.description', 'This is a validator address. Transfers to this address do not stake your funds with the validator.'),
            handleConfirm: sendTransaction,
            isDangerous: true
        });
        else sendTransaction();
    };
    // On successful transaction, clear the fields
    (0, _react.useEffect)(()=>{
        if (success) {
            setRecipient('');
            setAmount('');
        }
    }, [
        success
    ]);
    // Cleanup effect - clear the transaction when the component unmounts
    (0, _react.useEffect)(()=>{
        return function cleanup() {
            dispatch((0, _transaction.transactionActions).clearTransaction());
        };
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        margin: "none",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _heading.Heading), {
                level: "2",
                children: t('account.sendTransaction.send', 'Send')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                border: {
                    color: 'background-front-border',
                    size: '1px'
                },
                round: "5px",
                background: "background-front",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Form), {
                        onSubmit: onSubmit,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                            fill: true,
                            gap: "medium",
                            pad: "medium",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
                                    htmlFor: "recipient-id",
                                    name: "recipient",
                                    label: t('account.sendTransaction.recipient', 'Recipient'),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInput.TextInput), {
                                        id: "recipient-id",
                                        suggestions: contacts.map((contact)=>({
                                                label: contact.name,
                                                value: contact.address
                                            })),
                                        onSuggestionSelect: (event)=>setRecipient(contacts.find((contact)=>contact.address === event.suggestion?.value)?.address || ''),
                                        name: "recipient",
                                        value: recipient,
                                        placeholder: t('account.sendTransaction.enterAddress', 'Enter an address'),
                                        onChange: (event)=>setRecipient(event.target.value),
                                        required: true
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
                                    htmlFor: "amount-id",
                                    name: "amount",
                                    label: t('common.amount', 'Amount'),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInput.TextInput), {
                                        id: "amount-id",
                                        name: "amount",
                                        placeholder: t('account.sendTransaction.enterAmount', 'Enter an amount'),
                                        type: "number",
                                        step: "any",
                                        min: "0",
                                        value: amount,
                                        onChange: (event)=>setAmount(event.target.value),
                                        required: true,
                                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                            size: "xsmall",
                                            weight: 600,
                                            color: "ticker",
                                            children: ticker
                                        }),
                                        reverse: true,
                                        ...(0, _usePreventChangeOnNumberInputScroll.usePreventChangeOnNumberInputScroll)()
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                    direction: "row",
                                    justify: "between",
                                    margin: {
                                        top: 'medium'
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        type: "submit",
                                        label: t('account.sendTransaction.send', 'Send'),
                                        primary: true
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionStatus.TransactionStatus), {
                        error: error,
                        success: success
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","app/components/TransactionStatus":"7c9GE","app/components/Modal":"3R41W","app/state/transaction":"jax2p","app/state/transaction/selectors":"8LlWj","app/state/staking/selectors":"jY45G","app/state/contacts/selectors":"iLmat","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Form":"kRCRN","grommet/es6/components/FormField":"dcsVI","grommet/es6/components/TextInput":"cL4wi","grommet/es6/components/Text":"kz1Ni","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","app/lib/helpers":"bUnFy","app/state/network/selectors":"2zit7","app/lib/usePreventChangeOnNumberInputScroll":"10t9P","grommet/es6/components/Heading":"1SnMZ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7c9GE":[function(require,module,exports,__globalThis) {
/**
 *
 * TransactionStatus
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionStatus", ()=>TransactionStatus);
var _jsxRuntime = require("react/jsx-runtime");
var _alertBox = require("app/components/AlertBox");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _errorFormatter = require("../ErrorFormatter");
const TransactionStatus = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const { error, success } = props;
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBox.AlertBox), {
                status: "error",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorFormatter.ErrorFormatter), {
                    code: error.code,
                    message: error.message
                })
            }),
            success && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBox.AlertBox), {
                status: "ok-weak",
                children: t('account.sendTransaction.success', 'Transaction successfully sent. The transaction might take up to a minute to appear on your account.')
            })
        ]
    });
});

},{"react/jsx-runtime":"6pm7f","app/components/AlertBox":"ivux6","react":"8CCva","react-i18next":"7GUHL","../ErrorFormatter":"9p32r","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"10t9P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePreventChangeOnNumberInputScroll", ()=>usePreventChangeOnNumberInputScroll);
const usePreventChangeOnNumberInputScroll = ({ onWheel } = {})=>{
    return {
        onWheel: (e)=>{
            onWheel?.(e);
            const target = e.target;
            if (target !== document.activeElement) return;
            // Prevents input value change
            target.blur();
            // Focus after blur
            setTimeout(()=>{
                target.focus();
            }, 0);
        }
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"968n9":[function(require,module,exports,__globalThis) {
/**
 *
 * TransactionHistory
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Displays the past transactions from the state for a given account
 */ parcelHelpers.export(exports, "TransactionHistory", ()=>TransactionHistory);
var _jsxRuntime = require("react/jsx-runtime");
var _transaction = require("app/components/Transaction");
var _box = require("grommet/es6/components/Box");
var _heading = require("grommet/es6/components/Heading");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _selectors = require("app/state/account/selectors");
var _selectors1 = require("app/state/network/selectors");
var _errorFormatter = require("app/components/ErrorFormatter");
var _alertBox = require("../../../../components/AlertBox");
var _anchor = require("grommet/es6/components/Anchor");
var _text = require("grommet/es6/components/Text");
var _formNext = require("grommet-icons/es6/icons/FormNext");
var _config = require("../../../../../config");
var _backend = require("../../../../../vendors/backend");
function TransactionHistory() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const allTransactions = (0, _reactRedux.useSelector)((0, _selectors.selectTransactions));
    const transactionsError = (0, _reactRedux.useSelector)((0, _selectors.selectTransactionsError));
    const address = (0, _reactRedux.useSelector)((0, _selectors.selectAccountAddress));
    const accountIsLoading = (0, _reactRedux.useSelector)((0, _selectors.selectAccountIsLoading));
    const pendingTransactions = (0, _reactRedux.useSelector)((0, _selectors.selectPendingTransactionForAccount));
    const hasUnknownPendingTransactions = (0, _reactRedux.useSelector)((0, _selectors.hasAccountUnknownPendingTransactions));
    const network = (0, _reactRedux.useSelector)((0, _selectors1.selectSelectedNetwork));
    const [isInitialLoading, setInitialLoading] = (0, _react.useState)(true);
    (0, _react.useEffect)(()=>{
        if (!!address && !accountIsLoading) setInitialLoading(false);
    }, [
        address,
        accountIsLoading
    ]);
    const backendLinks = (0, _config.config)[network][(0, _backend.backend)()];
    const transactionComponents = allTransactions.map((t)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transaction.Transaction), {
            transaction: t,
            referenceAddress: address,
            network: network
        }, t.hash));
    const pendingTransactionComponents = pendingTransactions.filter(({ hash: pendingTxHash })=>!allTransactions.some(({ hash })=>hash === pendingTxHash)).map((t)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transaction.Transaction), {
            transaction: t,
            referenceAddress: address,
            network: network
        }, t.hash));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        margin: "none",
        children: [
            transactionsError && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    t('account.transaction.loadingError', `Couldn't load transactions.`),
                    ' ',
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorFormatter.ErrorFormatter), {
                        code: transactionsError.code,
                        message: transactionsError.message
                    })
                ]
            }),
            !isInitialLoading && (!!pendingTransactionComponents.length || hasUnknownPendingTransactions) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _heading.Heading), {
                        level: "2",
                        children: t('account.summary.pendingTransactions', 'Pending transactions')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBox.AlertBox), {
                        status: "ok-weak",
                        justify: "between",
                        endSlot: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: backendLinks.blockExplorerAccount && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _anchor.Anchor), {
                                href: backendLinks.blockExplorerAccount.replace('{{address}}', encodeURIComponent(address)),
                                target: "_blank",
                                rel: "noopener",
                                color: "brand",
                                style: {
                                    verticalAlign: 'middle'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                        size: "xsmall",
                                        children: t('account.summary.viewAccountTxs', 'View account transactions')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formNext.FormNext), {
                                        color: "brand",
                                        size: "20px"
                                    })
                                ]
                            })
                        }),
                        children: t('account.summary.someTxsInPendingState', 'Some transactions are currently in a pending state.')
                    }),
                    !!pendingTransactionComponents.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        gap: "medium",
                        "data-testid": "pending-txs",
                        margin: {
                            top: 'small'
                        },
                        children: pendingTransactionComponents
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _heading.Heading), {
                level: "2",
                children: t('account.summary.activity', 'Activity')
            }),
            allTransactions.length ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                gap: "medium",
                margin: "none",
                "data-testid": "completed-txs",
                children: transactionComponents
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                round: "5px",
                border: {
                    color: 'background-front-border',
                    size: '1px'
                },
                background: "background-front",
                pad: "large",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                    children: t('account.summary.noTransactionFound', 'No transactions found.')
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","app/components/Transaction":"eXZ34","grommet/es6/components/Box":"4o01A","grommet/es6/components/Heading":"1SnMZ","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","app/state/account/selectors":"avcAi","app/state/network/selectors":"2zit7","app/components/ErrorFormatter":"9p32r","../../../../components/AlertBox":"ivux6","grommet/es6/components/Anchor":"arBWH","grommet/es6/components/Text":"kz1Ni","grommet-icons/es6/icons/FormNext":"ajyuC","../../../../../config":"akiw0","../../../../../vendors/backend":"aIngR","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eXZ34":[function(require,module,exports,__globalThis) {
/**
 *
 * Transaction
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transaction", ()=>Transaction);
var _jsxRuntime = require("react/jsx-runtime");
var _anchor = require("grommet/es6/components/Anchor");
var _box = require("grommet/es6/components/Box");
var _card = require("grommet/es6/components/Card");
var _cardBody = require("grommet/es6/components/CardBody");
var _cardFooter = require("grommet/es6/components/CardFooter");
var _cardHeader = require("grommet/es6/components/CardHeader");
var _grid = require("grommet/es6/components/Grid");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _text = require("grommet/es6/components/Text");
var _package = require("grommet-icons/es6/icons/Package");
var _clock = require("grommet-icons/es6/icons/Clock");
var _contactInfo = require("grommet-icons/es6/icons/ContactInfo");
var _cube = require("grommet-icons/es6/icons/Cube");
var _formNext = require("grommet-icons/es6/icons/FormNext");
var _money = require("grommet-icons/es6/icons/Money");
var _inherit = require("grommet-icons/es6/icons/Inherit");
var _lineChart = require("grommet-icons/es6/icons/LineChart");
var _new = require("grommet-icons/es6/icons/New");
var _linkPrevious = require("grommet-icons/es6/icons/LinkPrevious");
var _linkNext = require("grommet-icons/es6/icons/LinkNext");
var _atm = require("grommet-icons/es6/icons/Atm");
var _muiLocalFireDepartmentIcon = require("../../../styles/theme/icons/mui-icons/MuiLocalFireDepartmentIcon");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _amountFormatter = require("../AmountFormatter");
var _intlDateTimeFormat = require("../DateFormatter/intlDateTimeFormat");
var _trimLongString = require("../ShortAddress/trimLongString");
var _infoBox = require("./InfoBox");
var _types = require("app/state/transaction/types");
var _config = require("config");
var _backend = require("vendors/backend");
var _addressFormatter = require("../AddressFormatter");
var TransactionSide = /*#__PURE__*/ function(TransactionSide) {
    TransactionSide["Sent"] = "sent";
    TransactionSide["Received"] = "received";
    return TransactionSide;
}(TransactionSide || {});
const StyledCardBody = (0, _styledComponentsDefault.default)((0, _cardBody.CardBody))`
  flex-direction: row;
  justify-content: space-between;

  @media only screen and (min-width: ${({ theme })=>// TODO: extend theme global breakpoints with more breakpoints or at least with 1024px. Requires Sidebar refactor and Grommet lib validation
    `${theme.global?.breakpoints?.small?.value}px`}) and (max-width: 1024px) {
    flex-direction: column-reverse;
    align-items: flex-end;

    > * {
      width: 100%;
    }
  }
`;
function Transaction(props) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const isMobile = _react.useContext((0, _responsiveContext.ResponsiveContext)) === 'small';
    const transaction = props.transaction;
    const referenceAddress = props.referenceAddress;
    const Amount = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
        amount: transaction.amount,
        size: "inherit",
        plainTicker: true
    });
    const AmountRelative = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
        amount: transaction.amount,
        size: "inherit",
        plainTicker: true,
        isRelative: true
    });
    let side;
    let otherAddress = '';
    if (transaction.from === referenceAddress) {
        side = "sent";
        otherAddress = transaction.to;
    } else {
        side = "received";
        otherAddress = transaction.from;
    }
    const genericTransaction = {
        destination: t('account.transaction.genericTransaction.destination', 'Other address'),
        icon: (0, _new.New),
        header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                i18nKey: "account.transaction.genericTransaction.header",
                t: t,
                values: {
                    method: transaction.type
                },
                defaults: "Method '{{method}}'"
            })
    };
    const unrecognizedTransaction = genericTransaction;
    // destination: t('account.transaction.unrecognizedTransaction.destination', 'Other address'),
    // icon: Alert,
    // header: () => (
    //   <Trans
    //     i18nKey="account.transaction.unrecognizedTransaction.header"
    //     t={t}
    //     values={{ method: transaction.type }}
    //     defaults="Unrecognized transaction, method '{{method}}'"
    //   />
    // ),
    // @TODO: This could probably cleverly be moved outside of the component
    //for better readability and marginal performance gain, but for now
    //the translation keys need to be read by i18next extraction
    const transactionDictionary = {
        [_types.TransactionType.StakingTransfer]: {
            ["received"]: {
                destination: t('common.from', 'From'),
                icon: (0, _linkPrevious.LinkPrevious),
                header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                        i18nKey: "account.transaction.transfer.received",
                        t: t,
                        components: {
                            Amount
                        },
                        defaults: "Received <Amount/>"
                    })
            },
            ["sent"]: {
                destination: t('common.to', 'To'),
                icon: (0, _linkNext.LinkNext),
                header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                        i18nKey: "account.transaction.transfer.sent.header",
                        t: t,
                        components: {
                            Amount
                        },
                        defaults: "Sent <Amount/>"
                    })
            }
        },
        [_types.TransactionType.StakingAddEscrow]: {
            ["received"]: {
                destination: t('common.delegator', 'Delegator'),
                icon: (0, _lineChart.LineChart),
                header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                        i18nKey: "account.transaction.addEscrow.received",
                        t: t,
                        components: {
                            Amount
                        },
                        defaults: "Received <Amount/> delegation in escrow"
                    })
            },
            ["sent"]: {
                destination: t('common.validator', 'Validator'),
                icon: (0, _lineChart.LineChart),
                header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                        i18nKey: "account.transaction.addEscrow.sent",
                        t: t,
                        components: {
                            Amount
                        },
                        defaults: "Delegated <Amount/> to validator"
                    })
            }
        },
        [_types.TransactionType.StakingReclaimEscrow]: {
            ["received"]: {
                destination: t('common.delegator', 'Delegator'),
                icon: (0, _money.Money),
                header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                        i18nKey: "account.transaction.reclaimEscrow.received",
                        t: t,
                        components: {
                            Amount
                        },
                        defaults: "<Amount/> reclaimed by delegator"
                    })
            },
            ["sent"]: {
                destination: t('common.validator', 'Validator'),
                icon: (0, _money.Money),
                header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                        i18nKey: "account.transaction.reclaimEscrow.sent",
                        t: t,
                        components: {
                            Amount
                        },
                        defaults: "Reclaimed <Amount/> from validator"
                    })
            }
        },
        [_types.TransactionType.ConsensusDeposit]: {
            ["received"]: {
                destination: t('common.from', 'From'),
                icon: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inherit.Inherit), {
                        color: "#FFCA58"
                    }),
                header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                        i18nKey: "account.transaction.consensusDeposit.received",
                        t: t,
                        values: {
                            runtimeName: transaction.runtimeName
                        },
                        components: {
                            Amount
                        },
                        defaults: "Received <Amount/> deposit into {{runtimeName}} ParaTime"
                    })
            },
            ["sent"]: {
                destination: t('common.to', 'To'),
                icon: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inherit.Inherit), {
                        color: "#FFCA58"
                    }),
                header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                        i18nKey: "account.transaction.consensusDeposit.sent",
                        t: t,
                        values: {
                            runtimeName: transaction.runtimeName
                        },
                        components: {
                            Amount
                        },
                        defaults: "Deposited <Amount/> into {{runtimeName}} ParaTime"
                    })
            }
        },
        [_types.TransactionType.ConsensusWithdraw]: {
            ["received"]: {
                destination: t('common.from', 'From'),
                icon: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inherit.Inherit), {
                        color: "#FFCA58"
                    }),
                header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                        i18nKey: "account.transaction.consensusWithdraw.received",
                        t: t,
                        values: {
                            runtimeName: transaction.runtimeName
                        },
                        components: {
                            Amount
                        },
                        defaults: "Withdrew <Amount/> out of {{runtimeName}} ParaTime"
                    })
            },
            ["sent"]: {
                destination: t('common.to', 'To'),
                icon: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inherit.Inherit), {
                        color: "#FFCA58"
                    }),
                header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                        i18nKey: "account.transaction.consensusWithdraw.sent",
                        t: t,
                        values: {
                            runtimeName: transaction.runtimeName
                        },
                        components: {
                            Amount
                        },
                        defaults: "Received <Amount/> from withdrawal out of {{runtimeName}} ParaTime"
                    })
            }
        },
        [_types.TransactionType.StakingAllow]: {
            ["received"]: {
                destination: t('common.from', 'From'),
                icon: (0, _atm.Atm),
                header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                        i18nKey: "account.transaction.stakingAllow.received",
                        t: t,
                        components: {
                            Amount
                        },
                        defaults: "Received <Amount/> allowance"
                    })
            },
            ["sent"]: {
                destination: t('common.to', 'To'),
                icon: (0, _atm.Atm),
                header: ()=>{
                    const addressToParaTime = {
                        [(0, _config.paraTimesConfig).sapphire.mainnet.address]: t('paraTimes.common.sapphire', 'Sapphire'),
                        [(0, _config.paraTimesConfig).sapphire.testnet.address]: t('paraTimes.common.sapphire', 'Sapphire'),
                        [(0, _config.paraTimesConfig).emerald.mainnet.address]: t('paraTimes.common.emerald', 'Emerald'),
                        [(0, _config.paraTimesConfig).emerald.testnet.address]: t('paraTimes.common.emerald', 'Emerald'),
                        [(0, _config.paraTimesConfig).cipher.mainnet.address]: t('paraTimes.common.cipher', 'Cipher'),
                        [(0, _config.paraTimesConfig).cipher.testnet.address]: t('paraTimes.common.cipher', 'Cipher')
                    };
                    const toRuntimeName = addressToParaTime[transaction.to];
                    return toRuntimeName ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                        i18nKey: "account.transaction.stakingAllow.sentToParaTime",
                        t: t,
                        components: {
                            Amount: AmountRelative
                        },
                        values: {
                            runtimeName: toRuntimeName
                        },
                        defaults: "Changed allowance <Amount /> for {{runtimeName}} ParaTime"
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                        i18nKey: "account.transaction.stakingAllow.sent",
                        t: t,
                        components: {
                            Amount: AmountRelative
                        },
                        defaults: "Changed allowance <Amount />"
                    });
                }
            }
        },
        [_types.TransactionType.StakingBurn]: {
            ["received"]: genericTransaction,
            ["sent"]: {
                destination: t('account.transaction.genericTransaction.destination', 'Other address'),
                icon: (0, _muiLocalFireDepartmentIcon.MuiLocalFireDepartmentIcon),
                header: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
                        i18nKey: "account.transaction.stakingBurn.sent",
                        t: t,
                        components: {
                            Amount
                        },
                        defaults: "Burned <Amount/>"
                    })
            }
        },
        [_types.TransactionType.StakingAmendCommissionSchedule]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.StakingWithdraw]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.RoothashExecutorCommit]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.RoothashExecutorProposerTimeout]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.RoothashSubmitMsg]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.RegistryDeregisterEntity]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.RegistryRegisterEntity]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.RegistryRegisterNode]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.RegistryRegisterRuntime]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.RegistryUnfreezeNode]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.GovernanceCastVote]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.GovernanceSubmitProposal]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.BeaconPvssCommit]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.BeaconPvssReveal]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.BeaconVrfProve]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.ConsensusMeta]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.ConsensusAccountsParameters]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.ConsensusBalance]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.ConsensusAccount]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        },
        [_types.TransactionType.VaultCreate]: {
            ["received"]: genericTransaction,
            ["sent"]: genericTransaction
        }
    };
    const isTypeRecognized = (type)=>type ? type in transactionDictionary : false;
    const matchingConfiguration = isTypeRecognized(transaction.type) ? transactionDictionary[transaction.type][side] : unrecognizedTransaction;
    const Icon = matchingConfiguration.icon;
    const header = matchingConfiguration.header();
    const destination = matchingConfiguration.destination;
    const backendLinks = (0, _config.config)[props.network][(0, _backend.backend)()];
    const externalExplorerLink = transaction.runtimeId ? backendLinks.blockExplorerParatimes?.replace('{{txHash}}', encodeURIComponent(transaction.hash)).replace('{{runtimeId}}', encodeURIComponent(transaction.runtimeId)) : backendLinks.blockExplorer.replace('{{txHash}}', encodeURIComponent(transaction.hash));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _card.Card), {
        pad: isMobile ? {
            horizontal: 'small',
            top: 'medium',
            bottom: 'small'
        } : 'small',
        round: "xsmall",
        elevation: "none",
        background: "background-front",
        border: transaction.status === (0, _types.TransactionStatus).Failed && {
            color: 'status-error'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _cardHeader.CardHeader), {
                margin: {
                    bottom: 'small'
                },
                pad: {
                    bottom: isMobile ? 'medium' : 'small'
                },
                border: {
                    color: 'background-front-border',
                    side: 'bottom'
                },
                direction: "row",
                align: "center",
                justify: "start",
                gap: "small",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(Icon, {
                        size: isMobile ? '20px' : 'medium',
                        color: "brand"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                        weight: "bold",
                        size: isMobile ? '14px' : 'medium',
                        children: header
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(StyledCardBody, {
                margin: {
                    bottom: 'small'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                        children: [
                            isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                                pad: {
                                    left: 'small'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                        size: "small",
                                        margin: {
                                            bottom: 'xsmall'
                                        },
                                        children: otherAddress ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressFormatter.AddressFormatter), {
                                            address: otherAddress
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: t('common.unavailable', 'Unavailable')
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                        size: "small",
                                        children: (0, _intlDateTimeFormat.intlDateTimeFormat)(transaction.timestamp)
                                    })
                                ]
                            }),
                            !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _grid.Grid), {
                                columns: {
                                    count: 2,
                                    size: 'max-content'
                                },
                                width: "max-content",
                                gap: "none",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                                        pad: "none",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBox.InfoBox), {
                                                copyToClipboardValue: otherAddress,
                                                icon: (0, _contactInfo.ContactInfo),
                                                label: destination,
                                                children: otherAddress ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressFormatter.AddressFormatter), {
                                                    address: otherAddress
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: t('common.unavailable', 'Unavailable')
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBox.InfoBox), {
                                                copyToClipboardValue: transaction.hash,
                                                icon: (0, _package.Package),
                                                label: t('common.hash', 'Tx Hash'),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                                    children: (0, _trimLongString.trimLongString)(transaction.hash)
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                                        pad: "none",
                                        children: [
                                            transaction.timestamp && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBox.InfoBox), {
                                                icon: (0, _clock.Clock),
                                                label: t('common.time', 'Time'),
                                                children: (0, _intlDateTimeFormat.intlDateTimeFormat)(transaction.timestamp)
                                            }),
                                            !transaction.runtimeId && transaction.level && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBox.InfoBox), {
                                                icon: (0, _cube.Cube),
                                                label: t('common.block', 'Block'),
                                                children: transaction.level.toString()
                                            }),
                                            transaction.runtimeId && transaction.round && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoBox.InfoBox), {
                                                icon: (0, _cube.Cube),
                                                label: t('common.round', 'Round'),
                                                children: transaction.round.toString()
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                        pad: {
                            right: 'small'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                weight: "bold",
                                size: isMobile ? 'small' : 'xlarge',
                                margin: {
                                    bottom: 'xsmall'
                                },
                                textAlign: "end",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                                    amount: transaction.amount,
                                    smallTicker: true
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                color: (()=>{
                                    switch(transaction.status){
                                        case (0, _types.TransactionStatus).Successful:
                                            return 'successful-label';
                                        case (0, _types.TransactionStatus).Pending:
                                            return 'status-warning';
                                        case (0, _types.TransactionStatus).Failed:
                                        default:
                                            return 'status-error';
                                    }
                                })(),
                                size: "small",
                                weight: "bold",
                                textAlign: "end",
                                children: (()=>{
                                    switch(transaction.status){
                                        case (0, _types.TransactionStatus).Successful:
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: t('account.transaction.successful', 'Successful')
                                            });
                                        case (0, _types.TransactionStatus).Pending:
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: t('account.transaction.pending', 'Pending')
                                            });
                                        case (0, _types.TransactionStatus).Failed:
                                        default:
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: t('account.transaction.failed', 'Failed')
                                            });
                                    }
                                })()
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardFooter.CardFooter), {
                justify: "center",
                fill: "horizontal",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _anchor.Anchor), {
                    href: externalExplorerLink,
                    target: "_blank",
                    rel: "noopener",
                    "data-testid": "explorer-link",
                    color: "brand",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                            size: isMobile ? 'xsmall' : 'small',
                            children: t('account.transaction.explorerLink', 'View transaction records through explorer')
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formNext.FormNext), {
                            color: "brand",
                            size: "20px"
                        })
                    ]
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Anchor":"arBWH","grommet/es6/components/Box":"4o01A","grommet/es6/components/Card":"a69r2","grommet/es6/components/CardBody":"88kcM","grommet/es6/components/CardFooter":"ahPe5","grommet/es6/components/CardHeader":"45h7c","grommet/es6/components/Grid":"2rRn7","grommet/es6/contexts/ResponsiveContext":"7EsNN","grommet/es6/components/Text":"kz1Ni","grommet-icons/es6/icons/Package":"lAmFe","grommet-icons/es6/icons/Clock":"gJMwL","grommet-icons/es6/icons/ContactInfo":"7o9yt","grommet-icons/es6/icons/Cube":"cof0z","grommet-icons/es6/icons/FormNext":"ajyuC","grommet-icons/es6/icons/Money":"hCHpe","grommet-icons/es6/icons/Inherit":"lgvk0","grommet-icons/es6/icons/LineChart":"6ydAo","grommet-icons/es6/icons/New":"7ribc","grommet-icons/es6/icons/LinkPrevious":"eWUq0","grommet-icons/es6/icons/LinkNext":"2yZMW","grommet-icons/es6/icons/Atm":"2d2fG","../../../styles/theme/icons/mui-icons/MuiLocalFireDepartmentIcon":"377HX","react":"8CCva","react-i18next":"7GUHL","styled-components":"6bGrk","../AmountFormatter":"dRP3j","../DateFormatter/intlDateTimeFormat":"f8Mrn","../ShortAddress/trimLongString":"1sxUU","./InfoBox":"6qjPi","app/state/transaction/types":"idhb9","config":"akiw0","vendors/backend":"aIngR","../AddressFormatter":"70nG2","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"a69r2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Card", ()=>(0, _card.Card));
var _card = require("./Card");

},{"./Card":"3Dv8O","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3Dv8O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Card", ()=>Card);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("../Box");
var _useThemeValue = require("../../utils/useThemeValue");
function _objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Card = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var _theme$card$hover;
    var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), _extends({
        overflow: "hidden",
        kind: _extends({
            hover: (_theme$card$hover = theme.card.hover) == null ? void 0 : _theme$card$hover.container
        }, theme.card.container),
        ref: ref
    }, theme.card.container, rest));
});
Card.displayName = 'Card';

},{"react":"8CCva","../Box":"4o01A","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"88kcM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardBody", ()=>(0, _cardBody.CardBody));
var _cardBody = require("./CardBody");

},{"./CardBody":"h25kh","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"h25kh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardBody", ()=>CardBody);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("../Box");
var _useThemeValue = require("../../utils/useThemeValue");
function _objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var CardBody = function CardBody(_ref) {
    var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), _extends({
        flex: true
    }, theme.card.body, rest));
};

},{"react":"8CCva","../Box":"4o01A","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ahPe5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardFooter", ()=>(0, _cardFooter.CardFooter));
var _cardFooter = require("./CardFooter");

},{"./CardFooter":"jPoRl","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jPoRl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardFooter", ()=>CardFooter);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _footer = require("../Footer");
var _useThemeValue = require("../../utils/useThemeValue");
function _objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
// Needs to have a CardBody or a flex container when Card uses a fixed height.
var CardFooter = function CardFooter(_ref) {
    var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _footer.Footer), _extends({}, theme.card.footer, rest));
};

},{"react":"8CCva","../Footer":"43GQ2","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"43GQ2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Footer", ()=>(0, _footer.Footer));
var _footer = require("./Footer");

},{"./Footer":"iDkrF","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iDkrF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Footer", ()=>Footer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("../Box");
function _objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Footer = function Footer(_ref) {
    var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), _extends({
        as: "footer",
        align: "center",
        direction: "row",
        flex: false,
        gap: "medium",
        justify: "between"
    }, rest));
};

},{"react":"8CCva","../Box":"4o01A","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"45h7c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardHeader", ()=>(0, _cardHeader.CardHeader));
var _cardHeader = require("./CardHeader");

},{"./CardHeader":"4BynV","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4BynV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardHeader", ()=>CardHeader);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _header = require("../Header");
var _useThemeValue = require("../../utils/useThemeValue");
function _objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var CardHeader = function CardHeader(_ref) {
    var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _header.Header), _extends({}, theme.card.header, rest));
};

},{"react":"8CCva","../Header":"dRDNw","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dRDNw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", ()=>(0, _header.Header));
var _header = require("./Header");

},{"./Header":"6pqnB","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6pqnB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Header", ()=>Header);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _utils = require("../../utils");
var _box = require("../Box");
var _useThemeValue = require("../../utils/useThemeValue");
var _excluded = [
    "sticky"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var Header = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(function(_ref, ref) {
    var _theme$header2;
    var sticky = _ref.sticky, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme;
    var headerRef = (0, _utils.useForwardedRef)(ref);
    (0, _react.useEffect)(function() {
        var scrollTop = 0;
        var updateScrollDir = function updateScrollDir() {
            // target is its scroll parent
            var target = (0, _utils.findScrollParent)(headerRef.current);
            var header = headerRef.current;
            if (target && sticky === 'scrollup') {
                var nextScrollTop = target === document ? window.pageYOffset : target.scrollTop;
                if (scrollTop - nextScrollTop <= 0) {
                    header.style.top = "-" + header.getBoundingClientRect().height + "px";
                    header.style.zIndex = '';
                } else if (scrollTop - nextScrollTop > 0) {
                    var _theme$header;
                    // ensure that header moves with the target
                    header.style.position = 'sticky';
                    header.style.top = '0px';
                    header.style.zIndex = "" + ((_theme$header = theme.header) == null || (_theme$header = _theme$header.sticky) == null ? void 0 : _theme$header.zIndex);
                    header.style.transition = 'top 0.6s';
                }
                scrollTop = nextScrollTop;
            }
        };
        if (sticky === 'scrollup') {
            updateScrollDir();
            window.addEventListener('resize', updateScrollDir);
            window.addEventListener('scroll', updateScrollDir, true);
        }
        return function() {
            if (sticky === 'scrollup') {
                window.removeEventListener('resize', updateScrollDir);
                window.removeEventListener('scroll', updateScrollDir, true);
            }
        };
    }, [
        headerRef,
        sticky,
        (_theme$header2 = theme.header) == null || (_theme$header2 = _theme$header2.sticky) == null ? void 0 : _theme$header2.zIndex
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _box.Box), _extends({
        align: "center",
        as: "header",
        direction: "row",
        flex: false,
        justify: "between",
        gap: "medium",
        ref: headerRef
    }, rest));
});
Header.displayName = 'Header';

},{"react":"8CCva","../../utils":"fx31z","../Box":"4o01A","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lAmFe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Package", ()=>Package);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Package = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Package"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.371.571 12 .423l-.371.148-10 4L1 4.823v14.354l.629.251 10 4 .371.149.371-.149 10-4 .629-.251V4.823l-.629-.252-10-4zM3 6.977v10.846l8 3.2V10.177l-8-3.2zm10 3.2v10.846l8-3.2V6.977l-8 3.2zM19.307 5.5 12 2.577 9.943 3.4l7.307 2.923 2.057-.823zm-14.614 0L7.25 4.477 14.557 7.4 12 8.423 4.693 5.5z",
        fill: "#000"
    }));
});
Package.displayName = 'Package';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gJMwL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Clock", ()=>Clock);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Clock = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Clock"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#000",
        d: "M13 7a1 1 0 1 0-2 0v5a1 1 0 0 0 .4.8l4 3a1 1 0 0 0 1.2-1.6L13 11.5V7z"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#000",
        fillRule: "evenodd",
        d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1zM3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0z",
        clipRule: "evenodd"
    }));
});
Clock.displayName = 'Clock';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7o9yt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContactInfo", ()=>ContactInfo);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var ContactInfo = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "ContactInfo"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M5 12a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm4 6v-2c0-2.25-1.787-4-4.036-4h.054C2.768 12 1 13.75 1 16v2M12 7h12M12 17h10m-10-5h7"
    }));
});
ContactInfo.displayName = 'ContactInfo';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cof0z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cube", ()=>Cube);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Cube = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Cube"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m12 2 10 5v10l-10 5-10-5V7l10-5zM2 7l10 5 10-5m-10 5v10-10z"
    }));
});
Cube.displayName = 'Cube';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"ajyuC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormNext", ()=>FormNext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var FormNext = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "FormNext"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m9 6 6 6-6 6"
    }));
});
FormNext.displayName = 'FormNext';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hCHpe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Money", ()=>Money);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Money = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Money"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M16 16c0-1.105-3.134-2-7-2s-7 .895-7 2 3.134 2 7 2 7-.895 7-2zM2 16v4.937C2 22.077 5.134 23 9 23s7-.924 7-2.063V16M9 5c-4.418 0-8 .895-8 2s3.582 2 8 2M1 7v5c0 1.013 3.582 2 8 2M23 4c0-1.105-3.1-2-6.923-2-3.824 0-6.923.895-6.923 2s3.1 2 6.923 2S23 5.105 23 4zm-7 12c3.824 0 7-.987 7-2V4M9.154 4v10.166M9 9c0 1.013 3.253 2 7.077 2C19.9 11 23 10.013 23 9"
    }));
});
Money.displayName = 'Money';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7ribc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "New", ()=>New);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var New = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "New"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 1v22M2 6l20 12m0-12L2 18"
    }));
});
New.displayName = 'New';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"eWUq0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkPrevious", ()=>LinkPrevious);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
var _utils = require("../utils");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var LinkPrevious = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var scaleProps = (0, _utils.useScaleProps)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "LinkPrevious"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M22 12H2m9-9-9 9 9 9"
    }, scaleProps)));
});
LinkPrevious.displayName = 'LinkPrevious';

},{"react":"8CCva","../StyledIcon":"6hZZK","../utils":"l0e2b","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2yZMW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkNext", ()=>LinkNext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
var _utils = require("../utils");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var LinkNext = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var scaleProps = (0, _utils.useScaleProps)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "LinkNext"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 12h20m-9-9 9 9-9 9"
    }, scaleProps)));
});
LinkNext.displayName = 'LinkNext';

},{"react":"8CCva","../StyledIcon":"6hZZK","../utils":"l0e2b","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"2d2fG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Atm", ()=>Atm);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Atm = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Atm"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M4 10H1V6h22v4h-3M6 6h12v14.006A2.003 2.003 0 0 1 15.991 22H8.01A2.002 2.002 0 0 1 6 20.006V6zm7 12h3m-3-3h3m-3-3h3m-6 10V6M3 2h3m2 0h3m2 0h3m2 0h3"
    }));
});
Atm.displayName = 'Atm';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"377HX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MuiLocalFireDepartmentIcon", ()=>MuiLocalFireDepartmentIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _blank = require("grommet-icons/es6/icons/Blank");
const MuiLocalFireDepartmentIcon = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _blank.Blank), {
        "aria-hidden": undefined,
        "aria-label": "Lock",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                    fill: "none",
                    height: "24",
                    width: "24"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M12,12.9l-2.13,2.09C9.31,15.55,9,16.28,9,17.06C9,18.68,10.35,20,12,20s3-1.32,3-2.94c0-0.78-0.31-1.52-0.87-2.07 L12,12.9z"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M16,6l-0.44,0.55C14.38,8.02,12,7.19,12,5.3V2c0,0-8,4-8,11c0,2.92,1.56,5.47,3.89,6.86C7.33,19.07,7,18.1,7,17.06 c0-1.32,0.52-2.56,1.47-3.5L12,10.1l3.53,3.47c0.95,0.93,1.47,2.17,1.47,3.5c0,1.02-0.31,1.96-0.85,2.75 c1.89-1.15,3.29-3.06,3.71-5.3C20.52,10.97,18.79,7.62,16,6z"
                            })
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"6pm7f","grommet-icons/es6/icons/Blank":"frgvY","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6qjPi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InfoBox", ()=>InfoBox);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("grommet/es6/components/Box");
var _text = require("grommet/es6/components/Text");
var _notification = require("grommet/es6/components/Notification");
var _copyToClipboard = require("copy-to-clipboard");
var _copyToClipboardDefault = parcelHelpers.interopDefault(_copyToClipboard);
var _react = require("react");
var _reactI18Next = require("react-i18next");
function InfoBox({ children, copyToClipboardValue, icon: IconComponent, label }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const [notificationVisible, setNotificationVisible] = (0, _react.useState)(false);
    const hideNotification = ()=>setNotificationVisible(false);
    const copyValue = ()=>{
        if (!copyToClipboardValue) return;
        const wasCopied = (0, _copyToClipboardDefault.default)(copyToClipboardValue);
        if (wasCopied) setNotificationVisible(true);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                direction: "row",
                gap: "small",
                hoverIndicator: {
                    color: 'background-contrast'
                },
                pad: {
                    horizontal: 'small',
                    vertical: 'small'
                },
                onClick: copyToClipboardValue ? copyValue : undefined,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        fill: "vertical",
                        align: "center",
                        justify: "center",
                        alignSelf: "center",
                        pad: {
                            right: 'xsmall'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(IconComponent, {
                            color: "brand",
                            size: "20px"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                        justify: "center",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                weight: "bold",
                                color: "grayMedium",
                                style: {
                                    opacity: 0.5
                                },
                                children: label
                            }),
                            children
                        ]
                    })
                ]
            }),
            notificationVisible && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notification.Notification), {
                toast: true,
                status: 'normal',
                title: t('infoBox.valueCopied', '{{label}} copied.', {
                    label
                }),
                onClose: hideNotification
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Box":"4o01A","grommet/es6/components/Text":"kz1Ni","grommet/es6/components/Notification":"1osU9","copy-to-clipboard":"bIAYJ","react":"8CCva","react-i18next":"7GUHL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4FmWe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectIsAddressInWallet", ()=>selectIsAddressInWallet);
var _toolkit = require("@reduxjs/toolkit");
var _selectors = require("app/state/account/selectors");
var _selectors1 = require("app/state/wallet/selectors");
const selectIsAddressInWallet = (0, _toolkit.createSelector)([
    (0, _selectors1.selectHasAccounts),
    (0, _selectors1.selectAddress),
    (0, _selectors.selectAccountAddress)
], (hasAccounts, walletAddress, address)=>hasAccounts && walletAddress === address);

},{"@reduxjs/toolkit":"9ol63","app/state/account/selectors":"avcAi","app/state/wallet/selectors":"cgtJ3","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5IWyP":[function(require,module,exports,__globalThis) {
/**
 *
 * ValidatorList
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorList", ()=>ValidatorList);
var _jsxRuntime = require("react/jsx-runtime");
var _amountFormatter = require("app/components/AmountFormatter");
var _errorFormatter = require("app/components/ErrorFormatter");
var _shortAddress = require("app/components/ShortAddress");
var _validatorStatus = require("app/pages/StakingPage/Features/ValidatorList/ValidatorStatus");
var _staking = require("app/state/staking");
var _selectors = require("app/state/staking/selectors");
var _selectIsAddressInWallet = require("app/state/selectIsAddressInWallet");
var _box = require("grommet/es6/components/Box");
var _text = require("grommet/es6/components/Text");
var _down = require("grommet-icons/es6/icons/Down");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _dataTableTheme = require("styles/theme/dataTableTheme");
var _typeSafeDataTable = require("types/TypeSafeDataTable");
var _validUrl = require("valid-url");
var _validatorItem = require("./ValidatorItem");
var _helpers = require("app/lib/helpers");
var _intlDateTimeFormat = require("app/components/DateFormatter/intlDateTimeFormat");
var _stakeSubnavigation = require("../../../AccountPage/Features/StakeSubnavigation");
var _selectors1 = require("../../../../state/account/selectors");
const ValidatorList = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const validators = (0, _reactRedux.useSelector)((0, _selectors.selectValidators));
    const validatorsTimestamp = (0, _reactRedux.useSelector)((0, _selectors.selectValidatorsTimestamp));
    const updateValidatorsError = (0, _reactRedux.useSelector)((0, _selectors.selectUpdateValidatorsError));
    const isAddressInWallet = (0, _reactRedux.useSelector)((0, _selectIsAddressInWallet.selectIsAddressInWallet));
    const accountAvailableBalance = (0, _reactRedux.useSelector)((0, _selectors1.selectAccountAvailableBalance));
    const selectedAddress = (0, _reactRedux.useSelector)((0, _selectors.selectSelectedAddress));
    const validatorDetails = (0, _reactRedux.useSelector)((0, _selectors.selectValidatorDetails));
    const rowClicked = (row)=>{
        if (selectedAddress === row.address) dispatch((0, _staking.stakingActions).validatorDeselected());
        else dispatch((0, _staking.stakingActions).validatorSelected(row.address));
    };
    const columns = [
        {
            name: '',
            id: 'icon',
            cell: (datum)=>datum.media?.logotype && (0, _validUrl.isWebUri)(datum.media.logotype) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: datum.media.logotype,
                    loading: "lazy",
                    className: 'logotype-small',
                    alt: ""
                }),
            width: '34px'
        },
        {
            name: '',
            id: 'status',
            cell: (datum)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorStatus.ValidatorStatus), {
                    status: datum.status,
                    showLabel: false
                }),
            width: '34px'
        },
        {
            name: t('validator.name', 'Name'),
            id: 'name',
            maxWidth: '40ex',
            minWidth: '15ex',
            cell: (datum)=>datum.name ?? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                    "data-tag": "allowRowEvents",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shortAddress.ShortAddress), {
                        address: datum.address
                    })
                }),
            sortable: true,
            sortFunction: (row1, row2)=>(row1.name ?? row1.address).localeCompare(row2.name ?? row2.address)
        },
        {
            name: t('validator.escrow', 'Escrow'),
            id: 'escrow',
            width: '28ex',
            right: true,
            hide: 'sm',
            cell: (datum)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                    amount: datum.escrow,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                }),
            sortable: true,
            sortFunction: (row1, row2)=>Number(BigInt(row1.escrow ?? 0) - BigInt(row2.escrow ?? 0))
        },
        {
            name: t('validator.fee', 'Fee'),
            id: 'fee',
            sortable: true,
            width: '110px',
            right: true,
            cell: (datum)=>datum.current_rate !== undefined ? `${(0, _helpers.formatCommissionPercent)(datum.current_rate)}%` : 'Unknown',
            sortFunction: (row1, row2)=>(row1.current_rate ?? 0) - (row2.current_rate ?? 0),
            hide: 'sm'
        }
    ];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stakeSubnavigation.StakeSubnavigation), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                as: "section",
                "data-testid": "validators-list",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    pad: "medium",
                    background: "background-front",
                    children: [
                        updateValidatorsError && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: t('account.validator.loadingError', "Couldn't load validators.")
                                }),
                                validators.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    children: [
                                        ' ',
                                        t('account.validator.showingStale', 'Showing validator list as of {{staleTimestamp}}.', {
                                            staleTimestamp: (0, _intlDateTimeFormat.intlDateTimeFormat)(validatorsTimestamp)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                validators.length <= 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorFormatter.ErrorFormatter), {
                                    code: updateValidatorsError.code,
                                    message: updateValidatorsError.message
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typeSafeDataTable.TypeSafeDataTable), {
                            noHeader: true,
                            columns: columns,
                            data: validators,
                            keyField: "address",
                            style: {},
                            customStyles: (0, _dataTableTheme.dataTableCustomStyles),
                            expandableRowsHideExpander: true,
                            expandableRows: true,
                            expandableRowsComponent: ({ data })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorItem.ValidatorItem), {
                                    data: data,
                                    details: validatorDetails,
                                    accountAvailableBalance: accountAvailableBalance,
                                    isAddressInWallet: isAddressInWallet
                                }, selectedAddress),
                            expandableRowExpanded: (row)=>row.address === selectedAddress,
                            sortIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _down.Down), {}),
                            theme: "blank",
                            onRowClicked: rowClicked,
                            highlightOnHover: true,
                            pointerOnHover: true
                        })
                    ]
                })
            })
        ]
    });
});

},{"react/jsx-runtime":"6pm7f","app/components/AmountFormatter":"dRP3j","app/components/ErrorFormatter":"9p32r","app/components/ShortAddress":"kAiso","app/pages/StakingPage/Features/ValidatorList/ValidatorStatus":"hLkP2","app/state/staking":"8XKJG","app/state/staking/selectors":"jY45G","app/state/selectIsAddressInWallet":"4FmWe","grommet/es6/components/Box":"4o01A","grommet/es6/components/Text":"kz1Ni","grommet-icons/es6/icons/Down":"1gv4k","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","styles/theme/dataTableTheme":"kVz1A","types/TypeSafeDataTable":"1uO3Y","valid-url":"gUZry","./ValidatorItem":"gfyNH","app/lib/helpers":"bUnFy","app/components/DateFormatter/intlDateTimeFormat":"f8Mrn","../../../AccountPage/Features/StakeSubnavigation":"gCIup","../../../../state/account/selectors":"avcAi","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"hLkP2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorStatus", ()=>ValidatorStatus);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("grommet/es6/components/Box");
var _text = require("grommet/es6/components/Text");
var _statusCritical = require("grommet-icons/es6/icons/StatusCritical");
var _statusGood = require("grommet-icons/es6/icons/StatusGood");
var _statusUnknown = require("grommet-icons/es6/icons/StatusUnknown");
var _reactI18Next = require("react-i18next");
const ValidatorStatus = (props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const mapStatus = {
        active: ()=>({
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusGood.StatusGood), {
                    color: "status-ok"
                }),
                label: t('validator.statusActive', 'Active')
            }),
        inactive: ()=>({
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusCritical.StatusCritical), {
                    color: "status-error"
                }),
                label: t('validator.statusInactive', 'Inactive')
            }),
        unknown: ()=>({
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusUnknown.StatusUnknown), {
                    color: "status-error"
                }),
                label: t('validator.statusUnknown', 'Unknown')
            })
    };
    const getMapped = mapStatus[props.status] ?? mapStatus.unknown;
    const mapped = getMapped();
    if (props.showLabel) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        direction: "row",
        align: "center",
        gap: "xxsmall",
        children: [
            mapped.icon,
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                size: "inherit",
                children: mapped.label
            })
        ]
    });
    else return mapped.icon;
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","grommet/es6/components/Box":"4o01A","grommet/es6/components/Text":"kz1Ni","grommet-icons/es6/icons/StatusCritical":"8hag1","grommet-icons/es6/icons/StatusGood":"3yaWj","grommet-icons/es6/icons/StatusUnknown":"3Z2y1","react-i18next":"7GUHL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"8hag1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusCritical", ()=>StatusCritical);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var StatusCritical = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Status is critical"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12.703 2.703a.99.99 0 0 0-1.406 0l-8.594 8.594a.99.99 0 0 0 0 1.406l8.594 8.594a.99.99 0 0 0 1.406 0l8.594-8.594a.99.99 0 0 0 0-1.406l-8.594-8.594zM8.983 14.7 14.7 8.983m-5.717 0L14.7 14.7"
    }));
});
StatusCritical.displayName = 'StatusCritical';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3yaWj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusGood", ()=>StatusGood);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var StatusGood = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Status is okay"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zM7 12l4 3 5-7"
    }));
});
StatusGood.displayName = 'StatusGood';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3Z2y1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StatusUnknown", ()=>StatusUnknown);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var StatusUnknown = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Status is unknown"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M2 3.99C2 2.892 2.898 2 3.99 2h16.02C21.108 2 22 2.898 22 3.99v16.02c0 1.099-.898 1.99-1.99 1.99H3.99A1.995 1.995 0 0 1 2 20.01V3.99zM12 15v-1c0-1 0-1.5 1-2s2-1 2-2.5c0-1-1-2.5-3-2.5s-3 1.264-3 3m3 6v2"
    }));
});
StatusUnknown.displayName = 'StatusUnknown';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1gv4k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Down", ()=>Down);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
var _utils = require("../utils");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Down = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var scaleProps = (0, _utils.useScaleProps)(props);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Down"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", _extends({
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "m2 8.35 10.173 9.823L21.997 8"
    }, scaleProps)));
});
Down.displayName = 'Down';

},{"react":"8CCva","../StyledIcon":"6hZZK","../utils":"l0e2b","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1uO3Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Overrides DataTable type to ensure:
 * - `keyField` on rows is not missing and is valid
 * - `id` on cols is not missing
 *
 * Fixes expanding rows when clicking non-plaintext cells.
 */ parcelHelpers.export(exports, "TypeSafeDataTable", ()=>TypeSafeDataTable);
var _jsxRuntime = require("react/jsx-runtime");
// eslint-disable-next-line no-restricted-imports
var _reactDataTableComponent = require("react-data-table-component");
var _reactDataTableComponentDefault = parcelHelpers.interopDefault(_reactDataTableComponent);
/**
 * Helper component for react-data-table-component custom cells
 *
 * react-data-table-component handles expandableRows correctly only for text nodes
 * or it requires to apply data-tag="allowRowEvents" to the innermost element which is hard to control
 *
 * To prevent expanding add `onClick={e => e.stopPropagation()}`.
 *
 * TODO: check if this is still needed in v7.7.0
 */ function ExpandableCell(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        onClick: (e)=>{
            if (e.currentTarget.parentElement?.getAttribute('data-tag') !== 'allowRowEvents') throw new Error('Could not find table cell');
            e.currentTarget.parentElement.click();
        },
        children: props.children
    });
}
function TypeSafeDataTable(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDataTableComponentDefault.default), {
        ...props,
        columns: props.columns.map((col)=>({
                ...col,
                cell: (row, rowIndex, column, id)=>{
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ExpandableCell, {
                        children: col.cell(row, rowIndex, column, id)
                    });
                }
            }))
    });
}

},{"react/jsx-runtime":"6pm7f","react-data-table-component":"kgfAv","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gUZry":[function(require,module,exports,__globalThis) {
(function(module1) {
    'use strict';
    module1.exports.is_uri = is_iri;
    module1.exports.is_http_uri = is_http_iri;
    module1.exports.is_https_uri = is_https_iri;
    module1.exports.is_web_uri = is_web_iri;
    // Create aliases
    module1.exports.isUri = is_iri;
    module1.exports.isHttpUri = is_http_iri;
    module1.exports.isHttpsUri = is_https_iri;
    module1.exports.isWebUri = is_web_iri;
    // private function
    // internal URI spitter method - direct from RFC 3986
    var splitUri = function(uri) {
        var splitted = uri.match(/(?:([^:\/?#]+):)?(?:\/\/([^\/?#]*))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?/);
        return splitted;
    };
    function is_iri(value) {
        if (!value) return;
        // check for illegal characters
        if (/[^a-z0-9\:\/\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\.\-\_\~\%]/i.test(value)) return;
        // check for hex escapes that aren't complete
        if (/%[^0-9a-f]/i.test(value)) return;
        if (/%[0-9a-f](:?[^0-9a-f]|$)/i.test(value)) return;
        var splitted = [];
        var scheme = '';
        var authority = '';
        var path = '';
        var query = '';
        var fragment = '';
        var out = '';
        // from RFC 3986
        splitted = splitUri(value);
        scheme = splitted[1];
        authority = splitted[2];
        path = splitted[3];
        query = splitted[4];
        fragment = splitted[5];
        // scheme and path are required, though the path can be empty
        if (!(scheme && scheme.length && path.length >= 0)) return;
        // if authority is present, the path must be empty or begin with a /
        if (authority && authority.length) {
            if (!(path.length === 0 || /^\//.test(path))) return;
        } else {
            // if authority is not present, the path must not start with //
            if (/^\/\//.test(path)) return;
        }
        // scheme must begin with a letter, then consist of letters, digits, +, ., or -
        if (!/^[a-z][a-z0-9\+\-\.]*$/.test(scheme.toLowerCase())) return;
        // re-assemble the URL per section 5.3 in RFC 3986
        out += scheme + ':';
        if (authority && authority.length) out += '//' + authority;
        out += path;
        if (query && query.length) out += '?' + query;
        if (fragment && fragment.length) out += '#' + fragment;
        return out;
    }
    function is_http_iri(value, allowHttps) {
        if (!is_iri(value)) return;
        var splitted = [];
        var scheme = '';
        var authority = '';
        var path = '';
        var port = '';
        var query = '';
        var fragment = '';
        var out = '';
        // from RFC 3986
        splitted = splitUri(value);
        scheme = splitted[1];
        authority = splitted[2];
        path = splitted[3];
        query = splitted[4];
        fragment = splitted[5];
        if (!scheme) return;
        if (allowHttps) {
            if (scheme.toLowerCase() != 'https') return;
        } else {
            if (scheme.toLowerCase() != 'http') return;
        }
        // fully-qualified URIs must have an authority section that is
        // a valid host
        if (!authority) return;
        // enable port component
        if (/:(\d+)$/.test(authority)) {
            port = authority.match(/:(\d+)$/)[0];
            authority = authority.replace(/:\d+$/, '');
        }
        out += scheme + ':';
        out += '//' + authority;
        if (port) out += port;
        out += path;
        if (query && query.length) out += '?' + query;
        if (fragment && fragment.length) out += '#' + fragment;
        return out;
    }
    function is_https_iri(value) {
        return is_http_iri(value, true);
    }
    function is_web_iri(value) {
        return is_http_iri(value) || is_https_iri(value);
    }
})(module);

},{}],"gfyNH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorItem", ()=>ValidatorItem);
var _jsxRuntime = require("react/jsx-runtime");
var _addEscrowForm = require("app/components/AddEscrowForm");
var _box = require("grommet/es6/components/Box");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _validatorInformations = require("./ValidatorInformations");
const ValidatorItem = (props)=>{
    const isAddressInWallet = props.isAddressInWallet;
    const validator = props.data;
    const details = props.details;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        pad: {
            vertical: 'medium'
        },
        "data-testid": "validator-item",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            style: {
                maxWidth: '85vw'
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorInformations.ValidatorInformations), {
                    validator: validator,
                    details: details,
                    delegation: null,
                    debonding: null
                }),
                isAddressInWallet && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addEscrowForm.AddEscrowForm), {
                    validatorAddress: validator.address,
                    validatorStatus: validator.status,
                    validatorRank: validator.rank,
                    accountAvailableBalance: props.accountAvailableBalance
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"6pm7f","app/components/AddEscrowForm":"11R6T","grommet/es6/components/Box":"4o01A","react":"8CCva","./ValidatorInformations":"fk580","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"11R6T":[function(require,module,exports,__globalThis) {
/**
 *
 * AddEscrowForm
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddEscrowForm", ()=>AddEscrowForm);
var _jsxRuntime = require("react/jsx-runtime");
var _modal = require("app/components/Modal");
var _helpers = require("app/lib/helpers");
var _selectors = require("app/state/network/selectors");
var _transaction = require("app/state/transaction");
var _selectors1 = require("app/state/transaction/selectors");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _checkBox = require("grommet/es6/components/CheckBox");
var _form = require("grommet/es6/components/Form");
var _text = require("grommet/es6/components/Text");
var _textInput = require("grommet/es6/components/TextInput");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _transactionStatus = require("../TransactionStatus");
var _usePreventChangeOnNumberInputScroll = require("../../lib/usePreventChangeOnNumberInputScroll");
var _amountFormatter = require("../AmountFormatter");
const AddEscrowForm = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { launchModal } = (0, _modal.useModal)();
    const { error, success } = (0, _reactRedux.useSelector)((0, _selectors1.selectTransaction));
    const isTop20 = props.validatorRank <= 20;
    const [showNotice, setShowNotice] = (0, _react.useState)(isTop20);
    const [amount, setAmount] = (0, _react.useState)('');
    const dispatch = (0, _reactRedux.useDispatch)();
    const minStaking = (0, _reactRedux.useSelector)((0, _selectors.selectMinStaking));
    const ticker = (0, _reactRedux.useSelector)((0, _selectors.selectTicker));
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    const { onWheel } = (0, _usePreventChangeOnNumberInputScroll.usePreventChangeOnNumberInputScroll)();
    const translateValidatorStatus = {
        active: t('validator.statusActive', 'Active'),
        inactive: t('validator.statusInactive', 'Inactive'),
        unknown: t('validator.statusUnknown', 'Unknown')
    };
    const delegate = ()=>{
        dispatch((0, _transaction.transactionActions).addEscrow({
            type: 'addEscrow',
            amount: (0, _helpers.parseRoseStringToBaseUnitString)(amount),
            validator: props.validatorAddress
        }));
    };
    const submit = ()=>{
        if (props.validatorStatus !== 'active') launchModal({
            title: t('account.addEscrow.confirmDelegatingToInactive.title', 'Are you sure you want to continue?'),
            description: t('account.addEscrow.confirmDelegatingToInactive.description', 'Status of this validator is {{validatorStatus}}. Your delegation might not generate any rewards.', {
                validatorStatus: translateValidatorStatus[props.validatorStatus]
            }),
            handleConfirm: delegate,
            isDangerous: true
        });
        else delegate();
    };
    (0, _react.useEffect)(()=>{
        return ()=>{
            dispatch((0, _transaction.transactionActions).clearTransaction());
        };
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            showNotice && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                pad: {
                    vertical: 'medium'
                },
                gap: "medium",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                        size: isMobile ? 'small' : 'medium',
                        children: t('account.addEscrow.confirmDelegatingToTop.description', 'This validator is ranked in the top 20 by stake. Please consider delegating to a smaller validator to increase network security and decentralization.')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                        weight: "bold",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkBox.CheckBox), {
                            label: t('account.addEscrow.confirmDelegatingToTop.acknowledge', 'Delegate anyway'),
                            checked: !showNotice,
                            onChange: (event)=>setShowNotice(!event.target.checked)
                        })
                    })
                ]
            }),
            !showNotice && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                onSubmit: submit,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                        direction: "row",
                        gap: "small",
                        pad: {
                            top: 'small'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                                background: "background-front",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInput.TextInput), {
                                        "data-testid": "amount",
                                        id: "amount-id",
                                        name: "amount",
                                        placeholder: t('common.amount'),
                                        type: "number",
                                        step: "any",
                                        min: minStaking,
                                        value: amount,
                                        onChange: (event)=>setAmount(event.target.value),
                                        required: true,
                                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                            size: "xsmall",
                                            weight: 600,
                                            color: "ticker",
                                            children: ticker
                                        }),
                                        reverse: true,
                                        onWheel: onWheel
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                        align: "end",
                                        margin: {
                                            top: 'xsmall'
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _text.Text), {
                                            weight: "bolder",
                                            size: "small",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    children: [
                                                        t('account.addEscrow.availableAmount', 'Available:'),
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                                                    amount: props.accountAvailableBalance,
                                                    smallTicker: true
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                label: t('account.addEscrow.delegate', 'Delegate'),
                                type: "submit",
                                primary: true,
                                style: {
                                    height: 45
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionStatus.TransactionStatus), {
                        error: error,
                        success: success
                    })
                ]
            })
        ]
    });
});

},{"react/jsx-runtime":"6pm7f","app/components/Modal":"3R41W","app/lib/helpers":"bUnFy","app/state/network/selectors":"2zit7","app/state/transaction":"jax2p","app/state/transaction/selectors":"8LlWj","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/CheckBox":"gaRRO","grommet/es6/components/Form":"kRCRN","grommet/es6/components/Text":"kz1Ni","grommet/es6/components/TextInput":"cL4wi","grommet/es6/contexts/ResponsiveContext":"7EsNN","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","../TransactionStatus":"7c9GE","../../lib/usePreventChangeOnNumberInputScroll":"10t9P","../AmountFormatter":"dRP3j","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"fk580":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorInformations", ()=>ValidatorInformations);
var _jsxRuntime = require("react/jsx-runtime");
var _addressBox = require("app/components/AddressBox");
var _header = require("app/components/Header");
var _amountFormatter = require("app/components/AmountFormatter");
var _responsiveGridRow = require("app/components/ResponsiveGridRow");
var _helpers = require("app/lib/helpers");
var _validatorStatus = require("app/pages/StakingPage/Features/ValidatorList/ValidatorStatus");
var _box = require("grommet/es6/components/Box");
var _grid = require("grommet/es6/components/Grid");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _spinner = require("grommet/es6/components/Spinner");
var _text = require("grommet/es6/components/Text");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _commissionBounds = require("../CommissionBounds");
var _validatorMediaInfo = require("../ValidatorMediaInfo");
const ValidatorInformations = (props)=>{
    const { validator, details } = props;
    const { t } = (0, _reactI18Next.useTranslation)();
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                align: "center",
                direction: "row",
                justify: isMobile ? 'between' : 'start',
                gap: isMobile ? 'none' : 'medium',
                children: [
                    validator.name && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.Header), {
                        level: "2",
                        margin: {
                            bottom: 'none',
                            top: 'none'
                        },
                        "data-testid": "validator-item-name",
                        children: validator.name
                    }),
                    validator.media && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        direction: "row",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorMediaInfo.ValidatorMediaInfo), {
                            mediaInfo: validator.media
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                size: isMobile ? 'small' : 'medium',
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressBox.AddressBox), {
                    address: validator.address,
                    trimMobile: true
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _grid.Grid), {
                columns: isMobile ? [
                    'auto'
                ] : [
                    'auto',
                    'flex'
                ],
                gap: {
                    column: 'medium',
                    row: isMobile ? 'xxsmall' : 'none'
                },
                fill: false,
                pad: {
                    vertical: 'small'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveGridRow.ResponsiveGridRow), {
                        label: t('validator.rank', 'Rank'),
                        value: validator.rank
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveGridRow.ResponsiveGridRow), {
                        label: t('validator.totalEscrow', 'Total escrow'),
                        value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                            amount: validator.escrow,
                            size: "inherit"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveGridRow.ResponsiveGridRow), {
                        label: t('validator.commission', 'Commission'),
                        value: `${validator.current_rate !== undefined ? (0, _helpers.formatCommissionPercent)(validator.current_rate) : 'Unknown'} %`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveGridRow.ResponsiveGridRow), {
                        label: t('validator.commissionBounds.label', 'Commission bounds'),
                        value: details ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commissionBounds.CommissionBounds), {
                            bounds: details?.scheduledCommissionBounds
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinner.Spinner), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveGridRow.ResponsiveGridRow), {
                        label: t('validator.status', 'Status'),
                        value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorStatus.ValidatorStatus), {
                            status: validator.status,
                            showLabel: true
                        })
                    }),
                    props.delegation && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveGridRow.ResponsiveGridRow), {
                        label: t('delegations.delegatedAmount', 'Delegated amount'),
                        value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                            amount: props.delegation,
                            size: "inherit"
                        })
                    }),
                    props.debonding && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveGridRow.ResponsiveGridRow), {
                        label: t('delegations.reclaimedAmount', 'Amount to reclaim'),
                        value: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                            amount: props.debonding,
                            size: "inherit"
                        })
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","app/components/AddressBox":"70dJ2","app/components/Header":"bHFRk","app/components/AmountFormatter":"dRP3j","app/components/ResponsiveGridRow":"cvHS9","app/lib/helpers":"bUnFy","app/pages/StakingPage/Features/ValidatorList/ValidatorStatus":"hLkP2","grommet/es6/components/Box":"4o01A","grommet/es6/components/Grid":"2rRn7","grommet/es6/contexts/ResponsiveContext":"7EsNN","grommet/es6/components/Spinner":"bxfAK","grommet/es6/components/Text":"kz1Ni","react":"8CCva","react-i18next":"7GUHL","../CommissionBounds":"dVt2k","../ValidatorMediaInfo":"3MjQq","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"dVt2k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CommissionBounds", ()=>CommissionBounds);
var _jsxRuntime = require("react/jsx-runtime");
var _helpers = require("app/lib/helpers");
var _selectors = require("app/state/network/selectors");
var _box = require("grommet/es6/components/Box");
var _text = require("grommet/es6/components/Text");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
const CommissionBound = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const epoch = (0, _reactRedux.useSelector)((0, _selectors.selectEpoch));
    if (typeof epoch !== 'number') return null;
    const bound = props.bound;
    const isCurrentBounds = epoch > bound.epochStart && (!bound.epochEnd || epoch < bound.epochEnd);
    const component = isCurrentBounds ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
        i18nKey: "validator.commissionBounds.current",
        t: t,
        defaults: "<strong>{{lowerBound}}% - {{upperBound}}%</strong> at current Epoch {{epoch}}",
        values: {
            lowerBound: (0, _helpers.formatCommissionPercent)(bound.lower),
            upperBound: (0, _helpers.formatCommissionPercent)(bound.upper),
            epoch: epoch
        }
    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
        i18nKey: "validator.commissionBounds.future",
        t: t,
        defaults: "{{lowerBound}}% - {{upperBound}}% starting from Epoch {{epoch}}",
        values: {
            lowerBound: (0, _helpers.formatCommissionPercent)(bound.lower),
            upperBound: (0, _helpers.formatCommissionPercent)(bound.upper),
            epoch: bound.epochStart
        }
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        as: "li",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
            size: "inherit",
            children: component
        })
    });
});
const CommissionBounds = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    if (props.bounds && props.bounds.length > 0) {
        const items = props.bounds// Always clone before sort so it doesn't mutate source
        .slice().sort((a, b)=>a.epochStart - b.epochStart).map((b, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(CommissionBound, {
                bound: b
            }, i));
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
            as: "ul",
            margin: "none",
            pad: "none",
            children: items
        });
    } else return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: t('validator.boundsNotSet', 'No bounds set (0% - 100%)')
    });
});

},{"react/jsx-runtime":"6pm7f","app/lib/helpers":"bUnFy","app/state/network/selectors":"2zit7","grommet/es6/components/Box":"4o01A","grommet/es6/components/Text":"kz1Ni","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"3MjQq":[function(require,module,exports,__globalThis) {
/**
 *
 * ValidatorMediaInfo
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ValidatorMediaInfo", ()=>ValidatorMediaInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _home = require("grommet-icons/es6/icons/Home");
var _mailOption = require("grommet-icons/es6/icons/MailOption");
var _twitter = require("grommet-icons/es6/icons/Twitter");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _validUrl = require("valid-url");
const ValidatorMediaInfo = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const info = props.mediaInfo;
    const size = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
            direction: "row",
            gap: size !== 'small' ? 'medium' : 'none',
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                direction: "row",
                gap: "none",
                children: [
                    info.email_address && !info.email_address.includes('?') && /*#__PURE__*/ (0, _jsxRuntime.jsx)(MediaButton, {
                        href: `mailto:${info.email_address}`,
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mailOption.MailOption), {
                            size: "20px"
                        })
                    }),
                    info.website_link && (0, _validUrl.isWebUri)(info.website_link) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(MediaButton, {
                        href: info.website_link,
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _home.Home), {
                            size: "20px"
                        })
                    }),
                    info.twitter_acc && (0, _validUrl.isWebUri)(info.twitter_acc) && /*#__PURE__*/ (0, _jsxRuntime.jsx)(MediaButton, {
                        href: info.twitter_acc,
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _twitter.Twitter), {
                            size: "20px"
                        })
                    })
                ]
            })
        })
    });
});
const MediaButton = /*#__PURE__*/ (0, _react.memo)((props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
        href: props.href,
        icon: props.icon,
        hoverIndicator: true,
        size: "small",
        target: "_blank",
        rel: "noopener"
    }));

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/contexts/ResponsiveContext":"7EsNN","grommet-icons/es6/icons/Home":"6RgCv","grommet-icons/es6/icons/MailOption":"em41J","grommet-icons/es6/icons/Twitter":"boetK","react":"8CCva","valid-url":"gUZry","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"em41J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MailOption", ()=>MailOption);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var MailOption = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "MailOption"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "none",
        stroke: "#000",
        strokeWidth: "2",
        d: "M1 4h22v16H1V4zm0 1 11 8.5L23 5"
    }));
});
MailOption.displayName = 'MailOption';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"boetK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Twitter", ()=>Twitter);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledIcon = require("../StyledIcon");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Twitter = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _styledIcon.StyledIcon), _extends({
        ref: ref,
        viewBox: "0 0 24 24",
        a11yTitle: "Twitter"
    }, props), /*#__PURE__*/ (0, _reactDefault.default).createElement("path", {
        fill: "#1DA1F2",
        fillRule: "evenodd",
        d: "M24 4.309a9.83 9.83 0 0 1-2.828.775 4.94 4.94 0 0 0 2.165-2.724 9.865 9.865 0 0 1-3.127 1.196 4.925 4.925 0 0 0-8.39 4.49A13.974 13.974 0 0 1 1.671 2.9a4.902 4.902 0 0 0-.667 2.476c0 1.708.869 3.216 2.191 4.099A4.936 4.936 0 0 1 .964 8.86v.06a4.926 4.926 0 0 0 3.95 4.829 4.964 4.964 0 0 1-2.224.085 4.93 4.93 0 0 0 4.6 3.42 9.886 9.886 0 0 1-6.115 2.107c-.398 0-.79-.023-1.175-.068a13.945 13.945 0 0 0 7.548 2.212c9.057 0 14.009-7.503 14.009-14.01 0-.213-.005-.425-.014-.636A10.012 10.012 0 0 0 24 4.309"
    }));
});
Twitter.displayName = 'Twitter';

},{"react":"8CCva","../StyledIcon":"6hZZK","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gCIup":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StakeSubnavigation", ()=>StakeSubnavigation);
var _jsxRuntime = require("react/jsx-runtime");
var _selectors = require("app/state/staking/selectors");
var _nav = require("grommet/es6/components/Nav");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _react = require("react");
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("grommet/es6/utils");
const StyledNavItem = (0, _styledComponentsDefault.default)((0, _reactRouterDom.NavLink))`
  letter-spacing: 0;
  padding: ${({ theme })=>theme.global?.edgeSize?.small};

  &:hover {
    color: ${({ theme })=>(0, _utils.normalizeColor)('text', theme)};
    background-color: ${({ theme })=>(0, _utils.normalizeColor)('active', theme)};
  }

  &.active {
    color: ${({ theme })=>(0, _utils.normalizeColor)('text', theme, true)};
    background-color: ${({ theme })=>(0, _utils.normalizeColor)('control', theme)};
  }

  @media only screen and (max-width: ${({ theme })=>`${theme.global?.breakpoints?.small?.value}px`}) {
    padding-top: ${({ theme })=>theme.global?.edgeSize?.xsmall};
    padding-bottom: ${({ theme })=>theme.global?.edgeSize?.xsmall};
  }
`;
const NavItem = ({ counter, label, route })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledNavItem, {
        end: true,
        to: route,
        children: counter ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                label,
                " (",
                counter,
                ")"
            ]
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            children: label
        })
    });
};
function StakeSubnavigation() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const isMobile = _react.useContext((0, _responsiveContext.ResponsiveContext)) === 'small';
    const address = (0, _reactRouterDom.useParams)().address;
    const stake = (0, _reactRedux.useSelector)((0, _selectors.selectStaking));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _nav.Nav), {
        background: "background-front",
        justify: isMobile ? 'evenly' : 'start',
        margin: {
            bottom: 'small'
        },
        direction: "row",
        gap: "none",
        wrap: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NavItem, {
                label: t('common.validators', 'Validators'),
                route: `/account/${address}/stake`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NavItem, {
                counter: stake.delegations?.length,
                label: isMobile ? t('account.subnavigation.mobileActiveDelegations', 'Staked') : t('account.subnavigation.activeDelegations', 'Staked'),
                route: `/account/${address}/stake/active-delegations`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(NavItem, {
                counter: stake.debondingDelegations?.length,
                label: isMobile ? t('account.subnavigation.mobileDebondingDelegations', 'Debonding') : t('account.subnavigation.debondingDelegations', 'Debonding'),
                route: `/account/${address}/stake/debonding-delegations`
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","app/state/staking/selectors":"jY45G","grommet/es6/components/Nav":"g5GDL","grommet/es6/contexts/ResponsiveContext":"7EsNN","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","react-router-dom":"9pTjq","styled-components":"6bGrk","grommet/es6/utils":"fx31z","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lCWWS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActiveDelegationList", ()=>ActiveDelegationList);
var _jsxRuntime = require("react/jsx-runtime");
var _selectors = require("app/state/staking/selectors");
var _box = require("grommet/es6/components/Box");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _ = require(".");
var _stakeSubnavigation = require("../../../AccountPage/Features/StakeSubnavigation");
const ActiveDelegationList = ()=>{
    const delegations = (0, _reactRedux.useSelector)((0, _selectors.selectActiveDelegations));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stakeSubnavigation.StakeSubnavigation), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                as: "section",
                "data-testid": "active-delegations",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                    pad: "medium",
                    background: "background-front",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.DelegationList), {
                        type: "active",
                        delegations: delegations ?? []
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","app/state/staking/selectors":"jY45G","grommet/es6/components/Box":"4o01A","react":"8CCva","react-redux":"azV3Y",".":"bDfvt","../../../AccountPage/Features/StakeSubnavigation":"gCIup","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bDfvt":[function(require,module,exports,__globalThis) {
/**
 *
 * DelegationList
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DelegationList", ()=>DelegationList);
var _jsxRuntime = require("react/jsx-runtime");
var _amountFormatter = require("app/components/AmountFormatter");
var _shortAddress = require("app/components/ShortAddress");
var _timeToEpoch = require("app/components/TimeToEpoch");
var _helpers = require("app/lib/helpers");
var _validatorStatus = require("app/pages/StakingPage/Features/ValidatorList/ValidatorStatus");
var _selectIsAddressInWallet = require("app/state/selectIsAddressInWallet");
var _staking = require("app/state/staking");
var _selectors = require("app/state/staking/selectors");
var _text = require("grommet/es6/components/Text");
var _down = require("grommet-icons/es6/icons/Down");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _dataTableTheme = require("styles/theme/dataTableTheme");
var _typeSafeDataTable = require("types/TypeSafeDataTable");
var _validUrl = require("valid-url");
var _delegationItem = require("./DelegationItem");
const DelegationList = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const type = props.type;
    // Create a combined unique key because validatorAddress is not unique in debondings
    const delegations = props.delegations.map((delegation)=>({
            ...delegation,
            uniqueKey: type === 'active' ? delegation.validatorAddress : `${delegation.validatorAddress}+${delegation.epoch}`
        }));
    const { t } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const validatorDetails = (0, _reactRedux.useSelector)((0, _selectors.selectValidatorDetails));
    const selectedAddress = (0, _reactRedux.useSelector)((0, _selectors.selectSelectedAddress));
    const isAddressInWallet = (0, _reactRedux.useSelector)((0, _selectIsAddressInWallet.selectIsAddressInWallet));
    const canReclaim = type === 'active' && isAddressInWallet;
    const rowClicked = (row)=>{
        if (selectedAddress === row.validatorAddress) dispatch((0, _staking.stakingActions).validatorDeselected());
        else dispatch((0, _staking.stakingActions).validatorSelected(row.validatorAddress));
    };
    const columnTypes = {
        icon: {
            name: '',
            id: 'icon',
            cell: (datum)=>datum.validator?.media?.logotype && (0, _validUrl.isWebUri)(datum.validator?.media.logotype) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: datum.validator?.media.logotype,
                    loading: "lazy",
                    className: 'logotype-small',
                    alt: ""
                }),
            width: '34px'
        },
        status: {
            name: '',
            id: 'status',
            cell: (datum)=>datum.validator && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorStatus.ValidatorStatus), {
                    status: datum.validator.status,
                    showLabel: false
                }),
            width: '34px'
        },
        name: {
            name: t('validator.name', 'Name'),
            id: 'name',
            maxWidth: '40ex',
            minWidth: '15ex',
            cell: (datum)=>datum.validator?.name ?? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                    "data-tag": "allowRowEvents",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shortAddress.ShortAddress), {
                        address: datum.validatorAddress
                    })
                }),
            sortable: true,
            sortFunction: (row1, row2)=>(row1.validator?.name ?? row1.validatorAddress).localeCompare(row2.validator?.name ?? row2.validatorAddress)
        },
        amount: {
            name: type === 'active' ? t('delegations.delegatedAmount', 'Delegated amount') : t('delegations.reclaimedAmount', 'Amount to reclaim'),
            id: 'amount',
            width: '28ex',
            right: true,
            cell: (datum)=>datum.amount && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                    amount: datum.amount,
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2
                }),
            sortable: true,
            sortFunction: (row1, row2)=>Number(BigInt(row1.amount) - BigInt(row2.amount))
        },
        fee: {
            name: t('validator.fee', 'Fee'),
            id: 'fee',
            width: '100px',
            right: true,
            hide: 'sm',
            cell: (datum)=>datum.validator?.current_rate !== undefined ? `${(0, _helpers.formatCommissionPercent)(datum.validator.current_rate)}%` : 'Unknown',
            sortable: true,
            sortFunction: (row1, row2)=>(row1.validator?.current_rate ?? 0) - (row2.validator?.current_rate ?? 0)
        },
        debondingTimeEnd: {
            name: t('delegations.debondingTimeEnd', 'End of debonding'),
            id: 'debondingTimeEnd',
            sortable: true,
            cell: (datum)=>{
                if ('currentEpoch' in props) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeToEpoch.TimeToEpoch), {
                    currentEpoch: props.currentEpoch,
                    epoch: datum.epoch
                });
            }
        }
    };
    const columns = type === 'active' ? [
        columnTypes.icon,
        columnTypes.status,
        columnTypes.name,
        columnTypes.amount,
        columnTypes.fee
    ] : [
        columnTypes.icon,
        columnTypes.name,
        columnTypes.amount,
        columnTypes.debondingTimeEnd
    ];
    const defaultSortField = type === 'active' ? undefined : 'epoch';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _typeSafeDataTable.TypeSafeDataTable), {
        noHeader: true,
        noDataComponent: type === 'active' ? t('account.emptyActiveDelegationsList', 'There are currently no active delegations for this account.') : t('account.emptyDebondingDelegationsList', 'There are no debonding delegations for this account.'),
        columns: columns,
        data: delegations,
        defaultSortFieldId: defaultSortField,
        keyField: "uniqueKey",
        style: {},
        customStyles: (0, _dataTableTheme.dataTableCustomStyles),
        expandableRowsHideExpander: true,
        expandableRows: true,
        expandableRowsComponent: ({ data })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _delegationItem.DelegationItem), {
                data: data,
                validatorDetails: validatorDetails,
                canReclaim: canReclaim,
                type: type
            }),
        expandableRowExpanded: (row)=>row.validatorAddress === selectedAddress,
        sortIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _down.Down), {}),
        theme: "blank",
        onRowClicked: rowClicked,
        highlightOnHover: true,
        pointerOnHover: true
    });
});

},{"react/jsx-runtime":"6pm7f","app/components/AmountFormatter":"dRP3j","app/components/ShortAddress":"kAiso","app/components/TimeToEpoch":"1G8Ss","app/lib/helpers":"bUnFy","app/pages/StakingPage/Features/ValidatorList/ValidatorStatus":"hLkP2","app/state/selectIsAddressInWallet":"4FmWe","app/state/staking":"8XKJG","app/state/staking/selectors":"jY45G","grommet/es6/components/Text":"kz1Ni","grommet-icons/es6/icons/Down":"1gv4k","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","styles/theme/dataTableTheme":"kVz1A","types/TypeSafeDataTable":"1uO3Y","valid-url":"gUZry","./DelegationItem":"h4e4p","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"1G8Ss":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeToEpoch", ()=>TimeToEpoch);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var process = require("bafc7fdbe4baa308");
const estimatedEpochsPerHour = 1;
const relativeFormat = new Intl.RelativeTimeFormat(process?.env?.NODE_ENV === 'test' ? 'en-US' : undefined);
function TimeToEpoch(props) {
    if (!props.currentEpoch) return null;
    const remainingHours = (props.epoch - props.currentEpoch) / estimatedEpochsPerHour;
    // TODO: add more thresholds if used for other than debonding
    const formattedRemainingTime = remainingHours > 48 ? relativeFormat.format(Math.round(remainingHours / 24), 'day') : relativeFormat.format(remainingHours, 'hour');
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        children: formattedRemainingTime
    });
}

},{"bafc7fdbe4baa308":"fQ8R7","react/jsx-runtime":"6pm7f","react":"8CCva","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"h4e4p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DelegationItem", ()=>DelegationItem);
var _jsxRuntime = require("react/jsx-runtime");
var _reclaimEscrowForm = require("app/components/ReclaimEscrowForm");
var _box = require("grommet/es6/components/Box");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _validatorInformations = require("../ValidatorList/ValidatorInformations");
var _addressBox = require("../../../../components/AddressBox");
const DelegationItem = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const delegation = props.data;
    const validator = props.data.validator;
    const canReclaim = props.canReclaim;
    const details = props.validatorDetails;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        pad: {
            vertical: 'medium'
        },
        "data-testid": "validator-item",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            style: {
                maxWidth: '85vw'
            },
            children: [
                validator && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _validatorInformations.ValidatorInformations), {
                    validator: validator,
                    details: details,
                    delegation: props.type === 'active' ? delegation.amount : null,
                    debonding: props.type === 'debonding' ? delegation.amount : null
                }),
                !validator && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addressBox.AddressBox), {
                            address: delegation.validatorAddress,
                            trimMobile: true
                        }),
                        t('validator.unknownValidator', 'Unknown validator')
                    ]
                }),
                canReclaim && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reclaimEscrowForm.ReclaimEscrowForm), {
                    address: delegation.validatorAddress,
                    maxAmount: delegation.amount,
                    maxShares: delegation.shares
                })
            ]
        })
    });
});

},{"react/jsx-runtime":"6pm7f","app/components/ReclaimEscrowForm":"g9wUa","grommet/es6/components/Box":"4o01A","react":"8CCva","react-i18next":"7GUHL","../ValidatorList/ValidatorInformations":"fk580","../../../../components/AddressBox":"70dJ2","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"g9wUa":[function(require,module,exports,__globalThis) {
/**
 *
 * ReclaimEscrowForm
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReclaimEscrowForm", ()=>ReclaimEscrowForm);
var _jsxRuntime = require("react/jsx-runtime");
var _helpers = require("app/lib/helpers");
var _transaction = require("app/state/transaction");
var _selectors = require("app/state/transaction/selectors");
var _bignumberJs = require("bignumber.js");
var _bignumberJsDefault = parcelHelpers.interopDefault(_bignumberJs);
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _form = require("grommet/es6/components/Form");
var _text = require("grommet/es6/components/Text");
var _textInput = require("grommet/es6/components/TextInput");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _transactionStatus = require("../TransactionStatus");
var _selectors1 = require("../../state/network/selectors");
var _amountFormatter = require("../AmountFormatter");
var _usePreventChangeOnNumberInputScroll = require("../../lib/usePreventChangeOnNumberInputScroll");
const ReclaimEscrowForm = /*#__PURE__*/ (0, _react.memo)((props)=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { error, success } = (0, _reactRedux.useSelector)((0, _selectors.selectTransaction));
    const ticker = (0, _reactRedux.useSelector)((0, _selectors1.selectTicker));
    const [amount, setAmount] = (0, _react.useState)('');
    const [shares, setShares] = (0, _react.useState)('0');
    const dispatch = (0, _reactRedux.useDispatch)();
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    (0, _react.useEffect)(()=>{
        return ()=>{
            dispatch((0, _transaction.transactionActions).clearTransaction());
        };
    }, [
        dispatch
    ]);
    const amountChanged = (amount)=>{
        const shares = (BigInt((0, _helpers.parseRoseStringToBaseUnitString)(amount || '0')) * BigInt(props.maxShares) / BigInt(props.maxAmount)).toString();
        setAmount(amount);
        setShares(shares);
    };
    const submit = ()=>{
        dispatch((0, _transaction.transactionActions).reclaimEscrow({
            type: 'reclaimEscrow',
            amount: (0, _helpers.parseRoseStringToBaseUnitString)(amount),
            shares: shares,
            validator: props.address
        }));
    };
    const reclaimAll = ()=>{
        dispatch((0, _transaction.transactionActions).reclaimEscrow({
            type: 'reclaimEscrow',
            amount: props.maxAmount,
            shares: props.maxShares,
            validator: props.address
        }));
    };
    /**
   * `<input max="9000000000.111111111">` warns about <=9000000000.11111 so we
   * round up to `<input max="9000000000.11112">`
   */ const roundedUpStringifiedFloatMaxAmount = new (0, _bignumberJsDefault.default)(props.maxAmount).shiftedBy(-9) // / 10 ** 9
    .toPrecision(15, (0, _bignumberJsDefault.default).ROUND_UP);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
        onSubmit: submit,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                direction: isMobile ? 'column' : 'row',
                gap: "medium",
                pad: {
                    top: 'small'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInput.TextInput), {
                                "data-testid": "amount",
                                id: "amount-id",
                                name: "amount",
                                placeholder: t('common.amount'),
                                type: "number",
                                step: "any",
                                min: "0",
                                max: roundedUpStringifiedFloatMaxAmount,
                                size: "medium",
                                value: amount,
                                onChange: (event)=>amountChanged(event.target.value),
                                required: true,
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                    size: "xsmall",
                                    weight: 600,
                                    color: "ticker",
                                    children: ticker
                                }),
                                reverse: true,
                                ...(0, _usePreventChangeOnNumberInputScroll.usePreventChangeOnNumberInputScroll)()
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                align: "end",
                                margin: {
                                    top: 'xsmall'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _text.Text), {
                                    weight: "bolder",
                                    size: "small",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            children: [
                                                t('account.reclaimEscrow.reclaimableAmount', 'Available:'),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                                            amount: props.maxAmount,
                                            smallTicker: true
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                        direction: "row",
                        gap: "medium",
                        height: "46px",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                fill: isMobile,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    fill: true,
                                    label: t('account.reclaimEscrow.reclaim', 'Reclaim'),
                                    type: "submit",
                                    primary: true
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                fill: isMobile,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    fill: true,
                                    label: t('account.reclaimEscrow.reclaimAll', 'Reclaim all'),
                                    onClick: reclaimAll
                                })
                            })
                        ]
                    })
                ]
            }),
            shares !== '0' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _text.Text), {
                size: "small",
                "data-testid": "numberOfShares",
                children: [
                    t('account.reclaimEscrow.convertedToShares', 'Corresponding number of shares: {{shares}}', {
                        shares: (0, _helpers.formatBaseUnitsAsRose)(shares)
                    }),
                    t('common.postfixAmountInBillions', 'B')
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionStatus.TransactionStatus), {
                error: error,
                success: success
            })
        ]
    });
});

},{"react/jsx-runtime":"6pm7f","app/lib/helpers":"bUnFy","app/state/transaction":"jax2p","app/state/transaction/selectors":"8LlWj","bignumber.js":"a7tdL","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Form":"kRCRN","grommet/es6/components/Text":"kz1Ni","grommet/es6/components/TextInput":"cL4wi","grommet/es6/contexts/ResponsiveContext":"7EsNN","react":"8CCva","react-i18next":"7GUHL","react-redux":"azV3Y","../TransactionStatus":"7c9GE","../../state/network/selectors":"2zit7","../AmountFormatter":"dRP3j","../../lib/usePreventChangeOnNumberInputScroll":"10t9P","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"im1Wq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DebondingDelegationList", ()=>DebondingDelegationList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _selectors = require("app/state/staking/selectors");
var _box = require("grommet/es6/components/Box");
var _reactRedux = require("react-redux");
var _ = require(".");
var _stakeSubnavigation = require("../../../AccountPage/Features/StakeSubnavigation");
var _network = require("../../../../../app/state/network");
var _selectors1 = require("../../../../../app/state/network/selectors");
const DebondingDelegationList = ()=>{
    const dispatch = (0, _reactRedux.useDispatch)();
    const delegations = (0, _reactRedux.useSelector)((0, _selectors.selectDebondingDelegations));
    const currentEpoch = (0, _reactRedux.useSelector)((0, _selectors1.selectEpoch));
    (0, _react.useEffect)(()=>{
        dispatch((0, _network.networkActions).getEpoch());
    }, [
        dispatch,
        currentEpoch
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stakeSubnavigation.StakeSubnavigation), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                as: "section",
                "data-testid": "debonding-delegations",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                    pad: "medium",
                    background: "background-front",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _.DelegationList), {
                        currentEpoch: currentEpoch,
                        type: "debonding",
                        delegations: delegations ?? []
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","app/state/staking/selectors":"jY45G","grommet/es6/components/Box":"4o01A","react-redux":"azV3Y",".":"bDfvt","../../../AccountPage/Features/StakeSubnavigation":"gCIup","../../../../../app/state/network":"8NDHR","../../../../../app/state/network/selectors":"2zit7","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bDRBN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParaTimes", ()=>ParaTimes);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _reactI18Next = require("react-i18next");
var _box = require("grommet/es6/components/Box");
var _selectors = require("app/state/network/selectors");
var _selectors1 = require("app/state/paratimes/selectors");
var _selectIsAddressInWallet = require("app/state/selectIsAddressInWallet");
var _types = require("app/state/paratimes/types");
var _types1 = require("app/state/wallet/types");
var _selectors2 = require("app/state/wallet/selectors");
var _errors = require("types/errors");
var _paraTimesPageInaccessible = require("./ParaTimesPageInaccessible");
var _paraTimeTransferType = require("./ParaTimeTransferType");
var _paraTimeSelection = require("./ParaTimeSelection");
var _transactionRecipient = require("./TransactionRecipient");
var _transactionAmount = require("./TransactionAmount");
var _transactionConfirmation = require("./TransactionConfirmation");
var _transactionSummary = require("./TransactionSummary");
var _transactionError = require("./TransactionError");
var _useParaTimes = require("./useParaTimes");
const ActiveFormStepComponent = ({ step })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    switch(step){
        case (0, _types.TransactionFormSteps).TransferType:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimeTransferType.ParaTimeTransferType), {});
        case (0, _types.TransactionFormSteps).ParaTimeSelection:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimeSelection.ParaTimeSelection), {});
        case (0, _types.TransactionFormSteps).TransactionRecipient:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionRecipient.TransactionRecipient), {});
        case (0, _types.TransactionFormSteps).TransactionAmount:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionAmount.TransactionAmount), {});
        case (0, _types.TransactionFormSteps).TransactionConfirmation:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionConfirmation.TransactionConfirmation), {});
        case (0, _types.TransactionFormSteps).TransactionSummary:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionSummary.TransactionSummary), {});
        case (0, _types.TransactionFormSteps).TransactionError:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _transactionError.TransactionError), {});
        default:
            throw new (0, _errors.ExhaustedTypeError)(t('paraTimes.unsupportedFormStep', 'Unsupported form step'), step);
    }
};
const ParaTimes = ()=>{
    const selectedNetwork = (0, _reactRedux.useSelector)((0, _selectors.selectSelectedNetwork));
    const { transactionFormStep } = (0, _reactRedux.useSelector)((0, _selectors1.selectParaTimes));
    const isAddressInWallet = (0, _reactRedux.useSelector)((0, _selectIsAddressInWallet.selectIsAddressInWallet));
    const walletType = (0, _reactRedux.useSelector)((0, _selectors2.selectType));
    const { clearTransactionForm } = (0, _useParaTimes.useParaTimes)();
    const isLedgerWallet = walletType === (0, _types1.WalletType).UsbLedger || walletType === (0, _types1.WalletType).BleLedger;
    (0, _react.useEffect)(()=>{
        return ()=>{
            clearTransactionForm();
        };
    }, [
        clearTransactionForm
    ]);
    (0, _react.useEffect)(()=>{
        clearTransactionForm();
    }, [
        clearTransactionForm,
        selectedNetwork
    ]);
    if (!isAddressInWallet) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        pad: "medium",
        background: "background-front",
        align: "center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimesPageInaccessible.ParaTimesPageInaccessibleForeign), {})
    });
    if (isLedgerWallet) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        pad: "medium",
        background: "background-front",
        align: "center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimesPageInaccessible.ParaTimesPageInaccessibleLedger), {})
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        pad: "medium",
        background: "background-front",
        align: "center",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ActiveFormStepComponent, {
            step: transactionFormStep
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-redux":"azV3Y","react-i18next":"7GUHL","grommet/es6/components/Box":"4o01A","app/state/network/selectors":"2zit7","app/state/paratimes/selectors":"kgZsW","app/state/selectIsAddressInWallet":"4FmWe","app/state/paratimes/types":"h4oxt","app/state/wallet/types":"b0U5N","app/state/wallet/selectors":"cgtJ3","types/errors":"gbx4q","./ParaTimesPageInaccessible":"cAbJg","./ParaTimeTransferType":"66Nbe","./ParaTimeSelection":"jwfzk","./TransactionRecipient":"6AivA","./TransactionAmount":"iTyKn","./TransactionConfirmation":"aicWa","./TransactionSummary":"bDFL1","./TransactionError":"lagoR","./useParaTimes":"kRFDd","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cAbJg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParaTimesPageInaccessibleForeign", ()=>ParaTimesPageInaccessibleForeign);
parcelHelpers.export(exports, "ParaTimesPageInaccessibleLedger", ()=>ParaTimesPageInaccessibleLedger);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _paraTimeContent = require("../ParaTimeContent");
const ParaTimesPageInaccessibleForeign = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimeContent.ParaTimeContent), {
        header: t('paraTimes.common.header', 'ParaTime Transfers'),
        description: t('paraTimes.pageInaccessible.foreignAccount', 'Transfers are not available.')
    });
};
const ParaTimesPageInaccessibleLedger = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimeContent.ParaTimeContent), {
        header: t('paraTimes.common.header', 'ParaTime Transfers'),
        description: t('paraTimes.pageInaccessible.ledgerAccount', 'Ledger account is not supported.')
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-i18next":"7GUHL","../ParaTimeContent":"b3Bev","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"b3Bev":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParaTimeContent", ()=>ParaTimeContent);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("grommet/es6/components/Box");
var _heading = require("grommet/es6/components/Heading");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _spinner = require("grommet/es6/components/Spinner");
var _text = require("grommet/es6/components/Text");
var _reactI18Next = require("react-i18next");
var _useParaTimes = require("../useParaTimes");
const ParaTimeContent = ({ children, description, header, isLoading })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    const { isDepositing } = (0, _useParaTimes.useParaTimes)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        align: "center",
        style: {
            maxWidth: 'min(100%, 550px)'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _heading.Heading), {
                level: 2,
                margin: {
                    bottom: 'large'
                },
                children: header || (isDepositing ? t('paraTimes.transfers.deposit', 'Deposit to ParaTime') : t('paraTimes.transfers.withdraw', 'Withdraw from ParaTime'))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                margin: {
                    bottom: 'large'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                    "data-testid": "paraTime-content-description",
                    textAlign: "center",
                    size: isMobile ? '16px' : 'medium',
                    children: description
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                align: "center",
                fill: "horizontal",
                gap: "medium",
                margin: {
                    bottom: 'xlarge'
                },
                responsive: false,
                children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinner.Spinner), {
                    "data-testid": "paraTime-content-loading",
                    size: "medium"
                }) : children
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","grommet/es6/components/Box":"4o01A","grommet/es6/components/Heading":"1SnMZ","grommet/es6/contexts/ResponsiveContext":"7EsNN","grommet/es6/components/Spinner":"bxfAK","grommet/es6/components/Text":"kz1Ni","react-i18next":"7GUHL","../useParaTimes":"kRFDd","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"kRFDd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useParaTimes", ()=>useParaTimes);
var _react = require("react");
var _reactRedux = require("react-redux");
var _reactI18Next = require("react-i18next");
var _paratimes = require("app/state/paratimes");
var _types = require("app/state/paratimes/types");
var _selectors = require("app/state/network/selectors");
var _selectors1 = require("app/state/account/selectors");
var _selectors2 = require("app/state/wallet/selectors");
var _selectors3 = require("app/state/paratimes/selectors");
var _config = require("../../../config");
var _selectors4 = require("app/state/evmAccounts/selectors");
var _getParaTimeName = require("./getParaTimeName");
const evmcParaTimes = Object.keys((0, _config.paraTimesConfig)).filter((key)=>(0, _config.paraTimesConfig)[key].type === (0, _config.RuntimeTypes).Evm);
const useParaTimes = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const clearTransactionForm = (0, _react.useCallback)(()=>{
        dispatch((0, _paratimes.paraTimesActions).clearTransactionForm());
    }, [
        dispatch
    ]);
    const submitTransaction = (0, _react.useCallback)(()=>{
        dispatch((0, _paratimes.paraTimesActions).submitTransaction());
    }, [
        dispatch
    ]);
    const setTransactionForm = (formValues)=>dispatch((0, _paratimes.paraTimesActions).setTransactionForm(formValues));
    const { balance, isLoading, transactionError, transactionForm } = (0, _reactRedux.useSelector)((0, _selectors3.selectParaTimes));
    const accountBalance = (0, _reactRedux.useSelector)((0, _selectors1.selectAccountAvailableBalance));
    const accountIsLoading = (0, _reactRedux.useSelector)((0, _selectors1.selectAccountIsLoading));
    const accountAddress = (0, _reactRedux.useSelector)((0, _selectors2.selectAddress));
    const evmAccounts = (0, _reactRedux.useSelector)((0, _selectors4.selectEvmAccounts));
    const selectedNetwork = (0, _reactRedux.useSelector)((0, _selectors.selectSelectedNetwork));
    const ticker = (0, _reactRedux.useSelector)((0, _selectors.selectTicker));
    const isDepositing = transactionForm.type !== (0, _types.TransactionTypes).Withdraw;
    const isEvmcParaTime = evmcParaTimes.includes(transactionForm.paraTime);
    const needsEthAddress = isDepositing && isEvmcParaTime;
    const balanceInBaseUnit = isDepositing || !isDepositing && !isEvmcParaTime;
    const paraTimeName = transactionForm.paraTime ? (0, _getParaTimeName.getParaTimeName)(t, transactionForm.paraTime) : '';
    const availableParaTimesForSelectedNetwork = Object.keys((0, _config.paraTimesConfig)).filter((paraTimeKey)=>(0, _config.paraTimesConfig)[paraTimeKey][selectedNetwork].runtimeId).sort((a, b)=>(0, _config.paraTimesConfig)[a].displayOrder - (0, _config.paraTimesConfig)[b].displayOrder).map((paraTimeKey)=>({
            isEvm: (0, _config.paraTimesConfig)[paraTimeKey].type === (0, _config.RuntimeTypes).Evm,
            value: paraTimeKey
        }));
    const walletBalance = !isDepositing ? balance : accountBalance;
    const paraTimeConfig = (0, _config.paraTimesConfig)[transactionForm.paraTime];
    return {
        accountAddress,
        accountIsLoading,
        availableParaTimesForSelectedNetwork,
        balance: walletBalance,
        balanceInBaseUnit,
        clearTransactionForm,
        evmAccounts,
        isDepositing,
        isEvmcParaTime,
        isLoading,
        isWalletEmpty: walletBalance === '0',
        paraTimeConfig,
        paraTimeName,
        setTransactionForm,
        submitTransaction,
        ticker,
        transactionError,
        transactionForm,
        usesOasisAddress: !needsEthAddress
    };
};

},{"react":"8CCva","react-redux":"azV3Y","react-i18next":"7GUHL","app/state/paratimes":"63sI2","app/state/paratimes/types":"h4oxt","app/state/network/selectors":"2zit7","app/state/account/selectors":"avcAi","app/state/wallet/selectors":"cgtJ3","app/state/paratimes/selectors":"kgZsW","../../../config":"akiw0","app/state/evmAccounts/selectors":"cYivh","./getParaTimeName":"4b62n","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"cYivh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectEvmAccounts", ()=>selectEvmAccounts);
var _toolkit = require("@reduxjs/toolkit");
var _ = require(".");
const selectSlice = (state)=>state.evmAccounts || (0, _.initialState);
const selectEvmAccounts = (0, _toolkit.createSelector)([
    selectSlice
], (evmAccounts)=>Object.values(evmAccounts));

},{"@reduxjs/toolkit":"9ol63",".":"dpUJw","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"4b62n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getParaTimeName", ()=>getParaTimeName);
var _errors = require("types/errors");
var _config = require("../../../config");
const getParaTimeName = (t, paraTime)=>{
    switch(paraTime){
        case (0, _config.ParaTime).Cipher:
            // Discourage mistaken ParaTime deposits into Cipher accounts controlled
            // by Binance. That requires contacting support to recover it.
            return `${t('paraTimes.common.cipher', 'Cipher')} ${t('paraTimes.common.discouragedType', '(experimental)')}`;
        case (0, _config.ParaTime).Emerald:
            return t('paraTimes.common.emerald', 'Emerald');
        case (0, _config.ParaTime).Sapphire:
            return t('paraTimes.common.sapphire', 'Sapphire');
        default:
            throw new (0, _errors.ExhaustedTypeError)(t('paraTimes.validation.unsupportedParaTime', 'Unsupported ParaTime'), paraTime);
    }
};

},{"types/errors":"gbx4q","../../../config":"akiw0","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"66Nbe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParaTimeTransferType", ()=>ParaTimeTransferType);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _text = require("grommet/es6/components/Text");
var _reactI18Next = require("react-i18next");
var _paraTimeContent = require("../ParaTimeContent");
var _useParaTimes = require("../useParaTimes");
var _useParaTimesNavigation = require("../useParaTimesNavigation");
const ParaTimeTransferType = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { accountIsLoading, isWalletEmpty, ticker } = (0, _useParaTimes.useParaTimes)();
    const { navigateToDeposit, navigateToWithdraw } = (0, _useParaTimesNavigation.useParaTimesNavigation)();
    const disabled = !accountIsLoading && isWalletEmpty;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimeContent.ParaTimeContent), {
        header: t('paraTimes.common.header', 'ParaTime Transfers'),
        description: t('paraTimes.transfers.description', 'Click on the "{{depositButtonLabel}}" button to deposit your {{ticker}} from consensus to a ParaTime of your choice or "{{withdrawButtonLabel}}" to withdraw your {{ticker}} from a ParaTime back to consensus.', {
            ticker,
            depositButtonLabel: t('paraTimes.transfers.deposit', 'Deposit to ParaTime'),
            withdrawButtonLabel: t('paraTimes.transfers.withdraw', 'Withdraw from ParaTime')
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            gap: "medium",
            responsive: false,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            disabled: disabled,
                            fill: "horizontal",
                            label: t('paraTimes.transfers.deposit', 'Deposit to ParaTime'),
                            onClick: navigateToDeposit,
                            primary: true
                        }),
                        disabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                            size: "small",
                            margin: {
                                top: 'xsmall'
                            },
                            children: t('paraTimes.transfers.depositDisabled', "You don't have any {{ticker}} tokens to transfer", {
                                ticker
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                    fill: "horizontal",
                    label: t('paraTimes.transfers.withdraw', 'Withdraw from ParaTime'),
                    onClick: navigateToWithdraw
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Text":"kz1Ni","react-i18next":"7GUHL","../ParaTimeContent":"b3Bev","../useParaTimes":"kRFDd","../useParaTimesNavigation":"70fv0","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"jwfzk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParaTimeSelection", ()=>ParaTimeSelection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("grommet/es6/components/Box");
var _form = require("grommet/es6/components/Form");
var _formField = require("grommet/es6/components/FormField");
var _text = require("grommet/es6/components/Text");
var _select = require("grommet/es6/components/Select");
var _reactI18Next = require("react-i18next");
var _paraTimeContent = require("../ParaTimeContent");
var _paraTimeFormFooter = require("../ParaTimeFormFooter");
var _useParaTimes = require("../useParaTimes");
var _getParaTimeName = require("../getParaTimeName");
var _useParaTimesNavigation = require("../useParaTimesNavigation");
var _styledComponents = require("styled-components");
const ParaTimeOption = ({ label, isEvm })=>{
    const theme = (0, _react.useContext)((0, _styledComponents.ThemeContext));
    const { t } = (0, _reactI18Next.useTranslation)();
    const paddingToMatchPlaceholder = theme.global?.input?.padding;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        direction: "row",
        justify: "between",
        width: "240px",
        pad: paddingToMatchPlaceholder,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                children: label
            }),
            isEvm && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                color: "lightText",
                children: t('paraTimes.selection.evmc', 'EVMc')
            })
        ]
    });
};
const ParaTimeSelection = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { availableParaTimesForSelectedNetwork, clearTransactionForm, isDepositing, setTransactionForm, ticker, transactionForm } = (0, _useParaTimes.useParaTimes)();
    const { navigateToRecipient } = (0, _useParaTimesNavigation.useParaTimesNavigation)();
    const options = availableParaTimesForSelectedNetwork.map((item)=>({
            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ParaTimeOption, {
                label: (0, _getParaTimeName.getParaTimeName)(t, item.value),
                isEvm: item.isEvm
            }),
            value: item.value
        }));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimeContent.ParaTimeContent), {
        description: isDepositing ? t('paraTimes.selection.depositDescription', 'Please select which ParaTime you wish to deposit your {{ticker}} to and then click "{{nextButtonLabel}}".', {
            ticker,
            nextButtonLabel: t('paraTimes.footer.next', 'Next')
        }) : t('paraTimes.selection.withdrawDescription', 'Please select which ParaTime you wish to withdraw your {{ticker}} from and then click "{{nextButtonLabel}}".', {
            ticker,
            nextButtonLabel: t('paraTimes.footer.next', 'Next')
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
            messages: {
                required: t('paraTimes.validation.required', 'Field is required')
            },
            onChange: (nextValue)=>setTransactionForm(nextValue),
            onSubmit: navigateToRecipient,
            value: transactionForm,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                    style: {
                        maxWidth: 'min(100%, 300px)',
                        margin: '0 auto'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        margin: {
                            bottom: 'medium'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
                            name: "paraTime",
                            required: true,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _select.Select), {
                                name: "paraTime",
                                placeholder: t('paraTimes.selection.select', 'Select a ParaTime'),
                                labelKey: "label",
                                valueKey: {
                                    key: 'value',
                                    reduce: true
                                },
                                value: transactionForm.paraTime,
                                options: options
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimeFormFooter.ParaTimeFormFooter), {
                    secondaryAction: clearTransactionForm,
                    secondaryLabel: t('paraTimes.selection.cancel', 'Cancel transfer'),
                    submitButton: true,
                    withNotice: true
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","grommet/es6/components/Box":"4o01A","grommet/es6/components/Form":"kRCRN","grommet/es6/components/FormField":"dcsVI","grommet/es6/components/Text":"kz1Ni","grommet/es6/components/Select":"glb1P","react-i18next":"7GUHL","../ParaTimeContent":"b3Bev","../ParaTimeFormFooter":"gAxgp","../useParaTimes":"kRFDd","../getParaTimeName":"4b62n","../useParaTimesNavigation":"70fv0","styled-components":"6bGrk","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gAxgp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ParaTimeFormFooter", ()=>ParaTimeFormFooter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _text = require("grommet/es6/components/Text");
var _reactI18Next = require("react-i18next");
const ParaTimeFormFooter = ({ disabled, primaryLabel, primaryAction, secondaryLabel, secondaryAction, submitButton, withNotice })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                margin: {
                    bottom: 'large'
                },
                align: "center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        margin: {
                            bottom: 'medium'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            disabled: disabled,
                            fill: "horizontal",
                            label: primaryLabel || t('paraTimes.footer.next', 'Next'),
                            onClick: primaryAction,
                            primary: true,
                            type: submitButton ? 'submit' : 'button'
                        })
                    }),
                    secondaryAction && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        label: secondaryLabel || t('paraTimes.footer.back', 'Back'),
                        onClick: secondaryAction,
                        plain: true,
                        style: {
                            textAlign: 'center',
                            fontSize: '14px',
                            textDecoration: 'underline'
                        }
                    })
                ]
            }),
            withNotice && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                size: "small",
                children: t('paraTimes.footer.notice', '* EVMc - compatible with Ethereum Virtual Machine')
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Text":"kz1Ni","react-i18next":"7GUHL","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6AivA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionRecipient", ()=>TransactionRecipient);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("grommet/es6/components/Box");
var _form = require("grommet/es6/components/Form");
var _formField = require("grommet/es6/components/FormField");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _textInput = require("grommet/es6/components/TextInput");
var _reactI18Next = require("react-i18next");
var _helpers = require("app/lib/helpers");
var _ethHelpers = require("app/lib/eth-helpers");
var _paraTimeContent = require("../ParaTimeContent");
var _paraTimeFormFooter = require("../ParaTimeFormFooter");
var _useParaTimes = require("../useParaTimes");
var _useParaTimesNavigation = require("../useParaTimesNavigation");
var _passwordField = require("app/components/PasswordField");
var _preventSavingInputsToUserData = require("app/lib/preventSavingInputsToUserData");
var _ethHelpers1 = require("../../../lib/eth-helpers");
const TransactionRecipient = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    const { accountAddress, clearTransactionForm, evmAccounts, isDepositing, isEvmcParaTime, paraTimeName, setTransactionForm, transactionForm, usesOasisAddress } = (0, _useParaTimes.useParaTimes)();
    const { navigateToAmount } = (0, _useParaTimesNavigation.useParaTimesNavigation)();
    const addressValidator = usesOasisAddress ? (0, _helpers.isValidAddress) : (0, _ethHelpers.isValidEthAddress);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimeContent.ParaTimeContent), {
        description: isDepositing ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            i18nKey: "paraTimes.recipient.depositDescription",
            t: t,
            values: {
                paratimeType: isEvmcParaTime ? t('paraTimes.common.evmcType', '(EVMc)') : '',
                paraTime: paraTimeName,
                nextButtonLabel: t('paraTimes.footer.next', 'Next')
            },
            defaults: 'Please enter the recipient address on <strong>{{paraTime}}</strong> {{paratimeType}} and then click "{{nextButtonLabel}}"'
        }) : isEvmcParaTime ? t('paraTimes.recipient.evmcWithdrawDescription', 'Please enter the private key of the account on ParaTime, the recipient address on consensus and click "{{nextButtonLabel}}"', {
            nextButtonLabel: t('paraTimes.footer.next', 'Next')
        }) : t('paraTimes.recipient.withdrawDescription', 'Please enter the recipient address on consensus and click "{{nextButtonLabel}}"', {
            nextButtonLabel: t('paraTimes.footer.next', 'Next')
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
            messages: {
                required: t('paraTimes.validation.required', 'Field is required')
            },
            onChange: (nextValue)=>setTransactionForm({
                    ...nextValue,
                    ethPrivateKeyRaw: typeof nextValue.ethPrivateKeyRaw === 'object' ? nextValue.ethPrivateKeyRaw.value // from suggestions
                     : nextValue.ethPrivateKeyRaw
                }),
            onSubmit: (formData)=>{
                setTransactionForm({
                    ...formData.value,
                    ethPrivateKey: (0, _ethHelpers1.stripHexPrefix)(formData.value.ethPrivateKeyRaw)
                });
                navigateToAmount();
            },
            value: transactionForm,
            style: {
                width: isMobile ? '100%' : '465px'
            },
            ...(0, _preventSavingInputsToUserData.preventSavingInputsToUserData),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    margin: {
                        bottom: 'medium'
                    },
                    children: [
                        isEvmcParaTime && !isDepositing && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _passwordField.PasswordField), {
                            inputElementId: "ethPrivateKeyRaw",
                            name: "ethPrivateKeyRaw",
                            validate: (ethPrivateKeyRaw)=>!(0, _ethHelpers.isValidEthPrivateKeyLength)((0, _ethHelpers1.stripHexPrefix)(ethPrivateKeyRaw)) ? t('paraTimes.validation.invalidEthPrivateKeyLength', 'Private key should be 64 characters long') : !(0, _ethHelpers.isValidEthPrivateKey)((0, _ethHelpers1.stripHexPrefix)(ethPrivateKeyRaw)) ? t('paraTimes.validation.invalidEthPrivateKey', 'Ethereum-compatible private key is invalid') : undefined,
                            placeholder: t('paraTimes.recipient.ethPrivateKeyPlaceholder', 'Enter Ethereum-compatible private key'),
                            value: transactionForm.ethPrivateKeyRaw,
                            showTip: t('openWallet.privateKey.showPrivateKey', 'Show private key'),
                            hideTip: t('openWallet.privateKey.hidePrivateKey', 'Hide private key'),
                            suggestions: [
                                ...evmAccounts.length > 0 ? [
                                    {
                                        label: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                            pad: "small",
                                            style: {
                                                fontWeight: 'bold'
                                            },
                                            onClick: (e)=>e.stopPropagation(),
                                            children: t('paraTimes.recipient.ethPrivateKeySelectInstructions', 'Type a private key or select a previously entered ParaTime account')
                                        }),
                                        value: ''
                                    }
                                ] : [],
                                ...evmAccounts.map((acc)=>({
                                        label: acc.ethAddress,
                                        value: acc.ethPrivateKey
                                    }))
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
                            name: "recipient",
                            required: true,
                            validate: (recipient)=>addressValidator(recipient) ? undefined : {
                                    message: t('errors.invalidAddress', 'Invalid address'),
                                    status: 'error'
                                },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInput.TextInput), {
                                "aria-label": t('account.sendTransaction.recipient', 'Recipient'),
                                name: "recipient",
                                suggestions: usesOasisAddress ? [] : evmAccounts.map((acc)=>acc.ethAddress),
                                placeholder: usesOasisAddress ? accountAddress : t('paraTimes.recipient.placeholder', '0x...'),
                                value: transactionForm.recipient
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimeFormFooter.ParaTimeFormFooter), {
                    secondaryAction: clearTransactionForm,
                    secondaryLabel: t('paraTimes.selection.cancel', 'Cancel transfer'),
                    submitButton: true,
                    withNotice: isEvmcParaTime
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","grommet/es6/components/Box":"4o01A","grommet/es6/components/Form":"kRCRN","grommet/es6/components/FormField":"dcsVI","grommet/es6/contexts/ResponsiveContext":"7EsNN","grommet/es6/components/TextInput":"cL4wi","react-i18next":"7GUHL","app/lib/helpers":"bUnFy","app/lib/eth-helpers":"gcAe1","../ParaTimeContent":"b3Bev","../ParaTimeFormFooter":"gAxgp","../useParaTimes":"kRFDd","../useParaTimesNavigation":"70fv0","app/components/PasswordField":"hEUcp","app/lib/preventSavingInputsToUserData":"idfdE","../../../lib/eth-helpers":"gcAe1","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"iTyKn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionAmount", ()=>TransactionAmount);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _bignumberJs = require("bignumber.js");
var _bignumberJsDefault = parcelHelpers.interopDefault(_bignumberJs);
var _reactRedux = require("react-redux");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _form = require("grommet/es6/components/Form");
var _formField = require("grommet/es6/components/FormField");
var _text = require("grommet/es6/components/Text");
var _textInput = require("grommet/es6/components/TextInput");
var _tip = require("grommet/es6/components/Tip");
var _reactI18Next = require("react-i18next");
var _helpers = require("app/lib/helpers");
var _paratimes = require("app/state/paratimes");
var _alertBox = require("app/components/AlertBox");
var _amountFormatter = require("../../../components/AmountFormatter");
var _paraTimeContent = require("../ParaTimeContent");
var _paraTimeFormFooter = require("../ParaTimeFormFooter");
var _useParaTimes = require("../useParaTimes");
var _useParaTimesNavigation = require("../useParaTimesNavigation");
var _feesSection = require("./FeesSection");
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _utils = require("grommet/es6/utils");
var _config = require("../../../../config");
const StyledMaxButton = (0, _styledComponentsDefault.default)((0, _button.Button))`
  position: absolute;
  top: 10px;
  right: 0;
  z-index: 2;
  background-color: ${({ theme })=>(0, _utils.normalizeColor)('background-front', theme)};
  font-weight: bold;
`;
const getMaxAmount = (isDepositing, layerDecimals, balance, feeAmount)=>{
    const shiftBy = isDepositing ? (0, _config.consensusDecimals) : layerDecimals;
    const fee = (0, _helpers.parseConsensusToLayerBaseUnit)(feeAmount, shiftBy);
    const maxAmount = new (0, _bignumberJsDefault.default)(balance).minus(fee).shiftedBy(-shiftBy);
    // Make value valid for Consensus input
    return maxAmount.decimalPlaces((0, _config.consensusDecimals), (0, _bignumberJsDefault.default).ROUND_DOWN).toFixed();
};
const TransactionAmount = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const { balance, balanceInBaseUnit, isDepositing, isEvmcParaTime, isLoading, isWalletEmpty, paraTimeConfig, paraTimeName, setTransactionForm, ticker, transactionForm } = (0, _useParaTimes.useParaTimes)();
    const { navigateToRecipient, navigateToConfirmation } = (0, _useParaTimesNavigation.useParaTimesNavigation)();
    const disabled = !isLoading && isWalletEmpty;
    const defaultFeeAmount = (0, _helpers.getDefaultFeeAmount)(isDepositing, paraTimeConfig);
    (0, _react.useEffect)(()=>{
        if (isDepositing) return;
        dispatch(isEvmcParaTime ? (0, _paratimes.paraTimesActions).fetchBalanceUsingEthPrivateKey() : (0, _paratimes.paraTimesActions).fetchBalanceUsingOasisAddress());
    }, [
        dispatch,
        isDepositing,
        isEvmcParaTime
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paraTimeContent.ParaTimeContent), {
        description: isDepositing ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            i18nKey: "paraTimes.amount.depositDescription",
            t: t,
            values: {
                paratimeType: isEvmcParaTime ? t('paraTimes.common.evmcType', '(EVMc)') : '',
                paraTime: paraTimeName,
                ticker,
                nextButtonLabel: t('paraTimes.footer.next', 'Next')
            },
            defaults: 'Please enter the amount of {{ticker}} to deposit and then click "{{nextButtonLabel}}"'
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            i18nKey: "paraTimes.amount.withdrawDescription",
            t: t,
            values: {
                paratimeType: isEvmcParaTime ? t('paraTimes.common.evmcType', '(EVMc)') : '',
                paraTime: paraTimeName,
                ticker,
                nextButtonLabel: t('paraTimes.footer.next', 'Next')
            },
            defaults: 'Please enter the amount of {{ticker}} to withdraw and then click "{{nextButtonLabel}}"'
        }),
        isLoading: isLoading,
        children: [
            disabled && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBox.AlertBox), {
                status: "warning",
                children: t('paraTimes.amount.emptyAccount', 'The account is empty. There is nothing to withdraw.')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                margin: {
                    bottom: 'medium'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
                    messages: {
                        required: t('paraTimes.validation.required', 'Field is required')
                    },
                    noValidate: true,
                    onChange: (nextValue)=>setTransactionForm(nextValue),
                    onSubmit: ()=>{
                        setTransactionForm({
                            ...transactionForm,
                            defaultFeeAmount
                        });
                        navigateToConfirmation();
                    },
                    value: transactionForm,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                            margin: {
                                bottom: 'small'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                                    width: "medium",
                                    direction: "row",
                                    margin: "none",
                                    align: "center",
                                    style: {
                                        position: 'relative'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
                                            name: "amount",
                                            style: {
                                                width: '100%'
                                            },
                                            required: true,
                                            validate: [
                                                (amount)=>!new RegExp(`^\\d*(?:[.][0-9]{0,${(0, _config.consensusDecimals)}})?$`).test(amount) ? {
                                                        message: t('paraTimes.validation.invalidDecimalValue', 'Maximum of {{decimals}} decimal places is allowed', {
                                                            decimals: (0, _config.consensusDecimals)
                                                        }),
                                                        status: 'error'
                                                    } : undefined,
                                                (amount)=>(0, _helpers.isAmountGreaterThan)(amount, getMaxAmount(isDepositing, paraTimeConfig.decimals, balance, '0')) ? {
                                                        message: t('errors.insufficientBalance', 'Insufficient balance'),
                                                        status: 'error'
                                                    } : undefined,
                                                (amount)=>(0, _helpers.isAmountGreaterThan)(amount, getMaxAmount(isDepositing, paraTimeConfig.decimals, balance, transactionForm.feeAmount || defaultFeeAmount)) ? {
                                                        message: t('paraTimes.validation.insufficientBalanceToPayFee', 'Insufficient balance to pay the fee'),
                                                        status: 'error'
                                                    } : undefined
                                            ],
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInput.TextInput), {
                                                "aria-label": t('common.amount', 'Amount'),
                                                disabled: disabled,
                                                inputMode: "decimal",
                                                name: "amount",
                                                placeholder: "0",
                                                value: transactionForm.amount
                                            })
                                        }),
                                        balance && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tip.Tip), {
                                            content: t('paraTimes.amount.tooltip', 'Max value may be decreased by the fee'),
                                            dropProps: {
                                                align: {
                                                    bottom: 'top'
                                                }
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StyledMaxButton, {
                                                disabled: disabled,
                                                plain: true,
                                                label: t('paraTimes.amount.max', 'MAX'),
                                                onClick: ()=>setTransactionForm({
                                                        ...transactionForm,
                                                        amount: getMaxAmount(isDepositing, paraTimeConfig.decimals, balance, transactionForm.feeAmount || defaultFeeAmount)
                                                    })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                    align: "end",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _text.Text), {
                                        weight: "bolder",
                                        size: "small",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                children: [
                                                    t('paraTimes.amount.available', 'Available:'),
                                                    " "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amountFormatter.AmountFormatter), {
                                                amount: balance,
                                                smallTicker: true,
                                                amountUnit: balanceInBaseUnit ? 'baseUnits' : 'wei'
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _feesSection.FeesSection), {
                            feeAmount: transactionForm.feeAmount,
                            feeGas: transactionForm.feeGas,
                            ticker: ticker
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimeFormFooter.ParaTimeFormFooter), {
                            disabled: disabled,
                            secondaryAction: navigateToRecipient,
                            submitButton: true,
                            withNotice: isEvmcParaTime
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","bignumber.js":"a7tdL","react-redux":"azV3Y","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Form":"kRCRN","grommet/es6/components/FormField":"dcsVI","grommet/es6/components/Text":"kz1Ni","grommet/es6/components/TextInput":"cL4wi","grommet/es6/components/Tip":"55RvR","react-i18next":"7GUHL","app/lib/helpers":"bUnFy","app/state/paratimes":"63sI2","app/components/AlertBox":"ivux6","../../../components/AmountFormatter":"dRP3j","../ParaTimeContent":"b3Bev","../ParaTimeFormFooter":"gAxgp","../useParaTimes":"kRFDd","../useParaTimesNavigation":"70fv0","./FeesSection":"7xiL7","styled-components":"6bGrk","grommet/es6/utils":"fx31z","../../../../config":"akiw0","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"7xiL7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FeesSection", ()=>FeesSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _collapsible = require("grommet/es6/components/Collapsible");
var _formField = require("grommet/es6/components/FormField");
var _textInput = require("grommet/es6/components/TextInput");
var _reactI18Next = require("react-i18next");
var _usePreventChangeOnNumberInputScroll = require("app/lib/usePreventChangeOnNumberInputScroll");
const FeesSection = ({ feeAmount, feeGas, ticker })=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const hasValue = !!feeAmount || !!feeGas;
    const [open, setOpen] = (0, _react.useState)(hasValue);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        pad: {
            vertical: 'medium'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                align: "start",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                    disabled: hasValue,
                    label: t('paraTimes.amount.advanced', 'Advanced'),
                    margin: {
                        bottom: 'medium'
                    },
                    onClick: ()=>setOpen(!open),
                    secondary: true,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _collapsible.Collapsible), {
                open: open,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
                        name: "feeAmount",
                        validate: {
                            regexp: /^(\s*|[0-9][0-9]*)$/,
                            message: t('paraTimes.validation.invalidFee', 'Value must be integer greater than or equal to 0')
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInput.TextInput), {
                            min: "0",
                            name: "feeAmount",
                            placeholder: t('paraTimes.amount.feeAmountPlaceholder', 'Fee Amount (nano {{ticker}})', {
                                ticker
                            }),
                            step: "1",
                            type: "number",
                            value: feeAmount,
                            ...(0, _usePreventChangeOnNumberInputScroll.usePreventChangeOnNumberInputScroll)()
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
                        name: "feeGas",
                        validate: {
                            regexp: /^(\s*|[0-9][0-9]*)$/,
                            message: t('paraTimes.validation.invalidFee', 'Value must be integer greater than or equal to 0')
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textInput.TextInput), {
                            min: "0",
                            name: "feeGas",
                            placeholder: t('paraTimes.amount.feeGasPlaceholder', 'Fee Gas'),
                            step: "1",
                            type: "number",
                            value: feeGas,
                            ...(0, _usePreventChangeOnNumberInputScroll.usePreventChangeOnNumberInputScroll)()
                        })
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Collapsible":"5JAvN","grommet/es6/components/FormField":"dcsVI","grommet/es6/components/TextInput":"cL4wi","react-i18next":"7GUHL","app/lib/usePreventChangeOnNumberInputScroll":"10t9P","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5JAvN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Collapsible", ()=>(0, _collapsible.Collapsible));
var _collapsible = require("./Collapsible");

},{"./Collapsible":"6Qii4","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"6Qii4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Collapsible", ()=>Collapsible);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _styledComponents = require("styled-components");
var _styledComponentsDefault = parcelHelpers.interopDefault(_styledComponents);
var _useIsomorphicLayoutEffect = require("../../utils/use-isomorphic-layout-effect");
var _utils = require("../../utils");
var _box = require("../Box");
var _propTypes = require("./propTypes");
var _useThemeValue = require("../../utils/useThemeValue");
var AnimatedBox = (0, _styledComponentsDefault.default)((0, _box.Box)).withConfig({
    displayName: "Collapsible__AnimatedBox",
    componentId: "sc-15kniua-0"
})([
    "",
    ""
], function(props) {
    return props.shouldOpen ? "visibility: hidden;\n      position: absolute;\n      pointer-events: none;" : "transition: " + ("max-" + props.dimension + " " + props.speedProp + "ms, opacity " + props.speedProp + "ms") + ";\n      opacity: " + (props.open ? 1 : 0) + ";\n      overflow: " + (props.animate || !props.open ? 'hidden' : 'visible') + ";";
});
var Collapsible = /*#__PURE__*/ (0, _react.forwardRef)(function(_ref, ref) {
    var children = _ref.children, direction = _ref.direction, openArg = _ref.open;
    var _useThemeValue1 = (0, _useThemeValue.useThemeValue)(), theme = _useThemeValue1.theme;
    var _useState = (0, _react.useState)(openArg), open = _useState[0], setOpen = _useState[1];
    var _useState2 = (0, _react.useState)(false), animate = _useState2[0], setAnimate = _useState2[1];
    var _useState3 = (0, _react.useState)(theme.collapsible.minSpeed), speed = _useState3[0], setSpeed = _useState3[1];
    var dimension = (0, _react.useMemo)(function() {
        return direction === 'horizontal' ? 'width' : 'height';
    }, [
        direction
    ]);
    var containerRef = (0, _utils.useForwardedRef)(ref);
    var sizeRef = (0, _react.useRef)(0);
    var shouldOpen = !open && openArg;
    var shouldClose = open && !openArg;
    // when the caller changes openArg, trigger animation
    (0, _react.useEffect)(function() {
        if (openArg !== open) {
            setAnimate(true);
            setOpen(openArg);
        }
    }, [
        open,
        openArg
    ]);
    // prepare to open or close
    (0, _useIsomorphicLayoutEffect.useLayoutEffect)(function() {
        var container = containerRef.current;
        // skip this if animation is in progress
        if (!animate && shouldOpen) {
            var parentPrevPosition = container.parentNode.style.position;
            container.parentNode.style.position = 'relative';
            var _container$getBoundin = container.getBoundingClientRect(), size = _container$getBoundin[dimension];
            container.parentNode.style.position = parentPrevPosition;
            sizeRef.current = size;
        }
        if (shouldOpen) container.style["max-" + dimension] = 0;
        else if (shouldClose) {
            var _container$getBoundin2 = container.getBoundingClientRect(), _size = _container$getBoundin2[dimension];
            container.style["max-" + dimension] = _size + "px";
        }
    }, [
        shouldOpen,
        shouldClose,
        containerRef,
        dimension,
        animate
    ]);
    (0, _react.useEffect)(function() {
        if (shouldOpen || shouldClose) {
            var container = containerRef.current;
            var _theme$collapsible = theme.collapsible, minSpeed = _theme$collapsible.minSpeed, baseline = _theme$collapsible.baseline;
            var nextSpeed = Math.max(sizeRef.current / baseline * minSpeed, minSpeed);
            setSpeed(nextSpeed);
            requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    // Change the max to where we want to end up, the transition will
                    // animate to get there. We do this in an animation frame to
                    // give our starter setting a chance to fully render.
                    container.style["max-" + dimension] = shouldOpen ? sizeRef.current + "px" : 0;
                });
            });
        }
    }, [
        shouldOpen,
        shouldClose,
        containerRef,
        dimension,
        theme
    ]);
    (0, _react.useEffect)(function() {
        if (animate) {
            var container = containerRef.current;
            var timer = setTimeout(function() {
                setAnimate(false);
                container.removeAttribute('style');
            }, speed);
            return function() {
                return clearTimeout(timer);
            };
        }
        return undefined;
    // we need open here to cancel the timer and restart it
    }, [
        animate,
        containerRef,
        speed,
        open
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(AnimatedBox, {
        "aria-hidden": !open,
        ref: containerRef,
        open: open,
        animate: animate,
        dimension: dimension,
        speedProp: speed,
        shouldOpen: !animate && shouldOpen
    }, shouldOpen || open || animate ? children : null);
});
Collapsible.displayName = 'Collapsible';
Collapsible.propTypes = (0, _propTypes.CollapsiblePropTypes);

},{"react":"8CCva","styled-components":"6bGrk","../../utils/use-isomorphic-layout-effect":"jThNw","../../utils":"fx31z","../Box":"4o01A","./propTypes":"gi0kw","../../utils/useThemeValue":"6LfDQ","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"gi0kw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CollapsiblePropTypes", ()=>CollapsiblePropTypes);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var PropType = {};
var CollapsiblePropTypes = PropType;

},{"prop-types":"j03Ye","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"aicWa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfirmationCheckbox", ()=>ConfirmationCheckbox);
parcelHelpers.export(exports, "TransactionConfirmation", ()=>TransactionConfirmation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _box = require("grommet/es6/components/Box");
var _checkBox = require("grommet/es6/components/CheckBox");
var _form = require("grommet/es6/components/Form");
var _formField = require("grommet/es6/components/FormField");
var _text = require("grommet/es6/components/Text");
var _responsiveContext = require("grommet/es6/contexts/ResponsiveContext");
var _reactI18Next = require("react-i18next");
var _selectors = require("app/state/staking/selectors");
var _selectors1 = require("app/state/wallet/selectors");
var _alertBox = require("app/components/AlertBox");
var _paraTimeContent = require("../ParaTimeContent");
var _paraTimeFormFooter = require("../ParaTimeFormFooter");
var _useParaTimes = require("../useParaTimes");
var _useParaTimesNavigation = require("../useParaTimesNavigation");
const ConfirmationCheckbox = ({ checked, description, label, name, warning })=>{
    const isMobile = (0, _react.useContext)((0, _responsiveContext.ResponsiveContext)) === 'small';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        margin: {
            bottom: 'medium'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                margin: {
                    bottom: 'small'
                },
                responsive: false,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBox.AlertBox), {
                    status: warning ? 'warning' : 'error',
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                        textAlign: "center",
                        size: isMobile ? '16px' : 'medium',
                        children: description
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _formField.FormField), {
                name: name,
                required: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkBox.CheckBox), {
                    checked: checked,
                    label: label,
                    name: name
                })
            })
        ]
    });
};
const TransactionConfirmation = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const validators = (0, _reactRedux.useSelector)((0, _selectors.selectValidators));
    const walletsAddresses = (0, _reactRedux.useSelector)((0, _selectors1.selectWalletsAddresses));
    const { isDepositing, isEvmcParaTime, isLoading, paraTimeName, setTransactionForm, submitTransaction, ticker, transactionForm, usesOasisAddress } = (0, _useParaTimes.useParaTimes)();
    const { navigateToAmount } = (0, _useParaTimesNavigation.useParaTimesNavigation)();
    const confirmTransferToValidator = usesOasisAddress && validators.some((validator)=>validator.address === transactionForm.recipient);
    const confirmTransferToForeignAccount = !confirmTransferToValidator && usesOasisAddress && !walletsAddresses.includes(transactionForm.recipient);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimeContent.ParaTimeContent), {
        description: isDepositing ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            i18nKey: "paraTimes.confirmation.depositDescription",
            t: t,
            values: {
                address: transactionForm.recipient,
                paratimeType: isEvmcParaTime ? t('paraTimes.common.evmcType', '(EVMc)') : '',
                paraTime: paraTimeName,
                ticker,
                value: transactionForm.amount
            },
            defaults: "You are about to deposit <strong>{{value}} {{ticker}}</strong> to <strong>{{address}}</strong> on <strong>{{paraTime}}</strong> {{paratimeType}}"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            i18nKey: "paraTimes.confirmation.withdrawDescription",
            t: t,
            values: {
                address: transactionForm.recipient,
                paratimeType: isEvmcParaTime ? t('paraTimes.common.evmcType', '(EVMc)') : '',
                paraTime: paraTimeName,
                ticker,
                value: transactionForm.amount
            },
            defaults: "You are about to withdraw <strong>{{value}} {{ticker}}</strong> from <strong>{{paraTime}}</strong> {{paratimeType}} to <strong>{{address}}</strong>"
        }),
        isLoading: isLoading,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _form.Form), {
            messages: {
                required: t('paraTimes.validation.required', 'Field is required')
            },
            onChange: (nextValue)=>setTransactionForm(nextValue),
            onSubmit: submitTransaction,
            value: transactionForm,
            children: [
                confirmTransferToValidator && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConfirmationCheckbox, {
                    checked: transactionForm.confirmTransferToValidator,
                    description: t('account.sendTransaction.confirmSendingToValidator.description', 'This is a validator address. Transfers to this address do not stake your funds with the validator.'),
                    label: t('paraTimes.confirmation.confirmTransferToValidatorLabel', 'I confirm I want to transfer {{ticker}} to a validator address', {
                        ticker
                    }),
                    name: "confirmTransferToValidator"
                }),
                confirmTransferToForeignAccount && /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConfirmationCheckbox, {
                    checked: transactionForm.confirmTransferToForeignAccount,
                    description: isDepositing ? t('paraTimes.confirmation.confirmDepositToForeignAccountDescription', 'Destination address does not match any of the accounts in your wallet! Some services such as exchanges, may not support direct deposits to fund your account. For better compatibility, we strongly recommend that you first deposit to your ParaTime account and then transfer {{ticker}} to the destination address.', {
                        ticker
                    }) : t('paraTimes.confirmation.confirmWithdrawToForeignAccountDescription', 'Destination address does not match any of the accounts in your wallet! Some services such as exchanges, may not support direct withdrawals to fund the account. For better compatibility, we strongly recommend that you first withdraw to your consensus account and then transfer {{ticker}} to the destination address.', {
                        ticker
                    }),
                    label: t('paraTimes.confirmation.confirmTransferToForeignAccount', 'I confirm I want to directly withdraw to an external account'),
                    name: "confirmTransferToForeignAccount"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConfirmationCheckbox, {
                    checked: transactionForm.confirmTransfer,
                    description: isDepositing ? t('paraTimes.confirmation.confirmDepositDescription', 'Please confirm the deposit amount and the recipient address are correct and then click "{{nextButtonLabel}}".', {
                        nextButtonLabel: t('paraTimes.confirmation.depositLabel', 'Deposit')
                    }) : t('paraTimes.confirmation.confirmWithdrawDescription', 'Please confirm the withdrawal amount and the recipient address are correct and then click "{{nextButtonLabel}}".', {
                        nextButtonLabel: t('paraTimes.confirmation.withdrawLabel', 'Withdraw')
                    }),
                    label: t('paraTimes.confirmation.confirmTransferLabel', 'I confirm the amount and the address are correct'),
                    name: "confirmTransfer",
                    warning: true
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimeFormFooter.ParaTimeFormFooter), {
                    primaryLabel: isDepositing ? t('paraTimes.confirmation.depositLabel', 'Deposit') : t('paraTimes.confirmation.withdrawLabel', 'Withdraw'),
                    secondaryAction: navigateToAmount,
                    submitButton: true,
                    withNotice: isEvmcParaTime
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-redux":"azV3Y","grommet/es6/components/Box":"4o01A","grommet/es6/components/CheckBox":"gaRRO","grommet/es6/components/Form":"kRCRN","grommet/es6/components/FormField":"dcsVI","grommet/es6/components/Text":"kz1Ni","grommet/es6/contexts/ResponsiveContext":"7EsNN","react-i18next":"7GUHL","app/state/staking/selectors":"jY45G","app/state/wallet/selectors":"cgtJ3","app/components/AlertBox":"ivux6","../ParaTimeContent":"b3Bev","../ParaTimeFormFooter":"gAxgp","../useParaTimes":"kRFDd","../useParaTimesNavigation":"70fv0","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"bDFL1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionSummary", ()=>TransactionSummary);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _box = require("grommet/es6/components/Box");
var _statusGood = require("grommet-icons/es6/icons/StatusGood");
var _paraTimeContent = require("../ParaTimeContent");
var _paraTimeFormFooter = require("../ParaTimeFormFooter");
var _useParaTimes = require("../useParaTimes");
const TransactionSummary = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { isDepositing, isEvmcParaTime, paraTimeName, clearTransactionForm, ticker, transactionForm } = (0, _useParaTimes.useParaTimes)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paraTimeContent.ParaTimeContent), {
        description: isDepositing ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            i18nKey: "paraTimes.summary.depositDescription",
            t: t,
            values: {
                address: transactionForm.recipient,
                paratimeType: isEvmcParaTime ? t('paraTimes.common.evmcType', '(EVMc)') : '',
                paraTime: paraTimeName,
                ticker,
                value: transactionForm.amount
            },
            defaults: "You have successfully deposited <strong>{{value}} {{ticker}}</strong> to <strong>{{address}}</strong> on <strong>{{paraTime}}</strong> {{paratimeType}}"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            i18nKey: "paraTimes.summary.withdrawDescription",
            t: t,
            values: {
                address: transactionForm.recipient,
                paratimeType: isEvmcParaTime ? t('paraTimes.common.evmcType', '(EVMc)') : '',
                paraTime: paraTimeName,
                ticker,
                value: transactionForm.amount
            },
            defaults: "You have successfully withdrawn <strong>{{value}} {{ticker}}</strong> from <strong>{{paraTime}}</strong> {{paratimeType}} to <strong>{{address}}</strong>"
        }),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                margin: {
                    bottom: 'medium'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusGood.StatusGood), {
                    size: "80px",
                    color: "successful-label"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimeFormFooter.ParaTimeFormFooter), {
                primaryLabel: t('paraTimes.summary.navigate', 'Navigate to ParaTime Transfers'),
                primaryAction: clearTransactionForm,
                withNotice: isEvmcParaTime
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-i18next":"7GUHL","grommet/es6/components/Box":"4o01A","grommet-icons/es6/icons/StatusGood":"3yaWj","../ParaTimeContent":"b3Bev","../ParaTimeFormFooter":"gAxgp","../useParaTimes":"kRFDd","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lagoR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TransactionError", ()=>TransactionError);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactI18Next = require("react-i18next");
var _statusCritical = require("grommet-icons/es6/icons/StatusCritical");
var _box = require("grommet/es6/components/Box");
var _alertBox = require("app/components/AlertBox");
var _errorFormatter = require("app/components/ErrorFormatter");
var _paraTimeContent = require("../ParaTimeContent");
var _paraTimeFormFooter = require("../ParaTimeFormFooter");
var _useParaTimes = require("../useParaTimes");
var _useParaTimesNavigation = require("../useParaTimesNavigation");
const TransactionError = ()=>{
    const { t } = (0, _reactI18Next.useTranslation)();
    const { clearTransactionForm, isDepositing, isEvmcParaTime, paraTimeName, ticker, transactionError, transactionForm } = (0, _useParaTimes.useParaTimes)();
    const { navigateToConfirmation } = (0, _useParaTimesNavigation.useParaTimesNavigation)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _paraTimeContent.ParaTimeContent), {
        description: isDepositing ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            i18nKey: "paraTimes.error.depositDescription",
            t: t,
            values: {
                address: transactionForm.recipient,
                paratimeType: isEvmcParaTime ? t('paraTimes.common.evmcType', '(EVMc)') : '',
                paraTime: paraTimeName,
                ticker,
                value: transactionForm.amount
            },
            defaults: "Transaction failed. We were not able to complete deposit of <strong>{{value}} {{ticker}}</strong> to <strong>{{address}}</strong> on <strong>{{paraTime}}</strong> {{paratimeType}}"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactI18Next.Trans), {
            i18nKey: "paraTimes.error.withdrawDescription",
            t: t,
            values: {
                address: transactionForm.recipient,
                paratimeType: isEvmcParaTime ? t('paraTimes.common.evmcType', '(EVMc)') : '',
                paraTime: paraTimeName,
                ticker,
                value: transactionForm.amount
            },
            defaults: "Transaction failed. We were not able to complete withdrawal of <strong>{{value}} {{ticker}}</strong> from <strong>{{paraTime}}</strong> {{paratimeType}} to <strong>{{address}}</strong>"
        }),
        children: [
            transactionError && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                margin: {
                    bottom: 'medium'
                },
                align: "center",
                gap: "medium",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _statusCritical.StatusCritical), {
                        size: "80px",
                        color: "status-error"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBox.AlertBox), {
                        status: "error",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorFormatter.ErrorFormatter), {
                            code: transactionError.code,
                            message: transactionError.message
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paraTimeFormFooter.ParaTimeFormFooter), {
                primaryLabel: t('paraTimes.summary.navigate', 'Navigate to ParaTime Transfers'),
                primaryAction: clearTransactionForm,
                secondaryAction: navigateToConfirmation,
                withNotice: isEvmcParaTime
            })
        ]
    });
};

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-i18next":"7GUHL","grommet-icons/es6/icons/StatusCritical":"8hag1","grommet/es6/components/Box":"4o01A","app/components/AlertBox":"ivux6","app/components/ErrorFormatter":"9p32r","../ParaTimeContent":"b3Bev","../ParaTimeFormFooter":"gAxgp","../useParaTimes":"kRFDd","../useParaTimesNavigation":"70fv0","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"5AebO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorBoundary", ()=>ErrorBoundary);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _errors = require("types/errors");
var _box = require("grommet/es6/components/Box");
var _alertBox = require("app/components/AlertBox");
var _errorFormatter = require("app/components/ErrorFormatter");
function ErrorBoundary() {
    const error = (0, _reactRouterDom.useRouteError)();
    let errorPayload;
    if ((0, _reactRouterDom.isRouteErrorResponse)(error)) errorPayload = {
        code: (0, _errors.WalletErrors).UnknownError,
        message: error.statusText
    };
    else if (error instanceof (0, _errors.WalletError)) errorPayload = {
        code: error.type,
        message: error.message
    };
    else if (error instanceof Error) errorPayload = {
        code: (0, _errors.WalletErrors).UnknownError,
        message: error.message
    };
    else errorPayload = {
        code: (0, _errors.WalletErrors).UnknownError,
        message: error
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        pad: 'small',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBox.AlertBox), {
            status: "error",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorFormatter.ErrorFormatter), {
                code: errorPayload.code,
                message: errorPayload.message
            })
        })
    });
}

},{"react/jsx-runtime":"6pm7f","react":"8CCva","react-router-dom":"9pTjq","types/errors":"gbx4q","grommet/es6/components/Box":"4o01A","app/components/AlertBox":"ivux6","app/components/ErrorFormatter":"9p32r","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"54cKp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FromBleLedger", ()=>FromBleLedger);
var _jsxRuntime = require("react/jsx-runtime");
var _importaccounts = require("app/state/importaccounts");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _heading = require("grommet/es6/components/Heading");
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _selectors = require("app/state/importaccounts/selectors");
var _header = require("app/components/Header");
var _listBleLedgerDevicesModal = require("../ListBleLedgerDevicesModal");
var _importAccountsSelectionModal = require("../ImportAccountsSelectionModal");
var _types = require("../../../../state/wallet/types");
function FromBleLedger() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const showAccountsSelectionModal = (0, _reactRedux.useSelector)((0, _selectors.selectShowAccountsSelectionModal));
    const showBleLedgerDevicesModal = (0, _reactRedux.useSelector)((0, _selectors.selectShowBleLedgerDevicesModal));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        background: "background-front",
        margin: "small",
        pad: "medium",
        round: "5px",
        border: {
            color: 'background-front-border',
            size: '1px'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.Header), {
                children: t('openWallet.ledger.header', 'Open from Ledger device')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _heading.Heading), {
                level: "2",
                margin: "0",
                children: t('ledger.instructionSteps.header', 'Steps:')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ol", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: t('ledger.instructionSteps.connectBluetoothLedger', 'Connect your Ledger to this device via Bluetooth')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: t('ledger.instructionSteps.deviceIsPaired', 'Make sure your Ledger is paired with this device')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: t('ledger.instructionSteps.closeLedgerLive', 'Close the Ledger Live app on your computer')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: t('ledger.instructionSteps.openOasisApp', 'Open the Oasis app on your Ledger')
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                direction: "row",
                margin: {
                    top: 'medium'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                    type: "submit",
                    label: t('openWallet.importAccounts.selectDevice', 'Select device'),
                    onClick: ()=>{
                        dispatch((0, _importaccounts.importAccountsActions).enumerateDevicesFromBleLedger());
                    },
                    primary: true
                })
            }),
            showBleLedgerDevicesModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBleLedgerDevicesModal.ListBleLedgerDevicesModal), {
                abort: ()=>{
                    dispatch((0, _importaccounts.importAccountsActions).clear());
                },
                next: ()=>{
                    dispatch((0, _importaccounts.importAccountsActions).enumerateAccountsFromLedger((0, _types.WalletType).BleLedger));
                }
            }),
            showAccountsSelectionModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importAccountsSelectionModal.ImportAccountsSelectionModal), {
                abort: ()=>{
                    dispatch((0, _importaccounts.importAccountsActions).clear());
                }
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","app/state/importaccounts":"eABjR","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Heading":"1SnMZ","react-i18next":"7GUHL","react-redux":"azV3Y","app/state/importaccounts/selectors":"6bs0S","app/components/Header":"bHFRk","../ListBleLedgerDevicesModal":"glp89","../ImportAccountsSelectionModal":"dCGWz","../../../../state/wallet/types":"b0U5N","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"glp89":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListBleLedgerDevicesModal", ()=>ListBleLedgerDevicesModal);
var _jsxRuntime = require("react/jsx-runtime");
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _alertBox = require("app/components/AlertBox");
var _errorFormatter = require("app/components/ErrorFormatter");
var _header = require("app/components/Header");
var _importAccountsStepFormatter = require("app/components/ImportAccountsStepFormatter");
var _responsiveLayer = require("app/components/ResponsiveLayer");
var _selectors = require("app/state/importaccounts/selectors");
var _types = require("app/state/importaccounts/types");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _spinner = require("grommet/es6/components/Spinner");
var _text = require("grommet/es6/components/Text");
var _checkBox = require("grommet/es6/components/CheckBox");
var _importaccounts = require("../../../../state/importaccounts");
function DevicesSelector({ devices }) {
    const dispatch = (0, _reactRedux.useDispatch)();
    const selectedBleDevice = (0, _reactRedux.useSelector)((0, _selectors.selectSelectedBleDevice));
    const selectBleDevice = (scanResult)=>dispatch((0, _importaccounts.importAccountsActions).setSelectedBleDevice(scanResult));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
        gap: "small",
        children: devices.map((d)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                round: "5px",
                pad: "small",
                flex: "grow",
                fill: "horizontal",
                role: "checkbox",
                hoverIndicator: {
                    background: 'brand'
                },
                direction: "row",
                onClick: ()=>{
                    selectBleDevice(d);
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        alignSelf: "center",
                        pad: {
                            left: 'small',
                            right: 'medium'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkBox.CheckBox), {
                            checked: selectedBleDevice?.device.deviceId === d.device.deviceId,
                            hidden: true
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                        flex: "grow",
                        gap: "xsmall",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                weight: "bold",
                                children: d.device.name
                            })
                        })
                    })
                ]
            }, d.device.deviceId))
    });
}
function ListBleLedgerDevicesModal(props) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const bleDevices = (0, _reactRedux.useSelector)((0, _selectors.selectBleDevices));
    const selectedBleDevice = (0, _reactRedux.useSelector)((0, _selectors.selectSelectedBleDevice));
    const error = (0, _reactRedux.useSelector)((0, _selectors.selectError));
    const step = (0, _reactRedux.useSelector)((0, _selectors.selectImportAccountsStep));
    const isBusyImporting = step !== (0, _types.ImportAccountsStep).Idle;
    const cancelDisabled = isBusyImporting && !error;
    const confirmDisabled = isBusyImporting || !selectedBleDevice;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _responsiveLayer.ResponsiveLayer), {
        onEsc: props.abort,
        onClickOutside: props.abort,
        modal: true,
        background: "background-front",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
            width: "800px",
            pad: "medium",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.ModalHeader), {
                    children: t('openWallet.importAccounts.selectLedgerDevice', 'Select Ledger device')
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    style: {
                        minHeight: '525px'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(DevicesSelector, {
                            devices: bleDevices
                        }),
                        ![
                            (0, _types.ImportAccountsStep).Idle,
                            (0, _types.ImportAccountsStep).LoadingBleDevices
                        ].includes(step) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                            direction: "row",
                            gap: "medium",
                            alignContent: "center",
                            pad: {
                                top: 'small'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _spinner.Spinner), {
                                    size: "medium"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                    alignSelf: "center",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                        size: "xlarge",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importAccountsStepFormatter.ImportAccountsStepFormatter), {
                                            step: step
                                        })
                                    })
                                })
                            ]
                        }),
                        ![
                            (0, _types.ImportAccountsStep).LoadingBleDevices
                        ].includes(step) && !bleDevices.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                            direction: "row",
                            gap: "medium",
                            alignContent: "center",
                            pad: {
                                top: 'small'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                                alignSelf: "center",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                    size: "xlarge",
                                    children: t('openWallet.importAccounts.NoBLEDevicesFound', 'No Bluetooth devices found')
                                })
                            })
                        }),
                        error && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _alertBox.AlertBox), {
                            status: "error",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _errorFormatter.ErrorFormatter), {
                                code: error.code,
                                message: error.message
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                    direction: "row",
                    gap: "small",
                    justify: "between",
                    pad: {
                        top: 'medium'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            secondary: true,
                            label: t('common.cancel', 'Cancel'),
                            onClick: props.abort,
                            disabled: cancelDisabled
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            type: "submit",
                            primary: true,
                            "data-testid": "ledger-open-accounts",
                            label: t('openWallet.importAccounts.openWallets', 'Open'),
                            onClick: props.next,
                            disabled: confirmDisabled
                        })
                    ]
                })
            ]
        })
    });
}

},{"react/jsx-runtime":"6pm7f","react-i18next":"7GUHL","react-redux":"azV3Y","app/components/AlertBox":"ivux6","app/components/ErrorFormatter":"9p32r","app/components/Header":"bHFRk","app/components/ImportAccountsStepFormatter":"lIxa3","app/components/ResponsiveLayer":"3jeKP","app/state/importaccounts/selectors":"6bs0S","app/state/importaccounts/types":"irNSx","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Spinner":"bxfAK","grommet/es6/components/Text":"kz1Ni","grommet/es6/components/CheckBox":"gaRRO","../../../../state/importaccounts":"eABjR","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"apWf9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FromUsbLedger", ()=>FromUsbLedger);
var _jsxRuntime = require("react/jsx-runtime");
var _importaccounts = require("app/state/importaccounts");
var _box = require("grommet/es6/components/Box");
var _button = require("grommet/es6/components/Button");
var _heading = require("grommet/es6/components/Heading");
var _reactI18Next = require("react-i18next");
var _reactRedux = require("react-redux");
var _importAccountsSelectionModal = require("app/pages/OpenWalletPage/Features/ImportAccountsSelectionModal");
var _selectors = require("app/state/importaccounts/selectors");
var _header = require("app/components/Header");
var _types = require("app/state/wallet/types");
function FromUsbLedger() {
    const { t } = (0, _reactI18Next.useTranslation)();
    const dispatch = (0, _reactRedux.useDispatch)();
    const showAccountsSelectionModal = (0, _reactRedux.useSelector)((0, _selectors.selectShowAccountsSelectionModal));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        background: "background-front",
        margin: "small",
        pad: "medium",
        round: "5px",
        border: {
            color: 'background-front-border',
            size: '1px'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.Header), {
                children: t('openWallet.ledger.header', 'Open from Ledger device')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _heading.Heading), {
                level: "3",
                margin: "0",
                children: t('ledger.instructionSteps.header', 'Steps:')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("ol", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: t('ledger.instructionSteps.connectUsbLedger', 'Connect your Ledger to this device via USB')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: t('ledger.instructionSteps.closeLedgerLive', 'Close the Ledger Live app on your computer')
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                        children: t('ledger.instructionSteps.openOasisApp', 'Open the Oasis app on your Ledger')
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _box.Box), {
                direction: "row",
                margin: {
                    top: 'medium'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                    type: "submit",
                    label: t('openWallet.importAccounts.selectWallets', 'Select accounts to open'),
                    onClick: ()=>{
                        dispatch((0, _importaccounts.importAccountsActions).enumerateAccountsFromLedger((0, _types.WalletType).UsbLedger));
                    },
                    primary: true
                })
            }),
            showAccountsSelectionModal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _importAccountsSelectionModal.ImportAccountsSelectionModal), {
                abort: ()=>{
                    dispatch((0, _importaccounts.importAccountsActions).clear());
                }
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","app/state/importaccounts":"eABjR","grommet/es6/components/Box":"4o01A","grommet/es6/components/Button":"fVON6","grommet/es6/components/Heading":"1SnMZ","react-i18next":"7GUHL","react-redux":"azV3Y","app/pages/OpenWalletPage/Features/ImportAccountsSelectionModal":"dCGWz","app/state/importaccounts/selectors":"6bs0S","app/components/Header":"bHFRk","app/state/wallet/types":"b0U5N","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}],"lRLtj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FromLedger", ()=>FromLedger);
var _jsxRuntime = require("react/jsx-runtime");
var _box = require("grommet/es6/components/Box");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _header = require("app/components/Header");
var _buttonLink = require("../../../../components/ButtonLink");
var _button = require("grommet/es6/components/Button");
var _text = require("grommet/es6/components/Text");
var _ledger = require("../../../../lib/ledger");
var _reactI18Next = require("react-i18next");
var _runtimeIs = require("app/lib/runtimeIs");
var _reduxSaga = require("redux-saga");
var _saga = require("../../../../state/importaccounts/saga");
function FromLedger({ openLedgerAccessPopup }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    const [supportsUsbLedger, setSupportsUsbLedger] = (0, _reactDefault.default).useState(true);
    const [hasUsbLedgerAccess, setHasUsbLedgerAccess] = (0, _reactDefault.default).useState(undefined);
    const [supportsBleLedger, setSupportsBleLedger] = (0, _reactDefault.default).useState(true);
    (0, _react.useEffect)(()=>{
        async function getLedgerSupport() {
            const usbLedgerSupported = await (0, _ledger.canAccessNavigatorUsb)();
            const bleLedgerSupported = (0, _runtimeIs.runtimeIs) === 'mobile-app' && await (0, _ledger.canAccessBle)();
            setSupportsUsbLedger(usbLedgerSupported);
            setSupportsBleLedger(bleLedgerSupported);
        }
        getLedgerSupport();
    }, []);
    (0, _react.useEffect)(()=>{
        if (openLedgerAccessPopup) // In default ext popup this gets auto-accepted / auto-rejected. In a tab or persistent popup it would
        // prompt user to select a ledger device.
        // If TransportWebUSB.create() is rejected then call openLedgerAccessPopup. When user
        // confirms the prompt tell them to come back here. TransportWebUSB.create() will resolve.
        (0, _reduxSaga.runSaga)({}, (0, _saga.getUSBTransport)).toPromise().then((t)=>t.close()).then(()=>setHasUsbLedgerAccess(true)).catch(()=>setHasUsbLedgerAccess(false));
        else // Assume true in web app. enumerateAccountsFromLedger will call TransportWebUSB.create in next steps
        // and will prompt user to select a ledger device.
        setHasUsbLedgerAccess(true);
    }, [
        openLedgerAccessPopup
    ]);
    const shouldOpenUsbLedgerAccessPopup = openLedgerAccessPopup && !hasUsbLedgerAccess;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
        round: "5px",
        border: {
            color: 'background-front-border',
            size: '1px'
        },
        background: "background-front",
        margin: "small",
        pad: "medium",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _header.Header), {
                children: t('openWallet.importAccounts.connectDeviceHeader', 'How do you want to connect your Ledger device?')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _box.Box), {
                direction: "row-responsive",
                justify: "start",
                margin: {
                    top: 'medium'
                },
                gap: "medium",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: shouldOpenUsbLedgerAccessPopup ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    disabled: !supportsUsbLedger,
                                    style: {
                                        width: 'fit-content'
                                    },
                                    onClick: ()=>{
                                        openLedgerAccessPopup();
                                        window.close();
                                    },
                                    label: t('ledger.extension.grantAccess', 'Grant access to your USB Ledger'),
                                    primary: true
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLink.ButtonLink), {
                                        disabled: !supportsUsbLedger,
                                        to: "usb",
                                        label: t('openWallet.importAccounts.usbLedger', 'USB Ledger'),
                                        primary: true
                                    })
                                })
                            }),
                            !supportsUsbLedger && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                size: "small",
                                textAlign: "center",
                                children: t('errors.usbTransportNotSupported', 'Current platform does not support WebUSB capability. Try on different platform or browser (preferably Chrome).')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonLink.ButtonLink), {
                                    disabled: !supportsBleLedger,
                                    to: "ble",
                                    label: t('openWallet.importAccounts.bluetoothLedger', 'Bluetooth Ledger'),
                                    primary: true
                                })
                            }),
                            !supportsBleLedger && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _text.Text), {
                                size: "small",
                                textAlign: "center",
                                children: t('errors.bluetoothTransportNotSupported', 'Bluetooth may be turned off or your current platform does not support Bluetooth capability.')
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"6pm7f","grommet/es6/components/Box":"4o01A","react":"8CCva","app/components/Header":"bHFRk","../../../../components/ButtonLink":"8j6EN","grommet/es6/components/Button":"fVON6","grommet/es6/components/Text":"kz1Ni","../../../../lib/ledger":"bREEn","react-i18next":"7GUHL","app/lib/runtimeIs":"fboJV","redux-saga":"kvMDH","../../../../state/importaccounts/saga":"4YSF4","@parcel/transformer-js/src/esmodule-helpers.js":"bFO5N"}]},["apfRo","4RXID"], "4RXID", "parcelRequirea829", {}, "./", "/")

//# sourceMappingURL=public.c7fa6d14.js.map
